import { GeometryCollection, Topology } from 'topojson-specification';

export type USTopology = Topology<{
  counties: GeometryCollection;
  states: GeometryCollection;
  nation: GeometryCollection;
}>;

export const usNameLookup: Record<string, string> = {
  '04': 'Arizona',
  '22': 'Louisiana',
  '16': 'Idaho',
  '27': 'Minnesota',
  '38': 'North Dakota',
  '46': 'South Dakota',
  '36': 'New York',
  '02': 'Alaska',
  '13': 'Georgia',
  '18': 'Indiana',
  '26': 'Michigan',
  '28': 'Mississippi',
  '39': 'Ohio',
  '48': 'Texas',
  '31': 'Nebraska',
  '08': 'Colorado',
  '24': 'Maryland',
  '20': 'Kansas',
  '17': 'Illinois',
  '55': 'Wisconsin',
  '06': 'California',
  '19': 'Iowa',
  '42': 'Pennsylvania',
  '30': 'Montana',
  '29': 'Missouri',
  '12': 'Florida',
  '21': 'Kentucky',
  '23': 'Maine',
  '49': 'Utah',
  '40': 'Oklahoma',
  '47': 'Tennessee',
  '41': 'Oregon',
  '54': 'West Virginia',
  '05': 'Arkansas',
  '53': 'Washington',
  '37': 'North Carolina',
  '51': 'Virginia',
  '56': 'Wyoming',
  '01': 'Alabama',
  '45': 'South Carolina',
  '35': 'New Mexico',
  '33': 'New Hampshire',
  '50': 'Vermont',
  '32': 'Nevada',
  '15': 'Hawaii',
  '25': 'Massachusetts',
  '44': 'Rhode Island',
  '34': 'New Jersey',
  '10': 'Delaware',
  '09': 'Connecticut',
  '11': 'District of Columbia'
};

export const usTopoJson: USTopology = {
  'type': 'Topology',
  'bbox': [
    -179.14733999999999,
    -14.552548999999999,
    179.77847,
    71.352561
  ],
  'transform': {
    'scale': [
      0.003589293992939929,
      0.0008590596905969058
    ],
    'translate': [
      -179.14733999999999,
      -14.552548999999999
    ]
  },
  'objects': {
    'counties': {
      'type': 'GeometryCollection',
      'geometries': [
        {
          'type': 'Polygon',
          'arcs': [
            [
              0,
              1,
              2,
              3,
              4,
              5,
              6,
              7,
              8,
              9,
              10,
              11
            ]
          ],
          'id': '04015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              12,
              13,
              14,
              15,
              16,
              17,
              18
            ]
          ],
          'id': '22105'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              19,
              20,
              21,
              22,
              23
            ]
          ],
          'id': '16063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              24,
              25,
              26,
              27,
              28,
              29,
              30,
              31,
              32
            ]
          ],
          'id': '27119'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              33,
              34,
              35,
              36,
              37,
              38,
              39
            ]
          ],
          'id': '38017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              40,
              41,
              42,
              43,
              44
            ]
          ],
          'id': '46081'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              45,
              46,
              47,
              48,
              49,
              50
            ]
          ],
          'id': '36095'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                51
              ]
            ],
            [
              [
                52
              ]
            ],
            [
              [
                53
              ]
            ],
            [
              [
                54,
                55,
                56,
                57
              ]
            ],
            [
              [
                58
              ]
            ],
            [
              [
                59
              ]
            ]
          ],
          'id': '02275'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              60,
              61,
              62,
              63
            ]
          ],
          'id': '13143'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              64,
              65,
              66,
              67,
              68
            ]
          ],
          'id': '13023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              69,
              70,
              71,
              72,
              73,
              74
            ]
          ],
          'id': '18093'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              75,
              76,
              77,
              78,
              79,
              80
            ]
          ],
          'id': '18079'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              81,
              82,
              83,
              84,
              85,
              86
            ]
          ],
          'id': '26087'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              87,
              88,
              89,
              90,
              91,
              92
            ]
          ],
          'id': '28017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              93,
              94,
              95,
              96,
              97,
              98
            ]
          ],
          'id': '39033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              99,
              100,
              101,
              102,
              103,
              104,
              105
            ]
          ],
          'id': '46099'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              106,
              -105,
              107,
              108,
              109,
              110
            ]
          ],
          'id': '46125'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              111,
              112,
              113,
              114,
              115,
              116
            ]
          ],
          'id': '48471'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              117,
              118,
              119,
              120
            ]
          ],
          'id': '72133'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              121,
              122,
              123,
              124,
              125,
              126
            ]
          ],
          'id': '46003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              127,
              128,
              129,
              130,
              131,
              132,
              133
            ]
          ],
          'id': '48047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              134,
              135,
              136,
              137,
              138,
              139,
              140
            ]
          ],
          'id': '72025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              141,
              142,
              143,
              144,
              145
            ]
          ],
          'id': '72033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              146,
              147,
              148,
              149,
              150,
              151
            ]
          ],
          'id': '72101'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              152,
              153,
              154,
              155,
              156
            ]
          ],
          'id': '31029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              157,
              158,
              159,
              160
            ]
          ],
          'id': '72054'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              161,
              162,
              163,
              164,
              165,
              166
            ]
          ],
          'id': '08021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              167,
              168,
              169,
              170,
              171,
              172,
              173,
              174
            ]
          ],
          'id': '24043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              175,
              176,
              177,
              178,
              179
            ]
          ],
          'id': '20137'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              180,
              181,
              182,
              183,
              184,
              185
            ]
          ],
          'id': '17053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              186,
              187,
              188,
              189,
              190,
              191
            ]
          ],
          'id': '48117'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              192,
              193,
              194,
              195,
              196,
              197,
              198,
              199
            ]
          ],
          'id': '13261'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              200,
              201,
              202,
              203,
              204,
              205,
              206,
              207
            ]
          ],
          'id': '55075'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              208,
              209,
              210,
              211,
              212,
              213,
              214
            ]
          ],
          'id': '06069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              215,
              216,
              217,
              218,
              219,
              220,
              221
            ]
          ],
          'id': '13199'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              222,
              223,
              224,
              225,
              226,
              227
            ]
          ],
          'id': '19013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              228,
              229,
              230,
              231
            ]
          ],
          'id': '19081'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              232,
              -27
            ]
          ],
          'id': '27125'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              233,
              234,
              235,
              236,
              237
            ]
          ],
          'id': '31125'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              238,
              239,
              240,
              241
            ]
          ],
          'id': '42075'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              242,
              243,
              244,
              245
            ]
          ],
          'id': '48219'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              246,
              247,
              248,
              249,
              250,
              251
            ]
          ],
          'id': '48417'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              252,
              253,
              254,
              255,
              256,
              257,
              258
            ]
          ],
          'id': '48451'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              259,
              260,
              261,
              262,
              263,
              264
            ]
          ],
          'id': '48497'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              265,
              266,
              267,
              -100,
              268,
              269
            ]
          ],
          'id': '46079'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              270,
              271,
              272,
              273,
              274,
              275,
              276
            ]
          ],
          'id': '46069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              277,
              278,
              279,
              280,
              281,
              282
            ]
          ],
          'id': '48101'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              283,
              284,
              285
            ]
          ],
          'id': '04023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              286,
              287,
              288,
              289,
              290
            ]
          ],
          'id': '19179'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              291,
              292,
              293,
              294,
              295,
              296
            ]
          ],
          'id': '19031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              297,
              298,
              299,
              300,
              301,
              302,
              303,
              304,
              305
            ]
          ],
          'id': '30033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              306,
              307,
              308,
              309,
              310,
              311,
              312
            ]
          ],
          'id': '29185'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              313,
              314,
              315,
              316,
              317
            ]
          ],
          'id': '12091'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              318,
              319,
              320,
              321,
              322
            ]
          ],
          'id': '21219'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              323,
              324,
              325,
              326,
              327
            ]
          ],
          'id': '23003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              328,
              329,
              330,
              -175,
              331,
              332,
              333,
              334
            ]
          ],
          'id': '24001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              335,
              336,
              337,
              338,
              339
            ]
          ],
          'id': '28075'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              340,
              341,
              342,
              343,
              344,
              345
            ]
          ],
          'id': '38021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              346,
              347,
              348,
              349,
              350
            ]
          ],
          'id': '27093'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              351,
              352,
              353,
              354
            ]
          ],
          'id': '46007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              355,
              356,
              357,
              358,
              359,
              360,
              361,
              362
            ]
          ],
          'id': '49043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              363,
              364,
              365,
              366,
              367,
              368
            ]
          ],
          'id': '36099'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              369,
              370,
              371,
              372,
              373,
              374,
              375
            ]
          ],
          'id': '20073'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              376,
              377,
              378,
              379
            ]
          ],
          'id': '20101'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              380,
              381,
              382,
              383,
              384,
              385
            ]
          ],
          'id': '26123'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              386,
              387,
              388,
              389,
              390
            ]
          ],
          'id': '31035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              391,
              392,
              393,
              394
            ]
          ],
          'id': '36073'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              395,
              396,
              397,
              398,
              399,
              400,
              401
            ]
          ],
          'id': '38063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              402,
              403,
              404,
              405,
              406,
              407
            ]
          ],
          'id': '40011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              408,
              409,
              410,
              411,
              412
            ]
          ],
          'id': '48441'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              413,
              414,
              415,
              416,
              417
            ]
          ],
          'id': '48011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              418,
              419,
              420,
              421
            ]
          ],
          'id': '48233'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -258,
              422,
              423,
              424
            ]
          ],
          'id': '48235'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              425,
              426,
              427,
              428,
              429,
              430
            ]
          ],
          'id': '55137'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              431,
              432,
              433,
              434,
              435,
              436,
              437
            ]
          ],
          'id': '47151'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              438,
              439,
              440,
              441,
              442
            ]
          ],
          'id': '55113'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              443,
              444,
              445,
              446,
              447
            ]
          ],
          'id': '26073'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              448,
              449,
              450,
              451,
              452,
              453
            ]
          ],
          'id': '28131'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              454,
              455,
              -93,
              456,
              457,
              458
            ]
          ],
          'id': '28013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              459,
              460,
              461,
              462,
              463
            ]
          ],
          'id': '31171'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              464,
              465,
              466,
              467,
              468,
              469
            ]
          ],
          'id': '48335'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              470,
              471,
              472,
              473,
              474
            ]
          ],
          'id': '08057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              475,
              476,
              477,
              478,
              479
            ]
          ],
          'id': '19089'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              480,
              481,
              482,
              483,
              -82
            ]
          ],
          'id': '26151'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              484,
              485,
              486,
              487,
              488,
              489,
              490
            ]
          ],
          'id': '18075'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              491,
              492,
              493,
              494,
              495
            ]
          ],
          'id': '38075'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              496,
              497,
              498,
              499,
              500
            ]
          ],
          'id': '41021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              501,
              502,
              503,
              504,
              505
            ]
          ],
          'id': '29119'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              506,
              507,
              508,
              509
            ]
          ],
          'id': '48501'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              510,
              511,
              512,
              -279,
              513
            ]
          ],
          'id': '48075'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              514,
              515,
              516,
              517
            ]
          ],
          'id': '13097'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              518,
              519,
              520,
              521
            ]
          ],
          'id': '02158'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              522,
              523,
              524,
              525,
              526
            ]
          ],
          'id': '19181'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              527,
              528,
              529,
              530,
              531,
              532
            ]
          ],
          'id': '40031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              533,
              534,
              535,
              536,
              537,
              538,
              539,
              540
            ]
          ],
          'id': '40009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -274,
              541,
              542,
              543,
              544
            ]
          ],
          'id': '46017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              545,
              546,
              547,
              548,
              549,
              550
            ]
          ],
          'id': '48171'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              551,
              552,
              553,
              554
            ]
          ],
          'id': '48125'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              555,
              556,
              557,
              558,
              559
            ]
          ],
          'id': '48283'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              560,
              561,
              562,
              563
            ]
          ],
          'id': '54093'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              564,
              565,
              566,
              567,
              568,
              569,
              570,
              571,
              572,
              573,
              574,
              575
            ]
          ],
          'id': '06089'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              576,
              577,
              578,
              579,
              580,
              581
            ]
          ],
          'id': '17165'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              582,
              583,
              584,
              585,
              586
            ]
          ],
          'id': '26101'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              587,
              588,
              589,
              590,
              591
            ]
          ],
          'id': '31071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              592,
              593,
              -591,
              594,
              595,
              596,
              597,
              598,
              599
            ]
          ],
          'id': '31041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              600,
              -270,
              601,
              602,
              603
            ]
          ],
          'id': '46097'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              604,
              605,
              606,
              607,
              608,
              609
            ]
          ],
          'id': '46025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              610,
              611,
              612,
              613,
              614
            ]
          ],
          'id': '05037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              615,
              616,
              617,
              -167,
              618,
              619,
              620
            ]
          ],
          'id': '08007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              621,
              622,
              623,
              624
            ]
          ],
          'id': '12043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              625,
              626,
              627,
              628,
              629
            ]
          ],
          'id': '46053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              630,
              631,
              632,
              -419,
              633
            ]
          ],
          'id': '48195'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                634,
                635,
                636,
                637,
                638
              ]
            ],
            [
              [
                639,
                640,
                641
              ]
            ]
          ],
          'id': '53053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              642,
              643,
              644,
              -216,
              645,
              646,
              647
            ]
          ],
          'id': '13077'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              648,
              649,
              650,
              651
            ]
          ],
          'id': '13059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              652,
              653,
              654,
              655,
              656
            ]
          ],
          'id': '18081'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              657,
              658,
              659,
              660,
              661,
              662
            ]
          ],
          'id': '20115'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              663,
              664,
              665,
              666,
              667
            ]
          ],
          'id': '27059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              668,
              669,
              670,
              671,
              672,
              673
            ]
          ],
          'id': '31003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              674,
              675,
              676,
              677,
              678
            ]
          ],
          'id': '39103'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              679,
              680,
              681,
              682,
              683,
              684
            ]
          ],
          'id': '47153'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              685,
              686,
              687,
              688
            ]
          ],
          'id': '48375'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              689,
              690,
              691,
              692,
              693
            ]
          ],
          'id': '48145'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -399,
              694,
              695,
              696,
              697,
              698
            ]
          ],
          'id': '38039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -125,
              699,
              700,
              701
            ]
          ],
          'id': '46043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              702,
              703,
              704,
              705,
              706,
              707
            ]
          ],
          'id': '48193'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              708,
              709,
              710,
              711,
              712
            ]
          ],
          'id': '19185'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              713,
              714,
              715,
              716,
              717,
              718,
              719
            ]
          ],
          'id': '38087'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              720,
              -412,
              721,
              722,
              -255,
              723
            ]
          ],
          'id': '48399'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6,
              -6,
              4,
              -4,
              724,
              725,
              726,
              727,
              728,
              -8
            ]
          ],
          'id': '04005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              729,
              730,
              731,
              732,
              733
            ]
          ],
          'id': '16009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              734,
              735,
              736,
              737,
              738,
              739,
              740
            ]
          ],
          'id': '20007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              741,
              742,
              743,
              744,
              -102
            ]
          ],
          'id': '27133'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              745,
              -324,
              746,
              747
            ]
          ],
          'id': '23029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              748,
              749,
              750,
              751,
              752
            ]
          ],
          'id': '30051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              753,
              754,
              755,
              756
            ]
          ],
          'id': '46091'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              757,
              758,
              -364,
              759,
              760
            ]
          ],
          'id': '36117'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              761,
              762
            ]
          ],
          'id': '02060'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              763,
              764,
              765,
              766,
              767
            ]
          ],
          'id': '12027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              768,
              769,
              770,
              771,
              772,
              773
            ]
          ],
          'id': '13015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              774,
              775,
              776,
              777,
              778
            ]
          ],
          'id': '19127'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              779,
              780,
              781,
              782,
              783,
              784
            ]
          ],
          'id': '20047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              785,
              786,
              787,
              788,
              789
            ]
          ],
          'id': '26129'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              790,
              -237,
              791,
              792,
              793,
              794
            ]
          ],
          'id': '31093'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              795,
              796,
              797,
              798,
              799,
              800
            ]
          ],
          'id': '39063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              801,
              802,
              803,
              804,
              805,
              806,
              807
            ]
          ],
          'id': '21209'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              808,
              809,
              810,
              811,
              -682
            ]
          ],
          'id': '47007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              812,
              813,
              814,
              815,
              816,
              817
            ]
          ],
          'id': '37157'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              818,
              819,
              820,
              821,
              822
            ]
          ],
          'id': '48189'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              823
            ]
          ],
          'id': '51820'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              824,
              825,
              826,
              827,
              828
            ]
          ],
          'id': '56025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -114,
              829,
              830,
              831,
              832
            ]
          ],
          'id': '48407'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              833,
              834,
              835,
              -427,
              836
            ]
          ],
          'id': '55135'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              837,
              838,
              839,
              840,
              841
            ]
          ],
          'id': '39067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              842,
              843,
              844,
              845,
              846,
              847,
              848
            ]
          ],
          'id': '13087'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              849,
              850,
              851,
              852,
              853
            ]
          ],
          'id': '22001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              854,
              855,
              856,
              857,
              858
            ]
          ],
          'id': '27019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              859,
              860,
              861,
              862,
              -578,
              863
            ]
          ],
          'id': '17065'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              864,
              865,
              -351,
              866,
              867,
              868
            ]
          ],
          'id': '27067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              869,
              870,
              871,
              872,
              873
            ]
          ],
          'id': '55071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              874,
              875,
              876,
              877,
              878,
              879
            ]
          ],
          'id': '01013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              880,
              881,
              882,
              883,
              884,
              885,
              886
            ]
          ],
          'id': '13169'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              887,
              888,
              889,
              890
            ]
          ],
          'id': '19069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              891,
              892,
              893,
              894,
              895,
              896
            ]
          ],
          'id': '18113'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              897,
              898,
              899,
              900,
              901,
              902
            ]
          ],
          'id': '20193'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              903,
              904,
              905,
              -444,
              906
            ]
          ],
          'id': '26035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              907,
              908,
              909,
              910
            ]
          ],
          'id': '26039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              911,
              912,
              913,
              914,
              915,
              916
            ]
          ],
          'id': '29225'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              917,
              918,
              919,
              920,
              921
            ]
          ],
          'id': '31005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              922,
              923,
              924,
              925,
              926
            ]
          ],
          'id': '31143'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              927,
              928,
              929,
              930,
              -606
            ]
          ],
          'id': '46029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              931,
              932,
              933,
              -128,
              934,
              935
            ]
          ],
          'id': '48131'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              936,
              -422,
              937,
              -686,
              938,
              939
            ]
          ],
          'id': '48341'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              940,
              941,
              942,
              943,
              944,
              945
            ]
          ],
          'id': '48317'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              946,
              947,
              948,
              949,
              950,
              951,
              952
            ]
          ],
          'id': '39083'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              953,
              954,
              955,
              956,
              957
            ]
          ],
          'id': '72073'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              958,
              959,
              960,
              961,
              962,
              -691,
              963
            ]
          ],
          'id': '48293'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              964,
              965,
              966,
              967,
              968
            ]
          ],
          'id': '19055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              969,
              970,
              971,
              972
            ]
          ],
          'id': '31159'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              973,
              974,
              975,
              976
            ]
          ],
          'id': '48507'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              977,
              978,
              979,
              980,
              981,
              982,
              983,
              984,
              985
            ]
          ],
          'id': '06091'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              986,
              987,
              988,
              989,
              990
            ]
          ],
          'id': '17201'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              991,
              992,
              993,
              994,
              995,
              996
            ]
          ],
          'id': '23031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              997,
              998,
              999,
              1000,
              1001
            ]
          ],
          'id': '24011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1002,
              1003,
              1004,
              1005,
              1006
            ]
          ],
          'id': '26119'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -38,
              1007,
              1008,
              1009,
              1010,
              1011,
              1012
            ]
          ],
          'id': '38077'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1013,
              1014,
              1015,
              1016,
              1017,
              1018
            ]
          ],
          'id': '42007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1019,
              1020,
              1021,
              -246,
              -507
            ]
          ],
          'id': '48079'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1022,
              -789,
              1023,
              1024,
              1025,
              -906
            ]
          ],
          'id': '26051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1026,
              1027,
              1028,
              1029,
              1030,
              1031,
              1032
            ]
          ],
          'id': '08121'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1033,
              -969,
              1034,
              1035,
              -224
            ]
          ],
          'id': '19019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1036,
              1037,
              1038,
              1039,
              1040,
              1041,
              1042
            ]
          ],
          'id': '19187'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1043,
              -785,
              1044,
              1045,
              1046,
              1047
            ]
          ],
          'id': '20057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1006,
              1048,
              -786,
              -909
            ]
          ],
          'id': '26135'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1049,
              1050,
              1051,
              1052
            ]
          ],
          'id': '28099'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1053,
              1054,
              1055,
              1056,
              1057,
              1058
            ]
          ],
          'id': '31137'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1059,
              1060,
              1061,
              1062,
              1063,
              1064
            ]
          ],
          'id': '31039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1065,
              1066,
              1067,
              1068,
              1069,
              1070,
              1071
            ]
          ],
          'id': '45045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1072,
              1073,
              1074,
              1075,
              1076
            ]
          ],
          'id': '48151'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1077,
              1078,
              1079,
              1080,
              1081
            ]
          ],
          'id': '37069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1082,
              1083,
              1084,
              1085,
              1086,
              1087
            ]
          ],
          'id': '39039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1088,
              1089,
              1090,
              1091,
              1092,
              1093
            ]
          ],
          'id': '47055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1094,
              1095,
              1096,
              1097,
              1098
            ]
          ],
          'id': '48023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1099,
              1100,
              1101,
              1102,
              1103
            ]
          ],
          'id': '48365'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1104,
              1105,
              1106,
              1107
            ]
          ],
          'id': '53001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1040,
              1108,
              1109,
              1110,
              1111,
              1112
            ]
          ],
          'id': '19015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1113,
              1114,
              1115,
              -265,
              1116,
              1117,
              1118
            ]
          ],
          'id': '48237'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1119,
              1120,
              1121,
              1122,
              1123
            ]
          ],
          'id': '72009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1124,
              1125,
              -370,
              1126,
              -660
            ]
          ],
          'id': '20017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -706,
              1127,
              1128,
              1129,
              1130
            ]
          ],
          'id': '48099'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1131,
              1132,
              1133,
              1134,
              1135
            ]
          ],
          'id': '26037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1136,
              1137,
              1138,
              -373
            ]
          ],
          'id': '20207'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1139,
              1140,
              1141,
              1142,
              1143,
              1144,
              1145
            ]
          ],
          'id': '17037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1146,
              1147,
              1148,
              1149,
              1150
            ]
          ],
          'id': '19159'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1151,
              1152,
              1153,
              1154,
              1155
            ]
          ],
          'id': '19165'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1156,
              1157,
              1158,
              1159,
              1160,
              1161,
              -212,
              1162
            ]
          ],
          'id': '06019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1163,
              1164,
              1165,
              -1147,
              1166
            ]
          ],
          'id': '19175'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1167,
              1168,
              1169,
              1170,
              1171,
              1172
            ]
          ],
          'id': '17123'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1173,
              1174,
              1175,
              1176,
              1177,
              1178
            ]
          ],
          'id': '17147'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1179,
              1180,
              -1167,
              1181,
              1182
            ]
          ],
          'id': '19003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1183,
              1184,
              1185,
              1186,
              1187,
              1188,
              1189
            ]
          ],
          'id': '17159'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1190,
              1191,
              1192,
              1193,
              1194
            ]
          ],
          'id': '47023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1195,
              1196,
              1197,
              1198,
              1199
            ]
          ],
          'id': '26023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1200,
              1201,
              1202,
              1203,
              1204,
              1205
            ]
          ],
          'id': '37151'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1206,
              1207,
              1208,
              1209,
              1210,
              1211
            ]
          ],
          'id': '20199'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1212,
              1213,
              1214,
              1215,
              1216,
              1217
            ]
          ],
          'id': '18177'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1218
            ]
          ],
          'id': '51595'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1219,
              1220,
              1221,
              1222,
              1223
            ]
          ],
          'id': '48295'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1224,
              1225,
              1226,
              1227
            ]
          ],
          'id': '47169'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1228,
              1229,
              1230,
              1231,
              1232,
              1233,
              1234,
              1235,
              1236,
              -726,
              1237
            ]
          ],
          'id': '49037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1238,
              1239,
              1240,
              -287,
              1241,
              1242
            ]
          ],
          'id': '19123'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1243,
              1244,
              1245,
              1246
            ]
          ],
          'id': '16021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1247,
              1248,
              1249,
              1250,
              1251,
              1252,
              1253
            ]
          ],
          'id': '17107'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1254,
              1255,
              1256,
              1257,
              1258
            ]
          ],
          'id': '20059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1259,
              1260,
              1261,
              1262,
              1263,
              1264,
              1265,
              1266
            ]
          ],
          'id': '22013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1267,
              1268,
              1269,
              1270,
              1271
            ]
          ],
          'id': '06005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1272,
              1273,
              -1268,
              1274,
              1275
            ]
          ],
          'id': '06017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1276,
              1277,
              1278,
              1279,
              1280
            ]
          ],
          'id': '05065'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1281
            ]
          ],
          'id': '51530'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1282,
              1283
            ]
          ],
          'id': '51590'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1284,
              1285
            ]
          ],
          'id': '51640'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1286
            ]
          ],
          'id': '51660'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1287
            ]
          ],
          'id': '51690'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1288,
              1289,
              1290,
              1291,
              1292,
              1293
            ]
          ],
          'id': '18049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1294,
              1295,
              -1164,
              -1181,
              1296
            ]
          ],
          'id': '19001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1297,
              -215,
              213,
              -213,
              -1162,
              1298,
              1299,
              1300
            ]
          ],
          'id': '06053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1301,
              1302,
              1303,
              1304,
              1305
            ]
          ],
          'id': '29219'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1306,
              1307,
              1308,
              1309,
              1310
            ]
          ],
          'id': '37197'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -446,
              1311,
              1312,
              1313,
              -1132,
              1314
            ]
          ],
          'id': '26057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1315,
              1316,
              1317,
              1318,
              1319,
              1320
            ]
          ],
          'id': '21129'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1321,
              1322,
              1323,
              1324,
              1325,
              1326
            ]
          ],
          'id': '20133'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1327,
              -1136,
              1328,
              1329,
              1330
            ]
          ],
          'id': '26067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1331,
              1332,
              1333,
              1334,
              1335
            ]
          ],
          'id': '26077'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1336,
              1337,
              1338,
              1339,
              1340,
              1341
            ]
          ],
          'id': '21149'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1342,
              1343,
              1344,
              1345,
              1346,
              1347
            ]
          ],
          'id': '27033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -585,
              1348,
              1349,
              -382,
              1350
            ]
          ],
          'id': '26085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -586,
              -1351,
              1351,
              1352
            ]
          ],
          'id': '26105'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1353,
              -448,
              1354,
              -383
            ]
          ],
          'id': '26107'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1355,
              -386,
              1356,
              1357,
              1358
            ]
          ],
          'id': '26121'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1359,
              1360,
              1361,
              1362,
              1363,
              1364
            ]
          ],
          'id': '27047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1365,
              1366,
              1367,
              1368,
              1369,
              1370,
              1371
            ]
          ],
          'id': '17051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1372,
              1373,
              1374,
              1375,
              -1368
            ]
          ],
          'id': '17049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1376,
              1377,
              1378,
              1379
            ]
          ],
          'id': '27009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1380,
              1381,
              1382,
              1383,
              -415
            ]
          ],
          'id': '48129'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1384,
              1385,
              1386,
              1387,
              1388
            ]
          ],
          'id': '27041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1389,
              1390,
              1391,
              1392,
              -404
            ]
          ],
          'id': '40073'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1393,
              1394,
              1395,
              1396,
              1397,
              1398
            ]
          ],
          'id': '47053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1399,
              1400,
              1401,
              1402,
              1403,
              1404,
              1405
            ]
          ],
          'id': '47005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1406,
              1407,
              1408,
              1409
            ]
          ],
          'id': '45009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1410,
              1411,
              1412,
              1413,
              1414,
              -557,
              1415,
              1416
            ]
          ],
          'id': '48013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1417,
              1418,
              1419,
              -111,
              1420,
              1421,
              1422,
              -701
            ]
          ],
          'id': '46067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1423,
              1424,
              1425,
              1426,
              -41,
              1427
            ]
          ],
          'id': '46019'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                1428,
                1429,
                1430,
                1431
              ]
            ],
            [
              [
                1432,
                1433
              ]
            ],
            [
              [
                1434
              ]
            ],
            [
              [
                1435,
                1436
              ]
            ],
            [
              [
                1437
              ]
            ],
            [
              [
                1438
              ]
            ],
            [
              [
                1439
              ]
            ],
            [
              [
                1440
              ]
            ],
            [
              [
                1441,
                1442
              ]
            ],
            [
              [
                1443,
                1444,
                1445,
                1446
              ]
            ]
          ],
          'id': '02105'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1447,
              1448,
              1449,
              1450,
              -542,
              -273
            ]
          ],
          'id': '46059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -608,
              1451,
              1452,
              -266,
              -601,
              1453,
              1454
            ]
          ],
          'id': '46077'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1455,
              1456,
              1457,
              1458,
              1459
            ]
          ],
          'id': '47101'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1460,
              1461,
              1462,
              1463,
              1464
            ]
          ],
          'id': '55069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1465,
              -1397,
              1466,
              1467,
              -1191,
              1468,
              1469
            ]
          ],
          'id': '47113'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1470
            ]
          ],
          'id': '51540'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1471,
              1472,
              1473,
              1474,
              1475,
              1476
            ]
          ],
          'id': '30037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1477,
              1478,
              1479,
              1480,
              1481,
              1482,
              1483,
              -827
            ]
          ],
          'id': '56009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1484,
              1485,
              1486,
              1487,
              1488
            ]
          ],
          'id': '47179'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1489,
              1490,
              -1465,
              1491,
              1492,
              1493
            ]
          ],
          'id': '55119'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1494,
              1495,
              1496,
              1497,
              1498,
              1499,
              1500,
              1501,
              1502,
              -1502,
              1501,
              1503,
              1504
            ]
          ],
          'id': '56029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1505,
              1506,
              -1348,
              1507,
              -743,
              1508
            ]
          ],
          'id': '27101'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1509,
              1510,
              1511,
              1512,
              1513,
              1514
            ]
          ],
          'id': '55133'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1515,
              1516,
              -1509,
              -742,
              1517
            ]
          ],
          'id': '27117'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1518,
              1519,
              1520,
              1521,
              1522
            ]
          ],
          'id': '51099'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1523,
              1524,
              1525,
              1526,
              1527,
              1528,
              1529
            ]
          ],
          'id': '30001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1530,
              1531,
              -1472,
              1532,
              1533
            ]
          ],
          'id': '30107'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1534,
              -916,
              1535,
              1536,
              1537,
              1538
            ]
          ],
          'id': '29043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1539,
              1540,
              1541,
              1542,
              1543,
              1544
            ]
          ],
          'id': '29053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1545,
              1546,
              1547,
              1548,
              1549,
              1550
            ]
          ],
          'id': '20029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1551,
              1552,
              1553,
              1554,
              1555
            ]
          ],
          'id': '51159'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1556,
              -1398,
              -1466,
              1557,
              1558
            ]
          ],
          'id': '47033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1559,
              1560,
              1561,
              1562,
              1563
            ]
          ],
          'id': '18063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1564,
              1565,
              1566,
              1567,
              1568,
              1569,
              1570,
              -378
            ]
          ],
          'id': '20135'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1571,
              1572,
              1573,
              1574,
              -1143
            ]
          ],
          'id': '17093'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1575,
              1576,
              1577,
              1578,
              1579
            ]
          ],
          'id': '18149'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1580,
              1581,
              1582,
              1583,
              1584,
              -654
            ]
          ],
          'id': '18145'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1585,
              1586,
              1587,
              1588,
              -913,
              1589
            ]
          ],
          'id': '29105'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1590,
              1591,
              1592,
              1593,
              1594,
              1595
            ]
          ],
          'id': '29117'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1596,
              1597,
              -1007,
              -908,
              1598
            ]
          ],
          'id': '26137'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1599,
              1600,
              1601,
              1602,
              1603
            ]
          ],
          'id': '31087'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -910,
              -790,
              -1023,
              -905,
              1604
            ]
          ],
          'id': '26143'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1605,
              1606,
              1607,
              1608,
              1609
            ]
          ],
          'id': '29011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -416,
              -1384,
              1610,
              1611,
              1612,
              1613
            ]
          ],
          'id': '48045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1614,
              1615,
              1616,
              1617,
              1618,
              1619
            ]
          ],
          'id': '26161'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1620,
              -1330,
              1621,
              1622,
              -1333,
              1623
            ]
          ],
          'id': '26015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1624,
              1625,
              1626,
              1627,
              1628
            ]
          ],
          'id': '35029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1629,
              1630,
              1631,
              1632,
              1633,
              1634,
              1635
            ]
          ],
          'id': '51169'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1636,
              1637,
              1638,
              1639,
              1640
            ]
          ],
          'id': '33007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1641,
              1642,
              1643,
              1644,
              1645,
              1646
            ]
          ],
          'id': '38095'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1647,
              1648,
              1649,
              1650,
              -502,
              1651
            ]
          ],
          'id': '29145'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                1652,
                1653
              ]
            ],
            [
              [
                -1431,
                1654,
                -55,
                1655
              ]
            ]
          ],
          'id': '02195'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1656,
              -1065,
              1657,
              1658,
              1659
            ]
          ],
          'id': '31167'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1660,
              1661,
              1662,
              -1060,
              -1657,
              1663
            ]
          ],
          'id': '31179'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1664,
              1665,
              1666,
              1667,
              -205,
              203,
              -203
            ]
          ],
          'id': '26109'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1668,
              1669,
              1670,
              1671,
              1672
            ]
          ],
          'id': '48175'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1673,
              -39,
              -1013,
              1674,
              -343,
              1675
            ]
          ],
          'id': '38073'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1676,
              1677,
              -1381,
              1678
            ]
          ],
          'id': '48179'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1679,
              1680,
              1681,
              1682,
              1683,
              1684
            ]
          ],
          'id': '42121'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1383,
              1685,
              -514,
              -278,
              1686,
              -1611
            ]
          ],
          'id': '48191'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1687,
              -1538,
              1688,
              1689,
              1690
            ]
          ],
          'id': '29209'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1691,
              1692,
              1693,
              1694,
              1695,
              1696
            ]
          ],
          'id': '39057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1697,
              1698,
              -1596,
              1699,
              1700,
              1701
            ]
          ],
          'id': '29061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1702,
              1703,
              1704,
              1705,
              1706,
              1707
            ]
          ],
          'id': '29199'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1708,
              1709,
              1710,
              1711,
              1712,
              1713,
              1714
            ]
          ],
          'id': '48049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -509,
              1715,
              1716,
              -941,
              1717,
              1718
            ]
          ],
          'id': '48165'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1130,
              1719,
              -694,
              1720,
              1721,
              1722,
              1723
            ]
          ],
          'id': '48027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1724,
              -1247,
              1725,
              1726,
              1727
            ]
          ],
          'id': '53051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1728,
              1729,
              1730,
              1731,
              1732,
              1733
            ]
          ],
          'id': '13277'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1734,
              1735,
              1736,
              1737,
              1738
            ]
          ],
          'id': '48435'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1739,
              1740,
              1741,
              1742,
              1743
            ]
          ],
          'id': '51023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1744,
              1745,
              1746,
              1747,
              1748
            ]
          ],
          'id': '48405'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -139,
              1749,
              1750,
              1751,
              1752,
              1753,
              1754
            ]
          ],
          'id': '72129'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1755,
              1756,
              1757,
              1758,
              -149,
              1759
            ]
          ],
          'id': '72143'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1760,
              1761,
              1762,
              1763
            ]
          ],
          'id': '27017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1764,
              1765,
              1766,
              1767,
              1768
            ]
          ],
          'id': '12029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1769,
              1770,
              1771,
              1772,
              1773,
              1774
            ]
          ],
          'id': '13211'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1775,
              1776,
              1777,
              1778
            ]
          ],
          'id': '02188'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1779,
              1780,
              1781,
              -715,
              1782
            ]
          ],
          'id': '38007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1783,
              1784,
              1785,
              -1764,
              1786,
              1787,
              1788,
              1789
            ]
          ],
          'id': '27001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1790,
              1791,
              1792,
              1793,
              1794,
              1795,
              1796
            ]
          ],
          'id': '08045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1257,
              1797,
              1798,
              1799
            ]
          ],
          'id': '20003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -282,
              1800,
              1801,
              1802,
              -553
            ]
          ],
          'id': '48269'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1803,
              -407,
              1804,
              1805,
              -535,
              1806
            ]
          ],
          'id': '40039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1807,
              -98,
              1808,
              1809,
              1810,
              1811
            ]
          ],
          'id': '39101'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1812,
              1813,
              1814,
              1815,
              1816,
              1817
            ]
          ],
          'id': '17095'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1818,
              1819,
              1820,
              1821
            ]
          ],
          'id': '13013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1144,
              -1575,
              1822,
              1823,
              1824,
              -1170,
              1825,
              1826,
              1827
            ]
          ],
          'id': '17099'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1828,
              1829,
              1830,
              1831,
              1832
            ]
          ],
          'id': '01031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1833,
              1834,
              1835,
              1836
            ]
          ],
          'id': '12085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1837,
              1838,
              1839,
              -1109,
              -1039
            ]
          ],
          'id': '19079'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -890,
              1840,
              -775,
              1841,
              -1839
            ]
          ],
          'id': '19083'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1842,
              1843,
              1844,
              1845,
              1846,
              1847
            ]
          ],
          'id': '16037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1848,
              1849,
              1850,
              1851,
              1852,
              1853
            ]
          ],
          'id': '13037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1854,
              1855,
              1856,
              1857
            ]
          ],
          'id': '19093'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1858,
              1859,
              -162,
              -618,
              1860
            ]
          ],
          'id': '08105'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1861,
              -1243,
              1862,
              1863,
              -524,
              1864
            ]
          ],
          'id': '19125'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1865,
              -1028,
              1866,
              1867
            ]
          ],
          'id': '08087'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1868,
              1869,
              1870,
              -1240,
              1871
            ]
          ],
          'id': '19157'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1872,
              1873,
              1874,
              -1248,
              1875,
              1876
            ]
          ],
          'id': '17179'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1877,
              1878,
              1879,
              1880
            ]
          ],
          'id': '08039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1111,
              1881,
              1882,
              -1865,
              -523,
              1883
            ]
          ],
          'id': '19153'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1884,
              1885,
              1886,
              1887,
              1888
            ]
          ],
          'id': '39149'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1889,
              -527,
              1890,
              -1165,
              -1296
            ]
          ],
          'id': '19121'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1891,
              1892,
              1893,
              1894,
              -677
            ]
          ],
          'id': '39153'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1895,
              1896,
              -765,
              1897
            ]
          ],
          'id': '12049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1898,
              1899,
              1900,
              1901,
              1902,
              1903,
              1904
            ]
          ],
          'id': '39161'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1905,
              -1696,
              1906,
              1907,
              1908,
              1909
            ]
          ],
          'id': '39165'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1910,
              1911,
              1912,
              1913,
              -974,
              1914
            ]
          ],
          'id': '48463'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1915,
              1916,
              1917,
              1918,
              1919,
              -650,
              1920
            ]
          ],
          'id': '13195'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1921,
              1922,
              -842,
              1923,
              1924,
              1925
            ]
          ],
          'id': '39059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1926,
              1927,
              1928,
              1929,
              -1412
            ]
          ],
          'id': '48493'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1810,
              1930,
              -953,
              1931,
              1932,
              1933
            ]
          ],
          'id': '39041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1934,
              1935,
              1936,
              1937,
              1938
            ]
          ],
          'id': '39055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -538,
              1939,
              1940,
              1941
            ]
          ],
          'id': '40055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1942,
              1943,
              1944,
              1945,
              1946,
              1947,
              1948
            ]
          ],
          'id': '27131'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1949,
              1950,
              1951,
              1952,
              1953,
              1954,
              1955
            ]
          ],
          'id': '05025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1956,
              1957,
              1958,
              1959,
              1960,
              -196
            ]
          ],
          'id': '13093'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -423,
              -257,
              1961,
              -1735,
              1962
            ]
          ],
          'id': '48413'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1963,
              1964,
              1965,
              1966,
              -1345
            ]
          ],
          'id': '27165'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1967,
              1968,
              1969,
              -391,
              1970,
              1971
            ]
          ],
          'id': '31001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1972,
              1973,
              1974,
              1975
            ]
          ],
          'id': '37003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1976,
              -312,
              1977,
              1978,
              -1607
            ]
          ],
          'id': '29039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1979,
              -417,
              -1614,
              1980,
              -820,
              1981
            ]
          ],
          'id': '48437'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1982,
              1983,
              1984,
              1985,
              1986,
              1987,
              1988
            ]
          ],
          'id': '30049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1989,
              1990,
              1991,
              -1545,
              1992,
              1993,
              1994
            ]
          ],
          'id': '29159'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1612,
              -1687,
              -283,
              -552,
              1995
            ]
          ],
          'id': '48345'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              1996,
              1997,
              1998,
              -1524,
              1999,
              2000
            ]
          ],
          'id': '30081'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2001,
              2002,
              2003,
              -11,
              2004,
              2005,
              2006,
              2007
            ]
          ],
          'id': '06071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2008,
              2009,
              2010,
              2011,
              2012,
              2013
            ]
          ],
          'id': '13189'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -1439
              ]
            ],
            [
              [
                2014
              ]
            ],
            [
              [
                2015,
                2016,
                2017,
                2018,
                -1446,
                2019
              ]
            ]
          ],
          'id': '02100'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1492,
              -1464,
              2020,
              2021,
              2022,
              2023,
              2024
            ]
          ],
          'id': '55073'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                2025
              ]
            ],
            [
              [
                2026
              ]
            ],
            [
              [
                2027
              ]
            ],
            [
              [
                2028
              ]
            ],
            [
              [
                2029
              ]
            ],
            [
              [
                2030
              ]
            ],
            [
              [
                2031
              ]
            ],
            [
              [
                2032
              ]
            ],
            [
              [
                2033
              ]
            ],
            [
              [
                2034
              ]
            ],
            [
              [
                2035
              ]
            ],
            [
              [
                2036
              ]
            ],
            [
              [
                2037
              ]
            ],
            [
              [
                2038
              ]
            ],
            [
              [
                2039
              ]
            ],
            [
              [
                2040
              ]
            ],
            [
              [
                2041
              ]
            ],
            [
              [
                2042,
                2043
              ]
            ],
            [
              [
                2044
              ]
            ],
            [
              [
                2045
              ]
            ],
            [
              [
                2046
              ]
            ],
            [
              [
                2047
              ]
            ],
            [
              [
                2048
              ]
            ],
            [
              [
                2049
              ]
            ]
          ],
          'id': '02013'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                2050
              ]
            ],
            [
              [
                2051
              ]
            ],
            [
              [
                2052
              ]
            ],
            [
              [
                2053
              ]
            ],
            [
              [
                2054
              ]
            ],
            [
              [
                2055
              ]
            ],
            [
              [
                2056
              ]
            ],
            [
              [
                2057
              ]
            ],
            [
              [
                2058
              ]
            ],
            [
              [
                2059
              ]
            ],
            [
              [
                2060
              ]
            ],
            [
              [
                2061
              ]
            ],
            [
              [
                2062,
                2063,
                2064
              ]
            ],
            [
              [
                2065
              ]
            ]
          ],
          'id': '02150'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                2066
              ]
            ],
            [
              [
                2067
              ]
            ],
            [
              [
                2068
              ]
            ],
            [
              [
                2069
              ]
            ],
            [
              [
                2070
              ]
            ],
            [
              [
                2071,
                -762,
                2072,
                2073,
                2074,
                2075,
                -2065,
                2076,
                -2043
              ]
            ]
          ],
          'id': '02164'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                2077
              ]
            ],
            [
              [
                2078
              ]
            ],
            [
              [
                2079
              ]
            ],
            [
              [
                2080
              ]
            ],
            [
              [
                2081
              ]
            ],
            [
              [
                2082
              ]
            ],
            [
              [
                2083
              ]
            ],
            [
              [
                2084
              ]
            ],
            [
              [
                2085,
                2086,
                2087,
                2088,
                2089,
                2090,
                2091
              ]
            ]
          ],
          'id': '02261'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2092,
              2093,
              -1418,
              -700,
              -124
            ]
          ],
          'id': '46035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2094,
              2095,
              2096,
              2097,
              2098,
              2099,
              2100,
              2101
            ]
          ],
          'id': '41023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2102,
              2103,
              2104,
              2105,
              2106,
              2107
            ]
          ],
          'id': '39129'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1938,
              2108,
              2109,
              2110,
              -1893
            ]
          ],
          'id': '39133'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2111,
              2112,
              2113,
              2114,
              -847
            ]
          ],
          'id': '13131'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2115,
              2116,
              2117,
              2118,
              2119,
              2120
            ]
          ],
          'id': '72093'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2121,
              2122,
              2123,
              2124,
              2125,
              2126
            ]
          ],
          'id': '54075'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2127,
              2128,
              2129
            ]
          ],
          'id': '72117'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2130,
              2131,
              2132,
              2133,
              -1385,
              2134,
              2135
            ]
          ],
          'id': '27111'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2136,
              2137,
              2138,
              2139,
              2140,
              2141,
              2142
            ]
          ],
          'id': '13111'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2143,
              2144,
              2145,
              -28,
              -233,
              -26
            ]
          ],
          'id': '27113'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2146,
              2147,
              2148,
              2149
            ]
          ],
          'id': '17021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2150,
              2151,
              2152,
              2153,
              2154,
              -1291
            ]
          ],
          'id': '18169'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2155,
              2156,
              2157,
              2158,
              2159,
              -1232
            ]
          ],
          'id': '08085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2160,
              2161,
              2162,
              -14,
              2163
            ]
          ],
          'id': '28113'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -495,
              2164,
              2165,
              2166,
              2167,
              2168
            ]
          ],
          'id': '38049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2169,
              2170,
              2171,
              2172,
              -1704,
              2173
            ]
          ],
          'id': '19177'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2174,
              2175,
              2176
            ]
          ],
          'id': '17171'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2177,
              -886,
              2178,
              2179,
              2180
            ]
          ],
          'id': '13021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2181,
              -140,
              -1755,
              2182,
              2183,
              2184,
              -1122
            ]
          ],
          'id': '72035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1026,
              2185,
              2186,
              -1312,
              -445
            ]
          ],
          'id': '26111'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2187,
              2188,
              2189,
              2190,
              -1567,
              2191
            ]
          ],
          'id': '20051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2192,
              2193,
              2194,
              -2165,
              -494
            ]
          ],
          'id': '38009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2195
            ]
          ],
          'id': '60030'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                2196
              ]
            ],
            [
              [
                2197
              ]
            ]
          ],
          'id': '60020'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2198,
              2199
            ]
          ],
          'id': '60050'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -894,
              2200,
              -1087,
              2201,
              -1905,
              2202,
              2203,
              2204,
              2205
            ]
          ],
          'id': '18003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2206,
              2207,
              2208,
              2209,
              2210,
              2211
            ]
          ],
          'id': '20085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2212,
              2213,
              2214,
              2215,
              2216,
              -2171
            ]
          ],
          'id': '19087'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2217,
              2218,
              2219,
              -1560,
              2220
            ]
          ],
          'id': '18011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              573,
              -573,
              571,
              -571,
              569,
              -569,
              2221,
              2222,
              2223,
              2224,
              2225,
              -575
            ]
          ],
          'id': '06103'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1292,
              -2155,
              2226,
              2227,
              2228
            ]
          ],
          'id': '18103'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2229,
              2230,
              2231,
              2232,
              2233
            ]
          ],
          'id': '38047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2234,
              2235,
              2236,
              2237,
              2238,
              2239
            ]
          ],
          'id': '40021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2240,
              -275,
              -545,
              2241,
              2242,
              -626,
              2243,
              2244,
              2245,
              2246
            ]
          ],
          'id': '46085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -30,
              2247,
              2248,
              2249
            ]
          ],
          'id': '27087'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1493,
              -2025,
              2250,
              2251,
              2252,
              2253
            ]
          ],
          'id': '55019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2254,
              2255,
              -380,
              2256,
              2257,
              2258
            ]
          ],
          'id': '20171'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2259,
              2260,
              2261,
              2262,
              2263
            ]
          ],
          'id': '27135'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2264,
              2265,
              2266,
              2267,
              2268,
              2269,
              2270
            ]
          ],
          'id': '05115'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2271,
              2272,
              2273,
              2274,
              2275
            ]
          ],
          'id': '26095'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1994,
              2276,
              2277,
              2278,
              -309,
              2279
            ]
          ],
          'id': '29015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2280,
              2281,
              2282,
              2283,
              2284,
              -2267
            ]
          ],
          'id': '05141'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2285,
              2286,
              2287,
              2288,
              2289,
              2290,
              2291,
              2292
            ]
          ],
          'id': '51199'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -915,
              2293,
              2294,
              2295,
              2296,
              2297,
              -1536
            ]
          ],
          'id': '29067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2298,
              2299,
              2300,
              2301,
              -1989,
              2302,
              2303,
              2304,
              2305,
              2306
            ]
          ],
          'id': '30029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2307,
              2308,
              2309,
              2310,
              2311
            ]
          ],
          'id': '48305'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2312,
              2313,
              2314,
              2315,
              2316,
              2317
            ]
          ],
          'id': '29065'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2318,
              2319,
              2320,
              2321,
              -1962
            ]
          ],
          'id': '48327'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1076,
              -413,
              -721,
              2322,
              -467
            ]
          ],
          'id': '48353'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2323,
              -2316,
              2324,
              2325,
              2326,
              2327
            ]
          ],
          'id': '29203'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2328,
              2329,
              -469,
              2330,
              -253,
              2331
            ]
          ],
          'id': '48431'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2332,
              2333,
              2334,
              2335,
              2336
            ]
          ],
          'id': '08089'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2337,
              2338,
              2339,
              2340,
              -2309
            ]
          ],
          'id': '48169'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2341,
              2342,
              2343,
              2344
            ]
          ],
          'id': '08119'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2345,
              -2306,
              2346,
              2347,
              2348,
              2349,
              2350
            ]
          ],
          'id': '30089'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2351,
              -251,
              2352,
              -1709,
              2353,
              -410
            ]
          ],
          'id': '48059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1803,
              2354,
              2355,
              -1074,
              2356
            ]
          ],
          'id': '48433'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2357,
              2358,
              2359,
              2360,
              -529,
              2361
            ]
          ],
          'id': '40051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2362,
              2363,
              2364,
              2365,
              2366,
              2367
            ]
          ],
          'id': '48159'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2368,
              2369,
              2370,
              2371,
              2372,
              2373
            ]
          ],
          'id': '48467'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2374,
              -1059,
              2375,
              2376
            ]
          ],
          'id': '31073'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2377,
              2378,
              2379,
              2380,
              -388
            ]
          ],
          'id': '31059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2381,
              2382,
              2383,
              2384,
              2385,
              -2369,
              2386,
              2387
            ]
          ],
          'id': '48231'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2388,
              2389,
              -117,
              2390,
              2391
            ]
          ],
          'id': '48313'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2392,
              2393,
              2394,
              2395,
              2396,
              2397,
              2398
            ]
          ],
          'id': '40019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2399,
              2400,
              2401,
              2402,
              2403
            ]
          ],
          'id': '51157'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2404,
              2405,
              2406,
              2407,
              2408
            ]
          ],
          'id': '01103'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2409,
              2410,
              2411,
              2412,
              2413
            ]
          ],
          'id': '51079'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2414,
              -1777,
              2415,
              2416,
              2417,
              2418,
              2419,
              2420,
              2421,
              -520
            ]
          ],
          'id': '02290'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2422,
              2423,
              2424,
              2425,
              2426
            ]
          ],
          'id': '42059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1953,
              2427,
              2428,
              2429,
              2430,
              2431
            ]
          ],
          'id': '05043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2432,
              2433,
              -458,
              2434,
              2435,
              2436,
              2437
            ]
          ],
          'id': '28043'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                2438
              ]
            ],
            [
              [
                2439,
                2440
              ]
            ]
          ],
          'id': '51750'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2441,
              2442,
              2443,
              2444,
              2445
            ]
          ],
          'id': '29211'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2446,
              2447,
              2448,
              2449,
              2450
            ]
          ],
          'id': '54047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2451,
              2452,
              2453,
              2454,
              2455
            ]
          ],
          'id': '37133'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2456,
              2457,
              2458,
              2459,
              2460,
              2461
            ]
          ],
          'id': '29049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2462,
              2463,
              2464,
              2465,
              2466,
              2467
            ]
          ],
          'id': '12005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -144,
              2468,
              2469,
              2470
            ]
          ],
          'id': '72061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2471,
              2472,
              2473,
              2474,
              2475
            ]
          ],
          'id': '72029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -150,
              -1759,
              2476,
              2477,
              2478,
              2479
            ]
          ],
          'id': '72047'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                2480,
                2481,
                2482,
                -636,
                2483
              ]
            ],
            [
              [
                2484
              ]
            ]
          ],
          'id': '53033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2485,
              2486,
              2487,
              2488,
              2489,
              2490,
              2491,
              2492,
              2493,
              2494,
              2495,
              -2496,
              2495,
              2496,
              -2482,
              2497
            ]
          ],
          'id': '53007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2498,
              2499,
              2500,
              2501
            ]
          ],
          'id': '12035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2497,
              -2496,
              2495,
              -2496,
              -2495,
              2493,
              -2493,
              2491,
              -2491,
              2489,
              -2489,
              2502,
              2503,
              2504,
              -2483
            ]
          ],
          'id': '53037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2505,
              2506,
              2507,
              2508
            ]
          ],
          'id': '12095'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2509,
              -68,
              2510,
              2511,
              -1959
            ]
          ],
          'id': '13235'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2512,
              2513,
              -2164,
              -13,
              2514,
              2515,
              2516
            ]
          ],
          'id': '28005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2517,
              2518,
              2519,
              2520,
              2521
            ]
          ],
          'id': '46045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1574,
              2522,
              2523,
              2524,
              -1823
            ]
          ],
          'id': '17063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2525,
              2526,
              2527,
              -735,
              2528,
              -783
            ]
          ],
          'id': '20151'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2529,
              2530,
              2531,
              -888,
              -230
            ]
          ],
          'id': '19033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2532,
              2533,
              2534,
              2535,
              2536,
              2537
            ]
          ],
          'id': '31155'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2538,
              2539,
              2540,
              2541,
              2542
            ]
          ],
          'id': '05125'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2023,
              -837,
              -426,
              2543,
              2544
            ]
          ],
          'id': '55097'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2545,
              2546,
              -1610,
              2547,
              2548,
              2549,
              -1324
            ]
          ],
          'id': '20037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2550,
              2551,
              2552,
              2553,
              2554
            ]
          ],
          'id': '48221'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2555,
              2556,
              2557,
              2558,
              -371,
              -1126
            ]
          ],
          'id': '20111'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2559,
              2560,
              2561,
              2562,
              2563
            ]
          ],
          'id': '46047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2564,
              -299,
              297,
              -306,
              2565,
              2566,
              2567
            ]
          ],
          'id': '30069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2568,
              2569,
              2570,
              2571,
              2572,
              -2218,
              2573
            ]
          ],
          'id': '18023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -696,
              2574,
              -40,
              -1674,
              2575,
              2576
            ]
          ],
          'id': '38003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2577,
              2578,
              2579,
              2580,
              2581
            ]
          ],
          'id': '50015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2582,
              2583,
              2584,
              2585,
              2586,
              2587
            ]
          ],
          'id': '13035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2251,
              -2024,
              -2545,
              2588,
              2589,
              2590
            ]
          ],
          'id': '55141'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2591,
              -231,
              -891,
              -1838,
              -1038
            ]
          ],
          'id': '19197'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2592,
              2593,
              2594,
              -546,
              2595,
              -2321
            ]
          ],
          'id': '48319'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2596,
              2597,
              2598,
              2599
            ]
          ],
          'id': '48183'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2600,
              2601,
              2602,
              2603,
              2604,
              2605
            ]
          ],
          'id': '28105'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -985,
              983,
              -983,
              981,
              -981,
              2606,
              2607,
              2608
            ]
          ],
          'id': '06057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2562,
              2609,
              2610,
              2611,
              2612
            ]
          ],
          'id': '31045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2613,
              2614,
              2615,
              2616,
              2617
            ]
          ],
          'id': '41033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -972,
              2618,
              2619,
              2620,
              -2379
            ]
          ],
          'id': '31151'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1222,
              2621,
              2622,
              2623,
              2624
            ]
          ],
          'id': '48211'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2625,
              -2587,
              2626,
              2627,
              2628
            ]
          ],
          'id': '13171'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2629,
              2630,
              2631,
              2632,
              2633
            ]
          ],
          'id': '28065'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1932,
              -952,
              2634,
              2635,
              2636,
              2637,
              2638
            ]
          ],
          'id': '39089'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -189,
              2639,
              -1982,
              -819,
              2640,
              2641
            ]
          ],
          'id': '48069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2642,
              -1599,
              2643,
              2644,
              2645
            ]
          ],
          'id': '26009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2646,
              2647,
              2648,
              2649,
              2650,
              -177
            ]
          ],
          'id': '20147'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2651,
              2652,
              2653,
              2654
            ]
          ],
          'id': '20067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1986,
              2655,
              2656,
              2657
            ]
          ],
          'id': '30007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -597,
              2658,
              -794,
              2659,
              -1968,
              2660,
              -1055,
              2661
            ]
          ],
          'id': '31019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2662,
              2663,
              2664,
              2665
            ]
          ],
          'id': '32009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2666,
              2667,
              2668,
              2669,
              2670
            ]
          ],
          'id': '37135'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2671,
              2672,
              2673,
              2674,
              2675,
              2676
            ]
          ],
          'id': '16051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2677,
              -1199,
              2678,
              -892,
              2679
            ]
          ],
          'id': '18087'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -967,
              2680,
              2681,
              2682,
              -293,
              2683
            ]
          ],
          'id': '19105'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2684,
              2685,
              2686,
              2687,
              2688,
              2689
            ]
          ],
          'id': '19027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2690,
              2691,
              -697,
              -2577,
              2692,
              -2231,
              2693
            ]
          ],
          'id': '38093'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2694,
              -1041,
              -1113,
              2695,
              2696,
              -2687
            ]
          ],
          'id': '19073'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2697,
              2698,
              2699,
              2700,
              2701,
              2702,
              2703
            ]
          ],
          'id': '01003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2704,
              2705,
              2706,
              -1620,
              2707,
              2708,
              2709
            ]
          ],
          'id': '26075'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2710,
              -1635,
              2711,
              2712,
              2713
            ]
          ],
          'id': '47067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -178,
              -2651,
              2714,
              2715,
              2716,
              2717
            ]
          ],
          'id': '20065'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1799,
              2718,
              -1322,
              -1138
            ]
          ],
          'id': '20001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2719,
              2720,
              2721,
              2722,
              2723,
              2724
            ]
          ],
          'id': '40127'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2725,
              2726,
              2727,
              2728,
              2729
            ]
          ],
          'id': '48461'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2730,
              -2521,
              2731,
              -271,
              2732,
              2733
            ]
          ],
          'id': '46107'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1057,
              2734,
              -2647,
              2735
            ]
          ],
          'id': '31083'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2736,
              2737,
              2738,
              2739,
              2740
            ]
          ],
          'id': '19063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2741,
              2742,
              2743,
              2744,
              -1643
            ]
          ],
          'id': '38019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2745,
              2746,
              2747,
              2748,
              2749,
              2750
            ]
          ],
          'id': '06109'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2716,
              2751,
              -2192,
              -1566,
              2752
            ]
          ],
          'id': '20195'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2753,
              -935,
              -134,
              2754,
              2755
            ]
          ],
          'id': '48247'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2756,
              2757,
              2758,
              2759
            ]
          ],
          'id': '72069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2760,
              2761,
              2762
            ]
          ],
          'id': '55078'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1966,
              2763,
              2764,
              2765,
              -2738,
              2766
            ]
          ],
          'id': '27091'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2767,
              2768,
              2769,
              -875,
              2770,
              2771
            ]
          ],
          'id': '01085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2772,
              2773,
              -808,
              2774,
              2775,
              2776
            ]
          ],
          'id': '21073'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2777,
              2778,
              2779,
              2780,
              2781
            ]
          ],
          'id': '29205'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2782,
              2783,
              2784,
              2785,
              2786,
              2787
            ]
          ],
          'id': '40037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2788,
              2789,
              2790,
              2791,
              2792,
              2793
            ]
          ],
          'id': '48285'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -429,
              2794,
              2795,
              2796,
              2797,
              2798
            ]
          ],
          'id': '55047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -598,
              -2662,
              -1054,
              -2375,
              2799,
              2800
            ]
          ],
          'id': '31047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1335,
              -1200,
              -2678,
              2801,
              2802
            ]
          ],
          'id': '26149'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2803,
              2804,
              2805,
              -860,
              2806,
              2807
            ]
          ],
          'id': '17081'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2808,
              -480,
              2809,
              -2531,
              2810
            ]
          ],
          'id': '19131'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2811,
              -2418,
              2812,
              -2087,
              2813,
              2814
            ]
          ],
          'id': '02240'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1826,
              -1169,
              2815
            ]
          ],
          'id': '17155'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2816,
              2817,
              -1183,
              2818,
              2819
            ]
          ],
          'id': '19137'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2820,
              2821,
              -223,
              2822
            ]
          ],
          'id': '19017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2823,
              -1370,
              2824,
              2825,
              -2805,
              2826
            ]
          ],
          'id': '17121'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2827,
              2828,
              2829,
              2830,
              2831
            ]
          ],
          'id': '37025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2832,
              -945,
              2833,
              -2727,
              2834
            ]
          ],
          'id': '48329'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2322,
              -2596,
              -551,
              2835,
              2836,
              -1736
            ]
          ],
          'id': '48267'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2837,
              2838,
              2839,
              2840,
              2841
            ]
          ],
          'id': '55103'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -938,
              -421,
              2842,
              -1679,
              -414,
              -687
            ]
          ],
          'id': '48065'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2843,
              2844,
              2845,
              2846,
              2847
            ]
          ],
          'id': '21061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2848,
              2849,
              2850,
              2851,
              2852,
              2853,
              2854
            ]
          ],
          'id': '18047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2855,
              2856,
              2857,
              -1848,
              2858,
              2859
            ]
          ],
          'id': '16085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2860,
              2861,
              2862,
              2863,
              2864,
              2865
            ]
          ],
          'id': '51109'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2866,
              -1118,
              2867,
              -2555,
              2868,
              2869,
              2870
            ]
          ],
          'id': '48363'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2871,
              -2641,
              -823,
              -243,
              2872
            ]
          ],
          'id': '48279'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2873,
              2874,
              2875,
              2876,
              -2468,
              2877,
              -316
            ]
          ],
          'id': '12131'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -49,
              2878,
              2879,
              2880,
              2881
            ]
          ],
          'id': '36039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1214,
              2882,
              -489,
              2883,
              -1889,
              2884,
              2885,
              2886
            ]
          ],
          'id': '39037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2262,
              2887,
              2888,
              2889,
              2890,
              2891,
              2892,
              -2145,
              2893
            ]
          ],
          'id': '27007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2894,
              2895,
              -907,
              -1354,
              -1350
            ]
          ],
          'id': '26133'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -375,
              2896,
              2897,
              2898,
              2899,
              2900
            ]
          ],
          'id': '20049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2901,
              2902,
              2903,
              2904,
              2905
            ]
          ],
          'id': '20075'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2906,
              2907,
              2908,
              2909,
              -1761,
              -1786,
              2910,
              2911
            ]
          ],
          'id': '27137'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2912,
              2913,
              2914,
              -2214,
              2915,
              2916
            ]
          ],
          'id': '19183'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -250,
              2917,
              -2870,
              2918,
              2919,
              -1710,
              -2353
            ]
          ],
          'id': '48133'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2836,
              -550,
              2920,
              2921,
              2922,
              2923
            ]
          ],
          'id': '48265'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2924,
              2925,
              2926,
              2927,
              2928,
              2929
            ]
          ],
          'id': '36003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -822,
              2930,
              -2308,
              -244
            ]
          ],
          'id': '48303'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2931,
              2932
            ]
          ],
          'id': '51775'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2933,
              2934
            ]
          ],
          'id': '51670'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2935,
              2936,
              2937,
              2938,
              -1814,
              2939
            ]
          ],
          'id': '17073'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2940,
              2941,
              -1053,
              2942,
              2943
            ]
          ],
          'id': '28079'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2944,
              2945,
              2946,
              2947,
              2948,
              2949,
              2950
            ]
          ],
          'id': '35057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2951,
              2952,
              -153,
              2953,
              2954
            ]
          ],
          'id': '08095'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2955,
              -2954,
              -157,
              2956,
              2957,
              2958,
              -1030
            ]
          ],
          'id': '08125'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2959,
              2960,
              2961,
              2962
            ]
          ],
          'id': '19141'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2944,
              2963,
              2964,
              2965,
              2966
            ]
          ],
          'id': '28123'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -590,
              2967,
              2968,
              2969,
              -595
            ]
          ],
          'id': '31175'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2970,
              -1310,
              2971,
              2972,
              -2828,
              2973,
              2974,
              2975,
              -1974
            ]
          ],
          'id': '37097'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2976,
              2977,
              2978,
              2979,
              2980
            ]
          ],
          'id': '01057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2981,
              2982,
              -180,
              2983,
              -899,
              2984
            ]
          ],
          'id': '20039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2985,
              2986,
              2987,
              2988,
              2989,
              -2098
            ]
          ],
          'id': '41001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2990,
              2991,
              2992,
              2993,
              2994
            ]
          ],
          'id': '01133'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              2995,
              2996,
              2997,
              2998,
              2999
            ]
          ],
          'id': '29221'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3000,
              3001,
              3002
            ]
          ],
          'id': '72015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3003,
              3004,
              3005,
              3006,
              3007,
              3008,
              3009
            ]
          ],
          'id': '18007'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                3010
              ]
            ],
            [
              [
                3011
              ]
            ],
            [
              [
                3012
              ]
            ],
            [
              [
                3013
              ]
            ],
            [
              [
                3014,
                3015,
                3016,
                3017,
                3018,
                3019,
                3020,
                3021
              ]
            ]
          ],
          'id': '06083'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3022,
              -576,
              -2226,
              3023,
              3024
            ]
          ],
          'id': '06105'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3025,
              3026,
              3027,
              3028,
              3029,
              3030
            ]
          ],
          'id': '17117'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3031,
              3032,
              3033,
              3034,
              -1313,
              -2187
            ]
          ],
          'id': '26145'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2869,
              -2554,
              3035,
              3036,
              -704,
              3037,
              -2919
            ]
          ],
          'id': '48143'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                3038,
                3039,
                3040,
                3041,
                3042,
                3043
              ]
            ],
            [
              [
                3044,
                3045
              ]
            ]
          ],
          'id': '12101'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3046,
              3047,
              -818,
              3048,
              3049
            ]
          ],
          'id': '37169'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3050,
              3051,
              -2860,
              3052,
              3053,
              3054,
              3055
            ]
          ],
          'id': '16045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3056,
              3057,
              3058,
              3059,
              3060
            ]
          ],
          'id': '54021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -738,
              3061,
              3062,
              3063,
              3064,
              3065
            ]
          ],
          'id': '40003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3066,
              3067,
              3068,
              3069,
              3070,
              -1547,
              3071
            ]
          ],
          'id': '20201'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3072,
              3073,
              3074,
              3075,
              3076
            ]
          ],
          'id': '13109'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3077,
              3078,
              3079,
              -1218,
              3080,
              3081,
              3082
            ]
          ],
          'id': '18065'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3083,
              3084,
              3085,
              3086
            ]
          ],
          'id': '45023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3087,
              -2005,
              -10,
              3088,
              3089,
              3090,
              3091
            ]
          ],
          'id': '04012'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3092,
              3093,
              3094,
              -593,
              3095,
              -461
            ]
          ],
          'id': '31009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2858,
              3096,
              -2000,
              -1530,
              3097,
              3098,
              -1843
            ]
          ],
          'id': '16059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3099,
              -1048,
              3100,
              3101,
              3102
            ]
          ],
          'id': '20069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2436,
              3103,
              3104,
              3105,
              3106
            ]
          ],
          'id': '28097'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3107,
              3108,
              3109,
              3110,
              -2597,
              3111,
              3112
            ]
          ],
          'id': '48459'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3113,
              3114,
              3115,
              3116,
              3117,
              3118,
              -548
            ]
          ],
          'id': '48031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3119,
              3120,
              3121,
              3122,
              3123
            ]
          ],
          'id': '20061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3124,
              3125,
              3126,
              3127,
              3128,
              3129
            ]
          ],
          'id': '21041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3130,
              3131,
              -1289,
              -1578,
              3132
            ]
          ],
          'id': '18099'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3133,
              -817,
              3134,
              -1201,
              3135
            ]
          ],
          'id': '37081'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3136,
              3137
            ]
          ],
          'id': '51610'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3138
            ]
          ],
          'id': '51678'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3139,
              -2709,
              3140,
              3141,
              3142,
              3143,
              -1197
            ]
          ],
          'id': '26059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1209,
              3144,
              -2259,
              3145,
              -2903,
              3146
            ]
          ],
          'id': '20203'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1946,
              3147,
              3148,
              3149,
              3150
            ]
          ],
          'id': '27039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3151,
              -1174,
              3152,
              -1250
            ]
          ],
          'id': '17039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1718,
              -946,
              -2833,
              3153,
              3154,
              3155
            ]
          ],
          'id': '48003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3156,
              -1454,
              -604,
              3157,
              -2093,
              -123,
              3158
            ]
          ],
          'id': '46111'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3159,
              3160,
              -1949,
              3161,
              3162,
              3163
            ]
          ],
          'id': '27079'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3164,
              3165,
              3166,
              3167,
              -988,
              3168
            ]
          ],
          'id': '55105'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1947,
              -3151,
              3169,
              -1361,
              3170
            ]
          ],
          'id': '27147'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3171,
              3172,
              3173,
              3174,
              3175,
              3176
            ]
          ],
          'id': '42065'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3177,
              3178,
              -1043,
              3179,
              3180
            ]
          ],
          'id': '19151'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1508,
              -1347,
              3181,
              3182,
              3183,
              -744
            ]
          ],
          'id': '27105'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                3184,
                3185
              ]
            ],
            [
              [
                3186
              ]
            ],
            [
              [
                3187
              ]
            ],
            [
              [
                3188
              ]
            ],
            [
              [
                3189
              ]
            ],
            [
              [
                3190
              ]
            ],
            [
              [
                3191
              ]
            ],
            [
              [
                3192
              ]
            ],
            [
              [
                3193
              ]
            ],
            [
              [
                3194
              ]
            ],
            [
              [
                3195
              ]
            ],
            [
              [
                3196
              ]
            ],
            [
              [
                -1654,
                3197
              ]
            ],
            [
              [
                3198,
                3199
              ]
            ]
          ],
          'id': '02198'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3200,
              3201,
              3202,
              -353
            ]
          ],
          'id': '46121'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3203,
              3204,
              3205,
              3206,
              3207
            ]
          ],
          'id': '13003'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -3200,
                3208
              ]
            ],
            [
              [
                3209
              ]
            ],
            [
              [
                -1442,
                3210
              ]
            ]
          ],
          'id': '02220'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2437,
              -3107,
              3211,
              3212,
              3213
            ]
          ],
          'id': '28015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3214,
              3215,
              -1834,
              3216
            ]
          ],
          'id': '12111'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -290,
              -2174,
              -1703,
              3217,
              3218
            ]
          ],
          'id': '19051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3219,
              3220,
              3221,
              3222,
              3223
            ]
          ],
          'id': '17109'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3224,
              3225,
              3226,
              3227,
              3228
            ]
          ],
          'id': '39143'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2826,
              3229,
              -1189,
              3230,
              3231,
              -861,
              -2806
            ]
          ],
          'id': '17191'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3232,
              3233,
              3234,
              3235,
              3236,
              3237
            ]
          ],
          'id': '48243'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3238,
              -858,
              3239,
              -3160,
              3240,
              3241
            ]
          ],
          'id': '27143'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3242,
              -1098,
              3243,
              -1802
            ]
          ],
          'id': '48275'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3244,
              3245,
              3246,
              3247,
              3248,
              3249,
              3250
            ]
          ],
          'id': '17163'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -788,
              3251,
              3252,
              3253,
              -1024
            ]
          ],
          'id': '26011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1375,
              3254,
              3255,
              3256,
              -1184,
              3257
            ]
          ],
          'id': '17079'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1548,
              -3071,
              3258,
              -3120,
              3259,
              3260
            ]
          ],
          'id': '20027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3261,
              3262,
              3263,
              3264,
              -2001,
              -3097,
              -2857,
              3265,
              3266
            ]
          ],
          'id': '16049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3267,
              -1647,
              3268,
              -2194
            ]
          ],
          'id': '38079'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2984,
              -179,
              -2718,
              3269,
              -900
            ]
          ],
          'id': '20179'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3270,
              3271,
              -3114,
              -547,
              -2595
            ]
          ],
          'id': '48299'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3272,
              3273,
              3274,
              -2337,
              3275,
              3276,
              3277
            ]
          ],
          'id': '08101'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3278,
              3279,
              -2618,
              3280,
              3281
            ]
          ],
          'id': '41015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3282,
              -2605,
              3283,
              3284,
              -1050,
              3285
            ]
          ],
          'id': '28159'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2661,
              -1972,
              3286,
              -1056
            ]
          ],
          'id': '31099'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2479,
              3287,
              3288,
              3289,
              -1120,
              3290,
              3291
            ]
          ],
          'id': '72019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3292,
              -2426,
              3293,
              3294,
              3295,
              3296,
              3297,
              3298
            ]
          ],
          'id': '54103'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3299,
              -844,
              3300,
              3301
            ]
          ],
          'id': '13201'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1860,
              3302,
              3303,
              3304,
              -163
            ]
          ],
          'id': '08003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -784,
              -2529,
              -741,
              3305,
              3306,
              -1045
            ]
          ],
          'id': '20097'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3307,
              3308,
              3309,
              -717
            ]
          ],
          'id': '38041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3149,
              3310,
              3311,
              3312,
              3313,
              3314
            ]
          ],
          'id': '27109'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3315,
              -2475,
              3316,
              -1751
            ]
          ],
          'id': '72077'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1857,
              3317,
              -2690,
              -1152,
              3318,
              3319
            ]
          ],
          'id': '19047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3320,
              3321,
              3322,
              -1259,
              3323,
              -2558
            ]
          ],
          'id': '20139'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3324,
              -227,
              3325,
              -776,
              -1841
            ]
          ],
          'id': '19075'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3326,
              3327,
              -903,
              3328,
              -1207,
              3329
            ]
          ],
          'id': '20181'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2119,
              3330,
              3331,
              3332,
              3333
            ]
          ],
          'id': '72121'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2689,
              3334,
              3335,
              -1153
            ]
          ],
          'id': '19009'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                3336
              ]
            ],
            [
              [
                3337
              ]
            ],
            [
              [
                3338
              ]
            ],
            [
              [
                3339
              ]
            ],
            [
              [
                3340
              ]
            ],
            [
              [
                3341
              ]
            ],
            [
              [
                3342,
                -748,
                3343,
                3344,
                3345,
                3346
              ]
            ]
          ],
          'id': '23009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3347,
              3348,
              3349,
              3350,
              3351,
              3352
            ]
          ],
          'id': '05081'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3353,
              3354,
              3355,
              3356
            ]
          ],
          'id': '05143'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3357,
              3358,
              3359,
              3360,
              -2539,
              3361
            ]
          ],
          'id': '05119'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3362,
              3363,
              3364,
              3365,
              -3359,
              3366
            ]
          ],
          'id': '05085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3367,
              3368,
              3369,
              3370,
              3371,
              3372,
              3373
            ]
          ],
          'id': '08009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3374,
              3375,
              3376,
              3377,
              3378,
              3379,
              3380,
              3381
            ]
          ],
          'id': '16031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3382,
              3383,
              3384,
              3385,
              3386,
              3387,
              3388
            ]
          ],
          'id': '01021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1961,
              3389,
              3390,
              3391,
              3392,
              -197
            ]
          ],
          'id': '13081'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3393,
              3394,
              -1506,
              -1517,
              3395
            ]
          ],
          'id': '27083'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3396,
              3397,
              3398,
              3399,
              3400,
              3401
            ]
          ],
          'id': '51049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3402,
              3403,
              3404,
              3405,
              3406,
              3407
            ]
          ],
          'id': '31133'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2624,
              3408,
              -541,
              3409,
              -1678
            ]
          ],
          'id': '48483'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -398,
              3410,
              3411,
              -34,
              -2575,
              -695
            ]
          ],
          'id': '38091'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -926,
              -973,
              -2378,
              3412
            ]
          ],
          'id': '31185'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2644,
              -911,
              3413,
              3414
            ]
          ],
          'id': '26079'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2650,
              3415,
              3416,
              -2188,
              -2752,
              -2715
            ]
          ],
          'id': '20163'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3417,
              3418,
              3419,
              -3255,
              -1374
            ]
          ],
          'id': '17035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3420,
              3421,
              3422,
              3423,
              -2122,
              3424,
              3425
            ]
          ],
          'id': '54101'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3426,
              3427,
              3428,
              3429,
              3430
            ]
          ],
          'id': '28139'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3431,
              3432,
              3433,
              3434,
              3435,
              3436,
              -3204,
              3437
            ]
          ],
          'id': '13069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3438,
              3439,
              3440,
              3441,
              3442
            ]
          ],
          'id': '20169'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3443,
              3444,
              3445,
              3446
            ]
          ],
          'id': '28119'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2693,
              -2576,
              -1676,
              -342,
              3447,
              -2232
            ]
          ],
          'id': '38045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3448,
              -3443,
              3449,
              3450,
              3451,
              3452
            ]
          ],
          'id': '20053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3453,
              3454,
              3455,
              -70,
              3456,
              3457,
              3458,
              3459
            ]
          ],
          'id': '18055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3460,
              3461,
              -1707,
              3462,
              3463,
              3464,
              -2443
            ]
          ],
          'id': '29001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3465,
              3466,
              3467,
              3468,
              -950,
              3469
            ]
          ],
          'id': '39075'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2268,
              -2285,
              3470,
              3471,
              3472
            ]
          ],
          'id': '05029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1579,
              -1294,
              3473,
              3474,
              3475
            ]
          ],
          'id': '18131'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3476,
              3477,
              3478,
              3479,
              -3289
            ]
          ],
          'id': '72045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3480,
              3481,
              -238,
              -791,
              3482,
              -2969
            ]
          ],
          'id': '31077'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3483,
              -555,
              -2338,
              -2931
            ]
          ],
          'id': '48107'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3484,
              3485,
              3486,
              3487,
              3488,
              3489,
              3490
            ]
          ],
          'id': '21083'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3491,
              3492,
              3493,
              3494,
              3495,
              3496
            ]
          ],
          'id': '21171'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3497,
              -1372,
              3498,
              3499
            ]
          ],
          'id': '17005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3500,
              3501,
              3502,
              3503,
              3504,
              3505,
              3506
            ]
          ],
          'id': '05097'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3507,
              3508,
              3509,
              3510,
              3511,
              -1227
            ]
          ],
          'id': '47159'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3512,
              3513,
              3514,
              3515,
              3516,
              3517
            ]
          ],
          'id': '17045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3518,
              3519,
              3520,
              3521,
              3522,
              3523
            ]
          ],
          'id': '42021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3524,
              3525,
              3526,
              3527,
              3528,
              3529
            ]
          ],
          'id': '41043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -867,
              -350,
              3530,
              -3242,
              3531,
              3532,
              3533,
              3534,
              3535
            ]
          ],
          'id': '27129'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3536,
              3537,
              3538,
              3539,
              -1386,
              -2134
            ]
          ],
          'id': '27153'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3540,
              3541,
              3542,
              3543,
              -3526,
              3544
            ]
          ],
          'id': '41047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3545,
              -241,
              3546,
              3547,
              3548,
              3549,
              3550
            ]
          ],
          'id': '42071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3551,
              3552,
              3553,
              3554,
              -2283
            ]
          ],
          'id': '05023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3555,
              3556,
              -3433,
              3557,
              3558
            ]
          ],
          'id': '13017'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                3559
              ]
            ],
            [
              [
                3560
              ]
            ],
            [
              [
                3561
              ]
            ],
            [
              [
                3562,
                3563
              ]
            ]
          ],
          'id': '15009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3564,
              3565,
              3566,
              3567,
              3568,
              -1587
            ]
          ],
          'id': '29169'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1415,
              3569,
              -932,
              -558
            ]
          ],
          'id': '48311'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1035,
              -968,
              -2684,
              -292,
              3570,
              3571
            ]
          ],
          'id': '19113'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -420,
              -633,
              3572,
              -1223,
              -2625,
              -1677,
              -2843
            ]
          ],
          'id': '48393'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1871,
              3573,
              -2917,
              3574,
              -288,
              -1241
            ]
          ],
          'id': '19107'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2106,
              3575,
              3576,
              3577,
              3578,
              3579
            ]
          ],
          'id': '39073'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3580,
              3581,
              3582,
              3583,
              3584
            ]
          ],
          'id': '13053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3585,
              -2567,
              3586,
              3587,
              -1474
            ]
          ],
          'id': '30065'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3588,
              -647,
              3589,
              3590
            ]
          ],
          'id': '13149'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3591,
              3592
            ]
          ],
          'id': '27031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3593,
              3594,
              -2685,
              -3318,
              -1856
            ]
          ],
          'id': '19161'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3595,
              3596,
              3597,
              -2668,
              3598
            ]
          ],
          'id': '37145'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2416,
              -1776,
              3599
            ]
          ],
          'id': '02185'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3600,
              3601,
              3602
            ]
          ],
          'id': '72095'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3603,
              -2205,
              3604,
              3605,
              -2153
            ]
          ],
          'id': '18069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3606,
              -2999,
              3607,
              3608,
              3609,
              3610,
              -2314
            ]
          ],
          'id': '29093'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -554,
              -2357,
              -1073,
              3611,
              -2339
            ]
          ],
          'id': '48263'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3612,
              3613,
              -2441,
              3614,
              3615,
              3616,
              3617,
              3618
            ]
          ],
          'id': '51155'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3619,
              -1700,
              -1595,
              3620,
              3621,
              -2458
            ]
          ],
          'id': '29025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3622,
              3623,
              3624,
              3625,
              3626,
              3627
            ]
          ],
          'id': '01073'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3628
            ]
          ],
          'id': '15001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3629,
              3630,
              3631,
              3632
            ]
          ],
          'id': '53023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3633,
              3634,
              3635,
              3636,
              3637
            ]
          ],
          'id': '01027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3638,
              3639,
              -1858,
              3640,
              3641,
              3642,
              3643
            ]
          ],
          'id': '19193'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3644,
              -1155,
              3645,
              -2817,
              3646,
              3647,
              3648,
              3649
            ]
          ],
          'id': '19155'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1845,
              3650,
              3651,
              3652,
              -3377,
              3653,
              -21,
              3654,
              3655
            ]
          ],
          'id': '16013'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                3656
              ]
            ],
            [
              [
                3657,
                3658,
                -3347,
                3659,
                3660,
                3661,
                3662
              ]
            ]
          ],
          'id': '23027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3663,
              3664,
              3665,
              3666,
              3667,
              3668
            ]
          ],
          'id': '25025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3669,
              3670,
              3671,
              3672,
              3673,
              3674
            ]
          ],
          'id': '25011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1025,
              -3254,
              3675,
              3676,
              -3032,
              -2186
            ]
          ],
          'id': '26017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3677,
              3678,
              3679,
              -3396,
              -1516
            ]
          ],
          'id': '27081'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3680,
              3681,
              3682,
              3683,
              3684,
              3685
            ]
          ],
          'id': '28011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3686,
              3687,
              3688,
              -1005
            ]
          ],
          'id': '26007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3689,
              3690,
              3691,
              3692,
              3693,
              3694,
              3695
            ]
          ],
          'id': '26053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3696,
              -327,
              3697,
              3698,
              -3658,
              3699,
              3700
            ]
          ],
          'id': '23025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3701,
              3702,
              3703,
              3704,
              3705,
              3706,
              3707,
              3708,
              3709
            ]
          ],
          'id': '28149'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3710,
              3711,
              3712,
              3713,
              3714,
              3715,
              3716
            ]
          ],
          'id': '36075'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3717,
              -3534,
              3718,
              -1343,
              -1507,
              -3395
            ]
          ],
          'id': '27127'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3719,
              3720,
              3721,
              3722,
              3723,
              3724,
              3725
            ]
          ],
          'id': '39095'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3726,
              -296,
              3727,
              3728,
              3729
            ]
          ],
          'id': '19139'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -531,
              3730,
              3731,
              3732,
              3733,
              3734
            ]
          ],
          'id': '40033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3647,
              -2820,
              3735,
              3736,
              3737
            ]
          ],
          'id': '19129'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3738,
              3739,
              3740,
              3741
            ]
          ],
          'id': '36059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3742,
              3743,
              3744,
              3745,
              3746,
              3747
            ]
          ],
          'id': '30109'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3748,
              3749,
              3750,
              3751,
              3752
            ]
          ],
          'id': '29155'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3753,
              3754,
              3755,
              3756,
              3757,
              -2780
            ]
          ],
          'id': '29127'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3758,
              3759,
              -1629,
              3760,
              3761
            ]
          ],
          'id': '35017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3762,
              -171,
              3763,
              3764,
              3765,
              3766,
              3767,
              3768
            ]
          ],
          'id': '51107'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3769,
              3770,
              3771,
              3772,
              3773,
              -1426
            ]
          ],
          'id': '46105'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3774,
              -3118,
              3775,
              3776,
              3777
            ]
          ],
          'id': '48091'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3778,
              -2756,
              3779,
              3780
            ]
          ],
          'id': '48505'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                3781,
                3782,
                3783,
                3784
              ]
            ],
            [
              [
                3785,
                3786,
                3787,
                3788
              ]
            ],
            [
              [
                3789,
                3790,
                3791
              ]
            ]
          ],
          'id': '48007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3792,
              3793,
              3794,
              3795,
              3796,
              3797
            ]
          ],
          'id': '48361'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3798,
              -3155,
              3799,
              3800,
              3801
            ]
          ],
          'id': '48495'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3802,
              3803,
              3804,
              3805,
              3806,
              3807
            ]
          ],
          'id': '51011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3808,
              3809,
              3810,
              -1108,
              3811,
              3812,
              3813,
              -2504
            ]
          ],
          'id': '53025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3814,
              -3297,
              3815,
              3816,
              -3058,
              3817
            ]
          ],
          'id': '54017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3818,
              -563,
              3819,
              3820,
              -2123,
              -3424,
              3821
            ]
          ],
          'id': '54083'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3183,
              3822,
              3823,
              -2960,
              3824
            ]
          ],
          'id': '19143'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1320,
              3825,
              3826,
              3827,
              3828
            ]
          ],
          'id': '21189'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3829,
              3830,
              -1078,
              3831
            ]
          ],
          'id': '37181'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -728,
              3832,
              3833,
              3834,
              3835,
              3836
            ]
          ],
          'id': '04007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3837,
              3838,
              3839,
              3840,
              -2281,
              -2266,
              3841
            ]
          ],
          'id': '05129'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3842,
              3843,
              3844,
              3845,
              3846,
              3847
            ]
          ],
          'id': '05095'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3848,
              3849,
              -2463,
              -2877
            ]
          ],
          'id': '12133'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3850,
              3851,
              -1775,
              3852,
              -2584,
              3853
            ]
          ],
          'id': '13217'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3854,
              3855,
              3856,
              -3040,
              3857,
              3858
            ]
          ],
          'id': '12119'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1584,
              3859,
              -2854,
              3860,
              -76,
              3861
            ]
          ],
          'id': '18031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3862,
              3863,
              3864,
              -1034,
              -2822
            ]
          ],
          'id': '19065'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3865,
              -778,
              -1872,
              -1239,
              -1862,
              -1883
            ]
          ],
          'id': '19099'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3866,
              3867,
              -1321,
              -3829,
              3868,
              3869,
              3870
            ]
          ],
          'id': '21109'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3871,
              3872,
              3873,
              -3703,
              3874,
              3875
            ]
          ],
          'id': '22035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -853,
              3876,
              3877,
              3878,
              3879,
              3880
            ]
          ],
          'id': '22113'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3881,
              3882,
              3883,
              3884,
              -850,
              3885
            ]
          ],
          'id': '22039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3886,
              -1701,
              -3620,
              -2457,
              3887,
              3888
            ]
          ],
          'id': '29063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1304,
              3889,
              3890,
              3891,
              -2996,
              3892,
              3893
            ]
          ],
          'id': '29071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3894,
              3895,
              -3403,
              3896
            ]
          ],
          'id': '31097'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3897,
              -673,
              3898,
              -3481,
              -2968,
              -589
            ]
          ],
          'id': '31183'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3899,
              3900,
              3901,
              3902,
              -1625,
              -3760,
              3903
            ]
          ],
          'id': '35051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3904,
              3905,
              3906,
              3907,
              3908,
              3909
            ]
          ],
          'id': '37107'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3910,
              3911,
              3912,
              3913,
              3914,
              3915
            ]
          ],
          'id': '37045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3916,
              3917,
              3918,
              3919,
              3920
            ]
          ],
          'id': '31105'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3921,
              3922,
              -2240,
              3923,
              3924,
              3925
            ]
          ],
          'id': '40145'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3926,
              3927,
              3928,
              3929
            ]
          ],
          'id': '40027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3930,
              3931,
              3932,
              -2395
            ]
          ],
          'id': '40099'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3933,
              3934,
              3935,
              -1017
            ]
          ],
          'id': '42003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3936,
              3937,
              3938,
              -3087,
              3939,
              3940,
              3941
            ]
          ],
          'id': '45087'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3942,
              -276,
              -2241,
              3943
            ]
          ],
          'id': '46065'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3944,
              3945,
              3946,
              3947,
              3948,
              3949
            ]
          ],
          'id': '21235'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3950,
              3951,
              -1072,
              3952,
              3953,
              3954
            ]
          ],
          'id': '37175'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3955,
              3956,
              3957,
              3958,
              3959,
              3960,
              -3907
            ]
          ],
          'id': '37049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2356,
              3961,
              -252,
              -2352,
              -409,
              -1075
            ]
          ],
          'id': '48253'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3962
            ]
          ],
          'id': '51720'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3963,
              3964,
              3965,
              3966,
              3967,
              3968
            ]
          ],
          'id': '39105'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3969,
              3970,
              -3969,
              3971,
              3972,
              3973
            ]
          ],
          'id': '39053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3974,
              -3425,
              -2127,
              3975,
              3976,
              3977,
              3978,
              3979
            ]
          ],
          'id': '54025'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                3980
              ]
            ],
            [
              [
                3981
              ]
            ],
            [
              [
                3982
              ]
            ],
            [
              [
                3983,
                3984
              ]
            ]
          ],
          'id': '78030'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3985,
              3986,
              3987,
              -612,
              3988
            ]
          ],
          'id': '05111'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3989,
              3990,
              3991,
              -2750,
              3992,
              3993
            ]
          ],
          'id': '06099'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3994,
              3995,
              3996,
              3997,
              3998
            ]
          ],
          'id': '06011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              3999,
              4000,
              4001,
              4002,
              4003
            ]
          ],
          'id': '13089'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4004,
              4005,
              4006,
              4007,
              4008
            ]
          ],
          'id': '13311'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4009,
              4010,
              4011,
              -769,
              4012,
              4013
            ]
          ],
          'id': '13115'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4014,
              -24,
              4015,
              4016,
              4017
            ]
          ],
          'id': '16047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4018,
              -990,
              -1146,
              4019,
              4020,
              4021
            ]
          ],
          'id': '17141'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4022,
              4023,
              4024,
              -3744,
              4025
            ]
          ],
          'id': '30083'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4026,
              4027,
              4028,
              4029,
              4030
            ]
          ],
          'id': '37065'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4031,
              4032,
              -634,
              -937,
              4033
            ]
          ],
          'id': '48421'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4034,
              4035,
              4036,
              4037,
              4038
            ]
          ],
          'id': '01017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1269,
              -1274,
              4039,
              4040,
              -2746,
              4041
            ]
          ],
          'id': '06003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2616,
              4042,
              4043,
              4044,
              -565,
              -3023,
              4045,
              4046
            ]
          ],
          'id': '06093'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4047,
              4048,
              4049,
              -1235
            ]
          ],
          'id': '08083'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4050,
              4051,
              -2143,
              4052,
              4053,
              4054
            ]
          ],
          'id': '13213'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4055,
              4056,
              4057,
              4058,
              4059,
              -3379
            ]
          ],
          'id': '16071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4060,
              4061,
              4062,
              4063,
              4064,
              4065
            ]
          ],
          'id': '18129'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4066,
              4067,
              4068,
              4069,
              4070,
              4071,
              4072,
              4073,
              4074
            ]
          ],
          'id': '21093'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3796,
              4075,
              4076,
              -3880,
              4077,
              4078
            ]
          ],
          'id': '22023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4079,
              4080,
              4081,
              4082,
              -1256
            ]
          ],
          'id': '20121'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2859,
              -1847,
              4083,
              4084,
              -3053
            ]
          ],
          'id': '16015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2675,
              4085,
              4086,
              4087,
              4088,
              4089,
              4090
            ]
          ],
          'id': '16019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4091,
              4092,
              4093,
              4094,
              4095,
              4096,
              4097
            ]
          ],
          'id': '25023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4098,
              4099,
              4100,
              4101,
              4102,
              4103,
              4104,
              4105
            ]
          ],
          'id': '22077'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4106,
              4107,
              -1665,
              -202,
              4108
            ]
          ],
          'id': '26043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2548,
              -1609,
              4109,
              4110,
              -1649,
              4111
            ]
          ],
          'id': '29097'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4112,
              -2654,
              4113,
              4114,
              4115,
              4116
            ]
          ],
          'id': '20189'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4117,
              4118,
              4119,
              4120,
              4121,
              4122
            ]
          ],
          'id': '17085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3222,
              4123,
              -1817,
              4124,
              -1877,
              4125,
              4126
            ]
          ],
          'id': '17057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4127,
              -761,
              4128,
              4129,
              4130,
              -393
            ]
          ],
          'id': '36055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4131,
              -3593,
              4132,
              -2908
            ]
          ],
          'id': '27075'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4133,
              4134,
              4135,
              4136,
              -4137,
              4137,
              4138
            ]
          ],
          'id': '41037'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                4139,
                4140
              ]
            ],
            [
              [
                4141
              ]
            ],
            [
              [
                4142
              ]
            ]
          ],
          'id': '44005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4143,
              4144,
              4145,
              4146,
              4147,
              4148,
              4149
            ]
          ],
          'id': '36043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4150,
              -3373,
              4151,
              4152,
              4153,
              4154,
              4155,
              4156
            ]
          ],
          'id': '35059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4157,
              4158,
              4159,
              4160,
              4161,
              4162
            ]
          ],
          'id': '48071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4163,
              4164,
              4165,
              -3810,
              4166,
              -2487,
              4167,
              4168
            ]
          ],
          'id': '53047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4169,
              4170,
              4171,
              4172,
              -3625,
              4173
            ]
          ],
          'id': '01115'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4174,
              4175,
              4176,
              4177,
              4178
            ]
          ],
          'id': '55059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -956,
              4179,
              4180,
              4181,
              -118,
              4182,
              4183
            ]
          ],
          'id': '72075'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -430,
              -2799,
              4184,
              4185
            ]
          ],
          'id': '55077'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -441,
              4186,
              4187,
              4188,
              4189,
              -1461,
              -1491,
              4190
            ]
          ],
          'id': '55099'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4191,
              -2472,
              4192,
              4193
            ]
          ],
          'id': '72087'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2350,
              4194,
              4195,
              4196,
              -731,
              4197,
              4198
            ]
          ],
          'id': '16079'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4199,
              4200,
              -1976,
              4201,
              4202,
              4203
            ]
          ],
          'id': '37027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4204,
              4205,
              4206,
              4207
            ]
          ],
          'id': '38065'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3405,
              4208,
              4209,
              4210,
              4211,
              4212
            ]
          ],
          'id': '31147'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4213,
              4214,
              -2982,
              4215,
              -1603
            ]
          ],
          'id': '31145'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4216,
              4217,
              4218,
              -3798,
              4219,
              4220
            ]
          ],
          'id': '48199'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4221,
              4222,
              -1093,
              4223,
              4224,
              4225,
              4226,
              4227
            ]
          ],
          'id': '01077'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -504,
              4228,
              4229,
              4230,
              -3354,
              4231,
              4232
            ]
          ],
          'id': '05007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4233,
              4234,
              -1827,
              -2816,
              -1168,
              4235,
              -2938
            ]
          ],
          'id': '17011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2154,
              -3606,
              4236,
              4237,
              4238,
              4239,
              4240,
              4241,
              -2227
            ]
          ],
          'id': '18053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3414,
              -1605,
              -904,
              -2896,
              4242
            ]
          ],
          'id': '26113'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1355,
              -447,
              -1315,
              -1328,
              4243,
              -384
            ]
          ],
          'id': '26117'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1589,
              4244,
              -2294,
              -914
            ]
          ],
          'id': '29229'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1588,
              -3569,
              4245,
              -2317,
              -2324,
              4246,
              -2295,
              -4245
            ]
          ],
          'id': '29215'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4247,
              4248,
              4249,
              4250,
              -3609
            ]
          ],
          'id': '29123'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4251,
              4252,
              4253,
              -2161,
              -2514,
              4254,
              4255
            ]
          ],
          'id': '28085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4256,
              4257,
              4258,
              4259,
              4260
            ]
          ],
          'id': '35011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4261,
              -4029,
              4262,
              4263,
              -3956,
              -3906,
              4264
            ]
          ],
          'id': '37147'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4265,
              -4207,
              4266,
              4267,
              4268,
              4269,
              4270
            ]
          ],
          'id': '38059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4271,
              4272,
              4273,
              4274,
              -95,
              4275,
              -3227
            ]
          ],
          'id': '39077'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2785,
              4276,
              -3925,
              4277,
              4278,
              4279
            ]
          ],
          'id': '40111'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4280,
              4281,
              4282,
              4283,
              4284,
              4285,
              4286,
              4287
            ]
          ],
          'id': '45041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4288,
              4289,
              4290,
              4291,
              4292
            ]
          ],
          'id': '45081'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4293,
              4294,
              -4067,
              4295,
              4296,
              4297
            ]
          ],
          'id': '21027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4064,
              4298,
              4299,
              4300,
              4301,
              4302
            ]
          ],
          'id': '21225'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4303,
              4304,
              4305,
              -432,
              4306,
              4307
            ]
          ],
          'id': '21231'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4308,
              -2777,
              4309,
              4310,
              4311,
              4312
            ]
          ],
          'id': '21211'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3908,
              -3961,
              4313,
              -2452,
              4314
            ]
          ],
          'id': '37103'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4315,
              4316,
              4317,
              4318,
              4319
            ]
          ],
          'id': '47105'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4320,
              4321,
              4322,
              -959,
              4323,
              4324
            ]
          ],
          'id': '48217'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4325,
              4326,
              4327,
              4328,
              4329,
              4330,
              4331
            ]
          ],
          'id': '51087'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4332,
              4333,
              4334,
              -839,
              4335
            ]
          ],
          'id': '39019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2744,
              4336,
              4337,
              4338,
              -396,
              4339
            ]
          ],
          'id': '38099'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4340,
              4341,
              4342,
              -2763,
              4343,
              -2021,
              -1463
            ]
          ],
          'id': '55067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4344,
              4345,
              -1494,
              -2254,
              4346,
              4347
            ]
          ],
          'id': '55017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4348,
              4349,
              4350,
              4351,
              4352
            ]
          ],
          'id': '22101'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4353,
              4354,
              4355,
              4356,
              4357
            ]
          ],
          'id': '72023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4358,
              4359,
              4360,
              4361,
              4362,
              4363
            ]
          ],
          'id': '41009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4364,
              4365,
              -2100,
              4366,
              4367,
              4368,
              -4135
            ]
          ],
          'id': '41025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4369,
              -1722,
              4370,
              4371,
              4372,
              4373
            ]
          ],
          'id': '48491'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4374,
              4375,
              4376,
              4377,
              -360
            ]
          ],
          'id': '49009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4378,
              4379,
              -1915,
              4380,
              4381
            ]
          ],
          'id': '48271'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4382,
              -356,
              4383,
              4384,
              4385
            ]
          ],
          'id': '49029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4386,
              4387,
              -4388,
              4387,
              4388,
              4389,
              4390,
              4391,
              4392,
              4393,
              -4394,
              4393,
              -4394,
              4393,
              4394,
              4395,
              4396,
              4397,
              -4398,
              4397,
              4398,
              4399
            ]
          ],
          'id': '51620'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                4400
              ]
            ],
            [
              [
                4401,
                4402,
                4403,
                4404,
                -1033,
                4405,
                -1878,
                4406,
                4407
              ]
            ]
          ],
          'id': '08005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4408,
              4409,
              4410,
              4411,
              4412,
              -4011,
              4413,
              4414
            ]
          ],
          'id': '13295'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4415,
              4416,
              4417,
              4418,
              4419,
              4420
            ]
          ],
          'id': '18121'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4421,
              -79,
              4422,
              4423,
              4424
            ]
          ],
          'id': '18143'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2847,
              4425,
              4426,
              4427,
              4428,
              4429
            ]
          ],
          'id': '21227'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4430,
              4431,
              -1266,
              4432,
              4433
            ]
          ],
          'id': '22081'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3533,
              4434,
              4435,
              -1964,
              -1344,
              -3719
            ]
          ],
          'id': '27015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4436,
              4437,
              4438,
              4439,
              -1306,
              4440,
              4441
            ]
          ],
          'id': '29139'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4442,
              -3752,
              4443,
              4444,
              4445,
              4446,
              4447,
              4448,
              -3987,
              4449
            ]
          ],
          'id': '05093'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4450,
              4451,
              4452,
              4453,
              -1277,
              4454
            ]
          ],
          'id': '05049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4455,
              4456,
              -4415,
              4457,
              4458,
              4459,
              4460
            ]
          ],
          'id': '01049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4461,
              4462,
              4463,
              -3501,
              4464,
              4465
            ]
          ],
          'id': '05127'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3281,
              -2617,
              -4047,
              4466,
              4467
            ]
          ],
          'id': '06015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4468,
              4469,
              -991,
              -4019,
              4470,
              -4120
            ]
          ],
          'id': '17177'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4471,
              4472,
              4473,
              4474,
              4475,
              4476
            ]
          ],
          'id': '18025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4477,
              4478,
              4479,
              4480
            ]
          ],
          'id': '18043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3075,
              4481,
              4482,
              4483,
              4484,
              4485
            ]
          ],
          'id': '13179'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -23,
              4486,
              -3375,
              4487,
              -4016
            ]
          ],
          'id': '16053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4488,
              4489,
              4490,
              4491,
              4492,
              4493,
              -4493,
              4494,
              4495
            ]
          ],
          'id': '24045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4496,
              4497,
              4498,
              4499
            ]
          ],
          'id': '26013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4500,
              4501,
              4502,
              4503,
              4504,
              -1,
              4505,
              4506
            ]
          ],
          'id': '32017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4507,
              4508,
              4509,
              4510,
              4511
            ]
          ],
          'id': '34011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4512,
              4513,
              4514,
              4515
            ]
          ],
          'id': '18115'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4516,
              4517,
              4518,
              4519,
              4520,
              4521
            ]
          ],
          'id': '36061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4522,
              4523,
              -4145,
              4524,
              4525,
              4526
            ]
          ],
          'id': '36089'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4527,
              4528,
              -4256,
              4529,
              4530,
              4531
            ]
          ],
          'id': '28063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4532,
              -2724,
              4533,
              4534,
              4535,
              4536
            ]
          ],
          'id': '40023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4537,
              4538,
              4539,
              -2177,
              4540,
              4541,
              4542,
              4543,
              -3756
            ]
          ],
          'id': '17149'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4544,
              4545,
              4546,
              4547,
              -2216
            ]
          ],
          'id': '19057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4548,
              4549,
              4550,
              -4024,
              4551,
              4552
            ]
          ],
          'id': '30085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4553,
              4554,
              4555,
              4556,
              -1070,
              4557,
              4558,
              4559
            ]
          ],
          'id': '45007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4560,
              4561,
              -2560,
              4562,
              4563
            ]
          ],
          'id': '46033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4564,
              -4447,
              4565,
              4566,
              4567,
              4568,
              4569
            ]
          ],
          'id': '47157'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4570,
              4571,
              4572,
              4573,
              4574
            ]
          ],
          'id': '34019'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -1288
              ]
            ],
            [
              [
                4575,
                4576,
                -813,
                -3048,
                4577
              ]
            ]
          ],
          'id': '51089'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2289,
              4578,
              4579,
              4580
            ]
          ],
          'id': '51650'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4581,
              4582,
              -300,
              -2565,
              4583,
              4584
            ]
          ],
          'id': '30071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4585,
              4586,
              4587,
              4588,
              4589,
              4590,
              -3435
            ]
          ],
          'id': '13161'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4591,
              -4089,
              4592,
              4593,
              4594,
              4595,
              4596,
              4597
            ]
          ],
          'id': '56023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4598,
              4599,
              4600,
              4601,
              4602
            ]
          ],
          'id': '01063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4603,
              4604,
              4605,
              4606
            ]
          ],
          'id': '05061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4607,
              4608,
              4609,
              -2125
            ]
          ],
          'id': '51091'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4610,
              4611,
              4612,
              4613
            ]
          ],
          'id': '51101'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                4614
              ]
            ],
            [
              [
                4615,
                4616,
                -439,
                4617
              ]
            ]
          ],
          'id': '55007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4618,
              4619,
              4620,
              4621,
              -2842,
              4622,
              4623,
              4624
            ]
          ],
          'id': '55123'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -672,
              4625,
              4626,
              -234,
              -3482,
              -3899
            ]
          ],
          'id': '31011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4211,
              4627,
              4628,
              4629,
              4630,
              4631
            ]
          ],
          'id': '20043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2970,
              -3483,
              -795,
              -2659,
              -596
            ]
          ],
          'id': '31163'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4632,
              4633,
              4634,
              -2666,
              4635
            ]
          ],
          'id': '32021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4636,
              4637,
              4638,
              4639,
              -1402
            ]
          ],
          'id': '47083'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -3787,
                4640
              ]
            ],
            [
              [
                4641,
                4642,
                4643,
                -3783,
                4644,
                4645,
                4646
              ]
            ]
          ],
          'id': '48057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4647,
              -4014,
              4648,
              4649,
              4650,
              4651,
              -4459
            ]
          ],
          'id': '01019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1475,
              -3588,
              4652,
              4653,
              4654,
              4655,
              4656
            ]
          ],
          'id': '30111'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -793,
              4657,
              4658,
              -1969,
              -2660
            ]
          ],
          'id': '31079'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4659,
              4660,
              4661,
              -3094,
              4662
            ]
          ],
          'id': '31017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4663,
              -2951,
              4664,
              4665
            ]
          ],
          'id': '35061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4666,
              4667,
              4668,
              4669,
              -2947,
              4670
            ]
          ],
          'id': '35047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4671,
              -3049,
              -3134,
              4672,
              4673,
              -1308
            ]
          ],
          'id': '37067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4674,
              4675,
              -3910,
              4676,
              4677,
              4678
            ]
          ],
          'id': '37191'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4679,
              4680,
              4681,
              4682,
              4683
            ]
          ],
          'id': '37017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4684,
              4685,
              -1534,
              4686,
              4687,
              4688,
              -2656,
              -1985
            ]
          ],
          'id': '30059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4689,
              4690,
              -3871,
              4691,
              4692,
              4693
            ]
          ],
          'id': '21203'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4694,
              4695,
              -4293,
              4696,
              4697,
              4698
            ]
          ],
          'id': '45047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4699,
              4700,
              -4298,
              4701,
              4702
            ]
          ],
          'id': '21091'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4703,
              4704,
              4705,
              4706,
              4707,
              4708,
              4709
            ]
          ],
          'id': '21045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4710,
              4711,
              4712,
              4713,
              4714
            ]
          ],
          'id': '21113'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4715,
              4716,
              -1067,
              4717
            ]
          ],
          'id': '37149'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4718,
              4719,
              4720,
              4721,
              4722
            ]
          ],
          'id': '37121'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4723,
              4724,
              4725,
              4726,
              4727,
              4728
            ]
          ],
          'id': '37053'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -2439
              ]
            ],
            [
              [
                4729,
                4730,
                4731,
                4732,
                -3615,
                -2440,
                -3614
              ]
            ]
          ],
          'id': '51121'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4331,
              4733
            ]
          ],
          'id': '51760'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3812,
              -1107,
              4734,
              4735,
              4736,
              4737
            ]
          ],
          'id': '53021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2478,
              4738,
              4739,
              -3477,
              -3288
            ]
          ],
          'id': '72105'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4740,
              -2399,
              4741,
              4742,
              4743,
              -3732
            ]
          ],
          'id': '40067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4744,
              4745,
              4746,
              4747,
              4748,
              4749,
              4750
            ]
          ],
          'id': '47091'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4751,
              4752,
              4753,
              4754,
              4755
            ]
          ],
          'id': '47121'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -544,
              4756,
              -127,
              4757,
              -2242
            ]
          ],
          'id': '46015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4758,
              4759,
              4760,
              4761,
              4762,
              -4322,
              4763
            ]
          ],
          'id': '48139'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3733,
              -4744,
              4764,
              -1115,
              4765,
              4766
            ]
          ],
          'id': '48077'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4767,
              4768,
              -3808,
              4769,
              4770,
              4771
            ]
          ],
          'id': '51009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4772,
              -1861,
              -617,
              4773
            ]
          ],
          'id': '08079'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4774,
              4775,
              4776,
              4777,
              4778,
              4779,
              4780,
              4781
            ]
          ],
          'id': '13107'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4126,
              -1876,
              -1254,
              4782,
              4783,
              4784
            ]
          ],
          'id': '17125'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1840,
              -1842,
              -779,
              -3866,
              -1882,
              -1110
            ]
          ],
          'id': '19169'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4785,
              4786,
              -3639,
              4787
            ]
          ],
          'id': '19149'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4788,
              4789,
              4790,
              4791,
              4792
            ]
          ],
          'id': '20173'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4793,
              -3128,
              4794,
              -2773,
              -4309,
              4795
            ]
          ],
          'id': '21103'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4796,
              4797,
              4798
            ]
          ],
          'id': '22089'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4226,
              4799,
              4800,
              4801
            ]
          ],
          'id': '01033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4802,
              4803,
              4804,
              4805,
              -286,
              4806,
              4807
            ]
          ],
          'id': '04019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4808,
              4809,
              -3762,
              4810,
              4811,
              4812
            ]
          ],
          'id': '04011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4813,
              4814,
              -615,
              4815,
              -3843,
              4816
            ]
          ],
          'id': '05147'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1836,
              4817,
              4818,
              4819
            ]
          ],
          'id': '12099'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4820,
              4821,
              4822,
              4823,
              4824
            ]
          ],
          'id': '13127'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4825,
              -3219,
              4826,
              4827,
              -710
            ]
          ],
          'id': '19007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4828,
              4829,
              -4123,
              4830,
              -2681,
              -966
            ]
          ],
          'id': '19061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4831,
              4832,
              4833,
              4834,
              -3494,
              4835
            ]
          ],
          'id': '21057'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                4836,
                4837,
                4838,
                4839,
                4840,
                -4349,
                4841,
                -3878
              ]
            ],
            [
              [
                4842
              ]
            ]
          ],
          'id': '22045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4843,
              4844,
              4845,
              -1186
            ]
          ],
          'id': '17101'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4846,
              4847,
              4848
            ]
          ],
          'id': '24037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4849,
              4850,
              4851,
              4852,
              4853,
              4854
            ]
          ],
          'id': '22033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4855,
              4856,
              4857,
              4858
            ]
          ],
          'id': '22043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1352,
              -381,
              -1356,
              4859
            ]
          ],
          'id': '26127'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4860,
              4861,
              4862,
              4863,
              -3895,
              4864
            ]
          ],
          'id': '31131'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4865,
              -4178,
              4866,
              4867,
              4868,
              -1141,
              4869
            ]
          ],
          'id': '17111'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4870,
              4871,
              4872,
              4873,
              -3416,
              -2649
            ]
          ],
          'id': '20183'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4869,
              4874,
              4875,
              -1572,
              -1142
            ]
          ],
          'id': '17089'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3902,
              4876,
              4877,
              4878,
              4879,
              4880,
              4881,
              4882
            ]
          ],
          'id': '35035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4883,
              4884,
              -4476,
              4885,
              -4294,
              -4701
            ]
          ],
          'id': '18123'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4845,
              4886,
              4887,
              -3459,
              4888,
              4889,
              4890,
              4891
            ]
          ],
          'id': '18083'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4892,
              4893,
              4894,
              4895,
              4896
            ]
          ],
          'id': '42049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4897,
              4898,
              4899,
              4900,
              4901
            ]
          ],
          'id': '45019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3914,
              4902,
              4903,
              4904,
              4905,
              4906,
              4907,
              4908,
              -4908,
              4907,
              4909,
              -3084,
              -3939,
              4910
            ]
          ],
          'id': '45091'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4911,
              4912,
              4913,
              4914,
              4915
            ]
          ],
          'id': '45053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4916,
              4917,
              4918,
              4919,
              4920,
              4921,
              4922,
              4923
            ]
          ],
          'id': '36071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4924,
              4925,
              4926,
              -3671,
              4927
            ]
          ],
          'id': '50025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4811,
              -3761,
              -1628,
              4928,
              4929
            ]
          ],
          'id': '35023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4930,
              4931,
              4932,
              -4666,
              4933,
              4934,
              4935
            ]
          ],
          'id': '35006'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2449,
              4936,
              4937,
              4938,
              4939,
              4940,
              4941
            ]
          ],
          'id': '54055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4942,
              4943,
              4944,
              -2427,
              -3293,
              4945
            ]
          ],
          'id': '54051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4946,
              4947,
              4948,
              4949,
              4950,
              -2769,
              4951
            ]
          ],
          'id': '01101'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4952,
              -4460,
              -4652,
              4953,
              -4170,
              4954
            ]
          ],
          'id': '01055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4955,
              -4801,
              4956,
              -2991,
              4957,
              4958
            ]
          ],
          'id': '01059'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -521,
                -2422,
                4959,
                4960,
                -2075,
                4961,
                4962,
                4963,
                4964
              ]
            ],
            [
              [
                4965
              ]
            ],
            [
              [
                4966
              ]
            ],
            [
              [
                4967
              ]
            ]
          ],
          'id': '02050'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4968,
              -43,
              4969,
              4970,
              4971,
              4972,
              -4561
            ]
          ],
          'id': '46103'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4973,
              4974,
              -610,
              4975,
              -1449,
              4976
            ]
          ],
          'id': '46115'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4977,
              4978,
              -4788,
              -3644,
              4979,
              4980,
              4981
            ]
          ],
          'id': '46127'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4982,
              4983,
              4984,
              -4913
            ]
          ],
          'id': '45013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4985,
              4986,
              4987,
              4988,
              4989,
              4990
            ]
          ],
          'id': '47029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              4991,
              4992,
              4993,
              -4575,
              4994,
              4995,
              4996,
              4997
            ]
          ],
          'id': '42017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1422,
              4998,
              4999,
              5000
            ]
          ],
          'id': '46009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4639,
              5001,
              5002,
              5003,
              5004,
              5005
            ]
          ],
          'id': '47043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5006,
              5007,
              5008,
              5009,
              5010
            ]
          ],
          'id': '40105'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5011,
              -2387,
              -2374,
              5012,
              -4761,
              5013
            ]
          ],
          'id': '48257'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5014,
              5015,
              -1099,
              -3243,
              -1801,
              -281
            ]
          ],
          'id': '48155'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5016,
              5017,
              -4355
            ]
          ],
          'id': '72067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5018,
              5019,
              5020,
              5021,
              5022
            ]
          ],
          'id': '23023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5023,
              5024,
              -2382,
              5025,
              5026,
              5027
            ]
          ],
          'id': '48085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2920,
              -3038,
              -703,
              5028,
              -1711
            ]
          ],
          'id': '48093'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -723,
              5029,
              5030,
              -2319,
              -256
            ]
          ],
          'id': '48095'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5031,
              -2730,
              5032,
              5033,
              5034
            ]
          ],
          'id': '48103'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5035,
              5036,
              5037,
              5038,
              5039,
              -4879
            ]
          ],
          'id': '35015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5040,
              5041,
              5042,
              -2318,
              -4246,
              -3568
            ]
          ],
          'id': '29161'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5043,
              5044,
              5045,
              -2270,
              5046,
              -4463
            ]
          ],
          'id': '05083'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2459,
              -3622,
              5047,
              5048,
              5049,
              5050
            ]
          ],
          'id': '29177'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5051,
              -2664,
              5052,
              5053,
              -2003,
              5054,
              5055,
              -1159
            ]
          ],
          'id': '06027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5056,
              5057,
              -3177,
              5058,
              5059
            ]
          ],
          'id': '42005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5060,
              -2975,
              5061,
              5062,
              -3912,
              5063
            ]
          ],
          'id': '37109'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4990,
              5064,
              5065,
              -3951,
              5066,
              5067,
              5068
            ]
          ],
          'id': '37087'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5069,
              5070,
              -2713,
              5071,
              5072,
              5073,
              5074
            ]
          ],
          'id': '47057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5075,
              5076,
              5077,
              5078,
              5079
            ]
          ],
          'id': '42023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -109,
              5080,
              -4982,
              5081,
              5082,
              5083
            ]
          ],
          'id': '46027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5084,
              5085,
              5086,
              5087,
              5088
            ]
          ],
          'id': '42025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5089,
              5090,
              5091,
              5092,
              5093,
              5094
            ]
          ],
          'id': '45025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5095,
              5096,
              -4898,
              5097
            ]
          ],
          'id': '45035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5098,
              5099,
              5100,
              5101,
              5102,
              5103,
              -1593
            ]
          ],
          'id': '29041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5104,
              5105,
              -2582,
              5106,
              5107
            ]
          ],
          'id': '50011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5108,
              5109,
              -5080,
              5110,
              -3174,
              5111
            ]
          ],
          'id': '42047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5112,
              5113,
              5114
            ]
          ],
          'id': '51115'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5115,
              5116,
              5117,
              5118,
              -3566,
              5119,
              5120
            ]
          ],
          'id': '29131'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -304,
              5121,
              5122,
              5123,
              5124,
              5125
            ]
          ],
          'id': '30017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5125,
              5126,
              5127,
              5128,
              5129,
              5130,
              5131
            ]
          ],
          'id': '30075'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5132,
              -1341,
              5133,
              5134,
              5135
            ]
          ],
          'id': '21107'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5136,
              -2272,
              5137,
              5138,
              5139
            ]
          ],
          'id': '26003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5140,
              5141,
              5142,
              5143,
              5144
            ]
          ],
          'id': '21115'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1177,
              5145,
              -3518,
              5146,
              5147
            ]
          ],
          'id': '17041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5148,
              5149,
              5150,
              5151,
              5152,
              5153
            ]
          ],
          'id': '21119'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5154,
              -662,
              5155,
              -4790,
              5156
            ]
          ],
          'id': '20079'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5157,
              -3245,
              5158
            ]
          ],
          'id': '29510'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3522,
              5159,
              5160,
              5161,
              -330,
              5162
            ]
          ],
          'id': '42009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4212,
              -4632,
              5163,
              -2208,
              5164
            ]
          ],
          'id': '20013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5165,
              5166,
              5167,
              5168,
              5169,
              5170,
              5171,
              5172
            ]
          ],
          'id': '05099'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3506,
              5173,
              -5167,
              5174,
              -4604
            ]
          ],
          'id': '05109'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5175,
              5176,
              5177,
              5178,
              5179
            ]
          ],
          'id': '51730'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4543,
              5180,
              5181,
              -4439,
              5182,
              5183
            ]
          ],
          'id': '29163'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3030,
              5184,
              5185,
              5186,
              5187
            ]
          ],
          'id': '17083'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5188,
              -4286,
              5189,
              5190,
              5191,
              5192
            ]
          ],
          'id': '45027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2712,
              -1634,
              5193,
              -1489,
              5194,
              5195,
              -5072
            ]
          ],
          'id': '47073'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5196,
              5197,
              5198,
              -1192,
              -1468
            ]
          ],
          'id': '47077'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5093,
              5199,
              -4281,
              5200,
              5201
            ]
          ],
          'id': '45031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3548,
              5202,
              5203,
              5204,
              5205,
              5206
            ]
          ],
          'id': '42029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5207,
              5208,
              5209,
              5210,
              -4283
            ]
          ],
          'id': '45033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5211,
              -3172,
              -5058,
              5212,
              -1683
            ]
          ],
          'id': '42031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5213,
              -4109,
              -201,
              5214
            ]
          ],
          'id': '55037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5215,
              -5112,
              -3173,
              -5212,
              -1682
            ]
          ],
          'id': '42053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5216,
              5217,
              5218,
              5219,
              5220
            ]
          ],
          'id': '13049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -619,
              -166,
              5221,
              5222,
              5223,
              5224,
              5225,
              5226
            ]
          ],
          'id': '35039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5227,
              -4434,
              5228,
              5229,
              5230,
              -1102
            ]
          ],
          'id': '22031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3598,
              5231,
              5232,
              5233,
              -2669
            ]
          ],
          'id': '37063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5234,
              5235,
              -4931,
              5236
            ]
          ],
          'id': '35031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5237,
              5238,
              5239,
              5240,
              5241
            ]
          ],
          'id': '24013'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                5242,
                5243
              ]
            ],
            [
              [
                5244
              ]
            ],
            [
              [
                -5206,
                5245,
                5246,
                5247,
                5248,
                5249,
                5250,
                5251
              ]
            ]
          ],
          'id': '10003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5252,
              5253,
              -3327,
              5254,
              -2958
            ]
          ],
          'id': '20023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5255,
              5256,
              5257,
              5258,
              5259,
              -4590
            ]
          ],
          'id': '13001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5260,
              5261,
              5262,
              -4947,
              5263,
              -3386
            ]
          ],
          'id': '01051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5264,
              5265,
              -4048,
              -1234
            ]
          ],
          'id': '08033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5266,
              -2264,
              5267,
              5268
            ]
          ],
          'id': '27069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5269,
              -1747,
              5270,
              5271,
              -3793,
              -4219,
              5272
            ]
          ],
          'id': '48241'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5273,
              5274,
              5275,
              -4900,
              5276,
              5277
            ]
          ],
          'id': '45043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5278,
              -3736,
              5279,
              5280,
              -4862
            ]
          ],
          'id': '19071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5281,
              -4784,
              5282,
              5283,
              5284,
              5285
            ]
          ],
          'id': '17017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5286,
              5287,
              5288,
              -4925,
              5289,
              5290,
              5291
            ]
          ],
          'id': '50027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5292,
              -2168,
              5293,
              5294,
              -4205,
              5295,
              5296,
              5297
            ]
          ],
          'id': '38055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5298,
              -4265,
              -3905,
              -4676
            ]
          ],
          'id': '37079'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5299,
              5300,
              5301,
              5302,
              5303
            ]
          ],
          'id': '17127'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                5304,
                5305
              ]
            ],
            [
              [
                5306,
                -1001,
                5307,
                -4489,
                5308
              ]
            ]
          ],
          'id': '24019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5309,
              -4198,
              -730,
              5310
            ]
          ],
          'id': '16055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5311,
              5312,
              5313,
              5314
            ]
          ],
          'id': '09007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5315,
              -2802,
              -2680,
              -897,
              5316,
              -3131,
              5317
            ]
          ],
          'id': '18039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5318,
              -1210,
              -3147,
              -2902,
              5319,
              5320
            ]
          ],
          'id': '20071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5321,
              -5285,
              5322,
              -3026,
              5323,
              -2175,
              -4540
            ]
          ],
          'id': '17137'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5324,
              5325,
              5326,
              -3946
            ]
          ],
          'id': '21121'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5327,
              -713,
              5328,
              5329,
              -1148
            ]
          ],
          'id': '19053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5330,
              5331,
              5332,
              5333,
              5334,
              -5141,
              5335
            ]
          ],
          'id': '21127'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5336,
              5337,
              -564,
              -3819,
              5338,
              5339
            ]
          ],
          'id': '54001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5340,
              5341,
              -3675,
              5342,
              5343,
              5344,
              5345,
              5346
            ]
          ],
          'id': '25003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5347,
              -4437,
              5348,
              5349,
              5350
            ]
          ],
          'id': '29027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5351,
              5352,
              5353,
              5354,
              5355,
              5356
            ]
          ],
          'id': '27073'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2865,
              5357,
              -4326,
              5358,
              -3399,
              5359
            ]
          ],
          'id': '51075'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5360,
              5361,
              5362,
              -4594
            ]
          ],
          'id': '56035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4059,
              5363,
              5364,
              5365,
              5366
            ]
          ],
          'id': '49005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1245,
              5367,
              -2307,
              -2346,
              5368
            ]
          ],
          'id': '30053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5369,
              5370,
              5371,
              5372,
              5373,
              5374,
              5375
            ]
          ],
          'id': '12001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4713,
              5376,
              5377,
              5378,
              -3867,
              -4691,
              5379
            ]
          ],
          'id': '21151'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5380,
              5381,
              5382,
              -2794,
              5383,
              5384,
              -1929
            ]
          ],
          'id': '48177'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5385,
              5386,
              -674,
              -3898,
              -588,
              5387,
              5388
            ]
          ],
          'id': '31089'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5389,
              5390,
              5391,
              -4679,
              5392,
              5393
            ]
          ],
          'id': '37101'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5394,
              -2940,
              -1813,
              5395,
              5396,
              -4546,
              5397
            ]
          ],
          'id': '17131'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -478,
              5398,
              5399,
              5400,
              -3864,
              5401
            ]
          ],
          'id': '19191'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1558,
              -1470,
              5402,
              5403,
              5404,
              5405
            ]
          ],
          'id': '47075'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5406,
              5407,
              -335,
              5408,
              5409,
              5410
            ]
          ],
          'id': '24023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5411,
              -5411,
              5412,
              -561,
              -5338,
              5413,
              5414
            ]
          ],
          'id': '54077'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5415,
              5416,
              5417,
              -4500,
              5418,
              5419
            ]
          ],
          'id': '26061'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                5420,
                -5405,
                5421,
                -4566,
                -4446
              ]
            ],
            [
              [
                -4448,
                -4565,
                5422
              ]
            ]
          ],
          'id': '47167'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1134,
              5423,
              5424,
              -2706,
              5425
            ]
          ],
          'id': '26065'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4792,
              5426,
              5427,
              5428,
              5429,
              5430
            ]
          ],
          'id': '20191'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5431,
              5432,
              5433,
              5434,
              5435,
              5436,
              5437
            ]
          ],
          'id': '21135'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4220,
              -3797,
              -4079,
              5438,
              -4159,
              5439
            ]
          ],
          'id': '48245'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5440,
              5441,
              -3650,
              5442,
              5443
            ]
          ],
          'id': '31177'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5444,
              5445,
              5446,
              -497,
              5447,
              5448,
              5449,
              5450
            ]
          ],
          'id': '53039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5451,
              -3757,
              -4544,
              -5184,
              5452
            ]
          ],
          'id': '29173'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1483,
              5453,
              5454,
              5455,
              -472,
              5456
            ]
          ],
          'id': '56001'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -1471
              ]
            ],
            [
              [
                5457,
                5458,
                -2413,
                5459,
                -2861,
                5460,
                5461,
                5462
              ]
            ]
          ],
          'id': '51003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5049,
              5463,
              5464,
              -1991,
              5465,
              5466
            ]
          ],
          'id': '29107'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5467,
              5468,
              -5041,
              -3567,
              -5119
            ]
          ],
          'id': '29125'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5469,
              -5349,
              -4442,
              5470,
              -5468,
              -5118
            ]
          ],
          'id': '29151'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3162,
              -1948,
              -3171,
              -1360,
              5471,
              5472
            ]
          ],
          'id': '27161'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5473,
              5474,
              5475,
              5476,
              -4551,
              5477
            ]
          ],
          'id': '38105'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3805,
              5478,
              -3402,
              5479,
              5480,
              5481,
              5482
            ]
          ],
          'id': '51147'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5483,
              -5251,
              5484,
              5485,
              5486
            ]
          ],
          'id': '24029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5487,
              -3223,
              -4127,
              -4785,
              -5282,
              5488,
              5489
            ]
          ],
          'id': '17169'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5490,
              5491,
              5492,
              5493,
              5494,
              -3765
            ]
          ],
          'id': '24031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1194,
              5495,
              5496,
              5497
            ]
          ],
          'id': '47109'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5498,
              5499,
              5500,
              -1260,
              5501
            ]
          ],
          'id': '22119'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5502,
              5503,
              5504
            ]
          ],
          'id': '37129'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5419,
              -4499,
              5505,
              -4107,
              -5214,
              5506,
              5507,
              -3692,
              5508
            ]
          ],
          'id': '26071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5302,
              5509,
              5510,
              5511,
              5512,
              5513,
              5514,
              5515
            ]
          ],
          'id': '21139'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5516,
              -1271,
              5517,
              -3991,
              5518,
              5519
            ]
          ],
          'id': '06077'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5520,
              -5303,
              -5516,
              5521,
              -3486,
              5522,
              5523
            ]
          ],
          'id': '21145'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5524,
              5525,
              -4983,
              -4912,
              5526,
              5527
            ]
          ],
          'id': '45049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1658,
              -1064,
              5528,
              5529,
              5530
            ]
          ],
          'id': '31037'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                5531
              ]
            ],
            [
              [
                5532
              ]
            ]
          ],
          'id': '78010'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5533,
              -2657,
              -4689,
              5534,
              -1505,
              5535,
              5536,
              5537
            ]
          ],
          'id': '30031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1404,
              5538,
              5539,
              -1460,
              5540,
              5541
            ]
          ],
          'id': '47135'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5542,
              -4084,
              -1846,
              -3656,
              5543,
              -4018,
              5544,
              5545
            ]
          ],
          'id': '16039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2612,
              5546,
              5547,
              5548,
              5549
            ]
          ],
          'id': '31013'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                5550
              ]
            ],
            [
              [
                5551,
                -4098,
                5552,
                -4140,
                5553,
                5554,
                5555
              ]
            ]
          ],
          'id': '25005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1187,
              -4846,
              -4892,
              5556,
              5557,
              5558
            ]
          ],
          'id': '17185'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5559,
              5560,
              5561,
              5562,
              5563,
              5564
            ]
          ],
          'id': '21095'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5565,
              5566,
              5567,
              -1089,
              5568,
              -1457
            ]
          ],
          'id': '47119'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5569,
              5570,
              -4076,
              -3795,
              5571
            ]
          ],
          'id': '22019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5572,
              -2670,
              -5234,
              5573,
              5574,
              5575,
              5576,
              -1203
            ]
          ],
          'id': '37037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -976,
              5577,
              -560,
              5578,
              5579
            ]
          ],
          'id': '48127'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5144,
              5580,
              -5149,
              5581,
              5582,
              5583
            ]
          ],
          'id': '21153'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4385,
              5584,
              5585,
              5586
            ]
          ],
          'id': '49011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5587,
              5588,
              5589,
              5590
            ]
          ],
          'id': '49031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5335,
              5591,
              5592,
              5593,
              5594,
              -5142
            ]
          ],
          'id': '21159'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5595,
              5596,
              -4625,
              5597,
              -5400,
              5598
            ]
          ],
          'id': '27055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5599,
              5600,
              5601,
              -4361
            ]
          ],
          'id': '53011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5602,
              5603,
              5604,
              5605
            ]
          ],
          'id': '55089'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5606,
              -1987,
              -2658,
              -5534,
              5607,
              5608,
              5609
            ]
          ],
          'id': '30043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5610,
              -4991,
              -5069,
              5611,
              5612,
              5613
            ]
          ],
          'id': '47155'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2184,
              5614,
              -3003,
              5615,
              5616
            ]
          ],
          'id': '72057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5617,
              5618,
              5619,
              5620
            ]
          ],
          'id': '32011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5621,
              5622,
              5623,
              -1262,
              5624
            ]
          ],
          'id': '22061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5625,
              5626,
              5627,
              -5622,
              5628
            ]
          ],
          'id': '22111'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5629,
              5630,
              5631,
              5632
            ]
          ],
          'id': '33001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1954,
              -2432,
              5633,
              5634,
              5635
            ]
          ],
          'id': '05011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5636,
              5637,
              5638,
              -1601,
              5639,
              -155
            ]
          ],
          'id': '31085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5640,
              5641,
              5642,
              5643,
              5644,
              5645,
              5646,
              5647,
              5648
            ]
          ],
          'id': '42097'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                5649,
                -1002,
                -5307,
                5650
              ]
            ],
            [
              [
                5651
              ]
            ]
          ],
          'id': '24041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5652,
              5653,
              5654,
              -2961
            ]
          ],
          'id': '19041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5655,
              5656,
              5657,
              -2137,
              -4052,
              5658
            ]
          ],
          'id': '47139'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5659,
              5660,
              -2212,
              5661,
              5662,
              5663
            ]
          ],
          'id': '20149'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5664,
              5665,
              5666
            ]
          ],
          'id': '24510'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5667,
              5668,
              -5023,
              5669,
              5670
            ]
          ],
          'id': '23001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5671,
              5672,
              5673,
              -3460,
              -4888,
              5674
            ]
          ],
          'id': '18153'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5675,
              5676,
              -3430,
              5677,
              5678,
              5679,
              5680
            ]
          ],
          'id': '28145'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1346,
              -1967,
              -2767,
              -2737,
              5681,
              -3823,
              -3182
            ]
          ],
          'id': '27063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5682,
              5683,
              5684,
              5685,
              5686,
              5687,
              5688
            ]
          ],
          'id': '49049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5689,
              -3979,
              5690,
              5691,
              -4939,
              5692
            ]
          ],
          'id': '54089'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5687,
              5693,
              5694,
              5695,
              5696,
              5697
            ]
          ],
          'id': '49039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2797,
              5698,
              5699,
              -1510,
              5700,
              5701,
              5702
            ]
          ],
          'id': '55027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5703,
              5704,
              -5357,
              5705,
              -929,
              5706
            ]
          ],
          'id': '46051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5162,
              5707,
              5708,
              -168,
              -331
            ]
          ],
          'id': '42057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5709,
              5710,
              5711,
              5712,
              5713,
              5714
            ]
          ],
          'id': '55093'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5715,
              5716,
              -1531,
              -4686,
              5717
            ]
          ],
          'id': '30045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5718,
              5719,
              -5095,
              5720,
              5721,
              -3085,
              -4910,
              -4908,
              4907,
              4908,
              -4908,
              -4907,
              4905,
              -4905
            ]
          ],
          'id': '45057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5722,
              5723,
              -1522,
              5724,
              5725,
              -4611,
              5726
            ]
          ],
          'id': '51033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5727,
              5728,
              5729,
              -5454,
              -1482
            ]
          ],
          'id': '56031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5730,
              5731,
              5732,
              5733,
              5734,
              -5715,
              5735
            ]
          ],
          'id': '27163'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5736,
              5737,
              5738,
              5739,
              5740,
              5741,
              5742
            ]
          ],
          'id': '29133'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5087,
              5743,
              5744,
              -4993,
              5745
            ]
          ],
          'id': '42095'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5230,
              5746,
              5747,
              5748,
              5749,
              5750
            ]
          ],
          'id': '22085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5751,
              5752,
              5753,
              -4836,
              -3493,
              5754
            ]
          ],
          'id': '21169'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3835,
              5755,
              -4804,
              5756
            ]
          ],
          'id': '04021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1237,
              5757,
              5758,
              -3833,
              -727
            ]
          ],
          'id': '04017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5759,
              -3091,
              5760,
              -4808,
              5761
            ]
          ],
          'id': '04027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5762,
              5763,
              5764,
              -5733,
              5765,
              -665
            ]
          ],
          'id': '27025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3751,
              5766,
              5767,
              -1399,
              -1557,
              5768,
              -4444
            ]
          ],
          'id': '47045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5769,
              5770,
              5771,
              5772,
              5773
            ]
          ],
          'id': '21181'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5774,
              -5472,
              -1365,
              5775,
              5776,
              -2765
            ]
          ],
          'id': '27043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5777,
              -5153,
              5778,
              -5561,
              5779,
              5780,
              -3827
            ]
          ],
          'id': '21193'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5781,
              -3352,
              -3351,
              3350,
              5782,
              5783,
              5784,
              5785
            ]
          ],
          'id': '48037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5128,
              5786,
              -1428,
              -45,
              5787,
              5788
            ]
          ],
          'id': '56011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5789,
              -5201,
              -4288,
              5790
            ]
          ],
          'id': '45061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5791,
              5792,
              5793,
              5794,
              5795,
              -5729
            ]
          ],
          'id': '56015'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                5796,
                -4094
              ]
            ],
            [
              [
                -3665,
                5797
              ]
            ],
            [
              [
                5798,
                -3669,
                5799,
                -4092,
                -5552,
                5800,
                5801
              ]
            ]
          ],
          'id': '25021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5802,
              5803,
              5804,
              5805,
              5806,
              -4073
            ]
          ],
          'id': '21123'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5807,
              -1528,
              5808,
              -5537,
              5809,
              5810,
              5811,
              -2673
            ]
          ],
          'id': '16043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4013,
              -774,
              5812,
              -61,
              5813,
              -4649
            ]
          ],
          'id': '13233'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -354,
              -3203,
              5814,
              -4663,
              -3093,
              -460,
              5815,
              5816,
              5817
            ]
          ],
          'id': '31031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4001,
              5818,
              5819,
              -3851,
              5820
            ]
          ],
          'id': '13247'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5821,
              -3092,
              -5760,
              5822,
              5823
            ]
          ],
          'id': '06025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1726,
              -1246,
              -5369,
              -2351,
              -4199,
              -5310,
              5824
            ]
          ],
          'id': '16017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5825,
              5826,
              5827,
              -4416,
              5828
            ]
          ],
          'id': '18045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5829,
              5830,
              5831,
              5832,
              5833,
              5834,
              5835
            ]
          ],
          'id': '47031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5836,
              5837,
              5838,
              -680,
              5839,
              -5833,
              5840
            ]
          ],
          'id': '47177'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5841,
              -5594,
              5842,
              5843,
              5844,
              5845,
              5846,
              -5151
            ]
          ],
          'id': '21195'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5847,
              5848,
              5849,
              -1317,
              5850,
              5851
            ]
          ],
          'id': '21197'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1358,
              5852,
              5853,
              5854
            ]
          ],
          'id': '26139'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5855,
              5856,
              5857,
              -1225,
              5858,
              5859,
              5860
            ]
          ],
          'id': '47165'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5861,
              5862,
              5863,
              5864,
              5865
            ]
          ],
          'id': '37153'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3236,
              5866,
              5867,
              5868,
              5869
            ]
          ],
          'id': '48043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5870,
              5871,
              -1478,
              -826,
              5872,
              5873
            ]
          ],
          'id': '56019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5874,
              5875,
              5876,
              -5734,
              -5765
            ]
          ],
          'id': '55095'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5877,
              5877,
              -5710,
              -5735
            ]
          ],
          'id': '55109'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5878,
              -4034,
              5879,
              -4153
            ]
          ],
          'id': '48111'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5880,
              -5649,
              5881,
              5882,
              5883,
              5884
            ]
          ],
          'id': '42067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5885,
              5886,
              5887,
              5888,
              5889,
              5890,
              5891
            ]
          ],
          'id': '18089'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5892,
              5893,
              5894,
              5895,
              5896
            ]
          ],
          'id': '42131'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5897,
              5898,
              -5050,
              -5467,
              5899,
              5900,
              5901
            ]
          ],
          'id': '29095'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5902,
              5903,
              -1015,
              5904,
              5905
            ]
          ],
          'id': '42073'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5906,
              -1685,
              5907,
              -5903,
              5908,
              5909
            ]
          ],
          'id': '42085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5910,
              -5897,
              5911,
              5912,
              -5085,
              5913,
              5914
            ]
          ],
          'id': '42079'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3655,
              -20,
              -4015,
              -5544
            ]
          ],
          'id': '16025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3571,
              -297,
              -3727,
              5915,
              -2914,
              5916
            ]
          ],
          'id': '19103'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -525,
              -1864,
              5917,
              -709,
              5918
            ]
          ],
          'id': '19117'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5919,
              -739,
              -3066,
              5920,
              5921,
              5922
            ]
          ],
          'id': '40151'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5923,
              -5922,
              5924,
              5925,
              5926
            ]
          ],
          'id': '40153'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2949,
              5927,
              -4261,
              5928,
              -4877,
              -3901,
              5929
            ]
          ],
          'id': '35027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5296,
              -4208,
              -4266,
              5930,
              5931
            ]
          ],
          'id': '38057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4934,
              -4665,
              -2950,
              -5930,
              -3900,
              5932
            ]
          ],
          'id': '35053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5933,
              5934,
              -2569,
              5935,
              -5827,
              5936,
              -3009
            ]
          ],
          'id': '18157'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5937,
              5938,
              5939,
              5940,
              5941,
              5942
            ]
          ],
          'id': '21221'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5864,
              5943,
              5944,
              5945
            ]
          ],
          'id': '37165'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2807,
              -864,
              -577,
              5946,
              5947,
              5948
            ]
          ],
          'id': '17055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -863,
              5949,
              -4065,
              -4303,
              5950,
              -579
            ]
          ],
          'id': '17059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4541,
              -2176,
              -5324,
              -3031,
              -5188,
              5951
            ]
          ],
          'id': '17061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4042,
              -2751,
              -3992,
              -5518,
              -1270
            ]
          ],
          'id': '06009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5952,
              -4698,
              5953,
              5954,
              5955,
              5956
            ]
          ],
          'id': '45065'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -4555,
                5957
              ]
            ],
            [
              [
                -3953,
                -1071,
                -4557,
                5958
              ]
            ]
          ],
          'id': '45077'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5461,
              -2866,
              -5360,
              -3398,
              5959
            ]
          ],
          'id': '51065'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5960,
              -5791,
              -4287,
              -5189,
              5961,
              5962
            ]
          ],
          'id': '45085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5963,
              5964,
              -1553,
              5965
            ]
          ],
          'id': '51133'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5966,
              -5436,
              5967,
              5968,
              -5772,
              5969
            ]
          ],
          'id': '21069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -435,
              5970,
              5971,
              5972,
              5973,
              5974
            ]
          ],
          'id': '47001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5975,
              5976,
              5977,
              -1983,
              -2302
            ]
          ],
          'id': '30099'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -165,
              5978,
              5979,
              5980,
              -5222
            ]
          ],
          'id': '35055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3132,
              -5317,
              -896,
              5981,
              -2151,
              -1290
            ]
          ],
          'id': '18085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5982,
              -4269,
              5983,
              5984,
              5985
            ]
          ],
          'id': '38085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3495,
              -4835,
              5986,
              5987,
              5988,
              5989,
              5990
            ]
          ],
          'id': '47027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5784,
              5991,
              5992,
              5993,
              5994
            ]
          ],
          'id': '48067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              5995,
              -5671,
              5996,
              -992,
              5997,
              -1639,
              5998
            ]
          ],
          'id': '23017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5773,
              -5969,
              5999,
              6000,
              6001
            ]
          ],
          'id': '21011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4673,
              -3136,
              -1206,
              6002,
              6003,
              6004
            ]
          ],
          'id': '37057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5670,
              -5022,
              6005,
              -993,
              -5997
            ]
          ],
          'id': '23005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6006,
              -3163,
              -5473,
              -5775,
              -2764,
              -1965,
              -4436
            ]
          ],
          'id': '27013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6007,
              6008,
              6009,
              6010,
              6011,
              -4399,
              -4398,
              4397,
              -4398,
              -4397,
              4395,
              -4395,
              -4394,
              4393,
              -4394,
              4393,
              -4394,
              -4393,
              4391,
              -4391,
              -4390,
              -4389,
              -4388,
              4387,
              -4388,
              -4387
            ]
          ],
          'id': '51093'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5363,
              6012,
              6013,
              6014,
              -4375,
              -359,
              6015,
              -4595
            ]
          ],
          'id': '56037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2349,
              6016,
              6017,
              -4195
            ]
          ],
          'id': '30061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6018,
              6019,
              6020
            ]
          ],
          'id': '51685'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6021,
              -4185,
              -2798,
              -5703,
              6022,
              6023
            ]
          ],
          'id': '55021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6024,
              -1760,
              -148,
              6025
            ]
          ],
          'id': '72145'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6026,
              6027,
              -2734,
              6028,
              6029,
              6030
            ]
          ],
          'id': '46041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6031,
              -1409,
              -5525,
              6032,
              6033
            ]
          ],
          'id': '45005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6034,
              -5195,
              -1488,
              6035,
              6036,
              -4988
            ]
          ],
          'id': '47059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3869,
              -3828,
              -5781,
              6037,
              6038,
              -5326,
              6039
            ]
          ],
          'id': '21051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6040,
              -4301,
              6041,
              6042,
              6043,
              -5513
            ]
          ],
          'id': '21055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6044,
              6045,
              -5866,
              -5091
            ]
          ],
          'id': '37007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6046,
              -437,
              6047,
              6048,
              6049,
              6050
            ]
          ],
          'id': '47049'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -5741,
                6051,
                6052,
                6053,
                6054
              ]
            ],
            [
              [
                6055,
                6056
              ]
            ]
          ],
          'id': '21075'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6057,
              6058,
              -5333,
              6059,
              6060
            ]
          ],
          'id': '21019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4558,
              6061,
              -4699,
              -5953,
              6062
            ]
          ],
          'id': '45001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6063,
              6064,
              6065,
              6066,
              6067,
              -2789,
              -5383,
              6068
            ]
          ],
          'id': '48149'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5447,
              6069,
              6070,
              -2095,
              6071,
              -498
            ]
          ],
          'id': '41049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6072,
              6073,
              6074,
              -5160,
              -3521
            ]
          ],
          'id': '42013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6075
            ]
          ],
          'id': '25019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5190,
              -4285,
              6076,
              -5278,
              6077
            ]
          ],
          'id': '45089'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3532,
              -3241,
              -3164,
              -6007,
              -4435
            ]
          ],
          'id': '27103'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6078,
              6079,
              -1230,
              6080,
              -5589
            ]
          ],
          'id': '49055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6081,
              -1723,
              -4370,
              6082,
              -3115,
              -3272,
              6083
            ]
          ],
          'id': '48053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6084,
              6085,
              -5610,
              6086,
              -1525,
              -1999
            ]
          ],
          'id': '30023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5609,
              6087,
              -1526,
              -6087
            ]
          ],
          'id': '30093'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1421,
              -110,
              -5084,
              6088,
              6089,
              -4999
            ]
          ],
          'id': '46135'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4972,
              6090,
              6091,
              6092,
              -352,
              6093
            ]
          ],
          'id': '46071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5989,
              6094,
              -6051,
              6095,
              6096
            ]
          ],
          'id': '47133'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5695,
              6097,
              6098,
              -6080,
              6099
            ]
          ],
          'id': '49015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6100,
              -1672,
              6101,
              -4646,
              6102,
              -3789,
              6103,
              -3792,
              6104
            ]
          ],
          'id': '48391'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6105,
              6106,
              -1224,
              -3573,
              -632
            ]
          ],
          'id': '48357'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4050,
              6107,
              -620,
              -5227,
              6108,
              -5235,
              6109
            ]
          ],
          'id': '35045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1279,
              6110,
              6111,
              6112,
              6113,
              -3553,
              6114
            ]
          ],
          'id': '05063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6115,
              -5120,
              -3565,
              -1586,
              6116,
              6117,
              -2278
            ]
          ],
          'id': '29029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6118,
              -5269,
              6119,
              -4337,
              -2743
            ]
          ],
          'id': '38067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6113,
              6120,
              6121,
              -3989,
              -611,
              -4815,
              6122
            ]
          ],
          'id': '05067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -104,
              6123,
              6124,
              -4978,
              -5081,
              -108
            ]
          ],
          'id': '46083'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6053,
              6125,
              6126,
              -1394,
              -5768,
              6127
            ]
          ],
          'id': '47131'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6128,
              -4291,
              6129,
              6130,
              6131,
              6132,
              6133
            ]
          ],
          'id': '45003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6134,
              -3530,
              6135,
              6136
            ]
          ],
          'id': '41003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6137,
              -6136,
              -3529,
              6138,
              6139,
              6140,
              6141
            ]
          ],
          'id': '41039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6142,
              6143,
              6144,
              6145,
              6146,
              -4612,
              -5726
            ]
          ],
          'id': '51097'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6147,
              6148,
              -5743,
              6149,
              6150
            ]
          ],
          'id': '29201'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4643,
              6151,
              6152,
              6153,
              6154
            ]
          ],
          'id': '48321'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1097,
              6155,
              6156,
              -248,
              6157
            ]
          ],
          'id': '48447'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6158,
              -443,
              6159,
              6160
            ]
          ],
          'id': '55129'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6161,
              -5590,
              -6081,
              -1229,
              6162,
              6163
            ]
          ],
          'id': '49017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6164,
              -5443,
              -3649,
              6165,
              -2534
            ]
          ],
          'id': '31055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6166,
              6167
            ]
          ],
          'id': '51520'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6168,
              -32,
              6169,
              -35,
              -3412
            ]
          ],
          'id': '38097'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3360,
              -3366,
              6170,
              6171,
              -1951,
              6172
            ]
          ],
          'id': '05069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6173,
              6174,
              6175,
              -6121,
              -6112,
              6176
            ]
          ],
          'id': '05075'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5177,
              6177
            ]
          ],
          'id': '51570'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6178,
              6179,
              6180,
              6181,
              6182
            ]
          ],
          'id': '48001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6183,
              -5523,
              -3485,
              6184,
              -5739
            ]
          ],
          'id': '21039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4318,
              6185,
              -5613,
              6186,
              6187,
              6188
            ]
          ],
          'id': '47009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6189,
              6190,
              -1406,
              6191,
              -5197,
              -1467,
              -1396
            ]
          ],
          'id': '47017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3489,
              6192,
              6193,
              -1400,
              -6191,
              6194
            ]
          ],
          'id': '47079'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6195,
              6196,
              6197,
              6198,
              6199,
              -5344
            ]
          ],
          'id': '25013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3621,
              -1594,
              -5104,
              6200,
              -5464,
              -5048
            ]
          ],
          'id': '29033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6201,
              6202,
              -6069,
              -5382,
              6203,
              6204
            ]
          ],
          'id': '48055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6205,
              -5291,
              6206,
              6207
            ]
          ],
          'id': '50021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3544,
              6208,
              6209,
              6210,
              6211,
              -3527
            ]
          ],
          'id': '41031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6212,
              -2450,
              -4942,
              6213,
              6214,
              6215
            ]
          ],
          'id': '51185'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6216,
              -3769,
              6217,
              6218,
              6219
            ]
          ],
          'id': '51043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6220,
              6221,
              -4181
            ]
          ],
          'id': '72149'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6222,
              6223,
              6224,
              -1766,
              6225
            ]
          ],
          'id': '12067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -374,
              -1139,
              -1327,
              6226,
              -2897
            ]
          ],
          'id': '20205'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1188,
              -5559,
              6227,
              -3231
            ]
          ],
          'id': '17047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1644,
              -2745,
              -4340,
              -402,
              6228
            ]
          ],
          'id': '38071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6088,
              -5608,
              -5538,
              -5809,
              -1527
            ]
          ],
          'id': '30057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5281,
              6229,
              6230,
              6231,
              6232,
              -4863
            ]
          ],
          'id': '29005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6233,
              6234,
              6235,
              6236,
              6237,
              -3596,
              6238
            ]
          ],
          'id': '51083'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6239,
              6240,
              6241,
              -3137,
              6242
            ]
          ],
          'id': '51013'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                6243
              ]
            ],
            [
              [
                6244
              ]
            ],
            [
              [
                6245,
                -4168,
                -2486,
                6246,
                6247
              ]
            ],
            [
              [
                6248
              ]
            ]
          ],
          'id': '53057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6249,
              -3747,
              6250,
              -720,
              6251,
              6252,
              6253,
              -5123
            ]
          ],
          'id': '30025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6254,
              6255,
              6256,
              -6009,
              6257,
              6258
            ]
          ],
          'id': '51181'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6259,
              6260,
              6261,
              -4737
            ]
          ],
          'id': '53071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6262,
              6263,
              6264,
              6265,
              6266,
              -771
            ]
          ],
          'id': '13057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6267,
              6268,
              6269,
              6270,
              6271
            ]
          ],
          'id': '27149'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2899,
              6272,
              6273,
              6274,
              6275
            ]
          ],
          'id': '20019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6276,
              6277,
              6278,
              -1702,
              -3887,
              6279
            ]
          ],
          'id': '29075'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6280,
              6281,
              -6219,
              6282,
              -2400,
              6283
            ]
          ],
          'id': '51187'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1863,
              -1242,
              -291,
              -4826,
              -5918
            ]
          ],
          'id': '19135'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6284,
              6285,
              -1417,
              6286,
              -1914
            ]
          ],
          'id': '48325'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4630,
              6287,
              -3888,
              -2462,
              6288,
              6289
            ]
          ],
          'id': '29021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5124,
              -6254,
              6290,
              -1424,
              -5787,
              -5127
            ]
          ],
          'id': '30011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6291,
              6292,
              -2645,
              -3415,
              6293,
              6294
            ]
          ],
          'id': '26055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6295,
              -4227,
              -4802,
              -4956,
              6296,
              6297,
              6298
            ]
          ],
          'id': '28141'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6299,
              -4935,
              -5933,
              -3904,
              -3759,
              -4810
            ]
          ],
          'id': '35003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6300,
              -3523,
              -5163,
              -329,
              -5408,
              6301
            ]
          ],
          'id': '42111'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -366,
              6302,
              6303,
              6304,
              6305,
              6306
            ]
          ],
          'id': '36109'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3715,
              6307,
              6308,
              6309
            ]
          ],
          'id': '36067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5210,
              6310,
              6311,
              6312,
              -5275,
              6313
            ]
          ],
          'id': '45051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6314,
              6315,
              6316,
              -751
            ]
          ],
          'id': '30041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6317,
              6318,
              6319,
              -2879,
              -48
            ]
          ],
          'id': '36001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -517,
              6320,
              -6266,
              6321,
              6322,
              -4004,
              6323,
              6324,
              -643,
              6325
            ]
          ],
          'id': '13121'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5712,
              6326,
              6327,
              6328,
              6329,
              6330
            ]
          ],
          'id': '55091'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6331,
              -3389,
              6332,
              6333,
              6334
            ]
          ],
          'id': '01105'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2812,
              6335,
              -2419
            ]
          ],
          'id': '02090'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6336,
              6337,
              6338,
              6339
            ]
          ],
          'id': '13125'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -944,
              6340,
              -2329,
              6341,
              -2834
            ]
          ],
          'id': '48173'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1504,
              -1502,
              1501,
              1502,
              -1502,
              -1501,
              6342,
              -5361,
              -4593,
              -4088,
              6343,
              -5810,
              -5536
            ]
          ],
          'id': '56039'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -4403,
                6344
              ]
            ],
            [
              [
                6345,
                6346,
                6347,
                6348,
                6349,
                6350,
                -4408,
                6351,
                6352
              ]
            ]
          ],
          'id': '08059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6353,
              -2157,
              6354
            ]
          ],
          'id': '08029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4003,
              6355,
              6356,
              6357,
              -6324
            ]
          ],
          'id': '13063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -74,
              6358,
              -4472,
              6359,
              6360
            ]
          ],
          'id': '18117'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                6361
              ]
            ],
            [
              [
                6362
              ]
            ],
            [
              [
                6363
              ]
            ],
            [
              [
                -3739,
                6364
              ]
            ]
          ],
          'id': '36103'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                6365
              ]
            ],
            [
              [
                -4526,
                6366,
                -3711,
                6367
              ]
            ],
            [
              [
                6368
              ]
            ]
          ],
          'id': '36045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4083,
              6369,
              6370,
              6371,
              -1798
            ]
          ],
          'id': '20107'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6372,
              6373,
              6374,
              -3916,
              6375,
              6376,
              -4716,
              6377
            ]
          ],
          'id': '37161'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6378,
              6379,
              6380,
              -4571,
              -4994,
              -5745
            ]
          ],
          'id': '34041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6381,
              6382,
              -5591,
              -6162,
              6383,
              -4503
            ]
          ],
          'id': '49001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6384,
              6385,
              -4746,
              6386,
              -6167,
              6387,
              -1632,
              6388
            ]
          ],
          'id': '51191'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4954,
              -4651,
              6389,
              6390,
              -4171
            ]
          ],
          'id': '01015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6391,
              6392,
              6393,
              6394,
              6395,
              -1772
            ]
          ],
          'id': '13133'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6396,
              6397,
              6398,
              6399
            ]
          ],
          'id': '54009'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                6400
              ]
            ],
            [
              [
                6401
              ]
            ],
            [
              [
                -2074,
                6402,
                -4962
              ]
            ],
            [
              [
                6403
              ]
            ],
            [
              [
                6404,
                -4964
              ]
            ]
          ],
          'id': '02070'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3090,
              6405,
              -3836,
              -5757,
              -4803,
              -5761
            ]
          ],
          'id': '04013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4890,
              6406,
              6407,
              6408,
              6409
            ]
          ],
          'id': '18125'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3861,
              -2853,
              6410,
              -4513,
              6411,
              6412,
              -77
            ]
          ],
          'id': '18137'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2528,
              6413,
              -4793,
              -5431,
              6414,
              -736
            ]
          ],
          'id': '20095'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6415,
              -1550,
              6416,
              6417,
              6418
            ]
          ],
          'id': '20123'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1570,
              6419,
              -780,
              -1044,
              -3100,
              6420
            ]
          ],
          'id': '20083'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3123,
              6421,
              -2556,
              -1125,
              -659,
              6422
            ]
          ],
          'id': '20127'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1789,
              6423,
              -668,
              6424,
              -1377,
              6425,
              6426
            ]
          ],
          'id': '27095'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5679,
              6427,
              6428,
              6429,
              -89,
              6430
            ]
          ],
          'id': '28081'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6431,
              6432,
              -5681,
              6433,
              -455,
              6434,
              6435
            ]
          ],
          'id': '28071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6436,
              6437,
              6438,
              6439,
              -4252,
              -4529
            ]
          ],
          'id': '28029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6440,
              6441,
              6442,
              6443,
              -450,
              6444
            ]
          ],
          'id': '28111'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4339,
              6445,
              -33,
              -6169,
              -3411,
              -397
            ]
          ],
          'id': '38035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6446,
              6447,
              6448,
              -5246,
              -5205
            ]
          ],
          'id': '42045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6449,
              6450,
              6451,
              6452,
              6453
            ]
          ],
          'id': '44003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6454,
              -5917,
              -2913,
              -3574,
              -1870
            ]
          ],
          'id': '19095'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1063,
              6455,
              -5444,
              -6165,
              -2533,
              6456,
              -5529
            ]
          ],
          'id': '31053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -334,
              6457,
              6458,
              -5409
            ]
          ],
          'id': '54057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6459,
              -4817,
              -3848,
              6460,
              -3364
            ]
          ],
          'id': '05117'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5759,
              6461,
              -4813,
              6462,
              -4805,
              -5756,
              -3834
            ]
          ],
          'id': '04009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -474,
              6463,
              6464,
              6465,
              6466,
              6467,
              6468,
              6469
            ]
          ],
          'id': '08049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6470,
              6471,
              6472,
              6473,
              6474,
              -3303,
              -1859,
              -4773,
              6475
            ]
          ],
          'id': '08109'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6476,
              6477,
              -3217,
              -1837,
              -623,
              6478
            ]
          ],
          'id': '12093'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2142,
              6479,
              6480,
              6481,
              -4053
            ]
          ],
          'id': '13123'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3437,
              6482,
              6483,
              6484,
              -5221,
              6485,
              6486,
              -3205
            ]
          ],
          'id': '13299'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6487,
              -5453,
              -5183,
              -4438,
              -5348,
              6488,
              6489
            ]
          ],
          'id': '29007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5225,
              6490,
              6491,
              6492,
              6493
            ]
          ],
          'id': '35028'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6494,
              6495,
              -4584,
              -2568,
              -3586,
              -1473,
              -1532,
              -5717
            ]
          ],
          'id': '30027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6496,
              -5389,
              6497,
              -4661
            ]
          ],
          'id': '31149'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6498,
              6499,
              -5298,
              6500,
              6501,
              -5476
            ]
          ],
          'id': '38061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6502,
              6503,
              6504,
              -1337,
              6505,
              -4299,
              -4063
            ]
          ],
          'id': '21101'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6506,
              -5801,
              -5556,
              6507,
              6508,
              -6450,
              6509
            ]
          ],
          'id': '44007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6510,
              -3949,
              6511,
              6512,
              -5971,
              -434
            ]
          ],
          'id': '47013'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                6513,
                6514,
                6515,
                6516
              ]
            ],
            [
              [
                6517,
                6518,
                6519,
                6520,
                -131
              ]
            ]
          ],
          'id': '48261'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6521,
              -4130,
              6522,
              6523,
              -2926,
              6524
            ]
          ],
          'id': '36051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6525,
              -3973,
              6526,
              6527,
              6528,
              6529
            ]
          ],
          'id': '54011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6530,
              6531,
              6532,
              -3996,
              6533,
              -2223
            ]
          ],
          'id': '06007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6468,
              6534,
              6535,
              6536,
              6537
            ]
          ],
          'id': '08117'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6538,
              6539,
              -4560,
              6540,
              -1918
            ]
          ],
          'id': '13147'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5396,
              -1818,
              -4124,
              -3221,
              6541
            ]
          ],
          'id': '17187'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6542,
              6543,
              6544,
              -3455,
              6545
            ]
          ],
          'id': '18119'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6546,
              6547,
              -6360,
              -4477,
              -4885,
              6548,
              6549,
              -6408
            ]
          ],
          'id': '18037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2191,
              6550,
              6551,
              6552,
              -1568
            ]
          ],
          'id': '20165'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -225,
              -1036,
              -3572,
              -6455,
              6553
            ]
          ],
          'id': '19011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6554,
              -4692,
              -3870,
              -6040,
              -5325,
              -3945,
              6555
            ]
          ],
          'id': '21125'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6556,
              6557,
              6558,
              6559,
              -2526,
              -782
            ]
          ],
          'id': '20185'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5748,
              6560,
              6561,
              6562,
              6563,
              6564
            ]
          ],
          'id': '22115'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6565,
              6566,
              6567,
              -1615,
              -2707,
              -5425
            ]
          ],
          'id': '26093'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3170,
              -3150,
              -3315,
              6568,
              -476,
              -2809,
              6569,
              -1362
            ]
          ],
          'id': '27099'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2632,
              6570,
              6571,
              6572,
              6573
            ]
          ],
          'id': '28073'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6574,
              6575,
              6576,
              6577,
              6578,
              6579
            ]
          ],
          'id': '28053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6580,
              6581,
              -1664,
              6582,
              -670
            ]
          ],
          'id': '31139'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6583,
              6584,
              -5583,
              6585,
              -1318,
              -5850
            ]
          ],
          'id': '21237'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6586,
              -5136,
              6587,
              -5939,
              6588,
              -6043
            ]
          ],
          'id': '21033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1427,
              -3774,
              6589,
              6590,
              -4970,
              -42
            ]
          ],
          'id': '46093'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6591,
              6592,
              6593,
              6594,
              6595,
              6596,
              -4705,
              6597
            ]
          ],
          'id': '21021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6598,
              -4722,
              6599,
              6600,
              6601
            ]
          ],
          'id': '37199'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6333,
              -3388,
              6602,
              -2772,
              6603,
              6604
            ]
          ],
          'id': '01047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6605,
              -2629,
              6606,
              -218
            ]
          ],
          'id': '13231'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -878,
              6607,
              6608,
              6609
            ]
          ],
          'id': '01035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3472,
              6610,
              -3362,
              -2543,
              6611,
              6612
            ]
          ],
          'id': '05105'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6481,
              6613,
              -6263,
              6614
            ]
          ],
          'id': '13227'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6615,
              -6395,
              6616,
              6617,
              -6340,
              6618,
              6619
            ]
          ],
          'id': '13141'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6620,
              -200,
              6621,
              6622,
              6623
            ]
          ],
          'id': '13307'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6624,
              -4240,
              6625,
              -3078,
              6626,
              6627
            ]
          ],
          'id': '18095'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3457,
              -75,
              -6361,
              -6548,
              6628
            ]
          ],
          'id': '18101'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2257,
              -379,
              -1571,
              -6421,
              -3103,
              6629,
              6630
            ]
          ],
          'id': '20055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2210,
              6631,
              6632,
              6633,
              6634
            ]
          ],
          'id': '20087'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3475,
              6635,
              6636,
              -5934,
              -3008,
              6637
            ]
          ],
          'id': '18181'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4707,
              6638,
              -4693,
              -6555,
              6639,
              -4305,
              6640
            ]
          ],
          'id': '21199'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5489,
              -5286,
              -5322,
              -4539,
              6641
            ]
          ],
          'id': '17009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6642,
              6643,
              6644,
              6645,
              6646,
              6647,
              6648
            ]
          ],
          'id': '22021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5900,
              -5466,
              -1990,
              6649,
              6650
            ]
          ],
          'id': '29101'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4250,
              6651,
              6652,
              6653,
              6654
            ]
          ],
          'id': '29017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2326,
              6655,
              6656,
              6657,
              6658,
              6659
            ]
          ],
          'id': '29035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -971,
              -2537,
              6660,
              -4865,
              6661,
              -2619
            ]
          ],
          'id': '31109'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6662,
              6663,
              6664,
              6665,
              -4573
            ]
          ],
          'id': '34035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6666,
              -6525,
              -2925,
              6667,
              6668
            ]
          ],
          'id': '36121'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6669,
              -367,
              -6307,
              6670,
              6671
            ]
          ],
          'id': '36097'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6672,
              6673,
              6674,
              6675,
              -1886
            ]
          ],
          'id': '39091'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6676,
              -1811,
              -1934,
              6677,
              6678,
              6679,
              -6675
            ]
          ],
          'id': '39159'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5059,
              -3176,
              6680,
              -3519,
              6681
            ]
          ],
          'id': '42063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4074,
              -5807,
              6682,
              -5752,
              6683,
              -2845,
              6684
            ]
          ],
          'id': '21099'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1339,
              6685,
              -4702,
              -4297,
              6686,
              6687,
              6688
            ]
          ],
          'id': '21183'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6689,
              6690,
              -2522,
              -2731,
              -6028,
              6691
            ]
          ],
          'id': '46129'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5074,
              6692,
              -4986,
              -5611,
              6693
            ]
          ],
          'id': '47089'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6694,
              6695,
              6696,
              6697,
              -5770,
              6698,
              -804
            ]
          ],
          'id': '21097'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5612,
              -5068,
              6699,
              6700,
              6701,
              -6187
            ]
          ],
          'id': '37173'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6702,
              -2367,
              6703,
              -3113,
              6704,
              6705,
              6706,
              6707,
              6708,
              6709,
              -6710,
              6709,
              6710,
              6711,
              6712,
              6713,
              6714,
              6715,
              6716,
              -2371,
              6717
            ]
          ],
          'id': '48499'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6718,
              6719,
              6720,
              6721,
              6722,
              6723
            ]
          ],
          'id': '37091'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -832,
              6724,
              -4221,
              -5440,
              -4158,
              6725,
              6726
            ]
          ],
          'id': '48291'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6727,
              6728,
              -80,
              -4422,
              6729,
              -72,
              6730
            ]
          ],
          'id': '18071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6553,
              6731,
              -6557,
              -781,
              -6420,
              -1569
            ]
          ],
          'id': '20145'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2559,
              -3324,
              -1258,
              -1800,
              -1137,
              -372
            ]
          ],
          'id': '20031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -852,
              6732,
              6733,
              -4837,
              -3877
            ]
          ],
          'id': '22055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6734,
              -2135,
              -1389,
              -6268,
              6735
            ]
          ],
          'id': '27051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6736,
              -2966,
              6737,
              6738,
              6739
            ]
          ],
          'id': '28121'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6740,
              6741,
              -6740,
              -6438,
              6742,
              -3706
            ]
          ],
          'id': '28049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6743,
              6744,
              6745,
              -4680,
              6746,
              6747
            ]
          ],
          'id': '37051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6748,
              6749,
              6750,
              6751,
              -1311,
              -2971,
              -1973,
              -4201
            ]
          ],
          'id': '37193'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1902,
              6752,
              6753,
              -6673,
              -1885,
              6754
            ]
          ],
          'id': '39011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6755,
              6756,
              6757,
              6758,
              6759,
              6760,
              -3928
            ]
          ],
          'id': '40125'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6761,
              -4279,
              6762,
              6763,
              6764,
              6765
            ]
          ],
          'id': '40091'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6766,
              6767,
              -3541,
              6768,
              6769
            ]
          ],
          'id': '41071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5088,
              -5746,
              -4992,
              6770,
              6771,
              6772
            ]
          ],
          'id': '42077'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5805,
              6773,
              -4710,
              6774,
              6775
            ]
          ],
          'id': '21217'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4426,
              -2846,
              -6684,
              -5755,
              -3492,
              6776
            ]
          ],
          'id': '21009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6083,
              -4374,
              6777,
              -6202,
              6778,
              -3116
            ]
          ],
          'id': '48453'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -115,
              -833,
              -6727,
              6779,
              6780,
              6781
            ]
          ],
          'id': '48339'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6782,
              -470,
              -2330,
              -6341,
              -943
            ]
          ],
          'id': '48227'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -3963
              ]
            ],
            [
              [
                6783,
                -5846,
                6784,
                6785,
                -1630,
                6786,
                -5563
              ]
            ]
          ],
          'id': '51195'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6787
            ]
          ],
          'id': '51840'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4275,
              6788,
              -948,
              6789,
              -96
            ]
          ],
          'id': '39139'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6739,
              6790,
              6791,
              -2630,
              6792,
              -6439
            ]
          ],
          'id': '28127'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6793,
              -6489,
              -5351,
              6794,
              6795,
              -1542,
              6796
            ]
          ],
          'id': '29019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -752,
              -6317,
              6797,
              -6495,
              -5716,
              6798,
              -5977,
              6799
            ]
          ],
          'id': '30015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6800,
              -927,
              -3413,
              -387,
              -1970,
              -4659
            ]
          ],
          'id': '31081'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6493,
              6801,
              -6491,
              -5224,
              6802,
              -4671,
              -2946,
              6803,
              6804
            ]
          ],
          'id': '35049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6805,
              -5393,
              -4678,
              6806,
              6807,
              -4681,
              -6746
            ]
          ],
          'id': '37163'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6808,
              -2786,
              -4280,
              -6762,
              6809,
              6810,
              -6758
            ]
          ],
          'id': '40107'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6811,
              6812,
              6813,
              -1391,
              6814,
              -3064
            ]
          ],
          'id': '40047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6001,
              6815,
              6816,
              -6584,
              -5849,
              6817
            ]
          ],
          'id': '21165'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5223,
              -5981,
              6818,
              6819,
              -4667,
              -6803
            ]
          ],
          'id': '35033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6583,
              -1660,
              6820,
              -4626,
              -671
            ]
          ],
          'id': '31119'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -236,
              6821,
              -923,
              -6801,
              -4658,
              -792
            ]
          ],
          'id': '31121'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3528,
              -6212,
              6822,
              -4365,
              -4134,
              6823,
              -6139
            ]
          ],
          'id': '41017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4368,
              6824,
              6825,
              6826,
              6827,
              6828,
              6829
            ]
          ],
          'id': '32013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6830,
              6831,
              6832,
              6833,
              6834
            ]
          ],
          'id': '42117'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6688,
              6835,
              -2848,
              -4430,
              6836,
              6837
            ]
          ],
          'id': '21031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4475,
              6838,
              -4068,
              -4295,
              -4886
            ]
          ],
          'id': '21163'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6597,
              -6596,
              -6595,
              6839,
              -4694,
              -6639,
              -4706
            ]
          ],
          'id': '21137'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5327,
              -6039,
              6840,
              -5565,
              6841,
              6842,
              -3947
            ]
          ],
          'id': '21013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3127,
              6843,
              6844,
              -802,
              -2774,
              -4795
            ]
          ],
          'id': '21187'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6845,
              6846,
              -3958
            ]
          ],
          'id': '37137'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6847,
              6848,
              6849,
              6850,
              6851,
              6852
            ]
          ],
          'id': '37187'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6853,
              6854,
              6855,
              6856,
              6857
            ]
          ],
          'id': '54015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6858,
              -5130,
              6859,
              -5871,
              6860
            ]
          ],
          'id': '56033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6861,
              -146,
              6862,
              6863,
              6864
            ]
          ],
          'id': '72137'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5018,
              6865,
              -2120,
              -3334,
              6866,
              -4356
            ]
          ],
          'id': '72125'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6867,
              -4923,
              6868,
              6869,
              6870
            ]
          ],
          'id': '42103'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6871,
              6872,
              -6844,
              -3126,
              6873
            ]
          ],
          'id': '21077'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1204,
              -5577,
              6874,
              6875,
              -6744,
              6876,
              -5863,
              6877
            ]
          ],
          'id': '37125'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5945,
              6878,
              -6747,
              -4684,
              6879,
              -5209,
              6880
            ]
          ],
          'id': '37155'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4373,
              6881,
              -6064,
              -6203,
              -6778
            ]
          ],
          'id': '48021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6882,
              6883,
              6884,
              -830,
              -113
            ]
          ],
          'id': '48455'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6885,
              6886,
              6887,
              -3050,
              -4672,
              -1307,
              -6752,
              6888
            ]
          ],
          'id': '37171'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6889,
              6890,
              -5474,
              6891
            ]
          ],
          'id': '38023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4192,
              6892,
              6893,
              6894,
              6895,
              6896,
              -2473
            ]
          ],
          'id': '72119'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1408,
              6897,
              -5098,
              -4902,
              6898,
              -4984,
              -5526
            ]
          ],
          'id': '45029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3511,
              6899,
              6900,
              -5837,
              6901,
              6902
            ]
          ],
          'id': '47041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4324,
              -964,
              -690,
              -1720,
              -1129,
              6903
            ]
          ],
          'id': '48309'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3960,
              6904,
              -2453,
              -4314
            ]
          ],
          'id': '37031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5031,
              6905,
              -1714,
              6906,
              -2593,
              -2320
            ]
          ],
          'id': '48307'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3143,
              6907,
              6908,
              -1083,
              6909,
              6910
            ]
          ],
          'id': '39171'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6911,
              6912,
              6913,
              6914,
              6915,
              6916,
              6917,
              -6154
            ]
          ],
          'id': '48039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1924,
              -841,
              6918,
              6919,
              -4943,
              6920,
              6921
            ]
          ],
          'id': '39013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6922,
              6923,
              6924,
              6925,
              6926,
              6927
            ]
          ],
          'id': '39071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3725,
              6928,
              -3229,
              6929,
              -796,
              6930
            ]
          ],
          'id': '39173'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6931,
              6932,
              -874,
              6933,
              6934,
              6935
            ]
          ],
          'id': '55015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6936,
              6937,
              6938,
              -5885,
              6939
            ]
          ],
          'id': '42087'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6940,
              -5927,
              6941,
              6942,
              -2622,
              -1221,
              6943
            ]
          ],
          'id': '40045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6944,
              6945,
              -2246,
              6946,
              6947,
              6948,
              -6092
            ]
          ],
          'id': '46075'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5941,
              6949,
              6950,
              -4637,
              -1401,
              -6194,
              6951
            ]
          ],
          'id': '47161'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6952,
              6953,
              6954,
              -2873,
              -1022
            ]
          ],
          'id': '48017'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                6955
              ]
            ],
            [
              [
                6956,
                6957,
                -957,
                -4184,
                6958,
                6959
              ]
            ]
          ],
          'id': '72113'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6960,
              -1941,
              6961,
              6962,
              6963,
              6964
            ]
          ],
          'id': '40065'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1069,
              6965,
              -3942,
              6966,
              -4695,
              -6062
            ]
          ],
          'id': '45059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6967,
              6968,
              -3770,
              -1425,
              -6291,
              -6253
            ]
          ],
          'id': '46063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6969,
              6970,
              6971,
              6972,
              6973
            ]
          ],
          'id': '54105'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6974,
              6975,
              -6932,
              6976,
              -835
            ]
          ],
          'id': '55087'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4270,
              -5983,
              6977,
              -3309,
              6978
            ]
          ],
          'id': '38037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6979,
              -4364,
              6980,
              6981
            ]
          ],
          'id': '41007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6982,
              -5914,
              -5089,
              -6773,
              6983,
              -239,
              6984,
              -5647
            ]
          ],
          'id': '42107'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6834,
              6985,
              6986,
              6987,
              6988,
              -5644,
              6989,
              6990,
              6991
            ]
          ],
          'id': '42081'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                6992,
                6993
              ]
            ],
            [
              [
                -6901,
                6994,
                6995,
                6996,
                -5838
              ]
            ]
          ],
          'id': '47185'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              6997,
              6998,
              6999,
              7000,
              -6329
            ]
          ],
          'id': '55011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7001
            ]
          ],
          'id': '69110'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6867,
              -3333,
              7002,
              7003,
              -4357
            ]
          ],
          'id': '72079'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7004,
              7005,
              7006,
              7007,
              7008,
              7009,
              7010
            ]
          ],
          'id': '72131'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7011,
              -4116,
              7012,
              7013,
              -6106,
              -631,
              -4033,
              7014
            ]
          ],
          'id': '40139'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6988,
              7015,
              -5915,
              -6983,
              -5646,
              7016
            ]
          ],
          'id': '42037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5985,
              7017,
              7018,
              -6692,
              -6027,
              7019,
              -3772
            ]
          ],
          'id': '46031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6181,
              7020,
              7021,
              -6883,
              -112,
              -2390,
              7022
            ]
          ],
          'id': '48225'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6907,
              -1713,
              7023,
              7024,
              -6084,
              -3271,
              -2594
            ]
          ],
          'id': '48411'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4329,
              7025,
              7026,
              7027,
              -6256,
              7028,
              7029
            ]
          ],
          'id': '51036'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7030,
              -6284,
              -2404,
              7031,
              -2410,
              7032
            ]
          ],
          'id': '51139'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2244,
              -630,
              7033,
              -3202,
              7034
            ]
          ],
          'id': '46123'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3237,
              -5870,
              7035
            ]
          ],
          'id': '48377'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6384,
              -6164,
              7036,
              7037,
              -4504
            ]
          ],
          'id': '49021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7038,
              7039,
              -1749,
              7040,
              7041
            ]
          ],
          'id': '48347'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7042,
              7043,
              7044,
              7045,
              7046,
              7047,
              -6066
            ]
          ],
          'id': '48477'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3380,
              -4060,
              -5367,
              7048,
              7049,
              7050
            ]
          ],
          'id': '49003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7051,
              7052,
              7053,
              -261,
              7054
            ]
          ],
          'id': '48097'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7055,
              -6964,
              7056,
              7057,
              -1095,
              -5016
            ]
          ],
          'id': '48487'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -962,
              7058,
              -6182,
              -7023,
              -2389,
              7059
            ]
          ],
          'id': '48289'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1930,
              -5385,
              7060,
              -1669,
              7061,
              7062,
              -1413
            ]
          ],
          'id': '48255'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4941,
              7063,
              -3619,
              7064,
              7065,
              -6214
            ]
          ],
          'id': '51021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7066,
              7067,
              -6259,
              7068,
              7069
            ]
          ],
          'id': '51183'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7070,
              -5482,
              7071,
              7072,
              7073
            ]
          ],
          'id': '51111'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7074,
              -3061,
              7075,
              -6855,
              7076,
              -6971
            ]
          ],
          'id': '54013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7077,
              -2451,
              -6213,
              7078,
              7079,
              -5844
            ]
          ],
          'id': '51027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7080,
              -7074,
              7081,
              7082,
              -3830,
              7083,
              -6237
            ]
          ],
          'id': '51117'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6699,
              -5774,
              7084,
              7085,
              7086,
              -805
            ]
          ],
          'id': '21017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -22,
              -3654,
              -3376,
              -4487
            ]
          ],
          'id': '16067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7087,
              -6889,
              -6751,
              7088
            ]
          ],
          'id': '37005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3401,
              7089,
              7090,
              7091,
              7092,
              -5480
            ]
          ],
          'id': '51007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7093,
              -5115,
              7094,
              -2286,
              7095,
              -6145
            ]
          ],
          'id': '51073'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7096,
              -6281,
              -7031,
              7097,
              7098
            ]
          ],
          'id': '51171'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5845,
              -7080,
              7099,
              -6785
            ]
          ],
          'id': '51051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7100,
              7101,
              7102,
              -958,
              -6958,
              7103,
              7104
            ]
          ],
          'id': '72141'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7105,
              -6160,
              7106,
              -4345,
              7107,
              -5876
            ]
          ],
          'id': '55005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7108,
              7109,
              7110,
              7111,
              -2128
            ]
          ],
          'id': '72003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7112,
              7113,
              7114,
              7115
            ]
          ],
          'id': '53049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7116,
              7117,
              7118,
              7119
            ]
          ],
          'id': '54045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7120,
              7121,
              -2748,
              7122,
              -1157
            ]
          ],
          'id': '06039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7123,
              7124,
              7125,
              -871,
              7126
            ]
          ],
          'id': '55061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7127,
              -2149,
              7128,
              -1366,
              -3498,
              7129,
              -3028
            ]
          ],
          'id': '17135'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2158,
              -6354,
              7130,
              7131,
              7132,
              -6471,
              7133,
              7134
            ]
          ],
          'id': '08051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7135,
              -656,
              7136,
              -6728,
              7137
            ]
          ],
          'id': '18013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7138,
              7139,
              7140,
              7141,
              7142
            ]
          ],
          'id': '13101'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7143,
              -5575,
              7144,
              -5394,
              -6806,
              -6745,
              -6876
            ]
          ],
          'id': '37085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6305,
              7145,
              7146,
              7147,
              7148,
              7149
            ]
          ],
          'id': '36107'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6877,
              -6748,
              -6879,
              -5944
            ]
          ],
          'id': '37093'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7150,
              7151,
              7152,
              7153
            ]
          ],
          'id': '37143'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4640,
              -5006,
              7154,
              -5539,
              -1403
            ]
          ],
          'id': '47085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -688,
              -418,
              -1980,
              -2640,
              -188
            ]
          ],
          'id': '48381'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3305,
              7155,
              7156,
              7157,
              -5979,
              -164
            ]
          ],
          'id': '08023'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                7158
              ]
            ],
            [
              [
                7159,
                -3920,
                7160,
                -1868,
                7161,
                7162,
                7163,
                7164
              ]
            ]
          ],
          'id': '08123'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7165,
              7166,
              -4055,
              7167,
              -4412
            ]
          ],
          'id': '13313'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7168,
              7169,
              7170,
              7171,
              -6697,
              7172
            ]
          ],
          'id': '21023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4241,
              -6625,
              7173,
              -2572,
              7174
            ]
          ],
          'id': '18159'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7175,
              -4708,
              -6641,
              -4304,
              7176,
              -4833
            ]
          ],
          'id': '21207'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6044,
              -6589,
              -5938,
              7177,
              -5514
            ]
          ],
          'id': '21143'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1046,
              -3307,
              7178,
              7179,
              7180,
              7181
            ]
          ],
          'id': '20025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3597,
              -6238,
              -7084,
              -3832,
              -1082,
              7182,
              -5232
            ]
          ],
          'id': '37077'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                7183,
                7184
              ]
            ],
            [
              [
                -6852,
                7185,
                7186,
                7187,
                7188,
                7189
              ]
            ]
          ],
          'id': '37095'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7190,
              -6579,
              7191,
              7192
            ]
          ],
          'id': '28125'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7104,
              -6957,
              7193,
              7194,
              7195,
              7196
            ]
          ],
          'id': '72001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6620,
              7197,
              7198,
              -883,
              7199
            ]
          ],
          'id': '13009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4296,
              -4075,
              -6685,
              -2844,
              -6836,
              -6687
            ]
          ],
          'id': '21085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5680,
              -6431,
              -88,
              -456,
              -6434
            ]
          ],
          'id': '28115'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -628,
              7200,
              7201,
              -5386,
              7202
            ]
          ],
          'id': '31015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7203
            ]
          ],
          'id': '51790'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2536,
              7204,
              -3737,
              -5279,
              -4861,
              -6661
            ]
          ],
          'id': '31025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1451,
              7205,
              -3159,
              -122,
              -4757,
              -543
            ]
          ],
          'id': '46073'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4806,
              -6463,
              -4812,
              -4930,
              7206,
              -284
            ]
          ],
          'id': '04003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7207,
              -4465,
              -3507,
              -4607,
              7208,
              7209
            ]
          ],
          'id': '05113'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3086,
              -5722,
              7210,
              7211,
              7212,
              -3940
            ]
          ],
          'id': '45039'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                7213
              ]
            ],
            [
              [
                -3021,
                7214,
                7215,
                7216
              ]
            ],
            [
              [
                7217
              ]
            ]
          ],
          'id': '06111'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7218,
              -2007,
              7219,
              7220,
              7221
            ]
          ],
          'id': '06059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7222,
              -3858,
              -3039,
              7223
            ]
          ],
          'id': '12053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7224,
              7225,
              7226,
              7227,
              -4482,
              -3074
            ]
          ],
          'id': '13029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2766,
              -5777,
              7228,
              -232,
              7229,
              7230,
              -2739
            ]
          ],
          'id': '19109'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7231,
              -2905,
              -2655,
              -4113,
              7232,
              -3370
            ]
          ],
          'id': '20187'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7233,
              -3276,
              -2336,
              7234,
              -3374,
              -4151,
              7235,
              -7157
            ]
          ],
          'id': '08071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3029,
              -7130,
              -3500,
              7236,
              -3246,
              -5158,
              7237,
              7238,
              -5185
            ]
          ],
          'id': '17119'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7239,
              -767,
              -625,
              7240,
              7241,
              7242,
              7243
            ]
          ],
          'id': '12015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5557,
              -4891,
              -6410,
              7244,
              7245,
              -4061,
              7246
            ]
          ],
          'id': '18051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7247,
              7248,
              -3728,
              -295
            ]
          ],
          'id': '19163'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7249,
              -6140,
              -6824,
              -4139,
              7250,
              -4044,
              7251
            ]
          ],
          'id': '41035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5384,
              -2793,
              7252,
              -1670,
              -7061
            ]
          ],
          'id': '48123'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7253,
              -338,
              7254,
              7255,
              7256,
              7257,
              7258
            ]
          ],
          'id': '01023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7259,
              7260,
              7261,
              -4603,
              7262,
              -7255,
              -337
            ]
          ],
          'id': '01119'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7263,
              -1690,
              7264,
              7265,
              7266,
              7267,
              -4230
            ]
          ],
          'id': '05015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7268,
              7269,
              -5055,
              -2002,
              7270,
              -7215,
              -3020,
              7271
            ]
          ],
          'id': '06029'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -7241,
                7272,
                7273,
                7274
              ]
            ],
            [
              [
                7275
              ]
            ],
            [
              [
                -7243,
                7276
              ]
            ]
          ],
          'id': '12071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7277,
              -475,
              -6470,
              7278,
              -1793,
              7279,
              7280
            ]
          ],
          'id': '08107'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7281,
              7282,
              7283,
              7284,
              7285,
              7286,
              7287
            ]
          ],
          'id': '17181'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3306,
              -740,
              -5920,
              7288,
              -7179
            ]
          ],
          'id': '20033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7289,
              7290,
              -4703,
              -6686,
              -1338,
              -6505
            ]
          ],
          'id': '21059'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                7291
              ]
            ],
            [
              [
                7292
              ]
            ],
            [
              [
                7293
              ]
            ],
            [
              [
                7294,
                7295,
                7296
              ]
            ]
          ],
          'id': '22087'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7297,
              7298,
              -4057,
              7299,
              7300
            ]
          ],
          'id': '16005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7301,
              -1604,
              -4216,
              -2985,
              -898,
              -3328,
              -5254
            ]
          ],
          'id': '20153'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7302,
              7303,
              7304,
              7305,
              7306,
              -2113
            ]
          ],
          'id': '13275'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7307,
              7308,
              -1854,
              7309,
              -3302,
              7310,
              7311
            ]
          ],
          'id': '13099'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5811,
              -6344,
              -4087,
              7312
            ]
          ],
          'id': '16081'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3549,
              -5207,
              -5252,
              -5484,
              7313,
              7314
            ]
          ],
          'id': '24015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -484,
              7315,
              7316,
              -83
            ]
          ],
          'id': '26147'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3846,
              7317,
              7318,
              7319,
              -3682,
              7320,
              7321
            ]
          ],
          'id': '05107'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7322,
              7323,
              -5520,
              7324,
              7325
            ]
          ],
          'id': '06013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7326,
              -5314,
              7327,
              7328,
              7329
            ]
          ],
          'id': '09009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7245,
              -6409,
              -6550,
              7330,
              -7290,
              -6504,
              7331
            ]
          ],
          'id': '18173'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7332,
              -4424,
              7333,
              7334,
              7335,
              7336,
              -4479
            ]
          ],
          'id': '18019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7337,
              7338,
              7339,
              -2509,
              7340,
              -3856
            ]
          ],
          'id': '12069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7341,
              7342,
              7343,
              7344
            ]
          ],
          'id': '21037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7345,
              -2516,
              7346,
              -4850,
              7347,
              7348
            ]
          ],
          'id': '22037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7349,
              7350,
              7351,
              7352,
              -6224
            ]
          ],
          'id': '12121'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                7353,
                -7349,
                7354,
                -4101,
                7355
              ]
            ],
            [
              [
                7356,
                -4099,
                7357
              ]
            ]
          ],
          'id': '22125'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -3345,
                7358
              ]
            ],
            [
              [
                7359
              ]
            ],
            [
              [
                7360
              ]
            ],
            [
              [
                -3661,
                7361,
                7362
              ]
            ]
          ],
          'id': '23013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7363,
              7364,
              7365,
              7366,
              -1617
            ]
          ],
          'id': '26163'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4569,
              7367,
              7368,
              7369,
              7370
            ]
          ],
          'id': '28033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7371,
              -5241,
              7372,
              7373,
              7374,
              -5492
            ]
          ],
          'id': '24027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7375,
              7376,
              7377,
              7378,
              -7282,
              7379,
              -6652,
              -4249
            ]
          ],
          'id': '29157'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5182,
              7380,
              7381,
              7382,
              7383,
              7384,
              7385,
              7386,
              7387,
              -1302,
              -4440
            ]
          ],
          'id': '29113'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2892,
              7388,
              7389,
              7390,
              7391
            ]
          ],
          'id': '27057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2549,
              -4112,
              -1648,
              7392,
              7393,
              7394
            ]
          ],
          'id': '20021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7395,
              -6271,
              7396,
              -5352,
              -5705,
              7397
            ]
          ],
          'id': '27011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5250,
              7398,
              7399,
              -999,
              7400,
              -5485
            ]
          ],
          'id': '10001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7401,
              -3056,
              7402,
              7403
            ]
          ],
          'id': '16075'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1198,
              -3144,
              -6911,
              7404,
              -2679
            ]
          ],
          'id': '18151'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1768,
              7405,
              -5375,
              7406,
              7407,
              7408
            ]
          ],
          'id': '12075'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3206,
              -6487,
              7409,
              7410,
              -7140,
              7411
            ]
          ],
          'id': '13065'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7412,
              7413,
              -2803,
              -5316,
              7414
            ]
          ],
          'id': '26027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4568,
              7415,
              7416,
              -5676,
              -6433,
              7417,
              -7368
            ]
          ],
          'id': '28093'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -385,
              -4244,
              -1331,
              -1621,
              7418,
              -5853,
              -1357
            ]
          ],
          'id': '26081'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7419,
              7420,
              -5637,
              -154,
              -2953,
              7421,
              7422
            ]
          ],
          'id': '31135'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7423,
              7424,
              7425,
              7426
            ]
          ],
          'id': '34029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3515,
              7427,
              -4420,
              7428,
              -5673,
              7429
            ]
          ],
          'id': '18167'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7430,
              -6671,
              -6306,
              -7150,
              7431,
              -6832
            ]
          ],
          'id': '36015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4516,
              7432,
              -6874,
              -3125,
              7433,
              -6412
            ]
          ],
          'id': '18155'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7434,
              -7390,
              7435,
              -3537,
              -2133
            ]
          ],
          'id': '27159'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7436,
              -4563,
              -2564,
              7437,
              -5792,
              -5728,
              -1481
            ]
          ],
          'id': '56027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4082,
              7438,
              7439,
              -307,
              7440,
              -6370
            ]
          ],
          'id': '29013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7441,
              -389,
              -2381,
              7442,
              7443,
              7444
            ]
          ],
          'id': '31129'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -78,
              -6413,
              -7434,
              -3130,
              7445,
              -7334,
              -4423
            ]
          ],
          'id': '18077'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7446,
              7447,
              7448,
              -4518,
              7449,
              7450,
              7451
            ]
          ],
          'id': '34003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7452,
              7453,
              7454,
              7455,
              -7448,
              7456
            ]
          ],
          'id': '36119'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -395,
              7457,
              7458,
              7459
            ]
          ],
          'id': '36063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7460,
              -6749,
              -4200,
              7461,
              -4749
            ]
          ],
          'id': '37189'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7462,
              -868,
              -3536,
              7463,
              -5354
            ]
          ],
          'id': '27023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5428,
              7464,
              7465,
              7466,
              7467
            ]
          ],
          'id': '40071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -581,
              7468,
              -5511,
              -5510,
              -5301,
              7469
            ]
          ],
          'id': '17151'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5913,
              7470,
              7471,
              -6870,
              7472,
              -6379,
              -5744,
              -5086
            ]
          ],
          'id': '42089'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -6802,
                -6492
              ]
            ],
            [
              [
                -5226,
                -6494,
                -6805,
                7473,
                -4932,
                -5236,
                -6109
              ]
            ]
          ],
          'id': '35043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3098,
              -1529,
              -5808,
              -2672,
              7474
            ]
          ],
          'id': '16033'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                7475,
                7476,
                -1597,
                -2643,
                7477
              ]
            ],
            [
              [
                7478
              ]
            ],
            [
              [
                7479
              ]
            ],
            [
              [
                7480
              ]
            ],
            [
              [
                7481
              ]
            ]
          ],
          'id': '26029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2708,
              -1619,
              7482,
              -3721,
              7483,
              -3141
            ]
          ],
          'id': '26091'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6330,
              -7001,
              7484,
              -3312,
              7485
            ]
          ],
          'id': '27157'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7486,
              -2460,
              -5051,
              -5899,
              7487
            ]
          ],
          'id': '29047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7488,
              7489,
              -2787,
              -6809,
              -6757,
              7490
            ]
          ],
          'id': '40081'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5403,
              -1469,
              -1195,
              -5498,
              7491,
              -3427,
              7492,
              7493
            ]
          ],
          'id': '47069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7494,
              -2912,
              7495,
              -2889,
              7496
            ]
          ],
          'id': '27071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -31,
              -2250,
              7497,
              7498,
              -36,
              -6170
            ]
          ],
          'id': '27107'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3516,
              -7430,
              -5672,
              7499,
              -3256,
              -3420,
              7500
            ]
          ],
          'id': '17023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7498,
              -2249,
              7501,
              -7391,
              -7435,
              -2132,
              7502
            ]
          ],
          'id': '27005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7503,
              -3319,
              -1156,
              -3645,
              -5442,
              7504
            ]
          ],
          'id': '19085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7505,
              -3447,
              7506,
              7507,
              -3683,
              -7320
            ]
          ],
          'id': '28027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4669,
              7508,
              -4155,
              7509,
              7510,
              -192,
              7511,
              7512,
              -4258,
              7513
            ]
          ],
          'id': '35037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6665,
              7514,
              7515,
              7516,
              7517,
              7518
            ]
          ],
          'id': '34023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3821,
              7519,
              7520,
              7521,
              7522,
              -4608,
              -2124
            ]
          ],
          'id': '54071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2431,
              7523,
              7524,
              7525,
              -5634
            ]
          ],
          'id': '05003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3684,
              -7508,
              7526,
              7527,
              -6575,
              7528
            ]
          ],
          'id': '28133'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7529,
              -7370,
              7530,
              7531,
              -3444,
              -7506,
              -7319,
              7532
            ]
          ],
          'id': '28143'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -711,
              -4828,
              7533,
              -3461,
              -2442,
              7534
            ]
          ],
          'id': '29171'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4827,
              -3218,
              -1708,
              -3462,
              -7534
            ]
          ],
          'id': '29197'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7535,
              7536,
              7537,
              -3818,
              -3057,
              -7075,
              -6970
            ]
          ],
          'id': '54085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7538,
              -3298,
              -3815,
              -7538,
              7539,
              7540
            ]
          ],
          'id': '54095'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4733,
              7541,
              7542,
              7543,
              7544,
              -3616
            ]
          ],
          'id': '51063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4552,
              -4023,
              7545,
              7546,
              -302,
              7547
            ]
          ],
          'id': '30055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2211,
              -6635,
              7548,
              -3322,
              7549,
              -5662
            ]
          ],
          'id': '20177'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7405,
              -6910,
              -1088,
              -2201,
              -893
            ]
          ],
          'id': '18033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7550,
              -1518,
              -101,
              -268
            ]
          ],
          'id': '46101'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7347,
              -2515,
              -19,
              7551,
              -4851
            ]
          ],
          'id': '22091'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7552,
              -3696,
              3694,
              -3694,
              7553,
              -4188,
              7554
            ]
          ],
          'id': '55051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7555,
              -3801,
              7556,
              -5035,
              7557,
              7558
            ]
          ],
          'id': '48475'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7559,
              -3734,
              -4767,
              7560,
              -7058
            ]
          ],
          'id': '48485'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -6516,
                7561,
                7562,
                7563
              ]
            ],
            [
              [
                -6520,
                7564,
                7565,
                7566
              ]
            ]
          ],
          'id': '48489'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7567,
              7568,
              -3876,
              7569,
              7570,
              -6645,
              7571
            ]
          ],
          'id': '22083'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1705,
              -2173,
              7572,
              7573,
              7574,
              7575
            ]
          ],
          'id': '29045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7576,
              7577,
              7578,
              -3295
            ]
          ],
          'id': '54049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7579,
              7580,
              7581,
              -7536,
              -6974,
              7582,
              -3966
            ]
          ],
          'id': '54107'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3296,
              -7579,
              7583,
              -5340,
              7584,
              7585,
              -3816
            ]
          ],
          'id': '54033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7586,
              7587,
              -4553,
              -7548,
              -301,
              -4583
            ]
          ],
          'id': '30105'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7588,
              7589,
              7590,
              -3667,
              7591
            ]
          ],
          'id': '25009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7592,
              -4751,
              7593,
              -4719,
              7594,
              -1486
            ]
          ],
          'id': '47019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -322,
              7595,
              7596,
              -5861,
              7597,
              7598,
              7599
            ]
          ],
          'id': '47147'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2430,
              7600,
              -3686,
              7601,
              7602,
              -3873,
              7603,
              7604,
              -7524
            ]
          ],
          'id': '05017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7174,
              -6628,
              7605,
              7606,
              -2219,
              -2573
            ]
          ],
          'id': '18057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7607,
              -2228,
              -4242,
              -7175,
              -2571,
              7608
            ]
          ],
          'id': '18067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2220,
              -7607,
              7609,
              -1581,
              -653,
              7610,
              -1561
            ]
          ],
          'id': '18097'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5936,
              -2574,
              -2221,
              -1564,
              7611,
              -4417,
              -5828
            ]
          ],
          'id': '18107'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7612,
              7613,
              -2941,
              -2967,
              -6737,
              -6742
            ]
          ],
          'id': '28089'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                7614
              ]
            ],
            [
              [
                7615,
                7616,
                -2274
              ]
            ]
          ],
          'id': '26033'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                7617
              ]
            ],
            [
              [
                7618
              ]
            ],
            [
              [
                7619
              ]
            ],
            [
              [
                -2275,
                -7617,
                7620,
                7621
              ]
            ]
          ],
          'id': '26097'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7622,
              7623,
              7624,
              7625,
              -5219
            ]
          ],
          'id': '12089'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7578,
              7626,
              -5414,
              -5337,
              -7584
            ]
          ],
          'id': '54091'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4755,
              7627,
              -5659,
              -4051,
              -7167,
              7628
            ]
          ],
          'id': '47011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7629,
              7630,
              7631,
              -7350,
              -6223,
              7632,
              7633
            ]
          ],
          'id': '12079'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7634,
              -3213,
              7635,
              7636,
              -6577
            ]
          ],
          'id': '28051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7637,
              -3490,
              -6195,
              -6190,
              -1395,
              -6127
            ]
          ],
          'id': '47183'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7638,
              -5713,
              -6331,
              -7486,
              -3311,
              -3148,
              -1945
            ]
          ],
          'id': '27049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7639,
              7640,
              -917,
              -1535,
              7641,
              7642
            ]
          ],
          'id': '29077'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7643,
              7644,
              -3591,
              7645,
              -4035,
              7646,
              -3635
            ]
          ],
          'id': '01111'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3903,
              -4883,
              7647,
              7648,
              -1626
            ]
          ],
          'id': '35013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7649,
              7650,
              -6990,
              -5643,
              -5642,
              7651,
              -6938
            ]
          ],
          'id': '42119'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2733,
              -277,
              -3943,
              7652,
              -6029
            ]
          ],
          'id': '46119'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1640,
              -5998,
              -997,
              7653,
              -5630,
              7654
            ]
          ],
          'id': '33003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2932,
              7655
            ]
          ],
          'id': '51770'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5916,
              -3730,
              -5398,
              -4545,
              -2215,
              -2915
            ]
          ],
          'id': '19115'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2819,
              7656,
              7657,
              -6230,
              -5280
            ]
          ],
          'id': '19145'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5721,
              -5094,
              -5202,
              -5790,
              -5961,
              7658,
              -7211
            ]
          ],
          'id': '45055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7659,
              -7300,
              -4056,
              -3378,
              -3653
            ]
          ],
          'id': '16077'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7660,
              -3279,
              7661
            ]
          ],
          'id': '41011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6141,
              -7250,
              7662,
              -2614,
              -3280,
              -7661,
              7663
            ]
          ],
          'id': '41019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4623,
              -2841,
              7664,
              7665,
              7666
            ]
          ],
          'id': '55023'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                7667
              ]
            ],
            [
              [
                7668,
                7669,
                -1741,
                7670,
                7671,
                -3977
              ]
            ]
          ],
          'id': '51005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4940,
              -5692,
              7672,
              7673,
              -4730,
              -3613,
              -7064
            ]
          ],
          'id': '51071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7352,
              7674,
              -7141,
              -7411,
              7675,
              7676,
              -5370,
              7677
            ]
          ],
          'id': '12023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7678,
              -2470,
              7679,
              -135,
              7680,
              -3479
            ]
          ],
          'id': '72007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -955,
              7681,
              -151,
              -2480,
              -3292,
              7682,
              -6221,
              -4180
            ]
          ],
          'id': '72107'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5731,
              7683,
              7684,
              7685
            ]
          ],
          'id': '27123'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7686,
              -4377,
              7687,
              7688,
              -1791,
              7689,
              7690
            ]
          ],
          'id': '49047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7691,
              7692,
              7693,
              -4576,
              7694,
              -7543
            ]
          ],
          'id': '51067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7695,
              -3563
            ]
          ],
          'id': '15005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5164,
              -4631,
              -6290,
              7696,
              7697,
              -6632,
              -2209
            ]
          ],
          'id': '20005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7698,
              -6510,
              -6454,
              7699,
              7700
            ]
          ],
          'id': '09015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7701,
              7702,
              -7700,
              -6453,
              7703,
              7704,
              -5312
            ]
          ],
          'id': '09011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7705,
              7706,
              7707,
              7708,
              -3542,
              -6768
            ]
          ],
          'id': '41005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1103,
              -5231,
              -5751,
              7709,
              -1745,
              -7040,
              7710
            ]
          ],
          'id': '48419'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7711,
              -5905,
              -1014,
              7712,
              7713,
              -4334,
              7714
            ]
          ],
          'id': '39029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1161,
              7715,
              -7269,
              7716,
              -1299
            ]
          ],
          'id': '06031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7717,
              -3024,
              -2225,
              7718,
              7719,
              7720,
              7721
            ]
          ],
          'id': '06045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4407,
              -1881,
              7722,
              -2342,
              -6352
            ]
          ],
          'id': '08035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -549,
              -3119,
              -3775,
              7723,
              7724,
              -2921
            ]
          ],
          'id': '48259'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7725,
              7726,
              -3838,
              7727,
              -7266
            ]
          ],
          'id': '05009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6814,
              7728,
              7729,
              -7489,
              7730,
              -1392
            ]
          ],
          'id': '40083'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7731,
              -4150,
              7732,
              7733,
              -3713
            ]
          ],
          'id': '36065'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7734,
              -6701,
              7735,
              7736,
              7737,
              7738
            ]
          ],
          'id': '37113'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7739,
              7740,
              7741,
              7742,
              7743,
              7744,
              7745
            ]
          ],
          'id': '36031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2126,
              -4610,
              7746,
              7747,
              -7669,
              -3976
            ]
          ],
          'id': '51017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7748,
              7749,
              7750,
              7751,
              -7118
            ]
          ],
          'id': '54005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7752,
              7753,
              -3980,
              -5690,
              7754
            ]
          ],
          'id': '54019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7755,
              7756,
              -6858,
              -7753,
              7757,
              -7750,
              7758,
              7759
            ]
          ],
          'id': '54039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7760,
              7761,
              7762,
              7763,
              -6895
            ]
          ],
          'id': '72037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7764,
              -160,
              7765,
              -152,
              -7682,
              -954,
              -7103
            ]
          ],
          'id': '72039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7766,
              -7280,
              -1792,
              -7689
            ]
          ],
          'id': '08103'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1562,
              -7611,
              -657,
              -7136,
              7767,
              -6544,
              7768
            ]
          ],
          'id': '18109'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7769,
              -6648,
              7770,
              7771,
              7772,
              -4857
            ]
          ],
          'id': '22059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1543,
              -6796,
              7773,
              -5116,
              7774
            ]
          ],
          'id': '29135'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4896,
              7775,
              -1680,
              -5907,
              7776,
              7777
            ]
          ],
          'id': '42039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5968,
              -5435,
              7778,
              7779,
              7780,
              -6816,
              -6000
            ]
          ],
          'id': '21205'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5004,
              7781,
              7782,
              7783,
              7784,
              -5567,
              7785
            ]
          ],
          'id': '47187'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1675,
              -1012,
              -754,
              7786,
              -344
            ]
          ],
          'id': '38081'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7003,
              -3332,
              7787,
              7788
            ]
          ],
          'id': '72055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7789,
              -3263,
              7790
            ]
          ],
          'id': '16061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7791,
              7792,
              7793,
              -7791,
              -3262,
              7794,
              7795
            ]
          ],
          'id': '16069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7796,
              -7445,
              7797,
              -1551,
              -6416,
              7798,
              -4873
            ]
          ],
          'id': '20089'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7799,
              -3407,
              7800,
              -5660,
              7801,
              -3069
            ]
          ],
          'id': '20117'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3406,
              -4213,
              -5165,
              -2207,
              -5661,
              -7801
            ]
          ],
          'id': '20131'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7802,
              -4232,
              -3357,
              7803,
              7804,
              -2237
            ]
          ],
          'id': '40001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7738,
              7805,
              7806,
              7807,
              7808
            ]
          ],
          'id': '37043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7809,
              -3954,
              -5959,
              -4556,
              -5958,
              -4554,
              -6540,
              7810,
              7811,
              7812,
              7813
            ]
          ],
          'id': '45073'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3356,
              7814,
              7815,
              7816,
              7817,
              -7804
            ]
          ],
          'id': '05033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3146,
              -2258,
              -6631,
              -2652,
              -2904
            ]
          ],
          'id': '20093'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7818
            ]
          ],
          'id': '72049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2633,
              -6574,
              7819,
              7820,
              7821,
              7822
            ]
          ],
          'id': '28091'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7823,
              -6435,
              -459,
              -2434,
              7824
            ]
          ],
          'id': '28161'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7825,
              -2376,
              -1058,
              -2736,
              -176,
              -2983,
              -4215
            ]
          ],
          'id': '31065'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7826,
              7827,
              -5600,
              -4360,
              7828
            ]
          ],
          'id': '53015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1092,
              7829,
              7830,
              -2405,
              7831,
              -4224
            ]
          ],
          'id': '01083'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7832,
              7833,
              7834,
              -2465
            ]
          ],
          'id': '12013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7835,
              -3859,
              -7223,
              7836,
              -7408
            ]
          ],
          'id': '12017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7603,
              7837,
              -7193,
              7838,
              -3704,
              -3874
            ]
          ],
          'id': '28055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7839,
              -4481,
              7840,
              -4069,
              -6839,
              -4474
            ]
          ],
          'id': '18061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7233,
              -4117,
              -7012,
              7841,
              -3371
            ]
          ],
          'id': '20129'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4717,
              -6377,
              7842,
              -3937,
              -6966,
              -1068
            ]
          ],
          'id': '45083'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1549,
              -3261,
              7843,
              -3440,
              7844,
              -6417
            ]
          ],
          'id': '20143'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7845,
              7846,
              -4654
            ]
          ],
          'id': '30103'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7847,
              -5082,
              -4981,
              7848,
              7849,
              -1662
            ]
          ],
          'id': '31051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7850,
              7851,
              -6161,
              -7106,
              -5875,
              -5764
            ]
          ],
          'id': '55013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7852,
              -6023,
              -5702,
              7853,
              -3165,
              7854,
              7855
            ]
          ],
          'id': '55025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7856,
              7857,
              7858,
              7859,
              7860,
              -4351,
              7861,
              -4840
            ]
          ],
          'id': '22007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7862,
              7863,
              7864,
              7865,
              -6871,
              -7472,
              7866
            ]
          ],
          'id': '42127'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7867,
              -7733,
              -4149,
              7868,
              -51,
              7869,
              7870
            ]
          ],
          'id': '36077'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7871,
              7872,
              -3931,
              -2394,
              7873,
              -2360
            ]
          ],
          'id': '40049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4524,
              7874,
              -7746,
              7875,
              7876,
              7877,
              -4146
            ]
          ],
          'id': '36041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4231,
              -7268,
              7878,
              7879,
              7880,
              -7815,
              -3355
            ]
          ],
          'id': '05087'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7881,
              -7863,
              7882,
              -5895,
              7883,
              -7148
            ]
          ],
          'id': '42115'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                7884
              ]
            ],
            [
              [
                7885,
                7886,
                7887,
                7888
              ]
            ]
          ],
          'id': '12037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -848,
              -2115,
              7889,
              7890,
              7891,
              7892,
              7893
            ]
          ],
          'id': '12039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2466,
              -7835,
              7894,
              -7889,
              7895
            ]
          ],
          'id': '12045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7896,
              -7306,
              7897,
              -7634,
              7898,
              7899,
              7900
            ]
          ],
          'id': '12065'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7901,
              -3043,
              7902,
              7903,
              -3045
            ]
          ],
          'id': '12103'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7904,
              7905,
              -533,
              7906,
              -6962,
              -1940,
              -537
            ]
          ],
          'id': '40075'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7816,
              -7881,
              7907,
              -5045,
              7908
            ]
          ],
          'id': '05047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7909,
              7910,
              -2783,
              7911,
              7912
            ]
          ],
          'id': '40117'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3933,
              7913,
              7914,
              7915,
              7916,
              7917,
              -2396
            ]
          ],
          'id': '40069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1149,
              -5330,
              7918,
              7919,
              -1698,
              -6279,
              7920
            ]
          ],
          'id': '29081'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6792,
              7921,
              7922,
              7923,
              -6571,
              -2631
            ]
          ],
          'id': '28031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7924,
              -7829,
              -4359,
              -6980,
              7925,
              -7115
            ]
          ],
          'id': '53069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7926,
              7927,
              7928,
              7929,
              7930
            ]
          ],
          'id': '12019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2276,
              -7622,
              7931,
              7932,
              -5138
            ]
          ],
          'id': '26153'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1762,
              -2910,
              7933,
              -4618,
              -6159,
              -7852,
              7934
            ]
          ],
          'id': '55031'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                7935,
                7936,
                7937
              ]
            ],
            [
              [
                7938,
                7939,
                7940,
                7941,
                -1957,
                -195,
                7942
              ]
            ]
          ],
          'id': '13193'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7943,
              7944,
              -5629,
              -5625,
              -1261,
              -5501
            ]
          ],
          'id': '22027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7721,
              7945,
              7946,
              7947,
              7948,
              7949,
              7950
            ]
          ],
          'id': '06097'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3929,
              -6761,
              7951,
              -7872,
              -2359,
              7952
            ]
          ],
          'id': '40087'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7953,
              -2620,
              -6662,
              -3897,
              -3408,
              -7800,
              -3068
            ]
          ],
          'id': '31067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7954,
              -5785,
              -5995,
              7955,
              -3109,
              7956,
              7957
            ]
          ],
          'id': '48343'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7731,
              -7491,
              -6756,
              -3927,
              7958
            ]
          ],
          'id': '40109'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7959,
              -2368,
              -6703,
              7960,
              -2385
            ]
          ],
          'id': '48223'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4148,
              7961,
              7962,
              7963,
              -46,
              -7869
            ]
          ],
          'id': '36057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7964,
              -6275,
              7965,
              7966,
              -7910,
              7967,
              -7466
            ]
          ],
          'id': '40113'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7968,
              -318,
              7969,
              7970
            ]
          ],
          'id': '12113'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7340,
              7971,
              -2506
            ]
          ],
          'id': '12117'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1853,
              7972,
              7973,
              -845,
              -3300,
              -7310
            ]
          ],
          'id': '13007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7974,
              7975,
              -4409,
              -4457,
              7976
            ]
          ],
          'id': '13083'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7977,
              7978,
              7979,
              7980,
              -7973,
              -1852
            ]
          ],
          'id': '13095'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7981,
              7981,
              7982,
              -7303,
              -2112,
              -846,
              -7974
            ]
          ],
          'id': '13205'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7311,
              -3301,
              -843,
              7983,
              7984
            ]
          ],
          'id': '13253'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7985,
              -7912,
              -2788,
              -7490,
              -7730
            ]
          ],
          'id': '40119'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5988,
              7986,
              -4307,
              -438,
              -6047,
              -6095
            ]
          ],
          'id': '47137'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5806,
              -6776,
              7987,
              -5753,
              -6683
            ]
          ],
          'id': '21087'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5026,
              -2388,
              -5012,
              7988
            ]
          ],
          'id': '48397'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                7989
              ]
            ],
            [
              [
                7990,
                -3984
              ]
            ]
          ],
          'id': '78020'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4881,
              7991,
              -3238,
              7992,
              7993
            ]
          ],
          'id': '48229'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6972,
              -7077,
              -6854,
              -7757,
              7994
            ]
          ],
          'id': '54087'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6640,
              -6556,
              -3950,
              -6511,
              -433,
              -4306
            ]
          ],
          'id': '21147'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              7995,
              7996,
              -7259,
              7997,
              7998,
              -6442,
              7999
            ]
          ],
          'id': '28153'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7665,
              -2840,
              8000,
              8001,
              -4118,
              -4830,
              8002
            ]
          ],
          'id': '55043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8003,
              8004,
              8005,
              -7356,
              -4100,
              -7357,
              8006,
              8007
            ]
          ],
          'id': '22029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6717,
              6715,
              -6715,
              6713,
              -6713,
              6711,
              -6711,
              -6710,
              6709,
              -6710,
              -6709,
              6707,
              -6707,
              -6706,
              -6705,
              -3112,
              -2600,
              8008,
              8009,
              8010,
              -2372
            ]
          ],
          'id': '48423'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8011,
              -7740,
              -7875,
              -4523,
              8012
            ]
          ],
          'id': '36033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8013,
              8014,
              -3710,
              8015,
              -3708,
              8016,
              -4532,
              8017,
              -8004,
              8018
            ]
          ],
          'id': '22107'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8019,
              8020,
              -2517,
              -7346,
              -7354,
              -8006
            ]
          ],
          'id': '28157'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3707,
              -6743,
              -6437,
              -4528,
              -8017
            ]
          ],
          'id': '28021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -339,
              -7254,
              -7997,
              8021
            ]
          ],
          'id': '28023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2520,
              8022,
              -4977,
              -1448,
              -272,
              -2732
            ]
          ],
          'id': '46049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1458,
              -5569,
              -1094,
              -4223,
              8023
            ]
          ],
          'id': '47099'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7924,
              8024,
              -6445,
              -449,
              8025,
              -6572
            ]
          ],
          'id': '28035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8026,
              8027,
              -638,
              8028,
              8029,
              -7827,
              -7925,
              -7114
            ]
          ],
          'id': '53041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7694,
              8030,
              8031,
              -6234,
              8032,
              -1284,
              8033,
              -814,
              -4577
            ]
          ],
          'id': '51143'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -333,
              8034,
              8035,
              8036,
              -6458
            ]
          ],
          'id': '54027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6532,
              8037,
              -986,
              -2609,
              8038,
              8039
            ]
          ],
          'id': '06115'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6578,
              -7637,
              -7613,
              -6741,
              -3705,
              -7839,
              -7192
            ]
          ],
          'id': '28163'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2928,
              8040,
              -6835,
              -6992,
              8041,
              -5077,
              8042
            ]
          ],
          'id': '42105'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -132,
              -6521,
              -7567,
              8043,
              8044,
              8045
            ]
          ],
          'id': '48215'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8046,
              8047
            ]
          ],
          'id': '51131'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4525,
              -4144,
              -7732,
              -3712,
              -6367
            ]
          ],
          'id': '36049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8048,
              -7943,
              -194,
              8049
            ]
          ],
          'id': '13249'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8050,
              -7666,
              -8003,
              -4829,
              -965,
              -3865
            ]
          ],
          'id': '19043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6722,
              8051,
              -7154,
              8052
            ]
          ],
          'id': '37041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8053,
              8054,
              -4461,
              -4953,
              8055,
              8056,
              -2407
            ]
          ],
          'id': '01095'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8057,
              8058,
              8059,
              -7864,
              -7882,
              -7147
            ]
          ],
          'id': '36007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7964,
              8060,
              -6318,
              -47
            ]
          ],
          'id': '36093'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8061,
              -2392,
              8062,
              -7045,
              8063
            ]
          ],
          'id': '48041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8064,
              8065,
              8066,
              8067,
              8068,
              -2402
            ]
          ],
          'id': '51047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8069,
              8070,
              -8064,
              -7044,
              8071
            ]
          ],
          'id': '48051'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                8072
              ]
            ],
            [
              [
                8073
              ]
            ],
            [
              [
                -453,
                8074,
                8075,
                8076
              ]
            ]
          ],
          'id': '28047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8077,
              8078,
              8079,
              -2363,
              -7960,
              -2384
            ]
          ],
          'id': '48119'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7038,
              8080,
              -2,
              -4505
            ]
          ],
          'id': '49053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6989,
              -7017,
              -5645
            ]
          ],
          'id': '42093'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5033,
              -2729,
              8081,
              -424,
              -1963,
              -1739,
              8082,
              8083,
              8084
            ]
          ],
          'id': '48105'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8085,
              -2501,
              8086,
              8087,
              -7972,
              -7339,
              8088
            ]
          ],
          'id': '12127'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6524,
              8089,
              8090,
              -6672,
              -7431,
              -6831,
              -8041,
              -2927
            ]
          ],
          'id': '36101'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1513,
              8091,
              8092,
              -4175,
              8093
            ]
          ],
          'id': '55101'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8094,
              -2541,
              8095,
              8096,
              8097,
              -3504
            ]
          ],
          'id': '05059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7230,
              -2592,
              -1037,
              -3179
            ]
          ],
          'id': '19091'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3893,
              -3000,
              -3607,
              -2313,
              -5043,
              8098
            ]
          ],
          'id': '29055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5355,
              -7464,
              -3535,
              -3718,
              -3394,
              -3680,
              8099
            ]
          ],
          'id': '27173'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4002,
              -5821,
              -3854,
              -2583,
              8100,
              -6356
            ]
          ],
          'id': '13151'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8101,
              8102,
              8103,
              8104,
              -4949
            ]
          ],
          'id': '01011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3993,
              8105,
              -7121,
              -1163,
              -211,
              8106
            ]
          ],
          'id': '06047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8107,
              -6146,
              -7096,
              -2293,
              8108,
              -2291,
              8109,
              8110,
              -7027
            ]
          ],
          'id': '51095'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5624,
              8111,
              -6643,
              8112,
              -1263
            ]
          ],
          'id': '22049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8113,
              8114,
              8115,
              8116,
              -7151,
              -8052,
              -6721
            ]
          ],
          'id': '37073'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8117,
              8118,
              8119,
              -4619,
              -5597,
              8120
            ]
          ],
          'id': '55063'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -7937,
                8121,
                -7940
              ]
            ],
            [
              [
                8122,
                8123,
                8124,
                -7938,
                -7939,
                -8049,
                8125
              ]
            ]
          ],
          'id': '13269'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8126,
              8127,
              -7152,
              -8117
            ]
          ],
          'id': '37139'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6218,
              -3768,
              8128,
              8129,
              -8065,
              -2401,
              -6283
            ]
          ],
          'id': '51061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2412,
              8130,
              -8068,
              8131,
              -2862,
              -5460
            ]
          ],
          'id': '51137'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8132,
              -7871,
              8133,
              -8059,
              8134
            ]
          ],
          'id': '36017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4771,
              8135,
              8136
            ]
          ],
          'id': '51680'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8137,
              8138,
              8139,
              8140,
              -7915
            ]
          ],
          'id': '40029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6810,
              -6766,
              8141,
              -8139,
              8142,
              8143
            ]
          ],
          'id': '40063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4372,
              8144,
              -8072,
              -7043,
              -6065,
              -6882
            ]
          ],
          'id': '48287'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8145,
              -8136,
              -4770,
              -3807,
              8146,
              -6235,
              -8032
            ]
          ],
          'id': '51031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7952,
              -6760,
              8147,
              -8143,
              -8138,
              -7914,
              -3932,
              -7873
            ]
          ],
          'id': '40123'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2607,
              -980,
              8148,
              8149,
              -4137,
              -4136,
              -4369,
              -6830,
              8150,
              8151,
              8152,
              8153,
              8154,
              8155
            ]
          ],
          'id': '32031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8156,
              8157,
              -4924,
              -6868,
              -7866
            ]
          ],
          'id': '36105'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8158,
              8159,
              8160,
              8161,
              8162
            ]
          ],
          'id': '42041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3817,
              -7586,
              8163,
              -3422,
              8164,
              -3059
            ]
          ],
          'id': '54041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8165,
              -3886,
              -854,
              -3881,
              -4077,
              -5571,
              8166
            ]
          ],
          'id': '22053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -462,
              -3096,
              -600,
              8167,
              8168
            ]
          ],
          'id': '31113'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8169,
              8170,
              -3585,
              8171,
              8172,
              -8103,
              8173
            ]
          ],
          'id': '01113'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4454,
              8174,
              8175,
              -6177,
              -6111,
              -1278
            ]
          ],
          'id': '05135'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5056,
              -7270,
              -7716,
              -1160
            ]
          ],
          'id': '06107'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4427,
              -6777,
              -3497,
              8176,
              -5857,
              8177
            ]
          ],
          'id': '21003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8178,
              8179,
              8180,
              8181,
              8182,
              8183,
              -4797
            ]
          ],
          'id': '22051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4919,
              8184,
              8185,
              -7453,
              8186
            ]
          ],
          'id': '36079'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4920,
              -8187,
              -7457,
              -7447,
              8187
            ]
          ],
          'id': '36087'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8186,
              8188,
              8189,
              -7329,
              8190,
              -7454
            ]
          ],
          'id': '09001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8191,
              -2296,
              -4247,
              -2328,
              8192,
              -4452
            ]
          ],
          'id': '29091'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                8193
              ]
            ],
            [
              [
                8194
              ]
            ]
          ],
          'id': '66010'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -692,
              -963,
              -7060,
              -8062,
              -8071,
              8195
            ]
          ],
          'id': '48395'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8196,
              8197,
              8198,
              -1275,
              -1272,
              -5517,
              -7324,
              8199
            ]
          ],
          'id': '06067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6764,
              8200,
              8201,
              8202,
              8203,
              8204
            ]
          ],
          'id': '40061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8204,
              8205,
              -2721,
              8206
            ]
          ],
          'id': '40077'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7713,
              -1019,
              8207,
              -6397,
              8208
            ]
          ],
          'id': '54029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8209,
              -5173,
              8210,
              -5499,
              8211,
              8212
            ]
          ],
          'id': '05073'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8213,
              8214,
              -7425,
              8215,
              8216,
              -4509,
              8217
            ]
          ],
          'id': '34001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5545,
              -4017,
              -4488,
              -3382,
              8218,
              8219
            ]
          ],
          'id': '16083'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1712,
              -5029,
              -708,
              8220,
              -7024
            ]
          ],
          'id': '48333'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4834,
              -7177,
              -4308,
              -7987,
              -5987
            ]
          ],
          'id': '21053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8221,
              -1894,
              -2111,
              8222,
              -7715,
              -4333,
              8223,
              -3467
            ]
          ],
          'id': '39151'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3626,
              -4173,
              8224,
              8225,
              -3384,
              8226
            ]
          ],
          'id': '01117'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8227,
              -6769,
              -3545,
              -3525,
              -6135,
              8228
            ]
          ],
          'id': '41053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8229,
              8230,
              -3453,
              8231,
              -6551,
              -2190
            ]
          ],
          'id': '20167'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6634,
              8232,
              8233,
              -1255,
              -3323,
              -7549
            ]
          ],
          'id': '20045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7444,
              8234,
              -3072,
              -1546,
              -7798
            ]
          ],
          'id': '20157'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8235,
              8236,
              -8200,
              -7323,
              8237,
              -7948
            ]
          ],
          'id': '06095'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8238,
              -4455,
              -1281,
              8239,
              -3840,
              8240
            ]
          ],
          'id': '05005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8241,
              8242,
              8243,
              8244
            ]
          ],
          'id': '51710'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8245,
              8246,
              -1020,
              -510,
              -1719,
              -3156,
              -3799,
              8247,
              -5037
            ]
          ],
          'id': '35025'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -8016,
                -3709
              ]
            ],
            [
              [
                -7570,
                -3875,
                -3702,
                -8015,
                8248
              ]
            ]
          ],
          'id': '22065'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5038,
              -8248,
              -3802,
              -7556,
              8249
            ]
          ],
          'id': '48301'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                8250
              ]
            ],
            [
              [
                -7159
              ]
            ],
            [
              [
                8251,
                8252
              ]
            ],
            [
              [
                8253,
                8254,
                8255,
                -7163,
                8256,
                -6349
              ]
            ]
          ],
          'id': '08014'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2723,
              8257,
              -7210,
              8258,
              -3353,
              -5782,
              8259,
              -4534
            ]
          ],
          'id': '40089'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8260,
              -6399,
              8261,
              -4944,
              -6920
            ]
          ],
          'id': '54069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6188,
              -6702,
              -7735,
              8262,
              8263
            ]
          ],
          'id': '37075'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8264,
              -8263,
              -7739,
              -7809,
              8265,
              -2138,
              -5658
            ]
          ],
          'id': '37039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4980,
              -3643,
              8266,
              -7849
            ]
          ],
          'id': '31043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8267,
              8268,
              8269,
              -5802,
              -6507,
              -7699,
              8270,
              -6197,
              8271,
              -3673
            ]
          ],
          'id': '25027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8272,
              8273,
              8274,
              -1910,
              8275,
              -2851
            ]
          ],
          'id': '39017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8276,
              -8212,
              -5502,
              -1267,
              -4432,
              8277
            ]
          ],
          'id': '22015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4020,
              -1145,
              -1828,
              -4235,
              8278
            ]
          ],
          'id': '17103'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4362,
              -5602,
              8279,
              8280,
              -7707,
              8281
            ]
          ],
          'id': '41051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8282,
              -5505,
              8283,
              -6312,
              8284
            ]
          ],
          'id': '37019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8285,
              -6096,
              -6050,
              8286,
              -6995,
              -6900,
              -3510
            ]
          ],
          'id': '47141'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8287,
              8288,
              8289,
              8290,
              -4027,
              8291
            ]
          ],
          'id': '37083'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3099,
              -7475,
              -2677,
              8292,
              -3651,
              -1844
            ]
          ],
          'id': '16023'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -4401
              ]
            ],
            [
              [
                8293,
                -4404,
                -6345,
                -4402,
                -6351
              ]
            ]
          ],
          'id': '08031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7525,
              -7605,
              8294,
              -7568,
              8295,
              -5627
            ]
          ],
          'id': '22067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8296,
              -4579,
              -2288
            ]
          ],
          'id': '51735'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8297,
              -8245,
              8298,
              8299
            ]
          ],
          'id': '51740'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -8252,
                -8253
              ]
            ],
            [
              [
                -8251
              ]
            ],
            [
              [
                8300,
                -7164,
                -8256,
                -8255,
                -8254,
                -6348,
                8301,
                -6465
              ]
            ]
          ],
          'id': '08013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8302,
              8303,
              -7297,
              8304,
              -8181
            ]
          ],
          'id': '22071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5067,
              -3955,
              -7810,
              -7736,
              -6700
            ]
          ],
          'id': '37099'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8305,
              8306,
              8307,
              -2700,
              8308,
              -7257
            ]
          ],
          'id': '01025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7263,
              -4602,
              8309,
              -6334,
              -6605,
              8310,
              -8306,
              -7256
            ]
          ],
          'id': '01091'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8311,
              8312,
              -6335,
              -8310,
              -4601
            ]
          ],
          'id': '01065'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8313,
              8314,
              -2981,
              8315,
              8316
            ]
          ],
          'id': '01075'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8317,
              -8316,
              -2980,
              8318,
              -4599,
              -7262,
              8319
            ]
          ],
          'id': '01107'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4864,
              -6233,
              8320,
              -4209,
              -3404,
              -3896
            ]
          ],
          'id': '31127'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8321,
              -4332,
              -4734,
              -4330,
              -7030,
              8322,
              -2934,
              8323,
              -5178,
              -6178,
              -5176,
              8324,
              -7091
            ]
          ],
          'id': '51041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7710,
              -5750,
              8325,
              -5271,
              -1746
            ]
          ],
          'id': '48403'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8326,
              -6295,
              -583,
              8327
            ]
          ],
          'id': '26019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8328,
              -5901,
              -6651,
              8329,
              -7439,
              -4081
            ]
          ],
          'id': '29037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8226,
              8330,
              -3637,
              8331,
              -5261,
              -3385
            ]
          ],
          'id': '01037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5456,
              8332,
              -7165,
              -8301,
              -6464,
              -473
            ]
          ],
          'id': '08069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7598,
              -5860,
              8333,
              8334,
              -7783,
              8335
            ]
          ],
          'id': '47037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8336,
              -7650,
              -6937,
              8337,
              -6074,
              8338
            ]
          ],
          'id': '42027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8339,
              8340,
              8341,
              8342,
              -6067,
              -7048
            ]
          ],
          'id': '48015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8343,
              -5108,
              8344,
              8345
            ]
          ],
          'id': '50013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6011,
              8346,
              -8300,
              8347,
              8348,
              -8115,
              8349
            ]
          ],
          'id': '51800'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8350,
              8351,
              -2333,
              -3275
            ]
          ],
          'id': '08025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8352,
              -3278,
              8353,
              -6474
            ]
          ],
          'id': '08027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5623,
              -5628,
              -8296,
              -7572,
              -6644,
              -8112
            ]
          ],
          'id': '22073'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6342,
              -2332,
              -259,
              -425,
              -8082,
              -2728
            ]
          ],
          'id': '48383'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2361,
              -7874,
              -2393,
              -4741,
              -3731,
              -530
            ]
          ],
          'id': '40137'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3611,
              8354,
              -6656,
              -2325,
              -2315
            ]
          ],
          'id': '29179'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5039,
              -8250,
              -7559,
              8355,
              -3234,
              8356
            ]
          ],
          'id': '48389'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7723,
              -1880,
              8357,
              -3274,
              8358,
              -2343
            ]
          ],
          'id': '08041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8359,
              8360,
              8361,
              -7541,
              8362,
              -7581,
              8363
            ]
          ],
          'id': '39167'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7671,
              -1740,
              8364,
              -4731,
              -7674,
              8365
            ]
          ],
          'id': '51045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2994,
              8366,
              8367,
              -3623,
              8368,
              -2978,
              8369
            ]
          ],
          'id': '01127'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -6788
              ]
            ],
            [
              [
                -8036,
                8370,
                8371,
                -6220,
                -6282,
                -7097,
                8372
              ]
            ]
          ],
          'id': '51069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1476,
              -4657,
              8373,
              8374,
              8375
            ]
          ],
          'id': '30095'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2163,
              8376,
              -7821,
              8377,
              8378,
              -15
            ]
          ],
          'id': '22117'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5859,
              -1228,
              -3512,
              -6903,
              8379,
              8380,
              -8334
            ]
          ],
          'id': '47189'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8381,
              -4196,
              -6018,
              8382,
              -3264,
              -7790,
              -7794
            ]
          ],
          'id': '16035'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                8383
              ]
            ],
            [
              [
                8384,
                8385
              ]
            ],
            [
              [
                8386,
                8387,
                -4798,
                -8184,
                8388,
                8389,
                -7860
              ]
            ]
          ],
          'id': '22057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8390,
              -7476,
              8391
            ]
          ],
          'id': '26047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7083,
              8392,
              8393,
              -8288,
              -1079,
              -3831
            ]
          ],
          'id': '37185'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                8394
              ]
            ],
            [
              [
                8395
              ]
            ]
          ],
          'id': '69120'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8396,
              8397,
              -161,
              -7765,
              -7102,
              8398
            ]
          ],
          'id': '72013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1618,
              -7367,
              8399,
              -3722,
              -7483
            ]
          ],
          'id': '26115'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2305,
              8400,
              -2347
            ]
          ],
          'id': '30047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2348,
              -8401,
              -2304,
              8401,
              8402,
              -1997,
              -3265,
              -8383,
              -6017
            ]
          ],
          'id': '30063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8302,
              -6347,
              8403,
              -6466
            ]
          ],
          'id': '08047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6475,
              -8354,
              -3277,
              -7234,
              -7156,
              -3304
            ]
          ],
          'id': '08055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8404,
              8405,
              -7120,
              8406,
              -2447,
              -7078,
              -5843,
              -5593
            ]
          ],
          'id': '54059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -174,
              8407,
              -8371,
              -8035,
              -332
            ]
          ],
          'id': '54065'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7258,
              -8309,
              -2699,
              8408,
              8409,
              -7998
            ]
          ],
          'id': '01129'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2148,
              8410,
              8411,
              8412,
              -3418,
              -1373,
              -1367,
              -7129
            ]
          ],
          'id': '17173'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8413,
              -5829,
              -4421,
              -7428,
              -3514,
              8414
            ]
          ],
          'id': '18165'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4996,
              8415,
              8416,
              -7426,
              -8215,
              8417,
              8418
            ]
          ],
          'id': '34005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3314,
              8419,
              -5599,
              -5399,
              -477,
              -6569
            ]
          ],
          'id': '27045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -263,
              8420,
              8421,
              -4759,
              8422,
              8423
            ]
          ],
          'id': '48439'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4868,
              8424,
              8425,
              -5887,
              8426,
              8427,
              -4875
            ]
          ],
          'id': '17031'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                8428
              ]
            ],
            [
              [
                8429
              ]
            ],
            [
              [
                8430
              ]
            ],
            [
              [
                8431
              ]
            ],
            [
              [
                8432
              ]
            ],
            [
              [
                8433
              ]
            ],
            [
              [
                8434
              ]
            ],
            [
              [
                8435
              ]
            ],
            [
              [
                8436
              ]
            ],
            [
              [
                8437
              ]
            ]
          ],
          'id': '69085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8299,
              -8244,
              8438,
              -4724,
              8439,
              -8348
            ]
          ],
          'id': '51550'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3035,
              8440,
              -6566,
              -5424,
              -1133,
              -1314
            ]
          ],
          'id': '26155'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8441,
              8442,
              -481,
              -87,
              8443,
              -3033,
              -3677
            ]
          ],
          'id': '26157'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -719,
              8444,
              -6968,
              -6252
            ]
          ],
          'id': '38011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8445,
              -1783,
              -714,
              -6251,
              -3746
            ]
          ],
          'id': '38033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4347,
              -2253,
              8446,
              8447,
              -6998,
              -6328,
              8448
            ]
          ],
          'id': '55035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8449,
              8450,
              8451,
              -4040,
              -1273,
              8452
            ]
          ],
          'id': '32005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8453,
              -485,
              8454,
              -4238
            ]
          ],
          'id': '18009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3605,
              -2204,
              8455,
              -486,
              -8454,
              -4237
            ]
          ],
          'id': '18179'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8456,
              -1955,
              -5636,
              8457,
              8458
            ]
          ],
          'id': '05013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2524,
              8459,
              -5892,
              8460,
              8461,
              -182,
              8462
            ]
          ],
          'id': '17091'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7246,
              -7332,
              -6503,
              -4062
            ]
          ],
          'id': '18163'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8463,
              -3266,
              -2856,
              -3052,
              8464,
              -2988
            ]
          ],
          'id': '16003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6198,
              -8271,
              -7701,
              -7703,
              8465
            ]
          ],
          'id': '09013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4480,
              -7337,
              8466,
              -4312,
              8467,
              8468,
              -4070,
              -7841
            ]
          ],
          'id': '21111'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8378,
              -7820,
              -6573,
              -8026,
              -454,
              8469,
              8470
            ]
          ],
          'id': '28109'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8471,
              8472,
              -8387,
              -7859
            ]
          ],
          'id': '22093'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -361,
              -4378,
              -7687,
              8473,
              -5685,
              8474
            ]
          ],
          'id': '49013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6779,
              -6205,
              8475,
              -3776,
              -3117
            ]
          ],
          'id': '48209'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8476,
              -5688,
              -5698,
              8477,
              8478
            ]
          ],
          'id': '49023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8479,
              8480,
              8481,
              -6719,
              8482,
              -8289,
              -8394
            ]
          ],
          'id': '37131'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2770,
              -4951,
              8483,
              -1829,
              8484,
              -876
            ]
          ],
          'id': '01041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4598,
              8485,
              8486,
              8487
            ]
          ],
          'id': '16007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2886,
              8488,
              8489,
              -1697,
              -1906,
              -8275,
              8490
            ]
          ],
          'id': '39113'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8491,
              8492,
              8493,
              8494,
              8495,
              -1831
            ]
          ],
          'id': '01045'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                8496,
                8497
              ]
            ],
            [
              [
                8498
              ]
            ],
            [
              [
                8499,
                8500
              ]
            ]
          ],
          'id': '06075'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7135,
              8501,
              8502,
              8503,
              -2159
            ]
          ],
          'id': '08091'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7286,
              8504,
              -5304,
              -5521,
              8505,
              8506
            ]
          ],
          'id': '17153'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8507,
              8508,
              8509,
              -6174,
              -8176,
              8510
            ]
          ],
          'id': '05121'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3554,
              -6114,
              -6123,
              -4814,
              -6460,
              -3363,
              8511
            ]
          ],
          'id': '05145'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8512,
              -679,
              8513,
              -3470,
              -949,
              -6789,
              -4274
            ]
          ],
          'id': '39005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3924,
              -2239,
              8514,
              -8201,
              -6763,
              -4278
            ]
          ],
          'id': '40101'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                8515
              ]
            ],
            [
              [
                8516
              ]
            ],
            [
              [
                -4352,
                -7861,
                -8390,
                8517,
                -8385,
                8518
              ]
            ]
          ],
          'id': '22109'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8519,
              -8229,
              -6137,
              -6138,
              8520
            ]
          ],
          'id': '41041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -482,
              -8443,
              8521
            ]
          ],
          'id': '26063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8522,
              -1150,
              -7921,
              -6278,
              8523
            ]
          ],
          'id': '29227'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8524,
              8525,
              -6490,
              -6794,
              8526,
              -5101
            ]
          ],
          'id': '29175'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8527
            ]
          ],
          'id': '15003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8528,
              -8478,
              -5697,
              8529,
              -6382,
              -4502
            ]
          ],
          'id': '49027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8530,
              -5696,
              -6100,
              -6079,
              -5588,
              -6383
            ]
          ],
          'id': '49041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8530,
              -7050,
              -5586,
              8531,
              -5689,
              -8477,
              8532
            ]
          ],
          'id': '49045'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                8533,
                8534,
                8535,
                8536
              ]
            ],
            [
              [
                8537
              ]
            ],
            [
              [
                8538
              ]
            ],
            [
              [
                8539
              ]
            ],
            [
              [
                8540,
                8541,
                8542
              ]
            ],
            [
              [
                8543
              ]
            ],
            [
              [
                8544
              ]
            ],
            [
              [
                8545
              ]
            ],
            [
              [
                8546
              ]
            ]
          ],
          'id': '12087'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8547,
              8548,
              -6133,
              8549,
              -6034,
              8550,
              8551,
              -4776
            ]
          ],
          'id': '13033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4038,
              8552,
              8553,
              -8170,
              8554,
              8555
            ]
          ],
          'id': '01081'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8556,
              -6105,
              -3791,
              8557,
              8558,
              8559,
              8560
            ]
          ],
          'id': '48409'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7122,
              -8106,
              -2749
            ]
          ],
          'id': '06043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7658,
              8561,
              -8524,
              -6277,
              8562,
              8563,
              -6231
            ]
          ],
          'id': '29147'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1369,
              -1376,
              -3258,
              -1190,
              -3230,
              -2825
            ]
          ],
          'id': '17025'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                8564
              ]
            ],
            [
              [
                8565
              ]
            ],
            [
              [
                8566
              ]
            ],
            [
              [
                8567
              ]
            ],
            [
              [
                -57,
                8568,
                -3186,
                8569
              ]
            ]
          ],
          'id': '02130'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8570,
              -1444,
              8571,
              -2089
            ]
          ],
          'id': '02282'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2203,
              -1904,
              8572,
              -487,
              -8456
            ]
          ],
          'id': '18001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8573,
              -1211,
              -5319,
              8574,
              8575
            ]
          ],
          'id': '08017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6513,
              8576,
              -5070,
              8577,
              -5972
            ]
          ],
          'id': '47173'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -184,
              8578,
              -3004,
              8579,
              -8415,
              -3513,
              8580
            ]
          ],
          'id': '17183'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8581,
              8582
            ]
          ],
          'id': '53009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8583,
              8584,
              8585,
              -8027,
              -7113,
              8586
            ]
          ],
          'id': '53027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8587,
              8588,
              -2499,
              8589,
              -7928
            ]
          ],
          'id': '12109'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8582,
              8590,
              8591,
              -8584,
              8592
            ]
          ],
          'id': '53031'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                8593
              ]
            ],
            [
              [
                -7950,
                8594
              ]
            ]
          ],
          'id': '06041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7092,
              -8325,
              -5180,
              8595,
              -7067,
              8596,
              8597,
              8598
            ]
          ],
          'id': '51053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4783,
              -1253,
              8599,
              -5283
            ]
          ],
          'id': '17129'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4376,
              -6015,
              8600,
              -7281,
              -7767,
              -7688
            ]
          ],
          'id': '08081'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7299,
              8601,
              -8487,
              -5364,
              -4058
            ]
          ],
          'id': '16041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6533,
              -8040,
              8602,
              -8198,
              8603,
              -3997
            ]
          ],
          'id': '06101'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7714,
              -8209,
              -6400,
              -8261,
              -6919,
              -840,
              -4335
            ]
          ],
          'id': '39081'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7512,
              -191,
              8604,
              -6954,
              8605
            ]
          ],
          'id': '35009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2880,
              8606,
              -5347,
              8607,
              8608
            ]
          ],
          'id': '36021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7528,
              8609,
              -2438,
              -3214,
              -7635,
              -6576
            ]
          ],
          'id': '28083'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8266,
              -7808,
              8610,
              -4005,
              8611,
              -2139
            ]
          ],
          'id': '13291'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8612,
              -6927,
              8613,
              8614,
              -5438,
              8615
            ]
          ],
          'id': '39001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4510,
              -8217,
              8616
            ]
          ],
          'id': '34009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4506,
              -12,
              -2004,
              -5054,
              8617
            ]
          ],
          'id': '32003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7698,
              8618,
              8619,
              8620,
              -8233,
              -6633
            ]
          ],
          'id': '20103'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3400,
              -5359,
              -8322,
              -7090
            ]
          ],
          'id': '51145'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4166,
              8621,
              8622,
              8623,
              8624,
              -1105,
              -3811
            ]
          ],
          'id': '53043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8625,
              8626,
              -640,
              8627,
              8628,
              -8585,
              -8592
            ]
          ],
          'id': '53045'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                8629
              ]
            ],
            [
              [
                8630
              ]
            ],
            [
              [
                8631
              ]
            ],
            [
              [
                8632
              ]
            ]
          ],
          'id': '53055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8633,
              -3250,
              8634,
              8635,
              8636
            ]
          ],
          'id': '17133'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1795,
              8637,
              8638,
              8639,
              -7132,
              8640
            ]
          ],
          'id': '08097'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8641,
              -8149,
              -979,
              8642,
              -567
            ]
          ],
          'id': '06035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3575,
              -2916,
              -2213,
              -2170,
              -289
            ]
          ],
          'id': '19101'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8643,
              -5320,
              -2906,
              -7232,
              -3369,
              8644
            ]
          ],
          'id': '08099'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -732,
              -4197,
              -8382,
              -7793,
              8645
            ]
          ],
          'id': '16057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2508,
              8646,
              8647,
              -6477,
              8648
            ]
          ],
          'id': '12097'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8649,
              8650,
              8651,
              -855,
              8652,
              -348
            ]
          ],
          'id': '27171'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6607,
              -2628,
              8653,
              8654,
              -8124,
              8655,
              -219
            ]
          ],
          'id': '13293'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8656,
              8657,
              -7423,
              8658,
              8659
            ]
          ],
          'id': '31049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8660,
              -939,
              -689,
              -187,
              -7511
            ]
          ],
          'id': '48359'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8661,
              -1821,
              8662,
              -1770,
              -3852,
              -5820
            ]
          ],
          'id': '13297'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6619,
              -6339,
              8663,
              8664,
              8665,
              -7198
            ]
          ],
          'id': '13303'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8666,
              -7451,
              8667,
              8668,
              8669
            ]
          ],
          'id': '34013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8670,
              8671,
              8672,
              -4821,
              8673,
              8674,
              -5258
            ]
          ],
          'id': '13305'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8675,
              -7238,
              -5159,
              -3251,
              -8634,
              8676,
              -3891
            ]
          ],
          'id': '29189'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7552,
              -18,
              8677,
              8678,
              -4852
            ]
          ],
          'id': '22063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3387,
              -5264,
              -4952,
              -2768,
              -6603
            ]
          ],
          'id': '01001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8104,
              -8173,
              8679,
              8680,
              8681,
              8682,
              -8493,
              8683
            ]
          ],
          'id': '01005'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                8684
              ]
            ],
            [
              [
                8685
              ]
            ],
            [
              [
                8686
              ]
            ],
            [
              [
                -8409,
                -2698,
                8687,
                8688,
                8689,
                8690
              ]
            ]
          ],
          'id': '01097'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8691,
              -1728,
              8692,
              -8623,
              8693
            ]
          ],
          'id': '53065'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                8694
              ]
            ],
            [
              [
                -4169,
                -6246,
                8695
              ]
            ],
            [
              [
                8696
              ]
            ]
          ],
          'id': '53073'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1731,
              8697,
              -3438,
              -3208,
              8698,
              8699,
              8700
            ]
          ],
          'id': '13019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8701,
              -4596,
              -6016,
              -358
            ]
          ],
          'id': '56041'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -1219
              ]
            ],
            [
              [
                8702,
                -8597,
                -7070,
                8703,
                -8481
              ]
            ]
          ],
          'id': '51081'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8356,
              -7558,
              -5034,
              -8085,
              8704,
              -5867,
              -3235
            ]
          ],
          'id': '48371'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3729,
              -7249,
              8705,
              8706,
              -2936,
              -5395
            ]
          ],
          'id': '17161'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1215,
              -2887,
              -8491,
              -8274,
              8707
            ]
          ],
          'id': '39135'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8708,
              -1085,
              8709,
              -801,
              8710,
              -1900
            ]
          ],
          'id': '39137'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8711,
              -8503,
              8712,
              8713,
              -5266
            ]
          ],
          'id': '08111'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2923,
              8714,
              -1912,
              8715
            ]
          ],
          'id': '48385'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2303,
              -1988,
              -5607,
              -6086,
              8716,
              -8402
            ]
          ],
          'id': '30077'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8717,
              8718,
              8719,
              8720,
              -4587,
              8721
            ]
          ],
          'id': '13309'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3088,
              -5822,
              8722,
              -7220,
              -2006
            ]
          ],
          'id': '06065'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7393,
              -1652,
              -506,
              8723,
              8724
            ]
          ],
          'id': '40115'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6896,
              -7764,
              8725,
              -2758,
              8726
            ]
          ],
          'id': '72103'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3689,
              8727,
              8728,
              -1049
            ]
          ],
          'id': '26001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8729,
              -5873,
              -825,
              8730,
              8731,
              -1498
            ]
          ],
          'id': '56043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8732,
              -5027,
              -7989,
              -5014,
              -4760,
              -8422
            ]
          ],
          'id': '48113'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8733,
              -7195,
              8734,
              8735
            ]
          ],
          'id': '72059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -895,
              -2206,
              -3604,
              -2152,
              -5982
            ]
          ],
          'id': '18183'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5422,
              -5404,
              -7494,
              8736,
              -7416,
              -4567
            ]
          ],
          'id': '47047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4874,
              -7799,
              -6419,
              8737,
              -8230,
              -2189,
              -3417
            ]
          ],
          'id': '20141'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7112,
              8738,
              -7011,
              8739,
              8740,
              8741,
              -2129
            ]
          ],
          'id': '72011'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -8741,
                8742,
                -2121,
                -6866,
                -5017,
                -4354,
                8743
              ]
            ],
            [
              [
                8744
              ]
            ],
            [
              [
                8745
              ]
            ]
          ],
          'id': '72097'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2199,
              8746
            ]
          ],
          'id': '60010'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8747,
              -6207,
              -5290,
              -4928,
              -3670,
              -5342,
              8748
            ]
          ],
          'id': '50003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4167,
              -3809,
              -2503,
              -2488
            ]
          ],
          'id': '53017'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -3785,
                8749,
                8750,
                8751
              ]
            ],
            [
              [
                -8559,
                8752,
                8753,
                8754
              ]
            ]
          ],
          'id': '48355'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8755,
              8756,
              8757,
              -2578,
              -5106
            ]
          ],
          'id': '50019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5410,
              -6459,
              8758,
              -7520,
              -3820,
              -562,
              -5413
            ]
          ],
          'id': '54023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8759,
              -5955,
              8760,
              8761,
              -2010
            ]
          ],
          'id': '13073'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2864,
              8762,
              -5727,
              -4614,
              8763,
              -4327,
              -5358
            ]
          ],
          'id': '51085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4535,
              -8260,
              -5786,
              -7955,
              8764,
              -2364,
              -8080,
              8765
            ]
          ],
          'id': '48387'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8766,
              -2107,
              -3580,
              8767,
              8768,
              8769,
              -6925
            ]
          ],
          'id': '39141'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -67,
              8770,
              -8718,
              8771,
              8772,
              -2511
            ]
          ],
          'id': '13091'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6323,
              8773,
              8774,
              -1822,
              -8662,
              -5819,
              -4000
            ]
          ],
          'id': '13135'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6480,
              -2141,
              8775,
              8776,
              8777,
              -6264,
              -6614
            ]
          ],
          'id': '13085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8778,
              -3632,
              8779,
              -7795,
              -3267,
              -8464,
              -2987,
              8780,
              8781
            ]
          ],
          'id': '41063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8665,
              8782,
              -4782,
              8783,
              8784
            ]
          ],
          'id': '13167'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6338,
              8785,
              -2012,
              8786,
              -8548,
              -4775,
              -8783,
              -8664
            ]
          ],
          'id': '13163'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8787,
              8788,
              8789,
              -1692,
              -8490
            ]
          ],
          'id': '39023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8790,
              8791,
              8792,
              8793,
              8794,
              -3753,
              -4443,
              8795
            ]
          ],
          'id': '29069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8796,
              -8346,
              8797,
              -7741,
              -8012
            ]
          ],
          'id': '36019'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -3139
              ]
            ],
            [
              [
                -1282
              ]
            ],
            [
              [
                -7670,
                -7748,
                8798,
                8799,
                -4768,
                8800,
                -1742
              ]
            ]
          ],
          'id': '51163'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5882,
              8801,
              -8159,
              8802
            ]
          ],
          'id': '42099'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8803,
              8804,
              -8792,
              8805,
              -8509
            ]
          ],
          'id': '05021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -172,
              -3763,
              -6217,
              8806
            ]
          ],
          'id': '54037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8807,
              8808,
              8809,
              -2300
            ]
          ],
          'id': '30035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8345,
              -5107,
              -2581,
              8810,
              8811,
              -7742,
              -8798
            ]
          ],
          'id': '50007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8812,
              -2963,
              -4786,
              -4979,
              -6125
            ]
          ],
          'id': '19167'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -722,
              -411,
              -2354,
              -1715,
              -6906,
              -5030
            ]
          ],
          'id': '48083'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2599,
              8813,
              -1104,
              -7711,
              -7039,
              8814,
              -8009
            ]
          ],
          'id': '48401'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8815,
              8816,
              8817,
              8818,
              -5432,
              -8615
            ]
          ],
          'id': '39145'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                8819,
                -1436
              ]
            ],
            [
              [
                8820
              ]
            ],
            [
              [
                8821,
                -1429,
                8822,
                -1433,
                8823,
                -2018
              ]
            ]
          ],
          'id': '02110'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8824,
              8825,
              -7533,
              -7318,
              -3845
            ]
          ],
          'id': '05077'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4816,
              -614,
              8826,
              -8825,
              -3844
            ]
          ],
          'id': '05123'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5605,
              8827,
              -8092,
              -1512
            ]
          ],
          'id': '55079'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8447,
              -2252,
              -2591,
              8828,
              8829,
              -8119,
              8830
            ]
          ],
          'id': '55053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4574,
              -6666,
              -7519,
              8831,
              -8416,
              -4995
            ]
          ],
          'id': '34021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8832,
              -7089,
              -6750,
              -7461,
              -4748
            ]
          ],
          'id': '37009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8833,
              -2136,
              -6735,
              8834,
              -1009
            ]
          ],
          'id': '27167'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2233,
              -3448,
              -341,
              8835,
              8836,
              8837
            ]
          ],
          'id': '38051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8811,
              -2580,
              8838,
              8839,
              8840
            ]
          ],
          'id': '50023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7850,
              -8267,
              -3642,
              8841,
              8842,
              -1061,
              -1663
            ]
          ],
          'id': '31173'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6829,
              8843,
              8844,
              -8151
            ]
          ],
          'id': '32027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8845,
              -8840,
              8846,
              8847,
              -5287
            ]
          ],
          'id': '50017'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                8848
              ]
            ],
            [
              [
                8849
              ]
            ],
            [
              [
                -7125,
                8850
              ]
            ]
          ],
          'id': '55029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -568,
              -8643,
              -978,
              -8038,
              -6531,
              -2222
            ]
          ],
          'id': '06063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6930,
              -3228,
              -4276,
              -94,
              8851,
              -797
            ]
          ],
          'id': '39147'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5527,
              -4916,
              8852,
              -7226,
              8853,
              8854
            ]
          ],
          'id': '13103'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8855,
              -5818,
              8856,
              8857,
              8858,
              -5547,
              -2611
            ]
          ],
          'id': '31161'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -602,
              -269,
              -106,
              -107,
              -1420,
              8859
            ]
          ],
          'id': '46087'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8860,
              -207,
              8861,
              8862,
              8863,
              -2761,
              -4343
            ]
          ],
          'id': '55083'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2420,
              -6336,
              -2815,
              8864
            ]
          ],
          'id': '02068'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7450,
              -4517,
              8865,
              8866,
              8867,
              -8668
            ]
          ],
          'id': '34017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1500,
              8868,
              -8731,
              -829,
              8869,
              -6013,
              -5362,
              -6343
            ]
          ],
          'id': '56013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2781,
              -3758,
              -5452,
              -6488,
              -8526
            ]
          ],
          'id': '29137'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8870,
              -2638,
              8871,
              -3576,
              -2105
            ]
          ],
          'id': '39045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8211,
              -5172,
              8872,
              8873,
              -7944,
              -5500
            ]
          ],
          'id': '05027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8874,
              8875,
              -4469,
              -4119,
              -8002
            ]
          ],
          'id': '55065'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4521,
              8876,
              8877
            ]
          ],
          'id': '36047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1993,
              -1544,
              -7775,
              -5121,
              -6116,
              -2277
            ]
          ],
          'id': '29141'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6270,
              8878,
              -869,
              -7463,
              -5353,
              -7397
            ]
          ],
          'id': '27151'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8879,
              -6150,
              -5742,
              -6055,
              8880,
              -6057,
              8881,
              -3749,
              -8795
            ]
          ],
          'id': '29143'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7855,
              -3169,
              -987,
              -4470,
              -8876,
              8882
            ]
          ],
          'id': '55045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8844,
              -6828,
              8883,
              -5621,
              8884,
              8885
            ]
          ],
          'id': '32015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8886,
              -8154
            ]
          ],
          'id': '32029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7474,
              -6804,
              -2945,
              -4664,
              -4933
            ]
          ],
          'id': '35001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3207,
              -7412,
              -7139,
              8887,
              -8699
            ]
          ],
          'id': '13173'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5788,
              -44,
              -4969,
              -4564,
              -7437,
              -1480,
              8888
            ]
          ],
          'id': '56045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8889,
              -6668,
              -2930,
              8890,
              8891,
              8892
            ]
          ],
          'id': '36009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8893,
              8894,
              -136,
              -7680,
              -2469,
              -143,
              8895
            ]
          ],
          'id': '72127'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8896,
              8897,
              -137,
              -8895
            ]
          ],
          'id': '72139'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2696,
              -1112,
              -1884,
              -1890,
              8898
            ]
          ],
          'id': '19049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8084,
              8899,
              8900,
              -5868,
              -8705
            ]
          ],
          'id': '48443'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8901,
              -7811,
              -6539,
              -1917,
              8902
            ]
          ],
          'id': '13119'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5947,
              -582,
              8903,
              -7284,
              8904
            ]
          ],
          'id': '17199'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1937,
              8905,
              -7777,
              -5910,
              8906,
              -2109
            ]
          ],
          'id': '39155'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1171,
              -1825,
              8907,
              8908,
              -1874,
              8909
            ]
          ],
          'id': '17203'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8714,
              8910,
              -621,
              -6108,
              -4049
            ]
          ],
          'id': '08067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3468,
              -8224,
              -4336,
              -838,
              -1923,
              8911
            ]
          ],
          'id': '39157'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5268,
              -2263,
              -2894,
              -2144,
              -25,
              -6446,
              -4338,
              -6120
            ]
          ],
          'id': '27089'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1787,
              -1763,
              -7935,
              -7851,
              -5763,
              8912
            ]
          ],
          'id': '27115'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5171,
              8913,
              8914,
              -8459,
              8915,
              -8873
            ]
          ],
          'id': '05103'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8916,
              8917,
              -675,
              -8513,
              -4273,
              8918
            ]
          ],
          'id': '39093'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8919,
              -6601,
              8920,
              -6373,
              8921,
              -5066
            ]
          ],
          'id': '37021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6176,
              8922,
              -8796,
              -4450,
              -3986,
              -6122
            ]
          ],
          'id': '05031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5929,
              -4260,
              8923,
              -8246,
              -5036,
              -4878
            ]
          ],
          'id': '35005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2563,
              -2613,
              -5550,
              8924,
              -5793,
              -7438
            ]
          ],
          'id': '31165'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8097,
              8925,
              -1956,
              -8457,
              -8915,
              8926
            ]
          ],
          'id': '05039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8927,
              -4203,
              8928,
              -5064,
              -3911,
              -6375,
              8929
            ]
          ],
          'id': '37023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6600,
              -4721,
              8930,
              -8930,
              -6374,
              -8921
            ]
          ],
          'id': '37111'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7652,
              5641,
              -5642,
              -5641,
              -5881,
              -6939
            ]
          ],
          'id': '42109'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8772,
              -8722,
              -4586,
              -3434,
              -3557,
              8931
            ]
          ],
          'id': '13271'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8932,
              -768,
              -7240,
              8933
            ]
          ],
          'id': '12115'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6541,
              -4559,
              -6063,
              -5957,
              8934,
              8935,
              8936,
              -1919
            ]
          ],
          'id': '13105'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8937,
              -8700,
              -8888,
              -7143,
              8938,
              -7631,
              8939
            ]
          ],
          'id': '13185'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -220,
              -8656,
              -8123,
              8940,
              -3582,
              8941,
              8942
            ]
          ],
          'id': '13263'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6880,
              -4683,
              8943,
              -8285,
              -6311
            ]
          ],
          'id': '37047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7469,
              -580,
              -5951,
              -4302,
              -6041,
              -5512,
              -5511,
              5510
            ]
          ],
          'id': '17069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8777,
              8944,
              -4008,
              8945,
              8946,
              8947,
              -8775,
              8948
            ]
          ],
          'id': '13139'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8949,
              -5490,
              -6642,
              -4538,
              -3755,
              8950
            ]
          ],
          'id': '17001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8951,
              8952,
              -2180,
              8953,
              -69,
              -2510,
              -1958,
              -7942
            ]
          ],
          'id': '13153'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8954,
              -5273,
              -4218,
              8955
            ]
          ],
          'id': '48457'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6225,
              -7353,
              -7678,
              -5376,
              -7406,
              -1767
            ]
          ],
          'id': '12041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -857,
              8956,
              8957,
              -1943,
              -3161,
              -3240
            ]
          ],
          'id': '27139'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3212,
              -3106,
              8958,
              -3286,
              -2942,
              -7614,
              -7636
            ]
          ],
          'id': '28007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8770,
              8959,
              -8816,
              -8614,
              -6926
            ]
          ],
          'id': '39131'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6949,
              6947,
              -6947,
              -2245,
              -7035,
              -3201,
              -6093
            ]
          ],
          'id': '46095'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8960,
              8961,
              -8893,
              8962,
              -4894
            ]
          ],
          'id': '36013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8132,
              -8067,
              8963,
              8964,
              8965,
              -5723,
              -8763,
              -2863
            ]
          ],
          'id': '51177'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2327,
              -6660,
              8966,
              -8511,
              -8175,
              -4453,
              -8193
            ]
          ],
          'id': '29149'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7518,
              8967,
              -7427,
              -8417,
              -8832
            ]
          ],
          'id': '34025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8818,
              8968,
              -3974,
              -6526,
              8969,
              -6058,
              8970
            ]
          ],
          'id': '39087'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4498,
              8971,
              -5140,
              8972,
              -1666,
              -4108,
              -5506
            ]
          ],
          'id': '26103'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8973,
              -5259,
              -8675,
              8974,
              -6484
            ]
          ],
          'id': '13229'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                8975
              ]
            ],
            [
              [
                8976
              ]
            ]
          ],
          'id': '15007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3175,
              -5111,
              -5079,
              8977,
              -8339,
              -6073,
              -3520,
              -6681
            ]
          ],
          'id': '42033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2893,
              -7392,
              -7502,
              -2248,
              -29,
              -2146
            ]
          ],
          'id': '27029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8978,
              -3558,
              -3432,
              -8698,
              -1730
            ]
          ],
          'id': '13155'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8979,
              -1790,
              -6427,
              8980
            ]
          ],
          'id': '27035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -305,
              -5126,
              -5132,
              8981,
              -7846,
              -4653,
              -3587,
              -2566
            ]
          ],
          'id': '30087'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -678,
              -1895,
              -8222,
              -3466,
              -8514
            ]
          ],
          'id': '39169'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -624,
              -4820,
              8982,
              8983,
              -7273
            ]
          ],
          'id': '12051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8935,
              -5956,
              -8760,
              -2009,
              8984
            ]
          ],
          'id': '13181'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4485,
              8985,
              -8672,
              8986
            ]
          ],
          'id': '13183'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7253,
              -2792,
              8987,
              -4647,
              -6102,
              -1671
            ]
          ],
          'id': '48469'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1908,
              8988,
              8989,
              -7169,
              8990,
              -7342,
              8991
            ]
          ],
          'id': '39025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1011,
              8992,
              -7398,
              -5704,
              8993,
              -755
            ]
          ],
          'id': '46109'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4973,
              -6094,
              -355,
              -8856,
              -2610,
              -2561,
              -4562
            ]
          ],
          'id': '46102'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6857,
              8994,
              -3426,
              -3975,
              -7754
            ]
          ],
          'id': '54067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              8995,
              -7006,
              8996,
              8997,
              8998
            ]
          ],
          'id': '72071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7010,
              8999,
              -2116,
              -8743,
              -8740
            ]
          ],
          'id': '72083'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9000,
              9001,
              -7007,
              -8996
            ]
          ],
          'id': '72115'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7009,
              9002,
              9003,
              -7105,
              -7197,
              9004,
              -2117,
              -9000
            ]
          ],
          'id': '72081'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9005,
              9006,
              -7761,
              -6894
            ]
          ],
          'id': '72089'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7194,
              -6960,
              9007,
              -8735
            ]
          ],
          'id': '72111'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5631,
              -7654,
              -996,
              9008,
              9009
            ]
          ],
          'id': '33017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3471,
              -2284,
              -3555,
              -8512,
              -3367,
              -3358,
              -6611
            ]
          ],
          'id': '05045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9010,
              -8636,
              9011,
              -7377,
              9012
            ]
          ],
          'id': '29186'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6166,
              -3648,
              -3738,
              -7205,
              -2535
            ]
          ],
          'id': '31153'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8130,
              9013,
              9014,
              -1523,
              -5724,
              -8966,
              9015,
              -8964,
              -8066
            ]
          ],
          'id': '51179'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9016,
              -5931,
              -4271,
              -6979,
              -3308,
              -716,
              -1782
            ]
          ],
          'id': '38089'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5835,
              9017,
              9018,
              9019,
              9020,
              9021,
              9022
            ]
          ],
          'id': '47051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -496,
              -2169,
              -5293,
              -6500,
              9023
            ]
          ],
          'id': '38101'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9024,
              -684,
              9025,
              -7975,
              9026,
              -9019
            ]
          ],
          'id': '47115'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9027,
              -7684,
              -5736,
              -5714,
              -7639,
              -1944,
              -8958
            ]
          ],
          'id': '27037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4239,
              -8455,
              -491,
              9028,
              -3079,
              -6626
            ]
          ],
          'id': '18035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7496,
              -2911,
              -1785,
              9029,
              -2890
            ]
          ],
          'id': '27061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8729,
              9030,
              -3252,
              -787
            ]
          ],
          'id': '26069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3451,
              9031,
              9032,
              -6559,
              9033
            ]
          ],
          'id': '20159'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9034,
              -7488,
              -5898,
              9035,
              -8620
            ]
          ],
          'id': '20209'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9036,
              -5579,
              -559,
              -936,
              -2754,
              -3779,
              9037
            ]
          ],
          'id': '48479'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8342,
              9038,
              -6912,
              -6153,
              9039,
              9040
            ]
          ],
          'id': '48481'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2627,
              -2586,
              9041,
              -887,
              -2178,
              9042,
              -8654
            ]
          ],
          'id': '13207'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1820,
              -652,
              9043,
              -6392,
              -1771,
              -8663
            ]
          ],
          'id': '13219'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7936,
              9044,
              -8952,
              -7941,
              -8122
            ]
          ],
          'id': '13225'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9045,
              9046,
              9047,
              -8681
            ]
          ],
          'id': '13239'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3469,
              -8912,
              -1922,
              9048,
              -2635,
              -951
            ]
          ],
          'id': '39031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9047,
              9049,
              -6623,
              9050,
              -1850,
              9051
            ]
          ],
          'id': '13243'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3317,
              -2474,
              -6897,
              -8727,
              -2757,
              9052,
              -1752
            ]
          ],
          'id': '72085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9053,
              -7760,
              9054,
              -6528,
              9055
            ]
          ],
          'id': '54079'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7119,
              -7752,
              9056,
              -4937,
              -2448,
              -8407
            ]
          ],
          'id': '54109'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6869,
              -4922,
              9057,
              9058,
              -6380,
              -7473
            ]
          ],
          'id': '34037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9059,
              -3627,
              -8227,
              -3383,
              -6332,
              -8313
            ]
          ],
          'id': '01007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9060,
              -6297,
              -4959,
              9061,
              9062,
              -6429
            ]
          ],
          'id': '28057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7575,
              9063,
              -8951,
              -3754,
              -2779,
              9064
            ]
          ],
          'id': '29111'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5289,
              9065,
              9066,
              9067,
              9068,
              -4926
            ]
          ],
          'id': '33019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2195,
              -3269,
              -1646,
              9069,
              9070,
              9071,
              -2166
            ]
          ],
          'id': '38069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9072,
              9073,
              -3741,
              9074,
              -8877,
              -4520
            ]
          ],
          'id': '36081'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8034,
              -1283,
              -8033,
              -6239,
              -3599,
              -2667,
              9075,
              -815
            ]
          ],
          'id': '37033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9076,
              -5420,
              -5509,
              -3691
            ]
          ],
          'id': '26131'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4853,
              -8679,
              9077,
              -8472,
              -7858,
              9078
            ]
          ],
          'id': '22005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9079,
              -6479,
              -622,
              -766,
              -1897
            ]
          ],
          'id': '12055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6378,
              -4718,
              -1066,
              -3952,
              -8922
            ]
          ],
          'id': '37089'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1154,
              -3336,
              -1297,
              -1180,
              -2818,
              -3646
            ]
          ],
          'id': '19029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8790,
              9080,
              -6679,
              9081,
              -2103,
              9082,
              -1693
            ]
          ],
          'id': '39097'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9083,
              9084,
              -3215,
              -6478,
              -8648
            ]
          ],
          'id': '12061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9085,
              -7817,
              -7909,
              -5044,
              -4462,
              9086
            ]
          ],
          'id': '05131'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8462,
              9087,
              -3005,
              -8579,
              -183
            ]
          ],
          'id': '17075'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8172,
              -3584,
              9088,
              -6624,
              -9050,
              -9046,
              -8680
            ]
          ],
          'id': '13259'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9089,
              9090,
              -1939,
              -1892,
              -676,
              -8918
            ]
          ],
          'id': '39035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3853,
              -1774,
              9091,
              -881,
              -9042,
              -2585
            ]
          ],
          'id': '13159'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6265,
              -8778,
              -8949,
              -8774,
              -6322
            ]
          ],
          'id': '13117'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9092,
              9093,
              -5546,
              -8220,
              9094,
              -6826,
              9095
            ]
          ],
          'id': '16073'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9096,
              9097,
              -3994,
              -8107,
              -210,
              9098,
              9099
            ]
          ],
          'id': '06085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9100,
              -4858,
              -7773,
              9101,
              -3883,
              9102,
              -6562
            ]
          ],
          'id': '22079'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -90,
              -6430,
              -9063,
              9103,
              -8314,
              9104,
              9105
            ]
          ],
          'id': '28095'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9106,
              -4997,
              -8419,
              9107,
              9108,
              -6448
            ]
          ],
          'id': '42101'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9109,
              -9009,
              -995,
              9110,
              -7590,
              9111
            ]
          ],
          'id': '33015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9112,
              9113,
              -8749,
              -5341,
              -8607,
              -6320
            ]
          ],
          'id': '36083'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5063,
              9114,
              -4903,
              -3913
            ]
          ],
          'id': '37071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9115,
              -6654,
              9116,
              -6151,
              -8880,
              -8794,
              9117
            ]
          ],
          'id': '29207'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8858,
              9118,
              -922,
              9119,
              -8657,
              9120,
              9121
            ]
          ],
          'id': '31069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4950,
              -8105,
              -8684,
              -8492,
              -1830,
              -8484
            ]
          ],
          'id': '01109'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4895,
              -8963,
              -8892,
              9122,
              -5109,
              -5216,
              -1681,
              -7776
            ]
          ],
          'id': '42123'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1325,
              -2550,
              -7395,
              9123,
              -5008,
              9124
            ]
          ],
          'id': '20099'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1891,
              -526,
              -5919,
              -5328,
              -1166
            ]
          ],
          'id': '19039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9125,
              -8724,
              -505,
              -4233,
              -7803,
              -2236,
              9126
            ]
          ],
          'id': '40041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9127,
              -7415,
              -5318,
              -3133,
              -1577,
              9128
            ]
          ],
          'id': '18141'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9129,
              -7186,
              -6851
            ]
          ],
          'id': '37177'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7134,
              -6476,
              -4774,
              -616,
              -8911,
              -8713,
              -8502
            ]
          ],
          'id': '08053'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -8751,
                9130,
                -6514,
                9131
              ]
            ],
            [
              [
                -8754,
                9132,
                -6518,
                -130,
                9133
              ]
            ]
          ],
          'id': '48273'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3617,
              -7545,
              9134,
              -6887,
              9135,
              -1285,
              9136,
              9137
            ]
          ],
          'id': '51035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2990,
              9138,
              -7404,
              9139,
              -9096,
              -6825,
              -4367,
              -2099
            ]
          ],
          'id': '41045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9140,
              9141,
              -4847,
              9142,
              9143
            ]
          ],
          'id': '24009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5143,
              -5595,
              -5842,
              -5150,
              -5581
            ]
          ],
          'id': '21071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6780,
              -6726,
              -4163,
              9144,
              9145,
              9146,
              9147,
              -6914,
              9148,
              9149
            ]
          ],
          'id': '48201'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8110,
              -2290,
              -4581,
              9150
            ]
          ],
          'id': '51700'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8865,
              -2814,
              -2086,
              9151,
              9152,
              9153,
              -4960,
              -2421
            ]
          ],
          'id': '02170'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4605,
              -5175,
              -5166,
              -8210,
              9154,
              -3349
            ]
          ],
          'id': '05057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7369,
              -7418,
              -6432,
              9155,
              -7531
            ]
          ],
          'id': '28137'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9156,
              -8867,
              9157,
              -7516
            ]
          ],
          'id': '36085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2167,
              -9072,
              9158,
              9159,
              9160,
              -5294
            ]
          ],
          'id': '38083'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9161,
              -2881,
              -8609,
              9162,
              -4917,
              -8158
            ]
          ],
          'id': '36111'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2972,
              -1309,
              -4674,
              -6005,
              9163
            ]
          ],
          'id': '37059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -513,
              9164,
              -6965,
              -7056,
              -5015,
              -280
            ]
          ],
          'id': '48197'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6030,
              -7653,
              -3944,
              -2247,
              -6946,
              9165
            ]
          ],
          'id': '46117'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9166,
              -2445,
              9167,
              -1591,
              -1699,
              -7920
            ]
          ],
          'id': '29079'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6678,
              -1933,
              -2639,
              -8871,
              -2104,
              -9082
            ]
          ],
          'id': '39049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8039,
              -2608,
              -8156,
              9168,
              -8453,
              -1276,
              -8199,
              -8603
            ]
          ],
          'id': '06061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8621,
              -9036,
              -5902,
              -8329,
              -4080,
              -8234
            ]
          ],
          'id': '20091'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5345,
              -6200,
              9169,
              -7330,
              -8190,
              9170
            ]
          ],
          'id': '09005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1832,
              -8496,
              9171,
              9172,
              9173,
              -2875,
              9174
            ]
          ],
          'id': '01061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9175,
              -7312,
              -7985,
              9176,
              -9172,
              -8495
            ]
          ],
          'id': '01069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6386,
              9177,
              9178,
              -9137,
              -1286,
              -9136,
              -6886,
              -7088,
              -8833,
              -4747
            ]
          ],
          'id': '51077'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1031,
              -2959,
              -5255,
              -3330,
              -1212,
              -8574,
              9179
            ]
          ],
          'id': '08063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3641,
              -3320,
              -7504,
              9180,
              -8842
            ]
          ],
          'id': '19133'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8326,
              -5749,
              -6565,
              9181,
              -5572,
              -3794,
              -5272
            ]
          ],
          'id': '48351'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9182,
              9183,
              9184,
              -6617,
              -6394
            ]
          ],
          'id': '13265'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -539,
              -1942,
              -6961,
              -9165,
              -512,
              9185
            ]
          ],
          'id': '40057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4763,
              9186,
              9187,
              -960,
              -4323
            ]
          ],
          'id': '48349'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9188,
              -4780,
              9189,
              -5256,
              -4589
            ]
          ],
          'id': '13279'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2998,
              9190,
              -9013,
              -7376,
              -4248,
              -3608
            ]
          ],
          'id': '29187'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9191,
              -4156,
              -7509,
              -4668,
              -6820
            ]
          ],
          'id': '35021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4687,
              -1533,
              -1477,
              -8376,
              9192
            ]
          ],
          'id': '30097'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9193,
              9194,
              -6598,
              -4704,
              -6774,
              -5804
            ]
          ],
          'id': '21155'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8335,
              -8381,
              9195,
              -5831,
              9196,
              9197,
              -7784
            ]
          ],
          'id': '47149'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                9198
              ]
            ],
            [
              [
                9199,
                -6247,
                -2498,
                -2481,
                9200,
                9201
              ]
            ]
          ],
          'id': '53061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6289,
              -2461,
              -7487,
              -9035,
              -8619,
              -7697
            ]
          ],
          'id': '29165'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8276,
              -1909,
              -8992,
              -7345,
              9202,
              9203,
              9204
            ]
          ],
          'id': '39061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7155,
              -5005,
              -7786,
              -5566,
              -1456,
              -5540
            ]
          ],
          'id': '47081'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4765,
              -4743,
              9205,
              -7055,
              -260,
              -1116
            ]
          ],
          'id': '48337'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5686,
              -8474,
              -7691,
              -6098,
              -5694
            ]
          ],
          'id': '49007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7844,
              -3260,
              -3124,
              -6423,
              -658,
              -3441
            ]
          ],
          'id': '20041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2525,
              -8463,
              -181,
              9206,
              -8908,
              -1824
            ]
          ],
          'id': '17105'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5047,
              -2269,
              -3473,
              -6613,
              9207,
              -3502,
              -4464
            ]
          ],
          'id': '05149'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5812,
              -7313,
              -4086,
              -2674
            ]
          ],
          'id': '16065'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3590,
              -646,
              -222,
              9208,
              -4036,
              -7646
            ]
          ],
          'id': '13285'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9209,
              -1898,
              -764,
              -8933,
              9210
            ]
          ],
          'id': '12081'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                9211,
                9212,
                9213,
                -8047,
                9214
              ]
            ],
            [
              [
                9215
              ]
            ],
            [
              [
                9216,
                9217
              ]
            ]
          ],
          'id': '51001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -885,
              9218,
              -65,
              -8954,
              -2179
            ]
          ],
          'id': '13289'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5486,
              -7401,
              -998,
              -5650,
              9219
            ]
          ],
          'id': '24035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3674,
              -8272,
              -6196,
              -5343
            ]
          ],
          'id': '25015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4547,
              -5397,
              -6542,
              -3220,
              9220,
              9221
            ]
          ],
          'id': '17071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9222,
              -9127,
              -2235,
              -3923,
              9223
            ]
          ],
          'id': '40097'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5179,
              -8324,
              -2935,
              -8323,
              -7029,
              -6255,
              -7068,
              -8596
            ]
          ],
          'id': '51149'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7449,
              -7456,
              9224,
              -9073,
              -4519
            ]
          ],
          'id': '36005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3505,
              -8098,
              -8927,
              -8914,
              -5170,
              5168,
              -5168,
              -5174
            ]
          ],
          'id': '05019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -799,
              9225,
              -1812,
              -6677,
              -6674,
              -6754,
              9226
            ]
          ],
          'id': '39065'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6287,
              -1416,
              -556,
              -5578,
              -975
            ]
          ],
          'id': '48163'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9208,
              -6612,
              -2542,
              -8095,
              -3503
            ]
          ],
          'id': '05051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -156,
              -5640,
              -1600,
              -7302,
              -5253,
              -2957
            ]
          ],
          'id': '31057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9227,
              -5530,
              -6457,
              -2538,
              -970,
              -925
            ]
          ],
          'id': '31023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7690,
              -1797,
              9228,
              -1231,
              -6099
            ]
          ],
          'id': '49019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8764,
              -4613,
              -6147,
              -8108,
              -7026,
              -4328
            ]
          ],
          'id': '51127'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9062,
              -4958,
              -2995,
              -8370,
              -2977,
              -8315,
              -9104
            ]
          ],
          'id': '01093'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8810,
              9229,
              -753,
              -6800,
              -5976,
              -2301
            ]
          ],
          'id': '30073'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8155,
              9230,
              -8450,
              -9169
            ]
          ],
          'id': '32510'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9231,
              9232,
              -5371,
              -7677
            ]
          ],
          'id': '12125'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -9152,
                -2092,
                9233,
                9234
              ]
            ],
            [
              [
                9235
              ]
            ]
          ],
          'id': '02020'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7554,
              -3693,
              -5508,
              9236,
              9237,
              -4189
            ]
          ],
          'id': '55125'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9238,
              -2606,
              -3283,
              -8959,
              -3105
            ]
          ],
          'id': '28019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2380,
              9239,
              -8235,
              -7443
            ]
          ],
          'id': '31169'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -773,
              9240,
              -515,
              9241,
              -62,
              -5813
            ]
          ],
          'id': '13223'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9242,
              -8533,
              -8479,
              -8529,
              -4501,
              9243,
              -5619
            ]
          ],
          'id': '32033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9244,
              9245,
              -1100,
              -8814,
              -2598,
              -3111
            ]
          ],
          'id': '48203'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6325,
              -6358,
              9246,
              -644
            ]
          ],
          'id': '13113'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7606,
              -6627,
              -3083,
              9247,
              -1582,
              -7610
            ]
          ],
          'id': '18059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7771,
              -6647,
              9248,
              -8019,
              -8008,
              9249
            ]
          ],
          'id': '22025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9250,
              -7343,
              -8991,
              -7173,
              -6696,
              9251
            ]
          ],
          'id': '21191'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3618,
              -9138,
              -9179,
              9252,
              -7065
            ]
          ],
          'id': '51197'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9253,
              9254,
              -6861,
              -5874,
              -8730,
              -1497
            ]
          ],
          'id': '56003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3773,
              -7020,
              -6031,
              9255,
              -6590
            ]
          ],
          'id': '46137'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                9256
              ]
            ],
            [
              [
                9257
              ]
            ],
            [
              [
                9258,
                9259
              ]
            ]
          ],
          'id': '25007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8948,
              9260,
              -1921,
              -649,
              -1819
            ]
          ],
          'id': '13157'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5891,
              9261,
              -3006,
              -9088,
              -8461
            ]
          ],
          'id': '18111'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9262,
              -4536,
              -8766,
              -8079,
              9263
            ]
          ],
          'id': '48277'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7389,
              -2891,
              -9030,
              -1784,
              -8980,
              9264,
              -3538,
              -7436
            ]
          ],
          'id': '27021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1981,
              -1613,
              -1996,
              -3484,
              -821
            ]
          ],
          'id': '48153'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3082,
              9265,
              -2855,
              -3860,
              -1583,
              -9248
            ]
          ],
          'id': '18139'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1300,
              -7717,
              -7272,
              -3019,
              -3018,
              -3017,
              3015,
              -3015,
              9266
            ]
          ],
          'id': '06079'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9033,
              9267,
              -5157,
              -4789,
              -6414,
              -2527,
              -6560
            ]
          ],
          'id': '20155'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3180,
              -1042,
              -2695,
              -2686,
              -3595
            ]
          ],
          'id': '19025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1788,
              -8913,
              -664,
              -6424
            ]
          ],
          'id': '27065'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5078,
              -8042,
              -6991,
              -7651,
              -8337,
              -8978
            ]
          ],
          'id': '42035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3329,
              -902,
              9268,
              -2255,
              -3145,
              -1208
            ]
          ],
          'id': '20109'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1907,
              -1695,
              9269,
              -6923,
              9270,
              -8989
            ]
          ],
          'id': '39027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8711,
              -800,
              -9227,
              -6753,
              -1901
            ]
          ],
          'id': '39003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4344,
              -2762,
              -8864,
              9271,
              -6975,
              -834,
              -2022
            ]
          ],
          'id': '55115'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2238,
              -7805,
              -7818,
              -9086,
              9272,
              -8202,
              -8515
            ]
          ],
          'id': '40135'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6996,
              -8287,
              -6049,
              9273,
              9274,
              9275,
              -810,
              9276,
              -6993,
              9277
            ]
          ],
          'id': '47035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9278,
              -6390,
              -4650,
              -5814,
              -64,
              9279,
              -7644,
              -3634
            ]
          ],
          'id': '01029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -84,
              -7317,
              9280,
              -7365,
              9281
            ]
          ],
          'id': '26099'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8444,
              -86,
              9282,
              -6567,
              -8441,
              -3034
            ]
          ],
          'id': '26049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3168,
              9283,
              -4870,
              -1140,
              -989
            ]
          ],
          'id': '17007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4025,
              -5477,
              -6502,
              9284,
              -1780,
              -8446,
              -3745
            ]
          ],
          'id': '38053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7544,
              -7695,
              -4578,
              -3047,
              -6888,
              -9135
            ]
          ],
          'id': '51141'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7287,
              -8507,
              9285,
              -5737,
              -6149,
              9286
            ]
          ],
          'id': '17003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7209,
              -4606,
              -3348,
              -8259
            ]
          ],
          'id': '05133'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6444,
              9287,
              -8690,
              9288,
              -451
            ]
          ],
          'id': '28039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6664,
              9289,
              -8669,
              -8868,
              -9157,
              -7515
            ]
          ],
          'id': '34039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4121,
              -4471,
              -4022,
              9290,
              9291,
              9292
            ]
          ],
          'id': '17015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3391,
              9293,
              -3559,
              -8979,
              -1729,
              9294
            ]
          ],
          'id': '13287'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8500,
              9295,
              -9100,
              9296,
              9297
            ]
          ],
          'id': '06081'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9298,
              9299,
              -8854,
              -7225,
              -3073,
              9300,
              -4778
            ]
          ],
          'id': '13031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4831,
              -4122,
              -9293,
              9301,
              -2682
            ]
          ],
          'id': '19097'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2160,
              -8504,
              -8712,
              -5265,
              -1233
            ]
          ],
          'id': '08113'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3780,
              -2755,
              -133,
              -8046,
              9302
            ]
          ],
          'id': '48427'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2140,
              -8612,
              -4009,
              -8945,
              -8776
            ]
          ],
          'id': '13187'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9059,
              9303,
              -8670,
              -9290,
              -6663,
              -4572,
              -6381
            ]
          ],
          'id': '34027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9304,
              -2800,
              -2377,
              -7826,
              -4214,
              -1602,
              -5639
            ]
          ],
          'id': '31063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7108,
              -4348,
              -8449,
              -6327,
              -5711,
              -5878
            ]
          ],
          'id': '55033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6157,
              9305,
              -2871,
              -2918,
              -249
            ]
          ],
          'id': '48429'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9247,
              -6357,
              -8101,
              -2588,
              -2626,
              -6606,
              -217,
              -645
            ]
          ],
          'id': '13255'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3142,
              -7484,
              -3720,
              9306,
              -6908
            ]
          ],
          'id': '39051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -479,
              -5402,
              -3863,
              -2821,
              9307
            ]
          ],
          'id': '19037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8605,
              -190,
              -2642,
              -2872,
              -6955
            ]
          ],
          'id': '48369'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2183,
              -1754,
              9308,
              -3603,
              9309,
              -3001,
              -5615
            ]
          ],
          'id': '72109'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5908,
              -1684,
              -5213,
              -5057,
              -3934,
              -1016,
              -5904
            ]
          ],
          'id': '42019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9310,
              -1637,
              9311,
              9312,
              -8757
            ]
          ],
          'id': '50009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2688,
              -2697,
              -8899,
              -1295,
              -3335
            ]
          ],
          'id': '19077'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9095,
              -8219,
              -3381,
              -7051,
              -8531,
              -9243,
              -5618,
              -8884,
              -6827
            ]
          ],
          'id': '32007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9313,
              -9021,
              9314,
              -8054,
              -2406,
              -7831
            ]
          ],
          'id': '01089'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4041,
              -8452,
              9315,
              -4636,
              -2665,
              -5052,
              -1158,
              -7123,
              -2747
            ]
          ],
          'id': '06051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7221,
              -8723,
              -5824,
              9316
            ]
          ],
          'id': '06073'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4662,
              -6498,
              -5388,
              -592,
              -594,
              -3095
            ]
          ],
          'id': '31115'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8925,
              -5549,
              9317,
              9318,
              -5794
            ]
          ],
          'id': '31157'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -718,
              -3310,
              -6978,
              -5986,
              -3771,
              -6969,
              -8445
            ]
          ],
          'id': '38001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1193,
              -5199,
              9319,
              9320,
              -4228,
              -6296,
              9321,
              -5496
            ]
          ],
          'id': '47071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7956,
              -5994,
              9322,
              -9245,
              -3110
            ]
          ],
          'id': '48315'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7807,
              9323,
              9324,
              -4006,
              -8611
            ]
          ],
          'id': '13281'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9204,
              9325,
              9326,
              -6872,
              -7433,
              -4515,
              9327
            ]
          ],
          'id': '21015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9328,
              -1336,
              -7414,
              9329,
              9330
            ]
          ],
          'id': '26159'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8083,
              -1738,
              9331,
              -4379,
              9332,
              -8900
            ]
          ],
          'id': '48465'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7199,
              -8666,
              -8785,
              9333,
              -9219,
              -884
            ]
          ],
          'id': '13319'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3393,
              9334,
              -7979,
              9335,
              -198
            ]
          ],
          'id': '13177'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9336,
              -3076,
              -4486,
              -8987,
              -8671,
              -5257,
              -9190
            ]
          ],
          'id': '13267'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9337,
              -3700,
              -3663,
              9338,
              -5019,
              -5669
            ]
          ],
          'id': '23011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5776,
              -1364,
              9339,
              -229,
              -7229
            ]
          ],
          'id': '19189'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5682,
              -2741,
              -5653,
              -3824
            ]
          ],
          'id': '19059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5229,
              -4433,
              -1265,
              9340,
              -4859,
              -9101,
              -6561,
              -5747
            ]
          ],
          'id': '22069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9341,
              9342,
              -158,
              -8398
            ]
          ],
          'id': '72017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8857,
              -5817,
              9343,
              -918,
              -9119
            ]
          ],
          'id': '31075'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7571,
              -8249,
              -8014,
              -9249,
              -6646
            ]
          ],
          'id': '22041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8941,
              -8126,
              -8050,
              -193,
              -6621,
              -9089,
              -3583
            ]
          ],
          'id': '13197'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7069,
              -6258,
              -6008,
              -4400,
              -6012,
              -8350,
              -8114,
              -6720,
              -8482,
              -8704
            ]
          ],
          'id': '51175'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8448,
              -8831,
              -8118,
              9344,
              -6999
            ]
          ],
          'id': '55121'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9345,
              9346,
              -8236,
              -7947
            ]
          ],
          'id': '06055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3841,
              -8240,
              -1280,
              -6115,
              -3552,
              -2282
            ]
          ],
          'id': '05137'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1378,
              -6425,
              -667,
              9347,
              9348,
              -8651,
              9349
            ]
          ],
          'id': '27141'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4882,
              -7994,
              9350,
              -7648
            ]
          ],
          'id': '48141'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -173,
              -8807,
              -8372,
              -8408
            ]
          ],
          'id': '54003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9351,
              -6837,
              -4429,
              9352,
              -7596,
              -321
            ]
          ],
          'id': '21141'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -468,
              -2323,
              -724,
              -254,
              -2331
            ]
          ],
          'id': '48081'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8769,
              9353,
              -3970,
              -8969,
              -8817,
              -8960
            ]
          ],
          'id': '39079'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4824,
              9354,
              -7623,
              -5218,
              9355
            ]
          ],
          'id': '13039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4750,
              -7462,
              -4204,
              -8928,
              -8931,
              -4720,
              -7594
            ]
          ],
          'id': '37011'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                9356
              ]
            ],
            [
              [
                9357
              ]
            ],
            [
              [
                9358
              ]
            ],
            [
              [
                9359
              ]
            ],
            [
              [
                9360
              ]
            ],
            [
              [
                9361
              ]
            ],
            [
              [
                9362
              ]
            ],
            [
              [
                9363
              ]
            ],
            [
              [
                9364
              ]
            ],
            [
              [
                9365
              ]
            ],
            [
              [
                9366
              ]
            ],
            [
              [
                9367
              ]
            ],
            [
              [
                9368
              ]
            ],
            [
              [
                9369
              ]
            ],
            [
              [
                9370
              ]
            ],
            [
              [
                9371
              ]
            ],
            [
              [
                9372
              ]
            ],
            [
              [
                9373
              ]
            ],
            [
              [
                9374
              ]
            ],
            [
              [
                9375
              ]
            ],
            [
              [
                9376
              ]
            ],
            [
              [
                9377
              ]
            ],
            [
              [
                9378
              ]
            ],
            [
              [
                9379
              ]
            ],
            [
              [
                9380
              ]
            ],
            [
              [
                9381
              ]
            ],
            [
              [
                9382
              ]
            ],
            [
              [
                9383
              ]
            ],
            [
              [
                9384
              ]
            ],
            [
              [
                9385
              ]
            ],
            [
              [
                9386
              ]
            ],
            [
              [
                9387
              ]
            ],
            [
              [
                9388
              ]
            ],
            [
              [
                9389
              ]
            ],
            [
              [
                9390
              ]
            ],
            [
              [
                9391
              ]
            ],
            [
              [
                9392
              ]
            ],
            [
              [
                9393
              ]
            ],
            [
              [
                9394
              ]
            ],
            [
              [
                9395
              ]
            ],
            [
              [
                9396
              ]
            ],
            [
              [
                9397
              ]
            ],
            [
              [
                9398
              ]
            ]
          ],
          'id': '02016'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                9399
              ]
            ],
            [
              [
                9400
              ]
            ],
            [
              [
                9401
              ]
            ],
            [
              [
                9402
              ]
            ],
            [
              [
                -9234,
                -2091,
                9403
              ]
            ],
            [
              [
                9404
              ]
            ],
            [
              [
                9405
              ]
            ],
            [
              [
                9406
              ]
            ],
            [
              [
                -4961,
                -9154,
                9407,
                -2063,
                -2076
              ]
            ]
          ],
          'id': '02122'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7625,
              9408,
              -8588,
              -7927,
              9409
            ]
          ],
          'id': '12031'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                9410
              ]
            ],
            [
              [
                -7704,
                -6452,
                9411
              ]
            ]
          ],
          'id': '44009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6467,
              -8404,
              -6346,
              9412,
              -6535
            ]
          ],
          'id': '08019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9413,
              -2297,
              -8192,
              -4451,
              -8239,
              9414
            ]
          ],
          'id': '29153'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9415,
              -8575,
              -5321,
              -8644,
              9416,
              -2334,
              -8352
            ]
          ],
          'id': '08061'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                9417,
                -7563
              ]
            ],
            [
              [
                -7566,
                9418,
                -8044
              ]
            ]
          ],
          'id': '48061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1537,
              -2298,
              -9414,
              9419,
              -7726,
              -7265,
              -1689
            ]
          ],
          'id': '29213'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1393,
              -7959,
              -3930,
              -7953,
              -2358,
              9420,
              -405
            ]
          ],
          'id': '40017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7880,
              9421,
              -2271,
              -5046,
              -7908
            ]
          ],
          'id': '05071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8882,
              -6056,
              -8881,
              -6054,
              -6128,
              -5767,
              -3750
            ]
          ],
          'id': '47095'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3806,
              -5483,
              -7071,
              -7081,
              -6236,
              -8147
            ]
          ],
          'id': '51037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8510,
              -8806,
              -8791,
              -8923,
              -6175
            ]
          ],
          'id': '05055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9422,
              -7901,
              9423,
              -7887,
              9424
            ]
          ],
          'id': '12129'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9425,
              -3687,
              -1004,
              9426
            ]
          ],
          'id': '26141'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9427,
              -8427,
              -5886,
              -8460,
              -2523,
              -1573
            ]
          ],
          'id': '17197'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9428
            ]
          ],
          'id': '72147'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7758,
              -7755,
              -5693,
              -4938,
              -9057,
              -7751
            ]
          ],
          'id': '54081'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -63,
              -9242,
              -518,
              -6326,
              -648,
              -3589,
              -7645,
              -9280
            ]
          ],
          'id': '13045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9429,
              -8885,
              -5620,
              -9244,
              -4507,
              -8618,
              -5053,
              -2663,
              -4635
            ]
          ],
          'id': '32023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9430,
              -6935,
              9431,
              9432,
              -5699,
              -2796
            ]
          ],
          'id': '55039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2217,
              -4548,
              -9222,
              9433,
              -7573,
              -2172
            ]
          ],
          'id': '19111'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9434,
              9435,
              -9113,
              -6319,
              -8061,
              -7963,
              9436,
              -7877
            ]
          ],
          'id': '36091'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9437,
              -4105,
              9438,
              -6733,
              -851,
              -3885
            ]
          ],
          'id': '22097'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8141,
              9439,
              -2725,
              -4533,
              9440,
              -7916
            ]
          ],
          'id': '40005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7878,
              -9437,
              -7962,
              -4147
            ]
          ],
          'id': '36035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8142,
              -6765,
              -8205,
              -8207,
              -2720,
              -9440,
              -8140
            ]
          ],
          'id': '40121'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3578,
              9441,
              9442,
              -8364,
              -7580,
              -3965,
              9443
            ]
          ],
          'id': '39009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8311,
              -6604,
              -2771,
              -880,
              9444,
              -8307
            ]
          ],
          'id': '01131'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9445,
              9446,
              -6302,
              -5407,
              -5412,
              9447,
              -2424
            ]
          ],
          'id': '42051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9448,
              9449,
              9450,
              -8056,
              -4955,
              -4174,
              -3624,
              -8368
            ]
          ],
          'id': '01009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4413,
              -7168,
              -4054,
              -6482,
              -6615,
              -770,
              -4012
            ]
          ],
          'id': '13129'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9078,
              -8678,
              -17,
              9451,
              -8179,
              -4799,
              -8388,
              -8473
            ]
          ],
          'id': '22095'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5896,
              -7883,
              -7867,
              -7471,
              -5912
            ]
          ],
          'id': '42069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9275,
              9452,
              -5974,
              9453,
              -4316,
              9454,
              -4753,
              9455
            ]
          ],
          'id': '47145'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8898,
              9456,
              -3316,
              -1750,
              -138
            ]
          ],
          'id': '72063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9457,
              -8837,
              9458,
              -6690,
              -7019
            ]
          ],
          'id': '46021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2118,
              -9005,
              -7196,
              -8734,
              9459,
              -7788,
              -3331
            ]
          ],
          'id': '72153'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7355,
              -7348,
              -4855,
              9460,
              -4102
            ]
          ],
          'id': '22121'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4418,
              -7612,
              -1563,
              -7769,
              -6543,
              9461
            ]
          ],
          'id': '18133'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1182,
              -1151,
              -8523,
              -8562,
              -7657
            ]
          ],
          'id': '19173'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3652,
              -8293,
              -2676,
              -4091,
              9462,
              -7301,
              -7660
            ]
          ],
          'id': '16011'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                9463
              ]
            ],
            [
              [
                9464
              ]
            ],
            [
              [
                9465
              ]
            ],
            [
              [
                9466
              ]
            ],
            [
              [
                9467
              ]
            ],
            [
              [
                9468
              ]
            ],
            [
              [
                9469
              ]
            ],
            [
              [
                9470,
                -7555,
                -4187,
                -440,
                -4617
              ]
            ]
          ],
          'id': '55003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7000,
              -9345,
              -8121,
              -5596,
              -8420,
              -3313,
              -7485
            ]
          ],
          'id': '27169'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -1287
              ]
            ],
            [
              [
                9471,
                -7098,
                -7033,
                -2414,
                -5459,
                9472,
                -7522
              ]
            ]
          ],
          'id': '51165'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9473,
              9474,
              -4549,
              -7588
            ]
          ],
          'id': '30019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7585,
              -5339,
              -3822,
              -3423,
              -8164
            ]
          ],
          'id': '54097'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8998,
              9475,
              -7110,
              9476
            ]
          ],
          'id': '72005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9477,
              -4193,
              -2476,
              -9457,
              -8897,
              -8894
            ]
          ],
          'id': '72031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9478,
              -8399,
              -7101,
              -9004,
              9479
            ]
          ],
          'id': '72065'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9480,
              -6781,
              -9150,
              9481,
              -8340,
              -7047
            ]
          ],
          'id': '48473'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1753,
              -9053,
              -2760,
              9482,
              -3601,
              -9309
            ]
          ],
          'id': '72151'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6549,
              -4884,
              -4700,
              -7291,
              -7331
            ]
          ],
          'id': '18147'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8391,
              9483,
              -9427,
              -1003,
              -1598,
              -7477
            ]
          ],
          'id': '26031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9163,
              -8608,
              -5346,
              -9171,
              -8189,
              -8185,
              -4918
            ]
          ],
          'id': '36027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5535,
              -4688,
              -9193,
              -8375,
              9484,
              -1495
            ]
          ],
          'id': '30067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6563,
              -9103,
              -3882,
              -8166,
              9485
            ]
          ],
          'id': '22003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2943,
              -1052,
              -340,
              9486,
              -2964
            ]
          ],
          'id': '28101'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4103,
              -9461,
              -4854,
              -9079,
              -7857,
              -4839,
              9487
            ]
          ],
          'id': '22047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3610,
              -4251,
              -6655,
              -9116,
              9488,
              -6657,
              -8355
            ]
          ],
          'id': '29223'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7907,
              -532,
              -3735,
              -7560,
              -7057,
              -6963
            ]
          ],
          'id': '40141'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -759,
              9489,
              -3716,
              -6310,
              9490,
              -6303,
              -365
            ]
          ],
          'id': '36011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7806,
              -7737,
              -7814,
              9491,
              -9324
            ]
          ],
          'id': '13241'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3988,
              -4449,
              -5423,
              -4570,
              -7371,
              -7530,
              -8826,
              -8827,
              -613
            ]
          ],
          'id': '05035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9173,
              -9177,
              -7984,
              -849,
              -7894,
              -7833,
              -2464,
              -3850,
              9492
            ]
          ],
          'id': '12063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9493,
              -6863,
              -145,
              -2471,
              -7679,
              -3478,
              -4740
            ]
          ],
          'id': '72021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3480,
              -7681,
              -141,
              -2182,
              -1121,
              -3290
            ]
          ],
          'id': '72041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4800,
              -4225,
              -7832,
              -2409,
              9494,
              -2992,
              -4957
            ]
          ],
          'id': '01079'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8468,
              -4311,
              9495,
              9496,
              9497
            ]
          ],
          'id': '21215'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8629,
              9498,
              -639,
              -8028,
              -8586
            ]
          ],
          'id': '53067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9499,
              9500,
              -3678,
              -7551,
              -267,
              -1453
            ]
          ],
          'id': '46011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5834,
              -5840,
              -685,
              -9025,
              -9018
            ]
          ],
          'id': '47061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7062,
              -1673,
              -6101,
              -8557,
              9501
            ]
          ],
          'id': '48025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9502,
              9503,
              -9143,
              -4849,
              9504
            ]
          ],
          'id': '24017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5893,
              -5911,
              -7016,
              -6987,
              9505
            ]
          ],
          'id': '42113'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2292,
              -8109
            ]
          ],
          'id': '51830'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8765,
              -7958,
              9506,
              -2365
            ]
          ],
          'id': '48449'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2366,
              -9507,
              -7957,
              -3108,
              -6704
            ]
          ],
          'id': '48063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9507,
              -5836,
              -9023,
              9508
            ]
          ],
          'id': '47127'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9509,
              -7917,
              -9441,
              -4537,
              -9263,
              9510,
              9511
            ]
          ],
          'id': '40013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2391,
              -116,
              -6782,
              -9481,
              -7046,
              -8063
            ]
          ],
          'id': '48185'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7892,
              7890,
              -7890,
              -2114,
              -7307,
              -7897,
              -9423,
              9512
            ]
          ],
          'id': '12073'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -91,
              -9106,
              9513,
              -2602,
              9514
            ]
          ],
          'id': '28025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6232,
              -8564,
              9515,
              -4628,
              -4210,
              -8321
            ]
          ],
          'id': '29087'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7459,
              9516,
              -6669,
              -8890,
              -8962,
              9517
            ]
          ],
          'id': '36029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8465,
              -3051,
              -7402,
              -9139,
              -2989
            ]
          ],
          'id': '16087'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6591,
              -9256,
              -9166,
              -6945,
              -6091,
              -4971
            ]
          ],
          'id': '46055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8203,
              -9273,
              -9087,
              -4466,
              -7208,
              -8258,
              -2722,
              -8206
            ]
          ],
          'id': '40079'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6059,
              -8970,
              -6530,
              9518,
              -8405,
              -5592,
              -5334
            ]
          ],
          'id': '54099'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7547,
              9519,
              -3748,
              -6250,
              -5122,
              -303
            ]
          ],
          'id': '30079'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9520,
              -7971,
              9521,
              -2703
            ]
          ],
          'id': '12033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9334,
              -8784,
              9522,
              -8719,
              -8771,
              -66
            ]
          ],
          'id': '13175'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9523,
              -2823,
              -228,
              -3325,
              -889
            ]
          ],
          'id': '19023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9524,
              -5449,
              9525,
              -500,
              9526,
              -6209,
              -3543,
              -7709
            ]
          ],
          'id': '41065'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6089,
              -5083,
              -7848,
              -1661,
              -6582,
              9527
            ]
          ],
          'id': '31027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9068,
              9528,
              -9112,
              -7589,
              9529,
              -8269,
              9530
            ]
          ],
          'id': '33011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8551,
              -6033,
              -5528,
              -8855,
              -9300,
              9531
            ]
          ],
          'id': '13251'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8843,
              -9181,
              -7505,
              -5441,
              -6456,
              -1062
            ]
          ],
          'id': '31021'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -4495,
                4492,
                -4494,
                -4493,
                -4492,
                9532,
                -9212,
                9533
              ]
            ],
            [
              [
                -9218,
                9534
              ]
            ],
            [
              [
                -5305,
                9535
              ]
            ]
          ],
          'id': '24039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4491,
              9536,
              9537,
              -9213,
              -9533
            ]
          ],
          'id': '24047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9538,
              -492,
              -9024,
              -6499,
              -5475,
              -6891
            ]
          ],
          'id': '38013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9539,
              9540,
              9541,
              -5889
            ]
          ],
          'id': '18127'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8330,
              -6650,
              -1995,
              -2280,
              -308,
              -7440
            ]
          ],
          'id': '29083'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6309,
              9542,
              -8135,
              -8058,
              -7146,
              -6304,
              -9491
            ]
          ],
          'id': '36023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3054,
              -4085,
              -5543,
              -9094,
              9543
            ]
          ],
          'id': '16001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2939,
              -4236,
              -1173,
              9544,
              -1815
            ]
          ],
          'id': '17175'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9160,
              9545,
              -2694,
              -2230,
              9546,
              9547
            ]
          ],
          'id': '38043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6215,
              -7066,
              -9253,
              -9178,
              -6385,
              9548
            ]
          ],
          'id': '51173'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9549,
              -2013,
              -8786,
              -6337,
              -6618,
              -9185
            ]
          ],
          'id': '13301'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7172,
              9550,
              -5970,
              -5771,
              -6698
            ]
          ],
          'id': '21201'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                9551
              ]
            ],
            [
              [
                9552
              ]
            ],
            [
              [
                -1778,
                -2415,
                -519,
                9553
              ]
            ],
            [
              [
                9554
              ]
            ],
            [
              [
                9555
              ]
            ]
          ],
          'id': '02180'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2340,
              -3612,
              -1077,
              -466,
              9556
            ]
          ],
          'id': '48415'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9557,
              -8560,
              -8755,
              -9134,
              -129,
              -934
            ]
          ],
          'id': '48249'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9240,
              -2621,
              -7954,
              -3067
            ]
          ],
          'id': '31095'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8380,
              -6902,
              -5841,
              -5832,
              -9196
            ]
          ],
          'id': '47015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3474,
              -1293,
              -2229,
              -7608,
              9558,
              -6636
            ]
          ],
          'id': '18017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9476,
              -8997,
              -7005,
              -8739,
              -7111
            ]
          ],
          'id': '72099'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9519,
              -6529,
              -9055,
              -7759,
              -7749,
              -7117,
              -8406
            ]
          ],
          'id': '54043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9559,
              -8168,
              -599,
              -2801,
              -9305,
              -5638,
              -7421,
              9560
            ]
          ],
          'id': '31111'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8635,
              -3249,
              9561,
              9562,
              9563,
              -7378,
              -9012
            ]
          ],
          'id': '17157'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9433,
              9564,
              -5606,
              -1511,
              -5700
            ]
          ],
          'id': '55131'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5494,
              9565,
              9566,
              -6240
            ]
          ],
          'id': '11001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9567,
              9568,
              -5113,
              -7094,
              -6144
            ]
          ],
          'id': '51119'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3287,
              9569,
              -4871,
              -2648,
              -2735
            ]
          ],
          'id': '31061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7325,
              -5519,
              -3990,
              -9098,
              9570,
              -8497,
              9571
            ]
          ],
          'id': '06001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6241,
              -9567,
              9572,
              9573
            ]
          ],
          'id': '51510'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6172,
              9574,
              9575,
              -2428,
              -1952
            ]
          ],
          'id': '05079'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6808,
              9576,
              -2455,
              9577,
              -5503,
              -8283,
              -8944,
              -4682
            ]
          ],
          'id': '37141'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6199,
              -8466,
              -7702,
              -5315,
              -7327,
              -9170
            ]
          ],
          'id': '09003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4177,
              9578,
              -8425,
              -4867
            ]
          ],
          'id': '17097'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6821,
              -1659,
              -5531,
              -9228,
              -924,
              -6822,
              -235,
              -4627
            ]
          ],
          'id': '31141'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6630,
              -3102,
              9579,
              9580,
              -4114,
              -2653
            ]
          ],
          'id': '20081'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3154,
              -2835,
              -2726,
              -5032,
              -7557,
              -3800
            ]
          ],
          'id': '48135'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -310,
              -2279,
              -6118,
              9581,
              9582
            ]
          ],
          'id': '29085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7082,
              -7073,
              9583,
              -8598,
              -8703,
              -8480,
              -8393
            ]
          ],
          'id': '51025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2810,
              -9308,
              -9524,
              -2532
            ]
          ],
          'id': '19067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9584
            ]
          ],
          'id': '51600'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5548,
              -8859,
              -9122,
              9585,
              9586,
              -9318
            ]
          ],
          'id': '31123'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9587,
              -1514,
              -8094,
              -4179,
              -4866,
              -9284,
              -3167
            ]
          ],
          'id': '55127'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9301,
              -3077,
              -9337,
              -4779
            ]
          ],
          'id': '13043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1251,
              -3153,
              -1179,
              9588,
              -8411,
              -2147,
              9589
            ]
          ],
          'id': '17115'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -901,
              -3270,
              -2717,
              -2753,
              -1565,
              -377,
              -2256,
              -9269
            ]
          ],
          'id': '20063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7999,
              -8410,
              -8691,
              -9288,
              -6443
            ]
          ],
          'id': '28041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9590,
              -2827,
              -2804,
              9591,
              -9562,
              -3248
            ]
          ],
          'id': '17189'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9592,
              -325,
              -746,
              -3343,
              -3659,
              -3699
            ]
          ],
          'id': '23019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2589,
              -2544,
              -431,
              -4186,
              -6022,
              9593
            ]
          ],
          'id': '55001'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                9594
              ]
            ],
            [
              [
                9595
              ]
            ],
            [
              [
                -9289,
                -8689,
                9596,
                -8075,
                -452
              ]
            ]
          ],
          'id': '28059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9597,
              -1733,
              9598,
              9599,
              -7304,
              -7983
            ]
          ],
          'id': '13071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4945,
              -8262,
              -6398,
              -8208,
              -1018,
              -3936,
              9600,
              -9446,
              -2423
            ]
          ],
          'id': '42125'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7400,
              9601,
              -9537,
              -4490,
              -5308,
              -1000
            ]
          ],
          'id': '10005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3122,
              9602,
              -5663,
              -7550,
              -3321,
              -2557,
              -6422
            ]
          ],
          'id': '20197'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5522,
              -5515,
              -7178,
              -5943,
              9603,
              -3487
            ]
          ],
          'id': '21157'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7781,
              9604,
              -5336,
              -5145,
              -5584,
              -6585,
              -6817
            ]
          ],
          'id': '21175'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1340,
              -6689,
              -6838,
              -9352,
              -320,
              9605,
              -5134
            ]
          ],
          'id': '21177'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9353,
              -4428,
              -8178,
              -5856,
              -7597
            ]
          ],
          'id': '21213'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4202,
              -1975,
              -2976,
              -5061,
              -8929
            ]
          ],
          'id': '37035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7467,
              -7968,
              -7913,
              -7986,
              -7729,
              -6813
            ]
          ],
          'id': '40103'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4736,
              9606,
              -3633,
              -8779,
              9607,
              -6260
            ]
          ],
          'id': '53013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9487,
              -8022,
              -7996,
              9608,
              9609
            ]
          ],
          'id': '28061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7500,
              -5675,
              -4887,
              -4844,
              -1185,
              -3257
            ]
          ],
          'id': '17033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4976,
              -609,
              -1455,
              -3157,
              -7206,
              -1450
            ]
          ],
          'id': '46005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9307,
              -3726,
              -6931,
              -8710,
              -1084,
              -6909
            ]
          ],
          'id': '39069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9083,
              -2108,
              -8767,
              -6924,
              -9270,
              -1694
            ]
          ],
          'id': '39047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3081,
              -1217,
              9610,
              -2849,
              -9266
            ]
          ],
          'id': '18041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7961,
              -6718,
              -2370,
              -2386
            ]
          ],
          'id': '48379'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5329,
              -712,
              -7535,
              -2446,
              -9167,
              -7919
            ]
          ],
          'id': '29129'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9611,
              -400,
              -699,
              9612,
              9613
            ]
          ],
          'id': '38027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3158,
              -603,
              -8860,
              -1419,
              -2094
            ]
          ],
          'id': '46061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1888,
              9614,
              -8788,
              -8489,
              -2885
            ]
          ],
          'id': '39109'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1117,
              -264,
              -8424,
              9615,
              -2551,
              -2868
            ]
          ],
          'id': '48367'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9616,
              -1119,
              -2867,
              -9306,
              -6156
            ]
          ],
          'id': '48503'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6885,
              9617,
              -8956,
              -4217,
              -6725,
              -831
            ]
          ],
          'id': '48373'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6564,
              -9486,
              -8167,
              -5570,
              -9182
            ]
          ],
          'id': '22011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8486,
              -4597,
              -8702,
              -357,
              -4383,
              9618,
              -5365
            ]
          ],
          'id': '49033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2505,
              -3814,
              9619,
              -5445,
              9620,
              -8029,
              -637
            ]
          ],
          'id': '53077'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                9621
              ]
            ],
            [
              [
                -3724,
                9622,
                9623,
                -3225,
                -6929
              ]
            ]
          ],
          'id': '39123'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4542,
              -5952,
              -5187,
              9624,
              -7381,
              -5181
            ]
          ],
          'id': '17013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7158,
              -7236,
              -4157,
              -9192,
              -6819,
              -5980
            ]
          ],
          'id': '35007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7034,
              -629,
              -7203,
              -6497,
              -4660,
              -5815
            ]
          ],
          'id': '31103'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1499,
              -8732,
              -8869
            ]
          ],
          'id': '56017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8506,
              -5524,
              -6184,
              -5738,
              -9286
            ]
          ],
          'id': '21007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9625,
              -7041,
              -1748,
              -5270,
              -8955,
              -9618,
              -6884,
              -7022
            ]
          ],
          'id': '48005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5191,
              -6078,
              -5277,
              -4899,
              -5097,
              9626
            ]
          ],
          'id': '45015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -931,
              9627,
              -9500,
              -1452,
              -607
            ]
          ],
          'id': '46057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4697,
              -4292,
              -6129,
              9628,
              -8761,
              -5954
            ]
          ],
          'id': '45037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1414,
              -7063,
              -9502,
              -8561,
              -9558,
              -933,
              -3570
            ]
          ],
          'id': '48297'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1388,
              9629,
              -865,
              -8879,
              -6269
            ]
          ],
          'id': '27121'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9630,
              9631,
              -8360,
              -9443,
              9632
            ]
          ],
          'id': '39115'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9633
            ]
          ],
          'id': '60040'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9634,
              -5450,
              -9525,
              -7708,
              -8281
            ]
          ],
          'id': '41027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -311,
              -9583,
              9635,
              -7640,
              9636,
              -1978
            ]
          ],
          'id': '29167'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9637,
              -2311,
              9638,
              -942,
              -1717
            ]
          ],
          'id': '48115'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2425,
              -9448,
              -5415,
              -7627,
              -7577,
              -3294
            ]
          ],
          'id': '54061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3244,
              -6158,
              -247,
              -3962,
              -2355
            ]
          ],
          'id': '48207'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -245,
              -2312,
              -9638,
              -1716,
              -508
            ]
          ],
          'id': '48445'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7561,
              -4766,
              -1114,
              -9617,
              -1096
            ]
          ],
          'id': '48009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1363,
              -6570,
              -2811,
              -2530,
              -9340
            ]
          ],
          'id': '19195'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7988,
              -6775,
              -4709,
              -7176,
              -4832,
              -5754
            ]
          ],
          'id': '21001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6536,
              -9413,
              -6353,
              -2345,
              9639,
              9640,
              9641
            ]
          ],
          'id': '08093'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6131,
              9642,
              9643,
              -5192,
              -9627,
              -5096,
              -6898,
              -1407,
              9644
            ]
          ],
          'id': '45075'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9645,
              -6537,
              -9642,
              9646,
              -8639
            ]
          ],
          'id': '08065'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8819,
              -8971,
              -6061,
              9647,
              -5433
            ]
          ],
          'id': '21089'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9492,
              -7813,
              9648,
              9649,
              -8946,
              -4007,
              -9325
            ]
          ],
          'id': '13137'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3579,
              -9444,
              -3964,
              -3971,
              -9354,
              -8768
            ]
          ],
          'id': '39163'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8852,
              -99,
              -1808,
              -9226,
              -798
            ]
          ],
          'id': '39175'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4655,
              -7847,
              -8982,
              -5131,
              -6859,
              -9255,
              9650
            ]
          ],
          'id': '30003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4530,
              -4255,
              -2513,
              -8021,
              9651
            ]
          ],
          'id': '28037'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                9652
              ]
            ],
            [
              [
                -6020,
                9653
              ]
            ]
          ],
          'id': '51683'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4754,
              -9455,
              -4320,
              9654,
              -5656,
              -7628
            ]
          ],
          'id': '47107'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9655,
              -463,
              -8169,
              -9560,
              9656,
              -920
            ]
          ],
          'id': '31117'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6811,
              -8144,
              -8148,
              -6759
            ]
          ],
          'id': '40133'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5013,
              -2373,
              -8011,
              9657,
              -6179,
              9658,
              -9187,
              -4762
            ]
          ],
          'id': '48213'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8812,
              -8841,
              -8846,
              -5292,
              -6206,
              9659,
              -7743
            ]
          ],
          'id': '50001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9660,
              -9586,
              -9121,
              -8660,
              9661,
              9662,
              -3918
            ]
          ],
          'id': '31033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9663,
              -323,
              -7600,
              9664,
              -5002,
              -4638,
              -6951
            ]
          ],
          'id': '47125'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9665,
              9666,
              -4325,
              -6904,
              -1128,
              -705,
              -3037
            ]
          ],
          'id': '48035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9667,
              -5541,
              -1459,
              -8024,
              -4222,
              -9321
            ]
          ],
          'id': '47181'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6967,
              -3941,
              -7213,
              9668,
              9669,
              -4289,
              -4696
            ]
          ],
          'id': '45071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5880,
              -940,
              -8661,
              -7510,
              -4154
            ]
          ],
          'id': '48205'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -442,
              -4191,
              -1490,
              -4346,
              -7107
            ]
          ],
          'id': '55107'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3429,
              9670,
              -6298,
              -9061,
              -6428,
              -5678
            ]
          ],
          'id': '28117'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2962,
              9671,
              -1855,
              -3640,
              -4787
            ]
          ],
          'id': '19035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3101,
              -1047,
              -7182,
              9672,
              9673,
              -9580
            ]
          ],
          'id': '20119'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3410,
              -540,
              -9186,
              -511,
              -1686,
              -1382
            ]
          ],
          'id': '48087'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7093,
              -8599,
              -9584,
              -7072,
              -5481
            ]
          ],
          'id': '51135'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2637,
              9674,
              -9633,
              -9442,
              -3577,
              -8872
            ]
          ],
          'id': '39127'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3714,
              -7734,
              -7868,
              -8133,
              -9543,
              -6308
            ]
          ],
          'id': '36053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3010,
              -5937,
              -5826,
              -8414,
              -8580
            ]
          ],
          'id': '18171'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8653,
              -859,
              -3239,
              -3531,
              -349
            ]
          ],
          'id': '27085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2553,
              9675,
              -9666,
              -3036
            ]
          ],
          'id': '48425'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1887,
              -6676,
              -6680,
              -9081,
              -8789,
              -9615
            ]
          ],
          'id': '39021'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                9676,
                -8536
              ]
            ],
            [
              [
                9677,
                9678,
                9679,
                -8534,
                9680,
                -8542
              ]
            ]
          ],
          'id': '12086'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9532,
              -9299,
              -4777,
              -8552
            ]
          ],
          'id': '13165'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5926,
              9681,
              -408,
              -1804,
              9682,
              -6942
            ]
          ],
          'id': '40043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2398,
              9683,
              9684,
              -7052,
              -9206,
              -4742
            ]
          ],
          'id': '40085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4591,
              -5260,
              -8974,
              -6483,
              -3436
            ]
          ],
          'id': '13005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -326,
              -9593,
              -3698
            ]
          ],
          'id': '23021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9685,
              9686,
              -1935,
              -9091
            ]
          ],
          'id': '39085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6068,
              -8343,
              -9041,
              9687,
              -2790
            ]
          ],
          'id': '48089'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5780,
              -5560,
              -6841,
              -6038
            ]
          ],
          'id': '21131'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3998,
              -8604,
              -8197,
              -8237,
              -9347,
              9688
            ]
          ],
          'id': '06113'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9233,
              9689,
              -7930,
              9690,
              -5372
            ]
          ],
          'id': '12007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9115,
              -5062,
              -2974,
              -2832,
              9691,
              -5719,
              -4904
            ]
          ],
          'id': '37119'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8909,
              -9207,
              -186,
              9692,
              -1175,
              -3152,
              -1249,
              -1875
            ]
          ],
          'id': '17113'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4363,
              -8282,
              -7706,
              -6767,
              9693
            ]
          ],
          'id': '41067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7429,
              -4419,
              -9462,
              -6546,
              -3454,
              -5674
            ]
          ],
          'id': '18021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9188,
              -9659,
              -6183,
              -7059,
              -961
            ]
          ],
          'id': '48161'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7374,
              9694,
              -5666,
              9695,
              -9141,
              9696
            ]
          ],
          'id': '24003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8891,
              -2929,
              -8043,
              -5076,
              -5110,
              -9123
            ]
          ],
          'id': '42083'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1706,
              -7576,
              -9065,
              -2778,
              9697,
              -3463
            ]
          ],
          'id': '29103'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2740,
              -7231,
              -3178,
              -5654
            ]
          ],
          'id': '19147'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3464,
              -9698,
              -2782,
              -8525,
              -5100,
              9698
            ]
          ],
          'id': '29121'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2604,
              9699,
              -8320,
              -7261,
              9700,
              -3284
            ]
          ],
          'id': '28103'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6440,
              -6793,
              -2634,
              -7823,
              9701,
              -4253
            ]
          ],
          'id': '28077'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1879,
              -4406,
              -1032,
              -9180,
              -8576,
              -9416,
              -8351,
              -8358
            ]
          ],
          'id': '08073'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6415,
              -5430,
              9702,
              -3062,
              -737
            ]
          ],
          'id': '20077'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -226,
              -6554,
              -1869,
              -777,
              -3326
            ]
          ],
          'id': '19171'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9514,
              -9105,
              -8317,
              -8318,
              -9700,
              -2603
            ]
          ],
          'id': '28087'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1608,
              -1979,
              -9637,
              -7643,
              9703,
              -4110
            ]
          ],
          'id': '29057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2310,
              -2341,
              -9557,
              -465,
              -6783,
              -9639
            ]
          ],
          'id': '48033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5655,
              -3181,
              -3594,
              -9672
            ]
          ],
          'id': '19021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6192,
              -1405,
              -5542,
              -9668,
              -9320,
              -5198
            ]
          ],
          'id': '47039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7403,
              -3055,
              -9544,
              -9093,
              -9140
            ]
          ],
          'id': '16027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4254,
              -9702,
              -7822,
              -8377,
              -2162
            ]
          ],
          'id': '28147'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9069,
              -9531,
              -8268,
              -3672,
              -4927
            ]
          ],
          'id': '33005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9168,
              -2444,
              -3465,
              -9699,
              -5099,
              -1592
            ]
          ],
          'id': '29115'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6943,
              -9683,
              -1807,
              -534,
              -3409,
              -2623
            ]
          ],
          'id': '40129'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9704,
              -6024,
              -7853,
              9705,
              -2838,
              -4622
            ]
          ],
          'id': '55111'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9102,
              -7772,
              -9250,
              -8007,
              -7358,
              -4106,
              -9438,
              -3884
            ]
          ],
          'id': '22009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4111,
              -9704,
              -7642,
              -1539,
              -1688,
              9706,
              -1650
            ]
          ],
          'id': '29109'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1080,
              -8292,
              -4031,
              9707,
              -5391
            ]
          ],
          'id': '37127'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -499,
              -6072,
              -2102,
              9708,
              -6210,
              -9527
            ]
          ],
          'id': '41069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5434,
              -9648,
              -6060,
              -5332,
              9709,
              -7779
            ]
          ],
          'id': '21043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6037,
              9710,
              -6602,
              -8920,
              -5065,
              -4989
            ]
          ],
          'id': '37115'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -6019,
                -6021,
                -9654
              ],
              [
                -9653
              ]
            ],
            [
              [
                -3767,
                9711,
                9712,
                9713,
                -9014,
                -8129
              ]
            ]
          ],
          'id': '51153'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8418,
              -8214,
              9714,
              -9108
            ]
          ],
          'id': '34007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9613,
              -698,
              -2692,
              9715
            ]
          ],
          'id': '38031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7100,
              -7079,
              -6216,
              -9549,
              -6389,
              -1631,
              -6786
            ]
          ],
          'id': '51167'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                9716
              ]
            ],
            [
              [
                9717
              ]
            ],
            [
              [
                -8973,
                -5139,
                -7933,
                9718,
                -1667
              ]
            ]
          ],
          'id': '26041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6730,
              -4425,
              -7333,
              -4478,
              -7840,
              -4473,
              -6359,
              -73
            ]
          ],
          'id': '18175'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4670,
              -7514,
              -4257,
              -5928,
              -2948
            ]
          ],
          'id': '35019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6411,
              -2852,
              -9205,
              -9328,
              -4514
            ]
          ],
          'id': '18029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9203,
              -7344,
              -9251,
              9719,
              -9326
            ]
          ],
          'id': '21117'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                9720
              ]
            ],
            [
              [
                -9339,
                -3662,
                -7363,
                9721,
                -5020
              ]
            ]
          ],
          'id': '23015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8737,
              -7493,
              -3431,
              -5677,
              -7417
            ]
          ],
          'id': '28009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -103,
              -745,
              -3184,
              -3825,
              -8813,
              -6124
            ]
          ],
          'id': '19119'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7086,
              9722,
              -5852,
              9723,
              -5378,
              9724
            ]
          ],
          'id': '21049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9725,
              9726,
              -6046,
              9727,
              -2830
            ]
          ],
          'id': '37167'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9197,
              -5830,
              -9508,
              9728,
              9729
            ]
          ],
          'id': '47003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5462,
              -5960,
              -3397,
              -5479,
              -3804,
              9730
            ]
          ],
          'id': '51029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9420,
              -9415,
              -8241,
              -3839,
              -7727
            ]
          ],
          'id': '05089'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8563,
              -6280,
              -3889,
              -6288,
              -4629,
              -9516
            ]
          ],
          'id': '29003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2979,
              -8369,
              -3628,
              -9060,
              -8312,
              -4600,
              -8319
            ]
          ],
          'id': '01125'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9731,
              -6864,
              -9494,
              -4739,
              -2477,
              -1758
            ]
          ],
          'id': '72135'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5196,
              -6035,
              -4987,
              -6693,
              -5073
            ]
          ],
          'id': '47063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3813,
              -4738,
              -6262,
              9732,
              -6070,
              -5446,
              -9620
            ]
          ],
          'id': '53005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8986,
              -4484,
              9733,
              -4822,
              -8673
            ]
          ],
          'id': '13191'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4880,
              -5040,
              -8357,
              -3233,
              -7992
            ]
          ],
          'id': '48109'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2011,
              -8762,
              -9629,
              -6134,
              -8549,
              -8787
            ]
          ],
          'id': '13245'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9604,
              -5942,
              -6952,
              -6193,
              -3488
            ]
          ],
          'id': '21035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9734,
              -5632,
              -9010,
              -9110,
              -9529,
              -9067
            ]
          ],
          'id': '33013'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -4161,
                9735
              ]
            ],
            [
              [
                9736,
                -6917
              ]
            ],
            [
              [
                -9148,
                9146,
                -9146,
                9737,
                -6915
              ]
            ]
          ],
          'id': '48167'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9319,
              -9587,
              -9661,
              -3917,
              9738,
              -5795
            ]
          ],
          'id': '31007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2540,
              -3361,
              -6173,
              -1950,
              -8926,
              -8096
            ]
          ],
          'id': '05053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9739,
              -5248,
              9740,
              -4512,
              9741,
              -5243
            ]
          ],
          'id': '34033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6981,
              -9694,
              -6770,
              -8228,
              -8520,
              9742
            ]
          ],
          'id': '41057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7744,
              -9660,
              -6208,
              -8748,
              -9114,
              -9436,
              9743
            ]
          ],
          'id': '36115'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9744,
              -7497,
              -2888,
              -2261
            ]
          ],
          'id': '27077'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8257,
              -7162,
              -1867,
              -1027,
              -4405,
              -8294,
              -6350
            ]
          ],
          'id': '08001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9745,
              -3999,
              -9689,
              -9346,
              -7946,
              -7720
            ]
          ],
          'id': '06033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8936,
              -8985,
              -2014,
              -9550,
              -9184,
              9746
            ]
          ],
          'id': '13317'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5102,
              -8527,
              -6797,
              -1541,
              9747
            ]
          ],
          'id': '29089'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6772,
              9748,
              -5203,
              -3547,
              -240,
              -6984
            ]
          ],
          'id': '42011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9749,
              -5990,
              -6097,
              -8286,
              -3509
            ]
          ],
          'id': '47087'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9750,
              -6026,
              -147,
              -7766,
              -159,
              -9343
            ]
          ],
          'id': '72091'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3060,
              -8165,
              -3421,
              -8995,
              -6856,
              -7076
            ]
          ],
          'id': '54007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7171,
              9751,
              -8616,
              -5437,
              -5967,
              -9551
            ]
          ],
          'id': '21161'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9752,
              -9330,
              -7413,
              -9128,
              9753
            ]
          ],
          'id': '26021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9693,
              -185,
              -8581,
              -5146,
              -1176
            ]
          ],
          'id': '17019'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -7204
              ]
            ],
            [
              [
                -824
              ]
            ],
            [
              [
                -4609,
                -7523,
                -9473,
                -5458,
                9754,
                -8799,
                -7747
              ]
            ]
          ],
          'id': '51015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3365,
              -6461,
              -3847,
              -7322,
              9755,
              -9575,
              -6171
            ]
          ],
          'id': '05001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8655,
              -9043,
              -2181,
              -8953,
              -9045,
              -8125
            ]
          ],
          'id': '13079'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3458,
              -6629,
              -6547,
              -6407,
              -4889
            ]
          ],
          'id': '18027'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                9756
              ]
            ],
            [
              [
                9757,
                -7184
              ]
            ],
            [
              [
                -4727,
                9758
              ]
            ],
            [
              [
                -7188,
                9759
              ]
            ]
          ],
          'id': '37055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4026,
              -3743,
              -9520,
              -7546
            ]
          ],
          'id': '30021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8221,
              -707,
              -1131,
              -1724,
              -6082,
              -7025
            ]
          ],
          'id': '48281'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7633,
              -6226,
              -1765,
              9760,
              -7899
            ]
          ],
          'id': '12123'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9761,
              -7166,
              -4411
            ]
          ],
          'id': '13047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -772,
              -6267,
              -6321,
              -516,
              -9241
            ]
          ],
          'id': '13067'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -4841,
                -7862,
                -4350
              ]
            ],
            [
              [
                -4104,
                -9488,
                -4838,
                -6734,
                -9439
              ]
            ]
          ],
          'id': '22099'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7507,
              -3446,
              9762,
              -7825,
              -2433,
              -8610,
              -7527
            ]
          ],
          'id': '28135'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9582,
              -6117,
              -1590,
              -912,
              -7641,
              -9636
            ]
          ],
          'id': '29059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4030,
              -4262,
              -5299,
              -4675,
              -5392,
              -9708
            ]
          ],
          'id': '37195'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1645,
              -6229,
              -401,
              -9612,
              9763,
              -9070
            ]
          ],
          'id': '38005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9670,
              9764,
              9765,
              -9643,
              -6130,
              -4290
            ]
          ],
          'id': '45063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1737,
              -2837,
              -2924,
              -8716,
              -1911,
              -4380,
              -9332
            ]
          ],
          'id': '48137'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4414,
              -4010,
              -4648,
              -4458
            ]
          ],
          'id': '13055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9766,
              -3550,
              -7315,
              9767,
              9768
            ]
          ],
          'id': '24025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5865,
              -5946,
              -6881,
              -5208,
              -4282,
              -5200,
              -5092
            ]
          ],
          'id': '45069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3070,
              -7802,
              -5664,
              -9603,
              -3121,
              -3259
            ]
          ],
          'id': '20161'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5854,
              -7419,
              -1624,
              -1332,
              -9329,
              9769
            ]
          ],
          'id': '26005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6795,
              -5350,
              -5470,
              -5117,
              -7774
            ]
          ],
          'id': '29051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7911,
              -7967,
              9770,
              9771,
              -3926,
              -4277,
              -2784
            ]
          ],
          'id': '40143'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3777,
              -8476,
              -6204,
              -5381,
              -1928,
              9772
            ]
          ],
          'id': '48187'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8758,
              -9313,
              9773,
              -8847,
              -8839,
              -2579
            ]
          ],
          'id': '50005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5701,
              -1515,
              -9588,
              -3166,
              -7854
            ]
          ],
          'id': '55055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8162,
              9774,
              -5238,
              9775,
              9776
            ]
          ],
          'id': '42001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6418,
              -7845,
              -3439,
              -3449,
              -8231,
              -8738
            ]
          ],
          'id': '20105'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -9202,
                9777
              ]
            ],
            [
              [
                9778
              ]
            ]
          ],
          'id': '53029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9779,
              -5000,
              -6090,
              -9528,
              -6581,
              -669,
              -5387,
              -7202
            ]
          ],
          'id': '31107'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8887,
              -8153,
              9780,
              -4633,
              -9316,
              -8451,
              -9231
            ]
          ],
          'id': '32019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7780,
              -9710,
              -5331,
              -9605
            ]
          ],
          'id': '21063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4714,
              -5380,
              -4690,
              -6840,
              -6594,
              9781
            ]
          ],
          'id': '21079'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5779,
              -5152,
              -5847,
              -6784,
              -5562
            ]
          ],
          'id': '21133'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3129,
              -4794,
              9782,
              -7335,
              -7446
            ]
          ],
          'id': '21223'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4319,
              -6189,
              -8264,
              -8265,
              -5657,
              -9655
            ]
          ],
          'id': '47123'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2403,
              -8069,
              -8131,
              -2411,
              -7032
            ]
          ],
          'id': '51113'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7237,
              -3499,
              -1371,
              -2824,
              -9591,
              -3247
            ]
          ],
          'id': '17027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4819,
              9783,
              -9679,
              9784,
              -8983
            ]
          ],
          'id': '12011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9581,
              -9674,
              9785,
              -7013,
              -4115
            ]
          ],
          'id': '20175'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8010,
              -8815,
              -7042,
              -9626,
              -7021,
              -6180,
              -9658
            ]
          ],
          'id': '48073'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9756,
              -7321,
              -3681,
              -7601,
              -2429,
              -9576
            ]
          ],
          'id': '05041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9463,
              -4090,
              -4592,
              -8488,
              -8602,
              -7298
            ]
          ],
          'id': '16029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4677,
              -3909,
              -4315,
              -2456,
              -9577,
              -6807
            ]
          ],
          'id': '37061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8232,
              -3452,
              -9034,
              -6558,
              -6732,
              -6552
            ]
          ],
          'id': '20009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1806,
              9786,
              -7905,
              -536
            ]
          ],
          'id': '40149'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7279,
              -6469,
              -6538,
              -9646,
              -8638,
              -1794
            ]
          ],
          'id': '08037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2110,
              -8907,
              -5909,
              -5906,
              -7712,
              -8223
            ]
          ],
          'id': '39099'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5263,
              9787,
              -8555,
              -8174,
              -8102,
              -4948
            ]
          ],
          'id': '01087'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8573,
              -1903,
              -6755,
              -2884,
              -488
            ]
          ],
          'id': '39107'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -9585
              ]
            ],
            [
              [
                -3766,
                -5495,
                -6243,
                -3138,
                -6242,
                -9574,
                9788,
                -9503,
                9789,
                -9713,
                -9712
              ]
            ]
          ],
          'id': '51059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9238,
              9790,
              -4341,
              -1462,
              -4190
            ]
          ],
          'id': '55085'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8781,
              -2986,
              -2097,
              9791
            ]
          ],
          'id': '41061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6132,
              -9645,
              -1410,
              -6032,
              -8550
            ]
          ],
          'id': '45011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9792,
              -362,
              -8475,
              -5684
            ]
          ],
          'id': '49051'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                9793
              ]
            ],
            [
              [
                9794
              ]
            ],
            [
              [
                9795
              ]
            ],
            [
              [
                -6292,
                -8327,
                9796
              ]
            ],
            [
              [
                9797
              ]
            ]
          ],
          'id': '26089'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7574,
              -9434,
              -9221,
              -3224,
              -5488,
              -8950,
              -9064
            ]
          ],
          'id': '17067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9798,
              -5966,
              -1552,
              9799,
              -1520
            ]
          ],
          'id': '51193'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3636,
              -7647,
              -4039,
              -8556,
              -9788,
              -5262,
              -8332
            ]
          ],
          'id': '01123'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1732,
              -8701,
              -8938,
              9800,
              -9599
            ]
          ],
          'id': '13075'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                9801
              ]
            ],
            [
              [
                -5417,
                9802
              ]
            ],
            [
              [
                9803
              ]
            ]
          ],
          'id': '26083'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3285,
              -9701,
              -7260,
              -336,
              -1051
            ]
          ],
          'id': '28069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1086,
              -8709,
              -1899,
              -2202
            ]
          ],
          'id': '39125'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6036,
              -1487,
              -7595,
              -4723,
              -6599,
              -9711
            ]
          ],
          'id': '47171'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9189,
              -4588,
              -8721,
              9804
            ]
          ],
          'id': '13209'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9600,
              -9801,
              -8940,
              -7630,
              -7898,
              -7305
            ]
          ],
          'id': '13027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3919,
              -9663,
              9805,
              -2955,
              -2956,
              -1029,
              -1866,
              -7161
            ]
          ],
          'id': '08075'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1809,
              -97,
              -6790,
              -947,
              -1931
            ]
          ],
          'id': '39117'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9049,
              -1926,
              9806,
              -9631,
              -9675,
              -2636
            ]
          ],
          'id': '39119'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8853,
              -4915,
              9807,
              -7227
            ]
          ],
          'id': '13051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9048,
              -9052,
              -1849,
              -7309,
              9808,
              -8682
            ]
          ],
          'id': '13061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9662,
              -8659,
              -7422,
              -2952,
              -9806
            ]
          ],
          'id': '08115'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3857,
              -7341,
              -8649,
              -9080,
              -1896,
              9809,
              -3041
            ]
          ],
          'id': '12105'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9810,
              -9511,
              -9264,
              -8078,
              -2383,
              -5025
            ]
          ],
          'id': '48147'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6185,
              -3491,
              -7638,
              -6126,
              -6052,
              -5740
            ]
          ],
          'id': '21105'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9020,
              -9027,
              -7977,
              -4456,
              -8055,
              -9315
            ]
          ],
          'id': '01071'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8942,
              -3581,
              -8171,
              -8554,
              9811
            ]
          ],
          'id': '13215'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9812,
              -9291,
              -4021,
              -8279,
              -4234,
              -2937,
              -8707
            ]
          ],
          'id': '17195'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9813,
              -9084,
              -8647,
              -2507,
              -8088
            ]
          ],
          'id': '12009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3392,
              -9295,
              -1734,
              -9598,
              -7982,
              -7980,
              -9335
            ]
          ],
          'id': '13321'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8975,
              -8674,
              -4825,
              -9356,
              -5217,
              -6485
            ]
          ],
          'id': '13025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1805,
              -406,
              -9421,
              -2362,
              -528,
              -7906,
              -9787
            ]
          ],
          'id': '40015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9814,
              -9729,
              -9509,
              -9022,
              -9314,
              -7830,
              -1091
            ]
          ],
          'id': '47103'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6921,
              -4946,
              -3299,
              -7539,
              -8362,
              9815
            ]
          ],
          'id': '39111'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9816,
              -4620,
              -8120,
              -8830
            ]
          ],
          'id': '55081'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6376,
              -3915,
              -4911,
              -3938,
              -7843
            ]
          ],
          'id': '45021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5507,
              -5215,
              -208,
              -8861,
              -4342,
              -9791,
              -9237
            ]
          ],
          'id': '55041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -806,
              -7087,
              -9725,
              -5377,
              -4712,
              9817
            ]
          ],
          'id': '21067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -394,
              -4131,
              -6522,
              -6667,
              -9517,
              -7458
            ]
          ],
          'id': '36037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9818,
              9819,
              9820,
              -6592,
              -9195
            ]
          ],
          'id': '21229'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8291,
              9821,
              -6848,
              9822,
              -4263,
              -4028
            ]
          ],
          'id': '37117'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3372,
              -7842,
              -7015,
              -4032,
              -5879,
              -4152
            ]
          ],
          'id': '40025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5211,
              -6314,
              -5274,
              -6077,
              -4284
            ]
          ],
          'id': '45067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -877,
              -8485,
              -1833,
              -9175,
              -2874,
              -315,
              9823,
              -6608
            ]
          ],
          'id': '01039'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                9824
              ]
            ],
            [
              [
                9825
              ]
            ],
            [
              [
                -7271,
                -2008,
                -7219,
                9826,
                -7216
              ]
            ]
          ],
          'id': '06037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8939,
              -7142,
              -7675,
              -7351,
              -7632
            ]
          ],
          'id': '12047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7274,
              -8984,
              -9785,
              -9678,
              -8541,
              9827
            ]
          ],
          'id': '12021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2898,
              -6227,
              -1326,
              -9125,
              -5007,
              9828,
              -6273
            ]
          ],
          'id': '20125'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3232,
              -6228,
              -5558,
              -7247,
              -4066,
              -5950,
              -862
            ]
          ],
          'id': '17193'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -503,
              -1651,
              -9707,
              -1691,
              -7264,
              -4229
            ]
          ],
          'id': '29009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -85,
              -9282,
              -7364,
              -1616,
              -6568,
              -9283
            ]
          ],
          'id': '26125'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5598,
              -4624,
              -7667,
              -8051,
              -5401
            ]
          ],
          'id': '19005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6274,
              -9829,
              -5011,
              9829,
              -9771,
              -7966
            ]
          ],
          'id': '40147'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9830,
              -4585,
              -6496,
              -6798,
              -6316
            ]
          ],
          'id': '30005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5965,
              9831,
              -1554
            ]
          ],
          'id': '51103'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7410,
              -6486,
              -5220,
              -7626,
              -9410,
              -7931,
              -9690,
              -9232,
              -7676
            ]
          ],
          'id': '12003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1264,
              -8113,
              -6649,
              -7770,
              -4856,
              -9341
            ]
          ],
          'id': '22127'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7785,
              -9198,
              -9730,
              -9815,
              -1090,
              -5568
            ]
          ],
          'id': '47117'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1521,
              -9800,
              -1556,
              9832,
              -9568,
              -6143,
              -5725
            ]
          ],
          'id': '51057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -490,
              -2883,
              -1213,
              -3080,
              -9029
            ]
          ],
          'id': '18135'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9833,
              -749,
              -9230,
              -8809
            ]
          ],
          'id': '30101'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3701,
              -9338,
              -5668,
              -5996,
              9834
            ]
          ],
          'id': '23007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1329,
              -1135,
              -5426,
              -2705,
              9835,
              -1622
            ]
          ],
          'id': '26045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8600,
              -1252,
              -9590,
              -2150,
              -7128,
              -3027,
              -5323,
              -5284
            ]
          ],
          'id': '17167'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9836,
              -4096,
              9837,
              -9259
            ]
          ],
          'id': '25001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9838,
              -6892,
              -5478,
              -4550,
              -9475
            ]
          ],
          'id': '30091'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7513,
              -8606,
              -6953,
              -1021,
              -8247,
              -8924,
              -4259
            ]
          ],
          'id': '35041'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9703,
              -5429,
              -7468,
              -6812,
              -3063
            ]
          ],
          'id': '40053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8161,
              9839,
              -3551,
              -9767,
              9840,
              -5239,
              -9775
            ]
          ],
          'id': '42133'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1773,
              -6396,
              -6616,
              -7200,
              -882,
              -9092
            ]
          ],
          'id': '13237'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9649,
              -7812,
              -8902,
              9841
            ]
          ],
          'id': '13257'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9650,
              -9842,
              -8903,
              -1916,
              -9261,
              -8947
            ]
          ],
          'id': '13011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5890,
              -9542,
              -1580,
              -3476,
              -6638,
              -3007,
              -9262
            ]
          ],
          'id': '18073'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3442,
              -663,
              -5155,
              -9268,
              -9032,
              -3450
            ]
          ],
          'id': '20113'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9265,
              -8981,
              -6426,
              -1380,
              9842,
              -3539
            ]
          ],
          'id': '27097'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5233,
              -7183,
              -1081,
              -5390,
              -7145,
              -5574
            ]
          ],
          'id': '37183'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3685,
              -7529,
              -6580,
              -7191,
              -7838,
              -7602
            ]
          ],
          'id': '28151'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9302,
              -9292,
              -9813,
              -8706,
              -7248,
              -294,
              -2683
            ]
          ],
          'id': '19045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7745,
              -9744,
              -9435,
              -7876
            ]
          ],
          'id': '36113'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9445,
              -879,
              -6610,
              9843,
              -2701,
              -8308
            ]
          ],
          'id': '01099'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5576,
              -7144,
              -6875
            ]
          ],
          'id': '37105'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9841,
              -9769,
              9844,
              -5667,
              -9695,
              -7373,
              -5240
            ]
          ],
          'id': '24005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9026,
              -683,
              -812,
              9845,
              -4756,
              -7629,
              -9762,
              -4410,
              -7976
            ]
          ],
          'id': '47065'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -170,
              9846,
              -9776,
              -5242,
              -7372,
              -5491,
              -3764
            ]
          ],
          'id': '24021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5769,
              -1559,
              -5406,
              -5421,
              -4445
            ]
          ],
          'id': '47097'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8134,
              -7870,
              -50,
              -2882,
              -9162,
              -8157,
              -7865,
              -8060
            ]
          ],
          'id': '36025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4172,
              -6391,
              -9279,
              -3638,
              -8331,
              -8225
            ]
          ],
          'id': '01121'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1623,
              -9836,
              -2710,
              -3140,
              -1196,
              -1334
            ]
          ],
          'id': '26025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8640,
              -9647,
              -9641,
              9847,
              -6472,
              -7133
            ]
          ],
          'id': '08015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1178,
              -5148,
              9848,
              -8412,
              -9589
            ]
          ],
          'id': '17139'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9156,
              -6436,
              -7824,
              -9763,
              -3445,
              -7532
            ]
          ],
          'id': '28107'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8403,
              -8717,
              -6085,
              -1998
            ]
          ],
          'id': '30039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9749,
              -6771,
              -4998,
              -9107,
              -6447,
              -5204
            ]
          ],
          'id': '42091'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8338,
              -6940,
              -5884,
              9849,
              -5708,
              -5161,
              -6075
            ]
          ],
          'id': '42061'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8341,
              -9482,
              -9149,
              -6913,
              -9039
            ]
          ],
          'id': '48157'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6211,
              -9709,
              -2101,
              -4366,
              -6823
            ]
          ],
          'id': '41013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8290,
              -8483,
              -6724,
              9850,
              -6849,
              -9822
            ]
          ],
          'id': '37015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8829,
              -2590,
              -9594,
              -9705,
              -4621,
              -9817
            ]
          ],
          'id': '55057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2397,
              -7918,
              -9510,
              9851,
              -9684
            ]
          ],
          'id': '40095'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1721,
              -693,
              -8196,
              -8070,
              -8145,
              -4371
            ]
          ],
          'id': '48331'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6294,
              -4243,
              -2895,
              -1349,
              -584
            ]
          ],
          'id': '26165'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9164,
              -6004,
              -9726,
              -2829,
              -2973
            ]
          ],
          'id': '37159'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -807,
              -9818,
              -4711,
              9852,
              9853,
              -2775
            ]
          ],
          'id': '21239'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7180,
              -7289,
              -5923,
              -5924,
              -6941,
              9854
            ]
          ],
          'id': '40059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -836,
              -6977,
              -6936,
              -9431,
              -2795,
              -428
            ]
          ],
          'id': '55139'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5135,
              -9606,
              -319,
              -9664,
              -6950,
              -5940,
              -6588
            ]
          ],
          'id': '21047'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3135,
              -816,
              -9076,
              -2671,
              -5573,
              -1202
            ]
          ],
          'id': '37001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9724,
              -5851,
              -1316,
              -3868,
              -5379
            ]
          ],
          'id': '21065'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3935,
              -5060,
              -6682,
              -3524,
              -6301,
              -9447,
              -9601
            ]
          ],
          'id': '42129'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6201,
              -5103,
              -9748,
              -1540,
              -1992,
              -5465
            ]
          ],
          'id': '29195'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9855,
              -756,
              -8994,
              -5707,
              -928,
              -605,
              -4975
            ]
          ],
          'id': '46037'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9856,
              -7724,
              -3778,
              -9773,
              -1927,
              -1411,
              -6286
            ]
          ],
          'id': '48029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1743,
              -8801,
              -4772,
              -8137,
              -8146,
              -8031,
              -7693,
              9857
            ]
          ],
          'id': '51019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8990,
              -9271,
              -6928,
              -8613,
              -9752,
              -7170
            ]
          ],
          'id': '39015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9733,
              -6261,
              -9608,
              -8782,
              -9792,
              -2096,
              -6071
            ]
          ],
          'id': '41059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -436,
              -5975,
              -9453,
              -9274,
              -6048
            ]
          ],
          'id': '47129'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -7656,
                -2933
              ]
            ],
            [
              [
                -8365,
                -1744,
                -9858,
                -7692,
                -7542,
                -4732
              ]
            ]
          ],
          'id': '51161'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8965,
              -9016
            ]
          ],
          'id': '51630'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8693,
              -1727,
              -5825,
              -5311,
              -734,
              9858,
              -8624
            ]
          ],
          'id': '53063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8363,
              -7540,
              -7537,
              -7582
            ]
          ],
          'id': '54073'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9859,
              -9480,
              -9003,
              -7008,
              -9002
            ]
          ],
          'id': '72027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9786,
              -9673,
              -7181,
              -9855,
              -6944,
              -1220,
              -6107,
              -7014
            ]
          ],
          'id': '40007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3948,
              -6843,
              9860,
              -2714,
              -5071,
              -8577,
              -6512
            ]
          ],
          'id': '47025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1236,
              -6110,
              -5237,
              -4936,
              -6300,
              -4809,
              -6462,
              -5758
            ]
          ],
          'id': '04001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9209,
              -221,
              -8943,
              -9812,
              -8553,
              -4037
            ]
          ],
          'id': '13145'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7834,
              -7893,
              -9513,
              -9425,
              -7886,
              -7895
            ]
          ],
          'id': '12077'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8470,
              -8077,
              9861,
              9862
            ]
          ],
          'id': '28045'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9863,
              -4897,
              -7778,
              -8906,
              -1936,
              -9687
            ]
          ],
          'id': '39007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2224,
              -6534,
              -3995,
              -9746,
              -7719
            ]
          ],
          'id': '06021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9124,
              -7394,
              -8725,
              -9126,
              -9223,
              9864,
              -5009
            ]
          ],
          'id': '40035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7285,
              -8904,
              -7470,
              -5300,
              -8505
            ]
          ],
          'id': '17087'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7388,
              7386,
              -7386,
              7384,
              -7384,
              7382,
              -7382,
              -9625,
              -5186,
              -7239,
              -8676,
              -3890,
              -1303
            ]
          ],
          'id': '29183'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9865,
              -2900,
              -6276,
              -7965,
              -7465,
              -5427
            ]
          ],
          'id': '20035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7604,
              -3872,
              -7569,
              -8295
            ]
          ],
          'id': '22123'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9866,
              -9547,
              -2234,
              -8838,
              -9458,
              -7018,
              -5984,
              -4268
            ]
          ],
          'id': '38029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6659,
              9867,
              -8804,
              -8508,
              -8967
            ]
          ],
          'id': '29181'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9099,
              -209,
              -1298,
              9868,
              -9297
            ]
          ],
          'id': '06087'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4467,
              -4046,
              -3025,
              -7718,
              9869
            ]
          ],
          'id': '06023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8836,
              -346,
              9870,
              -2518,
              -6691,
              -9459
            ]
          ],
          'id': '46089'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1106,
              -8625,
              -9859,
              -733,
              -8646,
              -7792,
              9871,
              -3630,
              -9607,
              -4735
            ]
          ],
          'id': '53075'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9872,
              -8694,
              -8622,
              -4165
            ]
          ],
          'id': '53019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6622,
              -199,
              -9336,
              -7978,
              -1851,
              -9051
            ]
          ],
          'id': '13273'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -651,
              -1920,
              -8937,
              -9747,
              -9183,
              -6393,
              -9044
            ]
          ],
          'id': '13221'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8374,
              -4656,
              -9651,
              -9254,
              -1496,
              -9485
            ]
          ],
          'id': '30009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5730,
              -5796,
              -9739,
              -3921,
              -7160,
              -8333,
              -5455
            ]
          ],
          'id': '56021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -655,
              -1585,
              -3862,
              -81,
              -6729,
              -7137
            ]
          ],
          'id': '18005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9327,
              -9720,
              -9252,
              -6695,
              -803,
              -6845,
              -6873
            ]
          ],
          'id': '21081'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                9873
              ]
            ],
            [
              [
                -9624,
                9874,
                -8919,
                -4272,
                -3226
              ]
            ]
          ],
          'id': '39043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9875,
              -9853,
              -4715,
              -9782,
              -6593,
              -9821
            ]
          ],
          'id': '21167'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7499,
              -7503,
              -2131,
              -8834,
              -1008,
              -37
            ]
          ],
          'id': '27027'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6002,
              -6818,
              -5848,
              -9723,
              -7085
            ]
          ],
          'id': '21173'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6003,
              -1205,
              -6878,
              -5862,
              -9727
            ]
          ],
          'id': '37123'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9349,
              9876,
              -7685,
              -9028,
              -8957,
              -856,
              -8652
            ]
          ],
          'id': '27053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4300,
              -6506,
              -1342,
              -5133,
              -6587,
              -6042
            ]
          ],
          'id': '21233'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9877,
              -9754,
              -9129,
              -1576,
              -9541
            ]
          ],
          'id': '18091'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2719,
              -6372,
              9878,
              -2546,
              -1323
            ]
          ],
          'id': '20011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9692,
              -2831,
              -9728,
              -6045,
              -5090,
              -5720
            ]
          ],
          'id': '37179'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8243,
              9879,
              -4725,
              -8439
            ]
          ],
          'id': '51810'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8863,
              9880,
              -7127,
              -870,
              -6933,
              -6976,
              -9272
            ]
          ],
          'id': '55009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9848,
              -9640,
              -2344,
              -8359,
              -3273,
              -8353,
              -6473
            ]
          ],
          'id': '08043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9881,
              -9609,
              -8000,
              -6441,
              -8025,
              -7923
            ]
          ],
          'id': '28067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1971,
              -390,
              -7442,
              -7797,
              -4872,
              -9570
            ]
          ],
          'id': '31181'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8440,
              -4729,
              9882,
              -8127,
              -8116,
              -8349
            ]
          ],
          'id': '37029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9616,
              -8423,
              -4764,
              -4321,
              -9667,
              -9676,
              -2552
            ]
          ],
          'id': '48251'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1796,
              -8641,
              -7131,
              -6355,
              -2156,
              -9229
            ]
          ],
          'id': '08077'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5978,
              -6799,
              -5718,
              -4685,
              -1984
            ]
          ],
          'id': '30013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5156,
              -661,
              -1127,
              -376,
              -2901,
              -9866,
              -4791
            ]
          ],
          'id': '20015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6501,
              -5297,
              -5932,
              -9017,
              -1781,
              -9285
            ]
          ],
          'id': '38025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5585,
              -4384,
              -363,
              -9793,
              -5683,
              -8532
            ]
          ],
          'id': '49035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7054,
              9883,
              -5028,
              -8733,
              -8421,
              -262
            ]
          ],
          'id': '48121'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2243,
              -4758,
              -126,
              -702,
              -1423,
              -5001,
              -9780,
              -7201,
              -627
            ]
          ],
          'id': '46023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9755,
              -5463,
              -9731,
              -3803,
              -4769,
              -8800
            ]
          ],
          'id': '51125'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7683,
              -3291,
              -1124,
              9884,
              -119,
              -4182,
              -6222
            ]
          ],
          'id': '72043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9071,
              -9764,
              -9614,
              -9716,
              -2691,
              -9546,
              -9159
            ]
          ],
          'id': '38103'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9885,
              -6865,
              -9732,
              -1757
            ]
          ],
          'id': '72051'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1816,
              -9545,
              -1172,
              -8910,
              -1873,
              -4125
            ]
          ],
          'id': '17143'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6449,
              -9109,
              -9715,
              -8218,
              -4508,
              -9741,
              -5247
            ]
          ],
          'id': '34015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -666,
              -5766,
              -5732,
              -7686,
              -9877,
              -9348
            ]
          ],
          'id': '27003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -345,
              -7787,
              -757,
              -9856,
              -4974,
              -8023,
              -2519,
              -9871
            ]
          ],
          'id': '46013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5921,
              -3065,
              -6815,
              -1390,
              -403,
              -9682,
              -5925
            ]
          ],
          'id': '40093'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -930,
              -5706,
              -5356,
              -8100,
              -3679,
              -9501,
              -9628
            ]
          ],
          'id': '46039'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2016,
              9886
            ]
          ],
          'id': '02230'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1633,
              -6388,
              -6168,
              -6387,
              -4745,
              -7593,
              -1485,
              -5194
            ]
          ],
          'id': '47163'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6508,
              -5555,
              9887
            ]
          ],
          'id': '44001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8578,
              -5075,
              -6694,
              -5614,
              -6186,
              -4317,
              -9454,
              -5973
            ]
          ],
          'id': '47093'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8870,
              -828,
              -1484,
              -5457,
              -471,
              -7278,
              -8601,
              -6014
            ]
          ],
          'id': '56007'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5648,
              -6985,
              -242,
              -3546,
              -9840,
              -8160,
              -8802
            ]
          ],
          'id': '42043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7668
            ]
          ],
          'id': '51580'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2839,
              -9706,
              -7856,
              -8883,
              -8875,
              -8001
            ]
          ],
          'id': '55049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6997,
              -9278,
              -6994,
              -9277,
              -809,
              -681,
              -5839
            ]
          ],
          'id': '47175'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2922,
              -7725,
              -9857,
              -6285,
              -1913,
              -8715
            ]
          ],
          'id': '48019'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9174,
              -9493,
              -3849,
              -2876
            ]
          ],
          'id': '12059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5448,
              -501,
              -9526
            ]
          ],
          'id': '41055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8683,
              -9809,
              -7308,
              -9176,
              -8494
            ]
          ],
          'id': '01067'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8916,
              -8458,
              -5635,
              -7526,
              -5626,
              -7945,
              -8874
            ]
          ],
          'id': '05139'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8037,
              -8373,
              -7099,
              -9472,
              -7521,
              -8759
            ]
          ],
          'id': '54031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9323,
              -5993,
              9888,
              -8278,
              -4431,
              -5228,
              -1101,
              -9246
            ]
          ],
          'id': '22017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2615,
              -7663,
              -7252,
              -4043
            ]
          ],
          'id': '41029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7251,
              -4138,
              4136,
              -8150,
              -8642,
              -566,
              -4045
            ]
          ],
          'id': '06049'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7492,
              -5497,
              -9322,
              -6299,
              -9671,
              -3428
            ]
          ],
          'id': '28003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9417,
              -8645,
              -3368,
              -7235,
              -2335
            ]
          ],
          'id': '08011'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7768,
              -7138,
              -6731,
              -71,
              -3456,
              -6545
            ]
          ],
          'id': '18105'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8469,
              -9498,
              9889,
              -4071
            ]
          ],
          'id': '21029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1925,
              -6922,
              -9816,
              -8361,
              -9632,
              -9807
            ]
          ],
          'id': '39121'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4310,
              -2776,
              -9854,
              -9876,
              -9820,
              9890,
              -9496
            ]
          ],
          'id': '21005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9890,
              -9497,
              -9891,
              -9819,
              -9194,
              -5803,
              -4072
            ]
          ],
          'id': '21179'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7049,
              -5366,
              -9619,
              -4386,
              -5587
            ]
          ],
          'id': '49057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7037,
              -6163,
              -1238,
              -725,
              -3,
              -8081
            ]
          ],
          'id': '49025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3350,
              -9155,
              -8213,
              -8277,
              -9889,
              -5992,
              -5783,
              -3351
            ]
          ],
          'id': '05091'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7212,
              -7659,
              -5963,
              9891,
              -9765,
              -9669
            ]
          ],
          'id': '45079'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9691,
              -7929,
              -8590,
              -2502,
              -8086,
              9892,
              -5373
            ]
          ],
          'id': '12107'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9893,
              -5948,
              -8905,
              -7283,
              -7379,
              -9564
            ]
          ],
          'id': '17077'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9823,
              -6853,
              -7190,
              9894,
              -6846,
              -3957,
              -4264
            ]
          ],
          'id': '37013'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -368,
              -6670,
              -8091,
              9895
            ]
          ],
          'id': '36123'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8177,
              -3496,
              -5991,
              -9750,
              -3508,
              -1226,
              -5858
            ]
          ],
          'id': '47111'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4381,
              -977,
              -5580,
              -9037,
              9896
            ]
          ],
          'id': '48323'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1010,
              -8835,
              -6736,
              -6272,
              -7396,
              -8993
            ]
          ],
          'id': '27155'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8845,
              -8886,
              -9430,
              -4634,
              -9781,
              -8152
            ]
          ],
          'id': '32001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5129,
              -5789,
              -8889,
              -1479,
              -5872,
              -6860
            ]
          ],
          'id': '56005'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7828,
              -8030,
              -9621,
              -5451,
              -9635,
              -8280,
              -5601
            ]
          ],
          'id': '53059'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1960,
              -2512,
              -8773,
              -8932,
              -3556,
              -9294,
              -3390
            ]
          ],
          'id': '13315'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                9897
              ]
            ],
            [
              [
                -9007,
                9898,
                -7762
              ]
            ]
          ],
          'id': '72053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9276,
              -9456,
              -4752,
              -9846,
              -811
            ]
          ],
          'id': '47143'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1319,
              -6586,
              -5582,
              -5154,
              -5778,
              -3826
            ]
          ],
          'id': '21025'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6371,
              -7441,
              -313,
              -1977,
              -1606,
              -2547,
              -9879
            ]
          ],
          'id': '29217'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9844,
              -6609,
              -9824,
              -314,
              -7969,
              -9521,
              -2702
            ]
          ],
          'id': '01053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5374,
              -9893,
              -8089,
              -7338,
              -3855,
              -7836,
              -7407
            ]
          ],
          'id': '12083'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9872,
              -7796,
              -8780,
              -3631
            ]
          ],
          'id': '53003'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9489,
              -9118,
              -8793,
              -8805,
              -9868,
              -6658
            ]
          ],
          'id': '29023'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7380,
              -7288,
              -9287,
              -6148,
              -9117,
              -6653
            ]
          ],
          'id': '29031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5564,
              -6787,
              -1636,
              -2711,
              -9861,
              -6842
            ]
          ],
          'id': '51105'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2993,
              -9495,
              -2408,
              -8057,
              -9451,
              9449,
              -9449,
              -8367
            ]
          ],
          'id': '01043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5147,
              -3517,
              -7501,
              -3419,
              -8413,
              -9849
            ]
          ],
          'id': '17029'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9559,
              -7609,
              -2570,
              -5935,
              -6637
            ]
          ],
          'id': '18015'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                9899
              ]
            ],
            [
              [
                -8305,
                -7296,
                9900,
                -8182
              ]
            ]
          ],
          'id': '22075'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5816,
              -464,
              -9656,
              -919,
              -9344
            ]
          ],
          'id': '31091'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5295,
              -9161,
              -9548,
              -9867,
              -4267,
              -4206
            ]
          ],
          'id': '38015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5691,
              -3978,
              -7672,
              -8366,
              -7673
            ]
          ],
          'id': '54063'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7599,
              -8336,
              -7782,
              -5003,
              -9665
            ]
          ],
          'id': '47021'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7149,
              -7884,
              -5894,
              -9506,
              -6986,
              -6833,
              -7432
            ]
          ],
          'id': '42015'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7336,
              -9783,
              -4796,
              -4313,
              -8467
            ]
          ],
          'id': '21185'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -7267,
              -7728,
              -3842,
              -2265,
              -9422,
              -7879
            ]
          ],
          'id': '05101'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8848,
              -9774,
              -9312,
              -1641,
              -7655,
              -5633,
              -9735,
              -9066,
              -5288
            ]
          ],
          'id': '33009'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -6934,
              -873,
              9901,
              -5603,
              -9565,
              -9432
            ]
          ],
          'id': '55117'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2965,
              -9610,
              -9882,
              -7922,
              -6791,
              -6738
            ]
          ],
          'id': '28129'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8379,
              -8471,
              -9863,
              9902,
              -8303,
              -8180,
              -9452,
              -16
            ]
          ],
          'id': '22103'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9573,
              -9566,
              -5493,
              -7375,
              -9697,
              -9144,
              -9504,
              -9789
            ]
          ],
          'id': '24033'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1387,
              -3540,
              -9843,
              -1379,
              -9350,
              -8650,
              -347,
              -866,
              -9630
            ]
          ],
          'id': '27145'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9530,
              -7592,
              -3666,
              -5798,
              -3664,
              -5799,
              -8270
            ]
          ],
          'id': '25017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5709,
              -9850,
              -5883,
              -8803,
              -8163,
              -9777,
              -9847,
              -169
            ]
          ],
          'id': '42055'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9592,
              -2808,
              -5949,
              -9894,
              -9563
            ]
          ],
          'id': '17145'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -5471,
              -4441,
              -1305,
              -3894,
              -8099,
              -5042,
              -5469
            ]
          ],
          'id': '29073'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -1216,
              -8708,
              -8273,
              -2850,
              -9611
            ]
          ],
          'id': '18161'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8677,
              -8637,
              -9011,
              -9191,
              -2997,
              -3892
            ]
          ],
          'id': '29099'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9830,
              -5010,
              -9865,
              -9224,
              -3922,
              -9772
            ]
          ],
          'id': '40131'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9892,
              -5962,
              -5193,
              -9644,
              -9766
            ]
          ],
          'id': '45017'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3967,
              -7583,
              -6973,
              -7995,
              -7756,
              -9054,
              9903
            ]
          ],
          'id': '54035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              9904
            ]
          ],
          'id': '69100'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9885,
              -1123,
              -2185,
              -5617,
              9905,
              -120
            ]
          ],
          'id': '72123'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -2791,
              -9688,
              -9040,
              -6152,
              -4642,
              -8988
            ]
          ],
          'id': '48239'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                9906
              ]
            ],
            [
              [
                -641,
                -8627,
                9907
              ]
            ]
          ],
          'id': '53035'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3042,
              -9810,
              -9210,
              9908,
              -7903
            ]
          ],
          'id': '12057'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8428,
              -9428,
              -4876
            ]
          ],
          'id': '17043'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9058,
              -4921,
              -8188,
              -7452,
              -8667,
              -9304
            ]
          ],
          'id': '34031'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9685,
              -9852,
              -9512,
              -9811,
              -5024,
              -9884,
              -7053
            ]
          ],
          'id': '48181'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4781,
              -9805,
              -8720,
              -9523
            ]
          ],
          'id': '13283'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -457,
              -92,
              -9515,
              -2601,
              -9239,
              -3104,
              -2435
            ]
          ],
          'id': '28155'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -9120,
              -921,
              -9657,
              -9561,
              -7420,
              -8658
            ]
          ],
          'id': '31101'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -8018,
              -4531,
              -9652,
              -8020,
              -8005
            ]
          ],
          'id': '28001'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -4129,
              -760,
              -369,
              -9896,
              -8090,
              -6523
            ]
          ],
          'id': '36069'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -3968,
              -9904,
              -9056,
              -6527,
              -3972
            ]
          ],
          'id': '54053'
        },
        {
          'type': 'Polygon',
          'arcs': [
            [
              -729,
              -3837,
              -6406,
              -3089,
              -9
            ]
          ],
          'id': '04025'
        }
      ]
    },
    'states': {
      'type': 'GeometryCollection',
      'geometries': [
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -1237,
                -1236,
                -6110,
                -5237,
                -4936,
                -6300,
                4809,
                -3762,
                4810,
                -4930,
                7206,
                284,
                4806,
                5761,
                5759,
                3091,
                3087,
                -2005,
                10,
                11,
                0,
                1,
                2,
                724,
                725
              ]
            ]
          ],
          'id': '04'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -8471,
                -9863,
                9902,
                8303,
                7294,
                9900,
                8182,
                8388,
                8517,
                8385,
                8518,
                4352,
                4841,
                3878,
                4077,
                4078,
                -3796,
                -3795,
                5571,
                -9182,
                6564,
                5748,
                5749,
                5750,
                5230,
                -1102,
                -1101,
                -9246,
                -9323,
                -5993,
                9888,
                8276,
                -8212,
                5498,
                5499,
                7943,
                7944,
                5625,
                -7525,
                -7605,
                -7604,
                3872,
                3873,
                -3703,
                -3702,
                -3710,
                -3709,
                -3708,
                8016,
                -4532,
                8017,
                8004,
                8005,
                7353,
                7345,
                -2516,
                -2515,
                12,
                13,
                -2163,
                8376,
                -7821,
                8377
              ]
            ],
            [
              [
                4842
              ]
            ],
            [
              [
                7291
              ]
            ],
            [
              [
                7292
              ]
            ],
            [
              [
                7293
              ]
            ],
            [
              [
                8383
              ]
            ],
            [
              [
                8515
              ]
            ],
            [
              [
                8516
              ]
            ],
            [
              [
                9899
              ]
            ]
          ],
          'id': '22'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                9094,
                -6826,
                9095,
                -9140,
                7403,
                -9139,
                -2989,
                -2988,
                8463,
                3266,
                7794,
                7795,
                7791,
                8645,
                732,
                733,
                5310,
                5824,
                -1726,
                1246,
                1243,
                1244,
                -5369,
                -2351,
                -2350,
                4194,
                -6018,
                8382,
                3264,
                -2001,
                -2000,
                -1530,
                -1529,
                -1528,
                5808,
                -5537,
                5809,
                -6344,
                4087,
                4088,
                -4592,
                -4598,
                8485,
                -5364,
                4058,
                4059,
                3379,
                3380,
                8218
              ]
            ]
          ],
          'id': '16'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                5268,
                5266,
                2259,
                9744,
                7494,
                2906,
                4131,
                3591,
                4132,
                2908,
                2909,
                1761,
                -7935,
                -7851,
                5763,
                5764,
                5733,
                5734,
                -5715,
                -5714,
                -5713,
                -6331,
                -6330,
                -7001,
                -7000,
                -9345,
                -8121,
                5596,
                -4625,
                5597,
                -5400,
                -5399,
                -477,
                -476,
                -2809,
                6569,
                1362,
                1363,
                5775,
                5776,
                2765,
                -2738,
                -2737,
                5681,
                -3823,
                3182,
                3183,
                744,
                -102,
                1517,
                3677,
                3678,
                8099,
                5355,
                5356,
                -5705,
                7397,
                -8993,
                -1010,
                -1009,
                -1008,
                -37,
                -36,
                -6170,
                31,
                32,
                -6446,
                -4338,
                -6120
              ]
            ]
          ],
          'id': '27'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                35,
                36,
                1007,
                1008,
                1009,
                1010,
                -754,
                7786,
                344,
                345,
                8835,
                8836,
                -9458,
                -7018,
                5984,
                -3771,
                -6969,
                -6968,
                -6252,
                719,
                -6251,
                -3746,
                -3745,
                -4025,
                -4551,
                5477,
                6891,
                6889,
                9538,
                492,
                2192,
                3267,
                1641,
                2741,
                6118,
                -5269,
                6119,
                4337,
                6445,
                -33,
                -32,
                6169
              ]
            ]
          ],
          'id': '38'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                1423,
                -6291,
                -6253,
                6967,
                6968,
                3770,
                -5985,
                7017,
                9457,
                -8837,
                -8836,
                -346,
                -345,
                -7787,
                753,
                -1011,
                8992,
                -7398,
                5704,
                -5357,
                -5356,
                -8100,
                -3679,
                -3678,
                -1518,
                101,
                102,
                6123,
                6124,
                4978,
                -4788,
                -3644,
                4979,
                4980,
                5081,
                5082,
                6088,
                6089,
                4999,
                -9780,
                -7201,
                627,
                628,
                7033,
                3202,
                353,
                -8856,
                -2610,
                2561,
                2562,
                2563,
                4562,
                4563,
                4968,
                43,
                44,
                1427
              ]
            ]
          ],
          'id': '46'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -7864,
                -7882,
                7147,
                7148,
                7431,
                -6832,
                -6831,
                -8041,
                2927,
                2928,
                8890,
                8891,
                8962,
                -4894,
                8960,
                9517,
                7459,
                391,
                4127,
                757,
                9489,
                3716,
                6367,
                4526,
                8012,
                8796,
                -8346,
                8797,
                7741,
                7742,
                -9660,
                -6208,
                -8748,
                -8749,
                -5341,
                -5347,
                -5346,
                -9171,
                -8189,
                8185,
                7453,
                7454,
                9224,
                9073,
                3741,
                6364,
                3739,
                9074,
                8877,
                4521,
                4516,
                4517,
                -7449,
                -7448,
                -7447,
                8187,
                4920,
                4921,
                4922,
                -6868,
                -7866,
                -7865
              ]
            ],
            [
              [
                6361
              ]
            ],
            [
              [
                6362
              ]
            ],
            [
              [
                6363
              ]
            ],
            [
              [
                6365
              ]
            ],
            [
              [
                6368
              ]
            ],
            [
              [
                9156,
                -8867,
                9157,
                -7516
              ]
            ]
          ],
          'id': '36'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                51
              ]
            ],
            [
              [
                52
              ]
            ],
            [
              [
                53
              ]
            ],
            [
              [
                8823,
                2018,
                1446,
                8571,
                2089,
                9403,
                9234,
                9152,
                9407,
                2063,
                2076,
                2043,
                2071,
                762,
                2072,
                6402,
                4962,
                6404,
                4964,
                521,
                9553,
                1778,
                3599,
                2416,
                2812,
                2087,
                8570,
                1444,
                2019,
                9886,
                2016,
                8821,
                1429,
                1654,
                55,
                8568,
                3184,
                8569,
                57,
                1655,
                1431,
                8822,
                1433
              ]
            ],
            [
              [
                58
              ]
            ],
            [
              [
                59
              ]
            ],
            [
              [
                1434
              ]
            ],
            [
              [
                1436,
                8819
              ]
            ],
            [
              [
                1437
              ]
            ],
            [],
            [
              [
                1439
              ]
            ],
            [
              [
                1440
              ]
            ],
            [
              [
                1442,
                3210
              ]
            ],
            [
              [
                1652,
                3197
              ]
            ],
            [
              [
                2014
              ]
            ],
            [
              [
                2025
              ]
            ],
            [
              [
                2026
              ]
            ],
            [
              [
                2027
              ]
            ],
            [
              [
                2028
              ]
            ],
            [
              [
                2029
              ]
            ],
            [
              [
                2030
              ]
            ],
            [
              [
                2031
              ]
            ],
            [
              [
                2032
              ]
            ],
            [
              [
                2033
              ]
            ],
            [
              [
                2034
              ]
            ],
            [
              [
                2035
              ]
            ],
            [
              [
                2036
              ]
            ],
            [
              [
                2037
              ]
            ],
            [
              [
                2038
              ]
            ],
            [
              [
                2039
              ]
            ],
            [
              [
                2040
              ]
            ],
            [
              [
                2041
              ]
            ],
            [
              [
                2044
              ]
            ],
            [
              [
                2045
              ]
            ],
            [
              [
                2046
              ]
            ],
            [
              [
                2047
              ]
            ],
            [
              [
                2048
              ]
            ],
            [
              [
                2049
              ]
            ],
            [
              [
                2050
              ]
            ],
            [
              [
                2051
              ]
            ],
            [
              [
                2052
              ]
            ],
            [
              [
                2053
              ]
            ],
            [
              [
                2054
              ]
            ],
            [
              [
                2055
              ]
            ],
            [
              [
                2056
              ]
            ],
            [
              [
                2057
              ]
            ],
            [
              [
                2058
              ]
            ],
            [
              [
                2059
              ]
            ],
            [
              [
                2060
              ]
            ],
            [
              [
                2061
              ]
            ],
            [
              [
                2065
              ]
            ],
            [
              [
                2066
              ]
            ],
            [
              [
                2067
              ]
            ],
            [
              [
                2068
              ]
            ],
            [
              [
                2069
              ]
            ],
            [
              [
                2070
              ]
            ],
            [
              [
                2077
              ]
            ],
            [
              [
                2078
              ]
            ],
            [
              [
                2079
              ]
            ],
            [
              [
                2080
              ]
            ],
            [
              [
                2081
              ]
            ],
            [
              [
                2082
              ]
            ],
            [
              [
                2083
              ]
            ],
            [
              [
                2084
              ]
            ],
            [
              [
                3186
              ]
            ],
            [
              [
                3187
              ]
            ],
            [
              [
                3188
              ]
            ],
            [
              [
                3189
              ]
            ],
            [
              [
                3190
              ]
            ],
            [
              [
                3191
              ]
            ],
            [
              [
                3192
              ]
            ],
            [
              [
                3193
              ]
            ],
            [
              [
                3194
              ]
            ],
            [
              [
                3195
              ]
            ],
            [
              [
                3196
              ]
            ],
            [
              [
                3198,
                3208
              ]
            ],
            [
              [
                3209
              ]
            ],
            [
              [
                4965
              ]
            ],
            [
              [
                4966
              ]
            ],
            [
              [
                4967
              ]
            ],
            [
              [
                6400
              ]
            ],
            [
              [
                6401
              ]
            ],
            [
              [
                6403
              ]
            ],
            [
              [
                8564
              ]
            ],
            [
              [
                8565
              ]
            ],
            [
              [
                8566
              ]
            ],
            [
              [
                8567
              ]
            ],
            [
              [
                8820
              ]
            ],
            [
              [
                9235
              ]
            ],
            [
              [
                9356
              ]
            ],
            [
              [
                9357
              ]
            ],
            [
              [
                9358
              ]
            ],
            [
              [
                9359
              ]
            ],
            [
              [
                9360
              ]
            ],
            [
              [
                9361
              ]
            ],
            [
              [
                9362
              ]
            ],
            [
              [
                9363
              ]
            ],
            [
              [
                9364
              ]
            ],
            [
              [
                9365
              ]
            ],
            [
              [
                9366
              ]
            ],
            [
              [
                9367
              ]
            ],
            [
              [
                9368
              ]
            ],
            [
              [
                9369
              ]
            ],
            [
              [
                9370
              ]
            ],
            [
              [
                9371
              ]
            ],
            [
              [
                9372
              ]
            ],
            [
              [
                9373
              ]
            ],
            [
              [
                9374
              ]
            ],
            [
              [
                9375
              ]
            ],
            [
              [
                9376
              ]
            ],
            [
              [
                9377
              ]
            ],
            [
              [
                9378
              ]
            ],
            [
              [
                9379
              ]
            ],
            [
              [
                9380
              ]
            ],
            [
              [
                9381
              ]
            ],
            [
              [
                9382
              ]
            ],
            [
              [
                9383
              ]
            ],
            [
              [
                9384
              ]
            ],
            [
              [
                9385
              ]
            ],
            [
              [
                9386
              ]
            ],
            [
              [
                9387
              ]
            ],
            [
              [
                9388
              ]
            ],
            [
              [
                9389
              ]
            ],
            [
              [
                9390
              ]
            ],
            [
              [
                9391
              ]
            ],
            [
              [
                9392
              ]
            ],
            [
              [
                9393
              ]
            ],
            [
              [
                9394
              ]
            ],
            [
              [
                9395
              ]
            ],
            [
              [
                9396
              ]
            ],
            [
              [
                9397
              ]
            ],
            [
              [
                9398
              ]
            ],
            [
              [
                9399
              ]
            ],
            [
              [
                9400
              ]
            ],
            [
              [
                9401
              ]
            ],
            [
              [
                9402
              ]
            ],
            [
              [
                9404
              ]
            ],
            [
              [
                9405
              ]
            ],
            [
              [
                9406
              ]
            ],
            [
              [
                9551
              ]
            ],
            [
              [
                9552
              ]
            ],
            [
              [
                9554
              ]
            ],
            [
              [
                9555
              ]
            ]
          ],
          'id': '02'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                4013,
                -4648,
                -4458,
                4414,
                -4457,
                7976,
                7974,
                7975,
                4409,
                9761,
                7166,
                4050,
                4051,
                2136,
                2137,
                -8266,
                -7808,
                -7807,
                -7806,
                -7737,
                -7814,
                -7813,
                -7812,
                -7811,
                6539,
                -4560,
                -4559,
                -6063,
                -5957,
                -5956,
                -5955,
                8760,
                -9629,
                -6134,
                -6133,
                8549,
                -6034,
                -6033,
                -5528,
                -5527,
                -4916,
                -4915,
                9807,
                7227,
                4482,
                9733,
                4822,
                9354,
                -7623,
                5218,
                5219,
                6485,
                7409,
                7410,
                7140,
                7141,
                8938,
                -7631,
                -7630,
                -7898,
                7305,
                7306,
                2113,
                2114,
                847,
                848,
                7983,
                7984,
                7311,
                7307,
                9808,
                -8682,
                -8681,
                -8680,
                -8172,
                3584,
                -8171,
                -8554,
                -8553,
                -4037,
                -4036,
                -7646,
                3590,
                -7645,
                -9280,
                63,
                5813,
                -4649
              ]
            ]
          ],
          'id': '13'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                5671,
                7429,
                -3515,
                -3514,
                8414,
                -8580,
                3003,
                3004,
                -9088,
                -8461,
                5891,
                5885,
                5886,
                5887,
                9539,
                9877,
                -9754,
                9127,
                -7415,
                5315,
                -2802,
                2677,
                -1199,
                -1198,
                -3144,
                -6911,
                -6910,
                -1088,
                -1087,
                2201,
                -1905,
                -1904,
                8572,
                487,
                488,
                -2883,
                1213,
                1214,
                -8708,
                -8273,
                2850,
                -9205,
                -9328,
                4514,
                7432,
                -6874,
                -3125,
                -3130,
                7445,
                7334,
                7335,
                7336,
                4479,
                7840,
                -4069,
                -6839,
                4474,
                4885,
                -4294,
                -4701,
                -4700,
                -7291,
                -7290,
                -6504,
                -6503,
                4062,
                4063,
                4064,
                4065,
                7246,
                -5557,
                4891,
                -4845,
                4886,
                5674
              ]
            ]
          ],
          'id': '18'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                7315,
                9280,
                7365,
                8399,
                -3722,
                -3721,
                7483,
                3141,
                3142,
                3143,
                1197,
                1198,
                -2678,
                2801,
                -5316,
                7414,
                -9128,
                9753,
                9752,
                9330,
                9769,
                5854,
                1358,
                4859,
                1352,
                586,
                8327,
                9796,
                6292,
                2645,
                7477,
                8391,
                9483,
                9425,
                3687,
                8727,
                9030,
                3252,
                3675,
                8441,
                8521,
                482
              ]
            ],
            [
              [
                -5214,
                5506,
                5507,
                3692,
                3693,
                3694,
                3695,
                3689,
                9076,
                5415,
                9802,
                5417,
                4496,
                8971,
                5136,
                2272,
                7615,
                7620,
                7931,
                9718,
                1667,
                -205,
                203,
                -203,
                -202,
                4108
              ]
            ],
            [
              [
                7478
              ]
            ],
            [
              [
                7479
              ]
            ],
            [
              [
                7480
              ]
            ],
            [
              [
                7481
              ]
            ],
            [
              [
                7614
              ]
            ],
            [
              [
                7617
              ]
            ],
            [
              [
                7618
              ]
            ],
            [
              [
                7619
              ]
            ],
            [
              [
                9716
              ]
            ],
            [
              [
                9717
              ]
            ],
            [
              [
                9793
              ]
            ],
            [
              [
                9794
              ]
            ],
            [
              [
                9795
              ]
            ],
            [
              [
                9797
              ]
            ],
            [
              [
                9801
              ]
            ],
            [
              [
                9803
              ]
            ]
          ],
          'id': '26'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -8317,
                -8318,
                -8320,
                -7261,
                -7260,
                336,
                337,
                -7254,
                -7259,
                7997,
                -8410,
                -8691,
                -8690,
                -8689,
                9596,
                8075,
                9861,
                9862,
                8470,
                -8378,
                7820,
                -8377,
                2162,
                -14,
                -13,
                2514,
                2515,
                -7346,
                -7354,
                -8006,
                -8005,
                -8018,
                4531,
                -8017,
                3707,
                3708,
                3709,
                3701,
                3702,
                -3874,
                -7603,
                -7602,
                3685,
                3680,
                3681,
                -7320,
                -7319,
                7532,
                7529,
                7370,
                -4569,
                -4568,
                7415,
                -8737,
                -7493,
                3426,
                -7492,
                -5497,
                -9322,
                6295,
                -4227,
                -4802,
                -4956,
                -4959,
                9061,
                9103,
                -8314
              ]
            ],
            [
              [
                8072
              ]
            ],
            [
              [
                8073
              ]
            ],
            [
              [
                9594
              ]
            ],
            [
              [
                9595
              ]
            ]
          ],
          'id': '28'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                1086,
                1087,
                6909,
                6910,
                -3143,
                -3142,
                -7484,
                3720,
                3721,
                3722,
                9622,
                9874,
                8916,
                9089,
                9685,
                9863,
                -4897,
                -7778,
                -7777,
                -5910,
                -5909,
                -5906,
                -5905,
                -1014,
                7712,
                -8209,
                -6400,
                -8261,
                6919,
                -4943,
                -4946,
                -3299,
                -7539,
                -7541,
                8362,
                -7581,
                -7580,
                3965,
                3966,
                3967,
                3971,
                3972,
                -6526,
                8969,
                -6058,
                8970,
                8818,
                -5432,
                -5438,
                8615,
                -9752,
                -7170,
                -7169,
                8990,
                -7342,
                -7345,
                9202,
                9203,
                9204,
                -2851,
                8272,
                8707,
                -1215,
                -1214,
                2882,
                -489,
                -488,
                -8573,
                1903,
                1904,
                -2202
              ]
            ],
            [
              [
                9621
              ]
            ],
            [
              [
                9873
              ]
            ]
          ],
          'id': '39'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                8900,
                5868,
                7035,
                7992,
                9350,
                -7648,
                -4882,
                -4881,
                -4880,
                -5040,
                -5039,
                -5038,
                -8248,
                3798,
                3155,
                1718,
                509,
                1019,
                1020,
                6952,
                6953,
                -8605,
                190,
                191,
                -7511,
                -7510,
                -4154,
                -4153,
                5878,
                4031,
                4032,
                630,
                6105,
                6106,
                1219,
                1220,
                2621,
                2622,
                3408,
                -541,
                -540,
                -9186,
                511,
                9164,
                -6965,
                -6964,
                7056,
                7559,
                -3734,
                -3733,
                -4744,
                -4743,
                9205,
                7051,
                -9685,
                -9852,
                -9512,
                -9511,
                9262,
                -4536,
                -4535,
                -8260,
                5781,
                -3352,
                5782,
                5991,
                5992,
                9322,
                9245,
                1100,
                1101,
                -5231,
                -5751,
                -5750,
                -5749,
                -6565,
                9181,
                -5572,
                3794,
                3795,
                -4079,
                5438,
                4159,
                9735,
                4161,
                9144,
                9737,
                6915,
                9736,
                6917,
                6154,
                4643,
                3783,
                8749,
                9130,
                6514,
                7561,
                9417,
                7563,
                6516,
                9131,
                8751,
                3781,
                4644,
                6102,
                3785,
                4640,
                3787,
                6103,
                3789,
                8557,
                8752,
                9132,
                6518,
                7564,
                9418,
                8044,
                9302,
                3780,
                9037,
                9896,
                4381,
                9332
              ]
            ]
          ],
          'id': '48'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                6958,
                9007,
                8735,
                9459,
                7788,
                7003,
                4357,
                8743,
                8741,
                2129,
                7108,
                9476,
                8998,
                9000,
                9859,
                9478,
                8396,
                9341,
                9750,
                6024,
                1755,
                9885,
                6861,
                141,
                8895,
                9477,
                4193,
                6892,
                9005,
                9898,
                7762,
                8725,
                2758,
                9482,
                3601,
                9309,
                3001,
                5615,
                9905,
                120,
                4182
              ]
            ],
            [
              [
                6955
              ]
            ],
            [
              [
                7818
              ]
            ],
            [
              [
                8744
              ]
            ],
            [
              [
                8745
              ]
            ],
            [
              [
                9428
              ]
            ],
            [
              [
                9897
              ]
            ]
          ],
          'id': '72'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                8658,
                9661,
                9662,
                3918,
                3919,
                3920,
                9738,
                -5795,
                -5794,
                -5793,
                -7438,
                -2563,
                -2562,
                2609,
                8855,
                -354,
                -3203,
                -7034,
                -629,
                -628,
                7200,
                9779,
                -5000,
                -6090,
                -6089,
                -5083,
                -5082,
                -4981,
                -4980,
                -3643,
                -3642,
                8841,
                -9181,
                -7505,
                5441,
                -3650,
                -3649,
                -3648,
                -3738,
                -3737,
                -5279,
                4861,
                4862,
                -6233,
                8320,
                4209,
                4210,
                4211,
                4212,
                3405,
                3406,
                -7800,
                -3068,
                -3067,
                -8235,
                7443,
                7444,
                -7797,
                -4872,
                -4871,
                -2648,
                -2647,
                -176,
                -2983,
                -2982,
                4215,
                1603,
                -7302,
                -5253,
                -2957,
                156,
                152,
                -2953,
                7421
              ]
            ]
          ],
          'id': '31'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                164,
                165,
                618,
                619,
                -6108,
                4049,
                -1235,
                -1234,
                -1233,
                -1232,
                -9229,
                1796,
                1790,
                -7689,
                -7688,
                -4376,
                -6015,
                8600,
                7277,
                470,
                471,
                -5456,
                8332,
                7159,
                -3920,
                -3919,
                -9663,
                -9662,
                -8659,
                -7422,
                2952,
                -153,
                -157,
                2956,
                2957,
                -5255,
                -3330,
                -1212,
                -1211,
                -5319,
                -5321,
                -5320,
                -2906,
                -7232,
                3369,
                3370,
                3371,
                3372,
                -4151,
                7235,
                7157,
                -5979
              ]
            ],
            [],
            [],
            [],
            []
          ],
          'id': '08'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -9841,
                9766,
                -3550,
                -3549,
                -5207,
                -5252,
                -5251,
                5484,
                -7401,
                998,
                999,
                5307,
                4489,
                9536,
                9537,
                -9213,
                -9212,
                9533,
                4495,
                5308,
                5650,
                9219,
                5486,
                7313,
                9767,
                9844,
                5664,
                9695,
                9141,
                4847,
                9504,
                9502,
                -9789,
                -9573,
                -9566,
                5493,
                5494,
                -3765,
                -3764,
                170,
                171,
                172,
                173,
                331,
                332,
                333,
                5408,
                5409,
                5410,
                5406,
                5407,
                328,
                329,
                330,
                167,
                168,
                9846,
                -9776,
                5237,
                5238
              ]
            ],
            [
              [
                5305,
                9535
              ]
            ],
            [
              [
                5651
              ]
            ],
            [
              [
                -9218,
                9534
              ]
            ]
          ],
          'id': '24'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                4870,
                4871,
                7796,
                -7445,
                -7444,
                8234,
                3066,
                3067,
                7799,
                -3407,
                -3406,
                -4213,
                -4212,
                -4211,
                4627,
                4628,
                4629,
                -6290,
                7696,
                8618,
                9034,
                -7488,
                -5898,
                -5902,
                -8329,
                4080,
                4081,
                6369,
                6370,
                9878,
                2546,
                -1610,
                2547,
                -4112,
                -1648,
                7392,
                7393,
                9123,
                -5008,
                -5007,
                9828,
                6273,
                6274,
                -7965,
                -7465,
                5427,
                5428,
                9702,
                -3062,
                737,
                738,
                -5920,
                7288,
                7179,
                7180,
                9672,
                9785,
                -7013,
                4115,
                -7012,
                7841,
                -3371,
                -3370,
                7231,
                2905,
                5319,
                5320,
                5318,
                1210,
                1211,
                3329,
                5254,
                -2958,
                5252,
                7301,
                -1604,
                -4216,
                2981,
                2982,
                175,
                2646,
                2647
              ]
            ]
          ],
          'id': '20'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -5510,
                5301,
                5302,
                -5521,
                8505,
                9285,
                -5737,
                -6149,
                9286,
                7287,
                7281,
                -7379,
                -7378,
                -9012,
                8635,
                8636,
                8633,
                3250,
                3244,
                -5158,
                7237,
                7238,
                5185,
                9624,
                -7381,
                -5181,
                4542,
                4543,
                -3756,
                -3755,
                8950,
                -9064,
                -7574,
                -9434,
                9221,
                -4547,
                -4546,
                5397,
                -3729,
                -7249,
                8705,
                9812,
                9291,
                9292,
                4121,
                4122,
                4117,
                4118,
                4468,
                4469,
                986,
                987,
                -3168,
                9283,
                4865,
                -4178,
                -4177,
                9578,
                8425,
                -5887,
                -5886,
                -5892,
                8460,
                9087,
                -3005,
                -3004,
                8579,
                -8415,
                3513,
                3514,
                -7430,
                -5672,
                -5675,
                -4887,
                4844,
                -4892,
                5556,
                -7247,
                -4066,
                -4065,
                -4303,
                -4302,
                -6041,
                -5512
              ]
            ]
          ],
          'id': '17'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                201,
                202,
                203,
                204,
                205,
                8861,
                9880,
                7123,
                8850,
                7125,
                871,
                9901,
                5603,
                8827,
                8092,
                4175,
                4176,
                4177,
                -4866,
                -9284,
                3167,
                -988,
                -987,
                -4470,
                -4469,
                -4119,
                -4118,
                -4830,
                8002,
                7665,
                7666,
                4623,
                4624,
                -5597,
                8120,
                9344,
                6999,
                7000,
                6329,
                6330,
                5712,
                5713,
                5714,
                -5735,
                -5734,
                -5765,
                -5764,
                7850,
                7934,
                -1762,
                -2910,
                7933,
                4615,
                9470,
                7552,
                -3696,
                3694,
                -3694,
                -3693,
                -5508,
                -5507,
                5213,
                -4109
              ]
            ],
            [
              [
                4614
              ]
            ],
            [
              [
                8848
              ]
            ],
            [
              [
                8849
              ]
            ],
            [
              [
                9463
              ]
            ],
            [
              [
                9464
              ]
            ],
            [
              [
                9465
              ]
            ],
            [
              [
                9466
              ]
            ],
            [
              [
                9467
              ]
            ],
            [
              [
                9468
              ]
            ],
            [
              [
                9469
              ]
            ]
          ],
          'id': '55'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                9297,
                8500,
                9295,
                9096,
                9570,
                8497,
                9571,
                7325,
                8237,
                7948,
                8594,
                7950,
                7721,
                9869,
                4467,
                -3281,
                -2617,
                -2616,
                4042,
                4043,
                -7251,
                -4138,
                4136,
                -8150,
                -8149,
                979,
                2606,
                -8156,
                9168,
                -8453,
                1272,
                4039,
                -8452,
                9315,
                -4636,
                -2665,
                -2664,
                5052,
                5053,
                2003,
                -11,
                2004,
                -3088,
                -3092,
                -5760,
                5822,
                9316,
                7221,
                9826,
                7216,
                3021,
                9266,
                1300,
                9868
              ]
            ],
            [
              [
                3010
              ]
            ],
            [
              [
                3011
              ]
            ],
            [
              [
                3012
              ]
            ],
            [
              [
                3013
              ]
            ],
            [
              [
                7213
              ]
            ],
            [
              [
                7217
              ]
            ],
            [
              [
                8498
              ]
            ],
            [
              [
                8593
              ]
            ],
            [
              [
                9824
              ]
            ],
            [
              [
                9825
              ]
            ]
          ],
          'id': '06'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                4787,
                -4979,
                -6125,
                -6124,
                -103,
                -745,
                -3184,
                -3183,
                3822,
                -5682,
                2736,
                2737,
                -2766,
                -5777,
                -5776,
                -1364,
                -1363,
                -6570,
                2808,
                475,
                476,
                5398,
                5399,
                -5598,
                -4624,
                -7667,
                -7666,
                -8003,
                4829,
                -4123,
                -4122,
                -9293,
                -9292,
                -9813,
                -8706,
                7248,
                3728,
                -5398,
                4545,
                4546,
                -9222,
                9433,
                -7573,
                2172,
                -1704,
                -1703,
                3217,
                4826,
                4827,
                710,
                711,
                5328,
                5329,
                1148,
                1149,
                -8523,
                -8562,
                7657,
                -6230,
                5280,
                -4862,
                5278,
                3736,
                3737,
                3647,
                3648,
                3649,
                -5442,
                7504,
                9180,
                -8842,
                3641,
                3642,
                3643
              ]
            ]
          ],
          'id': '19'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -9767,
                9840,
                -5239,
                -5238,
                9775,
                -9847,
                -169,
                -168,
                -331,
                -330,
                -329,
                -5408,
                -5407,
                -5412,
                9447,
                2424,
                2425,
                2426,
                -4945,
                -8262,
                -6398,
                -8208,
                1018,
                1013,
                5904,
                5905,
                5908,
                5909,
                7776,
                7777,
                4896,
                4892,
                4893,
                -8963,
                -8892,
                -8891,
                -2929,
                -2928,
                8040,
                6830,
                6831,
                -7432,
                -7149,
                -7148,
                7881,
                7863,
                7864,
                7865,
                6867,
                -4923,
                6868,
                7472,
                -6379,
                5744,
                4993,
                -4575,
                4994,
                4995,
                -8419,
                9107,
                9108,
                6448,
                -5246,
                5205,
                5206,
                3548,
                3549
              ]
            ]
          ],
          'id': '42'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                7586,
                9473,
                9838,
                -6892,
                -5478,
                4550,
                4024,
                3744,
                3745,
                6250,
                -720,
                6251,
                6252,
                6290,
                -1424,
                -5787,
                5127,
                5128,
                5129,
                -6859,
                -9255,
                -9254,
                -1496,
                -1495,
                -1505,
                5535,
                5536,
                -5809,
                1527,
                1528,
                1529,
                1999,
                2000,
                -3265,
                -8383,
                6017,
                -4195,
                2349,
                2350,
                5368,
                -1245,
                5367,
                2298,
                8807,
                9833,
                749,
                6314,
                9830,
                4581
              ]
            ]
          ],
          'id': '30'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -4082,
                -4081,
                8328,
                5901,
                5897,
                7487,
                -9035,
                -8619,
                -7697,
                6289,
                -4630,
                -4629,
                -4628,
                -4210,
                -8321,
                6232,
                -4863,
                -5281,
                6229,
                -7658,
                8561,
                8522,
                -1150,
                -1149,
                -5330,
                -5329,
                -712,
                -711,
                -4828,
                -4827,
                -3218,
                1702,
                1703,
                -2173,
                7572,
                7573,
                9063,
                -8951,
                3754,
                3755,
                -4544,
                -4543,
                5180,
                7380,
                -9625,
                -5186,
                -7239,
                -7238,
                5157,
                -3245,
                -3251,
                -8634,
                -8637,
                -8636,
                9011,
                7377,
                7378,
                -7282,
                -7288,
                -9287,
                6148,
                5736,
                5737,
                5738,
                5739,
                5740,
                -6055,
                8880,
                -6057,
                8881,
                3749,
                3750,
                3751,
                -4443,
                8795,
                8790,
                8791,
                -8805,
                -8804,
                -8508,
                -8511,
                -8175,
                -4453,
                -4452,
                -4451,
                -8239,
                9414,
                9419,
                -7726,
                -7265,
                1689,
                -7264,
                -4229,
                503,
                504,
                505,
                1651,
                1647,
                4111,
                -2548,
                1609,
                -2547,
                -9879,
                -6371,
                -6370
              ]
            ]
          ],
          'id': '29'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -9173,
                -9177,
                -7984,
                -849,
                -848,
                -2115,
                -2114,
                -7307,
                -7306,
                7897,
                7629,
                7630,
                -8939,
                -7142,
                -7141,
                -7411,
                -7410,
                -6486,
                -5220,
                -5219,
                7622,
                7623,
                9408,
                8588,
                2499,
                8086,
                9813,
                9084,
                3215,
                1834,
                4817,
                9783,
                9679,
                8534,
                9676,
                8536,
                9680,
                8542,
                9827,
                7274,
                7241,
                7276,
                7243,
                8933,
                9210,
                9908,
                7903,
                3045,
                7901,
                3043,
                7223,
                7836,
                7408,
                1768,
                9760,
                7899,
                9423,
                7887,
                7895,
                2466,
                2877,
                316,
                7969,
                9521,
                -2703,
                9520,
                7968,
                313,
                314,
                2873,
                2874,
                -9174
              ]
            ],
            [
              [
                7275
              ]
            ],
            [
              [
                7884
              ]
            ],
            [
              [
                8537
              ]
            ],
            [
              [
                8538
              ]
            ],
            [
              [
                8539
              ]
            ],
            [
              [
                8543
              ]
            ],
            [
              [
                8544
              ]
            ],
            [
              [
                8545
              ]
            ],
            [
              [
                8546
              ]
            ]
          ],
          'id': '12'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                5940,
                -6952,
                -6193,
                3488,
                3489,
                -7638,
                -6126,
                6052,
                6053,
                6054,
                -5741,
                -5740,
                -5739,
                -5738,
                -9286,
                -8506,
                5520,
                -5303,
                -5302,
                5509,
                5510,
                5511,
                6040,
                4301,
                4302,
                -4064,
                -4063,
                6502,
                6503,
                7289,
                7290,
                4699,
                4700,
                4293,
                -4886,
                -4475,
                6838,
                4068,
                -7841,
                -4480,
                -7337,
                -7336,
                -7335,
                -7446,
                3129,
                3124,
                6873,
                -7433,
                -4515,
                9327,
                -9204,
                -9203,
                7344,
                7341,
                -8991,
                7168,
                7169,
                9751,
                -8616,
                5437,
                5431,
                -8819,
                -8971,
                6057,
                6058,
                5333,
                5591,
                5592,
                5842,
                5843,
                5844,
                5845,
                -6784,
                5562,
                5563,
                6841,
                6842,
                3947,
                3948,
                -6511,
                -433,
                -432,
                4306,
                -7987,
                -5987,
                4834,
                3494,
                3495,
                8176,
                -5857,
                -5856,
                -7597,
                -7596,
                321,
                322,
                -9664,
                -6950
              ]
            ],
            [
              [
                6055,
                6056
              ]
            ]
          ],
          'id': '21'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                3343,
                7358,
                3345,
                3659,
                7361,
                9721,
                5020,
                6005,
                993,
                994,
                995,
                996,
                5997,
                -1639,
                5998,
                9834,
                3696,
                327,
                746
              ]
            ],
            [
              [
                3336
              ]
            ],
            [
              [
                3337
              ]
            ],
            [
              [
                3338
              ]
            ],
            [
              [
                3339
              ]
            ],
            [
              [
                3340
              ]
            ],
            [
              [
                3341
              ]
            ],
            [
              [
                3656
              ]
            ],
            [
              [
                7359
              ]
            ],
            [
              [
                7360
              ]
            ],
            [
              [
                9720
              ]
            ]
          ],
          'id': '23'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                357,
                358,
                4374,
                4375,
                7687,
                7688,
                -1791,
                -1797,
                9228,
                1231,
                1232,
                1233,
                1234,
                1235,
                1236,
                -726,
                -725,
                -3,
                -2,
                -4505,
                -4504,
                -4503,
                -4502,
                8528,
                8478,
                8532,
                8530,
                7050,
                -3380,
                -4060,
                -4059,
                5363,
                -8486,
                -4597,
                -8702
              ]
            ]
          ],
          'id': '49'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -2622,
                -1221,
                -1220,
                -6107,
                -6106,
                -631,
                -4033,
                -4032,
                -5879,
                -4152,
                -3372,
                -7842,
                7011,
                -4116,
                7012,
                -9786,
                -9673,
                -7181,
                -7180,
                -7289,
                5919,
                -739,
                -738,
                3061,
                -9703,
                -5429,
                -5428,
                7464,
                7964,
                -6275,
                -6274,
                -9829,
                5006,
                5007,
                -9124,
                -7394,
                -7393,
                -1652,
                -506,
                -505,
                -4233,
                -4232,
                -3357,
                7803,
                -7818,
                -9086,
                -9087,
                -4466,
                -7208,
                -7210,
                8258,
                -3353,
                -5782,
                8259,
                4534,
                4535,
                -9263,
                9510,
                9511,
                9851,
                9684,
                -7052,
                -9206,
                4742,
                4743,
                3732,
                3733,
                -7560,
                -7057,
                6963,
                6964,
                -9165,
                -512,
                9185,
                539,
                540,
                -3409,
                -2623
              ]
            ]
          ],
          'id': '40'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -3948,
                -6843,
                9860,
                2710,
                -1635,
                -1634,
                -1633,
                -6388,
                -6168,
                -6387,
                4745,
                4746,
                4747,
                4748,
                4749,
                7593,
                -4719,
                -4723,
                -6599,
                -9711,
                6036,
                4988,
                4989,
                -5069,
                5611,
                6186,
                6187,
                -8264,
                -8265,
                5657,
                -2137,
                -4052,
                -4051,
                -7167,
                -9762,
                -4410,
                -7976,
                -7975,
                9026,
                9019,
                9020,
                -9314,
                -7830,
                1091,
                1092,
                -4223,
                -4222,
                -4228,
                -6296,
                9321,
                5496,
                7491,
                -3427,
                7492,
                8736,
                -7416,
                4567,
                4568,
                4569,
                5422,
                -4448,
                -4447,
                -4446,
                -4445,
                -4444,
                -3751,
                -3750,
                -8882,
                -6056,
                -8881,
                -6054,
                -6053,
                6125,
                7637,
                -3490,
                -3489,
                6192,
                6951,
                -5941,
                6949,
                9663,
                -323,
                -322,
                7595,
                7596,
                5855,
                5856,
                -8177,
                -3496,
                -3495,
                -4835,
                5986,
                7986,
                -4307,
                431,
                432,
                6510,
                -3949
              ]
            ]
          ],
          'id': '47'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -9733,
                -6261,
                -9608,
                8778,
                -3632,
                8779,
                -7795,
                -3267,
                -8464,
                2987,
                2988,
                9138,
                -7404,
                9139,
                -9096,
                -6825,
                4367,
                4368,
                4135,
                4137,
                7250,
                -4044,
                -4043,
                2615,
                2616,
                3280,
                3281,
                7661,
                7663,
                6141,
                8520,
                9742,
                6981,
                6979,
                4358,
                4359,
                4360,
                -5602,
                8279,
                9634,
                -5450,
                -5449,
                -5448,
                496,
                -5447,
                6069
              ]
            ]
          ],
          'id': '41'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -5410,
                -5409,
                -334,
                -333,
                -332,
                -174,
                -173,
                -172,
                -3763,
                -6217,
                -8372,
                -8371,
                8035,
                -8373,
                -7099,
                -9472,
                7521,
                7522,
                -4608,
                2124,
                2125,
                3975,
                3976,
                -7672,
                -8366,
                -7673,
                5691,
                4939,
                4940,
                4941,
                2449,
                2450,
                -7078,
                -5843,
                -5593,
                -5592,
                -5334,
                -6059,
                -8970,
                6525,
                -3973,
                -3972,
                -3968,
                -3967,
                -3966,
                7579,
                7580,
                -8363,
                7540,
                7538,
                3298,
                4945,
                4942,
                -6920,
                8260,
                6399,
                8208,
                -7713,
                -1019,
                8207,
                6397,
                8261,
                4944,
                -2427,
                -2426,
                -2425,
                -9448,
                5411,
                -5411
              ]
            ]
          ],
          'id': '54'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -7533,
                7318,
                7319,
                -3682,
                -3681,
                -3686,
                7601,
                7602,
                -3873,
                7603,
                7604,
                7524,
                -5626,
                -7945,
                -7944,
                -5500,
                -5499,
                8211,
                -8277,
                -9889,
                -5992,
                -5783,
                3351,
                3352,
                -8259,
                7209,
                7207,
                4465,
                9086,
                9085,
                7817,
                -7804,
                3356,
                4231,
                4232,
                -504,
                4228,
                7263,
                -1690,
                7264,
                7725,
                -9420,
                -9415,
                8238,
                4450,
                4451,
                4452,
                8174,
                8510,
                8507,
                8803,
                8804,
                -8792,
                -8791,
                -8796,
                4442,
                -3752,
                4443,
                4444,
                4445,
                4446,
                4447,
                -5423,
                -4570,
                -7371,
                -7530
              ]
            ]
          ],
          'id': '05'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                9200,
                9777,
                9199,
                6247,
                8695,
                4163,
                9872,
                8691,
                1724,
                -1247,
                1725,
                -5825,
                -5311,
                -734,
                -733,
                -8646,
                -7792,
                -7796,
                -8780,
                3631,
                -8779,
                9607,
                6260,
                9732,
                -6070,
                5446,
                -497,
                5447,
                5448,
                5449,
                -9635,
                -8280,
                5601,
                -4361,
                -4360,
                -4359,
                -6980,
                7925,
                7115,
                8586,
                8592,
                8582,
                8590,
                8625,
                9907,
                641,
                8627,
                9498,
                634,
                2483
              ]
            ],
            [
              [
                2484
              ]
            ],
            [
              [
                6243
              ]
            ],
            [
              [
                6244
              ]
            ],
            [
              [
                6248
              ]
            ],
            [
              [
                8629
              ]
            ],
            [
              [
                8630
              ]
            ],
            [
              [
                8631
              ]
            ],
            [
              [
                8632
              ]
            ],
            [
              [
                8694
              ]
            ],
            [
              [
                8696
              ]
            ],
            [
              [
                9198
              ]
            ],
            [
              [
                9778
              ]
            ],
            [
              [
                9906
              ]
            ]
          ],
          'id': '53'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                3595,
                -6238,
                -7084,
                3829,
                -7083,
                8392,
                8479,
                8480,
                8481,
                6719,
                8113,
                8114,
                -8349,
                -8440,
                4723,
                4724,
                4725,
                9758,
                4727,
                9882,
                8127,
                7152,
                8052,
                6722,
                9850,
                6849,
                9129,
                7186,
                9759,
                7188,
                9894,
                6846,
                3958,
                6904,
                2453,
                9577,
                5503,
                8283,
                -6312,
                -6311,
                -5209,
                6880,
                5945,
                5864,
                -5091,
                -5090,
                -5720,
                -5719,
                -4904,
                -4903,
                3913,
                3914,
                6375,
                6376,
                4716,
                -1067,
                -1066,
                -1072,
                3952,
                3953,
                -7810,
                7736,
                7805,
                7806,
                7807,
                8265,
                -2138,
                -5658,
                8264,
                8263,
                -6188,
                -6187,
                -5612,
                5068,
                -4990,
                -4989,
                -6037,
                9710,
                6598,
                4722,
                4718,
                -7594,
                -4750,
                -4749,
                -4748,
                8832,
                7087,
                6885,
                6886,
                6887,
                3046,
                3047,
                812,
                813,
                -8034,
                -1283,
                -8033,
                -6239
              ]
            ],
            [
              [
                7184,
                9757
              ]
            ],
            [
              [
                9756
              ]
            ]
          ],
          'id': '37'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [],
            [],
            [],
            [
              [
                8032,
                1282,
                8033,
                -814,
                -813,
                -3048,
                -3047,
                -6888,
                -6887,
                -6886,
                -7088,
                -8833,
                -4747,
                -4746,
                6386,
                6167,
                6387,
                1632,
                1633,
                1634,
                -2711,
                -9861,
                -6842,
                -5564,
                -5563,
                6783,
                -5846,
                -5845,
                -5844,
                7077,
                -2451,
                -2450,
                -4942,
                -4941,
                -4940,
                -5692,
                7672,
                8365,
                7671,
                -3977,
                -3976,
                -2126,
                -2125,
                4607,
                -7523,
                -7522,
                9471,
                7098,
                8372,
                -8036,
                8370,
                8371,
                6216,
                3762,
                -171,
                3763,
                3764,
                -5495,
                6239,
                -9567,
                9572,
                9788,
                -9503,
                9789,
                9713,
                9014,
                1518,
                9798,
                5963,
                9831,
                1554,
                9832,
                9568,
                5113,
                7094,
                2286,
                8296,
                4579,
                9150,
                8110,
                7027,
                6256,
                6009,
                8346,
                8297,
                8241,
                9879,
                -4725,
                -4724,
                8439,
                8348,
                -8115,
                -8114,
                -6720,
                -8482,
                -8481,
                -8480,
                -8393,
                7082,
                -3830,
                7083,
                6237,
                -3596,
                6238
              ]
            ],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [
              [
                9211,
                9212,
                9213,
                8047,
                9214
              ]
            ],
            [
              [
                9215
              ]
            ],
            [
              [
                9216,
                9217
              ]
            ],
            []
          ],
          'id': '51'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                6014,
                -4375,
                -359,
                -358,
                8701,
                4596,
                4597,
                4591,
                -4089,
                -4088,
                6343,
                -5810,
                -5536,
                1504,
                1494,
                1495,
                9253,
                9254,
                6858,
                -5130,
                -5129,
                -5128,
                5786,
                -1428,
                -45,
                -44,
                -4969,
                -4564,
                -4563,
                -2564,
                7437,
                5792,
                5793,
                5794,
                -9739,
                -3921,
                -7160,
                -8333,
                5455,
                -472,
                -471,
                -7278,
                -8601
              ]
            ]
          ],
          'id': '56'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -314,
                -7969,
                -9521,
                2702,
                2703,
                8687,
                8688,
                8689,
                8690,
                8409,
                -7998,
                7258,
                7253,
                -338,
                -337,
                7259,
                7260,
                8319,
                8317,
                8316,
                8313,
                -9104,
                -9062,
                4958,
                4955,
                4801,
                4226,
                4227,
                4221,
                4222,
                -1093,
                -1092,
                7829,
                9313,
                -9021,
                -9020,
                -9027,
                -7977,
                4456,
                -4415,
                4457,
                4647,
                -4014,
                4648,
                -5814,
                -64,
                9279,
                7644,
                -3591,
                7645,
                4035,
                4036,
                8552,
                8553,
                8170,
                -3585,
                8171,
                8679,
                8680,
                8681,
                -9809,
                -7308,
                -7312,
                -7985,
                9176,
                9172,
                9173,
                -2875,
                -2874,
                -315
              ]
            ],
            [
              [
                8684
              ]
            ],
            [
              [
                8685
              ]
            ],
            [
              [
                8686
              ]
            ]
          ],
          'id': '01'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -6376,
                -3915,
                -3914,
                4902,
                4903,
                5718,
                5719,
                5089,
                5090,
                -5865,
                -5946,
                -6881,
                5208,
                6310,
                6311,
                6312,
                5275,
                4900,
                6898,
                4984,
                4913,
                4914,
                4915,
                5526,
                5527,
                6032,
                6033,
                -8550,
                6132,
                6133,
                9628,
                -8761,
                5954,
                5955,
                5956,
                6062,
                4558,
                4559,
                -6540,
                7810,
                7811,
                7812,
                7813,
                7809,
                -3954,
                -3953,
                1071,
                1065,
                1066,
                -4717,
                -6377
              ]
            ]
          ],
          'id': '45'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                1626,
                4928,
                4929,
                -4811,
                3761,
                -4810,
                6299,
                4935,
                5236,
                6109,
                -4050,
                6107,
                -620,
                -619,
                -166,
                -165,
                5978,
                -7158,
                -7236,
                4150,
                -3373,
                4151,
                4152,
                4153,
                7509,
                7510,
                -192,
                -191,
                8604,
                -6954,
                -6953,
                -1021,
                -1020,
                -510,
                -1719,
                -3156,
                -3799,
                8247,
                5037,
                5038,
                5039,
                4879,
                4880,
                4881,
                7647,
                7648
              ]
            ]
          ],
          'id': '35'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -996,
                -995,
                9110,
                -7590,
                -7589,
                9529,
                -8269,
                -8268,
                -3672,
                -4927,
                -4926,
                -5289,
                -5288,
                -8848,
                -9774,
                -9312,
                1636,
                1637,
                1638,
                -5998,
                -997
              ]
            ]
          ],
          'id': '33'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                2195
              ]
            ],
            [
              [
                2196
              ]
            ],
            [
              [
                2197
              ]
            ],
            [
              [
                2199,
                8746
              ]
            ],
            [
              [
                9633
              ]
            ]
          ],
          'id': '60'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                9310,
                -1637,
                9311,
                9773,
                8847,
                5287,
                5288,
                4925,
                4926,
                -3671,
                -3670,
                -5342,
                8748,
                8747,
                6207,
                9659,
                -7743,
                -7742,
                -8798,
                8345,
                8343,
                5104,
                8755
              ]
            ]
          ],
          'id': '50'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                2663,
                2664,
                4635,
                -9316,
                8451,
                -4040,
                -1273,
                8452,
                -9169,
                8155,
                -2607,
                -980,
                8148,
                8149,
                -4137,
                -4136,
                -4369,
                -4368,
                6824,
                6825,
                -9095,
                -8219,
                -3381,
                -7051,
                -8531,
                -8533,
                -8479,
                -8529,
                4501,
                4502,
                4503,
                4504,
                -1,
                -12,
                -2004,
                -5054,
                -5053
              ]
            ]
          ],
          'id': '32'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                3559
              ]
            ],
            [
              [
                3560
              ]
            ],
            [
              [
                3561
              ]
            ],
            [
              [
                3563,
                7695
              ]
            ],
            [
              [
                3628
              ]
            ],
            [
              [
                8527
              ]
            ],
            [
              [
                8975
              ]
            ],
            [
              [
                8976
              ]
            ]
          ],
          'id': '15'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                7588,
                7589,
                7590,
                3667,
                5799,
                4092,
                5796,
                4094,
                9837,
                9259,
                9836,
                4096,
                5552,
                -4140,
                5553,
                5554,
                5555,
                5800,
                -6507,
                -7699,
                8270,
                6197,
                6198,
                6199,
                5344,
                5345,
                5346,
                5340,
                5341,
                3669,
                3670,
                3671,
                8267,
                8268,
                -9530
              ]
            ],
            [
              [
                5550
              ]
            ],
            [
              [
                6075
              ]
            ],
            [
              [
                9256
              ]
            ],
            [
              [
                9257
              ]
            ]
          ],
          'id': '25'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                3980
              ]
            ],
            [
              [
                3981
              ]
            ],
            [
              [
                3982
              ]
            ],
            [
              [
                3984,
                7990
              ]
            ],
            [
              [
                5531
              ]
            ],
            [
              [
                5532
              ]
            ],
            [
              [
                7989
              ]
            ]
          ],
          'id': '78'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                4139,
                4140
              ]
            ],
            [
              [
                4141
              ]
            ],
            [
              [
                4142
              ]
            ],
            [
              [
                6508,
                6450,
                9411,
                -7704,
                6452,
                6453,
                6509,
                6506,
                -5801,
                -5556,
                -5555,
                9887
              ]
            ],
            [
              [
                9410
              ]
            ]
          ],
          'id': '44'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -6449,
                -9109,
                -9108,
                8418,
                -4996,
                -4995,
                4574,
                -4994,
                -5745,
                6378,
                -7473,
                -6869,
                -4922,
                -4921,
                -8188,
                7446,
                7447,
                7448,
                -4518,
                -4517,
                8865,
                8866,
                -9157,
                7515,
                7516,
                8967,
                7423,
                8215,
                8616,
                4510,
                9741,
                -5243,
                9739,
                -5248,
                -5247
              ]
            ]
          ],
          'id': '34'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                5242,
                5243
              ]
            ],
            [
              [
                5244
              ]
            ],
            [
              [
                -999,
                7400,
                -5485,
                5250,
                5251,
                -5206,
                5245,
                5246,
                5247,
                5248,
                7398,
                9601,
                -9537,
                -4490,
                -5308,
                -1000
              ]
            ]
          ],
          'id': '10'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                5312,
                7327,
                8190,
                -7454,
                -8186,
                8188,
                9170,
                -5345,
                -6200,
                -6199,
                -6198,
                -8271,
                7698,
                -6510,
                -6454,
                -6453,
                7703,
                7704
              ]
            ]
          ],
          'id': '09'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                7001
              ]
            ],
            [
              [
                8394
              ]
            ],
            [
              [
                8395
              ]
            ],
            [
              [
                8428
              ]
            ],
            [
              [
                8429
              ]
            ],
            [
              [
                8430
              ]
            ],
            [
              [
                8431
              ]
            ],
            [
              [
                8432
              ]
            ],
            [
              [
                8433
              ]
            ],
            [
              [
                8434
              ]
            ],
            [
              [
                8435
              ]
            ],
            [
              [
                8436
              ]
            ],
            [
              [
                8437
              ]
            ],
            [
              [
                9904
              ]
            ]
          ],
          'id': '69'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                8193
              ]
            ],
            [
              [
                8194
              ]
            ]
          ],
          'id': '66'
        },
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                -5494,
                9565,
                9566,
                -6240
              ]
            ]
          ],
          'id': '11'
        }
      ]
    },
    'nation': {
      'type': 'GeometryCollection',
      'geometries': [
        {
          'type': 'MultiPolygon',
          'arcs': [
            [
              [
                1626,
                4928,
                7206,
                284,
                4806,
                5761,
                5822,
                9316,
                7221,
                9826,
                7216,
                3021,
                9266,
                1300,
                9868,
                9297,
                8500,
                9295,
                9096,
                9570,
                8497,
                9571,
                7325,
                8237,
                7948,
                8594,
                7950,
                7721,
                9869,
                4467,
                3281,
                7661,
                7663,
                6141,
                8520,
                9742,
                6981,
                7925,
                7115,
                8586,
                8592,
                8582,
                8590,
                8625,
                9907,
                641,
                8627,
                9498,
                634,
                2483,
                9200,
                9777,
                9199,
                6247,
                8695,
                4163,
                9872,
                8691,
                1724,
                1243,
                5367,
                2298,
                8807,
                9833,
                749,
                6314,
                9830,
                4581,
                7586,
                9473,
                9838,
                6889,
                9538,
                492,
                2192,
                3267,
                1641,
                2741,
                6118,
                5266,
                2259,
                9744,
                7494,
                2906,
                4131,
                3591,
                4132,
                2908,
                7933,
                4615,
                9470,
                7552,
                3689,
                9076,
                5415,
                9802,
                5417,
                4496,
                8971,
                5136,
                2272,
                7615,
                7620,
                7931,
                9718,
                1667,
                205,
                8861,
                9880,
                7123,
                8850,
                7125,
                871,
                9901,
                5603,
                8827,
                8092,
                4175,
                9578,
                8425,
                5887,
                9539,
                9877,
                9752,
                9330,
                9769,
                5854,
                1358,
                4859,
                1352,
                586,
                8327,
                9796,
                6292,
                2645,
                7477,
                8391,
                9483,
                9425,
                3687,
                8727,
                9030,
                3252,
                3675,
                8441,
                8521,
                482,
                7315,
                9280,
                7365,
                8399,
                3722,
                9622,
                9874,
                8916,
                9089,
                9685,
                9863,
                4892,
                8960,
                9517,
                7459,
                391,
                4127,
                757,
                9489,
                3716,
                6367,
                4526,
                8012,
                8796,
                8343,
                5104,
                8755,
                9310,
                1637,
                5998,
                9834,
                3696,
                327,
                746,
                3343,
                7358,
                3345,
                3659,
                7361,
                9721,
                5020,
                6005,
                993,
                9110,
                7590,
                3667,
                5799,
                4092,
                5796,
                4094,
                9837,
                9259,
                9836,
                4096,
                5552,
                4140,
                5553,
                9887,
                6508,
                6450,
                9411,
                7704,
                5312,
                7327,
                8190,
                7454,
                9224,
                9073,
                3741,
                6364,
                3739,
                9074,
                8877,
                4521,
                8865,
                9157,
                7516,
                8967,
                7423,
                8215,
                8616,
                4510,
                9741,
                5243,
                9739,
                5248,
                7398,
                9601,
                9537,
                9213,
                8047,
                9214,
                9533,
                4495,
                5308,
                5650,
                9219,
                5486,
                7313,
                9767,
                9844,
                5664,
                9695,
                9141,
                4847,
                9504,
                9789,
                9713,
                9014,
                1518,
                9798,
                5963,
                9831,
                1554,
                9832,
                9568,
                5113,
                7094,
                2286,
                8296,
                4579,
                9150,
                8110,
                7027,
                6256,
                6009,
                8346,
                8297,
                8241,
                9879,
                4725,
                9758,
                4727,
                9882,
                8127,
                7152,
                8052,
                6722,
                9850,
                6849,
                9129,
                7186,
                9759,
                7188,
                9894,
                6846,
                3958,
                6904,
                2453,
                9577,
                5503,
                8283,
                6312,
                5275,
                4900,
                6898,
                4984,
                4913,
                9807,
                7227,
                4482,
                9733,
                4822,
                9354,
                7623,
                9408,
                8588,
                2499,
                8086,
                9813,
                9084,
                3215,
                1834,
                4817,
                9783,
                9679,
                8534,
                9676,
                8536,
                9680,
                8542,
                9827,
                7274,
                7241,
                7276,
                7243,
                8933,
                9210,
                9908,
                7903,
                3045,
                7901,
                3043,
                7223,
                7836,
                7408,
                1768,
                9760,
                7899,
                9423,
                7887,
                7895,
                2466,
                2877,
                316,
                7969,
                9521,
                2703,
                8687,
                9596,
                8075,
                9861,
                9902,
                8303,
                7294,
                9900,
                8182,
                8388,
                8517,
                8385,
                8518,
                4352,
                4841,
                3878,
                4077,
                5438,
                4159,
                9735,
                4161,
                9144,
                9737,
                6915,
                9736,
                6917,
                6154,
                4643,
                3783,
                8749,
                9130,
                6514,
                7561,
                9417,
                7563,
                6516,
                9131,
                8751,
                3781,
                4644,
                6102,
                3785,
                4640,
                3787,
                6103,
                3789,
                8557,
                8752,
                9132,
                6518,
                7564,
                9418,
                8044,
                9302,
                3780,
                9037,
                9896,
                4381,
                9332,
                8900,
                5868,
                7035,
                7992,
                9350,
                7648
              ],
              [
                5510
              ]
            ],
            [
              [
                4842
              ]
            ],
            [
              [
                7291
              ]
            ],
            [
              [
                7292
              ]
            ],
            [
              [
                7293
              ]
            ],
            [
              [
                8383
              ]
            ],
            [
              [
                8515
              ]
            ],
            [
              [
                8516
              ]
            ],
            [
              [
                9899
              ]
            ],
            [
              [
                6361
              ]
            ],
            [
              [
                6362
              ]
            ],
            [
              [
                6363
              ]
            ],
            [
              [
                6365
              ]
            ],
            [
              [
                6368
              ]
            ],
            [
              [
                51
              ]
            ],
            [
              [
                52
              ]
            ],
            [
              [
                53
              ]
            ],
            [
              [
                8823,
                2018,
                1446,
                8571,
                2089,
                9403,
                9234,
                9152,
                9407,
                2063,
                2076,
                2043,
                2071,
                762,
                2072,
                6402,
                4962,
                6404,
                4964,
                521,
                9553,
                1778,
                3599,
                2416,
                2812,
                2087,
                8570,
                1444,
                2019,
                9886,
                2016,
                8821,
                1429,
                1654,
                55,
                8568,
                3184,
                8569,
                57,
                1655,
                1431,
                8822,
                1433
              ]
            ],
            [
              [
                58
              ]
            ],
            [
              [
                59
              ]
            ],
            [
              [
                1434
              ]
            ],
            [
              [
                1436,
                8819
              ]
            ],
            [
              [
                1437
              ]
            ],
            [],
            [
              [
                1439
              ]
            ],
            [
              [
                1440
              ]
            ],
            [
              [
                1442,
                3210
              ]
            ],
            [
              [
                1652,
                3197
              ]
            ],
            [
              [
                2014
              ]
            ],
            [
              [
                2025
              ]
            ],
            [
              [
                2026
              ]
            ],
            [
              [
                2027
              ]
            ],
            [
              [
                2028
              ]
            ],
            [
              [
                2029
              ]
            ],
            [
              [
                2030
              ]
            ],
            [
              [
                2031
              ]
            ],
            [
              [
                2032
              ]
            ],
            [
              [
                2033
              ]
            ],
            [
              [
                2034
              ]
            ],
            [
              [
                2035
              ]
            ],
            [
              [
                2036
              ]
            ],
            [
              [
                2037
              ]
            ],
            [
              [
                2038
              ]
            ],
            [
              [
                2039
              ]
            ],
            [
              [
                2040
              ]
            ],
            [
              [
                2041
              ]
            ],
            [
              [
                2044
              ]
            ],
            [
              [
                2045
              ]
            ],
            [
              [
                2046
              ]
            ],
            [
              [
                2047
              ]
            ],
            [
              [
                2048
              ]
            ],
            [
              [
                2049
              ]
            ],
            [
              [
                2050
              ]
            ],
            [
              [
                2051
              ]
            ],
            [
              [
                2052
              ]
            ],
            [
              [
                2053
              ]
            ],
            [
              [
                2054
              ]
            ],
            [
              [
                2055
              ]
            ],
            [
              [
                2056
              ]
            ],
            [
              [
                2057
              ]
            ],
            [
              [
                2058
              ]
            ],
            [
              [
                2059
              ]
            ],
            [
              [
                2060
              ]
            ],
            [
              [
                2061
              ]
            ],
            [
              [
                2065
              ]
            ],
            [
              [
                2066
              ]
            ],
            [
              [
                2067
              ]
            ],
            [
              [
                2068
              ]
            ],
            [
              [
                2069
              ]
            ],
            [
              [
                2070
              ]
            ],
            [
              [
                2077
              ]
            ],
            [
              [
                2078
              ]
            ],
            [
              [
                2079
              ]
            ],
            [
              [
                2080
              ]
            ],
            [
              [
                2081
              ]
            ],
            [
              [
                2082
              ]
            ],
            [
              [
                2083
              ]
            ],
            [
              [
                2084
              ]
            ],
            [
              [
                3186
              ]
            ],
            [
              [
                3187
              ]
            ],
            [
              [
                3188
              ]
            ],
            [
              [
                3189
              ]
            ],
            [
              [
                3190
              ]
            ],
            [
              [
                3191
              ]
            ],
            [
              [
                3192
              ]
            ],
            [
              [
                3193
              ]
            ],
            [
              [
                3194
              ]
            ],
            [
              [
                3195
              ]
            ],
            [
              [
                3196
              ]
            ],
            [
              [
                3198,
                3208
              ]
            ],
            [
              [
                3209
              ]
            ],
            [
              [
                4965
              ]
            ],
            [
              [
                4966
              ]
            ],
            [
              [
                4967
              ]
            ],
            [
              [
                6400
              ]
            ],
            [
              [
                6401
              ]
            ],
            [
              [
                6403
              ]
            ],
            [
              [
                8564
              ]
            ],
            [
              [
                8565
              ]
            ],
            [
              [
                8566
              ]
            ],
            [
              [
                8567
              ]
            ],
            [
              [
                8820
              ]
            ],
            [
              [
                9235
              ]
            ],
            [
              [
                9356
              ]
            ],
            [
              [
                9357
              ]
            ],
            [
              [
                9358
              ]
            ],
            [
              [
                9359
              ]
            ],
            [
              [
                9360
              ]
            ],
            [
              [
                9361
              ]
            ],
            [
              [
                9362
              ]
            ],
            [
              [
                9363
              ]
            ],
            [
              [
                9364
              ]
            ],
            [
              [
                9365
              ]
            ],
            [
              [
                9366
              ]
            ],
            [
              [
                9367
              ]
            ],
            [
              [
                9368
              ]
            ],
            [
              [
                9369
              ]
            ],
            [
              [
                9370
              ]
            ],
            [
              [
                9371
              ]
            ],
            [
              [
                9372
              ]
            ],
            [
              [
                9373
              ]
            ],
            [
              [
                9374
              ]
            ],
            [
              [
                9375
              ]
            ],
            [
              [
                9376
              ]
            ],
            [
              [
                9377
              ]
            ],
            [
              [
                9378
              ]
            ],
            [
              [
                9379
              ]
            ],
            [
              [
                9380
              ]
            ],
            [
              [
                9381
              ]
            ],
            [
              [
                9382
              ]
            ],
            [
              [
                9383
              ]
            ],
            [
              [
                9384
              ]
            ],
            [
              [
                9385
              ]
            ],
            [
              [
                9386
              ]
            ],
            [
              [
                9387
              ]
            ],
            [
              [
                9388
              ]
            ],
            [
              [
                9389
              ]
            ],
            [
              [
                9390
              ]
            ],
            [
              [
                9391
              ]
            ],
            [
              [
                9392
              ]
            ],
            [
              [
                9393
              ]
            ],
            [
              [
                9394
              ]
            ],
            [
              [
                9395
              ]
            ],
            [
              [
                9396
              ]
            ],
            [
              [
                9397
              ]
            ],
            [
              [
                9398
              ]
            ],
            [
              [
                9399
              ]
            ],
            [
              [
                9400
              ]
            ],
            [
              [
                9401
              ]
            ],
            [
              [
                9402
              ]
            ],
            [
              [
                9404
              ]
            ],
            [
              [
                9405
              ]
            ],
            [
              [
                9406
              ]
            ],
            [
              [
                9551
              ]
            ],
            [
              [
                9552
              ]
            ],
            [
              [
                9554
              ]
            ],
            [
              [
                9555
              ]
            ],
            [
              [
                7478
              ]
            ],
            [
              [
                7479
              ]
            ],
            [
              [
                7480
              ]
            ],
            [
              [
                7481
              ]
            ],
            [
              [
                7614
              ]
            ],
            [
              [
                7617
              ]
            ],
            [
              [
                7618
              ]
            ],
            [
              [
                7619
              ]
            ],
            [
              [
                9716
              ]
            ],
            [
              [
                9717
              ]
            ],
            [
              [
                9793
              ]
            ],
            [
              [
                9794
              ]
            ],
            [
              [
                9795
              ]
            ],
            [
              [
                9797
              ]
            ],
            [
              [
                9801
              ]
            ],
            [
              [
                9803
              ]
            ],
            [
              [
                8072
              ]
            ],
            [
              [
                8073
              ]
            ],
            [
              [
                9594
              ]
            ],
            [
              [
                9595
              ]
            ],
            [
              [
                9621
              ]
            ],
            [
              [
                9873
              ]
            ],
            [
              [
                6958,
                9007,
                8735,
                9459,
                7788,
                7003,
                4357,
                8743,
                8741,
                2129,
                7108,
                9476,
                8998,
                9000,
                9859,
                9478,
                8396,
                9341,
                9750,
                6024,
                1755,
                9885,
                6861,
                141,
                8895,
                9477,
                4193,
                6892,
                9005,
                9898,
                7762,
                8725,
                2758,
                9482,
                3601,
                9309,
                3001,
                5615,
                9905,
                120,
                4182
              ]
            ],
            [
              [
                6955
              ]
            ],
            [
              [
                7818
              ]
            ],
            [
              [
                8744
              ]
            ],
            [
              [
                8745
              ]
            ],
            [
              [
                9428
              ]
            ],
            [
              [
                9897
              ]
            ],
            [],
            [],
            [],
            [],
            [
              [
                5305,
                9535
              ]
            ],
            [
              [
                5651
              ]
            ],
            [
              [
                9534,
                9216
              ]
            ],
            [
              [
                4614
              ]
            ],
            [
              [
                8848
              ]
            ],
            [
              [
                8849
              ]
            ],
            [
              [
                9463
              ]
            ],
            [
              [
                9464
              ]
            ],
            [
              [
                9465
              ]
            ],
            [
              [
                9466
              ]
            ],
            [
              [
                9467
              ]
            ],
            [
              [
                9468
              ]
            ],
            [
              [
                9469
              ]
            ],
            [
              [
                3010
              ]
            ],
            [
              [
                3011
              ]
            ],
            [
              [
                3012
              ]
            ],
            [
              [
                3013
              ]
            ],
            [
              [
                7213
              ]
            ],
            [
              [
                7217
              ]
            ],
            [
              [
                8498
              ]
            ],
            [
              [
                8593
              ]
            ],
            [
              [
                9824
              ]
            ],
            [
              [
                9825
              ]
            ],
            [
              [
                7275
              ]
            ],
            [
              [
                7884
              ]
            ],
            [
              [
                8537
              ]
            ],
            [
              [
                8538
              ]
            ],
            [
              [
                8539
              ]
            ],
            [
              [
                8543
              ]
            ],
            [
              [
                8544
              ]
            ],
            [
              [
                8545
              ]
            ],
            [
              [
                8546
              ]
            ],
            [
              [
                3336
              ]
            ],
            [
              [
                3337
              ]
            ],
            [
              [
                3338
              ]
            ],
            [
              [
                3339
              ]
            ],
            [
              [
                3340
              ]
            ],
            [
              [
                3341
              ]
            ],
            [
              [
                3656
              ]
            ],
            [
              [
                7359
              ]
            ],
            [
              [
                7360
              ]
            ],
            [
              [
                9720
              ]
            ],
            [
              [
                2484
              ]
            ],
            [
              [
                6243
              ]
            ],
            [
              [
                6244
              ]
            ],
            [
              [
                6248
              ]
            ],
            [
              [
                8629
              ]
            ],
            [
              [
                8630
              ]
            ],
            [
              [
                8631
              ]
            ],
            [
              [
                8632
              ]
            ],
            [
              [
                8694
              ]
            ],
            [
              [
                8696
              ]
            ],
            [
              [
                9198
              ]
            ],
            [
              [
                9778
              ]
            ],
            [
              [
                9906
              ]
            ],
            [
              [
                7184,
                9757
              ]
            ],
            [
              [
                9756
              ]
            ],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [
              [
                9215
              ]
            ],
            [],
            [
              [
                8684
              ]
            ],
            [
              [
                8685
              ]
            ],
            [
              [
                8686
              ]
            ],
            [
              [
                2195
              ]
            ],
            [
              [
                2196
              ]
            ],
            [
              [
                2197
              ]
            ],
            [
              [
                2199,
                8746
              ]
            ],
            [
              [
                9633
              ]
            ],
            [
              [
                3559
              ]
            ],
            [
              [
                3560
              ]
            ],
            [
              [
                3561
              ]
            ],
            [
              [
                3563,
                7695
              ]
            ],
            [
              [
                3628
              ]
            ],
            [
              [
                8527
              ]
            ],
            [
              [
                8975
              ]
            ],
            [
              [
                8976
              ]
            ],
            [
              [
                5550
              ]
            ],
            [
              [
                6075
              ]
            ],
            [
              [
                9256
              ]
            ],
            [
              [
                9257
              ]
            ],
            [
              [
                3980
              ]
            ],
            [
              [
                3981
              ]
            ],
            [
              [
                3982
              ]
            ],
            [
              [
                3984,
                7990
              ]
            ],
            [
              [
                5531
              ]
            ],
            [
              [
                5532
              ]
            ],
            [
              [
                7989
              ]
            ],
            [
              [
                4141
              ]
            ],
            [
              [
                4142
              ]
            ],
            [
              [
                9410
              ]
            ],
            [
              [
                5244
              ]
            ],
            [
              [
                7001
              ]
            ],
            [
              [
                8394
              ]
            ],
            [
              [
                8395
              ]
            ],
            [
              [
                8428
              ]
            ],
            [
              [
                8429
              ]
            ],
            [
              [
                8430
              ]
            ],
            [
              [
                8431
              ]
            ],
            [
              [
                8432
              ]
            ],
            [
              [
                8433
              ]
            ],
            [
              [
                8434
              ]
            ],
            [
              [
                8435
              ]
            ],
            [
              [
                8436
              ]
            ],
            [
              [
                8437
              ]
            ],
            [
              [
                9904
              ]
            ],
            [
              [
                8193
              ]
            ],
            [
              [
                8194
              ]
            ]
          ]
        }
      ]
    }
  },
  'arcs': [
    [
      [
        18136,
        59828
      ],
      [
        1,
        133
      ],
      [
        -1,
        50
      ]
    ],
    [
      [
        18136,
        60011
      ],
      [
        24,
        -1
      ],
      [
        114,
        1
      ],
      [
        183,
        0
      ]
    ],
    [
      [
        18457,
        60011
      ],
      [
        101,
        0
      ]
    ],
    [
      [
        18558,
        60011
      ],
      [
        -2,
        -21
      ],
      [
        4,
        -18
      ],
      [
        0,
        -17
      ],
      [
        -4,
        -16
      ],
      [
        -1,
        -26
      ],
      [
        -7,
        -28
      ],
      [
        0,
        -23
      ],
      [
        -4,
        -18
      ],
      [
        1,
        -11
      ],
      [
        -3,
        -18
      ],
      [
        -2,
        0
      ],
      [
        1,
        -2
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -2
      ],
      [
        1,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -4
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -10
      ],
      [
        -1,
        1
      ]
    ],
    [
      [
        18538,
        59778
      ],
      [
        0,
        0
      ]
    ],
    [
      [
        18538,
        59778
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -12
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        1,
        -6
      ],
      [
        0,
        -1
      ],
      [
        1,
        0
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -7
      ],
      [
        1,
        0
      ],
      [
        0,
        -7
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        0,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        -5
      ],
      [
        1,
        -3
      ],
      [
        0,
        -5
      ],
      [
        -1,
        2
      ],
      [
        0,
        -4
      ],
      [
        1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -2
      ],
      [
        1,
        -3
      ],
      [
        1,
        -3
      ],
      [
        0,
        -3
      ]
    ],
    [
      [
        18536,
        59695
      ],
      [
        0,
        0
      ]
    ],
    [
      [
        18536,
        59695
      ],
      [
        -1,
        0
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -5
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        1,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        1,
        -4
      ],
      [
        0,
        -12
      ],
      [
        1,
        -5
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -5
      ],
      [
        0,
        -14
      ],
      [
        1,
        0
      ],
      [
        0,
        -12
      ],
      [
        1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -4
      ],
      [
        0,
        -4
      ],
      [
        -1,
        0
      ],
      [
        0,
        -4
      ],
      [
        1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        1,
        0
      ],
      [
        0,
        -2
      ],
      [
        -1,
        0
      ],
      [
        0,
        -14
      ],
      [
        -1,
        -3
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        -3
      ],
      [
        1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        -2
      ],
      [
        1,
        0
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        -2,
        -3
      ],
      [
        0,
        -5
      ],
      [
        1,
        -1
      ],
      [
        0,
        -10
      ],
      [
        -2,
        0
      ],
      [
        0,
        -7
      ],
      [
        1,
        1
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -7
      ],
      [
        1,
        -1
      ],
      [
        0,
        -9
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        1,
        -3
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        1,
        1
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -10
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -5
      ],
      [
        1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -2
      ],
      [
        0,
        1
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        1,
        -2
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        1,
        0
      ],
      [
        1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        2
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        1,
        -1
      ],
      [
        0,
        -6
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        2,
        2
      ],
      [
        0,
        -4
      ],
      [
        1,
        -3
      ],
      [
        0,
        -6
      ],
      [
        1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -14
      ],
      [
        -1,
        -1
      ],
      [
        -4,
        -22
      ],
      [
        -1,
        -10
      ],
      [
        -3,
        -13
      ],
      [
        -3,
        -9
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        8
      ],
      [
        -1,
        7
      ],
      [
        -1,
        1
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        -4
      ],
      [
        -3,
        -4
      ],
      [
        -2,
        -9
      ],
      [
        1,
        -11
      ],
      [
        1,
        -7
      ],
      [
        -3,
        -8
      ],
      [
        -4,
        7
      ],
      [
        -1,
        2
      ],
      [
        -3,
        -5
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -6
      ],
      [
        -5,
        -2
      ],
      [
        0,
        -12
      ],
      [
        -2,
        -8
      ],
      [
        -2,
        2
      ],
      [
        -2,
        2
      ],
      [
        -2,
        1
      ],
      [
        -3,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        -9
      ],
      [
        -3,
        2
      ],
      [
        -4,
        4
      ],
      [
        -2,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -10
      ],
      [
        -3,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        2
      ],
      [
        -2,
        3
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -9
      ],
      [
        -2,
        -3
      ],
      [
        -4,
        -4
      ],
      [
        -5,
        -5
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        1
      ],
      [
        -5,
        7
      ],
      [
        -2,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -4,
        -5
      ],
      [
        -3,
        -6
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        -6
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -6
      ],
      [
        -1,
        -7
      ],
      [
        -2,
        -6
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        3
      ],
      [
        -2,
        5
      ],
      [
        -3,
        1
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -7
      ],
      [
        -3,
        -4
      ],
      [
        -4,
        -7
      ],
      [
        0,
        -11
      ],
      [
        -1,
        -10
      ],
      [
        1,
        -14
      ],
      [
        -1,
        -7
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -10
      ],
      [
        0,
        -4
      ],
      [
        -3,
        -4
      ],
      [
        -3,
        3
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        2
      ],
      [
        -2,
        2
      ],
      [
        -3,
        6
      ],
      [
        -5,
        -2
      ],
      [
        -3,
        4
      ],
      [
        -4,
        -9
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -10
      ],
      [
        -1,
        -13
      ],
      [
        -3,
        -8
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -20
      ],
      [
        1,
        -14
      ],
      [
        0,
        -5
      ],
      [
        1,
        -9
      ],
      [
        1,
        -4
      ],
      [
        0,
        -24
      ],
      [
        2,
        -6
      ],
      [
        3,
        -5
      ],
      [
        1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        1,
        -6
      ],
      [
        -2,
        -7
      ],
      [
        -2,
        -8
      ],
      [
        1,
        -13
      ],
      [
        0,
        -12
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -7
      ],
      [
        2,
        -6
      ],
      [
        1,
        -6
      ],
      [
        0,
        -5
      ],
      [
        2,
        -3
      ],
      [
        2,
        -14
      ],
      [
        -1,
        -16
      ],
      [
        0,
        -14
      ],
      [
        -3,
        -11
      ],
      [
        -1,
        -12
      ],
      [
        0,
        -13
      ],
      [
        -2,
        -8
      ],
      [
        1,
        -5
      ],
      [
        -1,
        -12
      ],
      [
        0,
        -323
      ]
    ],
    [
      [
        18336,
        58297
      ],
      [
        0,
        -1409
      ]
    ],
    [
      [
        18336,
        56888
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        -5,
        -17
      ],
      [
        -9,
        5
      ],
      [
        -4,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        2
      ],
      [
        -4,
        3
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        0
      ],
      [
        -3,
        4
      ],
      [
        -3,
        -1
      ],
      [
        -2,
        2
      ],
      [
        -3,
        -1
      ],
      [
        -3,
        0
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        2
      ],
      [
        -2,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -12
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -6
      ],
      [
        -3,
        -13
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        -4,
        -14
      ],
      [
        0,
        -16
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        0,
        3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        5
      ],
      [
        -1,
        0
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        -7,
        0
      ],
      [
        -1,
        4
      ],
      [
        -1,
        3
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        6
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        -1,
        8
      ],
      [
        -3,
        6
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        4
      ],
      [
        -2,
        4
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        2
      ],
      [
        0,
        3
      ],
      [
        -1,
        9
      ],
      [
        -2,
        10
      ],
      [
        0,
        8
      ],
      [
        -1,
        2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        2
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -4,
        -4
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -4,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        3
      ],
      [
        -3,
        5
      ],
      [
        -2,
        2
      ],
      [
        -6,
        0
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        0,
        3
      ],
      [
        -2,
        6
      ],
      [
        0,
        2
      ],
      [
        -1,
        2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        3
      ],
      [
        -1,
        2
      ],
      [
        -1,
        3
      ],
      [
        0,
        2
      ],
      [
        -1,
        3
      ],
      [
        0,
        3
      ],
      [
        -1,
        4
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -2,
        5
      ],
      [
        -1,
        7
      ],
      [
        -2,
        4
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        8
      ],
      [
        -4,
        0
      ],
      [
        -4,
        -3
      ],
      [
        -3,
        7
      ],
      [
        -3,
        2
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        18112,
        56871
      ],
      [
        -1,
        3
      ],
      [
        -4,
        14
      ],
      [
        -4,
        25
      ],
      [
        -1,
        7
      ],
      [
        -1,
        5
      ],
      [
        -1,
        3
      ],
      [
        -1,
        3
      ],
      [
        -2,
        2
      ],
      [
        -2,
        6
      ],
      [
        -4,
        1
      ],
      [
        -4,
        4
      ],
      [
        -1,
        4
      ],
      [
        -1,
        9
      ],
      [
        -3,
        10
      ],
      [
        -1,
        3
      ],
      [
        -1,
        2
      ],
      [
        -3,
        13
      ],
      [
        -1,
        2
      ],
      [
        -4,
        1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        -1,
        3
      ],
      [
        0,
        7
      ],
      [
        -1,
        5
      ],
      [
        -1,
        6
      ],
      [
        -4,
        7
      ],
      [
        -1,
        4
      ],
      [
        -2,
        1
      ],
      [
        -2,
        10
      ],
      [
        0,
        3
      ],
      [
        -2,
        4
      ],
      [
        -1,
        0
      ],
      [
        -4,
        -2
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        3
      ],
      [
        -2,
        8
      ],
      [
        0,
        5
      ],
      [
        1,
        10
      ],
      [
        0,
        33
      ],
      [
        1,
        10
      ],
      [
        0,
        11
      ],
      [
        -1,
        15
      ],
      [
        -2,
        15
      ],
      [
        -4,
        31
      ],
      [
        -5,
        13
      ],
      [
        -2,
        13
      ],
      [
        0,
        9
      ],
      [
        1,
        2
      ],
      [
        0,
        11
      ],
      [
        -1,
        5
      ],
      [
        -3,
        8
      ],
      [
        -1,
        10
      ],
      [
        0,
        1
      ],
      [
        1,
        8
      ],
      [
        -1,
        5
      ],
      [
        0,
        5
      ],
      [
        -2,
        6
      ],
      [
        0,
        6
      ],
      [
        -1,
        3
      ],
      [
        1,
        5
      ],
      [
        0,
        3
      ],
      [
        -1,
        2
      ],
      [
        0,
        9
      ],
      [
        -1,
        2
      ],
      [
        -1,
        10
      ],
      [
        -1,
        6
      ],
      [
        -1,
        12
      ],
      [
        0,
        7
      ],
      [
        -1,
        4
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        3
      ],
      [
        -1,
        7
      ],
      [
        -1,
        1
      ],
      [
        -1,
        3
      ],
      [
        -2,
        3
      ],
      [
        -2,
        3
      ],
      [
        -1,
        4
      ],
      [
        -2,
        5
      ],
      [
        0,
        3
      ],
      [
        -1,
        4
      ],
      [
        -1,
        4
      ],
      [
        -3,
        8
      ],
      [
        -2,
        5
      ],
      [
        -2,
        6
      ],
      [
        -1,
        8
      ],
      [
        -4,
        24
      ],
      [
        -1,
        13
      ],
      [
        0,
        11
      ],
      [
        -1,
        13
      ],
      [
        -2,
        11
      ],
      [
        -2,
        6
      ],
      [
        -2,
        8
      ],
      [
        -1,
        2
      ],
      [
        -4,
        9
      ],
      [
        -1,
        3
      ],
      [
        -2,
        8
      ],
      [
        -1,
        7
      ],
      [
        -1,
        3
      ],
      [
        0,
        23
      ],
      [
        2,
        14
      ],
      [
        0,
        6
      ],
      [
        -1,
        11
      ],
      [
        0,
        11
      ],
      [
        1,
        9
      ],
      [
        0,
        7
      ],
      [
        -1,
        8
      ],
      [
        0,
        8
      ],
      [
        -1,
        8
      ],
      [
        1,
        4
      ],
      [
        1,
        14
      ],
      [
        0,
        16
      ],
      [
        -1,
        8
      ]
    ],
    [
      [
        17974,
        57684
      ],
      [
        -1,
        9
      ],
      [
        0,
        22
      ],
      [
        1,
        11
      ],
      [
        2,
        8
      ],
      [
        5,
        17
      ],
      [
        1,
        6
      ],
      [
        0,
        12
      ],
      [
        -2,
        10
      ],
      [
        -3,
        7
      ],
      [
        -6,
        9
      ],
      [
        -1,
        6
      ],
      [
        1,
        5
      ],
      [
        4,
        14
      ],
      [
        3,
        4
      ],
      [
        6,
        -1
      ],
      [
        3,
        3
      ],
      [
        2,
        6
      ],
      [
        2,
        12
      ],
      [
        1,
        28
      ],
      [
        0,
        24
      ],
      [
        -1,
        20
      ],
      [
        -1,
        6
      ],
      [
        -1,
        4
      ],
      [
        -1,
        24
      ],
      [
        0,
        9
      ],
      [
        -1,
        29
      ],
      [
        -3,
        40
      ],
      [
        0,
        33
      ],
      [
        -2,
        33
      ],
      [
        -2,
        18
      ],
      [
        -4,
        47
      ],
      [
        -7,
        23
      ],
      [
        -3,
        17
      ],
      [
        -1,
        7
      ],
      [
        0,
        20
      ],
      [
        -2,
        17
      ],
      [
        -1,
        9
      ],
      [
        -1,
        12
      ],
      [
        1,
        16
      ],
      [
        1,
        5
      ],
      [
        3,
        8
      ],
      [
        1,
        7
      ],
      [
        0,
        10
      ],
      [
        -1,
        7
      ],
      [
        0,
        21
      ],
      [
        -1,
        17
      ],
      [
        0,
        3
      ],
      [
        2,
        8
      ],
      [
        1,
        12
      ],
      [
        0,
        15
      ],
      [
        -1,
        10
      ],
      [
        -5,
        26
      ],
      [
        -4,
        12
      ],
      [
        0,
        15
      ],
      [
        2,
        16
      ],
      [
        1,
        8
      ],
      [
        -1,
        5
      ],
      [
        -3,
        7
      ],
      [
        -2,
        7
      ],
      [
        -1,
        8
      ],
      [
        0,
        4
      ],
      [
        2,
        25
      ],
      [
        1,
        26
      ],
      [
        -2,
        16
      ],
      [
        1,
        24
      ],
      [
        -4,
        19
      ],
      [
        1,
        4
      ],
      [
        1,
        6
      ],
      [
        3,
        18
      ],
      [
        -1,
        4
      ],
      [
        -1,
        11
      ],
      [
        0,
        6
      ],
      [
        1,
        7
      ],
      [
        4,
        10
      ],
      [
        4,
        2
      ],
      [
        1,
        12
      ],
      [
        -10,
        31
      ],
      [
        -2,
        12
      ],
      [
        0,
        19
      ],
      [
        -2,
        7
      ],
      [
        -4,
        8
      ],
      [
        0,
        3
      ],
      [
        1,
        14
      ],
      [
        -1,
        7
      ],
      [
        -3,
        16
      ],
      [
        -1,
        11
      ],
      [
        0,
        25
      ],
      [
        1,
        4
      ],
      [
        0,
        4
      ],
      [
        1,
        3
      ],
      [
        2,
        7
      ],
      [
        0,
        11
      ],
      [
        -1,
        5
      ],
      [
        -2,
        2
      ],
      [
        0,
        14
      ],
      [
        1,
        6
      ],
      [
        0,
        4
      ],
      [
        -1,
        9
      ],
      [
        -1,
        5
      ],
      [
        -3,
        11
      ],
      [
        0,
        13
      ],
      [
        2,
        7
      ],
      [
        3,
        9
      ],
      [
        6,
        4
      ],
      [
        2,
        0
      ],
      [
        12,
        11
      ],
      [
        1,
        3
      ],
      [
        1,
        5
      ],
      [
        7,
        21
      ],
      [
        2,
        -1
      ],
      [
        1,
        -11
      ],
      [
        2,
        -2
      ],
      [
        2,
        4
      ],
      [
        3,
        10
      ],
      [
        7,
        11
      ],
      [
        7,
        1
      ],
      [
        10,
        -2
      ],
      [
        1,
        -3
      ],
      [
        1,
        -3
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -4
      ],
      [
        0,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        -1
      ],
      [
        3,
        2
      ],
      [
        4,
        11
      ],
      [
        2,
        1
      ],
      [
        2,
        -1
      ],
      [
        1,
        -9
      ],
      [
        1,
        -5
      ],
      [
        1,
        -1
      ],
      [
        5,
        12
      ],
      [
        3,
        11
      ],
      [
        2,
        2
      ],
      [
        1,
        0
      ],
      [
        10,
        -5
      ],
      [
        2,
        -15
      ],
      [
        7,
        -26
      ],
      [
        3,
        -3
      ],
      [
        6,
        -27
      ],
      [
        0,
        -13
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -4
      ],
      [
        0,
        -2
      ],
      [
        9,
        -14
      ],
      [
        3,
        -12
      ],
      [
        1,
        -8
      ],
      [
        1,
        -3
      ],
      [
        3,
        -7
      ],
      [
        4,
        -7
      ],
      [
        1,
        0
      ],
      [
        6,
        2
      ],
      [
        6,
        6
      ],
      [
        4,
        8
      ],
      [
        3,
        0
      ],
      [
        4,
        -5
      ],
      [
        0,
        1
      ],
      [
        1,
        4
      ],
      [
        3,
        15
      ],
      [
        0,
        22
      ],
      [
        7,
        41
      ],
      [
        0,
        2
      ],
      [
        -1,
        5
      ],
      [
        -2,
        4
      ],
      [
        0,
        8
      ],
      [
        1,
        4
      ],
      [
        3,
        6
      ],
      [
        2,
        0
      ],
      [
        1,
        2
      ],
      [
        3,
        26
      ],
      [
        6,
        43
      ],
      [
        2,
        10
      ],
      [
        3,
        5
      ],
      [
        0,
        153
      ],
      [
        1,
        77
      ],
      [
        0,
        96
      ],
      [
        -1,
        30
      ],
      [
        0,
        141
      ],
      [
        -1,
        5
      ],
      [
        0,
        254
      ]
    ],
    [
      [
        24679,
        53026
      ],
      [
        5,
        0
      ]
    ],
    [
      [
        24684,
        53026
      ],
      [
        56,
        0
      ]
    ],
    [
      [
        24740,
        53026
      ],
      [
        0,
        -110
      ],
      [
        4,
        0
      ],
      [
        1,
        -17
      ],
      [
        4,
        0
      ],
      [
        0,
        -20
      ],
      [
        4,
        -27
      ],
      [
        3,
        -36
      ],
      [
        -1,
        -15
      ],
      [
        4,
        -14
      ],
      [
        1,
        -17
      ],
      [
        4,
        -17
      ],
      [
        -1,
        -10
      ],
      [
        3,
        -25
      ],
      [
        0,
        -27
      ]
    ],
    [
      [
        24766,
        52691
      ],
      [
        -1,
        -2
      ],
      [
        2,
        -17
      ],
      [
        -1,
        -37
      ],
      [
        3,
        -20
      ],
      [
        -1,
        -36
      ],
      [
        1,
        -23
      ],
      [
        0,
        -273
      ],
      [
        1,
        -2
      ],
      [
        14,
        -57
      ],
      [
        1,
        -27
      ],
      [
        7,
        -62
      ]
    ],
    [
      [
        24792,
        52135
      ],
      [
        -23,
        41
      ],
      [
        -16,
        29
      ],
      [
        -5,
        5
      ],
      [
        -9,
        -2
      ],
      [
        -6,
        -16
      ],
      [
        -7,
        3
      ],
      [
        -6,
        -7
      ],
      [
        -18,
        -4
      ]
    ],
    [
      [
        24702,
        52184
      ],
      [
        0,
        52
      ],
      [
        3,
        28
      ],
      [
        -4,
        12
      ],
      [
        -9,
        68
      ],
      [
        -7,
        19
      ],
      [
        -2,
        38
      ],
      [
        1,
        5
      ],
      [
        -3,
        13
      ],
      [
        -2,
        10
      ],
      [
        0,
        190
      ]
    ],
    [
      [
        24679,
        52619
      ],
      [
        0,
        407
      ]
    ],
    [
      [
        17985,
        67226
      ],
      [
        61,
        1
      ]
    ],
    [
      [
        18046,
        67227
      ],
      [
        184,
        0
      ]
    ],
    [
      [
        18230,
        67227
      ],
      [
        0,
        -407
      ],
      [
        -14,
        0
      ],
      [
        0,
        -99
      ],
      [
        -47,
        0
      ]
    ],
    [
      [
        18169,
        66721
      ],
      [
        -32,
        0
      ],
      [
        0,
        51
      ],
      [
        -83,
        1
      ],
      [
        0,
        16
      ],
      [
        -5,
        0
      ],
      [
        0,
        32
      ],
      [
        -64,
        0
      ]
    ],
    [
      [
        17985,
        66821
      ],
      [
        0,
        405
      ]
    ],
    [
      [
        22846,
        73017
      ],
      [
        180,
        1
      ]
    ],
    [
      [
        23026,
        73018
      ],
      [
        0,
        -178
      ],
      [
        5,
        0
      ],
      [
        0,
        -67
      ]
    ],
    [
      [
        23031,
        72773
      ],
      [
        0,
        -135
      ],
      [
        36,
        -1
      ],
      [
        0,
        -101
      ],
      [
        144,
        1
      ],
      [
        0,
        101
      ],
      [
        35,
        1
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        23246,
        72740
      ],
      [
        36,
        -2
      ]
    ],
    [
      [
        23282,
        72738
      ],
      [
        1,
        -303
      ],
      [
        7,
        0
      ],
      [
        0,
        -202
      ]
    ],
    [
      [
        23290,
        72233
      ],
      [
        -3,
        0
      ],
      [
        -140,
        -1
      ]
    ],
    [
      [
        23147,
        72232
      ],
      [
        -219,
        0
      ]
    ],
    [
      [
        22928,
        72232
      ],
      [
        0,
        17
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        2
      ],
      [
        0,
        5
      ],
      [
        -1,
        5
      ],
      [
        0,
        3
      ],
      [
        1,
        2
      ],
      [
        1,
        0
      ],
      [
        1,
        8
      ],
      [
        0,
        17
      ],
      [
        1,
        2
      ],
      [
        -1,
        3
      ],
      [
        -1,
        2
      ],
      [
        0,
        6
      ],
      [
        1,
        2
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        4
      ],
      [
        1,
        0
      ],
      [
        1,
        3
      ],
      [
        -1,
        2
      ],
      [
        0,
        4
      ],
      [
        1,
        5
      ],
      [
        0,
        14
      ],
      [
        -1,
        3
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        0,
        3
      ],
      [
        -1,
        2
      ],
      [
        0,
        11
      ],
      [
        -1,
        2
      ],
      [
        -4,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        2
      ],
      [
        0,
        2
      ],
      [
        -2,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        15
      ],
      [
        -2,
        6
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        0,
        1
      ],
      [
        1,
        9
      ],
      [
        -1,
        1
      ],
      [
        -1,
        3
      ],
      [
        0,
        7
      ],
      [
        1,
        3
      ],
      [
        0,
        2
      ],
      [
        -1,
        4
      ],
      [
        0,
        2
      ],
      [
        -1,
        3
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        22917,
        72433
      ],
      [
        0,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        2
      ],
      [
        -1,
        17
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        0
      ],
      [
        0,
        3
      ],
      [
        1,
        3
      ],
      [
        0,
        1
      ],
      [
        -1,
        3
      ],
      [
        -1,
        4
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        1,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        1
      ],
      [
        -1,
        3
      ],
      [
        0,
        7
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        3
      ],
      [
        0,
        3
      ],
      [
        -1,
        5
      ],
      [
        -2,
        6
      ],
      [
        -1,
        3
      ],
      [
        0,
        3
      ],
      [
        1,
        4
      ],
      [
        1,
        2
      ],
      [
        0,
        7
      ],
      [
        -2,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        10
      ],
      [
        -3,
        7
      ],
      [
        -2,
        2
      ],
      [
        0,
        4
      ],
      [
        -2,
        4
      ],
      [
        -1,
        0
      ],
      [
        0,
        2
      ],
      [
        1,
        3
      ],
      [
        0,
        1
      ],
      [
        2,
        2
      ],
      [
        0,
        2
      ],
      [
        -2,
        3
      ],
      [
        -1,
        3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        -1,
        5
      ],
      [
        0,
        3
      ],
      [
        1,
        2
      ],
      [
        0,
        2
      ],
      [
        -1,
        5
      ],
      [
        0,
        6
      ],
      [
        1,
        1
      ],
      [
        0,
        3
      ],
      [
        -1,
        1
      ],
      [
        0,
        6
      ],
      [
        -2,
        8
      ],
      [
        -1,
        0
      ],
      [
        -2,
        5
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        0,
        12
      ],
      [
        -1,
        5
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        3
      ],
      [
        0,
        1
      ],
      [
        1,
        1
      ],
      [
        0,
        3
      ],
      [
        -1,
        2
      ],
      [
        -3,
        2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        2
      ],
      [
        1,
        2
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        5
      ],
      [
        1,
        4
      ],
      [
        0,
        1
      ],
      [
        -1,
        5
      ],
      [
        0,
        3
      ],
      [
        1,
        3
      ],
      [
        0,
        2
      ],
      [
        -1,
        4
      ],
      [
        0,
        4
      ],
      [
        1,
        -3
      ],
      [
        1,
        -1
      ],
      [
        1,
        2
      ],
      [
        -1,
        4
      ],
      [
        0,
        3
      ],
      [
        -1,
        2
      ],
      [
        -1,
        1
      ],
      [
        2,
        3
      ],
      [
        0,
        2
      ],
      [
        -3,
        9
      ],
      [
        -2,
        3
      ],
      [
        -1,
        3
      ],
      [
        1,
        4
      ],
      [
        0,
        4
      ],
      [
        -1,
        1
      ],
      [
        -2,
        1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        4
      ],
      [
        -1,
        3
      ],
      [
        0,
        2
      ],
      [
        1,
        4
      ],
      [
        0,
        6
      ],
      [
        -2,
        3
      ],
      [
        0,
        4
      ],
      [
        1,
        4
      ],
      [
        0,
        2
      ],
      [
        -1,
        4
      ],
      [
        0,
        1
      ],
      [
        1,
        7
      ],
      [
        1,
        8
      ],
      [
        0,
        4
      ],
      [
        -1,
        2
      ],
      [
        -2,
        3
      ],
      [
        0,
        3
      ],
      [
        -1,
        13
      ],
      [
        1,
        2
      ],
      [
        0,
        5
      ],
      [
        -2,
        1
      ],
      [
        0,
        6
      ],
      [
        1,
        6
      ],
      [
        0,
        1
      ],
      [
        -1,
        17
      ],
      [
        0,
        7
      ],
      [
        -1,
        4
      ],
      [
        0,
        2
      ],
      [
        -2,
        3
      ],
      [
        -1,
        3
      ],
      [
        -3,
        15
      ],
      [
        -2,
        1
      ],
      [
        0,
        3
      ],
      [
        1,
        3
      ],
      [
        0,
        10
      ],
      [
        -1,
        4
      ],
      [
        -1,
        1
      ],
      [
        0,
        3
      ],
      [
        1,
        2
      ],
      [
        0,
        4
      ],
      [
        -1,
        2
      ],
      [
        -1,
        6
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        1
      ],
      [
        0,
        4
      ],
      [
        1,
        3
      ],
      [
        0,
        5
      ],
      [
        -2,
        9
      ],
      [
        0,
        10
      ],
      [
        -1,
        3
      ],
      [
        0,
        5
      ],
      [
        -1,
        2
      ],
      [
        -2,
        2
      ],
      [
        0,
        5
      ],
      [
        1,
        4
      ],
      [
        0,
        9
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        -1,
        7
      ],
      [
        0,
        6
      ]
    ],
    [
      [
        22690,
        71930
      ],
      [
        71,
        -1
      ]
    ],
    [
      [
        22761,
        71929
      ],
      [
        172,
        -1
      ]
    ],
    [
      [
        22933,
        71928
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -4
      ],
      [
        0,
        -8
      ],
      [
        1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -7
      ],
      [
        1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -2
      ],
      [
        1,
        -3
      ],
      [
        1,
        -2
      ],
      [
        0,
        -17
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        22934,
        71826
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        2,
        -5
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        1,
        -1
      ],
      [
        0,
        -34
      ],
      [
        -1,
        -2
      ],
      [
        1,
        -3
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -9
      ],
      [
        1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -7
      ],
      [
        1,
        -3
      ],
      [
        0,
        -24
      ],
      [
        -1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -6
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -11
      ],
      [
        1,
        -3
      ],
      [
        1,
        -3
      ],
      [
        1,
        -2
      ],
      [
        0,
        -11
      ],
      [
        1,
        -15
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -2
      ],
      [
        1,
        -2
      ],
      [
        3,
        -4
      ],
      [
        2,
        2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -20
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -17
      ],
      [
        1,
        -1
      ],
      [
        1,
        -3
      ],
      [
        0,
        -1
      ],
      [
        1,
        4
      ],
      [
        1,
        3
      ],
      [
        4,
        4
      ],
      [
        1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        1,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        1,
        0
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        2
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -9
      ],
      [
        1,
        -13
      ],
      [
        0,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        -1
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        -16
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -7
      ],
      [
        -1,
        0
      ],
      [
        0,
        -8
      ],
      [
        -2,
        -1
      ],
      [
        0,
        -1
      ],
      [
        1,
        -4
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        1
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        -1,
        -19
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -9
      ],
      [
        1,
        -1
      ],
      [
        0,
        -7
      ],
      [
        1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        -1,
        0
      ],
      [
        0,
        -5
      ],
      [
        1,
        -4
      ],
      [
        0,
        -12
      ],
      [
        1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        1,
        -3
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -11
      ],
      [
        0,
        -1
      ],
      [
        1,
        -3
      ],
      [
        0,
        -14
      ],
      [
        1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        -2,
        -1
      ],
      [
        0,
        -3
      ],
      [
        1,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -13
      ],
      [
        2,
        -5
      ],
      [
        0,
        -19
      ]
    ],
    [
      [
        22945,
        71224
      ],
      [
        -2,
        -3
      ],
      [
        -65,
        -1
      ],
      [
        -69,
        0
      ]
    ],
    [
      [
        22809,
        71220
      ],
      [
        -112,
        0
      ]
    ],
    [
      [
        22697,
        71220
      ],
      [
        0,
        406
      ],
      [
        -7,
        0
      ],
      [
        0,
        304
      ]
    ],
    [
      [
        20921,
        68824
      ],
      [
        2,
        6
      ],
      [
        4,
        5
      ],
      [
        9,
        -8
      ],
      [
        10,
        9
      ],
      [
        9,
        -3
      ],
      [
        4,
        12
      ],
      [
        9,
        10
      ],
      [
        6,
        -10
      ],
      [
        6,
        -2
      ],
      [
        6,
        20
      ],
      [
        51,
        -1
      ],
      [
        20,
        0
      ]
    ],
    [
      [
        21057,
        68862
      ],
      [
        -1,
        -302
      ],
      [
        -1,
        -103
      ],
      [
        34,
        1
      ],
      [
        0,
        -135
      ]
    ],
    [
      [
        21089,
        68323
      ],
      [
        -168,
        0
      ]
    ],
    [
      [
        20921,
        68323
      ],
      [
        0,
        46
      ]
    ],
    [
      [
        20921,
        68369
      ],
      [
        0,
        455
      ]
    ],
    [
      [
        29114,
        66796
      ],
      [
        24,
        -19
      ],
      [
        30,
        -46
      ],
      [
        12,
        4
      ],
      [
        34,
        8
      ],
      [
        7,
        15
      ]
    ],
    [
      [
        29221,
        66758
      ],
      [
        5,
        -14
      ],
      [
        -3,
        -32
      ],
      [
        -8,
        0
      ],
      [
        -5,
        -11
      ],
      [
        9,
        -39
      ],
      [
        9,
        6
      ],
      [
        15,
        -8
      ],
      [
        1,
        20
      ]
    ],
    [
      [
        29244,
        66680
      ],
      [
        5,
        -14
      ],
      [
        -2,
        -58
      ],
      [
        -6,
        -57
      ],
      [
        -11,
        -50
      ],
      [
        -3,
        -29
      ],
      [
        2,
        -15
      ],
      [
        3,
        -13
      ],
      [
        -1,
        -38
      ],
      [
        -4,
        -28
      ],
      [
        -6,
        -58
      ],
      [
        0,
        -15
      ],
      [
        3,
        1
      ]
    ],
    [
      [
        29224,
        66306
      ],
      [
        3,
        -36
      ],
      [
        -4,
        2
      ],
      [
        -5,
        -18
      ],
      [
        -20,
        -9
      ],
      [
        -9,
        21
      ],
      [
        -18,
        -22
      ]
    ],
    [
      [
        29171,
        66244
      ],
      [
        -49,
        81
      ],
      [
        -26,
        109
      ]
    ],
    [
      [
        29096,
        66434
      ],
      [
        11,
        54
      ],
      [
        12,
        72
      ],
      [
        -1,
        25
      ],
      [
        -9,
        120
      ],
      [
        0,
        48
      ],
      [
        5,
        43
      ]
    ],
    [
      [
        12999,
        82714
      ],
      [
        4,
        31
      ],
      [
        0,
        17
      ],
      [
        8,
        -1
      ],
      [
        2,
        -18
      ],
      [
        -1,
        -11
      ],
      [
        -4,
        -9
      ],
      [
        -2,
        -11
      ],
      [
        -6,
        -6
      ],
      [
        -1,
        8
      ]
    ],
    [
      [
        12979,
        82569
      ],
      [
        2,
        29
      ],
      [
        15,
        38
      ],
      [
        6,
        2
      ],
      [
        17,
        -27
      ],
      [
        4,
        -11
      ],
      [
        -1,
        -22
      ],
      [
        -24,
        -37
      ],
      [
        -7,
        -1
      ],
      [
        -11,
        13
      ],
      [
        -1,
        16
      ]
    ],
    [
      [
        12954,
        82690
      ],
      [
        1,
        4
      ],
      [
        9,
        26
      ],
      [
        2,
        4
      ],
      [
        8,
        -1
      ],
      [
        5,
        27
      ],
      [
        4,
        20
      ],
      [
        5,
        13
      ],
      [
        2,
        -1
      ],
      [
        1,
        -7
      ],
      [
        -1,
        -17
      ],
      [
        -4,
        -33
      ],
      [
        -7,
        -25
      ],
      [
        -3,
        -4
      ],
      [
        -1,
        -37
      ],
      [
        -3,
        -9
      ],
      [
        -4,
        0
      ],
      [
        -14,
        30
      ],
      [
        0,
        10
      ]
    ],
    [
      [
        12982,
        82959
      ],
      [
        9,
        4
      ],
      [
        6,
        12
      ],
      [
        7,
        3
      ],
      [
        9,
        46
      ],
      [
        11,
        10
      ],
      [
        9,
        -1
      ],
      [
        5,
        -8
      ],
      [
        1,
        14
      ],
      [
        12,
        19
      ],
      [
        5,
        20
      ],
      [
        2,
        34
      ],
      [
        10,
        15
      ],
      [
        1,
        22
      ],
      [
        6,
        17
      ],
      [
        16,
        13
      ],
      [
        11,
        -14
      ]
    ],
    [
      [
        13102,
        83165
      ],
      [
        -2,
        -19
      ],
      [
        71,
        -81
      ],
      [
        -4,
        -34
      ],
      [
        -3,
        -19
      ],
      [
        -1,
        -8
      ],
      [
        11,
        -57
      ],
      [
        3,
        -50
      ],
      [
        2,
        -26
      ],
      [
        2,
        -43
      ],
      [
        21,
        3
      ],
      [
        50,
        11
      ],
      [
        24,
        -56
      ],
      [
        9,
        -21
      ],
      [
        28,
        -37
      ],
      [
        38,
        -54
      ],
      [
        10,
        -16
      ],
      [
        6,
        -8
      ],
      [
        11,
        -24
      ],
      [
        12,
        -24
      ]
    ],
    [
      [
        13390,
        82602
      ],
      [
        0,
        -3
      ],
      [
        1,
        -20
      ],
      [
        -7,
        -22
      ],
      [
        1,
        -29
      ],
      [
        10,
        -14
      ],
      [
        8,
        -12
      ],
      [
        5,
        -17
      ],
      [
        -4,
        -5
      ],
      [
        3,
        -26
      ],
      [
        1,
        -5
      ],
      [
        4,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        -3,
        -19
      ],
      [
        -8,
        -12
      ],
      [
        -6,
        -16
      ],
      [
        -9,
        -30
      ],
      [
        -9,
        -5
      ],
      [
        -6,
        -13
      ],
      [
        -16,
        -5
      ],
      [
        -5,
        -10
      ],
      [
        -6,
        4
      ],
      [
        -1,
        10
      ],
      [
        0,
        11
      ],
      [
        -5,
        10
      ],
      [
        -4,
        -3
      ],
      [
        -3,
        -9
      ],
      [
        -7,
        -5
      ],
      [
        -4,
        -13
      ],
      [
        -4,
        -6
      ],
      [
        -4,
        -21
      ],
      [
        -7,
        -13
      ],
      [
        -9,
        -5
      ],
      [
        -6,
        -9
      ],
      [
        1,
        -12
      ],
      [
        2,
        -6
      ],
      [
        3,
        -22
      ],
      [
        7,
        -20
      ],
      [
        6,
        -13
      ],
      [
        -2,
        -15
      ],
      [
        -1,
        -18
      ],
      [
        3,
        -19
      ],
      [
        -3,
        -15
      ],
      [
        -4,
        9
      ],
      [
        -9,
        4
      ],
      [
        -8,
        -3
      ],
      [
        -6,
        -2
      ],
      [
        -4,
        -4
      ],
      [
        -1,
        8
      ],
      [
        -4,
        8
      ],
      [
        -4,
        3
      ],
      [
        -1,
        10
      ],
      [
        0,
        6
      ],
      [
        -4,
        10
      ],
      [
        -3,
        6
      ],
      [
        -6,
        4
      ],
      [
        -4,
        9
      ],
      [
        -3,
        11
      ],
      [
        -2,
        7
      ],
      [
        -7,
        3
      ],
      [
        -5,
        12
      ],
      [
        -3,
        1
      ],
      [
        -5,
        -5
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        2,
        -1
      ],
      [
        2,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        1,
        -5
      ],
      [
        3,
        -4
      ],
      [
        0,
        -9
      ],
      [
        -4,
        -3
      ],
      [
        -3,
        -11
      ],
      [
        -6,
        1
      ],
      [
        -2,
        7
      ],
      [
        -5,
        4
      ],
      [
        -7,
        -5
      ],
      [
        -9,
        -4
      ],
      [
        -5,
        0
      ],
      [
        -3,
        -1
      ],
      [
        -3,
        0
      ],
      [
        0,
        -3
      ],
      [
        3,
        -10
      ],
      [
        0,
        -7
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        2
      ],
      [
        -3,
        4
      ],
      [
        -3,
        -2
      ],
      [
        -1,
        -7
      ],
      [
        -3,
        -6
      ],
      [
        -1,
        -8
      ],
      [
        1,
        -8
      ],
      [
        -2,
        -11
      ],
      [
        0,
        -11
      ],
      [
        -4,
        -5
      ],
      [
        -3,
        -13
      ],
      [
        1,
        -8
      ],
      [
        4,
        -11
      ],
      [
        3,
        -9
      ],
      [
        0,
        -9
      ],
      [
        -1,
        -11
      ],
      [
        -3,
        -15
      ],
      [
        -5,
        -8
      ],
      [
        -4,
        0
      ],
      [
        -3,
        -1
      ],
      [
        -2,
        -7
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -12
      ],
      [
        -4,
        -13
      ],
      [
        -6,
        -9
      ],
      [
        -3,
        -30
      ],
      [
        12,
        -32
      ],
      [
        7,
        -25
      ],
      [
        -1,
        -24
      ],
      [
        -11,
        -31
      ],
      [
        3,
        -43
      ],
      [
        -3,
        -23
      ],
      [
        -10,
        -4
      ],
      [
        -5,
        4
      ],
      [
        -13,
        8
      ],
      [
        -3,
        -27
      ],
      [
        -4,
        -26
      ],
      [
        -12,
        -8
      ],
      [
        -9,
        -18
      ],
      [
        -5,
        -1
      ]
    ],
    [
      [
        13080,
        81701
      ],
      [
        0,
        1
      ],
      [
        -4,
        56
      ],
      [
        -3,
        22
      ],
      [
        -4,
        12
      ],
      [
        -6,
        24
      ],
      [
        -6,
        34
      ],
      [
        0,
        5
      ],
      [
        5,
        -4
      ],
      [
        3,
        -7
      ],
      [
        7,
        -18
      ],
      [
        6,
        -5
      ],
      [
        4,
        7
      ],
      [
        2,
        12
      ],
      [
        0,
        30
      ],
      [
        -1,
        8
      ],
      [
        2,
        18
      ],
      [
        14,
        12
      ],
      [
        5,
        2
      ],
      [
        8,
        23
      ],
      [
        5,
        49
      ],
      [
        7,
        98
      ],
      [
        -8,
        102
      ],
      [
        9,
        52
      ],
      [
        1,
        5
      ],
      [
        6,
        -21
      ],
      [
        12,
        42
      ],
      [
        9,
        74
      ],
      [
        -2,
        18
      ],
      [
        -4,
        2
      ],
      [
        -10,
        -1
      ],
      [
        -7,
        -12
      ],
      [
        -4,
        -58
      ],
      [
        -7,
        -5
      ],
      [
        -12,
        -25
      ],
      [
        -21,
        -61
      ],
      [
        13,
        -113
      ],
      [
        -1,
        -19
      ],
      [
        -7,
        -23
      ],
      [
        -3,
        -3
      ],
      [
        -6,
        3
      ],
      [
        -9,
        10
      ],
      [
        -15,
        -7
      ],
      [
        -12,
        -43
      ],
      [
        0,
        -16
      ],
      [
        3,
        -10
      ],
      [
        0,
        -4
      ],
      [
        -4,
        -12
      ],
      [
        -13,
        -2
      ],
      [
        -1,
        4
      ],
      [
        -6,
        30
      ],
      [
        0,
        31
      ],
      [
        7,
        14
      ],
      [
        -3,
        22
      ],
      [
        -10,
        12
      ],
      [
        -9,
        11
      ],
      [
        -1,
        41
      ],
      [
        -3,
        31
      ],
      [
        -5,
        14
      ],
      [
        -3,
        42
      ],
      [
        -8,
        12
      ],
      [
        -6,
        -27
      ],
      [
        -8,
        20
      ],
      [
        -6,
        -3
      ],
      [
        -4,
        -19
      ],
      [
        4,
        -23
      ],
      [
        0,
        -12
      ],
      [
        -4,
        -13
      ],
      [
        -9,
        26
      ],
      [
        -12,
        57
      ],
      [
        -7,
        35
      ],
      [
        -4,
        39
      ],
      [
        1,
        84
      ],
      [
        8,
        25
      ],
      [
        5,
        0
      ],
      [
        2,
        -3
      ],
      [
        6,
        -4
      ],
      [
        8,
        1
      ],
      [
        4,
        7
      ],
      [
        5,
        45
      ],
      [
        0,
        8
      ],
      [
        2,
        13
      ],
      [
        9,
        41
      ],
      [
        4,
        8
      ],
      [
        24,
        18
      ],
      [
        3,
        -2
      ],
      [
        3,
        -4
      ],
      [
        5,
        -17
      ],
      [
        6,
        -28
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -10
      ],
      [
        5,
        -14
      ],
      [
        2,
        4
      ],
      [
        2,
        16
      ],
      [
        3,
        43
      ],
      [
        -6,
        46
      ],
      [
        -9,
        122
      ],
      [
        1,
        7
      ],
      [
        2,
        0
      ],
      [
        6,
        -4
      ],
      [
        30,
        -45
      ],
      [
        2,
        -10
      ],
      [
        3,
        -28
      ],
      [
        -2,
        -4
      ],
      [
        1,
        -17
      ],
      [
        4,
        -17
      ],
      [
        6,
        -14
      ],
      [
        1,
        -1
      ],
      [
        5,
        18
      ],
      [
        1,
        5
      ],
      [
        -1,
        9
      ],
      [
        -8,
        68
      ],
      [
        -8,
        23
      ],
      [
        -6,
        12
      ],
      [
        -5,
        -2
      ],
      [
        -3,
        2
      ],
      [
        -19,
        48
      ],
      [
        -1,
        7
      ],
      [
        -2,
        46
      ],
      [
        -11,
        13
      ],
      [
        -12,
        -25
      ],
      [
        -9,
        2
      ],
      [
        5,
        21
      ],
      [
        -6,
        26
      ],
      [
        -23,
        32
      ],
      [
        -3,
        30
      ],
      [
        -2,
        27
      ],
      [
        12,
        23
      ],
      [
        -2,
        14
      ]
    ],
    [
      [
        12850,
        82395
      ],
      [
        5,
        30
      ],
      [
        2,
        23
      ],
      [
        6,
        4
      ],
      [
        5,
        -9
      ],
      [
        -1,
        -19
      ],
      [
        9,
        -31
      ],
      [
        4,
        -22
      ],
      [
        9,
        -44
      ],
      [
        2,
        -33
      ],
      [
        8,
        -35
      ],
      [
        -2,
        -8
      ],
      [
        -8,
        8
      ],
      [
        -3,
        -15
      ],
      [
        -5,
        9
      ],
      [
        -8,
        21
      ],
      [
        -8,
        31
      ],
      [
        -9,
        4
      ],
      [
        -2,
        21
      ],
      [
        -1,
        15
      ],
      [
        3,
        12
      ],
      [
        -1,
        12
      ],
      [
        -5,
        26
      ]
    ],
    [
      [
        12838,
        82543
      ],
      [
        2,
        2
      ],
      [
        4,
        15
      ],
      [
        11,
        52
      ],
      [
        0,
        2
      ],
      [
        -1,
        4
      ],
      [
        0,
        4
      ],
      [
        2,
        7
      ],
      [
        7,
        10
      ],
      [
        6,
        11
      ],
      [
        8,
        9
      ],
      [
        9,
        2
      ],
      [
        7,
        -1
      ],
      [
        8,
        -15
      ],
      [
        6,
        -6
      ],
      [
        3,
        2
      ],
      [
        5,
        10
      ],
      [
        2,
        2
      ],
      [
        14,
        8
      ],
      [
        5,
        -4
      ],
      [
        13,
        -17
      ],
      [
        10,
        -21
      ],
      [
        1,
        -7
      ],
      [
        3,
        -29
      ],
      [
        -9,
        -18
      ],
      [
        -3,
        -8
      ],
      [
        -5,
        -17
      ],
      [
        -1,
        -10
      ],
      [
        2,
        -15
      ],
      [
        4,
        -14
      ],
      [
        2,
        -20
      ],
      [
        0,
        -9
      ],
      [
        -2,
        -24
      ],
      [
        -16,
        -19
      ],
      [
        -16,
        -5
      ],
      [
        -19,
        -18
      ],
      [
        -9,
        1
      ],
      [
        -18,
        39
      ],
      [
        -5,
        26
      ],
      [
        -14,
        16
      ],
      [
        -10,
        13
      ],
      [
        -6,
        15
      ],
      [
        -1,
        24
      ],
      [
        1,
        3
      ]
    ],
    [
      [
        26122,
        56404
      ],
      [
        49,
        -3
      ],
      [
        0,
        8
      ],
      [
        45,
        -2
      ]
    ],
    [
      [
        26216,
        56407
      ],
      [
        4,
        0
      ],
      [
        0,
        -88
      ],
      [
        -1,
        -20
      ]
    ],
    [
      [
        26219,
        56299
      ],
      [
        -3,
        1
      ],
      [
        0,
        -114
      ],
      [
        -16,
        -23
      ],
      [
        -6,
        -4
      ],
      [
        -3,
        10
      ],
      [
        -42,
        -56
      ],
      [
        -13,
        1
      ]
    ],
    [
      [
        26136,
        56114
      ],
      [
        -6,
        113
      ],
      [
        0,
        21
      ],
      [
        -1,
        7
      ],
      [
        -4,
        89
      ],
      [
        0,
        7
      ],
      [
        -3,
        53
      ]
    ],
    [
      [
        26649,
        54717
      ],
      [
        24,
        50
      ],
      [
        -1,
        8
      ],
      [
        4,
        -3
      ],
      [
        48,
        98
      ]
    ],
    [
      [
        26724,
        54870
      ],
      [
        13,
        -100
      ],
      [
        12,
        -87
      ]
    ],
    [
      [
        26749,
        54683
      ],
      [
        -10,
        34
      ],
      [
        -37,
        -129
      ],
      [
        6,
        -20
      ],
      [
        -13,
        -47
      ],
      [
        -4,
        0
      ],
      [
        0,
        -14
      ]
    ],
    [
      [
        26691,
        54507
      ],
      [
        -6,
        19
      ],
      [
        -36,
        132
      ]
    ],
    [
      [
        26649,
        54658
      ],
      [
        3,
        4
      ],
      [
        1,
        22
      ],
      [
        -4,
        33
      ]
    ],
    [
      [
        25761,
        62228
      ],
      [
        0,
        102
      ]
    ],
    [
      [
        25761,
        62330
      ],
      [
        31,
        -1
      ],
      [
        71,
        -1
      ]
    ],
    [
      [
        25863,
        62328
      ],
      [
        10,
        0
      ],
      [
        1,
        -35
      ],
      [
        1,
        -229
      ]
    ],
    [
      [
        25875,
        62064
      ],
      [
        -7,
        -40
      ],
      [
        -3,
        4
      ],
      [
        0,
        -53
      ]
    ],
    [
      [
        25865,
        61975
      ],
      [
        -68,
        0
      ],
      [
        -36,
        -1
      ]
    ],
    [
      [
        25761,
        61974
      ],
      [
        0,
        254
      ]
    ],
    [
      [
        26039,
        62491
      ],
      [
        33,
        2
      ],
      [
        35,
        73
      ]
    ],
    [
      [
        26107,
        62566
      ],
      [
        -1,
        -329
      ]
    ],
    [
      [
        26106,
        62237
      ],
      [
        -5,
        0
      ],
      [
        -21,
        -1
      ],
      [
        0,
        -34
      ],
      [
        -10,
        0
      ],
      [
        0,
        -34
      ],
      [
        -10,
        0
      ],
      [
        0,
        -34
      ],
      [
        -20,
        -10
      ]
    ],
    [
      [
        26040,
        62124
      ],
      [
        -14,
        19
      ],
      [
        -11,
        -26
      ],
      [
        -7,
        -3
      ]
    ],
    [
      [
        26008,
        62114
      ],
      [
        0,
        189
      ],
      [
        -1,
        115
      ]
    ],
    [
      [
        26007,
        62418
      ],
      [
        0,
        71
      ],
      [
        7,
        0
      ],
      [
        25,
        2
      ]
    ],
    [
      [
        26754,
        67376
      ],
      [
        0,
        -51
      ],
      [
        33,
        1
      ],
      [
        1,
        -152
      ]
    ],
    [
      [
        26788,
        67174
      ],
      [
        4,
        -303
      ]
    ],
    [
      [
        26792,
        66871
      ],
      [
        -33,
        -6
      ]
    ],
    [
      [
        26759,
        66865
      ],
      [
        -66,
        -7
      ],
      [
        -32,
        -2
      ]
    ],
    [
      [
        26661,
        66856
      ],
      [
        -1,
        96
      ],
      [
        -1,
        101
      ],
      [
        0,
        202
      ]
    ],
    [
      [
        26659,
        67255
      ],
      [
        0,
        11
      ],
      [
        30,
        3
      ],
      [
        0,
        101
      ],
      [
        65,
        6
      ]
    ],
    [
      [
        25077,
        56605
      ],
      [
        88,
        0
      ]
    ],
    [
      [
        25165,
        56605
      ],
      [
        29,
        0
      ]
    ],
    [
      [
        25194,
        56605
      ],
      [
        0,
        -306
      ]
    ],
    [
      [
        25194,
        56299
      ],
      [
        -59,
        1
      ],
      [
        0,
        -68
      ],
      [
        -29,
        0
      ],
      [
        0,
        -17
      ]
    ],
    [
      [
        25106,
        56215
      ],
      [
        -44,
        -1
      ]
    ],
    [
      [
        25062,
        56214
      ],
      [
        1,
        85
      ],
      [
        14,
        1
      ],
      [
        0,
        305
      ]
    ],
    [
      [
        26756,
        64659
      ],
      [
        72,
        0
      ],
      [
        7,
        4
      ]
    ],
    [
      [
        26835,
        64663
      ],
      [
        29,
        -1
      ]
    ],
    [
      [
        26864,
        64662
      ],
      [
        -1,
        -331
      ]
    ],
    [
      [
        26863,
        64331
      ],
      [
        -36,
        1
      ],
      [
        0,
        -9
      ]
    ],
    [
      [
        26827,
        64323
      ],
      [
        -65,
        -3
      ],
      [
        -6,
        1
      ]
    ],
    [
      [
        26756,
        64321
      ],
      [
        0,
        338
      ]
    ],
    [
      [
        22851,
        67982
      ],
      [
        67,
        0
      ]
    ],
    [
      [
        22918,
        67982
      ],
      [
        107,
        0
      ],
      [
        14,
        2
      ]
    ],
    [
      [
        23039,
        67984
      ],
      [
        0,
        -407
      ]
    ],
    [
      [
        23039,
        67577
      ],
      [
        -40,
        0
      ]
    ],
    [
      [
        22999,
        67577
      ],
      [
        -91,
        0
      ]
    ],
    [
      [
        22908,
        67577
      ],
      [
        -57,
        -1
      ]
    ],
    [
      [
        22851,
        67576
      ],
      [
        0,
        406
      ]
    ],
    [
      [
        22775,
        67577
      ],
      [
        76,
        -1
      ]
    ],
    [
      [
        22908,
        67577
      ],
      [
        0,
        -485
      ]
    ],
    [
      [
        22908,
        67092
      ],
      [
        -66,
        0
      ]
    ],
    [
      [
        22842,
        67092
      ],
      [
        0,
        101
      ],
      [
        -66,
        -1
      ]
    ],
    [
      [
        22776,
        67192
      ],
      [
        -1,
        385
      ]
    ],
    [
      [
        23272,
        52945
      ],
      [
        51,
        149
      ]
    ],
    [
      [
        23323,
        53094
      ],
      [
        0,
        -141
      ],
      [
        7,
        -11
      ],
      [
        -2,
        -21
      ],
      [
        5,
        -21
      ],
      [
        5,
        -5
      ],
      [
        0,
        -9
      ],
      [
        -5,
        4
      ],
      [
        2,
        -9
      ],
      [
        -2,
        -21
      ],
      [
        4,
        -5
      ],
      [
        9,
        5
      ],
      [
        2,
        21
      ],
      [
        5,
        -18
      ]
    ],
    [
      [
        23353,
        52863
      ],
      [
        -9,
        -414
      ]
    ],
    [
      [
        23344,
        52449
      ],
      [
        -1,
        5
      ],
      [
        -66,
        1
      ],
      [
        -64,
        141
      ]
    ],
    [
      [
        23213,
        52596
      ],
      [
        -9,
        272
      ]
    ],
    [
      [
        23204,
        52868
      ],
      [
        5,
        -3
      ],
      [
        16,
        21
      ],
      [
        6,
        19
      ],
      [
        9,
        5
      ],
      [
        4,
        13
      ],
      [
        9,
        -12
      ],
      [
        6,
        3
      ],
      [
        3,
        -12
      ],
      [
        7,
        8
      ],
      [
        3,
        12
      ],
      [
        0,
        23
      ]
    ],
    [
      [
        31398,
        37874
      ],
      [
        8,
        42
      ],
      [
        -1,
        27
      ]
    ],
    [
      [
        31405,
        37943
      ],
      [
        15,
        -12
      ],
      [
        4,
        5
      ],
      [
        7,
        -24
      ]
    ],
    [
      [
        31431,
        37912
      ],
      [
        -3,
        -26
      ],
      [
        1,
        -20
      ]
    ],
    [
      [
        31429,
        37866
      ],
      [
        -6,
        -10
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -6
      ],
      [
        -3,
        -9
      ],
      [
        -1,
        8
      ],
      [
        -3,
        6
      ],
      [
        -3,
        8
      ],
      [
        -10,
        25
      ],
      [
        -1,
        5
      ]
    ],
    [
      [
        22383,
        68083
      ],
      [
        133,
        3
      ]
    ],
    [
      [
        22516,
        68086
      ],
      [
        0,
        -101
      ],
      [
        2,
        1
      ]
    ],
    [
      [
        22518,
        67986
      ],
      [
        0,
        -317
      ],
      [
        1,
        -94
      ]
    ],
    [
      [
        22519,
        67575
      ],
      [
        -107,
        1
      ]
    ],
    [
      [
        22412,
        67576
      ],
      [
        -25,
        0
      ]
    ],
    [
      [
        22387,
        67576
      ],
      [
        -1,
        407
      ],
      [
        -3,
        0
      ],
      [
        0,
        100
      ]
    ],
    [
      [
        22462,
        48678
      ],
      [
        81,
        -3
      ]
    ],
    [
      [
        22543,
        48675
      ],
      [
        49,
        -1
      ]
    ],
    [
      [
        22592,
        48674
      ],
      [
        20,
        -1
      ],
      [
        0,
        -60
      ]
    ],
    [
      [
        22612,
        48613
      ],
      [
        0,
        -498
      ]
    ],
    [
      [
        22612,
        48115
      ],
      [
        -93,
        2
      ]
    ],
    [
      [
        22519,
        48117
      ],
      [
        -29,
        1
      ]
    ],
    [
      [
        22490,
        48118
      ],
      [
        2,
        316
      ],
      [
        -14,
        -1
      ],
      [
        0,
        102
      ],
      [
        -7,
        0
      ],
      [
        0,
        108
      ],
      [
        -4,
        5
      ],
      [
        -1,
        13
      ],
      [
        -6,
        5
      ],
      [
        -1,
        13
      ],
      [
        3,
        -1
      ]
    ],
    [
      [
        31491,
        38138
      ],
      [
        7,
        20
      ],
      [
        4,
        34
      ],
      [
        3,
        54
      ]
    ],
    [
      [
        31505,
        38246
      ],
      [
        5,
        -6
      ],
      [
        2,
        17
      ]
    ],
    [
      [
        31512,
        38257
      ],
      [
        4,
        -3
      ],
      [
        2,
        -6
      ]
    ],
    [
      [
        31518,
        38248
      ],
      [
        -3,
        -4
      ],
      [
        0,
        -12
      ],
      [
        6,
        -15
      ],
      [
        -1,
        -16
      ],
      [
        1,
        -27
      ],
      [
        -1,
        -18
      ],
      [
        4,
        -22
      ]
    ],
    [
      [
        31524,
        38134
      ],
      [
        0,
        -21
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        1
      ],
      [
        -3,
        -23
      ],
      [
        1,
        -26
      ],
      [
        -4,
        -29
      ],
      [
        -5,
        -7
      ]
    ],
    [
      [
        31509,
        38025
      ],
      [
        -2,
        4
      ],
      [
        -2,
        37
      ],
      [
        -8,
        24
      ]
    ],
    [
      [
        31497,
        38090
      ],
      [
        -2,
        2
      ],
      [
        0,
        14
      ],
      [
        -4,
        32
      ]
    ],
    [
      [
        31479,
        38421
      ],
      [
        2,
        1
      ],
      [
        3,
        12
      ],
      [
        1,
        11
      ],
      [
        3,
        -2
      ]
    ],
    [
      [
        31488,
        38443
      ],
      [
        5,
        -31
      ],
      [
        0,
        -8
      ]
    ],
    [
      [
        31493,
        38404
      ],
      [
        -1,
        2
      ],
      [
        -1,
        -1
      ],
      [
        -4,
        -17
      ]
    ],
    [
      [
        31487,
        38388
      ],
      [
        -8,
        -4
      ],
      [
        -3,
        11
      ]
    ],
    [
      [
        31476,
        38395
      ],
      [
        3,
        26
      ]
    ],
    [
      [
        31395,
        38326
      ],
      [
        3,
        1
      ],
      [
        2,
        -2
      ]
    ],
    [
      [
        31400,
        38325
      ],
      [
        6,
        8
      ],
      [
        6,
        -16
      ],
      [
        1,
        9
      ],
      [
        6,
        -32
      ]
    ],
    [
      [
        31419,
        38294
      ],
      [
        3,
        -13
      ]
    ],
    [
      [
        31422,
        38281
      ],
      [
        -2,
        -35
      ],
      [
        -2,
        -11
      ]
    ],
    [
      [
        31418,
        38235
      ],
      [
        -3,
        -24
      ],
      [
        -6,
        -11
      ],
      [
        -12,
        -7
      ]
    ],
    [
      [
        31397,
        38193
      ],
      [
        -3,
        30
      ],
      [
        3,
        31
      ],
      [
        0,
        26
      ],
      [
        -3,
        23
      ],
      [
        1,
        23
      ]
    ],
    [
      [
        21479,
        64015
      ],
      [
        0,
        300
      ]
    ],
    [
      [
        21479,
        64315
      ],
      [
        197,
        0
      ]
    ],
    [
      [
        21676,
        64315
      ],
      [
        1,
        -404
      ]
    ],
    [
      [
        21677,
        63911
      ],
      [
        -198,
        -2
      ]
    ],
    [
      [
        21479,
        63909
      ],
      [
        0,
        106
      ]
    ],
    [
      [
        31360,
        38347
      ],
      [
        6,
        27
      ],
      [
        6,
        -9
      ]
    ],
    [
      [
        31372,
        38365
      ],
      [
        4,
        -24
      ],
      [
        -1,
        -39
      ]
    ],
    [
      [
        31375,
        38302
      ],
      [
        -2,
        -8
      ],
      [
        -14,
        -7
      ]
    ],
    [
      [
        31359,
        38287
      ],
      [
        2,
        41
      ],
      [
        -1,
        19
      ]
    ],
    [
      [
        20190,
        60480
      ],
      [
        51,
        -2
      ],
      [
        2,
        -3
      ],
      [
        125,
        2
      ]
    ],
    [
      [
        20368,
        60477
      ],
      [
        0,
        -51
      ],
      [
        83,
        0
      ]
    ],
    [
      [
        20451,
        60426
      ],
      [
        -3,
        -16
      ],
      [
        9,
        -62
      ],
      [
        -1,
        -18
      ],
      [
        -4,
        -13
      ],
      [
        -2,
        -18
      ],
      [
        2,
        -8
      ],
      [
        -2,
        -27
      ],
      [
        5,
        -43
      ],
      [
        -3,
        -18
      ],
      [
        2,
        -11
      ],
      [
        -5,
        -24
      ],
      [
        0,
        -27
      ],
      [
        3,
        -10
      ],
      [
        -9,
        -49
      ],
      [
        2,
        -6
      ],
      [
        -2,
        -17
      ],
      [
        5,
        -16
      ],
      [
        2,
        -15
      ],
      [
        5,
        0
      ],
      [
        3,
        -22
      ]
    ],
    [
      [
        20458,
        60006
      ],
      [
        -78,
        -1
      ],
      [
        -2,
        0
      ]
    ],
    [
      [
        20378,
        60005
      ],
      [
        -1,
        0
      ],
      [
        -54,
        -1
      ],
      [
        -13,
        0
      ],
      [
        -12,
        -1
      ],
      [
        -14,
        1
      ],
      [
        -37,
        -1
      ]
    ],
    [
      [
        20247,
        60003
      ],
      [
        -4,
        25
      ],
      [
        -28,
        146
      ],
      [
        -2,
        63
      ],
      [
        -23,
        40
      ],
      [
        0,
        203
      ]
    ],
    [
      [
        28085,
        63180
      ],
      [
        68,
        0
      ]
    ],
    [
      [
        28153,
        63180
      ],
      [
        7,
        0
      ],
      [
        55,
        -1
      ],
      [
        24,
        0
      ],
      [
        6,
        -1
      ],
      [
        27,
        0
      ],
      [
        38,
        -1
      ],
      [
        18,
        0
      ]
    ],
    [
      [
        28328,
        63177
      ],
      [
        -6,
        -28
      ],
      [
        -5,
        -14
      ],
      [
        5,
        -9
      ],
      [
        -8,
        -42
      ],
      [
        -4,
        -11
      ],
      [
        -10,
        -13
      ],
      [
        -5,
        -56
      ],
      [
        -2,
        -9
      ],
      [
        -1,
        -27
      ],
      [
        -3,
        -8
      ],
      [
        -4,
        -31
      ],
      [
        3,
        -18
      ],
      [
        -2,
        -12
      ],
      [
        1,
        -14
      ],
      [
        -5,
        -26
      ],
      [
        -2,
        -52
      ],
      [
        -4,
        -40
      ],
      [
        -5,
        -29
      ],
      [
        -1,
        -22
      ]
    ],
    [
      [
        28270,
        62716
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -3,
        4
      ],
      [
        -3,
        -1
      ],
      [
        -1,
        1
      ]
    ],
    [
      [
        28258,
        62713
      ],
      [
        -2,
        0
      ],
      [
        -1,
        4
      ],
      [
        -1,
        2
      ],
      [
        -6,
        8
      ],
      [
        -1,
        4
      ],
      [
        0,
        10
      ],
      [
        3,
        4
      ],
      [
        1,
        5
      ],
      [
        1,
        8
      ],
      [
        0,
        6
      ],
      [
        -3,
        15
      ],
      [
        0,
        6
      ],
      [
        1,
        1
      ],
      [
        3,
        1
      ],
      [
        0,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        6
      ],
      [
        -1,
        10
      ],
      [
        -2,
        11
      ],
      [
        -2,
        11
      ],
      [
        0,
        5
      ],
      [
        -1,
        2
      ],
      [
        -2,
        2
      ],
      [
        -3,
        0
      ],
      [
        -2,
        3
      ],
      [
        -1,
        5
      ],
      [
        0,
        14
      ],
      [
        1,
        15
      ],
      [
        1,
        0
      ],
      [
        0,
        4
      ],
      [
        -3,
        5
      ],
      [
        -2,
        4
      ],
      [
        0,
        12
      ],
      [
        2,
        4
      ],
      [
        2,
        3
      ],
      [
        3,
        2
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        -1,
        2
      ],
      [
        -3,
        0
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        -6,
        -8
      ],
      [
        -4,
        4
      ],
      [
        -1,
        1
      ]
    ],
    [
      [
        28229,
        62914
      ],
      [
        -2,
        0
      ],
      [
        -4,
        5
      ],
      [
        0,
        8
      ],
      [
        5,
        10
      ],
      [
        1,
        3
      ],
      [
        0,
        15
      ],
      [
        -1,
        1
      ],
      [
        -1,
        3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -12
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        -2
      ],
      [
        -1,
        1
      ],
      [
        0,
        3
      ],
      [
        -1,
        3
      ],
      [
        1,
        5
      ],
      [
        0,
        16
      ],
      [
        -2,
        7
      ],
      [
        -4,
        9
      ],
      [
        -1,
        5
      ],
      [
        0,
        2
      ],
      [
        1,
        2
      ],
      [
        0,
        1
      ],
      [
        2,
        4
      ],
      [
        4,
        0
      ],
      [
        2,
        1
      ],
      [
        4,
        -1
      ],
      [
        2,
        3
      ],
      [
        0,
        3
      ],
      [
        1,
        2
      ],
      [
        0,
        12
      ],
      [
        1,
        7
      ],
      [
        0,
        5
      ],
      [
        -1,
        11
      ],
      [
        0,
        2
      ],
      [
        -2,
        4
      ],
      [
        -1,
        1
      ],
      [
        -3,
        0
      ],
      [
        -1,
        1
      ],
      [
        -3,
        4
      ],
      [
        -2,
        4
      ],
      [
        -3,
        1
      ],
      [
        0,
        -2
      ],
      [
        1,
        -7
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -6,
        5
      ],
      [
        -1,
        0
      ],
      [
        -1,
        3
      ],
      [
        -1,
        3
      ],
      [
        -1,
        7
      ],
      [
        -1,
        5
      ],
      [
        -1,
        1
      ],
      [
        -2,
        0
      ],
      [
        0,
        -2
      ],
      [
        1,
        -13
      ],
      [
        1,
        -13
      ],
      [
        -1,
        -9
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        8
      ],
      [
        0,
        10
      ],
      [
        -1,
        10
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        1
      ],
      [
        -3,
        1
      ],
      [
        -2,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        2
      ],
      [
        -3,
        18
      ]
    ],
    [
      [
        28174,
        63060
      ],
      [
        0,
        2
      ],
      [
        -2,
        7
      ],
      [
        -2,
        10
      ],
      [
        -1,
        2
      ],
      [
        -1,
        5
      ],
      [
        -1,
        1
      ],
      [
        -1,
        3
      ],
      [
        0,
        3
      ],
      [
        -5,
        15
      ],
      [
        0,
        1
      ],
      [
        -1,
        6
      ],
      [
        -1,
        2
      ],
      [
        -2,
        3
      ],
      [
        -2,
        0
      ],
      [
        -2,
        8
      ],
      [
        -1,
        2
      ],
      [
        -2,
        3
      ],
      [
        -1,
        0
      ],
      [
        -3,
        4
      ],
      [
        -3,
        1
      ],
      [
        0,
        2
      ],
      [
        -3,
        2
      ],
      [
        -3,
        0
      ],
      [
        -2,
        4
      ],
      [
        -2,
        2
      ],
      [
        -2,
        1
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -6,
        1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        3,
        -9
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        -5
      ],
      [
        -2,
        -9
      ],
      [
        -2,
        -5
      ],
      [
        -3,
        -12
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        1
      ],
      [
        -4,
        1
      ],
      [
        -7,
        10
      ],
      [
        -1,
        2
      ],
      [
        -5,
        6
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        28087,
        63079
      ],
      [
        -2,
        20
      ],
      [
        -6,
        8
      ],
      [
        8,
        3
      ],
      [
        -2,
        15
      ],
      [
        6,
        1
      ],
      [
        2,
        19
      ],
      [
        -8,
        35
      ]
    ],
    [
      [
        22001,
        63504
      ],
      [
        54,
        0
      ],
      [
        10,
        1
      ],
      [
        1,
        -1
      ],
      [
        37,
        0
      ],
      [
        10,
        1
      ],
      [
        1,
        0
      ],
      [
        3,
        -1
      ],
      [
        2,
        0
      ],
      [
        3,
        1
      ],
      [
        33,
        0
      ]
    ],
    [
      [
        22155,
        63505
      ],
      [
        0,
        -506
      ]
    ],
    [
      [
        22155,
        62999
      ],
      [
        -149,
        0
      ]
    ],
    [
      [
        22006,
        62999
      ],
      [
        -5,
        -1
      ]
    ],
    [
      [
        22001,
        62998
      ],
      [
        0,
        506
      ]
    ],
    [
      [
        25266,
        64221
      ],
      [
        20,
        0
      ],
      [
        43,
        1
      ],
      [
        -4,
        438
      ]
    ],
    [
      [
        25325,
        64660
      ],
      [
        32,
        4
      ]
    ],
    [
      [
        25357,
        64664
      ],
      [
        4,
        -560
      ],
      [
        0,
        -33
      ],
      [
        32,
        0
      ],
      [
        19,
        -3
      ]
    ],
    [
      [
        25412,
        64068
      ],
      [
        1,
        -95
      ],
      [
        0,
        -5
      ]
    ],
    [
      [
        25413,
        63968
      ],
      [
        -51,
        1
      ],
      [
        -64,
        -2
      ],
      [
        -32,
        0
      ]
    ],
    [
      [
        25266,
        63967
      ],
      [
        0,
        254
      ]
    ],
    [
      [
        21203,
        57896
      ],
      [
        244,
        0
      ]
    ],
    [
      [
        21447,
        57896
      ],
      [
        0,
        -508
      ]
    ],
    [
      [
        21447,
        57388
      ],
      [
        -2,
        -1
      ],
      [
        -98,
        1
      ]
    ],
    [
      [
        21347,
        57388
      ],
      [
        -144,
        0
      ]
    ],
    [
      [
        21203,
        57388
      ],
      [
        0,
        241
      ]
    ],
    [
      [
        21203,
        57629
      ],
      [
        0,
        267
      ]
    ],
    [
      [
        26389,
        54346
      ],
      [
        0,
        38
      ]
    ],
    [
      [
        26389,
        54384
      ],
      [
        42,
        -3
      ],
      [
        5,
        2
      ],
      [
        12,
        -7
      ],
      [
        10,
        -1
      ],
      [
        0,
        83
      ]
    ],
    [
      [
        26458,
        54458
      ],
      [
        13,
        -3
      ],
      [
        0,
        -49
      ],
      [
        14,
        7
      ],
      [
        10,
        -7
      ],
      [
        6,
        -17
      ]
    ],
    [
      [
        26501,
        54389
      ],
      [
        -2,
        -21
      ],
      [
        12,
        -67
      ],
      [
        5,
        -3
      ],
      [
        -4,
        -26
      ],
      [
        2,
        -30
      ],
      [
        3,
        -7
      ],
      [
        2,
        -9
      ]
    ],
    [
      [
        26519,
        54226
      ],
      [
        3,
        -18
      ],
      [
        0,
        -21
      ],
      [
        8,
        -58
      ],
      [
        1,
        -28
      ],
      [
        -1,
        -16
      ]
    ],
    [
      [
        26530,
        54085
      ],
      [
        -3,
        2
      ],
      [
        -72,
        4
      ],
      [
        -41,
        2
      ],
      [
        0,
        -50
      ]
    ],
    [
      [
        26414,
        54043
      ],
      [
        -5,
        13
      ],
      [
        -7,
        37
      ],
      [
        -16,
        50
      ],
      [
        -1,
        9
      ]
    ],
    [
      [
        26385,
        54152
      ],
      [
        0,
        2
      ],
      [
        3,
        85
      ],
      [
        1,
        107
      ]
    ],
    [
      [
        25276,
        70164
      ],
      [
        102,
        -11
      ],
      [
        0,
        79
      ]
    ],
    [
      [
        25378,
        70232
      ],
      [
        2,
        0
      ],
      [
        1,
        2
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        0,
        4
      ],
      [
        4,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        3,
        0
      ],
      [
        2,
        2
      ],
      [
        1,
        2
      ],
      [
        2,
        0
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        1,
        -12
      ],
      [
        1,
        -7
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -6
      ],
      [
        3,
        -3
      ],
      [
        1,
        -1
      ],
      [
        1,
        -3
      ],
      [
        1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        2,
        -1
      ],
      [
        1,
        1
      ],
      [
        3,
        -1
      ],
      [
        2,
        0
      ],
      [
        2,
        3
      ],
      [
        1,
        -1
      ],
      [
        1,
        -3
      ],
      [
        4,
        2
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        0,
        -2
      ],
      [
        1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        1,
        -1
      ],
      [
        1,
        2
      ],
      [
        3,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        1,
        -4
      ],
      [
        0,
        -10
      ],
      [
        2,
        -12
      ],
      [
        3,
        -5
      ]
    ],
    [
      [
        25437,
        70164
      ],
      [
        3,
        -7
      ],
      [
        1,
        -2
      ],
      [
        6,
        -4
      ],
      [
        0,
        -1
      ],
      [
        1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -4
      ],
      [
        0,
        -1
      ],
      [
        2,
        -4
      ],
      [
        0,
        -2
      ],
      [
        4,
        -8
      ],
      [
        2,
        -5
      ],
      [
        0,
        -11
      ],
      [
        -4,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        -6,
        -5
      ],
      [
        0,
        -3
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -7
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        2,
        -7
      ],
      [
        2,
        -11
      ],
      [
        2,
        -6
      ],
      [
        0,
        -6
      ],
      [
        1,
        -2
      ],
      [
        3,
        -3
      ],
      [
        1,
        -6
      ],
      [
        1,
        -13
      ],
      [
        -1,
        -11
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -18
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        1
      ],
      [
        -2,
        3
      ],
      [
        -4,
        4
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -11
      ],
      [
        1,
        -3
      ],
      [
        3,
        -4
      ],
      [
        1,
        -4
      ],
      [
        2,
        -6
      ],
      [
        1,
        -6
      ],
      [
        0,
        -28
      ],
      [
        1,
        -10
      ],
      [
        2,
        -1
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -7
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        -3
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -8
      ],
      [
        0,
        -13
      ],
      [
        1,
        -9
      ],
      [
        2,
        -3
      ],
      [
        0,
        -13
      ],
      [
        -3,
        -4
      ],
      [
        0,
        -3
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        1,
        -12
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -6
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        -1
      ],
      [
        1,
        -3
      ],
      [
        0,
        -7
      ]
    ],
    [
      [
        25436,
        69720
      ],
      [
        0,
        0
      ]
    ],
    [
      [
        25436,
        69720
      ],
      [
        3,
        5
      ],
      [
        1,
        1
      ],
      [
        0,
        6
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        0,
        -2
      ],
      [
        1,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        1
      ],
      [
        3,
        -1
      ],
      [
        3,
        3
      ],
      [
        3,
        -1
      ],
      [
        0,
        -1
      ],
      [
        2,
        -3
      ],
      [
        2,
        2
      ],
      [
        2,
        0
      ],
      [
        1,
        -3
      ],
      [
        3,
        1
      ],
      [
        0,
        5
      ],
      [
        1,
        1
      ],
      [
        3,
        4
      ],
      [
        0,
        2
      ],
      [
        1,
        5
      ],
      [
        5,
        15
      ],
      [
        2,
        5
      ],
      [
        1,
        3
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        1,
        2
      ],
      [
        2,
        0
      ],
      [
        1,
        -2
      ],
      [
        1,
        -4
      ],
      [
        2,
        -3
      ],
      [
        0,
        -6
      ],
      [
        5,
        -10
      ],
      [
        0,
        -12
      ],
      [
        1,
        -5
      ],
      [
        1,
        0
      ],
      [
        0,
        -17
      ],
      [
        -2,
        -10
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        1,
        -6
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -10
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        -9
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -3
      ],
      [
        -2,
        -7
      ],
      [
        0,
        -14
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -8
      ],
      [
        1,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -17
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -3
      ],
      [
        1,
        -2
      ],
      [
        0,
        -6
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -3
      ],
      [
        1,
        -5
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -2
      ],
      [
        2,
        -22
      ],
      [
        0,
        -7
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        2,
        -4
      ],
      [
        2,
        -3
      ],
      [
        1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        1,
        -3
      ],
      [
        1,
        -1
      ],
      [
        2,
        -2
      ],
      [
        1,
        -2
      ],
      [
        1,
        -4
      ],
      [
        3,
        -11
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -5
      ],
      [
        1,
        -10
      ],
      [
        1,
        -1
      ],
      [
        1,
        -3
      ],
      [
        1,
        -5
      ],
      [
        1,
        -1
      ],
      [
        0,
        -6
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        -2
      ],
      [
        4,
        -1
      ],
      [
        1,
        1
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        2,
        -1
      ],
      [
        2,
        -3
      ],
      [
        6,
        -6
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        25508,
        69434
      ],
      [
        1,
        -7
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        2
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -8
      ],
      [
        -5,
        -35
      ],
      [
        1,
        -37
      ],
      [
        -2,
        -43
      ],
      [
        -9,
        -4
      ],
      [
        -9,
        1
      ],
      [
        -19,
        -10
      ]
    ],
    [
      [
        25460,
        69283
      ],
      [
        1,
        29
      ],
      [
        -34,
        0
      ],
      [
        -17,
        3
      ],
      [
        0,
        32
      ],
      [
        -17,
        1
      ],
      [
        -33,
        2
      ],
      [
        1,
        101
      ],
      [
        -20,
        2
      ],
      [
        1,
        100
      ],
      [
        -34,
        5
      ],
      [
        1,
        201
      ],
      [
        -34,
        3
      ]
    ],
    [
      [
        25275,
        69762
      ],
      [
        1,
        284
      ],
      [
        0,
        118
      ]
    ],
    [
      [
        16021,
        59887
      ],
      [
        4,
        21
      ],
      [
        6,
        -15
      ],
      [
        7,
        0
      ]
    ],
    [
      [
        16038,
        59893
      ],
      [
        2,
        -7
      ],
      [
        4,
        5
      ],
      [
        4,
        23
      ],
      [
        2,
        4
      ],
      [
        0,
        5
      ],
      [
        1,
        7
      ],
      [
        3,
        7
      ],
      [
        3,
        10
      ],
      [
        0,
        15
      ],
      [
        2,
        7
      ],
      [
        1,
        9
      ],
      [
        4,
        13
      ],
      [
        6,
        -8
      ],
      [
        4,
        14
      ],
      [
        10,
        -32
      ],
      [
        56,
        0
      ]
    ],
    [
      [
        16140,
        59965
      ],
      [
        -5,
        -40
      ],
      [
        3,
        -19
      ],
      [
        7,
        5
      ],
      [
        4,
        -8
      ],
      [
        0,
        -13
      ],
      [
        4,
        -13
      ],
      [
        2,
        -19
      ],
      [
        3,
        -4
      ],
      [
        3,
        -34
      ],
      [
        58,
        -98
      ],
      [
        4,
        -14
      ]
    ],
    [
      [
        16223,
        59708
      ],
      [
        88,
        -293
      ],
      [
        2,
        -186
      ],
      [
        -10,
        -14
      ],
      [
        -8,
        -1
      ],
      [
        -6,
        -25
      ],
      [
        2,
        -16
      ],
      [
        -1,
        -15
      ]
    ],
    [
      [
        16290,
        59158
      ],
      [
        -6,
        18
      ],
      [
        -6,
        11
      ],
      [
        -7,
        21
      ],
      [
        -3,
        -2
      ],
      [
        4,
        -13
      ],
      [
        3,
        -26
      ],
      [
        4,
        -18
      ],
      [
        3,
        -38
      ],
      [
        0,
        -27
      ],
      [
        -3,
        -8
      ],
      [
        -4,
        8
      ],
      [
        -3,
        -6
      ],
      [
        -2,
        0
      ],
      [
        -1,
        3
      ],
      [
        -2,
        2
      ],
      [
        -1,
        7
      ],
      [
        0,
        4
      ],
      [
        -1,
        5
      ],
      [
        -2,
        4
      ],
      [
        -1,
        3
      ],
      [
        -1,
        5
      ],
      [
        -2,
        4
      ],
      [
        0,
        3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        3
      ],
      [
        -2,
        4
      ],
      [
        -1,
        3
      ],
      [
        0,
        6
      ],
      [
        -1,
        1
      ],
      [
        0,
        3
      ],
      [
        -1,
        0
      ],
      [
        -1,
        3
      ],
      [
        0,
        1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        3
      ],
      [
        -1,
        1
      ],
      [
        0,
        4
      ],
      [
        -1,
        3
      ],
      [
        0,
        10
      ],
      [
        -1,
        3
      ],
      [
        -2,
        2
      ],
      [
        0,
        3
      ],
      [
        -1,
        2
      ],
      [
        0,
        -1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -2,
        2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        6
      ],
      [
        -1,
        4
      ],
      [
        -1,
        3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        4
      ],
      [
        -2,
        2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        1
      ],
      [
        0,
        4
      ],
      [
        -2,
        1
      ],
      [
        0,
        4
      ],
      [
        -2,
        4
      ],
      [
        0,
        3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        -17
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        16197,
        59157
      ],
      [
        0,
        0
      ]
    ],
    [
      [
        16197,
        59157
      ],
      [
        -1,
        2
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        3
      ],
      [
        -1,
        3
      ],
      [
        0,
        6
      ],
      [
        1,
        0
      ],
      [
        0,
        3
      ],
      [
        -1,
        4
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        -1,
        18
      ],
      [
        0,
        26
      ],
      [
        -10,
        51
      ],
      [
        -12,
        39
      ],
      [
        -10,
        34
      ],
      [
        -12,
        39
      ],
      [
        -1,
        9
      ],
      [
        -2,
        7
      ],
      [
        -2,
        9
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        2
      ],
      [
        -1,
        4
      ],
      [
        1,
        5
      ],
      [
        -2,
        8
      ],
      [
        0,
        7
      ],
      [
        -2,
        13
      ],
      [
        -2,
        1
      ],
      [
        0,
        -2
      ],
      [
        -3,
        0
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        1
      ],
      [
        -3,
        1
      ],
      [
        -2,
        2
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        2
      ],
      [
        1,
        8
      ],
      [
        1,
        7
      ],
      [
        1,
        5
      ],
      [
        1,
        5
      ],
      [
        1,
        6
      ],
      [
        -1,
        5
      ],
      [
        0,
        5
      ],
      [
        -1,
        3
      ],
      [
        -2,
        6
      ],
      [
        -1,
        5
      ],
      [
        -2,
        4
      ],
      [
        -2,
        2
      ],
      [
        -1,
        6
      ],
      [
        0,
        11
      ],
      [
        -1,
        2
      ],
      [
        1,
        5
      ],
      [
        1,
        2
      ],
      [
        1,
        0
      ],
      [
        0,
        6
      ],
      [
        -1,
        4
      ],
      [
        1,
        4
      ],
      [
        0,
        16
      ],
      [
        1,
        4
      ],
      [
        0,
        5
      ],
      [
        -2,
        8
      ],
      [
        -2,
        5
      ],
      [
        -1,
        6
      ],
      [
        -1,
        7
      ],
      [
        0,
        6
      ],
      [
        -1,
        5
      ],
      [
        -1,
        4
      ],
      [
        -1,
        3
      ],
      [
        -2,
        6
      ],
      [
        -1,
        3
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        0
      ],
      [
        -2,
        2
      ],
      [
        -3,
        0
      ],
      [
        -2,
        3
      ],
      [
        0,
        7
      ],
      [
        -1,
        7
      ],
      [
        -2,
        4
      ],
      [
        -1,
        2
      ],
      [
        -3,
        3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        4
      ],
      [
        -1,
        4
      ],
      [
        -1,
        3
      ],
      [
        -1,
        2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        2
      ],
      [
        -1,
        4
      ],
      [
        0,
        5
      ],
      [
        -1,
        3
      ],
      [
        0,
        3
      ],
      [
        -1,
        4
      ],
      [
        -1,
        4
      ],
      [
        0,
        4
      ],
      [
        -1,
        3
      ],
      [
        1,
        3
      ],
      [
        1,
        0
      ],
      [
        2,
        2
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        4
      ],
      [
        1,
        2
      ],
      [
        0,
        5
      ],
      [
        -1,
        5
      ],
      [
        0,
        6
      ],
      [
        -1,
        4
      ],
      [
        -1,
        5
      ],
      [
        -1,
        1
      ],
      [
        -2,
        2
      ],
      [
        -1,
        6
      ],
      [
        0,
        12
      ],
      [
        -1,
        2
      ],
      [
        -2,
        0
      ],
      [
        -2,
        -3
      ],
      [
        -7,
        11
      ],
      [
        -11,
        40
      ],
      [
        -10,
        37
      ],
      [
        -7,
        10
      ],
      [
        -6,
        32
      ],
      [
        0,
        24
      ]
    ],
    [
      [
        26268,
        55577
      ],
      [
        3,
        37
      ],
      [
        16,
        0
      ],
      [
        34,
        -1
      ],
      [
        6,
        8
      ],
      [
        8,
        -8
      ],
      [
        34,
        -1
      ]
    ],
    [
      [
        26369,
        55612
      ],
      [
        3,
        -28
      ],
      [
        -2,
        -16
      ]
    ],
    [
      [
        26370,
        55568
      ],
      [
        -3,
        -10
      ],
      [
        -2,
        -32
      ],
      [
        1,
        -25
      ],
      [
        -2,
        -5
      ],
      [
        2,
        -42
      ],
      [
        -4,
        -8
      ],
      [
        0,
        -40
      ],
      [
        -3,
        -9
      ],
      [
        0,
        -32
      ],
      [
        3,
        -11
      ],
      [
        0,
        -34
      ]
    ],
    [
      [
        26362,
        55320
      ],
      [
        -2,
        -2
      ],
      [
        4,
        -24
      ],
      [
        -2,
        -41
      ],
      [
        5,
        -11
      ],
      [
        0,
        -25
      ]
    ],
    [
      [
        26367,
        55217
      ],
      [
        -17,
        -43
      ],
      [
        -37,
        -1
      ]
    ],
    [
      [
        26313,
        55173
      ],
      [
        -10,
        16
      ],
      [
        -4,
        13
      ],
      [
        -26,
        -1
      ],
      [
        -4,
        5
      ]
    ],
    [
      [
        26269,
        55206
      ],
      [
        0,
        103
      ],
      [
        -1,
        10
      ],
      [
        0,
        258
      ]
    ],
    [
      [
        24125,
        66578
      ],
      [
        132,
        0
      ]
    ],
    [
      [
        24257,
        66578
      ],
      [
        0,
        -202
      ],
      [
        5,
        0
      ],
      [
        0,
        -199
      ]
    ],
    [
      [
        24262,
        66177
      ],
      [
        -65,
        0
      ]
    ],
    [
      [
        24197,
        66177
      ],
      [
        -33,
        0
      ],
      [
        -33,
        -1
      ]
    ],
    [
      [
        24131,
        66176
      ],
      [
        0,
        201
      ],
      [
        -6,
        0
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        24125,
        66478
      ],
      [
        0,
        100
      ]
    ],
    [
      [
        23731,
        67292
      ],
      [
        132,
        0
      ]
    ],
    [
      [
        23863,
        67292
      ],
      [
        -1,
        -404
      ]
    ],
    [
      [
        23862,
        66888
      ],
      [
        -131,
        -1
      ]
    ],
    [
      [
        23731,
        66887
      ],
      [
        0,
        405
      ]
    ],
    [
      [
        23031,
        72773
      ],
      [
        215,
        1
      ],
      [
        0,
        -34
      ]
    ],
    [
      [
        22527,
        65226
      ],
      [
        53,
        0
      ],
      [
        0,
        17
      ],
      [
        17,
        1
      ],
      [
        0,
        17
      ],
      [
        43,
        1
      ],
      [
        0,
        17
      ],
      [
        16,
        0
      ]
    ],
    [
      [
        22656,
        65279
      ],
      [
        35,
        1
      ],
      [
        0,
        -154
      ]
    ],
    [
      [
        22691,
        65126
      ],
      [
        -1,
        -99
      ],
      [
        -53,
        -2
      ],
      [
        0,
        -17
      ],
      [
        -44,
        0
      ],
      [
        0,
        -17
      ],
      [
        -13,
        0
      ],
      [
        0,
        -17
      ],
      [
        -49,
        0
      ],
      [
        1,
        151
      ],
      [
        -4,
        0
      ]
    ],
    [
      [
        22528,
        65125
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        22527,
        65125
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        28588,
        64149
      ],
      [
        27,
        -69
      ]
    ],
    [
      [
        28615,
        64080
      ],
      [
        27,
        -72
      ],
      [
        10,
        -24
      ],
      [
        21,
        -55
      ],
      [
        9,
        -13
      ],
      [
        13,
        -46
      ]
    ],
    [
      [
        28695,
        63870
      ],
      [
        -43,
        -70
      ],
      [
        -22,
        -12
      ],
      [
        -14,
        -8
      ],
      [
        -8,
        -11
      ],
      [
        -28,
        -37
      ]
    ],
    [
      [
        28580,
        63732
      ],
      [
        -1,
        2
      ],
      [
        -6,
        65
      ],
      [
        -10,
        99
      ],
      [
        -12,
        126
      ],
      [
        -2,
        31
      ],
      [
        39,
        94
      ]
    ],
    [
      [
        21322,
        56315
      ],
      [
        148,
        -1
      ]
    ],
    [
      [
        21470,
        56314
      ],
      [
        3,
        -506
      ]
    ],
    [
      [
        21473,
        55808
      ],
      [
        -145,
        -2
      ]
    ],
    [
      [
        21328,
        55806
      ],
      [
        -6,
        509
      ]
    ],
    [
      [
        22159,
        55304
      ],
      [
        39,
        0
      ]
    ],
    [
      [
        22198,
        55304
      ],
      [
        105,
        0
      ]
    ],
    [
      [
        22303,
        55304
      ],
      [
        0,
        -515
      ]
    ],
    [
      [
        22303,
        54789
      ],
      [
        -5,
        0
      ]
    ],
    [
      [
        22298,
        54789
      ],
      [
        -139,
        0
      ]
    ],
    [
      [
        22159,
        54789
      ],
      [
        0,
        515
      ]
    ],
    [
      [
        21698,
        53674
      ],
      [
        112,
        7
      ],
      [
        1,
        166
      ],
      [
        10,
        -11
      ]
    ],
    [
      [
        21821,
        53836
      ],
      [
        164,
        -3
      ]
    ],
    [
      [
        21985,
        53833
      ],
      [
        1,
        -129
      ],
      [
        34,
        -2
      ]
    ],
    [
      [
        22020,
        53702
      ],
      [
        -1,
        -574
      ]
    ],
    [
      [
        22019,
        53128
      ],
      [
        -158,
        -2
      ],
      [
        -2,
        1
      ]
    ],
    [
      [
        21859,
        53127
      ],
      [
        -1,
        509
      ],
      [
        -160,
        5
      ]
    ],
    [
      [
        21698,
        53641
      ],
      [
        0,
        33
      ]
    ],
    [
      [
        22631,
        55859
      ],
      [
        120,
        0
      ]
    ],
    [
      [
        22751,
        55859
      ],
      [
        28,
        -1
      ],
      [
        1,
        -3
      ]
    ],
    [
      [
        22780,
        55855
      ],
      [
        -2,
        -246
      ],
      [
        -1,
        -41
      ],
      [
        -1,
        -224
      ]
    ],
    [
      [
        22776,
        55344
      ],
      [
        -5,
        1
      ],
      [
        -36,
        2
      ]
    ],
    [
      [
        22735,
        55347
      ],
      [
        -1,
        1
      ],
      [
        -37,
        2
      ],
      [
        -67,
        6
      ]
    ],
    [
      [
        22630,
        55356
      ],
      [
        1,
        503
      ]
    ],
    [
      [
        22784,
        68386
      ],
      [
        67,
        1
      ]
    ],
    [
      [
        22851,
        68387
      ],
      [
        67,
        0
      ]
    ],
    [
      [
        22918,
        68387
      ],
      [
        0,
        -405
      ]
    ],
    [
      [
        22851,
        67982
      ],
      [
        -67,
        1
      ]
    ],
    [
      [
        22784,
        67983
      ],
      [
        0,
        403
      ]
    ],
    [
      [
        22142,
        69204
      ],
      [
        28,
        -1
      ]
    ],
    [
      [
        22170,
        69203
      ],
      [
        73,
        0
      ]
    ],
    [
      [
        22243,
        69203
      ],
      [
        -1,
        -407
      ],
      [
        4,
        0
      ],
      [
        0,
        -410
      ]
    ],
    [
      [
        22246,
        68386
      ],
      [
        -77,
        -3
      ]
    ],
    [
      [
        22169,
        68383
      ],
      [
        -5,
        13
      ],
      [
        -11,
        14
      ],
      [
        -8,
        2
      ]
    ],
    [
      [
        22145,
        68412
      ],
      [
        0,
        385
      ],
      [
        -4,
        0
      ]
    ],
    [
      [
        22141,
        68797
      ],
      [
        1,
        407
      ]
    ],
    [
      [
        21907,
        56884
      ],
      [
        5,
        -1
      ],
      [
        23,
        0
      ]
    ],
    [
      [
        21935,
        56883
      ],
      [
        117,
        -2
      ]
    ],
    [
      [
        22052,
        56881
      ],
      [
        0,
        -102
      ]
    ],
    [
      [
        22052,
        56779
      ],
      [
        -3,
        2
      ],
      [
        -1,
        19
      ],
      [
        -7,
        -4
      ],
      [
        -3,
        -10
      ],
      [
        -1,
        -459
      ]
    ],
    [
      [
        22037,
        56327
      ],
      [
        -131,
        0
      ]
    ],
    [
      [
        21906,
        56327
      ],
      [
        1,
        557
      ]
    ],
    [
      [
        19139,
        53877
      ],
      [
        0,
        -136
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -168
      ],
      [
        1,
        -160
      ]
    ],
    [
      [
        19137,
        53413
      ],
      [
        -94,
        1
      ],
      [
        -57,
        -1
      ],
      [
        -21,
        0
      ],
      [
        -14,
        19
      ],
      [
        -67,
        90
      ]
    ],
    [
      [
        18884,
        53522
      ],
      [
        0,
        111
      ],
      [
        57,
        0
      ],
      [
        0,
        238
      ],
      [
        29,
        0
      ],
      [
        57,
        1
      ],
      [
        0,
        6
      ],
      [
        112,
        -1
      ]
    ],
    [
      [
        24101,
        64854
      ],
      [
        65,
        1
      ]
    ],
    [
      [
        24166,
        64855
      ],
      [
        31,
        1
      ],
      [
        33,
        0
      ]
    ],
    [
      [
        24230,
        64856
      ],
      [
        0,
        -306
      ]
    ],
    [
      [
        24230,
        64550
      ],
      [
        -96,
        -1
      ],
      [
        -32,
        0
      ]
    ],
    [
      [
        24102,
        64549
      ],
      [
        -1,
        305
      ]
    ],
    [
      [
        24456,
        65668
      ],
      [
        0,
        102
      ]
    ],
    [
      [
        24456,
        65770
      ],
      [
        131,
        -2
      ]
    ],
    [
      [
        24587,
        65768
      ],
      [
        0,
        -203
      ]
    ],
    [
      [
        24587,
        65565
      ],
      [
        -1,
        -203
      ]
    ],
    [
      [
        24586,
        65362
      ],
      [
        -38,
        0
      ],
      [
        -92,
        1
      ]
    ],
    [
      [
        24456,
        65363
      ],
      [
        0,
        305
      ]
    ],
    [
      [
        19834,
        71964
      ],
      [
        0,
        0
      ]
    ],
    [
      [
        19834,
        71964
      ],
      [
        1,
        -2
      ],
      [
        0,
        7
      ],
      [
        -1,
        2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        5
      ],
      [
        2,
        3
      ],
      [
        1,
        -1
      ],
      [
        -1,
        5
      ],
      [
        -2,
        2
      ],
      [
        -1,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        3
      ],
      [
        1,
        -1
      ],
      [
        1,
        1
      ],
      [
        0,
        7
      ],
      [
        -1,
        1
      ],
      [
        -1,
        7
      ],
      [
        3,
        8
      ],
      [
        2,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        2
      ],
      [
        -2,
        1
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -4
      ],
      [
        -1,
        2
      ],
      [
        0,
        5
      ],
      [
        1,
        2
      ],
      [
        -1,
        2
      ],
      [
        -2,
        5
      ],
      [
        1,
        2
      ],
      [
        1,
        4
      ],
      [
        1,
        7
      ],
      [
        0,
        2
      ],
      [
        -1,
        5
      ],
      [
        -1,
        1
      ],
      [
        0,
        4
      ],
      [
        1,
        3
      ],
      [
        1,
        0
      ],
      [
        0,
        9
      ],
      [
        1,
        2
      ],
      [
        2,
        2
      ],
      [
        1,
        4
      ],
      [
        0,
        5
      ],
      [
        -1,
        4
      ],
      [
        2,
        0
      ],
      [
        1,
        -1
      ],
      [
        1,
        5
      ],
      [
        -2,
        6
      ],
      [
        0,
        2
      ],
      [
        2,
        -1
      ],
      [
        1,
        4
      ],
      [
        1,
        9
      ],
      [
        2,
        4
      ],
      [
        1,
        4
      ],
      [
        0,
        7
      ],
      [
        -1,
        4
      ],
      [
        -1,
        5
      ],
      [
        1,
        -1
      ],
      [
        1,
        0
      ],
      [
        0,
        5
      ],
      [
        -1,
        3
      ],
      [
        1,
        7
      ],
      [
        -1,
        4
      ],
      [
        -1,
        0
      ],
      [
        0,
        7
      ],
      [
        1,
        0
      ],
      [
        -1,
        5
      ],
      [
        -1,
        0
      ],
      [
        1,
        3
      ],
      [
        2,
        5
      ]
    ],
    [
      [
        19847,
        72176
      ],
      [
        13,
        6
      ],
      [
        -1,
        31
      ],
      [
        5,
        11
      ],
      [
        -4,
        25
      ],
      [
        6,
        13
      ],
      [
        1,
        11
      ],
      [
        6,
        14
      ],
      [
        6,
        0
      ],
      [
        1,
        8
      ],
      [
        4,
        -11
      ],
      [
        4,
        5
      ],
      [
        0,
        18
      ],
      [
        9,
        10
      ],
      [
        0,
        16
      ],
      [
        6,
        17
      ],
      [
        4,
        34
      ],
      [
        7,
        0
      ],
      [
        2,
        -10
      ],
      [
        5,
        10
      ],
      [
        -3,
        27
      ],
      [
        5,
        -5
      ],
      [
        6,
        -20
      ],
      [
        2,
        19
      ],
      [
        4,
        2
      ],
      [
        8,
        -7
      ],
      [
        3,
        3
      ],
      [
        10,
        -4
      ],
      [
        6,
        -22
      ],
      [
        13,
        -2
      ],
      [
        3,
        4
      ],
      [
        0,
        25
      ],
      [
        6,
        18
      ],
      [
        -3,
        18
      ],
      [
        4,
        16
      ]
    ],
    [
      [
        19985,
        72456
      ],
      [
        15,
        0
      ],
      [
        8,
        -13
      ],
      [
        14,
        0
      ],
      [
        9,
        -22
      ],
      [
        21,
        1
      ],
      [
        4,
        6
      ],
      [
        13,
        2
      ],
      [
        12,
        -8
      ],
      [
        17,
        1
      ],
      [
        3,
        12
      ],
      [
        11,
        -1
      ],
      [
        4,
        4
      ],
      [
        5,
        -8
      ],
      [
        10,
        7
      ],
      [
        3,
        3
      ],
      [
        3,
        29
      ],
      [
        -3,
        18
      ],
      [
        5,
        22
      ],
      [
        8,
        7
      ],
      [
        13,
        -1
      ],
      [
        8,
        -12
      ],
      [
        7,
        3
      ],
      [
        6,
        24
      ],
      [
        0,
        20
      ],
      [
        10,
        4
      ],
      [
        4,
        -5
      ],
      [
        2,
        22
      ],
      [
        9,
        1
      ],
      [
        3,
        -16
      ],
      [
        2,
        9
      ],
      [
        -2,
        23
      ],
      [
        11,
        9
      ],
      [
        4,
        19
      ],
      [
        -2,
        14
      ],
      [
        10,
        11
      ],
      [
        0,
        12
      ],
      [
        -4,
        17
      ],
      [
        3,
        6
      ],
      [
        6,
        -2
      ],
      [
        0,
        14
      ],
      [
        -6,
        15
      ],
      [
        9,
        13
      ],
      [
        3,
        21
      ],
      [
        -5,
        16
      ],
      [
        2,
        14
      ],
      [
        13,
        14
      ],
      [
        2,
        14
      ],
      [
        5,
        -8
      ],
      [
        -1,
        -13
      ],
      [
        4,
        -8
      ]
    ],
    [
      [
        20263,
        72766
      ],
      [
        16,
        -1
      ],
      [
        1,
        -103
      ],
      [
        27,
        0
      ],
      [
        0,
        -395
      ],
      [
        -11,
        0
      ],
      [
        0,
        -204
      ],
      [
        36,
        1
      ],
      [
        0,
        -202
      ],
      [
        23,
        0
      ]
    ],
    [
      [
        20355,
        71862
      ],
      [
        0,
        -374
      ]
    ],
    [
      [
        20355,
        71488
      ],
      [
        0,
        -16
      ]
    ],
    [
      [
        20355,
        71472
      ],
      [
        -176,
        -1
      ],
      [
        0,
        17
      ],
      [
        -209,
        -1
      ],
      [
        0,
        -9
      ],
      [
        -118,
        0
      ]
    ],
    [
      [
        19852,
        71478
      ],
      [
        0,
        1
      ],
      [
        -1,
        2
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        3
      ],
      [
        1,
        5
      ],
      [
        1,
        3
      ],
      [
        -1,
        3
      ],
      [
        -2,
        1
      ],
      [
        -2,
        1
      ],
      [
        -1,
        3
      ],
      [
        1,
        3
      ],
      [
        0,
        4
      ],
      [
        -1,
        0
      ],
      [
        -3,
        2
      ],
      [
        0,
        -2
      ],
      [
        -2,
        3
      ],
      [
        -1,
        5
      ],
      [
        1,
        4
      ],
      [
        0,
        6
      ],
      [
        -1,
        3
      ],
      [
        2,
        3
      ],
      [
        1,
        2
      ],
      [
        0,
        7
      ],
      [
        1,
        8
      ],
      [
        -1,
        3
      ],
      [
        1,
        6
      ],
      [
        1,
        -1
      ],
      [
        1,
        0
      ],
      [
        1,
        3
      ],
      [
        -1,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        6
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        2
      ],
      [
        -1,
        0
      ],
      [
        -2,
        1
      ],
      [
        0,
        5
      ],
      [
        2,
        2
      ],
      [
        2,
        -1
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        -2,
        2
      ],
      [
        -1,
        4
      ],
      [
        1,
        8
      ],
      [
        2,
        3
      ],
      [
        0,
        1
      ],
      [
        -1,
        3
      ],
      [
        0,
        6
      ],
      [
        1,
        0
      ],
      [
        0,
        4
      ],
      [
        -1,
        4
      ],
      [
        -1,
        -1
      ],
      [
        1,
        4
      ],
      [
        1,
        2
      ],
      [
        2,
        0
      ],
      [
        2,
        5
      ],
      [
        1,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        1,
        2
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        0,
        2
      ],
      [
        -1,
        4
      ],
      [
        0,
        4
      ],
      [
        1,
        3
      ],
      [
        0,
        3
      ],
      [
        -1,
        7
      ],
      [
        -1,
        4
      ],
      [
        -1,
        1
      ],
      [
        0,
        8
      ],
      [
        -1,
        3
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        3
      ],
      [
        -1,
        6
      ],
      [
        0,
        2
      ],
      [
        1,
        4
      ],
      [
        1,
        2
      ],
      [
        2,
        2
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        -1,
        5
      ],
      [
        0,
        4
      ],
      [
        -2,
        5
      ],
      [
        -2,
        5
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        4
      ],
      [
        0,
        2
      ],
      [
        1,
        4
      ],
      [
        1,
        1
      ],
      [
        0,
        3
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        2
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        0,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        0
      ],
      [
        0,
        4
      ],
      [
        1,
        5
      ],
      [
        0,
        6
      ],
      [
        -2,
        0
      ],
      [
        0,
        -6
      ],
      [
        -1,
        0
      ],
      [
        0,
        4
      ],
      [
        -1,
        4
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        4
      ],
      [
        2,
        5
      ],
      [
        -1,
        10
      ],
      [
        -1,
        6
      ],
      [
        -2,
        3
      ],
      [
        -2,
        3
      ],
      [
        1,
        1
      ],
      [
        2,
        -2
      ],
      [
        1,
        3
      ],
      [
        0,
        2
      ],
      [
        1,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        4
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        -2,
        4
      ],
      [
        -2,
        0
      ],
      [
        -2,
        7
      ],
      [
        1,
        6
      ],
      [
        1,
        3
      ],
      [
        1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        1,
        -1
      ],
      [
        1,
        2
      ],
      [
        1,
        4
      ],
      [
        0,
        3
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        0
      ],
      [
        0,
        3
      ],
      [
        2,
        0
      ],
      [
        1,
        7
      ],
      [
        -1,
        1
      ],
      [
        -1,
        7
      ],
      [
        -1,
        3
      ],
      [
        1,
        4
      ],
      [
        1,
        -1
      ],
      [
        1,
        1
      ],
      [
        0,
        -7
      ],
      [
        1,
        4
      ],
      [
        0,
        7
      ],
      [
        -2,
        5
      ],
      [
        1,
        5
      ],
      [
        1,
        -2
      ],
      [
        1,
        -5
      ],
      [
        2,
        2
      ],
      [
        0,
        9
      ],
      [
        1,
        3
      ],
      [
        0,
        4
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -4
      ],
      [
        0,
        2
      ],
      [
        1,
        5
      ],
      [
        0,
        4
      ],
      [
        -1,
        1
      ],
      [
        0,
        3
      ],
      [
        1,
        0
      ],
      [
        0,
        3
      ],
      [
        -2,
        0
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        2
      ],
      [
        1,
        3
      ],
      [
        1,
        5
      ],
      [
        1,
        6
      ],
      [
        0,
        10
      ],
      [
        -1,
        2
      ],
      [
        -1,
        3
      ],
      [
        1,
        3
      ],
      [
        -1,
        3
      ],
      [
        -1,
        0
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        4
      ],
      [
        0,
        2
      ],
      [
        1,
        0
      ],
      [
        0,
        -3
      ],
      [
        1,
        2
      ],
      [
        0,
        5
      ],
      [
        -1,
        3
      ],
      [
        0,
        3
      ],
      [
        2,
        1
      ],
      [
        0,
        -2
      ],
      [
        1,
        2
      ],
      [
        0,
        5
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        3
      ],
      [
        -1,
        0
      ],
      [
        0,
        5
      ],
      [
        1,
        3
      ],
      [
        2,
        2
      ],
      [
        0,
        -2
      ],
      [
        2,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        2
      ],
      [
        -1,
        2
      ],
      [
        -2,
        1
      ],
      [
        -2,
        4
      ],
      [
        1,
        5
      ],
      [
        1,
        1
      ]
    ],
    [
      [
        23706,
        61217
      ],
      [
        3,
        207
      ]
    ],
    [
      [
        23709,
        61424
      ],
      [
        137,
        -15
      ],
      [
        -3,
        20
      ],
      [
        3,
        1
      ],
      [
        6,
        -16
      ],
      [
        3,
        2
      ]
    ],
    [
      [
        23855,
        61416
      ],
      [
        8,
        -10
      ],
      [
        -2,
        -146
      ]
    ],
    [
      [
        23861,
        61260
      ],
      [
        -2,
        -186
      ],
      [
        -16,
        1
      ],
      [
        -2,
        -101
      ]
    ],
    [
      [
        23841,
        60974
      ],
      [
        -15,
        2
      ]
    ],
    [
      [
        23826,
        60976
      ],
      [
        -51,
        6
      ],
      [
        1,
        68
      ],
      [
        -72,
        9
      ]
    ],
    [
      [
        23704,
        61059
      ],
      [
        2,
        158
      ]
    ],
    [
      [
        25733,
        53023
      ],
      [
        11,
        -1
      ],
      [
        5,
        0
      ],
      [
        6,
        -2
      ],
      [
        5,
        0
      ]
    ],
    [
      [
        25760,
        53020
      ],
      [
        34,
        0
      ],
      [
        13,
        -2
      ],
      [
        2,
        1
      ],
      [
        3,
        -1
      ],
      [
        12,
        1
      ],
      [
        19,
        0
      ]
    ],
    [
      [
        25843,
        53019
      ],
      [
        -1,
        -308
      ],
      [
        -1,
        -408
      ]
    ],
    [
      [
        25841,
        52303
      ],
      [
        -4,
        2
      ],
      [
        -17,
        4
      ],
      [
        -10,
        -2
      ],
      [
        -6,
        5
      ],
      [
        -29,
        11
      ],
      [
        -33,
        -5
      ],
      [
        -4,
        -2
      ],
      [
        -9,
        -4
      ]
    ],
    [
      [
        25729,
        52312
      ],
      [
        2,
        348
      ],
      [
        2,
        363
      ]
    ],
    [
      [
        25579,
        59593
      ],
      [
        22,
        502
      ]
    ],
    [
      [
        25601,
        60095
      ],
      [
        4,
        -10
      ],
      [
        -2,
        -27
      ],
      [
        37,
        5
      ],
      [
        18,
        18
      ]
    ],
    [
      [
        25658,
        60081
      ],
      [
        -1,
        -298
      ],
      [
        2,
        -43
      ],
      [
        -3,
        -23
      ],
      [
        0,
        -122
      ]
    ],
    [
      [
        25656,
        59595
      ],
      [
        -15,
        -1
      ]
    ],
    [
      [
        25641,
        59594
      ],
      [
        -37,
        0
      ],
      [
        -9,
        -1
      ],
      [
        -16,
        0
      ]
    ],
    [
      [
        31021,
        70115
      ],
      [
        -19,
        -13
      ],
      [
        -8,
        13
      ],
      [
        1,
        -18
      ],
      [
        -42,
        -29
      ]
    ],
    [
      [
        30953,
        70068
      ],
      [
        -59,
        -41
      ],
      [
        1,
        -8
      ],
      [
        -43,
        -29
      ],
      [
        -6,
        6
      ],
      [
        0,
        104
      ],
      [
        1,
        107
      ],
      [
        0,
        109
      ],
      [
        1,
        21
      ],
      [
        -1,
        86
      ],
      [
        -1,
        9
      ],
      [
        0,
        96
      ],
      [
        -1,
        9
      ],
      [
        0,
        395
      ],
      [
        -72,
        0
      ],
      [
        0,
        15
      ],
      [
        -35,
        1
      ]
    ],
    [
      [
        30738,
        70948
      ],
      [
        0,
        205
      ],
      [
        -251,
        2
      ]
    ],
    [
      [
        30487,
        71155
      ],
      [
        -84,
        0
      ]
    ],
    [
      [
        30403,
        71155
      ],
      [
        1,
        21
      ],
      [
        6,
        120
      ],
      [
        1,
        4
      ],
      [
        12,
        51
      ],
      [
        2,
        9
      ],
      [
        19,
        79
      ],
      [
        16,
        67
      ],
      [
        70,
        291
      ],
      [
        35,
        145
      ],
      [
        60,
        244
      ],
      [
        1,
        -3
      ],
      [
        5,
        -6
      ],
      [
        6,
        4
      ],
      [
        1,
        2
      ],
      [
        4,
        -7
      ],
      [
        2,
        0
      ],
      [
        3,
        -2
      ],
      [
        7,
        -9
      ],
      [
        4,
        -7
      ],
      [
        2,
        -5
      ],
      [
        1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        4,
        -3
      ],
      [
        4,
        7
      ],
      [
        2,
        3
      ],
      [
        1,
        -1
      ],
      [
        4,
        -5
      ],
      [
        0,
        -1
      ],
      [
        1,
        -5
      ],
      [
        0,
        -22
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -3
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        -7
      ],
      [
        0,
        -72
      ],
      [
        1,
        -11
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -8
      ],
      [
        1,
        0
      ],
      [
        0,
        -22
      ],
      [
        1,
        -8
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -7
      ],
      [
        3,
        -14
      ],
      [
        1,
        -4
      ],
      [
        1,
        -1
      ],
      [
        2,
        -2
      ],
      [
        6,
        -10
      ],
      [
        3,
        -7
      ],
      [
        3,
        -5
      ],
      [
        2,
        -4
      ],
      [
        0,
        -2
      ],
      [
        2,
        -2
      ],
      [
        2,
        -9
      ],
      [
        2,
        2
      ],
      [
        0,
        -5
      ],
      [
        1,
        0
      ],
      [
        2,
        4
      ],
      [
        2,
        -4
      ],
      [
        1,
        -6
      ],
      [
        1,
        -1
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        -3
      ],
      [
        0,
        -6
      ],
      [
        1,
        -1
      ],
      [
        2,
        -3
      ],
      [
        1,
        -6
      ],
      [
        1,
        -3
      ],
      [
        1,
        3
      ],
      [
        1,
        2
      ],
      [
        1,
        -1
      ],
      [
        3,
        2
      ],
      [
        1,
        3
      ],
      [
        1,
        2
      ],
      [
        1,
        1
      ],
      [
        2,
        1
      ],
      [
        1,
        1
      ],
      [
        2,
        3
      ],
      [
        1,
        5
      ],
      [
        5,
        9
      ],
      [
        5,
        12
      ],
      [
        2,
        1
      ],
      [
        7,
        6
      ],
      [
        3,
        0
      ],
      [
        1,
        1
      ],
      [
        4,
        5
      ],
      [
        2,
        5
      ],
      [
        2,
        6
      ],
      [
        5,
        6
      ],
      [
        2,
        0
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        3,
        6
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        3,
        -1
      ],
      [
        3,
        -7
      ],
      [
        1,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        2,
        0
      ],
      [
        2,
        2
      ],
      [
        4,
        1
      ],
      [
        2,
        1
      ],
      [
        3,
        5
      ],
      [
        1,
        2
      ],
      [
        2,
        10
      ],
      [
        1,
        2
      ],
      [
        0,
        4
      ],
      [
        -1,
        6
      ],
      [
        0,
        4
      ],
      [
        1,
        4
      ],
      [
        1,
        6
      ],
      [
        0,
        2
      ],
      [
        2,
        4
      ],
      [
        1,
        3
      ],
      [
        2,
        -1
      ],
      [
        3,
        -4
      ],
      [
        2,
        -1
      ],
      [
        2,
        0
      ],
      [
        2,
        3
      ],
      [
        3,
        9
      ],
      [
        2,
        2
      ],
      [
        1,
        2
      ],
      [
        4,
        0
      ],
      [
        2,
        -2
      ],
      [
        2,
        -1
      ],
      [
        1,
        1
      ],
      [
        2,
        3
      ],
      [
        2,
        0
      ],
      [
        1,
        -3
      ],
      [
        1,
        -3
      ],
      [
        1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        1,
        -2
      ],
      [
        2,
        -2
      ],
      [
        2,
        1
      ],
      [
        3,
        -2
      ],
      [
        1,
        0
      ],
      [
        1,
        2
      ],
      [
        2,
        5
      ],
      [
        1,
        1
      ],
      [
        7,
        -2
      ],
      [
        2,
        0
      ],
      [
        1,
        1
      ],
      [
        0,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        5
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -2,
        5
      ],
      [
        0,
        4
      ],
      [
        1,
        3
      ],
      [
        0,
        2
      ],
      [
        -1,
        15
      ],
      [
        0,
        6
      ],
      [
        1,
        15
      ],
      [
        1,
        4
      ],
      [
        1,
        5
      ],
      [
        1,
        4
      ],
      [
        1,
        3
      ],
      [
        2,
        2
      ],
      [
        1,
        2
      ],
      [
        6,
        3
      ],
      [
        3,
        0
      ],
      [
        4,
        -4
      ],
      [
        2,
        -1
      ],
      [
        1,
        1
      ],
      [
        2,
        4
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        2,
        -2
      ],
      [
        1,
        -5
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        5,
        0
      ],
      [
        2,
        2
      ],
      [
        2,
        1
      ],
      [
        2,
        -2
      ],
      [
        1,
        -3
      ],
      [
        0,
        -7
      ],
      [
        2,
        -4
      ],
      [
        1,
        -2
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        -1
      ],
      [
        7,
        -12
      ],
      [
        4,
        -1
      ],
      [
        2,
        -3
      ],
      [
        1,
        -2
      ],
      [
        0,
        -16
      ],
      [
        2,
        -7
      ],
      [
        2,
        -9
      ],
      [
        3,
        -2
      ],
      [
        0,
        -3
      ],
      [
        2,
        -4
      ],
      [
        0,
        -2
      ],
      [
        8,
        -12
      ],
      [
        2,
        -5
      ],
      [
        1,
        -3
      ],
      [
        1,
        -4
      ],
      [
        0,
        -5
      ],
      [
        1,
        -3
      ],
      [
        3,
        -3
      ],
      [
        7,
        -13
      ],
      [
        1,
        -2
      ],
      [
        4,
        -7
      ],
      [
        1,
        -4
      ],
      [
        3,
        -9
      ],
      [
        2,
        -10
      ],
      [
        2,
        -7
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        4,
        -3
      ],
      [
        1,
        -1
      ],
      [
        4,
        -8
      ],
      [
        1,
        -4
      ],
      [
        0,
        -15
      ],
      [
        2,
        -7
      ],
      [
        0,
        -1
      ],
      [
        1,
        -5
      ],
      [
        1,
        -8
      ],
      [
        3,
        -11
      ],
      [
        0,
        -1
      ],
      [
        2,
        -4
      ],
      [
        2,
        -3
      ],
      [
        2,
        -13
      ],
      [
        1,
        -3
      ],
      [
        2,
        -6
      ],
      [
        0,
        -1
      ],
      [
        1,
        -5
      ],
      [
        0,
        -15
      ],
      [
        1,
        -5
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        1,
        -2
      ],
      [
        2,
        -1
      ],
      [
        2,
        -2
      ],
      [
        4,
        -7
      ],
      [
        4,
        -8
      ],
      [
        1,
        -1
      ],
      [
        3,
        -2
      ],
      [
        0,
        -1
      ],
      [
        2,
        -2
      ],
      [
        1,
        -6
      ],
      [
        2,
        -3
      ],
      [
        3,
        -5
      ],
      [
        1,
        -2
      ],
      [
        0,
        -545
      ],
      [
        1,
        -155
      ],
      [
        0,
        -34
      ],
      [
        1,
        -184
      ],
      [
        0,
        -108
      ],
      [
        1,
        -172
      ],
      [
        0,
        -40
      ],
      [
        -1,
        -47
      ],
      [
        0,
        -24
      ],
      [
        1,
        -6
      ],
      [
        0,
        -5
      ],
      [
        1,
        0
      ],
      [
        0,
        1
      ],
      [
        5,
        -10
      ],
      [
        2,
        -10
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -5
      ],
      [
        -3,
        -3
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        -5,
        -14
      ],
      [
        0,
        -17
      ],
      [
        2,
        -11
      ],
      [
        2,
        -10
      ],
      [
        2,
        -6
      ],
      [
        1,
        -3
      ],
      [
        2,
        -3
      ],
      [
        1,
        -2
      ],
      [
        1,
        -6
      ],
      [
        0,
        -7
      ],
      [
        3,
        -5
      ],
      [
        -3,
        -4
      ],
      [
        0,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        -2,
        0
      ],
      [
        0,
        -4
      ],
      [
        -6,
        -15
      ],
      [
        -2,
        -10
      ],
      [
        1,
        -15
      ],
      [
        0,
        -14
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -14
      ],
      [
        4,
        -5
      ],
      [
        3,
        -23
      ],
      [
        -8,
        -2
      ],
      [
        2,
        -39
      ],
      [
        -4,
        -3
      ],
      [
        4,
        -15
      ]
    ],
    [
      [
        27922,
        63180
      ],
      [
        33,
        0
      ]
    ],
    [
      [
        27955,
        63180
      ],
      [
        119,
        0
      ]
    ],
    [
      [
        28074,
        63180
      ],
      [
        11,
        0
      ]
    ],
    [
      [
        28087,
        63079
      ],
      [
        -5,
        5
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -5
      ],
      [
        1,
        -2
      ],
      [
        1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        -2,
        1
      ],
      [
        -2,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        -5
      ],
      [
        2,
        -7
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        -3,
        0
      ],
      [
        -2,
        4
      ],
      [
        -1,
        5
      ],
      [
        -5,
        6
      ],
      [
        -2,
        3
      ],
      [
        -1,
        1
      ],
      [
        -2,
        -2
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        2,
        -8
      ],
      [
        1,
        -5
      ],
      [
        2,
        -6
      ],
      [
        3,
        -5
      ],
      [
        2,
        -4
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        3
      ],
      [
        -1,
        3
      ],
      [
        -4,
        5
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -8
      ],
      [
        1,
        -7
      ],
      [
        1,
        -4
      ],
      [
        3,
        -8
      ],
      [
        3,
        -6
      ],
      [
        1,
        -3
      ],
      [
        1,
        -5
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -1,
        3
      ],
      [
        -1,
        0
      ],
      [
        0,
        -12
      ],
      [
        -1,
        0
      ],
      [
        -1,
        3
      ],
      [
        -1,
        2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -7
      ],
      [
        -3,
        -1
      ],
      [
        0,
        -11
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -5
      ]
    ],
    [
      [
        28050,
        62940
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -2,
        3
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        2
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        5
      ],
      [
        -2,
        2
      ],
      [
        -2,
        0
      ],
      [
        -5,
        -4
      ],
      [
        -2,
        0
      ],
      [
        -1,
        1
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        3
      ],
      [
        -2,
        5
      ],
      [
        -2,
        1
      ],
      [
        -1,
        3
      ],
      [
        -1,
        2
      ],
      [
        0,
        4
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        1
      ],
      [
        -2,
        3
      ],
      [
        -2,
        3
      ],
      [
        -2,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -7,
        -3
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        27997,
        62961
      ],
      [
        -2,
        2
      ],
      [
        -1,
        4
      ],
      [
        -2,
        1
      ],
      [
        -2,
        4
      ],
      [
        -2,
        2
      ],
      [
        0,
        2
      ],
      [
        -1,
        4
      ],
      [
        0,
        3
      ],
      [
        -4,
        3
      ],
      [
        0,
        1
      ],
      [
        -1,
        6
      ],
      [
        -1,
        0
      ],
      [
        -3,
        2
      ],
      [
        0,
        4
      ],
      [
        -2,
        9
      ],
      [
        0,
        13
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        2
      ],
      [
        -1,
        1
      ],
      [
        -2,
        6
      ],
      [
        0,
        9
      ],
      [
        -1,
        2
      ],
      [
        0,
        1
      ],
      [
        -2,
        5
      ],
      [
        1,
        0
      ],
      [
        0,
        3
      ],
      [
        2,
        5
      ],
      [
        2,
        2
      ],
      [
        3,
        0
      ],
      [
        1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        2,
        4
      ],
      [
        2,
        5
      ],
      [
        0,
        2
      ],
      [
        -1,
        7
      ],
      [
        -2,
        4
      ],
      [
        -1,
        2
      ],
      [
        -3,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        1
      ],
      [
        -2,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        2,
        15
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        1,
        5
      ],
      [
        0,
        5
      ],
      [
        -3,
        -3
      ],
      [
        -4,
        -8
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -11
      ],
      [
        2,
        -15
      ],
      [
        0,
        -9
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        0
      ],
      [
        0,
        2
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -4
      ],
      [
        -2,
        -8
      ],
      [
        -2,
        0
      ],
      [
        0,
        -15
      ],
      [
        2,
        -2
      ],
      [
        1,
        -5
      ],
      [
        1,
        -5
      ],
      [
        -1,
        -7
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        4
      ],
      [
        -2,
        2
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        -8
      ],
      [
        0,
        -9
      ],
      [
        -5,
        -23
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -10
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -2,
        2
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -8
      ],
      [
        -4,
        -18
      ],
      [
        -2,
        -12
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        1
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -4
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -25
      ],
      [
        0,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -2
      ],
      [
        0,
        2
      ],
      [
        -1,
        4
      ],
      [
        -2,
        6
      ],
      [
        -5,
        7
      ],
      [
        -4,
        7
      ],
      [
        -2,
        7
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        3
      ],
      [
        0,
        7
      ],
      [
        -1,
        4
      ],
      [
        -2,
        8
      ],
      [
        -2,
        -2
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -2
      ],
      [
        -3,
        4
      ]
    ],
    [
      [
        27883,
        62891
      ],
      [
        0,
        6
      ],
      [
        19,
        140
      ],
      [
        20,
        143
      ]
    ],
    [
      [
        25139,
        54862
      ],
      [
        58,
        0
      ],
      [
        89,
        1
      ]
    ],
    [
      [
        25286,
        54863
      ],
      [
        -3,
        -108
      ],
      [
        -1,
        -41
      ],
      [
        -2,
        -59
      ],
      [
        -1,
        -23
      ],
      [
        0,
        -7
      ],
      [
        -2,
        -76
      ]
    ],
    [
      [
        25277,
        54549
      ],
      [
        -2,
        -68
      ],
      [
        -1,
        -26
      ]
    ],
    [
      [
        25274,
        54455
      ],
      [
        -53,
        -1
      ],
      [
        -81,
        -3
      ]
    ],
    [
      [
        25140,
        54451
      ],
      [
        -1,
        305
      ],
      [
        0,
        106
      ]
    ],
    [
      [
        22328,
        70417
      ],
      [
        1,
        399
      ]
    ],
    [
      [
        22329,
        70816
      ],
      [
        270,
        0
      ]
    ],
    [
      [
        22599,
        70816
      ],
      [
        7,
        0
      ]
    ],
    [
      [
        22606,
        70816
      ],
      [
        0,
        -403
      ]
    ],
    [
      [
        22606,
        70413
      ],
      [
        -113,
        0
      ],
      [
        -26,
        1
      ],
      [
        -33,
        1
      ],
      [
        -28,
        1
      ]
    ],
    [
      [
        22406,
        70416
      ],
      [
        -50,
        1
      ],
      [
        -28,
        0
      ]
    ],
    [
      [
        23510,
        69703
      ],
      [
        34,
        -1
      ],
      [
        23,
        0
      ],
      [
        6,
        1
      ],
      [
        43,
        0
      ],
      [
        0,
        -51
      ],
      [
        34,
        1
      ]
    ],
    [
      [
        23650,
        69653
      ],
      [
        1,
        -52
      ],
      [
        0,
        -302
      ]
    ],
    [
      [
        23651,
        69299
      ],
      [
        -68,
        0
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        23583,
        69198
      ],
      [
        -72,
        -1
      ]
    ],
    [
      [
        23511,
        69197
      ],
      [
        -1,
        404
      ],
      [
        0,
        102
      ]
    ],
    [
      [
        21463,
        67449
      ],
      [
        246,
        -1
      ]
    ],
    [
      [
        21709,
        67448
      ],
      [
        0,
        -456
      ]
    ],
    [
      [
        21709,
        66992
      ],
      [
        -1,
        0
      ],
      [
        -75,
        -1
      ],
      [
        -35,
        -1
      ],
      [
        -24,
        1
      ],
      [
        -38,
        3
      ],
      [
        -65,
        0
      ]
    ],
    [
      [
        21471,
        66994
      ],
      [
        0,
        151
      ],
      [
        -8,
        0
      ],
      [
        0,
        304
      ]
    ],
    [
      [
        18808,
        64433
      ],
      [
        8,
        14
      ],
      [
        5,
        -7
      ],
      [
        1,
        -13
      ],
      [
        10,
        -16
      ],
      [
        10,
        13
      ],
      [
        2,
        22
      ],
      [
        -2,
        10
      ],
      [
        5,
        15
      ],
      [
        3,
        26
      ],
      [
        3,
        5
      ],
      [
        -2,
        17
      ],
      [
        -7,
        29
      ],
      [
        -1,
        22
      ],
      [
        -4,
        3
      ],
      [
        1,
        40
      ],
      [
        -15,
        5
      ],
      [
        -3,
        9
      ],
      [
        -1,
        32
      ],
      [
        2,
        3
      ],
      [
        5,
        5
      ],
      [
        4,
        37
      ],
      [
        7,
        24
      ],
      [
        6,
        12
      ],
      [
        9,
        1
      ],
      [
        8,
        21
      ],
      [
        10,
        -8
      ],
      [
        8,
        14
      ],
      [
        1,
        24
      ],
      [
        3,
        26
      ],
      [
        6,
        -1
      ],
      [
        4,
        10
      ],
      [
        6,
        -8
      ],
      [
        6,
        14
      ],
      [
        6,
        1
      ]
    ],
    [
      [
        18912,
        64834
      ],
      [
        9,
        -1
      ],
      [
        9,
        24
      ],
      [
        15,
        23
      ],
      [
        5,
        17
      ],
      [
        -1,
        10
      ],
      [
        7,
        10
      ],
      [
        2,
        -9
      ],
      [
        7,
        42
      ],
      [
        3,
        8
      ],
      [
        5,
        2
      ]
    ],
    [
      [
        18973,
        64960
      ],
      [
        0,
        -296
      ],
      [
        83,
        -1
      ],
      [
        10,
        -1
      ],
      [
        48,
        0
      ],
      [
        11,
        -1
      ],
      [
        35,
        0
      ],
      [
        35,
        1
      ],
      [
        4,
        -1
      ],
      [
        31,
        2
      ],
      [
        1,
        0
      ],
      [
        20,
        1
      ]
    ],
    [
      [
        19251,
        64664
      ],
      [
        14,
        0
      ]
    ],
    [
      [
        19265,
        64664
      ],
      [
        0,
        -214
      ]
    ],
    [
      [
        19265,
        64450
      ],
      [
        -4,
        0
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        3
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        1
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -2
      ],
      [
        -4,
        0
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        -2,
        1
      ],
      [
        -2,
        0
      ],
      [
        -1,
        2
      ],
      [
        -1,
        1
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        4
      ],
      [
        -2,
        3
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        3
      ],
      [
        0,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        1
      ],
      [
        -1,
        3
      ],
      [
        -1,
        3
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        1
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        3
      ],
      [
        -3,
        1
      ],
      [
        -2,
        0
      ],
      [
        -3,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        0
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -7
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        1
      ],
      [
        -2,
        3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -6
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -3
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -4,
        0
      ],
      [
        -1,
        1
      ],
      [
        0,
        -3
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -1,
        2
      ],
      [
        -1,
        3
      ],
      [
        -1,
        2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        -2,
        0
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        3
      ],
      [
        -1,
        5
      ],
      [
        0,
        1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        -3
      ],
      [
        -1,
        2
      ],
      [
        -1,
        5
      ],
      [
        -1,
        4
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        2
      ],
      [
        -3,
        -15
      ],
      [
        -6,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        0
      ],
      [
        0,
        2
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        -1,
        3
      ],
      [
        -1,
        3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        2
      ],
      [
        -1,
        3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -4
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -1,
        4
      ],
      [
        -1,
        5
      ],
      [
        -1,
        0
      ],
      [
        -2,
        6
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -1,
        3
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        -2,
        0
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -6
      ],
      [
        1,
        -1
      ],
      [
        1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -34
      ]
    ],
    [
      [
        19014,
        64292
      ],
      [
        -9,
        3
      ],
      [
        -4,
        -23
      ],
      [
        1,
        -17
      ],
      [
        -5,
        -36
      ],
      [
        0,
        -9
      ],
      [
        -4,
        -17
      ],
      [
        -9,
        0
      ],
      [
        -5,
        -18
      ],
      [
        -8,
        5
      ],
      [
        -7,
        15
      ],
      [
        -11,
        -5
      ],
      [
        -3,
        -14
      ],
      [
        -2,
        -23
      ],
      [
        -4,
        -12
      ],
      [
        -8,
        12
      ],
      [
        -9,
        18
      ],
      [
        -7,
        4
      ],
      [
        -8,
        11
      ],
      [
        -10,
        22
      ],
      [
        -7,
        20
      ],
      [
        -11,
        7
      ],
      [
        -6,
        37
      ],
      [
        0,
        20
      ],
      [
        -2,
        15
      ],
      [
        -5,
        -12
      ],
      [
        -6,
        0
      ],
      [
        1,
        -18
      ],
      [
        -12,
        -25
      ],
      [
        -3,
        -27
      ],
      [
        -1,
        -25
      ],
      [
        -11,
        15
      ],
      [
        -7,
        -3
      ]
    ],
    [
      [
        18832,
        64212
      ],
      [
        -7,
        40
      ],
      [
        -5,
        19
      ],
      [
        -2,
        8
      ],
      [
        3,
        37
      ],
      [
        -2,
        11
      ],
      [
        -2,
        5
      ],
      [
        -4,
        22
      ],
      [
        0,
        26
      ],
      [
        -8,
        23
      ],
      [
        3,
        30
      ]
    ],
    [
      [
        28469,
        67010
      ],
      [
        70,
        13
      ]
    ],
    [
      [
        28539,
        67023
      ],
      [
        -7,
        -81
      ],
      [
        1,
        -70
      ],
      [
        4,
        -29
      ],
      [
        1,
        -36
      ],
      [
        -7,
        -57
      ],
      [
        1,
        -42
      ],
      [
        2,
        -47
      ],
      [
        13,
        -50
      ],
      [
        5,
        -55
      ]
    ],
    [
      [
        28552,
        66556
      ],
      [
        6,
        -36
      ],
      [
        7,
        -30
      ],
      [
        9,
        -19
      ],
      [
        -31,
        -4
      ]
    ],
    [
      [
        28543,
        66467
      ],
      [
        -55,
        -6
      ]
    ],
    [
      [
        28488,
        66461
      ],
      [
        0,
        142
      ],
      [
        -11,
        61
      ],
      [
        -3,
        40
      ],
      [
        0,
        17
      ],
      [
        -7,
        -1
      ]
    ],
    [
      [
        28467,
        66720
      ],
      [
        -2,
        11
      ],
      [
        1,
        70
      ],
      [
        -2,
        27
      ],
      [
        1,
        14
      ],
      [
        4,
        5
      ],
      [
        0,
        163
      ]
    ],
    [
      [
        23020,
        61275
      ],
      [
        46,
        -1
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        23066,
        61375
      ],
      [
        111,
        -2
      ]
    ],
    [
      [
        23177,
        61373
      ],
      [
        0,
        -152
      ]
    ],
    [
      [
        23177,
        61221
      ],
      [
        -1,
        -254
      ],
      [
        0,
        -102
      ]
    ],
    [
      [
        23176,
        60865
      ],
      [
        0,
        -152
      ]
    ],
    [
      [
        23176,
        60713
      ],
      [
        -157,
        4
      ]
    ],
    [
      [
        23019,
        60717
      ],
      [
        0,
        254
      ],
      [
        1,
        304
      ]
    ],
    [
      [
        21859,
        61989
      ],
      [
        123,
        -2
      ]
    ],
    [
      [
        21982,
        61987
      ],
      [
        1,
        -507
      ]
    ],
    [
      [
        21983,
        61480
      ],
      [
        -61,
        1
      ],
      [
        -62,
        1
      ]
    ],
    [
      [
        21860,
        61482
      ],
      [
        -1,
        507
      ]
    ],
    [
      [
        25940,
        67539
      ],
      [
        1,
        405
      ]
    ],
    [
      [
        25941,
        67944
      ],
      [
        132,
        0
      ]
    ],
    [
      [
        26073,
        67944
      ],
      [
        0,
        -404
      ]
    ],
    [
      [
        26073,
        67540
      ],
      [
        0,
        -203
      ]
    ],
    [
      [
        26073,
        67337
      ],
      [
        -63,
        -1
      ]
    ],
    [
      [
        26010,
        67336
      ],
      [
        -69,
        0
      ],
      [
        -1,
        203
      ]
    ],
    [
      [
        22531,
        64315
      ],
      [
        126,
        1
      ]
    ],
    [
      [
        22657,
        64316
      ],
      [
        0,
        -405
      ]
    ],
    [
      [
        22657,
        63911
      ],
      [
        -125,
        -1
      ]
    ],
    [
      [
        22532,
        63910
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        22531,
        63910
      ],
      [
        0,
        405
      ]
    ],
    [
      [
        28051,
        67427
      ],
      [
        26,
        6
      ],
      [
        3,
        -3
      ],
      [
        30,
        -3
      ],
      [
        5,
        -3
      ],
      [
        25,
        8
      ],
      [
        11,
        0
      ],
      [
        23,
        -10
      ],
      [
        8,
        -2
      ]
    ],
    [
      [
        28182,
        67420
      ],
      [
        -1,
        -93
      ],
      [
        0,
        -177
      ]
    ],
    [
      [
        28181,
        67150
      ],
      [
        -87,
        -2
      ],
      [
        -43,
        -3
      ]
    ],
    [
      [
        28051,
        67145
      ],
      [
        1,
        102
      ],
      [
        -2,
        100
      ],
      [
        1,
        80
      ]
    ],
    [
      [
        22527,
        73042
      ],
      [
        108,
        0
      ]
    ],
    [
      [
        22635,
        73042
      ],
      [
        0,
        -203
      ],
      [
        6,
        0
      ],
      [
        0,
        -405
      ]
    ],
    [
      [
        22641,
        72434
      ],
      [
        -29,
        0
      ]
    ],
    [
      [
        22612,
        72434
      ],
      [
        -143,
        0
      ]
    ],
    [
      [
        22469,
        72434
      ],
      [
        -7,
        0
      ],
      [
        0,
        202
      ]
    ],
    [
      [
        22462,
        72636
      ],
      [
        0,
        80
      ]
    ],
    [
      [
        22462,
        72716
      ],
      [
        0,
        124
      ],
      [
        28,
        0
      ],
      [
        1,
        202
      ],
      [
        36,
        0
      ]
    ],
    [
      [
        22431,
        59038
      ],
      [
        10,
        1
      ],
      [
        109,
        -1
      ]
    ],
    [
      [
        22550,
        59038
      ],
      [
        1,
        -310
      ],
      [
        0,
        -67
      ],
      [
        -1,
        -135
      ]
    ],
    [
      [
        22550,
        58526
      ],
      [
        -29,
        0
      ],
      [
        0,
        -202
      ]
    ],
    [
      [
        22521,
        58324
      ],
      [
        -86,
        0
      ]
    ],
    [
      [
        22435,
        58324
      ],
      [
        -3,
        0
      ],
      [
        0,
        304
      ]
    ],
    [
      [
        22432,
        58628
      ],
      [
        -1,
        101
      ],
      [
        0,
        309
      ]
    ],
    [
      [
        22010,
        54799
      ],
      [
        144,
        -3
      ],
      [
        0,
        -7
      ]
    ],
    [
      [
        22154,
        54789
      ],
      [
        0,
        -504
      ]
    ],
    [
      [
        22154,
        54285
      ],
      [
        -23,
        1
      ]
    ],
    [
      [
        22131,
        54286
      ],
      [
        -122,
        0
      ]
    ],
    [
      [
        22009,
        54286
      ],
      [
        1,
        375
      ],
      [
        0,
        138
      ]
    ],
    [
      [
        21599,
        57895
      ],
      [
        149,
        -1
      ]
    ],
    [
      [
        21748,
        57894
      ],
      [
        -1,
        -505
      ]
    ],
    [
      [
        21747,
        57389
      ],
      [
        -106,
        -1
      ]
    ],
    [
      [
        21641,
        57388
      ],
      [
        -44,
        1
      ]
    ],
    [
      [
        21597,
        57389
      ],
      [
        2,
        506
      ]
    ],
    [
      [
        21599,
        58911
      ],
      [
        149,
        0
      ]
    ],
    [
      [
        21748,
        58911
      ],
      [
        0,
        -501
      ]
    ],
    [
      [
        21748,
        58410
      ],
      [
        -149,
        -1
      ]
    ],
    [
      [
        21599,
        58409
      ],
      [
        0,
        502
      ]
    ],
    [
      [
        21859,
        53127
      ],
      [
        -76,
        -5
      ]
    ],
    [
      [
        21783,
        53122
      ],
      [
        -87,
        -4
      ]
    ],
    [
      [
        21696,
        53118
      ],
      [
        2,
        523
      ]
    ],
    [
      [
        24949,
        68445
      ],
      [
        70,
        -2
      ],
      [
        28,
        0
      ],
      [
        6,
        -1
      ]
    ],
    [
      [
        25053,
        68442
      ],
      [
        94,
        -1
      ]
    ],
    [
      [
        25147,
        68441
      ],
      [
        0,
        -302
      ]
    ],
    [
      [
        25147,
        68139
      ],
      [
        -11,
        1
      ],
      [
        -6,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -60,
        0
      ]
    ],
    [
      [
        25069,
        68139
      ],
      [
        -120,
        -1
      ]
    ],
    [
      [
        24949,
        68138
      ],
      [
        0,
        307
      ]
    ],
    [
      [
        26290,
        59549
      ],
      [
        2,
        0
      ]
    ],
    [
      [
        26292,
        59549
      ],
      [
        43,
        -5
      ],
      [
        22,
        -4
      ],
      [
        12,
        1
      ],
      [
        16,
        -1
      ],
      [
        48,
        -5
      ],
      [
        3,
        0
      ]
    ],
    [
      [
        26436,
        59535
      ],
      [
        -1,
        -29
      ],
      [
        4,
        -2
      ],
      [
        0,
        -36
      ],
      [
        -5,
        -26
      ],
      [
        -5,
        -9
      ],
      [
        -12,
        6
      ],
      [
        -3,
        -51
      ],
      [
        -3,
        1
      ],
      [
        2,
        -59
      ],
      [
        9,
        -36
      ],
      [
        -7,
        4
      ],
      [
        2,
        -120
      ],
      [
        -1,
        -8
      ],
      [
        -8,
        -7
      ],
      [
        -4,
        -14
      ],
      [
        1,
        -50
      ]
    ],
    [
      [
        26405,
        59099
      ],
      [
        -6,
        -18
      ],
      [
        -3,
        -31
      ],
      [
        -10,
        -13
      ]
    ],
    [
      [
        26386,
        59037
      ],
      [
        -8,
        33
      ],
      [
        -1,
        14
      ],
      [
        -22,
        35
      ],
      [
        -6,
        -5
      ],
      [
        1,
        8
      ],
      [
        -1,
        35
      ],
      [
        -5,
        11
      ],
      [
        -6,
        -7
      ],
      [
        -25,
        117
      ]
    ],
    [
      [
        26313,
        59278
      ],
      [
        5,
        20
      ],
      [
        7,
        8
      ],
      [
        -9,
        47
      ],
      [
        -7,
        74
      ],
      [
        -4,
        30
      ]
    ],
    [
      [
        26305,
        59457
      ],
      [
        -15,
        92
      ]
    ],
    [
      [
        24405,
        70670
      ],
      [
        87,
        1
      ],
      [
        87,
        -4
      ]
    ],
    [
      [
        24579,
        70667
      ],
      [
        0,
        -202
      ],
      [
        69,
        1
      ]
    ],
    [
      [
        24648,
        70466
      ],
      [
        0,
        -400
      ]
    ],
    [
      [
        24648,
        70066
      ],
      [
        -240,
        -1
      ]
    ],
    [
      [
        24408,
        70065
      ],
      [
        -1,
        402
      ],
      [
        -2,
        1
      ],
      [
        0,
        202
      ]
    ],
    [
      [
        26205,
        67942
      ],
      [
        135,
        2
      ]
    ],
    [
      [
        26340,
        67944
      ],
      [
        -1,
        -407
      ]
    ],
    [
      [
        26339,
        67537
      ],
      [
        -66,
        0
      ]
    ],
    [
      [
        26273,
        67537
      ],
      [
        -67,
        0
      ]
    ],
    [
      [
        26206,
        67537
      ],
      [
        -1,
        405
      ]
    ],
    [
      [
        25021,
        52921
      ],
      [
        56,
        0
      ]
    ],
    [
      [
        25077,
        52921
      ],
      [
        71,
        1
      ]
    ],
    [
      [
        25148,
        52922
      ],
      [
        0,
        -204
      ]
    ],
    [
      [
        25148,
        52718
      ],
      [
        0,
        -68
      ]
    ],
    [
      [
        25148,
        52650
      ],
      [
        -99,
        0
      ],
      [
        -2,
        -34
      ],
      [
        -2,
        -1
      ],
      [
        -6,
        1
      ],
      [
        -19,
        0
      ]
    ],
    [
      [
        25020,
        52616
      ],
      [
        1,
        55
      ],
      [
        0,
        250
      ]
    ],
    [
      [
        24974,
        56707
      ],
      [
        73,
        -1
      ]
    ],
    [
      [
        25047,
        56706
      ],
      [
        1,
        -102
      ],
      [
        29,
        1
      ]
    ],
    [
      [
        25062,
        56214
      ],
      [
        0,
        -19
      ],
      [
        -56,
        -1
      ],
      [
        -32,
        0
      ]
    ],
    [
      [
        24974,
        56194
      ],
      [
        0,
        170
      ]
    ],
    [
      [
        24974,
        56364
      ],
      [
        0,
        343
      ]
    ],
    [
      [
        21815,
        65933
      ],
      [
        161,
        -2
      ]
    ],
    [
      [
        21976,
        65931
      ],
      [
        1,
        -403
      ]
    ],
    [
      [
        21977,
        65528
      ],
      [
        -124,
        0
      ]
    ],
    [
      [
        21853,
        65528
      ],
      [
        -37,
        1
      ]
    ],
    [
      [
        21816,
        65529
      ],
      [
        -1,
        404
      ]
    ],
    [
      [
        21724,
        54800
      ],
      [
        0,
        4
      ]
    ],
    [
      [
        21724,
        54804
      ],
      [
        143,
        -2
      ]
    ],
    [
      [
        21867,
        54802
      ],
      [
        -1,
        -512
      ]
    ],
    [
      [
        21866,
        54290
      ],
      [
        -44,
        1
      ]
    ],
    [
      [
        21822,
        54291
      ],
      [
        -101,
        1
      ]
    ],
    [
      [
        21721,
        54292
      ],
      [
        3,
        508
      ]
    ],
    [
      [
        20140,
        64670
      ],
      [
        113,
        -1
      ],
      [
        6,
        0
      ],
      [
        11,
        -1
      ],
      [
        2,
        0
      ],
      [
        18,
        -2
      ]
    ],
    [
      [
        20290,
        64666
      ],
      [
        29,
        -2
      ],
      [
        7,
        0
      ]
    ],
    [
      [
        20326,
        64664
      ],
      [
        -1,
        -9
      ],
      [
        3,
        -40
      ],
      [
        -1,
        -21
      ],
      [
        5,
        -22
      ],
      [
        9,
        -20
      ],
      [
        3,
        -37
      ],
      [
        5,
        -7
      ],
      [
        0,
        -13
      ],
      [
        6,
        -22
      ],
      [
        6,
        -14
      ],
      [
        5,
        -20
      ],
      [
        1,
        -15
      ],
      [
        4,
        -21
      ],
      [
        5,
        -38
      ],
      [
        4,
        -9
      ],
      [
        2,
        -27
      ],
      [
        5,
        -18
      ],
      [
        0,
        -15
      ],
      [
        7,
        -46
      ],
      [
        1,
        -38
      ],
      [
        4,
        -4
      ],
      [
        2,
        -39
      ],
      [
        3,
        -7
      ],
      [
        2,
        -36
      ],
      [
        -1,
        -23
      ],
      [
        11,
        6
      ],
      [
        4,
        -17
      ],
      [
        0,
        -23
      ]
    ],
    [
      [
        20420,
        64069
      ],
      [
        -3,
        -7
      ],
      [
        -4,
        -3
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -17
      ],
      [
        0,
        -22
      ],
      [
        1,
        -16
      ],
      [
        -1,
        -14
      ],
      [
        -2,
        -11
      ],
      [
        -1,
        1
      ],
      [
        -4,
        -11
      ],
      [
        -5,
        -8
      ],
      [
        0,
        -12
      ],
      [
        1,
        -3
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -4
      ],
      [
        -3,
        -6
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -3
      ],
      [
        -2,
        0
      ],
      [
        -2,
        2
      ],
      [
        -2,
        9
      ],
      [
        -3,
        7
      ],
      [
        -3,
        -2
      ],
      [
        -3,
        1
      ],
      [
        0,
        8
      ],
      [
        -4,
        1
      ],
      [
        -6,
        -13
      ],
      [
        -7,
        -11
      ],
      [
        -5,
        0
      ],
      [
        -7,
        -5
      ],
      [
        -3,
        -9
      ],
      [
        -2,
        -6
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        2
      ],
      [
        -3,
        8
      ],
      [
        -2,
        5
      ],
      [
        -3,
        -2
      ],
      [
        -1,
        -9
      ],
      [
        -3,
        -9
      ],
      [
        -2,
        1
      ],
      [
        -2,
        1
      ],
      [
        -2,
        0
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        4
      ],
      [
        -2,
        9
      ],
      [
        -2,
        6
      ],
      [
        0,
        7
      ],
      [
        -1,
        8
      ],
      [
        -1,
        4
      ],
      [
        -2,
        3
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -7
      ],
      [
        1,
        -7
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        -4,
        0
      ],
      [
        -1,
        4
      ],
      [
        -2,
        5
      ],
      [
        -3,
        1
      ],
      [
        -1,
        3
      ],
      [
        -1,
        5
      ],
      [
        -1,
        5
      ],
      [
        -1,
        5
      ],
      [
        -2,
        4
      ],
      [
        -3,
        -2
      ],
      [
        -3,
        -1
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        2
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        3
      ],
      [
        -1,
        3
      ],
      [
        -3,
        2
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        5
      ],
      [
        -2,
        8
      ],
      [
        -2,
        11
      ],
      [
        -2,
        13
      ],
      [
        -2,
        12
      ],
      [
        0,
        13
      ],
      [
        -4,
        9
      ],
      [
        -2,
        -6
      ],
      [
        -2,
        -8
      ],
      [
        -2,
        -9
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        2
      ],
      [
        -1,
        4
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        4
      ],
      [
        0,
        2
      ],
      [
        -2,
        1
      ],
      [
        -3,
        1
      ],
      [
        -3,
        4
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        2
      ],
      [
        0,
        4
      ],
      [
        -1,
        9
      ],
      [
        -1,
        12
      ],
      [
        -1,
        11
      ],
      [
        -1,
        8
      ],
      [
        0,
        14
      ],
      [
        -2,
        5
      ],
      [
        -5,
        10
      ],
      [
        0,
        5
      ]
    ],
    [
      [
        20198,
        64021
      ],
      [
        -2,
        7
      ],
      [
        0,
        16
      ],
      [
        -2,
        6
      ],
      [
        0,
        8
      ],
      [
        1,
        5
      ],
      [
        1,
        10
      ],
      [
        1,
        9
      ],
      [
        0,
        14
      ],
      [
        -1,
        6
      ],
      [
        -3,
        6
      ],
      [
        -1,
        9
      ],
      [
        1,
        8
      ],
      [
        -3,
        10
      ],
      [
        -1,
        2
      ],
      [
        -1,
        5
      ],
      [
        -2,
        17
      ],
      [
        -2,
        14
      ],
      [
        0,
        7
      ],
      [
        1,
        8
      ],
      [
        1,
        11
      ],
      [
        -2,
        8
      ],
      [
        -1,
        13
      ],
      [
        1,
        12
      ],
      [
        1,
        5
      ],
      [
        3,
        12
      ],
      [
        1,
        10
      ],
      [
        -2,
        13
      ],
      [
        2,
        18
      ],
      [
        0,
        4
      ],
      [
        1,
        6
      ],
      [
        2,
        3
      ],
      [
        1,
        11
      ],
      [
        -1,
        13
      ],
      [
        1,
        14
      ],
      [
        0,
        13
      ],
      [
        -1,
        7
      ],
      [
        2,
        11
      ],
      [
        1,
        8
      ],
      [
        -2,
        6
      ],
      [
        1,
        8
      ],
      [
        1,
        6
      ],
      [
        3,
        6
      ],
      [
        0,
        5
      ],
      [
        3,
        7
      ],
      [
        1,
        11
      ],
      [
        0,
        20
      ],
      [
        -2,
        10
      ],
      [
        -3,
        2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        3
      ],
      [
        -1,
        3
      ],
      [
        0,
        5
      ],
      [
        1,
        7
      ],
      [
        1,
        6
      ],
      [
        0,
        8
      ],
      [
        -1,
        5
      ],
      [
        -1,
        3
      ],
      [
        -1,
        8
      ],
      [
        -3,
        3
      ],
      [
        -1,
        8
      ],
      [
        -1,
        9
      ],
      [
        -1,
        5
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -8
      ],
      [
        -7,
        -4
      ],
      [
        -2,
        2
      ],
      [
        -1,
        6
      ],
      [
        0,
        15
      ],
      [
        -2,
        2
      ],
      [
        -2,
        0
      ],
      [
        -2,
        3
      ],
      [
        -1,
        4
      ],
      [
        -1,
        6
      ],
      [
        -2,
        2
      ],
      [
        -2,
        -4
      ],
      [
        0,
        -3
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        3
      ],
      [
        1,
        2
      ],
      [
        -1,
        9
      ],
      [
        -2,
        8
      ],
      [
        -1,
        5
      ],
      [
        -1,
        8
      ],
      [
        0,
        2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        7
      ],
      [
        -1,
        5
      ],
      [
        -2,
        5
      ],
      [
        0,
        8
      ],
      [
        -1,
        9
      ],
      [
        -1,
        6
      ],
      [
        -1,
        12
      ],
      [
        1,
        11
      ],
      [
        3,
        4
      ],
      [
        1,
        3
      ],
      [
        0,
        3
      ],
      [
        1,
        5
      ],
      [
        -2,
        3
      ],
      [
        0,
        9
      ]
    ],
    [
      [
        24126,
        67577
      ],
      [
        29,
        0
      ]
    ],
    [
      [
        24155,
        67577
      ],
      [
        11,
        1
      ],
      [
        1,
        -1
      ],
      [
        57,
        0
      ],
      [
        6,
        1
      ],
      [
        28,
        0
      ]
    ],
    [
      [
        24258,
        67578
      ],
      [
        -1,
        -286
      ],
      [
        0,
        -49
      ]
    ],
    [
      [
        24257,
        67243
      ],
      [
        -132,
        0
      ]
    ],
    [
      [
        24125,
        67243
      ],
      [
        1,
        334
      ]
    ],
    [
      [
        26754,
        67376
      ],
      [
        4,
        0
      ],
      [
        -4,
        405
      ]
    ],
    [
      [
        26754,
        67781
      ],
      [
        143,
        18
      ]
    ],
    [
      [
        26897,
        67799
      ],
      [
        0,
        -25
      ],
      [
        2,
        -77
      ],
      [
        0,
        -15
      ],
      [
        1,
        -10
      ],
      [
        3,
        -44
      ],
      [
        5,
        -48
      ],
      [
        0,
        -7
      ],
      [
        4,
        -38
      ],
      [
        4,
        -31
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -11
      ],
      [
        2,
        -63
      ],
      [
        -1,
        -22
      ],
      [
        2,
        -18
      ],
      [
        0,
        -32
      ],
      [
        2,
        -94
      ],
      [
        1,
        -15
      ],
      [
        3,
        -18
      ],
      [
        2,
        -33
      ]
    ],
    [
      [
        26926,
        67191
      ],
      [
        -12,
        -1
      ],
      [
        -126,
        -16
      ]
    ],
    [
      [
        26169,
        63944
      ],
      [
        3,
        0
      ],
      [
        0,
        4
      ],
      [
        1,
        113
      ],
      [
        1,
        1
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        26174,
        64163
      ],
      [
        37,
        1
      ]
    ],
    [
      [
        26211,
        64164
      ],
      [
        74,
        5
      ]
    ],
    [
      [
        26285,
        64169
      ],
      [
        0,
        -256
      ]
    ],
    [
      [
        26285,
        63913
      ],
      [
        0,
        -49
      ]
    ],
    [
      [
        26285,
        63864
      ],
      [
        -116,
        -4
      ]
    ],
    [
      [
        26169,
        63860
      ],
      [
        0,
        84
      ]
    ],
    [
      [
        21488,
        73755
      ],
      [
        0,
        223
      ]
    ],
    [
      [
        21488,
        73978
      ],
      [
        110,
        0
      ],
      [
        35,
        1
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        21634,
        73979
      ],
      [
        0,
        -326
      ],
      [
        13,
        0
      ],
      [
        0,
        -202
      ],
      [
        109,
        -1
      ]
    ],
    [
      [
        21756,
        73450
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        21756,
        73349
      ],
      [
        -73,
        0
      ],
      [
        -73,
        1
      ],
      [
        -72,
        0
      ],
      [
        0,
        303
      ],
      [
        -50,
        1
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        16297,
        70181
      ],
      [
        5,
        10
      ],
      [
        12,
        1
      ],
      [
        9,
        -10
      ],
      [
        10,
        -33
      ],
      [
        5,
        -11
      ],
      [
        6,
        -7
      ],
      [
        22,
        6
      ],
      [
        21,
        14
      ],
      [
        11,
        10
      ],
      [
        2,
        2
      ],
      [
        20,
        5
      ],
      [
        11,
        42
      ],
      [
        8,
        13
      ],
      [
        20,
        14
      ],
      [
        20,
        31
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        16479,
        70269
      ],
      [
        -2,
        -344
      ],
      [
        0,
        -302
      ],
      [
        35,
        -1
      ],
      [
        -1,
        -102
      ],
      [
        35,
        0
      ],
      [
        -1,
        -102
      ],
      [
        -8,
        0
      ],
      [
        0,
        -16
      ]
    ],
    [
      [
        16537,
        69402
      ],
      [
        -33,
        0
      ],
      [
        -11,
        -2
      ],
      [
        -51,
        1
      ],
      [
        -101,
        1
      ]
    ],
    [
      [
        16341,
        69402
      ],
      [
        -3,
        18
      ]
    ],
    [
      [
        16338,
        69420
      ],
      [
        0,
        1
      ],
      [
        -1,
        4
      ],
      [
        -1,
        4
      ],
      [
        0,
        8
      ],
      [
        2,
        6
      ],
      [
        1,
        1
      ],
      [
        3,
        2
      ],
      [
        3,
        2
      ],
      [
        2,
        3
      ],
      [
        1,
        -5
      ],
      [
        1,
        -5
      ],
      [
        1,
        3
      ],
      [
        0,
        5
      ],
      [
        1,
        10
      ],
      [
        -1,
        9
      ],
      [
        0,
        11
      ],
      [
        2,
        6
      ],
      [
        1,
        6
      ],
      [
        -1,
        1
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        3
      ],
      [
        -2,
        2
      ],
      [
        -1,
        6
      ],
      [
        1,
        6
      ],
      [
        1,
        4
      ],
      [
        -2,
        6
      ],
      [
        -1,
        2
      ],
      [
        0,
        4
      ],
      [
        1,
        2
      ],
      [
        0,
        6
      ],
      [
        -1,
        0
      ],
      [
        -2,
        5
      ],
      [
        1,
        3
      ],
      [
        1,
        6
      ],
      [
        -2,
        6
      ],
      [
        -3,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        1
      ],
      [
        -2,
        3
      ],
      [
        -1,
        3
      ],
      [
        0,
        2
      ],
      [
        -1,
        2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        0,
        4
      ],
      [
        -1,
        3
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        1
      ],
      [
        0,
        6
      ],
      [
        2,
        1
      ],
      [
        1,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        -1,
        4
      ],
      [
        -1,
        1
      ],
      [
        -2,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        0,
        4
      ],
      [
        1,
        5
      ],
      [
        0,
        3
      ],
      [
        -1,
        3
      ],
      [
        -1,
        3
      ],
      [
        -1,
        3
      ],
      [
        0,
        9
      ],
      [
        -1,
        2
      ],
      [
        0,
        3
      ],
      [
        1,
        1
      ],
      [
        3,
        0
      ],
      [
        2,
        2
      ],
      [
        0,
        7
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        1
      ],
      [
        0,
        3
      ],
      [
        1,
        6
      ],
      [
        1,
        4
      ],
      [
        0,
        6
      ],
      [
        -1,
        2
      ],
      [
        -2,
        -1
      ],
      [
        0,
        4
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        4
      ],
      [
        -1,
        4
      ],
      [
        -1,
        6
      ],
      [
        0,
        4
      ],
      [
        1,
        5
      ],
      [
        1,
        0
      ],
      [
        1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        1,
        -3
      ],
      [
        1,
        0
      ],
      [
        1,
        2
      ],
      [
        1,
        4
      ],
      [
        0,
        5
      ],
      [
        -2,
        3
      ],
      [
        -2,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        5
      ],
      [
        2,
        2
      ],
      [
        2,
        4
      ],
      [
        0,
        6
      ],
      [
        -2,
        3
      ],
      [
        -1,
        0
      ],
      [
        -1,
        2
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        8
      ],
      [
        -1,
        5
      ],
      [
        -1,
        0
      ],
      [
        -1,
        4
      ],
      [
        1,
        3
      ],
      [
        1,
        3
      ],
      [
        0,
        6
      ],
      [
        1,
        7
      ],
      [
        -1,
        3
      ],
      [
        0,
        5
      ],
      [
        2,
        1
      ],
      [
        1,
        2
      ],
      [
        1,
        4
      ],
      [
        2,
        1
      ],
      [
        -1,
        4
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -1
      ],
      [
        0,
        7
      ],
      [
        1,
        4
      ],
      [
        0,
        9
      ],
      [
        -1,
        6
      ],
      [
        2,
        3
      ],
      [
        1,
        -1
      ],
      [
        3,
        4
      ],
      [
        0,
        5
      ],
      [
        1,
        6
      ],
      [
        2,
        1
      ],
      [
        1,
        -1
      ],
      [
        2,
        1
      ],
      [
        0,
        7
      ],
      [
        -1,
        3
      ],
      [
        -4,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        5
      ],
      [
        2,
        2
      ],
      [
        2,
        1
      ],
      [
        2,
        2
      ],
      [
        -1,
        6
      ],
      [
        -1,
        2
      ],
      [
        -1,
        7
      ],
      [
        2,
        5
      ],
      [
        1,
        2
      ],
      [
        0,
        7
      ],
      [
        -2,
        1
      ],
      [
        -1,
        2
      ],
      [
        1,
        5
      ],
      [
        4,
        6
      ],
      [
        2,
        4
      ],
      [
        1,
        1
      ],
      [
        2,
        4
      ],
      [
        1,
        3
      ],
      [
        2,
        1
      ],
      [
        1,
        -4
      ],
      [
        2,
        -8
      ],
      [
        3,
        -4
      ],
      [
        1,
        -3
      ],
      [
        3,
        1
      ],
      [
        1,
        7
      ],
      [
        0,
        5
      ],
      [
        -4,
        4
      ],
      [
        0,
        10
      ],
      [
        -1,
        5
      ],
      [
        1,
        4
      ],
      [
        1,
        1
      ],
      [
        2,
        -2
      ],
      [
        4,
        -2
      ],
      [
        3,
        0
      ],
      [
        2,
        -3
      ],
      [
        1,
        -1
      ],
      [
        1,
        1
      ],
      [
        2,
        2
      ],
      [
        0,
        5
      ],
      [
        1,
        4
      ],
      [
        0,
        9
      ],
      [
        -1,
        5
      ],
      [
        -2,
        2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        5
      ],
      [
        1,
        6
      ],
      [
        1,
        3
      ],
      [
        2,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        3
      ],
      [
        -1,
        3
      ],
      [
        -2,
        2
      ],
      [
        -3,
        0
      ],
      [
        -1,
        3
      ],
      [
        -1,
        5
      ],
      [
        0,
        5
      ],
      [
        -1,
        2
      ],
      [
        -2,
        3
      ],
      [
        -1,
        3
      ],
      [
        -2,
        4
      ],
      [
        1,
        6
      ],
      [
        1,
        4
      ],
      [
        -1,
        10
      ],
      [
        -1,
        7
      ],
      [
        0,
        14
      ],
      [
        -2,
        3
      ],
      [
        -1,
        1
      ],
      [
        -3,
        -1
      ],
      [
        -1,
        3
      ],
      [
        -2,
        6
      ],
      [
        -1,
        7
      ],
      [
        0,
        8
      ],
      [
        1,
        4
      ],
      [
        0,
        5
      ],
      [
        -1,
        2
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        2
      ],
      [
        0,
        3
      ],
      [
        -1,
        3
      ],
      [
        -1,
        1
      ],
      [
        0,
        5
      ],
      [
        -1,
        3
      ],
      [
        -1,
        1
      ],
      [
        0,
        5
      ],
      [
        2,
        2
      ],
      [
        -1,
        3
      ],
      [
        0,
        2
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        9
      ],
      [
        1,
        2
      ],
      [
        -1,
        3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        2
      ],
      [
        -1,
        3
      ],
      [
        0,
        1
      ],
      [
        -1,
        3
      ],
      [
        -3,
        4
      ],
      [
        -3,
        5
      ],
      [
        -3,
        -1
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        6
      ],
      [
        -2,
        8
      ],
      [
        -2,
        9
      ],
      [
        -3,
        9
      ],
      [
        -4,
        5
      ],
      [
        -3,
        6
      ],
      [
        -2,
        11
      ],
      [
        -4,
        6
      ],
      [
        -3,
        -1
      ],
      [
        -3,
        4
      ],
      [
        -1,
        8
      ],
      [
        0,
        3
      ],
      [
        -1,
        4
      ]
    ],
    [
      [
        23550,
        59739
      ],
      [
        153,
        -22
      ]
    ],
    [
      [
        23703,
        59717
      ],
      [
        1,
        -11
      ],
      [
        -3,
        -279
      ]
    ],
    [
      [
        23701,
        59427
      ],
      [
        -29,
        0
      ],
      [
        -24,
        1
      ],
      [
        -26,
        0
      ],
      [
        -44,
        -1
      ],
      [
        -11,
        1
      ],
      [
        -17,
        0
      ]
    ],
    [
      [
        23550,
        59428
      ],
      [
        0,
        196
      ]
    ],
    [
      [
        23550,
        59624
      ],
      [
        0,
        115
      ]
    ],
    [
      [
        21199,
        55806
      ],
      [
        129,
        0
      ]
    ],
    [
      [
        21328,
        55806
      ],
      [
        0,
        -500
      ]
    ],
    [
      [
        21328,
        55306
      ],
      [
        -131,
        1
      ]
    ],
    [
      [
        21197,
        55307
      ],
      [
        0,
        96
      ],
      [
        1,
        115
      ],
      [
        0,
        134
      ],
      [
        1,
        5
      ],
      [
        0,
        149
      ]
    ],
    [
      [
        21935,
        57388
      ],
      [
        116,
        -1
      ]
    ],
    [
      [
        22051,
        57387
      ],
      [
        0,
        -216
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        22052,
        57171
      ],
      [
        0,
        -290
      ]
    ],
    [
      [
        21935,
        56883
      ],
      [
        0,
        505
      ]
    ],
    [
      [
        26257,
        56263
      ],
      [
        7,
        -7
      ],
      [
        13,
        2
      ],
      [
        2,
        3
      ],
      [
        7,
        1
      ],
      [
        2,
        4
      ],
      [
        7,
        4
      ],
      [
        7,
        1
      ],
      [
        3,
        1
      ],
      [
        2,
        0
      ],
      [
        0,
        21
      ]
    ],
    [
      [
        26307,
        56293
      ],
      [
        2,
        0
      ],
      [
        6,
        -1
      ],
      [
        10,
        0
      ],
      [
        10,
        -1
      ],
      [
        1,
        -4
      ],
      [
        11,
        -60
      ],
      [
        1,
        -7
      ]
    ],
    [
      [
        26348,
        56220
      ],
      [
        -2,
        -15
      ],
      [
        -6,
        -16
      ],
      [
        -8,
        -21
      ],
      [
        1,
        -7
      ],
      [
        -6,
        -11
      ],
      [
        -1,
        -24
      ],
      [
        -2,
        -7
      ],
      [
        -4,
        -2
      ],
      [
        -15,
        -22
      ],
      [
        -1,
        -14
      ],
      [
        -2,
        -1
      ],
      [
        -3,
        8
      ],
      [
        -3,
        -19
      ],
      [
        -6,
        -12
      ],
      [
        -6,
        -20
      ],
      [
        -1,
        -15
      ]
    ],
    [
      [
        26283,
        56022
      ],
      [
        -27,
        0
      ],
      [
        1,
        76
      ],
      [
        0,
        97
      ],
      [
        -2,
        10
      ],
      [
        2,
        0
      ],
      [
        0,
        58
      ]
    ],
    [
      [
        4612,
        90593
      ],
      [
        59,
        -1
      ],
      [
        0,
        -100
      ],
      [
        53,
        0
      ],
      [
        0,
        -101
      ],
      [
        53,
        0
      ],
      [
        0,
        -101
      ],
      [
        319,
        0
      ]
    ],
    [
      [
        5096,
        90290
      ],
      [
        0,
        -15
      ],
      [
        -24,
        0
      ],
      [
        0,
        -117
      ],
      [
        -15,
        0
      ],
      [
        0,
        -403
      ],
      [
        -14,
        0
      ],
      [
        0,
        -403
      ],
      [
        36,
        0
      ],
      [
        0,
        -303
      ],
      [
        107,
        0
      ]
    ],
    [
      [
        5186,
        89049
      ],
      [
        1,
        -23
      ],
      [
        8,
        -39
      ],
      [
        9,
        -27
      ],
      [
        9,
        -13
      ],
      [
        11,
        -8
      ],
      [
        21,
        -6
      ],
      [
        10,
        3
      ],
      [
        9,
        10
      ],
      [
        2,
        -19
      ],
      [
        16,
        -7
      ],
      [
        0,
        -8
      ],
      [
        -4,
        -21
      ],
      [
        -17,
        9
      ],
      [
        -24,
        1
      ],
      [
        -15,
        -7
      ],
      [
        -16,
        -15
      ],
      [
        -38,
        -46
      ],
      [
        -24,
        -10
      ],
      [
        -25,
        -15
      ],
      [
        -27,
        -29
      ],
      [
        -23,
        -33
      ],
      [
        -21,
        -37
      ],
      [
        -16,
        -45
      ],
      [
        -11,
        -18
      ],
      [
        -42,
        -14
      ],
      [
        -14,
        -8
      ],
      [
        -34,
        -14
      ],
      [
        -25,
        -29
      ],
      [
        -17,
        -12
      ],
      [
        -18,
        0
      ],
      [
        -9,
        -4
      ],
      [
        -12,
        -14
      ],
      [
        -45,
        -44
      ],
      [
        -16,
        1
      ],
      [
        -15,
        -5
      ],
      [
        -12,
        6
      ],
      [
        -20,
        18
      ],
      [
        -26,
        14
      ],
      [
        -13,
        1
      ],
      [
        -17,
        9
      ],
      [
        -11,
        -16
      ],
      [
        -9,
        -6
      ],
      [
        -21,
        6
      ],
      [
        2,
        45
      ],
      [
        -11,
        16
      ],
      [
        -59,
        -23
      ],
      [
        -10,
        7
      ],
      [
        -26,
        -51
      ],
      [
        -4,
        -6
      ],
      [
        -15,
        -10
      ],
      [
        -12,
        -3
      ],
      [
        -29,
        -3
      ],
      [
        -10,
        -7
      ],
      [
        -11,
        -19
      ],
      [
        -9,
        -10
      ],
      [
        -34,
        8
      ],
      [
        -18,
        21
      ],
      [
        -11,
        -13
      ],
      [
        -3,
        24
      ],
      [
        -6,
        0
      ],
      [
        0,
        -25
      ],
      [
        -5,
        -18
      ],
      [
        -11,
        -16
      ],
      [
        6,
        -12
      ],
      [
        -1,
        -16
      ],
      [
        -17,
        -9
      ],
      [
        -3,
        -23
      ],
      [
        6,
        -20
      ],
      [
        -1,
        -11
      ],
      [
        -23,
        -21
      ],
      [
        -14,
        -1
      ],
      [
        -10,
        16
      ],
      [
        -4,
        0
      ],
      [
        -22,
        20
      ],
      [
        -10,
        -13
      ],
      [
        -15,
        15
      ],
      [
        -16,
        -4
      ],
      [
        -17,
        8
      ],
      [
        0,
        -25
      ],
      [
        -4,
        -32
      ],
      [
        9,
        -23
      ],
      [
        -4,
        -22
      ],
      [
        3,
        -26
      ],
      [
        -1,
        -22
      ],
      [
        10,
        14
      ],
      [
        6,
        -8
      ],
      [
        3,
        -30
      ],
      [
        -2,
        -14
      ],
      [
        -21,
        -22
      ],
      [
        -6,
        1
      ],
      [
        -17,
        -38
      ],
      [
        1,
        -19
      ],
      [
        -13,
        -19
      ],
      [
        -2,
        16
      ],
      [
        -8,
        14
      ],
      [
        -12,
        -2
      ],
      [
        -8,
        -35
      ],
      [
        9,
        -13
      ],
      [
        -4,
        -32
      ],
      [
        6,
        -13
      ],
      [
        12,
        4
      ],
      [
        -2,
        -61
      ],
      [
        -18,
        -18
      ],
      [
        -6,
        -23
      ],
      [
        -12,
        -1
      ],
      [
        -5,
        -13
      ],
      [
        -10,
        4
      ],
      [
        -15,
        -7
      ],
      [
        -6,
        -26
      ],
      [
        -10,
        8
      ],
      [
        -22,
        -19
      ],
      [
        -13,
        6
      ],
      [
        -8,
        -3
      ],
      [
        -3,
        10
      ],
      [
        -1,
        32
      ],
      [
        -16,
        -3
      ],
      [
        0,
        -9
      ],
      [
        -8,
        15
      ],
      [
        -6,
        2
      ],
      [
        -1,
        -15
      ],
      [
        -7,
        9
      ],
      [
        -4,
        -4
      ],
      [
        -8,
        9
      ],
      [
        -16,
        -15
      ],
      [
        -9,
        -3
      ],
      [
        -14,
        -16
      ],
      [
        -15,
        -6
      ],
      [
        -3,
        18
      ],
      [
        -35,
        -50
      ]
    ],
    [
      [
        3906,
        87856
      ],
      [
        -1,
        2
      ],
      [
        -12,
        20
      ],
      [
        -6,
        40
      ],
      [
        0,
        7
      ],
      [
        2,
        3
      ],
      [
        15,
        33
      ],
      [
        5,
        6
      ],
      [
        5,
        0
      ],
      [
        1,
        -2
      ],
      [
        3,
        -2
      ],
      [
        18,
        -2
      ],
      [
        6,
        3
      ],
      [
        10,
        12
      ],
      [
        3,
        8
      ],
      [
        0,
        45
      ],
      [
        -12,
        3
      ],
      [
        -5,
        -24
      ],
      [
        -13,
        10
      ],
      [
        -17,
        22
      ],
      [
        -13,
        40
      ],
      [
        -2,
        9
      ],
      [
        -1,
        5
      ],
      [
        3,
        9
      ],
      [
        0,
        4
      ],
      [
        -1,
        10
      ],
      [
        -1,
        2
      ],
      [
        -8,
        4
      ],
      [
        -11,
        1
      ],
      [
        -13,
        35
      ],
      [
        -5,
        1
      ],
      [
        -5,
        -15
      ],
      [
        -11,
        -68
      ],
      [
        -1,
        -31
      ],
      [
        -5,
        -5
      ],
      [
        -9,
        -1
      ],
      [
        -11,
        5
      ],
      [
        -27,
        11
      ],
      [
        -10,
        21
      ],
      [
        -10,
        66
      ],
      [
        1,
        29
      ],
      [
        -3,
        33
      ],
      [
        0,
        19
      ],
      [
        2,
        24
      ],
      [
        2,
        13
      ],
      [
        -1,
        11
      ],
      [
        -4,
        8
      ],
      [
        -7,
        11
      ],
      [
        -35,
        18
      ],
      [
        -6,
        -4
      ],
      [
        -2,
        -4
      ],
      [
        -4,
        4
      ],
      [
        -8,
        14
      ],
      [
        -6,
        19
      ],
      [
        -10,
        61
      ],
      [
        -1,
        18
      ],
      [
        0,
        8
      ],
      [
        1,
        11
      ],
      [
        20,
        25
      ],
      [
        13,
        10
      ],
      [
        2,
        1
      ],
      [
        7,
        8
      ],
      [
        5,
        23
      ],
      [
        1,
        15
      ],
      [
        -3,
        10
      ],
      [
        -14,
        36
      ],
      [
        -17,
        7
      ],
      [
        -13,
        24
      ],
      [
        -14,
        0
      ],
      [
        -5,
        -5
      ],
      [
        -1,
        -6
      ],
      [
        -4,
        -8
      ],
      [
        -10,
        -5
      ],
      [
        -11,
        -3
      ],
      [
        -4,
        -11
      ],
      [
        4,
        -25
      ],
      [
        0,
        -10
      ],
      [
        -9,
        -1
      ],
      [
        -7,
        14
      ],
      [
        -5,
        10
      ],
      [
        -2,
        33
      ],
      [
        -2,
        11
      ],
      [
        -4,
        28
      ],
      [
        -1,
        8
      ],
      [
        0,
        8
      ],
      [
        7,
        130
      ],
      [
        1,
        17
      ],
      [
        3,
        11
      ],
      [
        3,
        0
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -15
      ],
      [
        -1,
        -48
      ],
      [
        0,
        -41
      ],
      [
        2,
        -1
      ],
      [
        22,
        8
      ],
      [
        6,
        3
      ],
      [
        5,
        6
      ],
      [
        13,
        10
      ],
      [
        18,
        10
      ],
      [
        22,
        9
      ],
      [
        4,
        2
      ],
      [
        0,
        19
      ],
      [
        -13,
        2
      ],
      [
        -22,
        18
      ],
      [
        -16,
        20
      ],
      [
        -4,
        8
      ],
      [
        -24,
        82
      ],
      [
        0,
        15
      ],
      [
        2,
        3
      ],
      [
        36,
        19
      ],
      [
        24,
        -8
      ],
      [
        31,
        0
      ],
      [
        3,
        2
      ],
      [
        3,
        7
      ],
      [
        0,
        7
      ],
      [
        2,
        3
      ],
      [
        10,
        6
      ],
      [
        15,
        0
      ],
      [
        3,
        17
      ],
      [
        -15,
        38
      ],
      [
        -6,
        26
      ],
      [
        -11,
        53
      ],
      [
        -4,
        46
      ],
      [
        0,
        43
      ],
      [
        3,
        41
      ],
      [
        12,
        40
      ],
      [
        9,
        37
      ],
      [
        15,
        38
      ],
      [
        33,
        96
      ],
      [
        35,
        97
      ],
      [
        10,
        24
      ],
      [
        8,
        23
      ],
      [
        4,
        29
      ],
      [
        8,
        27
      ],
      [
        19,
        50
      ],
      [
        29,
        61
      ],
      [
        5,
        70
      ],
      [
        7,
        18
      ],
      [
        11,
        49
      ],
      [
        3,
        1
      ],
      [
        18,
        33
      ],
      [
        19,
        -4
      ],
      [
        9,
        23
      ],
      [
        -11,
        115
      ],
      [
        0,
        26
      ],
      [
        7,
        38
      ],
      [
        4,
        15
      ],
      [
        7,
        60
      ],
      [
        8,
        49
      ],
      [
        5,
        14
      ],
      [
        13,
        56
      ],
      [
        9,
        19
      ],
      [
        29,
        42
      ],
      [
        0,
        14
      ],
      [
        -8,
        9
      ],
      [
        -8,
        -6
      ],
      [
        -1,
        2
      ],
      [
        -1,
        5
      ],
      [
        2,
        14
      ],
      [
        2,
        8
      ],
      [
        39,
        93
      ],
      [
        19,
        40
      ],
      [
        17,
        16
      ],
      [
        43,
        30
      ],
      [
        19,
        9
      ],
      [
        20,
        3
      ],
      [
        9,
        -1
      ],
      [
        18,
        -15
      ],
      [
        17,
        -18
      ],
      [
        7,
        -12
      ],
      [
        27,
        -6
      ],
      [
        9,
        0
      ],
      [
        7,
        -5
      ],
      [
        2,
        -3
      ],
      [
        0,
        -4
      ],
      [
        6,
        -22
      ],
      [
        15,
        -35
      ],
      [
        9,
        -20
      ],
      [
        7,
        6
      ],
      [
        17,
        -12
      ],
      [
        3,
        -14
      ],
      [
        3,
        -12
      ],
      [
        9,
        -17
      ],
      [
        12,
        -11
      ],
      [
        4,
        -6
      ],
      [
        15,
        -33
      ],
      [
        14,
        -21
      ],
      [
        51,
        14
      ],
      [
        22,
        10
      ],
      [
        3,
        4
      ],
      [
        12,
        32
      ],
      [
        22,
        36
      ],
      [
        5,
        6
      ],
      [
        16,
        34
      ],
      [
        2,
        5
      ],
      [
        1,
        7
      ],
      [
        -2,
        26
      ],
      [
        1,
        7
      ],
      [
        1,
        6
      ],
      [
        4,
        8
      ],
      [
        14,
        14
      ],
      [
        3,
        0
      ],
      [
        3,
        -4
      ],
      [
        7,
        1
      ],
      [
        10,
        7
      ],
      [
        7,
        11
      ],
      [
        19,
        49
      ]
    ],
    [
      [
        23781,
        65263
      ],
      [
        41,
        0
      ],
      [
        18,
        -1
      ],
      [
        10,
        0
      ],
      [
        28,
        -4
      ],
      [
        5,
        4
      ],
      [
        3,
        -7
      ],
      [
        0,
        -15
      ],
      [
        4,
        11
      ],
      [
        1,
        -18
      ],
      [
        4,
        11
      ],
      [
        3,
        -11
      ],
      [
        5,
        12
      ],
      [
        3,
        -17
      ],
      [
        4,
        10
      ]
    ],
    [
      [
        23910,
        65238
      ],
      [
        0,
        -384
      ]
    ],
    [
      [
        23910,
        64854
      ],
      [
        -64,
        0
      ]
    ],
    [
      [
        23846,
        64854
      ],
      [
        -65,
        1
      ]
    ],
    [
      [
        23781,
        64855
      ],
      [
        0,
        408
      ]
    ],
    [
      [
        22435,
        57513
      ],
      [
        21,
        1
      ],
      [
        44,
        0
      ],
      [
        82,
        -1
      ]
    ],
    [
      [
        22582,
        57513
      ],
      [
        1,
        -16
      ],
      [
        0,
        -186
      ]
    ],
    [
      [
        22583,
        57311
      ],
      [
        -14,
        0
      ],
      [
        0,
        -203
      ]
    ],
    [
      [
        22569,
        57108
      ],
      [
        -29,
        1
      ],
      [
        0,
        -51
      ],
      [
        -14,
        0
      ],
      [
        0,
        -17
      ],
      [
        -59,
        0
      ],
      [
        0,
        -33
      ],
      [
        -29,
        0
      ],
      [
        0,
        -17
      ],
      [
        -14,
        0
      ]
    ],
    [
      [
        22424,
        56991
      ],
      [
        0,
        118
      ],
      [
        -46,
        0
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        22378,
        57210
      ],
      [
        0,
        304
      ],
      [
        57,
        -1
      ]
    ],
    [
      [
        22051,
        58174
      ],
      [
        118,
        -1
      ],
      [
        0,
        102
      ],
      [
        59,
        0
      ]
    ],
    [
      [
        22228,
        58275
      ],
      [
        0,
        -51
      ]
    ],
    [
      [
        22228,
        58224
      ],
      [
        0,
        -51
      ],
      [
        1,
        -253
      ],
      [
        0,
        -102
      ]
    ],
    [
      [
        22229,
        57818
      ],
      [
        -13,
        0
      ],
      [
        0,
        -2
      ]
    ],
    [
      [
        22216,
        57816
      ],
      [
        -9,
        -7
      ],
      [
        -96,
        9
      ],
      [
        0,
        -101
      ],
      [
        -29,
        1
      ]
    ],
    [
      [
        22082,
        57718
      ],
      [
        -31,
        0
      ]
    ],
    [
      [
        22051,
        57718
      ],
      [
        0,
        177
      ]
    ],
    [
      [
        22051,
        57895
      ],
      [
        0,
        279
      ]
    ],
    [
      [
        22246,
        68386
      ],
      [
        18,
        2
      ],
      [
        86,
        0
      ]
    ],
    [
      [
        22350,
        68388
      ],
      [
        0,
        -305
      ]
    ],
    [
      [
        22350,
        68083
      ],
      [
        -112,
        -2
      ],
      [
        -8,
        1
      ]
    ],
    [
      [
        22230,
        68082
      ],
      [
        3,
        33
      ],
      [
        0,
        22
      ],
      [
        -2,
        16
      ],
      [
        -19,
        52
      ],
      [
        -5,
        8
      ],
      [
        -20,
        10
      ],
      [
        -6,
        17
      ],
      [
        -7,
        26
      ],
      [
        -1,
        11
      ],
      [
        2,
        31
      ],
      [
        4,
        26
      ],
      [
        -3,
        24
      ],
      [
        -7,
        25
      ]
    ],
    [
      [
        22245,
        52444
      ],
      [
        95,
        -2
      ]
    ],
    [
      [
        22340,
        52442
      ],
      [
        103,
        2
      ]
    ],
    [
      [
        22443,
        52444
      ],
      [
        1,
        -420
      ]
    ],
    [
      [
        22444,
        52024
      ],
      [
        -92,
        -1
      ]
    ],
    [
      [
        22352,
        52023
      ],
      [
        -106,
        -5
      ],
      [
        -1,
        178
      ]
    ],
    [
      [
        22245,
        52196
      ],
      [
        0,
        248
      ]
    ],
    [
      [
        21761,
        56325
      ],
      [
        145,
        2
      ]
    ],
    [
      [
        21906,
        56327
      ],
      [
        1,
        -510
      ]
    ],
    [
      [
        21907,
        55817
      ],
      [
        -145,
        0
      ]
    ],
    [
      [
        21762,
        55817
      ],
      [
        -1,
        508
      ]
    ],
    [
      [
        22219,
        50280
      ],
      [
        166,
        8
      ]
    ],
    [
      [
        22385,
        50288
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        22385,
        50287
      ],
      [
        0,
        -518
      ],
      [
        -1,
        -168
      ]
    ],
    [
      [
        22384,
        49601
      ],
      [
        -163,
        -32
      ],
      [
        -1,
        195
      ],
      [
        0,
        8
      ]
    ],
    [
      [
        22220,
        49772
      ],
      [
        -1,
        56
      ],
      [
        0,
        452
      ]
    ],
    [
      [
        27676,
        62607
      ],
      [
        33,
        45
      ],
      [
        2,
        1
      ],
      [
        49,
        -63
      ],
      [
        6,
        -25
      ]
    ],
    [
      [
        27766,
        62565
      ],
      [
        5,
        -18
      ],
      [
        7,
        8
      ],
      [
        14,
        8
      ],
      [
        3,
        13
      ],
      [
        5,
        -5
      ],
      [
        6,
        16
      ],
      [
        10,
        -4
      ],
      [
        5,
        -24
      ],
      [
        -5,
        -9
      ],
      [
        -7,
        -39
      ],
      [
        0,
        -34
      ],
      [
        -4,
        -13
      ],
      [
        -2,
        -25
      ],
      [
        6,
        -4
      ],
      [
        5,
        -15
      ],
      [
        5,
        4
      ],
      [
        -4,
        -50
      ],
      [
        -8,
        -71
      ],
      [
        -5,
        -6
      ]
    ],
    [
      [
        27802,
        62297
      ],
      [
        -14,
        11
      ],
      [
        -4,
        -2
      ],
      [
        -20,
        6
      ],
      [
        -3,
        -8
      ],
      [
        -1,
        6
      ],
      [
        -37,
        35
      ],
      [
        -40,
        37
      ],
      [
        2,
        11
      ],
      [
        1,
        35
      ],
      [
        -7,
        36
      ],
      [
        -7,
        9
      ]
    ],
    [
      [
        27672,
        62473
      ],
      [
        -4,
        18
      ],
      [
        3,
        34
      ],
      [
        0,
        40
      ],
      [
        5,
        42
      ]
    ],
    [
      [
        15783,
        64879
      ],
      [
        57,
        3
      ],
      [
        40,
        0
      ],
      [
        6,
        -2
      ],
      [
        190,
        0
      ]
    ],
    [
      [
        16076,
        64880
      ],
      [
        32,
        1
      ]
    ],
    [
      [
        16108,
        64881
      ],
      [
        0,
        -324
      ],
      [
        3,
        0
      ],
      [
        -2,
        -475
      ],
      [
        0,
        -61
      ]
    ],
    [
      [
        16109,
        64021
      ],
      [
        -5,
        5
      ],
      [
        -6,
        -4
      ],
      [
        -36,
        -1
      ]
    ],
    [
      [
        16062,
        64021
      ],
      [
        -7,
        0
      ],
      [
        -13,
        -1
      ],
      [
        -4,
        -10
      ],
      [
        -2,
        -4
      ],
      [
        -4,
        2
      ],
      [
        -3,
        5
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        1
      ],
      [
        0,
        3
      ],
      [
        -2,
        4
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        2
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        -5,
        0
      ],
      [
        -2,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        0
      ],
      [
        -1,
        3
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        0,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        2
      ],
      [
        0,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        -2,
        2
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        1
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        2
      ],
      [
        0,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        4
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        2
      ],
      [
        -3,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        1
      ],
      [
        -3,
        1
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -1
      ],
      [
        -3,
        -4
      ],
      [
        -2,
        0
      ],
      [
        -2,
        -1
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        15896,
        63983
      ],
      [
        0,
        0
      ]
    ],
    [
      [
        15896,
        63983
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        4
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        0
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        1
      ],
      [
        -4,
        -4
      ],
      [
        0,
        -7
      ],
      [
        2,
        0
      ],
      [
        1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -3,
        5
      ],
      [
        -1,
        4
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -4
      ],
      [
        -3,
        5
      ],
      [
        -4,
        5
      ],
      [
        -5,
        -2
      ],
      [
        -4,
        -8
      ],
      [
        -5,
        -5
      ],
      [
        -3,
        4
      ],
      [
        -3,
        -6
      ],
      [
        -5,
        1
      ],
      [
        -3,
        -1
      ],
      [
        -4,
        -3
      ],
      [
        -4,
        2
      ],
      [
        -4,
        -1
      ],
      [
        -4,
        2
      ],
      [
        -4,
        0
      ],
      [
        -3,
        4
      ],
      [
        -4,
        -2
      ],
      [
        -9,
        0
      ],
      [
        -1,
        6
      ],
      [
        -3,
        4
      ],
      [
        -2,
        -4
      ],
      [
        -4,
        2
      ],
      [
        -2,
        8
      ],
      [
        -3,
        2
      ],
      [
        -3,
        1
      ],
      [
        1,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        -3,
        -1
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -8
      ],
      [
        -3,
        1
      ],
      [
        -3,
        -2
      ],
      [
        0,
        -5
      ],
      [
        -4,
        -7
      ],
      [
        -4,
        -10
      ],
      [
        -3,
        -3
      ],
      [
        -3,
        -7
      ],
      [
        -3,
        -5
      ],
      [
        -3,
        -6
      ],
      [
        -4,
        2
      ],
      [
        -3,
        7
      ],
      [
        -2,
        1
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        -2,
        2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        4
      ],
      [
        -3,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        15
      ],
      [
        -1,
        3
      ],
      [
        -1,
        3
      ],
      [
        -2,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -5
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        0,
        2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        -1,
        0
      ],
      [
        0,
        -6
      ],
      [
        -1,
        1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -5
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -4
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ]
    ],
    [
      [
        15661,
        63866
      ],
      [
        0,
        0
      ]
    ],
    [
      [
        15661,
        63866
      ],
      [
        -2,
        0
      ],
      [
        0,
        -2
      ],
      [
        -1,
        0
      ],
      [
        0,
        -3
      ],
      [
        -1,
        0
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -3,
        0
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        2
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        15647,
        63866
      ],
      [
        0,
        0
      ]
    ],
    [
      [
        15647,
        63866
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        0
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        -4
      ],
      [
        -1,
        2
      ]
    ],
    [
      [
        15625,
        63837
      ],
      [
        0,
        16
      ],
      [
        -1,
        2
      ],
      [
        0,
        4
      ],
      [
        1,
        14
      ],
      [
        -1,
        13
      ],
      [
        0,
        7
      ],
      [
        1,
        7
      ],
      [
        1,
        7
      ],
      [
        2,
        0
      ],
      [
        1,
        -1
      ],
      [
        2,
        3
      ],
      [
        0,
        3
      ],
      [
        1,
        9
      ],
      [
        2,
        5
      ],
      [
        3,
        5
      ],
      [
        1,
        11
      ],
      [
        0,
        8
      ],
      [
        3,
        7
      ],
      [
        3,
        8
      ],
      [
        0,
        15
      ],
      [
        1,
        10
      ],
      [
        4,
        0
      ],
      [
        4,
        7
      ],
      [
        4,
        -1
      ],
      [
        3,
        7
      ],
      [
        1,
        10
      ],
      [
        1,
        7
      ],
      [
        4,
        5
      ],
      [
        3,
        -3
      ],
      [
        1,
        -1
      ],
      [
        1,
        2
      ],
      [
        0,
        3
      ],
      [
        1,
        12
      ],
      [
        2,
        6
      ],
      [
        0,
        5
      ],
      [
        1,
        1
      ],
      [
        0,
        4
      ],
      [
        3,
        8
      ],
      [
        3,
        2
      ],
      [
        3,
        4
      ],
      [
        2,
        8
      ],
      [
        -1,
        6
      ],
      [
        1,
        8
      ],
      [
        1,
        2
      ],
      [
        2,
        1
      ],
      [
        2,
        1
      ],
      [
        4,
        3
      ],
      [
        4,
        2
      ],
      [
        2,
        9
      ],
      [
        3,
        15
      ],
      [
        0,
        12
      ],
      [
        2,
        7
      ],
      [
        2,
        7
      ],
      [
        2,
        1
      ],
      [
        2,
        -1
      ],
      [
        3,
        3
      ],
      [
        0,
        8
      ],
      [
        4,
        9
      ],
      [
        3,
        0
      ],
      [
        3,
        -3
      ],
      [
        2,
        2
      ],
      [
        1,
        7
      ],
      [
        0,
        6
      ],
      [
        -1,
        9
      ],
      [
        -1,
        3
      ],
      [
        0,
        5
      ],
      [
        -1,
        7
      ],
      [
        0,
        7
      ],
      [
        -1,
        4
      ],
      [
        0,
        17
      ],
      [
        -2,
        8
      ],
      [
        -2,
        0
      ],
      [
        -2,
        1
      ],
      [
        -1,
        4
      ],
      [
        0,
        4
      ],
      [
        1,
        5
      ],
      [
        1,
        6
      ],
      [
        -1,
        3
      ],
      [
        -1,
        5
      ],
      [
        0,
        5
      ],
      [
        -1,
        1
      ],
      [
        -1,
        3
      ],
      [
        0,
        10
      ],
      [
        -1,
        5
      ],
      [
        -1,
        5
      ],
      [
        -1,
        4
      ],
      [
        1,
        6
      ],
      [
        1,
        2
      ],
      [
        1,
        1
      ],
      [
        1,
        -2
      ],
      [
        3,
        0
      ],
      [
        1,
        2
      ],
      [
        0,
        6
      ],
      [
        1,
        7
      ],
      [
        2,
        6
      ],
      [
        1,
        11
      ],
      [
        1,
        5
      ],
      [
        -1,
        5
      ],
      [
        -2,
        8
      ],
      [
        -1,
        7
      ],
      [
        2,
        7
      ],
      [
        2,
        2
      ],
      [
        1,
        6
      ],
      [
        0,
        2
      ],
      [
        1,
        4
      ],
      [
        2,
        2
      ],
      [
        1,
        4
      ],
      [
        1,
        1
      ],
      [
        2,
        4
      ],
      [
        3,
        9
      ],
      [
        0,
        6
      ],
      [
        2,
        4
      ],
      [
        0,
        15
      ],
      [
        1,
        7
      ],
      [
        0,
        7
      ],
      [
        -2,
        9
      ],
      [
        -1,
        10
      ],
      [
        1,
        5
      ],
      [
        2,
        9
      ],
      [
        3,
        6
      ],
      [
        2,
        12
      ],
      [
        1,
        8
      ],
      [
        1,
        5
      ],
      [
        1,
        7
      ],
      [
        0,
        4
      ],
      [
        2,
        6
      ],
      [
        2,
        4
      ],
      [
        1,
        4
      ],
      [
        1,
        4
      ],
      [
        0,
        6
      ],
      [
        1,
        9
      ],
      [
        -1,
        7
      ],
      [
        -2,
        15
      ],
      [
        1,
        10
      ],
      [
        1,
        9
      ],
      [
        0,
        17
      ],
      [
        1,
        9
      ],
      [
        0,
        13
      ],
      [
        1,
        2
      ],
      [
        1,
        5
      ],
      [
        1,
        6
      ],
      [
        1,
        2
      ],
      [
        1,
        -1
      ],
      [
        4,
        1
      ],
      [
        2,
        10
      ],
      [
        2,
        11
      ],
      [
        3,
        2
      ],
      [
        3,
        6
      ],
      [
        2,
        13
      ],
      [
        0,
        26
      ],
      [
        -1,
        25
      ],
      [
        1,
        16
      ],
      [
        4,
        10
      ],
      [
        8,
        3
      ],
      [
        6,
        9
      ],
      [
        3,
        20
      ],
      [
        1,
        27
      ],
      [
        0,
        25
      ],
      [
        -6,
        13
      ],
      [
        -7,
        7
      ],
      [
        -1,
        7
      ]
    ],
    [
      [
        25197,
        61015
      ],
      [
        0,
        51
      ]
    ],
    [
      [
        25197,
        61066
      ],
      [
        93,
        1
      ]
    ],
    [
      [
        25290,
        61067
      ],
      [
        0,
        -359
      ]
    ],
    [
      [
        25290,
        60708
      ],
      [
        -11,
        1
      ]
    ],
    [
      [
        25279,
        60709
      ],
      [
        -82,
        -1
      ]
    ],
    [
      [
        25197,
        60708
      ],
      [
        0,
        307
      ]
    ],
    [
      [
        25886,
        68762
      ],
      [
        116,
        -6
      ]
    ],
    [
      [
        26002,
        68756
      ],
      [
        -1,
        -406
      ]
    ],
    [
      [
        26001,
        68350
      ],
      [
        -62,
        3
      ]
    ],
    [
      [
        25939,
        68353
      ],
      [
        -95,
        14
      ]
    ],
    [
      [
        25844,
        68367
      ],
      [
        2,
        12
      ],
      [
        4,
        22
      ],
      [
        3,
        25
      ],
      [
        3,
        23
      ],
      [
        4,
        16
      ],
      [
        3,
        25
      ],
      [
        5,
        28
      ],
      [
        9,
        43
      ],
      [
        4,
        65
      ],
      [
        1,
        23
      ],
      [
        0,
        16
      ],
      [
        -1,
        20
      ],
      [
        0,
        16
      ],
      [
        1,
        20
      ],
      [
        2,
        7
      ],
      [
        1,
        15
      ],
      [
        1,
        19
      ]
    ],
    [
      [
        22268,
        65933
      ],
      [
        128,
        1
      ]
    ],
    [
      [
        22396,
        65934
      ],
      [
        1,
        -405
      ]
    ],
    [
      [
        22397,
        65529
      ],
      [
        -127,
        0
      ]
    ],
    [
      [
        22270,
        65529
      ],
      [
        -2,
        0
      ]
    ],
    [
      [
        22268,
        65529
      ],
      [
        0,
        404
      ]
    ],
    [
      [
        21981,
        65528
      ],
      [
        69,
        -2
      ],
      [
        88,
        2
      ]
    ],
    [
      [
        22138,
        65528
      ],
      [
        130,
        1
      ]
    ],
    [
      [
        22270,
        65529
      ],
      [
        0,
        -403
      ],
      [
        3,
        -1
      ]
    ],
    [
      [
        22273,
        65125
      ],
      [
        -1,
        -404
      ]
    ],
    [
      [
        22272,
        64721
      ],
      [
        -61,
        0
      ]
    ],
    [
      [
        22211,
        64721
      ],
      [
        -223,
        0
      ]
    ],
    [
      [
        21988,
        64721
      ],
      [
        -3,
        0
      ],
      [
        0,
        404
      ],
      [
        -4,
        0
      ]
    ],
    [
      [
        21981,
        65125
      ],
      [
        0,
        403
      ]
    ],
    [
      [
        22650,
        68386
      ],
      [
        134,
        0
      ]
    ],
    [
      [
        22784,
        67983
      ],
      [
        -67,
        0
      ]
    ],
    [
      [
        22717,
        67983
      ],
      [
        -67,
        1
      ]
    ],
    [
      [
        22650,
        67984
      ],
      [
        0,
        402
      ]
    ],
    [
      [
        22613,
        69501
      ],
      [
        136,
        -2
      ]
    ],
    [
      [
        22749,
        69499
      ],
      [
        0,
        -300
      ],
      [
        1,
        -3
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        22750,
        69095
      ],
      [
        0,
        -303
      ]
    ],
    [
      [
        22750,
        68792
      ],
      [
        -101,
        1
      ]
    ],
    [
      [
        22649,
        68793
      ],
      [
        -1,
        101
      ],
      [
        -34,
        0
      ]
    ],
    [
      [
        22614,
        68894
      ],
      [
        1,
        304
      ],
      [
        -2,
        0
      ],
      [
        0,
        303
      ]
    ],
    [
      [
        24547,
        58095
      ],
      [
        0,
        105
      ]
    ],
    [
      [
        24547,
        58200
      ],
      [
        31,
        -3
      ],
      [
        29,
        4
      ],
      [
        30,
        0
      ],
      [
        30,
        4
      ],
      [
        0,
        -9
      ],
      [
        30,
        1
      ]
    ],
    [
      [
        24697,
        58197
      ],
      [
        0,
        -103
      ],
      [
        -1,
        -204
      ],
      [
        1,
        -40
      ]
    ],
    [
      [
        24697,
        57850
      ],
      [
        0,
        -1
      ],
      [
        -30,
        2
      ],
      [
        0,
        2
      ],
      [
        -7,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -23,
        4
      ],
      [
        -89,
        0
      ]
    ],
    [
      [
        24547,
        57855
      ],
      [
        0,
        240
      ]
    ],
    [
      [
        19966,
        60502
      ],
      [
        99,
        1
      ]
    ],
    [
      [
        20065,
        60503
      ],
      [
        0,
        -36
      ],
      [
        116,
        5
      ],
      [
        0,
        9
      ]
    ],
    [
      [
        20181,
        60481
      ],
      [
        9,
        -1
      ]
    ],
    [
      [
        20247,
        60003
      ],
      [
        -7,
        0
      ],
      [
        -33,
        -1
      ],
      [
        -3,
        0
      ],
      [
        -9,
        1
      ],
      [
        -4,
        -1
      ],
      [
        -54,
        0
      ],
      [
        -2,
        9
      ],
      [
        -30,
        0
      ],
      [
        -122,
        -1
      ]
    ],
    [
      [
        19983,
        60010
      ],
      [
        -17,
        0
      ]
    ],
    [
      [
        19966,
        60010
      ],
      [
        0,
        492
      ]
    ],
    [
      [
        27188,
        48409
      ],
      [
        82,
        -1
      ],
      [
        0,
        103
      ],
      [
        28,
        1
      ],
      [
        -1,
        102
      ],
      [
        63,
        1
      ]
    ],
    [
      [
        27360,
        48615
      ],
      [
        7,
        -24
      ],
      [
        3,
        -1
      ],
      [
        -1,
        -17
      ],
      [
        6,
        -12
      ],
      [
        3,
        6
      ],
      [
        2,
        -17
      ],
      [
        -4,
        -228
      ]
    ],
    [
      [
        27376,
        48322
      ],
      [
        -16,
        -221
      ],
      [
        -137,
        0
      ],
      [
        0,
        17
      ],
      [
        -7,
        0
      ],
      [
        0,
        -17
      ],
      [
        -29,
        1
      ]
    ],
    [
      [
        27187,
        48102
      ],
      [
        1,
        307
      ]
    ],
    [
      [
        22181,
        67577
      ],
      [
        66,
        -1
      ]
    ],
    [
      [
        22247,
        67576
      ],
      [
        -4,
        -36
      ],
      [
        8,
        -27
      ],
      [
        7,
        -9
      ],
      [
        25,
        -3
      ],
      [
        4,
        -9
      ],
      [
        7,
        -54
      ],
      [
        5,
        -9
      ],
      [
        7,
        -39
      ],
      [
        4,
        -22
      ],
      [
        14,
        -35
      ],
      [
        11,
        -37
      ],
      [
        10,
        -12
      ],
      [
        13,
        -2
      ],
      [
        6,
        -23
      ],
      [
        0,
        -55
      ],
      [
        3,
        -23
      ],
      [
        3,
        -6
      ],
      [
        18,
        -5
      ],
      [
        5,
        -5
      ],
      [
        6,
        -19
      ],
      [
        10,
        -48
      ],
      [
        7,
        -14
      ],
      [
        12,
        -6
      ],
      [
        8,
        3
      ],
      [
        17,
        -18
      ],
      [
        9,
        -22
      ],
      [
        5,
        -24
      ],
      [
        2,
        -24
      ]
    ],
    [
      [
        22469,
        66993
      ],
      [
        -210,
        0
      ]
    ],
    [
      [
        22259,
        66993
      ],
      [
        -40,
        0
      ],
      [
        -21,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -16,
        0
      ]
    ],
    [
      [
        22181,
        66993
      ],
      [
        0,
        584
      ]
    ],
    [
      [
        21599,
        59428
      ],
      [
        150,
        0
      ]
    ],
    [
      [
        21749,
        59428
      ],
      [
        -1,
        -515
      ]
    ],
    [
      [
        21748,
        58913
      ],
      [
        0,
        -2
      ]
    ],
    [
      [
        21599,
        58911
      ],
      [
        0,
        517
      ]
    ],
    [
      [
        15728,
        71772
      ],
      [
        5,
        0
      ],
      [
        7,
        33
      ],
      [
        2,
        3
      ],
      [
        2,
        1
      ],
      [
        -1,
        16
      ],
      [
        1,
        17
      ],
      [
        2,
        4
      ],
      [
        4,
        2
      ],
      [
        7,
        10
      ],
      [
        3,
        38
      ],
      [
        5,
        39
      ],
      [
        0,
        2
      ],
      [
        7,
        37
      ],
      [
        3,
        16
      ],
      [
        -6,
        29
      ],
      [
        0,
        2
      ],
      [
        2,
        1
      ],
      [
        2,
        -2
      ],
      [
        17,
        -46
      ],
      [
        8,
        -12
      ],
      [
        2,
        1
      ],
      [
        2,
        2
      ],
      [
        3,
        14
      ],
      [
        3,
        8
      ],
      [
        -2,
        6
      ],
      [
        -3,
        4
      ],
      [
        -2,
        -1
      ],
      [
        -3,
        5
      ],
      [
        0,
        7
      ],
      [
        6,
        15
      ],
      [
        1,
        1
      ]
    ],
    [
      [
        15805,
        72024
      ],
      [
        23,
        -67
      ],
      [
        0,
        -6
      ],
      [
        48,
        0
      ],
      [
        6,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -9
      ],
      [
        1,
        -4
      ],
      [
        2,
        -3
      ],
      [
        1,
        -1
      ],
      [
        0,
        -10
      ],
      [
        1,
        -1
      ],
      [
        1,
        0
      ],
      [
        0,
        -11
      ],
      [
        1,
        -4
      ],
      [
        0,
        -5
      ],
      [
        1,
        -6
      ],
      [
        2,
        -6
      ],
      [
        1,
        -4
      ],
      [
        1,
        -4
      ],
      [
        2,
        -3
      ],
      [
        2,
        -5
      ],
      [
        3,
        -3
      ],
      [
        2,
        -2
      ],
      [
        1,
        -4
      ],
      [
        1,
        -4
      ],
      [
        1,
        -5
      ],
      [
        1,
        -3
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        2,
        2
      ],
      [
        2,
        1
      ],
      [
        2,
        -1
      ],
      [
        1,
        1
      ],
      [
        2,
        -2
      ],
      [
        1,
        -2
      ],
      [
        2,
        -1
      ],
      [
        0,
        2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        1,
        -5
      ],
      [
        1,
        -2
      ],
      [
        1,
        2
      ],
      [
        1,
        -1
      ],
      [
        2,
        -3
      ],
      [
        0,
        -3
      ],
      [
        2,
        -3
      ],
      [
        2,
        1
      ],
      [
        2,
        -4
      ],
      [
        1,
        -11
      ],
      [
        2,
        -5
      ],
      [
        1,
        -2
      ],
      [
        2,
        4
      ],
      [
        1,
        4
      ],
      [
        1,
        5
      ],
      [
        3,
        1
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        3,
        1
      ],
      [
        2,
        -2
      ],
      [
        3,
        1
      ],
      [
        0,
        -2
      ],
      [
        2,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        0,
        -3
      ],
      [
        1,
        -3
      ],
      [
        1,
        1
      ],
      [
        2,
        -2
      ],
      [
        1,
        -3
      ],
      [
        2,
        1
      ],
      [
        1,
        3
      ],
      [
        0,
        4
      ],
      [
        2,
        4
      ],
      [
        2,
        6
      ],
      [
        2,
        1
      ],
      [
        0,
        5
      ],
      [
        2,
        4
      ],
      [
        2,
        3
      ],
      [
        1,
        4
      ],
      [
        1,
        -1
      ],
      [
        2,
        0
      ],
      [
        2,
        -1
      ],
      [
        1,
        -6
      ],
      [
        1,
        -1
      ],
      [
        2,
        2
      ],
      [
        1,
        -3
      ],
      [
        1,
        -2
      ],
      [
        2,
        -1
      ],
      [
        1,
        1
      ],
      [
        0,
        1
      ],
      [
        3,
        -6
      ],
      [
        2,
        -4
      ],
      [
        1,
        -4
      ],
      [
        2,
        0
      ],
      [
        3,
        -1
      ],
      [
        3,
        0
      ],
      [
        2,
        -2
      ],
      [
        1,
        1
      ],
      [
        1,
        4
      ],
      [
        2,
        2
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        1,
        1
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        2,
        0
      ],
      [
        2,
        -3
      ],
      [
        1,
        1
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        2,
        -5
      ],
      [
        0,
        -3
      ],
      [
        2,
        -1
      ],
      [
        1,
        -6
      ],
      [
        1,
        -6
      ],
      [
        1,
        -5
      ],
      [
        1,
        -5
      ],
      [
        1,
        -3
      ],
      [
        1,
        -2
      ],
      [
        2,
        -1
      ],
      [
        0,
        -1
      ],
      [
        2,
        2
      ],
      [
        2,
        -1
      ],
      [
        2,
        0
      ],
      [
        1,
        2
      ],
      [
        1,
        2
      ],
      [
        4,
        0
      ],
      [
        4,
        2
      ],
      [
        1,
        -2
      ],
      [
        2,
        0
      ],
      [
        1,
        -1
      ],
      [
        1,
        -3
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        1,
        -3
      ],
      [
        1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        2,
        -4
      ],
      [
        1,
        -5
      ],
      [
        2,
        -5
      ],
      [
        2,
        -3
      ],
      [
        1,
        -3
      ],
      [
        6,
        3
      ],
      [
        2,
        2
      ],
      [
        2,
        2
      ],
      [
        1,
        -3
      ],
      [
        4,
        1
      ],
      [
        3,
        -1
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        16094,
        71753
      ],
      [
        2,
        -36
      ],
      [
        -7,
        -27
      ],
      [
        1,
        -12
      ],
      [
        -3,
        -13
      ],
      [
        0,
        -15
      ],
      [
        -11,
        -22
      ],
      [
        1,
        -8
      ],
      [
        -4,
        -15
      ],
      [
        2,
        -30
      ],
      [
        -2,
        -13
      ],
      [
        -11,
        -19
      ],
      [
        -8,
        -40
      ],
      [
        8,
        -12
      ],
      [
        6,
        -49
      ],
      [
        9,
        -32
      ],
      [
        -4,
        -11
      ]
    ],
    [
      [
        16073,
        71399
      ],
      [
        -84,
        0
      ],
      [
        -5,
        -8
      ],
      [
        -12,
        -34
      ],
      [
        -4,
        -20
      ],
      [
        -2,
        -2
      ],
      [
        -7,
        1
      ],
      [
        -18,
        13
      ],
      [
        -7,
        17
      ],
      [
        -8,
        -13
      ],
      [
        -7,
        10
      ],
      [
        -4,
        -12
      ],
      [
        -5,
        0
      ],
      [
        -11,
        12
      ],
      [
        -10,
        -4
      ],
      [
        -3,
        6
      ],
      [
        -14,
        1
      ],
      [
        -7,
        9
      ]
    ],
    [
      [
        15865,
        71375
      ],
      [
        -10,
        15
      ],
      [
        -9,
        -10
      ],
      [
        -10,
        26
      ],
      [
        0,
        20
      ],
      [
        1,
        25
      ],
      [
        -6,
        3
      ],
      [
        -1,
        16
      ],
      [
        -3,
        -8
      ],
      [
        -9,
        9
      ],
      [
        -2,
        -7
      ],
      [
        -20,
        15
      ],
      [
        -2,
        14
      ],
      [
        -9,
        4
      ],
      [
        -1,
        44
      ],
      [
        -9,
        23
      ],
      [
        -10,
        10
      ],
      [
        -3,
        31
      ],
      [
        2,
        7
      ],
      [
        -13,
        12
      ],
      [
        0,
        -11
      ],
      [
        -5,
        5
      ],
      [
        -2,
        8
      ],
      [
        2,
        22
      ],
      [
        -12,
        20
      ],
      [
        -1,
        26
      ],
      [
        -7,
        41
      ],
      [
        -2,
        15
      ],
      [
        4,
        22
      ]
    ],
    [
      [
        15698,
        72062
      ],
      [
        0,
        59
      ]
    ],
    [
      [
        15698,
        72121
      ],
      [
        71,
        0
      ]
    ],
    [
      [
        15769,
        72121
      ],
      [
        -1,
        -11
      ],
      [
        4,
        -21
      ],
      [
        -4,
        -19
      ],
      [
        -1,
        -14
      ],
      [
        -5,
        -24
      ],
      [
        -1,
        -1
      ],
      [
        1,
        -9
      ],
      [
        0,
        -4
      ],
      [
        6,
        -29
      ],
      [
        1,
        -6
      ],
      [
        -8,
        -35
      ],
      [
        -3,
        -21
      ],
      [
        -1,
        -11
      ],
      [
        -3,
        -12
      ],
      [
        -4,
        4
      ],
      [
        -3,
        17
      ],
      [
        -12,
        41
      ],
      [
        -6,
        11
      ],
      [
        -2,
        5
      ],
      [
        8,
        69
      ],
      [
        10,
        31
      ],
      [
        0,
        7
      ],
      [
        -1,
        2
      ],
      [
        -9,
        -13
      ],
      [
        -16,
        -42
      ],
      [
        -5,
        -39
      ],
      [
        -1,
        -24
      ],
      [
        9,
        -31
      ],
      [
        -2,
        -16
      ],
      [
        4,
        -5
      ],
      [
        1,
        -1
      ],
      [
        6,
        2
      ],
      [
        1,
        -2
      ],
      [
        4,
        -9
      ],
      [
        2,
        -5
      ],
      [
        3,
        -4
      ],
      [
        2,
        -12
      ],
      [
        -1,
        -7
      ],
      [
        -4,
        -7
      ],
      [
        -5,
        -2
      ],
      [
        -1,
        -14
      ],
      [
        2,
        -6
      ],
      [
        0,
        -28
      ],
      [
        -1,
        -10
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -11
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        5
      ],
      [
        -3,
        11
      ],
      [
        -5,
        16
      ],
      [
        -3,
        7
      ],
      [
        -3,
        10
      ],
      [
        -2,
        2
      ],
      [
        -17,
        88
      ],
      [
        -3,
        17
      ],
      [
        0,
        12
      ],
      [
        2,
        7
      ],
      [
        5,
        3
      ],
      [
        5,
        15
      ],
      [
        1,
        61
      ],
      [
        -2,
        13
      ]
    ],
    [
      [
        26272,
        55950
      ],
      [
        33,
        -1
      ],
      [
        31,
        0
      ],
      [
        3,
        -10
      ]
    ],
    [
      [
        26339,
        55939
      ],
      [
        -1,
        -12
      ],
      [
        -4,
        -18
      ],
      [
        0,
        -44
      ],
      [
        4,
        -42
      ],
      [
        1,
        -7
      ],
      [
        5,
        -20
      ],
      [
        1,
        -25
      ],
      [
        6,
        -16
      ],
      [
        9,
        -10
      ],
      [
        4,
        -20
      ],
      [
        0,
        -30
      ],
      [
        6,
        -41
      ]
    ],
    [
      [
        26370,
        55654
      ],
      [
        -3,
        -10
      ],
      [
        2,
        -32
      ]
    ],
    [
      [
        26268,
        55577
      ],
      [
        -2,
        19
      ],
      [
        2,
        19
      ],
      [
        -19,
        1
      ],
      [
        -2,
        0
      ]
    ],
    [
      [
        26247,
        55616
      ],
      [
        -4,
        47
      ],
      [
        1,
        20
      ],
      [
        -2,
        0
      ],
      [
        0,
        -6
      ],
      [
        -16,
        173
      ]
    ],
    [
      [
        26226,
        55850
      ],
      [
        8,
        18
      ],
      [
        0,
        18
      ],
      [
        3,
        -5
      ],
      [
        10,
        -18
      ],
      [
        5,
        9
      ],
      [
        3,
        28
      ],
      [
        9,
        25
      ],
      [
        6,
        4
      ],
      [
        2,
        21
      ]
    ],
    [
      [
        26638,
        56479
      ],
      [
        10,
        25
      ],
      [
        -1,
        14
      ],
      [
        5,
        -8
      ],
      [
        9,
        14
      ],
      [
        19,
        29
      ],
      [
        0,
        9
      ],
      [
        7,
        3
      ]
    ],
    [
      [
        26687,
        56565
      ],
      [
        11,
        -16
      ],
      [
        7,
        -21
      ],
      [
        9,
        -2
      ],
      [
        1,
        -9
      ]
    ],
    [
      [
        26715,
        56517
      ],
      [
        -3,
        2
      ],
      [
        1,
        -35
      ],
      [
        -3,
        -22
      ],
      [
        1,
        -11
      ],
      [
        9,
        -44
      ],
      [
        -1,
        -5
      ],
      [
        -9,
        -61
      ]
    ],
    [
      [
        26710,
        56341
      ],
      [
        -13,
        8
      ],
      [
        -1,
        17
      ],
      [
        -9,
        9
      ],
      [
        -5,
        16
      ],
      [
        -1,
        9
      ],
      [
        -7,
        17
      ],
      [
        -4,
        16
      ],
      [
        -4,
        -5
      ],
      [
        -16,
        12
      ],
      [
        -4,
        -2
      ],
      [
        -8,
        41
      ]
    ],
    [
      [
        25882,
        63076
      ],
      [
        4,
        0
      ],
      [
        8,
        1
      ],
      [
        12,
        1
      ],
      [
        7,
        0
      ],
      [
        7,
        1
      ],
      [
        45,
        3
      ]
    ],
    [
      [
        25965,
        63082
      ],
      [
        0,
        -134
      ],
      [
        -1,
        -163
      ],
      [
        1,
        -42
      ]
    ],
    [
      [
        25965,
        62743
      ],
      [
        -21,
        -2
      ],
      [
        -16,
        -2
      ]
    ],
    [
      [
        25928,
        62739
      ],
      [
        -15,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -30,
        -2
      ]
    ],
    [
      [
        25881,
        62736
      ],
      [
        0,
        204
      ],
      [
        1,
        1
      ],
      [
        0,
        135
      ]
    ],
    [
      [
        22783,
        61884
      ],
      [
        123,
        0
      ]
    ],
    [
      [
        22906,
        61884
      ],
      [
        0,
        -101
      ],
      [
        31,
        0
      ]
    ],
    [
      [
        22937,
        61783
      ],
      [
        0,
        -203
      ],
      [
        -5,
        0
      ],
      [
        0,
        -84
      ],
      [
        -1,
        -17
      ],
      [
        0,
        -205
      ]
    ],
    [
      [
        22931,
        61274
      ],
      [
        -87,
        3
      ]
    ],
    [
      [
        22844,
        61277
      ],
      [
        0,
        101
      ],
      [
        -61,
        -1
      ]
    ],
    [
      [
        22783,
        61377
      ],
      [
        0,
        507
      ]
    ],
    [
      [
        23858,
        70178
      ],
      [
        35,
        -4
      ],
      [
        69,
        -1
      ]
    ],
    [
      [
        23962,
        70173
      ],
      [
        0,
        -200
      ],
      [
        33,
        -1
      ],
      [
        0,
        -101
      ],
      [
        1,
        -69
      ]
    ],
    [
      [
        23996,
        69802
      ],
      [
        -21,
        3
      ],
      [
        -13,
        -1
      ],
      [
        -6,
        1
      ],
      [
        -29,
        0
      ],
      [
        -68,
        1
      ]
    ],
    [
      [
        23859,
        69806
      ],
      [
        0,
        167
      ]
    ],
    [
      [
        23859,
        69973
      ],
      [
        -1,
        205
      ]
    ],
    [
      [
        22525,
        66339
      ],
      [
        129,
        1
      ]
    ],
    [
      [
        22654,
        66340
      ],
      [
        0,
        -405
      ]
    ],
    [
      [
        22654,
        65935
      ],
      [
        1,
        -202
      ]
    ],
    [
      [
        22655,
        65733
      ],
      [
        -129,
        -1
      ]
    ],
    [
      [
        22526,
        65732
      ],
      [
        0,
        194
      ],
      [
        -2,
        8
      ]
    ],
    [
      [
        22524,
        65934
      ],
      [
        1,
        405
      ]
    ],
    [
      [
        27018,
        64741
      ],
      [
        1,
        85
      ],
      [
        26,
        0
      ],
      [
        1,
        73
      ],
      [
        27,
        0
      ],
      [
        1,
        88
      ],
      [
        26,
        0
      ]
    ],
    [
      [
        27100,
        64987
      ],
      [
        11,
        0
      ],
      [
        8,
        1
      ],
      [
        29,
        1
      ],
      [
        6,
        0
      ]
    ],
    [
      [
        27154,
        64989
      ],
      [
        -1,
        -164
      ],
      [
        0,
        -172
      ]
    ],
    [
      [
        27153,
        64653
      ],
      [
        -81,
        2
      ],
      [
        -28,
        1
      ],
      [
        -14,
        1
      ]
    ],
    [
      [
        27030,
        64657
      ],
      [
        -12,
        0
      ],
      [
        0,
        84
      ]
    ],
    [
      [
        26061,
        58301
      ],
      [
        14,
        2
      ]
    ],
    [
      [
        26075,
        58303
      ],
      [
        17,
        17
      ],
      [
        10,
        -1
      ],
      [
        2,
        13
      ],
      [
        8,
        11
      ]
    ],
    [
      [
        26112,
        58343
      ],
      [
        -3,
        -31
      ],
      [
        7,
        -34
      ],
      [
        2,
        -23
      ],
      [
        24,
        -87
      ],
      [
        25,
        -73
      ]
    ],
    [
      [
        26167,
        58095
      ],
      [
        -5,
        -41
      ],
      [
        -40,
        -200
      ]
    ],
    [
      [
        26122,
        57854
      ],
      [
        -2,
        23
      ],
      [
        2,
        15
      ],
      [
        -1,
        25
      ],
      [
        -3,
        25
      ],
      [
        -12,
        46
      ],
      [
        -13,
        14
      ],
      [
        -1,
        6
      ],
      [
        -17,
        33
      ],
      [
        -1,
        13
      ]
    ],
    [
      [
        26074,
        58054
      ],
      [
        5,
        26
      ],
      [
        10,
        19
      ],
      [
        5,
        30
      ],
      [
        1,
        26
      ],
      [
        -8,
        2
      ],
      [
        0,
        18
      ],
      [
        -6,
        10
      ],
      [
        -2,
        34
      ],
      [
        2,
        30
      ],
      [
        -10,
        22
      ],
      [
        -10,
        30
      ]
    ],
    [
      [
        21448,
        58404
      ],
      [
        151,
        0
      ]
    ],
    [
      [
        21599,
        58404
      ],
      [
        0,
        -509
      ]
    ],
    [
      [
        21599,
        57895
      ],
      [
        -152,
        1
      ]
    ],
    [
      [
        21447,
        57896
      ],
      [
        1,
        508
      ]
    ],
    [
      [
        22809,
        53352
      ],
      [
        114,
        241
      ],
      [
        19,
        41
      ]
    ],
    [
      [
        22942,
        53634
      ],
      [
        57,
        -351
      ]
    ],
    [
      [
        22999,
        53283
      ],
      [
        -65,
        -134
      ]
    ],
    [
      [
        22934,
        53149
      ],
      [
        0,
        6
      ],
      [
        -23,
        -49
      ],
      [
        -10,
        -24
      ],
      [
        -34,
        -72
      ]
    ],
    [
      [
        22867,
        53010
      ],
      [
        -58,
        342
      ]
    ],
    [
      [
        22612,
        72434
      ],
      [
        1,
        -8
      ],
      [
        -1,
        -395
      ],
      [
        7,
        0
      ],
      [
        0,
        -100
      ]
    ],
    [
      [
        22619,
        71931
      ],
      [
        -141,
        0
      ]
    ],
    [
      [
        22478,
        71931
      ],
      [
        0,
        100
      ],
      [
        -9,
        0
      ]
    ],
    [
      [
        22469,
        72031
      ],
      [
        0,
        304
      ]
    ],
    [
      [
        22469,
        72335
      ],
      [
        0,
        99
      ]
    ],
    [
      [
        22519,
        67575
      ],
      [
        57,
        0
      ]
    ],
    [
      [
        22576,
        67575
      ],
      [
        1,
        -16
      ],
      [
        1,
        -335
      ]
    ],
    [
      [
        22578,
        67224
      ],
      [
        -159,
        205
      ],
      [
        -8,
        -3
      ],
      [
        1,
        150
      ]
    ],
    [
      [
        22479,
        53822
      ],
      [
        86,
        184
      ],
      [
        -15,
        88
      ]
    ],
    [
      [
        22550,
        54094
      ],
      [
        57,
        117
      ]
    ],
    [
      [
        22607,
        54211
      ],
      [
        66,
        -402
      ]
    ],
    [
      [
        22673,
        53809
      ],
      [
        -115,
        -243
      ]
    ],
    [
      [
        22558,
        53566
      ],
      [
        -25,
        -55
      ]
    ],
    [
      [
        22533,
        53511
      ],
      [
        -54,
        311
      ]
    ],
    [
      [
        23846,
        64548
      ],
      [
        128,
        0
      ]
    ],
    [
      [
        23974,
        64548
      ],
      [
        0,
        -366
      ]
    ],
    [
      [
        23974,
        64182
      ],
      [
        -11,
        -1
      ],
      [
        -34,
        -2
      ],
      [
        -16,
        0
      ],
      [
        -8,
        -1
      ],
      [
        -8,
        0
      ]
    ],
    [
      [
        23897,
        64178
      ],
      [
        -51,
        0
      ]
    ],
    [
      [
        23846,
        64178
      ],
      [
        0,
        370
      ]
    ],
    [
      [
        20924,
        71117
      ],
      [
        68,
        -1
      ],
      [
        0,
        104
      ],
      [
        53,
        0
      ]
    ],
    [
      [
        21045,
        71220
      ],
      [
        106,
        0
      ]
    ],
    [
      [
        21151,
        71220
      ],
      [
        84,
        0
      ]
    ],
    [
      [
        21235,
        71220
      ],
      [
        1,
        -405
      ]
    ],
    [
      [
        21236,
        70815
      ],
      [
        -20,
        -1
      ]
    ],
    [
      [
        21216,
        70814
      ],
      [
        -101,
        -1
      ],
      [
        -191,
        0
      ]
    ],
    [
      [
        20924,
        70813
      ],
      [
        0,
        304
      ]
    ],
    [
      [
        21985,
        54286
      ],
      [
        24,
        0
      ]
    ],
    [
      [
        22131,
        54286
      ],
      [
        -3,
        -589
      ]
    ],
    [
      [
        22128,
        53697
      ],
      [
        -108,
        5
      ]
    ],
    [
      [
        21985,
        53833
      ],
      [
        0,
        453
      ]
    ],
    [
      [
        18558,
        60011
      ],
      [
        47,
        1
      ],
      [
        284,
        0
      ]
    ],
    [
      [
        18889,
        60012
      ],
      [
        20,
        -1
      ],
      [
        6,
        1
      ],
      [
        34,
        -1
      ],
      [
        19,
        2
      ],
      [
        88,
        1
      ]
    ],
    [
      [
        19056,
        60014
      ],
      [
        0,
        -3189
      ]
    ],
    [
      [
        19056,
        56825
      ],
      [
        -5,
        -5
      ],
      [
        2,
        33
      ],
      [
        -6,
        14
      ],
      [
        -2,
        11
      ],
      [
        -6,
        -16
      ],
      [
        -10,
        13
      ],
      [
        7,
        -21
      ],
      [
        -4,
        -9
      ],
      [
        3,
        -6
      ],
      [
        -6,
        -12
      ],
      [
        -9,
        12
      ],
      [
        -5,
        31
      ],
      [
        -3,
        -2
      ],
      [
        -11,
        20
      ],
      [
        -3,
        -4
      ],
      [
        -5,
        26
      ],
      [
        -6,
        9
      ],
      [
        -2,
        15
      ],
      [
        -4,
        7
      ],
      [
        -4,
        -26
      ],
      [
        -7,
        14
      ],
      [
        5,
        24
      ],
      [
        -16,
        27
      ],
      [
        -6,
        -16
      ],
      [
        -3,
        9
      ],
      [
        -5,
        -18
      ],
      [
        -1,
        22
      ],
      [
        -9,
        19
      ],
      [
        -7,
        -2
      ],
      [
        -4,
        20
      ],
      [
        -5,
        6
      ],
      [
        -2,
        26
      ],
      [
        -4,
        -11
      ],
      [
        -13,
        -19
      ],
      [
        -12,
        -3
      ],
      [
        0,
        19
      ],
      [
        -4,
        -1
      ],
      [
        -9,
        -14
      ],
      [
        -1,
        -36
      ],
      [
        5,
        0
      ],
      [
        -4,
        -22
      ],
      [
        -5,
        -2
      ],
      [
        -2,
        21
      ],
      [
        0,
        49
      ],
      [
        5,
        -10
      ],
      [
        2,
        18
      ],
      [
        -10,
        3
      ],
      [
        -4,
        -14
      ],
      [
        -4,
        -29
      ],
      [
        -5,
        12
      ],
      [
        4,
        21
      ],
      [
        -5,
        -9
      ],
      [
        -3,
        4
      ],
      [
        -4,
        -21
      ],
      [
        -7,
        -4
      ],
      [
        -4,
        8
      ],
      [
        9,
        13
      ],
      [
        3,
        13
      ],
      [
        10,
        19
      ],
      [
        -4,
        7
      ],
      [
        -7,
        -10
      ],
      [
        -5,
        -1
      ],
      [
        -3,
        6
      ],
      [
        8,
        10
      ],
      [
        -1,
        28
      ],
      [
        3,
        7
      ],
      [
        -6,
        -4
      ],
      [
        1,
        -20
      ],
      [
        -8,
        -19
      ],
      [
        -1,
        12
      ]
    ],
    [
      [
        18832,
        57067
      ],
      [
        0,
        385
      ],
      [
        -37,
        1
      ],
      [
        -25,
        0
      ],
      [
        -1,
        18
      ],
      [
        1,
        189
      ],
      [
        -9,
        -5
      ],
      [
        -56,
        -1
      ],
      [
        -3,
        -2
      ],
      [
        -88,
        -1
      ],
      [
        0,
        204
      ],
      [
        -30,
        1
      ],
      [
        0,
        84
      ],
      [
        1,
        46
      ],
      [
        -9,
        -26
      ],
      [
        -8,
        5
      ],
      [
        -11,
        -8
      ],
      [
        -10,
        9
      ],
      [
        -8,
        30
      ],
      [
        -4,
        6
      ],
      [
        0,
        18
      ],
      [
        -3,
        11
      ],
      [
        -7,
        -9
      ],
      [
        -6,
        17
      ],
      [
        -5,
        6
      ],
      [
        -11,
        -8
      ],
      [
        -6,
        2
      ],
      [
        -11,
        19
      ],
      [
        -24,
        23
      ],
      [
        -18,
        12
      ],
      [
        -2,
        4
      ],
      [
        -2,
        24
      ],
      [
        -4,
        19
      ],
      [
        -31,
        70
      ],
      [
        -17,
        29
      ],
      [
        -3,
        21
      ],
      [
        -5,
        12
      ],
      [
        -6,
        5
      ],
      [
        -6,
        -2
      ],
      [
        -12,
        24
      ],
      [
        -10,
        1
      ],
      [
        -10,
        -3
      ]
    ],
    [
      [
        17303,
        72077
      ],
      [
        64,
        0
      ],
      [
        0,
        17
      ],
      [
        17,
        6
      ],
      [
        4,
        0
      ],
      [
        0,
        -17
      ],
      [
        30,
        0
      ],
      [
        0,
        34
      ],
      [
        12,
        0
      ],
      [
        0,
        17
      ],
      [
        42,
        -2
      ],
      [
        29,
        1
      ]
    ],
    [
      [
        17501,
        72133
      ],
      [
        0,
        -456
      ]
    ],
    [
      [
        17501,
        71677
      ],
      [
        -35,
        0
      ],
      [
        0,
        17
      ],
      [
        -88,
        -5
      ],
      [
        -17,
        0
      ],
      [
        0,
        15
      ],
      [
        -4,
        2
      ],
      [
        -10,
        22
      ],
      [
        -3,
        14
      ],
      [
        -9,
        4
      ],
      [
        -5,
        -17
      ],
      [
        -4,
        5
      ],
      [
        -5,
        21
      ],
      [
        3,
        30
      ],
      [
        -10,
        18
      ],
      [
        -10,
        -4
      ]
    ],
    [
      [
        17304,
        71799
      ],
      [
        0,
        115
      ],
      [
        -1,
        39
      ]
    ],
    [
      [
        17303,
        71953
      ],
      [
        1,
        102
      ],
      [
        -1,
        22
      ]
    ],
    [
      [
        22326,
        60558
      ],
      [
        153,
        1
      ]
    ],
    [
      [
        22479,
        60559
      ],
      [
        0,
        -101
      ],
      [
        32,
        0
      ]
    ],
    [
      [
        22511,
        60458
      ],
      [
        0,
        -450
      ]
    ],
    [
      [
        22511,
        60008
      ],
      [
        -1,
        0
      ],
      [
        -16,
        1
      ],
      [
        -38,
        0
      ]
    ],
    [
      [
        22456,
        60009
      ],
      [
        -48,
        0
      ],
      [
        -12,
        1
      ],
      [
        -67,
        0
      ]
    ],
    [
      [
        22329,
        60010
      ],
      [
        0,
        448
      ],
      [
        -3,
        0
      ]
    ],
    [
      [
        22326,
        60458
      ],
      [
        0,
        100
      ]
    ],
    [
      [
        23039,
        67984
      ],
      [
        108,
        -1
      ]
    ],
    [
      [
        23147,
        67983
      ],
      [
        4,
        0
      ]
    ],
    [
      [
        23151,
        67983
      ],
      [
        0,
        -406
      ]
    ],
    [
      [
        23151,
        67577
      ],
      [
        -112,
        0
      ]
    ],
    [
      [
        30951,
        69617
      ],
      [
        32,
        18
      ],
      [
        -7,
        98
      ],
      [
        2,
        1
      ],
      [
        -25,
        334
      ]
    ],
    [
      [
        31021,
        70115
      ],
      [
        0,
        -3
      ],
      [
        10,
        0
      ],
      [
        4,
        -12
      ],
      [
        6,
        -5
      ],
      [
        3,
        -1
      ],
      [
        0,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        4
      ],
      [
        -2,
        2
      ],
      [
        -2,
        9
      ],
      [
        0,
        7
      ],
      [
        -1,
        6
      ],
      [
        2,
        0
      ],
      [
        0,
        -1
      ],
      [
        5,
        -10
      ],
      [
        1,
        -7
      ],
      [
        2,
        -16
      ],
      [
        2,
        -11
      ],
      [
        5,
        -23
      ],
      [
        2,
        -7
      ],
      [
        6,
        -13
      ],
      [
        2,
        3
      ],
      [
        -2,
        8
      ],
      [
        2,
        2
      ],
      [
        2,
        -4
      ],
      [
        7,
        -17
      ],
      [
        6,
        -5
      ],
      [
        7,
        -9
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        3,
        1
      ],
      [
        3,
        -3
      ],
      [
        4,
        -9
      ],
      [
        6,
        -1
      ],
      [
        2,
        5
      ],
      [
        1,
        4
      ],
      [
        0,
        3
      ],
      [
        -1,
        2
      ],
      [
        0,
        3
      ],
      [
        4,
        3
      ],
      [
        6,
        1
      ],
      [
        2,
        -2
      ],
      [
        5,
        -23
      ],
      [
        1,
        -5
      ],
      [
        1,
        -8
      ],
      [
        1,
        -26
      ],
      [
        -2,
        -11
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -9
      ],
      [
        1,
        -10
      ],
      [
        3,
        -10
      ],
      [
        1,
        -9
      ],
      [
        0,
        -2
      ],
      [
        -1,
        4
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -5,
        4
      ],
      [
        -4,
        4
      ],
      [
        -2,
        -4
      ],
      [
        0,
        -6
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        -4
      ],
      [
        -3,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        1,
        -9
      ],
      [
        1,
        -5
      ],
      [
        2,
        -6
      ],
      [
        2,
        -9
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        2,
        -24
      ],
      [
        1,
        -7
      ],
      [
        1,
        -2
      ],
      [
        3,
        -9
      ],
      [
        3,
        -9
      ],
      [
        5,
        -18
      ],
      [
        3,
        -18
      ],
      [
        0,
        -4
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -4
      ],
      [
        2,
        -7
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -10
      ],
      [
        -2,
        -7
      ],
      [
        -3,
        -7
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        1,
        -5
      ],
      [
        0,
        -6
      ],
      [
        -2,
        -16
      ],
      [
        -2,
        -4
      ],
      [
        0,
        -4
      ],
      [
        -4,
        -5
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -13
      ],
      [
        7,
        -41
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        2,
        -1
      ],
      [
        3,
        -17
      ],
      [
        1,
        -5
      ],
      [
        2,
        -15
      ],
      [
        0,
        -19
      ],
      [
        7,
        -16
      ],
      [
        0,
        -23
      ],
      [
        4,
        -7
      ],
      [
        2,
        -2
      ],
      [
        7,
        -24
      ],
      [
        1,
        -2
      ],
      [
        3,
        -4
      ],
      [
        1,
        -1
      ],
      [
        3,
        7
      ],
      [
        3,
        9
      ],
      [
        4,
        7
      ],
      [
        2,
        2
      ],
      [
        0,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        5
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        5
      ],
      [
        1,
        9
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        3
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        11
      ],
      [
        0,
        2
      ],
      [
        2,
        3
      ],
      [
        3,
        -1
      ],
      [
        3,
        -3
      ],
      [
        1,
        -4
      ],
      [
        3,
        -5
      ],
      [
        1,
        -3
      ],
      [
        0,
        -7
      ],
      [
        1,
        -1
      ],
      [
        2,
        -3
      ],
      [
        1,
        -3
      ],
      [
        1,
        -3
      ],
      [
        1,
        1
      ],
      [
        5,
        8
      ],
      [
        4,
        -6
      ],
      [
        6,
        -1
      ],
      [
        2,
        -2
      ],
      [
        1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        3,
        -16
      ],
      [
        5,
        -17
      ],
      [
        5,
        -23
      ],
      [
        5,
        -43
      ],
      [
        1,
        -8
      ],
      [
        -5,
        -3
      ],
      [
        -3,
        -11
      ],
      [
        5,
        -14
      ],
      [
        5,
        -18
      ],
      [
        2,
        -12
      ],
      [
        1,
        -12
      ],
      [
        1,
        -9
      ],
      [
        4,
        -16
      ],
      [
        4,
        -46
      ],
      [
        0,
        -3
      ],
      [
        2,
        -6
      ],
      [
        8,
        -25
      ],
      [
        3,
        -1
      ],
      [
        2,
        -6
      ],
      [
        1,
        -11
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -16
      ],
      [
        2,
        -23
      ],
      [
        1,
        -7
      ],
      [
        -4,
        -9
      ],
      [
        -1,
        -5
      ],
      [
        3,
        -28
      ],
      [
        1,
        -11
      ],
      [
        2,
        2
      ],
      [
        0,
        3
      ],
      [
        2,
        4
      ],
      [
        4,
        1
      ],
      [
        1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        -3,
        -8
      ],
      [
        -3,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -9
      ],
      [
        -7,
        -23
      ],
      [
        -1,
        -4
      ],
      [
        -5,
        -4
      ],
      [
        -3,
        8
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -13
      ],
      [
        -3,
        -19
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        3
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -28
      ],
      [
        -7,
        -26
      ],
      [
        -3,
        -1
      ],
      [
        -2,
        -12
      ],
      [
        -2,
        -17
      ],
      [
        0,
        -1
      ],
      [
        -4,
        -7
      ],
      [
        -4,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -8
      ],
      [
        1,
        -9
      ],
      [
        0,
        -3
      ],
      [
        -6,
        -7
      ],
      [
        -6,
        -2
      ],
      [
        -4,
        -13
      ],
      [
        -8,
        -3
      ],
      [
        4,
        -22
      ],
      [
        -9,
        -7
      ],
      [
        -2,
        -2
      ],
      [
        -4,
        1
      ],
      [
        -2,
        13
      ],
      [
        0,
        4
      ],
      [
        3,
        1
      ],
      [
        5,
        24
      ],
      [
        0,
        17
      ],
      [
        -1,
        7
      ],
      [
        -3,
        5
      ],
      [
        0,
        38
      ],
      [
        2,
        6
      ],
      [
        1,
        10
      ],
      [
        -3,
        2
      ],
      [
        -11,
        -9
      ],
      [
        -2,
        0
      ],
      [
        -5,
        -9
      ],
      [
        -6,
        2
      ],
      [
        -3,
        -14
      ],
      [
        7,
        -14
      ],
      [
        0,
        -4
      ],
      [
        2,
        -3
      ],
      [
        2,
        -13
      ],
      [
        1,
        -24
      ],
      [
        -2,
        -8
      ],
      [
        -2,
        -6
      ],
      [
        -3,
        9
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -16
      ],
      [
        -1,
        -12
      ],
      [
        -2,
        -9
      ],
      [
        -2,
        3
      ],
      [
        -2,
        7
      ],
      [
        0,
        5
      ],
      [
        -2,
        2
      ],
      [
        -5,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        -9
      ],
      [
        -4,
        -11
      ],
      [
        -3,
        -6
      ],
      [
        0,
        -23
      ],
      [
        -7,
        -2
      ],
      [
        -5,
        12
      ],
      [
        -1,
        8
      ],
      [
        -10,
        -12
      ],
      [
        1,
        -5
      ],
      [
        2,
        -20
      ],
      [
        -1,
        -10
      ],
      [
        13,
        -25
      ],
      [
        3,
        -15
      ],
      [
        -6,
        -26
      ],
      [
        -5,
        -13
      ],
      [
        -11,
        -18
      ],
      [
        -2,
        17
      ],
      [
        -11,
        29
      ],
      [
        -4,
        23
      ],
      [
        -1,
        22
      ],
      [
        -1,
        12
      ],
      [
        -1,
        2
      ],
      [
        -7,
        -1
      ],
      [
        -3,
        -4
      ],
      [
        -2,
        -7
      ],
      [
        1,
        -14
      ],
      [
        -1,
        -12
      ],
      [
        -3,
        -12
      ],
      [
        -2,
        4
      ],
      [
        -4,
        -2
      ],
      [
        -2,
        1
      ],
      [
        0,
        10
      ],
      [
        1,
        3
      ],
      [
        -1,
        21
      ],
      [
        -3,
        20
      ],
      [
        -1,
        3
      ],
      [
        -3,
        2
      ],
      [
        -2,
        -6
      ],
      [
        -2,
        -14
      ],
      [
        2,
        -20
      ],
      [
        -5,
        -22
      ],
      [
        3,
        -23
      ],
      [
        -4,
        1
      ],
      [
        -3,
        11
      ],
      [
        -5,
        -3
      ],
      [
        -3,
        -21
      ],
      [
        2,
        -10
      ],
      [
        -6,
        -32
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -6
      ],
      [
        -4,
        6
      ],
      [
        -3,
        13
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -2
      ],
      [
        0,
        -8
      ],
      [
        -2,
        -19
      ],
      [
        -2,
        -18
      ],
      [
        -3,
        29
      ],
      [
        -1,
        13
      ],
      [
        -2,
        3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -9
      ],
      [
        -2,
        -11
      ],
      [
        -1,
        0
      ],
      [
        -3,
        5
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -1
      ]
    ],
    [
      [
        30978,
        68642
      ],
      [
        -7,
        68
      ],
      [
        3,
        18
      ],
      [
        -5,
        16
      ],
      [
        -6,
        77
      ],
      [
        -1,
        24
      ],
      [
        6,
        3
      ],
      [
        -1,
        20
      ],
      [
        -5,
        79
      ],
      [
        -5,
        -3
      ],
      [
        -20,
        308
      ],
      [
        4,
        2
      ],
      [
        30,
        18
      ],
      [
        -4,
        78
      ],
      [
        -7,
        140
      ],
      [
        -9,
        127
      ]
    ],
    [
      [
        18872,
        73071
      ],
      [
        38,
        0
      ],
      [
        0,
        808
      ],
      [
        1,
        4
      ],
      [
        0,
        93
      ]
    ],
    [
      [
        18911,
        73976
      ],
      [
        74,
        0
      ],
      [
        33,
        1
      ],
      [
        40,
        1
      ]
    ],
    [
      [
        19058,
        73978
      ],
      [
        0,
        -99
      ],
      [
        -2,
        -404
      ],
      [
        -2,
        -404
      ]
    ],
    [
      [
        19054,
        73071
      ],
      [
        -20,
        0
      ],
      [
        0,
        -101
      ],
      [
        -162,
        -1
      ]
    ],
    [
      [
        18872,
        72969
      ],
      [
        0,
        102
      ]
    ],
    [
      [
        22614,
        70412
      ],
      [
        128,
        0
      ],
      [
        8,
        -1
      ],
      [
        2,
        1
      ],
      [
        46,
        -1
      ],
      [
        2,
        0
      ],
      [
        23,
        1
      ]
    ],
    [
      [
        22823,
        70412
      ],
      [
        0,
        -439
      ]
    ],
    [
      [
        22823,
        69973
      ],
      [
        -38,
        0
      ],
      [
        -2,
        34
      ],
      [
        -169,
        1
      ]
    ],
    [
      [
        22614,
        70008
      ],
      [
        0,
        404
      ]
    ],
    [
      [
        28354,
        67318
      ],
      [
        10,
        4
      ],
      [
        7,
        0
      ],
      [
        3,
        -3
      ],
      [
        11,
        -1
      ],
      [
        14,
        8
      ],
      [
        12,
        -3
      ],
      [
        8,
        7
      ],
      [
        4,
        -3
      ],
      [
        5,
        3
      ],
      [
        12,
        -8
      ],
      [
        9,
        -11
      ],
      [
        10,
        0
      ],
      [
        3,
        3
      ],
      [
        8,
        -5
      ],
      [
        2,
        1
      ],
      [
        9,
        17
      ],
      [
        5,
        8
      ],
      [
        4,
        2
      ],
      [
        3,
        -1
      ],
      [
        6,
        6
      ],
      [
        4,
        8
      ],
      [
        13,
        5
      ],
      [
        7,
        11
      ],
      [
        6,
        15
      ],
      [
        5,
        14
      ],
      [
        2,
        0
      ]
    ],
    [
      [
        28536,
        67395
      ],
      [
        6,
        -307
      ],
      [
        -4,
        -20
      ],
      [
        -1,
        -35
      ],
      [
        2,
        -10
      ]
    ],
    [
      [
        28469,
        67010
      ],
      [
        -47,
        -1
      ],
      [
        -1,
        32
      ],
      [
        -31,
        0
      ],
      [
        0,
        -6
      ],
      [
        -35,
        0
      ]
    ],
    [
      [
        28355,
        67035
      ],
      [
        -1,
        188
      ],
      [
        0,
        95
      ]
    ],
    [
      [
        6173,
        85487
      ],
      [
        189,
        0
      ],
      [
        0,
        -313
      ],
      [
        -263,
        0
      ]
    ],
    [
      [
        6099,
        85174
      ],
      [
        1,
        4
      ],
      [
        21,
        47
      ],
      [
        28,
        55
      ],
      [
        7,
        4
      ],
      [
        -3,
        17
      ],
      [
        0,
        36
      ],
      [
        4,
        27
      ],
      [
        11,
        43
      ],
      [
        4,
        23
      ],
      [
        -1,
        23
      ],
      [
        -5,
        8
      ],
      [
        1,
        14
      ],
      [
        6,
        12
      ]
    ],
    [
      [
        27050,
        48612
      ],
      [
        0,
        152
      ]
    ],
    [
      [
        27050,
        48764
      ],
      [
        55,
        2
      ],
      [
        82,
        0
      ]
    ],
    [
      [
        27187,
        48766
      ],
      [
        1,
        -357
      ]
    ],
    [
      [
        27188,
        48409
      ],
      [
        -117,
        2
      ],
      [
        -3,
        -4
      ],
      [
        -18,
        0
      ]
    ],
    [
      [
        27050,
        48407
      ],
      [
        0,
        205
      ]
    ],
    [
      [
        26217,
        56630
      ],
      [
        0,
        83
      ],
      [
        1,
        54
      ],
      [
        5,
        0
      ],
      [
        0,
        44
      ],
      [
        3,
        0
      ],
      [
        -3,
        8
      ],
      [
        1,
        68
      ],
      [
        0,
        35
      ],
      [
        5,
        0
      ],
      [
        -1,
        53
      ]
    ],
    [
      [
        26228,
        56975
      ],
      [
        4,
        0
      ],
      [
        4,
        -9
      ],
      [
        0,
        15
      ],
      [
        7,
        -16
      ],
      [
        0,
        18
      ],
      [
        25,
        -3
      ],
      [
        7,
        1
      ],
      [
        11,
        0
      ],
      [
        18,
        -1
      ],
      [
        0,
        19
      ],
      [
        23,
        0
      ]
    ],
    [
      [
        26327,
        56999
      ],
      [
        -1,
        -67
      ],
      [
        3,
        0
      ],
      [
        -3,
        -10
      ],
      [
        1,
        -139
      ],
      [
        -2,
        -29
      ],
      [
        0,
        -145
      ]
    ],
    [
      [
        26325,
        56609
      ],
      [
        -12,
        1
      ],
      [
        -10,
        1
      ]
    ],
    [
      [
        26303,
        56611
      ],
      [
        -1,
        3
      ],
      [
        -50,
        0
      ]
    ],
    [
      [
        26252,
        56614
      ],
      [
        -35,
        1
      ],
      [
        0,
        15
      ]
    ],
    [
      [
        23937,
        66074
      ],
      [
        64,
        0
      ]
    ],
    [
      [
        24001,
        66074
      ],
      [
        65,
        1
      ]
    ],
    [
      [
        24066,
        66075
      ],
      [
        0,
        -404
      ]
    ],
    [
      [
        24066,
        65671
      ],
      [
        -129,
        0
      ]
    ],
    [
      [
        23937,
        65671
      ],
      [
        0,
        403
      ]
    ],
    [
      [
        22171,
        61073
      ],
      [
        0,
        203
      ]
    ],
    [
      [
        22171,
        61276
      ],
      [
        61,
        0
      ],
      [
        0,
        -101
      ],
      [
        30,
        -1
      ],
      [
        61,
        1
      ]
    ],
    [
      [
        22323,
        61175
      ],
      [
        0,
        -204
      ],
      [
        3,
        0
      ]
    ],
    [
      [
        22326,
        60971
      ],
      [
        0,
        -107
      ]
    ],
    [
      [
        22326,
        60864
      ],
      [
        -152,
        2
      ]
    ],
    [
      [
        22174,
        60866
      ],
      [
        -1,
        105
      ],
      [
        -2,
        1
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        26405,
        68749
      ],
      [
        135,
        2
      ]
    ],
    [
      [
        26540,
        68751
      ],
      [
        1,
        -404
      ]
    ],
    [
      [
        26541,
        68347
      ],
      [
        -79,
        0
      ]
    ],
    [
      [
        26462,
        68347
      ],
      [
        -56,
        -1
      ]
    ],
    [
      [
        26406,
        68346
      ],
      [
        1,
        17
      ],
      [
        -1,
        33
      ],
      [
        -1,
        353
      ]
    ],
    [
      [
        22401,
        65126
      ],
      [
        126,
        -1
      ]
    ],
    [
      [
        22528,
        65125
      ],
      [
        0,
        -404
      ]
    ],
    [
      [
        22528,
        64721
      ],
      [
        -121,
        0
      ]
    ],
    [
      [
        22407,
        64721
      ],
      [
        -7,
        0
      ]
    ],
    [
      [
        22400,
        64721
      ],
      [
        1,
        405
      ]
    ],
    [
      [
        26542,
        64862
      ],
      [
        128,
        -1
      ]
    ],
    [
      [
        26670,
        64861
      ],
      [
        0,
        -204
      ]
    ],
    [
      [
        26670,
        64657
      ],
      [
        -10,
        0
      ],
      [
        0,
        -50
      ],
      [
        -6,
        0
      ],
      [
        0,
        -51
      ],
      [
        -10,
        0
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        26644,
        64455
      ],
      [
        -102,
        2
      ]
    ],
    [
      [
        26542,
        64457
      ],
      [
        0,
        117
      ]
    ],
    [
      [
        26542,
        64574
      ],
      [
        0,
        288
      ]
    ],
    [
      [
        26302,
        61585
      ],
      [
        10,
        20
      ],
      [
        7,
        24
      ],
      [
        16,
        47
      ],
      [
        12,
        49
      ]
    ],
    [
      [
        26347,
        61725
      ],
      [
        5,
        20
      ],
      [
        1,
        3
      ]
    ],
    [
      [
        26353,
        61748
      ],
      [
        4,
        -33
      ],
      [
        5,
        -16
      ],
      [
        0,
        -20
      ],
      [
        9,
        -19
      ],
      [
        7,
        -28
      ],
      [
        3,
        -23
      ],
      [
        -1,
        -11
      ],
      [
        2,
        -31
      ],
      [
        3,
        -15
      ],
      [
        3,
        -29
      ],
      [
        -3,
        -19
      ]
    ],
    [
      [
        26385,
        61504
      ],
      [
        1,
        -7
      ],
      [
        5,
        -23
      ],
      [
        1,
        -50
      ],
      [
        5,
        -8
      ]
    ],
    [
      [
        26397,
        61416
      ],
      [
        -39,
        -56
      ],
      [
        -22,
        -35
      ],
      [
        -2,
        -15
      ]
    ],
    [
      [
        26334,
        61310
      ],
      [
        -5,
        0
      ],
      [
        2,
        14
      ],
      [
        -4,
        19
      ],
      [
        -1,
        31
      ],
      [
        2,
        6
      ],
      [
        -10,
        6
      ],
      [
        -2,
        -12
      ],
      [
        -4,
        2
      ],
      [
        -5,
        26
      ]
    ],
    [
      [
        26307,
        61402
      ],
      [
        -2,
        15
      ],
      [
        0,
        27
      ],
      [
        -3,
        141
      ]
    ],
    [
      [
        26112,
        58343
      ],
      [
        34,
        135
      ],
      [
        10,
        44
      ],
      [
        -1,
        30
      ],
      [
        4,
        22
      ]
    ],
    [
      [
        26159,
        58574
      ],
      [
        42,
        5
      ],
      [
        5,
        -11
      ],
      [
        13,
        13
      ],
      [
        3,
        -30
      ],
      [
        28,
        26
      ],
      [
        3,
        -8
      ]
    ],
    [
      [
        26253,
        58569
      ],
      [
        -36,
        -167
      ],
      [
        -17,
        -55
      ],
      [
        2,
        -43
      ],
      [
        -5,
        -6
      ],
      [
        -8,
        -44
      ],
      [
        9,
        -18
      ],
      [
        -6,
        -20
      ]
    ],
    [
      [
        26192,
        58216
      ],
      [
        -3,
        -15
      ],
      [
        -6,
        12
      ],
      [
        -6,
        -44
      ],
      [
        -10,
        -74
      ]
    ],
    [
      [
        27615,
        59478
      ],
      [
        56,
        0
      ],
      [
        32,
        -1
      ]
    ],
    [
      [
        27703,
        59477
      ],
      [
        13,
        0
      ],
      [
        43,
        -1
      ]
    ],
    [
      [
        27759,
        59476
      ],
      [
        -5,
        -339
      ]
    ],
    [
      [
        27754,
        59137
      ],
      [
        -1,
        -10
      ]
    ],
    [
      [
        27753,
        59127
      ],
      [
        -37,
        5
      ],
      [
        -56,
        7
      ],
      [
        -47,
        7
      ]
    ],
    [
      [
        27613,
        59146
      ],
      [
        1,
        102
      ],
      [
        1,
        230
      ]
    ],
    [
      [
        21469,
        56883
      ],
      [
        25,
        0
      ]
    ],
    [
      [
        21494,
        56883
      ],
      [
        121,
        -1
      ]
    ],
    [
      [
        21615,
        56882
      ],
      [
        0,
        -561
      ]
    ],
    [
      [
        21615,
        56321
      ],
      [
        -145,
        -7
      ]
    ],
    [
      [
        21470,
        56314
      ],
      [
        -1,
        569
      ]
    ],
    [
      [
        27916,
        61255
      ],
      [
        12,
        36
      ],
      [
        7,
        -10
      ],
      [
        4,
        5
      ],
      [
        3,
        -25
      ],
      [
        -5,
        -39
      ],
      [
        -1,
        2
      ],
      [
        -4,
        -4
      ],
      [
        -3,
        7
      ],
      [
        -2,
        -2
      ],
      [
        -4,
        -14
      ],
      [
        -2,
        21
      ],
      [
        -4,
        3
      ],
      [
        -1,
        6
      ],
      [
        2,
        6
      ],
      [
        -2,
        8
      ]
    ],
    [
      [
        19952,
        67578
      ],
      [
        79,
        1
      ],
      [
        5,
        -2
      ],
      [
        34,
        0
      ]
    ],
    [
      [
        20070,
        67577
      ],
      [
        0,
        -9
      ],
      [
        185,
        0
      ],
      [
        103,
        2
      ]
    ],
    [
      [
        20358,
        67570
      ],
      [
        0,
        -19
      ],
      [
        1,
        -6
      ],
      [
        0,
        -808
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -47
      ],
      [
        2,
        -18
      ],
      [
        -2,
        -4
      ],
      [
        0,
        -332
      ]
    ],
    [
      [
        20358,
        66335
      ],
      [
        -153,
        -3
      ],
      [
        -250,
        4
      ]
    ],
    [
      [
        19955,
        66336
      ],
      [
        -5,
        0
      ],
      [
        -1,
        405
      ],
      [
        12,
        -1
      ],
      [
        0,
        404
      ],
      [
        -4,
        0
      ],
      [
        0,
        401
      ],
      [
        -5,
        0
      ],
      [
        0,
        33
      ]
    ],
    [
      [
        23353,
        52863
      ],
      [
        4,
        15
      ],
      [
        0,
        29
      ],
      [
        17,
        10
      ],
      [
        6,
        -22
      ],
      [
        -4,
        -24
      ],
      [
        4,
        -30
      ],
      [
        8,
        -19
      ]
    ],
    [
      [
        23388,
        52822
      ],
      [
        6,
        -7
      ],
      [
        1,
        -13
      ],
      [
        5,
        -8
      ],
      [
        7,
        -22
      ],
      [
        -2,
        -6
      ],
      [
        2,
        -20
      ],
      [
        -3,
        -18
      ],
      [
        -1,
        -35
      ],
      [
        3,
        -23
      ],
      [
        7,
        -2
      ],
      [
        -2,
        -20
      ],
      [
        1,
        -13
      ],
      [
        3,
        -7
      ],
      [
        4,
        16
      ],
      [
        3,
        -3
      ],
      [
        7,
        13
      ],
      [
        0,
        -11
      ],
      [
        4,
        6
      ],
      [
        0,
        -14
      ],
      [
        8,
        -11
      ],
      [
        -4,
        -6
      ],
      [
        3,
        -26
      ],
      [
        1,
        1
      ],
      [
        1,
        -25
      ],
      [
        -8,
        -24
      ],
      [
        2,
        -8
      ],
      [
        7,
        1
      ],
      [
        11,
        -4
      ],
      [
        4,
        -6
      ],
      [
        3,
        -14
      ],
      [
        8,
        3
      ],
      [
        6,
        -6
      ],
      [
        4,
        -12
      ],
      [
        9,
        0
      ],
      [
        3,
        -6
      ],
      [
        -1,
        -12
      ],
      [
        -5,
        -8
      ],
      [
        -4,
        -15
      ],
      [
        0,
        -18
      ],
      [
        5,
        -2
      ]
    ],
    [
      [
        23486,
        52437
      ],
      [
        2,
        -8
      ],
      [
        -90,
        -165
      ]
    ],
    [
      [
        23398,
        52264
      ],
      [
        -17,
        -30
      ],
      [
        0,
        9
      ],
      [
        6,
        24
      ],
      [
        -4,
        10
      ],
      [
        -5,
        26
      ],
      [
        -7,
        5
      ],
      [
        -13,
        26
      ],
      [
        -2,
        8
      ],
      [
        -10,
        74
      ],
      [
        -2,
        33
      ]
    ],
    [
      [
        25053,
        68952
      ],
      [
        89,
        -2
      ],
      [
        6,
        0
      ],
      [
        41,
        -1
      ],
      [
        37,
        0
      ],
      [
        -1,
        -103
      ]
    ],
    [
      [
        25225,
        68846
      ],
      [
        -36,
        0
      ],
      [
        0,
        -252
      ],
      [
        -1,
        -67
      ],
      [
        0,
        -85
      ]
    ],
    [
      [
        25188,
        68442
      ],
      [
        -7,
        0
      ],
      [
        -34,
        -1
      ]
    ],
    [
      [
        25053,
        68442
      ],
      [
        0,
        510
      ]
    ],
    [
      [
        27250,
        63752
      ],
      [
        1,
        105
      ],
      [
        17,
        -1
      ],
      [
        1,
        151
      ]
    ],
    [
      [
        27269,
        64007
      ],
      [
        15,
        -2
      ],
      [
        33,
        -1
      ],
      [
        44,
        -7
      ]
    ],
    [
      [
        27361,
        63997
      ],
      [
        21,
        -2
      ],
      [
        -1,
        -51
      ],
      [
        -4,
        -256
      ]
    ],
    [
      [
        27377,
        63688
      ],
      [
        -63,
        10
      ],
      [
        -31,
        6
      ],
      [
        -1,
        -3
      ]
    ],
    [
      [
        27282,
        63701
      ],
      [
        -32,
        2
      ],
      [
        0,
        49
      ]
    ],
    [
      [
        26265,
        52709
      ],
      [
        4,
        40
      ],
      [
        3,
        12
      ],
      [
        10,
        11
      ],
      [
        4,
        24
      ],
      [
        3,
        -1
      ],
      [
        1,
        26
      ],
      [
        4,
        15
      ],
      [
        0,
        46
      ],
      [
        4,
        22
      ],
      [
        1,
        170
      ],
      [
        6,
        10
      ],
      [
        0,
        23
      ]
    ],
    [
      [
        26305,
        53107
      ],
      [
        24,
        -2
      ],
      [
        0,
        14
      ],
      [
        28,
        -1
      ]
    ],
    [
      [
        26357,
        53118
      ],
      [
        10,
        -1
      ]
    ],
    [
      [
        26367,
        53117
      ],
      [
        37,
        1
      ]
    ],
    [
      [
        26404,
        53118
      ],
      [
        0,
        -87
      ],
      [
        -1,
        -366
      ]
    ],
    [
      [
        26403,
        52665
      ],
      [
        -27,
        3
      ],
      [
        -16,
        5
      ],
      [
        -2,
        0
      ],
      [
        -18,
        4
      ],
      [
        -11,
        2
      ],
      [
        -53,
        10
      ],
      [
        -8,
        1
      ]
    ],
    [
      [
        26268,
        52690
      ],
      [
        -2,
        12
      ],
      [
        -1,
        7
      ]
    ],
    [
      [
        24104,
        52422
      ],
      [
        1,
        -1
      ],
      [
        37,
        0
      ]
    ],
    [
      [
        24142,
        52421
      ],
      [
        70,
        0
      ],
      [
        0,
        -51
      ],
      [
        19,
        1
      ],
      [
        0,
        -102
      ],
      [
        5,
        -8
      ],
      [
        0,
        -26
      ],
      [
        4,
        0
      ],
      [
        0,
        -25
      ]
    ],
    [
      [
        24240,
        52210
      ],
      [
        0,
        -17
      ],
      [
        -5,
        0
      ],
      [
        0,
        -17
      ],
      [
        -4,
        0
      ],
      [
        0,
        -33
      ],
      [
        -10,
        0
      ],
      [
        0,
        -18
      ],
      [
        -6,
        -7
      ],
      [
        -5,
        -19
      ],
      [
        1,
        -21
      ],
      [
        -8,
        -46
      ],
      [
        -3,
        2
      ]
    ],
    [
      [
        24200,
        52034
      ],
      [
        -1,
        2
      ],
      [
        -2,
        -15
      ],
      [
        -7,
        -22
      ],
      [
        -3,
        -19
      ],
      [
        -12,
        -41
      ],
      [
        -13,
        -20
      ],
      [
        -13,
        15
      ],
      [
        -10,
        20
      ],
      [
        -8,
        34
      ],
      [
        -6,
        9
      ],
      [
        -9,
        -23
      ],
      [
        -5,
        2
      ],
      [
        -5,
        -7
      ]
    ],
    [
      [
        24106,
        51969
      ],
      [
        2,
        14
      ],
      [
        -3,
        35
      ],
      [
        2,
        16
      ],
      [
        3,
        13
      ],
      [
        -3,
        19
      ],
      [
        8,
        8
      ],
      [
        0,
        23
      ],
      [
        2,
        -1
      ],
      [
        -5,
        5
      ],
      [
        -7,
        29
      ],
      [
        1,
        13
      ],
      [
        -1,
        27
      ],
      [
        1,
        43
      ],
      [
        -2,
        15
      ],
      [
        3,
        30
      ],
      [
        -3,
        45
      ],
      [
        6,
        8
      ],
      [
        2,
        17
      ],
      [
        2,
        23
      ],
      [
        -2,
        20
      ],
      [
        -8,
        51
      ]
    ],
    [
      [
        23719,
        69298
      ],
      [
        68,
        -1
      ]
    ],
    [
      [
        23787,
        69297
      ],
      [
        1,
        -4
      ],
      [
        -1,
        -97
      ],
      [
        24,
        0
      ],
      [
        5,
        1
      ],
      [
        5,
        -1
      ],
      [
        18,
        0
      ],
      [
        16,
        1
      ],
      [
        1,
        -4
      ],
      [
        0,
        -98
      ]
    ],
    [
      [
        23856,
        69095
      ],
      [
        -6,
        0
      ],
      [
        -16,
        -25
      ],
      [
        2,
        -8
      ],
      [
        -8,
        -18
      ],
      [
        -3,
        -26
      ],
      [
        2,
        -23
      ],
      [
        2,
        -12
      ],
      [
        -7,
        -18
      ],
      [
        -7,
        3
      ],
      [
        -8,
        -30
      ],
      [
        -14,
        -28
      ],
      [
        -2,
        -12
      ],
      [
        -4,
        6
      ]
    ],
    [
      [
        23787,
        68904
      ],
      [
        0,
        39
      ],
      [
        -33,
        0
      ],
      [
        0,
        51
      ],
      [
        -34,
        0
      ]
    ],
    [
      [
        23720,
        68994
      ],
      [
        0,
        203
      ],
      [
        -1,
        101
      ]
    ],
    [
      [
        25198,
        61320
      ],
      [
        1,
        153
      ]
    ],
    [
      [
        25199,
        61473
      ],
      [
        92,
        -1
      ]
    ],
    [
      [
        25291,
        61472
      ],
      [
        -1,
        -404
      ]
    ],
    [
      [
        25290,
        61068
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        25197,
        61066
      ],
      [
        0,
        52
      ],
      [
        1,
        202
      ]
    ],
    [
      [
        23373,
        69803
      ],
      [
        34,
        0
      ]
    ],
    [
      [
        23407,
        69803
      ],
      [
        103,
        1
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        23511,
        69197
      ],
      [
        -35,
        1
      ],
      [
        -101,
        -2
      ]
    ],
    [
      [
        23375,
        69196
      ],
      [
        0,
        304
      ]
    ],
    [
      [
        23375,
        69500
      ],
      [
        0,
        101
      ],
      [
        -2,
        0
      ],
      [
        0,
        202
      ]
    ],
    [
      [
        25382,
        68439
      ],
      [
        43,
        0
      ],
      [
        1,
        101
      ],
      [
        33,
        0
      ]
    ],
    [
      [
        25459,
        68540
      ],
      [
        63,
        0
      ]
    ],
    [
      [
        25522,
        68540
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -17
      ],
      [
        1,
        -16
      ],
      [
        5,
        -39
      ],
      [
        3,
        -22
      ],
      [
        1,
        -13
      ],
      [
        0,
        -22
      ],
      [
        -1,
        -21
      ],
      [
        -2,
        -15
      ],
      [
        -6,
        -23
      ],
      [
        -6,
        -18
      ],
      [
        -11,
        -15
      ],
      [
        -5,
        -11
      ],
      [
        -7,
        -20
      ],
      [
        -3,
        -27
      ],
      [
        1,
        -17
      ],
      [
        -1,
        -18
      ],
      [
        -4,
        -17
      ],
      [
        -4,
        -20
      ],
      [
        -3,
        -35
      ],
      [
        0,
        -12
      ],
      [
        -1,
        -16
      ],
      [
        -1,
        -11
      ],
      [
        -4,
        -15
      ],
      [
        0,
        -7
      ],
      [
        -3,
        -40
      ],
      [
        -1,
        -13
      ]
    ],
    [
      [
        25469,
        68033
      ],
      [
        -86,
        0
      ]
    ],
    [
      [
        25383,
        68033
      ],
      [
        0,
        34
      ],
      [
        -1,
        68
      ],
      [
        0,
        304
      ]
    ],
    [
      [
        25713,
        54146
      ],
      [
        114,
        3
      ]
    ],
    [
      [
        25827,
        54149
      ],
      [
        0,
        -138
      ],
      [
        2,
        -4
      ],
      [
        -2,
        -13
      ],
      [
        0,
        -152
      ],
      [
        -1,
        -53
      ],
      [
        -14,
        0
      ],
      [
        0,
        -151
      ]
    ],
    [
      [
        25812,
        53638
      ],
      [
        -56,
        -2
      ]
    ],
    [
      [
        25756,
        53636
      ],
      [
        -38,
        1
      ],
      [
        -2,
        13
      ],
      [
        -6,
        12
      ],
      [
        -2,
        37
      ],
      [
        -4,
        16
      ],
      [
        -2,
        29
      ],
      [
        -3,
        18
      ],
      [
        0,
        141
      ]
    ],
    [
      [
        25699,
        53903
      ],
      [
        0,
        90
      ]
    ],
    [
      [
        25699,
        53993
      ],
      [
        -1,
        153
      ],
      [
        15,
        0
      ]
    ],
    [
      [
        26560,
        55508
      ],
      [
        75,
        46
      ]
    ],
    [
      [
        26635,
        55554
      ],
      [
        30,
        16
      ],
      [
        3,
        0
      ]
    ],
    [
      [
        26668,
        55570
      ],
      [
        4,
        -93
      ],
      [
        5,
        -73
      ],
      [
        4,
        -52
      ],
      [
        7,
        -84
      ]
    ],
    [
      [
        26688,
        55268
      ],
      [
        -14,
        -32
      ]
    ],
    [
      [
        26674,
        55236
      ],
      [
        -30,
        -62
      ]
    ],
    [
      [
        26644,
        55174
      ],
      [
        -3,
        -5
      ],
      [
        -11,
        42
      ],
      [
        -4,
        -14
      ],
      [
        -6,
        27
      ],
      [
        -16,
        0
      ],
      [
        -2,
        12
      ],
      [
        -3,
        5
      ],
      [
        -6,
        16
      ],
      [
        -1,
        32
      ],
      [
        -3,
        10
      ]
    ],
    [
      [
        26589,
        55299
      ],
      [
        1,
        16
      ],
      [
        -4,
        11
      ],
      [
        -2,
        44
      ],
      [
        2,
        11
      ],
      [
        -1,
        11
      ],
      [
        -3,
        13
      ],
      [
        -3,
        23
      ],
      [
        -7,
        19
      ],
      [
        -6,
        28
      ],
      [
        -1,
        15
      ],
      [
        -5,
        11
      ],
      [
        0,
        7
      ]
    ],
    [
      [
        23862,
        66888
      ],
      [
        66,
        -1
      ],
      [
        66,
        0
      ]
    ],
    [
      [
        23994,
        66887
      ],
      [
        0,
        -408
      ]
    ],
    [
      [
        23994,
        66479
      ],
      [
        -132,
        1
      ]
    ],
    [
      [
        23862,
        66480
      ],
      [
        0,
        408
      ]
    ],
    [
      [
        26048,
        65276
      ],
      [
        64,
        3
      ],
      [
        64,
        0
      ]
    ],
    [
      [
        26176,
        65279
      ],
      [
        1,
        -305
      ]
    ],
    [
      [
        26177,
        64974
      ],
      [
        -33,
        0
      ]
    ],
    [
      [
        26144,
        64974
      ],
      [
        -32,
        1
      ],
      [
        -32,
        2
      ],
      [
        1,
        33
      ],
      [
        -33,
        0
      ]
    ],
    [
      [
        26048,
        65010
      ],
      [
        0,
        165
      ]
    ],
    [
      [
        26048,
        65175
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        21664,
        63000
      ],
      [
        181,
        0
      ]
    ],
    [
      [
        21845,
        63000
      ],
      [
        5,
        0
      ]
    ],
    [
      [
        21850,
        63000
      ],
      [
        0,
        -506
      ]
    ],
    [
      [
        21850,
        62494
      ],
      [
        -25,
        0
      ]
    ],
    [
      [
        21825,
        62494
      ],
      [
        -162,
        2
      ]
    ],
    [
      [
        21663,
        62496
      ],
      [
        0,
        202
      ],
      [
        1,
        302
      ]
    ],
    [
      [
        26206,
        68350
      ],
      [
        65,
        -3
      ]
    ],
    [
      [
        26271,
        68347
      ],
      [
        68,
        -1
      ]
    ],
    [
      [
        26339,
        68346
      ],
      [
        1,
        -402
      ]
    ],
    [
      [
        26205,
        67942
      ],
      [
        1,
        408
      ]
    ],
    [
      [
        26273,
        69158
      ],
      [
        132,
        -4
      ]
    ],
    [
      [
        26405,
        69154
      ],
      [
        0,
        -405
      ]
    ],
    [
      [
        26405,
        68749
      ],
      [
        -28,
        4
      ],
      [
        -105,
        1
      ]
    ],
    [
      [
        26272,
        68754
      ],
      [
        1,
        404
      ]
    ],
    [
      [
        23981,
        60494
      ],
      [
        0,
        84
      ],
      [
        61,
        -4
      ]
    ],
    [
      [
        24042,
        60574
      ],
      [
        46,
        -3
      ]
    ],
    [
      [
        24088,
        60571
      ],
      [
        -1,
        -254
      ],
      [
        4,
        0
      ],
      [
        -2,
        -229
      ]
    ],
    [
      [
        24089,
        60088
      ],
      [
        -39,
        2
      ],
      [
        -22,
        3
      ]
    ],
    [
      [
        24028,
        60093
      ],
      [
        0,
        17
      ],
      [
        -25,
        2
      ],
      [
        -20,
        2
      ]
    ],
    [
      [
        23983,
        60114
      ],
      [
        1,
        170
      ],
      [
        0,
        41
      ],
      [
        -4,
        0
      ],
      [
        1,
        169
      ]
    ],
    [
      [
        21498,
        65531
      ],
      [
        156,
        1
      ]
    ],
    [
      [
        21654,
        65532
      ],
      [
        5,
        0
      ]
    ],
    [
      [
        21659,
        65532
      ],
      [
        0,
        -405
      ]
    ],
    [
      [
        21659,
        65127
      ],
      [
        -161,
        -1
      ]
    ],
    [
      [
        21498,
        65126
      ],
      [
        0,
        405
      ]
    ],
    [
      [
        22656,
        64869
      ],
      [
        8,
        23
      ],
      [
        9,
        48
      ],
      [
        15,
        38
      ],
      [
        15,
        44
      ],
      [
        8,
        2
      ],
      [
        9,
        12
      ],
      [
        0,
        18
      ]
    ],
    [
      [
        22720,
        65054
      ],
      [
        8,
        5
      ],
      [
        13,
        29
      ],
      [
        20,
        8
      ],
      [
        23,
        32
      ]
    ],
    [
      [
        22784,
        65128
      ],
      [
        0,
        -407
      ]
    ],
    [
      [
        22784,
        64721
      ],
      [
        -127,
        0
      ]
    ],
    [
      [
        22657,
        64721
      ],
      [
        -1,
        4
      ],
      [
        0,
        144
      ]
    ],
    [
      [
        22749,
        69499
      ],
      [
        71,
        0
      ],
      [
        4,
        1
      ]
    ],
    [
      [
        22824,
        69500
      ],
      [
        95,
        -2
      ],
      [
        1,
        -202
      ]
    ],
    [
      [
        22920,
        69296
      ],
      [
        -1,
        -201
      ]
    ],
    [
      [
        22919,
        69095
      ],
      [
        -169,
        0
      ]
    ],
    [
      [
        22384,
        49601
      ],
      [
        131,
        0
      ]
    ],
    [
      [
        22515,
        49601
      ],
      [
        28,
        0
      ]
    ],
    [
      [
        22543,
        49601
      ],
      [
        0,
        -926
      ]
    ],
    [
      [
        22462,
        48678
      ],
      [
        1,
        91
      ],
      [
        -9,
        1
      ],
      [
        0,
        18
      ],
      [
        -10,
        -1
      ],
      [
        0,
        -23
      ],
      [
        -10,
        -1
      ],
      [
        0,
        23
      ],
      [
        -35,
        -1
      ],
      [
        -13,
        -3
      ]
    ],
    [
      [
        22386,
        48782
      ],
      [
        -2,
        819
      ]
    ],
    [
      [
        21448,
        58911
      ],
      [
        151,
        0
      ]
    ],
    [
      [
        21599,
        58409
      ],
      [
        0,
        -5
      ]
    ],
    [
      [
        21448,
        58404
      ],
      [
        0,
        9
      ]
    ],
    [
      [
        21448,
        58413
      ],
      [
        0,
        498
      ]
    ],
    [
      [
        21435,
        54799
      ],
      [
        2,
        0
      ]
    ],
    [
      [
        21437,
        54799
      ],
      [
        143,
        3
      ]
    ],
    [
      [
        21580,
        54802
      ],
      [
        -1,
        -510
      ]
    ],
    [
      [
        21579,
        54292
      ],
      [
        -23,
        -1
      ]
    ],
    [
      [
        21556,
        54291
      ],
      [
        -121,
        0
      ]
    ],
    [
      [
        21435,
        54291
      ],
      [
        0,
        508
      ]
    ],
    [
      [
        26858,
        63910
      ],
      [
        28,
        -6
      ],
      [
        1,
        206
      ],
      [
        0,
        33
      ],
      [
        5,
        0
      ]
    ],
    [
      [
        26892,
        64143
      ],
      [
        69,
        1
      ],
      [
        11,
        5
      ]
    ],
    [
      [
        26972,
        64149
      ],
      [
        33,
        15
      ]
    ],
    [
      [
        27005,
        64164
      ],
      [
        11,
        6
      ],
      [
        -2,
        -136
      ]
    ],
    [
      [
        27014,
        64034
      ],
      [
        0,
        -4
      ],
      [
        -3,
        -249
      ]
    ],
    [
      [
        27011,
        63781
      ],
      [
        -20,
        1
      ],
      [
        -3,
        -1
      ],
      [
        -19,
        1
      ],
      [
        -36,
        7
      ],
      [
        0,
        22
      ],
      [
        -76,
        14
      ]
    ],
    [
      [
        26857,
        63825
      ],
      [
        1,
        85
      ]
    ],
    [
      [
        31366,
        38241
      ],
      [
        3,
        -20
      ],
      [
        -3,
        -45
      ],
      [
        5,
        -26
      ],
      [
        4,
        -23
      ],
      [
        1,
        -24
      ],
      [
        -4,
        -20
      ]
    ],
    [
      [
        31372,
        38083
      ],
      [
        -1,
        -12
      ]
    ],
    [
      [
        31371,
        38071
      ],
      [
        -1,
        -1
      ]
    ],
    [
      [
        31370,
        38070
      ],
      [
        -11,
        24
      ],
      [
        -13,
        -24
      ],
      [
        -3,
        8
      ]
    ],
    [
      [
        31343,
        38078
      ],
      [
        -2,
        13
      ],
      [
        7,
        52
      ],
      [
        1,
        37
      ],
      [
        6,
        -9
      ],
      [
        2,
        53
      ],
      [
        5,
        0
      ],
      [
        4,
        17
      ]
    ],
    [
      [
        22906,
        53851
      ],
      [
        59,
        124
      ]
    ],
    [
      [
        22965,
        53975
      ],
      [
        62,
        -22
      ]
    ],
    [
      [
        23027,
        53953
      ],
      [
        72,
        -446
      ]
    ],
    [
      [
        23099,
        53507
      ],
      [
        -24,
        -46
      ],
      [
        1,
        -19
      ]
    ],
    [
      [
        23076,
        53442
      ],
      [
        -77,
        -159
      ]
    ],
    [
      [
        22942,
        53634
      ],
      [
        -36,
        217
      ]
    ],
    [
      [
        24389,
        66580
      ],
      [
        132,
        3
      ]
    ],
    [
      [
        24521,
        66583
      ],
      [
        0,
        -204
      ],
      [
        1,
        -103
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        24522,
        66175
      ],
      [
        -65,
        1
      ]
    ],
    [
      [
        24457,
        66176
      ],
      [
        -65,
        0
      ]
    ],
    [
      [
        24392,
        66176
      ],
      [
        0,
        201
      ],
      [
        -3,
        0
      ],
      [
        0,
        203
      ]
    ],
    [
      [
        22784,
        64721
      ],
      [
        128,
        -1
      ]
    ],
    [
      [
        22912,
        64720
      ],
      [
        0,
        -405
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        22911,
        64315
      ],
      [
        -127,
        1
      ]
    ],
    [
      [
        22784,
        64316
      ],
      [
        0,
        405
      ]
    ],
    [
      [
        22020,
        50798
      ],
      [
        194,
        6
      ]
    ],
    [
      [
        22214,
        50804
      ],
      [
        2,
        -524
      ]
    ],
    [
      [
        22216,
        50280
      ],
      [
        -24,
        0
      ],
      [
        -9,
        2
      ],
      [
        -164,
        6
      ]
    ],
    [
      [
        22019,
        50288
      ],
      [
        1,
        510
      ]
    ],
    [
      [
        16198,
        63083
      ],
      [
        1,
        -1
      ],
      [
        2,
        1
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        1,
        2
      ],
      [
        1,
        2
      ],
      [
        0,
        3
      ],
      [
        1,
        0
      ],
      [
        1,
        2
      ],
      [
        0,
        4
      ],
      [
        2,
        3
      ],
      [
        1,
        4
      ],
      [
        0,
        6
      ],
      [
        2,
        3
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        0,
        7
      ],
      [
        1,
        3
      ],
      [
        1,
        4
      ],
      [
        1,
        4
      ],
      [
        0,
        7
      ],
      [
        1,
        2
      ],
      [
        0,
        8
      ],
      [
        1,
        3
      ],
      [
        0,
        43
      ],
      [
        4,
        14
      ],
      [
        3,
        5
      ],
      [
        4,
        4
      ],
      [
        2,
        8
      ],
      [
        3,
        5
      ],
      [
        1,
        5
      ],
      [
        2,
        -4
      ],
      [
        1,
        -3
      ],
      [
        4,
        -15
      ],
      [
        1,
        -7
      ],
      [
        1,
        -6
      ],
      [
        3,
        1
      ],
      [
        0,
        -3
      ],
      [
        2,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -13
      ],
      [
        1,
        -8
      ],
      [
        2,
        -5
      ],
      [
        2,
        -3
      ],
      [
        1,
        -5
      ],
      [
        1,
        -5
      ],
      [
        2,
        1
      ],
      [
        2,
        2
      ],
      [
        1,
        5
      ],
      [
        5,
        3
      ],
      [
        2,
        -4
      ],
      [
        2,
        -6
      ],
      [
        3,
        -4
      ],
      [
        3,
        -1
      ],
      [
        1,
        -6
      ],
      [
        2,
        -7
      ],
      [
        2,
        -3
      ],
      [
        3,
        -7
      ],
      [
        1,
        -7
      ],
      [
        1,
        -3
      ],
      [
        2,
        2
      ],
      [
        0,
        2
      ],
      [
        3,
        3
      ],
      [
        2,
        11
      ],
      [
        0,
        10
      ],
      [
        5,
        5
      ],
      [
        46,
        0
      ],
      [
        24,
        2
      ],
      [
        52,
        0
      ],
      [
        15,
        -1
      ]
    ],
    [
      [
        16438,
        63162
      ],
      [
        36,
        2
      ],
      [
        4,
        16
      ]
    ],
    [
      [
        16478,
        63180
      ],
      [
        0,
        -323
      ]
    ],
    [
      [
        16478,
        62857
      ],
      [
        -60,
        0
      ],
      [
        -21,
        1
      ],
      [
        -58,
        0
      ],
      [
        -1,
        2
      ],
      [
        -1,
        3
      ],
      [
        0,
        5
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        0,
        24
      ],
      [
        -1,
        2
      ],
      [
        -1,
        6
      ],
      [
        -2,
        3
      ],
      [
        0,
        5
      ],
      [
        -1,
        6
      ],
      [
        -1,
        3
      ],
      [
        0,
        10
      ],
      [
        -1,
        0
      ],
      [
        0,
        2
      ],
      [
        -2,
        0
      ],
      [
        -1,
        2
      ],
      [
        0,
        3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        0
      ],
      [
        0,
        4
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -2
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        0
      ],
      [
        0,
        -2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        -1,
        2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        0,
        1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        1
      ],
      [
        -1,
        3
      ],
      [
        0,
        1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        0,
        3
      ],
      [
        -1,
        1
      ],
      [
        -2,
        -4
      ],
      [
        0,
        -2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        16240,
        62844
      ],
      [
        0,
        0
      ]
    ],
    [
      [
        16240,
        62844
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        16234,
        62839
      ],
      [
        0,
        0
      ]
    ],
    [
      [
        16234,
        62839
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        0
      ],
      [
        -1,
        2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -1
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        0,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        2
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        -1,
        1
      ],
      [
        0,
        -2
      ],
      [
        -2,
        0
      ],
      [
        0,
        2
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        -6
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        0
      ],
      [
        0,
        -9
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -5
      ]
    ],
    [
      [
        16194,
        62794
      ],
      [
        -3,
        143
      ],
      [
        -4,
        3
      ],
      [
        -3,
        24
      ],
      [
        3,
        13
      ],
      [
        6,
        12
      ],
      [
        5,
        94
      ]
    ],
    [
      [
        25004,
        66413
      ],
      [
        10,
        0
      ]
    ],
    [
      [
        25014,
        66413
      ],
      [
        1,
        0
      ],
      [
        20,
        -2
      ],
      [
        7,
        0
      ],
      [
        4,
        -1
      ],
      [
        1,
        1
      ],
      [
        5,
        0
      ],
      [
        1,
        -1
      ],
      [
        17,
        0
      ],
      [
        11,
        -1
      ],
      [
        7,
        0
      ],
      [
        8,
        -1
      ],
      [
        22,
        0
      ],
      [
        13,
        -1
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        25132,
        66407
      ],
      [
        0,
        -399
      ]
    ],
    [
      [
        25132,
        66008
      ],
      [
        -42,
        -2
      ],
      [
        -23,
        0
      ],
      [
        0,
        63
      ],
      [
        -45,
        -3
      ],
      [
        -17,
        0
      ]
    ],
    [
      [
        25005,
        66066
      ],
      [
        0,
        122
      ],
      [
        -1,
        225
      ]
    ],
    [
      [
        30134,
        67917
      ],
      [
        8,
        -8
      ],
      [
        9,
        6
      ],
      [
        11,
        19
      ],
      [
        13,
        4
      ],
      [
        12,
        -5
      ],
      [
        4,
        10
      ]
    ],
    [
      [
        30191,
        67943
      ],
      [
        1,
        -13
      ],
      [
        4,
        -13
      ],
      [
        9,
        -3
      ],
      [
        10,
        18
      ],
      [
        8,
        -15
      ],
      [
        4,
        -5
      ],
      [
        3,
        -38
      ],
      [
        -3,
        -25
      ],
      [
        -1,
        -38
      ],
      [
        7,
        3
      ],
      [
        5,
        -6
      ],
      [
        1,
        -13
      ],
      [
        3,
        8
      ],
      [
        6,
        -8
      ],
      [
        9,
        30
      ],
      [
        15,
        -52
      ],
      [
        10,
        -30
      ],
      [
        -3,
        -13
      ],
      [
        -7,
        -29
      ],
      [
        28,
        -61
      ],
      [
        0,
        -1
      ],
      [
        11,
        -21
      ]
    ],
    [
      [
        30311,
        67618
      ],
      [
        -2,
        -7
      ],
      [
        -5,
        -26
      ],
      [
        -2,
        -12
      ],
      [
        0,
        -31
      ],
      [
        1,
        -7
      ],
      [
        1,
        -3
      ],
      [
        3,
        -11
      ],
      [
        3,
        7
      ],
      [
        8,
        1
      ],
      [
        -2,
        -15
      ],
      [
        -3,
        -7
      ],
      [
        -5,
        -1
      ],
      [
        -2,
        -6
      ],
      [
        -4,
        -18
      ],
      [
        0,
        -6
      ],
      [
        -2,
        -13
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ],
      [
        -4,
        -6
      ],
      [
        -2,
        -8
      ],
      [
        1,
        -11
      ],
      [
        2,
        -9
      ],
      [
        0,
        -13
      ],
      [
        -3,
        -7
      ],
      [
        -4,
        2
      ],
      [
        -5,
        -16
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        4
      ],
      [
        0,
        1
      ],
      [
        -3,
        2
      ],
      [
        -5,
        -7
      ],
      [
        -3,
        4
      ],
      [
        -1,
        0
      ],
      [
        -5,
        -8
      ],
      [
        0,
        -2
      ],
      [
        -5,
        -15
      ],
      [
        -3,
        -14
      ],
      [
        -2,
        -29
      ],
      [
        -4,
        -18
      ],
      [
        0,
        -3
      ],
      [
        -2,
        -21
      ],
      [
        0,
        -13
      ],
      [
        2,
        -9
      ],
      [
        3,
        -10
      ],
      [
        -1,
        -5
      ],
      [
        -3,
        -21
      ],
      [
        -4,
        -20
      ],
      [
        4,
        -18
      ],
      [
        -2,
        -4
      ],
      [
        -4,
        6
      ],
      [
        -4,
        -18
      ],
      [
        1,
        -22
      ],
      [
        -4,
        -8
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -9
      ],
      [
        -4,
        -18
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -19
      ],
      [
        -2,
        -7
      ],
      [
        -9,
        -13
      ]
    ],
    [
      [
        30213,
        67064
      ],
      [
        0,
        13
      ],
      [
        -1,
        3
      ],
      [
        0,
        2
      ],
      [
        -4,
        0
      ],
      [
        -3,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -2,
        5
      ],
      [
        -3,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        10
      ],
      [
        -1,
        4
      ],
      [
        -1,
        1
      ],
      [
        -3,
        2
      ],
      [
        -1,
        5
      ],
      [
        0,
        1
      ],
      [
        -3,
        7
      ],
      [
        -4,
        12
      ],
      [
        -3,
        7
      ]
    ],
    [
      [
        30181,
        67138
      ],
      [
        -2,
        5
      ],
      [
        -1,
        2
      ],
      [
        0,
        11
      ],
      [
        -1,
        6
      ],
      [
        0,
        4
      ],
      [
        1,
        13
      ],
      [
        1,
        10
      ],
      [
        -1,
        3
      ],
      [
        1,
        3
      ],
      [
        0,
        1
      ],
      [
        1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        6
      ],
      [
        -1,
        8
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        5
      ],
      [
        -1,
        2
      ],
      [
        2,
        18
      ],
      [
        0,
        1
      ],
      [
        1,
        2
      ],
      [
        1,
        8
      ],
      [
        0,
        1
      ],
      [
        -1,
        3
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        7
      ],
      [
        -1,
        3
      ],
      [
        0,
        1
      ],
      [
        -1,
        2
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        0,
        9
      ],
      [
        -1,
        4
      ],
      [
        -2,
        3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        1
      ],
      [
        0,
        4
      ],
      [
        -1,
        4
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        -2,
        5
      ],
      [
        -3,
        3
      ],
      [
        0,
        6
      ],
      [
        -1,
        6
      ],
      [
        -1,
        2
      ],
      [
        -2,
        1
      ],
      [
        0,
        2
      ],
      [
        -2,
        5
      ],
      [
        -1,
        3
      ],
      [
        1,
        3
      ],
      [
        1,
        3
      ],
      [
        0,
        7
      ],
      [
        -2,
        0
      ],
      [
        0,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        13
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -2,
        5
      ],
      [
        -2,
        5
      ],
      [
        0,
        2
      ],
      [
        -1,
        4
      ],
      [
        0,
        3
      ],
      [
        -1,
        1
      ],
      [
        -4,
        -4
      ],
      [
        0,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        4
      ],
      [
        0,
        4
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        -2,
        13
      ],
      [
        0,
        9
      ],
      [
        -1,
        5
      ],
      [
        -1,
        8
      ],
      [
        -1,
        3
      ],
      [
        0,
        3
      ],
      [
        -1,
        1
      ],
      [
        0,
        5
      ],
      [
        1,
        3
      ],
      [
        -1,
        3
      ],
      [
        0,
        5
      ],
      [
        1,
        1
      ],
      [
        0,
        6
      ],
      [
        -1,
        2
      ],
      [
        0,
        15
      ],
      [
        1,
        6
      ],
      [
        2,
        3
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        0,
        11
      ],
      [
        2,
        4
      ],
      [
        0,
        6
      ],
      [
        -1,
        5
      ],
      [
        0,
        7
      ],
      [
        1,
        4
      ],
      [
        1,
        11
      ],
      [
        -1,
        4
      ],
      [
        -1,
        4
      ],
      [
        0,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        0,
        3
      ],
      [
        1,
        3
      ],
      [
        1,
        3
      ],
      [
        -1,
        1
      ],
      [
        0,
        3
      ],
      [
        1,
        6
      ],
      [
        1,
        7
      ],
      [
        1,
        2
      ],
      [
        0,
        10
      ],
      [
        1,
        2
      ],
      [
        0,
        17
      ],
      [
        -1,
        1
      ],
      [
        0,
        8
      ],
      [
        -1,
        3
      ],
      [
        0,
        8
      ]
    ],
    [
      [
        30141,
        67625
      ],
      [
        2,
        1
      ],
      [
        0,
        -2
      ],
      [
        1,
        12
      ],
      [
        0,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        6
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        -2,
        7
      ],
      [
        -1,
        2
      ],
      [
        -1,
        51
      ],
      [
        0,
        12
      ],
      [
        -1,
        89
      ],
      [
        0,
        1
      ],
      [
        -1,
        11
      ],
      [
        1,
        4
      ],
      [
        -1,
        44
      ],
      [
        -1,
        46
      ]
    ],
    [
      [
        28752,
        62244
      ],
      [
        -1,
        23
      ],
      [
        4,
        26
      ],
      [
        -1,
        18
      ],
      [
        6,
        28
      ],
      [
        8,
        21
      ],
      [
        6,
        45
      ],
      [
        6,
        17
      ],
      [
        0,
        16
      ],
      [
        3,
        27
      ],
      [
        13,
        28
      ],
      [
        12,
        12
      ]
    ],
    [
      [
        28808,
        62505
      ],
      [
        0,
        -32
      ],
      [
        1,
        -24
      ],
      [
        0,
        -24
      ],
      [
        4,
        -208
      ],
      [
        1,
        -30
      ],
      [
        0,
        -27
      ],
      [
        1,
        -16
      ],
      [
        0,
        -3
      ]
    ],
    [
      [
        28815,
        62141
      ],
      [
        0,
        -33
      ],
      [
        1,
        -42
      ],
      [
        1,
        -70
      ],
      [
        2,
        -82
      ]
    ],
    [
      [
        28819,
        61914
      ],
      [
        -15,
        59
      ],
      [
        -10,
        -11
      ],
      [
        -1,
        23
      ],
      [
        -10,
        9
      ],
      [
        -8,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        -6,
        1
      ],
      [
        -2,
        7
      ],
      [
        -2,
        -16
      ],
      [
        -9,
        -12
      ],
      [
        -2,
        -4
      ]
    ],
    [
      [
        28753,
        61959
      ],
      [
        -8,
        12
      ],
      [
        -1,
        16
      ],
      [
        -5,
        -1
      ],
      [
        0,
        13
      ],
      [
        -4,
        15
      ],
      [
        -2,
        9
      ],
      [
        6,
        15
      ],
      [
        -1,
        12
      ],
      [
        9,
        32
      ],
      [
        5,
        -1
      ],
      [
        4,
        20
      ],
      [
        7,
        12
      ],
      [
        3,
        7
      ],
      [
        -8,
        31
      ],
      [
        1,
        19
      ],
      [
        -7,
        34
      ],
      [
        0,
        40
      ]
    ],
    [
      [
        26407,
        69554
      ],
      [
        33,
        0
      ]
    ],
    [
      [
        26440,
        69554
      ],
      [
        63,
        0
      ],
      [
        39,
        4
      ]
    ],
    [
      [
        26542,
        69558
      ],
      [
        -1,
        -49
      ],
      [
        1,
        -150
      ],
      [
        -3,
        -1
      ],
      [
        1,
        -202
      ]
    ],
    [
      [
        26540,
        69156
      ],
      [
        -91,
        -2
      ],
      [
        -44,
        0
      ]
    ],
    [
      [
        26405,
        69154
      ],
      [
        2,
        400
      ]
    ],
    [
      [
        22945,
        71224
      ],
      [
        0,
        -2
      ],
      [
        2,
        -2
      ]
    ],
    [
      [
        22947,
        71220
      ],
      [
        0,
        -9
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        -1,
        -5
      ],
      [
        1,
        -2
      ],
      [
        0,
        -8
      ],
      [
        1,
        -3
      ],
      [
        1,
        0
      ],
      [
        1,
        -4
      ],
      [
        0,
        -7
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        0,
        -7
      ],
      [
        1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        1,
        -9
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -7
      ],
      [
        1,
        -4
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        1,
        -4
      ],
      [
        1,
        -4
      ],
      [
        0,
        -32
      ],
      [
        1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -6
      ],
      [
        1,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        2,
        -2
      ],
      [
        0,
        -4
      ],
      [
        1,
        -1
      ],
      [
        1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        1,
        -2
      ],
      [
        0,
        -11
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        1,
        0
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -5
      ],
      [
        1,
        -2
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        0,
        -6
      ],
      [
        1,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -9
      ],
      [
        1,
        0
      ],
      [
        0,
        -6
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        0,
        1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        3,
        -17
      ],
      [
        0,
        -17
      ],
      [
        1,
        -1
      ],
      [
        2,
        -1
      ],
      [
        0,
        -4
      ],
      [
        1,
        -5
      ],
      [
        1,
        -3
      ],
      [
        1,
        -1
      ],
      [
        0,
        -10
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        2,
        3
      ],
      [
        1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        2,
        -2
      ],
      [
        1,
        -4
      ],
      [
        0,
        -5
      ],
      [
        1,
        -3
      ],
      [
        2,
        -6
      ],
      [
        2,
        -2
      ],
      [
        0,
        -13
      ],
      [
        1,
        -6
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -10
      ],
      [
        0,
        -6
      ],
      [
        1,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -2
      ],
      [
        1,
        -1
      ],
      [
        0,
        -18
      ],
      [
        1,
        -2
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -2
      ],
      [
        1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -9
      ],
      [
        1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -27
      ],
      [
        2,
        -2
      ],
      [
        1,
        -10
      ],
      [
        0,
        -6
      ],
      [
        1,
        0
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        1,
        -2
      ],
      [
        0,
        -8
      ],
      [
        1,
        0
      ],
      [
        0,
        -7
      ],
      [
        1,
        -2
      ],
      [
        0,
        -25
      ],
      [
        1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        2,
        -11
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        2,
        -5
      ],
      [
        0,
        -4
      ],
      [
        -2,
        -1
      ],
      [
        1,
        -4
      ],
      [
        0,
        -4
      ],
      [
        2,
        -4
      ],
      [
        0,
        -21
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -14
      ],
      [
        0,
        -16
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -16
      ],
      [
        -2,
        -13
      ],
      [
        1,
        -4
      ],
      [
        0,
        -2
      ]
    ],
    [
      [
        23005,
        70512
      ],
      [
        0,
        -20
      ],
      [
        1,
        -2
      ],
      [
        0,
        -45
      ],
      [
        2,
        -16
      ],
      [
        1,
        -3
      ],
      [
        0,
        -12
      ],
      [
        -1,
        -2
      ]
    ],
    [
      [
        23008,
        70412
      ],
      [
        -185,
        0
      ]
    ],
    [
      [
        22823,
        70412
      ],
      [
        0,
        66
      ],
      [
        -9,
        6
      ],
      [
        1,
        332
      ],
      [
        -6,
        0
      ]
    ],
    [
      [
        22809,
        70816
      ],
      [
        0,
        404
      ]
    ],
    [
      [
        27478,
        64246
      ],
      [
        0,
        248
      ]
    ],
    [
      [
        27478,
        64494
      ],
      [
        55,
        2
      ],
      [
        46,
        2
      ]
    ],
    [
      [
        27579,
        64498
      ],
      [
        1,
        -78
      ],
      [
        1,
        -51
      ],
      [
        1,
        -81
      ]
    ],
    [
      [
        27582,
        64288
      ],
      [
        0,
        -1
      ],
      [
        1,
        -70
      ],
      [
        -4,
        -5
      ],
      [
        -6,
        0
      ],
      [
        -2,
        -15
      ],
      [
        -6,
        -10
      ],
      [
        -1,
        -6
      ],
      [
        -5,
        -11
      ],
      [
        -13,
        -43
      ],
      [
        -23,
        -68
      ]
    ],
    [
      [
        27523,
        64059
      ],
      [
        -1,
        0
      ],
      [
        -44,
        -1
      ]
    ],
    [
      [
        27478,
        64058
      ],
      [
        0,
        188
      ]
    ],
    [
      [
        21199,
        55806
      ],
      [
        1,
        212
      ]
    ],
    [
      [
        21200,
        56018
      ],
      [
        1,
        69
      ],
      [
        0,
        136
      ],
      [
        1,
        91
      ]
    ],
    [
      [
        21202,
        56314
      ],
      [
        120,
        1
      ]
    ],
    [
      [
        26339,
        68346
      ],
      [
        67,
        0
      ]
    ],
    [
      [
        26462,
        68347
      ],
      [
        0,
        -192
      ]
    ],
    [
      [
        26462,
        68155
      ],
      [
        0,
        -199
      ]
    ],
    [
      [
        26462,
        67956
      ],
      [
        -55,
        3
      ],
      [
        -1,
        -17
      ],
      [
        -66,
        2
      ]
    ],
    [
      [
        21018,
        63200
      ],
      [
        1,
        304
      ]
    ],
    [
      [
        21019,
        63504
      ],
      [
        65,
        0
      ],
      [
        0,
        406
      ],
      [
        1,
        101
      ]
    ],
    [
      [
        21085,
        64011
      ],
      [
        17,
        0
      ],
      [
        5,
        -1
      ],
      [
        169,
        3
      ]
    ],
    [
      [
        21276,
        64013
      ],
      [
        0,
        -102
      ],
      [
        -3,
        1
      ],
      [
        0,
        -406
      ],
      [
        -3,
        0
      ],
      [
        0,
        -506
      ]
    ],
    [
      [
        21270,
        63000
      ],
      [
        -98,
        -3
      ]
    ],
    [
      [
        21172,
        62997
      ],
      [
        -2,
        0
      ],
      [
        -152,
        1
      ]
    ],
    [
      [
        21018,
        62998
      ],
      [
        0,
        202
      ]
    ],
    [
      [
        24257,
        66578
      ],
      [
        44,
        0
      ],
      [
        22,
        2
      ],
      [
        66,
        0
      ]
    ],
    [
      [
        24392,
        66176
      ],
      [
        -65,
        3
      ]
    ],
    [
      [
        24327,
        66179
      ],
      [
        -33,
        -2
      ],
      [
        -32,
        0
      ]
    ],
    [
      [
        23599,
        66582
      ],
      [
        131,
        -1
      ]
    ],
    [
      [
        23730,
        66581
      ],
      [
        1,
        -101
      ]
    ],
    [
      [
        23731,
        66480
      ],
      [
        -1,
        -100
      ],
      [
        12,
        0
      ],
      [
        0,
        -305
      ]
    ],
    [
      [
        23742,
        66075
      ],
      [
        -65,
        0
      ]
    ],
    [
      [
        23677,
        66075
      ],
      [
        -65,
        -1
      ]
    ],
    [
      [
        23612,
        66074
      ],
      [
        0,
        308
      ],
      [
        -13,
        0
      ],
      [
        0,
        99
      ]
    ],
    [
      [
        23599,
        66481
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        21988,
        61074
      ],
      [
        98,
        -1
      ],
      [
        85,
        0
      ]
    ],
    [
      [
        22174,
        60866
      ],
      [
        1,
        -311
      ]
    ],
    [
      [
        22175,
        60555
      ],
      [
        -61,
        0
      ],
      [
        -62,
        6
      ],
      [
        -31,
        2
      ]
    ],
    [
      [
        22021,
        60563
      ],
      [
        -30,
        1
      ]
    ],
    [
      [
        21991,
        60564
      ],
      [
        0,
        409
      ],
      [
        -3,
        0
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        26540,
        69156
      ],
      [
        0,
        -405
      ]
    ],
    [
      [
        25027,
        55275
      ],
      [
        42,
        0
      ],
      [
        42,
        -1
      ],
      [
        14,
        -5
      ],
      [
        10,
        -9
      ],
      [
        0,
        9
      ],
      [
        4,
        0
      ]
    ],
    [
      [
        25139,
        55269
      ],
      [
        0,
        -407
      ]
    ],
    [
      [
        25139,
        54862
      ],
      [
        -14,
        -1
      ],
      [
        -3,
        1
      ],
      [
        -95,
        -1
      ]
    ],
    [
      [
        25027,
        54861
      ],
      [
        0,
        414
      ]
    ],
    [
      [
        22150,
        64300
      ],
      [
        17,
        -9
      ],
      [
        11,
        4
      ],
      [
        4,
        -6
      ],
      [
        24,
        3
      ],
      [
        7,
        -8
      ]
    ],
    [
      [
        22213,
        64284
      ],
      [
        2,
        -4
      ],
      [
        10,
        -4
      ],
      [
        12,
        8
      ],
      [
        8,
        -8
      ],
      [
        16,
        -6
      ],
      [
        19,
        2
      ]
    ],
    [
      [
        22280,
        64272
      ],
      [
        0,
        -361
      ]
    ],
    [
      [
        22280,
        63911
      ],
      [
        -126,
        0
      ]
    ],
    [
      [
        22154,
        63911
      ],
      [
        -3,
        0
      ]
    ],
    [
      [
        22151,
        63911
      ],
      [
        -1,
        389
      ]
    ],
    [
      [
        22881,
        65936
      ],
      [
        55,
        0
      ]
    ],
    [
      [
        22936,
        65936
      ],
      [
        75,
        -1
      ],
      [
        0,
        -86
      ]
    ],
    [
      [
        23011,
        65849
      ],
      [
        0,
        -319
      ]
    ],
    [
      [
        23011,
        65530
      ],
      [
        -98,
        1
      ]
    ],
    [
      [
        22913,
        65531
      ],
      [
        -32,
        1
      ]
    ],
    [
      [
        22881,
        65532
      ],
      [
        0,
        404
      ]
    ],
    [
      [
        26906,
        57850
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        0,
        3
      ],
      [
        1,
        2
      ],
      [
        1,
        0
      ],
      [
        0,
        -1
      ],
      [
        1,
        1
      ],
      [
        0,
        6
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        2,
        0
      ],
      [
        1,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        1,
        0
      ],
      [
        1,
        2
      ],
      [
        2,
        2
      ],
      [
        0,
        3
      ],
      [
        1,
        2
      ],
      [
        0,
        1
      ],
      [
        5,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        6
      ],
      [
        1,
        3
      ],
      [
        1,
        2
      ],
      [
        2,
        2
      ],
      [
        1,
        -1
      ],
      [
        1,
        0
      ],
      [
        3,
        4
      ],
      [
        1,
        -1
      ],
      [
        1,
        -3
      ],
      [
        0,
        -11
      ],
      [
        1,
        -1
      ],
      [
        2,
        1
      ],
      [
        1,
        3
      ],
      [
        1,
        3
      ],
      [
        2,
        15
      ],
      [
        1,
        11
      ],
      [
        1,
        7
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        2,
        2
      ],
      [
        3,
        11
      ],
      [
        0,
        2
      ],
      [
        1,
        0
      ],
      [
        2,
        -6
      ],
      [
        0,
        -3
      ],
      [
        1,
        -6
      ],
      [
        0,
        -18
      ],
      [
        2,
        -6
      ],
      [
        1,
        0
      ],
      [
        1,
        3
      ],
      [
        1,
        2
      ],
      [
        0,
        5
      ],
      [
        2,
        2
      ]
    ],
    [
      [
        26967,
        57906
      ],
      [
        1,
        1
      ],
      [
        2,
        0
      ],
      [
        1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        1,
        0
      ],
      [
        1,
        2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        4
      ],
      [
        1,
        3
      ],
      [
        0,
        1
      ],
      [
        2,
        2
      ],
      [
        4,
        2
      ],
      [
        1,
        5
      ],
      [
        2,
        1
      ],
      [
        2,
        0
      ],
      [
        5,
        -1
      ],
      [
        8,
        -3
      ],
      [
        4,
        0
      ]
    ],
    [
      [
        27006,
        57911
      ],
      [
        -1,
        -185
      ],
      [
        -1,
        -104
      ],
      [
        0,
        -41
      ],
      [
        -1,
        -11
      ],
      [
        0,
        -62
      ],
      [
        1,
        4
      ],
      [
        3,
        -12
      ],
      [
        0,
        -2
      ],
      [
        1,
        0
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        1,
        0
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        1,
        -5
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        1,
        -1
      ],
      [
        0,
        -5
      ],
      [
        1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        1,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        1
      ],
      [
        0,
        -4
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -6
      ],
      [
        4,
        -18
      ],
      [
        1,
        5
      ]
    ],
    [
      [
        27025,
        57433
      ],
      [
        -5,
        -44
      ],
      [
        -4,
        -34
      ],
      [
        0,
        -7
      ],
      [
        -5,
        -42
      ],
      [
        -4,
        -35
      ],
      [
        -7,
        -69
      ],
      [
        0,
        -60
      ],
      [
        -22,
        -60
      ]
    ],
    [
      [
        26978,
        57082
      ],
      [
        -14,
        37
      ],
      [
        -6,
        27
      ],
      [
        -8,
        16
      ],
      [
        -3,
        51
      ],
      [
        -8,
        33
      ],
      [
        0,
        38
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        14
      ],
      [
        3,
        15
      ],
      [
        -3,
        29
      ],
      [
        1,
        46
      ],
      [
        2,
        7
      ],
      [
        0,
        16
      ],
      [
        1,
        14
      ],
      [
        -2,
        3
      ],
      [
        0,
        20
      ],
      [
        -8,
        27
      ]
    ],
    [
      [
        26930,
        57472
      ],
      [
        2,
        5
      ],
      [
        -2,
        10
      ],
      [
        2,
        10
      ],
      [
        -2,
        0
      ],
      [
        1,
        13
      ],
      [
        0,
        8
      ],
      [
        -1,
        2
      ],
      [
        0,
        17
      ],
      [
        -1,
        4
      ],
      [
        0,
        8
      ],
      [
        -1,
        4
      ],
      [
        0,
        7
      ],
      [
        -6,
        36
      ],
      [
        -1,
        1
      ],
      [
        -2,
        30
      ],
      [
        0,
        16
      ],
      [
        -6,
        14
      ],
      [
        4,
        9
      ],
      [
        -2,
        21
      ],
      [
        1,
        14
      ],
      [
        -16,
        -9
      ],
      [
        3,
        28
      ],
      [
        -4,
        10
      ],
      [
        2,
        22
      ],
      [
        5,
        5
      ],
      [
        1,
        12
      ],
      [
        -5,
        -1
      ],
      [
        -15,
        -16
      ],
      [
        -10,
        6
      ],
      [
        -11,
        -12
      ],
      [
        -9,
        -8
      ],
      [
        -4,
        24
      ]
    ],
    [
      [
        26853,
        57762
      ],
      [
        2,
        -1
      ],
      [
        1,
        2
      ],
      [
        1,
        5
      ],
      [
        0,
        6
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        1,
        2
      ],
      [
        1,
        4
      ],
      [
        1,
        4
      ],
      [
        1,
        2
      ],
      [
        0,
        7
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        2,
        0
      ],
      [
        2,
        4
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        0,
        -1
      ],
      [
        1,
        2
      ],
      [
        2,
        7
      ],
      [
        0,
        5
      ],
      [
        -1,
        3
      ],
      [
        0,
        6
      ],
      [
        1,
        2
      ],
      [
        0,
        1
      ],
      [
        1,
        1
      ],
      [
        0,
        7
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        1,
        -1
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ],
      [
        1,
        3
      ],
      [
        0,
        4
      ],
      [
        2,
        4
      ],
      [
        1,
        1
      ],
      [
        2,
        -4
      ],
      [
        2,
        0
      ],
      [
        0,
        2
      ],
      [
        1,
        3
      ],
      [
        1,
        5
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        2,
        0
      ],
      [
        1,
        -1
      ],
      [
        2,
        1
      ],
      [
        1,
        5
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ]
    ],
    [
      [
        21868,
        55312
      ],
      [
        38,
        -1
      ]
    ],
    [
      [
        21906,
        55311
      ],
      [
        105,
        -3
      ]
    ],
    [
      [
        22011,
        55308
      ],
      [
        -1,
        -509
      ]
    ],
    [
      [
        22010,
        54799
      ],
      [
        -143,
        3
      ]
    ],
    [
      [
        21867,
        54802
      ],
      [
        1,
        510
      ]
    ],
    [
      [
        28042,
        59050
      ],
      [
        3,
        0
      ],
      [
        18,
        -12
      ],
      [
        2,
        6
      ],
      [
        10,
        76
      ],
      [
        11,
        -1
      ],
      [
        9,
        37
      ]
    ],
    [
      [
        28095,
        59156
      ],
      [
        23,
        -11
      ],
      [
        8,
        -11
      ],
      [
        6,
        10
      ],
      [
        5,
        -13
      ],
      [
        6,
        2
      ],
      [
        3,
        -24
      ],
      [
        6,
        -19
      ],
      [
        8,
        8
      ],
      [
        8,
        -1
      ],
      [
        10,
        -15
      ]
    ],
    [
      [
        28178,
        59082
      ],
      [
        -7,
        -48
      ],
      [
        -4,
        -23
      ],
      [
        -1,
        -8
      ],
      [
        -6,
        -37
      ],
      [
        -4,
        -25
      ],
      [
        -47,
        -306
      ]
    ],
    [
      [
        28109,
        58635
      ],
      [
        1,
        11
      ],
      [
        -5,
        20
      ],
      [
        -4,
        34
      ],
      [
        -6,
        26
      ],
      [
        -4,
        -2
      ],
      [
        -9,
        19
      ],
      [
        0,
        23
      ],
      [
        -12,
        7
      ],
      [
        -9,
        44
      ],
      [
        -16,
        29
      ],
      [
        -17,
        26
      ]
    ],
    [
      [
        28028,
        58872
      ],
      [
        1,
        68
      ],
      [
        6,
        51
      ],
      [
        7,
        59
      ]
    ],
    [
      [
        26285,
        65163
      ],
      [
        128,
        1
      ]
    ],
    [
      [
        26413,
        65164
      ],
      [
        32,
        1
      ],
      [
        0,
        -305
      ]
    ],
    [
      [
        26445,
        64860
      ],
      [
        -32,
        -1
      ]
    ],
    [
      [
        26413,
        64859
      ],
      [
        0,
        51
      ],
      [
        -32,
        0
      ],
      [
        0,
        52
      ],
      [
        -96,
        -1
      ]
    ],
    [
      [
        26285,
        64961
      ],
      [
        0,
        21
      ]
    ],
    [
      [
        26285,
        64982
      ],
      [
        0,
        181
      ]
    ],
    [
      [
        25615,
        58187
      ],
      [
        13,
        2
      ],
      [
        3,
        14
      ],
      [
        6,
        10
      ],
      [
        8,
        -7
      ],
      [
        2,
        -9
      ],
      [
        6,
        -2
      ],
      [
        3,
        -11
      ],
      [
        8,
        1
      ],
      [
        4,
        -19
      ],
      [
        7,
        -9
      ],
      [
        2,
        14
      ],
      [
        7,
        -3
      ]
    ],
    [
      [
        25684,
        58168
      ],
      [
        10,
        -17
      ],
      [
        -1,
        -32
      ],
      [
        2,
        -27
      ],
      [
        5,
        -17
      ],
      [
        -1,
        -27
      ],
      [
        5,
        1
      ],
      [
        0,
        -10
      ],
      [
        8,
        -9
      ],
      [
        4,
        26
      ],
      [
        5,
        -32
      ],
      [
        0,
        -35
      ]
    ],
    [
      [
        25721,
        57989
      ],
      [
        -3,
        -316
      ]
    ],
    [
      [
        25718,
        57673
      ],
      [
        -7,
        0
      ],
      [
        -29,
        3
      ],
      [
        -2,
        0
      ],
      [
        -7,
        1
      ],
      [
        -3,
        0
      ],
      [
        -31,
        2
      ],
      [
        -25,
        2
      ]
    ],
    [
      [
        25614,
        57681
      ],
      [
        -2,
        0
      ],
      [
        -2,
        1
      ]
    ],
    [
      [
        25610,
        57682
      ],
      [
        0,
        57
      ],
      [
        3,
        87
      ],
      [
        5,
        46
      ],
      [
        -7,
        12
      ],
      [
        2,
        63
      ],
      [
        0,
        69
      ],
      [
        -5,
        7
      ],
      [
        5,
        4
      ],
      [
        0,
        99
      ],
      [
        2,
        61
      ]
    ],
    [
      [
        22197,
        56325
      ],
      [
        146,
        0
      ]
    ],
    [
      [
        22343,
        56325
      ],
      [
        -1,
        -508
      ]
    ],
    [
      [
        22342,
        55817
      ],
      [
        -144,
        2
      ]
    ],
    [
      [
        22198,
        55819
      ],
      [
        -1,
        389
      ]
    ],
    [
      [
        22197,
        56208
      ],
      [
        0,
        117
      ]
    ],
    [
      [
        23586,
        54649
      ],
      [
        10,
        -29
      ],
      [
        4,
        -8
      ],
      [
        11,
        8
      ],
      [
        5,
        -3
      ],
      [
        1,
        -28
      ],
      [
        3,
        4
      ],
      [
        5,
        -23
      ],
      [
        86,
        77
      ]
    ],
    [
      [
        23711,
        54647
      ],
      [
        0,
        -229
      ]
    ],
    [
      [
        23711,
        54418
      ],
      [
        0,
        -237
      ],
      [
        1,
        0
      ],
      [
        2,
        4
      ],
      [
        3,
        -6
      ],
      [
        2,
        -10
      ]
    ],
    [
      [
        23719,
        54169
      ],
      [
        -1,
        -2
      ],
      [
        -138,
        -7
      ]
    ],
    [
      [
        23580,
        54160
      ],
      [
        -25,
        -1
      ],
      [
        0,
        124
      ],
      [
        2,
        37
      ],
      [
        4,
        56
      ],
      [
        0,
        50
      ],
      [
        6,
        54
      ],
      [
        8,
        27
      ],
      [
        3,
        39
      ],
      [
        7,
        59
      ],
      [
        1,
        44
      ]
    ],
    [
      [
        16763,
        71956
      ],
      [
        245,
        -1
      ],
      [
        6,
        -1
      ],
      [
        33,
        0
      ]
    ],
    [
      [
        17047,
        71954
      ],
      [
        -2,
        -402
      ],
      [
        -1,
        -55
      ],
      [
        -9,
        -22
      ],
      [
        3,
        -12
      ],
      [
        -1,
        -18
      ],
      [
        -7,
        -13
      ],
      [
        2,
        -31
      ],
      [
        -6,
        0
      ],
      [
        -3,
        -20
      ],
      [
        -14,
        13
      ],
      [
        -8,
        -21
      ],
      [
        -8,
        -2
      ],
      [
        -2,
        -14
      ],
      [
        -8,
        5
      ],
      [
        -6,
        -15
      ]
    ],
    [
      [
        16977,
        71347
      ],
      [
        -65,
        -2
      ],
      [
        -257,
        1
      ]
    ],
    [
      [
        16655,
        71346
      ],
      [
        0,
        203
      ],
      [
        107,
        -1
      ],
      [
        1,
        408
      ]
    ],
    [
      [
        23742,
        66075
      ],
      [
        65,
        -1
      ]
    ],
    [
      [
        23807,
        66074
      ],
      [
        0,
        -402
      ]
    ],
    [
      [
        23807,
        65672
      ],
      [
        -33,
        0
      ]
    ],
    [
      [
        23774,
        65672
      ],
      [
        -65,
        -1
      ],
      [
        -32,
        1
      ]
    ],
    [
      [
        23677,
        65672
      ],
      [
        0,
        403
      ]
    ],
    [
      [
        22491,
        55815
      ],
      [
        0,
        83
      ]
    ],
    [
      [
        22491,
        55898
      ],
      [
        123,
        0
      ]
    ],
    [
      [
        22614,
        55898
      ],
      [
        0,
        -39
      ],
      [
        17,
        0
      ]
    ],
    [
      [
        22630,
        55356
      ],
      [
        -37,
        2
      ]
    ],
    [
      [
        22593,
        55358
      ],
      [
        -104,
        5
      ]
    ],
    [
      [
        22489,
        55363
      ],
      [
        2,
        452
      ]
    ],
    [
      [
        31436,
        38070
      ],
      [
        10,
        26
      ],
      [
        8,
        -10
      ],
      [
        2,
        17
      ]
    ],
    [
      [
        31456,
        38103
      ],
      [
        5,
        -17
      ],
      [
        2,
        -26
      ]
    ],
    [
      [
        31463,
        38060
      ],
      [
        -3,
        -31
      ],
      [
        1,
        -25
      ]
    ],
    [
      [
        31461,
        38004
      ],
      [
        -4,
        -2
      ],
      [
        -1,
        -19
      ],
      [
        -4,
        -1
      ]
    ],
    [
      [
        31452,
        37982
      ],
      [
        -1,
        7
      ],
      [
        -3,
        5
      ],
      [
        -11,
        37
      ],
      [
        -3,
        9
      ],
      [
        2,
        30
      ]
    ],
    [
      [
        22937,
        61783
      ],
      [
        130,
        -1
      ]
    ],
    [
      [
        23067,
        61782
      ],
      [
        -1,
        -237
      ],
      [
        0,
        -170
      ]
    ],
    [
      [
        23020,
        61275
      ],
      [
        -89,
        -1
      ]
    ],
    [
      [
        22673,
        53809
      ],
      [
        22,
        45
      ],
      [
        23,
        -144
      ]
    ],
    [
      [
        22718,
        53710
      ],
      [
        52,
        -311
      ]
    ],
    [
      [
        22770,
        53399
      ],
      [
        -107,
        -231
      ],
      [
        -12,
        -25
      ],
      [
        -17,
        -36
      ]
    ],
    [
      [
        22634,
        53107
      ],
      [
        -6,
        37
      ],
      [
        -1,
        5
      ],
      [
        -69,
        417
      ]
    ],
    [
      [
        26275,
        67133
      ],
      [
        131,
        -1
      ]
    ],
    [
      [
        26406,
        67132
      ],
      [
        1,
        -398
      ]
    ],
    [
      [
        26407,
        66734
      ],
      [
        0,
        -7
      ],
      [
        -66,
        0
      ]
    ],
    [
      [
        26341,
        66727
      ],
      [
        -66,
        1
      ]
    ],
    [
      [
        26275,
        66728
      ],
      [
        0,
        405
      ]
    ],
    [
      [
        23177,
        61221
      ],
      [
        122,
        -2
      ]
    ],
    [
      [
        23299,
        61219
      ],
      [
        0,
        -254
      ],
      [
        -1,
        0
      ],
      [
        0,
        -102
      ]
    ],
    [
      [
        23298,
        60863
      ],
      [
        -122,
        2
      ]
    ],
    [
      [
        25132,
        66008
      ],
      [
        33,
        1
      ],
      [
        33,
        1
      ]
    ],
    [
      [
        25198,
        66010
      ],
      [
        32,
        0
      ]
    ],
    [
      [
        25230,
        66010
      ],
      [
        0,
        -102
      ],
      [
        -3,
        0
      ],
      [
        0,
        -404
      ]
    ],
    [
      [
        25227,
        65504
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -95
      ]
    ],
    [
      [
        25226,
        65402
      ],
      [
        -14,
        -1
      ],
      [
        -15,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -30,
        1
      ],
      [
        -33,
        -4
      ]
    ],
    [
      [
        25133,
        65398
      ],
      [
        -1,
        307
      ]
    ],
    [
      [
        25132,
        65705
      ],
      [
        0,
        51
      ],
      [
        1,
        150
      ],
      [
        -1,
        102
      ]
    ],
    [
      [
        23591,
        64550
      ],
      [
        127,
        -3
      ]
    ],
    [
      [
        23718,
        64547
      ],
      [
        0,
        -376
      ]
    ],
    [
      [
        23718,
        64171
      ],
      [
        -5,
        -1
      ],
      [
        -13,
        0
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -39,
        -2
      ]
    ],
    [
      [
        23658,
        64168
      ],
      [
        -35,
        0
      ],
      [
        -20,
        -1
      ],
      [
        -12,
        0
      ]
    ],
    [
      [
        23591,
        64167
      ],
      [
        0,
        383
      ]
    ],
    [
      [
        23289,
        65672
      ],
      [
        64,
        1
      ],
      [
        65,
        -1
      ]
    ],
    [
      [
        23418,
        65672
      ],
      [
        0,
        -304
      ],
      [
        15,
        0
      ],
      [
        0,
        -114
      ]
    ],
    [
      [
        23433,
        65254
      ],
      [
        -32,
        1
      ]
    ],
    [
      [
        23401,
        65255
      ],
      [
        -32,
        0
      ],
      [
        -64,
        1
      ]
    ],
    [
      [
        23305,
        65256
      ],
      [
        0,
        112
      ],
      [
        -17,
        0
      ],
      [
        1,
        304
      ]
    ],
    [
      [
        16328,
        60062
      ],
      [
        -1,
        -19
      ],
      [
        10,
        -24
      ],
      [
        3,
        -30
      ],
      [
        4,
        -12
      ],
      [
        2,
        -37
      ],
      [
        2,
        -2
      ],
      [
        5,
        -31
      ],
      [
        -4,
        -25
      ],
      [
        3,
        -10
      ],
      [
        0,
        -21
      ],
      [
        6,
        -14
      ],
      [
        5,
        -18
      ],
      [
        1,
        5
      ],
      [
        3,
        -20
      ],
      [
        3,
        2
      ],
      [
        6,
        -16
      ],
      [
        0,
        -30
      ],
      [
        7,
        2
      ],
      [
        -1,
        14
      ],
      [
        3,
        -17
      ],
      [
        10,
        -7
      ],
      [
        3,
        -17
      ],
      [
        1,
        12
      ],
      [
        16,
        -5
      ],
      [
        -1,
        11
      ],
      [
        4,
        11
      ],
      [
        4,
        2
      ],
      [
        4,
        -16
      ],
      [
        5,
        31
      ],
      [
        5,
        -5
      ],
      [
        5,
        12
      ],
      [
        9,
        5
      ],
      [
        7,
        14
      ],
      [
        2,
        -8
      ],
      [
        4,
        5
      ],
      [
        8,
        -9
      ],
      [
        4,
        15
      ],
      [
        6,
        3
      ],
      [
        2,
        12
      ],
      [
        5,
        -10
      ],
      [
        7,
        2
      ],
      [
        3,
        11
      ],
      [
        6,
        3
      ],
      [
        7,
        15
      ],
      [
        4,
        -8
      ],
      [
        9,
        3
      ],
      [
        7,
        -5
      ],
      [
        1,
        14
      ],
      [
        6,
        17
      ],
      [
        -1,
        22
      ],
      [
        5,
        27
      ],
      [
        4,
        2
      ],
      [
        2,
        17
      ],
      [
        5,
        13
      ],
      [
        -2,
        9
      ],
      [
        0,
        19
      ],
      [
        8,
        25
      ],
      [
        2,
        9
      ],
      [
        1,
        6
      ],
      [
        9,
        5
      ],
      [
        3,
        28
      ],
      [
        2,
        10
      ],
      [
        5,
        -4
      ],
      [
        0,
        -10
      ],
      [
        1,
        -7
      ],
      [
        3,
        4
      ],
      [
        1,
        15
      ],
      [
        1,
        19
      ],
      [
        1,
        9
      ],
      [
        1,
        8
      ],
      [
        3,
        -2
      ],
      [
        3,
        -4
      ],
      [
        4,
        -2
      ],
      [
        1,
        0
      ],
      [
        1,
        3
      ],
      [
        0,
        16
      ],
      [
        1,
        6
      ],
      [
        0,
        4
      ],
      [
        1,
        4
      ],
      [
        1,
        2
      ],
      [
        1,
        1
      ],
      [
        2,
        2
      ],
      [
        0,
        6
      ],
      [
        1,
        4
      ],
      [
        -1,
        5
      ],
      [
        -1,
        4
      ],
      [
        -2,
        5
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        0
      ],
      [
        -1,
        3
      ],
      [
        1,
        3
      ],
      [
        0,
        16
      ],
      [
        1,
        7
      ],
      [
        1,
        4
      ],
      [
        2,
        1
      ],
      [
        2,
        -6
      ],
      [
        2,
        -6
      ],
      [
        2,
        -4
      ],
      [
        0,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        3
      ],
      [
        0,
        8
      ],
      [
        1,
        9
      ],
      [
        2,
        4
      ],
      [
        2,
        -1
      ],
      [
        2,
        -5
      ],
      [
        2,
        -6
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -6
      ],
      [
        1,
        -7
      ],
      [
        2,
        -10
      ],
      [
        2,
        0
      ],
      [
        2,
        5
      ],
      [
        0,
        21
      ],
      [
        1,
        10
      ],
      [
        1,
        4
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        2,
        1
      ],
      [
        4,
        8
      ],
      [
        1,
        14
      ],
      [
        4,
        0
      ],
      [
        2,
        -4
      ],
      [
        1,
        -8
      ],
      [
        3,
        -5
      ],
      [
        2,
        1
      ],
      [
        1,
        5
      ],
      [
        1,
        1
      ],
      [
        1,
        4
      ],
      [
        0,
        7
      ],
      [
        2,
        1
      ],
      [
        1,
        1
      ],
      [
        1,
        4
      ],
      [
        0,
        11
      ],
      [
        1,
        4
      ],
      [
        1,
        2
      ],
      [
        0,
        2
      ],
      [
        2,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        3
      ],
      [
        1,
        4
      ],
      [
        0,
        6
      ],
      [
        1,
        3
      ],
      [
        1,
        4
      ],
      [
        1,
        4
      ],
      [
        -1,
        8
      ],
      [
        -1,
        1
      ],
      [
        -1,
        3
      ],
      [
        1,
        1
      ],
      [
        0,
        4
      ],
      [
        1,
        6
      ],
      [
        0,
        14
      ],
      [
        2,
        4
      ],
      [
        1,
        5
      ],
      [
        0,
        6
      ],
      [
        -1,
        5
      ],
      [
        0,
        13
      ],
      [
        -2,
        4
      ],
      [
        0,
        13
      ],
      [
        1,
        3
      ],
      [
        0,
        14
      ],
      [
        -1,
        5
      ],
      [
        -1,
        1
      ],
      [
        0,
        11
      ],
      [
        2,
        5
      ],
      [
        1,
        3
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        0,
        10
      ],
      [
        -2,
        2
      ],
      [
        2,
        8
      ],
      [
        1,
        7
      ],
      [
        0,
        9
      ],
      [
        4,
        14
      ],
      [
        3,
        12
      ],
      [
        11,
        34
      ],
      [
        12,
        40
      ],
      [
        17,
        57
      ],
      [
        9,
        30
      ],
      [
        18,
        61
      ],
      [
        7,
        24
      ]
    ],
    [
      [
        16751,
        60692
      ],
      [
        6,
        -17
      ],
      [
        5,
        -4
      ],
      [
        2,
        -12
      ],
      [
        7,
        10
      ],
      [
        6,
        -20
      ],
      [
        4,
        2
      ],
      [
        4,
        -22
      ],
      [
        5,
        -13
      ],
      [
        0,
        -11
      ],
      [
        6,
        -11
      ],
      [
        3,
        -30
      ],
      [
        10,
        14
      ],
      [
        5,
        1
      ],
      [
        6,
        -30
      ]
    ],
    [
      [
        16820,
        60549
      ],
      [
        1,
        -5
      ],
      [
        3,
        -9
      ],
      [
        0,
        -18
      ],
      [
        -3,
        -14
      ],
      [
        -3,
        -17
      ],
      [
        -1,
        -26
      ],
      [
        4,
        -15
      ],
      [
        1,
        -11
      ],
      [
        -5,
        -14
      ],
      [
        2,
        -19
      ],
      [
        5,
        -7
      ],
      [
        4,
        -11
      ],
      [
        5,
        3
      ],
      [
        6,
        -10
      ],
      [
        4,
        -16
      ],
      [
        2,
        -17
      ],
      [
        3,
        -17
      ],
      [
        2,
        -16
      ],
      [
        -4,
        -13
      ],
      [
        -1,
        -19
      ],
      [
        2,
        -17
      ],
      [
        0,
        -14
      ],
      [
        2,
        -12
      ],
      [
        2,
        -18
      ],
      [
        -1,
        -16
      ],
      [
        2,
        -15
      ],
      [
        4,
        -13
      ],
      [
        5,
        -2
      ],
      [
        3,
        4
      ],
      [
        3,
        -1
      ],
      [
        2,
        -5
      ],
      [
        1,
        2
      ],
      [
        2,
        -5
      ],
      [
        0,
        -4
      ],
      [
        2,
        -9
      ],
      [
        4,
        -9
      ],
      [
        6,
        0
      ],
      [
        4,
        -5
      ],
      [
        3,
        -14
      ],
      [
        5,
        -6
      ],
      [
        5,
        -19
      ],
      [
        8,
        -11
      ],
      [
        5,
        -15
      ],
      [
        0,
        -20
      ],
      [
        4,
        -17
      ],
      [
        1,
        -18
      ],
      [
        0,
        -18
      ],
      [
        5,
        -31
      ],
      [
        4,
        -28
      ],
      [
        3,
        -28
      ],
      [
        3,
        -26
      ],
      [
        -1,
        -21
      ],
      [
        1,
        -12
      ],
      [
        1,
        -13
      ],
      [
        -1,
        -18
      ],
      [
        -4,
        -6
      ],
      [
        -3,
        -2
      ],
      [
        0,
        -14
      ],
      [
        2,
        -10
      ],
      [
        2,
        -11
      ],
      [
        1,
        -6
      ],
      [
        -1,
        -11
      ],
      [
        0,
        -11
      ],
      [
        1,
        -16
      ],
      [
        1,
        -13
      ],
      [
        1,
        -7
      ],
      [
        1,
        -1
      ],
      [
        1,
        -3
      ]
    ],
    [
      [
        16936,
        59713
      ],
      [
        -55,
        0
      ],
      [
        -119,
        -3
      ],
      [
        0,
        -99
      ],
      [
        -29,
        1
      ],
      [
        -24,
        1
      ],
      [
        -21,
        3
      ],
      [
        -15,
        -1
      ],
      [
        -1,
        -101
      ],
      [
        -44,
        2
      ],
      [
        -7,
        -22
      ],
      [
        -16,
        -55
      ],
      [
        -7,
        -24
      ]
    ],
    [
      [
        16598,
        59415
      ],
      [
        -26,
        -81
      ],
      [
        -2,
        14
      ],
      [
        -11,
        -13
      ],
      [
        -10,
        -4
      ],
      [
        -2,
        -17
      ],
      [
        -57,
        -1
      ],
      [
        0,
        -255
      ],
      [
        -99,
        -320
      ]
    ],
    [
      [
        16391,
        58738
      ],
      [
        -6,
        19
      ],
      [
        0,
        16
      ],
      [
        -6,
        13
      ],
      [
        0,
        18
      ],
      [
        -14,
        14
      ],
      [
        -7,
        -8
      ],
      [
        -4,
        23
      ],
      [
        -8,
        14
      ],
      [
        -1,
        11
      ],
      [
        -17,
        31
      ],
      [
        -1,
        11
      ],
      [
        -6,
        8
      ],
      [
        -7,
        22
      ],
      [
        0,
        21
      ],
      [
        -3,
        14
      ],
      [
        -4,
        -8
      ],
      [
        -9,
        15
      ],
      [
        -2,
        28
      ],
      [
        -3,
        7
      ],
      [
        -1,
        31
      ],
      [
        4,
        4
      ],
      [
        5,
        34
      ],
      [
        3,
        7
      ],
      [
        -15,
        56
      ],
      [
        1,
        19
      ]
    ],
    [
      [
        16223,
        59708
      ],
      [
        73,
        248
      ],
      [
        18,
        -1
      ],
      [
        0,
        34
      ],
      [
        2,
        11
      ],
      [
        -4,
        9
      ],
      [
        16,
        53
      ]
    ],
    [
      [
        23591,
        64850
      ],
      [
        64,
        0
      ]
    ],
    [
      [
        23655,
        64850
      ],
      [
        64,
        -1
      ]
    ],
    [
      [
        23719,
        64849
      ],
      [
        -1,
        -302
      ]
    ],
    [
      [
        23591,
        64550
      ],
      [
        0,
        300
      ]
    ],
    [
      [
        24938,
        64840
      ],
      [
        48,
        0
      ]
    ],
    [
      [
        24986,
        64840
      ],
      [
        38,
        -1
      ],
      [
        -1,
        -28
      ],
      [
        -3,
        -15
      ],
      [
        -4,
        -9
      ],
      [
        54,
        1
      ]
    ],
    [
      [
        25070,
        64788
      ],
      [
        32,
        1
      ],
      [
        0,
        -209
      ]
    ],
    [
      [
        25102,
        64580
      ],
      [
        -26,
        2
      ],
      [
        -37,
        -3
      ],
      [
        -55,
        -4
      ]
    ],
    [
      [
        24984,
        64575
      ],
      [
        5,
        17
      ],
      [
        2,
        44
      ],
      [
        -53,
        0
      ]
    ],
    [
      [
        24938,
        64636
      ],
      [
        0,
        204
      ]
    ],
    [
      [
        25187,
        63567
      ],
      [
        0,
        51
      ],
      [
        16,
        0
      ],
      [
        0,
        50
      ],
      [
        31,
        162
      ]
    ],
    [
      [
        25234,
        63830
      ],
      [
        32,
        1
      ]
    ],
    [
      [
        25266,
        63831
      ],
      [
        -1,
        -68
      ],
      [
        0,
        -401
      ]
    ],
    [
      [
        25265,
        63362
      ],
      [
        0,
        -102
      ],
      [
        -3,
        0
      ]
    ],
    [
      [
        25262,
        63260
      ],
      [
        -76,
        1
      ]
    ],
    [
      [
        25186,
        63261
      ],
      [
        1,
        306
      ]
    ],
    [
      [
        23464,
        64851
      ],
      [
        63,
        0
      ]
    ],
    [
      [
        23527,
        64851
      ],
      [
        64,
        -1
      ]
    ],
    [
      [
        23591,
        64550
      ],
      [
        -127,
        1
      ]
    ],
    [
      [
        23464,
        64551
      ],
      [
        0,
        300
      ]
    ],
    [
      [
        25322,
        62161
      ],
      [
        87,
        3
      ]
    ],
    [
      [
        25409,
        62164
      ],
      [
        11,
        0
      ]
    ],
    [
      [
        25420,
        62164
      ],
      [
        -1,
        -320
      ],
      [
        0,
        -6
      ]
    ],
    [
      [
        25419,
        61838
      ],
      [
        -12,
        0
      ]
    ],
    [
      [
        25407,
        61838
      ],
      [
        -54,
        -1
      ]
    ],
    [
      [
        25353,
        61837
      ],
      [
        0,
        34
      ],
      [
        -29,
        1
      ]
    ],
    [
      [
        25324,
        61872
      ],
      [
        -9,
        23
      ],
      [
        -4,
        18
      ],
      [
        7,
        33
      ],
      [
        -3,
        22
      ],
      [
        0,
        58
      ],
      [
        7,
        0
      ],
      [
        0,
        135
      ]
    ],
    [
      [
        25160,
        58180
      ],
      [
        7,
        0
      ],
      [
        39,
        72
      ],
      [
        11,
        53
      ],
      [
        6,
        40
      ],
      [
        0,
        22
      ]
    ],
    [
      [
        25223,
        58367
      ],
      [
        4,
        4
      ],
      [
        10,
        -5
      ],
      [
        5,
        -45
      ],
      [
        5,
        -20
      ],
      [
        6,
        -23
      ],
      [
        11,
        -18
      ],
      [
        13,
        -8
      ],
      [
        2,
        -8
      ],
      [
        10,
        12
      ],
      [
        4,
        0
      ],
      [
        1,
        -86
      ]
    ],
    [
      [
        25294,
        58170
      ],
      [
        2,
        -14
      ],
      [
        -3,
        -30
      ]
    ],
    [
      [
        25293,
        58126
      ],
      [
        -35,
        5
      ],
      [
        -22,
        -4
      ],
      [
        -20,
        -24
      ],
      [
        -7,
        -25
      ],
      [
        0,
        -24
      ],
      [
        3,
        -2
      ],
      [
        -5,
        -6
      ],
      [
        -1,
        13
      ],
      [
        -4,
        -16
      ],
      [
        -5,
        -61
      ],
      [
        -3,
        -12
      ],
      [
        -18,
        1
      ]
    ],
    [
      [
        25176,
        57971
      ],
      [
        -3,
        95
      ],
      [
        -13,
        64
      ],
      [
        0,
        50
      ]
    ],
    [
      [
        26148,
        65914
      ],
      [
        130,
        1
      ]
    ],
    [
      [
        26278,
        65915
      ],
      [
        1,
        -364
      ]
    ],
    [
      [
        26279,
        65551
      ],
      [
        -104,
        0
      ]
    ],
    [
      [
        26175,
        65551
      ],
      [
        -26,
        0
      ]
    ],
    [
      [
        26149,
        65551
      ],
      [
        -1,
        363
      ]
    ],
    [
      [
        27610,
        58754
      ],
      [
        79,
        -14
      ],
      [
        14,
        -2
      ],
      [
        48,
        -8
      ]
    ],
    [
      [
        27751,
        58730
      ],
      [
        0,
        -66
      ]
    ],
    [
      [
        27751,
        58664
      ],
      [
        -4,
        -382
      ]
    ],
    [
      [
        27747,
        58282
      ],
      [
        -36,
        -3
      ],
      [
        -11,
        0
      ],
      [
        -12,
        -1
      ]
    ],
    [
      [
        27688,
        58278
      ],
      [
        -84,
        -7
      ]
    ],
    [
      [
        27604,
        58271
      ],
      [
        4,
        344
      ],
      [
        2,
        139
      ]
    ],
    [
      [
        21481,
        62494
      ],
      [
        158,
        1
      ]
    ],
    [
      [
        21639,
        62495
      ],
      [
        -2,
        -505
      ]
    ],
    [
      [
        21637,
        61990
      ],
      [
        -23,
        -1
      ]
    ],
    [
      [
        21614,
        61989
      ],
      [
        -133,
        -2
      ]
    ],
    [
      [
        21481,
        61987
      ],
      [
        0,
        406
      ]
    ],
    [
      [
        21481,
        62393
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        26174,
        63508
      ],
      [
        21,
        0
      ],
      [
        88,
        1
      ]
    ],
    [
      [
        26283,
        63509
      ],
      [
        0,
        -12
      ],
      [
        -1,
        -79
      ],
      [
        0,
        -12
      ]
    ],
    [
      [
        26282,
        63406
      ],
      [
        0,
        -222
      ]
    ],
    [
      [
        26282,
        63184
      ],
      [
        -43,
        1
      ],
      [
        -19,
        2
      ],
      [
        0,
        -16
      ]
    ],
    [
      [
        26220,
        63171
      ],
      [
        -42,
        0
      ],
      [
        1,
        85
      ],
      [
        -11,
        0
      ]
    ],
    [
      [
        26168,
        63256
      ],
      [
        1,
        99
      ],
      [
        5,
        1
      ],
      [
        0,
        152
      ]
    ],
    [
      [
        28304,
        59677
      ],
      [
        10,
        -1
      ],
      [
        2,
        9
      ],
      [
        -1,
        -24
      ],
      [
        2,
        -20
      ],
      [
        -9,
        -9
      ],
      [
        -4,
        0
      ],
      [
        -2,
        33
      ],
      [
        2,
        12
      ]
    ],
    [
      [
        21899,
        59428
      ],
      [
        151,
        0
      ]
    ],
    [
      [
        22050,
        59428
      ],
      [
        1,
        0
      ],
      [
        0,
        -517
      ]
    ],
    [
      [
        22051,
        58911
      ],
      [
        -151,
        1
      ]
    ],
    [
      [
        21900,
        58912
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        21899,
        58912
      ],
      [
        0,
        516
      ]
    ],
    [
      [
        25873,
        59251
      ],
      [
        3,
        13
      ],
      [
        1,
        110
      ],
      [
        8,
        -2
      ],
      [
        0,
        41
      ],
      [
        3,
        1
      ]
    ],
    [
      [
        25888,
        59414
      ],
      [
        10,
        -6
      ],
      [
        7,
        -44
      ],
      [
        52,
        -22
      ]
    ],
    [
      [
        25957,
        59342
      ],
      [
        2,
        -7
      ],
      [
        -3,
        -28
      ],
      [
        -15,
        -16
      ],
      [
        -12,
        -31
      ],
      [
        -8,
        -37
      ],
      [
        -5,
        -34
      ],
      [
        -3,
        2
      ]
    ],
    [
      [
        25913,
        59191
      ],
      [
        -11,
        38
      ],
      [
        -2,
        -11
      ],
      [
        -5,
        15
      ],
      [
        -1,
        12
      ],
      [
        -6,
        0
      ],
      [
        -1,
        8
      ],
      [
        -4,
        -15
      ],
      [
        -1,
        -36
      ],
      [
        -4,
        -7
      ],
      [
        -3,
        11
      ],
      [
        3,
        23
      ],
      [
        -3,
        22
      ],
      [
        -2,
        0
      ]
    ],
    [
      [
        19085,
        60640
      ],
      [
        0,
        4
      ],
      [
        5,
        17
      ],
      [
        4,
        7
      ],
      [
        3,
        43
      ],
      [
        8,
        12
      ],
      [
        2,
        12
      ],
      [
        1,
        14
      ],
      [
        4,
        5
      ],
      [
        5,
        1
      ],
      [
        7,
        16
      ],
      [
        0,
        -2
      ],
      [
        2,
        8
      ],
      [
        1,
        11
      ],
      [
        3,
        25
      ],
      [
        0,
        18
      ],
      [
        4,
        11
      ],
      [
        4,
        19
      ],
      [
        2,
        22
      ],
      [
        4,
        21
      ],
      [
        1,
        4
      ],
      [
        -2,
        5
      ],
      [
        -3,
        -3
      ],
      [
        -4,
        -1
      ],
      [
        -2,
        11
      ],
      [
        -1,
        12
      ],
      [
        -1,
        11
      ],
      [
        3,
        9
      ],
      [
        5,
        0
      ],
      [
        4,
        6
      ],
      [
        0,
        18
      ],
      [
        4,
        18
      ],
      [
        3,
        3
      ],
      [
        2,
        11
      ],
      [
        0,
        28
      ],
      [
        4,
        8
      ],
      [
        5,
        4
      ],
      [
        6,
        0
      ],
      [
        6,
        -1
      ],
      [
        7,
        -1
      ],
      [
        2,
        -10
      ],
      [
        0,
        -8
      ],
      [
        2,
        -8
      ],
      [
        1,
        -1
      ],
      [
        1,
        8
      ],
      [
        0,
        6
      ],
      [
        1,
        12
      ],
      [
        2,
        11
      ],
      [
        4,
        0
      ],
      [
        6,
        -3
      ],
      [
        4,
        -3
      ],
      [
        4,
        11
      ],
      [
        1,
        9
      ],
      [
        0,
        18
      ],
      [
        -1,
        16
      ],
      [
        2,
        11
      ],
      [
        3,
        6
      ],
      [
        3,
        8
      ],
      [
        2,
        6
      ],
      [
        1,
        12
      ],
      [
        2,
        10
      ],
      [
        2,
        3
      ],
      [
        2,
        8
      ],
      [
        1,
        9
      ],
      [
        2,
        5
      ],
      [
        3,
        2
      ],
      [
        3,
        -1
      ],
      [
        2,
        -8
      ],
      [
        4,
        -6
      ],
      [
        4,
        7
      ],
      [
        0,
        17
      ],
      [
        1,
        16
      ],
      [
        2,
        14
      ],
      [
        3,
        8
      ],
      [
        3,
        5
      ],
      [
        0,
        9
      ],
      [
        -1,
        6
      ],
      [
        0,
        8
      ],
      [
        1,
        6
      ],
      [
        1,
        7
      ],
      [
        2,
        5
      ],
      [
        1,
        6
      ],
      [
        1,
        5
      ],
      [
        1,
        4
      ],
      [
        1,
        6
      ],
      [
        2,
        4
      ],
      [
        2,
        -1
      ],
      [
        1,
        -4
      ],
      [
        1,
        -5
      ],
      [
        2,
        -1
      ],
      [
        2,
        6
      ],
      [
        4,
        9
      ],
      [
        3,
        18
      ],
      [
        5,
        8
      ],
      [
        3,
        16
      ],
      [
        0,
        3
      ]
    ],
    [
      [
        19285,
        61351
      ],
      [
        -1,
        7
      ],
      [
        13,
        35
      ],
      [
        -5,
        6
      ],
      [
        4,
        17
      ],
      [
        -8,
        9
      ],
      [
        -1,
        11
      ],
      [
        9,
        8
      ],
      [
        -3,
        13
      ],
      [
        -5,
        5
      ],
      [
        4,
        10
      ],
      [
        -2,
        18
      ],
      [
        -5,
        -13
      ],
      [
        -2,
        9
      ],
      [
        1,
        19
      ],
      [
        -5,
        6
      ],
      [
        1,
        21
      ],
      [
        -4,
        12
      ],
      [
        -1,
        14
      ],
      [
        4,
        9
      ],
      [
        2,
        15
      ],
      [
        -3,
        5
      ],
      [
        -4,
        -15
      ],
      [
        -5,
        19
      ],
      [
        3,
        21
      ],
      [
        -1,
        15
      ],
      [
        -6,
        -21
      ],
      [
        -4,
        -7
      ],
      [
        0,
        18
      ],
      [
        -5,
        6
      ],
      [
        8,
        36
      ],
      [
        -7,
        36
      ],
      [
        -5,
        6
      ],
      [
        3,
        9
      ],
      [
        7,
        -14
      ],
      [
        2,
        38
      ],
      [
        -6,
        23
      ]
    ],
    [
      [
        19258,
        61757
      ],
      [
        153,
        -1
      ],
      [
        116,
        1
      ]
    ],
    [
      [
        19527,
        61757
      ],
      [
        0,
        -262
      ],
      [
        1,
        -35
      ],
      [
        4,
        -94
      ],
      [
        0,
        -13
      ]
    ],
    [
      [
        19532,
        61353
      ],
      [
        0,
        -182
      ],
      [
        -1,
        -26
      ],
      [
        1,
        -78
      ],
      [
        0,
        -31
      ]
    ],
    [
      [
        19532,
        61036
      ],
      [
        0,
        -408
      ],
      [
        -1,
        -36
      ],
      [
        0,
        -17
      ]
    ],
    [
      [
        19531,
        60575
      ],
      [
        0,
        -566
      ]
    ],
    [
      [
        19531,
        60009
      ],
      [
        -38,
        1
      ],
      [
        -25,
        0
      ],
      [
        -30,
        -1
      ],
      [
        -33,
        0
      ],
      [
        -36,
        -1
      ],
      [
        -69,
        1
      ],
      [
        -35,
        -1
      ]
    ],
    [
      [
        19265,
        60008
      ],
      [
        0,
        1
      ],
      [
        -6,
        0
      ],
      [
        -125,
        -1
      ],
      [
        -6,
        7
      ],
      [
        -3,
        0
      ],
      [
        -27,
        -1
      ],
      [
        -7,
        0
      ],
      [
        0,
        1
      ],
      [
        -35,
        -1
      ]
    ],
    [
      [
        18889,
        60012
      ],
      [
        4,
        18
      ],
      [
        3,
        3
      ],
      [
        2,
        -7
      ],
      [
        3,
        0
      ],
      [
        0,
        10
      ],
      [
        2,
        10
      ],
      [
        2,
        4
      ],
      [
        2,
        4
      ],
      [
        -3,
        7
      ],
      [
        -3,
        10
      ],
      [
        0,
        12
      ],
      [
        1,
        5
      ],
      [
        3,
        -4
      ],
      [
        3,
        -5
      ],
      [
        5,
        -12
      ],
      [
        2,
        -20
      ],
      [
        1,
        -6
      ],
      [
        4,
        -3
      ],
      [
        1,
        9
      ],
      [
        0,
        14
      ],
      [
        -1,
        1
      ],
      [
        -3,
        5
      ],
      [
        1,
        9
      ],
      [
        1,
        9
      ],
      [
        3,
        1
      ],
      [
        1,
        -6
      ],
      [
        2,
        -4
      ],
      [
        1,
        1
      ],
      [
        5,
        23
      ],
      [
        5,
        26
      ],
      [
        2,
        5
      ],
      [
        4,
        -1
      ],
      [
        1,
        -8
      ],
      [
        3,
        -8
      ],
      [
        4,
        10
      ],
      [
        1,
        7
      ],
      [
        3,
        3
      ],
      [
        3,
        -3
      ],
      [
        6,
        -1
      ],
      [
        3,
        2
      ],
      [
        3,
        4
      ],
      [
        1,
        -6
      ],
      [
        2,
        -4
      ],
      [
        2,
        9
      ],
      [
        8,
        7
      ],
      [
        4,
        -2
      ],
      [
        3,
        0
      ],
      [
        2,
        3
      ],
      [
        0,
        12
      ],
      [
        1,
        4
      ],
      [
        1,
        -1
      ],
      [
        2,
        -2
      ],
      [
        3,
        0
      ],
      [
        1,
        8
      ],
      [
        0,
        20
      ],
      [
        3,
        0
      ],
      [
        1,
        -1
      ],
      [
        3,
        7
      ],
      [
        0,
        13
      ],
      [
        1,
        8
      ],
      [
        2,
        7
      ],
      [
        3,
        -3
      ],
      [
        1,
        -1
      ],
      [
        2,
        8
      ],
      [
        -1,
        6
      ],
      [
        2,
        10
      ],
      [
        1,
        13
      ],
      [
        -1,
        6
      ],
      [
        1,
        9
      ],
      [
        2,
        4
      ],
      [
        2,
        8
      ],
      [
        0,
        8
      ],
      [
        -2,
        7
      ],
      [
        -1,
        10
      ],
      [
        2,
        3
      ],
      [
        2,
        2
      ],
      [
        3,
        4
      ],
      [
        -1,
        11
      ],
      [
        0,
        26
      ],
      [
        6,
        4
      ],
      [
        2,
        19
      ],
      [
        -1,
        10
      ],
      [
        -3,
        6
      ],
      [
        -4,
        3
      ],
      [
        -2,
        11
      ],
      [
        1,
        15
      ],
      [
        3,
        -1
      ],
      [
        5,
        -12
      ],
      [
        4,
        -8
      ],
      [
        5,
        -10
      ],
      [
        6,
        1
      ],
      [
        4,
        9
      ],
      [
        3,
        2
      ],
      [
        1,
        7
      ],
      [
        0,
        9
      ],
      [
        3,
        3
      ],
      [
        1,
        -6
      ],
      [
        2,
        8
      ],
      [
        1,
        11
      ],
      [
        2,
        7
      ],
      [
        -1,
        11
      ],
      [
        -2,
        6
      ],
      [
        -2,
        7
      ],
      [
        -3,
        12
      ],
      [
        0,
        6
      ],
      [
        2,
        6
      ],
      [
        3,
        -3
      ],
      [
        3,
        -7
      ],
      [
        4,
        8
      ],
      [
        1,
        7
      ],
      [
        1,
        11
      ],
      [
        1,
        9
      ],
      [
        -2,
        9
      ],
      [
        -4,
        -2
      ],
      [
        -5,
        12
      ],
      [
        -2,
        10
      ],
      [
        0,
        3
      ],
      [
        1,
        4
      ],
      [
        4,
        -2
      ],
      [
        1,
        8
      ],
      [
        0,
        8
      ],
      [
        2,
        11
      ],
      [
        6,
        0
      ],
      [
        9,
        -4
      ],
      [
        5,
        6
      ],
      [
        1,
        2
      ],
      [
        0,
        8
      ],
      [
        -2,
        2
      ],
      [
        -3,
        0
      ],
      [
        -2,
        6
      ],
      [
        0,
        6
      ],
      [
        1,
        21
      ],
      [
        4,
        15
      ],
      [
        1,
        7
      ]
    ],
    [
      [
        24037,
        65259
      ],
      [
        32,
        0
      ]
    ],
    [
      [
        24069,
        65259
      ],
      [
        32,
        0
      ],
      [
        64,
        1
      ]
    ],
    [
      [
        24165,
        65260
      ],
      [
        1,
        -405
      ]
    ],
    [
      [
        24101,
        64854
      ],
      [
        -64,
        0
      ]
    ],
    [
      [
        24037,
        64854
      ],
      [
        0,
        405
      ]
    ],
    [
      [
        17306,
        73978
      ],
      [
        76,
        1
      ],
      [
        95,
        0
      ],
      [
        11,
        1
      ],
      [
        2,
        1
      ],
      [
        90,
        -1
      ]
    ],
    [
      [
        17580,
        73980
      ],
      [
        0,
        -580
      ]
    ],
    [
      [
        17580,
        73400
      ],
      [
        -205,
        -2
      ],
      [
        0,
        202
      ],
      [
        -1,
        0
      ],
      [
        0,
        202
      ],
      [
        -68,
        -1
      ]
    ],
    [
      [
        17306,
        73801
      ],
      [
        0,
        177
      ]
    ],
    [
      [
        24948,
        63875
      ],
      [
        94,
        6
      ]
    ],
    [
      [
        25042,
        63881
      ],
      [
        0,
        -51
      ],
      [
        32,
        2
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        25074,
        63831
      ],
      [
        1,
        -272
      ]
    ],
    [
      [
        25075,
        63559
      ],
      [
        1,
        -152
      ],
      [
        -21,
        -1
      ]
    ],
    [
      [
        25055,
        63406
      ],
      [
        -52,
        1
      ],
      [
        0,
        17
      ],
      [
        -22,
        1
      ],
      [
        0,
        51
      ],
      [
        -26,
        -1
      ]
    ],
    [
      [
        24955,
        63475
      ],
      [
        -1,
        135
      ],
      [
        -6,
        0
      ],
      [
        0,
        35
      ]
    ],
    [
      [
        24948,
        63645
      ],
      [
        -1,
        112
      ],
      [
        1,
        118
      ]
    ],
    [
      [
        23304,
        62035
      ],
      [
        66,
        -1
      ],
      [
        58,
        0
      ]
    ],
    [
      [
        23428,
        62034
      ],
      [
        -2,
        -51
      ],
      [
        0,
        -355
      ]
    ],
    [
      [
        23426,
        61628
      ],
      [
        -82,
        1
      ],
      [
        -42,
        0
      ]
    ],
    [
      [
        23302,
        61629
      ],
      [
        0,
        51
      ]
    ],
    [
      [
        23302,
        61680
      ],
      [
        0,
        304
      ],
      [
        2,
        0
      ],
      [
        0,
        51
      ]
    ],
    [
      [
        23897,
        54668
      ],
      [
        38,
        -1
      ],
      [
        0,
        52
      ],
      [
        25,
        1
      ],
      [
        0,
        17
      ],
      [
        -7,
        66
      ],
      [
        1,
        27
      ],
      [
        -3,
        41
      ]
    ],
    [
      [
        23951,
        54871
      ],
      [
        49,
        -1
      ],
      [
        18,
        1
      ],
      [
        16,
        0
      ]
    ],
    [
      [
        24034,
        54871
      ],
      [
        1,
        -32
      ],
      [
        0,
        -120
      ],
      [
        28,
        -1
      ]
    ],
    [
      [
        24063,
        54718
      ],
      [
        1,
        -158
      ],
      [
        0,
        -95
      ],
      [
        -4,
        -25
      ],
      [
        -3,
        -5
      ],
      [
        0,
        -34
      ],
      [
        -5,
        -23
      ],
      [
        -1,
        1
      ],
      [
        2,
        -18
      ]
    ],
    [
      [
        24053,
        54361
      ],
      [
        -35,
        1
      ]
    ],
    [
      [
        24018,
        54362
      ],
      [
        -69,
        1
      ]
    ],
    [
      [
        23949,
        54363
      ],
      [
        -1,
        35
      ],
      [
        -6,
        16
      ],
      [
        0,
        51
      ],
      [
        -60,
        0
      ]
    ],
    [
      [
        23882,
        54465
      ],
      [
        5,
        17
      ],
      [
        1,
        39
      ],
      [
        -3,
        -1
      ],
      [
        -3,
        30
      ],
      [
        7,
        69
      ],
      [
        -6,
        10
      ],
      [
        0,
        24
      ],
      [
        3,
        4
      ],
      [
        7,
        -5
      ],
      [
        4,
        16
      ]
    ],
    [
      [
        16193,
        61766
      ],
      [
        5,
        13
      ],
      [
        4,
        -7
      ],
      [
        14,
        17
      ],
      [
        1,
        1
      ],
      [
        0,
        -3
      ],
      [
        1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        2,
        -4
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        1
      ],
      [
        1,
        3
      ],
      [
        0,
        1
      ],
      [
        2,
        2
      ],
      [
        1,
        -1
      ],
      [
        0,
        2
      ],
      [
        1,
        3
      ],
      [
        0,
        -1
      ],
      [
        1,
        3
      ],
      [
        0,
        4
      ],
      [
        1,
        2
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        1,
        0
      ],
      [
        1,
        2
      ],
      [
        0,
        14
      ],
      [
        1,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        2
      ],
      [
        0,
        -2
      ],
      [
        1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        2,
        -3
      ],
      [
        1,
        1
      ],
      [
        0,
        7
      ],
      [
        1,
        1
      ],
      [
        1,
        -1
      ],
      [
        0,
        7
      ],
      [
        1,
        1
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        3
      ],
      [
        0,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        1,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        3
      ],
      [
        0,
        1
      ],
      [
        2,
        -1
      ],
      [
        0,
        5
      ],
      [
        1,
        0
      ],
      [
        1,
        -2
      ],
      [
        0,
        1
      ],
      [
        1,
        2
      ],
      [
        1,
        2
      ],
      [
        0,
        -5
      ],
      [
        1,
        0
      ],
      [
        2,
        -1
      ],
      [
        1,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        -4
      ],
      [
        2,
        -1
      ],
      [
        2,
        1
      ],
      [
        2,
        -1
      ],
      [
        1,
        1
      ],
      [
        3,
        -3
      ],
      [
        1,
        2
      ],
      [
        0,
        -2
      ],
      [
        1,
        -3
      ],
      [
        1,
        0
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        2
      ],
      [
        2,
        -1
      ],
      [
        1,
        -4
      ],
      [
        2,
        -5
      ],
      [
        2,
        -4
      ],
      [
        1,
        0
      ],
      [
        2,
        -6
      ],
      [
        1,
        -2
      ],
      [
        2,
        -2
      ],
      [
        2,
        -7
      ],
      [
        2,
        -4
      ],
      [
        2,
        -1
      ],
      [
        2,
        -5
      ],
      [
        3,
        -3
      ],
      [
        3,
        -4
      ],
      [
        2,
        -3
      ],
      [
        1,
        1
      ],
      [
        2,
        -2
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        2,
        1
      ],
      [
        5,
        0
      ],
      [
        2,
        2
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        2,
        2
      ],
      [
        1,
        2
      ],
      [
        2,
        -1
      ],
      [
        1,
        -1
      ],
      [
        5,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        2,
        1
      ],
      [
        1,
        1
      ],
      [
        2,
        1
      ],
      [
        1,
        3
      ],
      [
        2,
        2
      ],
      [
        1,
        3
      ],
      [
        2,
        1
      ],
      [
        1,
        1
      ],
      [
        2,
        1
      ],
      [
        2,
        1
      ],
      [
        2,
        1
      ],
      [
        1,
        3
      ],
      [
        4,
        1
      ],
      [
        1,
        -1
      ],
      [
        1,
        2
      ],
      [
        1,
        0
      ],
      [
        1,
        2
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        2,
        4
      ],
      [
        1,
        0
      ],
      [
        2,
        4
      ],
      [
        1,
        -2
      ],
      [
        1,
        1
      ],
      [
        1,
        4
      ],
      [
        1,
        2
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        2,
        1
      ],
      [
        1,
        2
      ],
      [
        8,
        0
      ],
      [
        5,
        -1
      ],
      [
        4,
        12
      ],
      [
        2,
        0
      ],
      [
        3,
        4
      ],
      [
        4,
        10
      ],
      [
        3,
        15
      ],
      [
        3,
        6
      ],
      [
        3,
        11
      ],
      [
        2,
        16
      ],
      [
        0,
        8
      ],
      [
        2,
        6
      ],
      [
        1,
        5
      ],
      [
        1,
        4
      ],
      [
        1,
        -1
      ],
      [
        3,
        -1
      ],
      [
        4,
        6
      ],
      [
        5,
        0
      ],
      [
        3,
        3
      ],
      [
        1,
        3
      ],
      [
        1,
        2
      ],
      [
        1,
        -1
      ],
      [
        2,
        6
      ],
      [
        1,
        9
      ],
      [
        0,
        11
      ],
      [
        3,
        7
      ],
      [
        0,
        3
      ],
      [
        1,
        9
      ],
      [
        -1,
        7
      ],
      [
        0,
        16
      ],
      [
        3,
        8
      ],
      [
        5,
        6
      ],
      [
        4,
        -10
      ],
      [
        1,
        2
      ],
      [
        1,
        1
      ]
    ],
    [
      [
        16459,
        61993
      ],
      [
        0,
        -225
      ]
    ],
    [
      [
        16459,
        61768
      ],
      [
        -4,
        -3
      ],
      [
        -3,
        -2
      ],
      [
        -3,
        -2
      ],
      [
        -3,
        -7
      ],
      [
        -3,
        -1
      ],
      [
        -4,
        0
      ],
      [
        -3,
        -3
      ],
      [
        -8,
        2
      ],
      [
        -5,
        5
      ],
      [
        -5,
        -5
      ],
      [
        -5,
        -8
      ],
      [
        -2,
        -4
      ],
      [
        -4,
        1
      ],
      [
        -2,
        -5
      ],
      [
        -4,
        -8
      ],
      [
        -5,
        0
      ],
      [
        -6,
        -6
      ],
      [
        -7,
        -4
      ],
      [
        -6,
        -1
      ],
      [
        -5,
        -5
      ],
      [
        -5,
        6
      ],
      [
        -4,
        8
      ],
      [
        -4,
        -6
      ],
      [
        -5,
        -14
      ],
      [
        -3,
        -11
      ],
      [
        -5,
        1
      ],
      [
        -4,
        -2
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -9
      ],
      [
        -5,
        -16
      ],
      [
        -3,
        -4
      ],
      [
        -4,
        0
      ],
      [
        -3,
        -5
      ],
      [
        -3,
        -13
      ],
      [
        -6,
        -5
      ],
      [
        -5,
        -11
      ],
      [
        -1,
        -16
      ],
      [
        0,
        -10
      ],
      [
        -2,
        -12
      ],
      [
        -2,
        -14
      ],
      [
        -3,
        -7
      ],
      [
        -5,
        -10
      ],
      [
        -4,
        -2
      ],
      [
        -3,
        -6
      ],
      [
        -5,
        -9
      ],
      [
        -5,
        -5
      ],
      [
        -5,
        -6
      ],
      [
        -3,
        -11
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        0
      ],
      [
        -5,
        -1
      ],
      [
        -4,
        -2
      ],
      [
        -2,
        0
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -8
      ],
      [
        -2,
        -7
      ],
      [
        -4,
        -7
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -15
      ],
      [
        -5,
        -7
      ],
      [
        -2,
        -9
      ],
      [
        -2,
        -8
      ],
      [
        -2,
        -7
      ],
      [
        -2,
        3
      ],
      [
        -2,
        4
      ],
      [
        -6,
        -5
      ],
      [
        -5,
        4
      ],
      [
        -4,
        -8
      ],
      [
        -4,
        2
      ],
      [
        -4,
        5
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        16201,
        61437
      ],
      [
        -8,
        87
      ]
    ],
    [
      [
        16193,
        61524
      ],
      [
        0,
        242
      ]
    ],
    [
      [
        16478,
        62417
      ],
      [
        1,
        -79
      ],
      [
        26,
        -77
      ]
    ],
    [
      [
        16505,
        62261
      ],
      [
        5,
        -18
      ],
      [
        2,
        -36
      ],
      [
        -2,
        -9
      ],
      [
        3,
        -11
      ],
      [
        -4,
        -14
      ],
      [
        -4,
        -4
      ],
      [
        -1,
        -23
      ],
      [
        -4,
        -5
      ],
      [
        1,
        -11
      ],
      [
        -6,
        -21
      ],
      [
        -2,
        -25
      ],
      [
        -4,
        -6
      ],
      [
        -30,
        -85
      ]
    ],
    [
      [
        16193,
        61766
      ],
      [
        -15,
        145
      ],
      [
        -11,
        98
      ],
      [
        -4,
        -13
      ],
      [
        -2,
        7
      ]
    ],
    [
      [
        16161,
        62003
      ],
      [
        2,
        0
      ],
      [
        9,
        86
      ],
      [
        0,
        35
      ],
      [
        5,
        0
      ],
      [
        0,
        9
      ],
      [
        -2,
        7
      ],
      [
        1,
        6
      ],
      [
        4,
        9
      ],
      [
        3,
        4
      ],
      [
        2,
        26
      ],
      [
        -2,
        16
      ],
      [
        5,
        10
      ],
      [
        -3,
        11
      ],
      [
        4,
        18
      ],
      [
        1,
        0
      ],
      [
        10,
        3
      ],
      [
        2,
        11
      ],
      [
        8,
        6
      ],
      [
        2,
        8
      ],
      [
        5,
        -4
      ],
      [
        0,
        31
      ],
      [
        11,
        -11
      ],
      [
        3,
        7
      ],
      [
        9,
        -8
      ],
      [
        2,
        28
      ],
      [
        4,
        -5
      ],
      [
        2,
        18
      ],
      [
        5,
        15
      ],
      [
        3,
        -5
      ],
      [
        10,
        16
      ],
      [
        5,
        1
      ],
      [
        5,
        -8
      ],
      [
        3,
        -20
      ],
      [
        4,
        -6
      ],
      [
        4,
        10
      ],
      [
        1,
        -26
      ],
      [
        12,
        -27
      ],
      [
        8,
        -2
      ],
      [
        5,
        -8
      ],
      [
        6,
        -25
      ],
      [
        5,
        1
      ],
      [
        3,
        13
      ],
      [
        9,
        5
      ],
      [
        6,
        15
      ],
      [
        1,
        18
      ],
      [
        5,
        7
      ],
      [
        7,
        61
      ],
      [
        3,
        13
      ],
      [
        29,
        -7
      ],
      [
        25,
        1
      ],
      [
        0,
        9
      ],
      [
        16,
        0
      ],
      [
        0,
        8
      ],
      [
        5,
        0
      ],
      [
        3,
        9
      ],
      [
        0,
        17
      ],
      [
        3,
        8
      ],
      [
        39,
        0
      ]
    ],
    [
      [
        24236,
        59150
      ],
      [
        89,
        -6
      ],
      [
        41,
        -3
      ]
    ],
    [
      [
        24366,
        59141
      ],
      [
        0,
        -51
      ],
      [
        5,
        -1
      ],
      [
        -2,
        -51
      ],
      [
        0,
        -165
      ],
      [
        -3,
        -4
      ],
      [
        2,
        -22
      ],
      [
        -7,
        0
      ],
      [
        -1,
        -68
      ]
    ],
    [
      [
        24360,
        58779
      ],
      [
        -11,
        1
      ],
      [
        -27,
        -88
      ]
    ],
    [
      [
        24322,
        58692
      ],
      [
        -5,
        17
      ],
      [
        -8,
        1
      ],
      [
        -12,
        34
      ],
      [
        -4,
        23
      ],
      [
        -4,
        10
      ],
      [
        -4,
        -1
      ],
      [
        -7,
        -23
      ],
      [
        -6,
        4
      ],
      [
        -1,
        19
      ],
      [
        -4,
        5
      ],
      [
        -9,
        -19
      ],
      [
        -10,
        11
      ],
      [
        1,
        15
      ],
      [
        7,
        19
      ],
      [
        0,
        23
      ],
      [
        -4,
        23
      ],
      [
        2,
        17
      ],
      [
        8,
        5
      ],
      [
        2,
        12
      ],
      [
        -5,
        21
      ],
      [
        -11,
        14
      ],
      [
        -3,
        20
      ],
      [
        -4,
        35
      ],
      [
        -4,
        4
      ],
      [
        -6,
        -16
      ],
      [
        -4,
        4
      ],
      [
        -2,
        32
      ]
    ],
    [
      [
        24225,
        59001
      ],
      [
        -5,
        1
      ],
      [
        0,
        48
      ],
      [
        15,
        -1
      ],
      [
        1,
        101
      ]
    ],
    [
      [
        27795,
        60874
      ],
      [
        10,
        16
      ],
      [
        4,
        5
      ],
      [
        2,
        -19
      ],
      [
        -7,
        -28
      ],
      [
        -6,
        -28
      ],
      [
        -3,
        13
      ],
      [
        4,
        24
      ],
      [
        -4,
        17
      ]
    ],
    [
      [
        27806,
        59476
      ],
      [
        -35,
        0
      ]
    ],
    [
      [
        27771,
        59476
      ],
      [
        -1,
        23
      ],
      [
        4,
        19
      ],
      [
        -9,
        5
      ],
      [
        -8,
        26
      ],
      [
        4,
        15
      ],
      [
        1,
        2
      ],
      [
        14,
        -7
      ],
      [
        8,
        -13
      ],
      [
        0,
        3
      ],
      [
        7,
        47
      ],
      [
        3,
        -7
      ],
      [
        5,
        -3
      ],
      [
        1,
        -32
      ],
      [
        9,
        -7
      ],
      [
        5,
        -22
      ],
      [
        3,
        -3
      ],
      [
        0,
        -12
      ],
      [
        -9,
        2
      ],
      [
        -4,
        -24
      ],
      [
        2,
        -12
      ]
    ],
    [
      [
        27363,
        59628
      ],
      [
        4,
        26
      ],
      [
        11,
        -1
      ],
      [
        -6,
        -34
      ],
      [
        -4,
        -16
      ]
    ],
    [
      [
        27368,
        59603
      ],
      [
        0,
        -24
      ],
      [
        -4,
        -5
      ],
      [
        2,
        21
      ],
      [
        -7,
        6
      ],
      [
        1,
        33
      ],
      [
        3,
        -6
      ]
    ],
    [
      [
        27925,
        61684
      ],
      [
        4,
        25
      ],
      [
        4,
        -4
      ],
      [
        5,
        39
      ],
      [
        0,
        -11
      ],
      [
        10,
        -31
      ],
      [
        2,
        -38
      ],
      [
        -3,
        -3
      ],
      [
        -12,
        -7
      ],
      [
        -3,
        -25
      ],
      [
        -6,
        0
      ],
      [
        3,
        39
      ],
      [
        -4,
        16
      ]
    ],
    [
      [
        27650,
        59643
      ],
      [
        6,
        32
      ],
      [
        4,
        1
      ],
      [
        8,
        -10
      ],
      [
        0,
        -15
      ],
      [
        -1,
        -22
      ],
      [
        4,
        -17
      ],
      [
        -1,
        -13
      ],
      [
        -2,
        15
      ],
      [
        0,
        -16
      ],
      [
        -6,
        5
      ],
      [
        -6,
        24
      ],
      [
        -6,
        16
      ]
    ],
    [
      [
        25821,
        64866
      ],
      [
        109,
        2
      ]
    ],
    [
      [
        25930,
        64868
      ],
      [
        0,
        -103
      ],
      [
        16,
        2
      ],
      [
        0,
        -52
      ],
      [
        21,
        2
      ]
    ],
    [
      [
        25967,
        64717
      ],
      [
        0,
        -47
      ],
      [
        -1,
        -4
      ]
    ],
    [
      [
        25966,
        64666
      ],
      [
        -61,
        -4
      ],
      [
        -1,
        -100
      ]
    ],
    [
      [
        25904,
        64562
      ],
      [
        -41,
        -1
      ],
      [
        -11,
        0
      ],
      [
        -31,
        1
      ]
    ],
    [
      [
        25821,
        64562
      ],
      [
        0,
        304
      ]
    ],
    [
      [
        23527,
        65254
      ],
      [
        128,
        -1
      ]
    ],
    [
      [
        23655,
        65253
      ],
      [
        0,
        -403
      ]
    ],
    [
      [
        23527,
        64851
      ],
      [
        1,
        201
      ],
      [
        -1,
        202
      ]
    ],
    [
      [
        15974,
        59837
      ],
      [
        7,
        40
      ],
      [
        4,
        -2
      ],
      [
        8,
        30
      ],
      [
        8,
        -1
      ],
      [
        4,
        13
      ],
      [
        6,
        -19
      ],
      [
        5,
        13
      ],
      [
        5,
        -24
      ]
    ],
    [
      [
        16391,
        58738
      ],
      [
        11,
        -1
      ],
      [
        9,
        -33
      ],
      [
        1,
        -14
      ],
      [
        -5,
        -24
      ],
      [
        4,
        -25
      ],
      [
        6,
        -5
      ],
      [
        2,
        -35
      ]
    ],
    [
      [
        16419,
        58601
      ],
      [
        -10,
        0
      ],
      [
        -241,
        5
      ],
      [
        -3,
        1
      ],
      [
        -61,
        1
      ]
    ],
    [
      [
        16104,
        58608
      ],
      [
        -3,
        10
      ],
      [
        -9,
        23
      ],
      [
        -5,
        25
      ],
      [
        -2,
        12
      ],
      [
        -4,
        6
      ],
      [
        -3,
        7
      ],
      [
        -7,
        22
      ],
      [
        1,
        13
      ],
      [
        -1,
        9
      ],
      [
        -2,
        18
      ],
      [
        -4,
        59
      ],
      [
        -5,
        35
      ],
      [
        -2,
        7
      ],
      [
        -6,
        9
      ],
      [
        -6,
        6
      ],
      [
        -4,
        2
      ],
      [
        -2,
        5
      ],
      [
        -4,
        29
      ],
      [
        0,
        4
      ],
      [
        -1,
        13
      ],
      [
        -4,
        8
      ],
      [
        -3,
        19
      ],
      [
        -1,
        13
      ],
      [
        -2,
        18
      ],
      [
        -14,
        59
      ],
      [
        -11,
        35
      ],
      [
        -17,
        37
      ],
      [
        -5,
        8
      ],
      [
        -3,
        -2
      ],
      [
        -1,
        2
      ],
      [
        -4,
        9
      ],
      [
        -3,
        10
      ],
      [
        -1,
        12
      ],
      [
        -3,
        20
      ],
      [
        -7,
        13
      ],
      [
        -3,
        16
      ],
      [
        -2,
        17
      ],
      [
        0,
        27
      ],
      [
        -3,
        20
      ],
      [
        1,
        7
      ],
      [
        0,
        35
      ],
      [
        -1,
        5
      ],
      [
        -3,
        7
      ],
      [
        0,
        25
      ],
      [
        -3,
        33
      ],
      [
        -3,
        21
      ],
      [
        -1,
        10
      ],
      [
        0,
        6
      ],
      [
        1,
        13
      ],
      [
        0,
        11
      ],
      [
        -2,
        6
      ],
      [
        0,
        12
      ],
      [
        4,
        1
      ],
      [
        1,
        3
      ],
      [
        -2,
        40
      ],
      [
        -2,
        8
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        0
      ],
      [
        -4,
        11
      ],
      [
        -1,
        8
      ],
      [
        2,
        3
      ],
      [
        8,
        41
      ],
      [
        1,
        18
      ],
      [
        0,
        4
      ],
      [
        2,
        0
      ],
      [
        2,
        -3
      ],
      [
        9,
        -29
      ],
      [
        1,
        -9
      ],
      [
        4,
        3
      ],
      [
        3,
        8
      ],
      [
        6,
        22
      ],
      [
        2,
        17
      ],
      [
        2,
        14
      ],
      [
        3,
        30
      ],
      [
        2,
        37
      ],
      [
        1,
        42
      ],
      [
        5,
        62
      ],
      [
        -1,
        13
      ],
      [
        -5,
        39
      ],
      [
        -1,
        3
      ]
    ],
    [
      [
        24485,
        62330
      ],
      [
        21,
        -1
      ],
      [
        0,
        -69
      ],
      [
        22,
        -1
      ],
      [
        -1,
        -69
      ],
      [
        11,
        0
      ],
      [
        32,
        -2
      ]
    ],
    [
      [
        24570,
        62188
      ],
      [
        -1,
        -149
      ],
      [
        0,
        -48
      ],
      [
        -1,
        -179
      ]
    ],
    [
      [
        24568,
        61812
      ],
      [
        -7,
        9
      ],
      [
        -5,
        8
      ],
      [
        -4,
        13
      ],
      [
        -3,
        23
      ],
      [
        -6,
        18
      ],
      [
        -6,
        1
      ],
      [
        -10,
        -12
      ],
      [
        -6,
        -1
      ],
      [
        -14,
        11
      ],
      [
        -12,
        16
      ],
      [
        0,
        25
      ],
      [
        -3,
        14
      ],
      [
        -6,
        13
      ],
      [
        -15,
        47
      ],
      [
        -1,
        2
      ],
      [
        -7,
        -13
      ],
      [
        -7,
        3
      ]
    ],
    [
      [
        24456,
        61989
      ],
      [
        -8,
        10
      ],
      [
        -6,
        2
      ]
    ],
    [
      [
        24442,
        62001
      ],
      [
        1,
        157
      ],
      [
        21,
        0
      ],
      [
        10,
        1
      ],
      [
        11,
        -2
      ],
      [
        0,
        173
      ]
    ],
    [
      [
        27380,
        59121
      ],
      [
        6,
        6
      ],
      [
        12,
        15
      ],
      [
        3,
        -7
      ],
      [
        5,
        11
      ],
      [
        0,
        17
      ],
      [
        3,
        4
      ],
      [
        5,
        -14
      ],
      [
        2,
        17
      ],
      [
        3,
        -12
      ],
      [
        13,
        1
      ],
      [
        4,
        -20
      ],
      [
        5,
        1
      ],
      [
        3,
        24
      ],
      [
        4,
        0
      ],
      [
        1,
        16
      ],
      [
        9,
        -20
      ],
      [
        4,
        10
      ],
      [
        8,
        9
      ],
      [
        3,
        -7
      ],
      [
        1,
        -23
      ],
      [
        8,
        0
      ],
      [
        7,
        -4
      ],
      [
        4,
        4
      ],
      [
        4,
        -22
      ]
    ],
    [
      [
        27497,
        59127
      ],
      [
        6,
        -27
      ],
      [
        -4,
        -13
      ],
      [
        2,
        -45
      ],
      [
        0,
        -34
      ],
      [
        -5,
        -19
      ],
      [
        -14,
        -16
      ],
      [
        -3,
        -18
      ],
      [
        2,
        -41
      ],
      [
        4,
        -13
      ]
    ],
    [
      [
        27485,
        58901
      ],
      [
        -28,
        1
      ],
      [
        -27,
        4
      ]
    ],
    [
      [
        27430,
        58906
      ],
      [
        -53,
        5
      ]
    ],
    [
      [
        27377,
        58911
      ],
      [
        1,
        75
      ],
      [
        2,
        135
      ]
    ],
    [
      [
        26339,
        67537
      ],
      [
        67,
        0
      ]
    ],
    [
      [
        26406,
        67537
      ],
      [
        0,
        -393
      ]
    ],
    [
      [
        26406,
        67144
      ],
      [
        0,
        -12
      ]
    ],
    [
      [
        26275,
        67133
      ],
      [
        1,
        202
      ],
      [
        -3,
        0
      ],
      [
        0,
        202
      ]
    ],
    [
      [
        26535,
        60642
      ],
      [
        13,
        78
      ],
      [
        -2,
        7
      ],
      [
        9,
        24
      ],
      [
        7,
        0
      ],
      [
        -4,
        34
      ],
      [
        12,
        26
      ],
      [
        9,
        32
      ],
      [
        7,
        1
      ]
    ],
    [
      [
        26586,
        60844
      ],
      [
        4,
        0
      ]
    ],
    [
      [
        26590,
        60844
      ],
      [
        22,
        -43
      ],
      [
        3,
        -14
      ],
      [
        27,
        -33
      ]
    ],
    [
      [
        26642,
        60754
      ],
      [
        -16,
        -154
      ]
    ],
    [
      [
        26626,
        60600
      ],
      [
        -8,
        10
      ],
      [
        -4,
        -5
      ],
      [
        -4,
        34
      ],
      [
        -6,
        -4
      ],
      [
        -6,
        -29
      ],
      [
        -6,
        -5
      ],
      [
        -9,
        16
      ],
      [
        -3,
        -15
      ],
      [
        0,
        -16
      ],
      [
        -24,
        -9
      ],
      [
        -10,
        21
      ],
      [
        0,
        10
      ],
      [
        -5,
        5
      ]
    ],
    [
      [
        26541,
        60613
      ],
      [
        -3,
        16
      ],
      [
        -3,
        13
      ]
    ],
    [
      [
        23298,
        60863
      ],
      [
        40,
        1
      ],
      [
        41,
        -1
      ],
      [
        30,
        2
      ],
      [
        10,
        -2
      ]
    ],
    [
      [
        23419,
        60863
      ],
      [
        0,
        -67
      ]
    ],
    [
      [
        23419,
        60796
      ],
      [
        0,
        -339
      ]
    ],
    [
      [
        23419,
        60457
      ],
      [
        -120,
        0
      ]
    ],
    [
      [
        23299,
        60457
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        23298,
        60457
      ],
      [
        0,
        406
      ]
    ],
    [
      [
        26143,
        67133
      ],
      [
        33,
        1
      ],
      [
        33,
        1
      ],
      [
        66,
        -2
      ]
    ],
    [
      [
        26275,
        66728
      ],
      [
        -66,
        0
      ]
    ],
    [
      [
        26209,
        66728
      ],
      [
        -65,
        -1
      ]
    ],
    [
      [
        26144,
        66727
      ],
      [
        -1,
        203
      ],
      [
        0,
        203
      ]
    ],
    [
      [
        26017,
        66320
      ],
      [
        62,
        1
      ]
    ],
    [
      [
        26079,
        66321
      ],
      [
        3,
        0
      ],
      [
        65,
        -2
      ]
    ],
    [
      [
        26147,
        66319
      ],
      [
        0,
        -202
      ],
      [
        1,
        -203
      ]
    ],
    [
      [
        26148,
        65914
      ],
      [
        -65,
        -1
      ],
      [
        -66,
        -2
      ]
    ],
    [
      [
        26017,
        65911
      ],
      [
        0,
        409
      ]
    ],
    [
      [
        25535,
        60764
      ],
      [
        6,
        20
      ],
      [
        16,
        11
      ],
      [
        2,
        11
      ]
    ],
    [
      [
        25559,
        60806
      ],
      [
        41,
        -72
      ],
      [
        28,
        -40
      ],
      [
        6,
        -13
      ],
      [
        12,
        -11
      ],
      [
        11,
        5
      ],
      [
        5,
        -12
      ]
    ],
    [
      [
        25662,
        60663
      ],
      [
        -3,
        -10
      ],
      [
        -15,
        -83
      ],
      [
        -3,
        -11
      ],
      [
        -6,
        16
      ],
      [
        9,
        -28
      ],
      [
        1,
        -52
      ]
    ],
    [
      [
        25645,
        60495
      ],
      [
        -3,
        -6
      ],
      [
        -17,
        3
      ],
      [
        -11,
        -38
      ],
      [
        -24,
        13
      ]
    ],
    [
      [
        25590,
        60467
      ],
      [
        -4,
        11
      ],
      [
        -5,
        -4
      ],
      [
        1,
        9
      ],
      [
        -7,
        22
      ],
      [
        -3,
        74
      ],
      [
        3,
        35
      ],
      [
        -4,
        19
      ],
      [
        2,
        12
      ],
      [
        -5,
        29
      ]
    ],
    [
      [
        25568,
        60674
      ],
      [
        -6,
        22
      ],
      [
        -19,
        6
      ],
      [
        -5,
        8
      ],
      [
        -4,
        31
      ],
      [
        1,
        23
      ]
    ],
    [
      [
        23315,
        68387
      ],
      [
        65,
        -1
      ],
      [
        34,
        0
      ]
    ],
    [
      [
        23414,
        68386
      ],
      [
        2,
        0
      ],
      [
        0,
        -101
      ],
      [
        67,
        0
      ]
    ],
    [
      [
        23483,
        68285
      ],
      [
        0,
        -303
      ]
    ],
    [
      [
        23483,
        67982
      ],
      [
        -165,
        0
      ]
    ],
    [
      [
        23318,
        67982
      ],
      [
        -3,
        0
      ]
    ],
    [
      [
        23315,
        67982
      ],
      [
        0,
        405
      ]
    ],
    [
      [
        26001,
        68350
      ],
      [
        72,
        1
      ]
    ],
    [
      [
        26073,
        68351
      ],
      [
        0,
        -407
      ]
    ],
    [
      [
        25941,
        67944
      ],
      [
        -1,
        203
      ],
      [
        0,
        67
      ],
      [
        -1,
        139
      ]
    ],
    [
      [
        25941,
        67944
      ],
      [
        -110,
        5
      ]
    ],
    [
      [
        25831,
        67949
      ],
      [
        0,
        42
      ],
      [
        -4,
        40
      ],
      [
        0,
        33
      ],
      [
        -5,
        61
      ],
      [
        -4,
        25
      ],
      [
        -1,
        7
      ],
      [
        0,
        3
      ],
      [
        -5,
        24
      ],
      [
        -2,
        13
      ],
      [
        -2,
        18
      ],
      [
        0,
        12
      ],
      [
        2,
        11
      ],
      [
        2,
        9
      ],
      [
        15,
        35
      ],
      [
        5,
        16
      ],
      [
        2,
        11
      ],
      [
        0,
        1
      ],
      [
        6,
        31
      ],
      [
        1,
        6
      ],
      [
        3,
        20
      ]
    ],
    [
      [
        26073,
        67944
      ],
      [
        34,
        -1
      ],
      [
        98,
        -1
      ]
    ],
    [
      [
        26206,
        67537
      ],
      [
        -133,
        3
      ]
    ],
    [
      [
        25823,
        67545
      ],
      [
        117,
        -6
      ]
    ],
    [
      [
        26010,
        67336
      ],
      [
        0,
        -102
      ]
    ],
    [
      [
        26010,
        67234
      ],
      [
        -33,
        1
      ],
      [
        0,
        -102
      ],
      [
        -33,
        -1
      ],
      [
        -68,
        1
      ]
    ],
    [
      [
        25876,
        67133
      ],
      [
        -3,
        20
      ],
      [
        -2,
        13
      ],
      [
        -6,
        46
      ],
      [
        -2,
        10
      ],
      [
        -3,
        24
      ],
      [
        -19,
        117
      ],
      [
        -3,
        26
      ],
      [
        -5,
        43
      ],
      [
        -3,
        25
      ],
      [
        -4,
        41
      ],
      [
        -3,
        47
      ]
    ],
    [
      [
        23821,
        67982
      ],
      [
        67,
        0
      ]
    ],
    [
      [
        23888,
        67982
      ],
      [
        99,
        0
      ]
    ],
    [
      [
        23987,
        67982
      ],
      [
        0,
        -406
      ]
    ],
    [
      [
        23987,
        67576
      ],
      [
        -124,
        0
      ]
    ],
    [
      [
        23863,
        67576
      ],
      [
        -42,
        0
      ]
    ],
    [
      [
        23821,
        67576
      ],
      [
        0,
        406
      ]
    ],
    [
      [
        25046,
        62371
      ],
      [
        0,
        221
      ],
      [
        31,
        0
      ]
    ],
    [
      [
        25077,
        62592
      ],
      [
        1,
        -1
      ],
      [
        30,
        -2
      ],
      [
        62,
        1
      ]
    ],
    [
      [
        25170,
        62590
      ],
      [
        -1,
        -354
      ],
      [
        32,
        3
      ]
    ],
    [
      [
        25201,
        62239
      ],
      [
        0,
        -103
      ]
    ],
    [
      [
        25201,
        62136
      ],
      [
        -94,
        -4
      ],
      [
        -30,
        2
      ],
      [
        0,
        -102
      ]
    ],
    [
      [
        25077,
        62032
      ],
      [
        -32,
        6
      ]
    ],
    [
      [
        25045,
        62038
      ],
      [
        -1,
        204
      ],
      [
        0,
        96
      ],
      [
        2,
        33
      ]
    ],
    [
      [
        25170,
        62590
      ],
      [
        93,
        -1
      ]
    ],
    [
      [
        25263,
        62589
      ],
      [
        0,
        -51
      ],
      [
        31,
        0
      ]
    ],
    [
      [
        25294,
        62538
      ],
      [
        -1,
        -303
      ]
    ],
    [
      [
        25293,
        62235
      ],
      [
        -60,
        5
      ],
      [
        -32,
        -1
      ]
    ],
    [
      [
        23788,
        70280
      ],
      [
        2,
        -306
      ]
    ],
    [
      [
        23790,
        69974
      ],
      [
        -109,
        0
      ]
    ],
    [
      [
        23681,
        69974
      ],
      [
        -3,
        8
      ],
      [
        -2,
        9
      ],
      [
        0,
        14
      ],
      [
        -7,
        20
      ],
      [
        -3,
        19
      ],
      [
        0,
        33
      ],
      [
        1,
        24
      ],
      [
        5,
        12
      ],
      [
        -6,
        -1
      ],
      [
        -6,
        44
      ],
      [
        2,
        13
      ],
      [
        -12,
        18
      ],
      [
        -3,
        38
      ]
    ],
    [
      [
        23647,
        70225
      ],
      [
        -11,
        18
      ],
      [
        -1,
        11
      ],
      [
        -4,
        -1
      ],
      [
        -7,
        27
      ],
      [
        96,
        2
      ],
      [
        68,
        -2
      ]
    ],
    [
      [
        21748,
        57894
      ],
      [
        153,
        2
      ]
    ],
    [
      [
        21901,
        57896
      ],
      [
        -1,
        -507
      ]
    ],
    [
      [
        21900,
        57389
      ],
      [
        -112,
        0
      ]
    ],
    [
      [
        21788,
        57389
      ],
      [
        -41,
        0
      ]
    ],
    [
      [
        23230,
        70612
      ],
      [
        69,
        1
      ],
      [
        104,
        -2
      ]
    ],
    [
      [
        23403,
        70611
      ],
      [
        0,
        -202
      ],
      [
        2,
        -101
      ],
      [
        0,
        -85
      ]
    ],
    [
      [
        23405,
        70223
      ],
      [
        0,
        -17
      ]
    ],
    [
      [
        23405,
        70206
      ],
      [
        -75,
        1
      ],
      [
        -28,
        -1
      ],
      [
        -69,
        2
      ]
    ],
    [
      [
        23233,
        70208
      ],
      [
        0,
        202
      ],
      [
        -3,
        0
      ],
      [
        0,
        202
      ]
    ],
    [
      [
        22550,
        59038
      ],
      [
        29,
        0
      ]
    ],
    [
      [
        22579,
        59038
      ],
      [
        120,
        0
      ]
    ],
    [
      [
        22699,
        59038
      ],
      [
        0,
        -511
      ]
    ],
    [
      [
        22699,
        58527
      ],
      [
        -109,
        0
      ],
      [
        -40,
        -1
      ]
    ],
    [
      [
        25073,
        59085
      ],
      [
        53,
        -4
      ],
      [
        1,
        25
      ]
    ],
    [
      [
        25127,
        59106
      ],
      [
        7,
        -33
      ],
      [
        11,
        -21
      ],
      [
        9,
        -45
      ],
      [
        4,
        -3
      ],
      [
        2,
        -14
      ],
      [
        12,
        -11
      ],
      [
        9,
        -2
      ],
      [
        4,
        -8
      ],
      [
        0,
        -15
      ],
      [
        16,
        -35
      ]
    ],
    [
      [
        25201,
        58919
      ],
      [
        -1,
        -71
      ],
      [
        -2,
        -239
      ],
      [
        -1,
        -6
      ]
    ],
    [
      [
        25197,
        58603
      ],
      [
        -58,
        7
      ]
    ],
    [
      [
        25139,
        58610
      ],
      [
        -6,
        21
      ],
      [
        -8,
        14
      ],
      [
        -6,
        1
      ],
      [
        -9,
        14
      ],
      [
        0,
        17
      ],
      [
        -10,
        -5
      ],
      [
        -8,
        13
      ],
      [
        -7,
        1
      ],
      [
        -2,
        27
      ],
      [
        -4,
        17
      ],
      [
        2,
        24
      ],
      [
        -3,
        55
      ],
      [
        -9,
        10
      ],
      [
        -5,
        13
      ],
      [
        -1,
        14
      ]
    ],
    [
      [
        25063,
        58846
      ],
      [
        -5,
        14
      ],
      [
        12,
        17
      ],
      [
        3,
        208
      ]
    ],
    [
      [
        25335,
        58986
      ],
      [
        10,
        32
      ],
      [
        1,
        23
      ],
      [
        9,
        40
      ],
      [
        1,
        20
      ],
      [
        7,
        5
      ],
      [
        3,
        12
      ],
      [
        0,
        24
      ],
      [
        5,
        7
      ],
      [
        -1,
        9
      ],
      [
        -1,
        32
      ],
      [
        -3,
        18
      ],
      [
        0,
        19
      ],
      [
        3,
        16
      ],
      [
        -1,
        22
      ],
      [
        17,
        0
      ],
      [
        11,
        -1
      ],
      [
        1,
        2
      ]
    ],
    [
      [
        25397,
        59266
      ],
      [
        3,
        -8
      ]
    ],
    [
      [
        25400,
        59258
      ],
      [
        7,
        -48
      ],
      [
        3,
        -56
      ],
      [
        -2,
        -25
      ]
    ],
    [
      [
        25408,
        59129
      ],
      [
        0,
        -24
      ],
      [
        3,
        -20
      ],
      [
        2,
        -25
      ],
      [
        5,
        -27
      ],
      [
        -1,
        -35
      ],
      [
        -5,
        -25
      ],
      [
        -7,
        -38
      ],
      [
        -8,
        -34
      ],
      [
        -3,
        -22
      ],
      [
        0,
        -30
      ],
      [
        -5,
        -26
      ],
      [
        -1,
        -16
      ],
      [
        3,
        -23
      ],
      [
        10,
        -11
      ],
      [
        11,
        4
      ],
      [
        3,
        -6
      ],
      [
        -1,
        -35
      ],
      [
        -3,
        -46
      ],
      [
        -6,
        -29
      ]
    ],
    [
      [
        25405,
        58661
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -22
      ]
    ],
    [
      [
        25402,
        58632
      ],
      [
        -9,
        1
      ],
      [
        -7,
        -7
      ],
      [
        0,
        34
      ],
      [
        -6,
        12
      ],
      [
        -9,
        -9
      ],
      [
        -26,
        4
      ]
    ],
    [
      [
        25345,
        58667
      ],
      [
        -11,
        1
      ],
      [
        0,
        158
      ],
      [
        1,
        160
      ]
    ],
    [
      [
        27282,
        55866
      ],
      [
        5,
        -2
      ],
      [
        5,
        -31
      ],
      [
        9,
        -6
      ],
      [
        11,
        -26
      ],
      [
        10,
        -10
      ],
      [
        7,
        -25
      ],
      [
        7,
        -6
      ],
      [
        13,
        -25
      ],
      [
        7,
        -20
      ],
      [
        5,
        -7
      ],
      [
        6,
        -24
      ],
      [
        7,
        -17
      ],
      [
        1,
        -9
      ],
      [
        1,
        4
      ],
      [
        11,
        -30
      ],
      [
        3,
        -41
      ],
      [
        11,
        -31
      ]
    ],
    [
      [
        27401,
        55560
      ],
      [
        -27,
        -60
      ],
      [
        3,
        -45
      ],
      [
        -4,
        -29
      ],
      [
        -2,
        -2
      ],
      [
        -9,
        50
      ],
      [
        -40,
        -89
      ]
    ],
    [
      [
        27322,
        55385
      ],
      [
        -2,
        10
      ],
      [
        -4,
        16
      ],
      [
        -6,
        5
      ],
      [
        -7,
        32
      ],
      [
        -12,
        44
      ]
    ],
    [
      [
        27291,
        55492
      ],
      [
        -4,
        13
      ],
      [
        -3,
        24
      ],
      [
        -3,
        12
      ],
      [
        2,
        53
      ],
      [
        0,
        62
      ],
      [
        2,
        125
      ],
      [
        0,
        36
      ],
      [
        -3,
        49
      ]
    ],
    [
      [
        22384,
        50990
      ],
      [
        7,
        -10
      ],
      [
        82,
        -118
      ],
      [
        12,
        -17
      ],
      [
        10,
        -14
      ]
    ],
    [
      [
        22495,
        50831
      ],
      [
        21,
        -94
      ],
      [
        39,
        -176
      ]
    ],
    [
      [
        22555,
        50561
      ],
      [
        6,
        -25
      ],
      [
        20,
        -86
      ]
    ],
    [
      [
        22581,
        50450
      ],
      [
        -66,
        -203
      ]
    ],
    [
      [
        22515,
        50247
      ],
      [
        0,
        42
      ],
      [
        -83,
        0
      ],
      [
        -47,
        -2
      ]
    ],
    [
      [
        22385,
        50288
      ],
      [
        -1,
        515
      ]
    ],
    [
      [
        22384,
        50803
      ],
      [
        0,
        187
      ]
    ],
    [
      [
        22576,
        67575
      ],
      [
        42,
        1
      ]
    ],
    [
      [
        22618,
        67576
      ],
      [
        100,
        1
      ]
    ],
    [
      [
        22718,
        67577
      ],
      [
        57,
        0
      ]
    ],
    [
      [
        22776,
        67192
      ],
      [
        -67,
        -1
      ]
    ],
    [
      [
        22709,
        67191
      ],
      [
        -122,
        0
      ]
    ],
    [
      [
        22587,
        67191
      ],
      [
        2,
        19
      ],
      [
        -11,
        14
      ]
    ],
    [
      [
        20920,
        69320
      ],
      [
        3,
        0
      ],
      [
        3,
        1
      ],
      [
        -1,
        3
      ],
      [
        1,
        143
      ],
      [
        -1,
        1
      ],
      [
        0,
        103
      ]
    ],
    [
      [
        20925,
        69571
      ],
      [
        290,
        0
      ],
      [
        4,
        -1
      ],
      [
        8,
        1
      ]
    ],
    [
      [
        21227,
        69571
      ],
      [
        0,
        -202
      ]
    ],
    [
      [
        21227,
        69369
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -401
      ],
      [
        0,
        -101
      ],
      [
        -168,
        0
      ]
    ],
    [
      [
        20921,
        68824
      ],
      [
        0,
        353
      ],
      [
        -1,
        143
      ]
    ],
    [
      [
        12690,
        84293
      ],
      [
        118,
        338
      ]
    ],
    [
      [
        12808,
        84631
      ],
      [
        7,
        -48
      ],
      [
        21,
        -128
      ],
      [
        57,
        -182
      ],
      [
        32,
        -161
      ],
      [
        27,
        -99
      ],
      [
        3,
        -12
      ]
    ],
    [
      [
        12955,
        84001
      ],
      [
        -2,
        -5
      ],
      [
        2,
        -12
      ],
      [
        -1,
        -10
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        -1
      ],
      [
        -3,
        -1
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        -1
      ],
      [
        -3,
        0
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        5
      ],
      [
        -10,
        3
      ],
      [
        -10,
        -7
      ],
      [
        -6,
        4
      ],
      [
        -1,
        3
      ],
      [
        -1,
        7
      ],
      [
        -4,
        6
      ],
      [
        -3,
        7
      ],
      [
        0,
        6
      ],
      [
        -2,
        3
      ],
      [
        -3,
        1
      ],
      [
        -3,
        0
      ],
      [
        -1,
        1
      ],
      [
        0,
        4
      ],
      [
        1,
        6
      ],
      [
        2,
        12
      ],
      [
        0,
        9
      ],
      [
        -1,
        4
      ],
      [
        2,
        6
      ],
      [
        6,
        10
      ],
      [
        3,
        9
      ],
      [
        -2,
        14
      ],
      [
        -7,
        13
      ],
      [
        -5,
        0
      ],
      [
        -2,
        3
      ],
      [
        1,
        5
      ],
      [
        1,
        14
      ],
      [
        4,
        6
      ],
      [
        0,
        13
      ],
      [
        -4,
        9
      ],
      [
        -6,
        2
      ],
      [
        -2,
        1
      ],
      [
        -2,
        4
      ],
      [
        -1,
        3
      ],
      [
        -1,
        2
      ],
      [
        -2,
        5
      ],
      [
        -2,
        3
      ],
      [
        -1,
        2
      ],
      [
        -2,
        -10
      ],
      [
        -2,
        -7
      ],
      [
        -2,
        -9
      ],
      [
        -4,
        -4
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        1
      ],
      [
        -1,
        1
      ],
      [
        -2,
        2
      ],
      [
        -3,
        2
      ],
      [
        -2,
        -1
      ],
      [
        -3,
        3
      ],
      [
        0,
        7
      ],
      [
        -2,
        7
      ],
      [
        -1,
        5
      ],
      [
        -2,
        3
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        -6
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        2
      ],
      [
        -3,
        1
      ],
      [
        -3,
        4
      ],
      [
        0,
        8
      ],
      [
        -1,
        2
      ],
      [
        -2,
        0
      ],
      [
        -3,
        -2
      ],
      [
        -3,
        1
      ],
      [
        -3,
        2
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        5
      ],
      [
        1,
        5
      ],
      [
        0,
        2
      ],
      [
        -2,
        4
      ],
      [
        -4,
        0
      ],
      [
        -2,
        4
      ],
      [
        0,
        5
      ],
      [
        -1,
        7
      ],
      [
        -3,
        4
      ],
      [
        -4,
        -2
      ],
      [
        -3,
        0
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        0
      ],
      [
        -2,
        6
      ],
      [
        2,
        12
      ],
      [
        0,
        11
      ],
      [
        -2,
        2
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -5
      ],
      [
        -3,
        -6
      ],
      [
        -2,
        0
      ],
      [
        -3,
        -3
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        3
      ],
      [
        -2,
        2
      ],
      [
        -2,
        2
      ],
      [
        -1,
        0
      ],
      [
        -3,
        5
      ],
      [
        -3,
        3
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        4
      ],
      [
        -1,
        10
      ],
      [
        0,
        11
      ],
      [
        -3,
        2
      ],
      [
        -1,
        1
      ],
      [
        -2,
        4
      ],
      [
        -2,
        4
      ],
      [
        -3,
        3
      ],
      [
        -3,
        3
      ],
      [
        -3,
        0
      ],
      [
        -2,
        4
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -7
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -9
      ],
      [
        -3,
        -7
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -8
      ]
    ],
    [
      [
        12703,
        84192
      ],
      [
        -2,
        5
      ],
      [
        1,
        13
      ],
      [
        -4,
        82
      ],
      [
        -8,
        1
      ]
    ],
    [
      [
        12663,
        84216
      ],
      [
        17,
        48
      ]
    ],
    [
      [
        12680,
        84264
      ],
      [
        -2,
        -28
      ],
      [
        1,
        -9
      ],
      [
        1,
        -4
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -2
      ],
      [
        -5,
        -5
      ],
      [
        -6,
        0
      ],
      [
        -5,
        9
      ]
    ],
    [
      [
        12611,
        83642
      ],
      [
        8,
        19
      ],
      [
        7,
        6
      ],
      [
        12,
        -13
      ],
      [
        2,
        -20
      ],
      [
        -10,
        -16
      ],
      [
        -7,
        -11
      ],
      [
        -10,
        -4
      ],
      [
        -2,
        39
      ]
    ],
    [
      [
        12379,
        84716
      ],
      [
        -16,
        -66
      ],
      [
        1,
        -51
      ],
      [
        -4,
        -31
      ],
      [
        16,
        -44
      ],
      [
        8,
        -31
      ],
      [
        6,
        -3
      ],
      [
        6,
        13
      ],
      [
        7,
        24
      ],
      [
        11,
        -2
      ],
      [
        3,
        -6
      ],
      [
        8,
        11
      ],
      [
        -5,
        17
      ],
      [
        8,
        23
      ],
      [
        8,
        -6
      ],
      [
        11,
        2
      ],
      [
        12,
        12
      ],
      [
        3,
        11
      ],
      [
        67,
        51
      ]
    ],
    [
      [
        12529,
        84640
      ],
      [
        3,
        -30
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -3
      ],
      [
        -5,
        -21
      ],
      [
        1,
        -28
      ],
      [
        1,
        -7
      ],
      [
        4,
        -12
      ],
      [
        9,
        -23
      ],
      [
        11,
        -33
      ],
      [
        2,
        -10
      ],
      [
        1,
        -10
      ],
      [
        0,
        -6
      ],
      [
        -4,
        -9
      ],
      [
        0,
        -6
      ],
      [
        3,
        -11
      ],
      [
        6,
        -16
      ],
      [
        15,
        -36
      ],
      [
        4,
        -17
      ],
      [
        1,
        -13
      ],
      [
        0,
        -10
      ],
      [
        9,
        -47
      ],
      [
        9,
        -20
      ],
      [
        8,
        -35
      ],
      [
        0,
        -15
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -13
      ],
      [
        4,
        -110
      ],
      [
        8,
        -30
      ],
      [
        9,
        -25
      ],
      [
        1,
        -3
      ],
      [
        3,
        -2
      ],
      [
        1,
        -5
      ],
      [
        3,
        -24
      ],
      [
        0,
        -36
      ],
      [
        -1,
        -7
      ],
      [
        -2,
        -5
      ],
      [
        -6,
        10
      ],
      [
        -6,
        33
      ],
      [
        1,
        14
      ],
      [
        -2,
        8
      ],
      [
        -13,
        46
      ],
      [
        -14,
        31
      ],
      [
        -2,
        6
      ],
      [
        -7,
        29
      ],
      [
        -5,
        46
      ],
      [
        0,
        35
      ],
      [
        -5,
        34
      ],
      [
        -9,
        13
      ],
      [
        -10,
        24
      ],
      [
        -6,
        24
      ],
      [
        0,
        2
      ],
      [
        -1,
        11
      ],
      [
        -1,
        9
      ],
      [
        -1,
        7
      ],
      [
        -6,
        8
      ],
      [
        -7,
        8
      ],
      [
        -7,
        -4
      ],
      [
        -1,
        -12
      ],
      [
        12,
        -55
      ],
      [
        14,
        -46
      ],
      [
        2,
        -16
      ],
      [
        2,
        -18
      ],
      [
        -1,
        -4
      ],
      [
        -12,
        -19
      ],
      [
        5,
        -25
      ],
      [
        3,
        -13
      ],
      [
        27,
        -83
      ],
      [
        2,
        -1
      ],
      [
        5,
        -8
      ],
      [
        10,
        -22
      ],
      [
        6,
        -18
      ],
      [
        1,
        -15
      ],
      [
        -3,
        -37
      ],
      [
        0,
        -10
      ],
      [
        3,
        -20
      ],
      [
        3,
        -16
      ],
      [
        6,
        -15
      ],
      [
        4,
        -14
      ],
      [
        8,
        -48
      ],
      [
        -19,
        6
      ],
      [
        0,
        -15
      ],
      [
        15,
        -87
      ],
      [
        1,
        -16
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        -25,
        -62
      ],
      [
        -2,
        -1
      ],
      [
        -4,
        -2
      ],
      [
        -7,
        17
      ],
      [
        -7,
        12
      ],
      [
        -6,
        3
      ],
      [
        -11,
        -4
      ],
      [
        -2,
        -6
      ],
      [
        5,
        -20
      ],
      [
        1,
        -8
      ],
      [
        -8,
        -55
      ],
      [
        -13,
        -49
      ],
      [
        -11,
        -27
      ],
      [
        -27,
        -56
      ],
      [
        -3,
        0
      ],
      [
        -13,
        -14
      ],
      [
        -8,
        -11
      ],
      [
        2,
        -18
      ],
      [
        -4,
        -15
      ],
      [
        -27,
        -48
      ],
      [
        -1,
        -11
      ],
      [
        -3,
        -6
      ],
      [
        -19,
        -9
      ],
      [
        -10,
        12
      ],
      [
        -9,
        89
      ],
      [
        -4,
        135
      ],
      [
        2,
        16
      ],
      [
        10,
        38
      ],
      [
        9,
        26
      ],
      [
        15,
        23
      ],
      [
        -7,
        26
      ],
      [
        -5,
        -1
      ],
      [
        -4,
        6
      ],
      [
        0,
        3
      ],
      [
        -1,
        66
      ],
      [
        7,
        8
      ],
      [
        7,
        -2
      ],
      [
        1,
        -9
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -4
      ],
      [
        12,
        -21
      ],
      [
        2,
        3
      ],
      [
        4,
        20
      ],
      [
        -22,
        77
      ],
      [
        -18,
        64
      ],
      [
        3,
        11
      ],
      [
        0,
        13
      ],
      [
        -4,
        34
      ],
      [
        -15,
        50
      ],
      [
        -3,
        10
      ],
      [
        -5,
        82
      ],
      [
        -2,
        13
      ],
      [
        -1,
        6
      ],
      [
        -4,
        7
      ],
      [
        -4,
        17
      ],
      [
        1,
        40
      ],
      [
        6,
        28
      ],
      [
        1,
        57
      ],
      [
        -6,
        56
      ],
      [
        -3,
        16
      ],
      [
        -3,
        9
      ],
      [
        -3,
        95
      ],
      [
        -2,
        16
      ],
      [
        -3,
        12
      ],
      [
        -6,
        63
      ],
      [
        4,
        28
      ],
      [
        0,
        16
      ],
      [
        -10,
        52
      ],
      [
        -10,
        41
      ],
      [
        -2,
        5
      ],
      [
        -4,
        1
      ],
      [
        -2,
        3
      ],
      [
        -4,
        12
      ],
      [
        -5,
        24
      ],
      [
        -9,
        77
      ],
      [
        -6,
        101
      ],
      [
        3,
        42
      ],
      [
        1,
        7
      ],
      [
        16,
        -39
      ],
      [
        26,
        -64
      ],
      [
        0,
        -6
      ],
      [
        1,
        -18
      ],
      [
        6,
        -23
      ],
      [
        6,
        -7
      ],
      [
        8,
        -2
      ],
      [
        1,
        -6
      ],
      [
        3,
        -52
      ]
    ],
    [
      [
        12097,
        84881
      ],
      [
        16,
        18
      ],
      [
        11,
        0
      ],
      [
        8,
        -7
      ],
      [
        18,
        -43
      ],
      [
        -2,
        -9
      ],
      [
        -29,
        -6
      ],
      [
        -13,
        13
      ],
      [
        -9,
        34
      ]
    ],
    [
      [
        12043,
        86098
      ],
      [
        19,
        -17
      ],
      [
        -1,
        -12
      ],
      [
        -12,
        12
      ],
      [
        -8,
        9
      ],
      [
        2,
        8
      ]
    ],
    [
      [
        11978,
        85151
      ],
      [
        2,
        12
      ],
      [
        7,
        2
      ],
      [
        6,
        -15
      ],
      [
        3,
        -25
      ],
      [
        0,
        -11
      ],
      [
        -2,
        -8
      ],
      [
        -15,
        38
      ],
      [
        -1,
        7
      ]
    ],
    [
      [
        11978,
        84786
      ],
      [
        10,
        23
      ],
      [
        20,
        18
      ],
      [
        2,
        0
      ],
      [
        2,
        -9
      ],
      [
        -1,
        -44
      ],
      [
        -16,
        -19
      ],
      [
        -9,
        6
      ],
      [
        -9,
        20
      ],
      [
        1,
        5
      ]
    ],
    [
      [
        12270,
        84186
      ],
      [
        -4,
        -7
      ],
      [
        -15,
        -5
      ],
      [
        -12,
        1
      ],
      [
        -16,
        17
      ],
      [
        -21,
        37
      ],
      [
        -8,
        21
      ],
      [
        -13,
        24
      ],
      [
        -29,
        43
      ],
      [
        -22,
        23
      ],
      [
        -11,
        15
      ],
      [
        -19,
        19
      ],
      [
        -21,
        33
      ],
      [
        -7,
        19
      ],
      [
        -17,
        27
      ],
      [
        -7,
        4
      ],
      [
        -21,
        -129
      ],
      [
        -13,
        -60
      ],
      [
        -96,
        -8
      ]
    ],
    [
      [
        11918,
        84260
      ],
      [
        -1,
        1
      ],
      [
        -5,
        0
      ],
      [
        -19,
        25
      ],
      [
        -4,
        20
      ],
      [
        -3,
        29
      ],
      [
        -14,
        21
      ],
      [
        -6,
        -3
      ],
      [
        -4,
        8
      ],
      [
        -1,
        10
      ],
      [
        3,
        126
      ],
      [
        1,
        33
      ],
      [
        1,
        15
      ],
      [
        5,
        20
      ],
      [
        11,
        13
      ],
      [
        7,
        -4
      ],
      [
        1,
        -5
      ],
      [
        7,
        19
      ],
      [
        7,
        21
      ],
      [
        15,
        20
      ],
      [
        3,
        51
      ],
      [
        -2,
        25
      ],
      [
        -3,
        21
      ],
      [
        -4,
        24
      ],
      [
        -5,
        17
      ],
      [
        2,
        5
      ],
      [
        23,
        2
      ],
      [
        9,
        -4
      ],
      [
        -1,
        -28
      ],
      [
        1,
        -26
      ],
      [
        12,
        -60
      ],
      [
        11,
        10
      ],
      [
        11,
        44
      ],
      [
        6,
        7
      ],
      [
        29,
        -6
      ],
      [
        1,
        -16
      ],
      [
        16,
        -4
      ],
      [
        3,
        11
      ],
      [
        14,
        38
      ],
      [
        25,
        45
      ],
      [
        7,
        6
      ],
      [
        4,
        -1
      ],
      [
        6,
        -24
      ],
      [
        8,
        -31
      ],
      [
        6,
        -9
      ],
      [
        23,
        -11
      ],
      [
        12,
        -10
      ],
      [
        18,
        -33
      ],
      [
        5,
        -13
      ],
      [
        2,
        -7
      ],
      [
        -7,
        -56
      ],
      [
        -5,
        -22
      ],
      [
        -13,
        -23
      ],
      [
        -18,
        -53
      ],
      [
        4,
        -49
      ],
      [
        5,
        -11
      ],
      [
        7,
        6
      ],
      [
        4,
        9
      ],
      [
        5,
        20
      ],
      [
        -1,
        10
      ],
      [
        0,
        21
      ],
      [
        1,
        2
      ],
      [
        5,
        21
      ],
      [
        13,
        29
      ],
      [
        13,
        56
      ],
      [
        9,
        12
      ],
      [
        2,
        1
      ],
      [
        4,
        -1
      ],
      [
        34,
        -55
      ],
      [
        4,
        0
      ],
      [
        42,
        -10
      ],
      [
        7,
        -9
      ],
      [
        1,
        -7
      ],
      [
        3,
        -16
      ],
      [
        26,
        -13
      ],
      [
        3,
        -3
      ],
      [
        4,
        -12
      ],
      [
        5,
        -18
      ],
      [
        6,
        -49
      ],
      [
        -2,
        -52
      ],
      [
        -2,
        -15
      ],
      [
        -22,
        -44
      ],
      [
        -37,
        49
      ],
      [
        -10,
        -8
      ],
      [
        3,
        -21
      ],
      [
        5,
        -11
      ],
      [
        4,
        -8
      ],
      [
        18,
        -18
      ],
      [
        21,
        -40
      ],
      [
        10,
        -23
      ],
      [
        2,
        -12
      ],
      [
        -21,
        -29
      ],
      [
        -12,
        -7
      ],
      [
        -6,
        13
      ],
      [
        -7,
        -8
      ],
      [
        2,
        -12
      ]
    ],
    [
      [
        11480,
        85398
      ],
      [
        116,
        116
      ]
    ],
    [
      [
        11596,
        85514
      ],
      [
        0,
        -3
      ],
      [
        22,
        4
      ],
      [
        51,
        108
      ],
      [
        111,
        158
      ],
      [
        11,
        23
      ],
      [
        68,
        8
      ],
      [
        26,
        110
      ]
    ],
    [
      [
        11885,
        85922
      ],
      [
        3,
        -3
      ],
      [
        4,
        4
      ],
      [
        1,
        4
      ],
      [
        4,
        -3
      ],
      [
        1,
        -8
      ],
      [
        4,
        -8
      ],
      [
        6,
        -4
      ],
      [
        4,
        4
      ],
      [
        1,
        4
      ],
      [
        2,
        -2
      ],
      [
        2,
        0
      ],
      [
        2,
        -5
      ],
      [
        0,
        -5
      ],
      [
        4,
        -11
      ],
      [
        7,
        -1
      ],
      [
        7,
        0
      ],
      [
        6,
        -5
      ],
      [
        6,
        0
      ],
      [
        5,
        -13
      ],
      [
        7,
        -1
      ],
      [
        3,
        3
      ],
      [
        5,
        -2
      ],
      [
        0,
        -8
      ],
      [
        7,
        -16
      ],
      [
        1,
        -9
      ],
      [
        4,
        -1
      ],
      [
        3,
        7
      ],
      [
        3,
        16
      ],
      [
        3,
        6
      ],
      [
        2,
        4
      ],
      [
        1,
        -2
      ],
      [
        1,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        4,
        -6
      ],
      [
        4,
        2
      ],
      [
        3,
        -3
      ],
      [
        1,
        -6
      ],
      [
        1,
        -8
      ],
      [
        3,
        -11
      ],
      [
        5,
        0
      ],
      [
        3,
        5
      ],
      [
        3,
        4
      ],
      [
        2,
        -3
      ],
      [
        6,
        -1
      ],
      [
        10,
        -1
      ],
      [
        6,
        -1
      ],
      [
        6,
        -4
      ],
      [
        4,
        -8
      ],
      [
        0,
        -7
      ],
      [
        3,
        -5
      ],
      [
        4,
        -5
      ],
      [
        4,
        -6
      ],
      [
        4,
        -11
      ],
      [
        13,
        0
      ],
      [
        5,
        -8
      ],
      [
        5,
        -12
      ],
      [
        6,
        -11
      ],
      [
        4,
        -4
      ],
      [
        1,
        -8
      ],
      [
        -1,
        -7
      ],
      [
        -2,
        -16
      ],
      [
        -1,
        -12
      ],
      [
        4,
        -35
      ],
      [
        3,
        -18
      ],
      [
        4,
        -9
      ],
      [
        5,
        -11
      ],
      [
        4,
        -9
      ],
      [
        6,
        -16
      ],
      [
        6,
        -6
      ],
      [
        5,
        -10
      ],
      [
        6,
        -14
      ],
      [
        0,
        -17
      ],
      [
        -5,
        -15
      ],
      [
        -2,
        -3
      ],
      [
        -5,
        -13
      ],
      [
        1,
        -16
      ],
      [
        1,
        -6
      ],
      [
        4,
        -6
      ],
      [
        5,
        4
      ],
      [
        6,
        -3
      ],
      [
        4,
        -11
      ],
      [
        1,
        -7
      ],
      [
        -3,
        -11
      ],
      [
        -3,
        2
      ],
      [
        -9,
        -16
      ],
      [
        -7,
        -7
      ],
      [
        -7,
        0
      ],
      [
        -7,
        -4
      ],
      [
        -6,
        -4
      ],
      [
        -1,
        -14
      ],
      [
        -7,
        -13
      ],
      [
        0,
        -15
      ],
      [
        -1,
        -15
      ],
      [
        -5,
        -14
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -11
      ],
      [
        1,
        -4
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -14
      ],
      [
        2,
        -15
      ],
      [
        0,
        -5
      ],
      [
        4,
        -4
      ],
      [
        3,
        5
      ],
      [
        7,
        2
      ],
      [
        1,
        -7
      ],
      [
        4,
        -10
      ],
      [
        4,
        -2
      ],
      [
        3,
        5
      ],
      [
        5,
        -1
      ],
      [
        2,
        -9
      ],
      [
        4,
        -4
      ],
      [
        2,
        1
      ],
      [
        5,
        0
      ],
      [
        2,
        -7
      ],
      [
        4,
        -5
      ],
      [
        2,
        1
      ],
      [
        3,
        -5
      ],
      [
        2,
        -9
      ],
      [
        0,
        -23
      ],
      [
        3,
        -12
      ],
      [
        7,
        -3
      ],
      [
        4,
        0
      ],
      [
        3,
        -8
      ],
      [
        5,
        -11
      ],
      [
        7,
        -3
      ],
      [
        5,
        -11
      ],
      [
        4,
        -9
      ],
      [
        2,
        -20
      ],
      [
        -3,
        -9
      ],
      [
        0,
        -15
      ],
      [
        3,
        -2
      ],
      [
        5,
        -10
      ],
      [
        2,
        -12
      ],
      [
        1,
        -16
      ],
      [
        3,
        -14
      ],
      [
        7,
        -15
      ],
      [
        4,
        -17
      ],
      [
        -4,
        -14
      ],
      [
        -6,
        -4
      ],
      [
        -6,
        10
      ],
      [
        -7,
        4
      ],
      [
        -5,
        9
      ],
      [
        -4,
        2
      ],
      [
        -6,
        -4
      ],
      [
        -5,
        0
      ],
      [
        -6,
        -12
      ],
      [
        0,
        -14
      ],
      [
        6,
        -20
      ],
      [
        1,
        -43
      ],
      [
        6,
        -29
      ],
      [
        0,
        -10
      ]
    ],
    [
      [
        12175,
        84921
      ],
      [
        -4,
        0
      ],
      [
        -1,
        -6
      ],
      [
        -13,
        -10
      ],
      [
        -3,
        6
      ],
      [
        -9,
        19
      ],
      [
        -19,
        24
      ],
      [
        -2,
        1
      ],
      [
        -27,
        -37
      ],
      [
        -27,
        -8
      ],
      [
        -23,
        -11
      ],
      [
        -3,
        1
      ],
      [
        -1,
        5
      ],
      [
        0,
        4
      ],
      [
        7,
        31
      ],
      [
        0,
        40
      ],
      [
        -6,
        16
      ],
      [
        -2,
        -1
      ],
      [
        -3,
        -13
      ],
      [
        -1,
        -1
      ],
      [
        -13,
        15
      ],
      [
        -3,
        7
      ],
      [
        -1,
        12
      ],
      [
        3,
        8
      ],
      [
        6,
        9
      ],
      [
        3,
        -3
      ],
      [
        3,
        3
      ],
      [
        11,
        13
      ],
      [
        4,
        9
      ],
      [
        -1,
        23
      ],
      [
        -5,
        8
      ],
      [
        -4,
        38
      ],
      [
        5,
        53
      ],
      [
        -28,
        109
      ],
      [
        -1,
        12
      ],
      [
        2,
        11
      ],
      [
        -1,
        13
      ],
      [
        -10,
        45
      ],
      [
        -10,
        31
      ],
      [
        -2,
        8
      ],
      [
        4,
        11
      ],
      [
        9,
        13
      ],
      [
        -2,
        90
      ],
      [
        -3,
        17
      ],
      [
        -16,
        47
      ],
      [
        -7,
        10
      ],
      [
        -5,
        0
      ],
      [
        0,
        -17
      ],
      [
        3,
        -18
      ],
      [
        7,
        -26
      ],
      [
        5,
        -70
      ],
      [
        -12,
        -125
      ],
      [
        -3,
        -6
      ],
      [
        -14,
        -1
      ],
      [
        -10,
        2
      ],
      [
        -42,
        70
      ],
      [
        -9,
        6
      ],
      [
        -12,
        15
      ],
      [
        -5,
        9
      ],
      [
        -10,
        105
      ],
      [
        0,
        30
      ],
      [
        -5,
        15
      ],
      [
        -4,
        -5
      ],
      [
        -3,
        -7
      ],
      [
        -1,
        -12
      ],
      [
        0,
        -21
      ],
      [
        -3,
        -23
      ],
      [
        -13,
        -22
      ],
      [
        -11,
        4
      ],
      [
        -1,
        2
      ],
      [
        -5,
        10
      ],
      [
        -3,
        12
      ],
      [
        -6,
        11
      ],
      [
        -7,
        8
      ],
      [
        -9,
        7
      ],
      [
        -2,
        0
      ],
      [
        -4,
        -16
      ],
      [
        -10,
        -4
      ],
      [
        -5,
        15
      ],
      [
        0,
        12
      ],
      [
        -5,
        23
      ],
      [
        -12,
        -18
      ],
      [
        1,
        -10
      ],
      [
        -5,
        -26
      ],
      [
        0,
        -9
      ],
      [
        1,
        -9
      ],
      [
        17,
        -18
      ],
      [
        28,
        -17
      ],
      [
        7,
        7
      ],
      [
        19,
        -23
      ],
      [
        17,
        -12
      ],
      [
        9,
        -9
      ],
      [
        12,
        -22
      ],
      [
        21,
        -44
      ],
      [
        30,
        -104
      ],
      [
        0,
        -10
      ],
      [
        -5,
        -19
      ],
      [
        -6,
        -15
      ],
      [
        -4,
        -6
      ],
      [
        -4,
        -3
      ],
      [
        -7,
        -11
      ],
      [
        -9,
        -24
      ],
      [
        6,
        -11
      ],
      [
        21,
        26
      ],
      [
        12,
        18
      ],
      [
        3,
        21
      ],
      [
        4,
        9
      ],
      [
        19,
        -9
      ],
      [
        5,
        14
      ],
      [
        3,
        -4
      ],
      [
        7,
        -105
      ],
      [
        14,
        -32
      ],
      [
        3,
        -26
      ],
      [
        9,
        -20
      ],
      [
        0,
        -16
      ],
      [
        7,
        -36
      ],
      [
        1,
        -16
      ],
      [
        3,
        -24
      ],
      [
        2,
        -21
      ],
      [
        3,
        -44
      ],
      [
        -14,
        -36
      ],
      [
        -5,
        -8
      ],
      [
        -43,
        -32
      ],
      [
        -3,
        -1
      ],
      [
        -3,
        3
      ],
      [
        -2,
        2
      ],
      [
        -3,
        6
      ],
      [
        0,
        6
      ],
      [
        1,
        9
      ],
      [
        1,
        8
      ],
      [
        2,
        10
      ],
      [
        3,
        2
      ],
      [
        2,
        12
      ],
      [
        -3,
        4
      ],
      [
        -1,
        3
      ],
      [
        -14,
        9
      ],
      [
        -12,
        -17
      ],
      [
        4,
        -19
      ],
      [
        2,
        -3
      ],
      [
        1,
        -17
      ],
      [
        -4,
        -32
      ],
      [
        -2,
        -4
      ],
      [
        -4,
        -1
      ],
      [
        -22,
        10
      ],
      [
        -12,
        5
      ],
      [
        -9,
        7
      ],
      [
        -7,
        -6
      ],
      [
        -4,
        -17
      ],
      [
        2,
        -22
      ],
      [
        2,
        -10
      ],
      [
        1,
        -28
      ],
      [
        -7,
        -32
      ],
      [
        -1,
        -3
      ],
      [
        -7,
        -6
      ],
      [
        -10,
        -3
      ],
      [
        -12,
        14
      ],
      [
        -6,
        30
      ],
      [
        -3,
        13
      ],
      [
        4,
        20
      ],
      [
        -3,
        15
      ],
      [
        -9,
        1
      ],
      [
        -6,
        4
      ],
      [
        -21,
        30
      ],
      [
        3,
        15
      ],
      [
        -28,
        74
      ],
      [
        -11,
        13
      ],
      [
        -6,
        6
      ],
      [
        -3,
        0
      ],
      [
        -16,
        -14
      ],
      [
        -10,
        -5
      ],
      [
        -6,
        16
      ],
      [
        -13,
        27
      ],
      [
        -16,
        27
      ],
      [
        -4,
        4
      ],
      [
        -7,
        4
      ],
      [
        -5,
        7
      ],
      [
        -31,
        58
      ],
      [
        -25,
        49
      ],
      [
        -20,
        35
      ],
      [
        -11,
        16
      ],
      [
        -7,
        -2
      ],
      [
        -11,
        18
      ],
      [
        -2,
        8
      ],
      [
        1,
        29
      ],
      [
        -2,
        15
      ],
      [
        -1,
        6
      ],
      [
        -30,
        70
      ],
      [
        -22,
        37
      ],
      [
        -8,
        10
      ],
      [
        -7,
        17
      ],
      [
        -4,
        16
      ],
      [
        -1,
        12
      ],
      [
        1,
        6
      ]
    ],
    [
      [
        22243,
        69203
      ],
      [
        166,
        0
      ]
    ],
    [
      [
        22409,
        69203
      ],
      [
        3,
        0
      ],
      [
        0,
        -306
      ]
    ],
    [
      [
        22412,
        68897
      ],
      [
        0,
        -101
      ],
      [
        1,
        -408
      ]
    ],
    [
      [
        22413,
        68388
      ],
      [
        -63,
        0
      ]
    ],
    [
      [
        22750,
        68792
      ],
      [
        101,
        -1
      ]
    ],
    [
      [
        22851,
        68791
      ],
      [
        0,
        -404
      ]
    ],
    [
      [
        22650,
        68386
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        22649,
        68386
      ],
      [
        0,
        407
      ]
    ],
    [
      [
        25489,
        58392
      ],
      [
        9,
        7
      ],
      [
        1,
        20
      ],
      [
        5,
        4
      ],
      [
        5,
        20
      ],
      [
        5,
        -1
      ],
      [
        6,
        -26
      ],
      [
        11,
        -2
      ],
      [
        14,
        -16
      ],
      [
        11,
        12
      ],
      [
        17,
        40
      ],
      [
        5,
        0
      ]
    ],
    [
      [
        25578,
        58450
      ],
      [
        2,
        -29
      ],
      [
        -5,
        -19
      ],
      [
        0,
        -39
      ],
      [
        8,
        -18
      ],
      [
        1,
        -23
      ],
      [
        6,
        -1
      ],
      [
        3,
        -8
      ],
      [
        1,
        -43
      ],
      [
        4,
        1
      ],
      [
        -4,
        -10
      ],
      [
        2,
        -16
      ],
      [
        -5,
        -45
      ]
    ],
    [
      [
        25591,
        58200
      ],
      [
        -9,
        3
      ],
      [
        0,
        11
      ],
      [
        -34,
        1
      ],
      [
        0,
        -43
      ],
      [
        -8,
        2
      ],
      [
        0,
        -9
      ],
      [
        -9,
        0
      ],
      [
        -2,
        -19
      ],
      [
        -16,
        0
      ]
    ],
    [
      [
        25513,
        58146
      ],
      [
        -7,
        16
      ],
      [
        -2,
        28
      ],
      [
        -11,
        7
      ],
      [
        0,
        36
      ],
      [
        -11,
        0
      ],
      [
        -9,
        12
      ]
    ],
    [
      [
        25473,
        58245
      ],
      [
        2,
        26
      ],
      [
        5,
        0
      ],
      [
        2,
        49
      ],
      [
        9,
        24
      ],
      [
        1,
        25
      ],
      [
        -3,
        23
      ]
    ],
    [
      [
        24825,
        69767
      ],
      [
        0,
        202
      ]
    ],
    [
      [
        24825,
        69969
      ],
      [
        138,
        1
      ],
      [
        33,
        -1
      ],
      [
        1,
        -102
      ]
    ],
    [
      [
        24997,
        69867
      ],
      [
        0,
        -405
      ]
    ],
    [
      [
        24997,
        69462
      ],
      [
        -18,
        0
      ],
      [
        -66,
        1
      ],
      [
        -88,
        0
      ]
    ],
    [
      [
        24825,
        69463
      ],
      [
        -1,
        256
      ],
      [
        1,
        48
      ]
    ],
    [
      [
        25096,
        58489
      ],
      [
        3,
        -16
      ],
      [
        7,
        -1
      ],
      [
        4,
        -9
      ],
      [
        35,
        132
      ],
      [
        -6,
        15
      ]
    ],
    [
      [
        25197,
        58603
      ],
      [
        28,
        -2
      ]
    ],
    [
      [
        25225,
        58601
      ],
      [
        -1,
        -166
      ],
      [
        2,
        -24
      ],
      [
        -3,
        -44
      ]
    ],
    [
      [
        25160,
        58180
      ],
      [
        -15,
        1
      ],
      [
        -51,
        4
      ]
    ],
    [
      [
        25094,
        58185
      ],
      [
        1,
        163
      ],
      [
        1,
        141
      ]
    ],
    [
      [
        28035,
        61205
      ],
      [
        3,
        7
      ],
      [
        4,
        1
      ],
      [
        -2,
        4
      ],
      [
        -3,
        0
      ],
      [
        0,
        8
      ],
      [
        3,
        5
      ],
      [
        -1,
        10
      ],
      [
        1,
        1
      ],
      [
        5,
        14
      ],
      [
        6,
        -5
      ],
      [
        -1,
        -22
      ],
      [
        5,
        15
      ],
      [
        -1,
        -43
      ],
      [
        -5,
        -12
      ],
      [
        -1,
        3
      ],
      [
        -5,
        4
      ],
      [
        -7,
        -8
      ],
      [
        -1,
        9
      ],
      [
        0,
        9
      ]
    ],
    [
      [
        19361,
        70742
      ],
      [
        70,
        1
      ],
      [
        0,
        315
      ],
      [
        4,
        0
      ],
      [
        0,
        236
      ]
    ],
    [
      [
        19435,
        71294
      ],
      [
        0,
        68
      ],
      [
        106,
        -1
      ]
    ],
    [
      [
        19541,
        71361
      ],
      [
        0,
        -151
      ],
      [
        6,
        0
      ],
      [
        0,
        -50
      ],
      [
        23,
        -1
      ],
      [
        0,
        -102
      ],
      [
        7,
        0
      ],
      [
        -1,
        -44
      ],
      [
        6,
        0
      ],
      [
        0,
        -102
      ],
      [
        6,
        0
      ],
      [
        0,
        -16
      ],
      [
        3,
        0
      ],
      [
        -1,
        -34
      ],
      [
        3,
        0
      ],
      [
        0,
        -17
      ],
      [
        6,
        0
      ],
      [
        0,
        -34
      ],
      [
        6,
        0
      ],
      [
        0,
        -169
      ]
    ],
    [
      [
        19605,
        70641
      ],
      [
        -40,
        0
      ]
    ],
    [
      [
        19565,
        70641
      ],
      [
        -137,
        0
      ],
      [
        -1,
        -102
      ]
    ],
    [
      [
        19427,
        70539
      ],
      [
        -52,
        0
      ],
      [
        0,
        102
      ],
      [
        -14,
        0
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        20358,
        67570
      ],
      [
        16,
        1
      ]
    ],
    [
      [
        20374,
        67571
      ],
      [
        93,
        1
      ],
      [
        169,
        3
      ]
    ],
    [
      [
        20636,
        67575
      ],
      [
        50,
        1
      ]
    ],
    [
      [
        20686,
        67576
      ],
      [
        0,
        -828
      ],
      [
        2,
        -6
      ],
      [
        0,
        -202
      ]
    ],
    [
      [
        20688,
        66540
      ],
      [
        -27,
        -1
      ],
      [
        -36,
        0
      ],
      [
        -11,
        -2
      ],
      [
        -36,
        -1
      ],
      [
        1,
        -24
      ],
      [
        0,
        -179
      ]
    ],
    [
      [
        20579,
        66333
      ],
      [
        -14,
        0
      ],
      [
        -2,
        -14
      ],
      [
        0,
        -17
      ],
      [
        -3,
        0
      ],
      [
        0,
        -33
      ],
      [
        -3,
        0
      ],
      [
        1,
        -67
      ],
      [
        -6,
        0
      ],
      [
        1,
        -34
      ],
      [
        -34,
        0
      ],
      [
        -8,
        -1
      ],
      [
        -2,
        7
      ],
      [
        -18,
        3
      ],
      [
        -4,
        8
      ],
      [
        0,
        85
      ],
      [
        11,
        0
      ],
      [
        0,
        34
      ],
      [
        5,
        0
      ],
      [
        0,
        28
      ],
      [
        -144,
        3
      ]
    ],
    [
      [
        20359,
        66335
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        26876,
        59349
      ],
      [
        5,
        12
      ],
      [
        17,
        -22
      ],
      [
        42,
        24
      ],
      [
        4,
        -7
      ],
      [
        4,
        11
      ],
      [
        0,
        -10
      ],
      [
        5,
        -2
      ],
      [
        -1,
        -12
      ],
      [
        10,
        -8
      ],
      [
        -4,
        -32
      ],
      [
        5,
        13
      ],
      [
        9,
        -2
      ],
      [
        10,
        -6
      ]
    ],
    [
      [
        26982,
        59308
      ],
      [
        0,
        -30
      ],
      [
        -1,
        -15
      ],
      [
        -3,
        -37
      ],
      [
        -7,
        -72
      ],
      [
        0,
        -13
      ]
    ],
    [
      [
        26971,
        59141
      ],
      [
        -5,
        -14
      ],
      [
        1,
        -13
      ],
      [
        -4,
        -21
      ],
      [
        -9,
        -20
      ],
      [
        -4,
        -18
      ],
      [
        -1,
        -19
      ],
      [
        -5,
        -10
      ],
      [
        -14,
        2
      ],
      [
        -11,
        -8
      ],
      [
        -19,
        -62
      ]
    ],
    [
      [
        26900,
        58958
      ],
      [
        -6,
        27
      ],
      [
        -7,
        27
      ],
      [
        -2,
        5
      ],
      [
        5,
        308
      ],
      [
        0,
        9
      ],
      [
        -20,
        -10
      ]
    ],
    [
      [
        26870,
        59324
      ],
      [
        7,
        15
      ],
      [
        -1,
        10
      ]
    ],
    [
      [
        24579,
        69663
      ],
      [
        0,
        102
      ],
      [
        69,
        -2
      ]
    ],
    [
      [
        24648,
        69763
      ],
      [
        61,
        -1
      ],
      [
        116,
        5
      ]
    ],
    [
      [
        24825,
        69463
      ],
      [
        -43,
        0
      ],
      [
        0,
        -101
      ],
      [
        -33,
        0
      ]
    ],
    [
      [
        24749,
        69362
      ],
      [
        -33,
        -3
      ],
      [
        -34,
        0
      ],
      [
        -68,
        1
      ],
      [
        -34,
        -1
      ]
    ],
    [
      [
        24580,
        69359
      ],
      [
        -1,
        104
      ],
      [
        0,
        200
      ]
    ],
    [
      [
        18974,
        69325
      ],
      [
        72,
        1
      ],
      [
        7,
        -3
      ],
      [
        3,
        -2
      ],
      [
        12,
        -7
      ],
      [
        61,
        0
      ],
      [
        24,
        2
      ],
      [
        11,
        8
      ],
      [
        6,
        -2
      ],
      [
        4,
        0
      ],
      [
        11,
        -3
      ],
      [
        24,
        0
      ],
      [
        25,
        8
      ],
      [
        66,
        0
      ],
      [
        21,
        -2
      ]
    ],
    [
      [
        19321,
        69325
      ],
      [
        13,
        0
      ],
      [
        25,
        1
      ],
      [
        24,
        0
      ],
      [
        53,
        3
      ],
      [
        3,
        -1
      ],
      [
        29,
        1
      ],
      [
        2,
        0
      ],
      [
        45,
        1
      ],
      [
        5,
        -8
      ],
      [
        6,
        1
      ],
      [
        123,
        0
      ]
    ],
    [
      [
        19649,
        69323
      ],
      [
        0,
        -150
      ],
      [
        8,
        0
      ],
      [
        0,
        -408
      ],
      [
        5,
        0
      ],
      [
        0,
        -410
      ],
      [
        7,
        0
      ]
    ],
    [
      [
        19669,
        68355
      ],
      [
        0,
        -104
      ]
    ],
    [
      [
        19669,
        68251
      ],
      [
        -68,
        1
      ],
      [
        1,
        -104
      ],
      [
        -35,
        0
      ],
      [
        1,
        -100
      ],
      [
        -50,
        0
      ],
      [
        -1,
        -101
      ],
      [
        -11,
        -2
      ],
      [
        -38,
        0
      ],
      [
        -12,
        -3
      ]
    ],
    [
      [
        19456,
        67942
      ],
      [
        -2,
        24
      ],
      [
        -4,
        9
      ],
      [
        -9,
        1
      ],
      [
        -3,
        46
      ],
      [
        -6,
        2
      ],
      [
        -4,
        29
      ],
      [
        -5,
        6
      ],
      [
        -3,
        19
      ],
      [
        -8,
        2
      ],
      [
        -1,
        19
      ],
      [
        -10,
        -11
      ],
      [
        -7,
        18
      ],
      [
        -7,
        0
      ],
      [
        -4,
        -12
      ],
      [
        -4,
        -6
      ],
      [
        -1,
        5
      ],
      [
        -4,
        -11
      ],
      [
        -5,
        -9
      ],
      [
        -8,
        -27
      ],
      [
        -3,
        -27
      ],
      [
        -2,
        -11
      ],
      [
        1,
        -12
      ],
      [
        1,
        -12
      ],
      [
        -2,
        -6
      ],
      [
        -3,
        -1
      ],
      [
        -4,
        -4
      ],
      [
        -3,
        -5
      ],
      [
        -3,
        0
      ],
      [
        -4,
        -4
      ],
      [
        -3,
        -7
      ],
      [
        -2,
        -6
      ],
      [
        -2,
        -4
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -2,
        1
      ],
      [
        -2,
        5
      ],
      [
        -2,
        4
      ],
      [
        -2,
        3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        0,
        3
      ],
      [
        -1,
        3
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        5
      ],
      [
        -1,
        9
      ],
      [
        1,
        6
      ],
      [
        -1,
        7
      ],
      [
        0,
        7
      ],
      [
        2,
        5
      ],
      [
        3,
        1
      ],
      [
        2,
        1
      ],
      [
        3,
        3
      ],
      [
        1,
        3
      ],
      [
        0,
        3
      ],
      [
        -1,
        2
      ],
      [
        -2,
        3
      ],
      [
        -1,
        4
      ],
      [
        0,
        5
      ],
      [
        2,
        2
      ],
      [
        0,
        12
      ],
      [
        -2,
        4
      ],
      [
        -4,
        11
      ],
      [
        -2,
        7
      ],
      [
        1,
        11
      ],
      [
        -1,
        8
      ],
      [
        -2,
        4
      ],
      [
        -2,
        2
      ],
      [
        0,
        13
      ],
      [
        2,
        10
      ],
      [
        1,
        9
      ],
      [
        -4,
        -1
      ],
      [
        -3,
        -4
      ],
      [
        -10,
        -4
      ],
      [
        -8,
        14
      ],
      [
        -10,
        -5
      ],
      [
        -4,
        -5
      ],
      [
        -1,
        5
      ],
      [
        -1,
        1
      ],
      [
        0,
        5
      ],
      [
        1,
        4
      ],
      [
        -1,
        2
      ],
      [
        0,
        3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -2,
        -1
      ],
      [
        0,
        15
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        6
      ],
      [
        -1,
        3
      ],
      [
        -1,
        4
      ],
      [
        0,
        10
      ],
      [
        -5,
        6
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        19250,
        68168
      ],
      [
        0,
        119
      ],
      [
        -7,
        26
      ],
      [
        -11,
        3
      ],
      [
        -1,
        3
      ],
      [
        -1,
        5
      ],
      [
        0,
        21
      ],
      [
        1,
        4
      ],
      [
        1,
        4
      ],
      [
        0,
        4
      ],
      [
        -1,
        2
      ],
      [
        0,
        5
      ],
      [
        2,
        3
      ],
      [
        2,
        2
      ],
      [
        -1,
        5
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        1,
        2
      ],
      [
        0,
        7
      ],
      [
        1,
        -1
      ],
      [
        1,
        4
      ],
      [
        -1,
        5
      ],
      [
        -2,
        3
      ],
      [
        1,
        6
      ],
      [
        1,
        2
      ],
      [
        0,
        4
      ],
      [
        -1,
        4
      ],
      [
        0,
        -2
      ],
      [
        -2,
        5
      ],
      [
        -2,
        7
      ],
      [
        -1,
        11
      ],
      [
        0,
        10
      ],
      [
        1,
        5
      ],
      [
        -2,
        3
      ],
      [
        0,
        2
      ],
      [
        -1,
        7
      ],
      [
        0,
        7
      ],
      [
        -1,
        4
      ],
      [
        0,
        6
      ],
      [
        1,
        6
      ],
      [
        -1,
        11
      ],
      [
        -4,
        10
      ],
      [
        -2,
        2
      ],
      [
        -1,
        5
      ],
      [
        -2,
        0
      ],
      [
        -1,
        2
      ],
      [
        0,
        3
      ],
      [
        -1,
        2
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        2
      ],
      [
        -1,
        4
      ],
      [
        0,
        5
      ],
      [
        1,
        -1
      ],
      [
        0,
        6
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        19209,
        68531
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        19209,
        68532
      ],
      [
        0,
        0
      ]
    ],
    [
      [
        19209,
        68532
      ],
      [
        0,
        3
      ],
      [
        -1,
        0
      ],
      [
        1,
        1
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        -1,
        3
      ],
      [
        -2,
        1
      ],
      [
        -2,
        4
      ],
      [
        -1,
        4
      ],
      [
        0,
        19
      ],
      [
        -1,
        7
      ],
      [
        1,
        4
      ],
      [
        -1,
        6
      ],
      [
        0,
        9
      ],
      [
        -1,
        5
      ],
      [
        -2,
        4
      ],
      [
        0,
        3
      ],
      [
        -2,
        2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        3
      ],
      [
        0,
        13
      ],
      [
        -1,
        5
      ],
      [
        -1,
        3
      ],
      [
        -1,
        2
      ],
      [
        -2,
        2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        3
      ],
      [
        -1,
        2
      ],
      [
        -1,
        3
      ],
      [
        -1,
        5
      ],
      [
        -1,
        3
      ],
      [
        -1,
        5
      ],
      [
        0,
        5
      ],
      [
        1,
        2
      ],
      [
        0,
        5
      ],
      [
        1,
        8
      ],
      [
        0,
        27
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        23
      ],
      [
        1,
        5
      ],
      [
        0,
        15
      ],
      [
        1,
        4
      ],
      [
        0,
        5
      ],
      [
        -2,
        5
      ],
      [
        -1,
        4
      ],
      [
        -1,
        2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        0,
        6
      ],
      [
        1,
        2
      ],
      [
        0,
        3
      ],
      [
        1,
        0
      ],
      [
        0,
        5
      ],
      [
        -1,
        6
      ],
      [
        -2,
        5
      ],
      [
        -2,
        3
      ],
      [
        -2,
        2
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        -2,
        2
      ],
      [
        -2,
        1
      ],
      [
        -2,
        4
      ],
      [
        -1,
        3
      ],
      [
        -1,
        2
      ],
      [
        -2,
        2
      ],
      [
        0,
        5
      ],
      [
        1,
        2
      ],
      [
        0,
        10
      ],
      [
        -1,
        7
      ],
      [
        -40,
        -1
      ],
      [
        -40,
        0
      ],
      [
        0,
        97
      ],
      [
        -29,
        1
      ],
      [
        -33,
        -1
      ],
      [
        -46,
        0
      ]
    ],
    [
      [
        18971,
        68934
      ],
      [
        0,
        98
      ],
      [
        -1,
        136
      ],
      [
        1,
        78
      ],
      [
        0,
        78
      ],
      [
        3,
        1
      ]
    ],
    [
      [
        23148,
        68388
      ],
      [
        131,
        -2
      ]
    ],
    [
      [
        23279,
        68386
      ],
      [
        36,
        1
      ]
    ],
    [
      [
        23315,
        67982
      ],
      [
        -97,
        0
      ],
      [
        -67,
        1
      ]
    ],
    [
      [
        23147,
        67983
      ],
      [
        1,
        405
      ]
    ],
    [
      [
        25245,
        67223
      ],
      [
        33,
        -2
      ]
    ],
    [
      [
        25278,
        67221
      ],
      [
        33,
        -1
      ],
      [
        32,
        -1
      ],
      [
        13,
        -1
      ],
      [
        21,
        0
      ]
    ],
    [
      [
        25377,
        67218
      ],
      [
        -1,
        -37
      ],
      [
        0,
        -159
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -202
      ]
    ],
    [
      [
        25375,
        66812
      ],
      [
        -33,
        0
      ],
      [
        -12,
        -1
      ],
      [
        -21,
        0
      ]
    ],
    [
      [
        25309,
        66811
      ],
      [
        -19,
        1
      ],
      [
        -47,
        0
      ]
    ],
    [
      [
        25243,
        66812
      ],
      [
        0,
        205
      ],
      [
        1,
        103
      ],
      [
        1,
        103
      ]
    ],
    [
      [
        23039,
        68388
      ],
      [
        104,
        0
      ]
    ],
    [
      [
        23143,
        68388
      ],
      [
        5,
        0
      ]
    ],
    [
      [
        23039,
        67984
      ],
      [
        0,
        404
      ]
    ],
    [
      [
        28379,
        61581
      ],
      [
        0,
        -3
      ],
      [
        2,
        -8
      ],
      [
        4,
        -8
      ],
      [
        7,
        -1
      ],
      [
        11,
        10
      ],
      [
        6,
        2
      ],
      [
        5,
        4
      ],
      [
        2,
        6
      ],
      [
        4,
        20
      ],
      [
        10,
        2
      ],
      [
        3,
        -2
      ],
      [
        2,
        0
      ],
      [
        4,
        11
      ],
      [
        4,
        22
      ],
      [
        2,
        3
      ],
      [
        2,
        2
      ],
      [
        5,
        -16
      ],
      [
        4,
        -14
      ],
      [
        -2,
        -39
      ],
      [
        -1,
        -14
      ],
      [
        -3,
        -21
      ],
      [
        2,
        -10
      ],
      [
        8,
        -29
      ]
    ],
    [
      [
        28460,
        61498
      ],
      [
        -14,
        -20
      ],
      [
        0,
        -70
      ],
      [
        -1,
        -26
      ],
      [
        -4,
        -8
      ],
      [
        1,
        -11
      ]
    ],
    [
      [
        28442,
        61363
      ],
      [
        -4,
        -24
      ],
      [
        -3,
        22
      ],
      [
        -8,
        -12
      ]
    ],
    [
      [
        28427,
        61349
      ],
      [
        -5,
        17
      ],
      [
        -5,
        6
      ],
      [
        -4,
        -5
      ],
      [
        -7,
        11
      ],
      [
        -7,
        26
      ],
      [
        -5,
        0
      ],
      [
        1,
        -11
      ],
      [
        -7,
        2
      ],
      [
        3,
        25
      ],
      [
        -2,
        22
      ],
      [
        6,
        6
      ],
      [
        1,
        8
      ],
      [
        -7,
        10
      ],
      [
        -5,
        -1
      ],
      [
        -3,
        -29
      ],
      [
        -3,
        16
      ],
      [
        -5,
        -4
      ],
      [
        -5,
        12
      ]
    ],
    [
      [
        28368,
        61460
      ],
      [
        -5,
        19
      ],
      [
        1,
        48
      ],
      [
        4,
        19
      ],
      [
        -1,
        17
      ],
      [
        2,
        14
      ],
      [
        10,
        4
      ]
    ],
    [
      [
        18166,
        70122
      ],
      [
        6,
        20
      ],
      [
        3,
        -6
      ],
      [
        2,
        38
      ],
      [
        -3,
        17
      ],
      [
        5,
        28
      ],
      [
        8,
        14
      ],
      [
        4,
        -10
      ],
      [
        1,
        -24
      ],
      [
        6,
        -2
      ],
      [
        7,
        14
      ],
      [
        5,
        18
      ],
      [
        -2,
        16
      ],
      [
        4,
        0
      ],
      [
        10,
        27
      ],
      [
        4,
        5
      ],
      [
        5,
        22
      ],
      [
        4,
        6
      ],
      [
        8,
        -10
      ],
      [
        4,
        6
      ],
      [
        9,
        1
      ],
      [
        3,
        11
      ],
      [
        5,
        0
      ],
      [
        0,
        14
      ],
      [
        7,
        11
      ],
      [
        11,
        11
      ],
      [
        -2,
        14
      ],
      [
        0,
        23
      ],
      [
        5,
        30
      ]
    ],
    [
      [
        18285,
        70416
      ],
      [
        6,
        -3
      ],
      [
        8,
        -59
      ],
      [
        7,
        -35
      ],
      [
        3,
        -29
      ],
      [
        -1,
        -28
      ],
      [
        11,
        -47
      ],
      [
        5,
        -7
      ],
      [
        4,
        -3
      ],
      [
        0,
        15
      ],
      [
        5,
        40
      ],
      [
        2,
        10
      ],
      [
        8,
        -8
      ],
      [
        3,
        14
      ],
      [
        6,
        -1
      ],
      [
        7,
        25
      ],
      [
        -1,
        7
      ],
      [
        7,
        25
      ],
      [
        9,
        9
      ],
      [
        5,
        12
      ],
      [
        22,
        -4
      ],
      [
        4,
        -24
      ]
    ],
    [
      [
        18405,
        70325
      ],
      [
        17,
        -36
      ],
      [
        6,
        -16
      ],
      [
        1,
        -10
      ],
      [
        3,
        1
      ],
      [
        12,
        -11
      ],
      [
        5,
        3
      ],
      [
        7,
        -25
      ],
      [
        5,
        11
      ],
      [
        5,
        -14
      ],
      [
        3,
        3
      ],
      [
        9,
        -7
      ],
      [
        7,
        -18
      ],
      [
        4,
        6
      ],
      [
        1,
        -10
      ],
      [
        6,
        -8
      ],
      [
        0,
        -17
      ],
      [
        3,
        -5
      ],
      [
        -1,
        -20
      ],
      [
        5,
        -30
      ],
      [
        9,
        -12
      ],
      [
        3,
        -24
      ],
      [
        -2,
        -12
      ],
      [
        3,
        -24
      ]
    ],
    [
      [
        18516,
        70050
      ],
      [
        2,
        -14
      ],
      [
        -2,
        -13
      ],
      [
        0,
        -37
      ],
      [
        -2,
        -31
      ],
      [
        -3,
        -11
      ],
      [
        2,
        -23
      ],
      [
        2,
        -35
      ],
      [
        15,
        -33
      ],
      [
        3,
        -17
      ],
      [
        8,
        -13
      ],
      [
        6,
        0
      ],
      [
        10,
        20
      ],
      [
        10,
        -4
      ],
      [
        11,
        -58
      ],
      [
        0,
        -51
      ],
      [
        2,
        -304
      ],
      [
        35,
        0
      ],
      [
        0,
        -102
      ],
      [
        39,
        0
      ],
      [
        1,
        -103
      ],
      [
        6,
        0
      ],
      [
        0,
        -100
      ],
      [
        28,
        -1
      ],
      [
        0,
        -49
      ],
      [
        12,
        -2
      ],
      [
        68,
        -1
      ],
      [
        0,
        -84
      ],
      [
        83,
        0
      ]
    ],
    [
      [
        18852,
        68984
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -5
      ],
      [
        1,
        -15
      ],
      [
        2,
        -6
      ],
      [
        3,
        -3
      ],
      [
        -2,
        -16
      ],
      [
        -8,
        -35
      ],
      [
        -5,
        -26
      ],
      [
        -1,
        -10
      ],
      [
        0,
        -11
      ],
      [
        2,
        -15
      ],
      [
        7,
        -25
      ],
      [
        7,
        -11
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -5
      ],
      [
        -8,
        0
      ],
      [
        -5,
        4
      ],
      [
        -2,
        5
      ],
      [
        -6,
        10
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        1
      ],
      [
        -6,
        9
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        -9
      ],
      [
        -4,
        -6
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        18814,
        68798
      ],
      [
        -18,
        13
      ],
      [
        -6,
        0
      ],
      [
        -1,
        -12
      ],
      [
        -2,
        -7
      ],
      [
        -6,
        -1
      ],
      [
        -3,
        -3
      ],
      [
        -3,
        -8
      ],
      [
        -1,
        -4
      ],
      [
        -12,
        -16
      ],
      [
        -1,
        -5
      ],
      [
        -4,
        -3
      ],
      [
        -5,
        19
      ],
      [
        -2,
        16
      ],
      [
        -6,
        28
      ],
      [
        -5,
        0
      ],
      [
        -4,
        -7
      ],
      [
        -13,
        -1
      ],
      [
        -1,
        -8
      ],
      [
        -8,
        -15
      ],
      [
        -4,
        -2
      ],
      [
        -5,
        8
      ],
      [
        -5,
        5
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -9
      ],
      [
        -4,
        6
      ],
      [
        -5,
        2
      ],
      [
        -6,
        -8
      ],
      [
        -1,
        -8
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        0
      ],
      [
        -5,
        9
      ],
      [
        -1,
        9
      ],
      [
        -2,
        4
      ],
      [
        -8,
        2
      ],
      [
        -4,
        -10
      ],
      [
        -2,
        0
      ],
      [
        -10,
        13
      ],
      [
        -2,
        7
      ],
      [
        0,
        15
      ],
      [
        -4,
        6
      ],
      [
        -4,
        2
      ],
      [
        -8,
        -1
      ],
      [
        -6,
        -13
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -13
      ],
      [
        -1,
        -4
      ],
      [
        -9,
        0
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -49
      ],
      [
        -3,
        -22
      ],
      [
        -5,
        -23
      ],
      [
        -14,
        17
      ],
      [
        -7,
        16
      ],
      [
        -3,
        5
      ],
      [
        -8,
        -20
      ],
      [
        -3,
        4
      ],
      [
        0,
        4
      ],
      [
        -2,
        7
      ],
      [
        -6,
        9
      ],
      [
        -3,
        1
      ],
      [
        -6,
        -4
      ],
      [
        -3,
        0
      ],
      [
        -5,
        11
      ],
      [
        -16,
        -6
      ],
      [
        -1,
        1
      ],
      [
        -2,
        6
      ],
      [
        -11,
        13
      ],
      [
        -3,
        2
      ],
      [
        -4,
        -6
      ],
      [
        -4,
        -9
      ],
      [
        -9,
        -8
      ],
      [
        -5,
        -22
      ],
      [
        -8,
        -27
      ],
      [
        -2,
        -23
      ],
      [
        4,
        -18
      ],
      [
        2,
        -17
      ],
      [
        0,
        -18
      ]
    ],
    [
      [
        18481,
        68598
      ],
      [
        -2,
        -7
      ],
      [
        -7,
        -15
      ],
      [
        -3,
        2
      ],
      [
        -7,
        24
      ],
      [
        -1,
        18
      ],
      [
        -8,
        8
      ],
      [
        -10,
        16
      ],
      [
        -9,
        20
      ],
      [
        -6,
        20
      ],
      [
        -1,
        24
      ],
      [
        -3,
        12
      ],
      [
        -2,
        17
      ],
      [
        2,
        9
      ],
      [
        3,
        16
      ],
      [
        0,
        9
      ],
      [
        -10,
        19
      ],
      [
        -1,
        10
      ],
      [
        2,
        9
      ],
      [
        1,
        7
      ],
      [
        -7,
        15
      ],
      [
        -3,
        15
      ],
      [
        -3,
        6
      ],
      [
        0,
        8
      ],
      [
        3,
        14
      ],
      [
        2,
        4
      ],
      [
        2,
        1
      ],
      [
        1,
        3
      ],
      [
        1,
        10
      ],
      [
        0,
        8
      ],
      [
        -4,
        15
      ],
      [
        -1,
        8
      ],
      [
        -1,
        13
      ],
      [
        1,
        6
      ],
      [
        0,
        8
      ],
      [
        -4,
        14
      ],
      [
        -4,
        7
      ],
      [
        -1,
        13
      ],
      [
        0,
        24
      ],
      [
        -4,
        10
      ],
      [
        -5,
        17
      ],
      [
        -1,
        9
      ],
      [
        1,
        5
      ],
      [
        0,
        10
      ],
      [
        -2,
        4
      ],
      [
        -5,
        5
      ],
      [
        -2,
        -2
      ],
      [
        -4,
        9
      ],
      [
        -1,
        8
      ],
      [
        -3,
        10
      ],
      [
        -4,
        8
      ],
      [
        -8,
        6
      ],
      [
        -3,
        10
      ],
      [
        -8,
        -12
      ],
      [
        -6,
        -11
      ],
      [
        -1,
        -5
      ],
      [
        -11,
        -16
      ],
      [
        -4,
        8
      ],
      [
        0,
        4
      ],
      [
        2,
        4
      ],
      [
        1,
        2
      ],
      [
        -3,
        22
      ],
      [
        -6,
        18
      ],
      [
        -2,
        3
      ],
      [
        -11,
        6
      ],
      [
        -9,
        26
      ],
      [
        -5,
        53
      ],
      [
        -5,
        20
      ],
      [
        -2,
        17
      ],
      [
        1,
        7
      ],
      [
        4,
        2
      ],
      [
        2,
        -2
      ],
      [
        2,
        -1
      ],
      [
        5,
        7
      ],
      [
        1,
        7
      ],
      [
        0,
        45
      ],
      [
        2,
        10
      ],
      [
        -3,
        33
      ],
      [
        0,
        13
      ],
      [
        -1,
        15
      ],
      [
        -2,
        6
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -1
      ],
      [
        -3,
        2
      ],
      [
        -10,
        34
      ],
      [
        3,
        8
      ],
      [
        1,
        9
      ],
      [
        -2,
        9
      ],
      [
        -7,
        0
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        0
      ],
      [
        -6,
        18
      ],
      [
        -6,
        44
      ],
      [
        2,
        13
      ],
      [
        -3,
        16
      ],
      [
        -10,
        26
      ],
      [
        -3,
        18
      ],
      [
        -1,
        7
      ],
      [
        -2,
        8
      ],
      [
        -2,
        6
      ],
      [
        -3,
        3
      ],
      [
        -1,
        0
      ],
      [
        -2,
        5
      ],
      [
        -2,
        14
      ],
      [
        0,
        6
      ],
      [
        1,
        7
      ],
      [
        0,
        8
      ],
      [
        -13,
        49
      ],
      [
        -1,
        5
      ],
      [
        0,
        18
      ],
      [
        2,
        46
      ],
      [
        0,
        6
      ],
      [
        -1,
        3
      ],
      [
        -4,
        12
      ],
      [
        -3,
        4
      ],
      [
        -1,
        5
      ],
      [
        -1,
        9
      ],
      [
        1,
        11
      ],
      [
        0,
        4
      ],
      [
        -5,
        24
      ],
      [
        0,
        4
      ],
      [
        6,
        30
      ],
      [
        -1,
        46
      ],
      [
        -4,
        3
      ],
      [
        -7,
        0
      ],
      [
        -1,
        -4
      ],
      [
        -7,
        1
      ],
      [
        4,
        53
      ],
      [
        4,
        17
      ],
      [
        0,
        14
      ],
      [
        -1,
        11
      ],
      [
        -4,
        12
      ],
      [
        -11,
        13
      ],
      [
        -7,
        -8
      ],
      [
        -5,
        6
      ],
      [
        1,
        17
      ],
      [
        1,
        9
      ],
      [
        -1,
        5
      ],
      [
        -1,
        3
      ],
      [
        -4,
        9
      ],
      [
        -3,
        15
      ],
      [
        -1,
        12
      ],
      [
        -3,
        5
      ]
    ],
    [
      [
        19189,
        71314
      ],
      [
        17,
        -2
      ],
      [
        6,
        20
      ],
      [
        9,
        -11
      ],
      [
        8,
        3
      ],
      [
        4,
        23
      ],
      [
        8,
        9
      ],
      [
        10,
        3
      ],
      [
        6,
        -15
      ],
      [
        16,
        19
      ],
      [
        10,
        -17
      ],
      [
        11,
        -14
      ],
      [
        11,
        -21
      ],
      [
        3,
        3
      ],
      [
        7,
        -20
      ],
      [
        21,
        1
      ]
    ],
    [
      [
        19336,
        71295
      ],
      [
        0,
        -1
      ],
      [
        99,
        0
      ]
    ],
    [
      [
        19361,
        70742
      ],
      [
        -175,
        2
      ]
    ],
    [
      [
        19186,
        70744
      ],
      [
        0,
        313
      ],
      [
        3,
        0
      ],
      [
        0,
        257
      ]
    ],
    [
      [
        23832,
        60125
      ],
      [
        40,
        -2
      ],
      [
        21,
        -1
      ],
      [
        18,
        -1
      ],
      [
        7,
        -1
      ],
      [
        10,
        0
      ],
      [
        25,
        -4
      ],
      [
        30,
        -2
      ]
    ],
    [
      [
        24028,
        60093
      ],
      [
        -2,
        -305
      ]
    ],
    [
      [
        24026,
        59788
      ],
      [
        -66,
        6
      ],
      [
        -22,
        2
      ],
      [
        -22,
        1
      ]
    ],
    [
      [
        23916,
        59797
      ],
      [
        -10,
        1
      ],
      [
        1,
        204
      ],
      [
        -35,
        1
      ],
      [
        -41,
        3
      ]
    ],
    [
      [
        23831,
        60006
      ],
      [
        1,
        119
      ]
    ],
    [
      [
        23987,
        62255
      ],
      [
        1,
        51
      ],
      [
        31,
        108
      ]
    ],
    [
      [
        24019,
        62414
      ],
      [
        6,
        -51
      ],
      [
        11,
        -23
      ],
      [
        6,
        -22
      ],
      [
        17,
        -12
      ],
      [
        21,
        14
      ],
      [
        7,
        -9
      ],
      [
        7,
        0
      ],
      [
        20,
        -10
      ],
      [
        10,
        3
      ]
    ],
    [
      [
        24124,
        62304
      ],
      [
        14,
        -44
      ],
      [
        3,
        -12
      ]
    ],
    [
      [
        24141,
        62248
      ],
      [
        -4,
        -31
      ],
      [
        -29,
        -234
      ],
      [
        0,
        -17
      ],
      [
        -31,
        5
      ],
      [
        -30,
        1
      ],
      [
        -1,
        -1
      ]
    ],
    [
      [
        24046,
        61971
      ],
      [
        -31,
        2
      ],
      [
        -31,
        8
      ]
    ],
    [
      [
        23984,
        61981
      ],
      [
        3,
        274
      ]
    ],
    [
      [
        22627,
        63100
      ],
      [
        157,
        0
      ]
    ],
    [
      [
        22784,
        63100
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        22784,
        62999
      ],
      [
        0,
        -304
      ]
    ],
    [
      [
        22784,
        62695
      ],
      [
        -156,
        0
      ]
    ],
    [
      [
        22628,
        62695
      ],
      [
        0,
        303
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        22627,
        62998
      ],
      [
        0,
        102
      ]
    ],
    [
      [
        28476,
        61264
      ],
      [
        17,
        55
      ],
      [
        4,
        -25
      ],
      [
        11,
        -44
      ],
      [
        7,
        -7
      ],
      [
        11,
        -31
      ],
      [
        0,
        -25
      ],
      [
        -2,
        -11
      ],
      [
        5,
        -7
      ],
      [
        5,
        5
      ],
      [
        8,
        -17
      ],
      [
        13,
        -3
      ],
      [
        2,
        -16
      ],
      [
        4,
        -2
      ]
    ],
    [
      [
        28561,
        61136
      ],
      [
        8,
        -21
      ],
      [
        14,
        -20
      ],
      [
        4,
        -58
      ],
      [
        -2,
        -15
      ],
      [
        10,
        -23
      ],
      [
        1,
        -12
      ]
    ],
    [
      [
        28596,
        60987
      ],
      [
        -16,
        -2
      ],
      [
        -6,
        -30
      ],
      [
        -12,
        -7
      ],
      [
        -3,
        -15
      ]
    ],
    [
      [
        28559,
        60933
      ],
      [
        -3,
        4
      ],
      [
        -2,
        13
      ],
      [
        -6,
        22
      ],
      [
        -4,
        -4
      ],
      [
        -2,
        0
      ],
      [
        -6,
        16
      ],
      [
        -1,
        7
      ],
      [
        -2,
        11
      ],
      [
        -1,
        16
      ],
      [
        -3,
        12
      ],
      [
        -5,
        4
      ],
      [
        -1,
        23
      ],
      [
        -8,
        30
      ],
      [
        -6,
        10
      ],
      [
        -5,
        1
      ],
      [
        -2,
        17
      ],
      [
        -2,
        28
      ],
      [
        -4,
        12
      ],
      [
        -9,
        18
      ],
      [
        -2,
        0
      ]
    ],
    [
      [
        28485,
        61173
      ],
      [
        -6,
        87
      ],
      [
        -3,
        4
      ]
    ],
    [
      [
        25020,
        58708
      ],
      [
        18,
        6
      ],
      [
        3,
        32
      ],
      [
        5,
        4
      ],
      [
        12,
        53
      ],
      [
        5,
        43
      ]
    ],
    [
      [
        25096,
        58489
      ],
      [
        -3,
        5
      ],
      [
        -10,
        2
      ],
      [
        -7,
        24
      ],
      [
        -8,
        19
      ],
      [
        -9,
        13
      ],
      [
        -19,
        9
      ],
      [
        -4,
        20
      ],
      [
        -7,
        1
      ],
      [
        -7,
        22
      ],
      [
        -4,
        24
      ],
      [
        -2,
        6
      ]
    ],
    [
      [
        25016,
        58634
      ],
      [
        0,
        24
      ],
      [
        5,
        28
      ],
      [
        -1,
        22
      ]
    ],
    [
      [
        25758,
        63413
      ],
      [
        68,
        0
      ],
      [
        26,
        1
      ],
      [
        9,
        0
      ]
    ],
    [
      [
        25861,
        63414
      ],
      [
        0,
        -67
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -163
      ],
      [
        1,
        -102
      ]
    ],
    [
      [
        25861,
        63074
      ],
      [
        -3,
        0
      ],
      [
        -23,
        -2
      ],
      [
        -13,
        0
      ],
      [
        0,
        -34
      ],
      [
        -27,
        0
      ],
      [
        -27,
        1
      ]
    ],
    [
      [
        25768,
        63039
      ],
      [
        5,
        33
      ],
      [
        -13,
        0
      ],
      [
        0,
        273
      ],
      [
        -2,
        0
      ]
    ],
    [
      [
        25758,
        63345
      ],
      [
        0,
        68
      ]
    ],
    [
      [
        21982,
        61987
      ],
      [
        26,
        -1
      ]
    ],
    [
      [
        22008,
        61986
      ],
      [
        155,
        -1
      ]
    ],
    [
      [
        22163,
        61985
      ],
      [
        4,
        0
      ]
    ],
    [
      [
        22167,
        61985
      ],
      [
        0,
        -404
      ]
    ],
    [
      [
        22167,
        61581
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        22167,
        61480
      ],
      [
        -179,
        0
      ]
    ],
    [
      [
        21988,
        61480
      ],
      [
        -5,
        0
      ]
    ],
    [
      [
        25227,
        65504
      ],
      [
        31,
        2
      ],
      [
        24,
        1
      ],
      [
        8,
        1
      ],
      [
        1,
        0
      ],
      [
        14,
        1
      ],
      [
        16,
        1
      ]
    ],
    [
      [
        25321,
        65510
      ],
      [
        1,
        -33
      ],
      [
        0,
        -70
      ],
      [
        1,
        -49
      ],
      [
        0,
        -85
      ],
      [
        1,
        -67
      ]
    ],
    [
      [
        25324,
        65206
      ],
      [
        -96,
        -7
      ]
    ],
    [
      [
        25228,
        65199
      ],
      [
        -2,
        203
      ]
    ],
    [
      [
        25692,
        64942
      ],
      [
        3,
        10
      ],
      [
        14,
        23
      ],
      [
        15,
        10
      ],
      [
        9,
        14
      ],
      [
        6,
        26
      ],
      [
        6,
        16
      ],
      [
        5,
        45
      ],
      [
        4,
        24
      ],
      [
        2,
        25
      ],
      [
        9,
        13
      ],
      [
        7,
        22
      ],
      [
        33,
        1
      ]
    ],
    [
      [
        25805,
        65171
      ],
      [
        16,
        0
      ]
    ],
    [
      [
        25821,
        65171
      ],
      [
        1,
        -68
      ],
      [
        -1,
        -84
      ],
      [
        0,
        -153
      ]
    ],
    [
      [
        25821,
        64866
      ],
      [
        -96,
        1
      ],
      [
        -33,
        0
      ]
    ],
    [
      [
        25692,
        64867
      ],
      [
        0,
        75
      ]
    ],
    [
      [
        25965,
        63082
      ],
      [
        0,
        68
      ]
    ],
    [
      [
        25965,
        63150
      ],
      [
        16,
        2
      ],
      [
        73,
        0
      ]
    ],
    [
      [
        26054,
        63152
      ],
      [
        0,
        -102
      ],
      [
        1,
        -184
      ]
    ],
    [
      [
        26055,
        62866
      ],
      [
        -1,
        -120
      ],
      [
        -15,
        0
      ]
    ],
    [
      [
        26039,
        62746
      ],
      [
        -32,
        0
      ],
      [
        -16,
        -1
      ],
      [
        -26,
        -2
      ]
    ],
    [
      [
        24041,
        61053
      ],
      [
        66,
        -4
      ],
      [
        2,
        -33
      ],
      [
        4,
        -14
      ],
      [
        0,
        -13
      ],
      [
        8,
        -21
      ],
      [
        2,
        -20
      ],
      [
        4,
        -6
      ],
      [
        5,
        13
      ],
      [
        5,
        1
      ],
      [
        3,
        18
      ],
      [
        6,
        1
      ],
      [
        8,
        -5
      ],
      [
        1,
        13
      ],
      [
        8,
        28
      ],
      [
        3,
        0
      ]
    ],
    [
      [
        24166,
        61011
      ],
      [
        0,
        -15
      ],
      [
        -1,
        -154
      ],
      [
        30,
        -51
      ],
      [
        15,
        -26
      ],
      [
        0,
        -51
      ]
    ],
    [
      [
        24210,
        60714
      ],
      [
        0,
        -153
      ]
    ],
    [
      [
        24210,
        60561
      ],
      [
        -86,
        7
      ],
      [
        -36,
        3
      ]
    ],
    [
      [
        24042,
        60574
      ],
      [
        2,
        276
      ],
      [
        -4,
        0
      ],
      [
        1,
        119
      ],
      [
        0,
        84
      ]
    ],
    [
      [
        23789,
        63456
      ],
      [
        111,
        9
      ]
    ],
    [
      [
        23900,
        63465
      ],
      [
        0,
        -307
      ],
      [
        27,
        0
      ]
    ],
    [
      [
        23927,
        63158
      ],
      [
        -6,
        -26
      ],
      [
        1,
        -35
      ],
      [
        6,
        -33
      ],
      [
        -4,
        -9
      ]
    ],
    [
      [
        23924,
        63055
      ],
      [
        -134,
        -5
      ]
    ],
    [
      [
        23790,
        63050
      ],
      [
        0,
        202
      ]
    ],
    [
      [
        23790,
        63252
      ],
      [
        -1,
        204
      ]
    ],
    [
      [
        26270,
        69459
      ],
      [
        34,
        -2
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        26304,
        69558
      ],
      [
        103,
        -4
      ]
    ],
    [
      [
        26273,
        69158
      ],
      [
        -3,
        200
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        21682,
        63506
      ],
      [
        0,
        405
      ]
    ],
    [
      [
        21682,
        63911
      ],
      [
        152,
        -2
      ]
    ],
    [
      [
        21834,
        63909
      ],
      [
        6,
        0
      ]
    ],
    [
      [
        21840,
        63909
      ],
      [
        -1,
        -203
      ],
      [
        1,
        -21
      ],
      [
        0,
        -180
      ]
    ],
    [
      [
        21840,
        63505
      ],
      [
        -104,
        0
      ],
      [
        -11,
        1
      ],
      [
        -43,
        0
      ]
    ],
    [
      [
        26271,
        68347
      ],
      [
        -1,
        320
      ],
      [
        2,
        87
      ]
    ],
    [
      [
        23551,
        60771
      ],
      [
        151,
        -16
      ]
    ],
    [
      [
        23702,
        60755
      ],
      [
        0,
        -68
      ]
    ],
    [
      [
        23702,
        60687
      ],
      [
        -2,
        -270
      ]
    ],
    [
      [
        23700,
        60417
      ],
      [
        -149,
        17
      ]
    ],
    [
      [
        23551,
        60434
      ],
      [
        0,
        337
      ]
    ],
    [
      [
        21788,
        57389
      ],
      [
        -1,
        -507
      ]
    ],
    [
      [
        21787,
        56882
      ],
      [
        -26,
        0
      ]
    ],
    [
      [
        21761,
        56882
      ],
      [
        -120,
        0
      ]
    ],
    [
      [
        21641,
        56882
      ],
      [
        0,
        506
      ]
    ],
    [
      [
        26472,
        66325
      ],
      [
        30,
        -1
      ],
      [
        22,
        0
      ],
      [
        78,
        9
      ]
    ],
    [
      [
        26602,
        66333
      ],
      [
        31,
        4
      ]
    ],
    [
      [
        26633,
        66337
      ],
      [
        2,
        -100
      ],
      [
        1,
        -101
      ],
      [
        0,
        -102
      ],
      [
        1,
        -104
      ]
    ],
    [
      [
        26637,
        65930
      ],
      [
        -30,
        -2
      ],
      [
        -3,
        1
      ],
      [
        -32,
        -2
      ]
    ],
    [
      [
        26572,
        65927
      ],
      [
        -66,
        -5
      ],
      [
        -34,
        -8
      ]
    ],
    [
      [
        26472,
        65914
      ],
      [
        0,
        411
      ]
    ],
    [
      [
        26078,
        66725
      ],
      [
        66,
        2
      ]
    ],
    [
      [
        26209,
        66728
      ],
      [
        1,
        -407
      ]
    ],
    [
      [
        26210,
        66321
      ],
      [
        -63,
        -2
      ]
    ],
    [
      [
        26079,
        66321
      ],
      [
        0,
        202
      ],
      [
        -1,
        202
      ]
    ],
    [
      [
        19931,
        54895
      ],
      [
        86,
        0
      ]
    ],
    [
      [
        20017,
        54895
      ],
      [
        0,
        -11
      ],
      [
        1,
        -438
      ],
      [
        -1,
        -160
      ],
      [
        1,
        -46
      ],
      [
        0,
        -302
      ]
    ],
    [
      [
        20018,
        53938
      ],
      [
        -254,
        0
      ]
    ],
    [
      [
        19764,
        53938
      ],
      [
        0,
        43
      ],
      [
        -2,
        0
      ],
      [
        0,
        51
      ]
    ],
    [
      [
        19762,
        54032
      ],
      [
        0,
        251
      ],
      [
        -4,
        0
      ],
      [
        0,
        509
      ],
      [
        85,
        0
      ],
      [
        0,
        102
      ],
      [
        88,
        1
      ]
    ],
    [
      [
        26851,
        59778
      ],
      [
        6,
        38
      ],
      [
        14,
        -19
      ],
      [
        5,
        17
      ],
      [
        7,
        16
      ],
      [
        3,
        26
      ],
      [
        3,
        13
      ],
      [
        5,
        3
      ],
      [
        23,
        2
      ],
      [
        37,
        2
      ],
      [
        -1,
        -9
      ]
    ],
    [
      [
        26953,
        59867
      ],
      [
        14,
        -113
      ],
      [
        6,
        -82
      ]
    ],
    [
      [
        26973,
        59672
      ],
      [
        7,
        -104
      ],
      [
        4,
        -28
      ]
    ],
    [
      [
        26984,
        59540
      ],
      [
        -1,
        0
      ],
      [
        -47,
        -2
      ],
      [
        -3,
        2
      ],
      [
        -3,
        0
      ],
      [
        -19,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -14,
        -1
      ]
    ],
    [
      [
        26896,
        59538
      ],
      [
        -20,
        -1
      ],
      [
        -4,
        0
      ],
      [
        -38,
        1
      ]
    ],
    [
      [
        26834,
        59538
      ],
      [
        -16,
        -1
      ],
      [
        -27,
        1
      ]
    ],
    [
      [
        26791,
        59538
      ],
      [
        11,
        95
      ],
      [
        19,
        40
      ],
      [
        7,
        8
      ],
      [
        8,
        19
      ],
      [
        -1,
        16
      ],
      [
        6,
        30
      ],
      [
        4,
        9
      ],
      [
        6,
        23
      ]
    ],
    [
      [
        29917,
        68632
      ],
      [
        1,
        1
      ],
      [
        2,
        -1
      ],
      [
        0,
        -1
      ],
      [
        2,
        -4
      ],
      [
        1,
        -1
      ],
      [
        1,
        1
      ],
      [
        0,
        5
      ],
      [
        1,
        3
      ],
      [
        0,
        1
      ],
      [
        2,
        1
      ],
      [
        1,
        1
      ],
      [
        3,
        -1
      ],
      [
        2,
        1
      ],
      [
        3,
        5
      ],
      [
        2,
        6
      ],
      [
        1,
        3
      ],
      [
        2,
        5
      ],
      [
        0,
        8
      ],
      [
        1,
        1
      ],
      [
        2,
        1
      ],
      [
        1,
        2
      ],
      [
        1,
        2
      ],
      [
        1,
        6
      ],
      [
        0,
        10
      ],
      [
        2,
        8
      ],
      [
        0,
        1
      ],
      [
        2,
        -1
      ],
      [
        0,
        1
      ],
      [
        1,
        3
      ],
      [
        0,
        2
      ],
      [
        -2,
        4
      ],
      [
        0,
        5
      ],
      [
        1,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        2,
        7
      ],
      [
        1,
        1
      ],
      [
        3,
        1
      ],
      [
        1,
        1
      ],
      [
        2,
        -2
      ],
      [
        3,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        7
      ],
      [
        0,
        3
      ],
      [
        1,
        4
      ],
      [
        1,
        0
      ],
      [
        0,
        1
      ],
      [
        2,
        1
      ],
      [
        1,
        1
      ],
      [
        0,
        3
      ],
      [
        -2,
        4
      ],
      [
        0,
        2
      ],
      [
        -1,
        4
      ],
      [
        0,
        1
      ],
      [
        -1,
        4
      ],
      [
        -1,
        2
      ],
      [
        0,
        4
      ],
      [
        2,
        -1
      ],
      [
        1,
        2
      ],
      [
        2,
        7
      ],
      [
        0,
        4
      ],
      [
        1,
        3
      ],
      [
        0,
        2
      ],
      [
        -1,
        3
      ],
      [
        -3,
        9
      ],
      [
        -3,
        6
      ],
      [
        0,
        9
      ],
      [
        1,
        3
      ],
      [
        1,
        2
      ],
      [
        4,
        -1
      ],
      [
        2,
        -2
      ],
      [
        2,
        1
      ],
      [
        1,
        1
      ],
      [
        0,
        7
      ],
      [
        1,
        9
      ],
      [
        0,
        3
      ],
      [
        1,
        0
      ],
      [
        1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        4
      ],
      [
        1,
        3
      ],
      [
        0,
        4
      ],
      [
        -1,
        2
      ],
      [
        -2,
        3
      ],
      [
        -2,
        1
      ],
      [
        0,
        18
      ],
      [
        -1,
        9
      ],
      [
        1,
        8
      ],
      [
        0,
        3
      ],
      [
        1,
        1
      ],
      [
        -1,
        6
      ],
      [
        -2,
        5
      ],
      [
        0,
        3
      ],
      [
        1,
        1
      ],
      [
        0,
        5
      ],
      [
        -1,
        7
      ],
      [
        -1,
        3
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -4
      ],
      [
        -2,
        0
      ],
      [
        0,
        6
      ],
      [
        -2,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        4
      ],
      [
        1,
        2
      ],
      [
        -1,
        3
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        0,
        5
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        4
      ],
      [
        0,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        3
      ],
      [
        -1,
        4
      ],
      [
        0,
        12
      ],
      [
        -1,
        1
      ],
      [
        0,
        3
      ],
      [
        1,
        3
      ],
      [
        -1,
        2
      ],
      [
        -1,
        3
      ],
      [
        -2,
        13
      ],
      [
        -2,
        4
      ],
      [
        0,
        2
      ],
      [
        1,
        4
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        2
      ],
      [
        0,
        21
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        0,
        3
      ],
      [
        1,
        1
      ],
      [
        2,
        2
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        0,
        2
      ],
      [
        1,
        5
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        1,
        5
      ],
      [
        1,
        4
      ],
      [
        1,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        4
      ],
      [
        3,
        4
      ],
      [
        1,
        -1
      ],
      [
        0,
        1
      ],
      [
        2,
        7
      ],
      [
        0,
        7
      ],
      [
        1,
        8
      ],
      [
        0,
        4
      ],
      [
        -1,
        2
      ],
      [
        -1,
        4
      ],
      [
        0,
        3
      ],
      [
        1,
        2
      ],
      [
        1,
        7
      ],
      [
        1,
        1
      ],
      [
        0,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        11
      ],
      [
        1,
        2
      ],
      [
        1,
        2
      ],
      [
        0,
        5
      ],
      [
        -1,
        4
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        2
      ],
      [
        0,
        2
      ],
      [
        2,
        4
      ],
      [
        0,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        4
      ],
      [
        1,
        4
      ],
      [
        2,
        3
      ],
      [
        2,
        1
      ],
      [
        1,
        5
      ],
      [
        0,
        5
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        3,
        11
      ],
      [
        0,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        1
      ],
      [
        2,
        4
      ],
      [
        2,
        6
      ],
      [
        0,
        2
      ],
      [
        1,
        -1
      ],
      [
        0,
        1
      ],
      [
        1,
        7
      ],
      [
        0,
        1
      ],
      [
        -2,
        3
      ],
      [
        -1,
        6
      ],
      [
        -1,
        5
      ],
      [
        -2,
        4
      ],
      [
        0,
        44
      ],
      [
        -2,
        2
      ],
      [
        -1,
        8
      ],
      [
        -2,
        3
      ],
      [
        -1,
        10
      ],
      [
        -1,
        4
      ],
      [
        1,
        7
      ],
      [
        2,
        7
      ],
      [
        1,
        2
      ],
      [
        2,
        1
      ],
      [
        1,
        2
      ],
      [
        5,
        -1
      ],
      [
        3,
        -3
      ],
      [
        2,
        2
      ],
      [
        4,
        11
      ],
      [
        0,
        2
      ],
      [
        -10,
        0
      ]
    ],
    [
      [
        29991,
        69339
      ],
      [
        0,
        15
      ],
      [
        2,
        9
      ],
      [
        1,
        9
      ],
      [
        0,
        2
      ],
      [
        -1,
        2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        5
      ],
      [
        0,
        4
      ],
      [
        1,
        -1
      ],
      [
        1,
        4
      ],
      [
        0,
        18
      ],
      [
        2,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        5
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        3
      ],
      [
        1,
        7
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        4
      ],
      [
        1,
        3
      ],
      [
        0,
        1
      ],
      [
        1,
        3
      ],
      [
        1,
        4
      ],
      [
        0,
        6
      ],
      [
        2,
        1
      ],
      [
        2,
        7
      ],
      [
        1,
        4
      ],
      [
        1,
        4
      ],
      [
        0,
        3
      ],
      [
        -2,
        9
      ],
      [
        -1,
        3
      ],
      [
        0,
        3
      ],
      [
        1,
        8
      ],
      [
        1,
        2
      ],
      [
        0,
        1
      ],
      [
        1,
        1
      ],
      [
        0,
        7
      ],
      [
        1,
        2
      ],
      [
        -1,
        6
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        1,
        8
      ],
      [
        0,
        11
      ],
      [
        2,
        2
      ],
      [
        1,
        9
      ],
      [
        0,
        3
      ],
      [
        2,
        6
      ],
      [
        0,
        3
      ],
      [
        -1,
        3
      ],
      [
        -1,
        8
      ],
      [
        -1,
        1
      ],
      [
        -2,
        2
      ],
      [
        0,
        1
      ],
      [
        -1,
        3
      ],
      [
        -1,
        3
      ],
      [
        -3,
        5
      ],
      [
        -2,
        5
      ],
      [
        0,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        5
      ],
      [
        1,
        0
      ],
      [
        2,
        -1
      ],
      [
        4,
        -3
      ],
      [
        2,
        4
      ],
      [
        1,
        3
      ],
      [
        1,
        1
      ],
      [
        3,
        -1
      ],
      [
        0,
        -5
      ],
      [
        1,
        -2
      ],
      [
        1,
        -3
      ],
      [
        0,
        1
      ],
      [
        1,
        1
      ],
      [
        1,
        5
      ],
      [
        0,
        6
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        1,
        0
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        1,
        3
      ],
      [
        0,
        4
      ],
      [
        -1,
        7
      ],
      [
        0,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        1
      ],
      [
        1,
        3
      ],
      [
        2,
        -1
      ],
      [
        1,
        0
      ],
      [
        1,
        4
      ],
      [
        1,
        -1
      ],
      [
        2,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        2
      ],
      [
        0,
        4
      ],
      [
        1,
        1
      ],
      [
        2,
        2
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        1,
        0
      ],
      [
        1,
        2
      ],
      [
        1,
        4
      ],
      [
        1,
        5
      ],
      [
        1,
        3
      ],
      [
        3,
        4
      ],
      [
        0,
        -1
      ],
      [
        1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        1,
        -1
      ],
      [
        2,
        2
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -10
      ],
      [
        0,
        -8
      ],
      [
        1,
        -3
      ],
      [
        1,
        0
      ],
      [
        2,
        -5
      ],
      [
        1,
        0
      ],
      [
        0,
        -1
      ],
      [
        2,
        -7
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        1,
        -8
      ],
      [
        0,
        -4
      ],
      [
        1,
        0
      ],
      [
        1,
        2
      ],
      [
        1,
        2
      ],
      [
        0,
        -3
      ],
      [
        3,
        -1
      ],
      [
        2,
        5
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        1,
        -1
      ],
      [
        1,
        -3
      ],
      [
        1,
        -3
      ],
      [
        1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        1,
        1
      ],
      [
        0,
        3
      ],
      [
        1,
        3
      ],
      [
        1,
        -1
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        1,
        -1
      ],
      [
        1,
        -3
      ],
      [
        2,
        -5
      ],
      [
        1,
        0
      ],
      [
        2,
        1
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        1,
        9
      ],
      [
        1,
        2
      ],
      [
        1,
        8
      ],
      [
        0,
        4
      ],
      [
        1,
        8
      ],
      [
        1,
        3
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        0,
        5
      ],
      [
        -1,
        -1
      ],
      [
        0,
        8
      ],
      [
        1,
        7
      ],
      [
        2,
        8
      ],
      [
        3,
        4
      ],
      [
        1,
        1
      ]
    ],
    [
      [
        30107,
        69679
      ],
      [
        2,
        -69
      ],
      [
        1,
        -76
      ],
      [
        1,
        -43
      ],
      [
        3,
        -162
      ],
      [
        0,
        -6
      ],
      [
        2,
        -81
      ],
      [
        2,
        -99
      ],
      [
        2,
        -105
      ],
      [
        0,
        -22
      ],
      [
        2,
        -94
      ],
      [
        0,
        -52
      ],
      [
        1,
        -61
      ],
      [
        1,
        -68
      ],
      [
        1,
        -31
      ],
      [
        1,
        -111
      ],
      [
        1,
        -43
      ],
      [
        0,
        -46
      ],
      [
        1,
        -19
      ]
    ],
    [
      [
        30128,
        68491
      ],
      [
        -10,
        -2
      ],
      [
        1,
        -54
      ],
      [
        -16,
        -2
      ],
      [
        -43,
        10
      ],
      [
        -14,
        -124
      ],
      [
        -2,
        -53
      ],
      [
        -7,
        -7
      ],
      [
        -2,
        7
      ],
      [
        0,
        37
      ],
      [
        -4,
        49
      ],
      [
        -8,
        15
      ],
      [
        -2,
        42
      ],
      [
        -6,
        -3
      ]
    ],
    [
      [
        30015,
        68406
      ],
      [
        -8,
        43
      ],
      [
        -7,
        12
      ],
      [
        -10,
        -5
      ],
      [
        -1,
        9
      ],
      [
        -19,
        -10
      ],
      [
        -3,
        59
      ],
      [
        -28,
        37
      ],
      [
        -3,
        -6
      ],
      [
        -19,
        87
      ]
    ],
    [
      [
        22183,
        73978
      ],
      [
        42,
        0
      ],
      [
        105,
        1
      ]
    ],
    [
      [
        22330,
        73979
      ],
      [
        0,
        -328
      ],
      [
        8,
        0
      ],
      [
        0,
        -202
      ]
    ],
    [
      [
        22338,
        73449
      ],
      [
        0,
        -203
      ],
      [
        -64,
        1
      ]
    ],
    [
      [
        22274,
        73247
      ],
      [
        -82,
        0
      ]
    ],
    [
      [
        22192,
        73247
      ],
      [
        0,
        202
      ]
    ],
    [
      [
        22192,
        73449
      ],
      [
        0,
        202
      ],
      [
        -9,
        0
      ],
      [
        0,
        327
      ]
    ],
    [
      [
        23550,
        60009
      ],
      [
        0,
        68
      ]
    ],
    [
      [
        23550,
        60077
      ],
      [
        12,
        -1
      ],
      [
        3,
        -1
      ],
      [
        33,
        -1
      ],
      [
        12,
        0
      ],
      [
        30,
        -2
      ],
      [
        66,
        -6
      ]
    ],
    [
      [
        23706,
        60066
      ],
      [
        0,
        -67
      ],
      [
        -1,
        -51
      ],
      [
        0,
        -17
      ]
    ],
    [
      [
        23705,
        59931
      ],
      [
        -2,
        -214
      ]
    ],
    [
      [
        23550,
        59739
      ],
      [
        0,
        270
      ]
    ],
    [
      [
        12766,
        83305
      ],
      [
        5,
        4
      ],
      [
        57,
        -11
      ],
      [
        30,
        -74
      ],
      [
        4,
        -17
      ],
      [
        10,
        -65
      ],
      [
        3,
        -37
      ],
      [
        0,
        -19
      ],
      [
        9,
        -23
      ],
      [
        8,
        -6
      ],
      [
        6,
        -1
      ],
      [
        9,
        -4
      ],
      [
        16,
        -48
      ],
      [
        6,
        -33
      ],
      [
        -1,
        -13
      ],
      [
        22,
        -39
      ],
      [
        11,
        -13
      ],
      [
        1,
        0
      ],
      [
        1,
        -9
      ],
      [
        -2,
        -9
      ],
      [
        0,
        -13
      ],
      [
        3,
        -3
      ],
      [
        3,
        -18
      ],
      [
        3,
        -12
      ],
      [
        5,
        -1
      ],
      [
        4,
        -6
      ],
      [
        2,
        1
      ],
      [
        2,
        -2
      ],
      [
        2,
        -16
      ],
      [
        0,
        -10
      ],
      [
        -20,
        -33
      ],
      [
        -4,
        -4
      ],
      [
        -1,
        1
      ],
      [
        -6,
        -2
      ],
      [
        -14,
        -26
      ],
      [
        -6,
        -16
      ],
      [
        -20,
        -22
      ],
      [
        -6,
        -2
      ],
      [
        -16,
        16
      ],
      [
        -31,
        4
      ],
      [
        0,
        -2
      ],
      [
        -16,
        9
      ],
      [
        -13,
        7
      ],
      [
        -7,
        6
      ],
      [
        -7,
        4
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -10
      ],
      [
        1,
        -5
      ],
      [
        4,
        -5
      ],
      [
        1,
        -23
      ],
      [
        -7,
        -28
      ],
      [
        -4,
        -9
      ],
      [
        -12,
        -14
      ],
      [
        -40,
        25
      ],
      [
        -2,
        3
      ],
      [
        -2,
        16
      ],
      [
        -3,
        9
      ],
      [
        -1,
        3
      ],
      [
        -7,
        0
      ],
      [
        -3,
        -2
      ]
    ],
    [
      [
        12742,
        82703
      ],
      [
        -2,
        2
      ],
      [
        -1,
        5
      ],
      [
        2,
        6
      ],
      [
        3,
        5
      ],
      [
        0,
        12
      ],
      [
        -3,
        7
      ],
      [
        -3,
        10
      ],
      [
        -2,
        2
      ],
      [
        -1,
        6
      ],
      [
        -1,
        8
      ],
      [
        0,
        18
      ],
      [
        -2,
        10
      ],
      [
        0,
        8
      ],
      [
        2,
        8
      ],
      [
        2,
        1
      ],
      [
        3,
        4
      ],
      [
        -1,
        7
      ],
      [
        0,
        21
      ],
      [
        -1,
        13
      ],
      [
        -2,
        11
      ],
      [
        -3,
        3
      ],
      [
        -3,
        2
      ],
      [
        -4,
        6
      ],
      [
        -3,
        10
      ],
      [
        -1,
        9
      ],
      [
        1,
        10
      ],
      [
        -2,
        10
      ],
      [
        -4,
        5
      ],
      [
        -1,
        6
      ],
      [
        1,
        9
      ],
      [
        4,
        2
      ],
      [
        4,
        1
      ],
      [
        5,
        -1
      ],
      [
        2,
        5
      ],
      [
        0,
        6
      ],
      [
        -2,
        1
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        5
      ],
      [
        -1,
        3
      ],
      [
        -2,
        -1
      ],
      [
        -5,
        1
      ],
      [
        -4,
        10
      ],
      [
        -3,
        5
      ],
      [
        -4,
        7
      ],
      [
        -3,
        9
      ],
      [
        -3,
        7
      ],
      [
        -1,
        6
      ],
      [
        -1,
        5
      ],
      [
        -2,
        1
      ],
      [
        1,
        7
      ],
      [
        2,
        1
      ],
      [
        1,
        3
      ],
      [
        3,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        2,
        -10
      ],
      [
        2,
        -3
      ],
      [
        4,
        -3
      ],
      [
        5,
        5
      ],
      [
        2,
        -3
      ],
      [
        2,
        -1
      ],
      [
        1,
        5
      ],
      [
        0,
        8
      ],
      [
        -1,
        4
      ],
      [
        -1,
        6
      ],
      [
        1,
        8
      ],
      [
        2,
        7
      ],
      [
        -1,
        5
      ],
      [
        -1,
        1
      ],
      [
        0,
        8
      ],
      [
        -1,
        5
      ],
      [
        -2,
        -1
      ],
      [
        -3,
        1
      ],
      [
        0,
        5
      ],
      [
        1,
        11
      ],
      [
        4,
        6
      ],
      [
        1,
        10
      ],
      [
        2,
        9
      ],
      [
        1,
        9
      ],
      [
        1,
        8
      ],
      [
        -3,
        3
      ],
      [
        0,
        21
      ],
      [
        -3,
        12
      ],
      [
        7,
        7
      ],
      [
        6,
        -2
      ],
      [
        5,
        3
      ],
      [
        4,
        5
      ],
      [
        4,
        7
      ],
      [
        3,
        -2
      ],
      [
        4,
        2
      ],
      [
        2,
        -1
      ],
      [
        2,
        4
      ],
      [
        0,
        5
      ],
      [
        2,
        6
      ],
      [
        19,
        13
      ],
      [
        7,
        7
      ],
      [
        -1,
        2
      ],
      [
        0,
        3
      ],
      [
        1,
        3
      ],
      [
        1,
        0
      ],
      [
        1,
        2
      ],
      [
        2,
        -1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        2
      ],
      [
        1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        -2,
        6
      ],
      [
        0,
        6
      ],
      [
        -1,
        3
      ],
      [
        0,
        3
      ],
      [
        -1,
        2
      ],
      [
        -1,
        3
      ],
      [
        -1,
        5
      ],
      [
        0,
        6
      ],
      [
        -1,
        3
      ],
      [
        0,
        3
      ],
      [
        -1,
        3
      ],
      [
        0,
        1
      ],
      [
        -1,
        4
      ],
      [
        -1,
        3
      ],
      [
        0,
        3
      ],
      [
        -1,
        3
      ],
      [
        -1,
        4
      ],
      [
        -1,
        3
      ],
      [
        0,
        4
      ],
      [
        -1,
        5
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        8
      ]
    ],
    [
      [
        12955,
        84001
      ],
      [
        25,
        -123
      ],
      [
        53,
        -180
      ],
      [
        20,
        -93
      ],
      [
        12,
        -62
      ],
      [
        -16,
        -67
      ],
      [
        -17,
        -73
      ],
      [
        43,
        -25
      ],
      [
        46,
        -27
      ],
      [
        -5,
        -52
      ],
      [
        -14,
        -134
      ]
    ],
    [
      [
        12982,
        82959
      ],
      [
        -4,
        28
      ],
      [
        2,
        22
      ],
      [
        -22,
        28
      ],
      [
        -37,
        66
      ],
      [
        -6,
        21
      ],
      [
        -2,
        10
      ],
      [
        1,
        2
      ],
      [
        1,
        6
      ],
      [
        -2,
        7
      ],
      [
        -5,
        23
      ],
      [
        -4,
        7
      ],
      [
        -4,
        9
      ],
      [
        -7,
        17
      ],
      [
        -12,
        48
      ],
      [
        -1,
        31
      ],
      [
        7,
        0
      ],
      [
        11,
        14
      ],
      [
        11,
        29
      ],
      [
        -5,
        47
      ],
      [
        -6,
        11
      ],
      [
        -5,
        -2
      ],
      [
        -1,
        -10
      ],
      [
        -12,
        -35
      ],
      [
        -6,
        10
      ],
      [
        -13,
        8
      ],
      [
        -2,
        -27
      ],
      [
        -9,
        29
      ],
      [
        -14,
        29
      ],
      [
        -14,
        8
      ],
      [
        -10,
        -3
      ],
      [
        -7,
        3
      ],
      [
        -6,
        24
      ],
      [
        -1,
        11
      ],
      [
        1,
        6
      ],
      [
        -5,
        15
      ],
      [
        -2,
        1
      ],
      [
        -4,
        -1
      ],
      [
        -21,
        -28
      ],
      [
        -40,
        54
      ],
      [
        -14,
        22
      ],
      [
        -8,
        75
      ],
      [
        1,
        10
      ],
      [
        5,
        32
      ],
      [
        9,
        31
      ],
      [
        4,
        3
      ],
      [
        6,
        -4
      ],
      [
        3,
        -8
      ],
      [
        1,
        -9
      ],
      [
        4,
        -4
      ],
      [
        15,
        0
      ],
      [
        18,
        4
      ],
      [
        6,
        15
      ],
      [
        3,
        33
      ],
      [
        -2,
        2
      ],
      [
        -16,
        5
      ],
      [
        -4,
        -4
      ],
      [
        -14,
        11
      ],
      [
        -10,
        11
      ],
      [
        -3,
        4
      ],
      [
        -5,
        10
      ],
      [
        -1,
        5
      ],
      [
        -1,
        14
      ],
      [
        1,
        9
      ],
      [
        3,
        7
      ],
      [
        -11,
        69
      ],
      [
        -6,
        42
      ],
      [
        -1,
        14
      ],
      [
        3,
        49
      ],
      [
        2,
        5
      ],
      [
        4,
        1
      ],
      [
        2,
        3
      ],
      [
        3,
        12
      ],
      [
        -1,
        11
      ],
      [
        -7,
        8
      ],
      [
        -6,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -3
      ],
      [
        -8,
        -5
      ],
      [
        -3,
        3
      ],
      [
        -12,
        16
      ],
      [
        -12,
        38
      ],
      [
        -4,
        15
      ],
      [
        -1,
        27
      ],
      [
        6,
        70
      ],
      [
        2,
        6
      ],
      [
        20,
        2
      ],
      [
        10,
        -22
      ],
      [
        4,
        -11
      ],
      [
        2,
        -3
      ],
      [
        10,
        -8
      ],
      [
        13,
        -6
      ],
      [
        10,
        -10
      ],
      [
        48,
        -64
      ],
      [
        12,
        -23
      ],
      [
        3,
        -2
      ],
      [
        5,
        15
      ],
      [
        -4,
        12
      ],
      [
        -21,
        46
      ],
      [
        -8,
        14
      ],
      [
        -3,
        4
      ],
      [
        -9,
        1
      ],
      [
        -45,
        85
      ],
      [
        -17,
        34
      ],
      [
        -2,
        6
      ]
    ],
    [
      [
        22784,
        65937
      ],
      [
        32,
        -1
      ],
      [
        65,
        0
      ]
    ],
    [
      [
        22881,
        65532
      ],
      [
        -65,
        0
      ]
    ],
    [
      [
        22816,
        65532
      ],
      [
        -32,
        0
      ]
    ],
    [
      [
        22784,
        65532
      ],
      [
        0,
        405
      ]
    ],
    [
      [
        22784,
        66240
      ],
      [
        98,
        0
      ]
    ],
    [
      [
        22882,
        66240
      ],
      [
        0,
        -101
      ],
      [
        54,
        -1
      ]
    ],
    [
      [
        22936,
        66138
      ],
      [
        0,
        -202
      ]
    ],
    [
      [
        22784,
        65937
      ],
      [
        0,
        303
      ]
    ],
    [
      [
        25437,
        70164
      ],
      [
        42,
        1
      ],
      [
        0,
        204
      ],
      [
        22,
        0
      ],
      [
        0,
        102
      ]
    ],
    [
      [
        25501,
        70471
      ],
      [
        69,
        -1
      ]
    ],
    [
      [
        25570,
        70470
      ],
      [
        0,
        -101
      ],
      [
        12,
        0
      ],
      [
        0,
        -404
      ],
      [
        17,
        -1
      ]
    ],
    [
      [
        25599,
        69964
      ],
      [
        -7,
        -57
      ],
      [
        -4,
        -31
      ],
      [
        -4,
        -12
      ],
      [
        -4,
        -20
      ],
      [
        0,
        -12
      ],
      [
        1,
        -6
      ],
      [
        1,
        -2
      ],
      [
        0,
        -6
      ],
      [
        -3,
        -12
      ],
      [
        -4,
        -8
      ],
      [
        -2,
        -10
      ],
      [
        -2,
        -13
      ],
      [
        -8,
        -22
      ],
      [
        -2,
        -23
      ],
      [
        -8,
        -39
      ],
      [
        -2,
        -12
      ],
      [
        0,
        -15
      ],
      [
        -8,
        -23
      ],
      [
        -13,
        -57
      ],
      [
        -10,
        -38
      ],
      [
        -4,
        -9
      ],
      [
        -6,
        -20
      ],
      [
        -5,
        -23
      ],
      [
        -2,
        -17
      ],
      [
        -1,
        -10
      ],
      [
        1,
        -11
      ],
      [
        3,
        -13
      ],
      [
        2,
        -8
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        22670,
        50311
      ],
      [
        57,
        170
      ]
    ],
    [
      [
        22727,
        50481
      ],
      [
        43,
        130
      ],
      [
        5,
        -11
      ],
      [
        5,
        0
      ],
      [
        0,
        -10
      ],
      [
        3,
        -9
      ],
      [
        9,
        -5
      ],
      [
        4,
        -11
      ],
      [
        0,
        -13
      ],
      [
        4,
        3
      ],
      [
        2,
        -15
      ]
    ],
    [
      [
        22802,
        50540
      ],
      [
        2,
        -3
      ],
      [
        -2,
        -19
      ],
      [
        13,
        3
      ],
      [
        1,
        11
      ],
      [
        4,
        -4
      ],
      [
        2,
        13
      ],
      [
        8,
        -13
      ],
      [
        5,
        -25
      ],
      [
        -1,
        -23
      ],
      [
        4,
        -26
      ],
      [
        4,
        -17
      ],
      [
        -2,
        -33
      ],
      [
        -3,
        -12
      ],
      [
        3,
        -11
      ],
      [
        -4,
        -136
      ],
      [
        2,
        -18
      ],
      [
        4,
        -11
      ],
      [
        -3,
        -7
      ],
      [
        5,
        -11
      ],
      [
        -3,
        -11
      ],
      [
        1,
        -9
      ]
    ],
    [
      [
        22842,
        50178
      ],
      [
        -60,
        -192
      ]
    ],
    [
      [
        22782,
        49986
      ],
      [
        -6,
        17
      ],
      [
        -6,
        1
      ],
      [
        -3,
        10
      ],
      [
        -8,
        -6
      ],
      [
        -6,
        31
      ],
      [
        -4,
        6
      ],
      [
        -7,
        -7
      ],
      [
        0,
        16
      ],
      [
        -9,
        4
      ],
      [
        0,
        51
      ],
      [
        -2,
        23
      ],
      [
        -5,
        10
      ],
      [
        -9,
        1
      ],
      [
        -4,
        7
      ],
      [
        -6,
        -10
      ],
      [
        -14,
        24
      ],
      [
        -2,
        23
      ],
      [
        -8,
        79
      ],
      [
        -5,
        12
      ],
      [
        -2,
        18
      ],
      [
        -6,
        15
      ]
    ],
    [
      [
        22599,
        71221
      ],
      [
        98,
        -1
      ]
    ],
    [
      [
        22809,
        70816
      ],
      [
        -203,
        0
      ]
    ],
    [
      [
        22599,
        70816
      ],
      [
        0,
        405
      ]
    ],
    [
      [
        21748,
        58403
      ],
      [
        152,
        0
      ]
    ],
    [
      [
        21900,
        58403
      ],
      [
        1,
        -507
      ]
    ],
    [
      [
        21748,
        57894
      ],
      [
        0,
        509
      ]
    ],
    [
      [
        27623,
        65237
      ],
      [
        5,
        27
      ],
      [
        7,
        0
      ],
      [
        4,
        28
      ],
      [
        5,
        0
      ],
      [
        9,
        43
      ],
      [
        4,
        0
      ],
      [
        14,
        33
      ],
      [
        0,
        23
      ],
      [
        17,
        -5
      ],
      [
        22,
        -1
      ],
      [
        21,
        0
      ],
      [
        0,
        8
      ]
    ],
    [
      [
        27731,
        65393
      ],
      [
        28,
        1
      ]
    ],
    [
      [
        27759,
        65394
      ],
      [
        0,
        -186
      ],
      [
        -3,
        -28
      ],
      [
        12,
        -1
      ],
      [
        1,
        -62
      ]
    ],
    [
      [
        27769,
        65117
      ],
      [
        -1,
        -60
      ],
      [
        -17,
        1
      ],
      [
        0,
        -18
      ],
      [
        -18,
        1
      ],
      [
        0,
        -52
      ],
      [
        -6,
        0
      ],
      [
        -2,
        -27
      ],
      [
        -5,
        0
      ],
      [
        1,
        -42
      ],
      [
        -6,
        -22
      ],
      [
        0,
        -18
      ],
      [
        -8,
        2
      ],
      [
        1,
        -14
      ]
    ],
    [
      [
        27708,
        64868
      ],
      [
        -53,
        -1
      ],
      [
        -32,
        0
      ]
    ],
    [
      [
        27623,
        64867
      ],
      [
        0,
        370
      ]
    ],
    [
      [
        21900,
        57389
      ],
      [
        35,
        -1
      ]
    ],
    [
      [
        21907,
        56884
      ],
      [
        -120,
        -2
      ]
    ],
    [
      [
        23831,
        59921
      ],
      [
        0,
        85
      ]
    ],
    [
      [
        23916,
        59797
      ],
      [
        -1,
        -101
      ],
      [
        -1,
        -201
      ],
      [
        -1,
        -68
      ]
    ],
    [
      [
        23913,
        59427
      ],
      [
        -75,
        0
      ]
    ],
    [
      [
        23838,
        59427
      ],
      [
        3,
        374
      ],
      [
        -11,
        1
      ],
      [
        1,
        76
      ],
      [
        0,
        43
      ]
    ],
    [
      [
        26494,
        63329
      ],
      [
        31,
        -8
      ],
      [
        0,
        -18
      ],
      [
        32,
        -7
      ],
      [
        -1,
        -29
      ],
      [
        18,
        -7
      ],
      [
        7,
        -12
      ],
      [
        26,
        -6
      ],
      [
        0,
        -4
      ]
    ],
    [
      [
        26607,
        63238
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -57
      ]
    ],
    [
      [
        26605,
        63173
      ],
      [
        -4,
        -194
      ]
    ],
    [
      [
        26601,
        62979
      ],
      [
        -86,
        22
      ]
    ],
    [
      [
        26515,
        63001
      ],
      [
        -22,
        6
      ],
      [
        -16,
        4
      ]
    ],
    [
      [
        26477,
        63011
      ],
      [
        1,
        47
      ],
      [
        -1,
        10
      ],
      [
        5,
        194
      ],
      [
        1,
        52
      ],
      [
        10,
        -2
      ],
      [
        1,
        17
      ]
    ],
    [
      [
        23662,
        63662
      ],
      [
        126,
        -5
      ]
    ],
    [
      [
        23788,
        63657
      ],
      [
        1,
        -201
      ]
    ],
    [
      [
        23790,
        63252
      ],
      [
        -32,
        2
      ],
      [
        -93,
        3
      ]
    ],
    [
      [
        23665,
        63257
      ],
      [
        1,
        286
      ],
      [
        -4,
        0
      ]
    ],
    [
      [
        23662,
        63543
      ],
      [
        0,
        119
      ]
    ],
    [
      [
        24182,
        64198
      ],
      [
        5,
        0
      ],
      [
        1,
        1
      ],
      [
        9,
        0
      ],
      [
        17,
        2
      ],
      [
        11,
        0
      ],
      [
        5,
        1
      ]
    ],
    [
      [
        24230,
        64202
      ],
      [
        23,
        1
      ],
      [
        1,
        0
      ],
      [
        3,
        1
      ],
      [
        4,
        0
      ],
      [
        11,
        1
      ],
      [
        16,
        2
      ],
      [
        6,
        0
      ],
      [
        2,
        1
      ]
    ],
    [
      [
        24296,
        64208
      ],
      [
        -2,
        -355
      ]
    ],
    [
      [
        24294,
        63853
      ],
      [
        -111,
        2
      ]
    ],
    [
      [
        24183,
        63855
      ],
      [
        -1,
        4
      ],
      [
        0,
        47
      ]
    ],
    [
      [
        24182,
        63906
      ],
      [
        0,
        292
      ]
    ],
    [
      [
        22275,
        54282
      ],
      [
        21,
        1
      ]
    ],
    [
      [
        22296,
        54283
      ],
      [
        55,
        -2
      ]
    ],
    [
      [
        22351,
        54281
      ],
      [
        71,
        -439
      ]
    ],
    [
      [
        22422,
        53842
      ],
      [
        -26,
        -15
      ],
      [
        -5,
        -90
      ],
      [
        -59,
        -147
      ]
    ],
    [
      [
        22332,
        53590
      ],
      [
        -8,
        -17
      ],
      [
        -6,
        24
      ],
      [
        -13,
        -40
      ],
      [
        -1,
        6
      ]
    ],
    [
      [
        22304,
        53563
      ],
      [
        -1,
        -15
      ],
      [
        -6,
        23
      ],
      [
        -13,
        0
      ],
      [
        -6,
        -15
      ],
      [
        -1,
        18
      ],
      [
        -4,
        -4
      ]
    ],
    [
      [
        22273,
        53570
      ],
      [
        2,
        712
      ]
    ],
    [
      [
        21328,
        55306
      ],
      [
        108,
        0
      ]
    ],
    [
      [
        21436,
        55306
      ],
      [
        1,
        -507
      ]
    ],
    [
      [
        21435,
        54799
      ],
      [
        -238,
        -1
      ]
    ],
    [
      [
        21197,
        54798
      ],
      [
        0,
        509
      ]
    ],
    [
      [
        22770,
        53399
      ],
      [
        21,
        -89
      ],
      [
        18,
        42
      ]
    ],
    [
      [
        22867,
        53010
      ],
      [
        -50,
        -106
      ],
      [
        -2,
        -6
      ],
      [
        -16,
        -160
      ]
    ],
    [
      [
        22799,
        52738
      ],
      [
        -55,
        88
      ],
      [
        -31,
        49
      ],
      [
        -39,
        33
      ],
      [
        -18,
        9
      ]
    ],
    [
      [
        22656,
        52917
      ],
      [
        -3,
        27
      ],
      [
        -13,
        83
      ],
      [
        -7,
        40
      ]
    ],
    [
      [
        22633,
        53067
      ],
      [
        -1,
        36
      ],
      [
        2,
        4
      ]
    ],
    [
      [
        17195,
        73980
      ],
      [
        45,
        -1
      ],
      [
        40,
        -1
      ],
      [
        26,
        0
      ]
    ],
    [
      [
        17306,
        73801
      ],
      [
        -1,
        -113
      ],
      [
        0,
        -441
      ],
      [
        -1,
        -190
      ],
      [
        0,
        -39
      ],
      [
        -1,
        -57
      ],
      [
        0,
        -93
      ]
    ],
    [
      [
        17303,
        72868
      ],
      [
        -110,
        2
      ]
    ],
    [
      [
        17193,
        72870
      ],
      [
        0,
        102
      ],
      [
        -18,
        0
      ],
      [
        0,
        607
      ],
      [
        -36,
        0
      ],
      [
        0,
        101
      ],
      [
        19,
        0
      ],
      [
        0,
        109
      ],
      [
        18,
        0
      ],
      [
        0,
        101
      ],
      [
        19,
        0
      ],
      [
        0,
        90
      ]
    ],
    [
      [
        26606,
        53687
      ],
      [
        0,
        33
      ],
      [
        13,
        2
      ],
      [
        29,
        -4
      ]
    ],
    [
      [
        26648,
        53718
      ],
      [
        0,
        -28
      ],
      [
        8,
        -1
      ],
      [
        0,
        -16
      ],
      [
        14,
        -3
      ],
      [
        7,
        -25
      ],
      [
        5,
        -58
      ],
      [
        9,
        -6
      ],
      [
        2,
        -1
      ]
    ],
    [
      [
        26693,
        53580
      ],
      [
        0,
        -13
      ],
      [
        -9,
        0
      ],
      [
        0,
        -74
      ],
      [
        -8,
        -29
      ],
      [
        -7,
        -15
      ],
      [
        -2,
        -15
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        26666,
        53434
      ],
      [
        -7,
        -28
      ],
      [
        -15,
        1
      ]
    ],
    [
      [
        26644,
        53407
      ],
      [
        -39,
        4
      ]
    ],
    [
      [
        26605,
        53411
      ],
      [
        1,
        119
      ],
      [
        -4,
        1
      ],
      [
        0,
        60
      ],
      [
        4,
        -1
      ],
      [
        0,
        97
      ]
    ],
    [
      [
        21783,
        52684
      ],
      [
        236,
        5
      ]
    ],
    [
      [
        22019,
        52689
      ],
      [
        0,
        -489
      ]
    ],
    [
      [
        22019,
        52200
      ],
      [
        -163,
        -2
      ]
    ],
    [
      [
        21856,
        52198
      ],
      [
        -73,
        -1
      ]
    ],
    [
      [
        21783,
        52197
      ],
      [
        0,
        487
      ]
    ],
    [
      [
        27602,
        60502
      ],
      [
        8,
        24
      ],
      [
        5,
        38
      ],
      [
        4,
        22
      ],
      [
        1,
        19
      ],
      [
        12,
        39
      ],
      [
        -17,
        93
      ],
      [
        -1,
        17
      ],
      [
        3,
        10
      ]
    ],
    [
      [
        27617,
        60764
      ],
      [
        18,
        42
      ],
      [
        4,
        18
      ],
      [
        7,
        3
      ],
      [
        8,
        43
      ],
      [
        6,
        12
      ],
      [
        6,
        30
      ],
      [
        0,
        9
      ],
      [
        8,
        22
      ],
      [
        40,
        -44
      ]
    ],
    [
      [
        27714,
        60899
      ],
      [
        -4,
        -33
      ],
      [
        3,
        -42
      ],
      [
        3,
        -5
      ],
      [
        -1,
        -24
      ],
      [
        -4,
        -14
      ],
      [
        31,
        -77
      ],
      [
        -1,
        -18
      ],
      [
        22,
        -55
      ]
    ],
    [
      [
        27763,
        60631
      ],
      [
        -6,
        -29
      ],
      [
        -8,
        -22
      ],
      [
        -5,
        -2
      ],
      [
        -6,
        -44
      ],
      [
        -8,
        10
      ],
      [
        -3,
        -4
      ],
      [
        -2,
        2
      ],
      [
        -2,
        17
      ],
      [
        -5,
        16
      ],
      [
        -9,
        -10
      ],
      [
        -8,
        -32
      ],
      [
        -10,
        -27
      ],
      [
        -10,
        -20
      ],
      [
        -6,
        -6
      ],
      [
        6,
        -26
      ],
      [
        4,
        1
      ],
      [
        -3,
        -36
      ],
      [
        -16,
        -39
      ],
      [
        0,
        -9
      ]
    ],
    [
      [
        27666,
        60371
      ],
      [
        -6,
        22
      ],
      [
        -6,
        11
      ],
      [
        -11,
        21
      ],
      [
        -5,
        8
      ],
      [
        -32,
        53
      ],
      [
        -4,
        16
      ]
    ],
    [
      [
        23611,
        53787
      ],
      [
        86,
        -39
      ],
      [
        30,
        -59
      ]
    ],
    [
      [
        23727,
        53689
      ],
      [
        0,
        -120
      ],
      [
        -4,
        -21
      ],
      [
        -13,
        -45
      ],
      [
        5,
        -33
      ],
      [
        1,
        -20
      ],
      [
        -5,
        -28
      ],
      [
        1,
        -8
      ],
      [
        -3,
        -43
      ],
      [
        3,
        -9
      ],
      [
        2,
        -56
      ],
      [
        -2,
        -27
      ],
      [
        0,
        -48
      ],
      [
        -3,
        -35
      ],
      [
        3,
        -14
      ]
    ],
    [
      [
        23712,
        53182
      ],
      [
        -1,
        -18
      ],
      [
        -25,
        -22
      ]
    ],
    [
      [
        23686,
        53142
      ],
      [
        -3,
        18
      ],
      [
        -14,
        25
      ],
      [
        -3,
        20
      ],
      [
        -5,
        12
      ],
      [
        1,
        11
      ],
      [
        -9,
        17
      ],
      [
        -3,
        -9
      ],
      [
        -3,
        18
      ],
      [
        -5,
        6
      ],
      [
        -1,
        14
      ],
      [
        -9,
        14
      ]
    ],
    [
      [
        23632,
        53288
      ],
      [
        -4,
        18
      ],
      [
        2,
        12
      ],
      [
        -2,
        15
      ],
      [
        5,
        25
      ],
      [
        2,
        23
      ],
      [
        -2,
        22
      ],
      [
        2,
        16
      ],
      [
        -4,
        26
      ],
      [
        2,
        33
      ],
      [
        -1,
        14
      ],
      [
        3,
        5
      ],
      [
        3,
        20
      ],
      [
        -5,
        27
      ],
      [
        3,
        28
      ],
      [
        -2,
        15
      ],
      [
        3,
        17
      ],
      [
        2,
        35
      ],
      [
        -2,
        30
      ],
      [
        1,
        13
      ],
      [
        -3,
        14
      ],
      [
        1,
        16
      ],
      [
        -11,
        21
      ],
      [
        -5,
        31
      ],
      [
        -8,
        5
      ],
      [
        -1,
        18
      ]
    ],
    [
      [
        31524,
        38134
      ],
      [
        3,
        16
      ],
      [
        10,
        10
      ]
    ],
    [
      [
        31537,
        38160
      ],
      [
        0,
        -15
      ],
      [
        6,
        -22
      ],
      [
        0,
        -41
      ],
      [
        1,
        -22
      ]
    ],
    [
      [
        31544,
        38060
      ],
      [
        2,
        -6
      ],
      [
        -2,
        -21
      ]
    ],
    [
      [
        31544,
        38033
      ],
      [
        -2,
        -31
      ],
      [
        -8,
        -8
      ],
      [
        -4,
        9
      ],
      [
        -9,
        -22
      ]
    ],
    [
      [
        31521,
        37981
      ],
      [
        -1,
        24
      ],
      [
        -11,
        16
      ]
    ],
    [
      [
        31509,
        38021
      ],
      [
        0,
        4
      ]
    ],
    [
      [
        31426,
        38459
      ],
      [
        3,
        0
      ],
      [
        7,
        -13
      ]
    ],
    [
      [
        31436,
        38446
      ],
      [
        -1,
        -28
      ],
      [
        5,
        -31
      ],
      [
        -1,
        -47
      ]
    ],
    [
      [
        31439,
        38340
      ],
      [
        -3,
        -3
      ],
      [
        -1,
        -16
      ]
    ],
    [
      [
        31435,
        38321
      ],
      [
        -10,
        -8
      ],
      [
        1,
        -10
      ],
      [
        -4,
        -22
      ]
    ],
    [
      [
        31419,
        38294
      ],
      [
        1,
        32
      ],
      [
        2,
        21
      ],
      [
        0,
        7
      ],
      [
        2,
        29
      ],
      [
        3,
        9
      ],
      [
        -1,
        67
      ]
    ],
    [
      [
        23984,
        71379
      ],
      [
        71,
        0
      ],
      [
        41,
        3
      ],
      [
        6,
        -2
      ],
      [
        58,
        -3
      ],
      [
        36,
        0
      ],
      [
        0,
        -114
      ],
      [
        2,
        -4
      ]
    ],
    [
      [
        24198,
        71259
      ],
      [
        1,
        -45
      ],
      [
        0,
        -23
      ],
      [
        -1,
        -117
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        24198,
        70973
      ],
      [
        -72,
        1
      ],
      [
        -70,
        0
      ],
      [
        -70,
        1
      ]
    ],
    [
      [
        23986,
        70975
      ],
      [
        0,
        186
      ],
      [
        -2,
        17
      ],
      [
        -1,
        98
      ],
      [
        1,
        103
      ]
    ],
    [
      [
        26672,
        51474
      ],
      [
        4,
        8
      ],
      [
        9,
        -9
      ],
      [
        1,
        13
      ],
      [
        3,
        20
      ],
      [
        2,
        38
      ],
      [
        0,
        19
      ],
      [
        2,
        20
      ],
      [
        5,
        21
      ],
      [
        0,
        52
      ]
    ],
    [
      [
        26698,
        51656
      ],
      [
        101,
        3
      ],
      [
        10,
        -2
      ]
    ],
    [
      [
        26809,
        51657
      ],
      [
        -4,
        -17
      ],
      [
        4,
        -17
      ],
      [
        -4,
        -10
      ],
      [
        -4,
        -37
      ],
      [
        3,
        -11
      ],
      [
        -3,
        -22
      ],
      [
        3,
        -29
      ],
      [
        -4,
        3
      ],
      [
        -1,
        -39
      ],
      [
        2,
        -10
      ],
      [
        -2,
        -26
      ],
      [
        -4,
        -17
      ],
      [
        0,
        -19
      ],
      [
        5,
        -26
      ],
      [
        5,
        6
      ]
    ],
    [
      [
        26805,
        51386
      ],
      [
        -2,
        -10
      ],
      [
        -2,
        -31
      ],
      [
        -7,
        -17
      ],
      [
        2,
        -22
      ],
      [
        -4,
        -6
      ],
      [
        0,
        -54
      ],
      [
        -5,
        -10
      ],
      [
        -7,
        -49
      ],
      [
        1,
        -24
      ],
      [
        -4,
        -13
      ],
      [
        -8,
        -18
      ],
      [
        1,
        -13
      ],
      [
        -3,
        -9
      ],
      [
        3,
        -5
      ],
      [
        -8,
        -20
      ],
      [
        -2,
        5
      ],
      [
        -2,
        -13
      ],
      [
        -4,
        -10
      ],
      [
        -6,
        8
      ],
      [
        -2,
        -19
      ],
      [
        -5,
        -22
      ]
    ],
    [
      [
        26741,
        51034
      ],
      [
        -1,
        2
      ],
      [
        -2,
        28
      ],
      [
        0,
        35
      ],
      [
        -4,
        22
      ],
      [
        -3,
        12
      ],
      [
        0,
        24
      ],
      [
        -5,
        30
      ],
      [
        -6,
        15
      ],
      [
        -6,
        3
      ],
      [
        -3,
        -4
      ],
      [
        -6,
        7
      ],
      [
        -3,
        25
      ],
      [
        -1,
        11
      ],
      [
        -1,
        8
      ],
      [
        -3,
        1
      ],
      [
        -2,
        -1
      ],
      [
        -5,
        16
      ],
      [
        -2,
        12
      ],
      [
        -4,
        0
      ],
      [
        -2,
        4
      ],
      [
        -2,
        11
      ],
      [
        -4,
        5
      ],
      [
        -1,
        7
      ],
      [
        1,
        11
      ],
      [
        -2,
        53
      ],
      [
        0,
        20
      ],
      [
        2,
        20
      ],
      [
        -1,
        33
      ],
      [
        -3,
        30
      ]
    ],
    [
      [
        26598,
        56049
      ],
      [
        17,
        91
      ],
      [
        23,
        124
      ],
      [
        3,
        17
      ],
      [
        5,
        25
      ]
    ],
    [
      [
        26646,
        56306
      ],
      [
        8,
        -18
      ],
      [
        5,
        -33
      ],
      [
        4,
        -60
      ],
      [
        6,
        -7
      ],
      [
        5,
        -21
      ]
    ],
    [
      [
        26674,
        56167
      ],
      [
        3,
        -9
      ],
      [
        3,
        -28
      ],
      [
        4,
        -12
      ],
      [
        3,
        -39
      ],
      [
        4,
        -26
      ],
      [
        5,
        -19
      ],
      [
        5,
        -24
      ],
      [
        6,
        -24
      ],
      [
        5,
        -11
      ],
      [
        -2,
        -7
      ],
      [
        -2,
        -25
      ],
      [
        2,
        -14
      ],
      [
        -1,
        -12
      ]
    ],
    [
      [
        26709,
        55917
      ],
      [
        -70,
        -57
      ]
    ],
    [
      [
        26639,
        55860
      ],
      [
        -15,
        36
      ],
      [
        -27,
        71
      ]
    ],
    [
      [
        26597,
        55967
      ],
      [
        1,
        52
      ],
      [
        -2,
        20
      ],
      [
        2,
        10
      ]
    ],
    [
      [
        3834,
        96137
      ],
      [
        247,
        0
      ],
      [
        0,
        201
      ],
      [
        495,
        0
      ],
      [
        0,
        101
      ],
      [
        195,
        0
      ],
      [
        0,
        -101
      ],
      [
        130,
        0
      ],
      [
        0,
        101
      ],
      [
        130,
        0
      ],
      [
        0,
        -101
      ],
      [
        259,
        1
      ],
      [
        0,
        100
      ],
      [
        130,
        0
      ],
      [
        0,
        -100
      ],
      [
        707,
        0
      ],
      [
        0,
        -101
      ],
      [
        256,
        0
      ],
      [
        0,
        -101
      ],
      [
        256,
        0
      ],
      [
        0,
        -41
      ]
    ],
    [
      [
        6639,
        96096
      ],
      [
        0,
        -160
      ],
      [
        -14,
        0
      ],
      [
        0,
        -101
      ],
      [
        63,
        0
      ],
      [
        0,
        -101
      ],
      [
        63,
        0
      ],
      [
        0,
        -101
      ],
      [
        63,
        0
      ],
      [
        0,
        -101
      ],
      [
        -16,
        0
      ],
      [
        0,
        -302
      ],
      [
        124,
        0
      ],
      [
        0,
        -101
      ],
      [
        43,
        0
      ],
      [
        0,
        -403
      ],
      [
        -17,
        0
      ],
      [
        0,
        -101
      ],
      [
        -182,
        0
      ],
      [
        0,
        -201
      ],
      [
        -181,
        0
      ],
      [
        0,
        -101
      ],
      [
        -12,
        0
      ],
      [
        0,
        -202
      ],
      [
        -119,
        0
      ],
      [
        0,
        101
      ],
      [
        -60,
        0
      ],
      [
        0,
        101
      ],
      [
        -119,
        0
      ],
      [
        0,
        -202
      ],
      [
        -119,
        0
      ],
      [
        0,
        202
      ],
      [
        -238,
        0
      ],
      [
        0,
        -403
      ],
      [
        -297,
        0
      ],
      [
        0,
        -202
      ],
      [
        -176,
        0
      ],
      [
        0,
        -202
      ],
      [
        3,
        0
      ],
      [
        0,
        -302
      ]
    ],
    [
      [
        5448,
        93214
      ],
      [
        -58,
        0
      ],
      [
        0,
        -101
      ],
      [
        -1102,
        0
      ],
      [
        0,
        202
      ],
      [
        -58,
        0
      ],
      [
        0,
        201
      ],
      [
        -78,
        0
      ],
      [
        0,
        404
      ],
      [
        -21,
        0
      ],
      [
        0,
        403
      ],
      [
        -21,
        0
      ],
      [
        0,
        122
      ]
    ],
    [
      [
        4110,
        94445
      ],
      [
        14,
        -1
      ],
      [
        70,
        14
      ],
      [
        32,
        2
      ],
      [
        0,
        -4
      ],
      [
        18,
        4
      ],
      [
        25,
        -3
      ],
      [
        27,
        -8
      ],
      [
        16,
        -10
      ],
      [
        18,
        -21
      ],
      [
        -8,
        -5
      ],
      [
        -33,
        -6
      ],
      [
        0,
        -23
      ],
      [
        7,
        -15
      ],
      [
        0,
        -20
      ],
      [
        -1,
        -9
      ],
      [
        -9,
        -42
      ],
      [
        -10,
        -21
      ],
      [
        -12,
        -21
      ],
      [
        -4,
        -11
      ],
      [
        -5,
        -24
      ],
      [
        1,
        -70
      ],
      [
        6,
        -25
      ],
      [
        3,
        -4
      ],
      [
        3,
        -27
      ],
      [
        -1,
        -10
      ],
      [
        -3,
        -14
      ],
      [
        -17,
        -35
      ],
      [
        -15,
        -15
      ],
      [
        -25,
        -9
      ],
      [
        -9,
        -9
      ],
      [
        -4,
        -20
      ],
      [
        1,
        -2
      ],
      [
        3,
        -2
      ],
      [
        20,
        -2
      ],
      [
        25,
        13
      ],
      [
        11,
        -35
      ],
      [
        5,
        -28
      ],
      [
        4,
        -17
      ],
      [
        12,
        -25
      ],
      [
        9,
        -21
      ],
      [
        1,
        -10
      ],
      [
        0,
        -15
      ],
      [
        40,
        -3
      ],
      [
        23,
        14
      ],
      [
        11,
        13
      ],
      [
        2,
        5
      ],
      [
        42,
        -1
      ],
      [
        8,
        -11
      ],
      [
        8,
        -7
      ],
      [
        33,
        -12
      ],
      [
        6,
        1
      ],
      [
        15,
        4
      ],
      [
        13,
        6
      ],
      [
        13,
        10
      ],
      [
        34,
        7
      ],
      [
        24,
        7
      ],
      [
        11,
        1
      ],
      [
        20,
        -33
      ],
      [
        0,
        -4
      ],
      [
        2,
        -5
      ],
      [
        10,
        -16
      ],
      [
        4,
        -1
      ],
      [
        25,
        7
      ],
      [
        21,
        15
      ],
      [
        9,
        -11
      ],
      [
        3,
        -16
      ],
      [
        6,
        -7
      ],
      [
        6,
        -1
      ],
      [
        11,
        4
      ],
      [
        17,
        12
      ],
      [
        18,
        17
      ],
      [
        18,
        26
      ],
      [
        1,
        0
      ],
      [
        2,
        -11
      ],
      [
        2,
        -2
      ],
      [
        27,
        -6
      ],
      [
        21,
        -26
      ],
      [
        31,
        -20
      ],
      [
        6,
        12
      ],
      [
        2,
        10
      ],
      [
        3,
        16
      ],
      [
        7,
        21
      ],
      [
        26,
        44
      ],
      [
        5,
        13
      ],
      [
        10,
        36
      ],
      [
        1,
        10
      ],
      [
        3,
        17
      ],
      [
        18,
        74
      ],
      [
        18,
        26
      ],
      [
        32,
        -5
      ],
      [
        8,
        -4
      ],
      [
        1,
        -14
      ],
      [
        1,
        -8
      ],
      [
        4,
        -14
      ],
      [
        2,
        -3
      ],
      [
        14,
        -8
      ],
      [
        18,
        -4
      ],
      [
        14,
        11
      ],
      [
        17,
        16
      ],
      [
        5,
        1
      ],
      [
        4,
        -5
      ],
      [
        5,
        -2
      ],
      [
        10,
        5
      ],
      [
        2,
        1
      ],
      [
        0,
        3
      ],
      [
        1,
        3
      ],
      [
        -2,
        15
      ],
      [
        -1,
        3
      ],
      [
        -17,
        34
      ],
      [
        -5,
        27
      ],
      [
        -3,
        9
      ],
      [
        -5,
        16
      ],
      [
        -6,
        9
      ],
      [
        -9,
        7
      ],
      [
        -16,
        7
      ],
      [
        -40,
        32
      ],
      [
        -45,
        24
      ],
      [
        -48,
        -1
      ],
      [
        -34,
        -41
      ],
      [
        -26,
        -19
      ],
      [
        -1,
        6
      ],
      [
        10,
        57
      ],
      [
        2,
        18
      ],
      [
        2,
        31
      ],
      [
        0,
        56
      ],
      [
        -3,
        27
      ],
      [
        -43,
        87
      ],
      [
        -17,
        23
      ],
      [
        -2,
        4
      ],
      [
        -2,
        15
      ],
      [
        -2,
        20
      ],
      [
        -3,
        13
      ],
      [
        -5,
        16
      ],
      [
        -10,
        27
      ],
      [
        -14,
        25
      ],
      [
        -12,
        10
      ],
      [
        -22,
        10
      ],
      [
        -20,
        6
      ],
      [
        -17,
        -2
      ],
      [
        -5,
        15
      ],
      [
        0,
        8
      ],
      [
        -1,
        11
      ],
      [
        -2,
        22
      ],
      [
        -9,
        31
      ],
      [
        -8,
        24
      ],
      [
        -6,
        14
      ],
      [
        -6,
        11
      ],
      [
        -2,
        5
      ],
      [
        -1,
        5
      ],
      [
        0,
        5
      ],
      [
        1,
        17
      ],
      [
        2,
        14
      ],
      [
        4,
        14
      ],
      [
        5,
        7
      ],
      [
        14,
        1
      ],
      [
        8,
        10
      ],
      [
        1,
        23
      ],
      [
        9,
        20
      ],
      [
        6,
        -30
      ],
      [
        10,
        -7
      ],
      [
        18,
        18
      ],
      [
        6,
        10
      ],
      [
        10,
        -14
      ],
      [
        2,
        -18
      ],
      [
        3,
        -13
      ],
      [
        12,
        -44
      ],
      [
        19,
        -41
      ],
      [
        12,
        -38
      ],
      [
        5,
        -12
      ],
      [
        7,
        -6
      ],
      [
        7,
        -3
      ],
      [
        10,
        -1
      ],
      [
        0,
        -24
      ],
      [
        -5,
        -29
      ],
      [
        -3,
        -12
      ],
      [
        -5,
        -9
      ],
      [
        -3,
        -7
      ],
      [
        -1,
        -8
      ],
      [
        -2,
        -12
      ],
      [
        4,
        -16
      ],
      [
        -3,
        -18
      ],
      [
        1,
        -15
      ],
      [
        1,
        -6
      ],
      [
        10,
        -17
      ],
      [
        18,
        -33
      ],
      [
        4,
        -12
      ],
      [
        19,
        -45
      ],
      [
        34,
        -66
      ],
      [
        39,
        -55
      ],
      [
        14,
        -13
      ],
      [
        16,
        4
      ],
      [
        23,
        14
      ],
      [
        30,
        28
      ],
      [
        13,
        31
      ],
      [
        -4,
        18
      ],
      [
        -29,
        4
      ],
      [
        -16,
        -2
      ],
      [
        -4,
        1
      ],
      [
        -4,
        3
      ],
      [
        -3,
        6
      ],
      [
        0,
        4
      ],
      [
        2,
        5
      ],
      [
        1,
        6
      ],
      [
        -2,
        20
      ],
      [
        -14,
        24
      ],
      [
        -16,
        14
      ],
      [
        -18,
        20
      ],
      [
        -8,
        12
      ],
      [
        -48,
        98
      ],
      [
        -5,
        14
      ],
      [
        10,
        52
      ],
      [
        -5,
        19
      ],
      [
        1,
        22
      ],
      [
        4,
        19
      ],
      [
        6,
        5
      ],
      [
        8,
        18
      ],
      [
        3,
        16
      ],
      [
        1,
        15
      ],
      [
        -3,
        26
      ],
      [
        6,
        17
      ],
      [
        14,
        24
      ],
      [
        8,
        32
      ],
      [
        2,
        13
      ],
      [
        -1,
        5
      ],
      [
        1,
        1
      ],
      [
        3,
        1
      ],
      [
        30,
        -32
      ],
      [
        22,
        3
      ],
      [
        1,
        10
      ],
      [
        0,
        18
      ],
      [
        -6,
        15
      ],
      [
        -7,
        13
      ],
      [
        -25,
        27
      ],
      [
        -21,
        3
      ],
      [
        -4,
        -11
      ],
      [
        -14,
        34
      ],
      [
        -11,
        20
      ],
      [
        -3,
        3
      ],
      [
        -7,
        2
      ],
      [
        -4,
        0
      ],
      [
        -12,
        -4
      ],
      [
        -64,
        -27
      ],
      [
        -25,
        -22
      ],
      [
        -6,
        -8
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -1
      ],
      [
        -34,
        0
      ],
      [
        -13,
        -10
      ],
      [
        -17,
        -5
      ],
      [
        -9,
        -4
      ],
      [
        -34,
        17
      ],
      [
        -9,
        19
      ],
      [
        -11,
        24
      ],
      [
        -17,
        -16
      ],
      [
        -6,
        4
      ],
      [
        -15,
        19
      ],
      [
        -1,
        -30
      ],
      [
        5,
        -11
      ],
      [
        -1,
        -6
      ],
      [
        -7,
        -4
      ],
      [
        -36,
        39
      ],
      [
        -35,
        19
      ],
      [
        -56,
        23
      ],
      [
        -27,
        16
      ],
      [
        -12,
        8
      ],
      [
        -15,
        7
      ],
      [
        -27,
        6
      ],
      [
        -21,
        9
      ],
      [
        -10,
        11
      ],
      [
        -12,
        19
      ],
      [
        0,
        13
      ],
      [
        2,
        30
      ],
      [
        0,
        25
      ],
      [
        -1,
        30
      ],
      [
        -5,
        54
      ],
      [
        -17,
        109
      ],
      [
        -9,
        44
      ],
      [
        -7,
        33
      ],
      [
        -36,
        139
      ],
      [
        -20,
        58
      ],
      [
        -8,
        19
      ],
      [
        -10,
        18
      ],
      [
        -18,
        25
      ],
      [
        -91,
        101
      ],
      [
        -68,
        111
      ],
      [
        -36,
        55
      ],
      [
        -41,
        62
      ],
      [
        -21,
        24
      ],
      [
        -17,
        28
      ],
      [
        -10,
        22
      ],
      [
        -24,
        37
      ],
      [
        -20,
        21
      ]
    ],
    [
      [
        21029,
        72034
      ],
      [
        158,
        0
      ]
    ],
    [
      [
        21187,
        72034
      ],
      [
        19,
        0
      ],
      [
        0,
        -406
      ]
    ],
    [
      [
        21206,
        71628
      ],
      [
        -55,
        0
      ],
      [
        0,
        -408
      ]
    ],
    [
      [
        21045,
        71220
      ],
      [
        0,
        408
      ],
      [
        -16,
        0
      ],
      [
        0,
        406
      ]
    ],
    [
      [
        23785,
        71422
      ],
      [
        0,
        264
      ]
    ],
    [
      [
        23785,
        71686
      ],
      [
        128,
        -2
      ],
      [
        35,
        -4
      ],
      [
        38,
        2
      ]
    ],
    [
      [
        23986,
        71682
      ],
      [
        -2,
        -303
      ]
    ],
    [
      [
        23986,
        70975
      ],
      [
        0,
        -304
      ]
    ],
    [
      [
        23986,
        70671
      ],
      [
        -35,
        1
      ],
      [
        -29,
        1
      ],
      [
        -41,
        -7
      ]
    ],
    [
      [
        23881,
        70666
      ],
      [
        0,
        108
      ],
      [
        -102,
        -4
      ]
    ],
    [
      [
        23779,
        70770
      ],
      [
        -4,
        9
      ],
      [
        0,
        388
      ],
      [
        9,
        6
      ],
      [
        1,
        249
      ]
    ],
    [
      [
        19529,
        62918
      ],
      [
        0,
        189
      ]
    ],
    [
      [
        19529,
        63107
      ],
      [
        44,
        0
      ],
      [
        0,
        -11
      ],
      [
        95,
        -1
      ],
      [
        0,
        51
      ],
      [
        171,
        1
      ],
      [
        0,
        152
      ],
      [
        42,
        0
      ],
      [
        26,
        6
      ],
      [
        73,
        -2
      ],
      [
        0,
        104
      ],
      [
        32,
        -3
      ],
      [
        0,
        204
      ],
      [
        78,
        1
      ]
    ],
    [
      [
        20090,
        63609
      ],
      [
        2,
        -103
      ],
      [
        -1,
        -98
      ]
    ],
    [
      [
        20091,
        63408
      ],
      [
        -22,
        0
      ],
      [
        0,
        -643
      ]
    ],
    [
      [
        20069,
        62765
      ],
      [
        -88,
        0
      ]
    ],
    [
      [
        19981,
        62765
      ],
      [
        -452,
        0
      ]
    ],
    [
      [
        19529,
        62765
      ],
      [
        0,
        153
      ]
    ],
    [
      [
        23426,
        61628
      ],
      [
        0,
        -152
      ],
      [
        -3,
        0
      ],
      [
        0,
        -122
      ],
      [
        -1,
        -136
      ]
    ],
    [
      [
        23422,
        61218
      ],
      [
        -41,
        1
      ],
      [
        -82,
        0
      ]
    ],
    [
      [
        23299,
        61219
      ],
      [
        1,
        257
      ],
      [
        3,
        0
      ],
      [
        -1,
        153
      ]
    ],
    [
      [
        22037,
        56327
      ],
      [
        15,
        0
      ]
    ],
    [
      [
        22052,
        56327
      ],
      [
        1,
        -510
      ]
    ],
    [
      [
        22053,
        55817
      ],
      [
        -146,
        0
      ]
    ],
    [
      [
        22225,
        58628
      ],
      [
        186,
        -1
      ],
      [
        0,
        1
      ],
      [
        21,
        0
      ]
    ],
    [
      [
        22435,
        58324
      ],
      [
        0,
        -17
      ],
      [
        -1,
        -84
      ]
    ],
    [
      [
        22434,
        58223
      ],
      [
        -117,
        1
      ],
      [
        -89,
        0
      ]
    ],
    [
      [
        22228,
        58275
      ],
      [
        0,
        50
      ],
      [
        -3,
        0
      ],
      [
        0,
        303
      ]
    ],
    [
      [
        26670,
        64302
      ],
      [
        32,
        0
      ],
      [
        0,
        18
      ],
      [
        54,
        1
      ]
    ],
    [
      [
        26827,
        64323
      ],
      [
        -1,
        -68
      ],
      [
        -27,
        -12
      ],
      [
        0,
        -169
      ],
      [
        -16,
        -7
      ],
      [
        -2,
        -59
      ]
    ],
    [
      [
        26781,
        64008
      ],
      [
        -40,
        6
      ],
      [
        -23,
        5
      ]
    ],
    [
      [
        26718,
        64019
      ],
      [
        0,
        74
      ],
      [
        -47,
        -2
      ]
    ],
    [
      [
        26671,
        64091
      ],
      [
        1,
        12
      ],
      [
        -2,
        102
      ],
      [
        0,
        97
      ]
    ],
    [
      [
        24715,
        64741
      ],
      [
        0,
        102
      ]
    ],
    [
      [
        24715,
        64843
      ],
      [
        126,
        -2
      ]
    ],
    [
      [
        24841,
        64841
      ],
      [
        0,
        -204
      ]
    ],
    [
      [
        24841,
        64637
      ],
      [
        0,
        -305
      ]
    ],
    [
      [
        24841,
        64332
      ],
      [
        -64,
        1
      ],
      [
        -64,
        2
      ]
    ],
    [
      [
        24713,
        64335
      ],
      [
        1,
        271
      ],
      [
        1,
        135
      ]
    ],
    [
      [
        26559,
        56667
      ],
      [
        2,
        -17
      ],
      [
        6,
        -15
      ],
      [
        0,
        -15
      ],
      [
        7,
        -26
      ],
      [
        9,
        3
      ],
      [
        3,
        -5
      ],
      [
        3,
        -20
      ],
      [
        3,
        9
      ],
      [
        6,
        -8
      ],
      [
        4,
        6
      ],
      [
        14,
        -6
      ],
      [
        4,
        -14
      ],
      [
        6,
        5
      ],
      [
        4,
        -9
      ],
      [
        8,
        -76
      ]
    ],
    [
      [
        26638,
        56479
      ],
      [
        -9,
        -19
      ],
      [
        -1,
        -2
      ],
      [
        -21,
        -49
      ]
    ],
    [
      [
        26607,
        56409
      ],
      [
        -8,
        13
      ],
      [
        -13,
        -20
      ],
      [
        -6,
        6
      ],
      [
        -4,
        -9
      ],
      [
        -1,
        -3
      ],
      [
        -10,
        41
      ]
    ],
    [
      [
        26565,
        56437
      ],
      [
        -4,
        22
      ],
      [
        0,
        5
      ],
      [
        -3,
        13
      ],
      [
        -4,
        23
      ],
      [
        -9,
        23
      ],
      [
        1,
        11
      ],
      [
        9,
        90
      ],
      [
        4,
        43
      ]
    ],
    [
      [
        25228,
        65199
      ],
      [
        3,
        -406
      ]
    ],
    [
      [
        25231,
        64793
      ],
      [
        -54,
        -2
      ],
      [
        -9,
        0
      ],
      [
        -33,
        -1
      ],
      [
        0,
        -207
      ]
    ],
    [
      [
        25135,
        64583
      ],
      [
        -33,
        -3
      ]
    ],
    [
      [
        25070,
        64788
      ],
      [
        0,
        240
      ]
    ],
    [
      [
        25070,
        65028
      ],
      [
        -1,
        216
      ],
      [
        0,
        104
      ]
    ],
    [
      [
        25069,
        65348
      ],
      [
        0,
        51
      ],
      [
        34,
        -3
      ],
      [
        30,
        2
      ]
    ],
    [
      [
        25897,
        53538
      ],
      [
        0,
        105
      ],
      [
        11,
        0
      ],
      [
        2,
        9
      ],
      [
        1,
        0
      ],
      [
        0,
        93
      ]
    ],
    [
      [
        25911,
        53745
      ],
      [
        99,
        0
      ]
    ],
    [
      [
        26010,
        53745
      ],
      [
        0,
        -490
      ]
    ],
    [
      [
        26010,
        53255
      ],
      [
        -75,
        -3
      ],
      [
        -16,
        -1
      ],
      [
        0,
        -13
      ],
      [
        -3,
        12
      ],
      [
        -18,
        0
      ]
    ],
    [
      [
        25898,
        53250
      ],
      [
        -1,
        187
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        27434,
        48610
      ],
      [
        55,
        0
      ],
      [
        42,
        -1
      ],
      [
        13,
        1
      ],
      [
        0,
        67
      ],
      [
        24,
        -1
      ]
    ],
    [
      [
        27568,
        48676
      ],
      [
        1,
        -16
      ],
      [
        9,
        -66
      ],
      [
        2,
        -27
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -1
      ],
      [
        2,
        -23
      ],
      [
        3,
        -37
      ],
      [
        7,
        -46
      ],
      [
        6,
        -63
      ],
      [
        4,
        -56
      ]
    ],
    [
      [
        27601,
        48335
      ],
      [
        -17,
        1
      ],
      [
        0,
        -17
      ],
      [
        -8,
        0
      ],
      [
        -101,
        2
      ],
      [
        -14,
        0
      ],
      [
        -85,
        1
      ]
    ],
    [
      [
        27376,
        48322
      ],
      [
        58,
        189
      ],
      [
        0,
        99
      ]
    ],
    [
      [
        23731,
        66480
      ],
      [
        131,
        0
      ]
    ],
    [
      [
        23862,
        66480
      ],
      [
        0,
        -101
      ],
      [
        10,
        0
      ],
      [
        0,
        -305
      ]
    ],
    [
      [
        23872,
        66074
      ],
      [
        -65,
        0
      ]
    ],
    [
      [
        23994,
        66479
      ],
      [
        0,
        -100
      ],
      [
        6,
        0
      ],
      [
        1,
        -102
      ],
      [
        0,
        -203
      ]
    ],
    [
      [
        23937,
        66074
      ],
      [
        -65,
        0
      ]
    ],
    [
      [
        17924,
        69100
      ],
      [
        4,
        -16
      ],
      [
        -6,
        -55
      ],
      [
        8,
        -40
      ],
      [
        3,
        1
      ],
      [
        7,
        -23
      ],
      [
        6,
        -38
      ],
      [
        -2,
        -10
      ],
      [
        8,
        -3
      ],
      [
        14,
        14
      ],
      [
        9,
        -11
      ],
      [
        6,
        -20
      ],
      [
        3,
        -19
      ],
      [
        -2,
        -26
      ],
      [
        10,
        -25
      ],
      [
        8,
        8
      ],
      [
        7,
        25
      ],
      [
        5,
        0
      ],
      [
        5,
        -11
      ],
      [
        8,
        20
      ],
      [
        1,
        23
      ],
      [
        3,
        23
      ],
      [
        8,
        6
      ],
      [
        6,
        19
      ],
      [
        4,
        43
      ],
      [
        -10,
        11
      ],
      [
        1,
        24
      ],
      [
        7,
        4
      ],
      [
        7,
        18
      ],
      [
        0,
        19
      ],
      [
        3,
        22
      ],
      [
        8,
        9
      ],
      [
        4,
        21
      ],
      [
        6,
        4
      ],
      [
        4,
        31
      ],
      [
        11,
        17
      ],
      [
        1,
        17
      ],
      [
        2,
        -18
      ],
      [
        5,
        -1
      ],
      [
        1,
        -29
      ],
      [
        -1,
        -40
      ],
      [
        -2,
        -4
      ],
      [
        0,
        -25
      ],
      [
        -4,
        -19
      ],
      [
        0,
        -18
      ],
      [
        17,
        -2
      ],
      [
        6,
        -17
      ],
      [
        3,
        13
      ],
      [
        11,
        17
      ],
      [
        9,
        -52
      ],
      [
        0,
        -16
      ],
      [
        5,
        -31
      ],
      [
        8,
        -42
      ],
      [
        9,
        -18
      ],
      [
        12,
        -44
      ],
      [
        3,
        -19
      ],
      [
        5,
        -8
      ],
      [
        16,
        -41
      ],
      [
        7,
        -33
      ],
      [
        8,
        -1
      ],
      [
        28,
        -30
      ],
      [
        8,
        -21
      ],
      [
        20,
        -8
      ],
      [
        10,
        -20
      ],
      [
        14,
        -5
      ],
      [
        7,
        30
      ],
      [
        8,
        5
      ],
      [
        4,
        -29
      ],
      [
        3,
        -5
      ],
      [
        5,
        -47
      ],
      [
        12,
        -43
      ],
      [
        2,
        -19
      ],
      [
        4,
        -15
      ],
      [
        1,
        -26
      ],
      [
        3,
        -24
      ],
      [
        -2,
        -30
      ],
      [
        4,
        -17
      ]
    ],
    [
      [
        18340,
        68430
      ],
      [
        -27,
        1
      ],
      [
        0,
        -203
      ],
      [
        -11,
        0
      ],
      [
        0,
        -80
      ],
      [
        3,
        -8
      ],
      [
        0,
        -81
      ],
      [
        -3,
        -24
      ],
      [
        0,
        -19
      ],
      [
        13,
        -20
      ],
      [
        8,
        -44
      ],
      [
        2,
        -1
      ],
      [
        3,
        -31
      ],
      [
        -4,
        17
      ],
      [
        -10,
        9
      ],
      [
        -8,
        -10
      ],
      [
        -2,
        -39
      ],
      [
        -11,
        -41
      ],
      [
        -5,
        -2
      ],
      [
        -6,
        -22
      ],
      [
        -4,
        0
      ],
      [
        -7,
        -18
      ],
      [
        -9,
        -10
      ],
      [
        -5,
        -13
      ],
      [
        -21,
        -37
      ],
      [
        -9,
        -27
      ],
      [
        -10,
        -7
      ],
      [
        -6,
        -50
      ],
      [
        -4,
        -13
      ]
    ],
    [
      [
        18207,
        67657
      ],
      [
        -3,
        3
      ],
      [
        -2,
        33
      ],
      [
        -6,
        6
      ],
      [
        -2,
        23
      ],
      [
        -9,
        30
      ],
      [
        -8,
        -1
      ],
      [
        -2,
        26
      ],
      [
        -6,
        9
      ],
      [
        -5,
        21
      ],
      [
        -6,
        12
      ],
      [
        -3,
        30
      ],
      [
        -6,
        37
      ],
      [
        -7,
        9
      ],
      [
        -6,
        -13
      ],
      [
        0,
        -18
      ],
      [
        -5,
        -14
      ],
      [
        -13,
        7
      ],
      [
        -6,
        18
      ],
      [
        -1,
        21
      ],
      [
        -5,
        0
      ],
      [
        -6,
        18
      ],
      [
        -17,
        25
      ],
      [
        -9,
        23
      ],
      [
        -3,
        35
      ],
      [
        2,
        21
      ],
      [
        -4,
        10
      ],
      [
        -14,
        3
      ],
      [
        -5,
        -19
      ],
      [
        -14,
        25
      ],
      [
        -5,
        -4
      ],
      [
        -4,
        6
      ],
      [
        -9,
        -1
      ],
      [
        -3,
        10
      ],
      [
        -6,
        -7
      ],
      [
        -3,
        -31
      ],
      [
        1,
        -10
      ],
      [
        -4,
        -21
      ],
      [
        -9,
        -1
      ],
      [
        -6,
        8
      ],
      [
        0,
        27
      ],
      [
        -6,
        22
      ],
      [
        -8,
        10
      ],
      [
        -3,
        14
      ],
      [
        -10,
        16
      ],
      [
        -37,
        0
      ],
      [
        0,
        76
      ],
      [
        -17,
        0
      ],
      [
        -16,
        -29
      ],
      [
        -2,
        -18
      ],
      [
        -9,
        -17
      ]
    ],
    [
      [
        17880,
        68087
      ],
      [
        -2,
        10
      ],
      [
        -4,
        3
      ]
    ],
    [
      [
        17874,
        68100
      ],
      [
        7,
        38
      ],
      [
        -5,
        8
      ],
      [
        1,
        26
      ],
      [
        -5,
        11
      ],
      [
        -2,
        -9
      ],
      [
        -7,
        8
      ],
      [
        -5,
        21
      ],
      [
        2,
        24
      ],
      [
        6,
        25
      ],
      [
        6,
        7
      ],
      [
        0,
        14
      ],
      [
        -6,
        0
      ],
      [
        -7,
        26
      ],
      [
        5,
        8
      ],
      [
        3,
        16
      ],
      [
        -2,
        17
      ],
      [
        -7,
        11
      ],
      [
        -3,
        -6
      ],
      [
        -6,
        19
      ],
      [
        -7,
        -7
      ],
      [
        -6,
        26
      ],
      [
        -4,
        -3
      ],
      [
        -7,
        15
      ],
      [
        2,
        13
      ],
      [
        -4,
        25
      ],
      [
        4,
        5
      ],
      [
        -2,
        50
      ],
      [
        -3,
        16
      ],
      [
        -7,
        -16
      ],
      [
        -2,
        25
      ],
      [
        -7,
        5
      ],
      [
        -3,
        -14
      ],
      [
        -1,
        17
      ],
      [
        -10,
        16
      ],
      [
        -2,
        17
      ]
    ],
    [
      [
        17790,
        68554
      ],
      [
        0,
        4
      ],
      [
        1,
        2
      ],
      [
        2,
        6
      ],
      [
        -1,
        5
      ],
      [
        2,
        4
      ],
      [
        2,
        5
      ],
      [
        3,
        8
      ],
      [
        1,
        12
      ],
      [
        3,
        9
      ],
      [
        2,
        22
      ],
      [
        2,
        8
      ],
      [
        1,
        16
      ],
      [
        0,
        31
      ],
      [
        -1,
        3
      ],
      [
        1,
        5
      ],
      [
        1,
        1
      ],
      [
        0,
        6
      ],
      [
        -1,
        0
      ],
      [
        -1,
        3
      ],
      [
        0,
        3
      ],
      [
        2,
        5
      ],
      [
        0,
        8
      ],
      [
        -1,
        6
      ],
      [
        -1,
        6
      ],
      [
        -1,
        5
      ],
      [
        -1,
        5
      ],
      [
        0,
        13
      ],
      [
        -2,
        4
      ],
      [
        0,
        4
      ],
      [
        -2,
        0
      ],
      [
        0,
        -2
      ],
      [
        -3,
        1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        2
      ],
      [
        0,
        4
      ],
      [
        -1,
        7
      ],
      [
        -1,
        2
      ],
      [
        -1,
        6
      ],
      [
        1,
        6
      ],
      [
        -1,
        5
      ],
      [
        0,
        4
      ],
      [
        -1,
        2
      ],
      [
        0,
        6
      ],
      [
        -1,
        9
      ],
      [
        0,
        6
      ],
      [
        -1,
        7
      ],
      [
        0,
        7
      ],
      [
        2,
        7
      ],
      [
        1,
        8
      ],
      [
        2,
        8
      ],
      [
        1,
        6
      ],
      [
        0,
        3
      ],
      [
        3,
        3
      ],
      [
        1,
        -4
      ],
      [
        2,
        -2
      ],
      [
        0,
        2
      ],
      [
        1,
        2
      ],
      [
        0,
        7
      ],
      [
        2,
        3
      ],
      [
        4,
        4
      ],
      [
        2,
        -3
      ],
      [
        2,
        0
      ],
      [
        -1,
        6
      ],
      [
        0,
        4
      ],
      [
        1,
        4
      ],
      [
        1,
        -2
      ],
      [
        2,
        -3
      ],
      [
        2,
        0
      ],
      [
        1,
        -2
      ],
      [
        1,
        4
      ],
      [
        0,
        5
      ],
      [
        3,
        6
      ],
      [
        1,
        3
      ],
      [
        0,
        4
      ],
      [
        2,
        3
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        1,
        8
      ],
      [
        0,
        9
      ],
      [
        1,
        7
      ],
      [
        2,
        6
      ],
      [
        0,
        7
      ],
      [
        1,
        8
      ],
      [
        1,
        10
      ],
      [
        -1,
        5
      ],
      [
        3,
        16
      ],
      [
        -1,
        7
      ],
      [
        -2,
        4
      ],
      [
        0,
        8
      ],
      [
        1,
        4
      ],
      [
        3,
        13
      ],
      [
        4,
        9
      ],
      [
        3,
        7
      ],
      [
        4,
        7
      ],
      [
        2,
        7
      ],
      [
        3,
        0
      ],
      [
        1,
        -3
      ],
      [
        2,
        -9
      ],
      [
        1,
        -4
      ],
      [
        2,
        0
      ],
      [
        3,
        -4
      ],
      [
        3,
        -7
      ],
      [
        0,
        -6
      ],
      [
        2,
        -6
      ],
      [
        1,
        5
      ],
      [
        2,
        2
      ],
      [
        1,
        -4
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -5
      ],
      [
        1,
        -10
      ],
      [
        0,
        -5
      ],
      [
        3,
        1
      ],
      [
        1,
        6
      ],
      [
        0,
        4
      ],
      [
        1,
        4
      ],
      [
        2,
        0
      ],
      [
        1,
        2
      ],
      [
        2,
        -1
      ],
      [
        2,
        -5
      ],
      [
        2,
        -2
      ],
      [
        2,
        -3
      ],
      [
        3,
        2
      ],
      [
        0,
        6
      ],
      [
        1,
        4
      ],
      [
        3,
        2
      ],
      [
        2,
        5
      ],
      [
        1,
        2
      ],
      [
        1,
        5
      ],
      [
        0,
        7
      ],
      [
        1,
        5
      ],
      [
        1,
        4
      ],
      [
        1,
        0
      ],
      [
        1,
        2
      ],
      [
        2,
        4
      ],
      [
        2,
        9
      ],
      [
        2,
        6
      ],
      [
        3,
        5
      ],
      [
        2,
        3
      ],
      [
        2,
        3
      ],
      [
        0,
        -1
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        2,
        2
      ],
      [
        1,
        9
      ],
      [
        1,
        4
      ],
      [
        2,
        1
      ],
      [
        1,
        3
      ],
      [
        1,
        2
      ],
      [
        2,
        2
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        26280,
        53609
      ],
      [
        4,
        16
      ],
      [
        -4,
        39
      ],
      [
        6,
        20
      ],
      [
        -5,
        1
      ],
      [
        0,
        63
      ]
    ],
    [
      [
        26281,
        53748
      ],
      [
        45,
        0
      ],
      [
        2,
        27
      ],
      [
        7,
        -6
      ],
      [
        0,
        -11
      ],
      [
        5,
        -1
      ],
      [
        2,
        11
      ],
      [
        0,
        -19
      ],
      [
        3,
        0
      ],
      [
        3,
        19
      ],
      [
        0,
        -19
      ],
      [
        2,
        9
      ],
      [
        6,
        -9
      ]
    ],
    [
      [
        26356,
        53749
      ],
      [
        26,
        0
      ],
      [
        1,
        1
      ]
    ],
    [
      [
        26383,
        53750
      ],
      [
        1,
        -20
      ],
      [
        -3,
        -21
      ],
      [
        1,
        -45
      ],
      [
        2,
        -4
      ],
      [
        4,
        -43
      ],
      [
        6,
        -59
      ],
      [
        -5,
        -24
      ]
    ],
    [
      [
        26389,
        53534
      ],
      [
        -5,
        0
      ],
      [
        3,
        6
      ],
      [
        -3,
        15
      ],
      [
        -6,
        -7
      ],
      [
        0,
        -11
      ],
      [
        -6,
        -4
      ],
      [
        0,
        -9
      ],
      [
        -16,
        5
      ],
      [
        -25,
        2
      ]
    ],
    [
      [
        26331,
        53531
      ],
      [
        -42,
        3
      ],
      [
        0,
        17
      ],
      [
        -5,
        26
      ],
      [
        3,
        0
      ],
      [
        0,
        33
      ],
      [
        -3,
        -12
      ],
      [
        -4,
        0
      ],
      [
        0,
        11
      ]
    ],
    [
      [
        23237,
        66484
      ],
      [
        99,
        1
      ]
    ],
    [
      [
        23336,
        66485
      ],
      [
        0,
        -102
      ],
      [
        18,
        0
      ],
      [
        0,
        -307
      ]
    ],
    [
      [
        23354,
        66076
      ],
      [
        -97,
        1
      ]
    ],
    [
      [
        23257,
        66077
      ],
      [
        1,
        306
      ],
      [
        -21,
        1
      ],
      [
        0,
        100
      ]
    ],
    [
      [
        20186,
        60983
      ],
      [
        30,
        -1
      ],
      [
        0,
        -101
      ],
      [
        153,
        1
      ]
    ],
    [
      [
        20369,
        60882
      ],
      [
        -1,
        -405
      ]
    ],
    [
      [
        20181,
        60481
      ],
      [
        0,
        303
      ],
      [
        5,
        0
      ],
      [
        0,
        199
      ]
    ],
    [
      [
        23910,
        65258
      ],
      [
        95,
        0
      ],
      [
        32,
        1
      ]
    ],
    [
      [
        24037,
        64854
      ],
      [
        -63,
        0
      ]
    ],
    [
      [
        23974,
        64854
      ],
      [
        -64,
        0
      ]
    ],
    [
      [
        23910,
        65238
      ],
      [
        0,
        20
      ]
    ],
    [
      [
        21053,
        64112
      ],
      [
        32,
        0
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        21019,
        63504
      ],
      [
        -124,
        0
      ]
    ],
    [
      [
        20895,
        63504
      ],
      [
        0,
        609
      ],
      [
        158,
        -1
      ]
    ],
    [
      [
        24066,
        65671
      ],
      [
        131,
        0
      ]
    ],
    [
      [
        24197,
        65671
      ],
      [
        -1,
        -101
      ],
      [
        1,
        -310
      ]
    ],
    [
      [
        24197,
        65260
      ],
      [
        -32,
        0
      ]
    ],
    [
      [
        24069,
        65259
      ],
      [
        0,
        108
      ],
      [
        -3,
        0
      ],
      [
        0,
        304
      ]
    ],
    [
      [
        24873,
        64100
      ],
      [
        16,
        33
      ],
      [
        12,
        14
      ],
      [
        9,
        -3
      ],
      [
        13,
        11
      ],
      [
        4,
        -8
      ],
      [
        5,
        16
      ],
      [
        1,
        15
      ],
      [
        -1,
        25
      ],
      [
        6,
        25
      ],
      [
        8,
        34
      ],
      [
        -2,
        14
      ],
      [
        7,
        24
      ],
      [
        9,
        18
      ],
      [
        1,
        4
      ],
      [
        0,
        3
      ],
      [
        2,
        16
      ],
      [
        -2,
        32
      ]
    ],
    [
      [
        24961,
        64373
      ],
      [
        63,
        1
      ],
      [
        0,
        -155
      ],
      [
        16,
        1
      ],
      [
        1,
        -26
      ]
    ],
    [
      [
        25041,
        64194
      ],
      [
        0,
        -126
      ],
      [
        1,
        -187
      ]
    ],
    [
      [
        24948,
        63875
      ],
      [
        -32,
        -1
      ],
      [
        0,
        136
      ],
      [
        -31,
        -2
      ],
      [
        -27,
        2
      ]
    ],
    [
      [
        24858,
        64010
      ],
      [
        4,
        11
      ],
      [
        6,
        32
      ],
      [
        1,
        23
      ],
      [
        1,
        15
      ],
      [
        3,
        9
      ]
    ],
    [
      [
        20752,
        62997
      ],
      [
        6,
        0
      ],
      [
        258,
        1
      ]
    ],
    [
      [
        21016,
        62998
      ],
      [
        -2,
        -510
      ],
      [
        1,
        -304
      ],
      [
        -94,
        2
      ]
    ],
    [
      [
        20921,
        62186
      ],
      [
        1,
        302
      ],
      [
        -139,
        1
      ],
      [
        -31,
        0
      ]
    ],
    [
      [
        20752,
        62489
      ],
      [
        0,
        508
      ]
    ],
    [
      [
        23807,
        65672
      ],
      [
        32,
        0
      ],
      [
        65,
        -1
      ]
    ],
    [
      [
        23904,
        65671
      ],
      [
        0,
        -305
      ],
      [
        6,
        0
      ],
      [
        0,
        -108
      ]
    ],
    [
      [
        23781,
        65263
      ],
      [
        0,
        103
      ],
      [
        -7,
        0
      ],
      [
        0,
        306
      ]
    ],
    [
      [
        26388,
        63915
      ],
      [
        0,
        28
      ],
      [
        26,
        1
      ],
      [
        0,
        119
      ],
      [
        94,
        2
      ]
    ],
    [
      [
        26508,
        64065
      ],
      [
        0,
        -104
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -90
      ],
      [
        -2,
        5
      ],
      [
        -1,
        -51
      ]
    ],
    [
      [
        26505,
        63821
      ],
      [
        -3,
        -104
      ]
    ],
    [
      [
        26502,
        63717
      ],
      [
        -54,
        18
      ],
      [
        -23,
        -2
      ],
      [
        -37,
        -1
      ]
    ],
    [
      [
        26388,
        63732
      ],
      [
        0,
        183
      ]
    ],
    [
      [
        23655,
        65253
      ],
      [
        96,
        -1
      ],
      [
        30,
        11
      ]
    ],
    [
      [
        23781,
        64855
      ],
      [
        -30,
        -6
      ],
      [
        -32,
        0
      ]
    ],
    [
      [
        27154,
        64989
      ],
      [
        4,
        0
      ],
      [
        22,
        1
      ],
      [
        7,
        0
      ],
      [
        -2,
        29
      ],
      [
        -4,
        7
      ],
      [
        0,
        40
      ],
      [
        -3,
        9
      ],
      [
        17,
        0
      ],
      [
        5,
        -1
      ],
      [
        19,
        -1
      ],
      [
        16,
        -1
      ]
    ],
    [
      [
        27235,
        65072
      ],
      [
        0,
        -419
      ]
    ],
    [
      [
        27235,
        64653
      ],
      [
        -7,
        0
      ],
      [
        -1,
        -95
      ],
      [
        -32,
        4
      ],
      [
        -31,
        5
      ]
    ],
    [
      [
        27164,
        64567
      ],
      [
        0,
        86
      ],
      [
        -11,
        0
      ]
    ],
    [
      [
        27051,
        49122
      ],
      [
        137,
        1
      ]
    ],
    [
      [
        27188,
        49123
      ],
      [
        -1,
        -357
      ]
    ],
    [
      [
        27050,
        48764
      ],
      [
        1,
        358
      ]
    ],
    [
      [
        26285,
        64654
      ],
      [
        112,
        1
      ]
    ],
    [
      [
        26397,
        64655
      ],
      [
        1,
        -101
      ],
      [
        16,
        0
      ],
      [
        0,
        -51
      ]
    ],
    [
      [
        26414,
        64503
      ],
      [
        0,
        -50
      ],
      [
        -16,
        -1
      ],
      [
        0,
        -152
      ]
    ],
    [
      [
        26398,
        64300
      ],
      [
        -16,
        0
      ]
    ],
    [
      [
        26382,
        64300
      ],
      [
        0,
        50
      ],
      [
        -97,
        0
      ]
    ],
    [
      [
        26285,
        64350
      ],
      [
        0,
        227
      ]
    ],
    [
      [
        26285,
        64577
      ],
      [
        0,
        77
      ]
    ],
    [
      [
        26407,
        63025
      ],
      [
        22,
        -1
      ],
      [
        48,
        -13
      ]
    ],
    [
      [
        26515,
        63001
      ],
      [
        -8,
        -366
      ]
    ],
    [
      [
        26507,
        62635
      ],
      [
        -71,
        19
      ]
    ],
    [
      [
        26436,
        62654
      ],
      [
        1,
        3
      ],
      [
        0,
        3
      ],
      [
        -1,
        14
      ],
      [
        -20,
        6
      ],
      [
        -6,
        -1
      ]
    ],
    [
      [
        26410,
        62679
      ],
      [
        4,
        140
      ],
      [
        1,
        50
      ],
      [
        -1,
        21
      ],
      [
        1,
        10
      ],
      [
        0,
        17
      ],
      [
        1,
        60
      ],
      [
        -9,
        -5
      ],
      [
        0,
        53
      ]
    ],
    [
      [
        22020,
        51423
      ],
      [
        27,
        1
      ]
    ],
    [
      [
        22047,
        51424
      ],
      [
        115,
        4
      ]
    ],
    [
      [
        22162,
        51428
      ],
      [
        53,
        0
      ]
    ],
    [
      [
        22215,
        51428
      ],
      [
        -1,
        -624
      ]
    ],
    [
      [
        22020,
        50798
      ],
      [
        0,
        625
      ]
    ],
    [
      [
        26675,
        56748
      ],
      [
        8,
        10
      ],
      [
        5,
        21
      ]
    ],
    [
      [
        26688,
        56779
      ],
      [
        12,
        41
      ],
      [
        4,
        6
      ],
      [
        7,
        -18
      ],
      [
        10,
        -3
      ],
      [
        10,
        2
      ],
      [
        8,
        -11
      ],
      [
        17,
        41
      ]
    ],
    [
      [
        26756,
        56837
      ],
      [
        -1,
        -14
      ],
      [
        11,
        -44
      ]
    ],
    [
      [
        26766,
        56779
      ],
      [
        -5,
        -25
      ],
      [
        -2,
        -34
      ],
      [
        2,
        -14
      ],
      [
        7,
        -8
      ],
      [
        6,
        -39
      ],
      [
        5,
        -9
      ],
      [
        -2,
        -16
      ],
      [
        13,
        -40
      ],
      [
        4,
        -25
      ]
    ],
    [
      [
        26794,
        56569
      ],
      [
        -7,
        -15
      ],
      [
        -8,
        0
      ],
      [
        -5,
        -17
      ],
      [
        -12,
        19
      ],
      [
        -3,
        -9
      ],
      [
        -6,
        27
      ],
      [
        -12,
        -16
      ],
      [
        -8,
        -28
      ],
      [
        -7,
        -11
      ],
      [
        -5,
        15
      ],
      [
        -6,
        -17
      ]
    ],
    [
      [
        26687,
        56565
      ],
      [
        -7,
        12
      ],
      [
        1,
        34
      ],
      [
        7,
        43
      ],
      [
        -1,
        37
      ],
      [
        -1,
        18
      ],
      [
        -4,
        9
      ],
      [
        -7,
        30
      ]
    ],
    [
      [
        27145,
        63680
      ],
      [
        13,
        -2
      ],
      [
        0,
        84
      ],
      [
        13,
        -2
      ]
    ],
    [
      [
        27171,
        63760
      ],
      [
        79,
        -8
      ]
    ],
    [
      [
        27282,
        63701
      ],
      [
        -3,
        -255
      ]
    ],
    [
      [
        27279,
        63446
      ],
      [
        -31,
        -2
      ],
      [
        -11,
        1
      ],
      [
        0,
        -34
      ],
      [
        -21,
        3
      ],
      [
        -1,
        -34
      ],
      [
        -32,
        4
      ],
      [
        0,
        -69
      ],
      [
        -32,
        4
      ]
    ],
    [
      [
        27151,
        63319
      ],
      [
        1,
        103
      ],
      [
        -11,
        1
      ],
      [
        4,
        257
      ]
    ],
    [
      [
        22495,
        50831
      ],
      [
        22,
        111
      ],
      [
        52,
        265
      ],
      [
        2,
        5
      ]
    ],
    [
      [
        22571,
        51212
      ],
      [
        3,
        -73
      ],
      [
        3,
        -15
      ],
      [
        8,
        16
      ],
      [
        35,
        -2
      ],
      [
        33,
        -1
      ]
    ],
    [
      [
        22653,
        51137
      ],
      [
        -5,
        -28
      ],
      [
        36,
        -153
      ]
    ],
    [
      [
        22684,
        50956
      ],
      [
        -75,
        -228
      ],
      [
        -54,
        -167
      ]
    ],
    [
      [
        26781,
        64008
      ],
      [
        0,
        -18
      ],
      [
        27,
        -4
      ],
      [
        -1,
        -66
      ],
      [
        51,
        -10
      ]
    ],
    [
      [
        26857,
        63825
      ],
      [
        -3,
        -176
      ]
    ],
    [
      [
        26854,
        63649
      ],
      [
        -59,
        11
      ],
      [
        -9,
        1
      ],
      [
        -2,
        0
      ],
      [
        -1,
        1
      ],
      [
        -43,
        7
      ]
    ],
    [
      [
        26740,
        63669
      ],
      [
        -1,
        118
      ],
      [
        -21,
        0
      ],
      [
        0,
        232
      ]
    ],
    [
      [
        27236,
        65330
      ],
      [
        26,
        0
      ],
      [
        0,
        83
      ],
      [
        54,
        0
      ],
      [
        0,
        85
      ],
      [
        27,
        1
      ]
    ],
    [
      [
        27343,
        65499
      ],
      [
        1,
        -167
      ],
      [
        0,
        -81
      ]
    ],
    [
      [
        27344,
        65251
      ],
      [
        0,
        -179
      ]
    ],
    [
      [
        27344,
        65072
      ],
      [
        -109,
        0
      ]
    ],
    [
      [
        27235,
        65072
      ],
      [
        0,
        89
      ],
      [
        5,
        0
      ],
      [
        0,
        24
      ],
      [
        -5,
        0
      ],
      [
        1,
        145
      ]
    ],
    [
      [
        22216,
        57816
      ],
      [
        3,
        -23
      ],
      [
        8,
        -8
      ],
      [
        1,
        -33
      ],
      [
        4,
        -19
      ],
      [
        6,
        -2
      ],
      [
        0,
        -24
      ],
      [
        -2,
        -38
      ],
      [
        -3,
        -6
      ],
      [
        3,
        -12
      ],
      [
        1,
        -33
      ],
      [
        9,
        -24
      ],
      [
        3,
        -25
      ],
      [
        -1,
        -19
      ],
      [
        -6,
        -1
      ],
      [
        -1,
        -16
      ],
      [
        3,
        -16
      ],
      [
        7,
        -10
      ],
      [
        1,
        -12
      ],
      [
        6,
        -3
      ],
      [
        3,
        -17
      ]
    ],
    [
      [
        22261,
        57475
      ],
      [
        -1,
        -11
      ],
      [
        -44,
        1
      ],
      [
        1,
        -52
      ],
      [
        -9,
        1
      ],
      [
        0,
        -38
      ],
      [
        -2,
        -8
      ],
      [
        6,
        -5
      ],
      [
        -68,
        -1
      ]
    ],
    [
      [
        22144,
        57362
      ],
      [
        0,
        34
      ],
      [
        -5,
        0
      ],
      [
        0,
        17
      ],
      [
        -10,
        0
      ],
      [
        0,
        103
      ],
      [
        -1,
        0
      ],
      [
        -2,
        101
      ],
      [
        -44,
        0
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        23855,
        68792
      ],
      [
        68,
        0
      ]
    ],
    [
      [
        23923,
        68792
      ],
      [
        0,
        -84
      ],
      [
        67,
        0
      ]
    ],
    [
      [
        23990,
        68708
      ],
      [
        0,
        -320
      ]
    ],
    [
      [
        23990,
        68388
      ],
      [
        -2,
        0
      ]
    ],
    [
      [
        23988,
        68388
      ],
      [
        -67,
        0
      ],
      [
        -33,
        -1
      ]
    ],
    [
      [
        23888,
        68387
      ],
      [
        -33,
        0
      ]
    ],
    [
      [
        23855,
        68387
      ],
      [
        0,
        405
      ]
    ],
    [
      [
        24186,
        56588
      ],
      [
        29,
        3
      ]
    ],
    [
      [
        24215,
        56591
      ],
      [
        45,
        1
      ],
      [
        23,
        1
      ],
      [
        10,
        0
      ]
    ],
    [
      [
        24293,
        56593
      ],
      [
        0,
        -101
      ],
      [
        -7,
        0
      ],
      [
        0,
        -216
      ]
    ],
    [
      [
        24286,
        56276
      ],
      [
        1,
        -102
      ]
    ],
    [
      [
        24287,
        56174
      ],
      [
        -59,
        1
      ],
      [
        -28,
        0
      ],
      [
        -12,
        3
      ]
    ],
    [
      [
        24188,
        56178
      ],
      [
        -3,
        41
      ],
      [
        4,
        41
      ],
      [
        -2,
        20
      ]
    ],
    [
      [
        24187,
        56280
      ],
      [
        -1,
        38
      ],
      [
        -5,
        29
      ],
      [
        -7,
        19
      ],
      [
        -4,
        20
      ],
      [
        -2,
        32
      ],
      [
        -5,
        29
      ],
      [
        -10,
        39
      ],
      [
        -6,
        0
      ],
      [
        1,
        99
      ],
      [
        38,
        3
      ]
    ],
    [
      [
        26501,
        54389
      ],
      [
        -1,
        9
      ],
      [
        5,
        27
      ],
      [
        7,
        18
      ],
      [
        6,
        36
      ],
      [
        19,
        38
      ],
      [
        1,
        13
      ],
      [
        13,
        -1
      ]
    ],
    [
      [
        26551,
        54529
      ],
      [
        36,
        -1
      ],
      [
        5,
        -9
      ],
      [
        0,
        9
      ],
      [
        24,
        -2
      ]
    ],
    [
      [
        26616,
        54526
      ],
      [
        2,
        0
      ],
      [
        0,
        -198
      ]
    ],
    [
      [
        26618,
        54328
      ],
      [
        -1,
        -105
      ]
    ],
    [
      [
        26617,
        54223
      ],
      [
        -98,
        3
      ]
    ],
    [
      [
        22019,
        53128
      ],
      [
        0,
        -439
      ]
    ],
    [
      [
        21783,
        52684
      ],
      [
        0,
        438
      ]
    ],
    [
      [
        23483,
        68285
      ],
      [
        34,
        1
      ],
      [
        103,
        -1
      ]
    ],
    [
      [
        23620,
        68285
      ],
      [
        0,
        -303
      ]
    ],
    [
      [
        23620,
        67982
      ],
      [
        -135,
        0
      ]
    ],
    [
      [
        23485,
        67982
      ],
      [
        -2,
        0
      ]
    ],
    [
      [
        22406,
        64306
      ],
      [
        1,
        10
      ]
    ],
    [
      [
        22407,
        64316
      ],
      [
        122,
        -1
      ]
    ],
    [
      [
        22529,
        64315
      ],
      [
        2,
        0
      ]
    ],
    [
      [
        22531,
        63910
      ],
      [
        -125,
        1
      ]
    ],
    [
      [
        22406,
        63911
      ],
      [
        0,
        395
      ]
    ],
    [
      [
        27253,
        58842
      ],
      [
        7,
        9
      ],
      [
        11,
        25
      ],
      [
        5,
        -1
      ],
      [
        15,
        15
      ],
      [
        7,
        -14
      ],
      [
        9,
        13
      ],
      [
        10,
        -10
      ],
      [
        11,
        4
      ],
      [
        8,
        17
      ]
    ],
    [
      [
        27336,
        58900
      ],
      [
        8,
        -57
      ],
      [
        -1,
        -45
      ],
      [
        -10,
        -117
      ],
      [
        -3,
        -15
      ],
      [
        -8,
        -49
      ],
      [
        -8,
        -31
      ]
    ],
    [
      [
        27314,
        58586
      ],
      [
        -5,
        15
      ],
      [
        -4,
        45
      ],
      [
        -14,
        -6
      ],
      [
        -10,
        -15
      ],
      [
        -6,
        7
      ],
      [
        -2,
        -9
      ],
      [
        -12,
        -11
      ],
      [
        -10,
        -3
      ]
    ],
    [
      [
        27251,
        58609
      ],
      [
        -2,
        33
      ],
      [
        3,
        64
      ],
      [
        -3,
        51
      ],
      [
        4,
        85
      ]
    ],
    [
      [
        23702,
        60755
      ],
      [
        0,
        17
      ],
      [
        1,
        118
      ],
      [
        -1,
        0
      ],
      [
        2,
        169
      ]
    ],
    [
      [
        23826,
        60976
      ],
      [
        0,
        -38
      ],
      [
        -1,
        -63
      ],
      [
        6,
        -1
      ],
      [
        -1,
        -129
      ],
      [
        0,
        -68
      ]
    ],
    [
      [
        23830,
        60677
      ],
      [
        -128,
        10
      ]
    ],
    [
      [
        21494,
        57389
      ],
      [
        103,
        0
      ]
    ],
    [
      [
        21641,
        56882
      ],
      [
        -26,
        0
      ]
    ],
    [
      [
        21494,
        56883
      ],
      [
        0,
        506
      ]
    ],
    [
      [
        18433,
        72761
      ],
      [
        1,
        -1
      ],
      [
        1,
        -12
      ],
      [
        1,
        -18
      ],
      [
        0,
        -13
      ],
      [
        2,
        -6
      ],
      [
        3,
        -3
      ],
      [
        2,
        -12
      ],
      [
        0,
        -15
      ],
      [
        1,
        -11
      ],
      [
        1,
        -5
      ],
      [
        1,
        -6
      ],
      [
        3,
        -6
      ],
      [
        0,
        -9
      ],
      [
        1,
        -5
      ],
      [
        0,
        -6
      ],
      [
        2,
        -6
      ],
      [
        0,
        -7
      ],
      [
        1,
        -9
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -31
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -16
      ],
      [
        -1,
        -10
      ],
      [
        2,
        -9
      ],
      [
        1,
        -13
      ],
      [
        2,
        -6
      ],
      [
        1,
        -7
      ],
      [
        0,
        -28
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -11
      ],
      [
        1,
        -4
      ],
      [
        1,
        -7
      ],
      [
        2,
        -6
      ],
      [
        1,
        -4
      ],
      [
        2,
        -11
      ],
      [
        2,
        -6
      ],
      [
        1,
        -9
      ],
      [
        2,
        -6
      ],
      [
        2,
        -10
      ],
      [
        1,
        -9
      ],
      [
        3,
        -3
      ],
      [
        1,
        -5
      ],
      [
        2,
        -5
      ],
      [
        2,
        -7
      ],
      [
        3,
        -6
      ],
      [
        2,
        2
      ],
      [
        2,
        1
      ],
      [
        3,
        -9
      ],
      [
        3,
        -5
      ],
      [
        4,
        0
      ],
      [
        2,
        4
      ],
      [
        0,
        4
      ],
      [
        2,
        2
      ],
      [
        1,
        1
      ],
      [
        2,
        2
      ],
      [
        2,
        4
      ],
      [
        2,
        5
      ],
      [
        2,
        -2
      ],
      [
        3,
        4
      ],
      [
        2,
        2
      ],
      [
        1,
        1
      ],
      [
        2,
        -3
      ],
      [
        0,
        -3
      ],
      [
        2,
        -2
      ],
      [
        1,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        3
      ],
      [
        1,
        1
      ],
      [
        2,
        -4
      ],
      [
        1,
        1
      ],
      [
        0,
        3
      ],
      [
        2,
        1
      ],
      [
        1,
        -1
      ],
      [
        3,
        1
      ],
      [
        1,
        5
      ],
      [
        2,
        0
      ],
      [
        1,
        4
      ],
      [
        1,
        4
      ],
      [
        3,
        2
      ],
      [
        2,
        -2
      ],
      [
        1,
        -1
      ],
      [
        3,
        2
      ],
      [
        4,
        0
      ],
      [
        3,
        3
      ],
      [
        1,
        3
      ],
      [
        0,
        3
      ],
      [
        1,
        5
      ],
      [
        1,
        5
      ],
      [
        1,
        1
      ],
      [
        2,
        -2
      ],
      [
        0,
        -3
      ],
      [
        1,
        -1
      ],
      [
        2,
        -4
      ],
      [
        2,
        -2
      ],
      [
        2,
        0
      ],
      [
        0,
        -10
      ],
      [
        1,
        -5
      ],
      [
        0,
        -5
      ],
      [
        1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        2,
        2
      ],
      [
        1,
        -4
      ],
      [
        0,
        -2
      ],
      [
        2,
        -3
      ],
      [
        2,
        2
      ],
      [
        2,
        -1
      ],
      [
        3,
        -3
      ],
      [
        3,
        -2
      ],
      [
        4,
        -4
      ],
      [
        2,
        0
      ],
      [
        1,
        -4
      ],
      [
        2,
        -4
      ],
      [
        1,
        -8
      ],
      [
        1,
        -6
      ],
      [
        -1,
        -6
      ],
      [
        2,
        -6
      ],
      [
        1,
        1
      ],
      [
        1,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        1,
        -6
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -5
      ],
      [
        5,
        0
      ],
      [
        2,
        -4
      ],
      [
        2,
        -2
      ],
      [
        4,
        3
      ],
      [
        2,
        1
      ],
      [
        2,
        -1
      ],
      [
        0,
        -9
      ],
      [
        2,
        -2
      ],
      [
        1,
        2
      ],
      [
        2,
        1
      ],
      [
        2,
        -2
      ],
      [
        2,
        -6
      ],
      [
        1,
        -9
      ],
      [
        1,
        -3
      ],
      [
        3,
        -4
      ],
      [
        2,
        -8
      ],
      [
        1,
        -6
      ],
      [
        1,
        -4
      ],
      [
        4,
        2
      ],
      [
        4,
        2
      ],
      [
        2,
        -4
      ],
      [
        3,
        0
      ],
      [
        2,
        1
      ],
      [
        3,
        0
      ],
      [
        0,
        -5
      ],
      [
        2,
        -1
      ],
      [
        1,
        4
      ],
      [
        3,
        1
      ],
      [
        2,
        5
      ],
      [
        3,
        2
      ],
      [
        1,
        -3
      ],
      [
        2,
        1
      ],
      [
        3,
        2
      ],
      [
        1,
        2
      ],
      [
        1,
        2
      ],
      [
        2,
        -2
      ],
      [
        2,
        -2
      ],
      [
        3,
        -2
      ],
      [
        1,
        -4
      ],
      [
        2,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        3,
        0
      ],
      [
        1,
        5
      ],
      [
        3,
        0
      ],
      [
        1,
        -3
      ],
      [
        2,
        1
      ],
      [
        1,
        4
      ],
      [
        3,
        -2
      ],
      [
        1,
        1
      ]
    ],
    [
      [
        18694,
        72252
      ],
      [
        1,
        -376
      ],
      [
        5,
        7
      ],
      [
        5,
        -10
      ],
      [
        0,
        -13
      ],
      [
        4,
        7
      ],
      [
        5,
        -2
      ],
      [
        -1,
        -12
      ],
      [
        5,
        -5
      ],
      [
        6,
        -30
      ],
      [
        6,
        -9
      ],
      [
        7,
        0
      ],
      [
        0,
        -14
      ],
      [
        1,
        -3
      ],
      [
        5,
        9
      ],
      [
        23,
        0
      ],
      [
        0,
        -250
      ],
      [
        37,
        -1
      ]
    ],
    [
      [
        18803,
        71550
      ],
      [
        9,
        -12
      ],
      [
        5,
        -12
      ],
      [
        0,
        -16
      ],
      [
        -9,
        -16
      ],
      [
        1,
        -16
      ],
      [
        -3,
        -9
      ],
      [
        2,
        -13
      ],
      [
        3,
        0
      ],
      [
        8,
        -29
      ],
      [
        7,
        3
      ],
      [
        12,
        -7
      ],
      [
        2,
        15
      ],
      [
        8,
        -31
      ],
      [
        0,
        -32
      ]
    ],
    [
      [
        18848,
        71375
      ],
      [
        -3,
        -4
      ],
      [
        -10,
        11
      ],
      [
        -5,
        -3
      ],
      [
        -2,
        12
      ],
      [
        -5,
        6
      ],
      [
        -5,
        -4
      ],
      [
        -6,
        -37
      ],
      [
        -4,
        -10
      ],
      [
        0,
        -181
      ],
      [
        2,
        -15
      ],
      [
        -43,
        0
      ]
    ],
    [
      [
        18767,
        71150
      ],
      [
        -8,
        0
      ],
      [
        -57,
        -1
      ],
      [
        -4,
        -3
      ],
      [
        0,
        -27
      ],
      [
        -3,
        -11
      ],
      [
        -11,
        -20
      ],
      [
        -10,
        -2
      ],
      [
        -4,
        9
      ],
      [
        -5,
        -12
      ],
      [
        -9,
        -13
      ],
      [
        -6,
        -1
      ],
      [
        1,
        -24
      ],
      [
        7,
        -10
      ],
      [
        1,
        -17
      ],
      [
        -4,
        -7
      ],
      [
        -7,
        0
      ],
      [
        -2,
        -16
      ],
      [
        -6,
        -16
      ],
      [
        -7,
        -9
      ],
      [
        -5,
        8
      ],
      [
        -7,
        -1
      ]
    ],
    [
      [
        18621,
        70977
      ],
      [
        -3,
        14
      ],
      [
        0,
        12
      ],
      [
        5,
        8
      ],
      [
        1,
        46
      ],
      [
        -2,
        24
      ],
      [
        4,
        9
      ],
      [
        0,
        15
      ],
      [
        -4,
        21
      ],
      [
        -3,
        30
      ],
      [
        7,
        35
      ],
      [
        -1,
        16
      ],
      [
        -7,
        44
      ],
      [
        -25,
        0
      ],
      [
        0,
        50
      ],
      [
        -35,
        0
      ],
      [
        0,
        157
      ],
      [
        -37,
        -3
      ],
      [
        -35,
        0
      ],
      [
        0,
        402
      ],
      [
        -73,
        3
      ],
      [
        0,
        359
      ],
      [
        -9,
        -9
      ],
      [
        -7,
        12
      ],
      [
        -2,
        29
      ],
      [
        -1,
        50
      ],
      [
        2,
        14
      ],
      [
        -7,
        29
      ]
    ],
    [
      [
        18389,
        72344
      ],
      [
        -1,
        14
      ],
      [
        3,
        15
      ],
      [
        -2,
        20
      ],
      [
        3,
        2
      ],
      [
        1,
        26
      ],
      [
        -5,
        18
      ],
      [
        -5,
        50
      ],
      [
        0,
        12
      ],
      [
        8,
        18
      ],
      [
        4,
        -5
      ],
      [
        8,
        3
      ],
      [
        4,
        7
      ],
      [
        -1,
        27
      ],
      [
        5,
        4
      ],
      [
        1,
        37
      ],
      [
        -2,
        24
      ],
      [
        3,
        16
      ],
      [
        0,
        33
      ],
      [
        -1,
        17
      ],
      [
        -9,
        12
      ],
      [
        2,
        26
      ],
      [
        6,
        8
      ],
      [
        12,
        2
      ],
      [
        2,
        17
      ],
      [
        8,
        14
      ]
    ],
    [
      [
        23859,
        61822
      ],
      [
        1,
        144
      ],
      [
        0,
        17
      ],
      [
        2,
        84
      ],
      [
        0,
        17
      ],
      [
        2,
        124
      ],
      [
        -2,
        13
      ],
      [
        1,
        34
      ]
    ],
    [
      [
        23863,
        62255
      ],
      [
        0,
        17
      ]
    ],
    [
      [
        23863,
        62272
      ],
      [
        62,
        -9
      ],
      [
        47,
        -4
      ],
      [
        15,
        -4
      ]
    ],
    [
      [
        23984,
        61981
      ],
      [
        0,
        -84
      ],
      [
        -2,
        -106
      ]
    ],
    [
      [
        23982,
        61791
      ],
      [
        -62,
        7
      ],
      [
        0,
        -34
      ],
      [
        -62,
        7
      ]
    ],
    [
      [
        23858,
        61771
      ],
      [
        1,
        51
      ]
    ],
    [
      [
        21761,
        56325
      ],
      [
        0,
        557
      ]
    ],
    [
      [
        18058,
        71256
      ],
      [
        140,
        0
      ]
    ],
    [
      [
        18198,
        71256
      ],
      [
        3,
        -27
      ],
      [
        4,
        -9
      ],
      [
        -3,
        -17
      ],
      [
        1,
        -30
      ],
      [
        -7,
        -6
      ],
      [
        2,
        -16
      ],
      [
        -4,
        -28
      ],
      [
        -1,
        -34
      ],
      [
        -9,
        -16
      ],
      [
        4,
        -13
      ],
      [
        4,
        -60
      ],
      [
        -2,
        -25
      ],
      [
        11,
        -14
      ],
      [
        1,
        -9
      ],
      [
        0,
        -3
      ],
      [
        2,
        -6
      ],
      [
        2,
        -8
      ],
      [
        1,
        -11
      ],
      [
        2,
        -5
      ],
      [
        1,
        -5
      ],
      [
        1,
        -5
      ],
      [
        -1,
        -11
      ],
      [
        0,
        -13
      ],
      [
        1,
        -11
      ],
      [
        1,
        -7
      ],
      [
        2,
        -8
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -6
      ],
      [
        1,
        -6
      ],
      [
        -1,
        -7
      ],
      [
        2,
        -4
      ],
      [
        4,
        -6
      ],
      [
        3,
        -4
      ],
      [
        1,
        -5
      ],
      [
        0,
        -7
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -14
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -6
      ],
      [
        1,
        -5
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        -3
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -8
      ],
      [
        1,
        -7
      ],
      [
        0,
        -5
      ],
      [
        2,
        -2
      ],
      [
        1,
        2
      ],
      [
        2,
        0
      ],
      [
        0,
        -4
      ],
      [
        1,
        -4
      ],
      [
        2,
        -3
      ],
      [
        1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -20
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -6
      ],
      [
        1,
        -3
      ],
      [
        2,
        -5
      ],
      [
        1,
        -2
      ],
      [
        0,
        -10
      ],
      [
        2,
        0
      ],
      [
        1,
        -5
      ],
      [
        1,
        -7
      ],
      [
        2,
        -6
      ],
      [
        1,
        -6
      ],
      [
        -2,
        -12
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -11
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -7
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -10
      ],
      [
        -3,
        -6
      ],
      [
        1,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        2,
        -5
      ],
      [
        1,
        0
      ],
      [
        3,
        -4
      ],
      [
        2,
        0
      ],
      [
        1,
        -4
      ],
      [
        2,
        1
      ],
      [
        1,
        3
      ],
      [
        1,
        7
      ],
      [
        0,
        4
      ],
      [
        1,
        6
      ],
      [
        2,
        2
      ],
      [
        1,
        -1
      ],
      [
        2,
        -7
      ],
      [
        1,
        -3
      ],
      [
        4,
        0
      ],
      [
        3,
        1
      ],
      [
        3,
        -3
      ],
      [
        2,
        -2
      ],
      [
        0,
        -8
      ],
      [
        1,
        -6
      ],
      [
        2,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -4
      ],
      [
        1,
        -5
      ],
      [
        0,
        -5
      ],
      [
        1,
        -8
      ],
      [
        0,
        -7
      ],
      [
        1,
        -8
      ],
      [
        0,
        -6
      ],
      [
        2,
        -5
      ],
      [
        2,
        -10
      ],
      [
        2,
        -4
      ],
      [
        4,
        4
      ],
      [
        2,
        3
      ],
      [
        1,
        1
      ],
      [
        1,
        -5
      ],
      [
        0,
        -11
      ],
      [
        1,
        -7
      ],
      [
        2,
        -3
      ],
      [
        2,
        2
      ],
      [
        2,
        -4
      ],
      [
        1,
        1
      ],
      [
        1,
        -3
      ],
      [
        1,
        -3
      ],
      [
        1,
        -4
      ],
      [
        1,
        2
      ],
      [
        2,
        2
      ],
      [
        2,
        4
      ],
      [
        2,
        1
      ],
      [
        1,
        -1
      ],
      [
        2,
        -1
      ],
      [
        2,
        0
      ],
      [
        2,
        -3
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ]
    ],
    [
      [
        18285,
        70417
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        18166,
        70122
      ],
      [
        -8,
        17
      ],
      [
        -4,
        4
      ],
      [
        -8,
        -10
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -27
      ],
      [
        2,
        -14
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -6
      ],
      [
        -4,
        0
      ],
      [
        -9,
        -24
      ],
      [
        -4,
        -19
      ],
      [
        -1,
        -9
      ],
      [
        1,
        -8
      ],
      [
        -2,
        -7
      ],
      [
        -3,
        -6
      ],
      [
        -7,
        -2
      ],
      [
        -2,
        -11
      ],
      [
        0,
        -3
      ],
      [
        1,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -9
      ],
      [
        -6,
        -5
      ],
      [
        -7,
        -2
      ],
      [
        -1,
        -7
      ],
      [
        -2,
        -10
      ],
      [
        -3,
        -2
      ],
      [
        -7,
        13
      ],
      [
        -6,
        -1
      ],
      [
        -1,
        -9
      ],
      [
        1,
        -5
      ],
      [
        0,
        -11
      ],
      [
        -3,
        -33
      ],
      [
        -3,
        -11
      ],
      [
        -2,
        -7
      ],
      [
        -15,
        -24
      ],
      [
        -4,
        0
      ],
      [
        -4,
        17
      ],
      [
        -1,
        19
      ],
      [
        -1,
        2
      ],
      [
        -6,
        12
      ],
      [
        -7,
        8
      ],
      [
        -7,
        31
      ],
      [
        -3,
        7
      ],
      [
        -2,
        2
      ],
      [
        -1,
        20
      ],
      [
        -4,
        3
      ],
      [
        -6,
        -9
      ],
      [
        -3,
        4
      ],
      [
        -3,
        10
      ],
      [
        -2,
        3
      ],
      [
        -7,
        -11
      ],
      [
        -2,
        5
      ]
    ],
    [
      [
        17995,
        69981
      ],
      [
        0,
        23
      ],
      [
        1,
        7
      ],
      [
        5,
        18
      ],
      [
        -2,
        12
      ],
      [
        -3,
        3
      ],
      [
        -2,
        14
      ],
      [
        -1,
        7
      ],
      [
        1,
        3
      ],
      [
        7,
        12
      ],
      [
        2,
        2
      ],
      [
        2,
        -3
      ],
      [
        4,
        11
      ],
      [
        2,
        12
      ],
      [
        1,
        40
      ],
      [
        0,
        8
      ],
      [
        -2,
        14
      ],
      [
        -9,
        19
      ],
      [
        -8,
        41
      ],
      [
        1,
        7
      ],
      [
        2,
        7
      ],
      [
        3,
        6
      ],
      [
        9,
        44
      ],
      [
        -2,
        5
      ],
      [
        0,
        3
      ],
      [
        1,
        6
      ],
      [
        2,
        5
      ],
      [
        2,
        6
      ],
      [
        8,
        1
      ],
      [
        5,
        4
      ],
      [
        1,
        5
      ],
      [
        8,
        -4
      ],
      [
        3,
        -5
      ],
      [
        6,
        36
      ],
      [
        1,
        8
      ],
      [
        -3,
        14
      ],
      [
        -2,
        3
      ],
      [
        -3,
        9
      ],
      [
        -5,
        28
      ],
      [
        0,
        3
      ],
      [
        1,
        2
      ],
      [
        1,
        5
      ],
      [
        3,
        4
      ],
      [
        1,
        6
      ],
      [
        2,
        4
      ],
      [
        0,
        13
      ],
      [
        -2,
        5
      ],
      [
        0,
        7
      ],
      [
        -3,
        4
      ],
      [
        -1,
        5
      ],
      [
        -4,
        4
      ],
      [
        -9,
        8
      ],
      [
        -2,
        6
      ],
      [
        0,
        10
      ],
      [
        1,
        8
      ],
      [
        -1,
        16
      ],
      [
        -2,
        0
      ],
      [
        -1,
        3
      ],
      [
        -1,
        5
      ],
      [
        0,
        12
      ],
      [
        7,
        18
      ],
      [
        2,
        18
      ],
      [
        0,
        22
      ],
      [
        -4,
        18
      ],
      [
        -4,
        1
      ],
      [
        -9,
        14
      ],
      [
        -1,
        24
      ],
      [
        3,
        25
      ],
      [
        7,
        0
      ],
      [
        3,
        -8
      ],
      [
        2,
        2
      ],
      [
        4,
        9
      ],
      [
        3,
        4
      ],
      [
        1,
        34
      ],
      [
        -1,
        20
      ],
      [
        -1,
        20
      ],
      [
        0,
        5
      ],
      [
        -5,
        9
      ],
      [
        -1,
        21
      ],
      [
        2,
        7
      ],
      [
        3,
        -3
      ],
      [
        4,
        4
      ],
      [
        1,
        3
      ],
      [
        2,
        8
      ],
      [
        1,
        5
      ],
      [
        -2,
        21
      ],
      [
        0,
        6
      ],
      [
        5,
        29
      ],
      [
        0,
        7
      ],
      [
        1,
        22
      ],
      [
        0,
        7
      ],
      [
        -3,
        24
      ],
      [
        4,
        15
      ],
      [
        6,
        13
      ],
      [
        3,
        37
      ],
      [
        -1,
        20
      ],
      [
        -1,
        7
      ],
      [
        -3,
        4
      ],
      [
        -2,
        8
      ],
      [
        -1,
        25
      ],
      [
        1,
        5
      ],
      [
        1,
        1
      ],
      [
        3,
        1
      ],
      [
        3,
        -3
      ],
      [
        5,
        4
      ],
      [
        1,
        3
      ],
      [
        3,
        14
      ],
      [
        -2,
        11
      ],
      [
        0,
        5
      ],
      [
        1,
        17
      ],
      [
        2,
        19
      ],
      [
        2,
        9
      ],
      [
        0,
        7
      ],
      [
        -1,
        5
      ],
      [
        0,
        11
      ],
      [
        4,
        22
      ],
      [
        -1,
        37
      ],
      [
        1,
        5
      ],
      [
        -1,
        8
      ],
      [
        -2,
        8
      ]
    ],
    [
      [
        17129,
        57476
      ],
      [
        10,
        -1
      ],
      [
        0,
        732
      ],
      [
        -1,
        132
      ],
      [
        0,
        102
      ],
      [
        5,
        0
      ],
      [
        0,
        34
      ],
      [
        -10,
        0
      ],
      [
        0,
        34
      ],
      [
        5,
        0
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        17138,
        58610
      ],
      [
        274,
        -2
      ],
      [
        255,
        -2
      ],
      [
        0,
        18
      ],
      [
        23,
        0
      ],
      [
        1,
        1
      ]
    ],
    [
      [
        17691,
        58625
      ],
      [
        0,
        -1
      ],
      [
        1,
        0
      ],
      [
        5,
        -18
      ],
      [
        0,
        -2
      ],
      [
        35,
        -115
      ],
      [
        25,
        -79
      ],
      [
        2,
        -8
      ],
      [
        0,
        -1
      ],
      [
        3,
        -9
      ],
      [
        1,
        -3
      ],
      [
        7,
        -22
      ],
      [
        17,
        -58
      ],
      [
        9,
        -30
      ],
      [
        31,
        -103
      ],
      [
        4,
        -12
      ],
      [
        0,
        -1
      ],
      [
        6,
        -19
      ],
      [
        6,
        -20
      ],
      [
        2,
        -5
      ],
      [
        15,
        -50
      ],
      [
        28,
        -96
      ],
      [
        5,
        -15
      ],
      [
        33,
        -112
      ],
      [
        0,
        -1
      ],
      [
        48,
        -161
      ]
    ],
    [
      [
        18112,
        56871
      ],
      [
        0,
        -17
      ],
      [
        1,
        -9
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        1,
        -7
      ],
      [
        0,
        -9
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        -4,
        -11
      ],
      [
        -5,
        -18
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -4
      ],
      [
        0,
        -13
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -6
      ],
      [
        -4,
        -5
      ],
      [
        -2,
        3
      ],
      [
        -4,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        -6,
        -25
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        -3
      ],
      [
        -4,
        1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -8
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -1
      ],
      [
        -3,
        -2
      ],
      [
        -3,
        -7
      ],
      [
        -3,
        2
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -9
      ]
    ],
    [
      [
        18029,
        56611
      ],
      [
        -220,
        -2
      ],
      [
        -25,
        0
      ],
      [
        0,
        -51
      ],
      [
        -105,
        1
      ],
      [
        -81,
        0
      ],
      [
        -89,
        -1
      ],
      [
        -58,
        -1
      ],
      [
        -58,
        1
      ],
      [
        -59,
        0
      ],
      [
        0,
        -34
      ],
      [
        -49,
        -1
      ],
      [
        -30,
        0
      ],
      [
        -3,
        17
      ],
      [
        -13,
        0
      ],
      [
        -28,
        1
      ],
      [
        -1,
        17
      ],
      [
        -41,
        -1
      ],
      [
        -10,
        0
      ],
      [
        0,
        -52
      ],
      [
        -14,
        -20
      ],
      [
        -1,
        -54
      ],
      [
        -12,
        -1
      ],
      [
        0,
        -41
      ],
      [
        -6,
        0
      ],
      [
        1,
        -21
      ]
    ],
    [
      [
        17127,
        56368
      ],
      [
        -2,
        8
      ],
      [
        -29,
        80
      ]
    ],
    [
      [
        17096,
        56456
      ],
      [
        -5,
        34
      ],
      [
        5,
        34
      ],
      [
        5,
        0
      ],
      [
        0,
        21
      ],
      [
        6,
        -4
      ],
      [
        4,
        2
      ],
      [
        6,
        68
      ],
      [
        1,
        18
      ],
      [
        3,
        31
      ],
      [
        5,
        47
      ],
      [
        0,
        5
      ],
      [
        4,
        63
      ],
      [
        2,
        34
      ],
      [
        3,
        46
      ],
      [
        -2,
        58
      ],
      [
        0,
        31
      ],
      [
        -1,
        37
      ],
      [
        -1,
        118
      ],
      [
        -2,
        69
      ],
      [
        0,
        308
      ]
    ],
    [
      [
        26932,
        56099
      ],
      [
        6,
        -3
      ],
      [
        8,
        21
      ],
      [
        1,
        -5
      ]
    ],
    [
      [
        26947,
        56112
      ],
      [
        -4,
        -15
      ],
      [
        3,
        -28
      ],
      [
        -1,
        -7
      ],
      [
        6,
        -12
      ],
      [
        0,
        -12
      ],
      [
        -6,
        -22
      ],
      [
        -1,
        -22
      ],
      [
        15,
        -23
      ],
      [
        -5,
        -16
      ],
      [
        1,
        -28
      ],
      [
        4,
        -17
      ],
      [
        0,
        -12
      ],
      [
        5,
        -19
      ],
      [
        8,
        -36
      ],
      [
        -1,
        -17
      ],
      [
        13,
        -59
      ]
    ],
    [
      [
        26984,
        55767
      ],
      [
        -17,
        -49
      ]
    ],
    [
      [
        26967,
        55718
      ],
      [
        -5,
        -2
      ],
      [
        -3,
        1
      ]
    ],
    [
      [
        26959,
        55717
      ],
      [
        -8,
        10
      ],
      [
        -11,
        24
      ],
      [
        -16,
        1
      ],
      [
        -7,
        18
      ],
      [
        -4,
        -5
      ],
      [
        1,
        25
      ],
      [
        -2,
        40
      ],
      [
        0,
        8
      ],
      [
        -9,
        40
      ],
      [
        -6,
        65
      ],
      [
        -12,
        120
      ]
    ],
    [
      [
        26885,
        56063
      ],
      [
        2,
        11
      ],
      [
        2,
        -8
      ],
      [
        5,
        1
      ],
      [
        -2,
        8
      ],
      [
        2,
        15
      ],
      [
        8,
        10
      ],
      [
        1,
        11
      ],
      [
        3,
        -12
      ],
      [
        2,
        7
      ],
      [
        6,
        -8
      ],
      [
        2,
        12
      ],
      [
        4,
        -5
      ],
      [
        5,
        17
      ],
      [
        7,
        -23
      ]
    ],
    [
      [
        12202,
        85643
      ],
      [
        6,
        -9
      ],
      [
        9,
        -62
      ],
      [
        0,
        -46
      ],
      [
        -5,
        6
      ],
      [
        -5,
        23
      ],
      [
        -6,
        77
      ],
      [
        1,
        11
      ]
    ],
    [
      [
        12100,
        86471
      ],
      [
        95,
        -444
      ],
      [
        97,
        -5
      ]
    ],
    [
      [
        12292,
        86022
      ],
      [
        7,
        -30
      ],
      [
        11,
        -46
      ],
      [
        73,
        -38
      ],
      [
        5,
        -66
      ],
      [
        32,
        -73
      ],
      [
        24,
        0
      ],
      [
        11,
        -53
      ],
      [
        18,
        -55
      ],
      [
        -6,
        -45
      ],
      [
        0,
        -24
      ],
      [
        20,
        -15
      ]
    ],
    [
      [
        12487,
        85577
      ],
      [
        -204,
        4
      ],
      [
        6,
        -19
      ],
      [
        1,
        -26
      ],
      [
        8,
        -19
      ],
      [
        -1,
        -12
      ],
      [
        7,
        -32
      ],
      [
        -1,
        -24
      ],
      [
        -3,
        -7
      ],
      [
        -1,
        -37
      ]
    ],
    [
      [
        12299,
        85405
      ],
      [
        -7,
        -39
      ],
      [
        1,
        -58
      ],
      [
        -34,
        126
      ],
      [
        -1,
        6
      ],
      [
        -4,
        89
      ],
      [
        -3,
        60
      ],
      [
        -1,
        28
      ],
      [
        -8,
        92
      ],
      [
        -9,
        62
      ],
      [
        -12,
        73
      ],
      [
        -24,
        82
      ],
      [
        -8,
        34
      ],
      [
        -36,
        37
      ],
      [
        -5,
        -16
      ],
      [
        15,
        -33
      ],
      [
        13,
        -5
      ],
      [
        4,
        -41
      ],
      [
        17,
        -39
      ],
      [
        10,
        -67
      ],
      [
        10,
        -64
      ],
      [
        -1,
        -16
      ],
      [
        -6,
        7
      ],
      [
        -8,
        20
      ],
      [
        -7,
        27
      ],
      [
        -9,
        47
      ],
      [
        -18,
        66
      ],
      [
        -22,
        36
      ],
      [
        -22,
        10
      ],
      [
        25,
        -54
      ],
      [
        16,
        -38
      ],
      [
        7,
        -61
      ],
      [
        6,
        -24
      ],
      [
        14,
        -10
      ],
      [
        3,
        -19
      ],
      [
        -5,
        -53
      ],
      [
        3,
        -11
      ],
      [
        1,
        -16
      ],
      [
        -6,
        -17
      ],
      [
        3,
        -17
      ],
      [
        -1,
        -22
      ],
      [
        7,
        -49
      ],
      [
        13,
        -23
      ],
      [
        0,
        -11
      ],
      [
        -5,
        -13
      ],
      [
        15,
        -83
      ],
      [
        3,
        -6
      ],
      [
        7,
        -26
      ],
      [
        2,
        -9
      ],
      [
        3,
        -55
      ],
      [
        25,
        -139
      ],
      [
        2,
        -32
      ],
      [
        -1,
        -13
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        -2,
        10
      ],
      [
        -2,
        10
      ],
      [
        -7,
        3
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -18
      ],
      [
        7,
        -35
      ],
      [
        9,
        -58
      ],
      [
        12,
        -86
      ],
      [
        9,
        -85
      ],
      [
        2,
        -47
      ],
      [
        -1,
        -22
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        2
      ],
      [
        -3,
        14
      ],
      [
        -7,
        -6
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -32
      ],
      [
        2,
        -23
      ],
      [
        12,
        -64
      ],
      [
        -5,
        1
      ],
      [
        -4,
        11
      ],
      [
        -7,
        1
      ],
      [
        -13,
        10
      ],
      [
        -17,
        30
      ],
      [
        -2,
        2
      ],
      [
        -5,
        -1
      ],
      [
        -9,
        -3
      ],
      [
        -2,
        1
      ],
      [
        -6,
        10
      ],
      [
        -10,
        32
      ],
      [
        -15,
        66
      ],
      [
        -3,
        18
      ],
      [
        -7,
        66
      ],
      [
        -4,
        0
      ]
    ],
    [
      [
        11885,
        85922
      ],
      [
        1,
        2
      ],
      [
        -3,
        14
      ],
      [
        8,
        13
      ],
      [
        -2,
        209
      ],
      [
        30,
        -19
      ],
      [
        2,
        2
      ],
      [
        16,
        17
      ],
      [
        19,
        71
      ],
      [
        -1,
        15
      ],
      [
        0,
        24
      ],
      [
        -32,
        47
      ],
      [
        27,
        29
      ],
      [
        18,
        19
      ],
      [
        68,
        28
      ],
      [
        24,
        30
      ],
      [
        2,
        2
      ],
      [
        38,
        46
      ]
    ],
    [
      [
        24997,
        69462
      ],
      [
        56,
        -1
      ],
      [
        0,
        -104
      ]
    ],
    [
      [
        25053,
        69357
      ],
      [
        0,
        -405
      ]
    ],
    [
      [
        25053,
        68952
      ],
      [
        -34,
        0
      ],
      [
        -40,
        5
      ],
      [
        -99,
        -1
      ]
    ],
    [
      [
        24880,
        68956
      ],
      [
        -131,
        0
      ]
    ],
    [
      [
        24749,
        68956
      ],
      [
        0,
        406
      ]
    ],
    [
      [
        5524,
        80844
      ],
      [
        2,
        7
      ],
      [
        0,
        18
      ],
      [
        -3,
        11
      ],
      [
        2,
        6
      ],
      [
        11,
        18
      ],
      [
        20,
        -25
      ],
      [
        1,
        -2
      ],
      [
        0,
        -13
      ],
      [
        -3,
        -21
      ],
      [
        -7,
        -23
      ],
      [
        -10,
        -14
      ],
      [
        -9,
        -1
      ],
      [
        -1,
        2
      ],
      [
        -5,
        22
      ],
      [
        2,
        15
      ]
    ],
    [
      [
        5485,
        80904
      ],
      [
        2,
        31
      ],
      [
        4,
        15
      ],
      [
        6,
        14
      ],
      [
        0,
        25
      ],
      [
        -11,
        16
      ],
      [
        0,
        30
      ],
      [
        2,
        3
      ],
      [
        19,
        0
      ],
      [
        10,
        -5
      ],
      [
        2,
        -15
      ],
      [
        3,
        -77
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -2
      ],
      [
        -27,
        -38
      ],
      [
        -6,
        -1
      ],
      [
        -2,
        5
      ],
      [
        -1,
        4
      ]
    ],
    [
      [
        5450,
        80763
      ],
      [
        5,
        -3
      ],
      [
        16,
        -42
      ],
      [
        -1,
        -34
      ],
      [
        -8,
        -7
      ],
      [
        -15,
        3
      ],
      [
        3,
        23
      ],
      [
        -5,
        44
      ],
      [
        5,
        16
      ]
    ],
    [
      [
        5429,
        81185
      ],
      [
        17,
        -21
      ],
      [
        5,
        49
      ],
      [
        17,
        46
      ],
      [
        1,
        0
      ],
      [
        4,
        -22
      ],
      [
        -1,
        -15
      ],
      [
        -2,
        -16
      ],
      [
        -5,
        -27
      ],
      [
        8,
        -10
      ],
      [
        1,
        -3
      ],
      [
        2,
        -22
      ],
      [
        -1,
        -22
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -2
      ],
      [
        -6,
        -28
      ],
      [
        0,
        -26
      ],
      [
        2,
        -7
      ],
      [
        11,
        -23
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        -6,
        -9
      ],
      [
        -2,
        4
      ],
      [
        -5,
        16
      ],
      [
        -10,
        2
      ],
      [
        -2,
        -21
      ],
      [
        -5,
        5
      ],
      [
        -11,
        -11
      ],
      [
        -1,
        2
      ],
      [
        -1,
        4
      ],
      [
        -2,
        8
      ],
      [
        0,
        19
      ],
      [
        -1,
        66
      ],
      [
        -5,
        70
      ],
      [
        3,
        9
      ]
    ],
    [
      [
        5385,
        80755
      ],
      [
        14,
        6
      ],
      [
        7,
        19
      ],
      [
        14,
        -9
      ],
      [
        -3,
        -21
      ],
      [
        -11,
        -4
      ],
      [
        -9,
        -22
      ],
      [
        -7,
        8
      ],
      [
        -5,
        16
      ],
      [
        0,
        7
      ]
    ],
    [
      [
        5377,
        81028
      ],
      [
        6,
        24
      ],
      [
        3,
        15
      ],
      [
        23,
        41
      ],
      [
        5,
        6
      ],
      [
        2,
        -10
      ],
      [
        -2,
        -32
      ],
      [
        -11,
        -31
      ],
      [
        -12,
        -7
      ],
      [
        -5,
        -38
      ],
      [
        1,
        -13
      ],
      [
        -5,
        -7
      ],
      [
        -8,
        34
      ],
      [
        3,
        18
      ]
    ],
    [
      [
        5303,
        81352
      ],
      [
        7,
        11
      ],
      [
        7,
        0
      ],
      [
        5,
        -15
      ],
      [
        5,
        -7
      ],
      [
        0,
        -12
      ],
      [
        -5,
        -8
      ],
      [
        -16,
        8
      ],
      [
        -3,
        23
      ]
    ],
    [
      [
        5265,
        80882
      ],
      [
        2,
        4
      ],
      [
        5,
        7
      ],
      [
        13,
        49
      ],
      [
        13,
        38
      ],
      [
        7,
        15
      ],
      [
        7,
        8
      ],
      [
        1,
        4
      ],
      [
        -3,
        15
      ],
      [
        -2,
        3
      ],
      [
        -11,
        -10
      ],
      [
        -11,
        10
      ],
      [
        -5,
        65
      ],
      [
        1,
        11
      ],
      [
        22,
        50
      ],
      [
        9,
        -17
      ],
      [
        5,
        -15
      ],
      [
        2,
        -14
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -5
      ],
      [
        7,
        6
      ],
      [
        5,
        8
      ],
      [
        2,
        7
      ],
      [
        0,
        6
      ],
      [
        -3,
        25
      ],
      [
        -9,
        29
      ],
      [
        -4,
        23
      ],
      [
        3,
        3
      ],
      [
        8,
        1
      ],
      [
        6,
        -11
      ],
      [
        2,
        -11
      ],
      [
        3,
        -5
      ],
      [
        8,
        10
      ],
      [
        7,
        36
      ],
      [
        11,
        78
      ],
      [
        3,
        3
      ],
      [
        3,
        -6
      ],
      [
        6,
        -20
      ],
      [
        1,
        -21
      ],
      [
        0,
        -7
      ],
      [
        -3,
        -15
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        4
      ],
      [
        -6,
        -3
      ],
      [
        -2,
        -13
      ],
      [
        -3,
        -62
      ],
      [
        1,
        -9
      ],
      [
        5,
        -13
      ],
      [
        6,
        4
      ],
      [
        1,
        19
      ],
      [
        -1,
        8
      ],
      [
        0,
        6
      ],
      [
        4,
        4
      ],
      [
        9,
        -3
      ],
      [
        -2,
        -40
      ],
      [
        -2,
        -20
      ],
      [
        -7,
        -30
      ],
      [
        -4,
        -7
      ],
      [
        -5,
        9
      ],
      [
        0,
        5
      ],
      [
        -5,
        7
      ],
      [
        -12,
        -9
      ],
      [
        -1,
        -5
      ],
      [
        2,
        -15
      ],
      [
        -2,
        -25
      ],
      [
        -28,
        -71
      ],
      [
        -8,
        -13
      ],
      [
        -10,
        -11
      ],
      [
        -19,
        -81
      ],
      [
        1,
        -14
      ],
      [
        -5,
        -33
      ],
      [
        -8,
        -13
      ],
      [
        -7,
        37
      ],
      [
        1,
        40
      ]
    ],
    [
      [
        5238,
        81460
      ],
      [
        7,
        21
      ],
      [
        15,
        21
      ],
      [
        2,
        1
      ],
      [
        9,
        -4
      ],
      [
        5,
        -5
      ],
      [
        20,
        -6
      ],
      [
        -1,
        -74
      ],
      [
        0,
        -4
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        0
      ],
      [
        -14,
        17
      ],
      [
        -21,
        4
      ],
      [
        -8,
        -3
      ],
      [
        -4,
        1
      ],
      [
        -5,
        18
      ],
      [
        -3,
        13
      ],
      [
        1,
        7
      ]
    ],
    [
      [
        5096,
        81334
      ],
      [
        4,
        25
      ],
      [
        12,
        49
      ],
      [
        6,
        8
      ],
      [
        19,
        17
      ],
      [
        6,
        -1
      ],
      [
        6,
        -4
      ],
      [
        5,
        -12
      ],
      [
        1,
        -6
      ],
      [
        0,
        -30
      ],
      [
        -2,
        -16
      ],
      [
        10,
        5
      ],
      [
        12,
        47
      ],
      [
        1,
        2
      ],
      [
        7,
        -3
      ],
      [
        7,
        -10
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -11
      ],
      [
        1,
        -4
      ],
      [
        26,
        -26
      ],
      [
        5,
        3
      ],
      [
        1,
        6
      ],
      [
        12,
        19
      ],
      [
        5,
        0
      ],
      [
        3,
        -3
      ],
      [
        2,
        -8
      ],
      [
        2,
        -17
      ],
      [
        3,
        -41
      ],
      [
        -7,
        -50
      ],
      [
        -2,
        -10
      ],
      [
        -9,
        9
      ],
      [
        -2,
        8
      ],
      [
        0,
        7
      ],
      [
        -3,
        16
      ],
      [
        -15,
        14
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -6
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        0
      ],
      [
        -2,
        3
      ],
      [
        -10,
        20
      ],
      [
        -2,
        12
      ],
      [
        5,
        10
      ],
      [
        -6,
        18
      ],
      [
        -1,
        0
      ],
      [
        -9,
        -12
      ],
      [
        -4,
        -22
      ],
      [
        0,
        -13
      ],
      [
        4,
        -34
      ],
      [
        4,
        -11
      ],
      [
        7,
        -9
      ],
      [
        11,
        -73
      ],
      [
        0,
        -14
      ],
      [
        -3,
        -18
      ],
      [
        -8,
        -42
      ],
      [
        -36,
        35
      ],
      [
        -6,
        16
      ],
      [
        -3,
        25
      ],
      [
        -1,
        18
      ],
      [
        -18,
        -18
      ],
      [
        -3,
        -12
      ],
      [
        0,
        -10
      ],
      [
        -8,
        -49
      ],
      [
        -3,
        -10
      ],
      [
        -4,
        -9
      ],
      [
        -1,
        2
      ],
      [
        2,
        25
      ],
      [
        3,
        17
      ],
      [
        0,
        14
      ],
      [
        -4,
        23
      ],
      [
        -6,
        20
      ],
      [
        0,
        104
      ],
      [
        -4,
        28
      ]
    ],
    [
      [
        4937,
        81216
      ],
      [
        8,
        9
      ],
      [
        19,
        -6
      ],
      [
        1,
        -41
      ],
      [
        -1,
        -24
      ],
      [
        -4,
        -6
      ],
      [
        -18,
        26
      ],
      [
        -8,
        21
      ],
      [
        3,
        21
      ]
    ],
    [
      [
        4863,
        81217
      ],
      [
        2,
        18
      ],
      [
        8,
        13
      ],
      [
        11,
        -4
      ],
      [
        21,
        20
      ],
      [
        4,
        -8
      ],
      [
        -9,
        -51
      ],
      [
        -19,
        -13
      ],
      [
        -18,
        3
      ],
      [
        0,
        22
      ]
    ],
    [
      [
        4804,
        81100
      ],
      [
        1,
        29
      ],
      [
        3,
        22
      ],
      [
        11,
        17
      ],
      [
        6,
        3
      ],
      [
        25,
        -19
      ],
      [
        6,
        -9
      ],
      [
        6,
        -20
      ],
      [
        5,
        -6
      ],
      [
        4,
        -2
      ],
      [
        3,
        1
      ],
      [
        12,
        -16
      ],
      [
        9,
        -16
      ],
      [
        2,
        -3
      ],
      [
        6,
        -21
      ],
      [
        0,
        -20
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -3
      ],
      [
        -5,
        -1
      ],
      [
        -3,
        3
      ],
      [
        -4,
        11
      ],
      [
        0,
        5
      ],
      [
        2,
        8
      ],
      [
        -16,
        26
      ],
      [
        -5,
        -9
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -6
      ],
      [
        -3,
        -11
      ],
      [
        -14,
        -28
      ],
      [
        -7,
        6
      ],
      [
        -8,
        21
      ],
      [
        -6,
        24
      ],
      [
        -1,
        15
      ],
      [
        0,
        3
      ],
      [
        -6,
        5
      ],
      [
        -7,
        -22
      ],
      [
        -4,
        -16
      ],
      [
        -13,
        29
      ],
      [
        6,
        8
      ]
    ],
    [
      [
        4656,
        80881
      ],
      [
        27,
        61
      ],
      [
        3,
        5
      ],
      [
        17,
        -4
      ],
      [
        3,
        -5
      ],
      [
        2,
        -2
      ],
      [
        4,
        -16
      ],
      [
        0,
        -83
      ],
      [
        -1,
        -11
      ],
      [
        -10,
        -42
      ],
      [
        -2,
        -5
      ],
      [
        -5,
        -10
      ],
      [
        -6,
        -6
      ],
      [
        -8,
        10
      ],
      [
        -19,
        48
      ],
      [
        -2,
        9
      ],
      [
        -4,
        49
      ],
      [
        1,
        2
      ]
    ],
    [
      [
        4545,
        80324
      ],
      [
        0,
        38
      ],
      [
        1,
        13
      ],
      [
        9,
        -3
      ],
      [
        15,
        -15
      ],
      [
        21,
        -21
      ],
      [
        9,
        -4
      ],
      [
        14,
        -11
      ],
      [
        8,
        -27
      ],
      [
        11,
        -12
      ],
      [
        12,
        5
      ],
      [
        14,
        -5
      ],
      [
        7,
        -8
      ],
      [
        11,
        -20
      ],
      [
        -8,
        -27
      ],
      [
        -12,
        4
      ],
      [
        -5,
        -10
      ],
      [
        -5,
        -23
      ],
      [
        -6,
        8
      ],
      [
        -16,
        32
      ],
      [
        -17,
        -9
      ],
      [
        -25,
        22
      ],
      [
        -6,
        15
      ],
      [
        -13,
        -15
      ],
      [
        2,
        -18
      ],
      [
        -7,
        4
      ],
      [
        -7,
        18
      ],
      [
        -15,
        39
      ],
      [
        8,
        30
      ]
    ],
    [
      [
        4451,
        81463
      ],
      [
        6,
        5
      ],
      [
        4,
        2
      ],
      [
        4,
        -8
      ],
      [
        1,
        -9
      ],
      [
        0,
        -21
      ],
      [
        -2,
        -4
      ],
      [
        -4,
        -4
      ],
      [
        -6,
        8
      ],
      [
        -4,
        15
      ],
      [
        1,
        16
      ]
    ],
    [
      [
        3979,
        80040
      ],
      [
        12,
        22
      ],
      [
        7,
        4
      ],
      [
        9,
        -7
      ],
      [
        0,
        -15
      ],
      [
        -15,
        -32
      ],
      [
        -6,
        -5
      ],
      [
        -12,
        21
      ],
      [
        5,
        12
      ]
    ],
    [
      [
        5643,
        83066
      ],
      [
        0,
        -60
      ],
      [
        -44,
        0
      ],
      [
        0,
        -101
      ],
      [
        -63,
        0
      ],
      [
        0,
        -101
      ],
      [
        -87,
        0
      ],
      [
        0,
        -101
      ],
      [
        -87,
        0
      ],
      [
        0,
        -202
      ],
      [
        27,
        0
      ],
      [
        0,
        -404
      ],
      [
        -18,
        0
      ],
      [
        0,
        -101
      ],
      [
        86,
        0
      ],
      [
        0,
        -289
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        5458,
        81707
      ],
      [
        -17,
        -50
      ],
      [
        -22,
        -26
      ],
      [
        -9,
        -4
      ],
      [
        -1,
        0
      ],
      [
        -3,
        35
      ],
      [
        0,
        4
      ],
      [
        2,
        9
      ],
      [
        3,
        4
      ],
      [
        15,
        3
      ],
      [
        1,
        -3
      ],
      [
        8,
        4
      ],
      [
        4,
        13
      ],
      [
        -3,
        18
      ],
      [
        -2,
        9
      ],
      [
        -10,
        4
      ],
      [
        0,
        30
      ],
      [
        1,
        65
      ],
      [
        1,
        16
      ],
      [
        12,
        61
      ],
      [
        1,
        1
      ],
      [
        6,
        1
      ],
      [
        -1,
        9
      ],
      [
        -10,
        20
      ],
      [
        -19,
        19
      ],
      [
        -28,
        12
      ],
      [
        -8,
        -5
      ],
      [
        -4,
        -6
      ],
      [
        -1,
        -7
      ],
      [
        2,
        -20
      ],
      [
        1,
        -25
      ],
      [
        -4,
        -18
      ],
      [
        -4,
        -3
      ],
      [
        -4,
        0
      ],
      [
        -13,
        22
      ],
      [
        -20,
        -8
      ],
      [
        -5,
        -5
      ],
      [
        -6,
        -24
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -7
      ],
      [
        1,
        -4
      ],
      [
        -3,
        -41
      ],
      [
        -20,
        -47
      ],
      [
        -15,
        -27
      ],
      [
        -26,
        -20
      ],
      [
        -13,
        3
      ],
      [
        -8,
        7
      ],
      [
        -16,
        18
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -11
      ],
      [
        0,
        -10
      ],
      [
        11,
        -44
      ],
      [
        -12,
        -34
      ],
      [
        -3,
        -17
      ],
      [
        -5,
        -30
      ],
      [
        0,
        -7
      ],
      [
        1,
        -14
      ],
      [
        0,
        -10
      ],
      [
        -6,
        -20
      ],
      [
        -5,
        -12
      ],
      [
        -6,
        -5
      ],
      [
        -4,
        0
      ],
      [
        -2,
        32
      ],
      [
        -3,
        24
      ],
      [
        -7,
        49
      ],
      [
        -4,
        13
      ],
      [
        -6,
        0
      ],
      [
        -6,
        -22
      ],
      [
        -4,
        -10
      ],
      [
        -4,
        -5
      ],
      [
        -11,
        14
      ],
      [
        -9,
        -1
      ],
      [
        -4,
        -3
      ],
      [
        -4,
        -6
      ],
      [
        -2,
        -10
      ],
      [
        1,
        -11
      ],
      [
        11,
        -7
      ],
      [
        20,
        -6
      ],
      [
        1,
        -7
      ],
      [
        2,
        -13
      ],
      [
        1,
        -10
      ],
      [
        -2,
        -21
      ],
      [
        -4,
        -17
      ],
      [
        -32,
        -10
      ],
      [
        -4,
        4
      ],
      [
        -12,
        21
      ],
      [
        -1,
        20
      ],
      [
        2,
        8
      ],
      [
        4,
        11
      ],
      [
        0,
        2
      ],
      [
        -2,
        9
      ],
      [
        -6,
        9
      ],
      [
        -5,
        4
      ],
      [
        -12,
        -3
      ],
      [
        -4,
        -6
      ],
      [
        -6,
        -13
      ],
      [
        -9,
        -41
      ],
      [
        0,
        -14
      ],
      [
        -1,
        -8
      ],
      [
        -4,
        -16
      ],
      [
        -5,
        -11
      ],
      [
        -61,
        -85
      ],
      [
        -13,
        -4
      ],
      [
        -13,
        6
      ],
      [
        2,
        4
      ],
      [
        2,
        12
      ],
      [
        -1,
        7
      ],
      [
        -8,
        8
      ],
      [
        -6,
        -2
      ],
      [
        -22,
        -19
      ],
      [
        -4,
        -10
      ],
      [
        -7,
        0
      ],
      [
        -6,
        4
      ],
      [
        -2,
        26
      ],
      [
        1,
        6
      ],
      [
        4,
        8
      ],
      [
        3,
        24
      ],
      [
        2,
        26
      ],
      [
        2,
        45
      ],
      [
        -2,
        7
      ],
      [
        2,
        14
      ],
      [
        26,
        85
      ],
      [
        3,
        11
      ],
      [
        3,
        31
      ],
      [
        -1,
        8
      ],
      [
        -1,
        7
      ],
      [
        -8,
        11
      ],
      [
        -7,
        5
      ],
      [
        -18,
        2
      ],
      [
        -13,
        -4
      ],
      [
        -17,
        -13
      ],
      [
        -4,
        -7
      ],
      [
        -3,
        -9
      ],
      [
        -24,
        -101
      ],
      [
        0,
        -6
      ],
      [
        1,
        -106
      ],
      [
        2,
        -8
      ],
      [
        1,
        -9
      ],
      [
        -10,
        -37
      ],
      [
        -30,
        -103
      ],
      [
        -1,
        -4
      ],
      [
        -4,
        -4
      ],
      [
        -2,
        -4
      ],
      [
        -3,
        -13
      ],
      [
        -3,
        -19
      ],
      [
        -1,
        -11
      ],
      [
        1,
        -10
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -4
      ],
      [
        -7,
        -22
      ],
      [
        -4,
        4
      ],
      [
        -11,
        23
      ],
      [
        -6,
        9
      ],
      [
        -14,
        4
      ],
      [
        -3,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -9
      ],
      [
        13,
        -65
      ],
      [
        10,
        -17
      ],
      [
        4,
        -33
      ],
      [
        -2,
        -17
      ],
      [
        -1,
        -6
      ],
      [
        -25,
        -38
      ],
      [
        -19,
        33
      ],
      [
        -3,
        24
      ],
      [
        3,
        21
      ],
      [
        -2,
        14
      ],
      [
        -4,
        5
      ],
      [
        -10,
        -4
      ],
      [
        -11,
        -41
      ],
      [
        -2,
        -12
      ],
      [
        0,
        -7
      ],
      [
        5,
        -24
      ],
      [
        4,
        -17
      ],
      [
        1,
        -8
      ],
      [
        -9,
        -37
      ],
      [
        -8,
        -10
      ],
      [
        -1,
        0
      ],
      [
        -4,
        2
      ],
      [
        -4,
        5
      ],
      [
        -3,
        8
      ],
      [
        -2,
        8
      ],
      [
        0,
        4
      ],
      [
        -17,
        -1
      ],
      [
        -15,
        -7
      ],
      [
        -16,
        18
      ],
      [
        -5,
        15
      ],
      [
        -6,
        25
      ],
      [
        -3,
        21
      ],
      [
        0,
        13
      ],
      [
        4,
        4
      ],
      [
        13,
        8
      ],
      [
        2,
        -2
      ],
      [
        3,
        -7
      ],
      [
        2,
        -7
      ],
      [
        3,
        -8
      ],
      [
        2,
        -1
      ],
      [
        2,
        2
      ],
      [
        1,
        17
      ],
      [
        -11,
        36
      ],
      [
        -10,
        11
      ],
      [
        -3,
        27
      ],
      [
        -1,
        17
      ],
      [
        -1,
        17
      ],
      [
        -3,
        43
      ],
      [
        -1,
        2
      ],
      [
        -20,
        54
      ],
      [
        -11,
        7
      ],
      [
        -7,
        -6
      ],
      [
        -3,
        -6
      ],
      [
        -6,
        -21
      ],
      [
        -5,
        -27
      ],
      [
        -4,
        -25
      ],
      [
        -1,
        -13
      ],
      [
        2,
        -10
      ],
      [
        5,
        -17
      ],
      [
        7,
        -4
      ],
      [
        7,
        4
      ],
      [
        1,
        -3
      ],
      [
        7,
        -23
      ],
      [
        10,
        -44
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        -4
      ],
      [
        -2,
        1
      ],
      [
        -4,
        -33
      ],
      [
        5,
        -50
      ],
      [
        9,
        -45
      ],
      [
        0,
        -52
      ],
      [
        -5,
        1
      ],
      [
        -8,
        18
      ],
      [
        -9,
        11
      ],
      [
        -11,
        -1
      ],
      [
        -6,
        -6
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -7
      ],
      [
        3,
        -10
      ],
      [
        1,
        -7
      ],
      [
        -1,
        -9
      ],
      [
        -17,
        -30
      ],
      [
        -18,
        -7
      ],
      [
        -3,
        1
      ],
      [
        -10,
        9
      ],
      [
        -9,
        18
      ],
      [
        -16,
        59
      ],
      [
        1,
        19
      ],
      [
        2,
        3
      ],
      [
        1,
        14
      ],
      [
        -2,
        12
      ],
      [
        -11,
        44
      ],
      [
        -14,
        27
      ],
      [
        -5,
        8
      ],
      [
        -2,
        2
      ],
      [
        -9,
        -3
      ],
      [
        -15,
        -12
      ],
      [
        -7,
        -10
      ],
      [
        -7,
        -28
      ],
      [
        -3,
        -20
      ],
      [
        0,
        -8
      ],
      [
        2,
        -14
      ],
      [
        1,
        -5
      ],
      [
        7,
        -11
      ],
      [
        4,
        -4
      ],
      [
        7,
        1
      ],
      [
        23,
        -41
      ],
      [
        5,
        -11
      ],
      [
        4,
        -31
      ],
      [
        -9,
        -19
      ],
      [
        -23,
        -47
      ],
      [
        -18,
        -45
      ],
      [
        -24,
        -21
      ],
      [
        -15,
        -22
      ],
      [
        -5,
        -11
      ],
      [
        0,
        -12
      ],
      [
        8,
        -30
      ],
      [
        8,
        -14
      ],
      [
        8,
        -2
      ],
      [
        16,
        3
      ],
      [
        3,
        1
      ],
      [
        8,
        22
      ],
      [
        1,
        2
      ],
      [
        12,
        -16
      ],
      [
        10,
        -34
      ],
      [
        3,
        -31
      ],
      [
        4,
        -23
      ],
      [
        7,
        3
      ],
      [
        2,
        -19
      ],
      [
        -3,
        -13
      ],
      [
        -10,
        1
      ],
      [
        -8,
        7
      ],
      [
        -8,
        -2
      ],
      [
        0,
        4
      ],
      [
        1,
        4
      ],
      [
        6,
        12
      ],
      [
        1,
        14
      ],
      [
        -5,
        -1
      ],
      [
        -12,
        7
      ],
      [
        -3,
        -2
      ],
      [
        -3,
        -7
      ],
      [
        -2,
        -18
      ],
      [
        -2,
        -1
      ],
      [
        -7,
        18
      ],
      [
        -9,
        4
      ],
      [
        -11,
        29
      ],
      [
        -2,
        19
      ],
      [
        -4,
        14
      ],
      [
        -4,
        2
      ],
      [
        -3,
        -1
      ],
      [
        -4,
        -4
      ],
      [
        -3,
        -5
      ],
      [
        -9,
        -25
      ],
      [
        -2,
        -6
      ],
      [
        3,
        -7
      ],
      [
        3,
        -18
      ],
      [
        -2,
        -34
      ],
      [
        -2,
        -10
      ],
      [
        -5,
        0
      ],
      [
        -9,
        1
      ],
      [
        -4,
        -2
      ],
      [
        -24,
        -37
      ],
      [
        -2,
        -7
      ],
      [
        -2,
        -6
      ],
      [
        -23,
        18
      ],
      [
        -21,
        9
      ],
      [
        -16,
        1
      ],
      [
        -16,
        -4
      ],
      [
        -26,
        -3
      ],
      [
        -3,
        2
      ],
      [
        -34,
        -14
      ],
      [
        -26,
        -24
      ],
      [
        -15,
        -16
      ],
      [
        -7,
        -15
      ],
      [
        -20,
        -49
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -34
      ],
      [
        2,
        -12
      ],
      [
        -1,
        -5
      ],
      [
        -4,
        -18
      ],
      [
        -18,
        -39
      ],
      [
        -11,
        -14
      ],
      [
        -12,
        -6
      ],
      [
        -6,
        0
      ],
      [
        -17,
        -10
      ],
      [
        -5,
        -4
      ],
      [
        -11,
        -13
      ],
      [
        -29,
        3
      ],
      [
        -13,
        9
      ],
      [
        -15,
        19
      ],
      [
        -9,
        30
      ],
      [
        0,
        7
      ],
      [
        -8,
        58
      ],
      [
        -1,
        9
      ],
      [
        -8,
        16
      ],
      [
        -2,
        14
      ],
      [
        -1,
        50
      ],
      [
        0,
        5
      ],
      [
        4,
        21
      ],
      [
        4,
        8
      ],
      [
        24,
        28
      ],
      [
        20,
        13
      ],
      [
        5,
        6
      ],
      [
        4,
        6
      ],
      [
        5,
        13
      ],
      [
        23,
        110
      ],
      [
        14,
        79
      ],
      [
        5,
        31
      ],
      [
        -1,
        29
      ],
      [
        4,
        15
      ],
      [
        18,
        39
      ],
      [
        14,
        13
      ],
      [
        2,
        -1
      ],
      [
        15,
        -20
      ],
      [
        3,
        -9
      ],
      [
        3,
        -11
      ],
      [
        2,
        -5
      ],
      [
        14,
        10
      ],
      [
        24,
        29
      ],
      [
        1,
        5
      ],
      [
        11,
        25
      ],
      [
        13,
        19
      ],
      [
        3,
        -6
      ],
      [
        6,
        -1
      ],
      [
        7,
        1
      ],
      [
        9,
        6
      ],
      [
        10,
        16
      ],
      [
        8,
        16
      ],
      [
        10,
        24
      ],
      [
        5,
        17
      ],
      [
        4,
        8
      ],
      [
        3,
        1
      ],
      [
        4,
        -3
      ],
      [
        5,
        1
      ],
      [
        10,
        8
      ],
      [
        7,
        9
      ],
      [
        5,
        4
      ],
      [
        9,
        -9
      ],
      [
        27,
        -5
      ],
      [
        21,
        6
      ],
      [
        10,
        -1
      ],
      [
        2,
        -9
      ],
      [
        -2,
        -18
      ],
      [
        1,
        -10
      ],
      [
        19,
        -40
      ],
      [
        5,
        -14
      ],
      [
        4,
        -18
      ],
      [
        3,
        -19
      ],
      [
        6,
        -42
      ],
      [
        0,
        -10
      ],
      [
        -3,
        -11
      ],
      [
        -2,
        -29
      ],
      [
        0,
        -4
      ],
      [
        1,
        -2
      ],
      [
        6,
        1
      ],
      [
        16,
        21
      ],
      [
        4,
        8
      ],
      [
        0,
        27
      ],
      [
        -5,
        17
      ],
      [
        -2,
        2
      ],
      [
        -1,
        6
      ],
      [
        1,
        30
      ],
      [
        1,
        7
      ],
      [
        5,
        4
      ],
      [
        2,
        -1
      ],
      [
        4,
        -25
      ],
      [
        9,
        2
      ],
      [
        10,
        -10
      ],
      [
        -1,
        17
      ],
      [
        -14,
        25
      ],
      [
        -1,
        23
      ],
      [
        3,
        54
      ],
      [
        -7,
        43
      ],
      [
        -2,
        42
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        7
      ],
      [
        0,
        10
      ],
      [
        1,
        8
      ],
      [
        13,
        22
      ],
      [
        19,
        24
      ],
      [
        12,
        11
      ],
      [
        14,
        10
      ],
      [
        7,
        -4
      ],
      [
        0,
        -5
      ],
      [
        3,
        -3
      ],
      [
        11,
        -2
      ],
      [
        21,
        -1
      ],
      [
        21,
        14
      ],
      [
        5,
        17
      ],
      [
        6,
        30
      ],
      [
        -1,
        22
      ],
      [
        -2,
        5
      ],
      [
        -1,
        2
      ],
      [
        -4,
        -1
      ],
      [
        -3,
        -10
      ],
      [
        -4,
        5
      ],
      [
        -2,
        3
      ],
      [
        0,
        2
      ],
      [
        1,
        5
      ],
      [
        3,
        21
      ],
      [
        2,
        4
      ],
      [
        8,
        8
      ],
      [
        1,
        -15
      ],
      [
        7,
        13
      ],
      [
        3,
        24
      ],
      [
        4,
        14
      ],
      [
        9,
        4
      ],
      [
        4,
        -8
      ],
      [
        5,
        0
      ],
      [
        4,
        13
      ],
      [
        3,
        12
      ],
      [
        5,
        13
      ],
      [
        -3,
        16
      ],
      [
        7,
        0
      ],
      [
        4,
        13
      ],
      [
        2,
        14
      ],
      [
        4,
        18
      ],
      [
        3,
        -32
      ],
      [
        8,
        -5
      ],
      [
        1,
        -5
      ],
      [
        6,
        -10
      ],
      [
        6,
        3
      ],
      [
        3,
        8
      ],
      [
        7,
        14
      ],
      [
        2,
        17
      ],
      [
        3,
        6
      ],
      [
        -1,
        26
      ],
      [
        -4,
        3
      ],
      [
        -1,
        15
      ],
      [
        4,
        17
      ],
      [
        -1,
        15
      ],
      [
        -2,
        7
      ],
      [
        -10,
        -10
      ],
      [
        -8,
        -10
      ],
      [
        -2,
        11
      ],
      [
        7,
        16
      ],
      [
        8,
        20
      ],
      [
        12,
        32
      ],
      [
        18,
        59
      ],
      [
        12,
        32
      ],
      [
        20,
        66
      ],
      [
        14,
        49
      ],
      [
        12,
        26
      ],
      [
        10,
        13
      ],
      [
        11,
        13
      ],
      [
        13,
        35
      ],
      [
        10,
        27
      ],
      [
        3,
        5
      ],
      [
        16,
        8
      ],
      [
        27,
        42
      ],
      [
        11,
        37
      ],
      [
        12,
        27
      ],
      [
        2,
        4
      ],
      [
        9,
        6
      ],
      [
        18,
        8
      ],
      [
        20,
        18
      ],
      [
        15,
        21
      ],
      [
        37,
        20
      ],
      [
        20,
        13
      ],
      [
        25,
        20
      ],
      [
        12,
        13
      ],
      [
        18,
        17
      ],
      [
        14,
        7
      ],
      [
        10,
        0
      ],
      [
        4,
        -4
      ],
      [
        16,
        -5
      ],
      [
        10,
        18
      ],
      [
        21,
        3
      ],
      [
        11,
        0
      ],
      [
        13,
        2
      ],
      [
        6,
        -3
      ],
      [
        4,
        -7
      ],
      [
        -20,
        -27
      ],
      [
        1,
        -16
      ],
      [
        -2,
        -31
      ],
      [
        14,
        -2
      ],
      [
        2,
        -7
      ],
      [
        -1,
        -25
      ],
      [
        3,
        -27
      ],
      [
        -5,
        1
      ],
      [
        -2,
        9
      ],
      [
        -9,
        -3
      ],
      [
        -20,
        -15
      ],
      [
        0,
        -27
      ],
      [
        -6,
        -23
      ],
      [
        2,
        -21
      ],
      [
        1,
        -14
      ],
      [
        3,
        -9
      ],
      [
        35,
        -89
      ],
      [
        11,
        22
      ],
      [
        10,
        -11
      ],
      [
        17,
        -28
      ],
      [
        2,
        0
      ],
      [
        2,
        7
      ],
      [
        0,
        12
      ],
      [
        -2,
        6
      ],
      [
        -4,
        7
      ],
      [
        -5,
        5
      ],
      [
        -16,
        28
      ],
      [
        -2,
        7
      ],
      [
        -3,
        85
      ],
      [
        -6,
        16
      ],
      [
        0,
        16
      ],
      [
        6,
        -3
      ],
      [
        10,
        -15
      ],
      [
        10,
        -10
      ],
      [
        17,
        -4
      ],
      [
        20,
        6
      ],
      [
        4,
        4
      ],
      [
        5,
        3
      ],
      [
        7,
        0
      ],
      [
        4,
        -6
      ],
      [
        4,
        -27
      ],
      [
        0,
        -22
      ],
      [
        3,
        -37
      ],
      [
        8,
        -1
      ],
      [
        15,
        8
      ],
      [
        12,
        -22
      ],
      [
        14,
        -14
      ],
      [
        4,
        0
      ],
      [
        4,
        12
      ],
      [
        -1,
        10
      ],
      [
        -7,
        20
      ],
      [
        -6,
        15
      ],
      [
        -1,
        5
      ],
      [
        13,
        15
      ],
      [
        14,
        0
      ],
      [
        -6,
        21
      ],
      [
        -9,
        8
      ],
      [
        -14,
        13
      ],
      [
        -15,
        25
      ],
      [
        -12,
        22
      ],
      [
        -18,
        18
      ],
      [
        -14,
        18
      ],
      [
        1,
        24
      ],
      [
        2,
        15
      ],
      [
        0,
        11
      ],
      [
        -1,
        4
      ],
      [
        -1,
        4
      ],
      [
        -5,
        3
      ],
      [
        -7,
        -14
      ],
      [
        -4,
        4
      ],
      [
        6,
        24
      ],
      [
        22,
        86
      ],
      [
        2,
        9
      ],
      [
        9,
        47
      ],
      [
        11,
        80
      ],
      [
        4,
        43
      ],
      [
        4,
        23
      ],
      [
        7,
        33
      ],
      [
        5,
        14
      ],
      [
        7,
        12
      ],
      [
        11,
        18
      ],
      [
        14,
        34
      ],
      [
        5,
        13
      ],
      [
        3,
        17
      ],
      [
        14,
        32
      ],
      [
        18,
        13
      ],
      [
        22,
        36
      ],
      [
        7,
        14
      ],
      [
        11,
        24
      ],
      [
        30,
        81
      ],
      [
        4,
        6
      ],
      [
        50,
        56
      ],
      [
        28,
        34
      ],
      [
        25,
        44
      ],
      [
        16,
        30
      ],
      [
        9,
        3
      ],
      [
        13,
        21
      ],
      [
        8,
        6
      ],
      [
        5,
        9
      ],
      [
        30,
        46
      ],
      [
        13,
        21
      ],
      [
        4,
        3
      ],
      [
        15,
        26
      ],
      [
        6,
        10
      ],
      [
        17,
        42
      ],
      [
        1,
        -1
      ],
      [
        0,
        -8
      ],
      [
        6,
        -18
      ],
      [
        6,
        -15
      ],
      [
        5,
        -10
      ]
    ],
    [
      [
        3880,
        79918
      ],
      [
        6,
        17
      ],
      [
        16,
        17
      ],
      [
        15,
        -3
      ],
      [
        6,
        -6
      ],
      [
        5,
        -2
      ],
      [
        7,
        0
      ],
      [
        4,
        16
      ],
      [
        9,
        -1
      ],
      [
        11,
        3
      ],
      [
        4,
        -10
      ],
      [
        1,
        -14
      ],
      [
        -1,
        -6
      ],
      [
        -8,
        -39
      ],
      [
        -2,
        -2
      ],
      [
        -24,
        -11
      ],
      [
        -44,
        25
      ],
      [
        -3,
        2
      ],
      [
        -2,
        14
      ]
    ],
    [
      [
        3807,
        79887
      ],
      [
        4,
        5
      ],
      [
        8,
        5
      ],
      [
        33,
        13
      ],
      [
        14,
        1
      ],
      [
        1,
        0
      ],
      [
        9,
        -35
      ],
      [
        0,
        -3
      ],
      [
        -3,
        -8
      ],
      [
        -10,
        1
      ],
      [
        -2,
        -22
      ],
      [
        -8,
        14
      ],
      [
        -5,
        23
      ],
      [
        -8,
        4
      ],
      [
        -26,
        -8
      ],
      [
        -7,
        7
      ],
      [
        0,
        3
      ]
    ],
    [
      [
        3781,
        79848
      ],
      [
        8,
        19
      ],
      [
        9,
        10
      ],
      [
        4,
        -20
      ],
      [
        6,
        -6
      ],
      [
        -3,
        -10
      ],
      [
        -5,
        -6
      ],
      [
        -5,
        0
      ],
      [
        -8,
        -8
      ],
      [
        -6,
        21
      ]
    ],
    [
      [
        3751,
        80090
      ],
      [
        2,
        18
      ],
      [
        11,
        38
      ],
      [
        3,
        2
      ],
      [
        3,
        -2
      ],
      [
        3,
        -4
      ],
      [
        5,
        -11
      ],
      [
        18,
        18
      ],
      [
        5,
        -1
      ],
      [
        7,
        -5
      ],
      [
        0,
        -15
      ],
      [
        -10,
        -9
      ],
      [
        -12,
        -24
      ],
      [
        0,
        -8
      ],
      [
        1,
        -9
      ],
      [
        12,
        -31
      ],
      [
        4,
        -2
      ],
      [
        5,
        3
      ],
      [
        21,
        -1
      ],
      [
        3,
        -10
      ],
      [
        3,
        -8
      ],
      [
        -5,
        -23
      ],
      [
        -4,
        2
      ],
      [
        -2,
        4
      ],
      [
        -15,
        0
      ],
      [
        -2,
        -3
      ],
      [
        -15,
        -59
      ],
      [
        -3,
        -20
      ],
      [
        -5,
        -5
      ],
      [
        -3,
        1
      ],
      [
        -10,
        14
      ],
      [
        -5,
        14
      ],
      [
        -2,
        78
      ],
      [
        4,
        10
      ],
      [
        8,
        12
      ],
      [
        2,
        5
      ],
      [
        2,
        8
      ],
      [
        -2,
        10
      ],
      [
        -2,
        5
      ],
      [
        -5,
        5
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        -13
      ],
      [
        -4,
        -5
      ],
      [
        -8,
        -1
      ],
      [
        -3,
        9
      ],
      [
        -2,
        8
      ],
      [
        1,
        7
      ]
    ],
    [
      [
        3635,
        79967
      ],
      [
        5,
        36
      ],
      [
        22,
        45
      ],
      [
        6,
        9
      ],
      [
        10,
        0
      ],
      [
        20,
        -6
      ],
      [
        2,
        -1
      ],
      [
        1,
        -4
      ],
      [
        -1,
        -14
      ],
      [
        -1,
        -12
      ],
      [
        -3,
        -7
      ],
      [
        4,
        -17
      ],
      [
        1,
        -3
      ],
      [
        7,
        -6
      ],
      [
        2,
        0
      ],
      [
        2,
        4
      ],
      [
        7,
        22
      ],
      [
        1,
        0
      ],
      [
        1,
        -2
      ],
      [
        0,
        -12
      ],
      [
        12,
        -12
      ],
      [
        2,
        -3
      ],
      [
        2,
        -12
      ],
      [
        6,
        -32
      ],
      [
        13,
        13
      ],
      [
        1,
        -1
      ],
      [
        2,
        -14
      ],
      [
        -5,
        -26
      ],
      [
        -26,
        -36
      ],
      [
        -12,
        11
      ],
      [
        -18,
        -45
      ],
      [
        -6,
        22
      ],
      [
        0,
        6
      ],
      [
        -2,
        3
      ],
      [
        -4,
        3
      ],
      [
        -4,
        1
      ],
      [
        -15,
        -6
      ],
      [
        -10,
        -12
      ],
      [
        -2,
        -6
      ],
      [
        -5,
        -2
      ],
      [
        -14,
        69
      ],
      [
        -4,
        22
      ],
      [
        3,
        25
      ]
    ],
    [
      [
        3608,
        79782
      ],
      [
        7,
        15
      ],
      [
        18,
        -11
      ],
      [
        9,
        -22
      ],
      [
        -11,
        -14
      ],
      [
        -11,
        -3
      ],
      [
        -10,
        6
      ],
      [
        -2,
        10
      ],
      [
        0,
        19
      ]
    ],
    [
      [
        7594,
        84711
      ],
      [
        8,
        45
      ],
      [
        12,
        6
      ],
      [
        8,
        -19
      ],
      [
        -2,
        -41
      ],
      [
        -6,
        -32
      ],
      [
        -12,
        -18
      ],
      [
        -3,
        1
      ],
      [
        -5,
        28
      ],
      [
        0,
        30
      ]
    ],
    [
      [
        7543,
        85532
      ],
      [
        3,
        26
      ],
      [
        9,
        2
      ],
      [
        7,
        -9
      ],
      [
        14,
        -31
      ],
      [
        -17,
        -6
      ],
      [
        -16,
        4
      ],
      [
        0,
        14
      ]
    ],
    [
      [
        7480,
        83737
      ],
      [
        2,
        14
      ],
      [
        7,
        -3
      ],
      [
        4,
        -9
      ],
      [
        -2,
        -20
      ],
      [
        -6,
        -2
      ],
      [
        -9,
        -3
      ],
      [
        4,
        23
      ]
    ],
    [
      [
        7464,
        85521
      ],
      [
        12,
        19
      ],
      [
        2,
        36
      ],
      [
        18,
        -28
      ],
      [
        18,
        10
      ],
      [
        6,
        -4
      ],
      [
        -1,
        -10
      ],
      [
        -33,
        -33
      ],
      [
        -18,
        -1
      ],
      [
        -4,
        11
      ]
    ],
    [
      [
        7168,
        84530
      ],
      [
        2,
        7
      ],
      [
        27,
        82
      ],
      [
        9,
        9
      ],
      [
        2,
        0
      ],
      [
        4,
        -3
      ],
      [
        9,
        -26
      ],
      [
        8,
        -24
      ],
      [
        9,
        -16
      ],
      [
        3,
        2
      ],
      [
        2,
        18
      ],
      [
        -5,
        26
      ],
      [
        -12,
        26
      ],
      [
        -4,
        13
      ],
      [
        6,
        54
      ],
      [
        9,
        10
      ],
      [
        27,
        -25
      ],
      [
        4,
        -1
      ],
      [
        7,
        6
      ],
      [
        10,
        14
      ],
      [
        0,
        3
      ],
      [
        -2,
        9
      ],
      [
        -15,
        16
      ],
      [
        -6,
        10
      ],
      [
        -6,
        16
      ],
      [
        0,
        3
      ],
      [
        1,
        4
      ],
      [
        15,
        49
      ],
      [
        12,
        -7
      ],
      [
        3,
        -4
      ],
      [
        3,
        -11
      ],
      [
        11,
        -9
      ],
      [
        15,
        4
      ],
      [
        3,
        7
      ],
      [
        2,
        19
      ],
      [
        -4,
        2
      ],
      [
        -8,
        0
      ],
      [
        -2,
        7
      ],
      [
        -5,
        21
      ],
      [
        1,
        5
      ],
      [
        3,
        5
      ],
      [
        8,
        7
      ],
      [
        7,
        -11
      ],
      [
        13,
        -9
      ],
      [
        5,
        13
      ],
      [
        9,
        32
      ],
      [
        -4,
        2
      ],
      [
        -14,
        4
      ],
      [
        -13,
        33
      ],
      [
        -1,
        10
      ],
      [
        0,
        2
      ],
      [
        6,
        -8
      ],
      [
        6,
        -1
      ],
      [
        9,
        0
      ],
      [
        7,
        10
      ],
      [
        4,
        9
      ],
      [
        1,
        12
      ],
      [
        10,
        36
      ],
      [
        3,
        2
      ],
      [
        9,
        -3
      ],
      [
        22,
        19
      ],
      [
        3,
        17
      ],
      [
        0,
        5
      ],
      [
        -2,
        1
      ],
      [
        -3,
        -3
      ],
      [
        -1,
        1
      ],
      [
        -9,
        14
      ],
      [
        -3,
        44
      ],
      [
        0,
        24
      ],
      [
        8,
        27
      ],
      [
        6,
        16
      ],
      [
        13,
        23
      ],
      [
        2,
        -2
      ],
      [
        3,
        -10
      ],
      [
        0,
        -12
      ],
      [
        2,
        -7
      ],
      [
        11,
        -1
      ],
      [
        14,
        29
      ],
      [
        28,
        23
      ],
      [
        4,
        -1
      ],
      [
        3,
        -6
      ],
      [
        -3,
        -50
      ],
      [
        -9,
        -68
      ],
      [
        -5,
        -10
      ],
      [
        -8,
        -8
      ],
      [
        -14,
        -45
      ],
      [
        -8,
        -32
      ],
      [
        -2,
        -9
      ],
      [
        -2,
        -17
      ],
      [
        5,
        -84
      ],
      [
        5,
        -5
      ],
      [
        25,
        10
      ],
      [
        6,
        6
      ],
      [
        5,
        32
      ],
      [
        -1,
        11
      ],
      [
        -2,
        14
      ],
      [
        -1,
        3
      ],
      [
        1,
        9
      ],
      [
        8,
        12
      ],
      [
        2,
        0
      ],
      [
        5,
        -6
      ],
      [
        7,
        -15
      ],
      [
        14,
        -46
      ],
      [
        -2,
        -17
      ],
      [
        3,
        -5
      ],
      [
        6,
        -3
      ],
      [
        20,
        48
      ],
      [
        2,
        0
      ],
      [
        9,
        -27
      ],
      [
        1,
        -6
      ],
      [
        -9,
        -44
      ],
      [
        -5,
        -40
      ],
      [
        -3,
        -33
      ],
      [
        1,
        -21
      ],
      [
        8,
        -1
      ],
      [
        2,
        14
      ],
      [
        0,
        23
      ],
      [
        7,
        35
      ],
      [
        27,
        47
      ],
      [
        1,
        -3
      ],
      [
        5,
        -18
      ],
      [
        1,
        -4
      ],
      [
        -1,
        -70
      ],
      [
        -2,
        -45
      ],
      [
        -4,
        -19
      ],
      [
        -26,
        -70
      ],
      [
        -9,
        -6
      ],
      [
        -23,
        29
      ],
      [
        -8,
        25
      ],
      [
        0,
        8
      ],
      [
        1,
        5
      ],
      [
        4,
        0
      ],
      [
        1,
        7
      ],
      [
        -9,
        36
      ],
      [
        -2,
        -2
      ],
      [
        -11,
        1
      ],
      [
        -8,
        -25
      ],
      [
        13,
        -99
      ],
      [
        -3,
        -12
      ],
      [
        -19,
        -8
      ],
      [
        -17,
        2
      ],
      [
        -6,
        8
      ],
      [
        -16,
        3
      ],
      [
        -9,
        -18
      ],
      [
        -4,
        -24
      ],
      [
        0,
        -7
      ],
      [
        -3,
        -5
      ],
      [
        -4,
        1
      ],
      [
        -1,
        2
      ],
      [
        -3,
        33
      ],
      [
        3,
        54
      ],
      [
        -1,
        12
      ],
      [
        0,
        8
      ],
      [
        -6,
        11
      ],
      [
        -4,
        -9
      ],
      [
        -5,
        -74
      ],
      [
        -4,
        -40
      ],
      [
        -8,
        -24
      ],
      [
        -14,
        -12
      ],
      [
        -17,
        -5
      ],
      [
        2,
        -37
      ],
      [
        -16,
        -22
      ],
      [
        -14,
        4
      ],
      [
        0,
        -3
      ],
      [
        -22,
        -15
      ],
      [
        -9,
        1
      ],
      [
        -32,
        23
      ],
      [
        -30,
        30
      ],
      [
        -2,
        5
      ],
      [
        -1,
        9
      ],
      [
        -1,
        2
      ],
      [
        -20,
        7
      ],
      [
        -15,
        -11
      ],
      [
        -6,
        -2
      ],
      [
        -15,
        24
      ],
      [
        0,
        5
      ]
    ],
    [
      [
        7113,
        83171
      ],
      [
        4,
        13
      ],
      [
        12,
        8
      ],
      [
        4,
        -6
      ],
      [
        -8,
        -20
      ],
      [
        -8,
        -5
      ],
      [
        -4,
        10
      ]
    ],
    [
      [
        6962,
        82933
      ],
      [
        11,
        19
      ],
      [
        6,
        -3
      ],
      [
        14,
        29
      ],
      [
        7,
        -18
      ],
      [
        1,
        -30
      ],
      [
        -1,
        -5
      ],
      [
        -7,
        -2
      ],
      [
        -29,
        -2
      ],
      [
        -2,
        12
      ]
    ],
    [
      [
        6905,
        82759
      ],
      [
        6,
        25
      ],
      [
        9,
        25
      ],
      [
        5,
        12
      ],
      [
        13,
        16
      ],
      [
        6,
        4
      ],
      [
        4,
        -4
      ],
      [
        1,
        -3
      ],
      [
        6,
        -4
      ],
      [
        13,
        7
      ],
      [
        7,
        9
      ],
      [
        2,
        1
      ],
      [
        3,
        0
      ],
      [
        1,
        -4
      ],
      [
        2,
        -13
      ],
      [
        1,
        -16
      ],
      [
        1,
        -7
      ],
      [
        10,
        -32
      ],
      [
        4,
        -5
      ],
      [
        5,
        0
      ],
      [
        19,
        8
      ],
      [
        7,
        7
      ],
      [
        10,
        1
      ],
      [
        2,
        -9
      ],
      [
        1,
        -7
      ],
      [
        -5,
        -21
      ],
      [
        -19,
        -31
      ],
      [
        -11,
        -6
      ],
      [
        -35,
        0
      ],
      [
        -7,
        5
      ],
      [
        -5,
        2
      ],
      [
        -10,
        -7
      ],
      [
        -10,
        -13
      ],
      [
        -20,
        13
      ],
      [
        -10,
        10
      ],
      [
        -2,
        2
      ],
      [
        -3,
        16
      ],
      [
        -1,
        19
      ]
    ],
    [
      [
        6789,
        83718
      ],
      [
        14,
        -4
      ],
      [
        6,
        21
      ],
      [
        2,
        24
      ],
      [
        0,
        13
      ],
      [
        -1,
        9
      ],
      [
        3,
        30
      ],
      [
        18,
        75
      ],
      [
        3,
        5
      ],
      [
        4,
        5
      ],
      [
        3,
        -1
      ],
      [
        15,
        25
      ],
      [
        5,
        44
      ],
      [
        3,
        1
      ],
      [
        3,
        -5
      ],
      [
        9,
        -4
      ],
      [
        10,
        16
      ],
      [
        6,
        16
      ],
      [
        18,
        38
      ],
      [
        33,
        36
      ],
      [
        8,
        3
      ],
      [
        3,
        -7
      ],
      [
        28,
        -11
      ],
      [
        9,
        4
      ],
      [
        6,
        10
      ],
      [
        11,
        -5
      ],
      [
        3,
        -8
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -51
      ],
      [
        1,
        -59
      ],
      [
        3,
        -16
      ],
      [
        7,
        1
      ],
      [
        2,
        -3
      ],
      [
        3,
        -6
      ],
      [
        1,
        -4
      ],
      [
        1,
        -11
      ],
      [
        0,
        -24
      ],
      [
        9,
        6
      ],
      [
        4,
        45
      ],
      [
        2,
        10
      ],
      [
        6,
        10
      ],
      [
        6,
        20
      ],
      [
        3,
        13
      ],
      [
        -3,
        10
      ],
      [
        -6,
        18
      ],
      [
        -2,
        1
      ],
      [
        -7,
        19
      ],
      [
        0,
        5
      ],
      [
        1,
        14
      ],
      [
        2,
        4
      ],
      [
        3,
        2
      ],
      [
        30,
        -6
      ],
      [
        12,
        -6
      ],
      [
        11,
        -2
      ],
      [
        1,
        1
      ],
      [
        4,
        16
      ],
      [
        -3,
        9
      ],
      [
        -5,
        9
      ],
      [
        -34,
        31
      ],
      [
        -18,
        13
      ],
      [
        -7,
        -2
      ],
      [
        -8,
        -11
      ],
      [
        -3,
        1
      ],
      [
        -1,
        8
      ],
      [
        -1,
        127
      ],
      [
        31,
        61
      ],
      [
        19,
        21
      ],
      [
        10,
        8
      ],
      [
        20,
        -12
      ],
      [
        22,
        -56
      ],
      [
        5,
        -52
      ],
      [
        0,
        -32
      ],
      [
        -2,
        -29
      ],
      [
        1,
        -14
      ],
      [
        2,
        -6
      ],
      [
        9,
        -1
      ],
      [
        6,
        14
      ],
      [
        7,
        44
      ],
      [
        2,
        33
      ],
      [
        -5,
        23
      ],
      [
        -2,
        23
      ],
      [
        2,
        9
      ],
      [
        8,
        -3
      ],
      [
        13,
        -13
      ],
      [
        14,
        -22
      ],
      [
        3,
        2
      ],
      [
        5,
        23
      ],
      [
        1,
        6
      ],
      [
        -1,
        14
      ],
      [
        -1,
        2
      ],
      [
        -18,
        10
      ],
      [
        -15,
        19
      ],
      [
        -4,
        7
      ],
      [
        -14,
        33
      ],
      [
        -4,
        15
      ],
      [
        -3,
        10
      ],
      [
        1,
        12
      ],
      [
        4,
        26
      ],
      [
        2,
        6
      ],
      [
        8,
        9
      ],
      [
        4,
        1
      ],
      [
        2,
        -5
      ],
      [
        3,
        -11
      ],
      [
        50,
        -85
      ],
      [
        1,
        -2
      ],
      [
        9,
        4
      ],
      [
        30,
        -41
      ],
      [
        2,
        0
      ],
      [
        8,
        6
      ],
      [
        1,
        4
      ],
      [
        -31,
        75
      ],
      [
        -9,
        13
      ],
      [
        -11,
        21
      ],
      [
        -7,
        31
      ],
      [
        -1,
        7
      ],
      [
        1,
        6
      ],
      [
        6,
        2
      ],
      [
        11,
        -2
      ],
      [
        4,
        -9
      ],
      [
        1,
        -6
      ],
      [
        25,
        -43
      ],
      [
        8,
        12
      ],
      [
        10,
        3
      ],
      [
        11,
        -3
      ],
      [
        41,
        -29
      ],
      [
        2,
        1
      ],
      [
        4,
        17
      ],
      [
        1,
        31
      ],
      [
        36,
        15
      ],
      [
        -5,
        -49
      ],
      [
        -3,
        -14
      ],
      [
        -15,
        -40
      ],
      [
        -5,
        -9
      ],
      [
        -19,
        -57
      ],
      [
        -3,
        -14
      ],
      [
        -2,
        -23
      ],
      [
        -2,
        -46
      ],
      [
        3,
        -23
      ],
      [
        4,
        -11
      ],
      [
        3,
        -4
      ],
      [
        2,
        0
      ],
      [
        7,
        2
      ],
      [
        0,
        8
      ],
      [
        -1,
        6
      ],
      [
        -1,
        21
      ],
      [
        2,
        60
      ],
      [
        2,
        10
      ],
      [
        5,
        15
      ],
      [
        9,
        18
      ],
      [
        9,
        -21
      ],
      [
        2,
        -7
      ],
      [
        5,
        -21
      ],
      [
        5,
        46
      ],
      [
        10,
        23
      ],
      [
        7,
        9
      ],
      [
        4,
        19
      ],
      [
        0,
        17
      ],
      [
        1,
        5
      ],
      [
        14,
        10
      ],
      [
        0,
        -22
      ],
      [
        5,
        -9
      ],
      [
        5,
        0
      ],
      [
        7,
        15
      ],
      [
        11,
        33
      ],
      [
        4,
        24
      ],
      [
        11,
        16
      ],
      [
        3,
        -1
      ],
      [
        2,
        -3
      ],
      [
        1,
        -4
      ],
      [
        -3,
        -24
      ],
      [
        -4,
        -10
      ],
      [
        0,
        -4
      ],
      [
        3,
        -7
      ],
      [
        10,
        -7
      ],
      [
        8,
        2
      ],
      [
        10,
        -11
      ],
      [
        -2,
        -17
      ],
      [
        -9,
        -21
      ],
      [
        -4,
        3
      ],
      [
        -2,
        5
      ],
      [
        -3,
        4
      ],
      [
        -2,
        8
      ],
      [
        -3,
        1
      ],
      [
        -9,
        0
      ],
      [
        -6,
        -16
      ],
      [
        6,
        -23
      ],
      [
        13,
        -13
      ],
      [
        -6,
        -24
      ],
      [
        -3,
        -15
      ],
      [
        1,
        -5
      ],
      [
        3,
        -5
      ],
      [
        15,
        16
      ],
      [
        4,
        6
      ],
      [
        7,
        -12
      ],
      [
        4,
        -39
      ],
      [
        18,
        2
      ],
      [
        9,
        -1
      ],
      [
        -9,
        -25
      ],
      [
        -15,
        -28
      ],
      [
        -12,
        19
      ],
      [
        -2,
        3
      ],
      [
        0,
        4
      ],
      [
        -2,
        7
      ],
      [
        -7,
        3
      ],
      [
        -17,
        -1
      ],
      [
        -6,
        -10
      ],
      [
        -2,
        -5
      ],
      [
        -7,
        -29
      ],
      [
        0,
        -4
      ],
      [
        16,
        -9
      ],
      [
        -7,
        -28
      ],
      [
        -1,
        -25
      ],
      [
        7,
        -16
      ],
      [
        12,
        22
      ],
      [
        0,
        1
      ],
      [
        7,
        -15
      ],
      [
        -15,
        -38
      ],
      [
        -9,
        -42
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -3
      ],
      [
        2,
        -4
      ],
      [
        6,
        -5
      ],
      [
        4,
        3
      ],
      [
        6,
        17
      ],
      [
        5,
        6
      ],
      [
        6,
        34
      ],
      [
        7,
        13
      ],
      [
        7,
        -19
      ],
      [
        -2,
        -16
      ],
      [
        15,
        4
      ],
      [
        24,
        -2
      ],
      [
        5,
        -2
      ],
      [
        3,
        -4
      ],
      [
        -2,
        -30
      ],
      [
        -1,
        -11
      ],
      [
        -27,
        -67
      ],
      [
        -9,
        -11
      ],
      [
        -6,
        -36
      ],
      [
        -3,
        -22
      ],
      [
        0,
        -30
      ],
      [
        3,
        -11
      ],
      [
        -7,
        -11
      ],
      [
        -6,
        6
      ],
      [
        -16,
        8
      ],
      [
        -16,
        -1
      ],
      [
        7,
        25
      ],
      [
        -9,
        14
      ],
      [
        -4,
        -18
      ],
      [
        -6,
        -23
      ],
      [
        -15,
        19
      ],
      [
        -8,
        23
      ],
      [
        -13,
        -3
      ],
      [
        -4,
        -3
      ],
      [
        -6,
        4
      ],
      [
        -9,
        14
      ],
      [
        -1,
        3
      ],
      [
        0,
        8
      ],
      [
        -1,
        7
      ],
      [
        -6,
        13
      ],
      [
        -7,
        -1
      ],
      [
        -8,
        -12
      ],
      [
        -3,
        0
      ],
      [
        -5,
        3
      ],
      [
        -3,
        6
      ],
      [
        -13,
        10
      ],
      [
        -8,
        -9
      ],
      [
        6,
        -19
      ],
      [
        -6,
        -18
      ],
      [
        27,
        1
      ],
      [
        15,
        -17
      ],
      [
        6,
        -11
      ],
      [
        5,
        -17
      ],
      [
        14,
        -23
      ],
      [
        12,
        -9
      ],
      [
        3,
        -5
      ],
      [
        5,
        -22
      ],
      [
        -2,
        -22
      ],
      [
        -6,
        -48
      ],
      [
        -8,
        -22
      ],
      [
        -10,
        -26
      ],
      [
        -4,
        -6
      ],
      [
        -1,
        2
      ],
      [
        -1,
        33
      ],
      [
        -10,
        3
      ],
      [
        -6,
        -21
      ],
      [
        -4,
        -12
      ],
      [
        -9,
        -17
      ],
      [
        -19,
        30
      ],
      [
        -4,
        13
      ],
      [
        -2,
        25
      ],
      [
        -21,
        18
      ],
      [
        -7,
        0
      ],
      [
        -13,
        -12
      ],
      [
        -6,
        -9
      ],
      [
        -6,
        -13
      ],
      [
        -5,
        -15
      ],
      [
        5,
        -12
      ],
      [
        1,
        0
      ],
      [
        16,
        7
      ],
      [
        6,
        5
      ],
      [
        0,
        3
      ],
      [
        1,
        -1
      ],
      [
        12,
        -19
      ],
      [
        7,
        -28
      ],
      [
        1,
        -2
      ],
      [
        -3,
        -9
      ],
      [
        -13,
        -21
      ],
      [
        -16,
        -19
      ],
      [
        -6,
        -4
      ],
      [
        -13,
        0
      ],
      [
        -11,
        6
      ],
      [
        -1,
        4
      ],
      [
        -9,
        2
      ],
      [
        -3,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -10
      ],
      [
        14,
        -28
      ],
      [
        11,
        -6
      ],
      [
        8,
        9
      ],
      [
        6,
        4
      ],
      [
        35,
        1
      ],
      [
        19,
        -26
      ],
      [
        2,
        -5
      ],
      [
        1,
        -12
      ],
      [
        -8,
        -22
      ],
      [
        -3,
        -6
      ],
      [
        -11,
        -8
      ],
      [
        -13,
        0
      ],
      [
        -34,
        -33
      ],
      [
        -3,
        1
      ],
      [
        -1,
        3
      ],
      [
        -1,
        5
      ],
      [
        -3,
        2
      ],
      [
        -9,
        -7
      ],
      [
        -10,
        -22
      ],
      [
        -2,
        -9
      ],
      [
        0,
        -9
      ],
      [
        2,
        -5
      ],
      [
        3,
        0
      ],
      [
        1,
        -16
      ],
      [
        -1,
        -10
      ],
      [
        -9,
        -31
      ],
      [
        -18,
        -19
      ],
      [
        -3,
        1
      ],
      [
        -10,
        19
      ],
      [
        0,
        4
      ],
      [
        7,
        30
      ],
      [
        -1,
        7
      ],
      [
        -11,
        34
      ],
      [
        -9,
        -14
      ],
      [
        -1,
        11
      ],
      [
        -1,
        12
      ],
      [
        6,
        41
      ],
      [
        1,
        6
      ],
      [
        10,
        22
      ],
      [
        7,
        21
      ],
      [
        10,
        19
      ],
      [
        0,
        2
      ],
      [
        -1,
        10
      ],
      [
        -7,
        12
      ],
      [
        -11,
        -2
      ],
      [
        -5,
        -9
      ],
      [
        0,
        -5
      ],
      [
        1,
        -5
      ],
      [
        -34,
        -105
      ],
      [
        -1,
        -13
      ],
      [
        -2,
        -11
      ],
      [
        -11,
        14
      ],
      [
        -7,
        14
      ],
      [
        -4,
        4
      ],
      [
        -22,
        -10
      ],
      [
        -6,
        -17
      ],
      [
        1,
        -18
      ],
      [
        3,
        -1
      ],
      [
        17,
        4
      ],
      [
        2,
        -1
      ],
      [
        4,
        -8
      ],
      [
        10,
        -63
      ],
      [
        -3,
        -31
      ],
      [
        -13,
        -30
      ],
      [
        -7,
        -6
      ],
      [
        -10,
        -7
      ],
      [
        -8,
        -7
      ],
      [
        -1,
        -20
      ],
      [
        2,
        -37
      ],
      [
        0,
        -13
      ],
      [
        -3,
        -12
      ],
      [
        -11,
        -10
      ],
      [
        -11,
        -19
      ],
      [
        -12,
        13
      ],
      [
        -5,
        -22
      ],
      [
        -9,
        -34
      ],
      [
        -9,
        -26
      ],
      [
        -17,
        -27
      ],
      [
        -2,
        -3
      ],
      [
        -5,
        -2
      ],
      [
        -7,
        0
      ],
      [
        -2,
        15
      ],
      [
        -4,
        8
      ],
      [
        -4,
        0
      ],
      [
        -4,
        -4
      ],
      [
        -5,
        -10
      ],
      [
        -6,
        -6
      ],
      [
        -7,
        -4
      ],
      [
        -2,
        0
      ],
      [
        -3,
        4
      ],
      [
        6,
        43
      ],
      [
        15,
        68
      ],
      [
        1,
        5
      ],
      [
        4,
        6
      ],
      [
        4,
        4
      ],
      [
        3,
        1
      ],
      [
        13,
        40
      ],
      [
        13,
        31
      ],
      [
        13,
        12
      ],
      [
        11,
        19
      ],
      [
        4,
        20
      ],
      [
        -6,
        17
      ],
      [
        -13,
        -7
      ],
      [
        -3,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -5,
        -4
      ],
      [
        -11,
        -5
      ],
      [
        -1,
        9
      ],
      [
        4,
        43
      ],
      [
        14,
        60
      ],
      [
        8,
        42
      ],
      [
        3,
        3
      ],
      [
        5,
        -1
      ],
      [
        15,
        28
      ],
      [
        6,
        22
      ],
      [
        1,
        13
      ],
      [
        0,
        19
      ],
      [
        -3,
        3
      ],
      [
        -5,
        -5
      ],
      [
        -4,
        -18
      ],
      [
        -1,
        -3
      ],
      [
        -10,
        -24
      ],
      [
        -34,
        -61
      ],
      [
        -3,
        -19
      ],
      [
        -9,
        -39
      ],
      [
        -8,
        -34
      ],
      [
        -6,
        -20
      ],
      [
        -13,
        -16
      ],
      [
        -11,
        -43
      ],
      [
        -14,
        -11
      ],
      [
        -3,
        -16
      ],
      [
        -1,
        -15
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -5
      ],
      [
        -13,
        -22
      ],
      [
        -6,
        -8
      ],
      [
        -2,
        0
      ],
      [
        2,
        6
      ],
      [
        0,
        47
      ],
      [
        -2,
        23
      ],
      [
        -2,
        8
      ],
      [
        -20,
        48
      ],
      [
        -6,
        10
      ],
      [
        -19,
        18
      ],
      [
        -10,
        5
      ],
      [
        -4,
        4
      ],
      [
        -1,
        12
      ],
      [
        3,
        33
      ],
      [
        1,
        55
      ],
      [
        -4,
        106
      ],
      [
        -1,
        17
      ],
      [
        -2,
        15
      ],
      [
        -10,
        51
      ],
      [
        -6,
        20
      ],
      [
        -5,
        12
      ],
      [
        -22,
        19
      ],
      [
        -1,
        1
      ],
      [
        -12,
        -9
      ],
      [
        -10,
        4
      ],
      [
        -4,
        7
      ],
      [
        -1,
        3
      ],
      [
        12,
        22
      ],
      [
        2,
        8
      ],
      [
        -4,
        18
      ],
      [
        -11,
        19
      ],
      [
        5,
        23
      ]
    ],
    [
      [
        6782,
        82633
      ],
      [
        8,
        33
      ],
      [
        10,
        39
      ],
      [
        9,
        29
      ],
      [
        48,
        93
      ],
      [
        3,
        4
      ],
      [
        3,
        0
      ],
      [
        18,
        -4
      ],
      [
        10,
        -16
      ],
      [
        3,
        -8
      ],
      [
        1,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        2,
        -12
      ],
      [
        1,
        -5
      ],
      [
        0,
        -4
      ],
      [
        -12,
        -23
      ],
      [
        -26,
        -37
      ],
      [
        -12,
        -10
      ],
      [
        -17,
        -26
      ],
      [
        -10,
        -23
      ],
      [
        -6,
        -18
      ],
      [
        -4,
        -15
      ],
      [
        -9,
        -23
      ],
      [
        -2,
        -3
      ],
      [
        -6,
        0
      ],
      [
        -3,
        3
      ],
      [
        -4,
        8
      ],
      [
        -3,
        10
      ],
      [
        -1,
        9
      ],
      [
        0,
        8
      ]
    ],
    [
      [
        6519,
        81925
      ],
      [
        16,
        19
      ],
      [
        10,
        22
      ],
      [
        5,
        38
      ],
      [
        13,
        22
      ],
      [
        6,
        -6
      ],
      [
        2,
        -26
      ],
      [
        -6,
        -43
      ],
      [
        5,
        -45
      ],
      [
        0,
        -23
      ],
      [
        -7,
        -33
      ],
      [
        -36,
        13
      ],
      [
        -2,
        7
      ],
      [
        -6,
        50
      ],
      [
        0,
        5
      ]
    ],
    [
      [
        6240,
        82171
      ],
      [
        5,
        47
      ],
      [
        14,
        25
      ],
      [
        9,
        -23
      ],
      [
        4,
        -36
      ],
      [
        -11,
        -25
      ],
      [
        1,
        -24
      ],
      [
        -3,
        -14
      ],
      [
        -15,
        33
      ],
      [
        -4,
        17
      ]
    ],
    [
      [
        6921,
        85216
      ],
      [
        136,
        0
      ],
      [
        0,
        101
      ],
      [
        50,
        0
      ],
      [
        0,
        134
      ],
      [
        106,
        0
      ]
    ],
    [
      [
        7213,
        85451
      ],
      [
        -17,
        -9
      ],
      [
        -2,
        2
      ],
      [
        -3,
        0
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -8
      ],
      [
        -3,
        -18
      ],
      [
        0,
        -26
      ],
      [
        -4,
        -38
      ],
      [
        -5,
        -28
      ],
      [
        -7,
        -25
      ],
      [
        -5,
        -14
      ],
      [
        -4,
        0
      ],
      [
        -3,
        4
      ],
      [
        -2,
        0
      ],
      [
        -21,
        -29
      ],
      [
        -7,
        -20
      ],
      [
        -3,
        -22
      ],
      [
        -1,
        -13
      ],
      [
        -3,
        -6
      ],
      [
        -21,
        -27
      ],
      [
        -26,
        -7
      ],
      [
        -10,
        1
      ],
      [
        -7,
        6
      ],
      [
        -5,
        0
      ],
      [
        -13,
        -7
      ],
      [
        -2,
        -10
      ],
      [
        -4,
        -94
      ],
      [
        2,
        -2
      ],
      [
        -5,
        -20
      ],
      [
        -2,
        -4
      ],
      [
        -7,
        -7
      ],
      [
        -4,
        0
      ],
      [
        -1,
        4
      ],
      [
        -6,
        1
      ],
      [
        -16,
        -4
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -10
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -16
      ],
      [
        1,
        -13
      ],
      [
        1,
        -8
      ],
      [
        4,
        -25
      ],
      [
        4,
        -17
      ],
      [
        2,
        -2
      ],
      [
        3,
        2
      ],
      [
        4,
        -2
      ],
      [
        6,
        -13
      ],
      [
        -4,
        -17
      ],
      [
        -27,
        -36
      ],
      [
        -10,
        6
      ],
      [
        -2,
        4
      ],
      [
        -3,
        4
      ],
      [
        -5,
        1
      ],
      [
        -2,
        -16
      ],
      [
        0,
        -29
      ],
      [
        3,
        1
      ],
      [
        5,
        -7
      ],
      [
        12,
        -40
      ],
      [
        -11,
        -81
      ],
      [
        -9,
        -24
      ],
      [
        -12,
        -6
      ],
      [
        -6,
        -33
      ],
      [
        7,
        -16
      ],
      [
        2,
        -8
      ],
      [
        -4,
        -4
      ],
      [
        -13,
        -4
      ],
      [
        -6,
        8
      ],
      [
        -14,
        -52
      ],
      [
        -12,
        34
      ],
      [
        -12,
        28
      ],
      [
        -2,
        4
      ],
      [
        -7,
        -2
      ],
      [
        -2,
        -5
      ],
      [
        2,
        -15
      ],
      [
        2,
        -9
      ],
      [
        1,
        -33
      ],
      [
        -4,
        -40
      ],
      [
        -4,
        -7
      ],
      [
        -6,
        -3
      ],
      [
        -11,
        7
      ],
      [
        -8,
        -35
      ],
      [
        -4,
        -8
      ],
      [
        -17,
        16
      ],
      [
        -2,
        15
      ],
      [
        2,
        12
      ],
      [
        -1,
        5
      ],
      [
        -2,
        4
      ],
      [
        -4,
        2
      ],
      [
        -2,
        0
      ],
      [
        -11,
        -12
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -14
      ],
      [
        0,
        -20
      ],
      [
        -5,
        -11
      ],
      [
        -5,
        -10
      ],
      [
        -3,
        -2
      ],
      [
        -9,
        -1
      ],
      [
        -3,
        3
      ],
      [
        -1,
        7
      ],
      [
        -1,
        8
      ],
      [
        -1,
        3
      ],
      [
        -13,
        10
      ],
      [
        -4,
        0
      ],
      [
        -28,
        -17
      ],
      [
        -10,
        -16
      ],
      [
        -25,
        -53
      ],
      [
        6,
        -29
      ],
      [
        6,
        -20
      ],
      [
        3,
        -3
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -24
      ],
      [
        -4,
        -13
      ],
      [
        -4,
        -8
      ],
      [
        -16,
        -12
      ],
      [
        -24,
        -32
      ],
      [
        -9,
        -4
      ],
      [
        -8,
        2
      ],
      [
        -1,
        3
      ],
      [
        -6,
        3
      ],
      [
        -4,
        -6
      ],
      [
        0,
        -7
      ],
      [
        1,
        -46
      ],
      [
        7,
        -18
      ],
      [
        2,
        -4
      ],
      [
        5,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -25
      ],
      [
        -4,
        -13
      ],
      [
        -20,
        -16
      ],
      [
        -25,
        40
      ],
      [
        -11,
        19
      ],
      [
        -7,
        18
      ],
      [
        -3,
        12
      ],
      [
        -7,
        3
      ],
      [
        -4,
        -3
      ],
      [
        -4,
        -4
      ],
      [
        -3,
        -7
      ],
      [
        -2,
        -9
      ],
      [
        -5,
        -63
      ],
      [
        0,
        -13
      ],
      [
        2,
        -13
      ],
      [
        3,
        -6
      ],
      [
        -4,
        -37
      ],
      [
        -19,
        -17
      ],
      [
        -7,
        -10
      ],
      [
        -3,
        -46
      ],
      [
        1,
        -6
      ],
      [
        0,
        -39
      ],
      [
        -1,
        -6
      ],
      [
        -15,
        -4
      ],
      [
        -25,
        1
      ],
      [
        -10,
        -14
      ],
      [
        -9,
        4
      ],
      [
        -6,
        6
      ],
      [
        -5,
        11
      ],
      [
        -1,
        6
      ],
      [
        -6,
        15
      ],
      [
        -6,
        -2
      ],
      [
        -3,
        -6
      ],
      [
        -2,
        -74
      ],
      [
        1,
        -16
      ],
      [
        3,
        -19
      ],
      [
        6,
        -18
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -13
      ],
      [
        -20,
        0
      ],
      [
        -2,
        4
      ],
      [
        -10,
        33
      ],
      [
        -13,
        12
      ],
      [
        -4,
        -2
      ],
      [
        -4,
        -7
      ],
      [
        0,
        -17
      ],
      [
        -2,
        -17
      ],
      [
        -2,
        -5
      ],
      [
        -8,
        -2
      ],
      [
        -24,
        -25
      ],
      [
        -6,
        -20
      ],
      [
        -4,
        -11
      ],
      [
        -29,
        -61
      ],
      [
        -8,
        -4
      ],
      [
        -7,
        -8
      ],
      [
        -1,
        -10
      ],
      [
        -4,
        -34
      ],
      [
        4,
        -9
      ],
      [
        9,
        -2
      ],
      [
        24,
        35
      ],
      [
        23,
        29
      ],
      [
        4,
        -50
      ],
      [
        -3,
        -33
      ],
      [
        -3,
        -20
      ],
      [
        -4,
        5
      ],
      [
        -5,
        0
      ],
      [
        -6,
        -12
      ],
      [
        -1,
        -10
      ],
      [
        1,
        -21
      ],
      [
        3,
        -10
      ],
      [
        9,
        -16
      ],
      [
        4,
        -1
      ],
      [
        1,
        -2
      ],
      [
        1,
        -9
      ],
      [
        -6,
        -26
      ]
    ],
    [
      [
        6350,
        83478
      ],
      [
        -32,
        -5
      ],
      [
        -78,
        8
      ],
      [
        0,
        85
      ],
      [
        22,
        -1
      ],
      [
        0,
        68
      ],
      [
        14,
        -1
      ],
      [
        1,
        50
      ],
      [
        22,
        -2
      ],
      [
        -1,
        18
      ],
      [
        -3,
        0
      ],
      [
        0,
        18
      ],
      [
        14,
        -2
      ],
      [
        -2,
        84
      ],
      [
        14,
        -1
      ],
      [
        0,
        52
      ],
      [
        15,
        -1
      ],
      [
        0,
        18
      ],
      [
        9,
        0
      ],
      [
        1,
        34
      ],
      [
        45,
        0
      ],
      [
        0,
        -17
      ],
      [
        21,
        2
      ],
      [
        0,
        34
      ],
      [
        8,
        0
      ],
      [
        1,
        20
      ],
      [
        8,
        0
      ],
      [
        0,
        33
      ],
      [
        17,
        0
      ],
      [
        0,
        17
      ],
      [
        16,
        -1
      ],
      [
        0,
        -52
      ],
      [
        9,
        1
      ],
      [
        -1,
        19
      ],
      [
        8,
        0
      ],
      [
        0,
        17
      ],
      [
        7,
        0
      ],
      [
        0,
        17
      ],
      [
        14,
        0
      ],
      [
        0,
        16
      ],
      [
        -7,
        0
      ],
      [
        0,
        18
      ],
      [
        -15,
        -1
      ],
      [
        0,
        46
      ],
      [
        37,
        1
      ],
      [
        -1,
        34
      ],
      [
        6,
        -1
      ],
      [
        0,
        50
      ],
      [
        16,
        -1
      ],
      [
        -1,
        69
      ],
      [
        43,
        2
      ],
      [
        1,
        30
      ],
      [
        25,
        1
      ],
      [
        0,
        52
      ],
      [
        33,
        6
      ],
      [
        -1,
        200
      ],
      [
        14,
        -1
      ],
      [
        1,
        71
      ],
      [
        -15,
        -1
      ],
      [
        0,
        100
      ],
      [
        31,
        0
      ],
      [
        0,
        50
      ],
      [
        46,
        0
      ],
      [
        -1,
        33
      ],
      [
        15,
        0
      ],
      [
        -1,
        30
      ],
      [
        39,
        0
      ],
      [
        0,
        17
      ],
      [
        39,
        -1
      ],
      [
        0,
        33
      ],
      [
        44,
        0
      ],
      [
        0,
        33
      ],
      [
        29,
        0
      ],
      [
        0,
        35
      ],
      [
        10,
        0
      ],
      [
        0,
        33
      ],
      [
        22,
        -2
      ],
      [
        -1,
        50
      ],
      [
        15,
        0
      ],
      [
        -2,
        158
      ],
      [
        1,
        66
      ]
    ],
    [
      [
        6225,
        82357
      ],
      [
        2,
        22
      ],
      [
        7,
        13
      ],
      [
        1,
        -16
      ],
      [
        1,
        -37
      ],
      [
        1,
        -29
      ],
      [
        -3,
        -8
      ],
      [
        -7,
        7
      ],
      [
        -2,
        24
      ],
      [
        0,
        24
      ]
    ],
    [
      [
        6080,
        82757
      ],
      [
        7,
        23
      ],
      [
        3,
        7
      ],
      [
        11,
        18
      ],
      [
        29,
        2
      ],
      [
        15,
        -3
      ],
      [
        4,
        -2
      ],
      [
        14,
        -23
      ],
      [
        10,
        -14
      ],
      [
        4,
        -8
      ],
      [
        1,
        -5
      ],
      [
        -4,
        -4
      ],
      [
        -5,
        3
      ],
      [
        0,
        4
      ],
      [
        -4,
        5
      ],
      [
        -9,
        8
      ],
      [
        -17,
        3
      ],
      [
        -2,
        -1
      ],
      [
        -6,
        -11
      ],
      [
        -2,
        -10
      ],
      [
        -6,
        -4
      ],
      [
        -43,
        -6
      ],
      [
        -1,
        3
      ],
      [
        1,
        15
      ]
    ],
    [
      [
        5919,
        82533
      ],
      [
        19,
        25
      ],
      [
        7,
        -14
      ],
      [
        4,
        -43
      ],
      [
        -9,
        -11
      ],
      [
        -21,
        36
      ],
      [
        0,
        7
      ]
    ],
    [
      [
        5642,
        81925
      ],
      [
        4,
        47
      ],
      [
        4,
        17
      ],
      [
        19,
        12
      ],
      [
        14,
        -18
      ],
      [
        13,
        -40
      ],
      [
        0,
        -11
      ],
      [
        -2,
        -9
      ],
      [
        -6,
        2
      ],
      [
        -8,
        13
      ],
      [
        -13,
        24
      ],
      [
        -11,
        -4
      ],
      [
        -5,
        -31
      ],
      [
        8,
        -15
      ],
      [
        -1,
        -8
      ],
      [
        -14,
        3
      ],
      [
        -2,
        18
      ]
    ],
    [
      [
        5573,
        81984
      ],
      [
        8,
        -10
      ],
      [
        5,
        -15
      ],
      [
        3,
        -24
      ],
      [
        -13,
        -7
      ],
      [
        -14,
        19
      ],
      [
        11,
        37
      ]
    ],
    [
      [
        5506,
        81836
      ],
      [
        8,
        67
      ],
      [
        10,
        10
      ],
      [
        8,
        -25
      ],
      [
        4,
        -23
      ],
      [
        -1,
        -14
      ],
      [
        -8,
        -14
      ],
      [
        -12,
        -5
      ],
      [
        -12,
        -36
      ],
      [
        3,
        40
      ]
    ],
    [
      [
        5643,
        83066
      ],
      [
        7,
        -11
      ],
      [
        4,
        -5
      ],
      [
        19,
        -14
      ],
      [
        11,
        17
      ],
      [
        20,
        2
      ],
      [
        5,
        16
      ],
      [
        0,
        25
      ],
      [
        3,
        18
      ],
      [
        -5,
        11
      ],
      [
        -8,
        36
      ],
      [
        2,
        28
      ],
      [
        -4,
        18
      ],
      [
        6,
        71
      ],
      [
        9,
        51
      ],
      [
        10,
        38
      ],
      [
        19,
        70
      ],
      [
        23,
        74
      ],
      [
        18,
        56
      ],
      [
        24,
        62
      ],
      [
        22,
        37
      ],
      [
        22,
        27
      ],
      [
        18,
        14
      ],
      [
        7,
        36
      ],
      [
        3,
        3
      ],
      [
        4,
        0
      ],
      [
        7,
        13
      ],
      [
        4,
        15
      ],
      [
        11,
        41
      ],
      [
        5,
        26
      ],
      [
        2,
        5
      ],
      [
        14,
        15
      ],
      [
        26,
        62
      ],
      [
        4,
        6
      ],
      [
        19,
        19
      ],
      [
        7,
        0
      ],
      [
        -1,
        -7
      ],
      [
        1,
        -23
      ],
      [
        8,
        -44
      ],
      [
        10,
        -13
      ],
      [
        8,
        -2
      ],
      [
        4,
        32
      ],
      [
        0,
        9
      ],
      [
        -5,
        69
      ],
      [
        -3,
        30
      ],
      [
        -2,
        6
      ],
      [
        -12,
        2
      ],
      [
        -9,
        -5
      ],
      [
        -2,
        1
      ],
      [
        -6,
        34
      ],
      [
        2,
        95
      ],
      [
        9,
        59
      ],
      [
        8,
        112
      ],
      [
        6,
        107
      ],
      [
        3,
        86
      ],
      [
        4,
        63
      ],
      [
        4,
        41
      ],
      [
        1,
        5
      ],
      [
        6,
        24
      ],
      [
        7,
        13
      ],
      [
        5,
        3
      ],
      [
        6,
        0
      ],
      [
        27,
        13
      ],
      [
        4,
        13
      ],
      [
        8,
        40
      ],
      [
        -4,
        16
      ],
      [
        -2,
        -1
      ],
      [
        -4,
        -5
      ],
      [
        -5,
        -19
      ],
      [
        -5,
        0
      ],
      [
        -5,
        9
      ],
      [
        -20,
        42
      ],
      [
        -7,
        19
      ],
      [
        -2,
        7
      ],
      [
        -3,
        30
      ],
      [
        0,
        32
      ],
      [
        6,
        71
      ],
      [
        3,
        26
      ],
      [
        10,
        67
      ],
      [
        2,
        10
      ],
      [
        6,
        22
      ],
      [
        2,
        7
      ],
      [
        16,
        26
      ],
      [
        4,
        -4
      ],
      [
        7,
        11
      ],
      [
        7,
        21
      ],
      [
        5,
        16
      ],
      [
        9,
        40
      ],
      [
        7,
        20
      ]
    ],
    [
      [
        6173,
        85487
      ],
      [
        3,
        6
      ],
      [
        4,
        15
      ],
      [
        -3,
        43
      ],
      [
        4,
        25
      ],
      [
        9,
        13
      ],
      [
        -5,
        12
      ],
      [
        -7,
        -1
      ],
      [
        -8,
        -11
      ],
      [
        -8,
        -20
      ],
      [
        -3,
        -12
      ],
      [
        0,
        -38
      ],
      [
        -8,
        -30
      ],
      [
        -13,
        -23
      ],
      [
        -20,
        -23
      ],
      [
        -3,
        -3
      ]
    ],
    [
      [
        6115,
        85440
      ],
      [
        1,
        280
      ],
      [
        -22,
        0
      ],
      [
        0,
        202
      ],
      [
        47,
        0
      ],
      [
        0,
        101
      ],
      [
        93,
        0
      ],
      [
        0,
        101
      ],
      [
        27,
        0
      ],
      [
        0,
        101
      ],
      [
        47,
        0
      ],
      [
        0,
        100
      ],
      [
        95,
        0
      ],
      [
        0,
        101
      ],
      [
        46,
        0
      ],
      [
        0,
        1413
      ]
    ],
    [
      [
        6449,
        87839
      ],
      [
        713,
        0
      ]
    ],
    [
      [
        7162,
        87839
      ],
      [
        0,
        -101
      ],
      [
        12,
        0
      ],
      [
        0,
        -404
      ],
      [
        -36,
        0
      ],
      [
        0,
        -403
      ],
      [
        -36,
        0
      ],
      [
        0,
        -404
      ],
      [
        -35,
        0
      ],
      [
        0,
        -101
      ],
      [
        -48,
        0
      ],
      [
        0,
        -201
      ],
      [
        -47,
        0
      ],
      [
        0,
        -101
      ],
      [
        -81,
        0
      ],
      [
        0,
        -202
      ],
      [
        -93,
        0
      ],
      [
        0,
        -202
      ],
      [
        15,
        0
      ],
      [
        0,
        -403
      ],
      [
        14,
        0
      ],
      [
        0,
        -101
      ],
      [
        94,
        0
      ]
    ],
    [
      [
        6350,
        83478
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        -9
      ],
      [
        -18,
        -26
      ],
      [
        -6,
        -25
      ],
      [
        3,
        -7
      ],
      [
        1,
        -6
      ],
      [
        0,
        -11
      ],
      [
        -19,
        -35
      ],
      [
        -7,
        -9
      ],
      [
        -8,
        -32
      ],
      [
        4,
        -18
      ],
      [
        1,
        -21
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -1
      ],
      [
        -23,
        12
      ],
      [
        -9,
        2
      ],
      [
        -17,
        -19
      ],
      [
        -6,
        13
      ],
      [
        -3,
        -5
      ],
      [
        -5,
        -17
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -5
      ],
      [
        1,
        -22
      ],
      [
        -3,
        -35
      ],
      [
        -2,
        -7
      ],
      [
        -6,
        -9
      ],
      [
        -4,
        4
      ],
      [
        -10,
        48
      ],
      [
        -3,
        12
      ],
      [
        0,
        6
      ],
      [
        1,
        2
      ],
      [
        0,
        3
      ],
      [
        -1,
        3
      ],
      [
        -2,
        1
      ],
      [
        -4,
        0
      ],
      [
        -3,
        -3
      ],
      [
        -5,
        -10
      ],
      [
        0,
        -40
      ],
      [
        -14,
        -11
      ],
      [
        -5,
        -8
      ],
      [
        -3,
        -6
      ],
      [
        -5,
        -17
      ],
      [
        -11,
        -53
      ],
      [
        -24,
        -6
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -3
      ],
      [
        6,
        -24
      ],
      [
        0,
        -14
      ],
      [
        -6,
        -19
      ],
      [
        -6,
        -6
      ],
      [
        -5,
        -2
      ],
      [
        -23,
        39
      ],
      [
        -2,
        4
      ],
      [
        0,
        8
      ],
      [
        -2,
        9
      ],
      [
        -9,
        23
      ],
      [
        -13,
        27
      ],
      [
        -5,
        3
      ],
      [
        -3,
        0
      ],
      [
        -8,
        -7
      ],
      [
        -6,
        -12
      ],
      [
        -4,
        -17
      ],
      [
        0,
        -10
      ],
      [
        3,
        -18
      ],
      [
        1,
        -6
      ],
      [
        3,
        -4
      ],
      [
        3,
        3
      ],
      [
        4,
        -2
      ],
      [
        1,
        -2
      ],
      [
        2,
        -25
      ],
      [
        -1,
        -11
      ],
      [
        -29,
        -10
      ],
      [
        -3,
        -8
      ],
      [
        -4,
        -17
      ],
      [
        -2,
        -10
      ],
      [
        -4,
        -32
      ],
      [
        4,
        -26
      ],
      [
        2,
        -6
      ],
      [
        10,
        -10
      ],
      [
        2,
        0
      ],
      [
        5,
        5
      ],
      [
        1,
        -1
      ],
      [
        7,
        -32
      ],
      [
        0,
        -9
      ],
      [
        -2,
        -11
      ],
      [
        -2,
        -3
      ],
      [
        -8,
        -7
      ],
      [
        -11,
        -2
      ],
      [
        -3,
        4
      ],
      [
        -12,
        4
      ],
      [
        -4,
        -1
      ],
      [
        -3,
        -2
      ],
      [
        -6,
        -8
      ],
      [
        -11,
        -4
      ],
      [
        -8,
        23
      ],
      [
        -3,
        13
      ],
      [
        0,
        10
      ],
      [
        -1,
        5
      ],
      [
        -5,
        26
      ],
      [
        -5,
        5
      ],
      [
        -2,
        -1
      ],
      [
        -24,
        -30
      ],
      [
        -20,
        -12
      ],
      [
        -9,
        -23
      ],
      [
        -9,
        -28
      ],
      [
        -16,
        -3
      ],
      [
        -5,
        -15
      ],
      [
        -7,
        -12
      ],
      [
        3,
        -22
      ],
      [
        19,
        -1
      ],
      [
        27,
        25
      ],
      [
        20,
        -17
      ],
      [
        3,
        -16
      ],
      [
        3,
        -38
      ],
      [
        -2,
        -14
      ],
      [
        -10,
        -21
      ],
      [
        -4,
        -12
      ],
      [
        -7,
        5
      ],
      [
        -24,
        25
      ],
      [
        -12,
        14
      ],
      [
        -23,
        11
      ],
      [
        -3,
        -3
      ],
      [
        -3,
        -19
      ],
      [
        2,
        -6
      ],
      [
        3,
        -4
      ],
      [
        1,
        -4
      ],
      [
        -2,
        -27
      ],
      [
        -3,
        -7
      ],
      [
        -33,
        6
      ],
      [
        -11,
        18
      ],
      [
        -12,
        3
      ],
      [
        -20,
        -33
      ],
      [
        -27,
        -88
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -12
      ],
      [
        3,
        -27
      ],
      [
        16,
        2
      ],
      [
        10,
        -17
      ],
      [
        17,
        -6
      ],
      [
        2,
        2
      ],
      [
        2,
        -1
      ],
      [
        32,
        -36
      ],
      [
        1,
        -12
      ],
      [
        -4,
        -17
      ],
      [
        -10,
        -19
      ],
      [
        -6,
        -5
      ],
      [
        -16,
        -18
      ],
      [
        -2,
        -18
      ],
      [
        3,
        -5
      ],
      [
        18,
        -4
      ],
      [
        21,
        19
      ],
      [
        4,
        12
      ],
      [
        15,
        6
      ],
      [
        2,
        0
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -11
      ],
      [
        -33,
        -50
      ],
      [
        -22,
        -28
      ],
      [
        -17,
        -34
      ],
      [
        -6,
        -29
      ],
      [
        1,
        -20
      ],
      [
        0,
        -32
      ],
      [
        -1,
        -2
      ],
      [
        -7,
        7
      ],
      [
        -4,
        29
      ],
      [
        0,
        2
      ],
      [
        2,
        5
      ],
      [
        -1,
        3
      ],
      [
        -2,
        6
      ],
      [
        -4,
        1
      ],
      [
        -2,
        -2
      ],
      [
        -4,
        -16
      ],
      [
        1,
        -6
      ],
      [
        7,
        -38
      ],
      [
        8,
        -22
      ],
      [
        3,
        -25
      ],
      [
        -1,
        -12
      ],
      [
        -5,
        -12
      ],
      [
        -3,
        -1
      ],
      [
        -1,
        5
      ],
      [
        -6,
        34
      ],
      [
        -3,
        2
      ],
      [
        -7,
        -4
      ],
      [
        -1,
        -11
      ],
      [
        2,
        -6
      ],
      [
        1,
        -4
      ],
      [
        0,
        -21
      ],
      [
        -1,
        -9
      ],
      [
        -3,
        -2
      ],
      [
        -24,
        76
      ],
      [
        -1,
        4
      ],
      [
        1,
        72
      ],
      [
        3,
        6
      ],
      [
        3,
        4
      ],
      [
        0,
        3
      ],
      [
        -7,
        10
      ],
      [
        -8,
        -11
      ],
      [
        -4,
        -8
      ],
      [
        -5,
        -18
      ],
      [
        -2,
        -23
      ],
      [
        2,
        -51
      ],
      [
        2,
        -4
      ],
      [
        3,
        -9
      ],
      [
        1,
        -9
      ],
      [
        0,
        -35
      ],
      [
        -4,
        -32
      ],
      [
        -6,
        -8
      ],
      [
        -18,
        2
      ],
      [
        -3,
        7
      ],
      [
        -1,
        5
      ],
      [
        5,
        38
      ],
      [
        2,
        8
      ],
      [
        -5,
        8
      ],
      [
        -30,
        -7
      ],
      [
        -12,
        -61
      ],
      [
        -4,
        -19
      ],
      [
        -25,
        -9
      ],
      [
        -38,
        -21
      ],
      [
        -37,
        -22
      ],
      [
        -22,
        -15
      ],
      [
        -7,
        -7
      ],
      [
        -6,
        -17
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -24
      ],
      [
        -1,
        -25
      ],
      [
        2,
        -16
      ],
      [
        -2,
        -9
      ],
      [
        -4,
        0
      ],
      [
        -3,
        5
      ],
      [
        -10,
        41
      ],
      [
        -1,
        12
      ],
      [
        1,
        5
      ],
      [
        2,
        11
      ],
      [
        3,
        52
      ],
      [
        -8,
        5
      ],
      [
        -3,
        -2
      ],
      [
        -10,
        -13
      ],
      [
        -2,
        -9
      ],
      [
        10,
        -30
      ],
      [
        1,
        -104
      ],
      [
        -2,
        -21
      ],
      [
        -5,
        -14
      ],
      [
        -4,
        -8
      ],
      [
        -4,
        -20
      ],
      [
        -1,
        -8
      ],
      [
        5,
        -17
      ],
      [
        1,
        -29
      ],
      [
        -4,
        -22
      ],
      [
        -3,
        -9
      ]
    ],
    [
      [
        9331,
        87212
      ],
      [
        19,
        -3
      ],
      [
        9,
        -11
      ],
      [
        5,
        -22
      ],
      [
        5,
        -4
      ],
      [
        2,
        -18
      ],
      [
        -6,
        -9
      ],
      [
        -9,
        -10
      ],
      [
        -12,
        10
      ],
      [
        -9,
        26
      ],
      [
        -8,
        36
      ],
      [
        4,
        5
      ]
    ],
    [
      [
        9232,
        87245
      ],
      [
        16,
        14
      ],
      [
        21,
        -8
      ],
      [
        13,
        -12
      ],
      [
        19,
        1
      ],
      [
        5,
        -7
      ],
      [
        -3,
        -31
      ],
      [
        -7,
        -8
      ],
      [
        -14,
        -2
      ],
      [
        -10,
        8
      ],
      [
        -12,
        22
      ],
      [
        -22,
        13
      ],
      [
        -6,
        10
      ]
    ],
    [
      [
        8867,
        87809
      ],
      [
        22,
        29
      ],
      [
        4,
        6
      ],
      [
        5,
        -2
      ],
      [
        2,
        -3
      ],
      [
        3,
        -4
      ],
      [
        4,
        1
      ],
      [
        2,
        2
      ],
      [
        6,
        5
      ],
      [
        5,
        4
      ],
      [
        4,
        -2
      ],
      [
        11,
        -14
      ],
      [
        1,
        -7
      ],
      [
        -5,
        -22
      ],
      [
        -10,
        -19
      ],
      [
        -4,
        -5
      ],
      [
        -14,
        9
      ],
      [
        -6,
        8
      ],
      [
        -1,
        1
      ],
      [
        -10,
        4
      ],
      [
        -16,
        1
      ],
      [
        -4,
        4
      ],
      [
        1,
        4
      ]
    ],
    [
      [
        8817,
        87545
      ],
      [
        5,
        34
      ],
      [
        -1,
        52
      ],
      [
        25,
        18
      ],
      [
        3,
        -2
      ],
      [
        7,
        -31
      ],
      [
        14,
        -58
      ],
      [
        -11,
        -44
      ],
      [
        -29,
        -9
      ],
      [
        -8,
        -1
      ],
      [
        -5,
        41
      ]
    ],
    [
      [
        8816,
        87079
      ],
      [
        2,
        14
      ],
      [
        21,
        17
      ],
      [
        22,
        30
      ],
      [
        1,
        -36
      ],
      [
        -40,
        -59
      ],
      [
        -5,
        13
      ],
      [
        -1,
        21
      ]
    ],
    [
      [
        8698,
        86532
      ],
      [
        8,
        21
      ],
      [
        0,
        16
      ],
      [
        -4,
        25
      ],
      [
        7,
        30
      ],
      [
        9,
        11
      ],
      [
        14,
        1
      ],
      [
        1,
        25
      ],
      [
        -4,
        17
      ],
      [
        3,
        14
      ],
      [
        8,
        11
      ],
      [
        10,
        29
      ],
      [
        8,
        -4
      ],
      [
        8,
        11
      ],
      [
        1,
        17
      ],
      [
        -8,
        8
      ],
      [
        4,
        16
      ],
      [
        15,
        15
      ],
      [
        15,
        19
      ],
      [
        9,
        30
      ],
      [
        19,
        26
      ],
      [
        24,
        49
      ],
      [
        7,
        36
      ],
      [
        0,
        16
      ],
      [
        12,
        28
      ],
      [
        3,
        38
      ],
      [
        12,
        18
      ],
      [
        15,
        26
      ],
      [
        7,
        25
      ],
      [
        -10,
        15
      ],
      [
        4,
        17
      ],
      [
        1,
        27
      ],
      [
        5,
        27
      ],
      [
        12,
        20
      ],
      [
        15,
        14
      ],
      [
        5,
        -13
      ],
      [
        -5,
        -14
      ],
      [
        4,
        -16
      ],
      [
        12,
        -1
      ],
      [
        12,
        3
      ],
      [
        -1,
        -14
      ],
      [
        -9,
        -23
      ],
      [
        -7,
        -14
      ],
      [
        9,
        -17
      ],
      [
        9,
        13
      ],
      [
        15,
        15
      ],
      [
        6,
        -1
      ],
      [
        2,
        -21
      ],
      [
        -11,
        -37
      ],
      [
        -7,
        -15
      ],
      [
        -11,
        -24
      ],
      [
        -20,
        -39
      ],
      [
        -24,
        -40
      ],
      [
        -10,
        -22
      ],
      [
        -12,
        -37
      ],
      [
        -14,
        -36
      ],
      [
        -13,
        -34
      ],
      [
        -6,
        -36
      ],
      [
        2,
        -26
      ],
      [
        -4,
        -18
      ],
      [
        12,
        -19
      ],
      [
        -9,
        -11
      ],
      [
        -14,
        15
      ],
      [
        -9,
        -14
      ],
      [
        -8,
        -12
      ],
      [
        -5,
        -19
      ],
      [
        8,
        -24
      ],
      [
        8,
        -4
      ],
      [
        14,
        -29
      ],
      [
        -5,
        -16
      ],
      [
        -14,
        -26
      ],
      [
        -13,
        0
      ],
      [
        -10,
        -8
      ],
      [
        -7,
        19
      ],
      [
        -15,
        -4
      ],
      [
        -8,
        -17
      ],
      [
        1,
        -18
      ],
      [
        -10,
        -22
      ],
      [
        -9,
        6
      ],
      [
        -14,
        -10
      ],
      [
        -10,
        -12
      ],
      [
        -8,
        -18
      ],
      [
        -13,
        -7
      ],
      [
        -9,
        9
      ],
      [
        -5,
        14
      ]
    ],
    [
      [
        8692,
        87068
      ],
      [
        4,
        34
      ],
      [
        27,
        164
      ],
      [
        13,
        72
      ],
      [
        2,
        8
      ],
      [
        2,
        1
      ],
      [
        3,
        -8
      ],
      [
        -4,
        -23
      ],
      [
        8,
        -19
      ],
      [
        4,
        1
      ],
      [
        6,
        7
      ],
      [
        2,
        5
      ],
      [
        -2,
        18
      ],
      [
        -3,
        6
      ],
      [
        0,
        35
      ],
      [
        1,
        7
      ],
      [
        30,
        67
      ],
      [
        14,
        17
      ],
      [
        1,
        -1
      ],
      [
        2,
        -7
      ],
      [
        1,
        -17
      ],
      [
        -4,
        -29
      ],
      [
        -12,
        -32
      ],
      [
        -4,
        -48
      ],
      [
        1,
        -34
      ],
      [
        -15,
        -26
      ],
      [
        -5,
        -11
      ],
      [
        2,
        -19
      ],
      [
        15,
        1
      ],
      [
        2,
        -6
      ],
      [
        1,
        -18
      ],
      [
        -6,
        -33
      ],
      [
        -9,
        -36
      ],
      [
        -9,
        -28
      ],
      [
        2,
        -46
      ],
      [
        -2,
        -21
      ],
      [
        -4,
        -30
      ],
      [
        -11,
        -53
      ],
      [
        -2,
        -3
      ],
      [
        -5,
        8
      ],
      [
        -10,
        22
      ],
      [
        -7,
        18
      ],
      [
        4,
        3
      ],
      [
        1,
        3
      ],
      [
        -1,
        8
      ],
      [
        -7,
        11
      ],
      [
        -15,
        9
      ],
      [
        -10,
        -2
      ],
      [
        -3,
        7
      ],
      [
        2,
        18
      ]
    ],
    [
      [
        8672,
        87628
      ],
      [
        15,
        31
      ],
      [
        3,
        -5
      ],
      [
        1,
        -7
      ],
      [
        13,
        -7
      ],
      [
        16,
        -43
      ],
      [
        1,
        -5
      ],
      [
        -4,
        -20
      ],
      [
        -2,
        -7
      ],
      [
        -18,
        -18
      ],
      [
        -11,
        21
      ],
      [
        -14,
        60
      ]
    ],
    [
      [
        8549,
        88444
      ],
      [
        350,
        0
      ],
      [
        0,
        52
      ],
      [
        73,
        0
      ],
      [
        0,
        403
      ],
      [
        -5,
        0
      ],
      [
        0,
        404
      ],
      [
        -5,
        0
      ],
      [
        0,
        101
      ],
      [
        155,
        0
      ],
      [
        -4,
        302
      ],
      [
        0,
        404
      ],
      [
        -3,
        0
      ],
      [
        0,
        117
      ],
      [
        -13,
        0
      ],
      [
        0,
        246
      ]
    ],
    [
      [
        9097,
        90473
      ],
      [
        8,
        10
      ],
      [
        35,
        15
      ],
      [
        34,
        -7
      ],
      [
        8,
        -5
      ],
      [
        14,
        5
      ],
      [
        8,
        17
      ],
      [
        0,
        22
      ],
      [
        267,
        0
      ],
      [
        0,
        -101
      ],
      [
        160,
        0
      ],
      [
        0,
        -17
      ],
      [
        403,
        0
      ],
      [
        -2,
        -6
      ],
      [
        5,
        -22
      ],
      [
        -1,
        -31
      ],
      [
        3,
        -11
      ],
      [
        -3,
        -18
      ],
      [
        10,
        -7
      ],
      [
        1,
        -12
      ],
      [
        -4,
        -20
      ],
      [
        27,
        -14
      ],
      [
        2,
        -15
      ],
      [
        -2,
        -10
      ],
      [
        -10,
        -6
      ],
      [
        2,
        -43
      ],
      [
        -10,
        -19
      ],
      [
        2,
        -7
      ],
      [
        -7,
        -16
      ],
      [
        -3,
        -19
      ],
      [
        -7,
        -3
      ],
      [
        -3,
        -23
      ],
      [
        -8,
        -6
      ],
      [
        -1,
        -20
      ],
      [
        -12,
        -7
      ],
      [
        12,
        -32
      ],
      [
        7,
        3
      ],
      [
        24,
        -39
      ],
      [
        9,
        4
      ],
      [
        3,
        -9
      ],
      [
        -12,
        -34
      ],
      [
        -13,
        -42
      ],
      [
        -8,
        0
      ],
      [
        -4,
        -12
      ],
      [
        5,
        -7
      ],
      [
        3,
        -23
      ],
      [
        -12,
        -1
      ],
      [
        -4,
        -15
      ],
      [
        6,
        -24
      ],
      [
        13,
        -18
      ],
      [
        25,
        0
      ],
      [
        13,
        -20
      ],
      [
        6,
        -3
      ],
      [
        5,
        19
      ],
      [
        13,
        -9
      ],
      [
        4,
        4
      ],
      [
        10,
        -7
      ],
      [
        -2,
        9
      ],
      [
        3,
        18
      ],
      [
        7,
        17
      ],
      [
        3,
        18
      ],
      [
        14,
        4
      ],
      [
        -3,
        29
      ],
      [
        5,
        5
      ],
      [
        -1,
        14
      ],
      [
        5,
        17
      ],
      [
        9,
        -3
      ],
      [
        4,
        -8
      ],
      [
        10,
        -5
      ],
      [
        2,
        -19
      ],
      [
        9,
        0
      ],
      [
        3,
        13
      ],
      [
        8,
        -10
      ],
      [
        15,
        -3
      ],
      [
        53,
        0
      ],
      [
        0,
        -101
      ],
      [
        52,
        0
      ],
      [
        0,
        -101
      ],
      [
        42,
        0
      ],
      [
        0,
        -403
      ],
      [
        -11,
        0
      ],
      [
        0,
        -54
      ],
      [
        51,
        -1
      ],
      [
        0,
        -248
      ],
      [
        231,
        0
      ]
    ],
    [
      [
        10627,
        89000
      ],
      [
        1,
        -172
      ],
      [
        -1,
        -32
      ],
      [
        1,
        -58
      ],
      [
        0,
        -282
      ],
      [
        1,
        -427
      ],
      [
        -1,
        -686
      ],
      [
        0,
        -103
      ]
    ],
    [
      [
        10628,
        87240
      ],
      [
        -59,
        0
      ],
      [
        0,
        51
      ],
      [
        -161,
        0
      ],
      [
        0,
        100
      ],
      [
        -391,
        0
      ],
      [
        -110,
        -325
      ],
      [
        -85,
        -254
      ],
      [
        0,
        -44
      ]
    ],
    [
      [
        9822,
        86768
      ],
      [
        -1,
        0
      ],
      [
        -38,
        39
      ],
      [
        -45,
        -26
      ],
      [
        -64,
        -120
      ],
      [
        -7,
        -26
      ],
      [
        -39,
        -89
      ],
      [
        -3,
        2
      ],
      [
        9,
        63
      ],
      [
        36,
        103
      ],
      [
        32,
        61
      ],
      [
        30,
        56
      ],
      [
        46,
        2
      ],
      [
        1,
        20
      ],
      [
        -17,
        46
      ],
      [
        -49,
        48
      ],
      [
        -8,
        25
      ],
      [
        -10,
        -18
      ],
      [
        7,
        -26
      ],
      [
        -1,
        -18
      ],
      [
        -6,
        -20
      ],
      [
        -22,
        66
      ],
      [
        -4,
        18
      ],
      [
        -3,
        3
      ],
      [
        -9,
        4
      ],
      [
        -14,
        23
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        -11,
        4
      ],
      [
        -16,
        27
      ],
      [
        -71,
        19
      ],
      [
        -6,
        9
      ],
      [
        15,
        19
      ],
      [
        38,
        23
      ],
      [
        -18,
        19
      ],
      [
        -24,
        14
      ],
      [
        -6,
        -14
      ],
      [
        -13,
        8
      ],
      [
        -2,
        25
      ],
      [
        15,
        63
      ],
      [
        11,
        51
      ],
      [
        5,
        11
      ],
      [
        6,
        31
      ],
      [
        -4,
        14
      ],
      [
        -7,
        2
      ],
      [
        -4,
        -1
      ],
      [
        -4,
        -16
      ],
      [
        -9,
        -20
      ],
      [
        -17,
        -13
      ],
      [
        -12,
        -9
      ],
      [
        0,
        -46
      ],
      [
        -1,
        -11
      ],
      [
        -13,
        -44
      ],
      [
        -7,
        -22
      ],
      [
        -6,
        -5
      ],
      [
        -23,
        9
      ],
      [
        -10,
        8
      ],
      [
        -23,
        31
      ],
      [
        -47,
        66
      ],
      [
        -2,
        17
      ],
      [
        2,
        2
      ],
      [
        1,
        7
      ],
      [
        0,
        5
      ],
      [
        -10,
        11
      ],
      [
        -7,
        15
      ],
      [
        -9,
        10
      ],
      [
        -21,
        16
      ],
      [
        -18,
        10
      ],
      [
        -18,
        -14
      ],
      [
        -15,
        -19
      ],
      [
        -8,
        -2
      ],
      [
        -18,
        13
      ],
      [
        -3,
        7
      ],
      [
        -1,
        4
      ],
      [
        0,
        3
      ],
      [
        13,
        29
      ],
      [
        14,
        11
      ],
      [
        17,
        21
      ],
      [
        25,
        74
      ],
      [
        -7,
        14
      ],
      [
        -7,
        -4
      ],
      [
        -5,
        -15
      ],
      [
        -5,
        -20
      ],
      [
        -6,
        -14
      ],
      [
        -2,
        0
      ],
      [
        -38,
        -42
      ],
      [
        -21,
        -24
      ],
      [
        -10,
        -15
      ],
      [
        -10,
        -12
      ],
      [
        -29,
        -23
      ],
      [
        -9,
        1
      ],
      [
        -18,
        7
      ],
      [
        -1,
        4
      ],
      [
        -10,
        -7
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -28
      ],
      [
        2,
        -20
      ],
      [
        5,
        -1
      ],
      [
        6,
        8
      ],
      [
        7,
        4
      ],
      [
        42,
        16
      ],
      [
        2,
        -1
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        9,
        -16
      ],
      [
        2,
        -53
      ],
      [
        -17,
        2
      ],
      [
        -14,
        -22
      ],
      [
        -14,
        -15
      ],
      [
        -18,
        6
      ],
      [
        -23,
        -15
      ],
      [
        -18,
        -23
      ],
      [
        -9,
        -15
      ],
      [
        -13,
        -28
      ],
      [
        -19,
        -34
      ],
      [
        -6,
        -2
      ],
      [
        -4,
        1
      ],
      [
        -2,
        3
      ],
      [
        -11,
        33
      ],
      [
        -1,
        9
      ],
      [
        0,
        6
      ],
      [
        3,
        9
      ],
      [
        9,
        15
      ],
      [
        15,
        19
      ],
      [
        7,
        0
      ],
      [
        8,
        20
      ],
      [
        5,
        14
      ],
      [
        -5,
        9
      ],
      [
        -9,
        -1
      ],
      [
        -9,
        -7
      ],
      [
        -5,
        -12
      ],
      [
        -9,
        -1
      ],
      [
        -17,
        11
      ],
      [
        -2,
        12
      ],
      [
        0,
        32
      ],
      [
        1,
        10
      ],
      [
        23,
        83
      ],
      [
        8,
        21
      ],
      [
        5,
        6
      ],
      [
        18,
        2
      ],
      [
        1,
        -6
      ],
      [
        5,
        -12
      ],
      [
        14,
        -13
      ],
      [
        24,
        17
      ],
      [
        15,
        20
      ],
      [
        7,
        21
      ],
      [
        38,
        13
      ],
      [
        21,
        19
      ],
      [
        36,
        39
      ],
      [
        18,
        11
      ],
      [
        3,
        -1
      ],
      [
        8,
        2
      ],
      [
        13,
        8
      ],
      [
        1,
        9
      ],
      [
        0,
        2
      ],
      [
        -6,
        11
      ],
      [
        -4,
        3
      ],
      [
        -7,
        -5
      ],
      [
        -9,
        -1
      ],
      [
        -2,
        2
      ],
      [
        -1,
        2
      ],
      [
        1,
        18
      ],
      [
        0,
        26
      ],
      [
        3,
        8
      ],
      [
        5,
        10
      ],
      [
        7,
        22
      ],
      [
        0,
        5
      ],
      [
        -3,
        0
      ],
      [
        -2,
        -2
      ],
      [
        -4,
        -6
      ],
      [
        -6,
        -10
      ],
      [
        -1,
        -4
      ],
      [
        -6,
        -22
      ],
      [
        -1,
        -4
      ],
      [
        -3,
        -19
      ],
      [
        -1,
        -2
      ],
      [
        -7,
        -9
      ],
      [
        -11,
        -9
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        10
      ],
      [
        2,
        18
      ],
      [
        9,
        32
      ],
      [
        8,
        17
      ],
      [
        2,
        3
      ],
      [
        6,
        13
      ],
      [
        3,
        10
      ],
      [
        -1,
        12
      ],
      [
        -1,
        -1
      ],
      [
        -20,
        -35
      ],
      [
        -11,
        -20
      ],
      [
        -2,
        -3
      ],
      [
        -9,
        -7
      ],
      [
        -8,
        -8
      ],
      [
        -9,
        -10
      ],
      [
        -4,
        -5
      ],
      [
        -3,
        -6
      ],
      [
        -1,
        -3
      ],
      [
        -11,
        -8
      ],
      [
        -19,
        -3
      ],
      [
        -1,
        5
      ],
      [
        -1,
        7
      ],
      [
        -2,
        10
      ],
      [
        0,
        8
      ],
      [
        2,
        4
      ],
      [
        21,
        42
      ],
      [
        2,
        5
      ],
      [
        11,
        19
      ],
      [
        4,
        5
      ],
      [
        7,
        8
      ],
      [
        16,
        29
      ],
      [
        -1,
        12
      ],
      [
        -1,
        11
      ],
      [
        -4,
        15
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        -4,
        -11
      ],
      [
        -1,
        -4
      ],
      [
        -9,
        -18
      ],
      [
        -11,
        -19
      ],
      [
        -2,
        -1
      ],
      [
        -6,
        8
      ],
      [
        -3,
        3
      ],
      [
        0,
        10
      ],
      [
        -2,
        1
      ],
      [
        -2,
        -3
      ],
      [
        -4,
        -7
      ],
      [
        0,
        -16
      ],
      [
        -3,
        -6
      ],
      [
        -5,
        -4
      ],
      [
        -13,
        0
      ],
      [
        -2,
        6
      ],
      [
        -1,
        3
      ],
      [
        -1,
        3
      ],
      [
        2,
        13
      ],
      [
        -10,
        1
      ],
      [
        -11,
        -24
      ],
      [
        -4,
        -25
      ],
      [
        -3,
        -3
      ],
      [
        -17,
        -11
      ],
      [
        -7,
        -1
      ],
      [
        -5,
        9
      ],
      [
        -4,
        2
      ],
      [
        -13,
        0
      ],
      [
        -8,
        -4
      ],
      [
        -5,
        -7
      ],
      [
        -7,
        3
      ],
      [
        -5,
        11
      ],
      [
        -9,
        46
      ],
      [
        -1,
        12
      ],
      [
        27,
        19
      ],
      [
        11,
        -9
      ],
      [
        18,
        25
      ],
      [
        10,
        -2
      ],
      [
        30,
        18
      ],
      [
        15,
        14
      ],
      [
        14,
        14
      ],
      [
        20,
        43
      ],
      [
        3,
        18
      ],
      [
        0,
        4
      ],
      [
        -4,
        4
      ],
      [
        -21,
        -2
      ],
      [
        -2,
        -5
      ],
      [
        -6,
        -24
      ],
      [
        -6,
        -17
      ],
      [
        -6,
        -7
      ],
      [
        -17,
        -12
      ],
      [
        -43,
        -3
      ],
      [
        -2,
        1
      ],
      [
        -18,
        68
      ],
      [
        -12,
        3
      ],
      [
        -10,
        -27
      ],
      [
        -5,
        -14
      ],
      [
        -1,
        -7
      ],
      [
        2,
        -11
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -3
      ],
      [
        -8,
        -5
      ],
      [
        -13,
        -3
      ],
      [
        -5,
        13
      ],
      [
        0,
        30
      ],
      [
        1,
        16
      ],
      [
        8,
        12
      ],
      [
        3,
        12
      ],
      [
        5,
        2
      ],
      [
        8,
        -14
      ],
      [
        9,
        8
      ],
      [
        -4,
        27
      ],
      [
        -7,
        17
      ],
      [
        -3,
        29
      ],
      [
        0,
        26
      ],
      [
        13,
        34
      ],
      [
        7,
        42
      ],
      [
        6,
        29
      ],
      [
        -2,
        15
      ],
      [
        5,
        16
      ],
      [
        10,
        12
      ],
      [
        48,
        0
      ],
      [
        48,
        6
      ],
      [
        2,
        10
      ],
      [
        -4,
        17
      ],
      [
        -5,
        11
      ],
      [
        -32,
        3
      ],
      [
        -6,
        9
      ],
      [
        -19,
        -12
      ],
      [
        -34,
        -5
      ],
      [
        -9,
        -17
      ],
      [
        -12,
        -46
      ],
      [
        -24,
        -22
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -17,
        -48
      ],
      [
        -4,
        -21
      ],
      [
        0,
        -8
      ],
      [
        -2,
        -5
      ],
      [
        -3,
        -8
      ],
      [
        -14,
        -24
      ],
      [
        -12,
        -11
      ],
      [
        -19,
        9
      ],
      [
        -4,
        3
      ],
      [
        10,
        17
      ],
      [
        10,
        19
      ],
      [
        2,
        23
      ],
      [
        -6,
        21
      ],
      [
        -1,
        32
      ],
      [
        -5,
        37
      ],
      [
        -7,
        25
      ],
      [
        -5,
        28
      ],
      [
        11,
        11
      ],
      [
        7,
        19
      ],
      [
        -6,
        7
      ],
      [
        -16,
        3
      ],
      [
        -9,
        -5
      ],
      [
        -5,
        -18
      ],
      [
        7,
        -21
      ],
      [
        -5,
        -21
      ],
      [
        -3,
        -9
      ],
      [
        6,
        -13
      ],
      [
        4,
        -25
      ],
      [
        2,
        -25
      ],
      [
        -2,
        -29
      ],
      [
        -5,
        -9
      ],
      [
        -7,
        -25
      ],
      [
        -2,
        -21
      ],
      [
        3,
        -20
      ],
      [
        -3,
        -7
      ],
      [
        -7,
        -8
      ],
      [
        -3,
        0
      ],
      [
        -7,
        11
      ],
      [
        -3,
        7
      ],
      [
        -1,
        5
      ],
      [
        -2,
        11
      ],
      [
        2,
        8
      ],
      [
        0,
        17
      ],
      [
        -9,
        -5
      ],
      [
        -6,
        -6
      ],
      [
        -1,
        -15
      ],
      [
        -1,
        -52
      ],
      [
        -26,
        -43
      ],
      [
        -1,
        -2
      ],
      [
        -11,
        10
      ],
      [
        -9,
        9
      ],
      [
        -1,
        3
      ],
      [
        0,
        52
      ],
      [
        -5,
        19
      ],
      [
        -6,
        0
      ],
      [
        -4,
        -36
      ],
      [
        0,
        -7
      ],
      [
        1,
        -1
      ],
      [
        3,
        -9
      ],
      [
        -7,
        -20
      ],
      [
        -2,
        1
      ],
      [
        -5,
        8
      ],
      [
        -2,
        6
      ],
      [
        4,
        129
      ],
      [
        1,
        14
      ],
      [
        5,
        35
      ],
      [
        3,
        13
      ],
      [
        -3,
        28
      ],
      [
        -3,
        6
      ],
      [
        -9,
        -2
      ],
      [
        1,
        -9
      ],
      [
        -1,
        -12
      ],
      [
        -9,
        -76
      ],
      [
        -8,
        -54
      ],
      [
        1,
        -21
      ],
      [
        5,
        -44
      ],
      [
        3,
        -46
      ],
      [
        -4,
        -29
      ],
      [
        -7,
        -5
      ],
      [
        -12,
        -4
      ],
      [
        -1,
        4
      ],
      [
        -1,
        29
      ],
      [
        4,
        5
      ],
      [
        -1,
        11
      ],
      [
        -18,
        32
      ],
      [
        -9,
        2
      ],
      [
        -7,
        -46
      ],
      [
        2,
        -12
      ],
      [
        4,
        -12
      ],
      [
        4,
        -1
      ],
      [
        5,
        -32
      ],
      [
        1,
        -8
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        -4
      ],
      [
        -9,
        -3
      ],
      [
        -15,
        6
      ],
      [
        -7,
        5
      ],
      [
        -16,
        5
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -7
      ],
      [
        -32,
        -34
      ],
      [
        -18,
        3
      ],
      [
        -10,
        6
      ],
      [
        -2,
        7
      ],
      [
        -3,
        24
      ],
      [
        1,
        13
      ],
      [
        13,
        82
      ],
      [
        5,
        22
      ],
      [
        6,
        23
      ],
      [
        13,
        39
      ],
      [
        18,
        67
      ],
      [
        1,
        13
      ],
      [
        -1,
        33
      ],
      [
        1,
        7
      ],
      [
        17,
        39
      ],
      [
        32,
        84
      ],
      [
        3,
        40
      ],
      [
        13,
        41
      ],
      [
        -3,
        20
      ],
      [
        -3,
        -2
      ],
      [
        -16,
        -39
      ],
      [
        -6,
        -29
      ],
      [
        -27,
        -78
      ],
      [
        -18,
        -44
      ],
      [
        -6,
        -21
      ],
      [
        -1,
        -28
      ],
      [
        0,
        -7
      ],
      [
        -18,
        -58
      ],
      [
        -6,
        1
      ],
      [
        -2,
        7
      ],
      [
        -3,
        28
      ],
      [
        -5,
        41
      ],
      [
        -7,
        7
      ],
      [
        -5,
        -8
      ],
      [
        1,
        -31
      ],
      [
        -4,
        -50
      ],
      [
        -6,
        -33
      ],
      [
        -5,
        -21
      ],
      [
        -7,
        -19
      ],
      [
        -6,
        -1
      ],
      [
        -5,
        -22
      ],
      [
        -3,
        -64
      ],
      [
        -5,
        -29
      ],
      [
        -8,
        -33
      ],
      [
        -3,
        -6
      ],
      [
        -7,
        -1
      ],
      [
        -4,
        3
      ],
      [
        -2,
        9
      ],
      [
        -8,
        16
      ],
      [
        -6,
        -22
      ],
      [
        -1,
        -14
      ],
      [
        0,
        -8
      ],
      [
        3,
        -14
      ],
      [
        3,
        -7
      ],
      [
        7,
        10
      ],
      [
        2,
        0
      ],
      [
        4,
        -5
      ],
      [
        5,
        -12
      ],
      [
        0,
        -29
      ],
      [
        -5,
        -62
      ],
      [
        3,
        -17
      ],
      [
        7,
        9
      ],
      [
        6,
        34
      ],
      [
        13,
        51
      ],
      [
        3,
        5
      ],
      [
        11,
        7
      ],
      [
        23,
        -6
      ],
      [
        7,
        -11
      ],
      [
        4,
        -11
      ],
      [
        4,
        -74
      ],
      [
        0,
        -17
      ],
      [
        -14,
        -45
      ],
      [
        -24,
        -32
      ],
      [
        -3,
        6
      ],
      [
        -4,
        -6
      ],
      [
        -11,
        -35
      ],
      [
        -4,
        -17
      ],
      [
        -6,
        -22
      ],
      [
        -1,
        -2
      ],
      [
        -4,
        -32
      ],
      [
        0,
        -16
      ],
      [
        5,
        -15
      ],
      [
        10,
        8
      ],
      [
        11,
        12
      ],
      [
        2,
        9
      ],
      [
        -1,
        8
      ],
      [
        3,
        16
      ],
      [
        13,
        42
      ],
      [
        22,
        45
      ],
      [
        3,
        2
      ],
      [
        5,
        -3
      ],
      [
        30,
        -89
      ],
      [
        4,
        -19
      ],
      [
        -2,
        -19
      ],
      [
        -2,
        -6
      ],
      [
        10,
        -43
      ],
      [
        -14,
        -107
      ],
      [
        -9,
        -85
      ],
      [
        -11,
        -4
      ],
      [
        -15,
        4
      ],
      [
        -9,
        20
      ],
      [
        -1,
        8
      ],
      [
        0,
        10
      ],
      [
        1,
        10
      ],
      [
        0,
        4
      ],
      [
        -6,
        13
      ],
      [
        -6,
        5
      ],
      [
        -7,
        -9
      ],
      [
        1,
        -16
      ],
      [
        1,
        -13
      ],
      [
        -1,
        -7
      ],
      [
        -20,
        -35
      ],
      [
        -7,
        -9
      ],
      [
        0,
        -17
      ],
      [
        28,
        14
      ],
      [
        23,
        -27
      ],
      [
        12,
        -27
      ],
      [
        10,
        -15
      ],
      [
        12,
        -27
      ],
      [
        11,
        -27
      ],
      [
        16,
        -28
      ],
      [
        6,
        -21
      ],
      [
        10,
        -39
      ],
      [
        8,
        -12
      ],
      [
        2,
        -13
      ],
      [
        -4,
        -19
      ],
      [
        -8,
        -31
      ],
      [
        -3,
        -27
      ],
      [
        -13,
        -26
      ],
      [
        -34,
        -35
      ],
      [
        -17,
        16
      ],
      [
        -14,
        -18
      ],
      [
        -21,
        -7
      ],
      [
        -8,
        1
      ],
      [
        9,
        51
      ],
      [
        -14,
        42
      ],
      [
        -12,
        25
      ],
      [
        4,
        24
      ],
      [
        5,
        36
      ],
      [
        -6,
        38
      ],
      [
        -11,
        25
      ],
      [
        -9,
        -26
      ],
      [
        3,
        -35
      ],
      [
        -10,
        -65
      ],
      [
        0,
        -62
      ],
      [
        -6,
        -28
      ],
      [
        -6,
        -13
      ],
      [
        -10,
        18
      ],
      [
        -3,
        24
      ],
      [
        -6,
        27
      ],
      [
        -9,
        -8
      ],
      [
        -1,
        -31
      ],
      [
        -6,
        -28
      ],
      [
        -4,
        -8
      ]
    ],
    [
      [
        8515,
        86711
      ],
      [
        4,
        145
      ],
      [
        2,
        75
      ],
      [
        0,
        336
      ],
      [
        -28,
        0
      ],
      [
        0,
        67
      ],
      [
        2,
        0
      ],
      [
        0,
        303
      ],
      [
        -25,
        0
      ]
    ],
    [
      [
        8470,
        87637
      ],
      [
        2,
        101
      ],
      [
        0,
        34
      ],
      [
        74,
        0
      ],
      [
        0,
        370
      ],
      [
        3,
        302
      ]
    ],
    [
      [
        22518,
        67986
      ],
      [
        99,
        -1
      ]
    ],
    [
      [
        22617,
        67985
      ],
      [
        1,
        -409
      ]
    ],
    [
      [
        16570,
        69317
      ],
      [
        2,
        0
      ],
      [
        140,
        2
      ]
    ],
    [
      [
        16712,
        69319
      ],
      [
        180,
        -1
      ]
    ],
    [
      [
        16892,
        69318
      ],
      [
        13,
        -1
      ],
      [
        9,
        -12
      ],
      [
        1,
        -26
      ],
      [
        8,
        17
      ],
      [
        4,
        -6
      ],
      [
        8,
        22
      ],
      [
        4,
        -4
      ],
      [
        8,
        -13
      ],
      [
        6,
        -17
      ],
      [
        4,
        4
      ],
      [
        2,
        -8
      ],
      [
        9,
        1
      ]
    ],
    [
      [
        16968,
        69275
      ],
      [
        0,
        -17
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -8
      ],
      [
        -2,
        -2
      ],
      [
        1,
        -4
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        1,
        -2
      ],
      [
        -1,
        -6
      ],
      [
        2,
        -6
      ],
      [
        0,
        -15
      ],
      [
        1,
        -5
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        0
      ],
      [
        -2,
        2
      ],
      [
        -2,
        0
      ],
      [
        -2,
        1
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -2,
        -2
      ],
      [
        0,
        -14
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -5
      ],
      [
        2,
        -2
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        1,
        -3
      ],
      [
        0,
        -1
      ],
      [
        2,
        -2
      ],
      [
        1,
        -4
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -15
      ],
      [
        1,
        -4
      ],
      [
        0,
        -10
      ],
      [
        2,
        -4
      ],
      [
        0,
        -5
      ],
      [
        1,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -9
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        2
      ],
      [
        -2,
        1
      ],
      [
        -4,
        1
      ],
      [
        -2,
        0
      ],
      [
        -2,
        3
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -7
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -2,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -4
      ],
      [
        -3,
        0
      ],
      [
        -1,
        3
      ],
      [
        -3,
        2
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -6
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        -2,
        0
      ],
      [
        0,
        3
      ],
      [
        -2,
        2
      ],
      [
        -2,
        2
      ],
      [
        -1,
        2
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -2
      ],
      [
        0,
        -11
      ],
      [
        1,
        -9
      ],
      [
        1,
        -12
      ],
      [
        1,
        -9
      ],
      [
        1,
        -5
      ],
      [
        1,
        0
      ],
      [
        2,
        -3
      ],
      [
        1,
        1
      ],
      [
        2,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        -6
      ],
      [
        4,
        0
      ],
      [
        3,
        -5
      ],
      [
        1,
        -2
      ],
      [
        2,
        4
      ],
      [
        1,
        -1
      ],
      [
        2,
        1
      ],
      [
        1,
        -2
      ],
      [
        1,
        -4
      ],
      [
        2,
        -3
      ],
      [
        1,
        -3
      ],
      [
        0,
        -1
      ],
      [
        2,
        -1
      ],
      [
        1,
        2
      ],
      [
        1,
        -1
      ],
      [
        2,
        1
      ],
      [
        2,
        3
      ],
      [
        1,
        0
      ],
      [
        3,
        -6
      ],
      [
        3,
        -2
      ],
      [
        1,
        -5
      ],
      [
        3,
        -5
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -4
      ],
      [
        0,
        -6
      ],
      [
        1,
        -5
      ],
      [
        1,
        -3
      ],
      [
        1,
        0
      ],
      [
        3,
        -3
      ],
      [
        2,
        -9
      ],
      [
        0,
        -6
      ],
      [
        2,
        -8
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -10
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        1,
        -6
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -8
      ],
      [
        1,
        -3
      ],
      [
        1,
        -6
      ],
      [
        1,
        -9
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -6
      ],
      [
        1,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        2
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        3
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -23
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -11
      ],
      [
        2,
        1
      ],
      [
        0,
        -6
      ],
      [
        1,
        -8
      ],
      [
        2,
        -5
      ],
      [
        2,
        -6
      ],
      [
        0,
        -6
      ],
      [
        -2,
        1
      ],
      [
        -4,
        -3
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -14
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        -1
      ],
      [
        -2,
        -10
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -4
      ],
      [
        1,
        -12
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -9
      ],
      [
        5,
        -18
      ],
      [
        32,
        0
      ],
      [
        3,
        2
      ],
      [
        30,
        0
      ],
      [
        4,
        -1
      ]
    ],
    [
      [
        16971,
        68457
      ],
      [
        1,
        -51
      ],
      [
        1,
        -201
      ]
    ],
    [
      [
        16973,
        68205
      ],
      [
        -34,
        -1
      ],
      [
        -67,
        2
      ],
      [
        -64,
        9
      ],
      [
        0,
        -102
      ],
      [
        -234,
        -2
      ]
    ],
    [
      [
        16574,
        68111
      ],
      [
        1,
        304
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        16575,
        68516
      ],
      [
        1,
        601
      ],
      [
        -6,
        0
      ],
      [
        0,
        200
      ]
    ],
    [
      [
        26717,
        63148
      ],
      [
        2,
        136
      ]
    ],
    [
      [
        26719,
        63284
      ],
      [
        35,
        -5
      ],
      [
        30,
        -4
      ],
      [
        52,
        -11
      ]
    ],
    [
      [
        26836,
        63264
      ],
      [
        -3,
        -163
      ],
      [
        -2,
        -109
      ],
      [
        31,
        -8
      ]
    ],
    [
      [
        26862,
        62984
      ],
      [
        -3,
        -100
      ]
    ],
    [
      [
        26859,
        62884
      ],
      [
        -71,
        13
      ],
      [
        5,
        12
      ],
      [
        0,
        13
      ],
      [
        -4,
        6
      ],
      [
        -76,
        12
      ]
    ],
    [
      [
        26713,
        62940
      ],
      [
        4,
        208
      ]
    ],
    [
      [
        27344,
        65072
      ],
      [
        0,
        -249
      ]
    ],
    [
      [
        27344,
        64823
      ],
      [
        0,
        -171
      ],
      [
        -24,
        1
      ]
    ],
    [
      [
        27320,
        64653
      ],
      [
        -32,
        0
      ],
      [
        -43,
        1
      ],
      [
        -10,
        -1
      ]
    ],
    [
      [
        26404,
        53118
      ],
      [
        72,
        -1
      ]
    ],
    [
      [
        26476,
        53117
      ],
      [
        0,
        -126
      ],
      [
        11,
        -74
      ],
      [
        -1,
        -29
      ],
      [
        2,
        -19
      ],
      [
        -2,
        -13
      ],
      [
        0,
        -11
      ],
      [
        -1,
        -196
      ]
    ],
    [
      [
        26485,
        52649
      ],
      [
        -6,
        1
      ],
      [
        -5,
        1
      ],
      [
        -35,
        7
      ],
      [
        -9,
        2
      ]
    ],
    [
      [
        26430,
        52660
      ],
      [
        -26,
        5
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        31239,
        38121
      ],
      [
        5,
        -3
      ],
      [
        7,
        17
      ],
      [
        22,
        -23
      ]
    ],
    [
      [
        31273,
        38112
      ],
      [
        10,
        -1
      ],
      [
        0,
        -14
      ],
      [
        7,
        -5
      ]
    ],
    [
      [
        31290,
        38092
      ],
      [
        -3,
        -9
      ],
      [
        -2,
        -28
      ],
      [
        -9,
        17
      ],
      [
        -4,
        -8
      ],
      [
        -7,
        5
      ]
    ],
    [
      [
        31265,
        38069
      ],
      [
        -12,
        -11
      ],
      [
        -1,
        2
      ],
      [
        -1,
        1
      ]
    ],
    [
      [
        31251,
        38061
      ],
      [
        -10,
        25
      ],
      [
        -10,
        10
      ]
    ],
    [
      [
        31231,
        38096
      ],
      [
        9,
        18
      ],
      [
        -1,
        7
      ]
    ],
    [
      [
        27523,
        61437
      ],
      [
        2,
        139
      ],
      [
        6,
        -11
      ],
      [
        24,
        62
      ]
    ],
    [
      [
        27555,
        61627
      ],
      [
        2,
        7
      ],
      [
        10,
        26
      ],
      [
        7,
        19
      ],
      [
        9,
        25
      ],
      [
        8,
        22
      ],
      [
        12,
        -9
      ],
      [
        12,
        -8
      ],
      [
        14,
        32
      ],
      [
        14,
        33
      ],
      [
        9,
        21
      ],
      [
        9,
        22
      ],
      [
        1,
        6
      ],
      [
        0,
        7
      ],
      [
        1,
        8
      ],
      [
        0,
        18
      ],
      [
        2,
        9
      ],
      [
        0,
        7
      ],
      [
        1,
        8
      ],
      [
        1,
        5
      ],
      [
        0,
        7
      ],
      [
        -1,
        4
      ],
      [
        0,
        12
      ],
      [
        1,
        0
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        1,
        3
      ],
      [
        1,
        8
      ],
      [
        0,
        4
      ],
      [
        -1,
        7
      ],
      [
        2,
        6
      ],
      [
        2,
        5
      ],
      [
        0,
        11
      ],
      [
        1,
        2
      ],
      [
        0,
        3
      ],
      [
        1,
        3
      ],
      [
        0,
        6
      ],
      [
        1,
        4
      ],
      [
        1,
        6
      ],
      [
        0,
        6
      ],
      [
        1,
        6
      ],
      [
        1,
        4
      ],
      [
        0,
        5
      ],
      [
        -1,
        1
      ],
      [
        0,
        4
      ],
      [
        1,
        4
      ],
      [
        2,
        4
      ],
      [
        0,
        5
      ],
      [
        1,
        5
      ],
      [
        1,
        3
      ],
      [
        1,
        6
      ],
      [
        0,
        5
      ],
      [
        1,
        2
      ],
      [
        1,
        1
      ],
      [
        1,
        -3
      ],
      [
        2,
        -2
      ],
      [
        1,
        -1
      ],
      [
        2,
        -4
      ],
      [
        0,
        -5
      ],
      [
        1,
        -6
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        2,
        -5
      ],
      [
        0,
        -2
      ],
      [
        1,
        1
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -20
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -7
      ],
      [
        2,
        -4
      ],
      [
        2,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        6
      ],
      [
        3,
        2
      ],
      [
        2,
        -6
      ],
      [
        0,
        -4
      ],
      [
        1,
        -4
      ],
      [
        0,
        -7
      ],
      [
        2,
        -3
      ],
      [
        2,
        -1
      ],
      [
        1,
        0
      ],
      [
        0,
        4
      ],
      [
        1,
        7
      ],
      [
        0,
        8
      ],
      [
        1,
        4
      ],
      [
        3,
        4
      ],
      [
        0,
        2
      ],
      [
        2,
        -1
      ],
      [
        0,
        -2
      ],
      [
        2,
        -4
      ],
      [
        2,
        -3
      ],
      [
        2,
        1
      ],
      [
        2,
        -2
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -8
      ],
      [
        1,
        1
      ],
      [
        1,
        4
      ]
    ],
    [
      [
        27727,
        61948
      ],
      [
        3,
        -7
      ],
      [
        -5,
        -26
      ],
      [
        4,
        -18
      ],
      [
        -8,
        -34
      ]
    ],
    [
      [
        27721,
        61863
      ],
      [
        -2,
        -18
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -6
      ],
      [
        1,
        -1
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -13
      ],
      [
        0,
        -7
      ],
      [
        1,
        -6
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -6
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        1,
        -3
      ],
      [
        1,
        -7
      ],
      [
        0,
        -5
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -5
      ],
      [
        -1,
        3
      ],
      [
        -2,
        0
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -8
      ],
      [
        1,
        -3
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -7
      ],
      [
        1,
        0
      ],
      [
        1,
        -7
      ],
      [
        1,
        -6
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -8
      ],
      [
        1,
        -1
      ],
      [
        -5,
        -19
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -14
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -9
      ],
      [
        1,
        -1
      ],
      [
        0,
        -6
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        0
      ],
      [
        -3,
        4
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -11
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -1
      ],
      [
        -3,
        -9
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -5
      ],
      [
        2,
        -8
      ],
      [
        0,
        -8
      ],
      [
        1,
        0
      ],
      [
        1,
        -2
      ],
      [
        2,
        -10
      ],
      [
        0,
        -16
      ],
      [
        -2,
        -1
      ]
    ],
    [
      [
        27680,
        61485
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        2
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -1
      ],
      [
        1,
        -3
      ],
      [
        -2,
        -4
      ],
      [
        0,
        1
      ],
      [
        -1,
        2
      ],
      [
        -2,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -8
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -8
      ],
      [
        -4,
        -15
      ],
      [
        -2,
        -4
      ],
      [
        0,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -6
      ],
      [
        -2,
        -8
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        0,
        -11
      ],
      [
        1,
        -1
      ],
      [
        -1,
        -15
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -5
      ],
      [
        -3,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        2,
        -24
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        2,
        0
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -14
      ],
      [
        0,
        -5
      ]
    ],
    [
      [
        27634,
        61249
      ],
      [
        -41,
        -9
      ],
      [
        -17,
        -23
      ],
      [
        -8,
        7
      ],
      [
        -5,
        -1
      ],
      [
        -14,
        6
      ],
      [
        -27,
        79
      ],
      [
        1,
        129
      ]
    ],
    [
      [
        31178,
        38330
      ],
      [
        4,
        -31
      ],
      [
        8,
        -21
      ],
      [
        4,
        -20
      ]
    ],
    [
      [
        31194,
        38258
      ],
      [
        0,
        -3
      ],
      [
        -11,
        -6
      ],
      [
        -1,
        -10
      ]
    ],
    [
      [
        31182,
        38239
      ],
      [
        -3,
        3
      ],
      [
        -3,
        25
      ],
      [
        -6,
        37
      ],
      [
        -1,
        11
      ],
      [
        1,
        5
      ],
      [
        2,
        4
      ],
      [
        6,
        6
      ]
    ],
    [
      [
        23087,
        71221
      ],
      [
        30,
        0
      ],
      [
        0,
        102
      ]
    ],
    [
      [
        23117,
        71323
      ],
      [
        106,
        -2
      ],
      [
        70,
        -1
      ],
      [
        15,
        2
      ],
      [
        15,
        -2
      ],
      [
        75,
        2
      ]
    ],
    [
      [
        23398,
        71322
      ],
      [
        0,
        -102
      ],
      [
        3,
        0
      ],
      [
        0,
        -304
      ]
    ],
    [
      [
        23401,
        70916
      ],
      [
        0,
        -100
      ],
      [
        2,
        0
      ],
      [
        0,
        -205
      ]
    ],
    [
      [
        23230,
        70612
      ],
      [
        -139,
        1
      ]
    ],
    [
      [
        23091,
        70613
      ],
      [
        1,
        203
      ],
      [
        -5,
        0
      ],
      [
        0,
        405
      ]
    ],
    [
      [
        26336,
        57669
      ],
      [
        31,
        -1
      ],
      [
        32,
        0
      ],
      [
        20,
        1
      ]
    ],
    [
      [
        26419,
        57669
      ],
      [
        54,
        -1
      ]
    ],
    [
      [
        26473,
        57668
      ],
      [
        -14,
        -41
      ],
      [
        2,
        -17
      ],
      [
        6,
        -21
      ],
      [
        4,
        -4
      ],
      [
        8,
        -34
      ],
      [
        -2,
        -20
      ],
      [
        -8,
        -19
      ],
      [
        -1,
        -11
      ],
      [
        2,
        -43
      ],
      [
        4,
        -13
      ],
      [
        9,
        6
      ],
      [
        0,
        -86
      ],
      [
        -3,
        0
      ],
      [
        -15,
        -92
      ]
    ],
    [
      [
        26465,
        57273
      ],
      [
        -9,
        -53
      ]
    ],
    [
      [
        26456,
        57220
      ],
      [
        -2,
        18
      ]
    ],
    [
      [
        26454,
        57238
      ],
      [
        1,
        24
      ],
      [
        -9,
        17
      ],
      [
        -5,
        20
      ],
      [
        -3,
        -7
      ],
      [
        0,
        62
      ],
      [
        -17,
        104
      ],
      [
        -4,
        -1
      ],
      [
        -4,
        21
      ],
      [
        -3,
        1
      ],
      [
        -18,
        28
      ],
      [
        -1,
        9
      ],
      [
        -55,
        -2
      ]
    ],
    [
      [
        26336,
        57514
      ],
      [
        -1,
        2
      ],
      [
        1,
        153
      ]
    ],
    [
      [
        23026,
        73018
      ],
      [
        66,
        1
      ],
      [
        7,
        -3
      ],
      [
        18,
        1
      ],
      [
        18,
        -2
      ],
      [
        35,
        0
      ],
      [
        109,
        1
      ]
    ],
    [
      [
        23279,
        73016
      ],
      [
        0,
        -177
      ],
      [
        3,
        0
      ]
    ],
    [
      [
        23282,
        72839
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        25055,
        63285
      ],
      [
        8,
        6
      ],
      [
        13,
        -20
      ],
      [
        1,
        -132
      ],
      [
        0,
        -38
      ],
      [
        31,
        0
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        25108,
        63100
      ],
      [
        1,
        -359
      ],
      [
        -32,
        4
      ]
    ],
    [
      [
        25077,
        62745
      ],
      [
        -109,
        0
      ],
      [
        -1,
        204
      ]
    ],
    [
      [
        24967,
        62949
      ],
      [
        0,
        136
      ],
      [
        15,
        0
      ],
      [
        0,
        50
      ],
      [
        15,
        -1
      ],
      [
        0,
        92
      ],
      [
        5,
        -22
      ],
      [
        3,
        -2
      ],
      [
        6,
        20
      ],
      [
        4,
        -4
      ],
      [
        2,
        19
      ],
      [
        7,
        -3
      ],
      [
        7,
        8
      ],
      [
        2,
        16
      ],
      [
        10,
        18
      ],
      [
        4,
        24
      ],
      [
        4,
        -15
      ],
      [
        4,
        0
      ]
    ],
    [
      [
        25967,
        64717
      ],
      [
        41,
        0
      ],
      [
        31,
        4
      ]
    ],
    [
      [
        26039,
        64721
      ],
      [
        1,
        -52
      ],
      [
        11,
        0
      ]
    ],
    [
      [
        26051,
        64669
      ],
      [
        0,
        -179
      ],
      [
        1,
        -227
      ]
    ],
    [
      [
        26052,
        64263
      ],
      [
        -10,
        0
      ],
      [
        -53,
        -2
      ]
    ],
    [
      [
        25989,
        64261
      ],
      [
        -21,
        -1
      ],
      [
        -2,
        406
      ]
    ],
    [
      [
        19527,
        61757
      ],
      [
        189,
        0
      ],
      [
        1,
        9
      ],
      [
        0,
        186
      ]
    ],
    [
      [
        19717,
        61952
      ],
      [
        105,
        1
      ],
      [
        139,
        0
      ]
    ],
    [
      [
        19961,
        61953
      ],
      [
        0,
        -427
      ],
      [
        -37,
        0
      ]
    ],
    [
      [
        19924,
        61526
      ],
      [
        0,
        35
      ],
      [
        -65,
        0
      ],
      [
        -74,
        -1
      ],
      [
        3,
        -20
      ],
      [
        5,
        0
      ],
      [
        0,
        -35
      ],
      [
        5,
        0
      ],
      [
        0,
        -33
      ],
      [
        21,
        0
      ],
      [
        0,
        -9
      ],
      [
        8,
        1
      ],
      [
        0,
        -17
      ],
      [
        5,
        0
      ],
      [
        0,
        -9
      ],
      [
        5,
        0
      ],
      [
        2,
        -9
      ],
      [
        0,
        -52
      ],
      [
        -2,
        0
      ],
      [
        0,
        -25
      ],
      [
        -5,
        0
      ]
    ],
    [
      [
        19832,
        61352
      ],
      [
        -263,
        3
      ],
      [
        -1,
        -2
      ],
      [
        -36,
        0
      ]
    ],
    [
      [
        24684,
        53433
      ],
      [
        22,
        0
      ],
      [
        58,
        1
      ]
    ],
    [
      [
        24764,
        53434
      ],
      [
        0,
        -203
      ],
      [
        1,
        -34
      ],
      [
        0,
        -170
      ]
    ],
    [
      [
        24765,
        53027
      ],
      [
        -24,
        -1
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        24684,
        53026
      ],
      [
        0,
        407
      ]
    ],
    [
      [
        21756,
        73450
      ],
      [
        0,
        101
      ],
      [
        182,
        0
      ],
      [
        0,
        -102
      ],
      [
        36,
        0
      ]
    ],
    [
      [
        21974,
        73449
      ],
      [
        0,
        -202
      ],
      [
        11,
        0
      ],
      [
        0,
        -406
      ],
      [
        11,
        0
      ],
      [
        0,
        -203
      ]
    ],
    [
      [
        21996,
        72638
      ],
      [
        -108,
        0
      ]
    ],
    [
      [
        21888,
        72638
      ],
      [
        -108,
        1
      ]
    ],
    [
      [
        21780,
        72639
      ],
      [
        1,
        202
      ],
      [
        -13,
        1
      ],
      [
        0,
        406
      ],
      [
        -12,
        0
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        24230,
        64550
      ],
      [
        96,
        2
      ],
      [
        32,
        0
      ]
    ],
    [
      [
        24358,
        64552
      ],
      [
        0,
        -102
      ]
    ],
    [
      [
        24358,
        64450
      ],
      [
        0,
        -204
      ],
      [
        1,
        -47
      ]
    ],
    [
      [
        24359,
        64199
      ],
      [
        -1,
        4
      ],
      [
        -3,
        14
      ],
      [
        -16,
        -3
      ],
      [
        -4,
        0
      ],
      [
        -3,
        -1
      ],
      [
        -3,
        0
      ],
      [
        -3,
        -1
      ],
      [
        -10,
        -2
      ],
      [
        -19,
        -2
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        24230,
        64202
      ],
      [
        0,
        348
      ]
    ],
    [
      [
        24670,
        63258
      ],
      [
        32,
        -1
      ],
      [
        0,
        -41
      ],
      [
        32,
        0
      ],
      [
        -1,
        -102
      ],
      [
        10,
        -1
      ],
      [
        0,
        -33
      ],
      [
        10,
        0
      ],
      [
        0,
        -136
      ]
    ],
    [
      [
        24753,
        62944
      ],
      [
        -78,
        2
      ]
    ],
    [
      [
        24675,
        62946
      ],
      [
        3,
        20
      ],
      [
        -2,
        24
      ],
      [
        -6,
        59
      ],
      [
        -2,
        32
      ],
      [
        -7,
        41
      ],
      [
        -4,
        35
      ],
      [
        11,
        76
      ],
      [
        2,
        25
      ]
    ],
    [
      [
        26539,
        55178
      ],
      [
        5,
        13
      ],
      [
        3,
        6
      ],
      [
        38,
        93
      ],
      [
        -2,
        9
      ],
      [
        6,
        0
      ]
    ],
    [
      [
        26644,
        55174
      ],
      [
        7,
        -25
      ],
      [
        -1,
        -22
      ],
      [
        -3,
        -4
      ],
      [
        -21,
        -74
      ],
      [
        -7,
        4
      ],
      [
        2,
        -34
      ],
      [
        -4,
        -27
      ],
      [
        4,
        -29
      ]
    ],
    [
      [
        26621,
        54963
      ],
      [
        -2,
        -4
      ],
      [
        -4,
        4
      ],
      [
        -2,
        7
      ],
      [
        -5,
        2
      ],
      [
        -6,
        3
      ],
      [
        -7,
        15
      ],
      [
        -3,
        6
      ]
    ],
    [
      [
        26592,
        54996
      ],
      [
        -10,
        2
      ],
      [
        -11,
        29
      ],
      [
        -9,
        13
      ],
      [
        -13,
        60
      ],
      [
        0,
        14
      ],
      [
        -6,
        15
      ],
      [
        -2,
        14
      ],
      [
        -2,
        1
      ],
      [
        0,
        34
      ]
    ],
    [
      [
        31463,
        38060
      ],
      [
        8,
        -7
      ],
      [
        2,
        9
      ],
      [
        2,
        -13
      ],
      [
        3,
        12
      ],
      [
        9,
        -13
      ],
      [
        0,
        7
      ],
      [
        4,
        -1
      ],
      [
        4,
        15
      ],
      [
        2,
        21
      ]
    ],
    [
      [
        31509,
        38021
      ],
      [
        0,
        -3
      ]
    ],
    [
      [
        31509,
        38018
      ],
      [
        -5,
        -6
      ],
      [
        -9,
        3
      ],
      [
        -3,
        -17
      ],
      [
        -4,
        -2
      ],
      [
        2,
        -30
      ],
      [
        -5,
        -30
      ],
      [
        -8,
        16
      ]
    ],
    [
      [
        31477,
        37952
      ],
      [
        -10,
        -5
      ],
      [
        0,
        25
      ],
      [
        -6,
        32
      ]
    ],
    [
      [
        26462,
        67956
      ],
      [
        0,
        -299
      ]
    ],
    [
      [
        26462,
        67657
      ],
      [
        -1,
        -101
      ],
      [
        -55,
        -1
      ],
      [
        0,
        -18
      ]
    ],
    [
      [
        22165,
        62493
      ],
      [
        151,
        0
      ]
    ],
    [
      [
        22316,
        62493
      ],
      [
        3,
        1
      ]
    ],
    [
      [
        22319,
        62494
      ],
      [
        0,
        -323
      ],
      [
        -1,
        -185
      ]
    ],
    [
      [
        22318,
        61986
      ],
      [
        -78,
        0
      ],
      [
        -73,
        -1
      ]
    ],
    [
      [
        22163,
        61985
      ],
      [
        2,
        508
      ]
    ],
    [
      [
        21634,
        73979
      ],
      [
        11,
        -1
      ],
      [
        64,
        1
      ],
      [
        3,
        0
      ],
      [
        25,
        -1
      ],
      [
        57,
        1
      ],
      [
        137,
        0
      ],
      [
        0,
        -1
      ],
      [
        69,
        0
      ]
    ],
    [
      [
        22000,
        73978
      ],
      [
        0,
        -326
      ],
      [
        10,
        0
      ],
      [
        0,
        -202
      ]
    ],
    [
      [
        22010,
        73450
      ],
      [
        -36,
        -1
      ]
    ],
    [
      [
        3060,
        19
      ],
      [
        1,
        6
      ],
      [
        3,
        0
      ],
      [
        2,
        -8
      ],
      [
        1,
        -13
      ],
      [
        -1,
        -4
      ],
      [
        -3,
        0
      ],
      [
        -2,
        4
      ],
      [
        -1,
        15
      ]
    ],
    [
      [
        2682,
        386
      ],
      [
        4,
        10
      ],
      [
        7,
        -3
      ],
      [
        8,
        4
      ],
      [
        7,
        0
      ],
      [
        2,
        -8
      ],
      [
        0,
        -20
      ],
      [
        -1,
        -23
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        2
      ],
      [
        -5,
        8
      ],
      [
        -2,
        -4
      ],
      [
        -4,
        -11
      ],
      [
        -2,
        -13
      ],
      [
        -2,
        1
      ],
      [
        -2,
        10
      ],
      [
        -3,
        26
      ],
      [
        -3,
        23
      ]
    ],
    [
      [
        2636,
        452
      ],
      [
        2,
        6
      ],
      [
        2,
        -2
      ],
      [
        7,
        -4
      ],
      [
        4,
        0
      ],
      [
        3,
        2
      ],
      [
        1,
        7
      ],
      [
        1,
        2
      ],
      [
        1,
        -3
      ],
      [
        0,
        -15
      ],
      [
        1,
        -11
      ],
      [
        -2,
        -16
      ],
      [
        -2,
        13
      ],
      [
        -1,
        8
      ],
      [
        -4,
        2
      ],
      [
        -3,
        -1
      ],
      [
        -3,
        -10
      ],
      [
        -3,
        -3
      ],
      [
        -4,
        16
      ],
      [
        0,
        9
      ]
    ],
    [
      [
        2341,
        307
      ],
      [
        4,
        -10
      ],
      [
        2,
        -11
      ],
      [
        5,
        -28
      ]
    ],
    [
      [
        2352,
        258
      ],
      [
        -4,
        -16
      ],
      [
        -6,
        -23
      ],
      [
        -5,
        -11
      ],
      [
        -7,
        19
      ],
      [
        -4,
        28
      ],
      [
        -5,
        1
      ],
      [
        -4,
        3
      ],
      [
        -4,
        8
      ],
      [
        0,
        4
      ],
      [
        3,
        10
      ],
      [
        3,
        9
      ],
      [
        1,
        4
      ],
      [
        3,
        6
      ],
      [
        3,
        6
      ],
      [
        4,
        2
      ],
      [
        6,
        0
      ],
      [
        4,
        -4
      ],
      [
        1,
        3
      ]
    ],
    [
      [
        26177,
        64974
      ],
      [
        31,
        2
      ],
      [
        77,
        6
      ]
    ],
    [
      [
        26285,
        64961
      ],
      [
        0,
        -307
      ]
    ],
    [
      [
        26285,
        64577
      ],
      [
        -76,
        -6
      ]
    ],
    [
      [
        26209,
        64571
      ],
      [
        -10,
        -1
      ],
      [
        -63,
        0
      ]
    ],
    [
      [
        26136,
        64570
      ],
      [
        1,
        99
      ],
      [
        0,
        4
      ]
    ],
    [
      [
        26137,
        64673
      ],
      [
        -1,
        98
      ],
      [
        0,
        104
      ],
      [
        8,
        0
      ],
      [
        0,
        99
      ]
    ],
    [
      [
        23155,
        62998
      ],
      [
        69,
        -1
      ],
      [
        0,
        102
      ]
    ],
    [
      [
        23224,
        63099
      ],
      [
        63,
        0
      ]
    ],
    [
      [
        23287,
        63099
      ],
      [
        0,
        -100
      ],
      [
        -2,
        -2
      ],
      [
        0,
        -171
      ]
    ],
    [
      [
        23285,
        62826
      ],
      [
        -5,
        0
      ],
      [
        0,
        -236
      ]
    ],
    [
      [
        23280,
        62590
      ],
      [
        -88,
        1
      ],
      [
        -37,
        0
      ]
    ],
    [
      [
        23155,
        62591
      ],
      [
        1,
        67
      ],
      [
        -1,
        340
      ]
    ],
    [
      [
        24358,
        64552
      ],
      [
        1,
        304
      ]
    ],
    [
      [
        24359,
        64856
      ],
      [
        64,
        0
      ]
    ],
    [
      [
        24423,
        64856
      ],
      [
        32,
        -2
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        24455,
        64753
      ],
      [
        0,
        -304
      ],
      [
        -11,
        0
      ]
    ],
    [
      [
        24444,
        64449
      ],
      [
        -86,
        1
      ]
    ],
    [
      [
        25758,
        63711
      ],
      [
        94,
        -1
      ],
      [
        1,
        0
      ],
      [
        10,
        1
      ],
      [
        21,
        2
      ]
    ],
    [
      [
        25884,
        63713
      ],
      [
        0,
        -212
      ],
      [
        1,
        -84
      ]
    ],
    [
      [
        25885,
        63417
      ],
      [
        -11,
        -2
      ],
      [
        -13,
        -1
      ]
    ],
    [
      [
        25758,
        63413
      ],
      [
        0,
        298
      ]
    ],
    [
      [
        16062,
        64021
      ],
      [
        0,
        -15
      ],
      [
        6,
        -10
      ],
      [
        -3,
        -32
      ],
      [
        3,
        -25
      ],
      [
        -2,
        -10
      ],
      [
        3,
        -17
      ],
      [
        12,
        -2
      ],
      [
        4,
        -8
      ],
      [
        9,
        -3
      ],
      [
        3,
        -17
      ],
      [
        8,
        -19
      ],
      [
        -4,
        -14
      ],
      [
        -6,
        1
      ],
      [
        8,
        -26
      ],
      [
        0,
        -14
      ],
      [
        -5,
        -22
      ],
      [
        1,
        -23
      ],
      [
        -1,
        -15
      ],
      [
        -5,
        -3
      ],
      [
        -6,
        -22
      ],
      [
        -9,
        5
      ],
      [
        -2,
        -21
      ],
      [
        2,
        -30
      ]
    ],
    [
      [
        16078,
        63679
      ],
      [
        -1,
        -25
      ],
      [
        -3,
        -9
      ],
      [
        -8,
        0
      ],
      [
        -3,
        -17
      ],
      [
        -5,
        -8
      ],
      [
        -21,
        0
      ],
      [
        -3,
        -9
      ],
      [
        0,
        -41
      ],
      [
        -8,
        -21
      ],
      [
        -3,
        -16
      ],
      [
        0,
        -34
      ],
      [
        -3,
        -17
      ],
      [
        -16,
        2
      ],
      [
        -6,
        -20
      ],
      [
        -6,
        -33
      ],
      [
        -1,
        -37
      ],
      [
        -7,
        -21
      ],
      [
        -8,
        -5
      ],
      [
        -19,
        0
      ],
      [
        -3,
        -1
      ],
      [
        -45,
        0
      ],
      [
        1,
        -4
      ],
      [
        -8,
        -46
      ],
      [
        4,
        -14
      ],
      [
        -2,
        -21
      ],
      [
        5,
        -15
      ]
    ],
    [
      [
        15909,
        63267
      ],
      [
        -241,
        2
      ],
      [
        -2,
        -1
      ],
      [
        -6,
        0
      ]
    ],
    [
      [
        15660,
        63268
      ],
      [
        -1,
        4
      ],
      [
        -1,
        36
      ],
      [
        -4,
        14
      ],
      [
        2,
        11
      ],
      [
        2,
        46
      ],
      [
        -1,
        16
      ],
      [
        8,
        11
      ],
      [
        3,
        23
      ],
      [
        -5,
        10
      ],
      [
        0,
        30
      ],
      [
        -2,
        8
      ]
    ],
    [
      [
        15661,
        63477
      ],
      [
        -5,
        24
      ],
      [
        -1,
        25
      ],
      [
        2,
        14
      ],
      [
        -1,
        32
      ],
      [
        -6,
        21
      ],
      [
        4,
        26
      ],
      [
        -4,
        35
      ],
      [
        2,
        10
      ],
      [
        -6,
        8
      ],
      [
        1,
        31
      ],
      [
        4,
        17
      ],
      [
        -2,
        33
      ],
      [
        0,
        31
      ],
      [
        -11,
        25
      ],
      [
        -9,
        6
      ],
      [
        -4,
        22
      ]
    ],
    [
      [
        25989,
        64261
      ],
      [
        0,
        -100
      ]
    ],
    [
      [
        25989,
        64161
      ],
      [
        -21,
        -1
      ],
      [
        -20,
        -1
      ],
      [
        -32,
        -1
      ],
      [
        -11,
        0
      ]
    ],
    [
      [
        25905,
        64158
      ],
      [
        0,
        207
      ],
      [
        -1,
        3
      ],
      [
        0,
        194
      ]
    ],
    [
      [
        22074,
        71224
      ],
      [
        130,
        -2
      ]
    ],
    [
      [
        22204,
        71222
      ],
      [
        114,
        -1
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        22319,
        71221
      ],
      [
        0,
        -404
      ]
    ],
    [
      [
        22319,
        70817
      ],
      [
        -234,
        -1
      ]
    ],
    [
      [
        22085,
        70816
      ],
      [
        -11,
        1
      ],
      [
        0,
        407
      ]
    ],
    [
      [
        23386,
        58933
      ],
      [
        25,
        0
      ],
      [
        0,
        102
      ],
      [
        30,
        0
      ]
    ],
    [
      [
        23441,
        59035
      ],
      [
        59,
        -1
      ]
    ],
    [
      [
        23500,
        59034
      ],
      [
        0,
        -303
      ],
      [
        -2,
        0
      ],
      [
        0,
        -305
      ]
    ],
    [
      [
        23498,
        58426
      ],
      [
        -31,
        0
      ],
      [
        -27,
        -1
      ],
      [
        -32,
        1
      ]
    ],
    [
      [
        23408,
        58426
      ],
      [
        1,
        183
      ],
      [
        0,
        19
      ],
      [
        -39,
        1
      ]
    ],
    [
      [
        23370,
        58629
      ],
      [
        3,
        24
      ],
      [
        6,
        20
      ],
      [
        2,
        13
      ],
      [
        -2,
        12
      ],
      [
        -7,
        6
      ],
      [
        -6,
        31
      ],
      [
        0,
        17
      ],
      [
        3,
        12
      ],
      [
        0,
        21
      ],
      [
        -3,
        20
      ],
      [
        8,
        27
      ],
      [
        4,
        0
      ],
      [
        3,
        25
      ],
      [
        0,
        36
      ],
      [
        5,
        0
      ],
      [
        0,
        40
      ]
    ],
    [
      [
        22068,
        68386
      ],
      [
        8,
        -47
      ],
      [
        7,
        -29
      ],
      [
        7,
        -7
      ],
      [
        25,
        14
      ],
      [
        5,
        -4
      ],
      [
        27,
        -36
      ],
      [
        7,
        -4
      ],
      [
        5,
        7
      ],
      [
        4,
        23
      ],
      [
        -3,
        29
      ],
      [
        -7,
        16
      ],
      [
        -7,
        7
      ],
      [
        -10,
        5
      ],
      [
        -4,
        14
      ],
      [
        0,
        10
      ],
      [
        7,
        25
      ],
      [
        6,
        3
      ]
    ],
    [
      [
        22230,
        68082
      ],
      [
        -2,
        -22
      ],
      [
        3,
        -26
      ],
      [
        7,
        -12
      ],
      [
        6,
        -26
      ],
      [
        -9,
        -48
      ],
      [
        -7,
        -31
      ],
      [
        -13,
        -20
      ],
      [
        -2,
        -35
      ],
      [
        3,
        -19
      ],
      [
        0,
        -27
      ],
      [
        -4,
        -11
      ],
      [
        -10,
        -11
      ],
      [
        -3,
        -16
      ],
      [
        3,
        -20
      ],
      [
        8,
        -4
      ],
      [
        11,
        7
      ],
      [
        4,
        -2
      ],
      [
        5,
        -16
      ],
      [
        4,
        -31
      ],
      [
        1,
        -41
      ],
      [
        4,
        -23
      ],
      [
        12,
        -35
      ],
      [
        0,
        -15
      ],
      [
        -4,
        -21
      ]
    ],
    [
      [
        22247,
        67577
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        22181,
        67577
      ],
      [
        -3,
        -1
      ],
      [
        -8,
        1
      ],
      [
        -12,
        0
      ],
      [
        -2,
        17
      ],
      [
        0,
        264
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -2,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        2
      ],
      [
        0,
        14
      ],
      [
        -1,
        4
      ],
      [
        0,
        4
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        4
      ],
      [
        -2,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -15
      ],
      [
        1,
        -2
      ],
      [
        0,
        -18
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        0
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        2
      ],
      [
        0,
        6
      ],
      [
        1,
        2
      ],
      [
        0,
        3
      ],
      [
        1,
        2
      ],
      [
        0,
        4
      ],
      [
        1,
        2
      ],
      [
        0,
        5
      ],
      [
        -1,
        2
      ],
      [
        0,
        4
      ],
      [
        -1,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -15
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -3
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -2,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        23
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -14
      ],
      [
        2,
        -6
      ],
      [
        2,
        -10
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -1
      ],
      [
        -4,
        2
      ],
      [
        -5,
        -2
      ],
      [
        -2,
        1
      ],
      [
        -2,
        -1
      ],
      [
        0,
        -4
      ],
      [
        -2,
        -7
      ],
      [
        -4,
        -5
      ],
      [
        -3,
        -5
      ],
      [
        -5,
        7
      ],
      [
        -2,
        4
      ],
      [
        -1,
        -4
      ],
      [
        2,
        -5
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        -9
      ],
      [
        -1,
        -10
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        2
      ],
      [
        -2,
        6
      ],
      [
        1,
        3
      ],
      [
        -2,
        11
      ],
      [
        -3,
        7
      ],
      [
        -3,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -6
      ],
      [
        -2,
        6
      ],
      [
        -2,
        4
      ],
      [
        -3,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        3
      ],
      [
        -2,
        0
      ],
      [
        0,
        -3
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        5
      ],
      [
        -2,
        7
      ],
      [
        -2,
        1
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        0
      ],
      [
        -1,
        6
      ],
      [
        1,
        6
      ],
      [
        -1,
        6
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        1
      ],
      [
        -2,
        4
      ],
      [
        -2,
        -3
      ],
      [
        0,
        -4
      ],
      [
        -2,
        -6
      ],
      [
        -2,
        0
      ],
      [
        -5,
        -1
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        4
      ],
      [
        -3,
        1
      ],
      [
        0,
        -3
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        6
      ],
      [
        -1,
        9
      ],
      [
        -2,
        5
      ],
      [
        -2,
        2
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        1
      ],
      [
        -4,
        9
      ],
      [
        -2,
        2
      ],
      [
        -3,
        1
      ],
      [
        -3,
        0
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        0,
        3
      ],
      [
        -2,
        5
      ],
      [
        -2,
        12
      ],
      [
        1,
        10
      ],
      [
        -1,
        4
      ],
      [
        -1,
        1
      ]
    ],
    [
      [
        21987,
        67826
      ],
      [
        -6,
        -13
      ],
      [
        -4,
        7
      ],
      [
        -4,
        -14
      ],
      [
        -6,
        27
      ],
      [
        -10,
        -4
      ]
    ],
    [
      [
        21957,
        67829
      ],
      [
        -1,
        152
      ],
      [
        -7,
        0
      ],
      [
        0,
        374
      ]
    ],
    [
      [
        21949,
        68355
      ],
      [
        0,
        30
      ],
      [
        119,
        1
      ]
    ],
    [
      [
        23290,
        72233
      ],
      [
        0,
        -406
      ]
    ],
    [
      [
        23290,
        71827
      ],
      [
        -143,
        1
      ]
    ],
    [
      [
        23147,
        71828
      ],
      [
        0,
        404
      ]
    ],
    [
      [
        24749,
        68956
      ],
      [
        0,
        -303
      ]
    ],
    [
      [
        24749,
        68653
      ],
      [
        -68,
        -3
      ],
      [
        -67,
        1
      ],
      [
        0,
        101
      ],
      [
        -34,
        0
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        24580,
        68853
      ],
      [
        0,
        304
      ]
    ],
    [
      [
        24580,
        69157
      ],
      [
        0,
        202
      ]
    ],
    [
      [
        21737,
        61990
      ],
      [
        86,
        -1
      ]
    ],
    [
      [
        21823,
        61989
      ],
      [
        36,
        0
      ]
    ],
    [
      [
        21860,
        61482
      ],
      [
        -116,
        0
      ]
    ],
    [
      [
        21744,
        61482
      ],
      [
        -7,
        0
      ]
    ],
    [
      [
        21737,
        61482
      ],
      [
        0,
        508
      ]
    ],
    [
      [
        23052,
        73979
      ],
      [
        120,
        0
      ],
      [
        169,
        -1
      ],
      [
        14,
        0
      ]
    ],
    [
      [
        23355,
        73978
      ],
      [
        -2,
        -20
      ],
      [
        2,
        -34
      ],
      [
        -1,
        -20
      ],
      [
        6,
        -36
      ],
      [
        13,
        -23
      ],
      [
        5,
        -4
      ],
      [
        27,
        16
      ],
      [
        13,
        30
      ],
      [
        1,
        -242
      ],
      [
        -71,
        0
      ],
      [
        1,
        -201
      ]
    ],
    [
      [
        23349,
        73444
      ],
      [
        -73,
        -2
      ]
    ],
    [
      [
        23276,
        73442
      ],
      [
        -219,
        7
      ]
    ],
    [
      [
        23057,
        73449
      ],
      [
        0,
        201
      ],
      [
        -4,
        0
      ],
      [
        -1,
        329
      ]
    ],
    [
      [
        23955,
        58531
      ],
      [
        60,
        -5
      ]
    ],
    [
      [
        24015,
        58526
      ],
      [
        39,
        -3
      ]
    ],
    [
      [
        24054,
        58523
      ],
      [
        -1,
        -202
      ],
      [
        -10,
        1
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        24043,
        58221
      ],
      [
        -1,
        -236
      ],
      [
        0,
        -102
      ],
      [
        -12,
        -2
      ]
    ],
    [
      [
        24030,
        57881
      ],
      [
        -8,
        6
      ],
      [
        -27,
        -15
      ],
      [
        -2,
        -4
      ],
      [
        0,
        -31
      ],
      [
        -1,
        -9
      ],
      [
        -4,
        -8
      ],
      [
        -4,
        -1
      ],
      [
        -6,
        12
      ],
      [
        -2,
        20
      ],
      [
        3,
        25
      ],
      [
        0,
        15
      ],
      [
        -2,
        3
      ],
      [
        -8,
        -12
      ],
      [
        -4,
        10
      ],
      [
        -3,
        34
      ],
      [
        -4,
        30
      ],
      [
        -8,
        32
      ],
      [
        -5,
        11
      ],
      [
        -9,
        2
      ],
      [
        -3,
        4
      ],
      [
        -2,
        24
      ],
      [
        -7,
        23
      ]
    ],
    [
      [
        23924,
        58052
      ],
      [
        -2,
        3
      ],
      [
        -4,
        8
      ]
    ],
    [
      [
        23918,
        58063
      ],
      [
        0,
        65
      ],
      [
        1,
        101
      ],
      [
        20,
        -1
      ],
      [
        0,
        17
      ],
      [
        1,
        135
      ],
      [
        14,
        -2
      ],
      [
        1,
        153
      ]
    ],
    [
      [
        25989,
        71075
      ],
      [
        0,
        215
      ]
    ],
    [
      [
        25989,
        71290
      ],
      [
        7,
        -1
      ],
      [
        13,
        -9
      ],
      [
        12,
        -4
      ],
      [
        10,
        -1
      ],
      [
        13,
        4
      ],
      [
        12,
        -2
      ],
      [
        10,
        -5
      ],
      [
        13,
        0
      ],
      [
        9,
        2
      ],
      [
        8,
        5
      ],
      [
        31,
        39
      ],
      [
        22,
        36
      ],
      [
        9,
        10
      ],
      [
        6,
        3
      ]
    ],
    [
      [
        26164,
        71367
      ],
      [
        0,
        -594
      ]
    ],
    [
      [
        26164,
        70773
      ],
      [
        -175,
        -1
      ]
    ],
    [
      [
        25989,
        70772
      ],
      [
        0,
        303
      ]
    ],
    [
      [
        23982,
        61791
      ],
      [
        -1,
        -102
      ],
      [
        -1,
        -160
      ],
      [
        0,
        -48
      ]
    ],
    [
      [
        23980,
        61481
      ],
      [
        -2,
        -89
      ],
      [
        7,
        -1
      ],
      [
        -2,
        -127
      ],
      [
        0,
        -17
      ]
    ],
    [
      [
        23983,
        61247
      ],
      [
        -122,
        13
      ]
    ],
    [
      [
        23855,
        61416
      ],
      [
        2,
        133
      ],
      [
        2,
        146
      ],
      [
        -1,
        76
      ]
    ],
    [
      [
        24054,
        58523
      ],
      [
        50,
        -4
      ],
      [
        0,
        84
      ],
      [
        9,
        -1
      ],
      [
        51,
        -2
      ]
    ],
    [
      [
        24164,
        58600
      ],
      [
        -1,
        -84
      ],
      [
        50,
        -5
      ]
    ],
    [
      [
        24213,
        58511
      ],
      [
        -1,
        -76
      ],
      [
        0,
        -126
      ],
      [
        -2,
        -17
      ],
      [
        -1,
        -186
      ]
    ],
    [
      [
        24209,
        58106
      ],
      [
        -38,
        3
      ],
      [
        -3,
        0
      ],
      [
        -22,
        2
      ]
    ],
    [
      [
        24146,
        58111
      ],
      [
        0,
        101
      ],
      [
        -24,
        2
      ],
      [
        -79,
        7
      ]
    ],
    [
      [
        28554,
        60453
      ],
      [
        3,
        -7
      ],
      [
        13,
        -70
      ],
      [
        9,
        -29
      ],
      [
        9,
        -21
      ],
      [
        6,
        -26
      ],
      [
        5,
        -9
      ]
    ],
    [
      [
        28599,
        60291
      ],
      [
        -2,
        -8
      ],
      [
        3,
        -10
      ],
      [
        6,
        -11
      ],
      [
        22,
        11
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -10
      ],
      [
        -1,
        -15
      ],
      [
        2,
        -9
      ],
      [
        -1,
        -16
      ],
      [
        -1,
        -18
      ]
    ],
    [
      [
        28627,
        60202
      ],
      [
        -5,
        -10
      ],
      [
        1,
        -36
      ],
      [
        1,
        1
      ],
      [
        2,
        -8
      ],
      [
        1,
        -14
      ]
    ],
    [
      [
        28627,
        60135
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -9
      ],
      [
        -2,
        -4
      ],
      [
        -5,
        0
      ],
      [
        -3,
        3
      ]
    ],
    [
      [
        28616,
        60121
      ],
      [
        -2,
        -1
      ],
      [
        -4,
        8
      ],
      [
        -1,
        2
      ],
      [
        -3,
        14
      ],
      [
        -10,
        46
      ],
      [
        -2,
        28
      ],
      [
        -12,
        38
      ],
      [
        -2,
        11
      ],
      [
        -3,
        -9
      ],
      [
        -4,
        1
      ]
    ],
    [
      [
        28573,
        60259
      ],
      [
        -3,
        29
      ],
      [
        -9,
        -2
      ],
      [
        -5,
        3
      ],
      [
        -3,
        14
      ]
    ],
    [
      [
        28553,
        60303
      ],
      [
        -6,
        22
      ],
      [
        1,
        26
      ],
      [
        -8,
        -18
      ],
      [
        -5,
        34
      ]
    ],
    [
      [
        28535,
        60367
      ],
      [
        -2,
        30
      ],
      [
        -5,
        8
      ],
      [
        -1,
        18
      ],
      [
        4,
        18
      ],
      [
        8,
        -6
      ],
      [
        11,
        3
      ],
      [
        4,
        15
      ]
    ],
    [
      [
        24089,
        60088
      ],
      [
        121,
        -8
      ]
    ],
    [
      [
        24210,
        60080
      ],
      [
        45,
        -4
      ]
    ],
    [
      [
        24255,
        60076
      ],
      [
        -2,
        -305
      ],
      [
        -5,
        0
      ]
    ],
    [
      [
        24248,
        59771
      ],
      [
        -181,
        14
      ]
    ],
    [
      [
        24067,
        59785
      ],
      [
        -41,
        3
      ]
    ],
    [
      [
        17948,
        73980
      ],
      [
        15,
        0
      ],
      [
        83,
        1
      ],
      [
        35,
        -1
      ],
      [
        7,
        -1
      ],
      [
        6,
        -1
      ],
      [
        6,
        1
      ],
      [
        31,
        -1
      ]
    ],
    [
      [
        18131,
        73978
      ],
      [
        1,
        -3
      ],
      [
        1,
        -7
      ],
      [
        2,
        -7
      ],
      [
        -1,
        -6
      ],
      [
        1,
        -6
      ],
      [
        1,
        -9
      ],
      [
        3,
        -4
      ],
      [
        3,
        2
      ],
      [
        2,
        -2
      ],
      [
        -1,
        -8
      ],
      [
        -3,
        -8
      ],
      [
        -1,
        -9
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -7
      ],
      [
        2,
        -1
      ],
      [
        4,
        0
      ],
      [
        2,
        -8
      ],
      [
        0,
        -7
      ],
      [
        1,
        -9
      ],
      [
        -2,
        -7
      ],
      [
        -3,
        -7
      ],
      [
        -4,
        -5
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        4,
        -5
      ],
      [
        3,
        -6
      ],
      [
        1,
        -8
      ],
      [
        2,
        -8
      ],
      [
        3,
        0
      ],
      [
        2,
        -4
      ],
      [
        1,
        -6
      ],
      [
        2,
        -5
      ],
      [
        0,
        -9
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -3
      ],
      [
        0,
        -6
      ],
      [
        1,
        -2
      ],
      [
        3,
        -4
      ],
      [
        2,
        -2
      ],
      [
        1,
        -4
      ],
      [
        1,
        0
      ],
      [
        1,
        2
      ],
      [
        1,
        0
      ],
      [
        1,
        -4
      ],
      [
        3,
        -1
      ],
      [
        1,
        3
      ],
      [
        2,
        5
      ],
      [
        3,
        3
      ],
      [
        2,
        7
      ],
      [
        2,
        8
      ],
      [
        1,
        6
      ],
      [
        1,
        2
      ],
      [
        1,
        -2
      ],
      [
        3,
        -2
      ],
      [
        2,
        -5
      ],
      [
        2,
        -2
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        2,
        6
      ],
      [
        3,
        4
      ],
      [
        2,
        3
      ],
      [
        2,
        1
      ],
      [
        3,
        -6
      ],
      [
        3,
        -3
      ],
      [
        0,
        -5
      ],
      [
        2,
        -5
      ],
      [
        2,
        2
      ],
      [
        2,
        5
      ],
      [
        1,
        1
      ],
      [
        2,
        -4
      ],
      [
        0,
        -5
      ],
      [
        1,
        -8
      ],
      [
        2,
        -5
      ],
      [
        2,
        -5
      ],
      [
        2,
        -3
      ],
      [
        1,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -9
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -8
      ],
      [
        1,
        -5
      ],
      [
        1,
        -4
      ],
      [
        1,
        -8
      ],
      [
        2,
        -7
      ],
      [
        3,
        -6
      ],
      [
        1,
        -9
      ],
      [
        1,
        -8
      ],
      [
        2,
        -5
      ],
      [
        3,
        -3
      ],
      [
        2,
        -5
      ],
      [
        1,
        -6
      ],
      [
        0,
        -12
      ],
      [
        1,
        -7
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -5
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        1,
        -6
      ],
      [
        1,
        -7
      ],
      [
        1,
        -5
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -25
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -7
      ],
      [
        1,
        -3
      ],
      [
        2,
        -3
      ],
      [
        2,
        -3
      ],
      [
        1,
        -5
      ],
      [
        2,
        -3
      ],
      [
        2,
        -2
      ],
      [
        2,
        -5
      ],
      [
        5,
        -2
      ],
      [
        3,
        0
      ],
      [
        3,
        -5
      ],
      [
        3,
        -1
      ],
      [
        2,
        6
      ],
      [
        1,
        4
      ],
      [
        2,
        5
      ],
      [
        2,
        -2
      ],
      [
        2,
        -5
      ],
      [
        2,
        -7
      ],
      [
        1,
        -10
      ],
      [
        3,
        -5
      ],
      [
        2,
        2
      ],
      [
        2,
        4
      ],
      [
        2,
        3
      ],
      [
        2,
        -3
      ],
      [
        3,
        1
      ],
      [
        3,
        2
      ],
      [
        2,
        2
      ],
      [
        1,
        0
      ],
      [
        1,
        -4
      ],
      [
        2,
        -5
      ],
      [
        3,
        -4
      ],
      [
        2,
        -5
      ],
      [
        0,
        -9
      ],
      [
        4,
        -6
      ],
      [
        3,
        -4
      ],
      [
        3,
        0
      ],
      [
        3,
        -7
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -17
      ],
      [
        -1,
        -10
      ],
      [
        0,
        -10
      ],
      [
        1,
        -11
      ],
      [
        1,
        -4
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -8
      ],
      [
        1,
        -10
      ],
      [
        -2,
        -6
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -6
      ],
      [
        1,
        -5
      ],
      [
        2,
        -2
      ],
      [
        1,
        -4
      ],
      [
        2,
        -3
      ],
      [
        2,
        -2
      ],
      [
        2,
        -2
      ],
      [
        1,
        -6
      ],
      [
        2,
        -4
      ],
      [
        3,
        -2
      ],
      [
        2,
        -6
      ],
      [
        1,
        -6
      ],
      [
        3,
        -3
      ],
      [
        3,
        -2
      ],
      [
        4,
        3
      ],
      [
        3,
        5
      ],
      [
        2,
        0
      ],
      [
        1,
        -4
      ],
      [
        1,
        -5
      ],
      [
        1,
        -6
      ],
      [
        0,
        -18
      ],
      [
        3,
        -5
      ],
      [
        1,
        -8
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -9
      ],
      [
        -2,
        -7
      ],
      [
        -2,
        -6
      ],
      [
        -4,
        -7
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -1
      ],
      [
        3,
        -7
      ],
      [
        0,
        -10
      ],
      [
        2,
        -4
      ],
      [
        3,
        -5
      ],
      [
        2,
        -8
      ]
    ],
    [
      [
        18332,
        73176
      ],
      [
        0,
        -8
      ],
      [
        7,
        -18
      ],
      [
        7,
        -4
      ],
      [
        2,
        -22
      ],
      [
        7,
        -6
      ],
      [
        8,
        -15
      ],
      [
        3,
        -15
      ],
      [
        -3,
        -19
      ],
      [
        2,
        -55
      ],
      [
        6,
        -8
      ],
      [
        5,
        13
      ],
      [
        7,
        -11
      ],
      [
        4,
        -17
      ],
      [
        6,
        -7
      ],
      [
        -1,
        -8
      ],
      [
        12,
        -2
      ],
      [
        7,
        16
      ],
      [
        3,
        -11
      ],
      [
        1,
        -23
      ],
      [
        6,
        14
      ],
      [
        4,
        -2
      ]
    ],
    [
      [
        18425,
        72968
      ],
      [
        4,
        -1
      ],
      [
        5,
        -15
      ],
      [
        -3,
        -22
      ],
      [
        4,
        -12
      ],
      [
        -1,
        -17
      ],
      [
        5,
        1
      ],
      [
        8,
        -22
      ],
      [
        -4,
        -7
      ],
      [
        1,
        -22
      ],
      [
        3,
        5
      ],
      [
        8,
        -6
      ],
      [
        8,
        -63
      ],
      [
        -4,
        1
      ],
      [
        -5,
        -35
      ],
      [
        -11,
        -2
      ],
      [
        -10,
        10
      ]
    ],
    [
      [
        18389,
        72344
      ],
      [
        -51,
        0
      ],
      [
        0,
        6
      ],
      [
        -39,
        0
      ]
    ],
    [
      [
        18299,
        72350
      ],
      [
        -47,
        0
      ]
    ],
    [
      [
        18252,
        72350
      ],
      [
        3,
        25
      ],
      [
        1,
        43
      ],
      [
        4,
        5
      ],
      [
        2,
        40
      ],
      [
        -1,
        28
      ],
      [
        -10,
        -2
      ],
      [
        -6,
        18
      ],
      [
        -1,
        12
      ],
      [
        4,
        12
      ],
      [
        -1,
        21
      ],
      [
        -5,
        11
      ],
      [
        -3,
        25
      ],
      [
        4,
        9
      ],
      [
        0,
        33
      ],
      [
        -2,
        29
      ],
      [
        3,
        20
      ],
      [
        -2,
        15
      ],
      [
        -8,
        24
      ],
      [
        -5,
        0
      ],
      [
        -7,
        39
      ],
      [
        -1,
        3
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        1
      ],
      [
        -3,
        -5
      ],
      [
        -1,
        4
      ],
      [
        1,
        8
      ],
      [
        -9,
        26
      ],
      [
        -11,
        -2
      ],
      [
        -6,
        41
      ],
      [
        -2,
        34
      ],
      [
        -3,
        11
      ],
      [
        -41,
        -1
      ],
      [
        1,
        -16
      ],
      [
        -6,
        0
      ],
      [
        -1,
        -17
      ],
      [
        -7,
        0
      ],
      [
        4,
        -38
      ],
      [
        1,
        11
      ],
      [
        4,
        -4
      ],
      [
        2,
        -39
      ],
      [
        -20,
        0
      ],
      [
        -72,
        -1
      ],
      [
        -35,
        0
      ],
      [
        0,
        -101
      ],
      [
        4,
        0
      ],
      [
        0,
        -99
      ],
      [
        -35,
        0
      ]
    ],
    [
      [
        17982,
        72571
      ],
      [
        0,
        99
      ],
      [
        -60,
        1
      ],
      [
        -11,
        -4
      ],
      [
        -36,
        0
      ],
      [
        0,
        152
      ],
      [
        -6,
        0
      ],
      [
        0,
        17
      ]
    ],
    [
      [
        17869,
        72836
      ],
      [
        0,
        141
      ],
      [
        -3,
        101
      ],
      [
        48,
        0
      ],
      [
        0,
        405
      ],
      [
        -11,
        0
      ],
      [
        0,
        99
      ],
      [
        69,
        0
      ],
      [
        -4,
        14
      ],
      [
        -10,
        9
      ],
      [
        3,
        19
      ],
      [
        -3,
        16
      ],
      [
        3,
        19
      ],
      [
        10,
        9
      ],
      [
        7,
        12
      ],
      [
        2,
        10
      ],
      [
        -7,
        9
      ],
      [
        -3,
        23
      ],
      [
        -7,
        12
      ],
      [
        0,
        12
      ],
      [
        -12,
        2
      ],
      [
        -5,
        10
      ],
      [
        3,
        25
      ],
      [
        9,
        12
      ],
      [
        -1,
        38
      ],
      [
        -5,
        19
      ],
      [
        2,
        23
      ],
      [
        -4,
        33
      ],
      [
        6,
        18
      ],
      [
        4,
        22
      ],
      [
        -4,
        8
      ],
      [
        -10,
        3
      ],
      [
        -2,
        10
      ],
      [
        4,
        11
      ]
    ],
    [
      [
        21473,
        55808
      ],
      [
        144,
        6
      ]
    ],
    [
      [
        21617,
        55814
      ],
      [
        0,
        -505
      ]
    ],
    [
      [
        21617,
        55309
      ],
      [
        -37,
        1
      ]
    ],
    [
      [
        21580,
        55310
      ],
      [
        -107,
        -3
      ]
    ],
    [
      [
        21473,
        55307
      ],
      [
        0,
        501
      ]
    ],
    [
      [
        24411,
        60929
      ],
      [
        62,
        -2
      ],
      [
        -1,
        -102
      ],
      [
        44,
        -3
      ]
    ],
    [
      [
        24516,
        60822
      ],
      [
        -1,
        -127
      ]
    ],
    [
      [
        24515,
        60695
      ],
      [
        -15,
        1
      ],
      [
        -29,
        5
      ],
      [
        0,
        -103
      ],
      [
        29,
        -3
      ],
      [
        -1,
        -101
      ]
    ],
    [
      [
        24499,
        60494
      ],
      [
        -121,
        9
      ]
    ],
    [
      [
        24378,
        60503
      ],
      [
        -30,
        1
      ],
      [
        0,
        203
      ],
      [
        -15,
        1
      ]
    ],
    [
      [
        24333,
        60708
      ],
      [
        1,
        224
      ],
      [
        20,
        -1
      ],
      [
        57,
        -2
      ]
    ],
    [
      [
        22019,
        53128
      ],
      [
        142,
        0
      ]
    ],
    [
      [
        22161,
        53128
      ],
      [
        0,
        -171
      ],
      [
        33,
        0
      ]
    ],
    [
      [
        22194,
        52957
      ],
      [
        1,
        -268
      ]
    ],
    [
      [
        22195,
        52689
      ],
      [
        -176,
        0
      ]
    ],
    [
      [
        21985,
        54286
      ],
      [
        -4,
        -1
      ],
      [
        -115,
        5
      ]
    ],
    [
      [
        24376,
        60067
      ],
      [
        2,
        233
      ],
      [
        0,
        203
      ]
    ],
    [
      [
        24499,
        60494
      ],
      [
        11,
        -1
      ],
      [
        -1,
        -85
      ],
      [
        0,
        -34
      ],
      [
        5,
        1
      ],
      [
        0,
        -68
      ],
      [
        10,
        0
      ],
      [
        -1,
        -64
      ],
      [
        11,
        4
      ],
      [
        0,
        -34
      ],
      [
        5,
        4
      ],
      [
        0,
        -17
      ],
      [
        10,
        8
      ],
      [
        0,
        -34
      ],
      [
        5,
        3
      ],
      [
        -1,
        -55
      ]
    ],
    [
      [
        24553,
        60122
      ],
      [
        -13,
        -2
      ],
      [
        -11,
        -9
      ],
      [
        -31,
        0
      ],
      [
        -2,
        -236
      ]
    ],
    [
      [
        24496,
        59875
      ],
      [
        -7,
        2
      ],
      [
        -64,
        1
      ],
      [
        -6,
        1
      ],
      [
        -44,
        2
      ]
    ],
    [
      [
        24375,
        59881
      ],
      [
        1,
        84
      ],
      [
        0,
        102
      ]
    ],
    [
      [
        21698,
        53784
      ],
      [
        1,
        508
      ]
    ],
    [
      [
        21699,
        54292
      ],
      [
        22,
        0
      ]
    ],
    [
      [
        21822,
        54291
      ],
      [
        -1,
        -455
      ]
    ],
    [
      [
        21698,
        53674
      ],
      [
        0,
        110
      ]
    ],
    [
      [
        20920,
        61345
      ],
      [
        3,
        -6
      ],
      [
        7,
        0
      ],
      [
        8,
        6
      ],
      [
        6,
        -9
      ],
      [
        0,
        -8
      ],
      [
        11,
        -9
      ],
      [
        3,
        7
      ],
      [
        13,
        -6
      ],
      [
        2,
        4
      ],
      [
        6,
        -6
      ],
      [
        3,
        -12
      ],
      [
        7,
        6
      ],
      [
        2,
        -7
      ],
      [
        52,
        1
      ],
      [
        0,
        68
      ],
      [
        30,
        1
      ],
      [
        0,
        107
      ],
      [
        2,
        1
      ]
    ],
    [
      [
        21075,
        61483
      ],
      [
        29,
        0
      ]
    ],
    [
      [
        21104,
        61483
      ],
      [
        0,
        -515
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -203
      ]
    ],
    [
      [
        21102,
        60760
      ],
      [
        -182,
        0
      ],
      [
        0,
        96
      ],
      [
        -1,
        10
      ]
    ],
    [
      [
        20919,
        60866
      ],
      [
        1,
        102
      ],
      [
        0,
        377
      ]
    ],
    [
      [
        21617,
        55814
      ],
      [
        145,
        3
      ]
    ],
    [
      [
        21762,
        55817
      ],
      [
        0,
        -497
      ]
    ],
    [
      [
        21762,
        55320
      ],
      [
        -38,
        -8
      ]
    ],
    [
      [
        21724,
        55312
      ],
      [
        -107,
        -3
      ]
    ],
    [
      [
        20566,
        62490
      ],
      [
        83,
        0
      ]
    ],
    [
      [
        20649,
        62490
      ],
      [
        1,
        -117
      ],
      [
        0,
        -187
      ],
      [
        -11,
        1
      ],
      [
        -1,
        -82
      ],
      [
        11,
        -3
      ],
      [
        26,
        0
      ],
      [
        0,
        -70
      ],
      [
        -1,
        -101
      ]
    ],
    [
      [
        20674,
        61931
      ],
      [
        -31,
        4
      ],
      [
        -5,
        -6
      ],
      [
        -41,
        -1
      ],
      [
        -6,
        0
      ],
      [
        1,
        58
      ],
      [
        -26,
        0
      ]
    ],
    [
      [
        20566,
        61986
      ],
      [
        0,
        504
      ]
    ],
    [
      [
        17579,
        73067
      ],
      [
        10,
        -12
      ],
      [
        -1,
        -43
      ],
      [
        4,
        -13
      ],
      [
        10,
        -4
      ],
      [
        3,
        -6
      ],
      [
        6,
        41
      ],
      [
        8,
        -2
      ],
      [
        2,
        13
      ],
      [
        12,
        19
      ],
      [
        7,
        1
      ],
      [
        1,
        7
      ],
      [
        8,
        7
      ],
      [
        5,
        19
      ],
      [
        3,
        23
      ],
      [
        9,
        5
      ],
      [
        8,
        -19
      ],
      [
        5,
        -26
      ],
      [
        1,
        -3
      ],
      [
        1,
        -5
      ],
      [
        1,
        -6
      ],
      [
        2,
        -6
      ],
      [
        0,
        -14
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -7
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -8
      ],
      [
        2,
        -4
      ],
      [
        3,
        -2
      ],
      [
        1,
        -4
      ],
      [
        1,
        -7
      ],
      [
        2,
        -4
      ],
      [
        1,
        -4
      ],
      [
        0,
        -4
      ],
      [
        1,
        -5
      ],
      [
        2,
        -8
      ],
      [
        -1,
        -11
      ],
      [
        2,
        -7
      ],
      [
        0,
        -5
      ],
      [
        1,
        -7
      ],
      [
        0,
        -13
      ],
      [
        1,
        -6
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        0
      ],
      [
        1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        2,
        -4
      ],
      [
        1,
        -3
      ],
      [
        2,
        -5
      ],
      [
        1,
        -2
      ],
      [
        2,
        -4
      ],
      [
        0,
        -14
      ],
      [
        1,
        -4
      ],
      [
        1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        1,
        -5
      ],
      [
        1,
        -4
      ],
      [
        2,
        -4
      ],
      [
        0,
        -4
      ],
      [
        2,
        -4
      ],
      [
        3,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        -4
      ],
      [
        2,
        -5
      ],
      [
        1,
        -3
      ],
      [
        1,
        -4
      ],
      [
        0,
        -4
      ],
      [
        1,
        -3
      ],
      [
        1,
        -5
      ],
      [
        0,
        -8
      ],
      [
        1,
        -6
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -9
      ],
      [
        -2,
        -8
      ],
      [
        0,
        -14
      ],
      [
        2,
        -6
      ],
      [
        1,
        -8
      ],
      [
        1,
        -7
      ],
      [
        2,
        -4
      ],
      [
        2,
        -5
      ],
      [
        3,
        -3
      ],
      [
        3,
        0
      ],
      [
        3,
        3
      ],
      [
        2,
        4
      ],
      [
        1,
        2
      ],
      [
        1,
        1
      ],
      [
        1,
        -2
      ],
      [
        2,
        -1
      ],
      [
        1,
        2
      ],
      [
        2,
        4
      ],
      [
        4,
        -5
      ],
      [
        3,
        -4
      ],
      [
        1,
        -1
      ],
      [
        2,
        3
      ],
      [
        0,
        6
      ],
      [
        -1,
        7
      ],
      [
        1,
        5
      ],
      [
        0,
        4
      ],
      [
        3,
        2
      ],
      [
        2,
        1
      ],
      [
        2,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -16
      ],
      [
        3,
        -7
      ],
      [
        3,
        -5
      ],
      [
        4,
        4
      ],
      [
        3,
        4
      ],
      [
        2,
        4
      ],
      [
        3,
        3
      ],
      [
        4,
        3
      ],
      [
        2,
        -1
      ],
      [
        2,
        -6
      ],
      [
        2,
        -4
      ],
      [
        1,
        -8
      ],
      [
        1,
        -6
      ],
      [
        2,
        -6
      ],
      [
        1,
        -3
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        2,
        4
      ],
      [
        2,
        8
      ],
      [
        1,
        1
      ],
      [
        2,
        3
      ],
      [
        0,
        7
      ],
      [
        3,
        0
      ],
      [
        2,
        -4
      ],
      [
        2,
        -1
      ],
      [
        2,
        3
      ],
      [
        1,
        3
      ],
      [
        2,
        3
      ],
      [
        1,
        3
      ],
      [
        1,
        -3
      ],
      [
        1,
        2
      ],
      [
        1,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        0,
        4
      ],
      [
        1,
        7
      ],
      [
        1,
        6
      ],
      [
        -1,
        4
      ],
      [
        1,
        5
      ],
      [
        0,
        4
      ],
      [
        -1,
        6
      ],
      [
        0,
        8
      ],
      [
        1,
        0
      ],
      [
        1,
        7
      ],
      [
        0,
        9
      ],
      [
        1,
        3
      ],
      [
        1,
        -2
      ],
      [
        2,
        -7
      ],
      [
        1,
        -6
      ],
      [
        1,
        0
      ],
      [
        2,
        2
      ],
      [
        0,
        13
      ],
      [
        2,
        4
      ],
      [
        1,
        4
      ],
      [
        -1,
        6
      ],
      [
        -2,
        4
      ],
      [
        -1,
        5
      ],
      [
        0,
        16
      ],
      [
        -1,
        4
      ],
      [
        0,
        3
      ],
      [
        2,
        4
      ],
      [
        38,
        0
      ]
    ],
    [
      [
        17982,
        72571
      ],
      [
        0,
        -51
      ],
      [
        6,
        0
      ],
      [
        0,
        -168
      ],
      [
        65,
        0
      ],
      [
        3,
        -15
      ],
      [
        5,
        8
      ],
      [
        -5,
        -13
      ],
      [
        0,
        -18
      ],
      [
        3,
        -14
      ],
      [
        -10,
        -19
      ],
      [
        0,
        -24
      ],
      [
        -5,
        -43
      ],
      [
        3,
        -3
      ],
      [
        6,
        18
      ],
      [
        14,
        0
      ],
      [
        4,
        -33
      ],
      [
        -5,
        -7
      ],
      [
        -6,
        6
      ],
      [
        -1,
        -18
      ],
      [
        -3,
        -13
      ],
      [
        -1,
        -38
      ],
      [
        -3,
        -21
      ],
      [
        8,
        -29
      ],
      [
        0,
        -10
      ],
      [
        5,
        7
      ],
      [
        5,
        -8
      ],
      [
        24,
        0
      ],
      [
        0,
        -202
      ],
      [
        4,
        0
      ],
      [
        0,
        -51
      ]
    ],
    [
      [
        18098,
        71812
      ],
      [
        -7,
        -12
      ],
      [
        -6,
        7
      ],
      [
        -5,
        -15
      ],
      [
        -10,
        6
      ],
      [
        -4,
        12
      ],
      [
        -8,
        10
      ],
      [
        -7,
        15
      ],
      [
        3,
        21
      ],
      [
        -2,
        17
      ],
      [
        -2,
        -4
      ],
      [
        -12,
        11
      ],
      [
        -6,
        16
      ],
      [
        -8,
        -3
      ],
      [
        -4,
        13
      ],
      [
        -6,
        1
      ],
      [
        -15,
        23
      ],
      [
        -6,
        17
      ],
      [
        -8,
        3
      ],
      [
        -12,
        11
      ],
      [
        -14,
        9
      ],
      [
        -6,
        -22
      ],
      [
        -12,
        10
      ],
      [
        -3,
        -4
      ],
      [
        -10,
        10
      ]
    ],
    [
      [
        17928,
        71964
      ],
      [
        -12,
        0
      ],
      [
        0,
        34
      ],
      [
        -18,
        0
      ],
      [
        0,
        17
      ],
      [
        -18,
        0
      ],
      [
        0,
        71
      ],
      [
        -2,
        25
      ],
      [
        -10,
        6
      ],
      [
        -4,
        16
      ],
      [
        -5,
        -7
      ],
      [
        -12,
        22
      ],
      [
        -11,
        -4
      ],
      [
        -6,
        11
      ],
      [
        -2,
        17
      ],
      [
        -10,
        16
      ],
      [
        -5,
        1
      ],
      [
        -11,
        21
      ],
      [
        -9,
        8
      ],
      [
        -6,
        -18
      ],
      [
        -11,
        -1
      ],
      [
        -5,
        15
      ],
      [
        -11,
        2
      ],
      [
        -8,
        -11
      ],
      [
        -4,
        -12
      ],
      [
        -13,
        10
      ],
      [
        -4,
        24
      ],
      [
        -6,
        1
      ],
      [
        1,
        -13
      ],
      [
        -3,
        -10
      ],
      [
        -9,
        -6
      ],
      [
        -13,
        5
      ],
      [
        -4,
        5
      ]
    ],
    [
      [
        17697,
        72209
      ],
      [
        -2,
        3
      ],
      [
        -6,
        -5
      ],
      [
        -3,
        12
      ],
      [
        -5,
        -3
      ],
      [
        -3,
        16
      ],
      [
        -4,
        16
      ],
      [
        0,
        13
      ],
      [
        3,
        4
      ],
      [
        -1,
        8
      ],
      [
        -4,
        -2
      ],
      [
        -7,
        7
      ],
      [
        -1,
        5
      ],
      [
        -1,
        7
      ],
      [
        1,
        7
      ],
      [
        3,
        15
      ],
      [
        4,
        10
      ],
      [
        4,
        1
      ],
      [
        5,
        21
      ],
      [
        -2,
        33
      ],
      [
        -4,
        14
      ],
      [
        -1,
        1
      ],
      [
        -5,
        7
      ],
      [
        -1,
        14
      ],
      [
        2,
        20
      ],
      [
        1,
        29
      ],
      [
        -2,
        9
      ],
      [
        -6,
        14
      ],
      [
        -2,
        3
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        0
      ],
      [
        -1,
        3
      ],
      [
        -2,
        11
      ],
      [
        0,
        16
      ],
      [
        -4,
        17
      ],
      [
        -2,
        1
      ],
      [
        -6,
        -7
      ],
      [
        -2,
        4
      ],
      [
        -1,
        6
      ],
      [
        0,
        16
      ],
      [
        -1,
        6
      ],
      [
        -2,
        6
      ],
      [
        -1,
        28
      ],
      [
        1,
        7
      ],
      [
        -2,
        15
      ],
      [
        -5,
        8
      ],
      [
        -1,
        10
      ],
      [
        -2,
        7
      ],
      [
        -5,
        -8
      ],
      [
        -2,
        4
      ],
      [
        -3,
        13
      ],
      [
        -6,
        30
      ],
      [
        -6,
        18
      ],
      [
        -1,
        14
      ],
      [
        -1,
        4
      ],
      [
        -4,
        2
      ],
      [
        -3,
        12
      ],
      [
        0,
        9
      ],
      [
        -1,
        6
      ],
      [
        -3,
        13
      ],
      [
        -6,
        27
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        6
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        17580,
        72789
      ],
      [
        0,
        104
      ],
      [
        -1,
        12
      ],
      [
        1,
        13
      ],
      [
        0,
        43
      ],
      [
        -1,
        106
      ]
    ],
    [
      [
        22154,
        54789
      ],
      [
        5,
        0
      ]
    ],
    [
      [
        22298,
        54789
      ],
      [
        -2,
        -506
      ]
    ],
    [
      [
        22275,
        54282
      ],
      [
        -121,
        3
      ]
    ],
    [
      [
        22053,
        55817
      ],
      [
        1,
        -509
      ]
    ],
    [
      [
        22054,
        55308
      ],
      [
        -43,
        0
      ]
    ],
    [
      [
        21906,
        55311
      ],
      [
        1,
        506
      ]
    ],
    [
      [
        22581,
        58122
      ],
      [
        22,
        0
      ],
      [
        3,
        -20
      ],
      [
        2,
        3
      ],
      [
        13,
        -20
      ],
      [
        2,
        12
      ],
      [
        0,
        22
      ],
      [
        4,
        -2
      ],
      [
        3,
        -23
      ],
      [
        6,
        0
      ],
      [
        -1,
        -10
      ],
      [
        5,
        5
      ],
      [
        6,
        15
      ],
      [
        2,
        -20
      ],
      [
        7,
        -11
      ],
      [
        1,
        -1
      ],
      [
        6,
        7
      ],
      [
        4,
        -9
      ],
      [
        6,
        15
      ],
      [
        3,
        -7
      ],
      [
        6,
        -19
      ],
      [
        9,
        2
      ],
      [
        10,
        12
      ]
    ],
    [
      [
        22700,
        58073
      ],
      [
        0,
        -556
      ],
      [
        1,
        -3
      ]
    ],
    [
      [
        22701,
        57514
      ],
      [
        0,
        -203
      ]
    ],
    [
      [
        22701,
        57311
      ],
      [
        -62,
        1
      ],
      [
        -41,
        0
      ],
      [
        -10,
        -1
      ],
      [
        -5,
        0
      ]
    ],
    [
      [
        22582,
        57513
      ],
      [
        0,
        272
      ],
      [
        1,
        134
      ],
      [
        -2,
        203
      ]
    ],
    [
      [
        23358,
        55793
      ],
      [
        1,
        1
      ]
    ],
    [
      [
        23359,
        55794
      ],
      [
        1,
        5
      ],
      [
        8,
        -6
      ],
      [
        5,
        -11
      ],
      [
        8,
        5
      ],
      [
        7,
        11
      ],
      [
        1,
        -9
      ],
      [
        9,
        14
      ],
      [
        3,
        -6
      ],
      [
        8,
        11
      ]
    ],
    [
      [
        23409,
        55808
      ],
      [
        0,
        -414
      ]
    ],
    [
      [
        23409,
        55394
      ],
      [
        -3,
        -4
      ],
      [
        -4,
        -20
      ]
    ],
    [
      [
        23402,
        55370
      ],
      [
        -6,
        -60
      ],
      [
        -16,
        0
      ],
      [
        -22,
        1
      ]
    ],
    [
      [
        23358,
        55311
      ],
      [
        0,
        482
      ]
    ],
    [
      [
        23144,
        55166
      ],
      [
        40,
        -1
      ]
    ],
    [
      [
        23184,
        55165
      ],
      [
        3,
        -26
      ],
      [
        4,
        -10
      ],
      [
        4,
        -3
      ],
      [
        8,
        -31
      ],
      [
        10,
        -12
      ],
      [
        9,
        10
      ],
      [
        10,
        -6
      ],
      [
        -1,
        -13
      ],
      [
        9,
        -8
      ],
      [
        0,
        -7
      ],
      [
        6,
        -1
      ],
      [
        9,
        -21
      ],
      [
        5,
        -19
      ],
      [
        7,
        11
      ]
    ],
    [
      [
        23267,
        55029
      ],
      [
        2,
        -14
      ],
      [
        10,
        -18
      ],
      [
        -1,
        -7
      ]
    ],
    [
      [
        23278,
        54990
      ],
      [
        0,
        -241
      ],
      [
        6,
        -22
      ],
      [
        6,
        -9
      ],
      [
        4,
        -24
      ],
      [
        10,
        -27
      ],
      [
        2,
        -23
      ],
      [
        9,
        -29
      ],
      [
        2,
        4
      ],
      [
        2,
        -15
      ]
    ],
    [
      [
        23319,
        54604
      ],
      [
        -175,
        2
      ]
    ],
    [
      [
        23144,
        54606
      ],
      [
        0,
        560
      ]
    ],
    [
      [
        22056,
        64317
      ],
      [
        79,
        0
      ],
      [
        15,
        -17
      ]
    ],
    [
      [
        22151,
        63911
      ],
      [
        -126,
        1
      ]
    ],
    [
      [
        22025,
        63912
      ],
      [
        -1,
        101
      ],
      [
        32,
        0
      ],
      [
        0,
        304
      ]
    ],
    [
      [
        22657,
        64316
      ],
      [
        127,
        0
      ]
    ],
    [
      [
        22784,
        64316
      ],
      [
        0,
        -405
      ]
    ],
    [
      [
        22784,
        63911
      ],
      [
        -126,
        0
      ]
    ],
    [
      [
        22658,
        63911
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        23083,
        55333
      ],
      [
        0,
        431
      ]
    ],
    [
      [
        23083,
        55764
      ],
      [
        122,
        67
      ]
    ],
    [
      [
        23205,
        55831
      ],
      [
        -1,
        -222
      ]
    ],
    [
      [
        23204,
        55609
      ],
      [
        -1,
        -255
      ],
      [
        1,
        -24
      ]
    ],
    [
      [
        23204,
        55330
      ],
      [
        -23,
        1
      ],
      [
        -10,
        -109
      ],
      [
        -2,
        -12
      ],
      [
        8,
        -36
      ],
      [
        7,
        -9
      ]
    ],
    [
      [
        23144,
        55166
      ],
      [
        -61,
        4
      ]
    ],
    [
      [
        23083,
        55170
      ],
      [
        0,
        163
      ]
    ],
    [
      [
        23098,
        52995
      ],
      [
        14,
        21
      ],
      [
        6,
        4
      ],
      [
        26,
        63
      ],
      [
        8,
        22
      ],
      [
        11,
        6
      ],
      [
        9,
        22
      ],
      [
        59,
        3
      ]
    ],
    [
      [
        23231,
        53136
      ],
      [
        4,
        -3
      ],
      [
        7,
        -14
      ],
      [
        9,
        2
      ],
      [
        5,
        -7
      ],
      [
        3,
        10
      ],
      [
        2,
        -6
      ],
      [
        3,
        -27
      ],
      [
        4,
        -5
      ],
      [
        -1,
        -16
      ],
      [
        -8,
        -5
      ],
      [
        -2,
        -10
      ],
      [
        4,
        -10
      ],
      [
        -4,
        -27
      ],
      [
        -3,
        -7
      ],
      [
        5,
        -19
      ],
      [
        7,
        -51
      ],
      [
        6,
        4
      ]
    ],
    [
      [
        23204,
        52868
      ],
      [
        -74,
        -44
      ],
      [
        -12,
        -4
      ]
    ],
    [
      [
        23118,
        52820
      ],
      [
        -1,
        8
      ],
      [
        -1,
        33
      ],
      [
        -5,
        15
      ],
      [
        0,
        13
      ],
      [
        -5,
        34
      ],
      [
        4,
        24
      ],
      [
        -2,
        17
      ],
      [
        -7,
        9
      ],
      [
        -3,
        22
      ]
    ],
    [
      [
        22730,
        56855
      ],
      [
        0,
        253
      ]
    ],
    [
      [
        22730,
        57108
      ],
      [
        59,
        0
      ]
    ],
    [
      [
        22789,
        57108
      ],
      [
        0,
        -152
      ],
      [
        84,
        -1
      ],
      [
        4,
        -3
      ],
      [
        0,
        -29
      ],
      [
        -2,
        -7
      ],
      [
        0,
        -4
      ],
      [
        3,
        -4
      ],
      [
        1,
        -3
      ],
      [
        26,
        0
      ]
    ],
    [
      [
        22905,
        56905
      ],
      [
        0,
        -186
      ]
    ],
    [
      [
        22905,
        56719
      ],
      [
        -9,
        0
      ],
      [
        -1,
        -118
      ]
    ],
    [
      [
        22895,
        56601
      ],
      [
        -164,
        0
      ]
    ],
    [
      [
        22731,
        56601
      ],
      [
        -1,
        14
      ],
      [
        0,
        240
      ]
    ],
    [
      [
        28101,
        62058
      ],
      [
        9,
        -2
      ],
      [
        14,
        23
      ],
      [
        5,
        18
      ],
      [
        4,
        37
      ],
      [
        5,
        35
      ],
      [
        6,
        12
      ]
    ],
    [
      [
        28144,
        62181
      ],
      [
        9,
        -40
      ],
      [
        5,
        -8
      ],
      [
        8,
        -28
      ],
      [
        7,
        -4
      ],
      [
        2,
        -21
      ],
      [
        -3,
        -24
      ],
      [
        4,
        -4
      ],
      [
        0,
        -31
      ],
      [
        5,
        -20
      ],
      [
        12,
        -18
      ],
      [
        5,
        2
      ]
    ],
    [
      [
        28198,
        61985
      ],
      [
        -12,
        -33
      ],
      [
        -31,
        -82
      ],
      [
        -24,
        -89
      ],
      [
        -11,
        20
      ],
      [
        -4,
        -7
      ]
    ],
    [
      [
        28116,
        61794
      ],
      [
        -30,
        111
      ]
    ],
    [
      [
        28086,
        61905
      ],
      [
        6,
        28
      ],
      [
        1,
        36
      ],
      [
        -5,
        23
      ],
      [
        3,
        41
      ],
      [
        5,
        2
      ],
      [
        5,
        23
      ]
    ],
    [
      [
        25644,
        57317
      ],
      [
        14,
        -42
      ],
      [
        5,
        2
      ],
      [
        8,
        -21
      ],
      [
        4,
        -8
      ],
      [
        3,
        -10
      ],
      [
        2,
        -6
      ],
      [
        19,
        -39
      ],
      [
        13,
        -15
      ],
      [
        6,
        -12
      ],
      [
        13,
        -7
      ]
    ],
    [
      [
        25731,
        57159
      ],
      [
        11,
        6
      ],
      [
        8,
        32
      ],
      [
        6,
        7
      ],
      [
        7,
        -13
      ],
      [
        3,
        -30
      ],
      [
        8,
        4
      ],
      [
        6,
        25
      ],
      [
        5,
        6
      ],
      [
        8,
        -8
      ],
      [
        4,
        -16
      ],
      [
        1,
        -18
      ]
    ],
    [
      [
        25798,
        57154
      ],
      [
        -1,
        -3
      ],
      [
        -5,
        -144
      ],
      [
        0,
        -2
      ],
      [
        -3,
        -55
      ],
      [
        0,
        -77
      ]
    ],
    [
      [
        25789,
        56873
      ],
      [
        -65,
        4
      ],
      [
        -6,
        0
      ],
      [
        -71,
        5
      ],
      [
        -5,
        2
      ]
    ],
    [
      [
        25642,
        56884
      ],
      [
        0,
        118
      ],
      [
        1,
        185
      ],
      [
        0,
        36
      ],
      [
        1,
        94
      ]
    ],
    [
      [
        28045,
        61665
      ],
      [
        6,
        30
      ],
      [
        3,
        33
      ]
    ],
    [
      [
        28054,
        61728
      ],
      [
        5,
        -30
      ],
      [
        0,
        -35
      ],
      [
        -2,
        -11
      ],
      [
        2,
        -18
      ],
      [
        3,
        -14
      ],
      [
        -1,
        -18
      ],
      [
        5,
        -19
      ],
      [
        1,
        -13
      ],
      [
        7,
        -25
      ],
      [
        5,
        -4
      ],
      [
        1,
        -17
      ],
      [
        -2,
        -9
      ],
      [
        5,
        -5
      ],
      [
        0,
        -13
      ],
      [
        12,
        -9
      ],
      [
        5,
        4
      ]
    ],
    [
      [
        28100,
        61492
      ],
      [
        -1,
        -5
      ],
      [
        -21,
        -98
      ]
    ],
    [
      [
        28078,
        61389
      ],
      [
        -63,
        81
      ],
      [
        -19,
        28
      ]
    ],
    [
      [
        27996,
        61498
      ],
      [
        3,
        18
      ],
      [
        5,
        -2
      ],
      [
        1,
        10
      ],
      [
        7,
        8
      ],
      [
        5,
        21
      ],
      [
        9,
        11
      ],
      [
        0,
        16
      ],
      [
        3,
        19
      ],
      [
        6,
        6
      ],
      [
        2,
        28
      ],
      [
        6,
        14
      ],
      [
        2,
        18
      ]
    ],
    [
      [
        5096,
        90290
      ],
      [
        0,
        303
      ],
      [
        53,
        0
      ],
      [
        0,
        100
      ],
      [
        -7,
        0
      ],
      [
        0,
        202
      ],
      [
        54,
        0
      ],
      [
        0,
        101
      ],
      [
        107,
        0
      ],
      [
        1,
        101
      ],
      [
        49,
        0
      ],
      [
        0,
        101
      ],
      [
        55,
        0
      ],
      [
        0,
        302
      ],
      [
        -59,
        0
      ],
      [
        -4,
        403
      ],
      [
        0,
        404
      ],
      [
        52,
        0
      ],
      [
        0,
        201
      ],
      [
        57,
        0
      ],
      [
        -3,
        202
      ],
      [
        0,
        202
      ],
      [
        57,
        0
      ],
      [
        -2,
        201
      ],
      [
        0,
        101
      ],
      [
        -58,
        0
      ]
    ],
    [
      [
        6639,
        96096
      ],
      [
        2596,
        0
      ],
      [
        0,
        582
      ],
      [
        1050,
        0
      ],
      [
        244,
        -1
      ],
      [
        98,
        0
      ]
    ],
    [
      [
        10627,
        96677
      ],
      [
        0,
        -3096
      ]
    ],
    [
      [
        10627,
        93581
      ],
      [
        -1,
        0
      ],
      [
        -11,
        -7
      ],
      [
        -9,
        -8
      ],
      [
        -5,
        -2
      ],
      [
        -5,
        -11
      ],
      [
        -5,
        -14
      ],
      [
        -6,
        -9
      ],
      [
        -6,
        -18
      ],
      [
        -10,
        -7
      ],
      [
        -4,
        -9
      ],
      [
        -4,
        -8
      ],
      [
        -5,
        -14
      ],
      [
        -8,
        -15
      ],
      [
        -9,
        -23
      ],
      [
        -6,
        -11
      ],
      [
        0,
        -28
      ],
      [
        -5,
        -23
      ],
      [
        -7,
        -18
      ],
      [
        0,
        -25
      ],
      [
        -10,
        -20
      ],
      [
        -17,
        -17
      ],
      [
        -6,
        -6
      ],
      [
        -1,
        -11
      ],
      [
        -6,
        -9
      ],
      [
        -7,
        -2
      ],
      [
        -9,
        -25
      ],
      [
        -8,
        -7
      ],
      [
        -3,
        -8
      ],
      [
        -5,
        -14
      ],
      [
        -12,
        -1
      ],
      [
        -14,
        -17
      ],
      [
        -10,
        -1
      ],
      [
        -5,
        -23
      ],
      [
        -3,
        -17
      ],
      [
        -7,
        -12
      ],
      [
        -7,
        -13
      ],
      [
        -4,
        -7
      ],
      [
        -7,
        13
      ],
      [
        -6,
        -1
      ],
      [
        -11,
        -11
      ],
      [
        -13,
        -4
      ],
      [
        -7,
        10
      ],
      [
        -9,
        10
      ],
      [
        -8,
        5
      ],
      [
        -7,
        6
      ],
      [
        -7,
        -2
      ],
      [
        -5,
        0
      ],
      [
        -7,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -11,
        -10
      ],
      [
        -15,
        -7
      ],
      [
        -12,
        -11
      ],
      [
        -9,
        -12
      ],
      [
        -7,
        -14
      ],
      [
        -11,
        -5
      ],
      [
        -3,
        -12
      ],
      [
        -5,
        -15
      ],
      [
        -8,
        -13
      ],
      [
        -11,
        0
      ],
      [
        -11,
        7
      ],
      [
        -10,
        10
      ],
      [
        -13,
        -7
      ],
      [
        -7,
        -11
      ],
      [
        -4,
        -18
      ],
      [
        -1,
        -18
      ],
      [
        -7,
        -14
      ],
      [
        -7,
        -9
      ],
      [
        -8,
        -3
      ],
      [
        -4,
        -4
      ],
      [
        1,
        -6
      ],
      [
        3,
        -2
      ],
      [
        4,
        -5
      ],
      [
        2,
        -3
      ],
      [
        -1,
        -11
      ],
      [
        2,
        -11
      ],
      [
        -1,
        -10
      ],
      [
        -1,
        -18
      ],
      [
        1,
        -20
      ],
      [
        -3,
        -7
      ],
      [
        -4,
        -12
      ],
      [
        1,
        -13
      ],
      [
        -4,
        -13
      ],
      [
        -1,
        -11
      ],
      [
        -7,
        -14
      ],
      [
        -7,
        -15
      ],
      [
        -6,
        -24
      ],
      [
        -11,
        -6
      ],
      [
        -13,
        2
      ],
      [
        -8,
        -14
      ],
      [
        -9,
        -5
      ],
      [
        1,
        2
      ],
      [
        -6,
        1
      ],
      [
        -5,
        -4
      ],
      [
        -4,
        -13
      ],
      [
        -7,
        -4
      ],
      [
        -9,
        -3
      ],
      [
        -4,
        -11
      ],
      [
        -3,
        -8
      ],
      [
        -6,
        -10
      ],
      [
        -3,
        -12
      ],
      [
        -4,
        8
      ],
      [
        -5,
        -2
      ],
      [
        -7,
        -9
      ],
      [
        -7,
        -24
      ],
      [
        -14,
        -17
      ],
      [
        -13,
        1
      ],
      [
        -7,
        -6
      ],
      [
        2,
        -7
      ],
      [
        -5,
        -16
      ],
      [
        1,
        -12
      ],
      [
        -3,
        -8
      ],
      [
        -3,
        1
      ],
      [
        -4,
        -7
      ],
      [
        3,
        -7
      ],
      [
        -9,
        -9
      ],
      [
        -8,
        4
      ],
      [
        -10,
        -19
      ],
      [
        -5,
        -2
      ],
      [
        -1,
        -11
      ],
      [
        3,
        -15
      ],
      [
        4,
        -15
      ],
      [
        3,
        -17
      ],
      [
        -3,
        -24
      ],
      [
        -2,
        -20
      ],
      [
        -2,
        -18
      ],
      [
        4,
        -19
      ],
      [
        9,
        -15
      ],
      [
        4,
        -8
      ],
      [
        0,
        -11
      ],
      [
        -5,
        -7
      ],
      [
        -12,
        -8
      ],
      [
        -6,
        -12
      ],
      [
        -1,
        -11
      ],
      [
        1,
        -10
      ],
      [
        5,
        -5
      ],
      [
        -3,
        -21
      ],
      [
        -13,
        -16
      ],
      [
        -12,
        -20
      ],
      [
        -5,
        -22
      ],
      [
        -5,
        -19
      ],
      [
        -7,
        -22
      ],
      [
        -4,
        -1
      ],
      [
        -3,
        -5
      ],
      [
        -1,
        -7
      ],
      [
        -5,
        -3
      ],
      [
        -5,
        -2
      ],
      [
        -5,
        -4
      ],
      [
        -5,
        0
      ],
      [
        -6,
        3
      ],
      [
        -4,
        2
      ],
      [
        -4,
        3
      ],
      [
        -6,
        -1
      ],
      [
        -7,
        8
      ],
      [
        -7,
        1
      ],
      [
        -11,
        7
      ],
      [
        -10,
        2
      ],
      [
        -17,
        6
      ],
      [
        -12,
        10
      ]
    ],
    [
      [
        9773,
        92236
      ],
      [
        0,
        11
      ],
      [
        -11,
        39
      ],
      [
        8,
        29
      ],
      [
        14,
        27
      ],
      [
        -17,
        17
      ],
      [
        -7,
        14
      ],
      [
        7,
        61
      ],
      [
        5,
        21
      ],
      [
        0,
        43
      ],
      [
        15,
        32
      ],
      [
        6,
        8
      ],
      [
        1,
        38
      ],
      [
        -20,
        20
      ],
      [
        -8,
        24
      ],
      [
        13,
        14
      ],
      [
        20,
        26
      ],
      [
        18,
        26
      ],
      [
        4,
        23
      ],
      [
        -9,
        14
      ],
      [
        -17,
        20
      ],
      [
        -19,
        0
      ],
      [
        -40,
        -4
      ],
      [
        -22,
        -2
      ],
      [
        -13,
        -16
      ],
      [
        -17,
        -24
      ],
      [
        -22,
        -9
      ],
      [
        -52,
        29
      ],
      [
        -31,
        7
      ],
      [
        -28,
        32
      ],
      [
        -14,
        -5
      ],
      [
        -24,
        2
      ],
      [
        -23,
        -29
      ],
      [
        -19,
        -6
      ],
      [
        -25,
        -31
      ],
      [
        -40,
        15
      ],
      [
        -12,
        -9
      ],
      [
        -4,
        -12
      ],
      [
        -17,
        1
      ],
      [
        -14,
        -23
      ],
      [
        -25,
        -17
      ],
      [
        -8,
        42
      ],
      [
        -26,
        2
      ],
      [
        0,
        17
      ],
      [
        19,
        28
      ],
      [
        8,
        24
      ],
      [
        10,
        8
      ],
      [
        -12,
        54
      ],
      [
        -11,
        2
      ],
      [
        -52,
        26
      ],
      [
        -26,
        20
      ],
      [
        -23,
        34
      ],
      [
        -10,
        21
      ],
      [
        -3,
        51
      ],
      [
        11,
        27
      ],
      [
        22,
        40
      ],
      [
        9,
        20
      ],
      [
        -7,
        22
      ],
      [
        -8,
        -2
      ],
      [
        -18,
        -4
      ],
      [
        -21,
        47
      ],
      [
        -15,
        0
      ],
      [
        -58,
        -19
      ],
      [
        -11,
        3
      ],
      [
        -15,
        -7
      ],
      [
        7,
        -38
      ],
      [
        2,
        -14
      ],
      [
        -16,
        -41
      ],
      [
        -25,
        -13
      ],
      [
        -22,
        -27
      ],
      [
        -42,
        -25
      ],
      [
        -36,
        -11
      ],
      [
        -54,
        3
      ],
      [
        -25,
        -4
      ],
      [
        -28,
        -25
      ],
      [
        -48,
        -56
      ],
      [
        -25,
        2
      ],
      [
        -283,
        0
      ],
      [
        3,
        -404
      ],
      [
        0,
        -310
      ],
      [
        -4,
        -7
      ],
      [
        4,
        -6
      ],
      [
        15,
        36
      ],
      [
        5,
        -7
      ],
      [
        7,
        8
      ],
      [
        6,
        -11
      ],
      [
        20,
        -21
      ],
      [
        9,
        -18
      ],
      [
        -5,
        -10
      ],
      [
        7,
        -5
      ],
      [
        5,
        -35
      ],
      [
        14,
        -11
      ],
      [
        7,
        -12
      ],
      [
        8,
        -28
      ],
      [
        7,
        5
      ],
      [
        11,
        -27
      ],
      [
        6,
        -23
      ],
      [
        -3,
        -16
      ],
      [
        13,
        -29
      ],
      [
        0,
        -11
      ],
      [
        20,
        -27
      ],
      [
        -1,
        -18
      ],
      [
        10,
        -8
      ],
      [
        7,
        -14
      ]
    ],
    [
      [
        8665,
        91840
      ],
      [
        -303,
        0
      ],
      [
        0,
        17
      ],
      [
        -445,
        0
      ],
      [
        -61,
        -168
      ],
      [
        -93,
        -252
      ],
      [
        -35,
        0
      ],
      [
        -7,
        12
      ],
      [
        -23,
        15
      ],
      [
        8,
        28
      ],
      [
        -15,
        7
      ],
      [
        -6,
        5
      ],
      [
        0,
        17
      ],
      [
        -46,
        0
      ],
      [
        -13,
        4
      ],
      [
        -5,
        -4
      ],
      [
        -9,
        -34
      ],
      [
        -10,
        -25
      ],
      [
        9,
        -25
      ],
      [
        -61,
        0
      ],
      [
        -2,
        -202
      ],
      [
        -48,
        0
      ],
      [
        0,
        -201
      ],
      [
        -180,
        0
      ],
      [
        0,
        -202
      ],
      [
        17,
        0
      ],
      [
        0,
        -151
      ],
      [
        54,
        0
      ],
      [
        0,
        -51
      ],
      [
        53,
        0
      ],
      [
        0,
        -141
      ],
      [
        -70,
        -234
      ],
      [
        -89,
        -296
      ]
    ],
    [
      [
        7285,
        89959
      ],
      [
        -1,
        0
      ],
      [
        0,
        -10
      ],
      [
        1,
        -496
      ]
    ],
    [
      [
        7285,
        89453
      ],
      [
        -20,
        0
      ],
      [
        0,
        -101
      ],
      [
        -90,
        0
      ],
      [
        0,
        -101
      ],
      [
        -102,
        0
      ],
      [
        0,
        -101
      ],
      [
        -920,
        0
      ],
      [
        0,
        101
      ],
      [
        -409,
        0
      ],
      [
        0,
        -101
      ],
      [
        -205,
        0
      ],
      [
        0,
        -101
      ],
      [
        -353,
        0
      ]
    ],
    [
      [
        27478,
        63459
      ],
      [
        6,
        -10
      ],
      [
        7,
        -2
      ],
      [
        6,
        25
      ],
      [
        16,
        5
      ],
      [
        4,
        19
      ],
      [
        20,
        13
      ],
      [
        2,
        18
      ],
      [
        8,
        -9
      ],
      [
        0,
        -13
      ],
      [
        9,
        9
      ],
      [
        14,
        -9
      ],
      [
        4,
        7
      ],
      [
        5,
        -10
      ],
      [
        8,
        -13
      ],
      [
        12,
        2
      ],
      [
        3,
        8
      ],
      [
        4,
        15
      ],
      [
        6,
        -15
      ],
      [
        -2,
        -21
      ],
      [
        14,
        5
      ]
    ],
    [
      [
        27624,
        63483
      ],
      [
        -4,
        -28
      ],
      [
        5,
        -11
      ],
      [
        10,
        4
      ],
      [
        9,
        -33
      ],
      [
        0,
        -12
      ],
      [
        -1,
        -14
      ],
      [
        4,
        -26
      ],
      [
        -5,
        -14
      ],
      [
        2,
        -14
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -3,
        -6
      ],
      [
        4,
        -10
      ],
      [
        1,
        -30
      ],
      [
        4,
        -22
      ],
      [
        -8,
        -14
      ],
      [
        2,
        -28
      ],
      [
        7,
        -16
      ],
      [
        -4,
        -26
      ]
    ],
    [
      [
        27646,
        63178
      ],
      [
        -140,
        0
      ]
    ],
    [
      [
        27506,
        63178
      ],
      [
        -28,
        0
      ]
    ],
    [
      [
        27478,
        63178
      ],
      [
        0,
        99
      ],
      [
        1,
        99
      ],
      [
        -1,
        53
      ],
      [
        0,
        30
      ]
    ],
    [
      [
        24286,
        56276
      ],
      [
        87,
        0
      ],
      [
        30,
        -10
      ]
    ],
    [
      [
        24403,
        56266
      ],
      [
        16,
        -3
      ],
      [
        14,
        0
      ],
      [
        -1,
        -253
      ]
    ],
    [
      [
        24432,
        56010
      ],
      [
        -1,
        -203
      ]
    ],
    [
      [
        24431,
        55807
      ],
      [
        -41,
        3
      ],
      [
        -75,
        6
      ],
      [
        -5,
        0
      ],
      [
        -27,
        2
      ]
    ],
    [
      [
        24283,
        55818
      ],
      [
        -4,
        20
      ],
      [
        3,
        24
      ],
      [
        -5,
        12
      ],
      [
        -1,
        12
      ],
      [
        4,
        20
      ],
      [
        -3,
        15
      ],
      [
        3,
        15
      ],
      [
        -2,
        34
      ],
      [
        8,
        1
      ],
      [
        1,
        195
      ],
      [
        0,
        8
      ]
    ],
    [
      [
        24799,
        56194
      ],
      [
        0,
        102
      ],
      [
        39,
        1
      ],
      [
        5,
        0
      ],
      [
        0,
        16
      ],
      [
        15,
        0
      ],
      [
        0,
        86
      ]
    ],
    [
      [
        24858,
        56399
      ],
      [
        43,
        0
      ],
      [
        0,
        -35
      ],
      [
        73,
        0
      ]
    ],
    [
      [
        24974,
        56194
      ],
      [
        0,
        -51
      ]
    ],
    [
      [
        24974,
        56143
      ],
      [
        -63,
        -1
      ],
      [
        -15,
        0
      ]
    ],
    [
      [
        24896,
        56142
      ],
      [
        -95,
        0
      ]
    ],
    [
      [
        24801,
        56142
      ],
      [
        -2,
        0
      ],
      [
        0,
        52
      ]
    ],
    [
      [
        27478,
        60164
      ],
      [
        1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        -1
      ]
    ],
    [
      [
        27475,
        60166
      ],
      [
        0,
        -1
      ],
      [
        6,
        17
      ],
      [
        0,
        -14
      ],
      [
        -6,
        -20
      ],
      [
        -6,
        1
      ],
      [
        -1,
        -22
      ],
      [
        -7,
        -12
      ]
    ],
    [
      [
        27461,
        60115
      ],
      [
        -2,
        14
      ],
      [
        -2,
        12
      ],
      [
        1,
        18
      ],
      [
        11,
        22
      ],
      [
        6,
        -15
      ]
    ],
    [
      [
        23899,
        63948
      ],
      [
        143,
        4
      ],
      [
        -1,
        -50
      ]
    ],
    [
      [
        24041,
        63902
      ],
      [
        0,
        -356
      ]
    ],
    [
      [
        24041,
        63546
      ],
      [
        -2,
        -1
      ],
      [
        -10,
        0
      ],
      [
        -129,
        -4
      ]
    ],
    [
      [
        23900,
        63541
      ],
      [
        -1,
        0
      ],
      [
        0,
        272
      ]
    ],
    [
      [
        23899,
        63813
      ],
      [
        0,
        135
      ]
    ],
    [
      [
        27086,
        60607
      ],
      [
        1,
        -1
      ],
      [
        4,
        18
      ],
      [
        15,
        25
      ]
    ],
    [
      [
        27106,
        60649
      ],
      [
        8,
        -15
      ],
      [
        3,
        -34
      ],
      [
        12,
        -2
      ],
      [
        18,
        -11
      ],
      [
        1,
        6
      ],
      [
        4,
        4
      ],
      [
        1,
        12
      ],
      [
        7,
        9
      ],
      [
        8,
        -14
      ],
      [
        2,
        10
      ],
      [
        7,
        -30
      ],
      [
        11,
        -4
      ],
      [
        2,
        3
      ],
      [
        7,
        -19
      ],
      [
        3,
        3
      ],
      [
        6,
        -5
      ],
      [
        2,
        9
      ],
      [
        8,
        2
      ],
      [
        3,
        -8
      ],
      [
        -2,
        -8
      ],
      [
        5,
        -18
      ],
      [
        2,
        -6
      ],
      [
        10,
        18
      ],
      [
        6,
        -24
      ],
      [
        18,
        -22
      ]
    ],
    [
      [
        27258,
        60505
      ],
      [
        -14,
        -101
      ]
    ],
    [
      [
        27244,
        60404
      ],
      [
        -2,
        -3
      ],
      [
        0,
        -9
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -2,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -7
      ],
      [
        0,
        -3
      ],
      [
        1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        -2,
        -1
      ],
      [
        0,
        -6
      ],
      [
        -2,
        -13
      ],
      [
        0,
        -6
      ],
      [
        -2,
        -9
      ],
      [
        -3,
        -2
      ],
      [
        -1,
        2
      ],
      [
        -4,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -7
      ],
      [
        -4,
        -6
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        7
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -14
      ],
      [
        -4,
        -6
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        -4
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        -2
      ],
      [
        -32,
        -6
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        3
      ],
      [
        0,
        7
      ],
      [
        -1,
        2
      ],
      [
        -2,
        0
      ],
      [
        -1,
        5
      ],
      [
        -5,
        13
      ],
      [
        0,
        6
      ],
      [
        -1,
        4
      ],
      [
        -1,
        3
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        27139,
        60288
      ],
      [
        -2,
        5
      ],
      [
        0,
        6
      ],
      [
        1,
        7
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        10
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        3
      ],
      [
        0,
        6
      ],
      [
        -2,
        0
      ],
      [
        0,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -1,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        3
      ],
      [
        -1,
        3
      ],
      [
        -1,
        3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        0,
        1
      ],
      [
        1,
        1
      ],
      [
        -1,
        2
      ],
      [
        -2,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -3
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        0
      ],
      [
        -3,
        2
      ],
      [
        0,
        5
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        3
      ],
      [
        0,
        9
      ],
      [
        -1,
        6
      ],
      [
        1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        6
      ],
      [
        0,
        1
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        1
      ],
      [
        0,
        3
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        1,
        3
      ],
      [
        1,
        2
      ],
      [
        0,
        2
      ],
      [
        -2,
        6
      ],
      [
        -1,
        0
      ],
      [
        -1,
        3
      ],
      [
        0,
        2
      ],
      [
        -1,
        4
      ],
      [
        0,
        4
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        2
      ],
      [
        -1,
        10
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        2
      ],
      [
        -1,
        5
      ],
      [
        0,
        1
      ],
      [
        -2,
        0
      ],
      [
        -1,
        5
      ],
      [
        0,
        3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        0,
        7
      ],
      [
        -1,
        2
      ],
      [
        -1,
        7
      ],
      [
        1,
        2
      ],
      [
        -1,
        4
      ],
      [
        0,
        1
      ],
      [
        -1,
        3
      ],
      [
        1,
        10
      ],
      [
        2,
        5
      ],
      [
        0,
        5
      ],
      [
        -1,
        4
      ],
      [
        0,
        4
      ],
      [
        1,
        2
      ],
      [
        1,
        0
      ],
      [
        0,
        5
      ],
      [
        -2,
        5
      ],
      [
        -2,
        5
      ],
      [
        -1,
        11
      ],
      [
        1,
        3
      ],
      [
        1,
        5
      ],
      [
        0,
        3
      ],
      [
        -1,
        2
      ],
      [
        -2,
        0
      ],
      [
        -1,
        6
      ],
      [
        -3,
        3
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        4
      ],
      [
        1,
        1
      ],
      [
        -2,
        7
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        1
      ],
      [
        -1,
        7
      ],
      [
        -1,
        10
      ],
      [
        0,
        8
      ],
      [
        1,
        8
      ],
      [
        1,
        2
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        2,
        6
      ],
      [
        2,
        4
      ],
      [
        2,
        -2
      ],
      [
        1,
        0
      ],
      [
        0,
        12
      ],
      [
        2,
        0
      ],
      [
        0,
        6
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        3,
        2
      ],
      [
        1,
        1
      ]
    ],
    [
      [
        28271,
        57652
      ],
      [
        10,
        12
      ],
      [
        38,
        -17
      ],
      [
        28,
        -53
      ],
      [
        10,
        -18
      ],
      [
        0,
        17
      ],
      [
        10,
        18
      ],
      [
        6,
        -2
      ],
      [
        11,
        -13
      ],
      [
        6,
        -30
      ],
      [
        3,
        0
      ],
      [
        1,
        -16
      ],
      [
        3,
        1
      ],
      [
        1,
        -18
      ],
      [
        5,
        -45
      ],
      [
        6,
        -4
      ],
      [
        -5,
        -22
      ],
      [
        6,
        -18
      ],
      [
        1,
        -17
      ],
      [
        2,
        5
      ]
    ],
    [
      [
        28413,
        57432
      ],
      [
        7,
        -29
      ],
      [
        4,
        -4
      ],
      [
        1,
        -28
      ],
      [
        3,
        -17
      ],
      [
        2,
        -27
      ],
      [
        -3,
        -18
      ],
      [
        5,
        -8
      ],
      [
        -5,
        -26
      ],
      [
        2,
        -11
      ]
    ],
    [
      [
        28429,
        57264
      ],
      [
        -8,
        -9
      ],
      [
        -9,
        -13
      ],
      [
        -2,
        -3
      ],
      [
        -9,
        -16
      ],
      [
        -9,
        -21
      ],
      [
        -23,
        -60
      ],
      [
        -39,
        -75
      ],
      [
        -8,
        -18
      ],
      [
        -7,
        -18
      ]
    ],
    [
      [
        28315,
        57031
      ],
      [
        -4,
        20
      ],
      [
        -6,
        16
      ],
      [
        -7,
        6
      ],
      [
        -10,
        119
      ],
      [
        -8,
        65
      ],
      [
        -11,
        100
      ]
    ],
    [
      [
        28269,
        57357
      ],
      [
        1,
        75
      ],
      [
        3,
        64
      ],
      [
        5,
        97
      ],
      [
        -1,
        20
      ],
      [
        -6,
        39
      ]
    ],
    [
      [
        23555,
        63208
      ],
      [
        110,
        -1
      ]
    ],
    [
      [
        23665,
        63207
      ],
      [
        0,
        -255
      ]
    ],
    [
      [
        23665,
        62952
      ],
      [
        -1,
        -84
      ]
    ],
    [
      [
        23664,
        62868
      ],
      [
        -71,
        1
      ],
      [
        -37,
        0
      ],
      [
        -1,
        1
      ]
    ],
    [
      [
        23555,
        62870
      ],
      [
        0,
        86
      ]
    ],
    [
      [
        23555,
        62956
      ],
      [
        0,
        252
      ]
    ],
    [
      [
        25953,
        52315
      ],
      [
        3,
        4
      ],
      [
        5,
        21
      ],
      [
        7,
        -2
      ],
      [
        5,
        8
      ],
      [
        4,
        -12
      ],
      [
        7,
        6
      ],
      [
        4,
        11
      ],
      [
        4,
        24
      ],
      [
        102,
        -5
      ],
      [
        1,
        153
      ],
      [
        14,
        0
      ]
    ],
    [
      [
        26109,
        52523
      ],
      [
        14,
        -1
      ]
    ],
    [
      [
        26123,
        52522
      ],
      [
        -1,
        -254
      ],
      [
        -1,
        -172
      ]
    ],
    [
      [
        26121,
        52096
      ],
      [
        0,
        -208
      ],
      [
        1,
        -114
      ]
    ],
    [
      [
        26122,
        51774
      ],
      [
        -5,
        16
      ],
      [
        -6,
        14
      ],
      [
        -9,
        11
      ],
      [
        -3,
        -2
      ],
      [
        -5,
        4
      ],
      [
        -6,
        12
      ],
      [
        -9,
        28
      ],
      [
        -8,
        36
      ],
      [
        -3,
        13
      ],
      [
        -2,
        21
      ],
      [
        -3,
        1
      ],
      [
        -5,
        10
      ],
      [
        -6,
        9
      ],
      [
        -4,
        6
      ],
      [
        -12,
        22
      ],
      [
        -9,
        25
      ],
      [
        -6,
        21
      ],
      [
        -7,
        23
      ],
      [
        -10,
        26
      ],
      [
        -19,
        43
      ],
      [
        -12,
        26
      ],
      [
        -20,
        36
      ]
    ],
    [
      [
        25953,
        52175
      ],
      [
        0,
        140
      ]
    ],
    [
      [
        31493,
        38404
      ],
      [
        1,
        -13
      ],
      [
        2,
        -13
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -34
      ],
      [
        4,
        -9
      ],
      [
        1,
        -21
      ],
      [
        -3,
        -9
      ],
      [
        0,
        -8
      ],
      [
        3,
        -9
      ],
      [
        1,
        -40
      ],
      [
        1,
        -4
      ]
    ],
    [
      [
        31501,
        38239
      ],
      [
        -2,
        -14
      ],
      [
        -5,
        -8
      ],
      [
        -11,
        2
      ]
    ],
    [
      [
        31483,
        38219
      ],
      [
        2,
        21
      ],
      [
        0,
        3
      ],
      [
        -1,
        26
      ],
      [
        2,
        14
      ],
      [
        -2,
        31
      ],
      [
        2,
        15
      ],
      [
        0,
        10
      ],
      [
        4,
        -4
      ],
      [
        -1,
        23
      ],
      [
        1,
        18
      ],
      [
        -3,
        12
      ]
    ],
    [
      [
        31546,
        38362
      ],
      [
        5,
        13
      ],
      [
        9,
        -6
      ],
      [
        -2,
        -35
      ],
      [
        2,
        -1
      ]
    ],
    [
      [
        31560,
        38333
      ],
      [
        -2,
        -19
      ],
      [
        4,
        -47
      ],
      [
        -2,
        -32
      ],
      [
        9,
        -21
      ]
    ],
    [
      [
        31569,
        38214
      ],
      [
        -3,
        -20
      ],
      [
        -1,
        -4
      ]
    ],
    [
      [
        31565,
        38190
      ],
      [
        -6,
        -3
      ],
      [
        -13,
        21
      ]
    ],
    [
      [
        31546,
        38208
      ],
      [
        3,
        2
      ],
      [
        -2,
        24
      ],
      [
        4,
        32
      ],
      [
        -4,
        32
      ],
      [
        0,
        23
      ],
      [
        1,
        14
      ],
      [
        -3,
        7
      ],
      [
        -2,
        10
      ],
      [
        3,
        10
      ]
    ],
    [
      [
        31435,
        38321
      ],
      [
        3,
        3
      ],
      [
        8,
        -47
      ]
    ],
    [
      [
        31446,
        38277
      ],
      [
        -5,
        -84
      ],
      [
        -5,
        -10
      ]
    ],
    [
      [
        31436,
        38183
      ],
      [
        -7,
        -12
      ],
      [
        -3,
        3
      ]
    ],
    [
      [
        31426,
        38174
      ],
      [
        -9,
        40
      ],
      [
        1,
        21
      ]
    ],
    [
      [
        15811,
        72557
      ],
      [
        19,
        -1
      ],
      [
        24,
        0
      ],
      [
        4,
        -1
      ],
      [
        17,
        0
      ],
      [
        40,
        -1
      ],
      [
        9,
        0
      ],
      [
        18,
        2
      ],
      [
        95,
        0
      ],
      [
        36,
        1
      ],
      [
        0,
        3
      ],
      [
        94,
        -1
      ]
    ],
    [
      [
        16167,
        72559
      ],
      [
        2,
        -25
      ],
      [
        5,
        0
      ],
      [
        4,
        -22
      ],
      [
        -2,
        -13
      ],
      [
        6,
        -17
      ],
      [
        -11,
        -29
      ],
      [
        -5,
        -4
      ],
      [
        -3,
        -46
      ],
      [
        6,
        -57
      ]
    ],
    [
      [
        16169,
        72346
      ],
      [
        -17,
        -8
      ],
      [
        -1,
        -27
      ],
      [
        -11,
        3
      ],
      [
        -5,
        -29
      ],
      [
        -8,
        -25
      ],
      [
        -6,
        -5
      ],
      [
        -5,
        -38
      ],
      [
        -10,
        -11
      ],
      [
        -11,
        -26
      ],
      [
        -2,
        -23
      ],
      [
        -7,
        -12
      ],
      [
        -5,
        -4
      ],
      [
        0,
        -36
      ],
      [
        -3,
        -21
      ],
      [
        -8,
        -5
      ],
      [
        6,
        -28
      ],
      [
        4,
        -10
      ],
      [
        -4,
        -31
      ],
      [
        4,
        -4
      ],
      [
        1,
        -18
      ],
      [
        5,
        1
      ],
      [
        19,
        -11
      ],
      [
        2,
        -24
      ],
      [
        -1,
        -15
      ],
      [
        -6,
        -8
      ],
      [
        -2,
        -19
      ],
      [
        14,
        -14
      ],
      [
        3,
        -28
      ],
      [
        -3,
        -16
      ],
      [
        5,
        -30
      ],
      [
        -1,
        -11
      ],
      [
        -9,
        -7
      ],
      [
        -8,
        10
      ],
      [
        -9,
        -10
      ],
      [
        -3,
        -17
      ],
      [
        1,
        -24
      ],
      [
        6,
        -12
      ]
    ],
    [
      [
        15805,
        72024
      ],
      [
        15,
        18
      ],
      [
        8,
        7
      ],
      [
        3,
        8
      ],
      [
        0,
        50
      ],
      [
        -1,
        10
      ],
      [
        -2,
        10
      ],
      [
        -3,
        8
      ],
      [
        -1,
        13
      ],
      [
        -1,
        17
      ],
      [
        -2,
        4
      ],
      [
        -2,
        3
      ],
      [
        -4,
        4
      ],
      [
        4,
        10
      ],
      [
        2,
        25
      ],
      [
        -1,
        9
      ],
      [
        -6,
        16
      ],
      [
        -3,
        15
      ],
      [
        1,
        11
      ],
      [
        -1,
        29
      ],
      [
        -4,
        22
      ],
      [
        -3,
        9
      ],
      [
        6,
        9
      ],
      [
        4,
        14
      ],
      [
        3,
        -13
      ],
      [
        1,
        -2
      ],
      [
        4,
        2
      ],
      [
        4,
        7
      ],
      [
        1,
        9
      ],
      [
        0,
        1
      ],
      [
        -1,
        10
      ],
      [
        0,
        1
      ],
      [
        -7,
        18
      ],
      [
        -5,
        8
      ],
      [
        -2,
        0
      ],
      [
        -3,
        3
      ],
      [
        -3,
        7
      ],
      [
        -4,
        22
      ],
      [
        6,
        25
      ],
      [
        1,
        11
      ],
      [
        3,
        14
      ],
      [
        4,
        9
      ],
      [
        0,
        3
      ],
      [
        1,
        5
      ],
      [
        1,
        15
      ],
      [
        -3,
        23
      ],
      [
        1,
        11
      ],
      [
        -4,
        16
      ],
      [
        -1,
        7
      ]
    ],
    [
      [
        15775,
        72069
      ],
      [
        2,
        11
      ],
      [
        -2,
        35
      ],
      [
        3,
        18
      ],
      [
        1,
        41
      ],
      [
        4,
        31
      ],
      [
        4,
        8
      ],
      [
        2,
        33
      ],
      [
        7,
        -9
      ],
      [
        -3,
        -11
      ],
      [
        0,
        -8
      ],
      [
        8,
        -24
      ],
      [
        -2,
        -9
      ],
      [
        0,
        -49
      ],
      [
        1,
        -11
      ],
      [
        3,
        -6
      ],
      [
        9,
        -3
      ],
      [
        6,
        -12
      ],
      [
        -2,
        -4
      ],
      [
        -6,
        -5
      ],
      [
        -10,
        -18
      ],
      [
        -3,
        -13
      ],
      [
        -2,
        -13
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        2
      ],
      [
        -6,
        -11
      ],
      [
        -1,
        -5
      ],
      [
        -3,
        0
      ],
      [
        -4,
        3
      ],
      [
        -3,
        14
      ],
      [
        1,
        16
      ]
    ],
    [
      [
        16200,
        73160
      ],
      [
        -20,
        25
      ],
      [
        4,
        34
      ],
      [
        4,
        -1
      ],
      [
        0,
        21
      ],
      [
        -6,
        32
      ],
      [
        8,
        47
      ],
      [
        -1,
        16
      ],
      [
        -6,
        17
      ],
      [
        3,
        29
      ],
      [
        4,
        12
      ],
      [
        10,
        -2
      ],
      [
        2,
        6
      ],
      [
        12,
        1
      ],
      [
        0,
        35
      ],
      [
        13,
        -7
      ],
      [
        0,
        11
      ],
      [
        5,
        6
      ],
      [
        6,
        -10
      ],
      [
        2,
        21
      ],
      [
        9,
        -3
      ],
      [
        4,
        -20
      ],
      [
        -2,
        -10
      ],
      [
        8,
        -15
      ],
      [
        7,
        2
      ],
      [
        17,
        27
      ]
    ],
    [
      [
        16283,
        73434
      ],
      [
        1,
        1
      ],
      [
        7,
        0
      ],
      [
        4,
        3
      ],
      [
        3,
        -3
      ],
      [
        0,
        -7
      ],
      [
        -2,
        -12
      ],
      [
        2,
        -12
      ],
      [
        3,
        -5
      ],
      [
        1,
        -6
      ],
      [
        -1,
        0
      ],
      [
        -3,
        -9
      ],
      [
        0,
        -14
      ],
      [
        2,
        -3
      ],
      [
        -1,
        -12
      ],
      [
        -2,
        -11
      ],
      [
        -3,
        -3
      ],
      [
        1,
        -12
      ],
      [
        2,
        -12
      ],
      [
        2,
        -22
      ],
      [
        0,
        -10
      ],
      [
        2,
        -7
      ],
      [
        5,
        1
      ],
      [
        5,
        -13
      ],
      [
        7,
        -11
      ],
      [
        3,
        -23
      ],
      [
        -5,
        -19
      ],
      [
        1,
        -27
      ],
      [
        9,
        -13
      ],
      [
        7,
        3
      ],
      [
        5,
        -9
      ],
      [
        5,
        -17
      ],
      [
        6,
        -20
      ],
      [
        6,
        -12
      ],
      [
        8,
        -14
      ],
      [
        8,
        -19
      ],
      [
        5,
        -16
      ],
      [
        5,
        -13
      ],
      [
        -1,
        -28
      ],
      [
        -2,
        -22
      ],
      [
        4,
        -23
      ],
      [
        6,
        -14
      ],
      [
        1,
        -7
      ],
      [
        2,
        -2
      ],
      [
        4,
        4
      ],
      [
        1,
        2
      ],
      [
        2,
        -3
      ],
      [
        2,
        -4
      ],
      [
        1,
        -3
      ],
      [
        2,
        -5
      ],
      [
        3,
        -7
      ],
      [
        3,
        -7
      ],
      [
        2,
        -5
      ],
      [
        2,
        -8
      ],
      [
        1,
        -6
      ],
      [
        2,
        -5
      ],
      [
        3,
        -3
      ],
      [
        3,
        -5
      ],
      [
        5,
        2
      ],
      [
        2,
        -7
      ],
      [
        4,
        -5
      ],
      [
        2,
        -1
      ],
      [
        2,
        -2
      ],
      [
        2,
        -2
      ],
      [
        3,
        -8
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -3,
        -4
      ],
      [
        0,
        -8
      ],
      [
        3,
        -10
      ],
      [
        4,
        -3
      ],
      [
        1,
        -4
      ],
      [
        3,
        -5
      ],
      [
        2,
        -3
      ],
      [
        1,
        -2
      ],
      [
        3,
        -3
      ],
      [
        1,
        -6
      ],
      [
        1,
        -8
      ],
      [
        1,
        -8
      ],
      [
        0,
        -9
      ],
      [
        2,
        -7
      ],
      [
        1,
        -4
      ],
      [
        1,
        -6
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -3
      ],
      [
        1,
        -1
      ],
      [
        2,
        -4
      ],
      [
        2,
        -3
      ],
      [
        50,
        0
      ]
    ],
    [
      [
        16515,
        72769
      ],
      [
        3,
        -21
      ],
      [
        -8,
        -29
      ],
      [
        -8,
        -19
      ],
      [
        2,
        -25
      ],
      [
        -3,
        -20
      ],
      [
        -11,
        -19
      ],
      [
        -1,
        -23
      ],
      [
        -4,
        -29
      ],
      [
        -5,
        -23
      ],
      [
        -12,
        -7
      ],
      [
        -15,
        -14
      ],
      [
        -11,
        15
      ],
      [
        -17,
        -20
      ],
      [
        -5,
        -13
      ],
      [
        -3,
        -29
      ],
      [
        5,
        -25
      ],
      [
        1,
        -23
      ],
      [
        -5,
        -21
      ],
      [
        -5,
        -37
      ],
      [
        1,
        -40
      ],
      [
        -7,
        -46
      ],
      [
        -10,
        -23
      ],
      [
        -3,
        -22
      ],
      [
        -3,
        -56
      ],
      [
        -1,
        -17
      ],
      [
        2,
        -14
      ],
      [
        1,
        -15
      ],
      [
        3,
        -22
      ],
      [
        1,
        -14
      ],
      [
        2,
        -9
      ],
      [
        7,
        -11
      ],
      [
        27,
        -19
      ],
      [
        10,
        -2
      ],
      [
        12,
        -31
      ],
      [
        0,
        -45
      ],
      [
        -2,
        -45
      ]
    ],
    [
      [
        16453,
        71956
      ],
      [
        -41,
        0
      ],
      [
        -10,
        -1
      ],
      [
        -28,
        0
      ],
      [
        -4,
        1
      ],
      [
        -1,
        3
      ],
      [
        -1,
        4
      ],
      [
        -1,
        4
      ],
      [
        -3,
        3
      ],
      [
        -2,
        1
      ],
      [
        -2,
        0
      ],
      [
        -3,
        8
      ],
      [
        -2,
        7
      ],
      [
        -1,
        7
      ],
      [
        -2,
        5
      ],
      [
        -2,
        2
      ],
      [
        -1,
        4
      ],
      [
        -2,
        2
      ],
      [
        -1,
        3
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -2,
        2
      ],
      [
        -1,
        6
      ],
      [
        -1,
        4
      ],
      [
        -2,
        2
      ],
      [
        -4,
        3
      ],
      [
        -1,
        10
      ],
      [
        -1,
        5
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -17
      ],
      [
        -2,
        -1
      ],
      [
        -3,
        -5
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        0
      ],
      [
        -2,
        3
      ],
      [
        0,
        14
      ],
      [
        -2,
        9
      ],
      [
        0,
        7
      ],
      [
        -2,
        3
      ],
      [
        -3,
        1
      ],
      [
        -3,
        0
      ],
      [
        -3,
        6
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        -1
      ],
      [
        -2,
        0
      ],
      [
        0,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        3
      ],
      [
        -1,
        0
      ],
      [
        0,
        4
      ],
      [
        -1,
        0
      ],
      [
        0,
        -2
      ],
      [
        -1,
        0
      ],
      [
        0,
        3
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        5
      ],
      [
        -1,
        0
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        0,
        3
      ],
      [
        -1,
        0
      ],
      [
        0,
        9
      ],
      [
        -1,
        1
      ],
      [
        0,
        11
      ],
      [
        -1,
        1
      ],
      [
        0,
        3
      ],
      [
        -3,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -2,
        0
      ],
      [
        -1,
        2
      ],
      [
        -4,
        0
      ],
      [
        -1,
        2
      ],
      [
        0,
        3
      ],
      [
        -1,
        2
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        8
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        4
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        16255,
        72143
      ],
      [
        0,
        0
      ]
    ],
    [
      [
        16255,
        72143
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -2,
        2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -6
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -2
      ]
    ],
    [
      [
        16244,
        72131
      ],
      [
        0,
        0
      ]
    ],
    [
      [
        16244,
        72131
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ]
    ],
    [
      [
        16239,
        72140
      ],
      [
        0,
        0
      ]
    ],
    [
      [
        16239,
        72140
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        4
      ],
      [
        -1,
        0
      ],
      [
        0,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        -2
      ],
      [
        -2,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        15
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        3
      ],
      [
        -1,
        2
      ],
      [
        1,
        1
      ],
      [
        -1,
        1
      ],
      [
        1,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -2,
        0
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        1
      ],
      [
        0,
        7
      ],
      [
        1,
        1
      ],
      [
        0,
        4
      ],
      [
        -1,
        0
      ],
      [
        0,
        3
      ],
      [
        -1,
        0
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        5
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -2,
        0
      ],
      [
        0,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        3
      ],
      [
        -1,
        1
      ],
      [
        0,
        4
      ],
      [
        -1,
        1
      ],
      [
        0,
        9
      ],
      [
        1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        3
      ],
      [
        -1,
        1
      ],
      [
        0,
        3
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        -2,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        5
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        5
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        7
      ],
      [
        -1,
        1
      ],
      [
        0,
        4
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        4
      ],
      [
        -1,
        1
      ],
      [
        0,
        4
      ],
      [
        1,
        1
      ],
      [
        0,
        4
      ],
      [
        -1,
        1
      ],
      [
        0,
        5
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        3
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        16170,
        72340
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        16170,
        72341
      ],
      [
        -1,
        0
      ],
      [
        0,
        5
      ]
    ],
    [
      [
        16167,
        72559
      ],
      [
        1,
        8
      ],
      [
        5,
        13
      ],
      [
        4,
        16
      ],
      [
        2,
        13
      ],
      [
        -2,
        13
      ],
      [
        -3,
        -2
      ],
      [
        -8,
        3
      ],
      [
        -5,
        9
      ],
      [
        -3,
        13
      ],
      [
        0,
        19
      ],
      [
        -2,
        6
      ],
      [
        0,
        7
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        4
      ],
      [
        -2,
        6
      ],
      [
        0,
        17
      ],
      [
        1,
        7
      ],
      [
        0,
        8
      ],
      [
        -1,
        1
      ],
      [
        0,
        6
      ],
      [
        2,
        4
      ],
      [
        -1,
        8
      ],
      [
        2,
        7
      ],
      [
        1,
        9
      ],
      [
        -1,
        13
      ],
      [
        3,
        5
      ],
      [
        1,
        6
      ],
      [
        1,
        10
      ],
      [
        0,
        5
      ],
      [
        2,
        5
      ],
      [
        1,
        0
      ],
      [
        2,
        7
      ],
      [
        3,
        11
      ],
      [
        0,
        9
      ],
      [
        -2,
        7
      ],
      [
        -1,
        10
      ],
      [
        -3,
        6
      ],
      [
        -3,
        12
      ],
      [
        1,
        6
      ],
      [
        5,
        4
      ],
      [
        3,
        13
      ],
      [
        5,
        6
      ],
      [
        4,
        2
      ],
      [
        6,
        7
      ],
      [
        5,
        1
      ],
      [
        5,
        9
      ],
      [
        5,
        -1
      ],
      [
        4,
        13
      ],
      [
        3,
        6
      ],
      [
        4,
        14
      ],
      [
        4,
        3
      ],
      [
        2,
        10
      ],
      [
        -2,
        15
      ],
      [
        -1,
        19
      ],
      [
        5,
        11
      ],
      [
        5,
        7
      ],
      [
        4,
        0
      ],
      [
        0,
        14
      ],
      [
        -3,
        17
      ],
      [
        -4,
        12
      ],
      [
        -4,
        10
      ],
      [
        -2,
        4
      ],
      [
        -2,
        10
      ],
      [
        1,
        11
      ],
      [
        -4,
        14
      ],
      [
        -4,
        18
      ],
      [
        -4,
        15
      ],
      [
        -1,
        7
      ],
      [
        -1,
        3
      ],
      [
        0,
        6
      ],
      [
        1,
        3
      ],
      [
        2,
        11
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        27199,
        51422
      ],
      [
        55,
        4
      ],
      [
        0,
        33
      ],
      [
        5,
        -13
      ],
      [
        3,
        10
      ],
      [
        4,
        -1
      ],
      [
        4,
        15
      ],
      [
        6,
        -5
      ],
      [
        5,
        13
      ],
      [
        4,
        1
      ]
    ],
    [
      [
        27285,
        51479
      ],
      [
        1,
        -5
      ],
      [
        13,
        -130
      ],
      [
        11,
        -94
      ],
      [
        6,
        -55
      ]
    ],
    [
      [
        27316,
        51195
      ],
      [
        -13,
        -12
      ],
      [
        -2,
        -7
      ],
      [
        1,
        -75
      ],
      [
        1,
        -93
      ],
      [
        -13,
        -2
      ],
      [
        -20,
        -2
      ],
      [
        -42,
        -2
      ],
      [
        -1,
        161
      ],
      [
        -3,
        -1
      ]
    ],
    [
      [
        27224,
        51162
      ],
      [
        -5,
        -10
      ],
      [
        -7,
        8
      ],
      [
        -3,
        32
      ],
      [
        0,
        25
      ],
      [
        -8,
        47
      ],
      [
        -2,
        16
      ],
      [
        0,
        142
      ]
    ],
    [
      [
        16453,
        71956
      ],
      [
        5,
        -42
      ],
      [
        16,
        1
      ],
      [
        3,
        -8
      ]
    ],
    [
      [
        16477,
        71907
      ],
      [
        1,
        -9
      ],
      [
        0,
        -34
      ],
      [
        -2,
        -25
      ],
      [
        2,
        -18
      ],
      [
        0,
        -23
      ],
      [
        -3,
        -17
      ],
      [
        -3,
        -6
      ],
      [
        -5,
        -41
      ],
      [
        3,
        -20
      ],
      [
        6,
        -17
      ],
      [
        3,
        -53
      ],
      [
        9,
        -58
      ],
      [
        1,
        -29
      ],
      [
        0,
        -70
      ],
      [
        10,
        -49
      ],
      [
        0,
        -22
      ],
      [
        -4,
        -27
      ],
      [
        -8,
        -23
      ],
      [
        -1,
        -21
      ]
    ],
    [
      [
        16486,
        71345
      ],
      [
        -132,
        1
      ],
      [
        -17,
        0
      ],
      [
        0,
        101
      ],
      [
        -32,
        1
      ],
      [
        -3,
        0
      ],
      [
        0,
        101
      ],
      [
        -109,
        -1
      ],
      [
        -12,
        42
      ],
      [
        0,
        13
      ],
      [
        -6,
        12
      ],
      [
        0,
        26
      ],
      [
        -9,
        9
      ],
      [
        -4,
        21
      ],
      [
        -8,
        21
      ],
      [
        -12,
        21
      ],
      [
        -4,
        16
      ],
      [
        -9,
        18
      ],
      [
        -7,
        7
      ],
      [
        -9,
        -13
      ],
      [
        -9,
        2
      ],
      [
        -4,
        -10
      ],
      [
        -6,
        20
      ]
    ],
    [
      [
        27229,
        50448
      ],
      [
        -2,
        -56
      ],
      [
        -6,
        -26
      ],
      [
        -5,
        -1
      ],
      [
        0,
        -83
      ],
      [
        1,
        -3
      ],
      [
        14,
        0
      ],
      [
        22,
        -1
      ],
      [
        0,
        -34
      ],
      [
        13,
        1
      ],
      [
        8,
        1
      ],
      [
        2,
        0
      ],
      [
        33,
        1
      ],
      [
        39,
        0
      ]
    ],
    [
      [
        27348,
        50247
      ],
      [
        8,
        -12
      ],
      [
        2,
        3
      ],
      [
        1,
        -23
      ],
      [
        5,
        -26
      ],
      [
        -1,
        -26
      ],
      [
        10,
        -36
      ],
      [
        5,
        -7
      ],
      [
        -1,
        -14
      ],
      [
        3,
        -23
      ],
      [
        -6,
        -6
      ],
      [
        -1,
        -16
      ],
      [
        -1,
        -23
      ],
      [
        5,
        -29
      ],
      [
        -1,
        -26
      ],
      [
        7,
        -45
      ]
    ],
    [
      [
        27383,
        49938
      ],
      [
        -65,
        1
      ],
      [
        -101,
        0
      ],
      [
        -8,
        -1
      ],
      [
        -48,
        0
      ]
    ],
    [
      [
        27161,
        49938
      ],
      [
        0,
        252
      ],
      [
        3,
        24
      ],
      [
        -3,
        10
      ],
      [
        0,
        203
      ],
      [
        3,
        22
      ],
      [
        65,
        -1
      ]
    ],
    [
      [
        26616,
        54526
      ],
      [
        10,
        56
      ],
      [
        15,
        76
      ],
      [
        6,
        -15
      ],
      [
        2,
        15
      ]
    ],
    [
      [
        26691,
        54507
      ],
      [
        -8,
        -26
      ],
      [
        23,
        -83
      ],
      [
        -9,
        -33
      ],
      [
        5,
        -20
      ],
      [
        -1,
        -9
      ],
      [
        -8,
        -23
      ]
    ],
    [
      [
        26693,
        54313
      ],
      [
        -6,
        0
      ],
      [
        3,
        8
      ],
      [
        -3,
        13
      ],
      [
        -10,
        1
      ],
      [
        0,
        9
      ],
      [
        -6,
        1
      ],
      [
        0,
        -9
      ],
      [
        -5,
        0
      ],
      [
        0,
        -9
      ],
      [
        -48,
        1
      ]
    ],
    [
      [
        24532,
        53400
      ],
      [
        19,
        19
      ],
      [
        2,
        9
      ],
      [
        9,
        -10
      ],
      [
        1,
        14
      ],
      [
        59,
        1
      ],
      [
        39,
        0
      ]
    ],
    [
      [
        24661,
        53433
      ],
      [
        23,
        0
      ]
    ],
    [
      [
        24679,
        53026
      ],
      [
        -6,
        0
      ],
      [
        -17,
        -1
      ],
      [
        -24,
        0
      ],
      [
        -6,
        1
      ],
      [
        -3,
        -1
      ],
      [
        -16,
        0
      ]
    ],
    [
      [
        24607,
        53025
      ],
      [
        -19,
        1
      ],
      [
        -41,
        -1
      ],
      [
        -5,
        0
      ]
    ],
    [
      [
        24542,
        53025
      ],
      [
        0,
        329
      ],
      [
        -6,
        8
      ],
      [
        -4,
        38
      ]
    ],
    [
      [
        22132,
        70014
      ],
      [
        274,
        -3
      ]
    ],
    [
      [
        22406,
        70011
      ],
      [
        1,
        -7
      ],
      [
        0,
        -397
      ]
    ],
    [
      [
        22407,
        69607
      ],
      [
        -237,
        2
      ]
    ],
    [
      [
        22170,
        69609
      ],
      [
        -38,
        0
      ]
    ],
    [
      [
        22132,
        69609
      ],
      [
        0,
        405
      ]
    ],
    [
      [
        25324,
        65206
      ],
      [
        0,
        -51
      ],
      [
        1,
        -51
      ],
      [
        0,
        -101
      ],
      [
        1,
        -102
      ]
    ],
    [
      [
        25326,
        64901
      ],
      [
        1,
        -101
      ],
      [
        -3,
        0
      ]
    ],
    [
      [
        25324,
        64800
      ],
      [
        -29,
        -3
      ],
      [
        -64,
        -4
      ]
    ],
    [
      [
        22326,
        60971
      ],
      [
        151,
        -1
      ]
    ],
    [
      [
        22477,
        60970
      ],
      [
        2,
        -1
      ],
      [
        0,
        -106
      ]
    ],
    [
      [
        22479,
        60863
      ],
      [
        0,
        -304
      ]
    ],
    [
      [
        22326,
        60558
      ],
      [
        0,
        306
      ]
    ],
    [
      [
        23863,
        67292
      ],
      [
        131,
        0
      ]
    ],
    [
      [
        23994,
        67292
      ],
      [
        0,
        -49
      ]
    ],
    [
      [
        23994,
        67243
      ],
      [
        0,
        -356
      ]
    ],
    [
      [
        22913,
        65194
      ],
      [
        19,
        -8
      ],
      [
        5,
        -7
      ],
      [
        13,
        12
      ],
      [
        7,
        -1
      ],
      [
        10,
        -22
      ],
      [
        6,
        -6
      ],
      [
        16,
        10
      ],
      [
        18,
        -1
      ],
      [
        14,
        -30
      ],
      [
        4,
        -13
      ],
      [
        9,
        -4
      ]
    ],
    [
      [
        23034,
        65124
      ],
      [
        3,
        -15
      ],
      [
        11,
        -18
      ],
      [
        4,
        -35
      ],
      [
        0,
        -23
      ],
      [
        8,
        -19
      ],
      [
        8,
        -39
      ],
      [
        0,
        -10
      ],
      [
        -4,
        -26
      ],
      [
        4,
        -35
      ],
      [
        6,
        -16
      ]
    ],
    [
      [
        23074,
        64888
      ],
      [
        3,
        -54
      ],
      [
        -1,
        -16
      ],
      [
        1,
        -6
      ],
      [
        2,
        -11
      ],
      [
        -6,
        -18
      ],
      [
        -2,
        -20
      ],
      [
        5,
        -44
      ]
    ],
    [
      [
        23076,
        64719
      ],
      [
        -8,
        0
      ],
      [
        0,
        -35
      ],
      [
        -32,
        1
      ]
    ],
    [
      [
        23036,
        64685
      ],
      [
        0,
        34
      ],
      [
        -38,
        1
      ],
      [
        -86,
        0
      ]
    ],
    [
      [
        22912,
        64720
      ],
      [
        0,
        405
      ],
      [
        1,
        4
      ],
      [
        0,
        65
      ]
    ],
    [
      [
        24074,
        57512
      ],
      [
        24,
        -2
      ],
      [
        0,
        -102
      ],
      [
        28,
        -3
      ],
      [
        1,
        -4
      ],
      [
        -1,
        -80
      ],
      [
        15,
        -2
      ],
      [
        -1,
        -17
      ],
      [
        15,
        -1
      ],
      [
        1,
        0
      ],
      [
        0,
        -53
      ],
      [
        26,
        -1
      ],
      [
        1,
        -4
      ],
      [
        0,
        -47
      ],
      [
        6,
        0
      ],
      [
        23,
        -2
      ],
      [
        -1,
        -101
      ]
    ],
    [
      [
        24211,
        57093
      ],
      [
        -41,
        2
      ],
      [
        -3,
        0
      ],
      [
        0,
        -51
      ],
      [
        -18,
        2
      ],
      [
        -2,
        0
      ],
      [
        -31,
        3
      ],
      [
        -10,
        -35
      ],
      [
        0,
        -15
      ],
      [
        -13,
        1
      ]
    ],
    [
      [
        24093,
        57000
      ],
      [
        -4,
        1
      ],
      [
        0,
        68
      ],
      [
        -15,
        1
      ],
      [
        0,
        34
      ],
      [
        -10,
        1
      ],
      [
        -5,
        -1
      ]
    ],
    [
      [
        24059,
        57104
      ],
      [
        0,
        68
      ],
      [
        -5,
        1
      ],
      [
        1,
        17
      ],
      [
        0,
        16
      ],
      [
        -20,
        0
      ],
      [
        1,
        52
      ],
      [
        -29,
        2
      ],
      [
        0,
        55
      ],
      [
        3,
        20
      ],
      [
        0,
        82
      ],
      [
        -30,
        0
      ]
    ],
    [
      [
        23980,
        57417
      ],
      [
        1,
        100
      ],
      [
        29,
        1
      ],
      [
        39,
        -4
      ],
      [
        3,
        -9
      ],
      [
        4,
        3
      ],
      [
        6,
        -12
      ],
      [
        7,
        3
      ],
      [
        4,
        -17
      ],
      [
        1,
        30
      ]
    ],
    [
      [
        24949,
        68445
      ],
      [
        -35,
        2
      ]
    ],
    [
      [
        24914,
        68447
      ],
      [
        0,
        147
      ],
      [
        -1,
        88
      ],
      [
        0,
        72
      ],
      [
        -33,
        0
      ],
      [
        0,
        202
      ]
    ],
    [
      [
        23419,
        60796
      ],
      [
        56,
        0
      ],
      [
        75,
        -2
      ]
    ],
    [
      [
        23550,
        60794
      ],
      [
        1,
        -23
      ]
    ],
    [
      [
        23551,
        60434
      ],
      [
        0,
        -30
      ]
    ],
    [
      [
        23551,
        60404
      ],
      [
        -57,
        2
      ],
      [
        -71,
        0
      ]
    ],
    [
      [
        23423,
        60406
      ],
      [
        0,
        51
      ],
      [
        -4,
        0
      ]
    ],
    [
      [
        22590,
        54841
      ],
      [
        125,
        -4
      ]
    ],
    [
      [
        22715,
        54837
      ],
      [
        0,
        -276
      ]
    ],
    [
      [
        22715,
        54561
      ],
      [
        -46,
        -2
      ],
      [
        -46,
        -97
      ]
    ],
    [
      [
        22623,
        54462
      ],
      [
        -1,
        12
      ],
      [
        -14,
        138
      ],
      [
        -6,
        46
      ],
      [
        -13,
        128
      ]
    ],
    [
      [
        22589,
        54786
      ],
      [
        1,
        55
      ]
    ],
    [
      [
        23067,
        61782
      ],
      [
        0,
        253
      ]
    ],
    [
      [
        23067,
        62035
      ],
      [
        113,
        0
      ]
    ],
    [
      [
        23180,
        62035
      ],
      [
        -1,
        -51
      ],
      [
        0,
        -304
      ]
    ],
    [
      [
        23179,
        61680
      ],
      [
        0,
        -203
      ],
      [
        -2,
        0
      ],
      [
        0,
        -104
      ]
    ],
    [
      [
        20921,
        67551
      ],
      [
        253,
        -1
      ],
      [
        41,
        0
      ]
    ],
    [
      [
        21215,
        67550
      ],
      [
        0,
        -555
      ]
    ],
    [
      [
        21215,
        66995
      ],
      [
        -37,
        1
      ],
      [
        -104,
        0
      ]
    ],
    [
      [
        21074,
        66996
      ],
      [
        -117,
        0
      ],
      [
        -11,
        1
      ],
      [
        -7,
        0
      ],
      [
        -17,
        -1
      ]
    ],
    [
      [
        20922,
        66996
      ],
      [
        0,
        345
      ],
      [
        -1,
        8
      ],
      [
        0,
        202
      ]
    ],
    [
      [
        19735,
        72330
      ],
      [
        8,
        -4
      ],
      [
        7,
        10
      ],
      [
        6,
        -7
      ],
      [
        10,
        9
      ],
      [
        6,
        -12
      ],
      [
        9,
        4
      ],
      [
        3,
        11
      ],
      [
        16,
        -1
      ],
      [
        4,
        8
      ],
      [
        12,
        -19
      ],
      [
        13,
        4
      ],
      [
        4,
        -19
      ],
      [
        9,
        -2
      ],
      [
        0,
        -27
      ],
      [
        3,
        -11
      ],
      [
        0,
        -17
      ],
      [
        5,
        -12
      ],
      [
        -3,
        -26
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        19852,
        71478
      ],
      [
        -1,
        -2
      ],
      [
        5,
        -5
      ],
      [
        1,
        -12
      ],
      [
        9,
        -39
      ],
      [
        -1,
        -24
      ],
      [
        5,
        -29
      ]
    ],
    [
      [
        19870,
        71367
      ],
      [
        -121,
        -2
      ],
      [
        -33,
        -5
      ],
      [
        -70,
        -1
      ]
    ],
    [
      [
        19646,
        71359
      ],
      [
        0,
        102
      ],
      [
        6,
        0
      ],
      [
        0,
        304
      ],
      [
        -35,
        0
      ],
      [
        0,
        100
      ],
      [
        5,
        0
      ],
      [
        0,
        101
      ],
      [
        35,
        0
      ],
      [
        0,
        42
      ],
      [
        36,
        0
      ],
      [
        35,
        2
      ],
      [
        6,
        8
      ],
      [
        0,
        251
      ],
      [
        1,
        61
      ]
    ],
    [
      [
        25758,
        63752
      ],
      [
        0,
        254
      ]
    ],
    [
      [
        25758,
        64006
      ],
      [
        32,
        -1
      ],
      [
        57,
        0
      ]
    ],
    [
      [
        25847,
        64005
      ],
      [
        18,
        0
      ],
      [
        0,
        -50
      ],
      [
        8,
        0
      ],
      [
        0,
        -17
      ],
      [
        11,
        0
      ]
    ],
    [
      [
        25884,
        63938
      ],
      [
        0,
        -184
      ]
    ],
    [
      [
        25884,
        63754
      ],
      [
        0,
        -41
      ]
    ],
    [
      [
        25758,
        63711
      ],
      [
        0,
        41
      ]
    ],
    [
      [
        22619,
        71931
      ],
      [
        71,
        -1
      ]
    ],
    [
      [
        22599,
        71221
      ],
      [
        -113,
        1
      ]
    ],
    [
      [
        22486,
        71222
      ],
      [
        0,
        405
      ],
      [
        -8,
        0
      ],
      [
        0,
        304
      ]
    ],
    [
      [
        29691,
        69069
      ],
      [
        45,
        -69
      ],
      [
        -17,
        -94
      ],
      [
        -1,
        -9
      ],
      [
        31,
        -49
      ],
      [
        -1,
        -9
      ]
    ],
    [
      [
        29748,
        68839
      ],
      [
        -16,
        -84
      ],
      [
        -1,
        -7
      ]
    ],
    [
      [
        29731,
        68748
      ],
      [
        -16,
        -94
      ],
      [
        0,
        -3
      ],
      [
        -29,
        66
      ],
      [
        -16,
        -95
      ],
      [
        -31,
        52
      ],
      [
        -11,
        11
      ]
    ],
    [
      [
        29628,
        68685
      ],
      [
        -10,
        8
      ],
      [
        10,
        55
      ],
      [
        -8,
        12
      ],
      [
        6,
        37
      ],
      [
        -5,
        5
      ],
      [
        -23,
        91
      ],
      [
        -4,
        3
      ]
    ],
    [
      [
        29594,
        68896
      ],
      [
        0,
        16
      ],
      [
        1,
        3
      ],
      [
        5,
        -4
      ],
      [
        4,
        13
      ],
      [
        11,
        63
      ],
      [
        15,
        -22
      ],
      [
        4,
        56
      ],
      [
        3,
        0
      ],
      [
        1,
        30
      ],
      [
        3,
        0
      ],
      [
        3,
        23
      ],
      [
        20,
        9
      ],
      [
        17,
        9
      ],
      [
        6,
        -13
      ],
      [
        4,
        -10
      ]
    ],
    [
      [
        26480,
        55701
      ],
      [
        2,
        5
      ],
      [
        3,
        -5
      ],
      [
        1,
        5
      ],
      [
        6,
        9
      ],
      [
        5,
        36
      ],
      [
        2,
        2
      ],
      [
        1,
        22
      ],
      [
        19,
        16
      ],
      [
        -3,
        38
      ],
      [
        8,
        20
      ],
      [
        3,
        20
      ],
      [
        3,
        2
      ]
    ],
    [
      [
        26530,
        55871
      ],
      [
        3,
        -31
      ],
      [
        5,
        -24
      ],
      [
        8,
        -23
      ],
      [
        1,
        -10
      ]
    ],
    [
      [
        26547,
        55783
      ],
      [
        0,
        -30
      ],
      [
        6,
        -16
      ],
      [
        1,
        -26
      ],
      [
        3,
        -17
      ],
      [
        -2,
        -22
      ],
      [
        5,
        -36
      ],
      [
        -3,
        -37
      ],
      [
        5,
        -21
      ],
      [
        -4,
        -14
      ]
    ],
    [
      [
        26558,
        55564
      ],
      [
        -6,
        19
      ],
      [
        -4,
        5
      ],
      [
        -51,
        2
      ]
    ],
    [
      [
        26497,
        55590
      ],
      [
        -23,
        0
      ]
    ],
    [
      [
        26474,
        55590
      ],
      [
        0,
        58
      ],
      [
        6,
        23
      ],
      [
        4,
        16
      ],
      [
        -4,
        14
      ]
    ],
    [
      [
        24914,
        68447
      ],
      [
        -50,
        2
      ]
    ],
    [
      [
        24864,
        68449
      ],
      [
        -49,
        0
      ],
      [
        -65,
        -1
      ]
    ],
    [
      [
        24750,
        68448
      ],
      [
        -2,
        7
      ],
      [
        1,
        198
      ]
    ],
    [
      [
        23730,
        66581
      ],
      [
        1,
        306
      ]
    ],
    [
      [
        22194,
        52957
      ],
      [
        110,
        0
      ]
    ],
    [
      [
        22304,
        52957
      ],
      [
        0,
        -22
      ],
      [
        35,
        0
      ]
    ],
    [
      [
        22339,
        52935
      ],
      [
        1,
        -493
      ]
    ],
    [
      [
        22245,
        52444
      ],
      [
        -50,
        0
      ],
      [
        0,
        245
      ]
    ],
    [
      [
        23448,
        54816
      ],
      [
        3,
        -2
      ],
      [
        8,
        13
      ],
      [
        35,
        51
      ],
      [
        17,
        80
      ],
      [
        4,
        9
      ],
      [
        5,
        -14
      ],
      [
        7,
        3
      ],
      [
        0,
        -7
      ]
    ],
    [
      [
        23527,
        54949
      ],
      [
        0,
        -268
      ],
      [
        2,
        7
      ],
      [
        6,
        -7
      ],
      [
        9,
        -27
      ],
      [
        12,
        1
      ],
      [
        3,
        -9
      ],
      [
        2,
        4
      ]
    ],
    [
      [
        23561,
        54650
      ],
      [
        -3,
        -34
      ],
      [
        -3,
        -7
      ],
      [
        -10,
        12
      ],
      [
        -72,
        -1
      ],
      [
        -25,
        2
      ]
    ],
    [
      [
        23448,
        54622
      ],
      [
        0,
        194
      ]
    ],
    [
      [
        25091,
        55975
      ],
      [
        0,
        33
      ],
      [
        15,
        1
      ],
      [
        4,
        0
      ]
    ],
    [
      [
        25110,
        56009
      ],
      [
        20,
        2
      ],
      [
        50,
        1
      ],
      [
        9,
        0
      ],
      [
        8,
        -7
      ],
      [
        4,
        7
      ],
      [
        6,
        0
      ],
      [
        0,
        -69
      ]
    ],
    [
      [
        25207,
        55943
      ],
      [
        0,
        -118
      ],
      [
        1,
        -137
      ]
    ],
    [
      [
        25208,
        55688
      ],
      [
        -40,
        0
      ]
    ],
    [
      [
        25168,
        55688
      ],
      [
        -25,
        0
      ],
      [
        0,
        -1
      ],
      [
        -52,
        0
      ]
    ],
    [
      [
        25091,
        55687
      ],
      [
        0,
        288
      ]
    ],
    [
      [
        16478,
        62857
      ],
      [
        0,
        -134
      ],
      [
        -1,
        -16
      ]
    ],
    [
      [
        16477,
        62707
      ],
      [
        -88,
        0
      ],
      [
        -65,
        -1
      ],
      [
        -25,
        -1
      ],
      [
        -13,
        -12
      ],
      [
        -10,
        -19
      ],
      [
        -8,
        -28
      ],
      [
        -13,
        -36
      ],
      [
        -4,
        -4
      ],
      [
        -11,
        -27
      ],
      [
        -3,
        -30
      ],
      [
        -11,
        -12
      ],
      [
        -1,
        -7
      ],
      [
        -10,
        -25
      ],
      [
        -9,
        -38
      ],
      [
        -3,
        2
      ],
      [
        0,
        -41
      ],
      [
        -5,
        -18
      ],
      [
        0,
        -11
      ],
      [
        -6,
        -16
      ],
      [
        -3,
        -28
      ],
      [
        -8,
        -10
      ],
      [
        -6,
        10
      ],
      [
        -4,
        -3
      ],
      [
        -9,
        31
      ],
      [
        -14,
        -29
      ],
      [
        -8,
        -1
      ],
      [
        -5,
        14
      ],
      [
        -13,
        12
      ]
    ],
    [
      [
        16122,
        62379
      ],
      [
        0,
        228
      ],
      [
        6,
        30
      ],
      [
        -2,
        19
      ],
      [
        7,
        13
      ],
      [
        6,
        -2
      ],
      [
        5,
        24
      ],
      [
        -1,
        16
      ],
      [
        7,
        26
      ],
      [
        7,
        -5
      ],
      [
        0,
        16
      ],
      [
        8,
        37
      ],
      [
        7,
        1
      ],
      [
        5,
        16
      ],
      [
        10,
        0
      ],
      [
        2,
        -7
      ],
      [
        5,
        3
      ]
    ],
    [
      [
        21215,
        66995
      ],
      [
        58,
        0
      ]
    ],
    [
      [
        21273,
        66995
      ],
      [
        0,
        -250
      ],
      [
        5,
        0
      ],
      [
        0,
        -402
      ]
    ],
    [
      [
        21278,
        66343
      ],
      [
        -187,
        -3
      ]
    ],
    [
      [
        21091,
        66340
      ],
      [
        -10,
        0
      ],
      [
        0,
        405
      ],
      [
        -6,
        -1
      ],
      [
        -1,
        252
      ]
    ],
    [
      [
        15443,
        66743
      ],
      [
        0,
        -51
      ],
      [
        6,
        0
      ],
      [
        0,
        16
      ],
      [
        5,
        -4
      ],
      [
        0,
        -12
      ],
      [
        27,
        0
      ],
      [
        4,
        -5
      ],
      [
        1,
        -21
      ],
      [
        6,
        -9
      ],
      [
        13,
        -1
      ],
      [
        8,
        -11
      ],
      [
        11,
        17
      ],
      [
        7,
        -4
      ],
      [
        0,
        17
      ],
      [
        8,
        0
      ],
      [
        0,
        17
      ],
      [
        28,
        -9
      ],
      [
        7,
        -9
      ],
      [
        0,
        -26
      ],
      [
        5,
        1
      ]
    ],
    [
      [
        15579,
        66649
      ],
      [
        0,
        -814
      ]
    ],
    [
      [
        15579,
        65835
      ],
      [
        -33,
        -5
      ],
      [
        -9,
        0
      ],
      [
        -15,
        3
      ],
      [
        -18,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -4,
        1
      ]
    ],
    [
      [
        15499,
        65832
      ],
      [
        -2,
        0
      ],
      [
        -8,
        -1
      ],
      [
        -20,
        0
      ],
      [
        -9,
        -6
      ],
      [
        -18,
        2
      ],
      [
        -2,
        0
      ],
      [
        -17,
        -1
      ],
      [
        -7,
        -1
      ],
      [
        -2,
        0
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        15414,
        65826
      ],
      [
        1,
        2
      ],
      [
        -1,
        3
      ],
      [
        -1,
        2
      ],
      [
        -1,
        5
      ],
      [
        1,
        2
      ],
      [
        -1,
        3
      ],
      [
        -1,
        2
      ],
      [
        -2,
        5
      ],
      [
        0,
        3
      ],
      [
        1,
        4
      ],
      [
        -2,
        10
      ],
      [
        -1,
        10
      ],
      [
        1,
        10
      ],
      [
        1,
        5
      ],
      [
        0,
        7
      ],
      [
        1,
        4
      ],
      [
        0,
        3
      ],
      [
        1,
        4
      ],
      [
        1,
        3
      ],
      [
        0,
        4
      ],
      [
        1,
        13
      ],
      [
        0,
        7
      ],
      [
        -1,
        8
      ],
      [
        -1,
        11
      ],
      [
        -1,
        5
      ],
      [
        -1,
        10
      ],
      [
        -1,
        6
      ],
      [
        -2,
        2
      ],
      [
        -1,
        5
      ],
      [
        -1,
        9
      ],
      [
        3,
        8
      ],
      [
        1,
        4
      ],
      [
        1,
        5
      ],
      [
        2,
        1
      ],
      [
        2,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        2
      ],
      [
        1,
        5
      ],
      [
        1,
        5
      ],
      [
        0,
        11
      ],
      [
        -1,
        12
      ],
      [
        -1,
        3
      ],
      [
        0,
        7
      ],
      [
        3,
        17
      ],
      [
        2,
        7
      ],
      [
        2,
        3
      ],
      [
        1,
        6
      ],
      [
        0,
        14
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -2,
        1
      ],
      [
        -1,
        3
      ],
      [
        -1,
        4
      ],
      [
        0,
        7
      ],
      [
        -1,
        4
      ],
      [
        0,
        6
      ],
      [
        -1,
        5
      ],
      [
        -1,
        1
      ],
      [
        0,
        4
      ],
      [
        -1,
        3
      ],
      [
        0,
        9
      ],
      [
        -1,
        3
      ],
      [
        -1,
        4
      ],
      [
        -1,
        3
      ],
      [
        0,
        3
      ],
      [
        -1,
        7
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        4
      ],
      [
        1,
        4
      ],
      [
        0,
        9
      ],
      [
        -1,
        5
      ],
      [
        -3,
        1
      ],
      [
        -2,
        4
      ],
      [
        -2,
        4
      ],
      [
        0,
        2
      ],
      [
        -1,
        3
      ],
      [
        0,
        4
      ],
      [
        -1,
        4
      ],
      [
        0,
        6
      ],
      [
        -1,
        4
      ],
      [
        0,
        1
      ],
      [
        -1,
        4
      ],
      [
        -1,
        4
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        4
      ],
      [
        -2,
        3
      ],
      [
        -1,
        2
      ],
      [
        0,
        3
      ],
      [
        -1,
        3
      ],
      [
        0,
        3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        1
      ],
      [
        -10,
        0
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        0,
        4
      ],
      [
        -1,
        2
      ],
      [
        0,
        4
      ],
      [
        -1,
        3
      ],
      [
        1,
        5
      ],
      [
        -1,
        2
      ],
      [
        0,
        6
      ],
      [
        -1,
        2
      ],
      [
        0,
        4
      ],
      [
        1,
        3
      ],
      [
        0,
        13
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        0,
        4
      ],
      [
        1,
        0
      ],
      [
        0,
        2
      ],
      [
        2,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        0
      ],
      [
        0,
        4
      ],
      [
        1,
        3
      ],
      [
        0,
        3
      ],
      [
        -1,
        1
      ],
      [
        0,
        21
      ],
      [
        2,
        3
      ],
      [
        1,
        2
      ],
      [
        0,
        3
      ],
      [
        -1,
        2
      ],
      [
        0,
        4
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        3
      ],
      [
        0,
        6
      ],
      [
        1,
        1
      ],
      [
        0,
        24
      ],
      [
        -1,
        4
      ],
      [
        -1,
        2
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        3
      ],
      [
        0,
        2
      ],
      [
        2,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        2
      ],
      [
        1,
        0
      ],
      [
        0,
        -4
      ],
      [
        1,
        -1
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        1,
        2
      ],
      [
        2,
        1
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        3,
        0
      ],
      [
        0,
        -2
      ],
      [
        1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        1,
        0
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        3
      ],
      [
        1,
        -1
      ],
      [
        2,
        2
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        0,
        4
      ],
      [
        1,
        2
      ],
      [
        1,
        1
      ],
      [
        0,
        4
      ],
      [
        1,
        0
      ],
      [
        0,
        6
      ],
      [
        -1,
        2
      ],
      [
        0,
        5
      ],
      [
        1,
        2
      ],
      [
        0,
        5
      ],
      [
        1,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        3
      ],
      [
        1,
        2
      ],
      [
        0,
        5
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        3
      ],
      [
        -1,
        3
      ],
      [
        0,
        4
      ],
      [
        -1,
        3
      ],
      [
        0,
        4
      ],
      [
        1,
        4
      ],
      [
        1,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        3
      ],
      [
        0,
        13
      ],
      [
        1,
        2
      ],
      [
        0,
        1
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        0,
        3
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        12
      ],
      [
        1,
        2
      ],
      [
        1,
        0
      ],
      [
        0,
        4
      ],
      [
        1,
        2
      ],
      [
        0,
        2
      ],
      [
        -1,
        4
      ],
      [
        0,
        4
      ],
      [
        -1,
        3
      ],
      [
        -1,
        1
      ],
      [
        3,
        27
      ],
      [
        4,
        21
      ],
      [
        8,
        40
      ],
      [
        0,
        3
      ],
      [
        1,
        2
      ],
      [
        1,
        1
      ],
      [
        0,
        4
      ],
      [
        1,
        2
      ],
      [
        0,
        5
      ],
      [
        1,
        2
      ],
      [
        0,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        4
      ],
      [
        1,
        2
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        4
      ],
      [
        1,
        1
      ],
      [
        0,
        5
      ],
      [
        1,
        3
      ],
      [
        0,
        4
      ],
      [
        1,
        1
      ],
      [
        0,
        3
      ],
      [
        1,
        2
      ],
      [
        0,
        2
      ],
      [
        2,
        6
      ],
      [
        -1,
        4
      ],
      [
        1,
        3
      ],
      [
        0,
        7
      ],
      [
        1,
        3
      ],
      [
        0,
        2
      ],
      [
        1,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        5
      ],
      [
        1,
        3
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        22911,
        64315
      ],
      [
        0,
        -203
      ]
    ],
    [
      [
        22911,
        64112
      ],
      [
        0,
        -198
      ],
      [
        -1,
        -4
      ]
    ],
    [
      [
        22910,
        63910
      ],
      [
        -126,
        1
      ]
    ],
    [
      [
        22051,
        58911
      ],
      [
        0,
        -203
      ]
    ],
    [
      [
        22051,
        58708
      ],
      [
        0,
        -305
      ]
    ],
    [
      [
        22051,
        58403
      ],
      [
        -151,
        0
      ]
    ],
    [
      [
        21900,
        58403
      ],
      [
        0,
        509
      ]
    ],
    [
      [
        26440,
        55574
      ],
      [
        6,
        -11
      ],
      [
        28,
        -1
      ],
      [
        0,
        28
      ]
    ],
    [
      [
        26497,
        55590
      ],
      [
        0,
        -202
      ],
      [
        -1,
        -94
      ],
      [
        -2,
        -20
      ],
      [
        -20,
        1
      ]
    ],
    [
      [
        26474,
        55275
      ],
      [
        1,
        67
      ],
      [
        -42,
        2
      ]
    ],
    [
      [
        26433,
        55344
      ],
      [
        1,
        47
      ],
      [
        5,
        9
      ],
      [
        1,
        42
      ],
      [
        0,
        132
      ]
    ],
    [
      [
        24844,
        53913
      ],
      [
        34,
        8
      ],
      [
        27,
        7
      ]
    ],
    [
      [
        24905,
        53928
      ],
      [
        0,
        -192
      ],
      [
        7,
        -3
      ],
      [
        4,
        -21
      ],
      [
        12,
        -29
      ],
      [
        9,
        -6
      ],
      [
        12,
        -29
      ],
      [
        0,
        -22
      ],
      [
        3,
        -2
      ],
      [
        0,
        -93
      ]
    ],
    [
      [
        24952,
        53531
      ],
      [
        -19,
        0
      ]
    ],
    [
      [
        24933,
        53531
      ],
      [
        -47,
        0
      ],
      [
        0,
        -51
      ],
      [
        -38,
        1
      ]
    ],
    [
      [
        24848,
        53481
      ],
      [
        0,
        153
      ],
      [
        -4,
        0
      ],
      [
        0,
        279
      ]
    ],
    [
      [
        27011,
        63781
      ],
      [
        4,
        -1
      ],
      [
        -1,
        -83
      ]
    ],
    [
      [
        27014,
        63697
      ],
      [
        -2,
        -170
      ],
      [
        -2,
        -82
      ],
      [
        -9,
        1
      ],
      [
        0,
        -44
      ]
    ],
    [
      [
        27001,
        63402
      ],
      [
        -52,
        10
      ],
      [
        0,
        7
      ],
      [
        -12,
        3
      ]
    ],
    [
      [
        26937,
        63422
      ],
      [
        -3,
        -7
      ],
      [
        -83,
        17
      ],
      [
        -3,
        0
      ]
    ],
    [
      [
        26848,
        63432
      ],
      [
        2,
        43
      ],
      [
        2,
        87
      ],
      [
        2,
        87
      ]
    ],
    [
      [
        21447,
        57388
      ],
      [
        47,
        1
      ]
    ],
    [
      [
        21469,
        56883
      ],
      [
        -122,
        0
      ]
    ],
    [
      [
        21347,
        56883
      ],
      [
        0,
        505
      ]
    ],
    [
      [
        26122,
        69565
      ],
      [
        46,
        -3
      ],
      [
        0,
        -102
      ],
      [
        102,
        -1
      ]
    ],
    [
      [
        26273,
        69158
      ],
      [
        -124,
        2
      ],
      [
        -10,
        -11
      ],
      [
        3,
        -31
      ],
      [
        -5,
        -13
      ]
    ],
    [
      [
        26137,
        69105
      ],
      [
        -4,
        18
      ],
      [
        -7,
        1
      ],
      [
        -2,
        35
      ],
      [
        -17,
        1
      ]
    ],
    [
      [
        26107,
        69160
      ],
      [
        4,
        25
      ],
      [
        1,
        16
      ],
      [
        5,
        19
      ],
      [
        3,
        23
      ],
      [
        5,
        78
      ],
      [
        -1,
        23
      ],
      [
        0,
        33
      ],
      [
        1,
        11
      ],
      [
        3,
        15
      ],
      [
        0,
        56
      ],
      [
        -2,
        11
      ],
      [
        -1,
        19
      ],
      [
        -1,
        44
      ],
      [
        -2,
        11
      ],
      [
        0,
        21
      ]
    ],
    [
      [
        22155,
        63505
      ],
      [
        125,
        0
      ]
    ],
    [
      [
        22280,
        63505
      ],
      [
        31,
        0
      ]
    ],
    [
      [
        22311,
        63505
      ],
      [
        0,
        -505
      ]
    ],
    [
      [
        22311,
        63000
      ],
      [
        -94,
        -1
      ],
      [
        -55,
        0
      ]
    ],
    [
      [
        22162,
        62999
      ],
      [
        -7,
        0
      ]
    ],
    [
      [
        21625,
        60868
      ],
      [
        122,
        0
      ]
    ],
    [
      [
        21747,
        60868
      ],
      [
        0,
        -406
      ]
    ],
    [
      [
        21747,
        60462
      ],
      [
        -121,
        1
      ]
    ],
    [
      [
        21626,
        60463
      ],
      [
        -1,
        405
      ]
    ],
    [
      [
        18848,
        71375
      ],
      [
        0,
        -1
      ],
      [
        2,
        -5
      ],
      [
        2,
        -2
      ],
      [
        1,
        0
      ],
      [
        1,
        -3
      ],
      [
        2,
        -1
      ],
      [
        2,
        -6
      ],
      [
        1,
        -2
      ],
      [
        0,
        -21
      ],
      [
        -1,
        0
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -1
      ],
      [
        2,
        -4
      ],
      [
        1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -2
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        2,
        -1
      ],
      [
        1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        1,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -4
      ],
      [
        1,
        0
      ],
      [
        2,
        -2
      ],
      [
        3,
        1
      ],
      [
        1,
        -2
      ],
      [
        1,
        -5
      ],
      [
        2,
        -5
      ],
      [
        0,
        -9
      ],
      [
        1,
        -9
      ],
      [
        -1,
        -10
      ],
      [
        1,
        -4
      ],
      [
        0,
        -4
      ],
      [
        1,
        -1
      ],
      [
        2,
        6
      ],
      [
        2,
        0
      ],
      [
        3,
        1
      ],
      [
        1,
        -1
      ],
      [
        2,
        -3
      ],
      [
        1,
        -7
      ],
      [
        2,
        -1
      ],
      [
        3,
        1
      ],
      [
        1,
        -1
      ],
      [
        2,
        1
      ],
      [
        1,
        -1
      ],
      [
        1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        1,
        -4
      ],
      [
        0,
        -11
      ],
      [
        1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -9
      ],
      [
        1,
        -10
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -7
      ],
      [
        2,
        -7
      ],
      [
        2,
        -7
      ],
      [
        0,
        -7
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -6
      ],
      [
        -2,
        -4
      ],
      [
        0,
        -7
      ],
      [
        1,
        -3
      ],
      [
        2,
        -4
      ],
      [
        4,
        -5
      ],
      [
        1,
        -1
      ],
      [
        3,
        -3
      ],
      [
        4,
        -3
      ],
      [
        3,
        -10
      ],
      [
        0,
        -10
      ],
      [
        1,
        -6
      ],
      [
        1,
        -3
      ],
      [
        1,
        -4
      ],
      [
        1,
        1
      ],
      [
        2,
        -1
      ],
      [
        0,
        -5
      ],
      [
        1,
        -7
      ],
      [
        -1,
        -8
      ],
      [
        1,
        -9
      ],
      [
        1,
        -11
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -10
      ],
      [
        1,
        -9
      ],
      [
        2,
        -4
      ],
      [
        2,
        -2
      ],
      [
        3,
        -6
      ],
      [
        3,
        -1
      ],
      [
        4,
        0
      ],
      [
        4,
        5
      ],
      [
        2,
        10
      ],
      [
        3,
        8
      ],
      [
        6,
        2
      ],
      [
        4,
        0
      ],
      [
        1,
        3
      ],
      [
        2,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -5
      ],
      [
        2,
        -1
      ],
      [
        1,
        -3
      ],
      [
        3,
        -1
      ],
      [
        1,
        -3
      ],
      [
        1,
        -5
      ],
      [
        0,
        -5
      ],
      [
        2,
        -2
      ],
      [
        2,
        -4
      ],
      [
        1,
        -6
      ],
      [
        3,
        -4
      ],
      [
        1,
        -1
      ],
      [
        1,
        -6
      ],
      [
        0,
        -9
      ],
      [
        -2,
        -3
      ],
      [
        0,
        -14
      ],
      [
        -2,
        -8
      ],
      [
        0,
        -6
      ],
      [
        1,
        -6
      ],
      [
        -1,
        -9
      ],
      [
        1,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        -3,
        -1
      ],
      [
        -3,
        -5
      ],
      [
        -1,
        -9
      ],
      [
        -3,
        -12
      ],
      [
        -3,
        -14
      ],
      [
        0,
        -22
      ],
      [
        -1,
        -12
      ],
      [
        -1,
        -8
      ],
      [
        1,
        -6
      ],
      [
        1,
        -5
      ],
      [
        2,
        -2
      ],
      [
        1,
        -1
      ],
      [
        0,
        -5
      ],
      [
        1,
        -2
      ],
      [
        2,
        -2
      ],
      [
        1,
        0
      ],
      [
        4,
        -7
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -6
      ],
      [
        2,
        0
      ],
      [
        2,
        -9
      ],
      [
        1,
        -4
      ],
      [
        0,
        -35
      ]
    ],
    [
      [
        18969,
        70711
      ],
      [
        -24,
        0
      ],
      [
        -13,
        -5
      ],
      [
        -31,
        0
      ],
      [
        -11,
        -41
      ],
      [
        -1,
        -29
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        -5
      ],
      [
        1,
        -11
      ],
      [
        -1,
        -7
      ],
      [
        -3,
        -7
      ],
      [
        -3,
        -13
      ],
      [
        -2,
        -12
      ],
      [
        0,
        -32
      ],
      [
        1,
        -6
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -7
      ],
      [
        2,
        -2
      ],
      [
        1,
        -16
      ],
      [
        -1,
        -8
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        1
      ],
      [
        -1,
        6
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -29
      ],
      [
        -1,
        -12
      ],
      [
        -2,
        -7
      ],
      [
        -3,
        -6
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -1
      ],
      [
        0,
        -7
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        -2
      ],
      [
        -2,
        0
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        0
      ],
      [
        0,
        -7
      ],
      [
        -2,
        -1
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        -9
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        -2,
        0
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        -1
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -8
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -3
      ],
      [
        1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -2,
        1
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -9
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -1
      ]
    ],
    [
      [
        18802,
        70293
      ],
      [
        0,
        251
      ],
      [
        -34,
        1
      ],
      [
        -1,
        101
      ],
      [
        0,
        504
      ]
    ],
    [
      [
        22272,
        64721
      ],
      [
        128,
        0
      ]
    ],
    [
      [
        22407,
        64721
      ],
      [
        0,
        -405
      ]
    ],
    [
      [
        22406,
        64306
      ],
      [
        -28,
        -18
      ],
      [
        -12,
        -18
      ],
      [
        -10,
        -8
      ],
      [
        -20,
        5
      ],
      [
        -6,
        -5
      ],
      [
        -23,
        5
      ],
      [
        -9,
        -2
      ],
      [
        -11,
        5
      ],
      [
        -5,
        -1
      ],
      [
        -2,
        3
      ]
    ],
    [
      [
        22213,
        64284
      ],
      [
        1,
        33
      ],
      [
        -3,
        0
      ],
      [
        0,
        404
      ]
    ],
    [
      [
        17122,
        61726
      ],
      [
        126,
        -470
      ],
      [
        -1,
        -23
      ],
      [
        7,
        -3
      ],
      [
        15,
        -54
      ],
      [
        0,
        -736
      ],
      [
        -1,
        -463
      ]
    ],
    [
      [
        17268,
        59977
      ],
      [
        -22,
        69
      ],
      [
        -5,
        17
      ],
      [
        -31,
        95
      ],
      [
        -35,
        109
      ],
      [
        -22,
        68
      ],
      [
        -28,
        87
      ],
      [
        -9,
        25
      ],
      [
        -33,
        105
      ]
    ],
    [
      [
        17083,
        60552
      ],
      [
        -12,
        37
      ],
      [
        -8,
        22
      ],
      [
        -20,
        62
      ],
      [
        -18,
        54
      ],
      [
        -4,
        11
      ],
      [
        -55,
        167
      ],
      [
        -49,
        149
      ]
    ],
    [
      [
        16917,
        61054
      ],
      [
        21,
        -3
      ],
      [
        28,
        104
      ],
      [
        5,
        19
      ],
      [
        151,
        552
      ]
    ],
    [
      [
        27830,
        59130
      ],
      [
        29,
        -2
      ]
    ],
    [
      [
        27859,
        59128
      ],
      [
        56,
        -3
      ]
    ],
    [
      [
        27915,
        59125
      ],
      [
        -4,
        -113
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -21
      ],
      [
        -3,
        -73
      ],
      [
        -7,
        -145
      ],
      [
        -1,
        -34
      ],
      [
        -2,
        -46
      ]
    ],
    [
      [
        27897,
        58687
      ],
      [
        -18,
        -3
      ],
      [
        -19,
        7
      ],
      [
        -20,
        10
      ],
      [
        -8,
        2
      ]
    ],
    [
      [
        27832,
        58703
      ],
      [
        -2,
        31
      ],
      [
        -3,
        7
      ],
      [
        1,
        5
      ],
      [
        1,
        183
      ],
      [
        1,
        201
      ]
    ],
    [
      [
        18514,
        68126
      ],
      [
        0,
        101
      ],
      [
        150,
        -1
      ]
    ],
    [
      [
        18664,
        68226
      ],
      [
        0,
        -101
      ],
      [
        50,
        0
      ],
      [
        0,
        -51
      ]
    ],
    [
      [
        18714,
        68074
      ],
      [
        0,
        -151
      ],
      [
        -2,
        -51
      ],
      [
        5,
        -6
      ],
      [
        5,
        3
      ],
      [
        5,
        19
      ],
      [
        3,
        -13
      ],
      [
        3,
        5
      ],
      [
        2,
        -15
      ],
      [
        8,
        -12
      ],
      [
        4,
        -22
      ],
      [
        8,
        -2
      ],
      [
        3,
        -14
      ],
      [
        4,
        -3
      ],
      [
        7,
        -30
      ],
      [
        5,
        -10
      ],
      [
        5,
        1
      ],
      [
        7,
        -15
      ],
      [
        26,
        0
      ],
      [
        0,
        -34
      ]
    ],
    [
      [
        18812,
        67724
      ],
      [
        -249,
        0
      ]
    ],
    [
      [
        18563,
        67724
      ],
      [
        -33,
        0
      ],
      [
        -17,
        -4
      ]
    ],
    [
      [
        18513,
        67720
      ],
      [
        1,
        204
      ],
      [
        0,
        202
      ]
    ],
    [
      [
        26046,
        65550
      ],
      [
        15,
        0
      ],
      [
        25,
        1
      ],
      [
        63,
        0
      ]
    ],
    [
      [
        26175,
        65551
      ],
      [
        1,
        -272
      ]
    ],
    [
      [
        26048,
        65276
      ],
      [
        -2,
        274
      ]
    ],
    [
      [
        24522,
        66175
      ],
      [
        65,
        -1
      ]
    ],
    [
      [
        24587,
        66174
      ],
      [
        0,
        -304
      ]
    ],
    [
      [
        24587,
        65870
      ],
      [
        0,
        -102
      ]
    ],
    [
      [
        24456,
        65770
      ],
      [
        1,
        203
      ],
      [
        0,
        203
      ]
    ],
    [
      [
        23419,
        66076
      ],
      [
        64,
        -1
      ]
    ],
    [
      [
        23483,
        66075
      ],
      [
        64,
        0
      ]
    ],
    [
      [
        23547,
        66075
      ],
      [
        0,
        -404
      ]
    ],
    [
      [
        23547,
        65671
      ],
      [
        -32,
        0
      ]
    ],
    [
      [
        23515,
        65671
      ],
      [
        -97,
        1
      ]
    ],
    [
      [
        23418,
        65672
      ],
      [
        1,
        404
      ]
    ],
    [
      [
        22196,
        72032
      ],
      [
        59,
        0
      ]
    ],
    [
      [
        22255,
        72032
      ],
      [
        214,
        -1
      ]
    ],
    [
      [
        22486,
        71222
      ],
      [
        -167,
        -1
      ]
    ],
    [
      [
        22204,
        71222
      ],
      [
        1,
        407
      ],
      [
        -9,
        0
      ],
      [
        0,
        403
      ]
    ],
    [
      [
        23547,
        66075
      ],
      [
        65,
        -1
      ]
    ],
    [
      [
        23677,
        65672
      ],
      [
        -33,
        -1
      ]
    ],
    [
      [
        23644,
        65671
      ],
      [
        -97,
        0
      ]
    ],
    [
      [
        25392,
        52659
      ],
      [
        2,
        16
      ],
      [
        -7,
        64
      ],
      [
        3,
        32
      ],
      [
        7,
        15
      ],
      [
        1,
        21
      ],
      [
        12,
        18
      ],
      [
        -3,
        26
      ],
      [
        -7,
        14
      ],
      [
        -1,
        29
      ],
      [
        8,
        37
      ],
      [
        1,
        8
      ],
      [
        7,
        12
      ],
      [
        -5,
        31
      ],
      [
        -6,
        7
      ],
      [
        2,
        25
      ],
      [
        -2,
        22
      ],
      [
        4,
        16
      ],
      [
        -2,
        8
      ],
      [
        5,
        22
      ],
      [
        -1,
        21
      ],
      [
        -6,
        3
      ],
      [
        -3,
        24
      ],
      [
        8,
        38
      ],
      [
        2,
        29
      ],
      [
        -7,
        2
      ],
      [
        -2,
        16
      ]
    ],
    [
      [
        25402,
        53215
      ],
      [
        9,
        1
      ],
      [
        -2,
        35
      ]
    ],
    [
      [
        25409,
        53251
      ],
      [
        9,
        -7
      ],
      [
        7,
        20
      ],
      [
        3,
        -7
      ],
      [
        3,
        20
      ],
      [
        4,
        -14
      ],
      [
        -2,
        37
      ],
      [
        7,
        -5
      ],
      [
        -2,
        14
      ],
      [
        4,
        38
      ],
      [
        8,
        -7
      ],
      [
        4,
        15
      ],
      [
        -7,
        28
      ],
      [
        2,
        14
      ],
      [
        2,
        -19
      ],
      [
        9,
        -6
      ]
    ],
    [
      [
        25460,
        53372
      ],
      [
        13,
        7
      ],
      [
        7,
        -24
      ],
      [
        4,
        -24
      ],
      [
        13,
        -22
      ],
      [
        4,
        2
      ]
    ],
    [
      [
        25501,
        53311
      ],
      [
        0,
        -288
      ],
      [
        5,
        0
      ]
    ],
    [
      [
        25506,
        53023
      ],
      [
        0,
        -2
      ],
      [
        1,
        -9
      ],
      [
        1,
        -6
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        1,
        -3
      ],
      [
        0,
        -5
      ],
      [
        1,
        -5
      ],
      [
        -1,
        -15
      ],
      [
        -1,
        -13
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        -2,
        -12
      ],
      [
        0,
        -9
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -12
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -5
      ],
      [
        1,
        -4
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -14
      ],
      [
        2,
        -7
      ],
      [
        0,
        -3
      ],
      [
        1,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -7
      ],
      [
        1,
        -1
      ],
      [
        2,
        -6
      ],
      [
        0,
        -6
      ],
      [
        2,
        -3
      ],
      [
        1,
        -1
      ],
      [
        1,
        -3
      ],
      [
        0,
        -5
      ],
      [
        1,
        -5
      ],
      [
        1,
        -4
      ],
      [
        2,
        -2
      ],
      [
        2,
        -3
      ],
      [
        1,
        -5
      ],
      [
        1,
        -9
      ],
      [
        2,
        -2
      ],
      [
        1,
        -3
      ],
      [
        1,
        -5
      ],
      [
        0,
        -2
      ],
      [
        1,
        -4
      ],
      [
        1,
        0
      ],
      [
        0,
        -1
      ],
      [
        2,
        -9
      ],
      [
        0,
        -7
      ],
      [
        1,
        -6
      ],
      [
        1,
        -5
      ],
      [
        0,
        -2
      ],
      [
        1,
        -7
      ],
      [
        0,
        -14
      ],
      [
        3,
        -6
      ],
      [
        3,
        -5
      ],
      [
        2,
        -9
      ],
      [
        1,
        -5
      ],
      [
        1,
        -2
      ],
      [
        0,
        1
      ],
      [
        3,
        -3
      ],
      [
        2,
        -2
      ],
      [
        0,
        -4
      ],
      [
        2,
        -8
      ],
      [
        1,
        -1
      ],
      [
        1,
        -4
      ],
      [
        0,
        -1
      ],
      [
        3,
        -4
      ],
      [
        1,
        3
      ],
      [
        1,
        -1
      ],
      [
        1,
        -5
      ],
      [
        1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        1,
        -2
      ],
      [
        2,
        0
      ],
      [
        1,
        -7
      ],
      [
        2,
        -3
      ],
      [
        2,
        -3
      ],
      [
        1,
        -3
      ],
      [
        1,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -6
      ],
      [
        1,
        -11
      ],
      [
        1,
        -3
      ],
      [
        0,
        -8
      ],
      [
        1,
        -4
      ],
      [
        0,
        -24
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -19
      ],
      [
        -1,
        -12
      ],
      [
        -1,
        1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -4,
        -25
      ],
      [
        0,
        -8
      ],
      [
        1,
        -7
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -4
      ],
      [
        1,
        -3
      ],
      [
        0,
        -1
      ],
      [
        1,
        0
      ],
      [
        1,
        -2
      ],
      [
        2,
        -11
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -5
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -8
      ],
      [
        1,
        -6
      ],
      [
        3,
        -10
      ],
      [
        2,
        -1
      ],
      [
        1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        1,
        0
      ],
      [
        2,
        1
      ],
      [
        3,
        -2
      ],
      [
        3,
        -4
      ],
      [
        0,
        -2
      ],
      [
        1,
        -5
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        -3,
        -9
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -6
      ],
      [
        1,
        -5
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -26
      ],
      [
        -2,
        -10
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -4,
        -8
      ],
      [
        -3,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        1,
        -7
      ],
      [
        2,
        -3
      ],
      [
        6,
        3
      ],
      [
        -1,
        -11
      ],
      [
        -12,
        -12
      ],
      [
        -3,
        -10
      ],
      [
        0,
        -4
      ]
    ],
    [
      [
        25528,
        52188
      ],
      [
        -7,
        -5
      ],
      [
        -4,
        -2
      ],
      [
        -6,
        -6
      ],
      [
        -21,
        -22
      ],
      [
        -22,
        -11
      ],
      [
        -18,
        -13
      ],
      [
        -11,
        -3
      ],
      [
        -24,
        4
      ],
      [
        -10,
        -1
      ],
      [
        -11,
        -4
      ],
      [
        -4,
        -4
      ],
      [
        -4,
        -2
      ],
      [
        0,
        2
      ],
      [
        2,
        9
      ],
      [
        15,
        6
      ],
      [
        5,
        25
      ],
      [
        4,
        5
      ],
      [
        5,
        -9
      ],
      [
        1,
        -7
      ],
      [
        4,
        -7
      ],
      [
        2,
        -3
      ],
      [
        4,
        0
      ],
      [
        5,
        2
      ],
      [
        12,
        16
      ],
      [
        4,
        -1
      ],
      [
        4,
        1
      ],
      [
        6,
        9
      ],
      [
        3,
        18
      ],
      [
        0,
        16
      ],
      [
        -4,
        24
      ],
      [
        -7,
        14
      ],
      [
        -4,
        10
      ],
      [
        -5,
        25
      ],
      [
        -1,
        4
      ],
      [
        -1,
        14
      ],
      [
        -3,
        9
      ],
      [
        -2,
        2
      ],
      [
        -3,
        5
      ],
      [
        -12,
        31
      ],
      [
        0,
        5
      ],
      [
        -2,
        37
      ],
      [
        -1,
        29
      ],
      [
        -2,
        6
      ],
      [
        -2,
        6
      ],
      [
        0,
        7
      ],
      [
        6,
        45
      ],
      [
        2,
        14
      ],
      [
        0,
        13
      ],
      [
        1,
        2
      ],
      [
        -1,
        18
      ],
      [
        -1,
        8
      ],
      [
        -1,
        4
      ],
      [
        -1,
        11
      ],
      [
        1,
        35
      ],
      [
        -2,
        23
      ],
      [
        -4,
        20
      ],
      [
        -1,
        5
      ],
      [
        -6,
        2
      ],
      [
        -7,
        19
      ],
      [
        -2,
        4
      ],
      [
        -5,
        7
      ]
    ],
    [
      [
        26308,
        66321
      ],
      [
        33,
        1
      ]
    ],
    [
      [
        26341,
        66322
      ],
      [
        66,
        3
      ],
      [
        62,
        0
      ]
    ],
    [
      [
        26469,
        66325
      ],
      [
        3,
        0
      ]
    ],
    [
      [
        26472,
        65914
      ],
      [
        -13,
        3
      ],
      [
        -19,
        -1
      ],
      [
        -33,
        0
      ]
    ],
    [
      [
        26407,
        65916
      ],
      [
        -32,
        0
      ],
      [
        -64,
        -3
      ]
    ],
    [
      [
        26311,
        65913
      ],
      [
        -1,
        103
      ],
      [
        -1,
        102
      ],
      [
        -1,
        102
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        26656,
        59542
      ],
      [
        27,
        0
      ],
      [
        27,
        1
      ],
      [
        5,
        -5
      ],
      [
        76,
        0
      ]
    ],
    [
      [
        26834,
        59538
      ],
      [
        -14,
        -24
      ],
      [
        -19,
        -36
      ],
      [
        -3,
        15
      ],
      [
        -6,
        -13
      ],
      [
        -2,
        20
      ],
      [
        -6,
        3
      ],
      [
        -8,
        -14
      ],
      [
        -22,
        -44
      ],
      [
        -4,
        -20
      ],
      [
        -9,
        -30
      ],
      [
        1,
        -11
      ],
      [
        -12,
        -24
      ],
      [
        3,
        -20
      ],
      [
        -8,
        -16
      ],
      [
        -16,
        -18
      ]
    ],
    [
      [
        26709,
        59306
      ],
      [
        -7,
        -8
      ],
      [
        -1,
        14
      ],
      [
        -9,
        10
      ],
      [
        -3,
        13
      ],
      [
        -10,
        -13
      ],
      [
        0,
        5
      ]
    ],
    [
      [
        26679,
        59327
      ],
      [
        5,
        24
      ],
      [
        0,
        30
      ],
      [
        -8,
        88
      ],
      [
        -9,
        44
      ],
      [
        -11,
        29
      ]
    ],
    [
      [
        22162,
        62999
      ],
      [
        0,
        -201
      ],
      [
        -1,
        -305
      ]
    ],
    [
      [
        22161,
        62493
      ],
      [
        -151,
        -1
      ]
    ],
    [
      [
        22010,
        62492
      ],
      [
        -5,
        0
      ]
    ],
    [
      [
        22005,
        62492
      ],
      [
        1,
        507
      ]
    ],
    [
      [
        23422,
        61218
      ],
      [
        0,
        -253
      ],
      [
        -2,
        0
      ],
      [
        0,
        -68
      ],
      [
        -1,
        -34
      ]
    ],
    [
      [
        23257,
        57210
      ],
      [
        44,
        0
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        23301,
        57311
      ],
      [
        126,
        0
      ]
    ],
    [
      [
        23427,
        57311
      ],
      [
        34,
        0
      ],
      [
        0,
        -203
      ]
    ],
    [
      [
        23461,
        57108
      ],
      [
        -30,
        1
      ],
      [
        0,
        -307
      ],
      [
        -29,
        0
      ],
      [
        -2,
        -101
      ]
    ],
    [
      [
        23400,
        56701
      ],
      [
        -159,
        0
      ],
      [
        0,
        -1
      ],
      [
        -14,
        1
      ]
    ],
    [
      [
        23227,
        56701
      ],
      [
        0,
        407
      ],
      [
        30,
        0
      ],
      [
        0,
        102
      ]
    ],
    [
      [
        21405,
        53784
      ],
      [
        9,
        0
      ]
    ],
    [
      [
        21414,
        53784
      ],
      [
        142,
        0
      ]
    ],
    [
      [
        21556,
        53784
      ],
      [
        0,
        -665
      ]
    ],
    [
      [
        21556,
        53119
      ],
      [
        -146,
        7
      ]
    ],
    [
      [
        21410,
        53126
      ],
      [
        0,
        48
      ],
      [
        -2,
        83
      ],
      [
        -3,
        527
      ]
    ],
    [
      [
        21978,
        69610
      ],
      [
        154,
        -1
      ]
    ],
    [
      [
        22170,
        69609
      ],
      [
        0,
        -406
      ]
    ],
    [
      [
        22142,
        69204
      ],
      [
        -204,
        0
      ]
    ],
    [
      [
        21938,
        69204
      ],
      [
        -3,
        30
      ],
      [
        -2,
        77
      ],
      [
        4,
        26
      ],
      [
        5,
        18
      ],
      [
        8,
        2
      ],
      [
        13,
        -16
      ],
      [
        7,
        -1
      ],
      [
        3,
        6
      ],
      [
        0,
        16
      ],
      [
        -10,
        30
      ],
      [
        -2,
        17
      ],
      [
        -1,
        30
      ],
      [
        10,
        45
      ],
      [
        3,
        24
      ],
      [
        1,
        46
      ],
      [
        4,
        30
      ],
      [
        0,
        26
      ]
    ],
    [
      [
        22280,
        63911
      ],
      [
        0,
        -406
      ]
    ],
    [
      [
        22155,
        63505
      ],
      [
        -1,
        406
      ]
    ],
    [
      [
        23468,
        67577
      ],
      [
        11,
        0
      ],
      [
        0,
        1
      ],
      [
        4,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        23485,
        67578
      ],
      [
        66,
        -1
      ],
      [
        41,
        0
      ],
      [
        6,
        1
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        23599,
        67578
      ],
      [
        0,
        -286
      ]
    ],
    [
      [
        23599,
        67292
      ],
      [
        -131,
        0
      ]
    ],
    [
      [
        23468,
        67292
      ],
      [
        0,
        285
      ]
    ],
    [
      [
        22330,
        73979
      ],
      [
        36,
        0
      ],
      [
        256,
        1
      ]
    ],
    [
      [
        22622,
        73980
      ],
      [
        0,
        -329
      ],
      [
        6,
        0
      ],
      [
        0,
        -204
      ]
    ],
    [
      [
        22628,
        73447
      ],
      [
        -108,
        1
      ]
    ],
    [
      [
        22520,
        73448
      ],
      [
        -182,
        1
      ]
    ],
    [
      [
        16473,
        61679
      ],
      [
        38,
        -90
      ],
      [
        4,
        13
      ],
      [
        9,
        18
      ],
      [
        6,
        6
      ],
      [
        4,
        16
      ],
      [
        9,
        6
      ],
      [
        5,
        12
      ],
      [
        11,
        2
      ],
      [
        2,
        -4
      ],
      [
        2,
        -6
      ],
      [
        1,
        -36
      ],
      [
        -2,
        -16
      ],
      [
        9,
        -20
      ],
      [
        8,
        -25
      ]
    ],
    [
      [
        16579,
        61555
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -38
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -7
      ],
      [
        2,
        -6
      ],
      [
        3,
        -8
      ],
      [
        3,
        -7
      ],
      [
        1,
        -3
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -8
      ],
      [
        2,
        -8
      ],
      [
        2,
        -6
      ],
      [
        -3,
        -6
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -14
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -8
      ],
      [
        2,
        -6
      ],
      [
        7,
        -12
      ],
      [
        1,
        4
      ],
      [
        3,
        -5
      ],
      [
        1,
        -8
      ],
      [
        1,
        -14
      ],
      [
        3,
        -8
      ],
      [
        3,
        -1
      ],
      [
        2,
        -7
      ],
      [
        2,
        -4
      ],
      [
        3,
        -1
      ],
      [
        4,
        -8
      ],
      [
        2,
        3
      ],
      [
        1,
        7
      ],
      [
        -1,
        7
      ],
      [
        1,
        5
      ],
      [
        2,
        -2
      ],
      [
        0,
        -6
      ],
      [
        2,
        -13
      ],
      [
        3,
        -9
      ],
      [
        2,
        -8
      ],
      [
        0,
        -8
      ],
      [
        3,
        -12
      ],
      [
        3,
        -8
      ],
      [
        1,
        -3
      ],
      [
        2,
        8
      ],
      [
        1,
        5
      ],
      [
        2,
        5
      ],
      [
        2,
        -6
      ],
      [
        5,
        -1
      ],
      [
        4,
        -8
      ],
      [
        4,
        -7
      ],
      [
        6,
        -10
      ],
      [
        5,
        -23
      ],
      [
        5,
        -20
      ],
      [
        3,
        -20
      ],
      [
        -1,
        -27
      ],
      [
        0,
        -6
      ],
      [
        -2,
        -20
      ],
      [
        -1,
        -19
      ],
      [
        3,
        -19
      ],
      [
        2,
        -9
      ],
      [
        6,
        -13
      ],
      [
        5,
        -16
      ],
      [
        4,
        -11
      ],
      [
        3,
        2
      ],
      [
        4,
        -10
      ],
      [
        3,
        -5
      ],
      [
        1,
        -6
      ],
      [
        1,
        -5
      ],
      [
        0,
        -7
      ],
      [
        -2,
        -24
      ],
      [
        -1,
        -10
      ],
      [
        2,
        -9
      ],
      [
        2,
        1
      ],
      [
        1,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -7
      ],
      [
        -2,
        -11
      ],
      [
        0,
        -13
      ],
      [
        2,
        -7
      ],
      [
        1,
        -17
      ],
      [
        -5,
        -15
      ],
      [
        -3,
        -6
      ],
      [
        -4,
        -10
      ],
      [
        -1,
        -11
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -10
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -2
      ]
    ],
    [
      [
        16682,
        60871
      ],
      [
        -5,
        7
      ],
      [
        -1,
        26
      ],
      [
        -5,
        12
      ]
    ],
    [
      [
        16671,
        60916
      ],
      [
        0,
        15
      ],
      [
        -4,
        9
      ],
      [
        -6,
        12
      ],
      [
        -6,
        26
      ],
      [
        -2,
        7
      ],
      [
        -1,
        3
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -2
      ],
      [
        -5,
        14
      ],
      [
        -5,
        15
      ],
      [
        -1,
        4
      ],
      [
        -5,
        4
      ],
      [
        -7,
        -9
      ],
      [
        -6,
        1
      ],
      [
        -4,
        13
      ],
      [
        -6,
        22
      ],
      [
        -8,
        9
      ],
      [
        -5,
        -6
      ],
      [
        -3,
        -24
      ],
      [
        -2,
        -11
      ],
      [
        -3,
        -9
      ],
      [
        -4,
        -5
      ],
      [
        -2,
        -6
      ],
      [
        -3,
        1
      ],
      [
        -4,
        -12
      ],
      [
        0,
        -22
      ],
      [
        -12,
        -27
      ],
      [
        -10,
        -11
      ],
      [
        -5,
        -14
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -3
      ],
      [
        -4,
        -2
      ],
      [
        -3,
        -3
      ],
      [
        0,
        -3
      ],
      [
        -2,
        0
      ],
      [
        -2,
        3
      ],
      [
        -2,
        7
      ],
      [
        -2,
        4
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        3
      ],
      [
        -1,
        6
      ],
      [
        -1,
        4
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        -4,
        -3
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -4
      ],
      [
        -3,
        3
      ],
      [
        -1,
        2
      ],
      [
        -3,
        2
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -5,
        13
      ],
      [
        -5,
        14
      ],
      [
        -7,
        13
      ],
      [
        -2,
        5
      ],
      [
        -3,
        4
      ],
      [
        -2,
        7
      ],
      [
        -3,
        -2
      ],
      [
        -1,
        1
      ],
      [
        -3,
        2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        4
      ],
      [
        0,
        5
      ],
      [
        -1,
        5
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        2
      ],
      [
        -2,
        2
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -11
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        1
      ],
      [
        -2,
        0
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -2,
        2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        5
      ],
      [
        -1,
        0
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -5
      ],
      [
        1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -15
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        -3,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        2
      ],
      [
        -2,
        2
      ],
      [
        0,
        1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -13
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        -9
      ],
      [
        0,
        -4
      ],
      [
        1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        2
      ],
      [
        -2,
        2
      ],
      [
        -2,
        4
      ],
      [
        -1,
        3
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -3
      ],
      [
        0,
        1
      ],
      [
        -2,
        2
      ],
      [
        -3,
        2
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        0
      ],
      [
        0,
        -5
      ],
      [
        1,
        -4
      ],
      [
        0,
        -6
      ],
      [
        1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        1,
        -5
      ],
      [
        1,
        -6
      ],
      [
        2,
        -11
      ],
      [
        1,
        -8
      ],
      [
        2,
        -11
      ],
      [
        1,
        -9
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -8
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        3
      ],
      [
        0,
        5
      ],
      [
        -2,
        5
      ],
      [
        -1,
        8
      ],
      [
        -2,
        5
      ],
      [
        -1,
        4
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        6
      ],
      [
        -3,
        2
      ],
      [
        -1,
        1
      ],
      [
        -2,
        1
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -8
      ],
      [
        1,
        -5
      ],
      [
        2,
        -7
      ],
      [
        1,
        -2
      ],
      [
        1,
        -7
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        16371,
        60748
      ],
      [
        -74,
        231
      ]
    ],
    [
      [
        16297,
        60979
      ],
      [
        0,
        2
      ],
      [
        2,
        7
      ],
      [
        1,
        7
      ],
      [
        1,
        6
      ],
      [
        1,
        6
      ],
      [
        1,
        6
      ],
      [
        2,
        6
      ],
      [
        3,
        6
      ],
      [
        2,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        2
      ],
      [
        0,
        3
      ],
      [
        2,
        5
      ],
      [
        0,
        5
      ],
      [
        2,
        7
      ],
      [
        2,
        2
      ],
      [
        2,
        -1
      ],
      [
        2,
        3
      ],
      [
        0,
        5
      ],
      [
        1,
        5
      ],
      [
        0,
        8
      ],
      [
        2,
        4
      ],
      [
        1,
        6
      ],
      [
        2,
        0
      ],
      [
        0,
        -2
      ],
      [
        1,
        3
      ],
      [
        1,
        4
      ],
      [
        0,
        18
      ],
      [
        1,
        4
      ],
      [
        2,
        3
      ],
      [
        2,
        5
      ],
      [
        1,
        11
      ],
      [
        -1,
        6
      ],
      [
        -2,
        7
      ],
      [
        0,
        5
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        4
      ],
      [
        1,
        2
      ],
      [
        2,
        1
      ],
      [
        1,
        5
      ],
      [
        -2,
        4
      ],
      [
        0,
        4
      ],
      [
        2,
        1
      ],
      [
        1,
        3
      ],
      [
        1,
        7
      ],
      [
        1,
        3
      ],
      [
        1,
        -1
      ],
      [
        1,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        1,
        -2
      ],
      [
        1,
        0
      ],
      [
        1,
        3
      ],
      [
        0,
        15
      ],
      [
        3,
        5
      ],
      [
        2,
        1
      ],
      [
        3,
        -1
      ],
      [
        2,
        2
      ],
      [
        0,
        9
      ],
      [
        3,
        15
      ],
      [
        0,
        9
      ],
      [
        3,
        11
      ],
      [
        0,
        4
      ],
      [
        1,
        6
      ],
      [
        1,
        0
      ],
      [
        2,
        6
      ],
      [
        0,
        10
      ],
      [
        2,
        3
      ],
      [
        2,
        7
      ],
      [
        1,
        13
      ],
      [
        2,
        14
      ],
      [
        4,
        10
      ],
      [
        2,
        16
      ],
      [
        1,
        8
      ],
      [
        2,
        2
      ],
      [
        0,
        6
      ],
      [
        -1,
        0
      ],
      [
        1,
        6
      ],
      [
        1,
        7
      ],
      [
        3,
        7
      ],
      [
        2,
        11
      ],
      [
        3,
        7
      ],
      [
        1,
        8
      ],
      [
        0,
        7
      ],
      [
        2,
        6
      ],
      [
        1,
        7
      ],
      [
        2,
        13
      ],
      [
        3,
        15
      ],
      [
        4,
        13
      ],
      [
        1,
        11
      ],
      [
        2,
        10
      ],
      [
        3,
        9
      ],
      [
        0,
        10
      ],
      [
        3,
        10
      ],
      [
        1,
        11
      ],
      [
        3,
        7
      ],
      [
        3,
        8
      ],
      [
        1,
        8
      ],
      [
        1,
        9
      ],
      [
        1,
        5
      ],
      [
        2,
        4
      ],
      [
        3,
        7
      ],
      [
        2,
        11
      ],
      [
        1,
        8
      ],
      [
        2,
        11
      ],
      [
        0,
        5
      ],
      [
        2,
        6
      ],
      [
        2,
        12
      ],
      [
        1,
        4
      ],
      [
        3,
        6
      ],
      [
        2,
        8
      ],
      [
        3,
        5
      ],
      [
        2,
        2
      ],
      [
        3,
        4
      ],
      [
        3,
        4
      ],
      [
        2,
        1
      ],
      [
        3,
        2
      ],
      [
        3,
        1
      ],
      [
        1,
        7
      ],
      [
        2,
        2
      ],
      [
        1,
        2
      ],
      [
        2,
        3
      ],
      [
        3,
        4
      ],
      [
        3,
        4
      ],
      [
        2,
        2
      ],
      [
        3,
        7
      ],
      [
        1,
        3
      ]
    ],
    [
      [
        22161,
        62493
      ],
      [
        4,
        0
      ]
    ],
    [
      [
        22008,
        61986
      ],
      [
        2,
        506
      ]
    ],
    [
      [
        22342,
        48683
      ],
      [
        44,
        -1
      ],
      [
        0,
        100
      ]
    ],
    [
      [
        22490,
        48118
      ],
      [
        -148,
        2
      ]
    ],
    [
      [
        22342,
        48120
      ],
      [
        0,
        563
      ]
    ],
    [
      [
        31558,
        38031
      ],
      [
        4,
        25
      ],
      [
        2,
        44
      ],
      [
        2,
        0
      ],
      [
        3,
        -3
      ],
      [
        3,
        30
      ]
    ],
    [
      [
        31572,
        38127
      ],
      [
        9,
        7
      ],
      [
        9,
        -13
      ],
      [
        -1,
        -16
      ],
      [
        7,
        -10
      ]
    ],
    [
      [
        31596,
        38095
      ],
      [
        -1,
        -11
      ],
      [
        -4,
        -8
      ],
      [
        -2,
        -10
      ],
      [
        -3,
        -22
      ],
      [
        -6,
        -53
      ],
      [
        0,
        -5
      ],
      [
        1,
        -1
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -5
      ]
    ],
    [
      [
        31580,
        37974
      ],
      [
        -9,
        18
      ],
      [
        -5,
        17
      ],
      [
        0,
        21
      ],
      [
        -6,
        -11
      ],
      [
        -2,
        12
      ]
    ],
    [
      [
        25216,
        69460
      ],
      [
        43,
        -1
      ],
      [
        -1,
        -304
      ]
    ],
    [
      [
        25258,
        69155
      ],
      [
        -69,
        1
      ],
      [
        0,
        101
      ],
      [
        -68,
        -1
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        25121,
        69357
      ],
      [
        0,
        103
      ],
      [
        95,
        0
      ]
    ],
    [
      [
        23620,
        67982
      ],
      [
        34,
        0
      ]
    ],
    [
      [
        23654,
        67982
      ],
      [
        0,
        -405
      ]
    ],
    [
      [
        23654,
        67577
      ],
      [
        -40,
        0
      ],
      [
        -15,
        1
      ]
    ],
    [
      [
        23485,
        67578
      ],
      [
        0,
        404
      ]
    ],
    [
      [
        25724,
        54587
      ],
      [
        -1,
        -9
      ],
      [
        1,
        -27
      ],
      [
        5,
        -2
      ],
      [
        7,
        38
      ],
      [
        -2,
        32
      ],
      [
        1,
        30
      ],
      [
        7,
        -6
      ],
      [
        7,
        18
      ],
      [
        2,
        -2
      ],
      [
        0,
        -36
      ],
      [
        2,
        -13
      ],
      [
        8,
        -9
      ],
      [
        8,
        27
      ],
      [
        0,
        25
      ],
      [
        10,
        9
      ],
      [
        2,
        -8
      ],
      [
        -1,
        -28
      ],
      [
        6,
        -15
      ],
      [
        3,
        16
      ],
      [
        3,
        0
      ],
      [
        8,
        -14
      ],
      [
        3,
        -29
      ],
      [
        10,
        7
      ]
    ],
    [
      [
        25813,
        54591
      ],
      [
        6,
        -15
      ],
      [
        -4,
        -35
      ],
      [
        1,
        -20
      ],
      [
        22,
        -46
      ],
      [
        0,
        -226
      ]
    ],
    [
      [
        25838,
        54249
      ],
      [
        1,
        -101
      ],
      [
        -12,
        1
      ]
    ],
    [
      [
        25713,
        54146
      ],
      [
        0,
        100
      ],
      [
        -14,
        0
      ]
    ],
    [
      [
        25699,
        54246
      ],
      [
        -1,
        206
      ],
      [
        28,
        0
      ],
      [
        0,
        15
      ],
      [
        -7,
        -1
      ],
      [
        -6,
        23
      ],
      [
        -2,
        17
      ],
      [
        1,
        15
      ],
      [
        3,
        4
      ],
      [
        6,
        21
      ],
      [
        -7,
        5
      ],
      [
        1,
        22
      ],
      [
        9,
        14
      ]
    ],
    [
      [
        26231,
        61565
      ],
      [
        25,
        46
      ],
      [
        4,
        -23
      ],
      [
        6,
        2
      ]
    ],
    [
      [
        26266,
        61590
      ],
      [
        9,
        0
      ],
      [
        13,
        -21
      ],
      [
        14,
        16
      ]
    ],
    [
      [
        26307,
        61402
      ],
      [
        -39,
        -63
      ],
      [
        -1,
        -8
      ],
      [
        1,
        -20
      ]
    ],
    [
      [
        26268,
        61311
      ],
      [
        -7,
        -24
      ],
      [
        -4,
        -4
      ],
      [
        -15,
        19
      ],
      [
        -3,
        11
      ],
      [
        -16,
        12
      ]
    ],
    [
      [
        26223,
        61325
      ],
      [
        1,
        14
      ],
      [
        5,
        23
      ],
      [
        -1,
        17
      ],
      [
        2,
        59
      ],
      [
        0,
        57
      ],
      [
        12,
        66
      ],
      [
        -11,
        4
      ]
    ],
    [
      [
        24200,
        63447
      ],
      [
        93,
        -3
      ]
    ],
    [
      [
        24293,
        63444
      ],
      [
        31,
        -2
      ]
    ],
    [
      [
        24324,
        63442
      ],
      [
        -2,
        -337
      ]
    ],
    [
      [
        24322,
        63105
      ],
      [
        -94,
        5
      ],
      [
        0,
        -64
      ],
      [
        -2,
        -4
      ],
      [
        -30,
        1
      ]
    ],
    [
      [
        24196,
        63043
      ],
      [
        4,
        404
      ]
    ],
    [
      [
        22992,
        59033
      ],
      [
        1,
        4
      ],
      [
        61,
        -1
      ],
      [
        28,
        -1
      ]
    ],
    [
      [
        23082,
        59035
      ],
      [
        0,
        -100
      ],
      [
        34,
        -1
      ],
      [
        41,
        0
      ],
      [
        0,
        -203
      ],
      [
        -1,
        -34
      ],
      [
        0,
        -17
      ]
    ],
    [
      [
        23156,
        58680
      ],
      [
        -44,
        0
      ],
      [
        0,
        -254
      ]
    ],
    [
      [
        23112,
        58426
      ],
      [
        -120,
        0
      ]
    ],
    [
      [
        22992,
        58426
      ],
      [
        0,
        352
      ]
    ],
    [
      [
        22992,
        58778
      ],
      [
        0,
        255
      ]
    ],
    [
      [
        22847,
        51429
      ],
      [
        75,
        5
      ]
    ],
    [
      [
        22922,
        51434
      ],
      [
        8,
        -18
      ],
      [
        3,
        -25
      ],
      [
        -1,
        -15
      ],
      [
        1,
        -7
      ],
      [
        11,
        1
      ],
      [
        65,
        -282
      ],
      [
        -27,
        -83
      ]
    ],
    [
      [
        22982,
        51005
      ],
      [
        -78,
        -233
      ]
    ],
    [
      [
        22904,
        50772
      ],
      [
        -11,
        47
      ]
    ],
    [
      [
        22893,
        50819
      ],
      [
        -73,
        326
      ]
    ],
    [
      [
        22820,
        51145
      ],
      [
        10,
        144
      ],
      [
        0,
        85
      ],
      [
        17,
        55
      ]
    ],
    [
      [
        25147,
        68139
      ],
      [
        0,
        -102
      ]
    ],
    [
      [
        25147,
        68037
      ],
      [
        0,
        -305
      ]
    ],
    [
      [
        25147,
        67732
      ],
      [
        -33,
        0
      ]
    ],
    [
      [
        25114,
        67732
      ],
      [
        -34,
        -2
      ],
      [
        0,
        14
      ],
      [
        -33,
        -1
      ]
    ],
    [
      [
        25047,
        67743
      ],
      [
        0,
        136
      ],
      [
        2,
        8
      ],
      [
        20,
        -1
      ],
      [
        0,
        52
      ],
      [
        -5,
        -7
      ],
      [
        -4,
        9
      ],
      [
        0,
        75
      ],
      [
        9,
        0
      ],
      [
        0,
        124
      ]
    ],
    [
      [
        22056,
        64317
      ],
      [
        -67,
        1
      ]
    ],
    [
      [
        21989,
        64318
      ],
      [
        -1,
        403
      ]
    ],
    [
      [
        26046,
        65550
      ],
      [
        -36,
        0
      ]
    ],
    [
      [
        26010,
        65550
      ],
      [
        1,
        1
      ],
      [
        0,
        21
      ],
      [
        5,
        9
      ],
      [
        2,
        16
      ],
      [
        -1,
        314
      ]
    ],
    [
      [
        25075,
        61422
      ],
      [
        0,
        304
      ]
    ],
    [
      [
        25075,
        61726
      ],
      [
        31,
        0
      ],
      [
        31,
        4
      ],
      [
        62,
        -3
      ]
    ],
    [
      [
        25199,
        61727
      ],
      [
        0,
        -254
      ]
    ],
    [
      [
        25198,
        61320
      ],
      [
        -118,
        0
      ]
    ],
    [
      [
        25080,
        61320
      ],
      [
        -6,
        0
      ],
      [
        1,
        102
      ]
    ],
    [
      [
        23994,
        67576
      ],
      [
        66,
        0
      ],
      [
        10,
        1
      ],
      [
        56,
        0
      ]
    ],
    [
      [
        24125,
        67243
      ],
      [
        -131,
        0
      ]
    ],
    [
      [
        23994,
        67292
      ],
      [
        0,
        284
      ]
    ],
    [
      [
        8956,
        91740
      ],
      [
        89,
        0
      ],
      [
        14,
        2
      ],
      [
        17,
        10
      ],
      [
        14,
        11
      ],
      [
        13,
        5
      ],
      [
        9,
        0
      ],
      [
        18,
        -3
      ],
      [
        11,
        3
      ],
      [
        9,
        19
      ],
      [
        16,
        14
      ],
      [
        6,
        41
      ],
      [
        2,
        24
      ],
      [
        8,
        10
      ],
      [
        14,
        8
      ],
      [
        11,
        7
      ],
      [
        13,
        -10
      ],
      [
        15,
        6
      ],
      [
        10,
        20
      ],
      [
        10,
        21
      ],
      [
        14,
        12
      ],
      [
        14,
        2
      ],
      [
        19,
        20
      ],
      [
        12,
        7
      ],
      [
        13,
        -11
      ],
      [
        13,
        -11
      ],
      [
        7,
        -13
      ],
      [
        18,
        -7
      ],
      [
        26,
        31
      ],
      [
        19,
        18
      ],
      [
        3,
        29
      ],
      [
        12,
        7
      ],
      [
        13,
        0
      ],
      [
        25,
        16
      ],
      [
        18,
        -1
      ],
      [
        20,
        30
      ],
      [
        15,
        34
      ],
      [
        16,
        21
      ],
      [
        24,
        -12
      ],
      [
        18,
        16
      ],
      [
        18,
        8
      ],
      [
        23,
        6
      ],
      [
        4,
        7
      ],
      [
        19,
        2
      ],
      [
        2,
        -11
      ],
      [
        10,
        2
      ],
      [
        14,
        -11
      ],
      [
        39,
        40
      ],
      [
        1,
        32
      ],
      [
        6,
        -3
      ],
      [
        17,
        8
      ],
      [
        12,
        -10
      ],
      [
        12,
        18
      ],
      [
        5,
        -8
      ],
      [
        7,
        8
      ],
      [
        9,
        -2
      ],
      [
        5,
        15
      ],
      [
        -4,
        19
      ]
    ],
    [
      [
        10627,
        93581
      ],
      [
        0,
        -4581
      ]
    ],
    [
      [
        9097,
        90473
      ],
      [
        0,
        1
      ],
      [
        3,
        12
      ],
      [
        -1,
        352
      ],
      [
        -143,
        -4
      ]
    ],
    [
      [
        8956,
        90834
      ],
      [
        0,
        906
      ]
    ],
    [
      [
        24986,
        64840
      ],
      [
        0,
        99
      ],
      [
        20,
        0
      ],
      [
        10,
        -1
      ],
      [
        6,
        57
      ],
      [
        0,
        22
      ],
      [
        15,
        13
      ],
      [
        4,
        12
      ],
      [
        12,
        -11
      ],
      [
        15,
        -5
      ],
      [
        2,
        2
      ]
    ],
    [
      [
        23337,
        64853
      ],
      [
        64,
        -1
      ]
    ],
    [
      [
        23401,
        64852
      ],
      [
        63,
        -1
      ]
    ],
    [
      [
        23464,
        64551
      ],
      [
        -127,
        1
      ]
    ],
    [
      [
        23337,
        64552
      ],
      [
        0,
        301
      ]
    ],
    [
      [
        24125,
        66887
      ],
      [
        132,
        0
      ]
    ],
    [
      [
        24257,
        66887
      ],
      [
        0,
        -309
      ]
    ],
    [
      [
        24125,
        66578
      ],
      [
        0,
        309
      ]
    ],
    [
      [
        25076,
        61760
      ],
      [
        1,
        170
      ],
      [
        0,
        102
      ]
    ],
    [
      [
        25201,
        62136
      ],
      [
        -1,
        -256
      ]
    ],
    [
      [
        25200,
        61880
      ],
      [
        -1,
        -153
      ]
    ],
    [
      [
        25075,
        61726
      ],
      [
        1,
        34
      ]
    ],
    [
      [
        27405,
        58271
      ],
      [
        13,
        0
      ]
    ],
    [
      [
        27418,
        58271
      ],
      [
        13,
        0
      ],
      [
        4,
        1
      ],
      [
        8,
        -1
      ],
      [
        10,
        -1
      ],
      [
        11,
        -2
      ],
      [
        77,
        0
      ]
    ],
    [
      [
        27541,
        58268
      ],
      [
        -42,
        -265
      ],
      [
        -11,
        -69
      ],
      [
        -6,
        -28
      ],
      [
        0,
        -8
      ]
    ],
    [
      [
        27482,
        57898
      ],
      [
        -12,
        27
      ]
    ],
    [
      [
        27470,
        57925
      ],
      [
        -14,
        30
      ],
      [
        -8,
        17
      ],
      [
        -11,
        22
      ],
      [
        -1,
        20
      ],
      [
        -6,
        72
      ],
      [
        -11,
        29
      ],
      [
        -9,
        35
      ],
      [
        4,
        14
      ],
      [
        -10,
        92
      ],
      [
        1,
        15
      ]
    ],
    [
      [
        21414,
        54291
      ],
      [
        21,
        0
      ]
    ],
    [
      [
        21556,
        54291
      ],
      [
        0,
        -507
      ]
    ],
    [
      [
        21414,
        53784
      ],
      [
        0,
        507
      ]
    ],
    [
      [
        22245,
        52196
      ],
      [
        -126,
        4
      ]
    ],
    [
      [
        22119,
        52200
      ],
      [
        -100,
        0
      ]
    ],
    [
      [
        24750,
        67640
      ],
      [
        34,
        1
      ],
      [
        -1,
        -26
      ],
      [
        1,
        -6
      ],
      [
        -1,
        -5
      ],
      [
        1,
        -14
      ],
      [
        0,
        -153
      ],
      [
        -1,
        -245
      ],
      [
        0,
        -6
      ]
    ],
    [
      [
        24783,
        67186
      ],
      [
        -7,
        10
      ],
      [
        -12,
        29
      ],
      [
        -5,
        -4
      ],
      [
        -5,
        16
      ],
      [
        -4,
        -2
      ],
      [
        -11,
        4
      ],
      [
        -16,
        -11
      ],
      [
        -6,
        1
      ]
    ],
    [
      [
        24717,
        67229
      ],
      [
        -32,
        12
      ],
      [
        -12,
        -13
      ],
      [
        -6,
        -17
      ],
      [
        -16,
        -16
      ]
    ],
    [
      [
        24651,
        67195
      ],
      [
        0,
        292
      ]
    ],
    [
      [
        24651,
        67487
      ],
      [
        -1,
        151
      ],
      [
        67,
        1
      ],
      [
        33,
        1
      ]
    ],
    [
      [
        21748,
        58410
      ],
      [
        0,
        -7
      ]
    ],
    [
      [
        25821,
        60384
      ],
      [
        72,
        14
      ],
      [
        5,
        -6
      ],
      [
        1,
        15
      ],
      [
        3,
        -9
      ],
      [
        6,
        3
      ]
    ],
    [
      [
        25908,
        60401
      ],
      [
        30,
        -140
      ],
      [
        -2,
        -56
      ]
    ],
    [
      [
        25936,
        60205
      ],
      [
        -5,
        -133
      ],
      [
        -11,
        10
      ]
    ],
    [
      [
        25920,
        60082
      ],
      [
        -22,
        18
      ],
      [
        -7,
        32
      ],
      [
        -7,
        -9
      ],
      [
        -4,
        -13
      ],
      [
        -7,
        -6
      ],
      [
        -33,
        104
      ]
    ],
    [
      [
        25840,
        60208
      ],
      [
        -19,
        176
      ]
    ],
    [
      [
        26147,
        62950
      ],
      [
        16,
        1
      ],
      [
        31,
        1
      ],
      [
        26,
        -1
      ]
    ],
    [
      [
        26220,
        62951
      ],
      [
        4,
        -2
      ],
      [
        57,
        -3
      ]
    ],
    [
      [
        26281,
        62946
      ],
      [
        0,
        -151
      ],
      [
        -1,
        -96
      ],
      [
        0,
        -5
      ]
    ],
    [
      [
        26280,
        62694
      ],
      [
        -68,
        2
      ]
    ],
    [
      [
        26212,
        62696
      ],
      [
        -3,
        3
      ],
      [
        -26,
        0
      ],
      [
        -14,
        -1
      ],
      [
        -22,
        -47
      ]
    ],
    [
      [
        26147,
        62651
      ],
      [
        0,
        97
      ],
      [
        1,
        5
      ],
      [
        -1,
        113
      ]
    ],
    [
      [
        26147,
        62866
      ],
      [
        0,
        84
      ]
    ],
    [
      [
        17550,
        68740
      ],
      [
        -1,
        1
      ],
      [
        0,
        9
      ],
      [
        -1,
        9
      ],
      [
        0,
        11
      ],
      [
        -1,
        12
      ],
      [
        -1,
        11
      ],
      [
        -1,
        10
      ],
      [
        -1,
        10
      ],
      [
        1,
        9
      ],
      [
        -1,
        9
      ],
      [
        -1,
        6
      ],
      [
        -1,
        2
      ],
      [
        0,
        4
      ],
      [
        1,
        8
      ],
      [
        1,
        9
      ],
      [
        0,
        11
      ],
      [
        2,
        9
      ],
      [
        0,
        7
      ],
      [
        -1,
        12
      ],
      [
        -1,
        11
      ],
      [
        1,
        11
      ],
      [
        1,
        12
      ],
      [
        2,
        16
      ],
      [
        0,
        14
      ],
      [
        1,
        3
      ],
      [
        0,
        9
      ],
      [
        -1,
        9
      ],
      [
        -1,
        3
      ],
      [
        -1,
        1
      ],
      [
        0,
        3
      ],
      [
        -1,
        1
      ],
      [
        0,
        3
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        20
      ],
      [
        -1,
        10
      ],
      [
        -2,
        6
      ],
      [
        -2,
        12
      ],
      [
        -1,
        3
      ],
      [
        -1,
        2
      ],
      [
        -1,
        6
      ],
      [
        0,
        11
      ],
      [
        1,
        5
      ],
      [
        0,
        6
      ],
      [
        1,
        4
      ],
      [
        0,
        5
      ],
      [
        -1,
        4
      ],
      [
        1,
        5
      ],
      [
        0,
        7
      ],
      [
        1,
        6
      ],
      [
        0,
        34
      ],
      [
        1,
        2
      ],
      [
        0,
        5
      ],
      [
        -1,
        5
      ],
      [
        0,
        5
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        1,
        7
      ],
      [
        0,
        14
      ],
      [
        1,
        4
      ],
      [
        3,
        0
      ],
      [
        0,
        10
      ],
      [
        1,
        5
      ],
      [
        1,
        0
      ],
      [
        1,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        8
      ],
      [
        0,
        12
      ],
      [
        1,
        7
      ],
      [
        0,
        16
      ],
      [
        2,
        2
      ],
      [
        1,
        -3
      ],
      [
        3,
        0
      ],
      [
        2,
        5
      ],
      [
        1,
        8
      ],
      [
        1,
        8
      ],
      [
        1,
        10
      ],
      [
        0,
        11
      ],
      [
        -1,
        4
      ],
      [
        0,
        2
      ],
      [
        -1,
        4
      ],
      [
        -1,
        2
      ],
      [
        -1,
        9
      ],
      [
        -1,
        4
      ],
      [
        0,
        12
      ],
      [
        2,
        8
      ],
      [
        1,
        7
      ],
      [
        2,
        5
      ],
      [
        2,
        6
      ],
      [
        1,
        3
      ],
      [
        1,
        10
      ],
      [
        -1,
        9
      ],
      [
        1,
        4
      ],
      [
        2,
        4
      ],
      [
        1,
        6
      ],
      [
        -1,
        6
      ],
      [
        -4,
        7
      ],
      [
        -5,
        3
      ],
      [
        -1,
        1
      ],
      [
        -3,
        6
      ],
      [
        0,
        17
      ],
      [
        -1,
        11
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        17553,
        69448
      ],
      [
        3,
        19
      ],
      [
        -1,
        16
      ],
      [
        4,
        25
      ],
      [
        12,
        -7
      ],
      [
        4,
        14
      ],
      [
        5,
        2
      ],
      [
        1,
        12
      ],
      [
        7,
        7
      ],
      [
        12,
        42
      ],
      [
        3,
        -18
      ],
      [
        -3,
        -10
      ],
      [
        272,
        2
      ],
      [
        85,
        0
      ]
    ],
    [
      [
        17957,
        69552
      ],
      [
        -8,
        -19
      ],
      [
        0,
        -24
      ],
      [
        -3,
        -10
      ],
      [
        3,
        -35
      ],
      [
        -3,
        -31
      ],
      [
        4,
        -7
      ],
      [
        -2,
        -11
      ],
      [
        1,
        -44
      ],
      [
        -1,
        -18
      ],
      [
        1,
        -24
      ],
      [
        -3,
        -38
      ],
      [
        0,
        -27
      ],
      [
        3,
        -17
      ],
      [
        -3,
        -12
      ],
      [
        3,
        -39
      ],
      [
        -3,
        -14
      ],
      [
        -8,
        -4
      ],
      [
        -2,
        -12
      ],
      [
        2,
        -8
      ],
      [
        -1,
        -19
      ],
      [
        -8,
        -9
      ],
      [
        -5,
        -30
      ]
    ],
    [
      [
        17790,
        68554
      ],
      [
        -2,
        3
      ],
      [
        -5,
        7
      ],
      [
        -4,
        2
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -8
      ],
      [
        1,
        -7
      ],
      [
        0,
        -35
      ],
      [
        -4,
        -7
      ],
      [
        -3,
        -6
      ],
      [
        -3,
        -8
      ],
      [
        0,
        -9
      ],
      [
        -2,
        -14
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -1,
        1
      ],
      [
        -2,
        3
      ],
      [
        -3,
        1
      ],
      [
        -3,
        -6
      ],
      [
        -3,
        -9
      ],
      [
        -2,
        -7
      ],
      [
        -4,
        -5
      ],
      [
        -2,
        -4
      ],
      [
        -4,
        0
      ],
      [
        -3,
        -6
      ],
      [
        -1,
        1
      ],
      [
        -1,
        5
      ],
      [
        -1,
        5
      ],
      [
        -3,
        -5
      ],
      [
        -13,
        -4
      ],
      [
        -125,
        0
      ],
      [
        -10,
        1
      ],
      [
        -13,
        0
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -14
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -15
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -5
      ],
      [
        1,
        -8
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -4
      ],
      [
        -4,
        0
      ],
      [
        -6,
        4
      ],
      [
        -16,
        0
      ]
    ],
    [
      [
        17534,
        68335
      ],
      [
        0,
        201
      ],
      [
        17,
        1
      ],
      [
        -1,
        203
      ]
    ],
    [
      [
        28095,
        61182
      ],
      [
        15,
        66
      ],
      [
        12,
        79
      ]
    ],
    [
      [
        28122,
        61327
      ],
      [
        11,
        -2
      ],
      [
        7,
        16
      ],
      [
        8,
        -4
      ],
      [
        4,
        15
      ],
      [
        15,
        -19
      ],
      [
        6,
        0
      ],
      [
        1,
        7
      ],
      [
        6,
        -5
      ],
      [
        6,
        -21
      ],
      [
        7,
        -2
      ]
    ],
    [
      [
        28193,
        61312
      ],
      [
        10,
        0
      ],
      [
        20,
        -23
      ],
      [
        3,
        9
      ],
      [
        4,
        -20
      ],
      [
        10,
        -15
      ],
      [
        1,
        -10
      ],
      [
        -1,
        -5
      ],
      [
        6,
        -12
      ],
      [
        5,
        -2
      ],
      [
        0,
        -32
      ],
      [
        2,
        11
      ],
      [
        8,
        -24
      ],
      [
        6,
        -5
      ]
    ],
    [
      [
        28267,
        61184
      ],
      [
        -15,
        -167
      ],
      [
        -15,
        -158
      ]
    ],
    [
      [
        28237,
        60859
      ],
      [
        -7,
        19
      ],
      [
        -3,
        9
      ],
      [
        -16,
        9
      ],
      [
        -3,
        9
      ],
      [
        -4,
        44
      ],
      [
        -9,
        48
      ],
      [
        -12,
        12
      ],
      [
        -2,
        9
      ],
      [
        -5,
        31
      ],
      [
        -13,
        15
      ]
    ],
    [
      [
        28163,
        61064
      ],
      [
        -31,
        53
      ],
      [
        -9,
        8
      ],
      [
        -4,
        15
      ],
      [
        -3,
        10
      ],
      [
        -13,
        15
      ],
      [
        -8,
        17
      ]
    ],
    [
      [
        22448,
        55301
      ],
      [
        41,
        -2
      ],
      [
        0,
        64
      ]
    ],
    [
      [
        22593,
        55358
      ],
      [
        -3,
        -517
      ]
    ],
    [
      [
        22589,
        54786
      ],
      [
        -113,
        1
      ]
    ],
    [
      [
        22476,
        54787
      ],
      [
        -6,
        0
      ],
      [
        -22,
        3
      ]
    ],
    [
      [
        22448,
        54790
      ],
      [
        0,
        511
      ]
    ],
    [
      [
        21322,
        56882
      ],
      [
        25,
        1
      ]
    ],
    [
      [
        21322,
        56315
      ],
      [
        0,
        567
      ]
    ],
    [
      [
        25843,
        53019
      ],
      [
        4,
        1
      ],
      [
        3,
        0
      ],
      [
        17,
        -1
      ],
      [
        32,
        0
      ]
    ],
    [
      [
        25899,
        53019
      ],
      [
        7,
        0
      ],
      [
        13,
        -1
      ],
      [
        23,
        0
      ]
    ],
    [
      [
        25942,
        53018
      ],
      [
        -1,
        -336
      ],
      [
        54,
        -2
      ]
    ],
    [
      [
        25995,
        52680
      ],
      [
        -9,
        -27
      ],
      [
        2,
        -19
      ],
      [
        -6,
        -8
      ],
      [
        -7,
        -23
      ],
      [
        2,
        -26
      ],
      [
        -2,
        -20
      ],
      [
        6,
        -12
      ],
      [
        2,
        -31
      ],
      [
        2,
        -5
      ],
      [
        -2,
        -42
      ],
      [
        2,
        -17
      ],
      [
        3,
        2
      ],
      [
        3,
        -19
      ],
      [
        -6,
        -28
      ],
      [
        -3,
        5
      ],
      [
        -3,
        -31
      ],
      [
        -4,
        -7
      ],
      [
        -5,
        8
      ],
      [
        -8,
        -6
      ],
      [
        -7,
        -19
      ],
      [
        -2,
        -40
      ]
    ],
    [
      [
        25953,
        52175
      ],
      [
        -2,
        2
      ],
      [
        -25,
        38
      ],
      [
        -37,
        47
      ],
      [
        -21,
        23
      ],
      [
        -18,
        13
      ],
      [
        -9,
        5
      ]
    ],
    [
      [
        29224,
        66306
      ],
      [
        89,
        43
      ],
      [
        42,
        22
      ]
    ],
    [
      [
        29355,
        66371
      ],
      [
        2,
        -3
      ],
      [
        0,
        -37
      ],
      [
        -5,
        -64
      ],
      [
        3,
        -58
      ],
      [
        0,
        -43
      ],
      [
        -5,
        -40
      ],
      [
        -9,
        -13
      ],
      [
        -4,
        -14
      ],
      [
        -2,
        -45
      ],
      [
        -10,
        -28
      ],
      [
        -5,
        -47
      ]
    ],
    [
      [
        29320,
        65979
      ],
      [
        -3,
        2
      ],
      [
        -23,
        56
      ],
      [
        0,
        -16
      ],
      [
        -11,
        8
      ],
      [
        -9,
        -86
      ],
      [
        -55,
        18
      ],
      [
        -10,
        3
      ],
      [
        -40,
        64
      ]
    ],
    [
      [
        29169,
        66028
      ],
      [
        -24,
        37
      ],
      [
        30,
        172
      ],
      [
        -4,
        7
      ]
    ],
    [
      [
        26283,
        63509
      ],
      [
        0,
        144
      ],
      [
        1,
        59
      ],
      [
        0,
        51
      ],
      [
        1,
        92
      ],
      [
        0,
        9
      ]
    ],
    [
      [
        26285,
        63913
      ],
      [
        57,
        1
      ],
      [
        46,
        1
      ]
    ],
    [
      [
        26388,
        63732
      ],
      [
        -1,
        -19
      ],
      [
        1,
        -16
      ],
      [
        2,
        -288
      ]
    ],
    [
      [
        26390,
        63409
      ],
      [
        -17,
        -1
      ]
    ],
    [
      [
        26373,
        63408
      ],
      [
        -91,
        -2
      ]
    ],
    [
      [
        23349,
        73444
      ],
      [
        36,
        0
      ],
      [
        0,
        -203
      ],
      [
        218,
        2
      ]
    ],
    [
      [
        23603,
        73243
      ],
      [
        2,
        -405
      ],
      [
        1,
        0
      ],
      [
        0,
        -202
      ]
    ],
    [
      [
        23606,
        72636
      ],
      [
        1,
        -294
      ],
      [
        0,
        -173
      ]
    ],
    [
      [
        23607,
        72169
      ],
      [
        0,
        -39
      ],
      [
        -71,
        -1
      ]
    ],
    [
      [
        23536,
        72129
      ],
      [
        -4,
        -1
      ],
      [
        -32,
        0
      ],
      [
        -36,
        2
      ],
      [
        -71,
        2
      ]
    ],
    [
      [
        23393,
        72132
      ],
      [
        0,
        100
      ],
      [
        -3,
        203
      ],
      [
        0,
        232
      ],
      [
        -15,
        12
      ],
      [
        -6,
        24
      ],
      [
        -2,
        47
      ],
      [
        1,
        19
      ],
      [
        7,
        52
      ],
      [
        5,
        17
      ],
      [
        -98,
        1
      ]
    ],
    [
      [
        23279,
        73016
      ],
      [
        0,
        225
      ],
      [
        -3,
        0
      ],
      [
        1,
        151
      ],
      [
        -1,
        50
      ]
    ],
    [
      [
        26073,
        68351
      ],
      [
        64,
        0
      ]
    ],
    [
      [
        26137,
        68351
      ],
      [
        69,
        -1
      ]
    ],
    [
      [
        23176,
        60713
      ],
      [
        0,
        -252
      ]
    ],
    [
      [
        23176,
        60461
      ],
      [
        -1,
        -14
      ],
      [
        0,
        -88
      ]
    ],
    [
      [
        23175,
        60359
      ],
      [
        -86,
        1
      ],
      [
        -70,
        3
      ]
    ],
    [
      [
        23019,
        60363
      ],
      [
        0,
        202
      ]
    ],
    [
      [
        23019,
        60565
      ],
      [
        0,
        152
      ]
    ],
    [
      [
        21481,
        61480
      ],
      [
        133,
        1
      ]
    ],
    [
      [
        21614,
        61481
      ],
      [
        7,
        0
      ]
    ],
    [
      [
        21621,
        61481
      ],
      [
        0,
        -507
      ],
      [
        5,
        0
      ],
      [
        -1,
        -106
      ]
    ],
    [
      [
        21625,
        60868
      ],
      [
        -143,
        2
      ]
    ],
    [
      [
        21482,
        60870
      ],
      [
        0,
        221
      ],
      [
        -1,
        137
      ],
      [
        0,
        252
      ]
    ],
    [
      [
        23977,
        73546
      ],
      [
        28,
        -5
      ],
      [
        9,
        9
      ],
      [
        1,
        -1
      ],
      [
        0,
        -26
      ],
      [
        6,
        -1
      ],
      [
        5,
        -13
      ],
      [
        5,
        -1
      ],
      [
        46,
        -65
      ],
      [
        20,
        8
      ],
      [
        6,
        -4
      ],
      [
        2,
        -24
      ],
      [
        0,
        -5
      ],
      [
        1,
        0
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -2,
        2
      ],
      [
        -2,
        -6
      ],
      [
        -7,
        1
      ],
      [
        -4,
        -3
      ],
      [
        -1,
        -12
      ],
      [
        -2,
        -13
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -9
      ],
      [
        7,
        -22
      ],
      [
        7,
        -4
      ],
      [
        2,
        -5
      ],
      [
        22,
        5
      ],
      [
        11,
        8
      ],
      [
        6,
        1
      ],
      [
        2,
        -1
      ],
      [
        5,
        -16
      ],
      [
        1,
        -4
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        1,
        -7
      ],
      [
        6,
        -6
      ],
      [
        0,
        -15
      ],
      [
        -6,
        -34
      ],
      [
        2,
        -23
      ],
      [
        4,
        -26
      ],
      [
        4,
        -16
      ],
      [
        1,
        -7
      ],
      [
        1,
        -6
      ],
      [
        1,
        1
      ],
      [
        1,
        -1
      ],
      [
        3,
        -11
      ],
      [
        2,
        -19
      ],
      [
        3,
        -16
      ],
      [
        1,
        -6
      ],
      [
        1,
        -8
      ],
      [
        1,
        -5
      ],
      [
        0,
        -6
      ],
      [
        1,
        1
      ],
      [
        0,
        -7
      ],
      [
        1,
        -3
      ],
      [
        0,
        -6
      ],
      [
        1,
        -2
      ],
      [
        1,
        -6
      ],
      [
        1,
        -4
      ],
      [
        2,
        3
      ],
      [
        2,
        8
      ],
      [
        2,
        2
      ],
      [
        2,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        1,
        -2
      ],
      [
        2,
        4
      ],
      [
        1,
        0
      ],
      [
        2,
        4
      ],
      [
        10,
        4
      ],
      [
        3,
        5
      ],
      [
        -1,
        10
      ],
      [
        -5,
        10
      ],
      [
        -1,
        7
      ],
      [
        0,
        6
      ],
      [
        -1,
        2
      ],
      [
        -1,
        12
      ],
      [
        2,
        21
      ],
      [
        -4,
        11
      ],
      [
        1,
        8
      ],
      [
        2,
        1
      ],
      [
        2,
        22
      ],
      [
        8,
        14
      ],
      [
        11,
        -6
      ],
      [
        1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        3,
        0
      ],
      [
        0,
        3
      ],
      [
        1,
        5
      ],
      [
        3,
        -2
      ],
      [
        0,
        -2
      ],
      [
        4,
        4
      ],
      [
        0,
        6
      ],
      [
        5,
        7
      ],
      [
        4,
        3
      ],
      [
        1,
        -11
      ],
      [
        14,
        -2
      ],
      [
        3,
        -1
      ],
      [
        1,
        5
      ],
      [
        3,
        2
      ],
      [
        3,
        -1
      ],
      [
        2,
        -12
      ],
      [
        1,
        -1
      ],
      [
        0,
        -15
      ],
      [
        2,
        -2
      ],
      [
        2,
        -9
      ],
      [
        9,
        -5
      ],
      [
        -4,
        -28
      ],
      [
        0,
        -11
      ],
      [
        2,
        -8
      ],
      [
        0,
        -18
      ],
      [
        5,
        -6
      ],
      [
        2,
        -14
      ],
      [
        1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        1,
        0
      ],
      [
        1,
        3
      ],
      [
        0,
        2
      ],
      [
        -1,
        2
      ],
      [
        1,
        3
      ],
      [
        3,
        0
      ],
      [
        1,
        -2
      ],
      [
        1,
        0
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -4
      ],
      [
        1,
        0
      ],
      [
        2,
        -3
      ],
      [
        1,
        1
      ],
      [
        0,
        1
      ],
      [
        1,
        3
      ],
      [
        3,
        2
      ],
      [
        2,
        1
      ],
      [
        1,
        2
      ],
      [
        3,
        -1
      ],
      [
        0,
        -1
      ],
      [
        1,
        0
      ],
      [
        2,
        1
      ],
      [
        3,
        -12
      ],
      [
        5,
        -10
      ],
      [
        1,
        -14
      ],
      [
        5,
        2
      ],
      [
        2,
        1
      ],
      [
        2,
        0
      ],
      [
        4,
        3
      ],
      [
        0,
        -4
      ],
      [
        2,
        -3
      ],
      [
        3,
        -4
      ]
    ],
    [
      [
        24336,
        73051
      ],
      [
        3,
        -763
      ],
      [
        -1,
        -200
      ],
      [
        0,
        -307
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -197
      ]
    ],
    [
      [
        24337,
        71581
      ],
      [
        -3,
        -7
      ],
      [
        -6,
        -8
      ],
      [
        -2,
        0
      ],
      [
        -2,
        -2
      ],
      [
        -8,
        -20
      ],
      [
        -4,
        -3
      ],
      [
        -6,
        -17
      ],
      [
        -3,
        -8
      ],
      [
        -2,
        -4
      ],
      [
        -8,
        -16
      ],
      [
        -9,
        -20
      ],
      [
        -4,
        -13
      ],
      [
        -4,
        -5
      ],
      [
        -13,
        -28
      ],
      [
        0,
        -7
      ],
      [
        -7,
        -11
      ],
      [
        -2,
        -7
      ],
      [
        0,
        -1
      ],
      [
        1,
        -16
      ],
      [
        7,
        -33
      ],
      [
        11,
        -41
      ],
      [
        3,
        -5
      ]
    ],
    [
      [
        24276,
        71309
      ],
      [
        -2,
        -2
      ],
      [
        -4,
        5
      ],
      [
        -15,
        47
      ],
      [
        -5,
        0
      ],
      [
        -3,
        -1
      ],
      [
        -6,
        -10
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -11
      ],
      [
        -1,
        -11
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -4,
        5
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        1,
        -5
      ],
      [
        1,
        -3
      ],
      [
        5,
        -1
      ],
      [
        1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -9
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        4
      ],
      [
        -2,
        0
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -1
      ],
      [
        -4,
        11
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -7
      ],
      [
        -2,
        0
      ],
      [
        0,
        2
      ],
      [
        -1,
        5
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        2
      ],
      [
        0,
        8
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -3
      ]
    ],
    [
      [
        23986,
        71682
      ],
      [
        0,
        96
      ],
      [
        -3,
        0
      ],
      [
        0,
        306
      ],
      [
        -1,
        26
      ],
      [
        0,
        74
      ],
      [
        1,
        49
      ],
      [
        1,
        256
      ],
      [
        -6,
        1
      ],
      [
        0,
        100
      ],
      [
        1,
        99
      ]
    ],
    [
      [
        23979,
        72689
      ],
      [
        -2,
        101
      ],
      [
        -1,
        104
      ],
      [
        -2,
        0
      ],
      [
        1,
        212
      ],
      [
        2,
        440
      ]
    ],
    [
      [
        24295,
        65261
      ],
      [
        32,
        1
      ]
    ],
    [
      [
        24327,
        65262
      ],
      [
        87,
        0
      ],
      [
        0,
        -16
      ],
      [
        3,
        4
      ],
      [
        2,
        -28
      ],
      [
        -4,
        -9
      ],
      [
        4,
        -11
      ],
      [
        0,
        -15
      ],
      [
        5,
        -27
      ]
    ],
    [
      [
        24424,
        65160
      ],
      [
        -1,
        -203
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        24359,
        64856
      ],
      [
        -32,
        -1
      ],
      [
        -32,
        2
      ]
    ],
    [
      [
        24295,
        64857
      ],
      [
        0,
        404
      ]
    ],
    [
      [
        22303,
        54789
      ],
      [
        145,
        1
      ]
    ],
    [
      [
        22476,
        54787
      ],
      [
        0,
        -249
      ],
      [
        -21,
        -44
      ]
    ],
    [
      [
        22455,
        54494
      ],
      [
        -104,
        -213
      ]
    ],
    [
      [
        22352,
        52023
      ],
      [
        0,
        -415
      ]
    ],
    [
      [
        22352,
        51608
      ],
      [
        -72,
        132
      ],
      [
        -28,
        10
      ],
      [
        -90,
        5
      ]
    ],
    [
      [
        22162,
        51755
      ],
      [
        -25,
        1
      ],
      [
        0,
        192
      ],
      [
        -19,
        0
      ]
    ],
    [
      [
        22118,
        51948
      ],
      [
        1,
        252
      ]
    ],
    [
      [
        28094,
        66437
      ],
      [
        73,
        0
      ],
      [
        3,
        1
      ]
    ],
    [
      [
        28170,
        66438
      ],
      [
        -2,
        -4
      ],
      [
        25,
        0
      ],
      [
        32,
        -1
      ],
      [
        0,
        -50
      ],
      [
        32,
        -4
      ]
    ],
    [
      [
        28257,
        66379
      ],
      [
        0,
        -78
      ],
      [
        -3,
        -143
      ],
      [
        -2,
        -103
      ],
      [
        -2,
        -226
      ]
    ],
    [
      [
        28250,
        65829
      ],
      [
        -69,
        0
      ],
      [
        -9,
        1
      ],
      [
        -26,
        1
      ],
      [
        -23,
        -1
      ]
    ],
    [
      [
        28123,
        65830
      ],
      [
        -29,
        0
      ]
    ],
    [
      [
        28094,
        65830
      ],
      [
        0,
        607
      ]
    ],
    [
      [
        21615,
        56321
      ],
      [
        2,
        -507
      ]
    ],
    [
      [
        27617,
        60369
      ],
      [
        0,
        -31
      ],
      [
        2,
        -12
      ],
      [
        -1,
        -8
      ],
      [
        -4,
        -2
      ]
    ],
    [
      [
        27614,
        60316
      ],
      [
        -5,
        -12
      ],
      [
        -7,
        6
      ],
      [
        -2,
        10
      ],
      [
        -3,
        19
      ],
      [
        -7,
        6
      ],
      [
        10,
        12
      ],
      [
        3,
        17
      ],
      [
        11,
        14
      ],
      [
        3,
        -19
      ]
    ],
    [
      [
        28366,
        60374
      ],
      [
        10,
        -4
      ],
      [
        4,
        5
      ]
    ],
    [
      [
        28380,
        60375
      ],
      [
        2,
        5
      ],
      [
        2,
        -10
      ],
      [
        4,
        -18
      ],
      [
        -7,
        -18
      ],
      [
        -1,
        -4
      ],
      [
        -5,
        -6
      ],
      [
        -1,
        -9
      ],
      [
        -5,
        1
      ],
      [
        -2,
        -5
      ],
      [
        1,
        10
      ],
      [
        -2,
        53
      ]
    ],
    [
      [
        24716,
        65047
      ],
      [
        1,
        102
      ],
      [
        0,
        49
      ],
      [
        15,
        26
      ],
      [
        2,
        21
      ],
      [
        10,
        20
      ],
      [
        26,
        13
      ],
      [
        13,
        21
      ],
      [
        4,
        35
      ],
      [
        -2,
        13
      ]
    ],
    [
      [
        24785,
        65347
      ],
      [
        90,
        0
      ]
    ],
    [
      [
        24875,
        65347
      ],
      [
        2,
        -77
      ],
      [
        0,
        -330
      ]
    ],
    [
      [
        24877,
        64940
      ],
      [
        -3,
        0
      ],
      [
        0,
        -100
      ],
      [
        -2,
        1
      ],
      [
        -31,
        0
      ]
    ],
    [
      [
        24715,
        64843
      ],
      [
        1,
        204
      ]
    ],
    [
      [
        24912,
        54928
      ],
      [
        0,
        292
      ]
    ],
    [
      [
        24912,
        55220
      ],
      [
        0,
        53
      ],
      [
        36,
        0
      ],
      [
        12,
        1
      ],
      [
        67,
        1
      ]
    ],
    [
      [
        25027,
        54861
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        25026,
        54861
      ],
      [
        -42,
        0
      ],
      [
        -72,
        1
      ],
      [
        0,
        66
      ]
    ],
    [
      [
        20265,
        57531
      ],
      [
        73,
        0
      ],
      [
        0,
        93
      ],
      [
        -2,
        4
      ],
      [
        -25,
        0
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        20311,
        57729
      ],
      [
        14,
        0
      ],
      [
        46,
        1
      ],
      [
        88,
        1
      ]
    ],
    [
      [
        20459,
        57731
      ],
      [
        118,
        0
      ]
    ],
    [
      [
        20577,
        57731
      ],
      [
        0,
        -506
      ],
      [
        -6,
        0
      ],
      [
        0,
        -303
      ]
    ],
    [
      [
        20571,
        56922
      ],
      [
        0,
        -101
      ],
      [
        -171,
        0
      ]
    ],
    [
      [
        20400,
        56821
      ],
      [
        -137,
        0
      ],
      [
        0,
        209
      ]
    ],
    [
      [
        20263,
        57030
      ],
      [
        0,
        96
      ],
      [
        -15,
        -1
      ],
      [
        2,
        101
      ],
      [
        -1,
        127
      ],
      [
        1,
        109
      ],
      [
        0,
        69
      ],
      [
        15,
        0
      ]
    ],
    [
      [
        21312,
        64375
      ],
      [
        167,
        0
      ]
    ],
    [
      [
        21479,
        64375
      ],
      [
        0,
        -60
      ]
    ],
    [
      [
        21479,
        64015
      ],
      [
        -170,
        -2
      ]
    ],
    [
      [
        21309,
        64013
      ],
      [
        0,
        311
      ],
      [
        3,
        0
      ],
      [
        0,
        51
      ]
    ],
    [
      [
        21276,
        64013
      ],
      [
        33,
        0
      ]
    ],
    [
      [
        21479,
        63909
      ],
      [
        0,
        -403
      ]
    ],
    [
      [
        21479,
        63506
      ],
      [
        0,
        -214
      ],
      [
        1,
        -167
      ],
      [
        0,
        -118
      ]
    ],
    [
      [
        21480,
        63007
      ],
      [
        -140,
        -4
      ],
      [
        -5,
        -2
      ],
      [
        -65,
        -1
      ]
    ],
    [
      [
        23204,
        67295
      ],
      [
        132,
        -3
      ]
    ],
    [
      [
        23336,
        67292
      ],
      [
        0,
        -402
      ]
    ],
    [
      [
        23336,
        66890
      ],
      [
        -131,
        -1
      ]
    ],
    [
      [
        23205,
        66889
      ],
      [
        -1,
        102
      ],
      [
        0,
        304
      ]
    ],
    [
      [
        25026,
        54861
      ],
      [
        0,
        -411
      ]
    ],
    [
      [
        25026,
        54450
      ],
      [
        -106,
        1
      ],
      [
        -8,
        -2
      ]
    ],
    [
      [
        24912,
        54449
      ],
      [
        0,
        152
      ],
      [
        -9,
        175
      ],
      [
        -6,
        97
      ]
    ],
    [
      [
        24897,
        54873
      ],
      [
        4,
        23
      ],
      [
        11,
        32
      ]
    ],
    [
      [
        22397,
        65529
      ],
      [
        2,
        0
      ]
    ],
    [
      [
        22399,
        65529
      ],
      [
        0,
        -404
      ]
    ],
    [
      [
        22399,
        65125
      ],
      [
        -126,
        0
      ]
    ],
    [
      [
        27336,
        58900
      ],
      [
        15,
        15
      ],
      [
        26,
        -4
      ]
    ],
    [
      [
        27430,
        58906
      ],
      [
        -4,
        -231
      ]
    ],
    [
      [
        27426,
        58675
      ],
      [
        -10,
        -121
      ],
      [
        -8,
        -89
      ],
      [
        4,
        -65
      ],
      [
        4,
        -66
      ],
      [
        2,
        -40
      ],
      [
        0,
        -23
      ]
    ],
    [
      [
        27405,
        58271
      ],
      [
        -35,
        11
      ],
      [
        -11,
        -28
      ]
    ],
    [
      [
        27359,
        58254
      ],
      [
        -4,
        9
      ],
      [
        2,
        38
      ],
      [
        4,
        -2
      ],
      [
        -5,
        20
      ]
    ],
    [
      [
        27356,
        58319
      ],
      [
        2,
        40
      ],
      [
        5,
        13
      ],
      [
        -3,
        15
      ],
      [
        5,
        16
      ],
      [
        0,
        4
      ],
      [
        -7,
        22
      ],
      [
        -4,
        34
      ],
      [
        -11,
        46
      ],
      [
        -16,
        1
      ],
      [
        -1,
        32
      ],
      [
        -12,
        44
      ]
    ],
    [
      [
        25408,
        56425
      ],
      [
        24,
        0
      ],
      [
        40,
        -6
      ],
      [
        24,
        1
      ]
    ],
    [
      [
        25496,
        56420
      ],
      [
        0,
        -51
      ],
      [
        29,
        -5
      ],
      [
        1,
        -204
      ],
      [
        29,
        -4
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        25555,
        56055
      ],
      [
        -58,
        9
      ],
      [
        0,
        -34
      ],
      [
        -10,
        -1
      ],
      [
        0,
        -68
      ],
      [
        -6,
        0
      ],
      [
        -13,
        -2
      ],
      [
        -29,
        6
      ]
    ],
    [
      [
        25439,
        55965
      ],
      [
        -30,
        -1
      ]
    ],
    [
      [
        25409,
        55964
      ],
      [
        0,
        137
      ],
      [
        -1,
        324
      ]
    ],
    [
      [
        21845,
        63505
      ],
      [
        146,
        0
      ],
      [
        5,
        -1
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        21997,
        63504
      ],
      [
        4,
        0
      ]
    ],
    [
      [
        22001,
        62998
      ],
      [
        -151,
        2
      ]
    ],
    [
      [
        21845,
        63000
      ],
      [
        0,
        505
      ]
    ],
    [
      [
        16968,
        69275
      ],
      [
        8,
        35
      ],
      [
        0,
        21
      ],
      [
        6,
        12
      ],
      [
        9,
        -2
      ],
      [
        5,
        14
      ],
      [
        4,
        20
      ],
      [
        10,
        -4
      ],
      [
        7,
        -28
      ],
      [
        9,
        -15
      ],
      [
        10,
        -12
      ],
      [
        9,
        2
      ],
      [
        17,
        40
      ],
      [
        5,
        32
      ],
      [
        4,
        9
      ],
      [
        3,
        -13
      ],
      [
        6,
        5
      ],
      [
        7,
        -38
      ],
      [
        7,
        0
      ],
      [
        3,
        -14
      ],
      [
        1,
        -25
      ],
      [
        59,
        1
      ],
      [
        1,
        100
      ],
      [
        82,
        2
      ]
    ],
    [
      [
        17240,
        69417
      ],
      [
        135,
        -3
      ]
    ],
    [
      [
        17375,
        69414
      ],
      [
        0,
        -1
      ],
      [
        -4,
        -20
      ],
      [
        -3,
        -11
      ],
      [
        -5,
        -15
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        -5
      ],
      [
        -2,
        -10
      ],
      [
        0,
        -1
      ],
      [
        1,
        -4
      ],
      [
        0,
        -21
      ],
      [
        -3,
        -18
      ],
      [
        -1,
        -7
      ],
      [
        2,
        -22
      ],
      [
        0,
        -2
      ],
      [
        1,
        -7
      ],
      [
        3,
        -13
      ],
      [
        1,
        -9
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -10
      ],
      [
        -1,
        -11
      ],
      [
        -2,
        -14
      ],
      [
        0,
        -7
      ],
      [
        -2,
        -8
      ],
      [
        -2,
        -12
      ],
      [
        -5,
        -14
      ],
      [
        -3,
        -12
      ],
      [
        -2,
        -8
      ]
    ],
    [
      [
        17342,
        69138
      ],
      [
        -1,
        -7
      ],
      [
        -4,
        -24
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -5
      ],
      [
        1,
        -4
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        -5
      ],
      [
        -5,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        -3,
        -7
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        0
      ],
      [
        -2,
        1
      ],
      [
        -7,
        -10
      ],
      [
        -2,
        -4
      ],
      [
        -5,
        -21
      ],
      [
        1,
        -6
      ],
      [
        -1,
        -18
      ],
      [
        0,
        -3
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -9
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -3
      ],
      [
        -3,
        -18
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -15
      ],
      [
        -1,
        -13
      ],
      [
        -3,
        -16
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -24
      ],
      [
        0,
        -14
      ],
      [
        -3,
        -8
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -3
      ],
      [
        2,
        -5
      ],
      [
        -1,
        -14
      ],
      [
        -1,
        -11
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -8
      ],
      [
        -2,
        -2
      ],
      [
        -4,
        0
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -11
      ],
      [
        -2,
        -9
      ],
      [
        -3,
        -8
      ],
      [
        -2,
        1
      ],
      [
        -2,
        -3
      ],
      [
        0,
        -11
      ],
      [
        1,
        -5
      ],
      [
        1,
        -13
      ],
      [
        1,
        -6
      ],
      [
        0,
        -31
      ],
      [
        -1,
        -7
      ],
      [
        -2,
        -15
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -7
      ],
      [
        -2,
        -4
      ],
      [
        0,
        -6
      ],
      [
        2,
        -20
      ],
      [
        2,
        -7
      ],
      [
        3,
        -9
      ],
      [
        2,
        -3
      ],
      [
        1,
        -3
      ],
      [
        3,
        -9
      ],
      [
        0,
        -1
      ],
      [
        2,
        -11
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -2
      ],
      [
        -3,
        -18
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -6
      ]
    ],
    [
      [
        17253,
        68510
      ],
      [
        -74,
        -2
      ],
      [
        0,
        102
      ],
      [
        -6,
        0
      ],
      [
        0,
        16
      ],
      [
        -6,
        0
      ],
      [
        0,
        17
      ],
      [
        -11,
        0
      ],
      [
        0,
        17
      ],
      [
        -6,
        0
      ],
      [
        0,
        16
      ],
      [
        -106,
        0
      ],
      [
        0,
        -17
      ],
      [
        -11,
        0
      ],
      [
        0,
        -17
      ],
      [
        -6,
        0
      ],
      [
        0,
        -29
      ],
      [
        -5,
        0
      ],
      [
        0,
        -21
      ],
      [
        -6,
        0
      ],
      [
        0,
        -17
      ],
      [
        -4,
        0
      ],
      [
        -2,
        -33
      ],
      [
        -5,
        0
      ],
      [
        0,
        -17
      ],
      [
        -6,
        0
      ],
      [
        0,
        -17
      ],
      [
        -5,
        0
      ],
      [
        -1,
        -34
      ],
      [
        -11,
        0
      ],
      [
        0,
        -17
      ],
      [
        -11,
        0
      ]
    ],
    [
      [
        25496,
        56876
      ],
      [
        29,
        -3
      ]
    ],
    [
      [
        25525,
        56873
      ],
      [
        9,
        0
      ],
      [
        108,
        -6
      ]
    ],
    [
      [
        25642,
        56867
      ],
      [
        0,
        -358
      ],
      [
        -11,
        1
      ]
    ],
    [
      [
        25631,
        56510
      ],
      [
        -5,
        14
      ],
      [
        -6,
        -2
      ],
      [
        -3,
        -21
      ],
      [
        -5,
        10
      ],
      [
        -13,
        1
      ],
      [
        -65,
        2
      ],
      [
        -38,
        7
      ]
    ],
    [
      [
        25496,
        56521
      ],
      [
        0,
        355
      ]
    ],
    [
      [
        24532,
        61412
      ],
      [
        56,
        1
      ],
      [
        32,
        -1
      ]
    ],
    [
      [
        24620,
        61412
      ],
      [
        27,
        -118
      ],
      [
        -1,
        -19
      ],
      [
        13,
        -11
      ]
    ],
    [
      [
        24659,
        61264
      ],
      [
        -1,
        -148
      ],
      [
        0,
        -16
      ],
      [
        -1,
        -234
      ]
    ],
    [
      [
        24657,
        60866
      ],
      [
        -29,
        3
      ],
      [
        -3,
        1
      ],
      [
        -6,
        -2
      ],
      [
        -26,
        -3
      ],
      [
        -20,
        5
      ],
      [
        -42,
        2
      ]
    ],
    [
      [
        24531,
        60872
      ],
      [
        1,
        152
      ],
      [
        0,
        388
      ]
    ],
    [
      [
        31501,
        37932
      ],
      [
        7,
        8
      ],
      [
        3,
        -12
      ],
      [
        -1,
        -24
      ],
      [
        8,
        -36
      ]
    ],
    [
      [
        31518,
        37868
      ],
      [
        -1,
        -3
      ],
      [
        -6,
        -24
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        6
      ],
      [
        -3,
        8
      ]
    ],
    [
      [
        31504,
        37854
      ],
      [
        0,
        32
      ],
      [
        -7,
        33
      ],
      [
        4,
        13
      ]
    ],
    [
      [
        25526,
        64058
      ],
      [
        0,
        16
      ]
    ],
    [
      [
        25526,
        64074
      ],
      [
        0,
        286
      ]
    ],
    [
      [
        25526,
        64360
      ],
      [
        72,
        0
      ]
    ],
    [
      [
        25598,
        64360
      ],
      [
        47,
        0
      ]
    ],
    [
      [
        25645,
        64360
      ],
      [
        1,
        -5
      ],
      [
        0,
        -197
      ]
    ],
    [
      [
        25646,
        64158
      ],
      [
        1,
        -102
      ]
    ],
    [
      [
        25647,
        64056
      ],
      [
        -121,
        2
      ]
    ],
    [
      [
        16741,
        55926
      ],
      [
        8,
        7
      ],
      [
        3,
        -18
      ],
      [
        -2,
        -23
      ],
      [
        -7,
        -7
      ],
      [
        -4,
        14
      ],
      [
        2,
        27
      ]
    ],
    [
      [
        16501,
        56608
      ],
      [
        2,
        0
      ],
      [
        6,
        -5
      ],
      [
        10,
        -2
      ],
      [
        8,
        -13
      ],
      [
        2,
        -8
      ],
      [
        3,
        -1
      ],
      [
        5,
        6
      ],
      [
        6,
        -3
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        2,
        -1
      ],
      [
        4,
        -8
      ],
      [
        4,
        -2
      ],
      [
        4,
        -5
      ],
      [
        2,
        -7
      ],
      [
        5,
        -21
      ],
      [
        14,
        -7
      ],
      [
        5,
        3
      ],
      [
        2,
        6
      ],
      [
        2,
        12
      ],
      [
        -1,
        4
      ],
      [
        0,
        3
      ],
      [
        4,
        14
      ],
      [
        6,
        1
      ],
      [
        2,
        3
      ],
      [
        10,
        -14
      ],
      [
        2,
        -8
      ],
      [
        0,
        -2
      ],
      [
        -3,
        -9
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -13
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -9
      ],
      [
        -2,
        -3
      ],
      [
        -4,
        1
      ],
      [
        -4,
        -8
      ],
      [
        -2,
        -1
      ],
      [
        -6,
        -2
      ],
      [
        -1,
        2
      ],
      [
        -7,
        -1
      ],
      [
        -4,
        -2
      ],
      [
        -8,
        -16
      ],
      [
        -5,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -2
      ],
      [
        -6,
        5
      ],
      [
        -2,
        0
      ],
      [
        -2,
        -5
      ],
      [
        -10,
        4
      ],
      [
        -13,
        9
      ],
      [
        -9,
        11
      ],
      [
        -1,
        7
      ],
      [
        -2,
        17
      ],
      [
        0,
        10
      ],
      [
        1,
        3
      ],
      [
        1,
        14
      ],
      [
        0,
        10
      ],
      [
        -4,
        15
      ],
      [
        -7,
        15
      ],
      [
        -2,
        13
      ],
      [
        1,
        9
      ]
    ],
    [
      [
        16410,
        56520
      ],
      [
        2,
        7
      ],
      [
        3,
        3
      ],
      [
        2,
        0
      ],
      [
        4,
        -5
      ],
      [
        3,
        -2
      ],
      [
        8,
        5
      ],
      [
        5,
        11
      ],
      [
        1,
        8
      ],
      [
        2,
        1
      ],
      [
        1,
        1
      ],
      [
        6,
        -8
      ],
      [
        7,
        0
      ],
      [
        4,
        6
      ],
      [
        3,
        8
      ],
      [
        1,
        3
      ],
      [
        1,
        4
      ],
      [
        4,
        -2
      ],
      [
        0,
        -13
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -4
      ],
      [
        1,
        -12
      ],
      [
        1,
        -6
      ],
      [
        5,
        -11
      ],
      [
        4,
        -6
      ],
      [
        2,
        -1
      ],
      [
        5,
        6
      ],
      [
        2,
        -1
      ],
      [
        -1,
        -16
      ],
      [
        1,
        -15
      ],
      [
        2,
        -7
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -2
      ],
      [
        -7,
        -1
      ],
      [
        -5,
        -6
      ],
      [
        -8,
        -19
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        -8,
        -7
      ],
      [
        -6,
        -1
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        -3,
        -4
      ],
      [
        -13,
        27
      ],
      [
        -3,
        10
      ],
      [
        -3,
        23
      ],
      [
        -1,
        3
      ],
      [
        -2,
        3
      ],
      [
        0,
        5
      ],
      [
        -3,
        18
      ],
      [
        -4,
        20
      ],
      [
        -6,
        11
      ],
      [
        0,
        3
      ]
    ],
    [
      [
        16354,
        56562
      ],
      [
        4,
        5
      ],
      [
        4,
        12
      ],
      [
        1,
        3
      ],
      [
        1,
        -2
      ],
      [
        2,
        -3
      ],
      [
        2,
        0
      ],
      [
        2,
        2
      ],
      [
        5,
        12
      ],
      [
        1,
        6
      ],
      [
        0,
        10
      ],
      [
        2,
        -4
      ],
      [
        2,
        -16
      ],
      [
        -2,
        -4
      ],
      [
        1,
        -6
      ],
      [
        3,
        -5
      ],
      [
        5,
        3
      ],
      [
        3,
        -8
      ],
      [
        2,
        -6
      ],
      [
        3,
        -15
      ],
      [
        -1,
        -3
      ],
      [
        -4,
        -3
      ],
      [
        -8,
        2
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -5,
        4
      ],
      [
        -9,
        16
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -4
      ],
      [
        -8,
        3
      ],
      [
        2,
        11
      ]
    ],
    [
      [
        16298,
        57653
      ],
      [
        1,
        -3
      ],
      [
        1,
        -7
      ],
      [
        3,
        -4
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        6,
        10
      ],
      [
        0,
        -1
      ],
      [
        2,
        -6
      ],
      [
        1,
        1
      ],
      [
        2,
        3
      ],
      [
        2,
        7
      ],
      [
        3,
        2
      ],
      [
        2,
        -2
      ],
      [
        1,
        -2
      ],
      [
        1,
        1
      ],
      [
        1,
        4
      ],
      [
        1,
        1
      ],
      [
        3,
        6
      ],
      [
        9,
        9
      ],
      [
        6,
        0
      ],
      [
        7,
        -3
      ],
      [
        2,
        -1
      ],
      [
        1,
        0
      ],
      [
        2,
        -1
      ],
      [
        1,
        -1
      ],
      [
        2,
        -5
      ],
      [
        1,
        -4
      ],
      [
        3,
        -5
      ],
      [
        2,
        -5
      ],
      [
        1,
        -1
      ],
      [
        7,
        -17
      ],
      [
        6,
        -17
      ],
      [
        1,
        -2
      ],
      [
        1,
        -3
      ],
      [
        2,
        -3
      ],
      [
        2,
        -4
      ],
      [
        2,
        -6
      ],
      [
        0,
        -7
      ],
      [
        2,
        -8
      ],
      [
        0,
        -6
      ],
      [
        1,
        -2
      ],
      [
        2,
        -1
      ],
      [
        1,
        2
      ],
      [
        1,
        0
      ],
      [
        0,
        2
      ],
      [
        1,
        3
      ],
      [
        0,
        13
      ],
      [
        1,
        15
      ],
      [
        0,
        14
      ],
      [
        -1,
        5
      ],
      [
        -2,
        4
      ],
      [
        0,
        4
      ],
      [
        1,
        5
      ],
      [
        -1,
        7
      ],
      [
        -3,
        11
      ],
      [
        0,
        8
      ],
      [
        -2,
        2
      ],
      [
        -1,
        2
      ],
      [
        -1,
        5
      ],
      [
        -2,
        13
      ],
      [
        2,
        8
      ],
      [
        1,
        7
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        0,
        -1
      ],
      [
        3,
        -6
      ],
      [
        5,
        4
      ],
      [
        4,
        -3
      ],
      [
        3,
        10
      ],
      [
        1,
        4
      ],
      [
        1,
        2
      ]
    ],
    [
      [
        16406,
        57712
      ],
      [
        0,
        0
      ]
    ],
    [
      [
        16406,
        57712
      ],
      [
        0,
        -5
      ],
      [
        1,
        -3
      ],
      [
        0,
        1
      ],
      [
        1,
        4
      ],
      [
        0,
        4
      ],
      [
        1,
        3
      ],
      [
        0,
        1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -5
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        0,
        -3
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        1,
        2
      ],
      [
        1,
        -2
      ],
      [
        0,
        3
      ],
      [
        1,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        4
      ],
      [
        1,
        2
      ],
      [
        3,
        0
      ],
      [
        0,
        3
      ],
      [
        1,
        4
      ],
      [
        1,
        2
      ],
      [
        0,
        9
      ],
      [
        -1,
        4
      ],
      [
        1,
        5
      ],
      [
        1,
        3
      ],
      [
        0,
        7
      ],
      [
        1,
        2
      ],
      [
        1,
        2
      ],
      [
        0,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        3
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        0,
        1
      ],
      [
        1,
        1
      ],
      [
        0,
        4
      ],
      [
        1,
        -1
      ],
      [
        0,
        4
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        1,
        0
      ],
      [
        1,
        2
      ],
      [
        0,
        1
      ],
      [
        -1,
        2
      ],
      [
        0,
        -1
      ],
      [
        -1,
        1
      ],
      [
        0,
        3
      ],
      [
        1,
        0
      ],
      [
        0,
        7
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        -2
      ],
      [
        0,
        1
      ],
      [
        1,
        -1
      ]
    ],
    [
      [
        16443,
        57793
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        0,
        1
      ],
      [
        1,
        1
      ],
      [
        -1,
        3
      ]
    ],
    [
      [
        16443,
        57793
      ],
      [
        1,
        3
      ],
      [
        0,
        2
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        1,
        1
      ],
      [
        0,
        7
      ],
      [
        1,
        2
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        1,
        2
      ],
      [
        0,
        4
      ],
      [
        1,
        -1
      ],
      [
        0,
        4
      ],
      [
        1,
        2
      ],
      [
        0,
        -3
      ],
      [
        1,
        -1
      ],
      [
        0,
        4
      ],
      [
        1,
        1
      ],
      [
        2,
        -1
      ],
      [
        1,
        2
      ],
      [
        0,
        -6
      ],
      [
        -1,
        0
      ],
      [
        0,
        -3
      ],
      [
        1,
        -1
      ],
      [
        2,
        -2
      ],
      [
        1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        1,
        -4
      ],
      [
        2,
        -5
      ],
      [
        0,
        -1
      ],
      [
        5,
        -8
      ],
      [
        1,
        3
      ],
      [
        4,
        -8
      ],
      [
        1,
        -2
      ],
      [
        1,
        2
      ],
      [
        1,
        -5
      ],
      [
        0,
        -3
      ],
      [
        4,
        -4
      ],
      [
        1,
        -5
      ],
      [
        3,
        -6
      ],
      [
        0,
        -1
      ],
      [
        2,
        -3
      ],
      [
        2,
        -3
      ],
      [
        3,
        -1
      ],
      [
        1,
        2
      ],
      [
        0,
        -1
      ],
      [
        3,
        0
      ],
      [
        1,
        -1
      ],
      [
        2,
        0
      ],
      [
        1,
        3
      ],
      [
        1,
        1
      ],
      [
        2,
        -8
      ],
      [
        2,
        -4
      ],
      [
        0,
        -2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -6
      ],
      [
        1,
        -2
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        2,
        2
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        2,
        -2
      ],
      [
        1,
        -3
      ],
      [
        3,
        -3
      ],
      [
        2,
        -2
      ],
      [
        2,
        -6
      ],
      [
        1,
        -6
      ],
      [
        0,
        -4
      ],
      [
        1,
        -3
      ],
      [
        3,
        -9
      ],
      [
        2,
        -3
      ],
      [
        2,
        -4
      ],
      [
        2,
        1
      ],
      [
        1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        2,
        -7
      ],
      [
        1,
        -2
      ],
      [
        2,
        1
      ],
      [
        5,
        -8
      ],
      [
        3,
        -4
      ],
      [
        2,
        -6
      ],
      [
        5,
        0
      ],
      [
        1,
        -1
      ],
      [
        3,
        -2
      ],
      [
        1,
        2
      ],
      [
        1,
        2
      ],
      [
        3,
        0
      ],
      [
        5,
        -5
      ],
      [
        2,
        2
      ],
      [
        1,
        -2
      ],
      [
        4,
        -12
      ],
      [
        3,
        -7
      ],
      [
        2,
        -2
      ],
      [
        1,
        0
      ],
      [
        1,
        -3
      ],
      [
        2,
        -2
      ],
      [
        2,
        2
      ],
      [
        2,
        -6
      ],
      [
        3,
        -8
      ],
      [
        2,
        -6
      ],
      [
        1,
        -5
      ],
      [
        1,
        -6
      ],
      [
        3,
        -6
      ],
      [
        3,
        -6
      ],
      [
        4,
        -9
      ],
      [
        1,
        -4
      ],
      [
        2,
        -5
      ],
      [
        0,
        -1
      ],
      [
        13,
        0
      ],
      [
        5,
        4
      ]
    ],
    [
      [
        16626,
        57567
      ],
      [
        8,
        0
      ]
    ],
    [
      [
        16634,
        57567
      ],
      [
        0,
        -509
      ],
      [
        1,
        -25
      ],
      [
        -4,
        -28
      ],
      [
        2,
        -16
      ],
      [
        -9,
        -32
      ]
    ],
    [
      [
        16624,
        56957
      ],
      [
        -9,
        11
      ],
      [
        -7,
        11
      ],
      [
        -6,
        20
      ],
      [
        -16,
        9
      ],
      [
        -7,
        -6
      ],
      [
        -2,
        2
      ],
      [
        -7,
        -1
      ],
      [
        -4,
        -5
      ],
      [
        1,
        -4
      ],
      [
        -2,
        -6
      ],
      [
        -5,
        -9
      ],
      [
        -6,
        0
      ],
      [
        -4,
        8
      ],
      [
        -12,
        15
      ],
      [
        -2,
        2
      ],
      [
        -11,
        -2
      ],
      [
        -5,
        -9
      ],
      [
        -6,
        1
      ],
      [
        -14,
        29
      ],
      [
        -9,
        2
      ],
      [
        -4,
        11
      ],
      [
        -10,
        18
      ],
      [
        -9,
        4
      ],
      [
        -3,
        -2
      ],
      [
        -11,
        -2
      ],
      [
        -2,
        2
      ],
      [
        -6,
        9
      ],
      [
        -7,
        4
      ],
      [
        -11,
        -3
      ],
      [
        -12,
        0
      ],
      [
        -3,
        -3
      ],
      [
        -6,
        -1
      ],
      [
        -7,
        1
      ],
      [
        -3,
        3
      ],
      [
        -2,
        -1
      ],
      [
        0,
        -3
      ],
      [
        -11,
        -10
      ],
      [
        -28,
        -8
      ],
      [
        -3,
        -5
      ],
      [
        -6,
        1
      ],
      [
        -1,
        31
      ],
      [
        -1,
        7
      ],
      [
        -3,
        11
      ],
      [
        -4,
        25
      ],
      [
        -2,
        13
      ],
      [
        -3,
        10
      ],
      [
        -16,
        30
      ],
      [
        -8,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        0
      ],
      [
        -4,
        14
      ],
      [
        -2,
        18
      ],
      [
        1,
        27
      ],
      [
        5,
        35
      ],
      [
        6,
        67
      ],
      [
        1,
        14
      ],
      [
        -1,
        6
      ],
      [
        -3,
        25
      ],
      [
        -4,
        8
      ],
      [
        -3,
        21
      ],
      [
        4,
        44
      ],
      [
        2,
        26
      ],
      [
        2,
        31
      ],
      [
        0,
        18
      ],
      [
        -2,
        10
      ],
      [
        -6,
        16
      ],
      [
        -1,
        16
      ],
      [
        -2,
        8
      ],
      [
        -4,
        0
      ],
      [
        -2,
        4
      ],
      [
        6,
        82
      ]
    ],
    [
      [
        15529,
        64876
      ],
      [
        2,
        -7
      ],
      [
        4,
        -17
      ],
      [
        5,
        -4
      ],
      [
        3,
        7
      ],
      [
        6,
        -7
      ],
      [
        3,
        -12
      ],
      [
        8,
        -5
      ],
      [
        4,
        -16
      ],
      [
        4,
        -16
      ],
      [
        3,
        -25
      ],
      [
        4,
        -17
      ],
      [
        9,
        -5
      ],
      [
        7,
        5
      ],
      [
        8,
        -2
      ],
      [
        9,
        1
      ],
      [
        5,
        -7
      ],
      [
        2,
        -9
      ],
      [
        4,
        -6
      ],
      [
        5,
        -5
      ],
      [
        3,
        -8
      ],
      [
        2,
        -8
      ],
      [
        1,
        -11
      ],
      [
        0,
        -7
      ],
      [
        1,
        -10
      ],
      [
        1,
        -8
      ],
      [
        2,
        -5
      ],
      [
        1,
        0
      ],
      [
        5,
        4
      ],
      [
        4,
        6
      ],
      [
        7,
        -1
      ],
      [
        6,
        -14
      ],
      [
        4,
        -9
      ],
      [
        5,
        4
      ],
      [
        2,
        15
      ],
      [
        3,
        20
      ],
      [
        -3,
        23
      ],
      [
        -3,
        23
      ],
      [
        -6,
        6
      ],
      [
        -7,
        19
      ],
      [
        -1,
        20
      ],
      [
        3,
        25
      ],
      [
        -1,
        13
      ],
      [
        1,
        7
      ],
      [
        2,
        10
      ],
      [
        -1,
        10
      ],
      [
        0,
        11
      ],
      [
        -1,
        7
      ],
      [
        0,
        7
      ],
      [
        1,
        1
      ],
      [
        3,
        1
      ],
      [
        1,
        -4
      ],
      [
        2,
        -2
      ],
      [
        2,
        5
      ],
      [
        2,
        6
      ],
      [
        3,
        3
      ],
      [
        2,
        8
      ],
      [
        3,
        7
      ],
      [
        3,
        1
      ],
      [
        4,
        0
      ],
      [
        10,
        6
      ],
      [
        9,
        -1
      ],
      [
        6,
        24
      ],
      [
        7,
        15
      ],
      [
        4,
        3
      ],
      [
        3,
        10
      ],
      [
        1,
        11
      ],
      [
        7,
        16
      ],
      [
        3,
        6
      ],
      [
        7,
        12
      ],
      [
        4,
        13
      ],
      [
        0,
        18
      ],
      [
        7,
        13
      ],
      [
        4,
        -1
      ],
      [
        3,
        -3
      ],
      [
        3,
        9
      ],
      [
        0,
        16
      ],
      [
        1,
        15
      ],
      [
        5,
        6
      ],
      [
        4,
        -4
      ],
      [
        3,
        -19
      ],
      [
        8,
        -2
      ],
      [
        5,
        -18
      ],
      [
        2,
        -5
      ],
      [
        0,
        -9
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -11
      ],
      [
        1,
        -9
      ],
      [
        -4,
        -20
      ],
      [
        1,
        -32
      ],
      [
        -2,
        -21
      ],
      [
        0,
        -32
      ],
      [
        5,
        -21
      ],
      [
        0,
        -5
      ]
    ],
    [
      [
        15661,
        63477
      ],
      [
        -170,
        -1
      ],
      [
        0,
        29
      ]
    ],
    [
      [
        15491,
        63505
      ],
      [
        0,
        805
      ],
      [
        1,
        47
      ],
      [
        -1,
        7
      ],
      [
        -1,
        12
      ],
      [
        -1,
        8
      ],
      [
        1,
        10
      ],
      [
        0,
        10
      ],
      [
        -2,
        16
      ],
      [
        -1,
        3
      ],
      [
        0,
        5
      ],
      [
        1,
        0
      ],
      [
        0,
        9
      ],
      [
        -1,
        9
      ],
      [
        -2,
        14
      ],
      [
        0,
        16
      ],
      [
        -2,
        11
      ],
      [
        0,
        13
      ],
      [
        -3,
        5
      ],
      [
        -1,
        9
      ],
      [
        -3,
        10
      ],
      [
        0,
        3
      ],
      [
        -1,
        11
      ],
      [
        -1,
        5
      ],
      [
        0,
        14
      ],
      [
        -2,
        8
      ],
      [
        -1,
        13
      ],
      [
        -1,
        4
      ],
      [
        1,
        5
      ],
      [
        2,
        -3
      ],
      [
        6,
        -1
      ],
      [
        1,
        4
      ],
      [
        4,
        6
      ],
      [
        1,
        7
      ],
      [
        1,
        7
      ],
      [
        2,
        -1
      ],
      [
        4,
        -15
      ],
      [
        3,
        -2
      ],
      [
        3,
        -7
      ],
      [
        7,
        -13
      ],
      [
        3,
        -1
      ],
      [
        1,
        4
      ],
      [
        1,
        14
      ],
      [
        3,
        8
      ],
      [
        2,
        4
      ],
      [
        3,
        2
      ],
      [
        1,
        11
      ],
      [
        -1,
        8
      ],
      [
        0,
        9
      ],
      [
        2,
        4
      ],
      [
        2,
        11
      ],
      [
        2,
        15
      ],
      [
        0,
        13
      ],
      [
        3,
        7
      ],
      [
        2,
        11
      ],
      [
        0,
        13
      ],
      [
        -3,
        9
      ],
      [
        -1,
        4
      ],
      [
        0,
        12
      ],
      [
        -1,
        11
      ],
      [
        -8,
        9
      ],
      [
        -1,
        14
      ],
      [
        1,
        11
      ],
      [
        1,
        -1
      ],
      [
        3,
        6
      ],
      [
        2,
        14
      ],
      [
        1,
        29
      ],
      [
        0,
        21
      ],
      [
        2,
        18
      ],
      [
        4,
        13
      ],
      [
        0,
        4
      ]
    ],
    [
      [
        24794,
        62944
      ],
      [
        64,
        2
      ]
    ],
    [
      [
        24858,
        62946
      ],
      [
        31,
        1
      ],
      [
        31,
        1
      ]
    ],
    [
      [
        24920,
        62948
      ],
      [
        1,
        -204
      ],
      [
        -1,
        -18
      ],
      [
        1,
        -389
      ]
    ],
    [
      [
        24921,
        62337
      ],
      [
        -117,
        0
      ],
      [
        -8,
        2
      ]
    ],
    [
      [
        24796,
        62339
      ],
      [
        0,
        304
      ]
    ],
    [
      [
        24796,
        62643
      ],
      [
        -2,
        301
      ]
    ],
    [
      [
        26462,
        67657
      ],
      [
        33,
        -2
      ],
      [
        -1,
        -50
      ],
      [
        38,
        -2
      ],
      [
        28,
        0
      ],
      [
        -1,
        -51
      ],
      [
        34,
        0
      ]
    ],
    [
      [
        26593,
        67552
      ],
      [
        0,
        -100
      ],
      [
        1,
        -78
      ],
      [
        -1,
        -121
      ]
    ],
    [
      [
        26593,
        67253
      ],
      [
        -33,
        -1
      ],
      [
        -32,
        -1
      ],
      [
        0,
        -102
      ]
    ],
    [
      [
        26528,
        67149
      ],
      [
        -122,
        -5
      ]
    ],
    [
      [
        22623,
        54462
      ],
      [
        2,
        -14
      ],
      [
        21,
        -156
      ]
    ],
    [
      [
        22646,
        54292
      ],
      [
        -39,
        -81
      ]
    ],
    [
      [
        22550,
        54094
      ],
      [
        -12,
        73
      ],
      [
        -5,
        -12
      ],
      [
        -16,
        -33
      ],
      [
        -62,
        372
      ]
    ],
    [
      [
        26877,
        50038
      ],
      [
        11,
        1
      ],
      [
        52,
        0
      ],
      [
        55,
        1
      ],
      [
        1,
        51
      ],
      [
        55,
        0
      ]
    ],
    [
      [
        27051,
        50091
      ],
      [
        -1,
        -155
      ],
      [
        0,
        -38
      ]
    ],
    [
      [
        27050,
        49898
      ],
      [
        0,
        -63
      ],
      [
        -14,
        1
      ],
      [
        0,
        -102
      ]
    ],
    [
      [
        27036,
        49734
      ],
      [
        -5,
        0
      ],
      [
        -38,
        -1
      ],
      [
        -42,
        0
      ],
      [
        -14,
        1
      ],
      [
        -3,
        0
      ],
      [
        -50,
        2
      ]
    ],
    [
      [
        26884,
        49736
      ],
      [
        -13,
        0
      ],
      [
        -29,
        -2
      ]
    ],
    [
      [
        26842,
        49734
      ],
      [
        2,
        18
      ],
      [
        9,
        37
      ],
      [
        0,
        29
      ],
      [
        1,
        12
      ],
      [
        4,
        8
      ],
      [
        4,
        36
      ],
      [
        -1,
        10
      ],
      [
        1,
        28
      ],
      [
        4,
        20
      ],
      [
        0,
        4
      ],
      [
        3,
        26
      ],
      [
        0,
        39
      ],
      [
        3,
        22
      ],
      [
        3,
        9
      ],
      [
        2,
        6
      ]
    ],
    [
      [
        26835,
        49734
      ],
      [
        -9,
        0
      ]
    ],
    [
      [
        26826,
        49734
      ],
      [
        0,
        53
      ],
      [
        4,
        13
      ],
      [
        5,
        -12
      ],
      [
        0,
        -54
      ]
    ],
    [
      [
        27500,
        59487
      ],
      [
        3,
        0
      ],
      [
        38,
        -7
      ],
      [
        18,
        -1
      ],
      [
        17,
        0
      ],
      [
        13,
        -1
      ],
      [
        19,
        0
      ]
    ],
    [
      [
        27608,
        59478
      ],
      [
        7,
        0
      ]
    ],
    [
      [
        27613,
        59146
      ],
      [
        -116,
        5
      ]
    ],
    [
      [
        27497,
        59151
      ],
      [
        3,
        336
      ]
    ],
    [
      [
        17467,
        68335
      ],
      [
        26,
        0
      ],
      [
        2,
        19
      ],
      [
        -1,
        46
      ],
      [
        4,
        12
      ],
      [
        -3,
        24
      ],
      [
        3,
        45
      ],
      [
        -3,
        13
      ],
      [
        3,
        27
      ],
      [
        -2,
        13
      ],
      [
        6,
        41
      ],
      [
        -2,
        22
      ],
      [
        3,
        12
      ],
      [
        1,
        40
      ],
      [
        3,
        3
      ],
      [
        3,
        24
      ]
    ],
    [
      [
        17510,
        68676
      ],
      [
        12,
        26
      ],
      [
        5,
        -2
      ],
      [
        1,
        19
      ],
      [
        6,
        35
      ],
      [
        5,
        -20
      ],
      [
        11,
        6
      ]
    ],
    [
      [
        17534,
        68335
      ],
      [
        -17,
        0
      ],
      [
        -2,
        -400
      ]
    ],
    [
      [
        17515,
        67935
      ],
      [
        -65,
        -1
      ]
    ],
    [
      [
        17450,
        67934
      ],
      [
        -55,
        0
      ]
    ],
    [
      [
        17395,
        67934
      ],
      [
        0,
        203
      ],
      [
        39,
        -1
      ],
      [
        0,
        34
      ],
      [
        11,
        -1
      ],
      [
        0,
        67
      ],
      [
        22,
        -1
      ],
      [
        0,
        100
      ]
    ],
    [
      [
        27335,
        62350
      ],
      [
        9,
        0
      ],
      [
        10,
        30
      ],
      [
        15,
        12
      ],
      [
        9,
        31
      ],
      [
        6,
        2
      ],
      [
        1,
        11
      ],
      [
        5,
        -2
      ],
      [
        7,
        20
      ],
      [
        0,
        12
      ]
    ],
    [
      [
        27397,
        62466
      ],
      [
        23,
        -16
      ]
    ],
    [
      [
        27420,
        62450
      ],
      [
        3,
        -102
      ],
      [
        7,
        -25
      ],
      [
        24,
        -96
      ]
    ],
    [
      [
        27454,
        62227
      ],
      [
        -10,
        -23
      ],
      [
        -8,
        10
      ],
      [
        -24,
        -54
      ],
      [
        -20,
        -49
      ],
      [
        -43,
        -101
      ]
    ],
    [
      [
        27349,
        62010
      ],
      [
        -4,
        34
      ],
      [
        -7,
        21
      ],
      [
        -8,
        17
      ],
      [
        -1,
        16
      ],
      [
        6,
        13
      ],
      [
        6,
        21
      ],
      [
        0,
        21
      ],
      [
        3,
        6
      ],
      [
        -2,
        64
      ],
      [
        -1,
        26
      ],
      [
        3,
        11
      ],
      [
        -3,
        29
      ],
      [
        2,
        4
      ],
      [
        -9,
        37
      ],
      [
        1,
        20
      ]
    ],
    [
      [
        22511,
        60008
      ],
      [
        66,
        0
      ]
    ],
    [
      [
        22577,
        60008
      ],
      [
        0,
        -57
      ],
      [
        1,
        -412
      ],
      [
        1,
        -2
      ]
    ],
    [
      [
        22579,
        59537
      ],
      [
        0,
        -152
      ]
    ],
    [
      [
        22579,
        59385
      ],
      [
        -120,
        1
      ]
    ],
    [
      [
        22459,
        59386
      ],
      [
        1,
        152
      ],
      [
        -2,
        405
      ],
      [
        -2,
        66
      ]
    ],
    [
      [
        22784,
        63505
      ],
      [
        5,
        0
      ],
      [
        29,
        -1
      ],
      [
        29,
        0
      ],
      [
        1,
        1
      ],
      [
        25,
        -1
      ],
      [
        37,
        0
      ]
    ],
    [
      [
        22910,
        63504
      ],
      [
        31,
        0
      ]
    ],
    [
      [
        22941,
        63504
      ],
      [
        0,
        -506
      ]
    ],
    [
      [
        22941,
        62998
      ],
      [
        -43,
        0
      ]
    ],
    [
      [
        22898,
        62998
      ],
      [
        -114,
        1
      ]
    ],
    [
      [
        22784,
        63100
      ],
      [
        0,
        405
      ]
    ],
    [
      [
        27074,
        54503
      ],
      [
        5,
        -2
      ],
      [
        10,
        9
      ],
      [
        7,
        0
      ],
      [
        10,
        -20
      ],
      [
        4,
        -19
      ],
      [
        7,
        -4
      ],
      [
        3,
        -20
      ],
      [
        1,
        -28
      ],
      [
        3,
        -4
      ],
      [
        4,
        -36
      ],
      [
        -1,
        -11
      ]
    ],
    [
      [
        27127,
        54368
      ],
      [
        1,
        -24
      ],
      [
        4,
        -17
      ],
      [
        2,
        -15
      ],
      [
        4,
        0
      ],
      [
        6,
        -18
      ]
    ],
    [
      [
        27144,
        54294
      ],
      [
        -12,
        -48
      ]
    ],
    [
      [
        27132,
        54246
      ],
      [
        -35,
        3
      ],
      [
        -26,
        36
      ],
      [
        -12,
        230
      ]
    ],
    [
      [
        27059,
        54515
      ],
      [
        7,
        -3
      ],
      [
        8,
        -9
      ]
    ],
    [
      [
        26070,
        63439
      ],
      [
        -1,
        52
      ],
      [
        0,
        67
      ],
      [
        1,
        34
      ]
    ],
    [
      [
        26070,
        63592
      ],
      [
        100,
        0
      ]
    ],
    [
      [
        26170,
        63592
      ],
      [
        1,
        -84
      ],
      [
        3,
        0
      ]
    ],
    [
      [
        26168,
        63256
      ],
      [
        -22,
        -1
      ]
    ],
    [
      [
        26146,
        63255
      ],
      [
        -30,
        0
      ],
      [
        -52,
        -1
      ]
    ],
    [
      [
        26064,
        63254
      ],
      [
        0,
        101
      ],
      [
        5,
        0
      ],
      [
        1,
        84
      ]
    ],
    [
      [
        27211,
        57475
      ],
      [
        41,
        0
      ],
      [
        43,
        -1
      ],
      [
        78,
        0
      ]
    ],
    [
      [
        27373,
        57474
      ],
      [
        6,
        -38
      ],
      [
        -1,
        -34
      ],
      [
        4,
        -62
      ],
      [
        1,
        -12
      ],
      [
        -7,
        -31
      ],
      [
        -3,
        -43
      ],
      [
        2,
        -41
      ],
      [
        2,
        -14
      ],
      [
        3,
        -37
      ],
      [
        -1,
        -11
      ]
    ],
    [
      [
        27379,
        57151
      ],
      [
        -35,
        5
      ],
      [
        -16,
        6
      ],
      [
        -52,
        13
      ],
      [
        -49,
        9
      ]
    ],
    [
      [
        27227,
        57184
      ],
      [
        2,
        72
      ],
      [
        -8,
        23
      ],
      [
        -3,
        25
      ],
      [
        0,
        22
      ],
      [
        -1,
        35
      ],
      [
        -6,
        0
      ],
      [
        -1,
        24
      ],
      [
        8,
        19
      ],
      [
        0,
        24
      ],
      [
        -7,
        47
      ]
    ],
    [
      [
        17976,
        55859
      ],
      [
        1,
        16
      ],
      [
        0,
        11
      ],
      [
        3,
        16
      ],
      [
        1,
        5
      ],
      [
        2,
        8
      ],
      [
        0,
        3
      ],
      [
        1,
        7
      ],
      [
        2,
        11
      ],
      [
        1,
        3
      ],
      [
        2,
        5
      ],
      [
        2,
        1
      ],
      [
        1,
        2
      ],
      [
        2,
        9
      ],
      [
        0,
        9
      ],
      [
        1,
        7
      ],
      [
        0,
        1
      ],
      [
        4,
        13
      ],
      [
        5,
        11
      ],
      [
        0,
        6
      ],
      [
        -3,
        13
      ],
      [
        0,
        1
      ],
      [
        -1,
        13
      ],
      [
        0,
        13
      ],
      [
        3,
        17
      ],
      [
        1,
        3
      ],
      [
        0,
        9
      ],
      [
        -1,
        3
      ],
      [
        0,
        13
      ],
      [
        1,
        3
      ],
      [
        0,
        5
      ],
      [
        -1,
        5
      ],
      [
        0,
        13
      ],
      [
        1,
        3
      ],
      [
        0,
        10
      ],
      [
        -1,
        3
      ],
      [
        0,
        5
      ],
      [
        -1,
        5
      ],
      [
        1,
        5
      ],
      [
        0,
        4
      ],
      [
        1,
        4
      ],
      [
        2,
        3
      ],
      [
        2,
        3
      ],
      [
        2,
        2
      ],
      [
        2,
        4
      ],
      [
        0,
        2
      ],
      [
        1,
        11
      ],
      [
        0,
        8
      ],
      [
        -1,
        5
      ],
      [
        -1,
        4
      ],
      [
        -1,
        3
      ],
      [
        0,
        4
      ],
      [
        -1,
        3
      ],
      [
        -1,
        1
      ],
      [
        0,
        3
      ],
      [
        1,
        8
      ],
      [
        0,
        6
      ],
      [
        1,
        5
      ],
      [
        0,
        11
      ],
      [
        -1,
        9
      ],
      [
        -3,
        24
      ],
      [
        0,
        13
      ],
      [
        -3,
        18
      ],
      [
        1,
        1
      ],
      [
        1,
        4
      ],
      [
        0,
        3
      ],
      [
        1,
        4
      ],
      [
        -1,
        3
      ],
      [
        0,
        9
      ],
      [
        -1,
        3
      ],
      [
        -1,
        11
      ],
      [
        0,
        8
      ],
      [
        1,
        3
      ],
      [
        0,
        2
      ],
      [
        2,
        -1
      ],
      [
        1,
        1
      ],
      [
        3,
        6
      ],
      [
        0,
        15
      ],
      [
        -2,
        7
      ],
      [
        -1,
        3
      ],
      [
        -1,
        3
      ],
      [
        0,
        8
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        2
      ],
      [
        1,
        2
      ],
      [
        0,
        6
      ],
      [
        -1,
        6
      ],
      [
        -2,
        7
      ],
      [
        -2,
        6
      ],
      [
        -1,
        1
      ],
      [
        -1,
        3
      ],
      [
        -1,
        3
      ],
      [
        0,
        7
      ],
      [
        2,
        16
      ],
      [
        2,
        9
      ],
      [
        2,
        2
      ],
      [
        1,
        -1
      ],
      [
        0,
        1
      ],
      [
        3,
        5
      ],
      [
        2,
        6
      ],
      [
        2,
        10
      ],
      [
        1,
        2
      ],
      [
        0,
        4
      ],
      [
        2,
        4
      ],
      [
        1,
        4
      ],
      [
        1,
        6
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        0,
        12
      ],
      [
        -1,
        3
      ],
      [
        1,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        2
      ],
      [
        2,
        4
      ],
      [
        1,
        4
      ],
      [
        0,
        4
      ],
      [
        1,
        6
      ],
      [
        0,
        17
      ],
      [
        -1,
        9
      ],
      [
        0,
        9
      ],
      [
        1,
        16
      ],
      [
        0,
        9
      ]
    ],
    [
      [
        18336,
        56888
      ],
      [
        0,
        -371
      ]
    ],
    [
      [
        18336,
        56517
      ],
      [
        0,
        -723
      ]
    ],
    [
      [
        18336,
        55794
      ],
      [
        -174,
        0
      ],
      [
        0,
        101
      ],
      [
        -50,
        -1
      ],
      [
        -36,
        0
      ],
      [
        0,
        -505
      ],
      [
        -20,
        0
      ],
      [
        -9,
        -3
      ],
      [
        -40,
        0
      ]
    ],
    [
      [
        18007,
        55386
      ],
      [
        -1,
        3
      ],
      [
        -1,
        1
      ],
      [
        -5,
        3
      ],
      [
        -4,
        1
      ],
      [
        -5,
        3
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        -1
      ],
      [
        -5,
        2
      ],
      [
        -2,
        2
      ],
      [
        -1,
        2
      ],
      [
        -1,
        10
      ],
      [
        -2,
        7
      ],
      [
        0,
        2
      ],
      [
        -2,
        2
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -12
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        2
      ],
      [
        -1,
        4
      ],
      [
        -1,
        5
      ],
      [
        -1,
        7
      ],
      [
        1,
        11
      ],
      [
        -4,
        16
      ],
      [
        -1,
        6
      ],
      [
        0,
        3
      ],
      [
        1,
        5
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        -2,
        0
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        3
      ],
      [
        0,
        8
      ],
      [
        1,
        9
      ],
      [
        0,
        10
      ],
      [
        2,
        20
      ],
      [
        2,
        8
      ],
      [
        1,
        5
      ],
      [
        1,
        7
      ],
      [
        0,
        8
      ],
      [
        1,
        5
      ],
      [
        0,
        18
      ],
      [
        1,
        7
      ],
      [
        0,
        22
      ],
      [
        -1,
        4
      ],
      [
        1,
        9
      ],
      [
        1,
        9
      ],
      [
        0,
        8
      ],
      [
        -1,
        5
      ],
      [
        -2,
        6
      ],
      [
        -2,
        12
      ],
      [
        0,
        1
      ],
      [
        1,
        2
      ],
      [
        4,
        9
      ],
      [
        0,
        5
      ],
      [
        -1,
        12
      ],
      [
        -1,
        4
      ],
      [
        -1,
        2
      ],
      [
        -3,
        5
      ],
      [
        -2,
        2
      ],
      [
        -3,
        2
      ],
      [
        -2,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        -2,
        16
      ],
      [
        0,
        4
      ],
      [
        2,
        8
      ],
      [
        3,
        9
      ],
      [
        1,
        4
      ],
      [
        1,
        5
      ],
      [
        1,
        10
      ],
      [
        1,
        18
      ],
      [
        0,
        11
      ],
      [
        -3,
        18
      ],
      [
        0,
        8
      ],
      [
        -1,
        5
      ],
      [
        -3,
        12
      ],
      [
        -1,
        5
      ],
      [
        0,
        3
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        2,
        -1
      ],
      [
        3,
        2
      ],
      [
        1,
        3
      ],
      [
        0,
        3
      ],
      [
        1,
        1
      ],
      [
        2,
        4
      ],
      [
        4,
        0
      ],
      [
        4,
        -6
      ],
      [
        2,
        0
      ],
      [
        0,
        1
      ],
      [
        2,
        3
      ],
      [
        2,
        7
      ],
      [
        2,
        7
      ],
      [
        1,
        6
      ]
    ],
    [
      [
        21976,
        65931
      ],
      [
        28,
        0
      ]
    ],
    [
      [
        22004,
        65931
      ],
      [
        134,
        0
      ]
    ],
    [
      [
        22138,
        65931
      ],
      [
        0,
        -403
      ]
    ],
    [
      [
        21981,
        65528
      ],
      [
        -4,
        0
      ]
    ],
    [
      [
        17957,
        69552
      ],
      [
        5,
        43
      ],
      [
        15,
        48
      ],
      [
        4,
        7
      ],
      [
        4,
        19
      ],
      [
        -3,
        -2
      ],
      [
        -10,
        27
      ],
      [
        -8,
        28
      ],
      [
        -1,
        23
      ],
      [
        -6,
        7
      ],
      [
        -7,
        32
      ],
      [
        -4,
        -1
      ],
      [
        -7,
        20
      ],
      [
        -3,
        26
      ],
      [
        -7,
        2
      ],
      [
        1,
        35
      ],
      [
        -2,
        11
      ],
      [
        1,
        38
      ],
      [
        8,
        3
      ],
      [
        9,
        -25
      ],
      [
        8,
        3
      ],
      [
        7,
        -9
      ],
      [
        0,
        -12
      ],
      [
        5,
        -4
      ],
      [
        8,
        56
      ],
      [
        11,
        18
      ],
      [
        6,
        18
      ],
      [
        4,
        18
      ]
    ],
    [
      [
        18481,
        68598
      ],
      [
        0,
        -171
      ],
      [
        -35,
        4
      ],
      [
        -16,
        0
      ]
    ],
    [
      [
        18430,
        68431
      ],
      [
        -90,
        -1
      ]
    ],
    [
      [
        21988,
        61176
      ],
      [
        0,
        -102
      ]
    ],
    [
      [
        21991,
        60564
      ],
      [
        -122,
        -1
      ]
    ],
    [
      [
        21869,
        60563
      ],
      [
        0,
        305
      ]
    ],
    [
      [
        21869,
        60868
      ],
      [
        0,
        107
      ],
      [
        -3,
        0
      ],
      [
        0,
        202
      ],
      [
        61,
        -2
      ],
      [
        61,
        1
      ]
    ],
    [
      [
        24974,
        56143
      ],
      [
        0,
        -118
      ],
      [
        1,
        -136
      ],
      [
        24,
        1
      ],
      [
        10,
        0
      ]
    ],
    [
      [
        25009,
        55890
      ],
      [
        -5,
        -9
      ],
      [
        -6,
        -27
      ],
      [
        -7,
        12
      ],
      [
        -2,
        -8
      ],
      [
        0,
        -171
      ]
    ],
    [
      [
        24989,
        55687
      ],
      [
        -53,
        0
      ]
    ],
    [
      [
        24936,
        55687
      ],
      [
        0,
        136
      ],
      [
        -15,
        -1
      ],
      [
        -5,
        0
      ],
      [
        0,
        17
      ],
      [
        -19,
        0
      ],
      [
        -1,
        303
      ]
    ],
    [
      [
        23402,
        55241
      ],
      [
        120,
        2
      ]
    ],
    [
      [
        23522,
        55243
      ],
      [
        4,
        -14
      ],
      [
        0,
        -15
      ]
    ],
    [
      [
        23526,
        55214
      ],
      [
        2,
        -40
      ],
      [
        7,
        -12
      ],
      [
        -8,
        -17
      ],
      [
        0,
        -32
      ]
    ],
    [
      [
        23527,
        55113
      ],
      [
        0,
        -164
      ]
    ],
    [
      [
        23448,
        54816
      ],
      [
        -7,
        -25
      ],
      [
        -3,
        6
      ],
      [
        2,
        25
      ],
      [
        -7,
        -12
      ],
      [
        -2,
        8
      ],
      [
        -5,
        -2
      ],
      [
        -5,
        6
      ],
      [
        1,
        15
      ],
      [
        -4,
        2
      ],
      [
        -5,
        -8
      ],
      [
        -8,
        0
      ],
      [
        -2,
        22
      ],
      [
        -2,
        1
      ]
    ],
    [
      [
        23401,
        54854
      ],
      [
        0,
        106
      ],
      [
        1,
        281
      ]
    ],
    [
      [
        22443,
        52444
      ],
      [
        51,
        2
      ],
      [
        16,
        -18
      ]
    ],
    [
      [
        22510,
        52428
      ],
      [
        63,
        -70
      ]
    ],
    [
      [
        22573,
        52358
      ],
      [
        -13,
        -81
      ]
    ],
    [
      [
        22560,
        52277
      ],
      [
        -35,
        -371
      ]
    ],
    [
      [
        22525,
        51906
      ],
      [
        -32,
        -117
      ]
    ],
    [
      [
        22493,
        51789
      ],
      [
        -49,
        235
      ]
    ],
    [
      [
        22897,
        62493
      ],
      [
        1,
        0
      ],
      [
        -1,
        102
      ]
    ],
    [
      [
        22897,
        62595
      ],
      [
        32,
        -1
      ],
      [
        0,
        -93
      ],
      [
        5,
        0
      ],
      [
        -1,
        -23
      ],
      [
        -5,
        -22
      ],
      [
        0,
        -15
      ],
      [
        34,
        0
      ],
      [
        7,
        4
      ],
      [
        0,
        -21
      ],
      [
        7,
        0
      ],
      [
        45,
        -1
      ],
      [
        5,
        0
      ],
      [
        0,
        -34
      ]
    ],
    [
      [
        23026,
        62389
      ],
      [
        0,
        -202
      ]
    ],
    [
      [
        23026,
        62187
      ],
      [
        -109,
        0
      ]
    ],
    [
      [
        22917,
        62187
      ],
      [
        -10,
        1
      ],
      [
        0,
        126
      ],
      [
        -2,
        0
      ],
      [
        -8,
        -16
      ],
      [
        0,
        195
      ]
    ],
    [
      [
        26174,
        61979
      ],
      [
        3,
        -4
      ],
      [
        1,
        0
      ],
      [
        3,
        1
      ],
      [
        1,
        -1
      ],
      [
        5,
        5
      ],
      [
        2,
        4
      ],
      [
        2,
        4
      ],
      [
        2,
        4
      ],
      [
        3,
        10
      ],
      [
        4,
        12
      ],
      [
        0,
        1
      ],
      [
        1,
        4
      ],
      [
        1,
        2
      ],
      [
        5,
        10
      ],
      [
        2,
        4
      ],
      [
        1,
        3
      ],
      [
        3,
        4
      ],
      [
        4,
        7
      ],
      [
        2,
        5
      ],
      [
        4,
        8
      ]
    ],
    [
      [
        26223,
        62062
      ],
      [
        17,
        -96
      ],
      [
        8,
        -21
      ]
    ],
    [
      [
        26248,
        61945
      ],
      [
        0,
        -13
      ],
      [
        -10,
        -2
      ],
      [
        -1,
        -14
      ],
      [
        -11,
        -5
      ],
      [
        -3,
        -22
      ],
      [
        -10,
        -3
      ],
      [
        -4,
        -17
      ]
    ],
    [
      [
        26209,
        61869
      ],
      [
        -26,
        -13
      ]
    ],
    [
      [
        26183,
        61856
      ],
      [
        -12,
        -6
      ],
      [
        -1,
        25
      ],
      [
        -4,
        19
      ],
      [
        0,
        10
      ],
      [
        -28,
        115
      ],
      [
        -1,
        12
      ]
    ],
    [
      [
        26137,
        62031
      ],
      [
        1,
        1
      ],
      [
        7,
        6
      ],
      [
        4,
        1
      ],
      [
        6,
        -3
      ],
      [
        3,
        -3
      ],
      [
        3,
        -7
      ],
      [
        2,
        -6
      ],
      [
        1,
        -4
      ],
      [
        3,
        -20
      ],
      [
        1,
        -6
      ],
      [
        3,
        -6
      ],
      [
        2,
        -4
      ],
      [
        1,
        -1
      ]
    ],
    [
      [
        25935,
        65224
      ],
      [
        0,
        -50
      ]
    ],
    [
      [
        25935,
        65174
      ],
      [
        1,
        -188
      ],
      [
        0,
        -118
      ],
      [
        -6,
        0
      ]
    ],
    [
      [
        25821,
        65171
      ],
      [
        0,
        50
      ],
      [
        39,
        2
      ],
      [
        6,
        -1
      ],
      [
        6,
        2
      ],
      [
        63,
        0
      ]
    ],
    [
      [
        27611,
        58859
      ],
      [
        1,
        110
      ],
      [
        0,
        48
      ],
      [
        1,
        129
      ]
    ],
    [
      [
        27753,
        59127
      ],
      [
        -2,
        -397
      ]
    ],
    [
      [
        27610,
        58754
      ],
      [
        1,
        105
      ]
    ],
    [
      [
        28411,
        62214
      ],
      [
        6,
        -20
      ]
    ],
    [
      [
        28417,
        62194
      ],
      [
        -2,
        -3
      ],
      [
        -9,
        6
      ],
      [
        0,
        18
      ],
      [
        -1,
        6
      ],
      [
        6,
        -7
      ]
    ],
    [
      [
        27773,
        60926
      ],
      [
        2,
        8
      ],
      [
        11,
        -6
      ],
      [
        -3,
        -4
      ],
      [
        -8,
        -23
      ],
      [
        -2,
        25
      ]
    ],
    [
      [
        26278,
        65915
      ],
      [
        33,
        -2
      ]
    ],
    [
      [
        26407,
        65916
      ],
      [
        1,
        -427
      ]
    ],
    [
      [
        26408,
        65489
      ],
      [
        -10,
        -1
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        26397,
        65488
      ],
      [
        -10,
        -1
      ],
      [
        -87,
        -8
      ],
      [
        -16,
        -2
      ]
    ],
    [
      [
        26284,
        65477
      ],
      [
        0,
        75
      ],
      [
        -3,
        -1
      ],
      [
        -2,
        0
      ]
    ],
    [
      [
        21637,
        61990
      ],
      [
        100,
        0
      ]
    ],
    [
      [
        21737,
        61482
      ],
      [
        -116,
        -1
      ]
    ],
    [
      [
        21614,
        61481
      ],
      [
        0,
        508
      ]
    ],
    [
      [
        23990,
        68388
      ],
      [
        67,
        0
      ],
      [
        34,
        -2
      ]
    ],
    [
      [
        24091,
        68386
      ],
      [
        0,
        -403
      ],
      [
        -3,
        0
      ]
    ],
    [
      [
        24088,
        67983
      ],
      [
        -67,
        0
      ],
      [
        -33,
        -1
      ]
    ],
    [
      [
        23988,
        67982
      ],
      [
        0,
        12
      ],
      [
        1,
        23
      ],
      [
        0,
        67
      ],
      [
        -1,
        304
      ]
    ],
    [
      [
        25074,
        63831
      ],
      [
        27,
        1
      ],
      [
        37,
        0
      ],
      [
        2,
        -1
      ],
      [
        94,
        -1
      ]
    ],
    [
      [
        25187,
        63567
      ],
      [
        -112,
        -8
      ]
    ],
    [
      [
        21414,
        54291
      ],
      [
        -143,
        -1
      ]
    ],
    [
      [
        21271,
        54290
      ],
      [
        -4,
        2
      ],
      [
        -70,
        -1
      ]
    ],
    [
      [
        21197,
        54291
      ],
      [
        0,
        507
      ]
    ],
    [
      [
        22516,
        68388
      ],
      [
        133,
        -2
      ]
    ],
    [
      [
        22650,
        67984
      ],
      [
        -33,
        1
      ]
    ],
    [
      [
        22516,
        68086
      ],
      [
        0,
        302
      ]
    ],
    [
      [
        23742,
        68691
      ],
      [
        4,
        7
      ],
      [
        9,
        64
      ],
      [
        -7,
        29
      ]
    ],
    [
      [
        23748,
        68791
      ],
      [
        73,
        1
      ],
      [
        34,
        0
      ]
    ],
    [
      [
        23855,
        68387
      ],
      [
        -68,
        0
      ]
    ],
    [
      [
        23787,
        68387
      ],
      [
        0,
        51
      ],
      [
        -68,
        0
      ]
    ],
    [
      [
        23719,
        68438
      ],
      [
        -3,
        21
      ],
      [
        7,
        24
      ],
      [
        2,
        20
      ],
      [
        9,
        14
      ],
      [
        7,
        42
      ],
      [
        -8,
        25
      ],
      [
        2,
        10
      ],
      [
        1,
        38
      ],
      [
        3,
        7
      ],
      [
        4,
        38
      ],
      [
        -1,
        14
      ]
    ],
    [
      [
        25013,
        66814
      ],
      [
        1,
        1
      ],
      [
        32,
        0
      ],
      [
        66,
        2
      ]
    ],
    [
      [
        25112,
        66817
      ],
      [
        26,
        -1
      ],
      [
        40,
        -4
      ]
    ],
    [
      [
        25178,
        66812
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -93
      ],
      [
        1,
        -305
      ]
    ],
    [
      [
        25178,
        66404
      ],
      [
        -3,
        -1
      ],
      [
        -43,
        4
      ]
    ],
    [
      [
        25014,
        66413
      ],
      [
        -1,
        314
      ],
      [
        0,
        87
      ]
    ],
    [
      [
        23988,
        67982
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        23888,
        67982
      ],
      [
        0,
        405
      ]
    ],
    [
      [
        27842,
        64725
      ],
      [
        1,
        33
      ],
      [
        0,
        295
      ]
    ],
    [
      [
        27843,
        65053
      ],
      [
        7,
        6
      ],
      [
        9,
        -10
      ],
      [
        4,
        15
      ],
      [
        9,
        -18
      ],
      [
        3,
        17
      ]
    ],
    [
      [
        27875,
        65063
      ],
      [
        5,
        16
      ],
      [
        4,
        -5
      ],
      [
        10,
        9
      ],
      [
        2,
        -8
      ],
      [
        8,
        21
      ],
      [
        6,
        9
      ],
      [
        3,
        -17
      ],
      [
        62,
        -115
      ],
      [
        0,
        -38
      ],
      [
        7,
        0
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        27982,
        64902
      ],
      [
        -15,
        1
      ],
      [
        -11,
        -82
      ],
      [
        0,
        -264
      ]
    ],
    [
      [
        27956,
        64557
      ],
      [
        -114,
        6
      ]
    ],
    [
      [
        27842,
        64563
      ],
      [
        1,
        161
      ],
      [
        -1,
        1
      ]
    ],
    [
      [
        23468,
        66890
      ],
      [
        131,
        -2
      ]
    ],
    [
      [
        23599,
        66888
      ],
      [
        0,
        -306
      ]
    ],
    [
      [
        23599,
        66481
      ],
      [
        -131,
        2
      ]
    ],
    [
      [
        23468,
        66483
      ],
      [
        0,
        407
      ]
    ],
    [
      [
        23318,
        67982
      ],
      [
        -1,
        -404
      ]
    ],
    [
      [
        23317,
        67578
      ],
      [
        -5,
        -1
      ],
      [
        -108,
        0
      ]
    ],
    [
      [
        23204,
        67577
      ],
      [
        -53,
        0
      ]
    ],
    [
      [
        13624,
        82241
      ],
      [
        0,
        -1
      ],
      [
        40,
        23
      ],
      [
        12,
        -56
      ],
      [
        7,
        -33
      ],
      [
        1,
        -4
      ],
      [
        4,
        -22
      ],
      [
        4,
        -28
      ],
      [
        -4,
        -10
      ],
      [
        -1,
        -24
      ],
      [
        -1,
        -39
      ],
      [
        0,
        -17
      ],
      [
        1,
        -1
      ],
      [
        2,
        1
      ],
      [
        -20,
        -107
      ],
      [
        -11,
        -20
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -13
      ],
      [
        -3,
        -14
      ],
      [
        -2,
        -14
      ]
    ],
    [
      [
        13651,
        81856
      ],
      [
        -12,
        26
      ],
      [
        -5,
        25
      ],
      [
        -8,
        7
      ],
      [
        -7,
        29
      ],
      [
        -8,
        19
      ],
      [
        -1,
        11
      ],
      [
        2,
        23
      ],
      [
        -6,
        26
      ],
      [
        -6,
        -6
      ],
      [
        -5,
        19
      ],
      [
        -11,
        27
      ],
      [
        2,
        16
      ],
      [
        9,
        13
      ],
      [
        9,
        1
      ],
      [
        -2,
        13
      ],
      [
        10,
        20
      ],
      [
        8,
        -15
      ],
      [
        12,
        18
      ],
      [
        -9,
        19
      ],
      [
        0,
        14
      ],
      [
        -11,
        22
      ],
      [
        2,
        37
      ],
      [
        10,
        21
      ]
    ],
    [
      [
        13234,
        81005
      ],
      [
        7,
        16
      ],
      [
        9,
        46
      ],
      [
        -4,
        22
      ],
      [
        2,
        21
      ],
      [
        5,
        6
      ],
      [
        6,
        -6
      ],
      [
        2,
        20
      ],
      [
        -4,
        14
      ],
      [
        -7,
        17
      ],
      [
        -3,
        12
      ],
      [
        -2,
        70
      ],
      [
        5,
        39
      ],
      [
        5,
        12
      ],
      [
        2,
        0
      ],
      [
        4,
        -3
      ],
      [
        9,
        -23
      ],
      [
        7,
        -4
      ],
      [
        3,
        -5
      ],
      [
        0,
        -11
      ],
      [
        5,
        -24
      ],
      [
        5,
        -8
      ],
      [
        4,
        2
      ],
      [
        4,
        -1
      ],
      [
        5,
        -8
      ],
      [
        12,
        -32
      ],
      [
        4,
        -21
      ],
      [
        -3,
        -1
      ],
      [
        -3,
        -10
      ],
      [
        3,
        -103
      ],
      [
        -1,
        -30
      ],
      [
        -6,
        -28
      ],
      [
        -3,
        -6
      ],
      [
        -27,
        -2
      ],
      [
        -4,
        6
      ],
      [
        -2,
        11
      ],
      [
        -1,
        5
      ],
      [
        -6,
        10
      ],
      [
        -13,
        -24
      ],
      [
        -3,
        -11
      ],
      [
        -5,
        -4
      ],
      [
        -2,
        3
      ],
      [
        -7,
        23
      ],
      [
        -2,
        10
      ]
    ],
    [
      [
        12888,
        80934
      ],
      [
        9,
        20
      ],
      [
        9,
        -14
      ],
      [
        -2,
        -13
      ],
      [
        2,
        -23
      ],
      [
        -4,
        -17
      ],
      [
        -7,
        10
      ],
      [
        -7,
        37
      ]
    ],
    [
      [
        12768,
        81460
      ],
      [
        7,
        21
      ],
      [
        14,
        6
      ],
      [
        3,
        -12
      ],
      [
        0,
        -11
      ],
      [
        -5,
        -23
      ],
      [
        -10,
        -9
      ],
      [
        -6,
        -2
      ],
      [
        -5,
        15
      ],
      [
        2,
        15
      ]
    ],
    [
      [
        12700,
        80811
      ],
      [
        9,
        0
      ],
      [
        5,
        -34
      ],
      [
        0,
        -43
      ],
      [
        3,
        -32
      ],
      [
        2,
        -19
      ],
      [
        -4,
        -14
      ],
      [
        -11,
        43
      ],
      [
        0,
        40
      ],
      [
        -2,
        30
      ],
      [
        -2,
        29
      ]
    ],
    [
      [
        12674,
        81692
      ],
      [
        9,
        23
      ],
      [
        1,
        33
      ],
      [
        0,
        28
      ],
      [
        5,
        -6
      ],
      [
        15,
        -24
      ],
      [
        -1,
        -23
      ],
      [
        2,
        -9
      ],
      [
        -7,
        -22
      ],
      [
        -7,
        -26
      ],
      [
        -8,
        -24
      ],
      [
        -9,
        33
      ],
      [
        0,
        17
      ]
    ],
    [
      [
        12659,
        81749
      ],
      [
        12,
        9
      ],
      [
        2,
        -9
      ],
      [
        -3,
        -27
      ],
      [
        -13,
        10
      ],
      [
        2,
        17
      ]
    ],
    [
      [
        12654,
        81667
      ],
      [
        4,
        12
      ],
      [
        5,
        -24
      ],
      [
        1,
        -13
      ],
      [
        -7,
        -2
      ],
      [
        -3,
        14
      ],
      [
        0,
        13
      ]
    ],
    [
      [
        12637,
        81497
      ],
      [
        8,
        92
      ],
      [
        2,
        8
      ],
      [
        6,
        17
      ],
      [
        32,
        -9
      ],
      [
        9,
        -13
      ],
      [
        1,
        -3
      ],
      [
        -2,
        -35
      ],
      [
        -2,
        -7
      ],
      [
        -4,
        -7
      ],
      [
        -4,
        -1
      ],
      [
        -2,
        -3
      ],
      [
        -4,
        -24
      ],
      [
        0,
        -8
      ],
      [
        2,
        -6
      ],
      [
        6,
        -2
      ],
      [
        12,
        17
      ],
      [
        8,
        23
      ],
      [
        1,
        18
      ],
      [
        4,
        24
      ],
      [
        0,
        1
      ],
      [
        13,
        -19
      ],
      [
        10,
        7
      ],
      [
        -3,
        16
      ],
      [
        4,
        24
      ],
      [
        1,
        9
      ],
      [
        7,
        12
      ],
      [
        19,
        -2
      ],
      [
        10,
        -31
      ],
      [
        4,
        -3
      ],
      [
        2,
        -5
      ],
      [
        1,
        -13
      ],
      [
        -2,
        -26
      ],
      [
        -4,
        -21
      ],
      [
        -15,
        -35
      ],
      [
        -4,
        8
      ],
      [
        -5,
        13
      ],
      [
        -2,
        1
      ],
      [
        -8,
        -7
      ],
      [
        -13,
        -35
      ],
      [
        2,
        -16
      ],
      [
        11,
        3
      ],
      [
        3,
        -4
      ],
      [
        1,
        -5
      ],
      [
        0,
        -13
      ],
      [
        -2,
        -24
      ],
      [
        -2,
        -5
      ],
      [
        -5,
        0
      ],
      [
        -15,
        -16
      ],
      [
        -22,
        -50
      ],
      [
        -5,
        -36
      ],
      [
        -2,
        -26
      ],
      [
        -2,
        -35
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        3
      ],
      [
        -3,
        9
      ],
      [
        -15,
        63
      ],
      [
        -1,
        5
      ],
      [
        1,
        13
      ],
      [
        5,
        8
      ],
      [
        6,
        22
      ],
      [
        5,
        18
      ],
      [
        3,
        41
      ],
      [
        -4,
        37
      ],
      [
        -29,
        51
      ],
      [
        -3,
        0
      ],
      [
        -4,
        -4
      ],
      [
        -7,
        -12
      ]
    ],
    [
      [
        12629,
        82086
      ],
      [
        6,
        13
      ],
      [
        5,
        9
      ],
      [
        8,
        31
      ],
      [
        16,
        71
      ],
      [
        2,
        6
      ],
      [
        7,
        9
      ],
      [
        11,
        1
      ],
      [
        8,
        -6
      ],
      [
        9,
        6
      ],
      [
        2,
        14
      ],
      [
        -8,
        1
      ],
      [
        -14,
        12
      ],
      [
        -3,
        23
      ],
      [
        2,
        24
      ],
      [
        5,
        -5
      ],
      [
        10,
        -17
      ],
      [
        6,
        16
      ],
      [
        3,
        18
      ],
      [
        -2,
        10
      ],
      [
        -8,
        13
      ],
      [
        -7,
        15
      ],
      [
        -11,
        8
      ],
      [
        -8,
        16
      ],
      [
        2,
        13
      ],
      [
        7,
        2
      ],
      [
        5,
        14
      ],
      [
        -1,
        19
      ],
      [
        -4,
        11
      ],
      [
        -3,
        22
      ],
      [
        -2,
        34
      ],
      [
        2,
        19
      ],
      [
        2,
        0
      ],
      [
        2,
        -3
      ],
      [
        5,
        15
      ],
      [
        0,
        8
      ],
      [
        9,
        10
      ],
      [
        3,
        0
      ],
      [
        45,
        -24
      ],
      [
        25,
        1
      ],
      [
        13,
        -7
      ],
      [
        13,
        -3
      ],
      [
        11,
        10
      ],
      [
        9,
        -18
      ],
      [
        19,
        -78
      ],
      [
        5,
        -4
      ],
      [
        2,
        -10
      ],
      [
        9,
        -63
      ],
      [
        -4,
        -33
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -18
      ],
      [
        1,
        -12
      ],
      [
        7,
        -6
      ],
      [
        7,
        0
      ],
      [
        5,
        -12
      ],
      [
        0,
        -23
      ],
      [
        3,
        -20
      ],
      [
        5,
        -13
      ],
      [
        8,
        -1
      ],
      [
        2,
        -20
      ],
      [
        -1,
        -10
      ],
      [
        8,
        -17
      ],
      [
        5,
        15
      ],
      [
        10,
        4
      ],
      [
        2,
        -14
      ],
      [
        57,
        -119
      ],
      [
        4,
        -12
      ],
      [
        1,
        -4
      ],
      [
        0,
        -10
      ],
      [
        7,
        -26
      ],
      [
        13,
        -37
      ],
      [
        11,
        -36
      ],
      [
        9,
        -38
      ],
      [
        3,
        -115
      ],
      [
        0,
        -11
      ],
      [
        3,
        -8
      ],
      [
        10,
        0
      ],
      [
        6,
        2
      ],
      [
        3,
        -4
      ],
      [
        7,
        -19
      ],
      [
        7,
        -63
      ],
      [
        1,
        -19
      ],
      [
        8,
        -32
      ],
      [
        16,
        -29
      ],
      [
        12,
        -15
      ],
      [
        3,
        -6
      ],
      [
        12,
        -44
      ],
      [
        1,
        -11
      ],
      [
        0,
        -3
      ],
      [
        -6,
        -8
      ],
      [
        -4,
        2
      ],
      [
        -12,
        22
      ],
      [
        -3,
        9
      ],
      [
        0,
        5
      ],
      [
        -4,
        10
      ],
      [
        -19,
        26
      ],
      [
        -3,
        1
      ],
      [
        -53,
        71
      ],
      [
        -8,
        -12
      ],
      [
        5,
        -19
      ],
      [
        -23,
        -74
      ],
      [
        1,
        -7
      ],
      [
        0,
        -4
      ],
      [
        10,
        3
      ],
      [
        14,
        47
      ],
      [
        8,
        -19
      ],
      [
        23,
        10
      ],
      [
        5,
        -37
      ],
      [
        7,
        3
      ],
      [
        13,
        -16
      ],
      [
        8,
        -21
      ],
      [
        2,
        -8
      ],
      [
        -1,
        -3
      ],
      [
        -5,
        -4
      ],
      [
        -32,
        -7
      ],
      [
        8,
        -36
      ],
      [
        32,
        21
      ],
      [
        5,
        -4
      ],
      [
        9,
        -48
      ],
      [
        16,
        -14
      ],
      [
        5,
        -40
      ],
      [
        6,
        -47
      ],
      [
        3,
        -8
      ],
      [
        5,
        -1
      ],
      [
        -1,
        -14
      ],
      [
        -2,
        -9
      ],
      [
        -9,
        -26
      ],
      [
        -6,
        -1
      ],
      [
        -14,
        10
      ],
      [
        -5,
        -9
      ],
      [
        5,
        -18
      ],
      [
        2,
        -5
      ],
      [
        22,
        -22
      ],
      [
        6,
        1
      ],
      [
        5,
        7
      ],
      [
        4,
        18
      ],
      [
        0,
        14
      ],
      [
        -1,
        7
      ],
      [
        0,
        7
      ],
      [
        4,
        16
      ],
      [
        7,
        18
      ],
      [
        3,
        2
      ],
      [
        7,
        -14
      ],
      [
        2,
        -7
      ],
      [
        4,
        -55
      ],
      [
        1,
        -36
      ],
      [
        -3,
        -18
      ],
      [
        -12,
        -16
      ],
      [
        -2,
        -9
      ],
      [
        -1,
        -19
      ],
      [
        1,
        -3
      ],
      [
        6,
        -5
      ],
      [
        -6,
        -39
      ],
      [
        -16,
        -55
      ],
      [
        -16,
        -25
      ],
      [
        -4,
        -3
      ],
      [
        -4,
        0
      ],
      [
        -4,
        -9
      ],
      [
        -1,
        -3
      ],
      [
        2,
        -18
      ],
      [
        14,
        -6
      ],
      [
        2,
        1
      ],
      [
        17,
        36
      ],
      [
        10,
        23
      ],
      [
        3,
        3
      ],
      [
        7,
        -4
      ],
      [
        5,
        -9
      ],
      [
        0,
        -203
      ],
      [
        2,
        -5
      ],
      [
        3,
        -16
      ],
      [
        2,
        -36
      ],
      [
        0,
        -15
      ],
      [
        -11,
        -69
      ],
      [
        -6,
        -26
      ],
      [
        -3,
        -10
      ],
      [
        -31,
        -11
      ],
      [
        -6,
        2
      ],
      [
        -5,
        14
      ],
      [
        -5,
        11
      ],
      [
        -16,
        23
      ],
      [
        -2,
        -1
      ],
      [
        -4,
        -7
      ],
      [
        -1,
        -2
      ],
      [
        1,
        -12
      ],
      [
        -1,
        -1
      ],
      [
        -7,
        4
      ],
      [
        -4,
        30
      ],
      [
        -13,
        8
      ],
      [
        -1,
        37
      ],
      [
        -16,
        3
      ],
      [
        -17,
        -12
      ],
      [
        -5,
        7
      ],
      [
        17,
        53
      ],
      [
        27,
        -10
      ],
      [
        0,
        4
      ],
      [
        3,
        6
      ],
      [
        2,
        -1
      ],
      [
        -4,
        30
      ],
      [
        -19,
        42
      ],
      [
        -19,
        13
      ],
      [
        -21,
        39
      ],
      [
        -6,
        16
      ],
      [
        -8,
        23
      ],
      [
        -1,
        5
      ],
      [
        -1,
        11
      ],
      [
        2,
        14
      ],
      [
        3,
        -2
      ],
      [
        6,
        5
      ],
      [
        0,
        5
      ],
      [
        10,
        115
      ],
      [
        -2,
        19
      ],
      [
        -1,
        1
      ],
      [
        -3,
        0
      ],
      [
        -9,
        -11
      ],
      [
        -7,
        -42
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        3
      ],
      [
        -1,
        21
      ],
      [
        4,
        48
      ],
      [
        4,
        32
      ],
      [
        3,
        10
      ],
      [
        2,
        6
      ],
      [
        1,
        0
      ],
      [
        2,
        12
      ],
      [
        -7,
        32
      ],
      [
        -4,
        7
      ],
      [
        -5,
        -16
      ],
      [
        2,
        -10
      ],
      [
        0,
        -4
      ],
      [
        -2,
        -25
      ],
      [
        -7,
        -10
      ],
      [
        -9,
        -7
      ],
      [
        -11,
        -4
      ],
      [
        6,
        -41
      ],
      [
        8,
        -62
      ],
      [
        -2,
        -21
      ],
      [
        -1,
        -3
      ],
      [
        -15,
        -34
      ],
      [
        -18,
        17
      ],
      [
        -14,
        16
      ],
      [
        -15,
        23
      ],
      [
        -3,
        13
      ],
      [
        -1,
        17
      ],
      [
        0,
        5
      ],
      [
        6,
        8
      ],
      [
        8,
        34
      ],
      [
        3,
        16
      ],
      [
        -1,
        12
      ],
      [
        -6,
        41
      ],
      [
        -11,
        47
      ],
      [
        -1,
        2
      ],
      [
        -12,
        5
      ],
      [
        -7,
        -12
      ],
      [
        -9,
        32
      ],
      [
        -1,
        18
      ],
      [
        -17,
        18
      ],
      [
        -4,
        -15
      ],
      [
        12,
        -78
      ],
      [
        18,
        -65
      ],
      [
        5,
        -57
      ],
      [
        1,
        -15
      ],
      [
        -6,
        -11
      ],
      [
        -3,
        -10
      ],
      [
        2,
        -15
      ],
      [
        15,
        -17
      ],
      [
        14,
        -113
      ],
      [
        -1,
        -12
      ],
      [
        7,
        -20
      ],
      [
        17,
        -32
      ],
      [
        6,
        2
      ],
      [
        1,
        4
      ],
      [
        0,
        27
      ],
      [
        -2,
        8
      ],
      [
        -1,
        6
      ],
      [
        -1,
        17
      ],
      [
        4,
        12
      ],
      [
        20,
        6
      ],
      [
        22,
        -41
      ],
      [
        6,
        -24
      ],
      [
        1,
        -88
      ],
      [
        3,
        -36
      ],
      [
        -1,
        -12
      ],
      [
        -5,
        -16
      ],
      [
        -8,
        12
      ],
      [
        -4,
        12
      ],
      [
        -6,
        29
      ],
      [
        0,
        15
      ],
      [
        -2,
        7
      ],
      [
        -4,
        9
      ],
      [
        -2,
        2
      ],
      [
        -7,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -11
      ],
      [
        3,
        -8
      ],
      [
        7,
        -44
      ],
      [
        13,
        -96
      ],
      [
        1,
        -7
      ],
      [
        -1,
        -2
      ],
      [
        -5,
        -5
      ],
      [
        -23,
        7
      ],
      [
        -25,
        30
      ],
      [
        -1,
        2
      ],
      [
        2,
        17
      ],
      [
        -1,
        14
      ],
      [
        -3,
        29
      ],
      [
        -4,
        17
      ],
      [
        -5,
        14
      ],
      [
        -2,
        3
      ],
      [
        -6,
        1
      ],
      [
        -3,
        5
      ],
      [
        -23,
        78
      ],
      [
        -19,
        74
      ],
      [
        -7,
        25
      ],
      [
        -10,
        22
      ],
      [
        -1,
        21
      ],
      [
        2,
        27
      ],
      [
        -3,
        36
      ],
      [
        -1,
        2
      ],
      [
        -7,
        0
      ],
      [
        -4,
        8
      ],
      [
        -8,
        61
      ],
      [
        5,
        9
      ],
      [
        1,
        1
      ],
      [
        21,
        -2
      ],
      [
        2,
        0
      ],
      [
        2,
        3
      ],
      [
        -7,
        11
      ],
      [
        -22,
        19
      ],
      [
        5,
        11
      ],
      [
        -6,
        54
      ],
      [
        4,
        54
      ],
      [
        -9,
        2
      ],
      [
        -8,
        -17
      ],
      [
        -11,
        -11
      ],
      [
        -5,
        -2
      ],
      [
        -4,
        18
      ],
      [
        -2,
        5
      ],
      [
        -4,
        3
      ],
      [
        -8,
        -15
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        -2
      ],
      [
        -5,
        1
      ],
      [
        -3,
        8
      ],
      [
        -6,
        34
      ],
      [
        0,
        23
      ],
      [
        4,
        46
      ],
      [
        2,
        15
      ],
      [
        4,
        12
      ],
      [
        12,
        13
      ],
      [
        12,
        7
      ],
      [
        5,
        -2
      ],
      [
        6,
        -16
      ],
      [
        0,
        -17
      ],
      [
        5,
        -30
      ],
      [
        7,
        -5
      ],
      [
        7,
        5
      ],
      [
        2,
        15
      ],
      [
        1,
        5
      ],
      [
        -6,
        12
      ],
      [
        -7,
        17
      ],
      [
        0,
        18
      ],
      [
        3,
        12
      ],
      [
        3,
        9
      ],
      [
        9,
        17
      ],
      [
        5,
        3
      ],
      [
        7,
        -6
      ],
      [
        7,
        -8
      ],
      [
        6,
        12
      ],
      [
        16,
        32
      ],
      [
        -7,
        20
      ],
      [
        -10,
        36
      ],
      [
        -9,
        24
      ],
      [
        -3,
        16
      ],
      [
        5,
        11
      ],
      [
        9,
        1
      ],
      [
        0,
        12
      ],
      [
        -7,
        3
      ],
      [
        -9,
        17
      ],
      [
        0,
        33
      ],
      [
        9,
        6
      ],
      [
        -5,
        27
      ],
      [
        -24,
        -21
      ],
      [
        -4,
        13
      ],
      [
        -5,
        10
      ],
      [
        -26,
        36
      ],
      [
        -14,
        28
      ],
      [
        0,
        2
      ],
      [
        -4,
        26
      ],
      [
        6,
        4
      ],
      [
        10,
        -5
      ],
      [
        -3,
        32
      ],
      [
        -6,
        18
      ],
      [
        3,
        35
      ],
      [
        -6,
        10
      ],
      [
        -15,
        18
      ],
      [
        -6,
        -10
      ],
      [
        1,
        -13
      ],
      [
        4,
        -13
      ],
      [
        1,
        -8
      ],
      [
        1,
        -15
      ],
      [
        -1,
        -8
      ],
      [
        -10,
        -13
      ],
      [
        -8,
        4
      ],
      [
        -8,
        8
      ],
      [
        -11,
        17
      ],
      [
        -5,
        10
      ],
      [
        -16,
        58
      ],
      [
        0,
        8
      ],
      [
        12,
        44
      ],
      [
        9,
        9
      ],
      [
        19,
        5
      ],
      [
        25,
        -34
      ],
      [
        12,
        -20
      ],
      [
        21,
        17
      ],
      [
        2,
        3
      ],
      [
        5,
        15
      ],
      [
        -8,
        21
      ],
      [
        -9,
        46
      ],
      [
        -18,
        16
      ],
      [
        -12,
        -20
      ],
      [
        -8,
        6
      ],
      [
        -1,
        11
      ],
      [
        8,
        30
      ],
      [
        -2,
        42
      ],
      [
        7,
        63
      ],
      [
        -5,
        16
      ],
      [
        -13,
        -47
      ],
      [
        -27,
        -65
      ],
      [
        -10,
        -9
      ],
      [
        -7,
        -16
      ],
      [
        8,
        -22
      ],
      [
        0,
        -21
      ],
      [
        -3,
        -14
      ],
      [
        -3,
        5
      ],
      [
        -3,
        27
      ],
      [
        -4,
        17
      ],
      [
        -23,
        38
      ],
      [
        -5,
        31
      ],
      [
        0,
        14
      ]
    ],
    [
      [
        12594,
        82026
      ],
      [
        1,
        6
      ],
      [
        1,
        3
      ],
      [
        12,
        19
      ],
      [
        5,
        1
      ],
      [
        3,
        -2
      ],
      [
        3,
        -5
      ],
      [
        2,
        -23
      ],
      [
        0,
        -8
      ],
      [
        2,
        -14
      ],
      [
        0,
        -7
      ],
      [
        -2,
        -20
      ],
      [
        -4,
        -24
      ],
      [
        -2,
        -4
      ],
      [
        -7,
        0
      ],
      [
        -3,
        3
      ],
      [
        -4,
        14
      ],
      [
        -3,
        11
      ],
      [
        -5,
        31
      ],
      [
        1,
        19
      ]
    ],
    [
      [
        12476,
        82024
      ],
      [
        9,
        18
      ],
      [
        5,
        -4
      ],
      [
        14,
        8
      ],
      [
        0,
        -15
      ],
      [
        1,
        -28
      ],
      [
        9,
        15
      ],
      [
        16,
        15
      ],
      [
        6,
        3
      ],
      [
        4,
        16
      ],
      [
        -1,
        19
      ],
      [
        5,
        40
      ],
      [
        7,
        -2
      ],
      [
        -5,
        -46
      ],
      [
        -2,
        -30
      ],
      [
        1,
        -5
      ],
      [
        -2,
        -14
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        1
      ],
      [
        -7,
        -5
      ],
      [
        -11,
        -18
      ],
      [
        -6,
        -14
      ],
      [
        -3,
        -12
      ],
      [
        -9,
        -25
      ],
      [
        -2,
        -5
      ],
      [
        -9,
        -2
      ],
      [
        -4,
        11
      ],
      [
        -5,
        8
      ],
      [
        0,
        16
      ],
      [
        8,
        14
      ],
      [
        -4,
        13
      ],
      [
        -5,
        15
      ],
      [
        -5,
        21
      ]
    ],
    [
      [
        12742,
        82703
      ],
      [
        -1,
        0
      ],
      [
        -3,
        -17
      ],
      [
        -9,
        -30
      ],
      [
        -15,
        -20
      ],
      [
        -6,
        -2
      ],
      [
        -19,
        0
      ],
      [
        -10,
        5
      ],
      [
        -5,
        3
      ],
      [
        -2,
        7
      ],
      [
        -2,
        46
      ],
      [
        -1,
        41
      ],
      [
        -11,
        32
      ],
      [
        -14,
        -29
      ],
      [
        -16,
        -35
      ],
      [
        13,
        -29
      ],
      [
        -2,
        -90
      ],
      [
        -23,
        -3
      ],
      [
        -2,
        -31
      ],
      [
        7,
        -14
      ],
      [
        3,
        -37
      ],
      [
        -11,
        -51
      ],
      [
        -2,
        -62
      ],
      [
        -6,
        -26
      ],
      [
        -11,
        -24
      ],
      [
        4,
        -39
      ],
      [
        -9,
        -64
      ],
      [
        -10,
        -11
      ],
      [
        -6,
        7
      ],
      [
        -19,
        8
      ],
      [
        -6,
        -17
      ],
      [
        -1,
        -41
      ],
      [
        -7,
        -45
      ],
      [
        -15,
        19
      ],
      [
        -12,
        52
      ],
      [
        -7,
        63
      ],
      [
        -1,
        109
      ],
      [
        -10,
        87
      ],
      [
        2,
        75
      ],
      [
        14,
        48
      ],
      [
        -3,
        57
      ],
      [
        8,
        36
      ],
      [
        7,
        65
      ],
      [
        -12,
        28
      ],
      [
        -16,
        -3
      ],
      [
        -6,
        2
      ],
      [
        5,
        77
      ],
      [
        -5,
        28
      ],
      [
        -15,
        28
      ],
      [
        -8,
        75
      ],
      [
        2,
        43
      ],
      [
        -6,
        61
      ],
      [
        1,
        30
      ],
      [
        17,
        52
      ],
      [
        16,
        17
      ],
      [
        7,
        33
      ],
      [
        6,
        -1
      ],
      [
        15,
        -2
      ],
      [
        12,
        2
      ],
      [
        1,
        26
      ],
      [
        28,
        -40
      ],
      [
        11,
        -83
      ],
      [
        18,
        -54
      ],
      [
        16,
        4
      ],
      [
        15,
        -6
      ],
      [
        9,
        -21
      ],
      [
        10,
        26
      ],
      [
        -2,
        2
      ],
      [
        -4,
        14
      ],
      [
        -3,
        4
      ],
      [
        -20,
        24
      ],
      [
        -5,
        27
      ],
      [
        -8,
        53
      ],
      [
        3,
        15
      ],
      [
        -5,
        40
      ],
      [
        -12,
        31
      ],
      [
        -23,
        48
      ],
      [
        4,
        39
      ],
      [
        7,
        14
      ],
      [
        34,
        26
      ],
      [
        31,
        -22
      ],
      [
        20,
        -15
      ],
      [
        25,
        -9
      ],
      [
        22,
        -22
      ],
      [
        25,
        -22
      ],
      [
        23,
        -15
      ],
      [
        4,
        -3
      ],
      [
        1,
        -3
      ],
      [
        3,
        1
      ],
      [
        2,
        10
      ]
    ],
    [
      [
        12402,
        82457
      ],
      [
        0,
        -20
      ],
      [
        -6,
        -78
      ],
      [
        -2,
        -19
      ],
      [
        -1,
        -14
      ]
    ],
    [
      [
        12393,
        82326
      ],
      [
        0,
        131
      ],
      [
        9,
        0
      ]
    ],
    [
      [
        21709,
        67448
      ],
      [
        52,
        0
      ],
      [
        230,
        1
      ]
    ],
    [
      [
        21991,
        67449
      ],
      [
        0,
        -305
      ],
      [
        5,
        0
      ],
      [
        0,
        -151
      ]
    ],
    [
      [
        21996,
        66993
      ],
      [
        -44,
        0
      ],
      [
        -33,
        1
      ],
      [
        -17,
        0
      ],
      [
        -3,
        -1
      ],
      [
        -90,
        0
      ],
      [
        -5,
        -1
      ],
      [
        -95,
        0
      ]
    ],
    [
      [
        26748,
        53515
      ],
      [
        51,
        -3
      ],
      [
        0,
        -17
      ],
      [
        33,
        -1
      ],
      [
        3,
        -28
      ],
      [
        3,
        -16
      ],
      [
        53,
        0
      ]
    ],
    [
      [
        26891,
        53450
      ],
      [
        -1,
        -104
      ],
      [
        -9,
        15
      ],
      [
        -10,
        -11
      ],
      [
        0,
        -64
      ],
      [
        2,
        0
      ],
      [
        6,
        -46
      ]
    ],
    [
      [
        26879,
        53240
      ],
      [
        -84,
        0
      ]
    ],
    [
      [
        26795,
        53240
      ],
      [
        -21,
        0
      ]
    ],
    [
      [
        26774,
        53240
      ],
      [
        -1,
        56
      ],
      [
        5,
        50
      ],
      [
        -7,
        34
      ],
      [
        0,
        30
      ],
      [
        -6,
        23
      ],
      [
        -9,
        21
      ],
      [
        -1,
        21
      ],
      [
        -7,
        21
      ],
      [
        0,
        19
      ]
    ],
    [
      [
        12393,
        82326
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        0
      ],
      [
        -9,
        10
      ],
      [
        -28,
        70
      ],
      [
        -5,
        51
      ],
      [
        -5,
        35
      ],
      [
        -21,
        59
      ],
      [
        -8,
        34
      ],
      [
        -13,
        80
      ],
      [
        -9,
        49
      ],
      [
        -8,
        32
      ],
      [
        -1,
        2
      ],
      [
        -1,
        15
      ],
      [
        1,
        33
      ],
      [
        3,
        15
      ],
      [
        5,
        13
      ],
      [
        6,
        9
      ],
      [
        2,
        -6
      ],
      [
        4,
        -2
      ],
      [
        5,
        9
      ],
      [
        -1,
        14
      ],
      [
        -3,
        14
      ],
      [
        -5,
        3
      ],
      [
        -9,
        -1
      ],
      [
        -1,
        -11
      ],
      [
        -9,
        -14
      ],
      [
        -7,
        -9
      ],
      [
        -3,
        -2
      ],
      [
        -4,
        -1
      ],
      [
        -2,
        6
      ],
      [
        -7,
        54
      ],
      [
        1,
        4
      ],
      [
        -8,
        30
      ],
      [
        -11,
        -15
      ],
      [
        -3,
        26
      ],
      [
        -14,
        16
      ],
      [
        -8,
        29
      ],
      [
        -4,
        20
      ],
      [
        0,
        6
      ],
      [
        6,
        9
      ],
      [
        4,
        3
      ],
      [
        0,
        11
      ],
      [
        -8,
        11
      ],
      [
        -14,
        -22
      ],
      [
        -10,
        24
      ],
      [
        -19,
        -9
      ],
      [
        -11,
        11
      ],
      [
        -8,
        52
      ],
      [
        -11,
        44
      ],
      [
        19,
        3
      ],
      [
        10,
        -29
      ],
      [
        10,
        13
      ],
      [
        -4,
        43
      ],
      [
        1,
        62
      ],
      [
        19,
        53
      ],
      [
        6,
        38
      ],
      [
        -8,
        23
      ],
      [
        -21,
        34
      ],
      [
        -10,
        29
      ],
      [
        5,
        24
      ],
      [
        19,
        39
      ],
      [
        -4,
        22
      ],
      [
        6,
        20
      ],
      [
        8,
        15
      ],
      [
        -1,
        10
      ],
      [
        1,
        25
      ],
      [
        3,
        7
      ],
      [
        1,
        11
      ],
      [
        -2,
        6
      ],
      [
        -11,
        4
      ],
      [
        -3,
        -1
      ],
      [
        -4,
        -5
      ],
      [
        -5,
        2
      ],
      [
        -6,
        8
      ],
      [
        -2,
        2
      ],
      [
        -7,
        -4
      ],
      [
        -3,
        -8
      ],
      [
        -11,
        -16
      ],
      [
        -3,
        10
      ],
      [
        0,
        3
      ],
      [
        -2,
        13
      ],
      [
        -9,
        35
      ],
      [
        -1,
        6
      ],
      [
        1,
        4
      ],
      [
        0,
        8
      ],
      [
        -8,
        12
      ],
      [
        -2,
        5
      ],
      [
        0,
        6
      ],
      [
        -10,
        19
      ],
      [
        -3,
        16
      ],
      [
        -3,
        8
      ],
      [
        0,
        6
      ],
      [
        2,
        5
      ],
      [
        8,
        8
      ],
      [
        6,
        -2
      ],
      [
        2,
        9
      ],
      [
        1,
        4
      ],
      [
        0,
        6
      ],
      [
        -2,
        7
      ],
      [
        0,
        5
      ],
      [
        2,
        1
      ],
      [
        6,
        12
      ],
      [
        6,
        8
      ],
      [
        4,
        1
      ],
      [
        4,
        10
      ],
      [
        0,
        12
      ],
      [
        -1,
        2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        6
      ],
      [
        2,
        4
      ],
      [
        4,
        0
      ],
      [
        2,
        5
      ],
      [
        0,
        36
      ],
      [
        -4,
        32
      ],
      [
        6,
        1
      ],
      [
        10,
        26
      ],
      [
        13,
        29
      ],
      [
        7,
        8
      ],
      [
        18,
        -12
      ],
      [
        2,
        -4
      ],
      [
        7,
        -19
      ],
      [
        8,
        -27
      ],
      [
        0,
        -2
      ],
      [
        -4,
        -16
      ],
      [
        3,
        -13
      ],
      [
        9,
        -4
      ],
      [
        5,
        4
      ],
      [
        5,
        7
      ],
      [
        5,
        -1
      ],
      [
        14,
        -33
      ],
      [
        -2,
        -8
      ],
      [
        2,
        -10
      ],
      [
        4,
        -7
      ],
      [
        23,
        -24
      ],
      [
        7,
        -1
      ],
      [
        3,
        3
      ],
      [
        28,
        2
      ],
      [
        9,
        -2
      ],
      [
        13,
        -12
      ],
      [
        12,
        -79
      ],
      [
        -2,
        -49
      ],
      [
        -5,
        -7
      ],
      [
        -1,
        7
      ],
      [
        -14,
        35
      ],
      [
        -10,
        1
      ],
      [
        -9,
        -3
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -17
      ],
      [
        1,
        -4
      ],
      [
        2,
        -3
      ],
      [
        6,
        0
      ],
      [
        12,
        -18
      ],
      [
        7,
        -27
      ],
      [
        4,
        -19
      ],
      [
        24,
        -222
      ],
      [
        5,
        -56
      ],
      [
        0,
        -48
      ],
      [
        -1,
        -23
      ],
      [
        6,
        -23
      ],
      [
        6,
        -33
      ],
      [
        0,
        -58
      ],
      [
        6,
        -30
      ],
      [
        3,
        -24
      ],
      [
        9,
        -88
      ],
      [
        4,
        -73
      ],
      [
        1,
        -34
      ],
      [
        -3,
        -97
      ],
      [
        -2,
        -15
      ],
      [
        -2,
        -2
      ],
      [
        -9,
        3
      ],
      [
        1,
        -20
      ],
      [
        1,
        -25
      ],
      [
        2,
        -10
      ],
      [
        1,
        -3
      ],
      [
        3,
        -23
      ],
      [
        2,
        -77
      ],
      [
        1,
        -105
      ],
      [
        0,
        -38
      ]
    ],
    [
      [
        12062,
        83572
      ],
      [
        0,
        31
      ],
      [
        4,
        17
      ],
      [
        -5,
        46
      ],
      [
        2,
        20
      ],
      [
        13,
        3
      ],
      [
        12,
        6
      ],
      [
        13,
        -18
      ],
      [
        4,
        -14
      ],
      [
        17,
        -30
      ],
      [
        12,
        -56
      ],
      [
        3,
        -18
      ],
      [
        12,
        -19
      ],
      [
        8,
        13
      ],
      [
        9,
        17
      ],
      [
        13,
        -3
      ],
      [
        10,
        -7
      ],
      [
        -4,
        -31
      ],
      [
        -11,
        -32
      ],
      [
        -1,
        -19
      ],
      [
        -11,
        -2
      ],
      [
        -7,
        -10
      ],
      [
        -6,
        -2
      ],
      [
        -9,
        -25
      ],
      [
        1,
        -39
      ],
      [
        -9,
        -25
      ],
      [
        -1,
        -30
      ],
      [
        -7,
        -23
      ],
      [
        -2,
        -19
      ],
      [
        -12,
        6
      ],
      [
        -15,
        -15
      ],
      [
        -11,
        -4
      ],
      [
        -14,
        -11
      ],
      [
        -9,
        8
      ],
      [
        3,
        53
      ],
      [
        0,
        49
      ],
      [
        11,
        30
      ],
      [
        14,
        17
      ],
      [
        5,
        26
      ],
      [
        -4,
        24
      ],
      [
        -11,
        5
      ],
      [
        -11,
        -1
      ],
      [
        2,
        29
      ],
      [
        -13,
        31
      ],
      [
        5,
        22
      ]
    ],
    [
      [
        12270,
        84186
      ],
      [
        2,
        -16
      ],
      [
        10,
        -4
      ],
      [
        11,
        -9
      ],
      [
        3,
        3
      ],
      [
        10,
        20
      ],
      [
        10,
        1
      ],
      [
        3,
        -6
      ],
      [
        3,
        -19
      ],
      [
        1,
        -43
      ],
      [
        0,
        -27
      ],
      [
        14,
        -69
      ],
      [
        3,
        -28
      ],
      [
        9,
        -115
      ],
      [
        -4,
        -20
      ],
      [
        -10,
        -22
      ],
      [
        -8,
        -6
      ],
      [
        -34,
        -5
      ],
      [
        -17,
        12
      ],
      [
        -2,
        2
      ],
      [
        -1,
        4
      ],
      [
        -11,
        32
      ],
      [
        -30,
        57
      ],
      [
        -23,
        36
      ],
      [
        -19,
        26
      ],
      [
        -23,
        37
      ],
      [
        -11,
        22
      ],
      [
        -16,
        28
      ],
      [
        -6,
        -13
      ],
      [
        -16,
        -13
      ],
      [
        -9,
        29
      ],
      [
        -8,
        -5
      ],
      [
        2,
        -17
      ],
      [
        2,
        -10
      ],
      [
        11,
        -24
      ],
      [
        19,
        -31
      ],
      [
        6,
        3
      ],
      [
        7,
        10
      ],
      [
        5,
        -8
      ],
      [
        4,
        -13
      ],
      [
        -2,
        -8
      ],
      [
        -2,
        0
      ],
      [
        -9,
        -6
      ],
      [
        -3,
        -5
      ],
      [
        -5,
        -12
      ],
      [
        0,
        -20
      ],
      [
        6,
        -5
      ],
      [
        -4,
        -36
      ],
      [
        4,
        -36
      ],
      [
        -9,
        -50
      ],
      [
        -19,
        -54
      ],
      [
        -12,
        -33
      ],
      [
        -3,
        7
      ],
      [
        -13,
        11
      ],
      [
        -21,
        9
      ],
      [
        -14,
        20
      ],
      [
        -2,
        11
      ],
      [
        1,
        27
      ],
      [
        -13,
        21
      ],
      [
        -7,
        16
      ],
      [
        -13,
        39
      ],
      [
        -9,
        9
      ],
      [
        -2,
        23
      ],
      [
        -9,
        25
      ],
      [
        0,
        26
      ],
      [
        -9,
        16
      ],
      [
        -12,
        -38
      ],
      [
        -8,
        25
      ],
      [
        -11,
        18
      ],
      [
        -2,
        35
      ],
      [
        -8,
        44
      ],
      [
        4,
        25
      ],
      [
        -8,
        38
      ],
      [
        -10,
        48
      ],
      [
        3,
        14
      ],
      [
        -1,
        10
      ],
      [
        -16,
        57
      ],
      [
        -1,
        4
      ]
    ],
    [
      [
        24936,
        55687
      ],
      [
        -16,
        -1
      ],
      [
        -5,
        -29
      ],
      [
        -8,
        -53
      ]
    ],
    [
      [
        24907,
        55604
      ],
      [
        -39,
        45
      ],
      [
        -7,
        8
      ],
      [
        -4,
        4
      ],
      [
        -69,
        81
      ]
    ],
    [
      [
        24788,
        55742
      ],
      [
        0,
        98
      ],
      [
        11,
        -1
      ],
      [
        0,
        50
      ],
      [
        10,
        -1
      ],
      [
        0,
        169
      ],
      [
        -8,
        0
      ],
      [
        6,
        3
      ],
      [
        1,
        63
      ],
      [
        -7,
        19
      ]
    ],
    [
      [
        27434,
        49020
      ],
      [
        92,
        -2
      ],
      [
        8,
        1
      ]
    ],
    [
      [
        27534,
        49019
      ],
      [
        2,
        -38
      ],
      [
        3,
        -29
      ],
      [
        2,
        0
      ],
      [
        8,
        -93
      ],
      [
        3,
        -47
      ],
      [
        6,
        -45
      ],
      [
        2,
        -22
      ],
      [
        8,
        -69
      ]
    ],
    [
      [
        27434,
        48610
      ],
      [
        0,
        410
      ]
    ],
    [
      [
        24182,
        64198
      ],
      [
        -8,
        -1
      ],
      [
        -21,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -5,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -27,
        -3
      ],
      [
        -16,
        -2
      ]
    ],
    [
      [
        24102,
        64190
      ],
      [
        0,
        359
      ]
    ],
    [
      [
        24585,
        64247
      ],
      [
        32,
        -4
      ]
    ],
    [
      [
        24617,
        64243
      ],
      [
        96,
        -10
      ]
    ],
    [
      [
        24713,
        64233
      ],
      [
        -1,
        -409
      ]
    ],
    [
      [
        24712,
        63824
      ],
      [
        -128,
        10
      ]
    ],
    [
      [
        24584,
        63834
      ],
      [
        1,
        413
      ]
    ],
    [
      [
        26672,
        65249
      ],
      [
        21,
        1
      ],
      [
        0,
        -51
      ],
      [
        84,
        0
      ],
      [
        24,
        1
      ]
    ],
    [
      [
        26801,
        65200
      ],
      [
        -1,
        -33
      ],
      [
        14,
        1
      ],
      [
        16,
        0
      ],
      [
        1,
        -79
      ],
      [
        0,
        -85
      ]
    ],
    [
      [
        26831,
        65004
      ],
      [
        1,
        -40
      ]
    ],
    [
      [
        26832,
        64964
      ],
      [
        -66,
        2
      ],
      [
        -48,
        -5
      ],
      [
        -21,
        2
      ],
      [
        -27,
        -1
      ]
    ],
    [
      [
        26670,
        64962
      ],
      [
        2,
        287
      ]
    ],
    [
      [
        25200,
        61880
      ],
      [
        37,
        1
      ],
      [
        87,
        -9
      ]
    ],
    [
      [
        25353,
        61837
      ],
      [
        -1,
        -364
      ]
    ],
    [
      [
        25352,
        61473
      ],
      [
        -61,
        -1
      ]
    ],
    [
      [
        20681,
        52634
      ],
      [
        227,
        515
      ]
    ],
    [
      [
        20908,
        53149
      ],
      [
        144,
        -395
      ]
    ],
    [
      [
        21052,
        52754
      ],
      [
        41,
        -117
      ]
    ],
    [
      [
        21093,
        52637
      ],
      [
        -101,
        -295
      ]
    ],
    [
      [
        20992,
        52342
      ],
      [
        -28,
        0
      ],
      [
        -58,
        49
      ],
      [
        -243,
        203
      ]
    ],
    [
      [
        20663,
        52594
      ],
      [
        2,
        4
      ],
      [
        16,
        36
      ]
    ],
    [
      [
        23584,
        68994
      ],
      [
        0,
        -102
      ],
      [
        68,
        1
      ],
      [
        0,
        102
      ],
      [
        68,
        -1
      ]
    ],
    [
      [
        23787,
        68904
      ],
      [
        -6,
        -13
      ],
      [
        -7,
        5
      ],
      [
        -6,
        -17
      ],
      [
        -6,
        3
      ],
      [
        -1,
        -17
      ],
      [
        -3,
        0
      ],
      [
        -8,
        -22
      ],
      [
        2,
        -3
      ],
      [
        -2,
        -18
      ],
      [
        3,
        -5
      ],
      [
        -5,
        -26
      ]
    ],
    [
      [
        23742,
        68691
      ],
      [
        -193,
        -1
      ]
    ],
    [
      [
        23549,
        68690
      ],
      [
        0,
        97
      ],
      [
        -2,
        206
      ],
      [
        37,
        1
      ]
    ],
    [
      [
        22052,
        56327
      ],
      [
        45,
        0
      ],
      [
        1,
        -22
      ],
      [
        6,
        12
      ],
      [
        4,
        -11
      ],
      [
        11,
        4
      ],
      [
        1,
        -16
      ],
      [
        2,
        4
      ],
      [
        7,
        -12
      ],
      [
        -1,
        16
      ],
      [
        4,
        -4
      ],
      [
        2,
        -13
      ],
      [
        2,
        32
      ],
      [
        7,
        -10
      ],
      [
        1,
        -12
      ],
      [
        4,
        12
      ],
      [
        5,
        -5
      ],
      [
        2,
        -12
      ],
      [
        7,
        -19
      ],
      [
        5,
        -3
      ],
      [
        2,
        21
      ],
      [
        4,
        -15
      ],
      [
        2,
        10
      ],
      [
        4,
        -6
      ],
      [
        -2,
        -13
      ],
      [
        6,
        2
      ],
      [
        1,
        -17
      ],
      [
        8,
        -3
      ],
      [
        3,
        -20
      ],
      [
        2,
        3
      ],
      [
        0,
        -22
      ]
    ],
    [
      [
        22198,
        55819
      ],
      [
        -145,
        -2
      ]
    ],
    [
      [
        24765,
        61794
      ],
      [
        2,
        12
      ],
      [
        1,
        3
      ],
      [
        7,
        35
      ],
      [
        0,
        2
      ],
      [
        2,
        2
      ],
      [
        1,
        6
      ],
      [
        2,
        4
      ],
      [
        1,
        2
      ],
      [
        1,
        6
      ],
      [
        2,
        6
      ],
      [
        1,
        10
      ],
      [
        1,
        4
      ],
      [
        1,
        21
      ],
      [
        0,
        5
      ],
      [
        1,
        11
      ],
      [
        -1,
        19
      ],
      [
        -1,
        1
      ]
    ],
    [
      [
        24786,
        61943
      ],
      [
        4,
        1
      ],
      [
        21,
        -2
      ],
      [
        1,
        0
      ],
      [
        15,
        -1
      ],
      [
        30,
        -1
      ],
      [
        62,
        -3
      ]
    ],
    [
      [
        24919,
        61937
      ],
      [
        0,
        -279
      ]
    ],
    [
      [
        24919,
        61658
      ],
      [
        1,
        -228
      ]
    ],
    [
      [
        24920,
        61430
      ],
      [
        -55,
        1
      ]
    ],
    [
      [
        24865,
        61431
      ],
      [
        1,
        11
      ],
      [
        -4,
        10
      ],
      [
        -1,
        21
      ],
      [
        -3,
        20
      ],
      [
        1,
        14
      ],
      [
        3,
        -11
      ],
      [
        2,
        25
      ],
      [
        -3,
        12
      ],
      [
        -34,
        1
      ],
      [
        0,
        17
      ],
      [
        -31,
        103
      ],
      [
        1,
        17
      ],
      [
        -33,
        110
      ]
    ],
    [
      [
        24764,
        61781
      ],
      [
        0,
        9
      ],
      [
        1,
        4
      ]
    ],
    [
      [
        26541,
        68347
      ],
      [
        89,
        2
      ]
    ],
    [
      [
        26630,
        68349
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -42
      ],
      [
        -1,
        -21
      ],
      [
        -5,
        -17
      ],
      [
        -1,
        -9
      ],
      [
        1,
        -11
      ],
      [
        2,
        -15
      ],
      [
        -5,
        -2
      ],
      [
        -6,
        1
      ],
      [
        -8,
        -4
      ],
      [
        -8,
        -19
      ],
      [
        -2,
        -18
      ],
      [
        2,
        -31
      ],
      [
        -4,
        -6
      ],
      [
        -10,
        15
      ],
      [
        -4,
        -12
      ],
      [
        -1,
        -3
      ],
      [
        -5,
        -4
      ],
      [
        -6,
        0
      ],
      [
        -12,
        4
      ],
      [
        -5,
        -9
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -5
      ],
      [
        -4,
        -14
      ],
      [
        -2,
        -2
      ],
      [
        -4,
        -28
      ],
      [
        0,
        -13
      ],
      [
        -5,
        -6
      ],
      [
        0,
        -9
      ]
    ],
    [
      [
        26534,
        68055
      ],
      [
        -38,
        0
      ],
      [
        0,
        100
      ],
      [
        -34,
        0
      ]
    ],
    [
      [
        25294,
        62538
      ],
      [
        98,
        3
      ]
    ],
    [
      [
        25392,
        62541
      ],
      [
        16,
        1
      ]
    ],
    [
      [
        25408,
        62542
      ],
      [
        1,
        -106
      ],
      [
        0,
        -272
      ]
    ],
    [
      [
        25322,
        62161
      ],
      [
        -29,
        5
      ],
      [
        0,
        69
      ]
    ],
    [
      [
        22898,
        62998
      ],
      [
        -1,
        -403
      ]
    ],
    [
      [
        22897,
        62493
      ],
      [
        -83,
        0
      ],
      [
        -31,
        -1
      ]
    ],
    [
      [
        22783,
        62492
      ],
      [
        0,
        101
      ],
      [
        1,
        102
      ]
    ],
    [
      [
        17372,
        70320
      ],
      [
        12,
        15
      ],
      [
        6,
        29
      ],
      [
        -8,
        56
      ],
      [
        3,
        22
      ],
      [
        13,
        41
      ]
    ],
    [
      [
        17398,
        70483
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        2,
        0
      ],
      [
        2,
        -1
      ],
      [
        4,
        -3
      ],
      [
        2,
        -4
      ],
      [
        2,
        1
      ],
      [
        2,
        3
      ],
      [
        0,
        5
      ],
      [
        1,
        9
      ],
      [
        -1,
        11
      ],
      [
        0,
        16
      ],
      [
        3,
        6
      ],
      [
        3,
        1
      ],
      [
        2,
        -2
      ],
      [
        1,
        -2
      ],
      [
        2,
        2
      ],
      [
        1,
        -1
      ],
      [
        2,
        -2
      ],
      [
        2,
        -3
      ],
      [
        2,
        -2
      ],
      [
        1,
        -2
      ],
      [
        1,
        -4
      ],
      [
        1,
        -4
      ],
      [
        2,
        -4
      ],
      [
        0,
        -4
      ],
      [
        2,
        -3
      ],
      [
        1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        2,
        -3
      ],
      [
        0,
        -3
      ],
      [
        1,
        -1
      ],
      [
        2,
        1
      ],
      [
        1,
        2
      ],
      [
        1,
        5
      ],
      [
        0,
        5
      ],
      [
        -1,
        5
      ],
      [
        0,
        6
      ],
      [
        1,
        6
      ],
      [
        1,
        3
      ],
      [
        1,
        4
      ],
      [
        0,
        6
      ],
      [
        1,
        2
      ],
      [
        0,
        3
      ],
      [
        -1,
        4
      ],
      [
        0,
        3
      ],
      [
        1,
        4
      ],
      [
        0,
        92
      ],
      [
        1,
        1
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        1,
        -3
      ],
      [
        1,
        -2
      ],
      [
        2,
        0
      ],
      [
        2,
        -1
      ],
      [
        1,
        -1
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        -1,
        5
      ],
      [
        0,
        13
      ],
      [
        -1,
        4
      ],
      [
        1,
        3
      ],
      [
        1,
        3
      ],
      [
        1,
        5
      ],
      [
        0,
        5
      ],
      [
        1,
        3
      ],
      [
        1,
        4
      ],
      [
        0,
        7
      ],
      [
        1,
        4
      ],
      [
        1,
        5
      ],
      [
        0,
        5
      ],
      [
        1,
        4
      ],
      [
        0,
        9
      ],
      [
        2,
        4
      ],
      [
        0,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        2,
        3
      ],
      [
        1,
        2
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        1,
        -3
      ],
      [
        2,
        -3
      ],
      [
        1,
        -3
      ],
      [
        2,
        -1
      ],
      [
        1,
        -3
      ],
      [
        3,
        0
      ],
      [
        1,
        -2
      ],
      [
        2,
        -2
      ],
      [
        3,
        0
      ],
      [
        1,
        1
      ],
      [
        3,
        0
      ],
      [
        2,
        -2
      ],
      [
        2,
        0
      ],
      [
        1,
        -1
      ],
      [
        1,
        -4
      ],
      [
        1,
        -4
      ],
      [
        1,
        -4
      ],
      [
        1,
        -3
      ],
      [
        2,
        -2
      ],
      [
        1,
        -2
      ],
      [
        3,
        4
      ],
      [
        2,
        4
      ],
      [
        2,
        -1
      ],
      [
        1,
        -2
      ],
      [
        2,
        -3
      ],
      [
        2,
        1
      ],
      [
        1,
        2
      ],
      [
        2,
        -2
      ],
      [
        2,
        -3
      ],
      [
        1,
        -6
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        2,
        2
      ],
      [
        2,
        -2
      ],
      [
        2,
        -2
      ],
      [
        2,
        -5
      ],
      [
        2,
        0
      ],
      [
        1,
        2
      ],
      [
        1,
        5
      ],
      [
        0,
        16
      ],
      [
        1,
        7
      ],
      [
        1,
        5
      ],
      [
        1,
        3
      ],
      [
        2,
        1
      ],
      [
        1,
        3
      ],
      [
        0,
        5
      ],
      [
        1,
        5
      ],
      [
        2,
        6
      ],
      [
        1,
        5
      ],
      [
        1,
        4
      ],
      [
        2,
        3
      ],
      [
        1,
        1
      ],
      [
        3,
        1
      ],
      [
        1,
        -4
      ],
      [
        3,
        -1
      ],
      [
        4,
        -2
      ],
      [
        3,
        -1
      ],
      [
        2,
        1
      ],
      [
        2,
        1
      ],
      [
        1,
        2
      ],
      [
        4,
        -2
      ],
      [
        2,
        2
      ],
      [
        2,
        3
      ],
      [
        2,
        3
      ],
      [
        2,
        4
      ],
      [
        1,
        3
      ],
      [
        1,
        2
      ],
      [
        1,
        4
      ],
      [
        0,
        3
      ],
      [
        -4,
        8
      ],
      [
        -2,
        4
      ],
      [
        -1,
        10
      ],
      [
        -4,
        5
      ],
      [
        -4,
        3
      ],
      [
        -3,
        5
      ],
      [
        -4,
        9
      ],
      [
        -2,
        12
      ],
      [
        -2,
        7
      ],
      [
        -3,
        10
      ],
      [
        -2,
        11
      ],
      [
        -2,
        10
      ],
      [
        -2,
        14
      ],
      [
        -2,
        12
      ],
      [
        0,
        6
      ],
      [
        -1,
        5
      ],
      [
        -2,
        10
      ],
      [
        -2,
        7
      ],
      [
        -1,
        15
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        17546,
        70920
      ],
      [
        6,
        -3
      ],
      [
        5,
        -18
      ],
      [
        4,
        11
      ],
      [
        11,
        -2
      ],
      [
        10,
        -17
      ],
      [
        11,
        -47
      ],
      [
        12,
        -21
      ],
      [
        6,
        4
      ],
      [
        24,
        -11
      ],
      [
        10,
        -20
      ],
      [
        2,
        7
      ],
      [
        8,
        -5
      ],
      [
        1,
        15
      ],
      [
        5,
        5
      ],
      [
        2,
        15
      ],
      [
        -1,
        14
      ],
      [
        4,
        12
      ],
      [
        2,
        25
      ],
      [
        0,
        25
      ],
      [
        2,
        13
      ],
      [
        12,
        24
      ],
      [
        4,
        22
      ],
      [
        9,
        28
      ],
      [
        -1,
        16
      ],
      [
        2,
        26
      ],
      [
        107,
        70
      ],
      [
        182,
        116
      ]
    ],
    [
      [
        17985,
        71224
      ],
      [
        3,
        0
      ],
      [
        6,
        10
      ],
      [
        4,
        3
      ],
      [
        14,
        -8
      ],
      [
        3,
        -5
      ],
      [
        5,
        -2
      ],
      [
        4,
        11
      ],
      [
        0,
        10
      ],
      [
        8,
        13
      ],
      [
        4,
        -4
      ],
      [
        2,
        3
      ],
      [
        3,
        6
      ],
      [
        9,
        5
      ],
      [
        8,
        -10
      ]
    ],
    [
      [
        17553,
        69448
      ],
      [
        -45,
        2
      ],
      [
        1,
        12
      ],
      [
        5,
        11
      ],
      [
        -3,
        22
      ],
      [
        -2,
        28
      ],
      [
        0,
        15
      ],
      [
        -3,
        31
      ],
      [
        -8,
        66
      ],
      [
        -96,
        0
      ]
    ],
    [
      [
        17402,
        69635
      ],
      [
        2,
        3
      ],
      [
        1,
        5
      ],
      [
        0,
        2
      ],
      [
        1,
        8
      ],
      [
        0,
        17
      ],
      [
        -1,
        19
      ],
      [
        1,
        8
      ],
      [
        5,
        35
      ],
      [
        8,
        43
      ],
      [
        2,
        11
      ],
      [
        6,
        17
      ],
      [
        1,
        17
      ],
      [
        1,
        19
      ],
      [
        2,
        7
      ],
      [
        2,
        4
      ],
      [
        3,
        9
      ],
      [
        3,
        3
      ],
      [
        0,
        11
      ],
      [
        -1,
        9
      ],
      [
        0,
        1
      ],
      [
        1,
        21
      ],
      [
        1,
        13
      ],
      [
        2,
        4
      ],
      [
        2,
        13
      ],
      [
        3,
        25
      ],
      [
        6,
        24
      ],
      [
        4,
        9
      ],
      [
        2,
        3
      ],
      [
        0,
        1
      ],
      [
        5,
        29
      ],
      [
        0,
        17
      ],
      [
        -2,
        3
      ],
      [
        0,
        5
      ],
      [
        -2,
        8
      ],
      [
        -1,
        10
      ],
      [
        -2,
        11
      ],
      [
        -2,
        7
      ],
      [
        -4,
        17
      ],
      [
        -4,
        9
      ],
      [
        -1,
        4
      ],
      [
        -2,
        12
      ],
      [
        0,
        6
      ],
      [
        -1,
        21
      ],
      [
        1,
        23
      ],
      [
        0,
        3
      ],
      [
        -3,
        16
      ],
      [
        -1,
        2
      ],
      [
        -1,
        1
      ],
      [
        -2,
        2
      ],
      [
        -5,
        14
      ],
      [
        -4,
        13
      ],
      [
        -3,
        3
      ],
      [
        -8,
        5
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -1
      ],
      [
        -4,
        0
      ],
      [
        -1,
        2
      ],
      [
        -4,
        14
      ],
      [
        -2,
        15
      ],
      [
        -3,
        16
      ],
      [
        -3,
        5
      ],
      [
        -1,
        2
      ],
      [
        -7,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -6,
        11
      ],
      [
        -1,
        7
      ],
      [
        -1,
        2
      ],
      [
        0,
        4
      ],
      [
        1,
        4
      ],
      [
        0,
        5
      ],
      [
        -1,
        6
      ],
      [
        -1,
        8
      ]
    ],
    [
      [
        22000,
        73978
      ],
      [
        183,
        0
      ]
    ],
    [
      [
        22192,
        73449
      ],
      [
        -182,
        1
      ]
    ],
    [
      [
        22005,
        62492
      ],
      [
        -155,
        2
      ]
    ],
    [
      [
        22339,
        52935
      ],
      [
        145,
        0
      ]
    ],
    [
      [
        22484,
        52935
      ],
      [
        -1,
        -37
      ],
      [
        -2,
        -13
      ],
      [
        2,
        -10
      ],
      [
        5,
        -1
      ],
      [
        3,
        -12
      ],
      [
        0,
        -28
      ],
      [
        4,
        10
      ],
      [
        8,
        -10
      ],
      [
        -4,
        -19
      ],
      [
        -3,
        -1
      ],
      [
        -3,
        -27
      ],
      [
        -5,
        -5
      ],
      [
        2,
        -18
      ],
      [
        -2,
        -16
      ],
      [
        2,
        -12
      ],
      [
        14,
        -5
      ],
      [
        1,
        -7
      ],
      [
        -6,
        -22
      ],
      [
        -3,
        -1
      ],
      [
        -3,
        -19
      ],
      [
        3,
        -33
      ],
      [
        -10,
        -3
      ],
      [
        0,
        -13
      ],
      [
        3,
        -2
      ],
      [
        3,
        -17
      ],
      [
        0,
        -22
      ],
      [
        5,
        -33
      ],
      [
        -4,
        -12
      ],
      [
        1,
        -16
      ],
      [
        3,
        -13
      ],
      [
        6,
        12
      ],
      [
        4,
        -3
      ],
      [
        3,
        -15
      ],
      [
        0,
        -84
      ]
    ],
    [
      [
        20644,
        61475
      ],
      [
        31,
        0
      ],
      [
        -1,
        133
      ],
      [
        0,
        171
      ]
    ],
    [
      [
        20674,
        61779
      ],
      [
        3,
        1
      ],
      [
        102,
        0
      ],
      [
        143,
        3
      ]
    ],
    [
      [
        20922,
        61783
      ],
      [
        -1,
        -304
      ],
      [
        -1,
        -134
      ]
    ],
    [
      [
        20919,
        60866
      ],
      [
        -80,
        96
      ]
    ],
    [
      [
        20839,
        60962
      ],
      [
        -83,
        97
      ],
      [
        -5,
        -1
      ],
      [
        -45,
        -10
      ],
      [
        -52,
        -12
      ],
      [
        -6,
        16
      ],
      [
        -4,
        24
      ]
    ],
    [
      [
        20644,
        61076
      ],
      [
        0,
        399
      ]
    ],
    [
      [
        15231,
        66942
      ],
      [
        61,
        0
      ],
      [
        6,
        -24
      ],
      [
        5,
        0
      ],
      [
        2,
        -35
      ],
      [
        6,
        -8
      ],
      [
        3,
        -17
      ],
      [
        5,
        1
      ],
      [
        0,
        -16
      ],
      [
        6,
        -22
      ],
      [
        0,
        -26
      ],
      [
        -5,
        0
      ],
      [
        -2,
        -12
      ],
      [
        2,
        -33
      ],
      [
        0,
        -58
      ],
      [
        6,
        0
      ],
      [
        1,
        -85
      ],
      [
        4,
        13
      ],
      [
        8,
        0
      ],
      [
        0,
        9
      ],
      [
        26,
        0
      ],
      [
        0,
        17
      ],
      [
        6,
        0
      ],
      [
        0,
        17
      ],
      [
        5,
        0
      ],
      [
        0,
        16
      ],
      [
        6,
        0
      ],
      [
        3,
        13
      ],
      [
        0,
        40
      ],
      [
        16,
        1
      ],
      [
        5,
        16
      ],
      [
        11,
        0
      ]
    ],
    [
      [
        15417,
        66749
      ],
      [
        8,
        12
      ],
      [
        14,
        -22
      ],
      [
        4,
        4
      ]
    ],
    [
      [
        15414,
        65826
      ],
      [
        -50,
        0
      ],
      [
        -24,
        1
      ],
      [
        -11,
        0
      ],
      [
        -24,
        2
      ]
    ],
    [
      [
        15305,
        65829
      ],
      [
        0,
        9
      ],
      [
        -16,
        46
      ],
      [
        -5,
        0
      ],
      [
        -3,
        7
      ],
      [
        -4,
        19
      ],
      [
        -8,
        29
      ],
      [
        -4,
        26
      ],
      [
        0,
        3
      ],
      [
        1,
        14
      ],
      [
        0,
        6
      ],
      [
        -1,
        8
      ],
      [
        -1,
        2
      ],
      [
        -2,
        10
      ],
      [
        0,
        7
      ],
      [
        1,
        0
      ],
      [
        1,
        5
      ],
      [
        0,
        21
      ],
      [
        -2,
        9
      ],
      [
        -2,
        2
      ],
      [
        0,
        22
      ],
      [
        -1,
        11
      ],
      [
        -1,
        10
      ],
      [
        -8,
        27
      ],
      [
        0,
        5
      ],
      [
        1,
        7
      ],
      [
        1,
        20
      ],
      [
        -2,
        35
      ],
      [
        -5,
        28
      ],
      [
        0,
        4
      ],
      [
        1,
        19
      ],
      [
        0,
        51
      ],
      [
        -1,
        29
      ],
      [
        -2,
        17
      ],
      [
        0,
        6
      ],
      [
        4,
        25
      ],
      [
        0,
        35
      ],
      [
        6,
        56
      ],
      [
        3,
        31
      ],
      [
        0,
        10
      ],
      [
        -3,
        26
      ],
      [
        0,
        35
      ],
      [
        -4,
        36
      ],
      [
        -1,
        4
      ],
      [
        -9,
        16
      ],
      [
        0,
        3
      ],
      [
        1,
        8
      ],
      [
        -1,
        6
      ],
      [
        -7,
        50
      ],
      [
        -5,
        10
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        -5
      ],
      [
        -1,
        0
      ],
      [
        0,
        22
      ],
      [
        -3,
        42
      ],
      [
        -3,
        29
      ],
      [
        -2,
        10
      ],
      [
        -3,
        20
      ],
      [
        15,
        90
      ],
      [
        5,
        39
      ],
      [
        1,
        4
      ]
    ],
    [
      [
        25027,
        55481
      ],
      [
        29,
        1
      ],
      [
        0,
        102
      ],
      [
        24,
        0
      ],
      [
        5,
        1
      ],
      [
        0,
        102
      ],
      [
        6,
        0
      ]
    ],
    [
      [
        25168,
        55688
      ],
      [
        0,
        -420
      ]
    ],
    [
      [
        25168,
        55268
      ],
      [
        -29,
        1
      ]
    ],
    [
      [
        25027,
        55275
      ],
      [
        0,
        206
      ]
    ],
    [
      [
        22406,
        63911
      ],
      [
        -126,
        0
      ]
    ],
    [
      [
        31436,
        38183
      ],
      [
        2,
        -9
      ],
      [
        4,
        6
      ],
      [
        7,
        -1
      ]
    ],
    [
      [
        31449,
        38179
      ],
      [
        1,
        -14
      ],
      [
        -2,
        -16
      ],
      [
        2,
        -40
      ],
      [
        7,
        -1
      ]
    ],
    [
      [
        31457,
        38108
      ],
      [
        -1,
        -5
      ]
    ],
    [
      [
        31436,
        38070
      ],
      [
        -2,
        16
      ],
      [
        -8,
        0
      ],
      [
        -7,
        9
      ]
    ],
    [
      [
        31419,
        38095
      ],
      [
        3,
        32
      ],
      [
        4,
        -8
      ],
      [
        0,
        55
      ]
    ],
    [
      [
        27391,
        63178
      ],
      [
        87,
        0
      ]
    ],
    [
      [
        27506,
        63178
      ],
      [
        4,
        -4
      ],
      [
        3,
        -43
      ],
      [
        0,
        -51
      ]
    ],
    [
      [
        27513,
        63080
      ],
      [
        -11,
        3
      ],
      [
        -2,
        -12
      ],
      [
        2,
        -10
      ],
      [
        -4,
        -9
      ],
      [
        -1,
        -20
      ],
      [
        -7,
        2
      ],
      [
        -1,
        -16
      ],
      [
        -5,
        -24
      ],
      [
        5,
        -56
      ],
      [
        4,
        -14
      ],
      [
        -1,
        -19
      ],
      [
        -5,
        -5
      ],
      [
        -2,
        -15
      ]
    ],
    [
      [
        27485,
        62885
      ],
      [
        -5,
        -13
      ],
      [
        -1,
        -27
      ],
      [
        -8,
        -7
      ]
    ],
    [
      [
        27471,
        62838
      ],
      [
        -10,
        26
      ],
      [
        -4,
        -11
      ],
      [
        -6,
        10
      ]
    ],
    [
      [
        27451,
        62863
      ],
      [
        -10,
        23
      ],
      [
        -5,
        -7
      ],
      [
        0,
        13
      ],
      [
        -4,
        -6
      ],
      [
        -7,
        7
      ],
      [
        -3,
        17
      ],
      [
        -3,
        1
      ],
      [
        -2,
        25
      ],
      [
        -13,
        28
      ],
      [
        1,
        12
      ],
      [
        -8,
        17
      ],
      [
        -3,
        -9
      ],
      [
        -1,
        25
      ],
      [
        -5,
        9
      ],
      [
        -1,
        20
      ],
      [
        -1,
        1
      ],
      [
        -10,
        -25
      ],
      [
        -16,
        31
      ]
    ],
    [
      [
        27360,
        63045
      ],
      [
        2,
        7
      ],
      [
        1,
        2
      ],
      [
        2,
        3
      ],
      [
        2,
        2
      ],
      [
        4,
        -1
      ],
      [
        2,
        -1
      ],
      [
        2,
        0
      ],
      [
        3,
        4
      ],
      [
        1,
        8
      ],
      [
        1,
        13
      ],
      [
        1,
        4
      ],
      [
        -1,
        1
      ],
      [
        1,
        5
      ],
      [
        1,
        6
      ],
      [
        0,
        46
      ],
      [
        1,
        2
      ],
      [
        2,
        4
      ],
      [
        1,
        2
      ],
      [
        2,
        1
      ],
      [
        1,
        2
      ],
      [
        2,
        2
      ],
      [
        0,
        3
      ],
      [
        1,
        7
      ],
      [
        0,
        3
      ],
      [
        -1,
        6
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        26330,
        53328
      ],
      [
        29,
        -4
      ],
      [
        -2,
        -206
      ]
    ],
    [
      [
        26305,
        53107
      ],
      [
        -53,
        4
      ]
    ],
    [
      [
        26252,
        53111
      ],
      [
        1,
        213
      ],
      [
        65,
        1
      ],
      [
        12,
        3
      ]
    ],
    [
      [
        20369,
        60882
      ],
      [
        162,
        3
      ]
    ],
    [
      [
        20531,
        60885
      ],
      [
        0,
        -32
      ],
      [
        -6,
        -19
      ],
      [
        0,
        -49
      ],
      [
        -3,
        -14
      ],
      [
        -4,
        -65
      ],
      [
        5,
        -23
      ]
    ],
    [
      [
        20523,
        60683
      ],
      [
        -3,
        -16
      ],
      [
        -69,
        -241
      ]
    ],
    [
      [
        22326,
        60458
      ],
      [
        -133,
        -4
      ],
      [
        -15,
        0
      ]
    ],
    [
      [
        22178,
        60454
      ],
      [
        -3,
        0
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        21235,
        71220
      ],
      [
        176,
        1
      ],
      [
        56,
        1
      ]
    ],
    [
      [
        21467,
        71222
      ],
      [
        13,
        -1
      ],
      [
        1,
        -404
      ],
      [
        13,
        0
      ],
      [
        0,
        -91
      ]
    ],
    [
      [
        21494,
        70726
      ],
      [
        -139,
        1
      ],
      [
        0,
        90
      ],
      [
        -14,
        -1
      ],
      [
        -105,
        -1
      ]
    ],
    [
      [
        24091,
        68386
      ],
      [
        35,
        0
      ]
    ],
    [
      [
        24126,
        68386
      ],
      [
        32,
        -1
      ],
      [
        33,
        0
      ],
      [
        0,
        -101
      ],
      [
        67,
        -1
      ]
    ],
    [
      [
        24258,
        68283
      ],
      [
        0,
        -302
      ]
    ],
    [
      [
        24258,
        67981
      ],
      [
        -103,
        1
      ],
      [
        0,
        -16
      ]
    ],
    [
      [
        24155,
        67966
      ],
      [
        -67,
        -1
      ],
      [
        0,
        18
      ]
    ],
    [
      [
        31537,
        38160
      ],
      [
        3,
        6
      ],
      [
        -1,
        21
      ],
      [
        7,
        21
      ]
    ],
    [
      [
        31565,
        38190
      ],
      [
        0,
        -8
      ],
      [
        -7,
        -37
      ],
      [
        -5,
        -16
      ],
      [
        -9,
        -69
      ]
    ],
    [
      [
        23354,
        66076
      ],
      [
        65,
        0
      ]
    ],
    [
      [
        23289,
        65672
      ],
      [
        -32,
        -1
      ]
    ],
    [
      [
        23257,
        65671
      ],
      [
        0,
        406
      ]
    ],
    [
      [
        23180,
        62035
      ],
      [
        0,
        152
      ]
    ],
    [
      [
        23180,
        62187
      ],
      [
        124,
        0
      ]
    ],
    [
      [
        23304,
        62187
      ],
      [
        0,
        -152
      ]
    ],
    [
      [
        23302,
        61680
      ],
      [
        -123,
        0
      ]
    ],
    [
      [
        23994,
        66479
      ],
      [
        33,
        -1
      ],
      [
        98,
        0
      ]
    ],
    [
      [
        24131,
        66176
      ],
      [
        -65,
        0
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        21480,
        63000
      ],
      [
        177,
        0
      ]
    ],
    [
      [
        21657,
        63000
      ],
      [
        7,
        0
      ]
    ],
    [
      [
        21663,
        62496
      ],
      [
        -24,
        -1
      ]
    ],
    [
      [
        21481,
        62494
      ],
      [
        0,
        4
      ],
      [
        -1,
        193
      ],
      [
        0,
        309
      ]
    ],
    [
      [
        31265,
        38069
      ],
      [
        5,
        -44
      ],
      [
        -3,
        -11
      ],
      [
        6,
        -74
      ],
      [
        3,
        -7
      ],
      [
        1,
        -11
      ]
    ],
    [
      [
        31277,
        37922
      ],
      [
        -3,
        -2
      ],
      [
        -18,
        11
      ]
    ],
    [
      [
        31256,
        37931
      ],
      [
        -6,
        10
      ],
      [
        0,
        13
      ]
    ],
    [
      [
        31250,
        37954
      ],
      [
        0,
        31
      ],
      [
        -1,
        33
      ],
      [
        4,
        29
      ],
      [
        -2,
        14
      ]
    ],
    [
      [
        23515,
        65671
      ],
      [
        0,
        -303
      ],
      [
        12,
        0
      ],
      [
        0,
        -114
      ]
    ],
    [
      [
        23527,
        65254
      ],
      [
        -94,
        0
      ]
    ],
    [
      [
        30861,
        68291
      ],
      [
        1,
        3
      ],
      [
        3,
        9
      ],
      [
        2,
        1
      ],
      [
        1,
        4
      ],
      [
        2,
        0
      ],
      [
        4,
        -20
      ],
      [
        0,
        -4
      ],
      [
        -2,
        -7
      ],
      [
        -7,
        0
      ],
      [
        -4,
        12
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        30863,
        68384
      ],
      [
        2,
        5
      ],
      [
        2,
        2
      ],
      [
        7,
        9
      ],
      [
        2,
        -2
      ],
      [
        2,
        -6
      ],
      [
        1,
        -4
      ],
      [
        -1,
        0
      ],
      [
        -1,
        3
      ],
      [
        -3,
        -8
      ],
      [
        -2,
        -24
      ],
      [
        -2,
        -3
      ],
      [
        -9,
        17
      ],
      [
        2,
        11
      ]
    ],
    [
      [
        30827,
        68345
      ],
      [
        1,
        3
      ],
      [
        2,
        47
      ],
      [
        1,
        12
      ],
      [
        1,
        13
      ],
      [
        2,
        8
      ],
      [
        2,
        -8
      ],
      [
        4,
        -26
      ],
      [
        8,
        -13
      ],
      [
        2,
        -4
      ],
      [
        3,
        -13
      ],
      [
        6,
        -25
      ],
      [
        -3,
        -16
      ],
      [
        -9,
        -25
      ],
      [
        -3,
        -4
      ],
      [
        -3,
        11
      ],
      [
        1,
        9
      ],
      [
        -3,
        14
      ],
      [
        -6,
        3
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        1
      ],
      [
        -2,
        6
      ],
      [
        1,
        9
      ]
    ],
    [
      [
        30822,
        68291
      ],
      [
        2,
        13
      ],
      [
        1,
        3
      ],
      [
        2,
        -4
      ],
      [
        2,
        -8
      ],
      [
        0,
        -8
      ],
      [
        -3,
        -12
      ],
      [
        -4,
        4
      ],
      [
        0,
        12
      ]
    ],
    [
      [
        30819,
        68560
      ],
      [
        2,
        16
      ],
      [
        0,
        11
      ],
      [
        1,
        15
      ],
      [
        2,
        5
      ],
      [
        1,
        0
      ],
      [
        2,
        -3
      ],
      [
        0,
        -15
      ],
      [
        6,
        -58
      ],
      [
        -3,
        -7
      ],
      [
        -7,
        13
      ],
      [
        -4,
        10
      ],
      [
        0,
        13
      ]
    ],
    [
      [
        30732,
        68434
      ],
      [
        2,
        5
      ],
      [
        2,
        3
      ],
      [
        0,
        -1
      ],
      [
        10,
        -5
      ],
      [
        6,
        -18
      ],
      [
        0,
        -11
      ],
      [
        -3,
        -12
      ],
      [
        -3,
        1
      ],
      [
        -3,
        6
      ],
      [
        -2,
        4
      ],
      [
        -2,
        2
      ],
      [
        -2,
        3
      ],
      [
        -2,
        0
      ],
      [
        -2,
        12
      ],
      [
        -1,
        11
      ]
    ],
    [
      [
        30739,
        68955
      ],
      [
        5,
        6
      ],
      [
        9,
        -16
      ],
      [
        -2,
        -13
      ],
      [
        8,
        -4
      ],
      [
        7,
        45
      ],
      [
        1,
        5
      ],
      [
        7,
        21
      ],
      [
        12,
        -21
      ],
      [
        9,
        43
      ],
      [
        24,
        13
      ],
      [
        23,
        13
      ],
      [
        -2,
        45
      ],
      [
        -5,
        81
      ],
      [
        -2,
        21
      ],
      [
        -4,
        64
      ],
      [
        -2,
        43
      ],
      [
        35,
        19
      ],
      [
        -6,
        100
      ],
      [
        35,
        19
      ],
      [
        -7,
        106
      ],
      [
        -2,
        36
      ],
      [
        69,
        36
      ]
    ],
    [
      [
        30978,
        68642
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -16
      ],
      [
        -5,
        -14
      ],
      [
        -2,
        0
      ],
      [
        -3,
        15
      ],
      [
        -1,
        8
      ],
      [
        -1,
        4
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -12
      ],
      [
        1,
        -8
      ],
      [
        -5,
        -35
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -17
      ],
      [
        -1,
        -15
      ],
      [
        -3,
        1
      ],
      [
        -2,
        5
      ],
      [
        -3,
        14
      ],
      [
        -5,
        4
      ],
      [
        -2,
        8
      ],
      [
        -1,
        7
      ],
      [
        1,
        18
      ],
      [
        -1,
        18
      ],
      [
        -6,
        -9
      ],
      [
        -4,
        -12
      ],
      [
        -2,
        11
      ],
      [
        -9,
        -2
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -7
      ],
      [
        1,
        -20
      ],
      [
        3,
        -15
      ],
      [
        0,
        -18
      ],
      [
        -5,
        -25
      ],
      [
        -9,
        -19
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -22
      ],
      [
        7,
        -4
      ],
      [
        4,
        -29
      ],
      [
        -2,
        -3
      ],
      [
        -14,
        -1
      ],
      [
        -5,
        -2
      ],
      [
        -2,
        4
      ],
      [
        -7,
        6
      ],
      [
        -5,
        -20
      ],
      [
        -6,
        -3
      ],
      [
        -1,
        8
      ],
      [
        -6,
        10
      ],
      [
        -2,
        6
      ],
      [
        -2,
        5
      ],
      [
        -3,
        -1
      ],
      [
        -3,
        7
      ],
      [
        -6,
        26
      ],
      [
        0,
        11
      ],
      [
        -1,
        12
      ],
      [
        -2,
        5
      ],
      [
        0,
        16
      ],
      [
        -1,
        5
      ],
      [
        -3,
        9
      ],
      [
        -2,
        13
      ],
      [
        -1,
        10
      ],
      [
        3,
        18
      ],
      [
        3,
        11
      ],
      [
        4,
        5
      ],
      [
        6,
        3
      ],
      [
        9,
        17
      ],
      [
        1,
        -2
      ],
      [
        1,
        0
      ],
      [
        1,
        4
      ],
      [
        -1,
        12
      ],
      [
        -3,
        22
      ],
      [
        0,
        2
      ],
      [
        -2,
        7
      ],
      [
        -3,
        2
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -10
      ],
      [
        -7,
        -24
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        1
      ],
      [
        -2,
        5
      ],
      [
        1,
        29
      ],
      [
        1,
        15
      ],
      [
        -3,
        10
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -8
      ],
      [
        2,
        -28
      ],
      [
        -2,
        -17
      ],
      [
        0,
        -8
      ],
      [
        1,
        -6
      ],
      [
        0,
        -9
      ],
      [
        -2,
        -1
      ],
      [
        -3,
        1
      ],
      [
        -1,
        12
      ],
      [
        0,
        10
      ],
      [
        3,
        8
      ],
      [
        -2,
        34
      ],
      [
        -2,
        1
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -18
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        2
      ],
      [
        -4,
        -17
      ],
      [
        -2,
        -1
      ],
      [
        -5,
        7
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -16
      ],
      [
        2,
        -12
      ],
      [
        2,
        -3
      ],
      [
        1,
        -20
      ],
      [
        -2,
        -10
      ],
      [
        -3,
        -15
      ],
      [
        -1,
        -18
      ],
      [
        1,
        -6
      ],
      [
        0,
        -6
      ],
      [
        2,
        -8
      ],
      [
        5,
        -1
      ],
      [
        2,
        -11
      ],
      [
        0,
        -5
      ],
      [
        1,
        -12
      ],
      [
        3,
        -13
      ],
      [
        0,
        -5
      ],
      [
        -3,
        -13
      ],
      [
        0,
        -9
      ],
      [
        2,
        -7
      ],
      [
        -1,
        -9
      ],
      [
        -1,
        -7
      ],
      [
        -7,
        -8
      ],
      [
        -3,
        -3
      ],
      [
        0,
        -24
      ],
      [
        -4,
        -7
      ],
      [
        -5,
        -13
      ],
      [
        -4,
        -22
      ],
      [
        9,
        -11
      ],
      [
        -7,
        -12
      ],
      [
        -2,
        -13
      ],
      [
        -3,
        -6
      ],
      [
        0,
        -8
      ]
    ],
    [
      [
        30793,
        68290
      ],
      [
        -3,
        2
      ],
      [
        0,
        1
      ],
      [
        -4,
        5
      ],
      [
        -1,
        1
      ],
      [
        -2,
        0
      ]
    ],
    [
      [
        30783,
        68299
      ],
      [
        0,
        8
      ],
      [
        -7,
        13
      ],
      [
        -10,
        32
      ],
      [
        0,
        25
      ],
      [
        -3,
        17
      ],
      [
        -1,
        22
      ],
      [
        6,
        13
      ],
      [
        4,
        17
      ],
      [
        5,
        21
      ],
      [
        -6,
        7
      ],
      [
        -7,
        13
      ],
      [
        -6,
        20
      ],
      [
        2,
        13
      ],
      [
        2,
        7
      ],
      [
        2,
        6
      ],
      [
        -6,
        11
      ],
      [
        -4,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -8
      ],
      [
        -6,
        -15
      ],
      [
        -9,
        5
      ],
      [
        0,
        26
      ],
      [
        2,
        18
      ],
      [
        1,
        4
      ],
      [
        0,
        10
      ],
      [
        -1,
        15
      ],
      [
        0,
        1
      ],
      [
        -1,
        39
      ],
      [
        2,
        22
      ],
      [
        4,
        8
      ],
      [
        1,
        16
      ],
      [
        4,
        -2
      ],
      [
        -1,
        18
      ],
      [
        1,
        14
      ],
      [
        1,
        18
      ],
      [
        -2,
        26
      ],
      [
        -3,
        16
      ],
      [
        -1,
        -1
      ]
    ],
    [
      [
        30743,
        68770
      ],
      [
        -1,
        33
      ],
      [
        2,
        17
      ],
      [
        -4,
        6
      ],
      [
        -8,
        44
      ],
      [
        -2,
        10
      ],
      [
        9,
        75
      ]
    ],
    [
      [
        23590,
        56449
      ],
      [
        2,
        4
      ],
      [
        6,
        -17
      ],
      [
        3,
        3
      ],
      [
        7,
        -7
      ],
      [
        -3,
        20
      ],
      [
        4,
        3
      ],
      [
        6,
        -6
      ],
      [
        2,
        -9
      ],
      [
        -3,
        -44
      ],
      [
        8,
        -9
      ],
      [
        -3,
        -11
      ],
      [
        9,
        6
      ],
      [
        2,
        -26
      ],
      [
        2,
        3
      ],
      [
        6,
        -11
      ],
      [
        0,
        -38
      ],
      [
        5,
        10
      ],
      [
        5,
        -14
      ],
      [
        5,
        0
      ],
      [
        3,
        -18
      ],
      [
        6,
        14
      ],
      [
        0,
        -12
      ],
      [
        7,
        10
      ],
      [
        2,
        -3
      ],
      [
        -1,
        -24
      ],
      [
        7,
        -6
      ],
      [
        5,
        6
      ],
      [
        0,
        -8
      ],
      [
        7,
        10
      ],
      [
        9,
        -9
      ],
      [
        13,
        -1
      ],
      [
        0,
        -34
      ],
      [
        23,
        -3
      ]
    ],
    [
      [
        23734,
        56228
      ],
      [
        -3,
        -26
      ],
      [
        1,
        -17
      ],
      [
        4,
        -8
      ],
      [
        -4,
        -3
      ],
      [
        2,
        -12
      ],
      [
        -2,
        -25
      ],
      [
        6,
        -15
      ],
      [
        2,
        -14
      ],
      [
        2,
        19
      ],
      [
        5,
        -1
      ],
      [
        3,
        -14
      ],
      [
        -4,
        -25
      ],
      [
        7,
        10
      ],
      [
        2,
        -13
      ],
      [
        3,
        8
      ],
      [
        3,
        -7
      ],
      [
        3,
        -16
      ],
      [
        3,
        3
      ],
      [
        4,
        -8
      ]
    ],
    [
      [
        23771,
        56064
      ],
      [
        -1,
        -8
      ],
      [
        -8,
        10
      ],
      [
        -5,
        -24
      ],
      [
        -4,
        2
      ],
      [
        -2,
        -24
      ],
      [
        -9,
        13
      ],
      [
        -3,
        -13
      ],
      [
        2,
        -25
      ],
      [
        -5,
        -1
      ],
      [
        -4,
        37
      ],
      [
        -3,
        -6
      ],
      [
        2,
        -25
      ],
      [
        -5,
        -25
      ],
      [
        -3,
        8
      ],
      [
        2,
        21
      ],
      [
        -2,
        7
      ],
      [
        -13,
        -14
      ]
    ],
    [
      [
        23710,
        55997
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        23710,
        55996
      ],
      [
        -1,
        0
      ],
      [
        -2,
        19
      ],
      [
        -5,
        5
      ],
      [
        -8,
        -2
      ],
      [
        -6,
        -21
      ],
      [
        -5,
        30
      ],
      [
        -6,
        13
      ],
      [
        -6,
        4
      ],
      [
        -7,
        -22
      ],
      [
        -4,
        -24
      ],
      [
        -7,
        4
      ],
      [
        3,
        24
      ],
      [
        -4,
        10
      ],
      [
        -5,
        -24
      ],
      [
        -3,
        11
      ],
      [
        -5,
        2
      ],
      [
        -3,
        -29
      ],
      [
        -6,
        2
      ],
      [
        -2,
        16
      ],
      [
        -4,
        -7
      ],
      [
        -1,
        -20
      ],
      [
        -10,
        9
      ],
      [
        1,
        16
      ],
      [
        3,
        11
      ],
      [
        -2,
        9
      ],
      [
        -9,
        -6
      ],
      [
        -5,
        20
      ],
      [
        -6,
        5
      ],
      [
        2,
        24
      ],
      [
        -2,
        30
      ],
      [
        -7,
        -7
      ],
      [
        -1,
        -1
      ]
    ],
    [
      [
        23587,
        56097
      ],
      [
        0,
        29
      ],
      [
        1,
        29
      ],
      [
        0,
        134
      ],
      [
        1,
        32
      ],
      [
        0,
        59
      ],
      [
        1,
        66
      ],
      [
        0,
        3
      ]
    ],
    [
      [
        23569,
        58965
      ],
      [
        36,
        -2
      ],
      [
        8,
        -1
      ],
      [
        1,
        50
      ],
      [
        15,
        0
      ],
      [
        0,
        45
      ],
      [
        1,
        39
      ],
      [
        6,
        0
      ],
      [
        36,
        -3
      ],
      [
        2,
        -1
      ],
      [
        10,
        -1
      ],
      [
        13,
        0
      ],
      [
        21,
        -2
      ],
      [
        -2,
        18
      ],
      [
        4,
        7
      ],
      [
        3,
        -22
      ],
      [
        4,
        1
      ],
      [
        3,
        -9
      ],
      [
        0,
        28
      ],
      [
        4,
        -7
      ],
      [
        4,
        16
      ],
      [
        16,
        -1
      ]
    ],
    [
      [
        23754,
        59120
      ],
      [
        -16,
        -168
      ],
      [
        0,
        -66
      ],
      [
        -1,
        -65
      ],
      [
        0,
        -102
      ],
      [
        -1,
        -67
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -84
      ]
    ],
    [
      [
        23733,
        58568
      ],
      [
        -40,
        4
      ],
      [
        -5,
        0
      ],
      [
        0,
        -16
      ],
      [
        -25,
        3
      ],
      [
        -19,
        2
      ],
      [
        -29,
        3
      ],
      [
        -30,
        2
      ]
    ],
    [
      [
        23585,
        58566
      ],
      [
        0,
        11
      ],
      [
        -1,
        29
      ],
      [
        -1,
        4
      ],
      [
        0,
        11
      ],
      [
        -1,
        13
      ],
      [
        0,
        19
      ],
      [
        -1,
        14
      ],
      [
        -3,
        65
      ],
      [
        -1,
        38
      ],
      [
        0,
        11
      ],
      [
        -1,
        2
      ],
      [
        -1,
        23
      ],
      [
        0,
        1
      ],
      [
        -1,
        25
      ],
      [
        0,
        17
      ],
      [
        -1,
        6
      ],
      [
        -3,
        81
      ],
      [
        0,
        1
      ],
      [
        -1,
        28
      ]
    ],
    [
      [
        24128,
        57628
      ],
      [
        17,
        -3
      ],
      [
        2,
        -5
      ],
      [
        7,
        -47
      ],
      [
        -3,
        -57
      ],
      [
        7,
        -17
      ],
      [
        -3,
        17
      ],
      [
        2,
        15
      ],
      [
        -3,
        36
      ],
      [
        9,
        15
      ],
      [
        0,
        21
      ],
      [
        44,
        -4
      ],
      [
        9,
        -1
      ],
      [
        0,
        101
      ],
      [
        6,
        0
      ],
      [
        24,
        -2
      ]
    ],
    [
      [
        24246,
        57697
      ],
      [
        14,
        -1
      ],
      [
        0,
        -109
      ],
      [
        -1,
        -24
      ],
      [
        0,
        -70
      ],
      [
        -1,
        -55
      ],
      [
        0,
        -70
      ],
      [
        -4,
        -22
      ],
      [
        -2,
        -49
      ],
      [
        0,
        -12
      ],
      [
        -4,
        -42
      ],
      [
        24,
        -2
      ],
      [
        -1,
        -153
      ]
    ],
    [
      [
        24271,
        57088
      ],
      [
        -31,
        2
      ],
      [
        -18,
        2
      ]
    ],
    [
      [
        24222,
        57092
      ],
      [
        -11,
        1
      ]
    ],
    [
      [
        24074,
        57512
      ],
      [
        -5,
        0
      ],
      [
        1,
        67
      ],
      [
        29,
        -1
      ],
      [
        0,
        34
      ],
      [
        17,
        -2
      ],
      [
        12,
        -2
      ],
      [
        0,
        20
      ]
    ],
    [
      [
        24246,
        57760
      ],
      [
        9,
        -2
      ],
      [
        4,
        12
      ],
      [
        7,
        -10
      ],
      [
        10,
        11
      ],
      [
        3,
        -16
      ],
      [
        6,
        -5
      ],
      [
        0,
        -3
      ],
      [
        8,
        -12
      ],
      [
        7,
        2
      ],
      [
        7,
        -21
      ],
      [
        2,
        4
      ],
      [
        5,
        -9
      ],
      [
        21,
        7
      ]
    ],
    [
      [
        24335,
        57718
      ],
      [
        -1,
        -127
      ],
      [
        31,
        -2
      ],
      [
        0,
        -51
      ],
      [
        -2,
        -237
      ],
      [
        2,
        -2
      ],
      [
        14,
        -39
      ],
      [
        2,
        -13
      ],
      [
        -3,
        -15
      ],
      [
        -5,
        -39
      ],
      [
        8,
        -15
      ],
      [
        1,
        -16
      ],
      [
        -10,
        -40
      ],
      [
        -3,
        -23
      ],
      [
        1,
        -20
      ]
    ],
    [
      [
        24370,
        57079
      ],
      [
        -8,
        1
      ]
    ],
    [
      [
        24362,
        57080
      ],
      [
        -75,
        7
      ],
      [
        -11,
        1
      ],
      [
        -5,
        0
      ]
    ],
    [
      [
        24246,
        57697
      ],
      [
        0,
        63
      ]
    ],
    [
      [
        21194,
        60759
      ],
      [
        14,
        2
      ],
      [
        77,
        -1
      ]
    ],
    [
      [
        21285,
        60760
      ],
      [
        197,
        0
      ]
    ],
    [
      [
        21482,
        60760
      ],
      [
        0,
        -297
      ]
    ],
    [
      [
        21482,
        60463
      ],
      [
        0,
        -461
      ]
    ],
    [
      [
        21482,
        60002
      ],
      [
        -3,
        0
      ],
      [
        -37,
        1
      ],
      [
        -6,
        0
      ],
      [
        -15,
        1
      ],
      [
        -26,
        0
      ],
      [
        -96,
        1
      ],
      [
        -12,
        3
      ],
      [
        -10,
        2
      ],
      [
        -18,
        0
      ],
      [
        -38,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -4,
        2
      ]
    ],
    [
      [
        21215,
        60011
      ],
      [
        -24,
        0
      ]
    ],
    [
      [
        21191,
        60011
      ],
      [
        1,
        444
      ],
      [
        2,
        0
      ],
      [
        0,
        304
      ]
    ],
    [
      [
        18150,
        66443
      ],
      [
        4,
        9
      ],
      [
        15,
        2
      ]
    ],
    [
      [
        18169,
        66454
      ],
      [
        12,
        16
      ],
      [
        4,
        0
      ],
      [
        10,
        -15
      ],
      [
        3,
        -1
      ],
      [
        7,
        18
      ],
      [
        7,
        7
      ],
      [
        4,
        -11
      ],
      [
        2,
        -16
      ],
      [
        5,
        -13
      ],
      [
        11,
        -4
      ],
      [
        13,
        20
      ],
      [
        3,
        11
      ],
      [
        6,
        48
      ],
      [
        4,
        11
      ],
      [
        6,
        33
      ],
      [
        3,
        24
      ],
      [
        5,
        13
      ],
      [
        18,
        20
      ],
      [
        6,
        -5
      ]
    ],
    [
      [
        18298,
        66610
      ],
      [
        16,
        6
      ],
      [
        11,
        15
      ],
      [
        4,
        -18
      ],
      [
        15,
        -50
      ],
      [
        12,
        -1
      ],
      [
        1,
        -12
      ],
      [
        6,
        9
      ]
    ],
    [
      [
        18363,
        66559
      ],
      [
        12,
        10
      ],
      [
        5,
        -8
      ],
      [
        0,
        -44
      ],
      [
        48,
        -2
      ],
      [
        1,
        -303
      ]
    ],
    [
      [
        18429,
        66212
      ],
      [
        0,
        -383
      ]
    ],
    [
      [
        18429,
        65829
      ],
      [
        -69,
        -3
      ],
      [
        -1,
        0
      ],
      [
        -25,
        -1
      ],
      [
        -5,
        -1
      ],
      [
        -20,
        0
      ],
      [
        -18,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -74,
        -4
      ],
      [
        -9,
        0
      ],
      [
        -7,
        -1
      ],
      [
        -20,
        0
      ],
      [
        -28,
        5
      ],
      [
        -13,
        1
      ]
    ],
    [
      [
        18139,
        65823
      ],
      [
        -2,
        0
      ],
      [
        0,
        1
      ],
      [
        -65,
        0
      ]
    ],
    [
      [
        18072,
        65824
      ],
      [
        -1,
        392
      ],
      [
        0,
        101
      ],
      [
        60,
        -1
      ],
      [
        0,
        100
      ],
      [
        1,
        14
      ],
      [
        18,
        13
      ]
    ],
    [
      [
        25667,
        55164
      ],
      [
        40,
        0
      ],
      [
        0,
        248
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        25706,
        55412
      ],
      [
        0,
        26
      ],
      [
        11,
        -1
      ],
      [
        5,
        -3
      ],
      [
        6,
        0
      ],
      [
        20,
        1
      ],
      [
        33,
        1
      ],
      [
        2,
        -18
      ],
      [
        14,
        -42
      ],
      [
        5,
        7
      ],
      [
        5,
        -5
      ]
    ],
    [
      [
        25807,
        55378
      ],
      [
        -1,
        -19
      ],
      [
        3,
        -22
      ],
      [
        -2,
        -16
      ],
      [
        1,
        -49
      ],
      [
        7,
        -28
      ],
      [
        3,
        -36
      ],
      [
        4,
        -6
      ],
      [
        4,
        -6
      ],
      [
        1,
        -15
      ],
      [
        -4,
        -21
      ],
      [
        1,
        -22
      ],
      [
        8,
        -26
      ],
      [
        4,
        -4
      ],
      [
        5,
        -30
      ],
      [
        6,
        -11
      ]
    ],
    [
      [
        25847,
        55067
      ],
      [
        -11,
        -3
      ],
      [
        0,
        -50
      ]
    ],
    [
      [
        25836,
        55014
      ],
      [
        -17,
        0
      ],
      [
        -14,
        -1
      ],
      [
        -53,
        -1
      ],
      [
        1,
        -52
      ],
      [
        -17,
        -1
      ],
      [
        -12,
        0
      ],
      [
        -28,
        4
      ]
    ],
    [
      [
        25696,
        54963
      ],
      [
        -28,
        -1
      ],
      [
        0,
        77
      ]
    ],
    [
      [
        25668,
        55039
      ],
      [
        0,
        68
      ],
      [
        -1,
        57
      ]
    ],
    [
      [
        26617,
        54223
      ],
      [
        0,
        -203
      ]
    ],
    [
      [
        26617,
        54020
      ],
      [
        0,
        -58
      ],
      [
        -53,
        -1
      ]
    ],
    [
      [
        26564,
        53961
      ],
      [
        -7,
        8
      ],
      [
        -5,
        25
      ],
      [
        -22,
        20
      ],
      [
        -4,
        -1
      ]
    ],
    [
      [
        26526,
        54013
      ],
      [
        3,
        18
      ],
      [
        -2,
        21
      ],
      [
        3,
        33
      ]
    ],
    [
      [
        23139,
        68893
      ],
      [
        137,
        -1
      ],
      [
        2,
        -102
      ]
    ],
    [
      [
        23278,
        68790
      ],
      [
        0,
        -200
      ],
      [
        1,
        -102
      ],
      [
        0,
        -102
      ]
    ],
    [
      [
        23143,
        68388
      ],
      [
        0,
        403
      ],
      [
        -4,
        1
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        28051,
        60406
      ],
      [
        60,
        344
      ],
      [
        2,
        64
      ]
    ],
    [
      [
        28113,
        60814
      ],
      [
        5,
        25
      ],
      [
        12,
        39
      ],
      [
        6,
        4
      ]
    ],
    [
      [
        28136,
        60882
      ],
      [
        16,
        -38
      ],
      [
        3,
        -24
      ],
      [
        -5,
        -18
      ],
      [
        10,
        -26
      ]
    ],
    [
      [
        28160,
        60776
      ],
      [
        -5,
        -21
      ],
      [
        1,
        -13
      ],
      [
        -13,
        -202
      ]
    ],
    [
      [
        28143,
        60540
      ],
      [
        -2,
        6
      ],
      [
        -8,
        -20
      ],
      [
        -4,
        2
      ],
      [
        -1,
        -22
      ],
      [
        -13,
        -67
      ]
    ],
    [
      [
        28115,
        60439
      ],
      [
        -7,
        -9
      ],
      [
        0,
        -20
      ],
      [
        -5,
        4
      ],
      [
        -4,
        -25
      ],
      [
        -5,
        -5
      ],
      [
        -3,
        -14
      ],
      [
        -6,
        12
      ],
      [
        -3,
        -20
      ],
      [
        -3,
        10
      ],
      [
        -9,
        -6
      ],
      [
        -5,
        22
      ],
      [
        -7,
        3
      ],
      [
        -7,
        15
      ]
    ],
    [
      [
        23036,
        63808
      ],
      [
        111,
        0
      ]
    ],
    [
      [
        23147,
        63808
      ],
      [
        16,
        -1
      ]
    ],
    [
      [
        23163,
        63807
      ],
      [
        -1,
        -304
      ]
    ],
    [
      [
        23162,
        63503
      ],
      [
        -63,
        0
      ]
    ],
    [
      [
        23099,
        63503
      ],
      [
        -18,
        0
      ],
      [
        -45,
        1
      ]
    ],
    [
      [
        23036,
        63504
      ],
      [
        0,
        304
      ]
    ],
    [
      [
        22051,
        58403
      ],
      [
        0,
        -229
      ]
    ],
    [
      [
        22051,
        57895
      ],
      [
        -150,
        1
      ]
    ],
    [
      [
        22641,
        72434
      ],
      [
        107,
        -1
      ],
      [
        7,
        0
      ]
    ],
    [
      [
        22755,
        72433
      ],
      [
        0,
        -404
      ],
      [
        6,
        0
      ],
      [
        0,
        -100
      ]
    ],
    [
      [
        22657,
        64316
      ],
      [
        0,
        405
      ]
    ],
    [
      [
        26272,
        68754
      ],
      [
        -135,
        1
      ]
    ],
    [
      [
        26137,
        68755
      ],
      [
        0,
        350
      ]
    ],
    [
      [
        22311,
        63000
      ],
      [
        6,
        0
      ]
    ],
    [
      [
        22317,
        63000
      ],
      [
        -1,
        -507
      ]
    ],
    [
      [
        25263,
        62589
      ],
      [
        0,
        186
      ]
    ],
    [
      [
        25263,
        62775
      ],
      [
        124,
        3
      ],
      [
        1,
        1
      ],
      [
        3,
        1
      ]
    ],
    [
      [
        25391,
        62780
      ],
      [
        1,
        -239
      ]
    ],
    [
      [
        27442,
        61787
      ],
      [
        39,
        139
      ],
      [
        15,
        109
      ]
    ],
    [
      [
        27496,
        62035
      ],
      [
        3,
        -14
      ],
      [
        15,
        0
      ]
    ],
    [
      [
        27514,
        62021
      ],
      [
        11,
        4
      ],
      [
        6,
        -16
      ],
      [
        3,
        -38
      ],
      [
        11,
        12
      ]
    ],
    [
      [
        27545,
        61983
      ],
      [
        20,
        -145
      ],
      [
        7,
        -52
      ],
      [
        -17,
        -159
      ]
    ],
    [
      [
        27523,
        61437
      ],
      [
        -22,
        49
      ]
    ],
    [
      [
        27501,
        61486
      ],
      [
        -48,
        106
      ],
      [
        -1,
        10
      ],
      [
        -3,
        -15
      ],
      [
        -3,
        25
      ],
      [
        -7,
        43
      ],
      [
        6,
        13
      ],
      [
        -3,
        25
      ],
      [
        -8,
        68
      ],
      [
        8,
        26
      ]
    ],
    [
      [
        25111,
        57676
      ],
      [
        25,
        0
      ],
      [
        11,
        2
      ],
      [
        10,
        -1
      ],
      [
        8,
        0
      ]
    ],
    [
      [
        25165,
        57677
      ],
      [
        0,
        -159
      ],
      [
        19,
        0
      ],
      [
        0,
        -119
      ],
      [
        10,
        0
      ]
    ],
    [
      [
        25194,
        57399
      ],
      [
        0,
        -186
      ],
      [
        -5,
        0
      ]
    ],
    [
      [
        25189,
        57213
      ],
      [
        -6,
        0
      ],
      [
        -92,
        2
      ]
    ],
    [
      [
        25091,
        57215
      ],
      [
        0,
        252
      ],
      [
        15,
        0
      ],
      [
        0,
        51
      ],
      [
        5,
        0
      ],
      [
        0,
        158
      ]
    ],
    [
      [
        26747,
        53576
      ],
      [
        7,
        1
      ],
      [
        2,
        6
      ],
      [
        4,
        32
      ],
      [
        4,
        12
      ],
      [
        7,
        57
      ],
      [
        0,
        54
      ],
      [
        4,
        -1
      ],
      [
        0,
        16
      ],
      [
        4,
        -1
      ],
      [
        0,
        15
      ],
      [
        4,
        -1
      ],
      [
        1,
        29
      ],
      [
        4,
        0
      ],
      [
        0,
        15
      ]
    ],
    [
      [
        26788,
        53810
      ],
      [
        0,
        125
      ]
    ],
    [
      [
        26788,
        53935
      ],
      [
        5,
        14
      ],
      [
        7,
        -11
      ],
      [
        2,
        5
      ],
      [
        11,
        -3
      ],
      [
        6,
        -6
      ],
      [
        5,
        3
      ],
      [
        9,
        39
      ]
    ],
    [
      [
        26833,
        53976
      ],
      [
        0,
        -168
      ],
      [
        6,
        0
      ],
      [
        52,
        1
      ]
    ],
    [
      [
        26891,
        53809
      ],
      [
        0,
        -133
      ],
      [
        9,
        -1
      ],
      [
        -1,
        -103
      ]
    ],
    [
      [
        26899,
        53572
      ],
      [
        -8,
        0
      ],
      [
        0,
        -122
      ]
    ],
    [
      [
        26748,
        53515
      ],
      [
        -3,
        48
      ],
      [
        2,
        13
      ]
    ],
    [
      [
        22628,
        62189
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        22628,
        62290
      ],
      [
        155,
        0
      ]
    ],
    [
      [
        22783,
        62290
      ],
      [
        -2,
        -34
      ],
      [
        2,
        -17
      ],
      [
        0,
        -355
      ]
    ],
    [
      [
        22783,
        61884
      ],
      [
        -61,
        -1
      ],
      [
        -31,
        1
      ],
      [
        -62,
        0
      ]
    ],
    [
      [
        22629,
        61884
      ],
      [
        -1,
        102
      ],
      [
        0,
        203
      ]
    ],
    [
      [
        24726,
        57012
      ],
      [
        27,
        0
      ],
      [
        -1,
        99
      ],
      [
        30,
        2
      ]
    ],
    [
      [
        24782,
        57113
      ],
      [
        1,
        -199
      ],
      [
        0,
        -45
      ],
      [
        16,
        -41
      ],
      [
        0,
        -123
      ]
    ],
    [
      [
        24799,
        56705
      ],
      [
        0,
        -102
      ],
      [
        -88,
        0
      ]
    ],
    [
      [
        24711,
        56603
      ],
      [
        0,
        221
      ],
      [
        15,
        -1
      ],
      [
        0,
        189
      ]
    ],
    [
      [
        22329,
        70816
      ],
      [
        -10,
        1
      ]
    ],
    [
      [
        22473,
        62188
      ],
      [
        93,
        0
      ],
      [
        62,
        1
      ]
    ],
    [
      [
        22629,
        61884
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        22629,
        61783
      ],
      [
        -92,
        -1
      ],
      [
        -63,
        0
      ]
    ],
    [
      [
        22474,
        61782
      ],
      [
        0,
        204
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        22473,
        61986
      ],
      [
        0,
        202
      ]
    ],
    [
      [
        25606,
        62539
      ],
      [
        31,
        -4
      ],
      [
        17,
        -1
      ],
      [
        4,
        0
      ]
    ],
    [
      [
        25658,
        62534
      ],
      [
        103,
        -2
      ]
    ],
    [
      [
        25761,
        62532
      ],
      [
        0,
        -202
      ]
    ],
    [
      [
        25761,
        62228
      ],
      [
        -61,
        -1
      ]
    ],
    [
      [
        25700,
        62227
      ],
      [
        -37,
        -2
      ],
      [
        -18,
        2
      ]
    ],
    [
      [
        25645,
        62227
      ],
      [
        -8,
        4
      ],
      [
        -31,
        0
      ]
    ],
    [
      [
        25606,
        62231
      ],
      [
        0,
        308
      ]
    ],
    [
      [
        24041,
        63902
      ],
      [
        48,
        0
      ]
    ],
    [
      [
        24089,
        63902
      ],
      [
        93,
        4
      ]
    ],
    [
      [
        24183,
        63855
      ],
      [
        0,
        -101
      ],
      [
        1,
        -208
      ]
    ],
    [
      [
        24184,
        63546
      ],
      [
        -92,
        1
      ],
      [
        -3,
        0
      ],
      [
        -45,
        -1
      ]
    ],
    [
      [
        24044,
        63546
      ],
      [
        -3,
        0
      ]
    ],
    [
      [
        27031,
        64280
      ],
      [
        69,
        -1
      ],
      [
        63,
        1
      ]
    ],
    [
      [
        27163,
        64280
      ],
      [
        1,
        -38
      ]
    ],
    [
      [
        27164,
        64242
      ],
      [
        -6,
        -3
      ],
      [
        0,
        -220
      ],
      [
        -11,
        1
      ]
    ],
    [
      [
        27147,
        64020
      ],
      [
        -105,
        11
      ],
      [
        -1,
        -1
      ],
      [
        -27,
        4
      ]
    ],
    [
      [
        27005,
        64164
      ],
      [
        -1,
        31
      ],
      [
        0,
        85
      ],
      [
        27,
        0
      ]
    ],
    [
      [
        24146,
        58111
      ],
      [
        -1,
        -102
      ],
      [
        -9,
        -28
      ],
      [
        3,
        -19
      ],
      [
        -7,
        -19
      ],
      [
        2,
        -3
      ],
      [
        -1,
        -37
      ],
      [
        7,
        -18
      ],
      [
        -2,
        -44
      ],
      [
        -3,
        -25
      ],
      [
        -7,
        13
      ],
      [
        -3,
        -15
      ]
    ],
    [
      [
        24125,
        57814
      ],
      [
        -2,
        3
      ],
      [
        -10,
        -35
      ],
      [
        -6,
        -9
      ],
      [
        -7,
        -2
      ],
      [
        0,
        9
      ],
      [
        6,
        11
      ],
      [
        0,
        18
      ],
      [
        -7,
        -5
      ],
      [
        -7,
        -30
      ],
      [
        -12,
        -8
      ],
      [
        -54,
        3
      ],
      [
        -14,
        2
      ],
      [
        -5,
        -1
      ],
      [
        -17,
        2
      ]
    ],
    [
      [
        23990,
        57772
      ],
      [
        4,
        13
      ],
      [
        -4,
        24
      ],
      [
        17,
        11
      ],
      [
        0,
        15
      ],
      [
        6,
        11
      ],
      [
        9,
        32
      ],
      [
        8,
        3
      ]
    ],
    [
      [
        25821,
        64562
      ],
      [
        -32,
        1
      ]
    ],
    [
      [
        25789,
        64563
      ],
      [
        -97,
        2
      ]
    ],
    [
      [
        25692,
        64565
      ],
      [
        0,
        302
      ]
    ],
    [
      [
        31449,
        38179
      ],
      [
        11,
        10
      ],
      [
        3,
        24
      ],
      [
        3,
        2
      ]
    ],
    [
      [
        31466,
        38215
      ],
      [
        1,
        0
      ],
      [
        3,
        -20
      ]
    ],
    [
      [
        31470,
        38195
      ],
      [
        4,
        -15
      ],
      [
        2,
        -26
      ]
    ],
    [
      [
        31476,
        38154
      ],
      [
        -3,
        -25
      ],
      [
        -7,
        -7
      ],
      [
        -1,
        -27
      ],
      [
        -8,
        13
      ]
    ],
    [
      [
        22399,
        65529
      ],
      [
        127,
        0
      ]
    ],
    [
      [
        22526,
        65529
      ],
      [
        1,
        -4
      ],
      [
        0,
        -299
      ]
    ],
    [
      [
        22401,
        65126
      ],
      [
        -2,
        -1
      ]
    ],
    [
      [
        21615,
        56321
      ],
      [
        146,
        4
      ]
    ],
    [
      [
        25168,
        59746
      ],
      [
        0,
        203
      ]
    ],
    [
      [
        25168,
        59949
      ],
      [
        29,
        -1
      ],
      [
        2,
        -4
      ],
      [
        35,
        0
      ],
      [
        25,
        -1
      ]
    ],
    [
      [
        25259,
        59943
      ],
      [
        0,
        -223
      ]
    ],
    [
      [
        25259,
        59720
      ],
      [
        -1,
        -290
      ]
    ],
    [
      [
        25258,
        59430
      ],
      [
        -8,
        0
      ]
    ],
    [
      [
        25250,
        59430
      ],
      [
        -8,
        1
      ],
      [
        -32,
        0
      ],
      [
        -15,
        1
      ],
      [
        -28,
        0
      ]
    ],
    [
      [
        25167,
        59432
      ],
      [
        0,
        209
      ],
      [
        -1,
        85
      ],
      [
        1,
        14
      ],
      [
        1,
        6
      ]
    ],
    [
      [
        25958,
        59688
      ],
      [
        47,
        115
      ],
      [
        10,
        17
      ],
      [
        9,
        6
      ]
    ],
    [
      [
        26024,
        59826
      ],
      [
        35,
        -10
      ],
      [
        3,
        -4
      ],
      [
        2,
        -13
      ]
    ],
    [
      [
        26064,
        59799
      ],
      [
        2,
        -48
      ],
      [
        5,
        -7
      ],
      [
        8,
        4
      ],
      [
        7,
        -50
      ],
      [
        13,
        2
      ],
      [
        -7,
        -50
      ],
      [
        16,
        -84
      ]
    ],
    [
      [
        26108,
        59566
      ],
      [
        -14,
        -4
      ],
      [
        -18,
        1
      ],
      [
        -35,
        3
      ],
      [
        -15,
        3
      ],
      [
        -16,
        1
      ]
    ],
    [
      [
        26010,
        59570
      ],
      [
        -3,
        1
      ],
      [
        -9,
        -1
      ],
      [
        -11,
        2
      ],
      [
        -24,
        6
      ],
      [
        -5,
        0
      ]
    ],
    [
      [
        25958,
        59578
      ],
      [
        7,
        26
      ],
      [
        1,
        13
      ],
      [
        -8,
        63
      ],
      [
        0,
        8
      ]
    ],
    [
      [
        24938,
        62338
      ],
      [
        14,
        0
      ],
      [
        0,
        33
      ],
      [
        94,
        0
      ]
    ],
    [
      [
        25045,
        62038
      ],
      [
        -69,
        -1
      ],
      [
        -27,
        3
      ]
    ],
    [
      [
        24949,
        62040
      ],
      [
        0,
        153
      ],
      [
        -11,
        -1
      ],
      [
        0,
        146
      ]
    ],
    [
      [
        23742,
        57293
      ],
      [
        15,
        0
      ],
      [
        0,
        25
      ],
      [
        2,
        30
      ],
      [
        15,
        -2
      ],
      [
        9,
        9
      ],
      [
        0,
        16
      ],
      [
        10,
        -1
      ],
      [
        1,
        17
      ],
      [
        9,
        -1
      ]
    ],
    [
      [
        23803,
        57386
      ],
      [
        88,
        -2
      ]
    ],
    [
      [
        23891,
        57384
      ],
      [
        0,
        -68
      ],
      [
        -2,
        0
      ],
      [
        0,
        -97
      ],
      [
        -1,
        -239
      ]
    ],
    [
      [
        23888,
        56980
      ],
      [
        -1,
        -67
      ]
    ],
    [
      [
        23887,
        56913
      ],
      [
        -19,
        2
      ]
    ],
    [
      [
        23868,
        56915
      ],
      [
        -54,
        5
      ],
      [
        -20,
        3
      ],
      [
        -24,
        0
      ],
      [
        -29,
        3
      ]
    ],
    [
      [
        23741,
        56926
      ],
      [
        0,
        234
      ],
      [
        1,
        133
      ]
    ],
    [
      [
        25957,
        59342
      ],
      [
        23,
        -6
      ],
      [
        19,
        -10
      ]
    ],
    [
      [
        25999,
        59326
      ],
      [
        -5,
        -144
      ],
      [
        3,
        -8
      ],
      [
        2,
        -30
      ],
      [
        4,
        -8
      ],
      [
        3,
        8
      ],
      [
        7,
        -21
      ]
    ],
    [
      [
        26013,
        59123
      ],
      [
        -2,
        -31
      ],
      [
        -6,
        -5
      ],
      [
        3,
        -17
      ],
      [
        -3,
        -70
      ]
    ],
    [
      [
        26005,
        59000
      ],
      [
        -6,
        -11
      ],
      [
        -3,
        7
      ],
      [
        -7,
        -40
      ],
      [
        -8,
        13
      ],
      [
        -1,
        13
      ],
      [
        -4,
        0
      ],
      [
        0,
        -22
      ],
      [
        -7,
        13
      ],
      [
        -3,
        -8
      ],
      [
        -3,
        10
      ],
      [
        -8,
        -27
      ],
      [
        -7,
        3
      ],
      [
        0,
        -7
      ],
      [
        -8,
        6
      ],
      [
        -5,
        -3
      ]
    ],
    [
      [
        25935,
        58947
      ],
      [
        -2,
        44
      ],
      [
        -3,
        13
      ],
      [
        -10,
        108
      ],
      [
        -2,
        4
      ],
      [
        0,
        23
      ],
      [
        1,
        20
      ],
      [
        -2,
        -4
      ],
      [
        -4,
        36
      ]
    ],
    [
      [
        25412,
        63363
      ],
      [
        37,
        1
      ],
      [
        52,
        1
      ],
      [
        0,
        -15
      ],
      [
        17,
        0
      ],
      [
        -7,
        16
      ],
      [
        13,
        0
      ]
    ],
    [
      [
        25524,
        63366
      ],
      [
        0,
        -275
      ],
      [
        1,
        0
      ],
      [
        0,
        -45
      ]
    ],
    [
      [
        25525,
        63046
      ],
      [
        0,
        -152
      ]
    ],
    [
      [
        25525,
        62894
      ],
      [
        -44,
        0
      ],
      [
        0,
        12
      ],
      [
        -21,
        -2
      ],
      [
        -55,
        -5
      ]
    ],
    [
      [
        25405,
        62899
      ],
      [
        -1,
        187
      ],
      [
        0,
        51
      ]
    ],
    [
      [
        25404,
        63137
      ],
      [
        -1,
        124
      ],
      [
        9,
        0
      ],
      [
        0,
        102
      ]
    ],
    [
      [
        27909,
        63964
      ],
      [
        14,
        99
      ],
      [
        18,
        143
      ],
      [
        3,
        37
      ],
      [
        4,
        30
      ],
      [
        7,
        68
      ],
      [
        3,
        -3
      ],
      [
        -1,
        8
      ]
    ],
    [
      [
        27957,
        64346
      ],
      [
        126,
        0
      ]
    ],
    [
      [
        28083,
        64346
      ],
      [
        -17,
        -93
      ],
      [
        -9,
        -4
      ],
      [
        -1,
        -58
      ],
      [
        -11,
        -59
      ],
      [
        -9,
        -14
      ],
      [
        -6,
        -26
      ],
      [
        -1,
        -23
      ],
      [
        1,
        -12
      ],
      [
        -3,
        -23
      ],
      [
        -3,
        -21
      ],
      [
        1,
        -34
      ],
      [
        -2,
        -45
      ],
      [
        -11,
        -20
      ],
      [
        -5,
        -31
      ]
    ],
    [
      [
        28007,
        63883
      ],
      [
        -8,
        -52
      ],
      [
        0,
        -8
      ],
      [
        1,
        -5
      ],
      [
        1,
        -13
      ],
      [
        -4,
        -20
      ]
    ],
    [
      [
        27997,
        63785
      ],
      [
        -50,
        3
      ],
      [
        -3,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -3
      ],
      [
        -4,
        6
      ],
      [
        -4,
        -5
      ],
      [
        -3,
        32
      ],
      [
        -9,
        14
      ],
      [
        -2,
        1
      ],
      [
        -34,
        0
      ]
    ],
    [
      [
        27886,
        63834
      ],
      [
        0,
        6
      ],
      [
        5,
        20
      ],
      [
        18,
        104
      ]
    ],
    [
      [
        15601,
        68997
      ],
      [
        5,
        27
      ],
      [
        -3,
        7
      ]
    ],
    [
      [
        15603,
        69031
      ],
      [
        9,
        11
      ],
      [
        2,
        -11
      ],
      [
        17,
        -13
      ],
      [
        0,
        -15
      ],
      [
        6,
        1
      ],
      [
        1,
        -32
      ],
      [
        5,
        -14
      ],
      [
        7,
        22
      ],
      [
        5,
        18
      ],
      [
        6,
        -7
      ],
      [
        4,
        12
      ],
      [
        0,
        2
      ],
      [
        3,
        7
      ],
      [
        0,
        4
      ],
      [
        3,
        6
      ],
      [
        1,
        4
      ],
      [
        0,
        -1
      ],
      [
        2,
        5
      ],
      [
        2,
        3
      ],
      [
        2,
        0
      ],
      [
        0,
        1
      ],
      [
        3,
        8
      ],
      [
        0,
        -1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        0,
        1
      ],
      [
        2,
        3
      ],
      [
        0,
        4
      ],
      [
        1,
        4
      ],
      [
        -1,
        3
      ],
      [
        1,
        3
      ],
      [
        0,
        1
      ],
      [
        1,
        -2
      ],
      [
        1,
        -3
      ],
      [
        3,
        0
      ],
      [
        1,
        4
      ],
      [
        1,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        0
      ],
      [
        1,
        3
      ],
      [
        0,
        4
      ],
      [
        1,
        2
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        0,
        2
      ],
      [
        1,
        0
      ],
      [
        2,
        1
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        2,
        -3
      ],
      [
        1,
        1
      ],
      [
        2,
        0
      ],
      [
        1,
        -2
      ],
      [
        4,
        -4
      ],
      [
        3,
        2
      ],
      [
        3,
        2
      ],
      [
        2,
        0
      ],
      [
        1,
        -8
      ],
      [
        2,
        -6
      ],
      [
        2,
        -2
      ],
      [
        1,
        0
      ],
      [
        1,
        -2
      ],
      [
        3,
        0
      ],
      [
        2,
        2
      ],
      [
        3,
        1
      ],
      [
        3,
        3
      ],
      [
        2,
        1
      ],
      [
        2,
        3
      ],
      [
        1,
        3
      ],
      [
        1,
        1
      ],
      [
        3,
        1
      ],
      [
        2,
        0
      ],
      [
        1,
        -3
      ],
      [
        2,
        -3
      ],
      [
        1,
        -2
      ],
      [
        2,
        -5
      ],
      [
        2,
        0
      ],
      [
        2,
        -1
      ],
      [
        2,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        2,
        0
      ],
      [
        2,
        -1
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        1,
        1
      ],
      [
        0,
        1
      ],
      [
        1,
        1
      ],
      [
        1,
        -1
      ],
      [
        2,
        -2
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        2,
        -1
      ],
      [
        1,
        -2
      ],
      [
        2,
        -1
      ],
      [
        1,
        1
      ],
      [
        2,
        2
      ],
      [
        1,
        2
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        0,
        1
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        -1
      ],
      [
        3,
        0
      ],
      [
        0,
        -2
      ],
      [
        1,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        2
      ],
      [
        1,
        0
      ],
      [
        0,
        -1
      ],
      [
        2,
        -4
      ],
      [
        1,
        0
      ],
      [
        1,
        2
      ],
      [
        1,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        3
      ],
      [
        1,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        2,
        0
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        2,
        2
      ],
      [
        1,
        1
      ],
      [
        2,
        -1
      ],
      [
        2,
        1
      ],
      [
        1,
        -1
      ],
      [
        2,
        -1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        2,
        2
      ],
      [
        1,
        0
      ],
      [
        2,
        -3
      ],
      [
        2,
        -1
      ],
      [
        2,
        -1
      ],
      [
        1,
        -1
      ],
      [
        3,
        -3
      ],
      [
        2,
        -14
      ],
      [
        4,
        -11
      ],
      [
        2,
        -8
      ],
      [
        2,
        -4
      ],
      [
        3,
        -17
      ],
      [
        2,
        -9
      ],
      [
        4,
        -3
      ],
      [
        3,
        3
      ],
      [
        3,
        8
      ],
      [
        3,
        3
      ],
      [
        5,
        10
      ],
      [
        2,
        4
      ],
      [
        2,
        9
      ],
      [
        4,
        -3
      ],
      [
        2,
        -6
      ],
      [
        2,
        -3
      ],
      [
        2,
        -7
      ],
      [
        4,
        -3
      ],
      [
        3,
        -5
      ],
      [
        1,
        -4
      ],
      [
        2,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        -3
      ],
      [
        2,
        0
      ],
      [
        2,
        -4
      ],
      [
        1,
        -2
      ],
      [
        2,
        -2
      ],
      [
        2,
        -4
      ],
      [
        1,
        -1
      ],
      [
        1,
        1
      ],
      [
        2,
        3
      ],
      [
        2,
        0
      ],
      [
        1,
        -3
      ],
      [
        2,
        1
      ],
      [
        1,
        1
      ],
      [
        1,
        -1
      ],
      [
        1,
        2
      ],
      [
        3,
        3
      ],
      [
        2,
        -2
      ],
      [
        2,
        -2
      ],
      [
        1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        11,
        0
      ],
      [
        30,
        -1
      ],
      [
        4,
        0
      ]
    ],
    [
      [
        15977,
        68954
      ],
      [
        1,
        -50
      ],
      [
        -4,
        -30
      ],
      [
        5,
        -24
      ],
      [
        -3,
        -45
      ],
      [
        -3,
        -24
      ],
      [
        2,
        -21
      ],
      [
        -11,
        -29
      ],
      [
        0,
        -27
      ],
      [
        2,
        -27
      ],
      [
        -2,
        -13
      ],
      [
        2,
        -27
      ],
      [
        -1,
        -21
      ]
    ],
    [
      [
        15965,
        68616
      ],
      [
        0,
        -30
      ],
      [
        2,
        -11
      ],
      [
        -1,
        -84
      ],
      [
        4,
        -3
      ],
      [
        2,
        -24
      ]
    ],
    [
      [
        15972,
        68464
      ],
      [
        -25,
        0
      ],
      [
        -34,
        -4
      ],
      [
        -83,
        -7
      ],
      [
        0,
        -25
      ],
      [
        -7,
        -12
      ],
      [
        -4,
        -13
      ],
      [
        -3,
        0
      ],
      [
        -2,
        9
      ],
      [
        -14,
        4
      ],
      [
        -3,
        -5
      ],
      [
        -5,
        8
      ],
      [
        -11,
        -2
      ],
      [
        -2,
        12
      ],
      [
        -6,
        2
      ],
      [
        -12,
        -7
      ],
      [
        0,
        8
      ],
      [
        -5,
        11
      ],
      [
        -14,
        11
      ],
      [
        -1,
        15
      ],
      [
        -6,
        3
      ],
      [
        -15,
        16
      ],
      [
        0,
        3
      ],
      [
        -7,
        0
      ],
      [
        -4,
        6
      ],
      [
        -4,
        -8
      ],
      [
        -8,
        1
      ],
      [
        -5,
        -12
      ],
      [
        -2,
        9
      ],
      [
        -10,
        6
      ],
      [
        0,
        -33
      ],
      [
        -10,
        1
      ],
      [
        -1,
        -68
      ],
      [
        -72,
        -1
      ],
      [
        4,
        31
      ],
      [
        -8,
        28
      ],
      [
        0,
        38
      ]
    ],
    [
      [
        15593,
        68489
      ],
      [
        -3,
        5
      ],
      [
        -2,
        24
      ],
      [
        -5,
        4
      ],
      [
        0,
        15
      ],
      [
        -8,
        8
      ],
      [
        4,
        15
      ],
      [
        -2,
        14
      ],
      [
        5,
        4
      ],
      [
        -7,
        28
      ],
      [
        6,
        10
      ],
      [
        -2,
        26
      ],
      [
        3,
        5
      ],
      [
        -3,
        15
      ],
      [
        6,
        4
      ],
      [
        1,
        9
      ],
      [
        -3,
        29
      ],
      [
        0,
        26
      ],
      [
        1,
        17
      ],
      [
        -7,
        26
      ],
      [
        -5,
        2
      ],
      [
        4,
        18
      ],
      [
        -5,
        12
      ],
      [
        1,
        20
      ],
      [
        9,
        14
      ],
      [
        11,
        4
      ],
      [
        -3,
        20
      ],
      [
        6,
        19
      ],
      [
        0,
        15
      ],
      [
        19,
        6
      ],
      [
        9,
        13
      ],
      [
        -6,
        30
      ],
      [
        -7,
        1
      ],
      [
        -1,
        16
      ],
      [
        -8,
        34
      ]
    ],
    [
      [
        23583,
        69198
      ],
      [
        1,
        -3
      ],
      [
        0,
        -201
      ]
    ],
    [
      [
        23549,
        68690
      ],
      [
        -44,
        0
      ]
    ],
    [
      [
        23505,
        68690
      ],
      [
        -8,
        18
      ],
      [
        -1,
        15
      ],
      [
        -15,
        16
      ]
    ],
    [
      [
        23481,
        68739
      ],
      [
        -3,
        19
      ],
      [
        -10,
        1
      ],
      [
        -4,
        10
      ],
      [
        -11,
        11
      ],
      [
        -6,
        15
      ],
      [
        -7,
        -4
      ],
      [
        -5,
        17
      ],
      [
        -7,
        6
      ],
      [
        -5,
        12
      ],
      [
        -6,
        -1
      ],
      [
        -2,
        18
      ],
      [
        -4,
        6
      ],
      [
        -8,
        17
      ],
      [
        -1,
        9
      ],
      [
        -10,
        11
      ],
      [
        -16,
        49
      ],
      [
        -7,
        -9
      ],
      [
        -6,
        3
      ],
      [
        -6,
        19
      ],
      [
        -2,
        18
      ],
      [
        -11,
        6
      ]
    ],
    [
      [
        23344,
        68972
      ],
      [
        -12,
        24
      ],
      [
        -11,
        28
      ],
      [
        -4,
        -3
      ],
      [
        -6,
        18
      ],
      [
        -2,
        -4
      ]
    ],
    [
      [
        23309,
        69035
      ],
      [
        0,
        161
      ],
      [
        66,
        0
      ]
    ],
    [
      [
        23401,
        70916
      ],
      [
        118,
        0
      ]
    ],
    [
      [
        23519,
        70916
      ],
      [
        3,
        -20
      ],
      [
        19,
        -3
      ]
    ],
    [
      [
        23541,
        70893
      ],
      [
        1,
        -77
      ],
      [
        0,
        -305
      ],
      [
        1,
        -102
      ],
      [
        0,
        -185
      ]
    ],
    [
      [
        23543,
        70224
      ],
      [
        -34,
        0
      ],
      [
        -104,
        -1
      ]
    ],
    [
      [
        15624,
        69410
      ],
      [
        9,
        27
      ],
      [
        5,
        3
      ],
      [
        6,
        19
      ],
      [
        -5,
        23
      ],
      [
        -4,
        5
      ],
      [
        0,
        23
      ],
      [
        6,
        -1
      ],
      [
        2,
        7
      ],
      [
        -4,
        13
      ],
      [
        -2,
        27
      ],
      [
        -6,
        -2
      ],
      [
        -2,
        15
      ],
      [
        3,
        11
      ],
      [
        11,
        4
      ],
      [
        1,
        14
      ],
      [
        -1,
        29
      ],
      [
        7,
        15
      ],
      [
        0,
        7
      ],
      [
        2,
        6
      ],
      [
        6,
        -21
      ],
      [
        9,
        0
      ],
      [
        4,
        -12
      ],
      [
        10,
        -4
      ],
      [
        4,
        7
      ]
    ],
    [
      [
        15685,
        69625
      ],
      [
        4,
        17
      ],
      [
        14,
        0
      ],
      [
        0,
        -17
      ],
      [
        13,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -9
      ],
      [
        -2,
        -6
      ],
      [
        1,
        -14
      ],
      [
        1,
        -1
      ],
      [
        -3,
        -28
      ],
      [
        1,
        -25
      ],
      [
        -1,
        -17
      ],
      [
        -6,
        -23
      ],
      [
        -3,
        -27
      ],
      [
        11,
        -25
      ],
      [
        2,
        -14
      ],
      [
        6,
        -19
      ],
      [
        4,
        -24
      ],
      [
        10,
        -15
      ],
      [
        6,
        -16
      ],
      [
        4,
        1
      ],
      [
        11,
        -16
      ],
      [
        1,
        -36
      ],
      [
        7,
        -7
      ],
      [
        2,
        -21
      ],
      [
        6,
        -32
      ],
      [
        5,
        -5
      ],
      [
        3,
        -16
      ],
      [
        6,
        4
      ],
      [
        8,
        -9
      ],
      [
        5,
        -13
      ],
      [
        11,
        0
      ],
      [
        2,
        -6
      ],
      [
        1,
        -15
      ],
      [
        183,
        0
      ]
    ],
    [
      [
        15996,
        69190
      ],
      [
        -6,
        -29
      ],
      [
        3,
        -17
      ],
      [
        -3,
        -19
      ]
    ],
    [
      [
        15990,
        69125
      ],
      [
        -3,
        -11
      ],
      [
        -3,
        -1
      ],
      [
        -9,
        -6
      ],
      [
        -3,
        -17
      ],
      [
        2,
        -21
      ],
      [
        8,
        -11
      ],
      [
        3,
        4
      ],
      [
        1,
        -10
      ],
      [
        2,
        -6
      ],
      [
        -3,
        -2
      ],
      [
        0,
        -9
      ],
      [
        -4,
        -5
      ],
      [
        -5,
        -22
      ],
      [
        3,
        -39
      ],
      [
        -2,
        -15
      ]
    ],
    [
      [
        15603,
        69031
      ],
      [
        -1,
        24
      ],
      [
        7,
        28
      ],
      [
        7,
        6
      ],
      [
        2,
        15
      ],
      [
        -6,
        11
      ],
      [
        -6,
        6
      ],
      [
        -12,
        6
      ],
      [
        -1,
        16
      ],
      [
        2,
        22
      ],
      [
        7,
        -3
      ],
      [
        10,
        80
      ],
      [
        11,
        -3
      ],
      [
        8,
        19
      ],
      [
        1,
        14
      ],
      [
        1,
        11
      ],
      [
        0,
        8
      ],
      [
        -1,
        18
      ],
      [
        -7,
        3
      ],
      [
        -3,
        28
      ],
      [
        2,
        70
      ]
    ],
    [
      [
        28536,
        63642
      ],
      [
        7,
        43
      ],
      [
        6,
        -8
      ],
      [
        9,
        18
      ],
      [
        2,
        6
      ],
      [
        9,
        23
      ],
      [
        1,
        -2
      ],
      [
        4,
        2
      ],
      [
        0,
        -1
      ],
      [
        1,
        2
      ],
      [
        1,
        4
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        28695,
        63870
      ],
      [
        17,
        -44
      ],
      [
        13,
        -36
      ],
      [
        29,
        -76
      ],
      [
        19,
        -52
      ]
    ],
    [
      [
        28773,
        63662
      ],
      [
        -18,
        -30
      ],
      [
        -1,
        -5
      ],
      [
        1,
        -33
      ],
      [
        0,
        -48
      ],
      [
        -4,
        -24
      ],
      [
        -6,
        -34
      ],
      [
        -6,
        -41
      ],
      [
        2,
        -15
      ],
      [
        1,
        -2
      ],
      [
        -4,
        -10
      ],
      [
        1,
        -35
      ],
      [
        1,
        -35
      ],
      [
        -3,
        7
      ],
      [
        -1,
        -24
      ],
      [
        -5,
        -5
      ],
      [
        2,
        -19
      ],
      [
        -6,
        -8
      ],
      [
        2,
        -16
      ],
      [
        -5,
        -13
      ],
      [
        2,
        -5
      ],
      [
        -7,
        -44
      ],
      [
        -10,
        -23
      ],
      [
        0,
        -19
      ],
      [
        -5,
        15
      ],
      [
        -4,
        -17
      ]
    ],
    [
      [
        28700,
        63179
      ],
      [
        -27,
        0
      ]
    ],
    [
      [
        28673,
        63179
      ],
      [
        -2,
        0
      ]
    ],
    [
      [
        28671,
        63179
      ],
      [
        -1,
        10
      ],
      [
        -9,
        52
      ],
      [
        -11,
        41
      ],
      [
        -7,
        13
      ],
      [
        -3,
        30
      ],
      [
        -9,
        31
      ],
      [
        1,
        16
      ],
      [
        -4,
        29
      ],
      [
        -16,
        25
      ],
      [
        -8,
        18
      ],
      [
        -5,
        31
      ],
      [
        0,
        24
      ],
      [
        -4,
        18
      ],
      [
        0,
        1
      ],
      [
        -7,
        44
      ],
      [
        -10,
        -6
      ],
      [
        -20,
        14
      ],
      [
        -5,
        6
      ],
      [
        -10,
        46
      ],
      [
        -5,
        16
      ],
      [
        -2,
        4
      ]
    ],
    [
      [
        24213,
        58511
      ],
      [
        58,
        -5
      ],
      [
        54,
        -3
      ]
    ],
    [
      [
        24325,
        58503
      ],
      [
        9,
        -1
      ],
      [
        4,
        9
      ],
      [
        -1,
        -207
      ]
    ],
    [
      [
        24337,
        58304
      ],
      [
        0,
        -91
      ],
      [
        -7,
        -7
      ],
      [
        -2,
        6
      ],
      [
        -3,
        -16
      ],
      [
        -3,
        -6
      ],
      [
        -1,
        -91
      ],
      [
        -72,
        6
      ]
    ],
    [
      [
        24249,
        58105
      ],
      [
        -3,
        -1
      ],
      [
        -17,
        0
      ],
      [
        -20,
        2
      ]
    ],
    [
      [
        26653,
        54012
      ],
      [
        11,
        0
      ],
      [
        65,
        -3
      ],
      [
        7,
        9
      ],
      [
        2,
        -5
      ]
    ],
    [
      [
        26738,
        54013
      ],
      [
        7,
        -19
      ],
      [
        0,
        -8
      ],
      [
        5,
        -1
      ],
      [
        -1,
        -11
      ],
      [
        11,
        -7
      ],
      [
        4,
        4
      ],
      [
        9,
        -26
      ],
      [
        3,
        1
      ],
      [
        3,
        -14
      ],
      [
        7,
        -4
      ],
      [
        2,
        7
      ]
    ],
    [
      [
        26788,
        53810
      ],
      [
        -50,
        6
      ],
      [
        0,
        -31
      ],
      [
        -25,
        3
      ],
      [
        0,
        29
      ],
      [
        -16,
        1
      ],
      [
        0,
        89
      ],
      [
        -4,
        0
      ],
      [
        0,
        15
      ],
      [
        -9,
        0
      ],
      [
        0,
        -15
      ],
      [
        -23,
        1
      ]
    ],
    [
      [
        26661,
        53908
      ],
      [
        -2,
        43
      ],
      [
        -7,
        48
      ],
      [
        1,
        13
      ]
    ],
    [
      [
        6254,
        41293
      ],
      [
        2,
        37
      ],
      [
        3,
        32
      ],
      [
        5,
        32
      ],
      [
        3,
        2
      ],
      [
        2,
        6
      ],
      [
        1,
        7
      ],
      [
        0,
        9
      ],
      [
        6,
        0
      ],
      [
        2,
        -4
      ],
      [
        0,
        3
      ],
      [
        2,
        8
      ],
      [
        4,
        -1
      ],
      [
        2,
        -9
      ],
      [
        1,
        -6
      ],
      [
        5,
        -5
      ],
      [
        4,
        -13
      ],
      [
        1,
        0
      ],
      [
        5,
        -43
      ],
      [
        2,
        -15
      ],
      [
        2,
        -4
      ],
      [
        1,
        -13
      ],
      [
        0,
        -3
      ],
      [
        3,
        -4
      ],
      [
        1,
        -7
      ],
      [
        1,
        -14
      ],
      [
        3,
        -21
      ],
      [
        0,
        -1
      ],
      [
        2,
        -3
      ],
      [
        7,
        9
      ],
      [
        7,
        11
      ],
      [
        8,
        7
      ],
      [
        2,
        2
      ],
      [
        4,
        9
      ],
      [
        1,
        6
      ],
      [
        5,
        10
      ],
      [
        2,
        0
      ],
      [
        1,
        -3
      ],
      [
        2,
        9
      ],
      [
        3,
        4
      ],
      [
        4,
        -8
      ],
      [
        6,
        6
      ],
      [
        3,
        -12
      ],
      [
        4,
        4
      ],
      [
        5,
        -4
      ],
      [
        4,
        -7
      ],
      [
        0,
        -16
      ],
      [
        1,
        -2
      ],
      [
        1,
        2
      ],
      [
        1,
        -2
      ],
      [
        1,
        -11
      ],
      [
        12,
        -35
      ],
      [
        1,
        -3
      ],
      [
        1,
        -10
      ],
      [
        9,
        -5
      ],
      [
        1,
        -16
      ],
      [
        4,
        -24
      ],
      [
        4,
        2
      ],
      [
        3,
        4
      ],
      [
        8,
        -25
      ],
      [
        8,
        -3
      ],
      [
        8,
        -15
      ],
      [
        0,
        -7
      ],
      [
        4,
        -15
      ],
      [
        1,
        -10
      ],
      [
        0,
        -52
      ],
      [
        -2,
        -11
      ],
      [
        -3,
        -18
      ],
      [
        -3,
        -14
      ],
      [
        -2,
        1
      ],
      [
        -3,
        -5
      ],
      [
        -2,
        -12
      ],
      [
        -1,
        -9
      ],
      [
        -3,
        -12
      ],
      [
        -2,
        -3
      ],
      [
        -6,
        3
      ],
      [
        -2,
        -7
      ],
      [
        -9,
        -17
      ],
      [
        -2,
        -7
      ],
      [
        -4,
        -5
      ],
      [
        0,
        1
      ],
      [
        -1,
        6
      ],
      [
        -3,
        0
      ],
      [
        -3,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        -3,
        6
      ],
      [
        -3,
        3
      ],
      [
        -5,
        -4
      ],
      [
        -4,
        -6
      ],
      [
        -3,
        -9
      ],
      [
        -3,
        -5
      ],
      [
        -5,
        -11
      ],
      [
        -5,
        -6
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -3
      ],
      [
        -6,
        2
      ],
      [
        -8,
        -1
      ],
      [
        -2,
        -6
      ],
      [
        -3,
        -4
      ],
      [
        -2,
        0
      ],
      [
        -11,
        9
      ],
      [
        0,
        14
      ],
      [
        -2,
        4
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        0
      ],
      [
        -2,
        3
      ],
      [
        -2,
        8
      ],
      [
        1,
        7
      ],
      [
        -3,
        33
      ],
      [
        2,
        8
      ],
      [
        0,
        8
      ],
      [
        -1,
        57
      ],
      [
        -1,
        24
      ],
      [
        0,
        7
      ],
      [
        -2,
        6
      ],
      [
        -1,
        20
      ],
      [
        0,
        32
      ],
      [
        -3,
        11
      ],
      [
        -4,
        9
      ],
      [
        -4,
        2
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        -6
      ],
      [
        -2,
        -16
      ],
      [
        -4,
        -3
      ],
      [
        -26,
        50
      ],
      [
        -13,
        58
      ],
      [
        -3,
        21
      ],
      [
        0,
        20
      ],
      [
        -1,
        7
      ],
      [
        -1,
        5
      ],
      [
        -1,
        5
      ]
    ],
    [
      [
        6253,
        40841
      ],
      [
        2,
        11
      ],
      [
        5,
        18
      ],
      [
        7,
        10
      ],
      [
        11,
        25
      ],
      [
        1,
        8
      ],
      [
        9,
        14
      ],
      [
        3,
        -2
      ],
      [
        4,
        -11
      ],
      [
        3,
        -17
      ],
      [
        0,
        -8
      ],
      [
        -2,
        -6
      ],
      [
        -2,
        -30
      ],
      [
        1,
        -4
      ],
      [
        3,
        -5
      ],
      [
        1,
        -8
      ],
      [
        -2,
        -6
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        2
      ],
      [
        -7,
        -12
      ],
      [
        -5,
        15
      ],
      [
        -8,
        -11
      ],
      [
        -3,
        -8
      ],
      [
        -1,
        4
      ],
      [
        -6,
        -8
      ],
      [
        -4,
        2
      ],
      [
        -6,
        24
      ],
      [
        0,
        6
      ]
    ],
    [
      [
        6153,
        41274
      ],
      [
        1,
        11
      ],
      [
        6,
        16
      ],
      [
        3,
        2
      ],
      [
        5,
        1
      ],
      [
        5,
        2
      ],
      [
        5,
        -6
      ],
      [
        10,
        -2
      ],
      [
        5,
        -3
      ],
      [
        6,
        -8
      ],
      [
        17,
        -60
      ],
      [
        3,
        -15
      ],
      [
        4,
        -29
      ],
      [
        1,
        -7
      ],
      [
        -1,
        -13
      ],
      [
        -2,
        -17
      ],
      [
        -6,
        -35
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        0
      ],
      [
        -5,
        -6
      ],
      [
        -6,
        -12
      ],
      [
        -5,
        -6
      ],
      [
        -11,
        0
      ],
      [
        -6,
        -5
      ],
      [
        -4,
        25
      ],
      [
        -3,
        35
      ],
      [
        1,
        34
      ],
      [
        0,
        13
      ],
      [
        -4,
        26
      ],
      [
        -2,
        6
      ],
      [
        -12,
        26
      ],
      [
        -1,
        9
      ],
      [
        -1,
        7
      ],
      [
        0,
        16
      ]
    ],
    [
      [
        6166,
        41601
      ],
      [
        3,
        -8
      ],
      [
        9,
        -4
      ],
      [
        3,
        -18
      ],
      [
        0,
        24
      ],
      [
        1,
        -22
      ],
      [
        5,
        -1
      ],
      [
        6,
        -36
      ],
      [
        5,
        3
      ],
      [
        1,
        18
      ],
      [
        -6,
        24
      ]
    ],
    [
      [
        6193,
        41581
      ],
      [
        4,
        -4
      ],
      [
        2,
        2
      ],
      [
        0,
        7
      ],
      [
        8,
        -9
      ],
      [
        8,
        4
      ],
      [
        5,
        8
      ],
      [
        14,
        6
      ],
      [
        8,
        -4
      ],
      [
        1,
        -5
      ],
      [
        1,
        -12
      ],
      [
        5,
        2
      ],
      [
        2,
        -6
      ],
      [
        0,
        -17
      ],
      [
        -3,
        -17
      ],
      [
        -5,
        -21
      ],
      [
        -7,
        -22
      ],
      [
        -6,
        -16
      ],
      [
        -5,
        -13
      ],
      [
        -8,
        -12
      ],
      [
        -7,
        -2
      ],
      [
        -5,
        -7
      ],
      [
        -5,
        3
      ],
      [
        -4,
        4
      ],
      [
        -13,
        12
      ],
      [
        -13,
        13
      ],
      [
        -7,
        14
      ],
      [
        -2,
        2
      ],
      [
        -4,
        6
      ],
      [
        -9,
        7
      ],
      [
        -4,
        2
      ],
      [
        -9,
        -7
      ],
      [
        -6,
        -7
      ],
      [
        -29,
        -5
      ],
      [
        -13,
        7
      ],
      [
        -3,
        10
      ],
      [
        3,
        22
      ],
      [
        2,
        18
      ],
      [
        1,
        12
      ],
      [
        3,
        14
      ],
      [
        2,
        2
      ],
      [
        4,
        13
      ],
      [
        2,
        15
      ],
      [
        -1,
        8
      ],
      [
        1,
        19
      ],
      [
        -2,
        9
      ],
      [
        -1,
        3
      ],
      [
        -1,
        4
      ],
      [
        1,
        5
      ],
      [
        1,
        2
      ],
      [
        4,
        -7
      ],
      [
        4,
        -1
      ],
      [
        4,
        2
      ],
      [
        3,
        -3
      ],
      [
        3,
        -14
      ],
      [
        2,
        -2
      ],
      [
        8,
        -6
      ],
      [
        2,
        0
      ],
      [
        1,
        2
      ],
      [
        5,
        -1
      ],
      [
        4,
        -5
      ],
      [
        4,
        1
      ],
      [
        9,
        -10
      ],
      [
        4,
        -1
      ],
      [
        1,
        2
      ],
      [
        2,
        1
      ],
      [
        7,
        -7
      ]
    ],
    [
      [
        24166,
        61011
      ],
      [
        0,
        138
      ],
      [
        1,
        50
      ]
    ],
    [
      [
        24167,
        61199
      ],
      [
        61,
        -5
      ]
    ],
    [
      [
        24228,
        61194
      ],
      [
        1,
        -2
      ],
      [
        45,
        -5
      ]
    ],
    [
      [
        24274,
        61187
      ],
      [
        -1,
        -151
      ],
      [
        0,
        -102
      ],
      [
        -1,
        -222
      ]
    ],
    [
      [
        24272,
        60712
      ],
      [
        -43,
        3
      ],
      [
        -19,
        -1
      ]
    ],
    [
      [
        22515,
        50247
      ],
      [
        0,
        -646
      ]
    ],
    [
      [
        24456,
        65668
      ],
      [
        -32,
        0
      ],
      [
        -32,
        1
      ],
      [
        -65,
        1
      ]
    ],
    [
      [
        24327,
        65670
      ],
      [
        -1,
        102
      ],
      [
        0,
        102
      ],
      [
        1,
        305
      ]
    ],
    [
      [
        21748,
        58913
      ],
      [
        151,
        -1
      ]
    ],
    [
      [
        24197,
        65260
      ],
      [
        98,
        1
      ]
    ],
    [
      [
        24295,
        64857
      ],
      [
        -65,
        -1
      ]
    ],
    [
      [
        26862,
        62984
      ],
      [
        0,
        17
      ],
      [
        31,
        -6
      ],
      [
        1,
        52
      ],
      [
        34,
        -7
      ],
      [
        1,
        69
      ],
      [
        33,
        -8
      ]
    ],
    [
      [
        26962,
        63101
      ],
      [
        -2,
        -68
      ],
      [
        33,
        -7
      ],
      [
        -1,
        -33
      ],
      [
        30,
        -7
      ]
    ],
    [
      [
        27022,
        62986
      ],
      [
        -3,
        -105
      ],
      [
        -31,
        8
      ],
      [
        -3,
        -103
      ]
    ],
    [
      [
        26985,
        62786
      ],
      [
        -31,
        7
      ],
      [
        -31,
        6
      ],
      [
        -1,
        -30
      ],
      [
        -33,
        7
      ],
      [
        0,
        -17
      ],
      [
        -32,
        8
      ]
    ],
    [
      [
        26857,
        62767
      ],
      [
        2,
        117
      ]
    ],
    [
      [
        26235,
        54630
      ],
      [
        5,
        -4
      ],
      [
        5,
        2
      ],
      [
        15,
        29
      ],
      [
        3,
        11
      ],
      [
        9,
        5
      ],
      [
        1,
        -2
      ],
      [
        2,
        0
      ],
      [
        1,
        -2
      ],
      [
        0,
        3
      ],
      [
        2,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        -1
      ],
      [
        4,
        8
      ],
      [
        4,
        -7
      ],
      [
        4,
        13
      ],
      [
        3,
        -5
      ],
      [
        12,
        101
      ],
      [
        8,
        13
      ]
    ],
    [
      [
        26315,
        54794
      ],
      [
        5,
        0
      ],
      [
        11,
        19
      ]
    ],
    [
      [
        26331,
        54813
      ],
      [
        0,
        -47
      ],
      [
        -5,
        0
      ],
      [
        -1,
        -305
      ]
    ],
    [
      [
        26325,
        54461
      ],
      [
        -40,
        -2
      ],
      [
        0,
        -12
      ],
      [
        -3,
        0
      ],
      [
        0,
        12
      ],
      [
        -30,
        0
      ]
    ],
    [
      [
        26252,
        54459
      ],
      [
        8,
        38
      ],
      [
        -12,
        40
      ],
      [
        -6,
        9
      ],
      [
        -12,
        19
      ],
      [
        -2,
        17
      ],
      [
        7,
        31
      ],
      [
        0,
        17
      ]
    ],
    [
      [
        19541,
        71361
      ],
      [
        105,
        -2
      ]
    ],
    [
      [
        19870,
        71367
      ],
      [
        4,
        -15
      ],
      [
        1,
        -17
      ],
      [
        -5,
        -2
      ],
      [
        3,
        -21
      ],
      [
        -2,
        -6
      ],
      [
        7,
        -13
      ],
      [
        2,
        -14
      ],
      [
        -5,
        -21
      ],
      [
        -3,
        -24
      ],
      [
        2,
        -11
      ],
      [
        -1,
        -19
      ],
      [
        -6,
        -22
      ],
      [
        12,
        0
      ],
      [
        0,
        -118
      ],
      [
        4,
        0
      ]
    ],
    [
      [
        19883,
        71064
      ],
      [
        0,
        -117
      ],
      [
        -41,
        0
      ],
      [
        0,
        -17
      ],
      [
        -6,
        0
      ],
      [
        0,
        -17
      ],
      [
        -6,
        0
      ],
      [
        0,
        -17
      ],
      [
        -5,
        0
      ],
      [
        0,
        -17
      ],
      [
        -6,
        0
      ],
      [
        0,
        -34
      ],
      [
        -5,
        0
      ],
      [
        0,
        -51
      ],
      [
        -81,
        0
      ],
      [
        0,
        -16
      ],
      [
        -12,
        0
      ],
      [
        0,
        -17
      ],
      [
        -12,
        1
      ],
      [
        0,
        -120
      ],
      [
        -104,
        -1
      ]
    ],
    [
      [
        26148,
        55852
      ],
      [
        54,
        -1
      ],
      [
        24,
        -1
      ]
    ],
    [
      [
        26247,
        55616
      ],
      [
        -28,
        -43
      ],
      [
        -2,
        -7
      ],
      [
        -11,
        -12
      ],
      [
        0,
        17
      ],
      [
        -6,
        10
      ],
      [
        0,
        -19
      ],
      [
        -3,
        0
      ],
      [
        0,
        -17
      ],
      [
        -33,
        -40
      ]
    ],
    [
      [
        26164,
        55505
      ],
      [
        -16,
        347
      ]
    ],
    [
      [
        24550,
        73035
      ],
      [
        2,
        1
      ],
      [
        0,
        3
      ],
      [
        3,
        7
      ],
      [
        2,
        2
      ],
      [
        0,
        3
      ],
      [
        8,
        20
      ],
      [
        14,
        12
      ],
      [
        3,
        1
      ],
      [
        2,
        7
      ],
      [
        6,
        10
      ],
      [
        1,
        -6
      ],
      [
        2,
        -3
      ],
      [
        2,
        0
      ],
      [
        6,
        8
      ],
      [
        1,
        -1
      ],
      [
        1,
        -5
      ],
      [
        1,
        -6
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -29
      ],
      [
        1,
        -15
      ],
      [
        -1,
        -14
      ],
      [
        1,
        -4
      ],
      [
        2,
        4
      ],
      [
        0,
        8
      ],
      [
        1,
        1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        2,
        0
      ],
      [
        2,
        -2
      ],
      [
        1,
        -17
      ],
      [
        1,
        -4
      ],
      [
        3,
        1
      ],
      [
        1,
        4
      ],
      [
        0,
        1
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -10
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        -7
      ],
      [
        0,
        -5
      ],
      [
        2,
        0
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        2,
        -3
      ],
      [
        0,
        -7
      ],
      [
        2,
        -2
      ],
      [
        0,
        -7
      ],
      [
        2,
        -12
      ],
      [
        0,
        -2
      ],
      [
        3,
        -9
      ],
      [
        2,
        4
      ],
      [
        11,
        2
      ],
      [
        5,
        5
      ],
      [
        12,
        4
      ],
      [
        4,
        9
      ],
      [
        2,
        0
      ],
      [
        1,
        1
      ],
      [
        3,
        4
      ],
      [
        4,
        2
      ],
      [
        0,
        3
      ],
      [
        3,
        4
      ],
      [
        1,
        -3
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        2,
        -1
      ],
      [
        1,
        -6
      ],
      [
        -4,
        -11
      ],
      [
        1,
        -7
      ],
      [
        1,
        -3
      ],
      [
        2,
        -3
      ],
      [
        11,
        4
      ],
      [
        2,
        -2
      ],
      [
        0,
        2
      ],
      [
        1,
        0
      ],
      [
        3,
        -1
      ],
      [
        0,
        3
      ],
      [
        2,
        -3
      ],
      [
        1,
        2
      ],
      [
        1,
        2
      ],
      [
        1,
        4
      ],
      [
        2,
        1
      ],
      [
        1,
        3
      ],
      [
        1,
        -2
      ],
      [
        3,
        -3
      ],
      [
        1,
        -1
      ],
      [
        1,
        -4
      ],
      [
        2,
        -2
      ],
      [
        8,
        7
      ],
      [
        2,
        0
      ],
      [
        2,
        -5
      ],
      [
        1,
        0
      ],
      [
        1,
        -3
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        1,
        -1
      ],
      [
        2,
        -3
      ],
      [
        0,
        3
      ],
      [
        2,
        1
      ],
      [
        3,
        1
      ],
      [
        2,
        -1
      ],
      [
        1,
        0
      ],
      [
        0,
        1
      ],
      [
        2,
        1
      ],
      [
        0,
        4
      ],
      [
        2,
        3
      ],
      [
        4,
        2
      ],
      [
        1,
        2
      ],
      [
        2,
        -1
      ],
      [
        2,
        -3
      ],
      [
        1,
        -3
      ],
      [
        1,
        -1
      ],
      [
        4,
        5
      ],
      [
        3,
        0
      ],
      [
        3,
        -1
      ],
      [
        6,
        6
      ],
      [
        2,
        1
      ],
      [
        3,
        -2
      ],
      [
        1,
        0
      ],
      [
        5,
        2
      ],
      [
        1,
        0
      ],
      [
        4,
        5
      ],
      [
        3,
        -3
      ],
      [
        4,
        0
      ],
      [
        2,
        2
      ],
      [
        0,
        1
      ],
      [
        2,
        0
      ],
      [
        1,
        -1
      ],
      [
        1,
        -4
      ],
      [
        1,
        0
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        2,
        -1
      ],
      [
        6,
        0
      ],
      [
        5,
        -4
      ],
      [
        5,
        -6
      ],
      [
        2,
        -5
      ],
      [
        1,
        -1
      ],
      [
        5,
        -4
      ],
      [
        1,
        -3
      ],
      [
        2,
        -15
      ],
      [
        1,
        -6
      ],
      [
        1,
        1
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        3,
        -13
      ],
      [
        1,
        -10
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -13
      ],
      [
        1,
        -3
      ],
      [
        1,
        -3
      ],
      [
        1,
        0
      ],
      [
        2,
        -3
      ],
      [
        1,
        -3
      ],
      [
        2,
        -7
      ],
      [
        1,
        0
      ],
      [
        3,
        -3
      ],
      [
        1,
        5
      ],
      [
        4,
        -1
      ],
      [
        1,
        -3
      ],
      [
        0,
        -5
      ],
      [
        3,
        -10
      ],
      [
        2,
        -6
      ],
      [
        1,
        -2
      ],
      [
        2,
        -1
      ],
      [
        0,
        -1
      ],
      [
        1,
        -3
      ],
      [
        1,
        -1
      ],
      [
        3,
        -2
      ],
      [
        1,
        0
      ],
      [
        2,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        4
      ],
      [
        5,
        3
      ],
      [
        1,
        1
      ],
      [
        1,
        5
      ],
      [
        0,
        7
      ],
      [
        1,
        -1
      ],
      [
        1,
        -3
      ],
      [
        1,
        -1
      ],
      [
        0,
        1
      ],
      [
        2,
        13
      ],
      [
        1,
        4
      ],
      [
        0,
        1
      ],
      [
        4,
        2
      ],
      [
        0,
        -4
      ],
      [
        2,
        1
      ],
      [
        1,
        0
      ],
      [
        0,
        4
      ],
      [
        4,
        0
      ],
      [
        0,
        1
      ],
      [
        2,
        3
      ],
      [
        3,
        2
      ],
      [
        4,
        0
      ],
      [
        1,
        -1
      ],
      [
        1,
        -3
      ],
      [
        1,
        1
      ],
      [
        0,
        1
      ],
      [
        2,
        -2
      ],
      [
        0,
        -1
      ],
      [
        2,
        0
      ],
      [
        0,
        2
      ],
      [
        1,
        -3
      ],
      [
        -1,
        0
      ],
      [
        0,
        -5
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        0,
        -9
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        1,
        -2
      ],
      [
        4,
        6
      ],
      [
        0,
        -1
      ],
      [
        2,
        0
      ],
      [
        2,
        2
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        3
      ],
      [
        2,
        0
      ],
      [
        0,
        -3
      ],
      [
        1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        1,
        1
      ],
      [
        0,
        1
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        0,
        -2
      ],
      [
        1,
        0
      ],
      [
        0,
        6
      ],
      [
        3,
        3
      ],
      [
        2,
        -1
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        0,
        3
      ],
      [
        1,
        0
      ],
      [
        0,
        -13
      ],
      [
        2,
        -2
      ],
      [
        2,
        -1
      ],
      [
        2,
        -3
      ],
      [
        0,
        -2
      ],
      [
        1,
        -4
      ],
      [
        1,
        -1
      ],
      [
        3,
        3
      ],
      [
        1,
        6
      ],
      [
        21,
        13
      ],
      [
        0,
        -11
      ],
      [
        -1,
        -3
      ],
      [
        -13,
        -11
      ],
      [
        -3,
        -7
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -7
      ],
      [
        -5,
        -9
      ],
      [
        -4,
        -1
      ],
      [
        -2,
        5
      ],
      [
        -5,
        12
      ],
      [
        -3,
        3
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -10
      ],
      [
        1,
        -6
      ],
      [
        -1,
        -1
      ],
      [
        -5,
        -3
      ],
      [
        -11,
        -11
      ],
      [
        -9,
        -19
      ],
      [
        -2,
        -8
      ],
      [
        -6,
        -13
      ],
      [
        -9,
        -18
      ],
      [
        -17,
        -21
      ],
      [
        -5,
        1
      ],
      [
        -15,
        -14
      ],
      [
        -2,
        -5
      ],
      [
        1,
        -9
      ],
      [
        -2,
        -4
      ],
      [
        -11,
        -19
      ],
      [
        -11,
        -11
      ],
      [
        -8,
        -4
      ],
      [
        -8,
        -8
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        1
      ],
      [
        -2,
        -1
      ],
      [
        -8,
        -9
      ],
      [
        -4,
        0
      ],
      [
        -8,
        -3
      ],
      [
        -5,
        -7
      ],
      [
        -2,
        -10
      ],
      [
        -12,
        -2
      ],
      [
        -5,
        -4
      ],
      [
        -13,
        -16
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        0
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        -15,
        -6
      ],
      [
        -2,
        -4
      ],
      [
        -7,
        -3
      ],
      [
        -5,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        -5,
        -6
      ],
      [
        -22,
        -22
      ],
      [
        -4,
        -14
      ],
      [
        -9,
        -12
      ],
      [
        -17,
        -28
      ],
      [
        -11,
        -15
      ],
      [
        -14,
        -22
      ],
      [
        -37,
        -79
      ],
      [
        -11,
        -28
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -4
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        -1
      ],
      [
        -3,
        -5
      ],
      [
        -23,
        -58
      ]
    ],
    [
      [
        24552,
        72192
      ],
      [
        1,
        493
      ],
      [
        -2,
        17
      ],
      [
        -1,
        188
      ],
      [
        0,
        145
      ]
    ],
    [
      [
        23336,
        66485
      ],
      [
        132,
        -2
      ]
    ],
    [
      [
        23468,
        66483
      ],
      [
        0,
        -100
      ],
      [
        16,
        0
      ],
      [
        -1,
        -308
      ]
    ],
    [
      [
        27863,
        59477
      ],
      [
        95,
        0
      ]
    ],
    [
      [
        27958,
        59477
      ],
      [
        1,
        -18
      ],
      [
        -1,
        -109
      ],
      [
        -1,
        -229
      ]
    ],
    [
      [
        27957,
        59121
      ],
      [
        -42,
        4
      ]
    ],
    [
      [
        27859,
        59128
      ],
      [
        4,
        349
      ]
    ],
    [
      [
        3834,
        96137
      ],
      [
        -12,
        12
      ],
      [
        -18,
        16
      ],
      [
        -54,
        37
      ],
      [
        -27,
        9
      ],
      [
        -24,
        14
      ],
      [
        -8,
        9
      ],
      [
        -21,
        26
      ],
      [
        -5,
        24
      ],
      [
        -14,
        46
      ],
      [
        -26,
        48
      ],
      [
        -28,
        36
      ],
      [
        -45,
        40
      ],
      [
        -36,
        22
      ],
      [
        -45,
        19
      ],
      [
        -42,
        -6
      ],
      [
        12,
        20
      ],
      [
        25,
        20
      ],
      [
        92,
        59
      ],
      [
        4,
        5
      ],
      [
        6,
        9
      ],
      [
        3,
        9
      ],
      [
        7,
        23
      ],
      [
        0,
        3
      ],
      [
        1,
        7
      ],
      [
        2,
        47
      ],
      [
        14,
        50
      ],
      [
        3,
        12
      ],
      [
        2,
        14
      ],
      [
        0,
        3
      ],
      [
        -2,
        10
      ],
      [
        1,
        31
      ],
      [
        4,
        59
      ],
      [
        4,
        16
      ],
      [
        1,
        14
      ],
      [
        3,
        103
      ],
      [
        -1,
        14
      ],
      [
        -2,
        15
      ],
      [
        -2,
        17
      ],
      [
        -5,
        49
      ],
      [
        -1,
        15
      ],
      [
        3,
        7
      ],
      [
        111,
        -18
      ],
      [
        42,
        -10
      ],
      [
        26,
        -3
      ],
      [
        14,
        4
      ],
      [
        54,
        2
      ],
      [
        101,
        29
      ],
      [
        23,
        10
      ],
      [
        20,
        3
      ],
      [
        44,
        18
      ],
      [
        35,
        10
      ],
      [
        64,
        11
      ],
      [
        13,
        4
      ],
      [
        25,
        16
      ],
      [
        9,
        7
      ],
      [
        17,
        22
      ],
      [
        26,
        18
      ],
      [
        23,
        31
      ],
      [
        10,
        20
      ],
      [
        8,
        14
      ],
      [
        29,
        30
      ],
      [
        19,
        28
      ],
      [
        23,
        39
      ],
      [
        11,
        20
      ],
      [
        23,
        62
      ],
      [
        43,
        93
      ],
      [
        8,
        19
      ],
      [
        7,
        18
      ],
      [
        11,
        44
      ],
      [
        10,
        48
      ],
      [
        3,
        33
      ],
      [
        2,
        19
      ],
      [
        2,
        27
      ],
      [
        -2,
        6
      ],
      [
        1,
        73
      ],
      [
        0,
        24
      ],
      [
        -1,
        83
      ],
      [
        2,
        29
      ],
      [
        7,
        35
      ],
      [
        3,
        9
      ],
      [
        10,
        72
      ],
      [
        2,
        12
      ],
      [
        6,
        36
      ],
      [
        9,
        40
      ],
      [
        6,
        14
      ],
      [
        20,
        44
      ],
      [
        18,
        37
      ],
      [
        7,
        9
      ],
      [
        11,
        31
      ],
      [
        22,
        48
      ],
      [
        15,
        40
      ],
      [
        14,
        37
      ],
      [
        5,
        19
      ],
      [
        8,
        23
      ],
      [
        10,
        17
      ],
      [
        5,
        15
      ],
      [
        8,
        28
      ],
      [
        8,
        18
      ],
      [
        16,
        31
      ],
      [
        13,
        28
      ],
      [
        11,
        16
      ],
      [
        24,
        31
      ],
      [
        40,
        47
      ],
      [
        7,
        6
      ],
      [
        0,
        5
      ],
      [
        15,
        17
      ],
      [
        15,
        15
      ],
      [
        3,
        7
      ],
      [
        14,
        18
      ],
      [
        10,
        -4
      ],
      [
        20,
        -7
      ],
      [
        34,
        -13
      ],
      [
        32,
        -11
      ],
      [
        25,
        -5
      ],
      [
        12,
        0
      ],
      [
        14,
        1
      ],
      [
        14,
        -3
      ],
      [
        4,
        4
      ],
      [
        14,
        9
      ],
      [
        41,
        25
      ],
      [
        13,
        6
      ],
      [
        11,
        9
      ],
      [
        53,
        44
      ],
      [
        57,
        59
      ],
      [
        36,
        45
      ],
      [
        74,
        108
      ],
      [
        44,
        86
      ],
      [
        40,
        68
      ],
      [
        32,
        47
      ],
      [
        42,
        73
      ],
      [
        17,
        18
      ],
      [
        16,
        13
      ],
      [
        37,
        23
      ],
      [
        62,
        40
      ],
      [
        7,
        -47
      ],
      [
        9,
        -20
      ],
      [
        14,
        0
      ],
      [
        32,
        -24
      ],
      [
        52,
        -10
      ],
      [
        30,
        -2
      ],
      [
        23,
        10
      ],
      [
        14,
        -3
      ],
      [
        17,
        12
      ],
      [
        14,
        -4
      ],
      [
        10,
        9
      ],
      [
        3,
        15
      ],
      [
        32,
        -3
      ],
      [
        26,
        4
      ],
      [
        35,
        13
      ],
      [
        41,
        25
      ],
      [
        12,
        9
      ],
      [
        20,
        17
      ],
      [
        17,
        18
      ],
      [
        57,
        67
      ],
      [
        23,
        33
      ],
      [
        8,
        13
      ],
      [
        40,
        75
      ],
      [
        36,
        88
      ],
      [
        13,
        30
      ],
      [
        31,
        67
      ],
      [
        42,
        88
      ],
      [
        10,
        14
      ],
      [
        36,
        45
      ],
      [
        7,
        7
      ],
      [
        15,
        10
      ],
      [
        0,
        -22
      ],
      [
        2,
        -20
      ],
      [
        1,
        -5
      ],
      [
        7,
        -18
      ],
      [
        2,
        -3
      ],
      [
        34,
        -30
      ],
      [
        13,
        -8
      ],
      [
        10,
        -3
      ],
      [
        5,
        2
      ],
      [
        24,
        -1
      ],
      [
        39,
        -20
      ],
      [
        13,
        -46
      ],
      [
        -3,
        -8
      ],
      [
        -1,
        -11
      ],
      [
        0,
        -2
      ],
      [
        7,
        -15
      ],
      [
        17,
        16
      ],
      [
        10,
        25
      ],
      [
        7,
        -16
      ],
      [
        3,
        -4
      ],
      [
        16,
        2
      ],
      [
        7,
        5
      ],
      [
        12,
        -2
      ],
      [
        29,
        -14
      ],
      [
        19,
        -12
      ],
      [
        6,
        -8
      ],
      [
        -1,
        -28
      ],
      [
        2,
        -15
      ],
      [
        12,
        -30
      ],
      [
        1,
        -7
      ],
      [
        1,
        -7
      ],
      [
        0,
        -11
      ],
      [
        -6,
        -16
      ],
      [
        -4,
        -8
      ],
      [
        -25,
        -21
      ],
      [
        -19,
        -26
      ],
      [
        -2,
        -9
      ],
      [
        -14,
        -31
      ],
      [
        -19,
        -23
      ],
      [
        -13,
        2
      ],
      [
        -21,
        -3
      ],
      [
        -7,
        -3
      ],
      [
        -5,
        -17
      ],
      [
        5,
        -34
      ],
      [
        -10,
        -18
      ],
      [
        0,
        -8
      ],
      [
        17,
        -4
      ],
      [
        8,
        -47
      ],
      [
        -3,
        -18
      ],
      [
        19,
        -9
      ],
      [
        38,
        2
      ],
      [
        24,
        -8
      ],
      [
        28,
        27
      ],
      [
        11,
        15
      ],
      [
        4,
        13
      ],
      [
        1,
        4
      ],
      [
        0,
        32
      ],
      [
        -2,
        17
      ],
      [
        -5,
        27
      ],
      [
        10,
        4
      ],
      [
        6,
        4
      ],
      [
        14,
        24
      ],
      [
        6,
        13
      ],
      [
        5,
        18
      ],
      [
        6,
        12
      ],
      [
        23,
        12
      ],
      [
        0,
        -4
      ],
      [
        1,
        -8
      ],
      [
        13,
        -31
      ],
      [
        2,
        -4
      ],
      [
        3,
        -1
      ],
      [
        3,
        5
      ],
      [
        4,
        12
      ],
      [
        2,
        9
      ],
      [
        0,
        8
      ],
      [
        -1,
        13
      ],
      [
        -4,
        16
      ],
      [
        -27,
        43
      ],
      [
        0,
        7
      ],
      [
        3,
        10
      ],
      [
        2,
        2
      ],
      [
        30,
        36
      ],
      [
        1,
        -1
      ],
      [
        0,
        -9
      ],
      [
        1,
        -7
      ],
      [
        4,
        -23
      ],
      [
        2,
        -5
      ],
      [
        3,
        -3
      ],
      [
        10,
        1
      ],
      [
        3,
        14
      ],
      [
        0,
        28
      ],
      [
        -6,
        23
      ],
      [
        7,
        21
      ],
      [
        8,
        1
      ],
      [
        25,
        -23
      ],
      [
        46,
        -51
      ],
      [
        45,
        -66
      ],
      [
        3,
        -5
      ],
      [
        6,
        -17
      ],
      [
        4,
        -20
      ],
      [
        -7,
        -15
      ],
      [
        -4,
        -18
      ],
      [
        0,
        -61
      ],
      [
        1,
        -48
      ],
      [
        9,
        -49
      ],
      [
        15,
        -4
      ],
      [
        4,
        -1
      ],
      [
        5,
        4
      ],
      [
        15,
        7
      ],
      [
        22,
        4
      ],
      [
        26,
        -23
      ],
      [
        9,
        -14
      ],
      [
        1,
        -9
      ],
      [
        -4,
        -21
      ],
      [
        16,
        -10
      ],
      [
        3,
        0
      ],
      [
        12,
        11
      ],
      [
        16,
        18
      ],
      [
        20,
        33
      ],
      [
        6,
        14
      ],
      [
        7,
        24
      ],
      [
        4,
        18
      ],
      [
        1,
        5
      ],
      [
        -1,
        3
      ],
      [
        1,
        2
      ],
      [
        12,
        9
      ],
      [
        24,
        0
      ],
      [
        15,
        3
      ],
      [
        10,
        0
      ],
      [
        13,
        -6
      ],
      [
        14,
        2
      ],
      [
        25,
        0
      ],
      [
        11,
        1
      ],
      [
        17,
        5
      ],
      [
        19,
        9
      ],
      [
        9,
        7
      ],
      [
        20,
        19
      ],
      [
        4,
        2
      ],
      [
        26,
        -4
      ],
      [
        27,
        -7
      ],
      [
        5,
        -14
      ],
      [
        9,
        -7
      ],
      [
        19,
        -4
      ],
      [
        7,
        -9
      ],
      [
        17,
        17
      ],
      [
        18,
        -19
      ],
      [
        49,
        0
      ],
      [
        28,
        -16
      ],
      [
        33,
        -16
      ],
      [
        9,
        -12
      ],
      [
        16,
        -8
      ],
      [
        20,
        -15
      ],
      [
        10,
        -26
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        -13,
        -2
      ],
      [
        -7,
        -3
      ],
      [
        -6,
        -6
      ],
      [
        -24,
        -65
      ],
      [
        -2,
        -18
      ],
      [
        -26,
        -30
      ],
      [
        0,
        -6
      ],
      [
        3,
        -43
      ],
      [
        8,
        -34
      ],
      [
        3,
        -10
      ],
      [
        16,
        -9
      ],
      [
        2,
        3
      ],
      [
        4,
        10
      ],
      [
        3,
        1
      ],
      [
        19,
        -24
      ],
      [
        18,
        -7
      ],
      [
        8,
        -1
      ],
      [
        7,
        2
      ],
      [
        12,
        0
      ],
      [
        7,
        -3
      ],
      [
        5,
        -11
      ],
      [
        -2,
        -8
      ],
      [
        0,
        -6
      ],
      [
        11,
        -4
      ],
      [
        14,
        4
      ],
      [
        27,
        -10
      ],
      [
        17,
        -10
      ],
      [
        12,
        2
      ],
      [
        8,
        7
      ],
      [
        8,
        2
      ],
      [
        5,
        -2
      ],
      [
        1,
        -5
      ],
      [
        0,
        -2
      ],
      [
        -4,
        -1
      ],
      [
        -3,
        -6
      ],
      [
        -8,
        -20
      ],
      [
        -3,
        -9
      ],
      [
        7,
        -15
      ],
      [
        2,
        -10
      ],
      [
        -13,
        -11
      ],
      [
        -14,
        -2
      ],
      [
        -26,
        -13
      ],
      [
        -5,
        -11
      ],
      [
        -3,
        -13
      ],
      [
        13,
        -21
      ],
      [
        7,
        -4
      ],
      [
        9,
        5
      ],
      [
        16,
        2
      ],
      [
        37,
        -2
      ],
      [
        13,
        3
      ],
      [
        14,
        -2
      ],
      [
        31,
        -12
      ],
      [
        28,
        -20
      ],
      [
        13,
        -9
      ],
      [
        14,
        -33
      ],
      [
        28,
        5
      ],
      [
        4,
        17
      ],
      [
        13,
        13
      ],
      [
        11,
        30
      ],
      [
        7,
        7
      ],
      [
        9,
        19
      ],
      [
        11,
        10
      ],
      [
        13,
        2
      ],
      [
        13,
        -11
      ],
      [
        9,
        3
      ],
      [
        11,
        11
      ],
      [
        12,
        -3
      ],
      [
        12,
        -15
      ],
      [
        9,
        18
      ],
      [
        1,
        16
      ],
      [
        40,
        7
      ],
      [
        6,
        -14
      ],
      [
        23,
        -13
      ],
      [
        11,
        -25
      ],
      [
        -3,
        -12
      ],
      [
        7,
        -22
      ],
      [
        42,
        27
      ],
      [
        27,
        -1
      ],
      [
        3,
        1
      ],
      [
        8,
        8
      ],
      [
        58,
        83
      ],
      [
        13,
        -22
      ],
      [
        2,
        -2
      ],
      [
        6,
        1
      ],
      [
        14,
        8
      ],
      [
        3,
        6
      ],
      [
        4,
        2
      ],
      [
        15,
        5
      ],
      [
        1,
        0
      ],
      [
        2,
        -5
      ],
      [
        19,
        -10
      ],
      [
        5,
        0
      ],
      [
        8,
        4
      ],
      [
        3,
        3
      ],
      [
        4,
        8
      ],
      [
        14,
        11
      ],
      [
        8,
        -17
      ],
      [
        4,
        -13
      ],
      [
        5,
        -3
      ],
      [
        24,
        6
      ],
      [
        37,
        -11
      ],
      [
        27,
        -24
      ],
      [
        35,
        -48
      ],
      [
        8,
        3
      ],
      [
        20,
        -4
      ],
      [
        19,
        -24
      ],
      [
        17,
        12
      ],
      [
        8,
        15
      ],
      [
        1,
        4
      ],
      [
        8,
        1
      ],
      [
        16,
        -9
      ],
      [
        5,
        -6
      ],
      [
        3,
        -5
      ],
      [
        29,
        -62
      ],
      [
        3,
        -23
      ],
      [
        -3,
        -22
      ],
      [
        3,
        -8
      ],
      [
        4,
        -6
      ],
      [
        11,
        -7
      ],
      [
        14,
        0
      ],
      [
        3,
        2
      ],
      [
        23,
        29
      ],
      [
        3,
        9
      ],
      [
        15,
        13
      ],
      [
        -7,
        -29
      ],
      [
        0,
        -24
      ],
      [
        8,
        -10
      ],
      [
        9,
        12
      ],
      [
        8,
        20
      ],
      [
        0,
        19
      ],
      [
        9,
        6
      ],
      [
        5,
        -7
      ],
      [
        0,
        -7
      ],
      [
        3,
        -4
      ],
      [
        33,
        -16
      ],
      [
        27,
        -24
      ],
      [
        13,
        -19
      ],
      [
        8,
        -34
      ],
      [
        6,
        -33
      ],
      [
        24,
        -23
      ],
      [
        9,
        4
      ],
      [
        17,
        0
      ],
      [
        23,
        -3
      ],
      [
        20,
        -14
      ],
      [
        8,
        -4
      ],
      [
        5,
        0
      ],
      [
        10,
        3
      ],
      [
        29,
        36
      ],
      [
        3,
        -13
      ],
      [
        1,
        -14
      ],
      [
        3,
        -19
      ],
      [
        11,
        -22
      ],
      [
        5,
        -5
      ],
      [
        48,
        -10
      ],
      [
        5,
        5
      ],
      [
        18,
        25
      ],
      [
        6,
        15
      ],
      [
        43,
        -12
      ],
      [
        5,
        0
      ],
      [
        25,
        8
      ],
      [
        32,
        4
      ],
      [
        17,
        -3
      ],
      [
        10,
        -6
      ],
      [
        22,
        -2
      ],
      [
        7,
        3
      ],
      [
        10,
        -2
      ],
      [
        28,
        -13
      ],
      [
        12,
        -8
      ],
      [
        4,
        -5
      ],
      [
        5,
        -12
      ],
      [
        25,
        -5
      ],
      [
        15,
        0
      ],
      [
        10,
        2
      ],
      [
        12,
        8
      ],
      [
        5,
        20
      ],
      [
        4,
        -2
      ],
      [
        14,
        -19
      ],
      [
        2,
        -10
      ],
      [
        5,
        -13
      ],
      [
        2,
        -3
      ],
      [
        38,
        -48
      ],
      [
        12,
        -9
      ],
      [
        16,
        1
      ],
      [
        5,
        -4
      ],
      [
        10,
        -18
      ],
      [
        0,
        -12
      ],
      [
        10,
        -13
      ],
      [
        7,
        -7
      ],
      [
        21,
        -10
      ],
      [
        24,
        -6
      ],
      [
        8,
        -12
      ],
      [
        6,
        -14
      ],
      [
        6,
        -4
      ],
      [
        45,
        -12
      ],
      [
        6,
        -4
      ],
      [
        7,
        -16
      ],
      [
        4,
        -6
      ],
      [
        14,
        6
      ],
      [
        10,
        9
      ],
      [
        1,
        2
      ],
      [
        2,
        14
      ],
      [
        0,
        1
      ],
      [
        17,
        -8
      ],
      [
        15,
        -11
      ],
      [
        19,
        -4
      ],
      [
        15,
        3
      ],
      [
        8,
        9
      ],
      [
        22,
        32
      ],
      [
        6,
        22
      ],
      [
        9,
        14
      ],
      [
        20,
        6
      ],
      [
        28,
        0
      ],
      [
        3,
        9
      ],
      [
        6,
        11
      ],
      [
        22,
        6
      ],
      [
        12,
        19
      ],
      [
        11,
        7
      ],
      [
        19,
        3
      ],
      [
        20,
        14
      ],
      [
        10,
        18
      ],
      [
        8,
        6
      ],
      [
        17,
        -15
      ],
      [
        14,
        7
      ],
      [
        1,
        14
      ],
      [
        16,
        7
      ],
      [
        15,
        3
      ],
      [
        11,
        0
      ],
      [
        12,
        14
      ],
      [
        17,
        -9
      ],
      [
        25,
        -16
      ],
      [
        19,
        9
      ],
      [
        21,
        21
      ],
      [
        8,
        2
      ],
      [
        9,
        -18
      ],
      [
        8,
        -6
      ],
      [
        12,
        -10
      ],
      [
        32,
        -31
      ],
      [
        27,
        -26
      ],
      [
        53,
        -37
      ],
      [
        70,
        -80
      ],
      [
        12,
        -18
      ],
      [
        12,
        -29
      ],
      [
        2,
        -20
      ],
      [
        37,
        -11
      ],
      [
        9,
        -12
      ],
      [
        35,
        -40
      ],
      [
        9,
        -8
      ],
      [
        1,
        -2
      ],
      [
        33,
        -35
      ],
      [
        32,
        -13
      ],
      [
        36,
        -27
      ],
      [
        30,
        -32
      ],
      [
        22,
        -30
      ],
      [
        27,
        -47
      ],
      [
        35,
        -12
      ],
      [
        26,
        -1
      ],
      [
        26,
        -13
      ],
      [
        32,
        -32
      ],
      [
        0,
        -1335
      ]
    ],
    [
      [
        31527,
        37962
      ],
      [
        3,
        2
      ],
      [
        12,
        -28
      ],
      [
        7,
        -1
      ],
      [
        8,
        -18
      ],
      [
        4,
        6
      ],
      [
        4,
        -16
      ]
    ],
    [
      [
        31565,
        37907
      ],
      [
        -5,
        -6
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -17
      ],
      [
        -1,
        0
      ],
      [
        -2,
        2
      ],
      [
        -3,
        -7
      ],
      [
        -2,
        -4
      ]
    ],
    [
      [
        31548,
        37871
      ],
      [
        -9,
        14
      ],
      [
        -2,
        35
      ],
      [
        -8,
        14
      ],
      [
        -2,
        28
      ]
    ],
    [
      [
        26051,
        64669
      ],
      [
        53,
        4
      ],
      [
        33,
        0
      ]
    ],
    [
      [
        26136,
        64570
      ],
      [
        1,
        -306
      ],
      [
        -3,
        1
      ],
      [
        -29,
        -2
      ]
    ],
    [
      [
        26105,
        64263
      ],
      [
        -53,
        0
      ]
    ],
    [
      [
        24516,
        60822
      ],
      [
        2,
        51
      ],
      [
        13,
        -1
      ]
    ],
    [
      [
        24657,
        60866
      ],
      [
        0,
        -107
      ],
      [
        31,
        1
      ]
    ],
    [
      [
        24688,
        60760
      ],
      [
        0,
        -53
      ],
      [
        -3,
        0
      ],
      [
        -1,
        -327
      ]
    ],
    [
      [
        24684,
        60380
      ],
      [
        0,
        -52
      ],
      [
        -26,
        -1
      ],
      [
        -5,
        3
      ],
      [
        -21,
        -4
      ]
    ],
    [
      [
        24632,
        60326
      ],
      [
        -5,
        -1
      ],
      [
        1,
        119
      ],
      [
        -6,
        1
      ],
      [
        1,
        267
      ],
      [
        -6,
        -1
      ],
      [
        -55,
        2
      ],
      [
        -32,
        -18
      ],
      [
        -15,
        0
      ]
    ],
    [
      [
        21868,
        55312
      ],
      [
        -93,
        1
      ],
      [
        -13,
        7
      ]
    ],
    [
      [
        27385,
        60182
      ],
      [
        15,
        38
      ],
      [
        28,
        36
      ],
      [
        8,
        15
      ],
      [
        18,
        24
      ]
    ],
    [
      [
        27454,
        60295
      ],
      [
        -2,
        -39
      ],
      [
        7,
        -32
      ],
      [
        7,
        17
      ],
      [
        10,
        10
      ],
      [
        4,
        -7
      ],
      [
        -2,
        -9
      ],
      [
        -9,
        -3
      ],
      [
        -3,
        -19
      ],
      [
        3,
        -14
      ],
      [
        6,
        -9
      ],
      [
        0,
        -24
      ]
    ],
    [
      [
        27461,
        60115
      ],
      [
        11,
        -48
      ],
      [
        -7,
        -1
      ],
      [
        7,
        -73
      ]
    ],
    [
      [
        27472,
        59993
      ],
      [
        -3,
        -17
      ],
      [
        -12,
        -32
      ],
      [
        -11,
        -13
      ]
    ],
    [
      [
        27446,
        59931
      ],
      [
        -11,
        -28
      ],
      [
        -2,
        -15
      ],
      [
        -16,
        -18
      ]
    ],
    [
      [
        27417,
        59870
      ],
      [
        -14,
        64
      ],
      [
        -20,
        81
      ],
      [
        -9,
        27
      ],
      [
        -5,
        54
      ]
    ],
    [
      [
        27369,
        60096
      ],
      [
        -5,
        48
      ],
      [
        7,
        6
      ],
      [
        14,
        32
      ]
    ],
    [
      [
        23665,
        63207
      ],
      [
        0,
        50
      ]
    ],
    [
      [
        23790,
        63050
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        23790,
        62949
      ],
      [
        -31,
        2
      ],
      [
        -30,
        -2
      ],
      [
        -49,
        2
      ],
      [
        -15,
        1
      ]
    ],
    [
      [
        25598,
        55951
      ],
      [
        -2,
        11
      ],
      [
        2,
        10
      ],
      [
        5,
        -19
      ],
      [
        5,
        29
      ],
      [
        6,
        -1
      ],
      [
        7,
        20
      ],
      [
        -3,
        8
      ],
      [
        -2,
        19
      ],
      [
        2,
        24
      ],
      [
        5,
        0
      ],
      [
        0,
        17
      ],
      [
        10,
        -1
      ],
      [
        0,
        17
      ],
      [
        14,
        0
      ],
      [
        0,
        34
      ],
      [
        10,
        -1
      ],
      [
        0,
        34
      ],
      [
        5,
        2
      ],
      [
        0,
        49
      ],
      [
        2,
        0
      ],
      [
        0,
        12
      ],
      [
        2,
        39
      ],
      [
        5,
        0
      ],
      [
        0,
        17
      ],
      [
        10,
        -1
      ],
      [
        4,
        16
      ],
      [
        1,
        17
      ]
    ],
    [
      [
        25686,
        56303
      ],
      [
        5,
        0
      ],
      [
        14,
        33
      ],
      [
        27,
        -3
      ],
      [
        8,
        0
      ],
      [
        31,
        -87
      ],
      [
        12,
        -1
      ],
      [
        7,
        0
      ]
    ],
    [
      [
        25790,
        56245
      ],
      [
        10,
        0
      ],
      [
        0,
        -34
      ],
      [
        5,
        -17
      ],
      [
        0,
        -76
      ],
      [
        -7,
        -42
      ],
      [
        0,
        -69
      ],
      [
        9,
        -9
      ],
      [
        0,
        -8
      ]
    ],
    [
      [
        25807,
        55990
      ],
      [
        0,
        -26
      ],
      [
        -12,
        -7
      ],
      [
        -12,
        -59
      ],
      [
        -10,
        0
      ],
      [
        -8,
        -1
      ],
      [
        -1,
        -17
      ],
      [
        -5,
        0
      ],
      [
        -3,
        -25
      ],
      [
        -3,
        0
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -10
      ],
      [
        -2,
        0
      ],
      [
        -6,
        1
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        -32
      ],
      [
        -4,
        1
      ],
      [
        0,
        -26
      ],
      [
        -15,
        -7
      ],
      [
        0,
        -33
      ],
      [
        -14,
        0
      ],
      [
        -4,
        -18
      ],
      [
        -9,
        -24
      ],
      [
        0,
        -21
      ],
      [
        -12,
        -12
      ],
      [
        -2,
        -14
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -8
      ],
      [
        -13,
        0
      ]
    ],
    [
      [
        25665,
        55641
      ],
      [
        -10,
        1
      ]
    ],
    [
      [
        25655,
        55642
      ],
      [
        0,
        33
      ],
      [
        -6,
        5
      ],
      [
        -1,
        13
      ],
      [
        -10,
        0
      ],
      [
        -1,
        17
      ],
      [
        -9,
        1
      ],
      [
        0,
        17
      ],
      [
        -5,
        8
      ],
      [
        0,
        17
      ],
      [
        -4,
        1
      ],
      [
        -1,
        17
      ],
      [
        -10,
        9
      ],
      [
        0,
        34
      ],
      [
        -5,
        1
      ],
      [
        -1,
        26
      ],
      [
        -8,
        9
      ],
      [
        0,
        17
      ],
      [
        -9,
        1
      ],
      [
        0,
        17
      ],
      [
        -6,
        0
      ],
      [
        -1,
        17
      ],
      [
        3,
        25
      ],
      [
        12,
        -7
      ],
      [
        0,
        19
      ],
      [
        7,
        -2
      ],
      [
        -2,
        14
      ]
    ],
    [
      [
        6433,
        39922
      ],
      [
        1,
        16
      ],
      [
        1,
        28
      ],
      [
        8,
        25
      ],
      [
        4,
        18
      ],
      [
        1,
        3
      ],
      [
        6,
        30
      ],
      [
        2,
        5
      ],
      [
        3,
        6
      ],
      [
        4,
        2
      ],
      [
        1,
        -3
      ],
      [
        0,
        -1
      ],
      [
        2,
        -2
      ],
      [
        4,
        8
      ],
      [
        0,
        6
      ],
      [
        -1,
        7
      ],
      [
        1,
        6
      ],
      [
        2,
        14
      ],
      [
        1,
        7
      ],
      [
        3,
        22
      ],
      [
        2,
        13
      ],
      [
        0,
        4
      ],
      [
        1,
        6
      ],
      [
        7,
        26
      ],
      [
        3,
        17
      ],
      [
        4,
        10
      ],
      [
        1,
        -2
      ],
      [
        1,
        1
      ],
      [
        1,
        7
      ],
      [
        1,
        15
      ],
      [
        1,
        36
      ],
      [
        -1,
        11
      ],
      [
        -6,
        31
      ],
      [
        -5,
        19
      ],
      [
        -5,
        33
      ],
      [
        -4,
        45
      ],
      [
        -2,
        69
      ],
      [
        1,
        36
      ],
      [
        3,
        22
      ],
      [
        3,
        10
      ],
      [
        2,
        5
      ],
      [
        6,
        4
      ],
      [
        12,
        -13
      ],
      [
        7,
        -16
      ],
      [
        2,
        -1
      ],
      [
        1,
        0
      ],
      [
        8,
        -15
      ],
      [
        2,
        -11
      ],
      [
        1,
        -12
      ],
      [
        0,
        -9
      ],
      [
        10,
        -19
      ],
      [
        12,
        -25
      ],
      [
        7,
        -24
      ],
      [
        2,
        -1
      ],
      [
        4,
        -9
      ],
      [
        2,
        -13
      ],
      [
        1,
        -3
      ],
      [
        2,
        -2
      ],
      [
        3,
        1
      ],
      [
        3,
        8
      ],
      [
        3,
        2
      ],
      [
        10,
        -14
      ],
      [
        2,
        -6
      ],
      [
        4,
        -1
      ],
      [
        9,
        -11
      ],
      [
        7,
        -11
      ],
      [
        11,
        -19
      ],
      [
        0,
        -4
      ],
      [
        5,
        -10
      ],
      [
        16,
        -33
      ],
      [
        9,
        -16
      ],
      [
        4,
        -3
      ],
      [
        3,
        -9
      ],
      [
        8,
        -28
      ],
      [
        11,
        -24
      ],
      [
        2,
        -13
      ],
      [
        4,
        -11
      ],
      [
        9,
        -30
      ],
      [
        1,
        -3
      ],
      [
        4,
        -16
      ],
      [
        2,
        -11
      ],
      [
        1,
        -13
      ],
      [
        4,
        -16
      ],
      [
        2,
        -6
      ],
      [
        1,
        1
      ],
      [
        3,
        -15
      ],
      [
        0,
        -20
      ],
      [
        -1,
        -13
      ],
      [
        -2,
        -14
      ],
      [
        1,
        -18
      ],
      [
        0,
        -72
      ],
      [
        1,
        -11
      ],
      [
        2,
        -2
      ],
      [
        5,
        3
      ],
      [
        5,
        12
      ],
      [
        11,
        0
      ],
      [
        2,
        -13
      ],
      [
        2,
        -14
      ],
      [
        1,
        -9
      ],
      [
        2,
        -21
      ],
      [
        -1,
        -21
      ],
      [
        0,
        -36
      ],
      [
        3,
        -10
      ],
      [
        3,
        -6
      ],
      [
        3,
        -1
      ],
      [
        1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -9
      ],
      [
        1,
        -11
      ],
      [
        4,
        -8
      ],
      [
        2,
        -6
      ],
      [
        1,
        -7
      ],
      [
        5,
        -18
      ],
      [
        8,
        -17
      ],
      [
        7,
        -8
      ],
      [
        4,
        -13
      ],
      [
        3,
        -1
      ],
      [
        3,
        -9
      ],
      [
        2,
        -9
      ],
      [
        0,
        -3
      ],
      [
        -4,
        -44
      ],
      [
        -4,
        -21
      ],
      [
        -9,
        -30
      ],
      [
        -5,
        -13
      ],
      [
        -12,
        -34
      ],
      [
        -4,
        -18
      ],
      [
        -6,
        -19
      ],
      [
        -4,
        -19
      ],
      [
        -11,
        -21
      ],
      [
        -12,
        -17
      ],
      [
        -14,
        -30
      ],
      [
        -6,
        -17
      ],
      [
        -7,
        -9
      ],
      [
        -3,
        0
      ],
      [
        -5,
        -3
      ],
      [
        -2,
        -6
      ],
      [
        -3,
        0
      ],
      [
        -10,
        12
      ],
      [
        -6,
        3
      ],
      [
        -9,
        -9
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -2
      ],
      [
        -3,
        -11
      ],
      [
        -7,
        -19
      ],
      [
        -3,
        -19
      ],
      [
        -3,
        -10
      ],
      [
        -5,
        -8
      ],
      [
        -3,
        -2
      ],
      [
        -8,
        -15
      ],
      [
        -2,
        -10
      ],
      [
        -2,
        -10
      ],
      [
        -6,
        -22
      ],
      [
        -3,
        -6
      ],
      [
        -11,
        -10
      ],
      [
        -3,
        -6
      ],
      [
        1,
        -6
      ],
      [
        0,
        -4
      ],
      [
        -2,
        -8
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -4,
        -27
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -8
      ],
      [
        1,
        -15
      ],
      [
        0,
        -18
      ],
      [
        -1,
        -8
      ],
      [
        -2,
        -17
      ],
      [
        -3,
        -6
      ],
      [
        -2,
        -6
      ],
      [
        -3,
        -27
      ],
      [
        -1,
        -21
      ],
      [
        -1,
        -11
      ],
      [
        -3,
        -1
      ],
      [
        -4,
        -10
      ],
      [
        0,
        -2
      ],
      [
        -3,
        -22
      ],
      [
        -6,
        -19
      ],
      [
        -4,
        -9
      ],
      [
        -2,
        2
      ],
      [
        -2,
        5
      ],
      [
        -1,
        10
      ],
      [
        -1,
        10
      ],
      [
        -9,
        34
      ],
      [
        -10,
        14
      ],
      [
        -12,
        38
      ],
      [
        -13,
        11
      ],
      [
        -8,
        15
      ],
      [
        -1,
        3
      ],
      [
        0,
        19
      ],
      [
        -5,
        29
      ],
      [
        -1,
        1
      ],
      [
        -4,
        46
      ],
      [
        1,
        41
      ],
      [
        4,
        72
      ],
      [
        -1,
        14
      ],
      [
        1,
        33
      ],
      [
        2,
        19
      ],
      [
        1,
        28
      ],
      [
        1,
        45
      ],
      [
        0,
        12
      ],
      [
        -3,
        35
      ],
      [
        -4,
        27
      ],
      [
        1,
        17
      ],
      [
        -3,
        17
      ],
      [
        -1,
        10
      ],
      [
        0,
        34
      ],
      [
        1,
        12
      ],
      [
        -1,
        4
      ],
      [
        -2,
        4
      ],
      [
        -1,
        1
      ],
      [
        0,
        -5
      ],
      [
        -1,
        0
      ],
      [
        -3,
        6
      ],
      [
        -1,
        2
      ],
      [
        0,
        25
      ],
      [
        -2,
        43
      ],
      [
        0,
        6
      ],
      [
        -1,
        3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        36
      ],
      [
        -2,
        25
      ],
      [
        -1,
        6
      ],
      [
        -4,
        35
      ],
      [
        -9,
        8
      ],
      [
        -1,
        4
      ],
      [
        -1,
        7
      ],
      [
        1,
        11
      ],
      [
        1,
        4
      ],
      [
        0,
        8
      ],
      [
        -2,
        13
      ],
      [
        -3,
        10
      ],
      [
        -1,
        5
      ],
      [
        -1,
        18
      ],
      [
        -1,
        4
      ],
      [
        -2,
        10
      ],
      [
        2,
        14
      ]
    ],
    [
      [
        17077,
        71214
      ],
      [
        7,
        -3
      ],
      [
        8,
        4
      ],
      [
        7,
        23
      ],
      [
        5,
        43
      ],
      [
        4,
        15
      ],
      [
        15,
        9
      ],
      [
        11,
        -3
      ],
      [
        6,
        -24
      ],
      [
        8,
        -8
      ],
      [
        13,
        9
      ],
      [
        10,
        -4
      ],
      [
        4,
        6
      ],
      [
        3,
        15
      ],
      [
        7,
        5
      ],
      [
        5,
        -28
      ],
      [
        5,
        -21
      ],
      [
        10,
        -4
      ],
      [
        2,
        -7
      ],
      [
        -1,
        -26
      ],
      [
        2,
        -12
      ],
      [
        7,
        -15
      ],
      [
        6,
        -24
      ],
      [
        7,
        -1
      ],
      [
        16,
        -41
      ],
      [
        6,
        -52
      ],
      [
        -2,
        -23
      ],
      [
        3,
        -22
      ]
    ],
    [
      [
        17251,
        71025
      ],
      [
        0,
        -59
      ],
      [
        -36,
        1
      ],
      [
        1,
        -17
      ],
      [
        -12,
        0
      ],
      [
        0,
        -17
      ],
      [
        -6,
        0
      ],
      [
        0,
        -304
      ],
      [
        -17,
        0
      ],
      [
        0,
        -144
      ]
    ],
    [
      [
        17181,
        70485
      ],
      [
        -7,
        0
      ],
      [
        -27,
        1
      ]
    ],
    [
      [
        17147,
        70486
      ],
      [
        0,
        142
      ],
      [
        -3,
        0
      ],
      [
        0,
        253
      ],
      [
        -17,
        -1
      ],
      [
        0,
        53
      ],
      [
        -6,
        0
      ],
      [
        0,
        17
      ],
      [
        -6,
        0
      ],
      [
        0,
        51
      ],
      [
        -6,
        1
      ],
      [
        0,
        34
      ],
      [
        -35,
        -1
      ],
      [
        3,
        104
      ],
      [
        0,
        75
      ]
    ],
    [
      [
        25993,
        55935
      ],
      [
        0,
        -9
      ],
      [
        -5,
        0
      ],
      [
        0,
        -17
      ],
      [
        -5,
        0
      ],
      [
        29,
        -8
      ],
      [
        0,
        16
      ],
      [
        5,
        0
      ],
      [
        0,
        18
      ],
      [
        34,
        -4
      ]
    ],
    [
      [
        26051,
        55931
      ],
      [
        -2,
        -199
      ],
      [
        2,
        -1
      ],
      [
        0,
        -21
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -233
      ]
    ],
    [
      [
        26048,
        55478
      ],
      [
        -28,
        -1
      ],
      [
        -13,
        -1
      ],
      [
        -49,
        1
      ],
      [
        1,
        -17
      ],
      [
        -10,
        -1
      ]
    ],
    [
      [
        25949,
        55459
      ],
      [
        0,
        17
      ],
      [
        -46,
        0
      ]
    ],
    [
      [
        25903,
        55476
      ],
      [
        0,
        106
      ],
      [
        15,
        -1
      ],
      [
        1,
        118
      ],
      [
        4,
        0
      ],
      [
        25,
        -2
      ],
      [
        9,
        0
      ],
      [
        0,
        30
      ],
      [
        1,
        72
      ],
      [
        7,
        -1
      ],
      [
        3,
        17
      ],
      [
        5,
        0
      ],
      [
        0,
        68
      ],
      [
        5,
        0
      ],
      [
        0,
        52
      ],
      [
        15,
        0
      ]
    ],
    [
      [
        23026,
        66484
      ],
      [
        28,
        1
      ],
      [
        46,
        -1
      ],
      [
        6,
        1
      ],
      [
        65,
        -1
      ],
      [
        33,
        -1
      ]
    ],
    [
      [
        23204,
        66483
      ],
      [
        33,
        1
      ]
    ],
    [
      [
        23257,
        66077
      ],
      [
        -162,
        4
      ],
      [
        -29,
        0
      ]
    ],
    [
      [
        23066,
        66081
      ],
      [
        3,
        3
      ],
      [
        2,
        1
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        2,
        9
      ],
      [
        0,
        5
      ],
      [
        -2,
        7
      ],
      [
        1,
        2
      ],
      [
        0,
        15
      ],
      [
        -1,
        6
      ],
      [
        -1,
        6
      ],
      [
        -2,
        5
      ],
      [
        -4,
        9
      ]
    ],
    [
      [
        23066,
        66153
      ],
      [
        -1,
        4
      ],
      [
        -2,
        7
      ],
      [
        0,
        26
      ],
      [
        -1,
        3
      ],
      [
        0,
        3
      ],
      [
        -1,
        5
      ],
      [
        -3,
        9
      ],
      [
        -3,
        6
      ],
      [
        -2,
        4
      ],
      [
        -1,
        4
      ],
      [
        -2,
        6
      ],
      [
        -1,
        10
      ],
      [
        0,
        11
      ],
      [
        1,
        6
      ],
      [
        2,
        12
      ],
      [
        -1,
        6
      ],
      [
        -1,
        14
      ],
      [
        0,
        17
      ],
      [
        1,
        3
      ],
      [
        6,
        25
      ],
      [
        1,
        6
      ],
      [
        1,
        10
      ],
      [
        0,
        18
      ],
      [
        -1,
        13
      ],
      [
        0,
        2
      ],
      [
        -3,
        11
      ],
      [
        -4,
        4
      ],
      [
        -1,
        1
      ],
      [
        -3,
        1
      ],
      [
        -6,
        2
      ]
    ],
    [
      [
        23041,
        66402
      ],
      [
        -3,
        2
      ],
      [
        -5,
        13
      ],
      [
        -1,
        7
      ],
      [
        0,
        2
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        2
      ],
      [
        -1,
        6
      ],
      [
        1,
        3
      ],
      [
        3,
        5
      ],
      [
        0,
        37
      ],
      [
        -4,
        1
      ],
      [
        -2,
        5
      ]
    ],
    [
      [
        23166,
        65257
      ],
      [
        49,
        -1
      ],
      [
        90,
        0
      ]
    ],
    [
      [
        23401,
        65255
      ],
      [
        0,
        -403
      ]
    ],
    [
      [
        23337,
        64853
      ],
      [
        -138,
        0
      ]
    ],
    [
      [
        23199,
        64853
      ],
      [
        1,
        6
      ],
      [
        1,
        3
      ],
      [
        1,
        1
      ],
      [
        1,
        -1
      ],
      [
        3,
        -3
      ],
      [
        2,
        2
      ],
      [
        1,
        5
      ],
      [
        1,
        4
      ],
      [
        -1,
        7
      ],
      [
        -2,
        5
      ],
      [
        -4,
        4
      ],
      [
        -12,
        -5
      ],
      [
        -2,
        1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        5
      ]
    ],
    [
      [
        23187,
        64889
      ],
      [
        -1,
        5
      ],
      [
        0,
        19
      ],
      [
        3,
        13
      ],
      [
        1,
        5
      ],
      [
        0,
        13
      ],
      [
        -2,
        13
      ],
      [
        -1,
        11
      ],
      [
        0,
        7
      ],
      [
        -1,
        9
      ],
      [
        0,
        2
      ],
      [
        -1,
        8
      ],
      [
        0,
        13
      ],
      [
        1,
        7
      ],
      [
        2,
        3
      ],
      [
        4,
        0
      ],
      [
        0,
        -9
      ],
      [
        1,
        -11
      ],
      [
        3,
        -6
      ],
      [
        2,
        3
      ],
      [
        2,
        5
      ],
      [
        1,
        5
      ],
      [
        0,
        7
      ],
      [
        -1,
        13
      ],
      [
        -1,
        6
      ],
      [
        -1,
        5
      ],
      [
        -2,
        3
      ],
      [
        -3,
        3
      ],
      [
        -4,
        -2
      ],
      [
        -2,
        1
      ],
      [
        -1,
        2
      ],
      [
        -4,
        8
      ],
      [
        -2,
        6
      ],
      [
        -2,
        6
      ],
      [
        -1,
        7
      ],
      [
        0,
        4
      ],
      [
        1,
        3
      ],
      [
        1,
        2
      ],
      [
        3,
        5
      ],
      [
        1,
        3
      ],
      [
        2,
        5
      ],
      [
        0,
        12
      ],
      [
        -2,
        11
      ],
      [
        0,
        8
      ]
    ],
    [
      [
        23183,
        65122
      ],
      [
        0,
        6
      ],
      [
        2,
        12
      ],
      [
        0,
        10
      ],
      [
        -1,
        8
      ],
      [
        0,
        11
      ],
      [
        1,
        3
      ],
      [
        2,
        7
      ],
      [
        0,
        2
      ],
      [
        1,
        3
      ],
      [
        0,
        8
      ],
      [
        -1,
        5
      ],
      [
        -1,
        4
      ],
      [
        -2,
        6
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        -2,
        0
      ],
      [
        -3,
        -4
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        -2,
        5
      ],
      [
        -3,
        3
      ],
      [
        -2,
        0
      ],
      [
        -4,
        3
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        -1,
        6
      ],
      [
        -1,
        6
      ],
      [
        0,
        3
      ],
      [
        1,
        4
      ],
      [
        2,
        6
      ],
      [
        3,
        8
      ],
      [
        0,
        3
      ]
    ],
    [
      [
        18207,
        67657
      ],
      [
        6,
        -2
      ],
      [
        6,
        9
      ],
      [
        2,
        14
      ],
      [
        5,
        4
      ],
      [
        8,
        -7
      ],
      [
        4,
        -36
      ],
      [
        0,
        -26
      ],
      [
        6,
        -22
      ],
      [
        -2,
        -14
      ],
      [
        5,
        -7
      ],
      [
        5,
        4
      ],
      [
        0,
        -151
      ],
      [
        76,
        -1
      ],
      [
        0,
        -96
      ],
      [
        99,
        0
      ]
    ],
    [
      [
        18427,
        67326
      ],
      [
        0,
        -202
      ]
    ],
    [
      [
        18427,
        67124
      ],
      [
        -66,
        0
      ],
      [
        0,
        -306
      ],
      [
        2,
        -100
      ],
      [
        16,
        0
      ],
      [
        0,
        -101
      ],
      [
        -16,
        0
      ],
      [
        0,
        -58
      ]
    ],
    [
      [
        18298,
        66610
      ],
      [
        0,
        209
      ],
      [
        16,
        0
      ],
      [
        0,
        408
      ],
      [
        -84,
        0
      ]
    ],
    [
      [
        18046,
        67227
      ],
      [
        0,
        68
      ],
      [
        -6,
        0
      ],
      [
        1,
        80
      ],
      [
        -11,
        9
      ],
      [
        -9,
        -11
      ],
      [
        -4,
        9
      ],
      [
        -7,
        -4
      ],
      [
        -8,
        5
      ],
      [
        2,
        41
      ],
      [
        0,
        35
      ],
      [
        -6,
        0
      ],
      [
        0,
        43
      ],
      [
        9,
        25
      ],
      [
        2,
        24
      ],
      [
        -6,
        15
      ],
      [
        -9,
        10
      ],
      [
        -10,
        37
      ],
      [
        3,
        32
      ],
      [
        -14,
        18
      ],
      [
        -4,
        22
      ],
      [
        -9,
        -3
      ],
      [
        1,
        30
      ],
      [
        3,
        16
      ],
      [
        2,
        36
      ],
      [
        -5,
        11
      ],
      [
        -2,
        18
      ],
      [
        3,
        14
      ],
      [
        -1,
        31
      ],
      [
        4,
        16
      ],
      [
        -7,
        14
      ],
      [
        -1,
        40
      ],
      [
        -2,
        24
      ],
      [
        -4,
        11
      ],
      [
        -7,
        -9
      ],
      [
        -5,
        -18
      ],
      [
        -12,
        13
      ],
      [
        -7,
        -17
      ],
      [
        -8,
        4
      ],
      [
        2,
        29
      ],
      [
        -10,
        9
      ],
      [
        -13,
        19
      ],
      [
        -6,
        16
      ],
      [
        -5,
        -6
      ],
      [
        -5,
        11
      ]
    ],
    [
      [
        17875,
        67994
      ],
      [
        4,
        10
      ],
      [
        -6,
        55
      ],
      [
        7,
        28
      ]
    ],
    [
      [
        30697,
        68452
      ],
      [
        0,
        9
      ],
      [
        4,
        15
      ],
      [
        3,
        10
      ],
      [
        6,
        34
      ],
      [
        0,
        29
      ],
      [
        2,
        35
      ],
      [
        3,
        16
      ],
      [
        6,
        9
      ],
      [
        3,
        -6
      ],
      [
        3,
        -20
      ],
      [
        -1,
        -11
      ],
      [
        -3,
        -12
      ],
      [
        -3,
        -7
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -14
      ],
      [
        2,
        -22
      ],
      [
        -3,
        -23
      ],
      [
        -2,
        -4
      ],
      [
        -3,
        -43
      ],
      [
        -3,
        -12
      ],
      [
        -5,
        -14
      ],
      [
        -2,
        -3
      ],
      [
        1,
        10
      ],
      [
        -2,
        20
      ],
      [
        -1,
        4
      ],
      [
        -2,
        3
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        30556,
        68965
      ],
      [
        16,
        10
      ],
      [
        0,
        20
      ],
      [
        6,
        17
      ],
      [
        2,
        24
      ],
      [
        12,
        -4
      ],
      [
        5,
        -41
      ],
      [
        16,
        8
      ]
    ],
    [
      [
        30613,
        68999
      ],
      [
        18,
        9
      ],
      [
        6,
        -99
      ],
      [
        34,
        23
      ],
      [
        13,
        9
      ],
      [
        33,
        23
      ],
      [
        8,
        3
      ],
      [
        8,
        9
      ],
      [
        0,
        -11
      ],
      [
        6,
        -10
      ]
    ],
    [
      [
        30743,
        68770
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -18
      ],
      [
        1,
        -8
      ],
      [
        -3,
        -6
      ],
      [
        -5,
        -14
      ],
      [
        2,
        -15
      ],
      [
        -1,
        -11
      ],
      [
        -8,
        -20
      ],
      [
        -2,
        -5
      ],
      [
        -4,
        -15
      ],
      [
        -2,
        3
      ],
      [
        -1,
        9
      ],
      [
        0,
        8
      ],
      [
        -2,
        6
      ],
      [
        -1,
        2
      ],
      [
        -5,
        5
      ],
      [
        -2,
        -10
      ],
      [
        -1,
        -10
      ],
      [
        -4,
        -12
      ],
      [
        -3,
        -1
      ],
      [
        -7,
        -2
      ],
      [
        -5,
        -1
      ],
      [
        2,
        -12
      ],
      [
        2,
        -21
      ],
      [
        2,
        -12
      ],
      [
        3,
        -6
      ],
      [
        2,
        -8
      ],
      [
        3,
        -22
      ],
      [
        -2,
        -37
      ],
      [
        -1,
        -11
      ],
      [
        -5,
        -21
      ],
      [
        -5,
        -1
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -24
      ],
      [
        -3,
        -20
      ],
      [
        -3,
        -9
      ]
    ],
    [
      [
        30680,
        68449
      ],
      [
        -4,
        12
      ],
      [
        -22,
        -5
      ],
      [
        -41,
        127
      ],
      [
        -22,
        -65
      ],
      [
        -15,
        40
      ],
      [
        -2,
        -17
      ]
    ],
    [
      [
        30574,
        68541
      ],
      [
        -27,
        17
      ]
    ],
    [
      [
        30547,
        68558
      ],
      [
        17,
        141
      ],
      [
        13,
        -8
      ],
      [
        7,
        102
      ],
      [
        -12,
        7
      ],
      [
        6,
        104
      ],
      [
        -19,
        8
      ],
      [
        5,
        30
      ],
      [
        -9,
        5
      ],
      [
        1,
        18
      ]
    ],
    [
      [
        30077,
        66160
      ],
      [
        4,
        14
      ],
      [
        4,
        10
      ]
    ],
    [
      [
        30085,
        66184
      ],
      [
        3,
        -10
      ],
      [
        3,
        8
      ],
      [
        4,
        20
      ],
      [
        2,
        4
      ],
      [
        2,
        7
      ],
      [
        1,
        8
      ],
      [
        0,
        6
      ],
      [
        1,
        10
      ],
      [
        -2,
        2
      ],
      [
        -2,
        1
      ],
      [
        -2,
        -2
      ],
      [
        -5,
        -13
      ],
      [
        -3,
        -10
      ]
    ],
    [
      [
        30087,
        66215
      ],
      [
        -3,
        4
      ],
      [
        -1,
        12
      ],
      [
        -1,
        8
      ],
      [
        2,
        11
      ],
      [
        5,
        2
      ],
      [
        2,
        4
      ],
      [
        3,
        10
      ],
      [
        4,
        -6
      ],
      [
        0,
        -9
      ],
      [
        4,
        -10
      ],
      [
        2,
        1
      ],
      [
        5,
        6
      ],
      [
        0,
        4
      ],
      [
        2,
        7
      ],
      [
        2,
        1
      ],
      [
        -3,
        5
      ],
      [
        -2,
        11
      ],
      [
        2,
        11
      ],
      [
        5,
        -6
      ],
      [
        4,
        17
      ],
      [
        2,
        15
      ],
      [
        2,
        12
      ],
      [
        2,
        16
      ],
      [
        -2,
        7
      ]
    ],
    [
      [
        30123,
        66348
      ],
      [
        5,
        -4
      ],
      [
        0,
        -7
      ],
      [
        7,
        -4
      ],
      [
        4,
        15
      ],
      [
        2,
        -1
      ]
    ],
    [
      [
        30141,
        66347
      ],
      [
        0,
        -3
      ],
      [
        -6,
        -20
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -11
      ],
      [
        1,
        -6
      ],
      [
        1,
        0
      ],
      [
        0,
        -7
      ],
      [
        1,
        -5
      ],
      [
        2,
        -2
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -11
      ],
      [
        6,
        -32
      ],
      [
        0,
        -7
      ],
      [
        -3,
        4
      ],
      [
        -3,
        10
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -4,
        -4
      ],
      [
        -2,
        -6
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -17
      ],
      [
        0,
        -3
      ],
      [
        1,
        -8
      ],
      [
        4,
        3
      ],
      [
        2,
        -10
      ]
    ],
    [
      [
        30133,
        66195
      ],
      [
        -5,
        -9
      ],
      [
        -5,
        4
      ],
      [
        -3,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -22
      ],
      [
        -1,
        -9
      ],
      [
        -3,
        1
      ],
      [
        -2,
        -12
      ],
      [
        -4,
        3
      ],
      [
        -4,
        0
      ],
      [
        -2,
        -3
      ],
      [
        -4,
        -7
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -13
      ],
      [
        -6,
        -23
      ],
      [
        -5,
        34
      ],
      [
        -2,
        -1
      ],
      [
        -5,
        23
      ],
      [
        -4,
        5
      ],
      [
        -1,
        3
      ]
    ],
    [
      [
        29567,
        66693
      ],
      [
        26,
        -2
      ]
    ],
    [
      [
        29593,
        66691
      ],
      [
        13,
        -1
      ],
      [
        21,
        -2
      ],
      [
        5,
        0
      ],
      [
        29,
        -4
      ],
      [
        47,
        -5
      ],
      [
        16,
        -2
      ]
    ],
    [
      [
        29724,
        66677
      ],
      [
        2,
        0
      ],
      [
        11,
        -2
      ],
      [
        24,
        -3
      ],
      [
        11,
        -1
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        29773,
        66671
      ],
      [
        3,
        -55
      ],
      [
        12,
        -14
      ],
      [
        1,
        -27
      ],
      [
        -1,
        -27
      ],
      [
        -7,
        -5
      ],
      [
        -3,
        -13
      ],
      [
        1,
        -29
      ],
      [
        -4,
        2
      ],
      [
        2,
        -51
      ],
      [
        7,
        -24
      ],
      [
        -13,
        -39
      ],
      [
        2,
        -45
      ],
      [
        -6,
        -24
      ],
      [
        -3,
        -30
      ],
      [
        1,
        -8
      ],
      [
        -1,
        -51
      ]
    ],
    [
      [
        29764,
        66231
      ],
      [
        -3,
        -28
      ],
      [
        -7,
        -18
      ],
      [
        -1,
        -1
      ],
      [
        1,
        36
      ],
      [
        -1,
        7
      ],
      [
        0,
        30
      ],
      [
        -3,
        14
      ],
      [
        -3,
        50
      ],
      [
        -30,
        -16
      ],
      [
        -2,
        31
      ],
      [
        -15,
        -8
      ],
      [
        -10,
        -5
      ],
      [
        -2,
        -1
      ],
      [
        -22,
        -14
      ],
      [
        -10,
        -5
      ],
      [
        1,
        55
      ],
      [
        -16,
        -8
      ],
      [
        -5,
        24
      ],
      [
        -27,
        20
      ],
      [
        -1,
        67
      ],
      [
        -28,
        17
      ]
    ],
    [
      [
        29580,
        66478
      ],
      [
        7,
        99
      ],
      [
        -1,
        28
      ],
      [
        -6,
        -5
      ],
      [
        -5,
        15
      ],
      [
        5,
        17
      ],
      [
        6,
        2
      ],
      [
        2,
        17
      ],
      [
        -21,
        -2
      ],
      [
        0,
        44
      ]
    ],
    [
      [
        26534,
        68055
      ],
      [
        0,
        -20
      ],
      [
        -2,
        -43
      ],
      [
        -3,
        -81
      ],
      [
        -1,
        -12
      ],
      [
        -4,
        -20
      ],
      [
        -3,
        2
      ],
      [
        0,
        -12
      ],
      [
        2,
        -14
      ],
      [
        3,
        -27
      ],
      [
        8,
        -50
      ],
      [
        3,
        -10
      ],
      [
        13,
        -22
      ],
      [
        6,
        31
      ],
      [
        3,
        2
      ],
      [
        5,
        -38
      ],
      [
        13,
        -11
      ],
      [
        7,
        -10
      ],
      [
        8,
        -25
      ]
    ],
    [
      [
        26592,
        67695
      ],
      [
        0,
        -42
      ],
      [
        1,
        -101
      ]
    ],
    [
      [
        23039,
        68388
      ],
      [
        0,
        404
      ]
    ],
    [
      [
        23039,
        68792
      ],
      [
        1,
        101
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        23040,
        68894
      ],
      [
        99,
        -1
      ]
    ],
    [
      [
        24494,
        56008
      ],
      [
        1,
        3
      ],
      [
        1,
        4
      ],
      [
        1,
        1
      ],
      [
        5,
        3
      ],
      [
        1,
        1
      ],
      [
        3,
        5
      ],
      [
        2,
        6
      ],
      [
        1,
        1
      ],
      [
        0,
        1
      ],
      [
        5,
        -2
      ],
      [
        1,
        0
      ],
      [
        1,
        2
      ],
      [
        4,
        9
      ],
      [
        1,
        4
      ],
      [
        1,
        3
      ],
      [
        0,
        16
      ],
      [
        -1,
        6
      ],
      [
        0,
        4
      ],
      [
        -1,
        7
      ],
      [
        -4,
        9
      ],
      [
        -3,
        12
      ],
      [
        -2,
        5
      ],
      [
        -2,
        4
      ],
      [
        -2,
        3
      ],
      [
        -7,
        6
      ],
      [
        -3,
        3
      ],
      [
        -1,
        4
      ],
      [
        -1,
        5
      ],
      [
        0,
        16
      ],
      [
        1,
        6
      ],
      [
        1,
        6
      ],
      [
        2,
        6
      ],
      [
        2,
        3
      ],
      [
        1,
        1
      ],
      [
        3,
        0
      ],
      [
        4,
        2
      ],
      [
        3,
        2
      ],
      [
        1,
        2
      ],
      [
        1,
        0
      ],
      [
        4,
        -20
      ],
      [
        3,
        -15
      ],
      [
        1,
        -3
      ],
      [
        8,
        -16
      ],
      [
        2,
        -2
      ],
      [
        2,
        -2
      ],
      [
        1,
        0
      ],
      [
        2,
        1
      ],
      [
        3,
        6
      ],
      [
        2,
        4
      ],
      [
        2,
        2
      ],
      [
        1,
        0
      ],
      [
        3,
        4
      ],
      [
        1,
        2
      ],
      [
        1,
        6
      ],
      [
        0,
        11
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        9
      ],
      [
        -1,
        4
      ],
      [
        -2,
        7
      ],
      [
        -2,
        8
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        -2,
        0
      ],
      [
        -2,
        -2
      ],
      [
        -4,
        -8
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        1
      ],
      [
        -3,
        4
      ],
      [
        -1,
        7
      ],
      [
        -4,
        14
      ],
      [
        0,
        29
      ],
      [
        1,
        5
      ],
      [
        0,
        6
      ],
      [
        -1,
        1
      ],
      [
        0,
        6
      ],
      [
        1,
        8
      ],
      [
        0,
        4
      ],
      [
        1,
        3
      ],
      [
        1,
        3
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        2,
        -4
      ],
      [
        1,
        -5
      ],
      [
        2,
        -5
      ],
      [
        5,
        6
      ],
      [
        1,
        1
      ],
      [
        7,
        1
      ],
      [
        1,
        2
      ],
      [
        8,
        -18
      ],
      [
        1,
        -1
      ],
      [
        3,
        2
      ],
      [
        3,
        6
      ],
      [
        2,
        5
      ],
      [
        1,
        3
      ],
      [
        0,
        5
      ],
      [
        1,
        4
      ],
      [
        -1,
        4
      ],
      [
        0,
        6
      ],
      [
        -3,
        8
      ],
      [
        -2,
        3
      ],
      [
        -3,
        3
      ],
      [
        -2,
        1
      ],
      [
        -4,
        8
      ],
      [
        -2,
        3
      ],
      [
        0,
        4
      ],
      [
        -1,
        7
      ],
      [
        -1,
        5
      ],
      [
        -3,
        10
      ],
      [
        0,
        4
      ],
      [
        -1,
        10
      ],
      [
        -1,
        9
      ],
      [
        0,
        6
      ],
      [
        1,
        5
      ],
      [
        2,
        13
      ],
      [
        2,
        6
      ],
      [
        5,
        18
      ],
      [
        3,
        11
      ],
      [
        3,
        13
      ],
      [
        1,
        8
      ],
      [
        1,
        1
      ],
      [
        0,
        3
      ],
      [
        -1,
        3
      ],
      [
        -2,
        6
      ],
      [
        -5,
        8
      ],
      [
        -3,
        4
      ],
      [
        -8,
        8
      ],
      [
        -1,
        0
      ],
      [
        -1,
        2
      ],
      [
        -1,
        3
      ],
      [
        0,
        3
      ],
      [
        -1,
        6
      ],
      [
        0,
        4
      ],
      [
        1,
        3
      ],
      [
        0,
        4
      ],
      [
        1,
        5
      ],
      [
        2,
        4
      ],
      [
        4,
        2
      ],
      [
        4,
        0
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        2,
        7
      ],
      [
        4,
        9
      ],
      [
        2,
        -10
      ],
      [
        2,
        -21
      ],
      [
        1,
        -7
      ],
      [
        0,
        -5
      ],
      [
        2,
        -4
      ],
      [
        2,
        -2
      ],
      [
        1,
        -1
      ],
      [
        2,
        0
      ],
      [
        2,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        0,
        14
      ],
      [
        -2,
        14
      ],
      [
        -2,
        5
      ],
      [
        -1,
        4
      ],
      [
        -2,
        22
      ],
      [
        1,
        2
      ],
      [
        2,
        1
      ],
      [
        2,
        0
      ],
      [
        3,
        -1
      ],
      [
        2,
        -3
      ],
      [
        2,
        0
      ],
      [
        3,
        2
      ],
      [
        3,
        4
      ],
      [
        2,
        -1
      ],
      [
        4,
        2
      ],
      [
        2,
        4
      ],
      [
        1,
        3
      ],
      [
        1,
        3
      ],
      [
        0,
        9
      ],
      [
        -1,
        7
      ],
      [
        0,
        7
      ],
      [
        1,
        4
      ],
      [
        0,
        3
      ],
      [
        1,
        7
      ],
      [
        2,
        9
      ],
      [
        1,
        5
      ],
      [
        0,
        12
      ],
      [
        -1,
        7
      ],
      [
        -1,
        2
      ],
      [
        -1,
        3
      ],
      [
        -1,
        1
      ],
      [
        -2,
        0
      ],
      [
        -2,
        -4
      ],
      [
        -4,
        -2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        -7,
        18
      ],
      [
        0,
        2
      ],
      [
        -2,
        9
      ]
    ],
    [
      [
        24571,
        56657
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        24571,
        56658
      ],
      [
        43,
        1
      ],
      [
        39,
        -2
      ],
      [
        0,
        -153
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        24654,
        56504
      ],
      [
        0,
        -237
      ],
      [
        -1,
        -93
      ],
      [
        1,
        -18
      ],
      [
        -1,
        -84
      ],
      [
        -29,
        -1
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        24624,
        55970
      ],
      [
        -16,
        1
      ],
      [
        -12,
        -1
      ],
      [
        -30,
        1
      ],
      [
        -68,
        -1
      ]
    ],
    [
      [
        24498,
        55970
      ],
      [
        -1,
        4
      ],
      [
        -2,
        10
      ],
      [
        -1,
        7
      ],
      [
        0,
        17
      ]
    ],
    [
      [
        26542,
        69558
      ],
      [
        102,
        6
      ],
      [
        35,
        0
      ]
    ],
    [
      [
        26679,
        69564
      ],
      [
        1,
        -4
      ],
      [
        1,
        0
      ],
      [
        3,
        -25
      ],
      [
        1,
        -11
      ],
      [
        1,
        -7
      ],
      [
        1,
        -4
      ],
      [
        3,
        -2
      ],
      [
        3,
        -17
      ],
      [
        6,
        -6
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -10
      ],
      [
        2,
        -35
      ],
      [
        3,
        -10
      ],
      [
        2,
        -25
      ],
      [
        0,
        -7
      ],
      [
        3,
        -20
      ],
      [
        1,
        -1
      ],
      [
        2,
        -8
      ],
      [
        1,
        -13
      ],
      [
        -1,
        -4
      ],
      [
        -5,
        4
      ],
      [
        -4,
        7
      ],
      [
        -11,
        10
      ],
      [
        -4,
        11
      ],
      [
        -3,
        13
      ],
      [
        -9,
        10
      ],
      [
        -10,
        -15
      ],
      [
        -2,
        -8
      ],
      [
        -3,
        -18
      ],
      [
        0,
        -4
      ],
      [
        2,
        -18
      ],
      [
        3,
        -5
      ],
      [
        1,
        -5
      ],
      [
        -1,
        -9
      ],
      [
        -1,
        0
      ],
      [
        -3,
        -11
      ],
      [
        2,
        -45
      ],
      [
        1,
        -13
      ],
      [
        2,
        -9
      ],
      [
        2,
        -7
      ],
      [
        6,
        -10
      ],
      [
        1,
        -14
      ],
      [
        1,
        -4
      ],
      [
        12,
        -20
      ],
      [
        9,
        -6
      ],
      [
        0,
        -26
      ]
    ],
    [
      [
        26698,
        69158
      ],
      [
        -158,
        -2
      ]
    ],
    [
      [
        24721,
        71146
      ],
      [
        19,
        40
      ],
      [
        6,
        8
      ],
      [
        6,
        -5
      ],
      [
        11,
        18
      ],
      [
        8,
        7
      ],
      [
        20,
        24
      ],
      [
        18,
        12
      ],
      [
        15,
        15
      ],
      [
        5,
        7
      ],
      [
        9,
        22
      ],
      [
        3,
        12
      ],
      [
        3,
        8
      ],
      [
        5,
        8
      ],
      [
        11,
        27
      ],
      [
        7,
        26
      ],
      [
        1,
        3
      ]
    ],
    [
      [
        24868,
        71378
      ],
      [
        7,
        0
      ],
      [
        0,
        -201
      ],
      [
        34,
        0
      ],
      [
        0,
        -101
      ],
      [
        105,
        0
      ],
      [
        0,
        -201
      ],
      [
        104,
        -1
      ]
    ],
    [
      [
        25118,
        70874
      ],
      [
        0,
        -274
      ]
    ],
    [
      [
        25118,
        70600
      ],
      [
        -28,
        48
      ],
      [
        -9,
        7
      ],
      [
        -10,
        9
      ],
      [
        -2,
        1
      ],
      [
        -8,
        6
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        -3,
        3
      ],
      [
        -1,
        0
      ],
      [
        -15,
        13
      ],
      [
        -1,
        0
      ],
      [
        -60,
        49
      ],
      [
        -11,
        9
      ],
      [
        -29,
        23
      ],
      [
        -8,
        7
      ],
      [
        -27,
        21
      ],
      [
        -40,
        33
      ],
      [
        -1,
        0
      ],
      [
        -2,
        2
      ],
      [
        -3,
        2
      ]
    ],
    [
      [
        24857,
        70836
      ],
      [
        -54,
        43
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        0,
        7
      ],
      [
        -1,
        1
      ],
      [
        1,
        3
      ],
      [
        0,
        13
      ],
      [
        -1,
        0
      ],
      [
        0,
        4
      ],
      [
        -1,
        4
      ],
      [
        -1,
        3
      ],
      [
        -1,
        3
      ],
      [
        -1,
        3
      ],
      [
        0,
        1
      ],
      [
        1,
        7
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        3
      ],
      [
        -1,
        6
      ],
      [
        -1,
        8
      ],
      [
        0,
        3
      ],
      [
        -2,
        2
      ],
      [
        -1,
        9
      ],
      [
        0,
        16
      ],
      [
        -2,
        14
      ],
      [
        0,
        6
      ],
      [
        -3,
        0
      ],
      [
        -1,
        1
      ],
      [
        0,
        19
      ],
      [
        -3,
        2
      ],
      [
        0,
        2
      ],
      [
        -1,
        3
      ],
      [
        1,
        3
      ],
      [
        0,
        4
      ],
      [
        -1,
        4
      ],
      [
        -2,
        4
      ],
      [
        -1,
        3
      ],
      [
        -2,
        14
      ],
      [
        -1,
        9
      ],
      [
        0,
        4
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -2
      ],
      [
        0,
        9
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -2
      ],
      [
        -4,
        0
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        0,
        5
      ],
      [
        -1,
        -1
      ],
      [
        0,
        6
      ],
      [
        -2,
        4
      ],
      [
        1,
        5
      ],
      [
        0,
        2
      ],
      [
        -1,
        4
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        0
      ],
      [
        -2,
        2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -1
      ],
      [
        0,
        2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        5
      ],
      [
        1,
        3
      ],
      [
        1,
        5
      ],
      [
        1,
        10
      ],
      [
        -1,
        3
      ],
      [
        -2,
        8
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        0,
        5
      ],
      [
        -1,
        3
      ],
      [
        -2,
        1
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -11
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        24739,
        71113
      ],
      [
        0,
        0
      ]
    ],
    [
      [
        24739,
        71113
      ],
      [
        -1,
        3
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -4,
        -7
      ],
      [
        -2,
        -1
      ],
      [
        0,
        4
      ],
      [
        -1,
        8
      ],
      [
        0,
        2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        3
      ],
      [
        -1,
        6
      ],
      [
        -1,
        6
      ],
      [
        -1,
        7
      ],
      [
        0,
        3
      ]
    ],
    [
      [
        30255,
        70100
      ],
      [
        3,
        -1
      ],
      [
        5,
        0
      ],
      [
        1,
        4
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        2,
        8
      ],
      [
        4,
        9
      ],
      [
        7,
        17
      ],
      [
        5,
        3
      ],
      [
        2,
        -1
      ],
      [
        2,
        1
      ],
      [
        2,
        3
      ],
      [
        9,
        15
      ],
      [
        2,
        10
      ],
      [
        2,
        7
      ],
      [
        -1,
        18
      ],
      [
        -2,
        7
      ],
      [
        -2,
        2
      ],
      [
        -1,
        5
      ],
      [
        -3,
        28
      ],
      [
        0,
        11
      ],
      [
        2,
        2
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        0,
        4
      ],
      [
        -1,
        2
      ],
      [
        1,
        5
      ],
      [
        2,
        12
      ],
      [
        2,
        7
      ],
      [
        4,
        12
      ],
      [
        7,
        20
      ],
      [
        3,
        2
      ],
      [
        4,
        3
      ],
      [
        3,
        4
      ],
      [
        6,
        14
      ],
      [
        6,
        18
      ],
      [
        1,
        4
      ],
      [
        1,
        14
      ],
      [
        0,
        4
      ],
      [
        -1,
        14
      ],
      [
        -1,
        2
      ],
      [
        0,
        6
      ],
      [
        3,
        9
      ],
      [
        3,
        7
      ],
      [
        0,
        6
      ],
      [
        -3,
        13
      ],
      [
        -4,
        9
      ],
      [
        -2,
        1
      ],
      [
        -2,
        2
      ],
      [
        -3,
        -3
      ],
      [
        -6,
        -1
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        1,
        9
      ],
      [
        1,
        10
      ],
      [
        0,
        3
      ],
      [
        2,
        3
      ],
      [
        2,
        1
      ],
      [
        2,
        6
      ],
      [
        1,
        5
      ],
      [
        -2,
        2
      ],
      [
        -3,
        2
      ],
      [
        -4,
        23
      ],
      [
        0,
        1
      ],
      [
        6,
        26
      ],
      [
        4,
        12
      ],
      [
        1,
        5
      ],
      [
        0,
        3
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -4,
        0
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        5,
        35
      ],
      [
        2,
        5
      ],
      [
        3,
        4
      ],
      [
        2,
        -1
      ],
      [
        3,
        -2
      ],
      [
        1,
        1
      ],
      [
        0,
        7
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        9
      ],
      [
        2,
        13
      ],
      [
        1,
        16
      ],
      [
        1,
        6
      ],
      [
        -1,
        3
      ],
      [
        -7,
        22
      ],
      [
        -1,
        3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        3
      ],
      [
        -4,
        12
      ],
      [
        0,
        7
      ],
      [
        2,
        6
      ],
      [
        3,
        15
      ],
      [
        4,
        25
      ],
      [
        0,
        5
      ],
      [
        1,
        13
      ],
      [
        0,
        9
      ],
      [
        1,
        6
      ],
      [
        1,
        9
      ],
      [
        4,
        20
      ],
      [
        5,
        13
      ],
      [
        3,
        5
      ],
      [
        1,
        17
      ],
      [
        -1,
        2
      ],
      [
        -1,
        4
      ],
      [
        0,
        14
      ],
      [
        5,
        19
      ],
      [
        1,
        2
      ],
      [
        3,
        10
      ],
      [
        1,
        1
      ],
      [
        3,
        2
      ],
      [
        4,
        -2
      ],
      [
        2,
        4
      ],
      [
        2,
        7
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        0,
        11
      ],
      [
        2,
        3
      ],
      [
        2,
        2
      ],
      [
        3,
        15
      ],
      [
        0,
        7
      ],
      [
        1,
        6
      ],
      [
        2,
        1
      ],
      [
        3,
        0
      ],
      [
        1,
        -1
      ],
      [
        5,
        6
      ],
      [
        0,
        2
      ],
      [
        9,
        164
      ],
      [
        1,
        19
      ]
    ],
    [
      [
        30487,
        71155
      ],
      [
        0,
        -209
      ],
      [
        -3,
        0
      ],
      [
        1,
        -486
      ],
      [
        12,
        8
      ],
      [
        10,
        -140
      ],
      [
        -7,
        -1
      ],
      [
        -3,
        -13
      ],
      [
        -5,
        30
      ],
      [
        1,
        10
      ],
      [
        -11,
        -3
      ],
      [
        9,
        -34
      ],
      [
        -3,
        -28
      ],
      [
        2,
        -21
      ],
      [
        -4,
        -33
      ],
      [
        -4,
        -1
      ],
      [
        3,
        -24
      ],
      [
        -4,
        -8
      ],
      [
        -7,
        7
      ],
      [
        -5,
        28
      ],
      [
        -5,
        1
      ],
      [
        5,
        -3
      ],
      [
        1,
        -16
      ],
      [
        -3,
        -10
      ],
      [
        1,
        -17
      ],
      [
        -10,
        -5
      ],
      [
        9,
        -19
      ],
      [
        -3,
        -11
      ],
      [
        4,
        -7
      ],
      [
        1,
        -21
      ],
      [
        8,
        -15
      ],
      [
        5,
        -1
      ],
      [
        -1,
        -31
      ],
      [
        5,
        6
      ],
      [
        9,
        -14
      ],
      [
        -6,
        6
      ],
      [
        -1,
        -12
      ],
      [
        4,
        -14
      ],
      [
        -5,
        -30
      ],
      [
        2,
        -8
      ],
      [
        -5,
        -33
      ],
      [
        -14,
        -28
      ],
      [
        20,
        -293
      ],
      [
        7,
        -92
      ],
      [
        1,
        -20
      ],
      [
        7,
        -111
      ],
      [
        10,
        -103
      ],
      [
        29,
        16
      ],
      [
        6,
        14
      ],
      [
        -2,
        20
      ],
      [
        41,
        22
      ]
    ],
    [
      [
        30589,
        69408
      ],
      [
        7,
        -100
      ],
      [
        13,
        -207
      ],
      [
        -1,
        -2
      ],
      [
        5,
        -100
      ]
    ],
    [
      [
        30556,
        68965
      ],
      [
        1,
        30
      ],
      [
        -4,
        2
      ],
      [
        -33,
        -18
      ],
      [
        -7,
        -4
      ],
      [
        -2,
        -3
      ],
      [
        2,
        -31
      ],
      [
        11,
        -44
      ],
      [
        2,
        -15
      ],
      [
        -3,
        -23
      ],
      [
        0,
        -21
      ],
      [
        -4,
        -7
      ],
      [
        -17,
        10
      ],
      [
        -13,
        9
      ],
      [
        -8,
        5
      ],
      [
        -1,
        5
      ],
      [
        -9,
        7
      ],
      [
        -4,
        -36
      ],
      [
        -7,
        5
      ],
      [
        -1,
        30
      ],
      [
        -9,
        16
      ],
      [
        -21,
        -12
      ]
    ],
    [
      [
        30429,
        68870
      ],
      [
        -5,
        43
      ],
      [
        -6,
        16
      ],
      [
        2,
        23
      ],
      [
        -10,
        -4
      ],
      [
        -2,
        36
      ],
      [
        -3,
        57
      ],
      [
        4,
        1
      ],
      [
        0,
        18
      ],
      [
        -1,
        17
      ],
      [
        -3,
        -2
      ],
      [
        -5,
        90
      ],
      [
        -27,
        -16
      ],
      [
        -6,
        106
      ],
      [
        11,
        7
      ],
      [
        -3,
        61
      ],
      [
        -10,
        149
      ],
      [
        -38,
        -21
      ],
      [
        -5,
        64
      ],
      [
        -29,
        -24
      ],
      [
        -28,
        428
      ],
      [
        3,
        2
      ],
      [
        -13,
        179
      ]
    ],
    [
      [
        24524,
        54436
      ],
      [
        2,
        -5
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        2,
        12
      ],
      [
        3,
        7
      ],
      [
        2,
        3
      ],
      [
        2,
        0
      ],
      [
        2,
        -1
      ],
      [
        2,
        -8
      ],
      [
        2,
        7
      ],
      [
        1,
        3
      ],
      [
        0,
        12
      ],
      [
        1,
        4
      ],
      [
        3,
        1
      ],
      [
        1,
        -1
      ],
      [
        2,
        -3
      ],
      [
        1,
        -3
      ],
      [
        4,
        -12
      ],
      [
        1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        1,
        -6
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        0,
        3
      ],
      [
        1,
        4
      ],
      [
        0,
        11
      ],
      [
        1,
        15
      ],
      [
        1,
        5
      ],
      [
        2,
        4
      ],
      [
        0,
        1
      ],
      [
        -1,
        6
      ],
      [
        -2,
        9
      ],
      [
        0,
        2
      ],
      [
        -1,
        4
      ],
      [
        0,
        11
      ],
      [
        1,
        13
      ],
      [
        0,
        3
      ],
      [
        1,
        3
      ],
      [
        0,
        1
      ],
      [
        3,
        0
      ],
      [
        1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        2,
        -9
      ],
      [
        0,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        0
      ],
      [
        4,
        8
      ],
      [
        3,
        10
      ],
      [
        2,
        6
      ],
      [
        3,
        13
      ],
      [
        1,
        5
      ],
      [
        2,
        10
      ],
      [
        5,
        35
      ],
      [
        0,
        17
      ],
      [
        -1,
        2
      ],
      [
        -3,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -18
      ],
      [
        -3,
        -13
      ],
      [
        -1,
        -5
      ],
      [
        -3,
        3
      ],
      [
        -3,
        4
      ],
      [
        -3,
        1
      ],
      [
        -3,
        0
      ],
      [
        -9,
        7
      ],
      [
        -2,
        2
      ],
      [
        -2,
        5
      ],
      [
        -1,
        5
      ],
      [
        0,
        7
      ],
      [
        1,
        15
      ],
      [
        1,
        8
      ],
      [
        1,
        5
      ],
      [
        0,
        13
      ],
      [
        4,
        5
      ],
      [
        2,
        5
      ],
      [
        0,
        3
      ],
      [
        1,
        4
      ],
      [
        1,
        3
      ],
      [
        0,
        17
      ],
      [
        -1,
        3
      ],
      [
        0,
        2
      ],
      [
        -3,
        8
      ],
      [
        -1,
        3
      ],
      [
        -3,
        2
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -5
      ],
      [
        -3,
        -6
      ],
      [
        -3,
        -7
      ],
      [
        -1,
        -1
      ],
      [
        -6,
        5
      ],
      [
        -5,
        8
      ],
      [
        -3,
        6
      ],
      [
        -4,
        10
      ],
      [
        -4,
        16
      ],
      [
        -1,
        4
      ],
      [
        -1,
        9
      ],
      [
        0,
        19
      ],
      [
        3,
        18
      ],
      [
        1,
        12
      ],
      [
        5,
        1
      ],
      [
        7,
        -16
      ],
      [
        2,
        -15
      ],
      [
        2,
        -5
      ],
      [
        2,
        -6
      ],
      [
        1,
        -2
      ],
      [
        3,
        -4
      ],
      [
        2,
        -2
      ],
      [
        3,
        -2
      ],
      [
        2,
        1
      ],
      [
        0,
        1
      ],
      [
        2,
        5
      ],
      [
        1,
        4
      ],
      [
        0,
        6
      ],
      [
        -1,
        4
      ],
      [
        -1,
        8
      ],
      [
        -3,
        8
      ],
      [
        -2,
        3
      ],
      [
        -11,
        17
      ],
      [
        -3,
        7
      ],
      [
        -4,
        12
      ],
      [
        -1,
        11
      ],
      [
        3,
        7
      ]
    ],
    [
      [
        24539,
        54845
      ],
      [
        0,
        1
      ],
      [
        6,
        12
      ],
      [
        1,
        3
      ]
    ],
    [
      [
        24546,
        54861
      ],
      [
        22,
        -1
      ],
      [
        1,
        -191
      ],
      [
        3,
        38
      ],
      [
        7,
        8
      ],
      [
        3,
        -8
      ],
      [
        6,
        5
      ],
      [
        3,
        -9
      ],
      [
        4,
        12
      ],
      [
        2,
        -9
      ],
      [
        0,
        154
      ],
      [
        26,
        -1
      ],
      [
        8,
        -3
      ],
      [
        3,
        -7
      ],
      [
        -1,
        25
      ],
      [
        3,
        5
      ],
      [
        1,
        23
      ],
      [
        -1,
        9
      ]
    ],
    [
      [
        24636,
        54911
      ],
      [
        9,
        -1
      ],
      [
        0,
        -34
      ],
      [
        9,
        1
      ],
      [
        0,
        -12
      ],
      [
        1,
        -39
      ],
      [
        18,
        0
      ],
      [
        0,
        -17
      ],
      [
        10,
        0
      ],
      [
        0,
        -28
      ]
    ],
    [
      [
        24683,
        54781
      ],
      [
        -10,
        -13
      ],
      [
        -4,
        -20
      ],
      [
        1,
        -34
      ],
      [
        4,
        -5
      ],
      [
        -4,
        -12
      ],
      [
        0,
        -13
      ],
      [
        -4,
        -17
      ],
      [
        -1,
        -19
      ],
      [
        -5,
        -22
      ],
      [
        2,
        -41
      ],
      [
        -15,
        16
      ],
      [
        -3,
        0
      ],
      [
        -4,
        -15
      ],
      [
        2,
        -11
      ],
      [
        -2,
        -17
      ],
      [
        3,
        -12
      ],
      [
        -5,
        -35
      ],
      [
        0,
        -23
      ],
      [
        -3,
        -22
      ],
      [
        -1,
        -13
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        24634,
        54452
      ],
      [
        -3,
        -10
      ],
      [
        0,
        -13
      ],
      [
        -4,
        1
      ],
      [
        1,
        -11
      ],
      [
        -8,
        -4
      ],
      [
        -3,
        -21
      ],
      [
        3,
        -4
      ],
      [
        1,
        -21
      ],
      [
        -5,
        -2
      ],
      [
        0,
        -9
      ],
      [
        -3,
        10
      ],
      [
        -4,
        -18
      ],
      [
        -3,
        9
      ],
      [
        1,
        13
      ],
      [
        -5,
        3
      ],
      [
        -4,
        -18
      ],
      [
        4,
        -6
      ],
      [
        -1,
        -12
      ],
      [
        -7,
        -9
      ],
      [
        -1,
        9
      ],
      [
        -2,
        -16
      ],
      [
        -7,
        21
      ],
      [
        -4,
        -17
      ],
      [
        -1,
        -23
      ],
      [
        3,
        -2
      ],
      [
        -1,
        -18
      ],
      [
        -7,
        -3
      ],
      [
        -4,
        14
      ],
      [
        -1,
        18
      ],
      [
        -2,
        -13
      ],
      [
        -6,
        3
      ],
      [
        -11,
        20
      ]
    ],
    [
      [
        24550,
        54323
      ],
      [
        0,
        7
      ]
    ],
    [
      [
        24550,
        54330
      ],
      [
        1,
        1
      ],
      [
        2,
        3
      ],
      [
        1,
        2
      ],
      [
        1,
        7
      ],
      [
        2,
        10
      ],
      [
        0,
        20
      ],
      [
        -3,
        4
      ],
      [
        -3,
        2
      ],
      [
        -1,
        7
      ],
      [
        -3,
        7
      ],
      [
        -3,
        5
      ],
      [
        -2,
        -1
      ],
      [
        0,
        -8
      ],
      [
        1,
        -8
      ],
      [
        2,
        -8
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -24
      ]
    ],
    [
      [
        24544,
        54335
      ],
      [
        -3,
        3
      ],
      [
        -2,
        5
      ],
      [
        -2,
        3
      ],
      [
        -4,
        0
      ],
      [
        -3,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -3,
        -5
      ],
      [
        -5,
        1
      ],
      [
        -2,
        1
      ],
      [
        -2,
        4
      ],
      [
        -3,
        2
      ],
      [
        -2,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        12
      ],
      [
        -1,
        6
      ],
      [
        0,
        17
      ],
      [
        1,
        15
      ],
      [
        1,
        11
      ],
      [
        1,
        12
      ],
      [
        0,
        3
      ],
      [
        1,
        3
      ],
      [
        7,
        14
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ]
    ],
    [
      [
        28682,
        67787
      ],
      [
        49,
        -14
      ],
      [
        0,
        45
      ],
      [
        69,
        -21
      ]
    ],
    [
      [
        28800,
        67797
      ],
      [
        2,
        -75
      ],
      [
        3,
        -180
      ]
    ],
    [
      [
        28805,
        67542
      ],
      [
        -16,
        16
      ],
      [
        -20,
        -185
      ],
      [
        7,
        -7
      ],
      [
        -6,
        -190
      ]
    ],
    [
      [
        28770,
        67176
      ],
      [
        -12,
        7
      ],
      [
        -2,
        17
      ],
      [
        -16,
        10
      ],
      [
        -1,
        -2
      ]
    ],
    [
      [
        28739,
        67208
      ],
      [
        -3,
        -4
      ],
      [
        -11,
        26
      ],
      [
        -9,
        -3
      ],
      [
        -2,
        17
      ],
      [
        5,
        -2
      ],
      [
        -13,
        24
      ],
      [
        -12,
        12
      ],
      [
        -13,
        33
      ],
      [
        -2,
        -4
      ],
      [
        0,
        -28
      ],
      [
        4,
        -31
      ],
      [
        -8,
        -15
      ],
      [
        -6,
        12
      ],
      [
        -4,
        26
      ],
      [
        -4,
        2
      ],
      [
        3,
        -24
      ],
      [
        -5,
        -20
      ],
      [
        -7,
        34
      ],
      [
        -11,
        3
      ],
      [
        -37,
        -6
      ]
    ],
    [
      [
        28604,
        67260
      ],
      [
        -1,
        34
      ],
      [
        -33,
        -4
      ],
      [
        -1,
        5
      ],
      [
        -3,
        188
      ]
    ],
    [
      [
        28566,
        67483
      ],
      [
        2,
        5
      ],
      [
        13,
        29
      ],
      [
        7,
        11
      ],
      [
        1,
        3
      ],
      [
        3,
        9
      ],
      [
        2,
        3
      ],
      [
        2,
        -2
      ],
      [
        6,
        7
      ],
      [
        4,
        20
      ],
      [
        10,
        20
      ],
      [
        5,
        14
      ],
      [
        2,
        2
      ],
      [
        11,
        3
      ],
      [
        1,
        0
      ],
      [
        6,
        -15
      ],
      [
        4,
        -1
      ],
      [
        10,
        1
      ],
      [
        10,
        14
      ],
      [
        7,
        5
      ],
      [
        2,
        4
      ],
      [
        3,
        14
      ],
      [
        2,
        18
      ],
      [
        2,
        17
      ],
      [
        1,
        30
      ],
      [
        1,
        57
      ],
      [
        -1,
        36
      ]
    ],
    [
      [
        23278,
        68790
      ],
      [
        66,
        0
      ],
      [
        0,
        182
      ]
    ],
    [
      [
        23481,
        68739
      ],
      [
        0,
        -251
      ],
      [
        -67,
        -1
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        26541,
        65234
      ],
      [
        0,
        131
      ],
      [
        2,
        21
      ],
      [
        -1,
        119
      ]
    ],
    [
      [
        26542,
        65505
      ],
      [
        6,
        1
      ],
      [
        27,
        3
      ]
    ],
    [
      [
        26575,
        65509
      ],
      [
        15,
        2
      ],
      [
        12,
        2
      ],
      [
        4,
        0
      ],
      [
        3,
        1
      ],
      [
        1,
        0
      ],
      [
        11,
        1
      ],
      [
        1,
        0
      ],
      [
        2,
        1
      ],
      [
        23,
        2
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        12,
        1
      ]
    ],
    [
      [
        26661,
        65520
      ],
      [
        -1,
        -7
      ],
      [
        2,
        -19
      ],
      [
        1,
        -4
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        9,
        -17
      ],
      [
        5,
        1
      ],
      [
        5,
        -6
      ],
      [
        5,
        1
      ],
      [
        4,
        7
      ],
      [
        1,
        6
      ],
      [
        0,
        6
      ],
      [
        3,
        -3
      ],
      [
        9,
        -24
      ],
      [
        1,
        -4
      ],
      [
        4,
        -6
      ],
      [
        11,
        -24
      ],
      [
        1,
        -7
      ],
      [
        1,
        -1
      ],
      [
        4,
        -7
      ],
      [
        6,
        -9
      ],
      [
        8,
        -9
      ]
    ],
    [
      [
        26741,
        65392
      ],
      [
        -20,
        0
      ],
      [
        -50,
        -5
      ]
    ],
    [
      [
        26671,
        65387
      ],
      [
        -43,
        -2
      ],
      [
        -5,
        -19
      ],
      [
        -6,
        -35
      ],
      [
        -4,
        -1
      ],
      [
        -22,
        -48
      ],
      [
        -2,
        -42
      ],
      [
        -6,
        -9
      ],
      [
        -4,
        -22
      ],
      [
        -7,
        -3
      ],
      [
        -3,
        -16
      ],
      [
        -17,
        -29
      ],
      [
        -3,
        -12
      ],
      [
        -8,
        0
      ]
    ],
    [
      [
        26541,
        65149
      ],
      [
        0,
        85
      ]
    ],
    [
      [
        24456,
        65159
      ],
      [
        0,
        204
      ]
    ],
    [
      [
        24586,
        65362
      ],
      [
        33,
        -1
      ],
      [
        -1,
        -152
      ],
      [
        0,
        -15
      ]
    ],
    [
      [
        24618,
        65194
      ],
      [
        -6,
        2
      ],
      [
        -5,
        0
      ],
      [
        -3,
        1
      ],
      [
        -3,
        0
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        -6
      ],
      [
        -3,
        -8
      ],
      [
        -3,
        -6
      ],
      [
        -3,
        -5
      ],
      [
        -5,
        -7
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -6,
        3
      ],
      [
        -1,
        2
      ],
      [
        -3,
        5
      ],
      [
        -3,
        5
      ],
      [
        -2,
        0
      ],
      [
        -6,
        -9
      ],
      [
        -2,
        -2
      ],
      [
        -4,
        -1
      ],
      [
        -3,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -13
      ],
      [
        0,
        -17
      ],
      [
        -4,
        -19
      ],
      [
        0,
        -4
      ],
      [
        -2,
        -30
      ],
      [
        0,
        -7
      ]
    ],
    [
      [
        24538,
        65055
      ],
      [
        -22,
        1
      ],
      [
        -60,
        2
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        22569,
        57108
      ],
      [
        0,
        -252
      ]
    ],
    [
      [
        22569,
        56856
      ],
      [
        0,
        -173
      ]
    ],
    [
      [
        22569,
        56683
      ],
      [
        -1,
        -6
      ],
      [
        -3,
        -16
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        -7
      ],
      [
        -6,
        2
      ],
      [
        -3,
        1
      ],
      [
        -1,
        1
      ],
      [
        -3,
        5
      ],
      [
        -2,
        4
      ],
      [
        -1,
        2
      ],
      [
        -4,
        7
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -1
      ],
      [
        -7,
        1
      ],
      [
        -4,
        3
      ],
      [
        -1,
        2
      ],
      [
        -6,
        14
      ],
      [
        -1,
        4
      ],
      [
        -1,
        1
      ],
      [
        -10,
        7
      ],
      [
        -1,
        -1
      ],
      [
        -4,
        -8
      ],
      [
        -1,
        -3
      ],
      [
        -4,
        -21
      ],
      [
        -1,
        -7
      ],
      [
        1,
        -1
      ],
      [
        0,
        -25
      ],
      [
        -4,
        -18
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ]
    ],
    [
      [
        22490,
        56616
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        -7,
        -11
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -5,
        11
      ],
      [
        -7,
        27
      ],
      [
        -1,
        5
      ],
      [
        -1,
        9
      ],
      [
        -4,
        14
      ],
      [
        -2,
        11
      ],
      [
        -1,
        5
      ],
      [
        -3,
        14
      ],
      [
        -2,
        5
      ],
      [
        -6,
        13
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -1
      ]
    ],
    [
      [
        22438,
        56701
      ],
      [
        0,
        206
      ],
      [
        -14,
        -1
      ],
      [
        0,
        85
      ]
    ],
    [
      [
        23337,
        64552
      ],
      [
        -120,
        0
      ]
    ],
    [
      [
        23217,
        64552
      ],
      [
        0,
        2
      ],
      [
        -1,
        4
      ],
      [
        -3,
        10
      ],
      [
        -1,
        2
      ],
      [
        -1,
        5
      ],
      [
        0,
        4
      ],
      [
        -1,
        9
      ],
      [
        0,
        9
      ],
      [
        1,
        12
      ],
      [
        2,
        16
      ],
      [
        0,
        16
      ],
      [
        -1,
        6
      ],
      [
        -2,
        4
      ],
      [
        -1,
        3
      ],
      [
        -3,
        3
      ],
      [
        -2,
        4
      ],
      [
        -1,
        3
      ],
      [
        -1,
        5
      ],
      [
        0,
        12
      ],
      [
        1,
        6
      ],
      [
        1,
        9
      ],
      [
        1,
        7
      ],
      [
        -1,
        5
      ],
      [
        0,
        5
      ],
      [
        -2,
        6
      ],
      [
        -3,
        10
      ]
    ],
    [
      [
        23199,
        64729
      ],
      [
        -1,
        4
      ],
      [
        0,
        10
      ],
      [
        1,
        5
      ],
      [
        2,
        6
      ],
      [
        2,
        6
      ],
      [
        0,
        4
      ],
      [
        1,
        6
      ],
      [
        -1,
        6
      ],
      [
        0,
        28
      ],
      [
        -1,
        8
      ],
      [
        -3,
        15
      ],
      [
        -1,
        7
      ],
      [
        0,
        19
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        29435,
        64577
      ],
      [
        5,
        -28
      ],
      [
        1,
        -25
      ],
      [
        4,
        -12
      ],
      [
        4,
        -95
      ],
      [
        1,
        -5
      ],
      [
        1,
        -35
      ],
      [
        1,
        -14
      ],
      [
        1,
        -18
      ],
      [
        0,
        -13
      ],
      [
        1,
        -17
      ],
      [
        0,
        -2
      ],
      [
        1,
        -47
      ],
      [
        0,
        -53
      ]
    ],
    [
      [
        29455,
        64213
      ],
      [
        -17,
        -14
      ],
      [
        -6,
        -6
      ],
      [
        -14,
        -13
      ],
      [
        -4,
        2
      ],
      [
        -1,
        1
      ],
      [
        -10,
        4
      ],
      [
        -8,
        -6
      ],
      [
        -29,
        5
      ],
      [
        -2,
        3
      ]
    ],
    [
      [
        29364,
        64189
      ],
      [
        4,
        4
      ],
      [
        -2,
        22
      ],
      [
        -3,
        -2
      ],
      [
        -3,
        6
      ],
      [
        -1,
        10
      ],
      [
        1,
        3
      ],
      [
        5,
        9
      ],
      [
        1,
        4
      ],
      [
        1,
        -3
      ],
      [
        1,
        16
      ],
      [
        1,
        1
      ],
      [
        2,
        4
      ],
      [
        -1,
        14
      ],
      [
        1,
        21
      ],
      [
        0,
        32
      ],
      [
        -1,
        10
      ],
      [
        0,
        3
      ],
      [
        1,
        3
      ],
      [
        5,
        4
      ],
      [
        2,
        13
      ],
      [
        0,
        16
      ],
      [
        -14,
        34
      ],
      [
        -5,
        21
      ]
    ],
    [
      [
        29359,
        64434
      ],
      [
        0,
        1
      ],
      [
        4,
        23
      ],
      [
        0,
        7
      ],
      [
        7,
        30
      ],
      [
        1,
        5
      ],
      [
        -1,
        10
      ],
      [
        0,
        1
      ],
      [
        4,
        4
      ],
      [
        11,
        -15
      ],
      [
        1,
        2
      ],
      [
        5,
        6
      ],
      [
        0,
        17
      ],
      [
        4,
        17
      ],
      [
        2,
        6
      ],
      [
        2,
        2
      ],
      [
        2,
        -2
      ],
      [
        5,
        6
      ],
      [
        2,
        5
      ],
      [
        7,
        9
      ],
      [
        1,
        1
      ],
      [
        5,
        -9
      ],
      [
        8,
        7
      ],
      [
        1,
        -2
      ],
      [
        4,
        6
      ],
      [
        1,
        6
      ]
    ],
    [
      [
        20768,
        71489
      ],
      [
        30,
        0
      ],
      [
        3,
        17
      ],
      [
        6,
        0
      ],
      [
        3,
        17
      ],
      [
        6,
        0
      ],
      [
        0,
        16
      ],
      [
        6,
        0
      ],
      [
        3,
        34
      ],
      [
        8,
        17
      ],
      [
        3,
        34
      ],
      [
        9,
        34
      ],
      [
        0,
        42
      ],
      [
        6,
        0
      ],
      [
        -3,
        110
      ],
      [
        0,
        51
      ],
      [
        -4,
        17
      ],
      [
        0,
        25
      ],
      [
        -3,
        0
      ],
      [
        0,
        34
      ],
      [
        -3,
        0
      ],
      [
        -6,
        33
      ],
      [
        -3,
        0
      ],
      [
        0,
        17
      ],
      [
        -9,
        17
      ],
      [
        -3,
        17
      ],
      [
        -6,
        2
      ],
      [
        8,
        30
      ],
      [
        0,
        11
      ]
    ],
    [
      [
        20819,
        72064
      ],
      [
        10,
        -1
      ],
      [
        71,
        0
      ],
      [
        0,
        51
      ],
      [
        24,
        -1
      ]
    ],
    [
      [
        20924,
        72113
      ],
      [
        0,
        -78
      ]
    ],
    [
      [
        20924,
        72035
      ],
      [
        0,
        -801
      ]
    ],
    [
      [
        20924,
        71234
      ],
      [
        -86,
        0
      ],
      [
        0,
        33
      ],
      [
        -18,
        0
      ],
      [
        0,
        17
      ],
      [
        -53,
        0
      ]
    ],
    [
      [
        20767,
        71284
      ],
      [
        0,
        171
      ],
      [
        1,
        34
      ]
    ],
    [
      [
        24848,
        59299
      ],
      [
        13,
        -3
      ],
      [
        45,
        0
      ],
      [
        2,
        37
      ],
      [
        4,
        11
      ],
      [
        10,
        -13
      ],
      [
        5,
        -18
      ],
      [
        10,
        0
      ],
      [
        8,
        12
      ],
      [
        6,
        -9
      ],
      [
        2,
        -24
      ],
      [
        6,
        -18
      ],
      [
        5,
        -9
      ],
      [
        0,
        -27
      ]
    ],
    [
      [
        24964,
        59238
      ],
      [
        -5,
        2
      ],
      [
        -5,
        5
      ],
      [
        -6,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -10
      ],
      [
        2,
        -14
      ],
      [
        6,
        -14
      ],
      [
        2,
        -4
      ],
      [
        1,
        -6
      ],
      [
        7,
        -12
      ],
      [
        2,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        0
      ],
      [
        1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        0,
        -6
      ],
      [
        1,
        -10
      ],
      [
        0,
        -11
      ],
      [
        -2,
        -4
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -2,
        3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        -3
      ],
      [
        -4,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        1
      ],
      [
        -3,
        5
      ],
      [
        -4,
        5
      ],
      [
        -1,
        2
      ],
      [
        -3,
        1
      ],
      [
        -7,
        -3
      ],
      [
        -3,
        2
      ],
      [
        -1,
        3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -6
      ],
      [
        2,
        -5
      ],
      [
        2,
        -7
      ],
      [
        2,
        -6
      ],
      [
        1,
        -4
      ],
      [
        5,
        -11
      ],
      [
        2,
        -6
      ],
      [
        3,
        -9
      ],
      [
        2,
        -6
      ],
      [
        2,
        -4
      ]
    ],
    [
      [
        24940,
        59062
      ],
      [
        2,
        -2
      ],
      [
        1,
        -4
      ],
      [
        4,
        -10
      ],
      [
        1,
        -8
      ],
      [
        2,
        -11
      ],
      [
        1,
        -6
      ],
      [
        0,
        -17
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -3
      ],
      [
        -4,
        -6
      ],
      [
        -3,
        -7
      ],
      [
        0,
        -1
      ],
      [
        -5,
        -4
      ],
      [
        -4,
        -5
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -8
      ],
      [
        0,
        -14
      ],
      [
        -1,
        -24
      ],
      [
        -1,
        -21
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -10
      ],
      [
        -3,
        -14
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -4
      ],
      [
        -8,
        -1
      ]
    ],
    [
      [
        24911,
        58847
      ],
      [
        -10,
        0
      ],
      [
        -27,
        -1
      ],
      [
        -10,
        0
      ],
      [
        -16,
        -1
      ]
    ],
    [
      [
        24848,
        58845
      ],
      [
        0,
        454
      ]
    ],
    [
      [
        24324,
        63442
      ],
      [
        113,
        -3
      ]
    ],
    [
      [
        24437,
        63439
      ],
      [
        2,
        -5
      ],
      [
        1,
        -4
      ],
      [
        1,
        -5
      ],
      [
        1,
        -7
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -9
      ],
      [
        -4,
        -16
      ],
      [
        -1,
        -13
      ],
      [
        0,
        -14
      ],
      [
        3,
        -29
      ],
      [
        1,
        -6
      ],
      [
        1,
        -3
      ],
      [
        4,
        -9
      ],
      [
        2,
        -4
      ],
      [
        3,
        -7
      ],
      [
        3,
        -6
      ],
      [
        2,
        -5
      ],
      [
        1,
        -3
      ],
      [
        2,
        -10
      ],
      [
        1,
        -9
      ],
      [
        1,
        -6
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -12
      ],
      [
        1,
        -7
      ]
    ],
    [
      [
        24457,
        63222
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -10
      ],
      [
        0,
        -15
      ],
      [
        1,
        -4
      ],
      [
        4,
        -16
      ],
      [
        2,
        -7
      ],
      [
        4,
        -10
      ],
      [
        4,
        -9
      ],
      [
        3,
        -9
      ]
    ],
    [
      [
        24473,
        63136
      ],
      [
        -114,
        2
      ],
      [
        0,
        -34
      ]
    ],
    [
      [
        24359,
        63104
      ],
      [
        -37,
        1
      ]
    ],
    [
      [
        19530,
        55597
      ],
      [
        26,
        -1
      ],
      [
        86,
        2
      ],
      [
        29,
        -2
      ],
      [
        26,
        -8
      ],
      [
        125,
        0
      ]
    ],
    [
      [
        19822,
        55588
      ],
      [
        38,
        -1
      ],
      [
        1,
        -12
      ],
      [
        6,
        -8
      ],
      [
        -5,
        -20
      ],
      [
        1,
        -36
      ],
      [
        3,
        -45
      ],
      [
        -1,
        -12
      ],
      [
        3,
        -21
      ],
      [
        -5,
        -13
      ],
      [
        -1,
        -18
      ],
      [
        0,
        -45
      ],
      [
        8,
        -45
      ],
      [
        13,
        -13
      ],
      [
        2,
        0
      ],
      [
        0,
        -2
      ],
      [
        1,
        -10
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -12
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        1,
        -4
      ],
      [
        0,
        -5
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        -3,
        -15
      ],
      [
        1,
        -51
      ],
      [
        4,
        -9
      ],
      [
        4,
        -24
      ],
      [
        -1,
        -24
      ],
      [
        3,
        -24
      ],
      [
        5,
        -7
      ],
      [
        1,
        -18
      ],
      [
        -2,
        -31
      ],
      [
        2,
        -17
      ],
      [
        -1,
        -28
      ],
      [
        -2,
        -6
      ],
      [
        1,
        -36
      ],
      [
        -4,
        -37
      ],
      [
        6,
        -8
      ],
      [
        30,
        -20
      ]
    ],
    [
      [
        19762,
        54032
      ],
      [
        -86,
        -1
      ],
      [
        0,
        252
      ],
      [
        -4,
        0
      ],
      [
        1,
        222
      ],
      [
        -1,
        286
      ],
      [
        -30,
        0
      ],
      [
        0,
        102
      ],
      [
        -26,
        0
      ],
      [
        -32,
        -1
      ],
      [
        0,
        203
      ],
      [
        -54,
        1
      ]
    ],
    [
      [
        19530,
        55096
      ],
      [
        0,
        501
      ]
    ],
    [
      [
        28228,
        62493
      ],
      [
        2,
        9
      ],
      [
        0,
        14
      ],
      [
        1,
        3
      ],
      [
        1,
        12
      ],
      [
        1,
        3
      ],
      [
        0,
        1
      ],
      [
        1,
        4
      ],
      [
        1,
        2
      ],
      [
        0,
        6
      ],
      [
        2,
        16
      ],
      [
        0,
        2
      ],
      [
        -1,
        6
      ],
      [
        1,
        1
      ],
      [
        1,
        7
      ],
      [
        0,
        4
      ],
      [
        1,
        6
      ],
      [
        2,
        10
      ],
      [
        0,
        4
      ],
      [
        1,
        2
      ],
      [
        2,
        9
      ],
      [
        0,
        2
      ],
      [
        1,
        13
      ],
      [
        -1,
        0
      ],
      [
        0,
        8
      ],
      [
        1,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        1
      ],
      [
        1,
        6
      ],
      [
        0,
        1
      ],
      [
        1,
        5
      ],
      [
        0,
        8
      ],
      [
        1,
        2
      ],
      [
        0,
        7
      ],
      [
        1,
        7
      ],
      [
        1,
        7
      ],
      [
        3,
        20
      ],
      [
        1,
        4
      ],
      [
        3,
        3
      ],
      [
        0,
        4
      ]
    ],
    [
      [
        28270,
        62716
      ],
      [
        1,
        0
      ],
      [
        1,
        -3
      ],
      [
        1,
        -5
      ],
      [
        5,
        -8
      ],
      [
        3,
        -3
      ],
      [
        1,
        0
      ],
      [
        5,
        -6
      ],
      [
        3,
        1
      ],
      [
        2,
        -2
      ],
      [
        2,
        -1
      ],
      [
        1,
        1
      ],
      [
        3,
        4
      ],
      [
        2,
        1
      ],
      [
        1,
        0
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -11
      ],
      [
        1,
        -9
      ],
      [
        2,
        -8
      ],
      [
        0,
        -4
      ],
      [
        2,
        -5
      ],
      [
        0,
        -3
      ],
      [
        1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        2,
        -3
      ],
      [
        3,
        -4
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        3,
        -5
      ],
      [
        4,
        -2
      ],
      [
        2,
        -4
      ],
      [
        1,
        -2
      ],
      [
        1,
        -5
      ],
      [
        3,
        -8
      ],
      [
        3,
        -8
      ],
      [
        0,
        -9
      ]
    ],
    [
      [
        28331,
        62595
      ],
      [
        0,
        -2
      ],
      [
        -3,
        -8
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -7
      ],
      [
        1,
        -9
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -4
      ],
      [
        -6,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -9
      ],
      [
        -1,
        -11
      ],
      [
        -1,
        -15
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -11
      ],
      [
        1,
        -11
      ],
      [
        1,
        -6
      ],
      [
        0,
        -2
      ],
      [
        1,
        -2
      ],
      [
        5,
        -6
      ],
      [
        1,
        -1
      ],
      [
        3,
        -4
      ],
      [
        1,
        -4
      ],
      [
        1,
        -7
      ],
      [
        1,
        -9
      ],
      [
        1,
        -7
      ],
      [
        2,
        -12
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        2,
        -1
      ],
      [
        4,
        -2
      ],
      [
        4,
        -5
      ],
      [
        2,
        0
      ],
      [
        3,
        -2
      ],
      [
        2,
        0
      ],
      [
        3,
        -3
      ],
      [
        2,
        1
      ],
      [
        1,
        -2
      ],
      [
        2,
        0
      ],
      [
        3,
        1
      ],
      [
        2,
        0
      ],
      [
        3,
        1
      ],
      [
        1,
        -2
      ],
      [
        1,
        0
      ],
      [
        0,
        -2
      ],
      [
        1,
        -2
      ]
    ],
    [
      [
        28367,
        62406
      ],
      [
        -11,
        -51
      ],
      [
        -3,
        -8
      ],
      [
        -6,
        -27
      ],
      [
        0,
        -2
      ],
      [
        -9,
        -35
      ],
      [
        -11,
        -48
      ],
      [
        -7,
        -28
      ],
      [
        -10,
        -46
      ]
    ],
    [
      [
        28310,
        62161
      ],
      [
        -4,
        -1
      ],
      [
        -1,
        47
      ],
      [
        -11,
        12
      ],
      [
        -8,
        40
      ],
      [
        -1,
        0
      ],
      [
        -4,
        12
      ],
      [
        -5,
        1
      ]
    ],
    [
      [
        28276,
        62272
      ],
      [
        -85,
        83
      ]
    ],
    [
      [
        28191,
        62355
      ],
      [
        19,
        48
      ],
      [
        2,
        11
      ],
      [
        7,
        19
      ],
      [
        2,
        16
      ],
      [
        0,
        7
      ],
      [
        2,
        19
      ],
      [
        1,
        3
      ],
      [
        1,
        2
      ],
      [
        3,
        13
      ]
    ],
    [
      [
        21227,
        69571
      ],
      [
        2,
        202
      ],
      [
        2,
        403
      ],
      [
        0,
        247
      ]
    ],
    [
      [
        21231,
        70423
      ],
      [
        77,
        0
      ],
      [
        4,
        1
      ],
      [
        3,
        -1
      ],
      [
        162,
        0
      ],
      [
        17,
        -1
      ]
    ],
    [
      [
        21494,
        70422
      ],
      [
        0,
        -549
      ]
    ],
    [
      [
        21494,
        69873
      ],
      [
        0,
        -506
      ]
    ],
    [
      [
        21494,
        69367
      ],
      [
        -267,
        2
      ]
    ],
    [
      [
        22428,
        51565
      ],
      [
        65,
        224
      ]
    ],
    [
      [
        22525,
        51906
      ],
      [
        49,
        -145
      ],
      [
        26,
        -75
      ],
      [
        3,
        -43
      ],
      [
        1,
        -12
      ],
      [
        4,
        -57
      ]
    ],
    [
      [
        22608,
        51574
      ],
      [
        0,
        -2
      ],
      [
        -25,
        -78
      ],
      [
        -30,
        -53
      ],
      [
        -31,
        -51
      ]
    ],
    [
      [
        22522,
        51390
      ],
      [
        -1,
        8
      ],
      [
        -4,
        8
      ],
      [
        -5,
        13
      ],
      [
        0,
        41
      ],
      [
        -10,
        23
      ],
      [
        0,
        34
      ],
      [
        7,
        0
      ],
      [
        4,
        7
      ],
      [
        1,
        14
      ],
      [
        -4,
        15
      ],
      [
        -5,
        -16
      ],
      [
        -1,
        11
      ],
      [
        -7,
        9
      ],
      [
        -1,
        13
      ],
      [
        -4,
        -3
      ],
      [
        -3,
        -32
      ],
      [
        -4,
        1
      ],
      [
        0,
        17
      ],
      [
        -4,
        -3
      ],
      [
        -3,
        8
      ],
      [
        -3,
        -6
      ],
      [
        -7,
        6
      ],
      [
        -11,
        15
      ],
      [
        -2,
        10
      ],
      [
        -3,
        -10
      ],
      [
        -4,
        -2
      ],
      [
        -2,
        -10
      ],
      [
        -5,
        10
      ],
      [
        0,
        -10
      ],
      [
        -5,
        3
      ],
      [
        -6,
        -4
      ],
      [
        -2,
        5
      ]
    ],
    [
      [
        22203,
        48678
      ],
      [
        23,
        63
      ],
      [
        11,
        -53
      ],
      [
        105,
        -5
      ]
    ],
    [
      [
        22342,
        48120
      ],
      [
        -16,
        -128
      ],
      [
        -44,
        -121
      ]
    ],
    [
      [
        22282,
        47871
      ],
      [
        -2,
        57
      ],
      [
        -6,
        42
      ],
      [
        -3,
        44
      ],
      [
        0,
        35
      ],
      [
        -8,
        25
      ],
      [
        -1,
        49
      ],
      [
        -5,
        32
      ],
      [
        -2,
        32
      ],
      [
        -4,
        18
      ],
      [
        -4,
        8
      ],
      [
        -6,
        1
      ],
      [
        -3,
        16
      ],
      [
        2,
        31
      ],
      [
        -1,
        11
      ],
      [
        -3,
        8
      ],
      [
        -7,
        7
      ],
      [
        -2,
        0
      ],
      [
        -3,
        7
      ],
      [
        -3,
        11
      ],
      [
        -1,
        19
      ],
      [
        1,
        7
      ],
      [
        3,
        8
      ],
      [
        1,
        5
      ],
      [
        -1,
        3
      ],
      [
        -2,
        2
      ],
      [
        -5,
        18
      ],
      [
        -1,
        10
      ],
      [
        -2,
        13
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        0
      ],
      [
        -2,
        5
      ],
      [
        -2,
        10
      ],
      [
        0,
        3
      ],
      [
        1,
        6
      ],
      [
        0,
        6
      ],
      [
        -2,
        31
      ],
      [
        0,
        6
      ],
      [
        5,
        12
      ],
      [
        1,
        15
      ],
      [
        0,
        4
      ],
      [
        -2,
        7
      ],
      [
        -2,
        7
      ],
      [
        1,
        4
      ],
      [
        2,
        11
      ],
      [
        1,
        8
      ],
      [
        -1,
        13
      ],
      [
        -2,
        8
      ],
      [
        0,
        8
      ],
      [
        1,
        3
      ],
      [
        2,
        6
      ],
      [
        1,
        20
      ],
      [
        -2,
        39
      ],
      [
        -3,
        10
      ],
      [
        0,
        6
      ],
      [
        1,
        15
      ],
      [
        0,
        16
      ],
      [
        -3,
        16
      ],
      [
        -1,
        1
      ]
    ],
    [
      [
        22865,
        49435
      ],
      [
        17,
        36
      ],
      [
        9,
        45
      ],
      [
        4,
        32
      ],
      [
        4,
        28
      ],
      [
        6,
        23
      ],
      [
        2,
        31
      ],
      [
        2,
        13
      ],
      [
        9,
        12
      ],
      [
        0,
        14
      ],
      [
        2,
        15
      ],
      [
        7,
        -10
      ],
      [
        9,
        22
      ]
    ],
    [
      [
        22936,
        49696
      ],
      [
        -2,
        -36
      ],
      [
        -7,
        -52
      ],
      [
        1,
        -4
      ]
    ],
    [
      [
        22928,
        49604
      ],
      [
        -10,
        -34
      ],
      [
        -17,
        -70
      ],
      [
        -15,
        -73
      ],
      [
        -11,
        -83
      ]
    ],
    [
      [
        22875,
        49344
      ],
      [
        -6,
        17
      ],
      [
        2,
        16
      ],
      [
        -6,
        58
      ]
    ],
    [
      [
        22945,
        49905
      ],
      [
        0,
        -8
      ],
      [
        -4,
        -18
      ],
      [
        -1,
        -7
      ],
      [
        1,
        -10
      ],
      [
        2,
        -11
      ]
    ],
    [
      [
        22943,
        49851
      ],
      [
        -3,
        -64
      ]
    ],
    [
      [
        22940,
        49787
      ],
      [
        -9,
        -28
      ],
      [
        -9,
        -20
      ],
      [
        -7,
        -27
      ],
      [
        -3,
        -7
      ],
      [
        -7,
        -27
      ],
      [
        -8,
        -1
      ],
      [
        -10,
        17
      ],
      [
        -2,
        -2
      ],
      [
        -6,
        15
      ],
      [
        2,
        41
      ],
      [
        -2,
        1
      ]
    ],
    [
      [
        22879,
        49749
      ],
      [
        3,
        21
      ],
      [
        -6,
        -2
      ],
      [
        -1,
        9
      ],
      [
        -3,
        -6
      ],
      [
        -3,
        13
      ],
      [
        -11,
        13
      ],
      [
        2,
        7
      ],
      [
        -8,
        25
      ],
      [
        2,
        8
      ],
      [
        -2,
        13
      ],
      [
        93,
        55
      ]
    ],
    [
      [
        22827,
        49623
      ],
      [
        0,
        -1
      ],
      [
        11,
        -18
      ],
      [
        10,
        -4
      ],
      [
        10,
        25
      ],
      [
        14,
        32
      ],
      [
        8,
        7
      ],
      [
        0,
        -10
      ],
      [
        -2,
        -11
      ],
      [
        -1,
        -11
      ],
      [
        0,
        -12
      ],
      [
        1,
        -24
      ],
      [
        2,
        -13
      ],
      [
        -2,
        -10
      ],
      [
        -3,
        -6
      ],
      [
        -2,
        -7
      ],
      [
        -4,
        -31
      ],
      [
        -3,
        -10
      ],
      [
        -13,
        -74
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -21
      ]
    ],
    [
      [
        22849,
        49420
      ],
      [
        -35,
        202
      ]
    ],
    [
      [
        22814,
        49622
      ],
      [
        6,
        -17
      ],
      [
        7,
        18
      ]
    ],
    [
      [
        23690,
        52143
      ],
      [
        60,
        1
      ]
    ],
    [
      [
        23750,
        52144
      ],
      [
        55,
        2
      ]
    ],
    [
      [
        23805,
        52146
      ],
      [
        0,
        -1
      ],
      [
        -3,
        -21
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -10
      ],
      [
        1,
        -19
      ],
      [
        2,
        -15
      ],
      [
        2,
        -8
      ],
      [
        1,
        -9
      ],
      [
        1,
        -15
      ],
      [
        2,
        -13
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        4
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -29
      ],
      [
        -5,
        -21
      ],
      [
        -3,
        -7
      ],
      [
        0,
        -8
      ],
      [
        5,
        -15
      ],
      [
        4,
        -4
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -3
      ],
      [
        -5,
        -1
      ],
      [
        0,
        -2
      ]
    ],
    [
      [
        23800,
        51922
      ],
      [
        -4,
        -17
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -13
      ],
      [
        -13,
        -36
      ],
      [
        -1,
        -3
      ],
      [
        -5,
        -39
      ],
      [
        -2,
        -23
      ],
      [
        0,
        -16
      ],
      [
        -1,
        -7
      ],
      [
        -3,
        -24
      ],
      [
        -2,
        -13
      ],
      [
        -5,
        -21
      ]
    ],
    [
      [
        23763,
        51705
      ],
      [
        4,
        56
      ],
      [
        0,
        36
      ],
      [
        -4,
        29
      ],
      [
        -1,
        10
      ],
      [
        -13,
        9
      ],
      [
        -2,
        12
      ],
      [
        -5,
        -5
      ],
      [
        -7,
        11
      ],
      [
        -1,
        13
      ],
      [
        -7,
        -1
      ],
      [
        -1,
        12
      ],
      [
        -3,
        -10
      ],
      [
        0,
        19
      ],
      [
        -9,
        -1
      ],
      [
        0,
        38
      ],
      [
        -8,
        16
      ],
      [
        -7,
        3
      ],
      [
        -2,
        7
      ],
      [
        1,
        25
      ],
      [
        4,
        11
      ],
      [
        -2,
        15
      ],
      [
        -8,
        13
      ],
      [
        -2,
        26
      ]
    ],
    [
      [
        23690,
        52049
      ],
      [
        2,
        32
      ],
      [
        5,
        19
      ],
      [
        -7,
        13
      ],
      [
        0,
        30
      ]
    ],
    [
      [
        21124,
        54191
      ],
      [
        16,
        0
      ],
      [
        1,
        -1
      ],
      [
        0,
        1
      ],
      [
        56,
        0
      ],
      [
        0,
        100
      ]
    ],
    [
      [
        21271,
        54290
      ],
      [
        0,
        -505
      ]
    ],
    [
      [
        21271,
        53785
      ],
      [
        -1,
        -1
      ],
      [
        -146,
        0
      ]
    ],
    [
      [
        21124,
        53784
      ],
      [
        0,
        407
      ]
    ],
    [
      [
        27938,
        60641
      ],
      [
        12,
        -5
      ],
      [
        0,
        18
      ]
    ],
    [
      [
        27950,
        60654
      ],
      [
        34,
        -113
      ],
      [
        6,
        -31
      ],
      [
        13,
        -15
      ],
      [
        -1,
        -14
      ],
      [
        3,
        -23
      ],
      [
        4,
        11
      ],
      [
        6,
        5
      ]
    ],
    [
      [
        28015,
        60474
      ],
      [
        0,
        -62
      ],
      [
        -9,
        -27
      ],
      [
        -13,
        -62
      ],
      [
        -3,
        -23
      ]
    ],
    [
      [
        27990,
        60300
      ],
      [
        -10,
        -14
      ],
      [
        -4,
        -19
      ],
      [
        -12,
        10
      ],
      [
        -9,
        -32
      ],
      [
        -4,
        4
      ]
    ],
    [
      [
        27951,
        60249
      ],
      [
        -9,
        8
      ],
      [
        -2,
        33
      ],
      [
        -8,
        10
      ],
      [
        -8,
        -4
      ],
      [
        -2,
        37
      ],
      [
        -4,
        8
      ],
      [
        -2,
        10
      ],
      [
        -1,
        29
      ],
      [
        -19,
        130
      ]
    ],
    [
      [
        27896,
        60510
      ],
      [
        3,
        19
      ],
      [
        9,
        27
      ],
      [
        9,
        15
      ],
      [
        -1,
        25
      ],
      [
        7,
        -6
      ],
      [
        8,
        18
      ],
      [
        -1,
        20
      ],
      [
        8,
        13
      ]
    ],
    [
      [
        16477,
        71907
      ],
      [
        0,
        13
      ],
      [
        1,
        104
      ],
      [
        6,
        0
      ],
      [
        -1,
        17
      ],
      [
        6,
        0
      ],
      [
        1,
        16
      ],
      [
        5,
        1
      ],
      [
        0,
        17
      ],
      [
        6,
        0
      ],
      [
        0,
        34
      ],
      [
        6,
        0
      ],
      [
        0,
        17
      ],
      [
        6,
        0
      ],
      [
        0,
        34
      ],
      [
        96,
        5
      ],
      [
        0,
        100
      ],
      [
        6,
        0
      ],
      [
        0,
        17
      ],
      [
        6,
        0
      ],
      [
        6,
        33
      ],
      [
        6,
        0
      ],
      [
        0,
        17
      ],
      [
        12,
        32
      ],
      [
        17,
        10
      ],
      [
        0,
        7
      ],
      [
        6,
        0
      ],
      [
        0,
        50
      ],
      [
        6,
        0
      ],
      [
        0,
        68
      ],
      [
        6,
        0
      ],
      [
        0,
        17
      ],
      [
        6,
        -1
      ],
      [
        0,
        34
      ],
      [
        6,
        1
      ],
      [
        0,
        33
      ],
      [
        6,
        0
      ],
      [
        0,
        101
      ],
      [
        6,
        1
      ],
      [
        0,
        17
      ],
      [
        12,
        0
      ],
      [
        0,
        17
      ],
      [
        6,
        0
      ],
      [
        0,
        34
      ],
      [
        6,
        0
      ],
      [
        0,
        18
      ],
      [
        34,
        0
      ]
    ],
    [
      [
        16762,
        72771
      ],
      [
        1,
        -16
      ],
      [
        2,
        -6
      ]
    ],
    [
      [
        16765,
        72749
      ],
      [
        -1,
        -295
      ],
      [
        -1,
        -498
      ]
    ],
    [
      [
        16655,
        71346
      ],
      [
        0,
        -70
      ],
      [
        -24,
        2
      ]
    ],
    [
      [
        16631,
        71278
      ],
      [
        1,
        7
      ],
      [
        -10,
        35
      ],
      [
        -7,
        14
      ],
      [
        -20,
        -67
      ],
      [
        -10,
        -26
      ],
      [
        -11,
        -9
      ],
      [
        -14,
        10
      ],
      [
        -12,
        -15
      ],
      [
        -24,
        -12
      ],
      [
        -10,
        3
      ]
    ],
    [
      [
        16514,
        71218
      ],
      [
        -2,
        3
      ],
      [
        -5,
        3
      ],
      [
        -1,
        3
      ],
      [
        -4,
        23
      ],
      [
        -8,
        24
      ],
      [
        -8,
        55
      ],
      [
        0,
        16
      ]
    ],
    [
      [
        27375,
        62681
      ],
      [
        17,
        57
      ],
      [
        27,
        61
      ],
      [
        5,
        40
      ],
      [
        16,
        4
      ],
      [
        2,
        11
      ],
      [
        9,
        9
      ]
    ],
    [
      [
        27471,
        62838
      ],
      [
        2,
        -22
      ],
      [
        -3,
        -8
      ],
      [
        2,
        -18
      ],
      [
        -1,
        -25
      ],
      [
        4,
        -7
      ],
      [
        -7,
        -27
      ],
      [
        -2,
        -19
      ],
      [
        -5,
        -5
      ],
      [
        -6,
        -35
      ],
      [
        7,
        -5
      ],
      [
        -1,
        -29
      ],
      [
        10,
        -26
      ],
      [
        -6,
        -16
      ],
      [
        12,
        -14
      ],
      [
        -1,
        -16
      ],
      [
        -13,
        -23
      ],
      [
        -5,
        8
      ],
      [
        -1,
        -18
      ]
    ],
    [
      [
        27457,
        62533
      ],
      [
        -9,
        -32
      ],
      [
        -8,
        2
      ],
      [
        -7,
        -23
      ],
      [
        -5,
        -36
      ],
      [
        -8,
        6
      ]
    ],
    [
      [
        27397,
        62466
      ],
      [
        -29,
        190
      ],
      [
        7,
        25
      ]
    ],
    [
      [
        27599,
        62277
      ],
      [
        53,
        31
      ],
      [
        2,
        34
      ],
      [
        5,
        37
      ],
      [
        2,
        44
      ],
      [
        4,
        26
      ],
      [
        4,
        2
      ],
      [
        3,
        22
      ]
    ],
    [
      [
        27802,
        62297
      ],
      [
        2,
        -8
      ]
    ],
    [
      [
        27804,
        62289
      ],
      [
        -5,
        -38
      ],
      [
        -2,
        -5
      ],
      [
        -11,
        3
      ],
      [
        -8,
        11
      ],
      [
        -3,
        -3
      ],
      [
        3,
        -36
      ],
      [
        -11,
        -15
      ],
      [
        -10,
        7
      ],
      [
        3,
        -19
      ],
      [
        -2,
        -15
      ],
      [
        -7,
        -25
      ],
      [
        5,
        -13
      ],
      [
        -1,
        -19
      ],
      [
        5,
        -16
      ],
      [
        0,
        -23
      ],
      [
        -5,
        -20
      ],
      [
        -3,
        -19
      ],
      [
        -5,
        -17
      ],
      [
        -2,
        -18
      ],
      [
        -10,
        -34
      ],
      [
        1,
        -28
      ],
      [
        -8,
        6
      ],
      [
        -1,
        -5
      ]
    ],
    [
      [
        27545,
        61983
      ],
      [
        12,
        57
      ],
      [
        26,
        2
      ],
      [
        5,
        1
      ],
      [
        8,
        110
      ],
      [
        -3,
        65
      ],
      [
        5,
        25
      ],
      [
        -2,
        11
      ],
      [
        3,
        23
      ]
    ],
    [
      [
        23317,
        67578
      ],
      [
        6,
        -1
      ],
      [
        13,
        0
      ]
    ],
    [
      [
        23336,
        67577
      ],
      [
        0,
        -285
      ]
    ],
    [
      [
        23204,
        67295
      ],
      [
        0,
        282
      ]
    ],
    [
      [
        26626,
        60600
      ],
      [
        8,
        -71
      ],
      [
        4,
        -33
      ],
      [
        -4,
        -27
      ],
      [
        1,
        -37
      ],
      [
        3,
        -11
      ],
      [
        -3,
        -21
      ]
    ],
    [
      [
        26635,
        60400
      ],
      [
        -1,
        -55
      ],
      [
        8,
        -17
      ],
      [
        -2,
        -17
      ]
    ],
    [
      [
        26640,
        60311
      ],
      [
        -4,
        11
      ],
      [
        -7,
        0
      ],
      [
        1,
        9
      ],
      [
        -5,
        23
      ],
      [
        -4,
        -3
      ],
      [
        -3,
        19
      ],
      [
        -4,
        7
      ],
      [
        -5,
        34
      ],
      [
        -4,
        16
      ],
      [
        -4,
        -3
      ],
      [
        -3,
        -21
      ],
      [
        -11,
        2
      ],
      [
        -18,
        11
      ]
    ],
    [
      [
        26569,
        60416
      ],
      [
        -10,
        39
      ],
      [
        -9,
        77
      ],
      [
        -4,
        4
      ],
      [
        -5,
        30
      ],
      [
        0,
        47
      ]
    ],
    [
      [
        28053,
        59478
      ],
      [
        6,
        0
      ],
      [
        31,
        1
      ]
    ],
    [
      [
        28090,
        59479
      ],
      [
        13,
        -276
      ],
      [
        -8,
        -47
      ]
    ],
    [
      [
        28042,
        59050
      ],
      [
        -3,
        9
      ],
      [
        -1,
        255
      ],
      [
        0,
        62
      ],
      [
        4,
        69
      ],
      [
        7,
        8
      ],
      [
        4,
        25
      ]
    ],
    [
      [
        19056,
        56825
      ],
      [
        0,
        -307
      ],
      [
        209,
        0
      ],
      [
        0,
        -492
      ]
    ],
    [
      [
        19265,
        56026
      ],
      [
        0,
        -103
      ],
      [
        -16,
        -26
      ],
      [
        -6,
        0
      ],
      [
        -13,
        -1
      ],
      [
        -5,
        0
      ],
      [
        -7,
        -8
      ],
      [
        0,
        -4
      ],
      [
        -2,
        -6
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -2,
        -3
      ],
      [
        0,
        -6
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -1
      ],
      [
        0,
        2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        1
      ],
      [
        -2,
        2
      ],
      [
        -2,
        2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -3,
        -3
      ],
      [
        -3,
        -2
      ],
      [
        -3,
        4
      ],
      [
        -1,
        1
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -6
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        3
      ],
      [
        -2,
        1
      ],
      [
        -2,
        1
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        0
      ],
      [
        -2,
        -2
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -11
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        5
      ],
      [
        -1,
        3
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -1
      ],
      [
        -3,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        0,
        2
      ],
      [
        -2,
        0
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -9
      ],
      [
        1,
        -5
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -5
      ],
      [
        0,
        -4
      ],
      [
        1,
        -6
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -26
      ],
      [
        -1,
        -7
      ],
      [
        1,
        -5
      ],
      [
        0,
        -18
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -2
      ],
      [
        1,
        -5
      ],
      [
        1,
        -6
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -3
      ],
      [
        1,
        -9
      ],
      [
        0,
        -7
      ],
      [
        1,
        -4
      ],
      [
        0,
        -6
      ],
      [
        2,
        -5
      ],
      [
        0,
        -4
      ],
      [
        4,
        -21
      ],
      [
        1,
        -13
      ],
      [
        3,
        -19
      ],
      [
        1,
        -8
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        1
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        1
      ],
      [
        -1,
        5
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        19140,
        55581
      ],
      [
        -4,
        -13
      ],
      [
        -12,
        3
      ],
      [
        -8,
        -22
      ],
      [
        -3,
        2
      ],
      [
        -1,
        -19
      ],
      [
        -9,
        -7
      ],
      [
        -3,
        -15
      ],
      [
        -5,
        11
      ],
      [
        -6,
        -1
      ],
      [
        -7,
        -34
      ],
      [
        -6,
        -2
      ],
      [
        -1,
        -27
      ],
      [
        -3,
        -13
      ],
      [
        -4,
        8
      ],
      [
        -5,
        -16
      ],
      [
        2,
        -20
      ],
      [
        -3,
        -30
      ],
      [
        -5,
        -19
      ],
      [
        -5,
        -9
      ],
      [
        -1,
        -21
      ],
      [
        -4,
        -1
      ],
      [
        -46,
        309
      ],
      [
        -2,
        34
      ],
      [
        -6,
        73
      ],
      [
        -18,
        145
      ]
    ],
    [
      [
        18975,
        55897
      ],
      [
        -5,
        39
      ],
      [
        -26,
        207
      ],
      [
        -8,
        -21
      ],
      [
        -8,
        -30
      ],
      [
        0,
        -15
      ],
      [
        -4,
        -22
      ],
      [
        -7,
        26
      ],
      [
        -4,
        -2
      ],
      [
        -7,
        40
      ],
      [
        -7,
        27
      ],
      [
        -5,
        9
      ],
      [
        -2,
        36
      ],
      [
        -6,
        26
      ],
      [
        -7,
        10
      ],
      [
        -1,
        31
      ],
      [
        3,
        18
      ],
      [
        -3,
        13
      ],
      [
        5,
        24
      ],
      [
        -7,
        24
      ],
      [
        2,
        22
      ],
      [
        -3,
        17
      ],
      [
        -4,
        8
      ],
      [
        2,
        41
      ],
      [
        -5,
        7
      ],
      [
        -4,
        -11
      ],
      [
        -3,
        4
      ],
      [
        1,
        25
      ],
      [
        -2,
        24
      ],
      [
        6,
        25
      ],
      [
        -4,
        21
      ],
      [
        -6,
        5
      ],
      [
        -8,
        -7
      ]
    ],
    [
      [
        18848,
        56518
      ],
      [
        1,
        45
      ],
      [
        5,
        3
      ],
      [
        3,
        37
      ],
      [
        -6,
        26
      ],
      [
        4,
        19
      ],
      [
        -3,
        23
      ],
      [
        -3,
        3
      ],
      [
        4,
        20
      ],
      [
        -65,
        0
      ],
      [
        -2,
        12
      ],
      [
        7,
        23
      ],
      [
        1,
        22
      ],
      [
        -4,
        14
      ],
      [
        1,
        33
      ],
      [
        7,
        35
      ],
      [
        -2,
        15
      ],
      [
        5,
        3
      ],
      [
        0,
        11
      ],
      [
        -3,
        -7
      ],
      [
        -2,
        10
      ],
      [
        2,
        10
      ],
      [
        2,
        2
      ],
      [
        2,
        19
      ],
      [
        -2,
        28
      ],
      [
        3,
        23
      ],
      [
        -1,
        21
      ],
      [
        12,
        17
      ],
      [
        4,
        18
      ],
      [
        6,
        4
      ],
      [
        8,
        23
      ],
      [
        0,
        37
      ]
    ],
    [
      [
        24017,
        58980
      ],
      [
        15,
        -1
      ]
    ],
    [
      [
        24032,
        58979
      ],
      [
        15,
        0
      ],
      [
        0,
        -51
      ],
      [
        29,
        -3
      ],
      [
        42,
        -3
      ],
      [
        24,
        -1
      ],
      [
        5,
        0
      ],
      [
        18,
        -2
      ]
    ],
    [
      [
        24165,
        58919
      ],
      [
        -1,
        -101
      ]
    ],
    [
      [
        24164,
        58818
      ],
      [
        0,
        -218
      ]
    ],
    [
      [
        24015,
        58526
      ],
      [
        1,
        103
      ],
      [
        2,
        206
      ],
      [
        0,
        95
      ],
      [
        -2,
        0
      ],
      [
        1,
        50
      ]
    ],
    [
      [
        24456,
        57581
      ],
      [
        20,
        -1
      ],
      [
        1,
        85
      ],
      [
        15,
        0
      ],
      [
        0,
        22
      ],
      [
        8,
        -1
      ],
      [
        17,
        -1
      ]
    ],
    [
      [
        24517,
        57685
      ],
      [
        -1,
        -105
      ],
      [
        10,
        0
      ],
      [
        0,
        -52
      ],
      [
        5,
        0
      ]
    ],
    [
      [
        24531,
        57528
      ],
      [
        -1,
        -154
      ],
      [
        15,
        -1
      ],
      [
        -1,
        -35
      ],
      [
        0,
        -68
      ]
    ],
    [
      [
        24544,
        57270
      ],
      [
        -1,
        -204
      ],
      [
        15,
        -1
      ],
      [
        0,
        -155
      ],
      [
        -15,
        0
      ]
    ],
    [
      [
        24543,
        56910
      ],
      [
        -11,
        9
      ],
      [
        -3,
        25
      ],
      [
        -5,
        12
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -2,
        25
      ],
      [
        -8,
        11
      ],
      [
        4,
        11
      ],
      [
        -6,
        34
      ],
      [
        -5,
        -13
      ],
      [
        -8,
        5
      ],
      [
        4,
        14
      ],
      [
        -3,
        20
      ],
      [
        0,
        16
      ],
      [
        -4,
        -7
      ],
      [
        -9,
        24
      ],
      [
        1,
        30
      ],
      [
        -11,
        8
      ],
      [
        2,
        32
      ],
      [
        -24,
        2
      ]
    ],
    [
      [
        24453,
        57174
      ],
      [
        0,
        34
      ],
      [
        -10,
        1
      ],
      [
        1,
        18
      ],
      [
        -10,
        0
      ],
      [
        0,
        68
      ],
      [
        20,
        -2
      ],
      [
        1,
        185
      ],
      [
        -1,
        2
      ],
      [
        4,
        42
      ],
      [
        5,
        13
      ],
      [
        -11,
        37
      ],
      [
        4,
        9
      ]
    ],
    [
      [
        25995,
        52680
      ],
      [
        6,
        42
      ],
      [
        -3,
        14
      ],
      [
        3,
        47
      ],
      [
        9,
        -1
      ],
      [
        11,
        -1
      ],
      [
        0,
        -16
      ],
      [
        4,
        -1
      ],
      [
        0,
        -33
      ],
      [
        33,
        -3
      ],
      [
        -1,
        31
      ],
      [
        5,
        30
      ],
      [
        1,
        40
      ]
    ],
    [
      [
        26063,
        52829
      ],
      [
        33,
        -1
      ],
      [
        0,
        -51
      ],
      [
        14,
        -1
      ],
      [
        -1,
        -253
      ]
    ],
    [
      [
        26496,
        55966
      ],
      [
        4,
        16
      ],
      [
        5,
        23
      ],
      [
        1,
        5
      ],
      [
        6,
        28
      ],
      [
        4,
        18
      ],
      [
        6,
        30
      ],
      [
        6,
        26
      ],
      [
        3,
        48
      ],
      [
        -1,
        21
      ],
      [
        3,
        2
      ],
      [
        -1,
        37
      ]
    ],
    [
      [
        26532,
        56220
      ],
      [
        8,
        -19
      ],
      [
        27,
        -71
      ],
      [
        9,
        -23
      ],
      [
        7,
        -1
      ],
      [
        12,
        -34
      ],
      [
        -3,
        -8
      ],
      [
        6,
        -15
      ]
    ],
    [
      [
        26597,
        55967
      ],
      [
        -1,
        -18
      ],
      [
        3,
        -28
      ],
      [
        -3,
        -4
      ],
      [
        -5,
        20
      ],
      [
        0,
        -14
      ],
      [
        -9,
        -9
      ],
      [
        -10,
        -33
      ],
      [
        -15,
        -18
      ],
      [
        -1,
        -21
      ],
      [
        -4,
        -5
      ],
      [
        1,
        -17
      ],
      [
        3,
        -8
      ],
      [
        -9,
        -29
      ]
    ],
    [
      [
        26530,
        55871
      ],
      [
        0,
        8
      ],
      [
        -6,
        36
      ],
      [
        -8,
        2
      ],
      [
        -7,
        12
      ],
      [
        -9,
        5
      ],
      [
        -3,
        24
      ],
      [
        -4,
        -4
      ],
      [
        3,
        12
      ]
    ],
    [
      [
        26979,
        50652
      ],
      [
        60,
        0
      ],
      [
        40,
        -1
      ]
    ],
    [
      [
        27079,
        50651
      ],
      [
        0,
        -475
      ],
      [
        -1,
        -240
      ]
    ],
    [
      [
        27078,
        49936
      ],
      [
        0,
        -43
      ],
      [
        -8,
        -4
      ],
      [
        -3,
        15
      ],
      [
        -7,
        7
      ],
      [
        -10,
        -13
      ]
    ],
    [
      [
        27051,
        50091
      ],
      [
        0,
        50
      ],
      [
        -4,
        11
      ],
      [
        -8,
        -7
      ],
      [
        -4,
        22
      ],
      [
        -6,
        3
      ],
      [
        -2,
        22
      ],
      [
        -5,
        9
      ],
      [
        -2,
        -11
      ],
      [
        -9,
        14
      ],
      [
        -4,
        -2
      ],
      [
        -3,
        22
      ],
      [
        -11,
        52
      ],
      [
        1,
        13
      ],
      [
        -5,
        9
      ],
      [
        4,
        13
      ]
    ],
    [
      [
        26993,
        50311
      ],
      [
        0,
        18
      ],
      [
        4,
        21
      ],
      [
        -1,
        19
      ],
      [
        11,
        43
      ],
      [
        6,
        5
      ],
      [
        2,
        29
      ],
      [
        4,
        11
      ],
      [
        -3,
        12
      ],
      [
        -1,
        21
      ],
      [
        -6,
        16
      ],
      [
        -5,
        21
      ],
      [
        -4,
        9
      ],
      [
        -2,
        18
      ],
      [
        -8,
        24
      ],
      [
        -2,
        17
      ],
      [
        -5,
        31
      ],
      [
        0,
        13
      ],
      [
        -4,
        13
      ]
    ],
    [
      [
        26055,
        62866
      ],
      [
        92,
        0
      ]
    ],
    [
      [
        26147,
        62651
      ],
      [
        -5,
        -11
      ],
      [
        -33,
        -70
      ],
      [
        -2,
        -4
      ]
    ],
    [
      [
        26039,
        62491
      ],
      [
        0,
        255
      ]
    ],
    [
      [
        24257,
        66887
      ],
      [
        0,
        204
      ]
    ],
    [
      [
        24257,
        67091
      ],
      [
        133,
        -1
      ]
    ],
    [
      [
        24390,
        67090
      ],
      [
        0,
        -103
      ],
      [
        -1,
        -200
      ],
      [
        0,
        -207
      ]
    ],
    [
      [
        23904,
        65671
      ],
      [
        33,
        0
      ]
    ],
    [
      [
        26453,
        60619
      ],
      [
        8,
        40
      ],
      [
        8,
        9
      ],
      [
        14,
        2
      ]
    ],
    [
      [
        26483,
        60670
      ],
      [
        13,
        -4
      ],
      [
        22,
        21
      ],
      [
        7,
        -9
      ],
      [
        10,
        -36
      ]
    ],
    [
      [
        26569,
        60416
      ],
      [
        0,
        -16
      ],
      [
        -11,
        -4
      ],
      [
        -11,
        -29
      ],
      [
        -5,
        1
      ],
      [
        1,
        -15
      ],
      [
        -6,
        -32
      ],
      [
        -1,
        -15
      ],
      [
        -6,
        9
      ],
      [
        -6,
        -13
      ]
    ],
    [
      [
        26524,
        60302
      ],
      [
        -17,
        3
      ],
      [
        -12,
        17
      ],
      [
        0,
        16
      ],
      [
        -8,
        7
      ],
      [
        -8,
        24
      ],
      [
        0,
        22
      ],
      [
        -4,
        10
      ],
      [
        -5,
        -18
      ]
    ],
    [
      [
        26470,
        60383
      ],
      [
        -1,
        38
      ],
      [
        4,
        6
      ],
      [
        -12,
        32
      ],
      [
        3,
        38
      ],
      [
        -3,
        10
      ],
      [
        -5,
        35
      ],
      [
        -4,
        34
      ],
      [
        -1,
        20
      ],
      [
        2,
        23
      ]
    ],
    [
      [
        24434,
        54868
      ],
      [
        6,
        20
      ],
      [
        8,
        12
      ],
      [
        -2,
        20
      ],
      [
        2,
        16
      ],
      [
        -2,
        33
      ],
      [
        1,
        28
      ],
      [
        7,
        -4
      ],
      [
        -1,
        19
      ],
      [
        9,
        59
      ],
      [
        2,
        76
      ],
      [
        -2,
        1
      ],
      [
        2,
        46
      ],
      [
        3,
        12
      ],
      [
        2,
        -10
      ],
      [
        3,
        30
      ],
      [
        0,
        54
      ],
      [
        8,
        17
      ],
      [
        4,
        28
      ],
      [
        1,
        35
      ]
    ],
    [
      [
        24485,
        55360
      ],
      [
        27,
        -1
      ]
    ],
    [
      [
        24512,
        55359
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -12
      ],
      [
        -1,
        -7
      ],
      [
        -2,
        -9
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        -13
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -7
      ],
      [
        1,
        -3
      ],
      [
        -2,
        -10
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -19
      ],
      [
        1,
        -5
      ],
      [
        3,
        -8
      ],
      [
        1,
        -2
      ],
      [
        4,
        -7
      ],
      [
        2,
        -1
      ],
      [
        1,
        -1
      ],
      [
        3,
        1
      ],
      [
        2,
        2
      ],
      [
        2,
        4
      ],
      [
        3,
        14
      ],
      [
        1,
        7
      ],
      [
        0,
        8
      ],
      [
        -1,
        19
      ],
      [
        -1,
        7
      ],
      [
        0,
        6
      ],
      [
        1,
        2
      ],
      [
        1,
        2
      ],
      [
        0,
        3
      ],
      [
        -1,
        3
      ],
      [
        -1,
        4
      ],
      [
        0,
        2
      ],
      [
        1,
        10
      ],
      [
        0,
        1
      ],
      [
        3,
        4
      ],
      [
        3,
        5
      ],
      [
        2,
        0
      ],
      [
        2,
        -3
      ],
      [
        1,
        -2
      ],
      [
        1,
        -4
      ],
      [
        1,
        -5
      ],
      [
        2,
        -16
      ],
      [
        0,
        -16
      ],
      [
        -1,
        -1
      ],
      [
        1,
        -4
      ],
      [
        0,
        -2
      ],
      [
        2,
        -6
      ],
      [
        1,
        -2
      ],
      [
        1,
        -11
      ],
      [
        1,
        -5
      ],
      [
        -1,
        -7
      ],
      [
        1,
        -12
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -11
      ],
      [
        0,
        -3
      ],
      [
        -5,
        -18
      ],
      [
        -5,
        -18
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -3,
        -7
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -13
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -11
      ],
      [
        0,
        -31
      ],
      [
        1,
        -6
      ],
      [
        1,
        -1
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -16
      ],
      [
        0,
        -12
      ],
      [
        1,
        -5
      ],
      [
        1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        2,
        0
      ],
      [
        5,
        1
      ],
      [
        2,
        0
      ],
      [
        3,
        -4
      ],
      [
        6,
        -4
      ],
      [
        4,
        -4
      ],
      [
        4,
        -6
      ],
      [
        2,
        -2
      ],
      [
        0,
        -15
      ],
      [
        -2,
        -12
      ],
      [
        -4,
        -10
      ],
      [
        -1,
        -3
      ],
      [
        -5,
        -7
      ],
      [
        -2,
        -3
      ],
      [
        -4,
        -10
      ],
      [
        -2,
        -10
      ],
      [
        -1,
        -8
      ],
      [
        -2,
        -10
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -30
      ],
      [
        2,
        -14
      ],
      [
        0,
        -4
      ],
      [
        1,
        -4
      ],
      [
        2,
        -6
      ],
      [
        2,
        -6
      ],
      [
        1,
        -2
      ],
      [
        1,
        0
      ],
      [
        2,
        6
      ],
      [
        2,
        1
      ],
      [
        5,
        7
      ],
      [
        2,
        4
      ],
      [
        5,
        6
      ],
      [
        4,
        2
      ],
      [
        0,
        7
      ],
      [
        1,
        9
      ],
      [
        1,
        5
      ],
      [
        0,
        8
      ],
      [
        1,
        5
      ],
      [
        2,
        9
      ],
      [
        1,
        3
      ],
      [
        2,
        -3
      ],
      [
        1,
        -4
      ],
      [
        3,
        -11
      ],
      [
        0,
        -8
      ],
      [
        1,
        -2
      ],
      [
        0,
        -9
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -9
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -6
      ],
      [
        -2,
        -10
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -4
      ]
    ],
    [
      [
        24539,
        54845
      ],
      [
        -11,
        0
      ],
      [
        -7,
        -29
      ],
      [
        -90,
        0
      ]
    ],
    [
      [
        24431,
        54816
      ],
      [
        7,
        27
      ],
      [
        -4,
        25
      ]
    ],
    [
      [
        24200,
        52034
      ],
      [
        2,
        -7
      ],
      [
        15,
        -6
      ],
      [
        6,
        7
      ],
      [
        9,
        -14
      ],
      [
        12,
        -17
      ],
      [
        2,
        7
      ],
      [
        9,
        7
      ],
      [
        5,
        -55
      ],
      [
        1,
        -8
      ],
      [
        12,
        -18
      ],
      [
        17,
        -25
      ]
    ],
    [
      [
        24290,
        51905
      ],
      [
        -5,
        -54
      ],
      [
        -3,
        -7
      ],
      [
        6,
        -176
      ]
    ],
    [
      [
        24288,
        51668
      ],
      [
        -3,
        -9
      ],
      [
        0,
        -16
      ],
      [
        1,
        -14
      ],
      [
        -8,
        -10
      ],
      [
        -16,
        -26
      ],
      [
        -14,
        -34
      ],
      [
        -3,
        16
      ],
      [
        -3,
        16
      ],
      [
        -4,
        -5
      ],
      [
        -7,
        -4
      ],
      [
        1,
        -23
      ],
      [
        -8,
        16
      ],
      [
        -2,
        -11
      ],
      [
        2,
        -21
      ],
      [
        9,
        -30
      ],
      [
        5,
        -6
      ],
      [
        9,
        4
      ],
      [
        4,
        -6
      ],
      [
        -9,
        -30
      ],
      [
        3,
        -28
      ],
      [
        5,
        -35
      ],
      [
        4,
        7
      ],
      [
        9,
        3
      ],
      [
        7,
        11
      ],
      [
        5,
        -18
      ],
      [
        -9,
        -2
      ],
      [
        -4,
        -12
      ],
      [
        4,
        -13
      ],
      [
        2,
        -7
      ],
      [
        -6,
        -1
      ],
      [
        -12,
        0
      ],
      [
        -14,
        -5
      ],
      [
        -15,
        -22
      ],
      [
        -11,
        -27
      ],
      [
        -8,
        -7
      ],
      [
        -12,
        -2
      ],
      [
        -12,
        9
      ],
      [
        -12,
        9
      ],
      [
        -18,
        16
      ],
      [
        -18,
        15
      ],
      [
        -8,
        4
      ],
      [
        -14,
        10
      ]
    ],
    [
      [
        24108,
        51380
      ],
      [
        1,
        219
      ],
      [
        -1,
        307
      ],
      [
        -34,
        -1
      ]
    ],
    [
      [
        24074,
        51905
      ],
      [
        4,
        14
      ],
      [
        11,
        12
      ],
      [
        9,
        23
      ],
      [
        4,
        -8
      ],
      [
        4,
        23
      ]
    ],
    [
      [
        24104,
        52430
      ],
      [
        5,
        23
      ],
      [
        -3,
        12
      ],
      [
        5,
        13
      ],
      [
        6,
        44
      ],
      [
        -4,
        20
      ],
      [
        0,
        363
      ]
    ],
    [
      [
        24113,
        52905
      ],
      [
        10,
        2
      ],
      [
        4,
        6
      ],
      [
        11,
        -8
      ],
      [
        3,
        5
      ],
      [
        5,
        21
      ],
      [
        0,
        39
      ],
      [
        6,
        5
      ],
      [
        6,
        16
      ],
      [
        5,
        6
      ],
      [
        3,
        20
      ],
      [
        8,
        9
      ],
      [
        11,
        -21
      ],
      [
        3,
        -22
      ],
      [
        14,
        2
      ]
    ],
    [
      [
        24202,
        52985
      ],
      [
        0,
        -33
      ],
      [
        11,
        -51
      ],
      [
        1,
        -52
      ],
      [
        7,
        1
      ]
    ],
    [
      [
        24221,
        52850
      ],
      [
        0,
        -65
      ],
      [
        1,
        -10
      ],
      [
        10,
        -19
      ],
      [
        0,
        -110
      ],
      [
        -6,
        -16
      ],
      [
        -5,
        -54
      ],
      [
        0,
        -53
      ],
      [
        -14,
        0
      ],
      [
        0,
        -34
      ],
      [
        -43,
        0
      ],
      [
        -9,
        -5
      ],
      [
        -3,
        -7
      ],
      [
        -2,
        -38
      ],
      [
        -8,
        -18
      ]
    ],
    [
      [
        24104,
        52422
      ],
      [
        0,
        8
      ]
    ],
    [
      [
        23554,
        63548
      ],
      [
        77,
        0
      ],
      [
        31,
        -5
      ]
    ],
    [
      [
        23555,
        63208
      ],
      [
        0,
        85
      ]
    ],
    [
      [
        23555,
        63293
      ],
      [
        -1,
        255
      ]
    ],
    [
      [
        24568,
        61812
      ],
      [
        12,
        -16
      ],
      [
        8,
        8
      ],
      [
        12,
        25
      ],
      [
        11,
        27
      ],
      [
        10,
        11
      ],
      [
        5,
        19
      ],
      [
        2,
        16
      ],
      [
        2,
        11
      ],
      [
        3,
        6
      ]
    ],
    [
      [
        24633,
        61919
      ],
      [
        0,
        -105
      ],
      [
        -1,
        -84
      ],
      [
        0,
        -12
      ]
    ],
    [
      [
        24632,
        61718
      ],
      [
        0,
        -60
      ],
      [
        -4,
        -67
      ],
      [
        -2,
        -32
      ],
      [
        -2,
        -40
      ],
      [
        -4,
        -107
      ]
    ],
    [
      [
        24532,
        61412
      ],
      [
        -76,
        0
      ],
      [
        0,
        7
      ]
    ],
    [
      [
        24456,
        61419
      ],
      [
        1,
        130
      ],
      [
        -1,
        11
      ],
      [
        0,
        429
      ]
    ],
    [
      [
        23036,
        64111
      ],
      [
        111,
        1
      ]
    ],
    [
      [
        23147,
        64112
      ],
      [
        0,
        -304
      ]
    ],
    [
      [
        23036,
        63808
      ],
      [
        0,
        303
      ]
    ],
    [
      [
        22396,
        65934
      ],
      [
        128,
        0
      ]
    ],
    [
      [
        22526,
        65732
      ],
      [
        0,
        -203
      ]
    ],
    [
      [
        19902,
        55909
      ],
      [
        86,
        1
      ],
      [
        259,
        -2
      ],
      [
        2,
        5
      ],
      [
        26,
        0
      ]
    ],
    [
      [
        20275,
        55913
      ],
      [
        1,
        -104
      ],
      [
        7,
        0
      ]
    ],
    [
      [
        20283,
        55809
      ],
      [
        1,
        -320
      ],
      [
        0,
        -73
      ]
    ],
    [
      [
        20284,
        55416
      ],
      [
        -152,
        -268
      ],
      [
        0,
        -51
      ],
      [
        -14,
        0
      ],
      [
        -90,
        1
      ],
      [
        -11,
        0
      ],
      [
        0,
        -203
      ]
    ],
    [
      [
        19822,
        55588
      ],
      [
        0,
        323
      ],
      [
        9,
        0
      ],
      [
        8,
        -5
      ],
      [
        63,
        3
      ]
    ],
    [
      [
        28234,
        58112
      ],
      [
        8,
        -2
      ],
      [
        10,
        5
      ],
      [
        13,
        6
      ],
      [
        5,
        -34
      ],
      [
        11,
        7
      ],
      [
        8,
        29
      ],
      [
        6,
        -6
      ],
      [
        15,
        29
      ],
      [
        2,
        19
      ],
      [
        6,
        8
      ],
      [
        2,
        -10
      ],
      [
        5,
        2
      ],
      [
        1,
        14
      ]
    ],
    [
      [
        28326,
        58179
      ],
      [
        2,
        -8
      ],
      [
        2,
        -23
      ],
      [
        3,
        -7
      ],
      [
        1,
        -26
      ],
      [
        5,
        -10
      ],
      [
        1,
        -16
      ],
      [
        5,
        5
      ],
      [
        5,
        -10
      ],
      [
        0,
        -6
      ]
    ],
    [
      [
        28350,
        58078
      ],
      [
        -1,
        3
      ],
      [
        -5,
        -5
      ],
      [
        1,
        -7
      ],
      [
        -6,
        -3
      ],
      [
        0,
        -19
      ],
      [
        -5,
        -13
      ],
      [
        6,
        -46
      ],
      [
        -1,
        -13
      ],
      [
        -9,
        -14
      ],
      [
        -3,
        -12
      ]
    ],
    [
      [
        28327,
        57949
      ],
      [
        -9,
        10
      ],
      [
        -6,
        6
      ],
      [
        6,
        -82
      ],
      [
        -27,
        -118
      ],
      [
        -36,
        -73
      ]
    ],
    [
      [
        28255,
        57692
      ],
      [
        -4,
        16
      ],
      [
        -1,
        101
      ],
      [
        -5,
        43
      ],
      [
        -19,
        37
      ]
    ],
    [
      [
        28226,
        57889
      ],
      [
        2,
        120
      ],
      [
        1,
        74
      ],
      [
        2,
        15
      ],
      [
        3,
        14
      ]
    ],
    [
      [
        27152,
        58358
      ],
      [
        0,
        5
      ],
      [
        5,
        -19
      ],
      [
        7,
        -8
      ],
      [
        11,
        6
      ],
      [
        12,
        -10
      ],
      [
        8,
        7
      ]
    ],
    [
      [
        27195,
        58339
      ],
      [
        6,
        -7
      ],
      [
        1,
        -41
      ],
      [
        8,
        -60
      ],
      [
        7,
        -55
      ],
      [
        1,
        -5
      ]
    ],
    [
      [
        27218,
        58171
      ],
      [
        15,
        -78
      ],
      [
        9,
        -19
      ],
      [
        3,
        -7
      ],
      [
        -3,
        -20
      ],
      [
        4,
        -42
      ],
      [
        9,
        -20
      ],
      [
        -1,
        -82
      ],
      [
        -1,
        -30
      ]
    ],
    [
      [
        27253,
        57873
      ],
      [
        -11,
        1
      ]
    ],
    [
      [
        27242,
        57874
      ],
      [
        -22,
        4
      ],
      [
        -2,
        0
      ],
      [
        -2,
        1
      ],
      [
        -9,
        1
      ],
      [
        -14,
        2
      ],
      [
        -11,
        2
      ],
      [
        -9,
        1
      ],
      [
        -9,
        2
      ],
      [
        -9,
        2
      ],
      [
        -10,
        2
      ],
      [
        -6,
        0
      ],
      [
        -9,
        1
      ]
    ],
    [
      [
        27130,
        57892
      ],
      [
        3,
        49
      ],
      [
        16,
        157
      ],
      [
        3,
        260
      ]
    ],
    [
      [
        20922,
        65124
      ],
      [
        167,
        1
      ],
      [
        21,
        1
      ]
    ],
    [
      [
        21110,
        65126
      ],
      [
        0,
        -404
      ],
      [
        -1,
        -53
      ]
    ],
    [
      [
        21109,
        64669
      ],
      [
        -4,
        1
      ],
      [
        -7,
        -1
      ],
      [
        -43,
        0
      ]
    ],
    [
      [
        21055,
        64669
      ],
      [
        -90,
        0
      ],
      [
        -2,
        -1
      ],
      [
        -14,
        1
      ],
      [
        -5,
        -1
      ],
      [
        0,
        1
      ],
      [
        -14,
        0
      ],
      [
        -4,
        -1
      ],
      [
        -4,
        0
      ]
    ],
    [
      [
        20922,
        64668
      ],
      [
        0,
        456
      ]
    ],
    [
      [
        23232,
        59036
      ],
      [
        10,
        0
      ],
      [
        1,
        -1
      ],
      [
        14,
        0
      ],
      [
        14,
        1
      ],
      [
        5,
        -34
      ],
      [
        10,
        -5
      ],
      [
        0,
        -26
      ],
      [
        4,
        -18
      ],
      [
        -5,
        -19
      ],
      [
        36,
        0
      ]
    ],
    [
      [
        23321,
        58934
      ],
      [
        21,
        0
      ],
      [
        44,
        -1
      ]
    ],
    [
      [
        23370,
        58629
      ],
      [
        -16,
        0
      ],
      [
        -11,
        11
      ],
      [
        -16,
        -27
      ],
      [
        -16,
        5
      ],
      [
        -11,
        -13
      ],
      [
        -11,
        -5
      ],
      [
        -2,
        -1
      ],
      [
        -5,
        -21
      ],
      [
        -2,
        -5
      ],
      [
        -4,
        15
      ],
      [
        -5,
        0
      ],
      [
        -5,
        11
      ],
      [
        0,
        55
      ],
      [
        -3,
        26
      ],
      [
        -32,
        -1
      ]
    ],
    [
      [
        23231,
        58679
      ],
      [
        -15,
        0
      ]
    ],
    [
      [
        23216,
        58679
      ],
      [
        0,
        52
      ],
      [
        16,
        0
      ],
      [
        0,
        305
      ]
    ],
    [
      [
        22700,
        58121
      ],
      [
        46,
        0
      ],
      [
        8,
        1
      ],
      [
        5,
        0
      ],
      [
        5,
        -1
      ],
      [
        5,
        1
      ],
      [
        29,
        -1
      ],
      [
        5,
        1
      ],
      [
        44,
        -1
      ]
    ],
    [
      [
        22847,
        58121
      ],
      [
        0,
        -522
      ]
    ],
    [
      [
        22847,
        57599
      ],
      [
        -3,
        3
      ],
      [
        -12,
        -3
      ],
      [
        -1,
        13
      ],
      [
        -5,
        5
      ],
      [
        -3,
        -14
      ],
      [
        -1,
        12
      ],
      [
        -8,
        4
      ],
      [
        -4,
        20
      ],
      [
        -7,
        2
      ],
      [
        -2,
        -12
      ],
      [
        -9,
        11
      ],
      [
        0,
        31
      ],
      [
        -5,
        51
      ],
      [
        2,
        20
      ],
      [
        -1,
        30
      ],
      [
        -4,
        10
      ],
      [
        -9,
        1
      ],
      [
        0,
        36
      ],
      [
        -2,
        24
      ],
      [
        -8,
        10
      ],
      [
        -2,
        16
      ],
      [
        -19,
        48
      ],
      [
        -8,
        15
      ],
      [
        -6,
        23
      ],
      [
        -1,
        15
      ],
      [
        3,
        17
      ],
      [
        -1,
        34
      ],
      [
        -6,
        13
      ],
      [
        -5,
        1
      ],
      [
        -5,
        3
      ],
      [
        -10,
        32
      ],
      [
        -5,
        5
      ]
    ],
    [
      [
        22700,
        58075
      ],
      [
        0,
        46
      ]
    ],
    [
      [
        22789,
        57108
      ],
      [
        58,
        0
      ],
      [
        -2,
        6
      ],
      [
        -1,
        6
      ],
      [
        3,
        5
      ],
      [
        -6,
        11
      ],
      [
        2,
        24
      ],
      [
        -5,
        23
      ],
      [
        2,
        20
      ],
      [
        -6,
        9
      ],
      [
        -3,
        31
      ],
      [
        16,
        0
      ],
      [
        0,
        17
      ],
      [
        59,
        0
      ]
    ],
    [
      [
        22906,
        57260
      ],
      [
        0,
        -51
      ],
      [
        29,
        0
      ],
      [
        0,
        -102
      ]
    ],
    [
      [
        22935,
        57107
      ],
      [
        -15,
        0
      ],
      [
        0,
        -201
      ],
      [
        -15,
        -1
      ]
    ],
    [
      [
        27582,
        64288
      ],
      [
        43,
        -1
      ],
      [
        8,
        -2
      ],
      [
        11,
        1
      ],
      [
        39,
        -2
      ],
      [
        15,
        -2
      ],
      [
        11,
        0
      ]
    ],
    [
      [
        27709,
        64282
      ],
      [
        1,
        -31
      ],
      [
        -7,
        -27
      ],
      [
        -2,
        -14
      ],
      [
        -8,
        -10
      ],
      [
        -4,
        -7
      ],
      [
        -2,
        -11
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -13
      ],
      [
        1,
        -8
      ],
      [
        1,
        -14
      ],
      [
        0,
        -1
      ],
      [
        8,
        -1
      ],
      [
        4,
        -8
      ],
      [
        6,
        -20
      ],
      [
        0,
        -42
      ],
      [
        -1,
        -64
      ],
      [
        -6,
        -25
      ],
      [
        1,
        -4
      ],
      [
        -3,
        -13
      ],
      [
        -2,
        -1
      ],
      [
        -6,
        -5
      ],
      [
        -3,
        -39
      ],
      [
        -3,
        -51
      ],
      [
        -1,
        -21
      ],
      [
        4,
        -11
      ],
      [
        -6,
        -7
      ],
      [
        2,
        -24
      ],
      [
        -5,
        -33
      ],
      [
        7,
        -6
      ],
      [
        -25,
        -36
      ]
    ],
    [
      [
        27659,
        63732
      ],
      [
        -7,
        -3
      ],
      [
        -18,
        25
      ],
      [
        -3,
        19
      ],
      [
        16,
        24
      ],
      [
        -33,
        41
      ],
      [
        -12,
        14
      ],
      [
        -11,
        14
      ],
      [
        -19,
        24
      ],
      [
        -14,
        50
      ],
      [
        -35,
        119
      ]
    ],
    [
      [
        27107,
        57210
      ],
      [
        4,
        61
      ],
      [
        4,
        39
      ],
      [
        11,
        183
      ],
      [
        12,
        52
      ],
      [
        8,
        36
      ]
    ],
    [
      [
        27146,
        57581
      ],
      [
        8,
        0
      ],
      [
        6,
        -17
      ],
      [
        4,
        2
      ],
      [
        2,
        -22
      ],
      [
        8,
        -6
      ],
      [
        7,
        13
      ],
      [
        12,
        -20
      ],
      [
        8,
        8
      ],
      [
        9,
        -12
      ],
      [
        7,
        -32
      ]
    ],
    [
      [
        27217,
        57495
      ],
      [
        -1,
        -9
      ],
      [
        -5,
        -11
      ]
    ],
    [
      [
        27227,
        57184
      ],
      [
        1,
        -6
      ],
      [
        -3,
        -43
      ],
      [
        2,
        -41
      ]
    ],
    [
      [
        27227,
        57094
      ],
      [
        -6,
        1
      ],
      [
        -4,
        -10
      ],
      [
        -3,
        8
      ],
      [
        -5,
        -4
      ],
      [
        -15,
        -53
      ],
      [
        -5,
        22
      ],
      [
        1,
        15
      ],
      [
        -10,
        24
      ],
      [
        -8,
        33
      ],
      [
        -2,
        -4
      ],
      [
        -5,
        13
      ]
    ],
    [
      [
        27165,
        57139
      ],
      [
        -9,
        29
      ],
      [
        -11,
        -5
      ],
      [
        0,
        -3
      ],
      [
        -9,
        20
      ],
      [
        -14,
        7
      ],
      [
        -12,
        30
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        21904,
        68796
      ],
      [
        237,
        1
      ]
    ],
    [
      [
        22068,
        68386
      ],
      [
        1,
        13
      ],
      [
        8,
        23
      ],
      [
        4,
        18
      ],
      [
        -3,
        20
      ],
      [
        -6,
        9
      ],
      [
        -10,
        -2
      ],
      [
        -7,
        4
      ],
      [
        -8,
        15
      ],
      [
        -7,
        6
      ],
      [
        -13,
        26
      ],
      [
        -22,
        19
      ],
      [
        -8,
        -3
      ],
      [
        -11,
        4
      ],
      [
        -29,
        20
      ],
      [
        -8,
        15
      ],
      [
        -2,
        32
      ],
      [
        -4,
        66
      ],
      [
        -6,
        21
      ],
      [
        -18,
        3
      ],
      [
        -17,
        -19
      ],
      [
        -5,
        1
      ],
      [
        -8,
        19
      ],
      [
        2,
        35
      ],
      [
        6,
        20
      ],
      [
        6,
        8
      ],
      [
        4,
        22
      ],
      [
        -3,
        15
      ]
    ],
    [
      [
        26426,
        59947
      ],
      [
        9,
        20
      ],
      [
        2,
        12
      ],
      [
        0,
        -22
      ],
      [
        3,
        -8
      ],
      [
        3,
        -7
      ],
      [
        4,
        22
      ],
      [
        3,
        -15
      ],
      [
        6,
        1
      ],
      [
        2,
        -10
      ],
      [
        6,
        10
      ],
      [
        7,
        24
      ],
      [
        3,
        2
      ],
      [
        6,
        -19
      ],
      [
        3,
        2
      ]
    ],
    [
      [
        26483,
        59959
      ],
      [
        3,
        -34
      ],
      [
        -1,
        -25
      ],
      [
        4,
        -17
      ],
      [
        1,
        -42
      ],
      [
        4,
        1
      ],
      [
        4,
        -8
      ],
      [
        -2,
        -10
      ],
      [
        5,
        -25
      ],
      [
        8,
        -8
      ],
      [
        0,
        -12
      ],
      [
        4,
        0
      ],
      [
        2,
        -26
      ],
      [
        -3,
        -23
      ],
      [
        5,
        2
      ],
      [
        3,
        -13
      ],
      [
        0,
        -26
      ],
      [
        23,
        -47
      ]
    ],
    [
      [
        26543,
        59646
      ],
      [
        -1,
        -8
      ],
      [
        -21,
        -40
      ],
      [
        9,
        -50
      ],
      [
        -2,
        -18
      ]
    ],
    [
      [
        26528,
        59530
      ],
      [
        -16,
        3
      ]
    ],
    [
      [
        26512,
        59533
      ],
      [
        -39,
        2
      ],
      [
        -28,
        1
      ]
    ],
    [
      [
        26445,
        59536
      ],
      [
        -3,
        24
      ],
      [
        -9,
        24
      ],
      [
        -10,
        50
      ],
      [
        -3,
        39
      ],
      [
        -1,
        57
      ],
      [
        -3,
        1
      ],
      [
        -1,
        17
      ],
      [
        -4,
        7
      ],
      [
        1,
        28
      ],
      [
        -3,
        7
      ],
      [
        3,
        13
      ],
      [
        8,
        13
      ],
      [
        -7,
        5
      ],
      [
        8,
        26
      ],
      [
        -3,
        13
      ],
      [
        3,
        9
      ],
      [
        -2,
        14
      ],
      [
        2,
        17
      ],
      [
        3,
        9
      ],
      [
        -2,
        23
      ],
      [
        4,
        15
      ]
    ],
    [
      [
        26809,
        58022
      ],
      [
        13,
        27
      ],
      [
        12,
        4
      ],
      [
        5,
        30
      ],
      [
        3,
        4
      ],
      [
        4,
        39
      ],
      [
        4,
        14
      ],
      [
        8,
        16
      ],
      [
        0,
        19
      ]
    ],
    [
      [
        26858,
        58175
      ],
      [
        28,
        -110
      ],
      [
        7,
        -29
      ],
      [
        3,
        -18
      ],
      [
        -2,
        -33
      ],
      [
        4,
        -1
      ],
      [
        0,
        -44
      ],
      [
        3,
        -66
      ],
      [
        5,
        -24
      ]
    ],
    [
      [
        26853,
        57762
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        3
      ],
      [
        0,
        3
      ],
      [
        1,
        1
      ],
      [
        0,
        8
      ],
      [
        1,
        5
      ],
      [
        -1,
        3
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -2,
        -1
      ],
      [
        -6,
        -7
      ],
      [
        -24,
        -26
      ]
    ],
    [
      [
        26816,
        57748
      ],
      [
        -29,
        -31
      ],
      [
        -2,
        -3
      ]
    ],
    [
      [
        26785,
        57714
      ],
      [
        -7,
        12
      ],
      [
        -2,
        12
      ],
      [
        -5,
        7
      ],
      [
        4,
        27
      ],
      [
        6,
        22
      ],
      [
        11,
        42
      ],
      [
        1,
        19
      ],
      [
        -4,
        6
      ],
      [
        -1,
        12
      ],
      [
        4,
        4
      ],
      [
        -1,
        24
      ],
      [
        5,
        8
      ],
      [
        2,
        24
      ],
      [
        7,
        11
      ],
      [
        3,
        15
      ],
      [
        2,
        39
      ],
      [
        -1,
        24
      ]
    ],
    [
      [
        28350,
        58078
      ],
      [
        11,
        -13
      ],
      [
        16,
        59
      ],
      [
        4,
        -4
      ],
      [
        5,
        -28
      ],
      [
        6,
        10
      ],
      [
        0,
        24
      ],
      [
        4,
        22
      ],
      [
        6,
        -2
      ],
      [
        4,
        23
      ]
    ],
    [
      [
        28406,
        58169
      ],
      [
        64,
        -136
      ],
      [
        18,
        -55
      ]
    ],
    [
      [
        28488,
        57978
      ],
      [
        -3,
        -21
      ],
      [
        -7,
        -7
      ],
      [
        -3,
        -19
      ],
      [
        -6,
        -18
      ],
      [
        -2,
        -40
      ],
      [
        -5,
        -11
      ],
      [
        6,
        -29
      ],
      [
        10,
        -14
      ],
      [
        -2,
        -32
      ],
      [
        1,
        -33
      ],
      [
        -2,
        -10
      ],
      [
        -5,
        -6
      ]
    ],
    [
      [
        28470,
        57738
      ],
      [
        -6,
        15
      ],
      [
        -2,
        -18
      ],
      [
        3,
        -47
      ],
      [
        24,
        -55
      ],
      [
        36,
        -43
      ],
      [
        22,
        49
      ]
    ],
    [
      [
        28547,
        57639
      ],
      [
        0,
        -1
      ],
      [
        9,
        -28
      ],
      [
        -3,
        -30
      ],
      [
        -6,
        -15
      ],
      [
        -3,
        -35
      ],
      [
        -18,
        -27
      ],
      [
        -35,
        -1
      ],
      [
        1,
        -10
      ],
      [
        -21,
        -14
      ],
      [
        1,
        -18
      ],
      [
        -35,
        3
      ]
    ],
    [
      [
        28437,
        57463
      ],
      [
        9,
        29
      ],
      [
        -17,
        -7
      ],
      [
        1,
        217
      ],
      [
        1,
        12
      ],
      [
        -3,
        23
      ],
      [
        -1,
        30
      ],
      [
        -4,
        0
      ],
      [
        -5,
        -21
      ],
      [
        -5,
        12
      ],
      [
        -4,
        -11
      ],
      [
        -3,
        13
      ],
      [
        1,
        17
      ],
      [
        -40,
        80
      ],
      [
        -34,
        80
      ],
      [
        -6,
        12
      ]
    ],
    [
      [
        22054,
        55308
      ],
      [
        105,
        -4
      ]
    ],
    [
      [
        26881,
        59918
      ],
      [
        3,
        13
      ],
      [
        5,
        24
      ],
      [
        7,
        2
      ],
      [
        3,
        5
      ],
      [
        3,
        -9
      ],
      [
        -1,
        -18
      ],
      [
        -6,
        -1
      ],
      [
        -2,
        -8
      ],
      [
        2,
        -26
      ],
      [
        -7,
        1
      ],
      [
        -2,
        -7
      ],
      [
        0,
        18
      ],
      [
        -5,
        4
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        26976,
        62371
      ],
      [
        4,
        207
      ],
      [
        11,
        -2
      ]
    ],
    [
      [
        26991,
        62576
      ],
      [
        86,
        -18
      ],
      [
        57,
        -9
      ]
    ],
    [
      [
        27134,
        62549
      ],
      [
        0,
        -11
      ],
      [
        3,
        -27
      ],
      [
        0,
        -25
      ],
      [
        1,
        -11
      ],
      [
        -1,
        -12
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -3
      ]
    ],
    [
      [
        27136,
        62450
      ],
      [
        -1,
        -7
      ],
      [
        -2,
        -7
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -2,
        1
      ],
      [
        -2,
        4
      ],
      [
        -1,
        1
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -26
      ],
      [
        1,
        -5
      ],
      [
        2,
        -9
      ],
      [
        0,
        -3
      ],
      [
        2,
        -5
      ],
      [
        2,
        -5
      ],
      [
        4,
        -12
      ],
      [
        2,
        -7
      ],
      [
        1,
        -6
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        -2,
        -4
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -11
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -20
      ],
      [
        2,
        -5
      ],
      [
        1,
        -3
      ],
      [
        4,
        -14
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -2,
        2
      ],
      [
        -1,
        2
      ],
      [
        -3,
        4
      ],
      [
        0,
        3
      ],
      [
        -3,
        11
      ],
      [
        -2,
        5
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -8
      ],
      [
        -2,
        -9
      ],
      [
        0,
        -22
      ],
      [
        -1,
        -10
      ],
      [
        -2,
        -10
      ],
      [
        -1,
        -3
      ],
      [
        -4,
        -11
      ],
      [
        -4,
        -8
      ],
      [
        -1,
        0
      ],
      [
        -2,
        1
      ],
      [
        -3,
        4
      ]
    ],
    [
      [
        27091,
        62197
      ],
      [
        0,
        1
      ],
      [
        -2,
        6
      ],
      [
        -3,
        8
      ],
      [
        0,
        12
      ],
      [
        2,
        8
      ],
      [
        1,
        3
      ],
      [
        1,
        5
      ],
      [
        1,
        2
      ],
      [
        2,
        8
      ],
      [
        1,
        2
      ],
      [
        0,
        14
      ],
      [
        -2,
        9
      ],
      [
        -2,
        10
      ],
      [
        -1,
        15
      ],
      [
        -3,
        12
      ],
      [
        -2,
        12
      ],
      [
        -1,
        3
      ],
      [
        -1,
        4
      ],
      [
        -3,
        3
      ],
      [
        -2,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        9
      ],
      [
        -1,
        4
      ],
      [
        -1,
        8
      ],
      [
        -1,
        7
      ],
      [
        -1,
        5
      ],
      [
        -2,
        6
      ],
      [
        -1,
        2
      ],
      [
        -3,
        1
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -16
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -6
      ],
      [
        -3,
        -4
      ],
      [
        -3,
        -6
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -7
      ]
    ],
    [
      [
        27038,
        62290
      ],
      [
        1,
        52
      ],
      [
        -63,
        12
      ],
      [
        0,
        17
      ]
    ],
    [
      [
        26906,
        62158
      ],
      [
        0,
        10
      ],
      [
        33,
        -10
      ],
      [
        6,
        221
      ]
    ],
    [
      [
        26945,
        62379
      ],
      [
        31,
        -8
      ]
    ],
    [
      [
        27038,
        62290
      ],
      [
        0,
        -3
      ],
      [
        -3,
        -12
      ],
      [
        0,
        -15
      ],
      [
        -3,
        -13
      ],
      [
        -2,
        -13
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -9
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -9
      ],
      [
        1,
        -8
      ],
      [
        1,
        -3
      ],
      [
        0,
        -11
      ],
      [
        -1,
        -15
      ],
      [
        0,
        -13
      ],
      [
        -1,
        -4
      ],
      [
        -4,
        -15
      ],
      [
        -1,
        -2
      ],
      [
        -4,
        -6
      ],
      [
        -3,
        -3
      ],
      [
        -3,
        -7
      ],
      [
        -2,
        -7
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -10
      ],
      [
        0,
        -16
      ],
      [
        2,
        -6
      ],
      [
        2,
        -5
      ],
      [
        2,
        -4
      ],
      [
        0,
        -3
      ],
      [
        1,
        -7
      ],
      [
        1,
        -13
      ],
      [
        1,
        -4
      ],
      [
        0,
        -4
      ],
      [
        1,
        -13
      ],
      [
        0,
        -8
      ],
      [
        1,
        -8
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -13
      ],
      [
        0,
        -8
      ],
      [
        1,
        -9
      ],
      [
        0,
        -16
      ],
      [
        2,
        -12
      ],
      [
        1,
        -7
      ],
      [
        0,
        -11
      ],
      [
        1,
        -5
      ],
      [
        0,
        -12
      ],
      [
        -1,
        -12
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        -2
      ],
      [
        -4,
        0
      ]
    ],
    [
      [
        27005,
        61863
      ],
      [
        -1,
        0
      ],
      [
        -7,
        8
      ],
      [
        -1,
        1
      ],
      [
        -3,
        -1
      ],
      [
        -3,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        -13
      ]
    ],
    [
      [
        26986,
        61853
      ],
      [
        -21,
        3
      ],
      [
        2,
        105
      ],
      [
        -33,
        8
      ],
      [
        2,
        69
      ],
      [
        -6,
        1
      ],
      [
        1,
        34
      ],
      [
        -27,
        8
      ],
      [
        2,
        77
      ]
    ],
    [
      [
        27377,
        61295
      ],
      [
        37,
        -20
      ],
      [
        11,
        -8
      ],
      [
        22,
        62
      ],
      [
        13,
        35
      ],
      [
        15,
        42
      ],
      [
        26,
        80
      ]
    ],
    [
      [
        27634,
        61249
      ],
      [
        -2,
        -19
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -1
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -10
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        -8
      ],
      [
        -3,
        -11
      ],
      [
        -3,
        -12
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -5
      ]
    ],
    [
      [
        27607,
        61119
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -4
      ],
      [
        0,
        -1
      ],
      [
        -3,
        -6
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -7
      ],
      [
        -3,
        -13
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -10
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -1
      ],
      [
        0,
        2
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -8
      ],
      [
        -2,
        2
      ],
      [
        0,
        3
      ],
      [
        -2,
        -6
      ],
      [
        -2,
        -8
      ],
      [
        -2,
        -9
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -7
      ],
      [
        -2,
        -2
      ],
      [
        0,
        -7
      ],
      [
        1,
        -8
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -7
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -4
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -13
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -2
      ],
      [
        1,
        -1
      ],
      [
        2,
        -10
      ],
      [
        1,
        -1
      ],
      [
        0,
        -7
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -7
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -9
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -21
      ],
      [
        1,
        -6
      ],
      [
        2,
        -4
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -6
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -5
      ],
      [
        -3,
        -13
      ],
      [
        -2,
        -3
      ],
      [
        0,
        -2
      ]
    ],
    [
      [
        27541,
        60816
      ],
      [
        -7,
        -7
      ],
      [
        -5,
        2
      ],
      [
        -3,
        7
      ],
      [
        2,
        13
      ],
      [
        -3,
        3
      ],
      [
        -3,
        -21
      ],
      [
        -6,
        4
      ],
      [
        1,
        17
      ],
      [
        -4,
        -6
      ],
      [
        0,
        17
      ],
      [
        -15,
        -39
      ],
      [
        -4,
        11
      ],
      [
        -12,
        -2
      ],
      [
        -41,
        42
      ],
      [
        -3,
        5
      ]
    ],
    [
      [
        27438,
        60862
      ],
      [
        -1,
        37
      ],
      [
        -4,
        12
      ],
      [
        -19,
        72
      ],
      [
        -16,
        39
      ]
    ],
    [
      [
        27398,
        61022
      ],
      [
        16,
        -5
      ],
      [
        -17,
        98
      ],
      [
        12,
        42
      ],
      [
        -5,
        6
      ],
      [
        0,
        16
      ],
      [
        -3,
        25
      ],
      [
        -9,
        7
      ],
      [
        0,
        14
      ],
      [
        5,
        4
      ],
      [
        3,
        19
      ],
      [
        -5,
        2
      ],
      [
        -4,
        -13
      ],
      [
        -9,
        5
      ],
      [
        -8,
        25
      ],
      [
        3,
        3
      ],
      [
        0,
        25
      ]
    ],
    [
      [
        31829,
        38215
      ],
      [
        3,
        4
      ],
      [
        4,
        -2
      ],
      [
        0,
        -12
      ],
      [
        -4,
        2
      ],
      [
        -4,
        -2
      ],
      [
        1,
        10
      ]
    ],
    [
      [
        31825,
        38364
      ],
      [
        2,
        11
      ],
      [
        2,
        -3
      ],
      [
        0,
        -13
      ],
      [
        1,
        -8
      ],
      [
        -2,
        -7
      ],
      [
        -2,
        9
      ],
      [
        -1,
        11
      ]
    ],
    [
      [
        31800,
        38249
      ],
      [
        2,
        9
      ],
      [
        2,
        -9
      ],
      [
        -1,
        -11
      ],
      [
        -3,
        0
      ],
      [
        0,
        11
      ]
    ],
    [
      [
        31846,
        38320
      ],
      [
        0,
        -19
      ]
    ],
    [
      [
        31846,
        38301
      ],
      [
        -3,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        1,
        -5
      ],
      [
        5,
        -14
      ],
      [
        4,
        -18
      ],
      [
        0,
        -17
      ],
      [
        -2,
        -1
      ],
      [
        -5,
        17
      ],
      [
        -8,
        -8
      ],
      [
        -1,
        -2
      ],
      [
        -6,
        8
      ],
      [
        -6,
        11
      ],
      [
        -3,
        4
      ],
      [
        -2,
        -7
      ],
      [
        -4,
        -7
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        10
      ],
      [
        -1,
        13
      ],
      [
        -2,
        4
      ],
      [
        -3,
        8
      ],
      [
        -5,
        14
      ],
      [
        -3,
        -6
      ],
      [
        -3,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -13,
        -6
      ],
      [
        -3,
        -1
      ],
      [
        1,
        4
      ],
      [
        2,
        9
      ],
      [
        3,
        38
      ],
      [
        1,
        3
      ],
      [
        10,
        -23
      ],
      [
        5,
        6
      ],
      [
        7,
        20
      ],
      [
        0,
        12
      ],
      [
        2,
        7
      ],
      [
        2,
        -7
      ],
      [
        1,
        -13
      ],
      [
        3,
        -9
      ],
      [
        4,
        8
      ],
      [
        7,
        -19
      ],
      [
        6,
        -4
      ],
      [
        6,
        5
      ],
      [
        8,
        -1
      ]
    ],
    [
      [
        24548,
        58507
      ],
      [
        90,
        -4
      ],
      [
        31,
        -1
      ],
      [
        29,
        4
      ],
      [
        30,
        -7
      ],
      [
        29,
        -2
      ]
    ],
    [
      [
        24757,
        58497
      ],
      [
        0,
        -304
      ]
    ],
    [
      [
        24757,
        58193
      ],
      [
        -15,
        1
      ],
      [
        -45,
        3
      ]
    ],
    [
      [
        24547,
        58200
      ],
      [
        1,
        307
      ]
    ],
    [
      [
        16069,
        60572
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        16069,
        60571
      ],
      [
        56,
        186
      ],
      [
        8,
        26
      ],
      [
        6,
        12
      ],
      [
        1,
        16
      ],
      [
        6,
        8
      ],
      [
        4,
        -4
      ],
      [
        1,
        15
      ],
      [
        5,
        0
      ],
      [
        1,
        19
      ],
      [
        3,
        -3
      ],
      [
        10,
        14
      ],
      [
        -1,
        14
      ],
      [
        5,
        -8
      ],
      [
        10,
        18
      ],
      [
        8,
        -11
      ],
      [
        9,
        22
      ],
      [
        12,
        -25
      ],
      [
        9,
        -1
      ],
      [
        0,
        26
      ],
      [
        -1,
        370
      ]
    ],
    [
      [
        16221,
        61265
      ],
      [
        14,
        -57
      ],
      [
        12,
        -41
      ],
      [
        22,
        -82
      ],
      [
        2,
        -12
      ],
      [
        26,
        -94
      ]
    ],
    [
      [
        16371,
        60748
      ],
      [
        -119,
        -194
      ],
      [
        -20,
        -31
      ],
      [
        -27,
        -47
      ],
      [
        -3,
        -17
      ],
      [
        5,
        -9
      ],
      [
        0,
        -33
      ],
      [
        3,
        -4
      ],
      [
        -28,
        -96
      ],
      [
        -45,
        -150
      ]
    ],
    [
      [
        16137,
        60167
      ],
      [
        -3,
        27
      ],
      [
        -7,
        2
      ],
      [
        -5,
        28
      ],
      [
        -5,
        -20
      ],
      [
        -8,
        0
      ],
      [
        -8,
        21
      ],
      [
        -5,
        -13
      ],
      [
        -5,
        -29
      ],
      [
        -4,
        9
      ],
      [
        -3,
        64
      ],
      [
        -11,
        45
      ],
      [
        1,
        31
      ],
      [
        -2,
        8
      ],
      [
        5,
        16
      ],
      [
        2,
        -6
      ],
      [
        8,
        22
      ],
      [
        -1,
        23
      ],
      [
        -4,
        33
      ],
      [
        4,
        27
      ],
      [
        -1,
        9
      ],
      [
        -6,
        8
      ],
      [
        -6,
        -1
      ],
      [
        0,
        13
      ],
      [
        -4,
        19
      ],
      [
        3,
        18
      ],
      [
        -1,
        15
      ],
      [
        -6,
        17
      ],
      [
        0,
        11
      ],
      [
        4,
        8
      ]
    ],
    [
      [
        15716,
        62785
      ],
      [
        40,
        2
      ],
      [
        128,
        0
      ],
      [
        0,
        34
      ],
      [
        35,
        -1
      ],
      [
        2,
        -19
      ],
      [
        -2,
        -16
      ],
      [
        33,
        0
      ]
    ],
    [
      [
        15952,
        62785
      ],
      [
        2,
        -11
      ],
      [
        -4,
        -20
      ],
      [
        1,
        -18
      ],
      [
        -4,
        -44
      ]
    ],
    [
      [
        15947,
        62692
      ],
      [
        -3,
        -26
      ],
      [
        -5,
        -16
      ],
      [
        -3,
        -32
      ],
      [
        6,
        -48
      ],
      [
        -5,
        -22
      ],
      [
        7,
        -44
      ],
      [
        -5,
        2
      ],
      [
        0,
        -9
      ],
      [
        4,
        -16
      ],
      [
        3,
        2
      ],
      [
        2,
        -23
      ],
      [
        3,
        -10
      ],
      [
        2,
        -27
      ],
      [
        5,
        -7
      ],
      [
        6,
        5
      ],
      [
        3,
        -9
      ],
      [
        0,
        -21
      ],
      [
        4,
        -15
      ],
      [
        -1,
        -25
      ],
      [
        9,
        -17
      ],
      [
        -7,
        -9
      ],
      [
        -1,
        -16
      ],
      [
        -3,
        -4
      ],
      [
        -2,
        -19
      ],
      [
        3,
        -19
      ],
      [
        -2,
        -16
      ]
    ],
    [
      [
        15967,
        62251
      ],
      [
        -140,
        -1
      ]
    ],
    [
      [
        15827,
        62250
      ],
      [
        -9,
        19
      ],
      [
        -10,
        26
      ],
      [
        -3,
        31
      ],
      [
        3,
        21
      ],
      [
        -2,
        15
      ],
      [
        -6,
        1
      ],
      [
        -9,
        28
      ],
      [
        -7,
        11
      ],
      [
        2,
        33
      ],
      [
        -4,
        45
      ],
      [
        1,
        22
      ],
      [
        5,
        -1
      ],
      [
        0,
        22
      ],
      [
        1,
        18
      ],
      [
        -5,
        5
      ],
      [
        -1,
        15
      ],
      [
        -5,
        6
      ],
      [
        0,
        15
      ],
      [
        -16,
        -6
      ],
      [
        -2,
        7
      ],
      [
        -15,
        15
      ],
      [
        -5,
        -10
      ],
      [
        -4,
        4
      ],
      [
        -4,
        24
      ],
      [
        -9,
        22
      ],
      [
        -5,
        19
      ],
      [
        -7,
        13
      ],
      [
        -5,
        31
      ],
      [
        2,
        37
      ],
      [
        4,
        3
      ],
      [
        2,
        26
      ],
      [
        -11,
        17
      ],
      [
        13,
        1
      ]
    ],
    [
      [
        26431,
        56469
      ],
      [
        2,
        -2
      ],
      [
        3,
        -43
      ],
      [
        1,
        -1
      ],
      [
        1,
        -8
      ],
      [
        4,
        -8
      ],
      [
        1,
        0
      ],
      [
        1,
        -3
      ],
      [
        5,
        -22
      ],
      [
        2,
        -6
      ],
      [
        1,
        -6
      ],
      [
        8,
        -17
      ],
      [
        5,
        -6
      ],
      [
        2,
        -12
      ],
      [
        4,
        -9
      ],
      [
        3,
        -19
      ],
      [
        3,
        -13
      ],
      [
        5,
        -10
      ],
      [
        1,
        -4
      ],
      [
        5,
        -21
      ],
      [
        8,
        -15
      ],
      [
        1,
        -8
      ],
      [
        5,
        -5
      ]
    ],
    [
      [
        26502,
        56231
      ],
      [
        -9,
        -31
      ],
      [
        -2,
        -15
      ],
      [
        -3,
        -24
      ],
      [
        0,
        -1
      ],
      [
        -8,
        -65
      ],
      [
        -4,
        -25
      ],
      [
        -3,
        19
      ],
      [
        -6,
        9
      ],
      [
        -6,
        0
      ],
      [
        -4,
        8
      ]
    ],
    [
      [
        26457,
        56106
      ],
      [
        -1,
        0
      ],
      [
        -10,
        1
      ],
      [
        0,
        -19
      ],
      [
        -6,
        0
      ],
      [
        -2,
        19
      ],
      [
        -4,
        1
      ],
      [
        -4,
        0
      ]
    ],
    [
      [
        26430,
        56108
      ],
      [
        -19,
        0
      ]
    ],
    [
      [
        26411,
        56108
      ],
      [
        0,
        147
      ],
      [
        1,
        9
      ],
      [
        0,
        209
      ],
      [
        2,
        10
      ],
      [
        17,
        -16
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        26549,
        57359
      ],
      [
        7,
        9
      ],
      [
        1,
        57
      ],
      [
        13,
        16
      ]
    ],
    [
      [
        26570,
        57441
      ],
      [
        10,
        10
      ],
      [
        11,
        -12
      ],
      [
        4,
        9
      ],
      [
        2,
        2
      ]
    ],
    [
      [
        26597,
        57450
      ],
      [
        10,
        -33
      ],
      [
        5,
        -10
      ],
      [
        -1,
        -11
      ],
      [
        3,
        -25
      ],
      [
        -5,
        -26
      ],
      [
        1,
        -12
      ],
      [
        -3,
        -35
      ],
      [
        -4,
        -12
      ],
      [
        6,
        -43
      ],
      [
        -2,
        -12
      ],
      [
        2,
        -38
      ],
      [
        7,
        -31
      ],
      [
        -5,
        -30
      ],
      [
        -8,
        -16
      ],
      [
        -1,
        -12
      ]
    ],
    [
      [
        26602,
        57104
      ],
      [
        -26,
        1
      ],
      [
        -5,
        11
      ],
      [
        -3,
        -10
      ],
      [
        -16,
        1
      ]
    ],
    [
      [
        26552,
        57107
      ],
      [
        3,
        31
      ],
      [
        -3,
        0
      ],
      [
        0,
        11
      ],
      [
        -3,
        0
      ],
      [
        -3,
        10
      ],
      [
        0,
        76
      ],
      [
        -3,
        16
      ],
      [
        1,
        53
      ],
      [
        3,
        16
      ],
      [
        2,
        39
      ]
    ],
    [
      [
        26101,
        56852
      ],
      [
        21,
        -1
      ],
      [
        1,
        20
      ],
      [
        6,
        42
      ],
      [
        8,
        36
      ],
      [
        15,
        23
      ],
      [
        11,
        22
      ],
      [
        0,
        8
      ],
      [
        5,
        0
      ],
      [
        2,
        16
      ],
      [
        10,
        8
      ],
      [
        5,
        42
      ],
      [
        4,
        50
      ],
      [
        7,
        44
      ],
      [
        4,
        40
      ]
    ],
    [
      [
        26200,
        57202
      ],
      [
        11,
        0
      ]
    ],
    [
      [
        26211,
        57202
      ],
      [
        1,
        -15
      ],
      [
        0,
        -37
      ],
      [
        -7,
        -1
      ],
      [
        0,
        -91
      ],
      [
        -6,
        -2
      ],
      [
        6,
        -43
      ],
      [
        -5,
        -12
      ],
      [
        1,
        -12
      ],
      [
        5,
        -4
      ],
      [
        15,
        0
      ],
      [
        2,
        -8
      ],
      [
        5,
        -2
      ]
    ],
    [
      [
        26217,
        56630
      ],
      [
        -21,
        1
      ],
      [
        0,
        -16
      ],
      [
        -10,
        0
      ],
      [
        0,
        16
      ],
      [
        -14,
        1
      ],
      [
        -14,
        3
      ],
      [
        0,
        -25
      ],
      [
        -7,
        1
      ],
      [
        -38,
        1
      ]
    ],
    [
      [
        26113,
        56612
      ],
      [
        -2,
        39
      ],
      [
        -1,
        13
      ],
      [
        -4,
        87
      ],
      [
        -3,
        59
      ],
      [
        0,
        3
      ],
      [
        -1,
        15
      ],
      [
        0,
        4
      ],
      [
        -1,
        20
      ]
    ],
    [
      [
        17848,
        67225
      ],
      [
        137,
        1
      ]
    ],
    [
      [
        17985,
        66821
      ],
      [
        -7,
        0
      ],
      [
        1,
        -234
      ]
    ],
    [
      [
        17979,
        66587
      ],
      [
        -10,
        13
      ],
      [
        -9,
        -1
      ],
      [
        -17,
        16
      ],
      [
        -9,
        -11
      ],
      [
        -10,
        0
      ],
      [
        -4,
        25
      ],
      [
        1,
        21
      ],
      [
        -7,
        12
      ],
      [
        1,
        24
      ],
      [
        -4,
        24
      ],
      [
        -5,
        2
      ],
      [
        -9,
        16
      ],
      [
        -7,
        -4
      ],
      [
        -2,
        28
      ],
      [
        3,
        17
      ],
      [
        -2,
        8
      ],
      [
        7,
        16
      ],
      [
        3,
        20
      ],
      [
        0,
        18
      ],
      [
        -5,
        25
      ],
      [
        -10,
        28
      ],
      [
        -1,
        12
      ],
      [
        -18,
        3
      ],
      [
        -4,
        -7
      ]
    ],
    [
      [
        17861,
        66892
      ],
      [
        -13,
        3
      ],
      [
        0,
        330
      ]
    ],
    [
      [
        24924,
        66063
      ],
      [
        81,
        3
      ]
    ],
    [
      [
        25132,
        65705
      ],
      [
        -117,
        -5
      ],
      [
        0,
        17
      ],
      [
        -12,
        0
      ],
      [
        -3,
        -19
      ],
      [
        -4,
        9
      ],
      [
        2,
        16
      ],
      [
        -14,
        5
      ],
      [
        -2,
        -11
      ],
      [
        -42,
        -1
      ]
    ],
    [
      [
        24940,
        65716
      ],
      [
        0,
        33
      ],
      [
        -15,
        1
      ]
    ],
    [
      [
        24925,
        65750
      ],
      [
        -1,
        8
      ],
      [
        1,
        103
      ],
      [
        -1,
        202
      ]
    ],
    [
      [
        20593,
        72571
      ],
      [
        0,
        91
      ],
      [
        11,
        0
      ],
      [
        0,
        231
      ]
    ],
    [
      [
        20604,
        72893
      ],
      [
        3,
        15
      ],
      [
        0,
        25
      ],
      [
        4,
        -6
      ],
      [
        -1,
        -17
      ],
      [
        8,
        -10
      ],
      [
        9,
        4
      ],
      [
        -1,
        -20
      ],
      [
        8,
        6
      ],
      [
        8,
        16
      ],
      [
        4,
        -29
      ],
      [
        2,
        13
      ],
      [
        6,
        6
      ],
      [
        2,
        19
      ],
      [
        4,
        -6
      ],
      [
        1,
        -17
      ],
      [
        4,
        21
      ],
      [
        -3,
        20
      ],
      [
        3,
        2
      ],
      [
        8,
        -10
      ],
      [
        5,
        18
      ],
      [
        1,
        31
      ],
      [
        7,
        15
      ],
      [
        5,
        0
      ],
      [
        8,
        -28
      ],
      [
        8,
        -7
      ],
      [
        10,
        10
      ],
      [
        8,
        -2
      ],
      [
        3,
        -17
      ],
      [
        10,
        9
      ],
      [
        8,
        -7
      ],
      [
        1,
        -12
      ],
      [
        15,
        11
      ],
      [
        -1,
        17
      ],
      [
        5,
        17
      ],
      [
        7,
        -19
      ],
      [
        -1,
        -20
      ],
      [
        2,
        -1
      ],
      [
        11,
        22
      ],
      [
        4,
        -2
      ],
      [
        5,
        -17
      ],
      [
        7,
        14
      ],
      [
        7,
        -3
      ],
      [
        5,
        -28
      ],
      [
        13,
        -21
      ],
      [
        6,
        -1
      ],
      [
        4,
        -9
      ],
      [
        3,
        -26
      ],
      [
        8,
        -1
      ],
      [
        9,
        6
      ],
      [
        12,
        -23
      ],
      [
        6,
        0
      ],
      [
        7,
        8
      ],
      [
        -1,
        33
      ],
      [
        5,
        0
      ],
      [
        -1,
        -20
      ],
      [
        6,
        -16
      ],
      [
        9,
        24
      ],
      [
        3,
        -21
      ],
      [
        8,
        -14
      ],
      [
        -3,
        -14
      ],
      [
        2,
        -16
      ],
      [
        9,
        4
      ],
      [
        6,
        -8
      ]
    ],
    [
      [
        20924,
        72811
      ],
      [
        0,
        -55
      ],
      [
        1,
        -68
      ],
      [
        0,
        -102
      ],
      [
        -1,
        -65
      ],
      [
        0,
        -408
      ]
    ],
    [
      [
        20819,
        72064
      ],
      [
        -25,
        0
      ],
      [
        0,
        203
      ],
      [
        -23,
        0
      ],
      [
        0,
        101
      ],
      [
        -107,
        0
      ],
      [
        0,
        102
      ],
      [
        -72,
        0
      ],
      [
        1,
        101
      ]
    ],
    [
      [
        28264,
        59025
      ],
      [
        6,
        0
      ],
      [
        2,
        -19
      ],
      [
        7,
        1
      ],
      [
        4,
        -13
      ],
      [
        0,
        -13
      ],
      [
        7,
        -6
      ],
      [
        3,
        -10
      ],
      [
        15,
        -7
      ],
      [
        4,
        -31
      ],
      [
        -4,
        -10
      ],
      [
        3,
        -25
      ],
      [
        4,
        -3
      ],
      [
        12,
        1
      ],
      [
        10,
        -19
      ],
      [
        -1,
        -8
      ],
      [
        6,
        -12
      ],
      [
        5,
        1
      ]
    ],
    [
      [
        28347,
        58852
      ],
      [
        16,
        -116
      ],
      [
        -1,
        -44
      ],
      [
        -1,
        -56
      ]
    ],
    [
      [
        28361,
        58636
      ],
      [
        -11,
        16
      ],
      [
        -5,
        -8
      ],
      [
        -5,
        -24
      ],
      [
        -5,
        4
      ],
      [
        -8,
        -9
      ],
      [
        -12,
        -46
      ],
      [
        -4,
        -10
      ],
      [
        -37,
        -91
      ]
    ],
    [
      [
        28274,
        58468
      ],
      [
        -3,
        16
      ],
      [
        -12,
        47
      ],
      [
        -6,
        64
      ],
      [
        -3,
        39
      ],
      [
        0,
        12
      ],
      [
        -22,
        46
      ]
    ],
    [
      [
        28228,
        58692
      ],
      [
        3,
        19
      ],
      [
        11,
        114
      ],
      [
        2,
        33
      ],
      [
        9,
        62
      ],
      [
        9,
        61
      ],
      [
        2,
        44
      ]
    ],
    [
      [
        21448,
        59429
      ],
      [
        37,
        0
      ]
    ],
    [
      [
        21485,
        59429
      ],
      [
        28,
        0
      ],
      [
        29,
        -1
      ],
      [
        57,
        0
      ]
    ],
    [
      [
        21448,
        58911
      ],
      [
        0,
        518
      ]
    ],
    [
      [
        26065,
        55479
      ],
      [
        100,
        1
      ]
    ],
    [
      [
        26165,
        55480
      ],
      [
        3,
        -53
      ],
      [
        0,
        -8
      ],
      [
        4,
        -85
      ],
      [
        2,
        -28
      ],
      [
        3,
        -80
      ],
      [
        1,
        -23
      ]
    ],
    [
      [
        26178,
        55203
      ],
      [
        1,
        -10
      ],
      [
        8,
        -22
      ],
      [
        -4,
        -36
      ],
      [
        10,
        -34
      ],
      [
        3,
        -11
      ],
      [
        -5,
        -15
      ],
      [
        3,
        -10
      ]
    ],
    [
      [
        26194,
        55065
      ],
      [
        -2,
        -6
      ],
      [
        -41,
        -1
      ],
      [
        -3,
        -17
      ],
      [
        -17,
        -1
      ],
      [
        -11,
        0
      ],
      [
        -5,
        17
      ],
      [
        -5,
        0
      ],
      [
        0,
        -17
      ],
      [
        -45,
        -2
      ]
    ],
    [
      [
        26065,
        55038
      ],
      [
        0,
        441
      ]
    ],
    [
      [
        16505,
        62261
      ],
      [
        89,
        -255
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        16594,
        62005
      ],
      [
        2,
        -9
      ],
      [
        -5,
        -40
      ],
      [
        -5,
        -6
      ],
      [
        -1,
        -72
      ],
      [
        5,
        -13
      ],
      [
        4,
        -41
      ],
      [
        5,
        -24
      ],
      [
        3,
        -24
      ],
      [
        0,
        -17
      ],
      [
        4,
        -3
      ],
      [
        0,
        -21
      ],
      [
        -3,
        -13
      ],
      [
        -1,
        -27
      ],
      [
        -3,
        -14
      ],
      [
        2,
        -28
      ],
      [
        -9,
        -14
      ],
      [
        -2,
        7
      ],
      [
        -6,
        -13
      ],
      [
        4,
        -32
      ],
      [
        -8,
        -15
      ],
      [
        2,
        -4
      ],
      [
        -3,
        -27
      ]
    ],
    [
      [
        16473,
        61679
      ],
      [
        -9,
        26
      ],
      [
        -5,
        -10
      ],
      [
        0,
        73
      ]
    ],
    [
      [
        15579,
        65835
      ],
      [
        10,
        2
      ],
      [
        11,
        3
      ],
      [
        2,
        2
      ],
      [
        18,
        -5
      ],
      [
        5,
        0
      ],
      [
        5,
        -3
      ],
      [
        43,
        0
      ],
      [
        5,
        1
      ],
      [
        21,
        0
      ],
      [
        24,
        1
      ],
      [
        22,
        0
      ],
      [
        37,
        5
      ],
      [
        29,
        0
      ],
      [
        5,
        1
      ],
      [
        25,
        -2
      ]
    ],
    [
      [
        15841,
        65840
      ],
      [
        8,
        -1
      ],
      [
        28,
        1
      ],
      [
        1,
        -1
      ],
      [
        15,
        -2
      ],
      [
        29,
        -2
      ],
      [
        42,
        -1
      ],
      [
        39,
        -2
      ],
      [
        1,
        0
      ],
      [
        4,
        -1
      ],
      [
        4,
        0
      ],
      [
        26,
        -2
      ],
      [
        17,
        -1
      ],
      [
        21,
        -1
      ]
    ],
    [
      [
        16076,
        65827
      ],
      [
        0,
        -54
      ],
      [
        -3,
        -1
      ],
      [
        0,
        -202
      ],
      [
        2,
        0
      ],
      [
        0,
        -403
      ],
      [
        1,
        -287
      ]
    ],
    [
      [
        15529,
        64876
      ],
      [
        -2,
        20
      ],
      [
        -5,
        19
      ],
      [
        -1,
        16
      ],
      [
        -5,
        11
      ],
      [
        4,
        15
      ],
      [
        -1,
        31
      ],
      [
        -5,
        7
      ],
      [
        2,
        13
      ],
      [
        -2,
        29
      ],
      [
        -4,
        11
      ],
      [
        -1,
        30
      ],
      [
        2,
        15
      ],
      [
        -4,
        12
      ],
      [
        -4,
        7
      ],
      [
        -44,
        -1
      ]
    ],
    [
      [
        15459,
        65111
      ],
      [
        1,
        5
      ],
      [
        0,
        3
      ],
      [
        3,
        11
      ],
      [
        1,
        21
      ],
      [
        1,
        13
      ],
      [
        5,
        10
      ],
      [
        2,
        12
      ],
      [
        0,
        11
      ],
      [
        -1,
        10
      ],
      [
        -3,
        7
      ],
      [
        -2,
        16
      ],
      [
        -1,
        13
      ],
      [
        0,
        7
      ],
      [
        -1,
        10
      ],
      [
        -1,
        7
      ],
      [
        0,
        5
      ],
      [
        1,
        2
      ],
      [
        -1,
        3
      ],
      [
        0,
        8
      ],
      [
        -1,
        6
      ],
      [
        -1,
        3
      ],
      [
        -1,
        0
      ],
      [
        -2,
        3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        9
      ],
      [
        -1,
        8
      ],
      [
        1,
        7
      ],
      [
        1,
        7
      ],
      [
        0,
        7
      ],
      [
        -1,
        5
      ],
      [
        1,
        6
      ],
      [
        1,
        1
      ],
      [
        0,
        7
      ],
      [
        -2,
        1
      ],
      [
        -3,
        -1
      ],
      [
        -1,
        4
      ],
      [
        -2,
        -2
      ],
      [
        0,
        -1
      ],
      [
        -2,
        2
      ],
      [
        0,
        5
      ],
      [
        1,
        9
      ],
      [
        1,
        8
      ],
      [
        2,
        10
      ],
      [
        2,
        6
      ],
      [
        3,
        20
      ],
      [
        -1,
        27
      ],
      [
        4,
        19
      ],
      [
        2,
        22
      ],
      [
        2,
        27
      ],
      [
        -5,
        23
      ],
      [
        -1,
        22
      ],
      [
        -1,
        20
      ],
      [
        3,
        9
      ],
      [
        0,
        8
      ],
      [
        -1,
        3
      ],
      [
        -3,
        4
      ],
      [
        -1,
        12
      ],
      [
        -2,
        5
      ],
      [
        -1,
        9
      ],
      [
        2,
        10
      ],
      [
        5,
        4
      ],
      [
        2,
        5
      ],
      [
        2,
        14
      ],
      [
        4,
        9
      ],
      [
        0,
        20
      ],
      [
        1,
        5
      ],
      [
        1,
        6
      ],
      [
        1,
        1
      ],
      [
        3,
        0
      ],
      [
        2,
        -3
      ],
      [
        1,
        -5
      ],
      [
        4,
        2
      ],
      [
        0,
        6
      ],
      [
        2,
        7
      ],
      [
        0,
        8
      ],
      [
        2,
        4
      ],
      [
        4,
        -1
      ],
      [
        3,
        1
      ],
      [
        2,
        9
      ],
      [
        0,
        10
      ],
      [
        1,
        12
      ],
      [
        2,
        9
      ],
      [
        2,
        11
      ],
      [
        1,
        10
      ],
      [
        0,
        20
      ],
      [
        -1,
        10
      ],
      [
        1,
        9
      ],
      [
        3,
        3
      ],
      [
        1,
        6
      ],
      [
        1,
        3
      ]
    ],
    [
      [
        19531,
        60575
      ],
      [
        36,
        171
      ],
      [
        62,
        0
      ],
      [
        13,
        1
      ],
      [
        135,
        3
      ],
      [
        15,
        4
      ],
      [
        38,
        1
      ]
    ],
    [
      [
        19830,
        60755
      ],
      [
        0,
        -11
      ],
      [
        -5,
        -9
      ],
      [
        -3,
        -10
      ],
      [
        -1,
        -7
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -23
      ],
      [
        1,
        -6
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -9
      ],
      [
        -2,
        -10
      ],
      [
        -1,
        -12
      ],
      [
        0,
        -35
      ],
      [
        1,
        -11
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -7
      ],
      [
        1,
        -9
      ],
      [
        -2,
        -8
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -8
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        1
      ],
      [
        -2,
        0
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -9
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -10
      ],
      [
        1,
        -9
      ],
      [
        -2,
        -6
      ],
      [
        -2,
        -6
      ],
      [
        -6,
        -2
      ],
      [
        -2,
        -11
      ],
      [
        -4,
        -1
      ],
      [
        -3,
        4
      ],
      [
        -4,
        -7
      ],
      [
        -3,
        -6
      ],
      [
        -2,
        -14
      ],
      [
        -1,
        -11
      ],
      [
        1,
        -5
      ],
      [
        0,
        -6
      ],
      [
        -2,
        -9
      ],
      [
        -1,
        -10
      ],
      [
        1,
        -11
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -8
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -10
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -11
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -9
      ],
      [
        -2,
        -7
      ],
      [
        -3,
        -6
      ],
      [
        -2,
        -4
      ],
      [
        -3,
        -10
      ],
      [
        0,
        -12
      ],
      [
        1,
        -10
      ],
      [
        -1,
        -12
      ],
      [
        0,
        -36
      ],
      [
        1,
        -13
      ],
      [
        -5,
        -18
      ],
      [
        0,
        -9
      ],
      [
        -1,
        -9
      ],
      [
        1,
        -8
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -13
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -7
      ],
      [
        -2,
        -9
      ],
      [
        0,
        -8
      ],
      [
        -3,
        -7
      ],
      [
        -2,
        -11
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        -2,
        -7
      ],
      [
        0,
        -9
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -5
      ]
    ],
    [
      [
        19716,
        60010
      ],
      [
        -67,
        0
      ],
      [
        -93,
        -1
      ],
      [
        -25,
        0
      ]
    ],
    [
      [
        26283,
        57668
      ],
      [
        9,
        0
      ]
    ],
    [
      [
        26292,
        57668
      ],
      [
        43,
        0
      ],
      [
        1,
        1
      ]
    ],
    [
      [
        26336,
        57514
      ],
      [
        10,
        -35
      ],
      [
        -7,
        -40
      ],
      [
        -5,
        -7
      ],
      [
        -4,
        -9
      ],
      [
        2,
        -6
      ],
      [
        -6,
        -50
      ],
      [
        0,
        -170
      ]
    ],
    [
      [
        26326,
        57197
      ],
      [
        -7,
        0
      ],
      [
        -7,
        18
      ],
      [
        -3,
        28
      ],
      [
        -8,
        -14
      ],
      [
        -10,
        -3
      ],
      [
        -6,
        0
      ],
      [
        -17,
        9
      ],
      [
        -12,
        0
      ],
      [
        -2,
        21
      ]
    ],
    [
      [
        26254,
        57256
      ],
      [
        -4,
        37
      ],
      [
        -4,
        16
      ],
      [
        4,
        -4
      ],
      [
        5,
        6
      ],
      [
        2,
        -18
      ],
      [
        4,
        4
      ],
      [
        0,
        11
      ],
      [
        -12,
        33
      ],
      [
        2,
        11
      ],
      [
        10,
        -13
      ],
      [
        2,
        11
      ],
      [
        5,
        -8
      ],
      [
        2,
        20
      ],
      [
        -4,
        8
      ],
      [
        4,
        6
      ],
      [
        1,
        14
      ],
      [
        -4,
        13
      ],
      [
        -2,
        34
      ],
      [
        3,
        -6
      ],
      [
        7,
        20
      ],
      [
        -6,
        7
      ],
      [
        -1,
        8
      ],
      [
        4,
        20
      ],
      [
        2,
        34
      ],
      [
        5,
        1
      ],
      [
        2,
        18
      ],
      [
        -5,
        24
      ],
      [
        3,
        5
      ],
      [
        -5,
        19
      ],
      [
        2,
        29
      ],
      [
        6,
        34
      ],
      [
        1,
        18
      ]
    ],
    [
      [
        18429,
        66212
      ],
      [
        96,
        2
      ],
      [
        0,
        101
      ],
      [
        44,
        0
      ],
      [
        0,
        101
      ],
      [
        22,
        0
      ]
    ],
    [
      [
        18591,
        66416
      ],
      [
        10,
        0
      ],
      [
        1,
        -25
      ],
      [
        4,
        -17
      ],
      [
        5,
        0
      ],
      [
        1,
        -22
      ],
      [
        13,
        7
      ],
      [
        2,
        -31
      ],
      [
        -1,
        -47
      ],
      [
        -3,
        -8
      ],
      [
        -7,
        -38
      ],
      [
        1,
        -27
      ],
      [
        6,
        3
      ],
      [
        4,
        -11
      ],
      [
        4,
        2
      ],
      [
        4,
        37
      ],
      [
        20,
        0
      ],
      [
        1,
        -15
      ],
      [
        7,
        -34
      ],
      [
        1,
        -16
      ],
      [
        5,
        1
      ],
      [
        4,
        -12
      ]
    ],
    [
      [
        18673,
        66163
      ],
      [
        3,
        -19
      ],
      [
        4,
        1
      ],
      [
        4,
        -28
      ],
      [
        4,
        -9
      ],
      [
        0,
        -80
      ],
      [
        -11,
        1
      ],
      [
        0,
        -201
      ]
    ],
    [
      [
        18677,
        65828
      ],
      [
        -15,
        -1
      ]
    ],
    [
      [
        18662,
        65827
      ],
      [
        -3,
        0
      ],
      [
        -5,
        5
      ],
      [
        -72,
        0
      ],
      [
        -55,
        -1
      ],
      [
        -17,
        0
      ],
      [
        -22,
        -1
      ],
      [
        -26,
        0
      ],
      [
        -8,
        -1
      ],
      [
        -25,
        0
      ]
    ],
    [
      [
        25398,
        61442
      ],
      [
        52,
        -1
      ],
      [
        0,
        -31
      ],
      [
        31,
        -2
      ],
      [
        0,
        -37
      ]
    ],
    [
      [
        25481,
        61371
      ],
      [
        0,
        -51
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -136
      ],
      [
        0,
        -129
      ]
    ],
    [
      [
        25478,
        61055
      ],
      [
        -3,
        -4
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        0
      ],
      [
        -2,
        3
      ],
      [
        -2,
        0
      ],
      [
        -7,
        -4
      ],
      [
        -2,
        -6
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        0
      ],
      [
        -7,
        2
      ],
      [
        0,
        1
      ],
      [
        -2,
        3
      ],
      [
        -1,
        3
      ],
      [
        0,
        6
      ],
      [
        -1,
        5
      ],
      [
        0,
        1
      ],
      [
        -3,
        9
      ],
      [
        0,
        2
      ],
      [
        -2,
        11
      ],
      [
        0,
        4
      ],
      [
        -2,
        7
      ],
      [
        -2,
        3
      ],
      [
        -1,
        3
      ],
      [
        -3,
        2
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -3
      ],
      [
        -5,
        -20
      ],
      [
        -1,
        -7
      ]
    ],
    [
      [
        25415,
        61060
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -23
      ],
      [
        1,
        -3
      ],
      [
        2,
        -11
      ],
      [
        4,
        -11
      ],
      [
        2,
        -14
      ],
      [
        1,
        -23
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -4
      ],
      [
        -3,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -15
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -2,
        0
      ],
      [
        -2,
        2
      ],
      [
        -2,
        10
      ],
      [
        -1,
        3
      ],
      [
        -1,
        4
      ],
      [
        -2,
        4
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        -2,
        3
      ],
      [
        -3,
        2
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        -2
      ]
    ],
    [
      [
        25386,
        60941
      ],
      [
        0,
        5
      ],
      [
        -2,
        7
      ],
      [
        -2,
        -1
      ],
      [
        -4,
        -8
      ],
      [
        -3,
        -1
      ],
      [
        -4,
        11
      ],
      [
        -2,
        16
      ],
      [
        2,
        7
      ],
      [
        3,
        -1
      ],
      [
        3,
        -8
      ],
      [
        4,
        -1
      ],
      [
        2,
        1
      ],
      [
        4,
        10
      ],
      [
        -2,
        12
      ],
      [
        -7,
        7
      ],
      [
        -3,
        10
      ],
      [
        -3,
        27
      ],
      [
        -3,
        14
      ]
    ],
    [
      [
        25369,
        61048
      ],
      [
        -1,
        3
      ],
      [
        -1,
        9
      ],
      [
        1,
        5
      ],
      [
        2,
        0
      ],
      [
        4,
        -12
      ],
      [
        5,
        -5
      ],
      [
        4,
        1
      ],
      [
        4,
        -1
      ],
      [
        2,
        -3
      ],
      [
        2,
        7
      ],
      [
        -2,
        21
      ],
      [
        -3,
        2
      ],
      [
        -10,
        6
      ],
      [
        -1,
        10
      ],
      [
        3,
        6
      ],
      [
        1,
        0
      ],
      [
        5,
        11
      ],
      [
        0,
        16
      ],
      [
        1,
        2
      ],
      [
        1,
        0
      ],
      [
        2,
        1
      ],
      [
        2,
        3
      ],
      [
        1,
        6
      ],
      [
        0,
        12
      ],
      [
        -3,
        22
      ],
      [
        0,
        22
      ],
      [
        4,
        16
      ],
      [
        -3,
        7
      ],
      [
        -3,
        -5
      ],
      [
        -3,
        9
      ],
      [
        1,
        15
      ],
      [
        10,
        1
      ],
      [
        3,
        4
      ],
      [
        6,
        14
      ],
      [
        2,
        13
      ],
      [
        1,
        11
      ],
      [
        -1,
        14
      ],
      [
        -12,
        -19
      ],
      [
        -2,
        2
      ],
      [
        -1,
        14
      ],
      [
        1,
        7
      ],
      [
        4,
        6
      ],
      [
        3,
        -2
      ],
      [
        2,
        1
      ],
      [
        1,
        4
      ],
      [
        0,
        11
      ],
      [
        1,
        10
      ],
      [
        1,
        3
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ],
      [
        2,
        -7
      ],
      [
        3,
        15
      ],
      [
        2,
        2
      ],
      [
        1,
        6
      ],
      [
        -1,
        6
      ],
      [
        -1,
        5
      ],
      [
        0,
        10
      ],
      [
        -1,
        9
      ],
      [
        -6,
        14
      ],
      [
        -5,
        16
      ],
      [
        -2,
        14
      ],
      [
        -1,
        21
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        25875,
        60701
      ],
      [
        26,
        178
      ],
      [
        8,
        61
      ]
    ],
    [
      [
        25909,
        60940
      ],
      [
        40,
        23
      ],
      [
        6,
        47
      ],
      [
        3,
        20
      ],
      [
        -2,
        40
      ],
      [
        -4,
        90
      ],
      [
        0,
        14
      ]
    ],
    [
      [
        25952,
        61174
      ],
      [
        0,
        1
      ],
      [
        6,
        4
      ],
      [
        5,
        1
      ],
      [
        2,
        1
      ],
      [
        1,
        2
      ],
      [
        1,
        1
      ]
    ],
    [
      [
        25967,
        61184
      ],
      [
        2,
        -11
      ]
    ],
    [
      [
        25969,
        61173
      ],
      [
        0,
        -3
      ],
      [
        8,
        -5
      ],
      [
        2,
        -26
      ],
      [
        -1,
        -31
      ],
      [
        3,
        -3
      ],
      [
        4,
        10
      ],
      [
        7,
        -4
      ],
      [
        3,
        -28
      ],
      [
        4,
        -3
      ],
      [
        1,
        -21
      ],
      [
        3,
        -13
      ],
      [
        -5,
        4
      ],
      [
        -1,
        -16
      ],
      [
        5,
        -24
      ],
      [
        4,
        2
      ],
      [
        5,
        -20
      ],
      [
        7,
        -11
      ],
      [
        5,
        -14
      ],
      [
        1,
        -12
      ]
    ],
    [
      [
        26024,
        60955
      ],
      [
        0,
        -26
      ],
      [
        3,
        -17
      ],
      [
        11,
        -23
      ],
      [
        4,
        -25
      ],
      [
        -2,
        -1
      ]
    ],
    [
      [
        26040,
        60863
      ],
      [
        -2,
        -15
      ],
      [
        -13,
        -76
      ],
      [
        -11,
        -18
      ],
      [
        0,
        -9
      ],
      [
        -7,
        -9
      ],
      [
        1,
        -18
      ],
      [
        -6,
        -27
      ],
      [
        -1,
        -12
      ],
      [
        -5,
        -7
      ],
      [
        -10,
        -28
      ],
      [
        -5,
        -84
      ],
      [
        0,
        -37
      ]
    ],
    [
      [
        25981,
        60523
      ],
      [
        -30,
        8
      ],
      [
        -13,
        3
      ]
    ],
    [
      [
        25938,
        60534
      ],
      [
        -5,
        9
      ],
      [
        2,
        18
      ],
      [
        3,
        5
      ],
      [
        -4,
        15
      ],
      [
        2,
        7
      ],
      [
        -16,
        83
      ],
      [
        -13,
        -5
      ],
      [
        -2,
        10
      ],
      [
        -3,
        -20
      ],
      [
        -7,
        23
      ],
      [
        -8,
        1
      ],
      [
        -4,
        31
      ],
      [
        -1,
        -9
      ],
      [
        -5,
        -11
      ],
      [
        -2,
        10
      ]
    ],
    [
      [
        23800,
        51922
      ],
      [
        5,
        1
      ],
      [
        48,
        -1
      ],
      [
        53,
        1
      ],
      [
        45,
        0
      ],
      [
        3,
        -1
      ],
      [
        11,
        1
      ],
      [
        0,
        -16
      ],
      [
        37,
        0
      ]
    ],
    [
      [
        24002,
        51907
      ],
      [
        67,
        1
      ],
      [
        5,
        -3
      ]
    ],
    [
      [
        24108,
        51380
      ],
      [
        -11,
        12
      ],
      [
        -24,
        30
      ],
      [
        -12,
        22
      ],
      [
        -26,
        46
      ],
      [
        -19,
        33
      ],
      [
        -13,
        18
      ],
      [
        -10,
        14
      ],
      [
        -16,
        15
      ],
      [
        -25,
        25
      ],
      [
        -14,
        8
      ],
      [
        -11,
        1
      ],
      [
        -8,
        -4
      ],
      [
        -14,
        -14
      ],
      [
        -10,
        3
      ],
      [
        -16,
        4
      ],
      [
        -10,
        0
      ],
      [
        -18,
        -7
      ],
      [
        -14,
        -8
      ],
      [
        -13,
        -4
      ],
      [
        -13,
        -6
      ],
      [
        -17,
        -13
      ],
      [
        -6,
        -8
      ],
      [
        -9,
        -16
      ],
      [
        -6,
        -13
      ],
      [
        -5,
        -16
      ]
    ],
    [
      [
        23768,
        51502
      ],
      [
        -7,
        39
      ],
      [
        -2,
        13
      ],
      [
        -1,
        3
      ],
      [
        -4,
        5
      ],
      [
        -1,
        3
      ],
      [
        -1,
        10
      ],
      [
        1,
        10
      ],
      [
        -1,
        6
      ],
      [
        -1,
        5
      ],
      [
        -7,
        16
      ],
      [
        -1,
        5
      ],
      [
        -1,
        9
      ],
      [
        0,
        7
      ],
      [
        1,
        7
      ],
      [
        1,
        11
      ],
      [
        2,
        7
      ],
      [
        4,
        14
      ],
      [
        3,
        7
      ],
      [
        5,
        10
      ],
      [
        3,
        7
      ],
      [
        2,
        8
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        23428,
        62034
      ],
      [
        125,
        0
      ]
    ],
    [
      [
        23553,
        62034
      ],
      [
        -1,
        -120
      ],
      [
        0,
        -184
      ]
    ],
    [
      [
        23552,
        61730
      ],
      [
        0,
        -103
      ]
    ],
    [
      [
        23552,
        61627
      ],
      [
        -85,
        0
      ],
      [
        -41,
        1
      ]
    ],
    [
      [
        17874,
        68100
      ],
      [
        -5,
        0
      ],
      [
        -8,
        10
      ],
      [
        -8,
        -20
      ],
      [
        -7,
        23
      ],
      [
        2,
        19
      ],
      [
        -6,
        -8
      ],
      [
        -8,
        16
      ],
      [
        -3,
        22
      ],
      [
        -1,
        45
      ],
      [
        -4,
        40
      ],
      [
        -5,
        17
      ],
      [
        -13,
        10
      ],
      [
        6,
        -18
      ],
      [
        3,
        -17
      ],
      [
        -4,
        -15
      ],
      [
        -1,
        -27
      ],
      [
        -5,
        -30
      ],
      [
        -5,
        -13
      ],
      [
        -7,
        -41
      ],
      [
        -3,
        -29
      ],
      [
        -14,
        -17
      ],
      [
        -8,
        4
      ],
      [
        -17,
        -18
      ],
      [
        -12,
        -17
      ],
      [
        -9,
        -5
      ],
      [
        -3,
        -10
      ],
      [
        -4,
        -28
      ],
      [
        -3,
        -12
      ],
      [
        2,
        -36
      ],
      [
        -5,
        -27
      ],
      [
        -12,
        6
      ],
      [
        -6,
        -18
      ],
      [
        -1,
        -22
      ],
      [
        -5,
        -21
      ],
      [
        3,
        -20
      ],
      [
        -6,
        -33
      ],
      [
        -5,
        -3
      ],
      [
        -9,
        -38
      ],
      [
        -9,
        3
      ],
      [
        -1,
        -16
      ],
      [
        -6,
        -13
      ],
      [
        -5,
        9
      ],
      [
        -7,
        -14
      ],
      [
        -10,
        -39
      ],
      [
        -4,
        4
      ],
      [
        -8,
        -20
      ],
      [
        -6,
        9
      ],
      [
        -4,
        -8
      ],
      [
        -5,
        4
      ],
      [
        -2,
        15
      ],
      [
        -5,
        -8
      ],
      [
        -1,
        -14
      ],
      [
        -5,
        2
      ]
    ],
    [
      [
        17600,
        67683
      ],
      [
        -1,
        -6
      ],
      [
        -17,
        50
      ],
      [
        -62,
        192
      ],
      [
        -5,
        16
      ]
    ],
    [
      [
        18812,
        67724
      ],
      [
        17,
        0
      ],
      [
        9,
        -5
      ],
      [
        37,
        0
      ]
    ],
    [
      [
        18875,
        67719
      ],
      [
        43,
        0
      ],
      [
        5,
        -18
      ],
      [
        0,
        -19
      ],
      [
        5,
        -54
      ],
      [
        3,
        -5
      ],
      [
        7,
        9
      ],
      [
        8,
        -1
      ],
      [
        5,
        -17
      ],
      [
        11,
        -12
      ],
      [
        4,
        7
      ],
      [
        5,
        -9
      ],
      [
        3,
        -22
      ]
    ],
    [
      [
        18974,
        67578
      ],
      [
        0,
        -216
      ]
    ],
    [
      [
        18974,
        67362
      ],
      [
        0,
        -345
      ]
    ],
    [
      [
        18974,
        67017
      ],
      [
        -86,
        2
      ],
      [
        -2,
        0
      ],
      [
        -64,
        -1
      ]
    ],
    [
      [
        18822,
        67018
      ],
      [
        0,
        305
      ],
      [
        -65,
        0
      ],
      [
        0,
        98
      ],
      [
        -34,
        0
      ],
      [
        -28,
        1
      ],
      [
        1,
        50
      ],
      [
        -17,
        0
      ],
      [
        0,
        18
      ],
      [
        -116,
        0
      ],
      [
        0,
        234
      ]
    ],
    [
      [
        30108,
        65942
      ],
      [
        5,
        9
      ],
      [
        10,
        16
      ],
      [
        1,
        2
      ],
      [
        6,
        9
      ],
      [
        0,
        1
      ],
      [
        6,
        9
      ],
      [
        9,
        15
      ],
      [
        6,
        11
      ],
      [
        3,
        79
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        5
      ],
      [
        -1,
        8
      ],
      [
        -1,
        9
      ],
      [
        0,
        3
      ],
      [
        8,
        24
      ],
      [
        -4,
        25
      ],
      [
        -6,
        -13
      ],
      [
        -5,
        8
      ]
    ],
    [
      [
        30143,
        66162
      ],
      [
        2,
        8
      ],
      [
        4,
        12
      ],
      [
        5,
        5
      ],
      [
        2,
        2
      ],
      [
        7,
        1
      ],
      [
        1,
        -9
      ],
      [
        3,
        -18
      ],
      [
        2,
        -11
      ],
      [
        3,
        -9
      ],
      [
        6,
        -1
      ],
      [
        1,
        -2
      ]
    ],
    [
      [
        30179,
        66140
      ],
      [
        -5,
        -6
      ],
      [
        -3,
        -24
      ],
      [
        8,
        -46
      ],
      [
        10,
        26
      ],
      [
        1,
        3
      ],
      [
        2,
        31
      ]
    ],
    [
      [
        30192,
        66124
      ],
      [
        2,
        -3
      ],
      [
        2,
        -6
      ],
      [
        3,
        -18
      ],
      [
        2,
        -8
      ],
      [
        1,
        -2
      ],
      [
        4,
        -11
      ],
      [
        2,
        -3
      ],
      [
        1,
        -27
      ],
      [
        1,
        -19
      ],
      [
        2,
        -6
      ],
      [
        6,
        -35
      ],
      [
        2,
        -8
      ],
      [
        4,
        -21
      ],
      [
        7,
        -23
      ],
      [
        0,
        -8
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -10
      ],
      [
        1,
        -20
      ],
      [
        0,
        -6
      ],
      [
        -2,
        1
      ],
      [
        -5,
        -11
      ],
      [
        -1,
        -15
      ],
      [
        0,
        -3
      ],
      [
        1,
        -11
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        9
      ],
      [
        -3,
        0
      ],
      [
        -4,
        -6
      ],
      [
        0,
        -10
      ],
      [
        3,
        -14
      ],
      [
        7,
        -22
      ],
      [
        4,
        -9
      ],
      [
        3,
        -2
      ],
      [
        1,
        3
      ],
      [
        4,
        -13
      ],
      [
        2,
        -8
      ],
      [
        2,
        -4
      ],
      [
        3,
        1
      ],
      [
        3,
        8
      ],
      [
        4,
        3
      ],
      [
        8,
        -24
      ],
      [
        2,
        -15
      ],
      [
        0,
        -11
      ],
      [
        4,
        -21
      ],
      [
        2,
        -36
      ],
      [
        -3,
        -22
      ],
      [
        -2,
        -10
      ],
      [
        0,
        -18
      ],
      [
        1,
        -5
      ]
    ],
    [
      [
        30259,
        65611
      ],
      [
        -7,
        -29
      ],
      [
        -5,
        -5
      ],
      [
        -14,
        -22
      ],
      [
        2,
        -9
      ],
      [
        1,
        -9
      ],
      [
        -6,
        -34
      ]
    ],
    [
      [
        30230,
        65503
      ],
      [
        0,
        1
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -1
      ],
      [
        -4,
        8
      ],
      [
        -10,
        11
      ],
      [
        -3,
        5
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -3
      ],
      [
        2,
        -12
      ],
      [
        1,
        -22
      ],
      [
        0,
        -11
      ],
      [
        -3,
        4
      ],
      [
        -4,
        10
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        -20
      ],
      [
        0,
        -11
      ],
      [
        1,
        -8
      ],
      [
        0,
        -8
      ],
      [
        -2,
        -14
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        5
      ],
      [
        -1,
        4
      ],
      [
        0,
        2
      ],
      [
        -9,
        7
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -8
      ],
      [
        3,
        -6
      ],
      [
        1,
        -11
      ],
      [
        0,
        -3
      ],
      [
        -3,
        -5
      ],
      [
        -7,
        0
      ],
      [
        -2,
        4
      ]
    ],
    [
      [
        30174,
        65398
      ],
      [
        0,
        19
      ],
      [
        -4,
        43
      ],
      [
        -2,
        22
      ],
      [
        -6,
        70
      ],
      [
        -6,
        4
      ],
      [
        -4,
        32
      ],
      [
        -29,
        -15
      ],
      [
        3,
        24
      ],
      [
        -2,
        8
      ],
      [
        -4,
        12
      ],
      [
        18,
        52
      ],
      [
        -4,
        52
      ],
      [
        -2,
        1
      ],
      [
        1,
        1
      ],
      [
        0,
        10
      ],
      [
        -1,
        9
      ],
      [
        -1,
        7
      ],
      [
        -14,
        39
      ],
      [
        -2,
        23
      ],
      [
        0,
        2
      ],
      [
        -4,
        76
      ],
      [
        0,
        7
      ],
      [
        -3,
        46
      ]
    ],
    [
      [
        24349,
        53048
      ],
      [
        10,
        -14
      ],
      [
        8,
        13
      ],
      [
        8,
        -28
      ]
    ],
    [
      [
        24375,
        53019
      ],
      [
        -1,
        -11
      ],
      [
        0,
        -16
      ]
    ],
    [
      [
        24374,
        52992
      ],
      [
        5,
        -49
      ],
      [
        -5,
        -39
      ],
      [
        0,
        -44
      ],
      [
        4,
        -14
      ],
      [
        7,
        -6
      ],
      [
        5,
        7
      ],
      [
        7,
        0
      ],
      [
        3,
        -11
      ],
      [
        3,
        14
      ],
      [
        -2,
        40
      ],
      [
        -3,
        12
      ],
      [
        -9,
        6
      ],
      [
        -2,
        22
      ],
      [
        13,
        2
      ],
      [
        5,
        -3
      ],
      [
        8,
        -31
      ],
      [
        2,
        -20
      ],
      [
        -1,
        -25
      ],
      [
        -6,
        -70
      ],
      [
        -5,
        -15
      ],
      [
        -7,
        -6
      ],
      [
        -3,
        -8
      ],
      [
        0,
        -19
      ],
      [
        6,
        -17
      ],
      [
        5,
        -5
      ],
      [
        12,
        11
      ],
      [
        7,
        1
      ],
      [
        10,
        -6
      ],
      [
        15,
        25
      ],
      [
        6,
        -1
      ],
      [
        6,
        -40
      ],
      [
        3,
        -61
      ],
      [
        3,
        -13
      ]
    ],
    [
      [
        24466,
        52629
      ],
      [
        6,
        -10
      ],
      [
        -3,
        -20
      ],
      [
        -12,
        -52
      ],
      [
        0,
        -23
      ],
      [
        -9,
        0
      ],
      [
        -5,
        -33
      ],
      [
        0,
        -34
      ],
      [
        -19,
        0
      ],
      [
        -1,
        -16
      ]
    ],
    [
      [
        24423,
        52441
      ],
      [
        -11,
        0
      ],
      [
        -9,
        -17
      ],
      [
        -7,
        0
      ],
      [
        0,
        17
      ],
      [
        -33,
        0
      ]
    ],
    [
      [
        24363,
        52441
      ],
      [
        -15,
        0
      ]
    ],
    [
      [
        24348,
        52441
      ],
      [
        6,
        15
      ],
      [
        -6,
        61
      ],
      [
        1,
        48
      ],
      [
        3,
        33
      ],
      [
        -2,
        31
      ],
      [
        4,
        9
      ],
      [
        0,
        43
      ],
      [
        -7,
        44
      ],
      [
        1,
        22
      ],
      [
        -4,
        29
      ],
      [
        -11,
        30
      ],
      [
        3,
        21
      ],
      [
        -5,
        22
      ]
    ],
    [
      [
        24331,
        52849
      ],
      [
        -2,
        10
      ],
      [
        5,
        8
      ],
      [
        1,
        71
      ],
      [
        -1,
        56
      ],
      [
        2,
        12
      ],
      [
        5,
        5
      ],
      [
        2,
        18
      ],
      [
        6,
        19
      ]
    ],
    [
      [
        25362,
        70396
      ],
      [
        0,
        378
      ]
    ],
    [
      [
        25362,
        70774
      ],
      [
        139,
        0
      ],
      [
        0,
        -303
      ]
    ],
    [
      [
        25378,
        70232
      ],
      [
        -4,
        -1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        3
      ],
      [
        0,
        1
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        2
      ],
      [
        -2,
        5
      ],
      [
        -1,
        1
      ],
      [
        0,
        10
      ],
      [
        -1,
        3
      ],
      [
        0,
        1
      ],
      [
        -2,
        1
      ],
      [
        -4,
        6
      ],
      [
        -1,
        2
      ],
      [
        -1,
        9
      ],
      [
        1,
        3
      ],
      [
        0,
        2
      ],
      [
        2,
        5
      ],
      [
        1,
        3
      ],
      [
        1,
        4
      ],
      [
        1,
        5
      ],
      [
        1,
        2
      ],
      [
        1,
        0
      ],
      [
        1,
        2
      ],
      [
        2,
        11
      ],
      [
        2,
        6
      ],
      [
        1,
        2
      ],
      [
        1,
        6
      ],
      [
        0,
        3
      ],
      [
        2,
        -2
      ],
      [
        0,
        2
      ],
      [
        1,
        8
      ],
      [
        0,
        4
      ],
      [
        -3,
        6
      ],
      [
        0,
        1
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        2
      ],
      [
        0,
        2
      ],
      [
        -1,
        16
      ],
      [
        0,
        12
      ],
      [
        1,
        4
      ],
      [
        1,
        2
      ],
      [
        1,
        2
      ],
      [
        0,
        1
      ],
      [
        -1,
        3
      ],
      [
        -1,
        5
      ],
      [
        -4,
        0
      ]
    ],
    [
      [
        23700,
        60417
      ],
      [
        -1,
        -68
      ],
      [
        9,
        -1
      ]
    ],
    [
      [
        23708,
        60348
      ],
      [
        -2,
        -282
      ]
    ],
    [
      [
        23550,
        60077
      ],
      [
        0,
        213
      ],
      [
        1,
        97
      ],
      [
        -1,
        16
      ],
      [
        1,
        1
      ]
    ],
    [
      [
        21617,
        60463
      ],
      [
        9,
        0
      ]
    ],
    [
      [
        21747,
        60462
      ],
      [
        6,
        0
      ]
    ],
    [
      [
        21753,
        60462
      ],
      [
        0,
        -152
      ],
      [
        1,
        -302
      ]
    ],
    [
      [
        21754,
        60008
      ],
      [
        -41,
        -1
      ],
      [
        -40,
        -1
      ],
      [
        -16,
        0
      ],
      [
        -20,
        -1
      ],
      [
        -19,
        0
      ]
    ],
    [
      [
        21618,
        60005
      ],
      [
        -1,
        458
      ]
    ],
    [
      [
        24658,
        66423
      ],
      [
        7,
        -1
      ],
      [
        35,
        0
      ],
      [
        3,
        -1
      ],
      [
        15,
        0
      ]
    ],
    [
      [
        24718,
        66421
      ],
      [
        34,
        0
      ],
      [
        9,
        1
      ],
      [
        2,
        0
      ],
      [
        3,
        -1
      ],
      [
        1,
        1
      ],
      [
        49,
        0
      ],
      [
        16,
        -1
      ],
      [
        6,
        0
      ],
      [
        3,
        -1
      ],
      [
        8,
        -1
      ],
      [
        8,
        1
      ]
    ],
    [
      [
        24857,
        66420
      ],
      [
        2,
        -360
      ]
    ],
    [
      [
        24859,
        66060
      ],
      [
        -49,
        0
      ],
      [
        -62,
        -4
      ]
    ],
    [
      [
        24748,
        66056
      ],
      [
        -2,
        9
      ],
      [
        -3,
        2
      ],
      [
        -5,
        3
      ],
      [
        -3,
        6
      ],
      [
        -3,
        5
      ],
      [
        -4,
        12
      ],
      [
        -1,
        4
      ],
      [
        0,
        5
      ],
      [
        -2,
        7
      ],
      [
        -2,
        10
      ],
      [
        -2,
        5
      ],
      [
        -1,
        3
      ],
      [
        -1,
        6
      ],
      [
        0,
        8
      ],
      [
        -2,
        14
      ],
      [
        0,
        7
      ],
      [
        1,
        7
      ],
      [
        1,
        3
      ],
      [
        1,
        14
      ],
      [
        0,
        15
      ],
      [
        1,
        2
      ],
      [
        0,
        6
      ],
      [
        -1,
        4
      ],
      [
        0,
        2
      ],
      [
        -1,
        3
      ],
      [
        -2,
        5
      ],
      [
        -4,
        21
      ],
      [
        0,
        2
      ],
      [
        -2,
        3
      ],
      [
        -3,
        9
      ],
      [
        0,
        3
      ],
      [
        -2,
        10
      ],
      [
        -1,
        4
      ]
    ],
    [
      [
        24705,
        66275
      ],
      [
        -1,
        3
      ],
      [
        -2,
        0
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        7
      ],
      [
        -1,
        3
      ],
      [
        -2,
        4
      ],
      [
        -3,
        5
      ],
      [
        -9,
        12
      ],
      [
        -2,
        3
      ],
      [
        0,
        6
      ],
      [
        -1,
        9
      ],
      [
        0,
        5
      ],
      [
        -1,
        6
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        -3,
        3
      ],
      [
        -2,
        4
      ],
      [
        -5,
        4
      ],
      [
        -5,
        9
      ],
      [
        -5,
        11
      ],
      [
        -1,
        4
      ],
      [
        -2,
        8
      ],
      [
        -1,
        6
      ],
      [
        0,
        9
      ],
      [
        2,
        8
      ],
      [
        2,
        12
      ]
    ],
    [
      [
        24713,
        64233
      ],
      [
        0,
        102
      ]
    ],
    [
      [
        24841,
        64332
      ],
      [
        -1,
        -101
      ],
      [
        32,
        -1
      ],
      [
        1,
        -130
      ]
    ],
    [
      [
        24858,
        64010
      ],
      [
        -7,
        -13
      ],
      [
        -9,
        -37
      ],
      [
        -16,
        -21
      ],
      [
        -2,
        -12
      ],
      [
        -2,
        -20
      ],
      [
        1,
        -15
      ],
      [
        -5,
        -24
      ],
      [
        -1,
        -24
      ],
      [
        -7,
        -31
      ],
      [
        -3,
        -7
      ],
      [
        -3,
        -30
      ],
      [
        -5,
        -14
      ],
      [
        -6,
        -4
      ],
      [
        -6,
        -27
      ],
      [
        -6,
        -14
      ]
    ],
    [
      [
        24781,
        63717
      ],
      [
        -70,
        6
      ],
      [
        1,
        101
      ]
    ],
    [
      [
        28182,
        67420
      ],
      [
        5,
        5
      ],
      [
        3,
        -2
      ],
      [
        3,
        -5
      ],
      [
        9,
        -8
      ],
      [
        5,
        0
      ],
      [
        8,
        -8
      ],
      [
        16,
        -7
      ],
      [
        3,
        -2
      ],
      [
        3,
        -3
      ],
      [
        3,
        0
      ],
      [
        7,
        2
      ],
      [
        1,
        -4
      ],
      [
        7,
        -9
      ],
      [
        5,
        -8
      ],
      [
        3,
        -17
      ],
      [
        12,
        -30
      ],
      [
        2,
        -4
      ],
      [
        7,
        -9
      ],
      [
        2,
        -4
      ],
      [
        5,
        -13
      ],
      [
        7,
        -16
      ],
      [
        7,
        -9
      ],
      [
        5,
        -1
      ],
      [
        9,
        18
      ],
      [
        7,
        5
      ],
      [
        11,
        13
      ],
      [
        6,
        4
      ],
      [
        7,
        9
      ],
      [
        4,
        1
      ]
    ],
    [
      [
        28355,
        67035
      ],
      [
        -31,
        0
      ],
      [
        0,
        -106
      ],
      [
        -27,
        1
      ]
    ],
    [
      [
        28297,
        66930
      ],
      [
        -15,
        0
      ],
      [
        -35,
        -4
      ],
      [
        8,
        5
      ],
      [
        3,
        40
      ],
      [
        -3,
        10
      ],
      [
        -50,
        0
      ]
    ],
    [
      [
        28205,
        66981
      ],
      [
        1,
        17
      ],
      [
        1,
        40
      ],
      [
        -13,
        3
      ],
      [
        12,
        104
      ],
      [
        0,
        5
      ],
      [
        -25,
        0
      ]
    ],
    [
      [
        24336,
        73051
      ],
      [
        2,
        0
      ],
      [
        1,
        -7
      ],
      [
        2,
        4
      ],
      [
        4,
        1
      ],
      [
        1,
        1
      ],
      [
        0,
        4
      ],
      [
        2,
        0
      ],
      [
        0,
        -5
      ],
      [
        2,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        1
      ],
      [
        0,
        6
      ],
      [
        1,
        0
      ],
      [
        6,
        -6
      ],
      [
        1,
        -6
      ],
      [
        0,
        -8
      ],
      [
        -3,
        -8
      ],
      [
        0,
        -13
      ],
      [
        1,
        3
      ],
      [
        3,
        1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -13
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -1
      ],
      [
        1,
        -9
      ],
      [
        2,
        0
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -11
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -2
      ],
      [
        2,
        -2
      ],
      [
        3,
        4
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        2,
        3
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -7
      ],
      [
        2,
        -4
      ],
      [
        1,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        1,
        2
      ],
      [
        0,
        3
      ],
      [
        2,
        3
      ],
      [
        1,
        0
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        4,
        -15
      ],
      [
        7,
        6
      ],
      [
        7,
        0
      ],
      [
        4,
        5
      ],
      [
        5,
        2
      ],
      [
        1,
        -6
      ],
      [
        -4,
        -11
      ],
      [
        -2,
        -32
      ],
      [
        1,
        -10
      ],
      [
        -1,
        -10
      ],
      [
        2,
        -6
      ],
      [
        7,
        11
      ],
      [
        15,
        17
      ],
      [
        7,
        -1
      ],
      [
        4,
        2
      ],
      [
        1,
        -1
      ],
      [
        0,
        -5
      ],
      [
        2,
        -13
      ],
      [
        0,
        -4
      ],
      [
        3,
        0
      ],
      [
        4,
        5
      ],
      [
        6,
        5
      ],
      [
        4,
        9
      ],
      [
        2,
        5
      ],
      [
        2,
        -3
      ],
      [
        4,
        6
      ],
      [
        3,
        1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        0,
        1
      ],
      [
        1,
        2
      ],
      [
        3,
        1
      ],
      [
        1,
        -1
      ],
      [
        2,
        0
      ],
      [
        4,
        1
      ],
      [
        4,
        6
      ],
      [
        2,
        0
      ],
      [
        5,
        6
      ],
      [
        4,
        14
      ],
      [
        2,
        4
      ],
      [
        4,
        4
      ],
      [
        6,
        26
      ],
      [
        2,
        -4
      ],
      [
        2,
        5
      ],
      [
        6,
        17
      ],
      [
        5,
        10
      ],
      [
        0,
        8
      ],
      [
        5,
        5
      ],
      [
        1,
        2
      ],
      [
        0,
        4
      ],
      [
        2,
        3
      ],
      [
        3,
        3
      ],
      [
        2,
        3
      ],
      [
        1,
        5
      ],
      [
        1,
        4
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        1,
        0
      ],
      [
        3,
        2
      ],
      [
        1,
        5
      ],
      [
        2,
        2
      ],
      [
        3,
        2
      ],
      [
        2,
        1
      ],
      [
        1,
        0
      ],
      [
        0,
        -1
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        24552,
        72192
      ],
      [
        -3,
        -8
      ],
      [
        -3,
        -2
      ],
      [
        -9,
        -32
      ],
      [
        -6,
        -17
      ],
      [
        -2,
        -3
      ],
      [
        -6,
        -14
      ],
      [
        -1,
        -7
      ],
      [
        -5,
        -14
      ],
      [
        -2,
        -3
      ],
      [
        -4,
        -15
      ],
      [
        -5,
        -30
      ],
      [
        -5,
        -13
      ],
      [
        -9,
        -28
      ],
      [
        -3,
        -17
      ],
      [
        -4,
        -13
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -5,
        -13
      ],
      [
        -10,
        -32
      ],
      [
        -8,
        -30
      ],
      [
        -1,
        -7
      ],
      [
        -5,
        -11
      ],
      [
        -3,
        -12
      ],
      [
        -4,
        -4
      ],
      [
        -5,
        -14
      ],
      [
        -10,
        -31
      ],
      [
        -1,
        -7
      ],
      [
        -6,
        -16
      ],
      [
        -5,
        -3
      ],
      [
        -3,
        -5
      ],
      [
        -3,
        -12
      ],
      [
        -15,
        -21
      ],
      [
        -5,
        -25
      ],
      [
        -3,
        -6
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -5
      ],
      [
        -4,
        -11
      ],
      [
        -3,
        -11
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -12
      ],
      [
        -5,
        -8
      ],
      [
        -1,
        -6
      ],
      [
        -11,
        -11
      ],
      [
        -9,
        -26
      ],
      [
        -11,
        -36
      ],
      [
        -1,
        -7
      ],
      [
        -4,
        -7
      ]
    ],
    [
      [
        16107,
        67713
      ],
      [
        92,
        0
      ],
      [
        8,
        -2
      ],
      [
        167,
        -4
      ],
      [
        134,
        -1
      ]
    ],
    [
      [
        16508,
        67706
      ],
      [
        0,
        -503
      ],
      [
        -10,
        0
      ],
      [
        0,
        -305
      ],
      [
        -3,
        0
      ],
      [
        -1,
        -198
      ],
      [
        59,
        0
      ],
      [
        8,
        2
      ],
      [
        95,
        1
      ],
      [
        0,
        -712
      ],
      [
        1,
        -3
      ],
      [
        0,
        -164
      ]
    ],
    [
      [
        16657,
        65824
      ],
      [
        -23,
        1
      ],
      [
        -79,
        1
      ],
      [
        -18,
        2
      ],
      [
        -27,
        0
      ],
      [
        -28,
        -2
      ],
      [
        -3,
        -1
      ]
    ],
    [
      [
        16479,
        65825
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        16479,
        65825
      ],
      [
        -51,
        -1
      ],
      [
        -29,
        -1
      ],
      [
        -12,
        0
      ],
      [
        -48,
        1
      ],
      [
        -40,
        -1
      ],
      [
        -14,
        0
      ],
      [
        -32,
        1
      ],
      [
        -19,
        0
      ]
    ],
    [
      [
        16234,
        65824
      ],
      [
        -1,
        399
      ],
      [
        0,
        2
      ],
      [
        1,
        168
      ],
      [
        -1,
        304
      ],
      [
        -24,
        0
      ],
      [
        -8,
        3
      ],
      [
        -98,
        0
      ],
      [
        0,
        710
      ],
      [
        5,
        0
      ],
      [
        -1,
        303
      ]
    ],
    [
      [
        30076,
        65453
      ],
      [
        0,
        -1
      ],
      [
        1,
        0
      ],
      [
        3,
        -2
      ],
      [
        2,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -1
      ],
      [
        4,
        -3
      ],
      [
        3,
        -1
      ],
      [
        2,
        -2
      ],
      [
        3,
        -2
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -21
      ],
      [
        0,
        -15
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -22
      ],
      [
        1,
        -3
      ],
      [
        2,
        -10
      ],
      [
        0,
        -2
      ],
      [
        2,
        -81
      ],
      [
        1,
        -29
      ]
    ],
    [
      [
        30097,
        65246
      ],
      [
        -5,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -5
      ],
      [
        -7,
        -17
      ],
      [
        -1,
        -8
      ],
      [
        -6,
        -7
      ],
      [
        -1,
        1
      ],
      [
        0,
        7
      ],
      [
        2,
        15
      ],
      [
        0,
        7
      ],
      [
        -3,
        9
      ],
      [
        0,
        4
      ],
      [
        -2,
        5
      ],
      [
        2,
        17
      ],
      [
        -4,
        37
      ],
      [
        1,
        29
      ],
      [
        1,
        35
      ],
      [
        -2,
        11
      ],
      [
        0,
        15
      ],
      [
        -1,
        3
      ],
      [
        -3,
        -4
      ],
      [
        -4,
        -3
      ],
      [
        0,
        -37
      ],
      [
        2,
        -15
      ],
      [
        0,
        -49
      ],
      [
        2,
        -5
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -8
      ],
      [
        -3,
        -17
      ],
      [
        1,
        -16
      ],
      [
        1,
        -4
      ],
      [
        -2,
        -10
      ],
      [
        -1,
        -3
      ],
      [
        0,
        11
      ],
      [
        -2,
        5
      ],
      [
        -3,
        4
      ],
      [
        -6,
        -1
      ],
      [
        -3,
        -4
      ],
      [
        -2,
        -35
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        1
      ],
      [
        0,
        4
      ],
      [
        -2,
        1
      ],
      [
        -5,
        -8
      ],
      [
        -3,
        2
      ],
      [
        -4,
        12
      ],
      [
        1,
        5
      ],
      [
        4,
        7
      ],
      [
        3,
        -2
      ],
      [
        2,
        8
      ],
      [
        0,
        8
      ],
      [
        -4,
        15
      ],
      [
        0,
        3
      ],
      [
        2,
        4
      ],
      [
        1,
        7
      ],
      [
        0,
        12
      ],
      [
        3,
        11
      ],
      [
        2,
        8
      ],
      [
        1,
        14
      ],
      [
        2,
        15
      ],
      [
        1,
        4
      ],
      [
        2,
        10
      ],
      [
        1,
        2
      ],
      [
        1,
        5
      ],
      [
        3,
        34
      ],
      [
        1,
        10
      ],
      [
        -1,
        3
      ],
      [
        0,
        2
      ],
      [
        1,
        5
      ],
      [
        4,
        14
      ],
      [
        2,
        3
      ],
      [
        1,
        1
      ],
      [
        4,
        1
      ],
      [
        3,
        16
      ],
      [
        3,
        3
      ],
      [
        1,
        2
      ],
      [
        3,
        20
      ]
    ],
    [
      [
        30029,
        65436
      ],
      [
        5,
        7
      ],
      [
        2,
        -9
      ],
      [
        1,
        -13
      ],
      [
        1,
        -5
      ],
      [
        2,
        -9
      ],
      [
        3,
        -6
      ],
      [
        2,
        -10
      ],
      [
        1,
        -18
      ],
      [
        -1,
        -10
      ],
      [
        -3,
        -17
      ],
      [
        -2,
        -6
      ],
      [
        -2,
        2
      ],
      [
        -1,
        7
      ],
      [
        0,
        10
      ],
      [
        1,
        13
      ],
      [
        1,
        4
      ],
      [
        1,
        8
      ],
      [
        0,
        9
      ],
      [
        -2,
        7
      ],
      [
        -4,
        3
      ],
      [
        -1,
        4
      ],
      [
        -4,
        18
      ],
      [
        0,
        11
      ]
    ],
    [
      [
        30019,
        65203
      ],
      [
        1,
        37
      ],
      [
        3,
        1
      ],
      [
        2,
        13
      ],
      [
        -3,
        12
      ],
      [
        -1,
        11
      ],
      [
        2,
        38
      ],
      [
        2,
        13
      ],
      [
        1,
        6
      ],
      [
        1,
        1
      ],
      [
        2,
        -4
      ],
      [
        1,
        -17
      ],
      [
        -1,
        -63
      ],
      [
        1,
        -22
      ],
      [
        -6,
        -10
      ],
      [
        0,
        -11
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -7
      ],
      [
        -3,
        -7
      ],
      [
        0,
        14
      ]
    ],
    [
      [
        28985,
        67711
      ],
      [
        -16,
        561
      ]
    ],
    [
      [
        28969,
        68272
      ],
      [
        30,
        -54
      ],
      [
        58,
        22
      ]
    ],
    [
      [
        29057,
        68240
      ],
      [
        22,
        -679
      ],
      [
        -26,
        -171
      ],
      [
        43,
        -62
      ]
    ],
    [
      [
        29096,
        67328
      ],
      [
        5,
        -130
      ],
      [
        -6,
        -11
      ],
      [
        2,
        -18
      ],
      [
        -7,
        -6
      ],
      [
        2,
        -22
      ],
      [
        -9,
        -7
      ],
      [
        -4,
        -42
      ],
      [
        3,
        -30
      ],
      [
        1,
        -12
      ]
    ],
    [
      [
        29083,
        67050
      ],
      [
        4,
        -19
      ],
      [
        1,
        -37
      ],
      [
        0,
        -3
      ],
      [
        -6,
        -155
      ]
    ],
    [
      [
        29082,
        66836
      ],
      [
        -32,
        40
      ],
      [
        -5,
        -77
      ],
      [
        -3,
        -8
      ],
      [
        -13,
        25
      ],
      [
        -41,
        72
      ],
      [
        -11,
        -56
      ],
      [
        -20,
        -4
      ],
      [
        0,
        27
      ]
    ],
    [
      [
        28957,
        66855
      ],
      [
        3,
        1
      ],
      [
        -2,
        70
      ],
      [
        -2,
        95
      ],
      [
        -1,
        35
      ],
      [
        3,
        14
      ],
      [
        7,
        12
      ],
      [
        1,
        23
      ],
      [
        5,
        23
      ],
      [
        26,
        131
      ],
      [
        -15,
        16
      ],
      [
        -11,
        21
      ],
      [
        4,
        54
      ],
      [
        8,
        -1
      ],
      [
        3,
        11
      ],
      [
        2,
        13
      ],
      [
        7,
        7
      ],
      [
        -10,
        331
      ]
    ],
    [
      [
        20934,
        60006
      ],
      [
        77,
        2
      ],
      [
        161,
        3
      ],
      [
        19,
        0
      ]
    ],
    [
      [
        21215,
        60011
      ],
      [
        0,
        -327
      ],
      [
        -1,
        -52
      ],
      [
        1,
        -67
      ],
      [
        0,
        -17
      ],
      [
        -1,
        -89
      ],
      [
        0,
        -30
      ]
    ],
    [
      [
        21214,
        59429
      ],
      [
        -11,
        0
      ],
      [
        0,
        -212
      ],
      [
        1,
        -1
      ],
      [
        0,
        -305
      ]
    ],
    [
      [
        21204,
        58911
      ],
      [
        0,
        -254
      ],
      [
        -1,
        -14
      ],
      [
        1,
        -13
      ],
      [
        -1,
        -21
      ],
      [
        1,
        -5
      ],
      [
        0,
        -61
      ]
    ],
    [
      [
        21204,
        58543
      ],
      [
        -93,
        0
      ]
    ],
    [
      [
        21111,
        58543
      ],
      [
        0,
        302
      ],
      [
        2,
        0
      ],
      [
        0,
        102
      ],
      [
        -119,
        -1
      ],
      [
        0,
        103
      ],
      [
        -60,
        1
      ],
      [
        0,
        50
      ]
    ],
    [
      [
        20934,
        59100
      ],
      [
        0,
        906
      ]
    ],
    [
      [
        23449,
        51727
      ],
      [
        150,
        6
      ]
    ],
    [
      [
        23599,
        51733
      ],
      [
        0,
        -2
      ],
      [
        24,
        0
      ],
      [
        1,
        -321
      ],
      [
        0,
        -58
      ]
    ],
    [
      [
        23624,
        51352
      ],
      [
        -5,
        -7
      ]
    ],
    [
      [
        23619,
        51345
      ],
      [
        0,
        48
      ],
      [
        -5,
        -2
      ],
      [
        -8,
        -7
      ],
      [
        2,
        -20
      ],
      [
        -3,
        -7
      ],
      [
        -15,
        -9
      ],
      [
        -10,
        -18
      ]
    ],
    [
      [
        23580,
        51330
      ],
      [
        -3,
        3
      ],
      [
        -1,
        8
      ],
      [
        -5,
        19
      ],
      [
        -1,
        4
      ],
      [
        -2,
        2
      ],
      [
        -4,
        -2
      ],
      [
        -3,
        -6
      ],
      [
        -4,
        -7
      ],
      [
        -9,
        -10
      ],
      [
        -18,
        -17
      ],
      [
        -8,
        -5
      ],
      [
        -6,
        -9
      ],
      [
        -5,
        -1
      ],
      [
        -3,
        1
      ],
      [
        -3,
        6
      ],
      [
        -3,
        20
      ],
      [
        3,
        2
      ],
      [
        3,
        -2
      ],
      [
        4,
        17
      ],
      [
        6,
        25
      ],
      [
        7,
        48
      ],
      [
        4,
        80
      ],
      [
        1,
        11
      ],
      [
        -1,
        23
      ],
      [
        0,
        40
      ],
      [
        -4,
        0
      ],
      [
        -3,
        10
      ],
      [
        -5,
        -5
      ],
      [
        -5,
        23
      ],
      [
        -4,
        -9
      ],
      [
        -6,
        -8
      ],
      [
        -7,
        -12
      ],
      [
        -10,
        -41
      ],
      [
        -3,
        -31
      ],
      [
        -1,
        -19
      ],
      [
        -2,
        -9
      ],
      [
        -5,
        -11
      ],
      [
        -6,
        -6
      ],
      [
        -2,
        2
      ],
      [
        -3,
        18
      ]
    ],
    [
      [
        23463,
        51482
      ],
      [
        5,
        28
      ],
      [
        -4,
        0
      ],
      [
        -1,
        19
      ],
      [
        -4,
        3
      ],
      [
        5,
        29
      ],
      [
        4,
        29
      ],
      [
        -3,
        42
      ],
      [
        4,
        22
      ],
      [
        -7,
        15
      ],
      [
        -5,
        25
      ],
      [
        -7,
        14
      ],
      [
        -1,
        19
      ]
    ],
    [
      [
        16242,
        73980
      ],
      [
        37,
        -1
      ],
      [
        95,
        1
      ],
      [
        95,
        -1
      ],
      [
        9,
        0
      ],
      [
        35,
        1
      ],
      [
        117,
        0
      ],
      [
        8,
        -1
      ],
      [
        81,
        1
      ],
      [
        84,
        0
      ]
    ],
    [
      [
        16803,
        73980
      ],
      [
        0,
        -404
      ],
      [
        -9,
        0
      ],
      [
        0,
        -200
      ],
      [
        7,
        0
      ],
      [
        -1,
        -603
      ],
      [
        -1,
        -7
      ]
    ],
    [
      [
        16799,
        72766
      ],
      [
        -30,
        -20
      ],
      [
        -4,
        3
      ]
    ],
    [
      [
        16762,
        72771
      ],
      [
        5,
        25
      ],
      [
        4,
        41
      ],
      [
        -8,
        21
      ],
      [
        -6,
        7
      ],
      [
        -5,
        31
      ],
      [
        -3,
        51
      ],
      [
        -7,
        28
      ],
      [
        -14,
        4
      ],
      [
        -5,
        10
      ],
      [
        -8,
        -4
      ],
      [
        -8,
        -21
      ],
      [
        -5,
        -3
      ],
      [
        -5,
        -12
      ],
      [
        -5,
        -2
      ],
      [
        -6,
        -13
      ],
      [
        -12,
        16
      ],
      [
        -8,
        -22
      ],
      [
        0,
        -31
      ],
      [
        -4,
        -24
      ],
      [
        -8,
        3
      ],
      [
        -9,
        -2
      ],
      [
        -9,
        30
      ],
      [
        -18,
        7
      ],
      [
        -4,
        -9
      ],
      [
        -1,
        -14
      ],
      [
        -21,
        -49
      ],
      [
        -6,
        -24
      ],
      [
        -4,
        -4
      ],
      [
        -6,
        4
      ],
      [
        -10,
        27
      ],
      [
        -2,
        10
      ],
      [
        7,
        42
      ],
      [
        -4,
        30
      ],
      [
        -5,
        -11
      ],
      [
        -7,
        1
      ],
      [
        -6,
        21
      ],
      [
        -7,
        1
      ],
      [
        -2,
        -20
      ],
      [
        -8,
        0
      ],
      [
        -10,
        -11
      ],
      [
        -13,
        -26
      ],
      [
        -1,
        -6
      ],
      [
        7,
        -36
      ],
      [
        -1,
        -30
      ],
      [
        -2,
        -27
      ],
      [
        3,
        -11
      ]
    ],
    [
      [
        16283,
        73434
      ],
      [
        -2,
        12
      ],
      [
        6,
        39
      ],
      [
        -9,
        24
      ],
      [
        -3,
        -16
      ],
      [
        -8,
        1
      ],
      [
        -7,
        22
      ],
      [
        -1,
        27
      ],
      [
        10,
        37
      ]
    ],
    [
      [
        16269,
        73580
      ],
      [
        10,
        20
      ],
      [
        4,
        26
      ],
      [
        7,
        0
      ],
      [
        0,
        25
      ],
      [
        6,
        7
      ],
      [
        -6,
        13
      ],
      [
        -9,
        43
      ],
      [
        -4,
        1
      ],
      [
        -3,
        16
      ],
      [
        -2,
        41
      ],
      [
        3,
        38
      ],
      [
        -1,
        11
      ],
      [
        -9,
        14
      ],
      [
        1,
        27
      ],
      [
        -2,
        9
      ],
      [
        0,
        24
      ],
      [
        5,
        10
      ],
      [
        -4,
        21
      ],
      [
        -7,
        6
      ],
      [
        -12,
        -23
      ],
      [
        -4,
        19
      ],
      [
        -7,
        8
      ],
      [
        -3,
        14
      ],
      [
        6,
        6
      ],
      [
        4,
        24
      ]
    ],
    [
      [
        25861,
        56449
      ],
      [
        1,
        11
      ],
      [
        9,
        39
      ],
      [
        3,
        7
      ],
      [
        7,
        -28
      ],
      [
        6,
        20
      ],
      [
        9,
        7
      ],
      [
        4,
        -19
      ],
      [
        5,
        -8
      ],
      [
        0,
        -45
      ],
      [
        5,
        -7
      ],
      [
        2,
        -25
      ],
      [
        8,
        5
      ],
      [
        5,
        -49
      ],
      [
        6,
        5
      ],
      [
        5,
        -23
      ],
      [
        -3,
        -4
      ]
    ],
    [
      [
        25933,
        56335
      ],
      [
        4,
        -21
      ],
      [
        -3,
        -31
      ],
      [
        5,
        -41
      ],
      [
        -4,
        -2
      ],
      [
        -7,
        -24
      ],
      [
        -4,
        -4
      ],
      [
        -7,
        -30
      ],
      [
        -6,
        -2
      ],
      [
        0,
        -35
      ]
    ],
    [
      [
        25911,
        56145
      ],
      [
        -3,
        -9
      ],
      [
        -4,
        9
      ],
      [
        -2,
        20
      ],
      [
        -3,
        3
      ],
      [
        -5,
        -11
      ],
      [
        1,
        -15
      ],
      [
        8,
        -20
      ],
      [
        3,
        -27
      ],
      [
        -2,
        -20
      ],
      [
        -8,
        -12
      ],
      [
        4,
        -18
      ],
      [
        -1,
        -3
      ],
      [
        -7,
        4
      ],
      [
        -2,
        -7
      ],
      [
        3,
        -33
      ],
      [
        5,
        -8
      ],
      [
        0,
        -11
      ],
      [
        -10,
        -27
      ],
      [
        -2,
        -30
      ],
      [
        -5,
        -7
      ],
      [
        -4,
        9
      ],
      [
        1,
        18
      ],
      [
        -5,
        -1
      ],
      [
        -8,
        -68
      ],
      [
        -4,
        -9
      ],
      [
        -3,
        -23
      ],
      [
        -3,
        -17
      ],
      [
        -9,
        -23
      ]
    ],
    [
      [
        25846,
        55809
      ],
      [
        0,
        130
      ],
      [
        -29,
        0
      ],
      [
        0,
        51
      ],
      [
        -10,
        0
      ]
    ],
    [
      [
        25790,
        56245
      ],
      [
        1,
        43
      ],
      [
        15,
        0
      ],
      [
        3,
        10
      ],
      [
        9,
        5
      ],
      [
        9,
        13
      ],
      [
        2,
        -7
      ],
      [
        9,
        18
      ],
      [
        8,
        30
      ],
      [
        10,
        29
      ],
      [
        -2,
        24
      ],
      [
        8,
        30
      ],
      [
        -1,
        9
      ]
    ],
    [
      [
        25309,
        66542
      ],
      [
        10,
        0
      ],
      [
        23,
        1
      ],
      [
        0,
        67
      ],
      [
        90,
        -1
      ],
      [
        5,
        -1
      ],
      [
        11,
        0
      ]
    ],
    [
      [
        25448,
        66608
      ],
      [
        -2,
        -28
      ],
      [
        -2,
        -32
      ],
      [
        1,
        -11
      ],
      [
        1,
        -12
      ],
      [
        0,
        -3
      ],
      [
        1,
        -8
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -27
      ],
      [
        1,
        -30
      ],
      [
        0,
        -18
      ],
      [
        3,
        -27
      ]
    ],
    [
      [
        25450,
        66403
      ],
      [
        -4,
        0
      ],
      [
        -8,
        1
      ],
      [
        -15,
        1
      ],
      [
        -1,
        0
      ],
      [
        -20,
        1
      ],
      [
        -5,
        0
      ],
      [
        -17,
        1
      ],
      [
        -12,
        1
      ],
      [
        -29,
        0
      ]
    ],
    [
      [
        25339,
        66408
      ],
      [
        -14,
        0
      ],
      [
        -6,
        -1
      ],
      [
        -10,
        0
      ]
    ],
    [
      [
        25309,
        66407
      ],
      [
        0,
        135
      ]
    ],
    [
      [
        31371,
        38071
      ],
      [
        1,
        -6
      ],
      [
        6,
        5
      ]
    ],
    [
      [
        31378,
        38070
      ],
      [
        -2,
        -52
      ],
      [
        3,
        -26
      ],
      [
        7,
        16
      ],
      [
        11,
        -20
      ],
      [
        7,
        1
      ]
    ],
    [
      [
        31404,
        37989
      ],
      [
        0,
        -7
      ],
      [
        1,
        -33
      ],
      [
        0,
        -6
      ]
    ],
    [
      [
        31398,
        37874
      ],
      [
        -1,
        4
      ],
      [
        -2,
        4
      ],
      [
        -8,
        0
      ],
      [
        -6,
        -5
      ],
      [
        0,
        -1
      ],
      [
        -8,
        -11
      ]
    ],
    [
      [
        31373,
        37865
      ],
      [
        0,
        18
      ],
      [
        3,
        14
      ],
      [
        -3,
        32
      ],
      [
        1,
        12
      ],
      [
        -3,
        15
      ],
      [
        1,
        17
      ],
      [
        -3,
        19
      ],
      [
        2,
        13
      ],
      [
        -4,
        22
      ],
      [
        -1,
        29
      ],
      [
        4,
        14
      ]
    ],
    [
      [
        25047,
        67743
      ],
      [
        -98,
        0
      ]
    ],
    [
      [
        24949,
        67743
      ],
      [
        0,
        395
      ]
    ],
    [
      [
        24648,
        70466
      ],
      [
        105,
        -1
      ]
    ],
    [
      [
        24753,
        70465
      ],
      [
        72,
        1
      ]
    ],
    [
      [
        24825,
        70466
      ],
      [
        0,
        -99
      ]
    ],
    [
      [
        24825,
        70367
      ],
      [
        -1,
        -92
      ],
      [
        1,
        -102
      ],
      [
        0,
        -204
      ]
    ],
    [
      [
        24648,
        69763
      ],
      [
        0,
        303
      ]
    ],
    [
      [
        31571,
        38386
      ],
      [
        -6,
        -25
      ],
      [
        -2,
        -23
      ],
      [
        -3,
        -5
      ]
    ],
    [
      [
        31546,
        38362
      ],
      [
        -3,
        30
      ],
      [
        -9,
        6
      ],
      [
        -1,
        -1
      ],
      [
        -7,
        29
      ]
    ],
    [
      [
        31526,
        38426
      ],
      [
        0,
        3
      ],
      [
        9,
        -10
      ],
      [
        9,
        -8
      ],
      [
        3,
        0
      ],
      [
        2,
        2
      ],
      [
        1,
        5
      ],
      [
        7,
        -15
      ],
      [
        9,
        -5
      ],
      [
        2,
        -2
      ],
      [
        3,
        -6
      ],
      [
        0,
        -4
      ]
    ],
    [
      [
        17697,
        72209
      ],
      [
        -1,
        -7
      ],
      [
        -2,
        -15
      ],
      [
        -3,
        -5
      ],
      [
        -6,
        -2
      ],
      [
        -6,
        3
      ],
      [
        -7,
        -4
      ],
      [
        -3,
        -10
      ],
      [
        -6,
        -4
      ],
      [
        -3,
        -22
      ],
      [
        6,
        4
      ],
      [
        5,
        -2
      ],
      [
        1,
        -4
      ],
      [
        2,
        -4
      ],
      [
        5,
        -3
      ],
      [
        10,
        -17
      ],
      [
        2,
        -12
      ],
      [
        1,
        -9
      ],
      [
        2,
        -4
      ],
      [
        6,
        4
      ],
      [
        2,
        -2
      ],
      [
        9,
        -16
      ],
      [
        2,
        -12
      ],
      [
        2,
        -3
      ],
      [
        2,
        -1
      ],
      [
        1,
        -4
      ],
      [
        1,
        -20
      ],
      [
        5,
        -21
      ],
      [
        1,
        -13
      ],
      [
        4,
        -9
      ],
      [
        7,
        -10
      ],
      [
        5,
        -2
      ],
      [
        4,
        -9
      ],
      [
        3,
        0
      ],
      [
        5,
        2
      ],
      [
        1,
        -3
      ],
      [
        0,
        -6
      ],
      [
        3,
        -8
      ],
      [
        11,
        1
      ],
      [
        2,
        -5
      ],
      [
        2,
        -2
      ],
      [
        5,
        3
      ],
      [
        4,
        -7
      ],
      [
        0,
        -13
      ],
      [
        3,
        -13
      ],
      [
        1,
        -5
      ],
      [
        1,
        1
      ],
      [
        3,
        -6
      ],
      [
        1,
        -5
      ],
      [
        0,
        -13
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -13
      ],
      [
        0,
        -7
      ],
      [
        4,
        -6
      ],
      [
        7,
        -1
      ],
      [
        2,
        -9
      ],
      [
        0,
        -13
      ],
      [
        3,
        -15
      ],
      [
        6,
        -2
      ],
      [
        6,
        -11
      ],
      [
        3,
        -9
      ],
      [
        5,
        -22
      ],
      [
        0,
        -7
      ],
      [
        9,
        -16
      ],
      [
        0,
        -9
      ],
      [
        1,
        -8
      ],
      [
        4,
        -20
      ],
      [
        4,
        -14
      ],
      [
        1,
        -2
      ],
      [
        2,
        2
      ],
      [
        2,
        -4
      ],
      [
        5,
        -27
      ],
      [
        1,
        -30
      ],
      [
        3,
        -11
      ],
      [
        2,
        -19
      ],
      [
        1,
        -1
      ],
      [
        4,
        2
      ],
      [
        1,
        2
      ],
      [
        0,
        3
      ],
      [
        7,
        -5
      ],
      [
        1,
        -5
      ],
      [
        4,
        -18
      ],
      [
        6,
        -22
      ]
    ],
    [
      [
        17882,
        71573
      ],
      [
        -241,
        1
      ],
      [
        -140,
        1
      ]
    ],
    [
      [
        17501,
        71575
      ],
      [
        0,
        102
      ]
    ],
    [
      [
        17501,
        72133
      ],
      [
        0,
        555
      ]
    ],
    [
      [
        17501,
        72688
      ],
      [
        0,
        148
      ],
      [
        16,
        51
      ],
      [
        11,
        8
      ],
      [
        8,
        -26
      ],
      [
        12,
        -29
      ],
      [
        12,
        14
      ],
      [
        4,
        -25
      ],
      [
        12,
        -19
      ],
      [
        4,
        -21
      ]
    ],
    [
      [
        27119,
        58976
      ],
      [
        37,
        13
      ],
      [
        4,
        -5
      ],
      [
        32,
        -1
      ]
    ],
    [
      [
        27192,
        58983
      ],
      [
        11,
        -24
      ],
      [
        8,
        0
      ],
      [
        3,
        -13
      ],
      [
        3,
        7
      ],
      [
        4,
        -23
      ],
      [
        5,
        7
      ],
      [
        8,
        -13
      ],
      [
        2,
        -19
      ],
      [
        -2,
        -11
      ],
      [
        4,
        4
      ],
      [
        11,
        -24
      ],
      [
        4,
        -32
      ]
    ],
    [
      [
        27251,
        58609
      ],
      [
        -6,
        -19
      ],
      [
        1,
        -4
      ],
      [
        -3,
        -10
      ]
    ],
    [
      [
        27243,
        58576
      ],
      [
        -4,
        -12
      ],
      [
        -6,
        1
      ],
      [
        -7,
        16
      ],
      [
        -4,
        2
      ],
      [
        -1,
        12
      ],
      [
        -31,
        -8
      ],
      [
        -13,
        56
      ],
      [
        -3,
        -7
      ],
      [
        -5,
        13
      ],
      [
        -3,
        21
      ],
      [
        -19,
        31
      ],
      [
        -10,
        39
      ],
      [
        -4,
        23
      ],
      [
        -5,
        -2
      ],
      [
        0,
        24
      ],
      [
        -5,
        2
      ],
      [
        -3,
        15
      ]
    ],
    [
      [
        27120,
        58802
      ],
      [
        20,
        123
      ],
      [
        -7,
        11
      ],
      [
        -1,
        15
      ],
      [
        -13,
        25
      ]
    ],
    [
      [
        21701,
        71959
      ],
      [
        11,
        -19
      ],
      [
        6,
        1
      ],
      [
        3,
        35
      ],
      [
        22,
        19
      ],
      [
        13,
        -3
      ],
      [
        7,
        -8
      ],
      [
        9,
        -17
      ],
      [
        7,
        -25
      ],
      [
        0,
        -18
      ],
      [
        -5,
        -35
      ],
      [
        3,
        -36
      ],
      [
        5,
        -20
      ]
    ],
    [
      [
        21782,
        71833
      ],
      [
        6,
        -20
      ],
      [
        2,
        -53
      ],
      [
        3,
        -19
      ],
      [
        12,
        -35
      ],
      [
        1,
        -29
      ],
      [
        -5,
        -23
      ],
      [
        -11,
        -23
      ]
    ],
    [
      [
        21790,
        71631
      ],
      [
        -178,
        -2
      ],
      [
        -53,
        0
      ]
    ],
    [
      [
        21559,
        71629
      ],
      [
        0,
        303
      ],
      [
        141,
        0
      ],
      [
        1,
        27
      ]
    ],
    [
      [
        23163,
        63807
      ],
      [
        127,
        1
      ]
    ],
    [
      [
        23290,
        63808
      ],
      [
        2,
        -4
      ],
      [
        7,
        -11
      ],
      [
        1,
        -1
      ],
      [
        5,
        1
      ],
      [
        2,
        -1
      ],
      [
        2,
        -1
      ],
      [
        0,
        -2
      ],
      [
        2,
        -4
      ],
      [
        1,
        -8
      ],
      [
        1,
        -6
      ],
      [
        0,
        -15
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -10
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -6
      ],
      [
        0,
        -7
      ],
      [
        1,
        -5
      ],
      [
        2,
        -5
      ],
      [
        3,
        -9
      ],
      [
        1,
        -3
      ],
      [
        4,
        -4
      ],
      [
        0,
        -1
      ],
      [
        1,
        -5
      ],
      [
        1,
        -3
      ],
      [
        0,
        -11
      ],
      [
        1,
        -6
      ],
      [
        0,
        -3
      ],
      [
        1,
        -4
      ],
      [
        1,
        -3
      ],
      [
        1,
        -2
      ],
      [
        3,
        -1
      ],
      [
        1,
        -1
      ],
      [
        2,
        -3
      ],
      [
        1,
        -4
      ],
      [
        0,
        -5
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -28
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -21
      ],
      [
        1,
        -6
      ],
      [
        1,
        -6
      ],
      [
        2,
        -6
      ],
      [
        1,
        -3
      ],
      [
        2,
        -3
      ],
      [
        1,
        -1
      ],
      [
        2,
        0
      ],
      [
        6,
        5
      ],
      [
        2,
        0
      ],
      [
        2,
        -2
      ],
      [
        0,
        -1
      ],
      [
        3,
        -11
      ],
      [
        2,
        -4
      ],
      [
        3,
        -3
      ],
      [
        1,
        -1
      ],
      [
        1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        1,
        -7
      ],
      [
        0,
        -2
      ]
    ],
    [
      [
        23358,
        63503
      ],
      [
        -9,
        0
      ]
    ],
    [
      [
        23349,
        63503
      ],
      [
        -125,
        0
      ]
    ],
    [
      [
        23224,
        63503
      ],
      [
        -62,
        0
      ]
    ],
    [
      [
        21840,
        63909
      ],
      [
        136,
        0
      ],
      [
        20,
        1
      ]
    ],
    [
      [
        21996,
        63910
      ],
      [
        1,
        -406
      ]
    ],
    [
      [
        21845,
        63505
      ],
      [
        -5,
        0
      ]
    ],
    [
      [
        23518,
        52432
      ],
      [
        55,
        2
      ],
      [
        -2,
        41
      ]
    ],
    [
      [
        23571,
        52475
      ],
      [
        132,
        -1
      ]
    ],
    [
      [
        23703,
        52474
      ],
      [
        -4,
        -23
      ],
      [
        1,
        -20
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -22
      ],
      [
        -3,
        -19
      ],
      [
        0,
        -15
      ],
      [
        -4,
        -13
      ],
      [
        2,
        -27
      ],
      [
        3,
        -10
      ],
      [
        1,
        -38
      ],
      [
        4,
        -23
      ],
      [
        -3,
        -3
      ],
      [
        -3,
        -19
      ],
      [
        1,
        -18
      ],
      [
        -4,
        -8
      ],
      [
        -1,
        -21
      ],
      [
        4,
        -25
      ],
      [
        3,
        -4
      ],
      [
        -6,
        -19
      ]
    ],
    [
      [
        23690,
        52049
      ],
      [
        -15,
        15
      ],
      [
        -2,
        17
      ],
      [
        -10,
        -7
      ],
      [
        -6,
        -19
      ],
      [
        -11,
        5
      ],
      [
        0,
        -35
      ],
      [
        -5,
        -26
      ],
      [
        -11,
        -4
      ],
      [
        -3,
        -13
      ],
      [
        -6,
        -2
      ],
      [
        -3,
        9
      ],
      [
        -7,
        -14
      ],
      [
        -12,
        19
      ]
    ],
    [
      [
        23599,
        51994
      ],
      [
        -43,
        -2
      ],
      [
        -38,
        440
      ]
    ],
    [
      [
        25398,
        57689
      ],
      [
        37,
        0
      ],
      [
        22,
        -1
      ],
      [
        4,
        0
      ],
      [
        14,
        -1
      ],
      [
        4,
        0
      ],
      [
        7,
        -1
      ],
      [
        2,
        0
      ],
      [
        11,
        1
      ],
      [
        5,
        0
      ]
    ],
    [
      [
        25504,
        57687
      ],
      [
        47,
        -1
      ],
      [
        2,
        0
      ],
      [
        2,
        -1
      ],
      [
        12,
        0
      ],
      [
        6,
        -1
      ],
      [
        3,
        0
      ],
      [
        13,
        -1
      ],
      [
        9,
        0
      ],
      [
        11,
        -1
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        25614,
        57681
      ],
      [
        -1,
        -213
      ],
      [
        -11,
        -32
      ],
      [
        -5,
        -5
      ],
      [
        -2,
        -12
      ],
      [
        5,
        -18
      ]
    ],
    [
      [
        25600,
        57401
      ],
      [
        -10,
        -9
      ],
      [
        -13,
        53
      ],
      [
        -7,
        10
      ],
      [
        -16,
        -5
      ]
    ],
    [
      [
        25554,
        57450
      ],
      [
        -7,
        9
      ],
      [
        -8,
        5
      ],
      [
        -12,
        23
      ],
      [
        -6,
        -2
      ],
      [
        -11,
        -13
      ],
      [
        -1,
        -10
      ],
      [
        -7,
        -14
      ],
      [
        -8,
        -7
      ],
      [
        -8,
        -12
      ],
      [
        -1,
        0
      ],
      [
        -6,
        -7
      ],
      [
        -3,
        -4
      ],
      [
        -7,
        -32
      ],
      [
        -10,
        -13
      ],
      [
        -11,
        -3
      ],
      [
        -8,
        11
      ],
      [
        -7,
        25
      ],
      [
        -17,
        49
      ],
      [
        -3,
        40
      ],
      [
        -5,
        33
      ],
      [
        -10,
        22
      ],
      [
        -15,
        24
      ],
      [
        -16,
        -17
      ]
    ],
    [
      [
        25367,
        57557
      ],
      [
        -1,
        2
      ],
      [
        -7,
        9
      ],
      [
        -3,
        7
      ],
      [
        -1,
        2
      ],
      [
        -2,
        6
      ],
      [
        -2,
        9
      ],
      [
        -2,
        13
      ],
      [
        -3,
        25
      ],
      [
        -1,
        9
      ],
      [
        -1,
        5
      ],
      [
        -2,
        9
      ],
      [
        -3,
        19
      ],
      [
        -1,
        5
      ]
    ],
    [
      [
        25338,
        57677
      ],
      [
        0,
        15
      ],
      [
        56,
        -3
      ],
      [
        4,
        0
      ]
    ],
    [
      [
        23701,
        59427
      ],
      [
        59,
        0
      ]
    ],
    [
      [
        23760,
        59427
      ],
      [
        0,
        -121
      ],
      [
        -5,
        -1
      ],
      [
        -2,
        -19
      ],
      [
        3,
        -10
      ],
      [
        4,
        9
      ],
      [
        1,
        -44
      ],
      [
        8,
        -19
      ],
      [
        0,
        -11
      ],
      [
        5,
        -8
      ]
    ],
    [
      [
        23774,
        59203
      ],
      [
        -15,
        1
      ],
      [
        0,
        -84
      ],
      [
        -5,
        0
      ]
    ],
    [
      [
        23569,
        58965
      ],
      [
        -3,
        58
      ],
      [
        0,
        12
      ]
    ],
    [
      [
        23566,
        59035
      ],
      [
        -1,
        19
      ],
      [
        0,
        6
      ],
      [
        -2,
        32
      ],
      [
        0,
        22
      ],
      [
        -1,
        3
      ],
      [
        0,
        20
      ],
      [
        -2,
        48
      ],
      [
        -1,
        11
      ],
      [
        -1,
        37
      ],
      [
        -1,
        16
      ],
      [
        -1,
        49
      ],
      [
        -1,
        16
      ],
      [
        0,
        4
      ],
      [
        -1,
        20
      ],
      [
        -2,
        46
      ],
      [
        0,
        17
      ],
      [
        -1,
        10
      ],
      [
        -1,
        17
      ]
    ],
    [
      [
        24875,
        65347
      ],
      [
        65,
        1
      ]
    ],
    [
      [
        24940,
        65348
      ],
      [
        129,
        0
      ]
    ],
    [
      [
        24938,
        64840
      ],
      [
        0,
        99
      ],
      [
        -61,
        1
      ]
    ],
    [
      [
        26105,
        64263
      ],
      [
        1,
        -100
      ]
    ],
    [
      [
        26106,
        64163
      ],
      [
        0,
        -219
      ]
    ],
    [
      [
        26106,
        63944
      ],
      [
        -37,
        0
      ]
    ],
    [
      [
        26069,
        63944
      ],
      [
        -58,
        0
      ],
      [
        -21,
        -1
      ]
    ],
    [
      [
        25990,
        63943
      ],
      [
        0,
        33
      ]
    ],
    [
      [
        25990,
        63976
      ],
      [
        0,
        84
      ],
      [
        -1,
        101
      ]
    ],
    [
      [
        26137,
        68351
      ],
      [
        -1,
        303
      ],
      [
        1,
        101
      ]
    ],
    [
      [
        26143,
        67133
      ],
      [
        0,
        204
      ],
      [
        -70,
        0
      ]
    ],
    [
      [
        24210,
        60561
      ],
      [
        -1,
        -111
      ],
      [
        0,
        -143
      ],
      [
        1,
        -227
      ]
    ],
    [
      [
        24272,
        60712
      ],
      [
        61,
        -4
      ]
    ],
    [
      [
        24376,
        60067
      ],
      [
        -40,
        2
      ],
      [
        -51,
        6
      ],
      [
        -30,
        1
      ]
    ],
    [
      [
        24688,
        60760
      ],
      [
        5,
        -1
      ],
      [
        18,
        0
      ],
      [
        85,
        -2
      ]
    ],
    [
      [
        24796,
        60757
      ],
      [
        0,
        -51
      ]
    ],
    [
      [
        24796,
        60706
      ],
      [
        2,
        -66
      ],
      [
        -2,
        -266
      ],
      [
        -20,
        3
      ]
    ],
    [
      [
        24776,
        60377
      ],
      [
        -5,
        2
      ],
      [
        -30,
        -2
      ],
      [
        -57,
        3
      ]
    ],
    [
      [
        24632,
        53839
      ],
      [
        40,
        0
      ],
      [
        50,
        2
      ],
      [
        0,
        -12
      ],
      [
        1,
        -5
      ],
      [
        7,
        0
      ],
      [
        1,
        17
      ],
      [
        19,
        0
      ],
      [
        15,
        4
      ],
      [
        4,
        16
      ]
    ],
    [
      [
        24769,
        53861
      ],
      [
        0,
        -427
      ]
    ],
    [
      [
        24769,
        53434
      ],
      [
        -5,
        0
      ]
    ],
    [
      [
        24661,
        53433
      ],
      [
        0,
        305
      ],
      [
        -29,
        -1
      ]
    ],
    [
      [
        24632,
        53737
      ],
      [
        0,
        102
      ]
    ],
    [
      [
        20688,
        56922
      ],
      [
        0,
        300
      ],
      [
        125,
        0
      ],
      [
        0,
        101
      ],
      [
        29,
        1
      ],
      [
        0,
        101
      ],
      [
        59,
        0
      ]
    ],
    [
      [
        20901,
        57425
      ],
      [
        0,
        -202
      ],
      [
        50,
        0
      ]
    ],
    [
      [
        20951,
        57223
      ],
      [
        0,
        -403
      ],
      [
        1,
        -11
      ],
      [
        0,
        -195
      ]
    ],
    [
      [
        20952,
        56614
      ],
      [
        -59,
        1
      ],
      [
        0,
        -102
      ],
      [
        -45,
        0
      ],
      [
        -130,
        5
      ],
      [
        -1,
        102
      ],
      [
        -29,
        1
      ]
    ],
    [
      [
        20688,
        56621
      ],
      [
        0,
        301
      ]
    ],
    [
      [
        28264,
        58442
      ],
      [
        3,
        10
      ],
      [
        5,
        12
      ],
      [
        2,
        4
      ]
    ],
    [
      [
        28361,
        58636
      ],
      [
        10,
        -15
      ],
      [
        17,
        -23
      ],
      [
        -1,
        -25
      ],
      [
        11,
        -6
      ],
      [
        12,
        -32
      ]
    ],
    [
      [
        28410,
        58535
      ],
      [
        1,
        -16
      ],
      [
        -4,
        1
      ],
      [
        -3,
        -23
      ],
      [
        8,
        -18
      ],
      [
        0,
        -14
      ],
      [
        -3,
        -4
      ],
      [
        2,
        -35
      ],
      [
        8,
        -24
      ],
      [
        1,
        -15
      ],
      [
        -3,
        -3
      ],
      [
        8,
        -12
      ],
      [
        -1,
        -9
      ],
      [
        4,
        -2
      ],
      [
        0,
        -16
      ],
      [
        7,
        -6
      ],
      [
        0,
        -13
      ],
      [
        -4,
        -2
      ],
      [
        -8,
        3
      ],
      [
        -6,
        -19
      ],
      [
        -7,
        -21
      ],
      [
        0,
        -73
      ],
      [
        -4,
        -25
      ],
      [
        0,
        -20
      ]
    ],
    [
      [
        28326,
        58179
      ],
      [
        0,
        22
      ],
      [
        -4,
        18
      ],
      [
        -1,
        19
      ],
      [
        -5,
        24
      ],
      [
        3,
        23
      ],
      [
        -6,
        1
      ],
      [
        0,
        11
      ],
      [
        -10,
        6
      ],
      [
        -3,
        18
      ],
      [
        -6,
        18
      ],
      [
        -5,
        4
      ],
      [
        -15,
        60
      ],
      [
        -5,
        14
      ],
      [
        -2,
        21
      ],
      [
        -3,
        4
      ]
    ],
    [
      [
        21467,
        71629
      ],
      [
        92,
        0
      ]
    ],
    [
      [
        21790,
        71631
      ],
      [
        1,
        -21
      ],
      [
        7,
        -19
      ],
      [
        1,
        -60
      ],
      [
        8,
        -37
      ],
      [
        4,
        -25
      ],
      [
        1,
        -4
      ],
      [
        7,
        -21
      ],
      [
        4,
        -16
      ],
      [
        0,
        -14
      ],
      [
        -6,
        -38
      ],
      [
        1,
        -17
      ],
      [
        9,
        -16
      ],
      [
        7,
        1
      ],
      [
        0,
        -19
      ],
      [
        -5,
        -5
      ],
      [
        5,
        -34
      ],
      [
        8,
        7
      ],
      [
        1,
        -31
      ],
      [
        5,
        -12
      ],
      [
        15,
        21
      ],
      [
        9,
        6
      ],
      [
        -5,
        -51
      ]
    ],
    [
      [
        21867,
        71226
      ],
      [
        10,
        -26
      ],
      [
        16,
        -22
      ],
      [
        2,
        -7
      ],
      [
        -2,
        -11
      ],
      [
        -6,
        -5
      ],
      [
        12,
        -47
      ],
      [
        0,
        -10
      ],
      [
        -9,
        -22
      ],
      [
        -2,
        -15
      ],
      [
        -4,
        -49
      ],
      [
        3,
        -27
      ]
    ],
    [
      [
        21887,
        70985
      ],
      [
        -5,
        -10
      ],
      [
        -6,
        0
      ],
      [
        -11,
        -15
      ],
      [
        -5,
        4
      ],
      [
        -2,
        -14
      ],
      [
        -5,
        -6
      ],
      [
        -3,
        -15
      ],
      [
        -1,
        15
      ],
      [
        -12,
        6
      ],
      [
        -2,
        -7
      ],
      [
        -8,
        -2
      ],
      [
        -3,
        -6
      ],
      [
        -11,
        12
      ],
      [
        -1,
        9
      ],
      [
        -3,
        -16
      ],
      [
        -4,
        2
      ],
      [
        0,
        21
      ],
      [
        -4,
        -15
      ],
      [
        -6,
        -1
      ],
      [
        -3,
        -20
      ],
      [
        -3,
        -3
      ],
      [
        0,
        -30
      ],
      [
        -6,
        -2
      ],
      [
        1,
        -9
      ],
      [
        -6,
        -12
      ],
      [
        -4,
        -17
      ],
      [
        -6,
        6
      ],
      [
        0,
        -24
      ],
      [
        -3,
        -18
      ]
    ],
    [
      [
        21765,
        70818
      ],
      [
        -6,
        0
      ],
      [
        0,
        101
      ],
      [
        -70,
        0
      ],
      [
        0,
        302
      ],
      [
        -117,
        1
      ],
      [
        0,
        101
      ],
      [
        -105,
        -1
      ]
    ],
    [
      [
        21467,
        71322
      ],
      [
        0,
        307
      ]
    ],
    [
      [
        26831,
        65004
      ],
      [
        139,
        -7
      ]
    ],
    [
      [
        26970,
        64997
      ],
      [
        0,
        -95
      ],
      [
        1,
        -17
      ],
      [
        0,
        -58
      ],
      [
        1,
        -84
      ]
    ],
    [
      [
        26972,
        64743
      ],
      [
        -28,
        0
      ],
      [
        1,
        -85
      ]
    ],
    [
      [
        26945,
        64658
      ],
      [
        -81,
        4
      ]
    ],
    [
      [
        26835,
        64663
      ],
      [
        -3,
        256
      ],
      [
        0,
        45
      ]
    ],
    [
      [
        23156,
        58680
      ],
      [
        35,
        -1
      ],
      [
        25,
        0
      ]
    ],
    [
      [
        23231,
        58679
      ],
      [
        -1,
        -152
      ],
      [
        15,
        0
      ],
      [
        0,
        -202
      ]
    ],
    [
      [
        23245,
        58325
      ],
      [
        -30,
        0
      ],
      [
        0,
        -103
      ],
      [
        -15,
        0
      ],
      [
        0,
        -101
      ],
      [
        -29,
        0
      ]
    ],
    [
      [
        23171,
        58121
      ],
      [
        -30,
        0
      ],
      [
        0,
        204
      ],
      [
        -29,
        0
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        27603,
        56618
      ],
      [
        27,
        71
      ],
      [
        4,
        10
      ],
      [
        13,
        34
      ],
      [
        7,
        18
      ],
      [
        14,
        39
      ],
      [
        5,
        14
      ],
      [
        5,
        11
      ],
      [
        5,
        -6
      ],
      [
        4,
        -1
      ],
      [
        6,
        -4
      ],
      [
        -1,
        6
      ],
      [
        6,
        52
      ],
      [
        13,
        -12
      ],
      [
        7,
        24
      ]
    ],
    [
      [
        27718,
        56874
      ],
      [
        6,
        -5
      ],
      [
        1,
        -4
      ]
    ],
    [
      [
        27725,
        56865
      ],
      [
        5,
        -1
      ],
      [
        4,
        -8
      ],
      [
        11,
        -37
      ],
      [
        4,
        -32
      ]
    ],
    [
      [
        27749,
        56787
      ],
      [
        1,
        -13
      ],
      [
        -1,
        -18
      ],
      [
        -7,
        -22
      ],
      [
        1,
        -12
      ],
      [
        7,
        -27
      ],
      [
        3,
        -30
      ],
      [
        5,
        0
      ],
      [
        -2,
        -11
      ],
      [
        2,
        -23
      ],
      [
        -4,
        3
      ],
      [
        1,
        -33
      ],
      [
        4,
        -29
      ],
      [
        0,
        -38
      ],
      [
        1,
        -10
      ],
      [
        -2,
        -13
      ],
      [
        5,
        -29
      ],
      [
        5,
        -6
      ],
      [
        -4,
        -16
      ],
      [
        3,
        -14
      ],
      [
        15,
        -47
      ],
      [
        8,
        -6
      ],
      [
        -3,
        -8
      ],
      [
        6,
        -14
      ],
      [
        0,
        -7
      ],
      [
        6,
        -29
      ],
      [
        7,
        0
      ],
      [
        2,
        -12
      ],
      [
        6,
        -7
      ],
      [
        0,
        -22
      ],
      [
        -3,
        -10
      ]
    ],
    [
      [
        27811,
        56284
      ],
      [
        -4,
        5
      ],
      [
        -3,
        14
      ],
      [
        -10,
        1
      ],
      [
        0,
        -10
      ],
      [
        -13,
        -17
      ],
      [
        -2,
        -10
      ],
      [
        -9,
        0
      ],
      [
        -7,
        -10
      ],
      [
        -38,
        38
      ],
      [
        0,
        11
      ],
      [
        -4,
        -3
      ],
      [
        -8,
        0
      ],
      [
        -3,
        -12
      ],
      [
        -10,
        11
      ],
      [
        -5,
        24
      ],
      [
        -16,
        1
      ],
      [
        -10,
        55
      ],
      [
        -3,
        2
      ],
      [
        -2,
        8
      ],
      [
        -4,
        -8
      ],
      [
        -2,
        1
      ]
    ],
    [
      [
        27658,
        56385
      ],
      [
        -8,
        4
      ],
      [
        -12,
        -3
      ],
      [
        -8,
        70
      ]
    ],
    [
      [
        27630,
        56456
      ],
      [
        23,
        48
      ],
      [
        -3,
        17
      ],
      [
        -20,
        31
      ],
      [
        -3,
        10
      ],
      [
        -4,
        10
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        27623,
        56574
      ],
      [
        -7,
        30
      ],
      [
        -13,
        14
      ]
    ],
    [
      [
        27102,
        56676
      ],
      [
        -2,
        25
      ],
      [
        0,
        13
      ],
      [
        5,
        13
      ],
      [
        6,
        -8
      ],
      [
        8,
        3
      ],
      [
        7,
        -10
      ],
      [
        4,
        9
      ],
      [
        7,
        6
      ],
      [
        4,
        10
      ],
      [
        6,
        -17
      ],
      [
        5,
        0
      ],
      [
        5,
        -20
      ],
      [
        10,
        -12
      ],
      [
        5,
        -25
      ],
      [
        7,
        -7
      ],
      [
        7,
        -22
      ],
      [
        6,
        -6
      ],
      [
        1,
        -8
      ],
      [
        1,
        -7
      ],
      [
        7,
        1
      ],
      [
        4,
        -10
      ],
      [
        8,
        3
      ]
    ],
    [
      [
        27213,
        56607
      ],
      [
        -6,
        -49
      ],
      [
        -12,
        -94
      ],
      [
        -9,
        -80
      ],
      [
        -1,
        -9
      ]
    ],
    [
      [
        27185,
        56375
      ],
      [
        -3,
        -11
      ],
      [
        -19,
        -62
      ]
    ],
    [
      [
        27163,
        56302
      ],
      [
        -19,
        21
      ],
      [
        -16,
        16
      ],
      [
        -13,
        25
      ],
      [
        -3,
        -2
      ],
      [
        -7,
        17
      ],
      [
        -3,
        14
      ],
      [
        -7,
        97
      ],
      [
        -10,
        1
      ],
      [
        -21,
        -17
      ]
    ],
    [
      [
        27064,
        56474
      ],
      [
        -1,
        3
      ],
      [
        6,
        39
      ],
      [
        12,
        48
      ],
      [
        5,
        45
      ],
      [
        16,
        67
      ]
    ],
    [
      [
        25769,
        60991
      ],
      [
        1,
        -1
      ],
      [
        1,
        0
      ],
      [
        3,
        1
      ],
      [
        1,
        2
      ],
      [
        2,
        4
      ],
      [
        3,
        6
      ],
      [
        2,
        3
      ],
      [
        1,
        4
      ],
      [
        2,
        10
      ],
      [
        0,
        5
      ],
      [
        -1,
        4
      ],
      [
        1,
        6
      ],
      [
        0,
        5
      ],
      [
        -1,
        20
      ],
      [
        0,
        6
      ],
      [
        1,
        5
      ],
      [
        0,
        4
      ],
      [
        2,
        8
      ],
      [
        1,
        1
      ],
      [
        2,
        1
      ],
      [
        4,
        -1
      ],
      [
        5,
        -5
      ],
      [
        2,
        -1
      ],
      [
        2,
        0
      ],
      [
        1,
        2
      ],
      [
        3,
        4
      ],
      [
        2,
        5
      ],
      [
        1,
        3
      ],
      [
        0,
        16
      ],
      [
        -1,
        5
      ],
      [
        -2,
        5
      ],
      [
        -1,
        3
      ],
      [
        -1,
        9
      ],
      [
        0,
        77
      ],
      [
        1,
        12
      ],
      [
        1,
        4
      ],
      [
        0,
        1
      ],
      [
        2,
        2
      ],
      [
        3,
        2
      ],
      [
        3,
        0
      ]
    ],
    [
      [
        25815,
        61228
      ],
      [
        17,
        -53
      ],
      [
        52,
        -144
      ],
      [
        9,
        -36
      ],
      [
        16,
        -55
      ]
    ],
    [
      [
        25875,
        60701
      ],
      [
        -12,
        -8
      ],
      [
        -7,
        10
      ],
      [
        -3,
        -9
      ],
      [
        2,
        -29
      ],
      [
        -8,
        -4
      ],
      [
        -4,
        9
      ],
      [
        -6,
        0
      ],
      [
        -4,
        16
      ],
      [
        -6,
        -4
      ],
      [
        -2,
        17
      ],
      [
        -6,
        -1
      ],
      [
        1,
        11
      ],
      [
        -11,
        27
      ],
      [
        -7,
        -11
      ],
      [
        -1,
        -16
      ],
      [
        5,
        2
      ],
      [
        -4,
        -14
      ],
      [
        -4,
        -2
      ],
      [
        0,
        9
      ],
      [
        -7,
        4
      ],
      [
        2,
        -21
      ],
      [
        -7,
        -20
      ]
    ],
    [
      [
        25786,
        60667
      ],
      [
        -7,
        27
      ],
      [
        -6,
        37
      ],
      [
        0,
        50
      ]
    ],
    [
      [
        25773,
        60781
      ],
      [
        5,
        -8
      ],
      [
        -15,
        160
      ],
      [
        3,
        50
      ],
      [
        3,
        8
      ]
    ],
    [
      [
        25415,
        61060
      ],
      [
        31,
        -162
      ],
      [
        1,
        10
      ],
      [
        5,
        -1
      ],
      [
        -2,
        -11
      ],
      [
        6,
        -8
      ],
      [
        1,
        15
      ],
      [
        3,
        -12
      ],
      [
        -1,
        -9
      ],
      [
        3,
        -23
      ],
      [
        2,
        -59
      ],
      [
        -1,
        -10
      ],
      [
        5,
        -36
      ]
    ],
    [
      [
        25468,
        60754
      ],
      [
        -19,
        -69
      ],
      [
        -36,
        -116
      ]
    ],
    [
      [
        25413,
        60569
      ],
      [
        -6,
        -1
      ],
      [
        -2,
        -8
      ],
      [
        -6,
        2
      ],
      [
        5,
        13
      ],
      [
        -2,
        17
      ],
      [
        -2,
        -7
      ],
      [
        -5,
        15
      ],
      [
        0,
        37
      ],
      [
        -5,
        10
      ],
      [
        -2,
        -21
      ],
      [
        -3,
        -18
      ],
      [
        -4,
        6
      ],
      [
        -4,
        -15
      ]
    ],
    [
      [
        25377,
        60599
      ],
      [
        0,
        12
      ],
      [
        -2,
        11
      ],
      [
        -1,
        4
      ],
      [
        -2,
        4
      ],
      [
        -2,
        2
      ],
      [
        0,
        1
      ],
      [
        -2,
        6
      ],
      [
        -2,
        13
      ],
      [
        -1,
        6
      ],
      [
        -3,
        7
      ],
      [
        -2,
        7
      ],
      [
        -2,
        5
      ],
      [
        -1,
        2
      ]
    ],
    [
      [
        25357,
        60679
      ],
      [
        -1,
        7
      ],
      [
        -1,
        7
      ],
      [
        0,
        20
      ],
      [
        -3,
        22
      ],
      [
        -1,
        12
      ],
      [
        -1,
        8
      ],
      [
        0,
        29
      ],
      [
        2,
        12
      ],
      [
        2,
        9
      ],
      [
        3,
        10
      ],
      [
        0,
        7
      ],
      [
        2,
        12
      ],
      [
        1,
        3
      ],
      [
        1,
        3
      ],
      [
        3,
        4
      ],
      [
        2,
        2
      ],
      [
        2,
        6
      ],
      [
        2,
        7
      ],
      [
        1,
        2
      ],
      [
        3,
        3
      ],
      [
        2,
        6
      ],
      [
        2,
        5
      ],
      [
        2,
        13
      ],
      [
        2,
        15
      ],
      [
        1,
        6
      ],
      [
        0,
        14
      ],
      [
        1,
        9
      ],
      [
        1,
        5
      ],
      [
        1,
        4
      ]
    ],
    [
      [
        26212,
        59846
      ],
      [
        13,
        33
      ],
      [
        16,
        34
      ],
      [
        3,
        46
      ],
      [
        1,
        5
      ],
      [
        7,
        -4
      ],
      [
        4,
        -13
      ],
      [
        20,
        61
      ]
    ],
    [
      [
        26276,
        60008
      ],
      [
        7,
        -12
      ],
      [
        7,
        -11
      ],
      [
        4,
        -24
      ],
      [
        11,
        10
      ],
      [
        7,
        17
      ],
      [
        9,
        -7
      ],
      [
        15,
        -91
      ],
      [
        5,
        -20
      ],
      [
        5,
        15
      ],
      [
        -2,
        -11
      ],
      [
        4,
        -18
      ]
    ],
    [
      [
        26348,
        59856
      ],
      [
        -4,
        -6
      ],
      [
        5,
        -21
      ],
      [
        -6,
        -8
      ],
      [
        5,
        -14
      ],
      [
        -1,
        -25
      ],
      [
        -5,
        6
      ],
      [
        1,
        -11
      ],
      [
        -8,
        -6
      ],
      [
        -3,
        -29
      ],
      [
        -11,
        -9
      ],
      [
        0,
        -26
      ],
      [
        -29,
        -158
      ]
    ],
    [
      [
        26290,
        59549
      ],
      [
        -5,
        1
      ],
      [
        -11,
        1
      ],
      [
        -5,
        1
      ],
      [
        -23,
        7
      ],
      [
        -9,
        4
      ]
    ],
    [
      [
        26237,
        59563
      ],
      [
        -7,
        10
      ],
      [
        -1,
        22
      ],
      [
        2,
        23
      ],
      [
        -4,
        6
      ],
      [
        3,
        10
      ],
      [
        -5,
        15
      ],
      [
        -1,
        33
      ],
      [
        5,
        45
      ],
      [
        -6,
        59
      ],
      [
        -9,
        30
      ],
      [
        -2,
        30
      ]
    ],
    [
      [
        26151,
        61591
      ],
      [
        80,
        -26
      ]
    ],
    [
      [
        26223,
        61325
      ],
      [
        -4,
        -12
      ],
      [
        -4,
        -40
      ],
      [
        2,
        -14
      ],
      [
        -7,
        -17
      ],
      [
        -3,
        -20
      ],
      [
        -5,
        -4
      ]
    ],
    [
      [
        26202,
        61218
      ],
      [
        -27,
        44
      ],
      [
        -10,
        17
      ],
      [
        -53,
        67
      ]
    ],
    [
      [
        26112,
        61346
      ],
      [
        5,
        136
      ],
      [
        -2,
        2
      ],
      [
        -15,
        23
      ]
    ],
    [
      [
        26100,
        61507
      ],
      [
        5,
        21
      ],
      [
        6,
        -13
      ],
      [
        2,
        12
      ],
      [
        2,
        -10
      ],
      [
        7,
        16
      ],
      [
        10,
        -6
      ],
      [
        8,
        8
      ],
      [
        11,
        56
      ]
    ],
    [
      [
        28437,
        57463
      ],
      [
        -25,
        -24
      ],
      [
        1,
        -7
      ]
    ],
    [
      [
        28271,
        57652
      ],
      [
        -16,
        40
      ]
    ],
    [
      [
        26346,
        58432
      ],
      [
        2,
        17
      ],
      [
        6,
        0
      ],
      [
        7,
        14
      ],
      [
        -1,
        16
      ],
      [
        6,
        37
      ],
      [
        5,
        0
      ],
      [
        13,
        50
      ],
      [
        3,
        -13
      ],
      [
        3,
        6
      ],
      [
        3,
        27
      ],
      [
        7,
        -9
      ],
      [
        3,
        57
      ],
      [
        2,
        10
      ],
      [
        7,
        7
      ],
      [
        2,
        21
      ],
      [
        3,
        50
      ],
      [
        13,
        -21
      ],
      [
        0,
        32
      ],
      [
        5,
        -7
      ]
    ],
    [
      [
        26435,
        58726
      ],
      [
        2,
        -3
      ],
      [
        5,
        -20
      ],
      [
        12,
        -49
      ],
      [
        8,
        -29
      ],
      [
        0,
        -5
      ]
    ],
    [
      [
        26462,
        58620
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -42
      ],
      [
        7,
        -13
      ],
      [
        -4,
        -18
      ],
      [
        -1,
        -34
      ],
      [
        2,
        -17
      ],
      [
        3,
        -28
      ],
      [
        6,
        -16
      ],
      [
        -1,
        -13
      ],
      [
        -5,
        -25
      ],
      [
        -10,
        -20
      ]
    ],
    [
      [
        26456,
        58393
      ],
      [
        -1,
        9
      ],
      [
        -8,
        -3
      ],
      [
        -9,
        6
      ],
      [
        1,
        19
      ],
      [
        -9,
        -2
      ],
      [
        -4,
        9
      ],
      [
        2,
        14
      ],
      [
        -10,
        11
      ],
      [
        -9,
        1
      ],
      [
        1,
        -13
      ],
      [
        -6,
        -15
      ],
      [
        -6,
        -1
      ],
      [
        -3,
        29
      ],
      [
        -5,
        -5
      ],
      [
        1,
        12
      ],
      [
        -10,
        -7
      ],
      [
        0,
        -7
      ],
      [
        -10,
        -5
      ],
      [
        -3,
        12
      ],
      [
        0,
        -17
      ],
      [
        -5,
        1
      ],
      [
        4,
        -14
      ],
      [
        1,
        -24
      ],
      [
        -6,
        6
      ]
    ],
    [
      [
        26362,
        58409
      ],
      [
        -6,
        20
      ],
      [
        -3,
        -14
      ],
      [
        -7,
        4
      ],
      [
        0,
        13
      ]
    ],
    [
      [
        22754,
        54392
      ],
      [
        0,
        10
      ],
      [
        109,
        97
      ]
    ],
    [
      [
        22863,
        54499
      ],
      [
        40,
        -248
      ],
      [
        13,
        25
      ]
    ],
    [
      [
        22916,
        54276
      ],
      [
        49,
        -301
      ]
    ],
    [
      [
        22906,
        53851
      ],
      [
        -30,
        180
      ],
      [
        -66,
        -137
      ]
    ],
    [
      [
        22810,
        53894
      ],
      [
        -10,
        19
      ],
      [
        -4,
        31
      ],
      [
        12,
        40
      ],
      [
        0,
        24
      ],
      [
        -6,
        6
      ],
      [
        -6,
        -8
      ],
      [
        -10,
        27
      ],
      [
        -6,
        7
      ],
      [
        0,
        15
      ],
      [
        6,
        8
      ],
      [
        -10,
        22
      ],
      [
        -4,
        0
      ],
      [
        -3,
        16
      ],
      [
        -5,
        7
      ],
      [
        4,
        15
      ],
      [
        6,
        13
      ],
      [
        7,
        22
      ],
      [
        0,
        15
      ],
      [
        -7,
        1
      ],
      [
        -5,
        25
      ],
      [
        -1,
        24
      ],
      [
        -4,
        -16
      ],
      [
        -10,
        -5
      ],
      [
        -3,
        9
      ],
      [
        0,
        29
      ],
      [
        -1,
        20
      ],
      [
        6,
        31
      ],
      [
        -1,
        13
      ],
      [
        -6,
        35
      ],
      [
        0,
        14
      ],
      [
        7,
        9
      ],
      [
        3,
        18
      ],
      [
        0,
        9
      ],
      [
        -5,
        3
      ]
    ],
    [
      [
        28276,
        60667
      ],
      [
        11,
        16
      ],
      [
        -7,
        29
      ],
      [
        -2,
        25
      ],
      [
        -1,
        19
      ],
      [
        6,
        76
      ]
    ],
    [
      [
        28283,
        60832
      ],
      [
        6,
        5
      ],
      [
        4,
        -15
      ],
      [
        10,
        -18
      ],
      [
        5,
        5
      ],
      [
        3,
        10
      ],
      [
        2,
        6
      ],
      [
        7,
        1
      ],
      [
        1,
        1
      ],
      [
        4,
        -23
      ],
      [
        2,
        7
      ],
      [
        6,
        -9
      ],
      [
        1,
        5
      ],
      [
        7,
        -50
      ],
      [
        5,
        -18
      ],
      [
        -1,
        -16
      ],
      [
        1,
        -8
      ],
      [
        28,
        -52
      ],
      [
        12,
        -13
      ],
      [
        6,
        -13
      ]
    ],
    [
      [
        28392,
        60637
      ],
      [
        2,
        2
      ],
      [
        15,
        -57
      ]
    ],
    [
      [
        28409,
        60582
      ],
      [
        -5,
        -43
      ],
      [
        -7,
        -55
      ],
      [
        2,
        -15
      ],
      [
        -3,
        -16
      ],
      [
        -6,
        17
      ],
      [
        -1,
        -15
      ]
    ],
    [
      [
        28389,
        60455
      ],
      [
        -4,
        -4
      ],
      [
        -1,
        -21
      ],
      [
        -3,
        -10
      ],
      [
        -7,
        8
      ],
      [
        -2,
        17
      ],
      [
        4,
        22
      ],
      [
        0,
        15
      ],
      [
        -8,
        -32
      ],
      [
        -9,
        7
      ],
      [
        -8,
        4
      ],
      [
        -3,
        39
      ],
      [
        -4,
        2
      ],
      [
        -2,
        -1
      ],
      [
        -3,
        11
      ],
      [
        3,
        19
      ]
    ],
    [
      [
        28342,
        60531
      ],
      [
        0,
        12
      ],
      [
        -1,
        48
      ],
      [
        2,
        7
      ],
      [
        0,
        14
      ],
      [
        6,
        -14
      ],
      [
        2,
        14
      ],
      [
        0,
        1
      ],
      [
        -2,
        10
      ],
      [
        1,
        5
      ],
      [
        1,
        -2
      ],
      [
        0,
        9
      ],
      [
        -2,
        1
      ],
      [
        0,
        15
      ],
      [
        -5,
        3
      ],
      [
        1,
        6
      ],
      [
        -2,
        6
      ],
      [
        1,
        20
      ],
      [
        -5,
        0
      ],
      [
        -2,
        5
      ],
      [
        0,
        16
      ],
      [
        -4,
        5
      ],
      [
        -2,
        0
      ],
      [
        -2,
        -6
      ],
      [
        -3,
        2
      ],
      [
        -1,
        -11
      ],
      [
        2,
        -13
      ],
      [
        -3,
        -6
      ],
      [
        -3,
        10
      ],
      [
        -6,
        0
      ],
      [
        -4,
        12
      ],
      [
        -1,
        -10
      ],
      [
        -2,
        -3
      ],
      [
        3,
        -26
      ],
      [
        -18,
        -4
      ]
    ],
    [
      [
        28293,
        60657
      ],
      [
        -5,
        1
      ],
      [
        -2,
        1
      ],
      [
        -8,
        3
      ],
      [
        -2,
        5
      ]
    ],
    [
      [
        27256,
        64261
      ],
      [
        21,
        -1
      ],
      [
        1,
        85
      ],
      [
        11,
        -2
      ],
      [
        0,
        8
      ],
      [
        31,
        -1
      ]
    ],
    [
      [
        27320,
        64350
      ],
      [
        48,
        -1
      ],
      [
        -1,
        -97
      ],
      [
        16,
        -1
      ],
      [
        0,
        -51
      ]
    ],
    [
      [
        27383,
        64200
      ],
      [
        -1,
        -51
      ],
      [
        -15,
        1
      ],
      [
        -2,
        -103
      ],
      [
        -4,
        1
      ],
      [
        0,
        -51
      ]
    ],
    [
      [
        27269,
        64007
      ],
      [
        1,
        51
      ],
      [
        1,
        102
      ],
      [
        -16,
        2
      ],
      [
        1,
        99
      ]
    ],
    [
      [
        22628,
        73447
      ],
      [
        214,
        0
      ]
    ],
    [
      [
        22842,
        73447
      ],
      [
        0,
        -2
      ],
      [
        2,
        -2
      ],
      [
        1,
        -3
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -6
      ],
      [
        1,
        -24
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        2,
        -4
      ],
      [
        0,
        -14
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        1,
        -1
      ],
      [
        0,
        -17
      ],
      [
        2,
        -3
      ],
      [
        1,
        -1
      ],
      [
        0,
        -9
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        1,
        -1
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -5
      ],
      [
        1,
        -1
      ],
      [
        0,
        -6
      ],
      [
        -2,
        -1
      ],
      [
        0,
        -5
      ],
      [
        1,
        -1
      ],
      [
        1,
        -4
      ],
      [
        0,
        -9
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -8
      ],
      [
        1,
        -3
      ],
      [
        1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -12
      ],
      [
        1,
        -6
      ],
      [
        1,
        -1
      ],
      [
        0,
        -11
      ],
      [
        2,
        -4
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -3
      ],
      [
        1,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -9
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        0,
        -6
      ],
      [
        1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -8
      ],
      [
        1,
        0
      ],
      [
        1,
        -2
      ],
      [
        1,
        -8
      ],
      [
        0,
        -4
      ],
      [
        -2,
        -10
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -1
      ],
      [
        0,
        -5
      ],
      [
        1,
        -1
      ],
      [
        0,
        -16
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -4
      ],
      [
        0,
        -5
      ],
      [
        1,
        -4
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        1,
        -3
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -4
      ]
    ],
    [
      [
        22847,
        73041
      ],
      [
        -203,
        1
      ],
      [
        -9,
        0
      ]
    ],
    [
      [
        22527,
        73042
      ],
      [
        0,
        203
      ],
      [
        -8,
        1
      ],
      [
        1,
        202
      ]
    ],
    [
      [
        24997,
        69867
      ],
      [
        17,
        3
      ],
      [
        67,
        -3
      ],
      [
        22,
        -3
      ]
    ],
    [
      [
        25103,
        69864
      ],
      [
        34,
        0
      ],
      [
        -1,
        -100
      ],
      [
        69,
        0
      ]
    ],
    [
      [
        25205,
        69764
      ],
      [
        0,
        -202
      ],
      [
        11,
        -1
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        25121,
        69357
      ],
      [
        -68,
        0
      ]
    ],
    [
      [
        24373,
        69565
      ],
      [
        30,
        -1
      ],
      [
        1,
        0
      ],
      [
        3,
        -1
      ],
      [
        0,
        4
      ],
      [
        1,
        96
      ]
    ],
    [
      [
        24408,
        69663
      ],
      [
        171,
        0
      ]
    ],
    [
      [
        24580,
        69157
      ],
      [
        -175,
        0
      ],
      [
        -28,
        -2
      ]
    ],
    [
      [
        24377,
        69155
      ],
      [
        0,
        309
      ],
      [
        -4,
        0
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        24319,
        51555
      ],
      [
        5,
        16
      ],
      [
        36,
        112
      ],
      [
        11,
        52
      ],
      [
        13,
        63
      ],
      [
        43,
        13
      ]
    ],
    [
      [
        24427,
        51811
      ],
      [
        0,
        -10
      ],
      [
        16,
        -50
      ],
      [
        4,
        -36
      ],
      [
        7,
        -46
      ],
      [
        -3,
        -59
      ],
      [
        9,
        -20
      ],
      [
        15,
        -2
      ],
      [
        19,
        -18
      ],
      [
        4,
        2
      ],
      [
        10,
        -26
      ],
      [
        13,
        -5
      ],
      [
        10,
        -29
      ]
    ],
    [
      [
        24531,
        51512
      ],
      [
        1,
        -4
      ],
      [
        -3,
        -62
      ],
      [
        5,
        -9
      ],
      [
        1,
        -10
      ]
    ],
    [
      [
        24535,
        51427
      ],
      [
        -9,
        -10
      ],
      [
        -2,
        -12
      ],
      [
        -4,
        2
      ],
      [
        -7,
        -19
      ],
      [
        -4,
        20
      ],
      [
        -9,
        -22
      ],
      [
        -4,
        -17
      ],
      [
        0,
        -16
      ],
      [
        -4,
        -17
      ],
      [
        -7,
        -6
      ],
      [
        -2,
        -7
      ],
      [
        1,
        -26
      ],
      [
        -2,
        -41
      ],
      [
        2,
        -8
      ],
      [
        2,
        -33
      ],
      [
        6,
        -7
      ]
    ],
    [
      [
        24492,
        51208
      ],
      [
        -5,
        0
      ],
      [
        -6,
        -34
      ],
      [
        -3,
        -7
      ],
      [
        -4,
        12
      ],
      [
        -2,
        -15
      ],
      [
        -7,
        -10
      ],
      [
        2,
        41
      ],
      [
        -10,
        -7
      ],
      [
        0,
        17
      ],
      [
        5,
        10
      ],
      [
        -2,
        12
      ],
      [
        6,
        10
      ],
      [
        3,
        18
      ],
      [
        -5,
        12
      ],
      [
        -5,
        28
      ],
      [
        -6,
        -1
      ],
      [
        -4,
        -17
      ],
      [
        -7,
        -14
      ],
      [
        -5,
        -4
      ],
      [
        -7,
        -14
      ],
      [
        -7,
        34
      ],
      [
        0,
        26
      ],
      [
        -3,
        20
      ],
      [
        -6,
        -10
      ],
      [
        -4,
        2
      ],
      [
        0,
        4
      ],
      [
        2,
        12
      ],
      [
        0,
        7
      ],
      [
        -1,
        8
      ],
      [
        -2,
        9
      ],
      [
        -2,
        33
      ],
      [
        -3,
        45
      ],
      [
        -2,
        5
      ],
      [
        -3,
        1
      ],
      [
        -3,
        -1
      ],
      [
        -5,
        -7
      ],
      [
        -7,
        -6
      ],
      [
        -5,
        5
      ],
      [
        -1,
        4
      ],
      [
        0,
        6
      ],
      [
        1,
        1
      ],
      [
        2,
        8
      ],
      [
        3,
        18
      ],
      [
        0,
        26
      ],
      [
        1,
        17
      ],
      [
        1,
        13
      ],
      [
        0,
        12
      ],
      [
        -1,
        17
      ],
      [
        -3,
        8
      ],
      [
        -9,
        4
      ],
      [
        -13,
        -8
      ],
      [
        -7,
        12
      ],
      [
        -4,
        -1
      ],
      [
        -9,
        -9
      ],
      [
        -13,
        -25
      ],
      [
        -7,
        -13
      ],
      [
        -7,
        6
      ],
      [
        6,
        17
      ],
      [
        0,
        10
      ]
    ],
    [
      [
        31195,
        38089
      ],
      [
        5,
        -18
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        31200,
        38072
      ],
      [
        8,
        -25
      ],
      [
        2,
        -20
      ],
      [
        7,
        -10
      ]
    ],
    [
      [
        31217,
        38017
      ],
      [
        -1,
        -38
      ],
      [
        1,
        -7
      ],
      [
        -2,
        -13
      ]
    ],
    [
      [
        31215,
        37959
      ],
      [
        -2,
        -27
      ],
      [
        1,
        -20
      ],
      [
        2,
        -48
      ],
      [
        -2,
        -34
      ]
    ],
    [
      [
        31214,
        37830
      ],
      [
        -5,
        3
      ],
      [
        -1,
        4
      ],
      [
        -10,
        13
      ],
      [
        -3,
        2
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -14
      ],
      [
        1,
        -5
      ],
      [
        1,
        -10
      ],
      [
        0,
        -8
      ],
      [
        -3,
        2
      ],
      [
        0,
        1
      ],
      [
        -1,
        2
      ],
      [
        -2,
        12
      ],
      [
        -2,
        8
      ],
      [
        0,
        4
      ],
      [
        -1,
        8
      ],
      [
        0,
        24
      ],
      [
        1,
        11
      ],
      [
        1,
        6
      ],
      [
        8,
        13
      ],
      [
        1,
        2
      ],
      [
        1,
        5
      ],
      [
        0,
        11
      ],
      [
        -6,
        8
      ],
      [
        -5,
        4
      ],
      [
        4,
        37
      ],
      [
        0,
        12
      ],
      [
        -1,
        16
      ],
      [
        2,
        6
      ],
      [
        3,
        9
      ],
      [
        0,
        6
      ],
      [
        2,
        49
      ],
      [
        -1,
        10
      ],
      [
        0,
        10
      ]
    ],
    [
      [
        15542,
        70657
      ],
      [
        8,
        0
      ],
      [
        9,
        -2
      ],
      [
        6,
        1
      ],
      [
        8,
        13
      ],
      [
        6,
        11
      ],
      [
        5,
        8
      ]
    ],
    [
      [
        15584,
        70688
      ],
      [
        13,
        19
      ],
      [
        14,
        -4
      ],
      [
        3,
        -9
      ],
      [
        15,
        -28
      ],
      [
        2,
        -9
      ],
      [
        3,
        -2
      ],
      [
        3,
        -6
      ],
      [
        3,
        -4
      ],
      [
        2,
        -2
      ],
      [
        11,
        -34
      ],
      [
        17,
        -25
      ],
      [
        5,
        -27
      ],
      [
        0,
        -5
      ],
      [
        2,
        -29
      ],
      [
        6,
        -19
      ],
      [
        5,
        -39
      ],
      [
        7,
        -23
      ],
      [
        2,
        -34
      ],
      [
        -1,
        -23
      ],
      [
        3,
        -33
      ],
      [
        4,
        -19
      ],
      [
        0,
        -20
      ]
    ],
    [
      [
        15703,
        70313
      ],
      [
        0,
        -7
      ],
      [
        -3,
        -23
      ],
      [
        0,
        -17
      ],
      [
        7,
        -34
      ],
      [
        2,
        -25
      ],
      [
        1,
        -11
      ],
      [
        0,
        -18
      ],
      [
        -1,
        -7
      ]
    ],
    [
      [
        15709,
        70171
      ],
      [
        -6,
        -9
      ],
      [
        -40,
        1
      ]
    ],
    [
      [
        15663,
        70163
      ],
      [
        0,
        16
      ],
      [
        -17,
        1
      ],
      [
        0,
        17
      ],
      [
        -12,
        1
      ],
      [
        0,
        32
      ],
      [
        -86,
        1
      ],
      [
        -6,
        -1
      ]
    ],
    [
      [
        15542,
        70230
      ],
      [
        1,
        67
      ],
      [
        0,
        34
      ],
      [
        -2,
        202
      ],
      [
        1,
        124
      ]
    ],
    [
      [
        16508,
        67706
      ],
      [
        -1,
        102
      ]
    ],
    [
      [
        16507,
        67808
      ],
      [
        34,
        -1
      ],
      [
        0,
        304
      ],
      [
        33,
        0
      ]
    ],
    [
      [
        16973,
        68205
      ],
      [
        0,
        -282
      ],
      [
        -2,
        -31
      ],
      [
        0,
        -461
      ],
      [
        1,
        -30
      ],
      [
        0,
        -506
      ],
      [
        4,
        1
      ],
      [
        0,
        -744
      ],
      [
        6,
        0
      ],
      [
        -1,
        -325
      ]
    ],
    [
      [
        16981,
        65827
      ],
      [
        -85,
        -2
      ],
      [
        -28,
        -1
      ],
      [
        -26,
        -3
      ],
      [
        -22,
        1
      ],
      [
        -6,
        0
      ],
      [
        -57,
        2
      ],
      [
        -58,
        -1
      ],
      [
        -6,
        1
      ],
      [
        -26,
        0
      ]
    ],
    [
      [
        16667,
        65824
      ],
      [
        -10,
        0
      ]
    ],
    [
      [
        22594,
        52589
      ],
      [
        25,
        188
      ],
      [
        37,
        140
      ]
    ],
    [
      [
        22799,
        52738
      ],
      [
        12,
        -20
      ],
      [
        33,
        -324
      ]
    ],
    [
      [
        22844,
        52394
      ],
      [
        -50,
        -63
      ]
    ],
    [
      [
        22794,
        52331
      ],
      [
        -10,
        19
      ]
    ],
    [
      [
        22784,
        52350
      ],
      [
        -4,
        6
      ],
      [
        -6,
        20
      ],
      [
        -3,
        -5
      ],
      [
        -8,
        28
      ],
      [
        -6,
        3
      ],
      [
        -13,
        25
      ],
      [
        -4,
        -12
      ],
      [
        -6,
        0
      ],
      [
        -2,
        18
      ],
      [
        -6,
        13
      ],
      [
        -5,
        0
      ],
      [
        -16,
        -31
      ],
      [
        -3,
        8
      ],
      [
        -5,
        -2
      ],
      [
        -2,
        -22
      ],
      [
        -9,
        -6
      ],
      [
        -7,
        -8
      ],
      [
        -2,
        -19
      ],
      [
        -6,
        -3
      ],
      [
        -4,
        16
      ],
      [
        -2,
        1
      ],
      [
        -4,
        2
      ],
      [
        -11,
        30
      ],
      [
        -2,
        34
      ],
      [
        -4,
        24
      ],
      [
        1,
        28
      ],
      [
        -10,
        29
      ],
      [
        -6,
        -4
      ],
      [
        3,
        15
      ],
      [
        -1,
        28
      ],
      [
        -11,
        27
      ],
      [
        -9,
        -21
      ],
      [
        -5,
        20
      ],
      [
        -8,
        -18
      ],
      [
        -4,
        15
      ]
    ],
    [
      [
        19265,
        64664
      ],
      [
        40,
        0
      ],
      [
        39,
        1
      ],
      [
        50,
        0
      ],
      [
        10,
        1
      ],
      [
        70,
        2
      ],
      [
        5,
        1
      ],
      [
        16,
        -1
      ],
      [
        35,
        -1
      ]
    ],
    [
      [
        19530,
        64667
      ],
      [
        0,
        -393
      ]
    ],
    [
      [
        19530,
        64274
      ],
      [
        -21,
        0
      ],
      [
        0,
        25
      ],
      [
        -10,
        0
      ],
      [
        -1,
        102
      ],
      [
        0,
        17
      ],
      [
        -11,
        -1
      ],
      [
        0,
        85
      ],
      [
        -53,
        0
      ],
      [
        0,
        -79
      ],
      [
        -11,
        -16
      ],
      [
        -1,
        -22
      ],
      [
        -9,
        -3
      ],
      [
        -4,
        -17
      ],
      [
        -8,
        12
      ],
      [
        -2,
        36
      ],
      [
        2,
        15
      ],
      [
        -4,
        37
      ],
      [
        -13,
        -16
      ],
      [
        -2,
        14
      ],
      [
        -6,
        -12
      ],
      [
        -9,
        1
      ],
      [
        -12,
        -24
      ],
      [
        -5,
        8
      ],
      [
        -7,
        0
      ],
      [
        -2,
        -8
      ],
      [
        -7,
        9
      ],
      [
        -4,
        -23
      ],
      [
        -7,
        -1
      ],
      [
        -11,
        -7
      ],
      [
        -1,
        -9
      ],
      [
        -10,
        -5
      ],
      [
        -7,
        21
      ],
      [
        -4,
        -1
      ],
      [
        -2,
        11
      ],
      [
        -7,
        5
      ],
      [
        -10,
        17
      ]
    ],
    [
      [
        19271,
        64445
      ],
      [
        -3,
        -2
      ],
      [
        -3,
        7
      ]
    ],
    [
      [
        21829,
        50979
      ],
      [
        6,
        5
      ],
      [
        5,
        -9
      ],
      [
        -2,
        12
      ],
      [
        5,
        8
      ],
      [
        2,
        41
      ],
      [
        -3,
        17
      ],
      [
        1,
        27
      ],
      [
        10,
        11
      ],
      [
        1,
        31
      ],
      [
        -1,
        6
      ],
      [
        1,
        37
      ],
      [
        2,
        22
      ],
      [
        0,
        237
      ]
    ],
    [
      [
        21856,
        51424
      ],
      [
        164,
        -1
      ]
    ],
    [
      [
        22020,
        50798
      ],
      [
        -155,
        -2
      ]
    ],
    [
      [
        21865,
        50796
      ],
      [
        -2,
        18
      ],
      [
        -3,
        13
      ],
      [
        -2,
        5
      ],
      [
        -5,
        5
      ],
      [
        -5,
        11
      ],
      [
        -3,
        12
      ],
      [
        0,
        13
      ],
      [
        -2,
        4
      ],
      [
        -4,
        4
      ],
      [
        -3,
        13
      ],
      [
        -1,
        6
      ],
      [
        3,
        14
      ],
      [
        -1,
        11
      ],
      [
        -5,
        38
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        2
      ],
      [
        0,
        16
      ]
    ],
    [
      [
        18869,
        65087
      ],
      [
        10,
        15
      ],
      [
        5,
        -14
      ],
      [
        10,
        -5
      ],
      [
        1,
        -14
      ],
      [
        9,
        -18
      ],
      [
        1,
        -24
      ],
      [
        8,
        -15
      ],
      [
        0,
        -11
      ],
      [
        -4,
        -11
      ],
      [
        0,
        -37
      ],
      [
        2,
        -11
      ],
      [
        -3,
        -13
      ],
      [
        8,
        4
      ],
      [
        0,
        -17
      ],
      [
        8,
        1
      ],
      [
        -2,
        -14
      ],
      [
        1,
        -14
      ],
      [
        -4,
        -31
      ],
      [
        -7,
        -24
      ]
    ],
    [
      [
        18808,
        64433
      ],
      [
        -2,
        29
      ],
      [
        -5,
        9
      ],
      [
        0,
        21
      ],
      [
        -12,
        3
      ],
      [
        -9,
        10
      ]
    ],
    [
      [
        18780,
        64505
      ],
      [
        -8,
        13
      ],
      [
        -7,
        68
      ],
      [
        -6,
        29
      ],
      [
        0,
        5
      ],
      [
        11,
        -1
      ],
      [
        -7,
        39
      ],
      [
        -3,
        15
      ],
      [
        -1,
        0
      ],
      [
        -6,
        20
      ],
      [
        1,
        17
      ],
      [
        -5,
        34
      ],
      [
        -1,
        45
      ],
      [
        0,
        7
      ],
      [
        3,
        12
      ],
      [
        -3,
        21
      ]
    ],
    [
      [
        18748,
        64829
      ],
      [
        0,
        18
      ],
      [
        -6,
        17
      ],
      [
        1,
        21
      ],
      [
        4,
        12
      ],
      [
        12,
        8
      ],
      [
        4,
        15
      ],
      [
        15,
        -4
      ],
      [
        1,
        -12
      ],
      [
        7,
        -19
      ],
      [
        11,
        -7
      ],
      [
        6,
        5
      ],
      [
        5,
        15
      ],
      [
        4,
        2
      ],
      [
        4,
        11
      ],
      [
        1,
        23
      ],
      [
        3,
        10
      ],
      [
        10,
        2
      ],
      [
        7,
        -4
      ],
      [
        3,
        -9
      ],
      [
        8,
        -2
      ],
      [
        1,
        17
      ],
      [
        4,
        4
      ],
      [
        6,
        33
      ],
      [
        5,
        19
      ],
      [
        -3,
        30
      ],
      [
        3,
        10
      ],
      [
        0,
        16
      ],
      [
        3,
        6
      ],
      [
        2,
        21
      ]
    ],
    [
      [
        28480,
        59670
      ],
      [
        -2,
        -3
      ],
      [
        1,
        -1
      ],
      [
        0,
        -4
      ]
    ],
    [
      [
        28479,
        59662
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        28479,
        59661
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        28480,
        59661
      ],
      [
        -1,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        28480,
        59661
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        28481,
        59661
      ],
      [
        0,
        0
      ]
    ],
    [
      [
        28481,
        59661
      ],
      [
        0,
        -1
      ],
      [
        1,
        1
      ]
    ],
    [
      [
        28482,
        59661
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        28482,
        59662
      ],
      [
        1,
        0
      ],
      [
        0,
        -7
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        28482,
        59655
      ],
      [
        0,
        0
      ]
    ],
    [
      [
        28482,
        59655
      ],
      [
        0,
        -6
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        1,
        0
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        28480,
        59641
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        28480,
        59642
      ],
      [
        0,
        -2
      ],
      [
        1,
        0
      ],
      [
        1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        0,
        -3
      ],
      [
        1,
        -28
      ]
    ],
    [
      [
        28484,
        59601
      ],
      [
        -12,
        18
      ],
      [
        -1,
        3
      ],
      [
        -2,
        1
      ],
      [
        4,
        13
      ],
      [
        -5,
        6
      ],
      [
        0,
        22
      ],
      [
        8,
        7
      ],
      [
        4,
        -1
      ]
    ],
    [
      [
        20674,
        63166
      ],
      [
        4,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        1,
        -9
      ],
      [
        -4,
        -2
      ],
      [
        0,
        19
      ]
    ],
    [
      [
        20643,
        63062
      ],
      [
        0,
        9
      ]
    ],
    [
      [
        20643,
        63071
      ],
      [
        0,
        3
      ]
    ],
    [
      [
        20643,
        63074
      ],
      [
        3,
        -4
      ],
      [
        2,
        -1
      ],
      [
        3,
        1
      ],
      [
        -3,
        29
      ],
      [
        6,
        8
      ],
      [
        2,
        22
      ],
      [
        -1,
        -22
      ],
      [
        10,
        9
      ],
      [
        9,
        -17
      ],
      [
        3,
        0
      ],
      [
        5,
        -17
      ],
      [
        0,
        -17
      ],
      [
        8,
        0
      ],
      [
        0,
        18
      ],
      [
        1,
        7
      ],
      [
        1,
        -1
      ],
      [
        8,
        14
      ],
      [
        0,
        3
      ],
      [
        -5,
        13
      ],
      [
        -10,
        -3
      ],
      [
        4,
        17
      ],
      [
        -4,
        12
      ],
      [
        3,
        4
      ],
      [
        7,
        0
      ],
      [
        -2,
        34
      ],
      [
        -3,
        4
      ],
      [
        0,
        13
      ]
    ],
    [
      [
        20690,
        63200
      ],
      [
        21,
        0
      ],
      [
        42,
        1
      ],
      [
        7,
        -1
      ],
      [
        9,
        0
      ],
      [
        21,
        -2
      ],
      [
        15,
        0
      ],
      [
        213,
        2
      ]
    ],
    [
      [
        21018,
        62998
      ],
      [
        -2,
        0
      ]
    ],
    [
      [
        20752,
        62997
      ],
      [
        -23,
        0
      ],
      [
        -11,
        1
      ],
      [
        -9,
        -1
      ],
      [
        -27,
        0
      ],
      [
        -17,
        1
      ],
      [
        -21,
        0
      ]
    ],
    [
      [
        20644,
        62998
      ],
      [
        -1,
        0
      ],
      [
        0,
        64
      ]
    ],
    [
      [
        26081,
        57244
      ],
      [
        12,
        54
      ],
      [
        0,
        34
      ],
      [
        8,
        38
      ],
      [
        1,
        23
      ],
      [
        3,
        9
      ],
      [
        0,
        84
      ],
      [
        4,
        51
      ],
      [
        4,
        29
      ],
      [
        13,
        72
      ],
      [
        3,
        25
      ]
    ],
    [
      [
        26129,
        57663
      ],
      [
        10,
        1
      ],
      [
        9,
        0
      ],
      [
        5,
        1
      ],
      [
        3,
        0
      ]
    ],
    [
      [
        26156,
        57665
      ],
      [
        0,
        -152
      ],
      [
        18,
        0
      ],
      [
        0,
        -93
      ],
      [
        12,
        1
      ],
      [
        4,
        -9
      ]
    ],
    [
      [
        26190,
        57412
      ],
      [
        -7,
        -55
      ],
      [
        22,
        0
      ],
      [
        11,
        -1
      ],
      [
        0,
        -113
      ]
    ],
    [
      [
        26216,
        57243
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -41
      ],
      [
        -2,
        0
      ]
    ],
    [
      [
        26200,
        57202
      ],
      [
        -5,
        1
      ],
      [
        -55,
        1
      ],
      [
        -8,
        0
      ],
      [
        0,
        -8
      ],
      [
        -6,
        9
      ],
      [
        -43,
        -1
      ]
    ],
    [
      [
        26083,
        57204
      ],
      [
        -2,
        40
      ]
    ],
    [
      [
        25556,
        63447
      ],
      [
        28,
        1
      ],
      [
        63,
        0
      ]
    ],
    [
      [
        25647,
        63448
      ],
      [
        0,
        -100
      ],
      [
        23,
        -1
      ]
    ],
    [
      [
        25670,
        63347
      ],
      [
        -1,
        -304
      ]
    ],
    [
      [
        25669,
        63043
      ],
      [
        -31,
        1
      ],
      [
        -21,
        1
      ]
    ],
    [
      [
        25617,
        63045
      ],
      [
        -51,
        1
      ]
    ],
    [
      [
        25566,
        63046
      ],
      [
        -3,
        53
      ],
      [
        4,
        48
      ],
      [
        -1,
        28
      ],
      [
        2,
        32
      ],
      [
        -1,
        24
      ],
      [
        1,
        30
      ],
      [
        -2,
        14
      ],
      [
        -1,
        34
      ],
      [
        6,
        11
      ],
      [
        3,
        22
      ],
      [
        -6,
        13
      ],
      [
        2,
        20
      ],
      [
        -3,
        16
      ],
      [
        -7,
        8
      ],
      [
        -4,
        17
      ],
      [
        -4,
        7
      ],
      [
        4,
        24
      ]
    ],
    [
      [
        25983,
        62029
      ],
      [
        1,
        -11
      ],
      [
        4,
        2
      ],
      [
        8,
        17
      ],
      [
        6,
        41
      ],
      [
        4,
        4
      ],
      [
        2,
        32
      ]
    ],
    [
      [
        26040,
        62124
      ],
      [
        0,
        -92
      ],
      [
        10,
        -8
      ],
      [
        0,
        -25
      ],
      [
        10,
        -1
      ],
      [
        1,
        -33
      ],
      [
        10,
        -1
      ],
      [
        0,
        -84
      ]
    ],
    [
      [
        26071,
        61880
      ],
      [
        -41,
        -1
      ],
      [
        -9,
        1
      ],
      [
        -4,
        -1
      ],
      [
        -8,
        0
      ],
      [
        -8,
        -35
      ],
      [
        0,
        -16
      ],
      [
        -7,
        0
      ]
    ],
    [
      [
        25994,
        61828
      ],
      [
        0,
        17
      ],
      [
        -11,
        -1
      ],
      [
        0,
        185
      ]
    ],
    [
      [
        25920,
        60082
      ],
      [
        -8,
        -79
      ],
      [
        -7,
        -69
      ]
    ],
    [
      [
        25905,
        59934
      ],
      [
        -6,
        -15
      ],
      [
        -4,
        14
      ],
      [
        -1,
        -30
      ],
      [
        -8,
        -12
      ],
      [
        -9,
        -6
      ],
      [
        0,
        -6
      ],
      [
        1,
        -3
      ],
      [
        0,
        -13
      ],
      [
        -3,
        -10
      ],
      [
        -16,
        -44
      ],
      [
        -21,
        -59
      ]
    ],
    [
      [
        25838,
        59750
      ],
      [
        2,
        36
      ],
      [
        -51,
        27
      ],
      [
        -6,
        45
      ],
      [
        -2,
        16
      ]
    ],
    [
      [
        25781,
        59874
      ],
      [
        -1,
        11
      ],
      [
        -16,
        125
      ]
    ],
    [
      [
        25764,
        60010
      ],
      [
        2,
        24
      ],
      [
        14,
        147
      ],
      [
        -1,
        0
      ],
      [
        0,
        3
      ],
      [
        1,
        1
      ],
      [
        0,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        4
      ],
      [
        -1,
        2
      ],
      [
        0,
        5
      ],
      [
        1,
        3
      ],
      [
        -3,
        19
      ],
      [
        17,
        7
      ],
      [
        -1,
        -8
      ],
      [
        7,
        -5
      ],
      [
        12,
        17
      ],
      [
        3,
        -10
      ],
      [
        5,
        -34
      ],
      [
        5,
        -2
      ],
      [
        2,
        17
      ],
      [
        9,
        -15
      ],
      [
        1,
        18
      ],
      [
        2,
        2
      ]
    ],
    [
      [
        23830,
        54467
      ],
      [
        40,
        -1
      ]
    ],
    [
      [
        23870,
        54466
      ],
      [
        12,
        -1
      ]
    ],
    [
      [
        23949,
        54363
      ],
      [
        10,
        -51
      ],
      [
        -4,
        -13
      ],
      [
        8,
        -43
      ],
      [
        -5,
        -37
      ],
      [
        -1,
        -18
      ],
      [
        6,
        -30
      ],
      [
        4,
        -13
      ],
      [
        -32,
        0
      ],
      [
        -1,
        -80
      ],
      [
        -1,
        8
      ],
      [
        -10,
        -27
      ],
      [
        -6,
        12
      ],
      [
        -4,
        -9
      ],
      [
        -9,
        10
      ],
      [
        -2,
        39
      ]
    ],
    [
      [
        23902,
        54111
      ],
      [
        -3,
        4
      ],
      [
        -2,
        30
      ],
      [
        -9,
        31
      ],
      [
        -10,
        2
      ],
      [
        -5,
        36
      ],
      [
        -6,
        13
      ],
      [
        0,
        30
      ],
      [
        -6,
        6
      ],
      [
        -2,
        18
      ],
      [
        -9,
        32
      ],
      [
        6,
        23
      ],
      [
        3,
        8
      ],
      [
        -3,
        14
      ],
      [
        -1,
        44
      ],
      [
        -3,
        13
      ],
      [
        -6,
        -1
      ],
      [
        -10,
        15
      ],
      [
        -1,
        15
      ],
      [
        -5,
        23
      ]
    ],
    [
      [
        23505,
        68690
      ],
      [
        -2,
        -6
      ],
      [
        6,
        -9
      ],
      [
        5,
        7
      ],
      [
        6,
        -18
      ],
      [
        9,
        -7
      ],
      [
        -2,
        -13
      ],
      [
        4,
        1
      ],
      [
        -1,
        -18
      ],
      [
        3,
        8
      ],
      [
        4,
        -17
      ],
      [
        3,
        6
      ],
      [
        9,
        -20
      ],
      [
        8,
        3
      ],
      [
        4,
        -15
      ],
      [
        7,
        4
      ],
      [
        2,
        -13
      ],
      [
        7,
        1
      ],
      [
        4,
        -12
      ],
      [
        5,
        6
      ],
      [
        0,
        -9
      ],
      [
        8,
        -23
      ],
      [
        3,
        1
      ],
      [
        0,
        -20
      ],
      [
        5,
        -24
      ],
      [
        5,
        -10
      ],
      [
        1,
        -16
      ],
      [
        11,
        -10
      ]
    ],
    [
      [
        23619,
        68467
      ],
      [
        1,
        -182
      ]
    ],
    [
      [
        24378,
        61993
      ],
      [
        4,
        414
      ]
    ],
    [
      [
        24382,
        62407
      ],
      [
        1,
        104
      ],
      [
        61,
        -7
      ]
    ],
    [
      [
        24444,
        62504
      ],
      [
        42,
        -3
      ]
    ],
    [
      [
        24486,
        62501
      ],
      [
        -1,
        -171
      ]
    ],
    [
      [
        24442,
        62001
      ],
      [
        -7,
        -1
      ],
      [
        -4,
        -3
      ],
      [
        1,
        3
      ],
      [
        -5,
        -2
      ],
      [
        -4,
        7
      ],
      [
        -3,
        -5
      ],
      [
        -2,
        -7
      ],
      [
        0,
        -9
      ],
      [
        -12,
        -22
      ],
      [
        -11,
        7
      ],
      [
        -15,
        25
      ]
    ],
    [
      [
        24380,
        61994
      ],
      [
        -2,
        -1
      ]
    ],
    [
      [
        24757,
        58842
      ],
      [
        36,
        1
      ],
      [
        9,
        1
      ],
      [
        6,
        0
      ],
      [
        37,
        1
      ],
      [
        3,
        0
      ]
    ],
    [
      [
        24911,
        58847
      ],
      [
        1,
        -4
      ],
      [
        1,
        -4
      ],
      [
        2,
        -9
      ],
      [
        0,
        -21
      ],
      [
        2,
        -6
      ],
      [
        1,
        -3
      ],
      [
        3,
        -7
      ],
      [
        3,
        -7
      ],
      [
        3,
        -9
      ],
      [
        2,
        -5
      ],
      [
        4,
        -12
      ],
      [
        1,
        -5
      ],
      [
        0,
        -4
      ],
      [
        1,
        -12
      ],
      [
        1,
        -4
      ]
    ],
    [
      [
        24936,
        58735
      ],
      [
        -1,
        -11
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -2,
        2
      ],
      [
        -1,
        5
      ],
      [
        -2,
        8
      ],
      [
        -8,
        11
      ],
      [
        -7,
        1
      ],
      [
        -4,
        -10
      ],
      [
        -3,
        -8
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -13
      ],
      [
        1,
        -4
      ],
      [
        2,
        -4
      ],
      [
        4,
        -6
      ],
      [
        5,
        -6
      ],
      [
        6,
        -10
      ],
      [
        1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        0,
        -16
      ],
      [
        -1,
        -2
      ],
      [
        -4,
        -8
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        -1
      ],
      [
        -5,
        6
      ],
      [
        -2,
        1
      ],
      [
        0,
        -2
      ],
      [
        -4,
        -6
      ],
      [
        -4,
        -14
      ],
      [
        -1,
        -5
      ],
      [
        1,
        -7
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        -3,
        -13
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -1
      ],
      [
        -4,
        1
      ],
      [
        -3,
        -7
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        -8
      ],
      [
        -1,
        0
      ],
      [
        -2,
        5
      ],
      [
        -1,
        5
      ],
      [
        -5,
        11
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        -10,
        -19
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -14
      ],
      [
        0,
        -25
      ],
      [
        1,
        -5
      ],
      [
        1,
        -4
      ],
      [
        2,
        -9
      ],
      [
        1,
        -11
      ],
      [
        2,
        -6
      ],
      [
        3,
        -6
      ],
      [
        2,
        -3
      ],
      [
        2,
        -2
      ],
      [
        2,
        0
      ],
      [
        3,
        2
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        3
      ],
      [
        1,
        8
      ],
      [
        0,
        2
      ],
      [
        2,
        2
      ],
      [
        2,
        3
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        2,
        -7
      ],
      [
        0,
        -6
      ],
      [
        1,
        -9
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -4
      ],
      [
        -4,
        -5
      ],
      [
        -5,
        -13
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -6
      ],
      [
        -3,
        -5
      ],
      [
        -4,
        -7
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -11
      ],
      [
        1,
        -6
      ],
      [
        2,
        -15
      ],
      [
        0,
        -3
      ],
      [
        1,
        -5
      ],
      [
        4,
        -6
      ],
      [
        1,
        -1
      ],
      [
        2,
        0
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -11
      ]
    ],
    [
      [
        24862,
        58309
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -13
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        1
      ],
      [
        -2,
        5
      ],
      [
        -4,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -2,
        4
      ],
      [
        0,
        19
      ],
      [
        -5,
        14
      ],
      [
        -4,
        7
      ],
      [
        -1,
        1
      ],
      [
        -2,
        1
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -12
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -21
      ],
      [
        1,
        -9
      ],
      [
        1,
        -5
      ],
      [
        2,
        -13
      ],
      [
        4,
        -12
      ],
      [
        1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -16
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -6
      ]
    ],
    [
      [
        24823,
        58157
      ],
      [
        -2,
        -5
      ]
    ],
    [
      [
        24821,
        58152
      ],
      [
        -3,
        6
      ],
      [
        2,
        8
      ],
      [
        -3,
        9
      ],
      [
        -1,
        12
      ],
      [
        0,
        7
      ],
      [
        1,
        13
      ],
      [
        1,
        12
      ],
      [
        0,
        6
      ],
      [
        -1,
        5
      ],
      [
        -2,
        7
      ],
      [
        -2,
        3
      ],
      [
        -3,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        0
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -6
      ],
      [
        -2,
        -21
      ],
      [
        -3,
        -7
      ]
    ],
    [
      [
        24798,
        58190
      ],
      [
        -41,
        3
      ]
    ],
    [
      [
        24757,
        58497
      ],
      [
        0,
        345
      ]
    ],
    [
      [
        24238,
        59427
      ],
      [
        8,
        0
      ]
    ],
    [
      [
        24246,
        59427
      ],
      [
        110,
        0
      ],
      [
        11,
        1
      ],
      [
        4,
        0
      ]
    ],
    [
      [
        24371,
        59428
      ],
      [
        8,
        0
      ],
      [
        3,
        -1
      ],
      [
        4,
        1
      ],
      [
        5,
        0
      ],
      [
        1,
        -1
      ],
      [
        27,
        0
      ],
      [
        14,
        -1
      ]
    ],
    [
      [
        24433,
        59426
      ],
      [
        -1,
        -92
      ],
      [
        0,
        -97
      ],
      [
        -16,
        1
      ],
      [
        -15,
        1
      ],
      [
        0,
        -102
      ],
      [
        -35,
        4
      ]
    ],
    [
      [
        24236,
        59150
      ],
      [
        -1,
        3
      ],
      [
        1,
        28
      ],
      [
        1,
        72
      ],
      [
        0,
        5
      ],
      [
        1,
        145
      ],
      [
        0,
        24
      ]
    ],
    [
      [
        25935,
        57072
      ],
      [
        7,
        -3
      ],
      [
        5,
        10
      ],
      [
        3,
        -2
      ],
      [
        11,
        22
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        6
      ],
      [
        6,
        21
      ],
      [
        16,
        43
      ],
      [
        26,
        72
      ],
      [
        26,
        140
      ],
      [
        5,
        0
      ],
      [
        4,
        12
      ],
      [
        7,
        51
      ],
      [
        2,
        39
      ],
      [
        13,
        33
      ]
    ],
    [
      [
        26068,
        57520
      ],
      [
        6,
        -129
      ],
      [
        2,
        -48
      ],
      [
        3,
        -60
      ],
      [
        2,
        -37
      ],
      [
        0,
        -2
      ]
    ],
    [
      [
        26083,
        57204
      ],
      [
        3,
        -54
      ],
      [
        1,
        -20
      ],
      [
        0,
        -2
      ]
    ],
    [
      [
        26087,
        57128
      ],
      [
        -6,
        -11
      ],
      [
        -3,
        -17
      ],
      [
        -4,
        2
      ],
      [
        0,
        -13
      ],
      [
        -5,
        -8
      ],
      [
        2,
        -18
      ],
      [
        -3,
        3
      ],
      [
        -1,
        -15
      ],
      [
        2,
        -21
      ],
      [
        -6,
        -22
      ],
      [
        -5,
        -32
      ],
      [
        -3,
        3
      ],
      [
        2,
        -10
      ],
      [
        -4,
        -24
      ],
      [
        -8,
        -5
      ],
      [
        -2,
        -12
      ],
      [
        -1,
        -10
      ],
      [
        -28,
        -98
      ],
      [
        -9,
        0
      ],
      [
        0,
        -23
      ],
      [
        -10,
        6
      ],
      [
        0,
        -52
      ]
    ],
    [
      [
        25995,
        56751
      ],
      [
        -73,
        1
      ]
    ],
    [
      [
        25922,
        56752
      ],
      [
        0,
        59
      ],
      [
        -1,
        36
      ],
      [
        0,
        129
      ],
      [
        -3,
        12
      ],
      [
        3,
        28
      ],
      [
        14,
        56
      ]
    ],
    [
      [
        23598,
        57605
      ],
      [
        5,
        -3
      ],
      [
        6,
        22
      ],
      [
        4,
        -7
      ],
      [
        5,
        5
      ],
      [
        2,
        16
      ],
      [
        5,
        -16
      ],
      [
        7,
        9
      ],
      [
        8,
        -4
      ],
      [
        11,
        8
      ],
      [
        7,
        11
      ],
      [
        0,
        20
      ],
      [
        1,
        82
      ],
      [
        -1,
        1
      ],
      [
        -5,
        1
      ],
      [
        0,
        9
      ],
      [
        5,
        5
      ],
      [
        10,
        18
      ],
      [
        10,
        8
      ],
      [
        0,
        9
      ],
      [
        5,
        -1
      ]
    ],
    [
      [
        23683,
        57798
      ],
      [
        0,
        -51
      ],
      [
        19,
        -2
      ],
      [
        0,
        -32
      ],
      [
        103,
        -8
      ]
    ],
    [
      [
        23805,
        57705
      ],
      [
        -1,
        -102
      ],
      [
        0,
        -31
      ],
      [
        -1,
        -186
      ]
    ],
    [
      [
        23742,
        57293
      ],
      [
        0,
        17
      ],
      [
        -24,
        4
      ],
      [
        0,
        10
      ],
      [
        -84,
        6
      ],
      [
        0,
        34
      ],
      [
        -38,
        3
      ]
    ],
    [
      [
        23596,
        57367
      ],
      [
        1,
        115
      ],
      [
        0,
        79
      ],
      [
        1,
        44
      ]
    ],
    [
      [
        15459,
        65111
      ],
      [
        -31,
        -1
      ],
      [
        0,
        97
      ],
      [
        -32,
        2
      ],
      [
        -50,
        -1
      ]
    ],
    [
      [
        15346,
        65208
      ],
      [
        0,
        6
      ],
      [
        -3,
        37
      ],
      [
        -1,
        11
      ],
      [
        0,
        42
      ],
      [
        -3,
        7
      ],
      [
        -3,
        18
      ],
      [
        0,
        11
      ],
      [
        1,
        8
      ],
      [
        -1,
        20
      ],
      [
        -3,
        17
      ],
      [
        -1,
        14
      ],
      [
        -1,
        13
      ],
      [
        -4,
        20
      ],
      [
        -1,
        17
      ],
      [
        0,
        8
      ],
      [
        -2,
        35
      ],
      [
        -1,
        10
      ],
      [
        -2,
        13
      ],
      [
        -2,
        13
      ],
      [
        -4,
        7
      ],
      [
        -2,
        -8
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        0
      ],
      [
        -2,
        12
      ],
      [
        -10,
        28
      ],
      [
        -1,
        1
      ],
      [
        -2,
        0
      ],
      [
        -2,
        13
      ],
      [
        3,
        11
      ],
      [
        4,
        31
      ],
      [
        3,
        32
      ],
      [
        3,
        49
      ],
      [
        2,
        61
      ],
      [
        -1,
        49
      ],
      [
        -2,
        18
      ]
    ],
    [
      [
        24857,
        66420
      ],
      [
        1,
        0
      ],
      [
        24,
        -1
      ]
    ],
    [
      [
        24882,
        66419
      ],
      [
        48,
        0
      ],
      [
        4,
        -1
      ],
      [
        2,
        0
      ],
      [
        9,
        -1
      ],
      [
        5,
        0
      ],
      [
        8,
        -1
      ],
      [
        12,
        -1
      ],
      [
        8,
        0
      ],
      [
        3,
        -1
      ],
      [
        17,
        0
      ],
      [
        0,
        -1
      ],
      [
        6,
        0
      ]
    ],
    [
      [
        24924,
        66063
      ],
      [
        -63,
        -4
      ],
      [
        -2,
        1
      ]
    ],
    [
      [
        25762,
        61634
      ],
      [
        18,
        1
      ],
      [
        85,
        -2
      ],
      [
        0,
        34
      ]
    ],
    [
      [
        25865,
        61667
      ],
      [
        15,
        0
      ]
    ],
    [
      [
        25880,
        61667
      ],
      [
        -1,
        -40
      ],
      [
        4,
        -46
      ],
      [
        -7,
        14
      ],
      [
        -3,
        -12
      ],
      [
        2,
        -18
      ],
      [
        0,
        -17
      ],
      [
        -4,
        -6
      ],
      [
        8,
        -11
      ],
      [
        -1,
        -13
      ],
      [
        3,
        -4
      ],
      [
        -6,
        -14
      ],
      [
        -1,
        -61
      ],
      [
        -5,
        -4
      ],
      [
        2,
        -25
      ],
      [
        -5,
        0
      ],
      [
        -3,
        -28
      ],
      [
        -4,
        3
      ]
    ],
    [
      [
        25859,
        61385
      ],
      [
        0,
        2
      ],
      [
        -4,
        15
      ],
      [
        -4,
        4
      ],
      [
        -4,
        -6
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -17
      ],
      [
        2,
        -8
      ],
      [
        5,
        -6
      ],
      [
        8,
        -6
      ],
      [
        1,
        -8
      ],
      [
        -1,
        -10
      ],
      [
        -1,
        -7
      ],
      [
        -2,
        -4
      ],
      [
        -5,
        -1
      ],
      [
        -6,
        3
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -5
      ],
      [
        -3,
        -20
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        1
      ],
      [
        -4,
        14
      ],
      [
        -4,
        9
      ],
      [
        -5,
        2
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -3
      ]
    ],
    [
      [
        25823,
        61316
      ],
      [
        0,
        99
      ],
      [
        -31,
        1
      ],
      [
        1,
        69
      ],
      [
        -31,
        -4
      ]
    ],
    [
      [
        25762,
        61481
      ],
      [
        0,
        153
      ]
    ],
    [
      [
        25942,
        61661
      ],
      [
        5,
        1
      ],
      [
        6,
        -1
      ]
    ],
    [
      [
        25953,
        61661
      ],
      [
        0,
        -8
      ],
      [
        8,
        -9
      ],
      [
        13,
        1
      ],
      [
        31,
        0
      ],
      [
        13,
        -63
      ],
      [
        -1,
        -2
      ],
      [
        -9,
        -18
      ],
      [
        4,
        -15
      ],
      [
        -3,
        -7
      ],
      [
        1,
        -30
      ]
    ],
    [
      [
        26010,
        61510
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -10
      ],
      [
        0,
        -20
      ],
      [
        -1,
        -13
      ],
      [
        -2,
        -11
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -8
      ],
      [
        -5,
        -13
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -5
      ],
      [
        -4,
        -17
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -5
      ]
    ],
    [
      [
        25979,
        61384
      ],
      [
        0,
        7
      ],
      [
        -16,
        0
      ],
      [
        1,
        87
      ],
      [
        -5,
        0
      ],
      [
        0,
        17
      ],
      [
        -5,
        0
      ],
      [
        -1,
        22
      ],
      [
        0,
        8
      ],
      [
        -5,
        1
      ],
      [
        -1,
        33
      ],
      [
        -5,
        0
      ],
      [
        0,
        102
      ]
    ],
    [
      [
        27144,
        54294
      ],
      [
        7,
        -1
      ],
      [
        5,
        -16
      ],
      [
        1,
        -13
      ],
      [
        6,
        -6
      ],
      [
        3,
        -10
      ],
      [
        10,
        -48
      ],
      [
        3,
        -19
      ],
      [
        0,
        -24
      ],
      [
        4,
        1
      ],
      [
        4,
        -15
      ],
      [
        12,
        -1
      ],
      [
        3,
        12
      ],
      [
        8,
        -3
      ],
      [
        2,
        9
      ],
      [
        3,
        -28
      ],
      [
        11,
        -13
      ],
      [
        5,
        6
      ],
      [
        1,
        -8
      ],
      [
        7,
        -103
      ],
      [
        7,
        -22
      ],
      [
        2,
        -7
      ],
      [
        4,
        19
      ],
      [
        1,
        -20
      ],
      [
        3,
        -6
      ],
      [
        -1,
        -10
      ],
      [
        3,
        -22
      ],
      [
        9,
        5
      ],
      [
        3,
        -12
      ],
      [
        -1,
        -20
      ],
      [
        3,
        -16
      ],
      [
        11,
        -11
      ],
      [
        6,
        -21
      ]
    ],
    [
      [
        27289,
        53871
      ],
      [
        -1,
        -7
      ],
      [
        5,
        -21
      ],
      [
        7,
        -12
      ],
      [
        1,
        3
      ],
      [
        1,
        5
      ],
      [
        1,
        1
      ],
      [
        3,
        1
      ],
      [
        2,
        -5
      ],
      [
        -1,
        -14
      ],
      [
        -1,
        -10
      ],
      [
        2,
        -24
      ],
      [
        -1,
        -36
      ],
      [
        -4,
        -35
      ],
      [
        -3,
        -27
      ],
      [
        -4,
        -17
      ],
      [
        -1,
        0
      ],
      [
        -2,
        5
      ],
      [
        0,
        9
      ],
      [
        -3,
        0
      ]
    ],
    [
      [
        27290,
        53687
      ],
      [
        1,
        35
      ],
      [
        -1,
        12
      ],
      [
        -6,
        13
      ],
      [
        -1,
        13
      ],
      [
        -11,
        23
      ],
      [
        -12,
        1
      ],
      [
        -3,
        10
      ],
      [
        -7,
        -14
      ],
      [
        -7,
        8
      ],
      [
        -8,
        -13
      ],
      [
        -7,
        10
      ],
      [
        -4,
        -13
      ],
      [
        -6,
        22
      ],
      [
        -4,
        23
      ],
      [
        1,
        17
      ],
      [
        -8,
        6
      ]
    ],
    [
      [
        27207,
        53840
      ],
      [
        -2,
        1
      ],
      [
        -35,
        69
      ],
      [
        -4,
        7
      ],
      [
        -1,
        24
      ],
      [
        -5,
        17
      ],
      [
        -7,
        10
      ],
      [
        -13,
        52
      ],
      [
        -9,
        24
      ],
      [
        0,
        16
      ],
      [
        6,
        56
      ],
      [
        -1,
        38
      ],
      [
        -9,
        14
      ],
      [
        -4,
        -4
      ],
      [
        -8,
        43
      ]
    ],
    [
      [
        27115,
        54207
      ],
      [
        3,
        2
      ],
      [
        14,
        37
      ]
    ],
    [
      [
        18169,
        66721
      ],
      [
        0,
        -267
      ]
    ],
    [
      [
        18150,
        66443
      ],
      [
        -8,
        -2
      ],
      [
        -3,
        5
      ],
      [
        -7,
        -7
      ],
      [
        -8,
        -17
      ],
      [
        -5,
        -2
      ],
      [
        -5,
        -13
      ],
      [
        -5,
        3
      ],
      [
        -7,
        22
      ],
      [
        -2,
        18
      ],
      [
        -18,
        32
      ],
      [
        -12,
        3
      ],
      [
        -5,
        11
      ],
      [
        -7,
        1
      ],
      [
        -5,
        19
      ],
      [
        -7,
        11
      ],
      [
        -18,
        -3
      ],
      [
        -7,
        5
      ],
      [
        -21,
        39
      ],
      [
        -17,
        10
      ],
      [
        -4,
        9
      ]
    ],
    [
      [
        28776,
        61584
      ],
      [
        0,
        37
      ],
      [
        7,
        5
      ],
      [
        -4,
        15
      ],
      [
        2,
        25
      ],
      [
        7,
        16
      ],
      [
        -5,
        11
      ],
      [
        6,
        24
      ],
      [
        -2,
        21
      ],
      [
        2,
        5
      ],
      [
        2,
        2
      ],
      [
        4,
        3
      ],
      [
        10,
        24
      ],
      [
        1,
        19
      ],
      [
        3,
        10
      ],
      [
        5,
        4
      ],
      [
        7,
        22
      ]
    ],
    [
      [
        28821,
        61827
      ],
      [
        0,
        -45
      ],
      [
        1,
        -30
      ],
      [
        0,
        -4
      ],
      [
        1,
        -38
      ],
      [
        8,
        -1
      ],
      [
        5,
        -1
      ],
      [
        4,
        0
      ],
      [
        9,
        -2
      ],
      [
        4,
        0
      ],
      [
        3,
        -1
      ],
      [
        4,
        0
      ],
      [
        7,
        -1
      ],
      [
        4,
        0
      ],
      [
        5,
        -1
      ],
      [
        7,
        0
      ],
      [
        14,
        -2
      ],
      [
        24,
        0
      ]
    ],
    [
      [
        28921,
        61701
      ],
      [
        7,
        -56
      ],
      [
        -4,
        -27
      ],
      [
        7,
        -31
      ],
      [
        -5,
        -26
      ],
      [
        -9,
        -22
      ],
      [
        -5,
        -27
      ],
      [
        -23,
        -4
      ],
      [
        -44,
        -9
      ]
    ],
    [
      [
        28845,
        61499
      ],
      [
        -14,
        23
      ],
      [
        -9,
        -28
      ],
      [
        0,
        -4
      ],
      [
        1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -8,
        0
      ],
      [
        -1,
        6
      ],
      [
        1,
        3
      ],
      [
        0,
        2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        0,
        7
      ],
      [
        -1,
        0
      ],
      [
        -1,
        2
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        2
      ],
      [
        0,
        5
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        28807,
        61506
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        28807,
        61505
      ],
      [
        0,
        -4
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        1,
        2
      ]
    ],
    [
      [
        28807,
        61506
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -3,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -14
      ],
      [
        -7,
        -8
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -5
      ],
      [
        -11,
        -1
      ],
      [
        -7,
        -18
      ]
    ],
    [
      [
        28775,
        61452
      ],
      [
        -1,
        6
      ],
      [
        -2,
        1
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -10
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        1
      ],
      [
        -2,
        4
      ],
      [
        -2,
        17
      ],
      [
        0,
        6
      ],
      [
        -1,
        7
      ],
      [
        -1,
        6
      ],
      [
        2,
        11
      ],
      [
        2,
        15
      ],
      [
        -1,
        14
      ],
      [
        3,
        13
      ],
      [
        3,
        24
      ],
      [
        3,
        3
      ],
      [
        3,
        18
      ],
      [
        0,
        5
      ]
    ],
    [
      [
        25269,
        71580
      ],
      [
        -2,
        -18
      ],
      [
        -5,
        -44
      ],
      [
        -1,
        -41
      ],
      [
        -2,
        -22
      ],
      [
        1,
        -6
      ],
      [
        2,
        -23
      ],
      [
        3,
        -23
      ],
      [
        -5,
        -5
      ],
      [
        -4,
        -21
      ],
      [
        0,
        -9
      ],
      [
        5,
        -9
      ],
      [
        6,
        12
      ],
      [
        5,
        32
      ],
      [
        1,
        8
      ],
      [
        6,
        21
      ],
      [
        8,
        26
      ],
      [
        1,
        13
      ],
      [
        -6,
        3
      ],
      [
        4,
        22
      ],
      [
        4,
        6
      ],
      [
        1,
        -17
      ],
      [
        6,
        4
      ],
      [
        11,
        34
      ],
      [
        8,
        19
      ],
      [
        5,
        11
      ],
      [
        5,
        16
      ],
      [
        22,
        34
      ],
      [
        3,
        7
      ],
      [
        3,
        2
      ],
      [
        3,
        -5
      ],
      [
        -5,
        -22
      ],
      [
        -10,
        -28
      ],
      [
        -7,
        -12
      ],
      [
        -5,
        -12
      ],
      [
        -3,
        -16
      ],
      [
        -3,
        -16
      ],
      [
        -9,
        -45
      ],
      [
        0,
        -11
      ],
      [
        5,
        -1
      ],
      [
        4,
        25
      ],
      [
        3,
        19
      ],
      [
        8,
        28
      ],
      [
        10,
        24
      ],
      [
        4,
        0
      ],
      [
        10,
        6
      ],
      [
        7,
        9
      ],
      [
        5,
        3
      ],
      [
        5,
        -2
      ],
      [
        6,
        -7
      ]
    ],
    [
      [
        25382,
        71549
      ],
      [
        0,
        -171
      ],
      [
        15,
        0
      ],
      [
        0,
        -100
      ],
      [
        -35,
        -1
      ],
      [
        0,
        -301
      ]
    ],
    [
      [
        25362,
        70976
      ],
      [
        -157,
        0
      ]
    ],
    [
      [
        25205,
        70976
      ],
      [
        0,
        503
      ],
      [
        35,
        0
      ],
      [
        0,
        101
      ],
      [
        29,
        0
      ]
    ],
    [
      [
        17872,
        61963
      ],
      [
        265,
        0
      ]
    ],
    [
      [
        18137,
        61963
      ],
      [
        -1,
        -122
      ]
    ],
    [
      [
        18136,
        61841
      ],
      [
        1,
        -29
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -52
      ],
      [
        1,
        -110
      ],
      [
        -1,
        -1
      ],
      [
        1,
        -162
      ],
      [
        -1,
        -18
      ],
      [
        1,
        -117
      ]
    ],
    [
      [
        18137,
        61348
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -173
      ],
      [
        1,
        -138
      ],
      [
        0,
        -134
      ],
      [
        -1,
        -11
      ],
      [
        0,
        -177
      ]
    ],
    [
      [
        18136,
        60714
      ],
      [
        0,
        -703
      ]
    ],
    [
      [
        18136,
        59828
      ],
      [
        -32,
        0
      ],
      [
        -166,
        1
      ],
      [
        0,
        11
      ],
      [
        -273,
        -1
      ],
      [
        0,
        -13
      ],
      [
        -43,
        1
      ]
    ],
    [
      [
        17622,
        59827
      ],
      [
        1,
        22
      ],
      [
        0,
        1384
      ],
      [
        249,
        1
      ],
      [
        0,
        729
      ]
    ],
    [
      [
        28999,
        63001
      ],
      [
        21,
        -63
      ]
    ],
    [
      [
        29020,
        62938
      ],
      [
        36,
        -106
      ],
      [
        0,
        -4
      ],
      [
        1,
        -6
      ],
      [
        0,
        -37
      ],
      [
        -3,
        -52
      ],
      [
        1,
        -17
      ]
    ],
    [
      [
        29055,
        62716
      ],
      [
        -6,
        -18
      ],
      [
        -4,
        -86
      ],
      [
        -7,
        -12
      ],
      [
        -1,
        -18
      ],
      [
        3,
        -37
      ]
    ],
    [
      [
        29040,
        62545
      ],
      [
        -13,
        15
      ],
      [
        -4,
        2
      ],
      [
        -6,
        -1
      ],
      [
        -8,
        3
      ],
      [
        1,
        13
      ],
      [
        -1,
        10
      ],
      [
        -3,
        10
      ],
      [
        -3,
        -8
      ],
      [
        -12,
        -5
      ],
      [
        -6,
        2
      ],
      [
        -3,
        -15
      ],
      [
        -1,
        -12
      ],
      [
        -3,
        -9
      ],
      [
        -4,
        10
      ],
      [
        -5,
        14
      ],
      [
        1,
        11
      ],
      [
        0,
        13
      ],
      [
        -3,
        23
      ],
      [
        -4,
        4
      ],
      [
        -4,
        19
      ],
      [
        -2,
        0
      ],
      [
        -8,
        14
      ],
      [
        -1,
        4
      ],
      [
        0,
        9
      ],
      [
        -2,
        17
      ],
      [
        -6,
        4
      ],
      [
        -3,
        -5
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -3
      ],
      [
        -5,
        14
      ],
      [
        -3,
        10
      ],
      [
        -3,
        26
      ],
      [
        0,
        7
      ],
      [
        -2,
        8
      ],
      [
        -2,
        3
      ],
      [
        -4,
        -1
      ],
      [
        -3,
        -7
      ],
      [
        -7,
        20
      ],
      [
        -1,
        6
      ],
      [
        0,
        9
      ],
      [
        -1,
        9
      ],
      [
        -2,
        3
      ]
    ],
    [
      [
        28903,
        62783
      ],
      [
        -4,
        33
      ],
      [
        3,
        16
      ],
      [
        -1,
        34
      ],
      [
        4,
        11
      ],
      [
        9,
        -7
      ],
      [
        7,
        40
      ],
      [
        7,
        1
      ],
      [
        13,
        46
      ],
      [
        9,
        32
      ],
      [
        17,
        -44
      ],
      [
        26,
        -74
      ],
      [
        1,
        4
      ],
      [
        2,
        29
      ],
      [
        -2,
        18
      ],
      [
        1,
        50
      ],
      [
        4,
        29
      ]
    ],
    [
      [
        26192,
        62257
      ],
      [
        1,
        21
      ]
    ],
    [
      [
        26193,
        62278
      ],
      [
        5,
        10
      ],
      [
        -1,
        -23
      ],
      [
        6,
        -2
      ],
      [
        4,
        20
      ],
      [
        7,
        -4
      ],
      [
        0,
        11
      ],
      [
        5,
        21
      ],
      [
        4,
        -2
      ],
      [
        2,
        9
      ],
      [
        4,
        -8
      ],
      [
        2,
        25
      ],
      [
        7,
        -5
      ],
      [
        5,
        3
      ],
      [
        2,
        13
      ],
      [
        4,
        0
      ],
      [
        6,
        15
      ],
      [
        3,
        -7
      ],
      [
        6,
        20
      ]
    ],
    [
      [
        26264,
        62374
      ],
      [
        2,
        -6
      ],
      [
        2,
        -7
      ],
      [
        2,
        -9
      ],
      [
        2,
        -10
      ],
      [
        0,
        -2
      ],
      [
        1,
        -5
      ],
      [
        2,
        -7
      ],
      [
        0,
        -3
      ],
      [
        1,
        -8
      ],
      [
        1,
        -8
      ],
      [
        0,
        -15
      ],
      [
        -1,
        -4
      ],
      [
        -8,
        -27
      ],
      [
        -2,
        -7
      ],
      [
        -2,
        -10
      ],
      [
        0,
        -13
      ],
      [
        2,
        -10
      ]
    ],
    [
      [
        26266,
        62223
      ],
      [
        -75,
        3
      ],
      [
        1,
        31
      ]
    ],
    [
      [
        29282,
        64306
      ],
      [
        1,
        12
      ],
      [
        5,
        10
      ],
      [
        1,
        19
      ],
      [
        0,
        9
      ],
      [
        1,
        13
      ],
      [
        1,
        14
      ],
      [
        1,
        7
      ],
      [
        0,
        3
      ],
      [
        2,
        10
      ],
      [
        0,
        1
      ],
      [
        2,
        12
      ],
      [
        2,
        10
      ],
      [
        1,
        5
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        29299,
        64433
      ],
      [
        4,
        20
      ],
      [
        0,
        2
      ],
      [
        1,
        3
      ],
      [
        1,
        7
      ],
      [
        3,
        25
      ],
      [
        1,
        12
      ],
      [
        3,
        19
      ],
      [
        1,
        8
      ]
    ],
    [
      [
        29313,
        64529
      ],
      [
        5,
        -7
      ],
      [
        2,
        4
      ],
      [
        0,
        -2
      ],
      [
        1,
        -5
      ],
      [
        -1,
        -8
      ],
      [
        -3,
        -10
      ],
      [
        0,
        -3
      ],
      [
        -2,
        -10
      ],
      [
        -2,
        -13
      ],
      [
        0,
        -8
      ],
      [
        1,
        -10
      ],
      [
        -1,
        -10
      ],
      [
        1,
        -4
      ],
      [
        1,
        -5
      ],
      [
        4,
        -8
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        29319,
        64429
      ],
      [
        -1,
        -14
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -6
      ],
      [
        -2,
        1
      ],
      [
        0,
        -8
      ],
      [
        -7,
        -31
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -7
      ]
    ],
    [
      [
        29305,
        64360
      ],
      [
        0,
        -16
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -10
      ],
      [
        -2,
        -4
      ],
      [
        -4,
        -1
      ],
      [
        -2,
        -17
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -2
      ]
    ],
    [
      [
        29289,
        64295
      ],
      [
        -1,
        4
      ],
      [
        -6,
        5
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        29092,
        69317
      ],
      [
        2,
        -49
      ],
      [
        22,
        0
      ],
      [
        5,
        -160
      ],
      [
        27,
        -750
      ],
      [
        -5,
        -2
      ],
      [
        3,
        -82
      ]
    ],
    [
      [
        29146,
        68274
      ],
      [
        -32,
        -12
      ],
      [
        -33,
        -13
      ],
      [
        -24,
        -9
      ]
    ],
    [
      [
        28969,
        68272
      ],
      [
        -26,
        45
      ],
      [
        -42,
        79
      ],
      [
        -9,
        16
      ]
    ],
    [
      [
        28892,
        68412
      ],
      [
        -18,
        34
      ],
      [
        -98,
        182
      ]
    ],
    [
      [
        28776,
        68628
      ],
      [
        11,
        34
      ],
      [
        4,
        46
      ],
      [
        12,
        51
      ],
      [
        11,
        32
      ],
      [
        8,
        29
      ],
      [
        10,
        28
      ],
      [
        12,
        32
      ],
      [
        10,
        34
      ],
      [
        21,
        66
      ],
      [
        8,
        17
      ],
      [
        15,
        42
      ],
      [
        3,
        15
      ],
      [
        4,
        5
      ],
      [
        3,
        8
      ],
      [
        4,
        3
      ],
      [
        2,
        8
      ],
      [
        6,
        19
      ],
      [
        3,
        1
      ],
      [
        8,
        23
      ],
      [
        -1,
        12
      ],
      [
        7,
        14
      ],
      [
        4,
        7
      ],
      [
        4,
        3
      ],
      [
        4,
        11
      ],
      [
        3,
        1
      ],
      [
        3,
        9
      ],
      [
        5,
        2
      ],
      [
        1,
        5
      ],
      [
        3,
        2
      ],
      [
        6,
        12
      ],
      [
        6,
        8
      ],
      [
        3,
        13
      ],
      [
        4,
        7
      ],
      [
        4,
        4
      ],
      [
        2,
        7
      ],
      [
        9,
        4
      ],
      [
        1,
        5
      ],
      [
        10,
        14
      ],
      [
        6,
        14
      ],
      [
        1,
        8
      ],
      [
        0,
        7
      ],
      [
        2,
        7
      ],
      [
        6,
        7
      ],
      [
        7,
        1
      ],
      [
        2,
        0
      ],
      [
        9,
        -1
      ],
      [
        2,
        11
      ],
      [
        3,
        8
      ],
      [
        3,
        2
      ],
      [
        3,
        -1
      ],
      [
        2,
        2
      ],
      [
        2,
        3
      ],
      [
        2,
        6
      ],
      [
        3,
        5
      ],
      [
        2,
        1
      ],
      [
        2,
        -3
      ],
      [
        2,
        1
      ],
      [
        2,
        -3
      ],
      [
        2,
        -2
      ],
      [
        2,
        -6
      ],
      [
        7,
        -1
      ],
      [
        2,
        -10
      ],
      [
        4,
        -5
      ],
      [
        4,
        0
      ],
      [
        1,
        5
      ]
    ],
    [
      [
        24489,
        54039
      ],
      [
        66,
        -10
      ],
      [
        25,
        -22
      ],
      [
        22,
        -19
      ],
      [
        1,
        -26
      ],
      [
        -4,
        -22
      ],
      [
        33,
        1
      ]
    ],
    [
      [
        24632,
        53941
      ],
      [
        0,
        -102
      ]
    ],
    [
      [
        24632,
        53737
      ],
      [
        -4,
        1
      ],
      [
        -15,
        -1
      ],
      [
        -68,
        0
      ],
      [
        -22,
        -1
      ],
      [
        -7,
        0
      ]
    ],
    [
      [
        24516,
        53736
      ],
      [
        0,
        24
      ],
      [
        -23,
        -2
      ],
      [
        -2,
        10
      ],
      [
        -8,
        12
      ],
      [
        1,
        19
      ],
      [
        -9,
        10
      ],
      [
        2,
        22
      ],
      [
        -4,
        23
      ],
      [
        -3,
        40
      ]
    ],
    [
      [
        24470,
        53894
      ],
      [
        12,
        0
      ],
      [
        3,
        10
      ],
      [
        1,
        8
      ],
      [
        -1,
        7
      ],
      [
        -3,
        5
      ],
      [
        -3,
        1
      ],
      [
        -5,
        -6
      ],
      [
        -4,
        0
      ],
      [
        -1,
        1
      ],
      [
        -8,
        -2
      ],
      [
        -4,
        5
      ],
      [
        0,
        11
      ],
      [
        1,
        23
      ],
      [
        4,
        50
      ],
      [
        1,
        5
      ],
      [
        1,
        5
      ],
      [
        1,
        2
      ],
      [
        2,
        2
      ],
      [
        9,
        7
      ],
      [
        1,
        -1
      ],
      [
        1,
        -15
      ],
      [
        0,
        -27
      ],
      [
        1,
        -6
      ],
      [
        1,
        -5
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        2,
        -3
      ],
      [
        2,
        0
      ],
      [
        2,
        4
      ],
      [
        2,
        6
      ],
      [
        0,
        5
      ],
      [
        1,
        11
      ],
      [
        0,
        2
      ],
      [
        -4,
        15
      ],
      [
        -2,
        6
      ],
      [
        0,
        5
      ],
      [
        -1,
        4
      ],
      [
        1,
        4
      ],
      [
        0,
        2
      ],
      [
        1,
        2
      ],
      [
        4,
        5
      ]
    ],
    [
      [
        23168,
        56701
      ],
      [
        59,
        0
      ]
    ],
    [
      [
        23400,
        56701
      ],
      [
        1,
        -256
      ]
    ],
    [
      [
        23401,
        56445
      ],
      [
        -2,
        1
      ],
      [
        -2,
        4
      ],
      [
        -4,
        10
      ],
      [
        -10,
        14
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -6,
        -32
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -2
      ],
      [
        1,
        -4
      ],
      [
        0,
        -13
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -3
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        3
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -19
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        0
      ],
      [
        -4,
        6
      ]
    ],
    [
      [
        23358,
        56379
      ],
      [
        -5,
        6
      ],
      [
        -2,
        1
      ],
      [
        0,
        -11
      ],
      [
        -2,
        -9
      ],
      [
        -3,
        -2
      ],
      [
        -7,
        1
      ],
      [
        -9,
        -2
      ],
      [
        -11,
        3
      ],
      [
        -4,
        4
      ],
      [
        0,
        15
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -8
      ],
      [
        -4,
        -5
      ],
      [
        -3,
        -1
      ],
      [
        -1,
        2
      ],
      [
        0,
        12
      ],
      [
        -1,
        4
      ],
      [
        -2,
        2
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        -3,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        1
      ],
      [
        -1,
        3
      ],
      [
        -1,
        6
      ],
      [
        0,
        7
      ],
      [
        1,
        8
      ],
      [
        0,
        8
      ],
      [
        -1,
        8
      ],
      [
        -1,
        14
      ],
      [
        -1,
        4
      ],
      [
        0,
        2
      ],
      [
        -1,
        0
      ],
      [
        -6,
        3
      ],
      [
        -4,
        0
      ],
      [
        -1,
        -9
      ],
      [
        -9,
        -23
      ],
      [
        -3,
        -1
      ],
      [
        -4,
        3
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -10
      ],
      [
        -2,
        -9
      ],
      [
        -3,
        -5
      ],
      [
        -4,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -4,
        10
      ],
      [
        -2,
        2
      ],
      [
        -3,
        0
      ],
      [
        -3,
        -4
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -13
      ]
    ],
    [
      [
        23232,
        56370
      ],
      [
        -12,
        -3
      ],
      [
        -10,
        5
      ],
      [
        -6,
        15
      ],
      [
        -2,
        22
      ],
      [
        -3,
        11
      ],
      [
        -11,
        11
      ],
      [
        -5,
        19
      ],
      [
        0,
        214
      ],
      [
        -4,
        5
      ],
      [
        -1,
        22
      ],
      [
        -10,
        10
      ]
    ],
    [
      [
        24457,
        63222
      ],
      [
        125,
        -2
      ],
      [
        0,
        102
      ]
    ],
    [
      [
        24582,
        63322
      ],
      [
        6,
        -5
      ],
      [
        90,
        -1
      ]
    ],
    [
      [
        24678,
        63316
      ],
      [
        1,
        -11
      ],
      [
        -9,
        -47
      ]
    ],
    [
      [
        24675,
        62946
      ],
      [
        -3,
        -41
      ],
      [
        -5,
        -34
      ],
      [
        -2,
        -39
      ],
      [
        1,
        -33
      ]
    ],
    [
      [
        24666,
        62799
      ],
      [
        -82,
        5
      ],
      [
        -8,
        0
      ]
    ],
    [
      [
        24576,
        62804
      ],
      [
        0,
        1
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        -2,
        4
      ],
      [
        -3,
        2
      ],
      [
        -3,
        3
      ],
      [
        -1,
        3
      ],
      [
        -1,
        4
      ],
      [
        -2,
        3
      ],
      [
        -3,
        3
      ],
      [
        -3,
        5
      ],
      [
        -2,
        6
      ],
      [
        -3,
        7
      ],
      [
        -4,
        12
      ],
      [
        -4,
        16
      ],
      [
        -2,
        7
      ],
      [
        -1,
        6
      ],
      [
        -1,
        24
      ],
      [
        -3,
        10
      ],
      [
        -1,
        6
      ],
      [
        -2,
        11
      ],
      [
        -1,
        14
      ],
      [
        -3,
        11
      ],
      [
        -3,
        2
      ],
      [
        -4,
        2
      ],
      [
        -6,
        4
      ],
      [
        -1,
        3
      ],
      [
        -2,
        5
      ],
      [
        -1,
        7
      ],
      [
        -2,
        7
      ],
      [
        0,
        20
      ],
      [
        -1,
        12
      ],
      [
        0,
        1
      ],
      [
        -1,
        6
      ]
    ],
    [
      [
        24509,
        63035
      ],
      [
        -1,
        5
      ],
      [
        -1,
        3
      ],
      [
        -9,
        12
      ],
      [
        -2,
        2
      ],
      [
        -1,
        4
      ],
      [
        -4,
        11
      ],
      [
        0,
        3
      ],
      [
        -1,
        5
      ],
      [
        -1,
        5
      ],
      [
        -3,
        9
      ],
      [
        -2,
        9
      ],
      [
        -3,
        11
      ],
      [
        -2,
        5
      ],
      [
        -2,
        5
      ],
      [
        -3,
        6
      ],
      [
        -1,
        5
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        24455,
        64753
      ],
      [
        118,
        -2
      ]
    ],
    [
      [
        24573,
        64751
      ],
      [
        0,
        -3
      ]
    ],
    [
      [
        24573,
        64748
      ],
      [
        1,
        -9
      ],
      [
        0,
        -58
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -13
      ],
      [
        -1,
        -10
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -3
      ],
      [
        1,
        -8
      ],
      [
        1,
        -9
      ],
      [
        0,
        -10
      ],
      [
        -3,
        -20
      ],
      [
        0,
        -14
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        -5
      ],
      [
        -2,
        -4
      ],
      [
        -3,
        -4
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -3,
        -14
      ],
      [
        -1,
        -6
      ],
      [
        -3,
        -5
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -12
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -5
      ],
      [
        -3,
        -10
      ],
      [
        -4,
        -10
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -11
      ],
      [
        0,
        -10
      ],
      [
        2,
        -11
      ],
      [
        0,
        -16
      ],
      [
        -1,
        -14
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -7
      ],
      [
        -2,
        -7
      ],
      [
        0,
        -7
      ],
      [
        -2,
        -23
      ],
      [
        0,
        -4
      ],
      [
        1,
        -3
      ],
      [
        0,
        -13
      ],
      [
        1,
        -6
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        24527,
        64313
      ],
      [
        -7,
        5
      ],
      [
        -2,
        5
      ],
      [
        -9,
        19
      ],
      [
        -1,
        -15
      ],
      [
        -8,
        7
      ],
      [
        -2,
        21
      ],
      [
        -11,
        23
      ],
      [
        -7,
        1
      ],
      [
        -3,
        23
      ],
      [
        -20,
        21
      ],
      [
        -13,
        26
      ]
    ],
    [
      [
        20434,
        73471
      ],
      [
        231,
        0
      ]
    ],
    [
      [
        20665,
        73471
      ],
      [
        60,
        0
      ],
      [
        0,
        -101
      ],
      [
        37,
        0
      ],
      [
        0,
        -102
      ],
      [
        161,
        0
      ]
    ],
    [
      [
        20923,
        73268
      ],
      [
        1,
        -17
      ],
      [
        0,
        -440
      ]
    ],
    [
      [
        20604,
        72893
      ],
      [
        -7,
        -4
      ],
      [
        0,
        21
      ],
      [
        -3,
        9
      ],
      [
        -9,
        0
      ],
      [
        -16,
        -12
      ],
      [
        -3,
        16
      ],
      [
        -10,
        -5
      ],
      [
        -5,
        5
      ],
      [
        -19,
        -4
      ],
      [
        -9,
        2
      ],
      [
        -5,
        8
      ],
      [
        -5,
        -11
      ],
      [
        -3,
        -24
      ],
      [
        -10,
        18
      ],
      [
        -8,
        -2
      ],
      [
        -6,
        -10
      ],
      [
        -9,
        5
      ],
      [
        3,
        -13
      ],
      [
        -1,
        -17
      ],
      [
        -5,
        -7
      ],
      [
        -2,
        14
      ],
      [
        -8,
        -5
      ],
      [
        -7,
        -25
      ],
      [
        -8,
        -7
      ],
      [
        -4,
        6
      ],
      [
        -4,
        19
      ],
      [
        -2,
        -29
      ],
      [
        -6,
        3
      ],
      [
        -10,
        -17
      ]
    ],
    [
      [
        20423,
        72827
      ],
      [
        0,
        243
      ],
      [
        11,
        0
      ],
      [
        0,
        401
      ]
    ],
    [
      [
        26789,
        57076
      ],
      [
        39,
        151
      ]
    ],
    [
      [
        26828,
        57227
      ],
      [
        2,
        12
      ]
    ],
    [
      [
        26830,
        57239
      ],
      [
        2,
        5
      ]
    ],
    [
      [
        26832,
        57244
      ],
      [
        2,
        8
      ],
      [
        12,
        49
      ],
      [
        32,
        64
      ],
      [
        11,
        23
      ],
      [
        30,
        61
      ],
      [
        11,
        23
      ]
    ],
    [
      [
        26978,
        57082
      ],
      [
        -17,
        -48
      ],
      [
        -3,
        -8
      ],
      [
        -1,
        -4
      ],
      [
        -82,
        -218
      ],
      [
        -16,
        -43
      ]
    ],
    [
      [
        26859,
        56761
      ],
      [
        0,
        6
      ],
      [
        1,
        5
      ],
      [
        0,
        2
      ],
      [
        -2,
        6
      ],
      [
        1,
        3
      ],
      [
        0,
        3
      ],
      [
        -1,
        15
      ],
      [
        0,
        2
      ],
      [
        1,
        9
      ],
      [
        -2,
        13
      ],
      [
        0,
        1
      ],
      [
        1,
        2
      ],
      [
        -1,
        6
      ],
      [
        -1,
        6
      ],
      [
        -2,
        6
      ],
      [
        -1,
        1
      ],
      [
        0,
        -1
      ],
      [
        -2,
        4
      ],
      [
        -1,
        4
      ]
    ],
    [
      [
        26850,
        56854
      ],
      [
        -2,
        10
      ],
      [
        0,
        7
      ],
      [
        -1,
        9
      ],
      [
        -2,
        15
      ],
      [
        0,
        19
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        -3,
        10
      ],
      [
        -1,
        4
      ],
      [
        -3,
        6
      ],
      [
        -2,
        6
      ],
      [
        -1,
        2
      ],
      [
        0,
        20
      ],
      [
        -2,
        8
      ],
      [
        0,
        12
      ],
      [
        -1,
        12
      ],
      [
        0,
        12
      ],
      [
        -1,
        4
      ],
      [
        0,
        3
      ],
      [
        -1,
        6
      ],
      [
        -1,
        14
      ],
      [
        -1,
        7
      ],
      [
        0,
        10
      ],
      [
        -1,
        2
      ],
      [
        -3,
        4
      ],
      [
        0,
        14
      ],
      [
        -2,
        4
      ],
      [
        -6,
        8
      ],
      [
        -1,
        -1
      ],
      [
        -4,
        -4
      ],
      [
        -1,
        0
      ],
      [
        -1,
        3
      ],
      [
        -3,
        2
      ],
      [
        -2,
        -7
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        5
      ],
      [
        -5,
        1
      ],
      [
        -4,
        -4
      ]
    ],
    [
      [
        20921,
        67988
      ],
      [
        190,
        4
      ],
      [
        191,
        -1
      ],
      [
        -4,
        -51
      ],
      [
        2,
        -16
      ],
      [
        -12,
        -33
      ],
      [
        -11,
        -56
      ],
      [
        -4,
        0
      ],
      [
        -2,
        -26
      ],
      [
        -5,
        -11
      ],
      [
        2,
        -3
      ]
    ],
    [
      [
        21268,
        67795
      ],
      [
        -1,
        -23
      ],
      [
        -5,
        -12
      ],
      [
        -4,
        9
      ],
      [
        -4,
        -7
      ],
      [
        -3,
        9
      ],
      [
        -9,
        9
      ],
      [
        -4,
        -15
      ],
      [
        -1,
        -25
      ],
      [
        -3,
        -25
      ],
      [
        -7,
        -6
      ],
      [
        -5,
        6
      ],
      [
        -7,
        -15
      ],
      [
        0,
        -150
      ]
    ],
    [
      [
        20921,
        67551
      ],
      [
        0,
        30
      ]
    ],
    [
      [
        20921,
        67581
      ],
      [
        0,
        407
      ]
    ],
    [
      [
        24816,
        58129
      ],
      [
        2,
        2
      ],
      [
        2,
        1
      ],
      [
        2,
        3
      ],
      [
        -1,
        17
      ]
    ],
    [
      [
        24823,
        58157
      ],
      [
        2,
        -13
      ],
      [
        43,
        -7
      ],
      [
        1,
        1
      ],
      [
        5,
        -1
      ],
      [
        19,
        1
      ],
      [
        6,
        -4
      ],
      [
        0,
        20
      ],
      [
        13,
        -5
      ],
      [
        8,
        9
      ],
      [
        0,
        -23
      ],
      [
        17,
        -3
      ],
      [
        -1,
        -18
      ],
      [
        3,
        6
      ]
    ],
    [
      [
        24939,
        58120
      ],
      [
        -1,
        -115
      ],
      [
        0,
        -92
      ],
      [
        -2,
        -236
      ]
    ],
    [
      [
        24936,
        57677
      ],
      [
        -22,
        0
      ]
    ],
    [
      [
        24914,
        57677
      ],
      [
        -5,
        0
      ],
      [
        -5,
        -1
      ],
      [
        -84,
        0
      ],
      [
        -10,
        1
      ],
      [
        -59,
        0
      ]
    ],
    [
      [
        24751,
        57677
      ],
      [
        0,
        17
      ],
      [
        1,
        9
      ],
      [
        1,
        13
      ],
      [
        1,
        10
      ],
      [
        1,
        3
      ],
      [
        0,
        1
      ],
      [
        1,
        1
      ],
      [
        7,
        -2
      ],
      [
        1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        2,
        -3
      ],
      [
        7,
        -3
      ],
      [
        1,
        -2
      ],
      [
        3,
        -4
      ],
      [
        0,
        -1
      ],
      [
        2,
        1
      ],
      [
        2,
        8
      ],
      [
        1,
        5
      ],
      [
        0,
        22
      ],
      [
        1,
        6
      ],
      [
        3,
        35
      ],
      [
        2,
        24
      ],
      [
        1,
        7
      ],
      [
        2,
        8
      ],
      [
        1,
        4
      ],
      [
        2,
        3
      ],
      [
        3,
        4
      ],
      [
        0,
        1
      ],
      [
        1,
        -2
      ],
      [
        9,
        -17
      ],
      [
        2,
        -3
      ],
      [
        3,
        2
      ],
      [
        1,
        2
      ],
      [
        1,
        2
      ],
      [
        3,
        11
      ],
      [
        1,
        6
      ],
      [
        1,
        2
      ],
      [
        0,
        3
      ],
      [
        -1,
        12
      ],
      [
        0,
        3
      ],
      [
        -6,
        3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        5
      ],
      [
        -1,
        4
      ],
      [
        -1,
        4
      ],
      [
        0,
        3
      ],
      [
        -1,
        5
      ],
      [
        0,
        4
      ],
      [
        -1,
        0
      ],
      [
        -1,
        4
      ],
      [
        -1,
        7
      ],
      [
        0,
        3
      ],
      [
        1,
        9
      ],
      [
        2,
        1
      ],
      [
        3,
        -5
      ],
      [
        1,
        10
      ],
      [
        1,
        11
      ],
      [
        2,
        -3
      ],
      [
        0,
        -2
      ],
      [
        2,
        0
      ],
      [
        0,
        19
      ],
      [
        -1,
        3
      ],
      [
        -1,
        5
      ],
      [
        -1,
        5
      ],
      [
        -1,
        7
      ],
      [
        -2,
        9
      ],
      [
        -1,
        2
      ],
      [
        -1,
        3
      ],
      [
        -2,
        2
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -1
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        -1
      ],
      [
        -3,
        4
      ],
      [
        -2,
        8
      ],
      [
        -2,
        14
      ],
      [
        -1,
        5
      ],
      [
        0,
        4
      ],
      [
        1,
        13
      ],
      [
        0,
        3
      ],
      [
        1,
        3
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        1,
        0
      ],
      [
        3,
        -5
      ],
      [
        2,
        2
      ],
      [
        3,
        5
      ],
      [
        1,
        -2
      ],
      [
        3,
        2
      ],
      [
        0,
        23
      ],
      [
        1,
        9
      ],
      [
        -2,
        12
      ],
      [
        1,
        0
      ],
      [
        0,
        1
      ],
      [
        2,
        10
      ],
      [
        1,
        6
      ],
      [
        1,
        4
      ],
      [
        1,
        0
      ],
      [
        1,
        3
      ],
      [
        1,
        7
      ],
      [
        2,
        17
      ]
    ],
    [
      [
        28963,
        64191
      ],
      [
        3,
        3
      ],
      [
        9,
        40
      ],
      [
        11,
        13
      ],
      [
        9,
        28
      ],
      [
        16,
        36
      ],
      [
        10,
        13
      ],
      [
        4,
        6
      ],
      [
        11,
        51
      ],
      [
        11,
        39
      ]
    ],
    [
      [
        29047,
        64420
      ],
      [
        18,
        -53
      ],
      [
        7,
        0
      ],
      [
        21,
        -27
      ]
    ],
    [
      [
        29093,
        64340
      ],
      [
        2,
        -22
      ],
      [
        -4,
        -40
      ],
      [
        2,
        -22
      ],
      [
        -1,
        -17
      ],
      [
        7,
        -13
      ],
      [
        -5,
        -24
      ],
      [
        2,
        -20
      ],
      [
        -8,
        -35
      ],
      [
        -9,
        -58
      ],
      [
        -7,
        14
      ],
      [
        5,
        -33
      ],
      [
        9,
        -74
      ]
    ],
    [
      [
        29086,
        63996
      ],
      [
        -17,
        -8
      ],
      [
        2,
        -37
      ],
      [
        -19,
        -9
      ],
      [
        4,
        -36
      ],
      [
        -21,
        -8
      ],
      [
        -3,
        2
      ]
    ],
    [
      [
        29032,
        63900
      ],
      [
        0,
        1
      ],
      [
        -1,
        6
      ],
      [
        0,
        12
      ],
      [
        -1,
        8
      ],
      [
        -1,
        13
      ],
      [
        0,
        1
      ],
      [
        -3,
        22
      ],
      [
        0,
        2
      ],
      [
        -1,
        3
      ],
      [
        -4,
        5
      ],
      [
        -1,
        2
      ],
      [
        -1,
        3
      ],
      [
        -2,
        3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        -4,
        -3
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        1
      ],
      [
        -2,
        3
      ],
      [
        -1,
        4
      ],
      [
        -1,
        0
      ],
      [
        0,
        3
      ],
      [
        -1,
        1
      ],
      [
        -3,
        3
      ],
      [
        0,
        2
      ],
      [
        -1,
        4
      ],
      [
        0,
        14
      ],
      [
        -2,
        18
      ],
      [
        -1,
        7
      ],
      [
        0,
        2
      ],
      [
        1,
        10
      ],
      [
        0,
        9
      ],
      [
        1,
        5
      ],
      [
        1,
        5
      ],
      [
        0,
        12
      ],
      [
        -1,
        15
      ],
      [
        0,
        37
      ],
      [
        -1,
        4
      ],
      [
        0,
        3
      ],
      [
        -3,
        7
      ],
      [
        -5,
        19
      ],
      [
        -1,
        4
      ],
      [
        -3,
        3
      ],
      [
        -2,
        3
      ],
      [
        -5,
        3
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        -9
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        0
      ],
      [
        -2,
        1
      ],
      [
        -2,
        3
      ],
      [
        -1,
        2
      ],
      [
        -1,
        6
      ],
      [
        -1,
        2
      ],
      [
        0,
        7
      ],
      [
        1,
        6
      ],
      [
        0,
        5
      ]
    ],
    [
      [
        27612,
        59771
      ],
      [
        6,
        -15
      ],
      [
        2,
        10
      ],
      [
        3,
        47
      ],
      [
        19,
        -15
      ],
      [
        36,
        -30
      ],
      [
        4,
        10
      ],
      [
        8,
        -14
      ],
      [
        5,
        22
      ],
      [
        14,
        25
      ],
      [
        6,
        -1
      ],
      [
        8,
        33
      ]
    ],
    [
      [
        27723,
        59843
      ],
      [
        -11,
        -199
      ],
      [
        -2,
        -41
      ],
      [
        -1,
        -5
      ],
      [
        -6,
        -121
      ]
    ],
    [
      [
        27608,
        59478
      ],
      [
        1,
        78
      ],
      [
        -3,
        27
      ],
      [
        1,
        28
      ],
      [
        -5,
        28
      ],
      [
        -2,
        26
      ],
      [
        -3,
        25
      ],
      [
        2,
        18
      ],
      [
        -1,
        10
      ],
      [
        -1,
        36
      ],
      [
        5,
        13
      ],
      [
        10,
        4
      ]
    ],
    [
      [
        28627,
        60135
      ],
      [
        4,
        6
      ],
      [
        9,
        -6
      ],
      [
        1,
        -12
      ],
      [
        10,
        6
      ],
      [
        2,
        2
      ],
      [
        4,
        16
      ]
    ],
    [
      [
        28657,
        60147
      ],
      [
        4,
        -27
      ],
      [
        1,
        -11
      ],
      [
        -3,
        -25
      ],
      [
        -2,
        -26
      ],
      [
        -1,
        -7
      ],
      [
        -2,
        -30
      ],
      [
        -1,
        -9
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        1
      ],
      [
        0,
        9
      ],
      [
        -1,
        6
      ],
      [
        -3,
        0
      ],
      [
        -3,
        1
      ],
      [
        -2,
        -10
      ],
      [
        -3,
        -4
      ],
      [
        -5,
        -5
      ],
      [
        -2,
        -6
      ],
      [
        -2,
        -5
      ]
    ],
    [
      [
        28629,
        59998
      ],
      [
        -3,
        3
      ],
      [
        -7,
        38
      ],
      [
        -5,
        -7
      ],
      [
        1,
        3
      ],
      [
        -3,
        19
      ],
      [
        0,
        17
      ],
      [
        1,
        3
      ],
      [
        -1,
        3
      ],
      [
        0,
        26
      ],
      [
        4,
        12
      ],
      [
        0,
        6
      ]
    ],
    [
      [
        19756,
        73979
      ],
      [
        148,
        0
      ],
      [
        74,
        -1
      ],
      [
        21,
        1
      ],
      [
        52,
        0
      ]
    ],
    [
      [
        20051,
        73979
      ],
      [
        0,
        -101
      ],
      [
        -8,
        0
      ],
      [
        0,
        -401
      ],
      [
        4,
        -1
      ],
      [
        0,
        -68
      ],
      [
        -9,
        0
      ],
      [
        -7,
        9
      ],
      [
        -2,
        -42
      ],
      [
        -12,
        0
      ],
      [
        0,
        -101
      ],
      [
        11,
        0
      ],
      [
        0,
        -104
      ],
      [
        -30,
        0
      ],
      [
        0,
        -101
      ],
      [
        -10,
        0
      ],
      [
        0,
        -405
      ],
      [
        -3,
        0
      ],
      [
        0,
        -208
      ]
    ],
    [
      [
        19735,
        72330
      ],
      [
        -6,
        -3
      ],
      [
        0,
        -15
      ],
      [
        -5,
        0
      ],
      [
        -1,
        14
      ],
      [
        -6,
        -3
      ],
      [
        -3,
        17
      ],
      [
        -5,
        4
      ],
      [
        -2,
        -12
      ],
      [
        -4,
        4
      ],
      [
        1,
        18
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        16
      ],
      [
        -4,
        1
      ],
      [
        -5,
        -20
      ],
      [
        -10,
        3
      ],
      [
        1,
        9
      ],
      [
        -5,
        14
      ],
      [
        -4,
        -8
      ],
      [
        -9,
        -5
      ],
      [
        -11,
        17
      ],
      [
        -6,
        -6
      ],
      [
        -11,
        0
      ],
      [
        -5,
        14
      ],
      [
        -6,
        2
      ],
      [
        -5,
        20
      ],
      [
        -7,
        -7
      ],
      [
        -5,
        2
      ],
      [
        -5,
        20
      ],
      [
        2,
        22
      ],
      [
        -11,
        33
      ],
      [
        -19,
        28
      ]
    ],
    [
      [
        19574,
        72506
      ],
      [
        0,
        159
      ],
      [
        1,
        60
      ],
      [
        60,
        1
      ],
      [
        13,
        -4
      ],
      [
        0,
        43
      ],
      [
        5,
        40
      ],
      [
        2,
        1
      ],
      [
        8,
        -13
      ],
      [
        38,
        -5
      ],
      [
        0,
        283
      ],
      [
        7,
        0
      ],
      [
        0,
        266
      ],
      [
        1,
        -9
      ],
      [
        13,
        -3
      ],
      [
        4,
        -18
      ],
      [
        0,
        170
      ],
      [
        7,
        0
      ],
      [
        0,
        202
      ],
      [
        17,
        0
      ],
      [
        0,
        200
      ],
      [
        6,
        0
      ],
      [
        0,
        100
      ]
    ],
    [
      [
        26833,
        53976
      ],
      [
        6,
        3
      ],
      [
        5,
        19
      ],
      [
        1,
        14
      ],
      [
        6,
        17
      ],
      [
        4,
        -5
      ],
      [
        2,
        14
      ],
      [
        9,
        19
      ],
      [
        5,
        21
      ],
      [
        2,
        -6
      ],
      [
        4,
        17
      ],
      [
        -1,
        9
      ],
      [
        6,
        3
      ],
      [
        4,
        -5
      ]
    ],
    [
      [
        26886,
        54096
      ],
      [
        14,
        15
      ],
      [
        8,
        29
      ],
      [
        6,
        -1
      ],
      [
        0,
        3
      ]
    ],
    [
      [
        26914,
        54142
      ],
      [
        3,
        3
      ],
      [
        5,
        -4
      ],
      [
        7,
        -11
      ],
      [
        3,
        8
      ],
      [
        -5,
        6
      ],
      [
        4,
        10
      ]
    ],
    [
      [
        26931,
        54154
      ],
      [
        1,
        3
      ],
      [
        6,
        -9
      ],
      [
        8,
        3
      ]
    ],
    [
      [
        26946,
        54151
      ],
      [
        0,
        -149
      ],
      [
        -25,
        0
      ],
      [
        0,
        -104
      ],
      [
        -9,
        0
      ],
      [
        0,
        -15
      ],
      [
        9,
        0
      ],
      [
        0,
        -30
      ]
    ],
    [
      [
        26921,
        53853
      ],
      [
        0,
        -44
      ],
      [
        -30,
        0
      ]
    ],
    [
      [
        18973,
        66429
      ],
      [
        0,
        80
      ],
      [
        1,
        163
      ],
      [
        0,
        345
      ]
    ],
    [
      [
        18974,
        67362
      ],
      [
        32,
        1
      ],
      [
        32,
        -3
      ],
      [
        0,
        -91
      ],
      [
        66,
        0
      ]
    ],
    [
      [
        19104,
        67269
      ],
      [
        0,
        -127
      ],
      [
        -3,
        0
      ],
      [
        0,
        -404
      ],
      [
        -10,
        0
      ],
      [
        0,
        -81
      ],
      [
        9,
        0
      ],
      [
        0,
        -304
      ],
      [
        14,
        0
      ],
      [
        0,
        -199
      ],
      [
        32,
        -2
      ],
      [
        61,
        1
      ],
      [
        4,
        -7
      ],
      [
        39,
        0
      ]
    ],
    [
      [
        19250,
        66146
      ],
      [
        0,
        -280
      ],
      [
        2,
        -27
      ],
      [
        0,
        -499
      ]
    ],
    [
      [
        19252,
        65340
      ],
      [
        -149,
        1
      ],
      [
        -129,
        1
      ]
    ],
    [
      [
        18974,
        65342
      ],
      [
        -1,
        232
      ],
      [
        0,
        259
      ]
    ],
    [
      [
        18973,
        65833
      ],
      [
        0,
        596
      ]
    ],
    [
      [
        25346,
        55349
      ],
      [
        0,
        9
      ],
      [
        2,
        12
      ],
      [
        6,
        14
      ],
      [
        -1,
        15
      ],
      [
        4,
        -2
      ],
      [
        5,
        6
      ],
      [
        8,
        -7
      ],
      [
        6,
        18
      ],
      [
        6,
        -22
      ],
      [
        5,
        36
      ],
      [
        12,
        20
      ],
      [
        4,
        -3
      ],
      [
        8,
        43
      ],
      [
        2,
        -2
      ],
      [
        16,
        30
      ],
      [
        10,
        17
      ]
    ],
    [
      [
        25439,
        55533
      ],
      [
        0,
        -19
      ],
      [
        2,
        -51
      ],
      [
        0,
        -89
      ],
      [
        22,
        0
      ],
      [
        12,
        1
      ],
      [
        -2,
        -13
      ]
    ],
    [
      [
        25473,
        55362
      ],
      [
        3,
        -11
      ],
      [
        -2,
        -13
      ],
      [
        -4,
        0
      ],
      [
        -2,
        -13
      ],
      [
        -4,
        4
      ],
      [
        3,
        -23
      ],
      [
        -2,
        -11
      ],
      [
        4,
        0
      ],
      [
        -2,
        -14
      ],
      [
        -10,
        -11
      ],
      [
        0,
        -9
      ],
      [
        4,
        -15
      ],
      [
        -6,
        -14
      ],
      [
        -6,
        3
      ],
      [
        -3,
        -23
      ],
      [
        -2,
        3
      ],
      [
        0,
        -18
      ],
      [
        -3,
        -1
      ],
      [
        0,
        -27
      ],
      [
        3,
        -5
      ],
      [
        1,
        -20
      ],
      [
        1,
        -11
      ],
      [
        -2,
        -18
      ],
      [
        -9,
        -26
      ],
      [
        -3,
        2
      ],
      [
        -2,
        -13
      ],
      [
        3,
        -7
      ],
      [
        7,
        4
      ],
      [
        2,
        10
      ],
      [
        6,
        -19
      ],
      [
        0,
        -22
      ],
      [
        -4,
        0
      ],
      [
        -3,
        -24
      ],
      [
        5,
        -7
      ],
      [
        5,
        10
      ],
      [
        0,
        -20
      ],
      [
        3,
        -18
      ],
      [
        -2,
        -19
      ],
      [
        1,
        -14
      ],
      [
        5,
        -6
      ],
      [
        5,
        12
      ],
      [
        3,
        -9
      ],
      [
        -3,
        -21
      ],
      [
        -6,
        9
      ],
      [
        -11,
        -9
      ],
      [
        4,
        -27
      ],
      [
        5,
        -6
      ],
      [
        9,
        8
      ],
      [
        4,
        -28
      ],
      [
        -6,
        -9
      ],
      [
        -3,
        -14
      ],
      [
        -1,
        11
      ],
      [
        -5,
        5
      ],
      [
        0,
        -26
      ],
      [
        -3,
        -1
      ],
      [
        1,
        -18
      ],
      [
        -5,
        -22
      ]
    ],
    [
      [
        25446,
        54801
      ],
      [
        -3,
        -5
      ],
      [
        1,
        27
      ],
      [
        -6,
        4
      ],
      [
        -3,
        -17
      ]
    ],
    [
      [
        25435,
        54810
      ],
      [
        -2,
        0
      ],
      [
        -4,
        20
      ],
      [
        0,
        26
      ],
      [
        -6,
        24
      ],
      [
        4,
        20
      ],
      [
        6,
        -4
      ],
      [
        0,
        -18
      ],
      [
        6,
        17
      ],
      [
        -5,
        18
      ],
      [
        -6,
        1
      ],
      [
        -7,
        -8
      ],
      [
        -2,
        11
      ],
      [
        -5,
        9
      ],
      [
        -5,
        -6
      ],
      [
        -8,
        -19
      ],
      [
        -10,
        -12
      ],
      [
        -12,
        -9
      ],
      [
        -7,
        31
      ],
      [
        0,
        16
      ],
      [
        6,
        12
      ],
      [
        0,
        36
      ],
      [
        5,
        18
      ],
      [
        -4,
        8
      ],
      [
        -7,
        -15
      ],
      [
        -8,
        8
      ],
      [
        -2,
        12
      ],
      [
        8,
        10
      ],
      [
        1,
        12
      ],
      [
        -5,
        23
      ],
      [
        -2,
        37
      ],
      [
        2,
        9
      ],
      [
        7,
        -5
      ],
      [
        3,
        19
      ],
      [
        -2,
        16
      ],
      [
        -7,
        -10
      ],
      [
        -2,
        3
      ],
      [
        -8,
        40
      ],
      [
        -4,
        -10
      ],
      [
        -8,
        5
      ],
      [
        6,
        28
      ],
      [
        -7,
        22
      ],
      [
        -3,
        45
      ],
      [
        -5,
        17
      ],
      [
        4,
        12
      ],
      [
        5,
        -4
      ],
      [
        1,
        13
      ],
      [
        -3,
        3
      ],
      [
        0,
        19
      ],
      [
        5,
        -9
      ],
      [
        2,
        12
      ],
      [
        -2,
        7
      ],
      [
        -1,
        3
      ],
      [
        0,
        9
      ],
      [
        -1,
        7
      ],
      [
        0,
        10
      ]
    ],
    [
      [
        23741,
        56926
      ],
      [
        -1,
        -102
      ],
      [
        4,
        0
      ],
      [
        -1,
        -88
      ],
      [
        30,
        -4
      ],
      [
        -1,
        -203
      ]
    ],
    [
      [
        23772,
        56529
      ],
      [
        -1,
        -68
      ],
      [
        -1,
        -236
      ],
      [
        -36,
        3
      ]
    ],
    [
      [
        23734,
        56228
      ],
      [
        -3,
        20
      ],
      [
        3,
        21
      ],
      [
        -3,
        9
      ],
      [
        1,
        3
      ],
      [
        -1,
        12
      ],
      [
        -9,
        31
      ],
      [
        -2,
        18
      ],
      [
        -3,
        2
      ],
      [
        0,
        26
      ],
      [
        -9,
        16
      ],
      [
        0,
        21
      ],
      [
        -3,
        11
      ],
      [
        -1,
        4
      ],
      [
        -1,
        25
      ],
      [
        4,
        34
      ],
      [
        -3,
        14
      ],
      [
        0,
        22
      ],
      [
        -2,
        3
      ],
      [
        -4,
        38
      ],
      [
        4,
        44
      ],
      [
        -5,
        5
      ],
      [
        3,
        30
      ],
      [
        -3,
        12
      ],
      [
        3,
        16
      ],
      [
        -6,
        11
      ],
      [
        2,
        14
      ],
      [
        -1,
        34
      ],
      [
        3,
        12
      ],
      [
        -5,
        5
      ],
      [
        -38,
        1
      ]
    ],
    [
      [
        23655,
        56742
      ],
      [
        0,
        90
      ],
      [
        -4,
        0
      ],
      [
        1,
        100
      ],
      [
        89,
        -6
      ]
    ],
    [
      [
        27721,
        61863
      ],
      [
        21,
        -33
      ],
      [
        2,
        -1
      ],
      [
        3,
        -2
      ],
      [
        4,
        -9
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        1,
        -6
      ],
      [
        0,
        -4
      ],
      [
        3,
        -10
      ],
      [
        6,
        -42
      ],
      [
        7,
        -47
      ],
      [
        30,
        -35
      ],
      [
        16,
        -18
      ]
    ],
    [
      [
        27815,
        61654
      ],
      [
        -3,
        -12
      ],
      [
        4,
        -9
      ],
      [
        0,
        -13
      ],
      [
        -5,
        -2
      ],
      [
        -7,
        -30
      ],
      [
        -10,
        -54
      ],
      [
        -1,
        -19
      ],
      [
        -3,
        1
      ],
      [
        -2,
        -18
      ],
      [
        2,
        -20
      ],
      [
        -2,
        -21
      ],
      [
        -7,
        -15
      ],
      [
        -1,
        -16
      ],
      [
        -8,
        7
      ],
      [
        -4,
        -7
      ],
      [
        -1,
        -12
      ],
      [
        -3,
        -6
      ],
      [
        -5,
        -23
      ]
    ],
    [
      [
        27759,
        61385
      ],
      [
        -14,
        21
      ],
      [
        -40,
        26
      ],
      [
        -13,
        25
      ],
      [
        -12,
        28
      ]
    ],
    [
      [
        28363,
        60929
      ],
      [
        4,
        19
      ],
      [
        14,
        45
      ],
      [
        9,
        37
      ],
      [
        1,
        28
      ],
      [
        1,
        11
      ],
      [
        8,
        -10
      ],
      [
        0,
        -17
      ],
      [
        8,
        6
      ]
    ],
    [
      [
        28408,
        61048
      ],
      [
        4,
        7
      ],
      [
        1,
        -16
      ],
      [
        4,
        -2
      ],
      [
        1,
        -20
      ],
      [
        4,
        2
      ],
      [
        -2,
        -17
      ],
      [
        4,
        -15
      ],
      [
        0,
        -14
      ],
      [
        3,
        -25
      ],
      [
        4,
        9
      ],
      [
        -1,
        -32
      ],
      [
        6,
        -5
      ],
      [
        2,
        -9
      ],
      [
        -4,
        -21
      ],
      [
        2,
        -9
      ],
      [
        6,
        2
      ],
      [
        8,
        -33
      ],
      [
        6,
        1
      ],
      [
        4,
        -17
      ],
      [
        7,
        -2
      ],
      [
        0,
        -15
      ],
      [
        4,
        -6
      ],
      [
        11,
        7
      ],
      [
        3,
        -27
      ],
      [
        -2,
        -13
      ],
      [
        2,
        -5
      ],
      [
        7,
        2
      ],
      [
        7,
        -26
      ],
      [
        -4,
        -12
      ],
      [
        4,
        -12
      ],
      [
        4,
        4
      ],
      [
        2,
        -12
      ],
      [
        5,
        -2
      ],
      [
        -3,
        -9
      ],
      [
        4,
        -10
      ],
      [
        5,
        -3
      ],
      [
        -1,
        -12
      ],
      [
        4,
        -8
      ],
      [
        2,
        -17
      ],
      [
        -3,
        -22
      ],
      [
        -1,
        -21
      ]
    ],
    [
      [
        28517,
        60613
      ],
      [
        -7,
        38
      ],
      [
        -10,
        -28
      ],
      [
        -3,
        -3
      ],
      [
        -4,
        9
      ],
      [
        4,
        21
      ],
      [
        3,
        27
      ],
      [
        -4,
        10
      ],
      [
        -4,
        -5
      ],
      [
        2,
        -28
      ],
      [
        -6,
        -8
      ],
      [
        -3,
        3
      ],
      [
        1,
        20
      ],
      [
        -5,
        4
      ],
      [
        -6,
        -11
      ],
      [
        -1,
        -24
      ],
      [
        -8,
        3
      ],
      [
        5,
        18
      ],
      [
        0,
        17
      ],
      [
        -3,
        17
      ],
      [
        -5,
        -3
      ],
      [
        1,
        -21
      ],
      [
        -10,
        2
      ],
      [
        0,
        17
      ],
      [
        -14,
        25
      ],
      [
        -5,
        -6
      ],
      [
        -1,
        23
      ],
      [
        -10,
        10
      ]
    ],
    [
      [
        28424,
        60740
      ],
      [
        -1,
        9
      ],
      [
        3,
        11
      ],
      [
        2,
        21
      ],
      [
        -7,
        2
      ],
      [
        -4,
        13
      ],
      [
        0,
        -13
      ],
      [
        -10,
        -7
      ],
      [
        -1,
        11
      ],
      [
        2,
        19
      ],
      [
        -3,
        8
      ],
      [
        -2,
        -14
      ],
      [
        -4,
        12
      ],
      [
        -7,
        -3
      ],
      [
        -1,
        15
      ],
      [
        4,
        17
      ],
      [
        -2,
        15
      ],
      [
        -3,
        4
      ],
      [
        0,
        -24
      ],
      [
        -6,
        17
      ],
      [
        -3,
        -12
      ],
      [
        -4,
        1
      ],
      [
        0,
        30
      ],
      [
        -8,
        -7
      ],
      [
        0,
        11
      ],
      [
        5,
        1
      ],
      [
        0,
        12
      ],
      [
        -8,
        0
      ],
      [
        3,
        18
      ],
      [
        -3,
        25
      ],
      [
        -3,
        -3
      ]
    ],
    [
      [
        24563,
        71635
      ],
      [
        10,
        6
      ],
      [
        2,
        12
      ],
      [
        3,
        -1
      ],
      [
        2,
        -17
      ],
      [
        -3,
        -27
      ],
      [
        -8,
        -2
      ],
      [
        -5,
        12
      ],
      [
        -1,
        9
      ],
      [
        0,
        8
      ]
    ],
    [
      [
        24405,
        71367
      ],
      [
        4,
        -1
      ],
      [
        7,
        3
      ],
      [
        3,
        4
      ],
      [
        2,
        6
      ],
      [
        6,
        3
      ],
      [
        6,
        5
      ],
      [
        7,
        11
      ],
      [
        4,
        8
      ],
      [
        3,
        2
      ],
      [
        2,
        -1
      ],
      [
        7,
        4
      ],
      [
        2,
        5
      ],
      [
        2,
        11
      ],
      [
        4,
        12
      ],
      [
        7,
        10
      ],
      [
        3,
        5
      ],
      [
        10,
        4
      ],
      [
        3,
        3
      ],
      [
        2,
        5
      ],
      [
        5,
        22
      ],
      [
        1,
        4
      ],
      [
        4,
        4
      ],
      [
        2,
        -1
      ],
      [
        0,
        -8
      ],
      [
        2,
        -6
      ],
      [
        6,
        -11
      ],
      [
        3,
        0
      ],
      [
        5,
        22
      ],
      [
        1,
        8
      ],
      [
        1,
        3
      ],
      [
        2,
        0
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -11
      ],
      [
        1,
        -2
      ],
      [
        3,
        -3
      ],
      [
        5,
        1
      ],
      [
        3,
        5
      ],
      [
        0,
        21
      ],
      [
        1,
        3
      ],
      [
        3,
        2
      ],
      [
        3,
        -7
      ],
      [
        5,
        4
      ],
      [
        3,
        9
      ],
      [
        1,
        5
      ],
      [
        1,
        11
      ],
      [
        4,
        10
      ],
      [
        4,
        6
      ],
      [
        2,
        -1
      ],
      [
        1,
        2
      ],
      [
        3,
        9
      ],
      [
        3,
        19
      ],
      [
        1,
        3
      ],
      [
        1,
        0
      ],
      [
        3,
        -7
      ],
      [
        9,
        -8
      ],
      [
        2,
        3
      ],
      [
        2,
        9
      ],
      [
        8,
        19
      ],
      [
        2,
        4
      ],
      [
        5,
        1
      ],
      [
        5,
        -5
      ],
      [
        14,
        -37
      ],
      [
        9,
        -32
      ],
      [
        1,
        -6
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        -8
      ],
      [
        -3,
        -20
      ],
      [
        -5,
        -42
      ],
      [
        -7,
        -22
      ],
      [
        -1,
        -8
      ],
      [
        -2,
        -9
      ],
      [
        -6,
        -1
      ],
      [
        -2,
        -9
      ],
      [
        2,
        -8
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        -6,
        -10
      ],
      [
        1,
        -10
      ],
      [
        4,
        -28
      ],
      [
        4,
        -28
      ],
      [
        0,
        -7
      ],
      [
        -4,
        -15
      ],
      [
        -5,
        -12
      ],
      [
        -7,
        -8
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -24
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -7
      ],
      [
        -4,
        -20
      ],
      [
        -3,
        -6
      ],
      [
        0,
        -7
      ],
      [
        3,
        -10
      ],
      [
        4,
        -4
      ]
    ],
    [
      [
        24579,
        71168
      ],
      [
        0,
        -501
      ]
    ],
    [
      [
        24405,
        70670
      ],
      [
        0,
        402
      ],
      [
        -1,
        18
      ],
      [
        1,
        277
      ]
    ],
    [
      [
        24487,
        67840
      ],
      [
        96,
        -1
      ]
    ],
    [
      [
        24583,
        67839
      ],
      [
        85,
        1
      ],
      [
        5,
        4
      ],
      [
        1,
        -4
      ],
      [
        42,
        0
      ],
      [
        34,
        6
      ]
    ],
    [
      [
        24750,
        67846
      ],
      [
        0,
        -105
      ]
    ],
    [
      [
        24750,
        67741
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        24651,
        67487
      ],
      [
        -22,
        2
      ],
      [
        -128,
        -2
      ]
    ],
    [
      [
        24501,
        67487
      ],
      [
        0,
        3
      ],
      [
        -6,
        23
      ],
      [
        -1,
        7
      ],
      [
        -1,
        5
      ],
      [
        0,
        3
      ],
      [
        1,
        2
      ],
      [
        0,
        3
      ],
      [
        2,
        4
      ],
      [
        1,
        6
      ],
      [
        1,
        12
      ],
      [
        0,
        22
      ]
    ],
    [
      [
        24498,
        67577
      ],
      [
        0,
        17
      ],
      [
        -2,
        4
      ],
      [
        -2,
        4
      ],
      [
        0,
        3
      ],
      [
        -2,
        10
      ],
      [
        -1,
        9
      ],
      [
        -1,
        6
      ],
      [
        0,
        4
      ],
      [
        1,
        2
      ],
      [
        0,
        5
      ],
      [
        2,
        8
      ],
      [
        1,
        3
      ],
      [
        0,
        22
      ],
      [
        -1,
        2
      ],
      [
        -1,
        5
      ],
      [
        -4,
        13
      ],
      [
        -2,
        3
      ],
      [
        0,
        3
      ],
      [
        -1,
        5
      ],
      [
        -1,
        6
      ],
      [
        0,
        14
      ],
      [
        1,
        13
      ],
      [
        0,
        12
      ],
      [
        -2,
        5
      ],
      [
        0,
        2
      ],
      [
        -1,
        14
      ],
      [
        0,
        11
      ],
      [
        2,
        23
      ],
      [
        0,
        21
      ],
      [
        2,
        6
      ],
      [
        0,
        5
      ],
      [
        1,
        3
      ]
    ],
    [
      [
        22655,
        65733
      ],
      [
        0,
        -202
      ]
    ],
    [
      [
        22655,
        65531
      ],
      [
        1,
        -252
      ]
    ],
    [
      [
        23358,
        63503
      ],
      [
        0,
        -13
      ],
      [
        2,
        -6
      ],
      [
        3,
        -7
      ],
      [
        4,
        -7
      ],
      [
        2,
        -3
      ],
      [
        2,
        -10
      ],
      [
        1,
        -7
      ],
      [
        2,
        -7
      ],
      [
        3,
        -4
      ],
      [
        1,
        -2
      ],
      [
        2,
        0
      ],
      [
        3,
        1
      ],
      [
        1,
        -1
      ],
      [
        3,
        -5
      ],
      [
        1,
        -6
      ],
      [
        0,
        -14
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -3
      ],
      [
        0,
        -1
      ],
      [
        1,
        -5
      ],
      [
        0,
        -2
      ],
      [
        2,
        -2
      ],
      [
        1,
        -1
      ],
      [
        3,
        0
      ],
      [
        2,
        3
      ],
      [
        3,
        5
      ],
      [
        2,
        1
      ],
      [
        1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        1,
        -3
      ],
      [
        0,
        -18
      ],
      [
        1,
        -5
      ],
      [
        1,
        -4
      ],
      [
        0,
        -2
      ],
      [
        2,
        -3
      ],
      [
        6,
        -6
      ],
      [
        5,
        -7
      ],
      [
        1,
        -1
      ],
      [
        1,
        0
      ],
      [
        8,
        3
      ],
      [
        3,
        0
      ],
      [
        1,
        1
      ],
      [
        2,
        3
      ],
      [
        1,
        4
      ],
      [
        1,
        6
      ],
      [
        0,
        17
      ],
      [
        2,
        7
      ],
      [
        1,
        3
      ],
      [
        2,
        1
      ],
      [
        1,
        0
      ],
      [
        3,
        -3
      ]
    ],
    [
      [
        23446,
        63384
      ],
      [
        1,
        -1
      ],
      [
        1,
        -1
      ],
      [
        2,
        1
      ],
      [
        4,
        5
      ],
      [
        1,
        0
      ],
      [
        2,
        -1
      ],
      [
        3,
        -3
      ],
      [
        2,
        -5
      ],
      [
        2,
        -6
      ],
      [
        0,
        -14
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -6
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -9
      ],
      [
        1,
        -6
      ],
      [
        0,
        -2
      ],
      [
        4,
        -10
      ],
      [
        2,
        -6
      ],
      [
        2,
        -2
      ],
      [
        2,
        -1
      ],
      [
        3,
        1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        2,
        -5
      ],
      [
        1,
        -2
      ],
      [
        0,
        -7
      ]
    ],
    [
      [
        23478,
        63294
      ],
      [
        1,
        -9
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -11
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -9,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -11
      ],
      [
        2,
        -5
      ],
      [
        1,
        -3
      ],
      [
        2,
        -7
      ],
      [
        1,
        -2
      ],
      [
        2,
        1
      ],
      [
        2,
        2
      ],
      [
        1,
        2
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        2,
        7
      ],
      [
        1,
        1
      ],
      [
        3,
        2
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        1,
        -5
      ],
      [
        0,
        -16
      ],
      [
        -1,
        -8
      ],
      [
        -2,
        -9
      ],
      [
        -1,
        -5
      ],
      [
        -3,
        -4
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -2,
        1
      ],
      [
        -2,
        4
      ],
      [
        -4,
        8
      ],
      [
        -2,
        7
      ],
      [
        -2,
        3
      ],
      [
        -2,
        2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -8
      ],
      [
        0,
        -11
      ],
      [
        1,
        -18
      ],
      [
        0,
        -17
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        0
      ],
      [
        -3,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -14
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -17
      ]
    ],
    [
      [
        23429,
        63055
      ],
      [
        -9,
        0
      ],
      [
        -3,
        6
      ],
      [
        -5,
        37
      ],
      [
        -63,
        1
      ]
    ],
    [
      [
        23349,
        63099
      ],
      [
        0,
        404
      ]
    ],
    [
      [
        16714,
        61657
      ],
      [
        8,
        -1
      ],
      [
        61,
        1
      ],
      [
        0,
        408
      ],
      [
        2,
        101
      ],
      [
        -32,
        -1
      ],
      [
        0,
        108
      ],
      [
        24,
        150
      ],
      [
        2,
        1
      ],
      [
        47,
        1
      ]
    ],
    [
      [
        16826,
        62425
      ],
      [
        248,
        -1
      ]
    ],
    [
      [
        17074,
        62424
      ],
      [
        -93,
        -86
      ],
      [
        0,
        -94
      ],
      [
        141,
        -518
      ]
    ],
    [
      [
        16917,
        61054
      ],
      [
        -21,
        61
      ],
      [
        -19,
        59
      ],
      [
        -14,
        41
      ],
      [
        -26,
        78
      ],
      [
        -9,
        27
      ],
      [
        -7,
        20
      ],
      [
        -24,
        73
      ],
      [
        -18,
        52
      ],
      [
        -8,
        23
      ],
      [
        -14,
        40
      ],
      [
        -8,
        25
      ],
      [
        -15,
        42
      ],
      [
        -4,
        14
      ],
      [
        -8,
        23
      ],
      [
        -8,
        25
      ]
    ],
    [
      [
        25400,
        59258
      ],
      [
        10,
        1
      ],
      [
        14,
        -23
      ],
      [
        9,
        -6
      ],
      [
        11,
        -1
      ],
      [
        10,
        6
      ],
      [
        8,
        11
      ],
      [
        9,
        20
      ],
      [
        2,
        9
      ],
      [
        35,
        -1
      ]
    ],
    [
      [
        25508,
        59274
      ],
      [
        1,
        -30
      ],
      [
        16,
        -6
      ],
      [
        5,
        -2
      ]
    ],
    [
      [
        25530,
        59236
      ],
      [
        -3,
        -100
      ],
      [
        -12,
        -83
      ]
    ],
    [
      [
        25515,
        59053
      ],
      [
        -3,
        6
      ],
      [
        -2,
        18
      ],
      [
        -22,
        4
      ],
      [
        -10,
        25
      ],
      [
        -9,
        14
      ],
      [
        -7,
        8
      ],
      [
        -12,
        3
      ],
      [
        -10,
        -14
      ],
      [
        -32,
        12
      ]
    ],
    [
      [
        22943,
        49851
      ],
      [
        3,
        -20
      ],
      [
        0,
        -6
      ],
      [
        -4,
        -30
      ],
      [
        -2,
        -8
      ]
    ],
    [
      [
        22986,
        50363
      ],
      [
        16,
        15
      ],
      [
        2,
        -22
      ],
      [
        5,
        -1
      ],
      [
        23,
        -3
      ],
      [
        14,
        1
      ],
      [
        8,
        31
      ],
      [
        0,
        -47
      ],
      [
        -1,
        -18
      ],
      [
        22,
        1
      ]
    ],
    [
      [
        23075,
        50320
      ],
      [
        0,
        -38
      ],
      [
        -15,
        -294
      ]
    ],
    [
      [
        23060,
        49988
      ],
      [
        -3,
        -10
      ],
      [
        -3,
        -28
      ],
      [
        -12,
        -46
      ],
      [
        -12,
        -23
      ],
      [
        -41,
        -88
      ],
      [
        -24,
        -68
      ],
      [
        -20,
        -63
      ],
      [
        -17,
        -58
      ]
    ],
    [
      [
        22936,
        49696
      ],
      [
        1,
        5
      ],
      [
        0,
        29
      ],
      [
        8,
        24
      ],
      [
        16,
        2
      ],
      [
        9,
        28
      ],
      [
        13,
        37
      ],
      [
        8,
        26
      ],
      [
        5,
        14
      ],
      [
        2,
        14
      ],
      [
        7,
        9
      ],
      [
        6,
        2
      ],
      [
        4,
        16
      ],
      [
        4,
        8
      ],
      [
        12,
        8
      ],
      [
        9,
        9
      ],
      [
        3,
        6
      ],
      [
        2,
        24
      ],
      [
        -4,
        8
      ],
      [
        -2,
        11
      ],
      [
        1,
        10
      ],
      [
        8,
        19
      ],
      [
        0,
        14
      ],
      [
        -9,
        2
      ],
      [
        -16,
        -41
      ],
      [
        -9,
        -13
      ],
      [
        -11,
        -22
      ],
      [
        -11,
        -40
      ],
      [
        -3,
        0
      ],
      [
        -9,
        -11
      ],
      [
        -5,
        6
      ],
      [
        -1,
        16
      ],
      [
        -5,
        24
      ],
      [
        1,
        24
      ],
      [
        -1,
        36
      ],
      [
        -2,
        7
      ],
      [
        -3,
        3
      ],
      [
        -7,
        0
      ],
      [
        -4,
        3
      ],
      [
        -1,
        -1
      ]
    ],
    [
      [
        22952,
        50012
      ],
      [
        0,
        18
      ],
      [
        -7,
        24
      ],
      [
        -6,
        -19
      ],
      [
        -3,
        18
      ],
      [
        -5,
        15
      ],
      [
        -2,
        20
      ],
      [
        -4,
        2
      ],
      [
        -1,
        15
      ],
      [
        -7,
        19
      ]
    ],
    [
      [
        22917,
        50124
      ],
      [
        -4,
        30
      ],
      [
        3,
        19
      ],
      [
        -2,
        21
      ],
      [
        -4,
        5
      ],
      [
        -4,
        18
      ],
      [
        22,
        56
      ],
      [
        36,
        41
      ],
      [
        16,
        41
      ],
      [
        2,
        -4
      ],
      [
        4,
        12
      ]
    ],
    [
      [
        26087,
        57128
      ],
      [
        0,
        -6
      ],
      [
        1,
        -20
      ],
      [
        2,
        -31
      ],
      [
        0,
        -1
      ],
      [
        5,
        -94
      ],
      [
        3,
        -57
      ],
      [
        1,
        -19
      ],
      [
        2,
        -48
      ]
    ],
    [
      [
        26113,
        56612
      ],
      [
        0,
        -10
      ],
      [
        4,
        -81
      ],
      [
        0,
        -3
      ],
      [
        2,
        -42
      ]
    ],
    [
      [
        26119,
        56476
      ],
      [
        -8,
        -8
      ],
      [
        -19,
        0
      ],
      [
        0,
        -17
      ],
      [
        -10,
        -1
      ]
    ],
    [
      [
        26082,
        56450
      ],
      [
        1,
        17
      ],
      [
        -18,
        4
      ],
      [
        -33,
        9
      ],
      [
        -8,
        2
      ]
    ],
    [
      [
        26024,
        56482
      ],
      [
        1,
        24
      ],
      [
        -17,
        129
      ],
      [
        2,
        29
      ],
      [
        -6,
        0
      ],
      [
        -6,
        -18
      ],
      [
        -2,
        1
      ],
      [
        -1,
        104
      ]
    ],
    [
      [
        19883,
        71064
      ],
      [
        7,
        0
      ],
      [
        5,
        -16
      ]
    ],
    [
      [
        19895,
        71048
      ],
      [
        0,
        -17
      ],
      [
        6,
        0
      ],
      [
        0,
        -34
      ],
      [
        6,
        0
      ],
      [
        0,
        -33
      ],
      [
        6,
        0
      ],
      [
        0,
        -17
      ],
      [
        5,
        0
      ],
      [
        0,
        -34
      ],
      [
        6,
        0
      ],
      [
        0,
        -17
      ],
      [
        6,
        0
      ],
      [
        0,
        -50
      ],
      [
        6,
        0
      ],
      [
        0,
        -17
      ],
      [
        6,
        0
      ],
      [
        0,
        -34
      ],
      [
        6,
        0
      ],
      [
        0,
        -17
      ],
      [
        5,
        0
      ],
      [
        0,
        -33
      ],
      [
        6,
        0
      ],
      [
        0,
        -34
      ],
      [
        6,
        0
      ],
      [
        0,
        -17
      ],
      [
        6,
        0
      ],
      [
        -2,
        -31
      ],
      [
        3,
        -13
      ],
      [
        -6,
        -20
      ],
      [
        3,
        -18
      ],
      [
        -7,
        -23
      ],
      [
        -1,
        -19
      ],
      [
        -4,
        -14
      ],
      [
        1,
        -18
      ]
    ],
    [
      [
        19958,
        70538
      ],
      [
        -45,
        0
      ],
      [
        0,
        -68
      ],
      [
        -35,
        0
      ],
      [
        0,
        -33
      ],
      [
        -11,
        0
      ],
      [
        0,
        -34
      ],
      [
        -12,
        0
      ],
      [
        0,
        -33
      ],
      [
        -46,
        0
      ],
      [
        0,
        -135
      ],
      [
        -6,
        0
      ],
      [
        0,
        -308
      ],
      [
        -35,
        0
      ],
      [
        0,
        -34
      ],
      [
        -34,
        0
      ],
      [
        0,
        -34
      ],
      [
        -36,
        0
      ],
      [
        -56,
        4
      ]
    ],
    [
      [
        19642,
        69863
      ],
      [
        -14,
        0
      ],
      [
        -1,
        68
      ],
      [
        -17,
        1
      ],
      [
        0,
        33
      ],
      [
        -11,
        0
      ],
      [
        0,
        42
      ],
      [
        5,
        33
      ],
      [
        0,
        26
      ],
      [
        -4,
        -4
      ],
      [
        -13,
        -28
      ]
    ],
    [
      [
        19587,
        70034
      ],
      [
        0,
        33
      ],
      [
        -6,
        0
      ],
      [
        -5,
        26
      ],
      [
        0,
        25
      ],
      [
        -6,
        0
      ],
      [
        1,
        118
      ],
      [
        0,
        204
      ],
      [
        -6,
        0
      ],
      [
        -1,
        84
      ],
      [
        1,
        117
      ]
    ],
    [
      [
        22528,
        64721
      ],
      [
        1,
        -5
      ],
      [
        0,
        -202
      ]
    ],
    [
      [
        22529,
        64514
      ],
      [
        0,
        -199
      ]
    ],
    [
      [
        21996,
        66816
      ],
      [
        3,
        -10
      ],
      [
        11,
        -9
      ],
      [
        4,
        -26
      ],
      [
        5,
        -9
      ],
      [
        16,
        -17
      ],
      [
        14,
        4
      ],
      [
        11,
        -19
      ],
      [
        6,
        1
      ],
      [
        13,
        -9
      ],
      [
        10,
        4
      ],
      [
        2,
        -19
      ],
      [
        5,
        2
      ],
      [
        6,
        -13
      ],
      [
        11,
        -9
      ],
      [
        7,
        2
      ],
      [
        11,
        -12
      ],
      [
        10,
        5
      ]
    ],
    [
      [
        22141,
        66682
      ],
      [
        0,
        -346
      ],
      [
        4,
        1
      ],
      [
        0,
        -406
      ]
    ],
    [
      [
        22145,
        65931
      ],
      [
        -7,
        0
      ]
    ],
    [
      [
        22004,
        65931
      ],
      [
        0,
        404
      ],
      [
        -4,
        0
      ],
      [
        0,
        405
      ],
      [
        -4,
        0
      ],
      [
        0,
        76
      ]
    ],
    [
      [
        20082,
        57632
      ],
      [
        12,
        -100
      ],
      [
        0,
        -1
      ],
      [
        84,
        0
      ],
      [
        1,
        2
      ],
      [
        4,
        16
      ],
      [
        5,
        24
      ],
      [
        72,
        -3
      ],
      [
        4,
        -13
      ],
      [
        1,
        -3
      ],
      [
        0,
        -23
      ]
    ],
    [
      [
        20263,
        57030
      ],
      [
        -11,
        -3
      ],
      [
        -13,
        23
      ],
      [
        -17,
        20
      ],
      [
        -57,
        67
      ],
      [
        -1,
        2
      ],
      [
        -7,
        12
      ],
      [
        -24,
        42
      ],
      [
        -38,
        0
      ],
      [
        -51,
        -1
      ]
    ],
    [
      [
        20044,
        57192
      ],
      [
        0,
        441
      ],
      [
        38,
        -1
      ]
    ],
    [
      [
        20456,
        58696
      ],
      [
        105,
        0
      ],
      [
        31,
        -38
      ],
      [
        5,
        -10
      ],
      [
        11,
        -4
      ],
      [
        8,
        -20
      ],
      [
        11,
        -1
      ],
      [
        9,
        -25
      ],
      [
        7,
        -12
      ],
      [
        8,
        -26
      ],
      [
        2,
        18
      ],
      [
        3,
        2
      ],
      [
        71,
        14
      ],
      [
        57,
        -3
      ],
      [
        25,
        -2
      ],
      [
        24,
        0
      ]
    ],
    [
      [
        20833,
        58589
      ],
      [
        74,
        3
      ],
      [
        23,
        0
      ],
      [
        13,
        24
      ],
      [
        71,
        -442
      ],
      [
        24,
        0
      ],
      [
        0,
        -38
      ]
    ],
    [
      [
        21038,
        58136
      ],
      [
        0,
        -173
      ],
      [
        -58,
        0
      ],
      [
        -4,
        1
      ],
      [
        0,
        26
      ],
      [
        -74,
        -142
      ]
    ],
    [
      [
        20902,
        57848
      ],
      [
        0,
        85
      ],
      [
        -64,
        1
      ],
      [
        -261,
        0
      ],
      [
        0,
        -203
      ]
    ],
    [
      [
        20459,
        57731
      ],
      [
        0,
        202
      ],
      [
        -1,
        103
      ],
      [
        0,
        408
      ],
      [
        -1,
        92
      ],
      [
        0,
        92
      ],
      [
        -1,
        13
      ],
      [
        0,
        55
      ]
    ],
    [
      [
        27497,
        59127
      ],
      [
        0,
        24
      ]
    ],
    [
      [
        27611,
        58859
      ],
      [
        -30,
        19
      ],
      [
        -17,
        0
      ],
      [
        0,
        -15
      ],
      [
        -1,
        -20
      ],
      [
        -6,
        0
      ],
      [
        -26,
        -1
      ],
      [
        -18,
        -27
      ]
    ],
    [
      [
        27513,
        58815
      ],
      [
        -7,
        16
      ],
      [
        1,
        33
      ],
      [
        -10,
        33
      ],
      [
        -3,
        22
      ],
      [
        -9,
        -18
      ]
    ],
    [
      [
        28162,
        58364
      ],
      [
        2,
        14
      ],
      [
        17,
        -14
      ],
      [
        34,
        1
      ],
      [
        11,
        0
      ],
      [
        4,
        -1
      ]
    ],
    [
      [
        28230,
        58364
      ],
      [
        -1,
        -126
      ],
      [
        0,
        -62
      ],
      [
        6,
        -23
      ],
      [
        1,
        -26
      ],
      [
        -1,
        -11
      ],
      [
        -1,
        -4
      ]
    ],
    [
      [
        28226,
        57889
      ],
      [
        -13,
        -18
      ],
      [
        -3,
        -18
      ],
      [
        -10,
        31
      ],
      [
        -12,
        -8
      ],
      [
        -3,
        20
      ],
      [
        -11,
        12
      ],
      [
        -6,
        -2
      ],
      [
        -9,
        -20
      ],
      [
        -24,
        17
      ]
    ],
    [
      [
        28135,
        57903
      ],
      [
        0,
        17
      ],
      [
        -8,
        9
      ],
      [
        -13,
        13
      ],
      [
        -2,
        3
      ],
      [
        -3,
        13
      ],
      [
        -14,
        59
      ]
    ],
    [
      [
        28095,
        58017
      ],
      [
        5,
        32
      ],
      [
        3,
        0
      ],
      [
        6,
        12
      ],
      [
        4,
        -6
      ],
      [
        7,
        15
      ],
      [
        0,
        10
      ],
      [
        10,
        2
      ],
      [
        8,
        9
      ],
      [
        -3,
        17
      ],
      [
        5,
        25
      ],
      [
        -3,
        6
      ],
      [
        0,
        30
      ],
      [
        25,
        195
      ]
    ],
    [
      [
        27929,
        57491
      ],
      [
        16,
        14
      ],
      [
        13,
        4
      ],
      [
        74,
        0
      ],
      [
        4,
        -6
      ],
      [
        6,
        12
      ]
    ],
    [
      [
        28042,
        57515
      ],
      [
        1,
        -15
      ],
      [
        6,
        -15
      ],
      [
        6,
        -20
      ],
      [
        4,
        -34
      ],
      [
        4,
        -21
      ],
      [
        3,
        -1
      ],
      [
        3,
        -18
      ],
      [
        2,
        0
      ],
      [
        0,
        -23
      ],
      [
        7,
        -30
      ],
      [
        -1,
        -9
      ],
      [
        7,
        -7
      ],
      [
        2,
        -18
      ],
      [
        4,
        -11
      ],
      [
        0,
        -18
      ],
      [
        3,
        -8
      ],
      [
        0,
        -12
      ],
      [
        2,
        -35
      ],
      [
        11,
        -22
      ],
      [
        4,
        -26
      ],
      [
        -1,
        -9
      ]
    ],
    [
      [
        28109,
        57163
      ],
      [
        -5,
        -18
      ],
      [
        5,
        -21
      ],
      [
        0,
        -14
      ],
      [
        6,
        -18
      ],
      [
        6,
        -5
      ],
      [
        3,
        -15
      ],
      [
        7,
        -12
      ],
      [
        -22,
        -77
      ]
    ],
    [
      [
        28109,
        56983
      ],
      [
        -22,
        -37
      ],
      [
        -9,
        6
      ],
      [
        -8,
        -2
      ],
      [
        -7,
        8
      ],
      [
        -7,
        0
      ],
      [
        -30,
        50
      ],
      [
        -11,
        12
      ],
      [
        -3,
        12
      ],
      [
        -12,
        23
      ],
      [
        -6,
        10
      ],
      [
        -44,
        -9
      ],
      [
        -9,
        14
      ],
      [
        -1,
        13
      ],
      [
        -2,
        0
      ]
    ],
    [
      [
        27938,
        57083
      ],
      [
        2,
        15
      ],
      [
        4,
        2
      ],
      [
        -2,
        28
      ],
      [
        -2,
        46
      ],
      [
        5,
        18
      ],
      [
        4,
        39
      ],
      [
        -1,
        11
      ],
      [
        7,
        54
      ],
      [
        1,
        25
      ],
      [
        -5,
        23
      ],
      [
        -9,
        32
      ],
      [
        -8,
        87
      ],
      [
        -5,
        28
      ]
    ],
    [
      [
        18803,
        71550
      ],
      [
        33,
        0
      ],
      [
        0,
        102
      ],
      [
        71,
        0
      ],
      [
        0,
        13
      ],
      [
        35,
        0
      ],
      [
        0,
        89
      ],
      [
        22,
        -1
      ],
      [
        -1,
        -17
      ],
      [
        2,
        -32
      ],
      [
        -8,
        -19
      ],
      [
        9,
        -27
      ],
      [
        5,
        4
      ],
      [
        16,
        -5
      ],
      [
        24,
        -29
      ],
      [
        6,
        -17
      ],
      [
        5,
        -24
      ],
      [
        4,
        1
      ],
      [
        0,
        -28
      ],
      [
        9,
        -8
      ],
      [
        6,
        -15
      ],
      [
        4,
        9
      ],
      [
        2,
        -9
      ],
      [
        8,
        -14
      ],
      [
        -3,
        -9
      ],
      [
        3,
        -26
      ],
      [
        0,
        -18
      ],
      [
        5,
        5
      ],
      [
        5,
        -12
      ],
      [
        6,
        8
      ],
      [
        5,
        -24
      ],
      [
        4,
        -8
      ],
      [
        3,
        7
      ]
    ],
    [
      [
        19083,
        71446
      ],
      [
        2,
        -9
      ],
      [
        -1,
        -17
      ],
      [
        8,
        -34
      ],
      [
        16,
        -1
      ],
      [
        1,
        -14
      ],
      [
        -1,
        -24
      ],
      [
        4,
        -7
      ],
      [
        7,
        -23
      ],
      [
        5,
        0
      ],
      [
        2,
        -12
      ],
      [
        4,
        -1
      ],
      [
        5,
        -27
      ],
      [
        8,
        9
      ],
      [
        4,
        -10
      ],
      [
        7,
        12
      ],
      [
        6,
        6
      ],
      [
        8,
        -13
      ],
      [
        1,
        -11
      ],
      [
        4,
        1
      ],
      [
        1,
        14
      ],
      [
        7,
        4
      ],
      [
        8,
        25
      ]
    ],
    [
      [
        19186,
        70744
      ],
      [
        0,
        -42
      ]
    ],
    [
      [
        19186,
        70702
      ],
      [
        -35,
        0
      ],
      [
        0,
        9
      ],
      [
        -104,
        0
      ]
    ],
    [
      [
        19047,
        70711
      ],
      [
        -78,
        0
      ]
    ],
    [
      [
        26384,
        60576
      ],
      [
        20,
        -15
      ],
      [
        6,
        29
      ],
      [
        -2,
        21
      ],
      [
        4,
        27
      ]
    ],
    [
      [
        26412,
        60638
      ],
      [
        12,
        -2
      ],
      [
        1,
        -16
      ],
      [
        9,
        -10
      ],
      [
        12,
        14
      ],
      [
        7,
        -5
      ]
    ],
    [
      [
        26470,
        60383
      ],
      [
        -3,
        -20
      ],
      [
        -8,
        -4
      ],
      [
        -6,
        -22
      ],
      [
        -5,
        0
      ],
      [
        0,
        -44
      ],
      [
        -3,
        6
      ],
      [
        -4,
        -22
      ],
      [
        -3,
        12
      ],
      [
        -3,
        -25
      ],
      [
        -2,
        -7
      ],
      [
        4,
        -7
      ],
      [
        -7,
        -10
      ],
      [
        5,
        -18
      ],
      [
        -9,
        -12
      ],
      [
        -1,
        -2
      ],
      [
        3,
        -9
      ],
      [
        0,
        -12
      ]
    ],
    [
      [
        26428,
        60187
      ],
      [
        -1,
        10
      ],
      [
        -2,
        4
      ],
      [
        -27,
        91
      ],
      [
        -14,
        43
      ],
      [
        -15,
        58
      ]
    ],
    [
      [
        26369,
        60393
      ],
      [
        15,
        183
      ]
    ],
    [
      [
        26997,
        56995
      ],
      [
        5,
        -21
      ],
      [
        2,
        0
      ],
      [
        4,
        -18
      ],
      [
        2,
        1
      ],
      [
        6,
        -22
      ],
      [
        3,
        -32
      ],
      [
        4,
        1
      ],
      [
        6,
        -9
      ],
      [
        3,
        -23
      ],
      [
        3,
        5
      ],
      [
        8,
        -10
      ],
      [
        8,
        -27
      ],
      [
        1,
        -9
      ],
      [
        7,
        -12
      ],
      [
        5,
        -20
      ],
      [
        4,
        1
      ],
      [
        4,
        -5
      ],
      [
        2,
        -18
      ],
      [
        7,
        -22
      ]
    ],
    [
      [
        27081,
        56755
      ],
      [
        5,
        -9
      ],
      [
        3,
        -22
      ],
      [
        3,
        0
      ],
      [
        0,
        -11
      ],
      [
        2,
        -24
      ],
      [
        8,
        -13
      ]
    ],
    [
      [
        27064,
        56474
      ],
      [
        -11,
        -10
      ]
    ],
    [
      [
        27053,
        56464
      ],
      [
        0,
        35
      ],
      [
        -8,
        -5
      ],
      [
        -21,
        9
      ],
      [
        -5,
        -16
      ],
      [
        -9,
        6
      ],
      [
        -5,
        14
      ],
      [
        -5,
        27
      ],
      [
        -19,
        -49
      ],
      [
        -6,
        108
      ]
    ],
    [
      [
        26975,
        56593
      ],
      [
        16,
        51
      ],
      [
        6,
        42
      ],
      [
        2,
        22
      ],
      [
        0,
        19
      ],
      [
        -2,
        47
      ],
      [
        -5,
        30
      ],
      [
        -12,
        37
      ],
      [
        -1,
        50
      ],
      [
        -6,
        26
      ],
      [
        12,
        41
      ],
      [
        12,
        37
      ]
    ],
    [
      [
        25679,
        61093
      ],
      [
        2,
        3
      ],
      [
        2,
        0
      ],
      [
        5,
        1
      ],
      [
        3,
        2
      ],
      [
        2,
        0
      ],
      [
        2,
        2
      ],
      [
        4,
        7
      ],
      [
        1,
        4
      ],
      [
        3,
        11
      ],
      [
        2,
        10
      ],
      [
        1,
        4
      ],
      [
        1,
        3
      ],
      [
        2,
        6
      ],
      [
        1,
        4
      ],
      [
        1,
        4
      ],
      [
        2,
        6
      ],
      [
        2,
        3
      ],
      [
        4,
        4
      ],
      [
        3,
        6
      ],
      [
        1,
        1
      ],
      [
        1,
        -1
      ]
    ],
    [
      [
        25724,
        61173
      ],
      [
        2,
        -2
      ],
      [
        4,
        -9
      ],
      [
        1,
        -11
      ],
      [
        1,
        -8
      ],
      [
        2,
        -19
      ],
      [
        4,
        -28
      ],
      [
        4,
        -23
      ],
      [
        5,
        -19
      ],
      [
        1,
        -2
      ],
      [
        2,
        -2
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        2,
        5
      ],
      [
        5,
        12
      ],
      [
        1,
        5
      ],
      [
        2,
        3
      ],
      [
        2,
        -1
      ],
      [
        3,
        -2
      ],
      [
        3,
        -3
      ],
      [
        1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -14
      ],
      [
        -1,
        -10
      ],
      [
        -3,
        -20
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -15
      ],
      [
        1,
        -7
      ],
      [
        1,
        -2
      ]
    ],
    [
      [
        25773,
        60781
      ],
      [
        -51,
        88
      ]
    ],
    [
      [
        25722,
        60869
      ],
      [
        2,
        63
      ],
      [
        -7,
        33
      ],
      [
        -4,
        24
      ],
      [
        -9,
        -5
      ],
      [
        -2,
        -9
      ],
      [
        -5,
        10
      ],
      [
        1,
        37
      ],
      [
        4,
        15
      ],
      [
        -4,
        5
      ],
      [
        -3,
        23
      ],
      [
        -3,
        4
      ],
      [
        -8,
        -13
      ],
      [
        -8,
        -1
      ],
      [
        4,
        24
      ],
      [
        -1,
        14
      ]
    ],
    [
      [
        26209,
        60492
      ],
      [
        9,
        -2
      ],
      [
        0,
        103
      ],
      [
        1,
        52
      ]
    ],
    [
      [
        26219,
        60645
      ],
      [
        10,
        4
      ],
      [
        0,
        -17
      ],
      [
        29,
        -2
      ],
      [
        15,
        19
      ]
    ],
    [
      [
        26273,
        60649
      ],
      [
        -3,
        -23
      ],
      [
        -1,
        -72
      ],
      [
        3,
        -46
      ],
      [
        15,
        -43
      ],
      [
        20,
        -35
      ],
      [
        5,
        -71
      ],
      [
        -5,
        -15
      ],
      [
        2,
        -40
      ],
      [
        -1,
        -16
      ]
    ],
    [
      [
        26308,
        60288
      ],
      [
        -25,
        -75
      ],
      [
        -25,
        -67
      ]
    ],
    [
      [
        26258,
        60146
      ],
      [
        -5,
        -11
      ],
      [
        -10,
        -6
      ],
      [
        -5,
        13
      ],
      [
        -20,
        85
      ]
    ],
    [
      [
        26218,
        60227
      ],
      [
        -3,
        12
      ],
      [
        -1,
        71
      ],
      [
        -15,
        29
      ],
      [
        -15,
        33
      ]
    ],
    [
      [
        26184,
        60372
      ],
      [
        9,
        63
      ],
      [
        1,
        23
      ],
      [
        7,
        15
      ],
      [
        5,
        0
      ],
      [
        3,
        19
      ]
    ],
    [
      [
        26311,
        61014
      ],
      [
        14,
        165
      ]
    ],
    [
      [
        26325,
        61179
      ],
      [
        15,
        -17
      ],
      [
        4,
        -3
      ],
      [
        6,
        -11
      ],
      [
        9,
        -16
      ],
      [
        4,
        -7
      ],
      [
        12,
        -20
      ],
      [
        2,
        -21
      ],
      [
        6,
        -15
      ],
      [
        5,
        -48
      ],
      [
        -1,
        -24
      ]
    ],
    [
      [
        26387,
        60997
      ],
      [
        -3,
        -8
      ],
      [
        -8,
        15
      ],
      [
        -3,
        -15
      ],
      [
        7,
        -43
      ],
      [
        -6,
        -2
      ],
      [
        -4,
        -19
      ],
      [
        -8,
        -19
      ]
    ],
    [
      [
        26362,
        60906
      ],
      [
        -3,
        -2
      ],
      [
        0,
        -14
      ],
      [
        -5,
        -7
      ],
      [
        -4,
        -24
      ],
      [
        -5,
        7
      ],
      [
        1,
        18
      ],
      [
        -4,
        3
      ],
      [
        -2,
        -12
      ],
      [
        -3,
        7
      ],
      [
        3,
        9
      ],
      [
        -2,
        12
      ],
      [
        -7,
        8
      ],
      [
        -2,
        17
      ],
      [
        5,
        10
      ],
      [
        5,
        -5
      ],
      [
        -2,
        13
      ],
      [
        -11,
        7
      ],
      [
        0,
        -30
      ],
      [
        -6,
        8
      ],
      [
        0,
        41
      ],
      [
        -5,
        2
      ],
      [
        -6,
        -14
      ]
    ],
    [
      [
        26309,
        60960
      ],
      [
        -2,
        20
      ],
      [
        10,
        25
      ],
      [
        -4,
        7
      ],
      [
        -2,
        2
      ]
    ],
    [
      [
        26993,
        58140
      ],
      [
        6,
        11
      ],
      [
        4,
        -8
      ],
      [
        6,
        9
      ],
      [
        5,
        -8
      ],
      [
        4,
        15
      ],
      [
        6,
        -2
      ],
      [
        6,
        -13
      ],
      [
        14,
        -51
      ],
      [
        0,
        -13
      ],
      [
        6,
        -5
      ],
      [
        8,
        -42
      ],
      [
        8,
        -21
      ],
      [
        1,
        -15
      ],
      [
        8,
        -15
      ],
      [
        1,
        -36
      ],
      [
        -2,
        -17
      ],
      [
        0,
        -29
      ]
    ],
    [
      [
        27074,
        57900
      ],
      [
        -9,
        2
      ],
      [
        -10,
        1
      ],
      [
        -3,
        0
      ],
      [
        -11,
        1
      ],
      [
        -5,
        1
      ],
      [
        -9,
        2
      ],
      [
        -8,
        1
      ],
      [
        -2,
        0
      ],
      [
        -3,
        1
      ],
      [
        -3,
        0
      ],
      [
        -5,
        2
      ]
    ],
    [
      [
        26967,
        57906
      ],
      [
        1,
        42
      ],
      [
        -2,
        19
      ],
      [
        2,
        0
      ],
      [
        1,
        41
      ],
      [
        6,
        34
      ],
      [
        4,
        7
      ],
      [
        2,
        21
      ],
      [
        12,
        70
      ]
    ],
    [
      [
        27004,
        59029
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        1,
        -1
      ],
      [
        2,
        -2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        1,
        -3
      ],
      [
        1,
        -1
      ],
      [
        2,
        -1
      ],
      [
        0,
        -3
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        3,
        0
      ],
      [
        1,
        2
      ],
      [
        3,
        1
      ],
      [
        1,
        -6
      ],
      [
        1,
        -9
      ],
      [
        1,
        -9
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -4
      ],
      [
        2,
        -16
      ],
      [
        1,
        -2
      ],
      [
        4,
        0
      ],
      [
        1,
        3
      ],
      [
        1,
        1
      ],
      [
        2,
        -2
      ],
      [
        0,
        -1
      ],
      [
        4,
        1
      ],
      [
        1,
        -1
      ]
    ],
    [
      [
        27043,
        58969
      ],
      [
        4,
        -47
      ],
      [
        8,
        -67
      ],
      [
        -3,
        1
      ],
      [
        -3,
        -25
      ],
      [
        7,
        -52
      ],
      [
        15,
        -36
      ]
    ],
    [
      [
        27071,
        58743
      ],
      [
        0,
        -30
      ],
      [
        -5,
        -13
      ],
      [
        -4,
        13
      ],
      [
        -10,
        -37
      ],
      [
        -7,
        -6
      ],
      [
        -7,
        4
      ],
      [
        -6,
        -31
      ],
      [
        -3,
        -2
      ]
    ],
    [
      [
        27029,
        58641
      ],
      [
        -3,
        2
      ],
      [
        -2,
        19
      ],
      [
        3,
        1
      ],
      [
        -3,
        58
      ],
      [
        2,
        19
      ],
      [
        -3,
        7
      ],
      [
        0,
        16
      ],
      [
        -4,
        0
      ],
      [
        -8,
        28
      ],
      [
        3,
        10
      ],
      [
        -2,
        10
      ],
      [
        0,
        24
      ],
      [
        -3,
        16
      ],
      [
        3,
        -2
      ],
      [
        -1,
        15
      ],
      [
        -10,
        -2
      ],
      [
        -1,
        -10
      ],
      [
        -5,
        1
      ],
      [
        1,
        -20
      ],
      [
        -6,
        17
      ],
      [
        1,
        16
      ],
      [
        -6,
        13
      ],
      [
        -3,
        20
      ],
      [
        -3,
        -22
      ],
      [
        -7,
        4
      ],
      [
        0,
        27
      ],
      [
        -4,
        37
      ],
      [
        -8,
        -16
      ],
      [
        -5,
        13
      ],
      [
        0,
        -12
      ],
      [
        -5,
        1
      ]
    ],
    [
      [
        26950,
        58931
      ],
      [
        2,
        12
      ],
      [
        1,
        5
      ],
      [
        4,
        11
      ],
      [
        3,
        3
      ],
      [
        0,
        4
      ],
      [
        1,
        3
      ],
      [
        1,
        1
      ],
      [
        2,
        2
      ],
      [
        1,
        3
      ],
      [
        0,
        1
      ],
      [
        2,
        5
      ],
      [
        1,
        2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        3,
        0
      ],
      [
        1,
        2
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        3,
        7
      ],
      [
        0,
        2
      ],
      [
        1,
        3
      ],
      [
        2,
        3
      ],
      [
        2,
        2
      ],
      [
        3,
        -8
      ],
      [
        2,
        1
      ],
      [
        0,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        1
      ],
      [
        0,
        3
      ],
      [
        1,
        4
      ],
      [
        2,
        0
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        3
      ],
      [
        1,
        2
      ],
      [
        0,
        3
      ],
      [
        2,
        6
      ],
      [
        1,
        4
      ],
      [
        1,
        6
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        28650,
        59487
      ],
      [
        53,
        0
      ]
    ],
    [
      [
        28703,
        59487
      ],
      [
        72,
        0
      ]
    ],
    [
      [
        28775,
        59487
      ],
      [
        2,
        -58
      ],
      [
        6,
        -91
      ],
      [
        5,
        -75
      ],
      [
        6,
        -79
      ],
      [
        7,
        -68
      ]
    ],
    [
      [
        28801,
        59116
      ],
      [
        -6,
        -5
      ]
    ],
    [
      [
        28795,
        59111
      ],
      [
        -1,
        4
      ],
      [
        -2,
        6
      ],
      [
        -2,
        9
      ],
      [
        0,
        5
      ],
      [
        1,
        14
      ],
      [
        -2,
        30
      ],
      [
        -2,
        7
      ],
      [
        -3,
        1
      ],
      [
        -1,
        2
      ],
      [
        -2,
        13
      ],
      [
        1,
        27
      ],
      [
        2,
        12
      ],
      [
        0,
        9
      ],
      [
        -1,
        19
      ],
      [
        -2,
        9
      ],
      [
        -1,
        2
      ],
      [
        -1,
        8
      ],
      [
        0,
        42
      ],
      [
        -4,
        18
      ],
      [
        -4,
        6
      ],
      [
        -2,
        6
      ],
      [
        -1,
        22
      ],
      [
        -3,
        26
      ],
      [
        -2,
        4
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        0
      ],
      [
        -3,
        9
      ],
      [
        -6,
        6
      ],
      [
        -4,
        -1
      ],
      [
        -1,
        -10
      ],
      [
        -4,
        9
      ],
      [
        3,
        22
      ],
      [
        -2,
        15
      ],
      [
        -2,
        3
      ],
      [
        -8,
        -1
      ],
      [
        -1,
        -12
      ],
      [
        -4,
        -7
      ],
      [
        3,
        -33
      ],
      [
        3,
        -28
      ],
      [
        2,
        -13
      ],
      [
        2,
        -6
      ],
      [
        4,
        -6
      ],
      [
        3,
        -2
      ],
      [
        5,
        -21
      ],
      [
        6,
        2
      ],
      [
        1,
        5
      ],
      [
        1,
        5
      ],
      [
        1,
        1
      ],
      [
        2,
        -3
      ],
      [
        2,
        -43
      ],
      [
        0,
        -7
      ],
      [
        -2,
        -17
      ],
      [
        0,
        -7
      ],
      [
        1,
        -10
      ],
      [
        1,
        -1
      ],
      [
        6,
        -39
      ],
      [
        2,
        -30
      ],
      [
        1,
        -10
      ],
      [
        3,
        -2
      ],
      [
        2,
        2
      ],
      [
        1,
        -5
      ],
      [
        0,
        -17
      ],
      [
        -2,
        -16
      ],
      [
        1,
        -19
      ],
      [
        2,
        -15
      ],
      [
        3,
        -8
      ],
      [
        3,
        -19
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -19
      ],
      [
        5,
        -22
      ],
      [
        0,
        -15
      ],
      [
        2,
        -10
      ],
      [
        4,
        -28
      ],
      [
        3,
        -36
      ],
      [
        -1,
        -12
      ],
      [
        -2,
        1
      ],
      [
        -10,
        23
      ],
      [
        -3,
        11
      ],
      [
        -6,
        30
      ],
      [
        1,
        16
      ],
      [
        0,
        21
      ],
      [
        -5,
        32
      ],
      [
        -8,
        29
      ],
      [
        -3,
        38
      ],
      [
        -8,
        16
      ],
      [
        -2,
        -3
      ]
    ],
    [
      [
        28749,
        59144
      ],
      [
        -1,
        15
      ],
      [
        4,
        6
      ],
      [
        0,
        13
      ],
      [
        -5,
        4
      ],
      [
        -1,
        21
      ],
      [
        -7,
        3
      ],
      [
        -4,
        23
      ],
      [
        -3,
        5
      ],
      [
        1,
        13
      ],
      [
        -4,
        -7
      ],
      [
        1,
        12
      ],
      [
        -7,
        13
      ],
      [
        -3,
        -14
      ],
      [
        -4,
        -1
      ],
      [
        -10,
        13
      ],
      [
        -2,
        15
      ],
      [
        -8,
        28
      ],
      [
        -2,
        4
      ],
      [
        -1,
        31
      ],
      [
        -43,
        146
      ]
    ],
    [
      [
        27454,
        60295
      ],
      [
        9,
        14
      ],
      [
        15,
        14
      ],
      [
        12,
        19
      ],
      [
        3,
        10
      ],
      [
        10,
        27
      ]
    ],
    [
      [
        27503,
        60379
      ],
      [
        22,
        38
      ],
      [
        8,
        23
      ],
      [
        17,
        -32
      ]
    ],
    [
      [
        27550,
        60408
      ],
      [
        1,
        -38
      ],
      [
        6,
        -26
      ],
      [
        9,
        -45
      ],
      [
        4,
        -17
      ],
      [
        4,
        -117
      ],
      [
        -1,
        -23
      ]
    ],
    [
      [
        27573,
        60142
      ],
      [
        -26,
        -36
      ],
      [
        -3,
        -4
      ],
      [
        -18,
        -66
      ],
      [
        -11,
        0
      ],
      [
        -5,
        -9
      ],
      [
        -2,
        9
      ],
      [
        0,
        -22
      ],
      [
        -6,
        16
      ],
      [
        -8,
        -7
      ],
      [
        -2,
        -20
      ],
      [
        -4,
        6
      ],
      [
        0,
        -12
      ],
      [
        -5,
        4
      ],
      [
        -4,
        22
      ],
      [
        -1,
        -16
      ],
      [
        -6,
        -14
      ]
    ],
    [
      [
        28342,
        60531
      ],
      [
        -4,
        12
      ],
      [
        -5,
        4
      ],
      [
        -2,
        4
      ],
      [
        -8,
        -6
      ],
      [
        0,
        -4
      ],
      [
        -4,
        10
      ],
      [
        -1,
        4
      ],
      [
        -5,
        36
      ],
      [
        0,
        4
      ],
      [
        -1,
        15
      ],
      [
        0,
        20
      ],
      [
        -5,
        -5
      ],
      [
        -3,
        18
      ],
      [
        -11,
        -10
      ],
      [
        0,
        24
      ]
    ],
    [
      [
        16977,
        71347
      ],
      [
        -10,
        -5
      ],
      [
        8,
        -64
      ],
      [
        -3,
        -26
      ],
      [
        8,
        -38
      ],
      [
        -4,
        -41
      ]
    ],
    [
      [
        16976,
        71173
      ],
      [
        -4,
        5
      ]
    ],
    [
      [
        16972,
        71178
      ],
      [
        -4,
        8
      ],
      [
        -8,
        -8
      ],
      [
        -9,
        14
      ],
      [
        -5,
        1
      ],
      [
        -11,
        -10
      ],
      [
        -8,
        -20
      ],
      [
        -9,
        4
      ],
      [
        -8,
        15
      ],
      [
        -5,
        0
      ],
      [
        -7,
        -25
      ],
      [
        -9,
        -9
      ],
      [
        -6,
        -14
      ],
      [
        -4,
        -24
      ],
      [
        -8,
        -11
      ],
      [
        -6,
        -25
      ],
      [
        -1,
        -35
      ],
      [
        -4,
        -23
      ],
      [
        -2,
        -24
      ],
      [
        1,
        -23
      ],
      [
        -7,
        -13
      ],
      [
        -2,
        -16
      ],
      [
        -7,
        -9
      ],
      [
        -3,
        -25
      ],
      [
        -12,
        0
      ],
      [
        -4,
        -41
      ],
      [
        -4,
        -9
      ],
      [
        2,
        -22
      ],
      [
        -17,
        -19
      ],
      [
        -10,
        -35
      ],
      [
        -30,
        -15
      ],
      [
        -14,
        -26
      ],
      [
        -2,
        -10
      ],
      [
        -3,
        -18
      ]
    ],
    [
      [
        16746,
        70711
      ],
      [
        -2,
        4
      ],
      [
        -16,
        26
      ],
      [
        -5,
        7
      ],
      [
        -10,
        3
      ],
      [
        -12,
        10
      ],
      [
        -10,
        31
      ],
      [
        -7,
        13
      ],
      [
        -1,
        13
      ],
      [
        5,
        36
      ],
      [
        -2,
        35
      ],
      [
        -4,
        29
      ],
      [
        1,
        38
      ],
      [
        2,
        38
      ],
      [
        -1,
        53
      ],
      [
        1,
        18
      ],
      [
        -3,
        26
      ],
      [
        -10,
        24
      ],
      [
        -6,
        28
      ],
      [
        -11,
        22
      ],
      [
        -10,
        36
      ],
      [
        -3,
        46
      ],
      [
        -11,
        20
      ],
      [
        0,
        11
      ]
    ],
    [
      [
        31446,
        38277
      ],
      [
        6,
        3
      ],
      [
        7,
        -9
      ],
      [
        4,
        11
      ],
      [
        4,
        -21
      ]
    ],
    [
      [
        31467,
        38261
      ],
      [
        -3,
        -11
      ],
      [
        2,
        -35
      ]
    ],
    [
      [
        22569,
        56856
      ],
      [
        44,
        -1
      ],
      [
        117,
        0
      ]
    ],
    [
      [
        22731,
        56601
      ],
      [
        0,
        -79
      ],
      [
        6,
        -23
      ],
      [
        -7,
        1
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        22730,
        56399
      ],
      [
        -6,
        4
      ],
      [
        -1,
        2
      ],
      [
        0,
        1
      ],
      [
        -2,
        12
      ],
      [
        -1,
        5
      ],
      [
        0,
        2
      ],
      [
        1,
        3
      ],
      [
        0,
        1
      ],
      [
        1,
        6
      ],
      [
        1,
        27
      ],
      [
        0,
        2
      ],
      [
        -6,
        17
      ],
      [
        -7,
        15
      ],
      [
        -6,
        10
      ],
      [
        -2,
        2
      ],
      [
        -2,
        0
      ],
      [
        -5,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -16
      ],
      [
        -2,
        -10
      ],
      [
        -2,
        -9
      ],
      [
        -2,
        -7
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -4,
        0
      ],
      [
        -3,
        -3
      ],
      [
        0,
        -4
      ],
      [
        1,
        -7
      ],
      [
        0,
        -9
      ],
      [
        -1,
        -4
      ],
      [
        -3,
        1
      ],
      [
        -3,
        -5
      ],
      [
        1,
        -7
      ],
      [
        1,
        -6
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        -5,
        -6
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -4
      ],
      [
        -8,
        -22
      ],
      [
        -8,
        -10
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        2
      ],
      [
        -5,
        9
      ],
      [
        -3,
        6
      ],
      [
        -8,
        19
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        1
      ],
      [
        -3,
        3
      ],
      [
        -2,
        5
      ],
      [
        -1,
        4
      ]
    ],
    [
      [
        22614,
        56390
      ],
      [
        -1,
        9
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        4
      ],
      [
        1,
        8
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        -5
      ],
      [
        1,
        -2
      ],
      [
        1,
        1
      ],
      [
        1,
        4
      ],
      [
        1,
        5
      ],
      [
        1,
        11
      ],
      [
        0,
        16
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        3
      ],
      [
        0,
        3
      ],
      [
        1,
        2
      ],
      [
        2,
        3
      ],
      [
        1,
        5
      ],
      [
        1,
        8
      ],
      [
        3,
        35
      ],
      [
        0,
        3
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -2,
        4
      ],
      [
        -1,
        7
      ],
      [
        -1,
        6
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -5,
        -4
      ],
      [
        -4,
        -3
      ],
      [
        -6,
        0
      ],
      [
        -4,
        2
      ],
      [
        -8,
        8
      ],
      [
        -1,
        1
      ],
      [
        0,
        3
      ],
      [
        -5,
        27
      ],
      [
        0,
        8
      ],
      [
        1,
        2
      ],
      [
        1,
        1
      ],
      [
        0,
        12
      ],
      [
        -5,
        16
      ],
      [
        -1,
        5
      ],
      [
        0,
        6
      ],
      [
        -1,
        11
      ],
      [
        1,
        4
      ],
      [
        4,
        16
      ],
      [
        1,
        7
      ],
      [
        2,
        8
      ],
      [
        0,
        6
      ],
      [
        1,
        6
      ],
      [
        0,
        10
      ],
      [
        -3,
        19
      ],
      [
        -2,
        7
      ],
      [
        0,
        2
      ],
      [
        -4,
        0
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -6
      ],
      [
        -1,
        -4
      ]
    ],
    [
      [
        27070,
        59438
      ],
      [
        6,
        27
      ],
      [
        9,
        24
      ],
      [
        1,
        18
      ],
      [
        15,
        24
      ],
      [
        1,
        16
      ],
      [
        12,
        14
      ]
    ],
    [
      [
        27114,
        59561
      ],
      [
        25,
        -2
      ],
      [
        25,
        0
      ]
    ],
    [
      [
        27164,
        59559
      ],
      [
        -8,
        -28
      ]
    ],
    [
      [
        27156,
        59531
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -8
      ],
      [
        1,
        -5
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        1
      ],
      [
        0,
        -19
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -4
      ],
      [
        -2,
        0
      ],
      [
        0,
        -12
      ],
      [
        2,
        -7
      ],
      [
        0,
        -7
      ],
      [
        1,
        -2
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        1,
        -2
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -11
      ],
      [
        1,
        -1
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -28
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -7
      ],
      [
        -3,
        -8
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -6
      ],
      [
        1,
        -5
      ],
      [
        1,
        -3
      ],
      [
        1,
        -3
      ],
      [
        0,
        -2
      ]
    ],
    [
      [
        27141,
        59301
      ],
      [
        0,
        -9
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        1,
        -3
      ],
      [
        1,
        -6
      ],
      [
        1,
        -6
      ],
      [
        0,
        -11
      ],
      [
        1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        2,
        -1
      ],
      [
        1,
        -4
      ],
      [
        1,
        -5
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        3
      ],
      [
        -1,
        3
      ],
      [
        -2,
        2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        3
      ],
      [
        -2,
        7
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        -1,
        4
      ],
      [
        0,
        3
      ],
      [
        -1,
        4
      ],
      [
        -2,
        0
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        -3,
        -3
      ],
      [
        -3,
        -1
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -5
      ],
      [
        -3,
        -13
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -6
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -3,
        -6
      ],
      [
        -2,
        -17
      ]
    ],
    [
      [
        27089,
        59181
      ],
      [
        -4,
        -26
      ]
    ],
    [
      [
        27085,
        59155
      ],
      [
        -6,
        -4
      ],
      [
        -8,
        31
      ],
      [
        -2,
        32
      ],
      [
        -4,
        20
      ],
      [
        -8,
        1
      ],
      [
        -3,
        34
      ],
      [
        -5,
        5
      ],
      [
        8,
        26
      ],
      [
        18,
        85
      ],
      [
        5,
        11
      ],
      [
        -10,
        42
      ]
    ],
    [
      [
        26225,
        58159
      ],
      [
        11,
        35
      ],
      [
        -2,
        31
      ],
      [
        2,
        4
      ],
      [
        3,
        -3
      ],
      [
        1,
        -17
      ],
      [
        5,
        -15
      ],
      [
        5,
        -3
      ],
      [
        5,
        7
      ],
      [
        2,
        15
      ],
      [
        0,
        19
      ],
      [
        2,
        13
      ],
      [
        6,
        5
      ],
      [
        4,
        11
      ],
      [
        -1,
        21
      ],
      [
        -4,
        12
      ],
      [
        -1,
        16
      ],
      [
        2,
        13
      ],
      [
        5,
        4
      ],
      [
        11,
        -10
      ],
      [
        6,
        9
      ],
      [
        -3,
        18
      ],
      [
        -1,
        16
      ],
      [
        8,
        15
      ],
      [
        1,
        21
      ],
      [
        -2,
        23
      ],
      [
        2,
        14
      ],
      [
        -1,
        34
      ],
      [
        4,
        30
      ],
      [
        4,
        -1
      ],
      [
        0,
        -22
      ],
      [
        3,
        -1
      ],
      [
        5,
        12
      ],
      [
        0,
        20
      ],
      [
        3,
        21
      ],
      [
        -3,
        33
      ]
    ],
    [
      [
        26307,
        58559
      ],
      [
        1,
        -1
      ],
      [
        2,
        -12
      ],
      [
        4,
        0
      ],
      [
        0,
        -28
      ],
      [
        6,
        0
      ],
      [
        1,
        -17
      ],
      [
        10,
        24
      ],
      [
        5,
        -19
      ],
      [
        -2,
        -20
      ],
      [
        0,
        -33
      ],
      [
        2,
        -20
      ]
    ],
    [
      [
        26336,
        58433
      ],
      [
        -6,
        -22
      ],
      [
        -7,
        -43
      ],
      [
        -7,
        -13
      ],
      [
        0,
        -19
      ],
      [
        -9,
        -47
      ],
      [
        -7,
        -12
      ],
      [
        -8,
        -53
      ],
      [
        -7,
        -12
      ],
      [
        0,
        -21
      ],
      [
        -3,
        0
      ],
      [
        -10,
        -74
      ],
      [
        -3,
        -27
      ]
    ],
    [
      [
        26269,
        58090
      ],
      [
        -5,
        9
      ],
      [
        -2,
        -34
      ],
      [
        -12,
        -46
      ],
      [
        -5,
        -2
      ]
    ],
    [
      [
        26245,
        58017
      ],
      [
        -5,
        27
      ],
      [
        -4,
        61
      ],
      [
        -8,
        23
      ],
      [
        -7,
        -4
      ],
      [
        4,
        35
      ]
    ],
    [
      [
        22350,
        68083
      ],
      [
        33,
        0
      ]
    ],
    [
      [
        22387,
        67576
      ],
      [
        -140,
        1
      ]
    ],
    [
      [
        22863,
        54830
      ],
      [
        7,
        -1
      ],
      [
        6,
        0
      ]
    ],
    [
      [
        22876,
        54829
      ],
      [
        7,
        -1
      ],
      [
        135,
        -3
      ]
    ],
    [
      [
        23018,
        54825
      ],
      [
        2,
        -16
      ],
      [
        5,
        -5
      ],
      [
        0,
        -19
      ],
      [
        -2,
        3
      ],
      [
        0,
        -37
      ],
      [
        5,
        -16
      ],
      [
        5,
        -39
      ],
      [
        7,
        -15
      ],
      [
        4,
        -12
      ],
      [
        -1,
        -13
      ],
      [
        1,
        -13
      ],
      [
        -5,
        -35
      ]
    ],
    [
      [
        23039,
        54608
      ],
      [
        1,
        -16
      ],
      [
        4,
        0
      ],
      [
        8,
        -19
      ],
      [
        7,
        0
      ]
    ],
    [
      [
        23059,
        54573
      ],
      [
        -4,
        -6
      ],
      [
        -139,
        -291
      ]
    ],
    [
      [
        22863,
        54499
      ],
      [
        0,
        331
      ]
    ],
    [
      [
        22614,
        56390
      ],
      [
        0,
        -492
      ]
    ],
    [
      [
        22491,
        55898
      ],
      [
        -1,
        429
      ]
    ],
    [
      [
        22490,
        56327
      ],
      [
        0,
        289
      ]
    ],
    [
      [
        27780,
        60729
      ],
      [
        5,
        10
      ],
      [
        5,
        0
      ],
      [
        6,
        20
      ],
      [
        4,
        3
      ],
      [
        5,
        17
      ],
      [
        2,
        21
      ],
      [
        5,
        17
      ],
      [
        4,
        48
      ],
      [
        12,
        71
      ],
      [
        9,
        21
      ],
      [
        6,
        -28
      ],
      [
        3,
        -1
      ],
      [
        8,
        17
      ]
    ],
    [
      [
        27854,
        60945
      ],
      [
        9,
        13
      ],
      [
        5,
        -13
      ],
      [
        3,
        -21
      ],
      [
        6,
        4
      ],
      [
        5,
        -12
      ],
      [
        1,
        -37
      ],
      [
        0,
        -30
      ],
      [
        10,
        -21
      ],
      [
        5,
        3
      ],
      [
        2,
        -9
      ],
      [
        6,
        -2
      ],
      [
        0,
        -15
      ],
      [
        7,
        -31
      ],
      [
        17,
        -130
      ],
      [
        8,
        -3
      ]
    ],
    [
      [
        27896,
        60510
      ],
      [
        -6,
        5
      ],
      [
        -1,
        -20
      ],
      [
        -7,
        6
      ],
      [
        3,
        -36
      ],
      [
        -2,
        -5
      ],
      [
        -5,
        10
      ]
    ],
    [
      [
        27878,
        60470
      ],
      [
        -7,
        14
      ],
      [
        -3,
        -10
      ],
      [
        -7,
        35
      ],
      [
        -6,
        16
      ],
      [
        -5,
        20
      ],
      [
        0,
        8
      ]
    ],
    [
      [
        27850,
        60553
      ],
      [
        -1,
        11
      ],
      [
        -6,
        2
      ],
      [
        -4,
        20
      ],
      [
        0,
        14
      ],
      [
        -4,
        -1
      ],
      [
        -5,
        -13
      ],
      [
        -1,
        16
      ],
      [
        -10,
        -8
      ],
      [
        -5,
        10
      ],
      [
        -6,
        6
      ],
      [
        -3,
        10
      ],
      [
        -6,
        32
      ],
      [
        -3,
        46
      ],
      [
        -7,
        20
      ],
      [
        -6,
        -8
      ],
      [
        -3,
        5
      ],
      [
        0,
        14
      ]
    ],
    [
      [
        20101,
        61123
      ],
      [
        3,
        16
      ],
      [
        6,
        6
      ],
      [
        6,
        -24
      ],
      [
        7,
        16
      ],
      [
        7,
        -1
      ],
      [
        4,
        -7
      ],
      [
        0,
        -13
      ],
      [
        9,
        -36
      ],
      [
        13,
        -6
      ],
      [
        8,
        -33
      ],
      [
        5,
        -5
      ],
      [
        5,
        8
      ],
      [
        6,
        -19
      ],
      [
        6,
        2
      ],
      [
        0,
        -44
      ]
    ],
    [
      [
        20065,
        60503
      ],
      [
        1,
        293
      ],
      [
        -6,
        1
      ],
      [
        2,
        178
      ],
      [
        0,
        128
      ],
      [
        8,
        6
      ],
      [
        2,
        13
      ],
      [
        2,
        -7
      ],
      [
        8,
        14
      ],
      [
        7,
        -14
      ],
      [
        5,
        6
      ],
      [
        4,
        -9
      ],
      [
        3,
        11
      ]
    ],
    [
      [
        26945,
        55077
      ],
      [
        10,
        18
      ],
      [
        -6,
        39
      ],
      [
        16,
        6
      ],
      [
        2,
        13
      ],
      [
        10,
        15
      ],
      [
        1,
        -5
      ]
    ],
    [
      [
        26978,
        55163
      ],
      [
        4,
        -10
      ],
      [
        12,
        -4
      ],
      [
        12,
        -23
      ],
      [
        16,
        14
      ],
      [
        3,
        -4
      ]
    ],
    [
      [
        27025,
        55136
      ],
      [
        18,
        -174
      ],
      [
        23,
        -65
      ]
    ],
    [
      [
        27066,
        54897
      ],
      [
        -8,
        -61
      ],
      [
        -1,
        -19
      ]
    ],
    [
      [
        27057,
        54817
      ],
      [
        -13,
        25
      ],
      [
        -19,
        -46
      ],
      [
        -10,
        -54
      ],
      [
        0,
        -16
      ],
      [
        -1,
        -31
      ],
      [
        -19,
        -96
      ],
      [
        3,
        -5
      ],
      [
        3,
        -33
      ]
    ],
    [
      [
        27001,
        54561
      ],
      [
        -13,
        -28
      ],
      [
        -21,
        -3
      ],
      [
        0,
        25
      ],
      [
        -7,
        27
      ],
      [
        -3,
        -2
      ],
      [
        -5,
        22
      ]
    ],
    [
      [
        26952,
        54602
      ],
      [
        -1,
        13
      ],
      [
        4,
        26
      ],
      [
        1,
        28
      ],
      [
        3,
        34
      ],
      [
        -4,
        13
      ],
      [
        -8,
        12
      ],
      [
        -17,
        35
      ],
      [
        -1,
        5
      ],
      [
        -7,
        4
      ],
      [
        -5,
        -3
      ],
      [
        -8,
        10
      ],
      [
        -15,
        -1
      ],
      [
        -9,
        9
      ]
    ],
    [
      [
        26885,
        54787
      ],
      [
        7,
        10
      ],
      [
        6,
        0
      ],
      [
        0,
        -14
      ],
      [
        1,
        27
      ],
      [
        4,
        -8
      ],
      [
        6,
        8
      ],
      [
        -7,
        27
      ],
      [
        -2,
        27
      ],
      [
        17,
        40
      ],
      [
        6,
        14
      ],
      [
        -1,
        10
      ],
      [
        5,
        10
      ],
      [
        2,
        -10
      ],
      [
        8,
        16
      ],
      [
        -8,
        17
      ],
      [
        -2,
        26
      ],
      [
        8,
        30
      ],
      [
        5,
        10
      ],
      [
        0,
        11
      ],
      [
        5,
        39
      ]
    ],
    [
      [
        24948,
        63645
      ],
      [
        -5,
        16
      ],
      [
        -4,
        20
      ],
      [
        -14,
        2
      ],
      [
        -3,
        -16
      ],
      [
        -4,
        6
      ],
      [
        -11,
        -23
      ],
      [
        -7,
        6
      ],
      [
        -6,
        -9
      ],
      [
        -10,
        -1
      ],
      [
        -3,
        8
      ],
      [
        -7,
        0
      ],
      [
        -1,
        8
      ],
      [
        -8,
        -11
      ],
      [
        -7,
        15
      ],
      [
        -3,
        -9
      ],
      [
        -7,
        2
      ],
      [
        -3,
        9
      ],
      [
        -3,
        -32
      ],
      [
        -4,
        -7
      ]
    ],
    [
      [
        24838,
        63629
      ],
      [
        -5,
        -9
      ],
      [
        -14,
        0
      ],
      [
        -8,
        -27
      ],
      [
        -9,
        -1
      ],
      [
        -2,
        -17
      ],
      [
        -15,
        1
      ],
      [
        -3,
        -12
      ],
      [
        -4,
        8
      ],
      [
        -4,
        -5
      ],
      [
        -11,
        8
      ],
      [
        -6,
        -8
      ],
      [
        -1,
        17
      ],
      [
        -4,
        9
      ],
      [
        1,
        18
      ],
      [
        -4,
        27
      ],
      [
        -11,
        9
      ]
    ],
    [
      [
        24738,
        63647
      ],
      [
        5,
        14
      ],
      [
        8,
        4
      ],
      [
        11,
        18
      ],
      [
        15,
        -5
      ],
      [
        3,
        6
      ],
      [
        1,
        33
      ]
    ],
    [
      [
        23016,
        66889
      ],
      [
        156,
        1
      ],
      [
        33,
        -1
      ]
    ],
    [
      [
        23205,
        66889
      ],
      [
        -1,
        -406
      ]
    ],
    [
      [
        23026,
        66484
      ],
      [
        3,
        11
      ],
      [
        1,
        2
      ],
      [
        0,
        4
      ],
      [
        -2,
        1
      ],
      [
        -1,
        3
      ],
      [
        0,
        4
      ],
      [
        1,
        2
      ],
      [
        0,
        2
      ],
      [
        -1,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        6
      ],
      [
        -1,
        13
      ],
      [
        -2,
        9
      ],
      [
        -1,
        14
      ],
      [
        0,
        7
      ],
      [
        -3,
        12
      ],
      [
        -2,
        3
      ],
      [
        -1,
        3
      ],
      [
        -1,
        2
      ],
      [
        1,
        5
      ],
      [
        0,
        4
      ],
      [
        -2,
        6
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        -4,
        9
      ],
      [
        -2,
        8
      ],
      [
        -2,
        7
      ],
      [
        -3,
        6
      ],
      [
        -1,
        1
      ],
      [
        -2,
        0
      ],
      [
        -4,
        7
      ],
      [
        -2,
        7
      ],
      [
        -3,
        6
      ],
      [
        0,
        4
      ],
      [
        1,
        1
      ],
      [
        0,
        19
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        11
      ],
      [
        0,
        3
      ],
      [
        1,
        4
      ],
      [
        1,
        6
      ],
      [
        1,
        5
      ],
      [
        0,
        9
      ],
      [
        -1,
        4
      ],
      [
        0,
        11
      ],
      [
        1,
        0
      ],
      [
        1,
        3
      ],
      [
        1,
        7
      ],
      [
        1,
        5
      ],
      [
        1,
        2
      ],
      [
        3,
        -3
      ],
      [
        0,
        6
      ],
      [
        3,
        6
      ],
      [
        0,
        9
      ],
      [
        1,
        9
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        6
      ],
      [
        2,
        0
      ],
      [
        1,
        3
      ],
      [
        1,
        1
      ],
      [
        1,
        10
      ],
      [
        0,
        1
      ],
      [
        -1,
        6
      ],
      [
        0,
        5
      ],
      [
        1,
        0
      ],
      [
        2,
        -1
      ],
      [
        3,
        -1
      ],
      [
        0,
        4
      ],
      [
        1,
        0
      ],
      [
        2,
        3
      ],
      [
        -1,
        2
      ],
      [
        0,
        4
      ],
      [
        1,
        0
      ],
      [
        1,
        3
      ],
      [
        1,
        2
      ],
      [
        -1,
        7
      ],
      [
        -1,
        7
      ],
      [
        0,
        8
      ],
      [
        1,
        4
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        2,
        4
      ],
      [
        -1,
        9
      ],
      [
        0,
        4
      ],
      [
        1,
        2
      ],
      [
        2,
        -1
      ],
      [
        1,
        2
      ],
      [
        0,
        2
      ],
      [
        -1,
        5
      ],
      [
        -2,
        3
      ],
      [
        0,
        10
      ]
    ],
    [
      [
        22662,
        60865
      ],
      [
        30,
        1
      ],
      [
        0,
        105
      ],
      [
        -1,
        5
      ],
      [
        0,
        95
      ]
    ],
    [
      [
        22691,
        61071
      ],
      [
        4,
        2
      ],
      [
        118,
        -1
      ],
      [
        31,
        1
      ]
    ],
    [
      [
        22844,
        61073
      ],
      [
        0,
        -509
      ]
    ],
    [
      [
        22844,
        60564
      ],
      [
        -35,
        0
      ],
      [
        -20,
        2
      ],
      [
        -46,
        -2
      ],
      [
        -81,
        -2
      ]
    ],
    [
      [
        22662,
        60562
      ],
      [
        0,
        303
      ]
    ],
    [
      [
        26143,
        61748
      ],
      [
        9,
        4
      ],
      [
        8,
        33
      ],
      [
        23,
        71
      ]
    ],
    [
      [
        26209,
        61869
      ],
      [
        0,
        -21
      ],
      [
        4,
        -17
      ],
      [
        5,
        12
      ],
      [
        9,
        -15
      ],
      [
        2,
        -11
      ],
      [
        -7,
        -48
      ],
      [
        3,
        -7
      ],
      [
        3,
        11
      ],
      [
        6,
        5
      ],
      [
        2,
        -6
      ],
      [
        -4,
        -21
      ],
      [
        1,
        -9
      ],
      [
        9,
        -16
      ],
      [
        1,
        -20
      ],
      [
        -3,
        -22
      ],
      [
        4,
        -13
      ],
      [
        3,
        1
      ],
      [
        0,
        27
      ],
      [
        5,
        16
      ],
      [
        2,
        -5
      ],
      [
        1,
        -12
      ],
      [
        -4,
        -9
      ],
      [
        0,
        -13
      ],
      [
        8,
        -7
      ],
      [
        4,
        -10
      ],
      [
        -4,
        -31
      ],
      [
        0,
        -17
      ],
      [
        8,
        -7
      ],
      [
        -1,
        -14
      ]
    ],
    [
      [
        26151,
        61591
      ],
      [
        -12,
        54
      ],
      [
        -1,
        45
      ],
      [
        -4,
        19
      ],
      [
        9,
        39
      ]
    ],
    [
      [
        24765,
        52052
      ],
      [
        -4,
        -65
      ],
      [
        -2,
        -68
      ],
      [
        0,
        -94
      ],
      [
        3,
        -74
      ],
      [
        7,
        -28
      ],
      [
        1,
        -22
      ],
      [
        19,
        -40
      ],
      [
        1,
        -10
      ],
      [
        -9,
        -79
      ],
      [
        -8,
        -69
      ]
    ],
    [
      [
        24773,
        51503
      ],
      [
        -32,
        2
      ],
      [
        -2,
        3
      ],
      [
        -3,
        13
      ],
      [
        0,
        35
      ],
      [
        -2,
        11
      ],
      [
        -1,
        15
      ],
      [
        -9,
        17
      ],
      [
        -7,
        3
      ],
      [
        -10,
        31
      ],
      [
        -3,
        11
      ],
      [
        0,
        14
      ],
      [
        -1,
        26
      ],
      [
        -5,
        21
      ],
      [
        -5,
        0
      ],
      [
        -4,
        23
      ]
    ],
    [
      [
        24689,
        51728
      ],
      [
        0,
        97
      ],
      [
        -5,
        0
      ],
      [
        0,
        40
      ],
      [
        3,
        13
      ],
      [
        17,
        26
      ],
      [
        3,
        -5
      ],
      [
        5,
        2
      ],
      [
        12,
        58
      ],
      [
        16,
        43
      ],
      [
        6,
        35
      ],
      [
        19,
        15
      ]
    ],
    [
      [
        25554,
        57450
      ],
      [
        -2,
        -31
      ],
      [
        5,
        -7
      ],
      [
        -5,
        -36
      ],
      [
        2,
        -32
      ],
      [
        -7,
        -15
      ],
      [
        0,
        -16
      ],
      [
        2,
        -25
      ],
      [
        -4,
        -20
      ],
      [
        -7,
        5
      ],
      [
        2,
        -12
      ],
      [
        -6,
        -14
      ],
      [
        -4,
        -36
      ],
      [
        1,
        -10
      ],
      [
        -3,
        -11
      ],
      [
        1,
        -13
      ],
      [
        -4,
        1
      ]
    ],
    [
      [
        25525,
        57178
      ],
      [
        -30,
        3
      ],
      [
        -140,
        14
      ]
    ],
    [
      [
        25355,
        57195
      ],
      [
        0,
        7
      ],
      [
        1,
        2
      ],
      [
        1,
        39
      ],
      [
        3,
        85
      ],
      [
        1,
        33
      ],
      [
        1,
        26
      ],
      [
        2,
        76
      ],
      [
        3,
        94
      ]
    ],
    [
      [
        18336,
        54778
      ],
      [
        63,
        0
      ],
      [
        252,
        2
      ]
    ],
    [
      [
        18651,
        54780
      ],
      [
        177,
        0
      ],
      [
        60,
        -6
      ],
      [
        54,
        0
      ],
      [
        0,
        11
      ],
      [
        84,
        0
      ],
      [
        3,
        3
      ],
      [
        110,
        0
      ]
    ],
    [
      [
        19139,
        54788
      ],
      [
        0,
        -100
      ]
    ],
    [
      [
        19139,
        54688
      ],
      [
        0,
        -202
      ],
      [
        1,
        -5
      ],
      [
        -1,
        -604
      ]
    ],
    [
      [
        18884,
        53522
      ],
      [
        -54,
        72
      ],
      [
        -17,
        23
      ],
      [
        -100,
        132
      ],
      [
        -74,
        97
      ],
      [
        -33,
        43
      ],
      [
        -3,
        3
      ],
      [
        -7,
        9
      ],
      [
        -130,
        167
      ],
      [
        -72,
        90
      ],
      [
        -25,
        35
      ],
      [
        -33,
        42
      ]
    ],
    [
      [
        18336,
        54235
      ],
      [
        0,
        543
      ]
    ],
    [
      [
        19405,
        56114
      ],
      [
        4,
        2
      ],
      [
        1,
        43
      ],
      [
        5,
        6
      ],
      [
        5,
        19
      ],
      [
        9,
        -5
      ],
      [
        9,
        19
      ],
      [
        7,
        0
      ],
      [
        -3,
        16
      ],
      [
        0,
        16
      ],
      [
        5,
        29
      ],
      [
        83,
        1
      ]
    ],
    [
      [
        19530,
        56260
      ],
      [
        0,
        -429
      ],
      [
        1,
        -40
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -191
      ]
    ],
    [
      [
        19530,
        55096
      ],
      [
        0,
        -410
      ]
    ],
    [
      [
        19530,
        54686
      ],
      [
        -18,
        0
      ]
    ],
    [
      [
        19512,
        54686
      ],
      [
        -31,
        120
      ],
      [
        0,
        16
      ],
      [
        4,
        48
      ],
      [
        -3,
        21
      ],
      [
        4,
        39
      ],
      [
        -2,
        21
      ],
      [
        0,
        31
      ],
      [
        -9,
        72
      ],
      [
        -2,
        9
      ],
      [
        -18,
        108
      ],
      [
        -4,
        1
      ],
      [
        -46,
        273
      ],
      [
        0,
        669
      ]
    ],
    [
      [
        24429,
        57786
      ],
      [
        4,
        15
      ],
      [
        7,
        2
      ],
      [
        -6,
        5
      ],
      [
        2,
        11
      ],
      [
        -4,
        23
      ],
      [
        7,
        -1
      ],
      [
        -2,
        21
      ],
      [
        -7,
        1
      ],
      [
        0,
        13
      ],
      [
        7,
        1
      ],
      [
        4,
        14
      ],
      [
        -1,
        7
      ],
      [
        -1,
        10
      ],
      [
        2,
        -2
      ],
      [
        2,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        3
      ],
      [
        0,
        13
      ],
      [
        1,
        5
      ],
      [
        3,
        -3
      ],
      [
        0,
        -19
      ],
      [
        1,
        -3
      ],
      [
        2,
        -4
      ],
      [
        1,
        0
      ],
      [
        1,
        2
      ],
      [
        0,
        10
      ],
      [
        -2,
        0
      ],
      [
        -1,
        1
      ],
      [
        0,
        5
      ],
      [
        2,
        10
      ],
      [
        1,
        4
      ],
      [
        -1,
        2
      ],
      [
        -2,
        0
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        0,
        -1
      ],
      [
        2,
        -4
      ],
      [
        1,
        3
      ],
      [
        0,
        4
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        4
      ],
      [
        0,
        8
      ],
      [
        1,
        7
      ],
      [
        0,
        2
      ],
      [
        1,
        3
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        1,
        3
      ],
      [
        0,
        13
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -15
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -3,
        15
      ],
      [
        -3,
        1
      ],
      [
        0,
        14
      ],
      [
        -1,
        30
      ],
      [
        -6,
        -8
      ],
      [
        3,
        39
      ],
      [
        -1,
        9
      ],
      [
        -5,
        10
      ],
      [
        6,
        8
      ],
      [
        -4,
        19
      ],
      [
        2,
        3
      ],
      [
        5,
        -13
      ],
      [
        1,
        6
      ],
      [
        -4,
        11
      ],
      [
        6,
        13
      ],
      [
        3,
        -13
      ],
      [
        3,
        3
      ],
      [
        -5,
        16
      ],
      [
        8,
        17
      ],
      [
        0,
        18
      ],
      [
        2,
        10
      ],
      [
        2,
        -26
      ],
      [
        3,
        19
      ],
      [
        -3,
        7
      ],
      [
        3,
        10
      ]
    ],
    [
      [
        24462,
        58193
      ],
      [
        -1,
        7
      ],
      [
        27,
        1
      ],
      [
        0,
        -102
      ],
      [
        59,
        -4
      ]
    ],
    [
      [
        24547,
        57855
      ],
      [
        -1,
        -171
      ],
      [
        -29,
        1
      ]
    ],
    [
      [
        24456,
        57581
      ],
      [
        0,
        110
      ],
      [
        1,
        52
      ],
      [
        -22,
        0
      ],
      [
        1,
        10
      ],
      [
        -6,
        -10
      ],
      [
        -5,
        7
      ],
      [
        1,
        10
      ],
      [
        8,
        1
      ],
      [
        -5,
        25
      ]
    ],
    [
      [
        27601,
        48335
      ],
      [
        6,
        -89
      ],
      [
        3,
        -40
      ],
      [
        3,
        -52
      ],
      [
        1,
        -21
      ],
      [
        0,
        -29
      ],
      [
        -1,
        0
      ],
      [
        0,
        -6
      ],
      [
        1,
        -60
      ],
      [
        0,
        -16
      ],
      [
        -1,
        -29
      ],
      [
        0,
        -95
      ],
      [
        -1,
        -30
      ],
      [
        -3,
        -69
      ],
      [
        -3,
        -76
      ],
      [
        0,
        -21
      ],
      [
        -3,
        -105
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -17
      ]
    ],
    [
      [
        27602,
        47579
      ],
      [
        -5,
        7
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        5
      ],
      [
        -29,
        0
      ],
      [
        -13,
        16
      ],
      [
        -13,
        16
      ],
      [
        0,
        -24
      ],
      [
        -162,
        -1
      ]
    ],
    [
      [
        27378,
        47594
      ],
      [
        -1,
        12
      ],
      [
        1,
        3
      ],
      [
        -2,
        463
      ],
      [
        0,
        250
      ]
    ],
    [
      [
        27141,
        53410
      ],
      [
        1,
        -3
      ],
      [
        6,
        55
      ],
      [
        4,
        30
      ],
      [
        7,
        -1
      ],
      [
        10,
        59
      ],
      [
        2,
        3
      ]
    ],
    [
      [
        27171,
        53553
      ],
      [
        4,
        -15
      ],
      [
        -1,
        -6
      ],
      [
        10,
        -41
      ],
      [
        8,
        -17
      ],
      [
        -1,
        -11
      ],
      [
        4,
        1
      ],
      [
        1,
        -10
      ],
      [
        8,
        -14
      ],
      [
        3,
        -14
      ],
      [
        6,
        -5
      ],
      [
        5,
        -15
      ],
      [
        4,
        7
      ],
      [
        1,
        -22
      ],
      [
        9,
        -7
      ],
      [
        -2,
        -15
      ],
      [
        3,
        1
      ],
      [
        5,
        25
      ],
      [
        4,
        2
      ],
      [
        14,
        -11
      ],
      [
        5,
        -20
      ],
      [
        8,
        3
      ]
    ],
    [
      [
        27269,
        53369
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -40
      ],
      [
        -1,
        -13
      ],
      [
        -2,
        -21
      ],
      [
        0,
        -17
      ],
      [
        -1,
        -6
      ],
      [
        -3,
        0
      ],
      [
        -3,
        2
      ],
      [
        -7,
        -24
      ],
      [
        -4,
        -23
      ],
      [
        -2,
        -13
      ],
      [
        0,
        -8
      ],
      [
        -2,
        -15
      ],
      [
        -5,
        -4
      ],
      [
        -4,
        1
      ],
      [
        -1,
        -10
      ],
      [
        0,
        -21
      ],
      [
        1,
        -25
      ],
      [
        0,
        -15
      ],
      [
        -4,
        -54
      ],
      [
        -2,
        -11
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        2
      ],
      [
        0,
        4
      ],
      [
        -2,
        -2
      ]
    ],
    [
      [
        27221,
        53045
      ],
      [
        0,
        15
      ],
      [
        -4,
        9
      ],
      [
        -8,
        -3
      ],
      [
        -2,
        23
      ],
      [
        -9,
        11
      ],
      [
        -4,
        24
      ],
      [
        -5,
        -4
      ],
      [
        -4,
        19
      ],
      [
        4,
        28
      ],
      [
        -1,
        11
      ],
      [
        -4,
        -15
      ],
      [
        -10,
        -5
      ],
      [
        -3,
        3
      ],
      [
        -3,
        -9
      ],
      [
        -8,
        20
      ],
      [
        -7,
        -3
      ],
      [
        -7,
        18
      ],
      [
        -3,
        12
      ],
      [
        -11,
        6
      ],
      [
        -1,
        18
      ]
    ],
    [
      [
        27131,
        53223
      ],
      [
        -4,
        -5
      ],
      [
        4,
        43
      ],
      [
        2,
        47
      ],
      [
        3,
        46
      ],
      [
        4,
        23
      ],
      [
        1,
        33
      ]
    ],
    [
      [
        23974,
        64548
      ],
      [
        128,
        1
      ]
    ],
    [
      [
        24102,
        64190
      ],
      [
        -14,
        -1
      ],
      [
        -7,
        0
      ]
    ],
    [
      [
        24081,
        64189
      ],
      [
        -8,
        0
      ],
      [
        -4,
        -1
      ],
      [
        -28,
        0
      ],
      [
        -2,
        -1
      ],
      [
        -22,
        0
      ],
      [
        -4,
        -1
      ],
      [
        -36,
        -3
      ],
      [
        -3,
        -1
      ]
    ],
    [
      [
        24521,
        66583
      ],
      [
        66,
        -1
      ],
      [
        0,
        35
      ]
    ],
    [
      [
        24587,
        66617
      ],
      [
        3,
        -3
      ],
      [
        5,
        -5
      ],
      [
        5,
        -4
      ],
      [
        2,
        -2
      ],
      [
        3,
        -2
      ],
      [
        10,
        -7
      ],
      [
        2,
        -2
      ],
      [
        3,
        -1
      ],
      [
        3,
        -2
      ],
      [
        2,
        -3
      ],
      [
        5,
        -4
      ],
      [
        3,
        -2
      ],
      [
        3,
        -3
      ],
      [
        3,
        -6
      ],
      [
        1,
        -2
      ],
      [
        1,
        -4
      ],
      [
        1,
        -5
      ],
      [
        0,
        -5
      ],
      [
        2,
        -9
      ],
      [
        0,
        -5
      ],
      [
        1,
        -13
      ],
      [
        0,
        -5
      ],
      [
        1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        2,
        -9
      ],
      [
        0,
        -3
      ],
      [
        2,
        -3
      ],
      [
        3,
        -10
      ],
      [
        0,
        -12
      ],
      [
        2,
        -9
      ],
      [
        2,
        -7
      ],
      [
        1,
        -4
      ],
      [
        1,
        -15
      ],
      [
        1,
        -10
      ],
      [
        0,
        -7
      ],
      [
        -2,
        -5
      ]
    ],
    [
      [
        24705,
        66275
      ],
      [
        -53,
        1
      ],
      [
        0,
        -102
      ],
      [
        -65,
        0
      ]
    ],
    [
      [
        26104,
        59938
      ],
      [
        61,
        -15
      ]
    ],
    [
      [
        26165,
        59923
      ],
      [
        -12,
        -31
      ],
      [
        8,
        -24
      ],
      [
        3,
        -28
      ],
      [
        6,
        1
      ]
    ],
    [
      [
        26170,
        59841
      ],
      [
        -9,
        -128
      ],
      [
        -13,
        -138
      ]
    ],
    [
      [
        26148,
        59575
      ],
      [
        -2,
        -2
      ],
      [
        -6,
        0
      ],
      [
        -3,
        -1
      ],
      [
        -27,
        -5
      ],
      [
        -2,
        -1
      ]
    ],
    [
      [
        26064,
        59799
      ],
      [
        4,
        5
      ],
      [
        2,
        18
      ],
      [
        -6,
        23
      ],
      [
        -2,
        17
      ],
      [
        6,
        -4
      ],
      [
        6,
        -21
      ],
      [
        6,
        13
      ],
      [
        9,
        6
      ],
      [
        9,
        31
      ],
      [
        6,
        51
      ]
    ],
    [
      [
        24290,
        51905
      ],
      [
        0,
        8
      ],
      [
        3,
        34
      ]
    ],
    [
      [
        24293,
        51947
      ],
      [
        13,
        -1
      ],
      [
        3,
        -18
      ],
      [
        3,
        8
      ],
      [
        2,
        5
      ],
      [
        7,
        -12
      ],
      [
        9,
        -16
      ],
      [
        2,
        7
      ],
      [
        3,
        23
      ],
      [
        11,
        25
      ],
      [
        -1,
        20
      ],
      [
        11,
        16
      ],
      [
        6,
        -1
      ],
      [
        7,
        -19
      ],
      [
        5,
        6
      ],
      [
        5,
        -31
      ],
      [
        7,
        -16
      ],
      [
        2,
        -2
      ],
      [
        2,
        -12
      ],
      [
        1,
        -28
      ],
      [
        26,
        0
      ],
      [
        3,
        9
      ],
      [
        3,
        20
      ],
      [
        33,
        0
      ]
    ],
    [
      [
        24456,
        51930
      ],
      [
        27,
        1
      ],
      [
        4,
        -23
      ],
      [
        5,
        -10
      ],
      [
        4,
        11
      ],
      [
        0,
        -18
      ]
    ],
    [
      [
        24496,
        51891
      ],
      [
        -3,
        -28
      ],
      [
        -7,
        -1
      ],
      [
        1,
        -33
      ]
    ],
    [
      [
        24487,
        51829
      ],
      [
        -60,
        -18
      ]
    ],
    [
      [
        24319,
        51555
      ],
      [
        0,
        9
      ],
      [
        -4,
        5
      ],
      [
        -2,
        10
      ],
      [
        5,
        19
      ],
      [
        3,
        22
      ],
      [
        3,
        -15
      ],
      [
        3,
        -2
      ],
      [
        2,
        14
      ],
      [
        0,
        22
      ],
      [
        -2,
        24
      ],
      [
        -8,
        -3
      ],
      [
        -8,
        11
      ],
      [
        -4,
        -3
      ],
      [
        -4,
        -16
      ],
      [
        -6,
        -3
      ],
      [
        -9,
        20
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        24275,
        51386
      ],
      [
        2,
        10
      ],
      [
        1,
        4
      ],
      [
        7,
        13
      ],
      [
        6,
        -6
      ],
      [
        6,
        1
      ],
      [
        3,
        26
      ],
      [
        8,
        2
      ],
      [
        3,
        -6
      ],
      [
        6,
        1
      ],
      [
        5,
        -3
      ],
      [
        5,
        -18
      ],
      [
        7,
        -13
      ],
      [
        1,
        -14
      ],
      [
        5,
        6
      ],
      [
        2,
        -11
      ],
      [
        3,
        -11
      ],
      [
        5,
        -1
      ],
      [
        4,
        8
      ],
      [
        1,
        -21
      ],
      [
        5,
        8
      ],
      [
        0,
        -16
      ],
      [
        -6,
        -18
      ],
      [
        -9,
        -18
      ],
      [
        -2,
        -23
      ],
      [
        1,
        -17
      ],
      [
        -5,
        -9
      ],
      [
        -4,
        6
      ],
      [
        -4,
        -7
      ],
      [
        -1,
        -9
      ],
      [
        -7,
        6
      ],
      [
        -3,
        24
      ],
      [
        -4,
        4
      ],
      [
        -4,
        -2
      ],
      [
        -5,
        14
      ],
      [
        -4,
        6
      ],
      [
        -9,
        20
      ],
      [
        -4,
        0
      ],
      [
        -2,
        8
      ],
      [
        -12,
        21
      ],
      [
        -5,
        14
      ],
      [
        4,
        21
      ]
    ],
    [
      [
        25420,
        62164
      ],
      [
        41,
        -1
      ],
      [
        21,
        3
      ],
      [
        42,
        1
      ]
    ],
    [
      [
        25524,
        62167
      ],
      [
        2,
        -4
      ],
      [
        1,
        -26
      ],
      [
        -1,
        -10
      ],
      [
        8,
        -46
      ],
      [
        0,
        -24
      ],
      [
        1,
        -18
      ],
      [
        -2,
        -11
      ],
      [
        -4,
        -20
      ],
      [
        -1,
        -22
      ],
      [
        -3,
        -15
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        -6
      ],
      [
        -14,
        -12
      ],
      [
        -7,
        -32
      ],
      [
        -1,
        -24
      ],
      [
        -1,
        -16
      ],
      [
        1,
        -10
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -1
      ],
      [
        -4,
        -24
      ]
    ],
    [
      [
        25491,
        61836
      ],
      [
        -72,
        2
      ]
    ],
    [
      [
        28550,
        61756
      ],
      [
        6,
        -30
      ],
      [
        -1,
        -10
      ],
      [
        9,
        -25
      ],
      [
        4,
        -22
      ],
      [
        3,
        -2
      ],
      [
        9,
        -20
      ],
      [
        3,
        -13
      ],
      [
        6,
        4
      ],
      [
        9,
        -30
      ],
      [
        5,
        -35
      ],
      [
        -1,
        -19
      ],
      [
        4,
        -2
      ]
    ],
    [
      [
        28606,
        61552
      ],
      [
        -1,
        -13
      ],
      [
        3,
        -16
      ],
      [
        3,
        -7
      ],
      [
        1,
        0
      ],
      [
        4,
        -1
      ],
      [
        3,
        10
      ],
      [
        5,
        4
      ],
      [
        1,
        8
      ],
      [
        6,
        -10
      ],
      [
        2,
        -4
      ],
      [
        0,
        -4
      ],
      [
        -5,
        -21
      ],
      [
        -2,
        -13
      ],
      [
        0,
        -9
      ],
      [
        4,
        -48
      ],
      [
        7,
        -30
      ],
      [
        2,
        -16
      ],
      [
        7,
        -27
      ],
      [
        2,
        -19
      ],
      [
        -5,
        -22
      ],
      [
        0,
        -10
      ],
      [
        2,
        -14
      ],
      [
        1,
        -32
      ],
      [
        2,
        -33
      ],
      [
        0,
        -8
      ],
      [
        -2,
        10
      ],
      [
        -1,
        6
      ],
      [
        -3,
        4
      ],
      [
        -3,
        -1
      ],
      [
        -2,
        8
      ],
      [
        -3,
        23
      ],
      [
        -6,
        27
      ],
      [
        -3,
        5
      ],
      [
        -3,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        2
      ],
      [
        -2,
        15
      ],
      [
        0,
        8
      ],
      [
        -3,
        15
      ],
      [
        1,
        9
      ],
      [
        0,
        8
      ],
      [
        -1,
        9
      ],
      [
        -5,
        -6
      ],
      [
        -3,
        -3
      ],
      [
        2,
        -21
      ],
      [
        -1,
        -9
      ],
      [
        -1,
        -10
      ],
      [
        0,
        -4
      ],
      [
        1,
        -5
      ],
      [
        0,
        -6
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        2
      ],
      [
        -2,
        13
      ],
      [
        -3,
        16
      ],
      [
        -2,
        9
      ],
      [
        -2,
        4
      ],
      [
        -2,
        1
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -6
      ],
      [
        -3,
        22
      ],
      [
        -1,
        14
      ],
      [
        -1,
        12
      ],
      [
        -2,
        13
      ],
      [
        -3,
        14
      ],
      [
        -2,
        4
      ],
      [
        -5,
        14
      ],
      [
        -12,
        13
      ],
      [
        -3,
        0
      ],
      [
        -8,
        10
      ],
      [
        -4,
        0
      ],
      [
        -7,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -6,
        2
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -10
      ],
      [
        -7,
        7
      ],
      [
        -1,
        1
      ],
      [
        -5,
        9
      ],
      [
        -4,
        16
      ],
      [
        0,
        2
      ],
      [
        2,
        0
      ],
      [
        0,
        3
      ],
      [
        1,
        30
      ],
      [
        -5,
        18
      ],
      [
        -1,
        18
      ],
      [
        -2,
        22
      ],
      [
        -1,
        0
      ],
      [
        -2,
        8
      ],
      [
        4,
        12
      ],
      [
        -3,
        4
      ],
      [
        0,
        1
      ],
      [
        -3,
        4
      ]
    ],
    [
      [
        28501,
        61588
      ],
      [
        0,
        12
      ],
      [
        -7,
        18
      ],
      [
        1,
        9
      ],
      [
        6,
        11
      ],
      [
        8,
        42
      ],
      [
        13,
        87
      ],
      [
        17,
        2
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -5
      ],
      [
        1,
        0
      ],
      [
        0,
        -4
      ],
      [
        1,
        1
      ],
      [
        0,
        -4
      ],
      [
        1,
        -2
      ],
      [
        4,
        -2
      ],
      [
        3,
        5
      ]
    ],
    [
      [
        24475,
        52618
      ],
      [
        3,
        33
      ],
      [
        5,
        4
      ],
      [
        2,
        20
      ],
      [
        3,
        8
      ],
      [
        56,
        8
      ],
      [
        56,
        8
      ]
    ],
    [
      [
        24600,
        52699
      ],
      [
        2,
        -13
      ],
      [
        -8,
        -17
      ],
      [
        -11,
        -51
      ]
    ],
    [
      [
        24583,
        52618
      ],
      [
        -8,
        -34
      ],
      [
        2,
        -8
      ],
      [
        -11,
        -19
      ],
      [
        -4,
        -14
      ],
      [
        4,
        -26
      ],
      [
        0,
        -25
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -15
      ],
      [
        4,
        -21
      ],
      [
        -2,
        -43
      ],
      [
        -4,
        -6
      ],
      [
        5,
        -28
      ],
      [
        -3,
        -17
      ],
      [
        5,
        -10
      ],
      [
        -2,
        -20
      ],
      [
        7,
        -4
      ],
      [
        3,
        -32
      ],
      [
        9,
        -7
      ],
      [
        2,
        -15
      ],
      [
        2,
        -3
      ]
    ],
    [
      [
        24589,
        52264
      ],
      [
        -6,
        -7
      ],
      [
        -3,
        6
      ],
      [
        -18,
        1
      ],
      [
        -2,
        -3
      ],
      [
        -6,
        -9
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -6
      ]
    ],
    [
      [
        24553,
        52236
      ],
      [
        -3,
        -6
      ],
      [
        -19,
        4
      ],
      [
        -11,
        -3
      ],
      [
        -1,
        7
      ]
    ],
    [
      [
        24519,
        52238
      ],
      [
        -3,
        17
      ],
      [
        -6,
        8
      ],
      [
        -17,
        0
      ],
      [
        -2,
        15
      ],
      [
        2,
        21
      ],
      [
        7,
        33
      ],
      [
        3,
        22
      ],
      [
        1,
        20
      ],
      [
        0,
        21
      ],
      [
        -1,
        57
      ],
      [
        -1,
        13
      ],
      [
        -2,
        6
      ],
      [
        -7,
        -11
      ],
      [
        -8,
        -10
      ],
      [
        -5,
        1
      ],
      [
        -1,
        11
      ],
      [
        11,
        24
      ],
      [
        1,
        20
      ],
      [
        -7,
        22
      ],
      [
        -11,
        1
      ],
      [
        -2,
        7
      ],
      [
        0,
        18
      ],
      [
        3,
        17
      ],
      [
        3,
        26
      ],
      [
        -1,
        12
      ],
      [
        -1,
        9
      ]
    ],
    [
      [
        24009,
        53851
      ],
      [
        22,
        0
      ],
      [
        63,
        1
      ],
      [
        13,
        0
      ],
      [
        0,
        102
      ],
      [
        11,
        0
      ],
      [
        61,
        -1
      ]
    ],
    [
      [
        24179,
        53953
      ],
      [
        0,
        -17
      ],
      [
        2,
        -2
      ],
      [
        3,
        -24
      ],
      [
        -4,
        -19
      ],
      [
        2,
        -5
      ],
      [
        -3,
        -20
      ],
      [
        -2,
        2
      ],
      [
        -1,
        -25
      ],
      [
        7,
        -6
      ],
      [
        -5,
        -56
      ],
      [
        4,
        -28
      ],
      [
        -5,
        -7
      ],
      [
        -4,
        2
      ],
      [
        11,
        -28
      ],
      [
        10,
        -8
      ],
      [
        -3,
        -20
      ],
      [
        2,
        1
      ],
      [
        4,
        -11
      ],
      [
        -2,
        -12
      ],
      [
        5,
        -19
      ],
      [
        3,
        -1
      ],
      [
        0,
        -47
      ],
      [
        10,
        7
      ],
      [
        -2,
        -20
      ],
      [
        9,
        8
      ],
      [
        1,
        -11
      ],
      [
        4,
        -5
      ]
    ],
    [
      [
        24225,
        53582
      ],
      [
        -13,
        -10
      ],
      [
        -17,
        -12
      ],
      [
        -40,
        -34
      ],
      [
        -1,
        -1
      ],
      [
        -50,
        -44
      ],
      [
        -8,
        -3
      ],
      [
        -3,
        18
      ],
      [
        -2,
        -9
      ],
      [
        -5,
        6
      ],
      [
        5,
        16
      ],
      [
        -5,
        15
      ],
      [
        4,
        19
      ],
      [
        -7,
        8
      ],
      [
        0,
        23
      ],
      [
        4,
        1
      ],
      [
        -2,
        24
      ],
      [
        4,
        1
      ],
      [
        -1,
        9
      ],
      [
        -4,
        -7
      ],
      [
        -5,
        27
      ]
    ],
    [
      [
        24079,
        53629
      ],
      [
        1,
        5
      ],
      [
        -12,
        29
      ],
      [
        1,
        14
      ],
      [
        -9,
        23
      ],
      [
        -3,
        21
      ],
      [
        -11,
        5
      ],
      [
        -9,
        19
      ],
      [
        -10,
        7
      ],
      [
        1,
        42
      ],
      [
        -6,
        7
      ],
      [
        -1,
        14
      ],
      [
        -10,
        2
      ],
      [
        1,
        25
      ],
      [
        -3,
        9
      ]
    ],
    [
      [
        25823,
        67545
      ],
      [
        -2,
        22
      ],
      [
        -3,
        28
      ],
      [
        -11,
        71
      ],
      [
        -3,
        20
      ],
      [
        -3,
        28
      ],
      [
        0,
        48
      ],
      [
        3,
        22
      ],
      [
        5,
        24
      ],
      [
        8,
        31
      ],
      [
        6,
        25
      ],
      [
        4,
        29
      ],
      [
        3,
        21
      ],
      [
        1,
        31
      ],
      [
        0,
        4
      ]
    ],
    [
      [
        23036,
        64415
      ],
      [
        176,
        0
      ]
    ],
    [
      [
        23212,
        64415
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -6
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -5
      ],
      [
        1,
        -13
      ],
      [
        1,
        -4
      ],
      [
        2,
        -4
      ],
      [
        1,
        -2
      ],
      [
        4,
        -5
      ],
      [
        1,
        -7
      ],
      [
        1,
        -5
      ],
      [
        1,
        -4
      ],
      [
        0,
        -14
      ],
      [
        1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        3,
        -7
      ],
      [
        1,
        -1
      ],
      [
        2,
        -4
      ],
      [
        2,
        -2
      ],
      [
        3,
        0
      ],
      [
        2,
        -3
      ],
      [
        2,
        -4
      ],
      [
        1,
        -2
      ],
      [
        1,
        -5
      ],
      [
        2,
        -7
      ],
      [
        1,
        -5
      ],
      [
        0,
        -22
      ],
      [
        1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        1,
        -2
      ],
      [
        2,
        -4
      ],
      [
        2,
        -5
      ],
      [
        0,
        -14
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -4
      ]
    ],
    [
      [
        23231,
        64184
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -6
      ],
      [
        1,
        -8
      ],
      [
        2,
        -11
      ],
      [
        0,
        -13
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -11
      ],
      [
        1,
        -3
      ],
      [
        2,
        -3
      ],
      [
        2,
        -2
      ],
      [
        4,
        0
      ],
      [
        1,
        1
      ],
      [
        2,
        3
      ],
      [
        1,
        0
      ],
      [
        2,
        -1
      ],
      [
        1,
        -4
      ]
    ],
    [
      [
        23246,
        64112
      ],
      [
        -99,
        0
      ]
    ],
    [
      [
        23036,
        64111
      ],
      [
        0,
        304
      ]
    ],
    [
      [
        25197,
        66405
      ],
      [
        19,
        2
      ],
      [
        93,
        0
      ]
    ],
    [
      [
        25339,
        66408
      ],
      [
        0,
        -398
      ]
    ],
    [
      [
        25339,
        66010
      ],
      [
        -11,
        0
      ]
    ],
    [
      [
        25328,
        66010
      ],
      [
        -98,
        0
      ]
    ],
    [
      [
        25198,
        66010
      ],
      [
        0,
        202
      ],
      [
        -1,
        193
      ]
    ],
    [
      [
        22311,
        63505
      ],
      [
        95,
        0
      ]
    ],
    [
      [
        22406,
        63505
      ],
      [
        9,
        0
      ],
      [
        1,
        1
      ],
      [
        5,
        -1
      ],
      [
        5,
        0
      ],
      [
        4,
        1
      ],
      [
        7,
        -1
      ],
      [
        6,
        1
      ],
      [
        5,
        0
      ],
      [
        4,
        -1
      ],
      [
        16,
        0
      ]
    ],
    [
      [
        22468,
        63505
      ],
      [
        -1,
        -506
      ]
    ],
    [
      [
        22467,
        62999
      ],
      [
        -150,
        1
      ]
    ],
    [
      [
        25328,
        66010
      ],
      [
        0,
        -101
      ],
      [
        -2,
        0
      ],
      [
        -5,
        -1
      ],
      [
        0,
        -93
      ]
    ],
    [
      [
        25321,
        65815
      ],
      [
        0,
        -305
      ]
    ],
    [
      [
        20283,
        55809
      ],
      [
        115,
        -1
      ],
      [
        55,
        1
      ],
      [
        2,
        0
      ],
      [
        1,
        -100
      ],
      [
        96,
        1
      ],
      [
        17,
        0
      ],
      [
        1,
        -202
      ]
    ],
    [
      [
        20570,
        55508
      ],
      [
        0,
        -198
      ],
      [
        -10,
        0
      ],
      [
        -1,
        -416
      ],
      [
        0,
        -100
      ],
      [
        57,
        2
      ],
      [
        83,
        0
      ]
    ],
    [
      [
        20699,
        54796
      ],
      [
        0,
        -303
      ],
      [
        1,
        -8
      ],
      [
        0,
        -294
      ]
    ],
    [
      [
        20700,
        54191
      ],
      [
        -19,
        0
      ]
    ],
    [
      [
        20681,
        54191
      ],
      [
        -143,
        0
      ],
      [
        -84,
        1
      ],
      [
        -5,
        1
      ],
      [
        -29,
        0
      ],
      [
        -9,
        -1
      ],
      [
        -4,
        1
      ],
      [
        -27,
        0
      ]
    ],
    [
      [
        20380,
        54193
      ],
      [
        -51,
        0
      ],
      [
        -6,
        -1
      ],
      [
        -35,
        0
      ],
      [
        -14,
        -1
      ]
    ],
    [
      [
        20274,
        54191
      ],
      [
        0,
        1114
      ],
      [
        10,
        1
      ],
      [
        0,
        110
      ]
    ],
    [
      [
        25724,
        61173
      ],
      [
        5,
        20
      ],
      [
        2,
        -14
      ],
      [
        5,
        -7
      ],
      [
        -3,
        59
      ],
      [
        5,
        10
      ],
      [
        -4,
        25
      ],
      [
        4,
        18
      ],
      [
        -7,
        26
      ],
      [
        -4,
        2
      ],
      [
        3,
        6
      ],
      [
        -3,
        23
      ],
      [
        3,
        16
      ],
      [
        -2,
        29
      ],
      [
        3,
        -2
      ],
      [
        0,
        29
      ]
    ],
    [
      [
        25731,
        61413
      ],
      [
        0,
        51
      ],
      [
        31,
        -1
      ],
      [
        0,
        18
      ]
    ],
    [
      [
        25823,
        61316
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -21
      ],
      [
        2,
        -5
      ],
      [
        7,
        -12
      ],
      [
        1,
        -9
      ],
      [
        -1,
        -13
      ],
      [
        -2,
        -8
      ],
      [
        -4,
        -12
      ],
      [
        -5,
        -5
      ],
      [
        -5,
        0
      ]
    ],
    [
      [
        25524,
        62167
      ],
      [
        -5,
        8
      ],
      [
        0,
        4
      ],
      [
        1,
        15
      ],
      [
        1,
        22
      ],
      [
        5,
        15
      ]
    ],
    [
      [
        25526,
        62231
      ],
      [
        1,
        -6
      ],
      [
        79,
        -1
      ],
      [
        0,
        7
      ]
    ],
    [
      [
        25645,
        62227
      ],
      [
        3,
        -5
      ],
      [
        -8,
        -1
      ],
      [
        -4,
        -16
      ],
      [
        3,
        -14
      ],
      [
        -6,
        -7
      ],
      [
        0,
        -22
      ],
      [
        -2,
        -12
      ],
      [
        -6,
        10
      ],
      [
        0,
        -20
      ],
      [
        -4,
        5
      ],
      [
        -8,
        -30
      ],
      [
        -7,
        13
      ],
      [
        -2,
        -13
      ],
      [
        2,
        -25
      ],
      [
        -4,
        -8
      ],
      [
        -1,
        -14
      ],
      [
        4,
        1
      ],
      [
        0,
        -21
      ],
      [
        -3,
        -21
      ],
      [
        2,
        -4
      ],
      [
        -4,
        6
      ],
      [
        0,
        -6
      ],
      [
        1,
        -12
      ],
      [
        -6,
        -32
      ],
      [
        5,
        -4
      ],
      [
        -3,
        -9
      ],
      [
        5,
        -29
      ],
      [
        4,
        4
      ],
      [
        -3,
        -6
      ],
      [
        3,
        -25
      ],
      [
        -4,
        0
      ],
      [
        4,
        -25
      ],
      [
        -3,
        5
      ],
      [
        1,
        -53
      ],
      [
        3,
        -10
      ],
      [
        -2,
        -18
      ]
    ],
    [
      [
        25605,
        61809
      ],
      [
        -3,
        -22
      ],
      [
        -13,
        -19
      ],
      [
        -4,
        13
      ],
      [
        -11,
        26
      ],
      [
        -4,
        -6
      ],
      [
        0,
        -29
      ],
      [
        -4,
        8
      ],
      [
        0,
        21
      ],
      [
        -6,
        4
      ],
      [
        -2,
        -18
      ],
      [
        -3,
        16
      ],
      [
        -3,
        -11
      ],
      [
        -8,
        4
      ]
    ],
    [
      [
        25544,
        61796
      ],
      [
        -4,
        -7
      ],
      [
        1,
        -17
      ],
      [
        -5,
        -8
      ],
      [
        -1,
        -12
      ],
      [
        -7,
        9
      ],
      [
        -4,
        -3
      ],
      [
        -1,
        20
      ],
      [
        -3,
        -8
      ],
      [
        2,
        -22
      ],
      [
        -9,
        -2
      ],
      [
        -7,
        -47
      ],
      [
        -11,
        -5
      ],
      [
        0,
        11
      ],
      [
        -4,
        -8
      ],
      [
        -1,
        11
      ],
      [
        -5,
        -14
      ],
      [
        3,
        -12
      ],
      [
        -10,
        -16
      ],
      [
        -13,
        -9
      ]
    ],
    [
      [
        25465,
        61657
      ],
      [
        1,
        25
      ],
      [
        3,
        8
      ],
      [
        0,
        4
      ],
      [
        -1,
        8
      ],
      [
        -2,
        7
      ],
      [
        0,
        10
      ],
      [
        1,
        9
      ],
      [
        2,
        4
      ],
      [
        5,
        1
      ],
      [
        6,
        10
      ],
      [
        4,
        12
      ],
      [
        4,
        5
      ],
      [
        2,
        5
      ],
      [
        1,
        5
      ],
      [
        0,
        7
      ],
      [
        -1,
        4
      ],
      [
        -1,
        23
      ],
      [
        3,
        18
      ],
      [
        -1,
        14
      ]
    ],
    [
      [
        27478,
        65805
      ],
      [
        24,
        32
      ],
      [
        7,
        7
      ],
      [
        10,
        15
      ],
      [
        3,
        4
      ],
      [
        4,
        3
      ],
      [
        5,
        7
      ],
      [
        9,
        14
      ],
      [
        0,
        1
      ],
      [
        19,
        34
      ],
      [
        1,
        1
      ],
      [
        11,
        17
      ],
      [
        6,
        14
      ],
      [
        3,
        10
      ],
      [
        5,
        41
      ],
      [
        2,
        8
      ],
      [
        3,
        11
      ],
      [
        8,
        8
      ],
      [
        4,
        -2
      ],
      [
        1,
        -3
      ],
      [
        -2,
        -6
      ],
      [
        2,
        -9
      ],
      [
        -2,
        -5
      ],
      [
        1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        3,
        -2
      ],
      [
        5,
        10
      ],
      [
        6,
        11
      ],
      [
        9,
        17
      ],
      [
        16,
        34
      ],
      [
        2,
        1
      ],
      [
        7,
        11
      ],
      [
        4,
        10
      ],
      [
        5,
        7
      ],
      [
        6,
        5
      ],
      [
        13,
        24
      ],
      [
        10,
        16
      ]
    ],
    [
      [
        27689,
        66145
      ],
      [
        0,
        -314
      ],
      [
        1,
        -2
      ],
      [
        25,
        1
      ],
      [
        16,
        0
      ]
    ],
    [
      [
        27731,
        65830
      ],
      [
        0,
        -174
      ]
    ],
    [
      [
        27731,
        65656
      ],
      [
        -19,
        2
      ],
      [
        -64,
        -1
      ],
      [
        -35,
        -1
      ],
      [
        -47,
        -1
      ],
      [
        -41,
        1
      ],
      [
        -47,
        0
      ]
    ],
    [
      [
        27478,
        65656
      ],
      [
        0,
        149
      ]
    ],
    [
      [
        27511,
        55189
      ],
      [
        28,
        -7
      ],
      [
        3,
        -4
      ],
      [
        4,
        -6
      ],
      [
        33,
        -29
      ],
      [
        3,
        1
      ],
      [
        -2,
        7
      ],
      [
        -1,
        6
      ],
      [
        -1,
        12
      ],
      [
        -6,
        7
      ],
      [
        -1,
        16
      ],
      [
        7,
        -7
      ],
      [
        0,
        23
      ],
      [
        10,
        18
      ],
      [
        1,
        14
      ],
      [
        1,
        -10
      ],
      [
        4,
        0
      ],
      [
        2,
        -8
      ],
      [
        2,
        22
      ],
      [
        3,
        26
      ],
      [
        -2,
        6
      ],
      [
        -1,
        4
      ],
      [
        -3,
        11
      ],
      [
        -10,
        35
      ],
      [
        -1,
        4
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        2,
        -3
      ],
      [
        5,
        7
      ],
      [
        -7,
        16
      ],
      [
        -3,
        -17
      ],
      [
        -3,
        14
      ],
      [
        -3,
        7
      ],
      [
        2,
        9
      ],
      [
        0,
        11
      ],
      [
        3,
        2
      ]
    ],
    [
      [
        27581,
        55379
      ],
      [
        5,
        -13
      ],
      [
        8,
        -10
      ],
      [
        2,
        -16
      ],
      [
        3,
        5
      ],
      [
        9,
        9
      ],
      [
        1,
        -10
      ],
      [
        3,
        -10
      ],
      [
        -1,
        -27
      ],
      [
        1,
        -5
      ],
      [
        1,
        -11
      ],
      [
        1,
        -6
      ],
      [
        3,
        -22
      ],
      [
        0,
        -1
      ],
      [
        1,
        -13
      ],
      [
        2,
        -11
      ],
      [
        5,
        3
      ],
      [
        2,
        2
      ],
      [
        10,
        7
      ],
      [
        -4,
        -38
      ],
      [
        1,
        -16
      ],
      [
        2,
        -8
      ],
      [
        6,
        -6
      ],
      [
        1,
        -33
      ],
      [
        3,
        -6
      ],
      [
        1,
        0
      ],
      [
        2,
        5
      ],
      [
        3,
        9
      ],
      [
        0,
        33
      ],
      [
        9,
        13
      ],
      [
        6,
        27
      ],
      [
        2,
        31
      ],
      [
        2,
        3
      ],
      [
        1,
        -3
      ],
      [
        6,
        12
      ],
      [
        6,
        15
      ],
      [
        3,
        -1
      ],
      [
        2,
        18
      ],
      [
        -2,
        13
      ],
      [
        2,
        23
      ],
      [
        10,
        30
      ],
      [
        4,
        30
      ],
      [
        3,
        7
      ],
      [
        8,
        40
      ],
      [
        4,
        12
      ],
      [
        4,
        34
      ],
      [
        9,
        21
      ],
      [
        15,
        21
      ],
      [
        7,
        -14
      ],
      [
        3,
        3
      ],
      [
        3,
        23
      ],
      [
        4,
        13
      ],
      [
        1,
        16
      ],
      [
        6,
        22
      ],
      [
        1,
        -4
      ],
      [
        6,
        8
      ]
    ],
    [
      [
        27777,
        55603
      ],
      [
        3,
        2
      ],
      [
        9,
        -36
      ],
      [
        15,
        -36
      ],
      [
        17,
        -8
      ],
      [
        6,
        -14
      ],
      [
        -6,
        -29
      ]
    ],
    [
      [
        27821,
        55482
      ],
      [
        -1,
        0
      ],
      [
        -10,
        -23
      ],
      [
        -2,
        -21
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -17
      ],
      [
        -6,
        -51
      ],
      [
        -12,
        -3
      ],
      [
        -3,
        3
      ],
      [
        -2,
        10
      ],
      [
        -11,
        -9
      ],
      [
        -6,
        -7
      ],
      [
        -1,
        17
      ],
      [
        -6,
        19
      ],
      [
        -4,
        3
      ],
      [
        -10,
        -16
      ],
      [
        -6,
        -17
      ],
      [
        -2,
        -18
      ],
      [
        -4,
        -14
      ],
      [
        -1,
        -8
      ],
      [
        -3,
        -23
      ],
      [
        0,
        -9
      ],
      [
        1,
        -12
      ],
      [
        2,
        -10
      ],
      [
        5,
        1
      ],
      [
        2,
        5
      ],
      [
        1,
        4
      ],
      [
        1,
        -1
      ],
      [
        1,
        -8
      ],
      [
        -2,
        -24
      ],
      [
        -15,
        -20
      ],
      [
        -7,
        -19
      ],
      [
        -11,
        -26
      ],
      [
        -1,
        -12
      ],
      [
        -1,
        -5
      ],
      [
        -5,
        -12
      ],
      [
        1,
        -6
      ],
      [
        0,
        -8
      ],
      [
        -3,
        -9
      ],
      [
        -23,
        -33
      ],
      [
        -2,
        -13
      ],
      [
        -6,
        -11
      ],
      [
        -3,
        -2
      ],
      [
        -4,
        8
      ],
      [
        0,
        11
      ],
      [
        -2,
        8
      ],
      [
        -2,
        6
      ],
      [
        -2,
        5
      ],
      [
        -11,
        -7
      ],
      [
        -1,
        -11
      ],
      [
        0,
        -21
      ],
      [
        8,
        -2
      ],
      [
        6,
        -2
      ],
      [
        3,
        -18
      ],
      [
        -1,
        -9
      ],
      [
        -4,
        -30
      ],
      [
        0,
        -20
      ],
      [
        -8,
        -23
      ],
      [
        -15,
        -29
      ],
      [
        -2,
        0
      ],
      [
        -3,
        -16
      ],
      [
        -2,
        -11
      ],
      [
        -2,
        -13
      ],
      [
        -3,
        4
      ],
      [
        -7,
        1
      ],
      [
        -11,
        -8
      ],
      [
        -13,
        -14
      ],
      [
        -7,
        -14
      ],
      [
        -6,
        -22
      ],
      [
        -1,
        -16
      ],
      [
        -3,
        -7
      ],
      [
        -2,
        8
      ],
      [
        -1,
        2
      ],
      [
        -3,
        8
      ],
      [
        -12,
        -29
      ],
      [
        0,
        -1
      ],
      [
        -8,
        -15
      ]
    ],
    [
      [
        27546,
        54792
      ],
      [
        -2,
        16
      ],
      [
        -10,
        -23
      ],
      [
        0,
        14
      ],
      [
        -8,
        4
      ],
      [
        0,
        -10
      ],
      [
        7,
        -17
      ],
      [
        -4,
        -11
      ],
      [
        -4,
        7
      ],
      [
        -8,
        36
      ],
      [
        -10,
        18
      ],
      [
        6,
        18
      ],
      [
        2,
        15
      ],
      [
        -2,
        26
      ],
      [
        2,
        14
      ],
      [
        0,
        11
      ],
      [
        -2,
        1
      ],
      [
        -6,
        -17
      ],
      [
        -2,
        4
      ],
      [
        -1,
        20
      ],
      [
        5,
        2
      ],
      [
        6,
        30
      ],
      [
        -5,
        0
      ],
      [
        -4,
        20
      ],
      [
        1,
        29
      ],
      [
        -2,
        23
      ],
      [
        -8,
        29
      ],
      [
        2,
        29
      ],
      [
        3,
        27
      ],
      [
        8,
        27
      ],
      [
        3,
        39
      ],
      [
        -2,
        16
      ]
    ],
    [
      [
        27253,
        57873
      ],
      [
        10,
        -2
      ],
      [
        6,
        -1
      ],
      [
        2,
        0
      ],
      [
        6,
        -1
      ],
      [
        1,
        0
      ],
      [
        28,
        -6
      ],
      [
        8,
        -1
      ],
      [
        9,
        -3
      ],
      [
        9,
        -2
      ],
      [
        1,
        -1
      ]
    ],
    [
      [
        27333,
        57856
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -13
      ],
      [
        0,
        -2
      ],
      [
        4,
        -6
      ],
      [
        0,
        -4
      ],
      [
        1,
        -10
      ],
      [
        0,
        -12
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -11
      ],
      [
        -1,
        -15
      ],
      [
        0,
        -13
      ],
      [
        1,
        -3
      ],
      [
        2,
        -5
      ],
      [
        2,
        -13
      ],
      [
        5,
        12
      ],
      [
        7,
        18
      ],
      [
        2,
        5
      ],
      [
        2,
        4
      ],
      [
        7,
        17
      ],
      [
        7,
        17
      ],
      [
        8,
        -35
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        27371,
        57771
      ],
      [
        0,
        -34
      ],
      [
        2,
        -16
      ],
      [
        -3,
        -19
      ],
      [
        2,
        -13
      ],
      [
        4,
        -18
      ],
      [
        -1,
        -6
      ],
      [
        1,
        -1
      ]
    ],
    [
      [
        27376,
        57664
      ],
      [
        0,
        0
      ]
    ],
    [
      [
        27376,
        57664
      ],
      [
        0,
        -9
      ],
      [
        1,
        -1
      ],
      [
        0,
        -10
      ]
    ],
    [
      [
        27377,
        57644
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        27377,
        57643
      ],
      [
        0,
        0
      ]
    ],
    [
      [
        27377,
        57643
      ],
      [
        1,
        0
      ],
      [
        0,
        -3
      ],
      [
        1,
        0
      ],
      [
        0,
        2
      ],
      [
        1,
        0
      ],
      [
        1,
        -42
      ],
      [
        -3,
        -31
      ],
      [
        0,
        -47
      ],
      [
        4,
        -17
      ],
      [
        -7,
        -19
      ],
      [
        -2,
        -12
      ]
    ],
    [
      [
        27217,
        57495
      ],
      [
        1,
        8
      ],
      [
        -3,
        10
      ],
      [
        -4,
        53
      ],
      [
        2,
        14
      ],
      [
        -1,
        28
      ],
      [
        -5,
        12
      ],
      [
        5,
        42
      ],
      [
        -4,
        52
      ],
      [
        10,
        25
      ],
      [
        12,
        0
      ],
      [
        2,
        68
      ],
      [
        1,
        34
      ],
      [
        9,
        33
      ]
    ],
    [
      [
        27266,
        54838
      ],
      [
        16,
        55
      ],
      [
        5,
        8
      ],
      [
        53,
        166
      ],
      [
        6,
        -26
      ],
      [
        5,
        -12
      ],
      [
        3,
        -30
      ],
      [
        6,
        -9
      ],
      [
        -2,
        -31
      ],
      [
        -3,
        -8
      ],
      [
        1,
        -13
      ],
      [
        8,
        -7
      ],
      [
        3,
        -12
      ],
      [
        5,
        -5
      ],
      [
        9,
        45
      ]
    ],
    [
      [
        27381,
        54959
      ],
      [
        6,
        -53
      ],
      [
        4,
        -22
      ],
      [
        -2,
        -45
      ],
      [
        0,
        -42
      ],
      [
        6,
        -36
      ],
      [
        0,
        -31
      ],
      [
        -3,
        -2
      ],
      [
        -5,
        -39
      ],
      [
        0,
        -20
      ],
      [
        5,
        0
      ],
      [
        -4,
        -21
      ],
      [
        1,
        -10
      ],
      [
        -9,
        -18
      ],
      [
        -1,
        -27
      ],
      [
        -5,
        9
      ],
      [
        -8,
        -2
      ],
      [
        -3,
        -37
      ],
      [
        0,
        -23
      ],
      [
        -14,
        7
      ],
      [
        -6,
        0
      ],
      [
        4,
        -45
      ],
      [
        -6,
        -37
      ],
      [
        0,
        -21
      ],
      [
        5,
        -25
      ],
      [
        13,
        -34
      ],
      [
        -2,
        -30
      ],
      [
        -3,
        -1
      ],
      [
        1,
        -17
      ],
      [
        6,
        13
      ],
      [
        9,
        -8
      ],
      [
        -6,
        -10
      ],
      [
        8,
        -12
      ],
      [
        -2,
        -39
      ],
      [
        8,
        2
      ]
    ],
    [
      [
        27378,
        54283
      ],
      [
        -7,
        -32
      ],
      [
        3,
        -10
      ],
      [
        2,
        -11
      ]
    ],
    [
      [
        27376,
        54230
      ],
      [
        -2,
        1
      ],
      [
        -5,
        2
      ],
      [
        -2,
        1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        3
      ],
      [
        -2,
        6
      ],
      [
        -3,
        12
      ],
      [
        -3,
        13
      ],
      [
        -1,
        3
      ],
      [
        -6,
        7
      ],
      [
        -1,
        3
      ],
      [
        -1,
        5
      ],
      [
        -1,
        8
      ],
      [
        -1,
        4
      ],
      [
        -1,
        5
      ],
      [
        -1,
        2
      ],
      [
        -1,
        1
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        -6
      ],
      [
        -1,
        -2
      ],
      [
        -4,
        1
      ],
      [
        -4,
        6
      ],
      [
        -5,
        12
      ],
      [
        -1,
        3
      ],
      [
        0,
        1
      ],
      [
        -1,
        4
      ],
      [
        0,
        4
      ],
      [
        -1,
        1
      ],
      [
        -2,
        0
      ],
      [
        -2,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        5
      ],
      [
        -1,
        19
      ],
      [
        0,
        10
      ],
      [
        1,
        2
      ],
      [
        -1,
        11
      ],
      [
        0,
        1
      ],
      [
        -1,
        8
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        0,
        1
      ],
      [
        1,
        3
      ],
      [
        1,
        3
      ],
      [
        1,
        4
      ],
      [
        0,
        7
      ],
      [
        1,
        5
      ],
      [
        0,
        4
      ],
      [
        -2,
        14
      ],
      [
        -1,
        9
      ],
      [
        -2,
        5
      ],
      [
        -1,
        1
      ],
      [
        -1,
        9
      ],
      [
        -1,
        6
      ]
    ],
    [
      [
        27304,
        54454
      ],
      [
        -2,
        13
      ],
      [
        -1,
        4
      ],
      [
        0,
        6
      ],
      [
        2,
        10
      ],
      [
        1,
        10
      ],
      [
        2,
        11
      ],
      [
        2,
        2
      ],
      [
        1,
        2
      ],
      [
        2,
        9
      ],
      [
        0,
        6
      ],
      [
        -1,
        19
      ],
      [
        0,
        4
      ],
      [
        -3,
        18
      ],
      [
        -1,
        4
      ],
      [
        0,
        2
      ],
      [
        1,
        6
      ],
      [
        0,
        7
      ],
      [
        -2,
        10
      ],
      [
        0,
        2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        -2,
        0
      ],
      [
        0,
        5
      ],
      [
        -2,
        7
      ],
      [
        -2,
        6
      ],
      [
        0,
        9
      ],
      [
        -1,
        4
      ],
      [
        -2,
        8
      ],
      [
        0,
        1
      ],
      [
        1,
        5
      ],
      [
        0,
        8
      ],
      [
        -1,
        6
      ],
      [
        -2,
        12
      ],
      [
        -2,
        5
      ],
      [
        -3,
        14
      ],
      [
        -1,
        15
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        0,
        14
      ],
      [
        1,
        0
      ],
      [
        2,
        5
      ],
      [
        1,
        8
      ],
      [
        0,
        3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        3
      ],
      [
        -4,
        12
      ],
      [
        -4,
        18
      ],
      [
        -2,
        5
      ],
      [
        -1,
        9
      ],
      [
        0,
        5
      ],
      [
        1,
        1
      ],
      [
        0,
        6
      ],
      [
        -1,
        1
      ],
      [
        -2,
        1
      ],
      [
        -2,
        0
      ],
      [
        -7,
        20
      ],
      [
        1,
        4
      ],
      [
        0,
        8
      ],
      [
        -1,
        11
      ],
      [
        -1,
        2
      ]
    ],
    [
      [
        29192,
        65355
      ],
      [
        8,
        4
      ],
      [
        10,
        24
      ],
      [
        11,
        20
      ],
      [
        4,
        -4
      ],
      [
        0,
        -28
      ],
      [
        17,
        -17
      ],
      [
        17,
        -9
      ],
      [
        -2,
        38
      ],
      [
        10,
        -9
      ],
      [
        3,
        -10
      ],
      [
        6,
        8
      ],
      [
        4,
        -29
      ],
      [
        4,
        1
      ],
      [
        24,
        9
      ]
    ],
    [
      [
        29308,
        65353
      ],
      [
        -1,
        -9
      ],
      [
        -9,
        -46
      ],
      [
        -2,
        -18
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -75
      ],
      [
        5,
        -18
      ]
    ],
    [
      [
        29300,
        65178
      ],
      [
        6,
        -45
      ],
      [
        3,
        -7
      ],
      [
        -3,
        -54
      ],
      [
        -6,
        -27
      ]
    ],
    [
      [
        29300,
        65045
      ],
      [
        -25,
        -74
      ],
      [
        -8,
        -24
      ],
      [
        -17,
        -52
      ],
      [
        -21,
        -62
      ]
    ],
    [
      [
        29229,
        64833
      ],
      [
        -12,
        23
      ],
      [
        -6,
        12
      ],
      [
        -6,
        11
      ],
      [
        -13,
        25
      ]
    ],
    [
      [
        29192,
        64904
      ],
      [
        -3,
        6
      ],
      [
        -22,
        46
      ],
      [
        -11,
        22
      ],
      [
        -30,
        59
      ],
      [
        -10,
        17
      ],
      [
        -15,
        29
      ]
    ],
    [
      [
        29101,
        65083
      ],
      [
        1,
        3
      ],
      [
        1,
        2
      ],
      [
        0,
        2
      ],
      [
        -1,
        4
      ],
      [
        -1,
        4
      ],
      [
        -2,
        5
      ],
      [
        -2,
        5
      ],
      [
        0,
        3
      ],
      [
        -1,
        9
      ],
      [
        -1,
        4
      ],
      [
        -1,
        2
      ],
      [
        -3,
        1
      ],
      [
        -1,
        2
      ],
      [
        0,
        1
      ],
      [
        -1,
        4
      ],
      [
        -1,
        4
      ],
      [
        0,
        8
      ],
      [
        1,
        2
      ],
      [
        1,
        11
      ],
      [
        0,
        5
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -6
      ],
      [
        -1,
        -1
      ]
    ],
    [
      [
        29084,
        65161
      ],
      [
        -2,
        29
      ],
      [
        4,
        16
      ],
      [
        -3,
        31
      ],
      [
        2,
        4
      ],
      [
        62,
        11
      ],
      [
        15,
        1
      ],
      [
        6,
        35
      ],
      [
        10,
        37
      ],
      [
        3,
        11
      ],
      [
        11,
        19
      ]
    ],
    [
      [
        29624,
        67292
      ],
      [
        17,
        -18
      ],
      [
        7,
        -8
      ],
      [
        13,
        -12
      ],
      [
        38,
        15
      ],
      [
        32,
        -3
      ]
    ],
    [
      [
        29731,
        67266
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -5
      ],
      [
        1,
        -7
      ],
      [
        0,
        -9
      ],
      [
        -4,
        -10
      ],
      [
        1,
        -4
      ],
      [
        1,
        -8
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -7
      ],
      [
        0,
        -12
      ]
    ],
    [
      [
        29726,
        67183
      ],
      [
        0,
        -11
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        1,
        -8
      ],
      [
        1,
        -2
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        0,
        -11
      ],
      [
        1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        1,
        -4
      ],
      [
        0,
        -11
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        2,
        -7
      ],
      [
        1,
        -9
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -7
      ],
      [
        -3,
        -9
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -9
      ],
      [
        1,
        -4
      ],
      [
        1,
        -4
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -3
      ],
      [
        1,
        -8
      ],
      [
        1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        2,
        -6
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -4
      ],
      [
        1,
        -4
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        0
      ],
      [
        -1,
        2
      ],
      [
        0,
        1
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        -4,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        -1
      ],
      [
        -3,
        -10
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -19
      ],
      [
        1,
        -12
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -2
      ],
      [
        0,
        -17
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -11
      ],
      [
        0,
        -11
      ],
      [
        1,
        -7
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -2
      ],
      [
        1,
        -6
      ],
      [
        1,
        -5
      ],
      [
        0,
        -11
      ],
      [
        1,
        -10
      ],
      [
        1,
        -18
      ],
      [
        1,
        -4
      ],
      [
        6,
        -17
      ],
      [
        0,
        -2
      ],
      [
        1,
        -5
      ],
      [
        1,
        -5
      ],
      [
        0,
        -8
      ],
      [
        -2,
        -2
      ],
      [
        0,
        -7
      ],
      [
        1,
        -2
      ],
      [
        1,
        0
      ],
      [
        0,
        1
      ],
      [
        2,
        3
      ],
      [
        1,
        2
      ],
      [
        0,
        4
      ],
      [
        1,
        1
      ],
      [
        1,
        -1
      ],
      [
        1,
        -4
      ],
      [
        0,
        -2
      ],
      [
        1,
        -2
      ],
      [
        1,
        -3
      ],
      [
        1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        1,
        -8
      ],
      [
        0,
        -6
      ],
      [
        2,
        -5
      ],
      [
        1,
        -10
      ],
      [
        1,
        -5
      ],
      [
        0,
        -2
      ]
    ],
    [
      [
        29593,
        66691
      ],
      [
        0,
        33
      ],
      [
        1,
        73
      ],
      [
        1,
        113
      ],
      [
        -24,
        3
      ],
      [
        2,
        108
      ],
      [
        1,
        101
      ],
      [
        0,
        9
      ],
      [
        36,
        -4
      ],
      [
        1,
        61
      ],
      [
        1,
        46
      ],
      [
        4,
        66
      ],
      [
        8,
        -8
      ]
    ],
    [
      [
        19764,
        53938
      ],
      [
        0,
        -524
      ],
      [
        -139,
        0
      ],
      [
        -23,
        -1
      ],
      [
        -72,
        0
      ]
    ],
    [
      [
        19530,
        53413
      ],
      [
        0,
        1273
      ]
    ],
    [
      [
        19531,
        57636
      ],
      [
        54,
        -1
      ],
      [
        106,
        0
      ],
      [
        1,
        388
      ],
      [
        0,
        16
      ],
      [
        99,
        0
      ],
      [
        77,
        -2
      ],
      [
        28,
        0
      ],
      [
        0,
        51
      ],
      [
        30,
        0
      ],
      [
        0,
        -51
      ],
      [
        89,
        1
      ]
    ],
    [
      [
        20015,
        58038
      ],
      [
        19,
        0
      ],
      [
        12,
        -100
      ]
    ],
    [
      [
        20046,
        57938
      ],
      [
        36,
        -306
      ]
    ],
    [
      [
        20044,
        57192
      ],
      [
        -136,
        1
      ],
      [
        -9,
        -2
      ]
    ],
    [
      [
        19899,
        57191
      ],
      [
        -80,
        2
      ],
      [
        -32,
        1
      ],
      [
        -256,
        -1
      ]
    ],
    [
      [
        19531,
        57193
      ],
      [
        0,
        443
      ]
    ],
    [
      [
        27258,
        60505
      ],
      [
        5,
        -14
      ],
      [
        3,
        8
      ],
      [
        -7,
        46
      ],
      [
        8,
        15
      ],
      [
        4,
        27
      ],
      [
        5,
        8
      ],
      [
        1,
        5
      ],
      [
        6,
        5
      ]
    ],
    [
      [
        27283,
        60605
      ],
      [
        2,
        -2
      ],
      [
        4,
        39
      ],
      [
        0,
        38
      ],
      [
        18,
        26
      ],
      [
        2,
        -6
      ],
      [
        5,
        2
      ],
      [
        4,
        -6
      ]
    ],
    [
      [
        27318,
        60696
      ],
      [
        66,
        -186
      ]
    ],
    [
      [
        27384,
        60510
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -6
      ],
      [
        1,
        -3
      ],
      [
        -6,
        -33
      ],
      [
        9,
        -43
      ],
      [
        -4,
        -7
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        -12
      ],
      [
        -6,
        -16
      ],
      [
        -5,
        -10
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        -5
      ],
      [
        -5,
        -4
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        1
      ]
    ],
    [
      [
        27350,
        60351
      ],
      [
        0,
        1
      ],
      [
        -1,
        3
      ],
      [
        1,
        5
      ],
      [
        0,
        2
      ],
      [
        -4,
        -3
      ],
      [
        -4,
        -4
      ],
      [
        -4,
        -2
      ],
      [
        -4,
        -5
      ],
      [
        -13,
        -7
      ],
      [
        -3,
        -2
      ],
      [
        -5,
        -4
      ],
      [
        -8,
        -11
      ],
      [
        -5,
        -5
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        -5
      ],
      [
        -8,
        -18
      ],
      [
        -5,
        -9
      ]
    ],
    [
      [
        27282,
        60284
      ],
      [
        -14,
        39
      ],
      [
        -13,
        36
      ],
      [
        -11,
        45
      ]
    ],
    [
      [
        27394,
        63328
      ],
      [
        2,
        4
      ],
      [
        4,
        6
      ],
      [
        2,
        6
      ],
      [
        1,
        4
      ],
      [
        0,
        6
      ],
      [
        -1,
        12
      ],
      [
        -1,
        3
      ],
      [
        -1,
        7
      ],
      [
        -2,
        7
      ],
      [
        0,
        7
      ],
      [
        -1,
        3
      ],
      [
        1,
        5
      ],
      [
        0,
        6
      ],
      [
        1,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        4,
        -3
      ],
      [
        3,
        -7
      ],
      [
        1,
        -2
      ],
      [
        3,
        0
      ],
      [
        0,
        13
      ],
      [
        -1,
        10
      ],
      [
        -1,
        20
      ],
      [
        0,
        9
      ],
      [
        2,
        6
      ],
      [
        1,
        3
      ],
      [
        2,
        5
      ],
      [
        1,
        4
      ],
      [
        1,
        2
      ],
      [
        0,
        30
      ],
      [
        -1,
        10
      ],
      [
        0,
        3
      ],
      [
        1,
        8
      ],
      [
        1,
        7
      ],
      [
        0,
        10
      ],
      [
        1,
        4
      ]
    ],
    [
      [
        27419,
        63541
      ],
      [
        11,
        -3
      ],
      [
        7,
        -2
      ],
      [
        4,
        -2
      ],
      [
        37,
        -12
      ]
    ],
    [
      [
        27478,
        63522
      ],
      [
        0,
        -63
      ]
    ],
    [
      [
        27391,
        63178
      ],
      [
        0,
        1
      ],
      [
        -1,
        2
      ],
      [
        -3,
        16
      ],
      [
        -2,
        4
      ],
      [
        0,
        2
      ],
      [
        -3,
        12
      ],
      [
        -1,
        5
      ],
      [
        0,
        11
      ],
      [
        1,
        6
      ],
      [
        1,
        4
      ],
      [
        7,
        18
      ],
      [
        3,
        9
      ],
      [
        0,
        3
      ],
      [
        1,
        12
      ],
      [
        0,
        19
      ],
      [
        -1,
        9
      ],
      [
        0,
        14
      ],
      [
        1,
        3
      ]
    ],
    [
      [
        25837,
        54667
      ],
      [
        3,
        2
      ],
      [
        0,
        18
      ],
      [
        15,
        7
      ],
      [
        10,
        -25
      ],
      [
        1,
        9
      ],
      [
        -5,
        28
      ],
      [
        5,
        28
      ],
      [
        -2,
        22
      ],
      [
        2,
        3
      ],
      [
        5,
        -19
      ],
      [
        3,
        16
      ],
      [
        4,
        0
      ],
      [
        0,
        18
      ],
      [
        7,
        -8
      ],
      [
        7,
        -23
      ],
      [
        4,
        -27
      ],
      [
        5,
        -5
      ],
      [
        -3,
        -13
      ],
      [
        10,
        -2
      ],
      [
        1,
        -12
      ],
      [
        7,
        11
      ],
      [
        -1,
        -13
      ],
      [
        4,
        -6
      ],
      [
        8,
        5
      ],
      [
        3,
        -10
      ],
      [
        9,
        -8
      ],
      [
        1,
        14
      ],
      [
        5,
        2
      ]
    ],
    [
      [
        25945,
        54679
      ],
      [
        3,
        -18
      ],
      [
        -1,
        -24
      ],
      [
        6,
        -30
      ],
      [
        1,
        -26
      ],
      [
        6,
        -3
      ],
      [
        3,
        -11
      ],
      [
        1,
        -25
      ],
      [
        10,
        -32
      ]
    ],
    [
      [
        25974,
        54510
      ],
      [
        -19,
        -3
      ],
      [
        0,
        -25
      ],
      [
        -3,
        0
      ],
      [
        0,
        -232
      ]
    ],
    [
      [
        25952,
        54250
      ],
      [
        1,
        -98
      ],
      [
        -55,
        -1
      ]
    ],
    [
      [
        25898,
        54151
      ],
      [
        -31,
        -2
      ],
      [
        0,
        100
      ],
      [
        -1,
        1
      ],
      [
        -28,
        -1
      ]
    ],
    [
      [
        25813,
        54591
      ],
      [
        1,
        22
      ],
      [
        5,
        1
      ],
      [
        4,
        16
      ],
      [
        1,
        33
      ],
      [
        4,
        -7
      ],
      [
        9,
        11
      ]
    ],
    [
      [
        25867,
        56634
      ],
      [
        32,
        97
      ],
      [
        4,
        1
      ],
      [
        5,
        4
      ],
      [
        14,
        -1
      ],
      [
        0,
        17
      ]
    ],
    [
      [
        26024,
        56482
      ],
      [
        0,
        -39
      ],
      [
        -20,
        14
      ],
      [
        -10,
        11
      ],
      [
        -10,
        -8
      ],
      [
        -5,
        -8
      ],
      [
        0,
        -43
      ],
      [
        -9,
        0
      ],
      [
        0,
        17
      ],
      [
        -10,
        -7
      ],
      [
        0,
        -25
      ],
      [
        -5,
        1
      ],
      [
        0,
        -17
      ],
      [
        -2,
        -17
      ],
      [
        -8,
        1
      ],
      [
        1,
        -17
      ],
      [
        -8,
        2
      ],
      [
        0,
        -13
      ],
      [
        -5,
        1
      ]
    ],
    [
      [
        25861,
        56449
      ],
      [
        -13,
        -1
      ],
      [
        9,
        37
      ],
      [
        2,
        17
      ],
      [
        0,
        63
      ],
      [
        3,
        37
      ],
      [
        5,
        32
      ]
    ],
    [
      [
        25351,
        57057
      ],
      [
        4,
        138
      ]
    ],
    [
      [
        25525,
        57178
      ],
      [
        0,
        -305
      ]
    ],
    [
      [
        25496,
        56876
      ],
      [
        -27,
        3
      ],
      [
        -49,
        3
      ],
      [
        -74,
        10
      ]
    ],
    [
      [
        25346,
        56892
      ],
      [
        2,
        70
      ],
      [
        0,
        2
      ],
      [
        3,
        93
      ]
    ],
    [
      [
        7285,
        89453
      ],
      [
        0,
        -1009
      ]
    ],
    [
      [
        7285,
        88444
      ],
      [
        -135,
        0
      ],
      [
        0,
        -303
      ],
      [
        12,
        0
      ],
      [
        0,
        -302
      ]
    ],
    [
      [
        6449,
        87839
      ],
      [
        -325,
        0
      ],
      [
        0,
        101
      ],
      [
        -99,
        0
      ],
      [
        0,
        -101
      ],
      [
        -50,
        0
      ],
      [
        0,
        -101
      ],
      [
        -49,
        0
      ],
      [
        0,
        101
      ],
      [
        -297,
        0
      ],
      [
        0,
        -101
      ],
      [
        -20,
        0
      ],
      [
        0,
        -101
      ],
      [
        -49,
        0
      ],
      [
        0,
        -101
      ],
      [
        -49,
        0
      ],
      [
        0,
        -202
      ],
      [
        -19,
        0
      ],
      [
        0,
        -101
      ],
      [
        -48,
        0
      ],
      [
        0,
        -201
      ],
      [
        -49,
        0
      ],
      [
        0,
        -101
      ],
      [
        -17,
        0
      ],
      [
        0,
        -202
      ],
      [
        -48,
        0
      ],
      [
        0,
        -202
      ],
      [
        -65,
        0
      ],
      [
        0,
        -202
      ],
      [
        -47,
        0
      ],
      [
        0,
        -201
      ],
      [
        -16,
        0
      ],
      [
        0,
        -101
      ],
      [
        -47,
        0
      ],
      [
        0,
        -101
      ],
      [
        -47,
        0
      ],
      [
        0,
        -202
      ],
      [
        -14,
        0
      ],
      [
        0,
        -101
      ],
      [
        -47,
        0
      ],
      [
        0,
        -186
      ],
      [
        -1,
        -1
      ]
    ],
    [
      [
        5046,
        85432
      ],
      [
        -10,
        -15
      ]
    ],
    [
      [
        5036,
        85417
      ],
      [
        -82,
        0
      ],
      [
        0,
        -101
      ],
      [
        7,
        0
      ]
    ],
    [
      [
        4961,
        85316
      ],
      [
        -9,
        -36
      ],
      [
        0,
        -49
      ],
      [
        -41,
        -38
      ],
      [
        -8,
        -26
      ],
      [
        -22,
        -10
      ],
      [
        -15,
        -44
      ],
      [
        -20,
        -15
      ],
      [
        -4,
        55
      ],
      [
        -29,
        45
      ],
      [
        -54,
        -20
      ],
      [
        -29,
        33
      ],
      [
        49,
        47
      ],
      [
        15,
        -39
      ],
      [
        18,
        12
      ],
      [
        5,
        50
      ],
      [
        25,
        77
      ],
      [
        3,
        60
      ],
      [
        -8,
        85
      ],
      [
        0,
        46
      ],
      [
        1,
        35
      ],
      [
        -16,
        74
      ],
      [
        5,
        21
      ],
      [
        -10,
        13
      ],
      [
        -6,
        7
      ],
      [
        -29,
        97
      ],
      [
        -18,
        120
      ],
      [
        -2,
        19
      ],
      [
        6,
        21
      ],
      [
        11,
        58
      ],
      [
        11,
        16
      ],
      [
        1,
        33
      ],
      [
        21,
        23
      ],
      [
        7,
        37
      ],
      [
        10,
        6
      ],
      [
        7,
        36
      ],
      [
        14,
        -2
      ],
      [
        10,
        28
      ],
      [
        -15,
        77
      ],
      [
        -18,
        44
      ],
      [
        -15,
        64
      ],
      [
        -3,
        57
      ],
      [
        -7,
        50
      ],
      [
        -29,
        102
      ],
      [
        -21,
        60
      ],
      [
        -5,
        46
      ],
      [
        2,
        28
      ],
      [
        -2,
        11
      ],
      [
        -3,
        13
      ],
      [
        -6,
        3
      ],
      [
        -8,
        19
      ],
      [
        -6,
        21
      ],
      [
        -4,
        23
      ],
      [
        -6,
        40
      ],
      [
        -11,
        15
      ],
      [
        -2,
        21
      ],
      [
        -17,
        49
      ],
      [
        -10,
        44
      ],
      [
        -22,
        9
      ],
      [
        -11,
        -37
      ],
      [
        -2,
        -32
      ],
      [
        0,
        -42
      ],
      [
        6,
        -37
      ],
      [
        -8,
        -56
      ],
      [
        -7,
        -11
      ],
      [
        -5,
        -10
      ],
      [
        -11,
        -5
      ],
      [
        -10,
        -6
      ],
      [
        -6,
        1
      ],
      [
        -18,
        21
      ],
      [
        -10,
        -7
      ],
      [
        2,
        -14
      ],
      [
        -3,
        -13
      ],
      [
        -8,
        -20
      ],
      [
        -9,
        -12
      ],
      [
        -14,
        -10
      ],
      [
        -13,
        -7
      ],
      [
        -7,
        -13
      ],
      [
        -19,
        -26
      ],
      [
        -24,
        -29
      ],
      [
        -24,
        -18
      ],
      [
        -49,
        -30
      ],
      [
        -11,
        -4
      ],
      [
        -48,
        -17
      ],
      [
        -29,
        -7
      ],
      [
        -12,
        -1
      ],
      [
        -18,
        1
      ],
      [
        -45,
        10
      ],
      [
        -41,
        28
      ],
      [
        -10,
        10
      ],
      [
        -5,
        10
      ],
      [
        -8,
        22
      ],
      [
        -11,
        60
      ],
      [
        -2,
        22
      ],
      [
        0,
        17
      ],
      [
        3,
        7
      ],
      [
        5,
        7
      ],
      [
        5,
        3
      ],
      [
        10,
        1
      ],
      [
        3,
        10
      ],
      [
        -5,
        21
      ],
      [
        -16,
        38
      ],
      [
        -31,
        35
      ],
      [
        -9,
        2
      ],
      [
        -14,
        25
      ],
      [
        -21,
        70
      ],
      [
        -11,
        38
      ],
      [
        2,
        8
      ],
      [
        -1,
        9
      ],
      [
        -3,
        11
      ],
      [
        -3,
        6
      ],
      [
        -7,
        7
      ],
      [
        -4,
        2
      ],
      [
        -11,
        18
      ],
      [
        -6,
        14
      ],
      [
        -5,
        10
      ],
      [
        -3,
        12
      ],
      [
        -2,
        11
      ],
      [
        0,
        6
      ],
      [
        -13,
        33
      ],
      [
        -7,
        -6
      ],
      [
        -14,
        3
      ],
      [
        -21,
        11
      ],
      [
        -13,
        16
      ],
      [
        -18,
        26
      ],
      [
        -12,
        24
      ],
      [
        -15,
        31
      ],
      [
        -20,
        55
      ],
      [
        0,
        6
      ],
      [
        2,
        12
      ],
      [
        1,
        2
      ],
      [
        14,
        11
      ],
      [
        6,
        1
      ],
      [
        9,
        12
      ],
      [
        5,
        10
      ],
      [
        10,
        33
      ],
      [
        2,
        22
      ],
      [
        -2,
        7
      ],
      [
        -1,
        4
      ],
      [
        -1,
        3
      ],
      [
        -5,
        3
      ],
      [
        -19,
        3
      ],
      [
        -38,
        -54
      ],
      [
        -15,
        -2
      ],
      [
        -33,
        12
      ],
      [
        -4,
        7
      ],
      [
        -7,
        25
      ],
      [
        -5,
        19
      ],
      [
        1,
        2
      ],
      [
        1,
        7
      ],
      [
        9,
        23
      ],
      [
        4,
        3
      ],
      [
        6,
        0
      ],
      [
        9,
        -5
      ],
      [
        7,
        -1
      ],
      [
        6,
        4
      ],
      [
        25,
        52
      ],
      [
        2,
        6
      ],
      [
        7,
        26
      ],
      [
        23,
        44
      ],
      [
        3,
        1
      ],
      [
        2,
        -3
      ],
      [
        5,
        -2
      ],
      [
        10,
        15
      ],
      [
        6,
        15
      ],
      [
        1,
        7
      ],
      [
        0,
        8
      ],
      [
        -2,
        6
      ],
      [
        -10,
        18
      ],
      [
        -4,
        10
      ],
      [
        -2,
        8
      ],
      [
        -3,
        14
      ],
      [
        0,
        14
      ],
      [
        1,
        5
      ],
      [
        1,
        -2
      ],
      [
        4,
        -2
      ],
      [
        12,
        6
      ],
      [
        9,
        12
      ],
      [
        6,
        10
      ],
      [
        -5,
        16
      ],
      [
        -19,
        -9
      ],
      [
        -3,
        0
      ],
      [
        -3,
        12
      ],
      [
        0,
        14
      ],
      [
        8,
        44
      ],
      [
        16,
        53
      ],
      [
        1,
        4
      ],
      [
        4,
        1
      ],
      [
        3,
        3
      ],
      [
        3,
        17
      ],
      [
        -5,
        5
      ],
      [
        -5,
        -2
      ],
      [
        -7,
        0
      ],
      [
        -3,
        -14
      ],
      [
        -8,
        -13
      ],
      [
        -7,
        -21
      ],
      [
        -27,
        20
      ]
    ],
    [
      [
        3261,
        87028
      ],
      [
        13,
        0
      ],
      [
        7,
        7
      ],
      [
        8,
        10
      ],
      [
        7,
        8
      ],
      [
        12,
        -1
      ],
      [
        10,
        -2
      ],
      [
        10,
        6
      ],
      [
        12,
        -5
      ],
      [
        13,
        2
      ],
      [
        9,
        -11
      ],
      [
        13,
        -9
      ],
      [
        9,
        5
      ],
      [
        14,
        5
      ],
      [
        9,
        -24
      ],
      [
        8,
        10
      ],
      [
        5,
        3
      ],
      [
        8,
        -3
      ],
      [
        7,
        15
      ],
      [
        3,
        15
      ],
      [
        -2,
        16
      ],
      [
        -6,
        22
      ],
      [
        6,
        17
      ],
      [
        12,
        21
      ],
      [
        9,
        12
      ],
      [
        7,
        18
      ],
      [
        14,
        -1
      ],
      [
        13,
        -9
      ],
      [
        10,
        -1
      ],
      [
        3,
        12
      ],
      [
        -3,
        25
      ],
      [
        9,
        14
      ],
      [
        9,
        13
      ],
      [
        7,
        19
      ],
      [
        15,
        -15
      ],
      [
        10,
        -17
      ],
      [
        8,
        -8
      ],
      [
        12,
        16
      ],
      [
        12,
        16
      ],
      [
        13,
        8
      ],
      [
        10,
        1
      ],
      [
        10,
        41
      ],
      [
        5,
        13
      ],
      [
        6,
        -22
      ],
      [
        3,
        -36
      ],
      [
        4,
        -23
      ],
      [
        2,
        -18
      ],
      [
        8,
        -12
      ],
      [
        -4,
        -21
      ],
      [
        13,
        -4
      ],
      [
        14,
        -6
      ],
      [
        9,
        7
      ],
      [
        10,
        20
      ],
      [
        10,
        7
      ],
      [
        14,
        -15
      ],
      [
        15,
        -5
      ],
      [
        3,
        -17
      ],
      [
        13,
        -2
      ],
      [
        11,
        -21
      ],
      [
        0,
        -25
      ],
      [
        -4,
        -21
      ],
      [
        -6,
        -3
      ],
      [
        -2,
        -16
      ],
      [
        8,
        -12
      ],
      [
        3,
        -32
      ],
      [
        -8,
        -20
      ],
      [
        -3,
        -20
      ],
      [
        5,
        -13
      ],
      [
        8,
        2
      ],
      [
        0,
        -13
      ],
      [
        3,
        -22
      ],
      [
        1,
        -30
      ],
      [
        -6,
        -17
      ],
      [
        -5,
        -8
      ],
      [
        -2,
        -13
      ],
      [
        8,
        -14
      ],
      [
        2,
        -28
      ],
      [
        11,
        -12
      ],
      [
        -3,
        -24
      ],
      [
        -2,
        -14
      ],
      [
        7,
        -20
      ],
      [
        8,
        3
      ],
      [
        13,
        7
      ],
      [
        -2,
        -12
      ],
      [
        -3,
        -13
      ],
      [
        -6,
        -9
      ],
      [
        2,
        -17
      ],
      [
        5,
        -8
      ],
      [
        -5,
        -23
      ],
      [
        -12,
        -8
      ],
      [
        -14,
        -3
      ],
      [
        -8,
        -18
      ],
      [
        -6,
        18
      ],
      [
        -12,
        2
      ],
      [
        -8,
        -6
      ],
      [
        -11,
        -6
      ],
      [
        -5,
        -24
      ],
      [
        -1,
        -10
      ],
      [
        -11,
        8
      ],
      [
        -9,
        11
      ],
      [
        -14,
        -7
      ],
      [
        -12,
        -11
      ],
      [
        -17,
        -26
      ],
      [
        -7,
        -14
      ],
      [
        -4,
        -18
      ],
      [
        4,
        -13
      ],
      [
        4,
        -19
      ],
      [
        3,
        -10
      ],
      [
        -3,
        -22
      ],
      [
        -4,
        -3
      ],
      [
        -12,
        -7
      ],
      [
        -10,
        2
      ],
      [
        -5,
        11
      ],
      [
        0,
        18
      ],
      [
        -18,
        42
      ],
      [
        -12,
        16
      ],
      [
        -8,
        1
      ],
      [
        -5,
        15
      ],
      [
        -13,
        15
      ],
      [
        -10,
        2
      ],
      [
        -12,
        -10
      ],
      [
        -7,
        2
      ],
      [
        -6,
        2
      ],
      [
        -12,
        -2
      ],
      [
        -10,
        2
      ],
      [
        -8,
        15
      ],
      [
        -6,
        20
      ],
      [
        -14,
        11
      ],
      [
        -14,
        7
      ],
      [
        -2,
        11
      ],
      [
        -25,
        47
      ],
      [
        -22,
        26
      ],
      [
        -13,
        16
      ],
      [
        -11,
        6
      ],
      [
        -11,
        4
      ],
      [
        -10,
        0
      ],
      [
        -8,
        9
      ],
      [
        -11,
        20
      ],
      [
        -16,
        32
      ],
      [
        -5,
        20
      ],
      [
        -6,
        3
      ],
      [
        -9,
        1
      ],
      [
        -10,
        6
      ],
      [
        1,
        12
      ],
      [
        -1,
        29
      ],
      [
        -2,
        29
      ],
      [
        -7,
        23
      ],
      [
        -10,
        35
      ],
      [
        -8,
        24
      ],
      [
        -7,
        13
      ],
      [
        4,
        2
      ]
    ],
    [
      [
        1695,
        87369
      ],
      [
        5,
        13
      ],
      [
        -1,
        13
      ],
      [
        0,
        19
      ],
      [
        2,
        24
      ],
      [
        13,
        18
      ],
      [
        12,
        34
      ],
      [
        11,
        -3
      ],
      [
        -1,
        -24
      ],
      [
        -3,
        -16
      ],
      [
        0,
        -18
      ],
      [
        7,
        -26
      ],
      [
        5,
        -28
      ],
      [
        11,
        -28
      ],
      [
        8,
        -8
      ],
      [
        14,
        -34
      ],
      [
        16,
        -21
      ],
      [
        20,
        -25
      ],
      [
        12,
        -17
      ],
      [
        22,
        -14
      ],
      [
        19,
        2
      ],
      [
        6,
        11
      ],
      [
        12,
        -12
      ],
      [
        2,
        -9
      ],
      [
        10,
        -21
      ],
      [
        15,
        -26
      ],
      [
        11,
        -16
      ],
      [
        7,
        -10
      ],
      [
        -4,
        -5
      ],
      [
        -6,
        -12
      ],
      [
        -11,
        -2
      ],
      [
        -4,
        19
      ],
      [
        -5,
        18
      ],
      [
        -16,
        9
      ],
      [
        -17,
        0
      ],
      [
        -18,
        -1
      ],
      [
        -19,
        -16
      ],
      [
        -7,
        -1
      ],
      [
        -7,
        18
      ],
      [
        -21,
        24
      ],
      [
        -5,
        4
      ],
      [
        -10,
        30
      ],
      [
        -17,
        35
      ],
      [
        -21,
        41
      ],
      [
        -4,
        5
      ],
      [
        -5,
        17
      ],
      [
        -1,
        8
      ],
      [
        -9,
        4
      ],
      [
        -10,
        8
      ],
      [
        -10,
        9
      ],
      [
        -6,
        2
      ],
      [
        -2,
        8
      ]
    ],
    [
      [
        1687,
        87598
      ],
      [
        5,
        6
      ],
      [
        3,
        -11
      ],
      [
        1,
        -46
      ],
      [
        5,
        -29
      ],
      [
        -1,
        -9
      ],
      [
        -20,
        42
      ],
      [
        7,
        47
      ]
    ],
    [
      [
        20921,
        67988
      ],
      [
        0,
        335
      ]
    ],
    [
      [
        21089,
        68323
      ],
      [
        112,
        0
      ],
      [
        185,
        -1
      ],
      [
        -5,
        21
      ],
      [
        5,
        11
      ],
      [
        -4,
        5
      ],
      [
        2,
        36
      ],
      [
        6,
        8
      ],
      [
        0,
        14
      ],
      [
        4,
        10
      ],
      [
        -3,
        38
      ],
      [
        2,
        41
      ],
      [
        5,
        36
      ],
      [
        1,
        23
      ],
      [
        5,
        22
      ],
      [
        3,
        -5
      ],
      [
        3,
        13
      ],
      [
        -1,
        20
      ],
      [
        -1,
        49
      ],
      [
        2,
        -4
      ],
      [
        5,
        21
      ],
      [
        8,
        -2
      ],
      [
        9,
        6
      ],
      [
        0,
        -10
      ],
      [
        7,
        -11
      ],
      [
        9,
        -8
      ],
      [
        6,
        20
      ],
      [
        8,
        -10
      ],
      [
        6,
        22
      ],
      [
        6,
        16
      ],
      [
        -1,
        8
      ],
      [
        6,
        9
      ],
      [
        4,
        24
      ],
      [
        10,
        9
      ]
    ],
    [
      [
        21493,
        68754
      ],
      [
        0,
        -193
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -406
      ]
    ],
    [
      [
        21492,
        68153
      ],
      [
        -4,
        -1
      ],
      [
        0,
        -332
      ],
      [
        -1,
        5
      ],
      [
        -4,
        -17
      ],
      [
        1,
        -11
      ],
      [
        -17,
        7
      ],
      [
        -1,
        -12
      ],
      [
        -4,
        9
      ],
      [
        2,
        11
      ],
      [
        -3,
        13
      ],
      [
        -6,
        -14
      ]
    ],
    [
      [
        21455,
        67811
      ],
      [
        -4,
        6
      ],
      [
        -6,
        -22
      ],
      [
        -177,
        0
      ]
    ],
    [
      [
        22408,
        69607
      ],
      [
        205,
        -4
      ]
    ],
    [
      [
        22613,
        69603
      ],
      [
        0,
        -102
      ]
    ],
    [
      [
        22614,
        68894
      ],
      [
        -101,
        1
      ],
      [
        -101,
        2
      ]
    ],
    [
      [
        22409,
        69203
      ],
      [
        -1,
        404
      ]
    ],
    [
      [
        22941,
        67092
      ],
      [
        98,
        0
      ]
    ],
    [
      [
        23039,
        67092
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -9
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        0
      ],
      [
        0,
        2
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        -8
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        -3,
        -3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -9
      ],
      [
        0,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        0
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        1,
        -3
      ],
      [
        0,
        -1
      ],
      [
        2,
        -6
      ],
      [
        1,
        -1
      ],
      [
        2,
        -5
      ],
      [
        0,
        -15
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        2,
        -6
      ],
      [
        1,
        -2
      ],
      [
        2,
        0
      ],
      [
        0,
        -3
      ],
      [
        1,
        -10
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -5
      ],
      [
        -4,
        -13
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        1,
        -2
      ],
      [
        1,
        -9
      ],
      [
        0,
        -2
      ]
    ],
    [
      [
        23041,
        66402
      ],
      [
        -4,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        -3,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        1
      ],
      [
        -3,
        3
      ],
      [
        -2,
        2
      ],
      [
        0,
        2
      ],
      [
        -2,
        9
      ],
      [
        -1,
        3
      ],
      [
        0,
        5
      ],
      [
        -1,
        4
      ],
      [
        -1,
        7
      ],
      [
        -1,
        3
      ],
      [
        -1,
        2
      ],
      [
        -2,
        4
      ],
      [
        -3,
        3
      ],
      [
        -2,
        0
      ],
      [
        -3,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        -9
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        -4,
        9
      ],
      [
        -1,
        4
      ],
      [
        -1,
        8
      ]
    ],
    [
      [
        22989,
        66441
      ],
      [
        0,
        19
      ],
      [
        -1,
        8
      ],
      [
        0,
        5
      ],
      [
        -2,
        7
      ],
      [
        -1,
        4
      ],
      [
        -3,
        6
      ],
      [
        -5,
        6
      ],
      [
        -1,
        3
      ],
      [
        -2,
        5
      ],
      [
        -3,
        14
      ],
      [
        -2,
        11
      ],
      [
        -1,
        5
      ],
      [
        -1,
        5
      ],
      [
        0,
        10
      ],
      [
        1,
        6
      ],
      [
        0,
        4
      ],
      [
        3,
        14
      ],
      [
        1,
        5
      ],
      [
        1,
        3
      ],
      [
        1,
        2
      ],
      [
        0,
        8
      ],
      [
        -1,
        4
      ],
      [
        -2,
        3
      ],
      [
        -8,
        9
      ],
      [
        -3,
        0
      ],
      [
        -3,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        -3
      ],
      [
        -4,
        2
      ],
      [
        -5,
        3
      ],
      [
        -1,
        3
      ],
      [
        -1,
        1
      ],
      [
        0,
        34
      ],
      [
        -1,
        6
      ]
    ],
    [
      [
        22941,
        66650
      ],
      [
        0,
        442
      ]
    ],
    [
      [
        27381,
        54959
      ],
      [
        3,
        18
      ],
      [
        6,
        28
      ],
      [
        3,
        5
      ]
    ],
    [
      [
        27393,
        55010
      ],
      [
        5,
        -17
      ],
      [
        12,
        -17
      ],
      [
        6,
        -1
      ],
      [
        1,
        9
      ],
      [
        9,
        -10
      ],
      [
        1,
        -10
      ],
      [
        5,
        9
      ],
      [
        5,
        -6
      ],
      [
        -4,
        -17
      ],
      [
        1,
        -10
      ],
      [
        3,
        2
      ],
      [
        2,
        -39
      ],
      [
        4,
        -19
      ],
      [
        5,
        -6
      ],
      [
        2,
        -11
      ],
      [
        3,
        10
      ],
      [
        3,
        -11
      ],
      [
        4,
        6
      ],
      [
        3,
        -9
      ],
      [
        -2,
        -14
      ],
      [
        4,
        0
      ],
      [
        1,
        -18
      ],
      [
        3,
        18
      ],
      [
        5,
        -43
      ],
      [
        6,
        -18
      ],
      [
        2,
        -10
      ],
      [
        0,
        -9
      ],
      [
        8,
        -14
      ]
    ],
    [
      [
        27490,
        54755
      ],
      [
        -1,
        -9
      ],
      [
        -1,
        -19
      ],
      [
        1,
        -15
      ],
      [
        0,
        -1
      ],
      [
        4,
        -26
      ],
      [
        3,
        -17
      ],
      [
        6,
        0
      ],
      [
        1,
        -10
      ],
      [
        0,
        -14
      ],
      [
        -1,
        -17
      ],
      [
        -3,
        -29
      ],
      [
        -3,
        -16
      ],
      [
        0,
        -12
      ],
      [
        -3,
        -8
      ],
      [
        -14,
        -24
      ],
      [
        -6,
        -14
      ],
      [
        -2,
        -6
      ],
      [
        -7,
        -10
      ],
      [
        -7,
        1
      ],
      [
        -6,
        -16
      ],
      [
        -6,
        -5
      ],
      [
        -2,
        11
      ],
      [
        0,
        30
      ],
      [
        -2,
        3
      ],
      [
        -10,
        11
      ],
      [
        -7,
        26
      ],
      [
        -4,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -16
      ],
      [
        -5,
        1
      ],
      [
        -3,
        -16
      ],
      [
        1,
        -15
      ],
      [
        6,
        -17
      ],
      [
        0,
        -1
      ],
      [
        6,
        3
      ],
      [
        11,
        -36
      ],
      [
        3,
        -23
      ],
      [
        -6,
        -18
      ],
      [
        -9,
        -47
      ],
      [
        -8,
        -24
      ],
      [
        -11,
        -20
      ],
      [
        -6,
        -15
      ],
      [
        -3,
        -1
      ],
      [
        -2,
        5
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        -3
      ],
      [
        -4,
        -12
      ],
      [
        -6,
        -23
      ]
    ],
    [
      [
        26701,
        58725
      ],
      [
        3,
        7
      ],
      [
        6,
        123
      ],
      [
        4,
        -12
      ],
      [
        2,
        55
      ],
      [
        4,
        15
      ],
      [
        -3,
        29
      ],
      [
        5,
        3
      ]
    ],
    [
      [
        26722,
        58945
      ],
      [
        2,
        9
      ],
      [
        -5,
        37
      ],
      [
        7,
        4
      ],
      [
        -1,
        25
      ],
      [
        2,
        1
      ],
      [
        6,
        -25
      ],
      [
        5,
        -1
      ],
      [
        -2,
        57
      ],
      [
        5,
        5
      ]
    ],
    [
      [
        26741,
        59057
      ],
      [
        -2,
        -28
      ],
      [
        6,
        -14
      ],
      [
        3,
        -18
      ],
      [
        7,
        -9
      ],
      [
        -1,
        -11
      ],
      [
        5,
        10
      ],
      [
        8,
        -31
      ],
      [
        5,
        -4
      ],
      [
        1,
        -15
      ],
      [
        12,
        -44
      ],
      [
        14,
        -47
      ],
      [
        17,
        -64
      ]
    ],
    [
      [
        26816,
        58782
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -14
      ],
      [
        1,
        -8
      ],
      [
        1,
        -13
      ],
      [
        1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        1,
        -4
      ],
      [
        0,
        -11
      ],
      [
        -4,
        -7
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -11
      ],
      [
        1,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -7
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -10
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -10
      ]
    ],
    [
      [
        26798,
        58604
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        -3,
        -5
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        5
      ],
      [
        -2,
        2
      ],
      [
        -7,
        9
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        0
      ],
      [
        0,
        2
      ],
      [
        -1,
        2
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -2,
        2
      ],
      [
        0,
        2
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        -9
      ],
      [
        -1,
        -2
      ],
      [
        0,
        1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -3
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        2
      ],
      [
        -6,
        -3
      ],
      [
        0,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -10
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        0
      ],
      [
        -3,
        -5
      ],
      [
        -2,
        1
      ],
      [
        -3,
        -2
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        -6,
        0
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        26716,
        58515
      ],
      [
        -6,
        -2
      ],
      [
        -1,
        42
      ],
      [
        2,
        23
      ],
      [
        -3,
        13
      ],
      [
        -1,
        17
      ],
      [
        7,
        29
      ],
      [
        -13,
        60
      ],
      [
        0,
        28
      ]
    ],
    [
      [
        28881,
        63990
      ],
      [
        21,
        81
      ],
      [
        21,
        57
      ]
    ],
    [
      [
        28923,
        64128
      ],
      [
        1,
        2
      ],
      [
        9,
        23
      ],
      [
        12,
        28
      ],
      [
        16,
        30
      ]
    ],
    [
      [
        28961,
        64211
      ],
      [
        1,
        -2
      ],
      [
        1,
        -5
      ],
      [
        0,
        -13
      ]
    ],
    [
      [
        29032,
        63900
      ],
      [
        1,
        -4
      ],
      [
        2,
        -6
      ],
      [
        1,
        -4
      ],
      [
        3,
        -8
      ],
      [
        3,
        -6
      ],
      [
        1,
        -2
      ],
      [
        2,
        -1
      ],
      [
        1,
        -2
      ],
      [
        2,
        -3
      ],
      [
        1,
        -6
      ],
      [
        4,
        -12
      ],
      [
        1,
        -5
      ],
      [
        1,
        -7
      ],
      [
        1,
        -8
      ],
      [
        1,
        -9
      ],
      [
        2,
        -13
      ],
      [
        1,
        -10
      ],
      [
        2,
        -5
      ],
      [
        3,
        -5
      ],
      [
        1,
        -4
      ],
      [
        7,
        -10
      ],
      [
        4,
        -10
      ],
      [
        3,
        -7
      ],
      [
        0,
        -1
      ],
      [
        1,
        -8
      ],
      [
        2,
        -9
      ],
      [
        0,
        -1
      ],
      [
        1,
        -11
      ],
      [
        0,
        -3
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        2,
        -3
      ],
      [
        2,
        -4
      ],
      [
        1,
        -3
      ],
      [
        3,
        -16
      ],
      [
        1,
        -3
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -4
      ]
    ],
    [
      [
        29093,
        63678
      ],
      [
        0,
        -6
      ],
      [
        -5,
        -12
      ],
      [
        0,
        -1
      ],
      [
        -5,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -4
      ],
      [
        -3,
        -10
      ],
      [
        -2,
        0
      ],
      [
        -3,
        3
      ],
      [
        -4,
        4
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -10
      ],
      [
        -1,
        -9
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -4
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -5,
        -4
      ],
      [
        -2,
        -3
      ],
      [
        -6,
        -7
      ],
      [
        -3,
        1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        -6
      ],
      [
        -9,
        -16
      ]
    ],
    [
      [
        29023,
        63560
      ],
      [
        -3,
        9
      ],
      [
        1,
        9
      ],
      [
        3,
        10
      ],
      [
        4,
        25
      ],
      [
        -2,
        28
      ],
      [
        -8,
        16
      ],
      [
        -1,
        -6
      ],
      [
        -5,
        12
      ]
    ],
    [
      [
        29012,
        63663
      ],
      [
        -4,
        10
      ],
      [
        -12,
        29
      ],
      [
        -10,
        24
      ],
      [
        -8,
        22
      ],
      [
        -22,
        54
      ],
      [
        -8,
        20
      ],
      [
        -25,
        63
      ],
      [
        -5,
        14
      ],
      [
        -15,
        35
      ],
      [
        -1,
        5
      ],
      [
        -10,
        25
      ],
      [
        -11,
        26
      ]
    ],
    [
      [
        22709,
        67191
      ],
      [
        1,
        -369
      ]
    ],
    [
      [
        22710,
        66822
      ],
      [
        -3,
        -5
      ],
      [
        -4,
        -3
      ],
      [
        -2,
        -2
      ],
      [
        -5,
        -1
      ],
      [
        -5,
        2
      ],
      [
        -5,
        4
      ],
      [
        -8,
        3
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        0
      ],
      [
        -3,
        1
      ],
      [
        -4,
        4
      ],
      [
        -3,
        6
      ],
      [
        -1,
        1
      ],
      [
        -4,
        3
      ],
      [
        -2,
        7
      ],
      [
        -1,
        1
      ],
      [
        -2,
        0
      ],
      [
        -3,
        -1
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -10
      ],
      [
        -2,
        -10
      ],
      [
        -1,
        -11
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        -3,
        -15
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -6
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        -11
      ],
      [
        -1,
        -3
      ],
      [
        -4,
        -7
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -5,
        1
      ],
      [
        -4,
        -6
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        0
      ],
      [
        -5,
        2
      ],
      [
        0,
        2
      ],
      [
        -2,
        2
      ],
      [
        0,
        1
      ],
      [
        -2,
        1
      ],
      [
        -2,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        10
      ],
      [
        -2,
        4
      ],
      [
        -4,
        11
      ],
      [
        -1,
        2
      ],
      [
        -2,
        4
      ],
      [
        -3,
        11
      ],
      [
        -1,
        2
      ],
      [
        -5,
        11
      ],
      [
        -1,
        2
      ],
      [
        -2,
        13
      ],
      [
        -3,
        8
      ],
      [
        0,
        1
      ],
      [
        -1,
        -2
      ]
    ],
    [
      [
        22566,
        66807
      ],
      [
        -3,
        13
      ],
      [
        4,
        0
      ],
      [
        2,
        17
      ],
      [
        7,
        6
      ],
      [
        1,
        25
      ],
      [
        -3,
        22
      ],
      [
        4,
        19
      ],
      [
        3,
        49
      ],
      [
        1,
        6
      ],
      [
        -5,
        32
      ],
      [
        0,
        23
      ],
      [
        5,
        11
      ],
      [
        -2,
        8
      ],
      [
        -2,
        59
      ],
      [
        1,
        29
      ],
      [
        3,
        7
      ],
      [
        1,
        39
      ],
      [
        4,
        19
      ]
    ],
    [
      [
        25530,
        59236
      ],
      [
        58,
        -26
      ],
      [
        5,
        11
      ]
    ],
    [
      [
        25593,
        59221
      ],
      [
        6,
        -1
      ],
      [
        6,
        3
      ],
      [
        3,
        9
      ],
      [
        4,
        -18
      ],
      [
        11,
        -2
      ],
      [
        7,
        -10
      ],
      [
        -1,
        -39
      ],
      [
        -7,
        -14
      ],
      [
        -3,
        -13
      ],
      [
        2,
        -8
      ],
      [
        3,
        7
      ],
      [
        3,
        -14
      ],
      [
        -4,
        -9
      ],
      [
        -3,
        -19
      ],
      [
        5,
        -12
      ],
      [
        6,
        -29
      ],
      [
        -6,
        -12
      ],
      [
        2,
        -14
      ],
      [
        -2,
        -52
      ],
      [
        0,
        -45
      ],
      [
        -3,
        -25
      ]
    ],
    [
      [
        25622,
        58904
      ],
      [
        -4,
        -81
      ],
      [
        -4,
        -12
      ],
      [
        2,
        -12
      ]
    ],
    [
      [
        25616,
        58799
      ],
      [
        -20,
        6
      ],
      [
        -1,
        -4
      ],
      [
        -6,
        9
      ],
      [
        -40,
        17
      ],
      [
        -13,
        1
      ],
      [
        -12,
        10
      ]
    ],
    [
      [
        25524,
        58838
      ],
      [
        -5,
        27
      ],
      [
        2,
        36
      ],
      [
        0,
        55
      ],
      [
        -2,
        51
      ],
      [
        -4,
        46
      ]
    ],
    [
      [
        23225,
        60010
      ],
      [
        73,
        0
      ]
    ],
    [
      [
        23298,
        60010
      ],
      [
        32,
        0
      ]
    ],
    [
      [
        23330,
        60010
      ],
      [
        0,
        -66
      ],
      [
        -6,
        0
      ],
      [
        0,
        -402
      ]
    ],
    [
      [
        23324,
        59542
      ],
      [
        -106,
        0
      ]
    ],
    [
      [
        23218,
        59542
      ],
      [
        0,
        401
      ],
      [
        7,
        0
      ],
      [
        0,
        67
      ]
    ],
    [
      [
        23021,
        55137
      ],
      [
        62,
        1
      ],
      [
        0,
        32
      ]
    ],
    [
      [
        23144,
        54606
      ],
      [
        -30,
        1
      ],
      [
        -3,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -14,
        5
      ],
      [
        -57,
        0
      ]
    ],
    [
      [
        23018,
        54825
      ],
      [
        2,
        0
      ],
      [
        1,
        292
      ],
      [
        0,
        20
      ]
    ],
    [
      [
        22052,
        56779
      ],
      [
        62,
        -152
      ],
      [
        7,
        9
      ],
      [
        4,
        -9
      ],
      [
        8,
        6
      ],
      [
        7,
        -6
      ],
      [
        2,
        -6
      ],
      [
        6,
        12
      ],
      [
        8,
        -3
      ],
      [
        1,
        -15
      ],
      [
        7,
        -1
      ],
      [
        4,
        -6
      ],
      [
        2,
        -16
      ],
      [
        7,
        -9
      ],
      [
        4,
        21
      ],
      [
        8,
        4
      ],
      [
        4,
        -14
      ],
      [
        4,
        24
      ]
    ],
    [
      [
        22197,
        56618
      ],
      [
        0,
        -293
      ]
    ],
    [
      [
        31200,
        38072
      ],
      [
        18,
        6
      ],
      [
        3,
        -10
      ]
    ],
    [
      [
        31221,
        38068
      ],
      [
        -2,
        -9
      ],
      [
        0,
        -20
      ],
      [
        4,
        -10
      ],
      [
        -1,
        -12
      ],
      [
        -5,
        0
      ]
    ],
    [
      [
        30408,
        68304
      ],
      [
        30,
        -20
      ],
      [
        5,
        53
      ],
      [
        7,
        17
      ],
      [
        24,
        -16
      ],
      [
        1,
        -1
      ],
      [
        2,
        -16
      ]
    ],
    [
      [
        30477,
        68321
      ],
      [
        -5,
        -46
      ],
      [
        -2,
        -11
      ],
      [
        -2,
        -56
      ],
      [
        -7,
        -19
      ],
      [
        17,
        -11
      ],
      [
        2,
        -3
      ],
      [
        13,
        -8
      ],
      [
        -6,
        -42
      ],
      [
        0,
        -46
      ],
      [
        4,
        -5
      ],
      [
        -10,
        -39
      ],
      [
        7,
        -50
      ],
      [
        7,
        8
      ],
      [
        -2,
        -38
      ]
    ],
    [
      [
        30493,
        67955
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -15
      ],
      [
        -1,
        -11
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -12
      ],
      [
        -4,
        -9
      ],
      [
        -3,
        -29
      ],
      [
        -5,
        -8
      ],
      [
        -18,
        -19
      ],
      [
        2,
        -16
      ],
      [
        -1,
        -7
      ],
      [
        -5,
        3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        23
      ],
      [
        0,
        10
      ],
      [
        -1,
        9
      ],
      [
        -2,
        2
      ],
      [
        2,
        19
      ],
      [
        -3,
        20
      ],
      [
        -4,
        3
      ],
      [
        0,
        -2
      ]
    ],
    [
      [
        30441,
        67899
      ],
      [
        0,
        13
      ],
      [
        4,
        31
      ],
      [
        -1,
        43
      ],
      [
        -6,
        17
      ],
      [
        1,
        17
      ],
      [
        7,
        35
      ],
      [
        1,
        10
      ],
      [
        0,
        14
      ],
      [
        2,
        16
      ],
      [
        -5,
        10
      ],
      [
        -8,
        -33
      ],
      [
        -3,
        -5
      ],
      [
        -5,
        -11
      ],
      [
        -6,
        13
      ],
      [
        -4,
        -2
      ],
      [
        -3,
        -7
      ],
      [
        -11,
        36
      ],
      [
        -4,
        35
      ]
    ],
    [
      [
        30400,
        68131
      ],
      [
        -4,
        14
      ],
      [
        -1,
        3
      ],
      [
        5,
        14
      ],
      [
        -1,
        5
      ],
      [
        0,
        12
      ],
      [
        3,
        39
      ],
      [
        6,
        86
      ]
    ],
    [
      [
        22933,
        55826
      ],
      [
        125,
        -9
      ]
    ],
    [
      [
        23058,
        55817
      ],
      [
        0,
        -66
      ],
      [
        25,
        13
      ]
    ],
    [
      [
        23083,
        55333
      ],
      [
        -21,
        0
      ],
      [
        -26,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -10,
        0
      ],
      [
        -4,
        1
      ]
    ],
    [
      [
        23021,
        55334
      ],
      [
        -18,
        1
      ],
      [
        -9,
        1
      ],
      [
        -19,
        1
      ],
      [
        -18,
        1
      ],
      [
        -6,
        1
      ],
      [
        -9,
        0
      ],
      [
        -10,
        1
      ],
      [
        -2,
        0
      ]
    ],
    [
      [
        22930,
        55340
      ],
      [
        0,
        44
      ],
      [
        1,
        70
      ],
      [
        0,
        1
      ],
      [
        1,
        155
      ],
      [
        0,
        50
      ],
      [
        1,
        166
      ]
    ],
    [
      [
        22479,
        53822
      ],
      [
        -8,
        46
      ],
      [
        -49,
        -26
      ]
    ],
    [
      [
        22128,
        53697
      ],
      [
        0,
        -16
      ],
      [
        4,
        -2
      ],
      [
        1,
        19
      ],
      [
        3,
        -22
      ],
      [
        6,
        -4
      ],
      [
        0,
        -9
      ],
      [
        -6,
        -10
      ],
      [
        1,
        -8
      ],
      [
        9,
        4
      ],
      [
        2,
        -9
      ],
      [
        -5,
        -19
      ],
      [
        -2,
        -16
      ],
      [
        4,
        1
      ],
      [
        4,
        -8
      ],
      [
        6,
        -28
      ],
      [
        4,
        5
      ],
      [
        1,
        11
      ],
      [
        -4,
        15
      ],
      [
        2,
        9
      ],
      [
        4,
        -11
      ]
    ],
    [
      [
        22162,
        53599
      ],
      [
        -1,
        -471
      ]
    ],
    [
      [
        21280,
        53785
      ],
      [
        125,
        -1
      ]
    ],
    [
      [
        21410,
        53126
      ],
      [
        -25,
        2
      ]
    ],
    [
      [
        21385,
        53128
      ],
      [
        -4,
        0
      ],
      [
        -4,
        36
      ],
      [
        -3,
        12
      ],
      [
        2,
        24
      ],
      [
        -2,
        51
      ],
      [
        -3,
        19
      ],
      [
        -3,
        4
      ],
      [
        -9,
        29
      ],
      [
        -5,
        18
      ],
      [
        -6,
        11
      ],
      [
        -16,
        10
      ],
      [
        -1,
        -10
      ],
      [
        -5,
        5
      ],
      [
        -4,
        26
      ],
      [
        -3,
        2
      ],
      [
        -4,
        22
      ],
      [
        -6,
        7
      ],
      [
        -4,
        16
      ],
      [
        -9,
        -22
      ],
      [
        -4,
        -3
      ],
      [
        -2,
        -24
      ],
      [
        -6,
        -10
      ],
      [
        -4,
        17
      ]
    ],
    [
      [
        21280,
        53368
      ],
      [
        0,
        417
      ]
    ],
    [
      [
        20699,
        54796
      ],
      [
        3,
        0
      ],
      [
        0,
        515
      ],
      [
        81,
        1
      ],
      [
        53,
        1
      ],
      [
        1,
        0
      ],
      [
        85,
        1
      ],
      [
        66,
        0
      ]
    ],
    [
      [
        20988,
        55314
      ],
      [
        0,
        -516
      ],
      [
        26,
        0
      ],
      [
        0,
        -608
      ]
    ],
    [
      [
        21014,
        54190
      ],
      [
        -7,
        0
      ],
      [
        -36,
        1
      ],
      [
        -29,
        -1
      ]
    ],
    [
      [
        20942,
        54190
      ],
      [
        -12,
        0
      ]
    ],
    [
      [
        20930,
        54190
      ],
      [
        -142,
        0
      ],
      [
        -30,
        1
      ],
      [
        -58,
        0
      ]
    ],
    [
      [
        24274,
        61187
      ],
      [
        15,
        -1
      ],
      [
        4,
        36
      ],
      [
        3,
        1
      ],
      [
        2,
        -13
      ],
      [
        11,
        24
      ],
      [
        40,
        2
      ],
      [
        33,
        -2
      ],
      [
        1,
        119
      ]
    ],
    [
      [
        24383,
        61353
      ],
      [
        27,
        -1
      ]
    ],
    [
      [
        24410,
        61352
      ],
      [
        2,
        0
      ],
      [
        -1,
        -423
      ]
    ],
    [
      [
        23683,
        57798
      ],
      [
        1,
        51
      ],
      [
        30,
        -3
      ],
      [
        1,
        83
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        23715,
        57931
      ],
      [
        0,
        20
      ],
      [
        15,
        -1
      ],
      [
        15,
        -1
      ],
      [
        1,
        105
      ],
      [
        29,
        -7
      ],
      [
        1,
        84
      ],
      [
        0,
        52
      ],
      [
        4,
        -32
      ],
      [
        10,
        -30
      ],
      [
        3,
        -14
      ],
      [
        10,
        12
      ]
    ],
    [
      [
        23803,
        58119
      ],
      [
        7,
        7
      ],
      [
        5,
        28
      ],
      [
        2,
        -2
      ],
      [
        6,
        -20
      ],
      [
        13,
        -3
      ],
      [
        9,
        19
      ],
      [
        9,
        10
      ],
      [
        5,
        -13
      ],
      [
        4,
        -1
      ],
      [
        4,
        10
      ],
      [
        5,
        22
      ],
      [
        8,
        4
      ],
      [
        3,
        -24
      ],
      [
        0,
        -21
      ],
      [
        3,
        -28
      ],
      [
        5,
        -16
      ],
      [
        -1,
        -8
      ],
      [
        -6,
        -8
      ],
      [
        0,
        -11
      ],
      [
        16,
        3
      ],
      [
        8,
        13
      ],
      [
        10,
        -17
      ]
    ],
    [
      [
        23924,
        58052
      ],
      [
        -1,
        -122
      ],
      [
        -10,
        0
      ],
      [
        -39,
        3
      ],
      [
        0,
        -8
      ],
      [
        -5,
        1
      ],
      [
        -3,
        -9
      ],
      [
        0,
        -25
      ],
      [
        -2,
        -7
      ],
      [
        -5,
        0
      ],
      [
        0,
        -17
      ],
      [
        -5,
        1
      ],
      [
        0,
        -17
      ],
      [
        -38,
        3
      ],
      [
        0,
        -17
      ],
      [
        -12,
        1
      ],
      [
        0,
        -102
      ],
      [
        1,
        -32
      ]
    ],
    [
      [
        23790,
        62949
      ],
      [
        0,
        -369
      ]
    ],
    [
      [
        23790,
        62580
      ],
      [
        -8,
        -7
      ],
      [
        -9,
        14
      ],
      [
        -6,
        2
      ],
      [
        -10,
        -13
      ],
      [
        -6,
        -23
      ],
      [
        -8,
        0
      ],
      [
        -4,
        -5
      ],
      [
        -2,
        -32
      ],
      [
        -4,
        -10
      ],
      [
        -7,
        10
      ],
      [
        1,
        19
      ],
      [
        6,
        17
      ],
      [
        0,
        10
      ],
      [
        -5,
        16
      ],
      [
        -13,
        -16
      ],
      [
        -2,
        -16
      ],
      [
        3,
        -28
      ],
      [
        -11,
        -23
      ],
      [
        -7,
        1
      ],
      [
        -5,
        10
      ]
    ],
    [
      [
        23693,
        62506
      ],
      [
        -8,
        32
      ],
      [
        -13,
        9
      ],
      [
        -2,
        5
      ],
      [
        5,
        34
      ],
      [
        -12,
        -6
      ]
    ],
    [
      [
        23663,
        62580
      ],
      [
        1,
        219
      ],
      [
        0,
        69
      ]
    ],
    [
      [
        16820,
        60549
      ],
      [
        263,
        3
      ]
    ],
    [
      [
        17268,
        59977
      ],
      [
        10,
        -30
      ],
      [
        18,
        -57
      ],
      [
        18,
        -57
      ],
      [
        128,
        -405
      ],
      [
        12,
        -37
      ],
      [
        3,
        -10
      ],
      [
        30,
        -98
      ],
      [
        2,
        -3
      ],
      [
        34,
        -111
      ],
      [
        43,
        -138
      ],
      [
        1,
        -3
      ],
      [
        51,
        -164
      ],
      [
        5,
        -18
      ],
      [
        11,
        -35
      ],
      [
        2,
        -6
      ]
    ],
    [
      [
        17636,
        58805
      ],
      [
        27,
        -88
      ],
      [
        17,
        -55
      ],
      [
        5,
        -18
      ],
      [
        6,
        -19
      ]
    ],
    [
      [
        17138,
        58610
      ],
      [
        -81,
        1
      ],
      [
        0,
        -13
      ],
      [
        -23,
        3
      ]
    ],
    [
      [
        17034,
        58601
      ],
      [
        1,
        86
      ],
      [
        6,
        5
      ],
      [
        -2,
        14
      ],
      [
        2,
        19
      ],
      [
        -2,
        23
      ],
      [
        2,
        13
      ],
      [
        -3,
        20
      ],
      [
        -4,
        3
      ],
      [
        -3,
        17
      ],
      [
        2,
        19
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        -1,
        11
      ],
      [
        -4,
        16
      ],
      [
        -3,
        6
      ],
      [
        -2,
        24
      ],
      [
        0,
        6
      ],
      [
        -2,
        10
      ],
      [
        1,
        7
      ],
      [
        -1,
        8
      ],
      [
        -1,
        14
      ],
      [
        0,
        13
      ],
      [
        -2,
        13
      ],
      [
        -3,
        8
      ],
      [
        1,
        18
      ],
      [
        -2,
        18
      ],
      [
        0,
        12
      ],
      [
        2,
        10
      ],
      [
        2,
        13
      ],
      [
        -1,
        11
      ],
      [
        -2,
        11
      ],
      [
        -2,
        14
      ],
      [
        -2,
        7
      ],
      [
        -3,
        7
      ],
      [
        -2,
        8
      ],
      [
        -2,
        16
      ],
      [
        1,
        11
      ],
      [
        -2,
        12
      ],
      [
        -2,
        13
      ],
      [
        0,
        23
      ],
      [
        -2,
        11
      ],
      [
        0,
        22
      ],
      [
        3,
        7
      ],
      [
        1,
        17
      ],
      [
        2,
        4
      ],
      [
        1,
        10
      ],
      [
        0,
        6
      ],
      [
        -3,
        12
      ],
      [
        -3,
        5
      ],
      [
        -2,
        14
      ],
      [
        -4,
        11
      ],
      [
        -3,
        9
      ],
      [
        -1,
        6
      ],
      [
        2,
        11
      ],
      [
        2,
        5
      ],
      [
        1,
        11
      ],
      [
        -1,
        12
      ],
      [
        -2,
        5
      ],
      [
        -1,
        4
      ],
      [
        -3,
        0
      ],
      [
        -3,
        -3
      ],
      [
        -3,
        1
      ],
      [
        -5,
        4
      ],
      [
        -2,
        2
      ],
      [
        0,
        5
      ],
      [
        1,
        6
      ],
      [
        -2,
        14
      ],
      [
        -3,
        11
      ],
      [
        -3,
        11
      ],
      [
        -2,
        8
      ],
      [
        0,
        11
      ],
      [
        2,
        7
      ],
      [
        -1,
        10
      ],
      [
        0,
        17
      ],
      [
        -1,
        4
      ],
      [
        -1,
        1
      ],
      [
        -1,
        6
      ],
      [
        1,
        7
      ],
      [
        -1,
        7
      ],
      [
        -3,
        10
      ],
      [
        -4,
        4
      ],
      [
        -4,
        8
      ],
      [
        0,
        34
      ],
      [
        3,
        4
      ],
      [
        0,
        12
      ],
      [
        -2,
        2
      ],
      [
        -3,
        9
      ],
      [
        -3,
        11
      ],
      [
        -3,
        8
      ],
      [
        0,
        14
      ],
      [
        -2,
        10
      ],
      [
        -2,
        4
      ],
      [
        -1,
        7
      ],
      [
        1,
        5
      ],
      [
        -2,
        12
      ],
      [
        -3,
        12
      ],
      [
        -4,
        8
      ],
      [
        0,
        3
      ],
      [
        9,
        16
      ],
      [
        -2,
        27
      ],
      [
        -5,
        18
      ]
    ],
    [
      [
        27709,
        64282
      ],
      [
        0,
        583
      ]
    ],
    [
      [
        27709,
        64865
      ],
      [
        3,
        -11
      ],
      [
        -1,
        -20
      ],
      [
        1,
        -32
      ],
      [
        0,
        -26
      ],
      [
        7,
        -32
      ],
      [
        -3,
        -20
      ],
      [
        13,
        -18
      ],
      [
        6,
        -2
      ],
      [
        -3,
        -31
      ],
      [
        6,
        -3
      ],
      [
        2,
        -10
      ],
      [
        -11,
        -6
      ],
      [
        0,
        -16
      ],
      [
        8,
        -6
      ],
      [
        5,
        18
      ],
      [
        6,
        -7
      ],
      [
        3,
        5
      ],
      [
        5,
        -10
      ],
      [
        2,
        13
      ],
      [
        6,
        -10
      ],
      [
        2,
        20
      ],
      [
        8,
        -5
      ],
      [
        2,
        -11
      ],
      [
        7,
        9
      ],
      [
        2,
        17
      ],
      [
        12,
        -23
      ],
      [
        0,
        -18
      ],
      [
        3,
        38
      ],
      [
        12,
        0
      ],
      [
        5,
        14
      ],
      [
        5,
        -4
      ],
      [
        7,
        22
      ],
      [
        13,
        25
      ]
    ],
    [
      [
        27842,
        64563
      ],
      [
        0,
        -157
      ],
      [
        -34,
        -151
      ],
      [
        -6,
        -25
      ],
      [
        -26,
        -110
      ]
    ],
    [
      [
        27776,
        64120
      ],
      [
        -4,
        4
      ],
      [
        -9,
        -10
      ],
      [
        -4,
        20
      ],
      [
        -4,
        0
      ],
      [
        -10,
        25
      ],
      [
        -1,
        34
      ],
      [
        4,
        13
      ],
      [
        -7,
        -3
      ],
      [
        -2,
        6
      ],
      [
        -2,
        12
      ],
      [
        1,
        12
      ],
      [
        -1,
        2
      ],
      [
        -5,
        -4
      ],
      [
        0,
        16
      ],
      [
        -1,
        3
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -5,
        24
      ],
      [
        -9,
        17
      ],
      [
        -6,
        -12
      ]
    ],
    [
      [
        27195,
        58344
      ],
      [
        161,
        -25
      ]
    ],
    [
      [
        27359,
        58254
      ],
      [
        -1,
        -24
      ],
      [
        3,
        -18
      ],
      [
        -5,
        -27
      ],
      [
        1,
        -35
      ],
      [
        0,
        -2
      ]
    ],
    [
      [
        27357,
        58148
      ],
      [
        -39,
        8
      ],
      [
        -100,
        15
      ]
    ],
    [
      [
        27195,
        58339
      ],
      [
        0,
        5
      ]
    ],
    [
      [
        26798,
        58604
      ],
      [
        3,
        -30
      ],
      [
        -2,
        -22
      ],
      [
        3,
        -10
      ],
      [
        8,
        7
      ],
      [
        2,
        -33
      ],
      [
        4,
        -14
      ],
      [
        -1,
        -22
      ],
      [
        5,
        -8
      ]
    ],
    [
      [
        26820,
        58472
      ],
      [
        5,
        -51
      ],
      [
        3,
        3
      ],
      [
        2,
        -27
      ],
      [
        9,
        16
      ],
      [
        5,
        -37
      ],
      [
        3,
        -5
      ],
      [
        5,
        -28
      ],
      [
        -3,
        -14
      ],
      [
        3,
        -17
      ],
      [
        -4,
        -18
      ],
      [
        1,
        -7
      ],
      [
        -6,
        -56
      ],
      [
        5,
        -37
      ],
      [
        10,
        -19
      ]
    ],
    [
      [
        26809,
        58022
      ],
      [
        -1,
        13
      ],
      [
        -11,
        14
      ],
      [
        0,
        21
      ],
      [
        -7,
        40
      ],
      [
        -5,
        12
      ],
      [
        -5,
        3
      ],
      [
        -5,
        16
      ],
      [
        0,
        24
      ],
      [
        -3,
        13
      ],
      [
        -7,
        10
      ],
      [
        0,
        15
      ],
      [
        -3,
        2
      ],
      [
        0,
        10
      ],
      [
        -5,
        8
      ],
      [
        -8,
        0
      ],
      [
        0,
        28
      ],
      [
        -7,
        9
      ],
      [
        0,
        15
      ],
      [
        -7,
        6
      ]
    ],
    [
      [
        26735,
        58281
      ],
      [
        4,
        8
      ],
      [
        0,
        19
      ],
      [
        5,
        18
      ],
      [
        -3,
        30
      ],
      [
        -4,
        7
      ],
      [
        -1,
        16
      ],
      [
        2,
        16
      ],
      [
        0,
        18
      ],
      [
        -7,
        26
      ],
      [
        6,
        25
      ],
      [
        -8,
        12
      ],
      [
        -2,
        12
      ],
      [
        -11,
        5
      ]
    ],
    [
      [
        26716,
        58493
      ],
      [
        0,
        22
      ]
    ],
    [
      [
        26583,
        59038
      ],
      [
        5,
        11
      ],
      [
        -4,
        9
      ],
      [
        4,
        21
      ],
      [
        4,
        9
      ],
      [
        2,
        35
      ],
      [
        -1,
        19
      ],
      [
        -2,
        -4
      ],
      [
        0,
        26
      ],
      [
        4,
        7
      ],
      [
        0,
        20
      ],
      [
        6,
        56
      ]
    ],
    [
      [
        26601,
        59247
      ],
      [
        2,
        -14
      ],
      [
        13,
        16
      ],
      [
        5,
        13
      ],
      [
        1,
        12
      ],
      [
        10,
        -5
      ],
      [
        2,
        6
      ],
      [
        5,
        -17
      ],
      [
        0,
        15
      ],
      [
        4,
        -11
      ],
      [
        3,
        18
      ],
      [
        3,
        -12
      ],
      [
        0,
        19
      ],
      [
        4,
        1
      ],
      [
        4,
        -12
      ],
      [
        5,
        6
      ],
      [
        -3,
        17
      ],
      [
        3,
        -1
      ],
      [
        3,
        29
      ],
      [
        6,
        -2
      ],
      [
        1,
        11
      ],
      [
        7,
        -9
      ]
    ],
    [
      [
        26709,
        59306
      ],
      [
        -2,
        -19
      ],
      [
        4,
        -10
      ],
      [
        3,
        -29
      ],
      [
        -3,
        -30
      ],
      [
        5,
        -35
      ]
    ],
    [
      [
        26716,
        59183
      ],
      [
        -3,
        -5
      ],
      [
        0,
        -12
      ],
      [
        -3,
        2
      ],
      [
        0,
        -14
      ],
      [
        -4,
        -2
      ],
      [
        -1,
        18
      ],
      [
        -3,
        -11
      ],
      [
        -6,
        33
      ],
      [
        -2,
        -15
      ],
      [
        -8,
        -6
      ],
      [
        0,
        -13
      ],
      [
        -7,
        -4
      ],
      [
        -9,
        -33
      ],
      [
        1,
        -19
      ],
      [
        -3,
        -9
      ],
      [
        -6,
        7
      ],
      [
        0,
        -32
      ],
      [
        -5,
        -2
      ],
      [
        0,
        -16
      ]
    ],
    [
      [
        26657,
        59050
      ],
      [
        -4,
        -9
      ],
      [
        -2,
        -1
      ],
      [
        -7,
        14
      ],
      [
        -4,
        -18
      ],
      [
        -3,
        22
      ],
      [
        -6,
        -2
      ],
      [
        -2,
        12
      ],
      [
        1,
        -28
      ],
      [
        -5,
        0
      ],
      [
        -2,
        -13
      ],
      [
        -2,
        10
      ],
      [
        -2,
        -30
      ],
      [
        -9,
        7
      ],
      [
        -1,
        -18
      ],
      [
        3,
        -6
      ],
      [
        0,
        -22
      ],
      [
        -3,
        -9
      ],
      [
        -4,
        10
      ],
      [
        1,
        23
      ],
      [
        -7,
        0
      ],
      [
        0,
        -10
      ],
      [
        5,
        -36
      ],
      [
        -3,
        -6
      ]
    ],
    [
      [
        26601,
        58940
      ],
      [
        -5,
        37
      ],
      [
        -4,
        -3
      ],
      [
        -7,
        38
      ],
      [
        -2,
        26
      ]
    ],
    [
      [
        28064,
        65368
      ],
      [
        -1,
        17
      ],
      [
        61,
        1
      ]
    ],
    [
      [
        28124,
        65386
      ],
      [
        42,
        -166
      ],
      [
        17,
        -1
      ]
    ],
    [
      [
        28183,
        65219
      ],
      [
        0,
        -125
      ],
      [
        -29,
        -175
      ]
    ],
    [
      [
        28154,
        64919
      ],
      [
        -40,
        16
      ]
    ],
    [
      [
        28114,
        64935
      ],
      [
        1,
        108
      ],
      [
        -6,
        0
      ],
      [
        1,
        95
      ],
      [
        -47,
        0
      ],
      [
        1,
        230
      ]
    ],
    [
      [
        22908,
        67092
      ],
      [
        33,
        0
      ]
    ],
    [
      [
        22941,
        66650
      ],
      [
        -2,
        3
      ],
      [
        -2,
        2
      ],
      [
        -3,
        0
      ],
      [
        -4,
        5
      ],
      [
        -1,
        3
      ],
      [
        -3,
        7
      ],
      [
        -4,
        4
      ],
      [
        -4,
        1
      ],
      [
        -5,
        10
      ],
      [
        -4,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        0
      ],
      [
        -2,
        1
      ],
      [
        0,
        3
      ],
      [
        -1,
        2
      ],
      [
        0,
        3
      ],
      [
        2,
        11
      ],
      [
        0,
        5
      ],
      [
        -3,
        16
      ],
      [
        -1,
        4
      ],
      [
        -1,
        3
      ],
      [
        -1,
        0
      ],
      [
        -3,
        -1
      ],
      [
        -7,
        2
      ]
    ],
    [
      [
        22882,
        66717
      ],
      [
        -2,
        1
      ],
      [
        -2,
        2
      ],
      [
        0,
        2
      ],
      [
        -6,
        5
      ],
      [
        -4,
        3
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -3,
        -1
      ],
      [
        -6,
        3
      ],
      [
        -1,
        3
      ],
      [
        0,
        8
      ],
      [
        -1,
        3
      ],
      [
        -2,
        7
      ],
      [
        -1,
        7
      ],
      [
        -3,
        5
      ]
    ],
    [
      [
        22842,
        66762
      ],
      [
        0,
        330
      ]
    ],
    [
      [
        28738,
        64565
      ],
      [
        17,
        26
      ],
      [
        24,
        43
      ],
      [
        9,
        12
      ],
      [
        5,
        1
      ],
      [
        19,
        29
      ],
      [
        -3,
        28
      ],
      [
        -4,
        -1
      ],
      [
        -3,
        22
      ],
      [
        0,
        18
      ],
      [
        1,
        23
      ],
      [
        -1,
        9
      ],
      [
        10,
        12
      ],
      [
        11,
        33
      ],
      [
        7,
        3
      ],
      [
        5,
        -14
      ]
    ],
    [
      [
        28835,
        64809
      ],
      [
        1,
        -11
      ],
      [
        7,
        -4
      ],
      [
        2,
        -18
      ],
      [
        10,
        -31
      ],
      [
        5,
        -21
      ],
      [
        18,
        -72
      ],
      [
        -22,
        -42
      ],
      [
        5,
        -26
      ],
      [
        19,
        -106
      ],
      [
        4,
        -27
      ]
    ],
    [
      [
        28884,
        64451
      ],
      [
        -29,
        -18
      ],
      [
        -9,
        -14
      ]
    ],
    [
      [
        28846,
        64419
      ],
      [
        -23,
        -20
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -6
      ],
      [
        -14,
        -29
      ]
    ],
    [
      [
        28805,
        64359
      ],
      [
        -28,
        73
      ],
      [
        -4,
        10
      ],
      [
        -4,
        11
      ],
      [
        -2,
        7
      ],
      [
        -9,
        34
      ],
      [
        -19,
        68
      ],
      [
        -1,
        3
      ]
    ],
    [
      [
        27467,
        57470
      ],
      [
        17,
        0
      ],
      [
        2,
        -1
      ],
      [
        12,
        0
      ],
      [
        4,
        -1
      ],
      [
        5,
        0
      ],
      [
        5,
        -1
      ],
      [
        14,
        -1
      ],
      [
        8,
        0
      ]
    ],
    [
      [
        27534,
        57466
      ],
      [
        4,
        0
      ],
      [
        6,
        -1
      ],
      [
        14,
        0
      ],
      [
        1,
        -1
      ],
      [
        20,
        -1
      ],
      [
        8,
        -1
      ],
      [
        8,
        -1
      ],
      [
        8,
        0
      ],
      [
        8,
        -1
      ],
      [
        4,
        0
      ],
      [
        4,
        -1
      ],
      [
        4,
        0
      ],
      [
        20,
        -2
      ]
    ],
    [
      [
        27643,
        57457
      ],
      [
        -2,
        -6
      ],
      [
        3,
        -42
      ],
      [
        4,
        -12
      ],
      [
        5,
        -15
      ],
      [
        5,
        -41
      ],
      [
        0,
        -13
      ],
      [
        5,
        -26
      ],
      [
        7,
        -19
      ],
      [
        10,
        -10
      ],
      [
        5,
        -41
      ],
      [
        -7,
        -5
      ],
      [
        -8,
        -90
      ]
    ],
    [
      [
        27670,
        57137
      ],
      [
        -3,
        2
      ],
      [
        -5,
        -14
      ],
      [
        -1,
        -15
      ],
      [
        -6,
        -20
      ],
      [
        -5,
        -2
      ],
      [
        -5,
        7
      ],
      [
        -5,
        -9
      ],
      [
        -7,
        0
      ],
      [
        -5,
        16
      ],
      [
        -13,
        -18
      ],
      [
        -5,
        7
      ],
      [
        -8,
        -18
      ],
      [
        -22,
        -47
      ],
      [
        -37,
        -81
      ]
    ],
    [
      [
        27543,
        56945
      ],
      [
        1,
        32
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        9
      ],
      [
        -3,
        28
      ],
      [
        -2,
        3
      ],
      [
        -2,
        54
      ],
      [
        0,
        29
      ],
      [
        -2,
        14
      ],
      [
        -5,
        13
      ],
      [
        -1,
        12
      ],
      [
        -5,
        18
      ],
      [
        -2,
        31
      ],
      [
        0,
        12
      ],
      [
        -3,
        18
      ],
      [
        -5,
        18
      ]
    ],
    [
      [
        27509,
        57234
      ],
      [
        -7,
        32
      ],
      [
        1,
        20
      ],
      [
        -8,
        20
      ],
      [
        -4,
        18
      ],
      [
        -4,
        14
      ],
      [
        0,
        21
      ],
      [
        -8,
        47
      ],
      [
        -8,
        25
      ],
      [
        -4,
        39
      ]
    ],
    [
      [
        27403,
        55565
      ],
      [
        80,
        179
      ],
      [
        2,
        -16
      ],
      [
        0,
        -22
      ],
      [
        3,
        -26
      ],
      [
        16,
        -26
      ],
      [
        9,
        8
      ],
      [
        9,
        -8
      ]
    ],
    [
      [
        27522,
        55654
      ],
      [
        4,
        -10
      ],
      [
        5,
        -59
      ],
      [
        9,
        -19
      ],
      [
        -4,
        -27
      ],
      [
        -5,
        -12
      ],
      [
        14,
        -34
      ],
      [
        10,
        -30
      ],
      [
        17,
        -53
      ],
      [
        5,
        -18
      ],
      [
        4,
        -13
      ]
    ],
    [
      [
        27511,
        55189
      ],
      [
        1,
        17
      ],
      [
        4,
        16
      ],
      [
        -6,
        33
      ],
      [
        1,
        37
      ],
      [
        -4,
        34
      ],
      [
        2,
        10
      ],
      [
        1,
        40
      ],
      [
        4,
        10
      ],
      [
        1,
        6
      ],
      [
        -1,
        15
      ],
      [
        -6,
        1
      ],
      [
        -17,
        21
      ],
      [
        -6,
        -1
      ],
      [
        -2,
        -7
      ],
      [
        -6,
        4
      ],
      [
        -2,
        10
      ],
      [
        -5,
        -13
      ],
      [
        -12,
        -1
      ],
      [
        -10,
        21
      ],
      [
        -12,
        33
      ],
      [
        -3,
        24
      ],
      [
        -8,
        37
      ],
      [
        -7,
        17
      ],
      [
        -10,
        1
      ],
      [
        -5,
        11
      ]
    ],
    [
      [
        23927,
        63158
      ],
      [
        51,
        3
      ],
      [
        34,
        -5
      ],
      [
        29,
        -3
      ]
    ],
    [
      [
        24041,
        63153
      ],
      [
        47,
        -2
      ],
      [
        -1,
        -102
      ]
    ],
    [
      [
        24087,
        63049
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -226
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -101
      ]
    ],
    [
      [
        24083,
        62713
      ],
      [
        -23,
        26
      ],
      [
        -17,
        -137
      ]
    ],
    [
      [
        24043,
        62602
      ],
      [
        -4,
        11
      ],
      [
        -9,
        -16
      ],
      [
        -4,
        2
      ],
      [
        -2,
        9
      ],
      [
        1,
        26
      ],
      [
        -3,
        11
      ],
      [
        -6,
        8
      ],
      [
        -3,
        15
      ],
      [
        1,
        18
      ],
      [
        -2,
        16
      ],
      [
        -4,
        4
      ],
      [
        -13,
        -3
      ],
      [
        -6,
        5
      ],
      [
        -8,
        21
      ],
      [
        -2,
        42
      ],
      [
        -7,
        14
      ]
    ],
    [
      [
        23972,
        62785
      ],
      [
        -3,
        7
      ],
      [
        0,
        31
      ],
      [
        -7,
        9
      ],
      [
        -4,
        -3
      ],
      [
        -3,
        17
      ],
      [
        -5,
        -4
      ],
      [
        -4,
        5
      ],
      [
        -4,
        -7
      ],
      [
        0,
        12
      ],
      [
        -5,
        -6
      ],
      [
        3,
        17
      ],
      [
        -2,
        26
      ],
      [
        -6,
        -17
      ],
      [
        -8,
        0
      ],
      [
        4,
        3
      ],
      [
        -1,
        20
      ],
      [
        -3,
        22
      ],
      [
        3,
        1
      ],
      [
        -5,
        25
      ],
      [
        5,
        35
      ],
      [
        0,
        26
      ],
      [
        -2,
        20
      ],
      [
        1,
        10
      ],
      [
        -2,
        21
      ]
    ],
    [
      [
        29520,
        69339
      ],
      [
        6,
        0
      ],
      [
        23,
        2
      ],
      [
        1,
        -1
      ],
      [
        5,
        0
      ],
      [
        2,
        1
      ],
      [
        2,
        0
      ],
      [
        1,
        -1
      ],
      [
        9,
        0
      ],
      [
        13,
        -1
      ],
      [
        9,
        1
      ],
      [
        2,
        1
      ],
      [
        23,
        1
      ],
      [
        19,
        -1
      ],
      [
        29,
        0
      ],
      [
        24,
        -3
      ],
      [
        2,
        -2
      ],
      [
        7,
        -3
      ]
    ],
    [
      [
        29697,
        69333
      ],
      [
        5,
        -85
      ],
      [
        0,
        -12
      ],
      [
        2,
        -107
      ],
      [
        -13,
        -60
      ]
    ],
    [
      [
        29594,
        68896
      ],
      [
        -31,
        21
      ],
      [
        -25,
        40
      ],
      [
        -28,
        43
      ]
    ],
    [
      [
        29510,
        69000
      ],
      [
        -8,
        43
      ],
      [
        -1,
        15
      ],
      [
        5,
        37
      ],
      [
        9,
        22
      ],
      [
        4,
        74
      ],
      [
        1,
        26
      ],
      [
        -11,
        21
      ],
      [
        -3,
        26
      ],
      [
        3,
        12
      ],
      [
        11,
        63
      ]
    ],
    [
      [
        27914,
        65392
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        27914,
        65393
      ],
      [
        39,
        -1
      ],
      [
        40,
        2
      ],
      [
        9,
        4
      ],
      [
        44,
        2
      ],
      [
        0,
        -32
      ],
      [
        18,
        0
      ]
    ],
    [
      [
        28114,
        64935
      ],
      [
        -69,
        16
      ],
      [
        -45,
        11
      ],
      [
        0,
        -42
      ],
      [
        -18,
        -18
      ]
    ],
    [
      [
        27875,
        65063
      ],
      [
        1,
        96
      ],
      [
        8,
        0
      ],
      [
        0,
        35
      ],
      [
        24,
        -1
      ],
      [
        0,
        -18
      ],
      [
        5,
        0
      ],
      [
        0,
        103
      ],
      [
        1,
        114
      ]
    ],
    [
      [
        28616,
        60609
      ],
      [
        5,
        -4
      ],
      [
        4,
        29
      ],
      [
        14,
        -10
      ]
    ],
    [
      [
        28639,
        60624
      ],
      [
        -2,
        -9
      ],
      [
        0,
        -7
      ],
      [
        2,
        -10
      ],
      [
        7,
        -11
      ],
      [
        6,
        3
      ],
      [
        3,
        10
      ],
      [
        0,
        6
      ],
      [
        -1,
        1
      ],
      [
        1,
        3
      ],
      [
        1,
        2
      ],
      [
        1,
        -3
      ],
      [
        2,
        -7
      ],
      [
        5,
        -31
      ],
      [
        3,
        -40
      ],
      [
        1,
        -29
      ],
      [
        1,
        -21
      ],
      [
        0,
        -20
      ],
      [
        -1,
        -14
      ],
      [
        -2,
        -15
      ],
      [
        -2,
        -2
      ],
      [
        0,
        -4
      ],
      [
        -3,
        -25
      ],
      [
        1,
        -16
      ],
      [
        -1,
        -14
      ],
      [
        -2,
        11
      ],
      [
        -3,
        6
      ],
      [
        -4,
        6
      ],
      [
        -1,
        10
      ],
      [
        -8,
        30
      ],
      [
        -8,
        12
      ],
      [
        -5,
        13
      ],
      [
        -2,
        6
      ],
      [
        0,
        9
      ],
      [
        -3,
        2
      ]
    ],
    [
      [
        28625,
        60476
      ],
      [
        -1,
        15
      ],
      [
        -11,
        8
      ],
      [
        1,
        38
      ],
      [
        -2,
        38
      ],
      [
        4,
        34
      ]
    ],
    [
      [
        24106,
        61676
      ],
      [
        26,
        -3
      ],
      [
        10,
        0
      ]
    ],
    [
      [
        24142,
        61673
      ],
      [
        25,
        -3
      ],
      [
        -1,
        -98
      ],
      [
        22,
        -5
      ],
      [
        13,
        0
      ],
      [
        9,
        -17
      ],
      [
        7,
        15
      ],
      [
        9,
        0
      ]
    ],
    [
      [
        24226,
        61565
      ],
      [
        -1,
        -50
      ]
    ],
    [
      [
        24225,
        61515
      ],
      [
        0,
        -152
      ],
      [
        4,
        -1
      ],
      [
        -1,
        -168
      ]
    ],
    [
      [
        24167,
        61199
      ],
      [
        -31,
        2
      ],
      [
        0,
        16
      ],
      [
        -5,
        1
      ],
      [
        0,
        17
      ],
      [
        -5,
        0
      ],
      [
        0,
        17
      ],
      [
        -5,
        3
      ],
      [
        0,
        31
      ],
      [
        -5,
        0
      ],
      [
        0,
        17
      ],
      [
        -2,
        0
      ],
      [
        0,
        34
      ],
      [
        -3,
        36
      ],
      [
        -10,
        1
      ],
      [
        0,
        48
      ],
      [
        -9,
        0
      ],
      [
        -6,
        11
      ]
    ],
    [
      [
        24086,
        61433
      ],
      [
        2,
        147
      ],
      [
        15,
        0
      ],
      [
        1,
        96
      ],
      [
        2,
        0
      ]
    ],
    [
      [
        20355,
        71488
      ],
      [
        71,
        1
      ],
      [
        0,
        -34
      ],
      [
        60,
        1
      ],
      [
        0,
        -102
      ],
      [
        11,
        0
      ],
      [
        0,
        -101
      ],
      [
        24,
        0
      ],
      [
        0,
        -67
      ],
      [
        12,
        -1
      ],
      [
        0,
        -33
      ],
      [
        58,
        -1
      ],
      [
        0,
        -34
      ],
      [
        71,
        -1
      ],
      [
        0,
        34
      ],
      [
        35,
        -1
      ],
      [
        0,
        51
      ],
      [
        35,
        0
      ]
    ],
    [
      [
        20732,
        71200
      ],
      [
        0,
        -152
      ],
      [
        -48,
        0
      ],
      [
        0,
        -196
      ],
      [
        6,
        0
      ],
      [
        0,
        -206
      ]
    ],
    [
      [
        20690,
        70646
      ],
      [
        -15,
        0
      ],
      [
        0,
        -407
      ],
      [
        -12,
        0
      ]
    ],
    [
      [
        20663,
        70239
      ],
      [
        -49,
        1
      ],
      [
        -140,
        1
      ],
      [
        -148,
        0
      ]
    ],
    [
      [
        20326,
        70241
      ],
      [
        0,
        406
      ],
      [
        11,
        0
      ],
      [
        0,
        101
      ],
      [
        -1,
        302
      ],
      [
        10,
        0
      ],
      [
        0,
        405
      ],
      [
        9,
        0
      ],
      [
        0,
        17
      ]
    ],
    [
      [
        20663,
        70239
      ],
      [
        -2,
        -401
      ],
      [
        0,
        -105
      ],
      [
        -14,
        0
      ],
      [
        0,
        -410
      ]
    ],
    [
      [
        20647,
        69323
      ],
      [
        -10,
        0
      ]
    ],
    [
      [
        20637,
        69323
      ],
      [
        -215,
        0
      ],
      [
        -19,
        1
      ],
      [
        0,
        -1
      ],
      [
        -4,
        -7
      ],
      [
        -27,
        0
      ]
    ],
    [
      [
        20372,
        69316
      ],
      [
        -66,
        0
      ]
    ],
    [
      [
        20306,
        69316
      ],
      [
        0,
        216
      ],
      [
        -5,
        0
      ]
    ],
    [
      [
        20301,
        69532
      ],
      [
        0,
        200
      ],
      [
        13,
        0
      ],
      [
        1,
        472
      ],
      [
        -1,
        37
      ],
      [
        12,
        0
      ]
    ],
    [
      [
        25446,
        60419
      ],
      [
        61,
        129
      ],
      [
        27,
        30
      ],
      [
        34,
        96
      ]
    ],
    [
      [
        25590,
        60467
      ],
      [
        -4,
        -18
      ],
      [
        3,
        -2
      ],
      [
        -6,
        -36
      ],
      [
        -4,
        -9
      ],
      [
        -3,
        -31
      ],
      [
        -5,
        10
      ],
      [
        -4,
        -7
      ],
      [
        -2,
        -45
      ],
      [
        0,
        -14
      ],
      [
        6,
        -15
      ],
      [
        -1,
        -12
      ],
      [
        6,
        -17
      ],
      [
        0,
        -11
      ],
      [
        4,
        -4
      ],
      [
        2,
        -17
      ],
      [
        5,
        -5
      ],
      [
        -3,
        -7
      ],
      [
        2,
        -11
      ],
      [
        -4,
        -6
      ],
      [
        -2,
        -17
      ]
    ],
    [
      [
        25580,
        60193
      ],
      [
        -8,
        0
      ],
      [
        2,
        -15
      ],
      [
        -5,
        -14
      ],
      [
        -32,
        -7
      ],
      [
        -9,
        -24
      ],
      [
        -29,
        35
      ],
      [
        -7,
        14
      ],
      [
        -9,
        2
      ]
    ],
    [
      [
        25483,
        60184
      ],
      [
        -4,
        15
      ],
      [
        -3,
        -1
      ],
      [
        -2,
        20
      ],
      [
        -4,
        0
      ],
      [
        -1,
        17
      ],
      [
        -4,
        -5
      ],
      [
        -1,
        24
      ],
      [
        -4,
        -17
      ],
      [
        -3,
        4
      ],
      [
        1,
        19
      ],
      [
        -5,
        21
      ],
      [
        -4,
        10
      ],
      [
        3,
        16
      ],
      [
        -2,
        29
      ],
      [
        2,
        13
      ],
      [
        -4,
        3
      ],
      [
        3,
        30
      ],
      [
        -7,
        -1
      ],
      [
        0,
        -21
      ],
      [
        -8,
        25
      ],
      [
        5,
        20
      ],
      [
        5,
        4
      ],
      [
        0,
        10
      ]
    ],
    [
      [
        25640,
        71063
      ],
      [
        3,
        2
      ],
      [
        2,
        8
      ],
      [
        6,
        14
      ],
      [
        9,
        5
      ],
      [
        5,
        7
      ],
      [
        3,
        9
      ],
      [
        2,
        -1
      ],
      [
        9,
        -7
      ],
      [
        4,
        -12
      ],
      [
        0,
        -8
      ],
      [
        5,
        -29
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -4
      ],
      [
        5,
        -9
      ],
      [
        7,
        2
      ],
      [
        4,
        -9
      ],
      [
        1,
        -9
      ],
      [
        0,
        -11
      ],
      [
        3,
        -5
      ],
      [
        7,
        -4
      ],
      [
        3,
        0
      ],
      [
        6,
        5
      ],
      [
        1,
        13
      ],
      [
        1,
        13
      ],
      [
        2,
        7
      ],
      [
        4,
        13
      ],
      [
        5,
        2
      ],
      [
        5,
        0
      ],
      [
        4,
        -5
      ],
      [
        2,
        -4
      ],
      [
        0,
        -4
      ],
      [
        5,
        -27
      ],
      [
        3,
        -7
      ],
      [
        1,
        0
      ],
      [
        3,
        19
      ],
      [
        0,
        19
      ],
      [
        1,
        31
      ],
      [
        -3,
        6
      ],
      [
        -2,
        10
      ],
      [
        -2,
        37
      ],
      [
        4,
        13
      ],
      [
        4,
        7
      ],
      [
        1,
        -5
      ],
      [
        2,
        0
      ],
      [
        4,
        2
      ],
      [
        1,
        3
      ],
      [
        7,
        -32
      ],
      [
        -1,
        -18
      ],
      [
        -1,
        -11
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -10
      ],
      [
        -1,
        -8
      ],
      [
        3,
        -8
      ],
      [
        3,
        -1
      ],
      [
        2,
        7
      ],
      [
        0,
        7
      ],
      [
        2,
        4
      ],
      [
        1,
        0
      ],
      [
        0,
        -27
      ],
      [
        6,
        -8
      ],
      [
        8,
        28
      ],
      [
        9,
        21
      ],
      [
        9,
        23
      ],
      [
        3,
        13
      ],
      [
        0,
        8
      ],
      [
        4,
        10
      ],
      [
        2,
        0
      ],
      [
        5,
        -4
      ],
      [
        2,
        1
      ],
      [
        13,
        17
      ],
      [
        11,
        17
      ],
      [
        45,
        88
      ],
      [
        7,
        18
      ],
      [
        7,
        4
      ],
      [
        5,
        -18
      ],
      [
        2,
        -2
      ],
      [
        4,
        -1
      ],
      [
        7,
        4
      ],
      [
        10,
        11
      ],
      [
        12,
        7
      ],
      [
        11,
        4
      ],
      [
        9,
        9
      ],
      [
        12,
        7
      ],
      [
        4,
        -1
      ]
    ],
    [
      [
        25989,
        71075
      ],
      [
        -139,
        1
      ],
      [
        0,
        -203
      ],
      [
        -70,
        2
      ],
      [
        0,
        -203
      ]
    ],
    [
      [
        25780,
        70672
      ],
      [
        -140,
        0
      ]
    ],
    [
      [
        25640,
        70672
      ],
      [
        0,
        391
      ]
    ],
    [
      [
        26790,
        61133
      ],
      [
        5,
        31
      ],
      [
        6,
        11
      ],
      [
        5,
        -5
      ],
      [
        16,
        -22
      ],
      [
        12,
        -11
      ],
      [
        27,
        -60
      ],
      [
        16,
        -28
      ],
      [
        18,
        -15
      ]
    ],
    [
      [
        26895,
        61034
      ],
      [
        -16,
        -32
      ],
      [
        7,
        -34
      ],
      [
        -5,
        -18
      ],
      [
        -3,
        -23
      ],
      [
        6,
        -11
      ],
      [
        -1,
        -29
      ],
      [
        4,
        -38
      ]
    ],
    [
      [
        26887,
        60849
      ],
      [
        -1,
        5
      ],
      [
        -12,
        6
      ],
      [
        1,
        6
      ],
      [
        -6,
        5
      ],
      [
        -5,
        12
      ],
      [
        -4,
        -7
      ],
      [
        -4,
        15
      ],
      [
        -3,
        0
      ],
      [
        -1,
        -17
      ],
      [
        -5,
        5
      ],
      [
        -17,
        -19
      ],
      [
        -7,
        -1
      ],
      [
        -1,
        -11
      ],
      [
        -7,
        -19
      ],
      [
        -7,
        19
      ],
      [
        -4,
        -4
      ]
    ],
    [
      [
        26804,
        60844
      ],
      [
        -3,
        92
      ],
      [
        -11,
        27
      ],
      [
        2,
        20
      ],
      [
        -6,
        28
      ]
    ],
    [
      [
        26786,
        61011
      ],
      [
        4,
        12
      ],
      [
        2,
        34
      ],
      [
        6,
        -6
      ],
      [
        0,
        22
      ],
      [
        -8,
        60
      ]
    ],
    [
      [
        25265,
        63362
      ],
      [
        32,
        0
      ],
      [
        115,
        1
      ]
    ],
    [
      [
        25404,
        63137
      ],
      [
        -17,
        -1
      ],
      [
        -10,
        -4
      ],
      [
        0,
        -34
      ],
      [
        -114,
        -1
      ]
    ],
    [
      [
        25263,
        63097
      ],
      [
        -1,
        163
      ]
    ],
    [
      [
        26802,
        60596
      ],
      [
        2,
        -16
      ],
      [
        4,
        -3
      ]
    ],
    [
      [
        26808,
        60577
      ],
      [
        -1,
        -7
      ],
      [
        27,
        -16
      ],
      [
        0,
        -36
      ],
      [
        -1,
        -25
      ],
      [
        7,
        -4
      ],
      [
        8,
        21
      ],
      [
        5,
        -5
      ],
      [
        2,
        -13
      ],
      [
        0,
        -39
      ],
      [
        1,
        -11
      ],
      [
        -3,
        -21
      ],
      [
        3,
        -18
      ],
      [
        1,
        -24
      ],
      [
        -1,
        -10
      ],
      [
        8,
        -8
      ],
      [
        0,
        -14
      ],
      [
        4,
        -4
      ]
    ],
    [
      [
        26868,
        60343
      ],
      [
        -4,
        -5
      ],
      [
        -2,
        -12
      ]
    ],
    [
      [
        26862,
        60326
      ],
      [
        -7,
        -2
      ],
      [
        -12,
        -9
      ],
      [
        -5,
        8
      ],
      [
        -4,
        -11
      ],
      [
        -6,
        -4
      ],
      [
        -6,
        -16
      ],
      [
        -5,
        -29
      ],
      [
        -8,
        -20
      ],
      [
        -3,
        3
      ],
      [
        -3,
        -14
      ],
      [
        -4,
        0
      ],
      [
        -6,
        -21
      ],
      [
        -1,
        18
      ],
      [
        -5,
        9
      ]
    ],
    [
      [
        26787,
        60238
      ],
      [
        -1,
        11
      ],
      [
        -7,
        4
      ],
      [
        -1,
        10
      ],
      [
        -6,
        -1
      ],
      [
        -4,
        18
      ],
      [
        1,
        15
      ],
      [
        -10,
        -10
      ],
      [
        -4,
        6
      ],
      [
        -3,
        -6
      ],
      [
        2,
        13
      ],
      [
        -2,
        25
      ],
      [
        2,
        31
      ],
      [
        2,
        4
      ],
      [
        -1,
        14
      ],
      [
        1,
        25
      ],
      [
        -3,
        85
      ]
    ],
    [
      [
        26753,
        60482
      ],
      [
        -3,
        61
      ],
      [
        11,
        47
      ],
      [
        0,
        24
      ],
      [
        2,
        5
      ],
      [
        4,
        -7
      ],
      [
        3,
        11
      ],
      [
        4,
        -5
      ],
      [
        5,
        -18
      ],
      [
        4,
        2
      ],
      [
        4,
        -8
      ],
      [
        4,
        6
      ],
      [
        3,
        -10
      ],
      [
        8,
        6
      ]
    ],
    [
      [
        22691,
        61377
      ],
      [
        92,
        0
      ]
    ],
    [
      [
        22844,
        61277
      ],
      [
        0,
        -204
      ]
    ],
    [
      [
        22691,
        61071
      ],
      [
        0,
        306
      ]
    ],
    [
      [
        24791,
        62074
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -6
      ],
      [
        -2,
        -9
      ],
      [
        -2,
        -5
      ],
      [
        -4,
        -12
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -12
      ],
      [
        1,
        -10
      ],
      [
        2,
        -11
      ],
      [
        1,
        -5
      ],
      [
        1,
        -2
      ],
      [
        2,
        -15
      ],
      [
        1,
        -11
      ],
      [
        0,
        -6
      ]
    ],
    [
      [
        24765,
        61794
      ],
      [
        -3,
        6
      ],
      [
        -1,
        13
      ],
      [
        -2,
        4
      ],
      [
        -5,
        12
      ],
      [
        -3,
        15
      ],
      [
        -2,
        11
      ],
      [
        -1,
        17
      ],
      [
        0,
        1
      ],
      [
        2,
        14
      ],
      [
        1,
        13
      ],
      [
        0,
        4
      ],
      [
        1,
        15
      ],
      [
        1,
        19
      ],
      [
        5,
        25
      ],
      [
        1,
        5
      ],
      [
        4,
        24
      ],
      [
        4,
        19
      ],
      [
        1,
        2
      ],
      [
        2,
        3
      ],
      [
        9,
        20
      ],
      [
        6,
        25
      ],
      [
        1,
        15
      ],
      [
        5,
        -2
      ]
    ],
    [
      [
        28007,
        63883
      ],
      [
        26,
        -39
      ],
      [
        6,
        -7
      ],
      [
        17,
        -50
      ],
      [
        3,
        68
      ],
      [
        12,
        -22
      ],
      [
        29,
        -49
      ],
      [
        9,
        65
      ]
    ],
    [
      [
        28109,
        63849
      ],
      [
        5,
        -85
      ],
      [
        29,
        -69
      ]
    ],
    [
      [
        28143,
        63695
      ],
      [
        -7,
        -50
      ],
      [
        -13,
        -42
      ],
      [
        1,
        -20
      ],
      [
        6,
        -12
      ],
      [
        -2,
        -14
      ],
      [
        -5,
        -5
      ],
      [
        0,
        -37
      ],
      [
        -4,
        -20
      ],
      [
        -13,
        -105
      ],
      [
        -9,
        -90
      ],
      [
        -8,
        -52
      ],
      [
        -15,
        -68
      ]
    ],
    [
      [
        27955,
        63180
      ],
      [
        12,
        84
      ],
      [
        2,
        33
      ],
      [
        -1,
        272
      ],
      [
        3,
        21
      ],
      [
        3,
        -6
      ],
      [
        18,
        164
      ],
      [
        5,
        37
      ]
    ],
    [
      [
        23349,
        63099
      ],
      [
        -62,
        0
      ]
    ],
    [
      [
        23224,
        63099
      ],
      [
        0,
        404
      ]
    ],
    [
      [
        23867,
        55908
      ],
      [
        0,
        102
      ],
      [
        2,
        179
      ],
      [
        0,
        42
      ],
      [
        1,
        84
      ],
      [
        3,
        0
      ],
      [
        1,
        153
      ]
    ],
    [
      [
        23874,
        56468
      ],
      [
        10,
        -9
      ],
      [
        13,
        9
      ]
    ],
    [
      [
        23897,
        56468
      ],
      [
        0,
        -7
      ],
      [
        4,
        -3
      ],
      [
        10,
        -47
      ],
      [
        5,
        -12
      ],
      [
        -1,
        -18
      ],
      [
        5,
        -43
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        23922,
        56336
      ],
      [
        0,
        0
      ]
    ],
    [
      [
        23922,
        56336
      ],
      [
        0,
        -1
      ],
      [
        1,
        0
      ],
      [
        0,
        -2
      ],
      [
        2,
        0
      ],
      [
        0,
        -1
      ],
      [
        5,
        -13
      ],
      [
        10,
        0
      ],
      [
        7,
        -11
      ],
      [
        4,
        -22
      ],
      [
        7,
        16
      ],
      [
        4,
        1
      ],
      [
        3,
        -26
      ],
      [
        5,
        -12
      ],
      [
        0,
        -3
      ],
      [
        2,
        -3
      ]
    ],
    [
      [
        23972,
        56259
      ],
      [
        -3,
        -378
      ]
    ],
    [
      [
        23969,
        55881
      ],
      [
        -29,
        3
      ],
      [
        0,
        -17
      ],
      [
        -30,
        4
      ],
      [
        -11,
        1
      ]
    ],
    [
      [
        23899,
        55872
      ],
      [
        -33,
        3
      ],
      [
        1,
        33
      ]
    ],
    [
      [
        23868,
        56915
      ],
      [
        -1,
        -102
      ],
      [
        -6,
        1
      ],
      [
        0,
        -47
      ],
      [
        12,
        -9
      ],
      [
        5,
        3
      ],
      [
        -5,
        -21
      ],
      [
        3,
        -12
      ],
      [
        -2,
        -25
      ],
      [
        2,
        -14
      ],
      [
        -2,
        -19
      ],
      [
        4,
        -11
      ],
      [
        -1,
        -8
      ],
      [
        3,
        -51
      ],
      [
        0,
        -24
      ],
      [
        5,
        -13
      ],
      [
        3,
        -38
      ],
      [
        4,
        -6
      ],
      [
        4,
        -17
      ],
      [
        -1,
        -15
      ],
      [
        2,
        -19
      ]
    ],
    [
      [
        23874,
        56468
      ],
      [
        -1,
        7
      ],
      [
        -11,
        -10
      ],
      [
        -8,
        -13
      ],
      [
        -1,
        13
      ],
      [
        -4,
        -3
      ],
      [
        -7,
        11
      ],
      [
        -9,
        4
      ],
      [
        -4,
        -6
      ],
      [
        -3,
        15
      ],
      [
        -5,
        12
      ],
      [
        -10,
        1
      ],
      [
        -5,
        13
      ],
      [
        -5,
        2
      ],
      [
        -9,
        12
      ],
      [
        -20,
        3
      ]
    ],
    [
      [
        28334,
        60270
      ],
      [
        4,
        2
      ],
      [
        5,
        10
      ]
    ],
    [
      [
        28343,
        60282
      ],
      [
        3,
        5
      ]
    ],
    [
      [
        28346,
        60287
      ],
      [
        1,
        -2
      ],
      [
        5,
        3
      ],
      [
        2,
        7
      ]
    ],
    [
      [
        28354,
        60295
      ],
      [
        4,
        -5
      ],
      [
        3,
        -23
      ],
      [
        6,
        -28
      ],
      [
        -4,
        -26
      ],
      [
        -4,
        -2
      ],
      [
        -5,
        10
      ],
      [
        -6,
        -12
      ]
    ],
    [
      [
        28348,
        60209
      ],
      [
        -6,
        -5
      ],
      [
        -2,
        22
      ],
      [
        -8,
        3
      ],
      [
        4,
        28
      ],
      [
        -2,
        13
      ]
    ],
    [
      [
        24576,
        62804
      ],
      [
        0,
        -3
      ],
      [
        1,
        -6
      ],
      [
        1,
        -5
      ],
      [
        1,
        -3
      ],
      [
        1,
        -2
      ],
      [
        2,
        -2
      ],
      [
        2,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        2,
        -6
      ],
      [
        10,
        -18
      ],
      [
        3,
        -8
      ],
      [
        2,
        -5
      ],
      [
        5,
        -20
      ],
      [
        1,
        -3
      ],
      [
        5,
        -9
      ],
      [
        2,
        -4
      ],
      [
        0,
        -3
      ],
      [
        1,
        -5
      ],
      [
        2,
        -7
      ],
      [
        2,
        -5
      ],
      [
        0,
        -2
      ],
      [
        2,
        -12
      ],
      [
        5,
        -17
      ],
      [
        0,
        -2
      ],
      [
        3,
        -3
      ],
      [
        2,
        -3
      ],
      [
        1,
        -4
      ],
      [
        0,
        -5
      ],
      [
        2,
        -22
      ],
      [
        0,
        -10
      ]
    ],
    [
      [
        24636,
        62599
      ],
      [
        -129,
        4
      ],
      [
        0,
        -103
      ],
      [
        -21,
        1
      ]
    ],
    [
      [
        24444,
        62504
      ],
      [
        -8,
        206
      ]
    ],
    [
      [
        24436,
        62710
      ],
      [
        -6,
        153
      ],
      [
        26,
        60
      ],
      [
        46,
        112
      ],
      [
        7,
        0
      ]
    ],
    [
      [
        24796,
        62339
      ],
      [
        -29,
        0
      ],
      [
        -6,
        -1
      ],
      [
        -1,
        -38
      ],
      [
        0,
        -51
      ]
    ],
    [
      [
        24760,
        62249
      ],
      [
        0,
        1
      ],
      [
        -2,
        0
      ],
      [
        -4,
        -1
      ],
      [
        -2,
        1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        5
      ],
      [
        -2,
        2
      ],
      [
        -3,
        4
      ],
      [
        -4,
        9
      ],
      [
        -10,
        17
      ],
      [
        0,
        1
      ],
      [
        -3,
        4
      ],
      [
        -3,
        3
      ],
      [
        -2,
        1
      ],
      [
        -3,
        0
      ],
      [
        -3,
        2
      ],
      [
        -2,
        3
      ],
      [
        -3,
        0
      ]
    ],
    [
      [
        24711,
        62301
      ],
      [
        -11,
        -1
      ],
      [
        -8,
        -15
      ],
      [
        -4,
        5
      ],
      [
        -10,
        41
      ],
      [
        -1,
        18
      ],
      [
        -1,
        31
      ],
      [
        -3,
        12
      ],
      [
        2,
        23
      ],
      [
        -2,
        12
      ],
      [
        -4,
        48
      ]
    ],
    [
      [
        24669,
        62475
      ],
      [
        1,
        20
      ],
      [
        5,
        12
      ],
      [
        -2,
        12
      ],
      [
        4,
        12
      ],
      [
        -2,
        23
      ],
      [
        2,
        -8
      ],
      [
        11,
        17
      ],
      [
        8,
        -9
      ],
      [
        1,
        -25
      ],
      [
        4,
        1
      ],
      [
        0,
        12
      ],
      [
        49,
        -1
      ],
      [
        0,
        60
      ],
      [
        31,
        0
      ],
      [
        -1,
        38
      ],
      [
        3,
        5
      ],
      [
        13,
        -1
      ]
    ],
    [
      [
        27474,
        56104
      ],
      [
        10,
        35
      ],
      [
        6,
        47
      ],
      [
        6,
        -1
      ],
      [
        2,
        28
      ],
      [
        5,
        1
      ],
      [
        1,
        -17
      ],
      [
        -2,
        -14
      ],
      [
        12,
        4
      ],
      [
        -2,
        37
      ],
      [
        0,
        24
      ],
      [
        35,
        21
      ],
      [
        3,
        12
      ],
      [
        2,
        9
      ],
      [
        17,
        41
      ],
      [
        16,
        34
      ],
      [
        4,
        1
      ],
      [
        22,
        52
      ],
      [
        19,
        38
      ]
    ],
    [
      [
        27658,
        56385
      ],
      [
        -11,
        -78
      ],
      [
        -8,
        -10
      ],
      [
        -15,
        -49
      ],
      [
        6,
        -54
      ],
      [
        -5,
        -20
      ],
      [
        -8,
        -68
      ],
      [
        -6,
        -52
      ],
      [
        -16,
        -121
      ]
    ],
    [
      [
        27595,
        55933
      ],
      [
        -6,
        6
      ],
      [
        -8,
        -28
      ],
      [
        2,
        -17
      ],
      [
        -2,
        -18
      ],
      [
        -11,
        -1
      ],
      [
        -5,
        6
      ],
      [
        0,
        -12
      ],
      [
        -4,
        2
      ]
    ],
    [
      [
        27561,
        55871
      ],
      [
        -4,
        -5
      ],
      [
        -1,
        12
      ],
      [
        -9,
        -14
      ],
      [
        -1,
        10
      ],
      [
        -13,
        -18
      ],
      [
        -9,
        -1
      ],
      [
        -10,
        18
      ],
      [
        -12,
        37
      ],
      [
        -1,
        29
      ],
      [
        -6,
        1
      ],
      [
        1,
        9
      ],
      [
        -3,
        14
      ],
      [
        5,
        2
      ],
      [
        -1,
        25
      ],
      [
        -4,
        -6
      ],
      [
        -5,
        22
      ],
      [
        -3,
        -2
      ]
    ],
    [
      [
        27485,
        56004
      ],
      [
        -5,
        19
      ],
      [
        3,
        20
      ],
      [
        -5,
        7
      ],
      [
        0,
        22
      ],
      [
        -6,
        14
      ],
      [
        2,
        18
      ]
    ],
    [
      [
        26896,
        59538
      ],
      [
        3,
        -20
      ],
      [
        -5,
        3
      ],
      [
        1,
        -40
      ],
      [
        1,
        -30
      ],
      [
        -5,
        -7
      ],
      [
        0,
        -21
      ],
      [
        -21,
        -46
      ],
      [
        6,
        -28
      ]
    ],
    [
      [
        26870,
        59324
      ],
      [
        -7,
        -7
      ],
      [
        -7,
        -22
      ],
      [
        -7,
        3
      ],
      [
        -10,
        -28
      ],
      [
        -7,
        8
      ],
      [
        -13,
        -20
      ],
      [
        -8,
        -29
      ],
      [
        -6,
        7
      ],
      [
        -9,
        -21
      ],
      [
        -6,
        -33
      ],
      [
        -9,
        -22
      ],
      [
        -3,
        8
      ],
      [
        -11,
        -40
      ],
      [
        -3,
        0
      ]
    ],
    [
      [
        26764,
        59128
      ],
      [
        -5,
        28
      ],
      [
        -2,
        19
      ],
      [
        -7,
        16
      ],
      [
        -7,
        43
      ],
      [
        -1,
        14
      ],
      [
        -6,
        -14
      ],
      [
        1,
        -24
      ],
      [
        -5,
        11
      ],
      [
        -1,
        -17
      ],
      [
        -4,
        -16
      ],
      [
        -6,
        0
      ],
      [
        1,
        -13
      ],
      [
        -6,
        8
      ]
    ],
    [
      [
        25225,
        58601
      ],
      [
        2,
        15
      ],
      [
        9,
        26
      ],
      [
        108,
        -9
      ]
    ],
    [
      [
        25344,
        58633
      ],
      [
        -3,
        -242
      ],
      [
        -14,
        -93
      ],
      [
        0,
        -123
      ]
    ],
    [
      [
        25327,
        58175
      ],
      [
        -1,
        -8
      ],
      [
        -32,
        3
      ]
    ],
    [
      [
        27670,
        57137
      ],
      [
        -1,
        -21
      ],
      [
        6,
        -19
      ],
      [
        1,
        -13
      ],
      [
        5,
        -1
      ],
      [
        3,
        15
      ],
      [
        3,
        -2
      ],
      [
        2,
        26
      ],
      [
        2,
        -15
      ],
      [
        8,
        -10
      ],
      [
        2,
        -11
      ],
      [
        -4,
        -25
      ],
      [
        -4,
        2
      ],
      [
        0,
        -36
      ],
      [
        7,
        -23
      ],
      [
        2,
        -27
      ],
      [
        4,
        13
      ],
      [
        5,
        -7
      ],
      [
        -1,
        -20
      ],
      [
        4,
        -9
      ],
      [
        -5,
        -20
      ],
      [
        9,
        -41
      ],
      [
        0,
        -19
      ]
    ],
    [
      [
        27603,
        56618
      ],
      [
        -7,
        25
      ],
      [
        -10,
        25
      ],
      [
        -7,
        38
      ],
      [
        13,
        42
      ],
      [
        0,
        36
      ],
      [
        -2,
        12
      ],
      [
        -1,
        17
      ],
      [
        -3,
        20
      ],
      [
        -1,
        2
      ],
      [
        0,
        14
      ],
      [
        -8,
        26
      ],
      [
        -3,
        23
      ],
      [
        0,
        47
      ],
      [
        -4,
        0
      ],
      [
        -4,
        -32
      ],
      [
        -11,
        -18
      ],
      [
        -2,
        20
      ],
      [
        -8,
        13
      ],
      [
        -2,
        14
      ]
    ],
    [
      [
        27543,
        56942
      ],
      [
        0,
        3
      ]
    ],
    [
      [
        28773,
        63662
      ],
      [
        18,
        47
      ],
      [
        18,
        46
      ],
      [
        13,
        29
      ]
    ],
    [
      [
        28822,
        63784
      ],
      [
        2,
        -6
      ],
      [
        4,
        7
      ],
      [
        2,
        3
      ],
      [
        6,
        -6
      ],
      [
        5,
        -8
      ],
      [
        4,
        -12
      ],
      [
        4,
        18
      ],
      [
        7,
        -50
      ],
      [
        5,
        14
      ],
      [
        3,
        -24
      ],
      [
        2,
        -14
      ],
      [
        3,
        -7
      ],
      [
        0,
        -22
      ],
      [
        7,
        11
      ],
      [
        -2,
        -26
      ],
      [
        5,
        -12
      ],
      [
        9,
        -2
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -9
      ],
      [
        2,
        -10
      ],
      [
        2,
        -18
      ],
      [
        10,
        11
      ],
      [
        8,
        -42
      ],
      [
        7,
        13
      ],
      [
        2,
        -8
      ]
    ],
    [
      [
        28916,
        63579
      ],
      [
        -4,
        -6
      ],
      [
        -12,
        -22
      ],
      [
        3,
        -17
      ],
      [
        -13,
        -39
      ],
      [
        5,
        -10
      ],
      [
        -19,
        -35
      ],
      [
        -6,
        -12
      ],
      [
        0,
        -25
      ],
      [
        -5,
        5
      ],
      [
        -6,
        -30
      ],
      [
        -2,
        -16
      ],
      [
        -7,
        -16
      ],
      [
        1,
        -7
      ],
      [
        -1,
        -36
      ]
    ],
    [
      [
        28850,
        63313
      ],
      [
        -6,
        -3
      ],
      [
        -5,
        -5
      ],
      [
        -2,
        -2
      ],
      [
        -6,
        -8
      ],
      [
        -1,
        -2
      ],
      [
        -5,
        -10
      ],
      [
        -4,
        -10
      ],
      [
        -3,
        -7
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -4
      ],
      [
        0,
        -3
      ],
      [
        -3,
        -10
      ],
      [
        -2,
        -9
      ],
      [
        -3,
        -12
      ],
      [
        -2,
        -11
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -11
      ],
      [
        -2,
        -19
      ],
      [
        -5,
        0
      ]
    ],
    [
      [
        28796,
        63179
      ],
      [
        -96,
        0
      ]
    ],
    [
      [
        27725,
        56865
      ],
      [
        29,
        215
      ],
      [
        22,
        161
      ]
    ],
    [
      [
        27776,
        57241
      ],
      [
        26,
        -88
      ],
      [
        7,
        -27
      ],
      [
        2,
        -7
      ],
      [
        1,
        -2
      ],
      [
        4,
        -16
      ],
      [
        6,
        -21
      ],
      [
        10,
        -38
      ],
      [
        1,
        -5
      ],
      [
        3,
        -9
      ],
      [
        6,
        -20
      ],
      [
        4,
        -16
      ],
      [
        2,
        -7
      ],
      [
        1,
        -1
      ],
      [
        10,
        -39
      ],
      [
        3,
        -8
      ],
      [
        9,
        -34
      ],
      [
        11,
        -36
      ]
    ],
    [
      [
        27882,
        56867
      ],
      [
        -4,
        -5
      ],
      [
        -2,
        -20
      ],
      [
        -10,
        -28
      ]
    ],
    [
      [
        27866,
        56814
      ],
      [
        -13,
        39
      ],
      [
        -11,
        -37
      ],
      [
        -7,
        -2
      ],
      [
        -6,
        6
      ],
      [
        -3,
        12
      ],
      [
        -6,
        9
      ],
      [
        -3,
        -9
      ],
      [
        -20,
        34
      ],
      [
        -10,
        2
      ],
      [
        -6,
        -8
      ],
      [
        -2,
        -1
      ],
      [
        -11,
        -5
      ],
      [
        -12,
        -43
      ],
      [
        -9,
        -5
      ],
      [
        2,
        -19
      ]
    ],
    [
      [
        27769,
        65117
      ],
      [
        21,
        0
      ],
      [
        0,
        57
      ],
      [
        12,
        -4
      ],
      [
        42,
        -2
      ],
      [
        -1,
        -115
      ]
    ],
    [
      [
        27709,
        64865
      ],
      [
        -1,
        3
      ]
    ],
    [
      [
        25204,
        70504
      ],
      [
        1,
        -1
      ],
      [
        1,
        -4
      ],
      [
        1,
        -6
      ],
      [
        1,
        -6
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        1,
        -5
      ],
      [
        1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        6,
        -5
      ],
      [
        0,
        3
      ],
      [
        1,
        0
      ],
      [
        2,
        1
      ],
      [
        2,
        -1
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        10
      ],
      [
        0,
        5
      ],
      [
        1,
        9
      ],
      [
        1,
        6
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        1,
        -7
      ],
      [
        0,
        -1
      ],
      [
        2,
        2
      ],
      [
        3,
        6
      ],
      [
        0,
        2
      ],
      [
        2,
        2
      ],
      [
        3,
        -1
      ],
      [
        1,
        -2
      ],
      [
        2,
        1
      ],
      [
        1,
        1
      ],
      [
        1,
        4
      ],
      [
        1,
        2
      ],
      [
        -1,
        1
      ],
      [
        1,
        1
      ],
      [
        2,
        -2
      ],
      [
        3,
        0
      ],
      [
        1,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -5
      ],
      [
        2,
        -15
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        1,
        -3
      ],
      [
        2,
        -2
      ],
      [
        2,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        7
      ],
      [
        1,
        2
      ],
      [
        2,
        0
      ],
      [
        1,
        -2
      ],
      [
        2,
        -2
      ],
      [
        0,
        -5
      ],
      [
        1,
        -3
      ],
      [
        0,
        -1
      ],
      [
        2,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        3,
        -2
      ],
      [
        0,
        -3
      ],
      [
        1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        1,
        0
      ],
      [
        1,
        5
      ],
      [
        2,
        2
      ],
      [
        1,
        -1
      ],
      [
        1,
        0
      ],
      [
        2,
        3
      ],
      [
        1,
        6
      ],
      [
        0,
        3
      ],
      [
        1,
        1
      ],
      [
        13,
        -26
      ],
      [
        1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        2,
        -5
      ],
      [
        1,
        2
      ],
      [
        2,
        -2
      ],
      [
        2,
        -4
      ],
      [
        1,
        -3
      ],
      [
        1,
        -3
      ],
      [
        1,
        0
      ],
      [
        2,
        5
      ],
      [
        4,
        3
      ],
      [
        3,
        2
      ],
      [
        1,
        4
      ],
      [
        0,
        1
      ],
      [
        2,
        -1
      ],
      [
        0,
        1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -13
      ],
      [
        1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        2,
        -2
      ],
      [
        2,
        0
      ],
      [
        1,
        1
      ],
      [
        2,
        -2
      ],
      [
        1,
        -3
      ],
      [
        1,
        0
      ],
      [
        2,
        1
      ],
      [
        0,
        6
      ],
      [
        1,
        3
      ],
      [
        1,
        1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        4,
        -6
      ],
      [
        0,
        -2
      ],
      [
        1,
        -5
      ],
      [
        1,
        -1
      ],
      [
        2,
        -2
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        3,
        -4
      ],
      [
        0,
        -2
      ],
      [
        1,
        0
      ],
      [
        1,
        -4
      ],
      [
        4,
        -5
      ],
      [
        0,
        -5
      ],
      [
        1,
        -1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ]
    ],
    [
      [
        25276,
        70164
      ],
      [
        -70,
        0
      ],
      [
        0,
        302
      ],
      [
        -2,
        1
      ],
      [
        0,
        37
      ]
    ],
    [
      [
        27759,
        65394
      ],
      [
        5,
        0
      ],
      [
        150,
        -2
      ]
    ],
    [
      [
        27029,
        53039
      ],
      [
        13,
        -1
      ],
      [
        1,
        1
      ],
      [
        6,
        75
      ],
      [
        35,
        -32
      ]
    ],
    [
      [
        27084,
        53082
      ],
      [
        8,
        -10
      ],
      [
        0,
        -47
      ],
      [
        -2,
        -27
      ],
      [
        6,
        -18
      ],
      [
        -2,
        -17
      ],
      [
        -4,
        -39
      ],
      [
        6,
        -3
      ],
      [
        -4,
        -95
      ],
      [
        1,
        -9
      ]
    ],
    [
      [
        27093,
        52817
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -4,
        2
      ],
      [
        -3,
        3
      ],
      [
        0,
        1
      ],
      [
        -1,
        5
      ],
      [
        -1,
        2
      ],
      [
        -2,
        0
      ],
      [
        -3,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -25
      ],
      [
        -3,
        -21
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -2,
        4
      ],
      [
        -1,
        2
      ],
      [
        -1,
        5
      ],
      [
        -3,
        7
      ],
      [
        0,
        1
      ],
      [
        -3,
        -1
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -5
      ],
      [
        2,
        -9
      ],
      [
        2,
        -15
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -7
      ],
      [
        -3,
        -5
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -13
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -11
      ],
      [
        1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        1,
        -14
      ],
      [
        -2,
        -17
      ],
      [
        -2,
        -19
      ],
      [
        0,
        -24
      ],
      [
        1,
        -4
      ],
      [
        1,
        -3
      ],
      [
        1,
        -7
      ],
      [
        0,
        -12
      ],
      [
        1,
        -4
      ],
      [
        2,
        -9
      ],
      [
        0,
        -18
      ],
      [
        3,
        -5
      ],
      [
        0,
        -1
      ],
      [
        1,
        -9
      ],
      [
        2,
        -19
      ],
      [
        0,
        -16
      ],
      [
        -2,
        -16
      ],
      [
        -1,
        -22
      ],
      [
        0,
        -15
      ],
      [
        1,
        -6
      ],
      [
        -1,
        -20
      ],
      [
        0,
        -24
      ],
      [
        -2,
        -9
      ],
      [
        0,
        -11
      ],
      [
        -1,
        -12
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -8
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -10
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -15
      ],
      [
        2,
        -14
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -9
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -1
      ]
    ],
    [
      [
        27052,
        52284
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        -1
      ],
      [
        -4,
        0
      ],
      [
        -4,
        2
      ],
      [
        -2,
        5
      ],
      [
        1,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -4,
        -1
      ],
      [
        -7,
        -5
      ],
      [
        -4,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -2,
        1
      ],
      [
        0,
        1
      ],
      [
        -2,
        10
      ],
      [
        -1,
        6
      ],
      [
        -2,
        3
      ],
      [
        -1,
        3
      ],
      [
        -3,
        26
      ],
      [
        -2,
        27
      ],
      [
        0,
        10
      ],
      [
        1,
        5
      ],
      [
        1,
        8
      ],
      [
        0,
        9
      ],
      [
        -1,
        4
      ],
      [
        0,
        6
      ],
      [
        1,
        10
      ],
      [
        1,
        6
      ],
      [
        0,
        13
      ],
      [
        -2,
        8
      ],
      [
        -1,
        8
      ],
      [
        -2,
        6
      ],
      [
        -2,
        4
      ],
      [
        0,
        3
      ],
      [
        -1,
        8
      ],
      [
        0,
        11
      ],
      [
        -2,
        8
      ],
      [
        0,
        13
      ],
      [
        1,
        14
      ],
      [
        2,
        5
      ],
      [
        1,
        3
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        27006,
        52524
      ],
      [
        18,
        251
      ],
      [
        -2,
        2
      ],
      [
        -6,
        6
      ],
      [
        -67,
        5
      ],
      [
        1,
        176
      ],
      [
        0,
        78
      ],
      [
        20,
        0
      ],
      [
        59,
        -3
      ]
    ],
    [
      [
        20378,
        60005
      ],
      [
        0,
        -22
      ],
      [
        5,
        -42
      ],
      [
        0,
        -23
      ],
      [
        4,
        -40
      ],
      [
        -1,
        -57
      ],
      [
        -2,
        -29
      ],
      [
        1,
        -52
      ],
      [
        -1,
        -25
      ],
      [
        2,
        -29
      ],
      [
        -1,
        -9
      ],
      [
        2,
        -35
      ],
      [
        1,
        -28
      ],
      [
        -4,
        0
      ],
      [
        0,
        -16
      ],
      [
        3,
        3
      ],
      [
        2,
        -58
      ],
      [
        3,
        -27
      ],
      [
        1,
        -38
      ],
      [
        0,
        -29
      ],
      [
        2,
        -21
      ],
      [
        1,
        -40
      ],
      [
        -4,
        -54
      ],
      [
        1,
        -52
      ],
      [
        -2,
        -23
      ],
      [
        -11,
        -24
      ],
      [
        -11,
        -10
      ],
      [
        -6,
        -33
      ],
      [
        56,
        -77
      ],
      [
        5,
        -23
      ],
      [
        22,
        -94
      ],
      [
        7,
        -35
      ],
      [
        34,
        -60
      ],
      [
        23,
        -41
      ]
    ],
    [
      [
        20510,
        58862
      ],
      [
        -2,
        -26
      ],
      [
        -8,
        -20
      ],
      [
        -11,
        0
      ],
      [
        -7,
        7
      ],
      [
        -4,
        -21
      ],
      [
        -4,
        -4
      ],
      [
        -5,
        11
      ],
      [
        -8,
        1
      ],
      [
        -3,
        12
      ]
    ],
    [
      [
        20458,
        58822
      ],
      [
        0,
        27
      ],
      [
        -93,
        0
      ],
      [
        -6,
        -1
      ],
      [
        0,
        -2
      ],
      [
        2,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        1,
        -2
      ],
      [
        3,
        0
      ],
      [
        0,
        -68
      ],
      [
        -53,
        0
      ]
    ],
    [
      [
        20311,
        58766
      ],
      [
        0,
        33
      ],
      [
        -1,
        8
      ]
    ],
    [
      [
        20310,
        58807
      ],
      [
        0,
        41
      ],
      [
        -37,
        -1
      ],
      [
        -3,
        1
      ],
      [
        -90,
        -2
      ],
      [
        -26,
        -1
      ],
      [
        -21,
        0
      ],
      [
        0,
        253
      ],
      [
        -103,
        0
      ],
      [
        -14,
        -2
      ],
      [
        -74,
        6
      ],
      [
        -15,
        0
      ]
    ],
    [
      [
        19927,
        59102
      ],
      [
        0,
        103
      ],
      [
        -1,
        131
      ],
      [
        0,
        138
      ],
      [
        1,
        57
      ],
      [
        0,
        57
      ],
      [
        1,
        46
      ],
      [
        0,
        141
      ],
      [
        2,
        3
      ],
      [
        1,
        -2
      ],
      [
        1,
        6
      ],
      [
        1,
        8
      ],
      [
        3,
        1
      ],
      [
        -1,
        5
      ],
      [
        -2,
        7
      ],
      [
        1,
        9
      ],
      [
        3,
        9
      ],
      [
        3,
        0
      ],
      [
        3,
        8
      ],
      [
        0,
        7
      ],
      [
        3,
        5
      ],
      [
        1,
        -3
      ],
      [
        3,
        0
      ],
      [
        2,
        3
      ],
      [
        1,
        14
      ],
      [
        3,
        13
      ],
      [
        4,
        1
      ],
      [
        4,
        0
      ],
      [
        2,
        12
      ],
      [
        3,
        7
      ],
      [
        3,
        3
      ],
      [
        2,
        5
      ],
      [
        1,
        10
      ],
      [
        0,
        11
      ],
      [
        -1,
        15
      ],
      [
        2,
        14
      ],
      [
        -1,
        6
      ],
      [
        0,
        10
      ],
      [
        1,
        7
      ],
      [
        2,
        4
      ],
      [
        3,
        9
      ],
      [
        -1,
        12
      ],
      [
        3,
        16
      ]
    ],
    [
      [
        23711,
        54418
      ],
      [
        25,
        0
      ],
      [
        9,
        24
      ],
      [
        6,
        12
      ],
      [
        11,
        31
      ],
      [
        1,
        32
      ],
      [
        2,
        13
      ],
      [
        11,
        25
      ],
      [
        0,
        17
      ],
      [
        5,
        14
      ],
      [
        10,
        4
      ],
      [
        1,
        -4
      ],
      [
        10,
        -28
      ],
      [
        8,
        1
      ],
      [
        6,
        1
      ],
      [
        4,
        -13
      ],
      [
        10,
        -43
      ],
      [
        0,
        -37
      ]
    ],
    [
      [
        23902,
        54111
      ],
      [
        -6,
        1
      ],
      [
        -6,
        -17
      ],
      [
        -6,
        18
      ],
      [
        -6,
        -23
      ],
      [
        0,
        -80
      ]
    ],
    [
      [
        23878,
        54010
      ],
      [
        -19,
        0
      ],
      [
        -103,
        -1
      ]
    ],
    [
      [
        23756,
        54009
      ],
      [
        -1,
        4
      ],
      [
        -1,
        11
      ],
      [
        -1,
        12
      ],
      [
        -2,
        7
      ],
      [
        -1,
        8
      ],
      [
        0,
        6
      ],
      [
        -1,
        6
      ],
      [
        -1,
        3
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        2
      ],
      [
        -2,
        5
      ],
      [
        0,
        9
      ],
      [
        -1,
        4
      ],
      [
        -2,
        2
      ],
      [
        -2,
        2
      ],
      [
        -6,
        11
      ],
      [
        -1,
        7
      ],
      [
        -10,
        65
      ]
    ],
    [
      [
        27957,
        59121
      ],
      [
        -1,
        -168
      ],
      [
        -1,
        -5
      ],
      [
        8,
        -18
      ],
      [
        8,
        -1
      ]
    ],
    [
      [
        27971,
        58929
      ],
      [
        -1,
        -17
      ],
      [
        0,
        -10
      ],
      [
        4,
        -28
      ],
      [
        6,
        7
      ],
      [
        5,
        -21
      ],
      [
        -4,
        -59
      ],
      [
        -12,
        -46
      ],
      [
        -1,
        -3
      ],
      [
        -11,
        9
      ],
      [
        -1,
        1
      ],
      [
        0,
        -5
      ],
      [
        -7,
        -65
      ],
      [
        -11,
        0
      ],
      [
        -6,
        1
      ],
      [
        -4,
        0
      ]
    ],
    [
      [
        27928,
        58693
      ],
      [
        -31,
        -6
      ]
    ],
    [
      [
        19531,
        58850
      ],
      [
        32,
        -1
      ],
      [
        29,
        1
      ],
      [
        188,
        0
      ],
      [
        93,
        -2
      ],
      [
        53,
        -1
      ]
    ],
    [
      [
        19926,
        58847
      ],
      [
        89,
        -2
      ],
      [
        0,
        -807
      ]
    ],
    [
      [
        19531,
        57636
      ],
      [
        0,
        415
      ],
      [
        -1,
        30
      ],
      [
        0,
        25
      ],
      [
        1,
        212
      ],
      [
        0,
        532
      ]
    ],
    [
      [
        28398,
        63177
      ],
      [
        61,
        0
      ]
    ],
    [
      [
        28459,
        63177
      ],
      [
        2,
        0
      ],
      [
        16,
        1
      ],
      [
        10,
        -1
      ],
      [
        2,
        0
      ],
      [
        3,
        1
      ],
      [
        26,
        0
      ]
    ],
    [
      [
        28518,
        63178
      ],
      [
        -5,
        -53
      ],
      [
        -7,
        -85
      ],
      [
        -10,
        -118
      ],
      [
        -1,
        -22
      ],
      [
        -6,
        -29
      ],
      [
        1,
        -20
      ],
      [
        -2,
        -12
      ],
      [
        4,
        -15
      ],
      [
        -1,
        -24
      ],
      [
        3,
        -9
      ],
      [
        -5,
        -7
      ],
      [
        1,
        -14
      ],
      [
        4,
        -16
      ],
      [
        -2,
        -8
      ]
    ],
    [
      [
        28492,
        62746
      ],
      [
        -13,
        5
      ],
      [
        -12,
        11
      ],
      [
        -15,
        -15
      ],
      [
        -11,
        13
      ],
      [
        -10,
        8
      ],
      [
        -14,
        -24
      ],
      [
        -5,
        7
      ]
    ],
    [
      [
        28412,
        62751
      ],
      [
        3,
        22
      ],
      [
        3,
        53
      ],
      [
        9,
        48
      ],
      [
        -1,
        22
      ],
      [
        3,
        15
      ],
      [
        -1,
        7
      ],
      [
        -12,
        40
      ],
      [
        -5,
        3
      ],
      [
        1,
        23
      ],
      [
        -8,
        24
      ],
      [
        -7,
        2
      ],
      [
        -10,
        31
      ],
      [
        -2,
        -10
      ],
      [
        -2,
        13
      ],
      [
        -4,
        -2
      ],
      [
        -6,
        17
      ],
      [
        2,
        7
      ],
      [
        -3,
        17
      ],
      [
        6,
        -10
      ],
      [
        4,
        2
      ],
      [
        0,
        17
      ],
      [
        4,
        21
      ],
      [
        8,
        15
      ],
      [
        -3,
        20
      ],
      [
        8,
        4
      ],
      [
        -3,
        9
      ],
      [
        2,
        16
      ]
    ],
    [
      [
        28860,
        63072
      ],
      [
        0,
        -7
      ],
      [
        1,
        -8
      ],
      [
        0,
        -13
      ]
    ],
    [
      [
        28861,
        63044
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        10
      ],
      [
        -1,
        11
      ],
      [
        0,
        4
      ],
      [
        3,
        4
      ]
    ],
    [
      [
        28854,
        63041
      ],
      [
        6,
        -13
      ],
      [
        -1,
        -10
      ],
      [
        -4,
        3
      ],
      [
        -2,
        8
      ],
      [
        1,
        12
      ]
    ],
    [
      [
        28850,
        63313
      ],
      [
        1,
        1
      ],
      [
        4,
        1
      ],
      [
        2,
        0
      ],
      [
        9,
        -1
      ],
      [
        6,
        -2
      ],
      [
        5,
        -3
      ],
      [
        5,
        -5
      ],
      [
        5,
        -6
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        2,
        -2
      ],
      [
        7,
        -13
      ],
      [
        3,
        -9
      ]
    ],
    [
      [
        28900,
        63272
      ],
      [
        3,
        -6
      ],
      [
        -2,
        -3
      ]
    ],
    [
      [
        28901,
        63263
      ],
      [
        -6,
        -10
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        -11
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -4
      ],
      [
        -2,
        -17
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -13
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -9
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -10
      ]
    ],
    [
      [
        28874,
        63137
      ],
      [
        -5,
        8
      ],
      [
        -1,
        -1
      ],
      [
        -7,
        -34
      ],
      [
        -2,
        -7
      ],
      [
        -6,
        -6
      ],
      [
        0,
        -1
      ],
      [
        -7,
        -33
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -17
      ],
      [
        1,
        -10
      ],
      [
        2,
        -9
      ],
      [
        0,
        -1
      ],
      [
        3,
        -6
      ],
      [
        1,
        -3
      ],
      [
        1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        4,
        -13
      ],
      [
        2,
        -6
      ],
      [
        0,
        -4
      ],
      [
        -2,
        -21
      ],
      [
        0,
        -16
      ],
      [
        3,
        -8
      ],
      [
        -2,
        -14
      ],
      [
        -2,
        1
      ],
      [
        -4,
        -15
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -19
      ],
      [
        0,
        -1
      ],
      [
        1,
        -19
      ],
      [
        0,
        -1
      ],
      [
        2,
        -12
      ],
      [
        1,
        -3
      ],
      [
        2,
        -6
      ],
      [
        0,
        -5
      ],
      [
        4,
        -9
      ],
      [
        5,
        -17
      ],
      [
        1,
        -8
      ],
      [
        3,
        -21
      ],
      [
        1,
        -4
      ],
      [
        2,
        -25
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        28873,
        62764
      ],
      [
        -6,
        -17
      ],
      [
        -5,
        4
      ],
      [
        -1,
        -22
      ],
      [
        -8,
        -31
      ],
      [
        -7,
        0
      ],
      [
        -2,
        2
      ],
      [
        -9,
        -18
      ],
      [
        -4,
        -5
      ],
      [
        -6,
        7
      ],
      [
        -21,
        0
      ]
    ],
    [
      [
        28804,
        62684
      ],
      [
        -2,
        94
      ]
    ],
    [
      [
        28802,
        62778
      ],
      [
        0,
        45
      ],
      [
        -2,
        75
      ],
      [
        -1,
        63
      ],
      [
        0,
        18
      ],
      [
        -2,
        71
      ],
      [
        0,
        31
      ],
      [
        -1,
        12
      ],
      [
        0,
        86
      ]
    ],
    [
      [
        21479,
        63506
      ],
      [
        142,
        0
      ],
      [
        35,
        -1
      ],
      [
        2,
        0
      ]
    ],
    [
      [
        21658,
        63505
      ],
      [
        -1,
        -505
      ]
    ],
    [
      [
        21480,
        63000
      ],
      [
        0,
        7
      ]
    ],
    [
      [
        26946,
        54151
      ],
      [
        6,
        -12
      ],
      [
        0,
        -8
      ],
      [
        2,
        13
      ],
      [
        8,
        -7
      ],
      [
        0,
        -15
      ],
      [
        14,
        -8
      ],
      [
        2,
        -4
      ],
      [
        7,
        13
      ],
      [
        9,
        -12
      ],
      [
        3,
        -20
      ],
      [
        4,
        5
      ],
      [
        2,
        -7
      ]
    ],
    [
      [
        27003,
        54089
      ],
      [
        9,
        -8
      ],
      [
        1,
        -7
      ],
      [
        7,
        4
      ],
      [
        6,
        -5
      ],
      [
        3,
        9
      ],
      [
        -1,
        -19
      ],
      [
        5,
        -4
      ],
      [
        2,
        15
      ],
      [
        1,
        -42
      ],
      [
        16,
        -43
      ]
    ],
    [
      [
        27052,
        53989
      ],
      [
        -7,
        2
      ],
      [
        -3,
        -9
      ],
      [
        0,
        -25
      ],
      [
        -6,
        0
      ],
      [
        0,
        -16
      ],
      [
        5,
        0
      ],
      [
        0,
        -15
      ],
      [
        -12,
        0
      ],
      [
        0,
        -237
      ],
      [
        -4,
        0
      ],
      [
        0,
        -14
      ],
      [
        4,
        0
      ],
      [
        0,
        -100
      ]
    ],
    [
      [
        27029,
        53575
      ],
      [
        -6,
        -1
      ],
      [
        -18,
        56
      ],
      [
        -2,
        14
      ]
    ],
    [
      [
        27003,
        53644
      ],
      [
        -4,
        28
      ],
      [
        -8,
        20
      ],
      [
        -14,
        26
      ],
      [
        -8,
        31
      ],
      [
        -12,
        20
      ],
      [
        -5,
        1
      ],
      [
        -6,
        22
      ],
      [
        -6,
        4
      ],
      [
        -12,
        57
      ],
      [
        -7,
        0
      ]
    ],
    [
      [
        25847,
        55067
      ],
      [
        11,
        1
      ],
      [
        0,
        16
      ],
      [
        5,
        0
      ],
      [
        -1,
        -17
      ],
      [
        87,
        2
      ]
    ],
    [
      [
        25949,
        55069
      ],
      [
        10,
        0
      ],
      [
        0,
        17
      ],
      [
        5,
        -1
      ],
      [
        0,
        -16
      ],
      [
        21,
        -1
      ],
      [
        -1,
        -19
      ],
      [
        -3,
        -12
      ],
      [
        1,
        -12
      ],
      [
        -5,
        -21
      ],
      [
        -1,
        -25
      ],
      [
        7,
        -35
      ],
      [
        -1,
        -17
      ],
      [
        -1,
        -35
      ],
      [
        2,
        -64
      ],
      [
        -1,
        -56
      ],
      [
        1,
        -8
      ]
    ],
    [
      [
        25983,
        54764
      ],
      [
        5,
        -13
      ],
      [
        4,
        -7
      ],
      [
        -5,
        -2
      ],
      [
        -3,
        -22
      ],
      [
        -3,
        -9
      ],
      [
        -11,
        7
      ],
      [
        -7,
        -14
      ],
      [
        -4,
        14
      ],
      [
        -3,
        -15
      ],
      [
        -3,
        13
      ],
      [
        1,
        -22
      ],
      [
        -9,
        -15
      ]
    ],
    [
      [
        25837,
        54667
      ],
      [
        0,
        171
      ],
      [
        -1,
        92
      ],
      [
        0,
        84
      ]
    ],
    [
      [
        19532,
        61036
      ],
      [
        61,
        0
      ],
      [
        2,
        17
      ],
      [
        156,
        -1
      ],
      [
        2,
        -18
      ],
      [
        3,
        -3
      ],
      [
        3,
        -39
      ],
      [
        4,
        -13
      ],
      [
        1,
        -13
      ],
      [
        9,
        14
      ],
      [
        10,
        -1
      ],
      [
        8,
        27
      ],
      [
        6,
        -18
      ],
      [
        7,
        13
      ],
      [
        2,
        -12
      ],
      [
        7,
        17
      ],
      [
        12,
        2
      ],
      [
        5,
        -29
      ],
      [
        6,
        4
      ],
      [
        3,
        -15
      ],
      [
        5,
        1
      ],
      [
        5,
        -19
      ],
      [
        3,
        -5
      ],
      [
        2,
        -20
      ],
      [
        3,
        1
      ],
      [
        4,
        -13
      ]
    ],
    [
      [
        19861,
        60913
      ],
      [
        -3,
        -15
      ],
      [
        3,
        -8
      ],
      [
        -4,
        -19
      ],
      [
        0,
        -20
      ],
      [
        -7,
        -4
      ],
      [
        -10,
        -19
      ],
      [
        -5,
        5
      ],
      [
        -4,
        -12
      ],
      [
        0,
        -20
      ],
      [
        3,
        -35
      ],
      [
        -4,
        -11
      ]
    ],
    [
      [
        22823,
        73980
      ],
      [
        83,
        -1
      ],
      [
        146,
        0
      ]
    ],
    [
      [
        23057,
        73449
      ],
      [
        -216,
        -1
      ]
    ],
    [
      [
        22841,
        73448
      ],
      [
        0,
        4
      ],
      [
        1,
        1
      ],
      [
        0,
        1
      ],
      [
        1,
        3
      ],
      [
        1,
        0
      ],
      [
        0,
        5
      ],
      [
        -1,
        2
      ],
      [
        0,
        10
      ],
      [
        2,
        2
      ],
      [
        0,
        15
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        0,
        19
      ],
      [
        1,
        2
      ],
      [
        0,
        14
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        0,
        7
      ],
      [
        1,
        2
      ],
      [
        1,
        0
      ],
      [
        0,
        10
      ],
      [
        1,
        2
      ],
      [
        2,
        -2
      ],
      [
        1,
        1
      ],
      [
        0,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        2
      ],
      [
        -1,
        5
      ],
      [
        0,
        6
      ],
      [
        1,
        4
      ],
      [
        0,
        6
      ],
      [
        1,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        3
      ],
      [
        0,
        4
      ],
      [
        -1,
        3
      ],
      [
        0,
        2
      ],
      [
        1,
        2
      ],
      [
        0,
        15
      ],
      [
        1,
        3
      ],
      [
        0,
        3
      ],
      [
        -1,
        1
      ],
      [
        -3,
        5
      ],
      [
        -2,
        11
      ],
      [
        0,
        10
      ],
      [
        -1,
        5
      ],
      [
        -1,
        6
      ],
      [
        0,
        3
      ],
      [
        -3,
        4
      ],
      [
        0,
        11
      ],
      [
        -1,
        3
      ],
      [
        0,
        11
      ],
      [
        -1,
        5
      ],
      [
        -2,
        5
      ],
      [
        0,
        3
      ],
      [
        1,
        7
      ],
      [
        0,
        3
      ],
      [
        -2,
        7
      ],
      [
        0,
        11
      ],
      [
        -1,
        2
      ],
      [
        0,
        9
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        20
      ],
      [
        -1,
        1
      ],
      [
        -2,
        1
      ],
      [
        -1,
        3
      ],
      [
        0,
        12
      ],
      [
        -1,
        5
      ],
      [
        0,
        5
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        8
      ],
      [
        -1,
        4
      ],
      [
        0,
        2
      ],
      [
        1,
        2
      ],
      [
        0,
        4
      ],
      [
        -1,
        5
      ],
      [
        0,
        5
      ],
      [
        -1,
        3
      ],
      [
        -1,
        1
      ],
      [
        0,
        10
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -2,
        6
      ],
      [
        -1,
        2
      ],
      [
        1,
        3
      ],
      [
        0,
        2
      ],
      [
        -1,
        5
      ],
      [
        1,
        4
      ],
      [
        0,
        5
      ],
      [
        -1,
        2
      ],
      [
        -2,
        3
      ],
      [
        -1,
        2
      ],
      [
        0,
        14
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        14
      ],
      [
        -2,
        2
      ],
      [
        0,
        11
      ],
      [
        -1,
        3
      ],
      [
        -1,
        4
      ],
      [
        0,
        17
      ],
      [
        -1,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        19
      ],
      [
        1,
        4
      ],
      [
        1,
        3
      ],
      [
        0,
        3
      ],
      [
        1,
        2
      ],
      [
        -1,
        4
      ],
      [
        0,
        1
      ],
      [
        1,
        4
      ]
    ],
    [
      [
        23595,
        53065
      ],
      [
        91,
        77
      ]
    ],
    [
      [
        23712,
        53182
      ],
      [
        35,
        28
      ]
    ],
    [
      [
        23747,
        53210
      ],
      [
        13,
        -245
      ],
      [
        -10,
        -821
      ]
    ],
    [
      [
        23703,
        52474
      ],
      [
        0,
        2
      ],
      [
        1,
        4
      ],
      [
        -2,
        4
      ],
      [
        0,
        10
      ],
      [
        -1,
        5
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        8
      ],
      [
        -1,
        5
      ],
      [
        -1,
        7
      ],
      [
        0,
        7
      ],
      [
        1,
        0
      ],
      [
        0,
        3
      ],
      [
        -1,
        4
      ],
      [
        0,
        11
      ],
      [
        1,
        6
      ],
      [
        1,
        6
      ],
      [
        1,
        3
      ],
      [
        1,
        12
      ],
      [
        1,
        8
      ],
      [
        1,
        5
      ],
      [
        1,
        2
      ],
      [
        2,
        6
      ],
      [
        1,
        3
      ],
      [
        1,
        2
      ],
      [
        0,
        13
      ],
      [
        -1,
        4
      ],
      [
        0,
        3
      ],
      [
        1,
        1
      ],
      [
        -1,
        4
      ],
      [
        -1,
        5
      ],
      [
        -2,
        7
      ],
      [
        -2,
        3
      ],
      [
        -1,
        2
      ],
      [
        0,
        -6
      ],
      [
        1,
        -4
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        13
      ],
      [
        -2,
        12
      ],
      [
        0,
        11
      ],
      [
        -2,
        1
      ],
      [
        -3,
        -1
      ],
      [
        -3,
        -4
      ],
      [
        -2,
        2
      ],
      [
        1,
        5
      ],
      [
        0,
        7
      ],
      [
        -1,
        9
      ],
      [
        -2,
        7
      ],
      [
        0,
        8
      ],
      [
        1,
        6
      ],
      [
        -2,
        13
      ],
      [
        2,
        10
      ],
      [
        1,
        6
      ],
      [
        -1,
        5
      ],
      [
        0,
        -1
      ],
      [
        -2,
        2
      ],
      [
        0,
        7
      ],
      [
        1,
        5
      ],
      [
        0,
        8
      ],
      [
        -1,
        1
      ],
      [
        -1,
        5
      ],
      [
        1,
        2
      ],
      [
        -1,
        6
      ],
      [
        -1,
        7
      ],
      [
        -3,
        2
      ],
      [
        -3,
        5
      ],
      [
        -3,
        1
      ],
      [
        -1,
        4
      ],
      [
        0,
        5
      ],
      [
        1,
        8
      ],
      [
        -1,
        1
      ],
      [
        -1,
        7
      ],
      [
        -1,
        1
      ],
      [
        0,
        5
      ],
      [
        2,
        2
      ],
      [
        0,
        15
      ],
      [
        -1,
        1
      ],
      [
        -2,
        4
      ],
      [
        0,
        5
      ],
      [
        -2,
        10
      ],
      [
        1,
        6
      ],
      [
        -1,
        4
      ],
      [
        2,
        2
      ],
      [
        -1,
        6
      ],
      [
        0,
        15
      ],
      [
        -1,
        2
      ],
      [
        -1,
        3
      ],
      [
        0,
        10
      ],
      [
        -1,
        4
      ],
      [
        -2,
        3
      ],
      [
        0,
        8
      ],
      [
        1,
        4
      ],
      [
        0,
        -1
      ],
      [
        1,
        3
      ],
      [
        1,
        4
      ],
      [
        -1,
        9
      ],
      [
        1,
        4
      ],
      [
        0,
        3
      ],
      [
        -1,
        0
      ],
      [
        0,
        4
      ],
      [
        1,
        3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        1
      ],
      [
        0,
        13
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -3
      ],
      [
        -1,
        2
      ],
      [
        0,
        4
      ],
      [
        -1,
        4
      ],
      [
        1,
        1
      ],
      [
        0,
        3
      ],
      [
        -1,
        -1
      ],
      [
        0,
        6
      ],
      [
        1,
        3
      ],
      [
        -2,
        1
      ],
      [
        -2,
        4
      ],
      [
        0,
        7
      ],
      [
        1,
        5
      ],
      [
        -1,
        8
      ],
      [
        0,
        12
      ],
      [
        1,
        0
      ],
      [
        0,
        -3
      ],
      [
        1,
        -1
      ],
      [
        1,
        1
      ],
      [
        -1,
        10
      ],
      [
        -2,
        12
      ],
      [
        -1,
        6
      ],
      [
        -3,
        8
      ],
      [
        -4,
        1
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        12
      ],
      [
        0,
        14
      ],
      [
        -1,
        2
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -9
      ],
      [
        -4,
        -13
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        4
      ],
      [
        -2,
        5
      ],
      [
        0,
        8
      ],
      [
        -2,
        2
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        0
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        2
      ],
      [
        -2,
        -5
      ],
      [
        -4,
        1
      ],
      [
        -3,
        -7
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        4
      ],
      [
        0,
        4
      ],
      [
        1,
        14
      ],
      [
        0,
        11
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        0
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        27813,
        56262
      ],
      [
        7,
        -35
      ],
      [
        2,
        -14
      ],
      [
        -2,
        -10
      ],
      [
        3,
        -15
      ],
      [
        3,
        6
      ],
      [
        -1,
        -15
      ],
      [
        2,
        -6
      ],
      [
        8,
        2
      ],
      [
        -2,
        -11
      ],
      [
        16,
        12
      ]
    ],
    [
      [
        27849,
        56176
      ],
      [
        10,
        -33
      ],
      [
        0,
        -23
      ],
      [
        2,
        0
      ],
      [
        2,
        7
      ],
      [
        1,
        -30
      ],
      [
        4,
        -39
      ],
      [
        7,
        -5
      ],
      [
        -2,
        -22
      ],
      [
        1,
        -11
      ],
      [
        23,
        0
      ],
      [
        0,
        -3
      ],
      [
        4,
        3
      ]
    ],
    [
      [
        27901,
        56020
      ],
      [
        -1,
        -6
      ],
      [
        -6,
        -39
      ],
      [
        -4,
        -11
      ],
      [
        -12,
        -47
      ],
      [
        -5,
        -26
      ],
      [
        -9,
        -67
      ],
      [
        -3,
        -30
      ],
      [
        -2,
        -31
      ],
      [
        -1,
        -21
      ],
      [
        -2,
        -7
      ],
      [
        -5,
        -85
      ],
      [
        0,
        -19
      ],
      [
        3,
        -36
      ],
      [
        -5,
        -39
      ],
      [
        -2,
        -9
      ],
      [
        -5,
        -12
      ],
      [
        -7,
        -21
      ],
      [
        -2,
        -14
      ],
      [
        -12,
        -18
      ]
    ],
    [
      [
        27777,
        55603
      ],
      [
        -3,
        25
      ],
      [
        -4,
        -6
      ],
      [
        -3,
        18
      ],
      [
        -3,
        -11
      ],
      [
        -15,
        23
      ],
      [
        0,
        11
      ],
      [
        -4,
        -3
      ],
      [
        0,
        11
      ],
      [
        -12,
        8
      ],
      [
        -7,
        16
      ],
      [
        -9,
        6
      ],
      [
        -4,
        8
      ]
    ],
    [
      [
        27713,
        55709
      ],
      [
        -1,
        17
      ],
      [
        1,
        20
      ],
      [
        7,
        29
      ],
      [
        5,
        12
      ],
      [
        3,
        22
      ],
      [
        8,
        36
      ],
      [
        1,
        25
      ],
      [
        13,
        52
      ],
      [
        2,
        11
      ],
      [
        11,
        22
      ],
      [
        4,
        24
      ],
      [
        14,
        47
      ],
      [
        -3,
        22
      ],
      [
        3,
        30
      ],
      [
        4,
        31
      ],
      [
        3,
        47
      ],
      [
        4,
        27
      ],
      [
        13,
        50
      ],
      [
        3,
        23
      ],
      [
        5,
        6
      ]
    ],
    [
      [
        23212,
        64415
      ],
      [
        -1,
        5
      ],
      [
        0,
        3
      ],
      [
        -2,
        15
      ],
      [
        -1,
        9
      ],
      [
        1,
        5
      ],
      [
        0,
        2
      ],
      [
        1,
        10
      ],
      [
        1,
        6
      ],
      [
        0,
        5
      ],
      [
        -1,
        12
      ],
      [
        -2,
        10
      ],
      [
        0,
        13
      ],
      [
        1,
        4
      ],
      [
        0,
        2
      ],
      [
        1,
        2
      ],
      [
        4,
        3
      ],
      [
        2,
        3
      ],
      [
        1,
        3
      ],
      [
        1,
        5
      ],
      [
        0,
        16
      ],
      [
        -1,
        4
      ]
    ],
    [
      [
        23337,
        64552
      ],
      [
        0,
        -201
      ],
      [
        4,
        -1
      ],
      [
        -1,
        -84
      ],
      [
        0,
        -88
      ]
    ],
    [
      [
        23340,
        64178
      ],
      [
        -12,
        1
      ],
      [
        -15,
        1
      ],
      [
        -18,
        0
      ],
      [
        -6,
        1
      ],
      [
        -5,
        0
      ],
      [
        -10,
        1
      ],
      [
        -9,
        1
      ],
      [
        -13,
        0
      ],
      [
        -16,
        1
      ],
      [
        -5,
        0
      ]
    ],
    [
      [
        24694,
        63489
      ],
      [
        17,
        26
      ],
      [
        5,
        12
      ],
      [
        2,
        46
      ],
      [
        9,
        21
      ],
      [
        0,
        16
      ],
      [
        6,
        34
      ],
      [
        5,
        3
      ]
    ],
    [
      [
        24838,
        63629
      ],
      [
        1,
        -241
      ]
    ],
    [
      [
        24839,
        63388
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        24839,
        63355
      ],
      [
        -165,
        4
      ]
    ],
    [
      [
        24674,
        63359
      ],
      [
        4,
        21
      ],
      [
        5,
        8
      ],
      [
        4,
        25
      ],
      [
        2,
        27
      ],
      [
        6,
        25
      ],
      [
        -1,
        24
      ]
    ],
    [
      [
        29631,
        68114
      ],
      [
        3,
        -38
      ],
      [
        22,
        -23
      ],
      [
        36,
        -42
      ],
      [
        32,
        -40
      ],
      [
        34,
        -34
      ],
      [
        37,
        -45
      ]
    ],
    [
      [
        29795,
        67892
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -2
      ],
      [
        -3,
        -11
      ],
      [
        -3,
        -6
      ],
      [
        -6,
        -11
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -3
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -34
      ],
      [
        -2,
        -8
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -18
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -17
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        1,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        29760,
        67693
      ],
      [
        -1,
        0
      ],
      [
        -5,
        -14
      ],
      [
        -3,
        -5
      ],
      [
        -3,
        -5
      ],
      [
        -2,
        -6
      ],
      [
        -1,
        -12
      ],
      [
        0,
        -1
      ],
      [
        1,
        -9
      ],
      [
        0,
        -17
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -3
      ],
      [
        1,
        -3
      ],
      [
        1,
        -5
      ],
      [
        2,
        -4
      ],
      [
        1,
        -8
      ],
      [
        0,
        -15
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -23
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -15
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -16
      ],
      [
        0,
        -14
      ],
      [
        -1,
        -13
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -18
      ],
      [
        1,
        -2
      ],
      [
        2,
        -5
      ],
      [
        1,
        -1
      ],
      [
        3,
        0
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -9
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -8
      ],
      [
        2,
        -8
      ],
      [
        1,
        -4
      ],
      [
        1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -11
      ],
      [
        -2,
        -24
      ],
      [
        -2,
        -13
      ],
      [
        -2,
        -10
      ],
      [
        -3,
        -5
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -23
      ],
      [
        1,
        -4
      ],
      [
        0,
        -2
      ]
    ],
    [
      [
        29624,
        67292
      ],
      [
        -1,
        51
      ],
      [
        -13,
        2
      ]
    ],
    [
      [
        29610,
        67345
      ],
      [
        1,
        54
      ],
      [
        3,
        0
      ],
      [
        0,
        28
      ],
      [
        8,
        11
      ],
      [
        18,
        -31
      ],
      [
        1,
        32
      ],
      [
        6,
        47
      ],
      [
        3,
        46
      ],
      [
        -1,
        8
      ],
      [
        -6,
        7
      ],
      [
        -6,
        4
      ],
      [
        0,
        16
      ],
      [
        -5,
        4
      ],
      [
        4,
        98
      ],
      [
        1,
        14
      ],
      [
        4,
        -4
      ],
      [
        16,
        111
      ],
      [
        -34,
        39
      ],
      [
        4,
        30
      ],
      [
        -3,
        5
      ],
      [
        10,
        67
      ],
      [
        -2,
        23
      ],
      [
        -12,
        17
      ],
      [
        -1,
        -11
      ],
      [
        -10,
        12
      ],
      [
        -1,
        22
      ],
      [
        -23,
        -37
      ]
    ],
    [
      [
        29585,
        67957
      ],
      [
        -4,
        47
      ],
      [
        -2,
        -4
      ],
      [
        0,
        22
      ],
      [
        7,
        -9
      ],
      [
        22,
        33
      ],
      [
        0,
        -45
      ],
      [
        3,
        -3
      ],
      [
        13,
        88
      ],
      [
        3,
        4
      ],
      [
        4,
        24
      ]
    ],
    [
      [
        21529,
        72638
      ],
      [
        216,
        1
      ],
      [
        35,
        0
      ]
    ],
    [
      [
        21888,
        72638
      ],
      [
        0,
        -202
      ],
      [
        -24,
        0
      ],
      [
        -1,
        -404
      ]
    ],
    [
      [
        21863,
        72032
      ],
      [
        -21,
        1
      ],
      [
        0,
        -199
      ],
      [
        -60,
        -1
      ]
    ],
    [
      [
        21701,
        71959
      ],
      [
        -8,
        16
      ],
      [
        -17,
        16
      ],
      [
        -3,
        38
      ],
      [
        -2,
        50
      ],
      [
        -3,
        6
      ],
      [
        -8,
        34
      ],
      [
        -3,
        39
      ],
      [
        -7,
        27
      ],
      [
        0,
        22
      ],
      [
        5,
        20
      ],
      [
        9,
        15
      ],
      [
        5,
        13
      ],
      [
        0,
        10
      ],
      [
        -7,
        12
      ],
      [
        -9,
        28
      ],
      [
        -7,
        2
      ],
      [
        -7,
        -9
      ],
      [
        -6,
        1
      ],
      [
        -19,
        -23
      ],
      [
        -20,
        -10
      ],
      [
        -19,
        12
      ],
      [
        -9,
        -11
      ],
      [
        -20,
        -38
      ],
      [
        -7,
        -1
      ],
      [
        -8,
        10
      ],
      [
        -7,
        1
      ],
      [
        -9,
        21
      ],
      [
        -11,
        17
      ],
      [
        -15,
        -2
      ],
      [
        -4,
        5
      ],
      [
        3,
        22
      ],
      [
        -4,
        16
      ],
      [
        -8,
        -4
      ],
      [
        -4,
        5
      ],
      [
        -23,
        -10
      ],
      [
        -12,
        11
      ]
    ],
    [
      [
        21437,
        72320
      ],
      [
        -8,
        28
      ],
      [
        -5,
        13
      ],
      [
        -4,
        17
      ],
      [
        0,
        119
      ],
      [
        -6,
        14
      ],
      [
        -1,
        16
      ],
      [
        8,
        11
      ],
      [
        0,
        23
      ],
      [
        -21,
        23
      ],
      [
        -6,
        -13
      ],
      [
        -5,
        -31
      ],
      [
        -3,
        -7
      ]
    ],
    [
      [
        21386,
        72533
      ],
      [
        0,
        105
      ],
      [
        143,
        0
      ]
    ],
    [
      [
        28230,
        58364
      ],
      [
        4,
        -3
      ],
      [
        30,
        81
      ]
    ],
    [
      [
        25135,
        60363
      ],
      [
        8,
        16
      ],
      [
        -2,
        22
      ],
      [
        50,
        0
      ],
      [
        5,
        2
      ]
    ],
    [
      [
        25196,
        60403
      ],
      [
        62,
        -207
      ],
      [
        0,
        -107
      ]
    ],
    [
      [
        25258,
        60089
      ],
      [
        -4,
        -3
      ],
      [
        -3,
        0
      ],
      [
        -2,
        1
      ],
      [
        -3,
        2
      ],
      [
        -4,
        3
      ],
      [
        -4,
        7
      ],
      [
        -1,
        3
      ]
    ],
    [
      [
        25237,
        60102
      ],
      [
        -1,
        4
      ],
      [
        -2,
        4
      ],
      [
        -2,
        6
      ],
      [
        -2,
        10
      ],
      [
        -1,
        3
      ],
      [
        -2,
        6
      ],
      [
        -3,
        7
      ],
      [
        -4,
        7
      ],
      [
        -1,
        2
      ],
      [
        -3,
        1
      ],
      [
        -1,
        1
      ],
      [
        -12,
        20
      ],
      [
        -2,
        2
      ],
      [
        -3,
        1
      ],
      [
        -4,
        -2
      ],
      [
        -1,
        1
      ],
      [
        -3,
        3
      ],
      [
        -1,
        3
      ],
      [
        -3,
        6
      ],
      [
        -2,
        4
      ],
      [
        -3,
        9
      ],
      [
        -3,
        7
      ],
      [
        -1,
        4
      ],
      [
        -2,
        7
      ],
      [
        -3,
        8
      ],
      [
        -2,
        4
      ],
      [
        -4,
        4
      ],
      [
        -4,
        5
      ],
      [
        -10,
        16
      ],
      [
        -9,
        11
      ],
      [
        -4,
        6
      ],
      [
        -1,
        0
      ],
      [
        -2,
        2
      ]
    ],
    [
      [
        25136,
        60274
      ],
      [
        -1,
        89
      ]
    ],
    [
      [
        28729,
        61346
      ],
      [
        -5,
        -31
      ]
    ],
    [
      [
        28724,
        61315
      ],
      [
        -2,
        5
      ],
      [
        -1,
        2
      ],
      [
        -6,
        -8
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        12
      ],
      [
        1,
        7
      ],
      [
        0,
        1
      ],
      [
        1,
        11
      ],
      [
        -1,
        12
      ],
      [
        1,
        48
      ],
      [
        5,
        12
      ],
      [
        1,
        0
      ],
      [
        5,
        1
      ],
      [
        7,
        -30
      ],
      [
        0,
        -7
      ],
      [
        -3,
        -4
      ],
      [
        0,
        -13
      ],
      [
        1,
        -10
      ],
      [
        0,
        -2
      ]
    ],
    [
      [
        28729,
        61841
      ],
      [
        11,
        23
      ],
      [
        3,
        21
      ],
      [
        -1,
        17
      ],
      [
        7,
        27
      ],
      [
        1,
        20
      ],
      [
        3,
        10
      ]
    ],
    [
      [
        28819,
        61914
      ],
      [
        0,
        -24
      ],
      [
        1,
        -26
      ],
      [
        0,
        -8
      ],
      [
        1,
        -29
      ]
    ],
    [
      [
        28776,
        61584
      ],
      [
        0,
        9
      ],
      [
        -8,
        -9
      ],
      [
        -7,
        -15
      ],
      [
        -3,
        -20
      ],
      [
        -4,
        -27
      ],
      [
        1,
        -30
      ],
      [
        -4,
        -7
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -13
      ],
      [
        2,
        -5
      ],
      [
        1,
        1
      ],
      [
        1,
        -3
      ],
      [
        -2,
        -9
      ],
      [
        -7,
        -7
      ],
      [
        1,
        15
      ],
      [
        -1,
        9
      ],
      [
        -3,
        13
      ],
      [
        -1,
        13
      ],
      [
        0,
        4
      ],
      [
        -1,
        4
      ],
      [
        -5,
        25
      ],
      [
        -2,
        3
      ],
      [
        0,
        2
      ],
      [
        2,
        4
      ],
      [
        8,
        3
      ],
      [
        3,
        6
      ],
      [
        1,
        5
      ],
      [
        1,
        10
      ],
      [
        0,
        10
      ],
      [
        -3,
        28
      ],
      [
        -8,
        10
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -11
      ],
      [
        0,
        -4
      ],
      [
        1,
        -4
      ],
      [
        -2,
        -25
      ],
      [
        -5,
        -10
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -10
      ],
      [
        0,
        -7
      ],
      [
        5,
        -18
      ],
      [
        1,
        -9
      ],
      [
        -3,
        -30
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -9
      ],
      [
        3,
        -13
      ],
      [
        1,
        -16
      ],
      [
        -8,
        12
      ],
      [
        -3,
        13
      ],
      [
        -1,
        16
      ],
      [
        -6,
        1
      ],
      [
        -1,
        1
      ],
      [
        -8,
        -17
      ],
      [
        -2,
        -8
      ],
      [
        -4,
        2
      ],
      [
        -1,
        1
      ],
      [
        -4,
        9
      ],
      [
        -4,
        21
      ],
      [
        -2,
        14
      ],
      [
        -1,
        2
      ],
      [
        -2,
        14
      ],
      [
        -1,
        2
      ],
      [
        -4,
        20
      ],
      [
        -2,
        10
      ],
      [
        -1,
        4
      ],
      [
        -1,
        3
      ],
      [
        -7,
        6
      ],
      [
        -2,
        18
      ],
      [
        4,
        25
      ],
      [
        -6,
        15
      ],
      [
        -3,
        21
      ],
      [
        0,
        24
      ],
      [
        -5,
        30
      ],
      [
        -6,
        24
      ],
      [
        -3,
        16
      ],
      [
        0,
        2
      ],
      [
        -1,
        19
      ],
      [
        2,
        10
      ],
      [
        3,
        -3
      ],
      [
        8,
        7
      ],
      [
        1,
        0
      ],
      [
        1,
        -2
      ],
      [
        5,
        2
      ],
      [
        0,
        1
      ],
      [
        1,
        2
      ],
      [
        3,
        19
      ],
      [
        1,
        1
      ],
      [
        0,
        16
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ],
      [
        -6,
        -9
      ],
      [
        -1,
        1
      ],
      [
        -1,
        5
      ],
      [
        1,
        6
      ],
      [
        1,
        8
      ],
      [
        -1,
        10
      ],
      [
        -1,
        5
      ],
      [
        -2,
        9
      ],
      [
        -5,
        3
      ],
      [
        0,
        4
      ],
      [
        4,
        9
      ],
      [
        5,
        10
      ],
      [
        2,
        7
      ],
      [
        -1,
        5
      ],
      [
        -2,
        9
      ],
      [
        2,
        7
      ],
      [
        2,
        0
      ],
      [
        5,
        13
      ],
      [
        3,
        2
      ],
      [
        1,
        -17
      ],
      [
        5,
        -8
      ],
      [
        3,
        4
      ],
      [
        0,
        3
      ],
      [
        3,
        9
      ],
      [
        5,
        9
      ],
      [
        1,
        1
      ],
      [
        1,
        -22
      ],
      [
        0,
        -14
      ],
      [
        4,
        -4
      ],
      [
        4,
        8
      ],
      [
        3,
        -12
      ],
      [
        5,
        -9
      ],
      [
        6,
        8
      ],
      [
        3,
        -9
      ],
      [
        6,
        -17
      ],
      [
        4,
        -13
      ],
      [
        4,
        10
      ],
      [
        0,
        1
      ],
      [
        -1,
        7
      ]
    ],
    [
      [
        17303,
        72789
      ],
      [
        114,
        0
      ],
      [
        0,
        16
      ],
      [
        36,
        0
      ],
      [
        0,
        -118
      ],
      [
        48,
        1
      ]
    ],
    [
      [
        17303,
        72077
      ],
      [
        0,
        10
      ],
      [
        1,
        29
      ],
      [
        0,
        91
      ],
      [
        -1,
        52
      ],
      [
        0,
        530
      ]
    ],
    [
      [
        29722,
        65346
      ],
      [
        9,
        -60
      ],
      [
        31,
        3
      ],
      [
        0,
        -19
      ],
      [
        3,
        -46
      ],
      [
        2,
        -49
      ],
      [
        -34,
        -15
      ],
      [
        -2,
        0
      ],
      [
        3,
        -39
      ],
      [
        11,
        -6
      ],
      [
        2,
        -10
      ],
      [
        -1,
        -31
      ],
      [
        3,
        -9
      ],
      [
        6,
        -21
      ],
      [
        0,
        -32
      ],
      [
        2,
        -19
      ]
    ],
    [
      [
        29757,
        64993
      ],
      [
        -2,
        -3
      ],
      [
        0,
        -9
      ],
      [
        -11,
        -10
      ],
      [
        0,
        4
      ],
      [
        -3,
        16
      ],
      [
        -15,
        0
      ],
      [
        -6,
        -10
      ],
      [
        -3,
        1
      ],
      [
        -1,
        0
      ],
      [
        -3,
        -6
      ],
      [
        -2,
        -7
      ],
      [
        -4,
        2
      ],
      [
        0,
        5
      ],
      [
        -3,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        29702,
        64964
      ],
      [
        -2,
        29
      ],
      [
        -11,
        34
      ],
      [
        0,
        17
      ],
      [
        -8,
        7
      ],
      [
        0,
        65
      ],
      [
        -5,
        31
      ],
      [
        -5,
        8
      ],
      [
        -1,
        22
      ],
      [
        -7,
        -5
      ],
      [
        -2,
        -1
      ],
      [
        -6,
        -4
      ],
      [
        -9,
        -6
      ],
      [
        -2,
        -2
      ],
      [
        2,
        18
      ],
      [
        1,
        41
      ],
      [
        0,
        14
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        17
      ],
      [
        -1,
        54
      ],
      [
        -1,
        41
      ]
    ],
    [
      [
        29642,
        65341
      ],
      [
        0,
        15
      ],
      [
        4,
        3
      ],
      [
        3,
        9
      ],
      [
        4,
        2
      ],
      [
        1,
        16
      ],
      [
        -1,
        11
      ],
      [
        24,
        15
      ],
      [
        -1,
        -8
      ],
      [
        24,
        11
      ],
      [
        11,
        5
      ],
      [
        11,
        -74
      ]
    ],
    [
      [
        25934,
        65552
      ],
      [
        6,
        0
      ],
      [
        14,
        -1
      ],
      [
        33,
        0
      ],
      [
        23,
        -1
      ]
    ],
    [
      [
        26048,
        65175
      ],
      [
        -32,
        -1
      ],
      [
        -23,
        -1
      ],
      [
        -10,
        1
      ],
      [
        -48,
        0
      ]
    ],
    [
      [
        25935,
        65224
      ],
      [
        0,
        125
      ],
      [
        -1,
        75
      ],
      [
        0,
        128
      ]
    ],
    [
      [
        21481,
        61891
      ],
      [
        0,
        96
      ]
    ],
    [
      [
        21481,
        61480
      ],
      [
        0,
        7
      ]
    ],
    [
      [
        21481,
        61487
      ],
      [
        0,
        404
      ]
    ],
    [
      [
        24678,
        63316
      ],
      [
        -4,
        37
      ],
      [
        0,
        6
      ]
    ],
    [
      [
        24839,
        63355
      ],
      [
        0,
        -102
      ],
      [
        2,
        -79
      ],
      [
        4,
        -42
      ],
      [
        13,
        -143
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        24794,
        62944
      ],
      [
        -41,
        0
      ]
    ],
    [
      [
        26483,
        59959
      ],
      [
        7,
        22
      ],
      [
        6,
        2
      ],
      [
        4,
        14
      ],
      [
        9,
        -9
      ],
      [
        11,
        -4
      ],
      [
        8,
        22
      ],
      [
        2,
        47
      ],
      [
        5,
        -5
      ],
      [
        10,
        26
      ]
    ],
    [
      [
        26545,
        60074
      ],
      [
        4,
        -14
      ],
      [
        6,
        1
      ],
      [
        1,
        -14
      ],
      [
        4,
        -5
      ],
      [
        5,
        11
      ],
      [
        6,
        1
      ],
      [
        -1,
        -17
      ],
      [
        1,
        -9
      ],
      [
        9,
        14
      ],
      [
        3,
        -12
      ],
      [
        -1,
        -12
      ],
      [
        10,
        -23
      ],
      [
        11,
        -12
      ],
      [
        6,
        -20
      ],
      [
        8,
        1
      ],
      [
        1,
        -9
      ],
      [
        5,
        4
      ]
    ],
    [
      [
        26623,
        59959
      ],
      [
        2,
        -17
      ],
      [
        5,
        -11
      ],
      [
        -3,
        -11
      ],
      [
        -2,
        -21
      ],
      [
        -8,
        -8
      ],
      [
        -3,
        -15
      ],
      [
        -2,
        4
      ],
      [
        -4,
        -10
      ],
      [
        0,
        -15
      ],
      [
        -6,
        -3
      ],
      [
        -5,
        -11
      ],
      [
        -2,
        -18
      ],
      [
        -4,
        -3
      ],
      [
        -3,
        -18
      ],
      [
        -6,
        -14
      ],
      [
        -1,
        -9
      ],
      [
        -4,
        5
      ],
      [
        -6,
        -9
      ],
      [
        -3,
        3
      ],
      [
        -3,
        -18
      ],
      [
        0,
        -14
      ],
      [
        -3,
        -13
      ],
      [
        0,
        -16
      ],
      [
        -5,
        -6
      ],
      [
        -4,
        -36
      ],
      [
        -4,
        -8
      ],
      [
        -3,
        11
      ],
      [
        -3,
        -32
      ]
    ],
    [
      [
        23718,
        64547
      ],
      [
        31,
        -1
      ],
      [
        97,
        2
      ]
    ],
    [
      [
        23846,
        64178
      ],
      [
        -3,
        0
      ],
      [
        -8,
        -1
      ],
      [
        -17,
        -1
      ],
      [
        -5,
        0
      ],
      [
        -4,
        -1
      ],
      [
        -24,
        0
      ]
    ],
    [
      [
        23785,
        64175
      ],
      [
        -11,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -10,
        0
      ],
      [
        -12,
        -1
      ],
      [
        -4,
        0
      ],
      [
        -6,
        -1
      ],
      [
        -12,
        0
      ],
      [
        -11,
        -1
      ]
    ],
    [
      [
        26781,
        61183
      ],
      [
        6,
        32
      ],
      [
        5,
        18
      ],
      [
        7,
        -1
      ],
      [
        4,
        17
      ],
      [
        0,
        16
      ],
      [
        7,
        25
      ],
      [
        3,
        -4
      ],
      [
        5,
        20
      ],
      [
        -5,
        23
      ],
      [
        0,
        28
      ],
      [
        -3,
        21
      ],
      [
        -2,
        0
      ]
    ],
    [
      [
        26808,
        61378
      ],
      [
        12,
        25
      ],
      [
        8,
        -7
      ],
      [
        9,
        21
      ],
      [
        0,
        28
      ],
      [
        8,
        13
      ]
    ],
    [
      [
        26845,
        61458
      ],
      [
        7,
        -10
      ],
      [
        9,
        3
      ],
      [
        10,
        28
      ],
      [
        24,
        5
      ],
      [
        2,
        -22
      ]
    ],
    [
      [
        26897,
        61462
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -12
      ],
      [
        0,
        -1
      ],
      [
        1,
        -10
      ],
      [
        0,
        -3
      ],
      [
        1,
        -3
      ],
      [
        2,
        -3
      ],
      [
        0,
        -25
      ],
      [
        -1,
        -11
      ],
      [
        -2,
        -19
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        2
      ],
      [
        -4,
        1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        2,
        -10
      ],
      [
        0,
        -21
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        2,
        -3
      ],
      [
        2,
        -1
      ],
      [
        0,
        -15
      ],
      [
        1,
        -1
      ],
      [
        3,
        1
      ],
      [
        1,
        -3
      ],
      [
        1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        1,
        -5
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -19
      ],
      [
        3,
        -10
      ],
      [
        2,
        -2
      ],
      [
        2,
        -9
      ],
      [
        2,
        -2
      ],
      [
        1,
        -3
      ],
      [
        0,
        -8
      ],
      [
        1,
        -3
      ],
      [
        0,
        -8
      ],
      [
        1,
        -4
      ],
      [
        1,
        -4
      ],
      [
        0,
        -9
      ],
      [
        1,
        -6
      ],
      [
        1,
        -4
      ],
      [
        1,
        -1
      ],
      [
        0,
        -10
      ],
      [
        1,
        -7
      ],
      [
        1,
        -6
      ],
      [
        1,
        -1
      ],
      [
        0,
        -9
      ],
      [
        1,
        0
      ],
      [
        1,
        2
      ],
      [
        1,
        0
      ],
      [
        2,
        -2
      ],
      [
        2,
        -1
      ],
      [
        1,
        0
      ],
      [
        0,
        -3
      ],
      [
        4,
        -11
      ],
      [
        2,
        -1
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -14
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        26927,
        61111
      ],
      [
        -10,
        20
      ],
      [
        -13,
        -10
      ],
      [
        0,
        -23
      ],
      [
        -6,
        -15
      ],
      [
        2,
        -37
      ],
      [
        -5,
        -12
      ]
    ],
    [
      [
        26790,
        61133
      ],
      [
        -7,
        10
      ],
      [
        -2,
        40
      ]
    ],
    [
      [
        27577,
        62621
      ],
      [
        4,
        -5
      ],
      [
        36,
        11
      ],
      [
        17,
        24
      ],
      [
        7,
        34
      ],
      [
        3,
        -10
      ],
      [
        8,
        12
      ]
    ],
    [
      [
        27652,
        62687
      ],
      [
        2,
        4
      ],
      [
        8,
        -21
      ],
      [
        3,
        -44
      ],
      [
        9,
        -8
      ],
      [
        2,
        -11
      ]
    ],
    [
      [
        27599,
        62277
      ],
      [
        6,
        17
      ],
      [
        -2,
        4
      ],
      [
        5,
        12
      ],
      [
        0,
        35
      ],
      [
        3,
        7
      ],
      [
        -4,
        12
      ],
      [
        1,
        18
      ],
      [
        -21,
        1
      ],
      [
        -6,
        39
      ],
      [
        -5,
        19
      ],
      [
        -9,
        12
      ],
      [
        -2,
        -1
      ],
      [
        -5,
        18
      ]
    ],
    [
      [
        27560,
        62470
      ],
      [
        0,
        68
      ],
      [
        17,
        83
      ]
    ],
    [
      [
        29475,
        66424
      ],
      [
        25,
        275
      ]
    ],
    [
      [
        29500,
        66699
      ],
      [
        34,
        -3
      ],
      [
        33,
        -3
      ]
    ],
    [
      [
        29580,
        66478
      ],
      [
        -1,
        -17
      ],
      [
        3,
        -2
      ],
      [
        -12,
        -186
      ],
      [
        -15,
        11
      ],
      [
        -1,
        -10
      ],
      [
        2,
        -60
      ],
      [
        9,
        -24
      ],
      [
        8,
        5
      ]
    ],
    [
      [
        29573,
        66195
      ],
      [
        0,
        -72
      ],
      [
        -1,
        -1
      ],
      [
        -8,
        -124
      ],
      [
        -10,
        5
      ],
      [
        2,
        -33
      ],
      [
        -3,
        -30
      ],
      [
        5,
        -42
      ],
      [
        0,
        -21
      ]
    ],
    [
      [
        29558,
        65877
      ],
      [
        -20,
        3
      ],
      [
        -29,
        3
      ],
      [
        -1,
        0
      ],
      [
        -16,
        2
      ],
      [
        -1,
        0
      ],
      [
        -38,
        5
      ],
      [
        -15,
        -1
      ]
    ],
    [
      [
        29438,
        65889
      ],
      [
        -3,
        0
      ]
    ],
    [
      [
        29435,
        65889
      ],
      [
        -3,
        42
      ],
      [
        9,
        102
      ],
      [
        25,
        293
      ],
      [
        9,
        98
      ]
    ],
    [
      [
        24249,
        62413
      ],
      [
        133,
        -6
      ]
    ],
    [
      [
        24378,
        61993
      ],
      [
        -22,
        4
      ],
      [
        -9,
        -25
      ],
      [
        -17,
        -6
      ],
      [
        -11,
        -14
      ],
      [
        -5,
        -12
      ],
      [
        -5,
        -27
      ],
      [
        -14,
        -43
      ],
      [
        -10,
        -11
      ],
      [
        -8,
        -20
      ]
    ],
    [
      [
        24277,
        61839
      ],
      [
        -15,
        -16
      ],
      [
        -12,
        5
      ],
      [
        -9,
        9
      ],
      [
        -8,
        15
      ],
      [
        -10,
        27
      ],
      [
        0,
        29
      ],
      [
        -5,
        15
      ]
    ],
    [
      [
        24218,
        61923
      ],
      [
        1,
        54
      ],
      [
        -2,
        10
      ],
      [
        3,
        5
      ],
      [
        0,
        14
      ],
      [
        6,
        14
      ],
      [
        0,
        12
      ],
      [
        6,
        33
      ],
      [
        2,
        0
      ],
      [
        0,
        20
      ],
      [
        1,
        21
      ],
      [
        7,
        17
      ],
      [
        -5,
        12
      ],
      [
        2,
        9
      ],
      [
        -1,
        39
      ],
      [
        -3,
        -1
      ],
      [
        1,
        53
      ],
      [
        1,
        38
      ],
      [
        3,
        28
      ],
      [
        -1,
        11
      ],
      [
        3,
        21
      ],
      [
        -1,
        7
      ],
      [
        3,
        26
      ],
      [
        -2,
        10
      ],
      [
        1,
        38
      ],
      [
        6,
        -1
      ]
    ],
    [
      [
        23039,
        69636
      ],
      [
        10,
        -3
      ],
      [
        3,
        -11
      ],
      [
        10,
        4
      ],
      [
        24,
        -16
      ],
      [
        3,
        -28
      ],
      [
        7,
        -4
      ],
      [
        7,
        2
      ],
      [
        14,
        -33
      ],
      [
        10,
        1
      ],
      [
        8,
        -12
      ],
      [
        2,
        -7
      ]
    ],
    [
      [
        23137,
        69529
      ],
      [
        13,
        -24
      ],
      [
        5,
        -5
      ]
    ],
    [
      [
        23155,
        69500
      ],
      [
        7,
        -33
      ],
      [
        2,
        -2
      ],
      [
        7,
        -29
      ],
      [
        27,
        -80
      ],
      [
        4,
        -5
      ],
      [
        2,
        -20
      ],
      [
        10,
        -23
      ],
      [
        1,
        -26
      ],
      [
        5,
        -18
      ],
      [
        9,
        -7
      ],
      [
        8,
        1
      ],
      [
        2,
        -10
      ]
    ],
    [
      [
        23239,
        69248
      ],
      [
        0,
        -51
      ],
      [
        -31,
        0
      ],
      [
        -1,
        -101
      ],
      [
        -167,
        1
      ]
    ],
    [
      [
        23040,
        69097
      ],
      [
        -1,
        98
      ],
      [
        0,
        102
      ]
    ],
    [
      [
        23039,
        69297
      ],
      [
        0,
        339
      ]
    ],
    [
      [
        28237,
        60859
      ],
      [
        3,
        -9
      ],
      [
        21,
        -17
      ],
      [
        14,
        4
      ],
      [
        8,
        -5
      ]
    ],
    [
      [
        28276,
        60667
      ],
      [
        -14,
        29
      ],
      [
        -7,
        1
      ],
      [
        -8,
        25
      ],
      [
        -9,
        2
      ],
      [
        -8,
        -5
      ],
      [
        -3,
        29
      ],
      [
        -9,
        19
      ],
      [
        -7,
        17
      ],
      [
        -3,
        10
      ],
      [
        -3,
        19
      ],
      [
        -4,
        1
      ],
      [
        -6,
        -14
      ],
      [
        -2,
        -20
      ],
      [
        3,
        -20
      ],
      [
        -4,
        -22
      ],
      [
        -7,
        -1
      ],
      [
        -10,
        21
      ],
      [
        -7,
        0
      ],
      [
        -5,
        7
      ],
      [
        -3,
        11
      ]
    ],
    [
      [
        28136,
        60882
      ],
      [
        1,
        17
      ],
      [
        26,
        165
      ]
    ],
    [
      [
        19104,
        67269
      ],
      [
        0,
        65
      ],
      [
        65,
        0
      ],
      [
        0,
        101
      ],
      [
        80,
        0
      ],
      [
        2,
        101
      ]
    ],
    [
      [
        19251,
        67536
      ],
      [
        82,
        -2
      ],
      [
        0,
        -113
      ],
      [
        6,
        0
      ],
      [
        7,
        9
      ],
      [
        4,
        -9
      ],
      [
        -1,
        -41
      ],
      [
        7,
        -24
      ],
      [
        -3,
        -33
      ],
      [
        1,
        -8
      ],
      [
        -4,
        -12
      ],
      [
        5,
        -19
      ],
      [
        2,
        -23
      ],
      [
        -2,
        -16
      ],
      [
        5,
        -14
      ],
      [
        2,
        -42
      ],
      [
        6,
        -4
      ],
      [
        3,
        -44
      ],
      [
        8,
        -12
      ],
      [
        8,
        -37
      ],
      [
        3,
        -28
      ],
      [
        -4,
        -11
      ],
      [
        3,
        -21
      ],
      [
        1,
        -23
      ],
      [
        14,
        -2
      ],
      [
        2,
        -18
      ],
      [
        9,
        -8
      ],
      [
        2,
        -21
      ],
      [
        6,
        -2
      ],
      [
        6,
        -15
      ],
      [
        4,
        -19
      ],
      [
        7,
        7
      ],
      [
        7,
        -29
      ],
      [
        4,
        -29
      ],
      [
        2,
        -37
      ],
      [
        9,
        -21
      ],
      [
        3,
        2
      ],
      [
        4,
        -27
      ],
      [
        6,
        -21
      ],
      [
        2,
        4
      ],
      [
        8,
        -18
      ],
      [
        -5,
        -7
      ],
      [
        -2,
        -23
      ],
      [
        5,
        -9
      ],
      [
        2,
        12
      ],
      [
        4,
        -3
      ],
      [
        4,
        -20
      ],
      [
        14,
        -16
      ],
      [
        -5,
        -11
      ],
      [
        6,
        -23
      ],
      [
        -2,
        -16
      ],
      [
        17,
        -1
      ],
      [
        1,
        -303
      ],
      [
        7,
        1
      ],
      [
        0,
        -198
      ]
    ],
    [
      [
        19531,
        66138
      ],
      [
        -139,
        0
      ],
      [
        -142,
        8
      ]
    ],
    [
      [
        18677,
        65828
      ],
      [
        27,
        1
      ],
      [
        38,
        0
      ],
      [
        35,
        1
      ],
      [
        68,
        0
      ]
    ],
    [
      [
        18845,
        65830
      ],
      [
        0,
        -14
      ],
      [
        6,
        -14
      ],
      [
        3,
        -32
      ],
      [
        1,
        -23
      ],
      [
        -2,
        -18
      ],
      [
        -7,
        1
      ],
      [
        -2,
        -10
      ],
      [
        3,
        -8
      ],
      [
        2,
        -28
      ],
      [
        -4,
        -25
      ],
      [
        13,
        -41
      ],
      [
        3,
        -28
      ],
      [
        -1,
        -16
      ],
      [
        3,
        -9
      ],
      [
        0,
        -41
      ],
      [
        6,
        -14
      ],
      [
        1,
        -14
      ],
      [
        -2,
        -42
      ],
      [
        6,
        -20
      ],
      [
        -4,
        -23
      ],
      [
        2,
        -14
      ],
      [
        -5,
        -11
      ],
      [
        0,
        -46
      ],
      [
        -1,
        -29
      ],
      [
        -4,
        -11
      ],
      [
        1,
        -15
      ],
      [
        -4,
        1
      ],
      [
        0,
        -13
      ],
      [
        -6,
        -20
      ],
      [
        1,
        -10
      ],
      [
        -4,
        -33
      ],
      [
        -3,
        -3
      ],
      [
        -3,
        -48
      ]
    ],
    [
      [
        18844,
        65159
      ],
      [
        -9,
        -20
      ],
      [
        -3,
        21
      ],
      [
        -6,
        6
      ],
      [
        -2,
        -12
      ],
      [
        -10,
        4
      ],
      [
        -10,
        -17
      ],
      [
        -3,
        25
      ],
      [
        -9,
        -14
      ],
      [
        -7,
        12
      ],
      [
        4,
        -26
      ],
      [
        -5,
        -23
      ],
      [
        0,
        -11
      ],
      [
        -10,
        -8
      ],
      [
        -10,
        27
      ],
      [
        -5,
        -5
      ],
      [
        -15,
        13
      ],
      [
        -4,
        32
      ]
    ],
    [
      [
        18740,
        65163
      ],
      [
        1,
        17
      ],
      [
        -10,
        23
      ],
      [
        1,
        10
      ],
      [
        10,
        6
      ],
      [
        1,
        13
      ],
      [
        -3,
        12
      ],
      [
        -6,
        1
      ],
      [
        -2,
        41
      ],
      [
        -9,
        24
      ],
      [
        -10,
        -22
      ],
      [
        -4,
        28
      ],
      [
        0,
        10
      ],
      [
        -3,
        30
      ],
      [
        0,
        46
      ],
      [
        -2,
        5
      ],
      [
        -1,
        31
      ],
      [
        -10,
        44
      ],
      [
        3,
        12
      ],
      [
        0,
        32
      ],
      [
        6,
        47
      ],
      [
        3,
        19
      ],
      [
        -6,
        18
      ],
      [
        -6,
        64
      ],
      [
        -9,
        44
      ],
      [
        -10,
        29
      ],
      [
        -5,
        42
      ],
      [
        -3,
        7
      ],
      [
        -4,
        31
      ]
    ],
    [
      [
        17580,
        73980
      ],
      [
        13,
        1
      ],
      [
        3,
        -1
      ],
      [
        136,
        0
      ],
      [
        82,
        -2
      ],
      [
        134,
        2
      ]
    ],
    [
      [
        17579,
        73067
      ],
      [
        0,
        68
      ],
      [
        1,
        41
      ],
      [
        -1,
        120
      ],
      [
        1,
        79
      ],
      [
        0,
        25
      ]
    ],
    [
      [
        26882,
        51664
      ],
      [
        2,
        -5
      ],
      [
        5,
        9
      ],
      [
        1,
        18
      ],
      [
        6,
        4
      ],
      [
        6,
        17
      ],
      [
        -1,
        24
      ],
      [
        4,
        9
      ],
      [
        0,
        23
      ],
      [
        6,
        16
      ],
      [
        4,
        -4
      ],
      [
        3,
        18
      ]
    ],
    [
      [
        26918,
        51793
      ],
      [
        1,
        5
      ],
      [
        12,
        -6
      ],
      [
        3,
        -16
      ],
      [
        7,
        6
      ],
      [
        6,
        -11
      ],
      [
        2,
        1
      ]
    ],
    [
      [
        26949,
        51772
      ],
      [
        4,
        -10
      ],
      [
        2,
        -31
      ],
      [
        6,
        -9
      ],
      [
        11,
        -1
      ],
      [
        6,
        -22
      ],
      [
        12,
        -20
      ],
      [
        8,
        11
      ],
      [
        3,
        -8
      ],
      [
        12,
        3
      ],
      [
        5,
        -13
      ],
      [
        11,
        -1
      ],
      [
        2,
        -14
      ],
      [
        0,
        -22
      ],
      [
        4,
        -26
      ],
      [
        9,
        -8
      ],
      [
        -1,
        -14
      ],
      [
        7,
        -18
      ],
      [
        0,
        -35
      ]
    ],
    [
      [
        27050,
        51534
      ],
      [
        2,
        -6
      ],
      [
        -1,
        -51
      ],
      [
        -1,
        -231
      ]
    ],
    [
      [
        27050,
        51246
      ],
      [
        0,
        -36
      ],
      [
        -4,
        4
      ],
      [
        -6,
        -15
      ],
      [
        -2,
        -13
      ],
      [
        0,
        22
      ],
      [
        -5,
        -11
      ],
      [
        -5,
        7
      ],
      [
        -3,
        -19
      ],
      [
        -1,
        10
      ],
      [
        -12,
        -7
      ],
      [
        -5,
        11
      ],
      [
        0,
        41
      ],
      [
        5,
        -16
      ],
      [
        1,
        11
      ],
      [
        -6,
        26
      ],
      [
        -54,
        2
      ]
    ],
    [
      [
        26953,
        51263
      ],
      [
        -25,
        -8
      ],
      [
        -17,
        2
      ],
      [
        0,
        67
      ],
      [
        -28,
        -3
      ],
      [
        0,
        34
      ]
    ],
    [
      [
        26883,
        51355
      ],
      [
        0,
        300
      ],
      [
        -1,
        9
      ]
    ],
    [
      [
        26387,
        60997
      ],
      [
        7,
        28
      ],
      [
        7,
        -30
      ],
      [
        6,
        15
      ],
      [
        -5,
        41
      ],
      [
        1,
        9
      ],
      [
        11,
        -23
      ],
      [
        1,
        12
      ]
    ],
    [
      [
        26415,
        61049
      ],
      [
        18,
        29
      ],
      [
        2,
        -39
      ],
      [
        0,
        -8
      ],
      [
        7,
        12
      ],
      [
        5,
        -18
      ],
      [
        10,
        9
      ],
      [
        5,
        -20
      ],
      [
        10,
        7
      ],
      [
        7,
        -20
      ],
      [
        4,
        12
      ],
      [
        3,
        -10
      ]
    ],
    [
      [
        26486,
        61003
      ],
      [
        -3,
        -20
      ],
      [
        -8,
        -26
      ],
      [
        6,
        3
      ],
      [
        7,
        -17
      ],
      [
        -8,
        -32
      ],
      [
        6,
        -7
      ],
      [
        0,
        -22
      ],
      [
        -4,
        -16
      ],
      [
        -1,
        -19
      ],
      [
        2,
        -10
      ],
      [
        1,
        -49
      ],
      [
        -11,
        -30
      ],
      [
        4,
        -43
      ],
      [
        6,
        -45
      ]
    ],
    [
      [
        26412,
        60638
      ],
      [
        -7,
        38
      ],
      [
        0,
        24
      ],
      [
        -7,
        8
      ],
      [
        -1,
        22
      ],
      [
        -6,
        0
      ],
      [
        3,
        14
      ],
      [
        -5,
        15
      ],
      [
        -5,
        33
      ],
      [
        -5,
        18
      ],
      [
        3,
        5
      ],
      [
        -6,
        20
      ],
      [
        -3,
        3
      ],
      [
        0,
        20
      ],
      [
        -5,
        7
      ],
      [
        3,
        16
      ],
      [
        -6,
        11
      ],
      [
        1,
        9
      ],
      [
        -4,
        5
      ]
    ],
    [
      [
        22653,
        51137
      ],
      [
        24,
        130
      ],
      [
        2,
        13
      ],
      [
        22,
        125
      ],
      [
        9,
        49
      ]
    ],
    [
      [
        22710,
        51454
      ],
      [
        5,
        -6
      ],
      [
        0,
        -13
      ],
      [
        5,
        -3
      ],
      [
        78,
        179
      ]
    ],
    [
      [
        22798,
        51611
      ],
      [
        52,
        -164
      ],
      [
        -3,
        -18
      ]
    ],
    [
      [
        22820,
        51145
      ],
      [
        -27,
        -80
      ],
      [
        -77,
        -239
      ]
    ],
    [
      [
        22716,
        50826
      ],
      [
        -32,
        130
      ]
    ],
    [
      [
        22258,
        66767
      ],
      [
        13,
        22
      ],
      [
        8,
        7
      ],
      [
        8,
        15
      ],
      [
        7,
        3
      ],
      [
        9,
        14
      ],
      [
        11,
        7
      ],
      [
        11,
        27
      ],
      [
        9,
        12
      ],
      [
        8,
        -2
      ],
      [
        19,
        -59
      ],
      [
        3,
        -3
      ],
      [
        10,
        5
      ],
      [
        6,
        -18
      ],
      [
        6,
        -7
      ],
      [
        10,
        4
      ],
      [
        14,
        -28
      ],
      [
        10,
        -1
      ],
      [
        5,
        8
      ],
      [
        21,
        -35
      ],
      [
        9,
        3
      ],
      [
        5,
        -9
      ],
      [
        11,
        -1
      ],
      [
        8,
        -8
      ],
      [
        13,
        11
      ],
      [
        16,
        -10
      ],
      [
        5,
        4
      ],
      [
        10,
        -11
      ]
    ],
    [
      [
        22523,
        66717
      ],
      [
        0,
        -378
      ],
      [
        2,
        0
      ]
    ],
    [
      [
        22268,
        65933
      ],
      [
        -4,
        0
      ]
    ],
    [
      [
        22264,
        65933
      ],
      [
        0,
        404
      ],
      [
        -3,
        0
      ],
      [
        0,
        405
      ],
      [
        -3,
        0
      ],
      [
        0,
        25
      ]
    ],
    [
      [
        27983,
        58287
      ],
      [
        18,
        59
      ],
      [
        13,
        40
      ],
      [
        8,
        29
      ],
      [
        2,
        5
      ],
      [
        25,
        79
      ],
      [
        1,
        6
      ],
      [
        2,
        -1
      ],
      [
        57,
        131
      ]
    ],
    [
      [
        28109,
        58635
      ],
      [
        3,
        -31
      ],
      [
        -1,
        -20
      ],
      [
        5,
        -27
      ],
      [
        3,
        4
      ],
      [
        1,
        -22
      ],
      [
        7,
        -6
      ]
    ],
    [
      [
        28127,
        58533
      ],
      [
        8,
        -21
      ],
      [
        0,
        -19
      ],
      [
        10,
        -104
      ],
      [
        1,
        -5
      ],
      [
        16,
        -20
      ]
    ],
    [
      [
        28095,
        58017
      ],
      [
        -4,
        -5
      ],
      [
        -12,
        -13
      ],
      [
        -10,
        -11
      ],
      [
        -3,
        -9
      ],
      [
        -23,
        10
      ],
      [
        -5,
        21
      ],
      [
        -3,
        15
      ],
      [
        -5,
        26
      ]
    ],
    [
      [
        28030,
        58051
      ],
      [
        3,
        21
      ],
      [
        -7,
        26
      ],
      [
        -4,
        12
      ],
      [
        -2,
        24
      ],
      [
        -6,
        16
      ],
      [
        -1,
        19
      ],
      [
        -8,
        47
      ],
      [
        -6,
        17
      ],
      [
        -3,
        27
      ],
      [
        -7,
        9
      ],
      [
        -1,
        14
      ],
      [
        -5,
        4
      ]
    ],
    [
      [
        24538,
        65055
      ],
      [
        146,
        -7
      ],
      [
        2,
        -1
      ],
      [
        30,
        0
      ]
    ],
    [
      [
        24715,
        64741
      ],
      [
        -31,
        0
      ],
      [
        -66,
        6
      ]
    ],
    [
      [
        24618,
        64747
      ],
      [
        -45,
        1
      ]
    ],
    [
      [
        24573,
        64751
      ],
      [
        0,
        28
      ],
      [
        -3,
        17
      ],
      [
        -2,
        10
      ],
      [
        -1,
        12
      ],
      [
        -3,
        15
      ],
      [
        -3,
        15
      ],
      [
        -1,
        6
      ],
      [
        -1,
        2
      ],
      [
        -3,
        4
      ],
      [
        -1,
        0
      ],
      [
        -4,
        -3
      ],
      [
        -1,
        0
      ],
      [
        -3,
        3
      ],
      [
        -4,
        23
      ],
      [
        -3,
        16
      ],
      [
        -2,
        9
      ],
      [
        -2,
        8
      ],
      [
        -4,
        10
      ],
      [
        -2,
        9
      ],
      [
        -2,
        7
      ],
      [
        -1,
        3
      ],
      [
        0,
        13
      ],
      [
        1,
        7
      ],
      [
        1,
        7
      ],
      [
        1,
        6
      ],
      [
        3,
        23
      ],
      [
        1,
        8
      ],
      [
        3,
        9
      ],
      [
        1,
        4
      ],
      [
        0,
        33
      ]
    ],
    [
      [
        24258,
        67578
      ],
      [
        36,
        -1
      ],
      [
        2,
        0
      ],
      [
        25,
        1
      ],
      [
        25,
        0
      ],
      [
        7,
        -1
      ],
      [
        0,
        1
      ],
      [
        2,
        0
      ]
    ],
    [
      [
        24355,
        67578
      ],
      [
        8,
        0
      ],
      [
        8,
        -1
      ],
      [
        8,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        -1
      ],
      [
        1,
        0
      ],
      [
        2,
        1
      ],
      [
        3,
        0
      ],
      [
        0,
        -1
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        24388,
        67577
      ],
      [
        0,
        -184
      ],
      [
        2,
        -303
      ]
    ],
    [
      [
        24257,
        67091
      ],
      [
        0,
        152
      ]
    ],
    [
      [
        25094,
        58185
      ],
      [
        -29,
        1
      ],
      [
        -1,
        -41
      ]
    ],
    [
      [
        25064,
        58145
      ],
      [
        -71,
        4
      ],
      [
        0,
        1
      ],
      [
        -9,
        1
      ]
    ],
    [
      [
        24984,
        58151
      ],
      [
        1,
        168
      ],
      [
        -4,
        0
      ],
      [
        2,
        16
      ],
      [
        -7,
        23
      ]
    ],
    [
      [
        24976,
        58358
      ],
      [
        5,
        16
      ],
      [
        4,
        1
      ],
      [
        1,
        102
      ],
      [
        3,
        0
      ],
      [
        6,
        55
      ],
      [
        2,
        20
      ],
      [
        -4,
        1
      ],
      [
        0,
        21
      ],
      [
        6,
        38
      ],
      [
        4,
        12
      ],
      [
        1,
        16
      ],
      [
        12,
        -6
      ]
    ],
    [
      [
        27769,
        63178
      ],
      [
        23,
        0
      ]
    ],
    [
      [
        27792,
        63178
      ],
      [
        94,
        2
      ],
      [
        36,
        0
      ]
    ],
    [
      [
        27883,
        62891
      ],
      [
        -5,
        -4
      ],
      [
        -2,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        -2,
        -17
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -12
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -1
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        0,
        4
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -13
      ],
      [
        1,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        -3,
        -3
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -10
      ],
      [
        -3,
        -14
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        1
      ],
      [
        -2,
        -6
      ],
      [
        -5,
        -2
      ],
      [
        0,
        -24
      ],
      [
        -4,
        -6
      ],
      [
        -1,
        -2
      ]
    ],
    [
      [
        27826,
        62722
      ],
      [
        -3,
        -7
      ],
      [
        0,
        -16
      ],
      [
        -2,
        -12
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        1
      ],
      [
        -3,
        6
      ],
      [
        -5,
        -5
      ],
      [
        -3,
        -8
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -3
      ],
      [
        0,
        -1
      ],
      [
        -3,
        -10
      ],
      [
        -2,
        -3
      ],
      [
        -4,
        -2
      ],
      [
        -3,
        -9
      ],
      [
        -7,
        -29
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -7
      ],
      [
        -4,
        -13
      ],
      [
        -3,
        -6
      ],
      [
        -5,
        -5
      ],
      [
        -2,
        -4
      ],
      [
        -3,
        2
      ]
    ],
    [
      [
        27766,
        62578
      ],
      [
        0,
        161
      ],
      [
        1,
        0
      ],
      [
        0,
        218
      ],
      [
        1,
        0
      ],
      [
        1,
        115
      ],
      [
        0,
        106
      ]
    ],
    [
      [
        27689,
        63178
      ],
      [
        80,
        0
      ]
    ],
    [
      [
        27766,
        62578
      ],
      [
        0,
        -13
      ]
    ],
    [
      [
        27652,
        62687
      ],
      [
        0,
        159
      ]
    ],
    [
      [
        27652,
        62846
      ],
      [
        -1,
        54
      ],
      [
        5,
        26
      ],
      [
        9,
        48
      ],
      [
        10,
        56
      ],
      [
        7,
        35
      ],
      [
        1,
        39
      ],
      [
        6,
        46
      ],
      [
        0,
        28
      ]
    ],
    [
      [
        25134,
        71689
      ],
      [
        3,
        11
      ],
      [
        3,
        20
      ],
      [
        2,
        31
      ],
      [
        5,
        17
      ],
      [
        9,
        16
      ],
      [
        2,
        1
      ],
      [
        9,
        31
      ],
      [
        7,
        11
      ],
      [
        3,
        -1
      ],
      [
        4,
        6
      ],
      [
        10,
        35
      ],
      [
        8,
        23
      ],
      [
        8,
        16
      ],
      [
        4,
        8
      ],
      [
        5,
        1
      ],
      [
        4,
        7
      ],
      [
        4,
        7
      ],
      [
        7,
        4
      ],
      [
        3,
        4
      ],
      [
        17,
        47
      ]
    ],
    [
      [
        25251,
        71984
      ],
      [
        60,
        0
      ],
      [
        0,
        -100
      ],
      [
        20,
        0
      ]
    ],
    [
      [
        25331,
        71884
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -12
      ],
      [
        -1,
        -16
      ],
      [
        0,
        -20
      ],
      [
        1,
        -8
      ],
      [
        0,
        -2
      ],
      [
        2,
        0
      ],
      [
        0,
        -4
      ],
      [
        -3,
        -8
      ],
      [
        -2,
        -4
      ],
      [
        0,
        1
      ],
      [
        -1,
        4
      ],
      [
        -1,
        4
      ],
      [
        -2,
        2
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        -6
      ],
      [
        -2,
        -10
      ],
      [
        0,
        -18
      ],
      [
        -3,
        -18
      ],
      [
        -12,
        -21
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -12
      ],
      [
        -2,
        -22
      ],
      [
        -2,
        -24
      ],
      [
        -2,
        -8
      ],
      [
        -3,
        -9
      ],
      [
        -5,
        -24
      ],
      [
        -2,
        -7
      ],
      [
        -9,
        -6
      ],
      [
        -2,
        -30
      ],
      [
        0,
        -9
      ]
    ],
    [
      [
        25205,
        70976
      ],
      [
        -87,
        0
      ]
    ],
    [
      [
        25118,
        70976
      ],
      [
        1,
        303
      ],
      [
        34,
        -1
      ],
      [
        1,
        100
      ],
      [
        -20,
        -1
      ],
      [
        0,
        312
      ]
    ],
    [
      [
        24862,
        58309
      ],
      [
        4,
        14
      ],
      [
        5,
        42
      ],
      [
        2,
        -6
      ],
      [
        9,
        23
      ],
      [
        4,
        3
      ],
      [
        -1,
        12
      ],
      [
        6,
        10
      ],
      [
        4,
        20
      ],
      [
        3,
        -6
      ],
      [
        6,
        9
      ],
      [
        0,
        9
      ],
      [
        9,
        -3
      ],
      [
        0,
        -13
      ],
      [
        10,
        9
      ],
      [
        1,
        -9
      ],
      [
        4,
        3
      ],
      [
        2,
        -9
      ],
      [
        4,
        10
      ],
      [
        0,
        10
      ],
      [
        6,
        -4
      ],
      [
        2,
        9
      ],
      [
        2,
        -18
      ],
      [
        8,
        -14
      ],
      [
        1,
        -8
      ],
      [
        6,
        -6
      ],
      [
        3,
        -8
      ],
      [
        5,
        -4
      ],
      [
        6,
        -24
      ],
      [
        3,
        -2
      ]
    ],
    [
      [
        24984,
        58151
      ],
      [
        -19,
        2
      ],
      [
        -16,
        -11
      ],
      [
        -9,
        -14
      ],
      [
        -1,
        -8
      ]
    ],
    [
      [
        24816,
        58129
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -2,
        6
      ],
      [
        -2,
        3
      ],
      [
        -1,
        2
      ],
      [
        -2,
        8
      ],
      [
        -1,
        2
      ],
      [
        -1,
        6
      ],
      [
        0,
        2
      ],
      [
        -2,
        2
      ],
      [
        -3,
        2
      ],
      [
        -2,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -5
      ],
      [
        1,
        -8
      ],
      [
        2,
        -13
      ],
      [
        -2,
        -3
      ],
      [
        -6,
        1
      ],
      [
        -2,
        3
      ],
      [
        -2,
        5
      ],
      [
        0,
        4
      ],
      [
        2,
        29
      ],
      [
        0,
        9
      ],
      [
        1,
        4
      ],
      [
        8,
        17
      ]
    ],
    [
      [
        26407,
        66734
      ],
      [
        58,
        1
      ]
    ],
    [
      [
        26465,
        66735
      ],
      [
        2,
        -107
      ],
      [
        1,
        -99
      ],
      [
        1,
        -106
      ],
      [
        0,
        -98
      ]
    ],
    [
      [
        26341,
        66322
      ],
      [
        0,
        405
      ]
    ],
    [
      [
        22844,
        60564
      ],
      [
        1,
        -200
      ],
      [
        0,
        -204
      ],
      [
        1,
        -151
      ]
    ],
    [
      [
        22846,
        60009
      ],
      [
        -88,
        0
      ]
    ],
    [
      [
        22758,
        60009
      ],
      [
        -95,
        0
      ]
    ],
    [
      [
        22663,
        60009
      ],
      [
        0,
        449
      ],
      [
        -1,
        2
      ]
    ],
    [
      [
        22662,
        60460
      ],
      [
        0,
        102
      ]
    ],
    [
      [
        26713,
        61894
      ],
      [
        1,
        4
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        2,
        2
      ],
      [
        2,
        1
      ],
      [
        2,
        -1
      ],
      [
        2,
        -4
      ],
      [
        3,
        -6
      ],
      [
        3,
        -2
      ],
      [
        3,
        0
      ],
      [
        5,
        4
      ],
      [
        2,
        -1
      ],
      [
        3,
        1
      ],
      [
        3,
        5
      ],
      [
        2,
        4
      ],
      [
        1,
        4
      ],
      [
        1,
        10
      ],
      [
        1,
        6
      ],
      [
        1,
        16
      ],
      [
        1,
        8
      ],
      [
        2,
        6
      ],
      [
        1,
        5
      ],
      [
        2,
        2
      ],
      [
        5,
        4
      ],
      [
        5,
        10
      ],
      [
        3,
        7
      ],
      [
        3,
        12
      ]
    ],
    [
      [
        26775,
        61996
      ],
      [
        6,
        -26
      ],
      [
        -4,
        -21
      ],
      [
        -4,
        -2
      ],
      [
        -1,
        -28
      ],
      [
        -5,
        -8
      ],
      [
        1,
        -13
      ],
      [
        -3,
        -13
      ],
      [
        2,
        -18
      ],
      [
        -5,
        -18
      ],
      [
        -3,
        -24
      ],
      [
        -6,
        -27
      ],
      [
        -7,
        -6
      ],
      [
        0,
        -10
      ],
      [
        -5,
        -21
      ]
    ],
    [
      [
        26741,
        61761
      ],
      [
        -6,
        -9
      ],
      [
        0,
        -31
      ],
      [
        -4,
        -18
      ],
      [
        -3,
        1
      ],
      [
        1,
        -16
      ],
      [
        -8,
        -17
      ],
      [
        0,
        -34
      ],
      [
        1,
        -27
      ],
      [
        -2,
        -21
      ],
      [
        3,
        -20
      ],
      [
        -5,
        -9
      ],
      [
        -10,
        -9
      ],
      [
        -8,
        12
      ],
      [
        -8,
        -17
      ]
    ],
    [
      [
        26692,
        61546
      ],
      [
        -4,
        3
      ],
      [
        -6,
        48
      ],
      [
        -6,
        15
      ],
      [
        -4,
        24
      ],
      [
        -11,
        -17
      ]
    ],
    [
      [
        26661,
        61619
      ],
      [
        -4,
        20
      ],
      [
        -8,
        3
      ],
      [
        -5,
        15
      ],
      [
        -11,
        6
      ],
      [
        -8,
        14
      ],
      [
        2,
        15
      ],
      [
        -4,
        52
      ],
      [
        -3,
        15
      ],
      [
        -7,
        2
      ],
      [
        -1,
        21
      ],
      [
        -4,
        4
      ]
    ],
    [
      [
        26608,
        61786
      ],
      [
        5,
        100
      ],
      [
        -6,
        30
      ]
    ],
    [
      [
        26607,
        61916
      ],
      [
        1,
        7
      ],
      [
        1,
        11
      ],
      [
        0,
        8
      ],
      [
        1,
        10
      ],
      [
        0,
        3
      ],
      [
        1,
        3
      ],
      [
        2,
        7
      ],
      [
        3,
        6
      ],
      [
        11,
        10
      ],
      [
        0,
        -1
      ],
      [
        2,
        1
      ],
      [
        2,
        3
      ],
      [
        3,
        4
      ],
      [
        5,
        4
      ],
      [
        3,
        1
      ],
      [
        2,
        -2
      ],
      [
        3,
        -3
      ],
      [
        3,
        -5
      ],
      [
        2,
        -5
      ],
      [
        3,
        -9
      ],
      [
        1,
        -5
      ],
      [
        1,
        -3
      ],
      [
        2,
        -2
      ],
      [
        1,
        0
      ],
      [
        3,
        -4
      ],
      [
        2,
        -1
      ],
      [
        5,
        -1
      ],
      [
        2,
        -3
      ],
      [
        8,
        -4
      ],
      [
        2,
        -2
      ],
      [
        3,
        -3
      ],
      [
        3,
        -5
      ],
      [
        5,
        -10
      ],
      [
        3,
        -9
      ],
      [
        1,
        -8
      ],
      [
        1,
        -10
      ],
      [
        0,
        -12
      ],
      [
        1,
        -3
      ],
      [
        1,
        -7
      ],
      [
        1,
        -3
      ],
      [
        2,
        -3
      ],
      [
        2,
        -2
      ],
      [
        2,
        2
      ],
      [
        0,
        1
      ],
      [
        5,
        19
      ],
      [
        1,
        3
      ]
    ],
    [
      [
        23768,
        51502
      ],
      [
        -1,
        -6
      ],
      [
        1,
        -8
      ],
      [
        -7,
        0
      ],
      [
        -8,
        2
      ],
      [
        -11,
        3
      ],
      [
        -20,
        -2
      ],
      [
        -15,
        -12
      ],
      [
        -11,
        -12
      ],
      [
        -11,
        -16
      ],
      [
        -61,
        -99
      ]
    ],
    [
      [
        23599,
        51733
      ],
      [
        0,
        261
      ]
    ],
    [
      [
        23041,
        65462
      ],
      [
        90,
        0
      ]
    ],
    [
      [
        23131,
        65462
      ],
      [
        0,
        -1
      ],
      [
        1,
        -5
      ],
      [
        0,
        -4
      ],
      [
        1,
        -4
      ],
      [
        1,
        -3
      ],
      [
        4,
        -9
      ],
      [
        0,
        -3
      ],
      [
        1,
        -6
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -9
      ],
      [
        -1,
        -5
      ],
      [
        -3,
        -13
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -4
      ],
      [
        0,
        -5
      ],
      [
        1,
        -4
      ],
      [
        1,
        -7
      ],
      [
        1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        4,
        -4
      ],
      [
        0,
        -2
      ],
      [
        1,
        -3
      ],
      [
        1,
        -4
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -23
      ],
      [
        1,
        -8
      ],
      [
        1,
        -2
      ],
      [
        2,
        -2
      ],
      [
        2,
        -4
      ],
      [
        2,
        -6
      ],
      [
        1,
        -4
      ],
      [
        1,
        -6
      ],
      [
        1,
        -3
      ],
      [
        2,
        -2
      ],
      [
        2,
        0
      ],
      [
        1,
        1
      ],
      [
        0,
        1
      ],
      [
        1,
        5
      ],
      [
        1,
        16
      ],
      [
        0,
        15
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        1,
        2
      ],
      [
        3,
        0
      ],
      [
        1,
        -2
      ],
      [
        1,
        -3
      ],
      [
        1,
        -3
      ],
      [
        1,
        -18
      ],
      [
        0,
        -16
      ],
      [
        -1,
        -3
      ]
    ],
    [
      [
        23183,
        65122
      ],
      [
        -1,
        2
      ],
      [
        -108,
        0
      ]
    ],
    [
      [
        23074,
        65124
      ],
      [
        0,
        51
      ],
      [
        -11,
        0
      ],
      [
        0,
        17
      ],
      [
        -5,
        0
      ],
      [
        0,
        17
      ],
      [
        -6,
        0
      ],
      [
        0,
        17
      ],
      [
        -5,
        0
      ],
      [
        0,
        17
      ],
      [
        -3,
        0
      ],
      [
        0,
        34
      ],
      [
        -2,
        0
      ],
      [
        -1,
        185
      ]
    ],
    [
      [
        16055,
        70538
      ],
      [
        108,
        1
      ],
      [
        18,
        -3
      ],
      [
        138,
        -1
      ],
      [
        35,
        0
      ],
      [
        5,
        -1
      ],
      [
        12,
        1
      ],
      [
        145,
        0
      ]
    ],
    [
      [
        16516,
        70535
      ],
      [
        0,
        -239
      ]
    ],
    [
      [
        16516,
        70296
      ],
      [
        -3,
        -1
      ],
      [
        -8,
        -8
      ],
      [
        -17,
        -4
      ],
      [
        -9,
        -14
      ]
    ],
    [
      [
        16297,
        70181
      ],
      [
        -5,
        -8
      ],
      [
        -5,
        -17
      ],
      [
        -10,
        -11
      ],
      [
        -18,
        -23
      ],
      [
        -19,
        -17
      ],
      [
        -4,
        -12
      ],
      [
        -7,
        -22
      ],
      [
        -5,
        -3
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        16224,
        70069
      ],
      [
        0,
        1
      ],
      [
        -8,
        17
      ],
      [
        -3,
        0
      ],
      [
        -7,
        -8
      ],
      [
        -1,
        -1
      ],
      [
        -7,
        5
      ],
      [
        -7,
        -2
      ],
      [
        -9,
        2
      ],
      [
        -5,
        -6
      ],
      [
        -10,
        -29
      ],
      [
        1,
        -6
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        2
      ],
      [
        -1,
        -4
      ],
      [
        -7,
        -3
      ],
      [
        -4,
        1
      ],
      [
        -4,
        12
      ],
      [
        1,
        15
      ],
      [
        -2,
        23
      ],
      [
        -4,
        25
      ],
      [
        -10,
        9
      ],
      [
        -10,
        10
      ],
      [
        -7,
        15
      ],
      [
        -7,
        6
      ],
      [
        -10,
        -3
      ],
      [
        -8,
        -11
      ],
      [
        -6,
        1
      ],
      [
        -5,
        4
      ]
    ],
    [
      [
        16077,
        70135
      ],
      [
        -6,
        4
      ],
      [
        -10,
        23
      ],
      [
        -6,
        5
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        16054,
        70167
      ],
      [
        1,
        27
      ],
      [
        -5,
        25
      ],
      [
        6,
        14
      ],
      [
        -26,
        1
      ],
      [
        1,
        102
      ],
      [
        -1,
        202
      ],
      [
        25,
        0
      ]
    ],
    [
      [
        24358,
        62733
      ],
      [
        2,
        303
      ],
      [
        -1,
        17
      ],
      [
        0,
        51
      ]
    ],
    [
      [
        24436,
        62710
      ],
      [
        -51,
        6
      ],
      [
        -27,
        0
      ],
      [
        0,
        17
      ]
    ],
    [
      [
        20579,
        66333
      ],
      [
        3,
        -399
      ],
      [
        -2,
        -404
      ],
      [
        0,
        -99
      ]
    ],
    [
      [
        20580,
        65431
      ],
      [
        0,
        -629
      ],
      [
        1,
        -137
      ]
    ],
    [
      [
        20581,
        64665
      ],
      [
        -125,
        -2
      ],
      [
        -94,
        0
      ],
      [
        -36,
        1
      ]
    ],
    [
      [
        20290,
        64666
      ],
      [
        -1,
        461
      ],
      [
        32,
        -2
      ],
      [
        39,
        2
      ],
      [
        -1,
        175
      ],
      [
        0,
        614
      ],
      [
        -1,
        16
      ],
      [
        1,
        403
      ]
    ],
    [
      [
        27947,
        61230
      ],
      [
        12,
        25
      ],
      [
        4,
        14
      ],
      [
        -2,
        53
      ],
      [
        3,
        17
      ],
      [
        2,
        37
      ],
      [
        6,
        39
      ]
    ],
    [
      [
        27972,
        61415
      ],
      [
        2,
        13
      ],
      [
        4,
        14
      ],
      [
        4,
        12
      ],
      [
        16,
        24
      ],
      [
        -2,
        20
      ]
    ],
    [
      [
        28078,
        61389
      ],
      [
        6,
        -8
      ],
      [
        25,
        -34
      ],
      [
        13,
        -20
      ]
    ],
    [
      [
        28095,
        61182
      ],
      [
        -3,
        -12
      ],
      [
        -49,
        -232
      ]
    ],
    [
      [
        28043,
        60938
      ],
      [
        -2,
        -41
      ],
      [
        -4,
        -5
      ],
      [
        -12,
        6
      ],
      [
        -7,
        -10
      ],
      [
        -9,
        2
      ],
      [
        -8,
        -26
      ]
    ],
    [
      [
        28001,
        60864
      ],
      [
        -7,
        -10
      ],
      [
        -5,
        15
      ],
      [
        1,
        26
      ],
      [
        4,
        -1
      ],
      [
        -4,
        17
      ],
      [
        0,
        10
      ],
      [
        -20,
        140
      ],
      [
        -13,
        93
      ],
      [
        -10,
        76
      ]
    ],
    [
      [
        23790,
        62580
      ],
      [
        5,
        3
      ],
      [
        8,
        -4
      ],
      [
        3,
        4
      ],
      [
        5,
        25
      ],
      [
        6,
        5
      ],
      [
        3,
        15
      ],
      [
        6,
        -6
      ],
      [
        12,
        -4
      ],
      [
        7,
        -25
      ],
      [
        12,
        -4
      ],
      [
        7,
        10
      ],
      [
        1,
        17
      ],
      [
        -2,
        31
      ],
      [
        1,
        21
      ],
      [
        4,
        11
      ]
    ],
    [
      [
        23868,
        62679
      ],
      [
        -5,
        -407
      ]
    ],
    [
      [
        23863,
        62255
      ],
      [
        -94,
        11
      ],
      [
        -1,
        -34
      ],
      [
        -30,
        5
      ],
      [
        -43,
        5
      ],
      [
        -4,
        0
      ]
    ],
    [
      [
        23691,
        62242
      ],
      [
        1,
        80
      ],
      [
        0,
        89
      ],
      [
        1,
        34
      ],
      [
        0,
        61
      ]
    ],
    [
      [
        24225,
        61515
      ],
      [
        48,
        -4
      ],
      [
        39,
        1
      ],
      [
        6,
        4
      ],
      [
        24,
        -2
      ],
      [
        5,
        -3
      ],
      [
        32,
        -1
      ]
    ],
    [
      [
        24379,
        61510
      ],
      [
        0,
        -157
      ],
      [
        4,
        0
      ]
    ],
    [
      [
        24226,
        61565
      ],
      [
        0,
        41
      ],
      [
        17,
        16
      ],
      [
        5,
        20
      ],
      [
        -3,
        21
      ],
      [
        -7,
        13
      ],
      [
        -5,
        38
      ],
      [
        0,
        7
      ],
      [
        5,
        6
      ],
      [
        9,
        -20
      ],
      [
        10,
        9
      ],
      [
        11,
        2
      ],
      [
        6,
        11
      ],
      [
        3,
        28
      ],
      [
        -4,
        28
      ],
      [
        0,
        32
      ],
      [
        6,
        10
      ],
      [
        -2,
        12
      ]
    ],
    [
      [
        24380,
        61994
      ],
      [
        -1,
        -278
      ],
      [
        0,
        -206
      ]
    ],
    [
      [
        23821,
        67982
      ],
      [
        -34,
        0
      ]
    ],
    [
      [
        23787,
        67982
      ],
      [
        0,
        405
      ]
    ],
    [
      [
        20923,
        73553
      ],
      [
        70,
        0
      ],
      [
        248,
        -1
      ],
      [
        6,
        0
      ]
    ],
    [
      [
        21247,
        73552
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        21247,
        73451
      ],
      [
        0,
        -202
      ],
      [
        16,
        0
      ],
      [
        0,
        -290
      ]
    ],
    [
      [
        21263,
        72959
      ],
      [
        -10,
        16
      ],
      [
        -12,
        -18
      ],
      [
        -6,
        2
      ],
      [
        -3,
        10
      ],
      [
        -9,
        7
      ],
      [
        -10,
        -7
      ],
      [
        -6,
        4
      ],
      [
        -11,
        -4
      ],
      [
        -6,
        -9
      ],
      [
        -1,
        22
      ],
      [
        -4,
        4
      ],
      [
        -14,
        -12
      ],
      [
        -12,
        -1
      ],
      [
        -3,
        -8
      ],
      [
        -11,
        -42
      ],
      [
        7,
        -20
      ],
      [
        -2,
        -14
      ],
      [
        -12,
        -6
      ],
      [
        -3,
        -21
      ],
      [
        -10,
        0
      ],
      [
        -16,
        -18
      ],
      [
        -13,
        13
      ],
      [
        -9,
        -13
      ],
      [
        -7,
        -21
      ],
      [
        -4,
        -1
      ],
      [
        -7,
        32
      ],
      [
        -13,
        3
      ],
      [
        -4,
        8
      ],
      [
        1,
        17
      ],
      [
        8,
        24
      ],
      [
        1,
        11
      ],
      [
        -10,
        5
      ],
      [
        -6,
        26
      ],
      [
        6,
        12
      ],
      [
        -3,
        12
      ],
      [
        -10,
        -27
      ],
      [
        -12,
        13
      ],
      [
        -12,
        -16
      ],
      [
        -7,
        -18
      ],
      [
        1,
        -12
      ],
      [
        8,
        -21
      ],
      [
        0,
        -8
      ],
      [
        -10,
        -20
      ],
      [
        -7,
        18
      ],
      [
        -3,
        3
      ],
      [
        -4,
        -27
      ],
      [
        2,
        -26
      ],
      [
        -3,
        -23
      ],
      [
        -8,
        -16
      ],
      [
        1,
        19
      ],
      [
        -8,
        22
      ],
      [
        -3,
        -8
      ],
      [
        3,
        -16
      ],
      [
        -4,
        -26
      ],
      [
        -5,
        -12
      ],
      [
        -9,
        -7
      ],
      [
        -7,
        23
      ],
      [
        -6,
        11
      ],
      [
        -6,
        -3
      ],
      [
        0,
        -10
      ],
      [
        -5,
        -8
      ],
      [
        -4,
        24
      ],
      [
        -7,
        10
      ]
    ],
    [
      [
        20923,
        73268
      ],
      [
        0,
        285
      ]
    ],
    [
      [
        28015,
        60474
      ],
      [
        3,
        -8
      ],
      [
        -3,
        -13
      ],
      [
        4,
        -3
      ],
      [
        0,
        -16
      ],
      [
        3,
        10
      ],
      [
        5,
        -30
      ],
      [
        4,
        4
      ],
      [
        7,
        -24
      ],
      [
        6,
        0
      ],
      [
        1,
        12
      ],
      [
        6,
        0
      ]
    ],
    [
      [
        28115,
        60439
      ],
      [
        1,
        -84
      ]
    ],
    [
      [
        28116,
        60355
      ],
      [
        -2,
        -118
      ],
      [
        0,
        -87
      ]
    ],
    [
      [
        28114,
        60150
      ],
      [
        -10,
        -19
      ],
      [
        -11,
        -5
      ],
      [
        -13,
        8
      ],
      [
        -6,
        -19
      ],
      [
        -17,
        -12
      ]
    ],
    [
      [
        28057,
        60103
      ],
      [
        -4,
        7
      ],
      [
        -7,
        0
      ],
      [
        -6,
        25
      ],
      [
        0,
        8
      ],
      [
        -3,
        22
      ],
      [
        -8,
        9
      ],
      [
        -1,
        12
      ],
      [
        -7,
        -5
      ],
      [
        -3,
        -7
      ],
      [
        -4,
        12
      ],
      [
        -7,
        8
      ],
      [
        -4,
        14
      ],
      [
        -2,
        29
      ],
      [
        -10,
        3
      ],
      [
        -4,
        8
      ],
      [
        3,
        52
      ]
    ],
    [
      [
        28737,
        62777
      ],
      [
        5,
        -11
      ],
      [
        6,
        9
      ],
      [
        6,
        -8
      ],
      [
        4,
        3
      ],
      [
        11,
        -11
      ],
      [
        5,
        8
      ],
      [
        4,
        -4
      ],
      [
        3,
        7
      ],
      [
        4,
        4
      ],
      [
        2,
        9
      ],
      [
        1,
        1
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        2,
        -6
      ],
      [
        10,
        3
      ]
    ],
    [
      [
        28804,
        62684
      ],
      [
        1,
        -59
      ]
    ],
    [
      [
        28805,
        62625
      ],
      [
        -14,
        -5
      ],
      [
        -9,
        19
      ],
      [
        -8,
        2
      ],
      [
        -1,
        -12
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        4
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -8
      ],
      [
        -1,
        0
      ],
      [
        -4,
        -3
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -5,
        -7
      ],
      [
        -6,
        4
      ],
      [
        -2,
        5
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -7
      ],
      [
        -6,
        1
      ],
      [
        -13,
        -35
      ],
      [
        -4,
        -21
      ],
      [
        2,
        -8
      ],
      [
        5,
        -5
      ],
      [
        1,
        -13
      ],
      [
        -2,
        -8
      ],
      [
        -9,
        -18
      ],
      [
        2,
        -11
      ],
      [
        -6,
        -13
      ],
      [
        -6,
        -23
      ],
      [
        -12,
        -15
      ]
    ],
    [
      [
        28693,
        62448
      ],
      [
        -2,
        1
      ],
      [
        -5,
        2
      ],
      [
        -5,
        -13
      ],
      [
        -2,
        -24
      ],
      [
        0,
        -9
      ],
      [
        -1,
        -10
      ],
      [
        0,
        -9
      ],
      [
        1,
        -19
      ],
      [
        3,
        -12
      ],
      [
        -3,
        -5
      ],
      [
        -6,
        10
      ],
      [
        -3,
        12
      ],
      [
        0,
        13
      ],
      [
        1,
        6
      ],
      [
        0,
        1
      ],
      [
        2,
        17
      ],
      [
        0,
        26
      ],
      [
        -1,
        10
      ],
      [
        -5,
        49
      ],
      [
        -2,
        11
      ],
      [
        -5,
        3
      ],
      [
        1,
        23
      ],
      [
        2,
        18
      ],
      [
        3,
        13
      ],
      [
        2,
        8
      ],
      [
        5,
        40
      ],
      [
        3,
        34
      ],
      [
        3,
        9
      ],
      [
        2,
        0
      ],
      [
        5,
        18
      ],
      [
        1,
        7
      ],
      [
        1,
        8
      ],
      [
        0,
        14
      ],
      [
        -2,
        2
      ],
      [
        0,
        8
      ],
      [
        4,
        15
      ],
      [
        3,
        5
      ],
      [
        4,
        -2
      ],
      [
        3,
        7
      ],
      [
        -1,
        4
      ],
      [
        1,
        8
      ],
      [
        5,
        12
      ],
      [
        2,
        13
      ],
      [
        17,
        -2
      ],
      [
        4,
        -4
      ],
      [
        3,
        -6
      ],
      [
        5,
        5
      ],
      [
        1,
        1
      ],
      [
        0,
        11
      ]
    ],
    [
      [
        24583,
        63727
      ],
      [
        1,
        107
      ]
    ],
    [
      [
        24694,
        63489
      ],
      [
        -8,
        -9
      ],
      [
        -7,
        4
      ],
      [
        -5,
        -6
      ],
      [
        -6,
        3
      ],
      [
        1,
        25
      ],
      [
        -4,
        14
      ],
      [
        3,
        12
      ],
      [
        -1,
        9
      ],
      [
        -6,
        -11
      ],
      [
        -6,
        11
      ],
      [
        -2,
        16
      ],
      [
        -5,
        7
      ],
      [
        1,
        33
      ],
      [
        -5,
        -2
      ],
      [
        -4,
        16
      ],
      [
        3,
        12
      ],
      [
        -28,
        3
      ],
      [
        -33,
        -2
      ]
    ],
    [
      [
        24582,
        63624
      ],
      [
        1,
        103
      ]
    ],
    [
      [
        28331,
        62595
      ],
      [
        1,
        2
      ],
      [
        47,
        90
      ],
      [
        1,
        1
      ],
      [
        6,
        12
      ],
      [
        26,
        50
      ]
    ],
    [
      [
        28412,
        62750
      ],
      [
        -5,
        -15
      ],
      [
        4,
        -32
      ],
      [
        9,
        -24
      ],
      [
        1,
        -18
      ],
      [
        2,
        -10
      ],
      [
        7,
        -3
      ],
      [
        9,
        -14
      ],
      [
        3,
        -15
      ],
      [
        4,
        -4
      ],
      [
        4,
        -20
      ],
      [
        6,
        -16
      ],
      [
        1,
        -29
      ],
      [
        3,
        -18
      ],
      [
        6,
        -5
      ],
      [
        0,
        -14
      ],
      [
        6,
        -4
      ],
      [
        -2,
        -14
      ],
      [
        9,
        5
      ],
      [
        3,
        -10
      ],
      [
        1,
        -4
      ],
      [
        7,
        5
      ]
    ],
    [
      [
        28490,
        62491
      ],
      [
        -5,
        -15
      ],
      [
        -3,
        -31
      ],
      [
        -10,
        -54
      ],
      [
        -5,
        -31
      ],
      [
        -1,
        -4
      ],
      [
        -5,
        -26
      ],
      [
        1,
        -20
      ],
      [
        -4,
        -12
      ]
    ],
    [
      [
        28458,
        62298
      ],
      [
        -1,
        6
      ],
      [
        -2,
        5
      ],
      [
        0,
        2
      ],
      [
        -6,
        18
      ],
      [
        -2,
        4
      ],
      [
        0,
        -1
      ],
      [
        -3,
        -11
      ],
      [
        -5,
        -15
      ],
      [
        -4,
        -13
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -9
      ],
      [
        -1,
        -3
      ],
      [
        -4,
        -14
      ]
    ],
    [
      [
        28426,
        62262
      ],
      [
        -3,
        7
      ],
      [
        -1,
        8
      ],
      [
        -1,
        10
      ],
      [
        -3,
        10
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        -4,
        2
      ],
      [
        -2,
        0
      ],
      [
        -3,
        1
      ],
      [
        -4,
        -2
      ],
      [
        -2,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        2
      ],
      [
        -1,
        3
      ],
      [
        -1,
        5
      ],
      [
        0,
        2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -4
      ],
      [
        -4,
        11
      ],
      [
        1,
        8
      ],
      [
        -1,
        1
      ],
      [
        -1,
        3
      ],
      [
        0,
        7
      ],
      [
        1,
        11
      ],
      [
        1,
        4
      ],
      [
        1,
        6
      ],
      [
        -1,
        6
      ],
      [
        0,
        2
      ],
      [
        -2,
        3
      ],
      [
        -3,
        3
      ],
      [
        -3,
        2
      ],
      [
        -5,
        15
      ],
      [
        -2,
        3
      ],
      [
        -3,
        3
      ],
      [
        -1,
        0
      ],
      [
        -2,
        5
      ],
      [
        -2,
        2
      ]
    ],
    [
      [
        25293,
        58126
      ],
      [
        -1,
        -76
      ],
      [
        -2,
        0
      ],
      [
        0,
        -14
      ],
      [
        2,
        -15
      ],
      [
        -4,
        -344
      ]
    ],
    [
      [
        25288,
        57677
      ],
      [
        -25,
        1
      ],
      [
        -12,
        0
      ],
      [
        -76,
        -1
      ]
    ],
    [
      [
        25175,
        57677
      ],
      [
        0,
        151
      ],
      [
        1,
        143
      ]
    ],
    [
      [
        23856,
        55376
      ],
      [
        9,
        0
      ]
    ],
    [
      [
        23865,
        55376
      ],
      [
        6,
        0
      ],
      [
        25,
        -1
      ],
      [
        10,
        1
      ],
      [
        9,
        -1
      ],
      [
        20,
        0
      ]
    ],
    [
      [
        23935,
        55375
      ],
      [
        0,
        -351
      ],
      [
        14,
        0
      ],
      [
        0,
        -51
      ],
      [
        4,
        -45
      ],
      [
        -2,
        -10
      ],
      [
        0,
        -47
      ]
    ],
    [
      [
        23897,
        54668
      ],
      [
        -19,
        0
      ],
      [
        0,
        102
      ],
      [
        -1,
        0
      ],
      [
        0,
        306
      ],
      [
        -7,
        0
      ],
      [
        2,
        12
      ],
      [
        -3,
        14
      ],
      [
        4,
        27
      ],
      [
        -2,
        3
      ],
      [
        4,
        15
      ],
      [
        -1,
        15
      ],
      [
        -3,
        15
      ],
      [
        3,
        4
      ],
      [
        2,
        18
      ],
      [
        -4,
        2
      ],
      [
        -4,
        20
      ],
      [
        -1,
        19
      ],
      [
        3,
        3
      ],
      [
        0,
        15
      ],
      [
        -3,
        11
      ],
      [
        -3,
        -6
      ],
      [
        -5,
        16
      ],
      [
        -3,
        35
      ],
      [
        -3,
        12
      ],
      [
        4,
        31
      ],
      [
        -1,
        19
      ]
    ],
    [
      [
        28172,
        56904
      ],
      [
        10,
        6
      ],
      [
        4,
        26
      ],
      [
        -2,
        15
      ],
      [
        3,
        1
      ],
      [
        4,
        12
      ],
      [
        1,
        -17
      ],
      [
        5,
        2
      ],
      [
        3,
        -10
      ],
      [
        3,
        16
      ],
      [
        5,
        0
      ],
      [
        1,
        -13
      ],
      [
        5,
        3
      ],
      [
        6,
        16
      ],
      [
        10,
        10
      ],
      [
        5,
        -14
      ],
      [
        -3,
        -10
      ],
      [
        1,
        -12
      ],
      [
        20,
        -76
      ],
      [
        8,
        5
      ]
    ],
    [
      [
        28261,
        56864
      ],
      [
        -1,
        -2
      ],
      [
        -7,
        -26
      ],
      [
        -7,
        -32
      ],
      [
        0,
        -1
      ],
      [
        -18,
        -95
      ],
      [
        -4,
        -26
      ],
      [
        -8,
        -72
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -9
      ],
      [
        -10,
        -112
      ],
      [
        -4,
        -30
      ],
      [
        -2,
        -19
      ]
    ],
    [
      [
        28198,
        56436
      ],
      [
        -3,
        49
      ],
      [
        2,
        11
      ],
      [
        2,
        55
      ],
      [
        0,
        36
      ],
      [
        -1,
        74
      ],
      [
        -5,
        36
      ],
      [
        -1,
        34
      ],
      [
        0,
        22
      ],
      [
        -1,
        5
      ],
      [
        1,
        33
      ],
      [
        -8,
        40
      ],
      [
        -8,
        28
      ],
      [
        2,
        33
      ],
      [
        -5,
        -2
      ],
      [
        -1,
        14
      ]
    ],
    [
      [
        25362,
        70976
      ],
      [
        0,
        -202
      ]
    ],
    [
      [
        25204,
        70504
      ],
      [
        -2,
        1
      ],
      [
        -2,
        3
      ],
      [
        -2,
        0
      ],
      [
        -2,
        -2
      ],
      [
        0,
        -4
      ],
      [
        -2,
        0
      ],
      [
        -1,
        7
      ],
      [
        0,
        4
      ],
      [
        -1,
        3
      ],
      [
        -1,
        2
      ],
      [
        -3,
        1
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        -2,
        0
      ],
      [
        -1,
        3
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -3
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        0,
        9
      ],
      [
        1,
        6
      ],
      [
        0,
        3
      ],
      [
        -1,
        1
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        2
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        1
      ],
      [
        -3,
        -3
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        3
      ],
      [
        -3,
        3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        5
      ],
      [
        0,
        2
      ],
      [
        -1,
        2
      ],
      [
        -23,
        39
      ]
    ],
    [
      [
        25134,
        70573
      ],
      [
        -3,
        5
      ],
      [
        -1,
        2
      ],
      [
        -12,
        20
      ]
    ],
    [
      [
        25118,
        70874
      ],
      [
        0,
        102
      ]
    ],
    [
      [
        25258,
        60089
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ],
      [
        4,
        6
      ],
      [
        4,
        29
      ],
      [
        1,
        11
      ],
      [
        0,
        2
      ],
      [
        2,
        18
      ],
      [
        0,
        2
      ],
      [
        3,
        27
      ],
      [
        0,
        3
      ],
      [
        -1,
        6
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        4
      ],
      [
        0,
        3
      ],
      [
        -1,
        16
      ],
      [
        0,
        2
      ],
      [
        -1,
        8
      ],
      [
        -2,
        17
      ],
      [
        0,
        4
      ],
      [
        -3,
        8
      ],
      [
        -2,
        4
      ],
      [
        -1,
        4
      ],
      [
        -2,
        8
      ],
      [
        0,
        3
      ],
      [
        -2,
        13
      ],
      [
        -1,
        4
      ],
      [
        -1,
        5
      ],
      [
        -2,
        6
      ],
      [
        -2,
        7
      ],
      [
        -1,
        3
      ],
      [
        1,
        5
      ],
      [
        -1,
        8
      ],
      [
        -2,
        12
      ],
      [
        1,
        8
      ],
      [
        1,
        9
      ],
      [
        1,
        6
      ],
      [
        1,
        5
      ],
      [
        1,
        11
      ],
      [
        2,
        12
      ],
      [
        1,
        8
      ],
      [
        1,
        6
      ],
      [
        0,
        7
      ],
      [
        1,
        11
      ],
      [
        0,
        11
      ],
      [
        1,
        12
      ],
      [
        0,
        14
      ],
      [
        2,
        11
      ],
      [
        1,
        5
      ],
      [
        3,
        9
      ],
      [
        2,
        4
      ],
      [
        3,
        5
      ],
      [
        2,
        2
      ],
      [
        2,
        2
      ],
      [
        2,
        3
      ],
      [
        1,
        2
      ]
    ],
    [
      [
        25279,
        60504
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        25279,
        60505
      ],
      [
        1,
        0
      ],
      [
        2,
        -1
      ],
      [
        2,
        -3
      ],
      [
        2,
        -6
      ],
      [
        3,
        -7
      ],
      [
        1,
        -7
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ]
    ],
    [
      [
        25294,
        60482
      ],
      [
        1,
        -9
      ],
      [
        11,
        1
      ],
      [
        5,
        -21
      ],
      [
        -2,
        -13
      ],
      [
        3,
        -39
      ],
      [
        8,
        -21
      ],
      [
        13,
        -52
      ],
      [
        6,
        -62
      ],
      [
        -6,
        -43
      ],
      [
        6,
        -9
      ],
      [
        3,
        -24
      ],
      [
        -2,
        -8
      ]
    ],
    [
      [
        25340,
        60182
      ],
      [
        -5,
        -20
      ],
      [
        -1,
        -40
      ],
      [
        -4,
        -17
      ],
      [
        4,
        -29
      ],
      [
        -3,
        -33
      ],
      [
        5,
        -33
      ],
      [
        -9,
        -21
      ]
    ],
    [
      [
        25327,
        59989
      ],
      [
        -19,
        78
      ],
      [
        -8,
        15
      ],
      [
        -8,
        3
      ],
      [
        -7,
        -10
      ],
      [
        -10,
        -6
      ],
      [
        -6,
        -18
      ],
      [
        -9,
        -14
      ]
    ],
    [
      [
        25260,
        60037
      ],
      [
        -4,
        -1
      ],
      [
        -9,
        15
      ],
      [
        -10,
        38
      ],
      [
        0,
        13
      ]
    ],
    [
      [
        16039,
        61284
      ],
      [
        4,
        13
      ],
      [
        -6,
        17
      ],
      [
        8,
        19
      ],
      [
        0,
        9
      ],
      [
        6,
        9
      ],
      [
        3,
        27
      ],
      [
        -1,
        22
      ],
      [
        7,
        22
      ],
      [
        -1,
        12
      ],
      [
        4,
        6
      ],
      [
        3,
        30
      ],
      [
        6,
        6
      ],
      [
        3,
        -5
      ],
      [
        3,
        1
      ],
      [
        3,
        -1
      ],
      [
        5,
        -27
      ],
      [
        18,
        -4
      ],
      [
        14,
        12
      ],
      [
        4,
        13
      ],
      [
        2,
        1
      ],
      [
        1,
        2
      ],
      [
        6,
        -8
      ],
      [
        7,
        -1
      ],
      [
        8,
        13
      ],
      [
        6,
        0
      ],
      [
        7,
        10
      ],
      [
        6,
        15
      ],
      [
        9,
        5
      ],
      [
        8,
        21
      ],
      [
        5,
        -9
      ],
      [
        6,
        10
      ]
    ],
    [
      [
        16201,
        61437
      ],
      [
        16,
        -160
      ],
      [
        4,
        -12
      ]
    ],
    [
      [
        16069,
        60571
      ],
      [
        0,
        9
      ],
      [
        -6,
        15
      ],
      [
        -3,
        28
      ],
      [
        -11,
        5
      ],
      [
        -4,
        14
      ],
      [
        0,
        319
      ]
    ],
    [
      [
        16045,
        60961
      ],
      [
        6,
        39
      ],
      [
        -5,
        13
      ],
      [
        -7,
        0
      ],
      [
        2,
        50
      ],
      [
        4,
        33
      ],
      [
        -3,
        19
      ],
      [
        1,
        13
      ],
      [
        -5,
        28
      ],
      [
        4,
        22
      ],
      [
        -3,
        1
      ],
      [
        2,
        15
      ],
      [
        4,
        0
      ],
      [
        -4,
        29
      ],
      [
        -4,
        -7
      ],
      [
        1,
        38
      ],
      [
        3,
        7
      ],
      [
        -2,
        23
      ]
    ],
    [
      [
        25134,
        60276
      ],
      [
        2,
        -2
      ]
    ],
    [
      [
        25260,
        60037
      ],
      [
        -1,
        -49
      ],
      [
        0,
        -45
      ]
    ],
    [
      [
        25168,
        59949
      ],
      [
        -1,
        8
      ]
    ],
    [
      [
        25167,
        59957
      ],
      [
        -2,
        16
      ],
      [
        -13,
        127
      ],
      [
        -17,
        169
      ],
      [
        -1,
        7
      ]
    ],
    [
      [
        27230,
        55057
      ],
      [
        5,
        0
      ],
      [
        7,
        19
      ],
      [
        8,
        9
      ],
      [
        3,
        23
      ],
      [
        19,
        59
      ],
      [
        -5,
        62
      ],
      [
        5,
        12
      ],
      [
        6,
        5
      ],
      [
        0,
        39
      ],
      [
        5,
        15
      ],
      [
        39,
        85
      ]
    ],
    [
      [
        27322,
        55385
      ],
      [
        4,
        -15
      ],
      [
        4,
        -28
      ],
      [
        6,
        -18
      ],
      [
        9,
        -50
      ],
      [
        3,
        -35
      ],
      [
        3,
        -4
      ],
      [
        5,
        -24
      ],
      [
        4,
        -2
      ],
      [
        12,
        -49
      ],
      [
        1,
        -26
      ],
      [
        9,
        -41
      ],
      [
        5,
        -53
      ],
      [
        1,
        -12
      ],
      [
        5,
        -18
      ]
    ],
    [
      [
        27266,
        54838
      ],
      [
        -4,
        7
      ],
      [
        -1,
        1
      ],
      [
        0,
        -1
      ],
      [
        -6,
        -4
      ],
      [
        -2,
        2
      ],
      [
        -11,
        19
      ],
      [
        0,
        15
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -3
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        -2,
        6
      ]
    ],
    [
      [
        27236,
        54883
      ],
      [
        -1,
        8
      ],
      [
        -1,
        4
      ],
      [
        -2,
        7
      ],
      [
        -2,
        8
      ],
      [
        -2,
        13
      ],
      [
        0,
        8
      ],
      [
        1,
        1
      ],
      [
        1,
        -5
      ],
      [
        0,
        -2
      ],
      [
        1,
        1
      ],
      [
        1,
        5
      ],
      [
        0,
        8
      ],
      [
        3,
        7
      ],
      [
        0,
        5
      ],
      [
        -2,
        3
      ],
      [
        -1,
        0
      ],
      [
        -1,
        5
      ],
      [
        0,
        2
      ],
      [
        1,
        6
      ],
      [
        1,
        12
      ],
      [
        0,
        3
      ],
      [
        -2,
        17
      ],
      [
        -1,
        0
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        10
      ],
      [
        -1,
        1
      ],
      [
        2,
        12
      ],
      [
        0,
        10
      ],
      [
        1,
        14
      ],
      [
        1,
        7
      ],
      [
        1,
        2
      ],
      [
        0,
        5
      ]
    ],
    [
      [
        22913,
        65531
      ],
      [
        0,
        -333
      ]
    ],
    [
      [
        22913,
        65198
      ],
      [
        -4,
        0
      ],
      [
        -12,
        -17
      ],
      [
        -10,
        -26
      ],
      [
        -5,
        -7
      ],
      [
        -11,
        -1
      ],
      [
        -10,
        -23
      ],
      [
        -24,
        -19
      ],
      [
        -6,
        11
      ],
      [
        -15,
        -2
      ]
    ],
    [
      [
        22816,
        65114
      ],
      [
        0,
        418
      ]
    ],
    [
      [
        31904,
        37656
      ],
      [
        3,
        0
      ],
      [
        5,
        -7
      ],
      [
        0,
        -6
      ],
      [
        -5,
        -1
      ],
      [
        -2,
        3
      ],
      [
        -1,
        11
      ]
    ],
    [
      [
        31828,
        37522
      ],
      [
        7,
        36
      ],
      [
        -1,
        16
      ],
      [
        -3,
        24
      ],
      [
        3,
        20
      ],
      [
        4,
        10
      ],
      [
        10,
        -13
      ],
      [
        8,
        22
      ],
      [
        8,
        6
      ],
      [
        9,
        -3
      ],
      [
        6,
        -29
      ],
      [
        8,
        -2
      ],
      [
        4,
        7
      ],
      [
        7,
        2
      ],
      [
        12,
        -2
      ],
      [
        8,
        0
      ],
      [
        5,
        -6
      ],
      [
        0,
        -6
      ],
      [
        -3,
        -6
      ],
      [
        -3,
        -2
      ],
      [
        -5,
        -2
      ],
      [
        -1,
        -12
      ],
      [
        -8,
        -13
      ],
      [
        -8,
        -9
      ],
      [
        -7,
        -10
      ],
      [
        -7,
        -7
      ],
      [
        -7,
        -4
      ],
      [
        -5,
        -14
      ],
      [
        -1,
        -2
      ],
      [
        -4,
        14
      ],
      [
        -5,
        -1
      ],
      [
        -12,
        -16
      ],
      [
        -3,
        8
      ],
      [
        -8,
        -2
      ],
      [
        -6,
        -12
      ],
      [
        -2,
        8
      ]
    ],
    [
      [
        18762,
        70252
      ],
      [
        6,
        -6
      ],
      [
        8,
        13
      ],
      [
        8,
        -12
      ],
      [
        6,
        3
      ],
      [
        12,
        43
      ]
    ],
    [
      [
        19047,
        70711
      ],
      [
        -1,
        -59
      ],
      [
        -2,
        -178
      ],
      [
        1,
        -67
      ],
      [
        0,
        -169
      ],
      [
        -2,
        0
      ],
      [
        0,
        -227
      ],
      [
        -17,
        0
      ],
      [
        0,
        -77
      ],
      [
        -17,
        0
      ],
      [
        0,
        -202
      ],
      [
        -33,
        0
      ],
      [
        0,
        -204
      ],
      [
        -2,
        -203
      ]
    ],
    [
      [
        18971,
        68934
      ],
      [
        0,
        -48
      ],
      [
        2,
        -175
      ]
    ],
    [
      [
        18973,
        68711
      ],
      [
        -4,
        2
      ],
      [
        -17,
        21
      ],
      [
        -2,
        7
      ],
      [
        -3,
        20
      ],
      [
        -1,
        22
      ],
      [
        -4,
        12
      ],
      [
        -2,
        1
      ],
      [
        -3,
        6
      ],
      [
        -2,
        17
      ],
      [
        -2,
        5
      ],
      [
        -3,
        5
      ],
      [
        -6,
        6
      ],
      [
        -2,
        7
      ],
      [
        0,
        23
      ],
      [
        2,
        20
      ],
      [
        -8,
        32
      ],
      [
        -3,
        -2
      ],
      [
        -4,
        7
      ],
      [
        2,
        15
      ],
      [
        -7,
        39
      ],
      [
        -8,
        26
      ],
      [
        -5,
        6
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        3
      ],
      [
        -3,
        12
      ],
      [
        0,
        5
      ],
      [
        -2,
        9
      ],
      [
        -1,
        2
      ]
    ],
    [
      [
        18881,
        69034
      ],
      [
        0,
        186
      ],
      [
        1,
        511
      ],
      [
        7,
        0
      ],
      [
        -1,
        339
      ],
      [
        -51,
        1
      ],
      [
        0,
        17
      ],
      [
        -6,
        -1
      ],
      [
        0,
        17
      ],
      [
        -6,
        0
      ],
      [
        0,
        17
      ],
      [
        -5,
        -1
      ],
      [
        0,
        18
      ],
      [
        -6,
        0
      ],
      [
        0,
        17
      ],
      [
        -6,
        -1
      ],
      [
        0,
        17
      ],
      [
        -6,
        0
      ],
      [
        0,
        17
      ],
      [
        -17,
        0
      ],
      [
        0,
        34
      ],
      [
        -11,
        0
      ],
      [
        0,
        17
      ],
      [
        -12,
        0
      ],
      [
        0,
        13
      ]
    ],
    [
      [
        25405,
        58661
      ],
      [
        14,
        -3
      ],
      [
        5,
        -16
      ],
      [
        11,
        -24
      ],
      [
        3,
        20
      ],
      [
        5,
        3
      ],
      [
        2,
        15
      ],
      [
        28,
        3
      ]
    ],
    [
      [
        25473,
        58659
      ],
      [
        -4,
        -131
      ],
      [
        6,
        -27
      ],
      [
        -8,
        -1
      ],
      [
        -1,
        -45
      ],
      [
        5,
        -16
      ],
      [
        10,
        -19
      ],
      [
        8,
        -28
      ]
    ],
    [
      [
        25473,
        58245
      ],
      [
        -5,
        10
      ],
      [
        -19,
        -8
      ],
      [
        -7,
        -18
      ],
      [
        -8,
        -5
      ],
      [
        -2,
        12
      ],
      [
        -12,
        -15
      ],
      [
        -7,
        3
      ],
      [
        -5,
        -8
      ],
      [
        -6,
        2
      ],
      [
        -5,
        -8
      ],
      [
        -6,
        -24
      ],
      [
        1,
        -11
      ]
    ],
    [
      [
        25392,
        58175
      ],
      [
        -6,
        5
      ],
      [
        -4,
        20
      ],
      [
        1,
        17
      ],
      [
        4,
        15
      ],
      [
        10,
        12
      ],
      [
        2,
        9
      ],
      [
        2,
        28
      ],
      [
        -2,
        24
      ],
      [
        -4,
        21
      ],
      [
        -10,
        71
      ],
      [
        -1,
        9
      ],
      [
        5,
        45
      ],
      [
        0,
        26
      ],
      [
        -3,
        13
      ],
      [
        -1,
        27
      ],
      [
        3,
        24
      ],
      [
        9,
        28
      ],
      [
        3,
        20
      ],
      [
        2,
        43
      ]
    ],
    [
      [
        17519,
        67126
      ],
      [
        80,
        1
      ],
      [
        1,
        293
      ],
      [
        0,
        263
      ]
    ],
    [
      [
        17875,
        67994
      ],
      [
        -3,
        -8
      ],
      [
        -1,
        -26
      ],
      [
        -5,
        -7
      ],
      [
        -5,
        -64
      ],
      [
        -1,
        -26
      ],
      [
        4,
        -21
      ],
      [
        5,
        -14
      ],
      [
        0,
        -22
      ],
      [
        -7,
        -28
      ],
      [
        1,
        -14
      ],
      [
        -1,
        -16
      ],
      [
        0,
        -33
      ],
      [
        -2,
        0
      ],
      [
        -6,
        -22
      ],
      [
        -5,
        5
      ],
      [
        0,
        -272
      ],
      [
        -1,
        -201
      ]
    ],
    [
      [
        17861,
        66892
      ],
      [
        0,
        -167
      ]
    ],
    [
      [
        17861,
        66725
      ],
      [
        -116,
        0
      ],
      [
        0,
        97
      ],
      [
        4,
        -1
      ],
      [
        0,
        94
      ],
      [
        -17,
        -5
      ],
      [
        -8,
        18
      ],
      [
        -8,
        -9
      ],
      [
        -13,
        3
      ],
      [
        -5,
        21
      ],
      [
        -7,
        -3
      ],
      [
        -6,
        -11
      ],
      [
        -7,
        -5
      ],
      [
        -13,
        4
      ],
      [
        -8,
        -5
      ],
      [
        -7,
        12
      ],
      [
        3,
        14
      ],
      [
        -2,
        14
      ],
      [
        -11,
        0
      ],
      [
        -4,
        -4
      ],
      [
        -5,
        6
      ],
      [
        -4,
        17
      ],
      [
        -4,
        -7
      ],
      [
        -7,
        5
      ],
      [
        0,
        9
      ],
      [
        -5,
        8
      ],
      [
        -7,
        -15
      ],
      [
        -3,
        -22
      ],
      [
        3,
        -20
      ],
      [
        -1,
        -11
      ],
      [
        -13,
        7
      ],
      [
        -6,
        14
      ],
      [
        -5,
        28
      ],
      [
        -11,
        3
      ],
      [
        -7,
        26
      ],
      [
        -8,
        3
      ],
      [
        1,
        25
      ],
      [
        -7,
        4
      ],
      [
        -10,
        13
      ],
      [
        -1,
        25
      ],
      [
        4,
        14
      ],
      [
        -4,
        12
      ],
      [
        -9,
        2
      ],
      [
        -8,
        13
      ],
      [
        0,
        8
      ]
    ],
    [
      [
        21278,
        66343
      ],
      [
        7,
        0
      ],
      [
        0,
        -26
      ],
      [
        -1,
        -71
      ],
      [
        2,
        -124
      ],
      [
        1,
        -84
      ],
      [
        0,
        -100
      ],
      [
        11,
        1
      ],
      [
        0,
        -49
      ],
      [
        1,
        -54
      ]
    ],
    [
      [
        21299,
        65836
      ],
      [
        -46,
        -4
      ],
      [
        -25,
        1
      ],
      [
        -114,
        1
      ]
    ],
    [
      [
        21114,
        65834
      ],
      [
        -11,
        1
      ]
    ],
    [
      [
        21103,
        65835
      ],
      [
        0,
        101
      ],
      [
        -12,
        0
      ],
      [
        0,
        404
      ]
    ],
    [
      [
        30177,
        65373
      ],
      [
        3,
        -10
      ],
      [
        0,
        -18
      ],
      [
        -2,
        3
      ],
      [
        -2,
        13
      ],
      [
        1,
        12
      ]
    ],
    [
      [
        30024,
        65813
      ],
      [
        5,
        1
      ],
      [
        21,
        34
      ],
      [
        22,
        34
      ],
      [
        5,
        9
      ],
      [
        4,
        7
      ],
      [
        3,
        4
      ],
      [
        8,
        14
      ],
      [
        7,
        11
      ],
      [
        9,
        15
      ]
    ],
    [
      [
        30174,
        65398
      ],
      [
        0,
        1
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        3,
        -32
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -6
      ],
      [
        -1,
        9
      ],
      [
        -2,
        13
      ],
      [
        -1,
        16
      ],
      [
        0,
        13
      ],
      [
        -1,
        3
      ],
      [
        -5,
        5
      ],
      [
        -1,
        -10
      ],
      [
        -3,
        0
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -4
      ],
      [
        2,
        -11
      ],
      [
        1,
        -19
      ],
      [
        0,
        -2
      ],
      [
        -3,
        4
      ],
      [
        -1,
        14
      ],
      [
        -1,
        4
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -10
      ],
      [
        1,
        -8
      ],
      [
        -1,
        -11
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        4
      ],
      [
        -2,
        0
      ],
      [
        0,
        -9
      ],
      [
        3,
        -9
      ],
      [
        2,
        -30
      ],
      [
        -3,
        0
      ],
      [
        -2,
        -12
      ],
      [
        -1,
        -17
      ],
      [
        -3,
        17
      ],
      [
        -5,
        1
      ],
      [
        -1,
        -11
      ],
      [
        1,
        -13
      ],
      [
        -6,
        3
      ],
      [
        -5,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        -8
      ],
      [
        -2,
        -5
      ],
      [
        -5,
        13
      ],
      [
        -7,
        4
      ],
      [
        -10,
        -14
      ]
    ],
    [
      [
        30076,
        65453
      ],
      [
        -2,
        7
      ],
      [
        -6,
        34
      ]
    ],
    [
      [
        30068,
        65494
      ],
      [
        0,
        2
      ],
      [
        -10,
        46
      ],
      [
        -7,
        12
      ],
      [
        -9,
        15
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        30042,
        65570
      ],
      [
        -3,
        5
      ],
      [
        0,
        8
      ],
      [
        -1,
        6
      ],
      [
        0,
        3
      ],
      [
        -1,
        0
      ],
      [
        -1,
        2
      ],
      [
        0,
        14
      ],
      [
        -2,
        17
      ],
      [
        0,
        6
      ],
      [
        2,
        4
      ],
      [
        0,
        2
      ],
      [
        1,
        2
      ],
      [
        -2,
        10
      ],
      [
        0,
        1
      ],
      [
        2,
        19
      ],
      [
        0,
        13
      ],
      [
        -1,
        1
      ],
      [
        0,
        29
      ],
      [
        -4,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -1
      ],
      [
        0,
        107
      ]
    ],
    [
      [
        25465,
        61657
      ],
      [
        0,
        -6
      ],
      [
        -4,
        -19
      ],
      [
        -5,
        -26
      ],
      [
        -8,
        -9
      ],
      [
        -4,
        -19
      ],
      [
        -3,
        -25
      ],
      [
        0,
        -37
      ],
      [
        -2,
        -15
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        6
      ],
      [
        -1,
        11
      ],
      [
        2,
        18
      ],
      [
        -1,
        5
      ],
      [
        -1,
        3
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -12
      ],
      [
        -1,
        -9
      ],
      [
        -2,
        -7
      ],
      [
        -3,
        -13
      ],
      [
        -1,
        0
      ],
      [
        -2,
        2
      ],
      [
        0,
        7
      ],
      [
        1,
        7
      ],
      [
        1,
        8
      ],
      [
        0,
        8
      ],
      [
        -2,
        4
      ],
      [
        -2,
        -1
      ],
      [
        -3,
        -7
      ],
      [
        -2,
        -16
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -12
      ],
      [
        2,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        -3,
        -5
      ],
      [
        0,
        -13
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        4
      ],
      [
        1,
        3
      ],
      [
        -4,
        15
      ],
      [
        -1,
        2
      ],
      [
        0,
        -2
      ]
    ],
    [
      [
        25398,
        61473
      ],
      [
        -1,
        4
      ]
    ],
    [
      [
        25397,
        61477
      ],
      [
        0,
        12
      ],
      [
        11,
        24
      ],
      [
        -2,
        11
      ],
      [
        3,
        10
      ],
      [
        -3,
        13
      ],
      [
        1,
        20
      ],
      [
        -4,
        19
      ],
      [
        -2,
        28
      ],
      [
        0,
        26
      ],
      [
        6,
        29
      ],
      [
        3,
        36
      ],
      [
        -2,
        39
      ],
      [
        1,
        19
      ],
      [
        -2,
        12
      ],
      [
        4,
        21
      ],
      [
        -3,
        11
      ],
      [
        -1,
        31
      ]
    ],
    [
      [
        26651,
        59889
      ],
      [
        9,
        -14
      ],
      [
        13,
        8
      ],
      [
        4,
        15
      ],
      [
        -1,
        20
      ],
      [
        21,
        23
      ],
      [
        18,
        33
      ],
      [
        8,
        40
      ],
      [
        12,
        4
      ],
      [
        2,
        17
      ]
    ],
    [
      [
        26737,
        60035
      ],
      [
        5,
        0
      ],
      [
        11,
        -23
      ]
    ],
    [
      [
        26753,
        60012
      ],
      [
        -1,
        -12
      ],
      [
        -6,
        -11
      ],
      [
        -1,
        -29
      ],
      [
        32,
        32
      ],
      [
        4,
        -8
      ],
      [
        5,
        19
      ],
      [
        11,
        10
      ],
      [
        7,
        16
      ],
      [
        20,
        -49
      ]
    ],
    [
      [
        26824,
        59980
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        1,
        -6
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -13
      ],
      [
        1,
        -5
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        2,
        -5
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        26821,
        59886
      ],
      [
        0,
        -5
      ],
      [
        -2,
        0
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        -3
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        0
      ],
      [
        -4,
        -8
      ],
      [
        -4,
        -1
      ],
      [
        -3,
        -5
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -2,
        1
      ],
      [
        -3,
        -1
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -5
      ],
      [
        -2,
        0
      ],
      [
        -3,
        3
      ],
      [
        -1,
        2
      ],
      [
        0,
        4
      ],
      [
        -4,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -3,
        2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -7
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -4
      ],
      [
        1,
        -3
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -9
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -1
      ],
      [
        0,
        -22
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        2,
        -3
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -2
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -1
      ],
      [
        -3,
        0
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -8,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -6,
        -7
      ],
      [
        -5,
        -5
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        -4
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -5,
        -3
      ],
      [
        -2,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -7,
        -8
      ],
      [
        -2,
        -4
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -2
      ],
      [
        -5,
        -7
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -7
      ],
      [
        0,
        -3
      ],
      [
        -4,
        -7
      ],
      [
        -3,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        1
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ]
    ],
    [
      [
        26659,
        59620
      ],
      [
        0,
        38
      ],
      [
        -6,
        15
      ],
      [
        -5,
        27
      ],
      [
        2,
        28
      ],
      [
        2,
        30
      ],
      [
        -7,
        28
      ],
      [
        8,
        49
      ],
      [
        -3,
        17
      ],
      [
        -1,
        24
      ],
      [
        2,
        13
      ]
    ],
    [
      [
        25578,
        58450
      ],
      [
        14,
        44
      ],
      [
        10,
        4
      ],
      [
        2,
        23
      ],
      [
        4,
        5
      ],
      [
        5,
        147
      ]
    ],
    [
      [
        25613,
        58673
      ],
      [
        50,
        -64
      ],
      [
        9,
        -20
      ],
      [
        9,
        -8
      ],
      [
        2,
        13
      ],
      [
        10,
        -6
      ],
      [
        -3,
        -19
      ],
      [
        14,
        -21
      ],
      [
        12,
        -22
      ],
      [
        9,
        -5
      ],
      [
        9,
        -16
      ]
    ],
    [
      [
        25734,
        58505
      ],
      [
        -5,
        -18
      ],
      [
        -4,
        6
      ],
      [
        -3,
        -111
      ],
      [
        -5,
        -11
      ],
      [
        4,
        -11
      ],
      [
        -4,
        -17
      ],
      [
        1,
        -20
      ],
      [
        -3,
        -29
      ],
      [
        -6,
        -27
      ],
      [
        -2,
        22
      ],
      [
        -1,
        -32
      ],
      [
        -12,
        -35
      ],
      [
        -9,
        -14
      ],
      [
        -1,
        -40
      ]
    ],
    [
      [
        25615,
        58187
      ],
      [
        -5,
        8
      ],
      [
        -1,
        -13
      ],
      [
        -18,
        15
      ],
      [
        0,
        3
      ]
    ],
    [
      [
        23795,
        52330
      ],
      [
        71,
        1
      ],
      [
        0,
        102
      ],
      [
        28,
        0
      ],
      [
        0,
        -102
      ],
      [
        71,
        0
      ]
    ],
    [
      [
        23965,
        52331
      ],
      [
        0,
        -27
      ],
      [
        28,
        0
      ],
      [
        0,
        -139
      ],
      [
        9,
        1
      ],
      [
        0,
        -121
      ],
      [
        29,
        -1
      ],
      [
        1,
        -15
      ],
      [
        -5,
        -15
      ],
      [
        0,
        -21
      ],
      [
        4,
        -19
      ],
      [
        2,
        -15
      ],
      [
        -31,
        -1
      ],
      [
        0,
        -51
      ]
    ],
    [
      [
        23805,
        52146
      ],
      [
        -1,
        7
      ],
      [
        0,
        45
      ],
      [
        -1,
        3
      ],
      [
        -1,
        4
      ],
      [
        -1,
        0
      ],
      [
        -2,
        1
      ],
      [
        -4,
        10
      ],
      [
        -6,
        30
      ],
      [
        -1,
        0
      ],
      [
        0,
        4
      ],
      [
        2,
        27
      ],
      [
        1,
        17
      ],
      [
        -1,
        19
      ],
      [
        0,
        3
      ],
      [
        2,
        7
      ],
      [
        2,
        1
      ],
      [
        1,
        6
      ]
    ],
    [
      [
        27751,
        58664
      ],
      [
        85,
        1
      ],
      [
        -4,
        17
      ],
      [
        0,
        21
      ]
    ],
    [
      [
        27928,
        58693
      ],
      [
        -1,
        -29
      ],
      [
        -6,
        -57
      ],
      [
        -2,
        -26
      ],
      [
        -16,
        -188
      ],
      [
        16,
        -21
      ],
      [
        6,
        -8
      ],
      [
        0,
        -2
      ]
    ],
    [
      [
        27925,
        58362
      ],
      [
        -15,
        -72
      ]
    ],
    [
      [
        27910,
        58290
      ],
      [
        -7,
        23
      ],
      [
        -6,
        3
      ],
      [
        -8,
        30
      ],
      [
        -2,
        30
      ],
      [
        -7,
        21
      ],
      [
        -11,
        17
      ],
      [
        -9,
        -11
      ],
      [
        -6,
        -29
      ],
      [
        -2,
        -6
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -4
      ],
      [
        -2,
        -1
      ],
      [
        -3,
        -5
      ],
      [
        1,
        -18
      ],
      [
        -7,
        -8
      ],
      [
        2,
        16
      ],
      [
        -7,
        4
      ],
      [
        -1,
        -19
      ],
      [
        -5,
        -20
      ],
      [
        -3,
        -5
      ],
      [
        -5,
        14
      ],
      [
        2,
        14
      ],
      [
        -10,
        -13
      ],
      [
        3,
        -14
      ],
      [
        -3,
        -9
      ],
      [
        -8,
        -8
      ]
    ],
    [
      [
        27804,
        58285
      ],
      [
        -57,
        -3
      ]
    ],
    [
      [
        22216,
        50280
      ],
      [
        3,
        0
      ]
    ],
    [
      [
        22220,
        49772
      ],
      [
        -201,
        -8
      ]
    ],
    [
      [
        22019,
        49764
      ],
      [
        0,
        524
      ]
    ],
    [
      [
        26804,
        60844
      ],
      [
        -2,
        -44
      ],
      [
        5,
        -25
      ],
      [
        5,
        -4
      ],
      [
        2,
        -15
      ],
      [
        -1,
        -39
      ],
      [
        3,
        -22
      ],
      [
        -1,
        -13
      ],
      [
        3,
        -14
      ],
      [
        0,
        -25
      ],
      [
        3,
        -9
      ],
      [
        -4,
        -4
      ],
      [
        -1,
        -27
      ],
      [
        -4,
        -11
      ],
      [
        0,
        -9
      ],
      [
        -4,
        -6
      ]
    ],
    [
      [
        26802,
        60596
      ],
      [
        -4,
        18
      ],
      [
        -10,
        11
      ],
      [
        -3,
        26
      ],
      [
        -3,
        -1
      ],
      [
        2,
        40
      ],
      [
        -4,
        7
      ],
      [
        -4,
        -6
      ],
      [
        -5,
        16
      ],
      [
        -1,
        15
      ],
      [
        -3,
        -2
      ],
      [
        -5,
        26
      ],
      [
        -7,
        -24
      ],
      [
        -5,
        -5
      ],
      [
        -2,
        14
      ],
      [
        -8,
        19
      ],
      [
        -1,
        8
      ],
      [
        -12,
        8
      ],
      [
        -9,
        24
      ]
    ],
    [
      [
        26718,
        60790
      ],
      [
        -2,
        18
      ],
      [
        4,
        15
      ],
      [
        -6,
        17
      ]
    ],
    [
      [
        26714,
        60840
      ],
      [
        6,
        37
      ],
      [
        -8,
        29
      ],
      [
        6,
        19
      ],
      [
        6,
        5
      ],
      [
        5,
        34
      ],
      [
        9,
        3
      ],
      [
        1,
        12
      ],
      [
        17,
        37
      ],
      [
        -5,
        36
      ],
      [
        11,
        -5
      ],
      [
        9,
        -24
      ],
      [
        4,
        3
      ],
      [
        3,
        16
      ],
      [
        3,
        -21
      ],
      [
        5,
        -10
      ]
    ],
    [
      [
        18780,
        64505
      ],
      [
        -2,
        -1
      ],
      [
        -3,
        -9
      ],
      [
        -15,
        -14
      ],
      [
        -7,
        -11
      ],
      [
        -9,
        -11
      ],
      [
        -19,
        0
      ],
      [
        -2,
        1
      ],
      [
        -5,
        36
      ],
      [
        -2,
        39
      ],
      [
        3,
        30
      ],
      [
        0,
        11
      ],
      [
        -14,
        -1
      ],
      [
        -39,
        -87
      ],
      [
        -31,
        -90
      ]
    ],
    [
      [
        18635,
        64398
      ],
      [
        -65,
        358
      ]
    ],
    [
      [
        18570,
        64756
      ],
      [
        12,
        12
      ],
      [
        74,
        77
      ],
      [
        30,
        -1
      ],
      [
        30,
        0
      ],
      [
        4,
        -14
      ],
      [
        12,
        -6
      ],
      [
        3,
        1
      ],
      [
        0,
        1
      ],
      [
        1,
        -2
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        1
      ],
      [
        6,
        0
      ],
      [
        1,
        -1
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        2,
        2
      ]
    ],
    [
      [
        18563,
        61769
      ],
      [
        87,
        2
      ],
      [
        23,
        0
      ],
      [
        17,
        -2
      ],
      [
        0,
        -10
      ],
      [
        83,
        0
      ]
    ],
    [
      [
        18773,
        61759
      ],
      [
        -16,
        -52
      ],
      [
        -4,
        -34
      ],
      [
        -3,
        -4
      ],
      [
        1,
        -318
      ]
    ],
    [
      [
        18751,
        61351
      ],
      [
        -30,
        -1
      ],
      [
        -30,
        -6
      ],
      [
        -107,
        5
      ]
    ],
    [
      [
        18584,
        61349
      ],
      [
        6,
        24
      ],
      [
        -1,
        12
      ],
      [
        9,
        29
      ],
      [
        8,
        11
      ],
      [
        2,
        11
      ],
      [
        -6,
        23
      ],
      [
        1,
        12
      ],
      [
        7,
        32
      ],
      [
        1,
        26
      ],
      [
        2,
        9
      ],
      [
        1,
        24
      ],
      [
        -2,
        17
      ],
      [
        -5,
        11
      ],
      [
        -5,
        27
      ],
      [
        -3,
        1
      ],
      [
        -4,
        16
      ],
      [
        0,
        24
      ],
      [
        -4,
        5
      ],
      [
        -2,
        -15
      ],
      [
        -5,
        -1
      ],
      [
        -3,
        27
      ],
      [
        -7,
        22
      ],
      [
        -4,
        4
      ],
      [
        -2,
        16
      ],
      [
        -5,
        17
      ],
      [
        3,
        10
      ],
      [
        -3,
        26
      ]
    ],
    [
      [
        26927,
        61111
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -4
      ],
      [
        1,
        -6
      ],
      [
        1,
        -1
      ],
      [
        2,
        -11
      ],
      [
        0,
        -1
      ],
      [
        4,
        -20
      ],
      [
        0,
        -1
      ],
      [
        1,
        0
      ],
      [
        6,
        6
      ],
      [
        3,
        -5
      ],
      [
        0,
        -3
      ],
      [
        1,
        -9
      ],
      [
        1,
        -2
      ],
      [
        2,
        -3
      ],
      [
        1,
        -2
      ],
      [
        0,
        -15
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -11
      ]
    ],
    [
      [
        26948,
        61005
      ],
      [
        1,
        -8
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        1,
        -1
      ],
      [
        1,
        -10
      ],
      [
        0,
        -1
      ],
      [
        3,
        -6
      ],
      [
        3,
        -14
      ],
      [
        1,
        -1
      ],
      [
        1,
        -8
      ],
      [
        0,
        -3
      ],
      [
        1,
        -6
      ],
      [
        0,
        -1
      ],
      [
        2,
        0
      ],
      [
        0,
        -2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        2,
        0
      ],
      [
        0,
        -1
      ],
      [
        2,
        -7
      ],
      [
        2,
        -2
      ],
      [
        1,
        -6
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        1,
        -10
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        1,
        0
      ],
      [
        1,
        -8
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -3
      ]
    ],
    [
      [
        26973,
        60873
      ],
      [
        -12,
        -2
      ],
      [
        -10,
        -31
      ],
      [
        7,
        -18
      ],
      [
        -5,
        -30
      ],
      [
        -4,
        11
      ],
      [
        -10,
        -14
      ],
      [
        -3,
        17
      ],
      [
        -7,
        -6
      ],
      [
        -3,
        12
      ],
      [
        -5,
        7
      ],
      [
        -10,
        -4
      ],
      [
        -2,
        -7
      ]
    ],
    [
      [
        26909,
        60808
      ],
      [
        -1,
        5
      ],
      [
        -15,
        18
      ],
      [
        -6,
        18
      ]
    ],
    [
      [
        24355,
        67981
      ],
      [
        124,
        0
      ]
    ],
    [
      [
        24479,
        67981
      ],
      [
        1,
        -5
      ],
      [
        1,
        -6
      ],
      [
        1,
        -15
      ],
      [
        0,
        -7
      ],
      [
        1,
        -6
      ],
      [
        1,
        -11
      ],
      [
        1,
        -5
      ],
      [
        0,
        -9
      ],
      [
        3,
        -10
      ],
      [
        2,
        -10
      ],
      [
        0,
        -2
      ],
      [
        -3,
        -33
      ],
      [
        0,
        -22
      ]
    ],
    [
      [
        24498,
        67577
      ],
      [
        -8,
        0
      ],
      [
        -5,
        1
      ],
      [
        -30,
        0
      ],
      [
        -2,
        -1
      ],
      [
        -5,
        1
      ],
      [
        -13,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -24,
        0
      ],
      [
        -2,
        -1
      ],
      [
        -20,
        0
      ]
    ],
    [
      [
        24355,
        67578
      ],
      [
        0,
        403
      ]
    ],
    [
      [
        15703,
        70313
      ],
      [
        12,
        23
      ],
      [
        6,
        -3
      ],
      [
        -1,
        6
      ],
      [
        -2,
        25
      ],
      [
        -5,
        5
      ],
      [
        3,
        5
      ],
      [
        0,
        14
      ],
      [
        3,
        1
      ],
      [
        2,
        19
      ],
      [
        9,
        -4
      ],
      [
        -1,
        15
      ],
      [
        6,
        -5
      ],
      [
        3,
        -11
      ],
      [
        4,
        11
      ],
      [
        8,
        -2
      ],
      [
        11,
        22
      ],
      [
        5,
        -1
      ],
      [
        7,
        30
      ],
      [
        6,
        6
      ],
      [
        4,
        -4
      ],
      [
        6,
        8
      ],
      [
        8,
        -6
      ],
      [
        1,
        -8
      ],
      [
        13,
        -4
      ],
      [
        7,
        -14
      ],
      [
        11,
        5
      ],
      [
        5,
        30
      ],
      [
        -4,
        23
      ],
      [
        16,
        57
      ],
      [
        7,
        -6
      ]
    ],
    [
      [
        15853,
        70550
      ],
      [
        0,
        -218
      ],
      [
        -1,
        -56
      ],
      [
        0,
        -315
      ]
    ],
    [
      [
        15852,
        69961
      ],
      [
        -4,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        -8,
        0
      ],
      [
        -10,
        5
      ],
      [
        -6,
        25
      ],
      [
        -7,
        7
      ],
      [
        -4,
        -1
      ],
      [
        -2,
        -4
      ],
      [
        -3,
        -4
      ],
      [
        -8,
        -5
      ],
      [
        -4,
        4
      ],
      [
        -6,
        13
      ],
      [
        -1,
        2
      ],
      [
        -4,
        4
      ],
      [
        -3,
        3
      ],
      [
        -5,
        4
      ],
      [
        -7,
        9
      ],
      [
        -1,
        0
      ],
      [
        -8,
        8
      ],
      [
        -2,
        1
      ],
      [
        -4,
        3
      ],
      [
        -12,
        3
      ],
      [
        -8,
        9
      ],
      [
        -5,
        8
      ],
      [
        -6,
        15
      ],
      [
        -7,
        8
      ],
      [
        -7,
        14
      ],
      [
        0,
        1
      ],
      [
        -3,
        27
      ],
      [
        0,
        22
      ],
      [
        3,
        34
      ]
    ],
    [
      [
        25383,
        67626
      ],
      [
        69,
        1
      ]
    ],
    [
      [
        25452,
        67627
      ],
      [
        -1,
        -18
      ],
      [
        0,
        -20
      ],
      [
        1,
        -21
      ],
      [
        -4,
        -36
      ],
      [
        -6,
        -31
      ],
      [
        -8,
        -34
      ],
      [
        -2,
        -14
      ],
      [
        -2,
        -16
      ],
      [
        -2,
        -12
      ],
      [
        -1,
        -20
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -51
      ],
      [
        -3,
        -27
      ],
      [
        -3,
        -40
      ],
      [
        0,
        -17
      ],
      [
        4,
        -45
      ],
      [
        1,
        -6
      ]
    ],
    [
      [
        25424,
        67218
      ],
      [
        -9,
        0
      ],
      [
        -9,
        1
      ],
      [
        -10,
        0
      ],
      [
        -19,
        -1
      ]
    ],
    [
      [
        25377,
        67218
      ],
      [
        0,
        204
      ],
      [
        6,
        0
      ],
      [
        0,
        204
      ]
    ],
    [
      [
        18552,
        70796
      ],
      [
        -3,
        46
      ],
      [
        10,
        31
      ],
      [
        8,
        -2
      ],
      [
        2,
        14
      ],
      [
        7,
        -2
      ],
      [
        5,
        -13
      ],
      [
        1,
        24
      ],
      [
        7,
        9
      ],
      [
        0,
        14
      ],
      [
        6,
        20
      ],
      [
        15,
        -1
      ],
      [
        4,
        21
      ],
      [
        7,
        20
      ]
    ],
    [
      [
        18762,
        70252
      ],
      [
        -1,
        13
      ],
      [
        -10,
        14
      ],
      [
        -8,
        -4
      ],
      [
        -3,
        15
      ],
      [
        -8,
        -1
      ],
      [
        -5,
        32
      ],
      [
        -7,
        -9
      ],
      [
        -3,
        4
      ],
      [
        -5,
        -8
      ],
      [
        -11,
        15
      ],
      [
        -7,
        -11
      ],
      [
        -6,
        4
      ],
      [
        -10,
        -14
      ],
      [
        -3,
        -33
      ],
      [
        1,
        -8
      ],
      [
        -7,
        -29
      ],
      [
        1,
        -11
      ],
      [
        -9,
        -25
      ],
      [
        -6,
        -2
      ]
    ],
    [
      [
        18655,
        70194
      ],
      [
        -7,
        20
      ],
      [
        -11,
        6
      ],
      [
        -4,
        18
      ],
      [
        -41,
        59
      ],
      [
        -3,
        8
      ],
      [
        -1,
        12
      ],
      [
        7,
        40
      ],
      [
        -5,
        25
      ],
      [
        1,
        9
      ],
      [
        1,
        5
      ],
      [
        -6,
        22
      ],
      [
        2,
        21
      ],
      [
        -4,
        44
      ],
      [
        2,
        20
      ],
      [
        -2,
        23
      ],
      [
        -4,
        4
      ],
      [
        -4,
        3
      ],
      [
        -1,
        14
      ],
      [
        4,
        28
      ],
      [
        -1,
        20
      ],
      [
        -8,
        19
      ],
      [
        -7,
        32
      ],
      [
        2,
        25
      ],
      [
        -1,
        9
      ],
      [
        3,
        22
      ],
      [
        -6,
        0
      ],
      [
        -5,
        -11
      ],
      [
        -9,
        4
      ]
    ],
    [
      [
        18547,
        70695
      ],
      [
        1,
        39
      ],
      [
        -7,
        29
      ],
      [
        5,
        6
      ],
      [
        6,
        27
      ]
    ],
    [
      [
        26600,
        58891
      ],
      [
        4,
        -4
      ],
      [
        1,
        9
      ],
      [
        13,
        -31
      ],
      [
        23,
        -60
      ],
      [
        5,
        -30
      ],
      [
        8,
        -10
      ],
      [
        1,
        -8
      ],
      [
        8,
        7
      ],
      [
        3,
        -6
      ],
      [
        5,
        11
      ],
      [
        8,
        -6
      ],
      [
        0,
        -17
      ],
      [
        8,
        6
      ],
      [
        8,
        -9
      ],
      [
        6,
        -18
      ]
    ],
    [
      [
        26716,
        58493
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        4
      ],
      [
        -1,
        5
      ],
      [
        -4,
        3
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -10
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        -3,
        -4
      ],
      [
        0,
        -2
      ],
      [
        -3,
        -2
      ],
      [
        -3,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        -3
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -6
      ],
      [
        -2,
        -3
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -10
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -4
      ],
      [
        -5,
        0
      ],
      [
        -1,
        3
      ],
      [
        -4,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -4,
        -2
      ],
      [
        -2,
        1
      ],
      [
        -1,
        1
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        3
      ],
      [
        -1,
        7
      ],
      [
        -2,
        6
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -6
      ],
      [
        -4,
        -8
      ],
      [
        -1,
        2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -2,
        3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        26603,
        58345
      ],
      [
        0,
        141
      ],
      [
        -4,
        -6
      ],
      [
        -2,
        29
      ],
      [
        -6,
        2
      ],
      [
        1,
        9
      ],
      [
        -4,
        11
      ],
      [
        -1,
        22
      ],
      [
        -8,
        59
      ],
      [
        2,
        9
      ],
      [
        -5,
        13
      ],
      [
        -10,
        81
      ]
    ],
    [
      [
        26566,
        58715
      ],
      [
        7,
        28
      ],
      [
        9,
        7
      ],
      [
        11,
        26
      ],
      [
        4,
        -3
      ],
      [
        -1,
        15
      ],
      [
        5,
        14
      ],
      [
        5,
        29
      ],
      [
        -3,
        5
      ],
      [
        -3,
        55
      ]
    ],
    [
      [
        31509,
        38018
      ],
      [
        -4,
        -33
      ],
      [
        -6,
        -26
      ],
      [
        2,
        -27
      ]
    ],
    [
      [
        31504,
        37854
      ],
      [
        -3,
        0
      ],
      [
        -10,
        -20
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        -6
      ],
      [
        -4,
        -9
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        1
      ],
      [
        -2,
        4
      ],
      [
        -2,
        2
      ],
      [
        -2,
        1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -8
      ],
      [
        -3,
        -7
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -7
      ]
    ],
    [
      [
        31463,
        37795
      ],
      [
        -2,
        11
      ],
      [
        1,
        20
      ],
      [
        4,
        24
      ],
      [
        0,
        58
      ],
      [
        7,
        14
      ],
      [
        4,
        30
      ]
    ],
    [
      [
        17430,
        64667
      ],
      [
        119,
        0
      ],
      [
        0,
        -389
      ],
      [
        44,
        -627
      ],
      [
        46,
        0
      ]
    ],
    [
      [
        17639,
        63651
      ],
      [
        1,
        -3
      ],
      [
        1,
        -12
      ],
      [
        -3,
        -17
      ],
      [
        2,
        -29
      ],
      [
        2,
        -26
      ],
      [
        0,
        -31
      ],
      [
        -2,
        -28
      ],
      [
        1,
        -22
      ],
      [
        3,
        -27
      ],
      [
        0,
        -29
      ],
      [
        4,
        -28
      ],
      [
        -1,
        -24
      ],
      [
        1,
        -21
      ],
      [
        2,
        -21
      ],
      [
        -1,
        -24
      ],
      [
        -4,
        -21
      ],
      [
        1,
        -31
      ],
      [
        0,
        -29
      ],
      [
        -2,
        -20
      ],
      [
        -4,
        -22
      ],
      [
        1,
        -36
      ],
      [
        1,
        -21
      ],
      [
        0,
        -52
      ],
      [
        2,
        -28
      ],
      [
        1,
        -26
      ],
      [
        -5,
        -21
      ],
      [
        0,
        -28
      ],
      [
        -2,
        -30
      ],
      [
        -1,
        -13
      ],
      [
        -3,
        -10
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -19
      ],
      [
        -2,
        -6
      ],
      [
        -4,
        -6
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        2
      ],
      [
        0,
        -345
      ]
    ],
    [
      [
        17619,
        62527
      ],
      [
        -26,
        0
      ],
      [
        0,
        -1
      ],
      [
        -167,
        1
      ]
    ],
    [
      [
        17426,
        62527
      ],
      [
        1,
        17
      ],
      [
        0,
        229
      ],
      [
        1,
        28
      ],
      [
        -2,
        788
      ],
      [
        2,
        286
      ],
      [
        -1,
        729
      ],
      [
        3,
        1
      ],
      [
        0,
        62
      ]
    ],
    [
      [
        24078,
        55074
      ],
      [
        24,
        0
      ],
      [
        7,
        -8
      ],
      [
        6,
        3
      ],
      [
        6,
        -7
      ],
      [
        7,
        -36
      ],
      [
        7,
        3
      ],
      [
        0,
        -58
      ],
      [
        29,
        -1
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        24164,
        54869
      ],
      [
        0,
        -102
      ]
    ],
    [
      [
        24164,
        54767
      ],
      [
        -47,
        1
      ],
      [
        -11,
        0
      ],
      [
        1,
        -51
      ],
      [
        -35,
        1
      ],
      [
        -9,
        0
      ]
    ],
    [
      [
        24034,
        54871
      ],
      [
        0,
        19
      ],
      [
        6,
        23
      ],
      [
        -2,
        66
      ],
      [
        1,
        12
      ],
      [
        3,
        10
      ],
      [
        4,
        15
      ],
      [
        3,
        6
      ],
      [
        0,
        51
      ],
      [
        29,
        1
      ]
    ],
    [
      [
        24078,
        55371
      ],
      [
        4,
        0
      ],
      [
        50,
        -2
      ],
      [
        7,
        -1
      ],
      [
        10,
        0
      ],
      [
        28,
        -1
      ],
      [
        2,
        0
      ],
      [
        7,
        -1
      ],
      [
        12,
        0
      ],
      [
        20,
        -1
      ],
      [
        43,
        -1
      ]
    ],
    [
      [
        24261,
        55364
      ],
      [
        -1,
        -23
      ],
      [
        -3,
        -8
      ],
      [
        2,
        -14
      ],
      [
        -3,
        -5
      ],
      [
        2,
        -37
      ],
      [
        0,
        -47
      ],
      [
        -2,
        -13
      ],
      [
        2,
        -20
      ],
      [
        6,
        -32
      ],
      [
        -3,
        -4
      ],
      [
        0,
        -15
      ],
      [
        4,
        -31
      ],
      [
        -3,
        -38
      ],
      [
        3,
        -29
      ],
      [
        -5,
        -4
      ],
      [
        2,
        -12
      ]
    ],
    [
      [
        24262,
        55032
      ],
      [
        -7,
        -41
      ],
      [
        -9,
        -17
      ],
      [
        -5,
        2
      ],
      [
        0,
        -17
      ],
      [
        -12,
        -32
      ],
      [
        -11,
        -26
      ],
      [
        -1,
        -24
      ],
      [
        -13,
        -11
      ],
      [
        -11,
        3
      ],
      [
        -29,
        0
      ]
    ],
    [
      [
        24078,
        55074
      ],
      [
        0,
        51
      ],
      [
        -3,
        0
      ],
      [
        0,
        17
      ],
      [
        3,
        0
      ],
      [
        0,
        229
      ]
    ],
    [
      [
        29982,
        67881
      ],
      [
        26,
        -77
      ],
      [
        27,
        -77
      ],
      [
        2,
        -9
      ],
      [
        14,
        -38
      ],
      [
        8,
        -20
      ],
      [
        8,
        -8
      ],
      [
        5,
        -16
      ],
      [
        3,
        10
      ],
      [
        10,
        -24
      ]
    ],
    [
      [
        30085,
        67622
      ],
      [
        -8,
        -28
      ],
      [
        9,
        -186
      ],
      [
        -13,
        -55
      ],
      [
        -8,
        -26
      ]
    ],
    [
      [
        30065,
        67327
      ],
      [
        -32,
        71
      ],
      [
        -29,
        66
      ],
      [
        -5,
        10
      ],
      [
        -22,
        47
      ],
      [
        -14,
        -20
      ],
      [
        -5,
        11
      ],
      [
        -5,
        55
      ],
      [
        -5,
        -5
      ],
      [
        0,
        5
      ],
      [
        -6,
        10
      ],
      [
        -4,
        21
      ],
      [
        1,
        12
      ],
      [
        -5,
        11
      ],
      [
        -6,
        26
      ],
      [
        0,
        4
      ]
    ],
    [
      [
        29928,
        67651
      ],
      [
        3,
        18
      ],
      [
        -4,
        13
      ],
      [
        6,
        12
      ],
      [
        6,
        -7
      ],
      [
        7,
        14
      ],
      [
        3,
        17
      ],
      [
        -1,
        12
      ],
      [
        1,
        16
      ],
      [
        -1,
        19
      ],
      [
        2,
        27
      ],
      [
        19,
        8
      ],
      [
        16,
        7
      ],
      [
        -3,
        74
      ]
    ],
    [
      [
        24283,
        55818
      ],
      [
        0,
        -13
      ],
      [
        8,
        -11
      ],
      [
        -3,
        -10
      ],
      [
        1,
        -15
      ],
      [
        -6,
        -18
      ],
      [
        4,
        -24
      ],
      [
        -1,
        -21
      ],
      [
        -9,
        -6
      ],
      [
        2,
        -13
      ],
      [
        -7,
        -13
      ],
      [
        -4,
        4
      ],
      [
        1,
        -14
      ],
      [
        -2,
        -11
      ],
      [
        -8,
        -8
      ],
      [
        1,
        -13
      ],
      [
        -4,
        3
      ],
      [
        -1,
        -18
      ],
      [
        -4,
        -8
      ],
      [
        -3,
        5
      ],
      [
        0,
        -19
      ],
      [
        -4,
        2
      ],
      [
        -2,
        -14
      ],
      [
        1,
        -27
      ],
      [
        -2,
        -12
      ]
    ],
    [
      [
        24241,
        55544
      ],
      [
        -6,
        10
      ],
      [
        -3,
        19
      ],
      [
        -3,
        0
      ],
      [
        1,
        29
      ],
      [
        -5,
        -13
      ],
      [
        -7,
        9
      ],
      [
        0,
        15
      ],
      [
        3,
        2
      ],
      [
        -6,
        8
      ],
      [
        2,
        26
      ],
      [
        -3,
        6
      ],
      [
        -3,
        -9
      ],
      [
        -5,
        4
      ],
      [
        -1,
        12
      ],
      [
        -7,
        1
      ],
      [
        -1,
        18
      ],
      [
        -3,
        -18
      ],
      [
        -5,
        -3
      ],
      [
        -1,
        20
      ],
      [
        -2,
        -5
      ],
      [
        -6,
        7
      ],
      [
        2,
        20
      ]
    ],
    [
      [
        24182,
        55702
      ],
      [
        -8,
        19
      ],
      [
        -1,
        32
      ],
      [
        2,
        42
      ],
      [
        5,
        1
      ],
      [
        1,
        26
      ],
      [
        4,
        15
      ],
      [
        0,
        16
      ],
      [
        3,
        18
      ],
      [
        3,
        29
      ],
      [
        -1,
        20
      ],
      [
        3,
        19
      ],
      [
        -3,
        25
      ],
      [
        2,
        32
      ],
      [
        -3,
        24
      ],
      [
        1,
        15
      ],
      [
        -2,
        37
      ],
      [
        2,
        16
      ],
      [
        -1,
        40
      ],
      [
        2,
        20
      ],
      [
        -3,
        30
      ]
    ],
    [
      [
        21676,
        64315
      ],
      [
        27,
        0
      ]
    ],
    [
      [
        21703,
        64315
      ],
      [
        131,
        3
      ]
    ],
    [
      [
        21834,
        64318
      ],
      [
        -1,
        -52
      ],
      [
        1,
        -327
      ],
      [
        0,
        -30
      ]
    ],
    [
      [
        21682,
        63911
      ],
      [
        -5,
        0
      ]
    ],
    [
      [
        28476,
        64246
      ],
      [
        10,
        41
      ],
      [
        6,
        16
      ],
      [
        6,
        28
      ],
      [
        1,
        45
      ],
      [
        -1,
        36
      ],
      [
        3,
        33
      ],
      [
        10,
        44
      ],
      [
        4,
        36
      ]
    ],
    [
      [
        28515,
        64525
      ],
      [
        0,
        4
      ]
    ],
    [
      [
        28515,
        64529
      ],
      [
        -7,
        10
      ],
      [
        -8,
        26
      ],
      [
        -8,
        65
      ],
      [
        3,
        30
      ],
      [
        2,
        30
      ],
      [
        1,
        61
      ],
      [
        -8,
        34
      ],
      [
        -2,
        44
      ]
    ],
    [
      [
        28488,
        64829
      ],
      [
        2,
        13
      ],
      [
        0,
        4
      ],
      [
        1,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        26,
        20
      ],
      [
        15,
        -4
      ]
    ],
    [
      [
        28533,
        64867
      ],
      [
        0,
        -93
      ],
      [
        -12,
        -98
      ],
      [
        -4,
        -71
      ],
      [
        16,
        9
      ],
      [
        20,
        15
      ],
      [
        5,
        -4
      ],
      [
        5,
        -5
      ],
      [
        7,
        -21
      ],
      [
        12,
        -4
      ],
      [
        -3,
        -27
      ],
      [
        5,
        -37
      ],
      [
        3,
        -1
      ],
      [
        3,
        0
      ]
    ],
    [
      [
        28590,
        64530
      ],
      [
        7,
        0
      ],
      [
        2,
        -33
      ],
      [
        -3,
        -9
      ],
      [
        2,
        -25
      ],
      [
        25,
        10
      ],
      [
        9,
        -68
      ]
    ],
    [
      [
        28632,
        64405
      ],
      [
        -25,
        -37
      ],
      [
        -65,
        -93
      ],
      [
        0,
        -6
      ]
    ],
    [
      [
        28542,
        64269
      ],
      [
        -13,
        -6
      ],
      [
        -13,
        -15
      ],
      [
        -3,
        8
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -10
      ],
      [
        -9,
        -9
      ],
      [
        -7,
        2
      ],
      [
        -5,
        -11
      ],
      [
        -9,
        -17
      ],
      [
        -9,
        29
      ]
    ],
    [
      [
        28473,
        64234
      ],
      [
        3,
        12
      ]
    ],
    [
      [
        28682,
        62165
      ],
      [
        2,
        16
      ],
      [
        3,
        -7
      ],
      [
        3,
        8
      ],
      [
        2,
        16
      ],
      [
        4,
        4
      ],
      [
        5,
        -4
      ],
      [
        1,
        -4
      ],
      [
        1,
        7
      ],
      [
        6,
        1
      ],
      [
        -4,
        36
      ],
      [
        1,
        3
      ],
      [
        0,
        2
      ],
      [
        1,
        3
      ],
      [
        -1,
        3
      ],
      [
        1,
        4
      ],
      [
        0,
        4
      ],
      [
        1,
        4
      ],
      [
        0,
        3
      ],
      [
        1,
        4
      ],
      [
        0,
        2
      ],
      [
        3,
        4
      ],
      [
        40,
        -30
      ]
    ],
    [
      [
        28729,
        61841
      ],
      [
        -1,
        13
      ],
      [
        -5,
        22
      ],
      [
        -9,
        26
      ],
      [
        -9,
        -2
      ],
      [
        -3,
        14
      ],
      [
        -5,
        2
      ],
      [
        -3,
        25
      ],
      [
        -5,
        17
      ],
      [
        -6,
        0
      ],
      [
        -1,
        -3
      ],
      [
        -4,
        13
      ],
      [
        -7,
        36
      ],
      [
        0,
        27
      ],
      [
        -5,
        1
      ],
      [
        -4,
        -14
      ],
      [
        0,
        -13
      ],
      [
        -1,
        -1
      ],
      [
        -7,
        6
      ],
      [
        0,
        2
      ],
      [
        1,
        5
      ],
      [
        -1,
        4
      ],
      [
        -4,
        4
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -12
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -16
      ],
      [
        2,
        -17
      ],
      [
        0,
        -12
      ],
      [
        -5,
        -9
      ],
      [
        -2,
        17
      ],
      [
        2,
        52
      ],
      [
        -1,
        25
      ],
      [
        2,
        24
      ],
      [
        3,
        8
      ],
      [
        4,
        20
      ],
      [
        0,
        19
      ],
      [
        3,
        15
      ],
      [
        1,
        3
      ],
      [
        2,
        -1
      ],
      [
        3,
        4
      ],
      [
        0,
        5
      ],
      [
        2,
        19
      ],
      [
        2,
        0
      ],
      [
        -1,
        -5
      ],
      [
        5,
        -26
      ],
      [
        1,
        -3
      ],
      [
        7,
        -11
      ],
      [
        0,
        -1
      ],
      [
        6,
        3
      ],
      [
        0,
        1
      ],
      [
        2,
        7
      ],
      [
        0,
        9
      ],
      [
        -2,
        17
      ],
      [
        0,
        8
      ]
    ],
    [
      [
        28627,
        62072
      ],
      [
        5,
        20
      ],
      [
        2,
        -11
      ],
      [
        0,
        -15
      ],
      [
        3,
        -20
      ],
      [
        -1,
        -2
      ],
      [
        -5,
        -4
      ],
      [
        -2,
        16
      ],
      [
        -2,
        16
      ]
    ],
    [
      [
        23336,
        67292
      ],
      [
        132,
        0
      ]
    ],
    [
      [
        23468,
        67292
      ],
      [
        0,
        -402
      ]
    ],
    [
      [
        23468,
        66890
      ],
      [
        -132,
        0
      ]
    ],
    [
      [
        26313,
        57963
      ],
      [
        5,
        6
      ],
      [
        5,
        25
      ],
      [
        42,
        -1
      ],
      [
        6,
        22
      ]
    ],
    [
      [
        26371,
        58015
      ],
      [
        38,
        -61
      ],
      [
        -1,
        -8
      ],
      [
        5,
        -7
      ],
      [
        -2,
        -16
      ],
      [
        2,
        -3
      ],
      [
        5,
        18
      ],
      [
        9,
        -15
      ]
    ],
    [
      [
        26427,
        57923
      ],
      [
        -1,
        -28
      ],
      [
        0,
        -18
      ],
      [
        -2,
        -53
      ],
      [
        -1,
        -33
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -16
      ],
      [
        -3,
        -105
      ]
    ],
    [
      [
        26292,
        57668
      ],
      [
        5,
        44
      ],
      [
        3,
        39
      ],
      [
        4,
        26
      ],
      [
        -4,
        5
      ],
      [
        14,
        101
      ],
      [
        -1,
        14
      ],
      [
        1,
        19
      ],
      [
        -1,
        21
      ],
      [
        1,
        11
      ],
      [
        -5,
        6
      ],
      [
        4,
        9
      ]
    ],
    [
      [
        23004,
        62998
      ],
      [
        95,
        0
      ]
    ],
    [
      [
        23099,
        62998
      ],
      [
        56,
        0
      ]
    ],
    [
      [
        23155,
        62591
      ],
      [
        0,
        -101
      ],
      [
        -1,
        -4
      ]
    ],
    [
      [
        23154,
        62486
      ],
      [
        -1,
        17
      ],
      [
        -12,
        13
      ],
      [
        1,
        13
      ],
      [
        7,
        -6
      ],
      [
        -7,
        41
      ],
      [
        -7,
        8
      ],
      [
        -2,
        -11
      ],
      [
        -6,
        -1
      ],
      [
        -11,
        -2
      ],
      [
        0,
        17
      ],
      [
        -12,
        -3
      ],
      [
        -3,
        13
      ],
      [
        -11,
        -38
      ],
      [
        -10,
        21
      ],
      [
        -5,
        -13
      ],
      [
        -2,
        -31
      ],
      [
        -7,
        -3
      ],
      [
        -9,
        19
      ]
    ],
    [
      [
        23057,
        62540
      ],
      [
        -8,
        15
      ],
      [
        -12,
        5
      ],
      [
        -1,
        -14
      ],
      [
        1,
        -11
      ],
      [
        -4,
        -5
      ],
      [
        -4,
        15
      ],
      [
        -3,
        -11
      ],
      [
        -5,
        4
      ],
      [
        0,
        19
      ],
      [
        -10,
        -10
      ],
      [
        -1,
        1
      ],
      [
        0,
        12
      ],
      [
        -1,
        5
      ],
      [
        0,
        4
      ],
      [
        1,
        1
      ],
      [
        0,
        -1
      ],
      [
        11,
        1
      ],
      [
        -6,
        19
      ],
      [
        -2,
        -8
      ],
      [
        -4,
        39
      ],
      [
        -9,
        15
      ],
      [
        -13,
        44
      ],
      [
        0,
        15
      ],
      [
        -5,
        14
      ],
      [
        3,
        10
      ],
      [
        -7,
        10
      ],
      [
        1,
        10
      ],
      [
        -5,
        18
      ],
      [
        -2,
        15
      ],
      [
        -9,
        37
      ],
      [
        3,
        20
      ],
      [
        -4,
        8
      ],
      [
        5,
        10
      ],
      [
        -3,
        9
      ],
      [
        4,
        21
      ],
      [
        6,
        1
      ],
      [
        1,
        21
      ],
      [
        4,
        -6
      ],
      [
        4,
        30
      ],
      [
        4,
        10
      ],
      [
        -1,
        11
      ],
      [
        6,
        22
      ],
      [
        2,
        -7
      ],
      [
        7,
        16
      ],
      [
        3,
        24
      ]
    ],
    [
      [
        28590,
        62619
      ],
      [
        -2,
        1
      ],
      [
        -2,
        13
      ],
      [
        -8,
        11
      ],
      [
        -1,
        3
      ],
      [
        0,
        -1
      ],
      [
        -3,
        -3
      ],
      [
        2,
        -13
      ],
      [
        0,
        -2
      ],
      [
        6,
        -18
      ],
      [
        -2,
        -10
      ],
      [
        3,
        -9
      ],
      [
        6,
        -4
      ],
      [
        0,
        -8
      ]
    ],
    [
      [
        28589,
        62579
      ],
      [
        -5,
        -11
      ],
      [
        -7,
        10
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        -2,
        7
      ],
      [
        -6,
        24
      ],
      [
        -2,
        4
      ]
    ],
    [
      [
        28565,
        62615
      ],
      [
        -7,
        13
      ],
      [
        -4,
        8
      ],
      [
        -7,
        13
      ],
      [
        -4,
        7
      ],
      [
        -4,
        6
      ],
      [
        0,
        110
      ],
      [
        51,
        0
      ],
      [
        0,
        -153
      ]
    ],
    [
      [
        30343,
        68693
      ],
      [
        10,
        22
      ],
      [
        20,
        11
      ]
    ],
    [
      [
        30373,
        68726
      ],
      [
        8,
        -120
      ],
      [
        -6,
        -3
      ],
      [
        -3,
        -12
      ],
      [
        9,
        -44
      ],
      [
        1,
        -16
      ],
      [
        6,
        -25
      ],
      [
        0,
        -107
      ],
      [
        4,
        -17
      ],
      [
        19,
        -13
      ],
      [
        -5,
        -14
      ],
      [
        -4,
        -44
      ],
      [
        4,
        -3
      ],
      [
        2,
        -4
      ]
    ],
    [
      [
        30400,
        68131
      ],
      [
        -13,
        -58
      ],
      [
        -4,
        7
      ],
      [
        -7,
        -28
      ],
      [
        -22,
        44
      ],
      [
        -2,
        2
      ],
      [
        1,
        5
      ],
      [
        -8,
        26
      ],
      [
        -24,
        73
      ],
      [
        -13,
        -59
      ],
      [
        -9,
        19
      ],
      [
        -2,
        -15
      ],
      [
        -21,
        42
      ],
      [
        -1,
        7
      ]
    ],
    [
      [
        30275,
        68196
      ],
      [
        -1,
        33
      ],
      [
        9,
        40
      ],
      [
        14,
        57
      ],
      [
        3,
        12
      ],
      [
        16,
        66
      ],
      [
        3,
        -3
      ],
      [
        12,
        133
      ],
      [
        4,
        47
      ],
      [
        -4,
        61
      ],
      [
        2,
        30
      ],
      [
        10,
        21
      ]
    ],
    [
      [
        25494,
        62522
      ],
      [
        0,
        11
      ],
      [
        6,
        9
      ],
      [
        9,
        27
      ],
      [
        3,
        15
      ],
      [
        1,
        9
      ],
      [
        -2,
        17
      ],
      [
        -1,
        12
      ],
      [
        -3,
        5
      ],
      [
        -2,
        14
      ]
    ],
    [
      [
        25505,
        62641
      ],
      [
        70,
        -1
      ],
      [
        31,
        0
      ]
    ],
    [
      [
        25606,
        62640
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        25526,
        62231
      ],
      [
        2,
        18
      ],
      [
        2,
        37
      ],
      [
        -5,
        20
      ],
      [
        -13,
        20
      ],
      [
        -1,
        14
      ],
      [
        3,
        21
      ],
      [
        -1,
        17
      ],
      [
        0,
        27
      ],
      [
        -6,
        26
      ],
      [
        -4,
        4
      ],
      [
        -1,
        3
      ],
      [
        -1,
        5
      ],
      [
        0,
        8
      ],
      [
        -1,
        5
      ],
      [
        -1,
        1
      ],
      [
        -2,
        3
      ],
      [
        0,
        17
      ],
      [
        -3,
        11
      ],
      [
        -1,
        19
      ],
      [
        1,
        15
      ]
    ],
    [
      [
        25047,
        57095
      ],
      [
        0,
        102
      ]
    ],
    [
      [
        25047,
        57197
      ],
      [
        0,
        17
      ],
      [
        29,
        0
      ],
      [
        15,
        1
      ]
    ],
    [
      [
        25189,
        57213
      ],
      [
        0,
        -102
      ]
    ],
    [
      [
        25189,
        57111
      ],
      [
        0,
        -17
      ],
      [
        -15,
        0
      ],
      [
        0,
        -117
      ],
      [
        -10,
        0
      ],
      [
        0,
        -34
      ]
    ],
    [
      [
        25164,
        56943
      ],
      [
        -28,
        0
      ],
      [
        -1,
        17
      ],
      [
        -88,
        0
      ]
    ],
    [
      [
        25047,
        56960
      ],
      [
        0,
        135
      ]
    ],
    [
      [
        23468,
        67577
      ],
      [
        -22,
        0
      ],
      [
        -6,
        1
      ],
      [
        -30,
        0
      ],
      [
        -9,
        -1
      ],
      [
        -4,
        1
      ],
      [
        -21,
        0
      ],
      [
        -2,
        -1
      ],
      [
        -38,
        0
      ]
    ],
    [
      [
        18660,
        64046
      ],
      [
        8,
        4
      ],
      [
        7,
        -22
      ],
      [
        1,
        -14
      ],
      [
        6,
        10
      ],
      [
        7,
        -2
      ],
      [
        8,
        21
      ],
      [
        2,
        -16
      ],
      [
        7,
        -28
      ],
      [
        7,
        -14
      ],
      [
        10,
        12
      ],
      [
        4,
        12
      ],
      [
        3,
        10
      ],
      [
        2,
        10
      ],
      [
        1,
        1
      ],
      [
        7,
        22
      ],
      [
        13,
        4
      ],
      [
        7,
        15
      ],
      [
        3,
        6
      ],
      [
        4,
        24
      ],
      [
        7,
        18
      ],
      [
        7,
        -2
      ],
      [
        5,
        -3
      ],
      [
        6,
        12
      ],
      [
        4,
        -5
      ],
      [
        9,
        23
      ],
      [
        4,
        20
      ],
      [
        8,
        -4
      ],
      [
        4,
        14
      ]
    ],
    [
      [
        18821,
        64174
      ],
      [
        7,
        -34
      ],
      [
        -3,
        -55
      ],
      [
        1,
        -16
      ],
      [
        -13,
        -43
      ],
      [
        3,
        -21
      ],
      [
        0,
        -1
      ],
      [
        3,
        5
      ],
      [
        7,
        -51
      ],
      [
        4,
        -4
      ],
      [
        2,
        -25
      ],
      [
        20,
        -5
      ],
      [
        12,
        -47
      ],
      [
        -5,
        -24
      ],
      [
        4,
        -13
      ],
      [
        19,
        8
      ],
      [
        4,
        -9
      ],
      [
        13,
        -3
      ],
      [
        14,
        -51
      ],
      [
        -3,
        -24
      ],
      [
        4,
        -28
      ],
      [
        9,
        -36
      ],
      [
        -1,
        -23
      ],
      [
        1,
        -3
      ],
      [
        2,
        -23
      ],
      [
        -6,
        -45
      ],
      [
        2,
        -20
      ],
      [
        -4,
        -16
      ],
      [
        1,
        -9
      ],
      [
        5,
        -14
      ],
      [
        6,
        14
      ],
      [
        5,
        -32
      ],
      [
        5,
        -19
      ],
      [
        1,
        -15
      ],
      [
        6,
        -5
      ],
      [
        4,
        -19
      ],
      [
        3,
        -2
      ],
      [
        -3,
        -25
      ],
      [
        3,
        -4
      ],
      [
        10,
        0
      ],
      [
        0,
        -51
      ],
      [
        53,
        0
      ]
    ],
    [
      [
        19016,
        63386
      ],
      [
        10,
        0
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        19026,
        63285
      ],
      [
        -62,
        1
      ],
      [
        0,
        -2
      ],
      [
        -47,
        1
      ]
    ],
    [
      [
        18917,
        63285
      ],
      [
        -110,
        0
      ]
    ],
    [
      [
        18807,
        63285
      ],
      [
        -34,
        -3
      ],
      [
        5,
        28
      ],
      [
        3,
        34
      ],
      [
        -6,
        15
      ],
      [
        0,
        14
      ],
      [
        -6,
        14
      ],
      [
        -4,
        35
      ],
      [
        -5,
        10
      ],
      [
        -4,
        10
      ],
      [
        -1,
        -11
      ],
      [
        -1,
        -16
      ],
      [
        -7,
        -12
      ],
      [
        -2,
        -10
      ],
      [
        -4,
        2
      ],
      [
        -3,
        -11
      ],
      [
        -5,
        -4
      ],
      [
        -8,
        -46
      ],
      [
        -5,
        -21
      ],
      [
        -4,
        -35
      ],
      [
        -6,
        5
      ],
      [
        0,
        -8
      ],
      [
        -10,
        -25
      ],
      [
        -5,
        -7
      ],
      [
        -12,
        6
      ],
      [
        3,
        21
      ],
      [
        3,
        34
      ],
      [
        -2,
        12
      ],
      [
        -2,
        30
      ],
      [
        6,
        17
      ],
      [
        2,
        16
      ],
      [
        -8,
        23
      ],
      [
        -1,
        14
      ],
      [
        -5,
        4
      ],
      [
        0,
        35
      ],
      [
        -2,
        17
      ],
      [
        -6,
        4
      ],
      [
        -8,
        34
      ],
      [
        -5,
        6
      ]
    ],
    [
      [
        18658,
        63516
      ],
      [
        2,
        33
      ],
      [
        -3,
        23
      ],
      [
        7,
        45
      ],
      [
        2,
        11
      ],
      [
        -7,
        28
      ],
      [
        2,
        18
      ],
      [
        -2,
        8
      ],
      [
        8,
        22
      ],
      [
        -2,
        11
      ],
      [
        1,
        15
      ],
      [
        -3,
        5
      ],
      [
        3,
        14
      ],
      [
        -5,
        9
      ],
      [
        -3,
        15
      ],
      [
        0,
        20
      ],
      [
        -4,
        17
      ],
      [
        2,
        27
      ],
      [
        -4,
        23
      ],
      [
        1,
        22
      ],
      [
        6,
        12
      ],
      [
        -5,
        28
      ],
      [
        1,
        14
      ],
      [
        -3,
        12
      ],
      [
        1,
        45
      ],
      [
        -4,
        13
      ],
      [
        -1,
        26
      ],
      [
        7,
        16
      ],
      [
        5,
        -2
      ]
    ],
    [
      [
        27360,
        60964
      ],
      [
        38,
        58
      ]
    ],
    [
      [
        27438,
        60862
      ],
      [
        1,
        -20
      ],
      [
        -10,
        -63
      ],
      [
        -1,
        -6
      ],
      [
        -13,
        -79
      ],
      [
        -14,
        -76
      ],
      [
        -17,
        -109
      ]
    ],
    [
      [
        27384,
        60509
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        27318,
        60696
      ],
      [
        9,
        26
      ],
      [
        -1,
        36
      ],
      [
        11,
        19
      ],
      [
        1,
        13
      ],
      [
        10,
        19
      ],
      [
        4,
        15
      ],
      [
        -1,
        18
      ],
      [
        8,
        1
      ],
      [
        9,
        -14
      ],
      [
        5,
        -16
      ],
      [
        -1,
        -15
      ],
      [
        6,
        7
      ],
      [
        0,
        11
      ],
      [
        -3,
        11
      ],
      [
        -2,
        32
      ],
      [
        -7,
        15
      ],
      [
        1,
        12
      ],
      [
        5,
        5
      ],
      [
        2,
        12
      ],
      [
        -2,
        19
      ],
      [
        -6,
        12
      ],
      [
        -1,
        19
      ],
      [
        -5,
        11
      ]
    ],
    [
      [
        18917,
        63285
      ],
      [
        0,
        -127
      ]
    ],
    [
      [
        18917,
        63158
      ],
      [
        0,
        -276
      ],
      [
        -15,
        0
      ],
      [
        0,
        -167
      ],
      [
        1,
        -34
      ],
      [
        0,
        -305
      ]
    ],
    [
      [
        18903,
        62376
      ],
      [
        -140,
        1
      ],
      [
        -14,
        0
      ],
      [
        0,
        15
      ],
      [
        -45,
        0
      ]
    ],
    [
      [
        18704,
        62392
      ],
      [
        0,
        101
      ],
      [
        -1,
        212
      ]
    ],
    [
      [
        18703,
        62705
      ],
      [
        0,
        26
      ],
      [
        16,
        0
      ],
      [
        0,
        34
      ],
      [
        10,
        1
      ],
      [
        0,
        17
      ],
      [
        49,
        1
      ],
      [
        0,
        90
      ],
      [
        10,
        0
      ],
      [
        0,
        103
      ],
      [
        -1,
        103
      ],
      [
        -1,
        67
      ],
      [
        8,
        1
      ],
      [
        0,
        17
      ],
      [
        13,
        18
      ],
      [
        0,
        17
      ],
      [
        16,
        0
      ],
      [
        0,
        51
      ],
      [
        -10,
        0
      ],
      [
        0,
        17
      ],
      [
        -6,
        0
      ],
      [
        0,
        17
      ]
    ],
    [
      [
        25147,
        67732
      ],
      [
        68,
        0
      ],
      [
        67,
        -3
      ],
      [
        1,
        -101
      ]
    ],
    [
      [
        25283,
        67628
      ],
      [
        -1,
        -202
      ],
      [
        -4,
        0
      ],
      [
        0,
        -52
      ],
      [
        -1,
        -51
      ],
      [
        1,
        -102
      ]
    ],
    [
      [
        25245,
        67223
      ],
      [
        -33,
        1
      ],
      [
        -11,
        0
      ],
      [
        -18,
        1
      ],
      [
        -70,
        0
      ]
    ],
    [
      [
        25113,
        67225
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        25113,
        67326
      ],
      [
        0,
        97
      ],
      [
        1,
        4
      ],
      [
        0,
        305
      ]
    ],
    [
      [
        22824,
        69669
      ],
      [
        61,
        0
      ],
      [
        4,
        34
      ],
      [
        145,
        0
      ]
    ],
    [
      [
        23034,
        69703
      ],
      [
        1,
        -2
      ],
      [
        0,
        -9
      ],
      [
        2,
        -4
      ],
      [
        1,
        -7
      ],
      [
        0,
        -5
      ],
      [
        1,
        -2
      ],
      [
        0,
        -38
      ]
    ],
    [
      [
        23039,
        69297
      ],
      [
        -119,
        -1
      ]
    ],
    [
      [
        22824,
        69500
      ],
      [
        0,
        169
      ]
    ],
    [
      [
        28143,
        63695
      ],
      [
        15,
        -37
      ],
      [
        43,
        -37
      ],
      [
        0,
        3
      ],
      [
        17,
        -50
      ]
    ],
    [
      [
        28218,
        63574
      ],
      [
        -5,
        -15
      ],
      [
        -10,
        -52
      ],
      [
        -7,
        -74
      ],
      [
        -4,
        -15
      ],
      [
        0,
        -15
      ],
      [
        -5,
        -50
      ],
      [
        -7,
        -52
      ],
      [
        -8,
        -31
      ],
      [
        -10,
        -49
      ],
      [
        -1,
        -11
      ],
      [
        -8,
        -30
      ]
    ],
    [
      [
        24066,
        69162
      ],
      [
        30,
        1
      ],
      [
        79,
        0
      ],
      [
        35,
        -5
      ],
      [
        4,
        -1
      ],
      [
        28,
        0
      ]
    ],
    [
      [
        24242,
        69157
      ],
      [
        0,
        -201
      ]
    ],
    [
      [
        24242,
        68956
      ],
      [
        0,
        -169
      ],
      [
        -50,
        2
      ]
    ],
    [
      [
        24192,
        68789
      ],
      [
        -1,
        1
      ],
      [
        0,
        3
      ],
      [
        -3,
        7
      ],
      [
        -2,
        4
      ],
      [
        -3,
        3
      ],
      [
        -4,
        3
      ],
      [
        -2,
        0
      ],
      [
        -6,
        -2
      ],
      [
        -2,
        1
      ],
      [
        -5,
        2
      ],
      [
        -1,
        2
      ],
      [
        -2,
        3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -3
      ],
      [
        -4,
        -1
      ],
      [
        -4,
        4
      ],
      [
        -3,
        3
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -4,
        5
      ],
      [
        -1,
        1
      ],
      [
        -2,
        4
      ],
      [
        -2,
        -1
      ],
      [
        -4,
        -8
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        3
      ],
      [
        0,
        2
      ],
      [
        1,
        3
      ],
      [
        0,
        6
      ],
      [
        -3,
        16
      ],
      [
        -2,
        8
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        2
      ],
      [
        -1,
        5
      ],
      [
        -3,
        7
      ],
      [
        -1,
        1
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        3
      ],
      [
        -1,
        4
      ],
      [
        0,
        6
      ],
      [
        1,
        6
      ],
      [
        0,
        12
      ],
      [
        -3,
        11
      ],
      [
        -7,
        11
      ],
      [
        -1,
        3
      ],
      [
        -1,
        3
      ],
      [
        -6,
        22
      ],
      [
        -3,
        8
      ],
      [
        -1,
        5
      ],
      [
        -4,
        9
      ],
      [
        -5,
        15
      ]
    ],
    [
      [
        24076,
        68990
      ],
      [
        -2,
        4
      ],
      [
        -3,
        5
      ],
      [
        -2,
        2
      ],
      [
        -3,
        7
      ],
      [
        -6,
        9
      ],
      [
        -4,
        9
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        24056,
        69027
      ],
      [
        0,
        3
      ],
      [
        -1,
        2
      ],
      [
        0,
        21
      ],
      [
        2,
        11
      ],
      [
        1,
        5
      ],
      [
        2,
        7
      ],
      [
        1,
        5
      ],
      [
        1,
        7
      ],
      [
        0,
        17
      ],
      [
        3,
        10
      ],
      [
        0,
        12
      ],
      [
        1,
        4
      ],
      [
        1,
        2
      ],
      [
        0,
        5
      ],
      [
        -1,
        15
      ],
      [
        0,
        9
      ]
    ],
    [
      [
        19087,
        72136
      ],
      [
        118,
        0
      ]
    ],
    [
      [
        19205,
        72136
      ],
      [
        0,
        -67
      ],
      [
        24,
        0
      ],
      [
        0,
        -101
      ],
      [
        36,
        0
      ],
      [
        0,
        -51
      ],
      [
        35,
        1
      ],
      [
        1,
        -51
      ],
      [
        32,
        0
      ],
      [
        0,
        -337
      ],
      [
        -6,
        0
      ],
      [
        0,
        -17
      ],
      [
        -4,
        0
      ],
      [
        -2,
        -17
      ],
      [
        0,
        -42
      ],
      [
        -10,
        0
      ],
      [
        0,
        -25
      ],
      [
        1,
        -8
      ],
      [
        9,
        0
      ],
      [
        3,
        -9
      ],
      [
        0,
        -17
      ],
      [
        9,
        0
      ],
      [
        0,
        -42
      ],
      [
        3,
        0
      ],
      [
        0,
        -58
      ]
    ],
    [
      [
        19083,
        71446
      ],
      [
        0,
        16
      ],
      [
        5,
        0
      ],
      [
        -2,
        101
      ],
      [
        -1,
        101
      ],
      [
        0,
        99
      ],
      [
        -35,
        0
      ],
      [
        1,
        102
      ],
      [
        0,
        59
      ],
      [
        -3,
        0
      ],
      [
        0,
        17
      ],
      [
        -3,
        0
      ],
      [
        0,
        68
      ],
      [
        5,
        1
      ],
      [
        1,
        -13
      ],
      [
        0,
        72
      ],
      [
        36,
        0
      ],
      [
        0,
        67
      ]
    ],
    [
      [
        27371,
        57771
      ],
      [
        6,
        -26
      ],
      [
        12,
        -61
      ]
    ],
    [
      [
        27389,
        57684
      ],
      [
        5,
        -25
      ],
      [
        4,
        -19
      ],
      [
        0,
        -1
      ],
      [
        7,
        -31
      ],
      [
        -1,
        -39
      ],
      [
        -2,
        -75
      ],
      [
        -1,
        -17
      ],
      [
        0,
        -4
      ],
      [
        5,
        -1
      ],
      [
        26,
        0
      ],
      [
        4,
        -1
      ],
      [
        14,
        0
      ],
      [
        17,
        -1
      ]
    ],
    [
      [
        27509,
        57234
      ],
      [
        -39,
        -64
      ],
      [
        6,
        -65
      ],
      [
        -6,
        -13
      ],
      [
        -14,
        3
      ],
      [
        -4,
        -8
      ],
      [
        0,
        13
      ],
      [
        -5,
        -22
      ],
      [
        0,
        12
      ],
      [
        -7,
        -15
      ],
      [
        -5,
        17
      ],
      [
        -4,
        26
      ],
      [
        -3,
        0
      ],
      [
        -4,
        -32
      ],
      [
        -7,
        -9
      ],
      [
        -2,
        38
      ],
      [
        1,
        32
      ],
      [
        -38,
        -96
      ]
    ],
    [
      [
        27378,
        57051
      ],
      [
        -5,
        34
      ],
      [
        4,
        15
      ],
      [
        2,
        51
      ]
    ],
    [
      [
        28280,
        61164
      ],
      [
        4,
        14
      ],
      [
        21,
        82
      ],
      [
        10,
        37
      ],
      [
        21,
        84
      ],
      [
        11,
        43
      ],
      [
        9,
        38
      ]
    ],
    [
      [
        28356,
        61462
      ],
      [
        8,
        7
      ],
      [
        4,
        -9
      ]
    ],
    [
      [
        28427,
        61349
      ],
      [
        2,
        -28
      ],
      [
        -3,
        -6
      ],
      [
        -7,
        0
      ],
      [
        -1,
        -31
      ],
      [
        -6,
        -17
      ],
      [
        3,
        -18
      ],
      [
        8,
        -22
      ],
      [
        2,
        -13
      ],
      [
        -3,
        -19
      ],
      [
        8,
        -7
      ],
      [
        4,
        2
      ],
      [
        5,
        -22
      ],
      [
        0,
        -35
      ]
    ],
    [
      [
        28439,
        61133
      ],
      [
        -10,
        8
      ],
      [
        -12,
        1
      ],
      [
        -5,
        -10
      ],
      [
        -4,
        -16
      ],
      [
        -1,
        -45
      ],
      [
        1,
        -23
      ]
    ],
    [
      [
        28363,
        60929
      ],
      [
        -5,
        10
      ],
      [
        -3,
        -24
      ],
      [
        -7,
        0
      ],
      [
        -2,
        10
      ],
      [
        3,
        20
      ],
      [
        -3,
        0
      ],
      [
        -4,
        15
      ],
      [
        2,
        8
      ],
      [
        -4,
        8
      ],
      [
        0,
        31
      ],
      [
        1,
        10
      ],
      [
        -4,
        24
      ],
      [
        -2,
        11
      ],
      [
        -11,
        -13
      ],
      [
        -3,
        16
      ],
      [
        -6,
        8
      ],
      [
        -3,
        19
      ],
      [
        -5,
        -5
      ],
      [
        -1,
        12
      ],
      [
        -4,
        11
      ],
      [
        -4,
        26
      ],
      [
        -1,
        -9
      ],
      [
        -8,
        4
      ],
      [
        -9,
        30
      ],
      [
        0,
        13
      ]
    ],
    [
      [
        20688,
        66540
      ],
      [
        66,
        0
      ]
    ],
    [
      [
        20754,
        66540
      ],
      [
        0,
        -1113
      ]
    ],
    [
      [
        20754,
        65427
      ],
      [
        -174,
        4
      ]
    ],
    [
      [
        23996,
        69196
      ],
      [
        4,
        0
      ],
      [
        6,
        4
      ],
      [
        -1,
        80
      ],
      [
        0,
        110
      ],
      [
        1,
        45
      ],
      [
        -1,
        23
      ],
      [
        0,
        9
      ],
      [
        -10,
        0
      ]
    ],
    [
      [
        23995,
        69467
      ],
      [
        1,
        70
      ],
      [
        0,
        132
      ]
    ],
    [
      [
        23996,
        69669
      ],
      [
        57,
        -1
      ],
      [
        19,
        -1
      ]
    ],
    [
      [
        24072,
        69667
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        -2
      ],
      [
        0,
        -14
      ],
      [
        1,
        -5
      ],
      [
        1,
        -6
      ],
      [
        0,
        -9
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -5
      ],
      [
        1,
        -13
      ],
      [
        0,
        -14
      ],
      [
        1,
        -4
      ],
      [
        0,
        -11
      ],
      [
        -1,
        -4
      ]
    ],
    [
      [
        24069,
        69567
      ],
      [
        -2,
        -3
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -11
      ],
      [
        0,
        -11
      ],
      [
        1,
        -3
      ],
      [
        3,
        -11
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -15
      ],
      [
        2,
        -16
      ],
      [
        1,
        -18
      ],
      [
        1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -5
      ],
      [
        -4,
        -9
      ],
      [
        -2,
        -7
      ],
      [
        -5,
        -11
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -11
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -12
      ],
      [
        2,
        -8
      ],
      [
        1,
        -4
      ],
      [
        1,
        -4
      ],
      [
        3,
        -5
      ],
      [
        2,
        -7
      ],
      [
        2,
        -6
      ],
      [
        0,
        -5
      ],
      [
        1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -13
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -9
      ],
      [
        1,
        -7
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -13
      ],
      [
        1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        2,
        -4
      ],
      [
        2,
        -11
      ],
      [
        1,
        -16
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -22
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -4,
        -7
      ],
      [
        0,
        -13
      ],
      [
        1,
        -8
      ],
      [
        2,
        -9
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -6
      ]
    ],
    [
      [
        24056,
        69027
      ],
      [
        -3,
        2
      ],
      [
        -11,
        0
      ],
      [
        -8,
        31
      ],
      [
        -13,
        9
      ],
      [
        -13,
        -11
      ],
      [
        -8,
        -1
      ],
      [
        -3,
        5
      ],
      [
        -2,
        13
      ],
      [
        5,
        32
      ],
      [
        -2,
        37
      ],
      [
        0,
        20
      ],
      [
        -1,
        25
      ],
      [
        -1,
        7
      ]
    ],
    [
      [
        25029,
        60021
      ],
      [
        5,
        -20
      ],
      [
        4,
        -4
      ],
      [
        1,
        2
      ],
      [
        2,
        4
      ],
      [
        0,
        3
      ],
      [
        1,
        4
      ],
      [
        2,
        18
      ],
      [
        -1,
        10
      ],
      [
        -2,
        6
      ],
      [
        -3,
        9
      ],
      [
        -4,
        4
      ],
      [
        -2,
        6
      ],
      [
        -2,
        6
      ],
      [
        -1,
        4
      ],
      [
        0,
        5
      ],
      [
        1,
        12
      ],
      [
        0,
        2
      ],
      [
        4,
        -3
      ],
      [
        3,
        -1
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        4,
        0
      ],
      [
        1,
        -1
      ],
      [
        2,
        9
      ],
      [
        2,
        -16
      ],
      [
        2,
        -18
      ],
      [
        1,
        -6
      ],
      [
        3,
        -7
      ],
      [
        5,
        -13
      ],
      [
        2,
        -5
      ],
      [
        0,
        -5
      ],
      [
        1,
        -14
      ],
      [
        0,
        -11
      ],
      [
        1,
        -12
      ],
      [
        2,
        -7
      ],
      [
        2,
        -3
      ],
      [
        2,
        -1
      ],
      [
        3,
        3
      ],
      [
        3,
        5
      ],
      [
        1,
        2
      ],
      [
        1,
        0
      ],
      [
        3,
        4
      ]
    ],
    [
      [
        25079,
        59990
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        2,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        -5
      ],
      [
        2,
        -8
      ],
      [
        1,
        -6
      ],
      [
        0,
        -24
      ]
    ],
    [
      [
        25088,
        59945
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -23
      ],
      [
        -2,
        -38
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -12
      ],
      [
        -1,
        -18
      ],
      [
        -2,
        -11
      ],
      [
        -3,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -33
      ],
      [
        1,
        -4
      ],
      [
        1,
        -7
      ],
      [
        1,
        -3
      ],
      [
        2,
        -5
      ],
      [
        1,
        -2
      ],
      [
        3,
        -1
      ],
      [
        4,
        0
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        25081,
        59760
      ],
      [
        1,
        -3
      ],
      [
        1,
        -8
      ],
      [
        0,
        -9
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -6
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        -2,
        4
      ],
      [
        -3,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        5
      ],
      [
        0,
        -1
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -9
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -21
      ],
      [
        1,
        -5
      ],
      [
        3,
        -12
      ],
      [
        3,
        -9
      ],
      [
        1,
        -6
      ],
      [
        1,
        -4
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        1,
        0
      ],
      [
        2,
        -7
      ],
      [
        -1,
        -7
      ],
      [
        -3,
        -11
      ]
    ],
    [
      [
        25067,
        59604
      ],
      [
        -2,
        -7
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -9
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -9
      ],
      [
        -1,
        -19
      ],
      [
        -3,
        -25
      ],
      [
        -1,
        -5
      ],
      [
        -3,
        -8
      ],
      [
        -2,
        -3
      ],
      [
        -6,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -2,
        5
      ],
      [
        -1,
        3
      ],
      [
        -2,
        7
      ],
      [
        -4,
        19
      ],
      [
        -2,
        12
      ],
      [
        -4,
        18
      ],
      [
        -1,
        6
      ],
      [
        -2,
        8
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        25024,
        59582
      ],
      [
        0,
        15
      ],
      [
        -5,
        8
      ],
      [
        0,
        18
      ],
      [
        -5,
        8
      ],
      [
        -3,
        34
      ],
      [
        -4,
        0
      ],
      [
        -3,
        31
      ],
      [
        -8,
        19
      ],
      [
        -2,
        25
      ],
      [
        -3,
        0
      ],
      [
        0,
        25
      ],
      [
        -4,
        0
      ],
      [
        -6,
        51
      ],
      [
        -5,
        0
      ],
      [
        0,
        17
      ],
      [
        -5,
        0
      ],
      [
        0,
        26
      ]
    ],
    [
      [
        24971,
        59859
      ],
      [
        0,
        8
      ],
      [
        5,
        0
      ],
      [
        0,
        34
      ],
      [
        10,
        0
      ],
      [
        0,
        35
      ],
      [
        10,
        -1
      ],
      [
        0,
        17
      ],
      [
        5,
        0
      ],
      [
        0,
        17
      ],
      [
        10,
        1
      ],
      [
        0,
        34
      ],
      [
        8,
        9
      ],
      [
        0,
        8
      ],
      [
        10,
        0
      ]
    ],
    [
      [
        28884,
        64451
      ],
      [
        9,
        4
      ],
      [
        7,
        9
      ],
      [
        11,
        8
      ],
      [
        16,
        27
      ],
      [
        7,
        7
      ],
      [
        3,
        5
      ],
      [
        11,
        33
      ],
      [
        1,
        17
      ],
      [
        6,
        22
      ],
      [
        25,
        36
      ],
      [
        3,
        11
      ]
    ],
    [
      [
        28983,
        64630
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -2
      ],
      [
        0,
        -11
      ],
      [
        2,
        -6
      ],
      [
        2,
        -10
      ],
      [
        0,
        -3
      ],
      [
        2,
        -12
      ],
      [
        0,
        -3
      ],
      [
        5,
        -12
      ],
      [
        1,
        -4
      ],
      [
        0,
        -19
      ],
      [
        1,
        -2
      ],
      [
        2,
        -7
      ],
      [
        1,
        -4
      ],
      [
        1,
        -6
      ],
      [
        1,
        -4
      ],
      [
        1,
        -4
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -1
      ],
      [
        -2,
        0
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        -4,
        -1
      ],
      [
        -2,
        -2
      ],
      [
        0,
        -9
      ],
      [
        1,
        -3
      ],
      [
        2,
        -8
      ],
      [
        1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -7
      ],
      [
        -2,
        -4
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -9
      ],
      [
        -2,
        -10
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -9
      ],
      [
        0,
        -3
      ],
      [
        -2,
        0
      ],
      [
        -3,
        2
      ],
      [
        -3,
        4
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -4
      ],
      [
        0,
        -6
      ],
      [
        1,
        -2
      ],
      [
        2,
        -9
      ],
      [
        1,
        -4
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -10
      ],
      [
        -2,
        -16
      ],
      [
        1,
        -7
      ],
      [
        1,
        -5
      ],
      [
        2,
        -3
      ],
      [
        0,
        1
      ],
      [
        2,
        0
      ],
      [
        2,
        -2
      ],
      [
        0,
        -6
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -2
      ],
      [
        2,
        -6
      ],
      [
        1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        1,
        -15
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -2
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        1,
        -4
      ],
      [
        0,
        -3
      ]
    ],
    [
      [
        28923,
        64128
      ],
      [
        -19,
        51
      ],
      [
        3,
        18
      ],
      [
        0,
        5
      ],
      [
        4,
        17
      ],
      [
        -3,
        21
      ],
      [
        -12,
        41
      ],
      [
        0,
        6
      ],
      [
        -4,
        -6
      ],
      [
        -6,
        -9
      ],
      [
        -4,
        -6
      ],
      [
        -4,
        26
      ],
      [
        -1,
        4
      ],
      [
        -5,
        24
      ],
      [
        -4,
        40
      ],
      [
        -7,
        -18
      ],
      [
        -7,
        16
      ],
      [
        -3,
        0
      ],
      [
        -3,
        18
      ],
      [
        -2,
        43
      ]
    ],
    [
      [
        23878,
        54010
      ],
      [
        0,
        -152
      ],
      [
        29,
        0
      ],
      [
        0,
        -206
      ],
      [
        28,
        1
      ],
      [
        0,
        -203
      ]
    ],
    [
      [
        23935,
        53450
      ],
      [
        -43,
        0
      ],
      [
        -14,
        -102
      ],
      [
        -26,
        0
      ],
      [
        0,
        -28
      ],
      [
        -5,
        -17
      ],
      [
        3,
        -13
      ],
      [
        -2,
        -13
      ],
      [
        2,
        -15
      ],
      [
        -3,
        -20
      ]
    ],
    [
      [
        23847,
        53242
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -5
      ],
      [
        -3,
        -12
      ],
      [
        -3,
        -2
      ],
      [
        -3,
        10
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        23834,
        53231
      ],
      [
        -1,
        8
      ],
      [
        -1,
        26
      ],
      [
        1,
        12
      ],
      [
        0,
        10
      ],
      [
        -1,
        4
      ],
      [
        -1,
        2
      ],
      [
        -1,
        5
      ],
      [
        -1,
        13
      ],
      [
        1,
        8
      ],
      [
        0,
        9
      ],
      [
        -2,
        14
      ],
      [
        -6,
        -2
      ],
      [
        -4,
        14
      ],
      [
        -3,
        19
      ],
      [
        -2,
        3
      ],
      [
        -2,
        1
      ],
      [
        -1,
        4
      ],
      [
        0,
        6
      ],
      [
        2,
        24
      ],
      [
        3,
        26
      ],
      [
        1,
        3
      ],
      [
        0,
        10
      ],
      [
        -1,
        3
      ],
      [
        0,
        15
      ],
      [
        -1,
        9
      ],
      [
        0,
        7
      ],
      [
        -1,
        5
      ],
      [
        -6,
        14
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        0,
        10
      ],
      [
        2,
        11
      ],
      [
        -1,
        11
      ],
      [
        -2,
        6
      ],
      [
        -12,
        30
      ],
      [
        0,
        12
      ],
      [
        1,
        2
      ],
      [
        0,
        1
      ],
      [
        1,
        2
      ],
      [
        2,
        1
      ],
      [
        2,
        9
      ],
      [
        0,
        5
      ],
      [
        1,
        9
      ],
      [
        0,
        9
      ],
      [
        -2,
        1
      ],
      [
        -2,
        3
      ],
      [
        0,
        8
      ],
      [
        -1,
        3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -2
      ],
      [
        -5,
        2
      ],
      [
        -2,
        2
      ],
      [
        -3,
        8
      ],
      [
        -6,
        24
      ],
      [
        0,
        4
      ],
      [
        -1,
        11
      ],
      [
        -3,
        21
      ]
    ],
    [
      [
        23769,
        53708
      ],
      [
        -2,
        15
      ],
      [
        1,
        9
      ],
      [
        3,
        12
      ],
      [
        1,
        -3
      ],
      [
        1,
        0
      ],
      [
        1,
        10
      ],
      [
        -1,
        29
      ],
      [
        -2,
        16
      ],
      [
        0,
        6
      ],
      [
        1,
        9
      ],
      [
        1,
        -3
      ],
      [
        4,
        16
      ],
      [
        1,
        9
      ],
      [
        0,
        5
      ],
      [
        -1,
        4
      ],
      [
        -1,
        4
      ],
      [
        -1,
        1
      ],
      [
        -1,
        3
      ],
      [
        0,
        13
      ],
      [
        -1,
        11
      ],
      [
        -2,
        7
      ],
      [
        -1,
        13
      ],
      [
        0,
        10
      ],
      [
        1,
        6
      ],
      [
        1,
        17
      ],
      [
        0,
        1
      ],
      [
        -1,
        3
      ],
      [
        -1,
        3
      ],
      [
        -1,
        4
      ],
      [
        -1,
        6
      ],
      [
        0,
        7
      ],
      [
        -1,
        5
      ],
      [
        -4,
        8
      ],
      [
        -4,
        13
      ],
      [
        -2,
        6
      ],
      [
        0,
        22
      ],
      [
        -1,
        4
      ]
    ],
    [
      [
        26023,
        60208
      ],
      [
        16,
        15
      ]
    ],
    [
      [
        26039,
        60223
      ],
      [
        7,
        -46
      ],
      [
        8,
        -21
      ],
      [
        11,
        -10
      ],
      [
        18,
        -8
      ]
    ],
    [
      [
        26083,
        60138
      ],
      [
        1,
        -49
      ],
      [
        6,
        -70
      ],
      [
        17,
        -62
      ],
      [
        -3,
        -19
      ]
    ],
    [
      [
        26024,
        59826
      ],
      [
        -3,
        191
      ],
      [
        -1,
        25
      ],
      [
        -1,
        48
      ],
      [
        0,
        48
      ],
      [
        -4,
        0
      ],
      [
        -1,
        33
      ],
      [
        4,
        14
      ],
      [
        5,
        23
      ]
    ],
    [
      [
        19140,
        55581
      ],
      [
        0,
        -786
      ],
      [
        -1,
        -7
      ]
    ],
    [
      [
        18651,
        54780
      ],
      [
        0,
        936
      ],
      [
        3,
        -14
      ],
      [
        -1,
        -24
      ],
      [
        1,
        -15
      ],
      [
        12,
        -13
      ],
      [
        10,
        -31
      ],
      [
        5,
        3
      ],
      [
        3,
        -30
      ],
      [
        53,
        1
      ],
      [
        2,
        -2
      ],
      [
        37,
        2
      ],
      [
        19,
        -1
      ],
      [
        15,
        1
      ],
      [
        14,
        0
      ],
      [
        0,
        202
      ],
      [
        1,
        76
      ],
      [
        0,
        25
      ],
      [
        38,
        1
      ],
      [
        112,
        0
      ]
    ],
    [
      [
        19265,
        60008
      ],
      [
        0,
        -1554
      ],
      [
        48,
        -1
      ],
      [
        0,
        -168
      ],
      [
        -5,
        0
      ],
      [
        1,
        -404
      ],
      [
        -1,
        -238
      ],
      [
        0,
        -167
      ],
      [
        -2,
        0
      ],
      [
        1,
        -204
      ],
      [
        -5,
        -102
      ],
      [
        5,
        -83
      ],
      [
        0,
        -422
      ],
      [
        -3,
        0
      ],
      [
        0,
        -406
      ],
      [
        -9,
        1
      ],
      [
        0,
        -245
      ]
    ],
    [
      [
        19295,
        56015
      ],
      [
        -7,
        8
      ],
      [
        -2,
        -8
      ],
      [
        -10,
        14
      ],
      [
        -10,
        3
      ],
      [
        -1,
        -6
      ]
    ],
    [
      [
        17950,
        55027
      ],
      [
        1,
        3
      ],
      [
        0,
        10
      ],
      [
        3,
        13
      ],
      [
        1,
        5
      ],
      [
        1,
        -1
      ],
      [
        3,
        -8
      ],
      [
        1,
        0
      ],
      [
        2,
        -2
      ],
      [
        2,
        -2
      ],
      [
        3,
        -1
      ],
      [
        7,
        -3
      ],
      [
        4,
        -3
      ],
      [
        1,
        0
      ],
      [
        0,
        7
      ],
      [
        21,
        26
      ],
      [
        4,
        0
      ],
      [
        -1,
        12
      ],
      [
        -1,
        8
      ],
      [
        0,
        20
      ],
      [
        1,
        3
      ],
      [
        0,
        3
      ],
      [
        2,
        6
      ],
      [
        0,
        3
      ],
      [
        1,
        2
      ],
      [
        1,
        7
      ],
      [
        1,
        5
      ],
      [
        4,
        7
      ],
      [
        1,
        1
      ],
      [
        5,
        18
      ],
      [
        2,
        8
      ],
      [
        1,
        34
      ],
      [
        0,
        45
      ],
      [
        -3,
        9
      ],
      [
        0,
        3
      ],
      [
        -1,
        6
      ],
      [
        -1,
        8
      ],
      [
        1,
        2
      ],
      [
        0,
        4
      ],
      [
        1,
        5
      ],
      [
        1,
        5
      ],
      [
        1,
        4
      ],
      [
        0,
        23
      ],
      [
        -1,
        2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        2
      ],
      [
        0,
        3
      ],
      [
        -1,
        7
      ],
      [
        0,
        13
      ],
      [
        -1,
        15
      ],
      [
        -1,
        8
      ],
      [
        -1,
        7
      ],
      [
        -1,
        7
      ],
      [
        -1,
        4
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        18336,
        55794
      ],
      [
        0,
        -1016
      ]
    ],
    [
      [
        18336,
        54235
      ],
      [
        -44,
        59
      ],
      [
        -72,
        93
      ],
      [
        -9,
        12
      ],
      [
        -130,
        168
      ],
      [
        -70,
        89
      ],
      [
        -87,
        109
      ],
      [
        0,
        34
      ],
      [
        5,
        32
      ],
      [
        -5,
        17
      ],
      [
        4,
        33
      ],
      [
        -3,
        27
      ],
      [
        3,
        9
      ],
      [
        5,
        7
      ],
      [
        4,
        22
      ],
      [
        10,
        58
      ],
      [
        0,
        6
      ],
      [
        2,
        10
      ],
      [
        1,
        7
      ]
    ],
    [
      [
        23962,
        70173
      ],
      [
        83,
        0
      ]
    ],
    [
      [
        24045,
        70173
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -1
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -14
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -9
      ],
      [
        -1,
        -16
      ],
      [
        0,
        -11
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -10
      ],
      [
        0,
        -2
      ]
    ],
    [
      [
        24033,
        70073
      ],
      [
        -1,
        -6
      ],
      [
        1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -4
      ],
      [
        1,
        -6
      ],
      [
        1,
        -7
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -12
      ],
      [
        1,
        -5
      ],
      [
        -1,
        -13
      ],
      [
        1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        3,
        -6
      ],
      [
        7,
        -2
      ],
      [
        1,
        0
      ],
      [
        2,
        -4
      ],
      [
        3,
        -2
      ],
      [
        4,
        0
      ],
      [
        2,
        2
      ],
      [
        4,
        5
      ],
      [
        1,
        1
      ],
      [
        3,
        1
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        2,
        -4
      ],
      [
        2,
        -7
      ],
      [
        3,
        -5
      ],
      [
        6,
        -14
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -13
      ],
      [
        0,
        -13
      ],
      [
        1,
        -3
      ],
      [
        2,
        -6
      ],
      [
        1,
        -4
      ],
      [
        3,
        -12
      ],
      [
        2,
        -12
      ],
      [
        1,
        -8
      ],
      [
        1,
        -4
      ],
      [
        2,
        -10
      ],
      [
        1,
        -1
      ],
      [
        5,
        -6
      ],
      [
        2,
        -3
      ],
      [
        0,
        -1
      ],
      [
        2,
        -15
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -10
      ],
      [
        0,
        -15
      ],
      [
        1,
        -3
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -10
      ],
      [
        -3,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -8
      ],
      [
        -5,
        -11
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -5
      ],
      [
        1,
        -13
      ],
      [
        0,
        -11
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -6
      ],
      [
        -5,
        -14
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -6
      ]
    ],
    [
      [
        23996,
        69669
      ],
      [
        0,
        133
      ]
    ],
    [
      [
        24940,
        59062
      ],
      [
        40,
        3
      ],
      [
        1,
        29
      ]
    ],
    [
      [
        24981,
        59094
      ],
      [
        92,
        -9
      ]
    ],
    [
      [
        25020,
        58708
      ],
      [
        -3,
        25
      ],
      [
        -8,
        21
      ],
      [
        -4,
        24
      ],
      [
        -3,
        6
      ],
      [
        -23,
        2
      ],
      [
        0,
        -16
      ],
      [
        -7,
        -7
      ],
      [
        -12,
        10
      ],
      [
        -3,
        -13
      ],
      [
        -5,
        3
      ],
      [
        -6,
        -10
      ],
      [
        -6,
        5
      ],
      [
        -4,
        -23
      ]
    ],
    [
      [
        26455,
        61607
      ],
      [
        25,
        102
      ]
    ],
    [
      [
        26480,
        61709
      ],
      [
        8,
        -2
      ],
      [
        18,
        -29
      ],
      [
        3,
        -12
      ],
      [
        5,
        20
      ]
    ],
    [
      [
        26514,
        61686
      ],
      [
        9,
        -19
      ],
      [
        8,
        -46
      ],
      [
        1,
        -27
      ],
      [
        7,
        4
      ],
      [
        -2,
        -18
      ],
      [
        7,
        16
      ],
      [
        2,
        -15
      ],
      [
        2,
        3
      ],
      [
        0,
        -21
      ],
      [
        5,
        5
      ],
      [
        -2,
        -15
      ],
      [
        4,
        -12
      ],
      [
        -4,
        -21
      ]
    ],
    [
      [
        26551,
        61520
      ],
      [
        -4,
        -11
      ],
      [
        -32,
        -111
      ]
    ],
    [
      [
        26515,
        61398
      ],
      [
        2,
        20
      ],
      [
        -2,
        13
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        -17
      ],
      [
        -4,
        18
      ],
      [
        -5,
        -6
      ],
      [
        -2,
        11
      ],
      [
        -8,
        13
      ],
      [
        3,
        5
      ],
      [
        -1,
        20
      ],
      [
        -6,
        0
      ],
      [
        0,
        15
      ],
      [
        -3,
        4
      ],
      [
        -2,
        -16
      ],
      [
        -2,
        13
      ],
      [
        -5,
        6
      ],
      [
        5,
        12
      ],
      [
        -8,
        11
      ],
      [
        0,
        11
      ],
      [
        -10,
        59
      ],
      [
        -7,
        19
      ]
    ],
    [
      [
        23654,
        67982
      ],
      [
        133,
        0
      ]
    ],
    [
      [
        23821,
        67576
      ],
      [
        -90,
        0
      ]
    ],
    [
      [
        23731,
        67576
      ],
      [
        -34,
        1
      ],
      [
        -43,
        0
      ]
    ],
    [
      [
        26635,
        60400
      ],
      [
        3,
        -5
      ],
      [
        14,
        33
      ],
      [
        2,
        22
      ],
      [
        4,
        -5
      ],
      [
        4,
        6
      ],
      [
        8,
        -32
      ],
      [
        5,
        -15
      ],
      [
        6,
        0
      ],
      [
        3,
        10
      ],
      [
        1,
        13
      ],
      [
        3,
        0
      ],
      [
        4,
        8
      ],
      [
        3,
        17
      ],
      [
        6,
        -2
      ],
      [
        2,
        10
      ],
      [
        9,
        15
      ],
      [
        15,
        52
      ],
      [
        4,
        -16
      ],
      [
        1,
        -18
      ],
      [
        21,
        -11
      ]
    ],
    [
      [
        26787,
        60238
      ],
      [
        -4,
        -21
      ],
      [
        -6,
        -14
      ],
      [
        0,
        -10
      ],
      [
        -6,
        -38
      ],
      [
        2,
        -37
      ],
      [
        3,
        -14
      ],
      [
        -1,
        -21
      ],
      [
        -4,
        -1
      ],
      [
        -4,
        -22
      ],
      [
        6,
        -9
      ],
      [
        -1,
        -20
      ],
      [
        -16,
        -30
      ],
      [
        -3,
        11
      ]
    ],
    [
      [
        26737,
        60035
      ],
      [
        -2,
        16
      ],
      [
        3,
        4
      ],
      [
        0,
        28
      ],
      [
        3,
        13
      ],
      [
        -3,
        9
      ],
      [
        3,
        25
      ],
      [
        -8,
        7
      ],
      [
        -3,
        24
      ],
      [
        -6,
        9
      ],
      [
        2,
        8
      ],
      [
        -2,
        12
      ],
      [
        7,
        15
      ],
      [
        0,
        9
      ],
      [
        -9,
        11
      ],
      [
        -6,
        23
      ],
      [
        -2,
        -4
      ],
      [
        -5,
        8
      ],
      [
        -2,
        11
      ],
      [
        -3,
        -3
      ],
      [
        -3,
        18
      ],
      [
        -4,
        -5
      ],
      [
        -6,
        41
      ],
      [
        3,
        14
      ],
      [
        -5,
        13
      ],
      [
        0,
        14
      ],
      [
        -12,
        16
      ],
      [
        -1,
        13
      ],
      [
        -9,
        -24
      ],
      [
        0,
        -12
      ],
      [
        -6,
        -2
      ],
      [
        -2,
        6
      ],
      [
        -5,
        -9
      ],
      [
        -2,
        -16
      ],
      [
        1,
        -23
      ],
      [
        -7,
        -19
      ]
    ],
    [
      [
        26646,
        60285
      ],
      [
        -1,
        22
      ],
      [
        -5,
        4
      ]
    ],
    [
      [
        23517,
        56176
      ],
      [
        0,
        -1
      ],
      [
        2,
        -6
      ],
      [
        1,
        0
      ],
      [
        0,
        3
      ],
      [
        1,
        4
      ],
      [
        0,
        1
      ],
      [
        1,
        2
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        -7
      ],
      [
        0,
        -15
      ],
      [
        7,
        -3
      ],
      [
        7,
        9
      ],
      [
        2,
        -1
      ],
      [
        1,
        -4
      ],
      [
        0,
        -17
      ],
      [
        1,
        -5
      ],
      [
        0,
        -1
      ],
      [
        3,
        2
      ],
      [
        1,
        4
      ],
      [
        1,
        5
      ],
      [
        2,
        4
      ],
      [
        1,
        -2
      ],
      [
        1,
        -5
      ],
      [
        1,
        -3
      ],
      [
        2,
        -1
      ],
      [
        1,
        0
      ],
      [
        1,
        3
      ],
      [
        1,
        4
      ],
      [
        1,
        2
      ],
      [
        2,
        -2
      ],
      [
        1,
        -5
      ],
      [
        1,
        -4
      ],
      [
        1,
        -4
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        1,
        2
      ],
      [
        2,
        1
      ],
      [
        2,
        -4
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -5
      ],
      [
        1,
        -3
      ],
      [
        1,
        0
      ],
      [
        1,
        3
      ],
      [
        2,
        -1
      ],
      [
        1,
        -3
      ],
      [
        0,
        -15
      ],
      [
        1,
        -3
      ],
      [
        2,
        -3
      ],
      [
        4,
        5
      ],
      [
        4,
        5
      ],
      [
        1,
        4
      ],
      [
        0,
        11
      ]
    ],
    [
      [
        23710,
        55996
      ],
      [
        1,
        -11
      ],
      [
        0,
        -284
      ]
    ],
    [
      [
        23711,
        55701
      ],
      [
        -9,
        -7
      ],
      [
        -5,
        16
      ],
      [
        -7,
        -1
      ],
      [
        -1,
        -14
      ],
      [
        -5,
        1
      ],
      [
        -8,
        20
      ],
      [
        -1,
        -10
      ],
      [
        -4,
        4
      ],
      [
        -9,
        -10
      ],
      [
        0,
        -11
      ],
      [
        -6,
        -17
      ],
      [
        2,
        -37
      ],
      [
        -14,
        5
      ],
      [
        -8,
        4
      ],
      [
        -6,
        8
      ],
      [
        -3,
        -4
      ],
      [
        -4,
        13
      ],
      [
        -6,
        -9
      ],
      [
        -9,
        17
      ],
      [
        -1,
        16
      ],
      [
        -5,
        4
      ],
      [
        -3,
        -7
      ],
      [
        -7,
        15
      ],
      [
        -1,
        -7
      ],
      [
        -13,
        -7
      ],
      [
        -3,
        -18
      ],
      [
        -3,
        3
      ],
      [
        -5,
        -10
      ],
      [
        -3,
        4
      ],
      [
        -1,
        -17
      ],
      [
        -4,
        0
      ],
      [
        -1,
        11
      ],
      [
        -8,
        -14
      ],
      [
        -6,
        8
      ],
      [
        -3,
        17
      ]
    ],
    [
      [
        23541,
        55667
      ],
      [
        -10,
        28
      ],
      [
        -1,
        23
      ],
      [
        -11,
        -4
      ],
      [
        -5,
        23
      ]
    ],
    [
      [
        23514,
        55737
      ],
      [
        1,
        436
      ],
      [
        2,
        3
      ]
    ],
    [
      [
        20647,
        69323
      ],
      [
        6,
        0
      ],
      [
        70,
        -1
      ],
      [
        11,
        0
      ],
      [
        17,
        -1
      ],
      [
        1,
        1
      ],
      [
        53,
        -1
      ],
      [
        62,
        0
      ],
      [
        53,
        -1
      ]
    ],
    [
      [
        20921,
        68369
      ],
      [
        -87,
        0
      ],
      [
        -2,
        1
      ],
      [
        -196,
        -6
      ]
    ],
    [
      [
        20636,
        68364
      ],
      [
        -1,
        4
      ],
      [
        -1,
        405
      ],
      [
        0,
        302
      ],
      [
        3,
        -1
      ],
      [
        0,
        249
      ]
    ],
    [
      [
        27489,
        56715
      ],
      [
        5,
        11
      ],
      [
        2,
        34
      ],
      [
        4,
        1
      ],
      [
        3,
        21
      ],
      [
        0,
        58
      ],
      [
        -2,
        9
      ],
      [
        5,
        12
      ],
      [
        5,
        1
      ],
      [
        6,
        12
      ],
      [
        8,
        -3
      ],
      [
        -4,
        29
      ],
      [
        1,
        14
      ],
      [
        10,
        -1
      ],
      [
        7,
        21
      ],
      [
        4,
        8
      ]
    ],
    [
      [
        27623,
        56574
      ],
      [
        -7,
        -46
      ],
      [
        -13,
        -1
      ],
      [
        -26,
        -58
      ],
      [
        -4,
        -7
      ],
      [
        -2,
        62
      ],
      [
        -12,
        -11
      ],
      [
        -6,
        -4
      ],
      [
        -5,
        50
      ],
      [
        -7,
        5
      ],
      [
        -2,
        28
      ],
      [
        -6,
        20
      ],
      [
        -15,
        0
      ],
      [
        -8,
        1
      ],
      [
        -21,
        36
      ],
      [
        0,
        66
      ]
    ],
    [
      [
        20754,
        66540
      ],
      [
        34,
        0
      ],
      [
        134,
        3
      ]
    ],
    [
      [
        20922,
        66543
      ],
      [
        0,
        -710
      ]
    ],
    [
      [
        20922,
        65833
      ],
      [
        0,
        -354
      ]
    ],
    [
      [
        20922,
        65479
      ],
      [
        0,
        -155
      ]
    ],
    [
      [
        20922,
        65324
      ],
      [
        -167,
        0
      ],
      [
        -1,
        103
      ]
    ],
    [
      [
        30179,
        66140
      ],
      [
        4,
        -3
      ],
      [
        6,
        -11
      ],
      [
        3,
        -2
      ]
    ],
    [
      [
        30085,
        66184
      ],
      [
        -4,
        13
      ],
      [
        2,
        9
      ],
      [
        4,
        9
      ]
    ],
    [
      [
        29997,
        66013
      ],
      [
        4,
        2
      ],
      [
        6,
        19
      ],
      [
        4,
        6
      ],
      [
        7,
        -1
      ],
      [
        0,
        11
      ],
      [
        5,
        4
      ],
      [
        7,
        5
      ],
      [
        5,
        5
      ],
      [
        -2,
        14
      ],
      [
        3,
        3
      ],
      [
        -1,
        6
      ],
      [
        4,
        16
      ],
      [
        -1,
        18
      ],
      [
        8,
        -1
      ],
      [
        -1,
        26
      ],
      [
        -5,
        31
      ],
      [
        0,
        8
      ],
      [
        -1,
        11
      ],
      [
        16,
        17
      ],
      [
        5,
        -2
      ],
      [
        1,
        -4
      ],
      [
        6,
        -5
      ],
      [
        0,
        -12
      ],
      [
        6,
        -13
      ],
      [
        0,
        -9
      ],
      [
        4,
        -8
      ]
    ],
    [
      [
        30133,
        66195
      ],
      [
        1,
        -8
      ],
      [
        -4,
        -13
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -6
      ],
      [
        3,
        -14
      ],
      [
        2,
        -4
      ],
      [
        6,
        1
      ],
      [
        3,
        3
      ],
      [
        -1,
        11
      ],
      [
        1,
        5
      ]
    ],
    [
      [
        30024,
        65813
      ],
      [
        0,
        40
      ],
      [
        -12,
        -1
      ],
      [
        -9,
        -1
      ],
      [
        -11,
        0
      ]
    ],
    [
      [
        29992,
        65851
      ],
      [
        0,
        55
      ],
      [
        1,
        41
      ],
      [
        -2,
        4
      ],
      [
        0,
        15
      ],
      [
        6,
        18
      ],
      [
        0,
        29
      ]
    ],
    [
      [
        26040,
        60863
      ],
      [
        3,
        0
      ],
      [
        7,
        -19
      ],
      [
        2,
        -23
      ],
      [
        4,
        -2
      ],
      [
        5,
        7
      ],
      [
        4,
        -8
      ],
      [
        -1,
        -47
      ],
      [
        -1,
        -16
      ],
      [
        4,
        5
      ],
      [
        3,
        -6
      ],
      [
        2,
        -18
      ],
      [
        -4,
        4
      ],
      [
        -3,
        -15
      ],
      [
        -6,
        2
      ],
      [
        1,
        -10
      ],
      [
        6,
        -12
      ],
      [
        -5,
        -7
      ],
      [
        1,
        -25
      ],
      [
        -6,
        -20
      ],
      [
        0,
        -13
      ],
      [
        5,
        9
      ],
      [
        4,
        -17
      ],
      [
        8,
        -13
      ],
      [
        5,
        9
      ],
      [
        -2,
        27
      ],
      [
        3,
        10
      ],
      [
        6,
        -9
      ]
    ],
    [
      [
        26085,
        60656
      ],
      [
        5,
        -6
      ],
      [
        3,
        -39
      ],
      [
        5,
        -28
      ],
      [
        2,
        -31
      ]
    ],
    [
      [
        26100,
        60552
      ],
      [
        -6,
        2
      ],
      [
        -3,
        19
      ],
      [
        -8,
        -34
      ],
      [
        -16,
        18
      ]
    ],
    [
      [
        26067,
        60557
      ],
      [
        -6,
        -10
      ],
      [
        -8,
        13
      ],
      [
        -1,
        -21
      ],
      [
        -7,
        -20
      ],
      [
        2,
        -17
      ]
    ],
    [
      [
        26047,
        60502
      ],
      [
        -21,
        4
      ],
      [
        -5,
        6
      ],
      [
        -40,
        11
      ]
    ],
    [
      [
        18664,
        68226
      ],
      [
        34,
        0
      ],
      [
        0,
        101
      ],
      [
        34,
        0
      ],
      [
        0,
        50
      ],
      [
        15,
        0
      ],
      [
        0,
        51
      ],
      [
        2,
        100
      ],
      [
        17,
        0
      ],
      [
        0,
        98
      ],
      [
        48,
        0
      ],
      [
        0,
        172
      ]
    ],
    [
      [
        18852,
        68984
      ],
      [
        12,
        14
      ],
      [
        3,
        -1
      ],
      [
        1,
        -7
      ],
      [
        3,
        -4
      ],
      [
        4,
        15
      ],
      [
        1,
        25
      ],
      [
        -1,
        2
      ],
      [
        2,
        7
      ],
      [
        2,
        3
      ],
      [
        2,
        -4
      ]
    ],
    [
      [
        18973,
        68711
      ],
      [
        0,
        -116
      ],
      [
        -1,
        -24
      ],
      [
        1,
        -267
      ],
      [
        0,
        -164
      ]
    ],
    [
      [
        18973,
        68140
      ],
      [
        -3,
        1
      ],
      [
        -12,
        -19
      ],
      [
        -3,
        0
      ],
      [
        -14,
        -25
      ],
      [
        -7,
        -17
      ],
      [
        -14,
        19
      ],
      [
        -5,
        -12
      ],
      [
        -4,
        1
      ],
      [
        -3,
        -14
      ],
      [
        -8,
        -9
      ],
      [
        -5,
        7
      ],
      [
        -2,
        17
      ],
      [
        -5,
        9
      ],
      [
        -13,
        -29
      ]
    ],
    [
      [
        18875,
        68069
      ],
      [
        -7,
        -14
      ],
      [
        -12,
        7
      ],
      [
        -3,
        13
      ],
      [
        -6,
        1
      ],
      [
        -9,
        -11
      ],
      [
        -7,
        -21
      ],
      [
        0,
        -21
      ],
      [
        -39,
        0
      ],
      [
        0,
        17
      ],
      [
        -39,
        0
      ],
      [
        0,
        34
      ],
      [
        -39,
        0
      ]
    ],
    [
      [
        26252,
        56614
      ],
      [
        -2,
        -12
      ],
      [
        -14,
        -140
      ],
      [
        -20,
        1
      ],
      [
        0,
        -56
      ]
    ],
    [
      [
        26122,
        56404
      ],
      [
        -3,
        72
      ]
    ],
    [
      [
        21996,
        66993
      ],
      [
        0,
        -177
      ]
    ],
    [
      [
        21815,
        65933
      ],
      [
        -161,
        5
      ]
    ],
    [
      [
        21654,
        65938
      ],
      [
        -162,
        5
      ]
    ],
    [
      [
        21492,
        65943
      ],
      [
        -9,
        0
      ],
      [
        0,
        404
      ],
      [
        -8,
        0
      ],
      [
        0,
        398
      ],
      [
        -5,
        0
      ],
      [
        1,
        249
      ]
    ],
    [
      [
        26502,
        56231
      ],
      [
        1,
        4
      ],
      [
        11,
        34
      ]
    ],
    [
      [
        26514,
        56269
      ],
      [
        18,
        -48
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        26496,
        55966
      ],
      [
        -1,
        18
      ],
      [
        -9,
        16
      ],
      [
        -5,
        6
      ],
      [
        -7,
        2
      ],
      [
        -13,
        68
      ],
      [
        -3,
        11
      ],
      [
        -1,
        19
      ]
    ],
    [
      [
        17570,
        55850
      ],
      [
        171,
        1
      ],
      [
        8,
        2
      ],
      [
        171,
        6
      ],
      [
        56,
        0
      ]
    ],
    [
      [
        17950,
        55027
      ],
      [
        -78,
        -22
      ],
      [
        -130,
        -38
      ],
      [
        -162,
        -51
      ],
      [
        -16,
        -6
      ]
    ],
    [
      [
        17564,
        54910
      ],
      [
        0,
        120
      ],
      [
        1,
        6
      ],
      [
        -1,
        90
      ],
      [
        0,
        315
      ],
      [
        7,
        0
      ],
      [
        -1,
        409
      ]
    ],
    [
      [
        17303,
        72789
      ],
      [
        0,
        79
      ]
    ],
    [
      [
        25560,
        63651
      ],
      [
        -1,
        18
      ],
      [
        -8,
        25
      ],
      [
        3,
        16
      ],
      [
        2,
        16
      ],
      [
        17,
        22
      ],
      [
        5,
        14
      ],
      [
        7,
        28
      ],
      [
        6,
        11
      ],
      [
        3,
        25
      ],
      [
        9,
        25
      ],
      [
        1,
        11
      ],
      [
        21,
        30
      ],
      [
        11,
        7
      ],
      [
        11,
        30
      ]
    ],
    [
      [
        25647,
        63929
      ],
      [
        0,
        -176
      ]
    ],
    [
      [
        25647,
        63753
      ],
      [
        0,
        -305
      ]
    ],
    [
      [
        25556,
        63447
      ],
      [
        -6,
        8
      ],
      [
        4,
        27
      ],
      [
        -2,
        51
      ],
      [
        5,
        38
      ],
      [
        3,
        80
      ]
    ],
    [
      [
        25880,
        58162
      ],
      [
        3,
        43
      ],
      [
        3,
        4
      ],
      [
        -3,
        8
      ],
      [
        1,
        52
      ],
      [
        0,
        78
      ],
      [
        -1,
        71
      ]
    ],
    [
      [
        25883,
        58418
      ],
      [
        0,
        66
      ],
      [
        7,
        21
      ],
      [
        4,
        -3
      ]
    ],
    [
      [
        25894,
        58502
      ],
      [
        11,
        -26
      ],
      [
        6,
        -23
      ],
      [
        7,
        -1
      ],
      [
        9,
        -17
      ],
      [
        14,
        -4
      ],
      [
        1,
        9
      ],
      [
        11,
        3
      ],
      [
        0,
        8
      ],
      [
        3,
        0
      ]
    ],
    [
      [
        25956,
        58451
      ],
      [
        5,
        -46
      ],
      [
        3,
        -1
      ],
      [
        2,
        -27
      ],
      [
        -2,
        -3
      ],
      [
        2,
        -24
      ],
      [
        12,
        -38
      ],
      [
        6,
        -2
      ],
      [
        2,
        -18
      ]
    ],
    [
      [
        25986,
        58292
      ],
      [
        -3,
        -8
      ],
      [
        3,
        -11
      ],
      [
        -3,
        -21
      ],
      [
        -1,
        -53
      ],
      [
        2,
        -59
      ],
      [
        -1,
        -14
      ],
      [
        5,
        -1
      ],
      [
        -3,
        -37
      ],
      [
        -7,
        -21
      ],
      [
        -1,
        -39
      ],
      [
        -1,
        -9
      ]
    ],
    [
      [
        25976,
        58019
      ],
      [
        -18,
        33
      ],
      [
        -7,
        -3
      ],
      [
        -6,
        23
      ],
      [
        -3,
        0
      ],
      [
        -1,
        10
      ],
      [
        -34,
        22
      ],
      [
        -10,
        -21
      ],
      [
        -1,
        -12
      ],
      [
        -4,
        15
      ],
      [
        -5,
        -7
      ],
      [
        -5,
        4
      ],
      [
        -3,
        -12
      ]
    ],
    [
      [
        25879,
        58071
      ],
      [
        -2,
        5
      ],
      [
        6,
        11
      ],
      [
        -8,
        29
      ],
      [
        6,
        15
      ],
      [
        -8,
        2
      ],
      [
        7,
        29
      ]
    ],
    [
      [
        25983,
        58660
      ],
      [
        3,
        7
      ],
      [
        25,
        -3
      ],
      [
        10,
        8
      ],
      [
        19,
        -22
      ]
    ],
    [
      [
        26040,
        58650
      ],
      [
        0,
        -5
      ],
      [
        11,
        -12
      ],
      [
        11,
        -25
      ]
    ],
    [
      [
        26062,
        58608
      ],
      [
        -3,
        -40
      ],
      [
        6,
        -8
      ],
      [
        -2,
        -15
      ],
      [
        2,
        -7
      ],
      [
        -4,
        -31
      ],
      [
        3,
        -105
      ],
      [
        11,
        -99
      ]
    ],
    [
      [
        26061,
        58301
      ],
      [
        -27,
        -3
      ],
      [
        -14,
        -6
      ],
      [
        -10,
        -7
      ],
      [
        -9,
        -15
      ],
      [
        -3,
        12
      ],
      [
        -12,
        10
      ]
    ],
    [
      [
        25956,
        58451
      ],
      [
        -4,
        60
      ],
      [
        8,
        48
      ],
      [
        4,
        16
      ],
      [
        11,
        65
      ],
      [
        8,
        20
      ]
    ],
    [
      [
        26868,
        60343
      ],
      [
        3,
        6
      ],
      [
        2,
        18
      ],
      [
        6,
        1
      ],
      [
        0,
        16
      ],
      [
        5,
        36
      ],
      [
        -4,
        21
      ],
      [
        4,
        12
      ],
      [
        5,
        -1
      ],
      [
        4,
        9
      ],
      [
        0,
        8
      ],
      [
        4,
        19
      ],
      [
        1,
        30
      ],
      [
        4,
        12
      ],
      [
        0,
        31
      ],
      [
        -3,
        35
      ],
      [
        -7,
        1
      ],
      [
        7,
        161
      ],
      [
        -4,
        33
      ],
      [
        14,
        17
      ]
    ],
    [
      [
        26973,
        60873
      ],
      [
        2,
        -6
      ],
      [
        2,
        -2
      ],
      [
        0,
        -7
      ],
      [
        1,
        -8
      ],
      [
        1,
        -3
      ],
      [
        0,
        -6
      ],
      [
        1,
        -7
      ],
      [
        1,
        -1
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -3
      ],
      [
        1,
        -4
      ],
      [
        0,
        -2
      ],
      [
        1,
        -9
      ],
      [
        0,
        -9
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        0,
        3
      ],
      [
        2,
        -1
      ],
      [
        2,
        -7
      ],
      [
        1,
        -1
      ],
      [
        3,
        -7
      ],
      [
        2,
        0
      ],
      [
        2,
        5
      ],
      [
        1,
        1
      ],
      [
        0,
        -1
      ],
      [
        4,
        -9
      ],
      [
        0,
        -7
      ],
      [
        1,
        -3
      ],
      [
        1,
        -2
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        -7
      ],
      [
        0,
        -3
      ],
      [
        1,
        0
      ],
      [
        2,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        0
      ],
      [
        2,
        -2
      ],
      [
        2,
        1
      ],
      [
        0,
        1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -6
      ],
      [
        2,
        -4
      ],
      [
        2,
        -6
      ],
      [
        0,
        -5
      ],
      [
        1,
        -1
      ],
      [
        2,
        -13
      ],
      [
        0,
        -5
      ],
      [
        3,
        -2
      ],
      [
        0,
        2
      ],
      [
        1,
        3
      ],
      [
        3,
        -2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -6
      ],
      [
        1,
        -9
      ],
      [
        0,
        -3
      ],
      [
        2,
        -19
      ],
      [
        4,
        0
      ],
      [
        0,
        -2
      ],
      [
        4,
        -2
      ],
      [
        1,
        -1
      ],
      [
        3,
        0
      ],
      [
        3,
        -13
      ],
      [
        0,
        -9
      ],
      [
        1,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        2,
        6
      ],
      [
        0,
        6
      ],
      [
        1,
        2
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        1,
        -5
      ],
      [
        2,
        -6
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        1,
        0
      ],
      [
        0,
        -8
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        1,
        1
      ],
      [
        4,
        4
      ],
      [
        0,
        1
      ],
      [
        1,
        5
      ],
      [
        2,
        -1
      ],
      [
        0,
        1
      ],
      [
        1,
        3
      ],
      [
        2,
        2
      ],
      [
        2,
        -4
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -4
      ]
    ],
    [
      [
        27075,
        60636
      ],
      [
        -23,
        -66
      ],
      [
        -4,
        -11
      ],
      [
        -17,
        -51
      ],
      [
        -21,
        -61
      ],
      [
        -1,
        -1
      ],
      [
        -14,
        -42
      ],
      [
        -10,
        -31
      ],
      [
        -5,
        -13
      ],
      [
        -2,
        -5
      ]
    ],
    [
      [
        26978,
        60355
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        1
      ],
      [
        0,
        -7
      ],
      [
        -3,
        -9
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        -1
      ],
      [
        -3,
        -5
      ],
      [
        -3,
        0
      ],
      [
        -9,
        -10
      ],
      [
        -3,
        -5
      ],
      [
        -2,
        -1
      ],
      [
        -3,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        0
      ],
      [
        -3,
        -3
      ],
      [
        -4,
        -5
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        0
      ],
      [
        -3,
        -5
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -5,
        -9
      ],
      [
        -1,
        -1
      ]
    ],
    [
      [
        26912,
        60247
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -4
      ]
    ],
    [
      [
        26908,
        60239
      ],
      [
        -6,
        15
      ],
      [
        -4,
        24
      ],
      [
        -7,
        21
      ],
      [
        -12,
        -24
      ],
      [
        -4,
        2
      ],
      [
        -6,
        16
      ],
      [
        2,
        15
      ],
      [
        -7,
        1
      ],
      [
        -2,
        17
      ]
    ],
    [
      [
        26518,
        61094
      ],
      [
        16,
        -16
      ],
      [
        6,
        -1
      ],
      [
        2,
        -13
      ],
      [
        14,
        2
      ],
      [
        4,
        -8
      ],
      [
        9,
        10
      ],
      [
        4,
        11
      ]
    ],
    [
      [
        26573,
        61079
      ],
      [
        5,
        -26
      ],
      [
        23,
        -50
      ],
      [
        2,
        -21
      ],
      [
        8,
        -11
      ]
    ],
    [
      [
        26611,
        60971
      ],
      [
        -21,
        -127
      ]
    ],
    [
      [
        26586,
        60844
      ],
      [
        0,
        15
      ],
      [
        -7,
        3
      ],
      [
        -6,
        11
      ],
      [
        -2,
        18
      ],
      [
        -8,
        0
      ],
      [
        -4,
        -13
      ],
      [
        -3,
        23
      ],
      [
        -10,
        -15
      ],
      [
        -11,
        8
      ],
      [
        -2,
        9
      ],
      [
        -14,
        39
      ],
      [
        0,
        52
      ],
      [
        -8,
        6
      ],
      [
        -3,
        -15
      ]
    ],
    [
      [
        26508,
        60985
      ],
      [
        -7,
        38
      ],
      [
        6,
        -11
      ],
      [
        4,
        46
      ],
      [
        0,
        21
      ],
      [
        7,
        15
      ]
    ],
    [
      [
        26010,
        67234
      ],
      [
        0,
        -203
      ],
      [
        2,
        -136
      ],
      [
        0,
        -170
      ]
    ],
    [
      [
        26012,
        66725
      ],
      [
        -27,
        -1
      ],
      [
        -69,
        1
      ],
      [
        -11,
        0
      ],
      [
        -12,
        -1
      ]
    ],
    [
      [
        25893,
        66724
      ],
      [
        0,
        19
      ],
      [
        -1,
        58
      ],
      [
        1,
        30
      ],
      [
        -1,
        28
      ],
      [
        -1,
        26
      ],
      [
        0,
        16
      ],
      [
        -3,
        80
      ],
      [
        0,
        10
      ],
      [
        -1,
        22
      ],
      [
        -4,
        40
      ],
      [
        -1,
        9
      ],
      [
        0,
        11
      ],
      [
        -2,
        19
      ],
      [
        -4,
        41
      ]
    ],
    [
      [
        25794,
        59584
      ],
      [
        4,
        5
      ],
      [
        0,
        8
      ],
      [
        2,
        -1
      ],
      [
        0,
        -4
      ],
      [
        10,
        14
      ],
      [
        10,
        -1
      ],
      [
        1,
        0
      ],
      [
        16,
        -1
      ]
    ],
    [
      [
        25837,
        59604
      ],
      [
        10,
        -1
      ],
      [
        4,
        0
      ],
      [
        8,
        -1
      ],
      [
        11,
        -4
      ],
      [
        20,
        -6
      ],
      [
        1,
        0
      ],
      [
        3,
        -1
      ]
    ],
    [
      [
        25894,
        59591
      ],
      [
        -5,
        -129
      ],
      [
        2,
        -16
      ],
      [
        -2,
        -28
      ],
      [
        -1,
        -4
      ]
    ],
    [
      [
        25873,
        59251
      ],
      [
        -4,
        -15
      ],
      [
        -1,
        -26
      ],
      [
        -9,
        7
      ],
      [
        -8,
        -8
      ],
      [
        4,
        21
      ],
      [
        0,
        18
      ],
      [
        -4,
        15
      ],
      [
        -5,
        -8
      ],
      [
        -3,
        -27
      ],
      [
        0,
        -21
      ],
      [
        -5,
        -2
      ],
      [
        -2,
        7
      ],
      [
        -1,
        22
      ],
      [
        -4,
        8
      ],
      [
        -5,
        -5
      ],
      [
        -18,
        -43
      ],
      [
        -2,
        -24
      ],
      [
        -4,
        15
      ],
      [
        -2,
        35
      ],
      [
        -3,
        -2
      ],
      [
        -3,
        -17
      ],
      [
        1,
        -20
      ],
      [
        -3,
        -29
      ],
      [
        -6,
        -20
      ]
    ],
    [
      [
        25786,
        59132
      ],
      [
        -6,
        0
      ],
      [
        -2,
        5
      ],
      [
        -5,
        6
      ],
      [
        0,
        39
      ],
      [
        -8,
        14
      ],
      [
        -2,
        18
      ],
      [
        -12,
        31
      ],
      [
        -2,
        35
      ],
      [
        -5,
        36
      ],
      [
        -3,
        2
      ]
    ],
    [
      [
        25741,
        59318
      ],
      [
        2,
        16
      ],
      [
        4,
        -1
      ],
      [
        11,
        -13
      ],
      [
        0,
        17
      ],
      [
        5,
        33
      ],
      [
        7,
        24
      ],
      [
        3,
        31
      ],
      [
        2,
        43
      ],
      [
        3,
        18
      ],
      [
        6,
        27
      ],
      [
        10,
        71
      ]
    ],
    [
      [
        27602,
        57849
      ],
      [
        15,
        -7
      ],
      [
        11,
        25
      ],
      [
        9,
        -1
      ],
      [
        2,
        7
      ],
      [
        12,
        -2
      ],
      [
        14,
        25
      ],
      [
        4,
        -7
      ],
      [
        6,
        3
      ],
      [
        6,
        -5
      ],
      [
        7,
        2
      ],
      [
        5,
        -5
      ],
      [
        4,
        6
      ],
      [
        6,
        -6
      ],
      [
        5,
        7
      ],
      [
        6,
        -5
      ],
      [
        9,
        -20
      ],
      [
        8,
        7
      ]
    ],
    [
      [
        27731,
        57873
      ],
      [
        1,
        -17
      ],
      [
        6,
        -12
      ],
      [
        4,
        -19
      ],
      [
        -3,
        -45
      ],
      [
        2,
        -16
      ],
      [
        21,
        -7
      ],
      [
        5,
        -6
      ],
      [
        7,
        -18
      ]
    ],
    [
      [
        27774,
        57733
      ],
      [
        -3,
        -8
      ],
      [
        -12,
        -12
      ],
      [
        -17,
        -40
      ],
      [
        2,
        -15
      ],
      [
        -3,
        -8
      ],
      [
        -2,
        -20
      ],
      [
        1,
        -23
      ],
      [
        3,
        -9
      ],
      [
        2,
        -20
      ],
      [
        -15,
        -52
      ],
      [
        -3,
        -16
      ],
      [
        3,
        -15
      ],
      [
        -2,
        -14
      ],
      [
        3,
        -14
      ],
      [
        -6,
        12
      ],
      [
        -6,
        -12
      ],
      [
        -10,
        -12
      ]
    ],
    [
      [
        27709,
        57455
      ],
      [
        -15,
        1
      ],
      [
        -41,
        0
      ],
      [
        -10,
        1
      ]
    ],
    [
      [
        27643,
        57457
      ],
      [
        4,
        15
      ],
      [
        3,
        41
      ],
      [
        6,
        14
      ],
      [
        5,
        19
      ],
      [
        4,
        23
      ],
      [
        0,
        10
      ],
      [
        -6,
        48
      ],
      [
        2,
        25
      ],
      [
        -1,
        10
      ],
      [
        -9,
        25
      ],
      [
        2,
        24
      ],
      [
        4,
        12
      ],
      [
        -1,
        20
      ],
      [
        -8,
        17
      ],
      [
        -1,
        35
      ],
      [
        -3,
        22
      ],
      [
        -6,
        3
      ],
      [
        -8,
        -18
      ],
      [
        -5,
        -20
      ],
      [
        -8,
        5
      ],
      [
        -5,
        14
      ],
      [
        -8,
        11
      ],
      [
        -2,
        37
      ]
    ],
    [
      [
        21093,
        52637
      ],
      [
        29,
        -85
      ],
      [
        214,
        -629
      ]
    ],
    [
      [
        21336,
        51923
      ],
      [
        68,
        -202
      ]
    ],
    [
      [
        21404,
        51721
      ],
      [
        -1,
        -8
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        2
      ],
      [
        -3,
        -8
      ],
      [
        -4,
        -20
      ],
      [
        1,
        -14
      ],
      [
        -2,
        -15
      ],
      [
        -2,
        -24
      ],
      [
        0,
        -11
      ],
      [
        -3,
        -27
      ],
      [
        -2,
        -2
      ],
      [
        -5,
        3
      ],
      [
        -6,
        10
      ],
      [
        -10,
        4
      ],
      [
        -6,
        4
      ],
      [
        -5,
        0
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -17
      ],
      [
        -8,
        -16
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        2
      ],
      [
        -2,
        9
      ],
      [
        -2,
        1
      ],
      [
        -3,
        -8
      ],
      [
        -3,
        -4
      ],
      [
        -3,
        1
      ],
      [
        -4,
        -4
      ],
      [
        -3,
        -14
      ],
      [
        -2,
        -2
      ],
      [
        -4,
        -1
      ],
      [
        -4,
        3
      ],
      [
        -3,
        7
      ],
      [
        -2,
        -5
      ],
      [
        -3,
        -18
      ],
      [
        -1,
        -18
      ],
      [
        -2,
        -13
      ],
      [
        0,
        -13
      ],
      [
        2,
        -10
      ],
      [
        -9,
        -32
      ],
      [
        -4,
        -8
      ],
      [
        -1,
        -11
      ],
      [
        1,
        -12
      ],
      [
        0,
        -27
      ],
      [
        -2,
        -7
      ],
      [
        -3,
        6
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -5
      ],
      [
        1,
        -18
      ],
      [
        -1,
        -8
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -19
      ],
      [
        1,
        -5
      ],
      [
        1,
        -5
      ],
      [
        -11,
        -30
      ],
      [
        1,
        -33
      ],
      [
        -2,
        -13
      ],
      [
        -5,
        -45
      ],
      [
        0,
        -13
      ],
      [
        1,
        -17
      ],
      [
        1,
        -22
      ],
      [
        -5,
        -26
      ],
      [
        0,
        -22
      ],
      [
        -5,
        -8
      ],
      [
        -3,
        1
      ],
      [
        -2,
        2
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -6
      ],
      [
        1,
        -11
      ],
      [
        -3,
        -34
      ],
      [
        0,
        -20
      ],
      [
        -1,
        -6
      ],
      [
        -3,
        -9
      ],
      [
        -1,
        -22
      ],
      [
        1,
        -7
      ],
      [
        4,
        -10
      ],
      [
        2,
        0
      ],
      [
        3,
        -5
      ],
      [
        1,
        -19
      ],
      [
        -3,
        -12
      ],
      [
        -3,
        -7
      ],
      [
        -3,
        0
      ],
      [
        -2,
        12
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -5
      ],
      [
        1,
        -6
      ],
      [
        -2,
        -18
      ],
      [
        -2,
        3
      ],
      [
        -2,
        1
      ],
      [
        -4,
        -6
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        -7,
        12
      ],
      [
        -3,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -13
      ],
      [
        -2,
        -13
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -13
      ],
      [
        -1,
        -14
      ],
      [
        -5,
        -13
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        -4,
        -4
      ],
      [
        -6,
        -9
      ],
      [
        0,
        -15
      ],
      [
        -7,
        -21
      ],
      [
        0,
        -46
      ],
      [
        -2,
        -5
      ],
      [
        -3,
        -16
      ],
      [
        1,
        -13
      ],
      [
        0,
        -4
      ],
      [
        -3,
        -4
      ],
      [
        -2,
        2
      ],
      [
        -3,
        -7
      ],
      [
        -4,
        -6
      ],
      [
        -2,
        -1
      ],
      [
        0,
        8
      ],
      [
        -17,
        15
      ],
      [
        -3,
        -11
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        6
      ],
      [
        -2,
        4
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        6
      ],
      [
        -1,
        8
      ],
      [
        0,
        7
      ],
      [
        -3,
        5
      ],
      [
        -4,
        7
      ],
      [
        -5,
        13
      ],
      [
        -1,
        6
      ],
      [
        1,
        8
      ],
      [
        -1,
        7
      ],
      [
        -2,
        2
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -10
      ],
      [
        -1,
        -8
      ],
      [
        -2,
        -3
      ],
      [
        -5,
        6
      ],
      [
        -13,
        21
      ],
      [
        -2,
        15
      ],
      [
        -5,
        14
      ],
      [
        -1,
        2
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        3
      ],
      [
        0,
        14
      ],
      [
        -1,
        6
      ],
      [
        -3,
        9
      ],
      [
        -5,
        29
      ],
      [
        -6,
        2
      ],
      [
        0,
        19
      ],
      [
        -10,
        20
      ],
      [
        -5,
        -6
      ],
      [
        -4,
        1
      ],
      [
        -4,
        12
      ],
      [
        -1,
        6
      ],
      [
        -10,
        -8
      ],
      [
        -2,
        5
      ],
      [
        -1,
        7
      ],
      [
        -1,
        2
      ],
      [
        -8,
        8
      ],
      [
        -2,
        -1
      ],
      [
        -5,
        9
      ],
      [
        -3,
        8
      ],
      [
        -5,
        20
      ],
      [
        -3,
        19
      ],
      [
        -4,
        3
      ],
      [
        -3,
        5
      ],
      [
        -1,
        20
      ],
      [
        -2,
        10
      ],
      [
        -1,
        2
      ]
    ],
    [
      [
        20994,
        51000
      ],
      [
        0,
        15
      ],
      [
        -1,
        702
      ],
      [
        -1,
        625
      ]
    ],
    [
      [
        19998,
        68811
      ],
      [
        93,
        -1
      ],
      [
        61,
        -2
      ],
      [
        74,
        -1
      ],
      [
        34,
        6
      ],
      [
        69,
        2
      ],
      [
        48,
        0
      ]
    ],
    [
      [
        20377,
        68815
      ],
      [
        0,
        -43
      ],
      [
        -2,
        -7
      ],
      [
        0,
        -409
      ],
      [
        2,
        -405
      ],
      [
        -3,
        0
      ],
      [
        0,
        -380
      ]
    ],
    [
      [
        20070,
        67577
      ],
      [
        0,
        65
      ],
      [
        -1,
        303
      ],
      [
        -4,
        0
      ],
      [
        0,
        407
      ],
      [
        -5,
        0
      ]
    ],
    [
      [
        20060,
        68352
      ],
      [
        0,
        184
      ],
      [
        -7,
        13
      ],
      [
        -5,
        15
      ],
      [
        1,
        13
      ],
      [
        7,
        11
      ],
      [
        -4,
        9
      ],
      [
        2,
        20
      ],
      [
        -3,
        11
      ],
      [
        -6,
        -4
      ],
      [
        -1,
        35
      ],
      [
        0,
        20
      ],
      [
        -11,
        -10
      ],
      [
        -10,
        15
      ],
      [
        0,
        9
      ],
      [
        -6,
        0
      ],
      [
        -1,
        6
      ],
      [
        3,
        43
      ],
      [
        -9,
        26
      ],
      [
        -3,
        20
      ],
      [
        -5,
        2
      ],
      [
        -4,
        21
      ]
    ],
    [
      [
        24033,
        70073
      ],
      [
        99,
        -3
      ],
      [
        1,
        101
      ],
      [
        68,
        -3
      ],
      [
        36,
        0
      ],
      [
        0,
        -100
      ]
    ],
    [
      [
        24237,
        70068
      ],
      [
        -1,
        -201
      ],
      [
        0,
        -300
      ]
    ],
    [
      [
        24236,
        69567
      ],
      [
        -35,
        0
      ],
      [
        -103,
        1
      ],
      [
        -29,
        -1
      ]
    ],
    [
      [
        24236,
        69567
      ],
      [
        0,
        -102
      ],
      [
        6,
        -1
      ],
      [
        0,
        -307
      ]
    ],
    [
      [
        21214,
        59429
      ],
      [
        234,
        0
      ]
    ],
    [
      [
        21448,
        58911
      ],
      [
        -244,
        0
      ]
    ],
    [
      [
        28379,
        64310
      ],
      [
        38,
        -19
      ],
      [
        11,
        17
      ],
      [
        5,
        -18
      ],
      [
        9,
        4
      ],
      [
        7,
        -3
      ],
      [
        0,
        -20
      ],
      [
        8,
        0
      ],
      [
        0,
        -20
      ],
      [
        11,
        5
      ],
      [
        6,
        4
      ],
      [
        2,
        -14
      ]
    ],
    [
      [
        28473,
        64234
      ],
      [
        -2,
        0
      ],
      [
        -19,
        -28
      ],
      [
        -5,
        0
      ],
      [
        -17,
        -10
      ],
      [
        -22,
        -16
      ],
      [
        4,
        -26
      ],
      [
        -8,
        -8
      ],
      [
        -10,
        -17
      ],
      [
        -16,
        -23
      ],
      [
        -34,
        -67
      ],
      [
        -9,
        -16
      ],
      [
        -27,
        -56
      ],
      [
        3,
        -27
      ],
      [
        -10,
        -10
      ],
      [
        -9,
        -22
      ],
      [
        -10,
        -30
      ],
      [
        -10,
        -38
      ]
    ],
    [
      [
        28272,
        63840
      ],
      [
        -4,
        -15
      ],
      [
        -5,
        -16
      ]
    ],
    [
      [
        28263,
        63809
      ],
      [
        -1,
        9
      ],
      [
        -13,
        125
      ]
    ],
    [
      [
        28249,
        63943
      ],
      [
        2,
        7
      ],
      [
        7,
        28
      ],
      [
        21,
        70
      ],
      [
        9,
        26
      ],
      [
        0,
        27
      ],
      [
        13,
        32
      ],
      [
        10,
        21
      ],
      [
        9,
        26
      ],
      [
        0,
        32
      ],
      [
        8,
        18
      ],
      [
        28,
        50
      ],
      [
        23,
        30
      ]
    ],
    [
      [
        25526,
        65014
      ],
      [
        0,
        200
      ]
    ],
    [
      [
        25526,
        65214
      ],
      [
        0,
        23
      ],
      [
        1,
        38
      ],
      [
        0,
        216
      ]
    ],
    [
      [
        25527,
        65491
      ],
      [
        1,
        2
      ],
      [
        1,
        -7
      ],
      [
        1,
        -8
      ],
      [
        2,
        -6
      ],
      [
        10,
        -22
      ],
      [
        0,
        -1
      ],
      [
        2,
        6
      ],
      [
        0,
        1
      ],
      [
        4,
        7
      ],
      [
        6,
        7
      ],
      [
        3,
        -2
      ],
      [
        1,
        -5
      ],
      [
        3,
        -8
      ],
      [
        -6,
        -21
      ],
      [
        -4,
        -6
      ],
      [
        2,
        -9
      ],
      [
        2,
        -4
      ],
      [
        4,
        -3
      ],
      [
        4,
        -4
      ],
      [
        1,
        0
      ],
      [
        7,
        -8
      ],
      [
        11,
        -8
      ],
      [
        11,
        -1
      ],
      [
        2,
        -3
      ],
      [
        5,
        1
      ],
      [
        11,
        4
      ]
    ],
    [
      [
        25611,
        65393
      ],
      [
        0,
        -119
      ],
      [
        1,
        -59
      ],
      [
        0,
        -100
      ],
      [
        -1,
        -60
      ],
      [
        1,
        -107
      ]
    ],
    [
      [
        25612,
        64948
      ],
      [
        -2,
        -7
      ],
      [
        -14,
        -20
      ]
    ],
    [
      [
        25596,
        64921
      ],
      [
        -14,
        -38
      ],
      [
        -15,
        -15
      ],
      [
        -4,
        -12
      ],
      [
        -6,
        0
      ],
      [
        -7,
        13
      ],
      [
        -24,
        -9
      ]
    ],
    [
      [
        25526,
        64860
      ],
      [
        0,
        154
      ]
    ],
    [
      [
        28659,
        65105
      ],
      [
        15,
        157
      ],
      [
        2,
        35
      ]
    ],
    [
      [
        28676,
        65297
      ],
      [
        6,
        124
      ],
      [
        23,
        4
      ]
    ],
    [
      [
        28705,
        65425
      ],
      [
        1,
        -9
      ],
      [
        7,
        1
      ],
      [
        85,
        -2
      ],
      [
        4,
        1
      ],
      [
        14,
        -2
      ]
    ],
    [
      [
        28816,
        65414
      ],
      [
        -3,
        -7
      ],
      [
        -13,
        -72
      ],
      [
        -7,
        -59
      ],
      [
        8,
        -23
      ],
      [
        -17,
        -89
      ]
    ],
    [
      [
        28784,
        65164
      ],
      [
        -2,
        -3
      ],
      [
        -10,
        -10
      ],
      [
        -36,
        -37
      ],
      [
        -69,
        -8
      ],
      [
        -8,
        -1
      ]
    ],
    [
      [
        23553,
        62390
      ],
      [
        0,
        81
      ]
    ],
    [
      [
        23553,
        62471
      ],
      [
        3,
        -5
      ],
      [
        5,
        9
      ],
      [
        4,
        7
      ],
      [
        4,
        9
      ],
      [
        4,
        16
      ],
      [
        4,
        5
      ],
      [
        11,
        -4
      ],
      [
        6,
        -29
      ],
      [
        5,
        10
      ],
      [
        12,
        44
      ],
      [
        -2,
        31
      ],
      [
        5,
        0
      ],
      [
        6,
        -35
      ],
      [
        9,
        23
      ],
      [
        6,
        42
      ],
      [
        7,
        20
      ],
      [
        9,
        0
      ],
      [
        12,
        -34
      ]
    ],
    [
      [
        23691,
        62242
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -93
      ]
    ],
    [
      [
        23689,
        62144
      ],
      [
        -41,
        3
      ],
      [
        -1,
        0
      ],
      [
        -29,
        3
      ],
      [
        -7,
        1
      ],
      [
        -25,
        3
      ],
      [
        -11,
        3
      ],
      [
        -22,
        4
      ]
    ],
    [
      [
        23553,
        62161
      ],
      [
        0,
        229
      ]
    ],
    [
      [
        27478,
        64812
      ],
      [
        38,
        2
      ],
      [
        35,
        2
      ],
      [
        0,
        -13
      ],
      [
        31,
        -4
      ],
      [
        14,
        -51
      ]
    ],
    [
      [
        27596,
        64748
      ],
      [
        -1,
        -5
      ],
      [
        -18,
        -76
      ],
      [
        1,
        -73
      ],
      [
        0,
        -59
      ],
      [
        1,
        -37
      ]
    ],
    [
      [
        27478,
        64494
      ],
      [
        0,
        57
      ]
    ],
    [
      [
        27478,
        64551
      ],
      [
        0,
        261
      ]
    ],
    [
      [
        27478,
        65236
      ],
      [
        21,
        -2
      ],
      [
        0,
        6
      ],
      [
        4,
        -6
      ],
      [
        46,
        -5
      ],
      [
        39,
        -3
      ],
      [
        24,
        10
      ],
      [
        11,
        1
      ]
    ],
    [
      [
        27623,
        64867
      ],
      [
        -19,
        -84
      ],
      [
        -8,
        -35
      ]
    ],
    [
      [
        27478,
        64812
      ],
      [
        0,
        10
      ]
    ],
    [
      [
        27478,
        64822
      ],
      [
        0,
        44
      ],
      [
        1,
        44
      ],
      [
        0,
        65
      ],
      [
        -1,
        4
      ],
      [
        1,
        43
      ],
      [
        -1,
        8
      ],
      [
        0,
        206
      ]
    ],
    [
      [
        28651,
        65028
      ],
      [
        8,
        77
      ]
    ],
    [
      [
        28784,
        65164
      ],
      [
        1,
        -38
      ],
      [
        10,
        -19
      ],
      [
        7,
        -14
      ],
      [
        2,
        -6
      ],
      [
        6,
        -15
      ],
      [
        15,
        -10
      ],
      [
        -2,
        -42
      ],
      [
        4,
        -18
      ],
      [
        0,
        -27
      ],
      [
        5,
        -4
      ],
      [
        2,
        -4
      ],
      [
        1,
        -78
      ],
      [
        2,
        -17
      ],
      [
        7,
        -4
      ],
      [
        5,
        -13
      ]
    ],
    [
      [
        28849,
        64855
      ],
      [
        -10,
        -45
      ],
      [
        -4,
        -1
      ]
    ],
    [
      [
        28738,
        64565
      ],
      [
        -8,
        -12
      ],
      [
        -22,
        24
      ],
      [
        -28,
        31
      ]
    ],
    [
      [
        28680,
        64608
      ],
      [
        -6,
        119
      ],
      [
        0,
        101
      ],
      [
        -14,
        -8
      ],
      [
        -11,
        86
      ],
      [
        -1,
        7
      ],
      [
        3,
        115
      ]
    ],
    [
      [
        24456,
        65159
      ],
      [
        -32,
        1
      ]
    ],
    [
      [
        24327,
        65262
      ],
      [
        1,
        104
      ],
      [
        -1,
        304
      ]
    ],
    [
      [
        23974,
        64854
      ],
      [
        0,
        -306
      ]
    ],
    [
      [
        23846,
        64548
      ],
      [
        0,
        306
      ]
    ],
    [
      [
        22202,
        60010
      ],
      [
        14,
        0
      ],
      [
        9,
        1
      ],
      [
        27,
        -1
      ],
      [
        77,
        0
      ]
    ],
    [
      [
        22459,
        59386
      ],
      [
        1,
        -77
      ],
      [
        -6,
        6
      ],
      [
        -11,
        -12
      ],
      [
        -9,
        0
      ],
      [
        -21,
        28
      ],
      [
        -2,
        7
      ],
      [
        -5,
        27
      ],
      [
        -15,
        3
      ],
      [
        -8,
        15
      ],
      [
        -3,
        12
      ],
      [
        -7,
        41
      ],
      [
        -32,
        0
      ]
    ],
    [
      [
        22341,
        59436
      ],
      [
        0,
        108
      ],
      [
        -3,
        1
      ],
      [
        -12,
        47
      ],
      [
        -3,
        2
      ],
      [
        0,
        22
      ],
      [
        -7,
        29
      ],
      [
        1,
        10
      ],
      [
        -5,
        24
      ],
      [
        -6,
        7
      ],
      [
        -4,
        24
      ],
      [
        -8,
        24
      ],
      [
        -3,
        24
      ],
      [
        -8,
        9
      ],
      [
        -6,
        -4
      ],
      [
        -6,
        4
      ],
      [
        -11,
        -7
      ],
      [
        -6,
        6
      ],
      [
        -6,
        19
      ],
      [
        -1,
        15
      ]
    ],
    [
      [
        22247,
        59800
      ],
      [
        -6,
        27
      ],
      [
        1,
        16
      ],
      [
        -17,
        27
      ],
      [
        -6,
        49
      ],
      [
        -7,
        23
      ],
      [
        -6,
        63
      ],
      [
        -4,
        5
      ]
    ],
    [
      [
        22161,
        59536
      ],
      [
        10,
        1
      ],
      [
        76,
        2
      ],
      [
        0,
        261
      ]
    ],
    [
      [
        22341,
        59436
      ],
      [
        -1,
        -302
      ],
      [
        2,
        -19
      ],
      [
        0,
        -81
      ]
    ],
    [
      [
        22342,
        59034
      ],
      [
        -119,
        4
      ]
    ],
    [
      [
        22223,
        59038
      ],
      [
        -60,
        -1
      ],
      [
        1,
        97
      ],
      [
        -3,
        -1
      ],
      [
        0,
        403
      ]
    ],
    [
      [
        20571,
        56922
      ],
      [
        117,
        0
      ]
    ],
    [
      [
        20688,
        56621
      ],
      [
        -1,
        -307
      ],
      [
        1,
        -3
      ],
      [
        0,
        -493
      ],
      [
        2,
        -6
      ],
      [
        0,
        -102
      ],
      [
        -5,
        0
      ],
      [
        -1,
        -99
      ],
      [
        0,
        -95
      ],
      [
        -28,
        -5
      ],
      [
        -19,
        -1
      ],
      [
        -9,
        -2
      ],
      [
        -58,
        0
      ]
    ],
    [
      [
        20275,
        55913
      ],
      [
        0,
        210
      ],
      [
        30,
        0
      ],
      [
        30,
        -12
      ],
      [
        30,
        0
      ],
      [
        0,
        204
      ],
      [
        35,
        0
      ],
      [
        0,
        506
      ]
    ],
    [
      [
        21467,
        71629
      ],
      [
        -14,
        0
      ],
      [
        0,
        34
      ]
    ],
    [
      [
        21453,
        71663
      ],
      [
        0,
        370
      ],
      [
        -17,
        0
      ],
      [
        0,
        177
      ],
      [
        1,
        110
      ]
    ],
    [
      [
        19902,
        55909
      ],
      [
        0,
        390
      ],
      [
        -1,
        16
      ],
      [
        0,
        506
      ],
      [
        -2,
        0
      ],
      [
        0,
        370
      ]
    ],
    [
      [
        25646,
        64158
      ],
      [
        26,
        -1
      ],
      [
        6,
        0
      ],
      [
        10,
        -1
      ],
      [
        21,
        0
      ],
      [
        28,
        1
      ]
    ],
    [
      [
        25737,
        64157
      ],
      [
        21,
        0
      ],
      [
        0,
        -151
      ]
    ],
    [
      [
        25758,
        63752
      ],
      [
        -48,
        1
      ],
      [
        -63,
        0
      ]
    ],
    [
      [
        25647,
        63929
      ],
      [
        0,
        127
      ]
    ],
    [
      [
        25350,
        59856
      ],
      [
        30,
        36
      ],
      [
        13,
        14
      ],
      [
        32,
        58
      ],
      [
        3,
        0
      ]
    ],
    [
      [
        25428,
        59964
      ],
      [
        6,
        -11
      ],
      [
        26,
        28
      ],
      [
        9,
        32
      ]
    ],
    [
      [
        25469,
        60013
      ],
      [
        20,
        -42
      ],
      [
        -3,
        -102
      ],
      [
        -1,
        -73
      ],
      [
        0,
        -70
      ],
      [
        -2,
        -61
      ],
      [
        -4,
        -77
      ]
    ],
    [
      [
        25479,
        59588
      ],
      [
        -14,
        -1
      ],
      [
        -30,
        -3
      ],
      [
        1,
        35
      ],
      [
        -6,
        2
      ],
      [
        -39,
        13
      ],
      [
        -9,
        2
      ],
      [
        -7,
        0
      ]
    ],
    [
      [
        25375,
        59636
      ],
      [
        -3,
        33
      ],
      [
        -9,
        47
      ]
    ],
    [
      [
        25363,
        59716
      ],
      [
        -5,
        70
      ],
      [
        -8,
        70
      ]
    ],
    [
      [
        27774,
        57733
      ],
      [
        0,
        -7
      ],
      [
        4,
        -17
      ],
      [
        4,
        -8
      ],
      [
        3,
        -13
      ],
      [
        6,
        -11
      ],
      [
        5,
        -23
      ],
      [
        7,
        -37
      ],
      [
        -1,
        -13
      ],
      [
        2,
        -12
      ],
      [
        0,
        -41
      ],
      [
        4,
        -40
      ],
      [
        -3,
        -17
      ]
    ],
    [
      [
        27805,
        57494
      ],
      [
        -1,
        0
      ],
      [
        0,
        -9
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        6,
        -62
      ],
      [
        -35,
        -159
      ]
    ],
    [
      [
        27773,
        57252
      ],
      [
        -2,
        6
      ],
      [
        -1,
        2
      ],
      [
        -2,
        9
      ],
      [
        -3,
        10
      ],
      [
        -8,
        28
      ],
      [
        0,
        1
      ],
      [
        -4,
        12
      ],
      [
        -6,
        20
      ],
      [
        -2,
        7
      ],
      [
        -19,
        66
      ],
      [
        -1,
        3
      ],
      [
        -11,
        39
      ],
      [
        -5,
        0
      ]
    ],
    [
      [
        25197,
        61015
      ],
      [
        -123,
        -1
      ]
    ],
    [
      [
        25074,
        61014
      ],
      [
        0,
        103
      ],
      [
        -8,
        0
      ]
    ],
    [
      [
        25066,
        61117
      ],
      [
        4,
        5
      ],
      [
        5,
        36
      ],
      [
        0,
        27
      ],
      [
        3,
        10
      ],
      [
        -1,
        18
      ],
      [
        2,
        23
      ],
      [
        3,
        8
      ],
      [
        1,
        31
      ],
      [
        0,
        12
      ],
      [
        -6,
        9
      ],
      [
        2,
        -1
      ],
      [
        1,
        25
      ]
    ],
    [
      [
        25290,
        61068
      ],
      [
        5,
        1
      ],
      [
        61,
        -2
      ],
      [
        0,
        10
      ],
      [
        13,
        -29
      ]
    ],
    [
      [
        25357,
        60679
      ],
      [
        -5,
        -1
      ],
      [
        -8,
        30
      ],
      [
        -54,
        0
      ]
    ],
    [
      [
        24669,
        62475
      ],
      [
        -3,
        29
      ],
      [
        0,
        24
      ],
      [
        6,
        42
      ],
      [
        -2,
        52
      ],
      [
        -3,
        19
      ],
      [
        2,
        38
      ],
      [
        -2,
        22
      ],
      [
        -3,
        63
      ],
      [
        2,
        35
      ]
    ],
    [
      [
        26900,
        56534
      ],
      [
        10,
        38
      ],
      [
        8,
        30
      ],
      [
        9,
        0
      ],
      [
        4,
        11
      ],
      [
        9,
        -25
      ],
      [
        21,
        -3
      ],
      [
        14,
        8
      ]
    ],
    [
      [
        27053,
        56464
      ],
      [
        -31,
        -28
      ],
      [
        3,
        -31
      ],
      [
        -3,
        -18
      ],
      [
        2,
        -11
      ],
      [
        10,
        -56
      ],
      [
        -3,
        -2
      ],
      [
        -7,
        -45
      ],
      [
        -6,
        -27
      ],
      [
        2,
        -26
      ],
      [
        -5,
        -23
      ],
      [
        5,
        -39
      ],
      [
        6,
        -7
      ],
      [
        -1,
        -9
      ],
      [
        3,
        -3
      ],
      [
        1,
        -17
      ],
      [
        6,
        -5
      ],
      [
        4,
        -25
      ],
      [
        -5,
        -39
      ],
      [
        0,
        -4
      ]
    ],
    [
      [
        27034,
        56049
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -3,
        4
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        4
      ],
      [
        -1,
        6
      ],
      [
        -1,
        3
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        -3,
        2
      ],
      [
        -1,
        3
      ],
      [
        -2,
        6
      ],
      [
        -3,
        11
      ],
      [
        -1,
        19
      ],
      [
        0,
        21
      ],
      [
        -2,
        6
      ],
      [
        -1,
        2
      ],
      [
        0,
        7
      ],
      [
        -2,
        8
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        27005,
        56153
      ],
      [
        -1,
        3
      ],
      [
        -3,
        13
      ],
      [
        -1,
        9
      ],
      [
        0,
        8
      ],
      [
        -1,
        19
      ],
      [
        0,
        5
      ],
      [
        -2,
        13
      ],
      [
        0,
        7
      ],
      [
        -2,
        9
      ],
      [
        -1,
        0
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        4
      ],
      [
        -1,
        1
      ],
      [
        -3,
        5
      ],
      [
        0,
        5
      ],
      [
        -2,
        4
      ],
      [
        -1,
        3
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        11
      ],
      [
        -1,
        3
      ],
      [
        0,
        2
      ],
      [
        -1,
        3
      ],
      [
        -1,
        3
      ],
      [
        -1,
        4
      ],
      [
        -1,
        3
      ],
      [
        -3,
        10
      ],
      [
        -3,
        8
      ],
      [
        -3,
        8
      ],
      [
        -1,
        3
      ],
      [
        -5,
        7
      ],
      [
        -1,
        1
      ],
      [
        0,
        3
      ],
      [
        -2,
        6
      ],
      [
        -1,
        4
      ],
      [
        -2,
        3
      ],
      [
        -1,
        2
      ],
      [
        -2,
        5
      ],
      [
        -1,
        3
      ],
      [
        -1,
        1
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -2,
        2
      ],
      [
        0,
        1
      ],
      [
        -2,
        8
      ],
      [
        -1,
        2
      ],
      [
        -2,
        3
      ],
      [
        -2,
        4
      ],
      [
        -1,
        6
      ],
      [
        -3,
        8
      ],
      [
        -3,
        10
      ],
      [
        -3,
        9
      ],
      [
        -1,
        5
      ],
      [
        -2,
        14
      ],
      [
        -2,
        6
      ],
      [
        -1,
        7
      ],
      [
        -3,
        7
      ],
      [
        -1,
        1
      ],
      [
        -2,
        0
      ],
      [
        -2,
        -3
      ],
      [
        -4,
        3
      ],
      [
        0,
        2
      ],
      [
        -2,
        12
      ]
    ],
    [
      [
        26909,
        56467
      ],
      [
        -1,
        3
      ],
      [
        0,
        12
      ],
      [
        -1,
        2
      ],
      [
        -1,
        4
      ],
      [
        -1,
        4
      ],
      [
        -1,
        3
      ],
      [
        0,
        8
      ],
      [
        1,
        2
      ],
      [
        0,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -2,
        2
      ],
      [
        0,
        2
      ],
      [
        -1,
        3
      ],
      [
        -1,
        11
      ],
      [
        -1,
        5
      ]
    ],
    [
      [
        26828,
        57227
      ],
      [
        -3,
        5
      ],
      [
        -1,
        5
      ],
      [
        3,
        5
      ],
      [
        -1,
        -4
      ],
      [
        1,
        1
      ],
      [
        1,
        -5
      ],
      [
        0,
        4
      ],
      [
        2,
        1
      ]
    ],
    [
      [
        26832,
        57244
      ],
      [
        -4,
        2
      ],
      [
        4,
        23
      ],
      [
        5,
        11
      ],
      [
        -5,
        -2
      ],
      [
        -4,
        20
      ],
      [
        1,
        31
      ],
      [
        -4,
        7
      ],
      [
        3,
        26
      ],
      [
        -5,
        14
      ],
      [
        -8,
        6
      ],
      [
        3,
        22
      ],
      [
        2,
        36
      ],
      [
        -4,
        13
      ],
      [
        0,
        40
      ],
      [
        -2,
        40
      ],
      [
        -1,
        26
      ],
      [
        2,
        10
      ],
      [
        -2,
        19
      ],
      [
        1,
        19
      ],
      [
        -4,
        29
      ],
      [
        1,
        14
      ],
      [
        -7,
        10
      ],
      [
        -1,
        9
      ],
      [
        6,
        32
      ],
      [
        1,
        23
      ],
      [
        6,
        24
      ]
    ],
    [
      [
        28113,
        60814
      ],
      [
        -5,
        2
      ],
      [
        -7,
        16
      ],
      [
        -14,
        12
      ],
      [
        -9,
        18
      ],
      [
        -5,
        3
      ],
      [
        -10,
        7
      ],
      [
        -12,
        23
      ],
      [
        -8,
        43
      ]
    ],
    [
      [
        27451,
        56634
      ],
      [
        0,
        11
      ],
      [
        10,
        -10
      ],
      [
        28,
        80
      ]
    ],
    [
      [
        27474,
        56104
      ],
      [
        -8,
        26
      ],
      [
        0,
        15
      ],
      [
        -7,
        6
      ],
      [
        -7,
        32
      ],
      [
        -4,
        31
      ],
      [
        2,
        5
      ]
    ],
    [
      [
        27450,
        56219
      ],
      [
        4,
        17
      ],
      [
        3,
        34
      ],
      [
        -5,
        32
      ],
      [
        -1,
        29
      ],
      [
        -4,
        16
      ],
      [
        2,
        16
      ],
      [
        2,
        34
      ],
      [
        -5,
        25
      ],
      [
        4,
        19
      ],
      [
        -2,
        18
      ],
      [
        4,
        19
      ],
      [
        -5,
        2
      ],
      [
        -4,
        38
      ],
      [
        6,
        5
      ],
      [
        7,
        41
      ],
      [
        -2,
        22
      ],
      [
        -2,
        -1
      ],
      [
        -6,
        30
      ],
      [
        5,
        19
      ]
    ],
    [
      [
        28593,
        61215
      ],
      [
        1,
        -10
      ],
      [
        6,
        -10
      ],
      [
        7,
        -5
      ],
      [
        1,
        -4
      ],
      [
        1,
        -13
      ],
      [
        9,
        -25
      ],
      [
        4,
        -12
      ],
      [
        6,
        -10
      ],
      [
        9,
        -7
      ],
      [
        5,
        -6
      ],
      [
        21,
        -42
      ],
      [
        9,
        -26
      ],
      [
        -3,
        -31
      ],
      [
        -2,
        -34
      ],
      [
        -4,
        -18
      ],
      [
        -2,
        -6
      ],
      [
        -2,
        0
      ],
      [
        0,
        7
      ],
      [
        -1,
        5
      ],
      [
        -2,
        0
      ],
      [
        -4,
        -12
      ],
      [
        -1,
        -20
      ],
      [
        1,
        -8
      ],
      [
        -1,
        -44
      ],
      [
        2,
        -24
      ],
      [
        -3,
        -11
      ],
      [
        3,
        -19
      ],
      [
        1,
        -10
      ],
      [
        -1,
        -8
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -4
      ]
    ],
    [
      [
        28648,
        60803
      ],
      [
        -7,
        12
      ],
      [
        -4,
        20
      ],
      [
        -4,
        4
      ],
      [
        3,
        19
      ],
      [
        0,
        47
      ],
      [
        -5,
        13
      ],
      [
        -5,
        1
      ],
      [
        -5,
        31
      ],
      [
        -1,
        19
      ],
      [
        -2,
        6
      ],
      [
        -3,
        -7
      ],
      [
        -8,
        0
      ],
      [
        -3,
        17
      ],
      [
        -8,
        2
      ]
    ],
    [
      [
        28561,
        61136
      ],
      [
        5,
        40
      ],
      [
        7,
        3
      ],
      [
        5,
        27
      ],
      [
        15,
        9
      ]
    ],
    [
      [
        26528,
        61748
      ],
      [
        20,
        -42
      ],
      [
        38,
        55
      ],
      [
        22,
        25
      ]
    ],
    [
      [
        26661,
        61619
      ],
      [
        -5,
        -31
      ],
      [
        -3,
        5
      ],
      [
        -5,
        -11
      ],
      [
        1,
        -19
      ],
      [
        2,
        -11
      ],
      [
        -3,
        -10
      ],
      [
        -2,
        -25
      ],
      [
        -2,
        -3
      ],
      [
        2,
        -26
      ],
      [
        -4,
        -2
      ],
      [
        -1,
        -15
      ],
      [
        -9,
        -20
      ],
      [
        -2,
        -24
      ],
      [
        -6,
        2
      ],
      [
        -8,
        -29
      ],
      [
        -6,
        -7
      ]
    ],
    [
      [
        26610,
        61393
      ],
      [
        -3,
        -19
      ],
      [
        -3,
        35
      ],
      [
        -4,
        -5
      ],
      [
        -3,
        20
      ],
      [
        -3,
        -6
      ],
      [
        1,
        29
      ],
      [
        -2,
        11
      ],
      [
        -6,
        10
      ],
      [
        2,
        19
      ],
      [
        -7,
        0
      ],
      [
        3,
        29
      ],
      [
        -5,
        -10
      ],
      [
        -7,
        10
      ],
      [
        -2,
        -9
      ],
      [
        -2,
        11
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        -15
      ],
      [
        -3,
        3
      ],
      [
        -3,
        22
      ],
      [
        -7,
        -5
      ]
    ],
    [
      [
        26514,
        61686
      ],
      [
        -1,
        14
      ],
      [
        15,
        48
      ]
    ],
    [
      [
        26405,
        59099
      ],
      [
        7,
        -2
      ],
      [
        5,
        -8
      ],
      [
        8,
        15
      ],
      [
        18,
        -50
      ],
      [
        1,
        4
      ],
      [
        2,
        40
      ],
      [
        -1,
        33
      ],
      [
        15,
        -5
      ],
      [
        10,
        -8
      ],
      [
        8,
        1
      ],
      [
        2,
        -11
      ],
      [
        9,
        7
      ],
      [
        0,
        25
      ],
      [
        4,
        -2
      ],
      [
        0,
        15
      ],
      [
        4,
        14
      ],
      [
        3,
        31
      ],
      [
        1,
        -6
      ],
      [
        2,
        -29
      ],
      [
        4,
        -2
      ]
    ],
    [
      [
        26507,
        59161
      ],
      [
        -1,
        0
      ],
      [
        11,
        -70
      ],
      [
        8,
        -28
      ]
    ],
    [
      [
        26525,
        59063
      ],
      [
        -10,
        -21
      ],
      [
        -8,
        -37
      ],
      [
        -3,
        -1
      ],
      [
        -4,
        -22
      ],
      [
        -12,
        -39
      ],
      [
        -5,
        -11
      ],
      [
        9,
        -43
      ],
      [
        -3,
        -9
      ],
      [
        -4,
        -14
      ],
      [
        -5,
        -6
      ],
      [
        -13,
        -29
      ],
      [
        -13,
        7
      ],
      [
        -1,
        -18
      ],
      [
        -4,
        -2
      ],
      [
        -2,
        -35
      ],
      [
        -6,
        11
      ],
      [
        2,
        -27
      ],
      [
        -5,
        9
      ],
      [
        -5,
        1
      ],
      [
        5,
        -25
      ],
      [
        -5,
        -10
      ]
    ],
    [
      [
        26433,
        58742
      ],
      [
        -14,
        95
      ],
      [
        -6,
        66
      ]
    ],
    [
      [
        26413,
        58903
      ],
      [
        -10,
        54
      ],
      [
        -11,
        16
      ],
      [
        -3,
        27
      ],
      [
        -6,
        11
      ],
      [
        3,
        26
      ]
    ],
    [
      [
        18425,
        72968
      ],
      [
        32,
        0
      ],
      [
        201,
        -1
      ],
      [
        0,
        -50
      ],
      [
        36,
        -1
      ],
      [
        0,
        -51
      ],
      [
        18,
        0
      ],
      [
        0,
        -68
      ],
      [
        54,
        0
      ],
      [
        35,
        3
      ],
      [
        71,
        0
      ]
    ],
    [
      [
        18872,
        72800
      ],
      [
        0,
        -336
      ]
    ],
    [
      [
        18872,
        72464
      ],
      [
        -66,
        -1
      ],
      [
        -5,
        0
      ],
      [
        0,
        -100
      ],
      [
        -72,
        0
      ],
      [
        0,
        -124
      ],
      [
        -11,
        -1
      ],
      [
        -10,
        4
      ],
      [
        -8,
        12
      ],
      [
        -6,
        -2
      ]
    ],
    [
      [
        20458,
        60006
      ],
      [
        15,
        0
      ],
      [
        10,
        -1
      ],
      [
        26,
        1
      ],
      [
        32,
        0
      ],
      [
        47,
        -1
      ],
      [
        8,
        0
      ]
    ],
    [
      [
        20596,
        60005
      ],
      [
        -4,
        -16
      ],
      [
        0,
        -22
      ],
      [
        7,
        -50
      ],
      [
        3,
        -5
      ],
      [
        -8,
        -79
      ],
      [
        2,
        -16
      ],
      [
        -3,
        -25
      ],
      [
        2,
        -9
      ],
      [
        -3,
        -16
      ],
      [
        3,
        -23
      ],
      [
        0,
        -43
      ],
      [
        -1,
        -12
      ],
      [
        -6,
        -8
      ],
      [
        -8,
        2
      ],
      [
        -3,
        11
      ],
      [
        -6,
        -6
      ],
      [
        -4,
        -29
      ],
      [
        -2,
        5
      ],
      [
        -5,
        -6
      ],
      [
        -5,
        -19
      ],
      [
        3,
        -21
      ],
      [
        -2,
        -10
      ],
      [
        4,
        -20
      ],
      [
        -3,
        -9
      ],
      [
        -4,
        -24
      ],
      [
        5,
        -22
      ],
      [
        2,
        -33
      ],
      [
        -7,
        -11
      ],
      [
        8,
        -22
      ],
      [
        1,
        -26
      ],
      [
        7,
        -22
      ],
      [
        -5,
        -10
      ],
      [
        -1,
        -15
      ],
      [
        -4,
        -21
      ],
      [
        1,
        -11
      ],
      [
        4,
        2
      ],
      [
        1,
        -18
      ],
      [
        -2,
        -15
      ],
      [
        4,
        -13
      ],
      [
        0,
        -29
      ],
      [
        -2,
        -15
      ],
      [
        1,
        -35
      ],
      [
        -2,
        -42
      ],
      [
        3,
        -28
      ],
      [
        -4,
        -18
      ]
    ],
    [
      [
        20563,
        59151
      ],
      [
        -13,
        -10
      ],
      [
        -6,
        -19
      ],
      [
        4,
        -24
      ],
      [
        -1,
        -29
      ],
      [
        -7,
        -25
      ],
      [
        2,
        -15
      ],
      [
        -1,
        -29
      ],
      [
        -12,
        -62
      ],
      [
        -7,
        -48
      ],
      [
        -5,
        -19
      ],
      [
        -7,
        -9
      ]
    ],
    [
      [
        26048,
        65010
      ],
      [
        1,
        -34
      ],
      [
        -1,
        -102
      ],
      [
        -9,
        0
      ],
      [
        0,
        -153
      ]
    ],
    [
      [
        21494,
        70549
      ],
      [
        2,
        -7
      ],
      [
        7,
        3
      ],
      [
        8,
        19
      ],
      [
        12,
        -11
      ],
      [
        0,
        15
      ],
      [
        6,
        -7
      ],
      [
        7,
        11
      ],
      [
        2,
        -51
      ],
      [
        4,
        9
      ],
      [
        7,
        -10
      ],
      [
        6,
        12
      ],
      [
        4,
        -9
      ],
      [
        3,
        13
      ],
      [
        2,
        -16
      ],
      [
        3,
        11
      ],
      [
        5,
        -17
      ],
      [
        16,
        -13
      ],
      [
        5,
        5
      ],
      [
        2,
        25
      ],
      [
        4,
        -1
      ],
      [
        3,
        -21
      ],
      [
        5,
        -11
      ],
      [
        5,
        18
      ],
      [
        6,
        -21
      ],
      [
        7,
        12
      ],
      [
        -2,
        16
      ],
      [
        11,
        -9
      ],
      [
        3,
        6
      ],
      [
        -3,
        16
      ],
      [
        2,
        10
      ],
      [
        9,
        -1
      ],
      [
        8,
        13
      ],
      [
        4,
        -3
      ],
      [
        2,
        14
      ],
      [
        6,
        10
      ],
      [
        6,
        -10
      ],
      [
        7,
        13
      ],
      [
        -1,
        9
      ],
      [
        12,
        18
      ],
      [
        1,
        16
      ],
      [
        -4,
        8
      ],
      [
        2,
        9
      ],
      [
        10,
        -3
      ],
      [
        6,
        14
      ],
      [
        5,
        -6
      ],
      [
        4,
        22
      ],
      [
        6,
        -9
      ],
      [
        -2,
        41
      ],
      [
        8,
        9
      ],
      [
        1,
        12
      ],
      [
        6,
        2
      ],
      [
        12,
        31
      ],
      [
        -4,
        17
      ],
      [
        7,
        15
      ],
      [
        1,
        21
      ],
      [
        8,
        -6
      ],
      [
        4,
        13
      ],
      [
        5,
        3
      ]
    ],
    [
      [
        21887,
        70985
      ],
      [
        8,
        -54
      ],
      [
        2,
        -21
      ],
      [
        1,
        -40
      ],
      [
        -3,
        -24
      ],
      [
        -6,
        -31
      ],
      [
        0,
        -11
      ],
      [
        6,
        -26
      ],
      [
        0,
        -17
      ],
      [
        -4,
        -30
      ],
      [
        -5,
        -15
      ],
      [
        -6,
        -31
      ],
      [
        -4,
        -28
      ],
      [
        0,
        -22
      ],
      [
        3,
        -13
      ],
      [
        1,
        -51
      ],
      [
        4,
        -26
      ],
      [
        11,
        -48
      ],
      [
        7,
        -9
      ],
      [
        8,
        -40
      ],
      [
        -2,
        -27
      ]
    ],
    [
      [
        21908,
        70421
      ],
      [
        -38,
        0
      ],
      [
        -20,
        1
      ],
      [
        -8,
        -1
      ],
      [
        -3,
        1
      ],
      [
        -345,
        0
      ]
    ],
    [
      [
        21494,
        70422
      ],
      [
        0,
        127
      ]
    ],
    [
      [
        26148,
        59575
      ],
      [
        1,
        1
      ],
      [
        4,
        0
      ]
    ],
    [
      [
        26153,
        59576
      ],
      [
        0,
        -47
      ],
      [
        3,
        -15
      ],
      [
        -5,
        -49
      ]
    ],
    [
      [
        26151,
        59465
      ],
      [
        -4,
        -11
      ],
      [
        -11,
        7
      ],
      [
        -15,
        -26
      ],
      [
        2,
        -20
      ],
      [
        -5,
        3
      ],
      [
        3,
        16
      ],
      [
        -15,
        -8
      ],
      [
        -10,
        -51
      ],
      [
        -4,
        -59
      ]
    ],
    [
      [
        26092,
        59316
      ],
      [
        -3,
        5
      ],
      [
        -7,
        35
      ],
      [
        -8,
        26
      ],
      [
        -1,
        18
      ],
      [
        -3,
        -5
      ],
      [
        -26,
        29
      ],
      [
        -8,
        0
      ],
      [
        -2,
        30
      ],
      [
        -9,
        -4
      ],
      [
        6,
        -24
      ],
      [
        -11,
        1
      ],
      [
        -4,
        21
      ],
      [
        -13,
        -20
      ]
    ],
    [
      [
        26003,
        59428
      ],
      [
        5,
        133
      ],
      [
        2,
        9
      ]
    ],
    [
      [
        23711,
        55701
      ],
      [
        0,
        -324
      ]
    ],
    [
      [
        23711,
        55377
      ],
      [
        0,
        -161
      ]
    ],
    [
      [
        23711,
        55216
      ],
      [
        -2,
        0
      ],
      [
        -169,
        -2
      ]
    ],
    [
      [
        23540,
        55214
      ],
      [
        1,
        453
      ]
    ],
    [
      [
        30177,
        69643
      ],
      [
        15,
        -299
      ],
      [
        -12,
        -5
      ],
      [
        5,
        -103
      ],
      [
        2,
        1
      ],
      [
        7,
        -101
      ],
      [
        1,
        -125
      ],
      [
        43,
        74
      ],
      [
        14,
        -96
      ],
      [
        15,
        -100
      ],
      [
        -11,
        -19
      ],
      [
        56,
        -36
      ],
      [
        19,
        -12
      ],
      [
        -8,
        -37
      ],
      [
        5,
        3
      ],
      [
        3,
        -41
      ],
      [
        8,
        -2
      ],
      [
        4,
        -52
      ]
    ],
    [
      [
        30275,
        68196
      ],
      [
        -6,
        12
      ],
      [
        -2,
        -1
      ],
      [
        -9,
        -42
      ],
      [
        -6,
        23
      ],
      [
        -5,
        -8
      ],
      [
        -4,
        16
      ],
      [
        -4,
        45
      ],
      [
        1,
        36
      ],
      [
        6,
        26
      ],
      [
        -6,
        36
      ],
      [
        -2,
        8
      ],
      [
        -3,
        11
      ],
      [
        -20,
        -43
      ],
      [
        -35,
        -66
      ],
      [
        -10,
        21
      ],
      [
        -2,
        -18
      ],
      [
        5,
        -35
      ],
      [
        15,
        -11
      ],
      [
        22,
        -92
      ],
      [
        -9,
        -18
      ],
      [
        5,
        -21
      ],
      [
        -8,
        -25
      ],
      [
        1,
        -20
      ],
      [
        3,
        -4
      ],
      [
        -6,
        -17
      ],
      [
        -9,
        -9
      ],
      [
        1,
        -33
      ],
      [
        3,
        -24
      ]
    ],
    [
      [
        30134,
        67917
      ],
      [
        -1,
        55
      ],
      [
        0,
        89
      ],
      [
        -2,
        146
      ],
      [
        -1,
        60
      ],
      [
        0,
        21
      ],
      [
        -2,
        157
      ],
      [
        0,
        46
      ]
    ],
    [
      [
        30107,
        69679
      ],
      [
        2,
        0
      ],
      [
        1,
        2
      ],
      [
        2,
        4
      ],
      [
        2,
        3
      ],
      [
        5,
        -1
      ],
      [
        1,
        -1
      ],
      [
        2,
        1
      ],
      [
        2,
        2
      ],
      [
        3,
        3
      ],
      [
        1,
        2
      ],
      [
        2,
        11
      ],
      [
        -1,
        4
      ],
      [
        -2,
        4
      ],
      [
        0,
        11
      ],
      [
        1,
        3
      ],
      [
        1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        3,
        -6
      ],
      [
        0,
        -3
      ],
      [
        1,
        -1
      ],
      [
        1,
        -3
      ],
      [
        5,
        0
      ],
      [
        4,
        2
      ],
      [
        1,
        -3
      ],
      [
        1,
        -9
      ],
      [
        1,
        -4
      ],
      [
        3,
        -2
      ],
      [
        2,
        -6
      ],
      [
        1,
        -2
      ],
      [
        2,
        -18
      ],
      [
        0,
        -4
      ],
      [
        -2,
        -7
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -7
      ],
      [
        2,
        -5
      ],
      [
        2,
        -7
      ],
      [
        3,
        -12
      ],
      [
        0,
        -19
      ],
      [
        1,
        -4
      ],
      [
        3,
        -5
      ],
      [
        1,
        -2
      ],
      [
        6,
        -4
      ],
      [
        4,
        6
      ],
      [
        1,
        3
      ],
      [
        0,
        2
      ],
      [
        -2,
        7
      ],
      [
        0,
        21
      ],
      [
        1,
        3
      ],
      [
        1,
        2
      ],
      [
        0,
        2
      ],
      [
        2,
        7
      ]
    ],
    [
      [
        26610,
        61393
      ],
      [
        5,
        -14
      ],
      [
        1,
        13
      ],
      [
        6,
        -21
      ],
      [
        -6,
        -9
      ],
      [
        -2,
        -14
      ],
      [
        5,
        -29
      ],
      [
        5,
        25
      ],
      [
        4,
        2
      ],
      [
        6,
        -18
      ],
      [
        -1,
        -23
      ],
      [
        8,
        8
      ],
      [
        3,
        -13
      ],
      [
        -6,
        -15
      ],
      [
        6,
        -30
      ],
      [
        2,
        21
      ],
      [
        12,
        -9
      ],
      [
        -1,
        -16
      ],
      [
        -4,
        4
      ],
      [
        -5,
        -22
      ]
    ],
    [
      [
        26648,
        61233
      ],
      [
        0,
        -1
      ],
      [
        -21,
        11
      ],
      [
        1,
        -41
      ],
      [
        -3,
        -14
      ],
      [
        -6,
        3
      ],
      [
        -2,
        -8
      ],
      [
        -7,
        23
      ],
      [
        -6,
        1
      ],
      [
        -9,
        -18
      ],
      [
        -4,
        0
      ],
      [
        -4,
        -11
      ],
      [
        -3,
        9
      ],
      [
        -8,
        -14
      ]
    ],
    [
      [
        26576,
        61173
      ],
      [
        0,
        9
      ],
      [
        -12,
        41
      ],
      [
        -5,
        46
      ],
      [
        -17,
        64
      ],
      [
        -26,
        26
      ],
      [
        2,
        14
      ],
      [
        -4,
        7
      ],
      [
        1,
        18
      ]
    ],
    [
      [
        27604,
        58271
      ],
      [
        -32,
        -2
      ]
    ],
    [
      [
        27572,
        58269
      ],
      [
        -7,
        56
      ],
      [
        0,
        33
      ],
      [
        -6,
        18
      ],
      [
        -6,
        27
      ],
      [
        -4,
        14
      ],
      [
        -5,
        3
      ],
      [
        -7,
        39
      ],
      [
        -6,
        13
      ],
      [
        1,
        28
      ],
      [
        -2,
        21
      ],
      [
        -11,
        -4
      ],
      [
        -5,
        6
      ],
      [
        -1,
        3
      ],
      [
        -8,
        1
      ],
      [
        -9,
        11
      ],
      [
        -1,
        9
      ]
    ],
    [
      [
        27495,
        58547
      ],
      [
        3,
        27
      ],
      [
        -8,
        27
      ],
      [
        4,
        18
      ],
      [
        -3,
        24
      ],
      [
        -4,
        9
      ],
      [
        3,
        12
      ],
      [
        4,
        -19
      ],
      [
        5,
        11
      ],
      [
        4,
        -8
      ],
      [
        2,
        26
      ],
      [
        7,
        -12
      ],
      [
        4,
        15
      ],
      [
        -2,
        18
      ],
      [
        -7,
        12
      ],
      [
        2,
        13
      ],
      [
        11,
        -7
      ],
      [
        1,
        10
      ],
      [
        -2,
        21
      ],
      [
        1,
        19
      ],
      [
        -2,
        15
      ],
      [
        0,
        24
      ],
      [
        -5,
        13
      ]
    ],
    [
      [
        30441,
        67899
      ],
      [
        -5,
        -5
      ],
      [
        -3,
        3
      ],
      [
        -4,
        6
      ],
      [
        -6,
        -17
      ],
      [
        -1,
        4
      ],
      [
        -1,
        -1
      ],
      [
        -4,
        -20
      ],
      [
        -3,
        -8
      ],
      [
        -3,
        -22
      ],
      [
        -2,
        -17
      ],
      [
        -10,
        2
      ],
      [
        -3,
        9
      ],
      [
        -5,
        -5
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -8
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -19
      ],
      [
        -2,
        -11
      ],
      [
        -5,
        13
      ],
      [
        -10,
        -2
      ],
      [
        -5,
        -7
      ],
      [
        -1,
        -9
      ],
      [
        -1,
        -9
      ],
      [
        -4,
        -17
      ],
      [
        -4,
        -14
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -32
      ],
      [
        0,
        -7
      ],
      [
        4,
        -4
      ],
      [
        1,
        -25
      ],
      [
        -2,
        -9
      ],
      [
        -3,
        -1
      ],
      [
        -3,
        -22
      ],
      [
        -5,
        2
      ],
      [
        0,
        14
      ],
      [
        -5,
        2
      ],
      [
        -2,
        9
      ],
      [
        -1,
        2
      ],
      [
        -1,
        -3
      ],
      [
        -9,
        -19
      ],
      [
        0,
        -18
      ],
      [
        -3,
        -1
      ],
      [
        -2,
        15
      ],
      [
        -7,
        -5
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        23619,
        68467
      ],
      [
        10,
        -9
      ],
      [
        5,
        -16
      ],
      [
        8,
        -4
      ],
      [
        5,
        -18
      ],
      [
        4,
        -1
      ],
      [
        1,
        -9
      ],
      [
        10,
        -2
      ],
      [
        1,
        -15
      ],
      [
        17,
        -11
      ],
      [
        3,
        2
      ],
      [
        8,
        -14
      ],
      [
        1,
        -10
      ],
      [
        10,
        -17
      ],
      [
        3,
        5
      ],
      [
        5,
        -9
      ],
      [
        12,
        17
      ],
      [
        -6,
        61
      ],
      [
        3,
        21
      ]
    ],
    [
      [
        28480,
        59670
      ],
      [
        3,
        17
      ],
      [
        -1,
        13
      ],
      [
        4,
        7
      ],
      [
        0,
        21
      ],
      [
        5,
        10
      ],
      [
        0,
        18
      ],
      [
        5,
        8
      ],
      [
        -1,
        23
      ],
      [
        5,
        51
      ],
      [
        10,
        33
      ],
      [
        -3,
        7
      ],
      [
        3,
        23
      ],
      [
        -5,
        19
      ],
      [
        -7,
        39
      ],
      [
        3,
        47
      ]
    ],
    [
      [
        28501,
        60006
      ],
      [
        33,
        60
      ],
      [
        9,
        13
      ],
      [
        4,
        34
      ],
      [
        1,
        44
      ],
      [
        2,
        19
      ]
    ],
    [
      [
        28550,
        60176
      ],
      [
        2,
        -5
      ],
      [
        2,
        -33
      ],
      [
        0,
        -15
      ],
      [
        -3,
        -24
      ],
      [
        0,
        -24
      ],
      [
        2,
        -11
      ],
      [
        2,
        -8
      ],
      [
        3,
        -3
      ],
      [
        9,
        -1
      ],
      [
        7,
        -8
      ],
      [
        3,
        -7
      ],
      [
        4,
        -22
      ],
      [
        3,
        -6
      ],
      [
        7,
        -17
      ],
      [
        1,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -6
      ],
      [
        2,
        -6
      ],
      [
        4,
        -3
      ],
      [
        4,
        -15
      ],
      [
        1,
        -27
      ]
    ],
    [
      [
        28603,
        59928
      ],
      [
        -5,
        -18
      ],
      [
        -6,
        -9
      ],
      [
        -2,
        12
      ],
      [
        -15,
        -43
      ],
      [
        -30,
        -97
      ],
      [
        -16,
        -51
      ],
      [
        -18,
        -53
      ],
      [
        -13,
        -42
      ],
      [
        -11,
        -31
      ]
    ],
    [
      [
        28487,
        59596
      ],
      [
        -3,
        5
      ]
    ],
    [
      [
        19531,
        66138
      ],
      [
        168,
        -1
      ],
      [
        256,
        -2
      ]
    ],
    [
      [
        19955,
        66135
      ],
      [
        0,
        -202
      ],
      [
        5,
        0
      ],
      [
        -1,
        -404
      ],
      [
        0,
        -97
      ],
      [
        -117,
        -4
      ],
      [
        0,
        -297
      ],
      [
        3,
        0
      ],
      [
        0,
        -462
      ]
    ],
    [
      [
        19845,
        64669
      ],
      [
        -36,
        0
      ],
      [
        -37,
        -2
      ],
      [
        -89,
        0
      ],
      [
        -8,
        -1
      ],
      [
        -29,
        1
      ],
      [
        -116,
        0
      ]
    ],
    [
      [
        19251,
        64664
      ],
      [
        1,
        676
      ]
    ],
    [
      [
        17928,
        71964
      ],
      [
        0,
        -34
      ],
      [
        6,
        1
      ],
      [
        0,
        -17
      ],
      [
        18,
        0
      ],
      [
        0,
        -51
      ],
      [
        6,
        0
      ],
      [
        0,
        -17
      ],
      [
        11,
        0
      ],
      [
        0,
        -34
      ],
      [
        6,
        0
      ],
      [
        0,
        -17
      ],
      [
        12,
        0
      ],
      [
        0,
        -34
      ],
      [
        6,
        0
      ],
      [
        0,
        -31
      ],
      [
        23,
        0
      ],
      [
        0,
        -52
      ],
      [
        18,
        0
      ],
      [
        0,
        -17
      ],
      [
        -9,
        0
      ],
      [
        0,
        -18
      ],
      [
        -10,
        7
      ],
      [
        -5,
        12
      ],
      [
        -6,
        0
      ],
      [
        0,
        -20
      ],
      [
        -6,
        0
      ],
      [
        0,
        -34
      ],
      [
        -5,
        0
      ],
      [
        0,
        -151
      ],
      [
        5,
        0
      ],
      [
        -1,
        -100
      ],
      [
        -35,
        0
      ],
      [
        0,
        -12
      ]
    ],
    [
      [
        17962,
        71345
      ],
      [
        -6,
        4
      ],
      [
        -3,
        -27
      ],
      [
        -1,
        -3
      ],
      [
        -4,
        0
      ],
      [
        -4,
        -3
      ],
      [
        -2,
        -11
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -4,
        -1
      ],
      [
        -6,
        17
      ],
      [
        0,
        3
      ],
      [
        2,
        19
      ],
      [
        2,
        2
      ],
      [
        2,
        8
      ],
      [
        0,
        23
      ],
      [
        -7,
        23
      ],
      [
        -5,
        5
      ],
      [
        -2,
        -2
      ],
      [
        -4,
        2
      ],
      [
        -1,
        10
      ],
      [
        -3,
        4
      ],
      [
        -3,
        8
      ],
      [
        -1,
        4
      ],
      [
        -1,
        8
      ],
      [
        0,
        2
      ],
      [
        -5,
        -2
      ],
      [
        -2,
        -4
      ],
      [
        -3,
        6
      ],
      [
        -2,
        11
      ],
      [
        -4,
        6
      ],
      [
        -2,
        9
      ],
      [
        0,
        9
      ],
      [
        1,
        5
      ],
      [
        -1,
        8
      ],
      [
        -4,
        2
      ],
      [
        -1,
        3
      ],
      [
        1,
        10
      ],
      [
        1,
        2
      ],
      [
        2,
        9
      ],
      [
        0,
        6
      ],
      [
        -2,
        18
      ],
      [
        1,
        5
      ],
      [
        2,
        9
      ],
      [
        0,
        5
      ],
      [
        -1,
        7
      ],
      [
        -8,
        12
      ],
      [
        -1,
        3
      ]
    ],
    [
      [
        28338,
        62082
      ],
      [
        2,
        -30
      ],
      [
        -9,
        22
      ]
    ],
    [
      [
        28331,
        62074
      ],
      [
        -4,
        10
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        28326,
        62084
      ],
      [
        -1,
        1
      ],
      [
        2,
        7
      ],
      [
        8,
        -21
      ],
      [
        1,
        15
      ],
      [
        2,
        -4
      ]
    ],
    [
      [
        24897,
        67741
      ],
      [
        10,
        1
      ],
      [
        8,
        1
      ],
      [
        34,
        0
      ]
    ],
    [
      [
        25113,
        67326
      ],
      [
        -66,
        -3
      ],
      [
        -33,
        -1
      ],
      [
        0,
        15
      ],
      [
        -33,
        0
      ],
      [
        -27,
        -1
      ],
      [
        -39,
        0
      ]
    ],
    [
      [
        24915,
        67336
      ],
      [
        -2,
        10
      ],
      [
        2,
        21
      ],
      [
        5,
        12
      ],
      [
        7,
        36
      ],
      [
        6,
        -1
      ],
      [
        11,
        12
      ],
      [
        4,
        12
      ],
      [
        1,
        206
      ],
      [
        -5,
        9
      ],
      [
        -7,
        -3
      ],
      [
        -9,
        8
      ],
      [
        -9,
        -3
      ],
      [
        -7,
        5
      ],
      [
        -1,
        11
      ],
      [
        5,
        19
      ],
      [
        -12,
        8
      ],
      [
        0,
        -1
      ],
      [
        -4,
        11
      ],
      [
        -3,
        33
      ]
    ],
    [
      [
        31401,
        38459
      ],
      [
        5,
        3
      ],
      [
        3,
        1
      ],
      [
        5,
        0
      ],
      [
        4,
        -2
      ],
      [
        2,
        0
      ],
      [
        6,
        -2
      ]
    ],
    [
      [
        31400,
        38325
      ],
      [
        -2,
        19
      ],
      [
        3,
        27
      ],
      [
        0,
        88
      ]
    ],
    [
      [
        21641,
        69873
      ],
      [
        315,
        0
      ]
    ],
    [
      [
        21956,
        69873
      ],
      [
        3,
        -33
      ],
      [
        9,
        -37
      ],
      [
        7,
        -36
      ],
      [
        -3,
        -30
      ],
      [
        -7,
        -27
      ],
      [
        -2,
        -17
      ],
      [
        2,
        -30
      ],
      [
        11,
        -36
      ],
      [
        2,
        -17
      ]
    ],
    [
      [
        21938,
        69204
      ],
      [
        3,
        -27
      ],
      [
        -2,
        -21
      ],
      [
        -5,
        -15
      ],
      [
        -15,
        -32
      ],
      [
        -11,
        -36
      ],
      [
        -5,
        -22
      ],
      [
        -3,
        -6
      ],
      [
        -19,
        10
      ],
      [
        -9,
        26
      ],
      [
        -9,
        36
      ],
      [
        -8,
        6
      ],
      [
        -3,
        -8
      ],
      [
        -4,
        -39
      ],
      [
        3,
        -20
      ]
    ],
    [
      [
        21851,
        69056
      ],
      [
        -5,
        -8
      ],
      [
        0,
        12
      ],
      [
        -5,
        -2
      ],
      [
        0,
        -14
      ],
      [
        -4,
        -3
      ],
      [
        -3,
        17
      ],
      [
        -6,
        -10
      ],
      [
        -8,
        23
      ],
      [
        -7,
        -3
      ],
      [
        -9,
        -13
      ],
      [
        -7,
        16
      ],
      [
        -2,
        -16
      ],
      [
        -6,
        -8
      ],
      [
        -4,
        3
      ],
      [
        0,
        -12
      ],
      [
        -6,
        -4
      ],
      [
        -3,
        -23
      ],
      [
        -2,
        8
      ],
      [
        -8,
        -17
      ],
      [
        -9,
        18
      ],
      [
        -8,
        -2
      ],
      [
        -15,
        11
      ]
    ],
    [
      [
        21734,
        69029
      ],
      [
        0,
        287
      ],
      [
        -101,
        0
      ],
      [
        0,
        52
      ],
      [
        4,
        0
      ],
      [
        0,
        404
      ],
      [
        4,
        0
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        27173,
        55464
      ],
      [
        20,
        74
      ],
      [
        25,
        -27
      ],
      [
        25,
        -31
      ],
      [
        11,
        0
      ],
      [
        17,
        3
      ],
      [
        15,
        12
      ],
      [
        5,
        -3
      ]
    ],
    [
      [
        27230,
        55057
      ],
      [
        0,
        3
      ],
      [
        -1,
        1
      ],
      [
        0,
        3
      ],
      [
        -1,
        2
      ],
      [
        0,
        3
      ],
      [
        1,
        3
      ],
      [
        -1,
        3
      ],
      [
        0,
        3
      ],
      [
        -1,
        3
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        6
      ],
      [
        1,
        0
      ],
      [
        0,
        7
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        5
      ],
      [
        1,
        3
      ],
      [
        0,
        24
      ],
      [
        2,
        3
      ],
      [
        0,
        6
      ],
      [
        -1,
        15
      ],
      [
        0,
        4
      ],
      [
        -1,
        7
      ],
      [
        -5,
        11
      ],
      [
        0,
        1
      ],
      [
        -2,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        0
      ],
      [
        0,
        2
      ],
      [
        -1,
        5
      ],
      [
        1,
        7
      ],
      [
        1,
        10
      ],
      [
        -1,
        5
      ],
      [
        0,
        2
      ],
      [
        -4,
        3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        4
      ],
      [
        1,
        7
      ],
      [
        1,
        4
      ],
      [
        2,
        6
      ],
      [
        0,
        5
      ],
      [
        -1,
        1
      ],
      [
        -3,
        5
      ],
      [
        0,
        9
      ],
      [
        -1,
        10
      ],
      [
        -3,
        12
      ],
      [
        -2,
        1
      ],
      [
        -1,
        3
      ],
      [
        0,
        4
      ],
      [
        1,
        6
      ],
      [
        0,
        1
      ],
      [
        -1,
        4
      ],
      [
        -1,
        3
      ],
      [
        0,
        13
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        0,
        2
      ],
      [
        2,
        17
      ],
      [
        1,
        19
      ],
      [
        0,
        15
      ],
      [
        -1,
        1
      ],
      [
        -2,
        7
      ],
      [
        -3,
        15
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        -6,
        12
      ],
      [
        0,
        1
      ],
      [
        -1,
        5
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        27193,
        55407
      ],
      [
        0,
        2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        0,
        10
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -2,
        6
      ],
      [
        0,
        4
      ],
      [
        -1,
        5
      ],
      [
        -2,
        5
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        4
      ],
      [
        1,
        2
      ],
      [
        0,
        3
      ],
      [
        -1,
        3
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -4
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        6
      ],
      [
        -1,
        3
      ],
      [
        0,
        2
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        26741,
        59057
      ],
      [
        7,
        8
      ],
      [
        8,
        38
      ],
      [
        8,
        25
      ]
    ],
    [
      [
        26900,
        58958
      ],
      [
        5,
        -20
      ],
      [
        -7,
        -45
      ]
    ],
    [
      [
        26898,
        58893
      ],
      [
        -1,
        1
      ],
      [
        -1,
        5
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        8
      ],
      [
        -1,
        3
      ],
      [
        -2,
        7
      ],
      [
        -1,
        4
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        -5
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        -3,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -1
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -5,
        -14
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -7
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -11
      ],
      [
        1,
        -4
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -8
      ],
      [
        -3,
        -10
      ],
      [
        -2,
        -7
      ],
      [
        0,
        -3
      ],
      [
        1,
        -6
      ],
      [
        0,
        -3
      ],
      [
        -2,
        0
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        0,
        1
      ],
      [
        -1,
        9
      ],
      [
        -1,
        3
      ],
      [
        -1,
        3
      ],
      [
        -2,
        6
      ],
      [
        -1,
        2
      ],
      [
        -2,
        7
      ],
      [
        -1,
        1
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        4
      ],
      [
        -2,
        2
      ],
      [
        -2,
        -4
      ],
      [
        -3,
        -4
      ],
      [
        -1,
        -1
      ]
    ],
    [
      [
        26646,
        60285
      ],
      [
        -6,
        -5
      ],
      [
        7,
        -32
      ],
      [
        -13,
        -43
      ],
      [
        0,
        -56
      ],
      [
        4,
        -19
      ],
      [
        -5,
        -27
      ],
      [
        4,
        -11
      ],
      [
        0,
        -23
      ],
      [
        4,
        -34
      ],
      [
        4,
        -20
      ],
      [
        -3,
        -6
      ],
      [
        3,
        -70
      ]
    ],
    [
      [
        26645,
        59939
      ],
      [
        -3,
        -1
      ],
      [
        -19,
        21
      ]
    ],
    [
      [
        26545,
        60074
      ],
      [
        -5,
        23
      ],
      [
        7,
        20
      ],
      [
        -1,
        14
      ],
      [
        -5,
        6
      ],
      [
        0,
        12
      ],
      [
        -6,
        -10
      ],
      [
        -6,
        3
      ],
      [
        -5,
        42
      ],
      [
        -7,
        23
      ],
      [
        6,
        26
      ],
      [
        2,
        18
      ],
      [
        -1,
        51
      ]
    ],
    [
      [
        25294,
        60482
      ],
      [
        3,
        7
      ],
      [
        4,
        19
      ],
      [
        1,
        2
      ],
      [
        3,
        6
      ],
      [
        1,
        2
      ],
      [
        1,
        5
      ],
      [
        4,
        8
      ],
      [
        5,
        6
      ],
      [
        7,
        5
      ],
      [
        5,
        0
      ],
      [
        4,
        1
      ],
      [
        5,
        3
      ],
      [
        5,
        2
      ],
      [
        3,
        2
      ],
      [
        1,
        2
      ],
      [
        4,
        2
      ],
      [
        7,
        5
      ],
      [
        2,
        -1
      ],
      [
        5,
        2
      ],
      [
        4,
        1
      ],
      [
        1,
        0
      ],
      [
        0,
        -2
      ],
      [
        1,
        0
      ],
      [
        1,
        2
      ],
      [
        1,
        8
      ],
      [
        2,
        4
      ],
      [
        1,
        -2
      ],
      [
        1,
        3
      ],
      [
        1,
        4
      ],
      [
        0,
        2
      ],
      [
        -1,
        3
      ],
      [
        1,
        5
      ],
      [
        0,
        11
      ]
    ],
    [
      [
        25413,
        60569
      ],
      [
        -3,
        -17
      ],
      [
        2,
        -31
      ],
      [
        -1,
        -15
      ],
      [
        3,
        -19
      ],
      [
        2,
        2
      ],
      [
        5,
        -15
      ],
      [
        2,
        6
      ],
      [
        8,
        2
      ],
      [
        6,
        18
      ],
      [
        0,
        -31
      ],
      [
        -4,
        -3
      ],
      [
        0,
        -13
      ],
      [
        5,
        -6
      ],
      [
        7,
        15
      ],
      [
        5,
        -10
      ]
    ],
    [
      [
        25450,
        60452
      ],
      [
        -70,
        -165
      ],
      [
        -11,
        -18
      ],
      [
        3,
        -12
      ],
      [
        -3,
        -6
      ],
      [
        2,
        -26
      ],
      [
        -3,
        -5
      ]
    ],
    [
      [
        25368,
        60220
      ],
      [
        -7,
        -29
      ],
      [
        -3,
        4
      ],
      [
        -2,
        -13
      ],
      [
        -4,
        3
      ],
      [
        -3,
        -8
      ],
      [
        1,
        -12
      ],
      [
        -7,
        -8
      ],
      [
        0,
        9
      ],
      [
        -4,
        -2
      ],
      [
        1,
        18
      ]
    ],
    [
      [
        27534,
        57466
      ],
      [
        12,
        444
      ]
    ],
    [
      [
        27546,
        57910
      ],
      [
        6,
        18
      ],
      [
        4,
        -34
      ],
      [
        4,
        -30
      ],
      [
        5,
        1
      ],
      [
        4,
        10
      ],
      [
        1,
        -12
      ],
      [
        5,
        -9
      ],
      [
        4,
        4
      ],
      [
        -2,
        16
      ],
      [
        3,
        12
      ],
      [
        5,
        -9
      ],
      [
        3,
        11
      ],
      [
        -1,
        13
      ],
      [
        5,
        7
      ],
      [
        1,
        -24
      ],
      [
        4,
        -11
      ],
      [
        5,
        -24
      ]
    ],
    [
      [
        26196,
        59320
      ],
      [
        5,
        4
      ],
      [
        4,
        104
      ],
      [
        7,
        33
      ],
      [
        3,
        -5
      ],
      [
        3,
        41
      ],
      [
        1,
        -6
      ],
      [
        7,
        14
      ],
      [
        1,
        9
      ],
      [
        3,
        -9
      ],
      [
        7,
        10
      ],
      [
        9,
        8
      ],
      [
        12,
        -3
      ],
      [
        10,
        -10
      ],
      [
        13,
        -23
      ],
      [
        9,
        -30
      ],
      [
        15,
        0
      ]
    ],
    [
      [
        26313,
        59278
      ],
      [
        -6,
        6
      ],
      [
        -2,
        -29
      ],
      [
        -4,
        0
      ],
      [
        2,
        -15
      ],
      [
        -7,
        -11
      ],
      [
        -3,
        6
      ],
      [
        -3,
        -9
      ],
      [
        -4,
        -34
      ],
      [
        -4,
        -4
      ],
      [
        -2,
        7
      ],
      [
        -6,
        -15
      ],
      [
        -4,
        8
      ],
      [
        -5,
        -10
      ],
      [
        -3,
        -53
      ],
      [
        -8,
        -36
      ],
      [
        1,
        -26
      ],
      [
        3,
        -16
      ],
      [
        -2,
        -19
      ]
    ],
    [
      [
        26256,
        59028
      ],
      [
        -7,
        -11
      ],
      [
        -1,
        10
      ],
      [
        -7,
        -8
      ],
      [
        -3,
        11
      ],
      [
        -7,
        3
      ],
      [
        -2,
        -8
      ],
      [
        -7,
        20
      ],
      [
        -8,
        -20
      ],
      [
        -7,
        -20
      ],
      [
        0,
        -4
      ],
      [
        -5,
        7
      ]
    ],
    [
      [
        26202,
        59008
      ],
      [
        -5,
        7
      ]
    ],
    [
      [
        26197,
        59015
      ],
      [
        10,
        60
      ],
      [
        -11,
        126
      ],
      [
        0,
        28
      ],
      [
        1,
        83
      ],
      [
        -1,
        8
      ]
    ],
    [
      [
        25067,
        59604
      ],
      [
        8,
        -2
      ],
      [
        33,
        -66
      ],
      [
        24,
        -1
      ],
      [
        4,
        -15
      ],
      [
        6,
        -2
      ],
      [
        20,
        -86
      ]
    ],
    [
      [
        25162,
        59432
      ],
      [
        -11,
        -1
      ],
      [
        -3,
        -1
      ],
      [
        -4,
        1
      ],
      [
        -28,
        0
      ],
      [
        -2,
        1
      ],
      [
        -23,
        0
      ],
      [
        -8,
        1
      ],
      [
        -1,
        0
      ],
      [
        -12,
        1
      ],
      [
        -13,
        1
      ],
      [
        -19,
        1
      ],
      [
        -1,
        0
      ],
      [
        -5,
        1
      ],
      [
        -13,
        -5
      ]
    ],
    [
      [
        25019,
        59432
      ],
      [
        -9,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -1
      ],
      [
        -8,
        0
      ]
    ],
    [
      [
        24999,
        59427
      ],
      [
        4,
        34
      ],
      [
        2,
        17
      ],
      [
        0,
        20
      ],
      [
        4,
        28
      ],
      [
        1,
        8
      ],
      [
        0,
        20
      ],
      [
        1,
        7
      ],
      [
        0,
        2
      ],
      [
        1,
        6
      ],
      [
        2,
        5
      ],
      [
        2,
        4
      ],
      [
        4,
        3
      ],
      [
        3,
        1
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        24980,
        59425
      ],
      [
        -2,
        1
      ],
      [
        -13,
        0
      ]
    ],
    [
      [
        24965,
        59426
      ],
      [
        -1,
        8
      ],
      [
        -3,
        14
      ],
      [
        -1,
        6
      ],
      [
        0,
        4
      ],
      [
        -2,
        13
      ],
      [
        -1,
        9
      ],
      [
        -1,
        4
      ],
      [
        0,
        6
      ],
      [
        1,
        6
      ],
      [
        1,
        7
      ],
      [
        1,
        5
      ],
      [
        1,
        6
      ],
      [
        2,
        4
      ],
      [
        1,
        4
      ],
      [
        1,
        0
      ],
      [
        5,
        1
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        4,
        -2
      ],
      [
        5,
        -5
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        2,
        -10
      ],
      [
        1,
        -15
      ],
      [
        1,
        -12
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -10
      ],
      [
        -1,
        -9
      ],
      [
        -1,
        -7
      ],
      [
        -2,
        -6
      ],
      [
        -1,
        -6
      ]
    ],
    [
      [
        26880,
        61763
      ],
      [
        3,
        -10
      ],
      [
        2,
        -8
      ],
      [
        3,
        -7
      ],
      [
        2,
        -3
      ],
      [
        2,
        -2
      ],
      [
        2,
        -3
      ],
      [
        1,
        -3
      ],
      [
        1,
        -4
      ],
      [
        0,
        -4
      ],
      [
        2,
        -9
      ],
      [
        0,
        -26
      ],
      [
        2,
        -13
      ],
      [
        0,
        -5
      ]
    ],
    [
      [
        26900,
        61666
      ],
      [
        0,
        -24
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -7
      ],
      [
        1,
        -7
      ],
      [
        0,
        -2
      ],
      [
        1,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -23
      ],
      [
        1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        1,
        -6
      ],
      [
        2,
        -6
      ],
      [
        0,
        -3
      ],
      [
        1,
        -8
      ],
      [
        1,
        -4
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -2
      ],
      [
        1,
        -4
      ],
      [
        0,
        -8
      ],
      [
        1,
        -4
      ],
      [
        0,
        -4
      ],
      [
        1,
        -4
      ],
      [
        0,
        -12
      ],
      [
        -1,
        -11
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -1
      ],
      [
        -3,
        0
      ],
      [
        -2,
        2
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        26845,
        61458
      ],
      [
        3,
        119
      ],
      [
        3,
        20
      ],
      [
        -13,
        13
      ]
    ],
    [
      [
        26838,
        61610
      ],
      [
        2,
        22
      ],
      [
        9,
        26
      ],
      [
        3,
        21
      ],
      [
        22,
        65
      ],
      [
        6,
        19
      ]
    ],
    [
      [
        26978,
        57082
      ],
      [
        0,
        -16
      ],
      [
        14,
        -43
      ],
      [
        5,
        -28
      ]
    ],
    [
      [
        26900,
        56534
      ],
      [
        0,
        20
      ],
      [
        -2,
        5
      ],
      [
        -2,
        6
      ],
      [
        -1,
        8
      ],
      [
        -2,
        5
      ],
      [
        0,
        8
      ],
      [
        -2,
        6
      ],
      [
        -1,
        3
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        3
      ],
      [
        -1,
        5
      ],
      [
        0,
        8
      ],
      [
        1,
        3
      ],
      [
        0,
        6
      ],
      [
        1,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        5
      ],
      [
        -1,
        6
      ],
      [
        -2,
        2
      ],
      [
        0,
        1
      ],
      [
        -2,
        3
      ],
      [
        0,
        5
      ],
      [
        -1,
        1
      ],
      [
        -1,
        6
      ],
      [
        0,
        8
      ],
      [
        -2,
        11
      ],
      [
        -1,
        3
      ],
      [
        -2,
        3
      ],
      [
        -1,
        4
      ],
      [
        -1,
        1
      ],
      [
        -2,
        0
      ],
      [
        -1,
        2
      ],
      [
        -3,
        9
      ],
      [
        -1,
        2
      ],
      [
        -2,
        18
      ],
      [
        0,
        5
      ],
      [
        -2,
        7
      ],
      [
        0,
        23
      ],
      [
        -3,
        15
      ]
    ],
    [
      [
        22799,
        51614
      ],
      [
        34,
        128
      ],
      [
        47,
        180
      ]
    ],
    [
      [
        22880,
        51922
      ],
      [
        1,
        -23
      ],
      [
        49,
        98
      ],
      [
        14,
        52
      ]
    ],
    [
      [
        22944,
        52049
      ],
      [
        6,
        -13
      ],
      [
        2,
        -12
      ],
      [
        8,
        10
      ],
      [
        6,
        -3
      ],
      [
        8,
        22
      ],
      [
        1,
        -15
      ],
      [
        10,
        -7
      ],
      [
        -2,
        -18
      ],
      [
        4,
        -11
      ],
      [
        2,
        -16
      ],
      [
        0,
        -36
      ],
      [
        3,
        -10
      ],
      [
        0,
        -26
      ]
    ],
    [
      [
        22992,
        51914
      ],
      [
        15,
        -97
      ]
    ],
    [
      [
        23007,
        51817
      ],
      [
        -41,
        -196
      ],
      [
        -44,
        -187
      ]
    ],
    [
      [
        22798,
        51611
      ],
      [
        1,
        3
      ]
    ],
    [
      [
        16516,
        70296
      ],
      [
        18,
        14
      ],
      [
        8,
        -3
      ],
      [
        29,
        13
      ],
      [
        13,
        57
      ],
      [
        6,
        16
      ],
      [
        8,
        7
      ],
      [
        13,
        -19
      ],
      [
        11,
        -3
      ],
      [
        10,
        13
      ],
      [
        5,
        1
      ]
    ],
    [
      [
        16637,
        70392
      ],
      [
        -1,
        -135
      ],
      [
        0,
        -232
      ],
      [
        52,
        -1
      ],
      [
        0,
        -100
      ],
      [
        29,
        -1
      ],
      [
        0,
        -504
      ],
      [
        -5,
        0
      ],
      [
        0,
        -100
      ]
    ],
    [
      [
        16570,
        69317
      ],
      [
        -33,
        0
      ],
      [
        0,
        85
      ]
    ],
    [
      [
        28083,
        64346
      ],
      [
        -3,
        9
      ]
    ],
    [
      [
        28080,
        64355
      ],
      [
        22,
        5
      ],
      [
        42,
        8
      ],
      [
        4,
        -5
      ]
    ],
    [
      [
        28148,
        64363
      ],
      [
        -6,
        -17
      ],
      [
        -19,
        -33
      ],
      [
        -5,
        -25
      ],
      [
        7,
        -31
      ],
      [
        0,
        -10
      ],
      [
        9,
        -25
      ],
      [
        -5,
        -26
      ],
      [
        2,
        -14
      ],
      [
        -6,
        -29
      ],
      [
        6,
        -28
      ],
      [
        3,
        -4
      ],
      [
        5,
        12
      ],
      [
        5,
        31
      ],
      [
        -5,
        -41
      ],
      [
        -1,
        -52
      ],
      [
        5,
        12
      ],
      [
        1,
        -9
      ],
      [
        -1,
        -20
      ],
      [
        -6,
        -41
      ],
      [
        -10,
        -54
      ],
      [
        -16,
        -93
      ],
      [
        -2,
        -17
      ]
    ],
    [
      [
        30332,
        65028
      ],
      [
        5,
        0
      ],
      [
        3,
        -6
      ],
      [
        1,
        -2
      ],
      [
        1,
        -9
      ],
      [
        0,
        -1
      ],
      [
        3,
        -6
      ],
      [
        6,
        0
      ],
      [
        1,
        2
      ],
      [
        2,
        4
      ],
      [
        20,
        -1
      ],
      [
        6,
        3
      ],
      [
        3,
        1
      ],
      [
        3,
        2
      ],
      [
        6,
        11
      ],
      [
        4,
        15
      ],
      [
        4,
        21
      ],
      [
        1,
        4
      ],
      [
        0,
        28
      ],
      [
        -2,
        6
      ],
      [
        -1,
        5
      ],
      [
        -2,
        8
      ],
      [
        0,
        3
      ],
      [
        -1,
        2
      ],
      [
        0,
        5
      ],
      [
        5,
        -7
      ],
      [
        4,
        -20
      ],
      [
        12,
        -77
      ],
      [
        4,
        -28
      ],
      [
        0,
        -16
      ],
      [
        -1,
        -12
      ],
      [
        0,
        -2
      ],
      [
        -3,
        -6
      ],
      [
        -7,
        -10
      ],
      [
        -4,
        -1
      ],
      [
        -11,
        5
      ],
      [
        -8,
        2
      ],
      [
        -4,
        -4
      ],
      [
        -5,
        2
      ],
      [
        -1,
        0
      ],
      [
        -14,
        16
      ],
      [
        -19,
        31
      ],
      [
        -5,
        6
      ],
      [
        -3,
        7
      ],
      [
        -2,
        9
      ],
      [
        0,
        6
      ],
      [
        -1,
        4
      ]
    ],
    [
      [
        27811,
        56284
      ],
      [
        1,
        -12
      ],
      [
        1,
        -10
      ]
    ],
    [
      [
        27713,
        55709
      ],
      [
        -9,
        19
      ],
      [
        -8,
        1
      ],
      [
        -5,
        9
      ],
      [
        -7,
        45
      ],
      [
        -4,
        11
      ],
      [
        -3,
        -6
      ],
      [
        -2,
        11
      ],
      [
        -11,
        24
      ],
      [
        -2,
        14
      ],
      [
        -5,
        16
      ],
      [
        3,
        2
      ],
      [
        -7,
        27
      ],
      [
        -5,
        3
      ],
      [
        -1,
        9
      ],
      [
        -16,
        43
      ],
      [
        -9,
        -6
      ],
      [
        -2,
        11
      ],
      [
        -20,
        1
      ],
      [
        -5,
        -10
      ]
    ],
    [
      [
        18773,
        61759
      ],
      [
        3,
        9
      ],
      [
        125,
        0
      ]
    ],
    [
      [
        18901,
        61768
      ],
      [
        0,
        -11
      ],
      [
        357,
        0
      ]
    ],
    [
      [
        19285,
        61351
      ],
      [
        -212,
        0
      ],
      [
        -202,
        3
      ],
      [
        -62,
        -5
      ],
      [
        0,
        1
      ],
      [
        -58,
        1
      ]
    ],
    [
      [
        22486,
        53060
      ],
      [
        147,
        7
      ]
    ],
    [
      [
        22594,
        52589
      ],
      [
        -20,
        -163
      ],
      [
        7,
        15
      ],
      [
        0,
        -35
      ],
      [
        -8,
        -48
      ]
    ],
    [
      [
        22484,
        52935
      ],
      [
        7,
        5
      ],
      [
        2,
        19
      ],
      [
        -9,
        11
      ],
      [
        -2,
        20
      ],
      [
        3,
        18
      ],
      [
        -5,
        27
      ],
      [
        6,
        25
      ]
    ],
    [
      [
        18285,
        70417
      ],
      [
        5,
        10
      ],
      [
        5,
        -10
      ],
      [
        6,
        26
      ],
      [
        -2,
        7
      ],
      [
        2,
        19
      ],
      [
        5,
        -4
      ],
      [
        7,
        10
      ],
      [
        5,
        13
      ],
      [
        0,
        16
      ],
      [
        6,
        5
      ],
      [
        4,
        -14
      ],
      [
        8,
        -2
      ],
      [
        16,
        47
      ],
      [
        1,
        16
      ],
      [
        0,
        89
      ],
      [
        -3,
        0
      ],
      [
        0,
        101
      ],
      [
        69,
        1
      ],
      [
        0,
        51
      ]
    ],
    [
      [
        18419,
        70798
      ],
      [
        133,
        -2
      ]
    ],
    [
      [
        18547,
        70695
      ],
      [
        -11,
        -15
      ],
      [
        -7,
        10
      ],
      [
        -4,
        -25
      ],
      [
        -7,
        -20
      ],
      [
        -27,
        0
      ],
      [
        0,
        -102
      ],
      [
        -21,
        0
      ],
      [
        -5,
        -23
      ],
      [
        1,
        -21
      ],
      [
        -5,
        -14
      ],
      [
        -10,
        8
      ],
      [
        -5,
        -14
      ],
      [
        0,
        -29
      ],
      [
        4,
        -39
      ],
      [
        -1,
        -9
      ],
      [
        -9,
        -5
      ],
      [
        -1,
        -20
      ],
      [
        -14,
        -26
      ],
      [
        -3,
        -14
      ],
      [
        -10,
        -2
      ],
      [
        -7,
        -10
      ]
    ],
    [
      [
        18655,
        70194
      ],
      [
        -76,
        -7
      ],
      [
        -7,
        19
      ],
      [
        -3,
        1
      ],
      [
        -5,
        -15
      ],
      [
        -3,
        -22
      ],
      [
        1,
        -23
      ],
      [
        -8,
        -28
      ],
      [
        -7,
        -7
      ],
      [
        -7,
        -19
      ],
      [
        -24,
        -43
      ]
    ],
    [
      [
        22842,
        66762
      ],
      [
        -2,
        2
      ],
      [
        -1,
        1
      ],
      [
        -2,
        1
      ],
      [
        -2,
        2
      ],
      [
        -4,
        0
      ],
      [
        -1,
        2
      ],
      [
        -2,
        3
      ],
      [
        0,
        1
      ],
      [
        -1,
        3
      ],
      [
        0,
        12
      ],
      [
        -1,
        5
      ],
      [
        0,
        21
      ],
      [
        -4,
        7
      ],
      [
        -4,
        4
      ],
      [
        -1,
        1
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        -2
      ],
      [
        -6,
        4
      ],
      [
        -3,
        11
      ],
      [
        -2,
        3
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -2
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -5,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        4
      ],
      [
        -2,
        5
      ],
      [
        0,
        3
      ],
      [
        -5,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        4
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -6
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -6
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -1
      ],
      [
        -3,
        0
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        -2,
        2
      ],
      [
        -4,
        0
      ]
    ],
    [
      [
        22752,
        66821
      ],
      [
        -2,
        1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        -1,
        3
      ],
      [
        -1,
        1
      ],
      [
        -3,
        -5
      ],
      [
        -4,
        -5
      ],
      [
        -5,
        -2
      ],
      [
        -4,
        -1
      ],
      [
        -3,
        3
      ],
      [
        -5,
        5
      ],
      [
        -2,
        2
      ],
      [
        -1,
        3
      ],
      [
        -3,
        0
      ],
      [
        -2,
        -2
      ],
      [
        -4,
        -6
      ]
    ],
    [
      [
        21492,
        68153
      ],
      [
        3,
        0
      ],
      [
        8,
        -1
      ],
      [
        251,
        1
      ]
    ],
    [
      [
        21754,
        68153
      ],
      [
        0,
        -179
      ]
    ],
    [
      [
        21754,
        67974
      ],
      [
        -6,
        2
      ],
      [
        0,
        8
      ],
      [
        -6,
        -4
      ],
      [
        1,
        -11
      ],
      [
        -5,
        9
      ],
      [
        -4,
        -4
      ],
      [
        1,
        -12
      ],
      [
        -6,
        -16
      ],
      [
        -2,
        15
      ],
      [
        -3,
        -16
      ],
      [
        -2,
        2
      ],
      [
        -2,
        -18
      ],
      [
        -5,
        11
      ],
      [
        -3,
        -9
      ],
      [
        -3,
        -18
      ],
      [
        0,
        -465
      ]
    ],
    [
      [
        21463,
        67449
      ],
      [
        0,
        101
      ],
      [
        -8,
        0
      ],
      [
        0,
        261
      ]
    ],
    [
      [
        26151,
        59465
      ],
      [
        4,
        10
      ],
      [
        5,
        -20
      ],
      [
        8,
        -9
      ],
      [
        10,
        -29
      ],
      [
        11,
        -40
      ],
      [
        0,
        -23
      ],
      [
        3,
        -34
      ],
      [
        4,
        0
      ]
    ],
    [
      [
        26197,
        59015
      ],
      [
        -24,
        9
      ],
      [
        -33,
        55
      ],
      [
        -1,
        21
      ],
      [
        -11,
        3
      ],
      [
        -15,
        18
      ],
      [
        -4,
        13
      ],
      [
        0,
        18
      ],
      [
        -5,
        -1
      ],
      [
        0,
        18
      ],
      [
        -4,
        3
      ],
      [
        4,
        1
      ],
      [
        -3,
        15
      ],
      [
        1,
        12
      ],
      [
        -10,
        -2
      ]
    ],
    [
      [
        26092,
        59198
      ],
      [
        -1,
        85
      ],
      [
        1,
        33
      ]
    ],
    [
      [
        18917,
        63158
      ],
      [
        8,
        -14
      ],
      [
        0,
        -19
      ],
      [
        5,
        -22
      ],
      [
        4,
        -43
      ],
      [
        8,
        -28
      ],
      [
        7,
        21
      ],
      [
        4,
        -49
      ],
      [
        1,
        -23
      ],
      [
        3,
        -6
      ],
      [
        6,
        -29
      ],
      [
        1,
        -30
      ],
      [
        1,
        -6
      ],
      [
        -1,
        -27
      ],
      [
        1,
        2
      ],
      [
        293,
        0
      ]
    ],
    [
      [
        19258,
        62885
      ],
      [
        2,
        -15
      ],
      [
        -2,
        -12
      ],
      [
        0,
        -27
      ],
      [
        4,
        -8
      ],
      [
        -4,
        -45
      ],
      [
        1,
        -30
      ],
      [
        -4,
        -3
      ],
      [
        -4,
        -27
      ],
      [
        -1,
        5
      ],
      [
        -2,
        -27
      ],
      [
        3,
        -8
      ],
      [
        -5,
        -7
      ],
      [
        -3,
        -21
      ],
      [
        5,
        -15
      ],
      [
        -1,
        -15
      ],
      [
        3,
        -26
      ],
      [
        -7,
        -2
      ],
      [
        1,
        -29
      ],
      [
        -1,
        -9
      ],
      [
        -6,
        -5
      ],
      [
        -1,
        -13
      ],
      [
        1,
        -11
      ],
      [
        -4,
        -19
      ],
      [
        4,
        -19
      ],
      [
        -4,
        -18
      ],
      [
        1,
        -9
      ],
      [
        -2,
        -20
      ],
      [
        -6,
        -8
      ],
      [
        -2,
        -13
      ],
      [
        2,
        -23
      ],
      [
        -5,
        -29
      ],
      [
        5,
        -9
      ],
      [
        -4,
        -12
      ],
      [
        4,
        -13
      ],
      [
        -3,
        -8
      ],
      [
        5,
        6
      ],
      [
        10,
        0
      ],
      [
        0,
        -18
      ],
      [
        10,
        0
      ],
      [
        0,
        8
      ],
      [
        5,
        0
      ],
      [
        0,
        -17
      ],
      [
        6,
        0
      ],
      [
        0,
        -17
      ],
      [
        5,
        0
      ],
      [
        0,
        -17
      ],
      [
        -11,
        0
      ],
      [
        -2,
        17
      ],
      [
        -5,
        0
      ],
      [
        0,
        17
      ],
      [
        -11,
        5
      ],
      [
        -12,
        -10
      ],
      [
        0,
        -3
      ],
      [
        3,
        -7
      ],
      [
        -1,
        -11
      ],
      [
        -3,
        -35
      ],
      [
        -2,
        -45
      ],
      [
        7,
        -32
      ],
      [
        -2,
        -14
      ],
      [
        2,
        -16
      ],
      [
        2,
        0
      ],
      [
        2,
        -3
      ],
      [
        0,
        -8
      ],
      [
        3,
        -11
      ],
      [
        2,
        -10
      ],
      [
        -2,
        -12
      ],
      [
        -2,
        -1
      ],
      [
        0,
        -8
      ],
      [
        1,
        -8
      ],
      [
        4,
        -9
      ],
      [
        3,
        -11
      ],
      [
        1,
        -16
      ],
      [
        -6,
        -13
      ],
      [
        0,
        -22
      ],
      [
        -2,
        -10
      ],
      [
        -2,
        -1
      ],
      [
        4,
        -2
      ],
      [
        6,
        -5
      ],
      [
        -2,
        -8
      ],
      [
        0,
        -16
      ],
      [
        1,
        -13
      ],
      [
        -1,
        -4
      ],
      [
        3,
        -2
      ],
      [
        4,
        -1
      ],
      [
        0,
        -13
      ],
      [
        3,
        -5
      ],
      [
        3,
        -1
      ],
      [
        3,
        3
      ],
      [
        -1,
        -9
      ],
      [
        -3,
        -10
      ],
      [
        0,
        -26
      ],
      [
        -4,
        -8
      ],
      [
        3,
        -4
      ],
      [
        4,
        4
      ],
      [
        6,
        9
      ],
      [
        5,
        1
      ],
      [
        1,
        -13
      ],
      [
        0,
        -13
      ],
      [
        -4,
        -9
      ],
      [
        -2,
        3
      ],
      [
        -2,
        12
      ],
      [
        -6,
        -5
      ],
      [
        -3,
        -11
      ],
      [
        1,
        -10
      ],
      [
        3,
        -1
      ],
      [
        4,
        -2
      ],
      [
        3,
        -12
      ],
      [
        4,
        1
      ],
      [
        1,
        2
      ],
      [
        3,
        -2
      ],
      [
        0,
        -9
      ],
      [
        -2,
        -7
      ],
      [
        -2,
        -17
      ],
      [
        2,
        -8
      ],
      [
        -1,
        -10
      ],
      [
        -4,
        -5
      ],
      [
        -5,
        -1
      ],
      [
        -3,
        -1
      ],
      [
        -1,
        -6
      ],
      [
        3,
        -8
      ],
      [
        3,
        -4
      ]
    ],
    [
      [
        18901,
        61768
      ],
      [
        0,
        189
      ],
      [
        2,
        0
      ],
      [
        0,
        419
      ]
    ],
    [
      [
        22736,
        49726
      ],
      [
        46,
        260
      ]
    ],
    [
      [
        22842,
        50178
      ],
      [
        4,
        -8
      ],
      [
        2,
        9
      ],
      [
        4,
        -10
      ],
      [
        5,
        11
      ],
      [
        4,
        -24
      ],
      [
        4,
        4
      ],
      [
        2,
        11
      ],
      [
        3,
        -4
      ],
      [
        4,
        7
      ],
      [
        -2,
        -15
      ],
      [
        4,
        -6
      ],
      [
        2,
        11
      ],
      [
        3,
        -25
      ],
      [
        4,
        -13
      ],
      [
        7,
        -11
      ],
      [
        7,
        6
      ],
      [
        11,
        -22
      ],
      [
        0,
        16
      ],
      [
        4,
        12
      ],
      [
        3,
        -3
      ]
    ],
    [
      [
        22952,
        50012
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -6
      ],
      [
        -4,
        -25
      ],
      [
        -1,
        -23
      ],
      [
        0,
        -18
      ],
      [
        1,
        -29
      ],
      [
        0,
        -6
      ]
    ],
    [
      [
        22879,
        49749
      ],
      [
        -3,
        1
      ],
      [
        -32,
        -61
      ],
      [
        -17,
        -53
      ],
      [
        0,
        -13
      ]
    ],
    [
      [
        22814,
        49622
      ],
      [
        -1,
        15
      ],
      [
        -5,
        3
      ],
      [
        -1,
        23
      ],
      [
        -5,
        -8
      ],
      [
        -4,
        10
      ],
      [
        3,
        9
      ],
      [
        -3,
        20
      ],
      [
        -2,
        -21
      ],
      [
        0,
        8
      ],
      [
        -5,
        4
      ],
      [
        0,
        -11
      ],
      [
        -3,
        3
      ],
      [
        -7,
        17
      ],
      [
        -1,
        -16
      ],
      [
        -6,
        8
      ],
      [
        1,
        -12
      ],
      [
        -7,
        -3
      ],
      [
        1,
        28
      ],
      [
        -4,
        -3
      ],
      [
        -6,
        24
      ],
      [
        -3,
        -6
      ],
      [
        -2,
        29
      ],
      [
        -2,
        -13
      ],
      [
        -3,
        -3
      ],
      [
        -7,
        -17
      ],
      [
        -6,
        16
      ]
    ],
    [
      [
        21749,
        59428
      ],
      [
        36,
        0
      ]
    ],
    [
      [
        21785,
        59428
      ],
      [
        114,
        0
      ]
    ],
    [
      [
        19716,
        60010
      ],
      [
        36,
        0
      ],
      [
        1,
        -1
      ],
      [
        60,
        1
      ],
      [
        153,
        0
      ]
    ],
    [
      [
        19927,
        59102
      ],
      [
        -1,
        -255
      ]
    ],
    [
      [
        19531,
        58850
      ],
      [
        0,
        1159
      ]
    ],
    [
      [
        24360,
        58779
      ],
      [
        22,
        -3
      ],
      [
        47,
        -3
      ],
      [
        0,
        -52
      ],
      [
        30,
        -2
      ]
    ],
    [
      [
        24459,
        58719
      ],
      [
        44,
        -1
      ]
    ],
    [
      [
        24503,
        58718
      ],
      [
        -5,
        -9
      ],
      [
        1,
        -27
      ],
      [
        -2,
        -8
      ],
      [
        3,
        -3
      ],
      [
        -5,
        -6
      ],
      [
        -2,
        -13
      ],
      [
        -4,
        1
      ],
      [
        4,
        -13
      ],
      [
        1,
        -12
      ],
      [
        -4,
        0
      ],
      [
        -4,
        -10
      ],
      [
        4,
        -3
      ],
      [
        -7,
        -15
      ],
      [
        -2,
        5
      ],
      [
        -4,
        -24
      ],
      [
        -5,
        -7
      ],
      [
        -6,
        -29
      ],
      [
        -2,
        -33
      ],
      [
        -2,
        10
      ],
      [
        -3,
        -30
      ],
      [
        3,
        -8
      ],
      [
        -2,
        -11
      ],
      [
        4,
        -16
      ],
      [
        0,
        -16
      ],
      [
        4,
        -5
      ],
      [
        0,
        -12
      ],
      [
        -12,
        3
      ],
      [
        0,
        -61
      ],
      [
        -1,
        -71
      ],
      [
        -59,
        5
      ]
    ],
    [
      [
        24396,
        58300
      ],
      [
        -18,
        2
      ],
      [
        -17,
        1
      ],
      [
        -10,
        1
      ],
      [
        -14,
        0
      ]
    ],
    [
      [
        24325,
        58503
      ],
      [
        0,
        51
      ],
      [
        -8,
        26
      ],
      [
        -1,
        46
      ],
      [
        6,
        41
      ],
      [
        0,
        25
      ]
    ],
    [
      [
        23980,
        61481
      ],
      [
        5,
        10
      ],
      [
        4,
        -8
      ],
      [
        8,
        -27
      ],
      [
        3,
        -22
      ],
      [
        5,
        -2
      ],
      [
        -1,
        -13
      ],
      [
        -6,
        0
      ],
      [
        -3,
        -13
      ],
      [
        2,
        -11
      ],
      [
        7,
        -1
      ],
      [
        3,
        11
      ],
      [
        5,
        35
      ],
      [
        8,
        -9
      ],
      [
        -1,
        -11
      ],
      [
        -7,
        -16
      ],
      [
        43,
        -7
      ],
      [
        12,
        -2
      ],
      [
        2,
        27
      ],
      [
        7,
        10
      ],
      [
        10,
        1
      ]
    ],
    [
      [
        24041,
        61053
      ],
      [
        -60,
        8
      ]
    ],
    [
      [
        23981,
        61061
      ],
      [
        2,
        186
      ]
    ],
    [
      [
        22622,
        73980
      ],
      [
        201,
        0
      ]
    ],
    [
      [
        22841,
        73448
      ],
      [
        1,
        -1
      ]
    ],
    [
      [
        24503,
        58718
      ],
      [
        17,
        0
      ],
      [
        29,
        -5
      ]
    ],
    [
      [
        24549,
        58713
      ],
      [
        0,
        -103
      ],
      [
        -1,
        -103
      ]
    ],
    [
      [
        24462,
        58193
      ],
      [
        -66,
        4
      ],
      [
        0,
        103
      ]
    ],
    [
      [
        22999,
        67577
      ],
      [
        -1,
        -5
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        1,
        1
      ],
      [
        1,
        -4
      ],
      [
        0,
        -1
      ],
      [
        2,
        -10
      ],
      [
        -2,
        -3
      ],
      [
        0,
        -9
      ],
      [
        1,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        -4,
        -9
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -2
      ],
      [
        3,
        -18
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        1,
        -1
      ],
      [
        1,
        1
      ],
      [
        2,
        -1
      ],
      [
        2,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -5
      ],
      [
        1,
        -3
      ],
      [
        2,
        -5
      ],
      [
        1,
        -7
      ],
      [
        1,
        -3
      ],
      [
        5,
        -10
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        1,
        -10
      ],
      [
        0,
        -16
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -6
      ],
      [
        1,
        -13
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -10
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -9
      ],
      [
        1,
        -14
      ],
      [
        1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -12
      ],
      [
        -3,
        -5
      ],
      [
        -4,
        -3
      ],
      [
        0,
        2
      ],
      [
        -3,
        0
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        3
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -24
      ],
      [
        -1,
        -1
      ],
      [
        0,
        3
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -6
      ],
      [
        1,
        -2
      ],
      [
        2,
        1
      ],
      [
        2,
        -6
      ],
      [
        1,
        -3
      ],
      [
        1,
        -1
      ],
      [
        1,
        -1
      ],
      [
        1,
        1
      ]
    ],
    [
      [
        23011,
        67297
      ],
      [
        0,
        -2
      ],
      [
        1,
        -8
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        -6
      ],
      [
        1,
        -9
      ],
      [
        2,
        -8
      ],
      [
        1,
        0
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        2,
        0
      ],
      [
        1,
        -1
      ],
      [
        1,
        0
      ],
      [
        1,
        2
      ],
      [
        3,
        -4
      ],
      [
        1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        1,
        -1
      ],
      [
        2,
        1
      ],
      [
        3,
        3
      ],
      [
        1,
        3
      ],
      [
        3,
        1
      ],
      [
        3,
        -3
      ],
      [
        0,
        -5
      ],
      [
        1,
        -9
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -10
      ],
      [
        1,
        -5
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -21
      ],
      [
        0,
        -16
      ],
      [
        1,
        -3
      ],
      [
        1,
        -5
      ],
      [
        1,
        0
      ],
      [
        0,
        1
      ],
      [
        2,
        -3
      ],
      [
        2,
        -9
      ],
      [
        0,
        -11
      ],
      [
        1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        -1,
        -8
      ],
      [
        -2,
        -11
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -2
      ],
      [
        3,
        -2
      ],
      [
        0,
        -5
      ]
    ],
    [
      [
        25162,
        59432
      ],
      [
        2,
        0
      ]
    ],
    [
      [
        25164,
        59432
      ],
      [
        3,
        -38
      ],
      [
        0,
        -70
      ],
      [
        -9,
        3
      ],
      [
        -5,
        -7
      ],
      [
        -6,
        -16
      ],
      [
        -3,
        1
      ],
      [
        -4,
        13
      ],
      [
        -10,
        8
      ],
      [
        -1,
        -27
      ],
      [
        -2,
        -193
      ]
    ],
    [
      [
        24981,
        59094
      ],
      [
        -1,
        10
      ],
      [
        9,
        8
      ],
      [
        3,
        9
      ],
      [
        4,
        27
      ],
      [
        4,
        39
      ],
      [
        3,
        25
      ],
      [
        1,
        21
      ],
      [
        -1,
        23
      ],
      [
        7,
        29
      ],
      [
        5,
        38
      ],
      [
        -2,
        29
      ],
      [
        2,
        26
      ],
      [
        6,
        22
      ],
      [
        -2,
        32
      ]
    ],
    [
      [
        27062,
        55974
      ],
      [
        20,
        64
      ],
      [
        2,
        7
      ],
      [
        21,
        68
      ],
      [
        22,
        74
      ],
      [
        18,
        57
      ],
      [
        18,
        58
      ]
    ],
    [
      [
        27185,
        56375
      ],
      [
        3,
        -17
      ],
      [
        4,
        -4
      ],
      [
        4,
        -31
      ],
      [
        6,
        -22
      ],
      [
        10,
        -17
      ],
      [
        4,
        -2
      ],
      [
        7,
        -25
      ],
      [
        3,
        -38
      ],
      [
        3,
        -13
      ],
      [
        16,
        -10
      ],
      [
        15,
        -22
      ],
      [
        4,
        -13
      ],
      [
        2,
        1
      ],
      [
        1,
        3
      ],
      [
        20,
        -44
      ],
      [
        5,
        -7
      ]
    ],
    [
      [
        27292,
        56114
      ],
      [
        -8,
        -29
      ],
      [
        -43,
        -160
      ]
    ],
    [
      [
        27241,
        55925
      ],
      [
        -2,
        -4
      ],
      [
        -38,
        -122
      ],
      [
        -67,
        -214
      ]
    ],
    [
      [
        27134,
        55585
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        -1,
        14
      ],
      [
        -1,
        2
      ],
      [
        -1,
        5
      ],
      [
        -2,
        0
      ],
      [
        0,
        -2
      ],
      [
        1,
        -6
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        1
      ],
      [
        -4,
        3
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        10
      ],
      [
        -1,
        2
      ],
      [
        -2,
        3
      ],
      [
        -2,
        2
      ],
      [
        -1,
        6
      ],
      [
        -2,
        5
      ],
      [
        -2,
        5
      ],
      [
        -2,
        6
      ]
    ],
    [
      [
        27107,
        55642
      ],
      [
        0,
        4
      ],
      [
        1,
        18
      ],
      [
        2,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        5
      ],
      [
        -2,
        7
      ],
      [
        -2,
        5
      ],
      [
        -3,
        3
      ],
      [
        0,
        14
      ],
      [
        2,
        2
      ],
      [
        1,
        0
      ],
      [
        0,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        5
      ],
      [
        -1,
        3
      ],
      [
        -1,
        4
      ],
      [
        -4,
        5
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -6
      ],
      [
        -2,
        4
      ],
      [
        -1,
        7
      ],
      [
        -3,
        6
      ],
      [
        1,
        3
      ],
      [
        0,
        4
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        0
      ],
      [
        0,
        4
      ],
      [
        -1,
        2
      ],
      [
        -1,
        4
      ],
      [
        -1,
        1
      ],
      [
        1,
        9
      ],
      [
        -2,
        4
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        0
      ],
      [
        0,
        7
      ],
      [
        1,
        3
      ],
      [
        0,
        5
      ],
      [
        -3,
        9
      ],
      [
        0,
        8
      ],
      [
        1,
        2
      ],
      [
        1,
        0
      ],
      [
        1,
        -4
      ],
      [
        1,
        -1
      ],
      [
        2,
        3
      ],
      [
        0,
        4
      ],
      [
        -2,
        7
      ],
      [
        -1,
        20
      ],
      [
        -1,
        4
      ],
      [
        0,
        4
      ],
      [
        1,
        2
      ],
      [
        1,
        1
      ],
      [
        2,
        1
      ],
      [
        1,
        3
      ],
      [
        0,
        8
      ],
      [
        -1,
        2
      ],
      [
        -1,
        4
      ],
      [
        0,
        5
      ],
      [
        1,
        3
      ],
      [
        1,
        2
      ],
      [
        1,
        2
      ],
      [
        1,
        5
      ],
      [
        0,
        5
      ],
      [
        -4,
        24
      ],
      [
        0,
        4
      ],
      [
        -2,
        3
      ],
      [
        -2,
        2
      ],
      [
        -1,
        2
      ],
      [
        -3,
        5
      ],
      [
        -3,
        6
      ],
      [
        -4,
        4
      ],
      [
        -1,
        3
      ],
      [
        -1,
        4
      ],
      [
        -1,
        5
      ],
      [
        1,
        7
      ],
      [
        -1,
        4
      ],
      [
        -3,
        19
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        9
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ]
    ],
    [
      [
        15475,
        68998
      ],
      [
        6,
        -2
      ],
      [
        17,
        2
      ],
      [
        61,
        -1
      ],
      [
        42,
        0
      ]
    ],
    [
      [
        15593,
        68489
      ],
      [
        -42,
        0
      ],
      [
        -11,
        -3
      ],
      [
        -62,
        1
      ],
      [
        0,
        -6
      ],
      [
        -34,
        4
      ],
      [
        -17,
        4
      ]
    ],
    [
      [
        15427,
        68489
      ],
      [
        0,
        38
      ],
      [
        -11,
        -1
      ],
      [
        -1,
        34
      ],
      [
        23,
        1
      ],
      [
        0,
        17
      ],
      [
        6,
        0
      ],
      [
        -2,
        34
      ],
      [
        0,
        51
      ],
      [
        34,
        0
      ],
      [
        -1,
        254
      ],
      [
        0,
        81
      ]
    ],
    [
      [
        15332,
        68480
      ],
      [
        15,
        -1
      ],
      [
        14,
        3
      ],
      [
        20,
        0
      ],
      [
        0,
        6
      ],
      [
        46,
        1
      ]
    ],
    [
      [
        15972,
        68464
      ],
      [
        5,
        -3
      ],
      [
        4,
        -31
      ],
      [
        1,
        -44
      ],
      [
        3,
        -32
      ],
      [
        -3,
        -23
      ],
      [
        3,
        -9
      ],
      [
        1,
        -45
      ],
      [
        -3,
        -25
      ],
      [
        -3,
        -6
      ],
      [
        -3,
        -26
      ],
      [
        -5,
        -1
      ],
      [
        -4,
        -17
      ],
      [
        3,
        -30
      ],
      [
        -2,
        -20
      ],
      [
        -4,
        -21
      ],
      [
        2,
        -5
      ],
      [
        -6,
        -8
      ],
      [
        -3,
        -61
      ],
      [
        -6,
        -4
      ],
      [
        -3,
        8
      ],
      [
        -7,
        -8
      ],
      [
        -4,
        -9
      ],
      [
        2,
        -9
      ],
      [
        -5,
        -25
      ],
      [
        -7,
        -18
      ],
      [
        0,
        -51
      ],
      [
        4,
        -4
      ],
      [
        -2,
        -40
      ],
      [
        2,
        -13
      ],
      [
        -3,
        -18
      ],
      [
        -2,
        -6
      ],
      [
        2,
        -43
      ],
      [
        -4,
        -52
      ],
      [
        2,
        -26
      ],
      [
        4,
        -14
      ],
      [
        -10,
        -2
      ],
      [
        0,
        -12
      ]
    ],
    [
      [
        15921,
        67711
      ],
      [
        -10,
        -16
      ],
      [
        -9,
        -26
      ],
      [
        -6,
        0
      ],
      [
        -11,
        -25
      ],
      [
        -5,
        -43
      ],
      [
        5,
        -12
      ],
      [
        1,
        -16
      ],
      [
        -3,
        -48
      ],
      [
        -4,
        -9
      ],
      [
        6,
        -9
      ]
    ],
    [
      [
        15885,
        67507
      ],
      [
        -39,
        0
      ],
      [
        -61,
        2
      ],
      [
        -5,
        -2
      ],
      [
        -32,
        0
      ],
      [
        -33,
        -3
      ],
      [
        0,
        125
      ],
      [
        -53,
        -1
      ],
      [
        -16,
        -6
      ],
      [
        -33,
        1
      ],
      [
        0,
        77
      ],
      [
        -8,
        0
      ],
      [
        0,
        185
      ],
      [
        -1,
        17
      ],
      [
        -58,
        1
      ],
      [
        0,
        34
      ],
      [
        -34,
        1
      ],
      [
        0,
        24
      ],
      [
        -16,
        -1
      ],
      [
        0,
        45
      ],
      [
        -15,
        0
      ],
      [
        1,
        26
      ],
      [
        -12,
        1
      ],
      [
        1,
        34
      ],
      [
        -12,
        1
      ],
      [
        0,
        17
      ],
      [
        -12,
        1
      ],
      [
        0,
        8
      ],
      [
        -15,
        0
      ],
      [
        -19,
        1
      ],
      [
        -8,
        -29
      ],
      [
        -5,
        -4
      ],
      [
        -8,
        -24
      ],
      [
        -7,
        3
      ],
      [
        0,
        -38
      ],
      [
        -6,
        7
      ],
      [
        0,
        -11
      ],
      [
        -33,
        0
      ],
      [
        -26,
        1
      ]
    ],
    [
      [
        15320,
        68000
      ],
      [
        3,
        55
      ],
      [
        2,
        55
      ],
      [
        2,
        91
      ],
      [
        3,
        79
      ],
      [
        -1,
        26
      ],
      [
        3,
        53
      ],
      [
        1,
        31
      ],
      [
        -1,
        9
      ],
      [
        1,
        34
      ],
      [
        1,
        35
      ],
      [
        0,
        6
      ],
      [
        -2,
        2
      ],
      [
        0,
        4
      ]
    ],
    [
      [
        28439,
        61133
      ],
      [
        0,
        -21
      ],
      [
        3,
        -4
      ],
      [
        2,
        -14
      ],
      [
        6,
        -6
      ],
      [
        2,
        -26
      ],
      [
        -2,
        -15
      ],
      [
        3,
        -6
      ],
      [
        -6,
        -19
      ],
      [
        6,
        -9
      ],
      [
        1,
        -19
      ],
      [
        4,
        -10
      ],
      [
        6,
        3
      ],
      [
        3,
        -12
      ],
      [
        7,
        -1
      ],
      [
        1,
        -52
      ],
      [
        10,
        15
      ],
      [
        9,
        -15
      ],
      [
        9,
        17
      ],
      [
        10,
        -3
      ],
      [
        4,
        -10
      ],
      [
        0,
        -17
      ],
      [
        5,
        -11
      ],
      [
        5,
        -21
      ],
      [
        1,
        -18
      ]
    ],
    [
      [
        28528,
        60859
      ],
      [
        0,
        -20
      ],
      [
        9,
        -63
      ],
      [
        10,
        -47
      ],
      [
        8,
        -16
      ]
    ],
    [
      [
        28555,
        60713
      ],
      [
        -4,
        -86
      ],
      [
        6,
        -39
      ],
      [
        0,
        -17
      ],
      [
        -5,
        -30
      ],
      [
        -2,
        6
      ],
      [
        -4,
        -15
      ],
      [
        -5,
        0
      ],
      [
        -2,
        -19
      ]
    ],
    [
      [
        28539,
        60513
      ],
      [
        -6,
        22
      ],
      [
        -2,
        19
      ]
    ],
    [
      [
        28531,
        60554
      ],
      [
        -3,
        20
      ],
      [
        -11,
        25
      ],
      [
        0,
        14
      ]
    ],
    [
      [
        24902,
        60157
      ],
      [
        2,
        17
      ],
      [
        11,
        0
      ],
      [
        5,
        17
      ],
      [
        0,
        34
      ],
      [
        4,
        16
      ],
      [
        11,
        9
      ],
      [
        0,
        15
      ],
      [
        8,
        0
      ],
      [
        0,
        17
      ],
      [
        10,
        0
      ],
      [
        10,
        8
      ],
      [
        1,
        9
      ],
      [
        12,
        -3
      ],
      [
        3,
        7
      ]
    ],
    [
      [
        24979,
        60303
      ],
      [
        3,
        2
      ],
      [
        3,
        0
      ],
      [
        2,
        -2
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -10
      ],
      [
        -3,
        -21
      ],
      [
        0,
        -5
      ],
      [
        2,
        -17
      ],
      [
        0,
        -4
      ],
      [
        2,
        -14
      ],
      [
        5,
        -31
      ],
      [
        0,
        -11
      ],
      [
        3,
        -16
      ],
      [
        3,
        -15
      ],
      [
        1,
        -3
      ],
      [
        1,
        -4
      ],
      [
        4,
        -9
      ],
      [
        2,
        -4
      ],
      [
        1,
        -5
      ],
      [
        1,
        -10
      ],
      [
        1,
        -11
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -11
      ],
      [
        -2,
        -15
      ],
      [
        0,
        -11
      ],
      [
        1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        1,
        -4
      ],
      [
        5,
        -11
      ],
      [
        4,
        -6
      ],
      [
        4,
        -6
      ],
      [
        3,
        -5
      ],
      [
        1,
        -4
      ],
      [
        2,
        -4
      ]
    ],
    [
      [
        24971,
        59859
      ],
      [
        -5,
        0
      ],
      [
        -8,
        1
      ],
      [
        -11,
        -5
      ],
      [
        0,
        -6
      ],
      [
        -5,
        0
      ],
      [
        -12,
        -1
      ],
      [
        -7,
        -1
      ]
    ],
    [
      [
        24923,
        59847
      ],
      [
        -2,
        17
      ],
      [
        3,
        15
      ],
      [
        -1,
        16
      ],
      [
        2,
        26
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        21
      ],
      [
        -6,
        15
      ],
      [
        -1,
        43
      ],
      [
        -10,
        47
      ],
      [
        0,
        22
      ],
      [
        -3,
        3
      ],
      [
        -6,
        41
      ],
      [
        4,
        12
      ],
      [
        2,
        33
      ]
    ],
    [
      [
        23075,
        50320
      ],
      [
        4,
        335
      ]
    ],
    [
      [
        23079,
        50655
      ],
      [
        96,
        214
      ],
      [
        25,
        96
      ]
    ],
    [
      [
        23200,
        50965
      ],
      [
        5,
        -14
      ],
      [
        2,
        -19
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -5
      ],
      [
        4,
        -19
      ],
      [
        0,
        -7
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -11
      ],
      [
        1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -7
      ],
      [
        1,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -15
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -10
      ],
      [
        1,
        -5
      ],
      [
        -1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        1,
        -2
      ],
      [
        0,
        1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        1,
        -2
      ],
      [
        1,
        0
      ],
      [
        2,
        1
      ],
      [
        1,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -8
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        1,
        -2
      ],
      [
        2,
        -3
      ],
      [
        2,
        -3
      ],
      [
        1,
        1
      ],
      [
        0,
        -1
      ],
      [
        1,
        -3
      ],
      [
        1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        0,
        1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -3
      ],
      [
        0,
        2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        1,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        -1,
        2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -3
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        1,
        -1
      ],
      [
        1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -6
      ],
      [
        1,
        -4
      ],
      [
        8,
        0
      ],
      [
        3,
        1
      ],
      [
        3,
        0
      ],
      [
        3,
        1
      ],
      [
        1,
        1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        1,
        -1
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        0,
        -4
      ],
      [
        1,
        -4
      ],
      [
        2,
        -4
      ],
      [
        2,
        -2
      ],
      [
        1,
        -4
      ],
      [
        1,
        -9
      ],
      [
        0,
        -11
      ],
      [
        -1,
        -13
      ],
      [
        2,
        -15
      ],
      [
        2,
        -5
      ],
      [
        1,
        -7
      ],
      [
        2,
        -4
      ],
      [
        2,
        -2
      ],
      [
        1,
        -6
      ],
      [
        2,
        -5
      ],
      [
        1,
        -5
      ],
      [
        2,
        -6
      ],
      [
        2,
        -3
      ],
      [
        1,
        -5
      ],
      [
        1,
        -3
      ],
      [
        1,
        -5
      ],
      [
        1,
        -7
      ],
      [
        0,
        -21
      ],
      [
        2,
        -5
      ],
      [
        1,
        -1
      ],
      [
        2,
        -1
      ],
      [
        1,
        0
      ],
      [
        2,
        -1
      ],
      [
        1,
        3
      ],
      [
        1,
        1
      ],
      [
        0,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        1,
        -1
      ],
      [
        5,
        8
      ],
      [
        3,
        -1
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -6
      ]
    ],
    [
      [
        23303,
        50495
      ],
      [
        -23,
        -49
      ],
      [
        -20,
        -38
      ],
      [
        -7,
        -20
      ],
      [
        -35,
        -80
      ],
      [
        -20,
        -37
      ],
      [
        -33,
        -52
      ],
      [
        -21,
        -37
      ],
      [
        -33,
        -64
      ],
      [
        -7,
        -11
      ],
      [
        -7,
        -20
      ],
      [
        -7,
        -15
      ],
      [
        -9,
        -24
      ],
      [
        -5,
        -19
      ],
      [
        -2,
        -2
      ],
      [
        -4,
        -7
      ],
      [
        -10,
        -32
      ]
    ],
    [
      [
        22342,
        55817
      ],
      [
        1,
        -513
      ]
    ],
    [
      [
        22343,
        55304
      ],
      [
        -40,
        0
      ]
    ],
    [
      [
        22198,
        55304
      ],
      [
        0,
        515
      ]
    ],
    [
      [
        24266,
        70670
      ],
      [
        136,
        1
      ],
      [
        3,
        -1
      ]
    ],
    [
      [
        24408,
        70065
      ],
      [
        -137,
        3
      ]
    ],
    [
      [
        24271,
        70068
      ],
      [
        0,
        204
      ],
      [
        -1,
        196
      ],
      [
        -4,
        0
      ],
      [
        0,
        202
      ]
    ],
    [
      [
        18574,
        61346
      ],
      [
        2,
        2
      ],
      [
        8,
        1
      ]
    ],
    [
      [
        19085,
        60640
      ],
      [
        -99,
        0
      ],
      [
        -3,
        -1
      ],
      [
        -224,
        0
      ],
      [
        -8,
        -5
      ],
      [
        -89,
        1
      ],
      [
        -55,
        8
      ],
      [
        -90,
        0
      ]
    ],
    [
      [
        18517,
        60643
      ],
      [
        0,
        202
      ],
      [
        -1,
        13
      ],
      [
        0,
        90
      ],
      [
        12,
        1
      ],
      [
        18,
        -2
      ],
      [
        1,
        90
      ],
      [
        -3,
        10
      ],
      [
        33,
        0
      ],
      [
        1,
        101
      ],
      [
        -4,
        1
      ],
      [
        0,
        197
      ]
    ],
    [
      [
        23034,
        65124
      ],
      [
        40,
        0
      ]
    ],
    [
      [
        23187,
        64889
      ],
      [
        -76,
        0
      ],
      [
        -37,
        -1
      ]
    ],
    [
      [
        26998,
        59540
      ],
      [
        18,
        36
      ],
      [
        6,
        0
      ],
      [
        12,
        14
      ],
      [
        -5,
        35
      ],
      [
        -3,
        2
      ],
      [
        3,
        8
      ],
      [
        4,
        -11
      ],
      [
        -1,
        -11
      ],
      [
        4,
        -8
      ],
      [
        0,
        -25
      ],
      [
        -11,
        -41
      ]
    ],
    [
      [
        27025,
        59539
      ],
      [
        -12,
        0
      ],
      [
        -6,
        1
      ],
      [
        -9,
        0
      ]
    ],
    [
      [
        22755,
        72433
      ],
      [
        162,
        0
      ]
    ],
    [
      [
        22928,
        72232
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -6
      ],
      [
        1,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -35
      ],
      [
        -1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -10
      ],
      [
        1,
        -4
      ],
      [
        2,
        -2
      ],
      [
        0,
        -3
      ],
      [
        1,
        -4
      ],
      [
        1,
        -3
      ],
      [
        0,
        -7
      ],
      [
        1,
        -2
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -2
      ],
      [
        -1,
        0
      ],
      [
        0,
        -4
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        1,
        -3
      ],
      [
        0,
        -8
      ],
      [
        1,
        0
      ],
      [
        0,
        -12
      ],
      [
        1,
        -6
      ],
      [
        1,
        -3
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -7
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        0,
        -7
      ],
      [
        -3,
        -14
      ],
      [
        0,
        -3
      ],
      [
        1,
        -7
      ],
      [
        0,
        -13
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -15
      ],
      [
        2,
        -3
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        1,
        -3
      ]
    ],
    [
      [
        24362,
        57080
      ],
      [
        -1,
        -203
      ],
      [
        -1,
        -86
      ],
      [
        33,
        -6
      ],
      [
        0,
        -20
      ],
      [
        6,
        13
      ],
      [
        7,
        0
      ],
      [
        5,
        -9
      ],
      [
        0,
        -36
      ],
      [
        4,
        -15
      ],
      [
        -2,
        -9
      ],
      [
        2,
        -25
      ],
      [
        6,
        8
      ],
      [
        0,
        -26
      ],
      [
        4,
        9
      ],
      [
        7,
        -1
      ],
      [
        3,
        -9
      ],
      [
        -1,
        -6
      ],
      [
        2,
        -28
      ],
      [
        -2,
        -19
      ]
    ],
    [
      [
        24434,
        56612
      ],
      [
        -6,
        5
      ],
      [
        -10,
        -13
      ],
      [
        -5,
        16
      ],
      [
        -3,
        12
      ],
      [
        -5,
        10
      ],
      [
        -5,
        -6
      ],
      [
        -4,
        -14
      ],
      [
        -5,
        -1
      ],
      [
        -2,
        17
      ],
      [
        2,
        17
      ],
      [
        5,
        9
      ],
      [
        -2,
        10
      ],
      [
        -7,
        -7
      ],
      [
        -8,
        12
      ],
      [
        -14,
        38
      ],
      [
        -5,
        3
      ],
      [
        -4,
        1
      ],
      [
        0,
        -127
      ],
      [
        -5,
        0
      ],
      [
        0,
        34
      ],
      [
        -29,
        -1
      ],
      [
        -29,
        0
      ],
      [
        0,
        -34
      ]
    ],
    [
      [
        24215,
        56591
      ],
      [
        0,
        196
      ],
      [
        5,
        -1
      ],
      [
        1,
        68
      ],
      [
        0,
        114
      ],
      [
        1,
        22
      ],
      [
        0,
        102
      ]
    ],
    [
      [
        24486,
        59147
      ],
      [
        5,
        -1
      ],
      [
        0,
        -37
      ],
      [
        3,
        18
      ],
      [
        1,
        -19
      ],
      [
        7,
        -7
      ],
      [
        5,
        -15
      ],
      [
        6,
        0
      ],
      [
        2,
        -17
      ],
      [
        3,
        -13
      ],
      [
        1,
        -16
      ],
      [
        6,
        -15
      ],
      [
        10,
        -3
      ],
      [
        -1,
        -21
      ],
      [
        4,
        -9
      ],
      [
        0,
        -12
      ],
      [
        3,
        5
      ],
      [
        -1,
        28
      ],
      [
        4,
        11
      ],
      [
        2,
        -1
      ],
      [
        25,
        -1
      ],
      [
        20,
        0
      ],
      [
        20,
        -2
      ]
    ],
    [
      [
        24611,
        59020
      ],
      [
        18,
        0
      ],
      [
        0,
        -3
      ],
      [
        -5,
        -14
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -16
      ],
      [
        -5,
        -24
      ],
      [
        -9,
        -16
      ],
      [
        -1,
        -28
      ],
      [
        -4,
        -18
      ],
      [
        1,
        -21
      ],
      [
        -5,
        -23
      ],
      [
        -1,
        -13
      ],
      [
        5,
        -15
      ],
      [
        -3,
        -12
      ]
    ],
    [
      [
        24600,
        58809
      ],
      [
        -3,
        -14
      ],
      [
        1,
        -6
      ],
      [
        -1,
        -31
      ],
      [
        -3,
        0
      ],
      [
        0,
        -50
      ],
      [
        -45,
        5
      ]
    ],
    [
      [
        24459,
        58719
      ],
      [
        1,
        104
      ],
      [
        0,
        207
      ],
      [
        1,
        85
      ],
      [
        5,
        0
      ],
      [
        0,
        16
      ],
      [
        20,
        -1
      ],
      [
        0,
        17
      ]
    ],
    [
      [
        28343,
        60282
      ],
      [
        -1,
        38
      ],
      [
        -2,
        4
      ],
      [
        -1,
        8
      ],
      [
        6,
        7
      ],
      [
        3,
        -12
      ],
      [
        2,
        18
      ],
      [
        6,
        13
      ],
      [
        2,
        -19
      ],
      [
        -5,
        -17
      ],
      [
        -1,
        -29
      ],
      [
        -6,
        -6
      ]
    ],
    [
      [
        23151,
        54197
      ],
      [
        174,
        91
      ]
    ],
    [
      [
        23325,
        54288
      ],
      [
        -3,
        -18
      ],
      [
        1,
        -18
      ],
      [
        3,
        -7
      ],
      [
        -3,
        -19
      ],
      [
        3,
        -14
      ],
      [
        -6,
        -24
      ],
      [
        -2,
        -25
      ],
      [
        2,
        -15
      ],
      [
        -2,
        -5
      ],
      [
        2,
        -16
      ],
      [
        6,
        -24
      ],
      [
        -4,
        -28
      ],
      [
        2,
        -24
      ],
      [
        -4,
        -27
      ],
      [
        -1,
        -16
      ],
      [
        10,
        -9
      ],
      [
        2,
        -16
      ],
      [
        1,
        -25
      ],
      [
        2,
        -16
      ],
      [
        -2,
        -29
      ],
      [
        6,
        -11
      ],
      [
        5,
        0
      ],
      [
        -1,
        -30
      ],
      [
        7,
        10
      ],
      [
        2,
        -9
      ],
      [
        -2,
        -11
      ],
      [
        4,
        -1
      ],
      [
        4,
        -23
      ],
      [
        6,
        -16
      ],
      [
        4,
        -31
      ],
      [
        -3,
        -17
      ],
      [
        1,
        -20
      ],
      [
        5,
        -1
      ],
      [
        2,
        -16
      ],
      [
        -4,
        -21
      ]
    ],
    [
      [
        23368,
        53716
      ],
      [
        -106,
        -59
      ],
      [
        2,
        -17
      ],
      [
        -26,
        -27
      ]
    ],
    [
      [
        23238,
        53613
      ],
      [
        1,
        17
      ],
      [
        -6,
        17
      ],
      [
        2,
        22
      ],
      [
        9,
        2
      ],
      [
        0,
        21
      ],
      [
        -3,
        13
      ],
      [
        5,
        23
      ],
      [
        0,
        15
      ],
      [
        -7,
        44
      ],
      [
        -6,
        -12
      ],
      [
        2,
        -30
      ],
      [
        -5,
        -23
      ],
      [
        -3,
        5
      ],
      [
        -2,
        19
      ]
    ],
    [
      [
        23225,
        53746
      ],
      [
        -1,
        2
      ],
      [
        0,
        9
      ],
      [
        -2,
        4
      ],
      [
        1,
        10
      ],
      [
        1,
        10
      ],
      [
        -1,
        11
      ],
      [
        1,
        10
      ],
      [
        2,
        14
      ],
      [
        0,
        9
      ],
      [
        -1,
        5
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -9
      ],
      [
        -2,
        -7
      ],
      [
        -3,
        2
      ],
      [
        -3,
        13
      ],
      [
        -2,
        5
      ],
      [
        -4,
        5
      ],
      [
        -4,
        -2
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        5
      ],
      [
        -1,
        4
      ],
      [
        0,
        4
      ],
      [
        1,
        3
      ],
      [
        0,
        7
      ],
      [
        1,
        10
      ],
      [
        1,
        1
      ],
      [
        0,
        18
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        4
      ],
      [
        1,
        5
      ],
      [
        1,
        -1
      ],
      [
        1,
        4
      ],
      [
        -1,
        5
      ],
      [
        -1,
        5
      ],
      [
        -3,
        4
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        2
      ],
      [
        0,
        6
      ],
      [
        1,
        3
      ],
      [
        -2,
        4
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        3
      ],
      [
        -2,
        0
      ],
      [
        -2,
        4
      ],
      [
        -1,
        2
      ],
      [
        -5,
        3
      ],
      [
        -1,
        6
      ],
      [
        -1,
        7
      ],
      [
        -3,
        1
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        2
      ],
      [
        1,
        8
      ],
      [
        1,
        15
      ],
      [
        0,
        30
      ],
      [
        -3,
        9
      ],
      [
        -2,
        1
      ],
      [
        1,
        7
      ],
      [
        0,
        5
      ],
      [
        1,
        10
      ],
      [
        2,
        5
      ],
      [
        1,
        5
      ],
      [
        1,
        4
      ],
      [
        1,
        -1
      ],
      [
        0,
        5
      ],
      [
        -2,
        2
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -4
      ],
      [
        0,
        2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        5
      ],
      [
        -1,
        3
      ],
      [
        0,
        4
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        1
      ],
      [
        0,
        15
      ],
      [
        1,
        7
      ],
      [
        1,
        13
      ],
      [
        1,
        2
      ],
      [
        0,
        4
      ],
      [
        1,
        1
      ],
      [
        1,
        -3
      ],
      [
        0,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        7
      ],
      [
        -1,
        6
      ],
      [
        0,
        6
      ],
      [
        -2,
        7
      ],
      [
        0,
        6
      ],
      [
        -2,
        3
      ],
      [
        1,
        7
      ],
      [
        0,
        5
      ],
      [
        -1,
        6
      ],
      [
        -2,
        5
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -3,
        -4
      ],
      [
        0,
        -5
      ],
      [
        -1,
        2
      ],
      [
        -1,
        3
      ],
      [
        -2,
        0
      ],
      [
        -1,
        4
      ],
      [
        -1,
        6
      ],
      [
        1,
        2
      ],
      [
        2,
        1
      ],
      [
        1,
        -2
      ],
      [
        1,
        4
      ],
      [
        -1,
        5
      ],
      [
        -1,
        2
      ],
      [
        -1,
        5
      ],
      [
        -1,
        1
      ],
      [
        -1,
        4
      ],
      [
        0,
        5
      ],
      [
        1,
        5
      ],
      [
        2,
        8
      ],
      [
        0,
        14
      ]
    ],
    [
      [
        25088,
        59945
      ],
      [
        5,
        -33
      ],
      [
        5,
        9
      ],
      [
        -2,
        10
      ],
      [
        6,
        5
      ],
      [
        0,
        -11
      ],
      [
        6,
        -3
      ],
      [
        4,
        7
      ],
      [
        7,
        -12
      ],
      [
        7,
        13
      ],
      [
        3,
        -3
      ],
      [
        10,
        16
      ],
      [
        3,
        -5
      ],
      [
        5,
        9
      ],
      [
        10,
        8
      ],
      [
        2,
        -6
      ],
      [
        8,
        8
      ]
    ],
    [
      [
        25168,
        59746
      ],
      [
        -53,
        -1
      ],
      [
        -18,
        1
      ],
      [
        1,
        17
      ],
      [
        -11,
        11
      ],
      [
        -6,
        -14
      ]
    ],
    [
      [
        26462,
        58620
      ],
      [
        2,
        -12
      ],
      [
        4,
        1
      ],
      [
        1,
        26
      ],
      [
        2,
        19
      ],
      [
        -3,
        17
      ],
      [
        6,
        -6
      ],
      [
        0,
        -15
      ],
      [
        12,
        23
      ],
      [
        4,
        -23
      ],
      [
        5,
        2
      ],
      [
        0,
        21
      ],
      [
        4,
        3
      ],
      [
        3,
        -15
      ],
      [
        4,
        3
      ],
      [
        -1,
        26
      ],
      [
        -4,
        12
      ],
      [
        12,
        1
      ],
      [
        2,
        -16
      ],
      [
        9,
        15
      ],
      [
        10,
        -34
      ],
      [
        16,
        -6
      ],
      [
        11,
        40
      ],
      [
        0,
        4
      ],
      [
        5,
        9
      ]
    ],
    [
      [
        26603,
        58345
      ],
      [
        -3,
        0
      ],
      [
        -1,
        1
      ],
      [
        -2,
        -2
      ],
      [
        -4,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -4,
        -6
      ],
      [
        0,
        -2
      ],
      [
        -3,
        2
      ],
      [
        -1,
        3
      ],
      [
        -4,
        -5
      ],
      [
        -2,
        2
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        1
      ],
      [
        0,
        -6
      ],
      [
        -2,
        -8
      ],
      [
        -2,
        -4
      ],
      [
        -4,
        -6
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -3
      ],
      [
        -5,
        -12
      ],
      [
        0,
        1
      ],
      [
        -2,
        0
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        2
      ],
      [
        -1,
        1
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -11
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -7
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        26522,
        58219
      ],
      [
        -1,
        3
      ],
      [
        -1,
        1
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        26520,
        58222
      ],
      [
        -2,
        9
      ],
      [
        8,
        19
      ],
      [
        -6,
        2
      ],
      [
        -5,
        13
      ],
      [
        -2,
        -16
      ],
      [
        -7,
        34
      ],
      [
        5,
        17
      ],
      [
        -1,
        26
      ],
      [
        -13,
        -13
      ],
      [
        -7,
        5
      ],
      [
        -4,
        -6
      ],
      [
        -4,
        14
      ],
      [
        2,
        8
      ],
      [
        -2,
        18
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        16
      ],
      [
        -5,
        -13
      ],
      [
        -8,
        19
      ],
      [
        -6,
        7
      ],
      [
        -2,
        14
      ]
    ],
    [
      [
        25201,
        58919
      ],
      [
        4,
        5
      ],
      [
        7,
        -3
      ],
      [
        0,
        62
      ],
      [
        34,
        -2
      ],
      [
        0,
        42
      ]
    ],
    [
      [
        25246,
        59023
      ],
      [
        12,
        -1
      ],
      [
        4,
        -1
      ],
      [
        73,
        -5
      ],
      [
        0,
        -30
      ]
    ],
    [
      [
        25345,
        58667
      ],
      [
        -1,
        -34
      ]
    ],
    [
      [
        25258,
        59430
      ],
      [
        5,
        0
      ],
      [
        5,
        -1
      ],
      [
        1,
        1
      ],
      [
        9,
        -1
      ],
      [
        27,
        0
      ],
      [
        54,
        -2
      ],
      [
        20,
        -2
      ]
    ],
    [
      [
        25379,
        59425
      ],
      [
        1,
        -30
      ],
      [
        -3,
        -32
      ],
      [
        7,
        -27
      ],
      [
        13,
        -70
      ]
    ],
    [
      [
        25246,
        59023
      ],
      [
        4,
        407
      ]
    ],
    [
      [
        29573,
        66195
      ],
      [
        13,
        36
      ],
      [
        16,
        -4
      ],
      [
        3,
        -9
      ],
      [
        2,
        -78
      ],
      [
        -9,
        -31
      ],
      [
        11,
        -26
      ],
      [
        1,
        8
      ],
      [
        3,
        20
      ],
      [
        12,
        5
      ],
      [
        6,
        -10
      ],
      [
        3,
        -43
      ],
      [
        27,
        -19
      ],
      [
        -1,
        35
      ],
      [
        6,
        14
      ],
      [
        3,
        3
      ],
      [
        6,
        54
      ],
      [
        6,
        14
      ],
      [
        1,
        -1
      ],
      [
        3,
        -20
      ],
      [
        -7,
        -40
      ],
      [
        9,
        -26
      ],
      [
        6,
        3
      ],
      [
        7,
        3
      ],
      [
        6,
        2
      ],
      [
        21,
        10
      ],
      [
        12,
        6
      ],
      [
        3,
        -54
      ],
      [
        10,
        5
      ],
      [
        -2,
        20
      ],
      [
        8,
        15
      ],
      [
        1,
        1
      ],
      [
        12,
        13
      ],
      [
        9,
        -3
      ],
      [
        3,
        15
      ],
      [
        7,
        3
      ]
    ],
    [
      [
        29790,
        66116
      ],
      [
        -11,
        -49
      ],
      [
        -1,
        -22
      ],
      [
        18,
        -26
      ],
      [
        16,
        -1
      ],
      [
        2,
        1
      ],
      [
        0,
        -153
      ]
    ],
    [
      [
        29814,
        65866
      ],
      [
        -19,
        1
      ],
      [
        -13,
        1
      ],
      [
        -18,
        0
      ],
      [
        -14,
        1
      ],
      [
        -9,
        0
      ],
      [
        -16,
        1
      ],
      [
        -15,
        1
      ]
    ],
    [
      [
        29710,
        65871
      ],
      [
        -5,
        0
      ],
      [
        -7,
        -3
      ],
      [
        -6,
        -2
      ],
      [
        -2,
        -6
      ],
      [
        -7,
        0
      ],
      [
        0,
        7
      ],
      [
        -10,
        1
      ],
      [
        -15,
        6
      ],
      [
        -17,
        -1
      ],
      [
        0,
        -3
      ],
      [
        1,
        -2
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        1
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -6
      ],
      [
        -2,
        -1
      ],
      [
        -12,
        -5
      ],
      [
        1,
        45
      ],
      [
        -9,
        1
      ],
      [
        -5,
        1
      ],
      [
        -32,
        1
      ],
      [
        -8,
        0
      ]
    ],
    [
      [
        29571,
        65876
      ],
      [
        -13,
        1
      ]
    ],
    [
      [
        23972,
        62785
      ],
      [
        -10,
        -6
      ],
      [
        -7,
        31
      ],
      [
        -5,
        7
      ],
      [
        -5,
        -11
      ],
      [
        3,
        -23
      ],
      [
        0,
        -19
      ],
      [
        -7,
        -32
      ],
      [
        -4,
        -12
      ],
      [
        -7,
        12
      ],
      [
        -6,
        -31
      ],
      [
        -4,
        -2
      ],
      [
        -11,
        0
      ],
      [
        -4,
        -14
      ],
      [
        0,
        -12
      ],
      [
        5,
        -25
      ],
      [
        -2,
        -18
      ],
      [
        -9,
        -20
      ],
      [
        -8,
        -8
      ],
      [
        -5,
        10
      ],
      [
        3,
        29
      ],
      [
        -2,
        9
      ],
      [
        -10,
        1
      ],
      [
        -5,
        28
      ],
      [
        -4,
        0
      ]
    ],
    [
      [
        22689,
        51891
      ],
      [
        15,
        56
      ],
      [
        2,
        -6
      ]
    ],
    [
      [
        22706,
        51941
      ],
      [
        93,
        -327
      ]
    ],
    [
      [
        22710,
        51454
      ],
      [
        -6,
        10
      ],
      [
        1,
        10
      ],
      [
        -10,
        7
      ],
      [
        -3,
        -7
      ],
      [
        -1,
        17
      ],
      [
        -5,
        1
      ],
      [
        -6,
        19
      ],
      [
        1,
        17
      ],
      [
        -8,
        7
      ],
      [
        2,
        7
      ],
      [
        -3,
        8
      ],
      [
        -3,
        32
      ],
      [
        -5,
        -8
      ],
      [
        0,
        16
      ],
      [
        -4,
        17
      ],
      [
        -1,
        11
      ],
      [
        -3,
        -13
      ],
      [
        0,
        17
      ],
      [
        -4,
        6
      ],
      [
        0,
        30
      ],
      [
        -2,
        22
      ],
      [
        -4,
        15
      ],
      [
        -3,
        2
      ]
    ],
    [
      [
        22643,
        51697
      ],
      [
        -7,
        -1
      ],
      [
        2,
        31
      ],
      [
        12,
        37
      ],
      [
        16,
        34
      ],
      [
        9,
        49
      ],
      [
        13,
        39
      ],
      [
        1,
        5
      ]
    ],
    [
      [
        29472,
        67872
      ],
      [
        37,
        13
      ],
      [
        7,
        2
      ],
      [
        -4,
        82
      ],
      [
        18,
        6
      ],
      [
        35,
        5
      ],
      [
        4,
        -48
      ],
      [
        16,
        25
      ]
    ],
    [
      [
        29610,
        67345
      ],
      [
        -30,
        4
      ],
      [
        -4,
        -15
      ],
      [
        1,
        16
      ],
      [
        -38,
        4
      ],
      [
        -37,
        7
      ]
    ],
    [
      [
        29502,
        67361
      ],
      [
        1,
        47
      ],
      [
        0,
        19
      ],
      [
        1,
        105
      ],
      [
        0,
        62
      ],
      [
        1,
        5
      ],
      [
        -1,
        0
      ],
      [
        0,
        5
      ],
      [
        1,
        3
      ],
      [
        1,
        2
      ],
      [
        0,
        9
      ],
      [
        -1,
        6
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        13
      ],
      [
        -1,
        3
      ],
      [
        -2,
        9
      ],
      [
        -1,
        5
      ],
      [
        -2,
        4
      ],
      [
        -3,
        2
      ],
      [
        0,
        4
      ],
      [
        -1,
        2
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        1
      ],
      [
        0,
        4
      ],
      [
        1,
        2
      ],
      [
        0,
        1
      ],
      [
        -1,
        3
      ],
      [
        1,
        6
      ],
      [
        0,
        11
      ],
      [
        -1,
        3
      ],
      [
        -1,
        6
      ],
      [
        0,
        1
      ],
      [
        -1,
        16
      ],
      [
        0,
        3
      ],
      [
        -1,
        1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        1
      ],
      [
        -1,
        3
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -4,
        1
      ],
      [
        -2,
        -5
      ],
      [
        -3,
        3
      ],
      [
        -2,
        -1
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -2
      ],
      [
        1,
        -8
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -3
      ],
      [
        0,
        -15
      ],
      [
        1,
        -6
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -2,
        3
      ],
      [
        -3,
        7
      ],
      [
        -1,
        5
      ],
      [
        -2,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        3
      ],
      [
        0,
        4
      ],
      [
        2,
        10
      ],
      [
        1,
        5
      ],
      [
        0,
        4
      ],
      [
        -1,
        5
      ],
      [
        0,
        2
      ],
      [
        2,
        9
      ],
      [
        0,
        3
      ],
      [
        -3,
        13
      ],
      [
        0,
        3
      ],
      [
        1,
        7
      ],
      [
        0,
        3
      ],
      [
        2,
        3
      ],
      [
        1,
        5
      ],
      [
        0,
        7
      ],
      [
        2,
        13
      ],
      [
        0,
        5
      ],
      [
        1,
        9
      ],
      [
        0,
        4
      ],
      [
        -1,
        4
      ],
      [
        1,
        2
      ],
      [
        0,
        4
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        1,
        3
      ],
      [
        0,
        5
      ],
      [
        2,
        9
      ],
      [
        1,
        3
      ],
      [
        1,
        4
      ],
      [
        2,
        9
      ],
      [
        0,
        22
      ],
      [
        2,
        11
      ]
    ],
    [
      [
        15990,
        69125
      ],
      [
        8,
        -5
      ],
      [
        177,
        -3
      ],
      [
        49,
        0
      ],
      [
        151,
        -2
      ]
    ],
    [
      [
        16375,
        69115
      ],
      [
        -9,
        -31
      ],
      [
        5,
        -39
      ],
      [
        0,
        -230
      ]
    ],
    [
      [
        16371,
        68815
      ],
      [
        -123,
        -1
      ],
      [
        0,
        -100
      ],
      [
        -45,
        0
      ],
      [
        0,
        -101
      ],
      [
        -33,
        1
      ]
    ],
    [
      [
        16170,
        68614
      ],
      [
        -33,
        0
      ],
      [
        -1,
        2
      ],
      [
        -171,
        0
      ]
    ],
    [
      [
        27093,
        60176
      ],
      [
        10,
        18
      ],
      [
        3,
        19
      ],
      [
        16,
        14
      ],
      [
        10,
        18
      ],
      [
        7,
        43
      ]
    ],
    [
      [
        27282,
        60284
      ],
      [
        -5,
        -13
      ],
      [
        -12,
        -9
      ],
      [
        6,
        -50
      ],
      [
        -14,
        -16
      ],
      [
        -5,
        -12
      ],
      [
        1,
        -12
      ],
      [
        16,
        -13
      ],
      [
        3,
        -15
      ],
      [
        -3,
        -25
      ],
      [
        -15,
        -30
      ],
      [
        -9,
        -11
      ],
      [
        -12,
        0
      ],
      [
        -10,
        -20
      ],
      [
        -7,
        -6
      ],
      [
        7,
        -30
      ]
    ],
    [
      [
        27223,
        60022
      ],
      [
        -12,
        -28
      ],
      [
        2,
        15
      ],
      [
        -1,
        23
      ],
      [
        -5,
        -4
      ],
      [
        -5,
        -14
      ],
      [
        -18,
        -16
      ],
      [
        -18,
        -48
      ],
      [
        -12,
        -18
      ],
      [
        -7,
        52
      ],
      [
        -5,
        -9
      ],
      [
        -15,
        -13
      ]
    ],
    [
      [
        27127,
        59962
      ],
      [
        -7,
        70
      ],
      [
        -3,
        23
      ],
      [
        -3,
        18
      ],
      [
        -18,
        69
      ],
      [
        -3,
        34
      ]
    ],
    [
      [
        28171,
        62647
      ],
      [
        0,
        -1
      ],
      [
        57,
        -153
      ]
    ],
    [
      [
        28191,
        62355
      ],
      [
        -8,
        -21
      ],
      [
        -4,
        -19
      ]
    ],
    [
      [
        28179,
        62315
      ],
      [
        -12,
        37
      ],
      [
        -3,
        9
      ],
      [
        -11,
        -7
      ],
      [
        -15,
        27
      ]
    ],
    [
      [
        28138,
        62381
      ],
      [
        3,
        29
      ],
      [
        4,
        32
      ],
      [
        5,
        8
      ],
      [
        0,
        29
      ],
      [
        5,
        31
      ],
      [
        2,
        13
      ],
      [
        3,
        23
      ],
      [
        -1,
        31
      ],
      [
        9,
        37
      ],
      [
        3,
        33
      ]
    ],
    [
      [
        31378,
        38070
      ],
      [
        14,
        30
      ],
      [
        8,
        -1
      ]
    ],
    [
      [
        31400,
        38099
      ],
      [
        1,
        -4
      ],
      [
        1,
        0
      ],
      [
        5,
        -33
      ],
      [
        -3,
        -33
      ],
      [
        2,
        -21
      ],
      [
        -2,
        -19
      ]
    ],
    [
      [
        26685,
        52165
      ],
      [
        33,
        0
      ]
    ],
    [
      [
        26718,
        52165
      ],
      [
        -1,
        -25
      ],
      [
        3,
        -13
      ],
      [
        -2,
        -31
      ],
      [
        0,
        -20
      ],
      [
        4,
        -18
      ],
      [
        -1,
        -19
      ],
      [
        4,
        -20
      ],
      [
        -1,
        -25
      ],
      [
        4,
        -12
      ],
      [
        3,
        3
      ],
      [
        5,
        -13
      ],
      [
        7,
        18
      ],
      [
        7,
        -15
      ],
      [
        5,
        8
      ],
      [
        1,
        -15
      ],
      [
        12,
        -11
      ],
      [
        1,
        -19
      ],
      [
        7,
        -12
      ],
      [
        8,
        -27
      ],
      [
        2,
        -24
      ],
      [
        7,
        -6
      ],
      [
        5,
        -15
      ],
      [
        0,
        -21
      ],
      [
        3,
        -20
      ],
      [
        6,
        -1
      ],
      [
        2,
        -31
      ],
      [
        -1,
        -11
      ],
      [
        4,
        -19
      ],
      [
        -2,
        -10
      ],
      [
        7,
        5
      ],
      [
        4,
        -16
      ]
    ],
    [
      [
        26821,
        51730
      ],
      [
        1,
        -23
      ],
      [
        -4,
        -25
      ],
      [
        -1,
        -22
      ],
      [
        -8,
        -3
      ]
    ],
    [
      [
        26698,
        51656
      ],
      [
        -9,
        -1
      ],
      [
        0,
        76
      ],
      [
        -5,
        1
      ],
      [
        1,
        348
      ],
      [
        0,
        85
      ]
    ],
    [
      [
        23298,
        60457
      ],
      [
        -82,
        2
      ],
      [
        -40,
        2
      ]
    ],
    [
      [
        25397,
        61477
      ],
      [
        -11,
        -5
      ],
      [
        -34,
        1
      ]
    ],
    [
      [
        22462,
        72716
      ],
      [
        -28,
        2
      ],
      [
        -3,
        17
      ],
      [
        3,
        7
      ],
      [
        -11,
        32
      ],
      [
        -2,
        42
      ],
      [
        -6,
        4
      ],
      [
        -8,
        -8
      ],
      [
        -4,
        -19
      ],
      [
        -7,
        -11
      ],
      [
        -9,
        -24
      ],
      [
        4,
        26
      ],
      [
        8,
        11
      ],
      [
        -4,
        21
      ],
      [
        0,
        33
      ],
      [
        -1,
        -35
      ],
      [
        -4,
        3
      ],
      [
        -1,
        33
      ],
      [
        -5,
        35
      ],
      [
        -6,
        3
      ],
      [
        -3,
        -16
      ],
      [
        -13,
        -28
      ],
      [
        -1,
        -18
      ],
      [
        -3,
        21
      ],
      [
        -6,
        -11
      ],
      [
        1,
        -16
      ],
      [
        -4,
        -8
      ],
      [
        -4,
        6
      ],
      [
        -13,
        -14
      ],
      [
        1,
        26
      ],
      [
        -5,
        34
      ],
      [
        1,
        13
      ],
      [
        -10,
        -7
      ],
      [
        -6,
        -29
      ],
      [
        -3,
        0
      ],
      [
        0,
        100
      ],
      [
        -11,
        -1
      ],
      [
        -8,
        42
      ],
      [
        -17,
        14
      ],
      [
        0,
        251
      ]
    ],
    [
      [
        23340,
        64178
      ],
      [
        10,
        0
      ],
      [
        32,
        -2
      ],
      [
        6,
        0
      ]
    ],
    [
      [
        23388,
        64176
      ],
      [
        0,
        -116
      ],
      [
        6,
        0
      ],
      [
        0,
        -253
      ]
    ],
    [
      [
        23394,
        63807
      ],
      [
        -105,
        3
      ]
    ],
    [
      [
        23289,
        63810
      ],
      [
        0,
        8
      ],
      [
        1,
        12
      ],
      [
        0,
        12
      ],
      [
        -2,
        5
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        -4,
        0
      ],
      [
        -2,
        3
      ],
      [
        0,
        2
      ],
      [
        -3,
        7
      ],
      [
        -2,
        3
      ],
      [
        -1,
        2
      ],
      [
        -2,
        0
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        -5
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        2
      ],
      [
        0,
        1
      ],
      [
        -1,
        3
      ],
      [
        0,
        11
      ],
      [
        1,
        3
      ],
      [
        1,
        4
      ],
      [
        4,
        4
      ],
      [
        1,
        2
      ],
      [
        2,
        4
      ],
      [
        0,
        17
      ],
      [
        -1,
        4
      ],
      [
        -1,
        6
      ],
      [
        -1,
        4
      ],
      [
        -2,
        6
      ],
      [
        0,
        24
      ],
      [
        -2,
        11
      ],
      [
        -3,
        14
      ],
      [
        0,
        12
      ],
      [
        1,
        7
      ],
      [
        0,
        20
      ],
      [
        -2,
        11
      ],
      [
        -2,
        6
      ],
      [
        -2,
        4
      ],
      [
        -2,
        4
      ],
      [
        -2,
        7
      ],
      [
        -1,
        2
      ],
      [
        0,
        33
      ],
      [
        -1,
        7
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        7,
        8
      ],
      [
        2,
        3
      ],
      [
        1,
        7
      ],
      [
        1,
        17
      ],
      [
        0,
        4
      ],
      [
        -1,
        6
      ],
      [
        -1,
        4
      ],
      [
        -1,
        8
      ],
      [
        -2,
        7
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -26
      ],
      [
        -3,
        -8
      ],
      [
        -1,
        2
      ]
    ],
    [
      [
        27841,
        59477
      ],
      [
        2,
        46
      ],
      [
        15,
        244
      ],
      [
        18,
        315
      ]
    ],
    [
      [
        27876,
        60082
      ],
      [
        9,
        -18
      ],
      [
        12,
        -8
      ],
      [
        4,
        -10
      ],
      [
        9,
        23
      ],
      [
        18,
        -33
      ]
    ],
    [
      [
        27928,
        60036
      ],
      [
        4,
        -24
      ],
      [
        -3,
        -25
      ],
      [
        3,
        -4
      ],
      [
        6,
        11
      ],
      [
        15,
        -2
      ],
      [
        3,
        -9
      ],
      [
        3,
        -24
      ],
      [
        5,
        0
      ],
      [
        0,
        29
      ],
      [
        8,
        7
      ],
      [
        -3,
        13
      ],
      [
        2,
        12
      ],
      [
        3,
        -8
      ],
      [
        2,
        -61
      ],
      [
        2,
        -13
      ],
      [
        -6,
        -10
      ],
      [
        -1,
        -11
      ],
      [
        8,
        -16
      ],
      [
        8,
        -32
      ],
      [
        2,
        -17
      ],
      [
        4,
        -7
      ],
      [
        2,
        -20
      ],
      [
        -5,
        -10
      ],
      [
        -1,
        -9
      ],
      [
        5,
        -15
      ],
      [
        -4,
        -17
      ],
      [
        0,
        -11
      ],
      [
        5,
        -27
      ],
      [
        -7,
        -26
      ],
      [
        5,
        -25
      ],
      [
        2,
        -16
      ],
      [
        5,
        -10
      ]
    ],
    [
      [
        28000,
        59659
      ],
      [
        2,
        -4
      ],
      [
        5,
        -26
      ],
      [
        13,
        -29
      ],
      [
        4,
        -6
      ],
      [
        3,
        -18
      ],
      [
        -4,
        16
      ],
      [
        -4,
        -2
      ],
      [
        -4,
        16
      ],
      [
        -9,
        17
      ],
      [
        -4,
        20
      ],
      [
        -4,
        8
      ],
      [
        -6,
        -3
      ],
      [
        -6,
        -23
      ],
      [
        -4,
        -32
      ],
      [
        0,
        -37
      ],
      [
        -2,
        -24
      ],
      [
        1,
        -9
      ],
      [
        -6,
        -30
      ],
      [
        1,
        -16
      ]
    ],
    [
      [
        27976,
        59477
      ],
      [
        -18,
        0
      ]
    ],
    [
      [
        27863,
        59477
      ],
      [
        -22,
        0
      ]
    ],
    [
      [
        28426,
        62262
      ],
      [
        0,
        -6
      ],
      [
        1,
        -4
      ],
      [
        2,
        -8
      ],
      [
        1,
        -7
      ],
      [
        1,
        -2
      ],
      [
        2,
        -6
      ],
      [
        1,
        -2
      ],
      [
        2,
        -3
      ],
      [
        1,
        0
      ],
      [
        2,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        1,
        -12
      ],
      [
        2,
        -10
      ],
      [
        1,
        0
      ],
      [
        0,
        -1
      ],
      [
        1,
        -5
      ],
      [
        0,
        -5
      ],
      [
        1,
        1
      ],
      [
        0,
        4
      ],
      [
        1,
        -1
      ],
      [
        1,
        -3
      ],
      [
        0,
        -8
      ],
      [
        2,
        -16
      ],
      [
        0,
        -11
      ],
      [
        -3,
        -1
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        28447,
        62152
      ],
      [
        -3,
        1
      ],
      [
        -3,
        5
      ],
      [
        -6,
        -2
      ],
      [
        -1,
        -18
      ],
      [
        -3,
        10
      ],
      [
        -2,
        7
      ],
      [
        -1,
        1
      ]
    ],
    [
      [
        28428,
        62156
      ],
      [
        -3,
        12
      ],
      [
        -4,
        15
      ],
      [
        -4,
        11
      ]
    ],
    [
      [
        28411,
        62214
      ],
      [
        1,
        4
      ],
      [
        3,
        11
      ],
      [
        3,
        9
      ],
      [
        2,
        6
      ],
      [
        4,
        14
      ],
      [
        2,
        4
      ]
    ],
    [
      [
        15740,
        73454
      ],
      [
        0,
        40
      ],
      [
        1,
        6
      ],
      [
        2,
        0
      ],
      [
        3,
        -19
      ],
      [
        5,
        -13
      ],
      [
        5,
        -8
      ],
      [
        3,
        -3
      ],
      [
        1,
        -4
      ],
      [
        2,
        -22
      ],
      [
        -3,
        4
      ],
      [
        -2,
        4
      ],
      [
        -3,
        1
      ],
      [
        -5,
        -9
      ],
      [
        -5,
        -4
      ],
      [
        -1,
        0
      ],
      [
        -2,
        4
      ],
      [
        -1,
        3
      ],
      [
        -1,
        7
      ],
      [
        1,
        13
      ]
    ],
    [
      [
        15727,
        73540
      ],
      [
        7,
        8
      ],
      [
        5,
        -23
      ],
      [
        -3,
        -2
      ],
      [
        -3,
        2
      ],
      [
        -3,
        4
      ],
      [
        -3,
        9
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        15785,
        73566
      ],
      [
        47,
        0
      ],
      [
        29,
        1
      ],
      [
        2,
        0
      ],
      [
        180,
        -4
      ],
      [
        183,
        -2
      ],
      [
        0,
        19
      ],
      [
        43,
        0
      ]
    ],
    [
      [
        16200,
        73160
      ],
      [
        -160,
        1
      ],
      [
        -1,
        2
      ],
      [
        -108,
        -2
      ],
      [
        -60,
        0
      ],
      [
        -5,
        1
      ],
      [
        -50,
        0
      ]
    ],
    [
      [
        15816,
        73162
      ],
      [
        -1,
        7
      ],
      [
        -7,
        26
      ],
      [
        -5,
        9
      ],
      [
        -5,
        5
      ],
      [
        -9,
        25
      ],
      [
        -2,
        2
      ],
      [
        -4,
        0
      ],
      [
        -3,
        4
      ],
      [
        -7,
        21
      ],
      [
        -2,
        16
      ],
      [
        -2,
        4
      ],
      [
        -2,
        7
      ],
      [
        -1,
        24
      ],
      [
        2,
        15
      ],
      [
        -2,
        5
      ],
      [
        -3,
        1
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -16
      ],
      [
        -9,
        -13
      ],
      [
        -12,
        -8
      ],
      [
        -3,
        6
      ],
      [
        -2,
        10
      ],
      [
        -2,
        17
      ],
      [
        1,
        5
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        2,
        0
      ],
      [
        3,
        14
      ],
      [
        -1,
        22
      ],
      [
        -2,
        6
      ],
      [
        -6,
        -2
      ],
      [
        -2,
        -14
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        4
      ],
      [
        -1,
        3
      ],
      [
        0,
        17
      ],
      [
        2,
        12
      ],
      [
        1,
        10
      ],
      [
        5,
        14
      ],
      [
        1,
        -2
      ],
      [
        1,
        -4
      ],
      [
        2,
        0
      ],
      [
        15,
        20
      ],
      [
        3,
        1
      ],
      [
        1,
        -1
      ],
      [
        1,
        -11
      ],
      [
        8,
        -4
      ],
      [
        3,
        -11
      ],
      [
        6,
        -38
      ],
      [
        1,
        0
      ],
      [
        2,
        2
      ],
      [
        3,
        -3
      ],
      [
        1,
        -4
      ],
      [
        3,
        -1
      ],
      [
        8,
        11
      ],
      [
        1,
        2
      ],
      [
        0,
        3
      ],
      [
        -1,
        6
      ],
      [
        -2,
        2
      ],
      [
        -1,
        12
      ],
      [
        -1,
        20
      ],
      [
        1,
        15
      ],
      [
        -1,
        7
      ],
      [
        -3,
        33
      ],
      [
        -2,
        10
      ],
      [
        -6,
        3
      ],
      [
        -2,
        1
      ],
      [
        0,
        9
      ],
      [
        6,
        2
      ],
      [
        4,
        -2
      ],
      [
        3,
        -14
      ],
      [
        1,
        -5
      ],
      [
        1,
        -1
      ],
      [
        10,
        13
      ],
      [
        3,
        13
      ],
      [
        2,
        21
      ],
      [
        -6,
        27
      ],
      [
        -5,
        4
      ],
      [
        -6,
        20
      ],
      [
        -1,
        2
      ]
    ],
    [
      [
        15715,
        73495
      ],
      [
        5,
        22
      ],
      [
        3,
        7
      ],
      [
        5,
        -14
      ],
      [
        1,
        -7
      ],
      [
        6,
        -26
      ],
      [
        -5,
        -29
      ],
      [
        -8,
        -5
      ],
      [
        -2,
        1
      ],
      [
        0,
        11
      ],
      [
        -2,
        19
      ],
      [
        -1,
        3
      ],
      [
        -1,
        6
      ],
      [
        -1,
        12
      ]
    ],
    [
      [
        20732,
        71200
      ],
      [
        0,
        51
      ],
      [
        35,
        0
      ],
      [
        0,
        33
      ]
    ],
    [
      [
        20924,
        71234
      ],
      [
        0,
        -117
      ]
    ],
    [
      [
        20924,
        70813
      ],
      [
        0,
        -182
      ],
      [
        -1,
        -144
      ],
      [
        1,
        -64
      ]
    ],
    [
      [
        20924,
        70423
      ],
      [
        0,
        -73
      ]
    ],
    [
      [
        20924,
        70350
      ],
      [
        -25,
        0
      ],
      [
        0,
        101
      ],
      [
        -54,
        2
      ],
      [
        -17,
        0
      ],
      [
        0,
        98
      ],
      [
        -35,
        0
      ],
      [
        0,
        95
      ],
      [
        -103,
        0
      ]
    ],
    [
      [
        28416,
        60141
      ],
      [
        18,
        66
      ],
      [
        5,
        18
      ],
      [
        7,
        8
      ],
      [
        1,
        13
      ],
      [
        5,
        -2
      ],
      [
        4,
        14
      ],
      [
        -2,
        8
      ],
      [
        1,
        16
      ],
      [
        3,
        -1
      ],
      [
        9,
        19
      ]
    ],
    [
      [
        28467,
        60300
      ],
      [
        0,
        -3
      ],
      [
        8,
        -14
      ]
    ],
    [
      [
        28475,
        60283
      ],
      [
        -2,
        -4
      ],
      [
        6,
        -16
      ],
      [
        5,
        -17
      ],
      [
        5,
        -3
      ],
      [
        7,
        11
      ],
      [
        9,
        -4
      ],
      [
        9,
        -9
      ],
      [
        1,
        -10
      ],
      [
        12,
        -32
      ],
      [
        2,
        -13
      ],
      [
        3,
        -5
      ],
      [
        2,
        -1
      ],
      [
        4,
        3
      ],
      [
        0,
        1
      ],
      [
        5,
        29
      ],
      [
        1,
        14
      ],
      [
        1,
        11
      ],
      [
        1,
        4
      ],
      [
        5,
        -18
      ],
      [
        2,
        -11
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -10
      ],
      [
        0,
        -19
      ]
    ],
    [
      [
        28501,
        60006
      ],
      [
        -6,
        -12
      ],
      [
        -23,
        -48
      ]
    ],
    [
      [
        28472,
        59946
      ],
      [
        -2,
        37
      ],
      [
        -2,
        28
      ],
      [
        0,
        43
      ],
      [
        1,
        20
      ],
      [
        -8,
        -5
      ],
      [
        -12,
        23
      ],
      [
        -11,
        -4
      ],
      [
        -1,
        21
      ],
      [
        -7,
        0
      ],
      [
        -2,
        18
      ],
      [
        -5,
        -4
      ],
      [
        -7,
        18
      ]
    ],
    [
      [
        16972,
        71178
      ],
      [
        1,
        -39
      ],
      [
        -5,
        0
      ],
      [
        1,
        -309
      ],
      [
        35,
        1
      ],
      [
        0,
        -102
      ],
      [
        34,
        0
      ],
      [
        0,
        -219
      ],
      [
        -1,
        -22
      ]
    ],
    [
      [
        17037,
        70488
      ],
      [
        -36,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -5,
        1
      ],
      [
        -23,
        0
      ],
      [
        -2,
        -1
      ],
      [
        -4,
        1
      ],
      [
        -192,
        0
      ],
      [
        -13,
        -1
      ]
    ],
    [
      [
        16761,
        70487
      ],
      [
        1,
        3
      ],
      [
        0,
        1
      ],
      [
        6,
        19
      ],
      [
        6,
        9
      ],
      [
        -2,
        28
      ],
      [
        2,
        16
      ],
      [
        -2,
        20
      ],
      [
        -6,
        39
      ],
      [
        -2,
        27
      ],
      [
        -11,
        43
      ],
      [
        -7,
        19
      ]
    ],
    [
      [
        26327,
        56999
      ],
      [
        19,
        -1
      ],
      [
        0,
        -36
      ],
      [
        39,
        -1
      ],
      [
        0,
        9
      ],
      [
        5,
        -1
      ],
      [
        4,
        -8
      ],
      [
        3,
        -8
      ],
      [
        2,
        8
      ],
      [
        38,
        1
      ]
    ],
    [
      [
        26437,
        56962
      ],
      [
        0,
        -54
      ]
    ],
    [
      [
        26437,
        56908
      ],
      [
        0,
        -173
      ]
    ],
    [
      [
        26437,
        56735
      ],
      [
        -20,
        0
      ],
      [
        -7,
        -11
      ],
      [
        -2,
        -46
      ],
      [
        0,
        -16
      ],
      [
        -5,
        -6
      ],
      [
        -9,
        -12
      ],
      [
        -2,
        1
      ],
      [
        0,
        -41
      ]
    ],
    [
      [
        26392,
        56604
      ],
      [
        -18,
        1
      ],
      [
        -9,
        5
      ],
      [
        -2,
        -4
      ],
      [
        -4,
        0
      ],
      [
        -10,
        1
      ],
      [
        -4,
        0
      ],
      [
        -9,
        6
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -9,
        1
      ]
    ],
    [
      [
        23095,
        70207
      ],
      [
        138,
        1
      ]
    ],
    [
      [
        23233,
        70208
      ],
      [
        0,
        -203
      ],
      [
        3,
        0
      ],
      [
        0,
        -202
      ]
    ],
    [
      [
        23236,
        69803
      ],
      [
        -103,
        0
      ]
    ],
    [
      [
        23133,
        69803
      ],
      [
        -35,
        0
      ],
      [
        0,
        202
      ],
      [
        -3,
        0
      ]
    ],
    [
      [
        23095,
        70005
      ],
      [
        0,
        202
      ]
    ],
    [
      [
        23175,
        60359
      ],
      [
        0,
        -350
      ]
    ],
    [
      [
        23175,
        60009
      ],
      [
        -10,
        0
      ]
    ],
    [
      [
        23165,
        60009
      ],
      [
        -43,
        0
      ],
      [
        -8,
        1
      ],
      [
        -4,
        -1
      ],
      [
        -5,
        0
      ],
      [
        -17,
        1
      ],
      [
        -32,
        0
      ],
      [
        -6,
        -1
      ],
      [
        -31,
        0
      ]
    ],
    [
      [
        23019,
        60009
      ],
      [
        0,
        354
      ]
    ],
    [
      [
        23554,
        63649
      ],
      [
        2,
        304
      ]
    ],
    [
      [
        23556,
        63953
      ],
      [
        107,
        -3
      ]
    ],
    [
      [
        23663,
        63950
      ],
      [
        -1,
        -288
      ]
    ],
    [
      [
        23554,
        63548
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        28070,
        62132
      ],
      [
        17,
        69
      ],
      [
        -1,
        11
      ],
      [
        11,
        61
      ],
      [
        -2,
        10
      ],
      [
        -8,
        -3
      ],
      [
        -1,
        32
      ],
      [
        5,
        -3
      ],
      [
        -3,
        22
      ],
      [
        5,
        17
      ]
    ],
    [
      [
        28093,
        62348
      ],
      [
        42,
        11
      ],
      [
        3,
        22
      ]
    ],
    [
      [
        28179,
        62315
      ],
      [
        -10,
        -48
      ],
      [
        -10,
        -30
      ],
      [
        4,
        -24
      ],
      [
        -14,
        -14
      ],
      [
        -5,
        -18
      ]
    ],
    [
      [
        28101,
        62058
      ],
      [
        -2,
        25
      ],
      [
        -8,
        11
      ],
      [
        -5,
        15
      ],
      [
        -16,
        23
      ]
    ],
    [
      [
        22215,
        51428
      ],
      [
        114,
        -5
      ],
      [
        5,
        -1
      ],
      [
        2,
        -10
      ],
      [
        -3,
        -33
      ],
      [
        2,
        -11
      ],
      [
        -1,
        -13
      ],
      [
        4,
        -15
      ],
      [
        1,
        9
      ],
      [
        11,
        3
      ],
      [
        33,
        150
      ]
    ],
    [
      [
        22383,
        51502
      ],
      [
        1,
        -196
      ],
      [
        0,
        -316
      ]
    ],
    [
      [
        22384,
        50803
      ],
      [
        -170,
        1
      ]
    ],
    [
      [
        23478,
        63294
      ],
      [
        16,
        1
      ],
      [
        61,
        -2
      ]
    ],
    [
      [
        23555,
        62956
      ],
      [
        -2,
        2
      ],
      [
        -138,
        1
      ]
    ],
    [
      [
        23415,
        62959
      ],
      [
        -1,
        5
      ],
      [
        0,
        6
      ],
      [
        -2,
        13
      ],
      [
        0,
        6
      ],
      [
        2,
        18
      ],
      [
        0,
        1
      ],
      [
        1,
        3
      ],
      [
        1,
        2
      ],
      [
        1,
        1
      ],
      [
        2,
        1
      ],
      [
        4,
        -5
      ],
      [
        1,
        -1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        1,
        8
      ],
      [
        1,
        6
      ],
      [
        0,
        13
      ],
      [
        -2,
        9
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        20924,
        70350
      ],
      [
        0,
        -16
      ],
      [
        1,
        -138
      ],
      [
        0,
        -625
      ]
    ],
    [
      [
        26003,
        69060
      ],
      [
        49,
        1
      ]
    ],
    [
      [
        26052,
        69061
      ],
      [
        1,
        -4
      ],
      [
        2,
        -5
      ],
      [
        5,
        -2
      ],
      [
        3,
        0
      ],
      [
        2,
        4
      ],
      [
        0,
        17
      ],
      [
        3,
        28
      ],
      [
        10,
        66
      ],
      [
        4,
        10
      ],
      [
        0,
        20
      ],
      [
        -6,
        1
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        8
      ],
      [
        7,
        25
      ],
      [
        1,
        11
      ],
      [
        4,
        40
      ],
      [
        0,
        16
      ],
      [
        8,
        18
      ],
      [
        5,
        2
      ],
      [
        1,
        -12
      ],
      [
        2,
        -23
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        1
      ],
      [
        -3,
        -7
      ],
      [
        -2,
        -30
      ],
      [
        0,
        -23
      ],
      [
        1,
        -7
      ],
      [
        -3,
        -43
      ],
      [
        -1,
        -11
      ],
      [
        -2,
        -9
      ],
      [
        -3,
        -3
      ],
      [
        -5,
        -13
      ],
      [
        -5,
        -19
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -24
      ],
      [
        -5,
        -34
      ],
      [
        2,
        -6
      ],
      [
        5,
        -8
      ],
      [
        4,
        -2
      ],
      [
        3,
        2
      ],
      [
        6,
        23
      ],
      [
        1,
        6
      ],
      [
        -1,
        10
      ],
      [
        -1,
        6
      ],
      [
        3,
        20
      ],
      [
        7,
        13
      ],
      [
        3,
        11
      ],
      [
        1,
        13
      ],
      [
        5,
        28
      ]
    ],
    [
      [
        26137,
        68755
      ],
      [
        -135,
        1
      ]
    ],
    [
      [
        26002,
        68756
      ],
      [
        1,
        304
      ]
    ],
    [
      [
        25293,
        57677
      ],
      [
        45,
        0
      ]
    ],
    [
      [
        25351,
        57057
      ],
      [
        -48,
        1
      ]
    ],
    [
      [
        25303,
        57058
      ],
      [
        -1,
        136
      ],
      [
        0,
        186
      ],
      [
        -5,
        1
      ],
      [
        0,
        17
      ],
      [
        -5,
        0
      ]
    ],
    [
      [
        25292,
        57398
      ],
      [
        0,
        51
      ],
      [
        1,
        228
      ]
    ],
    [
      [
        19530,
        56260
      ],
      [
        1,
        113
      ],
      [
        -1,
        145
      ],
      [
        1,
        608
      ],
      [
        0,
        67
      ]
    ],
    [
      [
        27820,
        63550
      ],
      [
        4,
        11
      ],
      [
        6,
        45
      ],
      [
        9,
        11
      ],
      [
        4,
        24
      ],
      [
        7,
        -11
      ],
      [
        6,
        37
      ],
      [
        1,
        23
      ],
      [
        5,
        3
      ],
      [
        0,
        19
      ],
      [
        5,
        6
      ],
      [
        10,
        65
      ],
      [
        9,
        44
      ],
      [
        0,
        7
      ]
    ],
    [
      [
        27792,
        63178
      ],
      [
        0,
        13
      ],
      [
        -5,
        3
      ],
      [
        5,
        10
      ],
      [
        -2,
        14
      ],
      [
        6,
        16
      ],
      [
        -3,
        10
      ],
      [
        3,
        14
      ],
      [
        6,
        -10
      ],
      [
        -3,
        24
      ],
      [
        1,
        22
      ],
      [
        -5,
        7
      ],
      [
        0,
        12
      ],
      [
        -10,
        19
      ],
      [
        6,
        55
      ],
      [
        9,
        55
      ],
      [
        5,
        25
      ],
      [
        5,
        27
      ],
      [
        9,
        51
      ],
      [
        1,
        5
      ]
    ],
    [
      [
        28552,
        66556
      ],
      [
        14,
        -1
      ],
      [
        44,
        6
      ],
      [
        0,
        -10
      ],
      [
        54,
        6
      ]
    ],
    [
      [
        28664,
        66557
      ],
      [
        3,
        -252
      ]
    ],
    [
      [
        28667,
        66305
      ],
      [
        -12,
        -3
      ],
      [
        -1,
        -23
      ],
      [
        16,
        -25
      ],
      [
        1,
        -14
      ],
      [
        -4,
        -31
      ],
      [
        1,
        -33
      ],
      [
        -11,
        0
      ],
      [
        0,
        14
      ],
      [
        -17,
        0
      ],
      [
        0,
        11
      ],
      [
        -18,
        0
      ],
      [
        0,
        -64
      ],
      [
        -17,
        1
      ],
      [
        0,
        20
      ],
      [
        -17,
        1
      ]
    ],
    [
      [
        28588,
        66159
      ],
      [
        -23,
        1
      ]
    ],
    [
      [
        28565,
        66160
      ],
      [
        -20,
        2
      ],
      [
        1,
        105
      ],
      [
        -3,
        200
      ]
    ],
    [
      [
        28739,
        67208
      ],
      [
        1,
        -4
      ],
      [
        0,
        -10
      ],
      [
        2,
        3
      ],
      [
        2,
        -11
      ],
      [
        1,
        -1
      ],
      [
        -1,
        -7
      ],
      [
        2,
        -3
      ],
      [
        1,
        -23
      ],
      [
        4,
        -3
      ],
      [
        -1,
        -20
      ],
      [
        -3,
        5
      ],
      [
        -3,
        -19
      ],
      [
        0,
        -14
      ],
      [
        7,
        -5
      ],
      [
        9,
        3
      ],
      [
        0,
        -4
      ],
      [
        2,
        -113
      ],
      [
        4,
        -231
      ]
    ],
    [
      [
        28766,
        66751
      ],
      [
        -83,
        -18
      ],
      [
        -22,
        -4
      ]
    ],
    [
      [
        28661,
        66729
      ],
      [
        0,
        10
      ],
      [
        -9,
        39
      ],
      [
        -14,
        42
      ],
      [
        -26,
        -5
      ],
      [
        -2,
        98
      ],
      [
        -1,
        89
      ],
      [
        -9,
        -1
      ],
      [
        -1,
        113
      ],
      [
        7,
        5
      ],
      [
        -4,
        41
      ],
      [
        4,
        5
      ],
      [
        -2,
        95
      ]
    ],
    [
      [
        27882,
        56867
      ],
      [
        21,
        -74
      ],
      [
        9,
        -31
      ],
      [
        15,
        -53
      ],
      [
        5,
        -20
      ],
      [
        5,
        -14
      ],
      [
        5,
        -19
      ],
      [
        12,
        -43
      ],
      [
        5,
        -18
      ],
      [
        7,
        -24
      ],
      [
        16,
        -57
      ],
      [
        0,
        -2
      ],
      [
        2,
        -6
      ],
      [
        12,
        -41
      ],
      [
        3,
        -10
      ],
      [
        0,
        -2
      ]
    ],
    [
      [
        27999,
        56453
      ],
      [
        8,
        -28
      ],
      [
        2,
        -5
      ],
      [
        10,
        -36
      ],
      [
        11,
        -39
      ]
    ],
    [
      [
        28030,
        56345
      ],
      [
        -4,
        -4
      ],
      [
        -9,
        -4
      ],
      [
        -24,
        -31
      ],
      [
        -12,
        -20
      ],
      [
        -7,
        -18
      ],
      [
        -2,
        -3
      ],
      [
        -7,
        -16
      ],
      [
        -11,
        -29
      ],
      [
        -14,
        -44
      ],
      [
        -14,
        -53
      ],
      [
        -7,
        -24
      ],
      [
        -6,
        -27
      ],
      [
        -12,
        -52
      ]
    ],
    [
      [
        27849,
        56176
      ],
      [
        -2,
        25
      ],
      [
        -7,
        24
      ],
      [
        0,
        10
      ],
      [
        -2,
        6
      ],
      [
        -5,
        26
      ],
      [
        -2,
        28
      ],
      [
        -2,
        8
      ],
      [
        3,
        17
      ],
      [
        -3,
        11
      ],
      [
        1,
        29
      ],
      [
        -2,
        33
      ],
      [
        -9,
        10
      ],
      [
        -12,
        81
      ],
      [
        2,
        27
      ],
      [
        5,
        3
      ],
      [
        4,
        38
      ],
      [
        10,
        17
      ],
      [
        6,
        28
      ],
      [
        -2,
        26
      ],
      [
        12,
        50
      ],
      [
        0,
        14
      ],
      [
        4,
        37
      ],
      [
        6,
        6
      ],
      [
        5,
        29
      ],
      [
        6,
        17
      ],
      [
        -1,
        5
      ],
      [
        2,
        6
      ],
      [
        0,
        27
      ]
    ],
    [
      [
        19058,
        73978
      ],
      [
        42,
        0
      ],
      [
        17,
        -1
      ],
      [
        14,
        1
      ],
      [
        86,
        0
      ],
      [
        49,
        1
      ],
      [
        138,
        1
      ],
      [
        3,
        0
      ]
    ],
    [
      [
        19407,
        73980
      ],
      [
        0,
        -101
      ],
      [
        -4,
        0
      ],
      [
        0,
        -403
      ],
      [
        2,
        0
      ],
      [
        0,
        -49
      ],
      [
        9,
        0
      ],
      [
        0,
        -85
      ],
      [
        -9,
        0
      ],
      [
        0,
        -67
      ],
      [
        -6,
        0
      ],
      [
        0,
        -118
      ],
      [
        -9,
        0
      ],
      [
        0,
        -84
      ],
      [
        5,
        0
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        19395,
        72972
      ],
      [
        -18,
        -3
      ],
      [
        -36,
        1
      ],
      [
        0,
        103
      ],
      [
        -33,
        -3
      ],
      [
        0,
        101
      ],
      [
        -61,
        0
      ],
      [
        -156,
        1
      ],
      [
        0,
        -101
      ],
      [
        -37,
        0
      ]
    ],
    [
      [
        29244,
        66680
      ],
      [
        21,
        11
      ],
      [
        48,
        25
      ],
      [
        8,
        3
      ],
      [
        26,
        14
      ],
      [
        1,
        4
      ]
    ],
    [
      [
        29348,
        66737
      ],
      [
        8,
        16
      ],
      [
        3,
        -7
      ],
      [
        9,
        39
      ],
      [
        4,
        1
      ],
      [
        1,
        -23
      ],
      [
        2,
        -8
      ],
      [
        6,
        -22
      ],
      [
        4,
        10
      ]
    ],
    [
      [
        29385,
        66743
      ],
      [
        -2,
        -20
      ],
      [
        0,
        -11
      ],
      [
        -6,
        -54
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -13
      ],
      [
        -4,
        -25
      ],
      [
        -1,
        -3
      ],
      [
        -4,
        -19
      ],
      [
        -5,
        -46
      ],
      [
        0,
        -1
      ],
      [
        2,
        -55
      ],
      [
        -3,
        -53
      ],
      [
        -3,
        -13
      ],
      [
        -4,
        -26
      ],
      [
        1,
        -27
      ]
    ],
    [
      [
        26348,
        56220
      ],
      [
        11,
        32
      ],
      [
        2,
        14
      ],
      [
        4,
        8
      ],
      [
        6,
        21
      ],
      [
        4,
        11
      ],
      [
        3,
        11
      ],
      [
        3,
        -3
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        30
      ],
      [
        1,
        7
      ],
      [
        0,
        7
      ],
      [
        2,
        11
      ],
      [
        1,
        6
      ],
      [
        1,
        12
      ],
      [
        -1,
        14
      ],
      [
        -1,
        9
      ],
      [
        12,
        40
      ],
      [
        4,
        16
      ],
      [
        2,
        11
      ],
      [
        2,
        23
      ],
      [
        -2,
        7
      ],
      [
        -5,
        25
      ],
      [
        -1,
        26
      ],
      [
        -1,
        1
      ],
      [
        -1,
        14
      ],
      [
        -2,
        14
      ],
      [
        0,
        14
      ]
    ],
    [
      [
        26437,
        56735
      ],
      [
        0,
        -89
      ],
      [
        8,
        -15
      ],
      [
        3,
        3
      ],
      [
        3,
        -10
      ],
      [
        5,
        -5
      ],
      [
        3,
        -19
      ],
      [
        10,
        -17
      ],
      [
        12,
        -6
      ]
    ],
    [
      [
        26481,
        56577
      ],
      [
        -7,
        -20
      ],
      [
        -12,
        -6
      ],
      [
        -4,
        -34
      ],
      [
        -6,
        -11
      ],
      [
        -3,
        17
      ],
      [
        -5,
        -3
      ],
      [
        -6,
        -18
      ],
      [
        -3,
        1
      ],
      [
        0,
        -15
      ],
      [
        2,
        -7
      ],
      [
        -6,
        -12
      ]
    ],
    [
      [
        26411,
        56108
      ],
      [
        -14,
        1
      ],
      [
        -5,
        0
      ],
      [
        -10,
        -8
      ],
      [
        -1,
        8
      ],
      [
        0,
        -113
      ]
    ],
    [
      [
        26381,
        55996
      ],
      [
        -5,
        -4
      ],
      [
        -2,
        -3
      ],
      [
        -20,
        -20
      ],
      [
        -4,
        -4
      ],
      [
        -10,
        -16
      ],
      [
        -1,
        -10
      ]
    ],
    [
      [
        26272,
        55950
      ],
      [
        9,
        10
      ],
      [
        -4,
        29
      ],
      [
        6,
        33
      ]
    ],
    [
      [
        24242,
        68956
      ],
      [
        135,
        -1
      ]
    ],
    [
      [
        24377,
        68955
      ],
      [
        0,
        -102
      ]
    ],
    [
      [
        24377,
        68853
      ],
      [
        -97,
        0
      ],
      [
        -7,
        -7
      ],
      [
        -1,
        -5
      ],
      [
        -3,
        -25
      ],
      [
        0,
        -20
      ],
      [
        -3,
        -24
      ],
      [
        1,
        -19
      ],
      [
        -4,
        -51
      ],
      [
        -6,
        -43
      ],
      [
        -1,
        -26
      ]
    ],
    [
      [
        24256,
        68633
      ],
      [
        -1,
        2
      ],
      [
        -2,
        3
      ],
      [
        -4,
        3
      ],
      [
        -1,
        2
      ],
      [
        -2,
        5
      ],
      [
        -1,
        2
      ],
      [
        -4,
        3
      ],
      [
        -6,
        3
      ],
      [
        -3,
        2
      ],
      [
        -7,
        6
      ],
      [
        -5,
        5
      ],
      [
        -2,
        3
      ],
      [
        -3,
        5
      ],
      [
        -1,
        5
      ],
      [
        -2,
        6
      ]
    ],
    [
      [
        24212,
        68688
      ],
      [
        0,
        3
      ],
      [
        -2,
        3
      ],
      [
        -3,
        6
      ],
      [
        -4,
        10
      ],
      [
        -2,
        5
      ],
      [
        -2,
        9
      ],
      [
        -2,
        8
      ],
      [
        -1,
        9
      ],
      [
        -1,
        4
      ],
      [
        1,
        15
      ],
      [
        -1,
        3
      ],
      [
        0,
        1
      ],
      [
        -1,
        5
      ],
      [
        -1,
        5
      ],
      [
        -1,
        11
      ],
      [
        0,
        4
      ]
    ],
    [
      [
        25555,
        55208
      ],
      [
        29,
        1
      ],
      [
        0,
        -51
      ],
      [
        24,
        1
      ],
      [
        3,
        3
      ],
      [
        34,
        1
      ],
      [
        22,
        1
      ]
    ],
    [
      [
        25668,
        55039
      ],
      [
        -4,
        -39
      ],
      [
        0,
        -37
      ],
      [
        -3,
        -24
      ],
      [
        -2,
        -26
      ],
      [
        2,
        -25
      ],
      [
        -4,
        -18
      ],
      [
        -7,
        -16
      ],
      [
        1,
        -15
      ],
      [
        -1,
        -24
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        -34
      ],
      [
        -4,
        -19
      ],
      [
        -30,
        -2
      ],
      [
        -12,
        -3
      ],
      [
        -44,
        -2
      ],
      [
        0,
        -203
      ],
      [
        -14,
        -1
      ]
    ],
    [
      [
        25541,
        54548
      ],
      [
        -14,
        0
      ],
      [
        0,
        203
      ]
    ],
    [
      [
        25527,
        54751
      ],
      [
        0,
        202
      ],
      [
        14,
        1
      ],
      [
        0,
        203
      ],
      [
        14,
        0
      ],
      [
        0,
        51
      ]
    ],
    [
      [
        8956,
        91740
      ],
      [
        -211,
        0
      ],
      [
        -6,
        2
      ],
      [
        -11,
        25
      ],
      [
        -13,
        8
      ],
      [
        -8,
        22
      ],
      [
        -8,
        7
      ],
      [
        -2,
        11
      ],
      [
        -8,
        3
      ],
      [
        -12,
        26
      ],
      [
        -12,
        -4
      ]
    ],
    [
      [
        26855,
        55649
      ],
      [
        7,
        4
      ],
      [
        8,
        19
      ],
      [
        7,
        1
      ],
      [
        9,
        32
      ],
      [
        8,
        6
      ],
      [
        7,
        17
      ],
      [
        9,
        7
      ],
      [
        17,
        -28
      ],
      [
        19,
        -33
      ]
    ],
    [
      [
        26946,
        55674
      ],
      [
        -11,
        -29
      ],
      [
        -32,
        -91
      ],
      [
        3,
        -18
      ],
      [
        -1,
        -42
      ],
      [
        -3,
        4
      ],
      [
        -21,
        3
      ]
    ],
    [
      [
        26881,
        55501
      ],
      [
        -13,
        30
      ],
      [
        -2,
        21
      ],
      [
        -6,
        6
      ],
      [
        2,
        38
      ],
      [
        -5,
        36
      ]
    ],
    [
      [
        26857,
        55632
      ],
      [
        1,
        9
      ],
      [
        -3,
        8
      ]
    ],
    [
      [
        21579,
        54292
      ],
      [
        120,
        0
      ]
    ],
    [
      [
        21698,
        53784
      ],
      [
        -142,
        0
      ]
    ],
    [
      [
        19250,
        68168
      ],
      [
        0,
        -218
      ],
      [
        1,
        -7
      ],
      [
        0,
        -407
      ]
    ],
    [
      [
        18974,
        67578
      ],
      [
        0,
        184
      ],
      [
        -1,
        26
      ],
      [
        0,
        352
      ]
    ],
    [
      [
        20643,
        63071
      ],
      [
        -1,
        3
      ],
      [
        -1,
        3
      ],
      [
        0,
        5
      ],
      [
        2,
        0
      ],
      [
        0,
        -8
      ]
    ],
    [
      [
        20547,
        62997
      ],
      [
        0,
        211
      ]
    ],
    [
      [
        20547,
        63208
      ],
      [
        0,
        193
      ]
    ],
    [
      [
        20547,
        63401
      ],
      [
        16,
        1
      ],
      [
        16,
        0
      ],
      [
        33,
        1
      ],
      [
        5,
        -1
      ]
    ],
    [
      [
        20617,
        63402
      ],
      [
        -5,
        -4
      ],
      [
        0,
        -21
      ],
      [
        10,
        -2
      ],
      [
        -5,
        28
      ],
      [
        11,
        0
      ],
      [
        3,
        -17
      ],
      [
        7,
        0
      ],
      [
        5,
        17
      ]
    ],
    [
      [
        20643,
        63403
      ],
      [
        0,
        -144
      ]
    ],
    [
      [
        20643,
        63259
      ],
      [
        -3,
        -3
      ],
      [
        3,
        -5
      ],
      [
        0,
        -47
      ],
      [
        -1,
        -12
      ],
      [
        1,
        -9
      ],
      [
        0,
        -33
      ],
      [
        -3,
        -21
      ],
      [
        3,
        -13
      ],
      [
        -2,
        0
      ],
      [
        -6,
        3
      ],
      [
        8,
        -22
      ],
      [
        -6,
        -15
      ],
      [
        -10,
        -4
      ],
      [
        0,
        -10
      ],
      [
        8,
        1
      ],
      [
        5,
        -9
      ],
      [
        -8,
        -2
      ],
      [
        -1,
        0
      ],
      [
        1,
        -4
      ],
      [
        10,
        0
      ],
      [
        1,
        8
      ]
    ],
    [
      [
        20644,
        62998
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -4
      ],
      [
        -3,
        -17
      ],
      [
        -4,
        -58
      ],
      [
        -14,
        -28
      ],
      [
        4,
        -43
      ],
      [
        -5,
        -13
      ],
      [
        -9,
        -18
      ],
      [
        2,
        -19
      ],
      [
        -2,
        -16
      ],
      [
        2,
        -18
      ],
      [
        -5,
        -38
      ],
      [
        -4,
        -22
      ],
      [
        -7,
        -49
      ],
      [
        1,
        -9
      ],
      [
        -4,
        -6
      ],
      [
        0,
        -10
      ],
      [
        -5,
        -4
      ],
      [
        -3,
        -17
      ],
      [
        0,
        -21
      ],
      [
        -6,
        -13
      ],
      [
        -1,
        -24
      ],
      [
        -7,
        -23
      ],
      [
        -5,
        -34
      ]
    ],
    [
      [
        20566,
        62490
      ],
      [
        -19,
        -1
      ],
      [
        0,
        508
      ]
    ],
    [
      [
        19961,
        62592
      ],
      [
        0,
        -639
      ]
    ],
    [
      [
        19717,
        61952
      ],
      [
        0,
        188
      ],
      [
        56,
        77
      ],
      [
        3,
        8
      ],
      [
        7,
        5
      ],
      [
        1,
        22
      ],
      [
        4,
        2
      ],
      [
        10,
        47
      ],
      [
        -2,
        14
      ],
      [
        7,
        20
      ],
      [
        4,
        20
      ],
      [
        5,
        4
      ],
      [
        1,
        11
      ],
      [
        13,
        30
      ],
      [
        1,
        8
      ],
      [
        18,
        5
      ],
      [
        3,
        -4
      ],
      [
        14,
        22
      ],
      [
        15,
        -17
      ],
      [
        10,
        -25
      ],
      [
        8,
        27
      ],
      [
        5,
        -1
      ],
      [
        2,
        18
      ],
      [
        7,
        7
      ],
      [
        2,
        15
      ],
      [
        12,
        49
      ],
      [
        20,
        46
      ],
      [
        6,
        0
      ],
      [
        0,
        15
      ],
      [
        10,
        26
      ],
      [
        2,
        1
      ]
    ],
    [
      [
        26430,
        56108
      ],
      [
        5,
        -19
      ],
      [
        0,
        -28
      ],
      [
        6,
        -20
      ],
      [
        -6,
        -18
      ],
      [
        0,
        -30
      ],
      [
        -5,
        0
      ],
      [
        -3,
        -18
      ],
      [
        3,
        -1
      ],
      [
        0,
        -56
      ],
      [
        -3,
        0
      ],
      [
        0,
        -57
      ],
      [
        -17,
        1
      ],
      [
        0,
        -97
      ]
    ],
    [
      [
        26410,
        55765
      ],
      [
        -9,
        -1
      ]
    ],
    [
      [
        26401,
        55764
      ],
      [
        -3,
        25
      ],
      [
        1,
        24
      ],
      [
        3,
        10
      ],
      [
        -5,
        26
      ],
      [
        0,
        13
      ],
      [
        5,
        10
      ],
      [
        -2,
        4
      ],
      [
        1,
        12
      ],
      [
        1,
        5
      ],
      [
        -4,
        27
      ],
      [
        -6,
        9
      ],
      [
        -2,
        27
      ],
      [
        -2,
        9
      ],
      [
        -2,
        30
      ],
      [
        -5,
        1
      ]
    ],
    [
      [
        25865,
        61975
      ],
      [
        0,
        -308
      ]
    ],
    [
      [
        25762,
        61634
      ],
      [
        -1,
        153
      ]
    ],
    [
      [
        25761,
        61787
      ],
      [
        0,
        187
      ]
    ],
    [
      [
        29842,
        64964
      ],
      [
        2,
        9
      ],
      [
        1,
        9
      ],
      [
        2,
        4
      ],
      [
        3,
        -1
      ],
      [
        4,
        9
      ],
      [
        3,
        -1
      ],
      [
        8,
        6
      ],
      [
        3,
        1
      ],
      [
        4,
        4
      ],
      [
        -2,
        -11
      ],
      [
        -3,
        -5
      ],
      [
        -5,
        -6
      ],
      [
        -4,
        -7
      ],
      [
        -5,
        -10
      ],
      [
        -2,
        -4
      ],
      [
        -9,
        -4
      ],
      [
        0,
        7
      ]
    ],
    [
      [
        29812,
        64781
      ],
      [
        1,
        3
      ],
      [
        2,
        4
      ],
      [
        1,
        5
      ],
      [
        1,
        8
      ],
      [
        11,
        -16
      ],
      [
        1,
        -9
      ],
      [
        -1,
        -41
      ],
      [
        -3,
        -5
      ],
      [
        0,
        25
      ],
      [
        -2,
        12
      ],
      [
        -1,
        3
      ],
      [
        -4,
        5
      ],
      [
        -5,
        -1
      ],
      [
        -1,
        3
      ],
      [
        0,
        4
      ]
    ],
    [
      [
        29792,
        64880
      ],
      [
        7,
        12
      ],
      [
        9,
        4
      ],
      [
        -1,
        -10
      ],
      [
        -6,
        -12
      ],
      [
        -1,
        -10
      ],
      [
        -4,
        -11
      ],
      [
        -4,
        12
      ],
      [
        0,
        15
      ]
    ],
    [
      [
        29435,
        64577
      ],
      [
        0,
        1
      ],
      [
        1,
        21
      ],
      [
        2,
        5
      ],
      [
        2,
        -4
      ],
      [
        4,
        -6
      ],
      [
        8,
        -3
      ],
      [
        2,
        -6
      ],
      [
        0,
        -10
      ],
      [
        6,
        -1
      ],
      [
        1,
        6
      ],
      [
        0,
        19
      ],
      [
        1,
        14
      ],
      [
        0,
        2
      ],
      [
        2,
        0
      ],
      [
        5,
        -21
      ],
      [
        2,
        -7
      ],
      [
        4,
        -6
      ],
      [
        2,
        -1
      ],
      [
        0,
        2
      ],
      [
        4,
        3
      ],
      [
        10,
        -6
      ],
      [
        16,
        -20
      ],
      [
        2,
        -3
      ],
      [
        23,
        28
      ],
      [
        0,
        1
      ],
      [
        1,
        6
      ],
      [
        0,
        24
      ],
      [
        1,
        12
      ],
      [
        9,
        7
      ],
      [
        4,
        1
      ],
      [
        4,
        0
      ],
      [
        8,
        -10
      ],
      [
        2,
        -2
      ],
      [
        1,
        2
      ],
      [
        12,
        3
      ],
      [
        12,
        -1
      ],
      [
        11,
        -4
      ],
      [
        7,
        1
      ],
      [
        18,
        8
      ],
      [
        14,
        -6
      ],
      [
        8,
        4
      ],
      [
        11,
        11
      ],
      [
        6,
        3
      ],
      [
        6,
        -1
      ],
      [
        8,
        3
      ],
      [
        14,
        18
      ],
      [
        5,
        14
      ],
      [
        2,
        7
      ],
      [
        3,
        5
      ],
      [
        8,
        21
      ],
      [
        12,
        16
      ],
      [
        5,
        18
      ],
      [
        4,
        22
      ],
      [
        7,
        2
      ],
      [
        5,
        11
      ],
      [
        13,
        50
      ],
      [
        7,
        8
      ],
      [
        5,
        1
      ],
      [
        6,
        9
      ],
      [
        3,
        3
      ],
      [
        2,
        -4
      ],
      [
        1,
        -1
      ],
      [
        7,
        8
      ],
      [
        2,
        -2
      ],
      [
        0,
        -3
      ],
      [
        -5,
        -23
      ],
      [
        -3,
        -10
      ],
      [
        -10,
        -19
      ],
      [
        0,
        23
      ],
      [
        -1,
        7
      ],
      [
        -2,
        1
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -14
      ],
      [
        0,
        -16
      ],
      [
        5,
        -21
      ],
      [
        5,
        -9
      ],
      [
        5,
        -1
      ],
      [
        1,
        -4
      ],
      [
        -2,
        -10
      ],
      [
        3,
        -19
      ],
      [
        3,
        -11
      ],
      [
        6,
        3
      ],
      [
        3,
        -1
      ],
      [
        3,
        -4
      ],
      [
        5,
        -10
      ],
      [
        3,
        1
      ],
      [
        2,
        3
      ],
      [
        1,
        3
      ],
      [
        1,
        9
      ],
      [
        4,
        9
      ],
      [
        2,
        -2
      ],
      [
        5,
        -14
      ],
      [
        0,
        -18
      ],
      [
        6,
        -29
      ],
      [
        2,
        -6
      ],
      [
        1,
        -3
      ],
      [
        2,
        0
      ],
      [
        4,
        6
      ],
      [
        1,
        8
      ],
      [
        0,
        3
      ],
      [
        1,
        3
      ],
      [
        4,
        1
      ],
      [
        1,
        -6
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        0,
        11
      ],
      [
        -1,
        6
      ],
      [
        2,
        2
      ],
      [
        3,
        -2
      ],
      [
        6,
        9
      ],
      [
        4,
        13
      ],
      [
        9,
        9
      ],
      [
        2,
        8
      ],
      [
        0,
        20
      ],
      [
        6,
        7
      ],
      [
        5,
        3
      ],
      [
        6,
        1
      ],
      [
        1,
        -4
      ],
      [
        2,
        -2
      ],
      [
        5,
        -1
      ],
      [
        2,
        2
      ],
      [
        2,
        -4
      ],
      [
        0,
        -3
      ],
      [
        -5,
        -21
      ],
      [
        -8,
        -15
      ],
      [
        -9,
        -7
      ],
      [
        -26,
        -39
      ],
      [
        -24,
        -33
      ],
      [
        -78,
        -123
      ],
      [
        -21,
        -27
      ],
      [
        -29,
        -35
      ],
      [
        -43,
        -48
      ],
      [
        -5,
        -5
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        1
      ],
      [
        -3,
        -3
      ],
      [
        -27,
        -33
      ],
      [
        -2,
        -4
      ],
      [
        -14,
        -19
      ],
      [
        -25,
        -39
      ],
      [
        -12,
        -16
      ],
      [
        -25,
        -24
      ],
      [
        -18,
        -17
      ],
      [
        -8,
        -7
      ],
      [
        -7,
        -4
      ],
      [
        -12,
        -1
      ],
      [
        -6,
        15
      ],
      [
        -7,
        -3
      ],
      [
        -18,
        -23
      ],
      [
        -2,
        -1
      ]
    ],
    [
      [
        28633,
        68013
      ],
      [
        8,
        30
      ],
      [
        8,
        20
      ],
      [
        5,
        0
      ],
      [
        -2,
        -14
      ],
      [
        -8,
        -31
      ],
      [
        -7,
        -7
      ],
      [
        -4,
        2
      ]
    ],
    [
      [
        28892,
        68412
      ],
      [
        -25,
        -116
      ],
      [
        -3,
        -17
      ],
      [
        17,
        -34
      ],
      [
        -5,
        -26
      ],
      [
        3,
        -6
      ],
      [
        -3,
        -12
      ],
      [
        0,
        -31
      ],
      [
        -13,
        -2
      ],
      [
        2,
        -47
      ],
      [
        -10,
        -3
      ],
      [
        -7,
        8
      ],
      [
        -43,
        -108
      ],
      [
        -23,
        6
      ],
      [
        -3,
        -107
      ],
      [
        18,
        -5
      ],
      [
        3,
        -115
      ]
    ],
    [
      [
        28682,
        67787
      ],
      [
        -2,
        44
      ],
      [
        -2,
        41
      ],
      [
        -4,
        59
      ],
      [
        -2,
        3
      ],
      [
        -18,
        37
      ],
      [
        1,
        22
      ],
      [
        3,
        12
      ],
      [
        7,
        16
      ],
      [
        9,
        6
      ],
      [
        4,
        16
      ],
      [
        1,
        -11
      ],
      [
        -3,
        -31
      ],
      [
        5,
        -2
      ],
      [
        14,
        32
      ],
      [
        2,
        -2
      ],
      [
        5,
        11
      ],
      [
        0,
        22
      ],
      [
        -3,
        21
      ],
      [
        -3,
        8
      ],
      [
        -6,
        20
      ],
      [
        -8,
        11
      ],
      [
        -2,
        8
      ],
      [
        -13,
        -10
      ],
      [
        -5,
        -7
      ],
      [
        -4,
        2
      ],
      [
        2,
        12
      ],
      [
        3,
        17
      ],
      [
        -1,
        16
      ],
      [
        -3,
        10
      ],
      [
        -4,
        -1
      ],
      [
        -2,
        6
      ],
      [
        -1,
        13
      ],
      [
        -4,
        7
      ],
      [
        -11,
        2
      ],
      [
        -4,
        -1
      ],
      [
        -2,
        6
      ],
      [
        0,
        12
      ],
      [
        3,
        5
      ],
      [
        3,
        25
      ],
      [
        0,
        17
      ],
      [
        -3,
        15
      ],
      [
        4,
        38
      ],
      [
        1,
        5
      ],
      [
        11,
        72
      ],
      [
        8,
        5
      ],
      [
        10,
        1
      ],
      [
        1,
        -1
      ],
      [
        11,
        13
      ],
      [
        4,
        7
      ],
      [
        8,
        22
      ],
      [
        0,
        48
      ],
      [
        9,
        18
      ],
      [
        1,
        -2
      ],
      [
        3,
        0
      ],
      [
        1,
        4
      ],
      [
        4,
        2
      ],
      [
        15,
        37
      ],
      [
        10,
        14
      ],
      [
        2,
        4
      ],
      [
        7,
        0
      ],
      [
        1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        1,
        -1
      ],
      [
        6,
        7
      ],
      [
        2,
        8
      ],
      [
        3,
        4
      ],
      [
        2,
        8
      ],
      [
        3,
        2
      ],
      [
        11,
        32
      ],
      [
        3,
        9
      ]
    ],
    [
      [
        28611,
        68032
      ],
      [
        12,
        40
      ],
      [
        9,
        -5
      ],
      [
        -3,
        -15
      ],
      [
        -9,
        -16
      ],
      [
        -6,
        -13
      ],
      [
        -3,
        9
      ]
    ],
    [
      [
        23552,
        61627
      ],
      [
        0,
        -374
      ],
      [
        -1,
        -2
      ],
      [
        1,
        -7
      ]
    ],
    [
      [
        23552,
        61244
      ],
      [
        0,
        -26
      ]
    ],
    [
      [
        23552,
        61218
      ],
      [
        -8,
        -1
      ],
      [
        -5,
        1
      ],
      [
        -117,
        0
      ]
    ],
    [
      [
        26992,
        58227
      ],
      [
        4,
        -8
      ],
      [
        7,
        43
      ],
      [
        -2,
        25
      ],
      [
        18,
        10
      ]
    ],
    [
      [
        27019,
        58297
      ],
      [
        5,
        -12
      ],
      [
        15,
        16
      ],
      [
        16,
        1
      ],
      [
        4,
        6
      ],
      [
        6,
        17
      ],
      [
        10,
        -30
      ],
      [
        9,
        11
      ],
      [
        4,
        -2
      ],
      [
        4,
        9
      ],
      [
        18,
        1
      ],
      [
        5,
        38
      ]
    ],
    [
      [
        27115,
        58352
      ],
      [
        0,
        6
      ],
      [
        8,
        4
      ],
      [
        6,
        10
      ],
      [
        6,
        25
      ],
      [
        5,
        -14
      ],
      [
        3,
        5
      ],
      [
        5,
        -29
      ],
      [
        4,
        -1
      ]
    ],
    [
      [
        27130,
        57892
      ],
      [
        -1,
        0
      ],
      [
        -8,
        1
      ],
      [
        -20,
        4
      ]
    ],
    [
      [
        27101,
        57897
      ],
      [
        -14,
        1
      ],
      [
        -13,
        2
      ]
    ],
    [
      [
        26993,
        58140
      ],
      [
        -2,
        9
      ],
      [
        -3,
        49
      ],
      [
        4,
        29
      ]
    ],
    [
      [
        28983,
        64630
      ],
      [
        -1,
        2
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        3
      ],
      [
        0,
        4
      ],
      [
        1,
        4
      ],
      [
        0,
        10
      ],
      [
        1,
        2
      ],
      [
        1,
        4
      ],
      [
        1,
        2
      ],
      [
        3,
        7
      ],
      [
        1,
        2
      ],
      [
        2,
        4
      ],
      [
        1,
        2
      ],
      [
        2,
        5
      ],
      [
        0,
        2
      ],
      [
        3,
        2
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        9,
        16
      ],
      [
        1,
        5
      ],
      [
        2,
        2
      ],
      [
        1,
        2
      ],
      [
        0,
        8
      ],
      [
        2,
        7
      ],
      [
        0,
        3
      ],
      [
        1,
        3
      ],
      [
        0,
        4
      ],
      [
        1,
        6
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        2,
        8
      ],
      [
        2,
        3
      ],
      [
        1,
        2
      ],
      [
        2,
        1
      ],
      [
        3,
        7
      ],
      [
        1,
        3
      ],
      [
        0,
        8
      ]
    ],
    [
      [
        29025,
        64777
      ],
      [
        50,
        -191
      ],
      [
        5,
        -23
      ]
    ],
    [
      [
        29080,
        64563
      ],
      [
        -2,
        -5
      ],
      [
        -8,
        -29
      ],
      [
        1,
        -21
      ],
      [
        -5,
        -18
      ],
      [
        1,
        -13
      ],
      [
        -9,
        -38
      ],
      [
        -11,
        -19
      ]
    ],
    [
      [
        18136,
        61841
      ],
      [
        84,
        2
      ],
      [
        196,
        -2
      ],
      [
        148,
        0
      ]
    ],
    [
      [
        18564,
        61841
      ],
      [
        0,
        -54
      ],
      [
        -2,
        -6
      ],
      [
        1,
        -12
      ]
    ],
    [
      [
        18574,
        61346
      ],
      [
        -216,
        2
      ],
      [
        -221,
        0
      ]
    ],
    [
      [
        27111,
        59928
      ],
      [
        27,
        -114
      ],
      [
        12,
        -49
      ],
      [
        22,
        -181
      ],
      [
        4,
        5
      ]
    ],
    [
      [
        27176,
        59589
      ],
      [
        -2,
        -24
      ],
      [
        -10,
        -6
      ]
    ],
    [
      [
        27114,
        59561
      ],
      [
        -27,
        3
      ],
      [
        -3,
        -26
      ],
      [
        -24,
        0
      ],
      [
        -35,
        1
      ]
    ],
    [
      [
        26998,
        59540
      ],
      [
        -14,
        0
      ]
    ],
    [
      [
        26973,
        59672
      ],
      [
        7,
        20
      ],
      [
        19,
        32
      ],
      [
        4,
        10
      ],
      [
        34,
        42
      ],
      [
        -4,
        22
      ],
      [
        3,
        21
      ],
      [
        9,
        24
      ],
      [
        26,
        27
      ],
      [
        2,
        -11
      ],
      [
        8,
        -6
      ],
      [
        17,
        29
      ],
      [
        13,
        46
      ]
    ],
    [
      [
        26082,
        56450
      ],
      [
        0,
        -61
      ],
      [
        -20,
        1
      ],
      [
        0,
        -17
      ],
      [
        -9,
        0
      ],
      [
        0,
        -33
      ],
      [
        14,
        -1
      ],
      [
        0,
        -51
      ],
      [
        -5,
        0
      ],
      [
        0,
        -17
      ],
      [
        -5,
        0
      ],
      [
        0,
        -16
      ],
      [
        -5,
        -1
      ],
      [
        0,
        -145
      ],
      [
        -2,
        0
      ],
      [
        -3,
        -25
      ],
      [
        -9,
        1
      ],
      [
        0,
        -14
      ],
      [
        -10,
        -3
      ],
      [
        0,
        -16
      ],
      [
        -5,
        1
      ],
      [
        0,
        -52
      ],
      [
        -15,
        1
      ]
    ],
    [
      [
        26008,
        56002
      ],
      [
        1,
        34
      ],
      [
        -43,
        0
      ],
      [
        -13,
        1
      ],
      [
        -1,
        17
      ],
      [
        -7,
        0
      ],
      [
        0,
        26
      ],
      [
        -1,
        27
      ],
      [
        -6,
        31
      ],
      [
        -2,
        2
      ],
      [
        -14,
        2
      ],
      [
        -11,
        3
      ]
    ],
    [
      [
        26674,
        56167
      ],
      [
        32,
        42
      ],
      [
        -2,
        5
      ],
      [
        5,
        27
      ]
    ],
    [
      [
        26709,
        56241
      ],
      [
        45,
        -73
      ],
      [
        20,
        19
      ],
      [
        9,
        -28
      ],
      [
        5,
        3
      ]
    ],
    [
      [
        26788,
        56162
      ],
      [
        5,
        -16
      ],
      [
        4,
        -4
      ],
      [
        4,
        -18
      ],
      [
        -6,
        -23
      ],
      [
        -2,
        -31
      ],
      [
        -2,
        16
      ],
      [
        -4,
        -10
      ],
      [
        3,
        -20
      ],
      [
        -7,
        -26
      ],
      [
        8,
        -70
      ],
      [
        0,
        -36
      ],
      [
        -7,
        -24
      ]
    ],
    [
      [
        26784,
        55900
      ],
      [
        -42,
        -133
      ]
    ],
    [
      [
        26742,
        55767
      ],
      [
        -2,
        19
      ],
      [
        -8,
        28
      ],
      [
        -7,
        -17
      ],
      [
        3,
        23
      ],
      [
        -4,
        5
      ],
      [
        -5,
        -6
      ],
      [
        1,
        22
      ],
      [
        -6,
        30
      ],
      [
        1,
        15
      ],
      [
        -4,
        8
      ],
      [
        -2,
        23
      ]
    ],
    [
      [
        27448,
        63962
      ],
      [
        15,
        6
      ],
      [
        16,
        0
      ]
    ],
    [
      [
        27479,
        63968
      ],
      [
        0,
        -37
      ],
      [
        -1,
        -30
      ],
      [
        0,
        -213
      ]
    ],
    [
      [
        27478,
        63688
      ],
      [
        -9,
        10
      ],
      [
        -12,
        11
      ],
      [
        -8,
        0
      ],
      [
        -11,
        2
      ],
      [
        0,
        1
      ],
      [
        1,
        3
      ],
      [
        -1,
        0
      ],
      [
        0,
        4
      ],
      [
        -5,
        0
      ]
    ],
    [
      [
        27433,
        63719
      ],
      [
        1,
        1
      ],
      [
        2,
        7
      ],
      [
        1,
        8
      ],
      [
        0,
        8
      ],
      [
        1,
        15
      ],
      [
        1,
        12
      ],
      [
        2,
        18
      ],
      [
        2,
        7
      ],
      [
        3,
        5
      ],
      [
        0,
        -1
      ],
      [
        4,
        8
      ],
      [
        1,
        4
      ],
      [
        0,
        24
      ],
      [
        1,
        7
      ],
      [
        2,
        14
      ],
      [
        1,
        4
      ],
      [
        1,
        12
      ],
      [
        0,
        4
      ],
      [
        -1,
        8
      ],
      [
        -2,
        15
      ],
      [
        -1,
        8
      ],
      [
        1,
        9
      ],
      [
        0,
        8
      ],
      [
        1,
        9
      ],
      [
        -1,
        6
      ],
      [
        -1,
        5
      ],
      [
        -1,
        3
      ],
      [
        -4,
        4
      ],
      [
        0,
        10
      ],
      [
        1,
        1
      ]
    ],
    [
      [
        5246,
        85264
      ],
      [
        3,
        27
      ],
      [
        2,
        14
      ],
      [
        5,
        -12
      ],
      [
        5,
        -23
      ],
      [
        3,
        -29
      ],
      [
        1,
        -19
      ],
      [
        -2,
        -14
      ],
      [
        -5,
        -11
      ],
      [
        -3,
        24
      ],
      [
        -7,
        27
      ],
      [
        -2,
        16
      ]
    ],
    [
      [
        5213,
        85252
      ],
      [
        3,
        34
      ],
      [
        1,
        20
      ],
      [
        4,
        23
      ],
      [
        6,
        -24
      ],
      [
        1,
        -21
      ],
      [
        -2,
        -12
      ],
      [
        -11,
        -27
      ],
      [
        -2,
        7
      ]
    ],
    [
      [
        6115,
        85440
      ],
      [
        -5,
        -5
      ],
      [
        -7,
        -4
      ],
      [
        -5,
        -2
      ],
      [
        -4,
        0
      ],
      [
        -22,
        -21
      ],
      [
        -21,
        -31
      ],
      [
        -15,
        -6
      ],
      [
        -14,
        -16
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -8
      ],
      [
        -2,
        -8
      ],
      [
        -41,
        -28
      ],
      [
        -7,
        -8
      ],
      [
        -21,
        -33
      ],
      [
        -16,
        -20
      ],
      [
        -50,
        -51
      ],
      [
        -19,
        -15
      ],
      [
        -10,
        -7
      ],
      [
        -14,
        -2
      ],
      [
        -7,
        3
      ],
      [
        -5,
        4
      ],
      [
        -11,
        16
      ],
      [
        -7,
        11
      ],
      [
        -8,
        20
      ],
      [
        -2,
        6
      ],
      [
        0,
        5
      ],
      [
        1,
        7
      ],
      [
        -1,
        13
      ],
      [
        -3,
        31
      ],
      [
        -2,
        17
      ],
      [
        -7,
        24
      ],
      [
        -7,
        15
      ],
      [
        -6,
        10
      ],
      [
        -9,
        8
      ],
      [
        -16,
        7
      ],
      [
        -7,
        7
      ],
      [
        -4,
        5
      ],
      [
        -4,
        11
      ],
      [
        0,
        15
      ],
      [
        2,
        31
      ],
      [
        11,
        17
      ],
      [
        9,
        167
      ],
      [
        -12,
        -3
      ],
      [
        -25,
        -101
      ],
      [
        -27,
        -45
      ],
      [
        -3,
        -1
      ],
      [
        -5,
        3
      ],
      [
        -6,
        -11
      ],
      [
        -6,
        -58
      ],
      [
        -1,
        -7
      ],
      [
        1,
        -4
      ],
      [
        2,
        -16
      ],
      [
        2,
        -15
      ],
      [
        1,
        -5
      ],
      [
        0,
        -11
      ],
      [
        -4,
        -20
      ],
      [
        -4,
        -17
      ],
      [
        -3,
        -6
      ],
      [
        -5,
        -4
      ],
      [
        -6,
        -2
      ],
      [
        -3,
        -32
      ],
      [
        9,
        -80
      ],
      [
        16,
        -91
      ],
      [
        14,
        -59
      ],
      [
        5,
        -17
      ],
      [
        -26,
        -87
      ],
      [
        -10,
        -13
      ],
      [
        -14,
        -7
      ],
      [
        -4,
        -1
      ],
      [
        -13,
        8
      ],
      [
        -29,
        24
      ],
      [
        -4,
        6
      ],
      [
        -5,
        25
      ],
      [
        -30,
        130
      ],
      [
        -15,
        73
      ],
      [
        -32,
        135
      ],
      [
        -10,
        32
      ],
      [
        -16,
        41
      ],
      [
        -15,
        31
      ],
      [
        -8,
        11
      ],
      [
        -7,
        5
      ],
      [
        -6,
        3
      ],
      [
        -18,
        5
      ],
      [
        11,
        47
      ],
      [
        4,
        6
      ],
      [
        1,
        12
      ],
      [
        -3,
        14
      ],
      [
        -2,
        10
      ],
      [
        -3,
        12
      ],
      [
        -8,
        8
      ],
      [
        -4,
        0
      ],
      [
        -9,
        -8
      ],
      [
        -6,
        -2
      ],
      [
        -3,
        3
      ],
      [
        -3,
        -2
      ],
      [
        -6,
        -87
      ],
      [
        -15,
        7
      ],
      [
        4,
        -44
      ],
      [
        -3,
        -21
      ],
      [
        -29,
        -30
      ],
      [
        -24,
        79
      ],
      [
        3,
        26
      ],
      [
        -19,
        19
      ],
      [
        -11,
        -30
      ],
      [
        -16,
        6
      ],
      [
        -1,
        59
      ],
      [
        -22,
        -18
      ],
      [
        -15,
        51
      ],
      [
        -10,
        10
      ],
      [
        18,
        47
      ],
      [
        -17,
        89
      ],
      [
        -44,
        -52
      ],
      [
        -46,
        -72
      ],
      [
        -31,
        -62
      ],
      [
        -20,
        -95
      ],
      [
        -13,
        57
      ],
      [
        -36,
        -33
      ],
      [
        -10,
        -13
      ]
    ],
    [
      [
        5033,
        85142
      ],
      [
        1,
        54
      ],
      [
        6,
        77
      ],
      [
        39,
        52
      ],
      [
        21,
        6
      ],
      [
        39,
        76
      ],
      [
        5,
        -2
      ],
      [
        -55,
        -273
      ],
      [
        -22,
        -32
      ],
      [
        -32,
        -4
      ],
      [
        -2,
        7
      ],
      [
        0,
        39
      ]
    ],
    [
      [
        5036,
        85417
      ],
      [
        -31,
        -42
      ],
      [
        -43,
        -54
      ],
      [
        -1,
        -5
      ]
    ],
    [
      [
        18336,
        56517
      ],
      [
        164,
        1
      ],
      [
        88,
        -92
      ],
      [
        43,
        -45
      ],
      [
        3,
        20
      ],
      [
        6,
        7
      ],
      [
        2,
        12
      ],
      [
        1,
        24
      ],
      [
        -3,
        6
      ],
      [
        8,
        31
      ],
      [
        5,
        8
      ],
      [
        1,
        18
      ],
      [
        3,
        18
      ],
      [
        0,
        7
      ],
      [
        6,
        9
      ],
      [
        -1,
        16
      ],
      [
        3,
        9
      ],
      [
        -3,
        8
      ],
      [
        84,
        -38
      ],
      [
        38,
        -18
      ],
      [
        64,
        0
      ]
    ],
    [
      [
        25605,
        61809
      ],
      [
        6,
        -7
      ],
      [
        5,
        15
      ],
      [
        8,
        -9
      ],
      [
        7,
        -33
      ],
      [
        12,
        25
      ],
      [
        6,
        -29
      ],
      [
        4,
        3
      ]
    ],
    [
      [
        25653,
        61774
      ],
      [
        -1,
        -108
      ],
      [
        1,
        -102
      ],
      [
        -1,
        -119
      ]
    ],
    [
      [
        25652,
        61445
      ],
      [
        -62,
        -1
      ],
      [
        0,
        17
      ],
      [
        -5,
        0
      ]
    ],
    [
      [
        25585,
        61461
      ],
      [
        0,
        158
      ],
      [
        -7,
        -4
      ],
      [
        -5,
        11
      ],
      [
        -4,
        -13
      ],
      [
        -10,
        -1
      ],
      [
        0,
        70
      ],
      [
        -10,
        0
      ],
      [
        0,
        34
      ],
      [
        -5,
        1
      ],
      [
        0,
        79
      ]
    ],
    [
      [
        26212,
        62696
      ],
      [
        -5,
        -99
      ],
      [
        -1,
        -18
      ],
      [
        -7,
        -182
      ],
      [
        -6,
        -119
      ]
    ],
    [
      [
        26192,
        62257
      ],
      [
        -18,
        -2
      ],
      [
        -1,
        -17
      ]
    ],
    [
      [
        26173,
        62238
      ],
      [
        -67,
        -1
      ]
    ],
    [
      [
        22479,
        60863
      ],
      [
        91,
        1
      ],
      [
        92,
        1
      ]
    ],
    [
      [
        22662,
        60460
      ],
      [
        -151,
        -2
      ]
    ],
    [
      [
        22472,
        62999
      ],
      [
        92,
        0
      ],
      [
        63,
        -1
      ]
    ],
    [
      [
        22628,
        62695
      ],
      [
        -1,
        -34
      ],
      [
        1,
        -67
      ]
    ],
    [
      [
        22628,
        62594
      ],
      [
        -156,
        0
      ]
    ],
    [
      [
        22472,
        62594
      ],
      [
        0,
        405
      ]
    ],
    [
      [
        22167,
        61480
      ],
      [
        4,
        0
      ],
      [
        0,
        -204
      ]
    ],
    [
      [
        21988,
        61176
      ],
      [
        0,
        304
      ]
    ],
    [
      [
        23026,
        62187
      ],
      [
        0,
        -51
      ],
      [
        31,
        0
      ],
      [
        0,
        -101
      ],
      [
        10,
        0
      ]
    ],
    [
      [
        22906,
        61884
      ],
      [
        0,
        48
      ],
      [
        -1,
        5
      ],
      [
        0,
        3
      ],
      [
        1,
        25
      ],
      [
        0,
        20
      ],
      [
        1,
        0
      ],
      [
        0,
        135
      ],
      [
        10,
        0
      ],
      [
        0,
        67
      ]
    ],
    [
      [
        23881,
        70666
      ],
      [
        0,
        -201
      ],
      [
        -24,
        1
      ],
      [
        1,
        -288
      ]
    ],
    [
      [
        23859,
        69973
      ],
      [
        -69,
        1
      ]
    ],
    [
      [
        23788,
        70280
      ],
      [
        -1,
        102
      ],
      [
        0,
        85
      ],
      [
        -12,
        0
      ],
      [
        0,
        202
      ]
    ],
    [
      [
        23775,
        70669
      ],
      [
        0,
        101
      ],
      [
        4,
        0
      ]
    ],
    [
      [
        25189,
        57111
      ],
      [
        54,
        0
      ],
      [
        0,
        -51
      ]
    ],
    [
      [
        25243,
        57060
      ],
      [
        0,
        -148
      ],
      [
        -1,
        -72
      ],
      [
        1,
        -49
      ],
      [
        0,
        -169
      ]
    ],
    [
      [
        25243,
        56622
      ],
      [
        -49,
        0
      ],
      [
        0,
        -17
      ]
    ],
    [
      [
        25165,
        56605
      ],
      [
        0,
        85
      ],
      [
        -1,
        68
      ],
      [
        0,
        185
      ]
    ],
    [
      [
        24915,
        57163
      ],
      [
        14,
        1
      ]
    ],
    [
      [
        24929,
        57164
      ],
      [
        44,
        0
      ],
      [
        7,
        -1
      ],
      [
        15,
        -39
      ],
      [
        8,
        8
      ],
      [
        7,
        -12
      ],
      [
        7,
        6
      ],
      [
        8,
        4
      ],
      [
        0,
        -3
      ],
      [
        9,
        -7
      ],
      [
        2,
        -12
      ],
      [
        6,
        -1
      ],
      [
        5,
        -12
      ]
    ],
    [
      [
        25047,
        56960
      ],
      [
        0,
        -254
      ]
    ],
    [
      [
        24974,
        56707
      ],
      [
        0,
        34
      ],
      [
        -5,
        0
      ],
      [
        -54,
        1
      ]
    ],
    [
      [
        24915,
        56742
      ],
      [
        0,
        421
      ]
    ],
    [
      [
        24632,
        53941
      ],
      [
        1,
        51
      ],
      [
        4,
        17
      ],
      [
        0,
        70
      ],
      [
        1,
        85
      ],
      [
        -1,
        82
      ]
    ],
    [
      [
        24637,
        54246
      ],
      [
        16,
        1
      ],
      [
        1,
        1
      ],
      [
        119,
        0
      ]
    ],
    [
      [
        24773,
        54248
      ],
      [
        -5,
        -21
      ],
      [
        2,
        -14
      ],
      [
        5,
        -1
      ],
      [
        -3,
        -12
      ],
      [
        3,
        -14
      ],
      [
        10,
        -55
      ],
      [
        -2,
        5
      ],
      [
        1,
        -11
      ],
      [
        -2,
        -3
      ],
      [
        5,
        1
      ],
      [
        3,
        -29
      ],
      [
        0,
        -15
      ],
      [
        6,
        -14
      ],
      [
        2,
        -20
      ],
      [
        2,
        -21
      ],
      [
        -2,
        -11
      ],
      [
        -5,
        -5
      ],
      [
        6,
        -29
      ],
      [
        -4,
        -22
      ],
      [
        3,
        -12
      ],
      [
        8,
        0
      ],
      [
        1,
        -14
      ],
      [
        -6,
        -13
      ],
      [
        2,
        -16
      ]
    ],
    [
      [
        24803,
        53902
      ],
      [
        -3,
        4
      ],
      [
        -4,
        -11
      ],
      [
        -2,
        1
      ],
      [
        -8,
        -18
      ],
      [
        -17,
        -17
      ]
    ],
    [
      [
        25075,
        53531
      ],
      [
        56,
        0
      ]
    ],
    [
      [
        25131,
        53531
      ],
      [
        29,
        0
      ]
    ],
    [
      [
        25160,
        53531
      ],
      [
        0,
        -507
      ],
      [
        2,
        0
      ]
    ],
    [
      [
        25162,
        53024
      ],
      [
        0,
        -102
      ],
      [
        -14,
        0
      ]
    ],
    [
      [
        25077,
        52921
      ],
      [
        0,
        105
      ],
      [
        -2,
        1
      ],
      [
        0,
        504
      ]
    ],
    [
      [
        22847,
        73041
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -4
      ],
      [
        1,
        0
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        28916,
        63579
      ],
      [
        3,
        -15
      ],
      [
        6,
        -30
      ],
      [
        2,
        -12
      ],
      [
        2,
        4
      ],
      [
        7,
        -35
      ],
      [
        3,
        -15
      ]
    ],
    [
      [
        28939,
        63476
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -6
      ],
      [
        8,
        -8
      ],
      [
        -1,
        -15
      ],
      [
        1,
        -7
      ],
      [
        1,
        -2
      ],
      [
        3,
        -5
      ],
      [
        -4,
        -24
      ],
      [
        -1,
        -15
      ],
      [
        -1,
        -11
      ],
      [
        -3,
        -8
      ],
      [
        0,
        -7
      ],
      [
        1,
        -6
      ],
      [
        13,
        -1
      ],
      [
        1,
        -12
      ]
    ],
    [
      [
        28957,
        63346
      ],
      [
        -2,
        -5
      ],
      [
        -4,
        -5
      ],
      [
        -3,
        -3
      ],
      [
        -7,
        -6
      ],
      [
        -7,
        0
      ],
      [
        -4,
        1
      ],
      [
        -4,
        0
      ],
      [
        -2,
        -1
      ],
      [
        -3,
        -4
      ],
      [
        -4,
        -7
      ],
      [
        -4,
        -14
      ],
      [
        -5,
        -14
      ],
      [
        -1,
        0
      ],
      [
        -3,
        -9
      ],
      [
        -4,
        -7
      ]
    ],
    [
      [
        29911,
        65511
      ],
      [
        24,
        2
      ],
      [
        9,
        1
      ],
      [
        30,
        2
      ],
      [
        5,
        1
      ],
      [
        3,
        0
      ],
      [
        10,
        1
      ],
      [
        6,
        0
      ],
      [
        4,
        1
      ],
      [
        5,
        10
      ],
      [
        -1,
        9
      ],
      [
        2,
        11
      ],
      [
        2,
        3
      ],
      [
        4,
        5
      ],
      [
        0,
        -3
      ],
      [
        4,
        6
      ],
      [
        1,
        1
      ],
      [
        4,
        -12
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        30023,
        65548
      ],
      [
        2,
        -13
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -14
      ],
      [
        1,
        -2
      ],
      [
        1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        2,
        -3
      ],
      [
        0,
        -26
      ],
      [
        -2,
        -26
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        0
      ],
      [
        -2,
        6
      ],
      [
        0,
        14
      ],
      [
        -8,
        0
      ],
      [
        -6,
        3
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -4
      ],
      [
        2,
        -26
      ],
      [
        4,
        3
      ],
      [
        1,
        4
      ],
      [
        4,
        -10
      ],
      [
        1,
        -10
      ]
    ],
    [
      [
        30017,
        65428
      ],
      [
        -10,
        -10
      ],
      [
        -2,
        -19
      ],
      [
        -5,
        6
      ],
      [
        -5,
        -22
      ],
      [
        1,
        -15
      ],
      [
        -11,
        0
      ],
      [
        -6,
        -1
      ],
      [
        -28,
        -1
      ],
      [
        -4,
        -2
      ],
      [
        -36,
        -3
      ]
    ],
    [
      [
        29911,
        65361
      ],
      [
        0,
        51
      ]
    ],
    [
      [
        29911,
        65412
      ],
      [
        0,
        99
      ]
    ],
    [
      [
        24197,
        65671
      ],
      [
        97,
        -1
      ],
      [
        33,
        0
      ]
    ],
    [
      [
        23011,
        65530
      ],
      [
        31,
        0
      ],
      [
        -1,
        -68
      ]
    ],
    [
      [
        22913,
        65194
      ],
      [
        0,
        4
      ]
    ],
    [
      [
        27997,
        62961
      ],
      [
        -13,
        -43
      ],
      [
        -7,
        -40
      ],
      [
        -11,
        -19
      ],
      [
        -6,
        -26
      ],
      [
        0,
        -14
      ],
      [
        -6,
        -42
      ],
      [
        -11,
        -54
      ],
      [
        -9,
        -2
      ],
      [
        -11,
        -41
      ],
      [
        -1,
        -17
      ],
      [
        -9,
        -21
      ],
      [
        -6,
        -27
      ]
    ],
    [
      [
        27907,
        62615
      ],
      [
        -43,
        87
      ],
      [
        -29,
        12
      ],
      [
        -9,
        8
      ]
    ],
    [
      [
        24335,
        57718
      ],
      [
        10,
        23
      ],
      [
        6,
        -4
      ],
      [
        12,
        19
      ],
      [
        6,
        -15
      ],
      [
        4,
        4
      ],
      [
        6,
        -13
      ],
      [
        1,
        -18
      ],
      [
        9,
        -8
      ],
      [
        6,
        6
      ],
      [
        1,
        77
      ],
      [
        33,
        -3
      ]
    ],
    [
      [
        24453,
        57174
      ],
      [
        -60,
        5
      ],
      [
        -1,
        -101
      ],
      [
        -5,
        -2
      ],
      [
        -17,
        3
      ]
    ],
    [
      [
        19295,
        56015
      ],
      [
        3,
        4
      ],
      [
        1,
        -14
      ],
      [
        12,
        -28
      ],
      [
        4,
        -16
      ],
      [
        -1,
        -14
      ],
      [
        5,
        -7
      ],
      [
        -2,
        -23
      ],
      [
        4,
        6
      ],
      [
        4,
        -14
      ],
      [
        5,
        -1
      ],
      [
        5,
        11
      ],
      [
        1,
        21
      ],
      [
        4,
        21
      ],
      [
        5,
        5
      ],
      [
        8,
        21
      ],
      [
        3,
        18
      ],
      [
        -1,
        16
      ],
      [
        4,
        13
      ],
      [
        11,
        -1
      ],
      [
        5,
        21
      ],
      [
        1,
        14
      ],
      [
        5,
        0
      ],
      [
        7,
        15
      ],
      [
        1,
        -7
      ],
      [
        7,
        3
      ],
      [
        4,
        22
      ],
      [
        5,
        13
      ]
    ],
    [
      [
        19512,
        54686
      ],
      [
        -30,
        1
      ],
      [
        -2,
        -3
      ],
      [
        -263,
        2
      ],
      [
        -49,
        1
      ],
      [
        -29,
        1
      ]
    ],
    [
      [
        20420,
        64069
      ],
      [
        13,
        -14
      ],
      [
        0,
        -31
      ],
      [
        -3,
        -14
      ],
      [
        1,
        -17
      ],
      [
        7,
        -26
      ],
      [
        0,
        -15
      ],
      [
        6,
        -31
      ],
      [
        9,
        -15
      ],
      [
        2,
        -13
      ],
      [
        7,
        -13
      ],
      [
        0,
        -13
      ],
      [
        5,
        -12
      ],
      [
        1,
        -35
      ],
      [
        8,
        -14
      ]
    ],
    [
      [
        20476,
        63806
      ],
      [
        2,
        -12
      ],
      [
        -4,
        -1
      ],
      [
        -3,
        -48
      ],
      [
        -2,
        -8
      ],
      [
        3,
        -50
      ],
      [
        9,
        -14
      ],
      [
        2,
        -22
      ],
      [
        -2,
        -17
      ],
      [
        0,
        -44
      ],
      [
        -4,
        -19
      ],
      [
        3,
        -15
      ],
      [
        -4,
        -26
      ],
      [
        -10,
        -10
      ],
      [
        2,
        -26
      ],
      [
        -3,
        -60
      ],
      [
        5,
        -10
      ]
    ],
    [
      [
        20470,
        63424
      ],
      [
        -7,
        -48
      ],
      [
        3,
        -46
      ]
    ],
    [
      [
        20466,
        63330
      ],
      [
        -2,
        -15
      ],
      [
        -5,
        -1
      ],
      [
        -6,
        -39
      ],
      [
        -8,
        -11
      ],
      [
        -10,
        10
      ],
      [
        -6,
        -21
      ],
      [
        -8,
        3
      ],
      [
        -1,
        9
      ],
      [
        -9,
        1
      ],
      [
        -2,
        -15
      ],
      [
        4,
        -29
      ],
      [
        -1,
        -26
      ],
      [
        -7,
        -12
      ],
      [
        -5,
        -32
      ]
    ],
    [
      [
        20400,
        63152
      ],
      [
        -6,
        -12
      ],
      [
        -1,
        8
      ],
      [
        -13,
        -13
      ],
      [
        -4,
        3
      ],
      [
        -6,
        9
      ],
      [
        -1,
        20
      ],
      [
        -6,
        15
      ],
      [
        -2,
        42
      ],
      [
        -4,
        31
      ],
      [
        -1,
        22
      ],
      [
        -13,
        44
      ],
      [
        -5,
        -5
      ],
      [
        -6,
        7
      ],
      [
        -9,
        21
      ],
      [
        -8,
        43
      ],
      [
        -6,
        16
      ],
      [
        -12,
        5
      ],
      [
        -28,
        -5
      ],
      [
        0,
        12
      ],
      [
        -11,
        0
      ]
    ],
    [
      [
        20258,
        63415
      ],
      [
        -51,
        1
      ],
      [
        -2,
        -1
      ]
    ],
    [
      [
        20205,
        63415
      ],
      [
        0,
        88
      ],
      [
        -3,
        2
      ],
      [
        0,
        206
      ],
      [
        1,
        189
      ],
      [
        -6,
        0
      ],
      [
        1,
        121
      ]
    ],
    [
      [
        20100,
        61346
      ],
      [
        1,
        324
      ],
      [
        66,
        -1
      ],
      [
        144,
        -2
      ]
    ],
    [
      [
        20311,
        61667
      ],
      [
        33,
        -1
      ],
      [
        14,
        2
      ],
      [
        5,
        24
      ],
      [
        0,
        14
      ],
      [
        4,
        2
      ],
      [
        7,
        -5
      ],
      [
        2,
        -9
      ]
    ],
    [
      [
        20376,
        61694
      ],
      [
        0,
        -7
      ],
      [
        4,
        -23
      ],
      [
        4,
        -1
      ],
      [
        10,
        -34
      ],
      [
        1,
        -14
      ],
      [
        7,
        -13
      ],
      [
        8,
        -31
      ],
      [
        4,
        -29
      ],
      [
        5,
        -20
      ],
      [
        4,
        -6
      ],
      [
        7,
        -23
      ],
      [
        6,
        -10
      ]
    ],
    [
      [
        20436,
        61483
      ],
      [
        2,
        -24
      ],
      [
        15,
        -41
      ],
      [
        10,
        -47
      ],
      [
        7,
        -11
      ],
      [
        0,
        -15
      ],
      [
        3,
        -32
      ],
      [
        2,
        -31
      ],
      [
        8,
        -29
      ],
      [
        9,
        -63
      ],
      [
        -2,
        -5
      ],
      [
        6,
        -39
      ],
      [
        -1,
        -10
      ],
      [
        7,
        -18
      ],
      [
        7,
        4
      ],
      [
        7,
        -18
      ],
      [
        2,
        -19
      ],
      [
        8,
        -32
      ]
    ],
    [
      [
        20526,
        61053
      ],
      [
        -1,
        -18
      ],
      [
        7,
        -2
      ],
      [
        6,
        -31
      ],
      [
        -1,
        -55
      ],
      [
        -6,
        -10
      ],
      [
        2,
        -21
      ],
      [
        -2,
        -31
      ]
    ],
    [
      [
        20101,
        61123
      ],
      [
        -1,
        223
      ]
    ],
    [
      [
        27305,
        49119
      ],
      [
        75,
        -2
      ]
    ],
    [
      [
        27380,
        49117
      ],
      [
        26,
        2
      ],
      [
        1,
        -99
      ],
      [
        27,
        0
      ]
    ],
    [
      [
        27360,
        48615
      ],
      [
        -2,
        17
      ],
      [
        -5,
        -9
      ],
      [
        -3,
        16
      ],
      [
        0,
        18
      ],
      [
        -4,
        5
      ],
      [
        -1,
        20
      ],
      [
        0,
        31
      ],
      [
        -2,
        8
      ],
      [
        -5,
        0
      ],
      [
        -2,
        26
      ],
      [
        -3,
        5
      ],
      [
        -2,
        14
      ],
      [
        4,
        10
      ],
      [
        0,
        12
      ],
      [
        -13,
        31
      ],
      [
        -5,
        -8
      ],
      [
        -8,
        17
      ],
      [
        1,
        12
      ],
      [
        -5,
        9
      ],
      [
        1,
        26
      ],
      [
        -3,
        15
      ],
      [
        -7,
        19
      ],
      [
        -3,
        22
      ],
      [
        -6,
        9
      ],
      [
        2,
        24
      ],
      [
        -4,
        21
      ],
      [
        6,
        33
      ],
      [
        4,
        1
      ],
      [
        3,
        20
      ],
      [
        3,
        0
      ],
      [
        0,
        19
      ],
      [
        4,
        8
      ],
      [
        0,
        53
      ]
    ],
    [
      [
        26454,
        57238
      ],
      [
        -8,
        -25
      ],
      [
        -8,
        1
      ],
      [
        0,
        -34
      ],
      [
        -12,
        2
      ],
      [
        -3,
        13
      ],
      [
        -8,
        -1
      ],
      [
        -3,
        -21
      ]
    ],
    [
      [
        26412,
        57173
      ],
      [
        -7,
        1
      ],
      [
        0,
        -17
      ],
      [
        -18,
        1
      ],
      [
        -9,
        0
      ],
      [
        0,
        16
      ],
      [
        -5,
        0
      ],
      [
        3,
        -15
      ],
      [
        -7,
        0
      ],
      [
        0,
        15
      ],
      [
        -6,
        -15
      ],
      [
        -37,
        -2
      ]
    ],
    [
      [
        26326,
        57157
      ],
      [
        0,
        40
      ]
    ],
    [
      [
        26899,
        53572
      ],
      [
        29,
        0
      ],
      [
        0,
        -30
      ],
      [
        4,
        0
      ],
      [
        0,
        -30
      ],
      [
        18,
        0
      ]
    ],
    [
      [
        26950,
        53512
      ],
      [
        0,
        -15
      ],
      [
        4,
        0
      ],
      [
        0,
        -16
      ],
      [
        -4,
        0
      ],
      [
        0,
        -14
      ],
      [
        4,
        0
      ],
      [
        0,
        -16
      ],
      [
        3,
        0
      ],
      [
        0,
        -63
      ],
      [
        2,
        -23
      ],
      [
        2,
        -1
      ],
      [
        5,
        -31
      ],
      [
        10,
        -30
      ],
      [
        2,
        -14
      ],
      [
        9,
        -2
      ]
    ],
    [
      [
        26987,
        53287
      ],
      [
        0,
        -37
      ],
      [
        9,
        -11
      ],
      [
        5,
        -15
      ],
      [
        7,
        1
      ],
      [
        0,
        -100
      ],
      [
        12,
        -42
      ],
      [
        9,
        -44
      ]
    ],
    [
      [
        27006,
        52524
      ],
      [
        -10,
        3
      ],
      [
        -2,
        0
      ],
      [
        -8,
        3
      ],
      [
        -25,
        6
      ],
      [
        -12,
        3
      ]
    ],
    [
      [
        26949,
        52539
      ],
      [
        0,
        37
      ],
      [
        -3,
        -1
      ],
      [
        0,
        91
      ],
      [
        -1,
        30
      ],
      [
        4,
        0
      ],
      [
        0,
        15
      ],
      [
        -4,
        0
      ],
      [
        -1,
        106
      ],
      [
        -16,
        -1
      ],
      [
        1,
        15
      ],
      [
        0,
        152
      ],
      [
        -8,
        0
      ],
      [
        -8,
        44
      ],
      [
        -12,
        21
      ],
      [
        -21,
        179
      ],
      [
        -1,
        13
      ]
    ],
    [
      [
        24193,
        62743
      ],
      [
        62,
        -8
      ],
      [
        103,
        -2
      ]
    ],
    [
      [
        24249,
        62413
      ],
      [
        2,
        205
      ],
      [
        -59,
        7
      ]
    ],
    [
      [
        24192,
        62625
      ],
      [
        1,
        102
      ],
      [
        0,
        16
      ]
    ],
    [
      [
        20311,
        58766
      ],
      [
        -1,
        -88
      ]
    ],
    [
      [
        20310,
        58678
      ],
      [
        -8,
        0
      ],
      [
        4,
        -6
      ],
      [
        1,
        -4
      ],
      [
        3,
        -5
      ],
      [
        0,
        -4
      ]
    ],
    [
      [
        20310,
        58659
      ],
      [
        7,
        -12
      ],
      [
        5,
        1
      ],
      [
        9,
        -2
      ],
      [
        0,
        -3
      ],
      [
        -6,
        -25
      ],
      [
        -4,
        -30
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        -9,
        -19
      ]
    ],
    [
      [
        20310,
        58562
      ],
      [
        -9,
        42
      ],
      [
        -21,
        29
      ],
      [
        -7,
        -10
      ],
      [
        -8,
        3
      ],
      [
        -2,
        17
      ],
      [
        5,
        3
      ],
      [
        0,
        154
      ],
      [
        4,
        -9
      ],
      [
        19,
        0
      ],
      [
        5,
        7
      ],
      [
        0,
        17
      ],
      [
        10,
        0
      ],
      [
        4,
        -8
      ]
    ],
    [
      [
        19205,
        72136
      ],
      [
        15,
        -1
      ],
      [
        4,
        15
      ],
      [
        19,
        23
      ],
      [
        0,
        8
      ],
      [
        13,
        28
      ],
      [
        8,
        -4
      ],
      [
        8,
        18
      ],
      [
        17,
        35
      ],
      [
        12,
        4
      ],
      [
        6,
        18
      ],
      [
        0,
        29
      ],
      [
        2,
        14
      ],
      [
        -2,
        33
      ],
      [
        3,
        23
      ],
      [
        2,
        27
      ],
      [
        -3,
        50
      ],
      [
        1,
        24
      ],
      [
        23,
        -10
      ],
      [
        9,
        -1
      ],
      [
        13,
        37
      ],
      [
        12,
        6
      ],
      [
        7,
        -8
      ],
      [
        8,
        18
      ],
      [
        11,
        -11
      ]
    ],
    [
      [
        19393,
        72511
      ],
      [
        8,
        7
      ],
      [
        7,
        -16
      ],
      [
        6,
        -7
      ],
      [
        8,
        1
      ],
      [
        3,
        -7
      ],
      [
        21,
        36
      ],
      [
        10,
        9
      ],
      [
        4,
        14
      ],
      [
        5,
        7
      ],
      [
        2,
        19
      ],
      [
        12,
        2
      ],
      [
        11,
        -4
      ],
      [
        9,
        -13
      ],
      [
        8,
        1
      ],
      [
        18,
        24
      ],
      [
        10,
        -10
      ],
      [
        8,
        12
      ],
      [
        7,
        -1
      ],
      [
        5,
        -11
      ],
      [
        4,
        -1
      ],
      [
        0,
        -22
      ],
      [
        7,
        -19
      ],
      [
        -9,
        -23
      ],
      [
        2,
        -9
      ],
      [
        7,
        7
      ],
      [
        8,
        -1
      ]
    ],
    [
      [
        22141,
        66682
      ],
      [
        5,
        4
      ],
      [
        9,
        -12
      ],
      [
        12,
        0
      ],
      [
        13,
        -8
      ],
      [
        18,
        24
      ],
      [
        3,
        16
      ],
      [
        7,
        2
      ],
      [
        6,
        22
      ],
      [
        4,
        -1
      ],
      [
        6,
        12
      ],
      [
        12,
        -2
      ],
      [
        10,
        19
      ],
      [
        7,
        -2
      ],
      [
        5,
        11
      ]
    ],
    [
      [
        22264,
        65933
      ],
      [
        -119,
        -2
      ]
    ],
    [
      [
        21247,
        73451
      ],
      [
        182,
        0
      ]
    ],
    [
      [
        21429,
        73451
      ],
      [
        72,
        1
      ],
      [
        0,
        -204
      ],
      [
        14,
        1
      ],
      [
        0,
        -407
      ],
      [
        15,
        0
      ],
      [
        -1,
        -204
      ]
    ],
    [
      [
        21386,
        72533
      ],
      [
        -8,
        -7
      ],
      [
        -16,
        15
      ],
      [
        -7,
        18
      ],
      [
        -18,
        0
      ],
      [
        -17,
        31
      ],
      [
        -5,
        20
      ]
    ],
    [
      [
        21315,
        72610
      ],
      [
        -4,
        43
      ],
      [
        2,
        48
      ],
      [
        11,
        43
      ],
      [
        12,
        35
      ],
      [
        4,
        35
      ],
      [
        -12,
        15
      ],
      [
        -1,
        29
      ],
      [
        -3,
        11
      ],
      [
        -9,
        -11
      ],
      [
        -4,
        3
      ],
      [
        -3,
        13
      ],
      [
        1,
        30
      ],
      [
        -11,
        13
      ],
      [
        -9,
        1
      ],
      [
        -7,
        8
      ],
      [
        5,
        6
      ],
      [
        1,
        19
      ],
      [
        -7,
        15
      ],
      [
        -9,
        -12
      ],
      [
        -9,
        5
      ]
    ],
    [
      [
        25478,
        61055
      ],
      [
        3,
        6
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        2,
        -2
      ],
      [
        1,
        -2
      ],
      [
        1,
        -5
      ],
      [
        1,
        -2
      ],
      [
        0,
        -19
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        -2,
        -11
      ],
      [
        0,
        -18
      ],
      [
        1,
        -5
      ],
      [
        1,
        -5
      ],
      [
        0,
        -3
      ],
      [
        2,
        -2
      ],
      [
        3,
        -2
      ],
      [
        3,
        0
      ],
      [
        3,
        1
      ],
      [
        3,
        3
      ],
      [
        2,
        3
      ],
      [
        1,
        2
      ],
      [
        2,
        6
      ],
      [
        4,
        21
      ],
      [
        1,
        5
      ],
      [
        0,
        9
      ],
      [
        -1,
        21
      ],
      [
        -2,
        6
      ],
      [
        -1,
        4
      ],
      [
        -2,
        4
      ],
      [
        -3,
        9
      ],
      [
        -1,
        5
      ],
      [
        -1,
        6
      ],
      [
        0,
        12
      ],
      [
        1,
        8
      ],
      [
        1,
        6
      ],
      [
        3,
        7
      ],
      [
        1,
        6
      ],
      [
        1,
        11
      ],
      [
        -1,
        3
      ],
      [
        0,
        4
      ],
      [
        1,
        4
      ],
      [
        0,
        5
      ],
      [
        2,
        2
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        0,
        -1
      ],
      [
        1,
        0
      ],
      [
        1,
        -2
      ],
      [
        1,
        -3
      ],
      [
        1,
        -4
      ],
      [
        0,
        -24
      ],
      [
        1,
        -7
      ],
      [
        1,
        -4
      ],
      [
        2,
        -8
      ],
      [
        2,
        -6
      ],
      [
        1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        4,
        -7
      ],
      [
        3,
        -4
      ],
      [
        2,
        -7
      ],
      [
        1,
        0
      ],
      [
        2,
        3
      ],
      [
        3,
        9
      ],
      [
        1,
        4
      ],
      [
        6,
        15
      ],
      [
        4,
        9
      ]
    ],
    [
      [
        25547,
        61106
      ],
      [
        1,
        1
      ],
      [
        3,
        3
      ],
      [
        5,
        0
      ],
      [
        5,
        -3
      ],
      [
        0,
        -1
      ],
      [
        3,
        -3
      ],
      [
        3,
        -3
      ],
      [
        2,
        -4
      ],
      [
        0,
        -3
      ],
      [
        3,
        -9
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        1,
        -3
      ],
      [
        1,
        -2
      ],
      [
        2,
        -6
      ],
      [
        2,
        -4
      ],
      [
        1,
        1
      ],
      [
        4,
        -3
      ],
      [
        5,
        -9
      ]
    ],
    [
      [
        25589,
        61056
      ],
      [
        -6,
        -92
      ],
      [
        5,
        -12
      ],
      [
        -2,
        -11
      ],
      [
        4,
        -17
      ],
      [
        7,
        -3
      ],
      [
        -2,
        -10
      ],
      [
        -3,
        -15
      ],
      [
        -9,
        -22
      ],
      [
        -13,
        -5
      ],
      [
        -7,
        -15
      ],
      [
        -4,
        -48
      ]
    ],
    [
      [
        25535,
        60764
      ],
      [
        -67,
        -10
      ]
    ],
    [
      [
        29908,
        65840
      ],
      [
        9,
        2
      ],
      [
        24,
        2
      ],
      [
        10,
        1
      ],
      [
        11,
        1
      ],
      [
        5,
        1
      ],
      [
        8,
        0
      ],
      [
        8,
        1
      ],
      [
        1,
        0
      ],
      [
        7,
        3
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        30042,
        65570
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -6
      ],
      [
        -3,
        -8
      ],
      [
        -1,
        1
      ],
      [
        -4,
        -4
      ]
    ],
    [
      [
        30030,
        65547
      ],
      [
        0,
        1
      ],
      [
        -1,
        9
      ],
      [
        0,
        15
      ],
      [
        -1,
        1
      ],
      [
        -1,
        6
      ],
      [
        -3,
        2
      ],
      [
        -2,
        -2
      ],
      [
        0,
        -6
      ],
      [
        1,
        -12
      ],
      [
        0,
        -13
      ]
    ],
    [
      [
        29911,
        65511
      ],
      [
        -1,
        52
      ],
      [
        0,
        45
      ],
      [
        -1,
        37
      ],
      [
        0,
        16
      ],
      [
        -1,
        72
      ],
      [
        0,
        107
      ]
    ],
    [
      [
        26436,
        59535
      ],
      [
        9,
        1
      ]
    ],
    [
      [
        26512,
        59533
      ],
      [
        2,
        -5
      ],
      [
        -1,
        -29
      ],
      [
        8,
        -69
      ],
      [
        3,
        -32
      ],
      [
        6,
        -54
      ],
      [
        7,
        -5
      ],
      [
        -2,
        -4
      ]
    ],
    [
      [
        26535,
        59335
      ],
      [
        1,
        -17
      ],
      [
        -5,
        -20
      ],
      [
        -9,
        15
      ],
      [
        -1,
        -15
      ],
      [
        2,
        -22
      ],
      [
        -6,
        -17
      ],
      [
        -1,
        -65
      ],
      [
        -3,
        -20
      ],
      [
        -4,
        1
      ],
      [
        -2,
        -14
      ]
    ],
    [
      [
        22782,
        48693
      ],
      [
        8,
        0
      ]
    ],
    [
      [
        22790,
        48693
      ],
      [
        -3,
        -50
      ],
      [
        -4,
        -95
      ],
      [
        -2,
        -108
      ],
      [
        1,
        -103
      ],
      [
        3,
        -100
      ],
      [
        5,
        -105
      ],
      [
        7,
        -109
      ],
      [
        7,
        -98
      ],
      [
        2,
        -20
      ]
    ],
    [
      [
        22806,
        47905
      ],
      [
        -7,
        -1
      ]
    ],
    [
      [
        22799,
        47904
      ],
      [
        -6,
        59
      ],
      [
        -6,
        87
      ],
      [
        -9,
        88
      ],
      [
        -3,
        106
      ],
      [
        1,
        138
      ],
      [
        -1,
        122
      ],
      [
        4,
        106
      ],
      [
        3,
        83
      ]
    ],
    [
      [
        22612,
        48613
      ],
      [
        8,
        5
      ],
      [
        2,
        23
      ],
      [
        14,
        6
      ],
      [
        4,
        -3
      ],
      [
        5,
        6
      ],
      [
        3,
        14
      ],
      [
        4,
        -10
      ],
      [
        8,
        14
      ],
      [
        -1,
        18
      ],
      [
        6,
        0
      ],
      [
        3,
        14
      ],
      [
        13,
        -6
      ],
      [
        3,
        -15
      ],
      [
        22,
        21
      ],
      [
        3,
        -2
      ]
    ],
    [
      [
        22709,
        48698
      ],
      [
        -1,
        -13
      ],
      [
        1,
        -21
      ],
      [
        1,
        -7
      ],
      [
        2,
        -4
      ],
      [
        8,
        -1
      ],
      [
        4,
        -2
      ],
      [
        3,
        -2
      ],
      [
        3,
        -7
      ],
      [
        6,
        -4
      ],
      [
        6,
        2
      ],
      [
        3,
        5
      ],
      [
        2,
        5
      ],
      [
        0,
        5
      ],
      [
        5,
        8
      ],
      [
        5,
        3
      ],
      [
        2,
        7
      ],
      [
        2,
        3
      ],
      [
        8,
        2
      ],
      [
        0,
        -7
      ],
      [
        -3,
        -65
      ],
      [
        -2,
        -44
      ],
      [
        3,
        -4
      ],
      [
        -3,
        -98
      ],
      [
        -1,
        -104
      ],
      [
        -2,
        -89
      ],
      [
        -2,
        -74
      ],
      [
        -2,
        -44
      ],
      [
        -4,
        -3
      ],
      [
        2,
        -56
      ],
      [
        1,
        -21
      ],
      [
        1,
        -36
      ],
      [
        6,
        -89
      ],
      [
        0,
        -28
      ],
      [
        1,
        -11
      ]
    ],
    [
      [
        22764,
        47904
      ],
      [
        -117,
        -2
      ],
      [
        -27,
        16
      ]
    ],
    [
      [
        22620,
        47918
      ],
      [
        -8,
        5
      ],
      [
        0,
        192
      ]
    ],
    [
      [
        28193,
        66835
      ],
      [
        0,
        50
      ],
      [
        5,
        0
      ],
      [
        1,
        46
      ],
      [
        6,
        0
      ],
      [
        0,
        50
      ]
    ],
    [
      [
        28297,
        66930
      ],
      [
        6,
        -27
      ],
      [
        4,
        -65
      ],
      [
        -2,
        -13
      ],
      [
        -10,
        0
      ],
      [
        0,
        -106
      ],
      [
        -7,
        0
      ],
      [
        4,
        -106
      ],
      [
        31,
        -2
      ],
      [
        -1,
        -28
      ],
      [
        0,
        -80
      ]
    ],
    [
      [
        28322,
        66503
      ],
      [
        -47,
        3
      ],
      [
        0,
        -52
      ],
      [
        -17,
        0
      ],
      [
        -1,
        -75
      ]
    ],
    [
      [
        28170,
        66438
      ],
      [
        -2,
        16
      ],
      [
        -5,
        -3
      ],
      [
        4,
        29
      ],
      [
        4,
        12
      ],
      [
        -4,
        13
      ],
      [
        7,
        7
      ],
      [
        5,
        16
      ],
      [
        -3,
        12
      ],
      [
        7,
        6
      ],
      [
        6,
        56
      ],
      [
        3,
        6
      ],
      [
        1,
        227
      ]
    ],
    [
      [
        26924,
        61653
      ],
      [
        6,
        8
      ],
      [
        8,
        8
      ],
      [
        3,
        3
      ],
      [
        3,
        3
      ],
      [
        1,
        0
      ],
      [
        8,
        11
      ],
      [
        4,
        -6
      ],
      [
        2,
        1
      ],
      [
        7,
        4
      ],
      [
        5,
        3
      ],
      [
        3,
        4
      ],
      [
        2,
        5
      ],
      [
        1,
        10
      ],
      [
        1,
        12
      ],
      [
        1,
        10
      ],
      [
        0,
        8
      ],
      [
        2,
        9
      ],
      [
        0,
        38
      ],
      [
        1,
        7
      ],
      [
        1,
        4
      ],
      [
        0,
        6
      ],
      [
        1,
        26
      ],
      [
        0,
        17
      ],
      [
        1,
        4
      ],
      [
        1,
        5
      ]
    ],
    [
      [
        27005,
        61863
      ],
      [
        46,
        -136
      ]
    ],
    [
      [
        27051,
        61727
      ],
      [
        0,
        -56
      ],
      [
        2,
        -61
      ]
    ],
    [
      [
        27053,
        61610
      ],
      [
        -5,
        3
      ],
      [
        -9,
        -11
      ],
      [
        -6,
        -27
      ],
      [
        -13,
        -9
      ],
      [
        -3,
        4
      ],
      [
        -6,
        -34
      ],
      [
        -7,
        0
      ],
      [
        1,
        -1
      ],
      [
        3,
        -24
      ],
      [
        -9,
        -21
      ],
      [
        -7,
        -49
      ]
    ],
    [
      [
        26992,
        61441
      ],
      [
        -3,
        -1
      ],
      [
        -7,
        14
      ],
      [
        -3,
        33
      ],
      [
        3,
        22
      ],
      [
        -1,
        9
      ],
      [
        4,
        10
      ],
      [
        4,
        0
      ],
      [
        -6,
        29
      ],
      [
        -5,
        3
      ],
      [
        -4,
        -9
      ],
      [
        0,
        -10
      ],
      [
        -4,
        -9
      ],
      [
        -1,
        -1
      ],
      [
        -30,
        81
      ],
      [
        -10,
        27
      ],
      [
        -5,
        14
      ]
    ],
    [
      [
        16078,
        63679
      ],
      [
        10,
        0
      ],
      [
        -1,
        -42
      ],
      [
        8,
        -8
      ],
      [
        0,
        -26
      ],
      [
        3,
        0
      ],
      [
        -4,
        -40
      ],
      [
        -5,
        0
      ],
      [
        0,
        -25
      ],
      [
        -6,
        -17
      ],
      [
        0,
        -33
      ],
      [
        3,
        0
      ],
      [
        0,
        -34
      ],
      [
        -3,
        0
      ],
      [
        0,
        -33
      ],
      [
        3,
        -17
      ],
      [
        -6,
        -1
      ],
      [
        0,
        -16
      ],
      [
        6,
        0
      ],
      [
        -1,
        -34
      ],
      [
        9,
        -19
      ],
      [
        6,
        0
      ],
      [
        2,
        -34
      ],
      [
        6,
        0
      ],
      [
        0,
        -17
      ],
      [
        3,
        0
      ],
      [
        1,
        -17
      ],
      [
        9,
        -18
      ],
      [
        0,
        -16
      ],
      [
        4,
        1
      ],
      [
        1,
        -16
      ],
      [
        4,
        -1
      ],
      [
        1,
        -16
      ],
      [
        5,
        0
      ],
      [
        0,
        -17
      ],
      [
        5,
        0
      ],
      [
        1,
        -29
      ],
      [
        5,
        -1
      ],
      [
        0,
        -17
      ],
      [
        6,
        1
      ],
      [
        0,
        -17
      ],
      [
        4,
        -17
      ],
      [
        5,
        0
      ],
      [
        0,
        -33
      ],
      [
        11,
        -9
      ],
      [
        2,
        -20
      ],
      [
        4,
        -7
      ]
    ],
    [
      [
        16179,
        63034
      ],
      [
        -1,
        -14
      ],
      [
        -8,
        0
      ],
      [
        0,
        -21
      ],
      [
        -9,
        -6
      ],
      [
        -3,
        -8
      ],
      [
        0,
        -34
      ],
      [
        -2,
        -8
      ],
      [
        -7,
        9
      ],
      [
        -16,
        0
      ],
      [
        0,
        -16
      ],
      [
        -10,
        0
      ],
      [
        0,
        8
      ],
      [
        -8,
        -1
      ],
      [
        0,
        -25
      ],
      [
        -2,
        -25
      ],
      [
        -7,
        -18
      ],
      [
        -2,
        -26
      ],
      [
        3,
        -15
      ],
      [
        -7,
        -31
      ],
      [
        -4,
        -40
      ],
      [
        -2,
        -2
      ],
      [
        -7,
        -27
      ],
      [
        -8,
        -3
      ],
      [
        -3,
        -8
      ],
      [
        -8,
        4
      ],
      [
        -3,
        -19
      ],
      [
        -13,
        1
      ],
      [
        -9,
        -15
      ],
      [
        -8,
        3
      ],
      [
        -5,
        13
      ],
      [
        -4,
        -27
      ]
    ],
    [
      [
        16026,
        62683
      ],
      [
        -1,
        11
      ],
      [
        -78,
        -2
      ]
    ],
    [
      [
        15952,
        62785
      ],
      [
        6,
        77
      ],
      [
        -1,
        48
      ],
      [
        -1,
        22
      ],
      [
        6,
        32
      ],
      [
        -25,
        -1
      ],
      [
        -8,
        -9
      ],
      [
        -6,
        6
      ],
      [
        -2,
        28
      ],
      [
        3,
        5
      ],
      [
        -3,
        13
      ],
      [
        2,
        10
      ],
      [
        0,
        25
      ],
      [
        4,
        13
      ],
      [
        -3,
        17
      ],
      [
        1,
        17
      ],
      [
        5,
        5
      ],
      [
        -2,
        19
      ],
      [
        -5,
        8
      ],
      [
        9,
        7
      ],
      [
        6,
        24
      ],
      [
        -3,
        20
      ],
      [
        1,
        21
      ],
      [
        -2,
        -16
      ],
      [
        -3,
        3
      ],
      [
        2,
        17
      ],
      [
        -7,
        -1
      ],
      [
        -13,
        52
      ],
      [
        2,
        20
      ],
      [
        -6,
        0
      ]
    ],
    [
      [
        20400,
        63152
      ],
      [
        0,
        -30
      ],
      [
        4,
        -12
      ],
      [
        7,
        -7
      ],
      [
        6,
        12
      ],
      [
        4,
        -27
      ],
      [
        8,
        -1
      ],
      [
        1,
        -11
      ],
      [
        7,
        3
      ],
      [
        5,
        -29
      ],
      [
        -2,
        -13
      ],
      [
        -7,
        -19
      ],
      [
        -9,
        -12
      ],
      [
        3,
        -10
      ]
    ],
    [
      [
        20427,
        62996
      ],
      [
        4,
        -15
      ],
      [
        -1,
        -16
      ],
      [
        -8,
        -17
      ],
      [
        -4,
        8
      ],
      [
        -2,
        -16
      ],
      [
        4,
        -14
      ],
      [
        -3,
        -3
      ],
      [
        -4,
        -21
      ],
      [
        -4,
        0
      ],
      [
        -5,
        -32
      ],
      [
        -8,
        2
      ],
      [
        -1,
        -20
      ],
      [
        -6,
        -4
      ],
      [
        4,
        -27
      ],
      [
        -12,
        -15
      ],
      [
        -7,
        -23
      ],
      [
        -1,
        -23
      ],
      [
        -9,
        -4
      ],
      [
        -12,
        22
      ],
      [
        -10,
        2
      ]
    ],
    [
      [
        20342,
        62780
      ],
      [
        -20,
        0
      ]
    ],
    [
      [
        20322,
        62780
      ],
      [
        -1,
        3
      ],
      [
        1,
        6
      ],
      [
        1,
        3
      ],
      [
        -1,
        11
      ],
      [
        -2,
        7
      ],
      [
        -1,
        2
      ],
      [
        -1,
        6
      ],
      [
        -2,
        4
      ],
      [
        -1,
        6
      ],
      [
        1,
        9
      ],
      [
        1,
        5
      ],
      [
        -1,
        7
      ],
      [
        -2,
        5
      ],
      [
        -1,
        9
      ],
      [
        -1,
        9
      ],
      [
        -3,
        11
      ],
      [
        1,
        12
      ],
      [
        0,
        10
      ],
      [
        -1,
        7
      ],
      [
        -1,
        1
      ],
      [
        0,
        8
      ],
      [
        1,
        2
      ],
      [
        2,
        12
      ],
      [
        -3,
        15
      ],
      [
        2,
        16
      ],
      [
        1,
        6
      ],
      [
        1,
        3
      ],
      [
        2,
        -1
      ],
      [
        1,
        -6
      ],
      [
        1,
        -8
      ],
      [
        2,
        -3
      ],
      [
        1,
        1
      ],
      [
        1,
        -1
      ],
      [
        0,
        2
      ],
      [
        1,
        4
      ],
      [
        0,
        12
      ],
      [
        2,
        4
      ],
      [
        1,
        6
      ],
      [
        -1,
        3
      ],
      [
        -2,
        13
      ],
      [
        -1,
        10
      ],
      [
        1,
        12
      ],
      [
        0,
        11
      ],
      [
        2,
        10
      ],
      [
        3,
        -2
      ],
      [
        3,
        3
      ],
      [
        1,
        18
      ],
      [
        0,
        17
      ],
      [
        -3,
        19
      ],
      [
        -9,
        6
      ],
      [
        -3,
        4
      ],
      [
        -2,
        16
      ],
      [
        -4,
        4
      ],
      [
        -2,
        3
      ],
      [
        -1,
        7
      ],
      [
        0,
        14
      ],
      [
        -2,
        3
      ],
      [
        -1,
        1
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        4
      ],
      [
        -1,
        11
      ],
      [
        -1,
        8
      ],
      [
        -3,
        5
      ],
      [
        -3,
        6
      ],
      [
        -2,
        9
      ],
      [
        -2,
        12
      ],
      [
        -2,
        9
      ],
      [
        0,
        2
      ],
      [
        -2,
        0
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        7
      ],
      [
        -4,
        9
      ],
      [
        -1,
        27
      ],
      [
        -3,
        16
      ],
      [
        -4,
        28
      ],
      [
        -3,
        17
      ],
      [
        -2,
        27
      ],
      [
        -1,
        13
      ],
      [
        2,
        23
      ],
      [
        -3,
        28
      ],
      [
        1,
        6
      ]
    ],
    [
      [
        26756,
        56837
      ],
      [
        2,
        6
      ],
      [
        3,
        79
      ],
      [
        -4,
        -3
      ],
      [
        4,
        84
      ],
      [
        12,
        92
      ]
    ],
    [
      [
        26773,
        57095
      ],
      [
        1,
        -3
      ],
      [
        1,
        -5
      ],
      [
        3,
        -6
      ],
      [
        1,
        1
      ],
      [
        7,
        -14
      ],
      [
        3,
        0
      ],
      [
        0,
        8
      ]
    ],
    [
      [
        26850,
        56854
      ],
      [
        -14,
        -21
      ],
      [
        -25,
        -26
      ],
      [
        -12,
        -34
      ],
      [
        -6,
        -10
      ],
      [
        -5,
        10
      ],
      [
        2,
        7
      ],
      [
        -8,
        11
      ],
      [
        -16,
        -12
      ]
    ],
    [
      [
        24617,
        64243
      ],
      [
        0,
        50
      ],
      [
        1,
        454
      ]
    ],
    [
      [
        25690,
        62890
      ],
      [
        69,
        -4
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        25760,
        62886
      ],
      [
        15,
        0
      ],
      [
        0,
        -34
      ],
      [
        1,
        -17
      ],
      [
        0,
        -93
      ]
    ],
    [
      [
        25776,
        62742
      ],
      [
        -6,
        10
      ],
      [
        -2,
        -9
      ],
      [
        0,
        -20
      ],
      [
        -8,
        7
      ],
      [
        1,
        -198
      ]
    ],
    [
      [
        25658,
        62534
      ],
      [
        0,
        203
      ],
      [
        31,
        0
      ],
      [
        0,
        105
      ],
      [
        1,
        48
      ]
    ],
    [
      [
        25653,
        61774
      ],
      [
        2,
        -16
      ],
      [
        5,
        11
      ],
      [
        6,
        -4
      ],
      [
        9,
        7
      ],
      [
        5,
        -13
      ],
      [
        5,
        2
      ],
      [
        4,
        -13
      ],
      [
        1,
        13
      ],
      [
        4,
        2
      ]
    ],
    [
      [
        25694,
        61763
      ],
      [
        2,
        -10
      ],
      [
        11,
        -2
      ],
      [
        9,
        23
      ],
      [
        2,
        13
      ],
      [
        43,
        0
      ]
    ],
    [
      [
        25731,
        61413
      ],
      [
        -37,
        -2
      ],
      [
        -26,
        0
      ]
    ],
    [
      [
        25668,
        61411
      ],
      [
        -16,
        1
      ],
      [
        0,
        33
      ]
    ],
    [
      [
        22318,
        61986
      ],
      [
        2,
        0
      ]
    ],
    [
      [
        22320,
        61986
      ],
      [
        1,
        -406
      ]
    ],
    [
      [
        22321,
        61580
      ],
      [
        -61,
        3
      ],
      [
        -31,
        -2
      ],
      [
        -62,
        0
      ]
    ],
    [
      [
        24197,
        65671
      ],
      [
        0,
        506
      ]
    ],
    [
      [
        26409,
        59963
      ],
      [
        4,
        14
      ],
      [
        -2,
        21
      ],
      [
        9,
        12
      ],
      [
        1,
        9
      ],
      [
        -5,
        20
      ],
      [
        6,
        1
      ],
      [
        2,
        15
      ],
      [
        -4,
        3
      ],
      [
        0,
        20
      ],
      [
        -2,
        5
      ],
      [
        7,
        29
      ],
      [
        4,
        2
      ],
      [
        2,
        15
      ],
      [
        -4,
        14
      ],
      [
        4,
        5
      ],
      [
        -5,
        4
      ],
      [
        2,
        9
      ],
      [
        0,
        26
      ]
    ],
    [
      [
        26426,
        59947
      ],
      [
        -14,
        -7
      ],
      [
        -6,
        7
      ],
      [
        3,
        16
      ]
    ],
    [
      [
        22323,
        61175
      ],
      [
        31,
        0
      ],
      [
        0,
        303
      ]
    ],
    [
      [
        22354,
        61478
      ],
      [
        120,
        0
      ]
    ],
    [
      [
        22474,
        61478
      ],
      [
        3,
        0
      ],
      [
        -1,
        -102
      ]
    ],
    [
      [
        22476,
        61376
      ],
      [
        1,
        -406
      ]
    ],
    [
      [
        23935,
        53450
      ],
      [
        57,
        -4
      ],
      [
        11,
        0
      ],
      [
        3,
        -16
      ]
    ],
    [
      [
        24006,
        53430
      ],
      [
        0,
        -9
      ],
      [
        5,
        0
      ],
      [
        0,
        -8
      ],
      [
        10,
        0
      ],
      [
        0,
        -9
      ],
      [
        9,
        0
      ],
      [
        5,
        -8
      ],
      [
        0,
        -34
      ],
      [
        4,
        0
      ],
      [
        0,
        -17
      ],
      [
        5,
        0
      ],
      [
        0,
        -24
      ],
      [
        5,
        -1
      ],
      [
        0,
        -281
      ],
      [
        1,
        -141
      ]
    ],
    [
      [
        24050,
        52898
      ],
      [
        0,
        -17
      ],
      [
        -43,
        3
      ]
    ],
    [
      [
        24007,
        52884
      ],
      [
        -43,
        0
      ],
      [
        -6,
        6
      ],
      [
        -65,
        0
      ],
      [
        -13,
        -2
      ],
      [
        -7,
        -17
      ],
      [
        -5,
        -9
      ],
      [
        -6,
        7
      ],
      [
        -6,
        17
      ],
      [
        -9,
        -3
      ],
      [
        -1,
        -10
      ]
    ],
    [
      [
        23846,
        52873
      ],
      [
        0,
        1
      ],
      [
        -2,
        6
      ],
      [
        -1,
        5
      ],
      [
        0,
        11
      ],
      [
        1,
        8
      ],
      [
        2,
        7
      ],
      [
        0,
        12
      ],
      [
        1,
        8
      ],
      [
        1,
        3
      ],
      [
        1,
        1
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        3,
        5
      ],
      [
        2,
        7
      ],
      [
        0,
        11
      ],
      [
        -2,
        13
      ],
      [
        -5,
        19
      ],
      [
        -3,
        5
      ],
      [
        -2,
        7
      ],
      [
        -1,
        12
      ],
      [
        0,
        10
      ],
      [
        1,
        6
      ],
      [
        0,
        3
      ],
      [
        1,
        2
      ],
      [
        2,
        -2
      ],
      [
        5,
        5
      ],
      [
        6,
        18
      ],
      [
        0,
        10
      ],
      [
        -2,
        6
      ],
      [
        -2,
        16
      ],
      [
        0,
        4
      ],
      [
        1,
        3
      ],
      [
        1,
        4
      ],
      [
        0,
        11
      ],
      [
        -2,
        5
      ],
      [
        -2,
        4
      ],
      [
        -2,
        6
      ],
      [
        -1,
        9
      ],
      [
        -1,
        7
      ],
      [
        1,
        9
      ],
      [
        2,
        10
      ],
      [
        1,
        10
      ],
      [
        0,
        8
      ],
      [
        -2,
        8
      ],
      [
        0,
        15
      ],
      [
        1,
        5
      ],
      [
        1,
        4
      ],
      [
        1,
        3
      ],
      [
        1,
        26
      ],
      [
        0,
        4
      ],
      [
        -1,
        1
      ],
      [
        -4,
        1
      ],
      [
        -1,
        -1
      ]
    ],
    [
      [
        26465,
        66735
      ],
      [
        65,
        5
      ]
    ],
    [
      [
        26530,
        66740
      ],
      [
        49,
        1
      ],
      [
        17,
        2
      ]
    ],
    [
      [
        26596,
        66743
      ],
      [
        1,
        -103
      ],
      [
        2,
        -104
      ],
      [
        1,
        -100
      ],
      [
        2,
        -103
      ]
    ],
    [
      [
        24155,
        67966
      ],
      [
        0,
        -389
      ]
    ],
    [
      [
        23994,
        67576
      ],
      [
        -7,
        0
      ]
    ],
    [
      [
        24952,
        53531
      ],
      [
        38,
        0
      ]
    ],
    [
      [
        24990,
        53531
      ],
      [
        0,
        -102
      ],
      [
        27,
        0
      ],
      [
        2,
        1
      ],
      [
        0,
        -102
      ],
      [
        -1,
        -108
      ],
      [
        0,
        -182
      ]
    ],
    [
      [
        25018,
        53038
      ],
      [
        -21,
        0
      ],
      [
        0,
        -32
      ],
      [
        -14,
        0
      ],
      [
        0,
        22
      ],
      [
        -7,
        0
      ],
      [
        0,
        14
      ],
      [
        -14,
        0
      ],
      [
        0,
        -14
      ],
      [
        -16,
        1
      ],
      [
        -13,
        0
      ]
    ],
    [
      [
        24933,
        53029
      ],
      [
        0,
        502
      ]
    ],
    [
      [
        24637,
        55669
      ],
      [
        45,
        0
      ],
      [
        0,
        68
      ],
      [
        29,
        1
      ]
    ],
    [
      [
        24711,
        55738
      ],
      [
        0,
        -73
      ],
      [
        11,
        -37
      ],
      [
        1,
        12
      ],
      [
        12,
        -7
      ],
      [
        -3,
        47
      ],
      [
        3,
        -5
      ],
      [
        6,
        39
      ],
      [
        4,
        -7
      ]
    ],
    [
      [
        24745,
        55707
      ],
      [
        0,
        -195
      ],
      [
        -5,
        -4
      ],
      [
        -2,
        -22
      ],
      [
        2,
        -14
      ],
      [
        -3,
        -8
      ],
      [
        -3,
        36
      ],
      [
        -5,
        -15
      ],
      [
        6,
        -20
      ],
      [
        -2,
        -13
      ],
      [
        -3,
        4
      ],
      [
        -3,
        17
      ],
      [
        -6,
        2
      ],
      [
        -1,
        13
      ],
      [
        -3,
        -22
      ],
      [
        0,
        -41
      ],
      [
        4,
        -14
      ],
      [
        7,
        1
      ],
      [
        3,
        -9
      ],
      [
        -1,
        -19
      ],
      [
        6,
        -17
      ]
    ],
    [
      [
        24736,
        55367
      ],
      [
        -2,
        -1
      ],
      [
        -22,
        -1
      ],
      [
        0,
        -100
      ],
      [
        -58,
        -1
      ]
    ],
    [
      [
        24654,
        55264
      ],
      [
        0,
        203
      ],
      [
        -13,
        -1
      ]
    ],
    [
      [
        24641,
        55466
      ],
      [
        7,
        7
      ],
      [
        0,
        15
      ],
      [
        -6,
        8
      ],
      [
        0,
        19
      ],
      [
        3,
        12
      ],
      [
        1,
        48
      ],
      [
        1,
        14
      ],
      [
        -6,
        13
      ],
      [
        -8,
        23
      ],
      [
        1,
        41
      ],
      [
        3,
        3
      ]
    ],
    [
      [
        22654,
        66340
      ],
      [
        98,
        1
      ]
    ],
    [
      [
        22752,
        66341
      ],
      [
        32,
        1
      ],
      [
        0,
        -102
      ]
    ],
    [
      [
        22784,
        65937
      ],
      [
        -130,
        -2
      ]
    ],
    [
      [
        26611,
        60971
      ],
      [
        3,
        11
      ],
      [
        9,
        -19
      ],
      [
        11,
        4
      ],
      [
        7,
        11
      ],
      [
        2,
        24
      ],
      [
        6,
        12
      ]
    ],
    [
      [
        26649,
        61014
      ],
      [
        5,
        -12
      ],
      [
        -2,
        -9
      ],
      [
        8,
        -2
      ],
      [
        7,
        -27
      ],
      [
        13,
        -6
      ],
      [
        -1,
        -16
      ],
      [
        6,
        -1
      ],
      [
        9,
        -24
      ],
      [
        1,
        5
      ],
      [
        -1,
        -23
      ],
      [
        2,
        -12
      ],
      [
        9,
        -10
      ],
      [
        4,
        -15
      ],
      [
        0,
        -15
      ],
      [
        5,
        -7
      ]
    ],
    [
      [
        26718,
        60790
      ],
      [
        -5,
        12
      ],
      [
        -4,
        -6
      ],
      [
        -4,
        9
      ],
      [
        -6,
        0
      ],
      [
        -4,
        -9
      ],
      [
        -9,
        11
      ],
      [
        -8,
        18
      ],
      [
        -7,
        -11
      ],
      [
        -4,
        -19
      ],
      [
        -1,
        -20
      ],
      [
        -7,
        -31
      ],
      [
        -10,
        -12
      ],
      [
        0,
        30
      ],
      [
        -7,
        -8
      ]
    ],
    [
      [
        25450,
        60452
      ],
      [
        -8,
        -31
      ],
      [
        4,
        -2
      ]
    ],
    [
      [
        25483,
        60184
      ],
      [
        -3,
        -57
      ],
      [
        -5,
        -91
      ],
      [
        -6,
        -23
      ]
    ],
    [
      [
        25428,
        59964
      ],
      [
        -27,
        125
      ],
      [
        -19,
        125
      ],
      [
        -14,
        6
      ]
    ],
    [
      [
        21494,
        69367
      ],
      [
        0,
        -613
      ]
    ],
    [
      [
        21494,
        68754
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        26222,
        60745
      ],
      [
        1,
        39
      ],
      [
        0,
        17
      ]
    ],
    [
      [
        26223,
        60801
      ],
      [
        7,
        1
      ],
      [
        54,
        29
      ],
      [
        4,
        14
      ],
      [
        13,
        -4
      ]
    ],
    [
      [
        26301,
        60841
      ],
      [
        3,
        -3
      ],
      [
        -3,
        -15
      ],
      [
        6,
        -6
      ],
      [
        5,
        6
      ],
      [
        2,
        -19
      ],
      [
        4,
        7
      ],
      [
        1,
        -16
      ],
      [
        -5,
        -6
      ],
      [
        6,
        -19
      ],
      [
        -5,
        -13
      ],
      [
        4,
        -5
      ],
      [
        0,
        10
      ],
      [
        6,
        11
      ],
      [
        2,
        -5
      ],
      [
        -2,
        -19
      ]
    ],
    [
      [
        26325,
        60749
      ],
      [
        2,
        -10
      ],
      [
        -2,
        -9
      ],
      [
        -7,
        3
      ],
      [
        -1,
        -10
      ],
      [
        -12,
        -27
      ],
      [
        -4,
        -4
      ],
      [
        -1,
        1
      ]
    ],
    [
      [
        26300,
        60693
      ],
      [
        1,
        9
      ],
      [
        0,
        4
      ],
      [
        -3,
        -2
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -5
      ],
      [
        1,
        1
      ],
      [
        1,
        -3
      ]
    ],
    [
      [
        26300,
        60693
      ],
      [
        -10,
        -11
      ],
      [
        -17,
        -33
      ]
    ],
    [
      [
        26219,
        60645
      ],
      [
        3,
        100
      ]
    ],
    [
      [
        26925,
        58820
      ],
      [
        2,
        6
      ],
      [
        3,
        11
      ],
      [
        1,
        1
      ],
      [
        0,
        6
      ],
      [
        3,
        3
      ],
      [
        2,
        7
      ],
      [
        2,
        1
      ],
      [
        12,
        76
      ]
    ],
    [
      [
        27029,
        58641
      ],
      [
        -10,
        -40
      ],
      [
        3,
        -11
      ],
      [
        -10,
        -52
      ],
      [
        -14,
        -26
      ],
      [
        -4,
        -16
      ],
      [
        -5,
        6
      ]
    ],
    [
      [
        26989,
        58502
      ],
      [
        -2,
        25
      ],
      [
        -8,
        9
      ],
      [
        -6,
        19
      ],
      [
        -4,
        42
      ],
      [
        3,
        12
      ],
      [
        -7,
        29
      ],
      [
        -13,
        -3
      ]
    ],
    [
      [
        26952,
        58635
      ],
      [
        -3,
        29
      ],
      [
        1,
        19
      ],
      [
        -7,
        23
      ],
      [
        -4,
        24
      ],
      [
        -5,
        11
      ],
      [
        -6,
        0
      ],
      [
        1,
        14
      ],
      [
        -2,
        10
      ],
      [
        5,
        21
      ],
      [
        -4,
        10
      ],
      [
        -3,
        24
      ]
    ],
    [
      [
        25696,
        54963
      ],
      [
        -1,
        -9
      ],
      [
        3,
        -32
      ],
      [
        -1,
        -19
      ],
      [
        2,
        -13
      ],
      [
        2,
        -39
      ],
      [
        -2,
        -36
      ],
      [
        4,
        -39
      ],
      [
        9,
        -61
      ],
      [
        -2,
        -14
      ],
      [
        5,
        -1
      ],
      [
        7,
        -15
      ],
      [
        -6,
        -11
      ],
      [
        0,
        -18
      ],
      [
        5,
        -25
      ],
      [
        3,
        -9
      ],
      [
        2,
        -19
      ],
      [
        -2,
        -16
      ]
    ],
    [
      [
        25699,
        54246
      ],
      [
        -76,
        -1
      ],
      [
        1,
        20
      ],
      [
        -5,
        7
      ],
      [
        1,
        18
      ],
      [
        -12,
        18
      ],
      [
        -4,
        24
      ],
      [
        -4,
        2
      ],
      [
        3,
        14
      ],
      [
        -3,
        13
      ],
      [
        -5,
        -3
      ],
      [
        -4,
        28
      ],
      [
        -7,
        15
      ],
      [
        -2,
        21
      ],
      [
        -11,
        -2
      ],
      [
        -3,
        28
      ],
      [
        -3,
        2
      ],
      [
        -1,
        19
      ],
      [
        -5,
        -3
      ],
      [
        -4,
        8
      ],
      [
        -6,
        29
      ],
      [
        -8,
        -4
      ]
    ],
    [
      [
        25541,
        54499
      ],
      [
        0,
        49
      ]
    ],
    [
      [
        26370,
        55568
      ],
      [
        5,
        6
      ],
      [
        1,
        14
      ],
      [
        6,
        2
      ],
      [
        1,
        7
      ],
      [
        16,
        0
      ],
      [
        0,
        -10
      ],
      [
        6,
        0
      ],
      [
        0,
        -12
      ],
      [
        29,
        -1
      ],
      [
        6,
        0
      ]
    ],
    [
      [
        26433,
        55344
      ],
      [
        -61,
        3
      ],
      [
        -4,
        -25
      ],
      [
        -6,
        -2
      ]
    ],
    [
      [
        25756,
        53636
      ],
      [
        0,
        -102
      ],
      [
        7,
        0
      ],
      [
        4,
        -39
      ],
      [
        -4,
        -16
      ],
      [
        3,
        -23
      ],
      [
        -8,
        -25
      ],
      [
        -2,
        -3
      ],
      [
        0,
        -178
      ]
    ],
    [
      [
        25756,
        53250
      ],
      [
        -10,
        -6
      ],
      [
        -5,
        7
      ],
      [
        -3,
        -13
      ],
      [
        -2,
        23
      ],
      [
        3,
        22
      ],
      [
        -3,
        35
      ],
      [
        2,
        12
      ],
      [
        -29,
        1
      ],
      [
        -46,
        -1
      ],
      [
        -109,
        -1
      ]
    ],
    [
      [
        25554,
        53329
      ],
      [
        2,
        19
      ],
      [
        7,
        28
      ],
      [
        10,
        20
      ],
      [
        4,
        40
      ],
      [
        2,
        0
      ],
      [
        3,
        16
      ],
      [
        8,
        41
      ],
      [
        19,
        62
      ],
      [
        6,
        5
      ],
      [
        3,
        24
      ],
      [
        2,
        10
      ],
      [
        3,
        19
      ],
      [
        3,
        18
      ],
      [
        3,
        54
      ],
      [
        3,
        25
      ],
      [
        3,
        63
      ],
      [
        11,
        12
      ],
      [
        5,
        17
      ],
      [
        6,
        13
      ],
      [
        -1,
        32
      ],
      [
        3,
        15
      ],
      [
        7,
        -6
      ],
      [
        10,
        6
      ],
      [
        2,
        9
      ],
      [
        9,
        11
      ],
      [
        4,
        13
      ],
      [
        8,
        8
      ]
    ],
    [
      [
        24125,
        57814
      ],
      [
        2,
        -4
      ],
      [
        1,
        -14
      ],
      [
        1,
        -11
      ],
      [
        0,
        -13
      ],
      [
        -1,
        -25
      ],
      [
        -4,
        -23
      ],
      [
        -3,
        -9
      ],
      [
        -4,
        -9
      ],
      [
        -4,
        -29
      ],
      [
        7,
        -38
      ],
      [
        8,
        -11
      ]
    ],
    [
      [
        23980,
        57417
      ],
      [
        -24,
        0
      ],
      [
        -35,
        1
      ]
    ],
    [
      [
        23921,
        57418
      ],
      [
        0,
        102
      ],
      [
        -5,
        1
      ],
      [
        0,
        16
      ],
      [
        5,
        0
      ],
      [
        0,
        16
      ],
      [
        5,
        0
      ],
      [
        0,
        17
      ],
      [
        4,
        0
      ],
      [
        1,
        3
      ],
      [
        0,
        14
      ],
      [
        5,
        0
      ],
      [
        0,
        17
      ],
      [
        5,
        0
      ],
      [
        0,
        18
      ],
      [
        4,
        -1
      ],
      [
        0,
        17
      ],
      [
        6,
        0
      ],
      [
        0,
        17
      ],
      [
        6,
        -1
      ],
      [
        0,
        17
      ],
      [
        5,
        0
      ],
      [
        0,
        17
      ],
      [
        5,
        -1
      ],
      [
        0,
        17
      ],
      [
        5,
        -1
      ],
      [
        0,
        19
      ],
      [
        5,
        0
      ],
      [
        0,
        17
      ],
      [
        5,
        -1
      ],
      [
        0,
        17
      ],
      [
        5,
        0
      ],
      [
        0,
        17
      ],
      [
        3,
        0
      ]
    ],
    [
      [
        26412,
        57173
      ],
      [
        0,
        -16
      ],
      [
        8,
        -94
      ],
      [
        17,
        -3
      ],
      [
        0,
        -98
      ]
    ],
    [
      [
        26327,
        56999
      ],
      [
        0,
        50
      ],
      [
        2,
        0
      ],
      [
        -2,
        8
      ],
      [
        -1,
        100
      ]
    ],
    [
      [
        26711,
        55572
      ],
      [
        6,
        59
      ],
      [
        -1,
        7
      ],
      [
        1,
        18
      ],
      [
        7,
        -3
      ],
      [
        -1,
        23
      ],
      [
        15,
        18
      ],
      [
        9,
        21
      ],
      [
        0,
        35
      ],
      [
        -5,
        17
      ]
    ],
    [
      [
        26784,
        55900
      ],
      [
        8,
        -25
      ],
      [
        9,
        5
      ],
      [
        3,
        -10
      ],
      [
        11,
        -5
      ],
      [
        8,
        9
      ],
      [
        6,
        -4
      ]
    ],
    [
      [
        26829,
        55870
      ],
      [
        3,
        -14
      ],
      [
        4,
        -4
      ],
      [
        0,
        -43
      ],
      [
        1,
        -19
      ],
      [
        5,
        -11
      ],
      [
        3,
        -65
      ],
      [
        3,
        -5
      ],
      [
        -1,
        -42
      ],
      [
        8,
        -18
      ]
    ],
    [
      [
        26857,
        55632
      ],
      [
        -8,
        0
      ],
      [
        -6,
        -20
      ],
      [
        -7,
        -13
      ],
      [
        -2,
        -10
      ],
      [
        -6,
        -6
      ],
      [
        -4,
        -21
      ],
      [
        -6,
        -46
      ],
      [
        -3,
        -12
      ],
      [
        -4,
        -2
      ],
      [
        -3,
        -12
      ],
      [
        -7,
        -11
      ],
      [
        -5,
        2
      ],
      [
        -6,
        -21
      ],
      [
        -5,
        -12
      ],
      [
        -12,
        0
      ]
    ],
    [
      [
        26773,
        55448
      ],
      [
        -6,
        -19
      ],
      [
        -3,
        0
      ],
      [
        -5,
        -16
      ],
      [
        -2,
        24
      ],
      [
        -3,
        14
      ],
      [
        2,
        14
      ],
      [
        1,
        40
      ],
      [
        3,
        4
      ],
      [
        0,
        21
      ],
      [
        -27,
        29
      ],
      [
        -19,
        15
      ],
      [
        -3,
        -2
      ]
    ],
    [
      [
        26328,
        54461
      ],
      [
        8,
        0
      ],
      [
        5,
        -26
      ],
      [
        0,
        -23
      ],
      [
        10,
        -1
      ],
      [
        0,
        -17
      ],
      [
        6,
        0
      ],
      [
        -1,
        -19
      ],
      [
        6,
        -9
      ],
      [
        0,
        -19
      ],
      [
        27,
        -1
      ]
    ],
    [
      [
        26385,
        54152
      ],
      [
        0,
        -48
      ],
      [
        -3,
        -8
      ],
      [
        -40,
        1
      ]
    ],
    [
      [
        26342,
        54097
      ],
      [
        -16,
        0
      ]
    ],
    [
      [
        26326,
        54097
      ],
      [
        0,
        48
      ],
      [
        3,
        0
      ],
      [
        0,
        27
      ],
      [
        -3,
        0
      ],
      [
        0,
        51
      ],
      [
        3,
        1
      ],
      [
        1,
        153
      ],
      [
        3,
        27
      ],
      [
        -3,
        48
      ],
      [
        -2,
        0
      ],
      [
        0,
        9
      ]
    ],
    [
      [
        25990,
        63757
      ],
      [
        0,
        186
      ]
    ],
    [
      [
        26069,
        63944
      ],
      [
        0,
        -85
      ],
      [
        1,
        -182
      ],
      [
        0,
        -85
      ]
    ],
    [
      [
        26070,
        63439
      ],
      [
        -64,
        -1
      ],
      [
        -16,
        -1
      ]
    ],
    [
      [
        25990,
        63437
      ],
      [
        0,
        320
      ]
    ],
    [
      [
        25694,
        61763
      ],
      [
        0,
        363
      ],
      [
        6,
        0
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        21869,
        60868
      ],
      [
        -122,
        0
      ]
    ],
    [
      [
        21747,
        60868
      ],
      [
        0,
        108
      ],
      [
        -4,
        -1
      ],
      [
        1,
        507
      ]
    ],
    [
      [
        23285,
        62826
      ],
      [
        52,
        2
      ],
      [
        57,
        -1
      ]
    ],
    [
      [
        23394,
        62827
      ],
      [
        0,
        -338
      ],
      [
        -2,
        0
      ],
      [
        0,
        -99
      ]
    ],
    [
      [
        23392,
        62390
      ],
      [
        -23,
        0
      ],
      [
        -4,
        3
      ],
      [
        0,
        -17
      ],
      [
        -4,
        12
      ],
      [
        -12,
        -13
      ],
      [
        -16,
        31
      ],
      [
        -11,
        14
      ],
      [
        -12,
        -15
      ],
      [
        -5,
        0
      ]
    ],
    [
      [
        23305,
        62405
      ],
      [
        -4,
        12
      ],
      [
        -10,
        1
      ],
      [
        -9,
        -17
      ],
      [
        -4,
        13
      ],
      [
        0,
        75
      ],
      [
        2,
        17
      ],
      [
        0,
        84
      ]
    ],
    [
      [
        25789,
        64563
      ],
      [
        0,
        -204
      ]
    ],
    [
      [
        25789,
        64359
      ],
      [
        -21,
        1
      ],
      [
        -23,
        1
      ],
      [
        -3,
        -2
      ],
      [
        -3,
        -44
      ],
      [
        4,
        -11
      ],
      [
        -4,
        -10
      ],
      [
        6,
        2
      ],
      [
        -5,
        -20
      ],
      [
        -4,
        0
      ],
      [
        1,
        -119
      ]
    ],
    [
      [
        25645,
        64360
      ],
      [
        0,
        118
      ],
      [
        32,
        0
      ],
      [
        -1,
        68
      ],
      [
        0,
        18
      ],
      [
        16,
        1
      ]
    ],
    [
      [
        26308,
        60288
      ],
      [
        41,
        122
      ],
      [
        5,
        15
      ],
      [
        15,
        -32
      ]
    ],
    [
      [
        26409,
        59963
      ],
      [
        -2,
        4
      ],
      [
        -5,
        -11
      ],
      [
        -9,
        -7
      ],
      [
        -45,
        -93
      ]
    ],
    [
      [
        26276,
        60008
      ],
      [
        -8,
        12
      ],
      [
        -12,
        45
      ],
      [
        0,
        47
      ],
      [
        2,
        34
      ]
    ],
    [
      [
        24582,
        63322
      ],
      [
        0,
        302
      ]
    ],
    [
      [
        24193,
        54360
      ],
      [
        0,
        153
      ]
    ],
    [
      [
        24193,
        54513
      ],
      [
        41,
        -1
      ],
      [
        3,
        -21
      ],
      [
        13,
        0
      ],
      [
        0,
        21
      ],
      [
        20,
        1
      ]
    ],
    [
      [
        24270,
        54513
      ],
      [
        12,
        -1
      ],
      [
        -1,
        -35
      ],
      [
        -3,
        -20
      ],
      [
        4,
        -3
      ],
      [
        -2,
        -18
      ],
      [
        4,
        14
      ],
      [
        2,
        -8
      ],
      [
        -8,
        -17
      ],
      [
        2,
        -13
      ],
      [
        7,
        16
      ],
      [
        -2,
        -13
      ],
      [
        2,
        -19
      ],
      [
        -2,
        -12
      ],
      [
        7,
        8
      ],
      [
        7,
        -10
      ],
      [
        6,
        5
      ],
      [
        4,
        -6
      ],
      [
        -1,
        -13
      ],
      [
        1,
        -1
      ]
    ],
    [
      [
        24309,
        54367
      ],
      [
        0,
        -16
      ],
      [
        3,
        -7
      ],
      [
        4,
        -20
      ],
      [
        -1,
        -13
      ],
      [
        2,
        -14
      ],
      [
        -9,
        -7
      ],
      [
        -1,
        -12
      ],
      [
        -2,
        11
      ],
      [
        -7,
        -21
      ],
      [
        4,
        -1
      ],
      [
        3,
        -23
      ],
      [
        3,
        -7
      ],
      [
        -1,
        -17
      ],
      [
        2,
        -18
      ],
      [
        -2,
        -17
      ],
      [
        4,
        -28
      ]
    ],
    [
      [
        24311,
        54157
      ],
      [
        -5,
        0
      ],
      [
        0,
        -51
      ],
      [
        -28,
        -1
      ]
    ],
    [
      [
        24278,
        54105
      ],
      [
        -85,
        1
      ]
    ],
    [
      [
        24193,
        54106
      ],
      [
        0,
        254
      ]
    ],
    [
      [
        23859,
        61822
      ],
      [
        -154,
        13
      ]
    ],
    [
      [
        23705,
        61835
      ],
      [
        -16,
        2
      ],
      [
        1,
        50
      ],
      [
        0,
        51
      ],
      [
        -3,
        0
      ],
      [
        2,
        206
      ]
    ],
    [
      [
        24796,
        60706
      ],
      [
        80,
        2
      ]
    ],
    [
      [
        24876,
        60708
      ],
      [
        -1,
        -443
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -105
      ]
    ],
    [
      [
        24874,
        60157
      ],
      [
        -26,
        2
      ],
      [
        0,
        -85
      ],
      [
        -10,
        0
      ],
      [
        0,
        -17
      ],
      [
        -32,
        1
      ]
    ],
    [
      [
        24806,
        60058
      ],
      [
        0,
        52
      ],
      [
        -31,
        1
      ],
      [
        1,
        266
      ]
    ],
    [
      [
        24553,
        60122
      ],
      [
        5,
        5
      ],
      [
        11,
        -3
      ],
      [
        -1,
        -51
      ],
      [
        52,
        -4
      ]
    ],
    [
      [
        24620,
        60069
      ],
      [
        14,
        -1
      ],
      [
        -1,
        -57
      ],
      [
        5,
        0
      ],
      [
        0,
        -34
      ],
      [
        5,
        -1
      ],
      [
        0,
        -50
      ],
      [
        5,
        -1
      ]
    ],
    [
      [
        24648,
        59925
      ],
      [
        0,
        -51
      ],
      [
        5,
        0
      ],
      [
        -1,
        -83
      ]
    ],
    [
      [
        24652,
        59791
      ],
      [
        -65,
        2
      ],
      [
        -14,
        6
      ],
      [
        -22,
        4
      ],
      [
        -25,
        2
      ]
    ],
    [
      [
        24526,
        59805
      ],
      [
        -30,
        3
      ],
      [
        0,
        67
      ]
    ],
    [
      [
        23036,
        64685
      ],
      [
        0,
        -270
      ]
    ],
    [
      [
        23036,
        64111
      ],
      [
        -68,
        1
      ],
      [
        -57,
        0
      ]
    ],
    [
      [
        29093,
        64340
      ],
      [
        19,
        18
      ],
      [
        7,
        7
      ],
      [
        21,
        20
      ],
      [
        1,
        -12
      ],
      [
        1,
        -8
      ],
      [
        5,
        -13
      ],
      [
        5,
        -37
      ],
      [
        -5,
        -39
      ],
      [
        2,
        -18
      ],
      [
        17,
        29
      ]
    ],
    [
      [
        29166,
        64287
      ],
      [
        3,
        -23
      ],
      [
        6,
        13
      ],
      [
        7,
        2
      ],
      [
        0,
        -14
      ],
      [
        -3,
        -16
      ],
      [
        -3,
        -25
      ],
      [
        -10,
        -24
      ]
    ],
    [
      [
        29166,
        64200
      ],
      [
        -7,
        -13
      ],
      [
        -7,
        -7
      ],
      [
        -3,
        -14
      ],
      [
        -1,
        -12
      ],
      [
        2,
        -5
      ],
      [
        1,
        -12
      ],
      [
        16,
        -57
      ],
      [
        -9,
        -25
      ],
      [
        -1,
        -6
      ],
      [
        -10,
        -33
      ],
      [
        -15,
        -27
      ],
      [
        -1,
        -27
      ],
      [
        -9,
        -24
      ]
    ],
    [
      [
        29122,
        63938
      ],
      [
        -1,
        12
      ],
      [
        -8,
        8
      ],
      [
        -19,
        -19
      ],
      [
        -8,
        57
      ]
    ],
    [
      [
        28051,
        66841
      ],
      [
        109,
        3
      ],
      [
        22,
        -6
      ],
      [
        11,
        -3
      ]
    ],
    [
      [
        28094,
        66437
      ],
      [
        -43,
        -2
      ],
      [
        0,
        20
      ]
    ],
    [
      [
        28051,
        66455
      ],
      [
        0,
        284
      ],
      [
        -7,
        0
      ],
      [
        1,
        102
      ],
      [
        6,
        0
      ]
    ],
    [
      [
        28429,
        66394
      ],
      [
        33,
        1
      ],
      [
        0,
        -25
      ],
      [
        7,
        -5
      ],
      [
        21,
        5
      ],
      [
        -3,
        36
      ],
      [
        1,
        55
      ]
    ],
    [
      [
        28565,
        66160
      ],
      [
        0,
        -40
      ],
      [
        -6,
        -17
      ],
      [
        -2,
        5
      ],
      [
        -11,
        -1
      ],
      [
        0,
        13
      ],
      [
        -13,
        0
      ],
      [
        0,
        53
      ],
      [
        -30,
        0
      ],
      [
        -34,
        -8
      ],
      [
        0,
        -10
      ]
    ],
    [
      [
        28469,
        66155
      ],
      [
        -31,
        -4
      ],
      [
        -7,
        -3
      ],
      [
        -2,
        246
      ]
    ],
    [
      [
        26508,
        64065
      ],
      [
        2,
        0
      ],
      [
        0,
        61
      ],
      [
        24,
        0
      ],
      [
        8,
        4
      ]
    ],
    [
      [
        26542,
        64130
      ],
      [
        0,
        -8
      ],
      [
        7,
        -2
      ],
      [
        93,
        -25
      ],
      [
        0,
        -6
      ]
    ],
    [
      [
        26642,
        64089
      ],
      [
        -3,
        -124
      ],
      [
        -5,
        -195
      ]
    ],
    [
      [
        26634,
        63770
      ],
      [
        -66,
        18
      ],
      [
        1,
        17
      ],
      [
        -64,
        16
      ]
    ],
    [
      [
        26642,
        64089
      ],
      [
        29,
        2
      ]
    ],
    [
      [
        26740,
        63669
      ],
      [
        0,
        -42
      ],
      [
        -10,
        1
      ]
    ],
    [
      [
        26730,
        63628
      ],
      [
        -83,
        4
      ]
    ],
    [
      [
        26647,
        63632
      ],
      [
        2,
        133
      ],
      [
        -15,
        5
      ]
    ],
    [
      [
        27956,
        64557
      ],
      [
        0,
        -205
      ],
      [
        1,
        -6
      ]
    ],
    [
      [
        27909,
        63964
      ],
      [
        -4,
        18
      ],
      [
        -8,
        10
      ],
      [
        -5,
        -4
      ],
      [
        2,
        -13
      ],
      [
        -9,
        -29
      ],
      [
        -6,
        10
      ],
      [
        -4,
        -22
      ],
      [
        -7,
        0
      ],
      [
        -2,
        19
      ],
      [
        3,
        9
      ],
      [
        -9,
        3
      ],
      [
        -2,
        17
      ],
      [
        -10,
        4
      ],
      [
        -15,
        20
      ],
      [
        -7,
        -16
      ],
      [
        0,
        24
      ],
      [
        -8,
        -5
      ],
      [
        0,
        20
      ],
      [
        -1,
        11
      ],
      [
        -6,
        -10
      ],
      [
        -4,
        20
      ],
      [
        -2,
        -18
      ],
      [
        -4,
        6
      ],
      [
        -1,
        21
      ],
      [
        -2,
        -28
      ],
      [
        -6,
        4
      ],
      [
        -4,
        20
      ],
      [
        -4,
        -1
      ],
      [
        -2,
        18
      ],
      [
        -3,
        -5
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        4
      ],
      [
        0,
        2
      ],
      [
        1,
        4
      ],
      [
        -2,
        34
      ],
      [
        2,
        14
      ]
    ],
    [
      [
        26047,
        60502
      ],
      [
        2,
        -30
      ],
      [
        -10,
        -41
      ],
      [
        -3,
        -69
      ],
      [
        4,
        -16
      ],
      [
        1,
        -20
      ],
      [
        2,
        -4
      ],
      [
        -2,
        -21
      ],
      [
        -2,
        -78
      ]
    ],
    [
      [
        26023,
        60208
      ],
      [
        -16,
        -8
      ],
      [
        -16,
        -14
      ],
      [
        -13,
        -3
      ],
      [
        -24,
        10
      ],
      [
        -18,
        12
      ]
    ],
    [
      [
        25908,
        60401
      ],
      [
        0,
        11
      ],
      [
        8,
        -7
      ],
      [
        2,
        9
      ],
      [
        4,
        -9
      ],
      [
        7,
        15
      ],
      [
        3,
        -13
      ],
      [
        1,
        27
      ],
      [
        -2,
        20
      ],
      [
        6,
        7
      ],
      [
        9,
        9
      ],
      [
        -7,
        16
      ],
      [
        3,
        11
      ],
      [
        -4,
        37
      ]
    ],
    [
      [
        25662,
        60663
      ],
      [
        9,
        23
      ],
      [
        16,
        58
      ],
      [
        2,
        -2
      ],
      [
        4,
        -6
      ],
      [
        6,
        8
      ],
      [
        4,
        15
      ],
      [
        10,
        14
      ],
      [
        4,
        12
      ],
      [
        7,
        10
      ],
      [
        -14,
        41
      ],
      [
        12,
        33
      ]
    ],
    [
      [
        25786,
        60667
      ],
      [
        5,
        -12
      ],
      [
        -1,
        -8
      ],
      [
        -9,
        -2
      ],
      [
        -4,
        24
      ],
      [
        -3,
        1
      ],
      [
        -3,
        -13
      ],
      [
        -5,
        1
      ],
      [
        0,
        -12
      ],
      [
        15,
        -176
      ]
    ],
    [
      [
        25781,
        60470
      ],
      [
        -41,
        -106
      ],
      [
        -3,
        6
      ],
      [
        -2,
        20
      ],
      [
        -7,
        10
      ],
      [
        -4,
        -7
      ],
      [
        -1,
        -27
      ],
      [
        3,
        -16
      ],
      [
        -5,
        3
      ],
      [
        0,
        -14
      ],
      [
        -5,
        -16
      ],
      [
        -2,
        -21
      ],
      [
        -3,
        2
      ],
      [
        -6,
        -20
      ],
      [
        0,
        -14
      ],
      [
        -4,
        -12
      ]
    ],
    [
      [
        25701,
        60258
      ],
      [
        -6,
        15
      ],
      [
        3,
        8
      ],
      [
        -4,
        11
      ],
      [
        -6,
        -2
      ],
      [
        -3,
        20
      ],
      [
        -4,
        1
      ],
      [
        -3,
        13
      ],
      [
        0,
        20
      ],
      [
        -2,
        18
      ],
      [
        1,
        17
      ],
      [
        -9,
        43
      ],
      [
        -4,
        11
      ],
      [
        -6,
        8
      ],
      [
        -5,
        0
      ],
      [
        -5,
        -12
      ],
      [
        -4,
        -37
      ],
      [
        -5,
        -2
      ],
      [
        -4,
        11
      ],
      [
        3,
        29
      ],
      [
        8,
        18
      ],
      [
        -1,
        47
      ]
    ],
    [
      [
        21931,
        70015
      ],
      [
        199,
        -1
      ]
    ],
    [
      [
        22130,
        70014
      ],
      [
        2,
        0
      ]
    ],
    [
      [
        21956,
        69873
      ],
      [
        -7,
        32
      ],
      [
        -7,
        14
      ],
      [
        -15,
        -3
      ],
      [
        -10,
        18
      ],
      [
        -2,
        13
      ],
      [
        4,
        28
      ],
      [
        9,
        22
      ],
      [
        3,
        18
      ]
    ],
    [
      [
        26657,
        59050
      ],
      [
        2,
        -23
      ],
      [
        10,
        -1
      ],
      [
        14,
        -1
      ],
      [
        22,
        -18
      ],
      [
        6,
        -8
      ],
      [
        9,
        -35
      ],
      [
        2,
        -19
      ]
    ],
    [
      [
        26600,
        58891
      ],
      [
        0,
        17
      ],
      [
        -6,
        6
      ],
      [
        -4,
        41
      ],
      [
        5,
        2
      ],
      [
        6,
        -17
      ]
    ],
    [
      [
        26353,
        61748
      ],
      [
        10,
        18
      ],
      [
        10,
        0
      ],
      [
        3,
        40
      ]
    ],
    [
      [
        26376,
        61806
      ],
      [
        8,
        -15
      ],
      [
        0,
        8
      ],
      [
        8,
        8
      ],
      [
        -3,
        4
      ],
      [
        5,
        21
      ],
      [
        3,
        -5
      ],
      [
        54,
        25
      ]
    ],
    [
      [
        26451,
        61852
      ],
      [
        1,
        -21
      ],
      [
        -3,
        -10
      ],
      [
        15,
        -1
      ]
    ],
    [
      [
        26464,
        61820
      ],
      [
        -5,
        -25
      ],
      [
        -2,
        -41
      ],
      [
        9,
        -9
      ],
      [
        1,
        -13
      ],
      [
        5,
        5
      ],
      [
        8,
        -28
      ]
    ],
    [
      [
        26455,
        61607
      ],
      [
        -24,
        -66
      ],
      [
        -4,
        -7
      ],
      [
        -4,
        5
      ],
      [
        1,
        -10
      ],
      [
        -8,
        -18
      ],
      [
        -8,
        8
      ],
      [
        -5,
        -21
      ],
      [
        -11,
        11
      ],
      [
        -7,
        -5
      ]
    ],
    [
      [
        26735,
        58281
      ],
      [
        -6,
        6
      ],
      [
        -2,
        8
      ],
      [
        -6,
        -2
      ],
      [
        -12,
        -30
      ],
      [
        -1,
        -12
      ],
      [
        -7,
        -11
      ],
      [
        -2,
        -16
      ],
      [
        -5,
        11
      ],
      [
        -5,
        -8
      ],
      [
        -3,
        -48
      ],
      [
        1,
        -17
      ],
      [
        5,
        -17
      ],
      [
        3,
        -50
      ],
      [
        -2,
        -27
      ]
    ],
    [
      [
        26693,
        58068
      ],
      [
        -7,
        -6
      ],
      [
        -10,
        2
      ],
      [
        -3,
        -13
      ],
      [
        -6,
        10
      ],
      [
        -6,
        -13
      ],
      [
        -4,
        -19
      ],
      [
        -6,
        9
      ],
      [
        -2,
        -7
      ],
      [
        -49,
        -19
      ],
      [
        -2,
        -4
      ]
    ],
    [
      [
        26598,
        58008
      ],
      [
        -5,
        23
      ],
      [
        4,
        29
      ],
      [
        6,
        13
      ],
      [
        11,
        11
      ],
      [
        8,
        37
      ],
      [
        3,
        39
      ],
      [
        -1,
        28
      ],
      [
        -7,
        -9
      ],
      [
        -2,
        11
      ],
      [
        -7,
        8
      ],
      [
        0,
        -13
      ],
      [
        -4,
        0
      ],
      [
        -21,
        18
      ],
      [
        -7,
        -7
      ],
      [
        -5,
        3
      ],
      [
        -8,
        13
      ],
      [
        0,
        -12
      ],
      [
        -11,
        10
      ],
      [
        -6,
        -6
      ],
      [
        -2,
        14
      ],
      [
        -11,
        6
      ],
      [
        -4,
        -17
      ],
      [
        -5,
        0
      ],
      [
        -2,
        12
      ]
    ],
    [
      [
        23259,
        55308
      ],
      [
        99,
        3
      ]
    ],
    [
      [
        23402,
        55370
      ],
      [
        0,
        -129
      ]
    ],
    [
      [
        23401,
        54854
      ],
      [
        -3,
        -30
      ],
      [
        -3,
        12
      ],
      [
        -4,
        -10
      ],
      [
        -5,
        16
      ],
      [
        1,
        14
      ],
      [
        -9,
        -13
      ],
      [
        -4,
        20
      ],
      [
        -7,
        -8
      ],
      [
        -1,
        10
      ],
      [
        -18,
        34
      ],
      [
        -8,
        -7
      ],
      [
        -1,
        -6
      ],
      [
        0,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        1,
        2
      ],
      [
        -1,
        1
      ]
    ],
    [
      [
        23337,
        54890
      ],
      [
        1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        23337,
        54890
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -2
      ],
      [
        -1,
        0
      ],
      [
        0,
        3
      ],
      [
        -1,
        1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        1
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        23333,
        54895
      ],
      [
        0,
        0
      ]
    ],
    [
      [
        23333,
        54895
      ],
      [
        -1,
        1
      ]
    ],
    [
      [
        23332,
        54896
      ],
      [
        0,
        -2
      ]
    ],
    [
      [
        23332,
        54894
      ],
      [
        0,
        -1
      ],
      [
        -1,
        1
      ]
    ],
    [
      [
        23331,
        54894
      ],
      [
        0,
        0
      ]
    ],
    [
      [
        23331,
        54894
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        23331,
        54895
      ],
      [
        0,
        0
      ]
    ],
    [
      [
        23331,
        54895
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        23330,
        54895
      ],
      [
        0,
        0
      ]
    ],
    [
      [
        23330,
        54895
      ],
      [
        -1,
        0
      ],
      [
        0,
        2
      ],
      [
        -6,
        -1
      ],
      [
        -3,
        9
      ],
      [
        -7,
        -10
      ],
      [
        -6,
        14
      ],
      [
        -5,
        3
      ],
      [
        0,
        8
      ],
      [
        -6,
        24
      ],
      [
        -8,
        17
      ],
      [
        -3,
        12
      ],
      [
        -4,
        2
      ],
      [
        -3,
        15
      ]
    ],
    [
      [
        23267,
        55029
      ],
      [
        -8,
        279
      ]
    ],
    [
      [
        28401,
        59133
      ],
      [
        21,
        218
      ],
      [
        -1,
        25
      ],
      [
        4,
        19
      ],
      [
        6,
        9
      ],
      [
        2,
        -8
      ],
      [
        6,
        9
      ],
      [
        1,
        19
      ],
      [
        -5,
        4
      ],
      [
        1,
        14
      ],
      [
        -3,
        8
      ],
      [
        -15,
        7
      ],
      [
        -1,
        11
      ],
      [
        -4,
        14
      ]
    ],
    [
      [
        28413,
        59482
      ],
      [
        3,
        -2
      ],
      [
        16,
        0
      ],
      [
        50,
        -1
      ]
    ],
    [
      [
        28482,
        59479
      ],
      [
        1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        5,
        -20
      ],
      [
        -1,
        -12
      ],
      [
        -4,
        -6
      ],
      [
        -4,
        -38
      ],
      [
        -4,
        -3
      ],
      [
        1,
        -35
      ],
      [
        0,
        -31
      ],
      [
        3,
        -14
      ],
      [
        8,
        -13
      ],
      [
        3,
        0
      ],
      [
        21,
        -31
      ],
      [
        7,
        -5
      ],
      [
        4,
        3
      ],
      [
        5,
        -11
      ],
      [
        8,
        -33
      ],
      [
        10,
        -33
      ]
    ],
    [
      [
        28543,
        59191
      ],
      [
        1,
        -13
      ],
      [
        1,
        -9
      ]
    ],
    [
      [
        28545,
        59169
      ],
      [
        -1,
        1
      ],
      [
        -7,
        -40
      ]
    ],
    [
      [
        28537,
        59130
      ],
      [
        -51,
        -1
      ],
      [
        -19,
        -5
      ],
      [
        -4,
        4
      ],
      [
        -6,
        -3
      ],
      [
        -49,
        4
      ],
      [
        -7,
        4
      ]
    ],
    [
      [
        23486,
        52437
      ],
      [
        20,
        -6
      ],
      [
        12,
        1
      ]
    ],
    [
      [
        23449,
        51727
      ],
      [
        -5,
        42
      ],
      [
        4,
        61
      ],
      [
        -4,
        22
      ],
      [
        -7,
        6
      ],
      [
        -2,
        -3
      ],
      [
        -7,
        78
      ],
      [
        -11,
        124
      ]
    ],
    [
      [
        23417,
        52057
      ],
      [
        -19,
        207
      ]
    ],
    [
      [
        25863,
        62395
      ],
      [
        66,
        2
      ]
    ],
    [
      [
        25929,
        62397
      ],
      [
        0,
        -17
      ],
      [
        5,
        0
      ],
      [
        56,
        6
      ],
      [
        0,
        10
      ],
      [
        4,
        8
      ],
      [
        4,
        9
      ],
      [
        3,
        7
      ],
      [
        6,
        -2
      ]
    ],
    [
      [
        25983,
        62029
      ],
      [
        -1,
        -5
      ],
      [
        -5,
        31
      ],
      [
        -2,
        -12
      ],
      [
        -6,
        11
      ],
      [
        -3,
        -2
      ],
      [
        -4,
        12
      ],
      [
        -4,
        -14
      ],
      [
        -2,
        19
      ],
      [
        -12,
        -14
      ],
      [
        -8,
        19
      ],
      [
        -5,
        2
      ],
      [
        -5,
        11
      ],
      [
        -3,
        -21
      ],
      [
        -9,
        -4
      ],
      [
        -14,
        25
      ],
      [
        -4,
        -12
      ],
      [
        -7,
        6
      ],
      [
        -4,
        -13
      ],
      [
        -4,
        3
      ],
      [
        -6,
        -7
      ]
    ],
    [
      [
        25863,
        62328
      ],
      [
        0,
        67
      ]
    ],
    [
      [
        22321,
        61580
      ],
      [
        0,
        -101
      ],
      [
        30,
        0
      ],
      [
        3,
        -1
      ]
    ],
    [
      [
        24240,
        52210
      ],
      [
        15,
        36
      ],
      [
        2,
        36
      ],
      [
        6,
        14
      ],
      [
        3,
        10
      ],
      [
        2,
        -6
      ],
      [
        3,
        -18
      ],
      [
        4,
        12
      ],
      [
        8,
        -3
      ]
    ],
    [
      [
        24283,
        52291
      ],
      [
        10,
        -10
      ],
      [
        -1,
        -30
      ],
      [
        -3,
        -10
      ],
      [
        3,
        -20
      ],
      [
        1,
        -18
      ],
      [
        1,
        -19
      ],
      [
        -8,
        -19
      ],
      [
        5,
        -27
      ],
      [
        5,
        -1
      ],
      [
        0,
        -12
      ],
      [
        -4,
        -8
      ],
      [
        0,
        -8
      ],
      [
        -6,
        -1
      ],
      [
        -1,
        -34
      ],
      [
        4,
        -6
      ],
      [
        3,
        12
      ],
      [
        10,
        1
      ],
      [
        4,
        -39
      ],
      [
        -6,
        -29
      ],
      [
        -2,
        -11
      ],
      [
        -2,
        -24
      ],
      [
        -3,
        -31
      ]
    ],
    [
      [
        23091,
        70512
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        23095,
        70207
      ],
      [
        0,
        204
      ],
      [
        -4,
        0
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        24819,
        54655
      ],
      [
        -3,
        22
      ],
      [
        3,
        2
      ],
      [
        -1,
        22
      ],
      [
        8,
        3
      ],
      [
        6,
        38
      ],
      [
        1,
        7
      ],
      [
        15,
        13
      ],
      [
        6,
        26
      ],
      [
        2,
        -1
      ],
      [
        2,
        19
      ],
      [
        8,
        14
      ],
      [
        3,
        26
      ],
      [
        3,
        -5
      ],
      [
        3,
        19
      ],
      [
        7,
        21
      ],
      [
        3,
        -10
      ],
      [
        12,
        2
      ]
    ],
    [
      [
        24912,
        54449
      ],
      [
        0,
        -204
      ]
    ],
    [
      [
        24912,
        54245
      ],
      [
        -71,
        3
      ],
      [
        -68,
        0
      ]
    ],
    [
      [
        24773,
        54248
      ],
      [
        -2,
        17
      ],
      [
        3,
        18
      ],
      [
        -6,
        22
      ],
      [
        2,
        27
      ],
      [
        -2,
        37
      ],
      [
        1,
        28
      ],
      [
        3,
        -5
      ],
      [
        11,
        17
      ],
      [
        3,
        16
      ],
      [
        -2,
        2
      ],
      [
        1,
        19
      ],
      [
        -6,
        19
      ],
      [
        1,
        18
      ],
      [
        5,
        11
      ],
      [
        0,
        15
      ],
      [
        2,
        3
      ],
      [
        1,
        16
      ],
      [
        2,
        -3
      ],
      [
        5,
        4
      ],
      [
        -2,
        7
      ],
      [
        -1,
        11
      ],
      [
        2,
        17
      ],
      [
        3,
        0
      ],
      [
        9,
        32
      ],
      [
        5,
        48
      ],
      [
        3,
        6
      ],
      [
        5,
        5
      ]
    ],
    [
      [
        24683,
        54781
      ],
      [
        9,
        -5
      ],
      [
        -1,
        18
      ],
      [
        16,
        34
      ],
      [
        5,
        30
      ]
    ],
    [
      [
        24712,
        54858
      ],
      [
        0,
        -99
      ],
      [
        15,
        -1
      ],
      [
        41,
        0
      ],
      [
        1,
        -102
      ],
      [
        23,
        0
      ],
      [
        6,
        -1
      ],
      [
        21,
        0
      ]
    ],
    [
      [
        24637,
        54246
      ],
      [
        -3,
        206
      ]
    ],
    [
      [
        27874,
        57885
      ],
      [
        0,
        16
      ],
      [
        1,
        5
      ]
    ],
    [
      [
        27875,
        57906
      ],
      [
        19,
        18
      ],
      [
        8,
        8
      ],
      [
        6,
        -3
      ],
      [
        10,
        9
      ],
      [
        2,
        -1
      ],
      [
        10,
        14
      ],
      [
        5,
        0
      ],
      [
        1,
        12
      ],
      [
        5,
        2
      ],
      [
        3,
        12
      ],
      [
        6,
        8
      ],
      [
        6,
        -3
      ],
      [
        3,
        10
      ],
      [
        3,
        -6
      ],
      [
        16,
        7
      ],
      [
        2,
        -8
      ],
      [
        28,
        -17
      ]
    ],
    [
      [
        28008,
        57968
      ],
      [
        0,
        -20
      ],
      [
        -4,
        -17
      ],
      [
        2,
        -11
      ],
      [
        -6,
        -9
      ],
      [
        3,
        -6
      ],
      [
        -1,
        -11
      ],
      [
        3,
        -12
      ],
      [
        -3,
        -7
      ],
      [
        1,
        -30
      ],
      [
        -4,
        -24
      ],
      [
        3,
        -4
      ],
      [
        -4,
        -5
      ],
      [
        -1,
        -20
      ],
      [
        -4,
        -10
      ],
      [
        3,
        -9
      ],
      [
        1,
        -42
      ],
      [
        4,
        -39
      ],
      [
        -1,
        -19
      ],
      [
        9,
        -34
      ],
      [
        12,
        -29
      ],
      [
        4,
        -26
      ],
      [
        3,
        0
      ],
      [
        0,
        -15
      ],
      [
        9,
        -26
      ],
      [
        0,
        -13
      ],
      [
        5,
        -15
      ]
    ],
    [
      [
        27929,
        57491
      ],
      [
        -1,
        1
      ],
      [
        -6,
        32
      ],
      [
        0,
        25
      ],
      [
        -8,
        32
      ],
      [
        -23,
        46
      ]
    ],
    [
      [
        27891,
        57627
      ],
      [
        0,
        6
      ],
      [
        1,
        6
      ],
      [
        -6,
        43
      ],
      [
        -9,
        49
      ],
      [
        0,
        33
      ],
      [
        -4,
        51
      ],
      [
        -3,
        14
      ],
      [
        4,
        56
      ]
    ],
    [
      [
        27192,
        58983
      ],
      [
        13,
        29
      ],
      [
        12,
        68
      ],
      [
        -6,
        46
      ]
    ],
    [
      [
        27211,
        59126
      ],
      [
        4,
        19
      ],
      [
        6,
        4
      ],
      [
        8,
        25
      ],
      [
        0,
        13
      ],
      [
        7,
        -9
      ],
      [
        6,
        -1
      ],
      [
        1,
        34
      ],
      [
        -1,
        53
      ],
      [
        2,
        9
      ],
      [
        11,
        8
      ],
      [
        4,
        -10
      ],
      [
        4,
        0
      ],
      [
        3,
        -12
      ],
      [
        6,
        2
      ],
      [
        2,
        12
      ]
    ],
    [
      [
        27274,
        59273
      ],
      [
        3,
        -1
      ],
      [
        6,
        14
      ],
      [
        9,
        25
      ],
      [
        7,
        39
      ],
      [
        7,
        -23
      ],
      [
        3,
        15
      ],
      [
        9,
        17
      ],
      [
        5,
        -26
      ],
      [
        9,
        -8
      ],
      [
        0,
        -21
      ],
      [
        5,
        -23
      ],
      [
        4,
        -2
      ],
      [
        6,
        8
      ],
      [
        3,
        -2
      ],
      [
        4,
        29
      ]
    ],
    [
      [
        27354,
        59314
      ],
      [
        7,
        -33
      ],
      [
        10,
        -14
      ],
      [
        3,
        -24
      ],
      [
        7,
        -17
      ],
      [
        0,
        -23
      ],
      [
        -1,
        -82
      ]
    ],
    [
      [
        26398,
        64300
      ],
      [
        49,
        1
      ],
      [
        0,
        -34
      ],
      [
        32,
        2
      ],
      [
        0,
        -18
      ],
      [
        63,
        2
      ]
    ],
    [
      [
        26542,
        64253
      ],
      [
        0,
        -123
      ]
    ],
    [
      [
        26388,
        63915
      ],
      [
        -6,
        5
      ],
      [
        0,
        380
      ]
    ],
    [
      [
        22847,
        58121
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        22847,
        58222
      ],
      [
        49,
        0
      ],
      [
        95,
        -1
      ]
    ],
    [
      [
        22991,
        58221
      ],
      [
        1,
        -72
      ]
    ],
    [
      [
        22992,
        58149
      ],
      [
        -9,
        -10
      ],
      [
        -13,
        28
      ],
      [
        -5,
        -5
      ],
      [
        -2,
        15
      ],
      [
        -5,
        -21
      ],
      [
        -9,
        -2
      ],
      [
        0,
        -588
      ]
    ],
    [
      [
        22949,
        57566
      ],
      [
        -6,
        7
      ],
      [
        0,
        28
      ],
      [
        -4,
        17
      ],
      [
        -11,
        -19
      ],
      [
        -9,
        -3
      ],
      [
        -7,
        38
      ],
      [
        -6,
        8
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        22906,
        57641
      ],
      [
        -7,
        -16
      ],
      [
        -3,
        -19
      ],
      [
        -8,
        -23
      ],
      [
        -6,
        -9
      ],
      [
        -10,
        17
      ],
      [
        -5,
        -2
      ],
      [
        -2,
        11
      ],
      [
        -15,
        6
      ],
      [
        -3,
        -7
      ]
    ],
    [
      [
        23171,
        58020
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        23245,
        58325
      ],
      [
        103,
        0
      ],
      [
        0,
        -302
      ]
    ],
    [
      [
        23348,
        58023
      ],
      [
        -13,
        41
      ],
      [
        -6,
        -5
      ],
      [
        -4,
        -21
      ],
      [
        -7,
        -11
      ]
    ],
    [
      [
        23318,
        58027
      ],
      [
        -13,
        6
      ],
      [
        -6,
        -25
      ],
      [
        2,
        -16
      ],
      [
        -17,
        -25
      ],
      [
        -6,
        -25
      ],
      [
        -3,
        -3
      ],
      [
        -4,
        5
      ],
      [
        4,
        12
      ],
      [
        -1,
        17
      ],
      [
        -5,
        -3
      ],
      [
        -12,
        -23
      ],
      [
        -3,
        -13
      ],
      [
        2,
        -9
      ],
      [
        -9,
        -7
      ],
      [
        -3,
        -15
      ],
      [
        -7,
        3
      ],
      [
        -4,
        -17
      ],
      [
        -3,
        2
      ],
      [
        -7,
        21
      ],
      [
        -13,
        -15
      ],
      [
        -9,
        2
      ],
      [
        -5,
        -35
      ],
      [
        -5,
        -15
      ],
      [
        -6,
        0
      ],
      [
        -9,
        11
      ],
      [
        -6,
        -1
      ]
    ],
    [
      [
        23170,
        57859
      ],
      [
        1,
        161
      ]
    ],
    [
      [
        15513,
        69827
      ],
      [
        91,
        1
      ],
      [
        1,
        -17
      ],
      [
        6,
        0
      ],
      [
        0,
        -17
      ],
      [
        23,
        0
      ],
      [
        0,
        -16
      ],
      [
        6,
        0
      ],
      [
        0,
        -17
      ],
      [
        11,
        -34
      ],
      [
        2,
        -1
      ],
      [
        11,
        0
      ],
      [
        4,
        -33
      ],
      [
        12,
        -1
      ]
    ],
    [
      [
        15680,
        69692
      ],
      [
        0,
        -67
      ],
      [
        5,
        0
      ]
    ],
    [
      [
        15624,
        69410
      ],
      [
        -119,
        0
      ],
      [
        -64,
        2
      ]
    ],
    [
      [
        15441,
        69412
      ],
      [
        -16,
        0
      ],
      [
        -1,
        163
      ],
      [
        90,
        0
      ],
      [
        0,
        184
      ],
      [
        -1,
        68
      ]
    ],
    [
      [
        28881,
        63990
      ],
      [
        -1,
        4
      ],
      [
        -11,
        29
      ]
    ],
    [
      [
        28869,
        64023
      ],
      [
        -12,
        31
      ],
      [
        -2,
        5
      ],
      [
        -18,
        46
      ],
      [
        -9,
        25
      ],
      [
        -18,
        48
      ],
      [
        -42,
        113
      ]
    ],
    [
      [
        28768,
        64291
      ],
      [
        10,
        19
      ],
      [
        13,
        16
      ],
      [
        8,
        26
      ],
      [
        6,
        7
      ]
    ],
    [
      [
        26100,
        60552
      ],
      [
        7,
        8
      ],
      [
        11,
        4
      ],
      [
        1,
        -8
      ],
      [
        8,
        -3
      ],
      [
        8,
        4
      ],
      [
        6,
        -23
      ],
      [
        2,
        1
      ],
      [
        9,
        -18
      ],
      [
        2,
        -21
      ],
      [
        2,
        -1
      ],
      [
        5,
        5
      ],
      [
        5,
        24
      ],
      [
        7,
        2
      ],
      [
        3,
        14
      ],
      [
        6,
        12
      ],
      [
        8,
        -21
      ],
      [
        4,
        7
      ],
      [
        5,
        -20
      ],
      [
        4,
        -5
      ],
      [
        2,
        -16
      ],
      [
        4,
        -5
      ]
    ],
    [
      [
        26184,
        60372
      ],
      [
        -6,
        -4
      ],
      [
        1,
        -13
      ],
      [
        -3,
        -28
      ],
      [
        -8,
        -11
      ],
      [
        -7,
        2
      ],
      [
        -7,
        -5
      ],
      [
        -6,
        -16
      ],
      [
        -5,
        0
      ],
      [
        1,
        -22
      ],
      [
        -2,
        -4
      ],
      [
        -10,
        -37
      ]
    ],
    [
      [
        26132,
        60234
      ],
      [
        -6,
        34
      ],
      [
        -10,
        3
      ],
      [
        2,
        15
      ],
      [
        3,
        1
      ],
      [
        -1,
        15
      ],
      [
        -10,
        64
      ],
      [
        -13,
        68
      ],
      [
        -30,
        79
      ],
      [
        0,
        44
      ]
    ],
    [
      [
        25958,
        59688
      ],
      [
        -2,
        22
      ],
      [
        -5,
        20
      ],
      [
        -8,
        6
      ],
      [
        -2,
        -5
      ],
      [
        -4,
        18
      ],
      [
        5,
        5
      ],
      [
        -1,
        13
      ],
      [
        -4,
        5
      ],
      [
        1,
        15
      ],
      [
        -6,
        -3
      ],
      [
        1,
        20
      ],
      [
        3,
        7
      ],
      [
        -6,
        30
      ],
      [
        0,
        45
      ],
      [
        3,
        7
      ],
      [
        -9,
        2
      ],
      [
        -3,
        -21
      ],
      [
        2,
        -22
      ],
      [
        -2,
        5
      ],
      [
        -4,
        32
      ],
      [
        -5,
        -4
      ],
      [
        2,
        12
      ],
      [
        -2,
        13
      ],
      [
        1,
        21
      ],
      [
        -3,
        -6
      ],
      [
        0,
        -18
      ],
      [
        -3,
        -5
      ],
      [
        -5,
        9
      ],
      [
        5,
        11
      ],
      [
        -2,
        12
      ]
    ],
    [
      [
        22784,
        52350
      ],
      [
        -9,
        -60
      ],
      [
        -24,
        -171
      ],
      [
        -1,
        -10
      ],
      [
        -1,
        -6
      ],
      [
        -43,
        -162
      ]
    ],
    [
      [
        22689,
        51891
      ],
      [
        -12,
        34
      ],
      [
        -8,
        25
      ],
      [
        -9,
        27
      ],
      [
        -12,
        38
      ],
      [
        -31,
        92
      ],
      [
        -6,
        19
      ],
      [
        -51,
        151
      ]
    ],
    [
      [
        23417,
        52057
      ],
      [
        -28,
        -93
      ],
      [
        -15,
        -51
      ],
      [
        -3,
        -13
      ],
      [
        -9,
        -6
      ],
      [
        -5,
        6
      ],
      [
        1,
        15
      ],
      [
        -13,
        36
      ],
      [
        -5,
        12
      ],
      [
        -6,
        -3
      ],
      [
        -3,
        9
      ],
      [
        -5,
        27
      ],
      [
        -4,
        -6
      ],
      [
        -10,
        -8
      ],
      [
        -4,
        6
      ],
      [
        -4,
        41
      ],
      [
        -4,
        10
      ],
      [
        -4,
        16
      ],
      [
        -3,
        5
      ],
      [
        -3,
        1
      ],
      [
        -6,
        -22
      ],
      [
        -5,
        -19
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -2
      ],
      [
        -5,
        3
      ],
      [
        -1,
        -11
      ],
      [
        -3,
        0
      ],
      [
        -10,
        -29
      ],
      [
        -4,
        6
      ],
      [
        -14,
        -15
      ],
      [
        -5,
        -2
      ],
      [
        -2,
        -6
      ],
      [
        -12,
        4
      ]
    ],
    [
      [
        23220,
        51967
      ],
      [
        0,
        181
      ]
    ],
    [
      [
        23220,
        52148
      ],
      [
        0,
        107
      ],
      [
        -4,
        189
      ],
      [
        -3,
        152
      ]
    ],
    [
      [
        21580,
        54802
      ],
      [
        144,
        -2
      ]
    ],
    [
      [
        26824,
        59980
      ],
      [
        0,
        5
      ],
      [
        1,
        0
      ],
      [
        0,
        2
      ],
      [
        1,
        -2
      ],
      [
        1,
        0
      ],
      [
        0,
        5
      ],
      [
        1,
        3
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        1,
        0
      ],
      [
        1,
        2
      ],
      [
        1,
        4
      ],
      [
        0,
        2
      ],
      [
        1,
        5
      ],
      [
        -1,
        4
      ],
      [
        1,
        3
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        1,
        -3
      ],
      [
        0,
        3
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        0,
        -2
      ],
      [
        4,
        3
      ],
      [
        1,
        2
      ],
      [
        0,
        -5
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        2,
        0
      ],
      [
        1,
        5
      ],
      [
        0,
        3
      ],
      [
        2,
        1
      ],
      [
        1,
        6
      ],
      [
        0,
        2
      ],
      [
        2,
        5
      ],
      [
        2,
        -1
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        1
      ],
      [
        1,
        5
      ],
      [
        1,
        14
      ],
      [
        0,
        1
      ],
      [
        2,
        2
      ],
      [
        1,
        -1
      ],
      [
        2,
        -2
      ],
      [
        0,
        1
      ],
      [
        1,
        3
      ],
      [
        -1,
        3
      ],
      [
        0,
        5
      ],
      [
        1,
        7
      ],
      [
        -1,
        5
      ],
      [
        0,
        5
      ],
      [
        -1,
        7
      ],
      [
        1,
        3
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        0,
        5
      ],
      [
        -1,
        2
      ],
      [
        -1,
        3
      ],
      [
        0,
        10
      ],
      [
        1,
        1
      ],
      [
        0,
        13
      ],
      [
        -1,
        8
      ],
      [
        -1,
        3
      ],
      [
        1,
        1
      ],
      [
        1,
        5
      ],
      [
        1,
        3
      ],
      [
        3,
        4
      ],
      [
        3,
        7
      ],
      [
        3,
        5
      ],
      [
        2,
        -1
      ],
      [
        2,
        4
      ],
      [
        1,
        4
      ],
      [
        1,
        2
      ],
      [
        2,
        1
      ],
      [
        0,
        7
      ],
      [
        1,
        1
      ],
      [
        5,
        3
      ],
      [
        3,
        10
      ],
      [
        2,
        6
      ],
      [
        2,
        6
      ],
      [
        3,
        5
      ],
      [
        2,
        3
      ],
      [
        0,
        3
      ],
      [
        1,
        4
      ],
      [
        3,
        3
      ],
      [
        3,
        9
      ]
    ],
    [
      [
        26912,
        60247
      ],
      [
        2,
        -91
      ],
      [
        1,
        -6
      ],
      [
        12,
        -64
      ],
      [
        1,
        -6
      ],
      [
        4,
        -43
      ],
      [
        4,
        -1
      ],
      [
        16,
        -39
      ],
      [
        8,
        -9
      ],
      [
        4,
        -21
      ],
      [
        1,
        -8
      ],
      [
        10,
        18
      ]
    ],
    [
      [
        26975,
        59977
      ],
      [
        8,
        -76
      ],
      [
        -22,
        -18
      ],
      [
        -4,
        -6
      ],
      [
        -4,
        -10
      ]
    ],
    [
      [
        26851,
        59778
      ],
      [
        -9,
        26
      ],
      [
        -9,
        29
      ],
      [
        -3,
        0
      ],
      [
        -1,
        26
      ],
      [
        -8,
        27
      ]
    ],
    [
      [
        28128,
        62542
      ],
      [
        0,
        35
      ],
      [
        9,
        -4
      ],
      [
        5,
        -20
      ],
      [
        -3,
        -10
      ],
      [
        -7,
        -40
      ],
      [
        -3,
        -12
      ],
      [
        -3,
        13
      ],
      [
        2,
        38
      ]
    ],
    [
      [
        26945,
        64658
      ],
      [
        4,
        0
      ],
      [
        0,
        -197
      ],
      [
        3,
        -18
      ],
      [
        6,
        0
      ],
      [
        -1,
        -14
      ],
      [
        3,
        -10
      ],
      [
        0,
        -70
      ],
      [
        11,
        0
      ],
      [
        1,
        -103
      ],
      [
        0,
        -97
      ]
    ],
    [
      [
        26892,
        64143
      ],
      [
        0,
        101
      ],
      [
        -6,
        0
      ],
      [
        0,
        34
      ],
      [
        5,
        0
      ],
      [
        0,
        50
      ],
      [
        -17,
        2
      ],
      [
        -11,
        1
      ]
    ],
    [
      [
        24912,
        54245
      ],
      [
        19,
        0
      ],
      [
        2,
        -39
      ],
      [
        0,
        -268
      ],
      [
        1,
        -3
      ]
    ],
    [
      [
        24934,
        53935
      ],
      [
        -29,
        -7
      ]
    ],
    [
      [
        24844,
        53913
      ],
      [
        -41,
        -11
      ]
    ],
    [
      [
        24160,
        62628
      ],
      [
        16,
        -1
      ],
      [
        1,
        0
      ],
      [
        15,
        -2
      ]
    ],
    [
      [
        24218,
        61923
      ],
      [
        -2,
        4
      ],
      [
        -6,
        -3
      ],
      [
        -12,
        26
      ],
      [
        -19,
        18
      ],
      [
        5,
        27
      ],
      [
        -5,
        29
      ],
      [
        -9,
        11
      ]
    ],
    [
      [
        24170,
        62035
      ],
      [
        -4,
        29
      ],
      [
        7,
        30
      ],
      [
        1,
        22
      ],
      [
        -5,
        13
      ],
      [
        -5,
        -1
      ],
      [
        -8,
        22
      ],
      [
        -3,
        26
      ],
      [
        -6,
        16
      ],
      [
        1,
        32
      ],
      [
        -2,
        7
      ],
      [
        -5,
        17
      ]
    ],
    [
      [
        24124,
        62304
      ],
      [
        -3,
        10
      ],
      [
        4,
        8
      ],
      [
        -3,
        15
      ],
      [
        15,
        105
      ],
      [
        23,
        186
      ]
    ],
    [
      [
        19395,
        72972
      ],
      [
        -2,
        -307
      ],
      [
        0,
        -154
      ]
    ],
    [
      [
        19087,
        72136
      ],
      [
        -1,
        35
      ],
      [
        -35,
        -1
      ],
      [
        0,
        93
      ],
      [
        -27,
        -1
      ],
      [
        -4,
        26
      ],
      [
        -3,
        6
      ],
      [
        -5,
        -12
      ],
      [
        -8,
        6
      ],
      [
        -8,
        19
      ],
      [
        -1,
        9
      ],
      [
        -9,
        1
      ],
      [
        -8,
        12
      ],
      [
        -6,
        19
      ],
      [
        4,
        32
      ],
      [
        6,
        34
      ],
      [
        3,
        4
      ],
      [
        3,
        24
      ],
      [
        3,
        3
      ],
      [
        2,
        19
      ],
      [
        -121,
        0
      ]
    ],
    [
      [
        18872,
        72800
      ],
      [
        0,
        169
      ]
    ],
    [
      [
        22529,
        64514
      ],
      [
        3,
        13
      ],
      [
        19,
        66
      ],
      [
        10,
        21
      ],
      [
        6,
        34
      ],
      [
        13,
        29
      ],
      [
        3,
        1
      ],
      [
        10,
        33
      ],
      [
        8,
        18
      ],
      [
        7,
        29
      ],
      [
        8,
        14
      ],
      [
        1,
        -6
      ],
      [
        23,
        34
      ],
      [
        3,
        10
      ],
      [
        13,
        59
      ]
    ],
    [
      [
        20310,
        58659
      ],
      [
        0,
        19
      ]
    ],
    [
      [
        20458,
        58822
      ],
      [
        -2,
        -126
      ]
    ],
    [
      [
        20311,
        57729
      ],
      [
        0,
        204
      ]
    ],
    [
      [
        20311,
        57933
      ],
      [
        0,
        27
      ],
      [
        -1,
        77
      ],
      [
        0,
        525
      ]
    ],
    [
      [
        28008,
        57968
      ],
      [
        9,
        32
      ],
      [
        1,
        28
      ],
      [
        12,
        23
      ]
    ],
    [
      [
        28135,
        57903
      ],
      [
        0,
        -61
      ],
      [
        -1,
        -7
      ],
      [
        -2,
        -44
      ],
      [
        4,
        -16
      ],
      [
        3,
        -206
      ],
      [
        -14,
        -187
      ],
      [
        13,
        -23
      ],
      [
        5,
        -14
      ],
      [
        6,
        13
      ]
    ],
    [
      [
        28149,
        57358
      ],
      [
        0,
        -17
      ],
      [
        -12,
        -32
      ],
      [
        -28,
        -146
      ]
    ],
    [
      [
        22991,
        58221
      ],
      [
        1,
        205
      ]
    ],
    [
      [
        23171,
        58020
      ],
      [
        -129,
        0
      ]
    ],
    [
      [
        23042,
        58020
      ],
      [
        0,
        207
      ],
      [
        -1,
        -11
      ],
      [
        -5,
        0
      ],
      [
        -2,
        6
      ],
      [
        -5,
        -17
      ],
      [
        2,
        -11
      ],
      [
        -4,
        -12
      ],
      [
        -6,
        2
      ],
      [
        -1,
        9
      ],
      [
        -9,
        18
      ],
      [
        -4,
        -19
      ],
      [
        4,
        -4
      ],
      [
        -2,
        -14
      ],
      [
        7,
        -13
      ],
      [
        0,
        -23
      ],
      [
        -6,
        4
      ],
      [
        1,
        8
      ],
      [
        -6,
        0
      ],
      [
        -3,
        11
      ],
      [
        -4,
        -17
      ],
      [
        -6,
        5
      ]
    ],
    [
      [
        22579,
        59537
      ],
      [
        179,
        0
      ]
    ],
    [
      [
        22758,
        59537
      ],
      [
        0,
        -499
      ]
    ],
    [
      [
        22758,
        59038
      ],
      [
        -59,
        0
      ]
    ],
    [
      [
        22579,
        59038
      ],
      [
        0,
        347
      ]
    ],
    [
      [
        26648,
        61233
      ],
      [
        10,
        0
      ],
      [
        -4,
        -21
      ],
      [
        6,
        1
      ],
      [
        -2,
        -19
      ],
      [
        8,
        20
      ]
    ],
    [
      [
        26666,
        61214
      ],
      [
        -3,
        -106
      ],
      [
        -14,
        -61
      ],
      [
        -3,
        -24
      ],
      [
        3,
        -9
      ]
    ],
    [
      [
        26573,
        61079
      ],
      [
        -2,
        82
      ],
      [
        5,
        12
      ]
    ],
    [
      [
        20563,
        59151
      ],
      [
        132,
        0
      ],
      [
        0,
        -51
      ],
      [
        120,
        1
      ]
    ],
    [
      [
        20815,
        59101
      ],
      [
        2,
        -6
      ],
      [
        -3,
        -23
      ],
      [
        7,
        -20
      ],
      [
        -1,
        -10
      ],
      [
        4,
        -15
      ],
      [
        -3,
        -37
      ],
      [
        3,
        -7
      ],
      [
        1,
        -30
      ],
      [
        8,
        -29
      ],
      [
        -2,
        -20
      ],
      [
        4,
        -6
      ],
      [
        1,
        -24
      ],
      [
        -1,
        -12
      ],
      [
        4,
        -4
      ],
      [
        2,
        -21
      ],
      [
        -4,
        -11
      ],
      [
        8,
        -26
      ],
      [
        -7,
        -23
      ],
      [
        0,
        -13
      ],
      [
        3,
        -20
      ],
      [
        -8,
        -34
      ],
      [
        -3,
        -24
      ],
      [
        -2,
        -3
      ],
      [
        7,
        -20
      ],
      [
        -4,
        -8
      ],
      [
        3,
        -7
      ],
      [
        -3,
        -7
      ],
      [
        4,
        -13
      ],
      [
        -2,
        -9
      ],
      [
        3,
        -25
      ],
      [
        -3,
        -5
      ]
    ],
    [
      [
        22784,
        65532
      ],
      [
        -129,
        -1
      ]
    ],
    [
      [
        22691,
        65126
      ],
      [
        29,
        1
      ],
      [
        0,
        -73
      ]
    ],
    [
      [
        16170,
        68614
      ],
      [
        0,
        -201
      ],
      [
        2,
        -55
      ],
      [
        0,
        -38
      ],
      [
        32,
        -5
      ],
      [
        0,
        -202
      ],
      [
        66,
        -4
      ],
      [
        0,
        -100
      ],
      [
        103,
        1
      ],
      [
        0,
        -101
      ],
      [
        34,
        0
      ],
      [
        0,
        -101
      ],
      [
        11,
        -1
      ],
      [
        89,
        1
      ]
    ],
    [
      [
        16107,
        67713
      ],
      [
        -186,
        -2
      ]
    ],
    [
      [
        16981,
        65827
      ],
      [
        90,
        2
      ],
      [
        70,
        0
      ],
      [
        50,
        1
      ],
      [
        11,
        0
      ],
      [
        52,
        1
      ],
      [
        53,
        0
      ]
    ],
    [
      [
        17307,
        65831
      ],
      [
        3,
        -1
      ]
    ],
    [
      [
        17310,
        65830
      ],
      [
        0,
        -1163
      ]
    ],
    [
      [
        17310,
        64667
      ],
      [
        -1,
        -416
      ],
      [
        -63,
        -1
      ],
      [
        -15,
        -135
      ]
    ],
    [
      [
        17231,
        64115
      ],
      [
        0,
        175
      ],
      [
        -96,
        9
      ],
      [
        0,
        202
      ],
      [
        -221,
        -2
      ],
      [
        -97,
        0
      ],
      [
        0,
        122
      ],
      [
        -146,
        0
      ]
    ],
    [
      [
        16671,
        64621
      ],
      [
        -5,
        0
      ],
      [
        -1,
        319
      ],
      [
        7,
        0
      ],
      [
        1,
        209
      ],
      [
        -6,
        0
      ],
      [
        -1,
        205
      ],
      [
        1,
        310
      ],
      [
        0,
        160
      ]
    ],
    [
      [
        28289,
        65830
      ],
      [
        29,
        1
      ],
      [
        14,
        0
      ],
      [
        92,
        -1
      ],
      [
        17,
        1
      ],
      [
        16,
        1
      ],
      [
        11,
        0
      ]
    ],
    [
      [
        28468,
        65832
      ],
      [
        7,
        1
      ],
      [
        4,
        0
      ]
    ],
    [
      [
        28479,
        65833
      ],
      [
        8,
        -224
      ],
      [
        0,
        -17
      ],
      [
        6,
        -203
      ],
      [
        1,
        -27
      ]
    ],
    [
      [
        28494,
        65362
      ],
      [
        -1,
        -8
      ],
      [
        -12,
        -11
      ],
      [
        -2,
        -12
      ],
      [
        -4,
        -2
      ],
      [
        -6,
        -15
      ],
      [
        1,
        -5
      ],
      [
        -178,
        -11
      ]
    ],
    [
      [
        28292,
        65298
      ],
      [
        -1,
        169
      ],
      [
        0,
        46
      ],
      [
        -1,
        104
      ],
      [
        0,
        77
      ],
      [
        -1,
        136
      ]
    ],
    [
      [
        25781,
        60470
      ],
      [
        35,
        -38
      ],
      [
        5,
        -48
      ]
    ],
    [
      [
        25764,
        60010
      ],
      [
        -48,
        66
      ],
      [
        -27,
        15
      ]
    ],
    [
      [
        25689,
        60091
      ],
      [
        0,
        11
      ],
      [
        6,
        -1
      ],
      [
        7,
        12
      ],
      [
        -2,
        16
      ],
      [
        0,
        12
      ],
      [
        6,
        -1
      ],
      [
        -5,
        13
      ],
      [
        0,
        13
      ],
      [
        -5,
        -9
      ],
      [
        1,
        12
      ],
      [
        -3,
        8
      ],
      [
        -4,
        -7
      ],
      [
        3,
        27
      ],
      [
        2,
        23
      ],
      [
        7,
        -3
      ],
      [
        -3,
        29
      ],
      [
        2,
        12
      ]
    ],
    [
      [
        25859,
        61385
      ],
      [
        4,
        -9
      ],
      [
        4,
        -6
      ],
      [
        4,
        -12
      ],
      [
        5,
        -23
      ],
      [
        0,
        -9
      ],
      [
        -2,
        -37
      ],
      [
        0,
        -11
      ],
      [
        1,
        -25
      ],
      [
        2,
        -11
      ],
      [
        0,
        -1
      ],
      [
        2,
        -5
      ],
      [
        3,
        -8
      ],
      [
        5,
        -8
      ],
      [
        2,
        -7
      ],
      [
        1,
        -6
      ],
      [
        4,
        -7
      ],
      [
        4,
        -6
      ],
      [
        4,
        -6
      ],
      [
        1,
        -2
      ],
      [
        2,
        0
      ],
      [
        7,
        7
      ],
      [
        4,
        0
      ],
      [
        3,
        -1
      ],
      [
        2,
        -2
      ],
      [
        4,
        -5
      ],
      [
        2,
        -5
      ],
      [
        2,
        -5
      ],
      [
        1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        0,
        -9
      ],
      [
        2,
        -14
      ],
      [
        1,
        -5
      ],
      [
        2,
        -9
      ],
      [
        2,
        -5
      ],
      [
        1,
        -1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        0,
        3
      ],
      [
        1,
        3
      ],
      [
        0,
        30
      ],
      [
        1,
        3
      ],
      [
        3,
        4
      ],
      [
        3,
        3
      ],
      [
        3,
        1
      ]
    ],
    [
      [
        26325,
        60749
      ],
      [
        4,
        -3
      ],
      [
        -2,
        -16
      ],
      [
        1,
        -10
      ],
      [
        4,
        -9
      ],
      [
        3,
        2
      ],
      [
        1,
        -12
      ],
      [
        41,
        -115
      ],
      [
        6,
        -2
      ],
      [
        1,
        -8
      ]
    ],
    [
      [
        26645,
        59939
      ],
      [
        0,
        -18
      ],
      [
        6,
        -14
      ],
      [
        -3,
        -18
      ],
      [
        3,
        0
      ]
    ],
    [
      [
        26659,
        59620
      ],
      [
        -2,
        0
      ],
      [
        -4,
        2
      ],
      [
        -2,
        2
      ],
      [
        -1,
        2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -2
      ],
      [
        -3,
        0
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        -3,
        -6
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        -5
      ],
      [
        -2,
        0
      ],
      [
        -4,
        -5
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -4
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        3
      ],
      [
        -2,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -7
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -2
      ]
    ],
    [
      [
        26599,
        59546
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -28,
        1
      ],
      [
        -29,
        3
      ],
      [
        -10,
        1
      ]
    ],
    [
      [
        26248,
        61945
      ],
      [
        3,
        13
      ],
      [
        5,
        -4
      ],
      [
        10,
        33
      ],
      [
        7,
        -1
      ],
      [
        4,
        17
      ],
      [
        11,
        15
      ],
      [
        2,
        -5
      ]
    ],
    [
      [
        26290,
        62013
      ],
      [
        3,
        -118
      ],
      [
        26,
        -69
      ],
      [
        4,
        -19
      ],
      [
        -2,
        -13
      ],
      [
        5,
        0
      ],
      [
        4,
        -21
      ],
      [
        4,
        -34
      ],
      [
        7,
        -5
      ],
      [
        6,
        -9
      ]
    ],
    [
      [
        28488,
        57978
      ],
      [
        14,
        -44
      ],
      [
        59,
        22
      ],
      [
        6,
        51
      ],
      [
        -2,
        25
      ],
      [
        0,
        33
      ],
      [
        3,
        10
      ]
    ],
    [
      [
        28568,
        58075
      ],
      [
        2,
        -1
      ],
      [
        4,
        -4
      ],
      [
        9,
        -1
      ],
      [
        2,
        -4
      ],
      [
        13,
        -8
      ],
      [
        5,
        -9
      ],
      [
        3,
        -22
      ],
      [
        1,
        -21
      ],
      [
        0,
        -19
      ],
      [
        -3,
        -21
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -9
      ],
      [
        0,
        -15
      ],
      [
        -1,
        -9
      ],
      [
        -3,
        -6
      ],
      [
        -5,
        -17
      ],
      [
        -4,
        -21
      ],
      [
        -1,
        -10
      ],
      [
        1,
        -19
      ],
      [
        0,
        -9
      ],
      [
        -3,
        -23
      ],
      [
        -3,
        -7
      ],
      [
        -1,
        -10
      ],
      [
        -2,
        -13
      ],
      [
        -2,
        -5
      ],
      [
        -7,
        -29
      ],
      [
        -4,
        -8
      ],
      [
        -2,
        0
      ],
      [
        -3,
        -5
      ],
      [
        -2,
        -6
      ],
      [
        -45,
        -101
      ],
      [
        -44,
        97
      ]
    ],
    [
      [
        28501,
        58520
      ],
      [
        5,
        13
      ],
      [
        4,
        21
      ],
      [
        3,
        39
      ],
      [
        4,
        9
      ],
      [
        -3,
        17
      ],
      [
        6,
        26
      ],
      [
        -2,
        13
      ],
      [
        3,
        23
      ],
      [
        5,
        8
      ]
    ],
    [
      [
        28526,
        58689
      ],
      [
        4,
        7
      ],
      [
        4,
        20
      ],
      [
        3,
        34
      ],
      [
        5,
        6
      ],
      [
        3,
        26
      ]
    ],
    [
      [
        28545,
        58782
      ],
      [
        5,
        -11
      ],
      [
        2,
        -2
      ],
      [
        2,
        2
      ],
      [
        14,
        2
      ],
      [
        1,
        3
      ],
      [
        5,
        3
      ],
      [
        16,
        2
      ],
      [
        6,
        7
      ],
      [
        3,
        6
      ],
      [
        6,
        7
      ],
      [
        4,
        11
      ],
      [
        18,
        16
      ],
      [
        2,
        -5
      ],
      [
        2,
        -10
      ],
      [
        0,
        -10
      ],
      [
        5,
        -21
      ]
    ],
    [
      [
        28636,
        58782
      ],
      [
        -1,
        -17
      ],
      [
        -3,
        -18
      ],
      [
        3,
        -37
      ],
      [
        4,
        -25
      ],
      [
        -15,
        -87
      ],
      [
        0,
        -104
      ]
    ],
    [
      [
        28624,
        58494
      ],
      [
        -39,
        9
      ],
      [
        -25,
        0
      ]
    ],
    [
      [
        28560,
        58503
      ],
      [
        -58,
        1
      ],
      [
        -1,
        16
      ]
    ],
    [
      [
        27290,
        61789
      ],
      [
        18,
        44
      ],
      [
        13,
        54
      ]
    ],
    [
      [
        27321,
        61887
      ],
      [
        15,
        65
      ]
    ],
    [
      [
        27336,
        61952
      ],
      [
        15,
        -50
      ],
      [
        2,
        -37
      ],
      [
        4,
        -1
      ],
      [
        8,
        -15
      ],
      [
        4,
        -18
      ],
      [
        -2,
        -22
      ],
      [
        8,
        -9
      ],
      [
        3,
        -35
      ]
    ],
    [
      [
        27378,
        61765
      ],
      [
        4,
        -8
      ],
      [
        11,
        -7
      ],
      [
        2,
        -18
      ],
      [
        -26,
        -75
      ],
      [
        -36,
        -72
      ],
      [
        -16,
        -31
      ],
      [
        -37,
        -73
      ]
    ],
    [
      [
        27280,
        61481
      ],
      [
        -3,
        59
      ],
      [
        -3,
        68
      ],
      [
        -8,
        112
      ],
      [
        0,
        5
      ],
      [
        24,
        64
      ]
    ],
    [
      [
        19847,
        69324
      ],
      [
        95,
        0
      ],
      [
        22,
        1
      ],
      [
        39,
        0
      ],
      [
        60,
        -2
      ],
      [
        3,
        -1
      ],
      [
        5,
        -1
      ],
      [
        6,
        -2
      ],
      [
        27,
        0
      ],
      [
        27,
        -1
      ],
      [
        1,
        0
      ],
      [
        89,
        -1
      ],
      [
        85,
        -1
      ]
    ],
    [
      [
        20372,
        69316
      ],
      [
        1,
        -146
      ],
      [
        2,
        -13
      ],
      [
        0,
        -175
      ],
      [
        1,
        -16
      ],
      [
        0,
        -67
      ],
      [
        1,
        -84
      ]
    ],
    [
      [
        19998,
        68811
      ],
      [
        0,
        1
      ],
      [
        -1,
        10
      ],
      [
        -1,
        10
      ],
      [
        0,
        5
      ],
      [
        -2,
        5
      ],
      [
        0,
        8
      ],
      [
        -3,
        4
      ],
      [
        -2,
        3
      ],
      [
        -2,
        0
      ],
      [
        -3,
        1
      ],
      [
        -1,
        5
      ],
      [
        0,
        6
      ],
      [
        -2,
        2
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        2
      ],
      [
        -2,
        2
      ],
      [
        -2,
        4
      ],
      [
        -2,
        1
      ],
      [
        -2,
        12
      ],
      [
        -2,
        6
      ],
      [
        -1,
        9
      ],
      [
        -2,
        6
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -8
      ],
      [
        -3,
        1
      ],
      [
        -2,
        6
      ],
      [
        0,
        15
      ],
      [
        2,
        4
      ],
      [
        0,
        7
      ],
      [
        -1,
        2
      ],
      [
        -1,
        4
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        5
      ],
      [
        0,
        4
      ],
      [
        -3,
        8
      ],
      [
        -4,
        4
      ],
      [
        -4,
        7
      ],
      [
        -2,
        5
      ],
      [
        -4,
        3
      ],
      [
        -3,
        2
      ],
      [
        -2,
        -6
      ],
      [
        -3,
        -1
      ],
      [
        -3,
        1
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        0
      ],
      [
        -2,
        1
      ],
      [
        -1,
        6
      ],
      [
        -2,
        5
      ],
      [
        1,
        11
      ],
      [
        -2,
        6
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        3
      ],
      [
        -3,
        3
      ],
      [
        -3,
        6
      ],
      [
        -2,
        -1
      ],
      [
        -3,
        1
      ],
      [
        -1,
        6
      ],
      [
        0,
        5
      ],
      [
        1,
        3
      ],
      [
        0,
        27
      ],
      [
        -1,
        6
      ],
      [
        -1,
        3
      ],
      [
        0,
        8
      ],
      [
        -4,
        9
      ],
      [
        -5,
        2
      ],
      [
        -3,
        6
      ],
      [
        -1,
        4
      ],
      [
        -6,
        8
      ],
      [
        -3,
        7
      ],
      [
        1,
        6
      ],
      [
        1,
        4
      ],
      [
        2,
        8
      ],
      [
        0,
        10
      ],
      [
        -2,
        1
      ],
      [
        0,
        5
      ],
      [
        -1,
        0
      ],
      [
        0,
        12
      ],
      [
        -1,
        8
      ],
      [
        0,
        3
      ],
      [
        -2,
        3
      ],
      [
        -2,
        15
      ],
      [
        -2,
        5
      ],
      [
        -2,
        3
      ],
      [
        -1,
        10
      ],
      [
        1,
        6
      ],
      [
        0,
        14
      ],
      [
        2,
        4
      ],
      [
        0,
        2
      ],
      [
        1,
        4
      ],
      [
        0,
        5
      ],
      [
        -1,
        7
      ],
      [
        -1,
        5
      ],
      [
        -4,
        10
      ],
      [
        -1,
        6
      ],
      [
        -2,
        11
      ],
      [
        1,
        12
      ],
      [
        0,
        23
      ],
      [
        -1,
        8
      ],
      [
        0,
        7
      ],
      [
        -1,
        6
      ],
      [
        -3,
        4
      ],
      [
        -3,
        5
      ],
      [
        -1,
        5
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        31468,
        38436
      ],
      [
        2,
        1
      ],
      [
        2,
        3
      ],
      [
        0,
        -2
      ],
      [
        1,
        -5
      ],
      [
        3,
        -6
      ],
      [
        3,
        -6
      ]
    ],
    [
      [
        31476,
        38395
      ],
      [
        -1,
        -12
      ],
      [
        -4,
        -1
      ],
      [
        -3,
        -6
      ],
      [
        1,
        -30
      ]
    ],
    [
      [
        31469,
        38346
      ],
      [
        -11,
        14
      ],
      [
        -5,
        -8
      ]
    ],
    [
      [
        31453,
        38352
      ],
      [
        -3,
        39
      ],
      [
        2,
        32
      ],
      [
        7,
        -1
      ],
      [
        9,
        14
      ]
    ],
    [
      [
        31221,
        38068
      ],
      [
        1,
        20
      ],
      [
        9,
        8
      ]
    ],
    [
      [
        31250,
        37954
      ],
      [
        -7,
        9
      ],
      [
        -8,
        -2
      ],
      [
        -9,
        9
      ],
      [
        -11,
        -11
      ]
    ],
    [
      [
        28997,
        65367
      ],
      [
        0,
        -3
      ],
      [
        1,
        -5
      ],
      [
        1,
        -5
      ],
      [
        2,
        -3
      ],
      [
        2,
        -5
      ],
      [
        1,
        -10
      ],
      [
        1,
        -6
      ],
      [
        1,
        -3
      ],
      [
        1,
        -3
      ],
      [
        1,
        0
      ],
      [
        0,
        -1
      ],
      [
        3,
        -14
      ],
      [
        1,
        -6
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -7
      ],
      [
        1,
        -1
      ],
      [
        1,
        -1
      ],
      [
        1,
        -1
      ],
      [
        1,
        -3
      ],
      [
        2,
        -5
      ],
      [
        1,
        -4
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -8
      ],
      [
        1,
        -1
      ],
      [
        2,
        2
      ],
      [
        2,
        0
      ],
      [
        0,
        -3
      ],
      [
        1,
        -6
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -6
      ],
      [
        1,
        -4
      ],
      [
        0,
        -1
      ],
      [
        3,
        -3
      ],
      [
        4,
        -1
      ],
      [
        0,
        1
      ],
      [
        3,
        4
      ],
      [
        0,
        3
      ],
      [
        1,
        1
      ],
      [
        3,
        -2
      ],
      [
        1,
        -5
      ],
      [
        1,
        -1
      ],
      [
        2,
        0
      ],
      [
        1,
        -2
      ],
      [
        1,
        -3
      ],
      [
        1,
        -5
      ],
      [
        0,
        -9
      ],
      [
        1,
        -1
      ],
      [
        2,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -7
      ],
      [
        1,
        -1
      ],
      [
        1,
        -1
      ],
      [
        3,
        2
      ],
      [
        4,
        5
      ],
      [
        2,
        0
      ],
      [
        1,
        -1
      ],
      [
        1,
        -4
      ],
      [
        1,
        -3
      ],
      [
        3,
        -7
      ],
      [
        0,
        -1
      ],
      [
        2,
        0
      ],
      [
        1,
        1
      ],
      [
        0,
        6
      ],
      [
        2,
        4
      ],
      [
        1,
        3
      ],
      [
        2,
        0
      ],
      [
        0,
        -1
      ],
      [
        1,
        -4
      ],
      [
        1,
        -3
      ],
      [
        0,
        -5
      ],
      [
        1,
        -9
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        2,
        0
      ],
      [
        2,
        4
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        2,
        -3
      ],
      [
        1,
        -1
      ],
      [
        1,
        2
      ]
    ],
    [
      [
        29101,
        65083
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        -6
      ],
      [
        -3,
        -2
      ],
      [
        -1,
        1
      ],
      [
        -5,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -10
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        1,
        -5
      ],
      [
        0,
        -4
      ],
      [
        -4,
        -8
      ],
      [
        -2,
        -6
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        -8
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -11
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -6
      ],
      [
        2,
        -6
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -10
      ],
      [
        -2,
        -12
      ],
      [
        -1,
        -10
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -8
      ],
      [
        -2,
        -8
      ],
      [
        -3,
        -9
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -7
      ],
      [
        -5,
        -20
      ],
      [
        -3,
        -6
      ],
      [
        -4,
        -5
      ],
      [
        0,
        -6
      ],
      [
        -5,
        -11
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        -19
      ]
    ],
    [
      [
        29018,
        64774
      ],
      [
        -10,
        -14
      ],
      [
        -3,
        10
      ],
      [
        -10,
        61
      ],
      [
        -22,
        11
      ],
      [
        5,
        79
      ],
      [
        2,
        39
      ],
      [
        -50,
        -11
      ],
      [
        -14,
        -4
      ]
    ],
    [
      [
        28916,
        64945
      ],
      [
        5,
        18
      ],
      [
        -2,
        13
      ],
      [
        4,
        5
      ],
      [
        6,
        50
      ],
      [
        0,
        22
      ],
      [
        -7,
        15
      ],
      [
        -4,
        27
      ],
      [
        4,
        10
      ],
      [
        4,
        -12
      ],
      [
        4,
        10
      ],
      [
        3,
        -9
      ],
      [
        9,
        6
      ],
      [
        3,
        17
      ],
      [
        1,
        30
      ],
      [
        3,
        10
      ],
      [
        6,
        3
      ],
      [
        9,
        22
      ],
      [
        0,
        18
      ],
      [
        5,
        20
      ],
      [
        28,
        147
      ]
    ],
    [
      [
        26287,
        62172
      ],
      [
        4,
        3
      ],
      [
        8,
        -33
      ],
      [
        19,
        -47
      ],
      [
        7,
        -16
      ]
    ],
    [
      [
        26325,
        62079
      ],
      [
        -34,
        -14
      ],
      [
        -1,
        -52
      ]
    ],
    [
      [
        26223,
        62062
      ],
      [
        4,
        5
      ],
      [
        3,
        9
      ],
      [
        1,
        3
      ],
      [
        2,
        2
      ],
      [
        3,
        1
      ],
      [
        4,
        -2
      ],
      [
        5,
        -3
      ],
      [
        1,
        0
      ],
      [
        3,
        3
      ],
      [
        5,
        7
      ],
      [
        3,
        8
      ],
      [
        3,
        3
      ],
      [
        1,
        2
      ],
      [
        9,
        -6
      ],
      [
        2,
        -2
      ],
      [
        4,
        -5
      ],
      [
        2,
        -1
      ],
      [
        2,
        0
      ],
      [
        2,
        2
      ],
      [
        0,
        5
      ],
      [
        1,
        4
      ],
      [
        -1,
        9
      ],
      [
        -1,
        6
      ],
      [
        -3,
        15
      ],
      [
        -1,
        8
      ],
      [
        0,
        6
      ],
      [
        1,
        5
      ],
      [
        1,
        5
      ],
      [
        2,
        5
      ],
      [
        4,
        9
      ],
      [
        2,
        7
      ]
    ],
    [
      [
        27804,
        58285
      ],
      [
        4,
        -23
      ],
      [
        -7,
        -33
      ],
      [
        9,
        -35
      ],
      [
        0,
        -19
      ],
      [
        11,
        -27
      ],
      [
        7,
        -64
      ],
      [
        23,
        -44
      ]
    ],
    [
      [
        27851,
        58040
      ],
      [
        -11,
        -46
      ],
      [
        8,
        -20
      ],
      [
        8,
        -11
      ],
      [
        3,
        -31
      ],
      [
        16,
        -26
      ]
    ],
    [
      [
        27874,
        57885
      ],
      [
        -7,
        -9
      ],
      [
        -2,
        13
      ],
      [
        -3,
        -10
      ],
      [
        -7,
        14
      ],
      [
        -2,
        14
      ],
      [
        -10,
        1
      ],
      [
        -5,
        19
      ],
      [
        -5,
        3
      ],
      [
        -3,
        -11
      ],
      [
        -7,
        -9
      ],
      [
        -8,
        -26
      ],
      [
        -7,
        -14
      ],
      [
        -34,
        -137
      ]
    ],
    [
      [
        27731,
        57873
      ],
      [
        -12,
        30
      ],
      [
        -5,
        65
      ],
      [
        -9,
        21
      ],
      [
        -2,
        14
      ],
      [
        1,
        30
      ],
      [
        -12,
        166
      ],
      [
        -3,
        37
      ],
      [
        -1,
        42
      ]
    ],
    [
      [
        27805,
        57494
      ],
      [
        36,
        -4
      ],
      [
        7,
        -1
      ],
      [
        2,
        6
      ],
      [
        21,
        66
      ],
      [
        20,
        66
      ]
    ],
    [
      [
        27938,
        57083
      ],
      [
        -7,
        -27
      ],
      [
        -6,
        -10
      ],
      [
        -5,
        2
      ],
      [
        -7,
        -14
      ],
      [
        -3,
        -18
      ],
      [
        0,
        -35
      ],
      [
        -8,
        -7
      ],
      [
        -3,
        -12
      ],
      [
        2,
        -21
      ],
      [
        -2,
        -13
      ],
      [
        -4,
        0
      ],
      [
        -6,
        -48
      ],
      [
        -2,
        5
      ],
      [
        -5,
        -18
      ]
    ],
    [
      [
        27776,
        57241
      ],
      [
        -2,
        9
      ],
      [
        -1,
        2
      ]
    ],
    [
      [
        22794,
        52331
      ],
      [
        23,
        -47
      ],
      [
        14,
        -29
      ],
      [
        12,
        -31
      ],
      [
        21,
        -60
      ],
      [
        16,
        -242
      ]
    ],
    [
      [
        23323,
        53094
      ],
      [
        78,
        225
      ],
      [
        55,
        157
      ]
    ],
    [
      [
        23456,
        53476
      ],
      [
        -1,
        -24
      ],
      [
        2,
        -9
      ],
      [
        -2,
        -11
      ],
      [
        4,
        -12
      ],
      [
        10,
        -2
      ],
      [
        3,
        -11
      ],
      [
        -1,
        -16
      ],
      [
        2,
        -25
      ],
      [
        3,
        4
      ],
      [
        2,
        -14
      ],
      [
        -3,
        -8
      ],
      [
        -3,
        -22
      ],
      [
        7,
        -9
      ],
      [
        4,
        -17
      ],
      [
        -1,
        -40
      ],
      [
        4,
        -26
      ],
      [
        0,
        -28
      ],
      [
        2,
        -9
      ]
    ],
    [
      [
        23488,
        53197
      ],
      [
        -27,
        -122
      ],
      [
        -73,
        -253
      ]
    ],
    [
      [
        27372,
        59500
      ],
      [
        18,
        -3
      ]
    ],
    [
      [
        27390,
        59497
      ],
      [
        9,
        2
      ],
      [
        9,
        0
      ],
      [
        12,
        2
      ],
      [
        7,
        0
      ],
      [
        14,
        -4
      ],
      [
        8,
        -1
      ],
      [
        4,
        0
      ]
    ],
    [
      [
        27453,
        59496
      ],
      [
        47,
        -9
      ]
    ],
    [
      [
        27354,
        59314
      ],
      [
        5,
        20
      ],
      [
        -7,
        40
      ],
      [
        13,
        56
      ],
      [
        2,
        45
      ],
      [
        5,
        25
      ]
    ],
    [
      [
        20923,
        73979
      ],
      [
        55,
        0
      ],
      [
        133,
        -1
      ],
      [
        5,
        1
      ],
      [
        116,
        0
      ]
    ],
    [
      [
        21232,
        73979
      ],
      [
        0,
        -325
      ],
      [
        15,
        0
      ],
      [
        0,
        -102
      ]
    ],
    [
      [
        20923,
        73553
      ],
      [
        0,
        426
      ]
    ],
    [
      [
        31571,
        38386
      ],
      [
        4,
        -15
      ],
      [
        3,
        0
      ],
      [
        3,
        14
      ],
      [
        1,
        -4
      ],
      [
        0,
        -1
      ],
      [
        2,
        -6
      ],
      [
        2,
        1
      ],
      [
        1,
        -1
      ],
      [
        1,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        2,
        -9
      ],
      [
        4,
        -15
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        31593,
        38341
      ],
      [
        -5,
        -21
      ],
      [
        4,
        -29
      ],
      [
        -2,
        -41
      ],
      [
        1,
        -18
      ]
    ],
    [
      [
        31591,
        38232
      ],
      [
        -2,
        -13
      ]
    ],
    [
      [
        31589,
        38219
      ],
      [
        -5,
        16
      ],
      [
        -3,
        3
      ],
      [
        0,
        -8
      ],
      [
        -5,
        1
      ],
      [
        -3,
        -20
      ]
    ],
    [
      [
        31573,
        38211
      ],
      [
        -4,
        3
      ]
    ],
    [
      [
        27401,
        55560
      ],
      [
        2,
        5
      ]
    ],
    [
      [
        27546,
        54792
      ],
      [
        0,
        -1
      ],
      [
        -16,
        -44
      ],
      [
        -1,
        0
      ],
      [
        -2,
        14
      ],
      [
        -5,
        7
      ],
      [
        -5,
        -12
      ],
      [
        -2,
        -9
      ],
      [
        -1,
        -4
      ],
      [
        -6,
        -5
      ],
      [
        -1,
        2
      ],
      [
        0,
        4
      ],
      [
        -1,
        18
      ],
      [
        0,
        2
      ],
      [
        -1,
        6
      ],
      [
        -4,
        6
      ],
      [
        -4,
        -7
      ],
      [
        -4,
        -2
      ],
      [
        -1,
        2
      ],
      [
        -2,
        -14
      ]
    ],
    [
      [
        26005,
        59000
      ],
      [
        6,
        -34
      ],
      [
        5,
        -9
      ],
      [
        -2,
        -19
      ],
      [
        2,
        -10
      ],
      [
        4,
        -2
      ],
      [
        2,
        11
      ],
      [
        7,
        5
      ],
      [
        10,
        -20
      ],
      [
        5,
        -41
      ],
      [
        4,
        -20
      ],
      [
        2,
        3
      ]
    ],
    [
      [
        26050,
        58864
      ],
      [
        4,
        -10
      ],
      [
        -9,
        -41
      ],
      [
        3,
        -77
      ],
      [
        -4,
        -25
      ],
      [
        6,
        7
      ],
      [
        2,
        -9
      ],
      [
        -9,
        -30
      ],
      [
        10,
        -3
      ],
      [
        1,
        -7
      ],
      [
        -6,
        -23
      ],
      [
        -8,
        4
      ]
    ],
    [
      [
        25983,
        58660
      ],
      [
        -1,
        21
      ],
      [
        -7,
        25
      ],
      [
        -23,
        86
      ],
      [
        -5,
        9
      ]
    ],
    [
      [
        25947,
        58801
      ],
      [
        -3,
        44
      ],
      [
        -4,
        12
      ],
      [
        1,
        26
      ],
      [
        -4,
        14
      ],
      [
        1,
        16
      ],
      [
        -4,
        15
      ],
      [
        1,
        19
      ]
    ],
    [
      [
        22718,
        53710
      ],
      [
        7,
        13
      ],
      [
        85,
        171
      ]
    ],
    [
      [
        28547,
        57639
      ],
      [
        14,
        31
      ],
      [
        13,
        2
      ],
      [
        6,
        8
      ],
      [
        7,
        3
      ],
      [
        10,
        8
      ],
      [
        2,
        5
      ],
      [
        2,
        6
      ],
      [
        0,
        20
      ],
      [
        3,
        21
      ],
      [
        1,
        21
      ],
      [
        2,
        6
      ],
      [
        1,
        1
      ],
      [
        8,
        -21
      ],
      [
        1,
        -11
      ],
      [
        0,
        -21
      ],
      [
        2,
        -34
      ],
      [
        5,
        -17
      ],
      [
        2,
        -12
      ],
      [
        1,
        -2
      ],
      [
        18,
        -5
      ],
      [
        2,
        7
      ],
      [
        -1,
        12
      ],
      [
        -6,
        35
      ],
      [
        -3,
        11
      ],
      [
        -1,
        6
      ],
      [
        0,
        4
      ],
      [
        3,
        -2
      ],
      [
        10,
        -15
      ],
      [
        7,
        -12
      ],
      [
        1,
        -5
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -12
      ],
      [
        2,
        -9
      ],
      [
        4,
        -9
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -17
      ],
      [
        -2,
        -3
      ],
      [
        -7,
        -31
      ],
      [
        -3,
        -15
      ],
      [
        -4,
        -18
      ],
      [
        -3,
        -11
      ],
      [
        -6,
        0
      ],
      [
        -3,
        -6
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        2
      ],
      [
        -2,
        11
      ],
      [
        -3,
        -6
      ],
      [
        0,
        -34
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        6
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -14
      ],
      [
        -4,
        -4
      ],
      [
        -3,
        -35
      ],
      [
        -3,
        -17
      ],
      [
        -4,
        -18
      ],
      [
        -4,
        -14
      ],
      [
        1,
        -13
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        -10
      ],
      [
        -2,
        -16
      ],
      [
        -2,
        -29
      ],
      [
        -17,
        20
      ],
      [
        1,
        80
      ],
      [
        -6,
        23
      ],
      [
        -4,
        -4
      ],
      [
        1,
        -82
      ],
      [
        -16,
        1
      ],
      [
        0,
        -8
      ],
      [
        42,
        -64
      ],
      [
        22,
        109
      ],
      [
        1,
        14
      ],
      [
        2,
        8
      ],
      [
        5,
        16
      ],
      [
        3,
        14
      ],
      [
        6,
        20
      ],
      [
        3,
        10
      ],
      [
        2,
        9
      ],
      [
        6,
        21
      ],
      [
        6,
        22
      ],
      [
        13,
        42
      ],
      [
        11,
        33
      ],
      [
        11,
        43
      ],
      [
        10,
        33
      ],
      [
        13,
        50
      ],
      [
        5,
        17
      ],
      [
        7,
        31
      ],
      [
        1,
        2
      ],
      [
        6,
        -8
      ],
      [
        2,
        -6
      ],
      [
        0,
        -7
      ],
      [
        -10,
        -33
      ],
      [
        -18,
        -50
      ],
      [
        -26,
        -96
      ],
      [
        -22,
        -62
      ],
      [
        -21,
        -78
      ],
      [
        -18,
        -82
      ],
      [
        -12,
        -61
      ],
      [
        -9,
        -54
      ],
      [
        -3,
        -32
      ],
      [
        -5,
        32
      ],
      [
        0,
        15
      ],
      [
        1,
        3
      ],
      [
        0,
        17
      ],
      [
        -8,
        17
      ],
      [
        -11,
        14
      ],
      [
        -7,
        6
      ],
      [
        -5,
        9
      ],
      [
        -4,
        9
      ],
      [
        -5,
        -1
      ],
      [
        -9,
        5
      ],
      [
        -12,
        0
      ],
      [
        -13,
        -3
      ],
      [
        -25,
        -13
      ],
      [
        -23,
        -15
      ],
      [
        -12,
        -10
      ],
      [
        -21,
        -24
      ]
    ],
    [
      [
        22162,
        53599
      ],
      [
        8,
        2
      ],
      [
        10,
        -12
      ],
      [
        2,
        -27
      ],
      [
        5,
        -42
      ],
      [
        5,
        23
      ],
      [
        6,
        -26
      ],
      [
        1,
        10
      ],
      [
        9,
        18
      ],
      [
        -3,
        5
      ],
      [
        1,
        29
      ],
      [
        7,
        -16
      ],
      [
        5,
        -1
      ],
      [
        -1,
        -17
      ],
      [
        10,
        -9
      ],
      [
        3,
        -8
      ],
      [
        3,
        14
      ],
      [
        0,
        -21
      ],
      [
        9,
        -18
      ],
      [
        3,
        27
      ],
      [
        4,
        -5
      ],
      [
        0,
        15
      ],
      [
        5,
        6
      ],
      [
        0,
        9
      ],
      [
        9,
        33
      ],
      [
        10,
        -18
      ]
    ],
    [
      [
        22304,
        53563
      ],
      [
        0,
        -606
      ]
    ],
    [
      [
        26397,
        65488
      ],
      [
        1,
        -103
      ],
      [
        4,
        0
      ],
      [
        1,
        -120
      ],
      [
        10,
        0
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        26413,
        65232
      ],
      [
        0,
        -68
      ]
    ],
    [
      [
        26285,
        65163
      ],
      [
        0,
        72
      ],
      [
        -1,
        14
      ],
      [
        0,
        35
      ]
    ],
    [
      [
        26284,
        65284
      ],
      [
        0,
        193
      ]
    ],
    [
      [
        23200,
        50965
      ],
      [
        9,
        34
      ],
      [
        -1,
        5
      ]
    ],
    [
      [
        23208,
        51004
      ],
      [
        14,
        52
      ],
      [
        4,
        -13
      ],
      [
        8,
        33
      ],
      [
        23,
        -29
      ],
      [
        5,
        -10
      ],
      [
        3,
        6
      ],
      [
        5,
        -4
      ],
      [
        -1,
        19
      ],
      [
        6,
        25
      ],
      [
        4,
        -4
      ],
      [
        4,
        15
      ],
      [
        -1,
        24
      ],
      [
        4,
        34
      ],
      [
        5,
        6
      ],
      [
        1,
        15
      ],
      [
        -3,
        20
      ],
      [
        2,
        15
      ],
      [
        24,
        1
      ],
      [
        4,
        53
      ],
      [
        1,
        17
      ],
      [
        0,
        13
      ],
      [
        2,
        26
      ],
      [
        4,
        55
      ]
    ],
    [
      [
        23326,
        51373
      ],
      [
        13,
        10
      ],
      [
        9,
        -3
      ],
      [
        4,
        15
      ],
      [
        9,
        -3
      ],
      [
        3,
        2
      ],
      [
        7,
        -6
      ],
      [
        0,
        -3
      ],
      [
        2,
        -42
      ],
      [
        5,
        8
      ],
      [
        6,
        -6
      ]
    ],
    [
      [
        23384,
        51345
      ],
      [
        -5,
        -105
      ],
      [
        11,
        -71
      ],
      [
        21,
        -127
      ],
      [
        17,
        -108
      ]
    ],
    [
      [
        23428,
        50934
      ],
      [
        -12,
        -34
      ],
      [
        -3,
        26
      ],
      [
        -7,
        -1
      ],
      [
        -6,
        -7
      ],
      [
        1,
        -44
      ],
      [
        -2,
        -21
      ],
      [
        -1,
        -23
      ],
      [
        6,
        -26
      ],
      [
        11,
        37
      ]
    ],
    [
      [
        23415,
        50841
      ],
      [
        -7,
        -43
      ],
      [
        1,
        -6
      ],
      [
        2,
        -3
      ]
    ],
    [
      [
        23411,
        50789
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -8
      ],
      [
        -18,
        -51
      ],
      [
        -14,
        -40
      ],
      [
        -9,
        -32
      ],
      [
        -7,
        -31
      ],
      [
        0,
        -1
      ],
      [
        -3,
        -7
      ],
      [
        -12,
        -35
      ],
      [
        -7,
        -25
      ],
      [
        -2,
        -12
      ],
      [
        -9,
        -8
      ],
      [
        -6,
        0
      ],
      [
        -14,
        -27
      ],
      [
        -5,
        -12
      ]
    ],
    [
      [
        27377,
        63688
      ],
      [
        33,
        -5
      ],
      [
        17,
        3
      ]
    ],
    [
      [
        27427,
        63686
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -16
      ],
      [
        1,
        -8
      ],
      [
        0,
        -19
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        -5,
        -12
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -5
      ],
      [
        1,
        -8
      ],
      [
        0,
        -6
      ],
      [
        1,
        -1
      ],
      [
        0,
        -30
      ]
    ],
    [
      [
        27394,
        63328
      ],
      [
        -54,
        10
      ],
      [
        0,
        2
      ],
      [
        -62,
        9
      ]
    ],
    [
      [
        27278,
        63349
      ],
      [
        1,
        97
      ]
    ],
    [
      [
        26546,
        62626
      ],
      [
        9,
        -1
      ],
      [
        -1,
        -26
      ],
      [
        7,
        -1
      ],
      [
        3,
        10
      ],
      [
        5,
        37
      ],
      [
        54,
        134
      ]
    ],
    [
      [
        26623,
        62779
      ],
      [
        60,
        -1
      ]
    ],
    [
      [
        26683,
        62778
      ],
      [
        0,
        -35
      ],
      [
        -3,
        -32
      ],
      [
        2,
        -34
      ],
      [
        -4,
        -27
      ],
      [
        3,
        -21
      ],
      [
        5,
        -10
      ],
      [
        5,
        11
      ],
      [
        1,
        -20
      ],
      [
        -3,
        -41
      ]
    ],
    [
      [
        26689,
        62569
      ],
      [
        -9,
        -166
      ]
    ],
    [
      [
        26680,
        62403
      ],
      [
        -63,
        -42
      ],
      [
        -17,
        1
      ]
    ],
    [
      [
        26600,
        62362
      ],
      [
        -9,
        1
      ],
      [
        -47,
        0
      ],
      [
        1,
        40
      ],
      [
        1,
        223
      ]
    ],
    [
      [
        26671,
        65387
      ],
      [
        1,
        -138
      ]
    ],
    [
      [
        26670,
        64962
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        26542,
        64862
      ],
      [
        -1,
        287
      ]
    ],
    [
      [
        25282,
        68443
      ],
      [
        14,
        0
      ],
      [
        18,
        -1
      ],
      [
        5,
        0
      ],
      [
        22,
        -1
      ]
    ],
    [
      [
        25341,
        68441
      ],
      [
        41,
        -2
      ]
    ],
    [
      [
        25383,
        68033
      ],
      [
        -34,
        0
      ]
    ],
    [
      [
        25349,
        68033
      ],
      [
        0,
        53
      ],
      [
        -34,
        0
      ],
      [
        -33,
        1
      ]
    ],
    [
      [
        25282,
        68087
      ],
      [
        0,
        356
      ]
    ],
    [
      [
        28269,
        64352
      ],
      [
        8,
        18
      ],
      [
        17,
        19
      ],
      [
        43,
        73
      ],
      [
        19,
        26
      ],
      [
        1,
        1
      ]
    ],
    [
      [
        28357,
        64489
      ],
      [
        2,
        -3
      ],
      [
        1,
        -44
      ]
    ],
    [
      [
        28360,
        64442
      ],
      [
        0,
        -123
      ],
      [
        19,
        -9
      ]
    ],
    [
      [
        28249,
        63943
      ],
      [
        -2,
        -11
      ],
      [
        -14,
        0
      ],
      [
        -2,
        -10
      ],
      [
        -6,
        10
      ],
      [
        -5,
        -4
      ],
      [
        -8,
        30
      ],
      [
        -8,
        9
      ],
      [
        25,
        109
      ],
      [
        -5,
        67
      ],
      [
        6,
        34
      ],
      [
        9,
        38
      ],
      [
        10,
        24
      ],
      [
        20,
        58
      ],
      [
        -6,
        -3
      ],
      [
        1,
        29
      ],
      [
        6,
        14
      ],
      [
        -1,
        15
      ]
    ],
    [
      [
        22050,
        59537
      ],
      [
        111,
        -1
      ]
    ],
    [
      [
        22223,
        59038
      ],
      [
        0,
        -177
      ]
    ],
    [
      [
        22223,
        58861
      ],
      [
        -11,
        -1
      ],
      [
        -9,
        -8
      ],
      [
        -6,
        -22
      ],
      [
        -6,
        -8
      ],
      [
        -5,
        -62
      ],
      [
        -10,
        -30
      ],
      [
        -2,
        -40
      ],
      [
        -12,
        -11
      ],
      [
        -5,
        -16
      ],
      [
        -9,
        9
      ],
      [
        -7,
        1
      ],
      [
        -11,
        10
      ],
      [
        -8,
        26
      ],
      [
        -4,
        -1
      ],
      [
        -5,
        8
      ],
      [
        -1,
        10
      ],
      [
        -6,
        16
      ],
      [
        -2,
        22
      ],
      [
        0,
        36
      ],
      [
        2,
        13
      ],
      [
        -2,
        33
      ],
      [
        -8,
        8
      ],
      [
        -5,
        -3
      ],
      [
        -5,
        -19
      ],
      [
        -4,
        0
      ],
      [
        -5,
        -24
      ],
      [
        -2,
        -14
      ],
      [
        2,
        -21
      ],
      [
        -5,
        -27
      ],
      [
        -10,
        -16
      ],
      [
        -3,
        -13
      ],
      [
        -8,
        -9
      ]
    ],
    [
      [
        22050,
        59428
      ],
      [
        0,
        109
      ]
    ],
    [
      [
        21754,
        68153
      ],
      [
        5,
        0
      ],
      [
        0,
        202
      ]
    ],
    [
      [
        21759,
        68355
      ],
      [
        190,
        0
      ]
    ],
    [
      [
        21957,
        67829
      ],
      [
        -2,
        5
      ],
      [
        -4,
        14
      ],
      [
        -2,
        4
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -7
      ],
      [
        -3,
        -4
      ],
      [
        -4,
        4
      ],
      [
        -2,
        3
      ],
      [
        -1,
        3
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -8
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        0
      ],
      [
        -4,
        7
      ],
      [
        -1,
        5
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -6
      ],
      [
        -3,
        1
      ],
      [
        -1,
        -1
      ],
      [
        1,
        5
      ],
      [
        0,
        10
      ],
      [
        -2,
        0
      ],
      [
        1,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        0
      ],
      [
        -1,
        6
      ],
      [
        -1,
        4
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -4
      ],
      [
        -3,
        0
      ],
      [
        -1,
        3
      ],
      [
        0,
        14
      ],
      [
        -3,
        1
      ],
      [
        -1,
        -5
      ],
      [
        -4,
        -4
      ],
      [
        -3,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        4
      ],
      [
        2,
        -2
      ],
      [
        1,
        5
      ],
      [
        0,
        4
      ],
      [
        -1,
        4
      ],
      [
        -2,
        1
      ],
      [
        -4,
        2
      ],
      [
        -1,
        12
      ],
      [
        -2,
        4
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -9
      ],
      [
        -3,
        -8
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        -4
      ],
      [
        0,
        9
      ],
      [
        -1,
        4
      ],
      [
        -4,
        -1
      ],
      [
        -2,
        -6
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -5
      ],
      [
        2,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        -4
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        3
      ],
      [
        -2,
        4
      ],
      [
        1,
        2
      ],
      [
        0,
        4
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        1
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        3
      ],
      [
        0,
        4
      ],
      [
        -2,
        2
      ],
      [
        -2,
        -2
      ],
      [
        1,
        -4
      ],
      [
        2,
        -3
      ],
      [
        0,
        -5
      ],
      [
        -2,
        1
      ],
      [
        -2,
        9
      ],
      [
        -2,
        3
      ],
      [
        0,
        5
      ],
      [
        2,
        3
      ],
      [
        0,
        7
      ],
      [
        -1,
        3
      ]
    ],
    [
      [
        21843,
        67852
      ],
      [
        0,
        0
      ]
    ],
    [
      [
        21843,
        67852
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        4
      ],
      [
        -1,
        -3
      ],
      [
        1,
        0
      ],
      [
        0,
        -6
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        -4,
        -9
      ],
      [
        -2,
        1
      ],
      [
        0,
        3
      ],
      [
        2,
        1
      ],
      [
        0,
        3
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        3
      ],
      [
        1,
        0
      ],
      [
        1,
        4
      ],
      [
        -1,
        3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        2
      ],
      [
        -1,
        3
      ],
      [
        1,
        4
      ],
      [
        1,
        -1
      ],
      [
        1,
        3
      ],
      [
        -1,
        5
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        6
      ],
      [
        0,
        3
      ],
      [
        -2,
        5
      ],
      [
        -2,
        2
      ],
      [
        -3,
        1
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -3
      ],
      [
        -1,
        0
      ],
      [
        0,
        3
      ],
      [
        -2,
        7
      ],
      [
        -2,
        13
      ],
      [
        -1,
        5
      ],
      [
        -3,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        2
      ],
      [
        0,
        6
      ],
      [
        1,
        7
      ],
      [
        0,
        6
      ],
      [
        -2,
        4
      ],
      [
        -1,
        -7
      ],
      [
        -4,
        -3
      ],
      [
        0,
        4
      ],
      [
        1,
        0
      ],
      [
        -1,
        5
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        4
      ],
      [
        1,
        5
      ],
      [
        1,
        -2
      ],
      [
        2,
        0
      ],
      [
        0,
        4
      ],
      [
        -1,
        5
      ],
      [
        -2,
        0
      ],
      [
        -3,
        2
      ],
      [
        -1,
        11
      ],
      [
        -1,
        5
      ],
      [
        -3,
        3
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -10
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -2
      ],
      [
        0,
        2
      ],
      [
        -1,
        6
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        2
      ],
      [
        -1,
        6
      ],
      [
        0,
        4
      ],
      [
        1,
        3
      ],
      [
        2,
        -1
      ],
      [
        1,
        4
      ],
      [
        0,
        3
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        6
      ],
      [
        -2,
        6
      ],
      [
        0,
        5
      ],
      [
        -3,
        5
      ],
      [
        -1,
        -4
      ],
      [
        -3,
        -5
      ],
      [
        -2,
        1
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        1
      ],
      [
        0,
        6
      ],
      [
        1,
        2
      ],
      [
        0,
        7
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -5
      ]
    ],
    [
      [
        25479,
        59588
      ],
      [
        15,
        1
      ]
    ],
    [
      [
        25494,
        59589
      ],
      [
        14,
        -315
      ]
    ],
    [
      [
        25379,
        59425
      ],
      [
        1,
        3
      ],
      [
        2,
        5
      ],
      [
        1,
        8
      ],
      [
        1,
        4
      ],
      [
        0,
        14
      ],
      [
        1,
        6
      ],
      [
        0,
        24
      ],
      [
        -1,
        11
      ],
      [
        -1,
        13
      ],
      [
        0,
        13
      ],
      [
        -1,
        22
      ],
      [
        -3,
        32
      ],
      [
        0,
        6
      ],
      [
        -1,
        6
      ],
      [
        0,
        3
      ],
      [
        -2,
        9
      ],
      [
        -1,
        10
      ],
      [
        0,
        22
      ]
    ],
    [
      [
        21202,
        56314
      ],
      [
        0,
        95
      ],
      [
        1,
        46
      ],
      [
        0,
        416
      ]
    ],
    [
      [
        21203,
        56871
      ],
      [
        0,
        11
      ]
    ],
    [
      [
        21203,
        56882
      ],
      [
        119,
        0
      ]
    ],
    [
      [
        31375,
        37770
      ],
      [
        4,
        16
      ],
      [
        4,
        -2
      ],
      [
        0,
        -15
      ],
      [
        -4,
        -12
      ],
      [
        -4,
        -5
      ],
      [
        0,
        18
      ]
    ],
    [
      [
        31330,
        38045
      ],
      [
        5,
        0
      ],
      [
        2,
        26
      ]
    ],
    [
      [
        31337,
        38071
      ],
      [
        5,
        7
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        31373,
        37865
      ],
      [
        -11,
        -16
      ],
      [
        -1,
        -1
      ],
      [
        0,
        2
      ],
      [
        -2,
        7
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        -3,
        -2
      ],
      [
        -5,
        14
      ],
      [
        -2,
        2
      ],
      [
        -4,
        -3
      ],
      [
        -4,
        -6
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -2
      ],
      [
        -7,
        13
      ]
    ],
    [
      [
        31329,
        37867
      ],
      [
        3,
        16
      ],
      [
        -1,
        57
      ],
      [
        3,
        43
      ],
      [
        1,
        27
      ],
      [
        -5,
        35
      ]
    ],
    [
      [
        22094,
        57108
      ],
      [
        50,
        1
      ],
      [
        0,
        253
      ]
    ],
    [
      [
        22261,
        57475
      ],
      [
        9,
        5
      ],
      [
        9,
        39
      ],
      [
        3,
        -13
      ],
      [
        3,
        -1
      ],
      [
        4,
        2
      ],
      [
        0,
        -23
      ],
      [
        -2,
        -2
      ],
      [
        1,
        -35
      ],
      [
        -4,
        -6
      ],
      [
        -1,
        -22
      ],
      [
        4,
        -16
      ],
      [
        -6,
        -6
      ],
      [
        5,
        -36
      ],
      [
        -1,
        -16
      ],
      [
        3,
        -9
      ],
      [
        14,
        -8
      ],
      [
        13,
        7
      ],
      [
        4,
        -17
      ],
      [
        -2,
        -12
      ],
      [
        -14,
        -9
      ],
      [
        -2,
        -36
      ]
    ],
    [
      [
        22301,
        57261
      ],
      [
        6,
        -22
      ],
      [
        -2,
        -5
      ],
      [
        1,
        -28
      ],
      [
        -4,
        4
      ],
      [
        -6,
        -7
      ],
      [
        -3,
        4
      ],
      [
        -9,
        -4
      ],
      [
        -6,
        -30
      ],
      [
        2,
        -26
      ],
      [
        -5,
        3
      ],
      [
        -4,
        -48
      ],
      [
        -3,
        -8
      ],
      [
        0,
        -35
      ],
      [
        2,
        -10
      ],
      [
        -4,
        -5
      ],
      [
        1,
        -22
      ],
      [
        -1,
        -15
      ],
      [
        -3,
        6
      ],
      [
        1,
        -28
      ],
      [
        2,
        0
      ],
      [
        0,
        -16
      ],
      [
        4,
        9
      ],
      [
        1,
        -7
      ],
      [
        -3,
        -17
      ],
      [
        4,
        0
      ],
      [
        4,
        -23
      ],
      [
        -2,
        -17
      ],
      [
        -3,
        -4
      ]
    ],
    [
      [
        22271,
        56910
      ],
      [
        -1,
        4
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -2,
        1
      ],
      [
        0,
        4
      ],
      [
        -1,
        11
      ],
      [
        -1,
        10
      ],
      [
        -1,
        12
      ],
      [
        -2,
        4
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        0
      ],
      [
        -3,
        10
      ],
      [
        -1,
        4
      ],
      [
        0,
        3
      ],
      [
        3,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        16
      ],
      [
        -1,
        2
      ],
      [
        -7,
        11
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -4
      ],
      [
        -3,
        -3
      ],
      [
        0,
        1
      ],
      [
        -2,
        7
      ],
      [
        -1,
        9
      ],
      [
        -2,
        6
      ],
      [
        -2,
        4
      ],
      [
        -2,
        7
      ],
      [
        -2,
        6
      ],
      [
        0,
        5
      ],
      [
        1,
        4
      ],
      [
        0,
        2
      ],
      [
        -1,
        5
      ],
      [
        -3,
        3
      ],
      [
        -2,
        0
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        -17
      ],
      [
        -1,
        -21
      ],
      [
        0,
        -8
      ],
      [
        1,
        -2
      ],
      [
        0,
        -12
      ],
      [
        -1,
        -32
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -4,
        9
      ],
      [
        -3,
        -8
      ],
      [
        -2,
        1
      ],
      [
        -1,
        6
      ],
      [
        -3,
        10
      ],
      [
        -5,
        10
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        22197,
        56980
      ],
      [
        -3,
        1
      ],
      [
        -1,
        3
      ],
      [
        -1,
        5
      ],
      [
        -1,
        4
      ],
      [
        -1,
        2
      ],
      [
        -4,
        5
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -1
      ],
      [
        -5,
        2
      ],
      [
        -2,
        2
      ],
      [
        -2,
        3
      ],
      [
        -2,
        1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -10
      ],
      [
        -1,
        -11
      ],
      [
        1,
        -8
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        -3,
        -10
      ],
      [
        -1,
        -3
      ],
      [
        -6,
        -1
      ],
      [
        -2,
        3
      ],
      [
        -5,
        4
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        4
      ],
      [
        -2,
        2
      ],
      [
        -5,
        2
      ],
      [
        -4,
        7
      ],
      [
        -1,
        4
      ],
      [
        -1,
        4
      ],
      [
        1,
        4
      ],
      [
        -1,
        4
      ],
      [
        0,
        2
      ],
      [
        -1,
        4
      ],
      [
        -3,
        6
      ],
      [
        -3,
        4
      ],
      [
        -4,
        8
      ],
      [
        -3,
        10
      ],
      [
        0,
        9
      ],
      [
        -3,
        7
      ],
      [
        -2,
        1
      ],
      [
        -3,
        11
      ],
      [
        -5,
        26
      ],
      [
        -2,
        10
      ],
      [
        1,
        3
      ],
      [
        -2,
        11
      ],
      [
        -2,
        3
      ],
      [
        -4,
        8
      ]
    ],
    [
      [
        27025,
        57433
      ],
      [
        4,
        -9
      ],
      [
        5,
        -33
      ],
      [
        1,
        8
      ],
      [
        3,
        -14
      ],
      [
        4,
        0
      ],
      [
        2,
        -29
      ],
      [
        3,
        -5
      ],
      [
        -1,
        -13
      ],
      [
        4,
        -4
      ],
      [
        4,
        -19
      ],
      [
        8,
        -18
      ],
      [
        3,
        -9
      ],
      [
        9,
        -5
      ],
      [
        9,
        -24
      ],
      [
        3,
        -21
      ],
      [
        5,
        -17
      ],
      [
        4,
        -2
      ],
      [
        1,
        -13
      ],
      [
        3,
        7
      ],
      [
        5,
        -19
      ],
      [
        3,
        16
      ]
    ],
    [
      [
        27165,
        57139
      ],
      [
        -16,
        -94
      ],
      [
        -6,
        -3
      ],
      [
        -4,
        -23
      ],
      [
        -13,
        -76
      ],
      [
        -9,
        -21
      ],
      [
        -6,
        -5
      ],
      [
        -3,
        -22
      ],
      [
        -5,
        -8
      ],
      [
        -7,
        -16
      ],
      [
        -3,
        -47
      ],
      [
        -7,
        -50
      ],
      [
        -5,
        -19
      ]
    ],
    [
      [
        20924,
        70423
      ],
      [
        292,
        0
      ]
    ],
    [
      [
        21216,
        70423
      ],
      [
        15,
        0
      ]
    ],
    [
      [
        27261,
        62555
      ],
      [
        -5,
        -21
      ],
      [
        2,
        -12
      ],
      [
        -5,
        -8
      ],
      [
        8,
        -24
      ],
      [
        3,
        3
      ],
      [
        4,
        -29
      ],
      [
        3,
        -1
      ],
      [
        2,
        -41
      ],
      [
        -5,
        -15
      ],
      [
        6,
        -3
      ],
      [
        1,
        -25
      ],
      [
        6,
        -3
      ],
      [
        1,
        10
      ],
      [
        12,
        1
      ],
      [
        5,
        -13
      ]
    ],
    [
      [
        27299,
        62374
      ],
      [
        -31,
        -110
      ],
      [
        -1,
        -25
      ]
    ],
    [
      [
        27267,
        62239
      ],
      [
        -9,
        -7
      ],
      [
        -9,
        -14
      ],
      [
        -20,
        28
      ],
      [
        -9,
        25
      ],
      [
        -6,
        -17
      ],
      [
        -10,
        -11
      ]
    ],
    [
      [
        27204,
        62243
      ],
      [
        -9,
        31
      ],
      [
        -4,
        26
      ],
      [
        6,
        12
      ],
      [
        -1,
        33
      ],
      [
        -14,
        24
      ]
    ],
    [
      [
        27182,
        62369
      ],
      [
        8,
        27
      ],
      [
        36,
        101
      ],
      [
        7,
        2
      ],
      [
        28,
        56
      ]
    ],
    [
      [
        25225,
        68846
      ],
      [
        33,
        -1
      ],
      [
        68,
        -5
      ]
    ],
    [
      [
        25326,
        68840
      ],
      [
        15,
        2
      ],
      [
        0,
        -401
      ]
    ],
    [
      [
        25282,
        68443
      ],
      [
        -43,
        0
      ],
      [
        -25,
        -1
      ],
      [
        -26,
        0
      ]
    ],
    [
      [
        21494,
        70549
      ],
      [
        0,
        177
      ]
    ],
    [
      [
        21467,
        71222
      ],
      [
        0,
        100
      ]
    ],
    [
      [
        15490,
        70789
      ],
      [
        3,
        1
      ],
      [
        3,
        4
      ],
      [
        3,
        3
      ],
      [
        4,
        5
      ],
      [
        6,
        -2
      ],
      [
        2,
        -1
      ],
      [
        1,
        -4
      ],
      [
        6,
        -17
      ],
      [
        6,
        -24
      ],
      [
        -1,
        -55
      ],
      [
        17,
        -42
      ],
      [
        2,
        0
      ]
    ],
    [
      [
        15542,
        70230
      ],
      [
        -34,
        1
      ],
      [
        0,
        -5
      ],
      [
        -66,
        -3
      ],
      [
        0,
        12
      ],
      [
        -69,
        0
      ]
    ],
    [
      [
        15373,
        70235
      ],
      [
        2,
        62
      ],
      [
        0,
        39
      ],
      [
        -2,
        44
      ],
      [
        -3,
        26
      ],
      [
        -4,
        10
      ],
      [
        0,
        9
      ],
      [
        7,
        26
      ],
      [
        3,
        6
      ],
      [
        5,
        2
      ],
      [
        1,
        2
      ],
      [
        2,
        37
      ],
      [
        0,
        38
      ],
      [
        -1,
        34
      ],
      [
        -4,
        52
      ],
      [
        -3,
        30
      ],
      [
        -4,
        32
      ],
      [
        -7,
        40
      ],
      [
        -3,
        23
      ],
      [
        -4,
        7
      ],
      [
        3,
        8
      ],
      [
        3,
        1
      ],
      [
        1,
        -2
      ],
      [
        2,
        -10
      ],
      [
        5,
        -16
      ],
      [
        6,
        -10
      ],
      [
        7,
        -15
      ],
      [
        4,
        -14
      ],
      [
        2,
        -12
      ],
      [
        4,
        -5
      ],
      [
        10,
        -9
      ],
      [
        3,
        4
      ],
      [
        1,
        11
      ],
      [
        -7,
        14
      ],
      [
        0,
        9
      ],
      [
        7,
        3
      ],
      [
        5,
        -2
      ],
      [
        8,
        6
      ],
      [
        3,
        3
      ],
      [
        3,
        6
      ],
      [
        1,
        3
      ],
      [
        1,
        6
      ],
      [
        2,
        2
      ],
      [
        3,
        -10
      ],
      [
        3,
        -4
      ],
      [
        2,
        -5
      ],
      [
        3,
        -9
      ],
      [
        7,
        1
      ],
      [
        5,
        10
      ],
      [
        0,
        20
      ],
      [
        2,
        3
      ],
      [
        2,
        -2
      ],
      [
        5,
        -4
      ],
      [
        3,
        0
      ],
      [
        3,
        3
      ],
      [
        5,
        11
      ],
      [
        5,
        4
      ],
      [
        10,
        23
      ],
      [
        0,
        13
      ]
    ],
    [
      [
        28632,
        64405
      ],
      [
        20,
        31
      ],
      [
        2,
        34
      ],
      [
        4,
        61
      ],
      [
        22,
        77
      ]
    ],
    [
      [
        28768,
        64291
      ],
      [
        -29,
        -44
      ],
      [
        -5,
        -72
      ],
      [
        -2,
        -4
      ],
      [
        -11,
        6
      ],
      [
        -2,
        0
      ],
      [
        -4,
        -15
      ],
      [
        -7,
        -5
      ],
      [
        -14,
        -20
      ],
      [
        -4,
        -12
      ],
      [
        -14,
        -7
      ],
      [
        -10,
        -13
      ],
      [
        -23,
        -2
      ],
      [
        -8,
        -7
      ],
      [
        -14,
        -16
      ],
      [
        -6,
        0
      ]
    ],
    [
      [
        28588,
        64149
      ],
      [
        -11,
        30
      ],
      [
        -35,
        90
      ]
    ],
    [
      [
        28494,
        65362
      ],
      [
        17,
        -8
      ]
    ],
    [
      [
        28511,
        65354
      ],
      [
        18,
        -215
      ],
      [
        43,
        -118
      ],
      [
        13,
        -13
      ],
      [
        28,
        -20
      ]
    ],
    [
      [
        28613,
        64988
      ],
      [
        -41,
        -138
      ],
      [
        -13,
        -2
      ]
    ],
    [
      [
        28559,
        64848
      ],
      [
        -11,
        -2
      ],
      [
        -15,
        21
      ]
    ],
    [
      [
        28488,
        64829
      ],
      [
        -18,
        11
      ],
      [
        -5,
        -71
      ],
      [
        -22,
        -3
      ],
      [
        -16,
        -19
      ],
      [
        -8,
        0
      ]
    ],
    [
      [
        28419,
        64747
      ],
      [
        -6,
        0
      ],
      [
        -30,
        121
      ],
      [
        -6,
        16
      ],
      [
        1,
        10
      ],
      [
        -9,
        28
      ],
      [
        -8,
        1
      ],
      [
        0,
        10
      ],
      [
        -5,
        5
      ],
      [
        -8,
        23
      ],
      [
        -9,
        34
      ],
      [
        -4,
        7
      ],
      [
        -3,
        19
      ],
      [
        -5,
        12
      ],
      [
        -1,
        27
      ],
      [
        -6,
        18
      ],
      [
        -8,
        6
      ],
      [
        -4,
        11
      ],
      [
        0,
        16
      ],
      [
        -6,
        36
      ],
      [
        -4,
        10
      ],
      [
        -2,
        23
      ],
      [
        -4,
        0
      ],
      [
        0,
        44
      ]
    ],
    [
      [
        28292,
        65224
      ],
      [
        0,
        74
      ]
    ],
    [
      [
        26154,
        58599
      ],
      [
        4,
        -6
      ],
      [
        0,
        6
      ],
      [
        3,
        -1
      ],
      [
        -1,
        -11
      ],
      [
        -1,
        -12
      ]
    ],
    [
      [
        26159,
        58575
      ],
      [
        -1,
        5
      ],
      [
        1,
        3
      ],
      [
        -1,
        4
      ],
      [
        1,
        1
      ],
      [
        -1,
        3
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        1
      ],
      [
        -1,
        5
      ],
      [
        0,
        4
      ]
    ],
    [
      [
        26050,
        58864
      ],
      [
        1,
        11
      ],
      [
        5,
        8
      ],
      [
        4,
        17
      ],
      [
        6,
        -6
      ],
      [
        3,
        26
      ],
      [
        2,
        -5
      ],
      [
        3,
        17
      ],
      [
        15,
        10
      ],
      [
        31,
        -32
      ],
      [
        6,
        -3
      ],
      [
        13,
        -25
      ],
      [
        5,
        1
      ],
      [
        -1,
        -45
      ],
      [
        13,
        -16
      ]
    ],
    [
      [
        26156,
        58822
      ],
      [
        0,
        -15
      ],
      [
        6,
        -62
      ],
      [
        9,
        -3
      ],
      [
        -1,
        -13
      ],
      [
        -4,
        -7
      ],
      [
        2,
        -18
      ],
      [
        -5,
        -79
      ],
      [
        -2,
        -13
      ],
      [
        -6,
        -6
      ]
    ],
    [
      [
        26155,
        58606
      ],
      [
        -2,
        18
      ],
      [
        3,
        15
      ],
      [
        -27,
        -29
      ],
      [
        -17,
        21
      ],
      [
        -4,
        1
      ],
      [
        -3,
        7
      ],
      [
        -4,
        0
      ],
      [
        0,
        -8
      ],
      [
        -3,
        9
      ],
      [
        -6,
        -11
      ],
      [
        -1,
        -8
      ],
      [
        -5,
        11
      ],
      [
        -3,
        -10
      ],
      [
        2,
        -18
      ],
      [
        -4,
        9
      ],
      [
        -2,
        -3
      ],
      [
        -8,
        11
      ],
      [
        -8,
        0
      ],
      [
        -1,
        -13
      ]
    ],
    [
      [
        24377,
        68853
      ],
      [
        34,
        0
      ]
    ],
    [
      [
        24411,
        68853
      ],
      [
        0,
        -407
      ],
      [
        -1,
        -7
      ],
      [
        -7,
        -19
      ],
      [
        -5,
        -2
      ],
      [
        -7,
        -13
      ],
      [
        -2,
        -12
      ],
      [
        3,
        -16
      ],
      [
        -4,
        -18
      ],
      [
        6,
        -19
      ],
      [
        7,
        -8
      ],
      [
        5,
        -28
      ],
      [
        0,
        -20
      ],
      [
        4,
        -13
      ],
      [
        -7,
        -39
      ],
      [
        -4,
        -29
      ],
      [
        4,
        -15
      ]
    ],
    [
      [
        24403,
        68188
      ],
      [
        -4,
        2
      ],
      [
        -2,
        0
      ],
      [
        -1,
        1
      ],
      [
        -3,
        4
      ],
      [
        -1,
        5
      ],
      [
        -2,
        10
      ],
      [
        -1,
        4
      ],
      [
        -1,
        2
      ],
      [
        -1,
        3
      ],
      [
        -2,
        3
      ],
      [
        -2,
        2
      ],
      [
        -1,
        5
      ],
      [
        -1,
        4
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        5
      ],
      [
        -2,
        3
      ],
      [
        0,
        3
      ],
      [
        -1,
        8
      ],
      [
        -1,
        5
      ],
      [
        0,
        2
      ],
      [
        -4,
        12
      ],
      [
        -2,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        -4,
        6
      ],
      [
        0,
        16
      ],
      [
        -1,
        3
      ],
      [
        -2,
        10
      ],
      [
        -1,
        2
      ],
      [
        -2,
        3
      ],
      [
        -6,
        2
      ],
      [
        -1,
        2
      ],
      [
        -4,
        8
      ],
      [
        -1,
        5
      ],
      [
        -7,
        8
      ],
      [
        -3,
        5
      ],
      [
        -2,
        6
      ],
      [
        -4,
        16
      ],
      [
        -1,
        3
      ],
      [
        -3,
        5
      ],
      [
        -4,
        10
      ]
    ],
    [
      [
        24319,
        68384
      ],
      [
        -1,
        4
      ],
      [
        -3,
        3
      ],
      [
        0,
        1
      ],
      [
        -1,
        3
      ],
      [
        0,
        12
      ],
      [
        -1,
        4
      ],
      [
        -2,
        11
      ],
      [
        -1,
        6
      ],
      [
        0,
        5
      ],
      [
        1,
        13
      ],
      [
        0,
        11
      ],
      [
        -2,
        8
      ],
      [
        0,
        14
      ],
      [
        -1,
        3
      ],
      [
        -2,
        5
      ],
      [
        -4,
        5
      ],
      [
        -1,
        2
      ],
      [
        0,
        11
      ],
      [
        1,
        4
      ],
      [
        2,
        9
      ],
      [
        0,
        3
      ],
      [
        -1,
        8
      ],
      [
        -1,
        5
      ],
      [
        -1,
        13
      ],
      [
        -1,
        2
      ],
      [
        -4,
        7
      ],
      [
        -2,
        9
      ],
      [
        -1,
        5
      ],
      [
        -2,
        7
      ],
      [
        -1,
        3
      ],
      [
        -2,
        5
      ],
      [
        -1,
        2
      ],
      [
        -1,
        1
      ],
      [
        -2,
        0
      ],
      [
        -1,
        1
      ],
      [
        -2,
        3
      ],
      [
        -1,
        3
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        2
      ],
      [
        -1,
        1
      ],
      [
        -3,
        2
      ],
      [
        -5,
        8
      ],
      [
        -2,
        7
      ],
      [
        -2,
        8
      ],
      [
        -1,
        2
      ],
      [
        -1,
        1
      ],
      [
        -3,
        0
      ],
      [
        -2,
        1
      ],
      [
        -2,
        3
      ]
    ],
    [
      [
        90501,
        34555
      ],
      [
        4,
        28
      ],
      [
        2,
        72
      ],
      [
        0,
        29
      ],
      [
        9,
        -12
      ],
      [
        8,
        21
      ],
      [
        12,
        46
      ],
      [
        2,
        -3
      ],
      [
        3,
        -19
      ],
      [
        -1,
        -14
      ],
      [
        -5,
        -15
      ],
      [
        0,
        -8
      ],
      [
        -3,
        -11
      ],
      [
        -5,
        -32
      ],
      [
        1,
        -23
      ],
      [
        4,
        -19
      ],
      [
        -2,
        -11
      ],
      [
        1,
        -10
      ],
      [
        -4,
        3
      ],
      [
        -3,
        4
      ],
      [
        -6,
        0
      ],
      [
        -1,
        -28
      ],
      [
        3,
        -12
      ],
      [
        -2,
        -33
      ],
      [
        -4,
        17
      ],
      [
        -8,
        1
      ],
      [
        -4,
        16
      ],
      [
        -1,
        13
      ]
    ],
    [
      [
        31256,
        37931
      ],
      [
        0,
        -48
      ],
      [
        -6,
        -45
      ]
    ],
    [
      [
        31250,
        37838
      ],
      [
        0,
        10
      ],
      [
        -1,
        5
      ],
      [
        0,
        2
      ],
      [
        -3,
        1
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        9
      ],
      [
        -3,
        2
      ],
      [
        -10,
        4
      ],
      [
        -4,
        -7
      ],
      [
        -2,
        -9
      ],
      [
        -2,
        -10
      ],
      [
        -3,
        -6
      ],
      [
        -3,
        -1
      ]
    ],
    [
      [
        31230,
        38250
      ],
      [
        5,
        27
      ],
      [
        -3,
        25
      ],
      [
        1,
        5
      ],
      [
        4,
        44
      ]
    ],
    [
      [
        31237,
        38351
      ],
      [
        5,
        2
      ],
      [
        21,
        -21
      ],
      [
        4,
        19
      ]
    ],
    [
      [
        31267,
        38351
      ],
      [
        0,
        -17
      ],
      [
        5,
        -15
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        31273,
        38319
      ],
      [
        2,
        2
      ]
    ],
    [
      [
        31275,
        38321
      ],
      [
        -5,
        -75
      ],
      [
        1,
        -58
      ]
    ],
    [
      [
        31271,
        38188
      ],
      [
        -9,
        6
      ],
      [
        -2,
        12
      ],
      [
        -17,
        12
      ],
      [
        -9,
        2
      ],
      [
        0,
        10
      ]
    ],
    [
      [
        31234,
        38230
      ],
      [
        0,
        13
      ],
      [
        -4,
        7
      ]
    ],
    [
      [
        21486,
        60002
      ],
      [
        8,
        1
      ],
      [
        27,
        0
      ],
      [
        84,
        2
      ],
      [
        13,
        0
      ]
    ],
    [
      [
        21754,
        60008
      ],
      [
        34,
        0
      ]
    ],
    [
      [
        21788,
        60008
      ],
      [
        0,
        -174
      ],
      [
        -3,
        0
      ],
      [
        0,
        -406
      ]
    ],
    [
      [
        21485,
        59429
      ],
      [
        0,
        406
      ],
      [
        1,
        4
      ],
      [
        0,
        163
      ]
    ],
    [
      [
        28613,
        64988
      ],
      [
        11,
        38
      ],
      [
        27,
        2
      ]
    ],
    [
      [
        28590,
        64530
      ],
      [
        3,
        51
      ],
      [
        -3,
        16
      ],
      [
        5,
        7
      ],
      [
        -1,
        15
      ],
      [
        -14,
        47
      ],
      [
        1,
        41
      ],
      [
        -2,
        22
      ],
      [
        -14,
        12
      ],
      [
        0,
        30
      ],
      [
        -6,
        77
      ]
    ],
    [
      [
        21908,
        70421
      ],
      [
        4,
        0
      ]
    ],
    [
      [
        21912,
        70421
      ],
      [
        3,
        -15
      ],
      [
        7,
        -13
      ],
      [
        13,
        -41
      ],
      [
        8,
        -17
      ],
      [
        2,
        -13
      ],
      [
        -1,
        -23
      ],
      [
        2,
        -26
      ],
      [
        7,
        -52
      ],
      [
        12,
        -74
      ],
      [
        0,
        -21
      ],
      [
        -3,
        -19
      ],
      [
        -5,
        -12
      ],
      [
        -12,
        -3
      ],
      [
        -7,
        -12
      ],
      [
        -3,
        -18
      ],
      [
        -4,
        -47
      ]
    ],
    [
      [
        21641,
        69873
      ],
      [
        -147,
        0
      ]
    ],
    [
      [
        23368,
        53716
      ],
      [
        3,
        -18
      ],
      [
        15,
        -8
      ],
      [
        11,
        15
      ],
      [
        2,
        -11
      ],
      [
        6,
        -13
      ],
      [
        -2,
        -14
      ],
      [
        1,
        -13
      ],
      [
        5,
        -3
      ],
      [
        7,
        -21
      ],
      [
        1,
        -29
      ],
      [
        -2,
        1
      ],
      [
        1,
        -31
      ],
      [
        10,
        4
      ],
      [
        6,
        -31
      ],
      [
        10,
        0
      ],
      [
        1,
        -22
      ]
    ],
    [
      [
        23443,
        53522
      ],
      [
        -1,
        -6
      ],
      [
        9,
        -15
      ],
      [
        5,
        -25
      ]
    ],
    [
      [
        23231,
        53136
      ],
      [
        -3,
        48
      ],
      [
        5,
        7
      ],
      [
        2,
        16
      ],
      [
        6,
        10
      ],
      [
        -5,
        21
      ],
      [
        0,
        31
      ],
      [
        5,
        19
      ],
      [
        1,
        25
      ],
      [
        0,
        29
      ],
      [
        6,
        13
      ],
      [
        0,
        12
      ],
      [
        4,
        5
      ],
      [
        2,
        -10
      ],
      [
        3,
        9
      ],
      [
        0,
        23
      ],
      [
        4,
        2
      ],
      [
        0,
        23
      ],
      [
        -1,
        9
      ],
      [
        -4,
        -1
      ],
      [
        4,
        15
      ],
      [
        -9,
        21
      ],
      [
        -2,
        36
      ],
      [
        -3,
        20
      ],
      [
        0,
        36
      ],
      [
        -4,
        9
      ],
      [
        -6,
        -5
      ],
      [
        4,
        19
      ],
      [
        3,
        -4
      ],
      [
        -2,
        21
      ],
      [
        -4,
        -3
      ],
      [
        1,
        21
      ]
    ],
    [
      [
        22332,
        53590
      ],
      [
        0,
        -1
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -7
      ],
      [
        1,
        -6
      ],
      [
        1,
        -3
      ],
      [
        5,
        -9
      ],
      [
        1,
        -4
      ],
      [
        0,
        -15
      ],
      [
        1,
        -1
      ],
      [
        1,
        5
      ],
      [
        1,
        10
      ],
      [
        1,
        7
      ],
      [
        2,
        3
      ],
      [
        2,
        -1
      ],
      [
        1,
        -6
      ],
      [
        0,
        -12
      ],
      [
        2,
        -9
      ],
      [
        3,
        1
      ],
      [
        3,
        0
      ],
      [
        2,
        -2
      ],
      [
        3,
        6
      ],
      [
        2,
        6
      ],
      [
        3,
        -1
      ],
      [
        4,
        -18
      ],
      [
        1,
        -10
      ],
      [
        -1,
        -7
      ],
      [
        1,
        0
      ],
      [
        3,
        -3
      ],
      [
        4,
        1
      ],
      [
        2,
        5
      ],
      [
        1,
        -4
      ],
      [
        0,
        -9
      ],
      [
        2,
        1
      ],
      [
        2,
        6
      ],
      [
        3,
        -3
      ],
      [
        2,
        4
      ],
      [
        3,
        0
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -16
      ],
      [
        -1,
        -12
      ],
      [
        0,
        -4
      ],
      [
        1,
        0
      ],
      [
        2,
        -2
      ],
      [
        3,
        5
      ],
      [
        2,
        9
      ],
      [
        -1,
        7
      ],
      [
        0,
        7
      ],
      [
        1,
        3
      ],
      [
        3,
        5
      ],
      [
        1,
        13
      ],
      [
        -1,
        6
      ],
      [
        1,
        7
      ],
      [
        1,
        -1
      ],
      [
        2,
        -1
      ],
      [
        0,
        -24
      ],
      [
        3,
        -4
      ],
      [
        3,
        3
      ],
      [
        2,
        -5
      ],
      [
        1,
        -13
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -15
      ],
      [
        0,
        -17
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -8
      ],
      [
        2,
        -3
      ],
      [
        0,
        -6
      ],
      [
        2,
        1
      ],
      [
        2,
        5
      ],
      [
        4,
        9
      ],
      [
        1,
        4
      ],
      [
        2,
        10
      ],
      [
        1,
        3
      ],
      [
        1,
        3
      ],
      [
        1,
        -8
      ],
      [
        1,
        -6
      ],
      [
        0,
        1
      ],
      [
        2,
        -1
      ],
      [
        1,
        -3
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -7
      ],
      [
        1,
        -6
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -7
      ],
      [
        1,
        -5
      ],
      [
        3,
        5
      ],
      [
        1,
        6
      ],
      [
        2,
        2
      ],
      [
        1,
        -1
      ],
      [
        1,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -3
      ],
      [
        0,
        -9
      ],
      [
        3,
        2
      ],
      [
        6,
        10
      ],
      [
        0,
        5
      ],
      [
        2,
        3
      ],
      [
        1,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -8
      ],
      [
        0,
        -20
      ],
      [
        -1,
        -9
      ],
      [
        -3,
        -4
      ],
      [
        -4,
        0
      ],
      [
        -1,
        -9
      ],
      [
        1,
        -6
      ],
      [
        3,
        -8
      ],
      [
        4,
        -10
      ],
      [
        2,
        1
      ],
      [
        0,
        11
      ],
      [
        2,
        3
      ],
      [
        2,
        -3
      ],
      [
        1,
        -12
      ],
      [
        2,
        -11
      ],
      [
        1,
        -8
      ],
      [
        0,
        -9
      ]
    ],
    [
      [
        22451,
        53294
      ],
      [
        -1,
        -37
      ],
      [
        3,
        -7
      ],
      [
        4,
        2
      ],
      [
        2,
        -9
      ],
      [
        -2,
        -14
      ],
      [
        7,
        -11
      ],
      [
        3,
        3
      ],
      [
        -1,
        -14
      ],
      [
        -5,
        0
      ],
      [
        0,
        -18
      ],
      [
        -6,
        -19
      ],
      [
        7,
        -40
      ],
      [
        7,
        32
      ],
      [
        5,
        3
      ],
      [
        3,
        -13
      ],
      [
        4,
        4
      ],
      [
        -4,
        -17
      ],
      [
        4,
        -10
      ],
      [
        0,
        -12
      ],
      [
        -5,
        -3
      ],
      [
        -3,
        -11
      ],
      [
        3,
        -15
      ],
      [
        7,
        -12
      ],
      [
        3,
        -16
      ]
    ],
    [
      [
        28409,
        60582
      ],
      [
        5,
        -17
      ],
      [
        10,
        -6
      ],
      [
        2,
        -18
      ],
      [
        6,
        -18
      ],
      [
        6,
        1
      ],
      [
        7,
        -10
      ],
      [
        6,
        -4
      ],
      [
        2,
        -15
      ],
      [
        8,
        -2
      ],
      [
        6,
        4
      ],
      [
        1,
        -13
      ],
      [
        4,
        -3
      ],
      [
        3,
        7
      ],
      [
        1,
        -12
      ],
      [
        -1,
        -19
      ],
      [
        4,
        19
      ],
      [
        3,
        -5
      ],
      [
        4,
        10
      ],
      [
        -4,
        -23
      ],
      [
        4,
        -8
      ]
    ],
    [
      [
        28486,
        60450
      ],
      [
        -2,
        -34
      ],
      [
        7,
        23
      ],
      [
        3,
        -3
      ],
      [
        -2,
        -65
      ],
      [
        3,
        -16
      ],
      [
        -3,
        -12
      ],
      [
        2,
        -29
      ]
    ],
    [
      [
        28494,
        60314
      ],
      [
        -9,
        -21
      ],
      [
        -8,
        -5
      ],
      [
        -2,
        -5
      ]
    ],
    [
      [
        28467,
        60300
      ],
      [
        -6,
        34
      ],
      [
        -1,
        27
      ],
      [
        -4,
        5
      ],
      [
        -6,
        -13
      ],
      [
        -10,
        -29
      ],
      [
        -3,
        6
      ],
      [
        -2,
        42
      ],
      [
        -3,
        2
      ],
      [
        -8,
        -11
      ],
      [
        -17,
        10
      ],
      [
        -11,
        9
      ],
      [
        -7,
        -12
      ],
      [
        -6,
        14
      ]
    ],
    [
      [
        28383,
        60384
      ],
      [
        2,
        27
      ],
      [
        6,
        29
      ],
      [
        -2,
        15
      ]
    ],
    [
      [
        28001,
        61878
      ],
      [
        6,
        22
      ],
      [
        9,
        74
      ],
      [
        11,
        51
      ],
      [
        0,
        9
      ],
      [
        11,
        -15
      ],
      [
        5,
        19
      ],
      [
        6,
        13
      ],
      [
        13,
        53
      ],
      [
        8,
        28
      ]
    ],
    [
      [
        28086,
        61905
      ],
      [
        -6,
        -16
      ],
      [
        -7,
        -36
      ],
      [
        1,
        -25
      ],
      [
        -9,
        -17
      ],
      [
        -2,
        -14
      ],
      [
        -6,
        -8
      ],
      [
        2,
        -7
      ],
      [
        -5,
        -54
      ]
    ],
    [
      [
        28045,
        61665
      ],
      [
        -17,
        6
      ],
      [
        -3,
        24
      ],
      [
        -18,
        22
      ],
      [
        -3,
        37
      ],
      [
        -11,
        4
      ],
      [
        -3,
        6
      ],
      [
        -2,
        6
      ],
      [
        4,
        26
      ],
      [
        4,
        44
      ],
      [
        4,
        35
      ],
      [
        1,
        3
      ]
    ],
    [
      [
        22181,
        66993
      ],
      [
        -1,
        0
      ],
      [
        -9,
        -1
      ],
      [
        -48,
        0
      ],
      [
        -8,
        1
      ],
      [
        -5,
        0
      ],
      [
        -3,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -2,
        0
      ],
      [
        -3,
        -1
      ],
      [
        -8,
        1
      ],
      [
        -3,
        -1
      ],
      [
        -3,
        1
      ],
      [
        -91,
        0
      ]
    ],
    [
      [
        21991,
        67449
      ],
      [
        0,
        101
      ],
      [
        -4,
        1
      ],
      [
        0,
        275
      ]
    ],
    [
      [
        20994,
        51000
      ],
      [
        -6,
        13
      ],
      [
        -6,
        9
      ],
      [
        -12,
        8
      ],
      [
        -10,
        -1
      ],
      [
        -1,
        1
      ],
      [
        0,
        6
      ],
      [
        -2,
        4
      ],
      [
        -5,
        1
      ],
      [
        -6,
        5
      ],
      [
        -3,
        -3
      ],
      [
        -17,
        28
      ],
      [
        -5,
        12
      ],
      [
        0,
        8
      ],
      [
        -6,
        9
      ],
      [
        -1,
        1
      ],
      [
        -3,
        9
      ],
      [
        0,
        7
      ],
      [
        -2,
        8
      ],
      [
        -2,
        7
      ],
      [
        -5,
        9
      ],
      [
        -6,
        3
      ],
      [
        -6,
        19
      ],
      [
        -4,
        15
      ],
      [
        0,
        16
      ],
      [
        -4,
        19
      ],
      [
        -3,
        7
      ],
      [
        -2,
        5
      ],
      [
        0,
        24
      ],
      [
        -2,
        5
      ],
      [
        -2,
        4
      ],
      [
        -2,
        6
      ],
      [
        0,
        12
      ],
      [
        -7,
        15
      ],
      [
        -1,
        5
      ],
      [
        -13,
        12
      ],
      [
        -2,
        4
      ],
      [
        -3,
        -6
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        0
      ],
      [
        -9,
        27
      ],
      [
        -3,
        0
      ],
      [
        -3,
        15
      ],
      [
        0,
        5
      ],
      [
        -2,
        14
      ],
      [
        -14,
        37
      ],
      [
        -4,
        6
      ],
      [
        -5,
        22
      ],
      [
        -3,
        7
      ],
      [
        -4,
        6
      ],
      [
        -9,
        43
      ],
      [
        0,
        6
      ],
      [
        1,
        7
      ],
      [
        0,
        4
      ],
      [
        -4,
        31
      ],
      [
        -1,
        16
      ],
      [
        0,
        11
      ],
      [
        -3,
        21
      ],
      [
        0,
        14
      ],
      [
        -8,
        46
      ],
      [
        0,
        -1
      ],
      [
        -1,
        2
      ],
      [
        -3,
        9
      ],
      [
        -3,
        30
      ],
      [
        -1,
        1
      ],
      [
        -2,
        9
      ],
      [
        0,
        12
      ],
      [
        -1,
        8
      ],
      [
        -6,
        22
      ],
      [
        -1,
        3
      ],
      [
        0,
        11
      ],
      [
        -4,
        12
      ],
      [
        -2,
        15
      ],
      [
        -1,
        37
      ],
      [
        1,
        22
      ],
      [
        -1,
        17
      ],
      [
        -2,
        29
      ],
      [
        -1,
        5
      ],
      [
        -2,
        3
      ],
      [
        -1,
        3
      ],
      [
        1,
        13
      ],
      [
        -1,
        18
      ],
      [
        1,
        16
      ],
      [
        1,
        1
      ],
      [
        2,
        5
      ],
      [
        2,
        19
      ],
      [
        -1,
        12
      ],
      [
        -1,
        13
      ],
      [
        -1,
        29
      ],
      [
        1,
        7
      ],
      [
        1,
        28
      ],
      [
        0,
        20
      ],
      [
        -4,
        37
      ],
      [
        -3,
        13
      ],
      [
        0,
        18
      ],
      [
        -6,
        27
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        2
      ],
      [
        -1,
        3
      ],
      [
        -2,
        22
      ],
      [
        -1,
        22
      ],
      [
        -5,
        14
      ],
      [
        -5,
        20
      ],
      [
        -3,
        5
      ],
      [
        -1,
        14
      ],
      [
        0,
        16
      ],
      [
        -1,
        6
      ],
      [
        -2,
        5
      ],
      [
        -4,
        4
      ],
      [
        -6,
        19
      ],
      [
        1,
        22
      ],
      [
        1,
        11
      ],
      [
        -2,
        12
      ],
      [
        -3,
        35
      ],
      [
        0,
        5
      ],
      [
        1,
        2
      ],
      [
        0,
        3
      ],
      [
        -3,
        51
      ],
      [
        -3,
        28
      ],
      [
        -1,
        19
      ],
      [
        -2,
        22
      ],
      [
        -7,
        40
      ],
      [
        -4,
        -1
      ],
      [
        -8,
        5
      ],
      [
        -1,
        2
      ],
      [
        -3,
        14
      ],
      [
        0,
        8
      ]
    ],
    [
      [
        18517,
        60643
      ],
      [
        -60,
        0
      ],
      [
        0,
        -51
      ]
    ],
    [
      [
        18457,
        60592
      ],
      [
        -38,
        0
      ],
      [
        0,
        -29
      ],
      [
        -29,
        0
      ],
      [
        -2,
        7
      ],
      [
        -30,
        2
      ],
      [
        0,
        54
      ],
      [
        -61,
        0
      ],
      [
        0,
        104
      ],
      [
        -32,
        0
      ],
      [
        0,
        -16
      ],
      [
        -129,
        0
      ]
    ],
    [
      [
        23461,
        54010
      ],
      [
        136,
        -1
      ]
    ],
    [
      [
        23597,
        54009
      ],
      [
        5,
        -23
      ],
      [
        2,
        -30
      ],
      [
        -1,
        -27
      ],
      [
        -1,
        -1
      ],
      [
        5,
        -27
      ],
      [
        1,
        -35
      ],
      [
        -2,
        -18
      ],
      [
        4,
        -29
      ],
      [
        -1,
        -19
      ],
      [
        2,
        -13
      ]
    ],
    [
      [
        23632,
        53288
      ],
      [
        -6,
        14
      ],
      [
        -3,
        26
      ],
      [
        -7,
        17
      ],
      [
        -1,
        19
      ],
      [
        -3,
        14
      ],
      [
        -15,
        22
      ],
      [
        -6,
        59
      ],
      [
        1,
        14
      ],
      [
        -5,
        8
      ],
      [
        -3,
        17
      ],
      [
        -5,
        5
      ],
      [
        -4,
        -13
      ],
      [
        -4,
        7
      ],
      [
        0,
        32
      ],
      [
        -10,
        1
      ],
      [
        -1,
        13
      ],
      [
        -13,
        -4
      ],
      [
        -8,
        14
      ],
      [
        -1,
        7
      ],
      [
        -7,
        -9
      ],
      [
        -11,
        7
      ],
      [
        -7,
        15
      ],
      [
        -4,
        0
      ],
      [
        -4,
        13
      ],
      [
        -5,
        1
      ],
      [
        -1,
        10
      ],
      [
        -6,
        -8
      ],
      [
        -4,
        28
      ],
      [
        -4,
        1
      ],
      [
        -4,
        21
      ]
    ],
    [
      [
        23481,
        53639
      ],
      [
        -5,
        4
      ],
      [
        -2,
        13
      ],
      [
        0,
        43
      ],
      [
        -6,
        -11
      ],
      [
        -3,
        13
      ],
      [
        -2,
        49
      ],
      [
        -3,
        19
      ],
      [
        -3,
        4
      ],
      [
        1,
        18
      ],
      [
        -5,
        47
      ],
      [
        3,
        31
      ],
      [
        -4,
        16
      ],
      [
        1,
        19
      ],
      [
        10,
        0
      ],
      [
        1,
        14
      ],
      [
        -12,
        19
      ],
      [
        -2,
        13
      ],
      [
        6,
        3
      ],
      [
        4,
        26
      ],
      [
        -2,
        8
      ],
      [
        4,
        7
      ],
      [
        -1,
        16
      ]
    ],
    [
      [
        22944,
        52049
      ],
      [
        15,
        43
      ],
      [
        -1,
        24
      ],
      [
        3,
        27
      ],
      [
        4,
        11
      ],
      [
        3,
        -6
      ],
      [
        6,
        4
      ],
      [
        0,
        8
      ],
      [
        8,
        37
      ],
      [
        5,
        10
      ]
    ],
    [
      [
        22987,
        52207
      ],
      [
        10,
        7
      ],
      [
        10,
        13
      ],
      [
        2,
        10
      ],
      [
        6,
        -5
      ],
      [
        8,
        9
      ],
      [
        4,
        -1
      ],
      [
        2,
        13
      ],
      [
        8,
        0
      ],
      [
        11,
        9
      ],
      [
        3,
        17
      ],
      [
        1,
        -8
      ],
      [
        13,
        19
      ],
      [
        6,
        0
      ],
      [
        7,
        19
      ],
      [
        3,
        -1
      ],
      [
        1,
        -5
      ]
    ],
    [
      [
        23082,
        52303
      ],
      [
        4,
        -16
      ],
      [
        5,
        -7
      ],
      [
        1,
        12
      ],
      [
        3,
        -5
      ],
      [
        15,
        21
      ],
      [
        2,
        19
      ],
      [
        4,
        -6
      ],
      [
        0,
        -21
      ],
      [
        5,
        2
      ],
      [
        3,
        -11
      ],
      [
        -1,
        -21
      ],
      [
        -2,
        -10
      ],
      [
        1,
        -14
      ]
    ],
    [
      [
        23122,
        52246
      ],
      [
        10,
        -28
      ],
      [
        7,
        4
      ],
      [
        -2,
        -19
      ],
      [
        4,
        -5
      ],
      [
        -3,
        -39
      ],
      [
        4,
        -5
      ],
      [
        -1,
        -15
      ],
      [
        -5,
        -6
      ],
      [
        3,
        -9
      ]
    ],
    [
      [
        23139,
        52124
      ],
      [
        -1,
        -12
      ],
      [
        -4,
        14
      ],
      [
        -4,
        -18
      ],
      [
        -5,
        8
      ],
      [
        -4,
        -13
      ],
      [
        1,
        -35
      ],
      [
        -1,
        -18
      ],
      [
        3,
        -7
      ],
      [
        -2,
        -16
      ],
      [
        -6,
        15
      ],
      [
        -2,
        -5
      ],
      [
        3,
        -11
      ],
      [
        -5,
        -3
      ],
      [
        5,
        -30
      ],
      [
        0,
        -15
      ],
      [
        4,
        10
      ],
      [
        2,
        -7
      ],
      [
        -2,
        -12
      ],
      [
        4,
        -8
      ],
      [
        3,
        -16
      ],
      [
        -3,
        -1
      ]
    ],
    [
      [
        23125,
        51944
      ],
      [
        -4,
        -19
      ],
      [
        -6,
        9
      ],
      [
        -9,
        8
      ],
      [
        -4,
        8
      ],
      [
        -9,
        0
      ],
      [
        -4,
        22
      ],
      [
        -4,
        3
      ],
      [
        -64,
        -37
      ],
      [
        -19,
        -1
      ],
      [
        -2,
        8
      ],
      [
        -8,
        -31
      ]
    ],
    [
      [
        18740,
        65163
      ],
      [
        -9,
        -16
      ],
      [
        -13,
        17
      ],
      [
        -3,
        -8
      ],
      [
        2,
        -29
      ],
      [
        -2,
        -20
      ],
      [
        3,
        -15
      ],
      [
        -17,
        -26
      ],
      [
        -1,
        -7
      ],
      [
        -2,
        -1
      ],
      [
        -57,
        0
      ],
      [
        -28,
        -119
      ],
      [
        -43,
        -183
      ]
    ],
    [
      [
        18570,
        64756
      ],
      [
        -85,
        -89
      ],
      [
        -346,
        0
      ]
    ],
    [
      [
        18139,
        64667
      ],
      [
        0,
        1156
      ]
    ],
    [
      [
        22752,
        56420
      ],
      [
        7,
        -14
      ],
      [
        0,
        -2
      ],
      [
        2,
        -12
      ],
      [
        0,
        -24
      ],
      [
        -2,
        -18
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -9
      ],
      [
        1,
        -8
      ],
      [
        2,
        -7
      ],
      [
        2,
        -6
      ],
      [
        5,
        -5
      ],
      [
        4,
        -1
      ],
      [
        11,
        1
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        2,
        7
      ],
      [
        3,
        17
      ],
      [
        2,
        19
      ],
      [
        0,
        8
      ],
      [
        1,
        6
      ],
      [
        1,
        2
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        0,
        -9
      ],
      [
        1,
        -1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        0,
        1
      ],
      [
        2,
        13
      ],
      [
        1,
        3
      ],
      [
        1,
        0
      ],
      [
        2,
        -5
      ],
      [
        2,
        -9
      ],
      [
        2,
        -4
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        4,
        1
      ],
      [
        1,
        1
      ],
      [
        0,
        1
      ],
      [
        1,
        12
      ],
      [
        1,
        29
      ],
      [
        1,
        3
      ],
      [
        0,
        4
      ],
      [
        5,
        10
      ],
      [
        4,
        2
      ],
      [
        1,
        -3
      ],
      [
        6,
        -15
      ],
      [
        1,
        -7
      ],
      [
        1,
        -3
      ],
      [
        3,
        -52
      ],
      [
        0,
        -9
      ],
      [
        -1,
        -5
      ],
      [
        -3,
        -5
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -10
      ],
      [
        1,
        -10
      ],
      [
        0,
        -5
      ],
      [
        2,
        -14
      ],
      [
        2,
        -5
      ],
      [
        0,
        -13
      ],
      [
        2,
        -16
      ],
      [
        3,
        -21
      ],
      [
        2,
        -10
      ],
      [
        3,
        -6
      ],
      [
        1,
        -2
      ],
      [
        3,
        -4
      ],
      [
        4,
        -2
      ],
      [
        1,
        0
      ],
      [
        2,
        2
      ],
      [
        1,
        2
      ],
      [
        2,
        2
      ],
      [
        2,
        6
      ],
      [
        1,
        4
      ],
      [
        0,
        5
      ],
      [
        2,
        10
      ],
      [
        0,
        25
      ],
      [
        -1,
        10
      ],
      [
        -1,
        18
      ],
      [
        -1,
        6
      ],
      [
        0,
        5
      ],
      [
        1,
        6
      ],
      [
        1,
        6
      ],
      [
        3,
        4
      ],
      [
        3,
        2
      ],
      [
        5,
        4
      ],
      [
        0,
        9
      ],
      [
        -2,
        11
      ],
      [
        -7,
        7
      ],
      [
        -2,
        5
      ],
      [
        0,
        10
      ],
      [
        6,
        8
      ],
      [
        3,
        -6
      ],
      [
        2,
        -10
      ],
      [
        2,
        -11
      ],
      [
        1,
        1
      ],
      [
        4,
        7
      ],
      [
        2,
        7
      ],
      [
        9,
        42
      ],
      [
        0,
        22
      ],
      [
        -1,
        15
      ],
      [
        -2,
        13
      ],
      [
        0,
        23
      ],
      [
        1,
        4
      ],
      [
        1,
        2
      ],
      [
        2,
        2
      ],
      [
        1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -12
      ],
      [
        1,
        -5
      ],
      [
        1,
        -2
      ],
      [
        0,
        1
      ],
      [
        6,
        10
      ],
      [
        2,
        5
      ]
    ],
    [
      [
        22902,
        56459
      ],
      [
        0,
        -620
      ]
    ],
    [
      [
        22902,
        55839
      ],
      [
        -77,
        10
      ],
      [
        -45,
        6
      ]
    ],
    [
      [
        22751,
        55859
      ],
      [
        1,
        561
      ]
    ],
    [
      [
        22197,
        56618
      ],
      [
        0,
        362
      ]
    ],
    [
      [
        22271,
        56910
      ],
      [
        0,
        -26
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -22
      ],
      [
        0,
        -6
      ],
      [
        1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        2,
        0
      ],
      [
        0,
        -48
      ],
      [
        1,
        -9
      ],
      [
        1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -7
      ],
      [
        1,
        -2
      ],
      [
        8,
        -7
      ],
      [
        4,
        7
      ],
      [
        2,
        5
      ],
      [
        2,
        1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -9
      ],
      [
        1,
        -1
      ],
      [
        2,
        -2
      ],
      [
        3,
        2
      ],
      [
        5,
        7
      ],
      [
        3,
        2
      ],
      [
        1,
        0
      ],
      [
        3,
        -3
      ],
      [
        2,
        -4
      ],
      [
        0,
        -5
      ],
      [
        3,
        -3
      ],
      [
        1,
        0
      ],
      [
        1,
        3
      ],
      [
        1,
        4
      ],
      [
        0,
        3
      ],
      [
        7,
        -4
      ],
      [
        2,
        4
      ],
      [
        1,
        2
      ],
      [
        0,
        11
      ],
      [
        3,
        4
      ],
      [
        1,
        0
      ],
      [
        2,
        -4
      ],
      [
        0,
        -9
      ],
      [
        1,
        -5
      ],
      [
        1,
        -3
      ],
      [
        1,
        -2
      ],
      [
        1,
        0
      ],
      [
        1,
        3
      ],
      [
        0,
        10
      ],
      [
        1,
        1
      ],
      [
        2,
        -1
      ]
    ],
    [
      [
        22343,
        56766
      ],
      [
        0,
        -441
      ]
    ],
    [
      [
        23099,
        53507
      ],
      [
        126,
        239
      ]
    ],
    [
      [
        23098,
        52995
      ],
      [
        1,
        28
      ],
      [
        -6,
        10
      ],
      [
        5,
        64
      ],
      [
        -5,
        19
      ],
      [
        -3,
        1
      ],
      [
        -3,
        21
      ],
      [
        1,
        23
      ],
      [
        -5,
        28
      ],
      [
        -1,
        22
      ],
      [
        1,
        26
      ],
      [
        -4,
        20
      ],
      [
        -1,
        35
      ],
      [
        -5,
        28
      ],
      [
        5,
        15
      ],
      [
        -4,
        25
      ],
      [
        1,
        28
      ],
      [
        2,
        17
      ],
      [
        -1,
        37
      ]
    ],
    [
      [
        22716,
        50826
      ],
      [
        -5,
        -14
      ],
      [
        -35,
        -106
      ],
      [
        51,
        -225
      ]
    ],
    [
      [
        22670,
        50311
      ],
      [
        -5,
        7
      ],
      [
        -8,
        -4
      ],
      [
        -2,
        9
      ],
      [
        -7,
        7
      ],
      [
        -10,
        19
      ],
      [
        0,
        3
      ],
      [
        -6,
        20
      ],
      [
        -25,
        -35
      ]
    ],
    [
      [
        22607,
        50337
      ],
      [
        -26,
        113
      ]
    ],
    [
      [
        27350,
        60351
      ],
      [
        -9,
        -20
      ],
      [
        9,
        -29
      ],
      [
        24,
        -83
      ],
      [
        6,
        17
      ],
      [
        3,
        -18
      ],
      [
        -5,
        -8
      ],
      [
        7,
        -28
      ]
    ],
    [
      [
        27369,
        60096
      ],
      [
        -17,
        -22
      ],
      [
        -17,
        -9
      ],
      [
        -20,
        -25
      ],
      [
        -2,
        -3
      ],
      [
        -5,
        18
      ],
      [
        -10,
        -16
      ],
      [
        -3,
        1
      ],
      [
        -4,
        14
      ],
      [
        -9,
        12
      ],
      [
        -17,
        -33
      ],
      [
        -8,
        -24
      ],
      [
        -7,
        -27
      ],
      [
        -5,
        -13
      ],
      [
        -3,
        3
      ],
      [
        -3,
        -17
      ]
    ],
    [
      [
        27239,
        59955
      ],
      [
        -16,
        67
      ]
    ],
    [
      [
        28286,
        59868
      ],
      [
        62,
        134
      ]
    ],
    [
      [
        28348,
        60002
      ],
      [
        56,
        117
      ],
      [
        3,
        7
      ],
      [
        9,
        15
      ]
    ],
    [
      [
        28472,
        59946
      ],
      [
        -33,
        -70
      ],
      [
        -13,
        -30
      ],
      [
        -37,
        -74
      ],
      [
        -26,
        -50
      ],
      [
        -24,
        -52
      ]
    ],
    [
      [
        28339,
        59670
      ],
      [
        -17,
        16
      ],
      [
        9,
        165
      ],
      [
        -4,
        -2
      ],
      [
        -5,
        -15
      ],
      [
        -5,
        -4
      ],
      [
        -9,
        9
      ],
      [
        -4,
        -8
      ],
      [
        -6,
        7
      ],
      [
        -5,
        22
      ],
      [
        -7,
        8
      ]
    ],
    [
      [
        28043,
        59884
      ],
      [
        14,
        219
      ]
    ],
    [
      [
        28114,
        60150
      ],
      [
        2,
        -27
      ],
      [
        10,
        -25
      ],
      [
        7,
        1
      ],
      [
        0,
        -22
      ],
      [
        24,
        -47
      ],
      [
        1,
        -7
      ],
      [
        13,
        4
      ],
      [
        8,
        10
      ]
    ],
    [
      [
        28179,
        60037
      ],
      [
        -5,
        -214
      ],
      [
        -1,
        -71
      ]
    ],
    [
      [
        28173,
        59752
      ],
      [
        -6,
        7
      ],
      [
        -1,
        -9
      ],
      [
        -10,
        20
      ],
      [
        -7,
        6
      ],
      [
        -2,
        -13
      ],
      [
        -14,
        17
      ],
      [
        -20,
        7
      ],
      [
        -1,
        8
      ],
      [
        -9,
        6
      ],
      [
        -12,
        34
      ],
      [
        -7,
        -8
      ],
      [
        -4,
        20
      ],
      [
        -10,
        5
      ],
      [
        -7,
        -14
      ],
      [
        -3,
        23
      ],
      [
        -4,
        -3
      ],
      [
        -10,
        16
      ],
      [
        -3,
        10
      ]
    ],
    [
      [
        27299,
        62374
      ],
      [
        8,
        17
      ],
      [
        4,
        -3
      ],
      [
        5,
        -24
      ],
      [
        12,
        -16
      ],
      [
        7,
        2
      ]
    ],
    [
      [
        27349,
        62010
      ],
      [
        -13,
        -58
      ]
    ],
    [
      [
        27321,
        61887
      ],
      [
        -5,
        31
      ],
      [
        -6,
        -9
      ],
      [
        -2,
        8
      ],
      [
        -8,
        7
      ],
      [
        -3,
        37
      ],
      [
        1,
        23
      ],
      [
        -1,
        14
      ],
      [
        0,
        38
      ],
      [
        -7,
        32
      ],
      [
        -9,
        30
      ],
      [
        3,
        6
      ],
      [
        -2,
        31
      ],
      [
        3,
        -1
      ],
      [
        -2,
        23
      ],
      [
        -7,
        11
      ],
      [
        2,
        32
      ],
      [
        -6,
        15
      ],
      [
        3,
        2
      ],
      [
        -4,
        18
      ],
      [
        -4,
        4
      ]
    ],
    [
      [
        27075,
        60636
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -1
      ],
      [
        2,
        2
      ],
      [
        1,
        0
      ],
      [
        0,
        -7
      ],
      [
        1,
        -1
      ],
      [
        2,
        4
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        1,
        -2
      ],
      [
        1,
        -3
      ],
      [
        3,
        -2
      ],
      [
        1,
        -6
      ],
      [
        0,
        -2
      ]
    ],
    [
      [
        27093,
        60176
      ],
      [
        -3,
        -13
      ],
      [
        -7,
        -5
      ],
      [
        -7,
        2
      ],
      [
        -4,
        -9
      ],
      [
        -3,
        9
      ],
      [
        -5,
        -10
      ],
      [
        -4,
        -34
      ],
      [
        1,
        -25
      ],
      [
        -4,
        -5
      ],
      [
        -1,
        -16
      ],
      [
        -4,
        -6
      ],
      [
        -7,
        -9
      ],
      [
        -6,
        16
      ],
      [
        -5,
        -14
      ],
      [
        -10,
        2
      ]
    ],
    [
      [
        27024,
        60059
      ],
      [
        4,
        10
      ],
      [
        -1,
        23
      ],
      [
        -5,
        22
      ],
      [
        0,
        25
      ],
      [
        -4,
        6
      ],
      [
        0,
        16
      ],
      [
        -8,
        31
      ],
      [
        -10,
        66
      ],
      [
        -4,
        70
      ],
      [
        -12,
        39
      ],
      [
        -6,
        -12
      ]
    ],
    [
      [
        28000,
        59659
      ],
      [
        43,
        225
      ]
    ],
    [
      [
        28173,
        59752
      ],
      [
        -6,
        -272
      ]
    ],
    [
      [
        28167,
        59480
      ],
      [
        -24,
        -1
      ],
      [
        -31,
        1
      ],
      [
        -22,
        -1
      ]
    ],
    [
      [
        28053,
        59478
      ],
      [
        -4,
        0
      ],
      [
        -11,
        -2
      ],
      [
        -26,
        0
      ],
      [
        -17,
        1
      ],
      [
        -19,
        0
      ]
    ],
    [
      [
        26515,
        61398
      ],
      [
        -4,
        -20
      ],
      [
        -25,
        -69
      ]
    ],
    [
      [
        26486,
        61309
      ],
      [
        -57,
        -56
      ]
    ],
    [
      [
        26429,
        61253
      ],
      [
        0,
        9
      ],
      [
        -9,
        21
      ],
      [
        -2,
        -10
      ],
      [
        -10,
        16
      ],
      [
        -5,
        18
      ],
      [
        3,
        23
      ],
      [
        -1,
        28
      ],
      [
        5,
        24
      ],
      [
        -5,
        35
      ],
      [
        -8,
        -1
      ]
    ],
    [
      [
        27246,
        59515
      ],
      [
        13,
        1
      ],
      [
        12,
        -2
      ],
      [
        4,
        0
      ],
      [
        20,
        -2
      ],
      [
        2,
        -1
      ],
      [
        8,
        -2
      ],
      [
        5,
        0
      ],
      [
        11,
        -2
      ],
      [
        6,
        -1
      ],
      [
        1,
        0
      ],
      [
        13,
        -3
      ],
      [
        2,
        -1
      ],
      [
        17,
        0
      ],
      [
        12,
        -2
      ]
    ],
    [
      [
        27274,
        59273
      ],
      [
        2,
        18
      ],
      [
        -6,
        39
      ],
      [
        1,
        16
      ],
      [
        -2,
        21
      ],
      [
        -7,
        21
      ],
      [
        -7,
        37
      ],
      [
        -2,
        18
      ],
      [
        -7,
        39
      ],
      [
        0,
        33
      ]
    ],
    [
      [
        28143,
        60540
      ],
      [
        3,
        -11
      ],
      [
        6,
        3
      ],
      [
        3,
        9
      ],
      [
        7,
        -4
      ],
      [
        4,
        22
      ],
      [
        10,
        1
      ],
      [
        0,
        23
      ],
      [
        4,
        7
      ],
      [
        4,
        -14
      ],
      [
        9,
        -3
      ],
      [
        5,
        -9
      ],
      [
        3,
        8
      ],
      [
        7,
        -8
      ],
      [
        1,
        -22
      ],
      [
        3,
        -9
      ],
      [
        6,
        9
      ],
      [
        0,
        -22
      ],
      [
        3,
        -23
      ]
    ],
    [
      [
        28221,
        60497
      ],
      [
        -6,
        -1
      ],
      [
        2,
        -26
      ],
      [
        -3,
        -33
      ],
      [
        8,
        -13
      ],
      [
        4,
        -20
      ],
      [
        11,
        -5
      ],
      [
        -3,
        -21
      ],
      [
        0,
        -13
      ],
      [
        11,
        -23
      ],
      [
        2,
        -18
      ],
      [
        6,
        1
      ],
      [
        1,
        17
      ],
      [
        5,
        0
      ],
      [
        0,
        14
      ],
      [
        4,
        -1
      ],
      [
        3,
        -17
      ],
      [
        6,
        13
      ],
      [
        5,
        -31
      ],
      [
        1,
        -1
      ]
    ],
    [
      [
        28278,
        60319
      ],
      [
        -3,
        -27
      ],
      [
        -7,
        -8
      ],
      [
        -2,
        -16
      ],
      [
        -5,
        -3
      ],
      [
        -10,
        -30
      ],
      [
        -14,
        0
      ]
    ],
    [
      [
        28237,
        60235
      ],
      [
        -8,
        11
      ],
      [
        -113,
        109
      ]
    ],
    [
      [
        28555,
        60713
      ],
      [
        5,
        -15
      ],
      [
        6,
        -8
      ],
      [
        6,
        5
      ],
      [
        5,
        -15
      ],
      [
        1,
        -14
      ],
      [
        5,
        -9
      ],
      [
        1,
        13
      ],
      [
        8,
        -21
      ],
      [
        4,
        -1
      ],
      [
        2,
        -13
      ],
      [
        5,
        0
      ],
      [
        13,
        -26
      ]
    ],
    [
      [
        28625,
        60476
      ],
      [
        -3,
        3
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -15
      ],
      [
        -1,
        -5
      ],
      [
        -4,
        -2
      ],
      [
        -3,
        -15
      ],
      [
        3,
        -14
      ],
      [
        8,
        -25
      ],
      [
        5,
        -29
      ],
      [
        1,
        -16
      ],
      [
        1,
        -10
      ],
      [
        4,
        -7
      ],
      [
        4,
        -2
      ],
      [
        1,
        -5
      ],
      [
        -3,
        -4
      ],
      [
        -9,
        -6
      ],
      [
        -7,
        -1
      ],
      [
        -1,
        -10
      ],
      [
        -2,
        -3
      ],
      [
        -13,
        -3
      ],
      [
        -2,
        5
      ],
      [
        -3,
        -6
      ],
      [
        -1,
        -10
      ]
    ],
    [
      [
        28554,
        60453
      ],
      [
        -4,
        18
      ],
      [
        -11,
        42
      ]
    ],
    [
      [
        28029,
        62404
      ],
      [
        25,
        -33
      ],
      [
        2,
        23
      ],
      [
        -1,
        10
      ],
      [
        5,
        12
      ],
      [
        4,
        23
      ],
      [
        7,
        18
      ],
      [
        5,
        -11
      ],
      [
        8,
        4
      ],
      [
        2,
        7
      ],
      [
        0,
        -20
      ],
      [
        4,
        -10
      ],
      [
        -5,
        -8
      ],
      [
        -1,
        -11
      ],
      [
        4,
        -12
      ],
      [
        5,
        -29
      ],
      [
        0,
        -19
      ]
    ],
    [
      [
        28001,
        61878
      ],
      [
        -42,
        123
      ],
      [
        -21,
        62
      ]
    ],
    [
      [
        27938,
        62063
      ],
      [
        1,
        4
      ],
      [
        1,
        6
      ],
      [
        4,
        27
      ],
      [
        4,
        19
      ],
      [
        0,
        4
      ],
      [
        2,
        8
      ],
      [
        2,
        11
      ],
      [
        1,
        12
      ],
      [
        1,
        10
      ],
      [
        1,
        7
      ],
      [
        3,
        22
      ],
      [
        2,
        3
      ],
      [
        0,
        3
      ],
      [
        1,
        6
      ],
      [
        0,
        2
      ],
      [
        2,
        6
      ],
      [
        2,
        2
      ],
      [
        4,
        8
      ],
      [
        0,
        3
      ],
      [
        1,
        3
      ],
      [
        0,
        2
      ],
      [
        1,
        10
      ],
      [
        3,
        13
      ],
      [
        4,
        4
      ],
      [
        1,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        3
      ],
      [
        1,
        2
      ],
      [
        -1,
        -11
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -12
      ],
      [
        1,
        -5
      ],
      [
        0,
        -2
      ],
      [
        1,
        1
      ],
      [
        1,
        4
      ],
      [
        2,
        8
      ],
      [
        2,
        0
      ],
      [
        2,
        8
      ],
      [
        1,
        3
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        2,
        10
      ],
      [
        2,
        6
      ],
      [
        0,
        3
      ],
      [
        1,
        4
      ],
      [
        1,
        2
      ],
      [
        1,
        8
      ],
      [
        1,
        8
      ],
      [
        1,
        8
      ],
      [
        2,
        -1
      ],
      [
        2,
        9
      ],
      [
        0,
        3
      ],
      [
        1,
        3
      ],
      [
        0,
        1
      ],
      [
        1,
        2
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        0,
        -9
      ],
      [
        1,
        2
      ],
      [
        1,
        1
      ],
      [
        1,
        -8
      ],
      [
        2,
        -6
      ],
      [
        0,
        6
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        1,
        8
      ],
      [
        2,
        8
      ],
      [
        0,
        3
      ],
      [
        1,
        3
      ],
      [
        2,
        12
      ],
      [
        3,
        9
      ],
      [
        0,
        3
      ],
      [
        2,
        4
      ],
      [
        0,
        2
      ],
      [
        1,
        2
      ],
      [
        -2,
        3
      ],
      [
        -1,
        4
      ],
      [
        -1,
        2
      ],
      [
        -2,
        7
      ],
      [
        3,
        11
      ],
      [
        1,
        3
      ],
      [
        1,
        5
      ],
      [
        2,
        7
      ],
      [
        0,
        1
      ],
      [
        1,
        1
      ]
    ],
    [
      [
        27024,
        60059
      ],
      [
        -5,
        -1
      ],
      [
        -4,
        -16
      ],
      [
        -4,
        5
      ],
      [
        -14,
        -42
      ],
      [
        -4,
        -7
      ],
      [
        -7,
        11
      ],
      [
        -11,
        -32
      ]
    ],
    [
      [
        31293,
        38270
      ],
      [
        16,
        -4
      ],
      [
        0,
        6
      ]
    ],
    [
      [
        31309,
        38272
      ],
      [
        10,
        28
      ],
      [
        4,
        -15
      ],
      [
        1,
        -24
      ],
      [
        12,
        10
      ],
      [
        18,
        4
      ]
    ],
    [
      [
        31354,
        38275
      ],
      [
        -1,
        -6
      ],
      [
        8,
        0
      ],
      [
        5,
        -28
      ]
    ],
    [
      [
        31337,
        38071
      ],
      [
        -2,
        -2
      ],
      [
        3,
        28
      ],
      [
        -4,
        15
      ],
      [
        0,
        19
      ],
      [
        -4,
        15
      ],
      [
        -4,
        -1
      ],
      [
        -6,
        11
      ],
      [
        -2,
        -6
      ],
      [
        -6,
        6
      ],
      [
        -1,
        14
      ],
      [
        -5,
        15
      ],
      [
        -4,
        -1
      ],
      [
        -1,
        -23
      ],
      [
        -5,
        0
      ]
    ],
    [
      [
        31296,
        38161
      ],
      [
        0,
        6
      ],
      [
        -2,
        11
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        51
      ],
      [
        1,
        42
      ]
    ],
    [
      [
        24237,
        70068
      ],
      [
        34,
        0
      ]
    ],
    [
      [
        24408,
        70065
      ],
      [
        0,
        -402
      ]
    ],
    [
      [
        24373,
        69565
      ],
      [
        -103,
        1
      ],
      [
        -2,
        0
      ],
      [
        -32,
        1
      ]
    ],
    [
      [
        31178,
        38330
      ],
      [
        4,
        4
      ],
      [
        3,
        4
      ],
      [
        4,
        9
      ],
      [
        0,
        1
      ],
      [
        3,
        7
      ],
      [
        8,
        22
      ]
    ],
    [
      [
        31200,
        38377
      ],
      [
        1,
        -25
      ],
      [
        7,
        -5
      ]
    ],
    [
      [
        31208,
        38347
      ],
      [
        2,
        -21
      ],
      [
        -3,
        -29
      ],
      [
        2,
        -34
      ]
    ],
    [
      [
        31209,
        38263
      ],
      [
        -5,
        6
      ],
      [
        -10,
        -11
      ]
    ],
    [
      [
        15337,
        71411
      ],
      [
        56,
        -1
      ],
      [
        11,
        -2
      ],
      [
        5,
        1
      ],
      [
        131,
        0
      ]
    ],
    [
      [
        15540,
        71409
      ],
      [
        0,
        -67
      ],
      [
        1,
        -99
      ],
      [
        0,
        -101
      ],
      [
        2,
        -1
      ],
      [
        0,
        -207
      ]
    ],
    [
      [
        15543,
        70934
      ],
      [
        -102,
        1
      ],
      [
        -1,
        -111
      ]
    ],
    [
      [
        15440,
        70824
      ],
      [
        0,
        -1
      ],
      [
        -4,
        2
      ],
      [
        -5,
        -18
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        2
      ],
      [
        -2,
        6
      ],
      [
        -4,
        5
      ],
      [
        -3,
        -1
      ],
      [
        -19,
        -51
      ],
      [
        -9,
        7
      ],
      [
        -3,
        6
      ],
      [
        -10,
        30
      ],
      [
        -4,
        17
      ],
      [
        0,
        9
      ],
      [
        -2,
        5
      ],
      [
        -2,
        7
      ],
      [
        -5,
        5
      ],
      [
        -5,
        3
      ],
      [
        -3,
        -9
      ],
      [
        -2,
        -13
      ],
      [
        0,
        -16
      ],
      [
        -2,
        -9
      ],
      [
        -5,
        4
      ],
      [
        -5,
        -14
      ],
      [
        -1,
        2
      ],
      [
        1,
        7
      ],
      [
        1,
        25
      ],
      [
        2,
        11
      ],
      [
        1,
        25
      ],
      [
        2,
        69
      ],
      [
        0,
        26
      ],
      [
        1,
        98
      ],
      [
        -2,
        73
      ],
      [
        -2,
        53
      ],
      [
        0,
        39
      ],
      [
        2,
        9
      ],
      [
        2,
        4
      ],
      [
        2,
        0
      ],
      [
        3,
        -18
      ],
      [
        -4,
        -9
      ],
      [
        0,
        -6
      ],
      [
        6,
        -31
      ],
      [
        2,
        -10
      ],
      [
        0,
        -21
      ],
      [
        -1,
        -38
      ],
      [
        -1,
        -41
      ],
      [
        1,
        -39
      ],
      [
        3,
        -98
      ],
      [
        2,
        -9
      ],
      [
        7,
        9
      ],
      [
        5,
        -2
      ],
      [
        3,
        2
      ],
      [
        1,
        37
      ],
      [
        -3,
        -2
      ],
      [
        -1,
        8
      ],
      [
        0,
        20
      ],
      [
        -3,
        10
      ],
      [
        -3,
        4
      ],
      [
        -1,
        21
      ],
      [
        0,
        3
      ],
      [
        -1,
        4
      ],
      [
        0,
        23
      ],
      [
        2,
        10
      ],
      [
        1,
        1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -9
      ],
      [
        3,
        -17
      ],
      [
        0,
        -2
      ],
      [
        7,
        -9
      ],
      [
        1,
        2
      ],
      [
        -1,
        11
      ],
      [
        6,
        36
      ],
      [
        7,
        17
      ],
      [
        0,
        7
      ],
      [
        1,
        10
      ],
      [
        -3,
        17
      ],
      [
        -3,
        13
      ],
      [
        -1,
        5
      ],
      [
        -1,
        12
      ],
      [
        -2,
        13
      ],
      [
        -3,
        9
      ],
      [
        -4,
        9
      ],
      [
        -1,
        11
      ],
      [
        -1,
        27
      ],
      [
        6,
        5
      ],
      [
        5,
        11
      ],
      [
        0,
        26
      ],
      [
        2,
        7
      ],
      [
        5,
        6
      ],
      [
        9,
        17
      ],
      [
        4,
        5
      ],
      [
        5,
        0
      ],
      [
        1,
        7
      ],
      [
        -1,
        11
      ],
      [
        -4,
        2
      ],
      [
        -4,
        9
      ],
      [
        -3,
        1
      ],
      [
        -1,
        3
      ],
      [
        -5,
        22
      ],
      [
        -1,
        0
      ],
      [
        -4,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -5
      ],
      [
        1,
        -7
      ],
      [
        -1,
        -5
      ],
      [
        -4,
        -2
      ],
      [
        -5,
        0
      ],
      [
        -6,
        13
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -10
      ],
      [
        1,
        -13
      ],
      [
        3,
        -10
      ],
      [
        -2,
        -2
      ],
      [
        -4,
        5
      ],
      [
        -2,
        0
      ],
      [
        -3,
        -6
      ],
      [
        -5,
        7
      ],
      [
        -5,
        13
      ],
      [
        0,
        3
      ],
      [
        -2,
        4
      ],
      [
        -4,
        9
      ],
      [
        -5,
        2
      ],
      [
        -3,
        7
      ],
      [
        -1,
        6
      ],
      [
        0,
        12
      ],
      [
        -1,
        32
      ],
      [
        0,
        11
      ]
    ],
    [
      [
        27013,
        61145
      ],
      [
        17,
        20
      ],
      [
        23,
        27
      ],
      [
        5,
        -1
      ],
      [
        1,
        5
      ],
      [
        10,
        7
      ],
      [
        13,
        -4
      ],
      [
        3,
        5
      ]
    ],
    [
      [
        27085,
        61204
      ],
      [
        -14,
        -45
      ],
      [
        9,
        -17
      ],
      [
        11,
        3
      ],
      [
        2,
        -16
      ],
      [
        12,
        -15
      ],
      [
        12,
        -1
      ],
      [
        4,
        -13
      ],
      [
        6,
        -2
      ],
      [
        4,
        -34
      ],
      [
        2,
        -22
      ],
      [
        -6,
        -22
      ],
      [
        2,
        -15
      ],
      [
        8,
        -12
      ],
      [
        0,
        -17
      ],
      [
        4,
        -5
      ],
      [
        2,
        -18
      ],
      [
        6,
        15
      ],
      [
        11,
        12
      ],
      [
        4,
        -2
      ],
      [
        5,
        -29
      ],
      [
        -1,
        -4
      ],
      [
        7,
        -16
      ]
    ],
    [
      [
        27175,
        60929
      ],
      [
        -8,
        -13
      ],
      [
        -6,
        2
      ],
      [
        -5,
        -8
      ],
      [
        -5,
        2
      ],
      [
        -4,
        -13
      ],
      [
        -9,
        1
      ],
      [
        -7,
        -15
      ],
      [
        13,
        -42
      ],
      [
        5,
        -16
      ],
      [
        -3,
        -3
      ],
      [
        -22,
        -33
      ],
      [
        -3,
        -12
      ]
    ],
    [
      [
        27121,
        60779
      ],
      [
        -3,
        -6
      ],
      [
        -7,
        20
      ],
      [
        -3,
        -9
      ],
      [
        -5,
        17
      ],
      [
        -2,
        -11
      ],
      [
        -8,
        -10
      ],
      [
        -3,
        22
      ],
      [
        -5,
        2
      ],
      [
        -4,
        -12
      ],
      [
        -9,
        -4
      ],
      [
        -4,
        -24
      ],
      [
        0,
        -8
      ],
      [
        -2,
        11
      ],
      [
        -6,
        21
      ],
      [
        -6,
        39
      ],
      [
        -11,
        0
      ],
      [
        -2,
        36
      ],
      [
        -5,
        21
      ],
      [
        -3,
        -3
      ],
      [
        5,
        22
      ],
      [
        -2,
        40
      ],
      [
        -7,
        10
      ],
      [
        0,
        19
      ],
      [
        -4,
        16
      ],
      [
        10,
        23
      ],
      [
        -5,
        21
      ],
      [
        1,
        25
      ],
      [
        -11,
        15
      ],
      [
        -5,
        45
      ],
      [
        -4,
        14
      ],
      [
        2,
        14
      ]
    ],
    [
      [
        16328,
        60062
      ],
      [
        18,
        61
      ],
      [
        19,
        16
      ],
      [
        7,
        16
      ],
      [
        6,
        -5
      ],
      [
        6,
        5
      ],
      [
        4,
        14
      ],
      [
        6,
        6
      ],
      [
        4,
        13
      ],
      [
        4,
        0
      ],
      [
        13,
        13
      ],
      [
        18,
        -1
      ],
      [
        16,
        5
      ],
      [
        3,
        6
      ],
      [
        12,
        13
      ]
    ],
    [
      [
        16464,
        60224
      ],
      [
        81,
        272
      ],
      [
        31,
        1
      ],
      [
        0,
        50
      ],
      [
        10,
        1
      ],
      [
        0,
        38
      ],
      [
        9,
        0
      ],
      [
        0,
        77
      ],
      [
        76,
        253
      ]
    ],
    [
      [
        16682,
        60871
      ],
      [
        4,
        -16
      ],
      [
        5,
        2
      ],
      [
        6,
        -15
      ],
      [
        5,
        26
      ],
      [
        8,
        2
      ],
      [
        6,
        -7
      ],
      [
        7,
        2
      ],
      [
        4,
        -11
      ],
      [
        4,
        -24
      ],
      [
        8,
        -23
      ],
      [
        3,
        -46
      ],
      [
        6,
        -17
      ],
      [
        0,
        -31
      ],
      [
        3,
        -21
      ]
    ],
    [
      [
        25460,
        68909
      ],
      [
        2,
        6
      ],
      [
        2,
        8
      ],
      [
        0,
        12
      ],
      [
        4,
        12
      ]
    ],
    [
      [
        25468,
        68947
      ],
      [
        101,
        -2
      ]
    ],
    [
      [
        25569,
        68945
      ],
      [
        -6,
        -40
      ],
      [
        -2,
        -11
      ],
      [
        -1,
        -5
      ],
      [
        -4,
        -7
      ],
      [
        -5,
        -19
      ],
      [
        -3,
        -22
      ],
      [
        -6,
        -40
      ],
      [
        -4,
        -47
      ],
      [
        0,
        -8
      ],
      [
        -2,
        -32
      ],
      [
        -2,
        -19
      ],
      [
        -2,
        -43
      ],
      [
        -2,
        -11
      ],
      [
        -1,
        -23
      ],
      [
        0,
        -22
      ],
      [
        -1,
        -9
      ],
      [
        -4,
        -19
      ],
      [
        -2,
        -28
      ]
    ],
    [
      [
        25459,
        68540
      ],
      [
        1,
        101
      ],
      [
        0,
        268
      ]
    ],
    [
      [
        24920,
        62948
      ],
      [
        47,
        1
      ]
    ],
    [
      [
        25077,
        62745
      ],
      [
        0,
        -153
      ]
    ],
    [
      [
        24938,
        62338
      ],
      [
        -4,
        0
      ],
      [
        -13,
        -1
      ]
    ],
    [
      [
        19961,
        62592
      ],
      [
        5,
        20
      ],
      [
        9,
        -5
      ],
      [
        6,
        12
      ],
      [
        0,
        19
      ],
      [
        10,
        -1
      ]
    ],
    [
      [
        19991,
        62637
      ],
      [
        6,
        -20
      ],
      [
        -2,
        -9
      ],
      [
        1,
        -39
      ],
      [
        6,
        -29
      ],
      [
        10,
        -9
      ],
      [
        6,
        -14
      ],
      [
        4,
        -40
      ],
      [
        60,
        0
      ],
      [
        9,
        -28
      ],
      [
        4,
        -6
      ],
      [
        7,
        -24
      ],
      [
        2,
        -20
      ],
      [
        -4,
        -11
      ],
      [
        4,
        -14
      ],
      [
        7,
        -2
      ],
      [
        0,
        -13
      ],
      [
        5,
        -4
      ],
      [
        11,
        -26
      ],
      [
        8,
        3
      ],
      [
        0,
        15
      ],
      [
        4,
        3
      ],
      [
        4,
        -27
      ],
      [
        6,
        -10
      ],
      [
        7,
        0
      ],
      [
        14,
        56
      ],
      [
        1,
        19
      ],
      [
        10,
        6
      ],
      [
        5,
        9
      ],
      [
        2,
        -12
      ],
      [
        9,
        -1
      ],
      [
        4,
        -29
      ],
      [
        8,
        -28
      ],
      [
        3,
        3
      ]
    ],
    [
      [
        20212,
        62336
      ],
      [
        1,
        -4
      ],
      [
        2,
        -3
      ],
      [
        3,
        0
      ],
      [
        5,
        8
      ],
      [
        5,
        -12
      ],
      [
        6,
        -24
      ],
      [
        0,
        -16
      ],
      [
        4,
        -15
      ],
      [
        5,
        -17
      ],
      [
        5,
        -16
      ],
      [
        7,
        2
      ],
      [
        3,
        7
      ],
      [
        5,
        3
      ],
      [
        0,
        -4
      ],
      [
        3,
        -6
      ],
      [
        4,
        4
      ],
      [
        4,
        -1
      ],
      [
        5,
        -6
      ],
      [
        4,
        -5
      ],
      [
        6,
        -5
      ],
      [
        -1,
        -17
      ],
      [
        -2,
        -15
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        6
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -12
      ],
      [
        -2,
        -4
      ],
      [
        0,
        -5
      ],
      [
        1,
        -5
      ],
      [
        0,
        -3
      ],
      [
        1,
        -3
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -5
      ],
      [
        1,
        -9
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -10
      ],
      [
        1,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -35
      ],
      [
        -5,
        -17
      ],
      [
        -3,
        -3
      ],
      [
        -1,
        -12
      ],
      [
        2,
        -11
      ],
      [
        4,
        -33
      ],
      [
        6,
        -13
      ],
      [
        5,
        -8
      ],
      [
        1,
        -19
      ],
      [
        4,
        -5
      ],
      [
        3,
        -22
      ],
      [
        2,
        -18
      ],
      [
        2,
        -28
      ],
      [
        -2,
        -28
      ],
      [
        2,
        -30
      ],
      [
        2,
        -15
      ],
      [
        1,
        -3
      ],
      [
        1,
        -2
      ],
      [
        1,
        2
      ],
      [
        2,
        1
      ],
      [
        1,
        -3
      ],
      [
        2,
        -2
      ],
      [
        1,
        -9
      ],
      [
        1,
        -10
      ],
      [
        3,
        -4
      ],
      [
        1,
        -10
      ],
      [
        1,
        -8
      ],
      [
        2,
        -3
      ],
      [
        4,
        -15
      ],
      [
        3,
        -1
      ],
      [
        1,
        -8
      ],
      [
        0,
        -6
      ],
      [
        1,
        -7
      ]
    ],
    [
      [
        20100,
        61346
      ],
      [
        -158,
        0
      ]
    ],
    [
      [
        19942,
        61346
      ],
      [
        2,
        13
      ],
      [
        -5,
        63
      ],
      [
        -2,
        43
      ],
      [
        -7,
        13
      ],
      [
        -6,
        48
      ]
    ],
    [
      [
        25845,
        62734
      ],
      [
        36,
        2
      ]
    ],
    [
      [
        25928,
        62739
      ],
      [
        1,
        -137
      ],
      [
        0,
        -205
      ]
    ],
    [
      [
        25863,
        62395
      ],
      [
        -15,
        0
      ],
      [
        1,
        33
      ],
      [
        -1,
        203
      ],
      [
        -2,
        0
      ],
      [
        -1,
        103
      ]
    ],
    [
      [
        26782,
        52851
      ],
      [
        1,
        -6
      ],
      [
        2,
        17
      ],
      [
        10,
        12
      ]
    ],
    [
      [
        26795,
        52874
      ],
      [
        35,
        -40
      ],
      [
        0,
        -9
      ],
      [
        4,
        -22
      ],
      [
        -1,
        -10
      ],
      [
        1,
        -21
      ],
      [
        5,
        -7
      ],
      [
        3,
        -30
      ],
      [
        2,
        -9
      ],
      [
        8,
        -11
      ],
      [
        7,
        1
      ],
      [
        9,
        -5
      ],
      [
        3,
        6
      ],
      [
        7,
        -11
      ],
      [
        10,
        -9
      ],
      [
        10,
        -4
      ],
      [
        6,
        -21
      ],
      [
        -2,
        -24
      ],
      [
        1,
        -20
      ],
      [
        0,
        -77
      ]
    ],
    [
      [
        26903,
        52551
      ],
      [
        -29,
        7
      ]
    ],
    [
      [
        26874,
        52558
      ],
      [
        -3,
        0
      ],
      [
        -50,
        13
      ],
      [
        -70,
        17
      ],
      [
        -2,
        0
      ]
    ],
    [
      [
        26749,
        52588
      ],
      [
        1,
        193
      ],
      [
        2,
        16
      ],
      [
        6,
        1
      ],
      [
        0,
        30
      ],
      [
        5,
        2
      ],
      [
        0,
        20
      ],
      [
        19,
        1
      ]
    ],
    [
      [
        27851,
        58040
      ],
      [
        59,
        250
      ]
    ],
    [
      [
        27925,
        58362
      ],
      [
        38,
        -50
      ],
      [
        10,
        -13
      ],
      [
        10,
        -12
      ]
    ],
    [
      [
        28667,
        66305
      ],
      [
        34,
        3
      ]
    ],
    [
      [
        28701,
        66308
      ],
      [
        8,
        -116
      ],
      [
        -1,
        -27
      ],
      [
        5,
        -10
      ],
      [
        2,
        -24
      ],
      [
        -4,
        0
      ],
      [
        4,
        -32
      ],
      [
        -2,
        -51
      ],
      [
        -8,
        -1
      ],
      [
        1,
        -38
      ],
      [
        1,
        -60
      ],
      [
        0,
        -31
      ],
      [
        1,
        -50
      ],
      [
        0,
        -39
      ]
    ],
    [
      [
        28708,
        65829
      ],
      [
        -5,
        1
      ],
      [
        -2,
        0
      ],
      [
        -4,
        -1
      ]
    ],
    [
      [
        28697,
        65829
      ],
      [
        -57,
        0
      ],
      [
        -31,
        1
      ],
      [
        -3,
        0
      ],
      [
        -24,
        1
      ]
    ],
    [
      [
        28582,
        65831
      ],
      [
        5,
        60
      ],
      [
        -5,
        93
      ],
      [
        -1,
        28
      ],
      [
        7,
        0
      ],
      [
        0,
        147
      ]
    ],
    [
      [
        28582,
        59255
      ],
      [
        0,
        5
      ],
      [
        29,
        26
      ]
    ],
    [
      [
        28611,
        59286
      ],
      [
        2,
        -16
      ],
      [
        15,
        -89
      ],
      [
        5,
        -14
      ],
      [
        0,
        -20
      ],
      [
        8,
        -10
      ],
      [
        3,
        -10
      ],
      [
        5,
        -1
      ],
      [
        4,
        -22
      ],
      [
        5,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        4,
        -29
      ]
    ],
    [
      [
        28661,
        59066
      ],
      [
        -1,
        -4
      ],
      [
        4,
        -16
      ],
      [
        5,
        -11
      ],
      [
        5,
        -37
      ],
      [
        10,
        -27
      ],
      [
        -7,
        -14
      ],
      [
        -6,
        4
      ],
      [
        -7,
        7
      ],
      [
        -18,
        34
      ],
      [
        -13,
        5
      ],
      [
        -5,
        29
      ],
      [
        -15,
        34
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -7
      ],
      [
        23,
        -73
      ],
      [
        8,
        0
      ],
      [
        3,
        -12
      ],
      [
        10,
        -11
      ],
      [
        -1,
        -10
      ],
      [
        -6,
        -9
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        3
      ],
      [
        -5,
        0
      ],
      [
        -16,
        -10
      ],
      [
        0,
        -3
      ]
    ],
    [
      [
        28623,
        58934
      ],
      [
        -10,
        1
      ],
      [
        -4,
        13
      ],
      [
        -5,
        7
      ],
      [
        -3,
        -10
      ],
      [
        -8,
        15
      ],
      [
        -6,
        -4
      ],
      [
        -9,
        16
      ],
      [
        -5,
        152
      ],
      [
        5,
        22
      ],
      [
        2,
        41
      ],
      [
        -1,
        19
      ],
      [
        2,
        15
      ],
      [
        1,
        34
      ]
    ],
    [
      [
        25524,
        58838
      ],
      [
        0,
        -27
      ],
      [
        -10,
        -25
      ],
      [
        -5,
        6
      ],
      [
        -7,
        -4
      ],
      [
        1,
        -4
      ],
      [
        -14,
        -36
      ],
      [
        -7,
        1
      ],
      [
        -6,
        -12
      ],
      [
        -3,
        -78
      ]
    ],
    [
      [
        20523,
        60683
      ],
      [
        8,
        15
      ],
      [
        4,
        25
      ],
      [
        9,
        7
      ],
      [
        2,
        -6
      ],
      [
        9,
        31
      ],
      [
        6,
        -2
      ],
      [
        14,
        24
      ],
      [
        17,
        -44
      ],
      [
        6,
        7
      ],
      [
        8,
        -8
      ],
      [
        -5,
        -30
      ],
      [
        -4,
        -14
      ],
      [
        7,
        -18
      ],
      [
        4,
        -24
      ],
      [
        2,
        -38
      ],
      [
        -1,
        -44
      ],
      [
        0,
        -22
      ],
      [
        5,
        1
      ],
      [
        5,
        -46
      ],
      [
        3,
        -7
      ],
      [
        -3,
        -13
      ],
      [
        -4,
        -1
      ],
      [
        -3,
        -13
      ],
      [
        -1,
        -32
      ],
      [
        1,
        -38
      ],
      [
        0,
        -46
      ],
      [
        3,
        5
      ]
    ],
    [
      [
        20615,
        60352
      ],
      [
        0,
        -347
      ]
    ],
    [
      [
        20615,
        60005
      ],
      [
        -19,
        0
      ]
    ],
    [
      [
        20664,
        63541
      ],
      [
        1,
        0
      ],
      [
        0,
        -4
      ],
      [
        -1,
        0
      ],
      [
        0,
        4
      ]
    ],
    [
      [
        20674,
        64664
      ],
      [
        24,
        0
      ],
      [
        7,
        2
      ],
      [
        16,
        1
      ],
      [
        27,
        1
      ],
      [
        21,
        0
      ],
      [
        29,
        1
      ],
      [
        8,
        -1
      ],
      [
        71,
        1
      ],
      [
        25,
        0
      ],
      [
        5,
        -1
      ],
      [
        6,
        1
      ],
      [
        5,
        -1
      ],
      [
        4,
        0
      ]
    ],
    [
      [
        21055,
        64669
      ],
      [
        0,
        -349
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -202
      ]
    ],
    [
      [
        20895,
        63504
      ],
      [
        -95,
        -1
      ],
      [
        -131,
        0
      ]
    ],
    [
      [
        20669,
        63503
      ],
      [
        0,
        51
      ],
      [
        -11,
        -21
      ],
      [
        3,
        -21
      ],
      [
        -5,
        -9
      ],
      [
        -13,
        0
      ]
    ],
    [
      [
        20643,
        63503
      ],
      [
        -1,
        1
      ],
      [
        0,
        160
      ],
      [
        1,
        76
      ],
      [
        0,
        67
      ]
    ],
    [
      [
        20643,
        63807
      ],
      [
        0,
        86
      ],
      [
        -1,
        16
      ],
      [
        31,
        0
      ],
      [
        0,
        287
      ],
      [
        1,
        101
      ],
      [
        0,
        367
      ]
    ],
    [
      [
        26190,
        57412
      ],
      [
        3,
        60
      ],
      [
        3,
        -8
      ],
      [
        5,
        8
      ],
      [
        12,
        0
      ],
      [
        0,
        52
      ],
      [
        8,
        0
      ],
      [
        3,
        8
      ],
      [
        1,
        35
      ],
      [
        1,
        1
      ],
      [
        5,
        45
      ],
      [
        0,
        37
      ],
      [
        5,
        1
      ],
      [
        0,
        17
      ]
    ],
    [
      [
        26236,
        57668
      ],
      [
        47,
        0
      ]
    ],
    [
      [
        26254,
        57256
      ],
      [
        -3,
        -21
      ],
      [
        -35,
        8
      ]
    ],
    [
      [
        26444,
        62138
      ],
      [
        1,
        -1
      ],
      [
        1,
        -11
      ],
      [
        1,
        -4
      ],
      [
        2,
        -10
      ],
      [
        2,
        -3
      ],
      [
        2,
        -2
      ],
      [
        12,
        -7
      ],
      [
        6,
        -6
      ],
      [
        5,
        -8
      ],
      [
        2,
        -4
      ],
      [
        4,
        -5
      ],
      [
        7,
        -6
      ],
      [
        2,
        1
      ],
      [
        3,
        0
      ]
    ],
    [
      [
        26494,
        62072
      ],
      [
        2,
        -1
      ],
      [
        6,
        6
      ],
      [
        5,
        6
      ],
      [
        3,
        2
      ],
      [
        5,
        6
      ],
      [
        4,
        0
      ],
      [
        3,
        -1
      ],
      [
        2,
        -3
      ],
      [
        5,
        -11
      ],
      [
        0,
        -3
      ],
      [
        3,
        -3
      ],
      [
        1,
        1
      ],
      [
        2,
        -2
      ]
    ],
    [
      [
        26535,
        62069
      ],
      [
        -24,
        -203
      ]
    ],
    [
      [
        26511,
        61866
      ],
      [
        -2,
        -12
      ],
      [
        -10,
        -1
      ],
      [
        -3,
        20
      ],
      [
        -8,
        -2
      ],
      [
        -3,
        12
      ],
      [
        0,
        -13
      ],
      [
        -5,
        -13
      ],
      [
        -5,
        -26
      ],
      [
        -7,
        -16
      ],
      [
        -4,
        5
      ]
    ],
    [
      [
        26451,
        61852
      ],
      [
        3,
        8
      ],
      [
        -1,
        17
      ],
      [
        -2,
        -7
      ],
      [
        -8,
        262
      ],
      [
        1,
        6
      ]
    ],
    [
      [
        25990,
        63757
      ],
      [
        -21,
        0
      ],
      [
        -85,
        -3
      ]
    ],
    [
      [
        25884,
        63938
      ],
      [
        0,
        34
      ],
      [
        32,
        1
      ],
      [
        19,
        1
      ],
      [
        23,
        2
      ],
      [
        32,
        0
      ]
    ],
    [
      [
        26165,
        59923
      ],
      [
        8,
        84
      ],
      [
        11,
        42
      ],
      [
        21,
        108
      ],
      [
        13,
        70
      ]
    ],
    [
      [
        26212,
        59846
      ],
      [
        -15,
        -37
      ],
      [
        -22,
        55
      ],
      [
        -10,
        13
      ],
      [
        5,
        -36
      ]
    ],
    [
      [
        25350,
        59856
      ],
      [
        -6,
        39
      ],
      [
        -3,
        40
      ],
      [
        -14,
        54
      ]
    ],
    [
      [
        22178,
        60454
      ],
      [
        0,
        -220
      ],
      [
        1,
        -224
      ]
    ],
    [
      [
        22179,
        60010
      ],
      [
        -30,
        0
      ],
      [
        -3,
        1
      ],
      [
        -32,
        0
      ],
      [
        -3,
        1
      ],
      [
        -61,
        0
      ]
    ],
    [
      [
        22050,
        60012
      ],
      [
        -1,
        0
      ],
      [
        -23,
        1
      ]
    ],
    [
      [
        22026,
        60013
      ],
      [
        -1,
        448
      ],
      [
        -4,
        0
      ],
      [
        0,
        102
      ]
    ],
    [
      [
        28028,
        58872
      ],
      [
        -38,
        61
      ],
      [
        -10,
        2
      ],
      [
        -9,
        -6
      ]
    ],
    [
      [
        28806,
        57915
      ],
      [
        1,
        -17
      ]
    ],
    [
      [
        28807,
        57898
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        -3
      ],
      [
        -6,
        -9
      ],
      [
        -14,
        -25
      ],
      [
        -20,
        -36
      ],
      [
        -9,
        -17
      ],
      [
        -5,
        -15
      ],
      [
        -6,
        -13
      ],
      [
        -5,
        -16
      ],
      [
        -3,
        -7
      ],
      [
        -1,
        4
      ],
      [
        1,
        4
      ],
      [
        3,
        18
      ],
      [
        3,
        10
      ],
      [
        1,
        10
      ],
      [
        -1,
        9
      ],
      [
        1,
        7
      ],
      [
        1,
        6
      ],
      [
        3,
        1
      ],
      [
        2,
        -4
      ],
      [
        3,
        3
      ],
      [
        9,
        17
      ],
      [
        4,
        9
      ],
      [
        4,
        9
      ],
      [
        15,
        26
      ],
      [
        6,
        5
      ],
      [
        2,
        2
      ],
      [
        3,
        5
      ],
      [
        2,
        7
      ],
      [
        2,
        6
      ],
      [
        9,
        6
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        28624,
        58494
      ],
      [
        38,
        -8
      ],
      [
        -7,
        -95
      ],
      [
        7,
        -1
      ],
      [
        15,
        -11
      ],
      [
        6,
        25
      ],
      [
        1,
        31
      ],
      [
        4,
        10
      ],
      [
        -1,
        12
      ],
      [
        3,
        10
      ],
      [
        -1,
        19
      ],
      [
        1,
        9
      ],
      [
        7,
        5
      ],
      [
        4,
        -12
      ],
      [
        4,
        0
      ],
      [
        -1,
        -10
      ],
      [
        8,
        -16
      ],
      [
        8,
        6
      ],
      [
        5,
        -11
      ]
    ],
    [
      [
        28725,
        58457
      ],
      [
        0,
        -7
      ],
      [
        1,
        -10
      ],
      [
        3,
        -2
      ],
      [
        5,
        23
      ]
    ],
    [
      [
        28734,
        58461
      ],
      [
        31,
        0
      ],
      [
        3,
        -19
      ],
      [
        0,
        -11
      ],
      [
        4,
        -21
      ],
      [
        -1,
        -21
      ],
      [
        3,
        -28
      ]
    ],
    [
      [
        28774,
        58361
      ],
      [
        -7,
        -12
      ],
      [
        -4,
        -16
      ],
      [
        0,
        -15
      ],
      [
        -2,
        -9
      ],
      [
        -8,
        -5
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        -3,
        -17
      ],
      [
        0,
        -8
      ],
      [
        1,
        -9
      ],
      [
        0,
        -4
      ],
      [
        -7,
        -11
      ],
      [
        -2,
        -10
      ],
      [
        0,
        -14
      ],
      [
        -1,
        -12
      ],
      [
        -3,
        -13
      ],
      [
        -1,
        -11
      ],
      [
        0,
        -11
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -8
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        6
      ],
      [
        -3,
        2
      ],
      [
        -3,
        -6
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -8
      ],
      [
        1,
        -7
      ],
      [
        0,
        -10
      ],
      [
        -3,
        -15
      ],
      [
        -6,
        -11
      ],
      [
        -9,
        -12
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        -12
      ],
      [
        0,
        -12
      ],
      [
        -2,
        -3
      ],
      [
        -5,
        3
      ],
      [
        -1,
        4
      ],
      [
        -3,
        5
      ],
      [
        -7,
        0
      ],
      [
        -8,
        16
      ],
      [
        -5,
        0
      ],
      [
        -1,
        -7
      ],
      [
        -2,
        -1
      ],
      [
        -5,
        3
      ],
      [
        -6,
        11
      ],
      [
        -7,
        2
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -10
      ],
      [
        -3,
        -1
      ],
      [
        -4,
        3
      ],
      [
        -3,
        8
      ],
      [
        -2,
        2
      ],
      [
        -2,
        0
      ],
      [
        -3,
        -10
      ],
      [
        -2,
        2
      ],
      [
        -1,
        4
      ],
      [
        -3,
        6
      ],
      [
        -3,
        4
      ],
      [
        -1,
        18
      ],
      [
        -4,
        7
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -4
      ],
      [
        -3,
        -10
      ],
      [
        -4,
        0
      ],
      [
        -4,
        11
      ],
      [
        -11,
        34
      ],
      [
        -13,
        115
      ],
      [
        31,
        3
      ],
      [
        5,
        45
      ],
      [
        -3,
        6
      ]
    ],
    [
      [
        28607,
        58329
      ],
      [
        -10,
        30
      ],
      [
        -10,
        2
      ],
      [
        2,
        15
      ],
      [
        -5,
        1
      ],
      [
        -7,
        17
      ],
      [
        -7,
        28
      ],
      [
        -1,
        13
      ],
      [
        1,
        27
      ],
      [
        -10,
        41
      ]
    ],
    [
      [
        24582,
        55363
      ],
      [
        0,
        105
      ],
      [
        15,
        -3
      ],
      [
        44,
        1
      ]
    ],
    [
      [
        24654,
        55264
      ],
      [
        -29,
        -101
      ],
      [
        0,
        -25
      ],
      [
        6,
        -6
      ],
      [
        4,
        11
      ],
      [
        9,
        -4
      ],
      [
        -5,
        -10
      ],
      [
        -1,
        -19
      ],
      [
        2,
        -14
      ],
      [
        5,
        -14
      ],
      [
        -1,
        -14
      ],
      [
        -7,
        -7
      ],
      [
        -5,
        9
      ],
      [
        -2,
        -31
      ],
      [
        8,
        -26
      ],
      [
        6,
        0
      ],
      [
        8,
        -21
      ],
      [
        -2,
        -22
      ],
      [
        -4,
        -7
      ],
      [
        -3,
        25
      ],
      [
        -3,
        6
      ],
      [
        -4,
        -33
      ]
    ],
    [
      [
        24636,
        54961
      ],
      [
        -68,
        1
      ],
      [
        1,
        204
      ],
      [
        2,
        17
      ],
      [
        4,
        11
      ],
      [
        0,
        27
      ],
      [
        3,
        26
      ],
      [
        4,
        42
      ],
      [
        0,
        74
      ]
    ],
    [
      [
        31330,
        38045
      ],
      [
        -5,
        2
      ],
      [
        -4,
        -22
      ],
      [
        -6,
        1
      ],
      [
        -6,
        24
      ]
    ],
    [
      [
        31309,
        38050
      ],
      [
        -4,
        5
      ],
      [
        -4,
        -6
      ]
    ],
    [
      [
        31301,
        38049
      ],
      [
        -1,
        17
      ],
      [
        -7,
        14
      ],
      [
        0,
        13
      ]
    ],
    [
      [
        31293,
        38093
      ],
      [
        -2,
        16
      ],
      [
        1,
        51
      ],
      [
        4,
        1
      ]
    ],
    [
      [
        26773,
        55448
      ],
      [
        2,
        -23
      ],
      [
        -7,
        -39
      ],
      [
        5,
        -28
      ],
      [
        1,
        -21
      ],
      [
        -6,
        -13
      ],
      [
        -1,
        -32
      ]
    ],
    [
      [
        26767,
        55292
      ],
      [
        -12,
        31
      ],
      [
        -2,
        33
      ],
      [
        -3,
        7
      ],
      [
        -4,
        1
      ],
      [
        -9,
        -24
      ],
      [
        5,
        -21
      ],
      [
        -12,
        16
      ],
      [
        -18,
        -29
      ],
      [
        -2,
        -19
      ],
      [
        -3,
        11
      ],
      [
        -19,
        -30
      ]
    ],
    [
      [
        26668,
        55570
      ],
      [
        3,
        -9
      ],
      [
        7,
        7
      ],
      [
        8,
        -17
      ],
      [
        0,
        13
      ],
      [
        9,
        -15
      ],
      [
        3,
        18
      ],
      [
        8,
        9
      ],
      [
        5,
        -4
      ]
    ],
    [
      [
        22469,
        66993
      ],
      [
        1,
        -12
      ],
      [
        2,
        -12
      ],
      [
        3,
        -17
      ],
      [
        3,
        -18
      ],
      [
        2,
        -4
      ],
      [
        0,
        -1
      ],
      [
        2,
        -6
      ],
      [
        1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -7
      ],
      [
        2,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        1,
        1
      ],
      [
        2,
        0
      ],
      [
        4,
        -8
      ],
      [
        2,
        -3
      ],
      [
        3,
        -5
      ],
      [
        4,
        -6
      ],
      [
        4,
        -7
      ],
      [
        4,
        -5
      ],
      [
        2,
        -6
      ],
      [
        1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        1,
        -2
      ],
      [
        2,
        -3
      ],
      [
        3,
        -2
      ]
    ],
    [
      [
        22522,
        66858
      ],
      [
        0,
        -114
      ],
      [
        1,
        -27
      ]
    ],
    [
      [
        22258,
        66767
      ],
      [
        1,
        117
      ],
      [
        0,
        109
      ]
    ],
    [
      [
        27870,
        61354
      ],
      [
        3,
        29
      ],
      [
        3,
        8
      ],
      [
        9,
        1
      ],
      [
        4,
        4
      ],
      [
        3,
        10
      ],
      [
        3,
        -4
      ],
      [
        0,
        -4
      ],
      [
        4,
        -12
      ],
      [
        -4,
        -6
      ],
      [
        3,
        -11
      ],
      [
        -2,
        -27
      ],
      [
        -3,
        -13
      ],
      [
        -5,
        -12
      ],
      [
        -6,
        10
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        0
      ],
      [
        -6,
        16
      ],
      [
        -2,
        16
      ]
    ],
    [
      [
        23076,
        64719
      ],
      [
        6,
        -20
      ],
      [
        4,
        -7
      ],
      [
        10,
        -3
      ],
      [
        4,
        -21
      ],
      [
        4,
        -8
      ],
      [
        4,
        2
      ],
      [
        17,
        25
      ],
      [
        10,
        36
      ],
      [
        15,
        20
      ],
      [
        6,
        1
      ],
      [
        8,
        -7
      ],
      [
        5,
        -9
      ],
      [
        10,
        7
      ],
      [
        1,
        -1
      ],
      [
        1,
        0
      ],
      [
        15,
        1
      ],
      [
        3,
        -6
      ]
    ],
    [
      [
        22413,
        68388
      ],
      [
        103,
        0
      ]
    ],
    [
      [
        19530,
        53413
      ],
      [
        -64,
        2
      ],
      [
        -154,
        0
      ],
      [
        -47,
        -1
      ],
      [
        -39,
        1
      ],
      [
        -89,
        -2
      ]
    ],
    [
      [
        23594,
        57109
      ],
      [
        0,
        47
      ],
      [
        1,
        101
      ],
      [
        0,
        10
      ],
      [
        1,
        59
      ],
      [
        0,
        41
      ]
    ],
    [
      [
        23655,
        56742
      ],
      [
        -63,
        -3
      ]
    ],
    [
      [
        23592,
        56739
      ],
      [
        1,
        189
      ],
      [
        0,
        79
      ],
      [
        1,
        102
      ]
    ],
    [
      [
        27378,
        57051
      ],
      [
        11,
        -45
      ],
      [
        4,
        -8
      ],
      [
        9,
        1
      ],
      [
        3,
        -8
      ],
      [
        0,
        -24
      ],
      [
        4,
        -10
      ],
      [
        -16,
        -126
      ]
    ],
    [
      [
        27393,
        56831
      ],
      [
        -22,
        -11
      ],
      [
        -16,
        -8
      ],
      [
        -22,
        -23
      ],
      [
        0,
        5
      ],
      [
        -8,
        -5
      ],
      [
        -7,
        -22
      ],
      [
        -24,
        8
      ],
      [
        3,
        -30
      ],
      [
        -2,
        -24
      ],
      [
        -14,
        37
      ],
      [
        -7,
        -4
      ],
      [
        -7,
        32
      ],
      [
        -5,
        9
      ],
      [
        -6,
        2
      ]
    ],
    [
      [
        27256,
        56797
      ],
      [
        -4,
        23
      ],
      [
        -3,
        9
      ],
      [
        1,
        27
      ],
      [
        -4,
        15
      ],
      [
        -4,
        27
      ],
      [
        -1,
        30
      ],
      [
        -7,
        41
      ],
      [
        0,
        16
      ],
      [
        -7,
        62
      ],
      [
        2,
        16
      ],
      [
        -2,
        31
      ]
    ],
    [
      [
        16637,
        56552
      ],
      [
        8,
        -17
      ],
      [
        11,
        14
      ],
      [
        5,
        -8
      ],
      [
        -5,
        -22
      ],
      [
        -8,
        -7
      ],
      [
        -9,
        3
      ],
      [
        -9,
        21
      ],
      [
        7,
        16
      ]
    ],
    [
      [
        16634,
        57567
      ],
      [
        17,
        0
      ],
      [
        0,
        -25
      ],
      [
        29,
        0
      ],
      [
        0,
        -26
      ],
      [
        10,
        1
      ],
      [
        0,
        -51
      ],
      [
        74,
        -2
      ],
      [
        0,
        -25
      ],
      [
        26,
        0
      ]
    ],
    [
      [
        16790,
        57439
      ],
      [
        24,
        -203
      ],
      [
        16,
        -137
      ],
      [
        5,
        -37
      ],
      [
        0,
        -1
      ],
      [
        8,
        -70
      ],
      [
        6,
        -53
      ],
      [
        5,
        -43
      ],
      [
        5,
        -37
      ],
      [
        1,
        -26
      ],
      [
        0,
        -32
      ],
      [
        -5,
        -2
      ],
      [
        -5,
        -4
      ],
      [
        0,
        -80
      ],
      [
        -34,
        0
      ],
      [
        -19,
        -48
      ],
      [
        -23,
        -60
      ],
      [
        -1,
        -35
      ]
    ],
    [
      [
        16773,
        56571
      ],
      [
        -3,
        3
      ],
      [
        -6,
        14
      ],
      [
        -6,
        7
      ],
      [
        -2,
        0
      ],
      [
        -9,
        20
      ],
      [
        -7,
        7
      ],
      [
        -2,
        2
      ],
      [
        -5,
        9
      ],
      [
        -3,
        1
      ],
      [
        -3,
        -6
      ],
      [
        -6,
        7
      ],
      [
        -16,
        45
      ],
      [
        -4,
        6
      ],
      [
        -2,
        1
      ],
      [
        -2,
        1
      ],
      [
        -2,
        15
      ],
      [
        -1,
        4
      ],
      [
        -3,
        16
      ],
      [
        -5,
        44
      ],
      [
        -3,
        24
      ],
      [
        -1,
        22
      ],
      [
        -1,
        6
      ],
      [
        -1,
        10
      ],
      [
        -4,
        9
      ],
      [
        -3,
        -2
      ],
      [
        -3,
        3
      ],
      [
        -7,
        17
      ],
      [
        -3,
        17
      ],
      [
        -6,
        17
      ],
      [
        -1,
        2
      ],
      [
        -4,
        -4
      ],
      [
        0,
        1
      ],
      [
        -11,
        40
      ],
      [
        -1,
        3
      ],
      [
        -1,
        0
      ],
      [
        -7,
        22
      ],
      [
        -3,
        2
      ],
      [
        -2,
        1
      ]
    ],
    [
      [
        16596,
        55679
      ],
      [
        5,
        -9
      ],
      [
        2,
        2
      ],
      [
        2,
        9
      ],
      [
        1,
        0
      ],
      [
        3,
        5
      ],
      [
        1,
        0
      ],
      [
        7,
        -14
      ],
      [
        6,
        -11
      ],
      [
        5,
        -5
      ],
      [
        2,
        -5
      ],
      [
        8,
        -31
      ],
      [
        -4,
        -11
      ],
      [
        -6,
        -4
      ],
      [
        -3,
        0
      ],
      [
        -7,
        6
      ],
      [
        -3,
        3
      ],
      [
        -2,
        4
      ],
      [
        -8,
        8
      ],
      [
        -5,
        16
      ],
      [
        0,
        6
      ],
      [
        -2,
        6
      ],
      [
        -2,
        25
      ]
    ],
    [
      [
        17004,
        56219
      ],
      [
        6,
        18
      ],
      [
        0,
        32
      ],
      [
        2,
        20
      ],
      [
        4,
        14
      ],
      [
        2,
        5
      ],
      [
        0,
        6
      ],
      [
        2,
        12
      ],
      [
        0,
        13
      ],
      [
        6,
        23
      ],
      [
        2,
        1
      ],
      [
        0,
        8
      ],
      [
        5,
        0
      ],
      [
        3,
        17
      ],
      [
        2,
        0
      ],
      [
        5,
        21
      ],
      [
        0,
        46
      ],
      [
        14,
        0
      ],
      [
        1,
        2
      ],
      [
        38,
        -1
      ]
    ],
    [
      [
        17127,
        56368
      ],
      [
        0,
        -15
      ],
      [
        3,
        -1
      ],
      [
        23,
        -102
      ],
      [
        3,
        -6
      ],
      [
        8,
        -7
      ],
      [
        1,
        -1
      ],
      [
        1,
        -55
      ],
      [
        16,
        -8
      ],
      [
        18,
        -52
      ],
      [
        -13,
        -66
      ],
      [
        -15,
        -79
      ],
      [
        1,
        -34
      ]
    ],
    [
      [
        17173,
        55942
      ],
      [
        0,
        -41
      ],
      [
        -8,
        -16
      ],
      [
        -12,
        -2
      ],
      [
        -4,
        -78
      ]
    ],
    [
      [
        17149,
        55805
      ],
      [
        -4,
        22
      ],
      [
        -6,
        28
      ],
      [
        -4,
        12
      ],
      [
        -11,
        25
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        -7,
        7
      ],
      [
        -3,
        27
      ],
      [
        -1,
        6
      ],
      [
        -8,
        32
      ],
      [
        -7,
        30
      ],
      [
        -5,
        5
      ],
      [
        -3,
        7
      ],
      [
        -7,
        25
      ],
      [
        -11,
        22
      ],
      [
        -6,
        8
      ],
      [
        -8,
        7
      ],
      [
        -3,
        17
      ],
      [
        -17,
        40
      ],
      [
        -8,
        26
      ],
      [
        -1,
        2
      ],
      [
        -9,
        38
      ],
      [
        -7,
        22
      ],
      [
        -3,
        5
      ],
      [
        -4,
        10
      ]
    ],
    [
      [
        26880,
        50342
      ],
      [
        44,
        1
      ],
      [
        25,
        0
      ],
      [
        0,
        -34
      ],
      [
        44,
        2
      ]
    ],
    [
      [
        26877,
        50038
      ],
      [
        0,
        1
      ],
      [
        1,
        9
      ],
      [
        -2,
        18
      ],
      [
        3,
        9
      ],
      [
        2,
        23
      ],
      [
        0,
        5
      ],
      [
        -1,
        10
      ],
      [
        -1,
        4
      ],
      [
        0,
        22
      ],
      [
        1,
        10
      ],
      [
        1,
        2
      ],
      [
        0,
        3
      ],
      [
        2,
        14
      ],
      [
        -1,
        6
      ],
      [
        0,
        5
      ],
      [
        1,
        16
      ],
      [
        1,
        27
      ],
      [
        -3,
        18
      ],
      [
        -3,
        48
      ],
      [
        2,
        54
      ]
    ],
    [
      [
        27127,
        54368
      ],
      [
        43,
        43
      ],
      [
        53,
        60
      ]
    ],
    [
      [
        27223,
        54471
      ],
      [
        2,
        -30
      ],
      [
        4,
        -4
      ],
      [
        -1,
        -18
      ],
      [
        3,
        -52
      ],
      [
        1,
        -2
      ],
      [
        -1,
        -56
      ],
      [
        4,
        -7
      ]
    ],
    [
      [
        27235,
        54302
      ],
      [
        2,
        -7
      ],
      [
        0,
        -12
      ],
      [
        5,
        -37
      ],
      [
        9,
        -24
      ],
      [
        9,
        -33
      ],
      [
        -2,
        -17
      ],
      [
        6,
        -7
      ],
      [
        1,
        -41
      ],
      [
        4,
        -5
      ],
      [
        -1,
        -16
      ],
      [
        3,
        2
      ],
      [
        -1,
        -19
      ],
      [
        3,
        -6
      ],
      [
        4,
        8
      ],
      [
        3,
        -7
      ],
      [
        -3,
        -17
      ],
      [
        1,
        -5
      ],
      [
        10,
        41
      ],
      [
        3,
        -4
      ],
      [
        0,
        -12
      ],
      [
        -7,
        -13
      ],
      [
        2,
        -11
      ],
      [
        8,
        15
      ],
      [
        6,
        -16
      ],
      [
        2,
        -29
      ],
      [
        4,
        -8
      ],
      [
        -6,
        -25
      ],
      [
        0,
        -12
      ],
      [
        -5,
        -9
      ],
      [
        -1,
        -29
      ],
      [
        5,
        -4
      ],
      [
        0,
        -10
      ],
      [
        -3,
        -18
      ],
      [
        4,
        -21
      ],
      [
        1,
        -23
      ]
    ],
    [
      [
        27301,
        53871
      ],
      [
        -1,
        3
      ],
      [
        -9,
        6
      ],
      [
        -2,
        -9
      ]
    ],
    [
      [
        23731,
        67576
      ],
      [
        0,
        -284
      ]
    ],
    [
      [
        23731,
        66887
      ],
      [
        -132,
        1
      ]
    ],
    [
      [
        23599,
        66888
      ],
      [
        0,
        404
      ]
    ],
    [
      [
        21482,
        60760
      ],
      [
        0,
        110
      ]
    ],
    [
      [
        21617,
        60463
      ],
      [
        -135,
        0
      ]
    ],
    [
      [
        20615,
        60352
      ],
      [
        1,
        3
      ],
      [
        4,
        4
      ],
      [
        3,
        -3
      ],
      [
        4,
        2
      ],
      [
        3,
        6
      ],
      [
        1,
        8
      ],
      [
        2,
        5
      ],
      [
        2,
        1
      ],
      [
        2,
        3
      ],
      [
        2,
        9
      ],
      [
        2,
        3
      ],
      [
        2,
        2
      ],
      [
        2,
        6
      ],
      [
        3,
        6
      ],
      [
        1,
        -1
      ],
      [
        2,
        0
      ],
      [
        0,
        15
      ],
      [
        2,
        6
      ],
      [
        3,
        6
      ],
      [
        2,
        7
      ],
      [
        5,
        5
      ],
      [
        3,
        5
      ],
      [
        5,
        13
      ],
      [
        3,
        1
      ],
      [
        3,
        7
      ],
      [
        2,
        -1
      ],
      [
        3,
        -1
      ],
      [
        3,
        -5
      ],
      [
        4,
        -1
      ],
      [
        2,
        -2
      ],
      [
        2,
        2
      ],
      [
        3,
        3
      ],
      [
        4,
        5
      ],
      [
        4,
        2
      ],
      [
        4,
        1
      ],
      [
        2,
        1
      ],
      [
        2,
        4
      ],
      [
        3,
        -2
      ],
      [
        4,
        1
      ],
      [
        2,
        5
      ],
      [
        4,
        -1
      ],
      [
        2,
        2
      ],
      [
        3,
        15
      ],
      [
        1,
        3
      ],
      [
        1,
        3
      ],
      [
        1,
        3
      ],
      [
        1,
        1
      ],
      [
        2,
        4
      ],
      [
        1,
        4
      ],
      [
        1,
        2
      ],
      [
        2,
        1
      ],
      [
        2,
        3
      ],
      [
        1,
        4
      ],
      [
        -1,
        4
      ],
      [
        -1,
        6
      ],
      [
        1,
        6
      ],
      [
        0,
        13
      ],
      [
        1,
        7
      ],
      [
        0,
        11
      ],
      [
        1,
        3
      ],
      [
        0,
        6
      ],
      [
        1,
        5
      ],
      [
        2,
        0
      ],
      [
        5,
        -1
      ],
      [
        12,
        40
      ],
      [
        17,
        46
      ],
      [
        4,
        55
      ],
      [
        8,
        50
      ],
      [
        8,
        42
      ],
      [
        8,
        50
      ],
      [
        12,
        41
      ],
      [
        15,
        44
      ],
      [
        3,
        7
      ]
    ],
    [
      [
        21102,
        60760
      ],
      [
        92,
        -1
      ]
    ],
    [
      [
        20934,
        60006
      ],
      [
        -67,
        -2
      ],
      [
        -25,
        -1
      ],
      [
        -50,
        0
      ],
      [
        -29,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -104,
        0
      ],
      [
        -8,
        -1
      ],
      [
        -26,
        3
      ],
      [
        -9,
        0
      ]
    ],
    [
      [
        24949,
        62040
      ],
      [
        1,
        -89
      ],
      [
        0,
        -13
      ],
      [
        -31,
        -1
      ]
    ],
    [
      [
        24791,
        62074
      ],
      [
        5,
        12
      ],
      [
        7,
        17
      ],
      [
        1,
        9
      ]
    ],
    [
      [
        24804,
        62112
      ],
      [
        1,
        11
      ],
      [
        2,
        26
      ],
      [
        0,
        7
      ],
      [
        -2,
        7
      ],
      [
        -10,
        21
      ],
      [
        -4,
        11
      ],
      [
        -6,
        10
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        -3,
        11
      ],
      [
        -1,
        4
      ],
      [
        -3,
        8
      ],
      [
        -2,
        4
      ],
      [
        -3,
        4
      ],
      [
        -3,
        6
      ],
      [
        -1,
        1
      ],
      [
        -2,
        0
      ],
      [
        -2,
        2
      ],
      [
        -2,
        1
      ]
    ],
    [
      [
        26961,
        48307
      ],
      [
        34,
        -1
      ],
      [
        0,
        102
      ],
      [
        50,
        -1
      ],
      [
        5,
        0
      ]
    ],
    [
      [
        27187,
        48102
      ],
      [
        -102,
        0
      ],
      [
        -36,
        1
      ]
    ],
    [
      [
        27049,
        48103
      ],
      [
        0,
        21
      ],
      [
        2,
        16
      ],
      [
        -1,
        23
      ],
      [
        0,
        42
      ],
      [
        -1,
        21
      ],
      [
        -2,
        7
      ],
      [
        -6,
        7
      ],
      [
        -1,
        21
      ],
      [
        1,
        19
      ],
      [
        2,
        6
      ],
      [
        4,
        0
      ],
      [
        2,
        4
      ],
      [
        0,
        10
      ],
      [
        -1,
        12
      ],
      [
        -3,
        9
      ],
      [
        -9,
        0
      ],
      [
        -3,
        -4
      ],
      [
        -2,
        -11
      ],
      [
        -3,
        -22
      ],
      [
        -7,
        -1
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -7
      ],
      [
        1,
        -23
      ],
      [
        4,
        -53
      ],
      [
        3,
        -72
      ],
      [
        -1,
        -7
      ],
      [
        -6,
        -6
      ],
      [
        -2,
        -7
      ],
      [
        -3,
        -2
      ],
      [
        -5,
        -4
      ],
      [
        -3,
        2
      ]
    ],
    [
      [
        27005,
        48101
      ],
      [
        -1,
        15
      ],
      [
        -3,
        1
      ],
      [
        -3,
        3
      ],
      [
        -6,
        5
      ],
      [
        -2,
        0
      ]
    ],
    [
      [
        26990,
        48125
      ],
      [
        -5,
        44
      ],
      [
        -3,
        16
      ],
      [
        -14,
        78
      ],
      [
        -7,
        44
      ]
    ],
    [
      [
        25585,
        61461
      ],
      [
        0,
        -52
      ],
      [
        -42,
        0
      ],
      [
        0,
        -42
      ]
    ],
    [
      [
        25543,
        61367
      ],
      [
        -62,
        4
      ]
    ],
    [
      [
        25398,
        61442
      ],
      [
        0,
        13
      ],
      [
        -1,
        9
      ],
      [
        1,
        8
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        24587,
        65565
      ],
      [
        31,
        0
      ],
      [
        1,
        -4
      ],
      [
        6,
        -6
      ],
      [
        2,
        -16
      ],
      [
        11,
        -17
      ],
      [
        6,
        10
      ],
      [
        5,
        21
      ],
      [
        5,
        3
      ],
      [
        2,
        -10
      ],
      [
        5,
        12
      ],
      [
        4,
        -11
      ],
      [
        7,
        17
      ],
      [
        4,
        -14
      ],
      [
        10,
        8
      ],
      [
        1,
        12
      ],
      [
        12,
        -12
      ],
      [
        7,
        9
      ],
      [
        3,
        -18
      ],
      [
        2,
        8
      ],
      [
        8,
        -17
      ],
      [
        0,
        -16
      ],
      [
        3,
        5
      ],
      [
        1,
        -13
      ],
      [
        5,
        9
      ],
      [
        8,
        -11
      ],
      [
        8,
        13
      ],
      [
        5,
        -12
      ]
    ],
    [
      [
        24749,
        65515
      ],
      [
        0,
        -12
      ],
      [
        1,
        -10
      ],
      [
        0,
        -14
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        -7
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -18
      ],
      [
        -2,
        -20
      ],
      [
        0,
        -7
      ],
      [
        1,
        -49
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -3
      ],
      [
        -5,
        -10
      ],
      [
        -5,
        -3
      ],
      [
        -5,
        -5
      ],
      [
        -4,
        -8
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -10
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -9
      ],
      [
        -5,
        -15
      ],
      [
        -3,
        -4
      ],
      [
        -4,
        -2
      ],
      [
        -3,
        0
      ],
      [
        -4,
        1
      ],
      [
        -5,
        7
      ],
      [
        -3,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        -1
      ],
      [
        -3,
        -8
      ],
      [
        -1,
        -1
      ],
      [
        -6,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -11
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        -11
      ],
      [
        -4,
        -7
      ],
      [
        -2,
        -6
      ],
      [
        -3,
        -10
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        0
      ],
      [
        -4,
        -5
      ],
      [
        -3,
        -2
      ],
      [
        -7,
        -3
      ],
      [
        -3,
        -2
      ],
      [
        -4,
        -1
      ],
      [
        -6,
        1
      ],
      [
        -2,
        1
      ],
      [
        -2,
        2
      ]
    ],
    [
      [
        15843,
        66991
      ],
      [
        0,
        63
      ],
      [
        4,
        20
      ],
      [
        48,
        0
      ],
      [
        4,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        3
      ],
      [
        -2,
        2
      ],
      [
        0,
        16
      ],
      [
        1,
        4
      ],
      [
        0,
        3
      ],
      [
        1,
        4
      ],
      [
        0,
        13
      ],
      [
        1,
        7
      ],
      [
        1,
        4
      ],
      [
        0,
        6
      ],
      [
        1,
        2
      ],
      [
        0,
        4
      ],
      [
        2,
        6
      ],
      [
        1,
        4
      ],
      [
        0,
        5
      ],
      [
        -1,
        5
      ],
      [
        0,
        8
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        4
      ],
      [
        0,
        6
      ],
      [
        -1,
        4
      ],
      [
        0,
        2
      ],
      [
        1,
        4
      ],
      [
        1,
        4
      ],
      [
        1,
        6
      ],
      [
        0,
        4
      ],
      [
        2,
        4
      ],
      [
        0,
        6
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        4
      ],
      [
        1,
        2
      ],
      [
        0,
        7
      ],
      [
        -1,
        6
      ],
      [
        -1,
        2
      ],
      [
        1,
        2
      ],
      [
        1,
        -1
      ],
      [
        0,
        2
      ],
      [
        2,
        2
      ],
      [
        1,
        4
      ],
      [
        2,
        3
      ],
      [
        0,
        1
      ],
      [
        1,
        3
      ],
      [
        0,
        3
      ],
      [
        1,
        2
      ],
      [
        1,
        0
      ],
      [
        1,
        2
      ],
      [
        1,
        2
      ],
      [
        1,
        4
      ],
      [
        0,
        5
      ],
      [
        1,
        5
      ],
      [
        0,
        3
      ],
      [
        2,
        6
      ],
      [
        2,
        3
      ],
      [
        -1,
        5
      ],
      [
        -1,
        7
      ],
      [
        -1,
        9
      ],
      [
        -4,
        6
      ],
      [
        -2,
        6
      ],
      [
        0,
        10
      ],
      [
        1,
        6
      ],
      [
        1,
        4
      ],
      [
        1,
        2
      ],
      [
        -1,
        4
      ],
      [
        -1,
        5
      ],
      [
        -2,
        3
      ],
      [
        0,
        12
      ],
      [
        1,
        8
      ],
      [
        0,
        6
      ],
      [
        -1,
        6
      ],
      [
        0,
        5
      ],
      [
        -2,
        11
      ],
      [
        -1,
        3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        5
      ],
      [
        -2,
        6
      ],
      [
        -2,
        6
      ],
      [
        -2,
        6
      ],
      [
        -1,
        2
      ],
      [
        -1,
        7
      ],
      [
        -1,
        7
      ],
      [
        1,
        4
      ],
      [
        0,
        3
      ],
      [
        -1,
        2
      ],
      [
        0,
        5
      ],
      [
        -2,
        2
      ],
      [
        -1,
        2
      ],
      [
        -2,
        6
      ],
      [
        -1,
        5
      ],
      [
        0,
        3
      ],
      [
        -1,
        3
      ],
      [
        -1,
        3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -3
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        3
      ],
      [
        -3,
        3
      ],
      [
        -3,
        4
      ],
      [
        -1,
        1
      ],
      [
        0,
        4
      ]
    ],
    [
      [
        16234,
        65824
      ],
      [
        -44,
        -1
      ],
      [
        -16,
        2
      ],
      [
        -9,
        1
      ],
      [
        -34,
        1
      ],
      [
        -1,
        1
      ],
      [
        -16,
        0
      ],
      [
        -7,
        -1
      ],
      [
        -2,
        -1
      ],
      [
        -5,
        1
      ],
      [
        -24,
        0
      ]
    ],
    [
      [
        15841,
        65840
      ],
      [
        0,
        139
      ],
      [
        1,
        188
      ],
      [
        -1,
        124
      ],
      [
        0,
        52
      ],
      [
        1,
        40
      ],
      [
        1,
        372
      ],
      [
        0,
        236
      ]
    ],
    [
      [
        22893,
        50819
      ],
      [
        -91,
        -279
      ]
    ],
    [
      [
        25262,
        54067
      ],
      [
        2,
        42
      ],
      [
        0,
        3
      ],
      [
        3,
        124
      ],
      [
        0,
        1
      ],
      [
        1,
        15
      ],
      [
        3,
        98
      ],
      [
        1,
        40
      ],
      [
        0,
        1
      ],
      [
        1,
        42
      ],
      [
        1,
        22
      ]
    ],
    [
      [
        25277,
        54549
      ],
      [
        137,
        3
      ]
    ],
    [
      [
        25414,
        54552
      ],
      [
        -1,
        -16
      ],
      [
        1,
        -5
      ],
      [
        -1,
        -12
      ],
      [
        -3,
        0
      ],
      [
        2,
        22
      ],
      [
        -3,
        3
      ],
      [
        -6,
        -7
      ],
      [
        -2,
        11
      ],
      [
        -4,
        -15
      ],
      [
        -5,
        -2
      ],
      [
        1,
        -11
      ],
      [
        -4,
        2
      ],
      [
        0,
        -16
      ],
      [
        3,
        -11
      ],
      [
        -2,
        -31
      ],
      [
        2,
        -19
      ],
      [
        -1,
        -21
      ],
      [
        1,
        -18
      ],
      [
        -2,
        -37
      ],
      [
        -2,
        -10
      ],
      [
        -4,
        0
      ],
      [
        -4,
        -50
      ],
      [
        2,
        -23
      ],
      [
        -7,
        -24
      ],
      [
        -4,
        11
      ],
      [
        -3,
        -2
      ],
      [
        -7,
        -19
      ],
      [
        2,
        -14
      ],
      [
        -1,
        -28
      ],
      [
        2,
        -20
      ],
      [
        4,
        -8
      ],
      [
        1,
        16
      ],
      [
        5,
        -19
      ]
    ],
    [
      [
        25374,
        54179
      ],
      [
        1,
        -37
      ],
      [
        -3,
        -6
      ],
      [
        -5,
        13
      ],
      [
        -7,
        -17
      ],
      [
        2,
        -13
      ],
      [
        4,
        1
      ],
      [
        4,
        -21
      ],
      [
        5,
        18
      ],
      [
        4,
        -16
      ],
      [
        -6,
        -2
      ],
      [
        -3,
        -13
      ],
      [
        -12,
        -7
      ],
      [
        -3,
        -47
      ],
      [
        -5,
        -12
      ],
      [
        -1,
        -15
      ],
      [
        -5,
        -23
      ],
      [
        6,
        -64
      ],
      [
        4,
        -16
      ],
      [
        11,
        10
      ],
      [
        3,
        -27
      ],
      [
        2,
        -45
      ]
    ],
    [
      [
        25370,
        53840
      ],
      [
        -105,
        -1
      ]
    ],
    [
      [
        25265,
        53839
      ],
      [
        0,
        28
      ],
      [
        -1,
        80
      ],
      [
        -1,
        70
      ],
      [
        0,
        28
      ],
      [
        -1,
        22
      ]
    ],
    [
      [
        25286,
        54863
      ],
      [
        2,
        57
      ],
      [
        2,
        99
      ],
      [
        2,
        41
      ],
      [
        4,
        149
      ],
      [
        1,
        63
      ]
    ],
    [
      [
        25297,
        55272
      ],
      [
        2,
        72
      ]
    ],
    [
      [
        25299,
        55344
      ],
      [
        47,
        5
      ]
    ],
    [
      [
        25435,
        54810
      ],
      [
        3,
        -8
      ],
      [
        0,
        -9
      ],
      [
        -3,
        -3
      ],
      [
        -13,
        9
      ],
      [
        -4,
        -6
      ],
      [
        -8,
        -31
      ],
      [
        -3,
        -21
      ],
      [
        -6,
        -18
      ],
      [
        -5,
        -3
      ],
      [
        -11,
        -25
      ],
      [
        -3,
        -27
      ],
      [
        -1,
        -39
      ],
      [
        8,
        -8
      ],
      [
        7,
        -27
      ],
      [
        6,
        -3
      ],
      [
        6,
        -18
      ],
      [
        2,
        -17
      ],
      [
        4,
        -4
      ]
    ],
    [
      [
        23760,
        59427
      ],
      [
        78,
        0
      ]
    ],
    [
      [
        23913,
        59427
      ],
      [
        6,
        -1
      ]
    ],
    [
      [
        23919,
        59426
      ],
      [
        -1,
        -1
      ],
      [
        1,
        -93
      ],
      [
        -1,
        -140
      ],
      [
        0,
        -138
      ],
      [
        -1,
        -66
      ]
    ],
    [
      [
        23917,
        58988
      ],
      [
        -40,
        3
      ],
      [
        -9,
        1
      ]
    ],
    [
      [
        23868,
        58992
      ],
      [
        -20,
        1
      ],
      [
        0,
        34
      ],
      [
        -10,
        1
      ],
      [
        0,
        35
      ],
      [
        -7,
        1
      ],
      [
        -3,
        17
      ],
      [
        1,
        67
      ],
      [
        -7,
        11
      ],
      [
        3,
        11
      ],
      [
        -2,
        6
      ],
      [
        -7,
        -9
      ],
      [
        2,
        32
      ],
      [
        -44,
        4
      ]
    ],
    [
      [
        16425,
        58601
      ],
      [
        183,
        0
      ]
    ],
    [
      [
        16608,
        58601
      ],
      [
        135,
        2
      ],
      [
        69,
        -1
      ],
      [
        83,
        0
      ],
      [
        12,
        3
      ],
      [
        24,
        -3
      ],
      [
        51,
        1
      ],
      [
        35,
        1
      ],
      [
        17,
        -3
      ]
    ],
    [
      [
        17129,
        57476
      ],
      [
        -30,
        1
      ],
      [
        -154,
        -5
      ],
      [
        -73,
        -2
      ],
      [
        -74,
        0
      ],
      [
        0,
        -17
      ],
      [
        -6,
        0
      ],
      [
        -2,
        17
      ],
      [
        -3,
        0
      ],
      [
        3,
        -31
      ]
    ],
    [
      [
        16626,
        57567
      ],
      [
        0,
        205
      ],
      [
        -5,
        0
      ],
      [
        0,
        17
      ],
      [
        -20,
        -5
      ],
      [
        2,
        108
      ],
      [
        -5,
        0
      ],
      [
        -26,
        -6
      ],
      [
        0,
        102
      ],
      [
        -40,
        1
      ],
      [
        0,
        102
      ],
      [
        -20,
        0
      ],
      [
        0,
        102
      ],
      [
        -9,
        1
      ],
      [
        -23,
        0
      ],
      [
        0,
        34
      ],
      [
        -6,
        0
      ],
      [
        1,
        17
      ],
      [
        -5,
        0
      ],
      [
        0,
        18
      ],
      [
        -5,
        0
      ],
      [
        0,
        16
      ],
      [
        -5,
        0
      ],
      [
        0,
        16
      ],
      [
        -5,
        0
      ],
      [
        0,
        103
      ],
      [
        -30,
        -1
      ],
      [
        0,
        204
      ]
    ],
    [
      [
        27187,
        48102
      ],
      [
        0,
        -299
      ]
    ],
    [
      [
        27187,
        47803
      ],
      [
        1,
        -105
      ],
      [
        -27,
        -2
      ],
      [
        0,
        -121
      ],
      [
        -24,
        0
      ],
      [
        -3,
        -1
      ],
      [
        -18,
        0
      ],
      [
        0,
        16
      ],
      [
        -7,
        0
      ]
    ],
    [
      [
        27109,
        47590
      ],
      [
        -7,
        57
      ],
      [
        -5,
        21
      ],
      [
        -4,
        16
      ],
      [
        0,
        6
      ],
      [
        -3,
        13
      ],
      [
        -3,
        11
      ],
      [
        -4,
        10
      ],
      [
        -5,
        8
      ],
      [
        -2,
        7
      ],
      [
        -1,
        6
      ],
      [
        0,
        2
      ],
      [
        -1,
        13
      ],
      [
        -3,
        6
      ],
      [
        -4,
        4
      ],
      [
        -4,
        -1
      ],
      [
        -1,
        8
      ],
      [
        1,
        17
      ],
      [
        -1,
        27
      ],
      [
        -8,
        -4
      ],
      [
        -4,
        27
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -18
      ],
      [
        0,
        -21
      ],
      [
        3,
        -23
      ],
      [
        -4,
        -1
      ],
      [
        -7,
        -10
      ],
      [
        -3,
        0
      ],
      [
        -1,
        66
      ],
      [
        -2,
        24
      ],
      [
        -1,
        21
      ],
      [
        -5,
        68
      ],
      [
        -3,
        19
      ],
      [
        -9,
        32
      ],
      [
        1,
        18
      ],
      [
        2,
        6
      ],
      [
        6,
        2
      ],
      [
        3,
        -1
      ],
      [
        4,
        -4
      ],
      [
        2,
        -10
      ],
      [
        3,
        -27
      ],
      [
        2,
        -6
      ],
      [
        2,
        4
      ],
      [
        0,
        4
      ],
      [
        2,
        18
      ],
      [
        0,
        20
      ],
      [
        2,
        17
      ],
      [
        3,
        30
      ],
      [
        2,
        33
      ]
    ],
    [
      [
        26992,
        48019
      ],
      [
        3,
        6
      ],
      [
        0,
        5
      ],
      [
        2,
        -2
      ],
      [
        1,
        -14
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -6
      ],
      [
        3,
        -25
      ],
      [
        5,
        -41
      ],
      [
        1,
        -27
      ],
      [
        5,
        -51
      ],
      [
        3,
        -37
      ],
      [
        2,
        -30
      ],
      [
        4,
        -14
      ],
      [
        4,
        -14
      ],
      [
        5,
        -1
      ],
      [
        3,
        -4
      ],
      [
        9,
        -21
      ],
      [
        3,
        12
      ],
      [
        4,
        5
      ],
      [
        7,
        -15
      ],
      [
        7,
        -3
      ],
      [
        0,
        -3
      ],
      [
        -14,
        -31
      ],
      [
        -3,
        -4
      ],
      [
        -2,
        0
      ],
      [
        -4,
        3
      ],
      [
        -8,
        14
      ],
      [
        -7,
        22
      ],
      [
        -6,
        14
      ],
      [
        -1,
        5
      ],
      [
        -1,
        5
      ],
      [
        -5,
        18
      ],
      [
        -6,
        66
      ],
      [
        -3,
        21
      ],
      [
        -4,
        28
      ],
      [
        -3,
        51
      ],
      [
        -3,
        25
      ],
      [
        1,
        21
      ],
      [
        -2,
        11
      ],
      [
        1,
        18
      ]
    ],
    [
      [
        27005,
        48101
      ],
      [
        -3,
        2
      ],
      [
        -4,
        -5
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -53
      ],
      [
        -4,
        3
      ],
      [
        1,
        43
      ],
      [
        -1,
        32
      ],
      [
        -1,
        6
      ]
    ],
    [
      [
        20012,
        64670
      ],
      [
        22,
        0
      ],
      [
        67,
        1
      ],
      [
        39,
        -1
      ]
    ],
    [
      [
        20205,
        63415
      ],
      [
        0,
        -7
      ],
      [
        -8,
        1
      ],
      [
        -106,
        -1
      ]
    ],
    [
      [
        20090,
        63609
      ],
      [
        0,
        156
      ],
      [
        -112,
        -2
      ]
    ],
    [
      [
        19978,
        63763
      ],
      [
        -1,
        129
      ],
      [
        3,
        0
      ],
      [
        1,
        242
      ],
      [
        16,
        0
      ],
      [
        0,
        67
      ],
      [
        16,
        0
      ],
      [
        -1,
        469
      ]
    ],
    [
      [
        24970,
        60670
      ],
      [
        0,
        5
      ]
    ],
    [
      [
        24970,
        60675
      ],
      [
        14,
        -10
      ],
      [
        5,
        21
      ],
      [
        1,
        23
      ],
      [
        61,
        -2
      ],
      [
        22,
        2
      ]
    ],
    [
      [
        25073,
        60709
      ],
      [
        31,
        -4
      ]
    ],
    [
      [
        25104,
        60705
      ],
      [
        -1,
        -311
      ]
    ],
    [
      [
        25103,
        60394
      ],
      [
        -15,
        5
      ],
      [
        -20,
        0
      ],
      [
        -22,
        2
      ]
    ],
    [
      [
        25046,
        60401
      ],
      [
        -66,
        -1
      ]
    ],
    [
      [
        24980,
        60400
      ],
      [
        1,
        1
      ],
      [
        2,
        3
      ],
      [
        6,
        1
      ],
      [
        2,
        2
      ],
      [
        3,
        4
      ],
      [
        1,
        3
      ],
      [
        1,
        6
      ],
      [
        0,
        5
      ],
      [
        2,
        28
      ],
      [
        0,
        20
      ],
      [
        -1,
        12
      ],
      [
        -2,
        22
      ],
      [
        -2,
        12
      ],
      [
        -1,
        6
      ],
      [
        -2,
        9
      ],
      [
        -6,
        19
      ],
      [
        -1,
        6
      ],
      [
        -6,
        39
      ],
      [
        -1,
        10
      ],
      [
        0,
        5
      ],
      [
        -2,
        8
      ],
      [
        -1,
        6
      ],
      [
        -1,
        7
      ],
      [
        0,
        2
      ],
      [
        -2,
        19
      ],
      [
        0,
        15
      ]
    ],
    [
      [
        22202,
        60010
      ],
      [
        -23,
        0
      ]
    ],
    [
      [
        25589,
        61056
      ],
      [
        7,
        -18
      ],
      [
        2,
        -3
      ],
      [
        0,
        -2
      ]
    ],
    [
      [
        25598,
        61033
      ],
      [
        2,
        -7
      ],
      [
        2,
        -6
      ],
      [
        9,
        -21
      ],
      [
        3,
        -4
      ],
      [
        2,
        -2
      ],
      [
        7,
        -3
      ],
      [
        2,
        1
      ],
      [
        2,
        -1
      ],
      [
        1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        1,
        -7
      ],
      [
        3,
        -18
      ],
      [
        2,
        -11
      ],
      [
        1,
        -17
      ],
      [
        1,
        -7
      ],
      [
        0,
        -2
      ],
      [
        3,
        -2
      ],
      [
        2,
        -1
      ],
      [
        6,
        6
      ],
      [
        3,
        10
      ],
      [
        0,
        1
      ],
      [
        2,
        6
      ],
      [
        1,
        5
      ],
      [
        1,
        5
      ],
      [
        2,
        20
      ],
      [
        0,
        9
      ],
      [
        1,
        21
      ],
      [
        1,
        7
      ],
      [
        2,
        13
      ],
      [
        0,
        16
      ],
      [
        -1,
        4
      ],
      [
        0,
        7
      ],
      [
        1,
        5
      ],
      [
        3,
        10
      ],
      [
        6,
        15
      ],
      [
        2,
        3
      ],
      [
        7,
        9
      ]
    ],
    [
      [
        25149,
        51924
      ],
      [
        3,
        -5
      ],
      [
        4,
        -17
      ],
      [
        4,
        -25
      ],
      [
        2,
        -16
      ],
      [
        3,
        -33
      ],
      [
        2,
        -43
      ],
      [
        -1,
        -52
      ],
      [
        -2,
        -49
      ],
      [
        -2,
        -27
      ],
      [
        -3,
        -33
      ],
      [
        -5,
        -45
      ],
      [
        -4,
        3
      ],
      [
        1,
        19
      ],
      [
        1,
        18
      ],
      [
        2,
        17
      ],
      [
        2,
        18
      ],
      [
        2,
        18
      ],
      [
        1,
        31
      ],
      [
        2,
        26
      ],
      [
        1,
        43
      ],
      [
        -1,
        26
      ],
      [
        0,
        20
      ],
      [
        -3,
        38
      ],
      [
        -2,
        20
      ],
      [
        -4,
        16
      ],
      [
        -2,
        18
      ],
      [
        -1,
        14
      ]
    ],
    [
      [
        25020,
        51931
      ],
      [
        7,
        12
      ],
      [
        4,
        26
      ],
      [
        20,
        50
      ],
      [
        12,
        31
      ],
      [
        2,
        -14
      ],
      [
        -9,
        -40
      ],
      [
        -4,
        -23
      ],
      [
        2,
        -28
      ],
      [
        10,
        -9
      ],
      [
        3,
        -24
      ],
      [
        -3,
        -12
      ],
      [
        -5,
        2
      ],
      [
        -3,
        -17
      ],
      [
        3,
        -21
      ],
      [
        -3,
        -10
      ],
      [
        -4,
        8
      ],
      [
        0,
        25
      ],
      [
        -3,
        22
      ],
      [
        -6,
        11
      ],
      [
        -4,
        -21
      ],
      [
        -2,
        1
      ],
      [
        -7,
        8
      ],
      [
        -6,
        -1
      ],
      [
        -2,
        2
      ],
      [
        -2,
        22
      ]
    ],
    [
      [
        24992,
        52030
      ],
      [
        5,
        11
      ],
      [
        2,
        -12
      ],
      [
        -3,
        -17
      ],
      [
        -3,
        -2
      ],
      [
        -4,
        14
      ],
      [
        3,
        6
      ]
    ],
    [
      [
        24877,
        51859
      ],
      [
        1,
        -9
      ],
      [
        0,
        -14
      ],
      [
        2,
        -26
      ],
      [
        2,
        -11
      ],
      [
        2,
        -5
      ],
      [
        1,
        -3
      ],
      [
        3,
        -6
      ],
      [
        3,
        -1
      ],
      [
        9,
        5
      ],
      [
        7,
        10
      ],
      [
        6,
        15
      ],
      [
        2,
        -6
      ],
      [
        2,
        -8
      ],
      [
        -7,
        -12
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -9
      ],
      [
        1,
        -23
      ],
      [
        8,
        -34
      ],
      [
        6,
        -12
      ],
      [
        6,
        -1
      ],
      [
        3,
        -6
      ],
      [
        6,
        2
      ],
      [
        7,
        9
      ],
      [
        4,
        11
      ],
      [
        2,
        18
      ],
      [
        0,
        24
      ],
      [
        2,
        16
      ],
      [
        0,
        17
      ],
      [
        2,
        16
      ],
      [
        1,
        28
      ],
      [
        -2,
        13
      ],
      [
        2,
        6
      ],
      [
        6,
        7
      ],
      [
        14,
        33
      ],
      [
        2,
        8
      ],
      [
        0,
        11
      ],
      [
        -1,
        10
      ],
      [
        1,
        15
      ],
      [
        3,
        8
      ],
      [
        7,
        -18
      ],
      [
        4,
        -3
      ],
      [
        4,
        -10
      ],
      [
        3,
        -3
      ],
      [
        13,
        6
      ],
      [
        1,
        -9
      ],
      [
        -1,
        -12
      ],
      [
        -3,
        -8
      ],
      [
        -3,
        0
      ],
      [
        -6,
        -11
      ],
      [
        -2,
        -6
      ],
      [
        -3,
        -9
      ],
      [
        0,
        -34
      ],
      [
        8,
        -15
      ],
      [
        3,
        1
      ],
      [
        4,
        -3
      ],
      [
        0,
        -52
      ],
      [
        3,
        -9
      ],
      [
        10,
        5
      ],
      [
        5,
        9
      ],
      [
        9,
        58
      ],
      [
        2,
        24
      ],
      [
        7,
        10
      ],
      [
        2,
        -6
      ],
      [
        -2,
        -25
      ],
      [
        9,
        -4
      ],
      [
        -2,
        -12
      ],
      [
        -2,
        -43
      ],
      [
        -4,
        6
      ],
      [
        -5,
        -1
      ],
      [
        -4,
        -5
      ],
      [
        -11,
        -32
      ],
      [
        -1,
        -12
      ],
      [
        3,
        -7
      ],
      [
        6,
        -1
      ],
      [
        5,
        7
      ],
      [
        8,
        3
      ],
      [
        2,
        -3
      ],
      [
        0,
        -11
      ],
      [
        -5,
        -15
      ],
      [
        -5,
        -5
      ],
      [
        -7,
        -3
      ],
      [
        -6,
        -8
      ],
      [
        -13,
        -6
      ],
      [
        -5,
        -8
      ],
      [
        0,
        -9
      ],
      [
        3,
        -6
      ],
      [
        7,
        -6
      ],
      [
        1,
        -26
      ],
      [
        3,
        -9
      ],
      [
        4,
        -2
      ],
      [
        7,
        17
      ],
      [
        4,
        5
      ],
      [
        0,
        -9
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -30
      ],
      [
        5,
        -10
      ],
      [
        -1,
        -6
      ],
      [
        -9,
        1
      ],
      [
        -3,
        5
      ],
      [
        -3,
        13
      ],
      [
        -3,
        8
      ],
      [
        -5,
        3
      ],
      [
        -4,
        -8
      ],
      [
        -5,
        16
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -17
      ],
      [
        -4,
        -21
      ],
      [
        -4,
        -13
      ],
      [
        0,
        -34
      ],
      [
        9,
        -19
      ],
      [
        3,
        -19
      ],
      [
        -5,
        3
      ],
      [
        -6,
        18
      ],
      [
        0,
        -22
      ],
      [
        -2,
        -26
      ],
      [
        -9,
        -5
      ],
      [
        -2,
        25
      ],
      [
        1,
        30
      ],
      [
        -5,
        31
      ],
      [
        -11,
        1
      ],
      [
        2,
        -40
      ],
      [
        -4,
        -26
      ]
    ],
    [
      [
        24967,
        51478
      ],
      [
        -10,
        -6
      ],
      [
        -16,
        18
      ],
      [
        -9,
        33
      ],
      [
        -7,
        8
      ],
      [
        -2,
        27
      ],
      [
        -4,
        16
      ],
      [
        -4,
        6
      ],
      [
        -11,
        1
      ],
      [
        -2,
        -4
      ],
      [
        -7,
        7
      ],
      [
        2,
        14
      ],
      [
        -5,
        23
      ],
      [
        -4,
        10
      ],
      [
        -4,
        0
      ],
      [
        -8,
        -10
      ],
      [
        -3,
        3
      ],
      [
        -2,
        23
      ],
      [
        -5,
        21
      ],
      [
        -4,
        40
      ]
    ],
    [
      [
        24862,
        51708
      ],
      [
        2,
        12
      ],
      [
        -1,
        22
      ],
      [
        -6,
        28
      ],
      [
        -12,
        4
      ],
      [
        -11,
        25
      ],
      [
        6,
        51
      ],
      [
        4,
        6
      ],
      [
        6,
        -16
      ],
      [
        2,
        2
      ],
      [
        9,
        19
      ],
      [
        5,
        4
      ],
      [
        5,
        -20
      ],
      [
        5,
        20
      ],
      [
        1,
        -6
      ]
    ],
    [
      [
        18690,
        67021
      ],
      [
        3,
        -37
      ],
      [
        -3,
        -13
      ],
      [
        -7,
        -7
      ],
      [
        2,
        -27
      ],
      [
        -6,
        2
      ],
      [
        -7,
        -9
      ],
      [
        -4,
        -31
      ],
      [
        2,
        -6
      ],
      [
        -4,
        -20
      ],
      [
        4,
        -18
      ],
      [
        0,
        -36
      ],
      [
        4,
        -21
      ],
      [
        -2,
        -24
      ],
      [
        -3,
        0
      ],
      [
        -2,
        -23
      ],
      [
        1,
        -32
      ],
      [
        1,
        -14
      ],
      [
        7,
        -29
      ],
      [
        2,
        -31
      ],
      [
        6,
        -2
      ],
      [
        8,
        24
      ],
      [
        24,
        0
      ],
      [
        1,
        -25
      ],
      [
        3,
        -7
      ],
      [
        -3,
        -19
      ],
      [
        6,
        0
      ],
      [
        0,
        -45
      ],
      [
        6,
        -5
      ],
      [
        2,
        -17
      ],
      [
        0,
        -108
      ],
      [
        5,
        0
      ],
      [
        1,
        -41
      ],
      [
        3,
        0
      ],
      [
        0,
        -51
      ],
      [
        2,
        0
      ],
      [
        0,
        -34
      ]
    ],
    [
      [
        18742,
        66315
      ],
      [
        -5,
        0
      ],
      [
        -1,
        -186
      ],
      [
        -24,
        0
      ],
      [
        0,
        34
      ],
      [
        -39,
        0
      ]
    ],
    [
      [
        18591,
        66416
      ],
      [
        1,
        76
      ],
      [
        8,
        4
      ],
      [
        -1,
        62
      ],
      [
        3,
        25
      ],
      [
        -11,
        0
      ],
      [
        0,
        34
      ],
      [
        -5,
        0
      ],
      [
        0,
        25
      ],
      [
        -6,
        0
      ],
      [
        0,
        42
      ],
      [
        -11,
        0
      ],
      [
        0,
        67
      ],
      [
        -5,
        0
      ],
      [
        -1,
        142
      ],
      [
        -11,
        56
      ],
      [
        -8,
        15
      ],
      [
        -4,
        -16
      ],
      [
        -5,
        1
      ],
      [
        -7,
        -22
      ],
      [
        -16,
        -7
      ],
      [
        0,
        -11
      ],
      [
        -7,
        -12
      ],
      [
        -3,
        -12
      ],
      [
        -3,
        8
      ],
      [
        5,
        32
      ],
      [
        -5,
        13
      ]
    ],
    [
      [
        18499,
        66938
      ],
      [
        -1,
        14
      ],
      [
        5,
        12
      ],
      [
        -2,
        18
      ],
      [
        10,
        2
      ],
      [
        7,
        25
      ],
      [
        1,
        11
      ],
      [
        3,
        -7
      ],
      [
        3,
        7
      ],
      [
        165,
        1
      ]
    ],
    [
      [
        21658,
        63505
      ],
      [
        10,
        1
      ],
      [
        14,
        0
      ]
    ],
    [
      [
        26476,
        53117
      ],
      [
        32,
        -1
      ]
    ],
    [
      [
        26508,
        53116
      ],
      [
        0,
        -42
      ],
      [
        23,
        -1
      ],
      [
        35,
        -2
      ],
      [
        0,
        -15
      ],
      [
        4,
        15
      ],
      [
        12,
        -1
      ]
    ],
    [
      [
        26582,
        53070
      ],
      [
        -1,
        -344
      ],
      [
        -1,
        -98
      ]
    ],
    [
      [
        26580,
        52628
      ],
      [
        -19,
        4
      ],
      [
        -2,
        1
      ],
      [
        -10,
        2
      ],
      [
        -7,
        2
      ],
      [
        -35,
        7
      ]
    ],
    [
      [
        26507,
        52644
      ],
      [
        -9,
        2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        -3,
        0
      ],
      [
        -8,
        2
      ]
    ],
    [
      [
        26205,
        53385
      ],
      [
        1,
        37
      ],
      [
        -2,
        26
      ],
      [
        4,
        41
      ],
      [
        0,
        15
      ],
      [
        4,
        24
      ],
      [
        -2,
        43
      ],
      [
        7,
        57
      ]
    ],
    [
      [
        26217,
        53628
      ],
      [
        5,
        2
      ],
      [
        0,
        -38
      ],
      [
        12,
        3
      ],
      [
        4,
        10
      ],
      [
        3,
        -5
      ],
      [
        6,
        12
      ],
      [
        33,
        -3
      ]
    ],
    [
      [
        26331,
        53531
      ],
      [
        0,
        -107
      ],
      [
        3,
        -11
      ],
      [
        -3,
        0
      ],
      [
        -1,
        -85
      ]
    ],
    [
      [
        26252,
        53111
      ],
      [
        -29,
        3
      ]
    ],
    [
      [
        26223,
        53114
      ],
      [
        0,
        6
      ],
      [
        -3,
        32
      ],
      [
        -5,
        13
      ],
      [
        -6,
        44
      ],
      [
        -5,
        6
      ],
      [
        -4,
        28
      ],
      [
        2,
        27
      ],
      [
        1,
        27
      ],
      [
        -5,
        51
      ],
      [
        7,
        21
      ],
      [
        0,
        16
      ]
    ],
    [
      [
        18875,
        67719
      ],
      [
        0,
        350
      ]
    ],
    [
      [
        28737,
        62777
      ],
      [
        0,
        10
      ],
      [
        -9,
        1
      ],
      [
        -2,
        2
      ],
      [
        0,
        7
      ],
      [
        2,
        10
      ],
      [
        5,
        7
      ],
      [
        3,
        7
      ],
      [
        2,
        18
      ],
      [
        4,
        6
      ],
      [
        2,
        11
      ],
      [
        0,
        4
      ],
      [
        -4,
        12
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -8
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        5
      ],
      [
        3,
        19
      ],
      [
        1,
        8
      ],
      [
        1,
        14
      ],
      [
        2,
        26
      ],
      [
        3,
        22
      ],
      [
        3,
        11
      ],
      [
        0,
        13
      ],
      [
        -1,
        9
      ],
      [
        -3,
        3
      ],
      [
        -3,
        3
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -11
      ],
      [
        -7,
        -2
      ],
      [
        -5,
        -1
      ],
      [
        -4,
        -1
      ],
      [
        -4,
        -4
      ]
    ],
    [
      [
        28716,
        62971
      ],
      [
        -2,
        18
      ],
      [
        -3,
        11
      ],
      [
        -3,
        14
      ],
      [
        -12,
        46
      ],
      [
        -7,
        47
      ],
      [
        -11,
        31
      ],
      [
        -5,
        41
      ]
    ],
    [
      [
        26926,
        67191
      ],
      [
        0,
        -8
      ],
      [
        2,
        -21
      ],
      [
        1,
        -30
      ],
      [
        1,
        -15
      ],
      [
        0,
        -3
      ],
      [
        5,
        -17
      ],
      [
        3,
        -31
      ],
      [
        10,
        -62
      ],
      [
        2,
        -3
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -13
      ],
      [
        1,
        -5
      ],
      [
        2,
        -9
      ],
      [
        -1,
        -12
      ],
      [
        -4,
        -17
      ],
      [
        -5,
        -17
      ],
      [
        -2,
        -12
      ],
      [
        -2,
        -30
      ],
      [
        -2,
        -16
      ],
      [
        0,
        -41
      ],
      [
        -1,
        -18
      ],
      [
        -1,
        -14
      ],
      [
        -1,
        -19
      ],
      [
        0,
        -7
      ],
      [
        3,
        -22
      ],
      [
        1,
        -17
      ],
      [
        0,
        -8
      ],
      [
        -5,
        -33
      ],
      [
        0,
        -18
      ],
      [
        -3,
        -20
      ],
      [
        -4,
        -42
      ],
      [
        0,
        -32
      ],
      [
        -3,
        -28
      ],
      [
        -1,
        -7
      ],
      [
        -7,
        -18
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -7
      ],
      [
        0,
        -2
      ],
      [
        -4,
        -11
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -13
      ],
      [
        -1,
        -4
      ],
      [
        -5,
        -3
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        -2,
        5
      ],
      [
        -2,
        3
      ],
      [
        -3,
        0
      ],
      [
        -2,
        -2
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -5
      ],
      [
        -3,
        -9
      ],
      [
        -2,
        -8
      ],
      [
        -3,
        -15
      ],
      [
        -2,
        -5
      ],
      [
        0,
        43
      ],
      [
        -2,
        3
      ],
      [
        3,
        20
      ],
      [
        -2,
        16
      ],
      [
        -4,
        -3
      ],
      [
        -2,
        6
      ],
      [
        -1,
        8
      ],
      [
        4,
        10
      ],
      [
        3,
        0
      ],
      [
        3,
        6
      ],
      [
        -1,
        8
      ],
      [
        -2,
        7
      ],
      [
        0,
        3
      ],
      [
        4,
        -1
      ],
      [
        3,
        1
      ],
      [
        -1,
        14
      ],
      [
        4,
        13
      ],
      [
        3,
        -10
      ],
      [
        3,
        0
      ],
      [
        2,
        14
      ],
      [
        0,
        13
      ],
      [
        -1,
        3
      ],
      [
        -4,
        9
      ],
      [
        -3,
        -4
      ],
      [
        -2,
        8
      ],
      [
        -4,
        10
      ],
      [
        -3,
        3
      ],
      [
        -4,
        -1
      ],
      [
        -2,
        -7
      ]
    ],
    [
      [
        26869,
        66626
      ],
      [
        0,
        4
      ],
      [
        -6,
        23
      ],
      [
        -1,
        17
      ],
      [
        0,
        84
      ],
      [
        -2,
        122
      ],
      [
        -35,
        -3
      ],
      [
        -33,
        -2
      ]
    ],
    [
      [
        24544,
        57270
      ],
      [
        20,
        -1
      ],
      [
        44,
        -2
      ],
      [
        66,
        -2
      ]
    ],
    [
      [
        24674,
        57265
      ],
      [
        -1,
        -17
      ],
      [
        0,
        -13
      ],
      [
        2,
        -13
      ],
      [
        2,
        -11
      ],
      [
        1,
        -9
      ],
      [
        2,
        -6
      ],
      [
        2,
        -6
      ],
      [
        2,
        -10
      ],
      [
        1,
        -6
      ],
      [
        1,
        -15
      ],
      [
        0,
        -12
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        -8
      ],
      [
        -4,
        -7
      ]
    ],
    [
      [
        24678,
        57129
      ],
      [
        -2,
        -10
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -10
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -30
      ],
      [
        1,
        -11
      ],
      [
        0,
        -3
      ],
      [
        2,
        -5
      ],
      [
        1,
        -3
      ],
      [
        2,
        -13
      ],
      [
        0,
        -18
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -6
      ],
      [
        -9,
        -23
      ],
      [
        -1,
        -2
      ],
      [
        -4,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -3
      ],
      [
        -4,
        -9
      ],
      [
        0,
        -5
      ],
      [
        -3,
        -19
      ],
      [
        0,
        -8
      ],
      [
        2,
        -14
      ],
      [
        0,
        -1
      ],
      [
        1,
        -10
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -8
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        0
      ],
      [
        -2,
        3
      ],
      [
        -1,
        3
      ],
      [
        -1,
        5
      ],
      [
        0,
        18
      ],
      [
        3,
        17
      ],
      [
        0,
        19
      ],
      [
        -2,
        -1
      ],
      [
        -3,
        -3
      ],
      [
        -3,
        -2
      ],
      [
        -5,
        0
      ],
      [
        -4,
        4
      ],
      [
        -2,
        1
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -18
      ],
      [
        1,
        -3
      ],
      [
        4,
        -13
      ],
      [
        2,
        -8
      ],
      [
        0,
        -5
      ],
      [
        1,
        -8
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -5
      ],
      [
        -3,
        -15
      ],
      [
        0,
        -3
      ],
      [
        -3,
        -7
      ],
      [
        -2,
        -1
      ],
      [
        -7,
        3
      ],
      [
        -2,
        0
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -21
      ],
      [
        -1,
        -16
      ],
      [
        0,
        -15
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        3
      ],
      [
        -1,
        3
      ],
      [
        -3,
        0
      ],
      [
        -3,
        4
      ],
      [
        -4,
        10
      ],
      [
        -1,
        4
      ],
      [
        -1,
        3
      ],
      [
        -1,
        13
      ],
      [
        0,
        3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        -3,
        0
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -21
      ],
      [
        1,
        -5
      ],
      [
        5,
        -21
      ],
      [
        1,
        -3
      ],
      [
        6,
        -11
      ],
      [
        1,
        -3
      ],
      [
        1,
        3
      ],
      [
        2,
        1
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        1
      ],
      [
        2,
        3
      ],
      [
        1,
        1
      ],
      [
        2,
        -1
      ],
      [
        2,
        -3
      ],
      [
        3,
        1
      ],
      [
        4,
        -2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        1,
        -3
      ],
      [
        0,
        -17
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -7
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -3,
        4
      ],
      [
        -1,
        2
      ],
      [
        -2,
        7
      ],
      [
        -2,
        4
      ],
      [
        -3,
        11
      ],
      [
        -3,
        4
      ],
      [
        -2,
        1
      ],
      [
        -7,
        -20
      ],
      [
        -5,
        -12
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -6
      ],
      [
        1,
        -6
      ]
    ],
    [
      [
        24571,
        56657
      ],
      [
        -45,
        0
      ]
    ],
    [
      [
        24526,
        56657
      ],
      [
        1,
        13
      ],
      [
        4,
        1
      ],
      [
        1,
        11
      ],
      [
        4,
        4
      ],
      [
        -3,
        14
      ],
      [
        2,
        4
      ],
      [
        -3,
        20
      ],
      [
        3,
        30
      ],
      [
        4,
        -1
      ],
      [
        3,
        18
      ],
      [
        -2,
        25
      ],
      [
        -4,
        13
      ],
      [
        5,
        6
      ],
      [
        -3,
        13
      ],
      [
        -1,
        20
      ],
      [
        5,
        41
      ],
      [
        1,
        21
      ]
    ],
    [
      [
        15847,
        61244
      ],
      [
        6,
        5
      ],
      [
        17,
        -12
      ],
      [
        5,
        -20
      ],
      [
        7,
        -6
      ],
      [
        12,
        18
      ],
      [
        1,
        2
      ],
      [
        10,
        16
      ],
      [
        3,
        -2
      ],
      [
        6,
        -2
      ],
      [
        12,
        10
      ],
      [
        16,
        -24
      ],
      [
        10,
        0
      ],
      [
        6,
        9
      ],
      [
        2,
        13
      ]
    ],
    [
      [
        15960,
        61251
      ],
      [
        6,
        -16
      ],
      [
        2,
        -24
      ],
      [
        5,
        -12
      ],
      [
        4,
        1
      ],
      [
        3,
        -4
      ],
      [
        15,
        10
      ],
      [
        10,
        21
      ],
      [
        5,
        19
      ],
      [
        0,
        24
      ],
      [
        3,
        13
      ],
      [
        3,
        3
      ],
      [
        6,
        -11
      ],
      [
        3,
        14
      ],
      [
        7,
        2
      ],
      [
        7,
        -7
      ]
    ],
    [
      [
        16045,
        60961
      ],
      [
        -6,
        -6
      ],
      [
        -81,
        -83
      ],
      [
        -24,
        -24
      ],
      [
        -16,
        32
      ],
      [
        4,
        19
      ],
      [
        -2,
        8
      ],
      [
        -11,
        33
      ],
      [
        -17,
        4
      ],
      [
        -2,
        1
      ],
      [
        -7,
        2
      ],
      [
        -5,
        16
      ],
      [
        -6,
        -2
      ],
      [
        -2,
        20
      ],
      [
        -10,
        36
      ],
      [
        -1,
        16
      ],
      [
        -7,
        15
      ],
      [
        -6,
        17
      ],
      [
        -12,
        -10
      ]
    ],
    [
      [
        15834,
        61055
      ],
      [
        -3,
        10
      ],
      [
        -3,
        3
      ],
      [
        -6,
        0
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        0
      ],
      [
        -3,
        1
      ],
      [
        -2,
        4
      ],
      [
        -1,
        2
      ],
      [
        0,
        14
      ],
      [
        -1,
        6
      ],
      [
        -2,
        1
      ],
      [
        -4,
        10
      ],
      [
        -1,
        8
      ],
      [
        -3,
        23
      ],
      [
        0,
        2
      ],
      [
        4,
        -2
      ],
      [
        1,
        -3
      ],
      [
        1,
        -4
      ],
      [
        2,
        -2
      ],
      [
        2,
        17
      ],
      [
        7,
        9
      ],
      [
        2,
        14
      ],
      [
        -1,
        5
      ],
      [
        -1,
        5
      ],
      [
        0,
        16
      ],
      [
        1,
        2
      ],
      [
        1,
        -5
      ],
      [
        6,
        -7
      ],
      [
        2,
        2
      ],
      [
        3,
        8
      ],
      [
        2,
        1
      ],
      [
        4,
        -3
      ],
      [
        5,
        14
      ],
      [
        2,
        12
      ],
      [
        3,
        13
      ],
      [
        0,
        16
      ],
      [
        -1,
        2
      ]
    ],
    [
      [
        29578,
        65411
      ],
      [
        5,
        2
      ],
      [
        7,
        4
      ],
      [
        2,
        -43
      ],
      [
        -3,
        -56
      ],
      [
        -1,
        -3
      ],
      [
        12,
        6
      ],
      [
        7,
        1
      ],
      [
        3,
        -16
      ],
      [
        4,
        -3
      ],
      [
        3,
        -2
      ],
      [
        1,
        28
      ],
      [
        3,
        2
      ],
      [
        1,
        -17
      ],
      [
        7,
        20
      ],
      [
        13,
        7
      ]
    ],
    [
      [
        29702,
        64964
      ],
      [
        -3,
        -6
      ],
      [
        -6,
        21
      ],
      [
        -4,
        4
      ],
      [
        -4,
        -4
      ],
      [
        -5,
        4
      ],
      [
        -7,
        -6
      ],
      [
        -3,
        -1
      ],
      [
        0,
        1
      ],
      [
        -3,
        3
      ],
      [
        -2,
        -3
      ],
      [
        -4,
        -10
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -2
      ],
      [
        -4,
        -1
      ],
      [
        -1,
        6
      ],
      [
        1,
        2
      ],
      [
        -1,
        4
      ],
      [
        -2,
        5
      ],
      [
        -11,
        -20
      ],
      [
        2,
        29
      ],
      [
        -1,
        0
      ],
      [
        -8,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -8,
        -13
      ],
      [
        0,
        2
      ],
      [
        -2,
        4
      ],
      [
        -6,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -9
      ],
      [
        -2,
        -2
      ],
      [
        0,
        -1
      ],
      [
        -6,
        -3
      ],
      [
        -4,
        1
      ],
      [
        -1,
        3
      ],
      [
        -1,
        2
      ],
      [
        0,
        6
      ],
      [
        3,
        4
      ],
      [
        0,
        4
      ],
      [
        -1,
        7
      ],
      [
        -2,
        5
      ],
      [
        0,
        12
      ],
      [
        -1,
        17
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        -2,
        -6
      ],
      [
        -2,
        -11
      ],
      [
        -4,
        -2
      ],
      [
        1,
        -4
      ],
      [
        1,
        -8
      ],
      [
        1,
        -7
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -1
      ],
      [
        -6,
        -7
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -7,
        -22
      ],
      [
        -3,
        -12
      ],
      [
        -3,
        -15
      ],
      [
        -2,
        -6
      ],
      [
        -1,
        -1
      ],
      [
        0,
        3
      ],
      [
        -1,
        1
      ],
      [
        -6,
        3
      ],
      [
        -2,
        0
      ],
      [
        -2,
        -4
      ],
      [
        -6,
        -14
      ],
      [
        -7,
        -26
      ],
      [
        -1,
        -4
      ]
    ],
    [
      [
        29543,
        64863
      ],
      [
        -4,
        12
      ],
      [
        4,
        29
      ],
      [
        0,
        30
      ],
      [
        5,
        20
      ],
      [
        1,
        9
      ],
      [
        0,
        20
      ],
      [
        2,
        13
      ],
      [
        3,
        7
      ],
      [
        1,
        7
      ],
      [
        -1,
        7
      ],
      [
        -4,
        14
      ],
      [
        -2,
        7
      ],
      [
        -7,
        15
      ],
      [
        -2,
        11
      ],
      [
        0,
        5
      ],
      [
        -4,
        7
      ],
      [
        -3,
        19
      ],
      [
        -2,
        10
      ],
      [
        -1,
        7
      ],
      [
        -7,
        11
      ],
      [
        -1,
        19
      ],
      [
        -6,
        14
      ],
      [
        -3,
        11
      ],
      [
        -4,
        -4
      ],
      [
        -3,
        16
      ],
      [
        -5,
        -6
      ],
      [
        -3,
        19
      ],
      [
        -7,
        -3
      ],
      [
        -3,
        23
      ]
    ],
    [
      [
        29487,
        65212
      ],
      [
        -5,
        19
      ],
      [
        2,
        22
      ],
      [
        19,
        10
      ],
      [
        13,
        -4
      ],
      [
        10,
        4
      ],
      [
        4,
        4
      ],
      [
        -3,
        48
      ],
      [
        6,
        1
      ],
      [
        14,
        14
      ],
      [
        3,
        18
      ],
      [
        5,
        4
      ],
      [
        2,
        0
      ],
      [
        0,
        21
      ],
      [
        2,
        3
      ],
      [
        4,
        7
      ],
      [
        5,
        -1
      ],
      [
        -1,
        15
      ],
      [
        11,
        14
      ]
    ],
    [
      [
        25668,
        61411
      ],
      [
        0,
        -99
      ],
      [
        -15,
        0
      ],
      [
        -1,
        -25
      ],
      [
        -4,
        -16
      ],
      [
        -2,
        -30
      ],
      [
        2,
        -9
      ],
      [
        -10,
        -6
      ],
      [
        -2,
        12
      ],
      [
        -6,
        -1
      ],
      [
        0,
        -35
      ],
      [
        -8,
        -15
      ],
      [
        -4,
        -27
      ],
      [
        -8,
        -18
      ],
      [
        -2,
        -28
      ],
      [
        -2,
        5
      ],
      [
        -8,
        -32
      ],
      [
        0,
        -54
      ]
    ],
    [
      [
        25547,
        61106
      ],
      [
        0,
        109
      ],
      [
        -6,
        0
      ],
      [
        0,
        101
      ],
      [
        2,
        51
      ]
    ],
    [
      [
        25953,
        61661
      ],
      [
        0,
        82
      ],
      [
        11,
        1
      ],
      [
        -1,
        15
      ],
      [
        21,
        2
      ],
      [
        0,
        17
      ],
      [
        5,
        0
      ],
      [
        0,
        33
      ],
      [
        5,
        0
      ],
      [
        0,
        17
      ]
    ],
    [
      [
        26071,
        61880
      ],
      [
        21,
        1
      ],
      [
        0,
        -17
      ],
      [
        5,
        -7
      ],
      [
        14,
        0
      ]
    ],
    [
      [
        26111,
        61857
      ],
      [
        2,
        -15
      ],
      [
        1,
        -11
      ],
      [
        0,
        -27
      ],
      [
        -2,
        -11
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -5
      ]
    ],
    [
      [
        26109,
        61785
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -4
      ],
      [
        -5,
        -7
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -10
      ],
      [
        -3,
        -13
      ],
      [
        -2,
        -7
      ],
      [
        -5,
        -8
      ],
      [
        -3,
        -4
      ],
      [
        -2,
        -3
      ],
      [
        -5,
        -2
      ],
      [
        -6,
        -1
      ],
      [
        -4,
        -3
      ],
      [
        -4,
        -10
      ],
      [
        -1,
        -3
      ],
      [
        -4,
        -19
      ],
      [
        0,
        -7
      ],
      [
        -2,
        -17
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -15
      ]
    ],
    [
      [
        26052,
        61617
      ],
      [
        0,
        -22
      ],
      [
        -2,
        -21
      ],
      [
        -2,
        -19
      ],
      [
        -2,
        -9
      ],
      [
        -2,
        -10
      ],
      [
        -2,
        -11
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -1
      ],
      [
        -8,
        -15
      ],
      [
        -5,
        -11
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        0
      ],
      [
        -3,
        6
      ],
      [
        -2,
        6
      ],
      [
        1,
        2
      ],
      [
        0,
        1
      ],
      [
        -2,
        7
      ],
      [
        -3,
        2
      ],
      [
        -2,
        0
      ]
    ],
    [
      [
        27079,
        50651
      ],
      [
        29,
        0
      ],
      [
        2,
        2
      ],
      [
        22,
        -1
      ],
      [
        12,
        1
      ],
      [
        7,
        -2
      ],
      [
        10,
        1
      ],
      [
        0,
        102
      ],
      [
        6,
        0
      ],
      [
        -1,
        140
      ],
      [
        0,
        126
      ]
    ],
    [
      [
        27166,
        51020
      ],
      [
        2,
        -37
      ],
      [
        4,
        -19
      ],
      [
        1,
        -26
      ],
      [
        6,
        -8
      ],
      [
        9,
        1
      ],
      [
        2,
        -14
      ],
      [
        6,
        -13
      ],
      [
        8,
        -62
      ],
      [
        1,
        -30
      ],
      [
        3,
        -6
      ],
      [
        7,
        4
      ],
      [
        3,
        -17
      ],
      [
        -1,
        -21
      ],
      [
        3,
        -2
      ],
      [
        4,
        -20
      ],
      [
        11,
        -29
      ],
      [
        3,
        -13
      ],
      [
        2,
        -18
      ],
      [
        6,
        -10
      ],
      [
        -2,
        -9
      ],
      [
        -2,
        -25
      ],
      [
        4,
        -11
      ],
      [
        0,
        -57
      ],
      [
        -4,
        -21
      ]
    ],
    [
      [
        27242,
        50557
      ],
      [
        -4,
        -31
      ],
      [
        -10,
        -32
      ],
      [
        1,
        -46
      ]
    ],
    [
      [
        27161,
        49938
      ],
      [
        -37,
        -1
      ],
      [
        0,
        18
      ],
      [
        -18,
        0
      ],
      [
        0,
        -18
      ],
      [
        -28,
        -1
      ]
    ],
    [
      [
        26420,
        62364
      ],
      [
        1,
        -6
      ],
      [
        3,
        -12
      ],
      [
        1,
        -12
      ],
      [
        1,
        -7
      ],
      [
        0,
        -25
      ],
      [
        2,
        -15
      ],
      [
        3,
        -12
      ],
      [
        1,
        -5
      ],
      [
        4,
        -17
      ],
      [
        1,
        -4
      ],
      [
        3,
        -19
      ],
      [
        1,
        -4
      ],
      [
        1,
        -3
      ],
      [
        1,
        -9
      ],
      [
        1,
        -10
      ],
      [
        0,
        -11
      ]
    ],
    [
      [
        26444,
        62193
      ],
      [
        -43,
        -73
      ],
      [
        -6,
        -7
      ],
      [
        -3,
        0
      ]
    ],
    [
      [
        26392,
        62113
      ],
      [
        -3,
        26
      ],
      [
        -6,
        -10
      ],
      [
        -4,
        36
      ],
      [
        4,
        13
      ],
      [
        3,
        50
      ],
      [
        0,
        3
      ],
      [
        -6,
        44
      ],
      [
        0,
        5
      ],
      [
        3,
        0
      ],
      [
        7,
        34
      ],
      [
        -4,
        6
      ],
      [
        -4,
        -19
      ],
      [
        -3,
        12
      ],
      [
        4,
        18
      ],
      [
        -5,
        13
      ],
      [
        -6,
        19
      ],
      [
        0,
        11
      ],
      [
        1,
        12
      ],
      [
        -3,
        21
      ],
      [
        1,
        16
      ],
      [
        -3,
        26
      ]
    ],
    [
      [
        26368,
        62449
      ],
      [
        1,
        2
      ],
      [
        1,
        4
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        2,
        9
      ],
      [
        2,
        7
      ],
      [
        1,
        3
      ],
      [
        1,
        3
      ],
      [
        3,
        0
      ],
      [
        2,
        -1
      ],
      [
        1,
        -3
      ],
      [
        2,
        -4
      ],
      [
        1,
        -6
      ],
      [
        1,
        -8
      ],
      [
        1,
        -10
      ],
      [
        0,
        -31
      ],
      [
        1,
        -11
      ],
      [
        0,
        -3
      ],
      [
        1,
        -3
      ],
      [
        1,
        -2
      ],
      [
        4,
        -6
      ],
      [
        2,
        0
      ],
      [
        0,
        1
      ],
      [
        2,
        -2
      ],
      [
        2,
        0
      ],
      [
        7,
        -4
      ],
      [
        4,
        -5
      ],
      [
        3,
        -5
      ],
      [
        2,
        -5
      ],
      [
        1,
        -1
      ],
      [
        2,
        -7
      ]
    ],
    [
      [
        24509,
        53025
      ],
      [
        33,
        0
      ]
    ],
    [
      [
        24607,
        53025
      ],
      [
        -5,
        -19
      ],
      [
        0,
        -24
      ],
      [
        -5,
        -23
      ],
      [
        4,
        -63
      ],
      [
        -3,
        -19
      ],
      [
        0,
        -15
      ],
      [
        5,
        -14
      ],
      [
        -2,
        -9
      ],
      [
        3,
        -30
      ],
      [
        -2,
        -24
      ],
      [
        0,
        -32
      ],
      [
        -2,
        -13
      ],
      [
        3,
        -35
      ],
      [
        -3,
        -6
      ]
    ],
    [
      [
        24475,
        52618
      ],
      [
        -3,
        5
      ]
    ],
    [
      [
        24472,
        52623
      ],
      [
        1,
        23
      ],
      [
        -4,
        30
      ],
      [
        8,
        19
      ],
      [
        -1,
        11
      ],
      [
        3,
        11
      ],
      [
        0,
        14
      ],
      [
        2,
        14
      ],
      [
        3,
        -1
      ],
      [
        5,
        33
      ],
      [
        4,
        11
      ],
      [
        -2,
        11
      ],
      [
        3,
        6
      ],
      [
        -1,
        17
      ],
      [
        1,
        4
      ],
      [
        2,
        22
      ],
      [
        -1,
        7
      ],
      [
        2,
        13
      ],
      [
        -1,
        19
      ],
      [
        2,
        14
      ],
      [
        3,
        -1
      ],
      [
        -1,
        27
      ],
      [
        6,
        25
      ],
      [
        -2,
        11
      ],
      [
        0,
        20
      ],
      [
        4,
        13
      ],
      [
        1,
        29
      ]
    ],
    [
      [
        26718,
        52165
      ],
      [
        6,
        45
      ],
      [
        5,
        15
      ],
      [
        -1,
        38
      ],
      [
        4,
        4
      ],
      [
        2,
        31
      ],
      [
        6,
        12
      ]
    ],
    [
      [
        26740,
        52310
      ],
      [
        3,
        18
      ],
      [
        1,
        20
      ],
      [
        6,
        2
      ],
      [
        3,
        16
      ],
      [
        11,
        6
      ],
      [
        2,
        -14
      ],
      [
        12,
        6
      ],
      [
        7,
        -10
      ],
      [
        2,
        8
      ],
      [
        5,
        -12
      ],
      [
        5,
        -2
      ],
      [
        16,
        -43
      ],
      [
        0,
        9
      ],
      [
        5,
        -3
      ],
      [
        -1,
        -13
      ],
      [
        3,
        -11
      ],
      [
        7,
        -8
      ],
      [
        4,
        -20
      ],
      [
        3,
        7
      ],
      [
        6,
        -12
      ],
      [
        3,
        9
      ],
      [
        1,
        -9
      ]
    ],
    [
      [
        26844,
        52254
      ],
      [
        1,
        -408
      ],
      [
        9,
        0
      ],
      [
        0,
        -24
      ],
      [
        -7,
        -13
      ],
      [
        -4,
        -26
      ]
    ],
    [
      [
        26843,
        51783
      ],
      [
        -9,
        -23
      ],
      [
        -9,
        -2
      ],
      [
        -4,
        -28
      ]
    ],
    [
      [
        24381,
        53025
      ],
      [
        128,
        0
      ]
    ],
    [
      [
        24472,
        52623
      ],
      [
        -6,
        6
      ]
    ],
    [
      [
        24374,
        52992
      ],
      [
        4,
        14
      ],
      [
        3,
        19
      ]
    ],
    [
      [
        24357,
        53078
      ],
      [
        7,
        -6
      ],
      [
        11,
        5
      ],
      [
        3,
        -8
      ],
      [
        1,
        -17
      ],
      [
        -4,
        -33
      ]
    ],
    [
      [
        24349,
        53048
      ],
      [
        1,
        5
      ],
      [
        7,
        25
      ]
    ],
    [
      [
        30793,
        68290
      ],
      [
        1,
        -18
      ],
      [
        5,
        -13
      ],
      [
        5,
        -17
      ],
      [
        -6,
        -38
      ],
      [
        1,
        -31
      ],
      [
        -5,
        -2
      ],
      [
        -4,
        8
      ],
      [
        -7,
        -16
      ],
      [
        -1,
        21
      ],
      [
        0,
        31
      ],
      [
        -2,
        33
      ],
      [
        6,
        4
      ],
      [
        -1,
        25
      ],
      [
        -2,
        10
      ],
      [
        0,
        12
      ]
    ],
    [
      [
        30712,
        67988
      ],
      [
        1,
        18
      ],
      [
        4,
        15
      ],
      [
        3,
        4
      ],
      [
        4,
        -17
      ],
      [
        0,
        -38
      ],
      [
        -3,
        -20
      ],
      [
        -5,
        1
      ],
      [
        -4,
        13
      ],
      [
        0,
        24
      ]
    ],
    [
      [
        30703,
        68290
      ],
      [
        3,
        21
      ],
      [
        5,
        20
      ],
      [
        8,
        14
      ],
      [
        3,
        8
      ],
      [
        8,
        19
      ],
      [
        6,
        4
      ],
      [
        2,
        -7
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -6
      ],
      [
        1,
        -15
      ],
      [
        3,
        1
      ],
      [
        5,
        -18
      ],
      [
        1,
        -3
      ],
      [
        1,
        2
      ],
      [
        1,
        -2
      ],
      [
        -3,
        -8
      ],
      [
        -3,
        1
      ],
      [
        -5,
        -1
      ],
      [
        0,
        -17
      ],
      [
        1,
        -7
      ],
      [
        3,
        0
      ],
      [
        4,
        -27
      ],
      [
        3,
        -10
      ],
      [
        2,
        -7
      ],
      [
        1,
        -10
      ],
      [
        -3,
        -14
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        1
      ],
      [
        -5,
        -21
      ],
      [
        -3,
        -5
      ],
      [
        -2,
        0
      ],
      [
        -10,
        -8
      ],
      [
        -3,
        0
      ],
      [
        -5,
        9
      ],
      [
        -7,
        15
      ],
      [
        2,
        14
      ],
      [
        3,
        11
      ],
      [
        -2,
        12
      ],
      [
        -2,
        9
      ],
      [
        1,
        24
      ],
      [
        0,
        5
      ],
      [
        -9,
        0
      ],
      [
        -1,
        3
      ]
    ],
    [
      [
        30680,
        68449
      ],
      [
        0,
        -1
      ],
      [
        -3,
        -17
      ],
      [
        -1,
        -10
      ],
      [
        0,
        -12
      ],
      [
        -3,
        -22
      ],
      [
        0,
        -28
      ],
      [
        -2,
        -7
      ],
      [
        -5,
        -1
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        1,
        -15
      ],
      [
        1,
        -16
      ],
      [
        -2,
        -14
      ],
      [
        0,
        -2
      ],
      [
        -5,
        -13
      ],
      [
        0,
        -13
      ],
      [
        2,
        -9
      ],
      [
        1,
        -1
      ],
      [
        3,
        6
      ],
      [
        6,
        6
      ],
      [
        2,
        -1
      ],
      [
        2,
        -3
      ],
      [
        3,
        -15
      ],
      [
        -5,
        -19
      ],
      [
        0,
        6
      ],
      [
        -2,
        2
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        -15
      ],
      [
        1,
        -10
      ],
      [
        2,
        -8
      ],
      [
        0,
        -3
      ],
      [
        6,
        -27
      ],
      [
        1,
        -9
      ],
      [
        -2,
        -9
      ],
      [
        -5,
        -9
      ],
      [
        -3,
        -20
      ],
      [
        -5,
        7
      ],
      [
        -10,
        -4
      ],
      [
        -4,
        6
      ],
      [
        -8,
        -5
      ],
      [
        -3,
        -20
      ],
      [
        -5,
        -21
      ],
      [
        -3,
        -24
      ],
      [
        -2,
        -7
      ],
      [
        -6,
        4
      ],
      [
        -9,
        -5
      ],
      [
        -2,
        -58
      ],
      [
        -11,
        -9
      ],
      [
        0,
        11
      ],
      [
        2,
        19
      ],
      [
        -2,
        22
      ],
      [
        2,
        19
      ],
      [
        5,
        18
      ],
      [
        -3,
        12
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        3
      ],
      [
        -2,
        3
      ],
      [
        -3,
        -14
      ],
      [
        0,
        -16
      ],
      [
        -9,
        -7
      ],
      [
        -3,
        -22
      ],
      [
        0,
        16
      ],
      [
        2,
        18
      ],
      [
        4,
        25
      ],
      [
        -1,
        22
      ],
      [
        -3,
        -4
      ]
    ],
    [
      [
        30583,
        68114
      ],
      [
        3,
        60
      ],
      [
        5,
        7
      ],
      [
        5,
        -15
      ],
      [
        2,
        32
      ],
      [
        11,
        22
      ],
      [
        0,
        3
      ],
      [
        -8,
        47
      ],
      [
        2,
        43
      ],
      [
        -5,
        47
      ],
      [
        -4,
        43
      ],
      [
        -10,
        -5
      ],
      [
        -9,
        6
      ],
      [
        0,
        10
      ],
      [
        -8,
        9
      ],
      [
        -4,
        41
      ],
      [
        2,
        26
      ],
      [
        -3,
        34
      ],
      [
        4,
        13
      ],
      [
        8,
        4
      ]
    ],
    [
      [
        26633,
        66337
      ],
      [
        33,
        5
      ],
      [
        17,
        2
      ],
      [
        2,
        0
      ],
      [
        14,
        1
      ],
      [
        32,
        3
      ],
      [
        0,
        1
      ],
      [
        6,
        0
      ],
      [
        4,
        1
      ],
      [
        7,
        0
      ],
      [
        16,
        1
      ]
    ],
    [
      [
        26764,
        66351
      ],
      [
        16,
        1
      ],
      [
        6,
        1
      ],
      [
        9,
        1
      ],
      [
        1,
        0
      ],
      [
        9,
        1
      ],
      [
        2,
        0
      ],
      [
        16,
        1
      ]
    ],
    [
      [
        26823,
        66356
      ],
      [
        -3,
        -42
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -12
      ],
      [
        -1,
        -10
      ],
      [
        -1,
        -5
      ],
      [
        -5,
        -8
      ],
      [
        -1,
        -4
      ],
      [
        -3,
        -18
      ],
      [
        1,
        -8
      ],
      [
        -6,
        -6
      ],
      [
        -3,
        -9
      ],
      [
        -9,
        -8
      ],
      [
        -8,
        -3
      ],
      [
        -13,
        -14
      ],
      [
        -4,
        -11
      ],
      [
        -5,
        -22
      ],
      [
        0,
        -4
      ],
      [
        -4,
        -30
      ],
      [
        -4,
        -25
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -37
      ],
      [
        -1,
        -33
      ],
      [
        3,
        -57
      ],
      [
        -3,
        -44
      ],
      [
        -7,
        -3
      ],
      [
        -3,
        -14
      ],
      [
        -5,
        -8
      ],
      [
        0,
        -6
      ],
      [
        1,
        -10
      ],
      [
        -1,
        -25
      ],
      [
        0,
        -2
      ]
    ],
    [
      [
        26735,
        65865
      ],
      [
        -9,
        23
      ],
      [
        -2,
        0
      ],
      [
        -10,
        23
      ],
      [
        -6,
        24
      ],
      [
        -5,
        5
      ],
      [
        -33,
        0
      ],
      [
        0,
        -7
      ],
      [
        -33,
        -3
      ]
    ],
    [
      [
        24914,
        57677
      ],
      [
        0,
        -260
      ]
    ],
    [
      [
        24914,
        57417
      ],
      [
        -53,
        0
      ],
      [
        0,
        -16
      ],
      [
        -11,
        -23
      ],
      [
        0,
        -13
      ],
      [
        -8,
        -2
      ],
      [
        -13,
        -20
      ],
      [
        -7,
        4
      ],
      [
        -2,
        19
      ],
      [
        -13,
        6
      ],
      [
        -3,
        22
      ],
      [
        -3,
        10
      ],
      [
        -12,
        -2
      ],
      [
        -6,
        -40
      ],
      [
        -2,
        0
      ]
    ],
    [
      [
        24781,
        57362
      ],
      [
        0,
        158
      ],
      [
        -29,
        0
      ]
    ],
    [
      [
        24752,
        57520
      ],
      [
        -2,
        13
      ],
      [
        1,
        4
      ],
      [
        2,
        6
      ],
      [
        6,
        11
      ],
      [
        8,
        20
      ],
      [
        1,
        3
      ],
      [
        0,
        5
      ],
      [
        1,
        8
      ],
      [
        0,
        20
      ],
      [
        -1,
        7
      ],
      [
        0,
        5
      ],
      [
        -1,
        4
      ],
      [
        -1,
        4
      ],
      [
        -1,
        3
      ],
      [
        -6,
        9
      ],
      [
        -1,
        3
      ],
      [
        -1,
        5
      ],
      [
        -2,
        3
      ],
      [
        -1,
        2
      ],
      [
        -1,
        6
      ],
      [
        -1,
        4
      ],
      [
        -1,
        12
      ]
    ],
    [
      [
        28412,
        62750
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        28492,
        62746
      ],
      [
        2,
        -21
      ],
      [
        11,
        -24
      ],
      [
        3,
        9
      ],
      [
        8,
        -6
      ],
      [
        5,
        -22
      ],
      [
        -5,
        -33
      ],
      [
        9,
        -18
      ],
      [
        -1,
        -2
      ],
      [
        7,
        -20
      ],
      [
        5,
        -6
      ],
      [
        2,
        -2
      ],
      [
        4,
        -14
      ],
      [
        1,
        1
      ]
    ],
    [
      [
        28543,
        62588
      ],
      [
        0,
        -3
      ],
      [
        -4,
        -11
      ],
      [
        -2,
        -15
      ],
      [
        -1,
        -7
      ],
      [
        -6,
        -4
      ],
      [
        -10,
        -40
      ],
      [
        -2,
        -20
      ],
      [
        -7,
        -7
      ],
      [
        -4,
        -14
      ],
      [
        -4,
        -8
      ]
    ],
    [
      [
        28503,
        62459
      ],
      [
        -8,
        11
      ],
      [
        -5,
        21
      ]
    ],
    [
      [
        24796,
        60757
      ],
      [
        10,
        35
      ]
    ],
    [
      [
        24806,
        60792
      ],
      [
        21,
        118
      ],
      [
        10,
        57
      ],
      [
        17,
        62
      ]
    ],
    [
      [
        24854,
        61029
      ],
      [
        4,
        -5
      ],
      [
        3,
        -1
      ],
      [
        3,
        0
      ],
      [
        2,
        2
      ],
      [
        4,
        9
      ],
      [
        1,
        5
      ],
      [
        3,
        12
      ],
      [
        1,
        3
      ],
      [
        4,
        9
      ],
      [
        1,
        2
      ],
      [
        1,
        -1
      ],
      [
        2,
        -4
      ],
      [
        6,
        -16
      ],
      [
        3,
        -6
      ],
      [
        1,
        -1
      ],
      [
        0,
        -15
      ],
      [
        1,
        -11
      ],
      [
        0,
        -3
      ],
      [
        3,
        -6
      ],
      [
        1,
        4
      ],
      [
        0,
        -2
      ],
      [
        2,
        -2
      ],
      [
        2,
        0
      ],
      [
        1,
        -1
      ],
      [
        2,
        -4
      ],
      [
        1,
        -1
      ],
      [
        3,
        0
      ],
      [
        1,
        -4
      ],
      [
        1,
        -5
      ],
      [
        1,
        -4
      ],
      [
        4,
        -11
      ],
      [
        4,
        -11
      ],
      [
        2,
        -3
      ],
      [
        3,
        -7
      ],
      [
        2,
        -3
      ],
      [
        1,
        -3
      ]
    ],
    [
      [
        24928,
        60945
      ],
      [
        1,
        -3
      ],
      [
        2,
        -11
      ],
      [
        0,
        -3
      ],
      [
        1,
        -2
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -14
      ],
      [
        1,
        -2
      ],
      [
        1,
        -3
      ],
      [
        3,
        -3
      ],
      [
        1,
        1
      ],
      [
        3,
        0
      ],
      [
        2,
        2
      ],
      [
        1,
        1
      ],
      [
        2,
        1
      ],
      [
        0,
        -8
      ],
      [
        1,
        -3
      ],
      [
        1,
        -1
      ],
      [
        2,
        -3
      ],
      [
        1,
        -4
      ],
      [
        2,
        -11
      ],
      [
        1,
        -7
      ],
      [
        1,
        -5
      ],
      [
        3,
        -5
      ],
      [
        2,
        -2
      ],
      [
        8,
        -7
      ],
      [
        2,
        -1
      ],
      [
        1,
        -3
      ],
      [
        1,
        -2
      ],
      [
        2,
        -4
      ],
      [
        0,
        -3
      ],
      [
        1,
        -6
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -38
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -6
      ],
      [
        1,
        -5
      ],
      [
        1,
        -8
      ],
      [
        6,
        -21
      ],
      [
        2,
        -9
      ],
      [
        1,
        -4
      ],
      [
        0,
        -12
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -1
      ],
      [
        -4,
        4
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -9
      ]
    ],
    [
      [
        24970,
        60670
      ],
      [
        -6,
        0
      ],
      [
        -3,
        12
      ],
      [
        -7,
        -7
      ],
      [
        -3,
        4
      ],
      [
        -3,
        33
      ],
      [
        -7,
        -17
      ],
      [
        -6,
        11
      ],
      [
        -5,
        1
      ],
      [
        -2,
        -17
      ],
      [
        -3,
        11
      ],
      [
        -8,
        7
      ],
      [
        -2,
        -13
      ],
      [
        -2,
        14
      ],
      [
        -6,
        -12
      ],
      [
        -15,
        5
      ],
      [
        0,
        10
      ],
      [
        -16,
        -4
      ]
    ],
    [
      [
        24636,
        62599
      ],
      [
        1,
        -11
      ],
      [
        0,
        -20
      ],
      [
        1,
        -14
      ],
      [
        1,
        -10
      ],
      [
        0,
        -25
      ],
      [
        1,
        -5
      ],
      [
        1,
        -9
      ],
      [
        0,
        -5
      ],
      [
        1,
        -4
      ],
      [
        1,
        -6
      ],
      [
        2,
        -12
      ],
      [
        1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        1,
        -15
      ],
      [
        0,
        -15
      ],
      [
        -5,
        -19
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -6
      ],
      [
        -3,
        -10
      ],
      [
        0,
        -4
      ],
      [
        1,
        -8
      ],
      [
        1,
        -5
      ],
      [
        2,
        -16
      ],
      [
        2,
        -14
      ],
      [
        1,
        -5
      ],
      [
        0,
        -8
      ],
      [
        1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        1,
        -8
      ],
      [
        1,
        -9
      ],
      [
        0,
        -26
      ],
      [
        1,
        -11
      ],
      [
        1,
        -5
      ],
      [
        1,
        -16
      ]
    ],
    [
      [
        24652,
        62262
      ],
      [
        -8,
        0
      ],
      [
        3,
        -21
      ],
      [
        -7,
        6
      ],
      [
        0,
        -22
      ],
      [
        -7,
        14
      ],
      [
        2,
        13
      ],
      [
        -6,
        4
      ],
      [
        -2,
        -10
      ],
      [
        -7,
        2
      ],
      [
        -7,
        -13
      ],
      [
        -1,
        -11
      ],
      [
        0,
        -28
      ],
      [
        -3,
        -2
      ],
      [
        -13,
        14
      ],
      [
        -15,
        0
      ],
      [
        -1,
        -1
      ],
      [
        0,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        24579,
        62208
      ],
      [
        0,
        0
      ]
    ],
    [
      [
        24579,
        62208
      ],
      [
        -1,
        0
      ],
      [
        0,
        -2
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        24577,
        62206
      ],
      [
        0,
        0
      ]
    ],
    [
      [
        24577,
        62206
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        -1
      ]
    ],
    [
      [
        24575,
        62207
      ],
      [
        0,
        0
      ]
    ],
    [
      [
        24575,
        62207
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        5
      ],
      [
        -1,
        0
      ],
      [
        0,
        2
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -27
      ]
    ],
    [
      [
        23536,
        72129
      ],
      [
        0,
        -102
      ],
      [
        2,
        -209
      ],
      [
        0,
        -193
      ],
      [
        1,
        -1
      ],
      [
        0,
        -201
      ],
      [
        -36,
        0
      ]
    ],
    [
      [
        23503,
        71423
      ],
      [
        -104,
        1
      ]
    ],
    [
      [
        23399,
        71424
      ],
      [
        0,
        202
      ],
      [
        -2,
        0
      ],
      [
        0,
        203
      ]
    ],
    [
      [
        23397,
        71829
      ],
      [
        0,
        201
      ],
      [
        -4,
        0
      ],
      [
        0,
        102
      ]
    ],
    [
      [
        23550,
        60009
      ],
      [
        -65,
        0
      ],
      [
        -40,
        1
      ],
      [
        -3,
        0
      ]
    ],
    [
      [
        23442,
        60010
      ],
      [
        -18,
        0
      ]
    ],
    [
      [
        23424,
        60010
      ],
      [
        -1,
        56
      ],
      [
        0,
        340
      ]
    ],
    [
      [
        22933,
        70005
      ],
      [
        162,
        0
      ]
    ],
    [
      [
        23133,
        69803
      ],
      [
        -1,
        -24
      ],
      [
        0,
        -177
      ],
      [
        4,
        0
      ],
      [
        1,
        -73
      ]
    ],
    [
      [
        23034,
        69703
      ],
      [
        -2,
        15
      ],
      [
        -1,
        8
      ],
      [
        -2,
        13
      ],
      [
        -3,
        9
      ],
      [
        -2,
        3
      ],
      [
        -4,
        9
      ],
      [
        -3,
        4
      ],
      [
        -2,
        2
      ],
      [
        -2,
        1
      ],
      [
        -4,
        5
      ],
      [
        -3,
        5
      ],
      [
        -2,
        3
      ],
      [
        -2,
        4
      ],
      [
        -4,
        8
      ],
      [
        -5,
        6
      ],
      [
        -3,
        1
      ],
      [
        -3,
        0
      ],
      [
        -2,
        1
      ],
      [
        -4,
        -1
      ],
      [
        -2,
        2
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        -3,
        7
      ],
      [
        -2,
        10
      ],
      [
        -3,
        13
      ],
      [
        -3,
        17
      ],
      [
        -2,
        6
      ],
      [
        -1,
        2
      ],
      [
        -1,
        9
      ],
      [
        0,
        8
      ],
      [
        -1,
        6
      ],
      [
        -1,
        2
      ],
      [
        0,
        10
      ],
      [
        -2,
        15
      ],
      [
        -3,
        15
      ],
      [
        -1,
        8
      ],
      [
        -4,
        17
      ],
      [
        -1,
        6
      ],
      [
        -3,
        11
      ],
      [
        -1,
        4
      ],
      [
        -1,
        1
      ],
      [
        -9,
        36
      ]
    ],
    [
      [
        28873,
        62764
      ],
      [
        1,
        0
      ],
      [
        1,
        -7
      ],
      [
        3,
        -6
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -6
      ],
      [
        1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        3,
        -7
      ],
      [
        0,
        -1
      ],
      [
        3,
        -6
      ],
      [
        3,
        -3
      ],
      [
        6,
        -18
      ],
      [
        0,
        -4
      ],
      [
        1,
        -14
      ],
      [
        0,
        -1
      ],
      [
        2,
        -14
      ],
      [
        5,
        -23
      ],
      [
        2,
        -12
      ],
      [
        -1,
        -10
      ],
      [
        0,
        -27
      ],
      [
        3,
        -8
      ],
      [
        1,
        -13
      ],
      [
        -1,
        -19
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        -14
      ],
      [
        0,
        -22
      ],
      [
        2,
        -78
      ],
      [
        0,
        -26
      ],
      [
        1,
        -1
      ],
      [
        1,
        -8
      ],
      [
        0,
        -1
      ],
      [
        2,
        -8
      ],
      [
        2,
        -3
      ],
      [
        10,
        -27
      ],
      [
        1,
        -6
      ],
      [
        6,
        -37
      ],
      [
        1,
        -9
      ],
      [
        1,
        -15
      ],
      [
        0,
        -25
      ]
    ],
    [
      [
        28929,
        62276
      ],
      [
        -2,
        8
      ],
      [
        -8,
        -7
      ],
      [
        -9,
        17
      ],
      [
        -3,
        -9
      ],
      [
        -3,
        -8
      ],
      [
        0,
        -33
      ],
      [
        -17,
        -9
      ],
      [
        -6,
        -8
      ],
      [
        -2,
        -17
      ],
      [
        -4,
        -12
      ],
      [
        -4,
        -27
      ],
      [
        -10,
        -24
      ],
      [
        -46,
        -6
      ]
    ],
    [
      [
        28808,
        62505
      ],
      [
        0,
        1
      ],
      [
        -1,
        25
      ],
      [
        0,
        15
      ],
      [
        -2,
        79
      ]
    ],
    [
      [
        17343,
        68337
      ],
      [
        124,
        -2
      ]
    ],
    [
      [
        17395,
        67934
      ],
      [
        -12,
        0
      ],
      [
        0,
        -8
      ],
      [
        -11,
        0
      ],
      [
        0,
        -8
      ],
      [
        -16,
        0
      ],
      [
        0,
        17
      ],
      [
        -12,
        0
      ],
      [
        0,
        16
      ],
      [
        -5,
        0
      ],
      [
        0,
        17
      ],
      [
        -12,
        1
      ],
      [
        0,
        50
      ],
      [
        -7,
        0
      ]
    ],
    [
      [
        17320,
        68019
      ],
      [
        1,
        18
      ],
      [
        0,
        12
      ],
      [
        -1,
        11
      ],
      [
        4,
        2
      ],
      [
        2,
        5
      ],
      [
        0,
        11
      ],
      [
        -2,
        5
      ],
      [
        -1,
        5
      ],
      [
        1,
        5
      ],
      [
        1,
        11
      ],
      [
        0,
        7
      ],
      [
        1,
        6
      ],
      [
        0,
        3
      ],
      [
        -1,
        2
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        8
      ],
      [
        2,
        4
      ],
      [
        3,
        6
      ],
      [
        6,
        2
      ],
      [
        0,
        8
      ],
      [
        -2,
        12
      ],
      [
        2,
        10
      ],
      [
        1,
        13
      ],
      [
        0,
        3
      ],
      [
        -1,
        6
      ],
      [
        -2,
        7
      ],
      [
        -3,
        9
      ],
      [
        -5,
        7
      ],
      [
        0,
        5
      ],
      [
        -1,
        37
      ],
      [
        1,
        4
      ],
      [
        2,
        3
      ],
      [
        3,
        1
      ],
      [
        3,
        2
      ],
      [
        2,
        4
      ],
      [
        1,
        3
      ],
      [
        2,
        9
      ],
      [
        0,
        2
      ],
      [
        8,
        51
      ]
    ],
    [
      [
        26284,
        65284
      ],
      [
        -45,
        -3
      ],
      [
        -31,
        -1
      ],
      [
        -32,
        -1
      ]
    ],
    [
      [
        26805,
        51386
      ],
      [
        22,
        0
      ],
      [
        24,
        -7
      ],
      [
        4,
        -9
      ],
      [
        0,
        -17
      ],
      [
        28,
        2
      ]
    ],
    [
      [
        26953,
        51263
      ],
      [
        0,
        -145
      ],
      [
        1,
        -169
      ],
      [
        -11,
        -1
      ],
      [
        -26,
        0
      ],
      [
        0,
        -198
      ]
    ],
    [
      [
        26917,
        50750
      ],
      [
        -12,
        -19
      ],
      [
        -5,
        2
      ],
      [
        -2,
        -19
      ],
      [
        -3,
        -5
      ],
      [
        -11,
        16
      ],
      [
        -6,
        3
      ],
      [
        -4,
        9
      ],
      [
        -7,
        -3
      ],
      [
        -4,
        -19
      ],
      [
        -8,
        -15
      ],
      [
        -1,
        -10
      ]
    ],
    [
      [
        26854,
        50690
      ],
      [
        -1,
        8
      ],
      [
        1,
        8
      ],
      [
        2,
        23
      ],
      [
        -2,
        32
      ],
      [
        -6,
        12
      ],
      [
        0,
        11
      ],
      [
        -10,
        3
      ],
      [
        -2,
        26
      ],
      [
        4,
        7
      ],
      [
        3,
        0
      ],
      [
        0,
        11
      ],
      [
        -2,
        18
      ],
      [
        1,
        20
      ],
      [
        -7,
        13
      ],
      [
        -8,
        5
      ],
      [
        -8,
        -1
      ],
      [
        -10,
        10
      ],
      [
        -3,
        -3
      ],
      [
        -4,
        0
      ],
      [
        -8,
        4
      ],
      [
        -1,
        1
      ],
      [
        -2,
        10
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -3
      ],
      [
        -6,
        -31
      ],
      [
        0,
        -12
      ],
      [
        -3,
        -8
      ],
      [
        -7,
        -4
      ],
      [
        -1,
        18
      ],
      [
        -3,
        8
      ],
      [
        2,
        21
      ],
      [
        0,
        6
      ],
      [
        -1,
        10
      ],
      [
        -4,
        14
      ],
      [
        -2,
        23
      ],
      [
        3,
        37
      ],
      [
        0,
        8
      ],
      [
        -4,
        13
      ],
      [
        -5,
        3
      ],
      [
        -5,
        12
      ],
      [
        0,
        4
      ],
      [
        -6,
        8
      ],
      [
        -4,
        -3
      ],
      [
        -1,
        2
      ]
    ],
    [
      [
        26949,
        52539
      ],
      [
        -11,
        3
      ]
    ],
    [
      [
        26938,
        52542
      ],
      [
        -18,
        5
      ],
      [
        -4,
        0
      ],
      [
        -4,
        2
      ],
      [
        -4,
        1
      ],
      [
        -1,
        0
      ],
      [
        -4,
        1
      ]
    ],
    [
      [
        26795,
        52874
      ],
      [
        0,
        366
      ]
    ],
    [
      [
        25888,
        65551
      ],
      [
        1,
        162
      ],
      [
        0,
        201
      ]
    ],
    [
      [
        25889,
        65914
      ],
      [
        32,
        -1
      ],
      [
        96,
        -2
      ]
    ],
    [
      [
        25934,
        65552
      ],
      [
        -32,
        0
      ],
      [
        -11,
        -1
      ],
      [
        -3,
        0
      ]
    ],
    [
      [
        24936,
        57677
      ],
      [
        22,
        -1
      ],
      [
        20,
        0
      ],
      [
        2,
        -1
      ],
      [
        37,
        0
      ]
    ],
    [
      [
        25017,
        57675
      ],
      [
        0,
        -174
      ],
      [
        15,
        0
      ],
      [
        0,
        -143
      ],
      [
        1,
        -161
      ],
      [
        14,
        0
      ]
    ],
    [
      [
        24929,
        57164
      ],
      [
        0,
        152
      ],
      [
        -15,
        0
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        26078,
        66725
      ],
      [
        -66,
        0
      ]
    ],
    [
      [
        21479,
        64671
      ],
      [
        224,
        0
      ]
    ],
    [
      [
        21703,
        64671
      ],
      [
        0,
        -356
      ]
    ],
    [
      [
        21479,
        64375
      ],
      [
        0,
        294
      ]
    ],
    [
      [
        21479,
        64669
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        29286,
        63620
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -21
      ],
      [
        -2,
        -27
      ],
      [
        -5,
        -92
      ],
      [
        -2,
        -49
      ],
      [
        -2,
        -30
      ],
      [
        -4,
        -129
      ],
      [
        -1,
        -38
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        -3,
        -18
      ],
      [
        -8,
        -60
      ],
      [
        -13,
        -75
      ],
      [
        -14,
        -81
      ],
      [
        -3,
        -9
      ],
      [
        -8,
        -39
      ],
      [
        -4,
        -7
      ],
      [
        -5,
        -2
      ],
      [
        0,
        -8
      ]
    ],
    [
      [
        29208,
        62920
      ],
      [
        -4,
        8
      ],
      [
        -15,
        -9
      ],
      [
        -11,
        68
      ]
    ],
    [
      [
        29178,
        62987
      ],
      [
        0,
        13
      ],
      [
        6,
        10
      ],
      [
        2,
        22
      ],
      [
        0,
        207
      ],
      [
        -12,
        95
      ],
      [
        -18,
        137
      ],
      [
        -2,
        22
      ],
      [
        -13,
        102
      ]
    ],
    [
      [
        29141,
        63595
      ],
      [
        7,
        12
      ],
      [
        33,
        96
      ],
      [
        41,
        -6
      ],
      [
        0,
        -21
      ],
      [
        5,
        -21
      ],
      [
        0,
        -18
      ],
      [
        23,
        -10
      ],
      [
        2,
        -8
      ],
      [
        13,
        43
      ],
      [
        6,
        -46
      ],
      [
        4,
        -10
      ],
      [
        2,
        5
      ],
      [
        5,
        14
      ],
      [
        4,
        -5
      ]
    ],
    [
      [
        25525,
        63046
      ],
      [
        41,
        0
      ]
    ],
    [
      [
        25617,
        63045
      ],
      [
        0,
        -101
      ],
      [
        -11,
        1
      ],
      [
        0,
        -305
      ]
    ],
    [
      [
        25505,
        62641
      ],
      [
        -1,
        2
      ],
      [
        -1,
        24
      ],
      [
        3,
        17
      ],
      [
        0,
        19
      ],
      [
        3,
        24
      ],
      [
        3,
        8
      ],
      [
        6,
        0
      ],
      [
        3,
        14
      ],
      [
        4,
        -5
      ],
      [
        0,
        150
      ]
    ],
    [
      [
        28468,
        65832
      ],
      [
        1,
        231
      ],
      [
        0,
        92
      ]
    ],
    [
      [
        28582,
        65831
      ],
      [
        -22,
        1
      ],
      [
        -31,
        1
      ],
      [
        -50,
        0
      ]
    ],
    [
      [
        26266,
        62223
      ],
      [
        1,
        -2
      ],
      [
        2,
        -2
      ],
      [
        8,
        0
      ],
      [
        3,
        -2
      ],
      [
        2,
        -1
      ],
      [
        4,
        -4
      ],
      [
        3,
        -9
      ],
      [
        1,
        -2
      ],
      [
        0,
        -14
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -1
      ]
    ],
    [
      [
        26174,
        61979
      ],
      [
        -1,
        259
      ]
    ],
    [
      [
        23398,
        71322
      ],
      [
        1,
        102
      ]
    ],
    [
      [
        23503,
        71423
      ],
      [
        0,
        -102
      ],
      [
        1,
        -100
      ],
      [
        2,
        -275
      ],
      [
        7,
        -18
      ],
      [
        7,
        2
      ],
      [
        -1,
        -14
      ]
    ],
    [
      [
        20686,
        67576
      ],
      [
        235,
        5
      ]
    ],
    [
      [
        20922,
        66996
      ],
      [
        0,
        -453
      ]
    ],
    [
      [
        23552,
        61730
      ],
      [
        51,
        -4
      ],
      [
        1,
        0
      ],
      [
        32,
        -3
      ],
      [
        4,
        -14
      ],
      [
        4,
        3
      ],
      [
        7,
        -14
      ],
      [
        9,
        11
      ],
      [
        4,
        -14
      ],
      [
        7,
        3
      ],
      [
        3,
        -5
      ],
      [
        12,
        10
      ],
      [
        13,
        2
      ],
      [
        5,
        -10
      ]
    ],
    [
      [
        23704,
        61695
      ],
      [
        0,
        -51
      ],
      [
        -2,
        -220
      ],
      [
        7,
        0
      ]
    ],
    [
      [
        23706,
        61217
      ],
      [
        -6,
        -6
      ],
      [
        -6,
        19
      ],
      [
        -2,
        -12
      ],
      [
        -2,
        13
      ],
      [
        -5,
        11
      ],
      [
        -6,
        -1
      ],
      [
        -9,
        -14
      ],
      [
        -3,
        -10
      ],
      [
        1,
        20
      ],
      [
        -4,
        -2
      ],
      [
        -1,
        -20
      ],
      [
        -3,
        6
      ],
      [
        0,
        -15
      ],
      [
        -4,
        -1
      ],
      [
        0,
        14
      ],
      [
        2,
        9
      ],
      [
        -2,
        6
      ],
      [
        -104,
        10
      ]
    ],
    [
      [
        22532,
        63506
      ],
      [
        0,
        404
      ]
    ],
    [
      [
        22658,
        63911
      ],
      [
        0,
        -406
      ]
    ],
    [
      [
        22658,
        63505
      ],
      [
        -31,
        0
      ]
    ],
    [
      [
        22627,
        63505
      ],
      [
        -67,
        0
      ],
      [
        -2,
        1
      ],
      [
        -4,
        0
      ],
      [
        -15,
        -1
      ],
      [
        -6,
        1
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        26137,
        62031
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        -3
      ],
      [
        -3,
        -1
      ],
      [
        -3,
        0
      ],
      [
        -8,
        6
      ],
      [
        -2,
        2
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        -6
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -8
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -16
      ],
      [
        0,
        -16
      ],
      [
        3,
        -13
      ],
      [
        2,
        -13
      ],
      [
        0,
        -67
      ],
      [
        1,
        -4
      ],
      [
        2,
        -14
      ]
    ],
    [
      [
        29236,
        64822
      ],
      [
        4,
        -8
      ],
      [
        4,
        -6
      ],
      [
        24,
        -44
      ],
      [
        1,
        -2
      ],
      [
        14,
        -27
      ],
      [
        23,
        -42
      ],
      [
        13,
        -25
      ],
      [
        2,
        -3
      ],
      [
        0,
        -1
      ],
      [
        1,
        0
      ],
      [
        2,
        -1
      ]
    ],
    [
      [
        29324,
        64663
      ],
      [
        0,
        -18
      ],
      [
        -1,
        -8
      ],
      [
        -2,
        -19
      ],
      [
        0,
        -8
      ],
      [
        -3,
        -31
      ],
      [
        0,
        -8
      ]
    ],
    [
      [
        29318,
        64571
      ],
      [
        -1,
        0
      ],
      [
        0,
        -5
      ],
      [
        -3,
        -28
      ],
      [
        -1,
        -9
      ]
    ],
    [
      [
        29299,
        64433
      ],
      [
        -4,
        11
      ],
      [
        -4,
        9
      ],
      [
        1,
        1
      ],
      [
        -1,
        3
      ],
      [
        1,
        1
      ],
      [
        -1,
        3
      ],
      [
        -1,
        0
      ],
      [
        -8,
        -18
      ],
      [
        -9,
        -14
      ],
      [
        -4,
        -39
      ],
      [
        -2,
        16
      ],
      [
        -9,
        2
      ],
      [
        -4,
        10
      ]
    ],
    [
      [
        29254,
        64418
      ],
      [
        2,
        15
      ],
      [
        0,
        7
      ],
      [
        2,
        17
      ]
    ],
    [
      [
        29258,
        64457
      ],
      [
        2,
        4
      ],
      [
        1,
        13
      ],
      [
        0,
        28
      ],
      [
        4,
        5
      ],
      [
        -3,
        16
      ],
      [
        -4,
        11
      ],
      [
        1,
        9
      ],
      [
        -1,
        4
      ],
      [
        0,
        29
      ],
      [
        -2,
        2
      ],
      [
        -3,
        21
      ],
      [
        1,
        7
      ],
      [
        1,
        22
      ],
      [
        -8,
        20
      ],
      [
        0,
        -8
      ],
      [
        -11,
        4
      ],
      [
        -4,
        1
      ],
      [
        -7,
        12
      ],
      [
        -5,
        29
      ],
      [
        -1,
        5
      ],
      [
        6,
        46
      ],
      [
        11,
        85
      ]
    ],
    [
      [
        29300,
        65041
      ],
      [
        24,
        11
      ],
      [
        9,
        4
      ],
      [
        18,
        7
      ],
      [
        5,
        2
      ],
      [
        33,
        15
      ],
      [
        33,
        13
      ]
    ],
    [
      [
        29422,
        65093
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -41
      ],
      [
        0,
        -36
      ],
      [
        9,
        -45
      ],
      [
        4,
        -23
      ],
      [
        6,
        -29
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        -6
      ],
      [
        -4,
        -7
      ],
      [
        -1,
        -2
      ],
      [
        -11,
        -22
      ],
      [
        -3,
        -5
      ],
      [
        -14,
        -26
      ],
      [
        -5,
        -10
      ],
      [
        -2,
        -4
      ],
      [
        -16,
        -30
      ],
      [
        -8,
        -17
      ],
      [
        1,
        -8
      ],
      [
        2,
        -7
      ],
      [
        3,
        -16
      ],
      [
        3,
        -17
      ],
      [
        2,
        -10
      ],
      [
        2,
        -11
      ],
      [
        3,
        -13
      ],
      [
        2,
        -11
      ],
      [
        2,
        -9
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -10
      ],
      [
        0,
        -17
      ]
    ],
    [
      [
        29390,
        64649
      ],
      [
        1,
        -6
      ],
      [
        -2,
        -13
      ],
      [
        0,
        -3
      ],
      [
        -1,
        2
      ],
      [
        -4,
        -6
      ],
      [
        -1,
        -16
      ],
      [
        -1,
        -4
      ],
      [
        -3,
        -7
      ],
      [
        -7,
        -8
      ],
      [
        -3,
        -9
      ],
      [
        -7,
        -14
      ],
      [
        -5,
        -24
      ],
      [
        2,
        -4
      ],
      [
        1,
        -3
      ],
      [
        0,
        -11
      ]
    ],
    [
      [
        29360,
        64523
      ],
      [
        -5,
        5
      ],
      [
        -11,
        12
      ],
      [
        0,
        -2
      ],
      [
        -1,
        2
      ],
      [
        -3,
        3
      ],
      [
        -3,
        14
      ],
      [
        -1,
        5
      ],
      [
        -2,
        -11
      ],
      [
        -5,
        6
      ],
      [
        -11,
        14
      ]
    ],
    [
      [
        29324,
        64663
      ],
      [
        0,
        10
      ],
      [
        2,
        37
      ],
      [
        -2,
        39
      ],
      [
        0,
        26
      ],
      [
        2,
        42
      ],
      [
        -1,
        25
      ],
      [
        -5,
        16
      ],
      [
        -3,
        26
      ],
      [
        -3,
        21
      ],
      [
        -5,
        21
      ],
      [
        -6,
        29
      ],
      [
        1,
        23
      ],
      [
        6,
        27
      ],
      [
        -5,
        11
      ],
      [
        -5,
        25
      ]
    ],
    [
      [
        28051,
        67145
      ],
      [
        0,
        -47
      ]
    ],
    [
      [
        28051,
        67098
      ],
      [
        -2,
        -8
      ],
      [
        -7,
        1
      ],
      [
        -4,
        18
      ],
      [
        -3,
        -11
      ],
      [
        -5,
        -3
      ],
      [
        -3,
        8
      ],
      [
        -7,
        -5
      ],
      [
        -3,
        -18
      ],
      [
        -5,
        -1
      ],
      [
        -4,
        18
      ],
      [
        -7,
        11
      ],
      [
        -1,
        -19
      ],
      [
        -5,
        6
      ],
      [
        -5,
        -7
      ],
      [
        -4,
        7
      ],
      [
        -6,
        -6
      ],
      [
        -2,
        6
      ],
      [
        -5,
        -18
      ],
      [
        -16,
        -6
      ],
      [
        -6,
        -16
      ],
      [
        -2,
        -2
      ],
      [
        1,
        -16
      ],
      [
        -1,
        -7
      ],
      [
        -3,
        -13
      ],
      [
        -13,
        4
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        26
      ],
      [
        -3,
        9
      ],
      [
        -2,
        4
      ],
      [
        -9,
        14
      ],
      [
        -18,
        3
      ],
      [
        -3,
        -4
      ]
    ],
    [
      [
        27896,
        67072
      ],
      [
        -15,
        13
      ],
      [
        0,
        7
      ],
      [
        1,
        6
      ],
      [
        2,
        5
      ],
      [
        1,
        14
      ],
      [
        0,
        7
      ],
      [
        -1,
        5
      ],
      [
        0,
        6
      ],
      [
        1,
        5
      ],
      [
        1,
        2
      ],
      [
        1,
        7
      ],
      [
        1,
        3
      ],
      [
        1,
        4
      ],
      [
        1,
        6
      ],
      [
        0,
        6
      ],
      [
        -1,
        5
      ],
      [
        0,
        11
      ],
      [
        -1,
        2
      ],
      [
        -1,
        11
      ],
      [
        0,
        12
      ],
      [
        1,
        16
      ],
      [
        -1,
        14
      ],
      [
        0,
        14
      ],
      [
        -1,
        20
      ],
      [
        -1,
        14
      ],
      [
        -3,
        13
      ],
      [
        14,
        13
      ],
      [
        14,
        9
      ],
      [
        11,
        14
      ],
      [
        20,
        21
      ],
      [
        6,
        9
      ],
      [
        1,
        -2
      ],
      [
        16,
        12
      ],
      [
        8,
        8
      ],
      [
        14,
        8
      ],
      [
        18,
        19
      ],
      [
        24,
        14
      ],
      [
        16,
        6
      ],
      [
        2,
        0
      ],
      [
        2,
        -5
      ],
      [
        3,
        1
      ]
    ],
    [
      [
        27141,
        59301
      ],
      [
        26,
        -48
      ],
      [
        14,
        -59
      ],
      [
        6,
        -31
      ],
      [
        4,
        5
      ],
      [
        18,
        -41
      ],
      [
        2,
        -1
      ]
    ],
    [
      [
        27119,
        58976
      ],
      [
        -6,
        67
      ],
      [
        -7,
        29
      ],
      [
        -8,
        -5
      ],
      [
        -7,
        31
      ],
      [
        1,
        26
      ],
      [
        3,
        5
      ],
      [
        0,
        34
      ],
      [
        -6,
        18
      ]
    ],
    [
      [
        23155,
        69500
      ],
      [
        220,
        0
      ]
    ],
    [
      [
        23309,
        69035
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        21
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        -3,
        -7
      ],
      [
        -4,
        6
      ],
      [
        1,
        14
      ],
      [
        7,
        5
      ],
      [
        -6,
        17
      ],
      [
        -7,
        2
      ],
      [
        3,
        9
      ],
      [
        -7,
        14
      ],
      [
        -5,
        18
      ],
      [
        -10,
        14
      ],
      [
        0,
        11
      ],
      [
        -5,
        21
      ],
      [
        -3,
        -4
      ],
      [
        -4,
        17
      ],
      [
        -4,
        9
      ],
      [
        0,
        8
      ],
      [
        -11,
        0
      ],
      [
        -2,
        21
      ],
      [
        -5,
        16
      ]
    ],
    [
      [
        22846,
        60009
      ],
      [
        68,
        0
      ],
      [
        7,
        1
      ],
      [
        3,
        0
      ],
      [
        12,
        -1
      ],
      [
        20,
        0
      ]
    ],
    [
      [
        22956,
        60009
      ],
      [
        0,
        -252
      ],
      [
        -10,
        0
      ],
      [
        0,
        -17
      ],
      [
        -10,
        0
      ],
      [
        0,
        -21
      ],
      [
        -3,
        -7
      ],
      [
        -9,
        11
      ],
      [
        -6,
        -2
      ],
      [
        -5,
        -18
      ],
      [
        -4,
        -22
      ],
      [
        -3,
        -36
      ],
      [
        -5,
        -3
      ],
      [
        -5,
        6
      ],
      [
        -7,
        -1
      ],
      [
        -3,
        7
      ],
      [
        -6,
        0
      ],
      [
        -2,
        9
      ],
      [
        -9,
        -20
      ],
      [
        0,
        -39
      ],
      [
        3,
        -8
      ],
      [
        2,
        -48
      ],
      [
        -3,
        -11
      ]
    ],
    [
      [
        22871,
        59537
      ],
      [
        -23,
        1
      ],
      [
        -90,
        -1
      ]
    ],
    [
      [
        22758,
        59537
      ],
      [
        0,
        472
      ]
    ],
    [
      [
        25279,
        60709
      ],
      [
        0,
        -204
      ]
    ],
    [
      [
        25196,
        60403
      ],
      [
        1,
        305
      ]
    ],
    [
      [
        28849,
        64855
      ],
      [
        0,
        12
      ],
      [
        6,
        7
      ],
      [
        5,
        33
      ],
      [
        5,
        20
      ],
      [
        7,
        -5
      ],
      [
        3,
        15
      ]
    ],
    [
      [
        28875,
        64937
      ],
      [
        39,
        7
      ],
      [
        2,
        1
      ]
    ],
    [
      [
        29018,
        64774
      ],
      [
        0,
        -4
      ],
      [
        1,
        0
      ],
      [
        0,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        2,
        5
      ],
      [
        1,
        2
      ],
      [
        1,
        1
      ],
      [
        0,
        -2
      ]
    ],
    [
      [
        20311,
        57933
      ],
      [
        -44,
        2
      ],
      [
        -16,
        1
      ],
      [
        -38,
        0
      ],
      [
        -2,
        -1
      ],
      [
        -10,
        -16
      ],
      [
        -1,
        -6
      ],
      [
        0,
        11
      ],
      [
        -4,
        12
      ],
      [
        -29,
        0
      ],
      [
        -56,
        1
      ],
      [
        -65,
        1
      ]
    ],
    [
      [
        18514,
        68126
      ],
      [
        -83,
        1
      ],
      [
        -1,
        304
      ]
    ],
    [
      [
        26203,
        69750
      ],
      [
        0,
        -36
      ],
      [
        14,
        -1
      ],
      [
        7,
        -29
      ],
      [
        1,
        -23
      ],
      [
        5,
        -21
      ],
      [
        10,
        -1
      ],
      [
        0,
        23
      ],
      [
        65,
        -2
      ]
    ],
    [
      [
        26305,
        69660
      ],
      [
        -1,
        -102
      ]
    ],
    [
      [
        26122,
        69565
      ],
      [
        0,
        32
      ],
      [
        5,
        41
      ],
      [
        4,
        14
      ],
      [
        6,
        13
      ],
      [
        3,
        11
      ],
      [
        4,
        11
      ],
      [
        4,
        4
      ],
      [
        1,
        -2
      ],
      [
        5,
        1
      ],
      [
        3,
        5
      ],
      [
        2,
        7
      ],
      [
        1,
        6
      ],
      [
        4,
        10
      ],
      [
        8,
        20
      ],
      [
        3,
        5
      ],
      [
        4,
        0
      ],
      [
        11,
        11
      ],
      [
        13,
        -4
      ]
    ],
    [
      [
        26125,
        70269
      ],
      [
        4,
        6
      ],
      [
        3,
        -26
      ],
      [
        -2,
        -22
      ],
      [
        -5,
        -9
      ],
      [
        -5,
        11
      ],
      [
        5,
        40
      ]
    ],
    [
      [
        26084,
        70289
      ],
      [
        8,
        -9
      ],
      [
        13,
        -30
      ],
      [
        0,
        -23
      ],
      [
        -4,
        -13
      ],
      [
        -12,
        15
      ],
      [
        -7,
        23
      ],
      [
        2,
        37
      ]
    ],
    [
      [
        26055,
        70019
      ],
      [
        2,
        31
      ],
      [
        3,
        9
      ],
      [
        2,
        8
      ],
      [
        0,
        10
      ],
      [
        -2,
        12
      ],
      [
        2,
        28
      ],
      [
        1,
        8
      ],
      [
        2,
        11
      ],
      [
        2,
        3
      ],
      [
        4,
        12
      ],
      [
        2,
        23
      ],
      [
        0,
        17
      ],
      [
        -1,
        5
      ],
      [
        0,
        12
      ],
      [
        5,
        -4
      ],
      [
        2,
        -6
      ],
      [
        2,
        -2
      ],
      [
        3,
        1
      ],
      [
        5,
        4
      ],
      [
        1,
        0
      ],
      [
        1,
        -9
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        -8
      ],
      [
        2,
        -1
      ],
      [
        3,
        -10
      ],
      [
        1,
        -24
      ],
      [
        0,
        -8
      ],
      [
        -2,
        -9
      ],
      [
        -1,
        -11
      ],
      [
        1,
        -13
      ],
      [
        1,
        -7
      ],
      [
        2,
        -14
      ],
      [
        1,
        -36
      ],
      [
        -1,
        -13
      ],
      [
        -5,
        -16
      ],
      [
        -2,
        -4
      ],
      [
        -3,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -13
      ],
      [
        -2,
        -4
      ],
      [
        -5,
        -3
      ],
      [
        -16,
        12
      ],
      [
        -1,
        4
      ],
      [
        -2,
        14
      ]
    ],
    [
      [
        26035,
        70180
      ],
      [
        3,
        13
      ],
      [
        10,
        -5
      ],
      [
        1,
        -24
      ],
      [
        -6,
        -30
      ],
      [
        -7,
        1
      ],
      [
        -1,
        45
      ]
    ],
    [
      [
        26572,
        65927
      ],
      [
        3,
        -418
      ]
    ],
    [
      [
        26542,
        65505
      ],
      [
        -5,
        0
      ],
      [
        -28,
        -4
      ],
      [
        -6,
        0
      ],
      [
        -32,
        -4
      ],
      [
        -63,
        -8
      ]
    ],
    [
      [
        24319,
        68384
      ],
      [
        -61,
        0
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        24126,
        68386
      ],
      [
        0,
        202
      ],
      [
        34,
        0
      ],
      [
        0,
        101
      ],
      [
        52,
        -1
      ]
    ],
    [
      [
        23555,
        62524
      ],
      [
        0,
        346
      ]
    ],
    [
      [
        23553,
        62471
      ],
      [
        0,
        7
      ],
      [
        1,
        3
      ],
      [
        1,
        7
      ],
      [
        3,
        9
      ],
      [
        0,
        22
      ],
      [
        -1,
        3
      ],
      [
        -2,
        2
      ]
    ],
    [
      [
        22847,
        58526
      ],
      [
        1,
        236
      ],
      [
        0,
        17
      ]
    ],
    [
      [
        22848,
        58779
      ],
      [
        144,
        -1
      ]
    ],
    [
      [
        22847,
        58222
      ],
      [
        0,
        304
      ]
    ],
    [
      [
        25175,
        57677
      ],
      [
        -10,
        0
      ]
    ],
    [
      [
        25111,
        57676
      ],
      [
        -34,
        0
      ],
      [
        -5,
        -1
      ],
      [
        -12,
        1
      ]
    ],
    [
      [
        25060,
        57676
      ],
      [
        1,
        20
      ],
      [
        3,
        449
      ]
    ],
    [
      [
        23603,
        73631
      ],
      [
        1,
        5
      ],
      [
        1,
        4
      ],
      [
        1,
        2
      ],
      [
        1,
        1
      ],
      [
        2,
        -1
      ],
      [
        5,
        2
      ],
      [
        2,
        0
      ],
      [
        1,
        -2
      ],
      [
        3,
        -5
      ],
      [
        4,
        -2
      ],
      [
        3,
        -1
      ],
      [
        4,
        1
      ],
      [
        6,
        7
      ],
      [
        5,
        -3
      ],
      [
        2,
        -3
      ],
      [
        2,
        -6
      ],
      [
        3,
        -1
      ],
      [
        1,
        -3
      ],
      [
        1,
        -6
      ],
      [
        1,
        -6
      ],
      [
        1,
        -3
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -17
      ],
      [
        0,
        -3
      ],
      [
        1,
        -5
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        4,
        -2
      ],
      [
        2,
        -3
      ],
      [
        3,
        0
      ],
      [
        4,
        2
      ],
      [
        3,
        -1
      ],
      [
        6,
        -2
      ],
      [
        3,
        -3
      ],
      [
        5,
        0
      ],
      [
        3,
        -2
      ],
      [
        5,
        0
      ],
      [
        3,
        2
      ],
      [
        2,
        -3
      ],
      [
        4,
        1
      ],
      [
        2,
        2
      ],
      [
        1,
        0
      ],
      [
        1,
        -3
      ],
      [
        1,
        0
      ],
      [
        2,
        1
      ],
      [
        3,
        -1
      ],
      [
        2,
        -3
      ],
      [
        1,
        0
      ],
      [
        7,
        3
      ],
      [
        1,
        -1
      ],
      [
        3,
        -3
      ],
      [
        4,
        -3
      ],
      [
        4,
        0
      ],
      [
        1,
        -1
      ],
      [
        1,
        -3
      ],
      [
        3,
        -2
      ],
      [
        5,
        -1
      ],
      [
        3,
        1
      ],
      [
        0,
        3
      ],
      [
        1,
        0
      ],
      [
        7,
        -5
      ],
      [
        10,
        0
      ],
      [
        2,
        -1
      ],
      [
        1,
        -1
      ],
      [
        2,
        -4
      ],
      [
        2,
        -14
      ],
      [
        1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        1,
        -6
      ],
      [
        0,
        -10
      ],
      [
        2,
        -12
      ],
      [
        1,
        -5
      ],
      [
        0,
        -3
      ],
      [
        1,
        -9
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -12
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -7
      ],
      [
        1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        3,
        -5
      ],
      [
        1,
        -2
      ],
      [
        1,
        -3
      ],
      [
        3,
        -1
      ],
      [
        3,
        1
      ],
      [
        3,
        0
      ],
      [
        1,
        -1
      ],
      [
        1,
        0
      ],
      [
        4,
        2
      ],
      [
        2,
        1
      ],
      [
        3,
        -1
      ],
      [
        4,
        1
      ],
      [
        1,
        -1
      ],
      [
        3,
        -3
      ],
      [
        1,
        0
      ],
      [
        4,
        2
      ],
      [
        5,
        -1
      ],
      [
        3,
        2
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        3
      ],
      [
        1,
        6
      ],
      [
        1,
        3
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        -5
      ],
      [
        1,
        -3
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        2,
        5
      ],
      [
        1,
        2
      ],
      [
        1,
        0
      ],
      [
        2,
        -3
      ],
      [
        1,
        0
      ],
      [
        5,
        3
      ],
      [
        4,
        0
      ],
      [
        2,
        1
      ],
      [
        2,
        3
      ],
      [
        4,
        2
      ],
      [
        1,
        1
      ],
      [
        4,
        7
      ],
      [
        5,
        2
      ],
      [
        4,
        3
      ],
      [
        1,
        1
      ],
      [
        1,
        5
      ],
      [
        1,
        6
      ],
      [
        0,
        13
      ],
      [
        -1,
        8
      ],
      [
        -2,
        16
      ],
      [
        1,
        4
      ],
      [
        0,
        1
      ],
      [
        7,
        2
      ],
      [
        1,
        2
      ],
      [
        2,
        5
      ],
      [
        1,
        2
      ],
      [
        3,
        5
      ],
      [
        1,
        3
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        0,
        -2
      ],
      [
        1,
        -4
      ],
      [
        1,
        -1
      ],
      [
        3,
        3
      ],
      [
        4,
        -1
      ],
      [
        1,
        3
      ],
      [
        0,
        1
      ],
      [
        1,
        7
      ],
      [
        2,
        -3
      ],
      [
        1,
        1
      ],
      [
        0,
        4
      ],
      [
        1,
        11
      ],
      [
        0,
        2
      ],
      [
        26,
        18
      ],
      [
        13,
        0
      ],
      [
        7,
        -16
      ],
      [
        1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        10,
        2
      ],
      [
        15,
        3
      ]
    ],
    [
      [
        23979,
        72689
      ],
      [
        -194,
        9
      ],
      [
        0,
        -62
      ],
      [
        -179,
        0
      ]
    ],
    [
      [
        23603,
        73243
      ],
      [
        0,
        388
      ]
    ],
    [
      [
        23147,
        71828
      ],
      [
        -36,
        -1
      ]
    ],
    [
      [
        23111,
        71827
      ],
      [
        -177,
        -1
      ]
    ],
    [
      [
        25494,
        62522
      ],
      [
        -4,
        0
      ],
      [
        0,
        17
      ],
      [
        -25,
        0
      ],
      [
        0,
        8
      ],
      [
        -57,
        -5
      ]
    ],
    [
      [
        25391,
        62780
      ],
      [
        -1,
        118
      ],
      [
        15,
        1
      ]
    ],
    [
      [
        23290,
        71827
      ],
      [
        107,
        2
      ]
    ],
    [
      [
        23117,
        71323
      ],
      [
        -1,
        101
      ],
      [
        1,
        201
      ],
      [
        -6,
        0
      ],
      [
        0,
        202
      ]
    ],
    [
      [
        23127,
        65675
      ],
      [
        130,
        -4
      ]
    ],
    [
      [
        23131,
        65462
      ],
      [
        1,
        6
      ],
      [
        0,
        3
      ],
      [
        1,
        4
      ],
      [
        1,
        4
      ],
      [
        2,
        2
      ],
      [
        4,
        -2
      ],
      [
        2,
        0
      ],
      [
        2,
        4
      ],
      [
        1,
        4
      ],
      [
        0,
        7
      ],
      [
        -1,
        3
      ],
      [
        -1,
        5
      ],
      [
        -2,
        5
      ],
      [
        -4,
        7
      ],
      [
        -1,
        4
      ],
      [
        0,
        15
      ],
      [
        1,
        2
      ],
      [
        1,
        4
      ],
      [
        2,
        1
      ],
      [
        2,
        4
      ],
      [
        1,
        5
      ],
      [
        1,
        4
      ],
      [
        -1,
        12
      ],
      [
        1,
        7
      ],
      [
        1,
        6
      ],
      [
        2,
        7
      ],
      [
        0,
        14
      ],
      [
        -1,
        3
      ],
      [
        -2,
        5
      ],
      [
        -1,
        3
      ],
      [
        -4,
        3
      ],
      [
        -1,
        1
      ],
      [
        -2,
        4
      ],
      [
        -1,
        4
      ],
      [
        0,
        9
      ],
      [
        -1,
        3
      ],
      [
        1,
        11
      ],
      [
        0,
        10
      ],
      [
        -1,
        5
      ],
      [
        -1,
        2
      ],
      [
        -2,
        4
      ],
      [
        -2,
        3
      ],
      [
        -1,
        2
      ],
      [
        -1,
        4
      ]
    ],
    [
      [
        24678,
        57129
      ],
      [
        48,
        -117
      ]
    ],
    [
      [
        24711,
        56603
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        24711,
        56502
      ],
      [
        -57,
        2
      ]
    ],
    [
      [
        21038,
        58136
      ],
      [
        69,
        0
      ],
      [
        2,
        8
      ],
      [
        0,
        298
      ],
      [
        2,
        101
      ]
    ],
    [
      [
        21204,
        58543
      ],
      [
        0,
        -136
      ]
    ],
    [
      [
        21204,
        58407
      ],
      [
        -1,
        -434
      ],
      [
        0,
        -77
      ]
    ],
    [
      [
        21203,
        57629
      ],
      [
        -67,
        0
      ],
      [
        0,
        -104
      ],
      [
        -29,
        1
      ],
      [
        -1,
        -102
      ],
      [
        -14,
        0
      ],
      [
        -15,
        1
      ],
      [
        0,
        -102
      ],
      [
        -39,
        1
      ],
      [
        -20,
        0
      ],
      [
        0,
        -101
      ],
      [
        -9,
        -1
      ]
    ],
    [
      [
        21009,
        57222
      ],
      [
        -58,
        1
      ]
    ],
    [
      [
        20901,
        57425
      ],
      [
        0,
        204
      ],
      [
        1,
        17
      ],
      [
        0,
        202
      ]
    ],
    [
      [
        29166,
        64200
      ],
      [
        2,
        -4
      ],
      [
        5,
        2
      ],
      [
        22,
        8
      ],
      [
        5,
        2
      ],
      [
        10,
        3
      ],
      [
        0,
        -9
      ],
      [
        4,
        -10
      ],
      [
        21,
        14
      ],
      [
        3,
        -13
      ]
    ],
    [
      [
        29238,
        64193
      ],
      [
        -1,
        -12
      ],
      [
        -1,
        -15
      ],
      [
        -2,
        -13
      ],
      [
        -3,
        -1
      ],
      [
        -3,
        -5
      ],
      [
        -3,
        -10
      ],
      [
        0,
        -14
      ],
      [
        1,
        -10
      ],
      [
        -1,
        -8
      ],
      [
        -2,
        -13
      ],
      [
        -1,
        -5
      ]
    ],
    [
      [
        29222,
        64087
      ],
      [
        -3,
        -15
      ],
      [
        1,
        -14
      ],
      [
        2,
        -14
      ],
      [
        1,
        -2
      ],
      [
        6,
        -6
      ],
      [
        3,
        -6
      ]
    ],
    [
      [
        29232,
        64030
      ],
      [
        1,
        -2
      ],
      [
        -7,
        -25
      ],
      [
        0,
        -21
      ],
      [
        -1,
        -2
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        -11,
        -36
      ],
      [
        -10,
        -33
      ],
      [
        -8,
        -23
      ],
      [
        -11,
        -43
      ],
      [
        0,
        -10
      ],
      [
        -19,
        -33
      ],
      [
        -6,
        3
      ]
    ],
    [
      [
        29160,
        63798
      ],
      [
        0,
        23
      ],
      [
        -16,
        17
      ],
      [
        -9,
        15
      ],
      [
        -8,
        24
      ],
      [
        -6,
        4
      ],
      [
        -2,
        21
      ],
      [
        1,
        3
      ],
      [
        1,
        23
      ],
      [
        1,
        10
      ]
    ],
    [
      [
        27804,
        62289
      ],
      [
        48,
        -133
      ],
      [
        12,
        -35
      ]
    ],
    [
      [
        27864,
        62121
      ],
      [
        22,
        -60
      ]
    ],
    [
      [
        27886,
        62061
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        -8
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -5
      ],
      [
        1,
        -5
      ],
      [
        -2,
        -16
      ],
      [
        0,
        -11
      ],
      [
        1,
        -3
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -15
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -12
      ],
      [
        -4,
        -4
      ],
      [
        -1,
        4
      ],
      [
        -3,
        1
      ],
      [
        -2,
        -6
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -10
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -11
      ],
      [
        0,
        -2
      ],
      [
        1,
        -3
      ],
      [
        -2,
        -7
      ],
      [
        0,
        -7
      ],
      [
        1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -11
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -9
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -10
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -20
      ],
      [
        1,
        -4
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -3
      ]
    ],
    [
      [
        27839,
        61731
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -12
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        3
      ],
      [
        -2,
        -9
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -3
      ],
      [
        1,
        -3
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        2
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        -3
      ]
    ],
    [
      [
        24431,
        55807
      ],
      [
        -1,
        -446
      ]
    ],
    [
      [
        24430,
        55361
      ],
      [
        -8,
        0
      ],
      [
        -3,
        1
      ],
      [
        -35,
        0
      ],
      [
        -31,
        1
      ],
      [
        -5,
        -1
      ],
      [
        -33,
        1
      ],
      [
        -22,
        0
      ],
      [
        -32,
        1
      ]
    ],
    [
      [
        24261,
        55364
      ],
      [
        -5,
        27
      ],
      [
        -6,
        0
      ],
      [
        -2,
        45
      ],
      [
        -4,
        0
      ],
      [
        -1,
        31
      ],
      [
        1,
        26
      ],
      [
        4,
        15
      ],
      [
        1,
        29
      ],
      [
        -8,
        7
      ]
    ],
    [
      [
        24711,
        56502
      ],
      [
        0,
        -203
      ]
    ],
    [
      [
        24711,
        56299
      ],
      [
        0,
        -561
      ]
    ],
    [
      [
        24637,
        55669
      ],
      [
        -13,
        0
      ],
      [
        0,
        204
      ],
      [
        1,
        94
      ],
      [
        -1,
        3
      ]
    ],
    [
      [
        24723,
        57488
      ],
      [
        2,
        3
      ],
      [
        6,
        12
      ],
      [
        8,
        8
      ],
      [
        1,
        3
      ],
      [
        2,
        6
      ],
      [
        2,
        -9
      ],
      [
        3,
        -7
      ],
      [
        1,
        -2
      ],
      [
        2,
        -1
      ],
      [
        1,
        2
      ],
      [
        1,
        5
      ],
      [
        1,
        5
      ],
      [
        0,
        2
      ],
      [
        -1,
        4
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        24781,
        57362
      ],
      [
        -6,
        -11
      ],
      [
        -2,
        -20
      ],
      [
        3,
        -10
      ],
      [
        -2,
        -19
      ],
      [
        3,
        -31
      ],
      [
        -7,
        -24
      ],
      [
        -1,
        -31
      ],
      [
        3,
        2
      ],
      [
        4,
        -48
      ],
      [
        6,
        -6
      ]
    ],
    [
      [
        24782,
        57164
      ],
      [
        0,
        -51
      ]
    ],
    [
      [
        24674,
        57265
      ],
      [
        1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        4
      ],
      [
        0,
        6
      ],
      [
        -1,
        16
      ],
      [
        0,
        6
      ],
      [
        2,
        11
      ],
      [
        1,
        4
      ],
      [
        1,
        3
      ],
      [
        6,
        3
      ],
      [
        4,
        -21
      ],
      [
        -3,
        -8
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -10
      ],
      [
        1,
        -7
      ],
      [
        0,
        -5
      ],
      [
        1,
        -5
      ],
      [
        2,
        -3
      ],
      [
        1,
        -2
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ],
      [
        2,
        3
      ],
      [
        2,
        6
      ],
      [
        2,
        5
      ],
      [
        2,
        9
      ],
      [
        2,
        8
      ],
      [
        2,
        5
      ],
      [
        3,
        12
      ],
      [
        1,
        5
      ],
      [
        1,
        12
      ],
      [
        0,
        8
      ],
      [
        -1,
        5
      ],
      [
        -1,
        4
      ],
      [
        -1,
        2
      ],
      [
        -2,
        1
      ],
      [
        -2,
        0
      ],
      [
        -2,
        -1
      ],
      [
        -4,
        -3
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        0
      ],
      [
        -3,
        3
      ],
      [
        -2,
        4
      ],
      [
        -6,
        22
      ],
      [
        0,
        18
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        0,
        18
      ],
      [
        -1,
        11
      ],
      [
        -1,
        6
      ],
      [
        0,
        7
      ],
      [
        1,
        7
      ],
      [
        2,
        6
      ],
      [
        1,
        3
      ],
      [
        1,
        2
      ],
      [
        2,
        2
      ],
      [
        3,
        0
      ],
      [
        0,
        -7
      ],
      [
        3,
        -19
      ],
      [
        0,
        -12
      ],
      [
        -1,
        -6
      ],
      [
        -3,
        -7
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -17
      ],
      [
        1,
        -7
      ],
      [
        1,
        -3
      ],
      [
        3,
        -7
      ],
      [
        4,
        0
      ],
      [
        2,
        1
      ],
      [
        3,
        3
      ],
      [
        3,
        6
      ],
      [
        1,
        3
      ],
      [
        1,
        6
      ],
      [
        0,
        15
      ],
      [
        -2,
        13
      ],
      [
        -3,
        19
      ],
      [
        -1,
        10
      ],
      [
        0,
        15
      ],
      [
        1,
        3
      ],
      [
        1,
        7
      ],
      [
        2,
        4
      ],
      [
        1,
        7
      ],
      [
        0,
        4
      ],
      [
        -2,
        13
      ],
      [
        -3,
        17
      ],
      [
        -2,
        10
      ],
      [
        -1,
        4
      ],
      [
        0,
        18
      ],
      [
        1,
        7
      ],
      [
        1,
        4
      ],
      [
        3,
        5
      ],
      [
        2,
        2
      ],
      [
        2,
        -1
      ],
      [
        2,
        -4
      ],
      [
        1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        2,
        -14
      ],
      [
        0,
        -25
      ],
      [
        1,
        -9
      ],
      [
        1,
        -8
      ],
      [
        0,
        -1
      ],
      [
        2,
        -2
      ],
      [
        2,
        0
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        24081,
        64189
      ],
      [
        6,
        -26
      ],
      [
        -7,
        -10
      ],
      [
        9,
        2
      ],
      [
        -3,
        -14
      ],
      [
        -1,
        -24
      ],
      [
        8,
        -10
      ],
      [
        -4,
        -5
      ],
      [
        2,
        -18
      ],
      [
        -5,
        -15
      ],
      [
        -4,
        -30
      ],
      [
        0,
        -17
      ],
      [
        5,
        -27
      ],
      [
        7,
        -17
      ],
      [
        0,
        -12
      ],
      [
        -5,
        -4
      ],
      [
        0,
        -60
      ]
    ],
    [
      [
        23899,
        63948
      ],
      [
        0,
        104
      ],
      [
        -2,
        0
      ],
      [
        0,
        126
      ]
    ],
    [
      [
        27261,
        62555
      ],
      [
        -1,
        19
      ],
      [
        12,
        76
      ],
      [
        6,
        1
      ]
    ],
    [
      [
        27278,
        62651
      ],
      [
        5,
        46
      ],
      [
        9,
        -3
      ],
      [
        6,
        7
      ],
      [
        13,
        3
      ],
      [
        11,
        20
      ],
      [
        7,
        -8
      ],
      [
        3,
        5
      ],
      [
        3,
        26
      ],
      [
        7,
        0
      ]
    ],
    [
      [
        27342,
        62747
      ],
      [
        4,
        -11
      ],
      [
        2,
        7
      ],
      [
        7,
        -9
      ],
      [
        4,
        12
      ],
      [
        1,
        28
      ],
      [
        3,
        18
      ],
      [
        6,
        -17
      ],
      [
        2,
        4
      ],
      [
        6,
        -21
      ],
      [
        0,
        -34
      ],
      [
        -3,
        -7
      ],
      [
        3,
        -20
      ],
      [
        -2,
        -16
      ]
    ],
    [
      [
        27334,
        62967
      ],
      [
        2,
        6
      ],
      [
        1,
        4
      ],
      [
        1,
        4
      ],
      [
        1,
        4
      ],
      [
        3,
        9
      ],
      [
        3,
        7
      ],
      [
        1,
        3
      ],
      [
        2,
        7
      ],
      [
        2,
        7
      ],
      [
        3,
        8
      ],
      [
        7,
        19
      ]
    ],
    [
      [
        27342,
        62747
      ],
      [
        -2,
        61
      ],
      [
        -2,
        45
      ],
      [
        -1,
        23
      ],
      [
        -1,
        7
      ],
      [
        -3,
        1
      ],
      [
        -6,
        9
      ],
      [
        2,
        -10
      ],
      [
        0,
        -5
      ],
      [
        -7,
        5
      ],
      [
        -4,
        -12
      ],
      [
        -3,
        7
      ],
      [
        -4,
        -7
      ]
    ],
    [
      [
        27311,
        62871
      ],
      [
        1,
        10
      ],
      [
        1,
        0
      ],
      [
        3,
        25
      ],
      [
        3,
        11
      ],
      [
        4,
        15
      ],
      [
        2,
        7
      ],
      [
        3,
        8
      ],
      [
        2,
        8
      ],
      [
        1,
        3
      ],
      [
        1,
        5
      ],
      [
        2,
        4
      ]
    ],
    [
      [
        27573,
        60142
      ],
      [
        2,
        -5
      ],
      [
        12,
        17
      ]
    ],
    [
      [
        27587,
        60154
      ],
      [
        5,
        -29
      ],
      [
        1,
        -24
      ],
      [
        -4,
        -26
      ],
      [
        3,
        -11
      ],
      [
        -2,
        -24
      ],
      [
        1,
        -19
      ],
      [
        -6,
        -6
      ],
      [
        4,
        -15
      ],
      [
        -6,
        -13
      ],
      [
        3,
        -18
      ],
      [
        -3,
        -17
      ],
      [
        -8,
        3
      ],
      [
        -5,
        -36
      ],
      [
        -2,
        -23
      ],
      [
        -11,
        -34
      ]
    ],
    [
      [
        27557,
        59862
      ],
      [
        -5,
        -9
      ],
      [
        -10,
        -8
      ],
      [
        -1,
        -12
      ],
      [
        -6,
        -4
      ],
      [
        -3,
        -16
      ],
      [
        -4,
        3
      ],
      [
        -1,
        -23
      ],
      [
        -5,
        -12
      ],
      [
        -7,
        -6
      ],
      [
        0,
        -32
      ],
      [
        -3,
        -7
      ],
      [
        1,
        -23
      ],
      [
        -5,
        -3
      ],
      [
        -9,
        7
      ],
      [
        -4,
        -11
      ],
      [
        -1,
        -35
      ]
    ],
    [
      [
        27494,
        59671
      ],
      [
        -29,
        157
      ],
      [
        -19,
        103
      ]
    ],
    [
      [
        20593,
        72571
      ],
      [
        -36,
        0
      ],
      [
        0,
        -303
      ],
      [
        -12,
        -1
      ],
      [
        0,
        -405
      ]
    ],
    [
      [
        20545,
        71862
      ],
      [
        -119,
        0
      ],
      [
        0,
        -103
      ],
      [
        -36,
        0
      ],
      [
        1,
        103
      ],
      [
        -36,
        0
      ]
    ],
    [
      [
        20263,
        72766
      ],
      [
        1,
        17
      ],
      [
        -4,
        53
      ],
      [
        3,
        29
      ],
      [
        5,
        22
      ],
      [
        7,
        1
      ],
      [
        3,
        -18
      ],
      [
        7,
        -1
      ],
      [
        5,
        11
      ],
      [
        5,
        -17
      ],
      [
        8,
        6
      ],
      [
        8,
        -19
      ],
      [
        4,
        -4
      ],
      [
        29,
        5
      ],
      [
        0,
        -14
      ],
      [
        -5,
        -14
      ],
      [
        6,
        -3
      ],
      [
        8,
        7
      ],
      [
        2,
        29
      ],
      [
        6,
        -3
      ],
      [
        6,
        -28
      ],
      [
        8,
        -2
      ],
      [
        1,
        11
      ],
      [
        -4,
        12
      ],
      [
        6,
        8
      ],
      [
        8,
        -20
      ],
      [
        11,
        -3
      ],
      [
        5,
        -11
      ],
      [
        6,
        12
      ],
      [
        -1,
        23
      ],
      [
        4,
        0
      ],
      [
        3,
        -15
      ],
      [
        9,
        -13
      ]
    ],
    [
      [
        23305,
        62405
      ],
      [
        -1,
        -35
      ],
      [
        0,
        -183
      ]
    ],
    [
      [
        23180,
        62187
      ],
      [
        0,
        266
      ],
      [
        -7,
        15
      ],
      [
        -10,
        5
      ],
      [
        4,
        21
      ],
      [
        -6,
        -15
      ],
      [
        -7,
        7
      ]
    ],
    [
      [
        22918,
        68387
      ],
      [
        34,
        0
      ],
      [
        87,
        1
      ]
    ],
    [
      [
        24679,
        52619
      ],
      [
        -19,
        -1
      ],
      [
        -77,
        0
      ]
    ],
    [
      [
        24684,
        71167
      ],
      [
        3,
        -4
      ],
      [
        4,
        7
      ],
      [
        5,
        3
      ],
      [
        9,
        -18
      ],
      [
        10,
        -14
      ],
      [
        6,
        5
      ]
    ],
    [
      [
        24857,
        70836
      ],
      [
        0,
        -370
      ],
      [
        -32,
        0
      ]
    ],
    [
      [
        24753,
        70465
      ],
      [
        0,
        101
      ],
      [
        -1,
        34
      ],
      [
        1,
        67
      ],
      [
        -35,
        -1
      ],
      [
        0,
        101
      ],
      [
        -35,
        0
      ],
      [
        1,
        400
      ]
    ],
    [
      [
        21045,
        53785
      ],
      [
        79,
        -1
      ]
    ],
    [
      [
        21271,
        53785
      ],
      [
        9,
        0
      ]
    ],
    [
      [
        21280,
        53368
      ],
      [
        -10,
        -15
      ],
      [
        -7,
        -16
      ],
      [
        -3,
        22
      ],
      [
        -5,
        6
      ],
      [
        -6,
        18
      ],
      [
        1,
        11
      ],
      [
        -6,
        7
      ],
      [
        -5,
        20
      ],
      [
        -4,
        1
      ],
      [
        -1,
        12
      ],
      [
        -9,
        1
      ],
      [
        -10,
        9
      ],
      [
        -3,
        14
      ]
    ],
    [
      [
        21212,
        53458
      ],
      [
        -4,
        10
      ],
      [
        -9,
        7
      ],
      [
        -3,
        -24
      ],
      [
        -11,
        -5
      ],
      [
        -10,
        5
      ],
      [
        -4,
        8
      ],
      [
        -6,
        -2
      ],
      [
        -18,
        22
      ],
      [
        -4,
        27
      ],
      [
        -1,
        18
      ],
      [
        -5,
        -14
      ],
      [
        -3,
        7
      ],
      [
        -11,
        -11
      ],
      [
        -4,
        12
      ],
      [
        -7,
        -10
      ],
      [
        -7,
        20
      ],
      [
        -6,
        -6
      ],
      [
        -7,
        7
      ],
      [
        -5,
        -4
      ],
      [
        -8,
        36
      ],
      [
        2,
        21
      ],
      [
        -6,
        32
      ],
      [
        2,
        53
      ],
      [
        -4,
        19
      ],
      [
        -1,
        18
      ],
      [
        3,
        17
      ],
      [
        -2,
        34
      ],
      [
        -6,
        19
      ],
      [
        -5,
        2
      ],
      [
        -4,
        -13
      ],
      [
        -3,
        0
      ],
      [
        -10,
        22
      ]
    ],
    [
      [
        22343,
        56766
      ],
      [
        0,
        -1
      ],
      [
        3,
        -10
      ],
      [
        4,
        -12
      ],
      [
        0,
        -2
      ],
      [
        1,
        -6
      ],
      [
        1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        3,
        -5
      ],
      [
        10,
        -13
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -2
      ],
      [
        1,
        -2
      ],
      [
        1,
        -5
      ],
      [
        2,
        0
      ],
      [
        1,
        1
      ],
      [
        0,
        13
      ],
      [
        1,
        0
      ],
      [
        7,
        1
      ],
      [
        5,
        -4
      ],
      [
        1,
        -3
      ],
      [
        5,
        -14
      ],
      [
        7,
        -9
      ],
      [
        1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        1,
        -4
      ],
      [
        0,
        -5
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ],
      [
        1,
        3
      ],
      [
        1,
        4
      ],
      [
        0,
        5
      ],
      [
        1,
        0
      ],
      [
        4,
        1
      ],
      [
        1,
        -1
      ],
      [
        5,
        -2
      ],
      [
        2,
        -1
      ],
      [
        9,
        29
      ],
      [
        2,
        6
      ],
      [
        1,
        2
      ],
      [
        1,
        0
      ],
      [
        2,
        -4
      ],
      [
        4,
        -5
      ],
      [
        1,
        -1
      ],
      [
        2,
        0
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        22490,
        56327
      ],
      [
        -147,
        -2
      ]
    ],
    [
      [
        22806,
        47905
      ],
      [
        10,
        -114
      ],
      [
        8,
        -106
      ]
    ],
    [
      [
        22824,
        47685
      ],
      [
        -5,
        0
      ]
    ],
    [
      [
        22819,
        47685
      ],
      [
        -3,
        31
      ],
      [
        -8,
        121
      ],
      [
        -24,
        16
      ],
      [
        18,
        27
      ],
      [
        -3,
        24
      ]
    ],
    [
      [
        22764,
        47904
      ],
      [
        3,
        -32
      ],
      [
        4,
        -22
      ],
      [
        -1,
        -31
      ],
      [
        3,
        -32
      ],
      [
        -1,
        -21
      ],
      [
        9,
        -1
      ],
      [
        8,
        -80
      ]
    ],
    [
      [
        22789,
        47685
      ],
      [
        -11,
        0
      ],
      [
        -3,
        -29
      ],
      [
        -6,
        -24
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -32
      ],
      [
        -3,
        -14
      ],
      [
        -5,
        10
      ],
      [
        -1,
        11
      ],
      [
        -3,
        -8
      ],
      [
        -8,
        -3
      ],
      [
        2,
        -17
      ],
      [
        -6,
        5
      ],
      [
        -1,
        -28
      ],
      [
        -14,
        8
      ],
      [
        -79,
        49
      ]
    ],
    [
      [
        22647,
        47611
      ],
      [
        0,
        99
      ],
      [
        -13,
        2
      ],
      [
        -23,
        14
      ],
      [
        -4,
        2
      ],
      [
        6,
        102
      ],
      [
        5,
        -3
      ],
      [
        -1,
        21
      ],
      [
        3,
        70
      ]
    ],
    [
      [
        24304,
        54779
      ],
      [
        3,
        5
      ],
      [
        1,
        30
      ],
      [
        3,
        9
      ],
      [
        6,
        -25
      ],
      [
        8,
        -4
      ],
      [
        0,
        29
      ],
      [
        5,
        12
      ],
      [
        1,
        15
      ],
      [
        3,
        5
      ],
      [
        10,
        -20
      ],
      [
        3,
        6
      ],
      [
        3,
        -2
      ],
      [
        4,
        16
      ],
      [
        0,
        19
      ],
      [
        8,
        30
      ],
      [
        9,
        -2
      ],
      [
        7,
        33
      ],
      [
        3,
        32
      ]
    ],
    [
      [
        24381,
        54967
      ],
      [
        11,
        0
      ],
      [
        0,
        -99
      ],
      [
        42,
        0
      ]
    ],
    [
      [
        24431,
        54816
      ],
      [
        -8,
        -50
      ],
      [
        0,
        -27
      ],
      [
        4,
        -44
      ],
      [
        -4,
        1
      ],
      [
        0,
        -25
      ],
      [
        3,
        -8
      ]
    ],
    [
      [
        24426,
        54663
      ],
      [
        -44,
        -1
      ],
      [
        -7,
        -22
      ],
      [
        -6,
        -3
      ],
      [
        0,
        -13
      ],
      [
        -5,
        -4
      ],
      [
        -1,
        -28
      ],
      [
        -6,
        -14
      ],
      [
        -11,
        2
      ],
      [
        0,
        -42
      ],
      [
        -3,
        -25
      ],
      [
        1,
        -23
      ],
      [
        -2,
        -17
      ],
      [
        -6,
        -21
      ],
      [
        -6,
        -13
      ],
      [
        -3,
        -38
      ],
      [
        -2,
        -6
      ],
      [
        -10,
        -5
      ],
      [
        -6,
        -23
      ]
    ],
    [
      [
        24270,
        54513
      ],
      [
        4,
        23
      ],
      [
        1,
        14
      ],
      [
        3,
        52
      ],
      [
        -1,
        11
      ],
      [
        5,
        40
      ],
      [
        2,
        19
      ],
      [
        11,
        41
      ],
      [
        3,
        49
      ],
      [
        4,
        7
      ],
      [
        2,
        10
      ]
    ],
    [
      [
        24359,
        64199
      ],
      [
        1,
        -4
      ],
      [
        4,
        -8
      ],
      [
        2,
        -5
      ],
      [
        1,
        -3
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -14
      ],
      [
        0,
        -6
      ],
      [
        1,
        -3
      ],
      [
        1,
        -5
      ],
      [
        3,
        -2
      ],
      [
        5,
        -2
      ],
      [
        5,
        -4
      ],
      [
        3,
        -3
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -17
      ],
      [
        -1,
        -11
      ],
      [
        0,
        -8
      ],
      [
        1,
        -3
      ],
      [
        1,
        -3
      ],
      [
        1,
        -3
      ],
      [
        1,
        -2
      ],
      [
        4,
        -6
      ],
      [
        1,
        -3
      ],
      [
        1,
        -6
      ],
      [
        1,
        -10
      ],
      [
        0,
        -7
      ],
      [
        1,
        -2
      ],
      [
        1,
        -6
      ],
      [
        2,
        -4
      ],
      [
        1,
        -2
      ],
      [
        3,
        -2
      ],
      [
        3,
        -1
      ],
      [
        4,
        1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        1,
        -5
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -7
      ],
      [
        1,
        -3
      ],
      [
        1,
        -1
      ],
      [
        2,
        0
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -10
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        0
      ],
      [
        2,
        -2
      ],
      [
        0,
        -3
      ],
      [
        1,
        -1
      ],
      [
        2,
        -2
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        -5
      ],
      [
        1,
        -18
      ],
      [
        6,
        1
      ],
      [
        6,
        1
      ],
      [
        5,
        -4
      ],
      [
        1,
        -2
      ],
      [
        1,
        -3
      ]
    ],
    [
      [
        24442,
        63943
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        -5
      ],
      [
        -2,
        -4
      ],
      [
        0,
        -4
      ],
      [
        -2,
        -7
      ],
      [
        -2,
        -13
      ],
      [
        -2,
        -9
      ],
      [
        0,
        -14
      ],
      [
        -1,
        -6
      ],
      [
        -4,
        -28
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -10
      ],
      [
        0,
        -9
      ],
      [
        1,
        -6
      ],
      [
        0,
        -6
      ],
      [
        -2,
        -13
      ]
    ],
    [
      [
        24420,
        63792
      ],
      [
        -126,
        10
      ]
    ],
    [
      [
        24294,
        63802
      ],
      [
        0,
        51
      ]
    ],
    [
      [
        27513,
        63080
      ],
      [
        8,
        -4
      ],
      [
        5,
        -25
      ],
      [
        10,
        0
      ],
      [
        39,
        -2
      ],
      [
        5,
        0
      ],
      [
        7,
        -32
      ],
      [
        5,
        -7
      ],
      [
        20,
        -70
      ],
      [
        2,
        -13
      ],
      [
        1,
        1
      ],
      [
        0,
        -2
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        1,
        0
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        1,
        -16
      ],
      [
        5,
        -3
      ],
      [
        7,
        -25
      ],
      [
        8,
        -13
      ]
    ],
    [
      [
        27640,
        62865
      ],
      [
        -20,
        -41
      ],
      [
        -4,
        -18
      ],
      [
        -17,
        -18
      ],
      [
        -8,
        27
      ],
      [
        -2,
        -9
      ],
      [
        -19,
        -10
      ],
      [
        -2,
        0
      ]
    ],
    [
      [
        27568,
        62796
      ],
      [
        -24,
        49
      ],
      [
        -8,
        3
      ],
      [
        -51,
        37
      ]
    ],
    [
      [
        27134,
        62549
      ],
      [
        1,
        5
      ],
      [
        1,
        2
      ],
      [
        2,
        3
      ],
      [
        1,
        5
      ],
      [
        0,
        3
      ],
      [
        1,
        11
      ],
      [
        1,
        7
      ],
      [
        1,
        4
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        27142,
        62590
      ],
      [
        2,
        2
      ],
      [
        2,
        2
      ],
      [
        3,
        2
      ],
      [
        2,
        3
      ],
      [
        1,
        3
      ],
      [
        0,
        11
      ],
      [
        -1,
        8
      ],
      [
        -1,
        4
      ],
      [
        0,
        13
      ],
      [
        2,
        7
      ],
      [
        0,
        3
      ],
      [
        2,
        6
      ],
      [
        1,
        3
      ],
      [
        3,
        3
      ],
      [
        4,
        1
      ],
      [
        3,
        0
      ],
      [
        6,
        -4
      ],
      [
        2,
        2
      ],
      [
        2,
        1
      ],
      [
        1,
        -1
      ],
      [
        3,
        -2
      ],
      [
        1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        5,
        -1
      ],
      [
        0,
        4
      ],
      [
        1,
        6
      ],
      [
        0,
        21
      ],
      [
        1,
        28
      ],
      [
        1,
        15
      ],
      [
        0,
        9
      ],
      [
        4,
        16
      ],
      [
        3,
        7
      ],
      [
        2,
        4
      ],
      [
        3,
        6
      ],
      [
        3,
        7
      ],
      [
        4,
        13
      ],
      [
        2,
        6
      ],
      [
        3,
        12
      ],
      [
        1,
        5
      ],
      [
        3,
        6
      ],
      [
        3,
        1
      ],
      [
        3,
        -2
      ],
      [
        2,
        -4
      ],
      [
        2,
        -5
      ],
      [
        1,
        -3
      ],
      [
        1,
        -4
      ],
      [
        2,
        -8
      ],
      [
        1,
        -13
      ],
      [
        1,
        -9
      ],
      [
        1,
        -16
      ],
      [
        1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        2,
        -7
      ],
      [
        2,
        -1
      ],
      [
        1,
        -1
      ],
      [
        1,
        1
      ]
    ],
    [
      [
        27241,
        62737
      ],
      [
        2,
        -25
      ],
      [
        4,
        9
      ],
      [
        7,
        -14
      ],
      [
        0,
        -21
      ],
      [
        18,
        -7
      ],
      [
        6,
        -28
      ]
    ],
    [
      [
        27182,
        62369
      ],
      [
        -46,
        81
      ]
    ],
    [
      [
        27568,
        62796
      ],
      [
        -2,
        -13
      ],
      [
        1,
        -62
      ],
      [
        0,
        -67
      ],
      [
        4,
        -4
      ],
      [
        6,
        -29
      ]
    ],
    [
      [
        27560,
        62470
      ],
      [
        -6,
        -14
      ],
      [
        -15,
        3
      ]
    ],
    [
      [
        27539,
        62459
      ],
      [
        -42,
        41
      ],
      [
        -4,
        8
      ],
      [
        -14,
        1
      ],
      [
        -8,
        6
      ],
      [
        -1,
        8
      ],
      [
        -10,
        12
      ],
      [
        -3,
        -2
      ]
    ],
    [
      [
        20051,
        73979
      ],
      [
        189,
        0
      ],
      [
        6,
        -1
      ],
      [
        28,
        1
      ],
      [
        3,
        0
      ],
      [
        26,
        -1
      ],
      [
        9,
        0
      ],
      [
        2,
        1
      ],
      [
        34,
        -1
      ]
    ],
    [
      [
        20348,
        73978
      ],
      [
        0,
        -103
      ],
      [
        -11,
        0
      ],
      [
        0,
        -101
      ],
      [
        36,
        0
      ],
      [
        0,
        -303
      ],
      [
        61,
        0
      ]
    ],
    [
      [
        30059,
        66688
      ],
      [
        3,
        7
      ]
    ],
    [
      [
        30062,
        66695
      ],
      [
        4,
        4
      ],
      [
        2,
        1
      ],
      [
        4,
        -4
      ],
      [
        1,
        0
      ],
      [
        7,
        -7
      ],
      [
        -1,
        62
      ],
      [
        1,
        4
      ],
      [
        2,
        9
      ],
      [
        2,
        7
      ],
      [
        0,
        1
      ],
      [
        5,
        8
      ],
      [
        5,
        7
      ],
      [
        4,
        -4
      ],
      [
        15,
        -14
      ],
      [
        3,
        32
      ],
      [
        1,
        12
      ],
      [
        1,
        6
      ],
      [
        4,
        12
      ],
      [
        7,
        5
      ],
      [
        2,
        0
      ],
      [
        9,
        6
      ],
      [
        5,
        9
      ],
      [
        5,
        9
      ],
      [
        1,
        1
      ],
      [
        3,
        2
      ],
      [
        4,
        0
      ],
      [
        4,
        -5
      ],
      [
        11,
        -25
      ],
      [
        3,
        5
      ],
      [
        2,
        4
      ],
      [
        2,
        4
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        30181,
        66846
      ],
      [
        0,
        -25
      ],
      [
        2,
        -47
      ],
      [
        2,
        -33
      ],
      [
        3,
        -34
      ],
      [
        0,
        -7
      ],
      [
        6,
        -42
      ],
      [
        0,
        -7
      ],
      [
        -2,
        -7
      ],
      [
        0,
        -6
      ],
      [
        4,
        -9
      ],
      [
        5,
        -2
      ],
      [
        1,
        -2
      ],
      [
        4,
        -15
      ],
      [
        0,
        -6
      ],
      [
        1,
        -1
      ],
      [
        10,
        -12
      ],
      [
        2,
        2
      ],
      [
        0,
        9
      ],
      [
        5,
        18
      ],
      [
        5,
        13
      ],
      [
        5,
        4
      ],
      [
        2,
        -5
      ],
      [
        0,
        -14
      ],
      [
        -1,
        -13
      ],
      [
        1,
        -5
      ],
      [
        2,
        -4
      ],
      [
        5,
        3
      ],
      [
        1,
        -12
      ],
      [
        0,
        -17
      ],
      [
        -4,
        0
      ],
      [
        -3,
        -7
      ],
      [
        -5,
        -34
      ],
      [
        -5,
        -20
      ],
      [
        -3,
        -3
      ],
      [
        -1,
        2
      ],
      [
        0,
        9
      ],
      [
        -1,
        3
      ],
      [
        0,
        3
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        -3,
        -13
      ],
      [
        -5,
        -4
      ],
      [
        -4,
        -3
      ],
      [
        -2,
        6
      ],
      [
        -6,
        -7
      ],
      [
        -10,
        -8
      ],
      [
        -3,
        -3
      ],
      [
        -3,
        -8
      ],
      [
        -2,
        -3
      ],
      [
        -7,
        -2
      ],
      [
        -7,
        -4
      ],
      [
        0,
        -8
      ],
      [
        2,
        -19
      ],
      [
        0,
        -1
      ],
      [
        2,
        -2
      ],
      [
        0,
        1
      ],
      [
        5,
        -3
      ],
      [
        3,
        -18
      ],
      [
        -2,
        -15
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        5
      ],
      [
        -3,
        -2
      ],
      [
        -6,
        -13
      ],
      [
        -2,
        -10
      ],
      [
        0,
        -6
      ],
      [
        -2,
        -5
      ],
      [
        -4,
        7
      ],
      [
        -3,
        2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -31
      ],
      [
        4,
        -8
      ],
      [
        1,
        -3
      ],
      [
        2,
        -6
      ],
      [
        -1,
        -5
      ],
      [
        -9,
        2
      ],
      [
        -2,
        22
      ],
      [
        0,
        18
      ],
      [
        -2,
        1
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -3
      ]
    ],
    [
      [
        30123,
        66348
      ],
      [
        -7,
        37
      ],
      [
        0,
        12
      ],
      [
        2,
        17
      ],
      [
        3,
        5
      ],
      [
        -1,
        22
      ],
      [
        -10,
        8
      ],
      [
        1,
        29
      ],
      [
        4,
        21
      ],
      [
        6,
        -4
      ],
      [
        2,
        4
      ],
      [
        -9,
        41
      ],
      [
        -5,
        -6
      ],
      [
        -16,
        -6
      ],
      [
        -3,
        11
      ],
      [
        -3,
        8
      ],
      [
        -2,
        -20
      ],
      [
        -5,
        12
      ],
      [
        3,
        9
      ],
      [
        -24,
        47
      ],
      [
        4,
        7
      ],
      [
        1,
        8
      ],
      [
        -5,
        78
      ]
    ],
    [
      [
        26982,
        59308
      ],
      [
        4,
        -1
      ],
      [
        10,
        28
      ],
      [
        14,
        -22
      ],
      [
        3,
        -1
      ],
      [
        23,
        58
      ],
      [
        2,
        11
      ],
      [
        6,
        -2
      ],
      [
        11,
        33
      ],
      [
        11,
        8
      ],
      [
        4,
        18
      ]
    ],
    [
      [
        27085,
        59155
      ],
      [
        -2,
        -11
      ],
      [
        -6,
        -32
      ],
      [
        -19,
        -114
      ],
      [
        1,
        -1
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        0
      ],
      [
        -1,
        5
      ],
      [
        -3,
        2
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -9
      ],
      [
        -2,
        -1
      ],
      [
        -3,
        -7
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        27004,
        59029
      ],
      [
        -2,
        39
      ],
      [
        -5,
        19
      ],
      [
        -6,
        4
      ],
      [
        3,
        27
      ],
      [
        -7,
        21
      ],
      [
        -10,
        10
      ],
      [
        -6,
        -8
      ]
    ],
    [
      [
        25656,
        59595
      ],
      [
        14,
        1
      ],
      [
        29,
        3
      ],
      [
        14,
        0
      ],
      [
        6,
        1
      ],
      [
        6,
        0
      ],
      [
        14,
        2
      ]
    ],
    [
      [
        25739,
        59602
      ],
      [
        14,
        0
      ],
      [
        29,
        3
      ],
      [
        1,
        0
      ],
      [
        4,
        1
      ],
      [
        7,
        -22
      ]
    ],
    [
      [
        25741,
        59318
      ],
      [
        -3,
        -13
      ],
      [
        -4,
        -5
      ],
      [
        -3,
        -15
      ],
      [
        1,
        -20
      ],
      [
        -10,
        -11
      ],
      [
        -9,
        23
      ],
      [
        -6,
        3
      ],
      [
        -5,
        19
      ],
      [
        -5,
        -7
      ]
    ],
    [
      [
        25697,
        59292
      ],
      [
        -14,
        -7
      ],
      [
        -7,
        -9
      ],
      [
        -5,
        27
      ],
      [
        -16,
        34
      ],
      [
        -9,
        27
      ],
      [
        -7,
        13
      ]
    ],
    [
      [
        25639,
        59377
      ],
      [
        -2,
        7
      ],
      [
        2,
        57
      ],
      [
        1,
        46
      ],
      [
        -3,
        -4
      ],
      [
        -6,
        23
      ],
      [
        5,
        -4
      ],
      [
        3,
        59
      ],
      [
        -1,
        18
      ],
      [
        3,
        15
      ]
    ],
    [
      [
        24432,
        56010
      ],
      [
        29,
        0
      ],
      [
        0,
        -51
      ],
      [
        1,
        16
      ],
      [
        4,
        0
      ],
      [
        2,
        -17
      ],
      [
        22,
        -2
      ],
      [
        0,
        52
      ],
      [
        4,
        0
      ]
    ],
    [
      [
        24498,
        55970
      ],
      [
        8,
        -22
      ],
      [
        1,
        -3
      ],
      [
        0,
        -13
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -12
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -7
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -12
      ],
      [
        0,
        -6
      ],
      [
        5,
        -5
      ],
      [
        2,
        -1
      ],
      [
        1,
        0
      ],
      [
        3,
        3
      ],
      [
        2,
        3
      ],
      [
        2,
        2
      ],
      [
        1,
        4
      ],
      [
        2,
        10
      ],
      [
        0,
        11
      ],
      [
        -2,
        11
      ],
      [
        0,
        17
      ],
      [
        1,
        5
      ],
      [
        0,
        7
      ],
      [
        2,
        2
      ],
      [
        1,
        -1
      ],
      [
        1,
        -3
      ],
      [
        1,
        -2
      ],
      [
        5,
        -14
      ],
      [
        4,
        -9
      ],
      [
        1,
        -15
      ],
      [
        1,
        -8
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -6
      ],
      [
        -2,
        -9
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -4,
        -5
      ],
      [
        -4,
        -6
      ],
      [
        -1,
        0
      ],
      [
        -1,
        3
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -8
      ],
      [
        1,
        -4
      ],
      [
        4,
        -10
      ],
      [
        4,
        -8
      ],
      [
        1,
        -2
      ],
      [
        2,
        -2
      ],
      [
        3,
        -1
      ],
      [
        4,
        2
      ],
      [
        5,
        8
      ],
      [
        3,
        7
      ],
      [
        2,
        7
      ],
      [
        2,
        10
      ],
      [
        1,
        11
      ],
      [
        0,
        10
      ],
      [
        -1,
        7
      ],
      [
        0,
        7
      ],
      [
        1,
        5
      ],
      [
        1,
        5
      ],
      [
        1,
        6
      ],
      [
        2,
        3
      ],
      [
        1,
        2
      ],
      [
        1,
        0
      ],
      [
        2,
        -1
      ],
      [
        0,
        -2
      ],
      [
        2,
        -4
      ],
      [
        0,
        -25
      ],
      [
        -1,
        -8
      ],
      [
        -4,
        -18
      ],
      [
        -4,
        -12
      ],
      [
        -3,
        -10
      ],
      [
        -1,
        -7
      ],
      [
        -4,
        -20
      ],
      [
        -1,
        -5
      ],
      [
        -5,
        -10
      ],
      [
        0,
        -21
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        1,
        -16
      ],
      [
        0,
        -21
      ],
      [
        4,
        -19
      ],
      [
        0,
        -13
      ],
      [
        2,
        -8
      ],
      [
        1,
        -1
      ],
      [
        1,
        -9
      ],
      [
        1,
        -9
      ],
      [
        1,
        -4
      ],
      [
        2,
        -5
      ],
      [
        0,
        4
      ],
      [
        1,
        11
      ],
      [
        1,
        5
      ],
      [
        0,
        3
      ],
      [
        1,
        19
      ],
      [
        1,
        5
      ],
      [
        1,
        4
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        2,
        1
      ],
      [
        2,
        0
      ],
      [
        2,
        -2
      ],
      [
        1,
        -3
      ],
      [
        1,
        -4
      ],
      [
        0,
        -16
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -10
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -11
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        0
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -12
      ],
      [
        1,
        -14
      ],
      [
        1,
        -20
      ],
      [
        0,
        -29
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -4
      ],
      [
        -3,
        -6
      ],
      [
        -2,
        -2
      ],
      [
        -5,
        -1
      ],
      [
        -4,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        0,
        3
      ],
      [
        -2,
        8
      ],
      [
        -1,
        0
      ],
      [
        -2,
        1
      ],
      [
        -4,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -11
      ],
      [
        0,
        -20
      ],
      [
        1,
        -1
      ],
      [
        1,
        -3
      ],
      [
        4,
        -7
      ],
      [
        2,
        -8
      ],
      [
        0,
        -3
      ],
      [
        1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        2,
        0
      ],
      [
        3,
        -5
      ],
      [
        7,
        -20
      ],
      [
        1,
        -6
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -10
      ],
      [
        -1,
        -9
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -10
      ]
    ],
    [
      [
        24512,
        55367
      ],
      [
        0,
        -8
      ]
    ],
    [
      [
        24485,
        55360
      ],
      [
        -18,
        0
      ],
      [
        -1,
        1
      ],
      [
        -29,
        0
      ]
    ],
    [
      [
        24437,
        55361
      ],
      [
        -7,
        0
      ]
    ],
    [
      [
        25990,
        63437
      ],
      [
        0,
        -17
      ],
      [
        -21,
        -2
      ]
    ],
    [
      [
        25969,
        63418
      ],
      [
        -64,
        0
      ],
      [
        -5,
        -1
      ],
      [
        -15,
        0
      ]
    ],
    [
      [
        25847,
        64156
      ],
      [
        32,
        1
      ],
      [
        26,
        1
      ]
    ],
    [
      [
        25847,
        64005
      ],
      [
        0,
        151
      ]
    ],
    [
      [
        25969,
        63418
      ],
      [
        0,
        -67
      ],
      [
        -5,
        -16
      ],
      [
        0,
        -34
      ],
      [
        1,
        -23
      ],
      [
        0,
        -128
      ]
    ],
    [
      [
        25882,
        63076
      ],
      [
        -21,
        -2
      ]
    ],
    [
      [
        25758,
        63345
      ],
      [
        -88,
        2
      ]
    ],
    [
      [
        24712,
        54858
      ],
      [
        6,
        14
      ],
      [
        6,
        -13
      ],
      [
        12,
        33
      ],
      [
        5,
        12
      ],
      [
        2,
        -9
      ],
      [
        4,
        12
      ],
      [
        5,
        34
      ],
      [
        5,
        -4
      ],
      [
        3,
        22
      ],
      [
        9,
        -2
      ],
      [
        5,
        11
      ],
      [
        1,
        -8
      ],
      [
        7,
        3
      ],
      [
        7,
        19
      ],
      [
        16,
        28
      ],
      [
        4,
        -5
      ],
      [
        2,
        9
      ],
      [
        5,
        25
      ],
      [
        9,
        17
      ],
      [
        3,
        19
      ],
      [
        4,
        51
      ],
      [
        0,
        27
      ],
      [
        6,
        5
      ],
      [
        9,
        56
      ]
    ],
    [
      [
        24847,
        55214
      ],
      [
        34,
        7
      ],
      [
        31,
        -1
      ]
    ],
    [
      [
        26506,
        70605
      ],
      [
        6,
        -4
      ],
      [
        1,
        -11
      ],
      [
        3,
        -8
      ],
      [
        0,
        -19
      ],
      [
        -6,
        12
      ],
      [
        -5,
        14
      ],
      [
        1,
        16
      ]
    ],
    [
      [
        26164,
        71367
      ],
      [
        18,
        9
      ],
      [
        30,
        -7
      ],
      [
        8,
        3
      ],
      [
        7,
        10
      ],
      [
        6,
        4
      ],
      [
        7,
        1
      ],
      [
        3,
        -2
      ],
      [
        1,
        -2
      ],
      [
        -10,
        -28
      ],
      [
        -6,
        -20
      ],
      [
        -4,
        -19
      ],
      [
        -2,
        -17
      ],
      [
        0,
        -26
      ],
      [
        -2,
        -58
      ],
      [
        0,
        -51
      ],
      [
        1,
        -15
      ],
      [
        1,
        -17
      ],
      [
        1,
        -9
      ],
      [
        -1,
        -4
      ],
      [
        -5,
        -6
      ],
      [
        -2,
        -6
      ],
      [
        -1,
        -7
      ],
      [
        1,
        -14
      ],
      [
        1,
        -12
      ],
      [
        5,
        -19
      ],
      [
        2,
        -6
      ],
      [
        3,
        -4
      ],
      [
        13,
        -4
      ],
      [
        3,
        5
      ],
      [
        3,
        8
      ],
      [
        3,
        3
      ],
      [
        0,
        -11
      ],
      [
        4,
        -12
      ],
      [
        2,
        -3
      ],
      [
        6,
        -2
      ],
      [
        5,
        1
      ],
      [
        4,
        4
      ],
      [
        3,
        -11
      ],
      [
        2,
        -14
      ],
      [
        4,
        -5
      ],
      [
        8,
        2
      ],
      [
        8,
        9
      ],
      [
        13,
        17
      ],
      [
        10,
        18
      ],
      [
        3,
        5
      ],
      [
        6,
        -7
      ],
      [
        7,
        3
      ],
      [
        4,
        -15
      ],
      [
        2,
        -17
      ],
      [
        5,
        -14
      ],
      [
        -2,
        -6
      ],
      [
        -2,
        -9
      ],
      [
        1,
        -9
      ],
      [
        2,
        -11
      ],
      [
        3,
        -2
      ],
      [
        9,
        6
      ],
      [
        13,
        24
      ],
      [
        3,
        2
      ],
      [
        4,
        -9
      ],
      [
        2,
        2
      ],
      [
        3,
        7
      ],
      [
        2,
        15
      ],
      [
        0,
        11
      ],
      [
        -2,
        5
      ],
      [
        5,
        25
      ],
      [
        7,
        14
      ],
      [
        7,
        -2
      ],
      [
        5,
        11
      ],
      [
        0,
        1
      ],
      [
        9,
        -2
      ],
      [
        2,
        -2
      ],
      [
        3,
        -7
      ],
      [
        9,
        -8
      ],
      [
        5,
        0
      ],
      [
        3,
        2
      ],
      [
        3,
        7
      ],
      [
        8,
        39
      ],
      [
        9,
        7
      ],
      [
        4,
        -16
      ],
      [
        3,
        0
      ],
      [
        4,
        2
      ],
      [
        2,
        3
      ],
      [
        2,
        2
      ],
      [
        3,
        -3
      ],
      [
        1,
        -11
      ],
      [
        2,
        -3
      ],
      [
        2,
        -16
      ],
      [
        -4,
        -40
      ],
      [
        -6,
        -60
      ],
      [
        2,
        -54
      ],
      [
        5,
        -41
      ],
      [
        4,
        -17
      ],
      [
        -4,
        -8
      ],
      [
        1,
        -55
      ],
      [
        5,
        -13
      ],
      [
        -2,
        -18
      ],
      [
        -3,
        -9
      ],
      [
        -2,
        -1
      ],
      [
        -3,
        -1
      ],
      [
        -3,
        -8
      ],
      [
        0,
        -1
      ],
      [
        -2,
        0
      ],
      [
        0,
        4
      ],
      [
        -2,
        7
      ],
      [
        -6,
        2
      ],
      [
        -11,
        -4
      ],
      [
        -3,
        -9
      ],
      [
        -5,
        -21
      ],
      [
        1,
        -16
      ],
      [
        0,
        -15
      ],
      [
        -1,
        -4
      ],
      [
        8,
        -15
      ],
      [
        7,
        3
      ],
      [
        5,
        21
      ],
      [
        2,
        -2
      ],
      [
        13,
        -2
      ],
      [
        3,
        -7
      ],
      [
        0,
        -6
      ],
      [
        4,
        -21
      ],
      [
        1,
        -4
      ],
      [
        2,
        -2
      ],
      [
        8,
        0
      ],
      [
        9,
        -17
      ],
      [
        -1,
        -10
      ],
      [
        -2,
        3
      ],
      [
        -4,
        -7
      ],
      [
        -2,
        -7
      ],
      [
        -3,
        -11
      ],
      [
        -1,
        -8
      ],
      [
        1,
        -5
      ],
      [
        1,
        -6
      ],
      [
        4,
        -10
      ],
      [
        7,
        -28
      ],
      [
        6,
        -12
      ],
      [
        5,
        -14
      ],
      [
        7,
        -6
      ],
      [
        3,
        2
      ],
      [
        2,
        3
      ],
      [
        2,
        -3
      ],
      [
        1,
        -10
      ],
      [
        1,
        -3
      ],
      [
        6,
        -8
      ],
      [
        2,
        -14
      ],
      [
        8,
        -7
      ],
      [
        1,
        2
      ],
      [
        7,
        36
      ],
      [
        4,
        -4
      ],
      [
        3,
        -23
      ],
      [
        7,
        -8
      ],
      [
        5,
        10
      ],
      [
        3,
        16
      ],
      [
        0,
        16
      ],
      [
        -2,
        23
      ],
      [
        -7,
        6
      ],
      [
        -4,
        20
      ],
      [
        -3,
        35
      ],
      [
        2,
        5
      ],
      [
        1,
        0
      ],
      [
        5,
        -7
      ],
      [
        4,
        -10
      ],
      [
        2,
        -3
      ],
      [
        5,
        1
      ],
      [
        7,
        -1
      ],
      [
        2,
        3
      ],
      [
        1,
        9
      ],
      [
        4,
        2
      ],
      [
        12,
        -3
      ],
      [
        7,
        4
      ],
      [
        3,
        -2
      ],
      [
        3,
        -7
      ],
      [
        4,
        -7
      ],
      [
        5,
        -1
      ],
      [
        2,
        -7
      ],
      [
        1,
        -10
      ],
      [
        0,
        -6
      ],
      [
        2,
        -9
      ],
      [
        3,
        -3
      ],
      [
        2,
        -13
      ],
      [
        1,
        -13
      ],
      [
        1,
        -18
      ],
      [
        2,
        -12
      ],
      [
        10,
        -14
      ],
      [
        2,
        0
      ],
      [
        2,
        -3
      ],
      [
        2,
        -9
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -15
      ],
      [
        -2,
        -3
      ],
      [
        -6,
        -46
      ],
      [
        -2,
        -7
      ],
      [
        -2,
        -6
      ],
      [
        -10,
        -7
      ],
      [
        -6,
        4
      ],
      [
        -14,
        19
      ],
      [
        -7,
        16
      ],
      [
        -8,
        -12
      ],
      [
        -9,
        -2
      ],
      [
        -4,
        4
      ],
      [
        -3,
        1
      ],
      [
        -6,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        -5,
        1
      ],
      [
        -4,
        5
      ],
      [
        -1,
        7
      ],
      [
        -1,
        3
      ],
      [
        -4,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        0
      ],
      [
        -1,
        13
      ],
      [
        -2,
        1
      ],
      [
        -5,
        7
      ],
      [
        -4,
        8
      ],
      [
        0,
        2
      ],
      [
        -9,
        -3
      ],
      [
        -2,
        -9
      ],
      [
        -9,
        9
      ],
      [
        -9,
        2
      ],
      [
        -3,
        -7
      ],
      [
        -6,
        -3
      ],
      [
        -18,
        14
      ],
      [
        -3,
        -4
      ],
      [
        -4,
        7
      ],
      [
        0,
        4
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        26477,
        70462
      ],
      [
        0,
        8
      ],
      [
        -35,
        -1
      ],
      [
        0,
        101
      ],
      [
        -35,
        0
      ],
      [
        0,
        101
      ],
      [
        -208,
        0
      ],
      [
        -1,
        102
      ],
      [
        -34,
        0
      ]
    ],
    [
      [
        26346,
        70444
      ],
      [
        2,
        9
      ],
      [
        4,
        -5
      ],
      [
        0,
        -9
      ],
      [
        -1,
        -13
      ],
      [
        -3,
        9
      ],
      [
        -2,
        9
      ]
    ],
    [
      [
        26330,
        70462
      ],
      [
        2,
        7
      ],
      [
        5,
        -13
      ],
      [
        2,
        -9
      ],
      [
        -3,
        -8
      ],
      [
        -4,
        -9
      ],
      [
        -2,
        9
      ],
      [
        0,
        23
      ]
    ],
    [
      [
        26327,
        70327
      ],
      [
        1,
        26
      ],
      [
        2,
        1
      ],
      [
        3,
        -4
      ],
      [
        2,
        -6
      ],
      [
        4,
        -18
      ],
      [
        2,
        -12
      ],
      [
        3,
        -30
      ],
      [
        4,
        -6
      ],
      [
        11,
        -15
      ],
      [
        6,
        3
      ],
      [
        6,
        -6
      ],
      [
        17,
        -21
      ],
      [
        2,
        1
      ],
      [
        1,
        6
      ],
      [
        1,
        8
      ],
      [
        -1,
        7
      ],
      [
        1,
        1
      ],
      [
        2,
        -11
      ],
      [
        2,
        -15
      ],
      [
        13,
        -15
      ],
      [
        0,
        -2
      ],
      [
        -4,
        -16
      ],
      [
        0,
        -12
      ],
      [
        -6,
        -12
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -6
      ],
      [
        -3,
        -6
      ],
      [
        -4,
        -1
      ],
      [
        -3,
        5
      ],
      [
        -6,
        2
      ],
      [
        -5,
        5
      ],
      [
        -4,
        -1
      ],
      [
        -5,
        7
      ],
      [
        -2,
        9
      ],
      [
        0,
        11
      ],
      [
        -5,
        11
      ],
      [
        -7,
        30
      ],
      [
        -3,
        8
      ],
      [
        -5,
        7
      ],
      [
        -2,
        5
      ],
      [
        -1,
        8
      ],
      [
        -2,
        11
      ],
      [
        -4,
        12
      ],
      [
        -3,
        15
      ],
      [
        -2,
        4
      ],
      [
        -3,
        3
      ],
      [
        -3,
        8
      ],
      [
        0,
        4
      ]
    ],
    [
      [
        26477,
        70462
      ],
      [
        -8,
        -4
      ],
      [
        -8,
        -10
      ],
      [
        -2,
        3
      ],
      [
        -17,
        -2
      ],
      [
        -4,
        -13
      ],
      [
        -21,
        0
      ],
      [
        -7,
        -17
      ],
      [
        -6,
        -11
      ],
      [
        -15,
        31
      ],
      [
        -2,
        17
      ],
      [
        -2,
        5
      ],
      [
        -5,
        -10
      ],
      [
        -5,
        10
      ],
      [
        -1,
        5
      ],
      [
        0,
        7
      ],
      [
        -7,
        4
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -18
      ],
      [
        -3,
        -4
      ],
      [
        -2,
        1
      ],
      [
        0,
        11
      ],
      [
        1,
        15
      ],
      [
        -1,
        17
      ],
      [
        -2,
        16
      ],
      [
        -1,
        4
      ],
      [
        -5,
        11
      ],
      [
        -5,
        -2
      ],
      [
        -2,
        -5
      ],
      [
        -6,
        0
      ],
      [
        -11,
        27
      ],
      [
        -2,
        3
      ],
      [
        -3,
        -2
      ],
      [
        -3,
        -5
      ],
      [
        -3,
        -13
      ],
      [
        -1,
        -10
      ],
      [
        0,
        -11
      ],
      [
        1,
        -44
      ],
      [
        1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        -4,
        -1
      ],
      [
        -6,
        -4
      ],
      [
        -2,
        -7
      ],
      [
        -2,
        -18
      ],
      [
        0,
        -5
      ],
      [
        1,
        -10
      ],
      [
        4,
        -6
      ],
      [
        2,
        -9
      ],
      [
        0,
        -5
      ],
      [
        -6,
        -10
      ],
      [
        4,
        -39
      ],
      [
        1,
        -9
      ],
      [
        4,
        -15
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -4,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -11
      ],
      [
        -5,
        -1
      ],
      [
        -13,
        27
      ],
      [
        -11,
        15
      ],
      [
        -2,
        11
      ],
      [
        0,
        9
      ],
      [
        -1,
        11
      ],
      [
        -3,
        2
      ],
      [
        -6,
        11
      ],
      [
        -1,
        7
      ],
      [
        -7,
        9
      ],
      [
        -4,
        8
      ],
      [
        -5,
        30
      ],
      [
        -11,
        35
      ],
      [
        -8,
        23
      ],
      [
        -3,
        6
      ],
      [
        -11,
        14
      ],
      [
        -10,
        6
      ],
      [
        -4,
        5
      ],
      [
        -7,
        16
      ],
      [
        -3,
        4
      ],
      [
        -3,
        1
      ],
      [
        -11,
        -4
      ],
      [
        -2,
        -3
      ],
      [
        -7,
        19
      ],
      [
        -12,
        6
      ],
      [
        -6,
        7
      ],
      [
        -8,
        17
      ],
      [
        -6,
        7
      ],
      [
        -5,
        -1
      ],
      [
        -3,
        -6
      ],
      [
        -4,
        -5
      ],
      [
        -4,
        15
      ],
      [
        -5,
        7
      ],
      [
        -4,
        1
      ],
      [
        -4,
        -7
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -9
      ],
      [
        -10,
        13
      ],
      [
        -5,
        1
      ],
      [
        -4,
        -3
      ],
      [
        -2,
        -4
      ],
      [
        -6,
        -13
      ],
      [
        -17,
        -58
      ],
      [
        -4,
        -25
      ],
      [
        -9,
        -29
      ],
      [
        -1,
        -12
      ],
      [
        -3,
        -7
      ],
      [
        -9,
        -8
      ],
      [
        -8,
        6
      ],
      [
        -5,
        -1
      ],
      [
        -8,
        8
      ],
      [
        -5,
        7
      ],
      [
        -6,
        3
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -10
      ],
      [
        -3,
        -2
      ],
      [
        -5,
        3
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        25989,
        70450
      ],
      [
        0,
        322
      ]
    ],
    [
      [
        27093,
        52817
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        3,
        -13
      ],
      [
        1,
        -6
      ],
      [
        2,
        -8
      ],
      [
        5,
        2
      ],
      [
        2,
        -5
      ],
      [
        1,
        -4
      ],
      [
        0,
        -1
      ],
      [
        4,
        3
      ],
      [
        5,
        2
      ],
      [
        1,
        -1
      ],
      [
        4,
        -6
      ],
      [
        2,
        -12
      ],
      [
        0,
        -5
      ],
      [
        1,
        -2
      ],
      [
        2,
        0
      ],
      [
        0,
        2
      ],
      [
        1,
        3
      ],
      [
        0,
        2
      ],
      [
        2,
        0
      ],
      [
        1,
        -3
      ],
      [
        1,
        -4
      ],
      [
        2,
        -2
      ],
      [
        1,
        0
      ],
      [
        0,
        -7
      ],
      [
        1,
        -1
      ],
      [
        2,
        -11
      ],
      [
        2,
        -4
      ],
      [
        2,
        -2
      ],
      [
        7,
        4
      ],
      [
        0,
        -1
      ],
      [
        1,
        -4
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        4,
        -3
      ],
      [
        1,
        2
      ],
      [
        0,
        5
      ],
      [
        1,
        1
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        2,
        -2
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -15
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        4,
        2
      ],
      [
        1,
        4
      ],
      [
        1,
        0
      ],
      [
        1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -8
      ],
      [
        3,
        -2
      ],
      [
        0,
        1
      ],
      [
        1,
        4
      ],
      [
        0,
        3
      ],
      [
        1,
        1
      ],
      [
        2,
        -4
      ],
      [
        2,
        -2
      ],
      [
        4,
        -1
      ],
      [
        0,
        -1
      ],
      [
        2,
        -4
      ],
      [
        1,
        -3
      ],
      [
        3,
        2
      ],
      [
        0,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        1
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        2
      ],
      [
        0,
        4
      ],
      [
        1,
        1
      ],
      [
        0,
        1
      ],
      [
        2,
        -1
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ],
      [
        5,
        3
      ],
      [
        1,
        0
      ],
      [
        1,
        -2
      ],
      [
        2,
        -11
      ],
      [
        1,
        -2
      ],
      [
        2,
        -2
      ],
      [
        1,
        -1
      ],
      [
        3,
        -1
      ],
      [
        2,
        0
      ]
    ],
    [
      [
        27221,
        52688
      ],
      [
        3,
        -8
      ],
      [
        1,
        -5
      ],
      [
        -1,
        -34
      ],
      [
        -3,
        -79
      ],
      [
        0,
        -54
      ],
      [
        3,
        -38
      ],
      [
        -3,
        -14
      ]
    ],
    [
      [
        27221,
        52456
      ],
      [
        -2,
        10
      ],
      [
        -8,
        17
      ],
      [
        -6,
        35
      ],
      [
        -4,
        4
      ],
      [
        -2,
        -12
      ],
      [
        0,
        -21
      ],
      [
        -2,
        -14
      ],
      [
        -4,
        -3
      ],
      [
        -3,
        24
      ],
      [
        -6,
        -8
      ],
      [
        -4,
        15
      ],
      [
        2,
        16
      ],
      [
        -3,
        1
      ],
      [
        -5,
        -13
      ],
      [
        -1,
        10
      ],
      [
        4,
        6
      ],
      [
        -2,
        8
      ],
      [
        1,
        12
      ],
      [
        -6,
        1
      ],
      [
        -6,
        -11
      ],
      [
        -5,
        -29
      ],
      [
        -1,
        11
      ],
      [
        -8,
        10
      ],
      [
        -2,
        -7
      ],
      [
        -5,
        10
      ],
      [
        -3,
        -15
      ],
      [
        -1,
        -29
      ],
      [
        -7,
        1
      ],
      [
        -1,
        -20
      ],
      [
        -4,
        -17
      ],
      [
        -4,
        2
      ],
      [
        -4,
        -24
      ],
      [
        -6,
        -20
      ],
      [
        -29,
        -109
      ],
      [
        -29,
        -105
      ],
      [
        -3,
        -12
      ]
    ],
    [
      [
        27052,
        52180
      ],
      [
        0,
        104
      ]
    ],
    [
      [
        27640,
        62865
      ],
      [
        12,
        -19
      ]
    ],
    [
      [
        26269,
        58090
      ],
      [
        3,
        -4
      ],
      [
        7,
        -25
      ],
      [
        12,
        -14
      ],
      [
        9,
        -30
      ],
      [
        7,
        -2
      ],
      [
        -7,
        -12
      ],
      [
        1,
        -13
      ],
      [
        4,
        -11
      ],
      [
        4,
        8
      ],
      [
        5,
        -10
      ],
      [
        -1,
        -14
      ]
    ],
    [
      [
        26236,
        57668
      ],
      [
        5,
        32
      ],
      [
        -9,
        23
      ],
      [
        -1,
        20
      ],
      [
        1,
        8
      ],
      [
        -2,
        20
      ],
      [
        -2,
        4
      ],
      [
        0,
        15
      ],
      [
        -5,
        51
      ],
      [
        5,
        44
      ],
      [
        0,
        11
      ],
      [
        8,
        49
      ],
      [
        3,
        40
      ],
      [
        7,
        26
      ],
      [
        -1,
        6
      ]
    ],
    [
      [
        26617,
        52620
      ],
      [
        31,
        -6
      ],
      [
        14,
        -4
      ],
      [
        3,
        -1
      ],
      [
        3,
        0
      ],
      [
        11,
        -3
      ],
      [
        3,
        -1
      ],
      [
        6,
        -1
      ]
    ],
    [
      [
        26688,
        52604
      ],
      [
        4,
        -1
      ],
      [
        8,
        -2
      ],
      [
        1,
        -1
      ],
      [
        10,
        -2
      ]
    ],
    [
      [
        26711,
        52598
      ],
      [
        5,
        -54
      ],
      [
        -2,
        -6
      ],
      [
        2,
        -25
      ],
      [
        -1,
        -7
      ],
      [
        3,
        -15
      ],
      [
        3,
        -29
      ],
      [
        -2,
        -49
      ],
      [
        5,
        -6
      ],
      [
        3,
        -14
      ],
      [
        -2,
        -38
      ],
      [
        5,
        -11
      ],
      [
        3,
        3
      ],
      [
        4,
        -8
      ],
      [
        3,
        -29
      ]
    ],
    [
      [
        26685,
        52165
      ],
      [
        -28,
        0
      ],
      [
        0,
        51
      ],
      [
        -98,
        -1
      ]
    ],
    [
      [
        26559,
        52215
      ],
      [
        0,
        12
      ],
      [
        7,
        6
      ],
      [
        2,
        15
      ],
      [
        -5,
        25
      ],
      [
        0,
        22
      ],
      [
        3,
        16
      ],
      [
        2,
        -4
      ],
      [
        8,
        4
      ],
      [
        2,
        25
      ],
      [
        8,
        32
      ],
      [
        -2,
        23
      ],
      [
        1,
        42
      ],
      [
        -3,
        20
      ],
      [
        3,
        18
      ],
      [
        6,
        0
      ],
      [
        0,
        17
      ],
      [
        9,
        0
      ],
      [
        0,
        18
      ],
      [
        10,
        -1
      ],
      [
        0,
        18
      ],
      [
        4,
        -1
      ],
      [
        0,
        17
      ],
      [
        5,
        0
      ],
      [
        0,
        66
      ],
      [
        -2,
        15
      ]
    ],
    [
      [
        24745,
        55707
      ],
      [
        6,
        20
      ],
      [
        1,
        -12
      ],
      [
        5,
        3
      ],
      [
        2,
        31
      ],
      [
        -4,
        26
      ],
      [
        -8,
        5
      ],
      [
        0,
        11
      ],
      [
        41,
        -49
      ]
    ],
    [
      [
        24907,
        55604
      ],
      [
        0,
        -4
      ],
      [
        -3,
        -19
      ],
      [
        -5,
        -1
      ],
      [
        1,
        -20
      ],
      [
        -3,
        -17
      ],
      [
        -3,
        -3
      ],
      [
        0,
        -34
      ],
      [
        -3,
        -20
      ],
      [
        -5,
        -4
      ],
      [
        1,
        -11
      ],
      [
        -2,
        -13
      ],
      [
        1,
        -29
      ],
      [
        -3,
        -2
      ],
      [
        0,
        -26
      ],
      [
        -11,
        -46
      ],
      [
        -3,
        -32
      ],
      [
        -3,
        -47
      ],
      [
        -19,
        -62
      ]
    ],
    [
      [
        24847,
        55214
      ],
      [
        -57,
        84
      ],
      [
        -1,
        1
      ],
      [
        -46,
        67
      ],
      [
        -2,
        14
      ],
      [
        -3,
        -12
      ],
      [
        -2,
        -1
      ]
    ],
    [
      [
        25164,
        59432
      ],
      [
        3,
        0
      ]
    ],
    [
      [
        23990,
        68708
      ],
      [
        0,
        51
      ],
      [
        15,
        4
      ],
      [
        9,
        -14
      ],
      [
        10,
        12
      ],
      [
        0,
        30
      ],
      [
        35,
        0
      ],
      [
        0,
        101
      ],
      [
        17,
        0
      ],
      [
        0,
        98
      ]
    ],
    [
      [
        23828,
        60508
      ],
      [
        51,
        -5
      ],
      [
        52,
        -5
      ],
      [
        19,
        -2
      ]
    ],
    [
      [
        23950,
        60496
      ],
      [
        31,
        -2
      ]
    ],
    [
      [
        23832,
        60125
      ],
      [
        1,
        213
      ],
      [
        -6,
        1
      ]
    ],
    [
      [
        23827,
        60339
      ],
      [
        1,
        169
      ]
    ],
    [
      [
        26051,
        55931
      ],
      [
        81,
        -4
      ],
      [
        1,
        11
      ],
      [
        5,
        -12
      ],
      [
        7,
        -10
      ]
    ],
    [
      [
        26145,
        55916
      ],
      [
        3,
        -64
      ]
    ],
    [
      [
        26164,
        55505
      ],
      [
        1,
        -25
      ]
    ],
    [
      [
        26065,
        55479
      ],
      [
        -17,
        -1
      ]
    ],
    [
      [
        20274,
        54191
      ],
      [
        -5,
        1
      ],
      [
        -4,
        0
      ],
      [
        -43,
        -1
      ],
      [
        -15,
        0
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        -3,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -6
      ],
      [
        1,
        -4
      ],
      [
        2,
        -6
      ],
      [
        1,
        -1
      ],
      [
        0,
        -19
      ],
      [
        1,
        -2
      ],
      [
        0,
        -21
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -5
      ],
      [
        2,
        -11
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -6
      ],
      [
        -2,
        -7
      ],
      [
        0,
        -3
      ],
      [
        1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        2,
        -1
      ],
      [
        2,
        -6
      ],
      [
        0,
        -8
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -10
      ],
      [
        2,
        -6
      ],
      [
        1,
        -5
      ],
      [
        1,
        -4
      ],
      [
        2,
        -8
      ],
      [
        3,
        0
      ],
      [
        1,
        -2
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -13
      ],
      [
        0,
        -4
      ],
      [
        3,
        0
      ],
      [
        1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        2,
        -8
      ],
      [
        0,
        -2
      ],
      [
        1,
        -4
      ],
      [
        2,
        0
      ],
      [
        1,
        4
      ],
      [
        1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        2,
        -1
      ],
      [
        3,
        -3
      ],
      [
        0,
        -3
      ],
      [
        1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        2,
        -4
      ],
      [
        0,
        -3
      ],
      [
        1,
        -5
      ],
      [
        1,
        0
      ],
      [
        0,
        -10
      ]
    ],
    [
      [
        20232,
        53938
      ],
      [
        -1,
        1
      ],
      [
        -61,
        -1
      ],
      [
        0,
        1
      ],
      [
        -67,
        -1
      ],
      [
        -85,
        0
      ]
    ],
    [
      [
        28357,
        64489
      ],
      [
        24,
        73
      ],
      [
        21,
        96
      ],
      [
        17,
        60
      ]
    ],
    [
      [
        28419,
        64718
      ],
      [
        0,
        29
      ]
    ],
    [
      [
        28515,
        64525
      ],
      [
        -8,
        11
      ],
      [
        -22,
        -3
      ],
      [
        -10,
        3
      ],
      [
        -19,
        -22
      ],
      [
        -4,
        -13
      ],
      [
        -8,
        14
      ],
      [
        -6,
        -2
      ],
      [
        -15,
        -17
      ],
      [
        -54,
        -42
      ],
      [
        -9,
        -12
      ]
    ],
    [
      [
        21904,
        68796
      ],
      [
        -3,
        6
      ],
      [
        -15,
        5
      ],
      [
        -8,
        12
      ],
      [
        -5,
        19
      ],
      [
        -2,
        17
      ],
      [
        1,
        28
      ],
      [
        5,
        34
      ],
      [
        3,
        43
      ],
      [
        0,
        22
      ],
      [
        -5,
        35
      ],
      [
        -14,
        12
      ],
      [
        -1,
        9
      ],
      [
        -9,
        18
      ]
    ],
    [
      [
        30141,
        67625
      ],
      [
        -17,
        -68
      ],
      [
        -4,
        55
      ],
      [
        -8,
        -3
      ],
      [
        -5,
        -24
      ],
      [
        -8,
        0
      ],
      [
        -4,
        77
      ],
      [
        -10,
        -40
      ]
    ],
    [
      [
        29982,
        67881
      ],
      [
        -1,
        39
      ],
      [
        -2,
        1
      ],
      [
        -5,
        92
      ],
      [
        -1,
        22
      ],
      [
        57,
        26
      ],
      [
        -5,
        100
      ],
      [
        -1,
        24
      ],
      [
        10,
        54
      ],
      [
        -6,
        0
      ],
      [
        -4,
        34
      ],
      [
        2,
        24
      ],
      [
        -3,
        43
      ],
      [
        -8,
        14
      ],
      [
        -3,
        50
      ],
      [
        3,
        2
      ]
    ],
    [
      [
        27617,
        60369
      ],
      [
        1,
        7
      ],
      [
        8,
        15
      ],
      [
        4,
        10
      ],
      [
        4,
        -18
      ],
      [
        3,
        7
      ],
      [
        4,
        -6
      ],
      [
        2,
        -1
      ],
      [
        -1,
        2
      ],
      [
        3,
        6
      ],
      [
        1,
        2
      ],
      [
        0,
        -9
      ],
      [
        1,
        -1
      ],
      [
        2,
        2
      ],
      [
        1,
        -4
      ],
      [
        5,
        -10
      ],
      [
        0,
        -30
      ],
      [
        -9,
        -4
      ],
      [
        4,
        -16
      ],
      [
        1,
        -11
      ],
      [
        -5,
        -19
      ],
      [
        -2,
        -19
      ],
      [
        -3,
        3
      ],
      [
        -5,
        -18
      ],
      [
        -5,
        21
      ],
      [
        -1,
        2
      ],
      [
        -2,
        -2
      ],
      [
        -4,
        26
      ],
      [
        -3,
        -7
      ],
      [
        0,
        3
      ],
      [
        -6,
        -6
      ],
      [
        -2,
        10
      ],
      [
        1,
        12
      ]
    ],
    [
      [
        23464,
        64551
      ],
      [
        0,
        -202
      ],
      [
        4,
        0
      ],
      [
        0,
        -177
      ]
    ],
    [
      [
        23468,
        64172
      ],
      [
        -12,
        1
      ],
      [
        -10,
        0
      ],
      [
        -21,
        1
      ],
      [
        -12,
        0
      ],
      [
        0,
        1
      ],
      [
        -15,
        0
      ],
      [
        -10,
        1
      ]
    ],
    [
      [
        27451,
        56634
      ],
      [
        -12,
        -16
      ],
      [
        -9,
        -5
      ],
      [
        -7,
        -14
      ],
      [
        -16,
        51
      ],
      [
        -12,
        42
      ],
      [
        -9,
        29
      ],
      [
        -5,
        9
      ],
      [
        1,
        6
      ],
      [
        7,
        60
      ],
      [
        4,
        35
      ]
    ],
    [
      [
        18427,
        67124
      ],
      [
        0,
        -289
      ],
      [
        53,
        1
      ],
      [
        3,
        22
      ],
      [
        3,
        -6
      ],
      [
        4,
        19
      ],
      [
        1,
        24
      ],
      [
        5,
        11
      ],
      [
        -2,
        12
      ],
      [
        5,
        20
      ]
    ],
    [
      [
        15303,
        67706
      ],
      [
        10,
        0
      ],
      [
        0,
        1
      ],
      [
        86,
        -4
      ],
      [
        0,
        -108
      ],
      [
        16,
        1
      ],
      [
        0,
        -99
      ],
      [
        15,
        0
      ],
      [
        0,
        -202
      ],
      [
        17,
        0
      ],
      [
        0,
        -199
      ],
      [
        -1,
        -4
      ],
      [
        -15,
        0
      ],
      [
        0,
        -101
      ],
      [
        -17,
        0
      ],
      [
        0,
        -84
      ],
      [
        1,
        -17
      ],
      [
        -1,
        -100
      ],
      [
        3,
        0
      ],
      [
        0,
        -41
      ]
    ],
    [
      [
        15231,
        66942
      ],
      [
        5,
        43
      ],
      [
        1,
        10
      ],
      [
        6,
        83
      ],
      [
        1,
        30
      ],
      [
        -1,
        22
      ],
      [
        3,
        12
      ],
      [
        6,
        68
      ],
      [
        2,
        31
      ],
      [
        0,
        14
      ],
      [
        4,
        54
      ],
      [
        -2,
        24
      ],
      [
        -1,
        10
      ],
      [
        -2,
        4
      ],
      [
        -1,
        4
      ],
      [
        4,
        23
      ],
      [
        4,
        15
      ],
      [
        6,
        5
      ],
      [
        3,
        10
      ],
      [
        8,
        43
      ],
      [
        7,
        56
      ],
      [
        9,
        76
      ],
      [
        6,
        64
      ],
      [
        4,
        63
      ]
    ],
    [
      [
        15843,
        66991
      ],
      [
        -33,
        0
      ],
      [
        0,
        -15
      ],
      [
        -6,
        0
      ],
      [
        0,
        -17
      ],
      [
        -5,
        0
      ],
      [
        0,
        -17
      ],
      [
        -6,
        0
      ],
      [
        0,
        -17
      ],
      [
        -27,
        -1
      ],
      [
        0,
        -17
      ],
      [
        -6,
        0
      ],
      [
        0,
        -16
      ],
      [
        -6,
        0
      ],
      [
        0,
        -18
      ],
      [
        -10,
        2
      ],
      [
        0,
        -19
      ],
      [
        -11,
        0
      ],
      [
        0,
        -16
      ],
      [
        -6,
        0
      ],
      [
        0,
        -17
      ],
      [
        -5,
        0
      ],
      [
        0,
        -17
      ],
      [
        -6,
        0
      ],
      [
        0,
        -17
      ],
      [
        -10,
        7
      ],
      [
        0,
        -26
      ],
      [
        -6,
        -16
      ],
      [
        0,
        -17
      ],
      [
        -16,
        -5
      ],
      [
        -16,
        1
      ],
      [
        -11,
        0
      ],
      [
        0,
        -9
      ],
      [
        -6,
        1
      ],
      [
        -5,
        -10
      ],
      [
        -6,
        -9
      ],
      [
        -28,
        0
      ],
      [
        -11,
        5
      ],
      [
        0,
        -21
      ],
      [
        -8,
        0
      ],
      [
        -9,
        -33
      ],
      [
        -5,
        -8
      ]
    ],
    [
      [
        15303,
        67706
      ],
      [
        5,
        66
      ],
      [
        -1,
        7
      ],
      [
        2,
        18
      ],
      [
        1,
        20
      ],
      [
        7,
        119
      ],
      [
        3,
        64
      ]
    ],
    [
      [
        24651,
        67195
      ],
      [
        -6,
        1
      ],
      [
        -3,
        -14
      ],
      [
        -5,
        -13
      ],
      [
        -7,
        -30
      ],
      [
        -6,
        -10
      ],
      [
        -9,
        -7
      ],
      [
        -7,
        -25
      ],
      [
        -7,
        -12
      ],
      [
        -10,
        -5
      ],
      [
        -9,
        -12
      ],
      [
        -7,
        -1
      ],
      [
        -4,
        -21
      ],
      [
        -9,
        -21
      ],
      [
        -5,
        -4
      ],
      [
        -2,
        -11
      ],
      [
        -11,
        -13
      ],
      [
        -3,
        -11
      ],
      [
        -8,
        2
      ],
      [
        -3,
        7
      ],
      [
        -10,
        -1
      ],
      [
        -5,
        -13
      ]
    ],
    [
      [
        24515,
        66981
      ],
      [
        0,
        4
      ],
      [
        -3,
        32
      ],
      [
        -2,
        23
      ],
      [
        -1,
        27
      ],
      [
        0,
        3
      ],
      [
        -1,
        3
      ],
      [
        1,
        4
      ],
      [
        0,
        11
      ]
    ],
    [
      [
        24509,
        67088
      ],
      [
        1,
        28
      ],
      [
        -1,
        17
      ],
      [
        0,
        15
      ],
      [
        1,
        4
      ],
      [
        1,
        3
      ],
      [
        3,
        3
      ],
      [
        1,
        3
      ],
      [
        3,
        11
      ],
      [
        0,
        5
      ],
      [
        1,
        8
      ],
      [
        1,
        8
      ],
      [
        1,
        4
      ],
      [
        0,
        1
      ],
      [
        3,
        16
      ],
      [
        0,
        10
      ],
      [
        1,
        4
      ],
      [
        2,
        3
      ],
      [
        1,
        4
      ],
      [
        6,
        18
      ],
      [
        4,
        16
      ],
      [
        2,
        4
      ],
      [
        1,
        5
      ],
      [
        1,
        6
      ],
      [
        0,
        12
      ],
      [
        -1,
        1
      ],
      [
        -2,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        16
      ],
      [
        -2,
        9
      ],
      [
        -1,
        11
      ],
      [
        -6,
        25
      ],
      [
        -3,
        7
      ],
      [
        -4,
        8
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        -5,
        6
      ],
      [
        -4,
        7
      ],
      [
        -3,
        5
      ],
      [
        -2,
        2
      ],
      [
        -4,
        2
      ],
      [
        0,
        1
      ],
      [
        -1,
        3
      ],
      [
        -2,
        16
      ],
      [
        0,
        5
      ],
      [
        2,
        4
      ],
      [
        0,
        6
      ],
      [
        1,
        8
      ],
      [
        1,
        5
      ],
      [
        0,
        26
      ],
      [
        -1,
        4
      ],
      [
        0,
        4
      ],
      [
        -1,
        4
      ]
    ],
    [
      [
        27621,
        60896
      ],
      [
        4,
        -15
      ],
      [
        7,
        11
      ],
      [
        -3,
        9
      ],
      [
        0,
        19
      ],
      [
        3,
        26
      ],
      [
        -5,
        12
      ],
      [
        -3,
        -37
      ],
      [
        -3,
        -25
      ]
    ],
    [
      [
        27607,
        61119
      ],
      [
        8,
        -11
      ],
      [
        7,
        20
      ],
      [
        8,
        -7
      ],
      [
        11,
        0
      ],
      [
        12,
        -65
      ],
      [
        1,
        -6
      ],
      [
        23,
        -14
      ],
      [
        16,
        5
      ],
      [
        8,
        -20
      ],
      [
        8,
        -28
      ],
      [
        9,
        33
      ],
      [
        3,
        2
      ]
    ],
    [
      [
        27721,
        61028
      ],
      [
        5,
        1
      ],
      [
        7,
        -15
      ],
      [
        -6,
        -38
      ],
      [
        -4,
        -18
      ],
      [
        -9,
        -59
      ]
    ],
    [
      [
        27617,
        60764
      ],
      [
        -3,
        15
      ],
      [
        -15,
        -39
      ],
      [
        -5,
        -5
      ],
      [
        -11,
        -30
      ],
      [
        -7,
        22
      ],
      [
        -10,
        1
      ],
      [
        -4,
        13
      ]
    ],
    [
      [
        27562,
        60741
      ],
      [
        -6,
        12
      ],
      [
        -4,
        5
      ],
      [
        -2,
        3
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        3
      ],
      [
        -3,
        9
      ],
      [
        -3,
        31
      ],
      [
        0,
        1
      ],
      [
        -1,
        9
      ]
    ],
    [
      [
        27384,
        60509
      ],
      [
        0,
        -1
      ],
      [
        2,
        -2
      ],
      [
        1,
        -3
      ],
      [
        1,
        0
      ],
      [
        1,
        3
      ],
      [
        1,
        0
      ],
      [
        0,
        -2
      ],
      [
        7,
        -19
      ],
      [
        1,
        -2
      ],
      [
        0,
        -9
      ],
      [
        2,
        -3
      ],
      [
        3,
        0
      ],
      [
        2,
        -1
      ],
      [
        0,
        -7
      ],
      [
        2,
        -5
      ],
      [
        0,
        -1
      ],
      [
        2,
        -13
      ],
      [
        2,
        3
      ],
      [
        3,
        6
      ],
      [
        1,
        0
      ],
      [
        2,
        3
      ],
      [
        2,
        2
      ],
      [
        2,
        4
      ],
      [
        3,
        3
      ],
      [
        3,
        5
      ],
      [
        3,
        8
      ],
      [
        2,
        3
      ],
      [
        6,
        12
      ],
      [
        2,
        4
      ],
      [
        1,
        2
      ],
      [
        2,
        3
      ],
      [
        3,
        6
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        1,
        2
      ],
      [
        1,
        1
      ],
      [
        2,
        2
      ],
      [
        1,
        0
      ],
      [
        0,
        3
      ],
      [
        1,
        4
      ],
      [
        5,
        8
      ],
      [
        2,
        6
      ],
      [
        1,
        2
      ],
      [
        1,
        4
      ],
      [
        5,
        12
      ],
      [
        2,
        3
      ],
      [
        2,
        5
      ],
      [
        2,
        1
      ],
      [
        2,
        0
      ],
      [
        1,
        2
      ],
      [
        1,
        1
      ],
      [
        2,
        0
      ],
      [
        3,
        2
      ],
      [
        0,
        1
      ],
      [
        1,
        2
      ],
      [
        5,
        -28
      ],
      [
        -1,
        -15
      ],
      [
        0,
        -11
      ],
      [
        6,
        -14
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        27491,
        60504
      ],
      [
        11,
        -98
      ],
      [
        -3,
        -22
      ],
      [
        4,
        -5
      ]
    ],
    [
      [
        26844,
        52254
      ],
      [
        2,
        -15
      ],
      [
        7,
        8
      ],
      [
        5,
        -16
      ],
      [
        2,
        10
      ],
      [
        4,
        10
      ],
      [
        2,
        -15
      ],
      [
        4,
        13
      ],
      [
        4,
        1
      ],
      [
        2,
        11
      ],
      [
        -1,
        11
      ],
      [
        6,
        21
      ],
      [
        2,
        25
      ],
      [
        3,
        4
      ],
      [
        -2,
        40
      ],
      [
        -5,
        17
      ],
      [
        2,
        11
      ],
      [
        -5,
        9
      ],
      [
        0,
        11
      ],
      [
        -5,
        5
      ],
      [
        -2,
        37
      ],
      [
        -2,
        -2
      ],
      [
        -4,
        29
      ],
      [
        4,
        2
      ],
      [
        -4,
        32
      ],
      [
        6,
        17
      ],
      [
        0,
        12
      ],
      [
        5,
        16
      ]
    ],
    [
      [
        26938,
        52542
      ],
      [
        0,
        -521
      ]
    ],
    [
      [
        26938,
        52021
      ],
      [
        2,
        -15
      ],
      [
        -1,
        -21
      ],
      [
        -4,
        -10
      ],
      [
        -8,
        -9
      ],
      [
        -6,
        -16
      ],
      [
        -4,
        -24
      ],
      [
        -3,
        -41
      ],
      [
        -8,
        -11
      ],
      [
        -1,
        -23
      ],
      [
        2,
        -18
      ],
      [
        4,
        -13
      ],
      [
        6,
        -6
      ],
      [
        1,
        -21
      ]
    ],
    [
      [
        26882,
        51664
      ],
      [
        -9,
        5
      ],
      [
        -5,
        15
      ],
      [
        -7,
        15
      ],
      [
        -5,
        24
      ],
      [
        -1,
        21
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        17
      ],
      [
        1,
        19
      ],
      [
        -3,
        -2
      ],
      [
        -3,
        11
      ],
      [
        -2,
        -4
      ]
    ],
    [
      [
        31470,
        38195
      ],
      [
        9,
        27
      ],
      [
        4,
        -3
      ]
    ],
    [
      [
        31501,
        38239
      ],
      [
        4,
        7
      ]
    ],
    [
      [
        31491,
        38138
      ],
      [
        -7,
        -14
      ],
      [
        -1,
        35
      ],
      [
        -7,
        -5
      ]
    ],
    [
      [
        31372,
        38083
      ],
      [
        3,
        -9
      ],
      [
        6,
        27
      ],
      [
        -2,
        55
      ],
      [
        5,
        36
      ],
      [
        9,
        -13
      ],
      [
        4,
        14
      ]
    ],
    [
      [
        31419,
        38095
      ],
      [
        -11,
        -12
      ],
      [
        -2,
        10
      ],
      [
        -6,
        6
      ]
    ],
    [
      [
        23996,
        69196
      ],
      [
        -5,
        10
      ],
      [
        -3,
        21
      ],
      [
        -1,
        2
      ],
      [
        -22,
        0
      ],
      [
        -2,
        -18
      ],
      [
        -5,
        -13
      ],
      [
        -4,
        -5
      ],
      [
        -3,
        0
      ]
    ],
    [
      [
        23951,
        69193
      ],
      [
        1,
        6
      ],
      [
        -5,
        14
      ],
      [
        -2,
        4
      ],
      [
        0,
        46
      ],
      [
        -2,
        5
      ],
      [
        0,
        97
      ],
      [
        -5,
        -1
      ]
    ],
    [
      [
        23938,
        69364
      ],
      [
        0,
        104
      ],
      [
        11,
        0
      ],
      [
        22,
        -1
      ],
      [
        24,
        0
      ]
    ],
    [
      [
        19271,
        63277
      ],
      [
        0,
        1168
      ]
    ],
    [
      [
        19530,
        64274
      ],
      [
        0,
        -143
      ],
      [
        -1,
        -46
      ],
      [
        0,
        -323
      ]
    ],
    [
      [
        19529,
        63762
      ],
      [
        0,
        -655
      ]
    ],
    [
      [
        19529,
        62918
      ],
      [
        -5,
        -2
      ],
      [
        -1,
        4
      ],
      [
        -1,
        -12
      ],
      [
        -3,
        4
      ],
      [
        -2,
        -24
      ],
      [
        -3,
        -12
      ],
      [
        -236,
        9
      ],
      [
        -20,
        0
      ]
    ],
    [
      [
        19258,
        62885
      ],
      [
        3,
        26
      ],
      [
        -2,
        10
      ],
      [
        -2,
        27
      ],
      [
        -6,
        11
      ],
      [
        5,
        5
      ],
      [
        1,
        19
      ],
      [
        -3,
        15
      ],
      [
        6,
        21
      ],
      [
        -3,
        19
      ],
      [
        5,
        28
      ],
      [
        4,
        1
      ],
      [
        -4,
        13
      ],
      [
        0,
        11
      ],
      [
        4,
        0
      ],
      [
        3,
        21
      ],
      [
        -1,
        23
      ],
      [
        -4,
        -2
      ],
      [
        3,
        24
      ],
      [
        6,
        4
      ],
      [
        -6,
        38
      ],
      [
        7,
        4
      ],
      [
        2,
        -22
      ],
      [
        3,
        -5
      ],
      [
        -1,
        17
      ],
      [
        3,
        19
      ],
      [
        4,
        0
      ],
      [
        2,
        28
      ],
      [
        -3,
        25
      ],
      [
        3,
        -11
      ],
      [
        7,
        3
      ],
      [
        5,
        -7
      ],
      [
        1,
        8
      ],
      [
        -5,
        9
      ],
      [
        2,
        10
      ],
      [
        -26,
        0
      ]
    ],
    [
      [
        27587,
        60154
      ],
      [
        12,
        44
      ],
      [
        1,
        0
      ],
      [
        21,
        13
      ],
      [
        1,
        -5
      ],
      [
        1,
        -19
      ],
      [
        10,
        -17
      ],
      [
        12,
        28
      ],
      [
        7,
        24
      ],
      [
        4,
        32
      ],
      [
        8,
        7
      ],
      [
        2,
        12
      ]
    ],
    [
      [
        27666,
        60273
      ],
      [
        4,
        -11
      ],
      [
        4,
        12
      ],
      [
        3,
        -13
      ],
      [
        7,
        20
      ],
      [
        1,
        -35
      ],
      [
        6,
        -14
      ],
      [
        8,
        1
      ],
      [
        1,
        1
      ],
      [
        5,
        -47
      ],
      [
        1,
        15
      ],
      [
        4,
        -18
      ],
      [
        3,
        7
      ],
      [
        7,
        -33
      ],
      [
        3,
        -28
      ],
      [
        7,
        -12
      ],
      [
        -2,
        -12
      ],
      [
        8,
        -34
      ],
      [
        0,
        -12
      ]
    ],
    [
      [
        27736,
        60060
      ],
      [
        -5,
        -79
      ],
      [
        -8,
        -138
      ]
    ],
    [
      [
        27612,
        59771
      ],
      [
        -9,
        34
      ],
      [
        2,
        21
      ],
      [
        -10,
        6
      ],
      [
        -38,
        30
      ]
    ],
    [
      [
        6166,
        41601
      ],
      [
        5,
        -3
      ],
      [
        2,
        3
      ],
      [
        1,
        5
      ],
      [
        1,
        21
      ],
      [
        0,
        5
      ],
      [
        3,
        8
      ],
      [
        1,
        -2
      ],
      [
        2,
        -6
      ],
      [
        3,
        -23
      ],
      [
        0,
        -11
      ],
      [
        1,
        -8
      ],
      [
        8,
        -9
      ]
    ],
    [
      [
        23415,
        62959
      ],
      [
        3,
        -10
      ],
      [
        3,
        -9
      ],
      [
        1,
        -4
      ],
      [
        5,
        -8
      ],
      [
        1,
        -3
      ],
      [
        1,
        -4
      ],
      [
        1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        1,
        -16
      ],
      [
        0,
        -9
      ],
      [
        2,
        -8
      ],
      [
        1,
        -3
      ],
      [
        1,
        -3
      ],
      [
        1,
        -3
      ],
      [
        4,
        -6
      ],
      [
        5,
        -6
      ],
      [
        2,
        -2
      ],
      [
        2,
        -7
      ],
      [
        1,
        -5
      ],
      [
        0,
        -11
      ],
      [
        2,
        -6
      ],
      [
        1,
        -3
      ]
    ],
    [
      [
        23453,
        62826
      ],
      [
        -59,
        1
      ]
    ],
    [
      [
        29823,
        65864
      ],
      [
        1,
        0
      ],
      [
        10,
        -1
      ],
      [
        21,
        -1
      ],
      [
        7,
        -1
      ],
      [
        20,
        -2
      ],
      [
        2,
        0
      ],
      [
        23,
        -1
      ],
      [
        1,
        -18
      ]
    ],
    [
      [
        29911,
        65412
      ],
      [
        -19,
        5
      ],
      [
        -8,
        -4
      ],
      [
        -18,
        -8
      ],
      [
        -2,
        1
      ],
      [
        -5,
        4
      ],
      [
        -2,
        1
      ],
      [
        -38,
        26
      ],
      [
        0,
        2
      ],
      [
        -9,
        5
      ],
      [
        -2,
        -12
      ],
      [
        -8,
        21
      ],
      [
        -7,
        22
      ],
      [
        -8,
        23
      ]
    ],
    [
      [
        29785,
        65498
      ],
      [
        -2,
        10
      ],
      [
        -1,
        6
      ],
      [
        15,
        0
      ],
      [
        3,
        32
      ],
      [
        8,
        -2
      ],
      [
        -2,
        95
      ],
      [
        -15,
        0
      ],
      [
        0,
        143
      ],
      [
        19,
        1
      ],
      [
        14,
        0
      ],
      [
        -1,
        81
      ]
    ],
    [
      [
        29722,
        65346
      ],
      [
        10,
        6
      ],
      [
        4,
        2
      ],
      [
        2,
        14
      ]
    ],
    [
      [
        29738,
        65368
      ],
      [
        7,
        -16
      ],
      [
        2,
        15
      ],
      [
        14,
        4
      ],
      [
        1,
        16
      ],
      [
        -3,
        29
      ],
      [
        8,
        12
      ],
      [
        11,
        27
      ],
      [
        -2,
        18
      ],
      [
        6,
        8
      ],
      [
        2,
        17
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        29911,
        65361
      ],
      [
        -1,
        -81
      ],
      [
        -1,
        -25
      ],
      [
        -1,
        -103
      ],
      [
        -5,
        3
      ],
      [
        -6,
        -9
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -17
      ],
      [
        2,
        -13
      ],
      [
        1,
        -5
      ],
      [
        0,
        -11
      ],
      [
        -2,
        -8
      ],
      [
        2,
        -22
      ],
      [
        -2,
        -12
      ],
      [
        -6,
        -17
      ]
    ],
    [
      [
        29891,
        65039
      ],
      [
        0,
        3
      ],
      [
        -2,
        10
      ],
      [
        -5,
        6
      ],
      [
        -9,
        -5
      ],
      [
        -1,
        3
      ],
      [
        -1,
        1
      ],
      [
        -3,
        3
      ],
      [
        -3,
        0
      ],
      [
        -3,
        -9
      ],
      [
        -4,
        -7
      ],
      [
        -2,
        7
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -11
      ],
      [
        -9,
        -4
      ],
      [
        -17,
        3
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -7
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -7
      ],
      [
        -6,
        0
      ],
      [
        -8,
        13
      ],
      [
        -4,
        8
      ],
      [
        -1,
        6
      ],
      [
        -1,
        2
      ],
      [
        -2,
        -1
      ],
      [
        -3,
        -9
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -16
      ],
      [
        -2,
        -9
      ],
      [
        -4,
        9
      ],
      [
        -3,
        1
      ],
      [
        -3,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -10
      ],
      [
        -3,
        -8
      ],
      [
        -16,
        -6
      ],
      [
        -2,
        1
      ],
      [
        -2,
        5
      ],
      [
        -2,
        -3
      ]
    ],
    [
      [
        15680,
        69692
      ],
      [
        6,
        0
      ],
      [
        0,
        34
      ],
      [
        11,
        0
      ],
      [
        0,
        -17
      ],
      [
        17,
        0
      ],
      [
        0,
        118
      ]
    ],
    [
      [
        15714,
        69827
      ],
      [
        27,
        0
      ],
      [
        1,
        10
      ],
      [
        -5,
        19
      ],
      [
        6,
        4
      ],
      [
        183,
        0
      ],
      [
        3,
        -1
      ],
      [
        43,
        1
      ]
    ],
    [
      [
        15972,
        69860
      ],
      [
        3,
        -8
      ],
      [
        0,
        -22
      ],
      [
        4,
        -24
      ],
      [
        5,
        -14
      ],
      [
        14,
        -11
      ],
      [
        8,
        -23
      ],
      [
        -2,
        -49
      ],
      [
        7,
        -40
      ],
      [
        -5,
        -46
      ]
    ],
    [
      [
        16006,
        69623
      ],
      [
        5,
        -8
      ],
      [
        -1,
        -25
      ],
      [
        -4,
        -3
      ],
      [
        -5,
        -18
      ],
      [
        -9,
        -7
      ],
      [
        4,
        -40
      ],
      [
        2,
        -14
      ],
      [
        4,
        -7
      ],
      [
        1,
        -22
      ],
      [
        4,
        -20
      ],
      [
        8,
        3
      ],
      [
        4,
        -36
      ],
      [
        -2,
        -26
      ],
      [
        -8,
        1
      ],
      [
        -10,
        -24
      ],
      [
        1,
        -10
      ],
      [
        -6,
        -4
      ],
      [
        -11,
        3
      ],
      [
        -1,
        -25
      ],
      [
        -6,
        -5
      ],
      [
        1,
        -33
      ],
      [
        4,
        -44
      ],
      [
        10,
        -17
      ],
      [
        1,
        -18
      ],
      [
        9,
        -11
      ],
      [
        -5,
        -23
      ]
    ],
    [
      [
        23769,
        53708
      ],
      [
        -14,
        18
      ],
      [
        -4,
        12
      ],
      [
        -20,
        -46
      ],
      [
        -4,
        -3
      ]
    ],
    [
      [
        23597,
        54009
      ],
      [
        -3,
        12
      ],
      [
        -1,
        28
      ],
      [
        -4,
        27
      ],
      [
        -9,
        26
      ],
      [
        0,
        58
      ]
    ],
    [
      [
        27320,
        64552
      ],
      [
        53,
        -1
      ],
      [
        0,
        34
      ],
      [
        21,
        0
      ],
      [
        0,
        -34
      ],
      [
        84,
        0
      ]
    ],
    [
      [
        27478,
        64246
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        0
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        -6
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        1
      ],
      [
        -2,
        8
      ],
      [
        0,
        2
      ],
      [
        -2,
        1
      ],
      [
        -1,
        0
      ],
      [
        -4,
        -4
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -9
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        -6
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -6
      ]
    ],
    [
      [
        27437,
        64181
      ],
      [
        -22,
        1
      ],
      [
        0,
        16
      ],
      [
        -32,
        2
      ]
    ],
    [
      [
        27320,
        64350
      ],
      [
        0,
        202
      ]
    ],
    [
      [
        16598,
        59415
      ],
      [
        13,
        0
      ],
      [
        -1,
        -101
      ],
      [
        15,
        -1
      ],
      [
        0,
        -153
      ],
      [
        -15,
        0
      ],
      [
        -2,
        -153
      ],
      [
        0,
        -406
      ]
    ],
    [
      [
        16425,
        58601
      ],
      [
        -6,
        0
      ]
    ],
    [
      [
        15358,
        63504
      ],
      [
        133,
        1
      ]
    ],
    [
      [
        15660,
        63268
      ],
      [
        0,
        -59
      ],
      [
        7,
        0
      ],
      [
        0,
        -45
      ],
      [
        6,
        0
      ],
      [
        1,
        -100
      ],
      [
        1,
        -14
      ],
      [
        0,
        -36
      ]
    ],
    [
      [
        15675,
        63014
      ],
      [
        -1,
        -60
      ],
      [
        -13,
        2
      ],
      [
        0,
        -16
      ],
      [
        -25,
        2
      ],
      [
        -11,
        -17
      ],
      [
        0,
        -60
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -53
      ],
      [
        5,
        0
      ],
      [
        0,
        -34
      ],
      [
        2,
        -17
      ],
      [
        3,
        0
      ],
      [
        0,
        -32
      ],
      [
        6,
        -17
      ],
      [
        0,
        -51
      ],
      [
        4,
        0
      ],
      [
        0,
        -24
      ],
      [
        3,
        -1
      ],
      [
        -1,
        -24
      ],
      [
        -5,
        1
      ],
      [
        1,
        -18
      ],
      [
        -8,
        -33
      ],
      [
        -2,
        -22
      ],
      [
        -9,
        0
      ],
      [
        0,
        -41
      ],
      [
        -2,
        0
      ],
      [
        0,
        -51
      ],
      [
        -2,
        -27
      ],
      [
        8,
        -8
      ],
      [
        2,
        -19
      ],
      [
        0,
        -32
      ],
      [
        8,
        -28
      ],
      [
        12,
        0
      ],
      [
        2,
        -16
      ],
      [
        0,
        -42
      ],
      [
        2,
        -17
      ],
      [
        6,
        -8
      ],
      [
        0,
        -30
      ],
      [
        11,
        2
      ],
      [
        5,
        -7
      ],
      [
        -1,
        -17
      ],
      [
        5,
        -9
      ],
      [
        11,
        -8
      ],
      [
        5,
        -19
      ]
    ],
    [
      [
        15693,
        62164
      ],
      [
        -73,
        3
      ],
      [
        0,
        -17
      ],
      [
        -15,
        2
      ],
      [
        0,
        -36
      ],
      [
        -65,
        -3
      ],
      [
        0,
        -34
      ],
      [
        -21,
        0
      ],
      [
        -15,
        2
      ],
      [
        -6,
        -23
      ],
      [
        -4,
        11
      ]
    ],
    [
      [
        15494,
        62069
      ],
      [
        -2,
        10
      ],
      [
        -8,
        25
      ],
      [
        -3,
        5
      ],
      [
        -1,
        0
      ],
      [
        -4,
        13
      ],
      [
        -1,
        6
      ],
      [
        -1,
        4
      ],
      [
        -9,
        25
      ],
      [
        -1,
        0
      ],
      [
        -1,
        2
      ],
      [
        -2,
        10
      ],
      [
        0,
        13
      ],
      [
        -2,
        8
      ],
      [
        -8,
        25
      ],
      [
        -6,
        23
      ],
      [
        -4,
        4
      ],
      [
        -1,
        14
      ],
      [
        1,
        8
      ],
      [
        -4,
        21
      ],
      [
        2,
        1
      ],
      [
        1,
        2
      ],
      [
        2,
        9
      ],
      [
        3,
        15
      ],
      [
        4,
        32
      ],
      [
        2,
        19
      ],
      [
        0,
        12
      ],
      [
        -1,
        30
      ],
      [
        -6,
        60
      ],
      [
        -2,
        19
      ],
      [
        -4,
        17
      ],
      [
        -1,
        5
      ],
      [
        -1,
        25
      ],
      [
        -5,
        31
      ],
      [
        -1,
        2
      ],
      [
        -3,
        21
      ],
      [
        -1,
        30
      ],
      [
        -3,
        31
      ],
      [
        -3,
        8
      ],
      [
        -1,
        9
      ],
      [
        1,
        6
      ],
      [
        -1,
        9
      ],
      [
        -2,
        25
      ],
      [
        1,
        13
      ],
      [
        -3,
        17
      ],
      [
        -1,
        6
      ],
      [
        -1,
        20
      ],
      [
        0,
        9
      ],
      [
        1,
        13
      ],
      [
        0,
        31
      ],
      [
        2,
        46
      ],
      [
        5,
        54
      ],
      [
        4,
        20
      ],
      [
        1,
        14
      ],
      [
        3,
        36
      ],
      [
        0,
        8
      ],
      [
        -5,
        52
      ],
      [
        1,
        6
      ],
      [
        0,
        14
      ],
      [
        -1,
        45
      ],
      [
        -2,
        28
      ],
      [
        -4,
        31
      ],
      [
        -5,
        9
      ],
      [
        -1,
        5
      ],
      [
        -1,
        9
      ],
      [
        -1,
        10
      ],
      [
        0,
        43
      ],
      [
        -1,
        23
      ],
      [
        -3,
        42
      ],
      [
        -1,
        3
      ],
      [
        -8,
        13
      ],
      [
        -7,
        20
      ],
      [
        -2,
        14
      ],
      [
        0,
        7
      ],
      [
        -4,
        34
      ],
      [
        -7,
        14
      ],
      [
        -2,
        18
      ],
      [
        -5,
        29
      ],
      [
        -4,
        12
      ],
      [
        -8,
        33
      ]
    ],
    [
      [
        20752,
        62489
      ],
      [
        -65,
        1
      ],
      [
        -38,
        0
      ]
    ],
    [
      [
        22428,
        51565
      ],
      [
        -1,
        11
      ],
      [
        -3,
        -14
      ],
      [
        -11,
        -6
      ],
      [
        -10,
        -20
      ],
      [
        -1,
        -4
      ],
      [
        -11,
        4
      ]
    ],
    [
      [
        22391,
        51536
      ],
      [
        -39,
        72
      ]
    ],
    [
      [
        23919,
        59426
      ],
      [
        123,
        0
      ]
    ],
    [
      [
        24042,
        59426
      ],
      [
        0,
        -39
      ],
      [
        -6,
        13
      ],
      [
        -3,
        18
      ],
      [
        -1,
        -184
      ],
      [
        0,
        -255
      ]
    ],
    [
      [
        24017,
        58980
      ],
      [
        -3,
        1
      ],
      [
        -27,
        1
      ],
      [
        -10,
        3
      ],
      [
        -15,
        -2
      ],
      [
        -35,
        3
      ],
      [
        -10,
        2
      ]
    ],
    [
      [
        22758,
        59038
      ],
      [
        30,
        0
      ],
      [
        0,
        -6
      ]
    ],
    [
      [
        22788,
        59032
      ],
      [
        0,
        -203
      ],
      [
        9,
        30
      ],
      [
        8,
        -6
      ],
      [
        2,
        -29
      ],
      [
        3,
        -9
      ],
      [
        9,
        -1
      ],
      [
        6,
        -9
      ],
      [
        5,
        -23
      ],
      [
        9,
        -4
      ],
      [
        8,
        15
      ],
      [
        1,
        -14
      ]
    ],
    [
      [
        22847,
        58526
      ],
      [
        -29,
        0
      ],
      [
        -35,
        1
      ],
      [
        -84,
        0
      ]
    ],
    [
      [
        28805,
        67542
      ],
      [
        62,
        -59
      ],
      [
        40,
        77
      ],
      [
        46,
        89
      ],
      [
        32,
        62
      ]
    ],
    [
      [
        28957,
        66855
      ],
      [
        -8,
        -3
      ],
      [
        -2,
        -7
      ]
    ],
    [
      [
        28947,
        66845
      ],
      [
        -53,
        -9
      ],
      [
        -5,
        81
      ],
      [
        -24,
        -2
      ],
      [
        -2,
        104
      ],
      [
        -1,
        20
      ],
      [
        -12,
        -3
      ],
      [
        -1,
        30
      ],
      [
        -11,
        22
      ],
      [
        0,
        18
      ],
      [
        -4,
        22
      ],
      [
        -4,
        1
      ],
      [
        -3,
        14
      ],
      [
        -8,
        12
      ],
      [
        0,
        16
      ],
      [
        -5,
        13
      ],
      [
        -8,
        -4
      ],
      [
        -4,
        13
      ],
      [
        -8,
        -13
      ],
      [
        -12,
        2
      ],
      [
        -8,
        -16
      ],
      [
        -4,
        10
      ]
    ],
    [
      [
        26591,
        57972
      ],
      [
        6,
        32
      ],
      [
        1,
        4
      ]
    ],
    [
      [
        26693,
        58068
      ],
      [
        2,
        -18
      ],
      [
        3,
        -5
      ],
      [
        -1,
        -12
      ],
      [
        3,
        -23
      ],
      [
        -1,
        -19
      ],
      [
        5,
        -11
      ],
      [
        1,
        -15
      ],
      [
        4,
        -16
      ],
      [
        10,
        3
      ],
      [
        1,
        8
      ],
      [
        5,
        0
      ],
      [
        2,
        -18
      ],
      [
        -1,
        -35
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -35
      ],
      [
        10,
        -28
      ],
      [
        3,
        -29
      ],
      [
        8,
        -18
      ],
      [
        1,
        -18
      ],
      [
        -4,
        0
      ],
      [
        -4,
        -10
      ],
      [
        1,
        -10
      ],
      [
        6,
        -8
      ],
      [
        6,
        -36
      ],
      [
        0,
        -9
      ],
      [
        5,
        -7
      ],
      [
        0,
        -10
      ]
    ],
    [
      [
        26757,
        57683
      ],
      [
        -23,
        -1
      ],
      [
        -37,
        -4
      ],
      [
        -44,
        -3
      ]
    ],
    [
      [
        26653,
        57675
      ],
      [
        -8,
        13
      ],
      [
        -2,
        -10
      ],
      [
        -3,
        15
      ],
      [
        2,
        11
      ],
      [
        -6,
        23
      ],
      [
        -4,
        0
      ],
      [
        -3,
        15
      ],
      [
        2,
        9
      ],
      [
        -7,
        27
      ],
      [
        0,
        11
      ],
      [
        -9,
        17
      ],
      [
        0,
        26
      ],
      [
        -5,
        -8
      ],
      [
        -2,
        20
      ],
      [
        -5,
        25
      ],
      [
        -1,
        -12
      ],
      [
        -5,
        9
      ],
      [
        -5,
        -6
      ],
      [
        -4,
        3
      ],
      [
        -3,
        -12
      ],
      [
        -3,
        13
      ]
    ],
    [
      [
        26582,
        57864
      ],
      [
        1,
        26
      ],
      [
        6,
        20
      ],
      [
        -5,
        5
      ],
      [
        9,
        30
      ],
      [
        2,
        20
      ],
      [
        -4,
        7
      ]
    ],
    [
      [
        29216,
        68299
      ],
      [
        53,
        20
      ],
      [
        -8,
        198
      ],
      [
        -6,
        116
      ],
      [
        65,
        26
      ]
    ],
    [
      [
        29320,
        68659
      ],
      [
        58,
        19
      ],
      [
        9,
        -5
      ],
      [
        11,
        19
      ],
      [
        4,
        -4
      ],
      [
        12,
        13
      ],
      [
        5,
        20
      ],
      [
        8,
        6
      ],
      [
        8,
        -2
      ],
      [
        2,
        15
      ],
      [
        8,
        24
      ],
      [
        -1,
        21
      ],
      [
        35,
        10
      ]
    ],
    [
      [
        29479,
        68795
      ],
      [
        0,
        -4
      ],
      [
        2,
        -8
      ],
      [
        0,
        -6
      ],
      [
        1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -15
      ],
      [
        2,
        -6
      ],
      [
        2,
        -8
      ],
      [
        0,
        -9
      ],
      [
        1,
        -8
      ],
      [
        1,
        -10
      ],
      [
        0,
        -26
      ],
      [
        1,
        -10
      ],
      [
        1,
        -6
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -12
      ],
      [
        -4,
        -29
      ],
      [
        -1,
        -10
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        -3,
        -7
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -18
      ],
      [
        2,
        -14
      ],
      [
        0,
        -1
      ],
      [
        1,
        -6
      ],
      [
        0,
        -33
      ],
      [
        1,
        -10
      ],
      [
        1,
        -16
      ],
      [
        1,
        -9
      ],
      [
        1,
        -7
      ],
      [
        -1,
        -10
      ],
      [
        0,
        -2
      ]
    ],
    [
      [
        29486,
        68466
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -10
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -3
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        1,
        -9
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -4
      ],
      [
        0,
        -12
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -11
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -2
      ],
      [
        1,
        -6
      ],
      [
        1,
        -10
      ],
      [
        0,
        -6
      ],
      [
        -2,
        -15
      ],
      [
        -3,
        -24
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -9
      ],
      [
        -2,
        -22
      ],
      [
        1,
        -3
      ],
      [
        1,
        -4
      ],
      [
        1,
        -1
      ],
      [
        1,
        -6
      ],
      [
        1,
        -1
      ],
      [
        2,
        -3
      ],
      [
        1,
        -3
      ],
      [
        1,
        -6
      ],
      [
        0,
        -12
      ],
      [
        -1,
        -29
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        1,
        -6
      ],
      [
        1,
        -9
      ],
      [
        0,
        -22
      ],
      [
        -1,
        -18
      ],
      [
        1,
        -4
      ],
      [
        2,
        -15
      ],
      [
        1,
        -13
      ],
      [
        0,
        -3
      ],
      [
        3,
        -14
      ],
      [
        2,
        -12
      ],
      [
        1,
        -6
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -11
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -8
      ],
      [
        2,
        -5
      ],
      [
        1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -2
      ],
      [
        1,
        -4
      ],
      [
        2,
        -4
      ],
      [
        0,
        -3
      ],
      [
        1,
        -3
      ]
    ],
    [
      [
        29468,
        67936
      ],
      [
        -17,
        -6
      ]
    ],
    [
      [
        29451,
        67930
      ],
      [
        -172,
        -69
      ]
    ],
    [
      [
        29279,
        67861
      ],
      [
        3,
        61
      ],
      [
        -11,
        14
      ],
      [
        -5,
        -4
      ],
      [
        -10,
        15
      ],
      [
        -3,
        14
      ],
      [
        -15,
        -11
      ],
      [
        -3,
        -11
      ],
      [
        -34,
        133
      ],
      [
        22,
        52
      ],
      [
        -7,
        175
      ]
    ],
    [
      [
        27759,
        61385
      ],
      [
        -4,
        -12
      ],
      [
        0,
        -22
      ],
      [
        5,
        4
      ],
      [
        8,
        18
      ],
      [
        6,
        -9
      ],
      [
        6,
        0
      ],
      [
        -2,
        -18
      ],
      [
        -7,
        -27
      ],
      [
        -7,
        -33
      ],
      [
        3,
        -11
      ]
    ],
    [
      [
        27767,
        61275
      ],
      [
        -7,
        -41
      ],
      [
        -4,
        -12
      ],
      [
        3,
        -6
      ],
      [
        -6,
        -38
      ],
      [
        -13,
        -57
      ],
      [
        -8,
        -22
      ],
      [
        -11,
        -71
      ]
    ],
    [
      [
        27085,
        61204
      ],
      [
        7,
        5
      ],
      [
        -13,
        11
      ],
      [
        -5,
        13
      ],
      [
        2,
        46
      ],
      [
        5,
        22
      ],
      [
        -2,
        12
      ],
      [
        3,
        22
      ],
      [
        4,
        17
      ],
      [
        7,
        -13
      ],
      [
        7,
        -5
      ],
      [
        -3,
        17
      ],
      [
        0,
        19
      ],
      [
        4,
        -5
      ],
      [
        1,
        15
      ],
      [
        5,
        -4
      ],
      [
        0,
        14
      ],
      [
        5,
        28
      ]
    ],
    [
      [
        27112,
        61418
      ],
      [
        4,
        -26
      ],
      [
        5,
        -9
      ],
      [
        -3,
        23
      ],
      [
        1,
        11
      ],
      [
        7,
        7
      ],
      [
        0,
        19
      ],
      [
        5,
        -4
      ],
      [
        3,
        -26
      ],
      [
        5,
        -8
      ],
      [
        3,
        27
      ],
      [
        8,
        8
      ],
      [
        3,
        -12
      ],
      [
        8,
        7
      ],
      [
        4,
        -4
      ],
      [
        -2,
        -20
      ],
      [
        1,
        -21
      ],
      [
        4,
        -9
      ],
      [
        9,
        -4
      ],
      [
        3,
        -23
      ],
      [
        6,
        -20
      ],
      [
        4,
        5
      ],
      [
        6,
        -23
      ],
      [
        5,
        -11
      ],
      [
        -5,
        -18
      ],
      [
        -1,
        -24
      ],
      [
        9,
        -18
      ],
      [
        4,
        8
      ],
      [
        8,
        -47
      ],
      [
        -1,
        -21
      ],
      [
        2,
        -25
      ]
    ],
    [
      [
        27217,
        61160
      ],
      [
        -9,
        -8
      ],
      [
        -5,
        9
      ],
      [
        -5,
        -20
      ],
      [
        -4,
        0
      ],
      [
        -4,
        -20
      ],
      [
        0,
        -9
      ],
      [
        -5,
        -22
      ],
      [
        3,
        -10
      ],
      [
        -1,
        -19
      ],
      [
        3,
        -10
      ],
      [
        -3,
        -12
      ],
      [
        1,
        -49
      ],
      [
        3,
        -20
      ],
      [
        6,
        -3
      ],
      [
        4,
        -4
      ],
      [
        0,
        -32
      ]
    ],
    [
      [
        27201,
        60931
      ],
      [
        -4,
        -1
      ],
      [
        -10,
        -26
      ],
      [
        -3,
        -5
      ],
      [
        -9,
        30
      ]
    ],
    [
      [
        27238,
        61139
      ],
      [
        14,
        223
      ],
      [
        1,
        10
      ],
      [
        0,
        15
      ],
      [
        4,
        -2
      ],
      [
        23,
        96
      ]
    ],
    [
      [
        27280,
        61481
      ],
      [
        8,
        -17
      ],
      [
        3,
        1
      ],
      [
        4,
        -19
      ],
      [
        7,
        -8
      ],
      [
        5,
        10
      ],
      [
        7,
        -26
      ],
      [
        7,
        -10
      ],
      [
        3,
        -9
      ],
      [
        1,
        16
      ],
      [
        5,
        4
      ],
      [
        -2,
        11
      ],
      [
        9,
        15
      ],
      [
        -2,
        -18
      ],
      [
        7,
        -17
      ],
      [
        0,
        18
      ],
      [
        7,
        2
      ],
      [
        4,
        -9
      ],
      [
        7,
        -25
      ],
      [
        -2,
        -30
      ],
      [
        14,
        -53
      ],
      [
        5,
        13
      ],
      [
        0,
        -35
      ]
    ],
    [
      [
        27360,
        60964
      ],
      [
        -9,
        16
      ],
      [
        -14,
        -4
      ],
      [
        -8,
        7
      ],
      [
        1,
        27
      ],
      [
        -11,
        -9
      ],
      [
        -3,
        10
      ],
      [
        8,
        1
      ],
      [
        0,
        18
      ],
      [
        -62,
        16
      ],
      [
        -2,
        51
      ],
      [
        2,
        12
      ],
      [
        -7,
        10
      ],
      [
        -7,
        28
      ],
      [
        -10,
        -8
      ]
    ],
    [
      [
        27150,
        61904
      ],
      [
        18,
        -84
      ],
      [
        15,
        26
      ],
      [
        16,
        42
      ]
    ],
    [
      [
        27199,
        61888
      ],
      [
        4,
        -35
      ],
      [
        6,
        -26
      ],
      [
        4,
        -17
      ],
      [
        2,
        5
      ],
      [
        32,
        -10
      ],
      [
        13,
        -8
      ],
      [
        8,
        -15
      ],
      [
        15,
        12
      ],
      [
        7,
        -5
      ]
    ],
    [
      [
        27238,
        61139
      ],
      [
        -9,
        5
      ],
      [
        -6,
        -7
      ],
      [
        -6,
        13
      ],
      [
        0,
        10
      ]
    ],
    [
      [
        27112,
        61418
      ],
      [
        0,
        16
      ],
      [
        7,
        -3
      ],
      [
        0,
        43
      ],
      [
        2,
        8
      ],
      [
        -1,
        34
      ],
      [
        -3,
        26
      ],
      [
        -4,
        8
      ],
      [
        -5,
        -11
      ],
      [
        -10,
        2
      ],
      [
        -9,
        13
      ]
    ],
    [
      [
        27089,
        61554
      ],
      [
        4,
        66
      ],
      [
        1,
        19
      ],
      [
        5,
        11
      ],
      [
        8,
        16
      ],
      [
        3,
        5
      ],
      [
        4,
        5
      ],
      [
        1,
        -1
      ],
      [
        27,
        42
      ],
      [
        0,
        11
      ],
      [
        -4,
        49
      ],
      [
        -4,
        7
      ],
      [
        2,
        35
      ],
      [
        -2,
        32
      ],
      [
        5,
        21
      ],
      [
        2,
        -3
      ],
      [
        9,
        35
      ]
    ],
    [
      [
        31591,
        38232
      ],
      [
        1,
        7
      ]
    ],
    [
      [
        31592,
        38239
      ],
      [
        5,
        -27
      ],
      [
        5,
        -7
      ],
      [
        5,
        6
      ],
      [
        2,
        15
      ],
      [
        3,
        -13
      ],
      [
        5,
        16
      ],
      [
        8,
        -6
      ],
      [
        4,
        6
      ]
    ],
    [
      [
        31629,
        38229
      ],
      [
        0,
        -15
      ],
      [
        4,
        -16
      ],
      [
        1,
        -2
      ],
      [
        8,
        -12
      ],
      [
        -4,
        -25
      ],
      [
        -3,
        -18
      ],
      [
        -3,
        -2
      ],
      [
        0,
        1
      ],
      [
        -2,
        18
      ],
      [
        -6,
        2
      ],
      [
        1,
        -5
      ],
      [
        2,
        -23
      ],
      [
        -2,
        -6
      ],
      [
        -7,
        8
      ]
    ],
    [
      [
        31618,
        38134
      ],
      [
        1,
        18
      ],
      [
        -10,
        19
      ],
      [
        3,
        16
      ],
      [
        -6,
        8
      ],
      [
        -5,
        -8
      ],
      [
        -8,
        12
      ],
      [
        -4,
        20
      ]
    ],
    [
      [
        31354,
        38275
      ],
      [
        2,
        14
      ],
      [
        3,
        -2
      ]
    ],
    [
      [
        31375,
        38302
      ],
      [
        1,
        -1
      ],
      [
        5,
        14
      ],
      [
        8,
        4
      ],
      [
        3,
        2
      ],
      [
        3,
        5
      ]
    ],
    [
      [
        19529,
        63762
      ],
      [
        119,
        -1
      ],
      [
        271,
        2
      ],
      [
        2,
        1
      ],
      [
        42,
        -5
      ],
      [
        15,
        0
      ],
      [
        0,
        4
      ]
    ],
    [
      [
        25845,
        62734
      ],
      [
        -23,
        -2
      ],
      [
        -31,
        2
      ],
      [
        -15,
        1
      ],
      [
        0,
        7
      ]
    ],
    [
      [
        25760,
        62886
      ],
      [
        0,
        60
      ],
      [
        7,
        22
      ],
      [
        4,
        29
      ],
      [
        -3,
        16
      ],
      [
        0,
        26
      ]
    ],
    [
      [
        24179,
        53953
      ],
      [
        0,
        14
      ],
      [
        6,
        6
      ],
      [
        0,
        23
      ],
      [
        3,
        19
      ],
      [
        -2,
        2
      ],
      [
        4,
        16
      ],
      [
        -1,
        25
      ],
      [
        4,
        11
      ],
      [
        0,
        37
      ]
    ],
    [
      [
        24278,
        54105
      ],
      [
        0,
        -152
      ],
      [
        -1,
        -179
      ],
      [
        0,
        -32
      ],
      [
        1,
        -337
      ]
    ],
    [
      [
        24278,
        53405
      ],
      [
        -5,
        20
      ],
      [
        -16,
        -22
      ],
      [
        -1,
        13
      ]
    ],
    [
      [
        24256,
        53416
      ],
      [
        4,
        10
      ],
      [
        -3,
        25
      ],
      [
        -6,
        14
      ],
      [
        -2,
        -5
      ],
      [
        -11,
        37
      ],
      [
        -3,
        35
      ],
      [
        2,
        15
      ],
      [
        -4,
        9
      ],
      [
        2,
        14
      ],
      [
        -10,
        12
      ]
    ],
    [
      [
        24170,
        62035
      ],
      [
        -10,
        -130
      ],
      [
        0,
        -1
      ],
      [
        -18,
        -231
      ]
    ],
    [
      [
        24106,
        61676
      ],
      [
        -61,
        193
      ],
      [
        1,
        102
      ]
    ],
    [
      [
        27731,
        65656
      ],
      [
        0,
        -263
      ]
    ],
    [
      [
        27478,
        65236
      ],
      [
        0,
        13
      ]
    ],
    [
      [
        27478,
        65249
      ],
      [
        0,
        407
      ]
    ],
    [
      [
        26692,
        61546
      ],
      [
        2,
        -37
      ],
      [
        7,
        -41
      ],
      [
        -1,
        -9
      ],
      [
        3,
        -40
      ],
      [
        4,
        6
      ],
      [
        0,
        -10
      ],
      [
        6,
        -18
      ],
      [
        6,
        1
      ]
    ],
    [
      [
        26719,
        61398
      ],
      [
        -5,
        -5
      ],
      [
        5,
        -14
      ],
      [
        11,
        0
      ],
      [
        2,
        -8
      ],
      [
        -4,
        -5
      ],
      [
        -3,
        -38
      ],
      [
        -7,
        -2
      ],
      [
        -4,
        -17
      ]
    ],
    [
      [
        26714,
        61309
      ],
      [
        -10,
        -27
      ],
      [
        -10,
        -9
      ],
      [
        -7,
        -22
      ],
      [
        -3,
        4
      ],
      [
        -3,
        -20
      ],
      [
        -8,
        -15
      ],
      [
        -2,
        10
      ],
      [
        -6,
        -9
      ],
      [
        1,
        -7
      ]
    ],
    [
      [
        25622,
        58904
      ],
      [
        27,
        -7
      ],
      [
        9,
        2
      ]
    ],
    [
      [
        25658,
        58899
      ],
      [
        4,
        -65
      ],
      [
        6,
        10
      ],
      [
        25,
        64
      ],
      [
        38,
        -19
      ],
      [
        4,
        -4
      ],
      [
        11,
        -23
      ],
      [
        7,
        -6
      ],
      [
        3,
        -7
      ],
      [
        15,
        -30
      ],
      [
        7,
        -6
      ],
      [
        1,
        -4
      ]
    ],
    [
      [
        25779,
        58809
      ],
      [
        -2,
        -1
      ],
      [
        3,
        -27
      ],
      [
        -3,
        -33
      ],
      [
        3,
        -37
      ],
      [
        -1,
        -23
      ],
      [
        4,
        -10
      ],
      [
        0,
        -19
      ],
      [
        -3,
        0
      ],
      [
        -3,
        -15
      ],
      [
        4,
        -2
      ],
      [
        0,
        -40
      ],
      [
        -10,
        6
      ],
      [
        -4,
        -5
      ],
      [
        0,
        -27
      ],
      [
        -3,
        5
      ],
      [
        -3,
        -26
      ],
      [
        -4,
        3
      ],
      [
        -1,
        -35
      ],
      [
        4,
        -14
      ]
    ],
    [
      [
        25760,
        58509
      ],
      [
        -17,
        -3
      ],
      [
        -1,
        -13
      ],
      [
        -8,
        12
      ]
    ],
    [
      [
        25613,
        58673
      ],
      [
        4,
        104
      ],
      [
        -1,
        22
      ]
    ],
    [
      [
        22614,
        70412
      ],
      [
        -2,
        0
      ],
      [
        -6,
        1
      ]
    ],
    [
      [
        31277,
        37922
      ],
      [
        6,
        -31
      ],
      [
        1,
        -51
      ]
    ],
    [
      [
        31284,
        37840
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -8
      ],
      [
        -4,
        4
      ],
      [
        0,
        4
      ],
      [
        -2,
        1
      ],
      [
        -4,
        -5
      ],
      [
        -1,
        2
      ],
      [
        0,
        1
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -18
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        0
      ],
      [
        -4,
        7
      ],
      [
        -4,
        -1
      ],
      [
        -1,
        10
      ],
      [
        -2,
        8
      ],
      [
        -4,
        5
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        17490,
        71031
      ],
      [
        14,
        -35
      ],
      [
        3,
        -28
      ],
      [
        31,
        0
      ],
      [
        4,
        -11
      ],
      [
        4,
        -37
      ]
    ],
    [
      [
        17398,
        70483
      ],
      [
        0,
        281
      ],
      [
        5,
        6
      ],
      [
        -6,
        57
      ],
      [
        -2,
        6
      ],
      [
        -1,
        33
      ],
      [
        63,
        0
      ],
      [
        -1,
        15
      ],
      [
        7,
        15
      ],
      [
        13,
        -10
      ],
      [
        5,
        5
      ],
      [
        4,
        -7
      ],
      [
        5,
        3
      ],
      [
        3,
        20
      ],
      [
        -2,
        65
      ],
      [
        -9,
        25
      ],
      [
        -5,
        35
      ],
      [
        13,
        -1
      ]
    ],
    [
      [
        17304,
        70983
      ],
      [
        0,
        135
      ]
    ],
    [
      [
        17304,
        71118
      ],
      [
        89,
        1
      ],
      [
        6,
        52
      ],
      [
        3,
        1
      ],
      [
        8,
        28
      ],
      [
        10,
        20
      ],
      [
        11,
        -1
      ],
      [
        35,
        0
      ]
    ],
    [
      [
        17466,
        71219
      ],
      [
        1,
        -84
      ],
      [
        0,
        -77
      ],
      [
        1,
        9
      ],
      [
        22,
        3
      ],
      [
        0,
        -39
      ]
    ],
    [
      [
        17372,
        70320
      ],
      [
        -1,
        2
      ],
      [
        -5,
        22
      ],
      [
        -1,
        4
      ],
      [
        -3,
        7
      ],
      [
        -4,
        7
      ],
      [
        -4,
        13
      ],
      [
        0,
        4
      ],
      [
        -2,
        11
      ],
      [
        -1,
        8
      ],
      [
        -2,
        25
      ],
      [
        -3,
        16
      ],
      [
        -2,
        18
      ],
      [
        -5,
        17
      ],
      [
        -1,
        8
      ]
    ],
    [
      [
        17338,
        70482
      ],
      [
        0,
        1
      ],
      [
        -1,
        4
      ],
      [
        -1,
        21
      ],
      [
        -2,
        25
      ],
      [
        -3,
        25
      ],
      [
        -2,
        8
      ],
      [
        -2,
        9
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        1
      ],
      [
        -2,
        4
      ],
      [
        -1,
        6
      ],
      [
        0,
        9
      ],
      [
        1,
        3
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        4,
        1
      ],
      [
        1,
        4
      ],
      [
        1,
        10
      ],
      [
        0,
        15
      ],
      [
        1,
        3
      ],
      [
        4,
        19
      ],
      [
        3,
        21
      ],
      [
        1,
        5
      ],
      [
        -1,
        3
      ],
      [
        0,
        4
      ],
      [
        -5,
        16
      ],
      [
        -3,
        10
      ],
      [
        -3,
        7
      ],
      [
        -1,
        5
      ],
      [
        0,
        7
      ],
      [
        2,
        12
      ],
      [
        1,
        7
      ],
      [
        0,
        6
      ],
      [
        -1,
        13
      ],
      [
        -1,
        13
      ],
      [
        -1,
        4
      ],
      [
        -1,
        5
      ],
      [
        -1,
        2
      ],
      [
        -1,
        4
      ],
      [
        -3,
        8
      ],
      [
        -1,
        4
      ],
      [
        0,
        4
      ],
      [
        2,
        11
      ],
      [
        0,
        4
      ],
      [
        -2,
        8
      ],
      [
        -2,
        4
      ],
      [
        -2,
        2
      ],
      [
        -3,
        7
      ],
      [
        -1,
        4
      ],
      [
        -1,
        4
      ],
      [
        0,
        21
      ],
      [
        -1,
        3
      ],
      [
        -1,
        2
      ],
      [
        -1,
        1
      ],
      [
        -3,
        2
      ],
      [
        -2,
        1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        4
      ],
      [
        -1,
        4
      ],
      [
        0,
        15
      ],
      [
        1,
        3
      ],
      [
        1,
        4
      ],
      [
        1,
        5
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        1,
        15
      ],
      [
        0,
        3
      ],
      [
        1,
        13
      ],
      [
        0,
        2
      ],
      [
        1,
        2
      ],
      [
        0,
        10
      ],
      [
        -1,
        5
      ],
      [
        0,
        4
      ]
    ],
    [
      [
        22468,
        63505
      ],
      [
        3,
        0
      ],
      [
        61,
        1
      ]
    ],
    [
      [
        22627,
        63505
      ],
      [
        0,
        -405
      ]
    ],
    [
      [
        22472,
        62999
      ],
      [
        -5,
        0
      ]
    ],
    [
      [
        22941,
        63504
      ],
      [
        95,
        0
      ]
    ],
    [
      [
        23099,
        63503
      ],
      [
        0,
        -505
      ]
    ],
    [
      [
        23004,
        62998
      ],
      [
        -63,
        0
      ]
    ],
    [
      [
        23500,
        59034
      ],
      [
        66,
        1
      ]
    ],
    [
      [
        23585,
        58566
      ],
      [
        2,
        -35
      ],
      [
        0,
        -3
      ],
      [
        4,
        -102
      ]
    ],
    [
      [
        23591,
        58426
      ],
      [
        -93,
        0
      ]
    ],
    [
      [
        26653,
        57675
      ],
      [
        -19,
        -1
      ]
    ],
    [
      [
        26634,
        57674
      ],
      [
        -20,
        -1
      ],
      [
        1,
        -6
      ],
      [
        -37,
        1
      ],
      [
        -52,
        0
      ]
    ],
    [
      [
        26526,
        57668
      ],
      [
        -19,
        0
      ]
    ],
    [
      [
        26507,
        57668
      ],
      [
        0,
        8
      ],
      [
        7,
        13
      ],
      [
        7,
        24
      ],
      [
        -3,
        21
      ],
      [
        3,
        12
      ],
      [
        3,
        2
      ],
      [
        4,
        15
      ],
      [
        6,
        11
      ],
      [
        7,
        32
      ],
      [
        6,
        18
      ],
      [
        2,
        19
      ],
      [
        4,
        7
      ],
      [
        7,
        -6
      ],
      [
        12,
        20
      ],
      [
        7,
        5
      ],
      [
        3,
        -5
      ]
    ],
    [
      [
        26757,
        57683
      ],
      [
        28,
        31
      ]
    ],
    [
      [
        26773,
        57095
      ],
      [
        -1,
        9
      ],
      [
        -1,
        1
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        1
      ],
      [
        -5,
        16
      ],
      [
        0,
        2
      ],
      [
        3,
        7
      ],
      [
        -1,
        1
      ],
      [
        -1,
        7
      ],
      [
        -1,
        2
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        4
      ]
    ],
    [
      [
        26758,
        57143
      ],
      [
        0,
        4
      ],
      [
        -5,
        23
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ],
      [
        -3,
        7
      ],
      [
        -3,
        12
      ],
      [
        -1,
        12
      ],
      [
        -4,
        3
      ],
      [
        0,
        17
      ],
      [
        -1,
        2
      ],
      [
        -2,
        1
      ],
      [
        -5,
        -2
      ],
      [
        0,
        2
      ],
      [
        -4,
        3
      ],
      [
        -2,
        -1
      ],
      [
        -3,
        2
      ],
      [
        -4,
        8
      ],
      [
        1,
        7
      ],
      [
        -1,
        2
      ],
      [
        -1,
        7
      ],
      [
        -2,
        7
      ],
      [
        -2,
        3
      ],
      [
        -3,
        1
      ],
      [
        -1,
        4
      ],
      [
        -3,
        7
      ],
      [
        -1,
        4
      ],
      [
        -3,
        9
      ],
      [
        0,
        5
      ],
      [
        -1,
        4
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        7
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        2
      ],
      [
        -2,
        2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        2
      ],
      [
        0,
        6
      ]
    ],
    [
      [
        26693,
        57318
      ],
      [
        -1,
        2
      ],
      [
        0,
        3
      ],
      [
        -1,
        3
      ],
      [
        -1,
        3
      ],
      [
        0,
        14
      ],
      [
        -1,
        6
      ],
      [
        0,
        3
      ]
    ],
    [
      [
        26689,
        57352
      ],
      [
        0,
        14
      ],
      [
        1,
        10
      ],
      [
        3,
        6
      ],
      [
        5,
        20
      ],
      [
        0,
        17
      ],
      [
        -1,
        19
      ],
      [
        3,
        11
      ],
      [
        3,
        3
      ],
      [
        0,
        14
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        4
      ],
      [
        0,
        7
      ],
      [
        2,
        -2
      ],
      [
        0,
        -2
      ],
      [
        2,
        -5
      ],
      [
        2,
        2
      ],
      [
        1,
        3
      ],
      [
        0,
        14
      ],
      [
        -1,
        5
      ],
      [
        1,
        9
      ],
      [
        1,
        2
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        1,
        1
      ],
      [
        0,
        1
      ],
      [
        1,
        1
      ],
      [
        0,
        7
      ],
      [
        1,
        3
      ],
      [
        0,
        8
      ],
      [
        1,
        3
      ],
      [
        1,
        1
      ],
      [
        1,
        4
      ],
      [
        0,
        8
      ],
      [
        2,
        1
      ],
      [
        0,
        3
      ],
      [
        3,
        -3
      ],
      [
        2,
        6
      ],
      [
        1,
        -3
      ],
      [
        1,
        0
      ],
      [
        1,
        5
      ],
      [
        -1,
        7
      ],
      [
        1,
        4
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        2,
        2
      ],
      [
        2,
        6
      ],
      [
        0,
        5
      ],
      [
        2,
        3
      ],
      [
        1,
        3
      ],
      [
        0,
        5
      ],
      [
        1,
        1
      ],
      [
        1,
        -1
      ],
      [
        1,
        2
      ],
      [
        1,
        5
      ],
      [
        1,
        3
      ],
      [
        0,
        1
      ],
      [
        2,
        -3
      ],
      [
        1,
        0
      ],
      [
        3,
        7
      ],
      [
        0,
        7
      ],
      [
        1,
        1
      ],
      [
        0,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        0,
        3
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        -1,
        5
      ],
      [
        0,
        6
      ],
      [
        1,
        1
      ],
      [
        1,
        5
      ],
      [
        -1,
        5
      ],
      [
        1,
        6
      ],
      [
        2,
        8
      ],
      [
        1,
        6
      ],
      [
        0,
        2
      ],
      [
        1,
        8
      ],
      [
        0,
        8
      ],
      [
        -1,
        5
      ]
    ],
    [
      [
        23733,
        58568
      ],
      [
        14,
        -1
      ]
    ],
    [
      [
        23747,
        58567
      ],
      [
        6,
        -1
      ],
      [
        -1,
        -16
      ],
      [
        -5,
        0
      ],
      [
        0,
        -17
      ],
      [
        -14,
        2
      ],
      [
        -1,
        -34
      ],
      [
        -5,
        1
      ],
      [
        0,
        -50
      ],
      [
        -25,
        1
      ],
      [
        0,
        -33
      ],
      [
        -1,
        -68
      ],
      [
        15,
        -1
      ],
      [
        0,
        -21
      ],
      [
        -5,
        -15
      ],
      [
        2,
        -49
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -6
      ],
      [
        -1,
        -2
      ],
      [
        1,
        -3
      ],
      [
        3,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        -3,
        -6
      ],
      [
        7,
        -19
      ],
      [
        -13,
        -18
      ]
    ],
    [
      [
        23702,
        58201
      ],
      [
        -4,
        -4
      ],
      [
        -15,
        9
      ],
      [
        -4,
        -10
      ],
      [
        -1,
        -7
      ],
      [
        7,
        -42
      ],
      [
        -1,
        -17
      ],
      [
        -8,
        -7
      ],
      [
        -6,
        11
      ],
      [
        -4,
        -32
      ],
      [
        -9,
        -8
      ],
      [
        -2,
        2
      ],
      [
        -5,
        -2
      ],
      [
        -5,
        7
      ],
      [
        -7,
        -8
      ],
      [
        -11,
        22
      ],
      [
        -1,
        11
      ],
      [
        2,
        32
      ],
      [
        -5,
        24
      ],
      [
        -8,
        22
      ],
      [
        -8,
        -2
      ],
      [
        -6,
        -21
      ]
    ],
    [
      [
        23601,
        58181
      ],
      [
        -4,
        79
      ],
      [
        0,
        1
      ],
      [
        -2,
        50
      ],
      [
        -1,
        50
      ],
      [
        -1,
        5
      ],
      [
        0,
        8
      ],
      [
        -2,
        52
      ]
    ],
    [
      [
        31708,
        38299
      ],
      [
        1,
        1
      ],
      [
        1,
        -9
      ],
      [
        3,
        -4
      ],
      [
        3,
        0
      ],
      [
        1,
        -7
      ],
      [
        2,
        -2
      ],
      [
        2,
        3
      ],
      [
        6,
        6
      ],
      [
        4,
        4
      ],
      [
        9,
        -24
      ],
      [
        0,
        -12
      ],
      [
        -7,
        -16
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -6,
        -11
      ],
      [
        -1,
        2
      ],
      [
        -11,
        17
      ],
      [
        -3,
        14
      ],
      [
        3,
        18
      ],
      [
        -4,
        25
      ],
      [
        1,
        4
      ]
    ],
    [
      [
        24933,
        53029
      ],
      [
        -20,
        0
      ]
    ],
    [
      [
        24913,
        53029
      ],
      [
        -1,
        2
      ],
      [
        0,
        1
      ],
      [
        -3,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        0
      ],
      [
        0,
        2
      ],
      [
        -23,
        0
      ]
    ],
    [
      [
        24883,
        53028
      ],
      [
        0,
        85
      ],
      [
        -24,
        0
      ],
      [
        -2,
        17
      ],
      [
        0,
        25
      ],
      [
        -3,
        0
      ],
      [
        0,
        26
      ],
      [
        -19,
        -1
      ],
      [
        0,
        50
      ],
      [
        -7,
        1
      ],
      [
        0,
        59
      ],
      [
        -2,
        8
      ],
      [
        0,
        119
      ]
    ],
    [
      [
        24826,
        53417
      ],
      [
        0,
        68
      ],
      [
        18,
        0
      ],
      [
        4,
        -4
      ]
    ],
    [
      [
        24856,
        56710
      ],
      [
        59,
        -1
      ],
      [
        0,
        33
      ]
    ],
    [
      [
        24858,
        56399
      ],
      [
        0,
        283
      ],
      [
        -2,
        28
      ]
    ],
    [
      [
        21996,
        63910
      ],
      [
        29,
        2
      ]
    ],
    [
      [
        15582,
        70936
      ],
      [
        29,
        3
      ],
      [
        48,
        -1
      ],
      [
        161,
        0
      ],
      [
        1,
        -2
      ],
      [
        33,
        0
      ]
    ],
    [
      [
        15854,
        70936
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -200
      ],
      [
        -1,
        -13
      ],
      [
        0,
        -170
      ]
    ],
    [
      [
        15584,
        70688
      ],
      [
        -1,
        81
      ],
      [
        0,
        65
      ],
      [
        -1,
        102
      ]
    ],
    [
      [
        25718,
        57673
      ],
      [
        15,
        0
      ]
    ],
    [
      [
        25733,
        57673
      ],
      [
        0,
        -221
      ],
      [
        -1,
        -85
      ],
      [
        0,
        -77
      ],
      [
        -1,
        -131
      ]
    ],
    [
      [
        25644,
        57317
      ],
      [
        -4,
        13
      ],
      [
        -6,
        31
      ],
      [
        -9,
        22
      ],
      [
        -14,
        24
      ],
      [
        -11,
        -6
      ]
    ],
    [
      [
        26123,
        52522
      ],
      [
        59,
        -3
      ],
      [
        1,
        51
      ],
      [
        66,
        -2
      ]
    ],
    [
      [
        26249,
        52568
      ],
      [
        -4,
        -13
      ],
      [
        0,
        -18
      ],
      [
        -5,
        0
      ],
      [
        1,
        -19
      ],
      [
        -4,
        -12
      ],
      [
        -4,
        -33
      ],
      [
        0,
        -24
      ],
      [
        -3,
        -37
      ],
      [
        4,
        -9
      ],
      [
        -4,
        -10
      ],
      [
        5,
        -17
      ],
      [
        -9,
        -8
      ],
      [
        -5,
        -17
      ],
      [
        5,
        -13
      ],
      [
        -4,
        -4
      ],
      [
        4,
        -13
      ],
      [
        -3,
        -22
      ],
      [
        -4,
        -4
      ],
      [
        3,
        -13
      ],
      [
        -4,
        -10
      ],
      [
        -2,
        -18
      ],
      [
        1,
        -19
      ],
      [
        3,
        -9
      ],
      [
        -3,
        0
      ],
      [
        -3,
        -13
      ],
      [
        1,
        -16
      ],
      [
        -3,
        -20
      ],
      [
        2,
        -9
      ],
      [
        -5,
        -14
      ],
      [
        -2,
        -26
      ],
      [
        -3,
        -1
      ],
      [
        -3,
        -19
      ],
      [
        -4,
        -1
      ],
      [
        1,
        -12
      ]
    ],
    [
      [
        26198,
        52095
      ],
      [
        -75,
        1
      ],
      [
        -2,
        0
      ]
    ],
    [
      [
        26917,
        50750
      ],
      [
        7,
        -8
      ],
      [
        6,
        12
      ],
      [
        8,
        -1
      ],
      [
        9,
        -30
      ],
      [
        2,
        -10
      ],
      [
        5,
        7
      ],
      [
        2,
        -13
      ],
      [
        9,
        -10
      ],
      [
        0,
        -7
      ],
      [
        1,
        0
      ],
      [
        1,
        -2
      ],
      [
        1,
        0
      ],
      [
        0,
        -2
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        1
      ],
      [
        8,
        -32
      ]
    ],
    [
      [
        26880,
        50342
      ],
      [
        0,
        2
      ],
      [
        -13,
        29
      ],
      [
        4,
        42
      ],
      [
        -9,
        109
      ],
      [
        12,
        64
      ],
      [
        -4,
        32
      ],
      [
        -2,
        3
      ],
      [
        -4,
        21
      ],
      [
        -3,
        23
      ],
      [
        -1,
        26
      ],
      [
        -6,
        -3
      ]
    ],
    [
      [
        24512,
        55367
      ],
      [
        56,
        -1
      ],
      [
        14,
        -3
      ]
    ],
    [
      [
        24636,
        54961
      ],
      [
        2,
        -23
      ],
      [
        6,
        -7
      ],
      [
        -1,
        -13
      ],
      [
        -7,
        -7
      ]
    ],
    [
      [
        25880,
        61667
      ],
      [
        32,
        -4
      ],
      [
        30,
        -2
      ]
    ],
    [
      [
        25979,
        61384
      ],
      [
        -2,
        -22
      ],
      [
        0,
        -24
      ],
      [
        1,
        -34
      ],
      [
        0,
        -29
      ],
      [
        -2,
        -15
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -16
      ],
      [
        -1,
        -10
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -3
      ]
    ],
    [
      [
        21486,
        60002
      ],
      [
        -4,
        0
      ]
    ],
    [
      [
        27101,
        57897
      ],
      [
        9,
        -71
      ],
      [
        2,
        -18
      ],
      [
        8,
        -61
      ],
      [
        0,
        -23
      ],
      [
        3,
        0
      ],
      [
        6,
        -55
      ],
      [
        5,
        -65
      ],
      [
        6,
        0
      ],
      [
        6,
        -23
      ]
    ],
    [
      [
        22783,
        62492
      ],
      [
        0,
        -202
      ]
    ],
    [
      [
        22628,
        62290
      ],
      [
        0,
        304
      ]
    ],
    [
      [
        19895,
        71048
      ],
      [
        157,
        1
      ],
      [
        0,
        -17
      ],
      [
        6,
        0
      ],
      [
        0,
        -84
      ],
      [
        35,
        -1
      ],
      [
        0,
        -103
      ],
      [
        6,
        -1
      ],
      [
        0,
        -200
      ],
      [
        19,
        3
      ],
      [
        0,
        -310
      ]
    ],
    [
      [
        20118,
        70336
      ],
      [
        -32,
        0
      ],
      [
        0,
        50
      ],
      [
        -34,
        0
      ],
      [
        0,
        51
      ],
      [
        -70,
        0
      ],
      [
        0,
        101
      ],
      [
        -24,
        0
      ]
    ],
    [
      [
        22882,
        66240
      ],
      [
        0,
        477
      ]
    ],
    [
      [
        22989,
        66441
      ],
      [
        -25,
        0
      ],
      [
        0,
        -101
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -177
      ]
    ],
    [
      [
        22963,
        66154
      ],
      [
        0,
        -16
      ],
      [
        -27,
        0
      ]
    ],
    [
      [
        24045,
        70173
      ],
      [
        2,
        3
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        2,
        7
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        1,
        4
      ],
      [
        1,
        3
      ],
      [
        0,
        2
      ],
      [
        1,
        2
      ],
      [
        4,
        13
      ],
      [
        1,
        10
      ],
      [
        1,
        11
      ],
      [
        0,
        9
      ],
      [
        2,
        6
      ],
      [
        1,
        3
      ],
      [
        2,
        4
      ],
      [
        0,
        3
      ],
      [
        1,
        3
      ],
      [
        0,
        5
      ],
      [
        -1,
        5
      ],
      [
        0,
        3
      ],
      [
        -1,
        8
      ],
      [
        -1,
        3
      ],
      [
        1,
        3
      ],
      [
        1,
        5
      ],
      [
        0,
        1
      ],
      [
        3,
        7
      ],
      [
        1,
        0
      ],
      [
        2,
        6
      ],
      [
        0,
        2
      ],
      [
        1,
        13
      ],
      [
        0,
        10
      ],
      [
        4,
        19
      ],
      [
        2,
        9
      ],
      [
        2,
        4
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        4,
        9
      ],
      [
        2,
        3
      ],
      [
        1,
        1
      ],
      [
        -1,
        4
      ],
      [
        0,
        2
      ],
      [
        2,
        5
      ],
      [
        3,
        7
      ],
      [
        1,
        2
      ],
      [
        5,
        0
      ],
      [
        0,
        2
      ],
      [
        -1,
        7
      ],
      [
        1,
        2
      ],
      [
        1,
        1
      ],
      [
        1,
        -3
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        3,
        -1
      ],
      [
        1,
        2
      ],
      [
        0,
        2
      ],
      [
        2,
        3
      ],
      [
        3,
        1
      ],
      [
        3,
        5
      ],
      [
        2,
        3
      ],
      [
        1,
        0
      ],
      [
        2,
        3
      ],
      [
        3,
        1
      ],
      [
        1,
        6
      ],
      [
        -1,
        4
      ],
      [
        1,
        9
      ],
      [
        0,
        1
      ],
      [
        1,
        1
      ],
      [
        2,
        9
      ],
      [
        2,
        5
      ],
      [
        1,
        2
      ],
      [
        1,
        1
      ],
      [
        1,
        -1
      ],
      [
        5,
        -4
      ],
      [
        3,
        -5
      ],
      [
        2,
        0
      ],
      [
        1,
        -2
      ],
      [
        2,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        1,
        4
      ],
      [
        0,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        3
      ],
      [
        1,
        3
      ],
      [
        2,
        3
      ],
      [
        0,
        7
      ],
      [
        1,
        1
      ],
      [
        0,
        4
      ],
      [
        1,
        2
      ],
      [
        1,
        8
      ],
      [
        0,
        3
      ],
      [
        1,
        5
      ],
      [
        1,
        6
      ],
      [
        2,
        3
      ],
      [
        3,
        3
      ],
      [
        2,
        1
      ],
      [
        1,
        -1
      ],
      [
        4,
        -8
      ],
      [
        3,
        -3
      ],
      [
        3,
        -3
      ],
      [
        3,
        -2
      ],
      [
        1,
        1
      ],
      [
        2,
        2
      ],
      [
        0,
        10
      ],
      [
        1,
        2
      ],
      [
        1,
        2
      ],
      [
        0,
        18
      ],
      [
        1,
        3
      ],
      [
        0,
        5
      ],
      [
        1,
        3
      ],
      [
        0,
        8
      ],
      [
        1,
        4
      ],
      [
        1,
        3
      ],
      [
        0,
        1
      ],
      [
        3,
        4
      ],
      [
        3,
        3
      ],
      [
        3,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        96
      ]
    ],
    [
      [
        24198,
        70670
      ],
      [
        68,
        0
      ]
    ],
    [
      [
        24882,
        67235
      ],
      [
        9,
        38
      ],
      [
        9,
        0
      ],
      [
        12,
        15
      ],
      [
        5,
        31
      ],
      [
        -2,
        17
      ]
    ],
    [
      [
        25113,
        67225
      ],
      [
        0,
        -34
      ],
      [
        -1,
        -169
      ],
      [
        0,
        -205
      ]
    ],
    [
      [
        25013,
        66814
      ],
      [
        0,
        14
      ],
      [
        -131,
        1
      ]
    ],
    [
      [
        24882,
        66829
      ],
      [
        0,
        406
      ]
    ],
    [
      [
        24496,
        51891
      ],
      [
        33,
        44
      ]
    ],
    [
      [
        24529,
        51935
      ],
      [
        5,
        0
      ],
      [
        0,
        16
      ],
      [
        4,
        6
      ],
      [
        5,
        -13
      ],
      [
        14,
        10
      ],
      [
        6,
        -16
      ],
      [
        6,
        1
      ]
    ],
    [
      [
        24569,
        51939
      ],
      [
        1,
        -36
      ],
      [
        0,
        -67
      ],
      [
        9,
        1
      ],
      [
        0,
        -51
      ],
      [
        11,
        1
      ],
      [
        0,
        -35
      ]
    ],
    [
      [
        24590,
        51752
      ],
      [
        0,
        -33
      ],
      [
        -6,
        0
      ],
      [
        -5,
        -54
      ],
      [
        0,
        -1
      ],
      [
        -6,
        -44
      ],
      [
        -16,
        -90
      ]
    ],
    [
      [
        24557,
        51530
      ],
      [
        -22,
        -103
      ]
    ],
    [
      [
        24531,
        51512
      ],
      [
        -2,
        40
      ],
      [
        3,
        4
      ],
      [
        0,
        32
      ],
      [
        -1,
        24
      ],
      [
        2,
        19
      ],
      [
        -5,
        26
      ],
      [
        -7,
        16
      ],
      [
        -4,
        -1
      ],
      [
        -11,
        14
      ],
      [
        -3,
        15
      ],
      [
        -4,
        53
      ],
      [
        -5,
        13
      ],
      [
        0,
        20
      ],
      [
        -6,
        26
      ],
      [
        -1,
        16
      ]
    ],
    [
      [
        28887,
        65414
      ],
      [
        -6,
        416
      ]
    ],
    [
      [
        28881,
        65830
      ],
      [
        23,
        0
      ]
    ],
    [
      [
        28904,
        65830
      ],
      [
        12,
        0
      ],
      [
        2,
        -3
      ],
      [
        2,
        -2
      ],
      [
        1,
        -3
      ],
      [
        1,
        -7
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -12
      ],
      [
        0,
        -2
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        2,
        -8
      ],
      [
        1,
        -1
      ],
      [
        0,
        -8
      ],
      [
        2,
        -4
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        1
      ],
      [
        0,
        6
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        -3
      ],
      [
        0,
        -11
      ],
      [
        3,
        -4
      ],
      [
        1,
        -7
      ],
      [
        0,
        -16
      ],
      [
        2,
        -9
      ],
      [
        1,
        -5
      ],
      [
        0,
        -6
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -5
      ],
      [
        1,
        -6
      ],
      [
        0,
        -2
      ],
      [
        2,
        -1
      ],
      [
        0,
        -2
      ],
      [
        1,
        -7
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -8
      ],
      [
        1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        2,
        0
      ],
      [
        1,
        2
      ],
      [
        1,
        4
      ],
      [
        1,
        0
      ],
      [
        1,
        -2
      ],
      [
        1,
        -4
      ],
      [
        1,
        -3
      ],
      [
        1,
        -2
      ],
      [
        1,
        0
      ],
      [
        1,
        3
      ],
      [
        1,
        8
      ],
      [
        2,
        3
      ],
      [
        1,
        0
      ],
      [
        2,
        -1
      ],
      [
        1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        1,
        -1
      ],
      [
        1,
        0
      ],
      [
        0,
        2
      ],
      [
        1,
        4
      ],
      [
        0,
        5
      ],
      [
        1,
        3
      ],
      [
        0,
        1
      ],
      [
        2,
        -2
      ],
      [
        0,
        -14
      ],
      [
        1,
        -6
      ],
      [
        0,
        -3
      ],
      [
        1,
        -2
      ],
      [
        2,
        -2
      ],
      [
        1,
        0
      ],
      [
        1,
        3
      ]
    ],
    [
      [
        28975,
        65657
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        3,
        -9
      ],
      [
        3,
        1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        1,
        -4
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -5
      ],
      [
        1,
        -4
      ],
      [
        3,
        -5
      ],
      [
        2,
        -5
      ],
      [
        1,
        -3
      ],
      [
        1,
        0
      ],
      [
        2,
        4
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        -2
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -10
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -13
      ],
      [
        1,
        -2
      ],
      [
        2,
        -1
      ],
      [
        4,
        3
      ],
      [
        1,
        1
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        2,
        -14
      ],
      [
        0,
        -30
      ],
      [
        1,
        -14
      ],
      [
        0,
        -4
      ],
      [
        -3,
        2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -5
      ],
      [
        2,
        -7
      ],
      [
        1,
        -4
      ],
      [
        1,
        -9
      ],
      [
        1,
        -7
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -7
      ],
      [
        1,
        0
      ],
      [
        1,
        -7
      ],
      [
        1,
        -7
      ],
      [
        -1,
        -17
      ],
      [
        1,
        -10
      ],
      [
        0,
        -2
      ],
      [
        1,
        -9
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        2
      ],
      [
        -1,
        1
      ],
      [
        -2,
        -2
      ],
      [
        0,
        -9
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        2,
        -5
      ]
    ],
    [
      [
        28875,
        64937
      ],
      [
        3,
        12
      ],
      [
        7,
        1
      ],
      [
        8,
        18
      ],
      [
        0,
        1
      ],
      [
        -2,
        193
      ],
      [
        -2,
        126
      ],
      [
        -2,
        126
      ]
    ],
    [
      [
        28934,
        66697
      ],
      [
        4,
        12
      ],
      [
        2,
        21
      ],
      [
        6,
        14
      ],
      [
        0,
        13
      ],
      [
        3,
        45
      ],
      [
        -2,
        12
      ],
      [
        0,
        23
      ],
      [
        1,
        5
      ],
      [
        -1,
        3
      ]
    ],
    [
      [
        29082,
        66836
      ],
      [
        3,
        -5
      ],
      [
        29,
        -35
      ]
    ],
    [
      [
        29096,
        66434
      ],
      [
        -11,
        -4
      ],
      [
        -6,
        -11
      ],
      [
        -1,
        1
      ],
      [
        -18,
        7
      ],
      [
        -35,
        -51
      ],
      [
        -7,
        -32
      ],
      [
        -7,
        16
      ],
      [
        0,
        -30
      ],
      [
        -11,
        2
      ],
      [
        -10,
        -12
      ],
      [
        -29,
        -72
      ],
      [
        2,
        25
      ],
      [
        -8,
        -15
      ],
      [
        -6,
        -2
      ],
      [
        -6,
        2
      ],
      [
        -2,
        -18
      ],
      [
        -6,
        -14
      ],
      [
        -5,
        -21
      ],
      [
        -9,
        -8
      ],
      [
        -10,
        9
      ],
      [
        -11,
        -10
      ]
    ],
    [
      [
        28900,
        66196
      ],
      [
        5,
        26
      ],
      [
        1,
        20
      ],
      [
        -3,
        32
      ],
      [
        4,
        23
      ],
      [
        5,
        18
      ],
      [
        -3,
        34
      ],
      [
        -4,
        18
      ],
      [
        -2,
        21
      ],
      [
        3,
        10
      ],
      [
        -2,
        25
      ],
      [
        4,
        3
      ],
      [
        6,
        50
      ],
      [
        8,
        9
      ],
      [
        3,
        18
      ],
      [
        -3,
        42
      ],
      [
        4,
        11
      ],
      [
        -1,
        27
      ],
      [
        -1,
        33
      ],
      [
        5,
        18
      ],
      [
        4,
        33
      ],
      [
        1,
        30
      ]
    ],
    [
      [
        22701,
        57514
      ],
      [
        106,
        0
      ],
      [
        99,
        -1
      ]
    ],
    [
      [
        22906,
        57513
      ],
      [
        0,
        -253
      ]
    ],
    [
      [
        22730,
        57108
      ],
      [
        0,
        199
      ],
      [
        -1,
        4
      ],
      [
        -28,
        0
      ]
    ],
    [
      [
        29146,
        68274
      ],
      [
        70,
        25
      ]
    ],
    [
      [
        29279,
        67861
      ],
      [
        -44,
        -18
      ],
      [
        15,
        -416
      ]
    ],
    [
      [
        29250,
        67427
      ],
      [
        6,
        -137
      ]
    ],
    [
      [
        29256,
        67290
      ],
      [
        -24,
        -6
      ],
      [
        1,
        -31
      ],
      [
        -28,
        -8
      ],
      [
        -1,
        31
      ],
      [
        -58,
        -16
      ],
      [
        -50,
        71
      ],
      [
        0,
        -3
      ]
    ],
    [
      [
        23868,
        58992
      ],
      [
        -1,
        -51
      ],
      [
        10,
        -1
      ],
      [
        -1,
        -31
      ],
      [
        0,
        -100
      ],
      [
        -5,
        0
      ],
      [
        0,
        -17
      ],
      [
        -5,
        0
      ],
      [
        0,
        -34
      ],
      [
        -5,
        1
      ],
      [
        -1,
        -51
      ],
      [
        -5,
        1
      ],
      [
        0,
        -68
      ],
      [
        2,
        0
      ],
      [
        0,
        -70
      ]
    ],
    [
      [
        23857,
        58571
      ],
      [
        -50,
        6
      ]
    ],
    [
      [
        23807,
        58577
      ],
      [
        -60,
        7
      ],
      [
        0,
        -17
      ]
    ],
    [
      [
        28708,
        65829
      ],
      [
        13,
        1
      ],
      [
        28,
        0
      ],
      [
        25,
        -1
      ],
      [
        27,
        0
      ],
      [
        8,
        -1
      ],
      [
        37,
        2
      ],
      [
        35,
        0
      ]
    ],
    [
      [
        28887,
        65414
      ],
      [
        -2,
        -1
      ],
      [
        -51,
        1
      ],
      [
        -18,
        0
      ]
    ],
    [
      [
        28705,
        65425
      ],
      [
        -1,
        101
      ],
      [
        -7,
        303
      ]
    ],
    [
      [
        26322,
        51623
      ],
      [
        9,
        7
      ],
      [
        11,
        23
      ],
      [
        6,
        19
      ],
      [
        3,
        -2
      ],
      [
        0,
        -29
      ],
      [
        -5,
        -19
      ],
      [
        -11,
        -18
      ],
      [
        -11,
        -6
      ],
      [
        -5,
        12
      ],
      [
        3,
        13
      ]
    ],
    [
      [
        26223,
        51829
      ],
      [
        6,
        46
      ],
      [
        -1,
        3
      ],
      [
        129,
        -3
      ]
    ],
    [
      [
        26357,
        51875
      ],
      [
        4,
        -4
      ],
      [
        3,
        -15
      ],
      [
        -1,
        -15
      ],
      [
        2,
        8
      ],
      [
        7,
        -2
      ],
      [
        6,
        17
      ],
      [
        5,
        -35
      ],
      [
        2,
        12
      ],
      [
        2,
        -6
      ],
      [
        27,
        -19
      ]
    ],
    [
      [
        26414,
        51816
      ],
      [
        0,
        -17
      ],
      [
        1,
        -4
      ],
      [
        1,
        -22
      ],
      [
        -1,
        -12
      ],
      [
        -2,
        -16
      ],
      [
        -2,
        -3
      ],
      [
        -8,
        -4
      ],
      [
        -7,
        9
      ],
      [
        -5,
        2
      ],
      [
        -3,
        4
      ],
      [
        -3,
        9
      ],
      [
        -2,
        17
      ],
      [
        -5,
        -5
      ],
      [
        -7,
        -12
      ],
      [
        -5,
        3
      ],
      [
        -7,
        -8
      ],
      [
        -11,
        -26
      ],
      [
        -7,
        -13
      ],
      [
        -3,
        -10
      ],
      [
        -10,
        -24
      ],
      [
        -2,
        -11
      ],
      [
        0,
        -4
      ],
      [
        -4,
        -6
      ],
      [
        -4,
        3
      ],
      [
        -2,
        -3
      ],
      [
        -11,
        -26
      ],
      [
        -7,
        -21
      ],
      [
        -2,
        0
      ],
      [
        -17,
        -35
      ],
      [
        -4,
        -3
      ],
      [
        -8,
        -16
      ],
      [
        -4,
        -10
      ],
      [
        -2,
        -13
      ],
      [
        -1,
        0
      ],
      [
        -3,
        15
      ],
      [
        4,
        24
      ],
      [
        3,
        20
      ],
      [
        -4,
        14
      ],
      [
        -3,
        1
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        -12
      ],
      [
        -5,
        -27
      ],
      [
        -2,
        -6
      ],
      [
        -5,
        -3
      ],
      [
        -1,
        -18
      ],
      [
        -3,
        -7
      ],
      [
        -4,
        -7
      ],
      [
        -12,
        -4
      ],
      [
        -10,
        9
      ],
      [
        -8,
        0
      ],
      [
        -6,
        -4
      ],
      [
        6,
        -36
      ],
      [
        7,
        -13
      ],
      [
        2,
        -38
      ],
      [
        16,
        -22
      ],
      [
        30,
        53
      ],
      [
        29,
        40
      ],
      [
        13,
        42
      ],
      [
        14,
        42
      ],
      [
        3,
        -13
      ],
      [
        -24,
        -82
      ],
      [
        -28,
        -43
      ],
      [
        -20,
        -38
      ],
      [
        -15,
        -28
      ],
      [
        -12,
        -14
      ],
      [
        -10,
        33
      ],
      [
        -16,
        22
      ],
      [
        -23,
        51
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        26167,
        51487
      ],
      [
        1,
        14
      ],
      [
        5,
        25
      ],
      [
        27,
        76
      ],
      [
        8,
        -9
      ],
      [
        3,
        18
      ],
      [
        8,
        -5
      ],
      [
        1,
        14
      ],
      [
        4,
        18
      ],
      [
        0,
        18
      ],
      [
        -3,
        8
      ],
      [
        -2,
        53
      ],
      [
        -3,
        21
      ],
      [
        -1,
        20
      ],
      [
        10,
        47
      ],
      [
        -2,
        24
      ]
    ],
    [
      [
        26430,
        52660
      ],
      [
        -5,
        -6
      ],
      [
        1,
        -4
      ],
      [
        -2,
        -8
      ],
      [
        1,
        -32
      ],
      [
        -1,
        -9
      ],
      [
        -5,
        -17
      ],
      [
        -4,
        -28
      ],
      [
        -10,
        -18
      ],
      [
        -4,
        -35
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -17
      ]
    ],
    [
      [
        26400,
        52478
      ],
      [
        0,
        0
      ]
    ],
    [
      [
        26400,
        52478
      ],
      [
        0,
        -3
      ],
      [
        -4,
        -22
      ],
      [
        2,
        -28
      ],
      [
        -3,
        -12
      ],
      [
        -3,
        -11
      ],
      [
        -28,
        -14
      ],
      [
        -3,
        -13
      ],
      [
        -8,
        -8
      ],
      [
        -1,
        5
      ],
      [
        -2,
        -13
      ],
      [
        -6,
        -18
      ],
      [
        -4,
        5
      ],
      [
        -12,
        -25
      ],
      [
        1,
        -7
      ]
    ],
    [
      [
        26329,
        52314
      ],
      [
        -10,
        0
      ],
      [
        0,
        34
      ],
      [
        -9,
        0
      ],
      [
        0,
        50
      ],
      [
        -19,
        -1
      ],
      [
        0,
        69
      ],
      [
        -10,
        0
      ],
      [
        0,
        17
      ],
      [
        -18,
        0
      ],
      [
        0,
        84
      ],
      [
        -14,
        1
      ]
    ],
    [
      [
        26249,
        52568
      ],
      [
        7,
        15
      ],
      [
        5,
        52
      ],
      [
        9,
        40
      ],
      [
        -2,
        15
      ]
    ],
    [
      [
        26198,
        52095
      ],
      [
        -5,
        -21
      ],
      [
        -2,
        -22
      ],
      [
        2,
        -20
      ],
      [
        -3,
        -27
      ],
      [
        4,
        -4
      ],
      [
        -5,
        -10
      ],
      [
        1,
        -13
      ],
      [
        -3,
        -9
      ],
      [
        5,
        -7
      ],
      [
        0,
        -50
      ],
      [
        6,
        -23
      ],
      [
        8,
        -10
      ],
      [
        4,
        -11
      ],
      [
        5,
        -5
      ],
      [
        1,
        -11
      ],
      [
        6,
        -5
      ],
      [
        1,
        -18
      ]
    ],
    [
      [
        26167,
        51487
      ],
      [
        -9,
        4
      ],
      [
        -9,
        3
      ],
      [
        -8,
        -3
      ],
      [
        -7,
        -11
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -9
      ],
      [
        -5,
        25
      ],
      [
        -3,
        20
      ],
      [
        -5,
        49
      ],
      [
        -4,
        69
      ],
      [
        -1,
        34
      ],
      [
        0,
        16
      ],
      [
        1,
        12
      ],
      [
        2,
        15
      ],
      [
        5,
        15
      ],
      [
        0,
        -105
      ],
      [
        3,
        -41
      ],
      [
        3,
        -50
      ],
      [
        3,
        -16
      ],
      [
        4,
        -6
      ],
      [
        5,
        7
      ],
      [
        5,
        32
      ],
      [
        1,
        84
      ],
      [
        0,
        13
      ],
      [
        -1,
        3
      ],
      [
        -2,
        4
      ],
      [
        -1,
        9
      ],
      [
        0,
        10
      ],
      [
        1,
        2
      ],
      [
        -1,
        7
      ],
      [
        -3,
        8
      ],
      [
        -2,
        1
      ],
      [
        -1,
        4
      ],
      [
        -3,
        26
      ],
      [
        -4,
        31
      ],
      [
        -6,
        26
      ],
      [
        -1,
        4
      ]
    ],
    [
      [
        26488,
        52181
      ],
      [
        0,
        187
      ],
      [
        9,
        45
      ],
      [
        0,
        57
      ],
      [
        18,
        0
      ],
      [
        -3,
        32
      ],
      [
        2,
        1
      ],
      [
        -5,
        26
      ],
      [
        -2,
        42
      ],
      [
        0,
        73
      ]
    ],
    [
      [
        26580,
        52628
      ],
      [
        19,
        -4
      ],
      [
        18,
        -4
      ]
    ],
    [
      [
        26559,
        52215
      ],
      [
        -5,
        -26
      ],
      [
        -6,
        -9
      ],
      [
        -6,
        -6
      ],
      [
        -6,
        -24
      ],
      [
        -4,
        -2
      ],
      [
        -2,
        -20
      ],
      [
        2,
        -6
      ],
      [
        -4,
        -40
      ],
      [
        -6,
        -3
      ],
      [
        -2,
        -40
      ],
      [
        -4,
        -7
      ],
      [
        1,
        -11
      ],
      [
        -6,
        -47
      ],
      [
        0,
        -14
      ]
    ],
    [
      [
        26511,
        51960
      ],
      [
        -3,
        14
      ],
      [
        -6,
        8
      ],
      [
        -7,
        0
      ],
      [
        -4,
        -2
      ],
      [
        -4,
        -7
      ]
    ],
    [
      [
        26487,
        51973
      ],
      [
        1,
        208
      ]
    ],
    [
      [
        26835,
        49734
      ],
      [
        0,
        -39
      ],
      [
        4,
        -89
      ],
      [
        9,
        -7
      ],
      [
        -1,
        59
      ],
      [
        1,
        24
      ],
      [
        -1,
        21
      ],
      [
        -1,
        8
      ],
      [
        -3,
        0
      ],
      [
        -2,
        3
      ],
      [
        1,
        20
      ]
    ],
    [
      [
        26884,
        49736
      ],
      [
        1,
        -33
      ],
      [
        0,
        -145
      ]
    ],
    [
      [
        26885,
        49558
      ],
      [
        -6,
        11
      ],
      [
        -5,
        -3
      ],
      [
        3,
        -32
      ],
      [
        -4,
        -19
      ],
      [
        1,
        -6
      ],
      [
        1,
        -8
      ],
      [
        -9,
        -16
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -9
      ],
      [
        1,
        -9
      ],
      [
        0,
        -4
      ],
      [
        3,
        -10
      ],
      [
        3,
        -2
      ],
      [
        2,
        -2
      ],
      [
        2,
        -10
      ],
      [
        4,
        -3
      ],
      [
        12,
        -3
      ],
      [
        -2,
        -8
      ],
      [
        1,
        -15
      ],
      [
        6,
        -20
      ],
      [
        3,
        -19
      ],
      [
        1,
        -16
      ],
      [
        2,
        -9
      ],
      [
        0,
        -23
      ],
      [
        -5,
        -20
      ],
      [
        -3,
        -13
      ],
      [
        -2,
        -9
      ],
      [
        -1,
        -26
      ],
      [
        -1,
        -5
      ],
      [
        2,
        -24
      ],
      [
        0,
        -7
      ],
      [
        -3,
        -19
      ],
      [
        -1,
        -8
      ],
      [
        -4,
        -4
      ],
      [
        -3,
        2
      ],
      [
        -2,
        5
      ],
      [
        -2,
        0
      ],
      [
        0,
        -14
      ],
      [
        -4,
        7
      ],
      [
        -6,
        -2
      ],
      [
        -1,
        -8
      ],
      [
        -2,
        -24
      ],
      [
        1,
        -8
      ],
      [
        1,
        -15
      ],
      [
        1,
        -5
      ],
      [
        4,
        -10
      ],
      [
        -2,
        -15
      ],
      [
        -7,
        -15
      ],
      [
        -1,
        5
      ],
      [
        -3,
        35
      ],
      [
        0,
        15
      ],
      [
        2,
        22
      ],
      [
        0,
        46
      ],
      [
        -2,
        15
      ],
      [
        -2,
        6
      ],
      [
        -2,
        10
      ],
      [
        -3,
        27
      ],
      [
        -3,
        18
      ],
      [
        -2,
        9
      ],
      [
        -9,
        26
      ],
      [
        -2,
        10
      ],
      [
        -2,
        17
      ],
      [
        -3,
        20
      ],
      [
        -1,
        11
      ],
      [
        0,
        27
      ],
      [
        1,
        27
      ],
      [
        2,
        32
      ],
      [
        2,
        29
      ],
      [
        1,
        66
      ],
      [
        0,
        1
      ],
      [
        -5,
        66
      ],
      [
        -4,
        111
      ]
    ],
    [
      [
        22229,
        57818
      ],
      [
        170,
        0
      ],
      [
        4,
        -17
      ],
      [
        2,
        12
      ],
      [
        3,
        1
      ],
      [
        2,
        -10
      ],
      [
        4,
        9
      ],
      [
        6,
        -4
      ],
      [
        1,
        12
      ],
      [
        6,
        6
      ],
      [
        0,
        -11
      ],
      [
        3,
        9
      ],
      [
        3,
        -7
      ],
      [
        2,
        -22
      ]
    ],
    [
      [
        22435,
        57796
      ],
      [
        0,
        -283
      ]
    ],
    [
      [
        22378,
        57210
      ],
      [
        -49,
        0
      ],
      [
        0,
        51
      ],
      [
        -28,
        0
      ]
    ],
    [
      [
        23807,
        58577
      ],
      [
        -1,
        -111
      ],
      [
        0,
        -33
      ],
      [
        -3,
        -314
      ]
    ],
    [
      [
        23715,
        57931
      ],
      [
        -5,
        1
      ],
      [
        -1,
        -17
      ],
      [
        -4,
        0
      ],
      [
        0,
        17
      ],
      [
        -5,
        2
      ],
      [
        0,
        82
      ],
      [
        1,
        146
      ],
      [
        0,
        15
      ],
      [
        1,
        24
      ]
    ],
    [
      [
        22884,
        59436
      ],
      [
        1,
        -24
      ],
      [
        11,
        -30
      ],
      [
        7,
        -5
      ],
      [
        8,
        14
      ],
      [
        11,
        4
      ],
      [
        6,
        23
      ],
      [
        4,
        24
      ],
      [
        0,
        11
      ],
      [
        5,
        21
      ],
      [
        6,
        17
      ],
      [
        8,
        14
      ],
      [
        4,
        -4
      ],
      [
        5,
        -14
      ],
      [
        3,
        -23
      ],
      [
        0,
        -32
      ],
      [
        5,
        -14
      ],
      [
        1,
        -16
      ],
      [
        -4,
        -26
      ],
      [
        2,
        -20
      ],
      [
        6,
        -16
      ],
      [
        4,
        -4
      ],
      [
        11,
        6
      ],
      [
        5,
        -19
      ],
      [
        3,
        -7
      ],
      [
        2,
        -25
      ],
      [
        7,
        -9
      ],
      [
        10,
        30
      ],
      [
        5,
        -15
      ],
      [
        0,
        -25
      ],
      [
        -3,
        -11
      ],
      [
        -7,
        -9
      ],
      [
        -4,
        -19
      ],
      [
        0,
        -19
      ],
      [
        7,
        -21
      ],
      [
        9,
        1
      ],
      [
        4,
        10
      ],
      [
        4,
        26
      ],
      [
        8,
        3
      ],
      [
        3,
        -13
      ],
      [
        4,
        -41
      ],
      [
        3,
        -10
      ],
      [
        10,
        -12
      ],
      [
        13,
        -43
      ],
      [
        3,
        -4
      ],
      [
        7,
        2
      ],
      [
        13,
        -3
      ],
      [
        4,
        -27
      ],
      [
        -8,
        -33
      ],
      [
        1,
        -14
      ]
    ],
    [
      [
        23091,
        59035
      ],
      [
        -9,
        0
      ]
    ],
    [
      [
        22992,
        59033
      ],
      [
        -1,
        0
      ],
      [
        -54,
        -2
      ],
      [
        0,
        102
      ],
      [
        -29,
        0
      ]
    ],
    [
      [
        22908,
        59133
      ],
      [
        0,
        101
      ],
      [
        -30,
        0
      ],
      [
        0,
        203
      ],
      [
        6,
        -1
      ]
    ],
    [
      [
        22935,
        57107
      ],
      [
        87,
        0
      ]
    ],
    [
      [
        23022,
        57107
      ],
      [
        0,
        -100
      ],
      [
        12,
        0
      ],
      [
        5,
        -2
      ],
      [
        13,
        0
      ]
    ],
    [
      [
        23052,
        57005
      ],
      [
        0,
        -304
      ]
    ],
    [
      [
        23052,
        56701
      ],
      [
        -13,
        0
      ],
      [
        0,
        -50
      ],
      [
        -37,
        0
      ]
    ],
    [
      [
        23002,
        56651
      ],
      [
        1,
        13
      ],
      [
        -7,
        17
      ],
      [
        -3,
        25
      ],
      [
        -6,
        8
      ],
      [
        -4,
        -8
      ],
      [
        -4,
        13
      ],
      [
        -74,
        0
      ]
    ],
    [
      [
        23785,
        64175
      ],
      [
        0,
        -123
      ],
      [
        3,
        1
      ],
      [
        1,
        -243
      ]
    ],
    [
      [
        23789,
        63810
      ],
      [
        -1,
        -153
      ]
    ],
    [
      [
        23663,
        63950
      ],
      [
        0,
        100
      ],
      [
        -5,
        0
      ],
      [
        0,
        118
      ]
    ],
    [
      [
        24934,
        53935
      ],
      [
        70,
        19
      ]
    ],
    [
      [
        25004,
        53954
      ],
      [
        0,
        -423
      ]
    ],
    [
      [
        25004,
        53531
      ],
      [
        -14,
        0
      ]
    ],
    [
      [
        15543,
        70934
      ],
      [
        28,
        -1
      ],
      [
        11,
        3
      ]
    ],
    [
      [
        15490,
        70789
      ],
      [
        0,
        7
      ],
      [
        -3,
        0
      ],
      [
        -1,
        -4
      ],
      [
        -5,
        -2
      ],
      [
        -9,
        0
      ],
      [
        -16,
        8
      ],
      [
        -2,
        6
      ],
      [
        0,
        21
      ],
      [
        -1,
        7
      ],
      [
        -2,
        3
      ],
      [
        -3,
        7
      ],
      [
        -7,
        -4
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -6
      ]
    ],
    [
      [
        27052,
        52080
      ],
      [
        59,
        2
      ],
      [
        28,
        0
      ],
      [
        1,
        5
      ],
      [
        6,
        -2
      ],
      [
        2,
        -3
      ],
      [
        7,
        2
      ],
      [
        -3,
        -22
      ],
      [
        0,
        -32
      ],
      [
        3,
        -27
      ]
    ],
    [
      [
        27155,
        52003
      ],
      [
        0,
        -40
      ],
      [
        -3,
        -51
      ],
      [
        2,
        -31
      ],
      [
        4,
        -11
      ],
      [
        12,
        -29
      ],
      [
        6,
        -23
      ],
      [
        1,
        -28
      ],
      [
        -2,
        -26
      ],
      [
        3,
        -47
      ],
      [
        4,
        -36
      ],
      [
        1,
        -5
      ]
    ],
    [
      [
        27183,
        51676
      ],
      [
        -65,
        -4
      ],
      [
        -3,
        -12
      ],
      [
        -11,
        -31
      ],
      [
        -13,
        -7
      ],
      [
        -4,
        -15
      ],
      [
        -2,
        -29
      ],
      [
        -2,
        -10
      ],
      [
        -11,
        0
      ],
      [
        -8,
        -9
      ],
      [
        -6,
        -24
      ],
      [
        -6,
        0
      ]
    ],
    [
      [
        27052,
        51535
      ],
      [
        1,
        33
      ],
      [
        -1,
        359
      ],
      [
        0,
        102
      ]
    ],
    [
      [
        27052,
        52029
      ],
      [
        0,
        51
      ]
    ],
    [
      [
        25989,
        70450
      ],
      [
        -5,
        0
      ],
      [
        -3,
        -1
      ],
      [
        -4,
        -10
      ],
      [
        -4,
        -12
      ],
      [
        -1,
        -12
      ],
      [
        0,
        -7
      ],
      [
        2,
        -5
      ],
      [
        2,
        -7
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        2
      ],
      [
        -10,
        18
      ],
      [
        -12,
        17
      ],
      [
        -15,
        13
      ],
      [
        -6,
        4
      ],
      [
        -6,
        1
      ],
      [
        -8,
        -2
      ],
      [
        -6,
        -9
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        -1
      ],
      [
        -10,
        11
      ],
      [
        -4,
        0
      ],
      [
        -3,
        -5
      ],
      [
        -2,
        -12
      ],
      [
        -2,
        -3
      ],
      [
        -4,
        -1
      ],
      [
        -2,
        4
      ],
      [
        -6,
        -7
      ],
      [
        -11,
        -32
      ],
      [
        -2,
        -10
      ],
      [
        -2,
        -63
      ],
      [
        -5,
        -21
      ],
      [
        -1,
        -34
      ],
      [
        0,
        -8
      ],
      [
        -3,
        -9
      ],
      [
        -2,
        -1
      ],
      [
        -7,
        0
      ],
      [
        -1,
        7
      ],
      [
        -4,
        -2
      ],
      [
        -3,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -11
      ],
      [
        -1,
        -9
      ],
      [
        -2,
        -9
      ],
      [
        -4,
        -4
      ],
      [
        -2,
        1
      ]
    ],
    [
      [
        25823,
        70205
      ],
      [
        1,
        161
      ],
      [
        -9,
        0
      ],
      [
        0,
        305
      ],
      [
        -35,
        1
      ]
    ],
    [
      [
        24276,
        71309
      ],
      [
        2,
        -1
      ],
      [
        5,
        -15
      ],
      [
        4,
        -7
      ],
      [
        3,
        -4
      ],
      [
        6,
        -3
      ],
      [
        15,
        11
      ],
      [
        9,
        3
      ],
      [
        4,
        -3
      ],
      [
        6,
        0
      ],
      [
        8,
        6
      ],
      [
        12,
        16
      ],
      [
        3,
        4
      ],
      [
        26,
        26
      ],
      [
        15,
        23
      ],
      [
        4,
        4
      ],
      [
        7,
        -2
      ]
    ],
    [
      [
        24198,
        70670
      ],
      [
        0,
        303
      ]
    ],
    [
      [
        26508,
        54807
      ],
      [
        -2,
        -10
      ]
    ],
    [
      [
        26506,
        54797
      ],
      [
        -12,
        1
      ]
    ],
    [
      [
        26494,
        54798
      ],
      [
        0,
        10
      ],
      [
        14,
        -1
      ]
    ],
    [
      [
        26438,
        54623
      ],
      [
        0,
        28
      ],
      [
        3,
        6
      ],
      [
        13,
        0
      ],
      [
        21,
        122
      ],
      [
        3,
        10
      ],
      [
        11,
        9
      ],
      [
        5,
        0
      ]
    ],
    [
      [
        26494,
        54798
      ],
      [
        5,
        -10
      ],
      [
        0,
        -19
      ],
      [
        5,
        0
      ],
      [
        0,
        11
      ]
    ],
    [
      [
        26504,
        54780
      ],
      [
        23,
        -1
      ],
      [
        3,
        6
      ],
      [
        -2,
        -32
      ],
      [
        2,
        16
      ],
      [
        6,
        0
      ],
      [
        7,
        -10
      ],
      [
        1,
        -11
      ],
      [
        7,
        -12
      ]
    ],
    [
      [
        26551,
        54736
      ],
      [
        0,
        -34
      ],
      [
        3,
        0
      ],
      [
        0,
        -67
      ],
      [
        -5,
        0
      ],
      [
        0,
        -28
      ],
      [
        2,
        0
      ],
      [
        0,
        -78
      ]
    ],
    [
      [
        26458,
        54458
      ],
      [
        -11,
        1
      ],
      [
        1,
        75
      ],
      [
        -11,
        1
      ],
      [
        1,
        88
      ]
    ],
    [
      [
        23935,
        55375
      ],
      [
        6,
        1
      ],
      [
        5,
        -1
      ],
      [
        36,
        0
      ],
      [
        22,
        -1
      ]
    ],
    [
      [
        24004,
        55374
      ],
      [
        12,
        0
      ],
      [
        22,
        -1
      ],
      [
        7,
        0
      ],
      [
        3,
        -1
      ],
      [
        10,
        -1
      ],
      [
        20,
        0
      ]
    ],
    [
      [
        15693,
        62164
      ],
      [
        3,
        -16
      ],
      [
        4,
        1
      ],
      [
        6,
        -18
      ],
      [
        7,
        -20
      ],
      [
        0,
        -19
      ],
      [
        4,
        -12
      ],
      [
        4,
        -28
      ],
      [
        2,
        -4
      ],
      [
        1,
        -21
      ],
      [
        5,
        -25
      ],
      [
        12,
        -5
      ],
      [
        6,
        -45
      ]
    ],
    [
      [
        15747,
        61952
      ],
      [
        0,
        -52
      ],
      [
        -5,
        -29
      ],
      [
        7,
        -44
      ],
      [
        5,
        -4
      ],
      [
        5,
        -9
      ],
      [
        5,
        -28
      ],
      [
        6,
        -6
      ],
      [
        -1,
        -10
      ],
      [
        3,
        -12
      ],
      [
        -2,
        -6
      ],
      [
        4,
        -31
      ],
      [
        4,
        2
      ],
      [
        2,
        -15
      ],
      [
        7,
        -7
      ],
      [
        1,
        -11
      ],
      [
        -5,
        -22
      ],
      [
        14,
        -52
      ],
      [
        -3,
        -14
      ],
      [
        9,
        -27
      ],
      [
        9,
        -46
      ],
      [
        -3,
        -5
      ],
      [
        0,
        -22
      ],
      [
        5,
        -9
      ],
      [
        -1,
        -15
      ],
      [
        4,
        -19
      ],
      [
        2,
        3
      ],
      [
        3,
        -43
      ],
      [
        2,
        -19
      ],
      [
        -3,
        4
      ],
      [
        -3,
        -46
      ],
      [
        -10,
        -2
      ]
    ],
    [
      [
        15808,
        61356
      ],
      [
        3,
        -16
      ]
    ],
    [
      [
        15811,
        61340
      ],
      [
        -4,
        -7
      ],
      [
        -8,
        -22
      ],
      [
        -3,
        -1
      ],
      [
        -1,
        3
      ],
      [
        -8,
        -5
      ],
      [
        -2,
        -3
      ],
      [
        0,
        -3
      ]
    ],
    [
      [
        15785,
        61302
      ],
      [
        -4,
        7
      ],
      [
        -2,
        19
      ],
      [
        -9,
        31
      ],
      [
        -4,
        2
      ],
      [
        -3,
        31
      ],
      [
        -16,
        -5
      ],
      [
        -6,
        -2
      ],
      [
        -5,
        10
      ],
      [
        -10,
        8
      ],
      [
        -6,
        13
      ],
      [
        -5,
        -1
      ],
      [
        -45,
        128
      ],
      [
        -2,
        5
      ],
      [
        -7,
        -8
      ],
      [
        -9,
        3
      ],
      [
        -10,
        -24
      ]
    ],
    [
      [
        15642,
        61519
      ],
      [
        0,
        1
      ],
      [
        -6,
        16
      ],
      [
        -4,
        4
      ],
      [
        -3,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        1,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        4
      ],
      [
        -3,
        24
      ],
      [
        2,
        15
      ],
      [
        0,
        28
      ],
      [
        -5,
        36
      ],
      [
        -5,
        29
      ],
      [
        -5,
        26
      ],
      [
        -2,
        15
      ],
      [
        -4,
        10
      ],
      [
        -6,
        18
      ],
      [
        -10,
        23
      ],
      [
        -14,
        19
      ],
      [
        -10,
        34
      ],
      [
        -3,
        4
      ],
      [
        -9,
        26
      ],
      [
        -4,
        28
      ],
      [
        -1,
        8
      ],
      [
        -7,
        12
      ],
      [
        -2,
        17
      ],
      [
        -5,
        30
      ],
      [
        -1,
        3
      ],
      [
        -1,
        8
      ],
      [
        -8,
        35
      ],
      [
        -2,
        15
      ],
      [
        -6,
        20
      ],
      [
        -8,
        18
      ],
      [
        -6,
        11
      ],
      [
        -3,
        14
      ],
      [
        -3,
        17
      ]
    ],
    [
      [
        22906,
        57641
      ],
      [
        0,
        -128
      ]
    ],
    [
      [
        22700,
        58073
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        22910,
        63504
      ],
      [
        0,
        406
      ]
    ],
    [
      [
        23497,
        55777
      ],
      [
        2,
        2
      ],
      [
        7,
        -39
      ],
      [
        -1,
        -15
      ],
      [
        9,
        12
      ]
    ],
    [
      [
        23540,
        55214
      ],
      [
        -14,
        0
      ]
    ],
    [
      [
        23522,
        55243
      ],
      [
        -14,
        25
      ],
      [
        -6,
        42
      ],
      [
        -8,
        24
      ]
    ],
    [
      [
        23494,
        55334
      ],
      [
        3,
        443
      ]
    ],
    [
      [
        22700,
        58121
      ],
      [
        0,
        187
      ],
      [
        -1,
        16
      ],
      [
        0,
        203
      ]
    ],
    [
      [
        23204,
        55609
      ],
      [
        5,
        17
      ],
      [
        9,
        10
      ],
      [
        7,
        14
      ],
      [
        4,
        29
      ],
      [
        11,
        30
      ],
      [
        6,
        -4
      ],
      [
        5,
        7
      ],
      [
        5,
        -6
      ],
      [
        16,
        42
      ],
      [
        2,
        14
      ],
      [
        7,
        10
      ],
      [
        8,
        -9
      ],
      [
        6,
        10
      ],
      [
        2,
        -12
      ],
      [
        7,
        -2
      ],
      [
        10,
        11
      ],
      [
        3,
        13
      ],
      [
        4,
        -7
      ],
      [
        11,
        11
      ],
      [
        5,
        -7
      ],
      [
        4,
        5
      ],
      [
        7,
        -10
      ],
      [
        8,
        6
      ],
      [
        2,
        12
      ]
    ],
    [
      [
        23259,
        55308
      ],
      [
        -1,
        22
      ],
      [
        -54,
        0
      ]
    ],
    [
      [
        29083,
        67050
      ],
      [
        61,
        -72
      ],
      [
        15,
        -1
      ],
      [
        109,
        -2
      ]
    ],
    [
      [
        29268,
        66975
      ],
      [
        0,
        -4
      ],
      [
        1,
        -28
      ]
    ],
    [
      [
        29269,
        66943
      ],
      [
        2,
        -64
      ],
      [
        0,
        -4
      ],
      [
        -48,
        -99
      ],
      [
        -2,
        -18
      ]
    ],
    [
      [
        22956,
        60009
      ],
      [
        3,
        1
      ],
      [
        10,
        0
      ],
      [
        50,
        -1
      ]
    ],
    [
      [
        23165,
        60009
      ],
      [
        0,
        -669
      ]
    ],
    [
      [
        23165,
        59340
      ],
      [
        0,
        -306
      ],
      [
        -43,
        0
      ],
      [
        -31,
        1
      ]
    ],
    [
      [
        22884,
        59436
      ],
      [
        4,
        26
      ],
      [
        5,
        7
      ],
      [
        5,
        -1
      ],
      [
        10,
        22
      ],
      [
        6,
        -2
      ],
      [
        4,
        28
      ],
      [
        -7,
        28
      ],
      [
        -2,
        2
      ],
      [
        -8,
        -13
      ],
      [
        -15,
        -8
      ],
      [
        -9,
        4
      ],
      [
        -6,
        8
      ]
    ],
    [
      [
        25627,
        53025
      ],
      [
        31,
        0
      ],
      [
        4,
        1
      ],
      [
        1,
        -1
      ],
      [
        9,
        0
      ],
      [
        1,
        -1
      ],
      [
        20,
        -1
      ],
      [
        40,
        0
      ]
    ],
    [
      [
        25729,
        52312
      ],
      [
        -1,
        0
      ],
      [
        -14,
        -7
      ],
      [
        -16,
        -9
      ],
      [
        -3,
        -3
      ]
    ],
    [
      [
        25695,
        52293
      ],
      [
        0,
        19
      ],
      [
        -43,
        -28
      ],
      [
        -18,
        -17
      ],
      [
        -4,
        1
      ],
      [
        -7,
        -17
      ],
      [
        -9,
        7
      ],
      [
        -6,
        10
      ],
      [
        0,
        25
      ],
      [
        1,
        16
      ],
      [
        21,
        25
      ],
      [
        2,
        6
      ],
      [
        3,
        16
      ],
      [
        -1,
        32
      ],
      [
        4,
        39
      ],
      [
        0,
        17
      ],
      [
        -9,
        41
      ],
      [
        -3,
        7
      ],
      [
        -12,
        16
      ],
      [
        -7,
        48
      ],
      [
        -6,
        18
      ],
      [
        2,
        14
      ],
      [
        -4,
        30
      ],
      [
        0,
        45
      ],
      [
        -2,
        34
      ],
      [
        -8,
        2
      ],
      [
        -3,
        19
      ],
      [
        3,
        29
      ],
      [
        -3,
        31
      ],
      [
        5,
        30
      ],
      [
        -2,
        34
      ],
      [
        -4,
        6
      ],
      [
        5,
        39
      ],
      [
        4,
        9
      ],
      [
        0,
        26
      ],
      [
        -1,
        17
      ],
      [
        5,
        11
      ],
      [
        4,
        -4
      ],
      [
        7,
        35
      ],
      [
        7,
        10
      ],
      [
        11,
        34
      ]
    ],
    [
      [
        27242,
        50557
      ],
      [
        4,
        -19
      ],
      [
        -1,
        -17
      ],
      [
        10,
        -16
      ],
      [
        13,
        -1
      ],
      [
        14,
        -1
      ],
      [
        2,
        -28
      ],
      [
        6,
        -19
      ],
      [
        3,
        6
      ],
      [
        2,
        -18
      ],
      [
        6,
        12
      ],
      [
        5,
        -1
      ],
      [
        4,
        27
      ],
      [
        -1,
        8
      ],
      [
        6,
        8
      ],
      [
        2,
        -8
      ],
      [
        9,
        -10
      ],
      [
        4,
        -46
      ],
      [
        -3,
        -27
      ],
      [
        7,
        -29
      ],
      [
        1,
        -18
      ],
      [
        5,
        -19
      ],
      [
        -1,
        -22
      ],
      [
        2,
        -7
      ],
      [
        3,
        -32
      ],
      [
        -2,
        -5
      ],
      [
        6,
        -28
      ]
    ],
    [
      [
        26389,
        53534
      ],
      [
        61,
        -1
      ],
      [
        19,
        5
      ]
    ],
    [
      [
        26469,
        53538
      ],
      [
        -3,
        -30
      ],
      [
        -7,
        -4
      ],
      [
        1,
        -15
      ],
      [
        -6,
        -6
      ],
      [
        -1,
        -43
      ],
      [
        -7,
        1
      ],
      [
        -2,
        -17
      ],
      [
        -6,
        -7
      ],
      [
        -4,
        7
      ],
      [
        -1,
        -11
      ],
      [
        -12,
        -12
      ],
      [
        -7,
        -20
      ],
      [
        1,
        -16
      ],
      [
        -1,
        -15
      ],
      [
        -6,
        -22
      ],
      [
        -1,
        -23
      ],
      [
        -8,
        -12
      ],
      [
        -4,
        -22
      ],
      [
        1,
        -13
      ],
      [
        -2,
        -11
      ],
      [
        -2,
        9
      ],
      [
        -12,
        -37
      ],
      [
        -13,
        -49
      ],
      [
        0,
        -53
      ]
    ],
    [
      [
        26061,
        57664
      ],
      [
        15,
        0
      ],
      [
        22,
        -1
      ]
    ],
    [
      [
        26098,
        57663
      ],
      [
        2,
        -1
      ],
      [
        23,
        1
      ],
      [
        6,
        0
      ]
    ],
    [
      [
        26068,
        57520
      ],
      [
        -4,
        74
      ],
      [
        -1,
        24
      ],
      [
        0,
        8
      ],
      [
        -2,
        38
      ]
    ],
    [
      [
        26383,
        53750
      ],
      [
        43,
        0
      ]
    ],
    [
      [
        26426,
        53750
      ],
      [
        10,
        1
      ],
      [
        61,
        1
      ],
      [
        4,
        29
      ],
      [
        3,
        2
      ]
    ],
    [
      [
        26504,
        53783
      ],
      [
        6,
        0
      ],
      [
        -5,
        -19
      ],
      [
        5,
        -10
      ],
      [
        -1,
        -137
      ],
      [
        0,
        -37
      ],
      [
        5,
        -15
      ],
      [
        -5,
        0
      ],
      [
        0,
        -22
      ]
    ],
    [
      [
        26509,
        53543
      ],
      [
        -33,
        -2
      ],
      [
        -6,
        0
      ],
      [
        -1,
        -3
      ]
    ],
    [
      [
        26509,
        53543
      ],
      [
        0,
        -127
      ]
    ],
    [
      [
        26509,
        53416
      ],
      [
        -1,
        -260
      ],
      [
        -3,
        -11
      ],
      [
        3,
        0
      ],
      [
        0,
        -29
      ]
    ],
    [
      [
        26265,
        52709
      ],
      [
        -3,
        6
      ],
      [
        0,
        3
      ],
      [
        -1,
        7
      ],
      [
        -2,
        11
      ],
      [
        0,
        1
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        2
      ],
      [
        0,
        10
      ],
      [
        -2,
        6
      ],
      [
        1,
        7
      ],
      [
        0,
        7
      ],
      [
        -3,
        14
      ],
      [
        0,
        17
      ],
      [
        -1,
        6
      ],
      [
        -1,
        8
      ],
      [
        0,
        20
      ],
      [
        1,
        4
      ],
      [
        1,
        3
      ],
      [
        0,
        8
      ],
      [
        -1,
        2
      ],
      [
        0,
        3
      ],
      [
        -1,
        3
      ],
      [
        0,
        16
      ],
      [
        -1,
        3
      ],
      [
        0,
        7
      ],
      [
        1,
        3
      ],
      [
        0,
        7
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -2,
        11
      ],
      [
        -1,
        5
      ],
      [
        -1,
        6
      ],
      [
        -3,
        12
      ],
      [
        0,
        5
      ],
      [
        -1,
        7
      ],
      [
        -1,
        3
      ],
      [
        -2,
        3
      ],
      [
        0,
        16
      ],
      [
        1,
        9
      ],
      [
        0,
        8
      ],
      [
        -1,
        5
      ],
      [
        -2,
        4
      ],
      [
        -2,
        3
      ],
      [
        -1,
        0
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        -1,
        2
      ],
      [
        0,
        4
      ],
      [
        1,
        8
      ],
      [
        1,
        12
      ],
      [
        0,
        4
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        26229,
        53027
      ],
      [
        1,
        5
      ],
      [
        -3,
        56
      ],
      [
        -4,
        26
      ]
    ],
    [
      [
        22788,
        59032
      ],
      [
        60,
        0
      ],
      [
        -1,
        101
      ],
      [
        61,
        0
      ]
    ],
    [
      [
        26153,
        59576
      ],
      [
        23,
        -2
      ],
      [
        27,
        -3
      ],
      [
        3,
        -1
      ],
      [
        17,
        -3
      ],
      [
        11,
        -3
      ],
      [
        3,
        -1
      ]
    ],
    [
      [
        26132,
        60234
      ],
      [
        -8,
        -28
      ],
      [
        -15,
        -27
      ],
      [
        -26,
        -41
      ]
    ],
    [
      [
        23021,
        55137
      ],
      [
        0,
        197
      ]
    ],
    [
      [
        31858,
        38286
      ],
      [
        4,
        18
      ],
      [
        5,
        1
      ],
      [
        3,
        0
      ],
      [
        1,
        20
      ],
      [
        1,
        2
      ],
      [
        4,
        -3
      ],
      [
        0,
        -8
      ],
      [
        4,
        -1
      ],
      [
        0,
        5
      ],
      [
        2,
        1
      ],
      [
        3,
        -7
      ],
      [
        2,
        1
      ],
      [
        2,
        -4
      ],
      [
        1,
        -6
      ],
      [
        2,
        -6
      ],
      [
        1,
        2
      ],
      [
        4,
        -8
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        2
      ],
      [
        -4,
        8
      ],
      [
        -4,
        1
      ],
      [
        1,
        -11
      ],
      [
        2,
        -11
      ],
      [
        -2,
        -13
      ],
      [
        1,
        -8
      ],
      [
        -1,
        -6
      ],
      [
        -5,
        12
      ],
      [
        -4,
        8
      ],
      [
        -6,
        2
      ],
      [
        -3,
        -7
      ],
      [
        -4,
        0
      ],
      [
        -3,
        7
      ],
      [
        -2,
        13
      ],
      [
        0,
        11
      ]
    ],
    [
      [
        31846,
        38320
      ],
      [
        2,
        0
      ],
      [
        7,
        8
      ],
      [
        4,
        -2
      ],
      [
        0,
        -9
      ],
      [
        -2,
        -14
      ],
      [
        -9,
        0
      ],
      [
        -2,
        -2
      ]
    ],
    [
      [
        20681,
        54191
      ],
      [
        0,
        -218
      ],
      [
        2,
        -947
      ],
      [
        1,
        -18
      ],
      [
        0,
        -173
      ],
      [
        -3,
        0
      ],
      [
        0,
        -201
      ]
    ],
    [
      [
        20663,
        52594
      ],
      [
        -1,
        7
      ],
      [
        0,
        31
      ],
      [
        -4,
        13
      ],
      [
        -1,
        10
      ],
      [
        -1,
        6
      ],
      [
        -4,
        -3
      ],
      [
        -6,
        4
      ],
      [
        -2,
        -7
      ],
      [
        -3,
        6
      ],
      [
        -1,
        14
      ],
      [
        -9,
        24
      ],
      [
        -3,
        13
      ],
      [
        -1,
        9
      ],
      [
        0,
        6
      ],
      [
        -1,
        3
      ],
      [
        -2,
        4
      ],
      [
        -5,
        4
      ],
      [
        -4,
        -1
      ],
      [
        -1,
        3
      ],
      [
        -1,
        3
      ],
      [
        0,
        12
      ],
      [
        -1,
        6
      ],
      [
        -4,
        0
      ],
      [
        -1,
        5
      ],
      [
        -1,
        9
      ],
      [
        -2,
        9
      ],
      [
        -4,
        -7
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        2
      ],
      [
        0,
        12
      ],
      [
        -1,
        5
      ],
      [
        -5,
        2
      ],
      [
        -5,
        -7
      ],
      [
        -2,
        1
      ],
      [
        -7,
        28
      ],
      [
        -2,
        0
      ],
      [
        -3,
        -6
      ],
      [
        -3,
        0
      ],
      [
        -1,
        9
      ],
      [
        0,
        3
      ],
      [
        -8,
        13
      ],
      [
        -4,
        10
      ],
      [
        -4,
        2
      ],
      [
        -5,
        5
      ],
      [
        -1,
        3
      ],
      [
        1,
        19
      ],
      [
        -1,
        20
      ],
      [
        -4,
        12
      ],
      [
        -5,
        7
      ],
      [
        -16,
        44
      ],
      [
        -3,
        8
      ],
      [
        0,
        8
      ],
      [
        -1,
        7
      ],
      [
        -9,
        25
      ],
      [
        -3,
        0
      ],
      [
        -3,
        7
      ],
      [
        -6,
        36
      ],
      [
        -1,
        6
      ],
      [
        0,
        10
      ],
      [
        -1,
        26
      ],
      [
        -3,
        9
      ],
      [
        -1,
        11
      ],
      [
        -1,
        9
      ],
      [
        -7,
        19
      ],
      [
        -4,
        0
      ],
      [
        -1,
        18
      ],
      [
        -1,
        2
      ],
      [
        -17,
        24
      ],
      [
        -2,
        6
      ],
      [
        -1,
        9
      ],
      [
        -6,
        18
      ],
      [
        -6,
        -1
      ],
      [
        -3,
        3
      ],
      [
        -1,
        19
      ],
      [
        0,
        10
      ],
      [
        -1,
        7
      ],
      [
        -3,
        5
      ],
      [
        -7,
        34
      ],
      [
        -5,
        18
      ],
      [
        -9,
        49
      ],
      [
        -2,
        3
      ],
      [
        -4,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -3,
        18
      ],
      [
        -1,
        7
      ],
      [
        -7,
        1
      ],
      [
        -2,
        6
      ],
      [
        -2,
        25
      ],
      [
        0,
        15
      ],
      [
        -2,
        14
      ],
      [
        -4,
        1
      ],
      [
        -8,
        24
      ]
    ],
    [
      [
        20380,
        53476
      ],
      [
        12,
        43
      ],
      [
        -1,
        0
      ],
      [
        0,
        64
      ],
      [
        -10,
        0
      ],
      [
        0,
        234
      ],
      [
        -1,
        376
      ]
    ],
    [
      [
        27199,
        61888
      ],
      [
        -7,
        69
      ],
      [
        4,
        64
      ],
      [
        3,
        114
      ],
      [
        -1,
        89
      ],
      [
        6,
        19
      ]
    ],
    [
      [
        25131,
        53986
      ],
      [
        10,
        2
      ]
    ],
    [
      [
        25141,
        53988
      ],
      [
        28,
        8
      ],
      [
        13,
        3
      ],
      [
        38,
        24
      ],
      [
        18,
        18
      ],
      [
        24,
        26
      ]
    ],
    [
      [
        25265,
        53839
      ],
      [
        0,
        -1
      ],
      [
        1,
        -86
      ],
      [
        0,
        -2
      ],
      [
        2,
        -142
      ],
      [
        0,
        -21
      ],
      [
        1,
        -26
      ],
      [
        0,
        -28
      ]
    ],
    [
      [
        25269,
        53533
      ],
      [
        -52,
        -2
      ],
      [
        -57,
        0
      ]
    ],
    [
      [
        25131,
        53531
      ],
      [
        0,
        455
      ]
    ],
    [
      [
        24717,
        67229
      ],
      [
        0,
        -21
      ],
      [
        1,
        -431
      ]
    ],
    [
      [
        24718,
        66777
      ],
      [
        0,
        -356
      ]
    ],
    [
      [
        24587,
        66617
      ],
      [
        -1,
        1
      ],
      [
        -3,
        8
      ],
      [
        -3,
        3
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -2,
        2
      ],
      [
        -1,
        1
      ],
      [
        -4,
        8
      ],
      [
        -2,
        2
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        -2,
        12
      ],
      [
        -2,
        6
      ],
      [
        -2,
        2
      ],
      [
        -2,
        5
      ],
      [
        -2,
        -1
      ],
      [
        -3,
        6
      ],
      [
        -1,
        3
      ],
      [
        0,
        6
      ],
      [
        -1,
        3
      ],
      [
        0,
        3
      ],
      [
        -2,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        0,
        11
      ],
      [
        -1,
        2
      ],
      [
        0,
        1
      ],
      [
        -2,
        1
      ],
      [
        0,
        7
      ],
      [
        1,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        3
      ],
      [
        -1,
        2
      ],
      [
        -2,
        7
      ],
      [
        0,
        15
      ],
      [
        -1,
        6
      ],
      [
        -1,
        9
      ],
      [
        0,
        13
      ],
      [
        -1,
        16
      ],
      [
        0,
        8
      ],
      [
        -1,
        3
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        2
      ],
      [
        0,
        5
      ],
      [
        1,
        17
      ],
      [
        0,
        2
      ],
      [
        -1,
        4
      ],
      [
        -1,
        6
      ],
      [
        0,
        18
      ],
      [
        -1,
        9
      ],
      [
        -1,
        3
      ],
      [
        -2,
        6
      ],
      [
        -1,
        4
      ],
      [
        0,
        2
      ],
      [
        -6,
        9
      ],
      [
        -2,
        1
      ],
      [
        0,
        30
      ],
      [
        -1,
        11
      ],
      [
        0,
        8
      ],
      [
        1,
        11
      ],
      [
        0,
        8
      ],
      [
        -1,
        3
      ],
      [
        -1,
        5
      ],
      [
        -1,
        7
      ],
      [
        0,
        14
      ]
    ],
    [
      [
        24407,
        53901
      ],
      [
        16,
        -1
      ],
      [
        24,
        3
      ],
      [
        6,
        -7
      ],
      [
        0,
        -17
      ]
    ],
    [
      [
        24453,
        53879
      ],
      [
        -1,
        0
      ],
      [
        -4,
        -25
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -14
      ],
      [
        0,
        -11
      ],
      [
        1,
        -30
      ],
      [
        0,
        -27
      ],
      [
        -1,
        -15
      ],
      [
        0,
        -7
      ],
      [
        -5,
        -8
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        0
      ],
      [
        -2,
        1
      ],
      [
        -8,
        9
      ],
      [
        -3,
        6
      ],
      [
        -1,
        4
      ],
      [
        -1,
        3
      ],
      [
        -1,
        7
      ],
      [
        -2,
        8
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -6
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -18
      ],
      [
        1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        3,
        -13
      ],
      [
        3,
        -7
      ],
      [
        1,
        -3
      ],
      [
        1,
        -2
      ],
      [
        5,
        0
      ],
      [
        3,
        2
      ],
      [
        6,
        9
      ],
      [
        1,
        1
      ],
      [
        3,
        1
      ],
      [
        1,
        -1
      ],
      [
        1,
        -1
      ],
      [
        3,
        -6
      ],
      [
        -1,
        -16
      ],
      [
        0,
        -8
      ],
      [
        -2,
        -9
      ],
      [
        -3,
        -8
      ],
      [
        -4,
        -10
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -4
      ],
      [
        -8,
        -11
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -2,
        2
      ],
      [
        -3,
        -2
      ],
      [
        -3,
        0
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -8
      ],
      [
        0,
        -13
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -44
      ],
      [
        1,
        -13
      ],
      [
        0,
        -6
      ],
      [
        1,
        -6
      ],
      [
        1,
        -9
      ],
      [
        2,
        -12
      ],
      [
        3,
        -10
      ],
      [
        3,
        -9
      ],
      [
        1,
        -8
      ],
      [
        1,
        -2
      ],
      [
        0,
        -29
      ],
      [
        -2,
        -7
      ],
      [
        -7,
        0
      ],
      [
        -1,
        1
      ],
      [
        -2,
        5
      ],
      [
        -2,
        6
      ],
      [
        -1,
        6
      ],
      [
        -2,
        11
      ],
      [
        -2,
        28
      ],
      [
        0,
        5
      ],
      [
        1,
        6
      ],
      [
        0,
        1
      ],
      [
        -1,
        7
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -3,
        -6
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -10
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -5
      ],
      [
        2,
        -10
      ],
      [
        0,
        -7
      ],
      [
        1,
        -8
      ],
      [
        2,
        6
      ],
      [
        0,
        2
      ],
      [
        2,
        2
      ],
      [
        0,
        -1
      ],
      [
        2,
        -4
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -34
      ],
      [
        1,
        -4
      ],
      [
        3,
        -6
      ],
      [
        1,
        -6
      ],
      [
        0,
        -2
      ],
      [
        4,
        -10
      ],
      [
        2,
        -7
      ],
      [
        1,
        -2
      ],
      [
        0,
        -27
      ],
      [
        -1,
        -9
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -3
      ],
      [
        -5,
        -10
      ],
      [
        -5,
        -5
      ],
      [
        -6,
        -2
      ],
      [
        -3,
        2
      ],
      [
        -6,
        4
      ],
      [
        -4,
        2
      ],
      [
        -4,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -6
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -7
      ],
      [
        1,
        -8
      ],
      [
        2,
        -10
      ],
      [
        5,
        -10
      ],
      [
        7,
        -20
      ],
      [
        2,
        -8
      ],
      [
        1,
        -9
      ],
      [
        0,
        -3
      ]
    ],
    [
      [
        24394,
        53249
      ],
      [
        0,
        -21
      ],
      [
        -2,
        -12
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        -5,
        -21
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -20
      ],
      [
        1,
        -8
      ],
      [
        1,
        -3
      ],
      [
        1,
        -3
      ],
      [
        2,
        -4
      ],
      [
        4,
        -11
      ],
      [
        7,
        -25
      ],
      [
        1,
        -4
      ],
      [
        1,
        -7
      ],
      [
        0,
        -17
      ],
      [
        -1,
        -9
      ],
      [
        -2,
        -10
      ],
      [
        -2,
        -7
      ],
      [
        -3,
        -8
      ],
      [
        -5,
        -7
      ],
      [
        -5,
        -7
      ],
      [
        -3,
        -7
      ]
    ],
    [
      [
        24357,
        53078
      ],
      [
        4,
        39
      ],
      [
        -2,
        18
      ],
      [
        3,
        14
      ],
      [
        -4,
        34
      ],
      [
        3,
        22
      ],
      [
        2,
        9
      ],
      [
        4,
        1
      ],
      [
        3,
        30
      ],
      [
        -4,
        16
      ],
      [
        -5,
        8
      ],
      [
        -4,
        -11
      ],
      [
        -4,
        6
      ],
      [
        -6,
        21
      ],
      [
        -5,
        0
      ],
      [
        -10,
        17
      ],
      [
        0,
        16
      ],
      [
        -6,
        18
      ]
    ],
    [
      [
        24326,
        53336
      ],
      [
        3,
        13
      ],
      [
        0,
        18
      ],
      [
        -5,
        -1
      ],
      [
        -6,
        12
      ],
      [
        -1,
        16
      ],
      [
        1,
        45
      ],
      [
        5,
        25
      ],
      [
        4,
        3
      ],
      [
        6,
        -9
      ],
      [
        6,
        4
      ],
      [
        3,
        12
      ],
      [
        -2,
        12
      ],
      [
        -9,
        1
      ],
      [
        -8,
        16
      ],
      [
        -3,
        16
      ],
      [
        -2,
        50
      ],
      [
        2,
        16
      ],
      [
        0,
        18
      ],
      [
        2,
        7
      ],
      [
        4,
        -1
      ],
      [
        3,
        -12
      ],
      [
        5,
        -60
      ],
      [
        6,
        3
      ],
      [
        5,
        -10
      ],
      [
        8,
        -2
      ],
      [
        4,
        9
      ],
      [
        1,
        12
      ],
      [
        -2,
        17
      ],
      [
        -3,
        4
      ],
      [
        -12,
        1
      ],
      [
        -5,
        6
      ],
      [
        -1,
        21
      ],
      [
        5,
        13
      ],
      [
        2,
        15
      ],
      [
        -1,
        18
      ],
      [
        -9,
        28
      ],
      [
        -4,
        20
      ],
      [
        1,
        30
      ],
      [
        0,
        2
      ],
      [
        1,
        8
      ],
      [
        1,
        14
      ],
      [
        3,
        14
      ],
      [
        9,
        21
      ],
      [
        5,
        -30
      ],
      [
        5,
        -10
      ],
      [
        3,
        8
      ],
      [
        6,
        25
      ],
      [
        -3,
        39
      ],
      [
        4,
        31
      ],
      [
        1,
        34
      ],
      [
        3,
        12
      ],
      [
        2,
        1
      ],
      [
        5,
        -16
      ],
      [
        7,
        0
      ],
      [
        6,
        19
      ],
      [
        4,
        19
      ],
      [
        5,
        -7
      ],
      [
        3,
        -24
      ],
      [
        7,
        -15
      ],
      [
        3,
        11
      ],
      [
        0,
        13
      ],
      [
        -2,
        10
      ]
    ],
    [
      [
        23448,
        54622
      ],
      [
        0,
        -271
      ]
    ],
    [
      [
        23448,
        54351
      ],
      [
        -68,
        -2
      ],
      [
        -64,
        -1
      ]
    ],
    [
      [
        23316,
        54348
      ],
      [
        -5,
        13
      ],
      [
        4,
        64
      ],
      [
        -4,
        12
      ],
      [
        -3,
        27
      ],
      [
        6,
        13
      ],
      [
        -1,
        18
      ],
      [
        4,
        13
      ],
      [
        2,
        26
      ],
      [
        -3,
        38
      ],
      [
        3,
        32
      ]
    ],
    [
      [
        29287,
        69318
      ],
      [
        5,
        -107
      ],
      [
        1,
        -37
      ],
      [
        0,
        -41
      ],
      [
        6,
        -150
      ],
      [
        5,
        1
      ],
      [
        6,
        -156
      ],
      [
        3,
        2
      ],
      [
        7,
        -171
      ]
    ],
    [
      [
        29092,
        69317
      ],
      [
        1,
        4
      ],
      [
        6,
        6
      ],
      [
        5,
        -4
      ],
      [
        2,
        0
      ],
      [
        1,
        1
      ],
      [
        2,
        1
      ],
      [
        1,
        -3
      ],
      [
        32,
        -1
      ],
      [
        25,
        -2
      ],
      [
        34,
        -5
      ],
      [
        28,
        0
      ],
      [
        25,
        -1
      ],
      [
        33,
        5
      ]
    ],
    [
      [
        24398,
        54053
      ],
      [
        2,
        13
      ],
      [
        7,
        24
      ],
      [
        5,
        2
      ],
      [
        4,
        17
      ],
      [
        0,
        28
      ],
      [
        -5,
        6
      ],
      [
        5,
        18
      ],
      [
        -1,
        12
      ],
      [
        5,
        6
      ],
      [
        0,
        23
      ],
      [
        -4,
        12
      ],
      [
        3,
        30
      ],
      [
        0,
        23
      ],
      [
        2,
        4
      ],
      [
        1,
        23
      ],
      [
        -6,
        10
      ],
      [
        3,
        9
      ],
      [
        -1,
        47
      ],
      [
        3,
        12
      ],
      [
        0,
        55
      ]
    ],
    [
      [
        24421,
        54427
      ],
      [
        48,
        -1
      ],
      [
        1,
        6
      ],
      [
        13,
        27
      ],
      [
        10,
        -24
      ],
      [
        5,
        26
      ],
      [
        9,
        15
      ],
      [
        14,
        4
      ],
      [
        4,
        -11
      ],
      [
        0,
        -29
      ],
      [
        -1,
        -4
      ]
    ],
    [
      [
        24544,
        54335
      ],
      [
        2,
        -3
      ],
      [
        2,
        -2
      ],
      [
        2,
        0
      ]
    ],
    [
      [
        24550,
        54323
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -4
      ],
      [
        -8,
        -15
      ],
      [
        -4,
        -7
      ],
      [
        0,
        -36
      ],
      [
        -1,
        -1
      ],
      [
        -4,
        1
      ],
      [
        -1,
        3
      ],
      [
        -3,
        9
      ],
      [
        -3,
        16
      ],
      [
        -1,
        5
      ],
      [
        -2,
        5
      ],
      [
        -1,
        1
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -9
      ],
      [
        1,
        -5
      ],
      [
        1,
        -4
      ],
      [
        1,
        -4
      ],
      [
        2,
        -3
      ],
      [
        6,
        -4
      ],
      [
        8,
        -6
      ],
      [
        2,
        -4
      ],
      [
        1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        1,
        -6
      ],
      [
        0,
        -6
      ],
      [
        1,
        -1
      ],
      [
        -4,
        -20
      ],
      [
        -1,
        -6
      ],
      [
        -3,
        -5
      ],
      [
        -3,
        -4
      ],
      [
        -13,
        -5
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -7
      ],
      [
        -2,
        -9
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -17
      ],
      [
        -1,
        -13
      ],
      [
        0,
        -2
      ],
      [
        2,
        2
      ],
      [
        0,
        -14
      ],
      [
        1,
        -4
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        -5,
        -18
      ],
      [
        -2,
        -9
      ],
      [
        -4,
        -8
      ]
    ],
    [
      [
        24470,
        53894
      ],
      [
        -5,
        -2
      ],
      [
        -6,
        -3
      ],
      [
        -6,
        -10
      ]
    ],
    [
      [
        24407,
        53901
      ],
      [
        -10,
        51
      ],
      [
        3,
        37
      ],
      [
        -2,
        64
      ]
    ],
    [
      [
        24394,
        53249
      ],
      [
        4,
        38
      ],
      [
        4,
        13
      ],
      [
        6,
        4
      ],
      [
        3,
        -10
      ],
      [
        0,
        -18
      ],
      [
        6,
        13
      ],
      [
        6,
        2
      ],
      [
        2,
        13
      ],
      [
        0,
        25
      ],
      [
        -5,
        19
      ],
      [
        1,
        9
      ],
      [
        6,
        2
      ],
      [
        1,
        39
      ],
      [
        12,
        -5
      ],
      [
        3,
        10
      ],
      [
        6,
        1
      ],
      [
        2,
        13
      ],
      [
        5,
        0
      ],
      [
        3,
        9
      ],
      [
        4,
        -4
      ],
      [
        3,
        14
      ],
      [
        7,
        10
      ],
      [
        7,
        -3
      ],
      [
        2,
        12
      ],
      [
        5,
        -10
      ],
      [
        7,
        15
      ],
      [
        5,
        -18
      ],
      [
        7,
        -9
      ],
      [
        8,
        -3
      ]
    ],
    [
      [
        24514,
        53430
      ],
      [
        12,
        -31
      ],
      [
        6,
        1
      ]
    ],
    [
      [
        25141,
        53988
      ],
      [
        -1,
        126
      ],
      [
        0,
        337
      ]
    ],
    [
      [
        22407,
        69607
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        25504,
        57687
      ],
      [
        -2,
        17
      ],
      [
        2,
        20
      ],
      [
        8,
        -1
      ],
      [
        1,
        16
      ],
      [
        -4,
        11
      ],
      [
        -1,
        98
      ],
      [
        5,
        56
      ],
      [
        -1,
        40
      ],
      [
        1,
        202
      ]
    ],
    [
      [
        25004,
        53531
      ],
      [
        71,
        0
      ]
    ],
    [
      [
        25021,
        52921
      ],
      [
        0,
        106
      ],
      [
        -3,
        11
      ]
    ],
    [
      [
        15540,
        71409
      ],
      [
        5,
        2
      ],
      [
        53,
        0
      ]
    ],
    [
      [
        15598,
        71411
      ],
      [
        0,
        -34
      ],
      [
        152,
        -3
      ],
      [
        18,
        2
      ],
      [
        18,
        -2
      ],
      [
        3,
        1
      ],
      [
        76,
        0
      ]
    ],
    [
      [
        16073,
        71399
      ],
      [
        4,
        -29
      ],
      [
        5,
        -1
      ],
      [
        -2,
        -18
      ],
      [
        7,
        -16
      ],
      [
        10,
        -3
      ],
      [
        5,
        -16
      ],
      [
        -7,
        -8
      ],
      [
        0,
        -22
      ],
      [
        -9,
        -3
      ],
      [
        -1,
        -41
      ],
      [
        5,
        -3
      ],
      [
        2,
        -29
      ],
      [
        -5,
        -23
      ],
      [
        0,
        -22
      ],
      [
        -5,
        -14
      ],
      [
        3,
        -14
      ],
      [
        -5,
        -22
      ],
      [
        -6,
        -7
      ],
      [
        1,
        -35
      ],
      [
        7,
        -12
      ],
      [
        -3,
        -20
      ],
      [
        6,
        -19
      ],
      [
        2,
        -33
      ],
      [
        6,
        -24
      ],
      [
        -2,
        -24
      ],
      [
        -1,
        -2
      ],
      [
        -35,
        0
      ]
    ],
    [
      [
        16055,
        70939
      ],
      [
        -165,
        -2
      ],
      [
        -34,
        -1
      ],
      [
        -2,
        0
      ]
    ],
    [
      [
        27736,
        60060
      ],
      [
        9,
        -9
      ],
      [
        1,
        11
      ],
      [
        5,
        2
      ],
      [
        13,
        -28
      ],
      [
        4,
        -19
      ],
      [
        5,
        19
      ],
      [
        -6,
        16
      ],
      [
        1,
        9
      ],
      [
        -3,
        17
      ],
      [
        4,
        7
      ],
      [
        9,
        -10
      ]
    ],
    [
      [
        27778,
        60075
      ],
      [
        11,
        10
      ],
      [
        0,
        32
      ],
      [
        5,
        2
      ],
      [
        5,
        20
      ],
      [
        -4,
        8
      ],
      [
        11,
        10
      ],
      [
        1,
        13
      ],
      [
        2,
        -13
      ],
      [
        10,
        -25
      ],
      [
        7,
        8
      ],
      [
        3,
        23
      ],
      [
        5,
        -8
      ],
      [
        2,
        -23
      ],
      [
        4,
        -4
      ],
      [
        0,
        12
      ],
      [
        2,
        8
      ],
      [
        4,
        -23
      ],
      [
        -2,
        -25
      ],
      [
        4,
        -26
      ],
      [
        3,
        17
      ],
      [
        11,
        8
      ],
      [
        4,
        16
      ],
      [
        6,
        -26
      ],
      [
        4,
        -7
      ]
    ],
    [
      [
        27841,
        59477
      ],
      [
        -9,
        -1
      ],
      [
        -26,
        0
      ]
    ],
    [
      [
        27771,
        59476
      ],
      [
        -12,
        0
      ]
    ],
    [
      [
        28050,
        62940
      ],
      [
        8,
        -19
      ],
      [
        26,
        -40
      ]
    ],
    [
      [
        28084,
        62881
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -4
      ],
      [
        0,
        -19
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -7
      ],
      [
        1,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -4
      ],
      [
        1,
        -6
      ],
      [
        2,
        -8
      ],
      [
        0,
        -5
      ],
      [
        2,
        -5
      ],
      [
        -4,
        -20
      ],
      [
        -2,
        -10
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        4,
        -3
      ],
      [
        2,
        -2
      ],
      [
        1,
        -4
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        0,
        1
      ],
      [
        -2,
        -4
      ],
      [
        1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        -4,
        -23
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        -12
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -2
      ],
      [
        -3,
        -13
      ],
      [
        -2,
        -8
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        1,
        0
      ],
      [
        1,
        -3
      ],
      [
        3,
        -10
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -8
      ],
      [
        -3,
        -16
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        1,
        0
      ],
      [
        2,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -6
      ],
      [
        1,
        -5
      ],
      [
        4,
        -11
      ],
      [
        1,
        -2
      ],
      [
        1,
        -5
      ],
      [
        -3,
        -8
      ],
      [
        0,
        -2
      ],
      [
        -4,
        -7
      ],
      [
        -2,
        -12
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -4
      ],
      [
        -6,
        -21
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        2
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        -8
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -9
      ],
      [
        -1,
        -3
      ]
    ],
    [
      [
        28039,
        62442
      ],
      [
        -15,
        50
      ],
      [
        -12,
        10
      ],
      [
        -5,
        -25
      ],
      [
        -10,
        8
      ],
      [
        -11,
        26
      ],
      [
        -10,
        2
      ],
      [
        -30,
        40
      ],
      [
        -16,
        17
      ],
      [
        -23,
        45
      ]
    ],
    [
      [
        16179,
        63034
      ],
      [
        19,
        49
      ]
    ],
    [
      [
        16122,
        62379
      ],
      [
        -7,
        21
      ],
      [
        -7,
        -13
      ],
      [
        -10,
        -11
      ],
      [
        -13,
        -42
      ]
    ],
    [
      [
        16085,
        62334
      ],
      [
        -8,
        -3
      ],
      [
        -4,
        5
      ],
      [
        -9,
        -7
      ],
      [
        -10,
        -24
      ],
      [
        -5,
        1
      ],
      [
        -3,
        -21
      ],
      [
        -5,
        -18
      ],
      [
        -1,
        -23
      ],
      [
        -2,
        20
      ],
      [
        1,
        13
      ],
      [
        -3,
        50
      ],
      [
        3,
        19
      ],
      [
        -6,
        6
      ],
      [
        2,
        14
      ],
      [
        -4,
        11
      ],
      [
        -1,
        29
      ],
      [
        7,
        37
      ],
      [
        0,
        14
      ],
      [
        -5,
        -2
      ],
      [
        2,
        32
      ],
      [
        -6,
        64
      ],
      [
        1,
        9
      ],
      [
        -4,
        17
      ],
      [
        2,
        1
      ],
      [
        2,
        27
      ],
      [
        -4,
        0
      ],
      [
        -2,
        20
      ],
      [
        0,
        18
      ],
      [
        4,
        2
      ],
      [
        -3,
        33
      ],
      [
        2,
        5
      ]
    ],
    [
      [
        28250,
        65829
      ],
      [
        39,
        1
      ]
    ],
    [
      [
        28292,
        65224
      ],
      [
        -109,
        -5
      ]
    ],
    [
      [
        28124,
        65386
      ],
      [
        -1,
        444
      ]
    ],
    [
      [
        22647,
        47611
      ],
      [
        0,
        -324
      ],
      [
        -2,
        -15
      ]
    ],
    [
      [
        22645,
        47272
      ],
      [
        -1,
        1
      ],
      [
        -2,
        8
      ],
      [
        -2,
        2
      ],
      [
        -8,
        -11
      ],
      [
        -6,
        -5
      ],
      [
        -2,
        8
      ],
      [
        -2,
        3
      ],
      [
        -5,
        -12
      ],
      [
        -3,
        9
      ],
      [
        -1,
        9
      ],
      [
        -8,
        -4
      ],
      [
        -5,
        3
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -11
      ],
      [
        -2,
        -12
      ],
      [
        -8,
        8
      ],
      [
        0,
        4
      ],
      [
        -2,
        19
      ],
      [
        -1,
        3
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        2
      ],
      [
        -2,
        8
      ],
      [
        -6,
        -6
      ],
      [
        -1,
        0
      ],
      [
        -5,
        -15
      ],
      [
        0,
        8
      ],
      [
        -1,
        2
      ],
      [
        -7,
        20
      ],
      [
        -4,
        -14
      ],
      [
        0,
        -7
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        4
      ],
      [
        -1,
        5
      ],
      [
        0,
        3
      ],
      [
        -4,
        12
      ],
      [
        -3,
        1
      ],
      [
        -5,
        -5
      ],
      [
        -5,
        14
      ],
      [
        -3,
        16
      ],
      [
        1,
        8
      ],
      [
        1,
        1
      ],
      [
        1,
        16
      ],
      [
        -8,
        0
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -9
      ],
      [
        -2,
        3
      ],
      [
        -4,
        10
      ],
      [
        -3,
        19
      ],
      [
        -1,
        16
      ],
      [
        1,
        9
      ],
      [
        0,
        4
      ],
      [
        -1,
        4
      ],
      [
        -2,
        0
      ],
      [
        -3,
        -15
      ],
      [
        -9,
        6
      ],
      [
        -5,
        28
      ],
      [
        -3,
        3
      ],
      [
        -7,
        17
      ],
      [
        -1,
        2
      ],
      [
        1,
        14
      ],
      [
        -2,
        8
      ],
      [
        -4,
        3
      ],
      [
        -5,
        -4
      ],
      [
        0,
        -3
      ],
      [
        -4,
        -4
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        -2,
        9
      ],
      [
        -2,
        1
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        4
      ],
      [
        -1,
        7
      ],
      [
        -1,
        4
      ],
      [
        -5,
        -5
      ],
      [
        -4,
        6
      ],
      [
        -2,
        9
      ],
      [
        -1,
        13
      ]
    ],
    [
      [
        22445,
        47502
      ],
      [
        0,
        6
      ],
      [
        26,
        216
      ],
      [
        27,
        210
      ],
      [
        21,
        183
      ]
    ],
    [
      [
        28755,
        60650
      ],
      [
        2,
        6
      ],
      [
        8,
        3
      ],
      [
        5,
        -9
      ],
      [
        13,
        6
      ],
      [
        14,
        -30
      ],
      [
        -5,
        -16
      ],
      [
        4,
        -13
      ],
      [
        -1,
        -18
      ],
      [
        -5,
        -17
      ],
      [
        3,
        -13
      ],
      [
        4,
        2
      ],
      [
        3,
        -11
      ],
      [
        3,
        10
      ],
      [
        10,
        -4
      ],
      [
        4,
        -12
      ],
      [
        9,
        6
      ],
      [
        2,
        10
      ]
    ],
    [
      [
        28828,
        60550
      ],
      [
        3,
        1
      ],
      [
        2,
        -15
      ],
      [
        -2,
        -14
      ],
      [
        -4,
        -13
      ],
      [
        -5,
        -27
      ],
      [
        -7,
        -37
      ],
      [
        -2,
        -15
      ],
      [
        1,
        -2
      ],
      [
        0,
        -10
      ],
      [
        -3,
        -17
      ],
      [
        -8,
        -35
      ],
      [
        -4,
        -10
      ],
      [
        -1,
        5
      ],
      [
        -3,
        -1
      ],
      [
        -1,
        -5
      ],
      [
        1,
        -22
      ],
      [
        0,
        -35
      ],
      [
        -3,
        -12
      ],
      [
        0,
        -11
      ],
      [
        -2,
        -13
      ],
      [
        -2,
        -4
      ],
      [
        1,
        -12
      ],
      [
        -1,
        -10
      ],
      [
        -3,
        -12
      ],
      [
        -1,
        -12
      ],
      [
        -6,
        -17
      ],
      [
        -6,
        -27
      ],
      [
        -3,
        -11
      ],
      [
        -3,
        -9
      ],
      [
        -3,
        -5
      ],
      [
        -2,
        -2
      ],
      [
        1,
        12
      ],
      [
        -4,
        9
      ],
      [
        -4,
        -6
      ],
      [
        -1,
        -5
      ],
      [
        -3,
        -1
      ],
      [
        1,
        -16
      ],
      [
        2,
        -6
      ],
      [
        1,
        -13
      ],
      [
        -4,
        -7
      ],
      [
        -5,
        2
      ],
      [
        -2,
        8
      ],
      [
        0,
        9
      ],
      [
        3,
        22
      ],
      [
        0,
        11
      ],
      [
        -2,
        34
      ],
      [
        -6,
        36
      ],
      [
        -2,
        7
      ],
      [
        -2,
        12
      ],
      [
        0,
        17
      ],
      [
        1,
        14
      ],
      [
        -1,
        4
      ],
      [
        -4,
        26
      ],
      [
        1,
        14
      ],
      [
        2,
        13
      ],
      [
        -2,
        10
      ],
      [
        1,
        33
      ],
      [
        2,
        17
      ],
      [
        4,
        23
      ],
      [
        3,
        19
      ],
      [
        2,
        42
      ],
      [
        -1,
        13
      ],
      [
        1,
        22
      ],
      [
        1,
        12
      ],
      [
        4,
        27
      ],
      [
        0,
        16
      ],
      [
        1,
        22
      ],
      [
        2,
        25
      ],
      [
        3,
        15
      ],
      [
        1,
        17
      ]
    ],
    [
      [
        26399,
        54672
      ],
      [
        3,
        16
      ],
      [
        6,
        0
      ],
      [
        -1,
        -35
      ],
      [
        12,
        0
      ],
      [
        -1,
        -29
      ],
      [
        20,
        -1
      ]
    ],
    [
      [
        26389,
        54384
      ],
      [
        2,
        9
      ],
      [
        1,
        20
      ],
      [
        -3,
        3
      ],
      [
        0,
        44
      ],
      [
        5,
        0
      ],
      [
        0,
        76
      ],
      [
        6,
        0
      ],
      [
        -1,
        136
      ]
    ],
    [
      [
        24390,
        67090
      ],
      [
        119,
        -2
      ]
    ],
    [
      [
        28543,
        59191
      ],
      [
        6,
        6
      ],
      [
        2,
        16
      ],
      [
        5,
        -4
      ],
      [
        3,
        20
      ],
      [
        8,
        -6
      ],
      [
        11,
        13
      ],
      [
        4,
        19
      ]
    ],
    [
      [
        28623,
        58934
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -13
      ],
      [
        -6,
        -21
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -13
      ],
      [
        0,
        -4
      ],
      [
        -10,
        -8
      ],
      [
        -6,
        -14
      ],
      [
        -9,
        5
      ],
      [
        -4,
        0
      ],
      [
        -4,
        -4
      ],
      [
        -1,
        1
      ],
      [
        -3,
        10
      ],
      [
        -4,
        20
      ],
      [
        -3,
        5
      ],
      [
        -5,
        1
      ],
      [
        -6,
        -4
      ],
      [
        -6,
        10
      ],
      [
        -12,
        121
      ],
      [
        0,
        61
      ],
      [
        12,
        78
      ],
      [
        -4,
        12
      ]
    ],
    [
      [
        25798,
        57154
      ],
      [
        0,
        -5
      ],
      [
        5,
        -47
      ],
      [
        1,
        -1
      ],
      [
        8,
        -21
      ],
      [
        9,
        -8
      ],
      [
        4,
        9
      ],
      [
        8,
        -4
      ],
      [
        4,
        16
      ],
      [
        6,
        8
      ],
      [
        -1,
        21
      ],
      [
        6,
        -6
      ],
      [
        4,
        12
      ],
      [
        5,
        -16
      ],
      [
        2,
        3
      ],
      [
        2,
        19
      ],
      [
        4,
        12
      ],
      [
        1,
        25
      ],
      [
        -6,
        5
      ],
      [
        -1,
        10
      ],
      [
        8,
        7
      ],
      [
        0,
        15
      ],
      [
        -7,
        8
      ]
    ],
    [
      [
        25860,
        57216
      ],
      [
        50,
        0
      ],
      [
        0,
        -91
      ],
      [
        6,
        14
      ],
      [
        8,
        -13
      ],
      [
        0,
        -11
      ],
      [
        3,
        -54
      ],
      [
        8,
        11
      ]
    ],
    [
      [
        25867,
        56634
      ],
      [
        -3,
        14
      ],
      [
        -18,
        73
      ],
      [
        -2,
        9
      ],
      [
        -7,
        27
      ],
      [
        -2,
        11
      ],
      [
        -4,
        20
      ],
      [
        -3,
        32
      ],
      [
        -3,
        0
      ]
    ],
    [
      [
        25825,
        56820
      ],
      [
        -2,
        35
      ],
      [
        -5,
        16
      ],
      [
        -20,
        1
      ],
      [
        -9,
        1
      ]
    ],
    [
      [
        28701,
        66308
      ],
      [
        20,
        2
      ],
      [
        11,
        -3
      ],
      [
        43,
        8
      ]
    ],
    [
      [
        28775,
        66315
      ],
      [
        4,
        -82
      ],
      [
        2,
        -100
      ],
      [
        2,
        -18
      ],
      [
        5,
        6
      ],
      [
        27,
        0
      ],
      [
        23,
        -1
      ],
      [
        1,
        -62
      ],
      [
        61,
        0
      ]
    ],
    [
      [
        28900,
        66058
      ],
      [
        -1,
        -52
      ],
      [
        0,
        -126
      ],
      [
        5,
        -50
      ]
    ],
    [
      [
        29269,
        66943
      ],
      [
        10,
        -3
      ],
      [
        14,
        -23
      ],
      [
        14,
        -42
      ],
      [
        14,
        16
      ],
      [
        3,
        -70
      ],
      [
        4,
        0
      ],
      [
        1,
        -19
      ],
      [
        15,
        -63
      ],
      [
        4,
        -2
      ]
    ],
    [
      [
        23007,
        52672
      ],
      [
        31,
        57
      ],
      [
        9,
        56
      ],
      [
        4,
        38
      ],
      [
        3,
        17
      ],
      [
        3,
        28
      ],
      [
        7,
        24
      ],
      [
        1,
        14
      ],
      [
        6,
        28
      ],
      [
        21,
        50
      ],
      [
        6,
        11
      ]
    ],
    [
      [
        23118,
        52820
      ],
      [
        -1,
        -25
      ],
      [
        -3,
        -5
      ],
      [
        6,
        -32
      ],
      [
        -2,
        -24
      ],
      [
        2,
        -11
      ],
      [
        0,
        -20
      ],
      [
        -4,
        -15
      ],
      [
        1,
        -35
      ],
      [
        3,
        -24
      ],
      [
        -7,
        -69
      ],
      [
        2,
        -16
      ],
      [
        5,
        -18
      ],
      [
        0,
        -33
      ],
      [
        4,
        -16
      ],
      [
        -1,
        -9
      ],
      [
        6,
        -35
      ],
      [
        -3,
        -21
      ],
      [
        3,
        -8
      ],
      [
        2,
        -26
      ],
      [
        5,
        1
      ],
      [
        7,
        -16
      ],
      [
        -2,
        -15
      ],
      [
        -5,
        5
      ],
      [
        -1,
        -18
      ],
      [
        -4,
        -26
      ],
      [
        -7,
        -1
      ],
      [
        2,
        -21
      ],
      [
        -2,
        -23
      ],
      [
        2,
        -5
      ],
      [
        -4,
        -13
      ]
    ],
    [
      [
        23082,
        52303
      ],
      [
        2,
        4
      ],
      [
        -4,
        11
      ],
      [
        3,
        24
      ],
      [
        5,
        -6
      ],
      [
        2,
        10
      ],
      [
        -5,
        6
      ],
      [
        2,
        7
      ],
      [
        -3,
        20
      ],
      [
        -5,
        13
      ],
      [
        -3,
        -7
      ],
      [
        0,
        11
      ],
      [
        -6,
        18
      ],
      [
        3,
        4
      ],
      [
        -4,
        26
      ],
      [
        -2,
        1
      ],
      [
        -2,
        48
      ],
      [
        -5,
        5
      ],
      [
        1,
        -12
      ],
      [
        -3,
        9
      ],
      [
        1,
        -10
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        3
      ],
      [
        -1,
        6
      ],
      [
        -3,
        -1
      ],
      [
        -1,
        8
      ],
      [
        -2,
        16
      ],
      [
        0,
        21
      ],
      [
        1,
        7
      ],
      [
        -1,
        4
      ],
      [
        -4,
        -15
      ],
      [
        -4,
        26
      ],
      [
        -5,
        12
      ],
      [
        -4,
        -4
      ],
      [
        0,
        19
      ],
      [
        -4,
        -9
      ],
      [
        -3,
        18
      ],
      [
        -15,
        2
      ],
      [
        -1,
        7
      ],
      [
        -9,
        6
      ],
      [
        5,
        27
      ],
      [
        0,
        22
      ],
      [
        4,
        15
      ]
    ],
    [
      [
        28198,
        61985
      ],
      [
        8,
        1
      ],
      [
        10,
        -57
      ],
      [
        -2,
        -13
      ],
      [
        5,
        -19
      ],
      [
        -4,
        -16
      ],
      [
        4,
        -10
      ],
      [
        -4,
        -16
      ],
      [
        5,
        -31
      ],
      [
        12,
        -32
      ],
      [
        4,
        -33
      ],
      [
        5,
        -16
      ],
      [
        0,
        -13
      ],
      [
        6,
        -22
      ],
      [
        2,
        -34
      ],
      [
        5,
        -19
      ],
      [
        12,
        16
      ],
      [
        16,
        -19
      ]
    ],
    [
      [
        28282,
        61652
      ],
      [
        1,
        -20
      ],
      [
        3,
        -12
      ],
      [
        1,
        -17
      ]
    ],
    [
      [
        28287,
        61603
      ],
      [
        -5,
        -9
      ],
      [
        -3,
        21
      ],
      [
        -9,
        -22
      ],
      [
        -7,
        2
      ]
    ],
    [
      [
        28263,
        61595
      ],
      [
        -19,
        37
      ],
      [
        -3,
        -8
      ],
      [
        0,
        -25
      ],
      [
        -6,
        14
      ],
      [
        -7,
        6
      ],
      [
        -3,
        -5
      ],
      [
        -4,
        5
      ],
      [
        -9,
        -3
      ],
      [
        0,
        10
      ],
      [
        -6,
        -7
      ],
      [
        -1,
        -13
      ],
      [
        -9,
        -10
      ],
      [
        -4,
        -10
      ],
      [
        -4,
        6
      ],
      [
        -1,
        -13
      ],
      [
        -5,
        2
      ],
      [
        -10,
        -24
      ],
      [
        -2,
        -19
      ],
      [
        -5,
        6
      ],
      [
        -4,
        -11
      ],
      [
        -7,
        4
      ]
    ],
    [
      [
        28154,
        61537
      ],
      [
        -3,
        1
      ],
      [
        6,
        18
      ],
      [
        -7,
        19
      ],
      [
        -3,
        29
      ],
      [
        6,
        20
      ],
      [
        -1,
        24
      ],
      [
        -5,
        11
      ],
      [
        0,
        21
      ],
      [
        -6,
        17
      ],
      [
        -25,
        97
      ]
    ],
    [
      [
        22897,
        52511
      ],
      [
        95,
        202
      ]
    ],
    [
      [
        22992,
        52713
      ],
      [
        6,
        -3
      ],
      [
        1,
        -16
      ],
      [
        8,
        -22
      ]
    ],
    [
      [
        22987,
        52207
      ],
      [
        -6,
        -1
      ],
      [
        -9,
        29
      ],
      [
        -8,
        -2
      ],
      [
        -2,
        6
      ],
      [
        -4,
        -5
      ],
      [
        -3,
        11
      ],
      [
        -4,
        42
      ],
      [
        -5,
        18
      ],
      [
        -1,
        12
      ],
      [
        -5,
        7
      ],
      [
        -10,
        40
      ],
      [
        -6,
        3
      ],
      [
        -3,
        16
      ],
      [
        1,
        12
      ],
      [
        -9,
        10
      ],
      [
        3,
        20
      ],
      [
        -3,
        29
      ],
      [
        -4,
        36
      ],
      [
        -12,
        21
      ]
    ],
    [
      [
        25119,
        52114
      ],
      [
        8,
        5
      ],
      [
        6,
        1
      ],
      [
        1,
        1
      ],
      [
        10,
        21
      ],
      [
        5,
        10
      ],
      [
        2,
        -5
      ],
      [
        -1,
        -11
      ],
      [
        -5,
        -13
      ],
      [
        -11,
        -16
      ],
      [
        -4,
        -5
      ],
      [
        -6,
        -6
      ],
      [
        -7,
        8
      ],
      [
        2,
        10
      ]
    ],
    [
      [
        25071,
        52140
      ],
      [
        17,
        -1
      ],
      [
        4,
        0
      ],
      [
        4,
        24
      ],
      [
        4,
        -11
      ],
      [
        -2,
        -23
      ],
      [
        -3,
        -20
      ],
      [
        -4,
        -2
      ],
      [
        -3,
        -3
      ],
      [
        -3,
        -2
      ],
      [
        -5,
        15
      ],
      [
        -12,
        11
      ],
      [
        3,
        12
      ]
    ],
    [
      [
        25148,
        52650
      ],
      [
        0,
        -300
      ],
      [
        6,
        -4
      ],
      [
        5,
        -12
      ],
      [
        3,
        -13
      ],
      [
        2,
        -13
      ],
      [
        3,
        -9
      ]
    ],
    [
      [
        25167,
        52299
      ],
      [
        -1,
        -17
      ],
      [
        -17,
        30
      ],
      [
        -1,
        3
      ],
      [
        0,
        3
      ],
      [
        -3,
        2
      ],
      [
        -11,
        0
      ],
      [
        -7,
        -2
      ],
      [
        -3,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -12,
        -8
      ],
      [
        -10,
        -10
      ],
      [
        -1,
        -1
      ],
      [
        -8,
        -8
      ],
      [
        -4,
        -5
      ],
      [
        0,
        -1
      ],
      [
        -7,
        -11
      ],
      [
        -17,
        -25
      ],
      [
        -10,
        -11
      ],
      [
        -7,
        -10
      ],
      [
        -7,
        -9
      ],
      [
        -4,
        -3
      ],
      [
        -2,
        0
      ],
      [
        0,
        29
      ],
      [
        1,
        6
      ],
      [
        2,
        -2
      ],
      [
        1,
        21
      ],
      [
        -4,
        19
      ],
      [
        -6,
        11
      ],
      [
        -6,
        -2
      ],
      [
        -1,
        -1
      ]
    ],
    [
      [
        25021,
        52296
      ],
      [
        -1,
        101
      ],
      [
        0,
        219
      ]
    ],
    [
      [
        23205,
        55831
      ],
      [
        0,
        61
      ]
    ],
    [
      [
        23205,
        55892
      ],
      [
        9,
        -4
      ],
      [
        5,
        19
      ],
      [
        9,
        20
      ],
      [
        4,
        4
      ],
      [
        10,
        -13
      ],
      [
        5,
        4
      ],
      [
        7,
        -20
      ],
      [
        11,
        19
      ],
      [
        11,
        -3
      ],
      [
        6,
        -18
      ],
      [
        4,
        10
      ],
      [
        11,
        -37
      ],
      [
        7,
        -3
      ],
      [
        3,
        14
      ],
      [
        5,
        -8
      ],
      [
        3,
        -17
      ],
      [
        4,
        1
      ],
      [
        9,
        -26
      ],
      [
        5,
        -3
      ],
      [
        8,
        -18
      ],
      [
        17,
        -16
      ]
    ],
    [
      [
        23358,
        55797
      ],
      [
        1,
        -3
      ]
    ],
    [
      [
        18457,
        60592
      ],
      [
        0,
        -581
      ]
    ],
    [
      [
        21556,
        53119
      ],
      [
        140,
        -1
      ]
    ],
    [
      [
        21783,
        52197
      ],
      [
        -3,
        0
      ],
      [
        -9,
        -1
      ],
      [
        -210,
        1
      ]
    ],
    [
      [
        21561,
        52197
      ],
      [
        4,
        16
      ],
      [
        2,
        30
      ],
      [
        10,
        22
      ],
      [
        9,
        -8
      ],
      [
        3,
        4
      ],
      [
        0,
        18
      ],
      [
        -8,
        13
      ],
      [
        -3,
        13
      ],
      [
        1,
        15
      ],
      [
        -2,
        10
      ],
      [
        -8,
        7
      ],
      [
        -3,
        15
      ],
      [
        6,
        25
      ],
      [
        0,
        15
      ],
      [
        -3,
        5
      ],
      [
        2,
        13
      ],
      [
        6,
        -15
      ],
      [
        3,
        11
      ],
      [
        0,
        28
      ],
      [
        4,
        13
      ],
      [
        -1,
        22
      ],
      [
        3,
        8
      ],
      [
        6,
        38
      ],
      [
        -5,
        32
      ],
      [
        4,
        37
      ],
      [
        -5,
        21
      ],
      [
        -6,
        1
      ],
      [
        -6,
        18
      ],
      [
        -11,
        -6
      ],
      [
        -1,
        9
      ],
      [
        -4,
        -5
      ]
    ],
    [
      [
        21558,
        52622
      ],
      [
        -2,
        33
      ],
      [
        -9,
        21
      ],
      [
        0,
        30
      ],
      [
        -2,
        31
      ],
      [
        -5,
        7
      ],
      [
        -2,
        32
      ],
      [
        3,
        19
      ],
      [
        -5,
        31
      ],
      [
        1,
        15
      ],
      [
        -4,
        38
      ],
      [
        -9,
        20
      ],
      [
        5,
        25
      ],
      [
        -3,
        16
      ],
      [
        -7,
        3
      ],
      [
        -3,
        8
      ],
      [
        0,
        13
      ],
      [
        -9,
        10
      ],
      [
        -2,
        18
      ],
      [
        -7,
        19
      ],
      [
        -2,
        3
      ],
      [
        -6,
        -12
      ],
      [
        -5,
        20
      ],
      [
        -5,
        8
      ],
      [
        -9,
        -19
      ],
      [
        -4,
        10
      ],
      [
        -4,
        -6
      ],
      [
        -5,
        12
      ],
      [
        -3,
        -7
      ],
      [
        -4,
        15
      ],
      [
        -5,
        -2
      ],
      [
        -4,
        11
      ],
      [
        -2,
        -14
      ],
      [
        -2,
        32
      ],
      [
        -9,
        5
      ],
      [
        -4,
        8
      ],
      [
        -5,
        -9
      ],
      [
        -7,
        2
      ],
      [
        -9,
        30
      ],
      [
        -10,
        15
      ],
      [
        -4,
        12
      ],
      [
        -5,
        3
      ]
    ],
    [
      [
        27155,
        51076
      ],
      [
        65,
        64
      ],
      [
        4,
        22
      ]
    ],
    [
      [
        27316,
        51195
      ],
      [
        9,
        -79
      ],
      [
        3,
        -29
      ],
      [
        3,
        -31
      ],
      [
        19,
        -151
      ],
      [
        2,
        -22
      ],
      [
        2,
        -13
      ],
      [
        1,
        -7
      ],
      [
        5,
        -36
      ],
      [
        10,
        -54
      ],
      [
        4,
        -33
      ],
      [
        4,
        -30
      ],
      [
        4,
        -20
      ],
      [
        22,
        -137
      ],
      [
        15,
        -98
      ]
    ],
    [
      [
        27419,
        50455
      ],
      [
        -31,
        0
      ],
      [
        -35,
        -1
      ],
      [
        1,
        -207
      ],
      [
        -6,
        0
      ]
    ],
    [
      [
        27166,
        51020
      ],
      [
        -4,
        27
      ],
      [
        -5,
        8
      ],
      [
        -2,
        21
      ]
    ],
    [
      [
        28322,
        66503
      ],
      [
        10,
        -1
      ],
      [
        25,
        0
      ]
    ],
    [
      [
        28357,
        66502
      ],
      [
        62,
        0
      ],
      [
        -2,
        -27
      ],
      [
        0,
        -62
      ],
      [
        6,
        -3
      ],
      [
        6,
        10
      ],
      [
        0,
        -26
      ]
    ],
    [
      [
        25375,
        66812
      ],
      [
        33,
        1
      ],
      [
        34,
        -2
      ]
    ],
    [
      [
        25442,
        66811
      ],
      [
        1,
        -8
      ],
      [
        9,
        -34
      ],
      [
        5,
        -15
      ],
      [
        2,
        -10
      ],
      [
        -1,
        -13
      ],
      [
        -2,
        -12
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -9
      ],
      [
        1,
        -24
      ],
      [
        -1,
        -22
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -12
      ],
      [
        -2,
        -17
      ],
      [
        -1,
        -9
      ]
    ],
    [
      [
        25309,
        66542
      ],
      [
        0,
        97
      ],
      [
        -1,
        71
      ],
      [
        0,
        2
      ],
      [
        1,
        97
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        23888,
        56980
      ],
      [
        5,
        1
      ],
      [
        39,
        -3
      ],
      [
        5,
        -1
      ],
      [
        32,
        -3
      ],
      [
        47,
        -3
      ],
      [
        0,
        65
      ],
      [
        9,
        4
      ],
      [
        0,
        67
      ],
      [
        10,
        0
      ],
      [
        24,
        -3
      ]
    ],
    [
      [
        24093,
        57000
      ],
      [
        -1,
        -203
      ],
      [
        -1,
        -105
      ]
    ],
    [
      [
        24091,
        56692
      ],
      [
        -38,
        3
      ],
      [
        -20,
        5
      ]
    ],
    [
      [
        24033,
        56700
      ],
      [
        -40,
        5
      ],
      [
        -3,
        -6
      ],
      [
        -1,
        29
      ],
      [
        3,
        19
      ],
      [
        2,
        6
      ],
      [
        -1,
        14
      ],
      [
        -3,
        9
      ],
      [
        2,
        17
      ],
      [
        -14,
        -1
      ],
      [
        -2,
        12
      ],
      [
        -30,
        3
      ],
      [
        0,
        34
      ],
      [
        -15,
        1
      ],
      [
        -28,
        2
      ],
      [
        -1,
        1
      ],
      [
        0,
        68
      ],
      [
        -15,
        0
      ]
    ],
    [
      [
        24410,
        61352
      ],
      [
        -1,
        68
      ],
      [
        47,
        -1
      ]
    ],
    [
      [
        23040,
        68894
      ],
      [
        0,
        168
      ],
      [
        -1,
        17
      ],
      [
        0,
        8
      ],
      [
        1,
        9
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        26480,
        55701
      ],
      [
        -13,
        18
      ],
      [
        0,
        26
      ],
      [
        -27,
        0
      ],
      [
        -1,
        20
      ],
      [
        -29,
        0
      ]
    ],
    [
      [
        25974,
        54510
      ],
      [
        6,
        0
      ],
      [
        0,
        35
      ],
      [
        5,
        -16
      ],
      [
        1,
        -52
      ],
      [
        4,
        -13
      ],
      [
        1,
        -4
      ],
      [
        118,
        3
      ]
    ],
    [
      [
        26109,
        54463
      ],
      [
        2,
        -102
      ],
      [
        5,
        0
      ]
    ],
    [
      [
        26116,
        54361
      ],
      [
        -5,
        -9
      ],
      [
        -1,
        -101
      ],
      [
        1,
        -43
      ],
      [
        -24,
        -2
      ],
      [
        0,
        -16
      ],
      [
        -19,
        -3
      ],
      [
        -3,
        -4
      ],
      [
        -3,
        -38
      ],
      [
        -13,
        -58
      ],
      [
        -2,
        -36
      ]
    ],
    [
      [
        26047,
        54051
      ],
      [
        -37,
        0
      ],
      [
        0,
        101
      ],
      [
        -26,
        0
      ],
      [
        0,
        17
      ],
      [
        -3,
        8
      ],
      [
        0,
        68
      ],
      [
        -5,
        0
      ],
      [
        0,
        9
      ],
      [
        -10,
        0
      ],
      [
        0,
        8
      ],
      [
        -1,
        -8
      ],
      [
        -7,
        -1
      ],
      [
        -2,
        -8
      ],
      [
        -4,
        5
      ]
    ],
    [
      [
        16371,
        60748
      ],
      [
        19,
        -132
      ],
      [
        2,
        -27
      ],
      [
        3,
        -10
      ],
      [
        6,
        -35
      ],
      [
        1,
        -17
      ],
      [
        -2,
        -14
      ],
      [
        5,
        -36
      ],
      [
        14,
        -74
      ],
      [
        3,
        -28
      ],
      [
        6,
        -25
      ],
      [
        -1,
        -13
      ],
      [
        2,
        -22
      ],
      [
        10,
        -26
      ],
      [
        16,
        -24
      ],
      [
        6,
        -24
      ],
      [
        3,
        -17
      ]
    ],
    [
      [
        16140,
        59965
      ],
      [
        -8,
        26
      ],
      [
        3,
        19
      ],
      [
        0,
        14
      ],
      [
        -3,
        16
      ],
      [
        6,
        17
      ],
      [
        0,
        20
      ],
      [
        4,
        5
      ],
      [
        0,
        8
      ],
      [
        -10,
        25
      ],
      [
        4,
        8
      ],
      [
        4,
        31
      ],
      [
        -3,
        13
      ]
    ],
    [
      [
        28486,
        60450
      ],
      [
        2,
        26
      ],
      [
        1,
        38
      ],
      [
        9,
        17
      ],
      [
        10,
        4
      ],
      [
        9,
        -18
      ],
      [
        6,
        0
      ],
      [
        3,
        12
      ],
      [
        1,
        19
      ],
      [
        4,
        6
      ]
    ],
    [
      [
        28535,
        60367
      ],
      [
        -3,
        2
      ],
      [
        -1,
        -40
      ],
      [
        1,
        -14
      ],
      [
        3,
        -13
      ],
      [
        18,
        1
      ]
    ],
    [
      [
        28573,
        60259
      ],
      [
        3,
        -36
      ],
      [
        -9,
        -18
      ]
    ],
    [
      [
        28567,
        60205
      ],
      [
        -1,
        14
      ],
      [
        -1,
        15
      ],
      [
        -1,
        8
      ],
      [
        -2,
        9
      ],
      [
        -3,
        11
      ],
      [
        -3,
        6
      ],
      [
        -11,
        2
      ],
      [
        -2,
        -5
      ],
      [
        -9,
        -6
      ],
      [
        -1,
        -11
      ],
      [
        -2,
        -10
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        2
      ],
      [
        -4,
        16
      ],
      [
        -2,
        4
      ],
      [
        -2,
        16
      ],
      [
        -2,
        10
      ],
      [
        -7,
        12
      ],
      [
        -1,
        2
      ],
      [
        -10,
        -3
      ],
      [
        -4,
        25
      ],
      [
        0,
        -2
      ]
    ],
    [
      [
        24164,
        54767
      ],
      [
        0,
        -102
      ],
      [
        26,
        -91
      ],
      [
        3,
        -10
      ],
      [
        0,
        -51
      ]
    ],
    [
      [
        24193,
        54360
      ],
      [
        -93,
        1
      ],
      [
        -47,
        0
      ]
    ],
    [
      [
        28482,
        59479
      ],
      [
        0,
        10
      ]
    ],
    [
      [
        28482,
        59489
      ],
      [
        31,
        -2
      ],
      [
        16,
        0
      ],
      [
        3,
        1
      ],
      [
        45,
        -1
      ],
      [
        10,
        0
      ]
    ],
    [
      [
        28587,
        59487
      ],
      [
        14,
        -46
      ]
    ],
    [
      [
        28601,
        59441
      ],
      [
        0,
        -49
      ],
      [
        6,
        -68
      ],
      [
        4,
        -38
      ]
    ],
    [
      [
        24440,
        68141
      ],
      [
        29,
        0
      ],
      [
        -5,
        26
      ],
      [
        0,
        36
      ],
      [
        9,
        31
      ],
      [
        6,
        -5
      ],
      [
        5,
        14
      ],
      [
        5,
        -17
      ],
      [
        8,
        -5
      ],
      [
        5,
        26
      ],
      [
        1,
        14
      ],
      [
        9,
        0
      ],
      [
        4,
        -9
      ]
    ],
    [
      [
        24516,
        68252
      ],
      [
        0,
        -10
      ],
      [
        50,
        -1
      ]
    ],
    [
      [
        24566,
        68241
      ],
      [
        17,
        1
      ],
      [
        0,
        -403
      ]
    ],
    [
      [
        24479,
        67981
      ],
      [
        -2,
        6
      ],
      [
        -1,
        3
      ],
      [
        -1,
        2
      ],
      [
        -1,
        3
      ],
      [
        -2,
        10
      ],
      [
        -1,
        9
      ],
      [
        0,
        7
      ],
      [
        -2,
        8
      ],
      [
        -2,
        6
      ],
      [
        -3,
        5
      ],
      [
        -1,
        6
      ],
      [
        -1,
        8
      ],
      [
        0,
        2
      ],
      [
        -2,
        3
      ],
      [
        -1,
        3
      ],
      [
        0,
        1
      ],
      [
        -2,
        10
      ],
      [
        0,
        10
      ],
      [
        -1,
        3
      ],
      [
        -2,
        8
      ],
      [
        -3,
        12
      ],
      [
        -3,
        6
      ],
      [
        -3,
        5
      ],
      [
        0,
        1
      ],
      [
        -1,
        7
      ],
      [
        -1,
        3
      ],
      [
        -3,
        11
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        26506,
        54797
      ],
      [
        -2,
        -11
      ],
      [
        0,
        -6
      ]
    ],
    [
      [
        26385,
        54844
      ],
      [
        10,
        0
      ],
      [
        0,
        57
      ],
      [
        8,
        25
      ],
      [
        4,
        55
      ],
      [
        7,
        0
      ],
      [
        0,
        48
      ],
      [
        5,
        1
      ],
      [
        5,
        14
      ],
      [
        4,
        3
      ],
      [
        1,
        13
      ]
    ],
    [
      [
        26429,
        55060
      ],
      [
        6,
        -9
      ],
      [
        2,
        -20
      ],
      [
        6,
        19
      ],
      [
        0,
        -20
      ],
      [
        4,
        -1
      ],
      [
        5,
        -36
      ]
    ],
    [
      [
        26452,
        54993
      ],
      [
        8,
        -14
      ],
      [
        8,
        9
      ],
      [
        5,
        -13
      ],
      [
        6,
        13
      ],
      [
        0,
        -14
      ],
      [
        8,
        -30
      ],
      [
        1,
        -14
      ],
      [
        5,
        1
      ],
      [
        -4,
        -21
      ],
      [
        0,
        -23
      ],
      [
        5,
        -37
      ],
      [
        5,
        -10
      ],
      [
        9,
        -33
      ]
    ],
    [
      [
        26399,
        54672
      ],
      [
        0,
        25
      ],
      [
        -4,
        10
      ],
      [
        0,
        48
      ],
      [
        -7,
        9
      ],
      [
        0,
        30
      ],
      [
        -6,
        18
      ],
      [
        3,
        32
      ]
    ],
    [
      [
        28601,
        59441
      ],
      [
        15,
        -50
      ],
      [
        7,
        -13
      ],
      [
        5,
        -3
      ],
      [
        7,
        -17
      ],
      [
        0,
        -10
      ],
      [
        6,
        -3
      ],
      [
        0,
        -8
      ],
      [
        7,
        7
      ],
      [
        -1,
        -12
      ],
      [
        6,
        -19
      ],
      [
        3,
        -17
      ],
      [
        9,
        -2
      ],
      [
        2,
        -25
      ],
      [
        4,
        10
      ],
      [
        4,
        -29
      ],
      [
        3,
        -6
      ],
      [
        0,
        -17
      ],
      [
        6,
        1
      ],
      [
        3,
        -6
      ],
      [
        -5,
        -6
      ],
      [
        -1,
        -15
      ],
      [
        -4,
        -6
      ],
      [
        9,
        -8
      ]
    ],
    [
      [
        28686,
        59187
      ],
      [
        -1,
        -13
      ],
      [
        2,
        -6
      ],
      [
        0,
        -2
      ],
      [
        3,
        -10
      ],
      [
        6,
        -2
      ],
      [
        9,
        -58
      ],
      [
        10,
        -17
      ],
      [
        4,
        -40
      ],
      [
        2,
        -12
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -4
      ],
      [
        -6,
        -6
      ],
      [
        -24,
        -14
      ],
      [
        -8,
        16
      ],
      [
        -6,
        25
      ],
      [
        -3,
        14
      ],
      [
        -3,
        5
      ],
      [
        -1,
        11
      ],
      [
        -4,
        6
      ],
      [
        -2,
        -1
      ]
    ],
    [
      [
        28276,
        62272
      ],
      [
        -2,
        -30
      ],
      [
        -4,
        -25
      ],
      [
        -4,
        -10
      ],
      [
        -4,
        -51
      ],
      [
        -2,
        0
      ],
      [
        1,
        -23
      ],
      [
        8,
        -52
      ],
      [
        1,
        0
      ],
      [
        2,
        -18
      ],
      [
        13,
        -78
      ],
      [
        12,
        -80
      ],
      [
        13,
        -77
      ],
      [
        1,
        -6
      ]
    ],
    [
      [
        28311,
        61822
      ],
      [
        -8,
        -34
      ],
      [
        -8,
        -27
      ],
      [
        -12,
        -40
      ],
      [
        -1,
        -3
      ],
      [
        2,
        -17
      ],
      [
        -2,
        -49
      ]
    ],
    [
      [
        28100,
        61492
      ],
      [
        6,
        -11
      ],
      [
        -1,
        -15
      ],
      [
        5,
        -19
      ],
      [
        6,
        -4
      ],
      [
        3,
        -1
      ],
      [
        1,
        15
      ],
      [
        7,
        3
      ],
      [
        4,
        11
      ],
      [
        -2,
        15
      ],
      [
        9,
        -2
      ],
      [
        -2,
        10
      ],
      [
        4,
        10
      ],
      [
        5,
        -1
      ],
      [
        9,
        25
      ],
      [
        0,
        9
      ]
    ],
    [
      [
        28263,
        61595
      ],
      [
        -3,
        -30
      ],
      [
        -9,
        -36
      ],
      [
        -11,
        -40
      ],
      [
        -1,
        -4
      ],
      [
        -46,
        -173
      ]
    ],
    [
      [
        28768,
        66673
      ],
      [
        129,
        25
      ],
      [
        0,
        -8
      ],
      [
        37,
        7
      ]
    ],
    [
      [
        28900,
        66196
      ],
      [
        0,
        -138
      ]
    ],
    [
      [
        28775,
        66315
      ],
      [
        -2,
        148
      ],
      [
        -5,
        210
      ]
    ],
    [
      [
        27878,
        60470
      ],
      [
        -10,
        -30
      ],
      [
        -3,
        7
      ],
      [
        -1,
        -1
      ],
      [
        -12,
        -37
      ],
      [
        -5,
        3
      ],
      [
        -5,
        -14
      ],
      [
        -12,
        27
      ]
    ],
    [
      [
        27830,
        60425
      ],
      [
        7,
        43
      ],
      [
        0,
        3
      ],
      [
        -6,
        10
      ],
      [
        2,
        19
      ],
      [
        -6,
        12
      ],
      [
        0,
        20
      ],
      [
        6,
        -1
      ],
      [
        10,
        25
      ],
      [
        7,
        -3
      ]
    ],
    [
      [
        23022,
        57107
      ],
      [
        1,
        0
      ],
      [
        0,
        203
      ],
      [
        29,
        0
      ],
      [
        0,
        102
      ]
    ],
    [
      [
        23052,
        57412
      ],
      [
        88,
        0
      ]
    ],
    [
      [
        23140,
        57412
      ],
      [
        0,
        -102
      ]
    ],
    [
      [
        23140,
        57310
      ],
      [
        0,
        -203
      ],
      [
        -15,
        0
      ],
      [
        0,
        -101
      ],
      [
        -73,
        -1
      ]
    ],
    [
      [
        23170,
        57859
      ],
      [
        -8,
        -12
      ],
      [
        0,
        -28
      ],
      [
        -5,
        3
      ],
      [
        -3,
        -14
      ],
      [
        -6,
        -23
      ],
      [
        -2,
        -37
      ],
      [
        -5,
        -8
      ],
      [
        -1,
        -227
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        23052,
        57412
      ],
      [
        0,
        190
      ],
      [
        -5,
        -32
      ],
      [
        -10,
        15
      ],
      [
        -8,
        -7
      ]
    ],
    [
      [
        23029,
        57578
      ],
      [
        0,
        239
      ],
      [
        13,
        0
      ],
      [
        0,
        203
      ]
    ],
    [
      [
        22844,
        52394
      ],
      [
        53,
        117
      ]
    ],
    [
      [
        27778,
        60075
      ],
      [
        32,
        213
      ],
      [
        10,
        68
      ],
      [
        10,
        69
      ]
    ],
    [
      [
        27951,
        60249
      ],
      [
        -22,
        -207
      ],
      [
        -1,
        -6
      ]
    ],
    [
      [
        22949,
        57566
      ],
      [
        6,
        0
      ],
      [
        4,
        -36
      ],
      [
        4,
        -14
      ],
      [
        9,
        13
      ],
      [
        2,
        17
      ],
      [
        -2,
        24
      ],
      [
        -5,
        10
      ],
      [
        3,
        21
      ],
      [
        9,
        -1
      ],
      [
        6,
        -32
      ],
      [
        7,
        -3
      ],
      [
        7,
        8
      ],
      [
        6,
        12
      ],
      [
        5,
        -3
      ],
      [
        1,
        -18
      ],
      [
        3,
        -21
      ],
      [
        4,
        -12
      ],
      [
        5,
        6
      ],
      [
        6,
        41
      ]
    ],
    [
      [
        16478,
        63180
      ],
      [
        1,
        13
      ],
      [
        0,
        259
      ],
      [
        1,
        134
      ],
      [
        0,
        756
      ],
      [
        -1,
        34
      ],
      [
        0,
        505
      ]
    ],
    [
      [
        16479,
        64881
      ],
      [
        0,
        943
      ]
    ],
    [
      [
        16671,
        64621
      ],
      [
        -1,
        -515
      ],
      [
        -7,
        -1
      ],
      [
        0,
        -604
      ],
      [
        32,
        1
      ]
    ],
    [
      [
        16695,
        63502
      ],
      [
        -1,
        -116
      ],
      [
        5,
        0
      ],
      [
        0,
        -105
      ],
      [
        6,
        0
      ],
      [
        0,
        -25
      ],
      [
        5,
        0
      ],
      [
        0,
        -125
      ],
      [
        -5,
        0
      ],
      [
        0,
        -35
      ]
    ],
    [
      [
        16705,
        63096
      ],
      [
        -20,
        -2
      ],
      [
        -7,
        -32
      ]
    ],
    [
      [
        16678,
        63062
      ],
      [
        1,
        7
      ],
      [
        -16,
        -36
      ],
      [
        -5,
        2
      ],
      [
        -4,
        -13
      ],
      [
        -12,
        4
      ],
      [
        -15,
        -7
      ],
      [
        -1,
        -22
      ],
      [
        -11,
        -4
      ],
      [
        -6,
        4
      ],
      [
        -7,
        -18
      ],
      [
        -7,
        -3
      ],
      [
        -9,
        -29
      ],
      [
        -2,
        -13
      ],
      [
        -12,
        -3
      ],
      [
        -6,
        13
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -75
      ],
      [
        0,
        -6
      ],
      [
        12,
        0
      ],
      [
        -1,
        -50
      ],
      [
        -5,
        0
      ],
      [
        -3,
        -17
      ],
      [
        5,
        -33
      ],
      [
        0,
        -17
      ],
      [
        3,
        -1
      ],
      [
        0,
        -16
      ],
      [
        -5,
        0
      ],
      [
        0,
        -59
      ],
      [
        -5,
        0
      ],
      [
        -1,
        -26
      ],
      [
        -5,
        0
      ],
      [
        1,
        -9
      ]
    ],
    [
      [
        16559,
        62631
      ],
      [
        -11,
        -8
      ],
      [
        0,
        -17
      ],
      [
        -5,
        0
      ],
      [
        0,
        -17
      ],
      [
        -10,
        -8
      ],
      [
        -6,
        0
      ],
      [
        -10,
        -26
      ],
      [
        0,
        -17
      ],
      [
        -5,
        -7
      ],
      [
        -34,
        0
      ]
    ],
    [
      [
        16478,
        62531
      ],
      [
        -1,
        70
      ],
      [
        0,
        106
      ]
    ],
    [
      [
        28975,
        65657
      ],
      [
        42,
        79
      ],
      [
        60,
        114
      ]
    ],
    [
      [
        29077,
        65850
      ],
      [
        30,
        -52
      ],
      [
        5,
        -10
      ],
      [
        56,
        -102
      ],
      [
        -9,
        -47
      ],
      [
        -11,
        -45
      ],
      [
        -14,
        -60
      ],
      [
        51,
        -118
      ],
      [
        5,
        -53
      ],
      [
        3,
        -5
      ],
      [
        -1,
        -3
      ]
    ],
    [
      [
        28288,
        63734
      ],
      [
        2,
        -16
      ],
      [
        10,
        32
      ],
      [
        4,
        8
      ],
      [
        5,
        0
      ],
      [
        18,
        41
      ],
      [
        13,
        37
      ],
      [
        9,
        20
      ],
      [
        10,
        12
      ],
      [
        0,
        -8
      ],
      [
        -14,
        -38
      ],
      [
        -3,
        -22
      ],
      [
        10,
        8
      ],
      [
        12,
        29
      ],
      [
        5,
        6
      ],
      [
        -2,
        -20
      ],
      [
        3,
        -9
      ],
      [
        11,
        10
      ],
      [
        11,
        9
      ],
      [
        15,
        4
      ],
      [
        29,
        16
      ],
      [
        19,
        4
      ],
      [
        11,
        7
      ],
      [
        17,
        21
      ]
    ],
    [
      [
        28483,
        63885
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -25
      ],
      [
        -1,
        -15
      ],
      [
        3,
        -21
      ],
      [
        4,
        -20
      ],
      [
        4,
        -9
      ],
      [
        3,
        -11
      ],
      [
        4,
        -13
      ]
    ],
    [
      [
        28498,
        63766
      ],
      [
        -2,
        -12
      ],
      [
        -7,
        0
      ],
      [
        -1,
        10
      ],
      [
        -5,
        -23
      ],
      [
        -2,
        5
      ],
      [
        -2,
        -14
      ],
      [
        5,
        -7
      ],
      [
        -4,
        -16
      ],
      [
        5,
        -13
      ],
      [
        -6,
        -6
      ],
      [
        -14,
        4
      ],
      [
        2,
        -9
      ],
      [
        -12,
        -10
      ],
      [
        -4,
        0
      ],
      [
        -15,
        -43
      ],
      [
        -15,
        -48
      ]
    ],
    [
      [
        28421,
        63584
      ],
      [
        -7,
        -21
      ],
      [
        -5,
        -18
      ],
      [
        -2,
        -8
      ],
      [
        -19,
        -10
      ],
      [
        -28,
        -21
      ],
      [
        -14,
        -10
      ],
      [
        -4,
        -15
      ],
      [
        -14,
        -43
      ]
    ],
    [
      [
        28328,
        63438
      ],
      [
        4,
        33
      ],
      [
        -11,
        38
      ],
      [
        -7,
        41
      ],
      [
        -3,
        9
      ],
      [
        -1,
        25
      ],
      [
        -7,
        36
      ],
      [
        -1,
        21
      ],
      [
        -13,
        39
      ],
      [
        -5,
        42
      ],
      [
        4,
        12
      ]
    ],
    [
      [
        27539,
        62459
      ],
      [
        -1,
        -49
      ],
      [
        -2,
        -25
      ],
      [
        -2,
        -31
      ],
      [
        -4,
        -19
      ],
      [
        2,
        -26
      ],
      [
        2,
        -6
      ],
      [
        0,
        -16
      ],
      [
        -8,
        -18
      ],
      [
        -4,
        -39
      ],
      [
        -1,
        -23
      ],
      [
        -6,
        -14
      ],
      [
        -3,
        -71
      ],
      [
        -3,
        -53
      ],
      [
        5,
        -48
      ]
    ],
    [
      [
        27496,
        62035
      ],
      [
        1,
        12
      ],
      [
        2,
        33
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        24
      ],
      [
        -6,
        5
      ],
      [
        3,
        38
      ],
      [
        -14,
        34
      ],
      [
        -5,
        -10
      ],
      [
        -4,
        16
      ],
      [
        -7,
        -10
      ],
      [
        -3,
        14
      ],
      [
        0,
        15
      ],
      [
        -4,
        24
      ]
    ],
    [
      [
        23965,
        52355
      ],
      [
        18,
        1
      ],
      [
        0,
        17
      ],
      [
        81,
        -2
      ],
      [
        0,
        59
      ],
      [
        40,
        0
      ]
    ],
    [
      [
        23965,
        52331
      ],
      [
        0,
        24
      ]
    ],
    [
      [
        21981,
        65125
      ],
      [
        -129,
        0
      ]
    ],
    [
      [
        21852,
        65125
      ],
      [
        0,
        176
      ],
      [
        1,
        227
      ]
    ],
    [
      [
        26109,
        54667
      ],
      [
        22,
        1
      ],
      [
        7,
        0
      ],
      [
        -1,
        67
      ],
      [
        0,
        1
      ],
      [
        18,
        1
      ],
      [
        12,
        1
      ],
      [
        6,
        0
      ],
      [
        41,
        3
      ],
      [
        -1,
        40
      ],
      [
        1,
        2
      ],
      [
        15,
        1
      ]
    ],
    [
      [
        26229,
        54784
      ],
      [
        0,
        -5
      ],
      [
        2,
        -33
      ],
      [
        0,
        -28
      ],
      [
        7,
        -12
      ],
      [
        2,
        -24
      ],
      [
        -5,
        -36
      ],
      [
        0,
        -16
      ]
    ],
    [
      [
        26252,
        54459
      ],
      [
        -2,
        -14
      ],
      [
        -11,
        0
      ],
      [
        2,
        -24
      ],
      [
        -14,
        -21
      ],
      [
        -13,
        -52
      ],
      [
        3,
        -56
      ],
      [
        -1,
        -29
      ]
    ],
    [
      [
        26216,
        54263
      ],
      [
        -38,
        -1
      ],
      [
        -1,
        3
      ],
      [
        -1,
        20
      ],
      [
        -10,
        25
      ],
      [
        -2,
        24
      ],
      [
        -6,
        17
      ],
      [
        0,
        11
      ],
      [
        -42,
        -1
      ]
    ],
    [
      [
        26109,
        54463
      ],
      [
        0,
        204
      ]
    ],
    [
      [
        24433,
        59426
      ],
      [
        1,
        -1
      ],
      [
        11,
        0
      ]
    ],
    [
      [
        24445,
        59425
      ],
      [
        2,
        -20
      ],
      [
        12,
        -17
      ],
      [
        2,
        -52
      ],
      [
        11,
        0
      ],
      [
        0,
        -36
      ],
      [
        5,
        -1
      ],
      [
        0,
        -16
      ],
      [
        5,
        -1
      ],
      [
        -1,
        -50
      ],
      [
        5,
        0
      ],
      [
        0,
        -85
      ]
    ],
    [
      [
        25958,
        59578
      ],
      [
        -16,
        2
      ],
      [
        -1,
        1
      ],
      [
        -12,
        3
      ],
      [
        -33,
        7
      ],
      [
        -2,
        0
      ]
    ],
    [
      [
        25837,
        59604
      ],
      [
        -2,
        29
      ],
      [
        3,
        52
      ],
      [
        -2,
        21
      ],
      [
        2,
        44
      ]
    ],
    [
      [
        24765,
        52052
      ],
      [
        11,
        14
      ],
      [
        17,
        17
      ]
    ],
    [
      [
        24793,
        52083
      ],
      [
        4,
        -11
      ],
      [
        10,
        -18
      ]
    ],
    [
      [
        24807,
        52054
      ],
      [
        -3,
        -149
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -27
      ],
      [
        -1,
        -24
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -11
      ],
      [
        0,
        -3
      ],
      [
        2,
        -6
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -23
      ],
      [
        4,
        -9
      ],
      [
        1,
        -1
      ],
      [
        4,
        -2
      ],
      [
        7,
        8
      ],
      [
        4,
        7
      ],
      [
        3,
        11
      ],
      [
        0,
        17
      ],
      [
        1,
        -5
      ],
      [
        1,
        -4
      ],
      [
        8,
        -31
      ],
      [
        1,
        -4
      ],
      [
        1,
        -5
      ],
      [
        2,
        -9
      ]
    ],
    [
      [
        24835,
        51740
      ],
      [
        -3,
        -19
      ],
      [
        -3,
        -30
      ],
      [
        -3,
        -9
      ],
      [
        -5,
        -10
      ],
      [
        -3,
        -9
      ],
      [
        -1,
        -25
      ],
      [
        3,
        -26
      ],
      [
        -4,
        -16
      ],
      [
        3,
        -21
      ],
      [
        -1,
        -17
      ],
      [
        8,
        -36
      ],
      [
        3,
        -24
      ],
      [
        4,
        -15
      ],
      [
        3,
        -59
      ],
      [
        5,
        -7
      ],
      [
        1,
        -44
      ],
      [
        -2,
        -36
      ],
      [
        3,
        -18
      ],
      [
        0,
        -98
      ],
      [
        5,
        -22
      ],
      [
        4,
        -64
      ],
      [
        4,
        -46
      ],
      [
        8,
        -48
      ]
    ],
    [
      [
        24864,
        51041
      ],
      [
        -11,
        -27
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -9
      ],
      [
        -18,
        -44
      ],
      [
        -4,
        -15
      ],
      [
        -6,
        -22
      ],
      [
        -6,
        -16
      ],
      [
        -3,
        -7
      ]
    ],
    [
      [
        24812,
        50889
      ],
      [
        0,
        19
      ],
      [
        7,
        31
      ],
      [
        2,
        27
      ],
      [
        8,
        45
      ],
      [
        4,
        6
      ],
      [
        4,
        28
      ],
      [
        -1,
        14
      ],
      [
        -7,
        25
      ],
      [
        -2,
        43
      ],
      [
        2,
        10
      ],
      [
        -1,
        19
      ],
      [
        3,
        41
      ],
      [
        -4,
        9
      ],
      [
        0,
        13
      ],
      [
        -4,
        16
      ],
      [
        -3,
        -3
      ],
      [
        -5,
        8
      ],
      [
        -5,
        -5
      ],
      [
        -5,
        5
      ],
      [
        -6,
        13
      ],
      [
        -3,
        27
      ],
      [
        -5,
        31
      ],
      [
        -3,
        19
      ],
      [
        -5,
        11
      ],
      [
        2,
        13
      ],
      [
        8,
        7
      ],
      [
        -2,
        9
      ],
      [
        4,
        12
      ],
      [
        0,
        25
      ],
      [
        -3,
        43
      ],
      [
        2,
        13
      ],
      [
        0,
        24
      ],
      [
        -4,
        7
      ],
      [
        -4,
        -4
      ],
      [
        -3,
        12
      ],
      [
        -10,
        1
      ]
    ],
    [
      [
        29300,
        65178
      ],
      [
        13,
        57
      ],
      [
        67,
        28
      ],
      [
        6,
        3
      ],
      [
        7,
        4
      ],
      [
        19,
        10
      ],
      [
        14,
        0
      ]
    ],
    [
      [
        29426,
        65280
      ],
      [
        -1,
        -55
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -50
      ],
      [
        -1,
        -33
      ],
      [
        -1,
        -34
      ],
      [
        0,
        -12
      ]
    ],
    [
      [
        29300,
        65041
      ],
      [
        0,
        4
      ]
    ],
    [
      [
        29236,
        64822
      ],
      [
        -7,
        11
      ]
    ],
    [
      [
        29426,
        65280
      ],
      [
        2,
        108
      ],
      [
        0,
        25
      ],
      [
        1,
        30
      ]
    ],
    [
      [
        29429,
        65443
      ],
      [
        3,
        -1
      ],
      [
        4,
        -6
      ],
      [
        2,
        -16
      ],
      [
        -3,
        -10
      ],
      [
        14,
        -135
      ],
      [
        0,
        -15
      ],
      [
        1,
        -21
      ],
      [
        3,
        7
      ],
      [
        13,
        20
      ],
      [
        3,
        -30
      ],
      [
        12,
        -19
      ],
      [
        6,
        -5
      ]
    ],
    [
      [
        29543,
        64863
      ],
      [
        0,
        -17
      ],
      [
        -1,
        -4
      ],
      [
        -5,
        -4
      ],
      [
        -9,
        13
      ],
      [
        -2,
        3
      ],
      [
        0,
        5
      ],
      [
        -2,
        2
      ],
      [
        -2,
        -3
      ],
      [
        -5,
        -7
      ],
      [
        -5,
        -13
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        1
      ],
      [
        -4,
        -20
      ],
      [
        -4,
        -11
      ],
      [
        -7,
        13
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        -10
      ],
      [
        -1,
        0
      ],
      [
        -5,
        -7
      ],
      [
        -4,
        -3
      ],
      [
        -7,
        -4
      ],
      [
        5,
        -22
      ],
      [
        -9,
        -28
      ],
      [
        -1,
        -4
      ],
      [
        -9,
        -12
      ],
      [
        -3,
        8
      ],
      [
        -1,
        3
      ],
      [
        -4,
        0
      ],
      [
        -5,
        -7
      ],
      [
        -3,
        -17
      ],
      [
        -4,
        14
      ],
      [
        -1,
        -1
      ],
      [
        -6,
        -10
      ],
      [
        0,
        -15
      ],
      [
        -1,
        -8
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        6
      ],
      [
        1,
        8
      ],
      [
        -1,
        4
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        -7
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -8
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -10
      ],
      [
        -3,
        -1
      ],
      [
        -1,
        11
      ],
      [
        -3,
        6
      ],
      [
        -2,
        -1
      ],
      [
        -11,
        -15
      ],
      [
        -2,
        -8
      ],
      [
        -2,
        -12
      ]
    ],
    [
      [
        24246,
        59427
      ],
      [
        2,
        344
      ]
    ],
    [
      [
        24375,
        59881
      ],
      [
        0,
        -118
      ],
      [
        -4,
        0
      ],
      [
        -2,
        -189
      ],
      [
        2,
        -22
      ],
      [
        0,
        -124
      ]
    ],
    [
      [
        90210,
        32355
      ],
      [
        2,
        4
      ],
      [
        2,
        1
      ],
      [
        2,
        -11
      ],
      [
        -3,
        -8
      ],
      [
        -4,
        1
      ],
      [
        1,
        13
      ]
    ],
    [
      [
        90204,
        32599
      ],
      [
        1,
        8
      ],
      [
        4,
        7
      ],
      [
        7,
        1
      ],
      [
        6,
        3
      ],
      [
        6,
        6
      ],
      [
        5,
        6
      ],
      [
        1,
        0
      ],
      [
        5,
        4
      ],
      [
        2,
        -2
      ],
      [
        2,
        -2
      ],
      [
        2,
        3
      ],
      [
        2,
        9
      ],
      [
        -2,
        7
      ],
      [
        1,
        9
      ],
      [
        1,
        4
      ],
      [
        2,
        3
      ],
      [
        4,
        -5
      ],
      [
        2,
        20
      ],
      [
        -1,
        17
      ],
      [
        3,
        19
      ],
      [
        3,
        20
      ],
      [
        4,
        31
      ],
      [
        0,
        30
      ],
      [
        3,
        17
      ],
      [
        3,
        18
      ],
      [
        2,
        2
      ],
      [
        5,
        -13
      ],
      [
        2,
        -15
      ],
      [
        4,
        -17
      ],
      [
        1,
        -11
      ],
      [
        5,
        -6
      ],
      [
        8,
        0
      ],
      [
        1,
        -5
      ],
      [
        -2,
        -20
      ],
      [
        -3,
        -32
      ],
      [
        -5,
        -36
      ],
      [
        -9,
        -25
      ],
      [
        -2,
        -10
      ],
      [
        -9,
        -31
      ],
      [
        -7,
        -25
      ],
      [
        -5,
        -18
      ],
      [
        -6,
        -13
      ],
      [
        -3,
        -31
      ],
      [
        0,
        -23
      ],
      [
        -1,
        -29
      ],
      [
        0,
        -44
      ],
      [
        -1,
        -15
      ],
      [
        -4,
        -20
      ],
      [
        -3,
        -14
      ],
      [
        -5,
        -22
      ],
      [
        -6,
        1
      ],
      [
        -8,
        11
      ],
      [
        -4,
        18
      ],
      [
        -1,
        15
      ],
      [
        -2,
        34
      ],
      [
        -4,
        31
      ],
      [
        0,
        21
      ],
      [
        5,
        28
      ],
      [
        3,
        22
      ],
      [
        -1,
        1
      ],
      [
        -1,
        12
      ],
      [
        -3,
        0
      ],
      [
        -2,
        10
      ],
      [
        -4,
        19
      ],
      [
        -2,
        10
      ],
      [
        1,
        7
      ]
    ],
    [
      [
        22992,
        52713
      ],
      [
        -3,
        12
      ],
      [
        6,
        19
      ],
      [
        -4,
        26
      ],
      [
        -6,
        -1
      ],
      [
        0,
        14
      ],
      [
        3,
        15
      ],
      [
        -4,
        27
      ],
      [
        -5,
        8
      ],
      [
        -7,
        35
      ],
      [
        0,
        18
      ],
      [
        3,
        3
      ],
      [
        -3,
        12
      ],
      [
        3,
        16
      ],
      [
        -4,
        3
      ],
      [
        -5,
        -12
      ],
      [
        -4,
        1
      ],
      [
        0,
        17
      ],
      [
        -3,
        1
      ],
      [
        -4,
        14
      ],
      [
        0,
        19
      ],
      [
        -4,
        18
      ],
      [
        0,
        16
      ],
      [
        7,
        26
      ],
      [
        -3,
        12
      ],
      [
        -4,
        -6
      ],
      [
        -3,
        42
      ],
      [
        4,
        9
      ],
      [
        -5,
        6
      ],
      [
        -3,
        20
      ],
      [
        -3,
        -8
      ],
      [
        -4,
        6
      ],
      [
        3,
        18
      ],
      [
        -6,
        24
      ],
      [
        0,
        6
      ]
    ],
    [
      [
        16035,
        61539
      ],
      [
        3,
        22
      ],
      [
        2,
        -6
      ],
      [
        4,
        18
      ],
      [
        11,
        21
      ],
      [
        1,
        55
      ],
      [
        -4,
        25
      ],
      [
        8,
        14
      ],
      [
        -1,
        33
      ],
      [
        -10,
        9
      ],
      [
        -4,
        29
      ],
      [
        1,
        14
      ],
      [
        8,
        6
      ],
      [
        -1,
        15
      ],
      [
        4,
        11
      ],
      [
        -2,
        29
      ],
      [
        4,
        23
      ],
      [
        -1,
        17
      ],
      [
        -12,
        3
      ],
      [
        -3,
        45
      ],
      [
        -8,
        2
      ],
      [
        -11,
        49
      ],
      [
        7,
        38
      ],
      [
        1,
        20
      ]
    ],
    [
      [
        16032,
        62031
      ],
      [
        10,
        0
      ],
      [
        2,
        1
      ],
      [
        20,
        -2
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        16065,
        62030
      ],
      [
        29,
        -8
      ],
      [
        20,
        -6
      ],
      [
        19,
        -5
      ],
      [
        7,
        -3
      ],
      [
        18,
        -5
      ],
      [
        3,
        0
      ]
    ],
    [
      [
        15960,
        61251
      ],
      [
        5,
        13
      ],
      [
        5,
        -12
      ],
      [
        8,
        -7
      ],
      [
        15,
        31
      ],
      [
        3,
        -5
      ],
      [
        6,
        3
      ],
      [
        1,
        31
      ],
      [
        4,
        24
      ],
      [
        2,
        31
      ],
      [
        7,
        26
      ],
      [
        8,
        15
      ],
      [
        5,
        1
      ],
      [
        3,
        29
      ],
      [
        0,
        87
      ],
      [
        3,
        21
      ]
    ],
    [
      [
        23348,
        58023
      ],
      [
        9,
        12
      ],
      [
        7,
        -9
      ],
      [
        7,
        -31
      ],
      [
        6,
        -7
      ],
      [
        5,
        11
      ],
      [
        5,
        20
      ],
      [
        1,
        17
      ],
      [
        7,
        -3
      ],
      [
        1,
        10
      ],
      [
        -3,
        31
      ],
      [
        2,
        16
      ],
      [
        7,
        -5
      ],
      [
        3,
        11
      ],
      [
        -6,
        16
      ],
      [
        6,
        13
      ],
      [
        5,
        -9
      ],
      [
        6,
        29
      ],
      [
        4,
        10
      ],
      [
        2,
        31
      ],
      [
        3,
        19
      ],
      [
        5,
        11
      ]
    ],
    [
      [
        23430,
        58216
      ],
      [
        7,
        -6
      ],
      [
        0,
        -26
      ],
      [
        6,
        -20
      ],
      [
        15,
        -6
      ],
      [
        1,
        -7
      ],
      [
        6,
        -11
      ],
      [
        6,
        6
      ],
      [
        3,
        -16
      ],
      [
        -1,
        -13
      ],
      [
        -5,
        -17
      ],
      [
        -1,
        -12
      ],
      [
        4,
        -2
      ],
      [
        10,
        11
      ],
      [
        6,
        17
      ],
      [
        5,
        -11
      ],
      [
        0,
        -28
      ],
      [
        4,
        -16
      ]
    ],
    [
      [
        23496,
        58059
      ],
      [
        0,
        -141
      ],
      [
        -32,
        0
      ],
      [
        0,
        -168
      ]
    ],
    [
      [
        23464,
        57750
      ],
      [
        -117,
        0
      ]
    ],
    [
      [
        23347,
        57750
      ],
      [
        0,
        119
      ],
      [
        -30,
        0
      ],
      [
        1,
        49
      ],
      [
        0,
        109
      ]
    ],
    [
      [
        23464,
        57750
      ],
      [
        0,
        -135
      ],
      [
        -19,
        0
      ],
      [
        0,
        -101
      ],
      [
        -18,
        0
      ],
      [
        0,
        -203
      ]
    ],
    [
      [
        23301,
        57311
      ],
      [
        2,
        202
      ],
      [
        0,
        203
      ],
      [
        44,
        0
      ],
      [
        0,
        34
      ]
    ],
    [
      [
        27478,
        64058
      ],
      [
        0,
        -4
      ],
      [
        1,
        -13
      ],
      [
        0,
        -73
      ]
    ],
    [
      [
        27448,
        63962
      ],
      [
        0,
        1
      ],
      [
        4,
        5
      ],
      [
        1,
        3
      ],
      [
        0,
        2
      ],
      [
        -1,
        4
      ],
      [
        0,
        32
      ],
      [
        1,
        3
      ],
      [
        2,
        11
      ],
      [
        0,
        3
      ],
      [
        1,
        10
      ],
      [
        1,
        6
      ],
      [
        0,
        14
      ],
      [
        -1,
        8
      ],
      [
        -1,
        2
      ],
      [
        -2,
        6
      ],
      [
        -2,
        15
      ],
      [
        -1,
        12
      ],
      [
        0,
        10
      ],
      [
        -2,
        17
      ],
      [
        -1,
        3
      ],
      [
        0,
        1
      ],
      [
        -3,
        11
      ],
      [
        -3,
        16
      ],
      [
        0,
        4
      ],
      [
        -3,
        5
      ],
      [
        -1,
        4
      ],
      [
        0,
        11
      ]
    ],
    [
      [
        23800,
        55915
      ],
      [
        24,
        -2
      ],
      [
        43,
        -5
      ]
    ],
    [
      [
        23899,
        55872
      ],
      [
        -3,
        -14
      ],
      [
        -12,
        -121
      ],
      [
        -2,
        -15
      ],
      [
        1,
        -8
      ],
      [
        0,
        -9
      ],
      [
        -3,
        -14
      ],
      [
        1,
        -15
      ],
      [
        -3,
        -21
      ],
      [
        -11,
        2
      ],
      [
        -2,
        -281
      ]
    ],
    [
      [
        23856,
        55376
      ],
      [
        -3,
        0
      ],
      [
        -53,
        1
      ],
      [
        -23,
        0
      ]
    ],
    [
      [
        23777,
        55377
      ],
      [
        0,
        5
      ],
      [
        -4,
        11
      ],
      [
        -2,
        29
      ],
      [
        -9,
        38
      ],
      [
        1,
        29
      ],
      [
        0,
        23
      ],
      [
        5,
        13
      ],
      [
        2,
        -9
      ],
      [
        3,
        1
      ],
      [
        0,
        19
      ],
      [
        4,
        7
      ],
      [
        2,
        4
      ],
      [
        3,
        -14
      ],
      [
        0,
        -11
      ],
      [
        3,
        7
      ],
      [
        0,
        9
      ],
      [
        2,
        11
      ],
      [
        3,
        -4
      ],
      [
        2,
        -6
      ],
      [
        4,
        -4
      ],
      [
        1,
        0
      ],
      [
        0,
        8
      ],
      [
        -2,
        6
      ],
      [
        -6,
        4
      ],
      [
        4,
        12
      ],
      [
        1,
        -4
      ],
      [
        2,
        -4
      ],
      [
        3,
        5
      ],
      [
        -4,
        16
      ],
      [
        -1,
        8
      ],
      [
        2,
        13
      ],
      [
        4,
        8
      ],
      [
        3,
        4
      ],
      [
        2,
        3
      ],
      [
        -3,
        2
      ],
      [
        3,
        24
      ],
      [
        -2,
        19
      ],
      [
        -5,
        20
      ],
      [
        1,
        8
      ],
      [
        4,
        -5
      ],
      [
        2,
        -7
      ],
      [
        4,
        2
      ],
      [
        2,
        15
      ],
      [
        -2,
        14
      ],
      [
        -2,
        16
      ],
      [
        3,
        4
      ],
      [
        5,
        18
      ],
      [
        -5,
        7
      ],
      [
        -3,
        0
      ],
      [
        -3,
        15
      ],
      [
        1,
        9
      ],
      [
        0,
        8
      ],
      [
        2,
        6
      ],
      [
        5,
        0
      ],
      [
        2,
        9
      ],
      [
        -1,
        4
      ],
      [
        -7,
        4
      ],
      [
        -3,
        12
      ],
      [
        -4,
        16
      ],
      [
        -1,
        5
      ],
      [
        0,
        11
      ],
      [
        2,
        1
      ],
      [
        4,
        7
      ],
      [
        -1,
        11
      ],
      [
        -3,
        -7
      ],
      [
        -2,
        -8
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        4
      ],
      [
        2,
        7
      ],
      [
        3,
        7
      ],
      [
        -2,
        9
      ],
      [
        -1,
        6
      ],
      [
        1,
        12
      ],
      [
        4,
        9
      ],
      [
        0,
        10
      ]
    ],
    [
      [
        29050,
        63047
      ],
      [
        5,
        18
      ],
      [
        17,
        59
      ],
      [
        18,
        64
      ]
    ],
    [
      [
        29090,
        63188
      ],
      [
        3,
        -9
      ],
      [
        13,
        -36
      ],
      [
        3,
        -11
      ],
      [
        2,
        -15
      ],
      [
        0,
        -44
      ],
      [
        2,
        -5
      ],
      [
        9,
        0
      ],
      [
        9,
        -17
      ],
      [
        3,
        -16
      ],
      [
        6,
        0
      ],
      [
        4,
        -22
      ],
      [
        3,
        -11
      ],
      [
        4,
        5
      ],
      [
        11,
        -26
      ],
      [
        6,
        -4
      ],
      [
        2,
        12
      ],
      [
        3,
        -20
      ],
      [
        0,
        11
      ],
      [
        5,
        7
      ]
    ],
    [
      [
        29208,
        62920
      ],
      [
        -1,
        -7
      ],
      [
        2,
        -11
      ],
      [
        1,
        -1
      ],
      [
        1,
        -5
      ],
      [
        -1,
        -9
      ],
      [
        -7,
        -36
      ],
      [
        -2,
        -10
      ],
      [
        -9,
        -34
      ],
      [
        -11,
        -29
      ],
      [
        0,
        -14
      ],
      [
        -1,
        -5
      ],
      [
        -13,
        -19
      ],
      [
        -18,
        -36
      ],
      [
        -5,
        -16
      ]
    ],
    [
      [
        29144,
        62688
      ],
      [
        -8,
        -1
      ],
      [
        -5,
        13
      ],
      [
        -8,
        -20
      ],
      [
        -7,
        3
      ],
      [
        -3,
        -8
      ],
      [
        -2,
        10
      ],
      [
        -11,
        -10
      ],
      [
        -6,
        11
      ],
      [
        -9,
        -4
      ],
      [
        -9,
        14
      ],
      [
        -11,
        -2
      ],
      [
        -10,
        22
      ]
    ],
    [
      [
        29020,
        62938
      ],
      [
        21,
        74
      ],
      [
        9,
        35
      ]
    ],
    [
      [
        18072,
        65824
      ],
      [
        -52,
        2
      ],
      [
        -8,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -28,
        0
      ],
      [
        -34,
        5
      ],
      [
        -24,
        4
      ],
      [
        -7,
        0
      ],
      [
        -13,
        -1
      ],
      [
        -6,
        -1
      ],
      [
        -4,
        0
      ],
      [
        -33,
        -5
      ],
      [
        -2,
        0
      ]
    ],
    [
      [
        17861,
        65826
      ],
      [
        0,
        899
      ]
    ],
    [
      [
        22533,
        53511
      ],
      [
        1,
        -7
      ],
      [
        -83,
        -210
      ]
    ],
    [
      [
        27163,
        64280
      ],
      [
        1,
        184
      ],
      [
        0,
        103
      ]
    ],
    [
      [
        27320,
        64653
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        27256,
        64261
      ],
      [
        -36,
        2
      ],
      [
        2,
        11
      ],
      [
        -5,
        5
      ],
      [
        -3,
        -13
      ],
      [
        -24,
        -12
      ],
      [
        -26,
        -12
      ]
    ],
    [
      [
        25846,
        55809
      ],
      [
        7,
        -21
      ],
      [
        3,
        -23
      ],
      [
        -5,
        -7
      ],
      [
        -2,
        -13
      ],
      [
        3,
        -47
      ],
      [
        -10,
        -23
      ],
      [
        -5,
        -3
      ],
      [
        -6,
        11
      ],
      [
        1,
        -38
      ],
      [
        -2,
        -9
      ],
      [
        -3,
        1
      ],
      [
        -6,
        -21
      ],
      [
        2,
        -26
      ],
      [
        -7,
        -1
      ],
      [
        -5,
        -26
      ],
      [
        6,
        -23
      ],
      [
        0,
        -13
      ],
      [
        6,
        -27
      ],
      [
        -8,
        -26
      ]
    ],
    [
      [
        25815,
        55474
      ],
      [
        -6,
        -17
      ],
      [
        1,
        -24
      ],
      [
        -3,
        -12
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        25706,
        55412
      ],
      [
        -15,
        17
      ],
      [
        0,
        17
      ],
      [
        -5,
        0
      ],
      [
        1,
        23
      ],
      [
        -6,
        0
      ],
      [
        0,
        69
      ],
      [
        -5,
        5
      ],
      [
        -10,
        4
      ],
      [
        -1,
        94
      ]
    ],
    [
      [
        15441,
        69375
      ],
      [
        0,
        37
      ]
    ],
    [
      [
        15475,
        68998
      ],
      [
        -28,
        0
      ],
      [
        0,
        21
      ],
      [
        -6,
        0
      ],
      [
        0,
        356
      ]
    ],
    [
      [
        22319,
        62494
      ],
      [
        153,
        -1
      ]
    ],
    [
      [
        22472,
        62493
      ],
      [
        1,
        -1
      ],
      [
        0,
        -304
      ]
    ],
    [
      [
        22473,
        61986
      ],
      [
        -153,
        0
      ]
    ],
    [
      [
        23392,
        62390
      ],
      [
        0,
        -93
      ],
      [
        5,
        5
      ],
      [
        1,
        15
      ],
      [
        7,
        -14
      ],
      [
        8,
        0
      ],
      [
        4,
        -15
      ],
      [
        6,
        9
      ],
      [
        -3,
        21
      ],
      [
        8,
        0
      ]
    ],
    [
      [
        23428,
        62318
      ],
      [
        0,
        -284
      ]
    ],
    [
      [
        22658,
        63505
      ],
      [
        126,
        0
      ]
    ],
    [
      [
        15808,
        61356
      ],
      [
        59,
        -1
      ],
      [
        0,
        9
      ],
      [
        -1,
        7
      ],
      [
        -4,
        13
      ],
      [
        2,
        33
      ],
      [
        4,
        6
      ],
      [
        -1,
        20
      ],
      [
        -4,
        25
      ],
      [
        4,
        7
      ],
      [
        -6,
        5
      ],
      [
        1,
        12
      ],
      [
        7,
        -1
      ],
      [
        -4,
        24
      ],
      [
        -1,
        27
      ],
      [
        40,
        0
      ],
      [
        1,
        16
      ],
      [
        -4,
        37
      ],
      [
        -4,
        27
      ],
      [
        -8,
        35
      ],
      [
        -3,
        17
      ],
      [
        1,
        22
      ],
      [
        5,
        50
      ],
      [
        1,
        26
      ]
    ],
    [
      [
        15893,
        61772
      ],
      [
        13,
        5
      ],
      [
        7,
        -27
      ],
      [
        5,
        -7
      ],
      [
        10,
        23
      ],
      [
        3,
        14
      ],
      [
        7,
        15
      ],
      [
        9,
        -4
      ],
      [
        6,
        10
      ],
      [
        8,
        0
      ],
      [
        13,
        -14
      ],
      [
        7,
        -4
      ],
      [
        5,
        11
      ],
      [
        1,
        -7
      ],
      [
        7,
        13
      ],
      [
        8,
        1
      ],
      [
        5,
        -13
      ],
      [
        0,
        -247
      ],
      [
        1,
        -1
      ],
      [
        27,
        -1
      ]
    ],
    [
      [
        15847,
        61244
      ],
      [
        -1,
        17
      ],
      [
        -3,
        10
      ],
      [
        -5,
        26
      ],
      [
        -5,
        8
      ],
      [
        -14,
        27
      ],
      [
        -7,
        9
      ],
      [
        -1,
        -1
      ]
    ],
    [
      [
        24132,
        59427
      ],
      [
        24,
        0
      ],
      [
        7,
        -1
      ],
      [
        10,
        0
      ],
      [
        2,
        -1
      ],
      [
        7,
        1
      ],
      [
        12,
        0
      ],
      [
        26,
        1
      ],
      [
        1,
        0
      ],
      [
        3,
        -1
      ],
      [
        14,
        1
      ]
    ],
    [
      [
        24225,
        59001
      ],
      [
        0,
        -86
      ],
      [
        -30,
        2
      ],
      [
        -1,
        -101
      ],
      [
        -30,
        2
      ]
    ],
    [
      [
        24165,
        58919
      ],
      [
        1,
        84
      ],
      [
        -5,
        17
      ],
      [
        3,
        0
      ],
      [
        2,
        4
      ],
      [
        -6,
        13
      ],
      [
        1,
        17
      ],
      [
        -4,
        -17
      ],
      [
        -6,
        18
      ],
      [
        -5,
        17
      ],
      [
        6,
        25
      ],
      [
        -5,
        15
      ],
      [
        1,
        33
      ],
      [
        -7,
        2
      ],
      [
        -6,
        12
      ],
      [
        -7,
        -6
      ],
      [
        6,
        41
      ],
      [
        -4,
        12
      ],
      [
        -4,
        5
      ],
      [
        -6,
        -8
      ],
      [
        1,
        19
      ],
      [
        5,
        16
      ],
      [
        5,
        -8
      ],
      [
        2,
        17
      ],
      [
        -2,
        8
      ],
      [
        -12,
        -10
      ],
      [
        -4,
        19
      ],
      [
        11,
        24
      ],
      [
        1,
        9
      ],
      [
        4,
        -1
      ],
      [
        1,
        131
      ]
    ],
    [
      [
        28645,
        59881
      ],
      [
        4,
        -4
      ],
      [
        1,
        12
      ],
      [
        0,
        8
      ],
      [
        -1,
        0
      ],
      [
        -2,
        1
      ],
      [
        -1,
        14
      ],
      [
        -1,
        27
      ],
      [
        1,
        24
      ],
      [
        2,
        0
      ],
      [
        1,
        -5
      ],
      [
        5,
        12
      ],
      [
        1,
        3
      ],
      [
        3,
        1
      ],
      [
        5,
        -5
      ],
      [
        1,
        -3
      ],
      [
        8,
        -19
      ],
      [
        4,
        -7
      ],
      [
        3,
        -3
      ],
      [
        6,
        -6
      ],
      [
        1,
        -1
      ]
    ],
    [
      [
        28686,
        59930
      ],
      [
        -1,
        -14
      ],
      [
        -1,
        -1
      ],
      [
        1,
        -5
      ],
      [
        0,
        -4
      ],
      [
        2,
        -4
      ],
      [
        -3,
        -34
      ],
      [
        0,
        -14
      ],
      [
        4,
        -13
      ],
      [
        -5,
        -31
      ],
      [
        -5,
        5
      ],
      [
        -3,
        9
      ]
    ],
    [
      [
        28675,
        59824
      ],
      [
        -5,
        -3
      ],
      [
        -4,
        -19
      ],
      [
        -4,
        7
      ],
      [
        -5,
        -6
      ]
    ],
    [
      [
        28657,
        59803
      ],
      [
        -2,
        13
      ],
      [
        0,
        13
      ],
      [
        -1,
        3
      ],
      [
        -4,
        14
      ],
      [
        -6,
        19
      ],
      [
        1,
        8
      ],
      [
        0,
        8
      ]
    ],
    [
      [
        20988,
        55314
      ],
      [
        14,
        0
      ],
      [
        0,
        500
      ],
      [
        12,
        0
      ],
      [
        0,
        203
      ],
      [
        59,
        1
      ]
    ],
    [
      [
        21073,
        56018
      ],
      [
        127,
        0
      ]
    ],
    [
      [
        21124,
        54191
      ],
      [
        -110,
        -1
      ]
    ],
    [
      [
        24421,
        54427
      ],
      [
        -12,
        0
      ],
      [
        -3,
        8
      ],
      [
        6,
        12
      ],
      [
        4,
        27
      ],
      [
        -4,
        -11
      ],
      [
        -9,
        18
      ],
      [
        4,
        11
      ],
      [
        6,
        -7
      ],
      [
        -1,
        55
      ],
      [
        6,
        -6
      ],
      [
        0,
        21
      ],
      [
        9,
        4
      ],
      [
        -2,
        30
      ],
      [
        -4,
        -5
      ],
      [
        -2,
        11
      ],
      [
        4,
        22
      ],
      [
        2,
        -13
      ],
      [
        4,
        -5
      ],
      [
        4,
        12
      ],
      [
        0,
        8
      ],
      [
        -7,
        19
      ],
      [
        0,
        25
      ]
    ],
    [
      [
        21045,
        53785
      ],
      [
        -6,
        25
      ],
      [
        -1,
        20
      ],
      [
        4,
        0
      ],
      [
        -1,
        17
      ],
      [
        -10,
        6
      ],
      [
        -4,
        14
      ],
      [
        -5,
        30
      ],
      [
        -9,
        -10
      ],
      [
        -8,
        2
      ],
      [
        -1,
        12
      ],
      [
        -6,
        14
      ],
      [
        -1,
        13
      ],
      [
        -4,
        -5
      ],
      [
        -3,
        28
      ],
      [
        0,
        32
      ],
      [
        -4,
        19
      ],
      [
        3,
        9
      ],
      [
        -5,
        19
      ],
      [
        0,
        30
      ],
      [
        -3,
        1
      ],
      [
        -13,
        -22
      ],
      [
        1,
        25
      ],
      [
        -8,
        13
      ],
      [
        -2,
        17
      ],
      [
        1,
        16
      ],
      [
        -2,
        13
      ],
      [
        -5,
        3
      ],
      [
        -2,
        11
      ],
      [
        2,
        8
      ],
      [
        -3,
        30
      ],
      [
        -6,
        -9
      ],
      [
        -3,
        17
      ],
      [
        1,
        7
      ]
    ],
    [
      [
        20635,
        63455
      ],
      [
        8,
        -1
      ],
      [
        0,
        7
      ],
      [
        -1,
        5
      ],
      [
        0,
        7
      ],
      [
        -7,
        -18
      ]
    ],
    [
      [
        20633,
        63454
      ],
      [
        -4,
        -1
      ],
      [
        -2,
        -1
      ]
    ],
    [
      [
        20627,
        63452
      ],
      [
        1,
        2
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        0,
        -1
      ],
      [
        3,
        0
      ]
    ],
    [
      [
        20617,
        63402
      ],
      [
        0,
        18
      ],
      [
        3,
        12
      ],
      [
        2,
        17
      ],
      [
        5,
        3
      ]
    ],
    [
      [
        20627,
        63452
      ],
      [
        -2,
        -27
      ],
      [
        2,
        -9
      ],
      [
        0,
        12
      ],
      [
        10,
        9
      ],
      [
        1,
        16
      ],
      [
        -5,
        1
      ]
    ],
    [
      [
        20633,
        63454
      ],
      [
        6,
        15
      ],
      [
        4,
        8
      ],
      [
        0,
        26
      ]
    ],
    [
      [
        20669,
        63503
      ],
      [
        -6,
        0
      ],
      [
        -2,
        -37
      ],
      [
        -7,
        15
      ],
      [
        0,
        -70
      ],
      [
        -11,
        -8
      ]
    ],
    [
      [
        23461,
        57108
      ],
      [
        2,
        0
      ],
      [
        131,
        1
      ]
    ],
    [
      [
        23592,
        56739
      ],
      [
        -2,
        -195
      ],
      [
        0,
        -95
      ]
    ],
    [
      [
        23517,
        56176
      ],
      [
        0,
        19
      ],
      [
        -1,
        5
      ],
      [
        -3,
        3
      ],
      [
        -2,
        0
      ],
      [
        -1,
        3
      ],
      [
        -1,
        7
      ],
      [
        0,
        18
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        -4,
        -10
      ],
      [
        -3,
        -2
      ],
      [
        -3,
        5
      ],
      [
        -1,
        3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -6,
        7
      ],
      [
        -1,
        4
      ],
      [
        -1,
        4
      ],
      [
        1,
        4
      ],
      [
        0,
        6
      ],
      [
        -1,
        5
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        3
      ],
      [
        -4,
        11
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ],
      [
        -3,
        9
      ],
      [
        0,
        10
      ],
      [
        1,
        8
      ],
      [
        0,
        9
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -2,
        2
      ],
      [
        -1,
        6
      ],
      [
        0,
        9
      ],
      [
        -2,
        11
      ],
      [
        -2,
        3
      ],
      [
        -1,
        13
      ],
      [
        0,
        14
      ],
      [
        -1,
        2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -9
      ],
      [
        0,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -1,
        1
      ],
      [
        -1,
        6
      ],
      [
        -1,
        6
      ],
      [
        -2,
        4
      ],
      [
        -3,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        -4,
        1
      ],
      [
        -3,
        2
      ],
      [
        -1,
        2
      ],
      [
        -2,
        26
      ],
      [
        -1,
        10
      ],
      [
        -1,
        5
      ],
      [
        -2,
        3
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        0
      ],
      [
        -1,
        3
      ],
      [
        -1,
        4
      ],
      [
        1,
        6
      ],
      [
        -1,
        6
      ],
      [
        -1,
        3
      ],
      [
        -1,
        2
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        3
      ],
      [
        -1,
        4
      ],
      [
        0,
        14
      ],
      [
        -1,
        4
      ],
      [
        -2,
        3
      ],
      [
        -5,
        -1
      ],
      [
        -1,
        1
      ]
    ],
    [
      [
        27427,
        63686
      ],
      [
        5,
        28
      ],
      [
        1,
        3
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        27478,
        63688
      ],
      [
        0,
        -166
      ]
    ],
    [
      [
        26591,
        57972
      ],
      [
        -2,
        10
      ],
      [
        -6,
        -15
      ],
      [
        -11,
        1
      ],
      [
        -6,
        14
      ],
      [
        -8,
        -8
      ],
      [
        -2,
        6
      ],
      [
        -12,
        -14
      ],
      [
        -6,
        -12
      ],
      [
        -2,
        2
      ],
      [
        -12,
        -18
      ],
      [
        -7,
        -2
      ],
      [
        -9,
        18
      ],
      [
        0,
        19
      ],
      [
        -2,
        7
      ],
      [
        0,
        20
      ],
      [
        -5,
        22
      ]
    ],
    [
      [
        26501,
        58022
      ],
      [
        0,
        1
      ],
      [
        1,
        4
      ],
      [
        1,
        6
      ],
      [
        -2,
        9
      ],
      [
        0,
        2
      ],
      [
        -2,
        1
      ],
      [
        0,
        7
      ],
      [
        1,
        9
      ],
      [
        0,
        13
      ],
      [
        -2,
        14
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        3,
        3
      ],
      [
        0,
        1
      ],
      [
        1,
        3
      ],
      [
        0,
        3
      ],
      [
        1,
        6
      ],
      [
        3,
        8
      ],
      [
        -1,
        8
      ],
      [
        0,
        14
      ],
      [
        -1,
        8
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        11
      ],
      [
        1,
        2
      ],
      [
        1,
        1
      ],
      [
        0,
        4
      ],
      [
        2,
        6
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        0,
        7
      ],
      [
        1,
        3
      ],
      [
        1,
        5
      ],
      [
        2,
        5
      ],
      [
        2,
        7
      ],
      [
        1,
        1
      ],
      [
        0,
        4
      ],
      [
        1,
        3
      ],
      [
        1,
        0
      ],
      [
        1,
        5
      ],
      [
        1,
        4
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        26427,
        57923
      ],
      [
        1,
        22
      ],
      [
        0,
        -1
      ],
      [
        2,
        2
      ],
      [
        0,
        2
      ],
      [
        2,
        8
      ],
      [
        4,
        8
      ],
      [
        1,
        5
      ],
      [
        1,
        4
      ],
      [
        3,
        4
      ],
      [
        1,
        2
      ],
      [
        2,
        12
      ],
      [
        1,
        3
      ],
      [
        1,
        2
      ],
      [
        4,
        -4
      ],
      [
        1,
        -7
      ],
      [
        0,
        -2
      ],
      [
        1,
        -3
      ],
      [
        0,
        -9
      ],
      [
        1,
        -4
      ],
      [
        0,
        -1
      ],
      [
        2,
        -1
      ],
      [
        1,
        -3
      ],
      [
        3,
        0
      ],
      [
        0,
        2
      ],
      [
        2,
        4
      ],
      [
        1,
        0
      ],
      [
        2,
        -2
      ],
      [
        0,
        3
      ],
      [
        1,
        0
      ],
      [
        4,
        1
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        0
      ],
      [
        0,
        3
      ],
      [
        1,
        4
      ],
      [
        1,
        1
      ],
      [
        2,
        0
      ],
      [
        0,
        -2
      ],
      [
        1,
        2
      ],
      [
        2,
        -2
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        2,
        3
      ],
      [
        3,
        9
      ],
      [
        0,
        4
      ],
      [
        2,
        3
      ],
      [
        1,
        0
      ],
      [
        2,
        4
      ],
      [
        2,
        1
      ],
      [
        1,
        3
      ],
      [
        3,
        9
      ],
      [
        2,
        12
      ],
      [
        2,
        4
      ]
    ],
    [
      [
        26507,
        57668
      ],
      [
        -34,
        0
      ]
    ],
    [
      [
        23066,
        66153
      ],
      [
        -103,
        1
      ]
    ],
    [
      [
        29773,
        66671
      ],
      [
        22,
        -3
      ],
      [
        22,
        -2
      ],
      [
        4,
        0
      ],
      [
        8,
        -1
      ],
      [
        1,
        0
      ],
      [
        27,
        -4
      ],
      [
        15,
        -1
      ]
    ],
    [
      [
        29872,
        66660
      ],
      [
        8,
        -1
      ]
    ],
    [
      [
        29880,
        66659
      ],
      [
        1,
        -9
      ],
      [
        11,
        -34
      ],
      [
        -1,
        -47
      ],
      [
        4,
        4
      ],
      [
        19,
        -1
      ],
      [
        0,
        9
      ],
      [
        31,
        -38
      ],
      [
        -4,
        -95
      ],
      [
        12,
        -7
      ],
      [
        -1,
        8
      ],
      [
        6,
        25
      ],
      [
        3,
        -8
      ],
      [
        4,
        -2
      ],
      [
        4,
        8
      ],
      [
        11,
        -9
      ],
      [
        2,
        -23
      ],
      [
        1,
        -4
      ],
      [
        -9,
        -53
      ],
      [
        5,
        -9
      ],
      [
        -1,
        -23
      ],
      [
        -3,
        -41
      ],
      [
        -13,
        -16
      ],
      [
        7,
        -13
      ],
      [
        -6,
        -23
      ],
      [
        -2,
        -11
      ],
      [
        -5,
        -8
      ],
      [
        2,
        -9
      ],
      [
        4,
        -7
      ],
      [
        6,
        -30
      ],
      [
        9,
        18
      ],
      [
        11,
        3
      ],
      [
        2,
        -1
      ],
      [
        5,
        2
      ],
      [
        0,
        -22
      ],
      [
        -3,
        -25
      ],
      [
        -3,
        -30
      ],
      [
        -4,
        3
      ],
      [
        -5,
        -4
      ],
      [
        -3,
        4
      ],
      [
        -2,
        2
      ],
      [
        -5,
        -7
      ],
      [
        -4,
        -13
      ],
      [
        -2,
        -29
      ],
      [
        -1,
        -9
      ],
      [
        5,
        -27
      ],
      [
        8,
        -15
      ],
      [
        4,
        9
      ],
      [
        10,
        2
      ],
      [
        2,
        -29
      ],
      [
        5,
        -12
      ]
    ],
    [
      [
        29823,
        65864
      ],
      [
        -9,
        2
      ]
    ],
    [
      [
        29790,
        66116
      ],
      [
        3,
        7
      ],
      [
        -1,
        10
      ],
      [
        -1,
        12
      ],
      [
        2,
        0
      ],
      [
        0,
        15
      ],
      [
        2,
        10
      ],
      [
        -3,
        3
      ],
      [
        1,
        20
      ],
      [
        -9,
        -6
      ],
      [
        -9,
        -5
      ],
      [
        -4,
        59
      ],
      [
        -5,
        -10
      ],
      [
        -2,
        0
      ]
    ],
    [
      [
        26281,
        62946
      ],
      [
        1,
        31
      ],
      [
        0,
        22
      ]
    ],
    [
      [
        26282,
        62999
      ],
      [
        93,
        2
      ],
      [
        0,
        26
      ]
    ],
    [
      [
        26375,
        63027
      ],
      [
        2,
        -1
      ],
      [
        30,
        -1
      ]
    ],
    [
      [
        26410,
        62679
      ],
      [
        -31,
        12
      ],
      [
        -5,
        -1
      ],
      [
        -6,
        5
      ],
      [
        -16,
        2
      ],
      [
        -19,
        5
      ],
      [
        -3,
        -8
      ],
      [
        -17,
        -1
      ],
      [
        -33,
        1
      ]
    ],
    [
      [
        23774,
        55377
      ],
      [
        3,
        0
      ]
    ],
    [
      [
        23870,
        54466
      ],
      [
        3,
        15
      ],
      [
        -7,
        9
      ],
      [
        1,
        -18
      ],
      [
        -2,
        2
      ],
      [
        -1,
        25
      ],
      [
        -5,
        12
      ],
      [
        -4,
        -2
      ],
      [
        3,
        27
      ],
      [
        -7,
        -8
      ],
      [
        1,
        17
      ],
      [
        2,
        10
      ],
      [
        -3,
        6
      ],
      [
        -2,
        -14
      ],
      [
        -3,
        29
      ],
      [
        -7,
        -3
      ],
      [
        -2,
        23
      ],
      [
        -7,
        0
      ],
      [
        -2,
        6
      ],
      [
        4,
        19
      ],
      [
        -5,
        -10
      ],
      [
        -1,
        44
      ],
      [
        -6,
        -25
      ],
      [
        4,
        21
      ],
      [
        -3,
        8
      ],
      [
        -6,
        1
      ],
      [
        1,
        -18
      ],
      [
        -6,
        9
      ],
      [
        0,
        13
      ],
      [
        7,
        11
      ],
      [
        -6,
        1
      ],
      [
        -3,
        6
      ],
      [
        4,
        13
      ],
      [
        2,
        -15
      ],
      [
        3,
        8
      ],
      [
        -4,
        15
      ],
      [
        -5,
        10
      ],
      [
        3,
        11
      ],
      [
        -5,
        27
      ],
      [
        1,
        14
      ],
      [
        -6,
        -7
      ],
      [
        4,
        11
      ],
      [
        -10,
        18
      ],
      [
        -8,
        33
      ],
      [
        4,
        -5
      ],
      [
        4,
        23
      ],
      [
        -4,
        0
      ],
      [
        0,
        10
      ],
      [
        5,
        17
      ],
      [
        -1,
        13
      ],
      [
        -5,
        -4
      ],
      [
        -3,
        10
      ],
      [
        7,
        8
      ],
      [
        -5,
        4
      ],
      [
        3,
        17
      ],
      [
        -3,
        24
      ],
      [
        -6,
        -3
      ],
      [
        1,
        11
      ],
      [
        4,
        5
      ],
      [
        -3,
        25
      ],
      [
        -3,
        -6
      ],
      [
        1,
        50
      ],
      [
        -1,
        15
      ],
      [
        -4,
        1
      ],
      [
        -5,
        -17
      ],
      [
        -2,
        6
      ],
      [
        2,
        23
      ],
      [
        8,
        27
      ],
      [
        2,
        29
      ],
      [
        -1,
        12
      ],
      [
        -5,
        3
      ],
      [
        -3,
        -17
      ],
      [
        -2,
        12
      ],
      [
        2,
        10
      ],
      [
        5,
        7
      ],
      [
        2,
        17
      ],
      [
        1,
        41
      ],
      [
        -4,
        -12
      ],
      [
        -4,
        5
      ],
      [
        4,
        11
      ],
      [
        0,
        12
      ],
      [
        -5,
        16
      ],
      [
        -1,
        20
      ],
      [
        6,
        35
      ],
      [
        -6,
        17
      ],
      [
        -6,
        4
      ],
      [
        5,
        19
      ],
      [
        7,
        -1
      ],
      [
        -1,
        10
      ],
      [
        -5,
        -8
      ],
      [
        1,
        10
      ],
      [
        -2,
        42
      ],
      [
        3,
        9
      ]
    ],
    [
      [
        24940,
        65348
      ],
      [
        0,
        368
      ]
    ],
    [
      [
        15852,
        69961
      ],
      [
        13,
        19
      ],
      [
        5,
        15
      ],
      [
        12,
        8
      ],
      [
        4,
        -1
      ],
      [
        0,
        -1
      ],
      [
        4,
        -1
      ],
      [
        3,
        2
      ],
      [
        16,
        30
      ],
      [
        6,
        7
      ],
      [
        6,
        1
      ],
      [
        5,
        8
      ],
      [
        1,
        2
      ],
      [
        5,
        10
      ],
      [
        2,
        12
      ],
      [
        1,
        2
      ],
      [
        5,
        -1
      ],
      [
        3,
        6
      ]
    ],
    [
      [
        15943,
        70079
      ],
      [
        0,
        -45
      ],
      [
        3,
        -11
      ],
      [
        -2,
        -16
      ],
      [
        5,
        -38
      ],
      [
        -4,
        -10
      ],
      [
        3,
        -29
      ],
      [
        3,
        -9
      ],
      [
        7,
        1
      ],
      [
        2,
        -25
      ],
      [
        12,
        -37
      ]
    ],
    [
      [
        15714,
        69827
      ],
      [
        0,
        97
      ],
      [
        -5,
        4
      ],
      [
        0,
        16
      ],
      [
        -6,
        17
      ],
      [
        -6,
        17
      ],
      [
        -6,
        4
      ],
      [
        -5,
        13
      ],
      [
        0,
        17
      ],
      [
        -6,
        0
      ],
      [
        0,
        17
      ],
      [
        -6,
        0
      ],
      [
        0,
        16
      ],
      [
        -6,
        1
      ],
      [
        -5,
        25
      ],
      [
        0,
        92
      ]
    ],
    [
      [
        28135,
        56934
      ],
      [
        7,
        17
      ],
      [
        12,
        -23
      ],
      [
        4,
        -14
      ],
      [
        14,
        -10
      ]
    ],
    [
      [
        28198,
        56436
      ],
      [
        -3,
        -20
      ],
      [
        -3,
        -40
      ],
      [
        -1,
        -29
      ],
      [
        -3,
        -10
      ],
      [
        -10,
        17
      ],
      [
        0,
        10
      ],
      [
        -3,
        24
      ],
      [
        -21,
        21
      ],
      [
        -12,
        7
      ],
      [
        -11,
        2
      ],
      [
        -28,
        -2
      ],
      [
        -30,
        -12
      ],
      [
        -35,
        -42
      ],
      [
        -8,
        -17
      ]
    ],
    [
      [
        27999,
        56453
      ],
      [
        2,
        17
      ],
      [
        -1,
        8
      ],
      [
        5,
        8
      ],
      [
        1,
        10
      ],
      [
        -4,
        34
      ],
      [
        6,
        15
      ],
      [
        7,
        7
      ],
      [
        4,
        11
      ],
      [
        -1,
        12
      ],
      [
        5,
        6
      ],
      [
        3,
        15
      ],
      [
        -2,
        29
      ],
      [
        4,
        12
      ],
      [
        -2,
        6
      ],
      [
        4,
        48
      ],
      [
        4,
        7
      ],
      [
        3,
        13
      ],
      [
        5,
        2
      ],
      [
        3,
        -10
      ],
      [
        18,
        -22
      ],
      [
        13,
        57
      ],
      [
        0,
        19
      ],
      [
        33,
        13
      ],
      [
        26,
        164
      ]
    ],
    [
      [
        26013,
        59123
      ],
      [
        0,
        13
      ],
      [
        10,
        -24
      ],
      [
        5,
        6
      ],
      [
        21,
        -15
      ],
      [
        4,
        -8
      ],
      [
        10,
        15
      ],
      [
        7,
        5
      ],
      [
        5,
        -9
      ],
      [
        0,
        13
      ],
      [
        6,
        10
      ],
      [
        0,
        19
      ],
      [
        6,
        -3
      ],
      [
        1,
        25
      ],
      [
        4,
        2
      ],
      [
        0,
        26
      ]
    ],
    [
      [
        26202,
        59008
      ],
      [
        -9,
        -12
      ],
      [
        -6,
        -34
      ],
      [
        -23,
        7
      ],
      [
        -3,
        -5
      ],
      [
        0,
        -19
      ],
      [
        1,
        -35
      ],
      [
        -2,
        -16
      ],
      [
        -3,
        -52
      ],
      [
        1,
        -21
      ],
      [
        -2,
        1
      ]
    ],
    [
      [
        28178,
        59082
      ],
      [
        18,
        112
      ],
      [
        9,
        98
      ],
      [
        0,
        49
      ],
      [
        -2,
        9
      ],
      [
        2,
        12
      ],
      [
        1,
        36
      ],
      [
        2,
        35
      ]
    ],
    [
      [
        28208,
        59433
      ],
      [
        12,
        3
      ],
      [
        11,
        -7
      ],
      [
        8,
        -11
      ],
      [
        4,
        -11
      ],
      [
        9,
        -2
      ],
      [
        3,
        8
      ],
      [
        6,
        0
      ],
      [
        8,
        -9
      ],
      [
        10,
        1
      ],
      [
        4,
        -34
      ],
      [
        6,
        -16
      ],
      [
        5,
        -7
      ],
      [
        1,
        -9
      ],
      [
        9,
        -6
      ],
      [
        3,
        -30
      ],
      [
        -1,
        -21
      ],
      [
        -9,
        -28
      ],
      [
        -1,
        -17
      ],
      [
        4,
        -25
      ],
      [
        8,
        -13
      ],
      [
        13,
        6
      ],
      [
        7,
        15
      ],
      [
        8,
        4
      ],
      [
        7,
        -36
      ],
      [
        2,
        -35
      ],
      [
        8,
        -16
      ],
      [
        1,
        -18
      ],
      [
        -3,
        -24
      ],
      [
        10,
        -26
      ],
      [
        6,
        1
      ],
      [
        8,
        -31
      ],
      [
        3,
        3
      ]
    ],
    [
      [
        28378,
        59042
      ],
      [
        7,
        -10
      ],
      [
        0,
        -24
      ],
      [
        4,
        -3
      ],
      [
        0,
        -26
      ],
      [
        6,
        -10
      ],
      [
        -23,
        -19
      ],
      [
        -4,
        -21
      ]
    ],
    [
      [
        28368,
        58929
      ],
      [
        -4,
        -6
      ],
      [
        -17,
        -71
      ]
    ],
    [
      [
        28264,
        59025
      ],
      [
        -6,
        -13
      ],
      [
        0,
        -10
      ],
      [
        -2,
        18
      ],
      [
        -6,
        9
      ],
      [
        -2,
        -9
      ],
      [
        -7,
        -9
      ],
      [
        -5,
        4
      ],
      [
        -2,
        -8
      ],
      [
        -4,
        8
      ],
      [
        -11,
        5
      ],
      [
        -7,
        -6
      ],
      [
        -4,
        22
      ],
      [
        -6,
        5
      ],
      [
        1,
        17
      ],
      [
        -7,
        13
      ],
      [
        -2,
        -14
      ],
      [
        -5,
        16
      ],
      [
        -2,
        -23
      ],
      [
        -3,
        17
      ],
      [
        -6,
        15
      ]
    ],
    [
      [
        18513,
        67720
      ],
      [
        0,
        -97
      ],
      [
        -17,
        -4
      ],
      [
        -16,
        0
      ],
      [
        0,
        -101
      ],
      [
        -33,
        0
      ],
      [
        -3,
        -96
      ],
      [
        0,
        -96
      ],
      [
        -17,
        0
      ]
    ],
    [
      [
        20643,
        63259
      ],
      [
        9,
        4
      ],
      [
        2,
        -4
      ],
      [
        11,
        0
      ],
      [
        2,
        9
      ],
      [
        8,
        -9
      ],
      [
        3,
        -8
      ],
      [
        4,
        0
      ],
      [
        3,
        17
      ],
      [
        5,
        0
      ],
      [
        0,
        17
      ],
      [
        5,
        0
      ],
      [
        0,
        -17
      ],
      [
        21,
        0
      ],
      [
        0,
        50
      ],
      [
        17,
        4
      ],
      [
        0,
        63
      ],
      [
        2,
        0
      ],
      [
        5,
        -1
      ],
      [
        3,
        19
      ],
      [
        4,
        -9
      ],
      [
        11,
        -1
      ],
      [
        2,
        -8
      ],
      [
        9,
        1
      ],
      [
        -1,
        -30
      ],
      [
        -4,
        0
      ],
      [
        0,
        -60
      ],
      [
        -40,
        1
      ],
      [
        0,
        -29
      ],
      [
        8,
        0
      ],
      [
        0,
        -34
      ],
      [
        -13,
        5
      ],
      [
        -13,
        0
      ],
      [
        -2,
        -9
      ],
      [
        -6,
        3
      ],
      [
        3,
        -16
      ],
      [
        -10,
        0
      ],
      [
        -1,
        -17
      ]
    ],
    [
      [
        24437,
        55361
      ],
      [
        -4,
        -26
      ],
      [
        4,
        -3
      ],
      [
        -6,
        -18
      ],
      [
        -6,
        -35
      ],
      [
        1,
        -7
      ],
      [
        -6,
        -32
      ],
      [
        1,
        -13
      ],
      [
        -5,
        -14
      ],
      [
        -7,
        -1
      ],
      [
        -8,
        -26
      ],
      [
        -4,
        -30
      ],
      [
        -3,
        -25
      ],
      [
        0,
        -13
      ],
      [
        -4,
        -11
      ],
      [
        3,
        -25
      ],
      [
        -1,
        -20
      ],
      [
        -6,
        -33
      ],
      [
        -3,
        -2
      ],
      [
        -3,
        -19
      ],
      [
        5,
        -8
      ],
      [
        0,
        -18
      ],
      [
        -4,
        -15
      ]
    ],
    [
      [
        24304,
        54779
      ],
      [
        3,
        11
      ],
      [
        -1,
        15
      ],
      [
        -6,
        49
      ],
      [
        1,
        4
      ],
      [
        -5,
        16
      ],
      [
        5,
        36
      ],
      [
        0,
        31
      ],
      [
        4,
        19
      ],
      [
        -7,
        -3
      ],
      [
        -9,
        32
      ],
      [
        -2,
        29
      ],
      [
        -12,
        -12
      ],
      [
        -4,
        13
      ],
      [
        -4,
        -6
      ],
      [
        4,
        -8
      ],
      [
        -5,
        -16
      ],
      [
        2,
        15
      ],
      [
        -4,
        -1
      ],
      [
        0,
        23
      ],
      [
        -2,
        6
      ]
    ],
    [
      [
        28627,
        60202
      ],
      [
        -1,
        -5
      ],
      [
        2,
        -3
      ],
      [
        3,
        -2
      ],
      [
        2,
        6
      ],
      [
        4,
        9
      ],
      [
        3,
        2
      ],
      [
        2,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        1,
        -5
      ],
      [
        1,
        -10
      ],
      [
        1,
        -9
      ],
      [
        1,
        -3
      ],
      [
        2,
        2
      ],
      [
        4,
        -5
      ],
      [
        5,
        -14
      ],
      [
        1,
        -11
      ]
    ],
    [
      [
        28624,
        59891
      ],
      [
        6,
        3
      ],
      [
        0,
        27
      ],
      [
        9,
        0
      ],
      [
        1,
        -33
      ],
      [
        5,
        -7
      ]
    ],
    [
      [
        28657,
        59803
      ],
      [
        -1,
        -27
      ],
      [
        -20,
        -13
      ],
      [
        -3,
        -2
      ],
      [
        -3,
        15
      ],
      [
        -4,
        9
      ],
      [
        -1,
        9
      ],
      [
        6,
        27
      ],
      [
        -1,
        17
      ],
      [
        -4,
        11
      ],
      [
        0,
        4
      ],
      [
        -6,
        2
      ]
    ],
    [
      [
        28620,
        59855
      ],
      [
        2,
        9
      ],
      [
        3,
        8
      ],
      [
        0,
        15
      ],
      [
        -1,
        4
      ]
    ],
    [
      [
        20476,
        63806
      ],
      [
        31,
        1
      ],
      [
        38,
        -4
      ],
      [
        8,
        4
      ],
      [
        24,
        2
      ],
      [
        37,
        -2
      ],
      [
        29,
        0
      ]
    ],
    [
      [
        20547,
        63401
      ],
      [
        0,
        24
      ],
      [
        -1,
        2
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        3
      ],
      [
        -2,
        -6
      ],
      [
        -1,
        3
      ],
      [
        -2,
        0
      ],
      [
        -2,
        7
      ],
      [
        -6,
        -6
      ],
      [
        -60,
        0
      ]
    ],
    [
      [
        24807,
        52054
      ],
      [
        7,
        -9
      ],
      [
        12,
        -2
      ],
      [
        10,
        9
      ],
      [
        8,
        15
      ],
      [
        20,
        26
      ],
      [
        15,
        -10
      ],
      [
        8,
        -11
      ],
      [
        6,
        -23
      ],
      [
        6,
        -1
      ],
      [
        6,
        12
      ],
      [
        3,
        9
      ],
      [
        9,
        -19
      ],
      [
        8,
        16
      ],
      [
        8,
        -19
      ],
      [
        9,
        -8
      ]
    ],
    [
      [
        24942,
        52039
      ],
      [
        -1,
        -3
      ],
      [
        -4,
        -13
      ],
      [
        -4,
        -23
      ],
      [
        -4,
        -9
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -19
      ],
      [
        -1,
        -19
      ],
      [
        -4,
        -6
      ],
      [
        -4,
        -2
      ],
      [
        -4,
        -7
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -9
      ],
      [
        4,
        -25
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -5
      ],
      [
        -3,
        0
      ],
      [
        -3,
        12
      ],
      [
        -5,
        11
      ],
      [
        -5,
        4
      ],
      [
        -10,
        -3
      ],
      [
        -6,
        -22
      ],
      [
        -5,
        -23
      ],
      [
        0,
        -8
      ]
    ],
    [
      [
        24862,
        51708
      ],
      [
        -2,
        -1
      ],
      [
        -5,
        30
      ],
      [
        -14,
        14
      ],
      [
        -1,
        -18
      ],
      [
        -5,
        7
      ]
    ],
    [
      [
        25374,
        54179
      ],
      [
        11,
        -1
      ],
      [
        63,
        1
      ],
      [
        14,
        0
      ],
      [
        25,
        1
      ]
    ],
    [
      [
        25487,
        54180
      ],
      [
        0,
        -132
      ],
      [
        13,
        -9
      ],
      [
        0,
        -50
      ],
      [
        33,
        2
      ]
    ],
    [
      [
        25533,
        53991
      ],
      [
        0,
        -17
      ],
      [
        -5,
        0
      ],
      [
        1,
        -136
      ],
      [
        -14,
        0
      ],
      [
        0,
        -168
      ],
      [
        -9,
        -30
      ],
      [
        -6,
        -15
      ],
      [
        4,
        -17
      ],
      [
        12,
        -26
      ],
      [
        0,
        -15
      ],
      [
        -4,
        -38
      ],
      [
        -3,
        -9
      ],
      [
        -2,
        -11
      ],
      [
        -5,
        -8
      ],
      [
        -3,
        3
      ],
      [
        -4,
        17
      ],
      [
        -5,
        0
      ],
      [
        -4,
        -5
      ],
      [
        -6,
        -18
      ],
      [
        -4,
        -5
      ],
      [
        -5,
        -32
      ],
      [
        0,
        -35
      ],
      [
        -6,
        -12
      ],
      [
        -2,
        34
      ],
      [
        -9,
        -39
      ],
      [
        1,
        -20
      ],
      [
        5,
        -17
      ]
    ],
    [
      [
        25409,
        53251
      ],
      [
        -1,
        13
      ],
      [
        3,
        19
      ],
      [
        2,
        4
      ],
      [
        -3,
        23
      ],
      [
        -6,
        7
      ],
      [
        -1,
        10
      ],
      [
        -5,
        1
      ],
      [
        3,
        12
      ],
      [
        6,
        -2
      ],
      [
        -1,
        14
      ],
      [
        3,
        19
      ],
      [
        -5,
        17
      ],
      [
        1,
        6
      ],
      [
        10,
        -4
      ],
      [
        1,
        26
      ],
      [
        3,
        -1
      ],
      [
        1,
        -13
      ],
      [
        5,
        48
      ],
      [
        -1,
        9
      ],
      [
        2,
        24
      ],
      [
        -3,
        -13
      ],
      [
        -6,
        10
      ],
      [
        0,
        -15
      ],
      [
        -7,
        -2
      ],
      [
        4,
        25
      ],
      [
        5,
        -3
      ],
      [
        1,
        14
      ],
      [
        -6,
        2
      ],
      [
        5,
        19
      ],
      [
        -7,
        21
      ],
      [
        6,
        9
      ],
      [
        -1,
        20
      ],
      [
        3,
        28
      ],
      [
        -5,
        15
      ],
      [
        -3,
        20
      ],
      [
        0,
        1
      ],
      [
        -10,
        10
      ],
      [
        -3,
        9
      ],
      [
        -10,
        16
      ],
      [
        -3,
        10
      ],
      [
        -3,
        13
      ],
      [
        5,
        -1
      ],
      [
        -1,
        15
      ],
      [
        -7,
        -1
      ],
      [
        -6,
        13
      ],
      [
        -2,
        13
      ],
      [
        2,
        13
      ],
      [
        -3,
        16
      ],
      [
        -2,
        33
      ],
      [
        3,
        13
      ],
      [
        -2,
        19
      ],
      [
        0,
        15
      ]
    ],
    [
      [
        25446,
        54801
      ],
      [
        24,
        0
      ],
      [
        0,
        -51
      ],
      [
        5,
        0
      ],
      [
        52,
        1
      ]
    ],
    [
      [
        25541,
        54499
      ],
      [
        -11,
        1
      ],
      [
        -3,
        -13
      ],
      [
        0,
        -142
      ],
      [
        -28,
        -1
      ],
      [
        0,
        -147
      ],
      [
        -10,
        -4
      ],
      [
        -2,
        -13
      ]
    ],
    [
      [
        25473,
        55362
      ],
      [
        23,
        -2
      ],
      [
        5,
        0
      ],
      [
        54,
        -2
      ]
    ],
    [
      [
        25555,
        55358
      ],
      [
        0,
        -150
      ]
    ],
    [
      [
        25325,
        56221
      ],
      [
        1,
        43
      ],
      [
        1,
        16
      ],
      [
        0,
        18
      ],
      [
        2,
        42
      ],
      [
        1,
        52
      ],
      [
        1,
        23
      ],
      [
        0,
        2
      ],
      [
        4,
        113
      ],
      [
        1,
        22
      ],
      [
        0,
        34
      ]
    ],
    [
      [
        25336,
        56586
      ],
      [
        62,
        -7
      ],
      [
        0,
        -34
      ],
      [
        10,
        -1
      ],
      [
        0,
        -119
      ]
    ],
    [
      [
        25409,
        55964
      ],
      [
        -91,
        12
      ]
    ],
    [
      [
        25318,
        55976
      ],
      [
        1,
        43
      ],
      [
        0,
        7
      ],
      [
        1,
        9
      ],
      [
        0,
        11
      ],
      [
        1,
        48
      ],
      [
        2,
        54
      ],
      [
        0,
        20
      ],
      [
        1,
        24
      ],
      [
        1,
        29
      ]
    ],
    [
      [
        25309,
        55690
      ],
      [
        1,
        16
      ],
      [
        3,
        113
      ],
      [
        4,
        132
      ],
      [
        0,
        4
      ],
      [
        1,
        21
      ]
    ],
    [
      [
        25439,
        55965
      ],
      [
        0,
        -432
      ]
    ],
    [
      [
        25299,
        55344
      ],
      [
        3,
        95
      ],
      [
        4,
        130
      ],
      [
        0,
        22
      ],
      [
        1,
        20
      ],
      [
        1,
        45
      ],
      [
        1,
        26
      ],
      [
        0,
        8
      ]
    ],
    [
      [
        23289,
        63810
      ],
      [
        1,
        -1
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        28221,
        60497
      ],
      [
        13,
        10
      ],
      [
        3,
        38
      ],
      [
        9,
        29
      ],
      [
        24,
        73
      ],
      [
        6,
        15
      ],
      [
        0,
        5
      ]
    ],
    [
      [
        28383,
        60384
      ],
      [
        -3,
        -2
      ],
      [
        0,
        -7
      ]
    ],
    [
      [
        28366,
        60374
      ],
      [
        -5,
        0
      ],
      [
        -1,
        -34
      ],
      [
        -5,
        -19
      ],
      [
        -1,
        -26
      ]
    ],
    [
      [
        28334,
        60270
      ],
      [
        -15,
        1
      ],
      [
        -5,
        -8
      ],
      [
        -4,
        11
      ],
      [
        -7,
        -1
      ],
      [
        -4,
        13
      ],
      [
        -1,
        1
      ],
      [
        -3,
        10
      ],
      [
        -7,
        29
      ],
      [
        -10,
        -7
      ]
    ],
    [
      [
        23834,
        53231
      ],
      [
        -87,
        -21
      ]
    ],
    [
      [
        25931,
        69065
      ],
      [
        38,
        0
      ],
      [
        34,
        -5
      ]
    ],
    [
      [
        25886,
        68762
      ],
      [
        3,
        36
      ],
      [
        1,
        21
      ],
      [
        -1,
        32
      ],
      [
        -2,
        17
      ],
      [
        -6,
        45
      ],
      [
        -2,
        18
      ],
      [
        1,
        27
      ],
      [
        0,
        6
      ],
      [
        2,
        9
      ],
      [
        5,
        8
      ],
      [
        16,
        17
      ],
      [
        4,
        9
      ],
      [
        11,
        -1
      ],
      [
        4,
        4
      ],
      [
        5,
        12
      ],
      [
        3,
        20
      ],
      [
        1,
        13
      ],
      [
        0,
        10
      ]
    ],
    [
      [
        23553,
        62034
      ],
      [
        0,
        127
      ]
    ],
    [
      [
        23705,
        61835
      ],
      [
        -1,
        -118
      ],
      [
        0,
        -22
      ]
    ],
    [
      [
        25815,
        55474
      ],
      [
        88,
        2
      ]
    ],
    [
      [
        25949,
        55459
      ],
      [
        0,
        -305
      ],
      [
        2,
        -31
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -48
      ]
    ],
    [
      [
        20581,
        64665
      ],
      [
        6,
        0
      ],
      [
        87,
        -1
      ]
    ],
    [
      [
        25786,
        59132
      ],
      [
        5,
        -59
      ],
      [
        1,
        -24
      ],
      [
        5,
        -33
      ],
      [
        -1,
        -12
      ],
      [
        8,
        6
      ],
      [
        -2,
        -37
      ],
      [
        6,
        -10
      ]
    ],
    [
      [
        25808,
        58963
      ],
      [
        -3,
        -50
      ],
      [
        -1,
        20
      ],
      [
        -4,
        14
      ],
      [
        -1,
        -23
      ],
      [
        -5,
        -21
      ],
      [
        1,
        -16
      ],
      [
        -2,
        0
      ],
      [
        -9,
        -27
      ],
      [
        -3,
        -5
      ],
      [
        1,
        -32
      ],
      [
        -3,
        -14
      ]
    ],
    [
      [
        25658,
        58899
      ],
      [
        3,
        -5
      ],
      [
        1,
        62
      ],
      [
        11,
        40
      ],
      [
        4,
        94
      ],
      [
        0,
        19
      ],
      [
        6,
        48
      ],
      [
        4,
        18
      ],
      [
        12,
        98
      ],
      [
        -2,
        19
      ]
    ],
    [
      [
        28170,
        64846
      ],
      [
        5,
        -1
      ],
      [
        4,
        -10
      ],
      [
        2,
        21
      ],
      [
        7,
        12
      ],
      [
        0,
        36
      ],
      [
        4,
        16
      ],
      [
        5,
        -10
      ],
      [
        0,
        16
      ],
      [
        5,
        4
      ],
      [
        7,
        31
      ],
      [
        0,
        -82
      ],
      [
        1,
        -5
      ],
      [
        26,
        4
      ],
      [
        3,
        -5
      ],
      [
        0,
        -41
      ],
      [
        3,
        4
      ],
      [
        5,
        -27
      ],
      [
        5,
        -17
      ],
      [
        7,
        -3
      ],
      [
        3,
        10
      ],
      [
        5,
        -9
      ],
      [
        7,
        3
      ],
      [
        1,
        -9
      ],
      [
        11,
        -11
      ],
      [
        7,
        -16
      ],
      [
        1,
        -8
      ],
      [
        7,
        -6
      ],
      [
        1,
        -9
      ],
      [
        -5,
        -13
      ],
      [
        6,
        -29
      ],
      [
        13,
        -61
      ],
      [
        1,
        -7
      ],
      [
        19,
        13
      ],
      [
        13,
        4
      ],
      [
        15,
        11
      ],
      [
        55,
        66
      ]
    ],
    [
      [
        28269,
        64352
      ],
      [
        -8,
        -17
      ],
      [
        -2,
        14
      ],
      [
        -14,
        -9
      ],
      [
        -16,
        28
      ],
      [
        -25,
        -44
      ],
      [
        -8,
        -16
      ],
      [
        -45,
        52
      ],
      [
        -3,
        3
      ]
    ],
    [
      [
        28080,
        64355
      ],
      [
        -5,
        26
      ],
      [
        10,
        33
      ],
      [
        1,
        19
      ],
      [
        7,
        11
      ],
      [
        4,
        18
      ],
      [
        -1,
        11
      ],
      [
        4,
        19
      ],
      [
        5,
        -3
      ],
      [
        6,
        9
      ],
      [
        0,
        17
      ],
      [
        8,
        23
      ],
      [
        -3,
        13
      ],
      [
        3,
        14
      ],
      [
        11,
        11
      ],
      [
        3,
        17
      ],
      [
        4,
        6
      ],
      [
        -4,
        22
      ],
      [
        9,
        -4
      ],
      [
        5,
        -18
      ],
      [
        3,
        9
      ],
      [
        9,
        11
      ],
      [
        -4,
        25
      ],
      [
        1,
        15
      ],
      [
        7,
        2
      ],
      [
        1,
        10
      ],
      [
        -6,
        32
      ],
      [
        6,
        9
      ],
      [
        -1,
        16
      ],
      [
        -8,
        9
      ],
      [
        -2,
        15
      ],
      [
        -4,
        48
      ],
      [
        12,
        10
      ],
      [
        9,
        36
      ]
    ],
    [
      [
        23125,
        51944
      ],
      [
        1,
        -14
      ],
      [
        7,
        -10
      ],
      [
        2,
        -13
      ],
      [
        -1,
        -14
      ],
      [
        5,
        -1
      ],
      [
        3,
        -24
      ],
      [
        -6,
        -10
      ],
      [
        3,
        -21
      ],
      [
        -3,
        -23
      ],
      [
        -5,
        11
      ],
      [
        1,
        -15
      ],
      [
        4,
        0
      ],
      [
        1,
        -14
      ],
      [
        -5,
        7
      ],
      [
        -3,
        -14
      ],
      [
        5,
        -25
      ],
      [
        -4,
        -20
      ],
      [
        9,
        -26
      ],
      [
        -5,
        -4
      ],
      [
        3,
        -22
      ],
      [
        -4,
        -8
      ],
      [
        -1,
        -12
      ],
      [
        3,
        -17
      ],
      [
        3,
        6
      ],
      [
        -1,
        -21
      ],
      [
        5,
        -5
      ],
      [
        10,
        -2
      ],
      [
        2,
        -13
      ],
      [
        -1,
        -15
      ],
      [
        4,
        -29
      ],
      [
        -3,
        -20
      ],
      [
        2,
        -11
      ]
    ],
    [
      [
        23156,
        51545
      ],
      [
        0,
        -12
      ],
      [
        6,
        3
      ],
      [
        1,
        -20
      ],
      [
        -4,
        3
      ],
      [
        2,
        -14
      ],
      [
        0,
        -15
      ],
      [
        -5,
        9
      ],
      [
        -7,
        -7
      ],
      [
        0,
        -7
      ],
      [
        4,
        -12
      ],
      [
        4,
        11
      ],
      [
        4,
        -13
      ],
      [
        -4,
        -10
      ],
      [
        3,
        -12
      ],
      [
        1,
        -21
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -25
      ],
      [
        -17,
        -2
      ]
    ],
    [
      [
        23141,
        51398
      ],
      [
        -6,
        25
      ],
      [
        -9,
        -4
      ],
      [
        -9,
        17
      ]
    ],
    [
      [
        23117,
        51436
      ],
      [
        -7,
        26
      ],
      [
        -7,
        10
      ],
      [
        -5,
        -8
      ],
      [
        -5,
        13
      ],
      [
        -2,
        21
      ],
      [
        -3,
        15
      ],
      [
        2,
        19
      ],
      [
        -8,
        24
      ],
      [
        1,
        15
      ],
      [
        -4,
        6
      ],
      [
        -2,
        42
      ],
      [
        -4,
        13
      ],
      [
        0,
        14
      ],
      [
        -3,
        18
      ],
      [
        -4,
        -13
      ],
      [
        -6,
        8
      ],
      [
        -3,
        -5
      ],
      [
        -7,
        4
      ],
      [
        -6,
        27
      ],
      [
        -4,
        10
      ],
      [
        -3,
        -2
      ],
      [
        -5,
        17
      ],
      [
        -2,
        -2
      ],
      [
        -14,
        46
      ],
      [
        -9,
        63
      ]
    ],
    [
      [
        29478,
        69336
      ],
      [
        26,
        1
      ],
      [
        2,
        1
      ],
      [
        14,
        1
      ]
    ],
    [
      [
        29510,
        69000
      ],
      [
        -2,
        -85
      ],
      [
        -5,
        -10
      ],
      [
        -1,
        -38
      ],
      [
        -1,
        -9
      ],
      [
        -2,
        -11
      ],
      [
        -8,
        -15
      ],
      [
        -18,
        -17
      ]
    ],
    [
      [
        29473,
        68815
      ],
      [
        -2,
        5
      ],
      [
        -2,
        9
      ],
      [
        0,
        7
      ],
      [
        -1,
        4
      ],
      [
        -1,
        5
      ],
      [
        0,
        1
      ],
      [
        1,
        4
      ],
      [
        0,
        7
      ],
      [
        -1,
        6
      ],
      [
        0,
        9
      ],
      [
        -2,
        5
      ],
      [
        0,
        8
      ],
      [
        1,
        4
      ],
      [
        0,
        4
      ],
      [
        -1,
        6
      ],
      [
        1,
        1
      ],
      [
        2,
        4
      ],
      [
        0,
        2
      ],
      [
        -1,
        5
      ],
      [
        1,
        8
      ],
      [
        0,
        4
      ],
      [
        1,
        7
      ],
      [
        1,
        0
      ],
      [
        0,
        4
      ],
      [
        -1,
        3
      ],
      [
        1,
        10
      ],
      [
        0,
        1
      ],
      [
        1,
        1
      ],
      [
        0,
        3
      ],
      [
        -1,
        3
      ],
      [
        0,
        1
      ],
      [
        2,
        3
      ],
      [
        1,
        8
      ],
      [
        0,
        1
      ],
      [
        -2,
        6
      ],
      [
        1,
        30
      ],
      [
        -1,
        18
      ],
      [
        1,
        4
      ],
      [
        2,
        7
      ],
      [
        1,
        5
      ],
      [
        1,
        15
      ],
      [
        1,
        6
      ],
      [
        0,
        4
      ],
      [
        3,
        6
      ],
      [
        0,
        4
      ],
      [
        1,
        4
      ],
      [
        -1,
        12
      ],
      [
        0,
        6
      ],
      [
        -4,
        14
      ],
      [
        -1,
        5
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -3,
        4
      ],
      [
        -1,
        3
      ],
      [
        0,
        2
      ],
      [
        -1,
        6
      ],
      [
        -1,
        2
      ],
      [
        -1,
        9
      ],
      [
        0,
        14
      ],
      [
        2,
        4
      ],
      [
        1,
        2
      ],
      [
        0,
        5
      ],
      [
        1,
        9
      ],
      [
        1,
        20
      ],
      [
        1,
        6
      ],
      [
        1,
        5
      ],
      [
        0,
        4
      ],
      [
        1,
        3
      ],
      [
        1,
        5
      ],
      [
        2,
        3
      ],
      [
        0,
        1
      ],
      [
        1,
        3
      ],
      [
        0,
        56
      ],
      [
        -2,
        6
      ],
      [
        -1,
        6
      ],
      [
        -1,
        5
      ],
      [
        0,
        11
      ],
      [
        1,
        5
      ],
      [
        2,
        20
      ]
    ],
    [
      [
        28603,
        59928
      ],
      [
        0,
        -38
      ],
      [
        1,
        -6
      ],
      [
        3,
        -10
      ],
      [
        4,
        1
      ],
      [
        0,
        11
      ],
      [
        2,
        12
      ],
      [
        1,
        3
      ],
      [
        3,
        -2
      ],
      [
        3,
        -2
      ],
      [
        4,
        -6
      ]
    ],
    [
      [
        28620,
        59855
      ],
      [
        -5,
        -24
      ],
      [
        0,
        -5
      ],
      [
        -5,
        -29
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -52
      ],
      [
        -1,
        -28
      ],
      [
        -4,
        -137
      ],
      [
        -2,
        -91
      ]
    ],
    [
      [
        28601,
        59487
      ],
      [
        -14,
        0
      ]
    ],
    [
      [
        28482,
        59489
      ],
      [
        -4,
        9
      ],
      [
        6,
        23
      ],
      [
        0,
        46
      ],
      [
        5,
        9
      ],
      [
        -2,
        20
      ]
    ],
    [
      [
        20922,
        61783
      ],
      [
        122,
        0
      ],
      [
        31,
        -7
      ]
    ],
    [
      [
        21075,
        61776
      ],
      [
        -1,
        -203
      ],
      [
        1,
        -90
      ]
    ],
    [
      [
        20436,
        61483
      ],
      [
        201,
        -8
      ],
      [
        7,
        0
      ]
    ],
    [
      [
        20644,
        61076
      ],
      [
        -4,
        2
      ],
      [
        0,
        32
      ],
      [
        -6,
        13
      ],
      [
        -6,
        -14
      ],
      [
        -5,
        9
      ],
      [
        -4,
        39
      ],
      [
        -4,
        8
      ],
      [
        2,
        16
      ],
      [
        -6,
        16
      ],
      [
        -7,
        -14
      ],
      [
        -1,
        -17
      ],
      [
        -5,
        -14
      ],
      [
        0,
        -12
      ],
      [
        -7,
        -9
      ],
      [
        -2,
        -12
      ],
      [
        -7,
        -52
      ],
      [
        -3,
        -9
      ],
      [
        -4,
        11
      ],
      [
        -2,
        27
      ],
      [
        -3,
        7
      ],
      [
        -9,
        -16
      ],
      [
        -8,
        -10
      ],
      [
        -10,
        -30
      ],
      [
        -8,
        8
      ],
      [
        -9,
        -2
      ]
    ],
    [
      [
        24632,
        60326
      ],
      [
        0,
        -122
      ],
      [
        -6,
        1
      ],
      [
        0,
        -34
      ],
      [
        -6,
        0
      ],
      [
        0,
        -102
      ]
    ],
    [
      [
        21212,
        53458
      ],
      [
        -101,
        -447
      ],
      [
        -59,
        -257
      ]
    ],
    [
      [
        20908,
        53149
      ],
      [
        0,
        17
      ],
      [
        1,
        6
      ],
      [
        0,
        9
      ],
      [
        6,
        304
      ],
      [
        15,
        705
      ]
    ],
    [
      [
        20921,
        62186
      ],
      [
        1,
        -403
      ]
    ],
    [
      [
        20674,
        61779
      ],
      [
        0,
        152
      ]
    ],
    [
      [
        27109,
        62863
      ],
      [
        5,
        -2
      ],
      [
        1,
        53
      ],
      [
        17,
        -7
      ],
      [
        15,
        -9
      ],
      [
        0,
        10
      ],
      [
        1,
        49
      ],
      [
        -5,
        0
      ],
      [
        2,
        61
      ],
      [
        8,
        8
      ],
      [
        28,
        -4
      ]
    ],
    [
      [
        27181,
        63022
      ],
      [
        32,
        -4
      ],
      [
        0,
        73
      ],
      [
        6,
        -1
      ],
      [
        -1,
        -17
      ],
      [
        11,
        0
      ],
      [
        0,
        -18
      ],
      [
        5,
        0
      ],
      [
        0,
        -16
      ],
      [
        11,
        -1
      ],
      [
        0,
        -9
      ],
      [
        20,
        -1
      ],
      [
        1,
        16
      ]
    ],
    [
      [
        27266,
        63044
      ],
      [
        5,
        -1
      ],
      [
        0,
        -33
      ],
      [
        5,
        3
      ],
      [
        58,
        -8
      ],
      [
        0,
        -38
      ]
    ],
    [
      [
        27311,
        62871
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -4,
        -1
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        -5
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -8
      ],
      [
        -2,
        -10
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -17
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -5,
        5
      ],
      [
        -2,
        0
      ],
      [
        -3,
        -4
      ],
      [
        -3,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -5
      ],
      [
        -4,
        -6
      ],
      [
        -2,
        -4
      ],
      [
        -5,
        -11
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        -7
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        -3
      ],
      [
        -4,
        -1
      ]
    ],
    [
      [
        27142,
        62590
      ],
      [
        1,
        62
      ],
      [
        -27,
        4
      ],
      [
        1,
        34
      ],
      [
        -5,
        1
      ],
      [
        0,
        17
      ],
      [
        -5,
        1
      ],
      [
        2,
        154
      ]
    ],
    [
      [
        27602,
        60502
      ],
      [
        -20,
        -46
      ],
      [
        -15,
        -5
      ],
      [
        -13,
        -29
      ],
      [
        -4,
        -14
      ]
    ],
    [
      [
        27491,
        60504
      ],
      [
        3,
        2
      ],
      [
        2,
        8
      ],
      [
        1,
        2
      ],
      [
        3,
        4
      ],
      [
        4,
        14
      ],
      [
        7,
        12
      ],
      [
        1,
        3
      ],
      [
        4,
        9
      ],
      [
        2,
        1
      ],
      [
        1,
        3
      ],
      [
        1,
        3
      ],
      [
        2,
        4
      ],
      [
        -1,
        6
      ],
      [
        6,
        8
      ],
      [
        4,
        2
      ],
      [
        1,
        2
      ],
      [
        2,
        4
      ],
      [
        1,
        3
      ],
      [
        2,
        2
      ],
      [
        0,
        1
      ],
      [
        3,
        5
      ],
      [
        4,
        29
      ],
      [
        -2,
        4
      ],
      [
        -5,
        -11
      ],
      [
        -6,
        11
      ],
      [
        1,
        4
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        1,
        2
      ],
      [
        -4,
        21
      ],
      [
        9,
        17
      ],
      [
        3,
        8
      ],
      [
        4,
        7
      ],
      [
        2,
        2
      ],
      [
        1,
        3
      ],
      [
        2,
        7
      ],
      [
        3,
        6
      ],
      [
        4,
        15
      ],
      [
        1,
        4
      ],
      [
        1,
        5
      ]
    ],
    [
      [
        25631,
        56510
      ],
      [
        4,
        -32
      ],
      [
        7,
        -7
      ],
      [
        2,
        -28
      ],
      [
        5,
        -19
      ],
      [
        1,
        -15
      ],
      [
        -5,
        -9
      ],
      [
        2,
        -10
      ],
      [
        24,
        -1
      ],
      [
        0,
        -27
      ],
      [
        4,
        -6
      ],
      [
        8,
        -3
      ]
    ],
    [
      [
        25683,
        56353
      ],
      [
        3,
        -15
      ],
      [
        0,
        -35
      ]
    ],
    [
      [
        25598,
        55951
      ],
      [
        -14,
        2
      ],
      [
        0,
        85
      ],
      [
        -15,
        0
      ],
      [
        0,
        17
      ],
      [
        -14,
        0
      ]
    ],
    [
      [
        25496,
        56420
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        28084,
        62881
      ],
      [
        16,
        -43
      ],
      [
        7,
        -17
      ],
      [
        10,
        -27
      ]
    ],
    [
      [
        28117,
        62794
      ],
      [
        6,
        -19
      ],
      [
        5,
        -13
      ],
      [
        8,
        -24
      ],
      [
        5,
        -11
      ],
      [
        9,
        -25
      ],
      [
        8,
        -20
      ],
      [
        0,
        -1
      ],
      [
        13,
        -34
      ]
    ],
    [
      [
        28029,
        62404
      ],
      [
        1,
        5
      ],
      [
        2,
        7
      ],
      [
        2,
        2
      ],
      [
        1,
        3
      ],
      [
        1,
        8
      ],
      [
        1,
        3
      ],
      [
        -1,
        2
      ],
      [
        2,
        3
      ],
      [
        1,
        5
      ]
    ],
    [
      [
        19587,
        70034
      ],
      [
        -5,
        3
      ],
      [
        -8,
        -13
      ],
      [
        -12,
        1
      ],
      [
        -11,
        16
      ],
      [
        -16,
        -18
      ],
      [
        -3,
        -12
      ],
      [
        -8,
        -9
      ],
      [
        -16,
        5
      ],
      [
        0,
        -75
      ],
      [
        -18,
        0
      ],
      [
        0,
        -68
      ],
      [
        -46,
        -1
      ],
      [
        0,
        -16
      ],
      [
        -17,
        -1
      ],
      [
        0,
        -16
      ],
      [
        -6,
        0
      ],
      [
        0,
        -17
      ],
      [
        -11,
        0
      ],
      [
        0,
        -17
      ],
      [
        -6,
        0
      ],
      [
        0,
        -17
      ],
      [
        -6,
        0
      ],
      [
        0,
        -17
      ],
      [
        -5,
        0
      ],
      [
        0,
        -17
      ],
      [
        -6,
        0
      ],
      [
        -2,
        -33
      ],
      [
        -5,
        0
      ],
      [
        0,
        -34
      ],
      [
        -6,
        0
      ],
      [
        0,
        -51
      ],
      [
        -22,
        0
      ],
      [
        0,
        -109
      ],
      [
        -31,
        0
      ]
    ],
    [
      [
        19321,
        69518
      ],
      [
        0,
        5
      ],
      [
        -74,
        0
      ]
    ],
    [
      [
        19247,
        69523
      ],
      [
        0,
        206
      ],
      [
        37,
        0
      ],
      [
        0,
        202
      ],
      [
        34,
        0
      ],
      [
        0,
        51
      ],
      [
        35,
        -1
      ],
      [
        0,
        51
      ],
      [
        34,
        0
      ],
      [
        -1,
        203
      ],
      [
        5,
        0
      ],
      [
        0,
        102
      ],
      [
        12,
        -1
      ],
      [
        -1,
        103
      ],
      [
        24,
        1
      ],
      [
        0,
        85
      ],
      [
        1,
        14
      ]
    ],
    [
      [
        24765,
        53027
      ],
      [
        64,
        0
      ],
      [
        2,
        1
      ],
      [
        52,
        0
      ]
    ],
    [
      [
        24913,
        53029
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -5
      ],
      [
        1,
        -1
      ],
      [
        1,
        0
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -13
      ],
      [
        0,
        -4
      ],
      [
        -2,
        -2
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        2,
        -4
      ],
      [
        0,
        -5
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -10
      ],
      [
        0,
        -4
      ],
      [
        2,
        -5
      ],
      [
        0,
        -14
      ],
      [
        1,
        -1
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        0
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -9
      ],
      [
        1,
        0
      ],
      [
        1,
        -6
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -2,
        1
      ],
      [
        -1,
        3
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        1,
        -8
      ],
      [
        0,
        -9
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -9
      ],
      [
        3,
        -8
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -11
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        1,
        -4
      ],
      [
        0,
        -4
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -8
      ],
      [
        1,
        0
      ],
      [
        1,
        -4
      ],
      [
        1,
        -8
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        5
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -13
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -7
      ],
      [
        1,
        -1
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        1
      ],
      [
        0,
        6
      ],
      [
        -1,
        3
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -10
      ],
      [
        -2,
        -14
      ],
      [
        1,
        -11
      ],
      [
        1,
        -13
      ],
      [
        -1,
        -6
      ],
      [
        1,
        -1
      ],
      [
        1,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -2,
        1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -7
      ],
      [
        1,
        -2
      ],
      [
        1,
        0
      ],
      [
        1,
        -2
      ],
      [
        -1,
        -10
      ],
      [
        0,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -3,
        -11
      ],
      [
        0,
        -3
      ],
      [
        1,
        -2
      ],
      [
        1,
        2
      ],
      [
        1,
        -6
      ],
      [
        0,
        -9
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -19
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -5
      ]
    ],
    [
      [
        24879,
        52637
      ],
      [
        -39,
        0
      ],
      [
        -3,
        1
      ],
      [
        -71,
        53
      ]
    ],
    [
      [
        25947,
        58801
      ],
      [
        -19,
        5
      ],
      [
        -10,
        -7
      ],
      [
        -10,
        4
      ],
      [
        1,
        -10
      ]
    ],
    [
      [
        25909,
        58793
      ],
      [
        -2,
        11
      ],
      [
        -26,
        -3
      ],
      [
        -16,
        23
      ],
      [
        0,
        6
      ],
      [
        -4,
        -1
      ],
      [
        -11,
        29
      ],
      [
        -7,
        20
      ],
      [
        2,
        9
      ],
      [
        -4,
        -5
      ],
      [
        -10,
        23
      ],
      [
        -1,
        -1
      ],
      [
        -22,
        59
      ]
    ],
    [
      [
        17466,
        71219
      ],
      [
        35,
        -1
      ],
      [
        0,
        357
      ]
    ],
    [
      [
        17962,
        71345
      ],
      [
        8,
        -5
      ],
      [
        4,
        -20
      ],
      [
        2,
        -3
      ],
      [
        1,
        -7
      ],
      [
        0,
        -18
      ],
      [
        -3,
        -9
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -7
      ],
      [
        2,
        -16
      ],
      [
        4,
        -2
      ],
      [
        2,
        -3
      ],
      [
        1,
        -9
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -4
      ],
      [
        6,
        -8
      ]
    ],
    [
      [
        24732,
        50824
      ],
      [
        5,
        20
      ],
      [
        2,
        7
      ],
      [
        2,
        -4
      ],
      [
        11,
        -61
      ],
      [
        -3,
        -10
      ],
      [
        -5,
        -4
      ],
      [
        -8,
        46
      ],
      [
        -4,
        6
      ]
    ],
    [
      [
        24726,
        51002
      ],
      [
        4,
        1
      ],
      [
        1,
        -7
      ]
    ],
    [
      [
        24731,
        50996
      ],
      [
        -6,
        -26
      ],
      [
        1,
        32
      ]
    ],
    [
      [
        24590,
        51752
      ],
      [
        28,
        2
      ],
      [
        0,
        17
      ],
      [
        2,
        0
      ],
      [
        9,
        -12
      ],
      [
        5,
        -1
      ],
      [
        3,
        -16
      ],
      [
        8,
        9
      ],
      [
        2,
        -14
      ],
      [
        7,
        -4
      ]
    ],
    [
      [
        24654,
        51733
      ],
      [
        1,
        3
      ],
      [
        7,
        4
      ],
      [
        5,
        -14
      ],
      [
        5,
        11
      ],
      [
        16,
        -1
      ],
      [
        1,
        -8
      ]
    ],
    [
      [
        24812,
        50889
      ],
      [
        -9,
        -23
      ],
      [
        -14,
        -34
      ],
      [
        -14,
        -35
      ],
      [
        -3,
        3
      ],
      [
        -4,
        7
      ],
      [
        -1,
        17
      ],
      [
        5,
        3
      ],
      [
        0,
        21
      ],
      [
        -4,
        11
      ],
      [
        -8,
        5
      ],
      [
        -2,
        41
      ],
      [
        6,
        3
      ],
      [
        1,
        22
      ],
      [
        -4,
        0
      ],
      [
        -9,
        78
      ],
      [
        -5,
        8
      ],
      [
        -6,
        19
      ],
      [
        -1,
        17
      ],
      [
        -2,
        -5
      ],
      [
        -6,
        -13
      ],
      [
        0,
        -6
      ]
    ],
    [
      [
        24732,
        51028
      ],
      [
        -2,
        -2
      ],
      [
        2,
        25
      ],
      [
        -3,
        25
      ],
      [
        2,
        28
      ],
      [
        -1,
        20
      ],
      [
        -5,
        21
      ],
      [
        -5,
        7
      ],
      [
        -10,
        46
      ],
      [
        -3,
        26
      ],
      [
        -11,
        30
      ],
      [
        -12,
        62
      ],
      [
        -5,
        5
      ],
      [
        -2,
        28
      ],
      [
        -8,
        16
      ],
      [
        -5,
        29
      ],
      [
        -10,
        11
      ],
      [
        -9,
        44
      ],
      [
        -4,
        18
      ],
      [
        -1,
        5
      ],
      [
        -6,
        12
      ],
      [
        -3,
        0
      ],
      [
        -8,
        24
      ],
      [
        -3,
        28
      ],
      [
        -3,
        32
      ],
      [
        -4,
        2
      ],
      [
        -2,
        31
      ],
      [
        -5,
        0
      ],
      [
        0,
        -13
      ],
      [
        -4,
        -10
      ],
      [
        1,
        -11
      ],
      [
        -12,
        -1
      ],
      [
        1,
        -34
      ],
      [
        -35,
        -2
      ]
    ],
    [
      [
        26305,
        70240
      ],
      [
        0,
        -580
      ]
    ],
    [
      [
        26203,
        69750
      ],
      [
        12,
        -3
      ],
      [
        3,
        -3
      ],
      [
        3,
        -1
      ],
      [
        3,
        7
      ],
      [
        17,
        11
      ],
      [
        12,
        20
      ],
      [
        1,
        11
      ],
      [
        0,
        8
      ],
      [
        -1,
        9
      ],
      [
        -1,
        5
      ],
      [
        -17,
        9
      ],
      [
        -2,
        -2
      ],
      [
        0,
        -3
      ],
      [
        -2,
        -2
      ],
      [
        -12,
        15
      ],
      [
        -8,
        27
      ],
      [
        -6,
        20
      ],
      [
        -5,
        52
      ],
      [
        -2,
        21
      ],
      [
        -1,
        34
      ],
      [
        0,
        7
      ],
      [
        2,
        13
      ],
      [
        5,
        17
      ],
      [
        4,
        19
      ],
      [
        1,
        8
      ],
      [
        0,
        6
      ],
      [
        4,
        12
      ],
      [
        13,
        14
      ],
      [
        2,
        6
      ],
      [
        2,
        6
      ],
      [
        1,
        10
      ],
      [
        7,
        19
      ],
      [
        8,
        28
      ],
      [
        1,
        13
      ],
      [
        -1,
        8
      ],
      [
        -2,
        10
      ],
      [
        -9,
        17
      ],
      [
        -6,
        3
      ],
      [
        -2,
        4
      ],
      [
        -1,
        3
      ],
      [
        2,
        3
      ],
      [
        3,
        -4
      ],
      [
        16,
        1
      ],
      [
        4,
        -4
      ],
      [
        4,
        -8
      ],
      [
        12,
        2
      ],
      [
        7,
        -8
      ],
      [
        10,
        2
      ],
      [
        2,
        1
      ],
      [
        3,
        6
      ],
      [
        2,
        10
      ],
      [
        0,
        10
      ],
      [
        -3,
        10
      ],
      [
        0,
        2
      ],
      [
        3,
        8
      ],
      [
        2,
        3
      ],
      [
        6,
        -8
      ],
      [
        3,
        2
      ],
      [
        2,
        4
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        28167,
        59480
      ],
      [
        41,
        0
      ]
    ],
    [
      [
        28208,
        59480
      ],
      [
        0,
        -47
      ]
    ],
    [
      [
        90472,
        34420
      ],
      [
        4,
        45
      ],
      [
        8,
        34
      ],
      [
        5,
        20
      ],
      [
        4,
        -20
      ],
      [
        1,
        -34
      ],
      [
        -4,
        -24
      ],
      [
        6,
        -21
      ],
      [
        1,
        -19
      ],
      [
        -2,
        -32
      ],
      [
        0,
        -29
      ],
      [
        -6,
        -24
      ],
      [
        -3,
        -5
      ],
      [
        -1,
        21
      ],
      [
        -5,
        33
      ],
      [
        -4,
        25
      ],
      [
        -4,
        3
      ],
      [
        0,
        27
      ]
    ],
    [
      [
        90461,
        34237
      ],
      [
        8,
        9
      ],
      [
        2,
        -8
      ],
      [
        -1,
        -13
      ],
      [
        -4,
        -6
      ],
      [
        -5,
        -4
      ],
      [
        -3,
        6
      ],
      [
        3,
        16
      ]
    ],
    [
      [
        31310,
        38457
      ],
      [
        5,
        -9
      ],
      [
        2,
        -2
      ],
      [
        2,
        -2
      ],
      [
        7,
        -1
      ],
      [
        2,
        4
      ],
      [
        2,
        2
      ],
      [
        3,
        5
      ],
      [
        1,
        4
      ],
      [
        4,
        3
      ],
      [
        6,
        1
      ],
      [
        6,
        7
      ],
      [
        10,
        -11
      ]
    ],
    [
      [
        31360,
        38458
      ],
      [
        2,
        -20
      ],
      [
        -2,
        -35
      ],
      [
        1,
        0
      ],
      [
        -3,
        -45
      ],
      [
        2,
        -11
      ]
    ],
    [
      [
        31309,
        38272
      ],
      [
        1,
        119
      ],
      [
        -1,
        7
      ],
      [
        1,
        52
      ],
      [
        0,
        7
      ]
    ],
    [
      [
        26735,
        65865
      ],
      [
        2,
        -12
      ],
      [
        -2,
        -13
      ],
      [
        -1,
        -2
      ],
      [
        -5,
        -1
      ],
      [
        0,
        -11
      ],
      [
        -2,
        -9
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -2
      ],
      [
        -6,
        -17
      ],
      [
        -2,
        -15
      ],
      [
        0,
        -11
      ],
      [
        -4,
        -13
      ],
      [
        -5,
        6
      ],
      [
        -2,
        0
      ],
      [
        -2,
        -2
      ],
      [
        -4,
        -8
      ],
      [
        -3,
        -13
      ],
      [
        -2,
        -20
      ],
      [
        0,
        -21
      ],
      [
        -2,
        -11
      ],
      [
        -2,
        -5
      ],
      [
        -3,
        -9
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        10
      ],
      [
        -1,
        1
      ],
      [
        -2,
        -5
      ],
      [
        -4,
        -20
      ],
      [
        -4,
        -27
      ],
      [
        -3,
        -9
      ],
      [
        -4,
        -4
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -23
      ],
      [
        1,
        -22
      ],
      [
        3,
        -23
      ],
      [
        1,
        -11
      ],
      [
        -3,
        -4
      ],
      [
        -5,
        -3
      ],
      [
        0,
        -2
      ]
    ],
    [
      [
        18252,
        72350
      ],
      [
        -87,
        0
      ],
      [
        5,
        -2
      ],
      [
        -1,
        -25
      ],
      [
        4,
        -32
      ],
      [
        -3,
        -12
      ],
      [
        1,
        -22
      ],
      [
        5,
        -7
      ],
      [
        -2,
        -16
      ],
      [
        -6,
        -3
      ],
      [
        -4,
        -26
      ],
      [
        6,
        -12
      ],
      [
        -1,
        -9
      ],
      [
        8,
        -12
      ],
      [
        4,
        -18
      ],
      [
        0,
        -18
      ],
      [
        5,
        -29
      ],
      [
        -1,
        -25
      ],
      [
        -4,
        -18
      ],
      [
        2,
        -19
      ],
      [
        -1,
        -24
      ],
      [
        -4,
        -8
      ],
      [
        5,
        -3
      ],
      [
        3,
        -23
      ],
      [
        5,
        -4
      ],
      [
        3,
        -15
      ],
      [
        5,
        3
      ],
      [
        0,
        -7
      ],
      [
        1,
        -101
      ],
      [
        -31,
        0
      ],
      [
        0,
        -51
      ],
      [
        -71,
        0
      ]
    ],
    [
      [
        18299,
        72350
      ],
      [
        0,
        -490
      ],
      [
        46,
        0
      ],
      [
        0,
        -404
      ]
    ],
    [
      [
        18345,
        71456
      ],
      [
        -32,
        0
      ],
      [
        0,
        -35
      ],
      [
        -18,
        0
      ],
      [
        0,
        -67
      ],
      [
        -18,
        0
      ],
      [
        -2,
        -20
      ],
      [
        0,
        -13
      ],
      [
        -32,
        0
      ],
      [
        0,
        -68
      ],
      [
        -35,
        0
      ],
      [
        -10,
        3
      ]
    ],
    [
      [
        20547,
        63208
      ],
      [
        -7,
        -1
      ],
      [
        0,
        10
      ],
      [
        -21,
        4
      ],
      [
        -13,
        18
      ],
      [
        0,
        16
      ],
      [
        -9,
        21
      ],
      [
        0,
        20
      ],
      [
        -7,
        -5
      ],
      [
        -7,
        16
      ],
      [
        -1,
        13
      ],
      [
        -8,
        9
      ],
      [
        -8,
        1
      ]
    ],
    [
      [
        26948,
        61005
      ],
      [
        8,
        -14
      ],
      [
        -3,
        24
      ],
      [
        28,
        94
      ]
    ],
    [
      [
        26981,
        61109
      ],
      [
        32,
        36
      ]
    ],
    [
      [
        27121,
        60779
      ],
      [
        2,
        -33
      ],
      [
        -2,
        -19
      ],
      [
        -7,
        -20
      ],
      [
        -2,
        -34
      ],
      [
        -6,
        -9
      ],
      [
        0,
        -15
      ]
    ],
    [
      [
        28174,
        63060
      ],
      [
        -10,
        -25
      ],
      [
        -6,
        2
      ],
      [
        -4,
        -21
      ],
      [
        -8,
        14
      ],
      [
        -4,
        0
      ],
      [
        -5,
        -35
      ],
      [
        -5,
        -50
      ],
      [
        -7,
        -88
      ],
      [
        -8,
        -59
      ],
      [
        0,
        -4
      ]
    ],
    [
      [
        25402,
        53215
      ],
      [
        -5,
        13
      ],
      [
        -6,
        -21
      ],
      [
        -3,
        -11
      ],
      [
        -1,
        -2
      ],
      [
        -48,
        0
      ],
      [
        -23,
        -1
      ],
      [
        -14,
        0
      ],
      [
        0,
        -34
      ],
      [
        -28,
        0
      ]
    ],
    [
      [
        25274,
        53159
      ],
      [
        -2,
        135
      ],
      [
        0,
        44
      ],
      [
        -2,
        102
      ],
      [
        -1,
        76
      ],
      [
        0,
        17
      ]
    ],
    [
      [
        25108,
        63100
      ],
      [
        60,
        -1
      ]
    ],
    [
      [
        25168,
        63099
      ],
      [
        1,
        -85
      ],
      [
        25,
        -1
      ],
      [
        0,
        -68
      ],
      [
        22,
        0
      ],
      [
        -1,
        -17
      ],
      [
        6,
        0
      ],
      [
        0,
        -17
      ],
      [
        5,
        0
      ],
      [
        0,
        -17
      ],
      [
        5,
        0
      ],
      [
        0,
        -34
      ],
      [
        32,
        -1
      ]
    ],
    [
      [
        25263,
        62859
      ],
      [
        0,
        -84
      ]
    ],
    [
      [
        25525,
        63675
      ],
      [
        11,
        0
      ],
      [
        0,
        -24
      ],
      [
        24,
        0
      ]
    ],
    [
      [
        25524,
        63366
      ],
      [
        0,
        122
      ],
      [
        1,
        12
      ],
      [
        0,
        175
      ]
    ],
    [
      [
        29093,
        63678
      ],
      [
        5,
        13
      ],
      [
        -1,
        23
      ],
      [
        10,
        -9
      ],
      [
        -1,
        -8
      ],
      [
        4,
        -2
      ],
      [
        11,
        -26
      ],
      [
        6,
        -7
      ],
      [
        4,
        2
      ]
    ],
    [
      [
        29131,
        63664
      ],
      [
        10,
        -69
      ]
    ],
    [
      [
        29090,
        63188
      ],
      [
        -10,
        24
      ],
      [
        -6,
        24
      ],
      [
        -8,
        20
      ],
      [
        -6,
        2
      ],
      [
        -9,
        -10
      ],
      [
        -8,
        11
      ],
      [
        -8,
        111
      ],
      [
        -7,
        33
      ],
      [
        -2,
        7
      ],
      [
        -5,
        8
      ],
      [
        -1,
        4
      ],
      [
        3,
        9
      ],
      [
        -8,
        3
      ],
      [
        -3,
        7
      ],
      [
        0,
        11
      ],
      [
        -1,
        3
      ],
      [
        0,
        10
      ],
      [
        2,
        14
      ],
      [
        -5,
        16
      ],
      [
        -2,
        3
      ],
      [
        -7,
        -5
      ]
    ],
    [
      [
        28999,
        63493
      ],
      [
        1,
        1
      ],
      [
        2,
        14
      ],
      [
        1,
        5
      ],
      [
        2,
        5
      ],
      [
        3,
        3
      ],
      [
        4,
        4
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        5,
        16
      ],
      [
        2,
        6
      ],
      [
        2,
        7
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        24258,
        67981
      ],
      [
        97,
        0
      ]
    ],
    [
      [
        22776,
        55344
      ],
      [
        12,
        -1
      ],
      [
        7,
        0
      ],
      [
        26,
        -1
      ],
      [
        19,
        0
      ],
      [
        11,
        1
      ],
      [
        1,
        -1
      ],
      [
        26,
        0
      ]
    ],
    [
      [
        22878,
        55342
      ],
      [
        0,
        -129
      ],
      [
        -1,
        -30
      ],
      [
        0,
        -206
      ],
      [
        -1,
        -35
      ],
      [
        0,
        -113
      ]
    ],
    [
      [
        22863,
        54830
      ],
      [
        -64,
        3
      ],
      [
        -9,
        1
      ],
      [
        -11,
        0
      ],
      [
        -12,
        1
      ],
      [
        -34,
        2
      ]
    ],
    [
      [
        22733,
        54837
      ],
      [
        1,
        257
      ],
      [
        1,
        253
      ]
    ],
    [
      [
        25339,
        66010
      ],
      [
        59,
        0
      ],
      [
        11,
        -1
      ],
      [
        28,
        0
      ],
      [
        7,
        -1
      ],
      [
        17,
        0
      ]
    ],
    [
      [
        25461,
        66008
      ],
      [
        3,
        -15
      ],
      [
        2,
        -13
      ],
      [
        5,
        -24
      ],
      [
        4,
        -14
      ],
      [
        8,
        -23
      ],
      [
        3,
        -20
      ],
      [
        0,
        -34
      ],
      [
        1,
        -7
      ],
      [
        5,
        -54
      ],
      [
        2,
        -20
      ],
      [
        1,
        -5
      ],
      [
        1,
        -12
      ],
      [
        1,
        -14
      ],
      [
        1,
        -15
      ],
      [
        0,
        -3
      ],
      [
        1,
        -9
      ],
      [
        0,
        -9
      ],
      [
        1,
        -1
      ],
      [
        1,
        -4
      ],
      [
        1,
        -5
      ],
      [
        0,
        -11
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -16
      ],
      [
        2,
        -27
      ],
      [
        3,
        -22
      ],
      [
        2,
        -11
      ],
      [
        0,
        -2
      ],
      [
        1,
        -5
      ],
      [
        2,
        -8
      ],
      [
        0,
        -2
      ],
      [
        1,
        -19
      ],
      [
        5,
        -24
      ],
      [
        5,
        -16
      ],
      [
        3,
        -4
      ],
      [
        2,
        -29
      ],
      [
        0,
        -18
      ]
    ],
    [
      [
        25526,
        65214
      ],
      [
        -73,
        0
      ],
      [
        0,
        67
      ],
      [
        -1,
        19
      ],
      [
        0,
        17
      ],
      [
        -5,
        0
      ],
      [
        -28,
        -2
      ],
      [
        0,
        101
      ],
      [
        -32,
        -3
      ],
      [
        -1,
        34
      ],
      [
        0,
        18
      ]
    ],
    [
      [
        25386,
        65465
      ],
      [
        7,
        0
      ],
      [
        6,
        1
      ],
      [
        1,
        1
      ],
      [
        3,
        -1
      ],
      [
        4,
        8
      ],
      [
        1,
        2
      ],
      [
        2,
        5
      ],
      [
        1,
        4
      ],
      [
        5,
        16
      ],
      [
        2,
        0
      ],
      [
        0,
        64
      ],
      [
        -1,
        10
      ],
      [
        0,
        45
      ],
      [
        -1,
        50
      ],
      [
        0,
        154
      ],
      [
        -5,
        -1
      ],
      [
        -9,
        0
      ],
      [
        -14,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -11,
        -2
      ],
      [
        -17,
        -2
      ],
      [
        -8,
        -1
      ],
      [
        -4,
        -1
      ],
      [
        -12,
        0
      ],
      [
        -10,
        -1
      ],
      [
        -3,
        0
      ]
    ],
    [
      [
        90597,
        35570
      ],
      [
        6,
        34
      ],
      [
        4,
        9
      ],
      [
        4,
        -16
      ],
      [
        -8,
        -45
      ],
      [
        -5,
        0
      ],
      [
        -1,
        18
      ]
    ],
    [
      [
        90541,
        37097
      ],
      [
        2,
        6
      ],
      [
        3,
        -2
      ],
      [
        2,
        -12
      ],
      [
        -3,
        -15
      ],
      [
        -4,
        12
      ],
      [
        0,
        11
      ]
    ],
    [
      [
        90537,
        37432
      ],
      [
        2,
        17
      ],
      [
        3,
        3
      ],
      [
        4,
        -14
      ],
      [
        1,
        -18
      ],
      [
        -4,
        -17
      ],
      [
        -3,
        1
      ],
      [
        -3,
        14
      ],
      [
        0,
        14
      ]
    ],
    [
      [
        90523,
        36389
      ],
      [
        3,
        15
      ],
      [
        4,
        -11
      ],
      [
        0,
        -12
      ],
      [
        -2,
        -12
      ],
      [
        -4,
        7
      ],
      [
        -1,
        13
      ]
    ],
    [
      [
        90507,
        37973
      ],
      [
        3,
        11
      ],
      [
        3,
        13
      ],
      [
        4,
        13
      ],
      [
        4,
        16
      ],
      [
        -1,
        14
      ],
      [
        2,
        13
      ],
      [
        -2,
        14
      ],
      [
        1,
        18
      ],
      [
        4,
        5
      ],
      [
        7,
        -5
      ],
      [
        2,
        -9
      ],
      [
        1,
        -25
      ],
      [
        -3,
        -32
      ],
      [
        -4,
        1
      ],
      [
        -5,
        -14
      ],
      [
        -4,
        -25
      ],
      [
        -2,
        -14
      ],
      [
        -4,
        -16
      ],
      [
        -6,
        -6
      ],
      [
        0,
        28
      ]
    ],
    [
      [
        90487,
        38800
      ],
      [
        1,
        18
      ],
      [
        5,
        21
      ],
      [
        6,
        -8
      ],
      [
        5,
        -20
      ],
      [
        0,
        -32
      ],
      [
        -1,
        -19
      ],
      [
        -2,
        -8
      ],
      [
        -6,
        -15
      ],
      [
        -7,
        25
      ],
      [
        -1,
        38
      ]
    ],
    [
      [
        90486,
        35993
      ],
      [
        3,
        2
      ],
      [
        12,
        -1
      ],
      [
        5,
        1
      ],
      [
        5,
        -11
      ],
      [
        0,
        -14
      ],
      [
        -2,
        -11
      ],
      [
        -4,
        -6
      ],
      [
        -7,
        1
      ],
      [
        -8,
        -3
      ],
      [
        -4,
        23
      ],
      [
        0,
        19
      ]
    ],
    [
      [
        90418,
        39869
      ],
      [
        3,
        11
      ],
      [
        4,
        -4
      ],
      [
        1,
        -14
      ],
      [
        -1,
        -11
      ],
      [
        -3,
        -7
      ],
      [
        -4,
        8
      ],
      [
        0,
        17
      ]
    ],
    [
      [
        90368,
        40257
      ],
      [
        3,
        5
      ],
      [
        3,
        -3
      ],
      [
        2,
        -14
      ],
      [
        -3,
        -10
      ],
      [
        -4,
        -1
      ],
      [
        -2,
        14
      ],
      [
        1,
        9
      ]
    ],
    [
      [
        90277,
        40864
      ],
      [
        3,
        6
      ],
      [
        3,
        -5
      ],
      [
        0,
        -12
      ],
      [
        -3,
        -10
      ],
      [
        -2,
        7
      ],
      [
        -1,
        14
      ]
    ],
    [
      [
        28675,
        59824
      ],
      [
        -1,
        -8
      ],
      [
        4,
        -45
      ],
      [
        3,
        -29
      ],
      [
        2,
        -3
      ],
      [
        3,
        -4
      ],
      [
        12,
        -7
      ],
      [
        12,
        -46
      ],
      [
        0,
        -1
      ],
      [
        5,
        -5
      ],
      [
        4,
        -32
      ],
      [
        -1,
        -9
      ],
      [
        -14,
        -14
      ],
      [
        -1,
        -23
      ],
      [
        0,
        -111
      ]
    ],
    [
      [
        28650,
        59487
      ],
      [
        -17,
        0
      ],
      [
        -25,
        1
      ],
      [
        -7,
        -1
      ]
    ],
    [
      [
        26528,
        67149
      ],
      [
        1,
        -307
      ],
      [
        1,
        -102
      ]
    ],
    [
      [
        26592,
        67695
      ],
      [
        5,
        -13
      ],
      [
        10,
        16
      ],
      [
        11,
        42
      ],
      [
        7,
        34
      ],
      [
        0,
        1
      ],
      [
        5,
        20
      ],
      [
        5,
        23
      ],
      [
        5,
        8
      ],
      [
        2,
        4
      ],
      [
        1,
        1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        5,
        -8
      ],
      [
        5,
        10
      ],
      [
        2,
        15
      ],
      [
        -1,
        3
      ]
    ],
    [
      [
        26655,
        67846
      ],
      [
        2,
        -3
      ],
      [
        0,
        -71
      ],
      [
        97,
        9
      ]
    ],
    [
      [
        26659,
        67255
      ],
      [
        -66,
        -2
      ]
    ],
    [
      [
        21216,
        70814
      ],
      [
        0,
        -391
      ]
    ],
    [
      [
        20924,
        72035
      ],
      [
        105,
        -1
      ]
    ],
    [
      [
        24580,
        68853
      ],
      [
        -34,
        0
      ],
      [
        -34,
        1
      ]
    ],
    [
      [
        24512,
        68854
      ],
      [
        -33,
        0
      ],
      [
        -34,
        -1
      ],
      [
        -34,
        0
      ]
    ],
    [
      [
        24377,
        68955
      ],
      [
        0,
        200
      ]
    ],
    [
      [
        16478,
        62470
      ],
      [
        67,
        1
      ],
      [
        3,
        -17
      ],
      [
        0,
        -17
      ],
      [
        56,
        1
      ]
    ],
    [
      [
        16604,
        62438
      ],
      [
        43,
        0
      ],
      [
        24,
        -2
      ],
      [
        0,
        -108
      ],
      [
        -11,
        -8
      ],
      [
        -14,
        -1
      ],
      [
        -1,
        -33
      ],
      [
        -5,
        0
      ],
      [
        0,
        -85
      ],
      [
        -5,
        0
      ],
      [
        0,
        -34
      ],
      [
        5,
        0
      ],
      [
        0,
        -34
      ],
      [
        5,
        -17
      ],
      [
        -1,
        -88
      ],
      [
        14,
        3
      ],
      [
        2,
        -8
      ],
      [
        1,
        -94
      ],
      [
        5,
        0
      ],
      [
        0,
        -132
      ]
    ],
    [
      [
        16666,
        61797
      ],
      [
        -1,
        4
      ],
      [
        -11,
        29
      ],
      [
        -1,
        4
      ],
      [
        -21,
        62
      ],
      [
        -12,
        35
      ],
      [
        -26,
        74
      ]
    ],
    [
      [
        16478,
        62417
      ],
      [
        0,
        53
      ]
    ],
    [
      [
        26106,
        64163
      ],
      [
        68,
        0
      ]
    ],
    [
      [
        26169,
        63944
      ],
      [
        -31,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -30,
        1
      ]
    ],
    [
      [
        26209,
        64571
      ],
      [
        1,
        -201
      ],
      [
        0,
        -5
      ],
      [
        1,
        -201
      ]
    ],
    [
      [
        24117,
        56288
      ],
      [
        70,
        -8
      ]
    ],
    [
      [
        24182,
        55702
      ],
      [
        -8,
        -23
      ],
      [
        -14,
        -11
      ],
      [
        -4,
        6
      ],
      [
        -3,
        15
      ],
      [
        -1,
        -5
      ],
      [
        -4,
        12
      ],
      [
        4,
        11
      ],
      [
        -6,
        29
      ],
      [
        -2,
        -14
      ],
      [
        -5,
        13
      ],
      [
        -5,
        -12
      ],
      [
        -3,
        46
      ],
      [
        -4,
        11
      ],
      [
        -5,
        2
      ]
    ],
    [
      [
        24122,
        55782
      ],
      [
        0,
        13
      ],
      [
        -4,
        -7
      ],
      [
        -1,
        29
      ],
      [
        -10,
        13
      ],
      [
        -6,
        -15
      ],
      [
        1,
        22
      ],
      [
        -5,
        10
      ],
      [
        1,
        12
      ],
      [
        -6,
        -4
      ],
      [
        -9,
        1
      ],
      [
        1,
        26
      ],
      [
        -4,
        -2
      ],
      [
        -2,
        10
      ],
      [
        2,
        25
      ],
      [
        -5,
        15
      ],
      [
        -1,
        -10
      ],
      [
        -4,
        -2
      ],
      [
        -3,
        9
      ],
      [
        2,
        10
      ],
      [
        -5,
        11
      ],
      [
        4,
        24
      ],
      [
        -5,
        8
      ],
      [
        1,
        8
      ],
      [
        3,
        10
      ],
      [
        5,
        -9
      ],
      [
        5,
        21
      ],
      [
        3,
        -13
      ],
      [
        2,
        45
      ],
      [
        -6,
        29
      ],
      [
        2,
        42
      ],
      [
        20,
        11
      ],
      [
        5,
        37
      ],
      [
        10,
        21
      ],
      [
        0,
        8
      ],
      [
        3,
        12
      ],
      [
        1,
        10
      ],
      [
        0,
        76
      ]
    ],
    [
      [
        25326,
        64901
      ],
      [
        65,
        5
      ],
      [
        -1,
        101
      ],
      [
        16,
        1
      ],
      [
        17,
        1
      ],
      [
        31,
        2
      ],
      [
        72,
        3
      ]
    ],
    [
      [
        25526,
        64860
      ],
      [
        0,
        -181
      ]
    ],
    [
      [
        25526,
        64679
      ],
      [
        -169,
        -15
      ]
    ],
    [
      [
        25325,
        64660
      ],
      [
        -1,
        140
      ]
    ],
    [
      [
        17375,
        69414
      ],
      [
        0,
        20
      ],
      [
        2,
        12
      ],
      [
        6,
        10
      ],
      [
        7,
        30
      ],
      [
        0,
        5
      ],
      [
        1,
        22
      ],
      [
        0,
        10
      ],
      [
        5,
        36
      ],
      [
        0,
        19
      ],
      [
        1,
        24
      ],
      [
        2,
        17
      ],
      [
        2,
        11
      ],
      [
        1,
        5
      ]
    ],
    [
      [
        17510,
        68676
      ],
      [
        -30,
        0
      ],
      [
        -34,
        55
      ],
      [
        0,
        144
      ],
      [
        -21,
        0
      ],
      [
        1,
        25
      ],
      [
        -7,
        30
      ],
      [
        0,
        205
      ],
      [
        -77,
        3
      ]
    ],
    [
      [
        29738,
        65368
      ],
      [
        0,
        33
      ],
      [
        -6,
        37
      ],
      [
        -5,
        11
      ],
      [
        -1,
        19
      ],
      [
        -2,
        45
      ],
      [
        -1,
        22
      ],
      [
        -3,
        52
      ],
      [
        0,
        9
      ],
      [
        -1,
        17
      ],
      [
        -2,
        -1
      ],
      [
        -6,
        -3
      ],
      [
        0,
        13
      ],
      [
        3,
        47
      ],
      [
        -6,
        -5
      ],
      [
        0,
        15
      ],
      [
        1,
        88
      ],
      [
        6,
        3
      ],
      [
        -5,
        101
      ]
    ],
    [
      [
        26052,
        61617
      ],
      [
        19,
        -45
      ],
      [
        -4,
        -2
      ],
      [
        11,
        -13
      ],
      [
        5,
        -12
      ],
      [
        8,
        -19
      ],
      [
        2,
        -4
      ],
      [
        4,
        -10
      ],
      [
        3,
        -5
      ]
    ],
    [
      [
        26112,
        61346
      ],
      [
        -1,
        -25
      ],
      [
        0,
        -9
      ]
    ],
    [
      [
        26111,
        61312
      ],
      [
        -25,
        -34
      ],
      [
        -3,
        -6
      ],
      [
        -6,
        -9
      ],
      [
        -5,
        -1
      ],
      [
        -14,
        5
      ],
      [
        -23,
        8
      ],
      [
        -3,
        1
      ],
      [
        -22,
        -25
      ],
      [
        -8,
        -8
      ],
      [
        -7,
        -9
      ],
      [
        -11,
        -12
      ],
      [
        -8,
        -23
      ],
      [
        -6,
        -28
      ],
      [
        -1,
        2
      ]
    ],
    [
      [
        25020,
        52616
      ],
      [
        -56,
        1
      ],
      [
        0,
        -153
      ],
      [
        -14,
        0
      ],
      [
        -1,
        -17
      ],
      [
        -14,
        0
      ],
      [
        0,
        -51
      ],
      [
        -12,
        1
      ]
    ],
    [
      [
        24923,
        52397
      ],
      [
        -1,
        4
      ],
      [
        -2,
        2
      ],
      [
        -1,
        9
      ],
      [
        -1,
        6
      ],
      [
        0,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        6
      ],
      [
        0,
        7
      ],
      [
        -1,
        4
      ],
      [
        -1,
        0
      ],
      [
        -4,
        6
      ],
      [
        0,
        2
      ],
      [
        -1,
        4
      ],
      [
        -2,
        0
      ],
      [
        -2,
        3
      ],
      [
        0,
        12
      ],
      [
        -2,
        0
      ],
      [
        -1,
        8
      ],
      [
        0,
        9
      ],
      [
        -1,
        10
      ],
      [
        -2,
        7
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        1
      ],
      [
        0,
        3
      ],
      [
        1,
        1
      ],
      [
        0,
        3
      ],
      [
        -1,
        6
      ],
      [
        -2,
        1
      ],
      [
        0,
        7
      ],
      [
        1,
        0
      ],
      [
        1,
        -2
      ],
      [
        1,
        1
      ],
      [
        0,
        3
      ],
      [
        1,
        2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        4
      ],
      [
        -1,
        15
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        -2,
        5
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -1,
        3
      ],
      [
        0,
        2
      ],
      [
        1,
        4
      ],
      [
        1,
        7
      ],
      [
        0,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        0,
        7
      ],
      [
        1,
        5
      ],
      [
        0,
        1
      ],
      [
        -1,
        4
      ],
      [
        2,
        13
      ],
      [
        -1,
        12
      ],
      [
        -1,
        6
      ],
      [
        -3,
        9
      ],
      [
        -2,
        2
      ],
      [
        -3,
        3
      ],
      [
        0,
        2
      ],
      [
        1,
        2
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        24569,
        51939
      ],
      [
        7,
        23
      ],
      [
        6,
        27
      ],
      [
        0,
        5
      ],
      [
        13,
        10
      ],
      [
        45,
        37
      ],
      [
        18,
        15
      ]
    ],
    [
      [
        24658,
        52056
      ],
      [
        -3,
        -82
      ],
      [
        -5,
        -3
      ],
      [
        3,
        -50
      ],
      [
        -3,
        -5
      ],
      [
        -5,
        -12
      ],
      [
        5,
        -51
      ],
      [
        -1,
        -6
      ],
      [
        2,
        -7
      ],
      [
        -2,
        -18
      ],
      [
        2,
        -16
      ],
      [
        1,
        -52
      ],
      [
        2,
        -21
      ]
    ],
    [
      [
        19271,
        63277
      ],
      [
        -150,
        1
      ],
      [
        0,
        5
      ],
      [
        -95,
        2
      ]
    ],
    [
      [
        19016,
        63386
      ],
      [
        -1,
        213
      ],
      [
        0,
        406
      ],
      [
        -2,
        0
      ],
      [
        1,
        287
      ]
    ],
    [
      [
        22643,
        51697
      ],
      [
        -19,
        -60
      ],
      [
        -16,
        -63
      ]
    ],
    [
      [
        18137,
        63393
      ],
      [
        223,
        -1
      ],
      [
        252,
        -1
      ],
      [
        2,
        22
      ],
      [
        -1,
        25
      ],
      [
        2,
        10
      ],
      [
        3,
        -10
      ],
      [
        4,
        5
      ],
      [
        2,
        -14
      ],
      [
        8,
        3
      ],
      [
        10,
        25
      ],
      [
        3,
        33
      ],
      [
        13,
        26
      ]
    ],
    [
      [
        18703,
        62705
      ],
      [
        -15,
        0
      ],
      [
        0,
        17
      ],
      [
        -33,
        0
      ],
      [
        0,
        51
      ],
      [
        -1,
        136
      ],
      [
        -3,
        0
      ],
      [
        -2,
        42
      ],
      [
        5,
        0
      ],
      [
        0,
        17
      ],
      [
        -5,
        15
      ],
      [
        -40,
        0
      ],
      [
        -150,
        -1
      ],
      [
        -257,
        0
      ],
      [
        0,
        -10
      ],
      [
        -65,
        -2
      ]
    ],
    [
      [
        18137,
        62970
      ],
      [
        0,
        423
      ]
    ],
    [
      [
        28208,
        59480
      ],
      [
        5,
        0
      ],
      [
        2,
        1
      ],
      [
        30,
        0
      ]
    ],
    [
      [
        28245,
        59481
      ],
      [
        5,
        0
      ],
      [
        126,
        -1
      ]
    ],
    [
      [
        28376,
        59480
      ],
      [
        26,
        0
      ],
      [
        4,
        2
      ],
      [
        6,
        1
      ],
      [
        1,
        -1
      ]
    ],
    [
      [
        28401,
        59133
      ],
      [
        -6,
        -34
      ],
      [
        -6,
        2
      ],
      [
        -13,
        -13
      ],
      [
        -1,
        -30
      ],
      [
        3,
        -16
      ]
    ],
    [
      [
        25898,
        54151
      ],
      [
        5,
        -42
      ],
      [
        0,
        -43
      ],
      [
        -2,
        -27
      ],
      [
        -1,
        -44
      ],
      [
        -4,
        -29
      ],
      [
        0,
        -20
      ],
      [
        14,
        1
      ],
      [
        0,
        -149
      ],
      [
        -3,
        -3
      ],
      [
        0,
        -15
      ],
      [
        -6,
        -26
      ],
      [
        0,
        -10
      ],
      [
        10,
        1
      ]
    ],
    [
      [
        25897,
        53538
      ],
      [
        -19,
        2
      ],
      [
        1,
        17
      ],
      [
        -5,
        -1
      ],
      [
        -1,
        85
      ],
      [
        -5,
        0
      ],
      [
        -6,
        -27
      ],
      [
        -3,
        -5
      ],
      [
        -2,
        -16
      ],
      [
        -7,
        0
      ],
      [
        -2,
        -16
      ],
      [
        -7,
        -26
      ],
      [
        -1,
        89
      ],
      [
        -4,
        -2
      ],
      [
        -24,
        0
      ]
    ],
    [
      [
        18973,
        65833
      ],
      [
        -103,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -13,
        -2
      ],
      [
        -10,
        0
      ]
    ],
    [
      [
        18845,
        65830
      ],
      [
        -2,
        81
      ],
      [
        -2,
        6
      ],
      [
        -13,
        10
      ],
      [
        -9,
        19
      ],
      [
        4,
        50
      ],
      [
        -6,
        14
      ],
      [
        -5,
        62
      ],
      [
        3,
        24
      ],
      [
        0,
        21
      ],
      [
        4,
        3
      ],
      [
        3,
        17
      ],
      [
        8,
        16
      ],
      [
        -7,
        13
      ],
      [
        1,
        26
      ],
      [
        -2,
        18
      ],
      [
        10,
        30
      ],
      [
        -1,
        13
      ],
      [
        -7,
        15
      ],
      [
        0,
        22
      ],
      [
        -5,
        -4
      ],
      [
        0,
        28
      ]
    ],
    [
      [
        18819,
        66314
      ],
      [
        6,
        17
      ],
      [
        -9,
        93
      ],
      [
        -3,
        10
      ],
      [
        -4,
        60
      ],
      [
        5,
        15
      ],
      [
        5,
        9
      ],
      [
        65,
        0
      ],
      [
        7,
        -5
      ],
      [
        0,
        -18
      ],
      [
        6,
        -11
      ],
      [
        11,
        -10
      ],
      [
        11,
        59
      ],
      [
        0,
        -21
      ],
      [
        5,
        -15
      ],
      [
        -4,
        -74
      ],
      [
        -3,
        -16
      ],
      [
        4,
        -19
      ],
      [
        13,
        1
      ],
      [
        5,
        -7
      ],
      [
        3,
        20
      ],
      [
        8,
        -10
      ],
      [
        6,
        11
      ],
      [
        4,
        -3
      ],
      [
        9,
        14
      ],
      [
        -1,
        9
      ],
      [
        5,
        6
      ]
    ],
    [
      [
        26390,
        63409
      ],
      [
        75,
        4
      ],
      [
        -3,
        -13
      ],
      [
        3,
        -31
      ],
      [
        29,
        -6
      ]
    ],
    [
      [
        26494,
        63363
      ],
      [
        0,
        -34
      ]
    ],
    [
      [
        26375,
        63027
      ],
      [
        0,
        76
      ],
      [
        -1,
        202
      ],
      [
        -1,
        103
      ]
    ],
    [
      [
        26010,
        53745
      ],
      [
        12,
        1
      ]
    ],
    [
      [
        26022,
        53746
      ],
      [
        69,
        2
      ],
      [
        23,
        -1
      ]
    ],
    [
      [
        26114,
        53747
      ],
      [
        0,
        -354
      ]
    ],
    [
      [
        26114,
        53393
      ],
      [
        0,
        -34
      ],
      [
        -9,
        1
      ],
      [
        -10,
        0
      ],
      [
        0,
        -47
      ],
      [
        -17,
        9
      ],
      [
        -11,
        12
      ],
      [
        -5,
        9
      ],
      [
        -9,
        4
      ],
      [
        -8,
        -8
      ],
      [
        -2,
        -22
      ],
      [
        -5,
        -16
      ],
      [
        -1,
        -28
      ],
      [
        -5,
        -20
      ]
    ],
    [
      [
        26032,
        53253
      ],
      [
        -22,
        2
      ]
    ],
    [
      [
        15829,
        60925
      ],
      [
        1,
        -3
      ]
    ],
    [
      [
        15830,
        60922
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        15816,
        60977
      ],
      [
        3,
        2
      ],
      [
        1,
        -9
      ],
      [
        2,
        -12
      ],
      [
        -1,
        -7
      ],
      [
        -3,
        4
      ],
      [
        0,
        6
      ],
      [
        -2,
        12
      ],
      [
        0,
        4
      ]
    ],
    [
      [
        15813,
        60835
      ],
      [
        -31,
        0
      ]
    ],
    [
      [
        15782,
        60835
      ],
      [
        -1,
        18
      ],
      [
        -1,
        14
      ],
      [
        -1,
        41
      ],
      [
        -1,
        11
      ],
      [
        3,
        9
      ],
      [
        3,
        0
      ],
      [
        2,
        3
      ],
      [
        2,
        23
      ],
      [
        3,
        -2
      ],
      [
        1,
        -5
      ],
      [
        11,
        7
      ],
      [
        5,
        1
      ],
      [
        3,
        -7
      ],
      [
        3,
        -17
      ],
      [
        3,
        -65
      ],
      [
        1,
        -3
      ],
      [
        1,
        3
      ],
      [
        1,
        0
      ],
      [
        2,
        -6
      ],
      [
        -1,
        -17
      ],
      [
        -3,
        3
      ],
      [
        -5,
        -11
      ]
    ],
    [
      [
        19942,
        61346
      ],
      [
        -1,
        -13
      ],
      [
        2,
        -10
      ],
      [
        0,
        -33
      ],
      [
        3,
        -23
      ],
      [
        6,
        1
      ],
      [
        6,
        -23
      ],
      [
        -8,
        -39
      ],
      [
        1,
        -21
      ],
      [
        -3,
        -12
      ],
      [
        -7,
        9
      ],
      [
        -5,
        -17
      ],
      [
        1,
        -25
      ],
      [
        5,
        -6
      ]
    ],
    [
      [
        19942,
        61134
      ],
      [
        -20,
        0
      ],
      [
        1,
        -52
      ],
      [
        -7,
        -20
      ],
      [
        -9,
        -13
      ],
      [
        -12,
        15
      ]
    ],
    [
      [
        19895,
        61064
      ],
      [
        2,
        29
      ],
      [
        -5,
        27
      ],
      [
        -8,
        9
      ],
      [
        -5,
        32
      ],
      [
        -15,
        5
      ],
      [
        0,
        19
      ],
      [
        -9,
        -2
      ],
      [
        -2,
        5
      ],
      [
        -3,
        17
      ],
      [
        3,
        23
      ],
      [
        -1,
        14
      ],
      [
        0,
        67
      ],
      [
        -16,
        1
      ],
      [
        0,
        33
      ],
      [
        -4,
        9
      ]
    ],
    [
      [
        25103,
        60394
      ],
      [
        0,
        -41
      ],
      [
        12,
        20
      ],
      [
        11,
        -16
      ],
      [
        9,
        6
      ]
    ],
    [
      [
        25134,
        60276
      ],
      [
        -2,
        1
      ],
      [
        -7,
        1
      ],
      [
        -5,
        -1
      ],
      [
        -5,
        -5
      ],
      [
        -2,
        -5
      ],
      [
        1,
        1
      ],
      [
        -2,
        -6
      ],
      [
        -5,
        -6
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -1
      ],
      [
        -5,
        -17
      ],
      [
        -5,
        -16
      ],
      [
        -2,
        -11
      ],
      [
        -2,
        -10
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -6
      ],
      [
        -3,
        -26
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        -6
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        0,
        -2
      ],
      [
        -4,
        -17
      ],
      [
        -1,
        -7
      ]
    ],
    [
      [
        25068,
        60090
      ],
      [
        -7,
        20
      ],
      [
        -9,
        7
      ],
      [
        -9,
        17
      ],
      [
        -4,
        24
      ],
      [
        5,
        23
      ],
      [
        0,
        16
      ],
      [
        -3,
        -1
      ],
      [
        2,
        12
      ],
      [
        -2,
        13
      ],
      [
        4,
        12
      ],
      [
        -3,
        12
      ],
      [
        1,
        22
      ],
      [
        3,
        27
      ],
      [
        0,
        15
      ],
      [
        3,
        17
      ],
      [
        8,
        11
      ],
      [
        2,
        10
      ],
      [
        -1,
        38
      ],
      [
        -6,
        12
      ],
      [
        -6,
        4
      ]
    ],
    [
      [
        24523,
        59426
      ],
      [
        41,
        0
      ],
      [
        5,
        1
      ],
      [
        24,
        0
      ],
      [
        0,
        -1
      ],
      [
        1,
        0
      ],
      [
        6,
        1
      ],
      [
        18,
        0
      ]
    ],
    [
      [
        24618,
        59427
      ],
      [
        5,
        -16
      ],
      [
        -2,
        -44
      ],
      [
        -1,
        -11
      ],
      [
        6,
        -19
      ],
      [
        -4,
        -10
      ],
      [
        6,
        0
      ],
      [
        0,
        -154
      ],
      [
        -4,
        8
      ],
      [
        -5,
        -4
      ],
      [
        -3,
        11
      ],
      [
        -4,
        -6
      ],
      [
        0,
        -25
      ]
    ],
    [
      [
        24612,
        59157
      ],
      [
        -1,
        -137
      ]
    ],
    [
      [
        24445,
        59425
      ],
      [
        1,
        0
      ],
      [
        49,
        1
      ],
      [
        28,
        0
      ]
    ],
    [
      [
        24246,
        57760
      ],
      [
        1,
        105
      ],
      [
        0,
        47
      ],
      [
        2,
        193
      ]
    ],
    [
      [
        26972,
        64743
      ],
      [
        46,
        -2
      ]
    ],
    [
      [
        27030,
        64657
      ],
      [
        0,
        -106
      ],
      [
        1,
        -17
      ],
      [
        0,
        -254
      ]
    ],
    [
      [
        23408,
        58426
      ],
      [
        1,
        -50
      ],
      [
        -2,
        -81
      ],
      [
        3,
        -24
      ],
      [
        7,
        -22
      ],
      [
        4,
        -31
      ],
      [
        9,
        -2
      ]
    ],
    [
      [
        24681,
        50807
      ],
      [
        10,
        -3
      ],
      [
        13,
        -18
      ],
      [
        11,
        -4
      ],
      [
        5,
        -8
      ],
      [
        -6,
        -11
      ],
      [
        -13,
        3
      ],
      [
        -14,
        18
      ],
      [
        -6,
        23
      ]
    ],
    [
      [
        24628,
        50763
      ],
      [
        6,
        8
      ],
      [
        8,
        9
      ],
      [
        11,
        2
      ],
      [
        2,
        -17
      ],
      [
        -8,
        -8
      ],
      [
        -18,
        -12
      ],
      [
        -5,
        6
      ],
      [
        4,
        12
      ]
    ],
    [
      [
        24732,
        51028
      ],
      [
        1,
        -22
      ],
      [
        -2,
        -10
      ]
    ],
    [
      [
        24726,
        51002
      ],
      [
        0,
        24
      ],
      [
        1,
        20
      ],
      [
        -2,
        15
      ],
      [
        -5,
        14
      ],
      [
        -3,
        27
      ],
      [
        -5,
        1
      ],
      [
        -3,
        -14
      ],
      [
        2,
        -17
      ],
      [
        -5,
        -27
      ],
      [
        -2,
        -7
      ],
      [
        -5,
        4
      ],
      [
        -5,
        8
      ],
      [
        -4,
        2
      ],
      [
        -7,
        -22
      ],
      [
        -4,
        22
      ],
      [
        -3,
        9
      ],
      [
        -5,
        -10
      ],
      [
        -1,
        -17
      ],
      [
        3,
        -20
      ],
      [
        0,
        -21
      ],
      [
        7,
        -22
      ],
      [
        -3,
        -8
      ],
      [
        -9,
        12
      ],
      [
        -2,
        -6
      ],
      [
        2,
        -10
      ],
      [
        -1,
        -11
      ],
      [
        -6,
        0
      ],
      [
        -3,
        -26
      ],
      [
        -1,
        -28
      ],
      [
        -8,
        7
      ],
      [
        -3,
        -10
      ],
      [
        1,
        -11
      ],
      [
        -3,
        -36
      ],
      [
        -5,
        -11
      ],
      [
        -3,
        23
      ],
      [
        -3,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -20
      ],
      [
        -7,
        -5
      ],
      [
        -1,
        -12
      ],
      [
        -5,
        5
      ],
      [
        -2,
        -13
      ],
      [
        -3,
        -37
      ],
      [
        0,
        -9
      ],
      [
        -1,
        -17
      ],
      [
        -8,
        5
      ],
      [
        -8,
        11
      ],
      [
        3,
        11
      ],
      [
        2,
        10
      ],
      [
        -3,
        24
      ],
      [
        -4,
        12
      ],
      [
        -3,
        14
      ],
      [
        -3,
        17
      ],
      [
        -8,
        25
      ],
      [
        -4,
        11
      ],
      [
        -2,
        14
      ],
      [
        -4,
        7
      ],
      [
        -5,
        -11
      ],
      [
        -6,
        -2
      ],
      [
        -6,
        6
      ],
      [
        -2,
        9
      ],
      [
        -8,
        -1
      ],
      [
        -10,
        7
      ],
      [
        -6,
        24
      ],
      [
        -4,
        9
      ],
      [
        -19,
        7
      ],
      [
        -6,
        5
      ],
      [
        -16,
        25
      ],
      [
        -7,
        22
      ],
      [
        -9,
        38
      ],
      [
        1,
        8
      ],
      [
        6,
        0
      ],
      [
        5,
        6
      ],
      [
        4,
        22
      ],
      [
        1,
        17
      ],
      [
        2,
        19
      ],
      [
        8,
        12
      ],
      [
        0,
        -24
      ],
      [
        5,
        -29
      ],
      [
        7,
        -23
      ],
      [
        7,
        22
      ],
      [
        2,
        -8
      ],
      [
        -2,
        -16
      ],
      [
        1,
        -19
      ],
      [
        -2,
        -25
      ],
      [
        5,
        -13
      ],
      [
        5,
        -6
      ],
      [
        5,
        2
      ],
      [
        0,
        17
      ],
      [
        -2,
        8
      ],
      [
        -1,
        15
      ],
      [
        3,
        17
      ],
      [
        -1,
        22
      ],
      [
        -3,
        25
      ],
      [
        -5,
        4
      ],
      [
        1,
        10
      ],
      [
        -12,
        21
      ],
      [
        -2,
        21
      ],
      [
        -5,
        8
      ],
      [
        -1,
        10
      ],
      [
        2,
        13
      ],
      [
        0,
        6
      ],
      [
        -1,
        13
      ],
      [
        -6,
        7
      ]
    ],
    [
      [
        15363,
        69375
      ],
      [
        78,
        0
      ]
    ],
    [
      [
        15332,
        68480
      ],
      [
        0,
        12
      ],
      [
        2,
        20
      ],
      [
        0,
        13
      ],
      [
        1,
        12
      ],
      [
        1,
        8
      ],
      [
        3,
        45
      ],
      [
        2,
        53
      ],
      [
        1,
        30
      ],
      [
        0,
        43
      ],
      [
        -1,
        10
      ],
      [
        0,
        16
      ],
      [
        2,
        35
      ],
      [
        3,
        90
      ],
      [
        -1,
        5
      ],
      [
        1,
        11
      ],
      [
        0,
        12
      ],
      [
        2,
        31
      ],
      [
        0,
        12
      ],
      [
        -3,
        17
      ],
      [
        2,
        22
      ],
      [
        1,
        41
      ],
      [
        -2,
        29
      ],
      [
        -3,
        10
      ],
      [
        1,
        31
      ],
      [
        2,
        38
      ],
      [
        1,
        5
      ],
      [
        2,
        4
      ],
      [
        2,
        13
      ],
      [
        4,
        59
      ],
      [
        2,
        32
      ],
      [
        0,
        10
      ],
      [
        1,
        16
      ],
      [
        2,
        38
      ],
      [
        3,
        72
      ]
    ],
    [
      [
        26655,
        67846
      ],
      [
        0,
        5
      ],
      [
        -4,
        10
      ],
      [
        -2,
        33
      ],
      [
        5,
        25
      ],
      [
        4,
        19
      ],
      [
        0,
        19
      ],
      [
        4,
        21
      ],
      [
        0,
        17
      ],
      [
        5,
        30
      ],
      [
        5,
        -9
      ],
      [
        -3,
        -25
      ],
      [
        2,
        -16
      ],
      [
        7,
        8
      ],
      [
        5,
        11
      ],
      [
        7,
        12
      ],
      [
        5,
        29
      ],
      [
        -5,
        7
      ],
      [
        -7,
        6
      ],
      [
        -7,
        5
      ],
      [
        -2,
        13
      ],
      [
        9,
        -1
      ],
      [
        15,
        -2
      ],
      [
        4,
        6
      ],
      [
        7,
        18
      ],
      [
        3,
        21
      ],
      [
        2,
        15
      ],
      [
        0,
        5
      ],
      [
        10,
        9
      ],
      [
        9,
        2
      ],
      [
        4,
        -1
      ],
      [
        10,
        9
      ],
      [
        3,
        4
      ],
      [
        4,
        9
      ],
      [
        3,
        3
      ],
      [
        8,
        -3
      ],
      [
        4,
        3
      ],
      [
        2,
        3
      ],
      [
        3,
        11
      ],
      [
        5,
        30
      ],
      [
        1,
        4
      ],
      [
        7,
        2
      ],
      [
        3,
        3
      ],
      [
        6,
        20
      ],
      [
        3,
        -1
      ],
      [
        0,
        -2
      ],
      [
        3,
        -2
      ],
      [
        5,
        9
      ],
      [
        4,
        1
      ],
      [
        7,
        -23
      ],
      [
        4,
        -7
      ],
      [
        12,
        -9
      ],
      [
        11,
        -16
      ],
      [
        1,
        -11
      ],
      [
        2,
        -5
      ],
      [
        5,
        -3
      ],
      [
        5,
        -13
      ],
      [
        2,
        -7
      ],
      [
        3,
        -20
      ],
      [
        4,
        -27
      ],
      [
        1,
        -1
      ],
      [
        5,
        -36
      ],
      [
        4,
        -39
      ],
      [
        6,
        -19
      ],
      [
        4,
        -18
      ],
      [
        0,
        -7
      ],
      [
        -2,
        -2
      ],
      [
        0,
        -2
      ],
      [
        1,
        -6
      ],
      [
        3,
        -8
      ],
      [
        5,
        -72
      ],
      [
        -1,
        -15
      ],
      [
        1,
        -11
      ],
      [
        1,
        -8
      ],
      [
        2,
        -57
      ]
    ],
    [
      [
        23546,
        64168
      ],
      [
        11,
        -1
      ],
      [
        34,
        0
      ]
    ],
    [
      [
        23556,
        63953
      ],
      [
        -3,
        0
      ],
      [
        0,
        100
      ],
      [
        -6,
        0
      ],
      [
        -1,
        115
      ]
    ],
    [
      [
        24087,
        63049
      ],
      [
        109,
        -6
      ]
    ],
    [
      [
        24196,
        63043
      ],
      [
        -2,
        -248
      ],
      [
        -1,
        -52
      ]
    ],
    [
      [
        24160,
        62628
      ],
      [
        -36,
        40
      ],
      [
        -3,
        3
      ],
      [
        -38,
        42
      ]
    ],
    [
      [
        5814,
        42059
      ],
      [
        7,
        5
      ],
      [
        18,
        3
      ],
      [
        5,
        -4
      ],
      [
        13,
        5
      ],
      [
        1,
        2
      ],
      [
        4,
        10
      ],
      [
        0,
        7
      ],
      [
        -1,
        3
      ],
      [
        1,
        3
      ],
      [
        8,
        24
      ],
      [
        3,
        18
      ],
      [
        0,
        10
      ],
      [
        1,
        7
      ],
      [
        7,
        30
      ],
      [
        6,
        18
      ],
      [
        7,
        10
      ],
      [
        1,
        5
      ],
      [
        6,
        0
      ],
      [
        6,
        -27
      ],
      [
        2,
        -24
      ],
      [
        2,
        -16
      ],
      [
        2,
        -5
      ],
      [
        0,
        -25
      ],
      [
        4,
        -21
      ],
      [
        2,
        -6
      ],
      [
        7,
        -36
      ],
      [
        0,
        -17
      ],
      [
        1,
        -4
      ],
      [
        2,
        8
      ],
      [
        3,
        -4
      ],
      [
        1,
        -4
      ],
      [
        4,
        -32
      ],
      [
        0,
        -20
      ],
      [
        -3,
        -3
      ],
      [
        -1,
        -12
      ],
      [
        1,
        -20
      ],
      [
        1,
        -18
      ],
      [
        1,
        -9
      ],
      [
        5,
        -4
      ],
      [
        2,
        -7
      ],
      [
        1,
        -11
      ],
      [
        0,
        -3
      ],
      [
        2,
        -9
      ],
      [
        5,
        -17
      ],
      [
        2,
        -3
      ],
      [
        1,
        -1
      ],
      [
        1,
        9
      ],
      [
        3,
        21
      ],
      [
        -5,
        10
      ],
      [
        2,
        13
      ],
      [
        2,
        4
      ],
      [
        6,
        -9
      ],
      [
        2,
        7
      ],
      [
        4,
        0
      ],
      [
        -1,
        -11
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -15
      ],
      [
        0,
        -13
      ],
      [
        1,
        -12
      ],
      [
        2,
        -3
      ],
      [
        1,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        1
      ],
      [
        0,
        -4
      ],
      [
        1,
        -4
      ],
      [
        3,
        -15
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -12
      ],
      [
        0,
        -12
      ],
      [
        1,
        -6
      ],
      [
        3,
        -20
      ],
      [
        1,
        -4
      ],
      [
        3,
        -8
      ],
      [
        6,
        -15
      ],
      [
        1,
        0
      ],
      [
        2,
        1
      ],
      [
        0,
        -18
      ],
      [
        -10,
        -27
      ],
      [
        -2,
        -10
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        2
      ],
      [
        0,
        3
      ],
      [
        1,
        6
      ],
      [
        -2,
        7
      ],
      [
        0,
        1
      ],
      [
        -4,
        4
      ],
      [
        -7,
        -5
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        -13
      ],
      [
        -4,
        -5
      ],
      [
        -4,
        -4
      ],
      [
        -3,
        4
      ],
      [
        -1,
        4
      ],
      [
        -1,
        8
      ],
      [
        -1,
        10
      ],
      [
        -6,
        6
      ],
      [
        -3,
        6
      ],
      [
        -1,
        4
      ],
      [
        -1,
        2
      ],
      [
        -6,
        13
      ],
      [
        -5,
        -1
      ],
      [
        -12,
        1
      ],
      [
        1,
        7
      ],
      [
        -1,
        7
      ],
      [
        -4,
        11
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -8
      ],
      [
        -2,
        -4
      ],
      [
        -8,
        -5
      ],
      [
        -4,
        -3
      ],
      [
        -6,
        -3
      ],
      [
        -11,
        -8
      ],
      [
        -1,
        -1
      ],
      [
        -4,
        -1
      ],
      [
        -3,
        5
      ],
      [
        -2,
        17
      ],
      [
        0,
        7
      ],
      [
        -1,
        9
      ],
      [
        -2,
        22
      ],
      [
        0,
        12
      ],
      [
        -2,
        17
      ],
      [
        -3,
        13
      ],
      [
        -3,
        13
      ],
      [
        -5,
        8
      ],
      [
        0,
        1
      ],
      [
        -1,
        6
      ],
      [
        0,
        24
      ],
      [
        -3,
        21
      ],
      [
        -3,
        14
      ],
      [
        -4,
        11
      ],
      [
        -4,
        21
      ],
      [
        0,
        61
      ],
      [
        -5,
        20
      ],
      [
        -6,
        15
      ],
      [
        -2,
        7
      ],
      [
        0,
        3
      ]
    ],
    [
      [
        18137,
        61963
      ],
      [
        0,
        1007
      ]
    ],
    [
      [
        18704,
        62392
      ],
      [
        -2,
        -58
      ],
      [
        -10,
        0
      ],
      [
        -3,
        -9
      ],
      [
        1,
        -34
      ],
      [
        -20,
        0
      ],
      [
        0,
        -28
      ],
      [
        -5,
        0
      ],
      [
        1,
        -33
      ],
      [
        -6,
        -1
      ],
      [
        0,
        -32
      ],
      [
        -5,
        1
      ],
      [
        0,
        -17
      ],
      [
        -10,
        0
      ],
      [
        -1,
        -32
      ],
      [
        0,
        -85
      ],
      [
        3,
        -43
      ],
      [
        -5,
        -5
      ],
      [
        -5,
        -21
      ],
      [
        -8,
        -4
      ],
      [
        0,
        -17
      ],
      [
        -8,
        -4
      ],
      [
        0,
        -8
      ],
      [
        -13,
        9
      ],
      [
        -25,
        -3
      ],
      [
        -5,
        -9
      ],
      [
        -5,
        -34
      ],
      [
        0,
        -51
      ],
      [
        -5,
        0
      ],
      [
        -1,
        -34
      ],
      [
        -3,
        1
      ]
    ],
    [
      [
        18137,
        63639
      ],
      [
        1,
        134
      ],
      [
        0,
        628
      ],
      [
        1,
        266
      ]
    ],
    [
      [
        18635,
        64398
      ],
      [
        9,
        -47
      ],
      [
        1,
        -6
      ],
      [
        0,
        -1
      ],
      [
        5,
        -8
      ],
      [
        3,
        -101
      ],
      [
        6,
        -29
      ],
      [
        -2,
        -28
      ],
      [
        1,
        -68
      ],
      [
        -3,
        -9
      ],
      [
        3,
        -34
      ],
      [
        2,
        -16
      ],
      [
        0,
        -5
      ]
    ],
    [
      [
        18137,
        63393
      ],
      [
        0,
        145
      ],
      [
        1,
        79
      ],
      [
        -1,
        7
      ],
      [
        0,
        15
      ]
    ],
    [
      [
        27485,
        46274
      ],
      [
        -2,
        12
      ],
      [
        4,
        -3
      ],
      [
        -2,
        23
      ],
      [
        4,
        -3
      ],
      [
        9,
        18
      ],
      [
        8,
        -4
      ],
      [
        3,
        20
      ],
      [
        4,
        0
      ],
      [
        0,
        22
      ],
      [
        4,
        18
      ],
      [
        0,
        21
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        27518,
        46398
      ],
      [
        0,
        -5
      ],
      [
        3,
        -19
      ],
      [
        8,
        5
      ],
      [
        13,
        34
      ],
      [
        5,
        34
      ],
      [
        1,
        5
      ]
    ],
    [
      [
        27548,
        46452
      ],
      [
        1,
        2
      ],
      [
        1,
        0
      ],
      [
        1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -7
      ],
      [
        1,
        -3
      ]
    ],
    [
      [
        27553,
        46440
      ],
      [
        -9,
        -60
      ],
      [
        -12,
        -78
      ],
      [
        -9,
        -82
      ],
      [
        -13,
        -57
      ],
      [
        -12,
        -36
      ],
      [
        -12,
        -54
      ],
      [
        -22,
        -85
      ],
      [
        -24,
        -66
      ],
      [
        -3,
        12
      ],
      [
        19,
        68
      ],
      [
        15,
        54
      ],
      [
        14,
        40
      ],
      [
        7,
        53
      ],
      [
        3,
        47
      ],
      [
        0,
        34
      ],
      [
        5,
        32
      ],
      [
        -6,
        23
      ],
      [
        -9,
        -11
      ]
    ],
    [
      [
        27414,
        45876
      ],
      [
        6,
        17
      ],
      [
        7,
        31
      ],
      [
        1,
        12
      ],
      [
        2,
        -11
      ],
      [
        3,
        -22
      ],
      [
        -5,
        -25
      ],
      [
        -9,
        -19
      ],
      [
        -5,
        17
      ]
    ],
    [
      [
        27386,
        45813
      ],
      [
        0,
        17
      ],
      [
        5,
        7
      ],
      [
        4,
        15
      ],
      [
        7,
        8
      ],
      [
        4,
        -4
      ],
      [
        -3,
        -19
      ],
      [
        0,
        -7
      ],
      [
        -2,
        -7
      ],
      [
        -7,
        -13
      ],
      [
        -7,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        27310,
        45701
      ],
      [
        11,
        20
      ],
      [
        12,
        22
      ],
      [
        15,
        19
      ],
      [
        14,
        29
      ],
      [
        8,
        -9
      ],
      [
        -2,
        -21
      ],
      [
        -30,
        -49
      ],
      [
        -15,
        -31
      ],
      [
        -8,
        -2
      ],
      [
        -5,
        22
      ]
    ],
    [
      [
        27214,
        46977
      ],
      [
        35,
        0
      ],
      [
        131,
        2
      ]
    ],
    [
      [
        27380,
        46979
      ],
      [
        0,
        -514
      ],
      [
        3,
        1
      ],
      [
        1,
        -141
      ],
      [
        0,
        -78
      ]
    ],
    [
      [
        27384,
        46247
      ],
      [
        -5,
        -2
      ],
      [
        -7,
        -15
      ],
      [
        0,
        -9
      ],
      [
        1,
        -7
      ],
      [
        -1,
        -10
      ],
      [
        -4,
        2
      ],
      [
        -8,
        -8
      ],
      [
        -4,
        2
      ],
      [
        -4,
        -2
      ],
      [
        -7,
        -12
      ],
      [
        -3,
        2
      ],
      [
        -4,
        4
      ],
      [
        -8,
        -1
      ],
      [
        -8,
        -11
      ],
      [
        -4,
        10
      ],
      [
        -5,
        21
      ],
      [
        -2,
        8
      ],
      [
        -4,
        5
      ],
      [
        -2,
        8
      ],
      [
        0,
        23
      ],
      [
        -1,
        12
      ],
      [
        -3,
        17
      ],
      [
        -4,
        16
      ],
      [
        0,
        28
      ],
      [
        1,
        8
      ],
      [
        1,
        43
      ],
      [
        1,
        10
      ],
      [
        2,
        8
      ],
      [
        1,
        15
      ],
      [
        -1,
        8
      ],
      [
        1,
        9
      ],
      [
        2,
        10
      ],
      [
        2,
        2
      ],
      [
        4,
        -5
      ],
      [
        1,
        8
      ],
      [
        0,
        11
      ],
      [
        -3,
        30
      ],
      [
        -4,
        1
      ],
      [
        -2,
        6
      ],
      [
        -1,
        14
      ],
      [
        1,
        6
      ],
      [
        1,
        4
      ],
      [
        -7,
        66
      ],
      [
        -3,
        13
      ],
      [
        -3,
        11
      ],
      [
        -5,
        23
      ],
      [
        0,
        14
      ],
      [
        2,
        20
      ],
      [
        0,
        6
      ],
      [
        -2,
        11
      ],
      [
        -4,
        12
      ],
      [
        -2,
        17
      ],
      [
        0,
        16
      ],
      [
        -3,
        14
      ],
      [
        -8,
        18
      ],
      [
        -1,
        27
      ],
      [
        -4,
        24
      ],
      [
        0,
        34
      ],
      [
        -6,
        18
      ],
      [
        -8,
        -12
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        16
      ],
      [
        0,
        29
      ],
      [
        -7,
        24
      ],
      [
        0,
        32
      ],
      [
        -9,
        8
      ],
      [
        -3,
        12
      ],
      [
        -12,
        11
      ]
    ],
    [
      [
        27118,
        45540
      ],
      [
        4,
        29
      ],
      [
        10,
        56
      ],
      [
        5,
        21
      ],
      [
        20,
        46
      ],
      [
        25,
        43
      ],
      [
        3,
        23
      ],
      [
        10,
        11
      ],
      [
        11,
        31
      ],
      [
        15,
        24
      ],
      [
        18,
        -36
      ],
      [
        15,
        -17
      ],
      [
        5,
        -14
      ],
      [
        4,
        -52
      ],
      [
        14,
        -43
      ],
      [
        -4,
        -11
      ],
      [
        -16,
        -20
      ],
      [
        -14,
        -19
      ],
      [
        -10,
        -9
      ],
      [
        -3,
        27
      ],
      [
        -9,
        -4
      ],
      [
        -10,
        3
      ],
      [
        -8,
        -4
      ],
      [
        -3,
        -24
      ],
      [
        -11,
        -14
      ],
      [
        -15,
        -28
      ],
      [
        -9,
        -12
      ],
      [
        -6,
        -2
      ],
      [
        -5,
        -17
      ],
      [
        -26,
        -10
      ],
      [
        -10,
        -5
      ],
      [
        0,
        27
      ]
    ],
    [
      [
        27062,
        45510
      ],
      [
        10,
        6
      ],
      [
        17,
        16
      ],
      [
        8,
        12
      ],
      [
        4,
        -10
      ],
      [
        -4,
        -14
      ],
      [
        -6,
        -29
      ],
      [
        -17,
        -14
      ],
      [
        -13,
        8
      ],
      [
        1,
        25
      ]
    ],
    [
      [
        27020,
        45533
      ],
      [
        4,
        15
      ],
      [
        2,
        20
      ],
      [
        2,
        4
      ],
      [
        3,
        1
      ],
      [
        6,
        -11
      ],
      [
        1,
        -4
      ],
      [
        0,
        -14
      ],
      [
        -1,
        -13
      ],
      [
        -4,
        -14
      ],
      [
        -12,
        -1
      ],
      [
        -1,
        4
      ],
      [
        0,
        13
      ]
    ],
    [
      [
        26806,
        45614
      ],
      [
        4,
        4
      ],
      [
        11,
        9
      ],
      [
        4,
        -23
      ],
      [
        -8,
        -15
      ],
      [
        -12,
        5
      ],
      [
        1,
        20
      ]
    ],
    [
      [
        26978,
        55163
      ],
      [
        7,
        61
      ],
      [
        5,
        58
      ],
      [
        -5,
        145
      ],
      [
        3,
        56
      ],
      [
        4,
        50
      ],
      [
        9,
        90
      ],
      [
        -2,
        1
      ],
      [
        -3,
        25
      ],
      [
        -5,
        16
      ]
    ],
    [
      [
        26991,
        55665
      ],
      [
        26,
        35
      ],
      [
        3,
        -1
      ],
      [
        1,
        -8
      ],
      [
        4,
        -8
      ],
      [
        6,
        -38
      ],
      [
        7,
        -21
      ],
      [
        11,
        13
      ],
      [
        4,
        -8
      ],
      [
        19,
        -10
      ],
      [
        12,
        30
      ],
      [
        14,
        10
      ],
      [
        9,
        -17
      ]
    ],
    [
      [
        27134,
        55585
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -10
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -8
      ],
      [
        0,
        -1
      ],
      [
        2,
        -11
      ],
      [
        0,
        -6
      ],
      [
        1,
        -7
      ],
      [
        2,
        -9
      ],
      [
        3,
        -12
      ],
      [
        6,
        -14
      ],
      [
        2,
        -6
      ],
      [
        3,
        -9
      ],
      [
        1,
        -1
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        4,
        -5
      ],
      [
        7,
        -11
      ],
      [
        3,
        -10
      ],
      [
        2,
        -1
      ],
      [
        1,
        -1
      ],
      [
        1,
        2
      ],
      [
        4,
        1
      ],
      [
        1,
        0
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        27193,
        55407
      ],
      [
        -62,
        -158
      ]
    ],
    [
      [
        27131,
        55249
      ],
      [
        -5,
        22
      ],
      [
        -20,
        29
      ],
      [
        -28,
        -35
      ],
      [
        -35,
        -8
      ],
      [
        -12,
        -38
      ],
      [
        -6,
        -75
      ],
      [
        0,
        -8
      ]
    ],
    [
      [
        26194,
        55065
      ],
      [
        3,
        -13
      ],
      [
        1,
        -12
      ],
      [
        -2,
        -17
      ],
      [
        2,
        -35
      ],
      [
        6,
        -18
      ],
      [
        1,
        -14
      ],
      [
        -4,
        -15
      ],
      [
        4,
        -26
      ],
      [
        2,
        -17
      ]
    ],
    [
      [
        26207,
        54898
      ],
      [
        4,
        -29
      ],
      [
        9,
        -35
      ],
      [
        4,
        -12
      ],
      [
        4,
        -22
      ],
      [
        1,
        -16
      ]
    ],
    [
      [
        26109,
        54667
      ],
      [
        0,
        23
      ],
      [
        -1,
        57
      ],
      [
        0,
        22
      ],
      [
        -14,
        0
      ],
      [
        -3,
        4
      ],
      [
        -31,
        54
      ],
      [
        -14,
        24
      ],
      [
        0,
        17
      ],
      [
        -10,
        0
      ],
      [
        0,
        16
      ]
    ],
    [
      [
        26036,
        54884
      ],
      [
        0,
        118
      ],
      [
        5,
        1
      ],
      [
        0,
        17
      ],
      [
        19,
        1
      ],
      [
        0,
        17
      ],
      [
        5,
        0
      ]
    ],
    [
      [
        22659,
        49740
      ],
      [
        69,
        -55
      ],
      [
        1,
        0
      ],
      [
        7,
        41
      ]
    ],
    [
      [
        22849,
        49420
      ],
      [
        0,
        -3
      ],
      [
        -2,
        -6
      ],
      [
        -3,
        -16
      ],
      [
        -9,
        -58
      ],
      [
        0,
        -8
      ],
      [
        -3,
        -2
      ],
      [
        -4,
        0
      ],
      [
        -3,
        2
      ],
      [
        -1,
        2
      ],
      [
        -1,
        4
      ],
      [
        0,
        4
      ],
      [
        1,
        7
      ],
      [
        -1,
        6
      ],
      [
        -2,
        6
      ],
      [
        -1,
        10
      ],
      [
        -1,
        9
      ],
      [
        -2,
        13
      ],
      [
        -6,
        6
      ],
      [
        -6,
        -4
      ],
      [
        -9,
        -12
      ],
      [
        -4,
        18
      ],
      [
        -11,
        -10
      ],
      [
        -21,
        -1
      ],
      [
        -11,
        12
      ],
      [
        -6,
        -16
      ],
      [
        0,
        -22
      ],
      [
        3,
        -8
      ]
    ],
    [
      [
        22746,
        49353
      ],
      [
        -8,
        4
      ],
      [
        -2,
        12
      ],
      [
        -9,
        3
      ],
      [
        -4,
        -6
      ],
      [
        -6,
        24
      ],
      [
        0,
        16
      ],
      [
        -6,
        4
      ],
      [
        1,
        -14
      ],
      [
        -3,
        -19
      ],
      [
        -10,
        20
      ],
      [
        1,
        12
      ],
      [
        -6,
        13
      ],
      [
        0,
        16
      ],
      [
        -5,
        6
      ],
      [
        -4,
        -8
      ],
      [
        -7,
        20
      ],
      [
        -3,
        -12
      ],
      [
        -1,
        18
      ],
      [
        -3,
        -1
      ],
      [
        -2,
        12
      ],
      [
        -7,
        -15
      ],
      [
        -1,
        27
      ],
      [
        -2,
        13
      ],
      [
        4,
        12
      ],
      [
        1,
        19
      ]
    ],
    [
      [
        22664,
        49529
      ],
      [
        3,
        21
      ],
      [
        -4,
        29
      ],
      [
        -10,
        -5
      ],
      [
        -8,
        8
      ],
      [
        -4,
        18
      ]
    ],
    [
      [
        22641,
        49600
      ],
      [
        -5,
        13
      ],
      [
        1,
        9
      ],
      [
        -3,
        19
      ],
      [
        3,
        9
      ],
      [
        -2,
        17
      ],
      [
        24,
        73
      ]
    ],
    [
      [
        23468,
        64172
      ],
      [
        5,
        0
      ],
      [
        20,
        -1
      ],
      [
        1,
        -1
      ],
      [
        13,
        0
      ],
      [
        16,
        -1
      ],
      [
        9,
        -1
      ],
      [
        14,
        0
      ]
    ],
    [
      [
        23554,
        63649
      ],
      [
        -122,
        5
      ]
    ],
    [
      [
        23432,
        63654
      ],
      [
        -6,
        24
      ],
      [
        1,
        25
      ],
      [
        -4,
        27
      ],
      [
        3,
        12
      ],
      [
        0,
        48
      ],
      [
        -2,
        16
      ],
      [
        -30,
        1
      ]
    ],
    [
      [
        13347,
        81071
      ],
      [
        9,
        23
      ],
      [
        5,
        -5
      ],
      [
        5,
        -23
      ],
      [
        -1,
        -7
      ],
      [
        -4,
        -17
      ],
      [
        1,
        -23
      ],
      [
        -1,
        -5
      ],
      [
        -6,
        2
      ],
      [
        -8,
        19
      ],
      [
        -2,
        13
      ],
      [
        2,
        23
      ]
    ],
    [
      [
        13279,
        80906
      ],
      [
        1,
        2
      ],
      [
        20,
        22
      ],
      [
        40,
        32
      ],
      [
        5,
        -2
      ],
      [
        1,
        -9
      ],
      [
        -4,
        -12
      ],
      [
        5,
        -57
      ],
      [
        2,
        -4
      ],
      [
        4,
        1
      ],
      [
        6,
        -7
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -9
      ],
      [
        -15,
        -50
      ],
      [
        -3,
        -9
      ],
      [
        -24,
        -1
      ],
      [
        -33,
        63
      ],
      [
        -6,
        21
      ],
      [
        2,
        23
      ]
    ],
    [
      [
        13241,
        80901
      ],
      [
        10,
        28
      ],
      [
        16,
        37
      ],
      [
        7,
        -8
      ],
      [
        1,
        -17
      ],
      [
        -6,
        -26
      ],
      [
        -8,
        -10
      ],
      [
        -5,
        -13
      ],
      [
        -7,
        -9
      ],
      [
        -8,
        18
      ]
    ],
    [
      [
        13172,
        81388
      ],
      [
        4,
        66
      ],
      [
        1,
        3
      ],
      [
        5,
        -2
      ],
      [
        6,
        -9
      ],
      [
        1,
        -2
      ],
      [
        0,
        -9
      ],
      [
        3,
        -7
      ],
      [
        10,
        -20
      ],
      [
        13,
        -37
      ],
      [
        8,
        -19
      ],
      [
        5,
        -7
      ],
      [
        6,
        -25
      ],
      [
        -3,
        -16
      ],
      [
        -9,
        -12
      ],
      [
        -1,
        -68
      ],
      [
        -7,
        -27
      ],
      [
        -8,
        -84
      ],
      [
        -14,
        40
      ],
      [
        -9,
        34
      ],
      [
        0,
        8
      ],
      [
        -6,
        88
      ],
      [
        -3,
        17
      ],
      [
        -2,
        88
      ]
    ],
    [
      [
        13390,
        82602
      ],
      [
        0,
        -1
      ],
      [
        5,
        -3
      ],
      [
        15,
        -7
      ],
      [
        37,
        -21
      ],
      [
        14,
        -7
      ],
      [
        6,
        -3
      ],
      [
        8,
        -5
      ],
      [
        11,
        -28
      ],
      [
        27,
        -72
      ],
      [
        6,
        -15
      ],
      [
        10,
        -9
      ],
      [
        13,
        -15
      ],
      [
        21,
        -9
      ],
      [
        11,
        -116
      ],
      [
        23,
        -15
      ],
      [
        27,
        -35
      ]
    ],
    [
      [
        13651,
        81856
      ],
      [
        0,
        -46
      ],
      [
        1,
        -14
      ],
      [
        5,
        -18
      ],
      [
        5,
        -20
      ],
      [
        -2,
        -49
      ],
      [
        -2,
        -44
      ],
      [
        -1,
        -25
      ],
      [
        2,
        -20
      ],
      [
        3,
        -22
      ],
      [
        4,
        -39
      ],
      [
        3,
        -23
      ],
      [
        11,
        -46
      ],
      [
        2,
        -27
      ],
      [
        2,
        -71
      ],
      [
        2,
        -35
      ],
      [
        9,
        -31
      ],
      [
        3,
        -11
      ],
      [
        0,
        -21
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        -3,
        -10
      ],
      [
        -2,
        -5
      ],
      [
        -8,
        -21
      ],
      [
        -3,
        -13
      ],
      [
        -7,
        -18
      ],
      [
        -3,
        -14
      ],
      [
        -5,
        -12
      ],
      [
        -2,
        -10
      ],
      [
        -4,
        -15
      ],
      [
        -5,
        -21
      ],
      [
        -3,
        -14
      ],
      [
        -2,
        -25
      ],
      [
        -1,
        -9
      ],
      [
        -3,
        -14
      ],
      [
        -4,
        -14
      ],
      [
        0,
        -16
      ],
      [
        -1,
        -17
      ],
      [
        -7,
        -28
      ],
      [
        -3,
        -17
      ],
      [
        -3,
        -12
      ],
      [
        -3,
        -10
      ],
      [
        -1,
        -6
      ],
      [
        -3,
        -17
      ],
      [
        -5,
        -17
      ],
      [
        -9,
        -29
      ],
      [
        -9,
        -31
      ],
      [
        -19,
        -47
      ],
      [
        -18,
        -50
      ],
      [
        -27,
        -55
      ],
      [
        -13,
        -11
      ],
      [
        -6,
        -3
      ],
      [
        -5,
        -20
      ],
      [
        8,
        -26
      ],
      [
        -5,
        -3
      ],
      [
        -11,
        -19
      ],
      [
        0,
        -4
      ],
      [
        -3,
        3
      ],
      [
        -12,
        40
      ],
      [
        -2,
        22
      ],
      [
        3,
        8
      ],
      [
        1,
        4
      ],
      [
        -1,
        14
      ],
      [
        -2,
        8
      ],
      [
        -9,
        22
      ],
      [
        -4,
        2
      ],
      [
        0,
        -32
      ],
      [
        -1,
        -12
      ],
      [
        -4,
        -9
      ],
      [
        -8,
        -13
      ],
      [
        -5,
        1
      ],
      [
        -4,
        3
      ],
      [
        -9,
        14
      ],
      [
        -4,
        10
      ],
      [
        -5,
        20
      ],
      [
        -4,
        22
      ],
      [
        2,
        18
      ],
      [
        -2,
        53
      ],
      [
        -4,
        37
      ],
      [
        0,
        17
      ],
      [
        3,
        40
      ],
      [
        -1,
        5
      ],
      [
        -6,
        3
      ],
      [
        -9,
        19
      ],
      [
        -1,
        6
      ],
      [
        2,
        39
      ],
      [
        5,
        42
      ],
      [
        1,
        4
      ],
      [
        0,
        18
      ],
      [
        -9,
        6
      ],
      [
        -4,
        11
      ],
      [
        -6,
        22
      ],
      [
        -6,
        23
      ],
      [
        -1,
        10
      ],
      [
        -3,
        14
      ],
      [
        0,
        5
      ],
      [
        -2,
        33
      ],
      [
        0,
        2
      ],
      [
        30,
        63
      ],
      [
        9,
        30
      ],
      [
        1,
        22
      ],
      [
        7,
        11
      ],
      [
        4,
        -1
      ],
      [
        11,
        -7
      ],
      [
        2,
        5
      ],
      [
        0,
        13
      ],
      [
        -2,
        5
      ],
      [
        -3,
        52
      ],
      [
        -11,
        82
      ],
      [
        0,
        20
      ],
      [
        3,
        16
      ],
      [
        4,
        12
      ],
      [
        4,
        29
      ],
      [
        3,
        45
      ],
      [
        -2,
        76
      ],
      [
        -7,
        114
      ],
      [
        -10,
        67
      ],
      [
        -13,
        52
      ],
      [
        -30,
        112
      ],
      [
        -22,
        55
      ],
      [
        -4,
        15
      ],
      [
        -8,
        33
      ],
      [
        -4,
        0
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -10
      ],
      [
        0,
        -9
      ],
      [
        1,
        -13
      ],
      [
        23,
        -62
      ],
      [
        25,
        -85
      ],
      [
        4,
        -33
      ],
      [
        3,
        -39
      ],
      [
        1,
        -4
      ],
      [
        12,
        -46
      ],
      [
        9,
        -40
      ],
      [
        5,
        -45
      ],
      [
        5,
        -86
      ],
      [
        -5,
        -22
      ],
      [
        -9,
        -8
      ],
      [
        -2,
        -13
      ],
      [
        -2,
        -79
      ],
      [
        7,
        -92
      ],
      [
        6,
        -14
      ],
      [
        5,
        -48
      ],
      [
        -1,
        -9
      ],
      [
        -4,
        -11
      ],
      [
        -4,
        -8
      ],
      [
        -2,
        1
      ],
      [
        1,
        19
      ],
      [
        -10,
        76
      ],
      [
        -2,
        8
      ],
      [
        -6,
        4
      ],
      [
        -1,
        -18
      ],
      [
        0,
        -16
      ],
      [
        1,
        -3
      ],
      [
        1,
        -6
      ],
      [
        2,
        -27
      ],
      [
        -4,
        -74
      ],
      [
        -11,
        -36
      ],
      [
        -25,
        -66
      ],
      [
        -7,
        -5
      ],
      [
        -7,
        0
      ],
      [
        -6,
        6
      ],
      [
        -8,
        12
      ],
      [
        -10,
        31
      ],
      [
        -1,
        18
      ],
      [
        7,
        12
      ],
      [
        10,
        31
      ],
      [
        3,
        12
      ],
      [
        11,
        73
      ],
      [
        0,
        9
      ],
      [
        -2,
        27
      ],
      [
        -1,
        2
      ],
      [
        -20,
        -6
      ],
      [
        -5,
        -4
      ],
      [
        0,
        -7
      ],
      [
        1,
        -23
      ],
      [
        6,
        -15
      ],
      [
        3,
        -19
      ],
      [
        0,
        -8
      ],
      [
        -8,
        -42
      ],
      [
        -2,
        -5
      ],
      [
        -10,
        -19
      ],
      [
        -21,
        -32
      ],
      [
        -6,
        1
      ],
      [
        -1,
        0
      ],
      [
        -3,
        11
      ],
      [
        -2,
        18
      ],
      [
        -5,
        22
      ],
      [
        -3,
        24
      ],
      [
        3,
        11
      ],
      [
        -2,
        12
      ],
      [
        -7,
        10
      ],
      [
        -4,
        0
      ],
      [
        -1,
        -5
      ],
      [
        -4,
        -38
      ],
      [
        -2,
        -3
      ],
      [
        -4,
        1
      ],
      [
        -5,
        15
      ],
      [
        -5,
        4
      ],
      [
        -15,
        35
      ],
      [
        -17,
        18
      ],
      [
        -9,
        26
      ],
      [
        -1,
        5
      ],
      [
        0,
        12
      ],
      [
        -2,
        7
      ],
      [
        -24,
        55
      ],
      [
        -4,
        13
      ],
      [
        0,
        76
      ],
      [
        1,
        6
      ],
      [
        13,
        17
      ],
      [
        8,
        -2
      ],
      [
        9,
        10
      ],
      [
        19,
        39
      ],
      [
        3,
        12
      ],
      [
        -5,
        17
      ],
      [
        -3,
        4
      ],
      [
        -5,
        4
      ],
      [
        -7,
        22
      ],
      [
        0,
        10
      ],
      [
        2,
        11
      ],
      [
        2,
        18
      ],
      [
        3,
        36
      ],
      [
        -2,
        11
      ],
      [
        -5,
        17
      ],
      [
        -2,
        11
      ],
      [
        4,
        22
      ],
      [
        4,
        7
      ],
      [
        15,
        15
      ],
      [
        3,
        20
      ],
      [
        0,
        4
      ],
      [
        -4,
        8
      ],
      [
        -7,
        5
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        1
      ],
      [
        -2,
        20
      ],
      [
        -1,
        54
      ],
      [
        4,
        9
      ],
      [
        3,
        17
      ],
      [
        1,
        13
      ],
      [
        -1,
        4
      ],
      [
        -9,
        5
      ],
      [
        -15,
        -18
      ],
      [
        -15,
        -2
      ],
      [
        -2,
        -2
      ],
      [
        2,
        -22
      ],
      [
        4,
        -23
      ],
      [
        11,
        -16
      ],
      [
        1,
        -15
      ],
      [
        -2,
        -22
      ],
      [
        -10,
        -70
      ],
      [
        -3,
        -15
      ],
      [
        -1,
        -43
      ],
      [
        0,
        -17
      ],
      [
        -10,
        -42
      ],
      [
        -9,
        -31
      ],
      [
        -12,
        23
      ],
      [
        -6,
        -10
      ],
      [
        0,
        -8
      ],
      [
        5,
        -42
      ],
      [
        2,
        -43
      ],
      [
        -10,
        -43
      ],
      [
        -4,
        2
      ],
      [
        -8,
        17
      ],
      [
        -8,
        24
      ],
      [
        -4,
        9
      ],
      [
        -11,
        8
      ],
      [
        -4,
        1
      ],
      [
        -8,
        9
      ],
      [
        -2,
        4
      ],
      [
        -9,
        30
      ],
      [
        -5,
        32
      ],
      [
        -1,
        13
      ],
      [
        1,
        8
      ]
    ],
    [
      [
        10628,
        87240
      ],
      [
        0,
        -100
      ],
      [
        130,
        -95
      ],
      [
        17,
        100
      ],
      [
        135,
        -145
      ],
      [
        69,
        155
      ],
      [
        12,
        25
      ],
      [
        170,
        20
      ],
      [
        1,
        -39
      ],
      [
        -33,
        -272
      ],
      [
        39,
        -92
      ],
      [
        1,
        -5
      ],
      [
        1,
        -6
      ],
      [
        2,
        -4
      ],
      [
        4,
        -5
      ],
      [
        66,
        -76
      ],
      [
        26,
        -22
      ],
      [
        11,
        -112
      ],
      [
        0,
        -4
      ],
      [
        6,
        -21
      ],
      [
        3,
        -12
      ],
      [
        3,
        -13
      ],
      [
        10,
        -21
      ],
      [
        7,
        -13
      ],
      [
        156,
        -337
      ],
      [
        110,
        -243
      ],
      [
        28,
        -281
      ],
      [
        2,
        -18
      ],
      [
        -8,
        -90
      ]
    ],
    [
      [
        11480,
        85398
      ],
      [
        1,
        5
      ],
      [
        2,
        7
      ],
      [
        1,
        9
      ],
      [
        1,
        19
      ],
      [
        -2,
        29
      ],
      [
        -6,
        20
      ],
      [
        -9,
        28
      ],
      [
        -23,
        55
      ],
      [
        -19,
        37
      ],
      [
        -11,
        17
      ],
      [
        -2,
        12
      ],
      [
        -12,
        21
      ],
      [
        -18,
        26
      ],
      [
        -96,
        89
      ],
      [
        -20,
        37
      ],
      [
        -16,
        34
      ],
      [
        -23,
        39
      ],
      [
        -20,
        27
      ],
      [
        -35,
        37
      ],
      [
        -63,
        67
      ],
      [
        -20,
        22
      ],
      [
        -22,
        27
      ],
      [
        -33,
        50
      ],
      [
        -16,
        26
      ],
      [
        -42,
        68
      ],
      [
        -30,
        39
      ],
      [
        -2,
        8
      ],
      [
        0,
        3
      ],
      [
        4,
        13
      ],
      [
        3,
        5
      ],
      [
        8,
        -9
      ],
      [
        7,
        11
      ],
      [
        -3,
        13
      ],
      [
        -1,
        12
      ],
      [
        8,
        17
      ],
      [
        12,
        45
      ],
      [
        20,
        -9
      ],
      [
        4,
        -5
      ],
      [
        -3,
        -9
      ],
      [
        -6,
        -3
      ],
      [
        -1,
        -6
      ],
      [
        1,
        -9
      ],
      [
        5,
        -6
      ],
      [
        9,
        -2
      ],
      [
        2,
        1
      ],
      [
        8,
        10
      ],
      [
        1,
        4
      ],
      [
        0,
        5
      ],
      [
        -2,
        6
      ],
      [
        -1,
        7
      ],
      [
        2,
        21
      ],
      [
        19,
        52
      ],
      [
        2,
        18
      ],
      [
        -6,
        4
      ],
      [
        -5,
        -4
      ],
      [
        -11,
        7
      ],
      [
        -2,
        11
      ],
      [
        3,
        9
      ],
      [
        2,
        10
      ],
      [
        -1,
        47
      ],
      [
        -4,
        37
      ],
      [
        -7,
        39
      ],
      [
        -3,
        40
      ],
      [
        2,
        34
      ],
      [
        5,
        1
      ],
      [
        8,
        16
      ],
      [
        12,
        20
      ],
      [
        2,
        5
      ],
      [
        -1,
        24
      ],
      [
        -4,
        10
      ],
      [
        4,
        6
      ],
      [
        7,
        13
      ],
      [
        5,
        11
      ],
      [
        -9,
        30
      ],
      [
        -4,
        26
      ],
      [
        -7,
        -2
      ],
      [
        -1,
        -16
      ],
      [
        -6,
        -27
      ],
      [
        -5,
        -6
      ],
      [
        -1,
        -36
      ],
      [
        -1,
        -23
      ],
      [
        -6,
        -6
      ],
      [
        -8,
        -12
      ],
      [
        -11,
        -3
      ],
      [
        -6,
        -21
      ],
      [
        -9,
        -29
      ],
      [
        -6,
        -22
      ],
      [
        1,
        -27
      ],
      [
        -2,
        -22
      ],
      [
        -18,
        -22
      ],
      [
        -23,
        -18
      ],
      [
        -19,
        -18
      ],
      [
        -24,
        -24
      ],
      [
        -23,
        -18
      ],
      [
        -6,
        -10
      ],
      [
        -6,
        -18
      ],
      [
        -13,
        -17
      ],
      [
        -15,
        -11
      ],
      [
        -20,
        6
      ],
      [
        -47,
        11
      ],
      [
        -14,
        5
      ],
      [
        -14,
        0
      ],
      [
        -40,
        20
      ],
      [
        -27,
        16
      ],
      [
        -26,
        32
      ],
      [
        -49,
        51
      ],
      [
        -16,
        16
      ],
      [
        -58,
        58
      ],
      [
        -12,
        25
      ],
      [
        -5,
        31
      ],
      [
        4,
        2
      ],
      [
        14,
        -12
      ],
      [
        34,
        24
      ],
      [
        2,
        35
      ],
      [
        9,
        36
      ],
      [
        -7,
        20
      ],
      [
        -2,
        22
      ],
      [
        -24,
        89
      ],
      [
        3,
        42
      ],
      [
        -4,
        14
      ],
      [
        -6,
        -4
      ],
      [
        -10,
        -27
      ],
      [
        -21,
        35
      ],
      [
        -10,
        9
      ],
      [
        -1,
        -19
      ],
      [
        7,
        -31
      ],
      [
        17,
        -51
      ],
      [
        19,
        -35
      ],
      [
        9,
        -34
      ],
      [
        -10,
        -21
      ],
      [
        -36,
        -33
      ],
      [
        -18,
        -18
      ],
      [
        -39,
        0
      ],
      [
        -37,
        43
      ],
      [
        -12,
        12
      ],
      [
        -15,
        11
      ],
      [
        -9,
        4
      ],
      [
        -18,
        2
      ],
      [
        -10,
        3
      ],
      [
        -9,
        4
      ],
      [
        -32,
        23
      ],
      [
        -81,
        40
      ],
      [
        -15,
        5
      ],
      [
        -30,
        6
      ],
      [
        -31,
        2
      ],
      [
        -18,
        -4
      ],
      [
        -10,
        -2
      ],
      [
        -44,
        -25
      ],
      [
        -19,
        -8
      ],
      [
        -16,
        0
      ],
      [
        -61,
        -12
      ],
      [
        -59,
        -17
      ],
      [
        -21,
        -11
      ],
      [
        -54,
        -48
      ]
    ],
    [
      [
        26285,
        64350
      ],
      [
        0,
        -181
      ]
    ],
    [
      [
        21170,
        62382
      ],
      [
        122,
        3
      ],
      [
        2,
        -1
      ],
      [
        187,
        9
      ]
    ],
    [
      [
        21481,
        61891
      ],
      [
        -6,
        0
      ],
      [
        -277,
        -1
      ],
      [
        -31,
        -3
      ]
    ],
    [
      [
        21167,
        61887
      ],
      [
        0,
        91
      ],
      [
        2,
        0
      ],
      [
        1,
        404
      ]
    ],
    [
      [
        26535,
        59335
      ],
      [
        6,
        2
      ],
      [
        6,
        15
      ],
      [
        6,
        -6
      ],
      [
        2,
        -11
      ],
      [
        8,
        19
      ],
      [
        3,
        -15
      ],
      [
        0,
        -12
      ],
      [
        8,
        -16
      ],
      [
        6,
        -34
      ],
      [
        0,
        -18
      ],
      [
        3,
        -11
      ],
      [
        6,
        1
      ],
      [
        4,
        23
      ],
      [
        8,
        -25
      ]
    ],
    [
      [
        26583,
        59038
      ],
      [
        -15,
        2
      ],
      [
        -33,
        3
      ],
      [
        0,
        -9
      ],
      [
        -3,
        9
      ],
      [
        -2,
        1
      ],
      [
        -5,
        19
      ]
    ],
    [
      [
        25412,
        64068
      ],
      [
        114,
        6
      ]
    ],
    [
      [
        25526,
        64058
      ],
      [
        0,
        -17
      ],
      [
        -1,
        -247
      ],
      [
        0,
        -119
      ]
    ],
    [
      [
        25412,
        63363
      ],
      [
        -1,
        237
      ],
      [
        0,
        68
      ],
      [
        -1,
        97
      ],
      [
        4,
        0
      ],
      [
        0,
        52
      ],
      [
        -1,
        151
      ]
    ],
    [
      [
        15663,
        72891
      ],
      [
        -6,
        0
      ],
      [
        0,
        -231
      ],
      [
        -155,
        0
      ],
      [
        0,
        17
      ],
      [
        -242,
        0
      ],
      [
        -18,
        2
      ],
      [
        -48,
        -3
      ]
    ],
    [
      [
        15194,
        72676
      ],
      [
        -4,
        9
      ],
      [
        -1,
        5
      ],
      [
        0,
        5
      ],
      [
        -4,
        45
      ],
      [
        -2,
        9
      ],
      [
        -3,
        10
      ],
      [
        -3,
        15
      ],
      [
        1,
        21
      ],
      [
        -3,
        38
      ],
      [
        -1,
        24
      ],
      [
        -1,
        15
      ],
      [
        0,
        7
      ],
      [
        -2,
        4
      ],
      [
        -1,
        13
      ],
      [
        1,
        21
      ],
      [
        2,
        6
      ],
      [
        0,
        7
      ],
      [
        -2,
        19
      ],
      [
        -8,
        44
      ],
      [
        -2,
        9
      ],
      [
        -1,
        3
      ],
      [
        1,
        8
      ],
      [
        7,
        17
      ],
      [
        2,
        16
      ],
      [
        2,
        17
      ],
      [
        0,
        8
      ],
      [
        -4,
        22
      ],
      [
        0,
        1
      ],
      [
        1,
        7
      ],
      [
        5,
        11
      ],
      [
        1,
        12
      ],
      [
        1,
        35
      ],
      [
        2,
        1
      ],
      [
        1,
        4
      ],
      [
        1,
        13
      ],
      [
        1,
        24
      ],
      [
        -3,
        11
      ],
      [
        -8,
        10
      ],
      [
        -4,
        20
      ],
      [
        -4,
        5
      ],
      [
        -1,
        6
      ],
      [
        0,
        6
      ],
      [
        1,
        5
      ],
      [
        3,
        5
      ],
      [
        6,
        -1
      ],
      [
        11,
        2
      ],
      [
        4,
        -6
      ],
      [
        3,
        -11
      ],
      [
        2,
        -8
      ],
      [
        3,
        -3
      ],
      [
        3,
        4
      ],
      [
        3,
        4
      ],
      [
        5,
        -9
      ],
      [
        2,
        2
      ],
      [
        5,
        -16
      ],
      [
        2,
        -5
      ],
      [
        4,
        -1
      ],
      [
        4,
        -6
      ],
      [
        27,
        -50
      ],
      [
        5,
        -14
      ],
      [
        4,
        -4
      ],
      [
        6,
        3
      ],
      [
        5,
        -12
      ],
      [
        12,
        -11
      ],
      [
        1,
        -6
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        7,
        -6
      ],
      [
        1,
        1
      ],
      [
        3,
        5
      ],
      [
        1,
        2
      ],
      [
        1,
        4
      ],
      [
        3,
        -2
      ],
      [
        6,
        -11
      ],
      [
        7,
        -8
      ],
      [
        14,
        -22
      ],
      [
        8,
        -8
      ],
      [
        3,
        -4
      ],
      [
        -1,
        -20
      ],
      [
        4,
        -4
      ],
      [
        5,
        -8
      ],
      [
        6,
        -14
      ],
      [
        20,
        -15
      ],
      [
        7,
        1
      ],
      [
        6,
        -6
      ],
      [
        5,
        -1
      ],
      [
        10,
        1
      ],
      [
        4,
        -7
      ],
      [
        2,
        0
      ],
      [
        7,
        4
      ],
      [
        15,
        -3
      ],
      [
        6,
        7
      ],
      [
        8,
        2
      ],
      [
        0,
        -3
      ],
      [
        1,
        -2
      ],
      [
        2,
        0
      ],
      [
        3,
        5
      ],
      [
        0,
        3
      ],
      [
        1,
        1
      ],
      [
        9,
        -4
      ],
      [
        6,
        -7
      ],
      [
        4,
        -8
      ],
      [
        -2,
        -5
      ],
      [
        4,
        -8
      ],
      [
        10,
        -5
      ],
      [
        5,
        7
      ],
      [
        4,
        12
      ],
      [
        2,
        0
      ],
      [
        5,
        -6
      ],
      [
        3,
        -12
      ],
      [
        5,
        -4
      ],
      [
        9,
        2
      ],
      [
        5,
        7
      ],
      [
        4,
        2
      ],
      [
        1,
        0
      ],
      [
        -1,
        -20
      ],
      [
        5,
        -7
      ],
      [
        8,
        -5
      ],
      [
        9,
        2
      ],
      [
        8,
        -3
      ],
      [
        5,
        1
      ],
      [
        8,
        8
      ],
      [
        2,
        -4
      ],
      [
        3,
        -2
      ],
      [
        6,
        0
      ],
      [
        2,
        3
      ],
      [
        6,
        10
      ],
      [
        8,
        20
      ],
      [
        7,
        25
      ],
      [
        6,
        12
      ],
      [
        3,
        1
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -10
      ],
      [
        -1,
        -12
      ],
      [
        3,
        -4
      ],
      [
        2,
        1
      ],
      [
        3,
        -4
      ],
      [
        8,
        -27
      ],
      [
        6,
        -8
      ],
      [
        4,
        -20
      ],
      [
        3,
        -25
      ],
      [
        6,
        5
      ],
      [
        4,
        6
      ],
      [
        7,
        6
      ],
      [
        9,
        3
      ],
      [
        5,
        -3
      ],
      [
        3,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -17
      ],
      [
        0,
        -10
      ]
    ],
    [
      [
        15266,
        72272
      ],
      [
        85,
        0
      ],
      [
        0,
        -17
      ],
      [
        151,
        -1
      ]
    ],
    [
      [
        15502,
        72254
      ],
      [
        0,
        -302
      ],
      [
        4,
        0
      ],
      [
        1,
        -205
      ],
      [
        33,
        0
      ],
      [
        47,
        3
      ]
    ],
    [
      [
        15587,
        71750
      ],
      [
        0,
        -87
      ],
      [
        -1,
        -15
      ],
      [
        13,
        -2
      ],
      [
        -1,
        -184
      ],
      [
        0,
        -51
      ]
    ],
    [
      [
        15337,
        71411
      ],
      [
        -1,
        20
      ],
      [
        -2,
        30
      ],
      [
        -4,
        50
      ],
      [
        -4,
        30
      ],
      [
        6,
        8
      ],
      [
        2,
        0
      ],
      [
        4,
        -13
      ],
      [
        1,
        -7
      ],
      [
        1,
        -32
      ],
      [
        4,
        -7
      ],
      [
        2,
        2
      ],
      [
        1,
        2
      ],
      [
        2,
        6
      ],
      [
        2,
        24
      ],
      [
        0,
        4
      ],
      [
        3,
        5
      ],
      [
        7,
        6
      ],
      [
        1,
        8
      ],
      [
        7,
        13
      ],
      [
        1,
        1
      ],
      [
        6,
        -2
      ],
      [
        12,
        14
      ],
      [
        9,
        8
      ],
      [
        6,
        10
      ],
      [
        -1,
        4
      ],
      [
        -3,
        11
      ],
      [
        -4,
        9
      ],
      [
        -2,
        3
      ],
      [
        -7,
        0
      ],
      [
        -5,
        -2
      ],
      [
        -2,
        2
      ],
      [
        -3,
        12
      ],
      [
        -9,
        -2
      ],
      [
        -6,
        6
      ],
      [
        -2,
        7
      ],
      [
        3,
        8
      ],
      [
        1,
        7
      ],
      [
        -3,
        9
      ],
      [
        0,
        3
      ],
      [
        -3,
        18
      ],
      [
        -11,
        13
      ],
      [
        -11,
        2
      ],
      [
        -5,
        -1
      ],
      [
        -5,
        -8
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -9
      ],
      [
        3,
        -38
      ],
      [
        1,
        -21
      ],
      [
        4,
        -31
      ],
      [
        -5,
        -4
      ],
      [
        -5,
        -13
      ],
      [
        -6,
        -4
      ],
      [
        2,
        18
      ],
      [
        1,
        20
      ],
      [
        0,
        42
      ],
      [
        -1,
        83
      ],
      [
        -1,
        31
      ],
      [
        -2,
        37
      ],
      [
        0,
        13
      ],
      [
        -1,
        13
      ],
      [
        -2,
        32
      ],
      [
        -4,
        51
      ],
      [
        -7,
        80
      ],
      [
        -2,
        10
      ],
      [
        -3,
        8
      ],
      [
        -1,
        2
      ],
      [
        -4,
        1
      ],
      [
        -4,
        24
      ],
      [
        -2,
        16
      ],
      [
        -2,
        11
      ],
      [
        -2,
        4
      ],
      [
        -4,
        4
      ],
      [
        -1,
        14
      ],
      [
        -1,
        25
      ],
      [
        -2,
        31
      ],
      [
        -3,
        85
      ],
      [
        -2,
        52
      ]
    ],
    [
      [
        27155,
        52003
      ],
      [
        8,
        0
      ],
      [
        8,
        15
      ],
      [
        12,
        -9
      ],
      [
        3,
        -10
      ],
      [
        8,
        3
      ],
      [
        0,
        -19
      ],
      [
        30,
        2
      ],
      [
        -1,
        171
      ],
      [
        16,
        0
      ]
    ],
    [
      [
        27239,
        52156
      ],
      [
        6,
        -105
      ],
      [
        13,
        -225
      ],
      [
        4,
        -47
      ],
      [
        2,
        -16
      ],
      [
        3,
        -17
      ],
      [
        2,
        -20
      ],
      [
        2,
        -29
      ],
      [
        0,
        -51
      ],
      [
        2,
        -35
      ],
      [
        4,
        -53
      ],
      [
        4,
        -28
      ],
      [
        4,
        -51
      ]
    ],
    [
      [
        27199,
        51422
      ],
      [
        -1,
        116
      ],
      [
        0,
        44
      ],
      [
        -4,
        12
      ],
      [
        -7,
        39
      ],
      [
        -4,
        43
      ]
    ],
    [
      [
        15663,
        72891
      ],
      [
        0,
        -1
      ],
      [
        3,
        -7
      ],
      [
        11,
        -13
      ],
      [
        5,
        -30
      ],
      [
        -4,
        -29
      ],
      [
        7,
        -1
      ],
      [
        3,
        7
      ],
      [
        2,
        21
      ],
      [
        1,
        32
      ],
      [
        -6,
        8
      ],
      [
        -2,
        14
      ],
      [
        -6,
        12
      ],
      [
        -1,
        28
      ],
      [
        1,
        12
      ],
      [
        12,
        28
      ],
      [
        14,
        10
      ],
      [
        7,
        0
      ],
      [
        3,
        -31
      ],
      [
        -7,
        -11
      ],
      [
        -1,
        -1
      ],
      [
        -4,
        -11
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -6
      ],
      [
        9,
        -40
      ],
      [
        0,
        -6
      ],
      [
        1,
        -4
      ],
      [
        7,
        6
      ],
      [
        0,
        5
      ],
      [
        1,
        18
      ],
      [
        -1,
        2
      ],
      [
        -2,
        0
      ],
      [
        0,
        1
      ],
      [
        4,
        22
      ],
      [
        4,
        8
      ],
      [
        6,
        6
      ],
      [
        3,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -11
      ],
      [
        3,
        -52
      ],
      [
        1,
        -8
      ],
      [
        2,
        -5
      ],
      [
        0,
        -17
      ],
      [
        -5,
        -10
      ],
      [
        -1,
        0
      ],
      [
        -2,
        8
      ],
      [
        -1,
        1
      ],
      [
        -6,
        -9
      ],
      [
        2,
        -24
      ],
      [
        4,
        -17
      ],
      [
        5,
        -1
      ],
      [
        1,
        -5
      ],
      [
        1,
        -11
      ],
      [
        -2,
        -17
      ],
      [
        0,
        -5
      ],
      [
        1,
        -4
      ],
      [
        5,
        -7
      ],
      [
        1,
        1
      ],
      [
        2,
        -12
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -12
      ],
      [
        2,
        -12
      ],
      [
        3,
        -6
      ],
      [
        5,
        0
      ],
      [
        3,
        -3
      ],
      [
        -6,
        -15
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -3
      ],
      [
        -4,
        -2
      ],
      [
        -4,
        4
      ],
      [
        -8,
        0
      ],
      [
        1,
        -9
      ],
      [
        3,
        -11
      ],
      [
        -1,
        -14
      ],
      [
        -1,
        -8
      ],
      [
        -9,
        -22
      ],
      [
        -3,
        -3
      ],
      [
        -5,
        -11
      ],
      [
        0,
        -31
      ],
      [
        -3,
        -19
      ],
      [
        0,
        -13
      ],
      [
        -6,
        -50
      ],
      [
        -9,
        -28
      ],
      [
        -5,
        19
      ],
      [
        11,
        113
      ],
      [
        -6,
        55
      ],
      [
        -2,
        -5
      ],
      [
        2,
        -33
      ],
      [
        -9,
        -35
      ],
      [
        -10,
        -66
      ],
      [
        -4,
        -53
      ],
      [
        -21,
        -70
      ],
      [
        -2,
        -10
      ]
    ],
    [
      [
        15649,
        72357
      ],
      [
        -108,
        1
      ],
      [
        -39,
        -3
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        15266,
        72272
      ],
      [
        -1,
        14
      ],
      [
        -1,
        3
      ],
      [
        -2,
        40
      ],
      [
        -1,
        20
      ],
      [
        -1,
        5
      ],
      [
        -2,
        33
      ],
      [
        -4,
        39
      ],
      [
        -4,
        30
      ],
      [
        -3,
        39
      ],
      [
        -1,
        16
      ],
      [
        -2,
        9
      ],
      [
        -6,
        22
      ],
      [
        -5,
        2
      ],
      [
        -1,
        3
      ],
      [
        -2,
        32
      ],
      [
        -2,
        23
      ],
      [
        -2,
        7
      ],
      [
        -3,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -8,
        16
      ],
      [
        -5,
        22
      ],
      [
        0,
        9
      ],
      [
        -1,
        3
      ],
      [
        -7,
        14
      ],
      [
        -6,
        2
      ],
      [
        -1,
        1
      ]
    ],
    [
      [
        15797,
        61013
      ],
      [
        2,
        8
      ],
      [
        3,
        5
      ],
      [
        2,
        -3
      ],
      [
        1,
        -9
      ],
      [
        0,
        -11
      ],
      [
        -4,
        0
      ],
      [
        -3,
        3
      ],
      [
        -1,
        7
      ]
    ],
    [
      [
        15785,
        61302
      ],
      [
        0,
        -15
      ],
      [
        1,
        -8
      ],
      [
        1,
        -21
      ],
      [
        -3,
        -18
      ],
      [
        -2,
        -28
      ],
      [
        1,
        -15
      ],
      [
        1,
        -5
      ],
      [
        3,
        -9
      ],
      [
        6,
        -5
      ],
      [
        2,
        -8
      ],
      [
        2,
        -9
      ],
      [
        0,
        -4
      ],
      [
        -3,
        -7
      ],
      [
        -1,
        3
      ],
      [
        -3,
        0
      ],
      [
        -5,
        -17
      ],
      [
        0,
        -9
      ],
      [
        1,
        -12
      ],
      [
        2,
        -4
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -4
      ],
      [
        -4,
        2
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -9
      ],
      [
        3,
        -8
      ],
      [
        2,
        0
      ],
      [
        2,
        -4
      ],
      [
        2,
        -10
      ],
      [
        0,
        -9
      ],
      [
        4,
        -10
      ],
      [
        3,
        -1
      ],
      [
        2,
        -11
      ],
      [
        1,
        -3
      ],
      [
        -4,
        -11
      ],
      [
        -3,
        -3
      ],
      [
        -6,
        25
      ],
      [
        -5,
        4
      ],
      [
        1,
        -27
      ],
      [
        4,
        -8
      ],
      [
        2,
        -36
      ],
      [
        -1,
        -9
      ],
      [
        -1,
        2
      ],
      [
        -6,
        -6
      ],
      [
        -7,
        -3
      ],
      [
        -2,
        13
      ],
      [
        -3,
        7
      ],
      [
        -4,
        18
      ],
      [
        -6,
        9
      ],
      [
        -5,
        18
      ],
      [
        -7,
        13
      ],
      [
        -4,
        13
      ],
      [
        -4,
        8
      ],
      [
        -6,
        3
      ],
      [
        -1,
        0
      ],
      [
        -4,
        -7
      ],
      [
        -2,
        -8
      ],
      [
        -7,
        12
      ],
      [
        -2,
        19
      ],
      [
        -1,
        6
      ],
      [
        -5,
        11
      ],
      [
        -3,
        3
      ],
      [
        -5,
        16
      ],
      [
        -2,
        21
      ],
      [
        -2,
        8
      ],
      [
        -6,
        24
      ],
      [
        -10,
        23
      ],
      [
        -7,
        10
      ],
      [
        -16,
        8
      ],
      [
        -5,
        -4
      ],
      [
        -4,
        -10
      ],
      [
        -3,
        -13
      ],
      [
        0,
        -6
      ],
      [
        1,
        -4
      ],
      [
        0,
        -6
      ],
      [
        1,
        -3
      ],
      [
        -14,
        3
      ],
      [
        1,
        5
      ],
      [
        1,
        2
      ],
      [
        2,
        3
      ],
      [
        5,
        44
      ],
      [
        9,
        83
      ],
      [
        2,
        30
      ],
      [
        1,
        18
      ],
      [
        0,
        11
      ],
      [
        -1,
        14
      ],
      [
        -3,
        13
      ],
      [
        -1,
        14
      ],
      [
        0,
        4
      ],
      [
        -7,
        36
      ],
      [
        0,
        8
      ],
      [
        2,
        -3
      ],
      [
        5,
        6
      ],
      [
        0,
        9
      ],
      [
        -3,
        20
      ],
      [
        -2,
        6
      ],
      [
        -2,
        12
      ],
      [
        -1,
        7
      ],
      [
        -2,
        8
      ]
    ],
    [
      [
        28348,
        60209
      ],
      [
        0,
        -15
      ],
      [
        1,
        -142
      ],
      [
        -1,
        -50
      ]
    ],
    [
      [
        28286,
        59868
      ],
      [
        -3,
        12
      ],
      [
        -2,
        -17
      ],
      [
        -3,
        27
      ],
      [
        -2,
        -2
      ]
    ],
    [
      [
        28276,
        59888
      ],
      [
        -6,
        11
      ],
      [
        -10,
        11
      ],
      [
        0,
        16
      ],
      [
        -9,
        37
      ],
      [
        -5,
        18
      ],
      [
        -9,
        11
      ],
      [
        -4,
        -1
      ],
      [
        -8,
        15
      ],
      [
        -3,
        -9
      ],
      [
        -11,
        0
      ]
    ],
    [
      [
        28211,
        59997
      ],
      [
        -3,
        181
      ],
      [
        8,
        7
      ],
      [
        8,
        23
      ],
      [
        5,
        -3
      ],
      [
        5,
        10
      ],
      [
        3,
        20
      ]
    ],
    [
      [
        24955,
        63475
      ],
      [
        -34,
        -1
      ],
      [
        -1,
        -68
      ],
      [
        -19,
        -1
      ],
      [
        0,
        -16
      ],
      [
        -62,
        -1
      ]
    ],
    [
      [
        19845,
        64669
      ],
      [
        81,
        0
      ],
      [
        72,
        1
      ],
      [
        14,
        0
      ]
    ],
    [
      [
        18742,
        66315
      ],
      [
        39,
        0
      ],
      [
        2,
        15
      ],
      [
        -1,
        2
      ],
      [
        5,
        0
      ],
      [
        1,
        -17
      ],
      [
        31,
        -1
      ]
    ],
    [
      [
        16085,
        62334
      ],
      [
        0,
        -81
      ],
      [
        -16,
        -1
      ],
      [
        0,
        -202
      ],
      [
        -4,
        -1
      ],
      [
        0,
        -19
      ]
    ],
    [
      [
        16032,
        62031
      ],
      [
        3,
        32
      ],
      [
        -4,
        20
      ],
      [
        -5,
        5
      ],
      [
        -3,
        -21
      ],
      [
        -8,
        1
      ],
      [
        2,
        -15
      ],
      [
        -4,
        -14
      ],
      [
        1,
        19
      ],
      [
        -5,
        5
      ],
      [
        -4,
        46
      ],
      [
        -6,
        1
      ],
      [
        0,
        26
      ],
      [
        -2,
        10
      ],
      [
        2,
        19
      ],
      [
        -8,
        24
      ],
      [
        -9,
        -17
      ],
      [
        -9,
        23
      ],
      [
        3,
        29
      ],
      [
        0,
        16
      ],
      [
        -9,
        11
      ]
    ],
    [
      [
        21203,
        57388
      ],
      [
        0,
        -506
      ]
    ],
    [
      [
        21203,
        56871
      ],
      [
        -194,
        0
      ],
      [
        0,
        351
      ]
    ],
    [
      [
        29355,
        66371
      ],
      [
        18,
        8
      ],
      [
        102,
        45
      ]
    ],
    [
      [
        29435,
        65889
      ],
      [
        -7,
        0
      ],
      [
        -2,
        -84
      ],
      [
        -51,
        32
      ],
      [
        -30,
        48
      ],
      [
        -25,
        38
      ],
      [
        -6,
        -1
      ]
    ],
    [
      [
        29314,
        65922
      ],
      [
        3,
        37
      ],
      [
        3,
        20
      ]
    ],
    [
      [
        24711,
        56299
      ],
      [
        64,
        -2
      ],
      [
        11,
        -1
      ],
      [
        3,
        -23
      ],
      [
        -4,
        -28
      ],
      [
        -5,
        -7
      ],
      [
        -6,
        0
      ],
      [
        -2,
        7
      ],
      [
        -17,
        -17
      ],
      [
        -5,
        -29
      ],
      [
        3,
        -32
      ],
      [
        9,
        -1
      ],
      [
        4,
        20
      ],
      [
        1,
        18
      ],
      [
        3,
        8
      ],
      [
        6,
        -17
      ],
      [
        23,
        -1
      ]
    ],
    [
      [
        26526,
        57668
      ],
      [
        -2,
        -20
      ],
      [
        5,
        -17
      ],
      [
        3,
        -34
      ],
      [
        14,
        -14
      ],
      [
        4,
        -18
      ],
      [
        5,
        0
      ],
      [
        -1,
        11
      ],
      [
        5,
        6
      ],
      [
        2,
        -9
      ],
      [
        2,
        -10
      ],
      [
        -2,
        -29
      ],
      [
        1,
        -15
      ],
      [
        5,
        -19
      ],
      [
        -2,
        -20
      ],
      [
        5,
        -9
      ],
      [
        0,
        -30
      ]
    ],
    [
      [
        26549,
        57359
      ],
      [
        -6,
        1
      ],
      [
        -7,
        11
      ],
      [
        -10,
        10
      ],
      [
        -13,
        -29
      ],
      [
        -3,
        -44
      ],
      [
        -8,
        -9
      ],
      [
        -4,
        -33
      ],
      [
        -5,
        1
      ],
      [
        -4,
        15
      ],
      [
        -8,
        -3
      ],
      [
        -7,
        13
      ],
      [
        -7,
        -22
      ],
      [
        -2,
        3
      ]
    ],
    [
      [
        26591,
        61919
      ],
      [
        0,
        46
      ],
      [
        9,
        397
      ]
    ],
    [
      [
        26680,
        62403
      ],
      [
        20,
        -4
      ],
      [
        1,
        -11
      ],
      [
        11,
        -31
      ]
    ],
    [
      [
        26712,
        62357
      ],
      [
        1,
        -455
      ],
      [
        0,
        -8
      ]
    ],
    [
      [
        26607,
        61916
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -3,
        2
      ],
      [
        -2,
        2
      ],
      [
        -5,
        9
      ]
    ],
    [
      [
        29144,
        62688
      ],
      [
        -3,
        -8
      ],
      [
        0,
        -7
      ],
      [
        -3,
        -10
      ],
      [
        -5,
        -9
      ],
      [
        -5,
        -14
      ],
      [
        -4,
        -17
      ],
      [
        -7,
        -27
      ],
      [
        -2,
        -11
      ],
      [
        -2,
        -15
      ],
      [
        -5,
        -22
      ],
      [
        -12,
        -70
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -3
      ],
      [
        2,
        -8
      ],
      [
        0,
        -6
      ],
      [
        -9,
        -32
      ],
      [
        -11,
        -61
      ],
      [
        -2,
        -26
      ],
      [
        -2,
        -10
      ],
      [
        -4,
        -7
      ],
      [
        -4,
        -7
      ],
      [
        -8,
        -29
      ],
      [
        -4,
        -17
      ],
      [
        0,
        1
      ],
      [
        -2,
        3
      ],
      [
        -3,
        -2
      ],
      [
        -7,
        -12
      ],
      [
        -4,
        -3
      ],
      [
        -3,
        -1
      ],
      [
        -9,
        3
      ],
      [
        -1,
        3
      ],
      [
        -1,
        8
      ],
      [
        5,
        71
      ],
      [
        1,
        17
      ],
      [
        3,
        23
      ],
      [
        10,
        60
      ],
      [
        2,
        14
      ],
      [
        1,
        16
      ],
      [
        2,
        36
      ],
      [
        0,
        17
      ],
      [
        -5,
        19
      ],
      [
        -3,
        3
      ]
    ],
    [
      [
        17636,
        58805
      ],
      [
        0,
        240
      ],
      [
        -14,
        2
      ],
      [
        0,
        780
      ]
    ],
    [
      [
        23453,
        62826
      ],
      [
        0,
        -2
      ],
      [
        4,
        -4
      ],
      [
        1,
        -2
      ],
      [
        1,
        -4
      ],
      [
        0,
        -17
      ],
      [
        1,
        -5
      ],
      [
        1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        3,
        -1
      ],
      [
        2,
        2
      ],
      [
        2,
        3
      ],
      [
        2,
        5
      ],
      [
        2,
        1
      ],
      [
        1,
        -1
      ],
      [
        1,
        -1
      ],
      [
        1,
        -3
      ],
      [
        1,
        -7
      ],
      [
        1,
        -4
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -7
      ],
      [
        1,
        -29
      ],
      [
        0,
        -13
      ],
      [
        1,
        -7
      ],
      [
        1,
        -7
      ],
      [
        1,
        -7
      ],
      [
        2,
        -9
      ],
      [
        2,
        -4
      ],
      [
        1,
        -2
      ],
      [
        3,
        -4
      ],
      [
        3,
        -5
      ],
      [
        3,
        -6
      ],
      [
        2,
        -7
      ],
      [
        2,
        -7
      ],
      [
        1,
        -8
      ],
      [
        1,
        -9
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -12
      ],
      [
        0,
        -7
      ],
      [
        1,
        -2
      ],
      [
        2,
        -7
      ],
      [
        1,
        -2
      ],
      [
        2,
        -2
      ],
      [
        4,
        -1
      ],
      [
        3,
        2
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        1,
        -4
      ],
      [
        1,
        -3
      ]
    ],
    [
      [
        23507,
        62572
      ],
      [
        -3,
        1
      ],
      [
        -32,
        2
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -86
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -159
      ]
    ],
    [
      [
        23469,
        62329
      ],
      [
        -4,
        13
      ],
      [
        -7,
        -22
      ],
      [
        -20,
        19
      ],
      [
        -2,
        -25
      ],
      [
        -8,
        4
      ]
    ],
    [
      [
        16799,
        72766
      ],
      [
        5,
        -9
      ],
      [
        1,
        -20
      ],
      [
        5,
        -15
      ],
      [
        8,
        -5
      ],
      [
        15,
        -18
      ],
      [
        5,
        4
      ],
      [
        1,
        35
      ],
      [
        5,
        10
      ],
      [
        8,
        -6
      ],
      [
        2,
        -12
      ],
      [
        23,
        6
      ],
      [
        10,
        -20
      ],
      [
        -3,
        -36
      ],
      [
        4,
        -11
      ],
      [
        8,
        -1
      ],
      [
        10,
        10
      ],
      [
        3,
        -9
      ],
      [
        0,
        -23
      ],
      [
        3,
        -11
      ],
      [
        15,
        -17
      ],
      [
        6,
        2
      ],
      [
        4,
        11
      ],
      [
        2,
        47
      ],
      [
        2,
        14
      ]
    ],
    [
      [
        16941,
        72692
      ],
      [
        5,
        2
      ],
      [
        2,
        15
      ],
      [
        16,
        30
      ],
      [
        3,
        10
      ],
      [
        5,
        -3
      ],
      [
        5,
        6
      ],
      [
        3,
        -20
      ],
      [
        7,
        -21
      ],
      [
        0,
        -11
      ],
      [
        4,
        -5
      ],
      [
        0,
        -14
      ],
      [
        5,
        0
      ],
      [
        6,
        -38
      ],
      [
        1,
        -23
      ],
      [
        5,
        -10
      ],
      [
        6,
        -28
      ],
      [
        6,
        -1
      ],
      [
        3,
        -8
      ],
      [
        3,
        12
      ],
      [
        6,
        4
      ],
      [
        3,
        20
      ],
      [
        4,
        13
      ],
      [
        6,
        -2
      ],
      [
        9,
        -11
      ],
      [
        6,
        14
      ],
      [
        8,
        4
      ],
      [
        1,
        11
      ],
      [
        14,
        -16
      ],
      [
        3,
        -10
      ]
    ],
    [
      [
        17086,
        72612
      ],
      [
        0,
        -246
      ],
      [
        -1,
        -238
      ],
      [
        0,
        -174
      ]
    ],
    [
      [
        17085,
        71954
      ],
      [
        -38,
        0
      ]
    ],
    [
      [
        15649,
        72357
      ],
      [
        -36,
        -173
      ],
      [
        -13,
        -119
      ],
      [
        4,
        -9
      ],
      [
        8,
        17
      ],
      [
        11,
        -13
      ],
      [
        12,
        0
      ],
      [
        12,
        27
      ],
      [
        13,
        10
      ],
      [
        8,
        7
      ],
      [
        9,
        25
      ],
      [
        2,
        15
      ],
      [
        -8,
        -2
      ],
      [
        -5,
        -9
      ],
      [
        -17,
        -21
      ],
      [
        -10,
        -20
      ],
      [
        -12,
        -12
      ],
      [
        -8,
        7
      ],
      [
        -8,
        2
      ],
      [
        -1,
        18
      ],
      [
        24,
        123
      ],
      [
        4,
        27
      ]
    ],
    [
      [
        15638,
        72257
      ],
      [
        22,
        2
      ],
      [
        38,
        -2
      ],
      [
        0,
        -136
      ]
    ],
    [
      [
        15698,
        72062
      ],
      [
        -1,
        4
      ],
      [
        -4,
        8
      ],
      [
        -1,
        -12
      ],
      [
        1,
        -29
      ],
      [
        0,
        -10
      ],
      [
        -7,
        -25
      ],
      [
        -5,
        -32
      ],
      [
        2,
        -43
      ],
      [
        5,
        -29
      ],
      [
        -6,
        -48
      ]
    ],
    [
      [
        15682,
        71846
      ],
      [
        -12,
        -12
      ],
      [
        -1,
        9
      ],
      [
        -1,
        13
      ],
      [
        -7,
        16
      ],
      [
        -3,
        -5
      ],
      [
        -2,
        -18
      ],
      [
        -4,
        -10
      ],
      [
        -10,
        -12
      ],
      [
        -2,
        -9
      ],
      [
        -1,
        -23
      ],
      [
        -5,
        -10
      ],
      [
        -8,
        -1
      ],
      [
        -4,
        -9
      ],
      [
        0,
        -25
      ],
      [
        -35,
        0
      ]
    ],
    [
      [
        15649,
        73739
      ],
      [
        11,
        -4
      ],
      [
        17,
        -30
      ],
      [
        17,
        -23
      ],
      [
        -8,
        -8
      ],
      [
        -14,
        10
      ],
      [
        -8,
        10
      ],
      [
        -15,
        31
      ],
      [
        0,
        14
      ]
    ],
    [
      [
        15623,
        73630
      ],
      [
        9,
        20
      ],
      [
        4,
        1
      ],
      [
        2,
        4
      ],
      [
        2,
        1
      ],
      [
        1,
        -4
      ],
      [
        1,
        -29
      ],
      [
        -3,
        -11
      ],
      [
        -2,
        -4
      ],
      [
        -6,
        -6
      ],
      [
        0,
        3
      ],
      [
        2,
        8
      ],
      [
        0,
        5
      ],
      [
        -3,
        7
      ],
      [
        -7,
        5
      ]
    ],
    [
      [
        15586,
        73509
      ],
      [
        2,
        13
      ],
      [
        5,
        17
      ],
      [
        8,
        2
      ],
      [
        3,
        -1
      ],
      [
        1,
        -3
      ],
      [
        8,
        3
      ],
      [
        3,
        -11
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -7
      ],
      [
        7,
        -7
      ],
      [
        4,
        -11
      ],
      [
        4,
        -15
      ],
      [
        4,
        -7
      ],
      [
        5,
        -3
      ],
      [
        8,
        1
      ],
      [
        0,
        10
      ],
      [
        -1,
        5
      ],
      [
        -2,
        4
      ],
      [
        -2,
        3
      ],
      [
        -4,
        0
      ],
      [
        -4,
        13
      ],
      [
        2,
        3
      ],
      [
        0,
        6
      ],
      [
        -4,
        14
      ],
      [
        -2,
        0
      ],
      [
        -1,
        11
      ],
      [
        7,
        15
      ],
      [
        3,
        10
      ],
      [
        0,
        6
      ],
      [
        1,
        9
      ],
      [
        6,
        14
      ],
      [
        1,
        6
      ],
      [
        10,
        24
      ],
      [
        2,
        11
      ],
      [
        0,
        5
      ],
      [
        7,
        8
      ],
      [
        6,
        1
      ],
      [
        6,
        -3
      ],
      [
        11,
        -16
      ],
      [
        9,
        -18
      ],
      [
        1,
        -4
      ],
      [
        16,
        -20
      ],
      [
        0,
        -2
      ],
      [
        -4,
        -13
      ],
      [
        -8,
        -16
      ],
      [
        -2,
        -2
      ],
      [
        -5,
        -17
      ],
      [
        0,
        -5
      ],
      [
        3,
        -12
      ],
      [
        0,
        -3
      ],
      [
        -2,
        -7
      ],
      [
        1,
        -12
      ],
      [
        4,
        -11
      ],
      [
        5,
        -16
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -7
      ],
      [
        -2,
        -8
      ],
      [
        -2,
        -17
      ],
      [
        0,
        -9
      ],
      [
        3,
        -6
      ],
      [
        0,
        -10
      ],
      [
        -6,
        -17
      ],
      [
        -5,
        -8
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -29
      ],
      [
        2,
        -7
      ],
      [
        2,
        -10
      ],
      [
        1,
        -13
      ],
      [
        0,
        -5
      ],
      [
        -3,
        -7
      ],
      [
        -3,
        2
      ],
      [
        -14,
        -7
      ],
      [
        -3,
        1
      ],
      [
        -2,
        4
      ],
      [
        1,
        16
      ],
      [
        -4,
        1
      ],
      [
        -3,
        7
      ],
      [
        -1,
        -4
      ],
      [
        -3,
        0
      ],
      [
        3,
        16
      ],
      [
        -1,
        6
      ],
      [
        -2,
        3
      ],
      [
        -3,
        -6
      ],
      [
        -6,
        -6
      ],
      [
        -22,
        11
      ],
      [
        -5,
        13
      ],
      [
        -3,
        9
      ],
      [
        -14,
        16
      ],
      [
        -6,
        14
      ],
      [
        -3,
        10
      ],
      [
        -3,
        19
      ],
      [
        -1,
        7
      ],
      [
        1,
        4
      ],
      [
        0,
        10
      ],
      [
        -3,
        10
      ],
      [
        -1,
        6
      ],
      [
        0,
        8
      ],
      [
        1,
        4
      ],
      [
        0,
        8
      ],
      [
        -4,
        9
      ],
      [
        -3,
        0
      ],
      [
        -1,
        4
      ],
      [
        -1,
        7
      ]
    ],
    [
      [
        15577,
        73617
      ],
      [
        7,
        1
      ],
      [
        4,
        -6
      ],
      [
        3,
        0
      ],
      [
        4,
        -5
      ],
      [
        7,
        -14
      ],
      [
        5,
        -13
      ],
      [
        2,
        -12
      ],
      [
        4,
        -15
      ],
      [
        -3,
        -1
      ],
      [
        -5,
        5
      ],
      [
        -22,
        37
      ],
      [
        -6,
        17
      ],
      [
        0,
        6
      ]
    ],
    [
      [
        24742,
        61626
      ],
      [
        3,
        12
      ],
      [
        2,
        4
      ],
      [
        8,
        29
      ],
      [
        2,
        14
      ],
      [
        1,
        6
      ],
      [
        0,
        9
      ],
      [
        1,
        17
      ],
      [
        0,
        7
      ],
      [
        1,
        9
      ],
      [
        0,
        8
      ],
      [
        1,
        11
      ],
      [
        1,
        6
      ],
      [
        0,
        6
      ],
      [
        2,
        16
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        24865,
        61431
      ],
      [
        -38,
        3
      ],
      [
        0,
        -102
      ],
      [
        -48,
        -55
      ]
    ],
    [
      [
        24779,
        61277
      ],
      [
        -3,
        7
      ],
      [
        -7,
        22
      ],
      [
        -2,
        14
      ],
      [
        0,
        3
      ]
    ],
    [
      [
        24767,
        61323
      ],
      [
        -7,
        35
      ],
      [
        -2,
        8
      ],
      [
        -2,
        7
      ],
      [
        -3,
        5
      ],
      [
        -3,
        4
      ],
      [
        -1,
        1
      ],
      [
        -2,
        3
      ],
      [
        -2,
        7
      ],
      [
        -1,
        3
      ],
      [
        -6,
        27
      ],
      [
        0,
        5
      ],
      [
        -1,
        8
      ],
      [
        -1,
        14
      ],
      [
        -1,
        16
      ],
      [
        0,
        6
      ],
      [
        -1,
        14
      ],
      [
        -1,
        7
      ],
      [
        0,
        58
      ],
      [
        1,
        12
      ],
      [
        0,
        8
      ],
      [
        4,
        23
      ],
      [
        2,
        20
      ],
      [
        1,
        5
      ],
      [
        0,
        4
      ],
      [
        1,
        3
      ]
    ],
    [
      [
        20069,
        62765
      ],
      [
        168,
        -5
      ],
      [
        23,
        0
      ]
    ],
    [
      [
        20260,
        62760
      ],
      [
        -2,
        -24
      ],
      [
        1,
        -29
      ],
      [
        -11,
        -9
      ],
      [
        -4,
        4
      ],
      [
        -5,
        -16
      ],
      [
        0,
        -16
      ],
      [
        6,
        -14
      ],
      [
        0,
        -20
      ],
      [
        -4,
        -16
      ],
      [
        2,
        -16
      ],
      [
        -1,
        -35
      ],
      [
        -4,
        -36
      ],
      [
        -4,
        -11
      ],
      [
        -4,
        6
      ],
      [
        -7,
        -8
      ],
      [
        -1,
        -27
      ],
      [
        2,
        -14
      ],
      [
        -2,
        -17
      ],
      [
        -4,
        -5
      ],
      [
        -2,
        -16
      ],
      [
        2,
        -35
      ]
    ],
    [
      [
        20218,
        62406
      ],
      [
        -5,
        -15
      ],
      [
        1,
        -23
      ],
      [
        -2,
        -32
      ]
    ],
    [
      [
        19991,
        62637
      ],
      [
        4,
        15
      ],
      [
        -5,
        30
      ],
      [
        -4,
        -4
      ],
      [
        -15,
        27
      ],
      [
        10,
        39
      ],
      [
        0,
        21
      ]
    ],
    [
      [
        16108,
        64881
      ],
      [
        371,
        0
      ]
    ],
    [
      [
        16438,
        63162
      ],
      [
        0,
        34
      ],
      [
        5,
        0
      ],
      [
        3,
        34
      ],
      [
        2,
        0
      ],
      [
        1,
        33
      ],
      [
        0,
        101
      ],
      [
        2,
        0
      ],
      [
        0,
        34
      ],
      [
        -3,
        0
      ],
      [
        1,
        34
      ],
      [
        -11,
        27
      ],
      [
        -5,
        7
      ],
      [
        -5,
        52
      ],
      [
        -5,
        0
      ],
      [
        0,
        34
      ],
      [
        -3,
        0
      ],
      [
        0,
        51
      ],
      [
        -10,
        0
      ],
      [
        0,
        25
      ],
      [
        -8,
        8
      ],
      [
        -18,
        1
      ],
      [
        0,
        8
      ],
      [
        -11,
        8
      ],
      [
        0,
        13
      ],
      [
        -8,
        8
      ],
      [
        -2,
        26
      ],
      [
        -8,
        8
      ],
      [
        -3,
        34
      ],
      [
        -8,
        0
      ],
      [
        -2,
        34
      ],
      [
        -5,
        0
      ],
      [
        0,
        16
      ],
      [
        -11,
        9
      ],
      [
        0,
        8
      ],
      [
        -8,
        1
      ],
      [
        0,
        25
      ],
      [
        -13,
        0
      ],
      [
        -5,
        9
      ],
      [
        -3,
        17
      ],
      [
        -21,
        1
      ],
      [
        0,
        8
      ],
      [
        -10,
        0
      ],
      [
        -3,
        -16
      ],
      [
        -6,
        -1
      ],
      [
        0,
        -27
      ],
      [
        -10,
        -8
      ],
      [
        -1,
        -17
      ],
      [
        -5,
        -17
      ],
      [
        -5,
        0
      ],
      [
        0,
        -49
      ],
      [
        -5,
        -9
      ],
      [
        -11,
        0
      ],
      [
        0,
        17
      ],
      [
        -5,
        0
      ],
      [
        0,
        17
      ],
      [
        -16,
        0
      ],
      [
        0,
        16
      ],
      [
        -10,
        0
      ],
      [
        0,
        25
      ],
      [
        -6,
        0
      ],
      [
        0,
        221
      ],
      [
        -74,
        -1
      ]
    ],
    [
      [
        21287,
        61485
      ],
      [
        5,
        1
      ],
      [
        1,
        -1
      ],
      [
        188,
        2
      ]
    ],
    [
      [
        21285,
        60760
      ],
      [
        0,
        209
      ],
      [
        2,
        1
      ],
      [
        0,
        515
      ]
    ],
    [
      [
        17304,
        71118
      ],
      [
        0,
        681
      ]
    ],
    [
      [
        27383,
        49938
      ],
      [
        0,
        -297
      ],
      [
        -2,
        -9
      ],
      [
        0,
        -305
      ]
    ],
    [
      [
        27381,
        49327
      ],
      [
        -4,
        0
      ],
      [
        1,
        -103
      ],
      [
        2,
        -107
      ]
    ],
    [
      [
        27305,
        49119
      ],
      [
        3,
        7
      ],
      [
        0,
        14
      ],
      [
        -4,
        9
      ],
      [
        -1,
        26
      ],
      [
        1,
        22
      ],
      [
        -7,
        18
      ],
      [
        1,
        19
      ],
      [
        -3,
        11
      ],
      [
        1,
        9
      ],
      [
        -6,
        36
      ],
      [
        -4,
        36
      ],
      [
        -6,
        24
      ],
      [
        -8,
        5
      ],
      [
        -6,
        13
      ],
      [
        -6,
        5
      ],
      [
        -1,
        28
      ],
      [
        -2,
        18
      ],
      [
        1,
        24
      ],
      [
        -8,
        11
      ],
      [
        1,
        21
      ],
      [
        -4,
        17
      ],
      [
        -7,
        17
      ],
      [
        -3,
        29
      ],
      [
        -8,
        -6
      ],
      [
        -3,
        16
      ],
      [
        -4,
        25
      ],
      [
        -5,
        7
      ],
      [
        -1,
        14
      ],
      [
        5,
        9
      ],
      [
        3,
        -19
      ],
      [
        7,
        -16
      ],
      [
        4,
        -2
      ],
      [
        3,
        -18
      ],
      [
        2,
        20
      ],
      [
        3,
        10
      ],
      [
        -1,
        28
      ],
      [
        6,
        16
      ],
      [
        0,
        10
      ],
      [
        -31,
        1
      ],
      [
        0,
        68
      ],
      [
        -4,
        0
      ],
      [
        -15,
        -1
      ],
      [
        0,
        68
      ],
      [
        -7,
        56
      ],
      [
        -2,
        12
      ],
      [
        -28,
        0
      ],
      [
        0,
        102
      ]
    ],
    [
      [
        23650,
        69653
      ],
      [
        1,
        27
      ],
      [
        19,
        13
      ],
      [
        7,
        -19
      ],
      [
        12,
        28
      ],
      [
        11,
        48
      ],
      [
        -1,
        15
      ],
      [
        9,
        51
      ],
      [
        1,
        -1
      ]
    ],
    [
      [
        23709,
        69815
      ],
      [
        6,
        -21
      ],
      [
        5,
        0
      ],
      [
        0,
        -16
      ],
      [
        4,
        12
      ],
      [
        6,
        -14
      ],
      [
        4,
        -13
      ],
      [
        11,
        7
      ],
      [
        9,
        -24
      ],
      [
        5,
        -28
      ],
      [
        11,
        -5
      ],
      [
        8,
        -29
      ],
      [
        12,
        -18
      ],
      [
        15,
        4
      ],
      [
        5,
        8
      ],
      [
        4,
        -10
      ],
      [
        26,
        -5
      ],
      [
        4,
        11
      ],
      [
        3,
        -43
      ],
      [
        9,
        -21
      ]
    ],
    [
      [
        23856,
        69610
      ],
      [
        0,
        -3
      ],
      [
        -4,
        -16
      ],
      [
        -10,
        -14
      ],
      [
        -19,
        -10
      ],
      [
        -5,
        -18
      ],
      [
        5,
        -23
      ],
      [
        0,
        -10
      ],
      [
        -10,
        -17
      ],
      [
        -2,
        0
      ],
      [
        -5,
        -17
      ],
      [
        -8,
        -46
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -5
      ],
      [
        -7,
        -1
      ],
      [
        -1,
        -28
      ],
      [
        -1,
        -93
      ]
    ],
    [
      [
        23719,
        69298
      ],
      [
        -68,
        1
      ]
    ],
    [
      [
        26474,
        55275
      ],
      [
        0,
        -96
      ]
    ],
    [
      [
        26474,
        55179
      ],
      [
        0,
        -57
      ],
      [
        -7,
        1
      ],
      [
        -15,
        -130
      ]
    ],
    [
      [
        26429,
        55060
      ],
      [
        -5,
        16
      ],
      [
        -3,
        -6
      ],
      [
        -7,
        7
      ],
      [
        -3,
        23
      ],
      [
        -2,
        -9
      ],
      [
        -6,
        6
      ],
      [
        -3,
        9
      ],
      [
        -3,
        34
      ],
      [
        -6,
        26
      ],
      [
        -3,
        0
      ],
      [
        -3,
        -15
      ],
      [
        -4,
        5
      ],
      [
        -3,
        27
      ],
      [
        -3,
        -1
      ],
      [
        -3,
        12
      ],
      [
        4,
        16
      ],
      [
        -9,
        7
      ]
    ],
    [
      [
        21324,
        64925
      ],
      [
        154,
        0
      ]
    ],
    [
      [
        21478,
        64925
      ],
      [
        0,
        -203
      ],
      [
        1,
        -51
      ]
    ],
    [
      [
        21479,
        64669
      ],
      [
        -5,
        1
      ],
      [
        -15,
        -1
      ],
      [
        -19,
        0
      ],
      [
        -5,
        1
      ],
      [
        -6,
        -1
      ],
      [
        -41,
        0
      ],
      [
        -25,
        1
      ],
      [
        0,
        -1
      ],
      [
        -5,
        1
      ],
      [
        -19,
        -1
      ],
      [
        -6,
        0
      ],
      [
        -12,
        1
      ]
    ],
    [
      [
        21321,
        64670
      ],
      [
        0,
        53
      ],
      [
        3,
        0
      ],
      [
        0,
        202
      ]
    ],
    [
      [
        21204,
        58407
      ],
      [
        244,
        6
      ]
    ],
    [
      [
        26514,
        56269
      ],
      [
        20,
        66
      ],
      [
        5,
        15
      ],
      [
        6,
        22
      ],
      [
        4,
        13
      ],
      [
        16,
        52
      ]
    ],
    [
      [
        26607,
        56409
      ],
      [
        2,
        3
      ],
      [
        3,
        -25
      ],
      [
        13,
        -4
      ],
      [
        -1,
        -19
      ],
      [
        3,
        -22
      ],
      [
        12,
        -27
      ],
      [
        7,
        -9
      ]
    ],
    [
      [
        26881,
        55501
      ],
      [
        5,
        -29
      ],
      [
        2,
        -1
      ],
      [
        -1,
        -19
      ],
      [
        8,
        -31
      ],
      [
        -1,
        -7
      ],
      [
        3,
        -7
      ],
      [
        2,
        -16
      ],
      [
        12,
        -20
      ],
      [
        2,
        6
      ],
      [
        2,
        -50
      ],
      [
        1,
        -34
      ],
      [
        8,
        -35
      ],
      [
        -5,
        -98
      ],
      [
        2,
        -13
      ]
    ],
    [
      [
        26921,
        55147
      ],
      [
        -11,
        -2
      ],
      [
        -14,
        -26
      ],
      [
        -16,
        -17
      ],
      [
        -4,
        16
      ],
      [
        -8,
        -15
      ],
      [
        -6,
        -3
      ],
      [
        -10,
        -15
      ],
      [
        -2,
        28
      ],
      [
        -7,
        12
      ],
      [
        -1,
        8
      ],
      [
        -40,
        -59
      ]
    ],
    [
      [
        26802,
        55074
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        21
      ],
      [
        2,
        31
      ],
      [
        -4,
        38
      ],
      [
        -8,
        25
      ],
      [
        -8,
        1
      ],
      [
        -3,
        27
      ],
      [
        -4,
        17
      ],
      [
        1,
        19
      ],
      [
        -4,
        28
      ],
      [
        -3,
        14
      ]
    ],
    [
      [
        29219,
        64547
      ],
      [
        3,
        -16
      ],
      [
        4,
        -3
      ],
      [
        2,
        0
      ],
      [
        10,
        -23
      ],
      [
        2,
        -5
      ],
      [
        4,
        -9
      ],
      [
        14,
        -34
      ]
    ],
    [
      [
        29254,
        64418
      ],
      [
        -1,
        -8
      ],
      [
        -3,
        -19
      ],
      [
        -2,
        -18
      ],
      [
        2,
        -14
      ],
      [
        1,
        -3
      ],
      [
        3,
        2
      ],
      [
        1,
        5
      ],
      [
        1,
        3
      ],
      [
        5,
        0
      ],
      [
        1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -17
      ],
      [
        1,
        -14
      ],
      [
        1,
        -9
      ],
      [
        -6,
        -33
      ]
    ],
    [
      [
        29257,
        64288
      ],
      [
        -8,
        17
      ],
      [
        -13,
        2
      ],
      [
        -1,
        11
      ],
      [
        -2,
        8
      ],
      [
        -10,
        7
      ],
      [
        -8,
        10
      ],
      [
        -3,
        -8
      ],
      [
        -2,
        -2
      ],
      [
        -6,
        4
      ],
      [
        -13,
        27
      ]
    ],
    [
      [
        29191,
        64364
      ],
      [
        2,
        11
      ],
      [
        2,
        6
      ],
      [
        -3,
        8
      ],
      [
        -2,
        -4
      ],
      [
        2,
        41
      ],
      [
        9,
        24
      ],
      [
        2,
        29
      ],
      [
        0,
        12
      ],
      [
        -2,
        20
      ],
      [
        3,
        49
      ],
      [
        15,
        -13
      ]
    ],
    [
      [
        27052,
        53989
      ],
      [
        6,
        -14
      ],
      [
        4,
        8
      ],
      [
        2,
        -26
      ],
      [
        8,
        -20
      ],
      [
        2,
        8
      ]
    ],
    [
      [
        27074,
        53945
      ],
      [
        5,
        -4
      ],
      [
        2,
        -29
      ],
      [
        3,
        2
      ],
      [
        3,
        -13
      ],
      [
        1,
        10
      ],
      [
        3,
        -12
      ],
      [
        -1,
        -12
      ],
      [
        2,
        -18
      ],
      [
        8,
        -13
      ],
      [
        3,
        -28
      ],
      [
        5,
        -12
      ],
      [
        -1,
        -13
      ],
      [
        7,
        -4
      ],
      [
        1,
        -14
      ],
      [
        3,
        0
      ],
      [
        0,
        15
      ],
      [
        7,
        -25
      ],
      [
        -1,
        -11
      ],
      [
        6,
        -7
      ],
      [
        0,
        -16
      ],
      [
        4,
        1
      ],
      [
        9,
        -18
      ],
      [
        2,
        -12
      ],
      [
        5,
        -13
      ],
      [
        0,
        -28
      ],
      [
        8,
        -8
      ],
      [
        2,
        -10
      ]
    ],
    [
      [
        27160,
        53653
      ],
      [
        3,
        -12
      ],
      [
        -2,
        -21
      ],
      [
        13,
        -48
      ],
      [
        -3,
        -19
      ]
    ],
    [
      [
        27141,
        53410
      ],
      [
        -10,
        21
      ],
      [
        -10,
        18
      ],
      [
        -12,
        -10
      ],
      [
        -22,
        -10
      ],
      [
        -30,
        23
      ],
      [
        -3,
        9
      ]
    ],
    [
      [
        27054,
        53461
      ],
      [
        -4,
        41
      ],
      [
        1,
        53
      ],
      [
        -3,
        14
      ],
      [
        -7,
        16
      ],
      [
        -12,
        -10
      ]
    ],
    [
      [
        24633,
        61919
      ],
      [
        7,
        7
      ],
      [
        1,
        13
      ],
      [
        7,
        11
      ],
      [
        4,
        25
      ],
      [
        2,
        2
      ],
      [
        6,
        2
      ],
      [
        7,
        -9
      ],
      [
        11,
        -3
      ],
      [
        6,
        2
      ],
      [
        3,
        5
      ],
      [
        2,
        14
      ],
      [
        0,
        38
      ],
      [
        11,
        24
      ],
      [
        3,
        14
      ],
      [
        2,
        22
      ],
      [
        0,
        9
      ],
      [
        9,
        43
      ],
      [
        3,
        2
      ],
      [
        10,
        -7
      ],
      [
        9,
        5
      ],
      [
        6,
        40
      ],
      [
        3,
        28
      ],
      [
        3,
        6
      ],
      [
        6,
        -4
      ],
      [
        12,
        -42
      ],
      [
        5,
        -10
      ],
      [
        15,
        -29
      ],
      [
        12,
        13
      ],
      [
        6,
        -28
      ]
    ],
    [
      [
        24742,
        61626
      ],
      [
        -2,
        22
      ],
      [
        0,
        34
      ],
      [
        3,
        21
      ],
      [
        -11,
        -1
      ],
      [
        -10,
        4
      ],
      [
        -3,
        31
      ],
      [
        3,
        -3
      ],
      [
        2,
        24
      ],
      [
        -17,
        1
      ],
      [
        -7,
        -1
      ],
      [
        -28,
        0
      ],
      [
        -3,
        -25
      ],
      [
        -3,
        -10
      ],
      [
        -6,
        17
      ],
      [
        -5,
        2
      ],
      [
        -2,
        -10
      ],
      [
        2,
        -25
      ],
      [
        -7,
        -13
      ],
      [
        -2,
        3
      ],
      [
        -3,
        26
      ],
      [
        -10,
        13
      ],
      [
        -1,
        -18
      ]
    ],
    [
      [
        24702,
        52184
      ],
      [
        -7,
        -54
      ],
      [
        -12,
        -40
      ],
      [
        -7,
        2
      ],
      [
        -4,
        12
      ],
      [
        -2,
        10
      ],
      [
        -9,
        6
      ]
    ],
    [
      [
        24661,
        52120
      ],
      [
        -5,
        12
      ],
      [
        -3,
        -7
      ],
      [
        0,
        -14
      ],
      [
        -5,
        -8
      ],
      [
        1,
        -11
      ],
      [
        -5,
        -26
      ],
      [
        -3,
        12
      ],
      [
        -4,
        5
      ],
      [
        -1,
        19
      ],
      [
        -4,
        7
      ],
      [
        1,
        10
      ],
      [
        -5,
        24
      ],
      [
        -5,
        -2
      ],
      [
        -2,
        12
      ],
      [
        -4,
        20
      ],
      [
        1,
        15
      ],
      [
        -7,
        -5
      ],
      [
        -4,
        20
      ],
      [
        -1,
        30
      ],
      [
        -6,
        14
      ],
      [
        -2,
        15
      ],
      [
        -2,
        -4
      ],
      [
        -7,
        6
      ]
    ],
    [
      [
        26216,
        54263
      ],
      [
        -1,
        -57
      ],
      [
        -2,
        -27
      ]
    ],
    [
      [
        26213,
        54179
      ],
      [
        -2,
        -27
      ],
      [
        -3,
        -32
      ],
      [
        -10,
        -54
      ],
      [
        -4,
        -18
      ],
      [
        -3,
        -45
      ],
      [
        2,
        -25
      ],
      [
        2,
        -44
      ]
    ],
    [
      [
        26195,
        53934
      ],
      [
        0,
        -20
      ]
    ],
    [
      [
        26195,
        53914
      ],
      [
        -6,
        12
      ],
      [
        -11,
        -31
      ],
      [
        -5,
        -5
      ],
      [
        -1,
        -37
      ],
      [
        -2,
        -9
      ],
      [
        -56,
        5
      ],
      [
        0,
        -102
      ]
    ],
    [
      [
        26022,
        53746
      ],
      [
        1,
        1
      ],
      [
        4,
        15
      ],
      [
        4,
        33
      ],
      [
        -1,
        44
      ],
      [
        3,
        10
      ],
      [
        1,
        29
      ],
      [
        2,
        19
      ],
      [
        6,
        12
      ],
      [
        3,
        29
      ],
      [
        -3,
        27
      ],
      [
        2,
        32
      ],
      [
        -3,
        26
      ],
      [
        6,
        28
      ]
    ],
    [
      [
        25382,
        52464
      ],
      [
        2,
        4
      ],
      [
        3,
        -5
      ],
      [
        0,
        -30
      ],
      [
        -8,
        18
      ],
      [
        3,
        13
      ]
    ],
    [
      [
        25320,
        52274
      ],
      [
        1,
        21
      ],
      [
        3,
        -6
      ],
      [
        1,
        -24
      ],
      [
        0,
        -23
      ],
      [
        -3,
        -9
      ],
      [
        -4,
        17
      ],
      [
        2,
        24
      ]
    ],
    [
      [
        25302,
        52136
      ],
      [
        7,
        3
      ],
      [
        5,
        1
      ],
      [
        7,
        7
      ],
      [
        10,
        7
      ],
      [
        14,
        8
      ],
      [
        5,
        0
      ],
      [
        4,
        3
      ],
      [
        4,
        2
      ],
      [
        1,
        13
      ],
      [
        0,
        12
      ],
      [
        11,
        -28
      ],
      [
        3,
        -12
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -4,
        -5
      ],
      [
        -4,
        -18
      ],
      [
        -10,
        16
      ],
      [
        -6,
        3
      ],
      [
        -12,
        -5
      ],
      [
        -20,
        -17
      ],
      [
        -7,
        -1
      ],
      [
        -5,
        2
      ],
      [
        -2,
        14
      ]
    ],
    [
      [
        25392,
        52659
      ],
      [
        -1,
        0
      ],
      [
        0,
        -2
      ],
      [
        -3,
        -11
      ],
      [
        -1,
        -14
      ],
      [
        -2,
        -9
      ],
      [
        -3,
        -1
      ],
      [
        -5,
        -9
      ],
      [
        1,
        -30
      ],
      [
        1,
        -8
      ],
      [
        -3,
        -28
      ],
      [
        -3,
        -11
      ],
      [
        -2,
        -16
      ],
      [
        -1,
        -2
      ],
      [
        1,
        -20
      ],
      [
        0,
        -21
      ],
      [
        -2,
        -6
      ],
      [
        -3,
        -16
      ],
      [
        -1,
        -10
      ],
      [
        1,
        -9
      ],
      [
        1,
        -26
      ],
      [
        -1,
        -11
      ],
      [
        -1,
        -10
      ],
      [
        0,
        -30
      ],
      [
        -1,
        -58
      ],
      [
        -2,
        -24
      ],
      [
        -2,
        -17
      ],
      [
        -1,
        -4
      ],
      [
        -3,
        -21
      ],
      [
        -5,
        8
      ],
      [
        -5,
        -3
      ],
      [
        -5,
        -9
      ],
      [
        -1,
        5
      ],
      [
        -1,
        20
      ],
      [
        1,
        6
      ],
      [
        2,
        2
      ],
      [
        0,
        3
      ],
      [
        -4,
        17
      ],
      [
        -1,
        0
      ],
      [
        -15,
        23
      ],
      [
        -7,
        1
      ],
      [
        -2,
        -14
      ],
      [
        -6,
        -3
      ],
      [
        -1,
        2
      ],
      [
        -1,
        12
      ],
      [
        -3,
        9
      ],
      [
        -3,
        1
      ],
      [
        -6,
        -1
      ],
      [
        -3,
        -3
      ],
      [
        -6,
        -19
      ]
    ],
    [
      [
        25284,
        52292
      ],
      [
        -2,
        165
      ],
      [
        0,
        39
      ],
      [
        -1,
        18
      ],
      [
        0,
        89
      ],
      [
        -1,
        37
      ],
      [
        0,
        52
      ],
      [
        -1,
        20
      ],
      [
        0,
        6
      ]
    ],
    [
      [
        25279,
        52718
      ],
      [
        -1,
        153
      ],
      [
        -1,
        10
      ],
      [
        0,
        58
      ],
      [
        -1,
        85
      ]
    ],
    [
      [
        25276,
        53024
      ],
      [
        0,
        3
      ],
      [
        -2,
        132
      ]
    ],
    [
      [
        16981,
        73980
      ],
      [
        54,
        0
      ],
      [
        1,
        -1
      ],
      [
        32,
        0
      ],
      [
        3,
        1
      ],
      [
        124,
        0
      ]
    ],
    [
      [
        17193,
        72870
      ],
      [
        -27,
        1
      ],
      [
        0,
        -295
      ],
      [
        -5,
        8
      ],
      [
        -7,
        -9
      ],
      [
        -7,
        11
      ],
      [
        -8,
        36
      ],
      [
        -6,
        1
      ],
      [
        -2,
        10
      ],
      [
        -2,
        43
      ],
      [
        -2,
        10
      ],
      [
        -5,
        -7
      ],
      [
        -3,
        -21
      ],
      [
        1,
        -10
      ],
      [
        -15,
        -34
      ],
      [
        -4,
        5
      ],
      [
        -4,
        -7
      ],
      [
        -3,
        -16
      ],
      [
        -4,
        1
      ],
      [
        -4,
        15
      ]
    ],
    [
      [
        16941,
        72692
      ],
      [
        -1,
        14
      ],
      [
        -2,
        50
      ],
      [
        0,
        30
      ],
      [
        -6,
        23
      ],
      [
        -1,
        10
      ],
      [
        -2,
        4
      ],
      [
        -2,
        9
      ],
      [
        -2,
        7
      ],
      [
        -1,
        10
      ],
      [
        2,
        4
      ],
      [
        3,
        6
      ],
      [
        3,
        4
      ],
      [
        5,
        10
      ],
      [
        14,
        -10
      ],
      [
        6,
        0
      ],
      [
        5,
        16
      ],
      [
        3,
        3
      ],
      [
        2,
        -3
      ],
      [
        2,
        3
      ],
      [
        2,
        8
      ],
      [
        -1,
        15
      ],
      [
        2,
        11
      ],
      [
        -2,
        16
      ],
      [
        -3,
        10
      ],
      [
        -2,
        4
      ],
      [
        0,
        11
      ],
      [
        1,
        12
      ],
      [
        2,
        4
      ],
      [
        5,
        2
      ],
      [
        7,
        4
      ],
      [
        2,
        13
      ],
      [
        1,
        15
      ],
      [
        -2,
        17
      ],
      [
        1,
        16
      ],
      [
        1,
        14
      ],
      [
        0,
        12
      ],
      [
        1,
        3
      ],
      [
        4,
        9
      ],
      [
        3,
        9
      ],
      [
        4,
        13
      ],
      [
        1,
        8
      ],
      [
        0,
        4
      ],
      [
        1,
        5
      ],
      [
        0,
        12
      ],
      [
        -2,
        10
      ],
      [
        -2,
        16
      ],
      [
        -2,
        12
      ],
      [
        -1,
        7
      ],
      [
        -2,
        11
      ],
      [
        -1,
        11
      ],
      [
        -1,
        8
      ],
      [
        0,
        28
      ],
      [
        -2,
        28
      ],
      [
        -1,
        11
      ],
      [
        -2,
        8
      ],
      [
        -1,
        8
      ],
      [
        0,
        40
      ],
      [
        -3,
        11
      ],
      [
        0,
        12
      ],
      [
        2,
        16
      ],
      [
        3,
        6
      ],
      [
        2,
        6
      ],
      [
        1,
        10
      ],
      [
        1,
        8
      ],
      [
        0,
        19
      ],
      [
        3,
        9
      ],
      [
        2,
        -2
      ],
      [
        3,
        -1
      ],
      [
        3,
        8
      ],
      [
        -1,
        9
      ],
      [
        0,
        14
      ],
      [
        1,
        17
      ],
      [
        2,
        17
      ],
      [
        2,
        12
      ],
      [
        0,
        12
      ],
      [
        -1,
        14
      ],
      [
        1,
        10
      ],
      [
        2,
        5
      ],
      [
        0,
        10
      ],
      [
        1,
        7
      ],
      [
        2,
        5
      ],
      [
        1,
        13
      ],
      [
        -1,
        11
      ],
      [
        0,
        7
      ],
      [
        -1,
        8
      ],
      [
        -1,
        0
      ],
      [
        -1,
        3
      ],
      [
        1,
        4
      ],
      [
        0,
        9
      ],
      [
        -2,
        17
      ],
      [
        0,
        32
      ],
      [
        1,
        5
      ],
      [
        -1,
        3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        5
      ],
      [
        1,
        4
      ],
      [
        1,
        2
      ],
      [
        0,
        4
      ],
      [
        -1,
        2
      ],
      [
        -1,
        3
      ],
      [
        -1,
        2
      ],
      [
        0,
        4
      ],
      [
        1,
        0
      ],
      [
        1,
        3
      ],
      [
        0,
        3
      ],
      [
        -2,
        0
      ],
      [
        0,
        7
      ],
      [
        2,
        4
      ],
      [
        1,
        4
      ],
      [
        -1,
        5
      ],
      [
        0,
        3
      ],
      [
        -3,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        5
      ],
      [
        -3,
        7
      ],
      [
        -1,
        10
      ],
      [
        -1,
        9
      ],
      [
        -2,
        12
      ],
      [
        0,
        12
      ],
      [
        -3,
        13
      ],
      [
        -2,
        1
      ],
      [
        -2,
        7
      ],
      [
        0,
        5
      ],
      [
        -1,
        8
      ],
      [
        -1,
        8
      ],
      [
        -1,
        9
      ],
      [
        -2,
        6
      ],
      [
        0,
        17
      ],
      [
        2,
        13
      ],
      [
        1,
        8
      ],
      [
        1,
        4
      ],
      [
        -1,
        4
      ],
      [
        -2,
        7
      ],
      [
        -3,
        13
      ],
      [
        -1,
        7
      ],
      [
        1,
        11
      ],
      [
        2,
        11
      ],
      [
        1,
        6
      ],
      [
        -2,
        7
      ],
      [
        -1,
        5
      ],
      [
        1,
        13
      ],
      [
        2,
        2
      ],
      [
        -1,
        6
      ],
      [
        -1,
        4
      ],
      [
        2,
        4
      ],
      [
        2,
        -3
      ],
      [
        2,
        1
      ],
      [
        -1,
        6
      ]
    ],
    [
      [
        15720,
        73667
      ],
      [
        2,
        20
      ],
      [
        4,
        -6
      ],
      [
        2,
        -8
      ],
      [
        7,
        -35
      ],
      [
        2,
        -11
      ],
      [
        5,
        -7
      ],
      [
        7,
        -24
      ],
      [
        3,
        -30
      ],
      [
        -2,
        1
      ],
      [
        -5,
        7
      ],
      [
        -11,
        34
      ],
      [
        -5,
        35
      ],
      [
        -3,
        7
      ],
      [
        -5,
        0
      ],
      [
        -1,
        7
      ],
      [
        0,
        10
      ]
    ],
    [
      [
        15785,
        73566
      ],
      [
        -1,
        8
      ],
      [
        -2,
        5
      ],
      [
        -2,
        16
      ],
      [
        -3,
        50
      ],
      [
        1,
        9
      ],
      [
        3,
        5
      ],
      [
        3,
        14
      ],
      [
        0,
        9
      ],
      [
        1,
        7
      ],
      [
        -6,
        8
      ],
      [
        0,
        2
      ],
      [
        -5,
        11
      ],
      [
        -2,
        9
      ],
      [
        -8,
        3
      ],
      [
        -9,
        -9
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -12
      ],
      [
        -6,
        -17
      ],
      [
        -3,
        -10
      ],
      [
        0,
        -4
      ],
      [
        3,
        -14
      ],
      [
        4,
        -7
      ],
      [
        2,
        -16
      ],
      [
        0,
        -3
      ],
      [
        -3,
        -5
      ],
      [
        -1,
        0
      ],
      [
        -3,
        3
      ],
      [
        -4,
        13
      ],
      [
        -8,
        29
      ],
      [
        2,
        18
      ],
      [
        1,
        7
      ],
      [
        4,
        23
      ],
      [
        1,
        9
      ],
      [
        -1,
        4
      ],
      [
        -2,
        0
      ],
      [
        -1,
        2
      ],
      [
        -6,
        19
      ],
      [
        -4,
        2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -16
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        0
      ],
      [
        -1,
        6
      ],
      [
        1,
        31
      ],
      [
        -1,
        17
      ],
      [
        -1,
        17
      ],
      [
        -2,
        7
      ],
      [
        -17,
        37
      ],
      [
        -2,
        10
      ],
      [
        0,
        2
      ],
      [
        2,
        0
      ],
      [
        9,
        19
      ],
      [
        1,
        5
      ],
      [
        1,
        7
      ],
      [
        0,
        11
      ],
      [
        -3,
        9
      ],
      [
        -3,
        4
      ],
      [
        -1,
        0
      ],
      [
        -5,
        -12
      ],
      [
        -8,
        8
      ],
      [
        -1,
        3
      ],
      [
        -1,
        4
      ],
      [
        2,
        13
      ],
      [
        6,
        22
      ],
      [
        6,
        19
      ],
      [
        2,
        1
      ],
      [
        3,
        6
      ],
      [
        0,
        3
      ],
      [
        -1,
        3
      ],
      [
        184,
        0
      ],
      [
        97,
        -6
      ],
      [
        99,
        3
      ],
      [
        14,
        1
      ],
      [
        25,
        -1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        5,
        1
      ],
      [
        29,
        0
      ],
      [
        19,
        -1
      ],
      [
        58,
        0
      ]
    ],
    [
      [
        15618,
        73982
      ],
      [
        15,
        0
      ],
      [
        4,
        -29
      ],
      [
        -2,
        -4
      ],
      [
        -3,
        4
      ],
      [
        -6,
        -2
      ],
      [
        -6,
        0
      ],
      [
        -1,
        13
      ],
      [
        -1,
        18
      ]
    ],
    [
      [
        26693,
        53580
      ],
      [
        54,
        -4
      ]
    ],
    [
      [
        26774,
        53240
      ],
      [
        -1,
        0
      ],
      [
        3,
        -19
      ],
      [
        1,
        -24
      ],
      [
        -36,
        0
      ],
      [
        0,
        -98
      ],
      [
        -9,
        -1
      ],
      [
        0,
        -42
      ]
    ],
    [
      [
        26732,
        53056
      ],
      [
        -27,
        2
      ]
    ],
    [
      [
        26705,
        53058
      ],
      [
        4,
        42
      ],
      [
        -4,
        10
      ],
      [
        -3,
        24
      ],
      [
        -4,
        5
      ],
      [
        -1,
        25
      ],
      [
        5,
        34
      ],
      [
        0,
        23
      ],
      [
        -8,
        28
      ],
      [
        1,
        28
      ],
      [
        -1,
        34
      ],
      [
        -3,
        9
      ],
      [
        -6,
        -4
      ],
      [
        -5,
        11
      ],
      [
        -7,
        33
      ],
      [
        -5,
        7
      ],
      [
        -3,
        27
      ],
      [
        2,
        19
      ],
      [
        -1,
        21
      ]
    ],
    [
      [
        18973,
        64960
      ],
      [
        0,
        146
      ],
      [
        1,
        219
      ],
      [
        0,
        17
      ]
    ],
    [
      [
        28245,
        59481
      ],
      [
        31,
        196
      ],
      [
        0,
        211
      ]
    ],
    [
      [
        28339,
        59670
      ],
      [
        -20,
        -43
      ],
      [
        7,
        -2
      ],
      [
        4,
        -19
      ],
      [
        13,
        2
      ],
      [
        11,
        -25
      ],
      [
        2,
        -30
      ],
      [
        3,
        -7
      ],
      [
        -1,
        -30
      ],
      [
        2,
        -25
      ],
      [
        6,
        4
      ],
      [
        10,
        -15
      ]
    ],
    [
      [
        21558,
        52622
      ],
      [
        -64,
        2
      ],
      [
        -39,
        2
      ],
      [
        0,
        -68
      ],
      [
        -57,
        1
      ],
      [
        0,
        -366
      ],
      [
        -62,
        -1
      ],
      [
        0,
        -269
      ]
    ],
    [
      [
        24749,
        65515
      ],
      [
        0,
        6
      ],
      [
        1,
        10
      ],
      [
        3,
        9
      ],
      [
        6,
        20
      ],
      [
        5,
        5
      ],
      [
        1,
        4
      ],
      [
        3,
        5
      ],
      [
        1,
        4
      ]
    ],
    [
      [
        24769,
        65578
      ],
      [
        -1,
        -24
      ],
      [
        3,
        0
      ],
      [
        -3,
        -18
      ],
      [
        4,
        -12
      ],
      [
        -3,
        -40
      ],
      [
        5,
        -11
      ],
      [
        -2,
        -19
      ],
      [
        12,
        -15
      ],
      [
        8,
        -23
      ],
      [
        -3,
        -4
      ],
      [
        3,
        -6
      ],
      [
        -1,
        -44
      ],
      [
        -6,
        -15
      ]
    ],
    [
      [
        26282,
        62999
      ],
      [
        0,
        185
      ]
    ],
    [
      [
        26397,
        64655
      ],
      [
        16,
        1
      ],
      [
        0,
        203
      ]
    ],
    [
      [
        26445,
        64860
      ],
      [
        97,
        2
      ]
    ],
    [
      [
        26542,
        64574
      ],
      [
        -32,
        -1
      ],
      [
        0,
        -17
      ],
      [
        -32,
        0
      ],
      [
        0,
        -51
      ],
      [
        -64,
        -2
      ]
    ],
    [
      [
        19861,
        60913
      ],
      [
        5,
        -1
      ],
      [
        6,
        25
      ],
      [
        -2,
        18
      ],
      [
        9,
        13
      ],
      [
        5,
        32
      ],
      [
        -1,
        21
      ],
      [
        7,
        18
      ],
      [
        5,
        25
      ]
    ],
    [
      [
        19942,
        61134
      ],
      [
        2,
        -11
      ],
      [
        8,
        -14
      ],
      [
        -1,
        -27
      ],
      [
        5,
        -22
      ],
      [
        -4,
        -16
      ],
      [
        -1,
        -16
      ],
      [
        5,
        -20
      ],
      [
        1,
        -36
      ],
      [
        7,
        -2
      ],
      [
        6,
        -17
      ],
      [
        3,
        -32
      ],
      [
        -3,
        -19
      ],
      [
        -4,
        3
      ],
      [
        0,
        -150
      ]
    ],
    [
      [
        19966,
        60755
      ],
      [
        -72,
        0
      ],
      [
        -5,
        1
      ],
      [
        -59,
        -1
      ]
    ],
    [
      [
        22162,
        51755
      ],
      [
        0,
        -327
      ]
    ],
    [
      [
        22047,
        51424
      ],
      [
        2,
        10
      ],
      [
        -6,
        36
      ],
      [
        3,
        16
      ],
      [
        -8,
        21
      ],
      [
        0,
        13
      ],
      [
        -5,
        6
      ],
      [
        11,
        14
      ],
      [
        -1,
        15
      ],
      [
        2,
        11
      ],
      [
        -4,
        39
      ],
      [
        2,
        11
      ],
      [
        4,
        7
      ],
      [
        -1,
        20
      ],
      [
        -3,
        15
      ],
      [
        -1,
        27
      ],
      [
        2,
        1
      ],
      [
        2,
        24
      ],
      [
        -2,
        16
      ],
      [
        6,
        16
      ],
      [
        4,
        150
      ],
      [
        4,
        -1
      ],
      [
        2,
        67
      ],
      [
        14,
        -5
      ],
      [
        44,
        -5
      ]
    ],
    [
      [
        18419,
        70798
      ],
      [
        0,
        157
      ],
      [
        -1,
        95
      ],
      [
        0,
        293
      ],
      [
        -6,
        -5
      ],
      [
        -5,
        -12
      ],
      [
        -10,
        -9
      ],
      [
        -5,
        15
      ],
      [
        -9,
        9
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        16
      ],
      [
        3,
        11
      ],
      [
        -11,
        29
      ],
      [
        -5,
        5
      ],
      [
        -3,
        21
      ],
      [
        0,
        14
      ],
      [
        -7,
        15
      ],
      [
        -3,
        -16
      ],
      [
        -4,
        -7
      ],
      [
        0,
        30
      ],
      [
        -3,
        0
      ]
    ],
    [
      [
        26807,
        54348
      ],
      [
        16,
        55
      ],
      [
        -4,
        15
      ]
    ],
    [
      [
        26819,
        54418
      ],
      [
        8,
        -2
      ],
      [
        12,
        42
      ],
      [
        13,
        46
      ],
      [
        3,
        0
      ],
      [
        -1,
        7
      ],
      [
        11,
        39
      ]
    ],
    [
      [
        26865,
        54550
      ],
      [
        7,
        -17
      ],
      [
        6,
        -1
      ],
      [
        5,
        5
      ]
    ],
    [
      [
        26883,
        54537
      ],
      [
        3,
        -3
      ],
      [
        -2,
        -10
      ],
      [
        4,
        -21
      ],
      [
        -3,
        -28
      ],
      [
        4,
        -13
      ],
      [
        0,
        -15
      ],
      [
        3,
        -17
      ],
      [
        -2,
        -12
      ],
      [
        1,
        -30
      ],
      [
        4,
        -10
      ],
      [
        0,
        -13
      ],
      [
        -4,
        -20
      ],
      [
        1,
        -22
      ],
      [
        4,
        -29
      ],
      [
        -4,
        -9
      ],
      [
        4,
        -10
      ],
      [
        -1,
        -14
      ],
      [
        3,
        -17
      ],
      [
        -1,
        -17
      ],
      [
        2,
        -2
      ],
      [
        0,
        -19
      ],
      [
        14,
        -37
      ],
      [
        3,
        -18
      ],
      [
        -2,
        -9
      ]
    ],
    [
      [
        26886,
        54096
      ],
      [
        -2,
        11
      ],
      [
        -5,
        7
      ],
      [
        -7,
        26
      ],
      [
        -9,
        58
      ],
      [
        -6,
        1
      ],
      [
        -10,
        17
      ],
      [
        -4,
        26
      ],
      [
        -10,
        19
      ],
      [
        -5,
        0
      ],
      [
        -4,
        16
      ],
      [
        -5,
        6
      ],
      [
        -4,
        21
      ],
      [
        0,
        15
      ],
      [
        -4,
        15
      ],
      [
        -7,
        2
      ],
      [
        3,
        12
      ]
    ],
    [
      [
        17570,
        55850
      ],
      [
        -8,
        0
      ],
      [
        -198,
        1
      ],
      [
        -58,
        0
      ],
      [
        0,
        4
      ],
      [
        -16,
        0
      ],
      [
        -15,
        3
      ],
      [
        -27,
        -1
      ],
      [
        -1,
        20
      ],
      [
        -2,
        3
      ],
      [
        -3,
        3
      ],
      [
        -17,
        24
      ],
      [
        -14,
        18
      ],
      [
        2,
        17
      ],
      [
        -40,
        0
      ]
    ],
    [
      [
        23550,
        59624
      ],
      [
        -43,
        0
      ],
      [
        -2,
        3
      ],
      [
        -61,
        0
      ]
    ],
    [
      [
        23444,
        59627
      ],
      [
        0,
        317
      ],
      [
        2,
        8
      ],
      [
        -8,
        13
      ],
      [
        -3,
        13
      ],
      [
        -1,
        26
      ],
      [
        8,
        6
      ]
    ],
    [
      [
        31618,
        38134
      ],
      [
        -1,
        0
      ],
      [
        -7,
        -14
      ],
      [
        -1,
        -9
      ],
      [
        1,
        -9
      ],
      [
        -2,
        0
      ],
      [
        -1,
        3
      ],
      [
        -3,
        6
      ],
      [
        0,
        2
      ],
      [
        -2,
        2
      ],
      [
        -3,
        -6
      ],
      [
        -2,
        -6
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        31572,
        38127
      ],
      [
        -1,
        34
      ],
      [
        4,
        38
      ],
      [
        -2,
        12
      ]
    ],
    [
      [
        26698,
        69158
      ],
      [
        0,
        -6
      ],
      [
        2,
        -13
      ],
      [
        3,
        -14
      ],
      [
        2,
        -43
      ],
      [
        0,
        -40
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -11
      ],
      [
        2,
        -19
      ],
      [
        2,
        -9
      ],
      [
        3,
        -9
      ],
      [
        -1,
        -29
      ],
      [
        -3,
        -42
      ],
      [
        -5,
        -27
      ],
      [
        -2,
        -25
      ],
      [
        -1,
        -15
      ],
      [
        1,
        -36
      ],
      [
        1,
        -19
      ],
      [
        0,
        -10
      ],
      [
        -2,
        -29
      ],
      [
        0,
        -4
      ]
    ],
    [
      [
        26699,
        68754
      ],
      [
        -159,
        -3
      ]
    ],
    [
      [
        19669,
        68355
      ],
      [
        128,
        0
      ],
      [
        103,
        -1
      ],
      [
        10,
        -1
      ],
      [
        150,
        -1
      ]
    ],
    [
      [
        19952,
        67578
      ],
      [
        -17,
        0
      ]
    ],
    [
      [
        19935,
        67578
      ],
      [
        0,
        169
      ],
      [
        -34,
        0
      ],
      [
        0,
        101
      ],
      [
        -67,
        1
      ],
      [
        0,
        99
      ],
      [
        -61,
        0
      ],
      [
        -6,
        11
      ],
      [
        3,
        23
      ],
      [
        -34,
        -2
      ],
      [
        0,
        66
      ],
      [
        -34,
        0
      ],
      [
        1,
        104
      ],
      [
        -17,
        -1
      ],
      [
        0,
        103
      ],
      [
        -17,
        -1
      ]
    ],
    [
      [
        22878,
        55342
      ],
      [
        14,
        0
      ],
      [
        6,
        -1
      ],
      [
        32,
        -1
      ]
    ],
    [
      [
        31286,
        37841
      ],
      [
        4,
        13
      ],
      [
        3,
        39
      ],
      [
        -1,
        22
      ],
      [
        4,
        12
      ],
      [
        -2,
        16
      ],
      [
        2,
        33
      ],
      [
        4,
        23
      ],
      [
        -2,
        20
      ],
      [
        4,
        17
      ],
      [
        -1,
        13
      ]
    ],
    [
      [
        31309,
        38050
      ],
      [
        3,
        -27
      ],
      [
        -3,
        -28
      ],
      [
        1,
        -6
      ],
      [
        -1,
        -27
      ],
      [
        1,
        -23
      ],
      [
        4,
        12
      ],
      [
        4,
        -8
      ],
      [
        -1,
        -14
      ],
      [
        2,
        -15
      ],
      [
        -4,
        -8
      ],
      [
        -3,
        -15
      ]
    ],
    [
      [
        31312,
        37891
      ],
      [
        -1,
        10
      ],
      [
        -2,
        -1
      ],
      [
        -4,
        -12
      ],
      [
        0,
        -20
      ],
      [
        -1,
        -6
      ],
      [
        -6,
        -9
      ],
      [
        -4,
        -13
      ],
      [
        -4,
        -5
      ],
      [
        -4,
        6
      ]
    ],
    [
      [
        25060,
        57676
      ],
      [
        -5,
        0
      ],
      [
        -38,
        -1
      ]
    ],
    [
      [
        22472,
        62594
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        31209,
        38263
      ],
      [
        2,
        7
      ],
      [
        4,
        -4
      ],
      [
        12,
        -10
      ],
      [
        3,
        -6
      ]
    ],
    [
      [
        31234,
        38230
      ],
      [
        0,
        -20
      ],
      [
        -6,
        -2
      ],
      [
        -6,
        -18
      ]
    ],
    [
      [
        31222,
        38190
      ],
      [
        -15,
        -10
      ],
      [
        0,
        6
      ],
      [
        -2,
        22
      ],
      [
        -12,
        -4
      ]
    ],
    [
      [
        31193,
        38204
      ],
      [
        -1,
        16
      ],
      [
        0,
        1
      ],
      [
        -2,
        10
      ],
      [
        -2,
        4
      ],
      [
        -2,
        2
      ],
      [
        -4,
        2
      ]
    ],
    [
      [
        31222,
        38190
      ],
      [
        7,
        -11
      ],
      [
        2,
        -21
      ],
      [
        5,
        -11
      ],
      [
        3,
        -26
      ]
    ],
    [
      [
        31195,
        38089
      ],
      [
        7,
        31
      ],
      [
        0,
        10
      ],
      [
        -1,
        16
      ],
      [
        -4,
        16
      ],
      [
        -1,
        19
      ],
      [
        0,
        1
      ],
      [
        -3,
        22
      ]
    ],
    [
      [
        31107,
        38346
      ],
      [
        3,
        9
      ],
      [
        3,
        -5
      ],
      [
        2,
        -15
      ],
      [
        -3,
        -10
      ],
      [
        -4,
        6
      ],
      [
        -1,
        15
      ]
    ],
    [
      [
        30985,
        38023
      ],
      [
        0,
        2
      ],
      [
        6,
        8
      ],
      [
        6,
        -7
      ],
      [
        1,
        -2
      ],
      [
        3,
        2
      ],
      [
        2,
        6
      ],
      [
        1,
        2
      ],
      [
        1,
        1
      ],
      [
        4,
        -16
      ],
      [
        1,
        -15
      ],
      [
        0,
        -12
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -5
      ],
      [
        -3,
        -15
      ],
      [
        -2,
        -8
      ],
      [
        -7,
        -7
      ],
      [
        -2,
        8
      ],
      [
        -4,
        5
      ],
      [
        -3,
        6
      ],
      [
        -3,
        13
      ],
      [
        2,
        37
      ]
    ],
    [
      [
        2341,
        307
      ],
      [
        1,
        1
      ],
      [
        5,
        18
      ],
      [
        3,
        12
      ],
      [
        3,
        9
      ],
      [
        3,
        7
      ],
      [
        5,
        22
      ],
      [
        4,
        -20
      ],
      [
        5,
        -1
      ],
      [
        5,
        -1
      ],
      [
        3,
        -4
      ],
      [
        8,
        1
      ],
      [
        2,
        6
      ],
      [
        4,
        1
      ],
      [
        0,
        -16
      ],
      [
        3,
        -23
      ],
      [
        1,
        -5
      ],
      [
        -1,
        -7
      ],
      [
        -2,
        0
      ],
      [
        -1,
        4
      ],
      [
        -3,
        16
      ],
      [
        -2,
        -3
      ],
      [
        -6,
        -11
      ],
      [
        -8,
        5
      ],
      [
        -3,
        -8
      ],
      [
        -6,
        -6
      ],
      [
        -4,
        -7
      ],
      [
        -5,
        -15
      ],
      [
        -2,
        -20
      ],
      [
        -1,
        -4
      ]
    ],
    [
      [
        29497,
        66929
      ],
      [
        1,
        102
      ],
      [
        0,
        6
      ],
      [
        1,
        59
      ],
      [
        0,
        11
      ],
      [
        2,
        140
      ],
      [
        0,
        16
      ],
      [
        1,
        34
      ],
      [
        0,
        64
      ]
    ],
    [
      [
        29500,
        66699
      ],
      [
        -4,
        0
      ],
      [
        -4,
        65
      ],
      [
        2,
        7
      ],
      [
        0,
        7
      ],
      [
        -1,
        7
      ],
      [
        1,
        17
      ],
      [
        0,
        1
      ],
      [
        2,
        -2
      ],
      [
        0,
        74
      ],
      [
        1,
        44
      ],
      [
        0,
        10
      ]
    ],
    [
      [
        22875,
        49344
      ],
      [
        -1,
        -3
      ],
      [
        -13,
        -56
      ],
      [
        -13,
        -81
      ],
      [
        -20,
        -140
      ],
      [
        -3,
        -23
      ]
    ],
    [
      [
        22825,
        49041
      ],
      [
        -6,
        7
      ],
      [
        -7,
        -8
      ]
    ],
    [
      [
        22812,
        49040
      ],
      [
        2,
        14
      ],
      [
        7,
        54
      ],
      [
        14,
        70
      ],
      [
        10,
        87
      ],
      [
        8,
        35
      ],
      [
        -3,
        27
      ],
      [
        1,
        20
      ],
      [
        7,
        46
      ],
      [
        6,
        40
      ],
      [
        1,
        2
      ]
    ],
    [
      [
        22746,
        49353
      ],
      [
        9,
        -24
      ],
      [
        15,
        -1
      ],
      [
        11,
        17
      ],
      [
        -3,
        -28
      ],
      [
        -1,
        -15
      ],
      [
        0,
        -21
      ],
      [
        2,
        -19
      ],
      [
        5,
        -29
      ],
      [
        6,
        -19
      ],
      [
        9,
        -15
      ],
      [
        17,
        -18
      ],
      [
        -2,
        -20
      ],
      [
        -1,
        -1
      ],
      [
        -9,
        -76
      ],
      [
        0,
        -17
      ],
      [
        1,
        -6
      ],
      [
        -2,
        -9
      ],
      [
        -6,
        -17
      ],
      [
        -1,
        -12
      ]
    ],
    [
      [
        22796,
        49023
      ],
      [
        -69,
        -1
      ],
      [
        -74,
        -2
      ],
      [
        0,
        5
      ],
      [
        -5,
        21
      ],
      [
        -5,
        8
      ],
      [
        -1,
        25
      ],
      [
        -3,
        13
      ],
      [
        -9,
        3
      ],
      [
        -3,
        15
      ],
      [
        -3,
        0
      ]
    ],
    [
      [
        22624,
        49110
      ],
      [
        3,
        164
      ],
      [
        -1,
        126
      ],
      [
        38,
        129
      ]
    ],
    [
      [
        29697,
        69333
      ],
      [
        7,
        -1
      ],
      [
        14,
        1
      ],
      [
        9,
        0
      ],
      [
        13,
        -2
      ],
      [
        15,
        -2
      ],
      [
        5,
        -1
      ],
      [
        6,
        -1
      ],
      [
        5,
        1
      ],
      [
        12,
        0
      ],
      [
        24,
        2
      ],
      [
        16,
        -1
      ],
      [
        14,
        1
      ],
      [
        6,
        3
      ],
      [
        1,
        -2
      ],
      [
        1,
        0
      ],
      [
        11,
        1
      ],
      [
        11,
        1
      ],
      [
        9,
        -1
      ],
      [
        4,
        1
      ]
    ],
    [
      [
        29880,
        69333
      ],
      [
        -8,
        -118
      ],
      [
        15,
        -36
      ],
      [
        -14,
        -51
      ],
      [
        -14,
        -54
      ],
      [
        10,
        -20
      ]
    ],
    [
      [
        29869,
        69054
      ],
      [
        -18,
        -74
      ],
      [
        -3,
        -8
      ],
      [
        -28,
        59
      ],
      [
        7,
        -76
      ],
      [
        -16,
        23
      ],
      [
        -25,
        -148
      ],
      [
        -7,
        -40
      ],
      [
        -31,
        49
      ]
    ],
    [
      [
        27907,
        62615
      ],
      [
        -6,
        -49
      ],
      [
        -9,
        -53
      ],
      [
        2,
        -9
      ],
      [
        -8,
        -59
      ],
      [
        -9,
        -62
      ],
      [
        3,
        -19
      ],
      [
        -1,
        -25
      ],
      [
        10,
        -84
      ],
      [
        -8,
        -34
      ],
      [
        -3,
        -6
      ],
      [
        1,
        -20
      ],
      [
        -9,
        -48
      ],
      [
        -6,
        -26
      ]
    ],
    [
      [
        26947,
        56112
      ],
      [
        4,
        18
      ],
      [
        17,
        19
      ],
      [
        4,
        12
      ],
      [
        8,
        9
      ],
      [
        9,
        -19
      ],
      [
        10,
        10
      ],
      [
        6,
        -8
      ]
    ],
    [
      [
        27034,
        56049
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        2,
        -11
      ],
      [
        1,
        -3
      ],
      [
        1,
        -1
      ],
      [
        1,
        -3
      ],
      [
        4,
        -4
      ],
      [
        2,
        -2
      ],
      [
        3,
        -10
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        2,
        -11
      ],
      [
        1,
        -7
      ],
      [
        1,
        -3
      ],
      [
        1,
        -1
      ]
    ],
    [
      [
        27058,
        55989
      ],
      [
        -7,
        -21
      ],
      [
        -5,
        -13
      ],
      [
        -10,
        -32
      ],
      [
        -5,
        -14
      ],
      [
        -1,
        -3
      ],
      [
        -43,
        -130
      ],
      [
        -3,
        -9
      ]
    ],
    [
      [
        28267,
        61184
      ],
      [
        8,
        -19
      ],
      [
        5,
        -1
      ]
    ],
    [
      [
        28424,
        60740
      ],
      [
        -4,
        -11
      ],
      [
        0,
        -29
      ],
      [
        -9,
        5
      ],
      [
        -19,
        -68
      ]
    ],
    [
      [
        23497,
        55777
      ],
      [
        -1,
        14
      ],
      [
        -5,
        9
      ],
      [
        -7,
        -7
      ],
      [
        -5,
        20
      ],
      [
        -4,
        1
      ],
      [
        -6,
        -13
      ],
      [
        -12,
        8
      ],
      [
        -7,
        -4
      ],
      [
        -11,
        4
      ],
      [
        -2,
        -8
      ],
      [
        -7,
        -1
      ],
      [
        -2,
        10
      ],
      [
        -5,
        -7
      ],
      [
        -5,
        14
      ],
      [
        -9,
        -9
      ]
    ],
    [
      [
        23358,
        55797
      ],
      [
        -1,
        576
      ],
      [
        1,
        6
      ]
    ],
    [
      [
        26683,
        62778
      ],
      [
        30,
        162
      ]
    ],
    [
      [
        26857,
        62767
      ],
      [
        -3,
        -152
      ],
      [
        -1,
        -34
      ]
    ],
    [
      [
        26853,
        62581
      ],
      [
        -1,
        -47
      ],
      [
        -5,
        1
      ]
    ],
    [
      [
        26847,
        62535
      ],
      [
        -15,
        4
      ],
      [
        -85,
        18
      ],
      [
        -58,
        12
      ]
    ],
    [
      [
        26749,
        54683
      ],
      [
        7,
        -60
      ],
      [
        34,
        -261
      ],
      [
        29,
        56
      ]
    ],
    [
      [
        26807,
        54348
      ],
      [
        -2,
        21
      ],
      [
        -5,
        -21
      ],
      [
        3,
        -13
      ],
      [
        -73,
        -261
      ]
    ],
    [
      [
        26730,
        54074
      ],
      [
        -6,
        42
      ],
      [
        -10,
        18
      ],
      [
        -8,
        38
      ],
      [
        3,
        14
      ],
      [
        -4,
        17
      ],
      [
        1,
        19
      ],
      [
        -4,
        27
      ],
      [
        2,
        5
      ],
      [
        1,
        28
      ],
      [
        -5,
        16
      ],
      [
        -1,
        -8
      ],
      [
        -6,
        23
      ]
    ],
    [
      [
        26481,
        56577
      ],
      [
        -5,
        18
      ],
      [
        1,
        14
      ],
      [
        1,
        23
      ],
      [
        3,
        29
      ],
      [
        7,
        48
      ],
      [
        3,
        5
      ]
    ],
    [
      [
        26491,
        56714
      ],
      [
        25,
        -37
      ],
      [
        16,
        -25
      ],
      [
        7,
        -10
      ],
      [
        6,
        -9
      ],
      [
        14,
        34
      ]
    ],
    [
      [
        26456,
        57220
      ],
      [
        -1,
        -70
      ],
      [
        1,
        -5
      ],
      [
        6,
        -20
      ],
      [
        15,
        -56
      ],
      [
        2,
        -8
      ],
      [
        35,
        -56
      ]
    ],
    [
      [
        26514,
        57005
      ],
      [
        2,
        -15
      ],
      [
        -3,
        -26
      ],
      [
        1,
        -29
      ],
      [
        7,
        -28
      ]
    ],
    [
      [
        26521,
        56907
      ],
      [
        -18,
        0
      ],
      [
        -36,
        1
      ],
      [
        -30,
        0
      ]
    ],
    [
      [
        17042,
        70488
      ],
      [
        73,
        -1
      ],
      [
        32,
        -1
      ]
    ],
    [
      [
        17181,
        70485
      ],
      [
        25,
        0
      ],
      [
        10,
        -2
      ],
      [
        5,
        2
      ],
      [
        34,
        0
      ],
      [
        40,
        -1
      ],
      [
        5,
        -1
      ],
      [
        31,
        0
      ],
      [
        7,
        -1
      ]
    ],
    [
      [
        17240,
        69417
      ],
      [
        1,
        100
      ],
      [
        -59,
        0
      ],
      [
        0,
        50
      ],
      [
        -12,
        0
      ],
      [
        -1,
        68
      ],
      [
        -5,
        -1
      ],
      [
        0,
        33
      ],
      [
        -6,
        0
      ],
      [
        0,
        17
      ],
      [
        -6,
        0
      ],
      [
        0,
        33
      ],
      [
        -17,
        -2
      ],
      [
        0,
        33
      ],
      [
        -5,
        1
      ],
      [
        0,
        73
      ],
      [
        -6,
        0
      ],
      [
        0,
        101
      ],
      [
        -12,
        -1
      ],
      [
        0,
        119
      ],
      [
        -5,
        0
      ],
      [
        0,
        51
      ],
      [
        -6,
        -1
      ],
      [
        0,
        35
      ],
      [
        -6,
        0
      ],
      [
        0,
        97
      ],
      [
        11,
        0
      ],
      [
        0,
        102
      ],
      [
        -62,
        0
      ]
    ],
    [
      [
        17044,
        70325
      ],
      [
        -2,
        0
      ],
      [
        0,
        163
      ]
    ],
    [
      [
        26921,
        55147
      ],
      [
        5,
        -25
      ],
      [
        12,
        -38
      ],
      [
        7,
        -7
      ]
    ],
    [
      [
        26885,
        54787
      ],
      [
        -7,
        13
      ],
      [
        2,
        103
      ],
      [
        -36,
        56
      ],
      [
        3,
        30
      ],
      [
        -22,
        34
      ],
      [
        -26,
        -8
      ]
    ],
    [
      [
        26799,
        55015
      ],
      [
        4,
        50
      ],
      [
        -1,
        9
      ]
    ],
    [
      [
        26946,
        55674
      ],
      [
        13,
        43
      ]
    ],
    [
      [
        26967,
        55718
      ],
      [
        4,
        -1
      ],
      [
        11,
        -27
      ],
      [
        1,
        -14
      ],
      [
        8,
        -11
      ]
    ],
    [
      [
        26494,
        63363
      ],
      [
        5,
        186
      ]
    ],
    [
      [
        26499,
        63549
      ],
      [
        63,
        -15
      ],
      [
        81,
        -20
      ]
    ],
    [
      [
        26643,
        63514
      ],
      [
        2,
        0
      ],
      [
        -15,
        -188
      ],
      [
        -7,
        -93
      ],
      [
        -16,
        5
      ]
    ],
    [
      [
        24732,
        58841
      ],
      [
        7,
        37
      ],
      [
        3,
        23
      ],
      [
        2,
        24
      ],
      [
        4,
        9
      ],
      [
        0,
        17
      ],
      [
        5,
        10
      ],
      [
        2,
        17
      ],
      [
        4,
        5
      ],
      [
        7,
        11
      ],
      [
        5,
        15
      ],
      [
        0,
        23
      ],
      [
        5,
        29
      ],
      [
        3,
        -3
      ],
      [
        2,
        12
      ],
      [
        3,
        10
      ]
    ],
    [
      [
        24784,
        59080
      ],
      [
        2,
        5
      ],
      [
        8,
        11
      ],
      [
        3,
        15
      ],
      [
        5,
        2
      ],
      [
        0,
        17
      ],
      [
        3,
        26
      ],
      [
        9,
        7
      ],
      [
        1,
        19
      ],
      [
        4,
        17
      ],
      [
        -4,
        18
      ],
      [
        0,
        26
      ],
      [
        4,
        19
      ],
      [
        0,
        34
      ],
      [
        -4,
        17
      ],
      [
        -8,
        4
      ],
      [
        -6,
        13
      ],
      [
        -4,
        10
      ],
      [
        3,
        15
      ],
      [
        -2,
        27
      ],
      [
        -1,
        14
      ],
      [
        -4,
        10
      ],
      [
        -1,
        1
      ],
      [
        2,
        16
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        -19,
        0
      ]
    ],
    [
      [
        24776,
        59426
      ],
      [
        0,
        28
      ],
      [
        3,
        9
      ],
      [
        0,
        14
      ],
      [
        5,
        3
      ],
      [
        2,
        20
      ],
      [
        -1,
        30
      ],
      [
        1,
        11
      ],
      [
        2,
        -5
      ],
      [
        2,
        26
      ],
      [
        4,
        3
      ],
      [
        2,
        15
      ]
    ],
    [
      [
        24796,
        59580
      ],
      [
        3,
        1
      ],
      [
        49,
        -2
      ]
    ],
    [
      [
        24848,
        59579
      ],
      [
        -1,
        -5
      ],
      [
        3,
        -92
      ],
      [
        -2,
        -47
      ],
      [
        1,
        -53
      ],
      [
        -4,
        -82
      ],
      [
        3,
        -1
      ]
    ],
    [
      [
        24757,
        58842
      ],
      [
        -23,
        0
      ],
      [
        -2,
        -1
      ]
    ],
    [
      [
        29287,
        69318
      ],
      [
        43,
        6
      ],
      [
        31,
        3
      ],
      [
        24,
        -1
      ],
      [
        10,
        1
      ],
      [
        56,
        7
      ],
      [
        27,
        2
      ]
    ],
    [
      [
        29473,
        68815
      ],
      [
        0,
        -1
      ],
      [
        1,
        -6
      ],
      [
        0,
        -1
      ],
      [
        2,
        -2
      ],
      [
        2,
        -4
      ],
      [
        1,
        -4
      ],
      [
        0,
        -2
      ]
    ],
    [
      [
        27767,
        61275
      ],
      [
        9,
        -21
      ],
      [
        74,
        -179
      ],
      [
        8,
        -27
      ]
    ],
    [
      [
        27858,
        61048
      ],
      [
        3,
        -41
      ],
      [
        -7,
        -62
      ]
    ],
    [
      [
        27780,
        60729
      ],
      [
        -6,
        -13
      ],
      [
        3,
        -35
      ],
      [
        4,
        -4
      ],
      [
        -13,
        -28
      ],
      [
        -5,
        -18
      ]
    ],
    [
      [
        28473,
        64234
      ],
      [
        -1,
        -28
      ],
      [
        -3,
        -20
      ],
      [
        -8,
        -23
      ],
      [
        3,
        -28
      ],
      [
        -1,
        -31
      ],
      [
        5,
        -22
      ],
      [
        5,
        -15
      ],
      [
        -1,
        -26
      ],
      [
        -8,
        -18
      ],
      [
        -6,
        -24
      ],
      [
        -4,
        -1
      ],
      [
        1,
        -27
      ],
      [
        -4,
        -13
      ],
      [
        2,
        -29
      ],
      [
        4,
        -9
      ],
      [
        19,
        -1
      ],
      [
        6,
        -30
      ],
      [
        1,
        -4
      ]
    ],
    [
      [
        28288,
        63734
      ],
      [
        3,
        34
      ],
      [
        -4,
        5
      ],
      [
        -6,
        -17
      ],
      [
        -3,
        10
      ],
      [
        1,
        35
      ],
      [
        -6,
        -5
      ],
      [
        3,
        21
      ],
      [
        -4,
        23
      ]
    ],
    [
      [
        24618,
        59427
      ],
      [
        6,
        0
      ],
      [
        15,
        -1
      ],
      [
        5,
        1
      ],
      [
        32,
        0
      ]
    ],
    [
      [
        24676,
        59427
      ],
      [
        23,
        0
      ],
      [
        43,
        -1
      ],
      [
        34,
        0
      ]
    ],
    [
      [
        24784,
        59080
      ],
      [
        0,
        1
      ],
      [
        -36,
        -1
      ],
      [
        0,
        68
      ],
      [
        -42,
        1
      ],
      [
        -68,
        9
      ],
      [
        -26,
        -1
      ]
    ],
    [
      [
        28171,
        62647
      ],
      [
        -1,
        15
      ],
      [
        11,
        39
      ],
      [
        8,
        65
      ],
      [
        6,
        15
      ],
      [
        5,
        1
      ],
      [
        12,
        42
      ],
      [
        11,
        34
      ],
      [
        6,
        56
      ]
    ],
    [
      [
        18131,
        73978
      ],
      [
        45,
        0
      ],
      [
        12,
        -1
      ],
      [
        48,
        -1
      ],
      [
        33,
        1
      ],
      [
        55,
        1
      ],
      [
        6,
        -1
      ],
      [
        45,
        1
      ],
      [
        22,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        -1
      ],
      [
        3,
        0
      ],
      [
        1,
        1
      ],
      [
        251,
        0
      ]
    ],
    [
      [
        18654,
        73978
      ],
      [
        1,
        -99
      ],
      [
        0,
        -404
      ],
      [
        1,
        -104
      ]
    ],
    [
      [
        18656,
        73371
      ],
      [
        -6,
        -1
      ],
      [
        -6,
        8
      ],
      [
        -97,
        0
      ],
      [
        0,
        -202
      ],
      [
        -215,
        0
      ]
    ],
    [
      [
        29628,
        68685
      ],
      [
        -10,
        -57
      ],
      [
        10,
        -15
      ],
      [
        -6,
        -36
      ],
      [
        -8,
        7
      ],
      [
        -7,
        -41
      ],
      [
        -9,
        -56
      ],
      [
        4,
        -7
      ],
      [
        -15,
        -133
      ]
    ],
    [
      [
        29587,
        68347
      ],
      [
        -4,
        81
      ],
      [
        -2,
        72
      ],
      [
        -13,
        12
      ],
      [
        1,
        -21
      ],
      [
        -15,
        -1
      ],
      [
        -18,
        -11
      ],
      [
        -18,
        -10
      ],
      [
        -20,
        -7
      ],
      [
        -12,
        4
      ]
    ],
    [
      [
        23011,
        67297
      ],
      [
        0,
        1
      ],
      [
        2,
        -1
      ],
      [
        0,
        1
      ],
      [
        125,
        -4
      ],
      [
        16,
        2
      ],
      [
        50,
        -1
      ]
    ],
    [
      [
        23561,
        54650
      ],
      [
        7,
        15
      ],
      [
        8,
        -7
      ],
      [
        2,
        -16
      ],
      [
        8,
        7
      ]
    ],
    [
      [
        23461,
        54010
      ],
      [
        -13,
        1
      ],
      [
        0,
        340
      ]
    ],
    [
      [
        26712,
        62357
      ],
      [
        9,
        -7
      ],
      [
        1,
        -13
      ],
      [
        5,
        -8
      ],
      [
        0,
        -23
      ],
      [
        1,
        -14
      ],
      [
        47,
        -4
      ],
      [
        12,
        0
      ],
      [
        54,
        -10
      ]
    ],
    [
      [
        26841,
        62278
      ],
      [
        15,
        -3
      ],
      [
        -2,
        -105
      ],
      [
        31,
        -7
      ]
    ],
    [
      [
        26885,
        62163
      ],
      [
        -3,
        -101
      ],
      [
        -1,
        -17
      ],
      [
        -9,
        3
      ],
      [
        -2,
        -69
      ],
      [
        -1,
        -16
      ],
      [
        -16,
        3
      ],
      [
        -1,
        -41
      ],
      [
        8,
        -55
      ],
      [
        -5,
        -8
      ],
      [
        -16,
        -23
      ]
    ],
    [
      [
        26839,
        61839
      ],
      [
        -2,
        2
      ],
      [
        -5,
        16
      ],
      [
        -1,
        5
      ],
      [
        -1,
        5
      ],
      [
        -1,
        11
      ],
      [
        -1,
        11
      ],
      [
        -1,
        8
      ],
      [
        0,
        30
      ],
      [
        -1,
        16
      ],
      [
        -1,
        11
      ],
      [
        -1,
        10
      ],
      [
        -2,
        5
      ],
      [
        -1,
        9
      ],
      [
        1,
        8
      ],
      [
        0,
        9
      ],
      [
        1,
        16
      ],
      [
        0,
        4
      ],
      [
        1,
        7
      ],
      [
        -1,
        13
      ],
      [
        0,
        4
      ],
      [
        -1,
        3
      ],
      [
        0,
        2
      ],
      [
        -1,
        5
      ],
      [
        -3,
        6
      ],
      [
        -1,
        0
      ],
      [
        -8,
        -7
      ],
      [
        -6,
        -8
      ],
      [
        -4,
        -10
      ],
      [
        -3,
        -7
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        0
      ],
      [
        -2,
        3
      ],
      [
        -2,
        1
      ],
      [
        -3,
        0
      ],
      [
        -3,
        -1
      ],
      [
        -2,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -9
      ],
      [
        0,
        -3
      ]
    ],
    [
      [
        12379,
        84716
      ],
      [
        1,
        -10
      ],
      [
        0,
        -26
      ],
      [
        2,
        -30
      ],
      [
        1,
        -6
      ],
      [
        3,
        -3
      ],
      [
        2,
        0
      ],
      [
        14,
        4
      ],
      [
        7,
        11
      ],
      [
        0,
        2
      ],
      [
        4,
        11
      ],
      [
        10,
        14
      ],
      [
        4,
        -13
      ],
      [
        7,
        -10
      ],
      [
        5,
        -3
      ],
      [
        6,
        -2
      ],
      [
        4,
        3
      ],
      [
        5,
        0
      ],
      [
        9,
        -7
      ],
      [
        3,
        -5
      ],
      [
        9,
        -17
      ],
      [
        12,
        -6
      ],
      [
        3,
        2
      ],
      [
        3,
        8
      ],
      [
        13,
        6
      ],
      [
        12,
        5
      ],
      [
        11,
        -2
      ],
      [
        0,
        -2
      ]
    ],
    [
      [
        12292,
        85061
      ],
      [
        2,
        -1
      ],
      [
        8,
        -17
      ],
      [
        6,
        -2
      ],
      [
        19,
        -25
      ],
      [
        14,
        -58
      ],
      [
        13,
        -67
      ],
      [
        -1,
        -4
      ],
      [
        -9,
        -1
      ],
      [
        -22,
        115
      ],
      [
        -10,
        2
      ],
      [
        -13,
        17
      ],
      [
        -8,
        34
      ],
      [
        1,
        7
      ]
    ],
    [
      [
        12487,
        85577
      ],
      [
        6,
        -5
      ],
      [
        -6,
        -46
      ],
      [
        17,
        -57
      ],
      [
        5,
        -14
      ],
      [
        72,
        -98
      ],
      [
        42,
        -54
      ],
      [
        32,
        -119
      ],
      [
        3,
        -9
      ],
      [
        4,
        -12
      ],
      [
        23,
        -60
      ],
      [
        16,
        -39
      ],
      [
        17,
        -38
      ],
      [
        33,
        -72
      ],
      [
        -23,
        -49
      ],
      [
        1,
        -3
      ],
      [
        20,
        -84
      ],
      [
        8,
        -31
      ],
      [
        4,
        -16
      ],
      [
        34,
        -98
      ],
      [
        3,
        -9
      ],
      [
        6,
        -19
      ],
      [
        4,
        -14
      ]
    ],
    [
      [
        12690,
        84293
      ],
      [
        -3,
        1
      ],
      [
        -6,
        -17
      ],
      [
        -1,
        -13
      ]
    ],
    [
      [
        12663,
        84216
      ],
      [
        0,
        1
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        1
      ],
      [
        -39,
        166
      ],
      [
        -55,
        147
      ],
      [
        -11,
        140
      ],
      [
        9,
        65
      ],
      [
        -2,
        52
      ],
      [
        14,
        13
      ],
      [
        13,
        28
      ],
      [
        -8,
        40
      ],
      [
        -5,
        60
      ],
      [
        -8,
        -2
      ],
      [
        -9,
        -85
      ],
      [
        -20,
        -30
      ],
      [
        0,
        -42
      ],
      [
        12,
        -22
      ],
      [
        -8,
        -19
      ],
      [
        -5,
        -38
      ],
      [
        -10,
        10
      ],
      [
        -22,
        -20
      ],
      [
        -25,
        11
      ],
      [
        -14,
        22
      ],
      [
        -22,
        12
      ],
      [
        -7,
        -15
      ],
      [
        -35,
        36
      ],
      [
        -17,
        75
      ],
      [
        -23,
        99
      ],
      [
        -4,
        110
      ],
      [
        -42,
        140
      ],
      [
        -13,
        79
      ],
      [
        19,
        1
      ],
      [
        -4,
        57
      ],
      [
        -2,
        62
      ],
      [
        -5,
        55
      ],
      [
        -11,
        -12
      ],
      [
        -1,
        -5
      ]
    ],
    [
      [
        24531,
        57528
      ],
      [
        0,
        52
      ],
      [
        14,
        0
      ],
      [
        27,
        -6
      ],
      [
        57,
        -2
      ],
      [
        15,
        0
      ],
      [
        20,
        1
      ],
      [
        59,
        -2
      ]
    ],
    [
      [
        24723,
        57571
      ],
      [
        0,
        -83
      ]
    ],
    [
      [
        24697,
        57850
      ],
      [
        28,
        5
      ],
      [
        -2,
        -170
      ],
      [
        0,
        -114
      ]
    ],
    [
      [
        25424,
        67218
      ],
      [
        2,
        -6
      ],
      [
        1,
        -19
      ],
      [
        -3,
        -25
      ],
      [
        -2,
        -13
      ],
      [
        0,
        -14
      ],
      [
        2,
        -13
      ],
      [
        5,
        -18
      ],
      [
        2,
        -20
      ],
      [
        0,
        -9
      ],
      [
        -1,
        -11
      ],
      [
        -3,
        -16
      ],
      [
        -4,
        -10
      ],
      [
        -1,
        -16
      ],
      [
        1,
        -15
      ],
      [
        3,
        -18
      ],
      [
        2,
        -9
      ],
      [
        2,
        -5
      ],
      [
        4,
        -12
      ],
      [
        3,
        -18
      ],
      [
        1,
        -21
      ],
      [
        0,
        -16
      ],
      [
        -1,
        -44
      ],
      [
        0,
        -4
      ],
      [
        3,
        -38
      ],
      [
        2,
        -17
      ]
    ],
    [
      [
        24750,
        68448
      ],
      [
        0,
        -108
      ]
    ],
    [
      [
        24750,
        68340
      ],
      [
        -34,
        6
      ],
      [
        -33,
        -1
      ],
      [
        -95,
        -2
      ],
      [
        -15,
        -13
      ],
      [
        -8,
        -20
      ],
      [
        1,
        -69
      ]
    ],
    [
      [
        24516,
        68252
      ],
      [
        0,
        195
      ],
      [
        -4,
        0
      ],
      [
        0,
        407
      ]
    ],
    [
      [
        29160,
        63798
      ],
      [
        1,
        -12
      ],
      [
        -18,
        -31
      ],
      [
        -5,
        -31
      ],
      [
        -9,
        -13
      ],
      [
        -6,
        4
      ],
      [
        8,
        -51
      ]
    ],
    [
      [
        27156,
        59531
      ],
      [
        21,
        -1
      ],
      [
        22,
        -8
      ],
      [
        6,
        -1
      ],
      [
        3,
        -1
      ],
      [
        4,
        2
      ],
      [
        9,
        -4
      ],
      [
        19,
        -3
      ],
      [
        6,
        0
      ]
    ],
    [
      [
        22947,
        71220
      ],
      [
        1,
        1
      ],
      [
        139,
        0
      ]
    ],
    [
      [
        23091,
        70512
      ],
      [
        -86,
        0
      ]
    ],
    [
      [
        22328,
        70417
      ],
      [
        -87,
        0
      ],
      [
        -8,
        1
      ],
      [
        -104,
        0
      ]
    ],
    [
      [
        22129,
        70418
      ],
      [
        -9,
        0
      ],
      [
        -24,
        1
      ],
      [
        -12,
        0
      ]
    ],
    [
      [
        22084,
        70419
      ],
      [
        1,
        397
      ]
    ],
    [
      [
        29731,
        68748
      ],
      [
        31,
        -51
      ],
      [
        28,
        -44
      ],
      [
        1,
        -4
      ],
      [
        0,
        -12
      ],
      [
        -14,
        -82
      ],
      [
        -14,
        -49
      ],
      [
        1,
        -30
      ],
      [
        -15,
        -80
      ]
    ],
    [
      [
        29749,
        68396
      ],
      [
        -14,
        20
      ],
      [
        -7,
        -107
      ],
      [
        -32,
        39
      ],
      [
        -1,
        -10
      ],
      [
        -7,
        7
      ],
      [
        -11,
        -83
      ],
      [
        -2,
        1
      ],
      [
        -14,
        -89
      ],
      [
        -16,
        19
      ]
    ],
    [
      [
        29645,
        68193
      ],
      [
        -22,
        27
      ],
      [
        -21,
        25
      ],
      [
        -3,
        -2
      ],
      [
        -7,
        106
      ],
      [
        -5,
        -2
      ]
    ],
    [
      [
        23066,
        66081
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        2,
        -9
      ],
      [
        1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        1,
        -9
      ],
      [
        -1,
        -11
      ],
      [
        0,
        -12
      ],
      [
        2,
        -7
      ],
      [
        1,
        -4
      ],
      [
        4,
        -7
      ],
      [
        1,
        -6
      ],
      [
        1,
        -4
      ],
      [
        1,
        -8
      ],
      [
        1,
        -4
      ],
      [
        1,
        -3
      ],
      [
        2,
        -2
      ],
      [
        4,
        -3
      ],
      [
        2,
        -3
      ],
      [
        1,
        -3
      ],
      [
        1,
        -2
      ],
      [
        0,
        -6
      ],
      [
        1,
        -4
      ],
      [
        0,
        -16
      ],
      [
        -1,
        -9
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -25
      ],
      [
        1,
        -10
      ],
      [
        0,
        -5
      ]
    ],
    [
      [
        23089,
        65886
      ],
      [
        -10,
        -1
      ],
      [
        0,
        -37
      ],
      [
        -42,
        3
      ],
      [
        -26,
        -2
      ]
    ],
    [
      [
        17231,
        64115
      ],
      [
        -67,
        -611
      ]
    ],
    [
      [
        17164,
        63504
      ],
      [
        -196,
        1
      ],
      [
        -273,
        -3
      ]
    ],
    [
      [
        29631,
        68114
      ],
      [
        14,
        79
      ]
    ],
    [
      [
        29749,
        68396
      ],
      [
        18,
        -24
      ],
      [
        36,
        11
      ],
      [
        3,
        -2
      ],
      [
        33,
        -39
      ],
      [
        2,
        1
      ]
    ],
    [
      [
        29841,
        68343
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -17
      ],
      [
        1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        -2,
        -8
      ],
      [
        0,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -11
      ],
      [
        4,
        -8
      ],
      [
        1,
        0
      ],
      [
        1,
        -2
      ],
      [
        0,
        -12
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        2,
        -5
      ],
      [
        -1,
        -7
      ],
      [
        -2,
        -4
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -6
      ],
      [
        1,
        -6
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -14
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        -8
      ],
      [
        0,
        -2
      ],
      [
        1,
        -5
      ],
      [
        1,
        -4
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -6
      ],
      [
        1,
        -1
      ],
      [
        3,
        -7
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -9
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -30
      ],
      [
        -1,
        -2
      ],
      [
        -4,
        -11
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        1
      ],
      [
        0,
        -12
      ],
      [
        1,
        -3
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -12
      ],
      [
        1,
        -9
      ],
      [
        0,
        -17
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -2
      ],
      [
        1,
        -6
      ],
      [
        1,
        -4
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -4
      ],
      [
        0,
        -18
      ]
    ],
    [
      [
        25685,
        69733
      ],
      [
        1,
        3
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        -1,
        9
      ],
      [
        -2,
        21
      ],
      [
        4,
        36
      ],
      [
        1,
        7
      ],
      [
        1,
        0
      ],
      [
        1,
        -4
      ],
      [
        1,
        -7
      ],
      [
        3,
        -4
      ],
      [
        7,
        1
      ],
      [
        4,
        6
      ],
      [
        4,
        -2
      ],
      [
        3,
        -8
      ],
      [
        6,
        6
      ],
      [
        0,
        18
      ],
      [
        1,
        3
      ],
      [
        3,
        -2
      ],
      [
        2,
        -5
      ],
      [
        1,
        -11
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        2
      ],
      [
        -2,
        -2
      ],
      [
        -5,
        -20
      ],
      [
        -3,
        -21
      ],
      [
        -3,
        -7
      ],
      [
        -1,
        -14
      ],
      [
        0,
        -14
      ],
      [
        -1,
        -9
      ],
      [
        -1,
        -3
      ],
      [
        -4,
        2
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -8
      ],
      [
        1,
        -17
      ],
      [
        0,
        -11
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        1
      ],
      [
        -2,
        18
      ],
      [
        -3,
        14
      ],
      [
        -4,
        11
      ],
      [
        -3,
        2
      ],
      [
        -2,
        8
      ],
      [
        0,
        12
      ]
    ],
    [
      [
        25568,
        69555
      ],
      [
        12,
        14
      ],
      [
        0,
        -14
      ],
      [
        -1,
        -30
      ],
      [
        3,
        -19
      ],
      [
        -14,
        23
      ],
      [
        0,
        26
      ]
    ],
    [
      [
        25468,
        68947
      ],
      [
        1,
        6
      ],
      [
        3,
        13
      ],
      [
        1,
        17
      ],
      [
        -1,
        13
      ],
      [
        0,
        6
      ],
      [
        4,
        16
      ],
      [
        5,
        24
      ],
      [
        12,
        47
      ],
      [
        2,
        17
      ],
      [
        8,
        29
      ],
      [
        8,
        15
      ],
      [
        2,
        2
      ],
      [
        7,
        -2
      ],
      [
        5,
        7
      ],
      [
        4,
        14
      ],
      [
        4,
        -6
      ],
      [
        7,
        -1
      ],
      [
        11,
        34
      ],
      [
        1,
        0
      ],
      [
        4,
        -6
      ],
      [
        0,
        -13
      ],
      [
        3,
        -17
      ],
      [
        1,
        -2
      ],
      [
        6,
        6
      ],
      [
        0,
        23
      ],
      [
        -1,
        6
      ],
      [
        -2,
        9
      ],
      [
        -3,
        8
      ],
      [
        0,
        8
      ],
      [
        2,
        16
      ],
      [
        1,
        11
      ],
      [
        2,
        5
      ],
      [
        3,
        20
      ],
      [
        4,
        37
      ],
      [
        7,
        30
      ],
      [
        4,
        24
      ],
      [
        5,
        21
      ],
      [
        6,
        13
      ],
      [
        5,
        21
      ],
      [
        1,
        13
      ],
      [
        0,
        15
      ],
      [
        1,
        19
      ],
      [
        2,
        11
      ],
      [
        3,
        7
      ],
      [
        -1,
        14
      ],
      [
        1,
        21
      ],
      [
        2,
        6
      ],
      [
        3,
        3
      ],
      [
        2,
        -11
      ],
      [
        5,
        -3
      ],
      [
        6,
        11
      ],
      [
        2,
        13
      ],
      [
        1,
        2
      ],
      [
        5,
        6
      ],
      [
        4,
        2
      ],
      [
        2,
        -3
      ],
      [
        1,
        1
      ],
      [
        1,
        17
      ],
      [
        -1,
        5
      ],
      [
        0,
        16
      ],
      [
        1,
        21
      ],
      [
        3,
        18
      ],
      [
        8,
        10
      ],
      [
        2,
        17
      ],
      [
        4,
        15
      ],
      [
        1,
        -8
      ],
      [
        3,
        -2
      ],
      [
        2,
        4
      ],
      [
        5,
        13
      ],
      [
        6,
        -1
      ],
      [
        3,
        -3
      ],
      [
        2,
        -6
      ],
      [
        2,
        -14
      ],
      [
        -1,
        -8
      ],
      [
        -3,
        -8
      ],
      [
        0,
        -7
      ],
      [
        1,
        -11
      ],
      [
        1,
        -4
      ],
      [
        1,
        1
      ],
      [
        -1,
        -22
      ],
      [
        -2,
        -14
      ],
      [
        -5,
        -5
      ],
      [
        -1,
        3
      ],
      [
        0,
        10
      ],
      [
        -7,
        0
      ],
      [
        -3,
        -13
      ],
      [
        -1,
        -44
      ],
      [
        0,
        -18
      ],
      [
        5,
        -14
      ],
      [
        -1,
        -5
      ],
      [
        -4,
        -8
      ],
      [
        -2,
        -17
      ],
      [
        1,
        -5
      ],
      [
        0,
        -31
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -10
      ],
      [
        -4,
        -10
      ],
      [
        -1,
        -13
      ],
      [
        -3,
        -5
      ],
      [
        -8,
        4
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -13
      ],
      [
        -4,
        -34
      ],
      [
        -4,
        -4
      ],
      [
        -3,
        -5
      ],
      [
        -5,
        -28
      ],
      [
        -2,
        -15
      ],
      [
        0,
        -23
      ],
      [
        4,
        -10
      ],
      [
        1,
        -10
      ],
      [
        -1,
        -4
      ],
      [
        -3,
        -3
      ],
      [
        -5,
        -10
      ],
      [
        -3,
        -12
      ],
      [
        -1,
        -10
      ],
      [
        3,
        -14
      ],
      [
        1,
        -12
      ],
      [
        -18,
        -33
      ],
      [
        -2,
        -16
      ],
      [
        -2,
        -22
      ],
      [
        -6,
        -12
      ],
      [
        -3,
        -12
      ],
      [
        -1,
        -10
      ],
      [
        0,
        -16
      ],
      [
        -5,
        -39
      ],
      [
        -2,
        -22
      ],
      [
        -3,
        -20
      ],
      [
        -4,
        -21
      ],
      [
        -1,
        -10
      ]
    ],
    [
      [
        26756,
        64659
      ],
      [
        -54,
        -1
      ],
      [
        -32,
        -1
      ]
    ],
    [
      [
        27304,
        54454
      ],
      [
        -14,
        13
      ],
      [
        -28,
        -85
      ],
      [
        -27,
        -80
      ]
    ],
    [
      [
        27223,
        54471
      ],
      [
        -1,
        39
      ],
      [
        -3,
        10
      ],
      [
        1,
        2
      ],
      [
        -1,
        14
      ],
      [
        -6,
        38
      ],
      [
        -4,
        5
      ],
      [
        -1,
        21
      ],
      [
        -5,
        7
      ],
      [
        0,
        16
      ],
      [
        -4,
        6
      ],
      [
        0,
        19
      ],
      [
        -4,
        0
      ],
      [
        1,
        16
      ],
      [
        -3,
        12
      ],
      [
        2,
        6
      ],
      [
        -1,
        15
      ],
      [
        4,
        17
      ],
      [
        -2,
        19
      ],
      [
        -3,
        0
      ],
      [
        2,
        17
      ],
      [
        -3,
        10
      ]
    ],
    [
      [
        27192,
        54760
      ],
      [
        2,
        23
      ],
      [
        42,
        100
      ]
    ],
    [
      [
        21273,
        66995
      ],
      [
        85,
        -1
      ],
      [
        113,
        0
      ]
    ],
    [
      [
        21492,
        65943
      ],
      [
        -1,
        -102
      ],
      [
        -16,
        0
      ]
    ],
    [
      [
        21475,
        65841
      ],
      [
        -170,
        -4
      ]
    ],
    [
      [
        21305,
        65837
      ],
      [
        -6,
        -1
      ]
    ],
    [
      [
        22718,
        67577
      ],
      [
        0,
        269
      ],
      [
        -1,
        37
      ],
      [
        0,
        100
      ]
    ],
    [
      [
        25205,
        69764
      ],
      [
        70,
        -2
      ]
    ],
    [
      [
        25460,
        69283
      ],
      [
        -1,
        -1
      ],
      [
        -13,
        -13
      ],
      [
        -1,
        -3
      ],
      [
        -6,
        -23
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -14
      ],
      [
        1,
        -8
      ],
      [
        3,
        -17
      ],
      [
        -1,
        -12
      ],
      [
        -2,
        -8
      ],
      [
        -3,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -9
      ],
      [
        -4,
        -20
      ],
      [
        -3,
        -1
      ],
      [
        -6,
        -14
      ],
      [
        -1,
        -10
      ],
      [
        -6,
        -47
      ],
      [
        -4,
        -26
      ],
      [
        -3,
        -3
      ],
      [
        -4,
        -12
      ],
      [
        -5,
        -27
      ],
      [
        -2,
        -39
      ],
      [
        0,
        -10
      ]
    ],
    [
      [
        25397,
        68948
      ],
      [
        -39,
        -1
      ],
      [
        -27,
        -5
      ],
      [
        -1,
        0
      ],
      [
        0,
        8
      ],
      [
        -3,
        0
      ]
    ],
    [
      [
        25327,
        68950
      ],
      [
        -3,
        101
      ],
      [
        1,
        101
      ],
      [
        -67,
        3
      ]
    ],
    [
      [
        8956,
        90834
      ],
      [
        0,
        -2
      ],
      [
        -285,
        0
      ],
      [
        0,
        -168
      ],
      [
        -418,
        0
      ],
      [
        -205,
        -194
      ],
      [
        -128,
        -120
      ],
      [
        -154,
        -145
      ],
      [
        -173,
        -164
      ],
      [
        0,
        -84
      ],
      [
        -291,
        0
      ],
      [
        -17,
        2
      ]
    ],
    [
      [
        29282,
        64306
      ],
      [
        -4,
        -13
      ],
      [
        -3,
        -21
      ]
    ],
    [
      [
        29275,
        64272
      ],
      [
        -3,
        -2
      ],
      [
        -1,
        -9
      ],
      [
        -4,
        -4
      ],
      [
        -4,
        -1
      ],
      [
        -4,
        -4
      ],
      [
        -4,
        -2
      ],
      [
        -5,
        3
      ]
    ],
    [
      [
        29250,
        64253
      ],
      [
        5,
        27
      ],
      [
        2,
        8
      ]
    ],
    [
      [
        19456,
        67942
      ],
      [
        1,
        -9
      ],
      [
        10,
        -11
      ],
      [
        3,
        -26
      ],
      [
        8,
        -12
      ],
      [
        11,
        -61
      ],
      [
        7,
        -14
      ],
      [
        0,
        -93
      ],
      [
        66,
        0
      ],
      [
        0,
        -17
      ],
      [
        33,
        0
      ],
      [
        0,
        -34
      ],
      [
        34,
        0
      ],
      [
        -1,
        -51
      ],
      [
        34,
        1
      ],
      [
        0,
        -34
      ],
      [
        33,
        0
      ],
      [
        0,
        -34
      ],
      [
        33,
        0
      ],
      [
        0,
        -17
      ],
      [
        51,
        0
      ],
      [
        0,
        13
      ],
      [
        156,
        2
      ],
      [
        0,
        33
      ]
    ],
    [
      [
        19955,
        66336
      ],
      [
        0,
        -201
      ]
    ],
    [
      [
        26836,
        63264
      ],
      [
        1,
        34
      ],
      [
        5,
        -1
      ],
      [
        1,
        42
      ],
      [
        2,
        60
      ],
      [
        -6,
        1
      ],
      [
        1,
        34
      ],
      [
        8,
        -2
      ]
    ],
    [
      [
        26937,
        63422
      ],
      [
        -3,
        -109
      ],
      [
        21,
        -5
      ],
      [
        -2,
        -103
      ],
      [
        11,
        -2
      ],
      [
        -2,
        -102
      ]
    ],
    [
      [
        23969,
        55881
      ],
      [
        -1,
        -84
      ],
      [
        29,
        -3
      ],
      [
        10,
        -1
      ]
    ],
    [
      [
        24007,
        55793
      ],
      [
        -2,
        -325
      ],
      [
        -1,
        -94
      ]
    ],
    [
      [
        24718,
        66777
      ],
      [
        99,
        1
      ],
      [
        65,
        0
      ]
    ],
    [
      [
        24882,
        66778
      ],
      [
        0,
        -359
      ]
    ],
    [
      [
        29305,
        64360
      ],
      [
        3,
        3
      ],
      [
        6,
        -12
      ],
      [
        1,
        -3
      ],
      [
        1,
        -11
      ],
      [
        3,
        -14
      ],
      [
        1,
        -8
      ],
      [
        4,
        -18
      ],
      [
        4,
        10
      ],
      [
        3,
        4
      ],
      [
        1,
        -15
      ],
      [
        1,
        -1
      ],
      [
        0,
        -7
      ],
      [
        1,
        -4
      ],
      [
        1,
        -33
      ],
      [
        2,
        1
      ],
      [
        4,
        -18
      ],
      [
        0,
        -25
      ],
      [
        -4,
        -21
      ],
      [
        -10,
        -17
      ],
      [
        -14,
        -6
      ]
    ],
    [
      [
        29313,
        64165
      ],
      [
        1,
        8
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -3,
        -1
      ],
      [
        -2,
        -1
      ],
      [
        -9,
        -3
      ],
      [
        -6,
        4
      ],
      [
        3,
        10
      ],
      [
        1,
        2
      ],
      [
        -1,
        13
      ],
      [
        -2,
        2
      ],
      [
        -6,
        8
      ],
      [
        -1,
        5
      ],
      [
        0,
        1
      ],
      [
        -1,
        4
      ],
      [
        -1,
        14
      ],
      [
        0,
        5
      ],
      [
        1,
        9
      ],
      [
        1,
        5
      ],
      [
        0,
        4
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        0,
        3
      ],
      [
        3,
        9
      ],
      [
        -1,
        23
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        23236,
        69803
      ],
      [
        69,
        -1
      ],
      [
        68,
        1
      ]
    ],
    [
      [
        24848,
        59579
      ],
      [
        72,
        -2
      ],
      [
        1,
        131
      ],
      [
        -2,
        139
      ],
      [
        4,
        0
      ]
    ],
    [
      [
        24999,
        59427
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -9
      ],
      [
        -2,
        -8
      ],
      [
        -3,
        -12
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -3,
        5
      ],
      [
        -1,
        4
      ],
      [
        -1,
        6
      ],
      [
        0,
        10
      ],
      [
        2,
        19
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        24965,
        59426
      ],
      [
        2,
        -8
      ],
      [
        3,
        -11
      ],
      [
        1,
        -3
      ],
      [
        0,
        -14
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        -4,
        -12
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -17
      ],
      [
        1,
        -5
      ],
      [
        4,
        -22
      ],
      [
        3,
        -19
      ],
      [
        1,
        -7
      ],
      [
        1,
        -4
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -16
      ],
      [
        -2,
        -13
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -1
      ]
    ],
    [
      [
        24882,
        66778
      ],
      [
        0,
        51
      ]
    ],
    [
      [
        17310,
        64667
      ],
      [
        120,
        0
      ]
    ],
    [
      [
        17426,
        62527
      ],
      [
        -63,
        0
      ],
      [
        -141,
        2
      ],
      [
        -123,
        -82
      ]
    ],
    [
      [
        17099,
        62447
      ],
      [
        -3,
        15
      ],
      [
        -5,
        11
      ],
      [
        3,
        19
      ],
      [
        -4,
        16
      ],
      [
        6,
        6
      ],
      [
        -2,
        12
      ],
      [
        3,
        17
      ],
      [
        3,
        -2
      ],
      [
        7,
        20
      ],
      [
        3,
        22
      ],
      [
        4,
        4
      ],
      [
        2,
        37
      ],
      [
        -3,
        6
      ],
      [
        -3,
        36
      ],
      [
        -5,
        35
      ],
      [
        -3,
        48
      ],
      [
        1,
        19
      ],
      [
        4,
        20
      ],
      [
        4,
        -7
      ],
      [
        10,
        7
      ],
      [
        6,
        44
      ],
      [
        8,
        3
      ],
      [
        2,
        30
      ],
      [
        -4,
        6
      ],
      [
        -1,
        12
      ],
      [
        9,
        10
      ],
      [
        2,
        16
      ],
      [
        8,
        15
      ],
      [
        -1,
        17
      ],
      [
        7,
        2
      ],
      [
        1,
        8
      ],
      [
        8,
        3
      ],
      [
        4,
        11
      ],
      [
        2,
        -8
      ],
      [
        7,
        17
      ],
      [
        3,
        44
      ],
      [
        -2,
        17
      ],
      [
        6,
        28
      ],
      [
        0,
        12
      ],
      [
        -7,
        14
      ],
      [
        6,
        36
      ],
      [
        -6,
        33
      ],
      [
        3,
        37
      ],
      [
        -5,
        15
      ],
      [
        0,
        30
      ],
      [
        2,
        14
      ],
      [
        0,
        47
      ],
      [
        4,
        14
      ],
      [
        2,
        23
      ],
      [
        1,
        33
      ],
      [
        -2,
        41
      ],
      [
        -3,
        20
      ],
      [
        -6,
        14
      ],
      [
        -2,
        20
      ],
      [
        -9,
        38
      ]
    ],
    [
      [
        16678,
        63062
      ],
      [
        -54,
        -331
      ],
      [
        -22,
        -38
      ],
      [
        -25,
        -44
      ],
      [
        -18,
        -18
      ]
    ],
    [
      [
        26782,
        52851
      ],
      [
        -2,
        18
      ],
      [
        1,
        19
      ],
      [
        0,
        25
      ],
      [
        -4,
        15
      ],
      [
        -2,
        37
      ],
      [
        -38,
        3
      ],
      [
        0,
        88
      ],
      [
        -5,
        0
      ]
    ],
    [
      [
        20636,
        67575
      ],
      [
        -1,
        5
      ],
      [
        0,
        540
      ],
      [
        1,
        244
      ]
    ],
    [
      [
        27885,
        66457
      ],
      [
        7,
        6
      ],
      [
        13,
        -25
      ],
      [
        1,
        -19
      ],
      [
        5,
        -14
      ],
      [
        3,
        -24
      ],
      [
        4,
        -5
      ],
      [
        6,
        -17
      ],
      [
        0,
        -13
      ],
      [
        5,
        8
      ],
      [
        5,
        -13
      ],
      [
        2,
        4
      ],
      [
        11,
        2
      ],
      [
        12,
        22
      ],
      [
        4,
        -8
      ],
      [
        5,
        18
      ],
      [
        6,
        2
      ],
      [
        1,
        9
      ],
      [
        10,
        6
      ],
      [
        1,
        -16
      ],
      [
        10,
        24
      ],
      [
        4,
        -2
      ],
      [
        2,
        9
      ],
      [
        8,
        5
      ],
      [
        4,
        11
      ],
      [
        9,
        -4
      ],
      [
        10,
        15
      ],
      [
        18,
        17
      ]
    ],
    [
      [
        28094,
        65830
      ],
      [
        -80,
        1
      ],
      [
        -43,
        -2
      ],
      [
        -34,
        -1
      ],
      [
        -13,
        1
      ]
    ],
    [
      [
        27924,
        65829
      ],
      [
        -18,
        1
      ],
      [
        -21,
        0
      ]
    ],
    [
      [
        27885,
        65830
      ],
      [
        0,
        627
      ]
    ],
    [
      [
        31513,
        38417
      ],
      [
        -1,
        -7
      ],
      [
        3,
        -19
      ],
      [
        2,
        -4
      ],
      [
        9,
        -24
      ],
      [
        -2,
        -27
      ]
    ],
    [
      [
        31524,
        38336
      ],
      [
        -7,
        -1
      ],
      [
        -3,
        -11
      ],
      [
        1,
        -17
      ],
      [
        -1,
        -13
      ],
      [
        0,
        -28
      ],
      [
        -2,
        -9
      ]
    ],
    [
      [
        31488,
        38443
      ],
      [
        1,
        0
      ],
      [
        2,
        -3
      ],
      [
        7,
        -4
      ],
      [
        2,
        -4
      ],
      [
        0,
        -1
      ],
      [
        1,
        0
      ],
      [
        2,
        -5
      ],
      [
        9,
        -5
      ],
      [
        1,
        1
      ],
      [
        0,
        -5
      ]
    ],
    [
      [
        31524,
        38336
      ],
      [
        2,
        -4
      ],
      [
        0,
        -12
      ],
      [
        3,
        -9
      ],
      [
        7,
        -47
      ],
      [
        5,
        -11
      ],
      [
        -1,
        -18
      ]
    ],
    [
      [
        31540,
        38235
      ],
      [
        -8,
        19
      ],
      [
        -14,
        -6
      ]
    ],
    [
      [
        23655,
        65253
      ],
      [
        0,
        113
      ],
      [
        -10,
        1
      ],
      [
        -1,
        304
      ]
    ],
    [
      [
        21561,
        52197
      ],
      [
        -1,
        -588
      ]
    ],
    [
      [
        21560,
        51609
      ],
      [
        0,
        2
      ],
      [
        -4,
        6
      ],
      [
        -3,
        -1
      ],
      [
        -1,
        -7
      ],
      [
        -2,
        0
      ],
      [
        -2,
        4
      ],
      [
        -1,
        5
      ],
      [
        -2,
        3
      ],
      [
        -4,
        -4
      ],
      [
        -6,
        14
      ],
      [
        -3,
        -2
      ],
      [
        -4,
        -7
      ],
      [
        -4,
        5
      ],
      [
        -6,
        0
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        8
      ],
      [
        -2,
        2
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        2
      ],
      [
        -2,
        10
      ],
      [
        -1,
        3
      ],
      [
        -1,
        0
      ],
      [
        -4,
        -11
      ],
      [
        -4,
        5
      ],
      [
        -5,
        -3
      ],
      [
        -4,
        2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -8
      ],
      [
        0,
        -2
      ],
      [
        -3,
        -7
      ],
      [
        -7,
        2
      ],
      [
        -1,
        6
      ],
      [
        -2,
        3
      ],
      [
        -2,
        -2
      ],
      [
        -6,
        -1
      ],
      [
        -8,
        13
      ],
      [
        -5,
        13
      ],
      [
        0,
        6
      ],
      [
        -6,
        31
      ],
      [
        -1,
        3
      ],
      [
        -1,
        0
      ],
      [
        -4,
        -7
      ],
      [
        -7,
        1
      ],
      [
        -9,
        11
      ],
      [
        -1,
        3
      ],
      [
        1,
        10
      ],
      [
        -1,
        4
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -6
      ],
      [
        -2,
        1
      ],
      [
        -4,
        14
      ],
      [
        -1,
        3
      ],
      [
        -4,
        2
      ],
      [
        -2,
        -1
      ]
    ],
    [
      [
        26676,
        57055
      ],
      [
        7,
        11
      ],
      [
        55,
        8
      ],
      [
        20,
        69
      ]
    ],
    [
      [
        26688,
        56779
      ],
      [
        5,
        43
      ],
      [
        -15,
        74
      ],
      [
        3,
        79
      ],
      [
        0,
        43
      ],
      [
        -5,
        37
      ]
    ],
    [
      [
        25197,
        60708
      ],
      [
        -31,
        2
      ],
      [
        -5,
        -4
      ],
      [
        -57,
        -1
      ]
    ],
    [
      [
        25073,
        60709
      ],
      [
        0,
        160
      ],
      [
        1,
        145
      ]
    ],
    [
      [
        27344,
        65251
      ],
      [
        134,
        -2
      ]
    ],
    [
      [
        27478,
        64822
      ],
      [
        -75,
        1
      ],
      [
        -59,
        0
      ]
    ],
    [
      [
        25135,
        64583
      ],
      [
        0,
        -203
      ]
    ],
    [
      [
        25135,
        64380
      ],
      [
        -16,
        -2
      ],
      [
        1,
        -101
      ],
      [
        -17,
        -2
      ],
      [
        0,
        -42
      ],
      [
        -16,
        -3
      ],
      [
        0,
        -15
      ],
      [
        -9,
        -1
      ],
      [
        0,
        -17
      ],
      [
        -6,
        0
      ],
      [
        -31,
        -3
      ]
    ],
    [
      [
        24961,
        64373
      ],
      [
        0,
        15
      ],
      [
        -2,
        38
      ],
      [
        9,
        49
      ],
      [
        1,
        16
      ],
      [
        7,
        30
      ],
      [
        8,
        54
      ]
    ],
    [
      [
        19966,
        60755
      ],
      [
        0,
        -253
      ]
    ],
    [
      [
        27171,
        63760
      ],
      [
        2,
        171
      ],
      [
        -27,
        3
      ],
      [
        1,
        86
      ]
    ],
    [
      [
        23962,
        70173
      ],
      [
        -1,
        292
      ],
      [
        25,
        0
      ],
      [
        0,
        206
      ]
    ],
    [
      [
        23972,
        56259
      ],
      [
        5,
        -1
      ],
      [
        2,
        11
      ],
      [
        5,
        1
      ],
      [
        8,
        -20
      ],
      [
        7,
        11
      ],
      [
        4,
        -2
      ],
      [
        15,
        27
      ],
      [
        0,
        13
      ],
      [
        6,
        12
      ],
      [
        6,
        -18
      ],
      [
        1,
        4
      ]
    ],
    [
      [
        24031,
        56297
      ],
      [
        2,
        0
      ],
      [
        84,
        -9
      ]
    ],
    [
      [
        24122,
        55782
      ],
      [
        -8,
        7
      ],
      [
        -2,
        -11
      ],
      [
        -6,
        -6
      ],
      [
        -6,
        11
      ],
      [
        -4,
        -15
      ],
      [
        -6,
        11
      ],
      [
        -10,
        7
      ],
      [
        -1,
        13
      ],
      [
        -11,
        7
      ],
      [
        -5,
        -15
      ],
      [
        -7,
        -3
      ],
      [
        -39,
        4
      ],
      [
        -10,
        1
      ]
    ],
    [
      [
        26969,
        65165
      ],
      [
        4,
        3
      ],
      [
        12,
        -3
      ],
      [
        6,
        3
      ],
      [
        4,
        4
      ],
      [
        17,
        35
      ],
      [
        1,
        5
      ],
      [
        1,
        6
      ],
      [
        0,
        1
      ],
      [
        1,
        -3
      ],
      [
        5,
        3
      ],
      [
        20,
        24
      ],
      [
        9,
        9
      ],
      [
        14,
        15
      ],
      [
        4,
        -1
      ],
      [
        2,
        -3
      ],
      [
        6,
        -7
      ]
    ],
    [
      [
        27075,
        65256
      ],
      [
        -1,
        -33
      ],
      [
        0,
        -147
      ],
      [
        26,
        -1
      ],
      [
        0,
        -88
      ]
    ],
    [
      [
        26970,
        64997
      ],
      [
        0,
        86
      ],
      [
        -1,
        82
      ]
    ],
    [
      [
        26820,
        58472
      ],
      [
        9,
        27
      ],
      [
        12,
        -18
      ],
      [
        3,
        11
      ],
      [
        13,
        13
      ],
      [
        5,
        18
      ],
      [
        5,
        -5
      ],
      [
        1,
        18
      ],
      [
        5,
        1
      ],
      [
        6,
        -9
      ],
      [
        -2,
        10
      ],
      [
        4,
        4
      ],
      [
        42,
        75
      ],
      [
        10,
        -5
      ],
      [
        4,
        13
      ],
      [
        8,
        -1
      ],
      [
        7,
        11
      ]
    ],
    [
      [
        26989,
        58502
      ],
      [
        -5,
        -23
      ],
      [
        4,
        -20
      ],
      [
        -2,
        -16
      ],
      [
        6,
        -47
      ],
      [
        -4,
        -5
      ],
      [
        -3,
        -20
      ],
      [
        11,
        -37
      ],
      [
        9,
        -8
      ],
      [
        14,
        -29
      ]
    ],
    [
      [
        26992,
        58227
      ],
      [
        -19,
        38
      ],
      [
        -7,
        -13
      ],
      [
        -3,
        -5
      ],
      [
        0,
        -21
      ],
      [
        1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        2,
        -5
      ],
      [
        -15,
        16
      ],
      [
        -9,
        -20
      ],
      [
        -2,
        -9
      ],
      [
        -11,
        -5
      ],
      [
        -11,
        -1
      ],
      [
        0,
        -33
      ],
      [
        -4,
        10
      ],
      [
        0,
        23
      ],
      [
        -6,
        -16
      ],
      [
        -11,
        14
      ],
      [
        -3,
        -9
      ],
      [
        -9,
        23
      ],
      [
        -6,
        5
      ],
      [
        -12,
        -13
      ],
      [
        -8,
        -29
      ]
    ],
    [
      [
        24600,
        58809
      ],
      [
        51,
        -2
      ],
      [
        18,
        -1
      ],
      [
        40,
        0
      ],
      [
        20,
        -1
      ],
      [
        3,
        36
      ]
    ],
    [
      [
        20952,
        56614
      ],
      [
        29,
        0
      ],
      [
        0,
        -306
      ],
      [
        34,
        0
      ],
      [
        0,
        -190
      ],
      [
        58,
        1
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        21103,
        65835
      ],
      [
        -181,
        -2
      ]
    ],
    [
      [
        24091,
        56692
      ],
      [
        51,
        -6
      ],
      [
        1,
        -13
      ],
      [
        6,
        5
      ],
      [
        6,
        -17
      ],
      [
        6,
        3
      ],
      [
        6,
        -11
      ],
      [
        3,
        -13
      ],
      [
        5,
        -21
      ],
      [
        1,
        -13
      ],
      [
        10,
        -18
      ]
    ],
    [
      [
        24031,
        56297
      ],
      [
        -2,
        7
      ],
      [
        3,
        12
      ],
      [
        -1,
        9
      ],
      [
        4,
        4
      ],
      [
        -1,
        21
      ],
      [
        -5,
        2
      ],
      [
        -3,
        48
      ],
      [
        5,
        5
      ],
      [
        -4,
        6
      ],
      [
        0,
        12
      ],
      [
        -8,
        23
      ],
      [
        -1,
        27
      ],
      [
        -6,
        15
      ],
      [
        3,
        14
      ],
      [
        16,
        -3
      ],
      [
        1,
        134
      ],
      [
        1,
        67
      ]
    ],
    [
      [
        27082,
        58800
      ],
      [
        12,
        46
      ],
      [
        5,
        -8
      ],
      [
        3,
        -19
      ],
      [
        7,
        -2
      ],
      [
        11,
        -15
      ]
    ],
    [
      [
        27243,
        58576
      ],
      [
        -19,
        -105
      ],
      [
        -12,
        -47
      ],
      [
        -9,
        -34
      ],
      [
        -8,
        -46
      ]
    ],
    [
      [
        27115,
        58352
      ],
      [
        -13,
        168
      ],
      [
        -32,
        102
      ],
      [
        3,
        16
      ],
      [
        5,
        -2
      ],
      [
        5,
        21
      ],
      [
        4,
        7
      ],
      [
        5,
        47
      ],
      [
        -1,
        25
      ],
      [
        -5,
        31
      ],
      [
        1,
        6
      ],
      [
        -5,
        27
      ]
    ],
    [
      [
        27071,
        58743
      ],
      [
        8,
        18
      ],
      [
        -3,
        18
      ],
      [
        6,
        21
      ]
    ],
    [
      [
        26738,
        54013
      ],
      [
        -1,
        37
      ],
      [
        -7,
        6
      ],
      [
        0,
        18
      ]
    ],
    [
      [
        26887,
        48823
      ],
      [
        27,
        0
      ],
      [
        4,
        -1
      ],
      [
        23,
        0
      ],
      [
        0,
        -3
      ],
      [
        3,
        1
      ],
      [
        52,
        -1
      ],
      [
        -1,
        -204
      ],
      [
        1,
        -2
      ],
      [
        54,
        -1
      ]
    ],
    [
      [
        26961,
        48307
      ],
      [
        -7,
        45
      ],
      [
        -5,
        42
      ],
      [
        -7,
        46
      ],
      [
        -4,
        46
      ],
      [
        -2,
        13
      ],
      [
        -1,
        3
      ],
      [
        -2,
        32
      ],
      [
        -6,
        45
      ],
      [
        -4,
        32
      ],
      [
        0,
        1
      ],
      [
        -8,
        54
      ],
      [
        -1,
        8
      ],
      [
        -4,
        9
      ],
      [
        -3,
        12
      ],
      [
        0,
        22
      ],
      [
        -2,
        13
      ],
      [
        -6,
        31
      ],
      [
        -7,
        30
      ],
      [
        -5,
        32
      ]
    ],
    [
      [
        26909,
        56467
      ],
      [
        -11,
        28
      ],
      [
        -6,
        3
      ],
      [
        -4,
        -11
      ],
      [
        -2,
        13
      ]
    ],
    [
      [
        26886,
        56500
      ],
      [
        -3,
        8
      ],
      [
        -13,
        -11
      ],
      [
        -4,
        4
      ],
      [
        -10,
        -15
      ],
      [
        -7,
        -1
      ]
    ],
    [
      [
        26849,
        56485
      ],
      [
        -13,
        15
      ],
      [
        -3,
        10
      ],
      [
        -2,
        -10
      ],
      [
        -6,
        -1
      ],
      [
        -5,
        19
      ],
      [
        -17,
        18
      ],
      [
        0,
        15
      ],
      [
        -9,
        18
      ]
    ],
    [
      [
        26655,
        53063
      ],
      [
        25,
        -3
      ],
      [
        25,
        -2
      ]
    ],
    [
      [
        26749,
        52588
      ],
      [
        -5,
        2
      ],
      [
        -2,
        1
      ],
      [
        -3,
        0
      ],
      [
        -4,
        1
      ],
      [
        -24,
        6
      ]
    ],
    [
      [
        26688,
        52604
      ],
      [
        -2,
        25
      ],
      [
        -9,
        19
      ],
      [
        -5,
        -2
      ],
      [
        -1,
        14
      ],
      [
        -6,
        4
      ],
      [
        -8,
        34
      ],
      [
        0,
        15
      ],
      [
        -5,
        25
      ],
      [
        8,
        15
      ],
      [
        -1,
        15
      ],
      [
        4,
        31
      ],
      [
        -1,
        15
      ],
      [
        7,
        -3
      ],
      [
        3,
        16
      ],
      [
        5,
        -4
      ],
      [
        9,
        14
      ],
      [
        3,
        5
      ],
      [
        2,
        13
      ],
      [
        -3,
        22
      ],
      [
        -4,
        14
      ],
      [
        -8,
        0
      ],
      [
        -5,
        6
      ],
      [
        -6,
        18
      ],
      [
        0,
        40
      ],
      [
        3,
        11
      ],
      [
        -4,
        43
      ],
      [
        -6,
        24
      ],
      [
        -1,
        26
      ],
      [
        -2,
        4
      ]
    ],
    [
      [
        26385,
        54844
      ],
      [
        -13,
        0
      ],
      [
        0,
        -16
      ],
      [
        -4,
        -7
      ],
      [
        -13,
        1
      ],
      [
        -1,
        7
      ],
      [
        -3,
        -10
      ],
      [
        1,
        -14
      ],
      [
        -6,
        -6
      ],
      [
        -6,
        14
      ],
      [
        -4,
        -6
      ],
      [
        -5,
        6
      ]
    ],
    [
      [
        26315,
        54794
      ],
      [
        4,
        15
      ],
      [
        0,
        5
      ],
      [
        4,
        33
      ],
      [
        -8,
        -1
      ],
      [
        0,
        24
      ]
    ],
    [
      [
        26315,
        54870
      ],
      [
        0,
        119
      ],
      [
        -2,
        17
      ],
      [
        2,
        8
      ],
      [
        1,
        17
      ],
      [
        2,
        9
      ],
      [
        -1,
        0
      ],
      [
        -1,
        10
      ],
      [
        0,
        106
      ],
      [
        -3,
        17
      ]
    ],
    [
      [
        28109,
        56983
      ],
      [
        6,
        -29
      ],
      [
        7,
        -7
      ],
      [
        2,
        -17
      ],
      [
        11,
        4
      ]
    ],
    [
      [
        26514,
        57005
      ],
      [
        17,
        49
      ],
      [
        -3,
        11
      ],
      [
        6,
        -12
      ],
      [
        18,
        44
      ],
      [
        0,
        10
      ]
    ],
    [
      [
        26602,
        57104
      ],
      [
        14,
        -83
      ]
    ],
    [
      [
        26616,
        57021
      ],
      [
        -11,
        -37
      ],
      [
        -4,
        -40
      ],
      [
        5,
        -26
      ],
      [
        0,
        -26
      ],
      [
        8,
        -30
      ]
    ],
    [
      [
        26614,
        56862
      ],
      [
        -10,
        -39
      ],
      [
        -11,
        -36
      ],
      [
        -16,
        -59
      ],
      [
        -5,
        -18
      ],
      [
        -13,
        -43
      ]
    ],
    [
      [
        26491,
        56714
      ],
      [
        2,
        18
      ],
      [
        7,
        14
      ],
      [
        12,
        0
      ],
      [
        4,
        38
      ],
      [
        7,
        13
      ],
      [
        -1,
        26
      ],
      [
        -1,
        7
      ],
      [
        8,
        22
      ],
      [
        -2,
        -2
      ],
      [
        -4,
        32
      ],
      [
        1,
        20
      ],
      [
        -3,
        5
      ]
    ],
    [
      [
        24418,
        63736
      ],
      [
        1,
        0
      ],
      [
        164,
        -9
      ]
    ],
    [
      [
        24437,
        63439
      ],
      [
        0,
        1
      ],
      [
        -2,
        6
      ],
      [
        -1,
        9
      ],
      [
        -1,
        7
      ],
      [
        -1,
        7
      ],
      [
        -1,
        9
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        0,
        3
      ],
      [
        -1,
        4
      ],
      [
        0,
        9
      ],
      [
        -3,
        16
      ],
      [
        -1,
        12
      ],
      [
        -1,
        5
      ],
      [
        -2,
        15
      ],
      [
        1,
        24
      ],
      [
        -2,
        16
      ],
      [
        0,
        9
      ],
      [
        -1,
        15
      ],
      [
        -2,
        19
      ],
      [
        0,
        17
      ],
      [
        -1,
        7
      ],
      [
        0,
        24
      ],
      [
        1,
        9
      ],
      [
        0,
        1
      ],
      [
        -1,
        15
      ],
      [
        -1,
        9
      ],
      [
        0,
        3
      ],
      [
        1,
        9
      ],
      [
        0,
        3
      ],
      [
        2,
        5
      ],
      [
        0,
        6
      ]
    ],
    [
      [
        26551,
        54736
      ],
      [
        9,
        -34
      ],
      [
        5,
        8
      ],
      [
        0,
        58
      ],
      [
        3,
        19
      ],
      [
        2,
        -8
      ],
      [
        9,
        -1
      ],
      [
        0,
        34
      ],
      [
        7,
        -15
      ],
      [
        1,
        12
      ],
      [
        0,
        120
      ],
      [
        -3,
        19
      ],
      [
        6,
        0
      ],
      [
        0,
        28
      ],
      [
        2,
        19
      ]
    ],
    [
      [
        26592,
        54995
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        26621,
        54963
      ],
      [
        11,
        -13
      ],
      [
        4,
        -31
      ],
      [
        2,
        -46
      ],
      [
        -3,
        -17
      ],
      [
        3,
        -50
      ],
      [
        -1,
        -5
      ],
      [
        6,
        -30
      ],
      [
        8,
        -16
      ],
      [
        -2,
        -38
      ]
    ],
    [
      [
        23566,
        53095
      ],
      [
        8,
        -3
      ],
      [
        7,
        -16
      ],
      [
        6,
        -4
      ],
      [
        4,
        -16
      ],
      [
        4,
        9
      ]
    ],
    [
      [
        23571,
        52475
      ],
      [
        -32,
        565
      ],
      [
        27,
        55
      ]
    ],
    [
      [
        23856,
        69095
      ],
      [
        18,
        -1
      ],
      [
        5,
        11
      ],
      [
        11,
        -16
      ],
      [
        5,
        -16
      ],
      [
        7,
        0
      ],
      [
        1,
        5
      ],
      [
        4,
        -4
      ],
      [
        2,
        6
      ]
    ],
    [
      [
        23909,
        69080
      ],
      [
        0,
        -15
      ],
      [
        1,
        -4
      ],
      [
        0,
        -67
      ],
      [
        3,
        0
      ],
      [
        -1,
        -42
      ],
      [
        0,
        -59
      ],
      [
        12,
        0
      ],
      [
        0,
        -101
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        24989,
        55687
      ],
      [
        38,
        0
      ],
      [
        0,
        -206
      ]
    ],
    [
      [
        26847,
        62535
      ],
      [
        -6,
        -257
      ]
    ],
    [
      [
        27689,
        66145
      ],
      [
        13,
        17
      ],
      [
        20,
        36
      ],
      [
        14,
        30
      ],
      [
        13,
        26
      ],
      [
        10,
        22
      ],
      [
        10,
        25
      ],
      [
        6,
        8
      ],
      [
        7,
        20
      ],
      [
        7,
        29
      ],
      [
        6,
        16
      ],
      [
        6,
        16
      ],
      [
        3,
        10
      ],
      [
        2,
        1
      ],
      [
        2,
        -2
      ],
      [
        1,
        1
      ],
      [
        3,
        7
      ],
      [
        1,
        6
      ],
      [
        10,
        13
      ],
      [
        5,
        14
      ],
      [
        6,
        10
      ],
      [
        5,
        5
      ],
      [
        9,
        11
      ],
      [
        12,
        9
      ],
      [
        3,
        13
      ],
      [
        1,
        6
      ]
    ],
    [
      [
        27864,
        66494
      ],
      [
        8,
        0
      ],
      [
        4,
        -21
      ],
      [
        9,
        -16
      ]
    ],
    [
      [
        27885,
        65830
      ],
      [
        -33,
        0
      ],
      [
        -20,
        -1
      ],
      [
        -84,
        0
      ],
      [
        -17,
        1
      ]
    ],
    [
      [
        28287,
        61603
      ],
      [
        4,
        -23
      ],
      [
        0,
        -17
      ],
      [
        5,
        15
      ],
      [
        11,
        -25
      ],
      [
        4,
        -19
      ]
    ],
    [
      [
        28311,
        61534
      ],
      [
        4,
        -4
      ],
      [
        0,
        -12
      ],
      [
        1,
        -18
      ],
      [
        6,
        -7
      ],
      [
        5,
        -4
      ],
      [
        4,
        9
      ],
      [
        0,
        -8
      ],
      [
        3,
        16
      ]
    ],
    [
      [
        28334,
        61506
      ],
      [
        8,
        -31
      ],
      [
        8,
        -15
      ],
      [
        6,
        2
      ]
    ],
    [
      [
        24526,
        59805
      ],
      [
        0,
        -49
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -328
      ]
    ],
    [
      [
        29232,
        64030
      ],
      [
        4,
        -7
      ],
      [
        1,
        -7
      ],
      [
        1,
        -2
      ],
      [
        3,
        2
      ],
      [
        1,
        6
      ],
      [
        1,
        8
      ],
      [
        1,
        6
      ],
      [
        2,
        0
      ],
      [
        0,
        -4
      ],
      [
        2,
        -4
      ],
      [
        1,
        -3
      ],
      [
        2,
        -1
      ],
      [
        1,
        0
      ],
      [
        2,
        5
      ],
      [
        2,
        4
      ],
      [
        0,
        2
      ],
      [
        1,
        -1
      ],
      [
        4,
        -8
      ],
      [
        4,
        -7
      ],
      [
        5,
        -6
      ],
      [
        3,
        -6
      ],
      [
        5,
        -12
      ],
      [
        3,
        -5
      ],
      [
        12,
        -9
      ],
      [
        2,
        0
      ],
      [
        1,
        10
      ],
      [
        1,
        27
      ],
      [
        -3,
        7
      ],
      [
        -1,
        13
      ],
      [
        -4,
        13
      ],
      [
        1,
        8
      ],
      [
        5,
        -1
      ],
      [
        4,
        -33
      ],
      [
        1,
        -33
      ],
      [
        1,
        -14
      ],
      [
        2,
        -43
      ],
      [
        0,
        -27
      ],
      [
        -1,
        -30
      ],
      [
        -1,
        -27
      ],
      [
        -1,
        -23
      ],
      [
        -3,
        -49
      ],
      [
        -2,
        -24
      ],
      [
        -1,
        -10
      ],
      [
        -8,
        -99
      ],
      [
        -1,
        -23
      ],
      [
        1,
        -3
      ]
    ],
    [
      [
        26885,
        62163
      ],
      [
        21,
        -5
      ]
    ],
    [
      [
        26924,
        61653
      ],
      [
        -6,
        -7
      ],
      [
        -3,
        -2
      ],
      [
        -3,
        0
      ],
      [
        -2,
        1
      ],
      [
        -3,
        2
      ],
      [
        -2,
        3
      ],
      [
        -1,
        2
      ],
      [
        -2,
        6
      ],
      [
        -2,
        8
      ]
    ],
    [
      [
        26880,
        61763
      ],
      [
        -2,
        12
      ],
      [
        -4,
        23
      ],
      [
        -2,
        8
      ],
      [
        -1,
        2
      ],
      [
        -4,
        7
      ],
      [
        -2,
        4
      ],
      [
        -1,
        5
      ],
      [
        -2,
        2
      ],
      [
        -2,
        -1
      ],
      [
        -7,
        2
      ],
      [
        -4,
        -2
      ],
      [
        -3,
        1
      ],
      [
        -3,
        4
      ],
      [
        -4,
        9
      ]
    ],
    [
      [
        25382,
        71549
      ],
      [
        3,
        -4
      ],
      [
        8,
        -2
      ],
      [
        5,
        -1
      ],
      [
        8,
        3
      ],
      [
        16,
        1
      ],
      [
        7,
        -20
      ],
      [
        8,
        -10
      ],
      [
        1,
        0
      ],
      [
        4,
        7
      ],
      [
        3,
        1
      ],
      [
        1,
        -3
      ],
      [
        6,
        -9
      ],
      [
        1,
        0
      ],
      [
        2,
        -1
      ],
      [
        1,
        -3
      ],
      [
        1,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        3,
        -6
      ],
      [
        3,
        -1
      ],
      [
        3,
        5
      ],
      [
        1,
        0
      ],
      [
        2,
        -17
      ],
      [
        0,
        -16
      ],
      [
        1,
        -6
      ],
      [
        1,
        -5
      ],
      [
        4,
        -2
      ],
      [
        5,
        2
      ],
      [
        3,
        6
      ],
      [
        -1,
        8
      ],
      [
        0,
        3
      ],
      [
        2,
        1
      ],
      [
        2,
        -7
      ],
      [
        0,
        -15
      ],
      [
        1,
        -4
      ],
      [
        2,
        -6
      ],
      [
        3,
        -3
      ],
      [
        3,
        1
      ],
      [
        2,
        -2
      ],
      [
        2,
        -8
      ],
      [
        5,
        -19
      ],
      [
        4,
        -7
      ],
      [
        1,
        -34
      ],
      [
        2,
        -27
      ],
      [
        3,
        -11
      ],
      [
        14,
        -38
      ],
      [
        0,
        -12
      ],
      [
        6,
        -35
      ],
      [
        3,
        -6
      ],
      [
        6,
        -8
      ],
      [
        1,
        -5
      ],
      [
        0,
        -6
      ],
      [
        1,
        -13
      ],
      [
        3,
        -11
      ],
      [
        3,
        -3
      ],
      [
        8,
        -2
      ],
      [
        2,
        -7
      ],
      [
        6,
        -3
      ],
      [
        1,
        -15
      ],
      [
        -4,
        -9
      ],
      [
        0,
        -1
      ],
      [
        3,
        -20
      ],
      [
        2,
        -8
      ],
      [
        -4,
        -5
      ],
      [
        -1,
        -11
      ],
      [
        1,
        -10
      ],
      [
        3,
        -9
      ],
      [
        4,
        -11
      ],
      [
        4,
        -8
      ],
      [
        11,
        -10
      ],
      [
        15,
        -5
      ],
      [
        15,
        3
      ],
      [
        8,
        8
      ],
      [
        13,
        -4
      ],
      [
        3,
        1
      ]
    ],
    [
      [
        25640,
        70672
      ],
      [
        -34,
        0
      ],
      [
        -1,
        -202
      ],
      [
        -35,
        0
      ]
    ],
    [
      [
        26950,
        53512
      ],
      [
        4,
        0
      ],
      [
        0,
        15
      ],
      [
        16,
        0
      ],
      [
        0,
        13
      ],
      [
        4,
        1
      ],
      [
        0,
        17
      ],
      [
        4,
        0
      ],
      [
        0,
        13
      ],
      [
        4,
        0
      ],
      [
        0,
        29
      ],
      [
        9,
        0
      ],
      [
        0,
        15
      ],
      [
        4,
        -1
      ],
      [
        0,
        14
      ],
      [
        4,
        1
      ],
      [
        0,
        15
      ],
      [
        4,
        0
      ]
    ],
    [
      [
        27054,
        53461
      ],
      [
        0,
        -13
      ],
      [
        6,
        -41
      ],
      [
        5,
        -19
      ],
      [
        3,
        -3
      ],
      [
        -1,
        -23
      ],
      [
        -3,
        -13
      ],
      [
        -4,
        2
      ],
      [
        -9,
        -9
      ],
      [
        -5,
        6
      ],
      [
        -3,
        -6
      ],
      [
        -4,
        4
      ],
      [
        -5,
        -5
      ],
      [
        -3,
        -14
      ],
      [
        -6,
        -7
      ],
      [
        0,
        -30
      ],
      [
        -7,
        -11
      ],
      [
        -6,
        -17
      ],
      [
        0,
        6
      ],
      [
        -9,
        15
      ],
      [
        -12,
        -4
      ],
      [
        -4,
        8
      ]
    ],
    [
      [
        5394,
        42585
      ],
      [
        1,
        20
      ],
      [
        0,
        20
      ],
      [
        11,
        38
      ],
      [
        2,
        26
      ],
      [
        2,
        23
      ],
      [
        3,
        14
      ],
      [
        4,
        9
      ],
      [
        4,
        5
      ],
      [
        4,
        4
      ],
      [
        7,
        16
      ],
      [
        5,
        14
      ],
      [
        6,
        10
      ],
      [
        8,
        26
      ],
      [
        3,
        -1
      ],
      [
        3,
        4
      ],
      [
        5,
        -5
      ],
      [
        1,
        -10
      ],
      [
        2,
        3
      ],
      [
        4,
        -2
      ],
      [
        2,
        -13
      ],
      [
        3,
        6
      ],
      [
        1,
        7
      ],
      [
        -1,
        6
      ],
      [
        3,
        12
      ],
      [
        5,
        -2
      ],
      [
        3,
        -4
      ],
      [
        3,
        1
      ],
      [
        5,
        -6
      ],
      [
        3,
        3
      ],
      [
        4,
        3
      ],
      [
        1,
        8
      ],
      [
        5,
        -9
      ],
      [
        1,
        -9
      ],
      [
        5,
        -3
      ],
      [
        4,
        1
      ],
      [
        5,
        -18
      ],
      [
        1,
        -6
      ],
      [
        4,
        -13
      ],
      [
        0,
        -12
      ],
      [
        3,
        -15
      ],
      [
        -1,
        -12
      ],
      [
        2,
        -3
      ],
      [
        1,
        -3
      ],
      [
        1,
        -25
      ],
      [
        -1,
        -21
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -13
      ],
      [
        -3,
        -15
      ],
      [
        0,
        -16
      ],
      [
        -2,
        -9
      ],
      [
        -3,
        -3
      ],
      [
        0,
        -11
      ],
      [
        -1,
        -21
      ],
      [
        1,
        -16
      ],
      [
        1,
        -12
      ],
      [
        0,
        -9
      ],
      [
        -1,
        -16
      ],
      [
        1,
        -21
      ],
      [
        -2,
        -10
      ],
      [
        -2,
        -18
      ],
      [
        -3,
        -5
      ],
      [
        -3,
        -7
      ],
      [
        -4,
        -5
      ],
      [
        -1,
        -10
      ],
      [
        -1,
        -11
      ],
      [
        -2,
        0
      ],
      [
        -3,
        -12
      ],
      [
        -3,
        -6
      ],
      [
        -2,
        -7
      ],
      [
        -3,
        -9
      ],
      [
        -3,
        -6
      ],
      [
        -8,
        15
      ],
      [
        -5,
        4
      ],
      [
        -6,
        3
      ],
      [
        -4,
        -5
      ],
      [
        -8,
        6
      ],
      [
        -5,
        5
      ],
      [
        -4,
        7
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        10
      ],
      [
        -6,
        18
      ],
      [
        -4,
        20
      ],
      [
        -3,
        11
      ],
      [
        -2,
        12
      ],
      [
        -11,
        9
      ],
      [
        -4,
        9
      ],
      [
        -9,
        11
      ],
      [
        -3,
        10
      ],
      [
        -3,
        22
      ],
      [
        -3,
        15
      ],
      [
        0,
        14
      ]
    ],
    [
      [
        5266,
        42374
      ],
      [
        4,
        43
      ],
      [
        1,
        3
      ],
      [
        4,
        12
      ],
      [
        2,
        10
      ],
      [
        1,
        6
      ],
      [
        4,
        13
      ],
      [
        6,
        10
      ],
      [
        8,
        19
      ],
      [
        3,
        8
      ],
      [
        1,
        4
      ],
      [
        1,
        4
      ],
      [
        2,
        38
      ],
      [
        5,
        7
      ],
      [
        6,
        2
      ],
      [
        4,
        -8
      ],
      [
        2,
        -15
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        2
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        -25
      ],
      [
        -2,
        -32
      ],
      [
        1,
        -19
      ],
      [
        1,
        -17
      ],
      [
        -6,
        -14
      ],
      [
        -7,
        -9
      ],
      [
        -7,
        -5
      ],
      [
        -3,
        -9
      ],
      [
        -4,
        -21
      ],
      [
        -4,
        -28
      ],
      [
        -5,
        -39
      ],
      [
        2,
        -3
      ],
      [
        -2,
        -8
      ],
      [
        -3,
        5
      ],
      [
        -5,
        13
      ],
      [
        -4,
        23
      ],
      [
        1,
        40
      ]
    ],
    [
      [
        28154,
        64919
      ],
      [
        9,
        -49
      ],
      [
        7,
        -24
      ]
    ],
    [
      [
        26648,
        53718
      ],
      [
        2,
        29
      ],
      [
        1,
        89
      ],
      [
        8,
        0
      ],
      [
        2,
        15
      ],
      [
        -4,
        39
      ],
      [
        4,
        18
      ]
    ],
    [
      [
        23627,
        70810
      ],
      [
        3,
        2
      ],
      [
        1,
        12
      ],
      [
        -1,
        398
      ],
      [
        -4,
        0
      ],
      [
        0,
        101
      ],
      [
        1,
        102
      ],
      [
        18,
        -1
      ],
      [
        140,
        -2
      ]
    ],
    [
      [
        23775,
        70669
      ],
      [
        -157,
        1
      ],
      [
        3,
        27
      ],
      [
        -9,
        37
      ],
      [
        1,
        19
      ],
      [
        1,
        11
      ],
      [
        10,
        20
      ],
      [
        4,
        17
      ],
      [
        -1,
        9
      ]
    ],
    [
      [
        20301,
        69532
      ],
      [
        -136,
        0
      ],
      [
        0,
        202
      ],
      [
        11,
        -2
      ],
      [
        0,
        374
      ],
      [
        1,
        4
      ],
      [
        -34,
        1
      ],
      [
        -18,
        8
      ],
      [
        0,
        121
      ],
      [
        10,
        0
      ],
      [
        0,
        51
      ],
      [
        -17,
        0
      ],
      [
        0,
        45
      ]
    ],
    [
      [
        27378,
        47594
      ],
      [
        0,
        -86
      ]
    ],
    [
      [
        27378,
        47508
      ],
      [
        -108,
        -8
      ],
      [
        -1,
        308
      ],
      [
        -41,
        -1
      ],
      [
        -15,
        -4
      ],
      [
        -26,
        0
      ]
    ],
    [
      [
        26932,
        56099
      ],
      [
        -26,
        170
      ],
      [
        -6,
        50
      ],
      [
        6,
        31
      ],
      [
        -1,
        22
      ],
      [
        -8,
        -17
      ],
      [
        -3,
        39
      ],
      [
        -8,
        102
      ],
      [
        0,
        4
      ]
    ],
    [
      [
        27207,
        53840
      ],
      [
        -20,
        -143
      ],
      [
        -16,
        -29
      ],
      [
        -11,
        -15
      ]
    ],
    [
      [
        27074,
        53945
      ],
      [
        -3,
        2
      ],
      [
        0,
        15
      ],
      [
        7,
        7
      ],
      [
        4,
        35
      ],
      [
        6,
        14
      ],
      [
        2,
        40
      ],
      [
        6,
        10
      ],
      [
        3,
        27
      ],
      [
        -2,
        34
      ],
      [
        3,
        24
      ],
      [
        4,
        6
      ],
      [
        2,
        18
      ],
      [
        9,
        30
      ]
    ],
    [
      [
        22904,
        50772
      ],
      [
        28,
        -45
      ],
      [
        2,
        -4
      ],
      [
        4,
        -42
      ],
      [
        7,
        -78
      ],
      [
        4,
        -3
      ],
      [
        5,
        -23
      ],
      [
        5,
        -3
      ],
      [
        2,
        -19
      ],
      [
        6,
        -30
      ],
      [
        -2,
        -40
      ],
      [
        3,
        -2
      ],
      [
        4,
        -27
      ],
      [
        -1,
        -16
      ],
      [
        3,
        -16
      ],
      [
        5,
        -5
      ],
      [
        0,
        -26
      ],
      [
        3,
        -16
      ],
      [
        4,
        -9
      ],
      [
        0,
        -5
      ]
    ],
    [
      [
        26507,
        62635
      ],
      [
        4,
        0
      ]
    ],
    [
      [
        26511,
        62635
      ],
      [
        -2,
        -74
      ],
      [
        -15,
        -489
      ]
    ],
    [
      [
        26444,
        62138
      ],
      [
        0,
        55
      ]
    ],
    [
      [
        26420,
        62364
      ],
      [
        1,
        41
      ],
      [
        4,
        137
      ],
      [
        3,
        14
      ],
      [
        4,
        20
      ],
      [
        -3,
        11
      ],
      [
        -7,
        -5
      ],
      [
        -3,
        17
      ],
      [
        11,
        33
      ],
      [
        6,
        15
      ],
      [
        0,
        7
      ]
    ],
    [
      [
        23008,
        70412
      ],
      [
        0,
        -22
      ],
      [
        -1,
        -1
      ],
      [
        1,
        -5
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -20
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -17
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -2
      ],
      [
        1,
        -4
      ],
      [
        -1,
        -22
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -14
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -9
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -6
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -12
      ],
      [
        -3,
        -15
      ],
      [
        -3,
        -9
      ],
      [
        -3,
        -8
      ],
      [
        -4,
        -7
      ],
      [
        -7,
        -10
      ],
      [
        -9,
        -18
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -9
      ],
      [
        -1,
        -4
      ],
      [
        -11,
        -22
      ],
      [
        -7,
        -17
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -1
      ],
      [
        0,
        -3
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -7
      ],
      [
        -2,
        -23
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        2,
        -4
      ],
      [
        1,
        -4
      ],
      [
        1,
        -5
      ],
      [
        0,
        -1
      ],
      [
        3,
        -9
      ]
    ],
    [
      [
        22824,
        69669
      ],
      [
        -1,
        304
      ]
    ],
    [
      [
        27378,
        61765
      ],
      [
        26,
        59
      ],
      [
        7,
        -19
      ],
      [
        3,
        -18
      ],
      [
        9,
        12
      ],
      [
        19,
        -12
      ]
    ],
    [
      [
        31257,
        38463
      ],
      [
        -3,
        -46
      ],
      [
        5,
        -14
      ],
      [
        3,
        -22
      ],
      [
        -2,
        -20
      ],
      [
        7,
        -10
      ]
    ],
    [
      [
        31237,
        38351
      ],
      [
        -7,
        64
      ],
      [
        -1,
        15
      ]
    ],
    [
      [
        31229,
        38430
      ],
      [
        0,
        22
      ],
      [
        -6,
        10
      ],
      [
        -7,
        30
      ]
    ],
    [
      [
        31216,
        38492
      ],
      [
        3,
        2
      ],
      [
        4,
        -3
      ],
      [
        16,
        -3
      ],
      [
        9,
        -15
      ],
      [
        5,
        -6
      ],
      [
        3,
        -4
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        31271,
        38188
      ],
      [
        -2,
        -24
      ],
      [
        4,
        -52
      ]
    ],
    [
      [
        31257,
        38463
      ],
      [
        3,
        3
      ],
      [
        3,
        -2
      ],
      [
        8,
        -8
      ],
      [
        1,
        1
      ]
    ],
    [
      [
        31272,
        38457
      ],
      [
        1,
        -115
      ],
      [
        0,
        -23
      ]
    ],
    [
      [
        31275,
        38321
      ],
      [
        1,
        1
      ],
      [
        3,
        -13
      ],
      [
        6,
        -2
      ],
      [
        9,
        -14
      ]
    ],
    [
      [
        31294,
        38293
      ],
      [
        -1,
        -23
      ]
    ],
    [
      [
        31293,
        38093
      ],
      [
        -3,
        -1
      ]
    ],
    [
      [
        31593,
        38341
      ],
      [
        2,
        -5
      ],
      [
        3,
        2
      ],
      [
        1,
        5
      ],
      [
        -1,
        7
      ],
      [
        0,
        3
      ],
      [
        4,
        -4
      ],
      [
        1,
        -17
      ],
      [
        0,
        -1
      ],
      [
        4,
        -9
      ],
      [
        3,
        -2
      ],
      [
        2,
        2
      ],
      [
        2,
        -5
      ],
      [
        2,
        -1
      ]
    ],
    [
      [
        31616,
        38316
      ],
      [
        -5,
        -39
      ],
      [
        -5,
        -10
      ],
      [
        -8,
        -38
      ],
      [
        -6,
        10
      ]
    ],
    [
      [
        31329,
        37867
      ],
      [
        -3,
        5
      ],
      [
        -1,
        7
      ],
      [
        -1,
        3
      ],
      [
        -4,
        2
      ],
      [
        -4,
        -2
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        0
      ],
      [
        -1,
        9
      ],
      [
        0,
        4
      ]
    ],
    [
      [
        30181,
        67138
      ],
      [
        -2,
        -6
      ],
      [
        -2,
        0
      ],
      [
        -4,
        10
      ],
      [
        -4,
        -2
      ],
      [
        0,
        -35
      ],
      [
        -4,
        -17
      ],
      [
        -16,
        12
      ],
      [
        -13,
        -9
      ],
      [
        -9,
        -1
      ],
      [
        -17,
        0
      ],
      [
        13,
        65
      ],
      [
        -28,
        73
      ],
      [
        -2,
        4
      ],
      [
        -31,
        83
      ]
    ],
    [
      [
        30062,
        67315
      ],
      [
        3,
        12
      ]
    ],
    [
      [
        24721,
        61224
      ],
      [
        24,
        60
      ],
      [
        10,
        -7
      ],
      [
        4,
        18
      ],
      [
        8,
        13
      ],
      [
        0,
        15
      ]
    ],
    [
      [
        24779,
        61277
      ],
      [
        10,
        -21
      ],
      [
        2,
        5
      ],
      [
        1,
        1
      ],
      [
        1,
        -1
      ],
      [
        4,
        -6
      ],
      [
        4,
        -8
      ],
      [
        0,
        -3
      ],
      [
        1,
        -6
      ],
      [
        0,
        -16
      ],
      [
        2,
        -11
      ],
      [
        2,
        -6
      ],
      [
        5,
        -10
      ],
      [
        1,
        -2
      ],
      [
        2,
        -1
      ],
      [
        3,
        2
      ],
      [
        2,
        0
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        1,
        -3
      ],
      [
        0,
        -7
      ],
      [
        1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        1,
        -1
      ],
      [
        4,
        -6
      ],
      [
        7,
        -29
      ],
      [
        2,
        -7
      ],
      [
        1,
        -1
      ],
      [
        3,
        -2
      ],
      [
        2,
        1
      ],
      [
        7,
        5
      ],
      [
        3,
        4
      ],
      [
        1,
        -6
      ],
      [
        1,
        -5
      ],
      [
        0,
        -2
      ],
      [
        3,
        1
      ],
      [
        0,
        -7
      ],
      [
        -2,
        -8
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        -7
      ],
      [
        -4,
        0
      ],
      [
        0,
        -7
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -10
      ],
      [
        1,
        -3
      ],
      [
        5,
        -37
      ],
      [
        1,
        -2
      ],
      [
        3,
        -8
      ]
    ],
    [
      [
        24806,
        60792
      ],
      [
        -12,
        33
      ],
      [
        -13,
        -35
      ],
      [
        -56,
        193
      ],
      [
        -16,
        51
      ],
      [
        37,
        114
      ],
      [
        1,
        5
      ],
      [
        -26,
        71
      ]
    ],
    [
      [
        28311,
        61822
      ],
      [
        12,
        41
      ],
      [
        7,
        -15
      ],
      [
        4,
        3
      ],
      [
        6,
        -19
      ],
      [
        2,
        -1
      ],
      [
        6,
        -20
      ],
      [
        7,
        -30
      ],
      [
        11,
        -8
      ],
      [
        7,
        -16
      ],
      [
        2,
        5
      ]
    ],
    [
      [
        28375,
        61762
      ],
      [
        -3,
        -13
      ],
      [
        -3,
        -31
      ],
      [
        -1,
        -21
      ],
      [
        2,
        -36
      ],
      [
        2,
        -24
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -7
      ],
      [
        6,
        -16
      ],
      [
        3,
        -12
      ],
      [
        0,
        -12
      ]
    ],
    [
      [
        28334,
        61506
      ],
      [
        -5,
        39
      ],
      [
        -1,
        1
      ],
      [
        -3,
        -3
      ],
      [
        -6,
        11
      ],
      [
        -7,
        -6
      ],
      [
        -1,
        -14
      ]
    ],
    [
      [
        21206,
        71628
      ],
      [
        141,
        1
      ],
      [
        0,
        34
      ],
      [
        106,
        0
      ]
    ],
    [
      [
        25976,
        58019
      ],
      [
        1,
        -15
      ],
      [
        10,
        -62
      ]
    ],
    [
      [
        25987,
        57942
      ],
      [
        3,
        -3
      ],
      [
        -1,
        -116
      ],
      [
        0,
        -154
      ]
    ],
    [
      [
        25989,
        57669
      ],
      [
        -55,
        1
      ],
      [
        -69,
        2
      ]
    ],
    [
      [
        25865,
        57672
      ],
      [
        -2,
        0
      ]
    ],
    [
      [
        25863,
        57672
      ],
      [
        -1,
        32
      ],
      [
        1,
        107
      ],
      [
        0,
        19
      ]
    ],
    [
      [
        25863,
        57830
      ],
      [
        1,
        8
      ],
      [
        -5,
        15
      ],
      [
        4,
        0
      ],
      [
        -1,
        17
      ],
      [
        3,
        13
      ],
      [
        0,
        27
      ],
      [
        5,
        14
      ],
      [
        -3,
        32
      ],
      [
        6,
        8
      ],
      [
        -2,
        21
      ],
      [
        9,
        42
      ],
      [
        3,
        33
      ],
      [
        -4,
        11
      ]
    ],
    [
      [
        21429,
        73451
      ],
      [
        0,
        203
      ],
      [
        22,
        0
      ],
      [
        0,
        101
      ],
      [
        37,
        0
      ]
    ],
    [
      [
        25987,
        57942
      ],
      [
        8,
        21
      ],
      [
        6,
        1
      ],
      [
        14,
        -27
      ],
      [
        9,
        -4
      ],
      [
        13,
        28
      ],
      [
        -5,
        58
      ],
      [
        6,
        -4
      ],
      [
        9,
        23
      ],
      [
        7,
        -2
      ],
      [
        20,
        18
      ]
    ],
    [
      [
        26122,
        57854
      ],
      [
        1,
        -12
      ],
      [
        -2,
        -19
      ],
      [
        8,
        -39
      ],
      [
        -1,
        -21
      ],
      [
        -6,
        -34
      ],
      [
        -6,
        0
      ],
      [
        -5,
        -39
      ],
      [
        -13,
        -27
      ]
    ],
    [
      [
        26061,
        57664
      ],
      [
        -61,
        5
      ],
      [
        -11,
        0
      ]
    ],
    [
      [
        23909,
        69080
      ],
      [
        22,
        23
      ],
      [
        11,
        33
      ],
      [
        4,
        26
      ],
      [
        5,
        21
      ],
      [
        0,
        10
      ]
    ],
    [
      [
        26169,
        63860
      ],
      [
        0,
        -84
      ],
      [
        1,
        -184
      ]
    ],
    [
      [
        23785,
        71686
      ],
      [
        0,
        213
      ],
      [
        -7,
        11
      ],
      [
        -3,
        14
      ],
      [
        1,
        3
      ],
      [
        3,
        26
      ],
      [
        4,
        3
      ],
      [
        2,
        19
      ],
      [
        -3,
        25
      ],
      [
        4,
        6
      ],
      [
        -12,
        3
      ],
      [
        -1,
        -8
      ],
      [
        -8,
        11
      ],
      [
        1,
        8
      ],
      [
        -12,
        2
      ],
      [
        -1,
        9
      ],
      [
        -1,
        -23
      ],
      [
        -5,
        -10
      ],
      [
        -8,
        13
      ],
      [
        -18,
        46
      ],
      [
        -6,
        4
      ],
      [
        -4,
        24
      ],
      [
        0,
        35
      ],
      [
        4,
        7
      ],
      [
        -10,
        34
      ],
      [
        -5,
        35
      ],
      [
        -4,
        11
      ],
      [
        -6,
        4
      ],
      [
        -59,
        -76
      ],
      [
        -14,
        19
      ],
      [
        -5,
        -5
      ],
      [
        -5,
        20
      ]
    ],
    [
      [
        26699,
        68754
      ],
      [
        0,
        -29
      ],
      [
        -3,
        -49
      ],
      [
        0,
        -17
      ],
      [
        1,
        -17
      ],
      [
        1,
        -7
      ],
      [
        0,
        -5
      ],
      [
        -4,
        -38
      ],
      [
        0,
        -16
      ],
      [
        1,
        -21
      ],
      [
        -2,
        -9
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        3
      ],
      [
        -3,
        0
      ],
      [
        -3,
        -6
      ],
      [
        -8,
        -30
      ],
      [
        -3,
        -8
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -18
      ],
      [
        -1,
        -3
      ],
      [
        -4,
        -5
      ],
      [
        -1,
        9
      ],
      [
        -5,
        6
      ],
      [
        -4,
        2
      ],
      [
        -6,
        -4
      ],
      [
        -3,
        -3
      ],
      [
        -4,
        -15
      ],
      [
        -4,
        -15
      ],
      [
        -3,
        -25
      ],
      [
        -1,
        -19
      ],
      [
        0,
        -15
      ],
      [
        -3,
        -40
      ]
    ],
    [
      [
        22629,
        61783
      ],
      [
        0,
        -204
      ],
      [
        1,
        -106
      ],
      [
        0,
        -96
      ]
    ],
    [
      [
        22630,
        61377
      ],
      [
        -61,
        0
      ],
      [
        0,
        -17
      ],
      [
        -21,
        -1
      ],
      [
        0,
        17
      ],
      [
        -15,
        1
      ],
      [
        -57,
        -1
      ]
    ],
    [
      [
        22474,
        61478
      ],
      [
        0,
        304
      ]
    ],
    [
      [
        23507,
        62572
      ],
      [
        1,
        -12
      ],
      [
        2,
        -12
      ],
      [
        3,
        -8
      ],
      [
        3,
        -3
      ],
      [
        1,
        -1
      ],
      [
        4,
        -1
      ],
      [
        3,
        2
      ],
      [
        5,
        9
      ],
      [
        2,
        6
      ],
      [
        2,
        1
      ],
      [
        3,
        -3
      ],
      [
        2,
        -3
      ],
      [
        0,
        -6
      ],
      [
        1,
        -7
      ],
      [
        -1,
        -12
      ],
      [
        3,
        -4
      ],
      [
        3,
        -1
      ],
      [
        5,
        4
      ],
      [
        2,
        4
      ],
      [
        2,
        0
      ],
      [
        2,
        -1
      ]
    ],
    [
      [
        23553,
        62390
      ],
      [
        -33,
        0
      ],
      [
        -9,
        -1
      ],
      [
        -12,
        0
      ],
      [
        -5,
        9
      ],
      [
        -7,
        12
      ],
      [
        -7,
        -3
      ],
      [
        -6,
        -33
      ],
      [
        1,
        -17
      ],
      [
        -6,
        -28
      ]
    ],
    [
      [
        21992,
        49763
      ],
      [
        27,
        1
      ]
    ],
    [
      [
        22203,
        48678
      ],
      [
        -3,
        4
      ],
      [
        -4,
        -10
      ],
      [
        -2,
        1
      ],
      [
        -2,
        4
      ],
      [
        -1,
        9
      ],
      [
        3,
        22
      ],
      [
        0,
        5
      ],
      [
        -2,
        10
      ],
      [
        -2,
        3
      ],
      [
        -3,
        -2
      ],
      [
        -3,
        0
      ],
      [
        -2,
        2
      ],
      [
        -2,
        8
      ],
      [
        0,
        4
      ],
      [
        2,
        9
      ],
      [
        2,
        1
      ],
      [
        5,
        16
      ],
      [
        -1,
        12
      ],
      [
        0,
        6
      ],
      [
        3,
        22
      ],
      [
        1,
        9
      ],
      [
        2,
        37
      ],
      [
        -3,
        31
      ],
      [
        1,
        14
      ],
      [
        2,
        16
      ],
      [
        1,
        3
      ],
      [
        1,
        16
      ],
      [
        0,
        5
      ],
      [
        -1,
        6
      ],
      [
        -4,
        11
      ],
      [
        -4,
        -1
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        0
      ],
      [
        -1,
        3
      ],
      [
        2,
        52
      ],
      [
        1,
        11
      ],
      [
        1,
        4
      ],
      [
        1,
        9
      ],
      [
        0,
        4
      ],
      [
        -1,
        5
      ],
      [
        -2,
        5
      ],
      [
        -2,
        4
      ],
      [
        -3,
        27
      ],
      [
        -4,
        13
      ],
      [
        -1,
        0
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -2
      ],
      [
        -5,
        -6
      ],
      [
        -1,
        2
      ],
      [
        0,
        3
      ],
      [
        1,
        4
      ],
      [
        0,
        11
      ],
      [
        -1,
        3
      ],
      [
        -2,
        6
      ],
      [
        -1,
        13
      ],
      [
        -1,
        2
      ],
      [
        -2,
        2
      ],
      [
        -5,
        -9
      ],
      [
        -1,
        -4
      ],
      [
        -3,
        -5
      ],
      [
        -5,
        4
      ],
      [
        -3,
        7
      ],
      [
        0,
        5
      ],
      [
        2,
        6
      ],
      [
        0,
        6
      ],
      [
        -1,
        6
      ],
      [
        -2,
        5
      ],
      [
        -5,
        1
      ],
      [
        -3,
        -6
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        4
      ],
      [
        -2,
        9
      ],
      [
        -1,
        9
      ],
      [
        -3,
        14
      ],
      [
        -6,
        30
      ],
      [
        -1,
        7
      ],
      [
        -3,
        17
      ],
      [
        -1,
        2
      ],
      [
        -3,
        -4
      ],
      [
        -1,
        0
      ],
      [
        -2,
        6
      ],
      [
        -2,
        7
      ],
      [
        -1,
        20
      ],
      [
        -2,
        18
      ],
      [
        -2,
        2
      ],
      [
        -1,
        -11
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        4
      ],
      [
        -1,
        14
      ],
      [
        -2,
        18
      ],
      [
        -5,
        1
      ],
      [
        -2,
        5
      ],
      [
        0,
        50
      ],
      [
        -1,
        10
      ],
      [
        -3,
        6
      ],
      [
        -3,
        10
      ],
      [
        0,
        23
      ],
      [
        2,
        10
      ],
      [
        1,
        8
      ],
      [
        -1,
        5
      ],
      [
        -1,
        10
      ],
      [
        -5,
        6
      ],
      [
        -6,
        27
      ],
      [
        0,
        15
      ],
      [
        2,
        16
      ],
      [
        0,
        16
      ],
      [
        -9,
        3
      ],
      [
        -6,
        8
      ],
      [
        -2,
        5
      ],
      [
        -4,
        34
      ],
      [
        -2,
        15
      ],
      [
        -1,
        32
      ],
      [
        -3,
        10
      ],
      [
        -5,
        7
      ],
      [
        -2,
        6
      ],
      [
        -1,
        12
      ],
      [
        0,
        11
      ],
      [
        -3,
        11
      ],
      [
        -2,
        13
      ],
      [
        -2,
        23
      ],
      [
        -2,
        5
      ],
      [
        -8,
        8
      ],
      [
        -6,
        15
      ],
      [
        -6,
        0
      ],
      [
        -2,
        4
      ],
      [
        -2,
        9
      ],
      [
        -3,
        7
      ],
      [
        -3,
        5
      ],
      [
        -3,
        0
      ],
      [
        -1,
        8
      ]
    ],
    [
      [
        23141,
        51398
      ],
      [
        8,
        -15
      ],
      [
        0,
        -23
      ],
      [
        4,
        -8
      ],
      [
        1,
        -25
      ],
      [
        -4,
        -9
      ],
      [
        0,
        -24
      ],
      [
        5,
        -1
      ],
      [
        4,
        -11
      ],
      [
        -4,
        -11
      ],
      [
        -6,
        -1
      ],
      [
        0,
        -21
      ],
      [
        3,
        -13
      ],
      [
        12,
        -39
      ],
      [
        3,
        6
      ],
      [
        3,
        -27
      ],
      [
        3,
        1
      ],
      [
        1,
        -33
      ],
      [
        6,
        -12
      ],
      [
        2,
        -24
      ],
      [
        -4,
        -8
      ],
      [
        2,
        -14
      ],
      [
        7,
        -5
      ],
      [
        2,
        -11
      ],
      [
        6,
        -5
      ],
      [
        -1,
        -19
      ],
      [
        6,
        -38
      ],
      [
        7,
        0
      ],
      [
        1,
        -4
      ]
    ],
    [
      [
        23079,
        50655
      ],
      [
        -92,
        331
      ]
    ],
    [
      [
        22987,
        50986
      ],
      [
        10,
        21
      ],
      [
        64,
        149
      ],
      [
        7,
        15
      ],
      [
        12,
        126
      ],
      [
        37,
        139
      ]
    ],
    [
      [
        26558,
        55564
      ],
      [
        0,
        -26
      ],
      [
        2,
        -12
      ],
      [
        0,
        -18
      ]
    ],
    [
      [
        26539,
        55178
      ],
      [
        -22,
        0
      ],
      [
        0,
        10
      ],
      [
        -2,
        -10
      ],
      [
        -41,
        1
      ]
    ],
    [
      [
        26710,
        56341
      ],
      [
        -8,
        -42
      ],
      [
        7,
        -33
      ],
      [
        0,
        -25
      ]
    ],
    [
      [
        26508,
        54807
      ],
      [
        13,
        39
      ],
      [
        3,
        -13
      ],
      [
        0,
        20
      ],
      [
        17,
        51
      ],
      [
        33,
        92
      ],
      [
        18,
        -1
      ]
    ],
    [
      [
        26213,
        54179
      ],
      [
        5,
        -7
      ],
      [
        0,
        -10
      ],
      [
        25,
        -1
      ],
      [
        0,
        -10
      ],
      [
        -6,
        -8
      ],
      [
        0,
        -11
      ],
      [
        6,
        0
      ],
      [
        0,
        -9
      ],
      [
        5,
        -1
      ],
      [
        0,
        -9
      ],
      [
        5,
        -1
      ],
      [
        3,
        -10
      ]
    ],
    [
      [
        26256,
        54102
      ],
      [
        -1,
        -172
      ],
      [
        -13,
        2
      ]
    ],
    [
      [
        26242,
        53932
      ],
      [
        -19,
        1
      ],
      [
        0,
        -9
      ],
      [
        -14,
        0
      ],
      [
        0,
        9
      ],
      [
        -14,
        1
      ]
    ],
    [
      [
        27145,
        63680
      ],
      [
        -2,
        1
      ],
      [
        -129,
        16
      ]
    ],
    [
      [
        26256,
        54102
      ],
      [
        62,
        -5
      ],
      [
        2,
        10
      ],
      [
        0,
        -9
      ],
      [
        6,
        -1
      ]
    ],
    [
      [
        26342,
        54097
      ],
      [
        -1,
        -172
      ],
      [
        11,
        -2
      ],
      [
        -2,
        -11
      ],
      [
        2,
        -33
      ],
      [
        4,
        -24
      ],
      [
        3,
        -41
      ],
      [
        0,
        -35
      ],
      [
        -3,
        -30
      ]
    ],
    [
      [
        26281,
        53748
      ],
      [
        -35,
        -2
      ],
      [
        0,
        43
      ],
      [
        3,
        0
      ],
      [
        0,
        20
      ],
      [
        -5,
        9
      ],
      [
        0,
        39
      ],
      [
        -3,
        -1
      ],
      [
        1,
        76
      ]
    ],
    [
      [
        31558,
        38031
      ],
      [
        -9,
        9
      ],
      [
        -5,
        -7
      ]
    ],
    [
      [
        27129,
        61967
      ],
      [
        7,
        4
      ],
      [
        0,
        -1
      ],
      [
        14,
        -66
      ]
    ],
    [
      [
        27089,
        61554
      ],
      [
        -18,
        -57
      ],
      [
        -3,
        -1
      ],
      [
        -1,
        -11
      ],
      [
        -15,
        27
      ],
      [
        2,
        55
      ],
      [
        -1,
        43
      ]
    ],
    [
      [
        27051,
        61727
      ],
      [
        -3,
        155
      ],
      [
        30,
        57
      ],
      [
        1,
        1
      ],
      [
        50,
        27
      ]
    ],
    [
      [
        27201,
        60931
      ],
      [
        11,
        -12
      ],
      [
        5,
        4
      ],
      [
        9,
        -47
      ],
      [
        8,
        -44
      ],
      [
        21,
        -126
      ],
      [
        3,
        -24
      ],
      [
        0,
        -28
      ],
      [
        14,
        -30
      ],
      [
        2,
        7
      ],
      [
        9,
        -26
      ]
    ],
    [
      [
        29192,
        64904
      ],
      [
        -15,
        -51
      ],
      [
        -22,
        -86
      ]
    ],
    [
      [
        29155,
        64767
      ],
      [
        -10,
        -32
      ],
      [
        -22,
        -79
      ],
      [
        -7,
        -31
      ],
      [
        1,
        -25
      ],
      [
        -4,
        -25
      ],
      [
        -16,
        -26
      ],
      [
        -1,
        4
      ],
      [
        -5,
        22
      ],
      [
        -11,
        -12
      ]
    ],
    [
      [
        25555,
        55358
      ],
      [
        29,
        3
      ],
      [
        0,
        9
      ],
      [
        2,
        94
      ],
      [
        8,
        45
      ],
      [
        23,
        -3
      ],
      [
        0,
        77
      ],
      [
        13,
        42
      ],
      [
        3,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        -17
      ],
      [
        5,
        0
      ],
      [
        7,
        30
      ],
      [
        4,
        0
      ]
    ],
    [
      [
        25243,
        57060
      ],
      [
        33,
        0
      ],
      [
        19,
        -2
      ],
      [
        8,
        0
      ]
    ],
    [
      [
        25346,
        56892
      ],
      [
        -1,
        -22
      ],
      [
        0,
        -12
      ],
      [
        -3,
        -83
      ],
      [
        0,
        -18
      ],
      [
        -1,
        -17
      ],
      [
        0,
        -18
      ],
      [
        -3,
        -69
      ],
      [
        -1,
        -34
      ]
    ],
    [
      [
        25337,
        56619
      ],
      [
        -85,
        3
      ],
      [
        -9,
        0
      ]
    ],
    [
      [
        24420,
        63792
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -6
      ],
      [
        1,
        -3
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -10
      ],
      [
        0,
        -13
      ],
      [
        1,
        -5
      ]
    ],
    [
      [
        24293,
        63444
      ],
      [
        1,
        308
      ],
      [
        -1,
        0
      ],
      [
        1,
        50
      ]
    ],
    [
      [
        29760,
        67693
      ],
      [
        34,
        -17
      ],
      [
        10,
        -13
      ],
      [
        18,
        -24
      ],
      [
        -4,
        -18
      ],
      [
        9,
        -11
      ],
      [
        6,
        29
      ],
      [
        0,
        -11
      ],
      [
        37,
        -18
      ]
    ],
    [
      [
        29870,
        67610
      ],
      [
        -15,
        -74
      ],
      [
        -6,
        -33
      ],
      [
        -12,
        5
      ],
      [
        -1,
        -21
      ],
      [
        3,
        -14
      ],
      [
        -1,
        -38
      ],
      [
        -8,
        -46
      ],
      [
        -3,
        -19
      ],
      [
        7,
        -78
      ],
      [
        5,
        -1
      ],
      [
        1,
        -37
      ],
      [
        9,
        -40
      ]
    ],
    [
      [
        29849,
        67214
      ],
      [
        -7,
        -7
      ],
      [
        3,
        -26
      ],
      [
        -4,
        -36
      ]
    ],
    [
      [
        29841,
        67145
      ],
      [
        -39,
        3
      ],
      [
        6,
        59
      ],
      [
        -29,
        -14
      ],
      [
        -20,
        -9
      ],
      [
        1,
        -9
      ],
      [
        -13,
        3
      ],
      [
        1,
        -29
      ],
      [
        -16,
        4
      ],
      [
        0,
        28
      ],
      [
        -6,
        2
      ]
    ],
    [
      [
        22192,
        73247
      ],
      [
        -98,
        0
      ],
      [
        -1,
        -407
      ],
      [
        10,
        0
      ],
      [
        0,
        -203
      ]
    ],
    [
      [
        22103,
        72637
      ],
      [
        -71,
        0
      ]
    ],
    [
      [
        22032,
        72637
      ],
      [
        -36,
        1
      ]
    ],
    [
      [
        29319,
        64429
      ],
      [
        6,
        -6
      ],
      [
        2,
        -5
      ],
      [
        3,
        1
      ],
      [
        1,
        2
      ],
      [
        2,
        10
      ],
      [
        4,
        4
      ],
      [
        6,
        3
      ],
      [
        4,
        2
      ],
      [
        5,
        -6
      ],
      [
        2,
        2
      ]
    ],
    [
      [
        29354,
        64436
      ],
      [
        2,
        -8
      ],
      [
        1,
        0
      ],
      [
        2,
        6
      ]
    ],
    [
      [
        29364,
        64189
      ],
      [
        -2,
        3
      ],
      [
        -5,
        -2
      ],
      [
        -16,
        -15
      ],
      [
        -20,
        -25
      ],
      [
        -10,
        -15
      ],
      [
        2,
        27
      ],
      [
        0,
        3
      ]
    ],
    [
      [
        27830,
        59130
      ],
      [
        -30,
        3
      ],
      [
        -46,
        4
      ]
    ],
    [
      [
        24868,
        71378
      ],
      [
        11,
        35
      ],
      [
        5,
        10
      ],
      [
        11,
        17
      ],
      [
        20,
        14
      ],
      [
        13,
        3
      ],
      [
        4,
        -3
      ],
      [
        5,
        -6
      ],
      [
        2,
        -7
      ],
      [
        4,
        -1
      ],
      [
        14,
        15
      ],
      [
        9,
        5
      ],
      [
        6,
        7
      ],
      [
        5,
        0
      ],
      [
        2,
        -4
      ],
      [
        5,
        -1
      ],
      [
        10,
        2
      ],
      [
        6,
        5
      ],
      [
        12,
        16
      ],
      [
        34,
        54
      ],
      [
        6,
        11
      ],
      [
        7,
        21
      ],
      [
        10,
        40
      ],
      [
        7,
        22
      ],
      [
        4,
        9
      ],
      [
        3,
        2
      ],
      [
        1,
        -5
      ],
      [
        2,
        -4
      ],
      [
        5,
        -1
      ],
      [
        7,
        4
      ],
      [
        7,
        12
      ],
      [
        3,
        2
      ],
      [
        1,
        -7
      ],
      [
        7,
        1
      ],
      [
        3,
        2
      ],
      [
        4,
        6
      ],
      [
        4,
        7
      ],
      [
        4,
        14
      ],
      [
        3,
        14
      ]
    ],
    [
      [
        24661,
        52120
      ],
      [
        -3,
        -64
      ]
    ],
    [
      [
        24529,
        51935
      ],
      [
        0,
        53
      ],
      [
        4,
        0
      ],
      [
        0,
        38
      ],
      [
        5,
        23
      ],
      [
        4,
        61
      ],
      [
        4,
        45
      ],
      [
        7,
        78
      ],
      [
        0,
        3
      ]
    ],
    [
      [
        27188,
        49123
      ],
      [
        9,
        -1
      ],
      [
        108,
        -3
      ]
    ],
    [
      [
        26643,
        63514
      ],
      [
        4,
        118
      ]
    ],
    [
      [
        26730,
        63628
      ],
      [
        -1,
        -49
      ],
      [
        -1,
        -20
      ],
      [
        -12,
        0
      ],
      [
        1,
        -47
      ],
      [
        -2,
        -4
      ],
      [
        4,
        -20
      ],
      [
        -1,
        -20
      ],
      [
        6,
        -44
      ],
      [
        -7,
        -18
      ],
      [
        2,
        -122
      ]
    ],
    [
      [
        26717,
        63148
      ],
      [
        -112,
        25
      ]
    ],
    [
      [
        27381,
        49327
      ],
      [
        100,
        0
      ],
      [
        5,
        38
      ],
      [
        10,
        0
      ],
      [
        3,
        7
      ]
    ],
    [
      [
        27499,
        49372
      ],
      [
        -1,
        -1
      ],
      [
        18,
        -140
      ],
      [
        9,
        -113
      ],
      [
        0,
        -17
      ],
      [
        2,
        -14
      ],
      [
        4,
        -22
      ],
      [
        2,
        -33
      ],
      [
        1,
        -13
      ]
    ],
    [
      [
        23602,
        58132
      ],
      [
        0,
        9
      ],
      [
        -1,
        40
      ]
    ],
    [
      [
        23598,
        57605
      ],
      [
        0,
        52
      ],
      [
        1,
        98
      ],
      [
        1,
        67
      ],
      [
        0,
        106
      ],
      [
        1,
        23
      ],
      [
        0,
        71
      ],
      [
        1,
        17
      ],
      [
        0,
        93
      ]
    ],
    [
      [
        25526,
        64679
      ],
      [
        0,
        -319
      ]
    ],
    [
      [
        26325,
        54461
      ],
      [
        3,
        0
      ]
    ],
    [
      [
        27075,
        65256
      ],
      [
        1,
        -1
      ],
      [
        0,
        -5
      ],
      [
        1,
        -3
      ],
      [
        6,
        -8
      ],
      [
        17,
        -10
      ],
      [
        5,
        1
      ],
      [
        1,
        1
      ],
      [
        5,
        6
      ],
      [
        8,
        7
      ],
      [
        4,
        1
      ],
      [
        4,
        -1
      ],
      [
        3,
        -5
      ],
      [
        7,
        -5
      ],
      [
        2,
        1
      ],
      [
        7,
        16
      ],
      [
        1,
        1
      ],
      [
        1,
        4
      ],
      [
        11,
        29
      ],
      [
        4,
        5
      ],
      [
        5,
        6
      ],
      [
        9,
        23
      ],
      [
        11,
        32
      ],
      [
        3,
        12
      ],
      [
        6,
        19
      ],
      [
        8,
        10
      ],
      [
        3,
        10
      ]
    ],
    [
      [
        27208,
        65402
      ],
      [
        0,
        -51
      ],
      [
        1,
        -21
      ],
      [
        27,
        0
      ]
    ],
    [
      [
        26639,
        55860
      ],
      [
        -2,
        -47
      ],
      [
        -2,
        -259
      ]
    ],
    [
      [
        17307,
        67787
      ],
      [
        6,
        -9
      ],
      [
        11,
        -6
      ],
      [
        3,
        -37
      ],
      [
        9,
        -19
      ],
      [
        3,
        -19
      ],
      [
        11,
        -13
      ],
      [
        8,
        3
      ],
      [
        8,
        -19
      ],
      [
        4,
        -35
      ],
      [
        6,
        -25
      ],
      [
        -1,
        -14
      ],
      [
        1,
        -42
      ],
      [
        10,
        -27
      ],
      [
        4,
        -22
      ],
      [
        15,
        -42
      ],
      [
        2,
        -16
      ],
      [
        13,
        -19
      ],
      [
        4,
        -22
      ],
      [
        2,
        -23
      ],
      [
        6,
        -30
      ],
      [
        8,
        -8
      ],
      [
        8,
        -1
      ],
      [
        3,
        -9
      ]
    ],
    [
      [
        17451,
        67333
      ],
      [
        3,
        -10
      ],
      [
        8,
        11
      ],
      [
        13,
        3
      ],
      [
        4,
        -11
      ],
      [
        3,
        -28
      ],
      [
        3,
        -8
      ],
      [
        3,
        -26
      ],
      [
        -2,
        -16
      ],
      [
        0,
        -28
      ],
      [
        9,
        -33
      ],
      [
        5,
        -4
      ],
      [
        1,
        -15
      ],
      [
        3,
        -6
      ],
      [
        6,
        -28
      ],
      [
        8,
        -3
      ],
      [
        1,
        -5
      ]
    ],
    [
      [
        17861,
        65826
      ],
      [
        -59,
        0
      ],
      [
        -1,
        1
      ],
      [
        -17,
        -1
      ],
      [
        -76,
        1
      ],
      [
        -11,
        1
      ],
      [
        -68,
        -1
      ],
      [
        -2,
        1
      ],
      [
        -2,
        0
      ],
      [
        -28,
        1
      ],
      [
        -7,
        -1
      ],
      [
        -89,
        0
      ],
      [
        -10,
        -2
      ],
      [
        -27,
        1
      ],
      [
        -10,
        0
      ],
      [
        -1,
        1
      ],
      [
        -2,
        -1
      ],
      [
        -4,
        1
      ],
      [
        -28,
        0
      ],
      [
        -96,
        2
      ],
      [
        -11,
        -1
      ],
      [
        -2,
        1
      ]
    ],
    [
      [
        17307,
        65831
      ],
      [
        0,
        1956
      ]
    ],
    [
      [
        15891,
        60553
      ],
      [
        6,
        -14
      ],
      [
        5,
        -2
      ],
      [
        3,
        -2
      ],
      [
        0,
        1
      ],
      [
        4,
        6
      ],
      [
        0,
        3
      ]
    ],
    [
      [
        15909,
        60545
      ],
      [
        14,
        9
      ],
      [
        6,
        -7
      ],
      [
        7,
        8
      ],
      [
        6,
        -16
      ],
      [
        16,
        34
      ],
      [
        4,
        1
      ],
      [
        51,
        -2
      ],
      [
        56,
        0
      ]
    ],
    [
      [
        16038,
        59893
      ],
      [
        0,
        23
      ],
      [
        -7,
        8
      ],
      [
        -5,
        17
      ],
      [
        -6,
        -9
      ],
      [
        -5,
        37
      ],
      [
        -8,
        4
      ],
      [
        -1,
        20
      ],
      [
        -6,
        12
      ],
      [
        -4,
        -7
      ],
      [
        -2,
        1
      ],
      [
        6,
        20
      ],
      [
        -2,
        16
      ],
      [
        -9,
        33
      ],
      [
        -6,
        8
      ],
      [
        -2,
        7
      ],
      [
        -6,
        8
      ],
      [
        -3,
        17
      ],
      [
        -8,
        15
      ],
      [
        -4,
        9
      ],
      [
        -8,
        1
      ],
      [
        -12,
        21
      ],
      [
        -16,
        24
      ],
      [
        -3,
        17
      ],
      [
        -7,
        10
      ],
      [
        -1,
        27
      ],
      [
        -7,
        26
      ],
      [
        -3,
        -3
      ],
      [
        -6,
        15
      ],
      [
        -9,
        41
      ],
      [
        -8,
        21
      ],
      [
        -1,
        11
      ]
    ],
    [
      [
        15879,
        60343
      ],
      [
        -4,
        11
      ],
      [
        1,
        11
      ],
      [
        -8,
        16
      ],
      [
        5,
        9
      ],
      [
        -8,
        40
      ],
      [
        4,
        29
      ],
      [
        -2,
        26
      ],
      [
        2,
        28
      ],
      [
        7,
        25
      ],
      [
        5,
        6
      ],
      [
        5,
        -7
      ],
      [
        5,
        16
      ]
    ],
    [
      [
        24006,
        53430
      ],
      [
        10,
        0
      ],
      [
        0,
        24
      ],
      [
        9,
        1
      ],
      [
        0,
        24
      ],
      [
        7,
        0
      ],
      [
        0,
        17
      ],
      [
        5,
        0
      ],
      [
        0,
        18
      ],
      [
        7,
        0
      ],
      [
        0,
        17
      ],
      [
        9,
        9
      ],
      [
        0,
        16
      ],
      [
        5,
        1
      ],
      [
        5,
        24
      ],
      [
        5,
        0
      ],
      [
        0,
        11
      ],
      [
        11,
        37
      ]
    ],
    [
      [
        24256,
        53416
      ],
      [
        -3,
        -12
      ],
      [
        -8,
        -22
      ],
      [
        -11,
        -3
      ],
      [
        -3,
        9
      ],
      [
        -1,
        14
      ],
      [
        -4,
        13
      ],
      [
        -5,
        -8
      ],
      [
        -3,
        5
      ],
      [
        -3,
        -12
      ],
      [
        0,
        -198
      ],
      [
        2,
        -11
      ],
      [
        -2,
        -12
      ],
      [
        0,
        -18
      ],
      [
        2,
        -48
      ],
      [
        3,
        -97
      ],
      [
        2,
        -34
      ],
      [
        -20,
        3
      ]
    ],
    [
      [
        24113,
        52905
      ],
      [
        0,
        3
      ],
      [
        -34,
        -8
      ],
      [
        -29,
        -2
      ]
    ],
    [
      [
        25337,
        56619
      ],
      [
        -1,
        -33
      ]
    ],
    [
      [
        25325,
        56221
      ],
      [
        -21,
        1
      ],
      [
        -2,
        -31
      ],
      [
        -11,
        -38
      ],
      [
        -7,
        11
      ],
      [
        -3,
        -26
      ],
      [
        -5,
        2
      ],
      [
        -3,
        -8
      ],
      [
        -3,
        4
      ],
      [
        -3,
        -9
      ],
      [
        -7,
        2
      ],
      [
        -9,
        -18
      ]
    ],
    [
      [
        25251,
        56111
      ],
      [
        0,
        12
      ],
      [
        6,
        15
      ],
      [
        -1,
        8
      ],
      [
        -62,
        0
      ],
      [
        0,
        153
      ]
    ],
    [
      [
        28939,
        63476
      ],
      [
        4,
        6
      ],
      [
        3,
        8
      ],
      [
        1,
        2
      ],
      [
        3,
        6
      ],
      [
        3,
        5
      ],
      [
        4,
        9
      ],
      [
        2,
        4
      ],
      [
        -4,
        11
      ],
      [
        -5,
        13
      ],
      [
        -6,
        20
      ],
      [
        -2,
        6
      ],
      [
        3,
        10
      ],
      [
        7,
        27
      ],
      [
        2,
        8
      ],
      [
        10,
        -24
      ],
      [
        3,
        14
      ],
      [
        7,
        -17
      ],
      [
        3,
        -8
      ],
      [
        4,
        -9
      ],
      [
        4,
        -10
      ],
      [
        3,
        6
      ],
      [
        4,
        14
      ],
      [
        -3,
        6
      ],
      [
        2,
        7
      ],
      [
        2,
        9
      ],
      [
        3,
        11
      ],
      [
        4,
        16
      ],
      [
        1,
        3
      ],
      [
        1,
        4
      ],
      [
        8,
        24
      ],
      [
        2,
        6
      ]
    ],
    [
      [
        28999,
        63493
      ],
      [
        -3,
        -13
      ],
      [
        -5,
        -6
      ],
      [
        -1,
        -1
      ],
      [
        -4,
        -5
      ],
      [
        -3,
        -6
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -23
      ],
      [
        1,
        -7
      ],
      [
        1,
        -5
      ],
      [
        0,
        -20
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -9
      ]
    ],
    [
      [
        28977,
        63373
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -2
      ],
      [
        -7,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -5
      ],
      [
        -5,
        -12
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        30021,
        67006
      ],
      [
        -3,
        37
      ],
      [
        4,
        0
      ],
      [
        9,
        71
      ],
      [
        8,
        45
      ],
      [
        3,
        25
      ],
      [
        1,
        2
      ],
      [
        9,
        63
      ],
      [
        9,
        57
      ],
      [
        1,
        9
      ]
    ],
    [
      [
        30213,
        67064
      ],
      [
        -3,
        -4
      ],
      [
        0,
        -16
      ],
      [
        -1,
        -12
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -2
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -11
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -14
      ],
      [
        0,
        -5
      ],
      [
        -2,
        0
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -6
      ],
      [
        -2,
        -7
      ],
      [
        0,
        -3
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        0
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -12
      ],
      [
        0,
        -10
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -20
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -12
      ],
      [
        -1,
        -9
      ]
    ],
    [
      [
        30062,
        66695
      ],
      [
        -4,
        15
      ],
      [
        -7,
        6
      ],
      [
        -18,
        14
      ],
      [
        -2,
        15
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        9
      ],
      [
        1,
        9
      ],
      [
        -7,
        28
      ],
      [
        -11,
        2
      ],
      [
        -5,
        76
      ],
      [
        -2,
        47
      ],
      [
        19,
        9
      ],
      [
        1,
        10
      ],
      [
        -4,
        72
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        29385,
        66743
      ],
      [
        1,
        14
      ],
      [
        3,
        8
      ],
      [
        1,
        19
      ],
      [
        -5,
        46
      ],
      [
        1,
        19
      ],
      [
        -3,
        21
      ],
      [
        0,
        10
      ],
      [
        1,
        13
      ],
      [
        5,
        23
      ],
      [
        3,
        7
      ],
      [
        4,
        3
      ]
    ],
    [
      [
        29396,
        66926
      ],
      [
        3,
        0
      ],
      [
        30,
        3
      ],
      [
        19,
        1
      ],
      [
        5,
        16
      ],
      [
        11,
        -6
      ],
      [
        3,
        -11
      ],
      [
        30,
        0
      ]
    ],
    [
      [
        27357,
        58148
      ],
      [
        -9,
        -24
      ],
      [
        4,
        -18
      ],
      [
        3,
        13
      ],
      [
        11,
        -18
      ],
      [
        -6,
        -10
      ],
      [
        -8,
        -1
      ],
      [
        -3,
        -12
      ],
      [
        -3,
        -31
      ],
      [
        -6,
        -51
      ],
      [
        2,
        -24
      ],
      [
        -1,
        -27
      ],
      [
        2,
        -20
      ],
      [
        0,
        -22
      ],
      [
        -1,
        -40
      ],
      [
        -9,
        -7
      ]
    ],
    [
      [
        24765,
        59920
      ],
      [
        5,
        -1
      ],
      [
        0,
        17
      ],
      [
        5,
        0
      ],
      [
        0,
        33
      ],
      [
        5,
        0
      ],
      [
        0,
        17
      ],
      [
        5,
        0
      ],
      [
        0,
        17
      ],
      [
        5,
        0
      ],
      [
        0,
        16
      ],
      [
        5,
        0
      ],
      [
        1,
        40
      ],
      [
        10,
        -1
      ]
    ],
    [
      [
        24874,
        60157
      ],
      [
        28,
        0
      ]
    ],
    [
      [
        24796,
        59580
      ],
      [
        3,
        34
      ],
      [
        -4,
        21
      ],
      [
        3,
        22
      ],
      [
        -5,
        25
      ],
      [
        -5,
        28
      ],
      [
        0,
        11
      ],
      [
        -3,
        5
      ],
      [
        -1,
        19
      ],
      [
        -4,
        0
      ],
      [
        2,
        37
      ],
      [
        -5,
        12
      ],
      [
        -3,
        20
      ],
      [
        3,
        13
      ],
      [
        -4,
        10
      ],
      [
        -8,
        33
      ],
      [
        4,
        15
      ],
      [
        -3,
        8
      ],
      [
        -1,
        27
      ]
    ],
    [
      [
        21475,
        65841
      ],
      [
        0,
        -310
      ],
      [
        23,
        0
      ]
    ],
    [
      [
        21498,
        65126
      ],
      [
        -20,
        1
      ],
      [
        0,
        -202
      ]
    ],
    [
      [
        21324,
        64925
      ],
      [
        0,
        202
      ],
      [
        -8,
        0
      ],
      [
        0,
        51
      ]
    ],
    [
      [
        21316,
        65178
      ],
      [
        0,
        354
      ],
      [
        -8,
        0
      ],
      [
        -2,
        33
      ],
      [
        -1,
        35
      ],
      [
        0,
        237
      ]
    ],
    [
      [
        27924,
        65829
      ],
      [
        0,
        -53
      ],
      [
        1,
        -106
      ],
      [
        0,
        -24
      ],
      [
        -1,
        -12
      ],
      [
        -8,
        -1
      ],
      [
        -2,
        -240
      ]
    ],
    [
      [
        23424,
        60010
      ],
      [
        -94,
        0
      ]
    ],
    [
      [
        23298,
        60010
      ],
      [
        1,
        226
      ],
      [
        1,
        68
      ],
      [
        -1,
        153
      ]
    ],
    [
      [
        23442,
        59440
      ],
      [
        0,
        102
      ],
      [
        2,
        85
      ]
    ],
    [
      [
        23441,
        59035
      ],
      [
        0,
        84
      ],
      [
        1,
        18
      ],
      [
        0,
        303
      ]
    ],
    [
      [
        25805,
        65551
      ],
      [
        7,
        0
      ],
      [
        64,
        1
      ],
      [
        1,
        0
      ],
      [
        11,
        -1
      ]
    ],
    [
      [
        25805,
        65171
      ],
      [
        0,
        101
      ],
      [
        6,
        -1
      ],
      [
        2,
        14
      ],
      [
        0,
        35
      ],
      [
        3,
        11
      ],
      [
        0,
        92
      ],
      [
        -11,
        1
      ],
      [
        0,
        127
      ]
    ],
    [
      [
        28636,
        58782
      ],
      [
        0,
        -3
      ],
      [
        7,
        1
      ],
      [
        6,
        5
      ],
      [
        13,
        30
      ],
      [
        16,
        17
      ],
      [
        10,
        7
      ],
      [
        23,
        -1
      ],
      [
        3,
        -3
      ],
      [
        6,
        3
      ],
      [
        11,
        -26
      ],
      [
        2,
        -12
      ],
      [
        1,
        -3
      ],
      [
        -2,
        -27
      ],
      [
        2,
        -16
      ],
      [
        -7,
        -36
      ],
      [
        -7,
        -42
      ],
      [
        3,
        -55
      ],
      [
        1,
        -103
      ],
      [
        3,
        -32
      ],
      [
        -2,
        -29
      ]
    ],
    [
      [
        22825,
        49041
      ],
      [
        -10,
        -77
      ],
      [
        -11,
        -97
      ],
      [
        -11,
        -127
      ],
      [
        -3,
        -47
      ]
    ],
    [
      [
        22782,
        48693
      ],
      [
        0,
        3
      ],
      [
        4,
        84
      ],
      [
        9,
        96
      ],
      [
        7,
        84
      ],
      [
        10,
        80
      ]
    ],
    [
      [
        22796,
        49023
      ],
      [
        -3,
        -39
      ],
      [
        -2,
        -11
      ],
      [
        -1,
        -18
      ],
      [
        -1,
        -28
      ],
      [
        -2,
        -24
      ],
      [
        -2,
        -9
      ],
      [
        -2,
        -29
      ],
      [
        1,
        -15
      ],
      [
        -1,
        -13
      ],
      [
        -2,
        -13
      ],
      [
        -6,
        -53
      ],
      [
        0,
        -11
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -10
      ],
      [
        -2,
        -5
      ],
      [
        -3,
        -4
      ],
      [
        -6,
        0
      ],
      [
        -9,
        -18
      ],
      [
        -7,
        -27
      ],
      [
        -7,
        4
      ],
      [
        -3,
        7
      ],
      [
        -1,
        7
      ],
      [
        3,
        -1
      ],
      [
        3,
        2
      ],
      [
        1,
        8
      ],
      [
        2,
        8
      ],
      [
        3,
        0
      ],
      [
        2,
        4
      ],
      [
        -1,
        16
      ],
      [
        1,
        7
      ],
      [
        4,
        12
      ],
      [
        0,
        15
      ],
      [
        -1,
        9
      ],
      [
        -4,
        9
      ],
      [
        -4,
        -6
      ],
      [
        -1,
        -10
      ],
      [
        -5,
        -21
      ],
      [
        -9,
        -23
      ],
      [
        -4,
        -7
      ],
      [
        -7,
        -28
      ],
      [
        -3,
        2
      ],
      [
        -3,
        -1
      ],
      [
        -2,
        -5
      ]
    ],
    [
      [
        22592,
        48674
      ],
      [
        0,
        436
      ],
      [
        32,
        0
      ]
    ],
    [
      [
        27494,
        59671
      ],
      [
        3,
        -9
      ],
      [
        -4,
        -32
      ],
      [
        -6,
        -13
      ],
      [
        0,
        -14
      ],
      [
        -3,
        8
      ],
      [
        -7,
        -15
      ],
      [
        -7,
        -2
      ],
      [
        -1,
        11
      ],
      [
        -7,
        12
      ],
      [
        -5,
        -1
      ],
      [
        -2,
        -10
      ],
      [
        0,
        -18
      ],
      [
        -5,
        -22
      ],
      [
        -1,
        -30
      ],
      [
        3,
        -4
      ],
      [
        1,
        -36
      ]
    ],
    [
      [
        27390,
        59497
      ],
      [
        -22,
        106
      ]
    ],
    [
      [
        27363,
        59628
      ],
      [
        -30,
        157
      ]
    ],
    [
      [
        27333,
        59785
      ],
      [
        3,
        10
      ],
      [
        2,
        -4
      ],
      [
        48,
        44
      ],
      [
        11,
        5
      ],
      [
        5,
        11
      ],
      [
        15,
        19
      ]
    ],
    [
      [
        17253,
        68510
      ],
      [
        0,
        -5
      ],
      [
        1,
        -10
      ],
      [
        5,
        -17
      ],
      [
        2,
        -4
      ],
      [
        6,
        -14
      ],
      [
        4,
        -1
      ],
      [
        4,
        1
      ],
      [
        1,
        1
      ],
      [
        1,
        4
      ],
      [
        1,
        1
      ],
      [
        0,
        7
      ],
      [
        3,
        9
      ],
      [
        1,
        2
      ],
      [
        2,
        2
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        1,
        -3
      ],
      [
        1,
        -6
      ],
      [
        1,
        -2
      ],
      [
        0,
        -10
      ],
      [
        1,
        -3
      ],
      [
        3,
        -9
      ],
      [
        3,
        -7
      ],
      [
        2,
        -8
      ],
      [
        1,
        -7
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        1
      ],
      [
        0,
        3
      ],
      [
        1,
        12
      ],
      [
        2,
        5
      ],
      [
        1,
        2
      ],
      [
        1,
        1
      ],
      [
        1,
        -1
      ],
      [
        1,
        -3
      ],
      [
        9,
        0
      ],
      [
        3,
        -3
      ],
      [
        1,
        -4
      ],
      [
        0,
        -37
      ],
      [
        1,
        -12
      ],
      [
        1,
        -4
      ],
      [
        5,
        -3
      ],
      [
        1,
        0
      ],
      [
        1,
        2
      ],
      [
        2,
        1
      ],
      [
        2,
        -3
      ],
      [
        7,
        -14
      ],
      [
        0,
        -3
      ],
      [
        2,
        -7
      ],
      [
        0,
        -20
      ],
      [
        -1,
        -1
      ]
    ],
    [
      [
        17320,
        68019
      ],
      [
        0,
        -13
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        2
      ],
      [
        0,
        -1
      ],
      [
        -3,
        -2
      ],
      [
        -3,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        1,
        -2
      ],
      [
        3,
        -3
      ],
      [
        0,
        -9
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -11
      ],
      [
        3,
        -7
      ],
      [
        1,
        -7
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -10
      ],
      [
        0,
        -149
      ]
    ],
    [
      [
        28546,
        62046
      ],
      [
        1,
        9
      ],
      [
        11,
        15
      ],
      [
        6,
        -2
      ],
      [
        0,
        -48
      ],
      [
        11,
        -6
      ],
      [
        13,
        0
      ],
      [
        2,
        -9
      ]
    ],
    [
      [
        28590,
        62005
      ],
      [
        -1,
        -16
      ],
      [
        0,
        -25
      ],
      [
        2,
        -38
      ],
      [
        3,
        -19
      ],
      [
        1,
        -16
      ],
      [
        -1,
        -29
      ],
      [
        0,
        -41
      ],
      [
        -1,
        -19
      ],
      [
        1,
        -12
      ],
      [
        3,
        -28
      ],
      [
        3,
        -25
      ],
      [
        11,
        -37
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        1,
        -4
      ],
      [
        4,
        -11
      ],
      [
        6,
        -22
      ],
      [
        3,
        -22
      ],
      [
        3,
        -7
      ],
      [
        1,
        -2
      ],
      [
        1,
        -7
      ],
      [
        0,
        -24
      ],
      [
        -5,
        -23
      ],
      [
        -4,
        -22
      ],
      [
        -4,
        2
      ],
      [
        -5,
        -4
      ],
      [
        -2,
        3
      ],
      [
        -3,
        6
      ],
      [
        -1,
        -5
      ]
    ],
    [
      [
        28550,
        61756
      ],
      [
        3,
        30
      ],
      [
        -4,
        12
      ]
    ],
    [
      [
        28549,
        61798
      ],
      [
        1,
        20
      ],
      [
        -2,
        32
      ],
      [
        2,
        22
      ],
      [
        0,
        21
      ],
      [
        -2,
        12
      ],
      [
        -4,
        10
      ],
      [
        1,
        14
      ],
      [
        2,
        10
      ],
      [
        0,
        6
      ],
      [
        -5,
        8
      ],
      [
        3,
        6
      ],
      [
        1,
        9
      ],
      [
        -4,
        34
      ],
      [
        4,
        44
      ]
    ],
    [
      [
        23463,
        51482
      ],
      [
        -1,
        6
      ],
      [
        0,
        16
      ],
      [
        -2,
        6
      ],
      [
        -7,
        3
      ],
      [
        -1,
        -18
      ],
      [
        -2,
        -7
      ],
      [
        -8,
        -23
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -12
      ],
      [
        0,
        -12
      ],
      [
        7,
        -22
      ],
      [
        2,
        -10
      ],
      [
        -2,
        -12
      ],
      [
        -5,
        -20
      ],
      [
        -3,
        -18
      ],
      [
        0,
        -4
      ]
    ],
    [
      [
        23439,
        51344
      ],
      [
        0,
        -8
      ],
      [
        -13,
        12
      ],
      [
        -4,
        -29
      ],
      [
        -1,
        1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -2
      ]
    ],
    [
      [
        23419,
        51317
      ],
      [
        0,
        0
      ]
    ],
    [
      [
        23419,
        51317
      ],
      [
        0,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        3
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -8
      ],
      [
        1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        -1,
        0
      ],
      [
        0,
        4
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        2
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -6,
        -1
      ],
      [
        -7,
        -11
      ],
      [
        -1,
        20
      ],
      [
        -4,
        5
      ],
      [
        -5,
        30
      ],
      [
        2,
        17
      ],
      [
        -2,
        5
      ],
      [
        -4,
        -9
      ]
    ],
    [
      [
        23326,
        51373
      ],
      [
        -6,
        13
      ],
      [
        -35,
        67
      ],
      [
        -3,
        6
      ],
      [
        -4,
        8
      ],
      [
        -1,
        0
      ],
      [
        -6,
        15
      ],
      [
        -9,
        20
      ],
      [
        -5,
        12
      ],
      [
        -4,
        11
      ],
      [
        -1,
        0
      ],
      [
        -12,
        28
      ],
      [
        -5,
        14
      ],
      [
        -17,
        40
      ],
      [
        -4,
        9
      ]
    ],
    [
      [
        23214,
        51616
      ],
      [
        -12,
        140
      ],
      [
        -26,
        296
      ],
      [
        5,
        -18
      ],
      [
        4,
        -4
      ],
      [
        5,
        -19
      ],
      [
        6,
        -10
      ],
      [
        4,
        3
      ],
      [
        5,
        -24
      ],
      [
        3,
        -1
      ],
      [
        1,
        -14
      ],
      [
        4,
        -8
      ],
      [
        7,
        10
      ]
    ],
    [
      [
        28629,
        59998
      ],
      [
        -2,
        -8
      ],
      [
        -3,
        -15
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -3
      ],
      [
        -2,
        2
      ],
      [
        -3,
        6
      ],
      [
        -4,
        23
      ],
      [
        -2,
        10
      ],
      [
        -1,
        8
      ],
      [
        1,
        0
      ],
      [
        1,
        3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        7
      ],
      [
        -3,
        16
      ],
      [
        -13,
        31
      ],
      [
        -2,
        1
      ],
      [
        -2,
        9
      ],
      [
        -1,
        6
      ],
      [
        1,
        2
      ],
      [
        0,
        9
      ],
      [
        -3,
        7
      ],
      [
        -5,
        -9
      ],
      [
        -3,
        2
      ],
      [
        -1,
        3
      ],
      [
        -3,
        19
      ],
      [
        -11,
        26
      ],
      [
        -2,
        9
      ],
      [
        1,
        18
      ],
      [
        2,
        3
      ],
      [
        3,
        18
      ],
      [
        -1,
        7
      ],
      [
        -1,
        1
      ]
    ],
    [
      [
        8549,
        88444
      ],
      [
        -200,
        0
      ],
      [
        0,
        34
      ],
      [
        -17,
        0
      ],
      [
        0,
        33
      ],
      [
        -33,
        0
      ],
      [
        -20,
        -18
      ]
    ],
    [
      [
        8279,
        88493
      ],
      [
        -13,
        0
      ],
      [
        -18,
        25
      ],
      [
        -20,
        4
      ],
      [
        -31,
        -46
      ],
      [
        -12,
        -18
      ],
      [
        -11,
        -49
      ],
      [
        -19,
        -14
      ],
      [
        -6,
        -36
      ],
      [
        -6,
        -34
      ],
      [
        0,
        -70
      ],
      [
        -18,
        -31
      ],
      [
        -25,
        19
      ],
      [
        -16,
        5
      ],
      [
        -20,
        2
      ],
      [
        -14,
        -6
      ],
      [
        -4,
        -4
      ],
      [
        -2,
        1
      ],
      [
        -3,
        7
      ],
      [
        -5,
        0
      ],
      [
        0,
        -2
      ],
      [
        -2,
        -2
      ],
      [
        -7,
        -4
      ],
      [
        -16,
        -2
      ],
      [
        -9,
        -4
      ],
      [
        -12,
        -1
      ],
      [
        -4,
        3
      ],
      [
        -3,
        4
      ],
      [
        -8,
        16
      ],
      [
        -11,
        20
      ],
      [
        -8,
        0
      ],
      [
        0,
        -3
      ],
      [
        -4,
        -2
      ],
      [
        -6,
        8
      ],
      [
        -5,
        14
      ],
      [
        -3,
        2
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -25
      ],
      [
        -3,
        -10
      ],
      [
        -3,
        -7
      ],
      [
        -6,
        -10
      ],
      [
        -32,
        -26
      ],
      [
        -4,
        -5
      ],
      [
        -2,
        -4
      ],
      [
        -13,
        -14
      ],
      [
        -9,
        -3
      ],
      [
        -3,
        5
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -5
      ],
      [
        -3,
        -5
      ],
      [
        -4,
        -3
      ]
    ],
    [
      [
        7849,
        88171
      ],
      [
        0,
        71
      ],
      [
        -100,
        0
      ],
      [
        0,
        202
      ],
      [
        -464,
        0
      ]
    ],
    [
      [
        23800,
        55915
      ],
      [
        -4,
        23
      ],
      [
        -5,
        17
      ],
      [
        2,
        20
      ],
      [
        -5,
        -22
      ],
      [
        3,
        -13
      ],
      [
        -5,
        -6
      ],
      [
        -2,
        32
      ],
      [
        -4,
        18
      ],
      [
        -2,
        28
      ],
      [
        -6,
        1
      ],
      [
        -1,
        13
      ],
      [
        3,
        13
      ],
      [
        1,
        18
      ],
      [
        -4,
        7
      ]
    ],
    [
      [
        24915,
        57163
      ],
      [
        -54,
        0
      ],
      [
        -79,
        1
      ]
    ],
    [
      [
        29238,
        64193
      ],
      [
        1,
        8
      ],
      [
        -1,
        8
      ],
      [
        0,
        28
      ],
      [
        1,
        2
      ],
      [
        1,
        4
      ],
      [
        2,
        10
      ],
      [
        2,
        2
      ],
      [
        6,
        -2
      ]
    ],
    [
      [
        29275,
        64272
      ],
      [
        -1,
        -15
      ],
      [
        1,
        -8
      ],
      [
        1,
        -20
      ],
      [
        1,
        -9
      ],
      [
        3,
        -15
      ],
      [
        -2,
        -11
      ],
      [
        -1,
        -4
      ],
      [
        -6,
        -24
      ],
      [
        -8,
        -26
      ],
      [
        -4,
        -11
      ],
      [
        -3,
        -9
      ],
      [
        -2,
        6
      ],
      [
        0,
        -1
      ],
      [
        -3,
        -5
      ],
      [
        -4,
        -9
      ],
      [
        -3,
        -2
      ],
      [
        -5,
        -11
      ],
      [
        -3,
        -2
      ],
      [
        -3,
        -8
      ],
      [
        -3,
        -2
      ],
      [
        -4,
        -6
      ],
      [
        -2,
        2
      ],
      [
        -2,
        5
      ]
    ],
    [
      [
        22032,
        72637
      ],
      [
        0,
        -202
      ],
      [
        10,
        0
      ],
      [
        0,
        -403
      ]
    ],
    [
      [
        22042,
        72032
      ],
      [
        -23,
        0
      ]
    ],
    [
      [
        22019,
        72032
      ],
      [
        -156,
        0
      ]
    ],
    [
      [
        29077,
        65850
      ],
      [
        31,
        60
      ],
      [
        32,
        62
      ],
      [
        2,
        7
      ],
      [
        5,
        22
      ],
      [
        7,
        -2
      ],
      [
        15,
        29
      ]
    ],
    [
      [
        29314,
        65922
      ],
      [
        1,
        -8
      ],
      [
        -1,
        -12
      ],
      [
        -2,
        -64
      ],
      [
        -7,
        -112
      ],
      [
        6,
        -43
      ],
      [
        -2,
        -26
      ],
      [
        -1,
        -93
      ],
      [
        2,
        -8
      ],
      [
        1,
        -10
      ],
      [
        0,
        -26
      ],
      [
        -1,
        -21
      ],
      [
        0,
        -29
      ],
      [
        1,
        -7
      ],
      [
        -2,
        -18
      ],
      [
        -1,
        -92
      ]
    ],
    [
      [
        27495,
        58547
      ],
      [
        -3,
        30
      ],
      [
        -4,
        9
      ],
      [
        -1,
        -11
      ],
      [
        -2,
        18
      ],
      [
        -4,
        -9
      ],
      [
        -7,
        14
      ],
      [
        -10,
        35
      ],
      [
        -8,
        13
      ],
      [
        -3,
        -5
      ],
      [
        -6,
        26
      ],
      [
        -11,
        1
      ],
      [
        1,
        10
      ],
      [
        -7,
        9
      ],
      [
        0,
        -11
      ],
      [
        -4,
        -1
      ]
    ],
    [
      [
        22052,
        57171
      ],
      [
        3,
        -1
      ],
      [
        3,
        2
      ],
      [
        1,
        1
      ],
      [
        2,
        4
      ],
      [
        1,
        6
      ],
      [
        1,
        2
      ],
      [
        0,
        4
      ],
      [
        1,
        2
      ],
      [
        2,
        2
      ],
      [
        5,
        -3
      ],
      [
        1,
        -3
      ],
      [
        1,
        -5
      ],
      [
        1,
        -5
      ],
      [
        5,
        -12
      ],
      [
        1,
        0
      ],
      [
        1,
        -2
      ],
      [
        1,
        -6
      ],
      [
        4,
        -14
      ],
      [
        0,
        -2
      ],
      [
        1,
        -3
      ],
      [
        0,
        -6
      ],
      [
        5,
        -18
      ],
      [
        2,
        -6
      ]
    ],
    [
      [
        21759,
        68355
      ],
      [
        -33,
        0
      ],
      [
        0,
        203
      ],
      [
        3,
        0
      ],
      [
        0,
        404
      ],
      [
        5,
        0
      ],
      [
        0,
        67
      ]
    ],
    [
      [
        23789,
        63810
      ],
      [
        110,
        3
      ]
    ],
    [
      [
        23900,
        63541
      ],
      [
        0,
        -76
      ]
    ],
    [
      [
        16478,
        62531
      ],
      [
        0,
        -61
      ]
    ],
    [
      [
        29571,
        65876
      ],
      [
        -6,
        -84
      ],
      [
        40,
        7
      ],
      [
        -5,
        -59
      ],
      [
        -3,
        -29
      ],
      [
        -7,
        -2
      ],
      [
        -4,
        -48
      ],
      [
        5,
        -17
      ],
      [
        -3,
        -39
      ],
      [
        -19,
        -9
      ],
      [
        5,
        -98
      ],
      [
        0,
        -2
      ],
      [
        4,
        -85
      ]
    ],
    [
      [
        29429,
        65443
      ],
      [
        0,
        24
      ],
      [
        2,
        62
      ],
      [
        0,
        21
      ],
      [
        2,
        76
      ],
      [
        0,
        40
      ],
      [
        1,
        40
      ],
      [
        1,
        34
      ],
      [
        1,
        42
      ],
      [
        1,
        49
      ],
      [
        1,
        58
      ]
    ],
    [
      [
        26032,
        53253
      ],
      [
        35,
        0
      ],
      [
        28,
        6
      ],
      [
        0,
        -68
      ],
      [
        -1,
        -168
      ]
    ],
    [
      [
        26094,
        53023
      ],
      [
        -3,
        -1
      ]
    ],
    [
      [
        26091,
        53022
      ],
      [
        -22,
        0
      ],
      [
        -48,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -40,
        -2
      ],
      [
        -39,
        0
      ]
    ],
    [
      [
        25899,
        53019
      ],
      [
        -1,
        11
      ],
      [
        0,
        220
      ]
    ],
    [
      [
        26114,
        53393
      ],
      [
        2,
        0
      ],
      [
        10,
        -1
      ],
      [
        14,
        -2
      ],
      [
        40,
        -6
      ],
      [
        25,
        1
      ]
    ],
    [
      [
        26229,
        53027
      ],
      [
        -67,
        0
      ],
      [
        -68,
        -4
      ]
    ],
    [
      [
        27176,
        59589
      ],
      [
        12,
        24
      ],
      [
        4,
        -2
      ],
      [
        4,
        23
      ],
      [
        0,
        20
      ],
      [
        -3,
        9
      ],
      [
        21,
        16
      ],
      [
        8,
        2
      ],
      [
        15,
        27
      ],
      [
        24,
        16
      ],
      [
        10,
        11
      ]
    ],
    [
      [
        27271,
        59735
      ],
      [
        22,
        -6
      ],
      [
        9,
        13
      ],
      [
        4,
        -7
      ],
      [
        14,
        5
      ],
      [
        1,
        24
      ],
      [
        3,
        3
      ],
      [
        9,
        18
      ]
    ],
    [
      [
        21170,
        62382
      ],
      [
        0,
        106
      ],
      [
        2,
        0
      ],
      [
        0,
        509
      ]
    ],
    [
      [
        23127,
        65675
      ],
      [
        -1,
        3
      ],
      [
        -1,
        4
      ],
      [
        0,
        3
      ],
      [
        -1,
        3
      ],
      [
        0,
        13
      ],
      [
        -1,
        4
      ],
      [
        -2,
        6
      ],
      [
        -1,
        5
      ],
      [
        0,
        5
      ],
      [
        1,
        3
      ],
      [
        0,
        2
      ],
      [
        1,
        3
      ],
      [
        4,
        3
      ],
      [
        0,
        2
      ],
      [
        1,
        5
      ],
      [
        0,
        7
      ],
      [
        -2,
        12
      ],
      [
        0,
        8
      ],
      [
        1,
        2
      ],
      [
        2,
        7
      ],
      [
        0,
        4
      ],
      [
        1,
        11
      ],
      [
        0,
        8
      ],
      [
        -1,
        3
      ],
      [
        -2,
        4
      ],
      [
        -4,
        3
      ],
      [
        -1,
        0
      ],
      [
        -4,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        4
      ],
      [
        0,
        5
      ],
      [
        1,
        5
      ],
      [
        1,
        7
      ],
      [
        0,
        9
      ],
      [
        -1,
        4
      ],
      [
        -2,
        3
      ],
      [
        -3,
        1
      ],
      [
        -3,
        -3
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        3
      ],
      [
        -1,
        3
      ],
      [
        0,
        9
      ],
      [
        1,
        6
      ],
      [
        3,
        7
      ],
      [
        1,
        5
      ],
      [
        1,
        4
      ],
      [
        0,
        4
      ],
      [
        -1,
        5
      ],
      [
        0,
        2
      ],
      [
        -2,
        4
      ],
      [
        -2,
        3
      ],
      [
        -2,
        0
      ],
      [
        -3,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        3
      ],
      [
        -1,
        3
      ],
      [
        -1,
        3
      ]
    ],
    [
      [
        23846,
        52873
      ],
      [
        0,
        -33
      ],
      [
        1,
        -6
      ],
      [
        0,
        -12
      ],
      [
        -2,
        -20
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        -1
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -11
      ],
      [
        0,
        -11
      ],
      [
        -1,
        -16
      ],
      [
        -4,
        -7
      ],
      [
        -3,
        -18
      ],
      [
        0,
        -4
      ],
      [
        2,
        -11
      ],
      [
        0,
        -13
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -11
      ],
      [
        0,
        -11
      ],
      [
        -2,
        -18
      ],
      [
        -3,
        -8
      ],
      [
        -4,
        -3
      ],
      [
        -5,
        -14
      ],
      [
        -3,
        -20
      ],
      [
        -1,
        -18
      ],
      [
        1,
        -20
      ],
      [
        1,
        -6
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        -5,
        -7
      ],
      [
        -5,
        -17
      ],
      [
        0,
        -9
      ],
      [
        1,
        -11
      ],
      [
        -1,
        -14
      ],
      [
        -3,
        -6
      ],
      [
        2,
        -11
      ],
      [
        1,
        -5
      ],
      [
        4,
        -8
      ],
      [
        1,
        -15
      ],
      [
        -1,
        -14
      ],
      [
        3,
        -42
      ],
      [
        2,
        -16
      ],
      [
        0,
        -4
      ],
      [
        -2,
        -13
      ],
      [
        -5,
        -10
      ],
      [
        -5,
        -22
      ]
    ],
    [
      [
        26788,
        56162
      ],
      [
        1,
        9
      ],
      [
        12,
        37
      ]
    ],
    [
      [
        26801,
        56208
      ],
      [
        17,
        -117
      ],
      [
        3,
        -14
      ],
      [
        3,
        25
      ],
      [
        5,
        -3
      ],
      [
        5,
        13
      ],
      [
        5,
        6
      ],
      [
        10,
        -27
      ],
      [
        10,
        -25
      ],
      [
        14,
        10
      ],
      [
        3,
        -24
      ]
    ],
    [
      [
        26876,
        56052
      ],
      [
        -7,
        -14
      ],
      [
        -4,
        -27
      ],
      [
        0,
        -28
      ],
      [
        -5,
        -13
      ],
      [
        -3,
        -21
      ],
      [
        -5,
        4
      ],
      [
        -6,
        -4
      ],
      [
        -7,
        12
      ],
      [
        -2,
        -20
      ],
      [
        -13,
        -44
      ],
      [
        5,
        -27
      ]
    ],
    [
      [
        22051,
        57387
      ],
      [
        0,
        331
      ]
    ],
    [
      [
        23059,
        54573
      ],
      [
        4,
        -13
      ],
      [
        8,
        -14
      ],
      [
        7,
        -3
      ],
      [
        8,
        -28
      ],
      [
        0,
        -27
      ],
      [
        5,
        4
      ],
      [
        1,
        -11
      ],
      [
        8,
        0
      ],
      [
        1,
        -16
      ],
      [
        9,
        -34
      ],
      [
        6,
        -3
      ],
      [
        6,
        12
      ],
      [
        2,
        -3
      ],
      [
        -3,
        -8
      ],
      [
        0,
        -16
      ],
      [
        -5,
        -12
      ],
      [
        0,
        -15
      ],
      [
        3,
        -11
      ],
      [
        8,
        -9
      ],
      [
        7,
        11
      ],
      [
        3,
        -21
      ],
      [
        -4,
        -19
      ],
      [
        1,
        -12
      ],
      [
        -1,
        -25
      ],
      [
        3,
        -22
      ],
      [
        7,
        7
      ],
      [
        4,
        5
      ],
      [
        -1,
        -11
      ],
      [
        2,
        -58
      ],
      [
        2,
        -16
      ]
    ],
    [
      [
        23150,
        54205
      ],
      [
        -123,
        -252
      ]
    ],
    [
      [
        26931,
        54154
      ],
      [
        12,
        290
      ],
      [
        1,
        87
      ],
      [
        8,
        71
      ]
    ],
    [
      [
        27001,
        54561
      ],
      [
        2,
        -48
      ],
      [
        4,
        -44
      ],
      [
        -1,
        -12
      ],
      [
        3,
        -23
      ],
      [
        3,
        -9
      ],
      [
        3,
        -37
      ],
      [
        0,
        -4
      ],
      [
        -3,
        -38
      ],
      [
        -3,
        -67
      ],
      [
        -1,
        -42
      ],
      [
        -5,
        -148
      ]
    ],
    [
      [
        24659,
        61264
      ],
      [
        2,
        -3
      ],
      [
        6,
        -5
      ],
      [
        -3,
        -35
      ],
      [
        2,
        -28
      ],
      [
        -4,
        -9
      ],
      [
        12,
        -5
      ],
      [
        47,
        45
      ]
    ],
    [
      [
        20815,
        59101
      ],
      [
        119,
        -1
      ]
    ],
    [
      [
        19247,
        69523
      ],
      [
        -46,
        0
      ],
      [
        0,
        206
      ],
      [
        3,
        0
      ],
      [
        0,
        373
      ],
      [
        -1,
        135
      ],
      [
        -20,
        0
      ],
      [
        0,
        406
      ],
      [
        3,
        0
      ],
      [
        0,
        59
      ]
    ],
    [
      [
        26085,
        60656
      ],
      [
        20,
        153
      ],
      [
        13,
        52
      ]
    ],
    [
      [
        26118,
        60861
      ],
      [
        3,
        -20
      ],
      [
        5,
        -13
      ],
      [
        1,
        -16
      ],
      [
        -1,
        -18
      ],
      [
        7,
        -20
      ],
      [
        2,
        -5
      ],
      [
        8,
        0
      ],
      [
        15,
        -24
      ],
      [
        64,
        0
      ]
    ],
    [
      [
        25909,
        58793
      ],
      [
        -1,
        -25
      ],
      [
        4,
        -21
      ],
      [
        -3,
        -6
      ],
      [
        -2,
        -33
      ],
      [
        -3,
        4
      ],
      [
        -3,
        -69
      ],
      [
        -2,
        -34
      ],
      [
        0,
        -38
      ],
      [
        -2,
        -26
      ],
      [
        -3,
        -10
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        25883,
        58418
      ],
      [
        -12,
        19
      ],
      [
        -5,
        -2
      ],
      [
        -1,
        17
      ],
      [
        -9,
        4
      ],
      [
        -3,
        -17
      ],
      [
        -7,
        -8
      ],
      [
        2,
        -14
      ],
      [
        -8,
        -14
      ],
      [
        -4,
        5
      ],
      [
        0,
        19
      ],
      [
        -3,
        15
      ],
      [
        -8,
        -9
      ],
      [
        -1,
        -9
      ],
      [
        -4,
        20
      ],
      [
        -6,
        4
      ],
      [
        -6,
        36
      ],
      [
        -8,
        10
      ],
      [
        -26,
        5
      ],
      [
        -1,
        -18
      ]
    ],
    [
      [
        25773,
        58481
      ],
      [
        -12,
        21
      ],
      [
        -1,
        7
      ]
    ],
    [
      [
        15830,
        72840
      ],
      [
        2,
        -2
      ],
      [
        5,
        -16
      ],
      [
        -1,
        -2
      ],
      [
        -5,
        7
      ],
      [
        -3,
        10
      ],
      [
        2,
        3
      ]
    ],
    [
      [
        15809,
        73109
      ],
      [
        2,
        6
      ],
      [
        1,
        14
      ],
      [
        6,
        21
      ],
      [
        -1,
        10
      ],
      [
        -1,
        2
      ]
    ],
    [
      [
        15811,
        72557
      ],
      [
        0,
        2
      ],
      [
        1,
        27
      ],
      [
        0,
        5
      ],
      [
        11,
        39
      ],
      [
        2,
        2
      ],
      [
        2,
        5
      ],
      [
        1,
        6
      ],
      [
        1,
        8
      ],
      [
        1,
        12
      ],
      [
        0,
        7
      ],
      [
        -1,
        6
      ],
      [
        1,
        20
      ],
      [
        2,
        16
      ],
      [
        3,
        16
      ],
      [
        0,
        13
      ],
      [
        1,
        15
      ],
      [
        3,
        3
      ],
      [
        5,
        6
      ],
      [
        8,
        3
      ],
      [
        6,
        13
      ],
      [
        1,
        7
      ],
      [
        -2,
        13
      ],
      [
        0,
        22
      ],
      [
        1,
        7
      ],
      [
        1,
        4
      ],
      [
        -2,
        16
      ],
      [
        -14,
        23
      ],
      [
        -7,
        28
      ],
      [
        -4,
        14
      ],
      [
        -1,
        8
      ],
      [
        -5,
        6
      ],
      [
        -6,
        30
      ],
      [
        0,
        32
      ],
      [
        -2,
        16
      ],
      [
        2,
        11
      ],
      [
        1,
        15
      ],
      [
        -3,
        7
      ],
      [
        -3,
        16
      ],
      [
        -1,
        13
      ],
      [
        -3,
        12
      ]
    ],
    [
      [
        15811,
        73081
      ],
      [
        1,
        5
      ],
      [
        0,
        7
      ],
      [
        -2,
        4
      ],
      [
        0,
        5
      ],
      [
        -1,
        2
      ],
      [
        0,
        5
      ]
    ],
    [
      [
        26368,
        62449
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        0
      ],
      [
        -4,
        8
      ],
      [
        -1,
        1
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -9
      ],
      [
        -3,
        -6
      ],
      [
        -5,
        -5
      ],
      [
        -3,
        -4
      ],
      [
        -2,
        -1
      ],
      [
        -3,
        0
      ],
      [
        -1,
        1
      ]
    ],
    [
      [
        26335,
        62425
      ],
      [
        -3,
        3
      ],
      [
        -5,
        17
      ],
      [
        -1,
        5
      ],
      [
        -3,
        3
      ],
      [
        -3,
        0
      ],
      [
        -2,
        3
      ],
      [
        -2,
        4
      ],
      [
        0,
        4
      ],
      [
        -3,
        13
      ],
      [
        -3,
        16
      ],
      [
        -2,
        5
      ],
      [
        -2,
        6
      ],
      [
        -1,
        3
      ],
      [
        -4,
        3
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        -9
      ],
      [
        -5,
        -24
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -3
      ],
      [
        -4,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -2
      ]
    ],
    [
      [
        26280,
        62461
      ],
      [
        0,
        233
      ]
    ],
    [
      [
        22730,
        56399
      ],
      [
        1,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        2,
        4
      ],
      [
        3,
        6
      ],
      [
        2,
        7
      ],
      [
        2,
        2
      ],
      [
        5,
        7
      ],
      [
        2,
        -1
      ],
      [
        2,
        -2
      ],
      [
        1,
        -2
      ]
    ],
    [
      [
        25266,
        64221
      ],
      [
        -32,
        -1
      ],
      [
        0,
        63
      ],
      [
        -2,
        0
      ],
      [
        -1,
        102
      ],
      [
        -96,
        -5
      ]
    ],
    [
      [
        23921,
        57418
      ],
      [
        -30,
        -1
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        26269,
        55206
      ],
      [
        0,
        -5
      ],
      [
        -67,
        2
      ],
      [
        -2,
        -4
      ],
      [
        0,
        4
      ],
      [
        -22,
        0
      ]
    ],
    [
      [
        26911,
        49121
      ],
      [
        9,
        0
      ],
      [
        19,
        1
      ],
      [
        112,
        0
      ]
    ],
    [
      [
        26887,
        48823
      ],
      [
        -9,
        41
      ],
      [
        -5,
        15
      ],
      [
        0,
        8
      ],
      [
        -4,
        50
      ],
      [
        -2,
        15
      ],
      [
        -3,
        16
      ],
      [
        -5,
        20
      ],
      [
        -1,
        9
      ],
      [
        1,
        1
      ],
      [
        10,
        -19
      ],
      [
        1,
        -30
      ],
      [
        4,
        -1
      ],
      [
        1,
        1
      ],
      [
        -1,
        12
      ],
      [
        1,
        6
      ],
      [
        3,
        8
      ],
      [
        3,
        3
      ],
      [
        4,
        1
      ],
      [
        1,
        12
      ],
      [
        4,
        21
      ],
      [
        5,
        23
      ],
      [
        0,
        16
      ],
      [
        5,
        10
      ],
      [
        3,
        3
      ],
      [
        4,
        15
      ],
      [
        1,
        8
      ],
      [
        2,
        26
      ],
      [
        1,
        8
      ]
    ],
    [
      [
        28830,
        61117
      ],
      [
        1,
        -1
      ],
      [
        2,
        -5
      ],
      [
        3,
        2
      ],
      [
        0,
        26
      ],
      [
        1,
        8
      ],
      [
        1,
        4
      ],
      [
        2,
        5
      ],
      [
        0,
        4
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        0,
        5
      ]
    ],
    [
      [
        28842,
        61168
      ],
      [
        53,
        18
      ],
      [
        2,
        1
      ],
      [
        8,
        3
      ],
      [
        6,
        2
      ],
      [
        32,
        12
      ],
      [
        6,
        2
      ]
    ],
    [
      [
        28949,
        61206
      ],
      [
        -16,
        -79
      ],
      [
        -6,
        -43
      ],
      [
        -5,
        -32
      ],
      [
        -4,
        -23
      ],
      [
        -4,
        -14
      ],
      [
        -2,
        -8
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        1
      ],
      [
        -1,
        4
      ],
      [
        -1,
        9
      ],
      [
        -2,
        7
      ],
      [
        -7,
        0
      ],
      [
        -4,
        -1
      ],
      [
        -4,
        -6
      ],
      [
        -4,
        -15
      ],
      [
        -6,
        -22
      ],
      [
        -9,
        -41
      ],
      [
        -9,
        -57
      ],
      [
        -3,
        -13
      ],
      [
        -1,
        -15
      ],
      [
        -2,
        -28
      ],
      [
        -2,
        -8
      ],
      [
        -3,
        -35
      ],
      [
        -3,
        -40
      ],
      [
        -3,
        -22
      ],
      [
        0,
        -38
      ],
      [
        4,
        -4
      ],
      [
        -1,
        -7
      ],
      [
        -3,
        -18
      ],
      [
        -8,
        -41
      ],
      [
        -8,
        -39
      ],
      [
        -4,
        -5
      ],
      [
        1,
        -18
      ],
      [
        2,
        0
      ]
    ],
    [
      [
        28755,
        60650
      ],
      [
        0,
        3
      ],
      [
        -1,
        7
      ],
      [
        0,
        7
      ],
      [
        4,
        42
      ],
      [
        5,
        26
      ],
      [
        9,
        44
      ],
      [
        2,
        9
      ],
      [
        0,
        23
      ],
      [
        3,
        18
      ],
      [
        4,
        6
      ],
      [
        2,
        5
      ],
      [
        2,
        15
      ],
      [
        -1,
        7
      ],
      [
        1,
        8
      ],
      [
        1,
        4
      ],
      [
        4,
        9
      ],
      [
        2,
        15
      ],
      [
        -2,
        16
      ],
      [
        -2,
        18
      ],
      [
        7,
        15
      ],
      [
        3,
        3
      ],
      [
        3,
        -3
      ],
      [
        8,
        2
      ],
      [
        2,
        12
      ],
      [
        4,
        4
      ],
      [
        1,
        8
      ],
      [
        1,
        13
      ],
      [
        2,
        11
      ],
      [
        1,
        2
      ],
      [
        4,
        15
      ],
      [
        1,
        13
      ],
      [
        0,
        15
      ],
      [
        -7,
        17
      ],
      [
        -3,
        1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        -8,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        1,
        6
      ],
      [
        13,
        37
      ],
      [
        2,
        -8
      ],
      [
        3,
        1
      ],
      [
        7,
        24
      ]
    ],
    [
      [
        28738,
        60998
      ],
      [
        0,
        2
      ],
      [
        2,
        -1
      ],
      [
        1,
        -9
      ],
      [
        1,
        -5
      ],
      [
        3,
        -2
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -23
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        9
      ],
      [
        -1,
        26
      ],
      [
        1,
        16
      ]
    ],
    [
      [
        28739,
        61120
      ],
      [
        -2,
        -6
      ],
      [
        -4,
        -15
      ],
      [
        -5,
        -23
      ],
      [
        0,
        16
      ],
      [
        -3,
        28
      ]
    ],
    [
      [
        28725,
        61120
      ],
      [
        1,
        1
      ],
      [
        10,
        0
      ],
      [
        3,
        -1
      ]
    ],
    [
      [
        26674,
        55236
      ],
      [
        46,
        -337
      ],
      [
        4,
        -29
      ]
    ],
    [
      [
        28682,
        62165
      ],
      [
        0,
        5
      ],
      [
        -1,
        9
      ],
      [
        1,
        23
      ],
      [
        -2,
        12
      ],
      [
        1,
        41
      ],
      [
        -3,
        11
      ],
      [
        -5,
        6
      ],
      [
        -1,
        -1
      ],
      [
        -4,
        -4
      ],
      [
        0,
        -21
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        1
      ],
      [
        0,
        12
      ],
      [
        -3,
        14
      ],
      [
        -6,
        -15
      ],
      [
        -1,
        -12
      ],
      [
        2,
        -10
      ],
      [
        0,
        -9
      ],
      [
        -4,
        -5
      ],
      [
        -3,
        13
      ],
      [
        0,
        2
      ],
      [
        -2,
        0
      ],
      [
        -3,
        -6
      ],
      [
        -1,
        -16
      ],
      [
        1,
        -7
      ],
      [
        1,
        -25
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        -3,
        2
      ],
      [
        -3,
        -7
      ],
      [
        -2,
        -18
      ],
      [
        -2,
        4
      ],
      [
        0,
        12
      ],
      [
        3,
        28
      ],
      [
        0,
        39
      ],
      [
        1,
        37
      ],
      [
        2,
        21
      ],
      [
        9,
        49
      ],
      [
        0,
        8
      ],
      [
        -1,
        3
      ],
      [
        1,
        16
      ],
      [
        3,
        15
      ],
      [
        2,
        5
      ],
      [
        1,
        -10
      ],
      [
        -1,
        -6
      ],
      [
        3,
        -26
      ],
      [
        4,
        -25
      ],
      [
        3,
        1
      ],
      [
        2,
        1
      ],
      [
        8,
        -7
      ],
      [
        1,
        -1
      ],
      [
        3,
        -8
      ],
      [
        4,
        3
      ],
      [
        11,
        31
      ],
      [
        0,
        12
      ],
      [
        -1,
        10
      ],
      [
        -3,
        15
      ],
      [
        -2,
        17
      ],
      [
        3,
        15
      ],
      [
        1,
        5
      ],
      [
        3,
        3
      ],
      [
        2,
        10
      ],
      [
        1,
        6
      ],
      [
        1,
        16
      ],
      [
        -4,
        1
      ]
    ],
    [
      [
        24585,
        64247
      ],
      [
        -33,
        -5
      ],
      [
        -45,
        3
      ]
    ],
    [
      [
        24507,
        64245
      ],
      [
        8,
        18
      ],
      [
        5,
        9
      ],
      [
        4,
        10
      ],
      [
        0,
        1
      ],
      [
        1,
        3
      ],
      [
        0,
        3
      ],
      [
        1,
        19
      ],
      [
        1,
        5
      ]
    ],
    [
      [
        23353,
        59440
      ],
      [
        89,
        0
      ]
    ],
    [
      [
        23321,
        58934
      ],
      [
        0,
        202
      ],
      [
        2,
        1
      ],
      [
        0,
        303
      ],
      [
        30,
        0
      ]
    ],
    [
      [
        29360,
        64523
      ],
      [
        -1,
        -19
      ],
      [
        1,
        -3
      ],
      [
        0,
        -15
      ],
      [
        -1,
        0
      ],
      [
        -2,
        2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        5
      ],
      [
        -1,
        5
      ],
      [
        0,
        11
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -5
      ],
      [
        -2,
        2
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -13
      ],
      [
        0,
        -5
      ],
      [
        1,
        -7
      ],
      [
        2,
        -8
      ],
      [
        2,
        -3
      ],
      [
        3,
        -16
      ]
    ],
    [
      [
        26644,
        64455
      ],
      [
        5,
        0
      ],
      [
        0,
        -136
      ],
      [
        16,
        1
      ],
      [
        0,
        -17
      ],
      [
        5,
        -1
      ]
    ],
    [
      [
        26542,
        64253
      ],
      [
        0,
        204
      ]
    ],
    [
      [
        22784,
        65128
      ],
      [
        9,
        -5
      ],
      [
        14,
        10
      ],
      [
        9,
        -19
      ]
    ],
    [
      [
        19529,
        62765
      ],
      [
        0,
        -537
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -127
      ],
      [
        -1,
        -88
      ],
      [
        0,
        -255
      ]
    ],
    [
      [
        18656,
        73371
      ],
      [
        3,
        -12
      ],
      [
        6,
        -3
      ],
      [
        0,
        8
      ],
      [
        15,
        -25
      ],
      [
        6,
        -17
      ],
      [
        1,
        10
      ],
      [
        13,
        10
      ],
      [
        6,
        -4
      ],
      [
        4,
        -12
      ],
      [
        0,
        -52
      ],
      [
        20,
        -1
      ],
      [
        35,
        0
      ],
      [
        0,
        -51
      ],
      [
        36,
        0
      ],
      [
        0,
        -151
      ],
      [
        71,
        0
      ]
    ],
    [
      [
        16559,
        62631
      ],
      [
        8,
        -49
      ],
      [
        10,
        -16
      ],
      [
        24,
        -1
      ],
      [
        0,
        -19
      ],
      [
        -3,
        -24
      ],
      [
        0,
        -15
      ],
      [
        3,
        -9
      ],
      [
        3,
        -60
      ]
    ],
    [
      [
        26938,
        52021
      ],
      [
        4,
        2
      ],
      [
        24,
        1
      ],
      [
        60,
        5
      ]
    ],
    [
      [
        27026,
        52029
      ],
      [
        1,
        -19
      ],
      [
        -2,
        -20
      ],
      [
        -6,
        -12
      ],
      [
        -3,
        -28
      ],
      [
        -2,
        -13
      ],
      [
        -6,
        -14
      ],
      [
        -5,
        -21
      ],
      [
        -10,
        -7
      ],
      [
        -3,
        -34
      ],
      [
        -10,
        -50
      ],
      [
        -5,
        -1
      ],
      [
        -4,
        7
      ],
      [
        -2,
        -23
      ],
      [
        -3,
        -10
      ],
      [
        -3,
        3
      ],
      [
        -6,
        -12
      ],
      [
        -8,
        -3
      ]
    ],
    [
      [
        8470,
        87637
      ],
      [
        -81,
        0
      ],
      [
        0,
        101
      ],
      [
        1,
        17
      ],
      [
        0,
        11
      ]
    ],
    [
      [
        8390,
        87766
      ],
      [
        8,
        -14
      ],
      [
        2,
        9
      ],
      [
        -3,
        18
      ],
      [
        -22,
        63
      ],
      [
        -29,
        36
      ],
      [
        -38,
        -14
      ],
      [
        -51,
        63
      ],
      [
        -24,
        -1
      ],
      [
        -40,
        42
      ],
      [
        -3,
        8
      ],
      [
        -9,
        16
      ],
      [
        -1,
        3
      ],
      [
        -5,
        21
      ],
      [
        -7,
        20
      ],
      [
        -1,
        1
      ],
      [
        -7,
        3
      ],
      [
        -16,
        26
      ],
      [
        -13,
        33
      ],
      [
        -2,
        3
      ],
      [
        -12,
        9
      ],
      [
        -7,
        5
      ],
      [
        -8,
        8
      ],
      [
        -2,
        6
      ],
      [
        2,
        11
      ],
      [
        16,
        44
      ],
      [
        24,
        9
      ],
      [
        3,
        11
      ],
      [
        7,
        30
      ],
      [
        21,
        83
      ],
      [
        9,
        7
      ],
      [
        14,
        11
      ],
      [
        8,
        60
      ],
      [
        25,
        11
      ],
      [
        10,
        16
      ],
      [
        11,
        0
      ],
      [
        11,
        22
      ],
      [
        1,
        2
      ],
      [
        18,
        21
      ],
      [
        -1,
        25
      ]
    ],
    [
      [
        8053,
        88108
      ],
      [
        4,
        29
      ],
      [
        2,
        9
      ],
      [
        16,
        5
      ],
      [
        2,
        -8
      ],
      [
        0,
        -8
      ],
      [
        -9,
        -24
      ],
      [
        -11,
        -19
      ],
      [
        -10,
        4
      ],
      [
        6,
        12
      ]
    ],
    [
      [
        25134,
        70573
      ],
      [
        0,
        -107
      ],
      [
        -32,
        0
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        25102,
        70365
      ],
      [
        -20,
        0
      ],
      [
        -16,
        5
      ],
      [
        1,
        -50
      ],
      [
        -23,
        6
      ],
      [
        -12,
        -1
      ],
      [
        0,
        47
      ],
      [
        -35,
        -3
      ],
      [
        -92,
        0
      ],
      [
        -74,
        -2
      ],
      [
        -6,
        0
      ]
    ],
    [
      [
        25009,
        55890
      ],
      [
        6,
        15
      ],
      [
        6,
        -4
      ],
      [
        6,
        31
      ],
      [
        13,
        17
      ],
      [
        3,
        9
      ],
      [
        9,
        1
      ],
      [
        13,
        15
      ],
      [
        26,
        1
      ]
    ],
    [
      [
        22784,
        63911
      ],
      [
        0,
        -406
      ]
    ],
    [
      [
        26303,
        56611
      ],
      [
        0,
        -154
      ],
      [
        4,
        0
      ],
      [
        0,
        -164
      ]
    ],
    [
      [
        26257,
        56263
      ],
      [
        -9,
        11
      ],
      [
        -29,
        25
      ]
    ],
    [
      [
        17639,
        63651
      ],
      [
        93,
        1
      ],
      [
        271,
        -11
      ],
      [
        134,
        -2
      ]
    ],
    [
      [
        17872,
        61963
      ],
      [
        -167,
        375
      ],
      [
        -1,
        0
      ],
      [
        -85,
        189
      ]
    ],
    [
      [
        23527,
        55113
      ],
      [
        10,
        -20
      ],
      [
        10,
        -22
      ],
      [
        4,
        -8
      ],
      [
        7,
        -16
      ],
      [
        5,
        -11
      ],
      [
        3,
        -6
      ],
      [
        1,
        -3
      ],
      [
        6,
        -11
      ],
      [
        9,
        -18
      ],
      [
        31,
        0
      ],
      [
        4,
        1
      ],
      [
        1,
        3
      ],
      [
        1,
        8
      ],
      [
        1,
        -3
      ],
      [
        2,
        2
      ],
      [
        2,
        3
      ],
      [
        2,
        4
      ],
      [
        0,
        4
      ],
      [
        3,
        4
      ],
      [
        2,
        2
      ],
      [
        2,
        8
      ],
      [
        1,
        3
      ],
      [
        1,
        1
      ],
      [
        2,
        -2
      ],
      [
        2,
        -2
      ],
      [
        2,
        3
      ],
      [
        1,
        9
      ],
      [
        1,
        4
      ],
      [
        1,
        8
      ],
      [
        1,
        5
      ],
      [
        2,
        -1
      ],
      [
        0,
        -2
      ],
      [
        3,
        0
      ],
      [
        0,
        3
      ],
      [
        1,
        0
      ],
      [
        0,
        2
      ],
      [
        1,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -5
      ],
      [
        1,
        0
      ],
      [
        0,
        3
      ],
      [
        1,
        0
      ],
      [
        2,
        -5
      ],
      [
        1,
        -15
      ],
      [
        1,
        -8
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -8
      ],
      [
        2,
        -6
      ],
      [
        4,
        -5
      ],
      [
        4,
        -5
      ],
      [
        7,
        4
      ],
      [
        2,
        15
      ],
      [
        4,
        14
      ],
      [
        1,
        10
      ],
      [
        3,
        5
      ],
      [
        4,
        -3
      ],
      [
        3,
        -2
      ],
      [
        1,
        0
      ],
      [
        2,
        -2
      ],
      [
        1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -9
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        2
      ],
      [
        1,
        -12
      ],
      [
        3,
        -2
      ],
      [
        5,
        -15
      ],
      [
        10,
        6
      ]
    ],
    [
      [
        23711,
        54997
      ],
      [
        0,
        -350
      ]
    ],
    [
      [
        26401,
        55764
      ],
      [
        1,
        -14
      ],
      [
        -3,
        -36
      ],
      [
        -7,
        -18
      ],
      [
        -4,
        -43
      ],
      [
        -18,
        1
      ]
    ],
    [
      [
        26064,
        63254
      ],
      [
        -10,
        0
      ],
      [
        0,
        -102
      ]
    ],
    [
      [
        24311,
        54157
      ],
      [
        12,
        -21
      ],
      [
        -1,
        -10
      ],
      [
        7,
        -32
      ],
      [
        5,
        1
      ],
      [
        3,
        -18
      ],
      [
        -3,
        -11
      ],
      [
        7,
        -7
      ],
      [
        0,
        -18
      ],
      [
        7,
        15
      ],
      [
        7,
        -3
      ],
      [
        2,
        13
      ],
      [
        7,
        12
      ],
      [
        4,
        23
      ],
      [
        4,
        2
      ],
      [
        4,
        29
      ],
      [
        2,
        24
      ],
      [
        14,
        -1
      ],
      [
        0,
        -101
      ],
      [
        6,
        -1
      ]
    ],
    [
      [
        24326,
        53336
      ],
      [
        -6,
        -2
      ],
      [
        -4,
        19
      ],
      [
        -11,
        19
      ],
      [
        -7,
        -9
      ],
      [
        -3,
        -20
      ],
      [
        3,
        -39
      ],
      [
        4,
        -8
      ],
      [
        -6,
        -12
      ],
      [
        -1,
        21
      ],
      [
        -5,
        3
      ],
      [
        -3,
        -20
      ],
      [
        -5,
        1
      ],
      [
        0,
        15
      ],
      [
        -3,
        5
      ],
      [
        4,
        7
      ],
      [
        -4,
        11
      ],
      [
        -2,
        28
      ],
      [
        -3,
        -2
      ],
      [
        1,
        25
      ],
      [
        2,
        -12
      ],
      [
        4,
        9
      ],
      [
        -3,
        8
      ],
      [
        1,
        13
      ],
      [
        -1,
        9
      ]
    ],
    [
      [
        26360,
        62096
      ],
      [
        31,
        16
      ],
      [
        1,
        1
      ]
    ],
    [
      [
        26376,
        61806
      ],
      [
        -16,
        290
      ]
    ],
    [
      [
        27271,
        59735
      ],
      [
        -2,
        33
      ],
      [
        -16,
        126
      ],
      [
        -14,
        61
      ]
    ],
    [
      [
        19649,
        69323
      ],
      [
        12,
        1
      ],
      [
        3,
        0
      ],
      [
        19,
        -1
      ],
      [
        64,
        0
      ],
      [
        6,
        -1
      ]
    ],
    [
      [
        19753,
        69322
      ],
      [
        3,
        1
      ],
      [
        5,
        1
      ],
      [
        61,
        0
      ],
      [
        1,
        1
      ],
      [
        24,
        -1
      ]
    ],
    [
      [
        21734,
        69029
      ],
      [
        -1,
        0
      ],
      [
        -3,
        -22
      ],
      [
        -20,
        -40
      ],
      [
        -5,
        5
      ],
      [
        -4,
        -3
      ],
      [
        -3,
        -7
      ],
      [
        -8,
        -1
      ],
      [
        -3,
        -5
      ],
      [
        -5,
        0
      ],
      [
        -2,
        7
      ],
      [
        -6,
        -3
      ],
      [
        -2,
        -10
      ],
      [
        -1,
        -8
      ],
      [
        -2,
        1
      ],
      [
        0,
        -7
      ],
      [
        1,
        -3
      ],
      [
        -2,
        -8
      ],
      [
        -3,
        -5
      ],
      [
        -3,
        3
      ],
      [
        -4,
        -8
      ],
      [
        -5,
        -10
      ],
      [
        -5,
        -3
      ],
      [
        -2,
        -8
      ],
      [
        -3,
        -18
      ],
      [
        1,
        -6
      ],
      [
        -3,
        -2
      ],
      [
        -1,
        -7
      ],
      [
        -3,
        -1
      ],
      [
        -3,
        -7
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -11
      ],
      [
        -2,
        4
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -10
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        0
      ],
      [
        -2,
        4
      ],
      [
        -2,
        0
      ],
      [
        -1,
        2
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        2
      ],
      [
        -4,
        6
      ],
      [
        -4,
        -4
      ],
      [
        -3,
        1
      ],
      [
        -4,
        -4
      ],
      [
        -3,
        1
      ],
      [
        0,
        7
      ],
      [
        -1,
        5
      ],
      [
        -2,
        1
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        3
      ],
      [
        -3,
        3
      ],
      [
        -4,
        -6
      ],
      [
        -1,
        -10
      ],
      [
        -3,
        0
      ],
      [
        -1,
        3
      ],
      [
        -3,
        3
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        -7
      ],
      [
        -3,
        -2
      ],
      [
        -3,
        0
      ],
      [
        0,
        -10
      ],
      [
        -4,
        -12
      ],
      [
        -4,
        -9
      ],
      [
        -3,
        -1
      ],
      [
        -5,
        -1
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -5
      ],
      [
        -3,
        -4
      ],
      [
        1,
        4
      ],
      [
        -3,
        4
      ],
      [
        -2,
        -6
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        4
      ],
      [
        -1,
        2
      ],
      [
        -4,
        2
      ],
      [
        -3,
        2
      ],
      [
        -2,
        0
      ],
      [
        -1,
        4
      ],
      [
        -2,
        1
      ],
      [
        -3,
        -1
      ],
      [
        -3,
        -4
      ],
      [
        -3,
        -3
      ],
      [
        -3,
        1
      ],
      [
        -2,
        3
      ],
      [
        -5,
        -6
      ],
      [
        -3,
        -3
      ],
      [
        -3,
        -4
      ],
      [
        -3,
        0
      ],
      [
        -2,
        -12
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        30179,
        64969
      ],
      [
        2,
        2
      ],
      [
        2,
        4
      ],
      [
        1,
        -3
      ],
      [
        2,
        -5
      ],
      [
        -1,
        -10
      ],
      [
        -2,
        0
      ],
      [
        -3,
        2
      ],
      [
        -3,
        8
      ],
      [
        2,
        2
      ]
    ],
    [
      [
        30177,
        65078
      ],
      [
        6,
        3
      ],
      [
        3,
        -2
      ],
      [
        5,
        -7
      ],
      [
        2,
        1
      ],
      [
        2,
        5
      ],
      [
        11,
        52
      ],
      [
        1,
        1
      ],
      [
        4,
        12
      ],
      [
        0,
        7
      ],
      [
        3,
        18
      ],
      [
        4,
        12
      ],
      [
        10,
        23
      ],
      [
        13,
        25
      ],
      [
        1,
        -1
      ],
      [
        1,
        -11
      ],
      [
        6,
        -4
      ],
      [
        2,
        3
      ],
      [
        1,
        -2
      ],
      [
        3,
        -19
      ],
      [
        0,
        -11
      ],
      [
        -1,
        -15
      ],
      [
        1,
        -8
      ],
      [
        2,
        -9
      ],
      [
        2,
        -8
      ],
      [
        3,
        -5
      ],
      [
        3,
        -1
      ],
      [
        3,
        -4
      ],
      [
        1,
        -10
      ],
      [
        0,
        -8
      ],
      [
        1,
        -1
      ],
      [
        2,
        -1
      ],
      [
        2,
        3
      ],
      [
        3,
        15
      ],
      [
        0,
        12
      ],
      [
        1,
        4
      ],
      [
        2,
        8
      ],
      [
        4,
        1
      ],
      [
        1,
        -28
      ],
      [
        -1,
        -18
      ],
      [
        0,
        -32
      ],
      [
        -1,
        -6
      ],
      [
        -12,
        -2
      ],
      [
        -12,
        3
      ],
      [
        -17,
        0
      ],
      [
        -31,
        -9
      ],
      [
        -6,
        -6
      ],
      [
        -4,
        -7
      ],
      [
        -5,
        -13
      ],
      [
        -1,
        -8
      ],
      [
        1,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -3
      ],
      [
        -7,
        15
      ],
      [
        -5,
        16
      ],
      [
        -6,
        23
      ],
      [
        2,
        7
      ]
    ],
    [
      [
        30216,
        65279
      ],
      [
        1,
        -10
      ],
      [
        0,
        -1
      ],
      [
        2,
        1
      ],
      [
        2,
        2
      ],
      [
        1,
        -4
      ],
      [
        1,
        -3
      ]
    ],
    [
      [
        30223,
        65264
      ],
      [
        -2,
        -1
      ],
      [
        -8,
        -18
      ],
      [
        -8,
        -12
      ],
      [
        -7,
        -19
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -6
      ],
      [
        -8,
        -17
      ],
      [
        -8,
        -1
      ],
      [
        -5,
        -4
      ],
      [
        -6,
        -19
      ],
      [
        -2,
        -4
      ],
      [
        -10,
        -1
      ],
      [
        -7,
        -6
      ],
      [
        -3,
        -5
      ],
      [
        -3,
        -3
      ],
      [
        -1,
        3
      ],
      [
        1,
        4
      ],
      [
        6,
        19
      ],
      [
        1,
        -1
      ],
      [
        6,
        4
      ],
      [
        6,
        5
      ],
      [
        7,
        12
      ],
      [
        7,
        9
      ],
      [
        8,
        5
      ],
      [
        4,
        16
      ],
      [
        3,
        3
      ],
      [
        6,
        18
      ],
      [
        3,
        10
      ],
      [
        14,
        29
      ]
    ],
    [
      [
        26614,
        56862
      ],
      [
        17,
        -50
      ],
      [
        20,
        5
      ],
      [
        2,
        6
      ],
      [
        22,
        -75
      ]
    ],
    [
      [
        25596,
        64921
      ],
      [
        0,
        -357
      ],
      [
        2,
        0
      ],
      [
        0,
        -204
      ]
    ],
    [
      [
        23208,
        56333
      ],
      [
        1,
        -2
      ],
      [
        1,
        -3
      ],
      [
        2,
        -2
      ],
      [
        1,
        1
      ],
      [
        2,
        4
      ],
      [
        0,
        2
      ],
      [
        1,
        2
      ],
      [
        0,
        7
      ],
      [
        -1,
        3
      ],
      [
        0,
        8
      ],
      [
        5,
        4
      ],
      [
        1,
        0
      ],
      [
        3,
        -4
      ],
      [
        0,
        -2
      ],
      [
        4,
        -13
      ],
      [
        1,
        -2
      ],
      [
        2,
        5
      ],
      [
        2,
        3
      ],
      [
        1,
        4
      ],
      [
        0,
        3
      ],
      [
        -1,
        14
      ],
      [
        -1,
        3
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        23205,
        55892
      ],
      [
        1,
        426
      ],
      [
        2,
        15
      ]
    ],
    [
      [
        23627,
        70810
      ],
      [
        -5,
        26
      ],
      [
        -3,
        -3
      ],
      [
        -3,
        14
      ],
      [
        -12,
        27
      ],
      [
        -10,
        -1
      ],
      [
        -6,
        -18
      ],
      [
        -7,
        -4
      ],
      [
        -7,
        -12
      ],
      [
        -6,
        6
      ],
      [
        -9,
        20
      ],
      [
        -6,
        6
      ],
      [
        -4,
        -4
      ],
      [
        -8,
        26
      ]
    ],
    [
      [
        26146,
        63255
      ],
      [
        1,
        -305
      ]
    ],
    [
      [
        16298,
        57653
      ],
      [
        3,
        33
      ],
      [
        1,
        35
      ],
      [
        1,
        33
      ],
      [
        0,
        47
      ],
      [
        -1,
        25
      ],
      [
        -3,
        19
      ],
      [
        -2,
        9
      ],
      [
        -3,
        7
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        1
      ],
      [
        -4,
        9
      ],
      [
        -3,
        13
      ],
      [
        -1,
        2
      ],
      [
        -3,
        3
      ],
      [
        -6,
        3
      ],
      [
        -4,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -1
      ],
      [
        -5,
        11
      ],
      [
        -2,
        10
      ],
      [
        -6,
        9
      ],
      [
        -11,
        22
      ],
      [
        -3,
        3
      ],
      [
        -4,
        22
      ],
      [
        -7,
        26
      ],
      [
        0,
        7
      ],
      [
        2,
        28
      ],
      [
        3,
        19
      ],
      [
        3,
        38
      ],
      [
        1,
        23
      ],
      [
        1,
        16
      ],
      [
        -1,
        38
      ],
      [
        -1,
        12
      ],
      [
        -5,
        31
      ],
      [
        -3,
        14
      ],
      [
        -3,
        8
      ],
      [
        -11,
        -3
      ],
      [
        -1,
        2
      ],
      [
        -1,
        6
      ],
      [
        -4,
        8
      ],
      [
        -2,
        -1
      ],
      [
        -8,
        2
      ],
      [
        -6,
        27
      ],
      [
        -8,
        27
      ],
      [
        -1,
        3
      ],
      [
        -12,
        45
      ],
      [
        -7,
        52
      ],
      [
        -2,
        8
      ],
      [
        -3,
        7
      ],
      [
        -6,
        34
      ],
      [
        -6,
        9
      ],
      [
        -2,
        -3
      ],
      [
        -16,
        19
      ],
      [
        -6,
        11
      ],
      [
        -3,
        9
      ],
      [
        -2,
        18
      ],
      [
        -1,
        8
      ],
      [
        -3,
        6
      ],
      [
        -2,
        14
      ],
      [
        -1,
        45
      ],
      [
        -2,
        20
      ],
      [
        -2,
        16
      ],
      [
        -4,
        14
      ]
    ],
    [
      [
        22630,
        61377
      ],
      [
        61,
        0
      ]
    ],
    [
      [
        21825,
        62494
      ],
      [
        -2,
        -505
      ]
    ],
    [
      [
        26601,
        62979
      ],
      [
        23,
        -6
      ],
      [
        3,
        -1
      ],
      [
        -4,
        -193
      ]
    ],
    [
      [
        26546,
        62626
      ],
      [
        -35,
        9
      ]
    ],
    [
      [
        25327,
        68950
      ],
      [
        -3,
        0
      ],
      [
        3,
        -22
      ],
      [
        -1,
        -88
      ]
    ],
    [
      [
        23602,
        58132
      ],
      [
        -4,
        -7
      ],
      [
        -7,
        -5
      ],
      [
        -4,
        -13
      ],
      [
        2,
        -15
      ],
      [
        -4,
        -11
      ],
      [
        0,
        -15
      ],
      [
        4,
        -23
      ],
      [
        -4,
        -10
      ],
      [
        -6,
        10
      ],
      [
        -5,
        -6
      ],
      [
        -6,
        6
      ],
      [
        -4,
        18
      ],
      [
        -7,
        3
      ],
      [
        -6,
        -28
      ],
      [
        -9,
        -15
      ],
      [
        -6,
        5
      ],
      [
        -2,
        11
      ],
      [
        -1,
        16
      ],
      [
        -3,
        13
      ],
      [
        -10,
        23
      ],
      [
        -8,
        9
      ],
      [
        -6,
        -7
      ],
      [
        -5,
        -28
      ],
      [
        -5,
        -4
      ]
    ],
    [
      [
        26256,
        59028
      ],
      [
        3,
        -10
      ],
      [
        7,
        -12
      ],
      [
        11,
        -62
      ],
      [
        2,
        13
      ],
      [
        5,
        -5
      ],
      [
        4,
        -36
      ],
      [
        20,
        -76
      ],
      [
        11,
        -100
      ]
    ],
    [
      [
        26319,
        58740
      ],
      [
        -1,
        -5
      ],
      [
        -5,
        -10
      ],
      [
        -7,
        -43
      ],
      [
        -15,
        -39
      ]
    ],
    [
      [
        26291,
        58643
      ],
      [
        -5,
        0
      ],
      [
        -23,
        -54
      ],
      [
        -7,
        -6
      ],
      [
        -3,
        -14
      ]
    ],
    [
      [
        26159,
        58574
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        26154,
        58599
      ],
      [
        1,
        7
      ]
    ],
    [
      [
        25993,
        55935
      ],
      [
        15,
        50
      ],
      [
        0,
        17
      ]
    ],
    [
      [
        26136,
        56114
      ],
      [
        4,
        -84
      ],
      [
        0,
        -7
      ],
      [
        2,
        -45
      ],
      [
        1,
        -7
      ],
      [
        2,
        -55
      ]
    ],
    [
      [
        26869,
        66626
      ],
      [
        -6,
        0
      ],
      [
        -7,
        -16
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -12
      ],
      [
        -5,
        -4
      ],
      [
        -3,
        3
      ],
      [
        -1,
        -1
      ],
      [
        -5,
        -15
      ],
      [
        -1,
        -12
      ],
      [
        -1,
        -5
      ],
      [
        1,
        -12
      ],
      [
        2,
        -6
      ],
      [
        6,
        -9
      ],
      [
        0,
        -24
      ],
      [
        2,
        -13
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        5
      ],
      [
        -2,
        3
      ],
      [
        -7,
        0
      ],
      [
        -4,
        -3
      ],
      [
        -3,
        -9
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -8
      ],
      [
        -3,
        -8
      ],
      [
        0,
        -2
      ],
      [
        -4,
        -20
      ],
      [
        -2,
        -26
      ],
      [
        0,
        -34
      ],
      [
        3,
        -24
      ]
    ],
    [
      [
        26764,
        66351
      ],
      [
        0,
        34
      ],
      [
        -2,
        136
      ],
      [
        0,
        36
      ],
      [
        -1,
        103
      ],
      [
        -2,
        205
      ]
    ],
    [
      [
        26661,
        66856
      ],
      [
        0,
        -5
      ],
      [
        -33,
        -4
      ],
      [
        -33,
        -2
      ],
      [
        1,
        -60
      ],
      [
        0,
        -42
      ]
    ],
    [
      [
        25178,
        66404
      ],
      [
        3,
        0
      ],
      [
        16,
        1
      ]
    ],
    [
      [
        21315,
        72610
      ],
      [
        0,
        -174
      ],
      [
        -128,
        0
      ],
      [
        1,
        -377
      ],
      [
        -1,
        -25
      ]
    ],
    [
      [
        25068,
        60090
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -11
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -22
      ],
      [
        1,
        -7
      ],
      [
        1,
        -11
      ],
      [
        1,
        -4
      ],
      [
        1,
        -6
      ],
      [
        2,
        -4
      ],
      [
        6,
        -17
      ],
      [
        2,
        -3
      ]
    ],
    [
      [
        24979,
        60303
      ],
      [
        -2,
        8
      ],
      [
        -1,
        6
      ],
      [
        -2,
        6
      ],
      [
        -2,
        10
      ],
      [
        0,
        6
      ],
      [
        -1,
        4
      ],
      [
        0,
        7
      ],
      [
        1,
        4
      ],
      [
        0,
        10
      ],
      [
        1,
        8
      ],
      [
        1,
        4
      ],
      [
        0,
        2
      ],
      [
        3,
        7
      ],
      [
        1,
        4
      ],
      [
        1,
        7
      ],
      [
        0,
        3
      ],
      [
        1,
        1
      ]
    ],
    [
      [
        25162,
        53024
      ],
      [
        114,
        0
      ]
    ],
    [
      [
        25279,
        52718
      ],
      [
        -37,
        0
      ],
      [
        -32,
        -1
      ],
      [
        -48,
        0
      ],
      [
        -2,
        2
      ],
      [
        -12,
        -1
      ]
    ],
    [
      [
        29166,
        64287
      ],
      [
        2,
        1
      ],
      [
        3,
        16
      ],
      [
        15,
        35
      ],
      [
        0,
        8
      ],
      [
        2,
        -1
      ],
      [
        3,
        18
      ]
    ],
    [
      [
        24925,
        65750
      ],
      [
        -82,
        1
      ],
      [
        -3,
        -1
      ],
      [
        -8,
        0
      ],
      [
        -13,
        -1
      ],
      [
        -24,
        -1
      ]
    ],
    [
      [
        24795,
        65748
      ],
      [
        0,
        2
      ],
      [
        -1,
        3
      ],
      [
        -1,
        6
      ],
      [
        -1,
        3
      ],
      [
        -1,
        5
      ],
      [
        0,
        13
      ],
      [
        1,
        6
      ],
      [
        2,
        15
      ],
      [
        2,
        4
      ],
      [
        0,
        12
      ],
      [
        2,
        9
      ],
      [
        0,
        15
      ],
      [
        -1,
        7
      ],
      [
        -1,
        6
      ],
      [
        -1,
        3
      ],
      [
        0,
        9
      ],
      [
        -1,
        3
      ]
    ],
    [
      [
        24794,
        65869
      ],
      [
        -1,
        6
      ],
      [
        -2,
        3
      ],
      [
        0,
        26
      ],
      [
        -1,
        15
      ],
      [
        1,
        14
      ],
      [
        1,
        13
      ],
      [
        0,
        21
      ],
      [
        -2,
        6
      ],
      [
        -1,
        3
      ],
      [
        -4,
        1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        3
      ],
      [
        -1,
        3
      ],
      [
        -1,
        10
      ],
      [
        0,
        7
      ],
      [
        -1,
        4
      ],
      [
        0,
        4
      ],
      [
        -2,
        5
      ],
      [
        -2,
        4
      ],
      [
        -3,
        6
      ],
      [
        -5,
        7
      ],
      [
        -1,
        1
      ],
      [
        -4,
        3
      ],
      [
        -4,
        5
      ],
      [
        -4,
        10
      ],
      [
        -6,
        7
      ]
    ],
    [
      [
        26617,
        54020
      ],
      [
        19,
        -1
      ],
      [
        -1,
        -6
      ],
      [
        18,
        -1
      ]
    ],
    [
      [
        26606,
        53687
      ],
      [
        -6,
        5
      ],
      [
        1,
        16
      ],
      [
        -3,
        18
      ],
      [
        -1,
        -5
      ],
      [
        -5,
        11
      ],
      [
        -2,
        15
      ],
      [
        -3,
        3
      ],
      [
        -22,
        1
      ],
      [
        0,
        207
      ],
      [
        -1,
        3
      ]
    ],
    [
      [
        15813,
        60835
      ],
      [
        -1,
        -1
      ],
      [
        2,
        -33
      ],
      [
        3,
        -20
      ],
      [
        0,
        -11
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -3
      ],
      [
        0,
        -12
      ],
      [
        6,
        -14
      ],
      [
        3,
        -12
      ],
      [
        -1,
        -5
      ],
      [
        -4,
        4
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -10
      ],
      [
        5,
        -15
      ],
      [
        12,
        -2
      ],
      [
        1,
        -4
      ],
      [
        0,
        -4
      ],
      [
        2,
        -10
      ],
      [
        12,
        -3
      ],
      [
        3,
        -7
      ],
      [
        3,
        -10
      ],
      [
        8,
        -23
      ],
      [
        5,
        -1
      ],
      [
        0,
        -17
      ],
      [
        8,
        -22
      ],
      [
        1,
        -1
      ],
      [
        2,
        -2
      ],
      [
        2,
        2
      ],
      [
        3,
        6
      ],
      [
        4,
        -16
      ],
      [
        2,
        -27
      ],
      [
        2,
        -6
      ]
    ],
    [
      [
        15879,
        60343
      ],
      [
        0,
        -82
      ],
      [
        -25,
        0
      ],
      [
        0,
        -29
      ],
      [
        -21,
        -4
      ],
      [
        2,
        -46
      ],
      [
        6,
        -39
      ],
      [
        -1,
        -8
      ]
    ],
    [
      [
        15840,
        60135
      ],
      [
        -4,
        11
      ],
      [
        -2,
        2
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        0
      ],
      [
        -2,
        2
      ],
      [
        -1,
        4
      ],
      [
        1,
        12
      ],
      [
        -1,
        6
      ],
      [
        -1,
        9
      ],
      [
        -5,
        14
      ],
      [
        0,
        9
      ],
      [
        -2,
        11
      ],
      [
        -3,
        9
      ],
      [
        -3,
        2
      ],
      [
        -2,
        5
      ],
      [
        -2,
        10
      ],
      [
        -1,
        28
      ],
      [
        0,
        7
      ],
      [
        -2,
        8
      ],
      [
        -1,
        11
      ],
      [
        0,
        8
      ],
      [
        2,
        20
      ],
      [
        2,
        55
      ],
      [
        1,
        28
      ],
      [
        0,
        26
      ],
      [
        -2,
        18
      ],
      [
        -4,
        20
      ],
      [
        -6,
        51
      ],
      [
        -1,
        30
      ],
      [
        -1,
        22
      ],
      [
        -5,
        20
      ],
      [
        -1,
        3
      ],
      [
        -4,
        -7
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        3
      ],
      [
        -5,
        30
      ],
      [
        -1,
        19
      ],
      [
        1,
        9
      ],
      [
        0,
        8
      ],
      [
        -1,
        28
      ],
      [
        1,
        17
      ],
      [
        4,
        10
      ],
      [
        1,
        15
      ],
      [
        1,
        37
      ],
      [
        0,
        25
      ],
      [
        -1,
        24
      ],
      [
        -1,
        26
      ]
    ],
    [
      [
        27066,
        54897
      ],
      [
        16,
        17
      ],
      [
        28,
        32
      ]
    ],
    [
      [
        27110,
        54946
      ],
      [
        2,
        5
      ],
      [
        9,
        -14
      ],
      [
        2,
        -15
      ],
      [
        6,
        -26
      ],
      [
        5,
        -5
      ],
      [
        6,
        -30
      ],
      [
        7,
        -12
      ],
      [
        5,
        -23
      ],
      [
        2,
        3
      ],
      [
        7,
        -10
      ],
      [
        3,
        -15
      ],
      [
        2,
        6
      ],
      [
        3,
        -10
      ],
      [
        10,
        -20
      ],
      [
        0,
        2
      ],
      [
        2,
        4
      ],
      [
        2,
        1
      ],
      [
        9,
        -27
      ]
    ],
    [
      [
        27074,
        54503
      ],
      [
        4,
        20
      ],
      [
        7,
        102
      ],
      [
        4,
        49
      ],
      [
        -6,
        12
      ],
      [
        0,
        10
      ],
      [
        -7,
        21
      ],
      [
        -4,
        29
      ],
      [
        0,
        24
      ],
      [
        2,
        18
      ],
      [
        -17,
        29
      ]
    ],
    [
      [
        24794,
        65869
      ],
      [
        -110,
        0
      ],
      [
        -97,
        1
      ]
    ],
    [
      [
        22445,
        47502
      ],
      [
        -4,
        4
      ],
      [
        -4,
        -7
      ],
      [
        -3,
        0
      ],
      [
        -3,
        -11
      ],
      [
        -5,
        -8
      ],
      [
        -4,
        1
      ],
      [
        -2,
        4
      ],
      [
        -1,
        7
      ],
      [
        0,
        11
      ],
      [
        -1,
        9
      ],
      [
        -1,
        2
      ],
      [
        -4,
        1
      ],
      [
        -2,
        8
      ],
      [
        -1,
        8
      ],
      [
        1,
        6
      ],
      [
        -1,
        6
      ],
      [
        -5,
        11
      ],
      [
        -2,
        0
      ],
      [
        -2,
        5
      ],
      [
        -1,
        16
      ],
      [
        -1,
        5
      ],
      [
        -1,
        4
      ],
      [
        -7,
        2
      ],
      [
        -3,
        6
      ],
      [
        -2,
        20
      ],
      [
        0,
        13
      ],
      [
        -3,
        11
      ],
      [
        -5,
        1
      ],
      [
        -2,
        -8
      ],
      [
        -3,
        -6
      ],
      [
        -1,
        1
      ],
      [
        -2,
        7
      ],
      [
        -2,
        1
      ],
      [
        -8,
        -10
      ],
      [
        -4,
        7
      ],
      [
        -5,
        21
      ],
      [
        -1,
        0
      ],
      [
        -3,
        -6
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        5
      ],
      [
        -2,
        16
      ],
      [
        -2,
        5
      ],
      [
        -7,
        -3
      ],
      [
        -5,
        0
      ],
      [
        -2,
        4
      ],
      [
        -2,
        11
      ],
      [
        -2,
        4
      ],
      [
        -2,
        1
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -9
      ],
      [
        -3,
        -6
      ],
      [
        -5,
        -1
      ],
      [
        -1,
        3
      ],
      [
        -1,
        11
      ],
      [
        -6,
        21
      ],
      [
        -1,
        9
      ],
      [
        3,
        9
      ],
      [
        3,
        41
      ],
      [
        -4,
        27
      ],
      [
        -6,
        29
      ],
      [
        -4,
        3
      ],
      [
        -7,
        10
      ],
      [
        -1,
        5
      ],
      [
        0,
        11
      ],
      [
        1,
        12
      ],
      [
        -1,
        13
      ]
    ],
    [
      [
        29155,
        64767
      ],
      [
        4,
        -11
      ],
      [
        -4,
        -40
      ],
      [
        1,
        -9
      ],
      [
        5,
        13
      ],
      [
        9,
        10
      ],
      [
        6,
        -20
      ],
      [
        -2,
        -20
      ],
      [
        3,
        9
      ],
      [
        5,
        -4
      ],
      [
        4,
        -14
      ],
      [
        8,
        1
      ],
      [
        3,
        -11
      ],
      [
        6,
        -3
      ],
      [
        8,
        -2
      ],
      [
        0,
        4
      ],
      [
        1,
        -27
      ],
      [
        5,
        -7
      ],
      [
        -1,
        -43
      ],
      [
        0,
        -23
      ],
      [
        4,
        -10
      ],
      [
        -1,
        -12
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        21834,
        64318
      ],
      [
        155,
        0
      ]
    ],
    [
      [
        22343,
        55304
      ],
      [
        105,
        -3
      ]
    ],
    [
      [
        26541,
        65234
      ],
      [
        -64,
        -1
      ],
      [
        -64,
        -1
      ]
    ],
    [
      [
        24125,
        66887
      ],
      [
        0,
        356
      ]
    ],
    [
      [
        31521,
        37981
      ],
      [
        0,
        -9
      ],
      [
        6,
        -10
      ]
    ],
    [
      [
        31548,
        37871
      ],
      [
        -3,
        -6
      ],
      [
        -10,
        -6
      ],
      [
        -5,
        -3
      ],
      [
        -2,
        2
      ],
      [
        0,
        2
      ],
      [
        -3,
        9
      ],
      [
        -4,
        2
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -1
      ]
    ],
    [
      [
        29880,
        69333
      ],
      [
        37,
        3
      ],
      [
        21,
        0
      ],
      [
        23,
        2
      ],
      [
        13,
        0
      ],
      [
        17,
        1
      ]
    ],
    [
      [
        29917,
        68632
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -4,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -7
      ],
      [
        0,
        -4
      ],
      [
        1,
        -5
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -6
      ],
      [
        1,
        -6
      ],
      [
        0,
        -4
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -2
      ]
    ],
    [
      [
        29897,
        68564
      ],
      [
        -26,
        108
      ],
      [
        8,
        16
      ],
      [
        13,
        48
      ],
      [
        -15,
        60
      ],
      [
        3,
        12
      ],
      [
        16,
        62
      ],
      [
        -19,
        42
      ],
      [
        20,
        81
      ],
      [
        -28,
        61
      ]
    ],
    [
      [
        25733,
        57673
      ],
      [
        40,
        0
      ],
      [
        11,
        -1
      ],
      [
        13,
        0
      ],
      [
        7,
        -1
      ],
      [
        17,
        0
      ],
      [
        10,
        1
      ],
      [
        10,
        1
      ],
      [
        22,
        -1
      ]
    ],
    [
      [
        25865,
        57672
      ],
      [
        1,
        -19
      ],
      [
        5,
        -7
      ],
      [
        0,
        -13
      ],
      [
        8,
        -14
      ],
      [
        1,
        -9
      ],
      [
        0,
        -13
      ],
      [
        -4,
        -3
      ],
      [
        -3,
        17
      ],
      [
        -4,
        7
      ],
      [
        -4,
        -12
      ],
      [
        -4,
        3
      ],
      [
        4,
        -26
      ],
      [
        -5,
        -15
      ],
      [
        -6,
        -33
      ],
      [
        1,
        -18
      ],
      [
        5,
        -31
      ],
      [
        -4,
        -17
      ],
      [
        1,
        -63
      ],
      [
        -1,
        -21
      ],
      [
        -4,
        -11
      ],
      [
        -1,
        -119
      ],
      [
        2,
        -4
      ],
      [
        8,
        -23
      ],
      [
        -2,
        -3
      ],
      [
        1,
        -9
      ]
    ],
    [
      [
        16666,
        61797
      ],
      [
        14,
        -41
      ],
      [
        8,
        -22
      ],
      [
        4,
        -14
      ],
      [
        22,
        -63
      ]
    ],
    [
      [
        17564,
        54910
      ],
      [
        -3,
        -1
      ],
      [
        -3,
        -1
      ],
      [
        -24,
        -7
      ],
      [
        -91,
        -31
      ],
      [
        -24,
        -9
      ],
      [
        -63,
        -22
      ],
      [
        -2,
        0
      ],
      [
        -19,
        -8
      ],
      [
        -5,
        -1
      ],
      [
        -23,
        -8
      ],
      [
        -10,
        -3
      ],
      [
        -15,
        -6
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        25
      ],
      [
        -2,
        23
      ],
      [
        1,
        12
      ],
      [
        0,
        13
      ],
      [
        -1,
        25
      ],
      [
        -1,
        10
      ],
      [
        -6,
        39
      ],
      [
        -2,
        13
      ],
      [
        -4,
        12
      ],
      [
        -3,
        7
      ],
      [
        -1,
        1
      ],
      [
        -5,
        -1
      ],
      [
        -3,
        -6
      ],
      [
        -3,
        -13
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        36
      ],
      [
        -1,
        30
      ],
      [
        0,
        23
      ],
      [
        1,
        9
      ],
      [
        0,
        39
      ],
      [
        -2,
        19
      ],
      [
        -6,
        22
      ],
      [
        0,
        24
      ],
      [
        2,
        10
      ],
      [
        3,
        -3
      ],
      [
        1,
        5
      ],
      [
        1,
        8
      ],
      [
        1,
        14
      ],
      [
        1,
        3
      ],
      [
        -1,
        30
      ],
      [
        -2,
        36
      ],
      [
        -5,
        82
      ],
      [
        -1,
        13
      ],
      [
        -3,
        26
      ],
      [
        -5,
        46
      ],
      [
        -1,
        22
      ],
      [
        -4,
        33
      ],
      [
        -9,
        54
      ],
      [
        -8,
        40
      ],
      [
        -3,
        13
      ],
      [
        -13,
        64
      ],
      [
        -6,
        32
      ],
      [
        -10,
        44
      ],
      [
        -12,
        37
      ],
      [
        -7,
        15
      ],
      [
        -6,
        9
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        21114,
        65834
      ],
      [
        0,
        -302
      ],
      [
        -2,
        0
      ],
      [
        0,
        -51
      ]
    ],
    [
      [
        21112,
        65481
      ],
      [
        -190,
        -2
      ]
    ],
    [
      [
        25327,
        58175
      ],
      [
        7,
        -13
      ],
      [
        4,
        -20
      ],
      [
        1,
        -18
      ],
      [
        9,
        15
      ],
      [
        11,
        -10
      ],
      [
        6,
        8
      ],
      [
        11,
        31
      ],
      [
        11,
        -29
      ]
    ],
    [
      [
        25387,
        58139
      ],
      [
        0,
        -26
      ],
      [
        6,
        -22
      ],
      [
        -3,
        -19
      ],
      [
        -1,
        -41
      ],
      [
        6,
        3
      ],
      [
        4,
        -8
      ],
      [
        -1,
        -337
      ]
    ],
    [
      [
        25293,
        57677
      ],
      [
        -5,
        0
      ]
    ],
    [
      [
        23711,
        55216
      ],
      [
        0,
        -219
      ]
    ],
    [
      [
        26634,
        57674
      ],
      [
        1,
        -54
      ],
      [
        -15,
        -9
      ],
      [
        0,
        -30
      ],
      [
        -7,
        -4
      ],
      [
        -1,
        -18
      ],
      [
        -4,
        -3
      ],
      [
        -4,
        -15
      ],
      [
        -1,
        -35
      ],
      [
        3,
        -30
      ]
    ],
    [
      [
        26606,
        57476
      ],
      [
        -5,
        -19
      ],
      [
        -4,
        -7
      ]
    ],
    [
      [
        26335,
        62425
      ],
      [
        0,
        -14
      ],
      [
        2,
        -51
      ],
      [
        1,
        -47
      ],
      [
        0,
        -7
      ],
      [
        1,
        -17
      ],
      [
        3,
        -91
      ],
      [
        -3,
        -53
      ],
      [
        -2,
        -37
      ]
    ],
    [
      [
        26337,
        62108
      ],
      [
        -8,
        -5
      ],
      [
        -4,
        -24
      ]
    ],
    [
      [
        26264,
        62374
      ],
      [
        -1,
        4
      ],
      [
        -2,
        8
      ],
      [
        -2,
        10
      ],
      [
        0,
        9
      ],
      [
        1,
        6
      ],
      [
        1,
        5
      ],
      [
        5,
        9
      ],
      [
        3,
        5
      ],
      [
        3,
        11
      ],
      [
        3,
        8
      ],
      [
        2,
        8
      ],
      [
        1,
        3
      ],
      [
        2,
        1
      ]
    ],
    [
      [
        25875,
        66319
      ],
      [
        142,
        1
      ]
    ],
    [
      [
        25889,
        65914
      ],
      [
        0,
        200
      ],
      [
        -39,
        0
      ]
    ],
    [
      [
        25850,
        66114
      ],
      [
        2,
        13
      ],
      [
        10,
        65
      ],
      [
        7,
        56
      ],
      [
        3,
        42
      ],
      [
        0,
        8
      ],
      [
        2,
        14
      ],
      [
        1,
        7
      ]
    ],
    [
      [
        21856,
        52198
      ],
      [
        0,
        -774
      ]
    ],
    [
      [
        21829,
        50979
      ],
      [
        0,
        6
      ],
      [
        -7,
        18
      ],
      [
        -3,
        -1
      ],
      [
        -2,
        2
      ],
      [
        -2,
        10
      ],
      [
        -3,
        5
      ],
      [
        -2,
        0
      ],
      [
        -3,
        4
      ],
      [
        -1,
        3
      ],
      [
        -1,
        20
      ],
      [
        -1,
        10
      ],
      [
        -5,
        5
      ],
      [
        -6,
        17
      ],
      [
        -4,
        8
      ],
      [
        -1,
        10
      ],
      [
        -1,
        6
      ],
      [
        -5,
        0
      ],
      [
        -2,
        5
      ],
      [
        0,
        4
      ],
      [
        -6,
        10
      ],
      [
        -3,
        2
      ],
      [
        -2,
        4
      ],
      [
        -3,
        29
      ],
      [
        -4,
        15
      ],
      [
        0,
        10
      ],
      [
        -2,
        17
      ],
      [
        -4,
        13
      ],
      [
        0,
        21
      ],
      [
        -8,
        12
      ],
      [
        -5,
        2
      ],
      [
        -3,
        -3
      ],
      [
        -4,
        12
      ],
      [
        -2,
        -6
      ],
      [
        -2,
        0
      ],
      [
        -2,
        4
      ],
      [
        -5,
        32
      ],
      [
        -1,
        12
      ],
      [
        -5,
        7
      ],
      [
        -10,
        2
      ],
      [
        -2,
        3
      ],
      [
        -6,
        -5
      ],
      [
        -1,
        11
      ],
      [
        0,
        8
      ],
      [
        4,
        38
      ],
      [
        -2,
        40
      ],
      [
        1,
        17
      ],
      [
        -1,
        8
      ],
      [
        -5,
        5
      ],
      [
        -3,
        -17
      ],
      [
        1,
        -26
      ],
      [
        -4,
        -24
      ],
      [
        -4,
        7
      ],
      [
        -2,
        20
      ],
      [
        2,
        53
      ],
      [
        -1,
        9
      ],
      [
        -2,
        8
      ],
      [
        -2,
        3
      ],
      [
        -7,
        -4
      ],
      [
        -3,
        4
      ],
      [
        -2,
        7
      ],
      [
        -3,
        40
      ],
      [
        -5,
        18
      ],
      [
        -1,
        4
      ],
      [
        1,
        11
      ],
      [
        0,
        8
      ],
      [
        -1,
        5
      ],
      [
        -3,
        4
      ],
      [
        -1,
        6
      ],
      [
        0,
        12
      ],
      [
        -3,
        1
      ],
      [
        -5,
        -5
      ],
      [
        -1,
        2
      ],
      [
        -2,
        5
      ],
      [
        0,
        14
      ],
      [
        -4,
        10
      ],
      [
        -2,
        1
      ],
      [
        -8,
        -19
      ],
      [
        -5,
        -6
      ],
      [
        -3,
        6
      ],
      [
        -1,
        21
      ],
      [
        -3,
        17
      ],
      [
        -4,
        -3
      ],
      [
        -4,
        -24
      ],
      [
        -2,
        -3
      ],
      [
        -6,
        3
      ],
      [
        -6,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -12
      ],
      [
        -3,
        -5
      ],
      [
        -1,
        5
      ],
      [
        -1,
        8
      ],
      [
        -2,
        7
      ],
      [
        -8,
        0
      ],
      [
        -5,
        -10
      ],
      [
        -2,
        6
      ],
      [
        -5,
        4
      ],
      [
        -6,
        7
      ],
      [
        -2,
        6
      ]
    ],
    [
      [
        26799,
        55015
      ],
      [
        -23,
        -41
      ],
      [
        -52,
        -104
      ]
    ],
    [
      [
        26526,
        54013
      ],
      [
        -8,
        -16
      ],
      [
        -3,
        -17
      ],
      [
        0,
        -19
      ],
      [
        -4,
        4
      ],
      [
        -5,
        -6
      ],
      [
        0,
        -11
      ],
      [
        5,
        -10
      ],
      [
        1,
        -21
      ],
      [
        -4,
        -13
      ],
      [
        -1,
        -22
      ],
      [
        -7,
        -22
      ],
      [
        3,
        -28
      ],
      [
        0,
        -8
      ],
      [
        2,
        -26
      ],
      [
        -1,
        -15
      ]
    ],
    [
      [
        26426,
        53750
      ],
      [
        0,
        80
      ],
      [
        -2,
        9
      ],
      [
        2,
        0
      ],
      [
        1,
        60
      ],
      [
        2,
        48
      ],
      [
        7,
        0
      ],
      [
        -1,
        25
      ],
      [
        1,
        18
      ],
      [
        -5,
        16
      ],
      [
        1,
        10
      ],
      [
        -5,
        17
      ],
      [
        -13,
        10
      ]
    ],
    [
      [
        27001,
        54561
      ],
      [
        58,
        -46
      ]
    ],
    [
      [
        30373,
        68726
      ],
      [
        24,
        -2
      ],
      [
        2,
        26
      ],
      [
        -10,
        25
      ],
      [
        9,
        49
      ],
      [
        0,
        20
      ],
      [
        24,
        -16
      ],
      [
        2,
        9
      ],
      [
        5,
        25
      ],
      [
        0,
        8
      ]
    ],
    [
      [
        30547,
        68558
      ],
      [
        -5,
        -73
      ],
      [
        -1,
        -5
      ],
      [
        -6,
        -17
      ],
      [
        -28,
        21
      ],
      [
        -1,
        -5
      ],
      [
        -4,
        -55
      ],
      [
        3,
        -119
      ],
      [
        -3,
        -2
      ],
      [
        -25,
        18
      ]
    ],
    [
      [
        23863,
        67576
      ],
      [
        0,
        -284
      ]
    ],
    [
      [
        24018,
        54362
      ],
      [
        2,
        -29
      ],
      [
        5,
        -22
      ],
      [
        3,
        -26
      ],
      [
        -2,
        -5
      ],
      [
        4,
        -26
      ],
      [
        -1,
        -12
      ],
      [
        3,
        -16
      ],
      [
        0,
        -26
      ],
      [
        -3,
        -24
      ],
      [
        5,
        -8
      ],
      [
        -1,
        -28
      ],
      [
        4,
        -13
      ],
      [
        -4,
        -8
      ],
      [
        -2,
        -25
      ],
      [
        0,
        -19
      ],
      [
        -2,
        -8
      ],
      [
        -2,
        -29
      ],
      [
        3,
        -12
      ],
      [
        -3,
        -10
      ],
      [
        -11,
        8
      ],
      [
        -1,
        -9
      ],
      [
        3,
        -23
      ],
      [
        -2,
        -13
      ],
      [
        1,
        -4
      ],
      [
        -3,
        -37
      ],
      [
        -4,
        -2
      ],
      [
        0,
        -59
      ],
      [
        -2,
        -21
      ],
      [
        0,
        -4
      ],
      [
        1,
        -1
      ]
    ],
    [
      [
        31360,
        38458
      ],
      [
        1,
        -1
      ],
      [
        5,
        1
      ],
      [
        0,
        1
      ],
      [
        1,
        3
      ],
      [
        0,
        2
      ],
      [
        1,
        0
      ],
      [
        7,
        -11
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        31375,
        38454
      ],
      [
        2,
        -30
      ],
      [
        -3,
        -23
      ],
      [
        4,
        -5
      ],
      [
        -6,
        -16
      ],
      [
        0,
        -15
      ]
    ],
    [
      [
        21654,
        65938
      ],
      [
        0,
        -406
      ]
    ],
    [
      [
        24440,
        68141
      ],
      [
        0,
        4
      ],
      [
        -1,
        7
      ],
      [
        -1,
        3
      ],
      [
        -1,
        4
      ],
      [
        -1,
        2
      ],
      [
        -5,
        5
      ],
      [
        -2,
        3
      ],
      [
        -1,
        1
      ],
      [
        -3,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -4,
        5
      ],
      [
        -1,
        6
      ],
      [
        -2,
        2
      ],
      [
        -5,
        3
      ],
      [
        -2,
        0
      ],
      [
        -4,
        1
      ],
      [
        -3,
        3
      ]
    ],
    [
      [
        15747,
        61952
      ],
      [
        45,
        43
      ],
      [
        14,
        74
      ],
      [
        3,
        5
      ],
      [
        -2,
        15
      ],
      [
        4,
        21
      ],
      [
        5,
        -2
      ],
      [
        2,
        18
      ],
      [
        -3,
        19
      ],
      [
        -6,
        25
      ],
      [
        3,
        11
      ]
    ],
    [
      [
        15812,
        62181
      ],
      [
        2,
        -14
      ],
      [
        10,
        -20
      ],
      [
        7,
        12
      ],
      [
        3,
        -7
      ],
      [
        7,
        0
      ],
      [
        4,
        -35
      ],
      [
        4,
        -23
      ],
      [
        3,
        -40
      ],
      [
        7,
        -39
      ],
      [
        0,
        -26
      ],
      [
        5,
        -5
      ],
      [
        1,
        -21
      ],
      [
        6,
        -24
      ],
      [
        4,
        -2
      ],
      [
        2,
        -22
      ],
      [
        -2,
        -20
      ],
      [
        4,
        7
      ],
      [
        7,
        -48
      ],
      [
        5,
        -69
      ],
      [
        2,
        -13
      ]
    ],
    [
      [
        23859,
        69806
      ],
      [
        0,
        -135
      ],
      [
        -1,
        -62
      ]
    ],
    [
      [
        23858,
        69609
      ],
      [
        -2,
        1
      ]
    ],
    [
      [
        23709,
        69815
      ],
      [
        -1,
        14
      ],
      [
        -7,
        4
      ],
      [
        -7,
        21
      ],
      [
        1,
        12
      ],
      [
        -2,
        7
      ],
      [
        -10,
        24
      ],
      [
        1,
        27
      ],
      [
        -3,
        11
      ],
      [
        1,
        27
      ],
      [
        -1,
        12
      ]
    ],
    [
      [
        20380,
        53476
      ],
      [
        -2,
        7
      ],
      [
        -21,
        7
      ],
      [
        -7,
        27
      ],
      [
        -2,
        2
      ],
      [
        -6,
        2
      ],
      [
        -7,
        16
      ],
      [
        -5,
        20
      ],
      [
        -8,
        11
      ],
      [
        -4,
        17
      ],
      [
        -1,
        24
      ],
      [
        -4,
        15
      ],
      [
        -2,
        32
      ],
      [
        -3,
        8
      ],
      [
        -7,
        16
      ],
      [
        -2,
        26
      ],
      [
        -4,
        42
      ],
      [
        -9,
        51
      ],
      [
        -1,
        8
      ],
      [
        -2,
        24
      ],
      [
        -1,
        6
      ],
      [
        -6,
        16
      ],
      [
        -1,
        5
      ],
      [
        -1,
        16
      ],
      [
        -1,
        4
      ],
      [
        -10,
        23
      ],
      [
        -4,
        3
      ],
      [
        -5,
        12
      ],
      [
        -5,
        -6
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        -3,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -5,
        15
      ],
      [
        -5,
        18
      ],
      [
        -1,
        6
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        25658,
        60081
      ],
      [
        21,
        15
      ],
      [
        10,
        -5
      ]
    ],
    [
      [
        25781,
        59874
      ],
      [
        -6,
        0
      ],
      [
        -6,
        -8
      ],
      [
        -10,
        -37
      ],
      [
        -4,
        -40
      ],
      [
        -3,
        -17
      ],
      [
        -7,
        -46
      ],
      [
        -3,
        -33
      ],
      [
        -3,
        -91
      ]
    ],
    [
      [
        26853,
        62581
      ],
      [
        32,
        -7
      ],
      [
        -1,
        -15
      ],
      [
        32,
        -10
      ],
      [
        -1,
        -42
      ],
      [
        33,
        -8
      ],
      [
        -3,
        -120
      ]
    ],
    [
      [
        27221,
        53045
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -5
      ],
      [
        -3,
        -12
      ],
      [
        -6,
        -12
      ],
      [
        -1,
        -9
      ],
      [
        2,
        -9
      ],
      [
        3,
        -5
      ],
      [
        1,
        5
      ],
      [
        1,
        1
      ],
      [
        4,
        -6
      ],
      [
        2,
        -10
      ],
      [
        6,
        0
      ],
      [
        1,
        20
      ],
      [
        2,
        4
      ],
      [
        2,
        0
      ],
      [
        1,
        -23
      ],
      [
        0,
        -58
      ],
      [
        -7,
        -83
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -12
      ],
      [
        -2,
        -13
      ],
      [
        -2,
        -22
      ],
      [
        -2,
        -25
      ],
      [
        0,
        -32
      ],
      [
        3,
        -31
      ],
      [
        2,
        -7
      ]
    ],
    [
      [
        27084,
        53082
      ],
      [
        -1,
        15
      ],
      [
        3,
        1
      ],
      [
        0,
        20
      ],
      [
        3,
        19
      ],
      [
        8,
        6
      ],
      [
        13,
        -3
      ],
      [
        6,
        45
      ],
      [
        5,
        17
      ],
      [
        4,
        1
      ],
      [
        6,
        20
      ]
    ],
    [
      [
        99917,
        77451
      ],
      [
        1,
        2
      ],
      [
        11,
        -4
      ],
      [
        5,
        12
      ],
      [
        7,
        23
      ],
      [
        11,
        13
      ],
      [
        8,
        4
      ],
      [
        7,
        -3
      ],
      [
        31,
        -61
      ],
      [
        1,
        -10
      ],
      [
        -3,
        -17
      ],
      [
        -3,
        -13
      ],
      [
        -4,
        -28
      ],
      [
        -24,
        -42
      ],
      [
        -5,
        -5
      ],
      [
        -7,
        0
      ],
      [
        -25,
        29
      ],
      [
        -11,
        29
      ],
      [
        -2,
        19
      ],
      [
        2,
        52
      ]
    ],
    [
      [
        99678,
        77049
      ],
      [
        5,
        24
      ],
      [
        6,
        5
      ],
      [
        3,
        -3
      ],
      [
        2,
        -11
      ],
      [
        2,
        -7
      ],
      [
        13,
        -13
      ],
      [
        13,
        1
      ],
      [
        6,
        2
      ],
      [
        16,
        -14
      ],
      [
        11,
        -10
      ],
      [
        5,
        -11
      ],
      [
        -1,
        -12
      ],
      [
        0,
        -8
      ],
      [
        1,
        -2
      ],
      [
        23,
        -40
      ],
      [
        21,
        -62
      ],
      [
        6,
        -16
      ],
      [
        12,
        -18
      ],
      [
        6,
        -6
      ],
      [
        4,
        0
      ],
      [
        3,
        -2
      ],
      [
        8,
        -28
      ],
      [
        2,
        -17
      ],
      [
        1,
        -12
      ],
      [
        2,
        -5
      ],
      [
        8,
        -4
      ],
      [
        19,
        -1
      ],
      [
        15,
        -1
      ],
      [
        4,
        -4
      ],
      [
        17,
        -29
      ],
      [
        1,
        -5
      ],
      [
        -4,
        -8
      ],
      [
        -15,
        -6
      ],
      [
        -2,
        2
      ],
      [
        -2,
        3
      ],
      [
        -5,
        9
      ],
      [
        -29,
        -16
      ],
      [
        -11,
        22
      ],
      [
        -1,
        12
      ],
      [
        -3,
        7
      ],
      [
        -31,
        55
      ],
      [
        -10,
        17
      ],
      [
        -7,
        27
      ],
      [
        -6,
        22
      ],
      [
        -13,
        40
      ],
      [
        -4,
        12
      ],
      [
        -30,
        43
      ],
      [
        -4,
        2
      ],
      [
        -10,
        -6
      ],
      [
        -3,
        -4
      ],
      [
        -5,
        5
      ],
      [
        -17,
        20
      ],
      [
        -20,
        36
      ],
      [
        -1,
        2
      ],
      [
        -1,
        13
      ]
    ],
    [
      [
        99628,
        77446
      ],
      [
        5,
        11
      ],
      [
        4,
        0
      ],
      [
        20,
        -16
      ],
      [
        5,
        -7
      ],
      [
        6,
        -18
      ],
      [
        0,
        -8
      ],
      [
        -6,
        -23
      ],
      [
        -8,
        -26
      ],
      [
        -6,
        -4
      ],
      [
        -4,
        0
      ],
      [
        -5,
        12
      ],
      [
        -5,
        25
      ],
      [
        -4,
        33
      ],
      [
        -2,
        21
      ]
    ],
    [
      [
        99570,
        77271
      ],
      [
        19,
        -7
      ],
      [
        1,
        -2
      ],
      [
        2,
        -5
      ],
      [
        5,
        -10
      ],
      [
        10,
        -39
      ],
      [
        3,
        -11
      ],
      [
        -8,
        5
      ],
      [
        -4,
        3
      ],
      [
        -1,
        -1
      ],
      [
        -5,
        2
      ],
      [
        -3,
        4
      ],
      [
        -1,
        2
      ],
      [
        -16,
        46
      ],
      [
        -2,
        13
      ]
    ],
    [
      [
        99530,
        77510
      ],
      [
        3,
        15
      ],
      [
        3,
        3
      ],
      [
        1,
        4
      ],
      [
        6,
        -1
      ],
      [
        9,
        -17
      ],
      [
        2,
        -4
      ],
      [
        3,
        -34
      ],
      [
        -5,
        -14
      ],
      [
        -12,
        -6
      ],
      [
        -7,
        13
      ],
      [
        -1,
        7
      ],
      [
        -2,
        34
      ]
    ],
    [
      [
        99282,
        77351
      ],
      [
        8,
        15
      ],
      [
        11,
        12
      ],
      [
        5,
        0
      ],
      [
        14,
        41
      ],
      [
        1,
        9
      ],
      [
        19,
        20
      ],
      [
        20,
        6
      ],
      [
        3,
        10
      ],
      [
        2,
        18
      ],
      [
        1,
        8
      ],
      [
        0,
        27
      ],
      [
        11,
        72
      ],
      [
        5,
        24
      ],
      [
        11,
        18
      ],
      [
        16,
        -28
      ],
      [
        4,
        -24
      ],
      [
        -2,
        -19
      ],
      [
        -2,
        -8
      ],
      [
        -2,
        1
      ],
      [
        -3,
        -2
      ],
      [
        -3,
        -4
      ],
      [
        -6,
        -42
      ],
      [
        -2,
        -15
      ],
      [
        -7,
        -13
      ],
      [
        -2,
        -3
      ],
      [
        -9,
        -27
      ],
      [
        -2,
        -10
      ],
      [
        2,
        -13
      ],
      [
        1,
        -4
      ],
      [
        8,
        -5
      ],
      [
        2,
        -1
      ],
      [
        8,
        5
      ],
      [
        1,
        -5
      ],
      [
        0,
        -16
      ],
      [
        -1,
        -14
      ],
      [
        -2,
        -3
      ],
      [
        -11,
        -7
      ],
      [
        -21,
        8
      ],
      [
        -21,
        9
      ],
      [
        -10,
        -13
      ],
      [
        -7,
        -18
      ],
      [
        -6,
        -36
      ],
      [
        0,
        -3
      ],
      [
        2,
        -5
      ],
      [
        0,
        -26
      ],
      [
        -3,
        -18
      ],
      [
        -3,
        -3
      ],
      [
        -3,
        4
      ],
      [
        -2,
        9
      ],
      [
        0,
        10
      ],
      [
        -6,
        13
      ],
      [
        -10,
        19
      ],
      [
        -7,
        4
      ],
      [
        -2,
        4
      ],
      [
        -1,
        17
      ],
      [
        1,
        2
      ]
    ],
    [
      [
        98911,
        77903
      ],
      [
        9,
        6
      ],
      [
        13,
        -9
      ],
      [
        4,
        -10
      ],
      [
        -6,
        -27
      ],
      [
        -9,
        -2
      ],
      [
        -3,
        2
      ],
      [
        -3,
        9
      ],
      [
        -5,
        20
      ],
      [
        0,
        11
      ]
    ],
    [
      [
        98408,
        78327
      ],
      [
        7,
        8
      ],
      [
        1,
        2
      ],
      [
        10,
        -11
      ],
      [
        4,
        -7
      ],
      [
        2,
        -15
      ],
      [
        1,
        -9
      ],
      [
        0,
        -2
      ],
      [
        -13,
        3
      ],
      [
        -11,
        12
      ],
      [
        -1,
        14
      ],
      [
        0,
        5
      ]
    ],
    [
      [
        98376,
        78346
      ],
      [
        8,
        -3
      ],
      [
        6,
        -5
      ],
      [
        5,
        -17
      ],
      [
        -5,
        -12
      ],
      [
        -9,
        11
      ],
      [
        -3,
        11
      ],
      [
        -2,
        11
      ],
      [
        0,
        4
      ]
    ],
    [
      [
        98352,
        78374
      ],
      [
        4,
        0
      ],
      [
        5,
        -4
      ],
      [
        9,
        -16
      ],
      [
        2,
        -7
      ],
      [
        -2,
        -6
      ],
      [
        0,
        4
      ],
      [
        -2,
        2
      ],
      [
        -8,
        -2
      ],
      [
        -6,
        13
      ],
      [
        -3,
        14
      ],
      [
        1,
        2
      ]
    ],
    [
      [
        98210,
        77943
      ],
      [
        6,
        31
      ],
      [
        17,
        25
      ],
      [
        2,
        2
      ],
      [
        6,
        -12
      ],
      [
        2,
        -3
      ],
      [
        7,
        -1
      ],
      [
        7,
        8
      ],
      [
        1,
        2
      ],
      [
        6,
        20
      ],
      [
        0,
        3
      ],
      [
        -2,
        7
      ],
      [
        3,
        5
      ],
      [
        9,
        -4
      ],
      [
        10,
        36
      ],
      [
        16,
        6
      ],
      [
        16,
        0
      ],
      [
        9,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        -5,
        -12
      ],
      [
        -5,
        -3
      ],
      [
        -8,
        -19
      ],
      [
        -4,
        -21
      ],
      [
        -1,
        -16
      ],
      [
        1,
        -8
      ],
      [
        2,
        -4
      ],
      [
        1,
        -4
      ],
      [
        2,
        -13
      ],
      [
        2,
        -27
      ],
      [
        2,
        -48
      ],
      [
        -21,
        0
      ],
      [
        -2,
        2
      ],
      [
        -1,
        2
      ],
      [
        -9,
        22
      ],
      [
        -4,
        16
      ],
      [
        -1,
        10
      ],
      [
        -9,
        0
      ],
      [
        -4,
        -10
      ],
      [
        -9,
        -8
      ],
      [
        -8,
        -2
      ],
      [
        -5,
        1
      ],
      [
        -3,
        6
      ],
      [
        -16,
        15
      ],
      [
        -3,
        2
      ],
      [
        -8,
        0
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        97960,
        78551
      ],
      [
        47,
        86
      ],
      [
        4,
        4
      ],
      [
        29,
        7
      ],
      [
        100,
        -20
      ],
      [
        7,
        -7
      ],
      [
        8,
        -16
      ],
      [
        4,
        -15
      ],
      [
        10,
        -25
      ],
      [
        7,
        5
      ],
      [
        4,
        1
      ],
      [
        13,
        -21
      ],
      [
        35,
        -94
      ],
      [
        2,
        -18
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        -1
      ],
      [
        -31,
        -5
      ],
      [
        -5,
        5
      ],
      [
        -16,
        33
      ],
      [
        -1,
        0
      ],
      [
        -5,
        -8
      ],
      [
        -5,
        -21
      ],
      [
        -4,
        -31
      ],
      [
        -2,
        -11
      ],
      [
        -7,
        -10
      ],
      [
        -2,
        -3
      ],
      [
        -4,
        1
      ],
      [
        -34,
        14
      ],
      [
        -26,
        -41
      ],
      [
        -27,
        32
      ],
      [
        -12,
        40
      ],
      [
        1,
        29
      ],
      [
        -1,
        17
      ],
      [
        -3,
        17
      ],
      [
        -32,
        56
      ],
      [
        -15,
        -5
      ],
      [
        -10,
        -8
      ],
      [
        -10,
        -11
      ],
      [
        -12,
        7
      ],
      [
        -3,
        19
      ]
    ],
    [
      [
        3147,
        79003
      ],
      [
        17,
        23
      ],
      [
        22,
        53
      ],
      [
        5,
        8
      ],
      [
        11,
        5
      ],
      [
        9,
        -8
      ],
      [
        37,
        40
      ],
      [
        4,
        14
      ],
      [
        0,
        7
      ],
      [
        5,
        6
      ],
      [
        18,
        -4
      ],
      [
        5,
        -8
      ],
      [
        5,
        -9
      ],
      [
        7,
        10
      ],
      [
        -3,
        26
      ],
      [
        10,
        -17
      ],
      [
        1,
        29
      ],
      [
        7,
        15
      ],
      [
        3,
        -1
      ],
      [
        11,
        -11
      ],
      [
        3,
        -4
      ],
      [
        5,
        -3
      ],
      [
        1,
        5
      ],
      [
        3,
        28
      ],
      [
        -1,
        39
      ],
      [
        24,
        -11
      ],
      [
        -1,
        30
      ],
      [
        -7,
        8
      ],
      [
        -1,
        4
      ],
      [
        -8,
        64
      ],
      [
        0,
        9
      ],
      [
        1,
        4
      ],
      [
        5,
        11
      ],
      [
        9,
        7
      ],
      [
        5,
        1
      ],
      [
        2,
        -8
      ],
      [
        4,
        -8
      ],
      [
        2,
        0
      ],
      [
        15,
        18
      ],
      [
        0,
        8
      ],
      [
        -3,
        7
      ],
      [
        -3,
        6
      ],
      [
        -12,
        14
      ],
      [
        1,
        25
      ],
      [
        3,
        14
      ],
      [
        5,
        11
      ],
      [
        5,
        8
      ],
      [
        7,
        4
      ],
      [
        21,
        1
      ],
      [
        8,
        -2
      ],
      [
        10,
        -50
      ],
      [
        -1,
        -18
      ],
      [
        8,
        -2
      ],
      [
        7,
        9
      ],
      [
        -7,
        29
      ],
      [
        0,
        21
      ],
      [
        15,
        13
      ],
      [
        -2,
        18
      ],
      [
        -20,
        14
      ],
      [
        -24,
        26
      ],
      [
        -5,
        9
      ],
      [
        -4,
        -2
      ],
      [
        -2,
        -5
      ],
      [
        -3,
        -10
      ],
      [
        -3,
        -8
      ],
      [
        -3,
        -1
      ],
      [
        -3,
        3
      ],
      [
        -14,
        34
      ],
      [
        -18,
        47
      ],
      [
        0,
        46
      ],
      [
        23,
        74
      ],
      [
        8,
        18
      ],
      [
        28,
        36
      ],
      [
        14,
        14
      ],
      [
        17,
        6
      ],
      [
        19,
        26
      ],
      [
        1,
        1
      ],
      [
        1,
        -1
      ],
      [
        4,
        -15
      ],
      [
        14,
        17
      ],
      [
        9,
        -4
      ],
      [
        2,
        -3
      ],
      [
        5,
        -12
      ],
      [
        6,
        -20
      ],
      [
        3,
        -28
      ],
      [
        -5,
        -5
      ],
      [
        -4,
        -2
      ],
      [
        -7,
        -35
      ],
      [
        1,
        -13
      ],
      [
        6,
        -22
      ],
      [
        7,
        -12
      ],
      [
        6,
        -5
      ],
      [
        4,
        -1
      ],
      [
        2,
        29
      ],
      [
        5,
        17
      ],
      [
        7,
        7
      ],
      [
        6,
        -33
      ],
      [
        12,
        16
      ],
      [
        2,
        8
      ],
      [
        1,
        5
      ],
      [
        -1,
        41
      ],
      [
        18,
        63
      ],
      [
        2,
        -1
      ],
      [
        3,
        -12
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -21
      ],
      [
        11,
        -20
      ],
      [
        11,
        26
      ],
      [
        4,
        -6
      ],
      [
        15,
        -51
      ],
      [
        1,
        -5
      ],
      [
        -1,
        -20
      ],
      [
        -7,
        -36
      ],
      [
        -4,
        -5
      ],
      [
        -19,
        -8
      ],
      [
        -9,
        -13
      ],
      [
        -11,
        -31
      ],
      [
        -4,
        -26
      ],
      [
        -8,
        -14
      ],
      [
        -32,
        -56
      ],
      [
        -1,
        -25
      ],
      [
        3,
        -14
      ],
      [
        20,
        23
      ],
      [
        3,
        12
      ],
      [
        11,
        19
      ],
      [
        23,
        29
      ],
      [
        9,
        5
      ],
      [
        26,
        30
      ],
      [
        -1,
        3
      ],
      [
        1,
        9
      ],
      [
        4,
        10
      ],
      [
        22,
        22
      ],
      [
        1,
        -2
      ],
      [
        5,
        -11
      ],
      [
        1,
        -6
      ],
      [
        -5,
        -72
      ],
      [
        -16,
        -51
      ],
      [
        -9,
        -7
      ],
      [
        -17,
        -27
      ],
      [
        -1,
        -7
      ],
      [
        -3,
        -13
      ],
      [
        -2,
        -3
      ],
      [
        -45,
        -51
      ],
      [
        -6,
        7
      ],
      [
        -18,
        -19
      ],
      [
        -6,
        -8
      ],
      [
        7,
        -14
      ],
      [
        5,
        -32
      ],
      [
        -16,
        -1
      ],
      [
        -1,
        -27
      ],
      [
        -3,
        -34
      ],
      [
        -16,
        17
      ],
      [
        1,
        -26
      ],
      [
        -3,
        -22
      ],
      [
        -3,
        -20
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        1
      ],
      [
        -13,
        15
      ],
      [
        -6,
        9
      ],
      [
        -2,
        10
      ],
      [
        -8,
        -22
      ],
      [
        8,
        -15
      ],
      [
        0,
        -22
      ],
      [
        -2,
        -27
      ],
      [
        -11,
        14
      ],
      [
        -5,
        -22
      ],
      [
        -16,
        11
      ],
      [
        -4,
        -16
      ],
      [
        -12,
        13
      ],
      [
        -10,
        17
      ],
      [
        -2,
        -27
      ],
      [
        -8,
        -4
      ],
      [
        -12,
        23
      ],
      [
        -3,
        0
      ],
      [
        -1,
        -18
      ],
      [
        -7,
        -10
      ],
      [
        -10,
        -9
      ],
      [
        -3,
        10
      ],
      [
        -3,
        1
      ],
      [
        -19,
        -33
      ],
      [
        -25,
        -40
      ],
      [
        -3,
        -31
      ],
      [
        -2,
        -3
      ],
      [
        -11,
        -2
      ],
      [
        -10,
        9
      ],
      [
        -16,
        -23
      ],
      [
        -7,
        -29
      ],
      [
        -6,
        -31
      ],
      [
        -7,
        -2
      ],
      [
        -5,
        9
      ],
      [
        -2,
        3
      ],
      [
        -14,
        13
      ],
      [
        -2,
        -1
      ],
      [
        -4,
        -3
      ],
      [
        -3,
        -41
      ],
      [
        -6,
        0
      ],
      [
        -43,
        40
      ],
      [
        -10,
        17
      ],
      [
        -5,
        11
      ],
      [
        0,
        8
      ]
    ],
    [
      [
        2812,
        78476
      ],
      [
        4,
        8
      ],
      [
        13,
        4
      ],
      [
        6,
        5
      ],
      [
        4,
        10
      ],
      [
        -4,
        35
      ],
      [
        3,
        24
      ],
      [
        18,
        0
      ],
      [
        10,
        36
      ],
      [
        -3,
        33
      ],
      [
        3,
        24
      ],
      [
        21,
        33
      ],
      [
        6,
        30
      ],
      [
        1,
        12
      ],
      [
        -2,
        15
      ],
      [
        -3,
        4
      ],
      [
        -3,
        4
      ],
      [
        -4,
        8
      ],
      [
        -1,
        14
      ],
      [
        2,
        28
      ],
      [
        2,
        14
      ],
      [
        1,
        6
      ],
      [
        7,
        25
      ],
      [
        41,
        91
      ],
      [
        5,
        15
      ],
      [
        16,
        -26
      ],
      [
        4,
        1
      ],
      [
        7,
        6
      ],
      [
        3,
        8
      ],
      [
        13,
        1
      ],
      [
        9,
        -8
      ],
      [
        13,
        -7
      ],
      [
        1,
        0
      ],
      [
        5,
        12
      ],
      [
        -6,
        54
      ],
      [
        -2,
        9
      ],
      [
        -1,
        2
      ],
      [
        -12,
        5
      ],
      [
        -4,
        15
      ],
      [
        7,
        13
      ],
      [
        6,
        49
      ],
      [
        -6,
        26
      ],
      [
        6,
        24
      ],
      [
        12,
        52
      ],
      [
        8,
        6
      ],
      [
        5,
        9
      ],
      [
        16,
        34
      ],
      [
        0,
        4
      ],
      [
        11,
        14
      ],
      [
        15,
        13
      ],
      [
        39,
        24
      ],
      [
        7,
        -5
      ],
      [
        5,
        -9
      ],
      [
        1,
        -1
      ],
      [
        -2,
        -11
      ],
      [
        0,
        -5
      ],
      [
        8,
        -14
      ],
      [
        10,
        -8
      ],
      [
        4,
        -1
      ],
      [
        20,
        -2
      ],
      [
        5,
        4
      ],
      [
        2,
        0
      ],
      [
        0,
        -2
      ],
      [
        1,
        -6
      ],
      [
        1,
        -15
      ],
      [
        -1,
        -10
      ],
      [
        -6,
        -22
      ],
      [
        -10,
        -23
      ],
      [
        -2,
        -10
      ],
      [
        -2,
        -9
      ],
      [
        1,
        -11
      ],
      [
        1,
        -8
      ],
      [
        2,
        -5
      ],
      [
        1,
        -8
      ],
      [
        0,
        -28
      ],
      [
        -3,
        -9
      ],
      [
        -6,
        -13
      ],
      [
        -1,
        0
      ],
      [
        -23,
        -30
      ],
      [
        -8,
        -14
      ],
      [
        -6,
        -14
      ],
      [
        -8,
        -15
      ],
      [
        -34,
        -43
      ],
      [
        -14,
        -13
      ],
      [
        -5,
        -2
      ],
      [
        -12,
        -14
      ],
      [
        -7,
        -18
      ],
      [
        -4,
        -14
      ],
      [
        -8,
        -34
      ],
      [
        -1,
        -36
      ],
      [
        -8,
        -31
      ],
      [
        -6,
        -6
      ],
      [
        -5,
        -15
      ],
      [
        -6,
        -19
      ],
      [
        -3,
        -10
      ],
      [
        -2,
        -12
      ],
      [
        -2,
        -23
      ],
      [
        -11,
        -23
      ],
      [
        -8,
        -8
      ],
      [
        -5,
        1
      ],
      [
        -2,
        4
      ],
      [
        -8,
        -4
      ],
      [
        -2,
        -3
      ],
      [
        -7,
        -21
      ],
      [
        -3,
        -13
      ],
      [
        -18,
        -37
      ],
      [
        -15,
        -17
      ],
      [
        -4,
        -51
      ],
      [
        -8,
        -4
      ],
      [
        -7,
        25
      ],
      [
        -27,
        -49
      ],
      [
        -37,
        -52
      ],
      [
        -17,
        -17
      ],
      [
        13,
        45
      ]
    ],
    [
      [
        2752,
        78371
      ],
      [
        16,
        29
      ],
      [
        13,
        20
      ],
      [
        3,
        -16
      ],
      [
        -4,
        -29
      ],
      [
        -8,
        -14
      ],
      [
        -18,
        -11
      ],
      [
        -2,
        21
      ]
    ],
    [
      [
        2615,
        78610
      ],
      [
        4,
        50
      ],
      [
        1,
        3
      ],
      [
        13,
        12
      ],
      [
        5,
        1
      ],
      [
        4,
        -13
      ],
      [
        0,
        -31
      ],
      [
        -9,
        -45
      ],
      [
        -7,
        -13
      ],
      [
        -5,
        5
      ],
      [
        -5,
        18
      ],
      [
        -1,
        5
      ],
      [
        0,
        8
      ]
    ],
    [
      [
        2607,
        82847
      ],
      [
        7,
        3
      ],
      [
        24,
        -10
      ],
      [
        19,
        -6
      ],
      [
        16,
        2
      ],
      [
        7,
        4
      ],
      [
        6,
        -1
      ],
      [
        9,
        -11
      ],
      [
        1,
        -3
      ],
      [
        -5,
        -18
      ],
      [
        -22,
        -50
      ],
      [
        -4,
        -4
      ],
      [
        -16,
        6
      ],
      [
        -3,
        2
      ],
      [
        -2,
        4
      ],
      [
        -3,
        8
      ],
      [
        -1,
        8
      ],
      [
        0,
        7
      ],
      [
        -1,
        13
      ],
      [
        -2,
        6
      ],
      [
        -20,
        10
      ],
      [
        -9,
        25
      ],
      [
        -1,
        5
      ]
    ],
    [
      [
        2611,
        78728
      ],
      [
        4,
        1
      ],
      [
        6,
        -20
      ],
      [
        -2,
        -20
      ],
      [
        -6,
        0
      ],
      [
        -9,
        13
      ],
      [
        7,
        26
      ]
    ],
    [
      [
        2547,
        78457
      ],
      [
        4,
        11
      ],
      [
        4,
        3
      ],
      [
        9,
        3
      ],
      [
        11,
        -9
      ],
      [
        12,
        6
      ],
      [
        -2,
        19
      ],
      [
        5,
        8
      ],
      [
        9,
        -4
      ],
      [
        13,
        19
      ],
      [
        6,
        -2
      ],
      [
        13,
        -8
      ],
      [
        10,
        -25
      ],
      [
        -4,
        -44
      ],
      [
        -6,
        -38
      ],
      [
        0,
        -20
      ],
      [
        -7,
        -3
      ],
      [
        -6,
        19
      ],
      [
        -24,
        31
      ],
      [
        -12,
        -2
      ],
      [
        -2,
        -8
      ],
      [
        -3,
        -8
      ],
      [
        -8,
        -11
      ],
      [
        -7,
        -5
      ],
      [
        -3,
        2
      ],
      [
        -9,
        17
      ],
      [
        -5,
        31
      ],
      [
        2,
        18
      ]
    ],
    [
      [
        2517,
        78521
      ],
      [
        6,
        21
      ],
      [
        2,
        5
      ],
      [
        11,
        0
      ],
      [
        7,
        -8
      ],
      [
        5,
        -8
      ],
      [
        2,
        -9
      ],
      [
        -1,
        -13
      ],
      [
        0,
        -9
      ],
      [
        -1,
        -4
      ],
      [
        -4,
        -12
      ],
      [
        -9,
        -15
      ],
      [
        -13,
        16
      ],
      [
        -5,
        24
      ],
      [
        0,
        12
      ]
    ],
    [
      [
        2497,
        78313
      ],
      [
        4,
        72
      ],
      [
        12,
        3
      ],
      [
        18,
        -16
      ],
      [
        3,
        -5
      ],
      [
        0,
        -12
      ],
      [
        -1,
        -15
      ],
      [
        -4,
        -25
      ],
      [
        -2,
        -5
      ],
      [
        -10,
        -5
      ],
      [
        -16,
        1
      ],
      [
        -4,
        6
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        2431,
        83489
      ],
      [
        0,
        26
      ],
      [
        1,
        1
      ],
      [
        4,
        11
      ],
      [
        4,
        5
      ],
      [
        16,
        13
      ],
      [
        6,
        2
      ],
      [
        5,
        -8
      ],
      [
        7,
        -2
      ],
      [
        8,
        5
      ],
      [
        21,
        17
      ],
      [
        3,
        -8
      ],
      [
        -5,
        -48
      ],
      [
        -32,
        -62
      ],
      [
        -2,
        20
      ],
      [
        -3,
        11
      ],
      [
        -6,
        2
      ],
      [
        -10,
        -1
      ],
      [
        -17,
        6
      ],
      [
        0,
        10
      ]
    ],
    [
      [
        2316,
        78170
      ],
      [
        4,
        38
      ],
      [
        1,
        4
      ],
      [
        25,
        51
      ],
      [
        15,
        21
      ],
      [
        11,
        -1
      ],
      [
        15,
        -18
      ],
      [
        5,
        -8
      ],
      [
        1,
        -8
      ],
      [
        0,
        -19
      ],
      [
        -2,
        -13
      ],
      [
        -11,
        -45
      ],
      [
        -9,
        -7
      ],
      [
        -6,
        -2
      ],
      [
        -2,
        1
      ],
      [
        -1,
        7
      ],
      [
        -1,
        3
      ],
      [
        -3,
        -1
      ],
      [
        -4,
        -5
      ],
      [
        -10,
        -20
      ],
      [
        -9,
        -27
      ],
      [
        -3,
        -13
      ],
      [
        -3,
        -8
      ],
      [
        -15,
        21
      ],
      [
        2,
        49
      ]
    ],
    [
      [
        2228,
        78152
      ],
      [
        5,
        0
      ],
      [
        4,
        -10
      ],
      [
        0,
        -22
      ],
      [
        -9,
        -8
      ],
      [
        -7,
        10
      ],
      [
        7,
        30
      ]
    ],
    [
      [
        2183,
        78046
      ],
      [
        1,
        9
      ],
      [
        5,
        16
      ],
      [
        4,
        9
      ],
      [
        7,
        8
      ],
      [
        15,
        -34
      ],
      [
        1,
        -3
      ],
      [
        -4,
        -34
      ],
      [
        -2,
        -6
      ],
      [
        -6,
        -15
      ],
      [
        -4,
        -1
      ],
      [
        -12,
        2
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        1
      ],
      [
        -2,
        27
      ],
      [
        0,
        24
      ]
    ],
    [
      [
        1818,
        77819
      ],
      [
        13,
        54
      ],
      [
        2,
        5
      ],
      [
        26,
        40
      ],
      [
        7,
        9
      ],
      [
        12,
        -2
      ],
      [
        22,
        -27
      ],
      [
        5,
        -12
      ],
      [
        2,
        -16
      ],
      [
        0,
        -15
      ],
      [
        -3,
        -10
      ],
      [
        -28,
        -51
      ],
      [
        -32,
        -27
      ],
      [
        -22,
        -1
      ],
      [
        -3,
        3
      ],
      [
        -4,
        12
      ],
      [
        3,
        38
      ]
    ],
    [
      [
        1421,
        77626
      ],
      [
        3,
        4
      ],
      [
        14,
        -10
      ],
      [
        18,
        6
      ],
      [
        13,
        18
      ],
      [
        -4,
        -27
      ],
      [
        16,
        -17
      ],
      [
        2,
        -5
      ],
      [
        2,
        -1
      ],
      [
        4,
        1
      ],
      [
        9,
        30
      ],
      [
        14,
        -2
      ],
      [
        18,
        19
      ],
      [
        9,
        7
      ],
      [
        6,
        1
      ],
      [
        3,
        -9
      ],
      [
        9,
        -3
      ],
      [
        8,
        19
      ],
      [
        5,
        -8
      ],
      [
        -6,
        -28
      ],
      [
        5,
        -23
      ],
      [
        5,
        -6
      ],
      [
        8,
        15
      ],
      [
        26,
        -10
      ],
      [
        0,
        -2
      ],
      [
        1,
        -4
      ],
      [
        4,
        -8
      ],
      [
        23,
        16
      ],
      [
        10,
        -11
      ],
      [
        18,
        10
      ],
      [
        14,
        1
      ],
      [
        1,
        -2
      ],
      [
        4,
        -10
      ],
      [
        11,
        -3
      ],
      [
        13,
        1
      ],
      [
        17,
        -5
      ],
      [
        0,
        -7
      ],
      [
        -21,
        -15
      ],
      [
        -4,
        -1
      ],
      [
        -16,
        6
      ],
      [
        -14,
        -22
      ],
      [
        -14,
        4
      ],
      [
        -30,
        -5
      ],
      [
        -22,
        -35
      ],
      [
        -8,
        16
      ],
      [
        -16,
        -19
      ],
      [
        -9,
        -1
      ],
      [
        -10,
        5
      ],
      [
        -18,
        25
      ],
      [
        -28,
        6
      ],
      [
        -24,
        -3
      ],
      [
        -5,
        -6
      ],
      [
        -1,
        -6
      ],
      [
        -3,
        -3
      ],
      [
        -19,
        10
      ],
      [
        -10,
        9
      ],
      [
        0,
        9
      ],
      [
        -10,
        40
      ],
      [
        -6,
        1
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        1
      ],
      [
        -7,
        17
      ],
      [
        -3,
        11
      ],
      [
        -1,
        9
      ],
      [
        1,
        3
      ]
    ],
    [
      [
        1064,
        77503
      ],
      [
        37,
        28
      ],
      [
        11,
        7
      ],
      [
        7,
        2
      ],
      [
        4,
        -5
      ],
      [
        0,
        -2
      ],
      [
        1,
        -8
      ],
      [
        6,
        -13
      ],
      [
        13,
        26
      ],
      [
        3,
        22
      ],
      [
        9,
        2
      ],
      [
        3,
        -22
      ],
      [
        3,
        3
      ],
      [
        5,
        24
      ],
      [
        11,
        11
      ],
      [
        -1,
        11
      ],
      [
        2,
        10
      ],
      [
        4,
        8
      ],
      [
        7,
        -16
      ],
      [
        10,
        0
      ],
      [
        1,
        -13
      ],
      [
        15,
        0
      ],
      [
        12,
        8
      ],
      [
        -2,
        22
      ],
      [
        10,
        12
      ],
      [
        6,
        -24
      ],
      [
        10,
        1
      ],
      [
        15,
        17
      ],
      [
        2,
        22
      ],
      [
        8,
        -3
      ],
      [
        3,
        17
      ],
      [
        1,
        8
      ],
      [
        -3,
        17
      ],
      [
        3,
        6
      ],
      [
        7,
        -6
      ],
      [
        9,
        5
      ],
      [
        8,
        2
      ],
      [
        3,
        -5
      ],
      [
        9,
        -9
      ],
      [
        2,
        1
      ],
      [
        3,
        13
      ],
      [
        0,
        3
      ],
      [
        -14,
        22
      ],
      [
        -2,
        12
      ],
      [
        3,
        7
      ],
      [
        15,
        0
      ],
      [
        11,
        -7
      ],
      [
        9,
        -1
      ],
      [
        8,
        3
      ],
      [
        13,
        34
      ],
      [
        -1,
        36
      ],
      [
        -13,
        5
      ],
      [
        -6,
        6
      ],
      [
        -6,
        1
      ],
      [
        -1,
        -4
      ],
      [
        -6,
        -1
      ],
      [
        -11,
        11
      ],
      [
        -12,
        18
      ],
      [
        -1,
        10
      ],
      [
        1,
        6
      ],
      [
        3,
        7
      ],
      [
        2,
        3
      ],
      [
        14,
        -8
      ],
      [
        5,
        -8
      ],
      [
        2,
        0
      ],
      [
        5,
        10
      ],
      [
        3,
        7
      ],
      [
        4,
        19
      ],
      [
        -1,
        12
      ],
      [
        -3,
        13
      ],
      [
        0,
        8
      ],
      [
        2,
        6
      ],
      [
        38,
        46
      ],
      [
        9,
        -2
      ],
      [
        24,
        -30
      ],
      [
        14,
        -49
      ],
      [
        8,
        -27
      ],
      [
        1,
        -9
      ],
      [
        0,
        -22
      ],
      [
        -1,
        -4
      ],
      [
        -13,
        -58
      ],
      [
        -7,
        -23
      ],
      [
        -6,
        -2
      ],
      [
        -7,
        5
      ],
      [
        -19,
        6
      ],
      [
        -2,
        -1
      ],
      [
        -4,
        -15
      ],
      [
        -1,
        -9
      ],
      [
        1,
        -19
      ],
      [
        2,
        -6
      ],
      [
        4,
        -10
      ],
      [
        11,
        -15
      ],
      [
        13,
        -35
      ],
      [
        2,
        -8
      ],
      [
        1,
        -5
      ],
      [
        -3,
        -24
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        0
      ],
      [
        -2,
        10
      ],
      [
        -2,
        5
      ],
      [
        -8,
        9
      ],
      [
        -7,
        -17
      ],
      [
        -10,
        7
      ],
      [
        -4,
        -14
      ],
      [
        0,
        -13
      ],
      [
        -16,
        -4
      ],
      [
        -7,
        25
      ],
      [
        -9,
        4
      ],
      [
        -4,
        -6
      ],
      [
        -5,
        -14
      ],
      [
        -5,
        -19
      ],
      [
        -9,
        -62
      ],
      [
        -10,
        25
      ],
      [
        -15,
        6
      ],
      [
        -1,
        -7
      ],
      [
        -13,
        -14
      ],
      [
        -7,
        4
      ],
      [
        -3,
        6
      ],
      [
        -7,
        -15
      ],
      [
        -27,
        -26
      ],
      [
        -6,
        -3
      ],
      [
        -13,
        29
      ],
      [
        -29,
        12
      ],
      [
        -23,
        -6
      ],
      [
        -9,
        -11
      ],
      [
        -4,
        -9
      ],
      [
        0,
        -15
      ],
      [
        -22,
        -8
      ],
      [
        -3,
        4
      ],
      [
        -14,
        9
      ],
      [
        -16,
        -7
      ],
      [
        -17,
        15
      ],
      [
        -5,
        0
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        -6,
        -5
      ],
      [
        -5,
        17
      ],
      [
        4,
        6
      ]
    ],
    [
      [
        1013,
        77451
      ],
      [
        8,
        8
      ],
      [
        9,
        9
      ],
      [
        6,
        -8
      ],
      [
        1,
        -21
      ],
      [
        -11,
        -3
      ],
      [
        -11,
        -1
      ],
      [
        -2,
        16
      ]
    ],
    [
      [
        1005,
        77685
      ],
      [
        7,
        10
      ],
      [
        5,
        -13
      ],
      [
        4,
        -16
      ],
      [
        -4,
        -14
      ],
      [
        -7,
        2
      ],
      [
        -5,
        17
      ],
      [
        0,
        14
      ]
    ],
    [
      [
        949,
        77433
      ],
      [
        5,
        9
      ],
      [
        15,
        -2
      ],
      [
        14,
        -2
      ],
      [
        11,
        1
      ],
      [
        0,
        -10
      ],
      [
        1,
        -16
      ],
      [
        -6,
        -3
      ],
      [
        -13,
        6
      ],
      [
        -13,
        -9
      ],
      [
        -9,
        -15
      ],
      [
        -6,
        17
      ],
      [
        1,
        24
      ]
    ],
    [
      [
        890,
        77452
      ],
      [
        11,
        14
      ],
      [
        28,
        -1
      ],
      [
        1,
        -6
      ],
      [
        4,
        -36
      ],
      [
        3,
        -22
      ],
      [
        7,
        -17
      ],
      [
        0,
        -9
      ],
      [
        -16,
        5
      ],
      [
        -13,
        26
      ],
      [
        -4,
        23
      ],
      [
        -20,
        14
      ],
      [
        -1,
        9
      ]
    ],
    [
      [
        821,
        77563
      ],
      [
        5,
        26
      ],
      [
        9,
        19
      ],
      [
        16,
        -8
      ],
      [
        10,
        -1
      ],
      [
        6,
        -27
      ],
      [
        8,
        -14
      ],
      [
        -1,
        -25
      ],
      [
        10,
        -14
      ],
      [
        -2,
        -15
      ],
      [
        -6,
        -2
      ],
      [
        -5,
        -10
      ],
      [
        -7,
        -11
      ],
      [
        3,
        -16
      ],
      [
        3,
        -14
      ],
      [
        9,
        -26
      ],
      [
        -3,
        -17
      ],
      [
        -7,
        -13
      ],
      [
        -3,
        -4
      ],
      [
        -18,
        -2
      ],
      [
        -18,
        22
      ],
      [
        3,
        57
      ],
      [
        -7,
        2
      ],
      [
        -2,
        31
      ],
      [
        -6,
        46
      ],
      [
        3,
        16
      ]
    ],
    [
      [
        811,
        77269
      ],
      [
        5,
        56
      ],
      [
        3,
        10
      ],
      [
        9,
        0
      ],
      [
        2,
        -3
      ],
      [
        0,
        -3
      ],
      [
        2,
        -9
      ],
      [
        6,
        -12
      ],
      [
        11,
        -5
      ],
      [
        5,
        4
      ],
      [
        3,
        11
      ],
      [
        -1,
        2
      ],
      [
        -1,
        6
      ],
      [
        -10,
        14
      ],
      [
        1,
        3
      ],
      [
        13,
        15
      ],
      [
        12,
        10
      ],
      [
        8,
        2
      ],
      [
        2,
        -5
      ],
      [
        4,
        -23
      ],
      [
        4,
        5
      ],
      [
        1,
        -14
      ],
      [
        0,
        -15
      ],
      [
        -3,
        -26
      ],
      [
        -6,
        8
      ],
      [
        -17,
        -8
      ],
      [
        8,
        -18
      ],
      [
        5,
        -34
      ],
      [
        -7,
        4
      ],
      [
        -8,
        14
      ],
      [
        -14,
        11
      ],
      [
        2,
        -40
      ],
      [
        -8,
        13
      ],
      [
        -4,
        -1
      ],
      [
        0,
        -22
      ],
      [
        -5,
        -17
      ],
      [
        -8,
        23
      ],
      [
        1,
        22
      ],
      [
        -10,
        6
      ],
      [
        -5,
        13
      ],
      [
        0,
        3
      ]
    ],
    [
      [
        601,
        77040
      ],
      [
        2,
        33
      ],
      [
        2,
        10
      ],
      [
        7,
        24
      ],
      [
        6,
        12
      ],
      [
        6,
        -1
      ],
      [
        3,
        5
      ],
      [
        6,
        27
      ],
      [
        1,
        6
      ],
      [
        0,
        3
      ],
      [
        -3,
        41
      ],
      [
        -6,
        5
      ],
      [
        -4,
        20
      ],
      [
        0,
        10
      ],
      [
        2,
        12
      ],
      [
        2,
        5
      ],
      [
        13,
        8
      ],
      [
        19,
        -1
      ],
      [
        7,
        59
      ],
      [
        -9,
        47
      ],
      [
        -4,
        22
      ],
      [
        6,
        35
      ],
      [
        4,
        10
      ],
      [
        11,
        4
      ],
      [
        4,
        0
      ],
      [
        6,
        -6
      ],
      [
        12,
        -14
      ],
      [
        7,
        21
      ],
      [
        1,
        9
      ],
      [
        7,
        22
      ],
      [
        4,
        7
      ],
      [
        2,
        0
      ],
      [
        6,
        -7
      ],
      [
        1,
        -7
      ],
      [
        3,
        -74
      ],
      [
        -3,
        -21
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        7
      ],
      [
        -14,
        -14
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -15
      ],
      [
        0,
        -27
      ],
      [
        13,
        -20
      ],
      [
        9,
        -4
      ],
      [
        8,
        1
      ],
      [
        2,
        7
      ],
      [
        31,
        26
      ],
      [
        24,
        5
      ],
      [
        6,
        0
      ],
      [
        1,
        -3
      ],
      [
        1,
        -7
      ],
      [
        5,
        -54
      ],
      [
        -1,
        -37
      ],
      [
        -1,
        -16
      ],
      [
        -5,
        -35
      ],
      [
        -15,
        -12
      ],
      [
        -23,
        9
      ],
      [
        -11,
        -15
      ],
      [
        -2,
        24
      ],
      [
        -10,
        -20
      ],
      [
        -3,
        -32
      ],
      [
        -18,
        -12
      ],
      [
        -13,
        -41
      ],
      [
        -7,
        2
      ],
      [
        -3,
        20
      ],
      [
        -10,
        11
      ],
      [
        -3,
        -2
      ],
      [
        -6,
        -25
      ],
      [
        4,
        -19
      ],
      [
        2,
        -29
      ],
      [
        -11,
        17
      ],
      [
        -13,
        -26
      ],
      [
        -3,
        4
      ],
      [
        -4,
        20
      ],
      [
        0,
        8
      ],
      [
        3,
        23
      ],
      [
        -6,
        26
      ],
      [
        -8,
        3
      ],
      [
        -11,
        -58
      ],
      [
        -8,
        -50
      ],
      [
        -2,
        -2
      ],
      [
        -4,
        2
      ],
      [
        -8,
        11
      ],
      [
        -1,
        6
      ],
      [
        -1,
        26
      ]
    ],
    [
      [
        469,
        77371
      ],
      [
        5,
        16
      ],
      [
        8,
        -7
      ],
      [
        2,
        -26
      ],
      [
        -5,
        -13
      ],
      [
        -9,
        -4
      ],
      [
        -5,
        16
      ],
      [
        4,
        18
      ]
    ],
    [
      [
        402,
        77131
      ],
      [
        2,
        6
      ],
      [
        16,
        27
      ],
      [
        12,
        -11
      ],
      [
        12,
        -6
      ],
      [
        5,
        0
      ],
      [
        6,
        4
      ],
      [
        5,
        16
      ],
      [
        10,
        14
      ],
      [
        50,
        39
      ],
      [
        12,
        17
      ],
      [
        7,
        16
      ],
      [
        2,
        10
      ],
      [
        1,
        28
      ],
      [
        1,
        44
      ],
      [
        0,
        56
      ],
      [
        2,
        8
      ],
      [
        3,
        6
      ],
      [
        7,
        2
      ],
      [
        16,
        -10
      ],
      [
        12,
        -32
      ],
      [
        3,
        -12
      ],
      [
        -10,
        -50
      ],
      [
        -11,
        -18
      ],
      [
        -3,
        -7
      ],
      [
        -2,
        -23
      ],
      [
        2,
        -60
      ],
      [
        3,
        -26
      ],
      [
        -1,
        -13
      ],
      [
        -6,
        -25
      ],
      [
        -33,
        -31
      ],
      [
        -3,
        -1
      ],
      [
        -6,
        5
      ],
      [
        -6,
        7
      ],
      [
        0,
        12
      ],
      [
        -2,
        12
      ],
      [
        -5,
        12
      ],
      [
        -5,
        7
      ],
      [
        -9,
        7
      ],
      [
        -7,
        -3
      ],
      [
        -8,
        -6
      ],
      [
        -5,
        -14
      ],
      [
        -7,
        -10
      ],
      [
        -14,
        -7
      ],
      [
        -9,
        -1
      ],
      [
        -10,
        8
      ],
      [
        -3,
        -1
      ],
      [
        -4,
        -9
      ],
      [
        -2,
        -28
      ],
      [
        1,
        -15
      ],
      [
        -4,
        -7
      ],
      [
        -6,
        12
      ],
      [
        -10,
        46
      ],
      [
        1,
        5
      ]
    ],
    [
      [
        257,
        77332
      ],
      [
        1,
        5
      ],
      [
        7,
        24
      ],
      [
        6,
        7
      ],
      [
        8,
        7
      ],
      [
        6,
        3
      ],
      [
        9,
        0
      ],
      [
        6,
        -3
      ],
      [
        3,
        -5
      ],
      [
        16,
        -3
      ],
      [
        11,
        9
      ],
      [
        3,
        -3
      ],
      [
        11,
        -42
      ],
      [
        -3,
        -25
      ],
      [
        1,
        -5
      ],
      [
        12,
        -4
      ],
      [
        5,
        -27
      ],
      [
        2,
        -1
      ],
      [
        15,
        17
      ],
      [
        11,
        -11
      ],
      [
        7,
        -6
      ],
      [
        12,
        21
      ],
      [
        21,
        13
      ],
      [
        0,
        -3
      ],
      [
        -3,
        -18
      ],
      [
        -7,
        -19
      ],
      [
        -10,
        -10
      ],
      [
        -2,
        2
      ],
      [
        -12,
        -7
      ],
      [
        -17,
        -17
      ],
      [
        -1,
        -18
      ],
      [
        1,
        -8
      ],
      [
        -4,
        -20
      ],
      [
        -8,
        -25
      ],
      [
        0,
        -11
      ],
      [
        1,
        -7
      ],
      [
        3,
        -6
      ],
      [
        0,
        -7
      ],
      [
        -4,
        -19
      ],
      [
        -4,
        -10
      ],
      [
        -4,
        -2
      ],
      [
        -2,
        3
      ],
      [
        -3,
        9
      ],
      [
        -3,
        4
      ],
      [
        -1,
        -2
      ],
      [
        -5,
        -20
      ],
      [
        -3,
        -22
      ],
      [
        0,
        -5
      ],
      [
        1,
        -10
      ],
      [
        3,
        -14
      ],
      [
        4,
        -28
      ],
      [
        -1,
        -10
      ],
      [
        -1,
        -1
      ],
      [
        -6,
        6
      ],
      [
        -4,
        11
      ],
      [
        -2,
        10
      ],
      [
        0,
        21
      ],
      [
        -1,
        11
      ],
      [
        -2,
        3
      ],
      [
        -14,
        -24
      ],
      [
        -16,
        48
      ],
      [
        -4,
        -8
      ],
      [
        -7,
        8
      ],
      [
        -2,
        8
      ],
      [
        4,
        28
      ],
      [
        23,
        6
      ],
      [
        16,
        15
      ],
      [
        2,
        4
      ],
      [
        2,
        20
      ],
      [
        1,
        14
      ],
      [
        -1,
        16
      ],
      [
        -2,
        8
      ],
      [
        -3,
        6
      ],
      [
        -8,
        4
      ],
      [
        -12,
        -3
      ],
      [
        -6,
        9
      ],
      [
        -6,
        14
      ],
      [
        -1,
        11
      ],
      [
        -24,
        37
      ],
      [
        -12,
        21
      ],
      [
        -3,
        8
      ],
      [
        -1,
        10
      ],
      [
        1,
        8
      ]
    ],
    [
      [
        130,
        77016
      ],
      [
        12,
        4
      ],
      [
        5,
        -3
      ],
      [
        6,
        -7
      ],
      [
        6,
        3
      ],
      [
        3,
        -9
      ],
      [
        -3,
        -18
      ],
      [
        -4,
        0
      ],
      [
        -8,
        7
      ],
      [
        -6,
        -3
      ],
      [
        -9,
        3
      ],
      [
        -3,
        15
      ],
      [
        1,
        8
      ]
    ],
    [
      [
        81,
        76979
      ],
      [
        8,
        -2
      ],
      [
        19,
        -15
      ],
      [
        7,
        -13
      ],
      [
        0,
        -10
      ],
      [
        -17,
        -1
      ],
      [
        -8,
        6
      ],
      [
        -9,
        30
      ],
      [
        0,
        5
      ]
    ],
    [
      [
        77,
        77233
      ],
      [
        4,
        30
      ],
      [
        8,
        18
      ],
      [
        2,
        4
      ],
      [
        3,
        -1
      ],
      [
        6,
        -7
      ],
      [
        6,
        -11
      ],
      [
        5,
        -16
      ],
      [
        4,
        -30
      ],
      [
        -4,
        -31
      ],
      [
        -8,
        -10
      ],
      [
        -4,
        -3
      ],
      [
        -5,
        1
      ],
      [
        -2,
        2
      ],
      [
        -16,
        39
      ],
      [
        1,
        15
      ]
    ],
    [
      [
        43,
        76751
      ],
      [
        4,
        21
      ],
      [
        4,
        4
      ],
      [
        10,
        -22
      ],
      [
        4,
        -23
      ],
      [
        1,
        -27
      ],
      [
        -12,
        -2
      ],
      [
        0,
        -7
      ],
      [
        -3,
        -12
      ],
      [
        -4,
        -10
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        1
      ],
      [
        -1,
        81
      ]
    ],
    [
      [
        3,
        76640
      ],
      [
        6,
        17
      ],
      [
        6,
        1
      ],
      [
        5,
        -19
      ],
      [
        2,
        -26
      ],
      [
        -1,
        -14
      ],
      [
        -7,
        -28
      ],
      [
        -8,
        -8
      ],
      [
        -3,
        11
      ],
      [
        -3,
        56
      ],
      [
        3,
        10
      ]
    ],
    [
      [
        7905,
        86007
      ],
      [
        9,
        20
      ],
      [
        11,
        46
      ],
      [
        9,
        24
      ],
      [
        15,
        -17
      ],
      [
        2,
        -10
      ],
      [
        -3,
        -36
      ],
      [
        -9,
        -14
      ],
      [
        -8,
        -45
      ],
      [
        -11,
        -15
      ],
      [
        -12,
        14
      ],
      [
        -3,
        5
      ],
      [
        0,
        28
      ]
    ],
    [
      [
        7695,
        85792
      ],
      [
        13,
        -6
      ],
      [
        13,
        -8
      ],
      [
        1,
        -21
      ],
      [
        -4,
        -15
      ],
      [
        -13,
        19
      ],
      [
        -10,
        15
      ],
      [
        0,
        16
      ]
    ],
    [
      [
        7642,
        85774
      ],
      [
        8,
        -3
      ],
      [
        14,
        -14
      ],
      [
        -1,
        -15
      ],
      [
        -6,
        -18
      ],
      [
        -14,
        14
      ],
      [
        -3,
        16
      ],
      [
        2,
        20
      ]
    ],
    [
      [
        7602,
        85813
      ],
      [
        10,
        14
      ],
      [
        7,
        -1
      ],
      [
        3,
        -15
      ],
      [
        -1,
        -22
      ],
      [
        -4,
        -12
      ],
      [
        -4,
        2
      ],
      [
        -10,
        9
      ],
      [
        -7,
        14
      ],
      [
        6,
        11
      ]
    ],
    [
      [
        8515,
        86711
      ],
      [
        -14,
        -25
      ],
      [
        -10,
        7
      ],
      [
        -1,
        1
      ],
      [
        -4,
        26
      ],
      [
        -19,
        16
      ],
      [
        -12,
        -7
      ],
      [
        -6,
        -25
      ],
      [
        -11,
        -8
      ],
      [
        -5,
        14
      ],
      [
        -10,
        38
      ],
      [
        -14,
        4
      ],
      [
        -13,
        -25
      ],
      [
        -8,
        20
      ],
      [
        -14,
        -15
      ],
      [
        -9,
        15
      ],
      [
        0,
        13
      ],
      [
        11,
        35
      ],
      [
        13,
        39
      ],
      [
        -9,
        14
      ],
      [
        -10,
        -13
      ],
      [
        -17,
        -25
      ],
      [
        -10,
        -39
      ],
      [
        -5,
        -58
      ],
      [
        -14,
        -78
      ],
      [
        -30,
        -42
      ],
      [
        -9,
        18
      ],
      [
        7,
        36
      ],
      [
        7,
        19
      ],
      [
        3,
        42
      ],
      [
        10,
        42
      ],
      [
        -4,
        45
      ],
      [
        -3,
        43
      ],
      [
        -5,
        42
      ],
      [
        0,
        7
      ],
      [
        -3,
        35
      ],
      [
        -16,
        5
      ],
      [
        -5,
        -28
      ],
      [
        0,
        -46
      ],
      [
        1,
        -35
      ],
      [
        8,
        -18
      ],
      [
        5,
        -35
      ],
      [
        -10,
        -4
      ],
      [
        -2,
        -18
      ],
      [
        -8,
        -54
      ],
      [
        -5,
        12
      ],
      [
        -12,
        -1
      ],
      [
        -8,
        -20
      ],
      [
        0,
        -24
      ],
      [
        -5,
        -44
      ],
      [
        -11,
        -17
      ],
      [
        4,
        -47
      ],
      [
        14,
        -17
      ],
      [
        11,
        -14
      ],
      [
        -2,
        -38
      ],
      [
        -4,
        -36
      ],
      [
        -16,
        15
      ],
      [
        -11,
        17
      ],
      [
        -5,
        40
      ],
      [
        -3,
        41
      ],
      [
        -4,
        46
      ],
      [
        8,
        37
      ],
      [
        -1,
        22
      ],
      [
        -10,
        56
      ],
      [
        -10,
        13
      ],
      [
        -7,
        -7
      ],
      [
        2,
        -23
      ],
      [
        4,
        -29
      ],
      [
        -8,
        -49
      ],
      [
        2,
        -150
      ],
      [
        3,
        -46
      ],
      [
        -5,
        -64
      ],
      [
        -12,
        28
      ],
      [
        -15,
        46
      ],
      [
        -1,
        43
      ],
      [
        -16,
        28
      ],
      [
        -34,
        31
      ],
      [
        -4,
        -19
      ],
      [
        7,
        -21
      ],
      [
        10,
        -11
      ],
      [
        14,
        -25
      ],
      [
        3,
        -37
      ],
      [
        -4,
        -26
      ],
      [
        -27,
        -64
      ],
      [
        -22,
        -53
      ],
      [
        -20,
        -41
      ],
      [
        -20,
        -55
      ],
      [
        -12,
        -36
      ],
      [
        0,
        -36
      ],
      [
        -16,
        -10
      ],
      [
        -3,
        -39
      ],
      [
        -6,
        -47
      ],
      [
        -12,
        2
      ],
      [
        -3,
        70
      ],
      [
        20,
        132
      ],
      [
        14,
        79
      ],
      [
        0,
        29
      ],
      [
        -10,
        -14
      ],
      [
        -16,
        -51
      ],
      [
        -6,
        -47
      ],
      [
        -13,
        -64
      ],
      [
        -5,
        -3
      ],
      [
        -5,
        7
      ],
      [
        -2,
        7
      ],
      [
        0,
        7
      ],
      [
        1,
        3
      ],
      [
        1,
        6
      ],
      [
        0,
        5
      ],
      [
        -2,
        10
      ],
      [
        -4,
        4
      ],
      [
        -2,
        14
      ],
      [
        -2,
        19
      ],
      [
        0,
        14
      ],
      [
        5,
        28
      ],
      [
        -1,
        21
      ],
      [
        -1,
        7
      ],
      [
        -2,
        4
      ],
      [
        -2,
        0
      ],
      [
        -6,
        -13
      ],
      [
        -4,
        -16
      ],
      [
        -1,
        -14
      ],
      [
        -2,
        -9
      ],
      [
        -4,
        0
      ],
      [
        -4,
        4
      ],
      [
        -3,
        -2
      ],
      [
        1,
        -18
      ],
      [
        2,
        -12
      ],
      [
        4,
        -13
      ],
      [
        6,
        -12
      ],
      [
        1,
        0
      ],
      [
        2,
        -7
      ],
      [
        1,
        -17
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -10
      ],
      [
        -1,
        -20
      ],
      [
        2,
        -6
      ],
      [
        -6,
        -23
      ],
      [
        -13,
        -5
      ],
      [
        -1,
        1
      ],
      [
        -14,
        13
      ],
      [
        -11,
        -9
      ],
      [
        -1,
        -29
      ],
      [
        -7,
        -32
      ],
      [
        -7,
        -12
      ],
      [
        -7,
        -6
      ],
      [
        -4,
        -6
      ],
      [
        -12,
        -40
      ],
      [
        -9,
        -7
      ],
      [
        -1,
        -8
      ],
      [
        5,
        -22
      ],
      [
        2,
        -15
      ],
      [
        0,
        -6
      ],
      [
        -3,
        -15
      ],
      [
        -12,
        -26
      ],
      [
        -5,
        0
      ],
      [
        -4,
        4
      ],
      [
        -4,
        -7
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        0
      ],
      [
        -2,
        10
      ],
      [
        0,
        22
      ],
      [
        3,
        7
      ],
      [
        -1,
        15
      ],
      [
        -6,
        -2
      ],
      [
        -3,
        8
      ],
      [
        -3,
        21
      ],
      [
        -1,
        6
      ],
      [
        -3,
        3
      ],
      [
        -4,
        -16
      ],
      [
        1,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        -4,
        -14
      ],
      [
        -1,
        0
      ],
      [
        -4,
        -7
      ],
      [
        1,
        -26
      ],
      [
        -1,
        -14
      ],
      [
        -1,
        -13
      ],
      [
        -5,
        -9
      ],
      [
        -10,
        -8
      ],
      [
        -7,
        0
      ],
      [
        -1,
        4
      ],
      [
        -1,
        6
      ],
      [
        -3,
        9
      ],
      [
        -5,
        6
      ],
      [
        -11,
        -5
      ],
      [
        -3,
        11
      ],
      [
        -2,
        1
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -7
      ],
      [
        -2,
        -6
      ],
      [
        -3,
        -5
      ],
      [
        -10,
        15
      ],
      [
        -11,
        23
      ],
      [
        -2,
        9
      ],
      [
        -1,
        17
      ],
      [
        -2,
        13
      ],
      [
        -2,
        4
      ],
      [
        -7,
        -13
      ],
      [
        -2,
        -17
      ],
      [
        -3,
        -6
      ],
      [
        -11,
        -12
      ],
      [
        -6,
        -4
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -6
      ],
      [
        1,
        -10
      ],
      [
        4,
        -5
      ],
      [
        2,
        -5
      ],
      [
        0,
        -9
      ],
      [
        -1,
        -6
      ],
      [
        -5,
        0
      ],
      [
        -10,
        6
      ],
      [
        -5,
        -6
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -17
      ],
      [
        -1,
        -9
      ],
      [
        -3,
        -4
      ],
      [
        -30,
        2
      ],
      [
        -3,
        -6
      ],
      [
        -3,
        -2
      ],
      [
        -5,
        -1
      ],
      [
        -2,
        3
      ],
      [
        -5,
        20
      ],
      [
        1,
        35
      ],
      [
        1,
        12
      ],
      [
        -1,
        6
      ],
      [
        -22,
        -14
      ],
      [
        -10,
        4
      ],
      [
        -11,
        18
      ],
      [
        -1,
        4
      ],
      [
        2,
        6
      ],
      [
        2,
        2
      ],
      [
        0,
        10
      ],
      [
        -6,
        9
      ],
      [
        -7,
        -5
      ],
      [
        -2,
        -3
      ],
      [
        -6,
        7
      ],
      [
        -3,
        70
      ],
      [
        8,
        36
      ],
      [
        3,
        6
      ],
      [
        8,
        5
      ],
      [
        5,
        7
      ],
      [
        4,
        15
      ],
      [
        1,
        11
      ],
      [
        -6,
        15
      ],
      [
        1,
        7
      ],
      [
        5,
        23
      ],
      [
        17,
        21
      ],
      [
        15,
        10
      ],
      [
        6,
        -1
      ],
      [
        3,
        -10
      ],
      [
        3,
        2
      ],
      [
        2,
        4
      ],
      [
        4,
        23
      ],
      [
        3,
        6
      ],
      [
        17,
        16
      ],
      [
        11,
        -7
      ],
      [
        7,
        9
      ],
      [
        6,
        -15
      ],
      [
        9,
        16
      ],
      [
        -4,
        22
      ],
      [
        4,
        23
      ],
      [
        12,
        18
      ],
      [
        10,
        -10
      ],
      [
        1,
        16
      ],
      [
        10,
        -3
      ],
      [
        14,
        30
      ],
      [
        13,
        15
      ],
      [
        7,
        17
      ],
      [
        12,
        4
      ],
      [
        19,
        -13
      ],
      [
        2,
        8
      ],
      [
        -2,
        9
      ],
      [
        -6,
        8
      ],
      [
        -5,
        26
      ],
      [
        -1,
        12
      ],
      [
        1,
        6
      ],
      [
        9,
        7
      ],
      [
        13,
        19
      ],
      [
        1,
        7
      ],
      [
        0,
        4
      ],
      [
        2,
        21
      ],
      [
        5,
        16
      ],
      [
        22,
        55
      ],
      [
        21,
        35
      ],
      [
        4,
        7
      ],
      [
        -6,
        -1
      ],
      [
        -9,
        -10
      ],
      [
        -5,
        6
      ],
      [
        -2,
        5
      ],
      [
        -6,
        4
      ],
      [
        -10,
        -4
      ],
      [
        -14,
        -18
      ],
      [
        -16,
        -31
      ],
      [
        -12,
        -25
      ],
      [
        -32,
        -53
      ],
      [
        -13,
        -3
      ],
      [
        -13,
        -13
      ],
      [
        -4,
        -4
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -11
      ],
      [
        -2,
        -7
      ],
      [
        -3,
        -6
      ],
      [
        -12,
        -11
      ],
      [
        -39,
        16
      ],
      [
        -12,
        16
      ],
      [
        -17,
        30
      ],
      [
        -14,
        21
      ],
      [
        -9,
        18
      ],
      [
        -6,
        22
      ],
      [
        -2,
        12
      ],
      [
        -3,
        23
      ],
      [
        0,
        11
      ],
      [
        3,
        15
      ],
      [
        7,
        27
      ],
      [
        5,
        35
      ],
      [
        3,
        40
      ],
      [
        3,
        11
      ],
      [
        4,
        11
      ],
      [
        6,
        23
      ],
      [
        4,
        31
      ],
      [
        7,
        76
      ],
      [
        4,
        26
      ],
      [
        12,
        29
      ],
      [
        10,
        36
      ],
      [
        5,
        14
      ],
      [
        17,
        33
      ],
      [
        8,
        20
      ],
      [
        8,
        26
      ],
      [
        19,
        53
      ],
      [
        4,
        18
      ],
      [
        5,
        45
      ],
      [
        2,
        35
      ],
      [
        -1,
        34
      ],
      [
        1,
        37
      ],
      [
        1,
        8
      ],
      [
        3,
        9
      ],
      [
        17,
        17
      ],
      [
        1,
        -3
      ],
      [
        1,
        1
      ],
      [
        1,
        35
      ],
      [
        2,
        22
      ],
      [
        1,
        20
      ],
      [
        0,
        20
      ],
      [
        1,
        51
      ],
      [
        0,
        8
      ],
      [
        4,
        27
      ],
      [
        -1,
        7
      ],
      [
        -9,
        14
      ],
      [
        -6,
        15
      ],
      [
        -2,
        8
      ],
      [
        -1,
        9
      ],
      [
        -1,
        7
      ],
      [
        -2,
        22
      ],
      [
        0,
        11
      ],
      [
        -2,
        14
      ],
      [
        -3,
        22
      ],
      [
        -7,
        24
      ],
      [
        -5,
        24
      ],
      [
        -1,
        19
      ],
      [
        0,
        11
      ],
      [
        7,
        11
      ],
      [
        4,
        4
      ],
      [
        17,
        8
      ],
      [
        8,
        8
      ],
      [
        3,
        4
      ],
      [
        2,
        8
      ],
      [
        1,
        6
      ],
      [
        -1,
        8
      ],
      [
        3,
        5
      ],
      [
        11,
        7
      ],
      [
        29,
        4
      ],
      [
        13,
        5
      ],
      [
        7,
        7
      ],
      [
        3,
        4
      ],
      [
        0,
        5
      ],
      [
        4,
        9
      ],
      [
        32,
        51
      ],
      [
        3,
        6
      ],
      [
        0,
        4
      ],
      [
        11,
        19
      ],
      [
        10,
        15
      ],
      [
        11,
        24
      ],
      [
        18,
        31
      ],
      [
        8,
        23
      ],
      [
        21,
        19
      ],
      [
        5,
        9
      ],
      [
        19,
        20
      ],
      [
        1,
        7
      ],
      [
        3,
        3
      ],
      [
        13,
        10
      ],
      [
        6,
        9
      ],
      [
        9,
        14
      ],
      [
        7,
        4
      ],
      [
        6,
        -9
      ],
      [
        3,
        -9
      ],
      [
        9,
        -40
      ],
      [
        7,
        -27
      ],
      [
        7,
        -22
      ],
      [
        19,
        -54
      ],
      [
        15,
        1
      ],
      [
        8,
        -14
      ],
      [
        9,
        -4
      ],
      [
        9,
        1
      ],
      [
        6,
        -22
      ],
      [
        7,
        -5
      ],
      [
        7,
        33
      ],
      [
        8,
        13
      ],
      [
        19,
        66
      ],
      [
        6,
        8
      ],
      [
        5,
        2
      ],
      [
        6,
        -3
      ],
      [
        13,
        1
      ],
      [
        36,
        -45
      ],
      [
        19,
        10
      ],
      [
        63,
        -48
      ],
      [
        65,
        -20
      ],
      [
        6,
        -14
      ],
      [
        16,
        -27
      ]
    ],
    [
      [
        7540,
        87187
      ],
      [
        3,
        17
      ],
      [
        17,
        50
      ],
      [
        9,
        12
      ],
      [
        4,
        70
      ],
      [
        4,
        42
      ],
      [
        6,
        7
      ],
      [
        25,
        -36
      ],
      [
        0,
        -5
      ],
      [
        -15,
        -24
      ],
      [
        1,
        -24
      ],
      [
        -14,
        -11
      ],
      [
        -9,
        -49
      ],
      [
        5,
        -24
      ],
      [
        -35,
        -31
      ],
      [
        -1,
        6
      ]
    ],
    [
      [
        7385,
        86976
      ],
      [
        6,
        21
      ],
      [
        11,
        -15
      ],
      [
        3,
        -14
      ],
      [
        5,
        -52
      ],
      [
        -1,
        -17
      ],
      [
        -2,
        -5
      ],
      [
        -20,
        63
      ],
      [
        -2,
        19
      ]
    ],
    [
      [
        7129,
        86075
      ],
      [
        14,
        0
      ],
      [
        27,
        28
      ],
      [
        6,
        -3
      ],
      [
        12,
        -40
      ],
      [
        1,
        -26
      ],
      [
        -6,
        -22
      ],
      [
        -13,
        -16
      ],
      [
        -29,
        -3
      ],
      [
        -8,
        13
      ],
      [
        -8,
        46
      ],
      [
        4,
        23
      ]
    ],
    [
      [
        7849,
        88171
      ],
      [
        -4,
        -3
      ],
      [
        -6,
        -7
      ],
      [
        -4,
        -5
      ],
      [
        -13,
        -43
      ],
      [
        -2,
        -10
      ],
      [
        -11,
        -49
      ],
      [
        -1,
        -9
      ],
      [
        -1,
        -8
      ],
      [
        -5,
        -16
      ],
      [
        -6,
        -19
      ],
      [
        -7,
        -4
      ],
      [
        -17,
        -4
      ],
      [
        -12,
        -4
      ],
      [
        -4,
        -6
      ],
      [
        -1,
        -5
      ],
      [
        -5,
        -13
      ],
      [
        -5,
        -6
      ],
      [
        -4,
        -1
      ],
      [
        -17,
        4
      ],
      [
        -12,
        -1
      ],
      [
        -4,
        -1
      ],
      [
        -16,
        -23
      ],
      [
        -10,
        -18
      ],
      [
        -13,
        -22
      ],
      [
        -5,
        -12
      ],
      [
        -1,
        -5
      ],
      [
        -10,
        -23
      ],
      [
        -4,
        -6
      ],
      [
        -6,
        -1
      ],
      [
        -2,
        -14
      ],
      [
        -4,
        -15
      ],
      [
        -13,
        -27
      ],
      [
        -3,
        -6
      ],
      [
        -2,
        -11
      ],
      [
        1,
        -18
      ],
      [
        3,
        -19
      ],
      [
        2,
        -14
      ],
      [
        8,
        -25
      ],
      [
        13,
        -66
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -11
      ],
      [
        -1,
        -7
      ],
      [
        -2,
        -2
      ],
      [
        -7,
        2
      ],
      [
        -2,
        2
      ],
      [
        -3,
        9
      ],
      [
        -6,
        6
      ],
      [
        -6,
        3
      ],
      [
        -2,
        3
      ],
      [
        -3,
        12
      ],
      [
        -3,
        6
      ],
      [
        -5,
        8
      ],
      [
        -3,
        -1
      ],
      [
        -1,
        -4
      ],
      [
        4,
        -14
      ],
      [
        1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        -6,
        -7
      ],
      [
        -13,
        -11
      ],
      [
        -30,
        -52
      ],
      [
        -10,
        -31
      ],
      [
        -11,
        -61
      ],
      [
        -11,
        -19
      ],
      [
        -3,
        -3
      ],
      [
        -4,
        1
      ],
      [
        -9,
        -8
      ],
      [
        -18,
        -37
      ],
      [
        -14,
        -37
      ],
      [
        -1,
        -7
      ],
      [
        -5,
        -31
      ],
      [
        0,
        -35
      ],
      [
        2,
        -10
      ],
      [
        3,
        -17
      ],
      [
        3,
        -7
      ],
      [
        19,
        -24
      ],
      [
        -18,
        -28
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        -9
      ],
      [
        -10,
        -4
      ],
      [
        -4,
        -3
      ],
      [
        -3,
        -9
      ],
      [
        -2,
        -20
      ],
      [
        0,
        -14
      ],
      [
        -2,
        -16
      ],
      [
        -5,
        -17
      ],
      [
        -3,
        -3
      ],
      [
        -6,
        0
      ],
      [
        -4,
        -1
      ],
      [
        -7,
        -11
      ],
      [
        -13,
        -28
      ],
      [
        -3,
        -11
      ],
      [
        -3,
        -16
      ],
      [
        -2,
        -4
      ],
      [
        -19,
        -7
      ],
      [
        0,
        9
      ],
      [
        -5,
        3
      ],
      [
        -4,
        16
      ],
      [
        -3,
        2
      ],
      [
        -8,
        -4
      ],
      [
        -5,
        1
      ],
      [
        -9,
        -10
      ],
      [
        1,
        -10
      ],
      [
        -3,
        -16
      ],
      [
        0,
        -9
      ],
      [
        2,
        -15
      ],
      [
        4,
        -18
      ],
      [
        9,
        -11
      ],
      [
        4,
        1
      ],
      [
        3,
        -3
      ],
      [
        1,
        -13
      ],
      [
        -4,
        -14
      ],
      [
        0,
        -3
      ],
      [
        8,
        -19
      ],
      [
        7,
        -6
      ],
      [
        10,
        -17
      ],
      [
        6,
        -22
      ],
      [
        2,
        -13
      ],
      [
        -2,
        -27
      ],
      [
        -4,
        -14
      ],
      [
        -5,
        -13
      ],
      [
        -1,
        -12
      ],
      [
        0,
        -7
      ],
      [
        -11,
        -24
      ],
      [
        -8,
        -23
      ],
      [
        -4,
        -41
      ],
      [
        -2,
        -15
      ],
      [
        -1,
        -6
      ],
      [
        -11,
        -13
      ],
      [
        -14,
        -8
      ],
      [
        -3,
        -10
      ],
      [
        -1,
        -12
      ],
      [
        -14,
        -4
      ],
      [
        -4,
        3
      ],
      [
        -2,
        6
      ],
      [
        -5,
        -1
      ],
      [
        -6,
        -4
      ],
      [
        -8,
        -2
      ],
      [
        -5,
        6
      ],
      [
        -10,
        6
      ],
      [
        -5,
        -1
      ],
      [
        -7,
        -4
      ],
      [
        -9,
        -13
      ],
      [
        -19,
        -13
      ],
      [
        -18,
        3
      ],
      [
        -4,
        -5
      ],
      [
        -1,
        -6
      ],
      [
        -8,
        -19
      ],
      [
        -6,
        -10
      ],
      [
        -2,
        -9
      ],
      [
        0,
        -4
      ],
      [
        2,
        -7
      ],
      [
        6,
        0
      ],
      [
        6,
        13
      ],
      [
        5,
        3
      ],
      [
        6,
        0
      ],
      [
        4,
        -3
      ],
      [
        11,
        -17
      ],
      [
        8,
        9
      ],
      [
        7,
        21
      ],
      [
        19,
        1
      ],
      [
        3,
        -4
      ],
      [
        2,
        -5
      ],
      [
        3,
        -19
      ],
      [
        -1,
        -22
      ],
      [
        -10,
        -79
      ],
      [
        -6,
        -37
      ],
      [
        -16,
        -16
      ],
      [
        -3,
        0
      ],
      [
        -9,
        -27
      ],
      [
        -17,
        -24
      ],
      [
        -7,
        -2
      ],
      [
        -4,
        7
      ],
      [
        -2,
        6
      ],
      [
        -4,
        28
      ],
      [
        -3,
        3
      ],
      [
        -4,
        -2
      ],
      [
        -4,
        -3
      ],
      [
        0,
        -4
      ],
      [
        2,
        -10
      ],
      [
        3,
        -20
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -6
      ],
      [
        -1,
        -2
      ],
      [
        -10,
        -5
      ],
      [
        -6,
        15
      ],
      [
        -5,
        5
      ],
      [
        -2,
        1
      ],
      [
        -5,
        -3
      ],
      [
        -2,
        2
      ],
      [
        -1,
        4
      ],
      [
        1,
        11
      ],
      [
        6,
        9
      ],
      [
        3,
        9
      ],
      [
        1,
        26
      ],
      [
        1,
        49
      ],
      [
        -18,
        62
      ],
      [
        -4,
        9
      ],
      [
        -1,
        -32
      ],
      [
        3,
        -24
      ],
      [
        1,
        -18
      ],
      [
        1,
        -13
      ],
      [
        0,
        -19
      ],
      [
        -1,
        -13
      ],
      [
        -6,
        -45
      ],
      [
        -3,
        -10
      ],
      [
        -18,
        -15
      ],
      [
        -6,
        11
      ],
      [
        -7,
        14
      ],
      [
        -5,
        -15
      ],
      [
        -1,
        -12
      ],
      [
        0,
        -8
      ],
      [
        5,
        -12
      ],
      [
        9,
        -6
      ],
      [
        2,
        -10
      ],
      [
        -1,
        -11
      ],
      [
        -6,
        -37
      ],
      [
        -2,
        -5
      ],
      [
        -9,
        1
      ],
      [
        -5,
        4
      ],
      [
        -5,
        -1
      ],
      [
        -19,
        -6
      ],
      [
        -11,
        -8
      ],
      [
        -2,
        -24
      ],
      [
        9,
        -19
      ],
      [
        8,
        -33
      ],
      [
        2,
        -17
      ],
      [
        -8,
        -32
      ],
      [
        -5,
        -7
      ],
      [
        -17,
        -12
      ],
      [
        -5,
        -2
      ],
      [
        -10,
        8
      ],
      [
        -10,
        -7
      ],
      [
        -4,
        -6
      ],
      [
        -4,
        -9
      ],
      [
        -6,
        -23
      ],
      [
        -1,
        1
      ],
      [
        -1,
        7
      ],
      [
        -2,
        5
      ],
      [
        -8,
        0
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -7
      ],
      [
        -3,
        -3
      ],
      [
        -5,
        -1
      ],
      [
        -3,
        6
      ],
      [
        -2,
        2
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        -5
      ],
      [
        -7,
        -17
      ],
      [
        -4,
        -2
      ],
      [
        -5,
        -1
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -9
      ],
      [
        6,
        -12
      ],
      [
        19,
        1
      ],
      [
        1,
        -7
      ],
      [
        0,
        -12
      ],
      [
        -14,
        -16
      ],
      [
        -9,
        -16
      ],
      [
        -3,
        -14
      ],
      [
        -4,
        -29
      ],
      [
        -1,
        -54
      ],
      [
        3,
        -7
      ],
      [
        -12,
        -44
      ],
      [
        -12,
        -25
      ],
      [
        -8,
        -8
      ],
      [
        -4,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        2,
        -23
      ],
      [
        1,
        -9
      ],
      [
        2,
        5
      ],
      [
        1,
        5
      ],
      [
        4,
        7
      ],
      [
        13,
        -3
      ],
      [
        2,
        -3
      ],
      [
        2,
        -23
      ],
      [
        0,
        -12
      ],
      [
        -2,
        -8
      ],
      [
        -6,
        -16
      ],
      [
        -1,
        -10
      ],
      [
        2,
        -20
      ],
      [
        5,
        -26
      ],
      [
        4,
        -13
      ],
      [
        0,
        9
      ],
      [
        7,
        8
      ],
      [
        7,
        14
      ],
      [
        13,
        41
      ],
      [
        8,
        2
      ],
      [
        7,
        -1
      ],
      [
        16,
        -7
      ],
      [
        5,
        -5
      ],
      [
        23,
        -12
      ],
      [
        3,
        3
      ],
      [
        7,
        11
      ],
      [
        1,
        7
      ],
      [
        2,
        2
      ],
      [
        3,
        -1
      ],
      [
        12,
        -22
      ],
      [
        0,
        7
      ],
      [
        1,
        8
      ],
      [
        12,
        12
      ],
      [
        2,
        -2
      ],
      [
        13,
        -52
      ],
      [
        9,
        -26
      ],
      [
        19,
        -27
      ],
      [
        7,
        -5
      ],
      [
        5,
        3
      ],
      [
        7,
        15
      ],
      [
        5,
        -9
      ],
      [
        3,
        -13
      ],
      [
        4,
        -7
      ],
      [
        4,
        1
      ],
      [
        7,
        -6
      ],
      [
        1,
        -17
      ],
      [
        2,
        -7
      ],
      [
        6,
        -20
      ],
      [
        4,
        -7
      ],
      [
        5,
        -2
      ],
      [
        3,
        -14
      ],
      [
        5,
        -34
      ],
      [
        0,
        -5
      ],
      [
        1,
        -4
      ],
      [
        2,
        -7
      ],
      [
        2,
        -3
      ],
      [
        5,
        5
      ],
      [
        4,
        -6
      ],
      [
        1,
        -7
      ],
      [
        -2,
        -1
      ]
    ],
    [
      [
        27221,
        52456
      ],
      [
        -1,
        -8
      ],
      [
        2,
        -7
      ],
      [
        4,
        -1
      ],
      [
        4,
        -17
      ],
      [
        1,
        -70
      ],
      [
        3,
        -25
      ],
      [
        0,
        -70
      ],
      [
        1,
        -43
      ],
      [
        2,
        -34
      ],
      [
        2,
        -25
      ]
    ],
    [
      [
        27052,
        52080
      ],
      [
        0,
        100
      ]
    ],
    [
      [
        29960,
        64853
      ],
      [
        2,
        26
      ],
      [
        3,
        7
      ],
      [
        1,
        9
      ],
      [
        3,
        10
      ],
      [
        1,
        12
      ],
      [
        0,
        11
      ],
      [
        1,
        5
      ],
      [
        3,
        -5
      ],
      [
        2,
        -9
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -10
      ],
      [
        -2,
        -11
      ],
      [
        0,
        -13
      ],
      [
        1,
        -9
      ],
      [
        3,
        -11
      ],
      [
        2,
        -2
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -3
      ],
      [
        -12,
        -6
      ],
      [
        -2,
        1
      ],
      [
        -3,
        7
      ],
      [
        0,
        8
      ]
    ],
    [
      [
        30017,
        65428
      ],
      [
        1,
        -75
      ],
      [
        -3,
        -3
      ],
      [
        -9,
        -8
      ],
      [
        1,
        -18
      ],
      [
        6,
        -31
      ],
      [
        1,
        -4
      ],
      [
        1,
        -13
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -15
      ],
      [
        -1,
        -6
      ],
      [
        1,
        -16
      ],
      [
        0,
        -14
      ],
      [
        -1,
        -3
      ],
      [
        0,
        3
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -6
      ],
      [
        1,
        -7
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -10
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        1
      ],
      [
        -3,
        -4
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -30
      ],
      [
        -6,
        -26
      ],
      [
        -2,
        -17
      ],
      [
        -9,
        4
      ],
      [
        -2,
        2
      ],
      [
        -1,
        0
      ],
      [
        -8,
        -4
      ],
      [
        -19,
        -14
      ],
      [
        -18,
        -21
      ],
      [
        -4,
        -7
      ],
      [
        -5,
        -6
      ],
      [
        -3,
        -1
      ],
      [
        -12,
        -4
      ],
      [
        -3,
        -2
      ],
      [
        -14,
        -12
      ],
      [
        -6,
        -11
      ],
      [
        -2,
        4
      ],
      [
        0,
        8
      ],
      [
        1,
        4
      ]
    ],
    [
      [
        20547,
        62997
      ],
      [
        -53,
        3
      ],
      [
        -52,
        -4
      ],
      [
        -15,
        0
      ]
    ],
    [
      [
        24065,
        59426
      ],
      [
        2,
        359
      ]
    ],
    [
      [
        24132,
        59427
      ],
      [
        -9,
        -1
      ],
      [
        -58,
        0
      ]
    ],
    [
      [
        21075,
        61776
      ],
      [
        0,
        8
      ],
      [
        92,
        2
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        21287,
        61485
      ],
      [
        -23,
        0
      ],
      [
        -160,
        -2
      ]
    ],
    [
      [
        22824,
        47685
      ],
      [
        1,
        -14
      ],
      [
        7,
        -109
      ],
      [
        7,
        -167
      ],
      [
        4,
        -93
      ],
      [
        -3,
        -6
      ],
      [
        -4,
        53
      ],
      [
        -5,
        147
      ],
      [
        -7,
        111
      ],
      [
        -5,
        78
      ]
    ],
    [
      [
        22789,
        47685
      ],
      [
        6,
        -53
      ],
      [
        9,
        -82
      ],
      [
        5,
        -29
      ],
      [
        -4,
        -14
      ],
      [
        -5,
        -33
      ],
      [
        0,
        -20
      ],
      [
        4,
        -14
      ],
      [
        0,
        -22
      ],
      [
        -1,
        -22
      ],
      [
        0,
        -18
      ],
      [
        4,
        -23
      ],
      [
        0,
        -15
      ],
      [
        -1,
        -12
      ],
      [
        3,
        -15
      ],
      [
        2,
        -7
      ],
      [
        7,
        -7
      ],
      [
        11,
        -1
      ],
      [
        2,
        -3
      ],
      [
        1,
        -35
      ],
      [
        4,
        8
      ],
      [
        5,
        12
      ],
      [
        3,
        -2
      ],
      [
        0,
        -52
      ],
      [
        2,
        -54
      ],
      [
        0,
        -21
      ],
      [
        -3,
        -5
      ],
      [
        -1,
        2
      ],
      [
        -2,
        10
      ],
      [
        -3,
        4
      ],
      [
        -2,
        -5
      ],
      [
        -6,
        3
      ],
      [
        -6,
        -2
      ],
      [
        -3,
        -5
      ],
      [
        -2,
        -8
      ],
      [
        -8,
        5
      ],
      [
        -2,
        -5
      ],
      [
        2,
        -14
      ],
      [
        -8,
        1
      ],
      [
        -5,
        -8
      ],
      [
        -1,
        -7
      ],
      [
        -3,
        -1
      ],
      [
        -4,
        3
      ],
      [
        -5,
        -11
      ],
      [
        -2,
        -10
      ],
      [
        1,
        -3
      ],
      [
        2,
        -3
      ],
      [
        0,
        -14
      ],
      [
        1,
        -25
      ],
      [
        -1,
        -22
      ],
      [
        -2,
        -11
      ],
      [
        -6,
        -4
      ],
      [
        -8,
        4
      ],
      [
        -6,
        11
      ],
      [
        -1,
        11
      ],
      [
        0,
        14
      ],
      [
        -2,
        9
      ],
      [
        -4,
        6
      ],
      [
        -5,
        -6
      ],
      [
        -3,
        1
      ],
      [
        -7,
        8
      ],
      [
        0,
        8
      ],
      [
        -2,
        13
      ],
      [
        0,
        14
      ],
      [
        -4,
        4
      ],
      [
        0,
        16
      ],
      [
        -3,
        4
      ],
      [
        -1,
        -6
      ],
      [
        -7,
        6
      ],
      [
        1,
        9
      ],
      [
        -1,
        12
      ],
      [
        -4,
        2
      ],
      [
        -3,
        18
      ],
      [
        0,
        4
      ],
      [
        -5,
        24
      ],
      [
        -2,
        3
      ],
      [
        -3,
        8
      ],
      [
        0,
        12
      ],
      [
        -1,
        6
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        1
      ],
      [
        -1,
        5
      ],
      [
        -7,
        -1
      ],
      [
        -2,
        8
      ],
      [
        -2,
        3
      ],
      [
        -3,
        -2
      ],
      [
        -11,
        1
      ],
      [
        -1,
        2
      ],
      [
        0,
        5
      ],
      [
        -2,
        4
      ],
      [
        -2,
        2
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        2
      ],
      [
        -1,
        2
      ],
      [
        -1,
        13
      ],
      [
        -1,
        6
      ],
      [
        -7,
        -5
      ],
      [
        -3,
        -5
      ],
      [
        -7,
        1
      ],
      [
        -2,
        5
      ]
    ],
    [
      [
        24065,
        59426
      ],
      [
        -23,
        0
      ]
    ],
    [
      [
        22581,
        58122
      ],
      [
        -57,
        -1
      ],
      [
        -1,
        0
      ],
      [
        0,
        162
      ],
      [
        -1,
        41
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        23857,
        58571
      ],
      [
        -1,
        -34
      ],
      [
        41,
        -5
      ],
      [
        48,
        0
      ],
      [
        10,
        -1
      ]
    ],
    [
      [
        26310,
        52211
      ],
      [
        119,
        4
      ],
      [
        9,
        0
      ],
      [
        3,
        -34
      ],
      [
        47,
        0
      ]
    ],
    [
      [
        26487,
        51973
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        0
      ],
      [
        -2,
        4
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        -10
      ],
      [
        -3,
        6
      ],
      [
        -3,
        -8
      ],
      [
        -6,
        -12
      ],
      [
        -3,
        -2
      ],
      [
        -3,
        2
      ],
      [
        -6,
        17
      ],
      [
        -1,
        0
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -8,
        1
      ],
      [
        -3,
        8
      ],
      [
        0,
        10
      ],
      [
        -3,
        3
      ],
      [
        -3,
        -7
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -11
      ],
      [
        1,
        -9
      ],
      [
        0,
        -9
      ],
      [
        -2,
        -9
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        0
      ],
      [
        -11,
        -29
      ],
      [
        -8,
        -28
      ],
      [
        1,
        -24
      ],
      [
        0,
        -4
      ],
      [
        4,
        0
      ],
      [
        1,
        -11
      ],
      [
        1,
        -17
      ]
    ],
    [
      [
        26357,
        51875
      ],
      [
        -13,
        21
      ],
      [
        -5,
        36
      ],
      [
        -5,
        3
      ],
      [
        -3,
        24
      ],
      [
        -5,
        19
      ],
      [
        2,
        10
      ],
      [
        -6,
        23
      ],
      [
        -1,
        26
      ],
      [
        1,
        37
      ],
      [
        -2,
        7
      ],
      [
        -1,
        34
      ],
      [
        -6,
        17
      ],
      [
        1,
        15
      ],
      [
        -11,
        24
      ],
      [
        2,
        24
      ],
      [
        5,
        16
      ]
    ],
    [
      [
        26452,
        70053
      ],
      [
        2,
        -7
      ],
      [
        4,
        -19
      ],
      [
        7,
        -23
      ],
      [
        5,
        -13
      ],
      [
        3,
        -14
      ],
      [
        0,
        -23
      ],
      [
        2,
        -21
      ],
      [
        1,
        -13
      ],
      [
        2,
        -9
      ],
      [
        4,
        -9
      ],
      [
        6,
        -8
      ],
      [
        5,
        -1
      ],
      [
        5,
        5
      ],
      [
        1,
        3
      ],
      [
        2,
        1
      ],
      [
        5,
        -3
      ],
      [
        3,
        -4
      ],
      [
        6,
        3
      ],
      [
        11,
        -1
      ],
      [
        8,
        -9
      ],
      [
        8,
        -20
      ],
      [
        6,
        -25
      ],
      [
        5,
        -13
      ],
      [
        10,
        -19
      ],
      [
        4,
        -3
      ],
      [
        5,
        1
      ],
      [
        5,
        -8
      ],
      [
        5,
        0
      ],
      [
        4,
        3
      ],
      [
        7,
        -20
      ],
      [
        8,
        -13
      ],
      [
        7,
        -15
      ],
      [
        12,
        -23
      ],
      [
        8,
        -6
      ],
      [
        6,
        4
      ],
      [
        1,
        2
      ],
      [
        0,
        7
      ],
      [
        2,
        0
      ],
      [
        5,
        -13
      ],
      [
        2,
        -1
      ],
      [
        5,
        13
      ],
      [
        2,
        -2
      ],
      [
        3,
        -16
      ],
      [
        9,
        -36
      ],
      [
        4,
        -9
      ],
      [
        2,
        -8
      ],
      [
        1,
        -7
      ],
      [
        6,
        -13
      ],
      [
        3,
        -3
      ],
      [
        1,
        -3
      ],
      [
        1,
        -6
      ],
      [
        -2,
        -16
      ],
      [
        -7,
        -11
      ],
      [
        0,
        -8
      ],
      [
        2,
        -14
      ],
      [
        5,
        -23
      ]
    ],
    [
      [
        26440,
        69554
      ],
      [
        -1,
        97
      ],
      [
        -1,
        401
      ],
      [
        14,
        1
      ]
    ],
    [
      [
        25321,
        65510
      ],
      [
        16,
        1
      ],
      [
        1,
        0
      ],
      [
        15,
        1
      ],
      [
        9,
        1
      ],
      [
        15,
        1
      ],
      [
        9,
        1
      ],
      [
        0,
        -50
      ]
    ],
    [
      [
        31642,
        38028
      ],
      [
        8,
        4
      ],
      [
        10,
        16
      ],
      [
        6,
        3
      ],
      [
        6,
        10
      ],
      [
        8,
        16
      ],
      [
        11,
        5
      ],
      [
        8,
        -5
      ],
      [
        10,
        -12
      ],
      [
        6,
        -4
      ],
      [
        1,
        1
      ],
      [
        2,
        -5
      ],
      [
        2,
        2
      ],
      [
        2,
        7
      ],
      [
        4,
        -16
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        1
      ],
      [
        -3,
        -6
      ],
      [
        -8,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        -14
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        1
      ],
      [
        -2,
        0
      ],
      [
        1,
        13
      ],
      [
        -1,
        2
      ],
      [
        -3,
        -1
      ],
      [
        -2,
        -3
      ],
      [
        0,
        -16
      ],
      [
        -3,
        -2
      ],
      [
        -1,
        5
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        1
      ],
      [
        -4,
        -3
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -5
      ],
      [
        -7,
        -9
      ],
      [
        -1,
        2
      ],
      [
        -3,
        0
      ],
      [
        0,
        6
      ],
      [
        -4,
        4
      ],
      [
        -7,
        -5
      ],
      [
        -5,
        -11
      ],
      [
        -5,
        -1
      ],
      [
        -4,
        5
      ],
      [
        -3,
        7
      ],
      [
        -1,
        7
      ],
      [
        -2,
        6
      ],
      [
        1,
        15
      ]
    ],
    [
      [
        17074,
        62424
      ],
      [
        25,
        23
      ]
    ],
    [
      [
        25147,
        68037
      ],
      [
        34,
        0
      ],
      [
        101,
        -3
      ],
      [
        0,
        53
      ]
    ],
    [
      [
        25349,
        68033
      ],
      [
        0,
        -406
      ]
    ],
    [
      [
        25349,
        67627
      ],
      [
        -66,
        1
      ]
    ],
    [
      [
        24507,
        64245
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        -1
      ],
      [
        -5,
        3
      ],
      [
        -9,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -3
      ],
      [
        -4,
        -2
      ],
      [
        -8,
        -7
      ],
      [
        -9,
        -15
      ],
      [
        -3,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -6
      ],
      [
        -4,
        -22
      ],
      [
        -1,
        -10
      ],
      [
        -6,
        -17
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -11
      ],
      [
        1,
        -4
      ],
      [
        1,
        -3
      ],
      [
        2,
        -2
      ],
      [
        1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        1,
        -3
      ],
      [
        4,
        -19
      ],
      [
        0,
        -2
      ],
      [
        1,
        -12
      ],
      [
        0,
        -19
      ],
      [
        -1,
        -11
      ],
      [
        -3,
        -21
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -13
      ],
      [
        1,
        -10
      ],
      [
        1,
        -10
      ],
      [
        1,
        -7
      ],
      [
        0,
        -15
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -2
      ],
      [
        -5,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -4
      ]
    ],
    [
      [
        29250,
        67427
      ],
      [
        77,
        31
      ],
      [
        4,
        -30
      ],
      [
        -2,
        -8
      ],
      [
        7,
        -32
      ],
      [
        -2,
        -9
      ],
      [
        6,
        -27
      ],
      [
        3,
        -2
      ],
      [
        0,
        -34
      ],
      [
        -2,
        -12
      ],
      [
        0,
        -19
      ],
      [
        9,
        1
      ],
      [
        3,
        -7
      ],
      [
        6,
        -25
      ],
      [
        2,
        3
      ],
      [
        5,
        20
      ],
      [
        2,
        29
      ],
      [
        9,
        14
      ],
      [
        5,
        2
      ],
      [
        2,
        -16
      ],
      [
        5,
        6
      ],
      [
        -4,
        15
      ],
      [
        1,
        9
      ],
      [
        6,
        -4
      ],
      [
        2,
        17
      ],
      [
        14,
        2
      ]
    ],
    [
      [
        29408,
        67351
      ],
      [
        1,
        -6
      ],
      [
        -3,
        -38
      ],
      [
        3,
        -5
      ],
      [
        -2,
        -23
      ],
      [
        5,
        -41
      ],
      [
        -2,
        -18
      ],
      [
        1,
        -11
      ],
      [
        -2,
        -16
      ],
      [
        3,
        -20
      ],
      [
        -3,
        -22
      ],
      [
        4,
        -18
      ],
      [
        0,
        -13
      ],
      [
        -1,
        -60
      ],
      [
        -2,
        -7
      ],
      [
        -3,
        -49
      ],
      [
        -4,
        -31
      ],
      [
        -6,
        -13
      ],
      [
        -1,
        -34
      ]
    ],
    [
      [
        29268,
        66975
      ],
      [
        -8,
        199
      ],
      [
        -4,
        116
      ]
    ],
    [
      [
        24221,
        52850
      ],
      [
        24,
        1
      ],
      [
        27,
        0
      ],
      [
        59,
        -2
      ]
    ],
    [
      [
        24348,
        52441
      ],
      [
        5,
        -53
      ],
      [
        4,
        1
      ],
      [
        8,
        -59
      ],
      [
        4,
        -9
      ],
      [
        -37,
        0
      ],
      [
        -16,
        27
      ],
      [
        -15,
        -22
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        1
      ],
      [
        -8,
        18
      ],
      [
        -3,
        -4
      ],
      [
        -1,
        -30
      ],
      [
        -2,
        -15
      ]
    ],
    [
      [
        23140,
        57310
      ],
      [
        58,
        0
      ],
      [
        0,
        -101
      ],
      [
        59,
        1
      ]
    ],
    [
      [
        23168,
        56701
      ],
      [
        -116,
        0
      ]
    ],
    [
      [
        27022,
        62986
      ],
      [
        31,
        -6
      ]
    ],
    [
      [
        27053,
        62980
      ],
      [
        -3,
        -106
      ],
      [
        59,
        -11
      ]
    ],
    [
      [
        26991,
        62576
      ],
      [
        2,
        104
      ],
      [
        -10,
        2
      ],
      [
        2,
        104
      ]
    ],
    [
      [
        25699,
        53993
      ],
      [
        -86,
        -3
      ],
      [
        -8,
        4
      ],
      [
        -72,
        -3
      ]
    ],
    [
      [
        27624,
        63483
      ],
      [
        1,
        30
      ],
      [
        6,
        6
      ],
      [
        5,
        -22
      ],
      [
        5,
        5
      ],
      [
        6,
        25
      ],
      [
        5,
        1
      ],
      [
        5,
        12
      ],
      [
        0,
        5
      ],
      [
        -4,
        15
      ],
      [
        4,
        16
      ],
      [
        -5,
        20
      ],
      [
        9,
        -5
      ],
      [
        7,
        18
      ],
      [
        -4,
        29
      ],
      [
        -7,
        12
      ]
    ],
    [
      [
        27657,
        63650
      ],
      [
        1,
        3
      ],
      [
        26,
        -1
      ],
      [
        10,
        0
      ],
      [
        6,
        -18
      ],
      [
        11,
        1
      ],
      [
        7,
        -19
      ],
      [
        6,
        -17
      ],
      [
        4,
        13
      ],
      [
        8,
        -14
      ],
      [
        4,
        27
      ],
      [
        11,
        10
      ],
      [
        1,
        14
      ],
      [
        3,
        -3
      ],
      [
        6,
        20
      ],
      [
        6,
        4
      ],
      [
        10,
        -16
      ],
      [
        3,
        -17
      ],
      [
        10,
        -15
      ],
      [
        2,
        -14
      ],
      [
        11,
        -19
      ],
      [
        3,
        -35
      ],
      [
        14,
        -4
      ]
    ],
    [
      [
        27689,
        63178
      ],
      [
        -43,
        0
      ]
    ],
    [
      [
        25683,
        56353
      ],
      [
        12,
        18
      ],
      [
        -1,
        42
      ],
      [
        11,
        9
      ],
      [
        2,
        22
      ],
      [
        3,
        -4
      ],
      [
        8,
        21
      ],
      [
        5,
        -11
      ],
      [
        0,
        19
      ],
      [
        8,
        -6
      ],
      [
        0,
        13
      ],
      [
        8,
        12
      ],
      [
        1,
        26
      ],
      [
        5,
        5
      ],
      [
        1,
        13
      ],
      [
        5,
        24
      ],
      [
        5,
        8
      ],
      [
        0,
        25
      ],
      [
        4,
        -2
      ],
      [
        -1,
        6
      ],
      [
        0,
        1
      ],
      [
        -1,
        3
      ],
      [
        0,
        3
      ],
      [
        -1,
        2
      ],
      [
        0,
        4
      ],
      [
        -1,
        2
      ],
      [
        0,
        1
      ],
      [
        -1,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        2
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        0,
        4
      ],
      [
        1,
        2
      ],
      [
        1,
        0
      ],
      [
        0,
        -15
      ],
      [
        1,
        0
      ],
      [
        0,
        3
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        2
      ],
      [
        0,
        1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -3
      ]
    ],
    [
      [
        25765,
        56617
      ],
      [
        0,
        0
      ]
    ],
    [
      [
        25765,
        56617
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        2
      ],
      [
        1,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        18
      ],
      [
        9,
        18
      ],
      [
        6,
        -4
      ],
      [
        2,
        19
      ],
      [
        7,
        40
      ],
      [
        1,
        1
      ],
      [
        6,
        19
      ],
      [
        -3,
        2
      ],
      [
        4,
        43
      ],
      [
        5,
        2
      ],
      [
        1,
        29
      ],
      [
        5,
        -4
      ],
      [
        4,
        13
      ],
      [
        9,
        -1
      ]
    ],
    [
      [
        24792,
        52135
      ],
      [
        2,
        -36
      ],
      [
        -1,
        -16
      ]
    ],
    [
      [
        26319,
        58740
      ],
      [
        5,
        8
      ],
      [
        3,
        15
      ],
      [
        9,
        5
      ],
      [
        4,
        14
      ],
      [
        0,
        11
      ],
      [
        2,
        -9
      ],
      [
        12,
        5
      ],
      [
        3,
        21
      ],
      [
        16,
        19
      ],
      [
        11,
        1
      ],
      [
        18,
        45
      ],
      [
        5,
        19
      ],
      [
        6,
        9
      ]
    ],
    [
      [
        26433,
        58742
      ],
      [
        2,
        -16
      ]
    ],
    [
      [
        26346,
        58432
      ],
      [
        -10,
        1
      ]
    ],
    [
      [
        26307,
        58559
      ],
      [
        -9,
        1
      ],
      [
        2,
        24
      ],
      [
        3,
        5
      ],
      [
        -3,
        18
      ],
      [
        -11,
        23
      ],
      [
        2,
        13
      ]
    ],
    [
      [
        31540,
        38235
      ],
      [
        0,
        -8
      ],
      [
        6,
        -19
      ]
    ],
    [
      [
        21912,
        70421
      ],
      [
        62,
        0
      ],
      [
        29,
        -1
      ],
      [
        29,
        0
      ],
      [
        17,
        -1
      ],
      [
        35,
        0
      ]
    ],
    [
      [
        22129,
        70418
      ],
      [
        1,
        -404
      ]
    ],
    [
      [
        31286,
        37841
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        -1,
        -3
      ]
    ],
    [
      [
        24519,
        52238
      ],
      [
        -31,
        0
      ],
      [
        -16,
        -1
      ],
      [
        -3,
        25
      ],
      [
        -1,
        4
      ],
      [
        -3,
        6
      ],
      [
        -8,
        36
      ],
      [
        -9,
        14
      ],
      [
        0,
        16
      ],
      [
        -10,
        52
      ],
      [
        -8,
        20
      ],
      [
        -7,
        31
      ]
    ],
    [
      [
        25690,
        62890
      ],
      [
        -21,
        0
      ],
      [
        0,
        153
      ]
    ],
    [
      [
        18822,
        67018
      ],
      [
        -100,
        1
      ],
      [
        -32,
        2
      ]
    ],
    [
      [
        24707,
        71654
      ],
      [
        3,
        12
      ],
      [
        0,
        47
      ],
      [
        2,
        15
      ],
      [
        3,
        9
      ],
      [
        6,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        -2
      ],
      [
        1,
        -9
      ],
      [
        -1,
        -8
      ],
      [
        -2,
        -17
      ],
      [
        0,
        -24
      ],
      [
        -3,
        -15
      ],
      [
        -5,
        -8
      ],
      [
        -9,
        -13
      ],
      [
        -1,
        9
      ]
    ],
    [
      [
        24691,
        71507
      ],
      [
        8,
        19
      ],
      [
        13,
        14
      ],
      [
        3,
        -11
      ],
      [
        -8,
        -26
      ],
      [
        -9,
        -10
      ],
      [
        -7,
        14
      ]
    ],
    [
      [
        24655,
        71564
      ],
      [
        5,
        21
      ],
      [
        10,
        11
      ],
      [
        20,
        18
      ],
      [
        1,
        -1
      ],
      [
        3,
        -7
      ],
      [
        1,
        -5
      ],
      [
        -4,
        -25
      ],
      [
        -3,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        -4,
        2
      ],
      [
        -18,
        -16
      ],
      [
        -2,
        2
      ],
      [
        -3,
        13
      ],
      [
        0,
        7
      ]
    ],
    [
      [
        24625,
        71464
      ],
      [
        3,
        27
      ],
      [
        6,
        13
      ],
      [
        14,
        28
      ],
      [
        3,
        -9
      ],
      [
        -2,
        -10
      ],
      [
        -12,
        -20
      ],
      [
        -8,
        -33
      ],
      [
        -3,
        -6
      ],
      [
        -1,
        10
      ]
    ],
    [
      [
        24631,
        71609
      ],
      [
        7,
        -8
      ],
      [
        6,
        -24
      ],
      [
        1,
        -22
      ],
      [
        -13,
        -3
      ],
      [
        -8,
        37
      ],
      [
        7,
        20
      ]
    ],
    [
      [
        24621,
        71679
      ],
      [
        4,
        11
      ],
      [
        21,
        12
      ],
      [
        10,
        13
      ],
      [
        2,
        -16
      ],
      [
        9,
        -39
      ],
      [
        10,
        30
      ],
      [
        4,
        4
      ],
      [
        4,
        -23
      ],
      [
        -2,
        -21
      ],
      [
        -16,
        -9
      ],
      [
        -7,
        -24
      ],
      [
        -10,
        -25
      ],
      [
        -11,
        42
      ],
      [
        -16,
        20
      ],
      [
        -2,
        25
      ]
    ],
    [
      [
        24616,
        71401
      ],
      [
        1,
        1
      ],
      [
        9,
        12
      ],
      [
        7,
        5
      ],
      [
        1,
        4
      ],
      [
        0,
        7
      ],
      [
        2,
        7
      ],
      [
        3,
        5
      ],
      [
        10,
        16
      ],
      [
        5,
        11
      ],
      [
        4,
        12
      ],
      [
        2,
        12
      ],
      [
        4,
        10
      ],
      [
        1,
        2
      ],
      [
        4,
        -2
      ],
      [
        4,
        -17
      ],
      [
        5,
        -10
      ],
      [
        1,
        -3
      ],
      [
        -3,
        -6
      ],
      [
        -2,
        -2
      ],
      [
        -8,
        -3
      ],
      [
        -17,
        -22
      ],
      [
        -2,
        -6
      ],
      [
        -1,
        -10
      ],
      [
        4,
        -6
      ],
      [
        4,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -7
      ],
      [
        -11,
        -8
      ],
      [
        -6,
        4
      ],
      [
        -2,
        -4
      ],
      [
        -4,
        -16
      ],
      [
        -7,
        -15
      ],
      [
        -2,
        -2
      ],
      [
        -5,
        0
      ],
      [
        2,
        23
      ],
      [
        -2,
        10
      ],
      [
        -1,
        4
      ]
    ],
    [
      [
        24579,
        71168
      ],
      [
        2,
        -2
      ],
      [
        3,
        -1
      ],
      [
        1,
        1
      ],
      [
        9,
        21
      ],
      [
        1,
        1
      ],
      [
        11,
        16
      ],
      [
        10,
        10
      ],
      [
        6,
        14
      ],
      [
        5,
        11
      ],
      [
        -1,
        22
      ],
      [
        3,
        6
      ],
      [
        2,
        23
      ],
      [
        1,
        3
      ],
      [
        11,
        -33
      ],
      [
        19,
        -47
      ],
      [
        12,
        -28
      ],
      [
        8,
        -15
      ],
      [
        2,
        -3
      ]
    ],
    [
      [
        27886,
        62061
      ],
      [
        0,
        11
      ],
      [
        1,
        2
      ],
      [
        0,
        9
      ],
      [
        -1,
        3
      ],
      [
        0,
        3
      ],
      [
        2,
        6
      ],
      [
        1,
        2
      ],
      [
        3,
        -2
      ],
      [
        2,
        0
      ],
      [
        0,
        2
      ],
      [
        1,
        7
      ],
      [
        0,
        12
      ],
      [
        1,
        11
      ],
      [
        1,
        2
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        1,
        1
      ],
      [
        0,
        8
      ],
      [
        1,
        7
      ],
      [
        1,
        4
      ],
      [
        0,
        9
      ],
      [
        1,
        3
      ],
      [
        35,
        -101
      ]
    ],
    [
      [
        27972,
        61415
      ],
      [
        -20,
        54
      ],
      [
        -21,
        62
      ],
      [
        -5,
        -3
      ],
      [
        -19,
        44
      ],
      [
        -26,
        60
      ],
      [
        -42,
        99
      ]
    ],
    [
      [
        20348,
        73978
      ],
      [
        17,
        0
      ],
      [
        24,
        1
      ],
      [
        160,
        0
      ],
      [
        1,
        -1
      ],
      [
        9,
        0
      ],
      [
        22,
        1
      ],
      [
        3,
        0
      ],
      [
        58,
        -1
      ]
    ],
    [
      [
        20642,
        73978
      ],
      [
        0,
        -103
      ],
      [
        5,
        0
      ],
      [
        0,
        -303
      ],
      [
        18,
        0
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        31229,
        38430
      ],
      [
        -12,
        -28
      ],
      [
        -7,
        -33
      ],
      [
        -2,
        -22
      ]
    ],
    [
      [
        31200,
        38377
      ],
      [
        1,
        4
      ],
      [
        1,
        6
      ],
      [
        -1,
        18
      ],
      [
        -1,
        16
      ],
      [
        -2,
        15
      ],
      [
        0,
        14
      ],
      [
        1,
        11
      ],
      [
        1,
        1
      ],
      [
        5,
        20
      ],
      [
        1,
        2
      ],
      [
        1,
        0
      ],
      [
        3,
        5
      ],
      [
        6,
        3
      ]
    ],
    [
      [
        31513,
        38417
      ],
      [
        4,
        -7
      ],
      [
        5,
        0
      ],
      [
        2,
        7
      ],
      [
        2,
        9
      ]
    ],
    [
      [
        31290,
        38461
      ],
      [
        4,
        2
      ],
      [
        7,
        4
      ],
      [
        5,
        -2
      ],
      [
        4,
        -8
      ]
    ],
    [
      [
        31294,
        38293
      ],
      [
        4,
        50
      ],
      [
        -1,
        4
      ],
      [
        -3,
        26
      ],
      [
        -1,
        70
      ],
      [
        -3,
        18
      ]
    ],
    [
      [
        23139,
        52124
      ],
      [
        2,
        4
      ],
      [
        37,
        10
      ],
      [
        9,
        0
      ],
      [
        33,
        10
      ]
    ],
    [
      [
        23214,
        51616
      ],
      [
        -35,
        -56
      ],
      [
        -6,
        0
      ],
      [
        0,
        -14
      ],
      [
        -17,
        -1
      ]
    ],
    [
      [
        31580,
        37974
      ],
      [
        -1,
        -13
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        8
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -13
      ],
      [
        0,
        -28
      ],
      [
        -2,
        0
      ],
      [
        -3,
        -4
      ]
    ],
    [
      [
        26305,
        70240
      ],
      [
        1,
        -1
      ],
      [
        2,
        -11
      ],
      [
        1,
        -13
      ],
      [
        10,
        -12
      ],
      [
        0,
        -8
      ],
      [
        10,
        -11
      ],
      [
        11,
        -21
      ],
      [
        9,
        -13
      ],
      [
        5,
        -10
      ],
      [
        0,
        -4
      ],
      [
        4,
        -9
      ],
      [
        12,
        -24
      ],
      [
        6,
        -13
      ],
      [
        4,
        -8
      ],
      [
        5,
        3
      ],
      [
        2,
        11
      ],
      [
        3,
        6
      ],
      [
        3,
        0
      ],
      [
        4,
        -7
      ],
      [
        7,
        -9
      ],
      [
        13,
        10
      ],
      [
        11,
        -13
      ],
      [
        5,
        -9
      ],
      [
        16,
        -12
      ],
      [
        3,
        -9
      ]
    ],
    [
      [
        19321,
        69518
      ],
      [
        0,
        -193
      ]
    ],
    [
      [
        23965,
        52355
      ],
      [
        0,
        203
      ],
      [
        42,
        1
      ],
      [
        0,
        325
      ]
    ],
    [
      [
        25140,
        54451
      ],
      [
        -76,
        0
      ],
      [
        -38,
        -1
      ]
    ],
    [
      [
        24456,
        51930
      ],
      [
        -3,
        42
      ],
      [
        -3,
        9
      ],
      [
        -21,
        0
      ],
      [
        -2,
        8
      ],
      [
        3,
        26
      ],
      [
        -2,
        20
      ],
      [
        -1,
        44
      ],
      [
        -5,
        15
      ],
      [
        4,
        35
      ],
      [
        -9,
        13
      ],
      [
        -15,
        2
      ],
      [
        -7,
        17
      ],
      [
        0,
        19
      ],
      [
        -10,
        43
      ],
      [
        -1,
        23
      ],
      [
        0,
        28
      ],
      [
        -6,
        13
      ],
      [
        5,
        15
      ],
      [
        1,
        19
      ],
      [
        -1,
        23
      ],
      [
        -3,
        17
      ],
      [
        0,
        16
      ],
      [
        -10,
        37
      ],
      [
        -3,
        2
      ],
      [
        -4,
        25
      ]
    ],
    [
      [
        24765,
        59920
      ],
      [
        -22,
        4
      ],
      [
        -4,
        1
      ],
      [
        -91,
        0
      ]
    ],
    [
      [
        28536,
        67395
      ],
      [
        7,
        1
      ],
      [
        4,
        9
      ],
      [
        4,
        16
      ],
      [
        7,
        41
      ],
      [
        4,
        14
      ],
      [
        4,
        7
      ]
    ],
    [
      [
        28661,
        66729
      ],
      [
        3,
        -170
      ],
      [
        0,
        -2
      ]
    ],
    [
      [
        26689,
        57352
      ],
      [
        -10,
        25
      ],
      [
        -4,
        -10
      ],
      [
        -8,
        21
      ],
      [
        -7,
        -17
      ],
      [
        -6,
        -10
      ],
      [
        -7,
        12
      ],
      [
        -3,
        -3
      ],
      [
        -10,
        21
      ],
      [
        -3,
        36
      ],
      [
        1,
        5
      ],
      [
        -5,
        12
      ],
      [
        -3,
        29
      ],
      [
        -4,
        7
      ],
      [
        -4,
        -5
      ],
      [
        -10,
        1
      ]
    ],
    [
      [
        26063,
        52829
      ],
      [
        1,
        33
      ],
      [
        6,
        46
      ],
      [
        7,
        39
      ],
      [
        5,
        8
      ],
      [
        1,
        41
      ],
      [
        8,
        26
      ]
    ],
    [
      [
        31467,
        38261
      ],
      [
        0,
        24
      ],
      [
        1,
        4
      ],
      [
        0,
        17
      ],
      [
        1,
        7
      ],
      [
        0,
        33
      ]
    ],
    [
      [
        25642,
        56884
      ],
      [
        0,
        -17
      ]
    ],
    [
      [
        26202,
        61218
      ],
      [
        -7,
        -20
      ],
      [
        -1,
        -28
      ],
      [
        -11,
        2
      ],
      [
        0,
        -30
      ]
    ],
    [
      [
        26183,
        61142
      ],
      [
        -38,
        -22
      ],
      [
        -21,
        -15
      ],
      [
        -5,
        0
      ],
      [
        -8,
        23
      ],
      [
        -10,
        13
      ],
      [
        -7,
        23
      ]
    ],
    [
      [
        26094,
        61164
      ],
      [
        -8,
        24
      ],
      [
        8,
        59
      ],
      [
        5,
        40
      ],
      [
        10,
        9
      ],
      [
        2,
        16
      ]
    ],
    [
      [
        15682,
        71846
      ],
      [
        0,
        -2
      ],
      [
        2,
        -2
      ],
      [
        11,
        18
      ],
      [
        11,
        -66
      ],
      [
        15,
        -23
      ],
      [
        7,
        1
      ]
    ],
    [
      [
        22851,
        68791
      ],
      [
        2,
        0
      ],
      [
        66,
        1
      ]
    ],
    [
      [
        22919,
        68792
      ],
      [
        120,
        0
      ]
    ],
    [
      [
        22659,
        49740
      ],
      [
        2,
        7
      ],
      [
        -78,
        559
      ],
      [
        24,
        31
      ]
    ],
    [
      [
        28423,
        61914
      ],
      [
        -1,
        7
      ],
      [
        0,
        3
      ],
      [
        -1,
        7
      ],
      [
        0,
        12
      ],
      [
        1,
        16
      ],
      [
        3,
        14
      ],
      [
        4,
        13
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        2,
        5
      ],
      [
        2,
        3
      ]
    ],
    [
      [
        28435,
        61996
      ],
      [
        2,
        -18
      ],
      [
        9,
        -86
      ],
      [
        7,
        35
      ],
      [
        6,
        10
      ],
      [
        9,
        7
      ],
      [
        15,
        -9
      ],
      [
        14,
        6
      ],
      [
        29,
        -45
      ],
      [
        3,
        -2
      ],
      [
        2,
        -28
      ],
      [
        0,
        -41
      ],
      [
        11,
        -15
      ],
      [
        0,
        -4
      ],
      [
        7,
        -8
      ]
    ],
    [
      [
        28501,
        61588
      ],
      [
        -2,
        4
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -10
      ],
      [
        -2,
        -14
      ],
      [
        3,
        -8
      ],
      [
        2,
        -13
      ],
      [
        2,
        -16
      ],
      [
        1,
        -13
      ],
      [
        2,
        -18
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -13
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        2
      ],
      [
        -5,
        15
      ],
      [
        -1,
        0
      ],
      [
        -5,
        9
      ],
      [
        -7,
        13
      ],
      [
        -3,
        4
      ],
      [
        0,
        23
      ],
      [
        -1,
        4
      ],
      [
        0,
        1
      ],
      [
        -1,
        6
      ],
      [
        -4,
        10
      ],
      [
        -3,
        4
      ],
      [
        -6,
        17
      ],
      [
        -3,
        18
      ],
      [
        -1,
        37
      ],
      [
        -3,
        17
      ],
      [
        -1,
        15
      ],
      [
        -4,
        27
      ],
      [
        -6,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -1
      ],
      [
        -9,
        -21
      ],
      [
        -3,
        -12
      ],
      [
        -1,
        -8
      ],
      [
        -5,
        -2
      ],
      [
        -1,
        4
      ],
      [
        -3,
        2
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -10
      ],
      [
        -14,
        -31
      ],
      [
        -6,
        -7
      ],
      [
        -2,
        4
      ],
      [
        -10,
        23
      ],
      [
        -4,
        37
      ],
      [
        1,
        16
      ],
      [
        0,
        9
      ],
      [
        -4,
        53
      ],
      [
        3,
        36
      ],
      [
        3,
        15
      ],
      [
        2,
        16
      ],
      [
        3,
        15
      ],
      [
        3,
        3
      ],
      [
        1,
        1
      ],
      [
        3,
        16
      ],
      [
        8,
        37
      ],
      [
        4,
        7
      ],
      [
        5,
        -2
      ],
      [
        6,
        11
      ],
      [
        1,
        6
      ],
      [
        4,
        8
      ],
      [
        1,
        9
      ],
      [
        -1,
        0
      ],
      [
        -5,
        1
      ]
    ],
    [
      [
        28511,
        65354
      ],
      [
        10,
        -4
      ],
      [
        155,
        -53
      ]
    ],
    [
      [
        23494,
        55334
      ],
      [
        -9,
        24
      ],
      [
        -3,
        14
      ],
      [
        -8,
        12
      ],
      [
        -3,
        19
      ],
      [
        -5,
        10
      ],
      [
        -2,
        22
      ],
      [
        -2,
        5
      ],
      [
        -10,
        -2
      ],
      [
        -12,
        5
      ],
      [
        -8,
        -8
      ],
      [
        -5,
        -17
      ],
      [
        -5,
        -4
      ],
      [
        -4,
        -16
      ],
      [
        -6,
        -8
      ],
      [
        -3,
        4
      ]
    ],
    [
      [
        25805,
        58095
      ],
      [
        10,
        8
      ],
      [
        4,
        -27
      ],
      [
        9,
        -20
      ],
      [
        6,
        -3
      ],
      [
        2,
        7
      ],
      [
        1,
        26
      ],
      [
        11,
        1
      ],
      [
        3,
        17
      ],
      [
        4,
        -1
      ],
      [
        5,
        18
      ],
      [
        9,
        18
      ],
      [
        2,
        17
      ],
      [
        9,
        6
      ]
    ],
    [
      [
        25863,
        57830
      ],
      [
        -8,
        3
      ],
      [
        -1,
        20
      ],
      [
        -5,
        -21
      ],
      [
        0,
        50
      ],
      [
        -7,
        74
      ],
      [
        -4,
        3
      ],
      [
        -2,
        -11
      ],
      [
        -3,
        15
      ],
      [
        3,
        5
      ],
      [
        1,
        16
      ],
      [
        -4,
        0
      ],
      [
        -3,
        19
      ],
      [
        -7,
        11
      ],
      [
        0,
        9
      ],
      [
        -15,
        21
      ],
      [
        -3,
        1
      ],
      [
        -4,
        28
      ],
      [
        4,
        22
      ]
    ],
    [
      [
        23001,
        56396
      ],
      [
        2,
        16
      ],
      [
        -4,
        41
      ],
      [
        6,
        24
      ],
      [
        -3,
        12
      ],
      [
        -2,
        -4
      ],
      [
        -6,
        22
      ],
      [
        -3,
        22
      ],
      [
        6,
        -2
      ],
      [
        3,
        11
      ],
      [
        3,
        -12
      ],
      [
        3,
        17
      ],
      [
        -1,
        19
      ],
      [
        8,
        31
      ],
      [
        -4,
        11
      ],
      [
        -1,
        19
      ],
      [
        -6,
        28
      ]
    ],
    [
      [
        23208,
        56333
      ],
      [
        -1,
        5
      ],
      [
        -2,
        8
      ],
      [
        -7,
        10
      ],
      [
        -1,
        4
      ],
      [
        -2,
        5
      ],
      [
        -3,
        8
      ],
      [
        -3,
        7
      ],
      [
        -2,
        3
      ],
      [
        -4,
        4
      ],
      [
        0,
        -19
      ],
      [
        -1,
        -11
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -3
      ],
      [
        -6,
        -1
      ],
      [
        -2,
        3
      ],
      [
        -1,
        6
      ],
      [
        -2,
        3
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -15
      ],
      [
        -2,
        -7
      ],
      [
        -4,
        -5
      ],
      [
        -1,
        1
      ],
      [
        0,
        11
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -1
      ],
      [
        -2,
        -12
      ],
      [
        -3,
        -5
      ],
      [
        -2,
        2
      ],
      [
        -2,
        4
      ],
      [
        -6,
        6
      ],
      [
        -5,
        1
      ],
      [
        0,
        -4
      ],
      [
        1,
        -2
      ],
      [
        0,
        -14
      ],
      [
        -2,
        0
      ],
      [
        -1,
        2
      ],
      [
        -3,
        7
      ],
      [
        -1,
        2
      ],
      [
        -4,
        -1
      ],
      [
        -3,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -15
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        0
      ],
      [
        -4,
        -3
      ],
      [
        0,
        -11
      ],
      [
        1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -9
      ],
      [
        -2,
        -21
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -4
      ],
      [
        -3,
        -4
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        -6,
        -6
      ],
      [
        -2,
        1
      ],
      [
        -6,
        13
      ],
      [
        -6,
        11
      ],
      [
        -2,
        1
      ],
      [
        -4,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -12
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -11
      ],
      [
        0,
        -25
      ],
      [
        -1,
        -11
      ],
      [
        -2,
        -13
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -6,
        -9
      ],
      [
        -2,
        -1
      ],
      [
        -2,
        1
      ],
      [
        -2,
        6
      ],
      [
        0,
        10
      ],
      [
        -1,
        12
      ],
      [
        -1,
        7
      ],
      [
        -2,
        10
      ]
    ],
    [
      [
        23060,
        56199
      ],
      [
        -2,
        5
      ],
      [
        -5,
        19
      ],
      [
        -1,
        6
      ],
      [
        -2,
        7
      ],
      [
        -1,
        10
      ],
      [
        0,
        3
      ],
      [
        -1,
        5
      ],
      [
        0,
        4
      ],
      [
        -2,
        3
      ],
      [
        -2,
        1
      ],
      [
        -3,
        1
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -1
      ],
      [
        -7,
        -3
      ],
      [
        -4,
        0
      ],
      [
        -1,
        1
      ],
      [
        -2,
        9
      ],
      [
        -1,
        7
      ],
      [
        0,
        13
      ],
      [
        -1,
        5
      ],
      [
        0,
        10
      ],
      [
        -2,
        8
      ],
      [
        0,
        3
      ],
      [
        -2,
        2
      ],
      [
        -5,
        -4
      ],
      [
        -4,
        -1
      ],
      [
        -2,
        1
      ],
      [
        -4,
        10
      ],
      [
        -2,
        3
      ],
      [
        -2,
        4
      ],
      [
        -6,
        9
      ],
      [
        -2,
        4
      ],
      [
        0,
        8
      ],
      [
        1,
        5
      ],
      [
        4,
        15
      ],
      [
        3,
        4
      ],
      [
        1,
        3
      ],
      [
        2,
        6
      ],
      [
        1,
        5
      ],
      [
        0,
        12
      ],
      [
        -1,
        0
      ]
    ],
    [
      [
        26310,
        52211
      ],
      [
        3,
        23
      ],
      [
        -4,
        16
      ],
      [
        9,
        20
      ],
      [
        1,
        21
      ],
      [
        10,
        23
      ]
    ],
    [
      [
        25251,
        56111
      ],
      [
        4,
        -7
      ],
      [
        -1,
        -36
      ],
      [
        8,
        -11
      ],
      [
        -6,
        -28
      ],
      [
        1,
        -43
      ],
      [
        6,
        -18
      ],
      [
        -3,
        -5
      ],
      [
        -12,
        33
      ],
      [
        -1,
        -6
      ],
      [
        -4,
        -23
      ],
      [
        -9,
        -8
      ],
      [
        -1,
        3
      ],
      [
        -6,
        -17
      ],
      [
        -9,
        -1
      ],
      [
        -11,
        -1
      ]
    ],
    [
      [
        25110,
        56009
      ],
      [
        0,
        85
      ],
      [
        -4,
        -2
      ],
      [
        0,
        123
      ]
    ],
    [
      [
        23432,
        63654
      ],
      [
        3,
        -25
      ],
      [
        -3,
        -7
      ],
      [
        0,
        -28
      ],
      [
        -5,
        -10
      ],
      [
        5,
        -9
      ],
      [
        3,
        -16
      ],
      [
        6,
        -2
      ],
      [
        2,
        -23
      ],
      [
        -2,
        -13
      ],
      [
        2,
        -42
      ],
      [
        2,
        -9
      ],
      [
        2,
        -34
      ],
      [
        -5,
        -24
      ],
      [
        4,
        -8
      ],
      [
        0,
        -20
      ]
    ],
    [
      [
        28051,
        67098
      ],
      [
        0,
        -257
      ]
    ],
    [
      [
        27864,
        66494
      ],
      [
        2,
        23
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        2,
        14
      ],
      [
        1,
        9
      ],
      [
        9,
        31
      ],
      [
        1,
        0
      ],
      [
        3,
        5
      ],
      [
        0,
        28
      ],
      [
        4,
        24
      ],
      [
        8,
        14
      ],
      [
        4,
        4
      ],
      [
        4,
        1
      ],
      [
        6,
        14
      ],
      [
        7,
        17
      ],
      [
        7,
        6
      ],
      [
        14,
        38
      ],
      [
        5,
        16
      ],
      [
        0,
        9
      ],
      [
        -1,
        10
      ],
      [
        -1,
        1
      ],
      [
        -1,
        5
      ],
      [
        0,
        9
      ],
      [
        -1,
        16
      ],
      [
        2,
        10
      ],
      [
        0,
        7
      ],
      [
        -2,
        13
      ],
      [
        -2,
        1
      ],
      [
        -3,
        16
      ],
      [
        -2,
        21
      ],
      [
        -6,
        2
      ],
      [
        2,
        15
      ],
      [
        0,
        28
      ],
      [
        -1,
        11
      ],
      [
        -1,
        5
      ],
      [
        -2,
        11
      ],
      [
        -3,
        10
      ],
      [
        -9,
        3
      ],
      [
        -3,
        12
      ],
      [
        -11,
        20
      ],
      [
        -2,
        11
      ],
      [
        0,
        22
      ],
      [
        2,
        18
      ],
      [
        2,
        21
      ],
      [
        0,
        11
      ],
      [
        -1,
        9
      ],
      [
        -3,
        2
      ]
    ],
    [
      [
        26992,
        61441
      ],
      [
        0,
        -21
      ],
      [
        -4,
        -6
      ],
      [
        2,
        -42
      ],
      [
        -4,
        -29
      ],
      [
        8,
        -13
      ],
      [
        -2,
        -16
      ],
      [
        1,
        -14
      ],
      [
        6,
        -12
      ],
      [
        1,
        -25
      ],
      [
        8,
        -9
      ],
      [
        1,
        -22
      ],
      [
        3,
        -4
      ],
      [
        -3,
        -26
      ],
      [
        -4,
        -4
      ],
      [
        -16,
        -55
      ],
      [
        -4,
        -21
      ],
      [
        -4,
        -13
      ]
    ],
    [
      [
        20545,
        71862
      ],
      [
        22,
        0
      ],
      [
        0,
        -237
      ],
      [
        36,
        0
      ],
      [
        0,
        -68
      ],
      [
        36,
        0
      ],
      [
        0,
        -16
      ],
      [
        5,
        0
      ],
      [
        0,
        -17
      ],
      [
        6,
        0
      ],
      [
        0,
        -34
      ],
      [
        118,
        -1
      ]
    ],
    [
      [
        25506,
        53023
      ],
      [
        8,
        1
      ],
      [
        6,
        0
      ],
      [
        8,
        -1
      ],
      [
        11,
        1
      ],
      [
        63,
        0
      ],
      [
        5,
        -2
      ],
      [
        2,
        0
      ],
      [
        1,
        1
      ],
      [
        17,
        2
      ]
    ],
    [
      [
        25695,
        52293
      ],
      [
        -65,
        -49
      ],
      [
        -15,
        -8
      ],
      [
        -17,
        -7
      ],
      [
        -4,
        4
      ],
      [
        -3,
        6
      ],
      [
        -7,
        -7
      ],
      [
        -9,
        -6
      ],
      [
        -19,
        -18
      ],
      [
        -28,
        -20
      ]
    ],
    [
      [
        26885,
        54787
      ],
      [
        -2,
        -7
      ],
      [
        6,
        -12
      ],
      [
        -3,
        -32
      ],
      [
        -5,
        -10
      ],
      [
        -6,
        0
      ],
      [
        -2,
        -20
      ],
      [
        -3,
        -13
      ],
      [
        2,
        -17
      ],
      [
        -2,
        -23
      ],
      [
        -3,
        -7
      ],
      [
        -5,
        -35
      ],
      [
        -5,
        -38
      ],
      [
        8,
        -23
      ]
    ],
    [
      [
        23994,
        66887
      ],
      [
        131,
        0
      ]
    ],
    [
      [
        16006,
        69623
      ],
      [
        60,
        0
      ],
      [
        0,
        305
      ],
      [
        11,
        0
      ],
      [
        0,
        207
      ]
    ],
    [
      [
        16224,
        70069
      ],
      [
        0,
        -7
      ],
      [
        1,
        -3
      ],
      [
        1,
        -7
      ],
      [
        0,
        -2
      ],
      [
        1,
        -4
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -5
      ],
      [
        2,
        -4
      ],
      [
        1,
        -2
      ],
      [
        1,
        -6
      ],
      [
        0,
        -10
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -15
      ],
      [
        1,
        -4
      ],
      [
        1,
        -5
      ],
      [
        0,
        -5
      ],
      [
        1,
        -5
      ],
      [
        1,
        0
      ],
      [
        2,
        -4
      ],
      [
        0,
        -8
      ],
      [
        2,
        -6
      ],
      [
        1,
        0
      ],
      [
        2,
        2
      ],
      [
        2,
        -2
      ],
      [
        2,
        -4
      ],
      [
        0,
        -2
      ],
      [
        2,
        -3
      ],
      [
        2,
        -4
      ],
      [
        3,
        0
      ],
      [
        1,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        1,
        -4
      ],
      [
        1,
        -6
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -7
      ],
      [
        0,
        -4
      ],
      [
        1,
        -8
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        -4,
        -4
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -8
      ],
      [
        2,
        -7
      ],
      [
        1,
        -2
      ],
      [
        1,
        -5
      ],
      [
        0,
        -2
      ],
      [
        -2,
        0
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -18
      ],
      [
        1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        0
      ],
      [
        -2,
        4
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -7
      ],
      [
        -4,
        0
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -9
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        -7
      ],
      [
        2,
        -2
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        2
      ],
      [
        -2,
        5
      ],
      [
        -1,
        -5
      ],
      [
        1,
        -1
      ],
      [
        0,
        -9
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -10
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        1
      ],
      [
        -1,
        5
      ],
      [
        1,
        4
      ],
      [
        0,
        2
      ],
      [
        -1,
        3
      ],
      [
        -1,
        2
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -8
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        2
      ],
      [
        -2,
        0
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -12
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -3
      ],
      [
        1,
        1
      ],
      [
        1,
        -1
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -3
      ],
      [
        0,
        -47
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        1,
        -1
      ],
      [
        1,
        0
      ],
      [
        0,
        -5
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        1,
        1
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        1,
        1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        1,
        -1
      ],
      [
        1,
        0
      ],
      [
        1,
        -4
      ],
      [
        0,
        -2
      ],
      [
        1,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        -2
      ],
      [
        1,
        0
      ],
      [
        1,
        -2
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        0,
        6
      ],
      [
        1,
        1
      ],
      [
        1,
        -2
      ],
      [
        1,
        0
      ],
      [
        0,
        -2
      ],
      [
        1,
        1
      ],
      [
        2,
        2
      ],
      [
        0,
        2
      ],
      [
        1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        2,
        2
      ],
      [
        0,
        1
      ],
      [
        1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        1,
        1
      ],
      [
        0,
        1
      ],
      [
        1,
        1
      ],
      [
        2,
        0
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        1,
        1
      ],
      [
        1,
        -2
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        2,
        -1
      ],
      [
        1,
        0
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        2,
        -2
      ],
      [
        0,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        1,
        -4
      ],
      [
        2,
        -4
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        1,
        -3
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        1,
        1
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        0
      ],
      [
        1,
        -2
      ],
      [
        1,
        1
      ],
      [
        1,
        -1
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        1,
        0
      ],
      [
        1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        1,
        -1
      ],
      [
        0,
        -5
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        1,
        -1
      ],
      [
        1,
        -4
      ],
      [
        1,
        -3
      ],
      [
        1,
        -2
      ],
      [
        1,
        0
      ],
      [
        1,
        -2
      ],
      [
        2,
        -2
      ],
      [
        0,
        -7
      ],
      [
        1,
        -4
      ],
      [
        0,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -11
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -14
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        2,
        -1
      ],
      [
        61,
        0
      ]
    ],
    [
      [
        16341,
        69402
      ],
      [
        3,
        -14
      ],
      [
        -1,
        -58
      ],
      [
        3,
        -30
      ],
      [
        -3,
        -34
      ],
      [
        4,
        -18
      ],
      [
        1,
        -26
      ],
      [
        5,
        -5
      ],
      [
        4,
        -17
      ],
      [
        -6,
        -15
      ],
      [
        1,
        -18
      ],
      [
        12,
        -17
      ],
      [
        3,
        -25
      ],
      [
        8,
        -10
      ]
    ],
    [
      [
        22752,
        66341
      ],
      [
        0,
        480
      ]
    ],
    [
      [
        29849,
        67214
      ],
      [
        27,
        22
      ],
      [
        16,
        -107
      ],
      [
        34,
        29
      ],
      [
        18,
        14
      ],
      [
        8,
        -114
      ],
      [
        34,
        17
      ],
      [
        2,
        -22
      ],
      [
        6,
        2
      ],
      [
        4,
        -19
      ],
      [
        6,
        10
      ],
      [
        4,
        -30
      ],
      [
        13,
        -10
      ]
    ],
    [
      [
        30059,
        66688
      ],
      [
        -3,
        -12
      ],
      [
        -3,
        -17
      ],
      [
        -4,
        -17
      ],
      [
        -10,
        0
      ],
      [
        -7,
        1
      ],
      [
        -4,
        1
      ],
      [
        -5,
        0
      ],
      [
        -13,
        2
      ],
      [
        -7,
        0
      ],
      [
        -3,
        1
      ],
      [
        -8,
        0
      ],
      [
        -13,
        2
      ],
      [
        -24,
        2
      ],
      [
        -2,
        0
      ],
      [
        -4,
        1
      ],
      [
        -26,
        2
      ],
      [
        -8,
        1
      ],
      [
        -9,
        1
      ],
      [
        -26,
        3
      ]
    ],
    [
      [
        29872,
        66660
      ],
      [
        -5,
        89
      ],
      [
        -8,
        1
      ],
      [
        -3,
        51
      ],
      [
        -4,
        100
      ],
      [
        -1,
        13
      ],
      [
        -1,
        15
      ],
      [
        -15,
        2
      ],
      [
        0,
        24
      ],
      [
        1,
        46
      ],
      [
        0,
        16
      ],
      [
        4,
        74
      ],
      [
        2,
        49
      ],
      [
        -1,
        5
      ]
    ],
    [
      [
        27110,
        54946
      ],
      [
        -7,
        16
      ],
      [
        -1,
        12
      ],
      [
        1,
        9
      ],
      [
        28,
        266
      ]
    ],
    [
      [
        28845,
        61499
      ],
      [
        2,
        -35
      ],
      [
        9,
        -44
      ],
      [
        4,
        -13
      ],
      [
        4,
        -24
      ],
      [
        -1,
        -18
      ],
      [
        -8,
        -23
      ],
      [
        10,
        -40
      ],
      [
        0,
        -23
      ],
      [
        -8,
        -5
      ],
      [
        -3,
        -20
      ],
      [
        -10,
        5
      ],
      [
        -1,
        -21
      ],
      [
        -5,
        -11
      ],
      [
        -5,
        9
      ],
      [
        -1,
        -8
      ],
      [
        1,
        -19
      ],
      [
        5,
        -8
      ],
      [
        4,
        -33
      ]
    ],
    [
      [
        28830,
        61117
      ],
      [
        1,
        7
      ],
      [
        0,
        7
      ],
      [
        -2,
        5
      ],
      [
        -4,
        1
      ],
      [
        -8,
        10
      ],
      [
        -2,
        -3
      ],
      [
        0,
        -3
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        0
      ],
      [
        -3,
        6
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ],
      [
        -5,
        2
      ],
      [
        -2,
        1
      ],
      [
        -7,
        -21
      ],
      [
        -3,
        -10
      ],
      [
        -3,
        -9
      ],
      [
        -1,
        -6
      ],
      [
        -4,
        -10
      ],
      [
        -4,
        -8
      ],
      [
        -6,
        -6
      ],
      [
        0,
        -1
      ],
      [
        -3,
        6
      ],
      [
        -1,
        9
      ],
      [
        1,
        7
      ],
      [
        0,
        11
      ],
      [
        1,
        17
      ],
      [
        -2,
        23
      ],
      [
        4,
        33
      ],
      [
        2,
        10
      ],
      [
        0,
        19
      ],
      [
        1,
        8
      ],
      [
        1,
        1
      ],
      [
        3,
        4
      ],
      [
        2,
        -3
      ],
      [
        0,
        -3
      ],
      [
        1,
        1
      ],
      [
        3,
        5
      ],
      [
        2,
        4
      ],
      [
        0,
        1
      ],
      [
        1,
        4
      ],
      [
        4,
        14
      ],
      [
        -2,
        9
      ],
      [
        -7,
        7
      ],
      [
        -4,
        -6
      ],
      [
        -1,
        -2
      ],
      [
        1,
        -6
      ],
      [
        -3,
        -2
      ],
      [
        -1,
        0
      ],
      [
        0,
        2
      ],
      [
        -2,
        17
      ],
      [
        2,
        16
      ],
      [
        2,
        12
      ],
      [
        0,
        2
      ],
      [
        2,
        4
      ],
      [
        4,
        10
      ],
      [
        2,
        1
      ],
      [
        0,
        1
      ],
      [
        3,
        22
      ],
      [
        -5,
        13
      ],
      [
        -2,
        0
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -6
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        3
      ],
      [
        -6,
        5
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -4,
        -9
      ],
      [
        -4,
        -7
      ],
      [
        0,
        -16
      ],
      [
        -2,
        3
      ],
      [
        -1,
        6
      ],
      [
        -3,
        22
      ],
      [
        2,
        29
      ],
      [
        1,
        7
      ],
      [
        0,
        3
      ],
      [
        -1,
        7
      ],
      [
        0,
        2
      ],
      [
        3,
        10
      ],
      [
        15,
        20
      ],
      [
        0,
        -1
      ],
      [
        1,
        -4
      ],
      [
        2,
        -2
      ],
      [
        3,
        3
      ],
      [
        5,
        11
      ],
      [
        0,
        1
      ],
      [
        -1,
        18
      ],
      [
        -2,
        8
      ],
      [
        -2,
        6
      ]
    ],
    [
      [
        28725,
        61120
      ],
      [
        -1,
        35
      ],
      [
        0,
        37
      ],
      [
        1,
        12
      ],
      [
        1,
        8
      ],
      [
        6,
        8
      ],
      [
        3,
        -3
      ],
      [
        2,
        -13
      ],
      [
        4,
        -4
      ],
      [
        2,
        -20
      ],
      [
        -1,
        -19
      ],
      [
        -3,
        -16
      ],
      [
        2,
        -17
      ],
      [
        -2,
        -8
      ]
    ],
    [
      [
        28729,
        61346
      ],
      [
        2,
        -16
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        1,
        1
      ],
      [
        0,
        -11
      ],
      [
        -2,
        -6
      ],
      [
        0,
        -11
      ],
      [
        3,
        -14
      ],
      [
        1,
        -22
      ],
      [
        -2,
        -5
      ],
      [
        -3,
        -2
      ],
      [
        -4,
        7
      ],
      [
        -6,
        21
      ],
      [
        0,
        1
      ],
      [
        3,
        14
      ],
      [
        0,
        1
      ],
      [
        2,
        1
      ],
      [
        0,
        5
      ],
      [
        -1,
        5
      ],
      [
        -1,
        3
      ]
    ],
    [
      [
        28921,
        61701
      ],
      [
        19,
        -1
      ],
      [
        62,
        0
      ]
    ],
    [
      [
        29002,
        61700
      ],
      [
        -1,
        -43
      ],
      [
        -2,
        -29
      ],
      [
        -3,
        -40
      ],
      [
        -4,
        -36
      ],
      [
        0,
        -2
      ],
      [
        -2,
        1
      ],
      [
        -3,
        -14
      ],
      [
        -3,
        -43
      ],
      [
        -8,
        -63
      ],
      [
        -4,
        -42
      ],
      [
        0,
        -3
      ],
      [
        -5,
        -60
      ],
      [
        -5,
        -40
      ],
      [
        -6,
        -40
      ],
      [
        -7,
        -40
      ]
    ],
    [
      [
        21232,
        73979
      ],
      [
        25,
        0
      ],
      [
        176,
        -1
      ],
      [
        55,
        0
      ]
    ],
    [
      [
        25611,
        65393
      ],
      [
        10,
        7
      ],
      [
        7,
        9
      ],
      [
        0,
        9
      ],
      [
        10,
        6
      ],
      [
        1,
        -6
      ],
      [
        15,
        19
      ],
      [
        11,
        15
      ],
      [
        26,
        41
      ],
      [
        1,
        1
      ]
    ],
    [
      [
        25692,
        65494
      ],
      [
        0,
        -552
      ]
    ],
    [
      [
        25692,
        64942
      ],
      [
        -10,
        -20
      ],
      [
        -12,
        25
      ],
      [
        -14,
        33
      ],
      [
        -17,
        20
      ],
      [
        -3,
        0
      ],
      [
        -17,
        -24
      ],
      [
        -7,
        -28
      ]
    ],
    [
      [
        28766,
        66751
      ],
      [
        2,
        -78
      ]
    ],
    [
      [
        17451,
        67333
      ],
      [
        -1,
        196
      ],
      [
        11,
        0
      ],
      [
        0,
        204
      ],
      [
        -11,
        0
      ],
      [
        0,
        201
      ]
    ],
    [
      [
        24938,
        64636
      ],
      [
        -97,
        1
      ]
    ],
    [
      [
        22042,
        72032
      ],
      [
        154,
        0
      ]
    ],
    [
      [
        22074,
        71224
      ],
      [
        -46,
        0
      ]
    ],
    [
      [
        22028,
        71224
      ],
      [
        2,
        304
      ],
      [
        0,
        101
      ],
      [
        -11,
        1
      ],
      [
        0,
        402
      ]
    ],
    [
      [
        27111,
        59928
      ],
      [
        5,
        21
      ],
      [
        11,
        13
      ]
    ],
    [
      [
        26876,
        56052
      ],
      [
        8,
        -4
      ],
      [
        1,
        15
      ]
    ],
    [
      [
        26511,
        61866
      ],
      [
        6,
        -8
      ],
      [
        3,
        -63
      ],
      [
        8,
        -47
      ]
    ],
    [
      [
        4587,
        90956
      ],
      [
        11,
        22
      ],
      [
        8,
        22
      ],
      [
        8,
        4
      ],
      [
        8,
        10
      ],
      [
        5,
        2
      ],
      [
        8,
        -7
      ],
      [
        4,
        -9
      ],
      [
        12,
        -1
      ],
      [
        4,
        2
      ],
      [
        2,
        3
      ],
      [
        2,
        5
      ],
      [
        0,
        2
      ],
      [
        -1,
        2
      ],
      [
        1,
        4
      ],
      [
        7,
        -2
      ],
      [
        7,
        -10
      ],
      [
        9,
        -37
      ],
      [
        -1,
        -50
      ],
      [
        -9,
        -9
      ],
      [
        -11,
        4
      ],
      [
        -15,
        0
      ],
      [
        -23,
        -7
      ],
      [
        -2,
        -5
      ],
      [
        -15,
        4
      ],
      [
        -17,
        18
      ],
      [
        -1,
        1
      ],
      [
        -8,
        24
      ],
      [
        7,
        8
      ]
    ],
    [
      [
        3078,
        92568
      ],
      [
        5,
        7
      ],
      [
        2,
        6
      ],
      [
        7,
        3
      ],
      [
        0,
        -25
      ],
      [
        -9,
        -3
      ],
      [
        -5,
        7
      ],
      [
        0,
        5
      ]
    ],
    [
      [
        4612,
        90593
      ],
      [
        6,
        15
      ],
      [
        38,
        108
      ],
      [
        1,
        5
      ],
      [
        2,
        13
      ],
      [
        -1,
        9
      ],
      [
        2,
        9
      ],
      [
        10,
        31
      ],
      [
        9,
        22
      ],
      [
        14,
        22
      ],
      [
        9,
        17
      ],
      [
        1,
        3
      ],
      [
        0,
        5
      ],
      [
        -6,
        37
      ],
      [
        -4,
        13
      ],
      [
        2,
        3
      ],
      [
        12,
        2
      ],
      [
        17,
        -14
      ],
      [
        11,
        -14
      ],
      [
        8,
        -6
      ],
      [
        4,
        -1
      ],
      [
        10,
        2
      ],
      [
        9,
        -28
      ],
      [
        -1,
        -16
      ],
      [
        -2,
        -3
      ],
      [
        0,
        -3
      ],
      [
        3,
        -14
      ],
      [
        4,
        -13
      ],
      [
        27,
        -3
      ],
      [
        25,
        3
      ],
      [
        21,
        7
      ],
      [
        16,
        12
      ],
      [
        8,
        1
      ],
      [
        24,
        -12
      ],
      [
        2,
        -8
      ],
      [
        9,
        2
      ],
      [
        28,
        9
      ],
      [
        40,
        17
      ],
      [
        33,
        22
      ],
      [
        15,
        16
      ],
      [
        1,
        3
      ],
      [
        4,
        30
      ],
      [
        4,
        18
      ],
      [
        19,
        37
      ],
      [
        31,
        76
      ],
      [
        6,
        15
      ],
      [
        26,
        85
      ],
      [
        7,
        26
      ],
      [
        5,
        24
      ],
      [
        1,
        23
      ],
      [
        -1,
        48
      ],
      [
        -6,
        40
      ],
      [
        -6,
        41
      ],
      [
        -12,
        58
      ],
      [
        -7,
        27
      ],
      [
        -4,
        10
      ],
      [
        -12,
        74
      ],
      [
        -5,
        47
      ],
      [
        -1,
        56
      ],
      [
        0,
        62
      ],
      [
        1,
        7
      ],
      [
        2,
        8
      ],
      [
        -8,
        37
      ],
      [
        -71,
        157
      ],
      [
        -9,
        32
      ],
      [
        -14,
        3
      ],
      [
        -27,
        25
      ],
      [
        -15,
        -3
      ],
      [
        -2,
        -1
      ],
      [
        -6,
        -13
      ],
      [
        -4,
        18
      ],
      [
        7,
        73
      ],
      [
        3,
        24
      ],
      [
        23,
        30
      ],
      [
        4,
        3
      ],
      [
        3,
        -9
      ],
      [
        3,
        -7
      ],
      [
        8,
        -9
      ],
      [
        25,
        -15
      ],
      [
        10,
        -5
      ],
      [
        12,
        -2
      ],
      [
        21,
        -1
      ],
      [
        15,
        7
      ],
      [
        3,
        3
      ],
      [
        0,
        6
      ],
      [
        -1,
        11
      ],
      [
        -5,
        6
      ],
      [
        -3,
        3
      ],
      [
        -2,
        4
      ],
      [
        -1,
        5
      ],
      [
        1,
        6
      ],
      [
        1,
        4
      ],
      [
        16,
        0
      ],
      [
        6,
        3
      ],
      [
        9,
        7
      ],
      [
        38,
        71
      ],
      [
        3,
        10
      ],
      [
        0,
        4
      ],
      [
        2,
        67
      ],
      [
        0,
        43
      ],
      [
        -24,
        78
      ],
      [
        -18,
        44
      ],
      [
        -14,
        14
      ],
      [
        -26,
        41
      ],
      [
        -7,
        13
      ],
      [
        -8,
        21
      ],
      [
        -5,
        16
      ],
      [
        0,
        5
      ],
      [
        1,
        5
      ],
      [
        -8,
        7
      ],
      [
        -5,
        -6
      ],
      [
        0,
        -4
      ],
      [
        -2,
        -14
      ],
      [
        0,
        -9
      ],
      [
        1,
        -5
      ],
      [
        -5,
        -13
      ],
      [
        -14,
        -24
      ],
      [
        -8,
        -11
      ],
      [
        -9,
        -27
      ],
      [
        -9,
        -28
      ],
      [
        -2,
        -14
      ],
      [
        0,
        -17
      ],
      [
        -3,
        -7
      ],
      [
        -10,
        -12
      ],
      [
        -5,
        -4
      ],
      [
        -24,
        -7
      ],
      [
        -22,
        13
      ],
      [
        -10,
        8
      ],
      [
        -4,
        6
      ],
      [
        -6,
        15
      ],
      [
        -59,
        -93
      ],
      [
        -6,
        -7
      ],
      [
        -11,
        -5
      ],
      [
        -44,
        -9
      ],
      [
        -11,
        -6
      ],
      [
        -9,
        -7
      ],
      [
        -5,
        -9
      ],
      [
        -8,
        -19
      ],
      [
        -1,
        -14
      ],
      [
        -4,
        -29
      ],
      [
        -10,
        -12
      ],
      [
        -6,
        -4
      ],
      [
        -14,
        -15
      ],
      [
        -55,
        -72
      ],
      [
        -4,
        -12
      ],
      [
        -17,
        -58
      ],
      [
        0,
        -4
      ],
      [
        4,
        -12
      ],
      [
        -1,
        -10
      ],
      [
        -8,
        -73
      ],
      [
        -3,
        -7
      ],
      [
        -7,
        -5
      ],
      [
        -14,
        -18
      ],
      [
        -14,
        -31
      ],
      [
        -6,
        -9
      ],
      [
        -1,
        3
      ],
      [
        -3,
        9
      ],
      [
        -1,
        20
      ],
      [
        0,
        14
      ],
      [
        2,
        11
      ],
      [
        0,
        24
      ],
      [
        -1,
        12
      ],
      [
        -9,
        37
      ],
      [
        -6,
        44
      ],
      [
        0,
        29
      ],
      [
        -23,
        50
      ],
      [
        -8,
        5
      ],
      [
        -17,
        -6
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        11
      ],
      [
        6,
        12
      ],
      [
        0,
        11
      ],
      [
        -9,
        22
      ],
      [
        -23,
        24
      ],
      [
        -9,
        36
      ],
      [
        -12,
        -9
      ],
      [
        -26,
        -51
      ],
      [
        1,
        -20
      ],
      [
        15,
        -25
      ],
      [
        21,
        -7
      ],
      [
        16,
        -39
      ],
      [
        24,
        11
      ],
      [
        2,
        -48
      ],
      [
        -18,
        -47
      ],
      [
        -4,
        -34
      ],
      [
        -4,
        -6
      ],
      [
        -8,
        -7
      ],
      [
        -7,
        2
      ],
      [
        -15,
        36
      ],
      [
        -6,
        30
      ],
      [
        -1,
        16
      ],
      [
        -27,
        42
      ],
      [
        -17,
        22
      ],
      [
        -11,
        12
      ],
      [
        -41,
        33
      ],
      [
        -15,
        5
      ],
      [
        -49,
        8
      ],
      [
        -13,
        -2
      ],
      [
        -6,
        -10
      ],
      [
        -22,
        -15
      ],
      [
        -5,
        0
      ],
      [
        -14,
        9
      ],
      [
        -8,
        3
      ],
      [
        -21,
        3
      ],
      [
        -31,
        0
      ],
      [
        -13,
        -3
      ],
      [
        -32,
        -19
      ],
      [
        -20,
        -18
      ],
      [
        -16,
        -15
      ],
      [
        -72,
        -79
      ],
      [
        -8,
        -5
      ],
      [
        -10,
        -4
      ],
      [
        -36,
        -9
      ],
      [
        -4,
        1
      ],
      [
        -55,
        41
      ],
      [
        -56,
        33
      ],
      [
        -38,
        16
      ],
      [
        -56,
        29
      ],
      [
        -19,
        4
      ],
      [
        -28,
        10
      ],
      [
        -75,
        31
      ],
      [
        -13,
        9
      ],
      [
        -43,
        64
      ],
      [
        -6,
        15
      ],
      [
        -11,
        47
      ],
      [
        -6,
        32
      ],
      [
        -3,
        17
      ],
      [
        1,
        61
      ],
      [
        0,
        13
      ],
      [
        14,
        12
      ],
      [
        4,
        13
      ],
      [
        2,
        11
      ],
      [
        0,
        37
      ],
      [
        -2,
        14
      ],
      [
        -4,
        13
      ],
      [
        -28,
        63
      ],
      [
        -15,
        22
      ],
      [
        -8,
        10
      ],
      [
        -6,
        4
      ],
      [
        -16,
        20
      ],
      [
        -3,
        14
      ],
      [
        -1,
        3
      ],
      [
        3,
        6
      ],
      [
        2,
        15
      ],
      [
        -1,
        14
      ],
      [
        -1,
        7
      ],
      [
        -10,
        20
      ],
      [
        -25,
        28
      ],
      [
        -11,
        16
      ],
      [
        -7,
        17
      ],
      [
        -7,
        24
      ],
      [
        0,
        9
      ],
      [
        1,
        3
      ],
      [
        3,
        3
      ],
      [
        3,
        0
      ],
      [
        4,
        -2
      ],
      [
        10,
        -11
      ],
      [
        3,
        -9
      ],
      [
        2,
        -3
      ],
      [
        17,
        -8
      ],
      [
        24,
        -1
      ],
      [
        9,
        4
      ],
      [
        1,
        15
      ],
      [
        8,
        12
      ],
      [
        24,
        15
      ],
      [
        3,
        4
      ],
      [
        8,
        17
      ],
      [
        5,
        11
      ],
      [
        1,
        8
      ],
      [
        0,
        7
      ],
      [
        -2,
        6
      ],
      [
        -2,
        27
      ],
      [
        0,
        7
      ],
      [
        6,
        14
      ],
      [
        18,
        21
      ],
      [
        11,
        26
      ],
      [
        -4,
        14
      ],
      [
        -4,
        11
      ],
      [
        -17,
        25
      ],
      [
        -13,
        13
      ],
      [
        -10,
        6
      ],
      [
        -9,
        3
      ],
      [
        -6,
        0
      ],
      [
        -6,
        -2
      ],
      [
        -8,
        -13
      ],
      [
        -9,
        -1
      ],
      [
        -6,
        3
      ],
      [
        -33,
        12
      ],
      [
        -15,
        13
      ],
      [
        -14,
        14
      ],
      [
        -35,
        25
      ],
      [
        -21,
        7
      ],
      [
        -19,
        1
      ],
      [
        -64,
        13
      ],
      [
        -21,
        15
      ],
      [
        -28,
        37
      ],
      [
        -13,
        22
      ],
      [
        0,
        3
      ],
      [
        -25,
        38
      ],
      [
        -36,
        36
      ],
      [
        -3,
        10
      ],
      [
        -16,
        14
      ],
      [
        -16,
        9
      ],
      [
        -8,
        1
      ],
      [
        -15,
        12
      ],
      [
        -7,
        8
      ],
      [
        -7,
        19
      ],
      [
        0,
        8
      ],
      [
        1,
        2
      ],
      [
        -1,
        11
      ],
      [
        -8,
        19
      ],
      [
        -2,
        16
      ],
      [
        2,
        18
      ],
      [
        7,
        34
      ],
      [
        34,
        50
      ],
      [
        34,
        30
      ],
      [
        34,
        26
      ],
      [
        55,
        52
      ],
      [
        63,
        74
      ],
      [
        19,
        31
      ],
      [
        29,
        43
      ],
      [
        45,
        56
      ],
      [
        7,
        13
      ],
      [
        35,
        51
      ],
      [
        65,
        79
      ],
      [
        19,
        26
      ],
      [
        55,
        56
      ],
      [
        125,
        142
      ],
      [
        3,
        5
      ],
      [
        18,
        20
      ],
      [
        38,
        34
      ],
      [
        73,
        68
      ],
      [
        61,
        52
      ],
      [
        18,
        9
      ],
      [
        115,
        81
      ],
      [
        87,
        45
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        2840,
        93488
      ],
      [
        2,
        5
      ],
      [
        3,
        4
      ],
      [
        6,
        4
      ],
      [
        3,
        -1
      ],
      [
        3,
        -29
      ],
      [
        -2,
        -6
      ],
      [
        -1,
        -1
      ],
      [
        -8,
        0
      ],
      [
        -2,
        5
      ],
      [
        -3,
        7
      ],
      [
        -1,
        10
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        2036,
        90914
      ],
      [
        2,
        37
      ],
      [
        11,
        48
      ],
      [
        10,
        22
      ],
      [
        4,
        17
      ],
      [
        0,
        13
      ],
      [
        -4,
        41
      ],
      [
        1,
        21
      ],
      [
        4,
        -2
      ],
      [
        2,
        4
      ],
      [
        1,
        7
      ],
      [
        1,
        9
      ],
      [
        -1,
        12
      ],
      [
        -3,
        18
      ],
      [
        -1,
        27
      ],
      [
        1,
        2
      ],
      [
        11,
        -4
      ],
      [
        2,
        1
      ],
      [
        3,
        6
      ],
      [
        2,
        0
      ],
      [
        2,
        -2
      ],
      [
        2,
        -12
      ],
      [
        4,
        -6
      ],
      [
        2,
        -13
      ],
      [
        0,
        -11
      ],
      [
        -1,
        -5
      ],
      [
        -3,
        -7
      ],
      [
        0,
        -3
      ],
      [
        1,
        -2
      ],
      [
        1,
        -7
      ],
      [
        -2,
        -24
      ],
      [
        1,
        -7
      ],
      [
        3,
        -11
      ],
      [
        2,
        -5
      ],
      [
        6,
        -11
      ],
      [
        25,
        -24
      ],
      [
        39,
        -33
      ],
      [
        49,
        -27
      ],
      [
        28,
        -21
      ],
      [
        17,
        -10
      ],
      [
        26,
        -12
      ],
      [
        12,
        2
      ],
      [
        2,
        3
      ],
      [
        11,
        15
      ],
      [
        12,
        22
      ],
      [
        33,
        47
      ],
      [
        26,
        30
      ],
      [
        32,
        28
      ],
      [
        5,
        2
      ],
      [
        3,
        0
      ],
      [
        6,
        -7
      ],
      [
        18,
        -6
      ],
      [
        4,
        0
      ],
      [
        2,
        6
      ],
      [
        2,
        2
      ],
      [
        9,
        -2
      ],
      [
        9,
        -9
      ],
      [
        4,
        -10
      ],
      [
        3,
        -11
      ],
      [
        22,
        -48
      ],
      [
        6,
        -7
      ],
      [
        4,
        -3
      ],
      [
        8,
        -1
      ],
      [
        5,
        -4
      ],
      [
        5,
        -28
      ],
      [
        10,
        -76
      ],
      [
        -2,
        -38
      ],
      [
        6,
        -11
      ],
      [
        5,
        -6
      ],
      [
        10,
        -6
      ],
      [
        19,
        -15
      ],
      [
        13,
        -18
      ],
      [
        31,
        -11
      ],
      [
        25,
        -3
      ],
      [
        4,
        -3
      ],
      [
        18,
        -29
      ],
      [
        3,
        -16
      ],
      [
        1,
        -4
      ],
      [
        3,
        -10
      ],
      [
        2,
        -5
      ],
      [
        7,
        -8
      ],
      [
        29,
        -12
      ],
      [
        9,
        1
      ],
      [
        20,
        -4
      ],
      [
        9,
        -5
      ],
      [
        4,
        -5
      ],
      [
        46,
        -7
      ],
      [
        4,
        3
      ],
      [
        10,
        3
      ],
      [
        14,
        -3
      ],
      [
        18,
        -8
      ],
      [
        0,
        -4
      ],
      [
        1,
        -2
      ],
      [
        38,
        -23
      ],
      [
        29,
        -8
      ],
      [
        2,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        -8,
        -43
      ],
      [
        -10,
        -44
      ],
      [
        -8,
        -40
      ],
      [
        -2,
        -5
      ],
      [
        -8,
        -19
      ],
      [
        -12,
        -19
      ],
      [
        -3,
        -1
      ],
      [
        -5,
        2
      ],
      [
        -17,
        15
      ],
      [
        -4,
        8
      ],
      [
        -5,
        3
      ],
      [
        -17,
        8
      ],
      [
        -17,
        2
      ],
      [
        -26,
        -3
      ],
      [
        -18,
        -7
      ],
      [
        -11,
        -6
      ],
      [
        -21,
        -16
      ],
      [
        -5,
        -17
      ],
      [
        -12,
        -27
      ],
      [
        -9,
        -17
      ],
      [
        -12,
        -16
      ],
      [
        -6,
        -12
      ],
      [
        -7,
        -23
      ],
      [
        -4,
        -21
      ],
      [
        -1,
        -11
      ],
      [
        2,
        -6
      ],
      [
        1,
        -53
      ],
      [
        -20,
        -46
      ],
      [
        -30,
        22
      ],
      [
        -3,
        5
      ],
      [
        0,
        4
      ],
      [
        6,
        12
      ],
      [
        0,
        3
      ],
      [
        -15,
        77
      ],
      [
        -11,
        42
      ],
      [
        -3,
        6
      ],
      [
        -11,
        25
      ],
      [
        -18,
        31
      ],
      [
        -12,
        13
      ],
      [
        -5,
        1
      ],
      [
        -4,
        6
      ],
      [
        -8,
        16
      ],
      [
        -1,
        5
      ],
      [
        0,
        2
      ],
      [
        -14,
        12
      ],
      [
        -6,
        5
      ],
      [
        -8,
        3
      ],
      [
        -6,
        -1
      ],
      [
        -3,
        -4
      ],
      [
        1,
        -4
      ],
      [
        -3,
        -1
      ],
      [
        -20,
        2
      ],
      [
        -5,
        9
      ],
      [
        -1,
        9
      ],
      [
        2,
        3
      ],
      [
        0,
        13
      ],
      [
        -7,
        35
      ],
      [
        -9,
        32
      ],
      [
        -8,
        23
      ],
      [
        -18,
        33
      ],
      [
        -23,
        32
      ],
      [
        -13,
        15
      ],
      [
        -43,
        36
      ],
      [
        -43,
        33
      ],
      [
        -16,
        8
      ],
      [
        -12,
        3
      ],
      [
        -28,
        1
      ],
      [
        -9,
        -1
      ],
      [
        -47,
        -44
      ],
      [
        -3,
        -5
      ],
      [
        -2,
        -5
      ],
      [
        0,
        -12
      ],
      [
        -1,
        -13
      ],
      [
        -12,
        -23
      ],
      [
        -28,
        -33
      ],
      [
        -8,
        -1
      ],
      [
        -28,
        33
      ],
      [
        -29,
        25
      ],
      [
        -20,
        11
      ],
      [
        -16,
        49
      ],
      [
        -6,
        25
      ],
      [
        -2,
        9
      ],
      [
        -7,
        56
      ],
      [
        3,
        73
      ]
    ],
    [
      [
        21724,
        54804
      ],
      [
        0,
        508
      ]
    ],
    [
      [
        22543,
        49601
      ],
      [
        98,
        -1
      ]
    ],
    [
      [
        25847,
        64156
      ],
      [
        0,
        153
      ],
      [
        -26,
        -1
      ],
      [
        -16,
        1
      ],
      [
        0,
        50
      ],
      [
        -16,
        0
      ]
    ],
    [
      [
        21697,
        65126
      ],
      [
        155,
        -1
      ]
    ],
    [
      [
        21703,
        64671
      ],
      [
        0,
        51
      ],
      [
        -6,
        0
      ],
      [
        0,
        404
      ]
    ],
    [
      [
        24920,
        61430
      ],
      [
        30,
        0
      ]
    ],
    [
      [
        24950,
        61430
      ],
      [
        1,
        -93
      ],
      [
        -1,
        -215
      ]
    ],
    [
      [
        24950,
        61122
      ],
      [
        -17,
        -112
      ],
      [
        -3,
        -35
      ],
      [
        -4,
        -7
      ],
      [
        2,
        -23
      ]
    ],
    [
      [
        25349,
        67627
      ],
      [
        34,
        -1
      ]
    ],
    [
      [
        28458,
        62298
      ],
      [
        3,
        -9
      ],
      [
        14,
        -45
      ],
      [
        2,
        -6
      ],
      [
        2,
        -7
      ],
      [
        5,
        -17
      ],
      [
        0,
        -1
      ],
      [
        -3,
        -8
      ],
      [
        0,
        -1
      ],
      [
        -8,
        -27
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -4
      ],
      [
        -4,
        -16
      ],
      [
        -4,
        -11
      ],
      [
        -2,
        -8
      ],
      [
        -7,
        -21
      ],
      [
        -4,
        -14
      ]
    ],
    [
      [
        28448,
        62096
      ],
      [
        0,
        11
      ],
      [
        1,
        16
      ],
      [
        -1,
        1
      ],
      [
        0,
        19
      ],
      [
        -1,
        2
      ],
      [
        0,
        -1
      ],
      [
        -1,
        2
      ],
      [
        0,
        5
      ],
      [
        1,
        1
      ]
    ],
    [
      [
        28528,
        60859
      ],
      [
        8,
        32
      ],
      [
        6,
        -1
      ],
      [
        5,
        17
      ]
    ],
    [
      [
        28547,
        60907
      ],
      [
        0,
        -5
      ],
      [
        1,
        -7
      ],
      [
        1,
        -4
      ],
      [
        4,
        -5
      ],
      [
        6,
        -1
      ],
      [
        6,
        -8
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -6
      ],
      [
        1,
        -7
      ],
      [
        4,
        -8
      ],
      [
        2,
        -9
      ],
      [
        0,
        -16
      ],
      [
        5,
        -37
      ],
      [
        -1,
        -11
      ],
      [
        3,
        -18
      ],
      [
        8,
        -35
      ],
      [
        3,
        -5
      ],
      [
        2,
        -1
      ],
      [
        25,
        2
      ],
      [
        4,
        -17
      ],
      [
        3,
        -19
      ],
      [
        8,
        -10
      ],
      [
        7,
        0
      ],
      [
        7,
        -4
      ],
      [
        9,
        -10
      ],
      [
        0,
        -4
      ],
      [
        -1,
        -8
      ],
      [
        -8,
        -17
      ],
      [
        -2,
        2
      ],
      [
        -3,
        -2
      ],
      [
        -1,
        -11
      ]
    ],
    [
      [
        22406,
        63911
      ],
      [
        0,
        -406
      ]
    ],
    [
      [
        15909,
        60545
      ],
      [
        -4,
        19
      ],
      [
        -2,
        18
      ],
      [
        -7,
        10
      ],
      [
        -5,
        9
      ],
      [
        0,
        4
      ],
      [
        -1,
        21
      ],
      [
        -4,
        37
      ],
      [
        -2,
        3
      ],
      [
        -1,
        5
      ],
      [
        -2,
        17
      ],
      [
        0,
        29
      ],
      [
        -2,
        39
      ],
      [
        -3,
        31
      ],
      [
        0,
        1
      ],
      [
        -2,
        9
      ],
      [
        -2,
        5
      ],
      [
        -5,
        15
      ],
      [
        -2,
        6
      ],
      [
        -3,
        1
      ],
      [
        -2,
        8
      ],
      [
        -7,
        19
      ],
      [
        -3,
        16
      ],
      [
        0,
        11
      ],
      [
        1,
        3
      ],
      [
        2,
        3
      ],
      [
        1,
        4
      ],
      [
        -3,
        9
      ],
      [
        -3,
        4
      ],
      [
        -3,
        3
      ],
      [
        -3,
        2
      ],
      [
        -2,
        1
      ],
      [
        -3,
        5
      ],
      [
        -4,
        5
      ],
      [
        -3,
        5
      ]
    ],
    [
      [
        15829,
        60925
      ],
      [
        0,
        12
      ],
      [
        -1,
        4
      ],
      [
        1,
        12
      ],
      [
        2,
        16
      ],
      [
        2,
        4
      ],
      [
        3,
        1
      ],
      [
        1,
        3
      ],
      [
        0,
        3
      ],
      [
        1,
        17
      ],
      [
        -3,
        31
      ],
      [
        0,
        22
      ],
      [
        -1,
        5
      ]
    ],
    [
      [
        28448,
        62096
      ],
      [
        0,
        -7
      ]
    ],
    [
      [
        28448,
        62089
      ],
      [
        -9,
        16
      ],
      [
        -2,
        2
      ],
      [
        -4,
        2
      ],
      [
        -5,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -6,
        -4
      ],
      [
        0,
        3
      ],
      [
        -2,
        15
      ],
      [
        0,
        14
      ],
      [
        5,
        17
      ],
      [
        4,
        3
      ]
    ],
    [
      [
        24434,
        56612
      ],
      [
        3,
        -14
      ],
      [
        0,
        -51
      ],
      [
        4,
        -12
      ]
    ],
    [
      [
        24441,
        56535
      ],
      [
        0,
        -18
      ],
      [
        -12,
        7
      ],
      [
        0,
        -34
      ],
      [
        -23,
        1
      ],
      [
        -1,
        -38
      ],
      [
        -1,
        -63
      ],
      [
        0,
        -22
      ],
      [
        -1,
        -102
      ]
    ],
    [
      [
        28149,
        57358
      ],
      [
        13,
        8
      ],
      [
        10,
        -4
      ],
      [
        5,
        9
      ],
      [
        6,
        -19
      ],
      [
        5,
        3
      ],
      [
        4,
        -3
      ],
      [
        6,
        8
      ],
      [
        4,
        -4
      ],
      [
        67,
        1
      ]
    ],
    [
      [
        28315,
        57031
      ],
      [
        -11,
        -27
      ],
      [
        -7,
        -20
      ],
      [
        -15,
        -47
      ],
      [
        -7,
        -21
      ],
      [
        -8,
        -25
      ],
      [
        -6,
        -27
      ]
    ],
    [
      [
        25450,
        66403
      ],
      [
        0,
        -56
      ],
      [
        -1,
        -27
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -33
      ],
      [
        -3,
        -24
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        -37
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -27
      ],
      [
        2,
        -37
      ],
      [
        5,
        -44
      ],
      [
        3,
        -28
      ],
      [
        11,
        -65
      ]
    ],
    [
      [
        21869,
        60563
      ],
      [
        0,
        -101
      ]
    ],
    [
      [
        21869,
        60462
      ],
      [
        -116,
        0
      ]
    ],
    [
      [
        23981,
        61061
      ],
      [
        -31,
        2
      ],
      [
        -1,
        -118
      ]
    ],
    [
      [
        23949,
        60945
      ],
      [
        -108,
        12
      ],
      [
        0,
        17
      ]
    ],
    [
      [
        28179,
        60037
      ],
      [
        10,
        -41
      ],
      [
        14,
        -5
      ],
      [
        8,
        6
      ]
    ],
    [
      [
        28366,
        62171
      ],
      [
        1,
        10
      ],
      [
        10,
        8
      ],
      [
        1,
        -5
      ],
      [
        6,
        -3
      ],
      [
        0,
        -28
      ],
      [
        -8,
        -7
      ],
      [
        -6,
        0
      ],
      [
        -4,
        20
      ],
      [
        0,
        5
      ]
    ],
    [
      [
        21316,
        65178
      ],
      [
        -204,
        -2
      ]
    ],
    [
      [
        21112,
        65176
      ],
      [
        0,
        305
      ]
    ],
    [
      [
        25178,
        66812
      ],
      [
        65,
        0
      ]
    ],
    [
      [
        25186,
        63261
      ],
      [
        -3,
        0
      ],
      [
        0,
        -61
      ],
      [
        -15,
        1
      ],
      [
        0,
        -102
      ]
    ],
    [
      [
        25055,
        63285
      ],
      [
        0,
        121
      ]
    ],
    [
      [
        24919,
        61658
      ],
      [
        3,
        11
      ],
      [
        7,
        8
      ],
      [
        2,
        16
      ],
      [
        5,
        -4
      ],
      [
        5,
        11
      ],
      [
        3,
        24
      ],
      [
        8,
        4
      ],
      [
        3,
        9
      ],
      [
        2,
        -8
      ],
      [
        8,
        5
      ],
      [
        16,
        -14
      ],
      [
        8,
        13
      ],
      [
        7,
        22
      ],
      [
        5,
        -12
      ],
      [
        2,
        8
      ],
      [
        10,
        3
      ],
      [
        5,
        24
      ],
      [
        2,
        -9
      ],
      [
        9,
        1
      ],
      [
        4,
        -7
      ],
      [
        11,
        4
      ],
      [
        32,
        -7
      ]
    ],
    [
      [
        25075,
        61422
      ],
      [
        -93,
        4
      ],
      [
        -32,
        4
      ]
    ],
    [
      [
        30589,
        69408
      ],
      [
        34,
        20
      ],
      [
        69,
        41
      ],
      [
        36,
        20
      ],
      [
        -7,
        96
      ],
      [
        29,
        18
      ],
      [
        -15,
        235
      ],
      [
        -7,
        99
      ],
      [
        -30,
        -18
      ],
      [
        3,
        81
      ],
      [
        0,
        66
      ],
      [
        -2,
        28
      ],
      [
        37,
        26
      ],
      [
        0,
        36
      ],
      [
        2,
        792
      ]
    ],
    [
      [
        24897,
        67741
      ],
      [
        -1,
        30
      ],
      [
        -5,
        12
      ],
      [
        -4,
        18
      ],
      [
        -6,
        51
      ],
      [
        0,
        25
      ],
      [
        -6,
        30
      ],
      [
        -7,
        15
      ],
      [
        -4,
        20
      ],
      [
        -4,
        9
      ],
      [
        -1,
        20
      ],
      [
        -11,
        30
      ],
      [
        -1,
        22
      ],
      [
        -5,
        26
      ],
      [
        0,
        12
      ],
      [
        8,
        10
      ],
      [
        -3,
        49
      ],
      [
        0,
        15
      ],
      [
        -3,
        19
      ],
      [
        -9,
        15
      ],
      [
        2,
        18
      ],
      [
        -5,
        27
      ],
      [
        -2,
        49
      ],
      [
        6,
        15
      ],
      [
        -1,
        22
      ],
      [
        4,
        6
      ],
      [
        4,
        -4
      ],
      [
        2,
        51
      ],
      [
        8,
        -4
      ],
      [
        3,
        -15
      ],
      [
        2,
        2
      ],
      [
        1,
        31
      ],
      [
        5,
        2
      ],
      [
        0,
        13
      ],
      [
        -6,
        -1
      ],
      [
        5,
        13
      ],
      [
        -5,
        13
      ],
      [
        8,
        19
      ],
      [
        -2,
        23
      ]
    ],
    [
      [
        25252,
        52115
      ],
      [
        5,
        2
      ],
      [
        8,
        -13
      ],
      [
        3,
        -2
      ],
      [
        1,
        1
      ],
      [
        2,
        1
      ],
      [
        4,
        8
      ],
      [
        5,
        5
      ],
      [
        2,
        -15
      ],
      [
        -7,
        -15
      ],
      [
        -6,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        -12,
        9
      ],
      [
        -3,
        10
      ],
      [
        -1,
        14
      ]
    ],
    [
      [
        25179,
        52148
      ],
      [
        10,
        9
      ],
      [
        6,
        4
      ],
      [
        7,
        -8
      ],
      [
        6,
        -8
      ],
      [
        3,
        -4
      ],
      [
        14,
        -9
      ],
      [
        6,
        -15
      ],
      [
        -7,
        -2
      ],
      [
        -9,
        4
      ],
      [
        -7,
        2
      ],
      [
        -1,
        1
      ],
      [
        -12,
        17
      ],
      [
        -7,
        -5
      ],
      [
        -5,
        0
      ],
      [
        -3,
        4
      ],
      [
        -1,
        10
      ]
    ],
    [
      [
        25284,
        52292
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -8
      ],
      [
        1,
        -7
      ],
      [
        0,
        -6
      ],
      [
        -2,
        -6
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        14
      ],
      [
        -5,
        1
      ],
      [
        -3,
        -8
      ],
      [
        0,
        -12
      ],
      [
        -2,
        -9
      ],
      [
        -5,
        -11
      ],
      [
        -3,
        -2
      ],
      [
        -6,
        3
      ],
      [
        -1,
        1
      ],
      [
        0,
        6
      ],
      [
        -4,
        15
      ],
      [
        -4,
        4
      ],
      [
        -9,
        -16
      ],
      [
        -4,
        1
      ],
      [
        -5,
        30
      ],
      [
        -4,
        -3
      ],
      [
        -6,
        7
      ],
      [
        -8,
        3
      ],
      [
        -10,
        -22
      ],
      [
        -8,
        -1
      ],
      [
        -5,
        6
      ],
      [
        0,
        1
      ],
      [
        -7,
        19
      ],
      [
        -11,
        23
      ],
      [
        -1,
        -11
      ]
    ],
    [
      [
        26509,
        53416
      ],
      [
        62,
        -3
      ],
      [
        5,
        0
      ],
      [
        0,
        -16
      ],
      [
        12,
        0
      ],
      [
        0,
        15
      ],
      [
        17,
        -1
      ]
    ],
    [
      [
        26644,
        53407
      ],
      [
        0,
        -29
      ],
      [
        2,
        -26
      ],
      [
        -2,
        -60
      ],
      [
        1,
        -26
      ],
      [
        -8,
        -32
      ],
      [
        -1,
        -36
      ],
      [
        -3,
        -3
      ],
      [
        -1,
        -40
      ],
      [
        -3,
        -12
      ],
      [
        -2,
        -26
      ]
    ],
    [
      [
        26627,
        53117
      ],
      [
        0,
        -52
      ],
      [
        -45,
        5
      ]
    ],
    [
      [
        27659,
        63732
      ],
      [
        5,
        -7
      ],
      [
        1,
        -19
      ],
      [
        -6,
        -15
      ],
      [
        -5,
        4
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -6
      ],
      [
        5,
        -26
      ],
      [
        2,
        -4
      ]
    ],
    [
      [
        28929,
        62276
      ],
      [
        0,
        -2
      ],
      [
        3,
        -6
      ],
      [
        -3,
        -17
      ],
      [
        2,
        -14
      ],
      [
        12,
        -41
      ],
      [
        8,
        -39
      ],
      [
        8,
        -24
      ],
      [
        4,
        -19
      ],
      [
        8,
        -18
      ],
      [
        1,
        -2
      ],
      [
        7,
        -9
      ],
      [
        6,
        1
      ],
      [
        2,
        4
      ],
      [
        2,
        19
      ],
      [
        1,
        1
      ],
      [
        1,
        -8
      ],
      [
        2,
        -29
      ],
      [
        1,
        -25
      ],
      [
        0,
        -14
      ],
      [
        4,
        -90
      ],
      [
        0,
        -33
      ],
      [
        1,
        -28
      ],
      [
        0,
        -1
      ],
      [
        3,
        -141
      ],
      [
        0,
        -41
      ]
    ],
    [
      [
        23026,
        62389
      ],
      [
        30,
        0
      ],
      [
        1,
        151
      ]
    ],
    [
      [
        25363,
        59716
      ],
      [
        -7,
        2
      ],
      [
        -97,
        2
      ]
    ],
    [
      [
        26714,
        61309
      ],
      [
        0,
        -15
      ],
      [
        -2,
        -39
      ],
      [
        1,
        -12
      ],
      [
        4,
        -10
      ],
      [
        5,
        2
      ],
      [
        3,
        -9
      ],
      [
        1,
        -20
      ],
      [
        7,
        -19
      ],
      [
        6,
        7
      ],
      [
        6,
        -7
      ],
      [
        2,
        -16
      ],
      [
        2,
        8
      ],
      [
        8,
        0
      ],
      [
        2,
        7
      ],
      [
        10,
        -2
      ],
      [
        5,
        -13
      ],
      [
        5,
        15
      ],
      [
        2,
        -3
      ]
    ],
    [
      [
        25601,
        60095
      ],
      [
        -5,
        -2
      ],
      [
        -3,
        16
      ],
      [
        2,
        5
      ],
      [
        -1,
        22
      ],
      [
        -6,
        -1
      ],
      [
        -8,
        29
      ],
      [
        0,
        29
      ]
    ],
    [
      [
        16976,
        71173
      ],
      [
        10,
        -33
      ],
      [
        4,
        -7
      ],
      [
        13,
        2
      ],
      [
        7,
        21
      ],
      [
        7,
        0
      ],
      [
        9,
        12
      ],
      [
        14,
        2
      ],
      [
        9,
        6
      ],
      [
        12,
        -8
      ],
      [
        8,
        8
      ],
      [
        3,
        32
      ],
      [
        5,
        6
      ]
    ],
    [
      [
        17042,
        70488
      ],
      [
        -5,
        0
      ]
    ],
    [
      [
        25131,
        53986
      ],
      [
        -38,
        -10
      ],
      [
        -33,
        -8
      ],
      [
        -18,
        -5
      ],
      [
        -15,
        -3
      ]
    ],
    [
      [
        25027,
        53960
      ],
      [
        0,
        84
      ],
      [
        -1,
        17
      ],
      [
        0,
        389
      ]
    ],
    [
      [
        26220,
        63171
      ],
      [
        0,
        -220
      ]
    ],
    [
      [
        22247,
        72637
      ],
      [
        209,
        1
      ],
      [
        2,
        -2
      ],
      [
        4,
        0
      ]
    ],
    [
      [
        22469,
        72335
      ],
      [
        -214,
        0
      ]
    ],
    [
      [
        22255,
        72335
      ],
      [
        1,
        99
      ],
      [
        -9,
        0
      ],
      [
        0,
        203
      ]
    ],
    [
      [
        26502,
        63717
      ],
      [
        -3,
        -168
      ]
    ],
    [
      [
        22733,
        54837
      ],
      [
        -18,
        0
      ]
    ],
    [
      [
        22342,
        55817
      ],
      [
        149,
        -2
      ]
    ],
    [
      [
        23488,
        53197
      ],
      [
        29,
        -50
      ],
      [
        5,
        4
      ],
      [
        6,
        -13
      ],
      [
        7,
        0
      ],
      [
        4,
        -13
      ],
      [
        3,
        16
      ],
      [
        1,
        -12
      ],
      [
        7,
        -3
      ],
      [
        6,
        -20
      ],
      [
        10,
        -7
      ],
      [
        0,
        -4
      ]
    ],
    [
      [
        18869,
        65087
      ],
      [
        -7,
        7
      ],
      [
        -9,
        20
      ],
      [
        1,
        18
      ],
      [
        -9,
        16
      ],
      [
        -1,
        11
      ]
    ],
    [
      [
        16514,
        71218
      ],
      [
        -1,
        -76
      ],
      [
        1,
        -33
      ],
      [
        0,
        -372
      ],
      [
        2,
        0
      ],
      [
        0,
        -202
      ]
    ],
    [
      [
        16055,
        70538
      ],
      [
        0,
        401
      ]
    ],
    [
      [
        26831,
        65420
      ],
      [
        2,
        72
      ],
      [
        3,
        16
      ],
      [
        1,
        2
      ],
      [
        3,
        -5
      ],
      [
        7,
        -27
      ],
      [
        1,
        -3
      ],
      [
        -3,
        -35
      ],
      [
        -6,
        -21
      ],
      [
        -4,
        -15
      ],
      [
        -4,
        -6
      ],
      [
        0,
        22
      ]
    ],
    [
      [
        26741,
        65392
      ],
      [
        6,
        -6
      ],
      [
        11,
        -5
      ],
      [
        5,
        -8
      ],
      [
        6,
        -13
      ],
      [
        6,
        -32
      ],
      [
        4,
        -14
      ],
      [
        8,
        -20
      ],
      [
        9,
        -17
      ],
      [
        10,
        -12
      ],
      [
        10,
        6
      ],
      [
        2,
        4
      ],
      [
        4,
        8
      ],
      [
        2,
        5
      ],
      [
        3,
        17
      ],
      [
        1,
        18
      ],
      [
        -2,
        15
      ],
      [
        2,
        8
      ],
      [
        2,
        2
      ],
      [
        3,
        3
      ],
      [
        4,
        -20
      ],
      [
        8,
        -28
      ],
      [
        2,
        -7
      ],
      [
        4,
        0
      ],
      [
        6,
        7
      ],
      [
        9,
        -5
      ],
      [
        2,
        -7
      ],
      [
        0,
        -11
      ],
      [
        -3,
        -12
      ],
      [
        0,
        -7
      ],
      [
        2,
        -10
      ],
      [
        1,
        -5
      ],
      [
        4,
        -4
      ]
    ],
    [
      [
        26872,
        65242
      ],
      [
        -7,
        -14
      ],
      [
        -5,
        -5
      ],
      [
        -22,
        8
      ],
      [
        -5,
        -6
      ],
      [
        -22,
        -24
      ],
      [
        -10,
        -1
      ]
    ],
    [
      [
        24711,
        62301
      ],
      [
        -3,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -17
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -2
      ],
      [
        1,
        -6
      ],
      [
        -2,
        -11
      ],
      [
        -3,
        -18
      ],
      [
        -2,
        -9
      ],
      [
        -3,
        -4
      ],
      [
        -4,
        -14
      ],
      [
        -4,
        -14
      ],
      [
        0,
        -1
      ],
      [
        -3,
        -4
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -3,
        -1
      ],
      [
        -2,
        1
      ],
      [
        -3,
        7
      ],
      [
        -8,
        16
      ],
      [
        -1,
        3
      ],
      [
        -2,
        15
      ],
      [
        -1,
        5
      ],
      [
        -3,
        4
      ],
      [
        -1,
        5
      ],
      [
        -1,
        5
      ],
      [
        -1,
        5
      ],
      [
        -1,
        4
      ],
      [
        0,
        7
      ]
    ],
    [
      [
        23443,
        53522
      ],
      [
        38,
        117
      ]
    ],
    [
      [
        27522,
        55654
      ],
      [
        2,
        20
      ],
      [
        3,
        4
      ],
      [
        9,
        -16
      ],
      [
        5,
        8
      ],
      [
        11,
        33
      ],
      [
        2,
        45
      ],
      [
        2,
        15
      ],
      [
        1,
        47
      ],
      [
        4,
        0
      ],
      [
        -1,
        21
      ],
      [
        1,
        40
      ]
    ],
    [
      [
        22919,
        69095
      ],
      [
        0,
        -303
      ]
    ],
    [
      [
        27062,
        55974
      ],
      [
        -2,
        3
      ],
      [
        -1,
        3
      ],
      [
        0,
        4
      ],
      [
        -1,
        5
      ]
    ],
    [
      [
        23405,
        70206
      ],
      [
        0,
        -202
      ],
      [
        2,
        0
      ],
      [
        0,
        -201
      ]
    ],
    [
      [
        27045,
        63236
      ],
      [
        14,
        -3
      ],
      [
        1,
        1
      ],
      [
        90,
        -16
      ]
    ],
    [
      [
        27150,
        63218
      ],
      [
        16,
        -2
      ],
      [
        -1,
        -103
      ],
      [
        16,
        -2
      ],
      [
        0,
        -89
      ]
    ],
    [
      [
        27053,
        62980
      ],
      [
        6,
        202
      ],
      [
        -15,
        4
      ],
      [
        1,
        50
      ]
    ],
    [
      [
        2245,
        4076
      ],
      [
        0,
        2
      ],
      [
        1,
        1
      ],
      [
        3,
        2
      ],
      [
        2,
        -2
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        6
      ],
      [
        -1,
        7
      ],
      [
        0,
        3
      ]
    ],
    [
      [
        15943,
        70079
      ],
      [
        4,
        6
      ],
      [
        2,
        9
      ],
      [
        0,
        10
      ],
      [
        10,
        26
      ],
      [
        15,
        16
      ],
      [
        21,
        -15
      ],
      [
        8,
        1
      ],
      [
        11,
        12
      ],
      [
        10,
        -1
      ],
      [
        28,
        26
      ],
      [
        2,
        -2
      ]
    ],
    [
      [
        23949,
        60945
      ],
      [
        -1,
        -85
      ],
      [
        5,
        0
      ],
      [
        -3,
        -364
      ]
    ],
    [
      [
        23828,
        60508
      ],
      [
        2,
        169
      ]
    ],
    [
      [
        21436,
        55306
      ],
      [
        37,
        1
      ]
    ],
    [
      [
        21580,
        55310
      ],
      [
        0,
        -508
      ]
    ],
    [
      [
        20566,
        61986
      ],
      [
        -154,
        -4
      ],
      [
        -2,
        2
      ],
      [
        -2,
        -2
      ],
      [
        -20,
        0
      ]
    ],
    [
      [
        20388,
        61982
      ],
      [
        6,
        27
      ],
      [
        2,
        54
      ],
      [
        9,
        51
      ],
      [
        -9,
        39
      ],
      [
        -1,
        14
      ],
      [
        5,
        23
      ],
      [
        -4,
        15
      ],
      [
        -10,
        -3
      ],
      [
        -1,
        14
      ],
      [
        4,
        13
      ],
      [
        -6,
        14
      ],
      [
        -2,
        -4
      ],
      [
        -10,
        33
      ],
      [
        -8,
        -1
      ],
      [
        -2,
        -12
      ],
      [
        -5,
        9
      ],
      [
        -8,
        1
      ],
      [
        0,
        18
      ],
      [
        2,
        21
      ],
      [
        -1,
        16
      ],
      [
        -10,
        12
      ],
      [
        -7,
        -8
      ],
      [
        -3,
        24
      ],
      [
        -3,
        8
      ],
      [
        2,
        23
      ],
      [
        -2,
        21
      ]
    ],
    [
      [
        20326,
        62404
      ],
      [
        0,
        14
      ],
      [
        6,
        21
      ],
      [
        -3,
        20
      ],
      [
        -8,
        1
      ],
      [
        10,
        38
      ],
      [
        -3,
        84
      ],
      [
        4,
        25
      ],
      [
        -4,
        14
      ],
      [
        1,
        21
      ],
      [
        -2,
        22
      ],
      [
        1,
        35
      ],
      [
        4,
        15
      ],
      [
        5,
        -2
      ],
      [
        3,
        22
      ],
      [
        -3,
        27
      ],
      [
        5,
        19
      ]
    ],
    [
      [
        27292,
        56114
      ],
      [
        28,
        50
      ],
      [
        9,
        9
      ],
      [
        4,
        4
      ]
    ],
    [
      [
        27333,
        56177
      ],
      [
        16,
        -72
      ],
      [
        5,
        -23
      ],
      [
        6,
        21
      ],
      [
        1,
        -40
      ],
      [
        6,
        -4
      ],
      [
        9,
        15
      ],
      [
        22,
        -17
      ],
      [
        21,
        -63
      ],
      [
        11,
        -32
      ],
      [
        -1,
        -14
      ],
      [
        10,
        -46
      ],
      [
        9,
        4
      ],
      [
        5,
        -4
      ],
      [
        -4,
        21
      ],
      [
        0,
        12
      ],
      [
        10,
        46
      ],
      [
        -6,
        14
      ],
      [
        2,
        6
      ],
      [
        14,
        11
      ],
      [
        4,
        -4
      ],
      [
        8,
        -27
      ],
      [
        4,
        23
      ]
    ],
    [
      [
        27282,
        55866
      ],
      [
        -5,
        2
      ],
      [
        -6,
        12
      ],
      [
        -11,
        34
      ],
      [
        -11,
        0
      ],
      [
        -8,
        11
      ]
    ],
    [
      [
        20260,
        62760
      ],
      [
        8,
        22
      ],
      [
        5,
        -6
      ],
      [
        3,
        -18
      ],
      [
        5,
        -8
      ],
      [
        4,
        7
      ],
      [
        10,
        2
      ],
      [
        5,
        -14
      ],
      [
        7,
        15
      ],
      [
        6,
        4
      ],
      [
        3,
        16
      ],
      [
        6,
        0
      ]
    ],
    [
      [
        20326,
        62404
      ],
      [
        -108,
        2
      ]
    ],
    [
      [
        26838,
        61610
      ],
      [
        -26,
        29
      ],
      [
        -8,
        3
      ],
      [
        -9,
        -9
      ],
      [
        -22,
        83
      ],
      [
        -4,
        1
      ],
      [
        -9,
        20
      ],
      [
        -7,
        3
      ],
      [
        -4,
        13
      ],
      [
        -8,
        8
      ]
    ],
    [
      [
        26693,
        57318
      ],
      [
        -7,
        -14
      ],
      [
        -27,
        -226
      ]
    ],
    [
      [
        26659,
        57078
      ],
      [
        -3,
        4
      ],
      [
        -13,
        6
      ],
      [
        -5,
        3
      ],
      [
        -5,
        -7
      ],
      [
        -9,
        -39
      ],
      [
        -6,
        -10
      ],
      [
        -2,
        -14
      ]
    ],
    [
      [
        19753,
        69322
      ],
      [
        0,
        3
      ],
      [
        1,
        3
      ],
      [
        -1,
        3
      ],
      [
        -3,
        0
      ],
      [
        1,
        4
      ],
      [
        1,
        4
      ],
      [
        0,
        3
      ],
      [
        -1,
        3
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        0,
        11
      ],
      [
        1,
        8
      ],
      [
        1,
        8
      ],
      [
        2,
        3
      ],
      [
        2,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        5
      ],
      [
        -1,
        3
      ],
      [
        -2,
        1
      ],
      [
        -2,
        3
      ],
      [
        0,
        4
      ],
      [
        1,
        4
      ],
      [
        1,
        0
      ],
      [
        2,
        1
      ],
      [
        -1,
        4
      ],
      [
        2,
        9
      ],
      [
        1,
        8
      ],
      [
        0,
        9
      ],
      [
        1,
        5
      ],
      [
        1,
        -1
      ],
      [
        2,
        3
      ],
      [
        0,
        6
      ],
      [
        2,
        2
      ],
      [
        -1,
        -2
      ],
      [
        2,
        -4
      ],
      [
        2,
        3
      ],
      [
        0,
        4
      ],
      [
        -1,
        6
      ],
      [
        -1,
        2
      ],
      [
        0,
        4
      ],
      [
        1,
        -2
      ],
      [
        2,
        3
      ],
      [
        0,
        14
      ],
      [
        -1,
        1
      ],
      [
        1,
        5
      ],
      [
        3,
        -1
      ],
      [
        2,
        5
      ],
      [
        0,
        7
      ],
      [
        -1,
        2
      ],
      [
        -1,
        3
      ],
      [
        1,
        3
      ],
      [
        -1,
        7
      ],
      [
        0,
        7
      ],
      [
        2,
        1
      ],
      [
        1,
        0
      ],
      [
        0,
        5
      ],
      [
        -2,
        2
      ],
      [
        0,
        4
      ],
      [
        1,
        1
      ],
      [
        2,
        0
      ],
      [
        0,
        -2
      ],
      [
        2,
        -2
      ],
      [
        0,
        4
      ],
      [
        1,
        9
      ],
      [
        0,
        4
      ],
      [
        1,
        3
      ],
      [
        1,
        -4
      ],
      [
        2,
        0
      ],
      [
        0,
        4
      ],
      [
        -1,
        2
      ],
      [
        -1,
        5
      ],
      [
        -1,
        3
      ],
      [
        1,
        0
      ],
      [
        2,
        4
      ],
      [
        -1,
        2
      ],
      [
        1,
        9
      ],
      [
        1,
        3
      ],
      [
        0,
        8
      ],
      [
        2,
        0
      ],
      [
        3,
        -1
      ],
      [
        2,
        4
      ],
      [
        0,
        2
      ],
      [
        -19,
        0
      ],
      [
        -16,
        -1
      ],
      [
        -38,
        0
      ],
      [
        -14,
        -1
      ],
      [
        -13,
        -1
      ],
      [
        -19,
        0
      ],
      [
        -5,
        -1
      ],
      [
        -39,
        0
      ],
      [
        -3,
        10
      ],
      [
        0,
        121
      ],
      [
        1,
        30
      ],
      [
        1,
        21
      ],
      [
        2,
        18
      ],
      [
        3,
        57
      ],
      [
        7,
        24
      ],
      [
        1,
        6
      ]
    ],
    [
      [
        24514,
        53430
      ],
      [
        1,
        91
      ],
      [
        0,
        13
      ],
      [
        1,
        202
      ]
    ],
    [
      [
        28325,
        62049
      ],
      [
        1,
        -1
      ],
      [
        0,
        2
      ],
      [
        -1,
        5
      ],
      [
        0,
        -6
      ]
    ],
    [
      [
        28331,
        62074
      ],
      [
        3,
        -14
      ],
      [
        0,
        -14
      ],
      [
        -1,
        -10
      ],
      [
        -1,
        -5
      ],
      [
        -4,
        -9
      ],
      [
        -7,
        -3
      ],
      [
        -2,
        14
      ],
      [
        -1,
        4
      ],
      [
        -3,
        -6
      ],
      [
        1,
        -5
      ],
      [
        1,
        -10
      ],
      [
        0,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        -4
      ],
      [
        -1,
        -13
      ],
      [
        -5,
        21
      ],
      [
        -1,
        11
      ],
      [
        9,
        44
      ],
      [
        5,
        12
      ]
    ],
    [
      [
        26362,
        58409
      ],
      [
        1,
        -44
      ],
      [
        5,
        -9
      ],
      [
        17,
        -135
      ],
      [
        -2,
        -3
      ],
      [
        5,
        -13
      ],
      [
        -1,
        -31
      ],
      [
        3,
        -5
      ],
      [
        0,
        -19
      ],
      [
        5,
        -4
      ],
      [
        0,
        -63
      ],
      [
        2,
        -16
      ],
      [
        -15,
        -13
      ],
      [
        -11,
        -39
      ]
    ],
    [
      [
        21659,
        65532
      ],
      [
        157,
        -3
      ]
    ],
    [
      [
        21697,
        65126
      ],
      [
        -38,
        1
      ]
    ],
    [
      [
        23316,
        54348
      ],
      [
        0,
        -26
      ],
      [
        9,
        -34
      ]
    ],
    [
      [
        23151,
        54197
      ],
      [
        -1,
        8
      ]
    ],
    [
      [
        29472,
        67872
      ],
      [
        3,
        12
      ],
      [
        1,
        8
      ],
      [
        0,
        1
      ],
      [
        -2,
        6
      ],
      [
        0,
        11
      ],
      [
        -2,
        5
      ],
      [
        -1,
        3
      ],
      [
        -3,
        7
      ],
      [
        0,
        11
      ]
    ],
    [
      [
        21110,
        65126
      ],
      [
        2,
        0
      ],
      [
        0,
        50
      ]
    ],
    [
      [
        21321,
        64670
      ],
      [
        -9,
        -1
      ]
    ],
    [
      [
        21312,
        64669
      ],
      [
        -32,
        0
      ],
      [
        -2,
        1
      ],
      [
        -15,
        -1
      ],
      [
        -48,
        0
      ],
      [
        0,
        1
      ],
      [
        -11,
        -1
      ],
      [
        -95,
        0
      ]
    ],
    [
      [
        25494,
        59589
      ],
      [
        21,
        1
      ],
      [
        1,
        0
      ],
      [
        33,
        2
      ],
      [
        2,
        0
      ],
      [
        3,
        1
      ],
      [
        25,
        0
      ]
    ],
    [
      [
        25639,
        59377
      ],
      [
        -8,
        -13
      ],
      [
        0,
        -32
      ],
      [
        -4,
        -5
      ],
      [
        -1,
        17
      ],
      [
        -3,
        -4
      ],
      [
        0,
        -20
      ],
      [
        -7,
        3
      ],
      [
        -3,
        -16
      ],
      [
        -10,
        -21
      ],
      [
        -4,
        -27
      ],
      [
        -4,
        0
      ],
      [
        -2,
        -38
      ]
    ],
    [
      [
        22646,
        54292
      ],
      [
        65,
        140
      ],
      [
        4,
        -5
      ]
    ],
    [
      [
        22715,
        54427
      ],
      [
        5,
        0
      ],
      [
        2,
        -15
      ],
      [
        -3,
        -17
      ],
      [
        7,
        6
      ],
      [
        2,
        -5
      ],
      [
        1,
        -31
      ],
      [
        3,
        -1
      ],
      [
        11,
        -18
      ],
      [
        2,
        7
      ],
      [
        -1,
        26
      ],
      [
        10,
        13
      ]
    ],
    [
      [
        25387,
        58139
      ],
      [
        4,
        -6
      ],
      [
        9,
        9
      ],
      [
        2,
        12
      ],
      [
        -1,
        10
      ],
      [
        -9,
        11
      ]
    ],
    [
      [
        27256,
        56797
      ],
      [
        -8,
        -40
      ],
      [
        2,
        -9
      ]
    ],
    [
      [
        27250,
        56748
      ],
      [
        -4,
        -1
      ],
      [
        -6,
        -20
      ],
      [
        -8,
        -2
      ],
      [
        -9,
        -55
      ],
      [
        13,
        -58
      ],
      [
        -1,
        -10
      ],
      [
        -9,
        13
      ],
      [
        -5,
        -6
      ],
      [
        -7,
        11
      ],
      [
        -1,
        -13
      ]
    ],
    [
      [
        25194,
        57399
      ],
      [
        5,
        0
      ],
      [
        93,
        -1
      ]
    ],
    [
      [
        23336,
        66890
      ],
      [
        0,
        -405
      ]
    ],
    [
      [
        22026,
        60013
      ],
      [
        -31,
        0
      ],
      [
        -98,
        -2
      ],
      [
        -11,
        0
      ],
      [
        -11,
        -1
      ]
    ],
    [
      [
        21875,
        60010
      ],
      [
        -1,
        300
      ],
      [
        0,
        152
      ],
      [
        -5,
        0
      ]
    ],
    [
      [
        27001,
        63402
      ],
      [
        20,
        -5
      ],
      [
        -3,
        -103
      ],
      [
        28,
        -5
      ],
      [
        -1,
        -53
      ]
    ],
    [
      [
        22715,
        54561
      ],
      [
        0,
        -134
      ]
    ],
    [
      [
        27548,
        46452
      ],
      [
        6,
        49
      ],
      [
        13,
        106
      ],
      [
        7,
        41
      ],
      [
        0,
        -41
      ],
      [
        -8,
        -83
      ],
      [
        -13,
        -81
      ],
      [
        0,
        -3
      ]
    ],
    [
      [
        27380,
        46979
      ],
      [
        0,
        203
      ]
    ],
    [
      [
        27380,
        47182
      ],
      [
        54,
        -1
      ],
      [
        0,
        -25
      ],
      [
        103,
        0
      ],
      [
        4,
        -1
      ],
      [
        0,
        16
      ],
      [
        13,
        2
      ],
      [
        5,
        1
      ],
      [
        7,
        0
      ],
      [
        11,
        1
      ],
      [
        5,
        1
      ],
      [
        7,
        0
      ],
      [
        1,
        1
      ]
    ],
    [
      [
        27590,
        47177
      ],
      [
        0,
        -69
      ],
      [
        -1,
        -38
      ],
      [
        0,
        -13
      ],
      [
        1,
        -36
      ],
      [
        -1,
        -27
      ],
      [
        -1,
        -31
      ],
      [
        -1,
        -22
      ],
      [
        -1,
        -12
      ],
      [
        -1,
        -11
      ],
      [
        0,
        -3
      ],
      [
        -2,
        -11
      ],
      [
        -3,
        -44
      ],
      [
        0,
        -23
      ],
      [
        1,
        -8
      ],
      [
        -1,
        -13
      ],
      [
        -2,
        0
      ],
      [
        -4,
        23
      ],
      [
        2,
        30
      ],
      [
        1,
        13
      ],
      [
        0,
        8
      ],
      [
        -2,
        11
      ],
      [
        -3,
        9
      ],
      [
        -4,
        -2
      ],
      [
        -9,
        -14
      ],
      [
        -3,
        -9
      ],
      [
        -1,
        -9
      ],
      [
        -2,
        -33
      ],
      [
        -4,
        -35
      ],
      [
        0,
        -8
      ],
      [
        -3,
        -17
      ],
      [
        -3,
        -7
      ],
      [
        -3,
        -10
      ],
      [
        -1,
        -10
      ],
      [
        -1,
        -24
      ],
      [
        0,
        -21
      ],
      [
        1,
        -9
      ],
      [
        -3,
        -33
      ],
      [
        -3,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -39
      ],
      [
        0,
        -39
      ],
      [
        3,
        -27
      ],
      [
        2,
        -6
      ],
      [
        -2,
        -17
      ],
      [
        0,
        -29
      ],
      [
        2,
        -8
      ],
      [
        3,
        -2
      ],
      [
        1,
        -6
      ],
      [
        -1,
        -13
      ],
      [
        -7,
        -40
      ],
      [
        -5,
        -10
      ],
      [
        -3,
        -3
      ],
      [
        -3,
        -12
      ],
      [
        -1,
        -13
      ]
    ],
    [
      [
        27485,
        46274
      ],
      [
        -3,
        8
      ],
      [
        -2,
        15
      ],
      [
        -2,
        3
      ],
      [
        -6,
        -18
      ],
      [
        -8,
        -4
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        -1
      ],
      [
        -6,
        0
      ],
      [
        -8,
        -11
      ],
      [
        -7,
        -4
      ],
      [
        -4,
        -21
      ],
      [
        -7,
        -19
      ],
      [
        -3,
        -1
      ],
      [
        -3,
        16
      ],
      [
        -5,
        -2
      ],
      [
        0,
        -17
      ],
      [
        -1,
        -3
      ],
      [
        -11,
        25
      ],
      [
        -2,
        16
      ],
      [
        -5,
        4
      ],
      [
        -3,
        -13
      ],
      [
        -5,
        3
      ],
      [
        -2,
        1
      ],
      [
        -3,
        -2
      ]
    ],
    [
      [
        22342,
        59034
      ],
      [
        89,
        4
      ]
    ],
    [
      [
        22225,
        58628
      ],
      [
        -2,
        101
      ],
      [
        0,
        132
      ]
    ],
    [
      [
        22895,
        56601
      ],
      [
        0,
        -68
      ],
      [
        10,
        0
      ],
      [
        0,
        -68
      ]
    ],
    [
      [
        22905,
        56465
      ],
      [
        -3,
        -6
      ]
    ],
    [
      [
        27208,
        65402
      ],
      [
        7,
        20
      ],
      [
        6,
        28
      ],
      [
        15,
        40
      ],
      [
        10,
        24
      ],
      [
        14,
        26
      ],
      [
        5,
        12
      ],
      [
        1,
        -1
      ],
      [
        5,
        -2
      ],
      [
        4,
        4
      ],
      [
        18,
        29
      ],
      [
        20,
        36
      ],
      [
        5,
        6
      ],
      [
        1,
        1
      ],
      [
        11,
        19
      ],
      [
        8,
        8
      ],
      [
        4,
        9
      ],
      [
        2,
        1
      ]
    ],
    [
      [
        27344,
        65662
      ],
      [
        -1,
        -150
      ],
      [
        0,
        -13
      ]
    ],
    [
      [
        22987,
        50986
      ],
      [
        -5,
        19
      ]
    ],
    [
      [
        15812,
        62181
      ],
      [
        1,
        4
      ],
      [
        -9,
        42
      ],
      [
        5,
        25
      ],
      [
        14,
        0
      ],
      [
        4,
        -2
      ]
    ],
    [
      [
        27026,
        52029
      ],
      [
        26,
        0
      ]
    ],
    [
      [
        27052,
        51535
      ],
      [
        -2,
        -1
      ]
    ],
    [
      [
        27470,
        57925
      ],
      [
        -14,
        -46
      ],
      [
        -15,
        -51
      ],
      [
        -19,
        -62
      ],
      [
        -4,
        -14
      ],
      [
        -9,
        -27
      ],
      [
        -10,
        -10
      ],
      [
        -2,
        -8
      ],
      [
        -3,
        -5
      ],
      [
        -5,
        -18
      ]
    ],
    [
      [
        25266,
        63967
      ],
      [
        0,
        -136
      ]
    ],
    [
      [
        15513,
        69827
      ],
      [
        -5,
        0
      ],
      [
        0,
        16
      ],
      [
        6,
        1
      ],
      [
        1,
        51
      ],
      [
        5,
        0
      ],
      [
        0,
        35
      ],
      [
        5,
        0
      ],
      [
        0,
        16
      ],
      [
        6,
        0
      ],
      [
        0,
        17
      ],
      [
        11,
        0
      ],
      [
        0,
        34
      ],
      [
        12,
        0
      ],
      [
        0,
        16
      ],
      [
        6,
        0
      ],
      [
        0,
        17
      ],
      [
        -12,
        0
      ],
      [
        0,
        17
      ],
      [
        -11,
        0
      ],
      [
        0,
        16
      ],
      [
        -12,
        0
      ],
      [
        0,
        17
      ],
      [
        -6,
        0
      ],
      [
        0,
        17
      ],
      [
        -5,
        0
      ],
      [
        0,
        17
      ],
      [
        -6,
        0
      ],
      [
        0,
        34
      ],
      [
        34,
        0
      ],
      [
        0,
        82
      ]
    ],
    [
      [
        28543,
        62588
      ],
      [
        0,
        4
      ],
      [
        13,
        14
      ],
      [
        3,
        -5
      ],
      [
        3,
        -2
      ],
      [
        3,
        16
      ]
    ],
    [
      [
        28589,
        62579
      ],
      [
        0,
        -19
      ],
      [
        2,
        -14
      ],
      [
        2,
        -4
      ],
      [
        2,
        -4
      ],
      [
        1,
        -2
      ],
      [
        2,
        -10
      ],
      [
        5,
        4
      ],
      [
        2,
        -4
      ],
      [
        1,
        -7
      ],
      [
        5,
        -13
      ],
      [
        4,
        -8
      ],
      [
        2,
        -5
      ],
      [
        1,
        -1
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -16
      ],
      [
        2,
        -31
      ],
      [
        1,
        -5
      ],
      [
        0,
        -9
      ],
      [
        -3,
        -15
      ],
      [
        -2,
        -10
      ],
      [
        10,
        -23
      ],
      [
        2,
        -12
      ],
      [
        1,
        -13
      ],
      [
        -8,
        -26
      ],
      [
        -2,
        -2
      ],
      [
        -6,
        -5
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        -1
      ],
      [
        -3,
        -1
      ],
      [
        0,
        -6
      ],
      [
        1,
        -13
      ],
      [
        2,
        -9
      ],
      [
        2,
        0
      ],
      [
        2,
        -9
      ],
      [
        -3,
        -20
      ],
      [
        1,
        -11
      ],
      [
        -1,
        -9
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        5
      ],
      [
        -2,
        3
      ],
      [
        -4,
        -4
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -17
      ],
      [
        1,
        -1
      ],
      [
        0,
        -12
      ],
      [
        -6,
        -17
      ],
      [
        -2,
        -8
      ],
      [
        0,
        -14
      ],
      [
        1,
        0
      ],
      [
        2,
        -3
      ],
      [
        3,
        6
      ],
      [
        2,
        -12
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -25
      ],
      [
        -4,
        -19
      ],
      [
        -4,
        -7
      ],
      [
        0,
        -9
      ],
      [
        -3,
        -11
      ],
      [
        -6,
        -12
      ],
      [
        0,
        -27
      ],
      [
        2,
        -11
      ],
      [
        2,
        -8
      ],
      [
        4,
        0
      ],
      [
        1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -13
      ]
    ],
    [
      [
        28546,
        62046
      ],
      [
        -3,
        6
      ],
      [
        -5,
        28
      ],
      [
        4,
        12
      ],
      [
        -2,
        32
      ],
      [
        3,
        8
      ],
      [
        2,
        43
      ],
      [
        5,
        32
      ],
      [
        -1,
        10
      ],
      [
        2,
        13
      ],
      [
        -6,
        21
      ],
      [
        -2,
        69
      ],
      [
        -13,
        38
      ],
      [
        -2,
        21
      ],
      [
        -7,
        12
      ],
      [
        -4,
        1
      ],
      [
        -3,
        19
      ],
      [
        -8,
        8
      ],
      [
        -2,
        3
      ],
      [
        2,
        5
      ],
      [
        1,
        20
      ],
      [
        -4,
        12
      ]
    ],
    [
      [
        24200,
        63447
      ],
      [
        -16,
        1
      ],
      [
        0,
        98
      ]
    ],
    [
      [
        24041,
        63153
      ],
      [
        3,
        393
      ]
    ],
    [
      [
        25208,
        55688
      ],
      [
        101,
        2
      ]
    ],
    [
      [
        25297,
        55272
      ],
      [
        -129,
        -4
      ]
    ],
    [
      [
        24826,
        53417
      ],
      [
        -4,
        -8
      ],
      [
        -8,
        0
      ],
      [
        -7,
        25
      ],
      [
        -38,
        0
      ]
    ],
    [
      [
        22663,
        60009
      ],
      [
        -66,
        0
      ],
      [
        -1,
        -1
      ],
      [
        -19,
        0
      ]
    ],
    [
      [
        23827,
        60339
      ],
      [
        -119,
        9
      ]
    ],
    [
      [
        24750,
        67741
      ],
      [
        147,
        0
      ]
    ],
    [
      [
        24882,
        67235
      ],
      [
        -6,
        -13
      ],
      [
        -12,
        -8
      ],
      [
        -26,
        8
      ],
      [
        -8,
        -14
      ],
      [
        -3,
        -12
      ],
      [
        -4,
        -7
      ],
      [
        -1,
        -24
      ],
      [
        -8,
        17
      ],
      [
        -9,
        -1
      ],
      [
        -12,
        8
      ],
      [
        -7,
        -11
      ],
      [
        -3,
        8
      ]
    ],
    [
      [
        23831,
        59921
      ],
      [
        -111,
        9
      ],
      [
        -15,
        1
      ]
    ],
    [
      [
        28228,
        58692
      ],
      [
        -2,
        -14
      ],
      [
        -2,
        -21
      ],
      [
        -9,
        14
      ],
      [
        -11,
        -15
      ],
      [
        -5,
        -7
      ],
      [
        -60,
        -99
      ],
      [
        -9,
        -9
      ],
      [
        -3,
        -8
      ]
    ],
    [
      [
        16575,
        68516
      ],
      [
        -68,
        0
      ],
      [
        0,
        96
      ],
      [
        -34,
        1
      ],
      [
        0,
        57
      ],
      [
        -102,
        -3
      ],
      [
        0,
        148
      ]
    ],
    [
      [
        26808,
        61378
      ],
      [
        -5,
        -8
      ],
      [
        -4,
        8
      ],
      [
        -5,
        -3
      ],
      [
        -4,
        8
      ],
      [
        0,
        11
      ],
      [
        -5,
        4
      ],
      [
        -1,
        16
      ],
      [
        -4,
        -12
      ],
      [
        -4,
        5
      ],
      [
        -3,
        -24
      ],
      [
        -1,
        12
      ],
      [
        -6,
        20
      ],
      [
        -2,
        18
      ],
      [
        -5,
        5
      ],
      [
        -9,
        18
      ],
      [
        -7,
        26
      ],
      [
        -5,
        3
      ],
      [
        -3,
        -17
      ],
      [
        -9,
        -18
      ],
      [
        0,
        -31
      ],
      [
        -4,
        -19
      ],
      [
        -3,
        -2
      ]
    ],
    [
      [
        26898,
        58893
      ],
      [
        0,
        -3
      ],
      [
        1,
        -4
      ],
      [
        1,
        -3
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -14
      ],
      [
        0,
        -15
      ],
      [
        2,
        -2
      ],
      [
        1,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -11
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -5
      ],
      [
        1,
        -1
      ],
      [
        2,
        -2
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        3,
        -1
      ],
      [
        1,
        -1
      ],
      [
        0,
        -6
      ],
      [
        1,
        -1
      ],
      [
        2,
        -3
      ],
      [
        2,
        -2
      ],
      [
        2,
        8
      ],
      [
        1,
        4
      ],
      [
        2,
        4
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        1,
        3
      ],
      [
        2,
        1
      ],
      [
        1,
        2
      ],
      [
        1,
        1
      ],
      [
        1,
        0
      ],
      [
        2,
        2
      ]
    ],
    [
      [
        28310,
        62161
      ],
      [
        1,
        -12
      ],
      [
        6,
        5
      ],
      [
        -1,
        -13
      ],
      [
        3,
        -6
      ],
      [
        -1,
        -10
      ],
      [
        4,
        -8
      ],
      [
        -1,
        -13
      ],
      [
        5,
        1
      ],
      [
        2,
        -4
      ],
      [
        5,
        0
      ],
      [
        1,
        8
      ],
      [
        1,
        1
      ],
      [
        3,
        -28
      ]
    ],
    [
      [
        28338,
        62082
      ],
      [
        6,
        -8
      ],
      [
        1,
        -27
      ],
      [
        6,
        -1
      ],
      [
        2,
        -30
      ],
      [
        3,
        -15
      ],
      [
        2,
        14
      ],
      [
        12,
        -12
      ],
      [
        -2,
        -12
      ],
      [
        7,
        4
      ],
      [
        5,
        -10
      ],
      [
        2,
        -2
      ],
      [
        3,
        -10
      ],
      [
        4,
        -14
      ],
      [
        1,
        -2
      ],
      [
        2,
        -5
      ],
      [
        5,
        -24
      ],
      [
        0,
        -11
      ]
    ],
    [
      [
        28397,
        61917
      ],
      [
        -5,
        1
      ],
      [
        -2,
        -4
      ],
      [
        0,
        -8
      ],
      [
        1,
        -9
      ],
      [
        -1,
        -35
      ],
      [
        -5,
        -9
      ],
      [
        0,
        -3
      ],
      [
        1,
        -17
      ],
      [
        -4,
        -22
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -11
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -11
      ],
      [
        -3,
        -10
      ],
      [
        0,
        -3
      ]
    ],
    [
      [
        29050,
        63047
      ],
      [
        -7,
        27
      ],
      [
        -2,
        39
      ],
      [
        -5,
        26
      ],
      [
        -4,
        13
      ],
      [
        -12,
        9
      ],
      [
        -3,
        15
      ],
      [
        -8,
        13
      ],
      [
        1,
        18
      ],
      [
        -6,
        19
      ],
      [
        -2,
        19
      ],
      [
        -4,
        8
      ],
      [
        -2,
        -13
      ],
      [
        -4,
        6
      ],
      [
        4,
        16
      ],
      [
        0,
        2
      ],
      [
        -1,
        0
      ],
      [
        0,
        8
      ],
      [
        1,
        0
      ],
      [
        -1,
        1
      ],
      [
        1,
        0
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -4,
        11
      ],
      [
        2,
        30
      ],
      [
        -10,
        26
      ],
      [
        -6,
        30
      ]
    ],
    [
      [
        22255,
        72032
      ],
      [
        0,
        303
      ]
    ],
    [
      [
        25759,
        70041
      ],
      [
        4,
        -4
      ],
      [
        3,
        -8
      ],
      [
        6,
        -25
      ],
      [
        5,
        -13
      ],
      [
        2,
        -14
      ],
      [
        -1,
        -6
      ],
      [
        -4,
        -17
      ],
      [
        -3,
        1
      ],
      [
        -4,
        36
      ],
      [
        -8,
        26
      ],
      [
        -6,
        17
      ],
      [
        6,
        7
      ]
    ],
    [
      [
        25732,
        69922
      ],
      [
        5,
        2
      ],
      [
        3,
        -14
      ],
      [
        2,
        -23
      ],
      [
        -3,
        -12
      ],
      [
        -6,
        15
      ],
      [
        -2,
        17
      ],
      [
        1,
        15
      ]
    ],
    [
      [
        25823,
        70205
      ],
      [
        -1,
        2
      ],
      [
        -4,
        -2
      ],
      [
        -2,
        -13
      ],
      [
        -3,
        3
      ],
      [
        -2,
        6
      ],
      [
        -3,
        -2
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -13
      ],
      [
        -1,
        -18
      ],
      [
        -2,
        -12
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        -9,
        10
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -8
      ],
      [
        1,
        -27
      ],
      [
        -1,
        -18
      ],
      [
        -2,
        -1
      ],
      [
        -5,
        5
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -6
      ],
      [
        4,
        -45
      ],
      [
        0,
        -16
      ],
      [
        -2,
        8
      ],
      [
        -3,
        6
      ],
      [
        -4,
        -3
      ],
      [
        -5,
        7
      ],
      [
        -6,
        14
      ],
      [
        0,
        7
      ],
      [
        -2,
        9
      ],
      [
        -4,
        2
      ],
      [
        -3,
        22
      ],
      [
        0,
        10
      ],
      [
        1,
        8
      ],
      [
        3,
        8
      ],
      [
        4,
        -3
      ],
      [
        4,
        4
      ],
      [
        3,
        12
      ],
      [
        0,
        8
      ],
      [
        -1,
        2
      ],
      [
        -1,
        12
      ],
      [
        3,
        10
      ],
      [
        4,
        4
      ],
      [
        4,
        17
      ],
      [
        0,
        19
      ],
      [
        1,
        21
      ],
      [
        3,
        2
      ],
      [
        2,
        -5
      ],
      [
        4,
        -4
      ],
      [
        4,
        3
      ],
      [
        2,
        12
      ],
      [
        -1,
        4
      ],
      [
        -1,
        3
      ],
      [
        2,
        8
      ],
      [
        1,
        5
      ],
      [
        2,
        -2
      ],
      [
        2,
        5
      ],
      [
        1,
        6
      ],
      [
        -1,
        10
      ],
      [
        1,
        11
      ],
      [
        1,
        5
      ],
      [
        1,
        1
      ],
      [
        2,
        4
      ],
      [
        3,
        15
      ],
      [
        0,
        25
      ],
      [
        -1,
        9
      ],
      [
        -2,
        9
      ],
      [
        -4,
        8
      ],
      [
        -4,
        4
      ],
      [
        -4,
        -2
      ],
      [
        -3,
        -16
      ],
      [
        -3,
        -10
      ],
      [
        -2,
        0
      ],
      [
        -4,
        -9
      ],
      [
        -2,
        -10
      ],
      [
        0,
        -19
      ],
      [
        -4,
        -11
      ],
      [
        -20,
        13
      ],
      [
        -3,
        4
      ],
      [
        -3,
        19
      ],
      [
        -2,
        3
      ],
      [
        -3,
        0
      ],
      [
        -6,
        -9
      ],
      [
        -1,
        -6
      ],
      [
        0,
        -29
      ],
      [
        2,
        -3
      ],
      [
        1,
        -7
      ],
      [
        0,
        -12
      ],
      [
        -3,
        -19
      ],
      [
        -5,
        -17
      ],
      [
        -5,
        -11
      ],
      [
        -1,
        -6
      ],
      [
        1,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        -4,
        -18
      ],
      [
        -1,
        -14
      ],
      [
        1,
        -8
      ],
      [
        -9,
        -14
      ],
      [
        -2,
        2
      ],
      [
        -5,
        -1
      ],
      [
        -2,
        -2
      ],
      [
        -5,
        -14
      ],
      [
        -7,
        -2
      ],
      [
        -5,
        -27
      ],
      [
        -1,
        3
      ],
      [
        0,
        11
      ],
      [
        -1,
        8
      ],
      [
        -3,
        6
      ],
      [
        -1,
        11
      ],
      [
        1,
        16
      ],
      [
        1,
        10
      ],
      [
        1,
        29
      ],
      [
        -2,
        15
      ],
      [
        0,
        30
      ],
      [
        -2,
        22
      ],
      [
        -5,
        24
      ],
      [
        -3,
        8
      ],
      [
        -4,
        -1
      ],
      [
        -2,
        -4
      ],
      [
        -4,
        -14
      ],
      [
        -1,
        -11
      ],
      [
        -1,
        -13
      ],
      [
        1,
        -26
      ],
      [
        -2,
        -15
      ],
      [
        0,
        -15
      ],
      [
        2,
        -2
      ],
      [
        1,
        -4
      ],
      [
        -1,
        -13
      ],
      [
        -1,
        -5
      ],
      [
        -3,
        -16
      ],
      [
        3,
        -12
      ],
      [
        -10,
        -9
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        -3,
        -11
      ],
      [
        -5,
        -4
      ],
      [
        -12,
        -24
      ],
      [
        -7,
        -29
      ],
      [
        -7,
        -43
      ],
      [
        -4,
        -13
      ],
      [
        -8,
        -42
      ],
      [
        0,
        -2
      ]
    ],
    [
      [
        26360,
        62096
      ],
      [
        -20,
        1
      ],
      [
        -3,
        11
      ]
    ],
    [
      [
        30595,
        67889
      ],
      [
        3,
        9
      ],
      [
        4,
        3
      ],
      [
        4,
        -8
      ],
      [
        -1,
        -13
      ],
      [
        -4,
        -9
      ],
      [
        -6,
        6
      ],
      [
        0,
        12
      ]
    ],
    [
      [
        30583,
        68114
      ],
      [
        -5,
        -6
      ],
      [
        -10,
        1
      ],
      [
        3,
        -25
      ],
      [
        -1,
        -15
      ],
      [
        -1,
        -12
      ],
      [
        -3,
        -3
      ],
      [
        -13,
        -34
      ],
      [
        -1,
        -13
      ],
      [
        -4,
        -37
      ],
      [
        -4,
        -7
      ],
      [
        0,
        6
      ],
      [
        1,
        9
      ],
      [
        -2,
        28
      ],
      [
        -1,
        8
      ],
      [
        -6,
        7
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -6
      ],
      [
        2,
        -14
      ],
      [
        -2,
        -23
      ],
      [
        -2,
        -1
      ],
      [
        -3,
        5
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -22
      ],
      [
        -3,
        -6
      ],
      [
        -5,
        -5
      ],
      [
        0,
        14
      ],
      [
        2,
        0
      ],
      [
        2,
        6
      ],
      [
        1,
        24
      ],
      [
        -2,
        9
      ],
      [
        -3,
        -1
      ],
      [
        -2,
        -16
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -6
      ],
      [
        -3,
        12
      ],
      [
        0,
        8
      ],
      [
        -1,
        3
      ],
      [
        -4,
        -12
      ],
      [
        -1,
        -22
      ],
      [
        0,
        -16
      ],
      [
        1,
        -14
      ],
      [
        -3,
        -14
      ],
      [
        -2,
        14
      ],
      [
        -5,
        29
      ],
      [
        0,
        5
      ],
      [
        -2,
        4
      ],
      [
        -2,
        1
      ]
    ],
    [
      [
        26486,
        61309
      ],
      [
        28,
        -183
      ],
      [
        4,
        -32
      ]
    ],
    [
      [
        26508,
        60985
      ],
      [
        -10,
        -4
      ],
      [
        -6,
        16
      ],
      [
        1,
        -14
      ],
      [
        -5,
        -14
      ],
      [
        -2,
        34
      ]
    ],
    [
      [
        26415,
        61049
      ],
      [
        -4,
        7
      ],
      [
        3,
        11
      ],
      [
        -2,
        9
      ],
      [
        4,
        6
      ],
      [
        -2,
        16
      ],
      [
        8,
        38
      ],
      [
        -3,
        -2
      ],
      [
        0,
        42
      ],
      [
        11,
        21
      ],
      [
        -2,
        13
      ],
      [
        -1,
        3
      ],
      [
        2,
        8
      ],
      [
        0,
        32
      ]
    ],
    [
      [
        27541,
        58268
      ],
      [
        31,
        1
      ]
    ],
    [
      [
        27572,
        58269
      ],
      [
        2,
        -22
      ],
      [
        4,
        -12
      ],
      [
        6,
        0
      ],
      [
        9,
        -18
      ],
      [
        2,
        -34
      ],
      [
        3,
        -17
      ],
      [
        -1,
        -16
      ],
      [
        9,
        -18
      ],
      [
        3,
        -17
      ],
      [
        -4,
        -17
      ],
      [
        0,
        -16
      ],
      [
        -5,
        -25
      ],
      [
        1,
        -17
      ],
      [
        -4,
        -24
      ],
      [
        0,
        -17
      ],
      [
        -1,
        -20
      ],
      [
        2,
        -22
      ],
      [
        3,
        -8
      ],
      [
        5,
        -32
      ],
      [
        2,
        -34
      ],
      [
        -6,
        -34
      ]
    ],
    [
      [
        27546,
        57910
      ],
      [
        -6,
        -3
      ],
      [
        -7,
        -23
      ],
      [
        -9,
        -10
      ],
      [
        -4,
        17
      ],
      [
        -5,
        -16
      ],
      [
        -11,
        2
      ],
      [
        -3,
        -7
      ],
      [
        -8,
        6
      ],
      [
        -4,
        16
      ],
      [
        -7,
        6
      ]
    ],
    [
      [
        25805,
        58095
      ],
      [
        -16,
        19
      ],
      [
        -5,
        -7
      ]
    ],
    [
      [
        25784,
        58107
      ],
      [
        -5,
        2
      ],
      [
        -11,
        80
      ],
      [
        0,
        24
      ],
      [
        -2,
        42
      ],
      [
        3,
        96
      ],
      [
        5,
        3
      ],
      [
        -7,
        6
      ],
      [
        3,
        6
      ],
      [
        3,
        115
      ]
    ],
    [
      [
        27950,
        60654
      ],
      [
        4,
        18
      ],
      [
        -5,
        15
      ],
      [
        0,
        16
      ],
      [
        5,
        8
      ],
      [
        -3,
        20
      ],
      [
        0,
        14
      ],
      [
        6,
        13
      ],
      [
        4,
        0
      ],
      [
        13,
        -12
      ],
      [
        8,
        10
      ],
      [
        -2,
        25
      ],
      [
        2,
        12
      ],
      [
        7,
        7
      ],
      [
        -3,
        17
      ],
      [
        6,
        4
      ],
      [
        3,
        -19
      ],
      [
        4,
        -2
      ],
      [
        3,
        9
      ],
      [
        -4,
        20
      ],
      [
        3,
        35
      ]
    ],
    [
      [
        31439,
        38340
      ],
      [
        9,
        0
      ],
      [
        5,
        12
      ]
    ],
    [
      [
        16761,
        70487
      ],
      [
        -6,
        -24
      ],
      [
        -5,
        -12
      ],
      [
        -10,
        -12
      ],
      [
        -9,
        -19
      ],
      [
        -9,
        -11
      ],
      [
        -12,
        -6
      ],
      [
        -7,
        0
      ],
      [
        -8,
        6
      ],
      [
        -9,
        8
      ],
      [
        -18,
        -8
      ],
      [
        -12,
        -13
      ],
      [
        -19,
        -4
      ]
    ],
    [
      [
        27290,
        53687
      ],
      [
        -2,
        0
      ],
      [
        -3,
        -12
      ],
      [
        -8,
        -6
      ],
      [
        -3,
        4
      ],
      [
        -2,
        -9
      ],
      [
        -1,
        -18
      ],
      [
        0,
        -2
      ],
      [
        1,
        -2
      ],
      [
        12,
        -2
      ],
      [
        1,
        1
      ],
      [
        4,
        11
      ],
      [
        2,
        -2
      ],
      [
        3,
        -10
      ],
      [
        1,
        -6
      ],
      [
        0,
        -6
      ],
      [
        -3,
        -16
      ],
      [
        -5,
        -35
      ],
      [
        -11,
        -59
      ],
      [
        -4,
        -21
      ],
      [
        -5,
        -43
      ],
      [
        0,
        -19
      ],
      [
        -1,
        -29
      ],
      [
        2,
        0
      ],
      [
        2,
        -3
      ],
      [
        3,
        -10
      ],
      [
        -1,
        -13
      ],
      [
        -3,
        -11
      ]
    ],
    [
      [
        29870,
        67610
      ],
      [
        1,
        6
      ],
      [
        11,
        48
      ],
      [
        12,
        42
      ],
      [
        9,
        -78
      ],
      [
        5,
        18
      ],
      [
        6,
        -8
      ],
      [
        5,
        18
      ],
      [
        7,
        1
      ],
      [
        2,
        -6
      ]
    ],
    [
      [
        23619,
        51345
      ],
      [
        -36,
        -59
      ],
      [
        -26,
        -43
      ],
      [
        -10,
        -20
      ],
      [
        -11,
        -24
      ],
      [
        -7,
        -17
      ],
      [
        -4,
        -15
      ],
      [
        -4,
        -23
      ],
      [
        -2,
        -16
      ],
      [
        -4,
        0
      ],
      [
        -5,
        -9
      ],
      [
        -4,
        0
      ],
      [
        -1,
        3
      ],
      [
        -1,
        13
      ],
      [
        5,
        21
      ],
      [
        3,
        9
      ],
      [
        9,
        29
      ],
      [
        5,
        12
      ],
      [
        5,
        35
      ],
      [
        2,
        6
      ],
      [
        2,
        6
      ],
      [
        2,
        2
      ],
      [
        3,
        -1
      ],
      [
        3,
        -5
      ],
      [
        5,
        3
      ],
      [
        5,
        9
      ],
      [
        4,
        10
      ],
      [
        0,
        18
      ],
      [
        1,
        7
      ],
      [
        3,
        13
      ],
      [
        4,
        8
      ],
      [
        3,
        -3
      ],
      [
        2,
        -6
      ],
      [
        4,
        -7
      ],
      [
        6,
        2
      ],
      [
        5,
        6
      ],
      [
        -3,
        21
      ],
      [
        -2,
        0
      ]
    ],
    [
      [
        23415,
        50841
      ],
      [
        2,
        7
      ],
      [
        26,
        65
      ],
      [
        3,
        19
      ],
      [
        32,
        99
      ],
      [
        4,
        9
      ],
      [
        4,
        4
      ],
      [
        7,
        10
      ],
      [
        0,
        45
      ],
      [
        4,
        10
      ],
      [
        7,
        -20
      ],
      [
        1,
        -1
      ],
      [
        1,
        2
      ],
      [
        9,
        -3
      ],
      [
        0,
        3
      ],
      [
        4,
        1
      ],
      [
        2,
        -7
      ],
      [
        -2,
        0
      ],
      [
        -11,
        -31
      ],
      [
        -4,
        -17
      ],
      [
        -5,
        -13
      ],
      [
        -62,
        -153
      ],
      [
        -16,
        -43
      ],
      [
        -8,
        -26
      ],
      [
        -2,
        -12
      ]
    ],
    [
      [
        23439,
        51344
      ],
      [
        1,
        -17
      ],
      [
        3,
        -18
      ],
      [
        1,
        -4
      ],
      [
        5,
        -12
      ],
      [
        7,
        -7
      ],
      [
        13,
        -10
      ],
      [
        -1,
        -11
      ],
      [
        -3,
        -21
      ],
      [
        -2,
        -22
      ],
      [
        3,
        -3
      ],
      [
        8,
        -17
      ],
      [
        1,
        -21
      ],
      [
        1,
        -57
      ],
      [
        -3,
        -33
      ],
      [
        1,
        -34
      ],
      [
        -2,
        -6
      ],
      [
        -6,
        -25
      ],
      [
        -9,
        10
      ],
      [
        -19,
        -71
      ],
      [
        -10,
        -31
      ]
    ],
    [
      [
        20922,
        65124
      ],
      [
        0,
        200
      ]
    ],
    [
      [
        28860,
        63072
      ],
      [
        1,
        6
      ],
      [
        2,
        3
      ],
      [
        1,
        3
      ],
      [
        1,
        7
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        2,
        9
      ],
      [
        0,
        2
      ],
      [
        2,
        5
      ],
      [
        1,
        3
      ],
      [
        1,
        6
      ],
      [
        1,
        7
      ],
      [
        0,
        13
      ]
    ],
    [
      [
        28901,
        63263
      ],
      [
        10,
        -56
      ],
      [
        0,
        -23
      ],
      [
        11,
        -26
      ],
      [
        3,
        -16
      ],
      [
        9,
        -5
      ],
      [
        2,
        -7
      ],
      [
        10,
        -1
      ],
      [
        1,
        -17
      ],
      [
        4,
        -3
      ],
      [
        9,
        6
      ],
      [
        39,
        -114
      ]
    ],
    [
      [
        28903,
        62783
      ],
      [
        -4,
        6
      ],
      [
        -3,
        5
      ],
      [
        -3,
        13
      ],
      [
        -7,
        43
      ],
      [
        -3,
        -1
      ],
      [
        -2,
        3
      ],
      [
        -6,
        14
      ],
      [
        -1,
        7
      ],
      [
        -7,
        2
      ],
      [
        -2,
        11
      ],
      [
        -1,
        11
      ],
      [
        1,
        20
      ],
      [
        4,
        1
      ],
      [
        0,
        4
      ],
      [
        -1,
        5
      ],
      [
        0,
        6
      ],
      [
        1,
        19
      ],
      [
        0,
        10
      ],
      [
        -1,
        1
      ],
      [
        -1,
        5
      ],
      [
        1,
        3
      ],
      [
        2,
        6
      ],
      [
        2,
        8
      ],
      [
        1,
        8
      ],
      [
        0,
        22
      ],
      [
        -2,
        3
      ],
      [
        0,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -2,
        5
      ],
      [
        -1,
        3
      ],
      [
        -1,
        3
      ],
      [
        0,
        1
      ],
      [
        -1,
        2
      ],
      [
        -1,
        1
      ],
      [
        -2,
        6
      ],
      [
        -1,
        5
      ]
    ],
    [
      [
        15363,
        69375
      ],
      [
        0,
        4
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        3
      ],
      [
        1,
        17
      ],
      [
        1,
        14
      ],
      [
        2,
        10
      ],
      [
        0,
        -1
      ],
      [
        4,
        11
      ],
      [
        4,
        60
      ],
      [
        2,
        65
      ],
      [
        -1,
        18
      ],
      [
        3,
        74
      ],
      [
        -1,
        43
      ],
      [
        -2,
        23
      ],
      [
        -2,
        2
      ],
      [
        -8,
        -2
      ],
      [
        0,
        3
      ],
      [
        8,
        10
      ],
      [
        2,
        8
      ],
      [
        2,
        37
      ],
      [
        1,
        51
      ],
      [
        -1,
        22
      ],
      [
        -2,
        21
      ],
      [
        -1,
        26
      ],
      [
        2,
        4
      ],
      [
        1,
        0
      ],
      [
        2,
        20
      ],
      [
        3,
        64
      ],
      [
        -3,
        7
      ],
      [
        2,
        17
      ],
      [
        3,
        88
      ],
      [
        0,
        55
      ],
      [
        -1,
        21
      ],
      [
        -1,
        7
      ],
      [
        -6,
        28
      ],
      [
        -4,
        6
      ],
      [
        0,
        7
      ],
      [
        4,
        17
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        29408,
        67351
      ],
      [
        -5,
        90
      ],
      [
        -5,
        120
      ],
      [
        -2,
        13
      ],
      [
        8,
        64
      ],
      [
        -2,
        12
      ],
      [
        7,
        8
      ],
      [
        18,
        77
      ],
      [
        3,
        2
      ],
      [
        6,
        20
      ],
      [
        2,
        44
      ],
      [
        4,
        17
      ],
      [
        3,
        39
      ],
      [
        0,
        33
      ],
      [
        -3,
        3
      ],
      [
        9,
        37
      ]
    ],
    [
      [
        23355,
        73978
      ],
      [
        46,
        0
      ],
      [
        0,
        449
      ],
      [
        1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        1,
        -2
      ],
      [
        1,
        0
      ],
      [
        5,
        -11
      ],
      [
        3,
        -3
      ],
      [
        1,
        0
      ],
      [
        2,
        -2
      ],
      [
        0,
        -2
      ],
      [
        4,
        -2
      ],
      [
        9,
        -10
      ],
      [
        2,
        0
      ],
      [
        10,
        4
      ],
      [
        7,
        15
      ],
      [
        4,
        -2
      ],
      [
        5,
        3
      ],
      [
        1,
        -2
      ],
      [
        12,
        -21
      ],
      [
        1,
        -2
      ],
      [
        8,
        -18
      ],
      [
        7,
        -10
      ],
      [
        4,
        -1
      ],
      [
        6,
        -3
      ],
      [
        -2,
        -14
      ],
      [
        0,
        -17
      ],
      [
        7,
        -93
      ],
      [
        0,
        -20
      ],
      [
        7,
        -84
      ],
      [
        0,
        -5
      ],
      [
        7,
        -25
      ],
      [
        8,
        -116
      ],
      [
        10,
        -135
      ],
      [
        0,
        -13
      ],
      [
        -2,
        -4
      ],
      [
        0,
        -18
      ],
      [
        2,
        -16
      ],
      [
        -4,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -8
      ],
      [
        3,
        -18
      ],
      [
        0,
        -23
      ],
      [
        1,
        -13
      ],
      [
        1,
        -3
      ],
      [
        4,
        -7
      ],
      [
        2,
        -4
      ],
      [
        2,
        -7
      ],
      [
        2,
        -5
      ],
      [
        2,
        -7
      ],
      [
        0,
        -7
      ],
      [
        1,
        -3
      ],
      [
        6,
        -5
      ],
      [
        2,
        -6
      ],
      [
        3,
        -4
      ],
      [
        2,
        -5
      ],
      [
        1,
        -5
      ],
      [
        1,
        -3
      ],
      [
        5,
        -2
      ],
      [
        4,
        1
      ],
      [
        2,
        -2
      ],
      [
        1,
        -3
      ],
      [
        2,
        -11
      ],
      [
        1,
        -2
      ],
      [
        2,
        1
      ],
      [
        5,
        -2
      ],
      [
        2,
        -2
      ],
      [
        4,
        0
      ],
      [
        6,
        -3
      ],
      [
        4,
        -4
      ],
      [
        1,
        1
      ],
      [
        2,
        2
      ],
      [
        3,
        7
      ]
    ],
    [
      [
        15675,
        63014
      ],
      [
        42,
        1
      ],
      [
        -1,
        -84
      ],
      [
        2,
        -18
      ],
      [
        0,
        -50
      ],
      [
        -3,
        -18
      ],
      [
        1,
        -60
      ]
    ],
    [
      [
        26801,
        56208
      ],
      [
        -3,
        21
      ],
      [
        -7,
        34
      ],
      [
        0,
        5
      ],
      [
        3,
        20
      ],
      [
        4,
        10
      ],
      [
        5,
        44
      ],
      [
        6,
        10
      ],
      [
        3,
        23
      ],
      [
        6,
        23
      ],
      [
        4,
        29
      ],
      [
        5,
        7
      ],
      [
        3,
        15
      ],
      [
        6,
        0
      ],
      [
        9,
        11
      ],
      [
        4,
        25
      ]
    ],
    [
      [
        24019,
        62414
      ],
      [
        8,
        23
      ],
      [
        0,
        13
      ],
      [
        -7,
        4
      ],
      [
        -4,
        9
      ],
      [
        1,
        17
      ],
      [
        6,
        11
      ],
      [
        4,
        19
      ],
      [
        1,
        22
      ],
      [
        4,
        17
      ],
      [
        8,
        24
      ],
      [
        3,
        29
      ]
    ],
    [
      [
        28869,
        64023
      ],
      [
        -9,
        -43
      ],
      [
        -2,
        -14
      ],
      [
        -20,
        -99
      ],
      [
        -16,
        -83
      ]
    ],
    [
      [
        25999,
        59326
      ],
      [
        4,
        102
      ]
    ],
    [
      [
        31375,
        38454
      ],
      [
        1,
        1
      ],
      [
        5,
        -7
      ],
      [
        12,
        -9
      ],
      [
        3,
        0
      ],
      [
        2,
        2
      ],
      [
        2,
        8
      ],
      [
        0,
        3
      ],
      [
        1,
        6
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        26535,
        62069
      ],
      [
        5,
        -3
      ],
      [
        4,
        -4
      ],
      [
        2,
        -3
      ],
      [
        2,
        -4
      ],
      [
        2,
        -6
      ],
      [
        1,
        -5
      ],
      [
        0,
        -5
      ],
      [
        1,
        -6
      ],
      [
        0,
        -8
      ],
      [
        1,
        -4
      ],
      [
        0,
        -6
      ],
      [
        1,
        -5
      ],
      [
        1,
        -2
      ],
      [
        3,
        -8
      ],
      [
        3,
        -2
      ],
      [
        2,
        -1
      ],
      [
        2,
        -2
      ],
      [
        2,
        -4
      ],
      [
        1,
        -2
      ],
      [
        1,
        -5
      ],
      [
        1,
        -12
      ],
      [
        1,
        -16
      ],
      [
        0,
        -5
      ],
      [
        1,
        -10
      ],
      [
        1,
        -4
      ],
      [
        1,
        -3
      ],
      [
        1,
        0
      ],
      [
        3,
        -3
      ],
      [
        4,
        -2
      ],
      [
        4,
        -2
      ],
      [
        1,
        -1
      ],
      [
        1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        2,
        -2
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        25722,
        65552
      ],
      [
        13,
        28
      ],
      [
        17,
        40
      ],
      [
        10,
        30
      ],
      [
        17,
        57
      ],
      [
        1,
        5
      ],
      [
        5,
        24
      ],
      [
        4,
        28
      ],
      [
        0,
        1
      ],
      [
        5,
        44
      ],
      [
        2,
        22
      ],
      [
        7,
        43
      ],
      [
        7,
        42
      ],
      [
        2,
        13
      ],
      [
        3,
        24
      ],
      [
        1,
        15
      ],
      [
        6,
        19
      ],
      [
        8,
        34
      ],
      [
        9,
        38
      ],
      [
        0,
        3
      ],
      [
        5,
        22
      ],
      [
        6,
        30
      ]
    ],
    [
      [
        25805,
        65551
      ],
      [
        -63,
        0
      ],
      [
        -14,
        1
      ],
      [
        -6,
        0
      ]
    ],
    [
      [
        27947,
        61230
      ],
      [
        -5,
        -13
      ],
      [
        -1,
        -5
      ],
      [
        -4,
        -4
      ],
      [
        -5,
        -39
      ],
      [
        -4,
        -8
      ],
      [
        -1,
        -14
      ],
      [
        4,
        1
      ],
      [
        -3,
        -36
      ],
      [
        -10,
        -7
      ],
      [
        -5,
        -23
      ],
      [
        -6,
        -17
      ],
      [
        -7,
        -28
      ],
      [
        -3,
        13
      ],
      [
        -8,
        -3
      ],
      [
        -2,
        26
      ],
      [
        -3,
        5
      ],
      [
        -15,
        -19
      ],
      [
        -8,
        -14
      ],
      [
        -3,
        3
      ]
    ],
    [
      [
        24526,
        56657
      ],
      [
        -2,
        -13
      ],
      [
        -5,
        4
      ],
      [
        -2,
        -28
      ],
      [
        -6,
        8
      ],
      [
        -7,
        -26
      ],
      [
        2,
        -9
      ],
      [
        -2,
        -16
      ],
      [
        0,
        -19
      ],
      [
        3,
        -3
      ],
      [
        0,
        -17
      ],
      [
        4,
        -2
      ],
      [
        4,
        -25
      ],
      [
        -1,
        -17
      ],
      [
        7,
        -20
      ],
      [
        0,
        -8
      ],
      [
        -5,
        -20
      ],
      [
        -5,
        24
      ],
      [
        -8,
        -6
      ],
      [
        -3,
        2
      ],
      [
        -1,
        20
      ],
      [
        -4,
        7
      ],
      [
        -3,
        -5
      ],
      [
        -4,
        -20
      ],
      [
        -3,
        1
      ],
      [
        -2,
        17
      ],
      [
        -4,
        1
      ],
      [
        -6,
        -14
      ],
      [
        -13,
        -5
      ],
      [
        -1,
        8
      ],
      [
        9,
        18
      ],
      [
        1,
        24
      ],
      [
        -8,
        3
      ],
      [
        -7,
        -23
      ],
      [
        -5,
        0
      ],
      [
        -8,
        37
      ]
    ],
    [
      [
        28814,
        58772
      ],
      [
        2,
        4
      ],
      [
        4,
        0
      ],
      [
        4,
        -3
      ],
      [
        1,
        -5
      ],
      [
        3,
        -4
      ],
      [
        4,
        -11
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -11
      ],
      [
        2,
        -3
      ],
      [
        5,
        -22
      ],
      [
        5,
        -34
      ],
      [
        -1,
        -10
      ],
      [
        2,
        -37
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        0
      ],
      [
        -4,
        11
      ],
      [
        -8,
        6
      ],
      [
        -2,
        8
      ],
      [
        4,
        10
      ],
      [
        0,
        27
      ],
      [
        -1,
        9
      ],
      [
        -2,
        15
      ],
      [
        -3,
        1
      ],
      [
        -4,
        21
      ],
      [
        0,
        9
      ],
      [
        -2,
        7
      ],
      [
        -6,
        12
      ],
      [
        -1,
        9
      ],
      [
        1,
        3
      ]
    ],
    [
      [
        28806,
        57915
      ],
      [
        2,
        4
      ],
      [
        4,
        1
      ],
      [
        4,
        6
      ],
      [
        3,
        5
      ],
      [
        2,
        9
      ],
      [
        2,
        2
      ],
      [
        2,
        9
      ],
      [
        1,
        2
      ],
      [
        2,
        -5
      ],
      [
        3,
        -1
      ],
      [
        7,
        8
      ],
      [
        2,
        5
      ],
      [
        5,
        12
      ],
      [
        4,
        9
      ],
      [
        0,
        5
      ],
      [
        1,
        7
      ],
      [
        0,
        3
      ],
      [
        3,
        -4
      ],
      [
        1,
        -2
      ],
      [
        6,
        2
      ],
      [
        7,
        8
      ],
      [
        2,
        18
      ],
      [
        1,
        35
      ],
      [
        2,
        21
      ],
      [
        1,
        31
      ],
      [
        2,
        28
      ],
      [
        2,
        43
      ],
      [
        1,
        35
      ],
      [
        2,
        36
      ],
      [
        0,
        47
      ],
      [
        2,
        15
      ],
      [
        1,
        17
      ],
      [
        0,
        54
      ],
      [
        -2,
        25
      ],
      [
        -1,
        25
      ],
      [
        -3,
        28
      ],
      [
        -2,
        17
      ],
      [
        -3,
        47
      ],
      [
        0,
        17
      ],
      [
        -3,
        41
      ],
      [
        1,
        3
      ],
      [
        2,
        -5
      ],
      [
        4,
        -31
      ],
      [
        2,
        -17
      ],
      [
        5,
        -58
      ],
      [
        5,
        -95
      ],
      [
        0,
        -18
      ],
      [
        -1,
        -32
      ],
      [
        -2,
        -86
      ],
      [
        -5,
        -103
      ],
      [
        -4,
        -83
      ],
      [
        -6,
        -100
      ],
      [
        -3,
        -10
      ],
      [
        -3,
        3
      ],
      [
        -4,
        4
      ],
      [
        -6,
        -1
      ],
      [
        -8,
        -4
      ],
      [
        -7,
        -8
      ],
      [
        -10,
        -14
      ],
      [
        -16,
        -21
      ],
      [
        -6,
        -6
      ]
    ],
    [
      [
        28801,
        59116
      ],
      [
        0,
        -3
      ],
      [
        3,
        -28
      ],
      [
        6,
        -59
      ],
      [
        6,
        -47
      ],
      [
        6,
        -42
      ],
      [
        11,
        -67
      ],
      [
        24,
        -183
      ],
      [
        5,
        -48
      ],
      [
        4,
        -28
      ],
      [
        2,
        -12
      ],
      [
        -1,
        -9
      ],
      [
        -2,
        0
      ],
      [
        -2,
        7
      ],
      [
        -1,
        11
      ],
      [
        -3,
        5
      ],
      [
        -2,
        18
      ],
      [
        -1,
        9
      ],
      [
        -4,
        26
      ],
      [
        -3,
        26
      ],
      [
        -6,
        29
      ],
      [
        -1,
        20
      ],
      [
        -1,
        18
      ],
      [
        -2,
        13
      ],
      [
        -3,
        21
      ],
      [
        -4,
        18
      ],
      [
        -2,
        2
      ],
      [
        0,
        8
      ],
      [
        -1,
        8
      ],
      [
        -2,
        10
      ],
      [
        -13,
        11
      ],
      [
        0,
        21
      ],
      [
        1,
        13
      ],
      [
        0,
        6
      ],
      [
        -1,
        4
      ],
      [
        -3,
        0
      ],
      [
        -1,
        7
      ],
      [
        0,
        33
      ],
      [
        -3,
        53
      ],
      [
        -1,
        11
      ],
      [
        0,
        12
      ],
      [
        -1,
        14
      ],
      [
        -5,
        43
      ],
      [
        -3,
        24
      ],
      [
        -2,
        19
      ],
      [
        0,
        1
      ]
    ],
    [
      [
        28734,
        58461
      ],
      [
        0,
        1
      ],
      [
        7,
        115
      ],
      [
        0,
        80
      ],
      [
        3,
        70
      ],
      [
        3,
        2
      ],
      [
        1,
        3
      ],
      [
        4,
        22
      ],
      [
        4,
        9
      ],
      [
        1,
        0
      ],
      [
        1,
        4
      ],
      [
        0,
        10
      ],
      [
        -3,
        12
      ],
      [
        -2,
        2
      ],
      [
        -1,
        4
      ],
      [
        0,
        5
      ],
      [
        3,
        6
      ],
      [
        11,
        14
      ],
      [
        5,
        2
      ],
      [
        5,
        -1
      ],
      [
        3,
        -2
      ],
      [
        12,
        -20
      ],
      [
        1,
        -6
      ],
      [
        1,
        -11
      ],
      [
        5,
        -11
      ],
      [
        0,
        -8
      ],
      [
        1,
        -12
      ],
      [
        3,
        -19
      ],
      [
        5,
        -27
      ],
      [
        -1,
        -8
      ],
      [
        2,
        -22
      ],
      [
        3,
        -16
      ],
      [
        3,
        -19
      ],
      [
        0,
        -13
      ],
      [
        -2,
        -24
      ],
      [
        -2,
        -15
      ],
      [
        0,
        -8
      ],
      [
        1,
        -4
      ],
      [
        3,
        -29
      ],
      [
        2,
        -33
      ],
      [
        1,
        -7
      ],
      [
        0,
        -17
      ],
      [
        -8,
        -25
      ],
      [
        0,
        -20
      ],
      [
        2,
        -20
      ],
      [
        2,
        -11
      ],
      [
        0,
        -3
      ],
      [
        -5,
        -18
      ],
      [
        -4,
        -8
      ],
      [
        -5,
        -13
      ],
      [
        1,
        -15
      ],
      [
        -6,
        -6
      ],
      [
        -11,
        -4
      ],
      [
        -4,
        9
      ],
      [
        -2,
        9
      ],
      [
        -3,
        -4
      ]
    ],
    [
      [
        26672,
        51474
      ],
      [
        0,
        4
      ],
      [
        -6,
        8
      ],
      [
        -3,
        0
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        1
      ],
      [
        -7,
        17
      ],
      [
        0,
        9
      ],
      [
        -3,
        12
      ],
      [
        -6,
        9
      ],
      [
        -7,
        8
      ],
      [
        -2,
        10
      ],
      [
        -2,
        12
      ],
      [
        -3,
        22
      ],
      [
        -4,
        8
      ],
      [
        -2,
        9
      ],
      [
        0,
        10
      ],
      [
        1,
        3
      ],
      [
        0,
        6
      ],
      [
        -1,
        23
      ],
      [
        -3,
        19
      ],
      [
        -2,
        10
      ],
      [
        -4,
        6
      ],
      [
        -5,
        51
      ],
      [
        -7,
        16
      ],
      [
        -5,
        22
      ],
      [
        -2,
        6
      ],
      [
        -20,
        40
      ],
      [
        -8,
        22
      ],
      [
        -12,
        7
      ],
      [
        -4,
        18
      ],
      [
        -24,
        47
      ],
      [
        -1,
        3
      ],
      [
        1,
        3
      ],
      [
        -1,
        3
      ],
      [
        -7,
        22
      ],
      [
        -9,
        22
      ]
    ],
    [
      [
        26156,
        57665
      ],
      [
        12,
        0
      ],
      [
        1,
        1
      ],
      [
        11,
        0
      ],
      [
        37,
        1
      ],
      [
        19,
        1
      ]
    ],
    [
      [
        24799,
        56705
      ],
      [
        5,
        0
      ],
      [
        45,
        -1
      ],
      [
        7,
        6
      ]
    ],
    [
      [
        22247,
        72637
      ],
      [
        -144,
        0
      ]
    ],
    [
      [
        27250,
        56748
      ],
      [
        6,
        -13
      ],
      [
        5,
        -24
      ],
      [
        -3,
        -26
      ],
      [
        0,
        -2
      ],
      [
        5,
        -28
      ],
      [
        1,
        0
      ],
      [
        4,
        -23
      ],
      [
        11,
        5
      ],
      [
        14,
        -11
      ],
      [
        3,
        -3
      ],
      [
        1,
        -4
      ],
      [
        5,
        -11
      ],
      [
        4,
        -10
      ],
      [
        3,
        -15
      ],
      [
        2,
        -5
      ],
      [
        3,
        -17
      ],
      [
        2,
        -16
      ],
      [
        13,
        -25
      ],
      [
        3,
        -28
      ],
      [
        7,
        -47
      ],
      [
        1,
        -5
      ],
      [
        0,
        -1
      ],
      [
        -4,
        -19
      ],
      [
        6,
        -13
      ],
      [
        -1,
        -28
      ]
    ],
    [
      [
        27341,
        56379
      ],
      [
        -7,
        -11
      ],
      [
        0,
        -26
      ],
      [
        -3,
        -69
      ],
      [
        -2,
        -13
      ],
      [
        -1,
        -36
      ],
      [
        6,
        -2
      ],
      [
        1,
        22
      ],
      [
        6,
        20
      ],
      [
        13,
        -5
      ],
      [
        7,
        -9
      ],
      [
        4,
        -15
      ],
      [
        -5,
        -9
      ],
      [
        -3,
        -13
      ],
      [
        -10,
        -7
      ],
      [
        -14,
        -29
      ]
    ],
    [
      [
        28579,
        63178
      ],
      [
        14,
        1
      ],
      [
        21,
        0
      ],
      [
        7,
        -1
      ],
      [
        0,
        1
      ],
      [
        4,
        0
      ],
      [
        2,
        -1
      ],
      [
        4,
        1
      ],
      [
        40,
        0
      ]
    ],
    [
      [
        28716,
        62971
      ],
      [
        -5,
        -7
      ],
      [
        -6,
        -48
      ],
      [
        1,
        -11
      ],
      [
        2,
        -9
      ],
      [
        2,
        -3
      ],
      [
        4,
        2
      ],
      [
        3,
        -3
      ],
      [
        4,
        -27
      ],
      [
        0,
        -5
      ],
      [
        -6,
        -13
      ],
      [
        -1,
        2
      ],
      [
        -5,
        -3
      ],
      [
        -4,
        -10
      ],
      [
        -1,
        -7
      ],
      [
        -7,
        -19
      ],
      [
        -4,
        2
      ],
      [
        -3,
        -17
      ],
      [
        -3,
        -17
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        -10
      ],
      [
        -7,
        -17
      ],
      [
        -4,
        10
      ],
      [
        -3,
        21
      ],
      [
        2,
        29
      ],
      [
        5,
        25
      ],
      [
        -2,
        36
      ],
      [
        -6,
        -8
      ],
      [
        1,
        -22
      ],
      [
        -1,
        -22
      ],
      [
        -4,
        -10
      ],
      [
        0,
        -17
      ],
      [
        -5,
        -24
      ],
      [
        5,
        -14
      ],
      [
        3,
        -20
      ],
      [
        -5,
        -19
      ],
      [
        -2,
        -27
      ],
      [
        -4,
        2
      ],
      [
        2,
        19
      ],
      [
        -3,
        14
      ],
      [
        1,
        24
      ],
      [
        -7,
        9
      ],
      [
        4,
        8
      ],
      [
        1,
        20
      ],
      [
        -3,
        9
      ],
      [
        -1,
        0
      ],
      [
        -3,
        -2
      ],
      [
        -6,
        6
      ],
      [
        -2,
        1
      ],
      [
        0,
        -5
      ]
    ],
    [
      [
        28638,
        62792
      ],
      [
        0,
        1
      ],
      [
        -1,
        4
      ],
      [
        0,
        1
      ],
      [
        -3,
        12
      ],
      [
        -1,
        19
      ],
      [
        -3,
        45
      ],
      [
        -10,
        21
      ],
      [
        -3,
        12
      ],
      [
        -1,
        16
      ],
      [
        -16,
        29
      ],
      [
        -5,
        -3
      ],
      [
        -6,
        23
      ],
      [
        -4,
        51
      ],
      [
        -3,
        11
      ],
      [
        -2,
        20
      ],
      [
        0,
        56
      ],
      [
        -1,
        68
      ]
    ],
    [
      [
        25875,
        66319
      ],
      [
        4,
        28
      ],
      [
        3,
        43
      ],
      [
        2,
        69
      ],
      [
        2,
        29
      ],
      [
        2,
        22
      ],
      [
        1,
        13
      ],
      [
        -1,
        50
      ],
      [
        0,
        8
      ],
      [
        3,
        23
      ],
      [
        2,
        29
      ],
      [
        0,
        3
      ],
      [
        1,
        32
      ],
      [
        0,
        36
      ],
      [
        -1,
        15
      ],
      [
        0,
        5
      ]
    ],
    [
      [
        23165,
        59340
      ],
      [
        33,
        0
      ],
      [
        20,
        -1
      ]
    ],
    [
      [
        23218,
        59339
      ],
      [
        5,
        0
      ],
      [
        0,
        -33
      ],
      [
        -5,
        -1
      ],
      [
        0,
        -151
      ],
      [
        -1,
        -17
      ],
      [
        0,
        -101
      ],
      [
        15,
        0
      ]
    ],
    [
      [
        22571,
        51212
      ],
      [
        3,
        10
      ],
      [
        0,
        32
      ],
      [
        -6,
        10
      ],
      [
        -6,
        -10
      ],
      [
        -1,
        21
      ],
      [
        -5,
        6
      ],
      [
        -5,
        25
      ],
      [
        -4,
        2
      ],
      [
        -5,
        37
      ],
      [
        -10,
        -5
      ],
      [
        -7,
        11
      ],
      [
        0,
        7
      ],
      [
        -4,
        27
      ],
      [
        1,
        5
      ]
    ],
    [
      [
        29897,
        68564
      ],
      [
        -4,
        -8
      ],
      [
        -3,
        -1
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        0
      ],
      [
        0,
        1
      ],
      [
        -2,
        3
      ],
      [
        -6,
        8
      ],
      [
        -1,
        1
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -2,
        2
      ],
      [
        -3,
        0
      ],
      [
        -2,
        -1
      ],
      [
        -5,
        1
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -6
      ],
      [
        -1,
        -1
      ],
      [
        -4,
        -6
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        2
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -22
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -10
      ],
      [
        -1,
        -8
      ],
      [
        0,
        -3
      ],
      [
        1,
        0
      ],
      [
        1,
        -6
      ],
      [
        0,
        -8
      ],
      [
        2,
        -11
      ],
      [
        1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -11
      ],
      [
        -1,
        -10
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -8
      ],
      [
        2,
        -6
      ],
      [
        1,
        -6
      ],
      [
        1,
        -14
      ],
      [
        2,
        -7
      ],
      [
        1,
        -1
      ],
      [
        1,
        -3
      ]
    ],
    [
      [
        28421,
        63584
      ],
      [
        12,
        -19
      ],
      [
        7,
        -29
      ],
      [
        14,
        -17
      ],
      [
        14,
        -92
      ],
      [
        0,
        -22
      ],
      [
        -5,
        -26
      ],
      [
        8,
        -43
      ],
      [
        0,
        -1
      ],
      [
        -6,
        -10
      ],
      [
        -6,
        -19
      ],
      [
        0,
        -129
      ]
    ],
    [
      [
        28398,
        63177
      ],
      [
        -67,
        0
      ]
    ],
    [
      [
        28331,
        63177
      ],
      [
        -2,
        151
      ],
      [
        -1,
        110
      ]
    ],
    [
      [
        15811,
        73081
      ],
      [
        0,
        1
      ],
      [
        -8,
        4
      ],
      [
        -1,
        4
      ],
      [
        -1,
        0
      ],
      [
        -5,
        -4
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -3
      ],
      [
        1,
        -14
      ],
      [
        2,
        0
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        -15
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        2
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        -7
      ],
      [
        0,
        -14
      ],
      [
        1,
        -11
      ],
      [
        9,
        -42
      ],
      [
        9,
        -20
      ],
      [
        9,
        -30
      ],
      [
        5,
        -30
      ],
      [
        1,
        -7
      ],
      [
        -2,
        -1
      ],
      [
        -3,
        3
      ],
      [
        -3,
        9
      ],
      [
        -1,
        5
      ],
      [
        -1,
        10
      ],
      [
        -2,
        8
      ],
      [
        -6,
        21
      ],
      [
        -8,
        13
      ],
      [
        -5,
        19
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        -9
      ],
      [
        -1,
        0
      ],
      [
        -6,
        15
      ],
      [
        -3,
        32
      ],
      [
        -4,
        26
      ],
      [
        -1,
        30
      ],
      [
        2,
        16
      ],
      [
        -1,
        20
      ],
      [
        2,
        11
      ],
      [
        7,
        8
      ],
      [
        1,
        0
      ],
      [
        1,
        -4
      ],
      [
        1,
        -1
      ],
      [
        4,
        -1
      ],
      [
        1,
        4
      ],
      [
        3,
        17
      ],
      [
        0,
        1
      ],
      [
        16,
        -22
      ],
      [
        1,
        1
      ]
    ],
    [
      [
        15707,
        73080
      ],
      [
        5,
        38
      ],
      [
        6,
        22
      ],
      [
        2,
        29
      ],
      [
        5,
        13
      ],
      [
        9,
        46
      ],
      [
        2,
        23
      ],
      [
        0,
        32
      ],
      [
        6,
        4
      ],
      [
        3,
        -1
      ],
      [
        3,
        -5
      ],
      [
        2,
        8
      ],
      [
        2,
        5
      ],
      [
        2,
        -2
      ],
      [
        1,
        -5
      ],
      [
        1,
        -9
      ],
      [
        3,
        -3
      ],
      [
        -1,
        -37
      ],
      [
        1,
        -12
      ],
      [
        5,
        -6
      ],
      [
        4,
        -7
      ],
      [
        10,
        -25
      ],
      [
        2,
        -12
      ],
      [
        1,
        -11
      ],
      [
        0,
        -3
      ],
      [
        -4,
        -11
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -3
      ],
      [
        -6,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -5,
        15
      ],
      [
        -2,
        4
      ],
      [
        -4,
        0
      ],
      [
        -6,
        -4
      ],
      [
        -2,
        -6
      ],
      [
        2,
        -7
      ],
      [
        -1,
        -16
      ],
      [
        -8,
        -5
      ],
      [
        0,
        -7
      ],
      [
        -5,
        -22
      ],
      [
        -14,
        -7
      ],
      [
        -2,
        -14
      ],
      [
        5,
        -10
      ],
      [
        11,
        12
      ],
      [
        11,
        -4
      ],
      [
        1,
        2
      ],
      [
        6,
        -16
      ],
      [
        5,
        -26
      ],
      [
        0,
        -5
      ],
      [
        1,
        -13
      ],
      [
        2,
        -18
      ],
      [
        2,
        -8
      ],
      [
        3,
        -34
      ],
      [
        0,
        -6
      ],
      [
        -4,
        -11
      ],
      [
        0,
        -3
      ],
      [
        5,
        -29
      ],
      [
        3,
        -29
      ],
      [
        2,
        -42
      ],
      [
        5,
        7
      ],
      [
        3,
        20
      ],
      [
        -2,
        23
      ],
      [
        1,
        19
      ],
      [
        -1,
        7
      ],
      [
        -3,
        18
      ],
      [
        4,
        1
      ],
      [
        6,
        -4
      ],
      [
        8,
        -30
      ],
      [
        4,
        -17
      ],
      [
        4,
        -10
      ],
      [
        9,
        -10
      ],
      [
        4,
        -3
      ],
      [
        3,
        0
      ],
      [
        1,
        -39
      ],
      [
        1,
        -6
      ],
      [
        4,
        -16
      ],
      [
        1,
        -15
      ],
      [
        0,
        -18
      ],
      [
        -2,
        -19
      ],
      [
        -3,
        -6
      ],
      [
        -2,
        -10
      ],
      [
        0,
        -15
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -3
      ],
      [
        -3,
        2
      ],
      [
        -2,
        8
      ],
      [
        -6,
        0
      ],
      [
        -3,
        3
      ],
      [
        -5,
        18
      ],
      [
        0,
        7
      ],
      [
        2,
        12
      ],
      [
        0,
        6
      ],
      [
        -2,
        13
      ],
      [
        -7,
        30
      ],
      [
        -4,
        2
      ],
      [
        -4,
        -4
      ],
      [
        -4,
        -7
      ],
      [
        -1,
        -7
      ],
      [
        -1,
        -2
      ],
      [
        -7,
        -7
      ],
      [
        -1,
        7
      ],
      [
        0,
        5
      ],
      [
        2,
        10
      ],
      [
        1,
        8
      ],
      [
        -1,
        4
      ],
      [
        -4,
        12
      ],
      [
        -6,
        4
      ],
      [
        -8,
        24
      ],
      [
        3,
        9
      ],
      [
        1,
        10
      ],
      [
        0,
        11
      ],
      [
        -5,
        19
      ],
      [
        0,
        8
      ],
      [
        1,
        10
      ],
      [
        3,
        26
      ],
      [
        -1,
        29
      ],
      [
        -2,
        19
      ],
      [
        -2,
        8
      ],
      [
        -5,
        5
      ],
      [
        -6,
        -1
      ],
      [
        -4,
        -6
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        1
      ],
      [
        -2,
        22
      ],
      [
        -1,
        8
      ],
      [
        -6,
        14
      ],
      [
        -6,
        8
      ],
      [
        -3,
        11
      ],
      [
        -5,
        7
      ],
      [
        -2,
        10
      ],
      [
        0,
        4
      ]
    ],
    [
      [
        22522,
        66858
      ],
      [
        3,
        -3
      ],
      [
        5,
        -6
      ],
      [
        3,
        -1
      ],
      [
        3,
        1
      ],
      [
        2,
        -2
      ],
      [
        1,
        -1
      ],
      [
        0,
        -4
      ],
      [
        5,
        -9
      ],
      [
        1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        1,
        -3
      ],
      [
        4,
        -7
      ],
      [
        4,
        -7
      ],
      [
        5,
        -5
      ],
      [
        3,
        0
      ],
      [
        3,
        2
      ]
    ],
    [
      [
        16705,
        63096
      ],
      [
        -1,
        -22
      ],
      [
        3,
        23
      ],
      [
        5,
        4
      ],
      [
        14,
        41
      ],
      [
        15,
        58
      ],
      [
        0,
        -12
      ],
      [
        -5,
        -8
      ],
      [
        0,
        -100
      ],
      [
        -3,
        0
      ],
      [
        -1,
        -138
      ],
      [
        -7,
        0
      ],
      [
        -1,
        -151
      ],
      [
        6,
        -1
      ],
      [
        0,
        -16
      ],
      [
        5,
        -2
      ],
      [
        0,
        -15
      ],
      [
        5,
        0
      ],
      [
        0,
        -17
      ],
      [
        5,
        0
      ],
      [
        0,
        -17
      ],
      [
        5,
        0
      ],
      [
        0,
        -17
      ],
      [
        6,
        0
      ],
      [
        0,
        -18
      ],
      [
        5,
        0
      ],
      [
        0,
        -17
      ],
      [
        6,
        0
      ],
      [
        0,
        -17
      ],
      [
        5,
        0
      ],
      [
        0,
        -17
      ],
      [
        5,
        0
      ],
      [
        0,
        -16
      ],
      [
        6,
        0
      ],
      [
        0,
        -17
      ],
      [
        5,
        0
      ],
      [
        0,
        -35
      ],
      [
        6,
        0
      ],
      [
        0,
        -14
      ],
      [
        5,
        0
      ],
      [
        1,
        -17
      ],
      [
        5,
        0
      ],
      [
        0,
        -18
      ],
      [
        5,
        0
      ],
      [
        0,
        -16
      ],
      [
        5,
        -1
      ],
      [
        0,
        -34
      ],
      [
        11,
        0
      ],
      [
        0,
        -44
      ]
    ],
    [
      [
        26301,
        60841
      ],
      [
        2,
        6
      ],
      [
        3,
        -6
      ],
      [
        0,
        18
      ],
      [
        3,
        -5
      ],
      [
        8,
        3
      ],
      [
        -5,
        5
      ],
      [
        4,
        15
      ],
      [
        -3,
        2
      ],
      [
        2,
        20
      ],
      [
        -6,
        8
      ],
      [
        4,
        19
      ],
      [
        -4,
        15
      ],
      [
        0,
        19
      ]
    ],
    [
      [
        26143,
        61748
      ],
      [
        -3,
        9
      ],
      [
        -11,
        8
      ],
      [
        -4,
        13
      ],
      [
        -14,
        1
      ],
      [
        -2,
        6
      ]
    ],
    [
      [
        27602,
        47579
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -64
      ],
      [
        -2,
        -17
      ],
      [
        -1,
        -20
      ],
      [
        -3,
        -98
      ],
      [
        -1,
        -60
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -7
      ],
      [
        -3,
        -117
      ],
      [
        0,
        -13
      ]
    ],
    [
      [
        27380,
        47182
      ],
      [
        -2,
        225
      ],
      [
        0,
        101
      ]
    ],
    [
      [
        21875,
        60010
      ],
      [
        -12,
        0
      ],
      [
        -17,
        -1
      ],
      [
        -6,
        1
      ],
      [
        -2,
        -1
      ],
      [
        -39,
        0
      ],
      [
        -11,
        -1
      ]
    ],
    [
      [
        22434,
        58223
      ],
      [
        0,
        -303
      ],
      [
        2,
        -119
      ],
      [
        -1,
        -5
      ]
    ],
    [
      [
        25983,
        54764
      ],
      [
        5,
        1
      ],
      [
        20,
        0
      ],
      [
        0,
        102
      ],
      [
        23,
        0
      ],
      [
        0,
        17
      ],
      [
        5,
        0
      ]
    ],
    [
      [
        28448,
        62089
      ],
      [
        -1,
        -14
      ],
      [
        0,
        -64
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -5
      ],
      [
        -3,
        -1
      ],
      [
        -2,
        2
      ],
      [
        0,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        -2
      ],
      [
        -2,
        -4
      ]
    ],
    [
      [
        28423,
        61914
      ],
      [
        -8,
        1
      ],
      [
        -5,
        -14
      ],
      [
        -7,
        -8
      ],
      [
        -1,
        1
      ],
      [
        0,
        7
      ],
      [
        -3,
        16
      ],
      [
        -2,
        0
      ]
    ],
    [
      [
        25102,
        70365
      ],
      [
        1,
        -401
      ],
      [
        0,
        -100
      ]
    ],
    [
      [
        16892,
        69318
      ],
      [
        0,
        99
      ],
      [
        -9,
        0
      ],
      [
        1,
        135
      ],
      [
        -31,
        0
      ],
      [
        0,
        71
      ],
      [
        -11,
        0
      ],
      [
        0,
        102
      ],
      [
        11,
        0
      ],
      [
        12,
        -6
      ],
      [
        0,
        17
      ],
      [
        52,
        0
      ],
      [
        0,
        86
      ],
      [
        6,
        0
      ],
      [
        0,
        16
      ],
      [
        6,
        0
      ],
      [
        5,
        -16
      ],
      [
        35,
        0
      ],
      [
        12,
        -2
      ],
      [
        0,
        51
      ],
      [
        23,
        0
      ],
      [
        -1,
        51
      ],
      [
        0,
        203
      ],
      [
        15,
        -1
      ],
      [
        0,
        99
      ],
      [
        5,
        0
      ],
      [
        0,
        51
      ],
      [
        21,
        0
      ],
      [
        0,
        51
      ]
    ],
    [
      [
        18821,
        64174
      ],
      [
        8,
        10
      ],
      [
        3,
        28
      ]
    ],
    [
      [
        26009,
        69884
      ],
      [
        3,
        11
      ],
      [
        2,
        -1
      ],
      [
        2,
        -12
      ],
      [
        0,
        -14
      ],
      [
        -1,
        -9
      ],
      [
        -4,
        14
      ],
      [
        -2,
        11
      ]
    ],
    [
      [
        25984,
        69839
      ],
      [
        7,
        -4
      ],
      [
        6,
        -13
      ],
      [
        3,
        -28
      ],
      [
        -2,
        -31
      ],
      [
        -11,
        51
      ],
      [
        -3,
        25
      ]
    ],
    [
      [
        25933,
        69486
      ],
      [
        2,
        14
      ],
      [
        2,
        7
      ],
      [
        2,
        2
      ],
      [
        3,
        -2
      ],
      [
        8,
        -3
      ],
      [
        3,
        -3
      ],
      [
        1,
        -2
      ],
      [
        4,
        -15
      ],
      [
        0,
        -21
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -31
      ],
      [
        0,
        -7
      ],
      [
        2,
        -9
      ],
      [
        0,
        -12
      ],
      [
        -6,
        -8
      ],
      [
        -4,
        9
      ],
      [
        -2,
        9
      ],
      [
        -5,
        18
      ],
      [
        -4,
        10
      ],
      [
        -2,
        6
      ],
      [
        0,
        5
      ],
      [
        -2,
        41
      ]
    ],
    [
      [
        25931,
        69065
      ],
      [
        0,
        31
      ],
      [
        2,
        19
      ],
      [
        0,
        16
      ],
      [
        -1,
        35
      ],
      [
        -1,
        23
      ],
      [
        1,
        13
      ],
      [
        1,
        11
      ],
      [
        2,
        6
      ],
      [
        6,
        6
      ],
      [
        2,
        -10
      ],
      [
        2,
        -5
      ],
      [
        4,
        -4
      ],
      [
        5,
        1
      ],
      [
        3,
        7
      ],
      [
        2,
        10
      ],
      [
        2,
        17
      ],
      [
        1,
        7
      ],
      [
        3,
        6
      ],
      [
        3,
        16
      ],
      [
        1,
        12
      ],
      [
        1,
        5
      ],
      [
        5,
        -1
      ],
      [
        5,
        -7
      ],
      [
        2,
        -5
      ],
      [
        3,
        -17
      ],
      [
        3,
        -5
      ],
      [
        4,
        -1
      ],
      [
        5,
        2
      ],
      [
        6,
        7
      ],
      [
        2,
        5
      ],
      [
        8,
        32
      ],
      [
        0,
        6
      ],
      [
        1,
        21
      ],
      [
        1,
        17
      ],
      [
        3,
        9
      ],
      [
        4,
        33
      ],
      [
        2,
        5
      ],
      [
        8,
        11
      ],
      [
        4,
        13
      ],
      [
        4,
        19
      ],
      [
        2,
        15
      ],
      [
        0,
        12
      ],
      [
        5,
        35
      ],
      [
        11,
        47
      ],
      [
        1,
        -2
      ],
      [
        1,
        -4
      ],
      [
        1,
        -3
      ],
      [
        4,
        0
      ],
      [
        2,
        2
      ],
      [
        6,
        14
      ],
      [
        1,
        9
      ],
      [
        3,
        12
      ],
      [
        2,
        0
      ],
      [
        4,
        -25
      ],
      [
        -1,
        -14
      ],
      [
        -2,
        -4
      ],
      [
        -4,
        -7
      ],
      [
        -2,
        -10
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -4
      ],
      [
        -1,
        0
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ],
      [
        -4,
        -3
      ],
      [
        -3,
        -4
      ],
      [
        -4,
        -26
      ],
      [
        1,
        -16
      ],
      [
        8,
        -49
      ],
      [
        2,
        -3
      ],
      [
        2,
        -11
      ],
      [
        0,
        -18
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        2
      ],
      [
        -1,
        14
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        -14
      ],
      [
        -1,
        -22
      ],
      [
        -6,
        -20
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -11
      ],
      [
        -4,
        -22
      ],
      [
        2,
        -7
      ],
      [
        3,
        -2
      ],
      [
        3,
        9
      ],
      [
        4,
        19
      ],
      [
        1,
        0
      ],
      [
        0,
        -74
      ],
      [
        -5,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        -4,
        -36
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -12
      ],
      [
        -1,
        -29
      ],
      [
        1,
        -20
      ],
      [
        2,
        -24
      ],
      [
        2,
        -24
      ],
      [
        -1,
        -17
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        25908,
        69335
      ],
      [
        0,
        9
      ],
      [
        4,
        26
      ],
      [
        1,
        3
      ],
      [
        6,
        6
      ],
      [
        6,
        -8
      ],
      [
        4,
        -12
      ],
      [
        -4,
        1
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -9
      ],
      [
        2,
        -12
      ],
      [
        -6,
        -10
      ],
      [
        -5,
        -3
      ],
      [
        -6,
        7
      ],
      [
        0,
        9
      ]
    ],
    [
      [
        28460,
        61498
      ],
      [
        2,
        -5
      ],
      [
        2,
        1
      ],
      [
        5,
        -21
      ],
      [
        2,
        -15
      ],
      [
        0,
        -8
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        0
      ],
      [
        0,
        -3
      ],
      [
        1,
        -15
      ],
      [
        7,
        -14
      ],
      [
        6,
        -3
      ],
      [
        2,
        -3
      ],
      [
        10,
        -29
      ],
      [
        10,
        -10
      ],
      [
        4,
        0
      ],
      [
        6,
        5
      ],
      [
        4,
        1
      ],
      [
        6,
        -2
      ],
      [
        2,
        -1
      ],
      [
        3,
        -5
      ],
      [
        1,
        -6
      ],
      [
        1,
        -5
      ],
      [
        1,
        -6
      ],
      [
        0,
        -1
      ],
      [
        4,
        -10
      ],
      [
        5,
        13
      ],
      [
        1,
        8
      ],
      [
        5,
        1
      ],
      [
        5,
        -11
      ],
      [
        6,
        1
      ],
      [
        1,
        4
      ],
      [
        3,
        2
      ],
      [
        4,
        -6
      ],
      [
        3,
        -23
      ],
      [
        1,
        -21
      ],
      [
        6,
        -18
      ],
      [
        10,
        -21
      ],
      [
        2,
        -9
      ],
      [
        4,
        -31
      ],
      [
        1,
        -9
      ]
    ],
    [
      [
        28476,
        61264
      ],
      [
        -13,
        12
      ],
      [
        -1,
        18
      ],
      [
        -4,
        7
      ],
      [
        -3,
        -18
      ],
      [
        -5,
        -2
      ],
      [
        -5,
        21
      ],
      [
        -1,
        41
      ],
      [
        -2,
        20
      ]
    ],
    [
      [
        26655,
        53063
      ],
      [
        -9,
        19
      ],
      [
        -12,
        7
      ],
      [
        -7,
        28
      ]
    ],
    [
      [
        25491,
        72136
      ],
      [
        4,
        5
      ],
      [
        4,
        6
      ],
      [
        9,
        -2
      ],
      [
        2,
        -7
      ],
      [
        -4,
        -12
      ],
      [
        -5,
        0
      ],
      [
        -6,
        3
      ],
      [
        -4,
        7
      ]
    ],
    [
      [
        25251,
        71984
      ],
      [
        4,
        9
      ],
      [
        6,
        23
      ],
      [
        2,
        16
      ],
      [
        3,
        15
      ],
      [
        12,
        36
      ],
      [
        8,
        16
      ],
      [
        18,
        22
      ],
      [
        6,
        10
      ],
      [
        5,
        12
      ],
      [
        13,
        9
      ],
      [
        3,
        6
      ],
      [
        2,
        7
      ],
      [
        1,
        5
      ],
      [
        0,
        3
      ],
      [
        10,
        11
      ],
      [
        8,
        3
      ],
      [
        3,
        3
      ],
      [
        15,
        7
      ],
      [
        3,
        -1
      ],
      [
        7,
        2
      ],
      [
        1,
        0
      ],
      [
        0,
        6
      ],
      [
        2,
        1
      ],
      [
        17,
        4
      ],
      [
        14,
        -1
      ],
      [
        7,
        -2
      ],
      [
        2,
        -2
      ],
      [
        22,
        -3
      ],
      [
        5,
        1
      ],
      [
        12,
        -15
      ],
      [
        7,
        -13
      ],
      [
        4,
        -11
      ],
      [
        2,
        -39
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        0
      ],
      [
        -6,
        5
      ],
      [
        -3,
        0
      ],
      [
        -2,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        -10,
        -7
      ],
      [
        -4,
        -9
      ],
      [
        -4,
        2
      ],
      [
        -2,
        5
      ],
      [
        -3,
        5
      ],
      [
        -3,
        0
      ],
      [
        -7,
        1
      ],
      [
        -17,
        -7
      ],
      [
        -4,
        -3
      ],
      [
        -2,
        -15
      ],
      [
        0,
        -7
      ],
      [
        1,
        -7
      ],
      [
        2,
        -7
      ],
      [
        2,
        -1
      ],
      [
        2,
        -10
      ],
      [
        0,
        -5
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -2
      ],
      [
        -3,
        0
      ],
      [
        -3,
        -2
      ],
      [
        -6,
        -11
      ],
      [
        -7,
        -19
      ],
      [
        -11,
        -10
      ],
      [
        -2,
        -3
      ],
      [
        -3,
        -10
      ],
      [
        -7,
        -30
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        -5
      ],
      [
        -5,
        -18
      ],
      [
        -8,
        -27
      ],
      [
        -9,
        -8
      ],
      [
        -3,
        1
      ],
      [
        -2,
        -1
      ],
      [
        -4,
        -11
      ]
    ],
    [
      [
        25045,
        72671
      ],
      [
        2,
        14
      ],
      [
        6,
        8
      ],
      [
        1,
        7
      ],
      [
        0,
        8
      ],
      [
        2,
        7
      ],
      [
        10,
        25
      ],
      [
        23,
        38
      ],
      [
        22,
        28
      ],
      [
        6,
        12
      ],
      [
        15,
        20
      ],
      [
        3,
        2
      ],
      [
        1,
        -2
      ],
      [
        3,
        1
      ],
      [
        6,
        10
      ],
      [
        0,
        7
      ],
      [
        16,
        25
      ],
      [
        6,
        0
      ],
      [
        1,
        -2
      ],
      [
        7,
        10
      ],
      [
        4,
        8
      ],
      [
        0,
        11
      ],
      [
        2,
        6
      ],
      [
        6,
        9
      ],
      [
        4,
        11
      ],
      [
        7,
        10
      ],
      [
        2,
        0
      ],
      [
        4,
        6
      ],
      [
        2,
        5
      ],
      [
        0,
        8
      ],
      [
        5,
        14
      ],
      [
        12,
        18
      ],
      [
        10,
        9
      ],
      [
        9,
        15
      ],
      [
        6,
        -11
      ],
      [
        7,
        3
      ],
      [
        2,
        8
      ],
      [
        3,
        6
      ],
      [
        6,
        4
      ],
      [
        4,
        -1
      ],
      [
        6,
        9
      ],
      [
        2,
        -12
      ],
      [
        -1,
        -11
      ],
      [
        -2,
        -5
      ],
      [
        -6,
        -4
      ],
      [
        -3,
        -5
      ],
      [
        -3,
        -7
      ],
      [
        -4,
        -18
      ],
      [
        -7,
        -18
      ],
      [
        -16,
        -33
      ],
      [
        -3,
        -11
      ],
      [
        0,
        -7
      ],
      [
        1,
        -3
      ],
      [
        0,
        -13
      ],
      [
        -1,
        -7
      ],
      [
        -25,
        -55
      ],
      [
        -14,
        -19
      ],
      [
        -15,
        -16
      ],
      [
        -5,
        -2
      ],
      [
        -12,
        -16
      ],
      [
        -5,
        0
      ],
      [
        -13,
        -14
      ],
      [
        -6,
        -9
      ],
      [
        -1,
        -9
      ],
      [
        -11,
        -17
      ],
      [
        -11,
        -17
      ],
      [
        -1,
        -14
      ],
      [
        3,
        -6
      ],
      [
        7,
        4
      ],
      [
        5,
        -5
      ],
      [
        15,
        14
      ],
      [
        0,
        -2
      ],
      [
        -4,
        -11
      ],
      [
        -24,
        -28
      ],
      [
        -7,
        -11
      ],
      [
        -6,
        -3
      ],
      [
        -3,
        -3
      ],
      [
        -14,
        -20
      ],
      [
        -5,
        -8
      ],
      [
        -9,
        -6
      ],
      [
        -9,
        9
      ],
      [
        -1,
        2
      ],
      [
        0,
        9
      ],
      [
        -3,
        11
      ],
      [
        -9,
        2
      ],
      [
        0,
        4
      ],
      [
        2,
        3
      ],
      [
        -5,
        15
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        7
      ]
    ],
    [
      [
        26883,
        54537
      ],
      [
        2,
        15
      ],
      [
        67,
        50
      ]
    ],
    [
      [
        21312,
        64669
      ],
      [
        0,
        -294
      ]
    ],
    [
      [
        27151,
        63319
      ],
      [
        -1,
        -101
      ]
    ],
    [
      [
        27376,
        54230
      ],
      [
        8,
        -12
      ],
      [
        2,
        3
      ],
      [
        2,
        -3
      ],
      [
        1,
        -15
      ],
      [
        0,
        -10
      ],
      [
        -2,
        -17
      ],
      [
        -4,
        -22
      ],
      [
        -6,
        -12
      ],
      [
        -4,
        -11
      ],
      [
        -4,
        -6
      ],
      [
        -5,
        1
      ],
      [
        0,
        14
      ],
      [
        -5,
        0
      ],
      [
        -7,
        -18
      ],
      [
        -1,
        -21
      ],
      [
        2,
        -9
      ],
      [
        4,
        -5
      ],
      [
        4,
        2
      ],
      [
        2,
        -5
      ],
      [
        -4,
        -15
      ],
      [
        -7,
        -21
      ],
      [
        -5,
        -24
      ],
      [
        -3,
        -1
      ],
      [
        -4,
        13
      ],
      [
        -7,
        10
      ],
      [
        -7,
        1
      ],
      [
        2,
        -22
      ],
      [
        0,
        -9
      ],
      [
        -1,
        -7
      ],
      [
        -4,
        -10
      ],
      [
        0,
        -8
      ],
      [
        6,
        -7
      ],
      [
        1,
        -1
      ],
      [
        1,
        3
      ],
      [
        2,
        -2
      ],
      [
        1,
        -4
      ],
      [
        0,
        -8
      ],
      [
        -3,
        -11
      ],
      [
        -6,
        -40
      ],
      [
        -2,
        -9
      ],
      [
        -6,
        -9
      ],
      [
        -9,
        -36
      ],
      [
        -2,
        -2
      ],
      [
        -5,
        6
      ]
    ],
    [
      [
        26217,
        53628
      ],
      [
        1,
        1
      ],
      [
        0,
        31
      ],
      [
        -4,
        31
      ],
      [
        0,
        57
      ],
      [
        -7,
        38
      ],
      [
        -12,
        49
      ],
      [
        2,
        44
      ],
      [
        -2,
        35
      ]
    ],
    [
      [
        27051,
        49122
      ],
      [
        0,
        304
      ],
      [
        -1,
        23
      ],
      [
        0,
        285
      ],
      [
        -14,
        0
      ]
    ],
    [
      [
        23058,
        55817
      ],
      [
        2,
        382
      ]
    ],
    [
      [
        26207,
        54898
      ],
      [
        2,
        0
      ],
      [
        26,
        -1
      ],
      [
        13,
        1
      ],
      [
        6,
        -1
      ],
      [
        2,
        0
      ],
      [
        0,
        -28
      ],
      [
        46,
        0
      ],
      [
        13,
        1
      ]
    ],
    [
      [
        24769,
        65578
      ],
      [
        6,
        12
      ],
      [
        2,
        3
      ],
      [
        8,
        9
      ],
      [
        1,
        4
      ],
      [
        1,
        3
      ],
      [
        0,
        3
      ],
      [
        -1,
        12
      ],
      [
        0,
        26
      ],
      [
        2,
        10
      ],
      [
        1,
        5
      ],
      [
        0,
        10
      ],
      [
        1,
        12
      ],
      [
        1,
        8
      ],
      [
        2,
        17
      ],
      [
        1,
        10
      ],
      [
        0,
        11
      ],
      [
        1,
        15
      ]
    ],
    [
      [
        27419,
        50455
      ],
      [
        6,
        -40
      ],
      [
        18,
        -92
      ],
      [
        8,
        -50
      ],
      [
        9,
        -43
      ],
      [
        3,
        -15
      ],
      [
        2,
        -27
      ],
      [
        2,
        -36
      ],
      [
        7,
        -61
      ],
      [
        3,
        -22
      ],
      [
        -1,
        -9
      ],
      [
        -10,
        -17
      ],
      [
        -3,
        -11
      ],
      [
        -4,
        -20
      ],
      [
        -2,
        -23
      ],
      [
        -1,
        -23
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -32
      ],
      [
        0,
        -55
      ],
      [
        1,
        -37
      ],
      [
        4,
        -93
      ],
      [
        6,
        -96
      ],
      [
        5,
        -54
      ],
      [
        1,
        -8
      ],
      [
        10,
        -83
      ],
      [
        18,
        -127
      ],
      [
        0,
        -1
      ]
    ],
    [
      [
        25721,
        57989
      ],
      [
        22,
        -12
      ],
      [
        3,
        9
      ],
      [
        11,
        40
      ],
      [
        17,
        30
      ],
      [
        10,
        7
      ],
      [
        0,
        44
      ]
    ],
    [
      [
        27266,
        63044
      ],
      [
        0,
        118
      ],
      [
        -10,
        0
      ],
      [
        1,
        189
      ],
      [
        21,
        -2
      ]
    ],
    [
      [
        24750,
        68340
      ],
      [
        0,
        -494
      ]
    ],
    [
      [
        26325,
        61179
      ],
      [
        0,
        16
      ],
      [
        3,
        30
      ],
      [
        5,
        71
      ],
      [
        1,
        14
      ]
    ],
    [
      [
        26118,
        60861
      ],
      [
        4,
        12
      ],
      [
        4,
        -2
      ],
      [
        0,
        29
      ],
      [
        6,
        -8
      ],
      [
        -1,
        31
      ],
      [
        5,
        -4
      ],
      [
        0,
        7
      ],
      [
        8,
        8
      ],
      [
        -1,
        13
      ],
      [
        4,
        31
      ],
      [
        6,
        9
      ],
      [
        -1,
        11
      ],
      [
        4,
        -5
      ],
      [
        6,
        5
      ],
      [
        -3,
        21
      ],
      [
        6,
        0
      ],
      [
        2,
        -13
      ],
      [
        3,
        19
      ],
      [
        -1,
        -18
      ],
      [
        4,
        -12
      ],
      [
        2,
        14
      ],
      [
        -2,
        6
      ],
      [
        2,
        21
      ],
      [
        -1,
        20
      ],
      [
        8,
        -12
      ],
      [
        5,
        -3
      ],
      [
        0,
        14
      ]
    ],
    [
      [
        26187,
        61055
      ],
      [
        5,
        -7
      ],
      [
        3,
        30
      ],
      [
        5,
        -9
      ],
      [
        0,
        -18
      ],
      [
        11,
        -9
      ],
      [
        5,
        13
      ],
      [
        6,
        -7
      ]
    ],
    [
      [
        26222,
        61048
      ],
      [
        -1,
        -11
      ],
      [
        9,
        -32
      ],
      [
        -3,
        -22
      ],
      [
        1,
        -22
      ],
      [
        -5,
        -160
      ]
    ],
    [
      [
        28368,
        58929
      ],
      [
        0,
        -8
      ],
      [
        1,
        -5
      ],
      [
        1,
        -4
      ],
      [
        1,
        -2
      ],
      [
        0,
        -1
      ],
      [
        2,
        -3
      ],
      [
        2,
        -3
      ],
      [
        2,
        -4
      ],
      [
        3,
        -7
      ],
      [
        4,
        -9
      ],
      [
        3,
        -5
      ],
      [
        4,
        -5
      ],
      [
        3,
        -7
      ],
      [
        3,
        -2
      ],
      [
        2,
        -2
      ],
      [
        1,
        -5
      ],
      [
        1,
        -8
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        2,
        -1
      ],
      [
        2,
        2
      ],
      [
        1,
        -3
      ],
      [
        1,
        -7
      ],
      [
        -1,
        -4
      ],
      [
        1,
        -6
      ],
      [
        1,
        -1
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -5
      ],
      [
        1,
        -2
      ],
      [
        0,
        -3
      ],
      [
        1,
        -1
      ],
      [
        0,
        -3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -9
      ],
      [
        -1,
        1
      ],
      [
        0,
        -9
      ],
      [
        1,
        -7
      ],
      [
        2,
        -5
      ],
      [
        3,
        -4
      ],
      [
        2,
        0
      ],
      [
        1,
        5
      ],
      [
        1,
        4
      ],
      [
        2,
        0
      ],
      [
        3,
        -1
      ],
      [
        1,
        -1
      ],
      [
        2,
        0
      ],
      [
        0,
        4
      ],
      [
        2,
        1
      ],
      [
        0,
        -4
      ],
      [
        1,
        -6
      ],
      [
        0,
        -5
      ],
      [
        2,
        1
      ],
      [
        2,
        1
      ],
      [
        1,
        4
      ],
      [
        2,
        -3
      ],
      [
        1,
        -2
      ],
      [
        2,
        2
      ],
      [
        1,
        3
      ],
      [
        1,
        4
      ],
      [
        1,
        1
      ],
      [
        1,
        -2
      ],
      [
        2,
        3
      ],
      [
        0,
        6
      ],
      [
        1,
        -3
      ],
      [
        2,
        2
      ],
      [
        1,
        3
      ],
      [
        2,
        0
      ],
      [
        1,
        -5
      ],
      [
        2,
        -12
      ],
      [
        2,
        -6
      ],
      [
        0,
        -20
      ],
      [
        1,
        -5
      ],
      [
        0,
        -13
      ],
      [
        -1,
        1
      ],
      [
        -1,
        0
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -11
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -2
      ],
      [
        1,
        -2
      ],
      [
        0,
        -13
      ],
      [
        1,
        -2
      ],
      [
        3,
        0
      ],
      [
        4,
        4
      ],
      [
        2,
        -2
      ],
      [
        1,
        -1
      ],
      [
        2,
        4
      ],
      [
        2,
        8
      ],
      [
        2,
        5
      ],
      [
        2,
        4
      ],
      [
        3,
        6
      ],
      [
        2,
        6
      ],
      [
        2,
        6
      ],
      [
        2,
        7
      ],
      [
        3,
        1
      ],
      [
        4,
        -9
      ],
      [
        3,
        -15
      ],
      [
        2,
        -15
      ],
      [
        1,
        -7
      ],
      [
        -1,
        -14
      ],
      [
        -1,
        -5
      ],
      [
        0,
        -9
      ],
      [
        1,
        -2
      ],
      [
        1,
        -8
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -4
      ],
      [
        2,
        -3
      ],
      [
        0,
        -4
      ],
      [
        1,
        -4
      ],
      [
        2,
        -1
      ],
      [
        4,
        4
      ],
      [
        4,
        13
      ],
      [
        2,
        10
      ],
      [
        2,
        9
      ],
      [
        3,
        12
      ],
      [
        -1,
        21
      ],
      [
        0,
        13
      ],
      [
        4,
        5
      ],
      [
        2,
        -2
      ],
      [
        4,
        -11
      ],
      [
        2,
        -8
      ],
      [
        3,
        -6
      ],
      [
        3,
        -1
      ],
      [
        2,
        2
      ],
      [
        1,
        0
      ]
    ],
    [
      [
        28501,
        58520
      ],
      [
        -38,
        -71
      ],
      [
        -14,
        24
      ],
      [
        -36,
        70
      ],
      [
        -3,
        -8
      ]
    ],
    [
      [
        25760,
        53020
      ],
      [
        -4,
        7
      ],
      [
        0,
        223
      ]
    ],
    [
      [
        16868,
        55911
      ],
      [
        1,
        0
      ],
      [
        4,
        -5
      ],
      [
        11,
        0
      ],
      [
        4,
        -7
      ],
      [
        9,
        -21
      ],
      [
        0,
        -2
      ],
      [
        4,
        -2
      ],
      [
        2,
        2
      ],
      [
        9,
        -23
      ],
      [
        6,
        -1
      ],
      [
        12,
        -21
      ],
      [
        3,
        0
      ],
      [
        0,
        -3
      ],
      [
        1,
        -22
      ],
      [
        12,
        -46
      ],
      [
        2,
        -7
      ],
      [
        2,
        -8
      ],
      [
        2,
        -18
      ],
      [
        -1,
        -12
      ],
      [
        -3,
        -10
      ],
      [
        -3,
        -3
      ],
      [
        -5,
        7
      ],
      [
        -4,
        12
      ],
      [
        -4,
        6
      ],
      [
        -8,
        1
      ],
      [
        -11,
        -3
      ],
      [
        -4,
        4
      ],
      [
        -3,
        5
      ],
      [
        -4,
        21
      ],
      [
        -2,
        14
      ],
      [
        2,
        16
      ],
      [
        1,
        19
      ],
      [
        -2,
        30
      ],
      [
        -1,
        9
      ],
      [
        -4,
        5
      ],
      [
        -4,
        -2
      ],
      [
        0,
        3
      ],
      [
        -2,
        7
      ],
      [
        -4,
        4
      ],
      [
        -6,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -2,
        6
      ],
      [
        -1,
        10
      ],
      [
        -5,
        22
      ],
      [
        -2,
        3
      ],
      [
        -1,
        8
      ],
      [
        0,
        2
      ]
    ],
    [
      [
        16867,
        55390
      ],
      [
        4,
        6
      ],
      [
        5,
        -2
      ],
      [
        2,
        -6
      ],
      [
        1,
        -5
      ],
      [
        0,
        -7
      ],
      [
        1,
        -14
      ],
      [
        6,
        -30
      ],
      [
        3,
        -12
      ],
      [
        9,
        -43
      ],
      [
        3,
        -12
      ],
      [
        2,
        -4
      ],
      [
        5,
        -12
      ],
      [
        4,
        -17
      ],
      [
        21,
        -65
      ],
      [
        5,
        -20
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        3
      ],
      [
        -6,
        5
      ],
      [
        -2,
        1
      ],
      [
        -2,
        -2
      ],
      [
        -2,
        -4
      ],
      [
        -7,
        -23
      ],
      [
        -1,
        6
      ],
      [
        1,
        1
      ],
      [
        -5,
        16
      ],
      [
        -9,
        25
      ],
      [
        -3,
        3
      ],
      [
        -2,
        8
      ],
      [
        -3,
        20
      ],
      [
        -1,
        3
      ],
      [
        1,
        6
      ],
      [
        -5,
        20
      ],
      [
        0,
        3
      ],
      [
        -3,
        12
      ],
      [
        -5,
        45
      ],
      [
        -2,
        15
      ],
      [
        -4,
        13
      ],
      [
        -3,
        46
      ],
      [
        -3,
        8
      ],
      [
        -3,
        -1
      ],
      [
        0,
        19
      ]
    ],
    [
      [
        17004,
        56219
      ],
      [
        -5,
        12
      ],
      [
        -4,
        5
      ],
      [
        -3,
        3
      ],
      [
        -5,
        4
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -16
      ],
      [
        1,
        -15
      ],
      [
        0,
        -15
      ],
      [
        -8,
        -2
      ],
      [
        -6,
        -9
      ],
      [
        -7,
        -12
      ],
      [
        -5,
        4
      ],
      [
        -6,
        2
      ],
      [
        -5,
        5
      ],
      [
        -2,
        3
      ],
      [
        -3,
        7
      ],
      [
        -6,
        13
      ],
      [
        -1,
        5
      ],
      [
        -7,
        5
      ],
      [
        -3,
        -6
      ],
      [
        -5,
        7
      ],
      [
        -4,
        38
      ],
      [
        1,
        9
      ],
      [
        5,
        21
      ],
      [
        3,
        4
      ],
      [
        1,
        13
      ],
      [
        0,
        30
      ],
      [
        -6,
        50
      ],
      [
        -3,
        21
      ],
      [
        -5,
        45
      ],
      [
        -5,
        33
      ],
      [
        -6,
        31
      ],
      [
        -1,
        3
      ],
      [
        -5,
        20
      ],
      [
        -5,
        14
      ],
      [
        -6,
        13
      ],
      [
        -7,
        3
      ],
      [
        -1,
        1
      ],
      [
        -9,
        -3
      ],
      [
        -2,
        -3
      ],
      [
        -16,
        3
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        -5
      ],
      [
        -8,
        -5
      ],
      [
        -7,
        4
      ],
      [
        -4,
        0
      ],
      [
        -10,
        -13
      ],
      [
        -1,
        -2
      ],
      [
        -5,
        -21
      ],
      [
        -5,
        14
      ],
      [
        -5,
        16
      ],
      [
        -4,
        8
      ],
      [
        -12,
        6
      ],
      [
        -9,
        8
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        2
      ]
    ],
    [
      [
        27214,
        46977
      ],
      [
        -1,
        16
      ],
      [
        -12,
        25
      ],
      [
        -9,
        13
      ],
      [
        -10,
        31
      ],
      [
        -9,
        20
      ],
      [
        -2,
        4
      ],
      [
        -5,
        1
      ],
      [
        -1,
        0
      ],
      [
        -3,
        -5
      ],
      [
        -2,
        -9
      ],
      [
        -3,
        -34
      ],
      [
        -2,
        -13
      ],
      [
        -1,
        2
      ],
      [
        -2,
        6
      ],
      [
        -6,
        53
      ],
      [
        -1,
        5
      ],
      [
        -3,
        6
      ],
      [
        -1,
        28
      ],
      [
        -2,
        12
      ],
      [
        -2,
        9
      ],
      [
        -1,
        13
      ],
      [
        0,
        39
      ],
      [
        -1,
        5
      ],
      [
        -2,
        2
      ],
      [
        -1,
        7
      ],
      [
        -11,
        95
      ],
      [
        -2,
        75
      ],
      [
        -1,
        24
      ],
      [
        -1,
        40
      ],
      [
        -1,
        34
      ],
      [
        -4,
        68
      ],
      [
        -3,
        38
      ],
      [
        0,
        3
      ]
    ],
    [
      [
        23225,
        60010
      ],
      [
        -6,
        -1
      ],
      [
        -17,
        1
      ],
      [
        -19,
        0
      ],
      [
        -8,
        -1
      ]
    ],
    [
      [
        23218,
        59542
      ],
      [
        0,
        -203
      ]
    ],
    [
      [
        19407,
        73980
      ],
      [
        10,
        1
      ],
      [
        5,
        -1
      ],
      [
        42,
        0
      ],
      [
        10,
        -1
      ],
      [
        53,
        0
      ],
      [
        16,
        -1
      ],
      [
        143,
        0
      ],
      [
        70,
        1
      ]
    ],
    [
      [
        28648,
        60803
      ],
      [
        -1,
        -5
      ],
      [
        -4,
        -24
      ],
      [
        2,
        -12
      ],
      [
        7,
        -4
      ],
      [
        4,
        -7
      ],
      [
        1,
        -5
      ],
      [
        3,
        -16
      ],
      [
        -1,
        -5
      ],
      [
        -8,
        9
      ],
      [
        -14,
        -13
      ],
      [
        -6,
        19
      ],
      [
        -2,
        4
      ],
      [
        -3,
        -2
      ],
      [
        -12,
        28
      ],
      [
        -8,
        15
      ],
      [
        -5,
        1
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -19
      ],
      [
        -1,
        -4
      ],
      [
        -3,
        -2
      ],
      [
        -7,
        25
      ],
      [
        0,
        41
      ],
      [
        -1,
        6
      ],
      [
        -6,
        28
      ],
      [
        -4,
        34
      ],
      [
        -2,
        13
      ],
      [
        -3,
        5
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -4,
        9
      ],
      [
        -7,
        14
      ]
    ],
    [
      [
        28485,
        61173
      ],
      [
        -3,
        0
      ],
      [
        -3,
        -20
      ],
      [
        6,
        -10
      ],
      [
        5,
        -24
      ],
      [
        12,
        -39
      ],
      [
        11,
        -26
      ],
      [
        6,
        -31
      ],
      [
        0,
        -8
      ],
      [
        5,
        -26
      ],
      [
        4,
        -19
      ],
      [
        5,
        -30
      ],
      [
        3,
        -12
      ],
      [
        2,
        -3
      ],
      [
        7,
        -1
      ],
      [
        2,
        -4
      ],
      [
        1,
        -4
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -6
      ]
    ],
    [
      [
        18654,
        73978
      ],
      [
        53,
        0
      ],
      [
        41,
        -1
      ],
      [
        26,
        -1
      ],
      [
        137,
        0
      ]
    ],
    [
      [
        30177,
        69643
      ],
      [
        0,
        5
      ],
      [
        1,
        9
      ],
      [
        0,
        4
      ],
      [
        3,
        9
      ],
      [
        1,
        0
      ],
      [
        1,
        5
      ],
      [
        1,
        11
      ],
      [
        0,
        16
      ],
      [
        -1,
        2
      ],
      [
        0,
        1
      ],
      [
        -1,
        3
      ],
      [
        -1,
        2
      ],
      [
        0,
        10
      ],
      [
        1,
        18
      ],
      [
        2,
        7
      ],
      [
        0,
        1
      ],
      [
        1,
        1
      ],
      [
        1,
        1
      ],
      [
        -1,
        2
      ],
      [
        0,
        11
      ],
      [
        -1,
        2
      ],
      [
        -1,
        6
      ],
      [
        -3,
        9
      ],
      [
        -1,
        3
      ],
      [
        0,
        8
      ],
      [
        4,
        13
      ],
      [
        3,
        7
      ],
      [
        1,
        8
      ],
      [
        0,
        3
      ],
      [
        1,
        1
      ],
      [
        3,
        4
      ],
      [
        8,
        -3
      ],
      [
        0,
        -1
      ],
      [
        3,
        -8
      ],
      [
        0,
        -11
      ],
      [
        4,
        -14
      ],
      [
        2,
        -5
      ],
      [
        3,
        -5
      ],
      [
        5,
        2
      ],
      [
        2,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        0
      ],
      [
        1,
        -1
      ],
      [
        5,
        -10
      ],
      [
        0,
        -9
      ],
      [
        3,
        -1
      ],
      [
        1,
        2
      ],
      [
        3,
        5
      ],
      [
        1,
        39
      ],
      [
        -1,
        13
      ],
      [
        -4,
        17
      ],
      [
        -4,
        5
      ],
      [
        -3,
        7
      ],
      [
        -2,
        7
      ],
      [
        -3,
        14
      ],
      [
        -3,
        10
      ],
      [
        -1,
        2
      ],
      [
        -3,
        8
      ],
      [
        -1,
        23
      ],
      [
        0,
        9
      ],
      [
        1,
        3
      ],
      [
        4,
        13
      ],
      [
        1,
        3
      ],
      [
        4,
        20
      ],
      [
        -1,
        17
      ],
      [
        1,
        2
      ],
      [
        2,
        6
      ],
      [
        5,
        19
      ],
      [
        3,
        13
      ],
      [
        0,
        2
      ],
      [
        2,
        9
      ],
      [
        2,
        3
      ],
      [
        5,
        7
      ],
      [
        3,
        12
      ],
      [
        2,
        1
      ],
      [
        2,
        3
      ],
      [
        0,
        1
      ],
      [
        8,
        29
      ],
      [
        1,
        6
      ],
      [
        -1,
        1
      ],
      [
        0,
        1
      ],
      [
        2,
        5
      ],
      [
        1,
        1
      ]
    ],
    [
      [
        26308,
        66321
      ],
      [
        -32,
        1
      ],
      [
        -66,
        -1
      ]
    ],
    [
      [
        30216,
        65279
      ],
      [
        10,
        20
      ],
      [
        1,
        8
      ],
      [
        0,
        18
      ],
      [
        1,
        5
      ],
      [
        2,
        3
      ],
      [
        1,
        6
      ],
      [
        -1,
        6
      ],
      [
        -3,
        26
      ],
      [
        0,
        6
      ],
      [
        4,
        17
      ],
      [
        -2,
        10
      ],
      [
        -2,
        5
      ],
      [
        1,
        8
      ],
      [
        3,
        6
      ],
      [
        0,
        10
      ],
      [
        -2,
        23
      ],
      [
        -1,
        3
      ],
      [
        -3,
        1
      ],
      [
        4,
        14
      ],
      [
        6,
        6
      ],
      [
        0,
        17
      ],
      [
        -5,
        6
      ]
    ],
    [
      [
        30259,
        65611
      ],
      [
        2,
        -7
      ],
      [
        4,
        -17
      ],
      [
        6,
        -19
      ],
      [
        7,
        -15
      ],
      [
        16,
        -20
      ],
      [
        8,
        -5
      ],
      [
        3,
        -1
      ],
      [
        23,
        -6
      ],
      [
        4,
        -9
      ],
      [
        1,
        -3
      ],
      [
        0,
        -3
      ],
      [
        3,
        -8
      ],
      [
        1,
        0
      ],
      [
        7,
        23
      ],
      [
        5,
        11
      ],
      [
        7,
        10
      ],
      [
        2,
        -1
      ],
      [
        12,
        10
      ],
      [
        5,
        -1
      ],
      [
        7,
        9
      ],
      [
        9,
        7
      ],
      [
        9,
        14
      ],
      [
        2,
        3
      ],
      [
        5,
        16
      ],
      [
        1,
        9
      ],
      [
        0,
        35
      ],
      [
        -1,
        44
      ],
      [
        2,
        12
      ],
      [
        -1,
        4
      ],
      [
        -2,
        2
      ],
      [
        -4,
        8
      ],
      [
        0,
        15
      ],
      [
        -1,
        20
      ],
      [
        -4,
        1
      ],
      [
        -3,
        -3
      ],
      [
        0,
        -7
      ],
      [
        -2,
        -13
      ],
      [
        -1,
        -20
      ],
      [
        -1,
        -9
      ],
      [
        -2,
        20
      ],
      [
        1,
        42
      ],
      [
        -1,
        55
      ],
      [
        -2,
        31
      ],
      [
        -2,
        15
      ],
      [
        -1,
        9
      ],
      [
        -4,
        13
      ],
      [
        -4,
        9
      ],
      [
        -7,
        12
      ],
      [
        -2,
        0
      ],
      [
        -4,
        -3
      ],
      [
        -3,
        -4
      ],
      [
        -2,
        -7
      ],
      [
        -2,
        -12
      ],
      [
        0,
        -14
      ],
      [
        2,
        -7
      ],
      [
        0,
        -2
      ],
      [
        -1,
        0
      ],
      [
        -2,
        3
      ],
      [
        -3,
        10
      ],
      [
        -3,
        17
      ],
      [
        -4,
        14
      ],
      [
        -1,
        3
      ],
      [
        -2,
        0
      ],
      [
        0,
        4
      ],
      [
        2,
        11
      ],
      [
        3,
        6
      ],
      [
        5,
        4
      ],
      [
        5,
        1
      ],
      [
        9,
        -5
      ],
      [
        12,
        -13
      ],
      [
        9,
        -15
      ],
      [
        7,
        -16
      ],
      [
        7,
        -27
      ],
      [
        6,
        -32
      ],
      [
        7,
        -47
      ],
      [
        5,
        -44
      ],
      [
        6,
        -77
      ],
      [
        3,
        -42
      ],
      [
        2,
        -79
      ],
      [
        0,
        -58
      ],
      [
        -3,
        -25
      ],
      [
        -2,
        -29
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -24
      ],
      [
        -3,
        -10
      ],
      [
        -4,
        -36
      ],
      [
        -2,
        -31
      ],
      [
        0,
        -13
      ],
      [
        -4,
        -6
      ],
      [
        -2,
        7
      ],
      [
        -1,
        8
      ],
      [
        2,
        8
      ],
      [
        3,
        14
      ],
      [
        1,
        39
      ],
      [
        2,
        19
      ],
      [
        2,
        13
      ],
      [
        2,
        19
      ],
      [
        -1,
        8
      ],
      [
        -6,
        15
      ],
      [
        -3,
        5
      ],
      [
        -2,
        1
      ],
      [
        -4,
        -5
      ],
      [
        -7,
        -3
      ],
      [
        -10,
        -3
      ],
      [
        -8,
        -8
      ],
      [
        -6,
        -6
      ],
      [
        -5,
        0
      ],
      [
        -9,
        -6
      ],
      [
        -12,
        -16
      ],
      [
        -3,
        -4
      ],
      [
        -3,
        -9
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -8
      ],
      [
        -2,
        -2
      ],
      [
        0,
        2
      ],
      [
        -1,
        8
      ],
      [
        0,
        9
      ],
      [
        -1,
        8
      ],
      [
        -2,
        3
      ],
      [
        -3,
        0
      ],
      [
        -3,
        -7
      ],
      [
        -3,
        -2
      ],
      [
        -2,
        4
      ],
      [
        -3,
        4
      ],
      [
        -2,
        2
      ],
      [
        -4,
        -1
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -5
      ],
      [
        1,
        -3
      ],
      [
        -2,
        -9
      ],
      [
        -2,
        -6
      ],
      [
        -6,
        -5
      ],
      [
        -3,
        1
      ],
      [
        -8,
        -3
      ],
      [
        -2,
        -15
      ],
      [
        -1,
        -8
      ],
      [
        -3,
        -16
      ],
      [
        -5,
        -15
      ],
      [
        -2,
        -5
      ],
      [
        -2,
        -3
      ],
      [
        -8,
        -3
      ],
      [
        -3,
        0
      ],
      [
        -7,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -8,
        -4
      ],
      [
        -6,
        -2
      ],
      [
        -6,
        -6
      ],
      [
        -3,
        -7
      ],
      [
        -3,
        -15
      ],
      [
        -3,
        -6
      ],
      [
        -1,
        -1
      ]
    ],
    [
      [
        20642,
        73978
      ],
      [
        114,
        0
      ],
      [
        29,
        1
      ],
      [
        138,
        0
      ]
    ],
    [
      [
        28498,
        63766
      ],
      [
        6,
        -5
      ],
      [
        4,
        -24
      ],
      [
        5,
        -1
      ],
      [
        1,
        0
      ],
      [
        11,
        -24
      ],
      [
        2,
        -3
      ],
      [
        5,
        -60
      ],
      [
        4,
        -7
      ]
    ],
    [
      [
        28579,
        63178
      ],
      [
        -61,
        0
      ]
    ],
    [
      [
        26676,
        57055
      ],
      [
        -4,
        8
      ],
      [
        -13,
        15
      ]
    ],
    [
      [
        23647,
        70225
      ],
      [
        -67,
        -1
      ],
      [
        -37,
        0
      ]
    ],
    [
      [
        25554,
        53329
      ],
      [
        -17,
        0
      ],
      [
        -10,
        -14
      ],
      [
        -10,
        -24
      ],
      [
        -16,
        20
      ]
    ],
    [
      [
        28638,
        62792
      ],
      [
        -1,
        -9
      ],
      [
        0,
        -1
      ],
      [
        5,
        -8
      ],
      [
        0,
        -18
      ],
      [
        2,
        -19
      ],
      [
        -3,
        1
      ],
      [
        -1,
        -4
      ],
      [
        0,
        -10
      ],
      [
        6,
        -19
      ],
      [
        -2,
        -11
      ],
      [
        -1,
        1
      ],
      [
        -7,
        7
      ],
      [
        0,
        -2
      ],
      [
        -4,
        -14
      ],
      [
        -1,
        -16
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -9
      ],
      [
        8,
        -18
      ],
      [
        4,
        -4
      ],
      [
        -2,
        -10
      ],
      [
        -6,
        -12
      ],
      [
        -7,
        -8
      ],
      [
        -1,
        -2
      ],
      [
        -5,
        -12
      ],
      [
        -2,
        -16
      ],
      [
        -5,
        -12
      ],
      [
        -1,
        3
      ],
      [
        -4,
        8
      ],
      [
        -1,
        1
      ],
      [
        -4,
        -1
      ],
      [
        -3,
        -3
      ],
      [
        -2,
        3
      ],
      [
        -1,
        5
      ],
      [
        1,
        12
      ],
      [
        0,
        6
      ],
      [
        -2,
        9
      ],
      [
        -2,
        -4
      ],
      [
        -3,
        14
      ],
      [
        -2,
        0
      ]
    ],
    [
      [
        26192,
        58216
      ],
      [
        7,
        -2
      ],
      [
        3,
        -33
      ],
      [
        9,
        10
      ],
      [
        14,
        -32
      ]
    ],
    [
      [
        28328,
        63177
      ],
      [
        3,
        0
      ]
    ],
    [
      [
        20388,
        61982
      ],
      [
        7,
        -4
      ],
      [
        5,
        -12
      ],
      [
        0,
        -16
      ],
      [
        5,
        -18
      ],
      [
        -2,
        -24
      ],
      [
        8,
        -10
      ],
      [
        2,
        -23
      ],
      [
        -4,
        -33
      ],
      [
        2,
        -14
      ],
      [
        -5,
        -16
      ],
      [
        -1,
        -49
      ],
      [
        -8,
        -2
      ],
      [
        -21,
        -67
      ]
    ],
    [
      [
        25263,
        63097
      ],
      [
        0,
        -238
      ]
    ],
    [
      [
        28263,
        63809
      ],
      [
        -6,
        -15
      ],
      [
        -12,
        -54
      ],
      [
        -8,
        -43
      ],
      [
        -17,
        -114
      ],
      [
        -2,
        -9
      ]
    ],
    [
      [
        28537,
        59130
      ],
      [
        -7,
        -36
      ],
      [
        -2,
        -76
      ],
      [
        8,
        -94
      ],
      [
        11,
        -77
      ],
      [
        1,
        -10
      ],
      [
        -1,
        -10
      ],
      [
        -3,
        -11
      ],
      [
        -2,
        -11
      ],
      [
        1,
        -15
      ],
      [
        2,
        -8
      ]
    ],
    [
      [
        23001,
        56396
      ],
      [
        -1,
        1
      ],
      [
        -4,
        -1
      ],
      [
        -6,
        -1
      ],
      [
        0,
        2
      ],
      [
        -4,
        12
      ],
      [
        -4,
        12
      ],
      [
        -2,
        1
      ],
      [
        -1,
        0
      ],
      [
        0,
        -3
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        -15
      ],
      [
        -1,
        -14
      ],
      [
        0,
        -24
      ],
      [
        -1,
        -10
      ],
      [
        -1,
        -5
      ],
      [
        -3,
        -13
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -2
      ],
      [
        -1,
        -2
      ],
      [
        -9,
        -7
      ],
      [
        -3,
        -1
      ],
      [
        -2,
        0
      ],
      [
        -1,
        1
      ],
      [
        -1,
        2
      ],
      [
        0,
        3
      ],
      [
        -2,
        14
      ],
      [
        0,
        7
      ],
      [
        -1,
        12
      ],
      [
        0,
        2
      ],
      [
        -1,
        4
      ],
      [
        -3,
        7
      ],
      [
        -5,
        4
      ],
      [
        -5,
        3
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -18
      ],
      [
        -1,
        -5
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        1
      ],
      [
        -3,
        6
      ],
      [
        -2,
        9
      ],
      [
        -3,
        9
      ],
      [
        -3,
        33
      ],
      [
        -1,
        7
      ],
      [
        1,
        12
      ],
      [
        -1,
        24
      ],
      [
        -1,
        10
      ],
      [
        -1,
        6
      ],
      [
        0,
        3
      ],
      [
        -2,
        5
      ],
      [
        -1,
        4
      ],
      [
        -1,
        1
      ],
      [
        -1,
        1
      ],
      [
        -2,
        -4
      ],
      [
        -1,
        -2
      ]
    ],
    [
      [
        26311,
        61014
      ],
      [
        -3,
        0
      ],
      [
        -7,
        -13
      ],
      [
        -6,
        -4
      ],
      [
        -2,
        11
      ],
      [
        4,
        20
      ],
      [
        -2,
        17
      ],
      [
        -3,
        2
      ],
      [
        1,
        16
      ],
      [
        -2,
        4
      ],
      [
        -3,
        -22
      ],
      [
        -2,
        1
      ],
      [
        1,
        29
      ],
      [
        -9,
        2
      ],
      [
        2,
        12
      ],
      [
        7,
        12
      ],
      [
        -6,
        10
      ],
      [
        0,
        9
      ],
      [
        6,
        12
      ],
      [
        0,
        8
      ]
    ],
    [
      [
        26287,
        61140
      ],
      [
        -6,
        4
      ],
      [
        -2,
        9
      ],
      [
        2,
        21
      ],
      [
        -5,
        9
      ],
      [
        1,
        19
      ],
      [
        -5,
        28
      ],
      [
        6,
        5
      ],
      [
        0,
        10
      ],
      [
        -4,
        10
      ],
      [
        4,
        17
      ],
      [
        -1,
        11
      ],
      [
        -3,
        8
      ],
      [
        -4,
        -11
      ],
      [
        -2,
        7
      ],
      [
        0,
        24
      ]
    ],
    [
      [
        22050,
        59537
      ],
      [
        0,
        475
      ]
    ],
    [
      [
        22613,
        69603
      ],
      [
        1,
        405
      ]
    ],
    [
      [
        22383,
        51502
      ],
      [
        8,
        34
      ]
    ],
    [
      [
        27666,
        60273
      ],
      [
        0,
        25
      ],
      [
        -3,
        23
      ],
      [
        5,
        40
      ],
      [
        -2,
        10
      ]
    ],
    [
      [
        17303,
        71953
      ],
      [
        -218,
        1
      ]
    ],
    [
      [
        31272,
        38457
      ],
      [
        4,
        3
      ],
      [
        6,
        5
      ],
      [
        5,
        -1
      ],
      [
        3,
        -3
      ]
    ],
    [
      [
        26599,
        59546
      ],
      [
        2,
        0
      ],
      [
        6,
        -1
      ],
      [
        7,
        -2
      ],
      [
        18,
        -1
      ],
      [
        24,
        0
      ]
    ],
    [
      [
        25021,
        52296
      ],
      [
        -3,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        -13
      ],
      [
        0,
        -6
      ],
      [
        3,
        -6
      ],
      [
        2,
        -4
      ],
      [
        2,
        -1
      ],
      [
        2,
        -6
      ],
      [
        3,
        -21
      ],
      [
        0,
        -5
      ],
      [
        -2,
        -14
      ],
      [
        -4,
        -12
      ],
      [
        -4,
        -5
      ],
      [
        -2,
        -4
      ],
      [
        -4,
        -17
      ],
      [
        -1,
        -3
      ],
      [
        -10,
        -16
      ],
      [
        -2,
        -10
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -18
      ],
      [
        -5,
        -21
      ],
      [
        0,
        -23
      ],
      [
        -4,
        -13
      ],
      [
        -1,
        -1
      ],
      [
        -1,
        3
      ],
      [
        -2,
        18
      ],
      [
        -1,
        3
      ],
      [
        -3,
        -8
      ],
      [
        -4,
        -5
      ],
      [
        -5,
        0
      ],
      [
        -1,
        -3
      ]
    ],
    [
      [
        24969,
        52072
      ],
      [
        0,
        10
      ],
      [
        -1,
        4
      ],
      [
        -1,
        3
      ],
      [
        -1,
        1
      ],
      [
        -1,
        -1
      ],
      [
        -2,
        -2
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -3
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -4
      ],
      [
        -2,
        -2
      ],
      [
        -1,
        2
      ],
      [
        -2,
        5
      ],
      [
        -2,
        7
      ],
      [
        0,
        9
      ],
      [
        -3,
        14
      ],
      [
        -1,
        5
      ],
      [
        -2,
        1
      ],
      [
        -1,
        1
      ],
      [
        0,
        2
      ],
      [
        -1,
        4
      ],
      [
        0,
        14
      ],
      [
        1,
        7
      ],
      [
        0,
        4
      ],
      [
        -1,
        3
      ],
      [
        -2,
        3
      ],
      [
        -1,
        2
      ],
      [
        -1,
        6
      ],
      [
        -1,
        4
      ],
      [
        1,
        2
      ],
      [
        0,
        21
      ],
      [
        -2,
        6
      ],
      [
        -2,
        3
      ],
      [
        1,
        19
      ],
      [
        0,
        4
      ],
      [
        2,
        1
      ],
      [
        1,
        1
      ],
      [
        1,
        6
      ],
      [
        0,
        1
      ],
      [
        -1,
        7
      ],
      [
        0,
        21
      ],
      [
        -2,
        5
      ],
      [
        -2,
        5
      ],
      [
        0,
        4
      ],
      [
        -1,
        1
      ],
      [
        -1,
        4
      ],
      [
        -1,
        1
      ],
      [
        -1,
        8
      ],
      [
        -1,
        9
      ],
      [
        -2,
        13
      ],
      [
        -1,
        8
      ],
      [
        -2,
        13
      ],
      [
        0,
        3
      ],
      [
        -1,
        3
      ],
      [
        0,
        8
      ],
      [
        1,
        1
      ],
      [
        0,
        -2
      ],
      [
        1,
        3
      ],
      [
        -1,
        17
      ],
      [
        0,
        6
      ],
      [
        -1,
        1
      ],
      [
        0,
        20
      ],
      [
        -2,
        9
      ]
    ],
    [
      [
        27344,
        65662
      ],
      [
        3,
        1
      ],
      [
        5,
        3
      ],
      [
        10,
        5
      ],
      [
        10,
        7
      ],
      [
        24,
        34
      ],
      [
        2,
        4
      ],
      [
        2,
        10
      ],
      [
        4,
        2
      ],
      [
        1,
        -6
      ],
      [
        7,
        8
      ],
      [
        10,
        7
      ],
      [
        39,
        44
      ],
      [
        8,
        12
      ],
      [
        9,
        12
      ]
    ],
    [
      [
        23353,
        59440
      ],
      [
        -1,
        102
      ],
      [
        -28,
        0
      ]
    ],
    [
      [
        22844,
        60564
      ],
      [
        61,
        0
      ],
      [
        114,
        1
      ]
    ],
    [
      [
        21867,
        71226
      ],
      [
        161,
        -2
      ]
    ],
    [
      [
        24652,
        59791
      ],
      [
        10,
        -1
      ],
      [
        0,
        -153
      ],
      [
        10,
        0
      ],
      [
        0,
        -101
      ],
      [
        5,
        -1
      ],
      [
        -1,
        -108
      ]
    ],
    [
      [
        15974,
        59837
      ],
      [
        -4,
        33
      ],
      [
        -10,
        61
      ],
      [
        -5,
        21
      ],
      [
        -4,
        14
      ],
      [
        -3,
        8
      ],
      [
        -7,
        11
      ],
      [
        -3,
        0
      ],
      [
        -3,
        -8
      ],
      [
        -6,
        -20
      ],
      [
        -1,
        0
      ],
      [
        -2,
        5
      ],
      [
        -8,
        7
      ],
      [
        -3,
        -3
      ],
      [
        -1,
        -12
      ],
      [
        -6,
        -3
      ],
      [
        -5,
        -1
      ],
      [
        -1,
        1
      ],
      [
        -10,
        8
      ],
      [
        -10,
        22
      ],
      [
        -4,
        7
      ],
      [
        -8,
        26
      ],
      [
        -6,
        13
      ],
      [
        -13,
        53
      ],
      [
        -2,
        15
      ],
      [
        -7,
        34
      ],
      [
        -2,
        6
      ]
    ],
    [
      [
        15358,
        63504
      ],
      [
        -4,
        14
      ],
      [
        -5,
        13
      ],
      [
        -3,
        0
      ],
      [
        -1,
        -4
      ],
      [
        -1,
        2
      ],
      [
        -2,
        8
      ],
      [
        0,
        43
      ],
      [
        -2,
        14
      ],
      [
        -6,
        29
      ],
      [
        -9,
        15
      ],
      [
        -8,
        9
      ],
      [
        -5,
        8
      ],
      [
        -7,
        35
      ],
      [
        -5,
        12
      ],
      [
        -8,
        15
      ],
      [
        -10,
        29
      ],
      [
        -7,
        20
      ],
      [
        -2,
        13
      ],
      [
        -4,
        8
      ],
      [
        -3,
        7
      ],
      [
        -3,
        12
      ],
      [
        0,
        18
      ],
      [
        4,
        45
      ],
      [
        -1,
        19
      ],
      [
        -1,
        5
      ],
      [
        -2,
        17
      ],
      [
        0,
        29
      ],
      [
        -3,
        21
      ],
      [
        -1,
        7
      ],
      [
        -4,
        9
      ],
      [
        -3,
        18
      ],
      [
        -2,
        19
      ],
      [
        1,
        6
      ],
      [
        3,
        22
      ],
      [
        3,
        32
      ],
      [
        1,
        11
      ],
      [
        -1,
        6
      ],
      [
        1,
        17
      ],
      [
        1,
        4
      ],
      [
        4,
        30
      ],
      [
        10,
        79
      ],
      [
        4,
        27
      ],
      [
        0,
        2
      ],
      [
        7,
        45
      ],
      [
        11,
        64
      ],
      [
        6,
        40
      ],
      [
        7,
        42
      ],
      [
        7,
        45
      ],
      [
        5,
        37
      ],
      [
        6,
        58
      ],
      [
        5,
        74
      ],
      [
        2,
        45
      ],
      [
        -4,
        24
      ],
      [
        -2,
        5
      ],
      [
        -1,
        2
      ],
      [
        -1,
        0
      ],
      [
        -2,
        -2
      ],
      [
        0,
        -1
      ],
      [
        -1,
        -1
      ],
      [
        0,
        3
      ],
      [
        -1,
        7
      ],
      [
        0,
        32
      ],
      [
        -1,
        14
      ],
      [
        0,
        27
      ],
      [
        -2,
        9
      ],
      [
        1,
        10
      ],
      [
        1,
        5
      ],
      [
        3,
        -2
      ],
      [
        1,
        4
      ],
      [
        6,
        53
      ],
      [
        5,
        46
      ],
      [
        0,
        13
      ],
      [
        4,
        55
      ],
      [
        3,
        69
      ],
      [
        2,
        32
      ],
      [
        3,
        75
      ],
      [
        -1,
        30
      ]
    ],
    [
      [
        22406,
        70416
      ],
      [
        0,
        -405
      ]
    ],
    [
      [
        17304,
        70983
      ],
      [
        -5,
        4
      ],
      [
        -8,
        -14
      ],
      [
        -19,
        15
      ],
      [
        -7,
        -10
      ],
      [
        -8,
        2
      ],
      [
        0,
        30
      ],
      [
        -6,
        15
      ]
    ],
    [
      [
        16803,
        73980
      ],
      [
        178,
        0
      ]
    ],
    [
      [
        26861,
        65369
      ],
      [
        5,
        19
      ],
      [
        3,
        0
      ],
      [
        1,
        -2
      ],
      [
        1,
        -7
      ],
      [
        2,
        -1
      ],
      [
        3,
        9
      ],
      [
        1,
        -1
      ],
      [
        -1,
        -27
      ],
      [
        -1,
        -9
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        -1
      ],
      [
        -1,
        0
      ],
      [
        -6,
        12
      ],
      [
        -3,
        6
      ],
      [
        0,
        3
      ]
    ],
    [
      [
        26872,
        65242
      ],
      [
        2,
        -2
      ],
      [
        1,
        -4
      ],
      [
        7,
        -32
      ],
      [
        12,
        -35
      ],
      [
        0,
        -4
      ],
      [
        4,
        -8
      ],
      [
        12,
        -25
      ],
      [
        13,
        -18
      ],
      [
        4,
        -3
      ],
      [
        5,
        0
      ],
      [
        6,
        5
      ],
      [
        8,
        13
      ],
      [
        9,
        20
      ],
      [
        10,
        14
      ],
      [
        4,
        2
      ]
    ],
    [
      [
        26222,
        61048
      ],
      [
        0,
        -8
      ],
      [
        6,
        8
      ],
      [
        2,
        18
      ],
      [
        4,
        -1
      ],
      [
        3,
        34
      ],
      [
        10,
        21
      ],
      [
        8,
        -3
      ],
      [
        7,
        -12
      ],
      [
        25,
        35
      ]
    ],
    [
      [
        23858,
        69609
      ],
      [
        8,
        -23
      ],
      [
        17,
        -17
      ],
      [
        3,
        -12
      ],
      [
        11,
        -27
      ],
      [
        4,
        -3
      ],
      [
        6,
        -22
      ],
      [
        3,
        -6
      ],
      [
        4,
        -9
      ],
      [
        4,
        -17
      ],
      [
        1,
        -8
      ],
      [
        0,
        -8
      ],
      [
        3,
        -8
      ],
      [
        2,
        -6
      ],
      [
        -1,
        -37
      ],
      [
        -1,
        -15
      ],
      [
        1,
        -8
      ],
      [
        -1,
        -19
      ],
      [
        16,
        0
      ]
    ],
    [
      [
        25692,
        65494
      ],
      [
        6,
        19
      ],
      [
        10,
        13
      ],
      [
        14,
        26
      ]
    ],
    [
      [
        23552,
        61218
      ],
      [
        -1,
        -52
      ],
      [
        0,
        -202
      ],
      [
        -1,
        -54
      ],
      [
        0,
        -96
      ],
      [
        1,
        -3
      ],
      [
        -1,
        -1
      ],
      [
        0,
        -16
      ]
    ],
    [
      [
        28686,
        59930
      ],
      [
        2,
        -2
      ],
      [
        5,
        -3
      ],
      [
        6,
        -4
      ],
      [
        2,
        -4
      ],
      [
        10,
        -13
      ],
      [
        2,
        0
      ],
      [
        8,
        10
      ],
      [
        5,
        12
      ],
      [
        2,
        5
      ],
      [
        6,
        -1
      ],
      [
        1,
        -2
      ],
      [
        4,
        -8
      ],
      [
        1,
        -13
      ],
      [
        5,
        -76
      ],
      [
        0,
        -4
      ],
      [
        2,
        -35
      ],
      [
        5,
        -60
      ],
      [
        7,
        -80
      ],
      [
        9,
        -71
      ],
      [
        5,
        -55
      ],
      [
        2,
        -39
      ]
    ],
    [
      [
        25397,
        68948
      ],
      [
        0,
        -11
      ],
      [
        -3,
        -5
      ],
      [
        -2,
        -32
      ],
      [
        0,
        -7
      ],
      [
        3,
        -25
      ],
      [
        -1,
        -6
      ],
      [
        -3,
        -2
      ],
      [
        -1,
        -12
      ],
      [
        -3,
        -15
      ],
      [
        -3,
        -3
      ],
      [
        -1,
        -5
      ],
      [
        -1,
        -7
      ],
      [
        2,
        -6
      ],
      [
        9,
        -25
      ],
      [
        9,
        -11
      ],
      [
        8,
        -1
      ],
      [
        1,
        3
      ],
      [
        3,
        5
      ],
      [
        3,
        14
      ],
      [
        5,
        24
      ],
      [
        0,
        7
      ],
      [
        -1,
        8
      ],
      [
        1,
        3
      ],
      [
        2,
        5
      ],
      [
        7,
        23
      ],
      [
        10,
        18
      ],
      [
        6,
        15
      ],
      [
        10,
        3
      ],
      [
        2,
        3
      ],
      [
        1,
        3
      ]
    ],
    [
      [
        25004,
        53954
      ],
      [
        23,
        6
      ]
    ],
    [
      [
        28749,
        59144
      ],
      [
        -2,
        -1
      ],
      [
        2,
        -8
      ],
      [
        4,
        -30
      ],
      [
        -3,
        -28
      ],
      [
        5,
        -20
      ],
      [
        6,
        -10
      ],
      [
        3,
        -9
      ],
      [
        -4,
        0
      ],
      [
        -2,
        -1
      ],
      [
        -4,
        2
      ],
      [
        -15,
        15
      ],
      [
        -6,
        9
      ],
      [
        -1,
        3
      ],
      [
        -3,
        16
      ],
      [
        -4,
        9
      ],
      [
        -3,
        22
      ],
      [
        -7,
        10
      ],
      [
        -14,
        58
      ],
      [
        -8,
        4
      ],
      [
        -7,
        8
      ],
      [
        0,
        -6
      ]
    ],
    [
      [
        22902,
        55839
      ],
      [
        29,
        -4
      ],
      [
        2,
        -9
      ]
    ],
    [
      [
        31452,
        37982
      ],
      [
        -6,
        -9
      ],
      [
        -2,
        -10
      ],
      [
        -3,
        -3
      ],
      [
        -10,
        -48
      ]
    ],
    [
      [
        31436,
        38446
      ],
      [
        6,
        -3
      ],
      [
        3,
        0
      ],
      [
        2,
        7
      ],
      [
        1,
        2
      ],
      [
        4,
        -4
      ],
      [
        0,
        -1
      ],
      [
        1,
        -4
      ],
      [
        3,
        -4
      ],
      [
        6,
        -3
      ],
      [
        6,
        0
      ]
    ],
    [
      [
        12100,
        86471
      ],
      [
        67,
        80
      ],
      [
        62,
        -115
      ],
      [
        3,
        -4
      ],
      [
        2,
        0
      ],
      [
        1,
        -1
      ],
      [
        5,
        -38
      ],
      [
        13,
        -37
      ],
      [
        1,
        -2
      ],
      [
        3,
        -6
      ],
      [
        11,
        -2
      ],
      [
        24,
        -70
      ],
      [
        0,
        -104
      ],
      [
        -12,
        -24
      ],
      [
        1,
        -37
      ],
      [
        14,
        -31
      ],
      [
        2,
        -16
      ],
      [
        -2,
        -24
      ],
      [
        -3,
        -18
      ]
    ],
    [
      [
        30068,
        65494
      ],
      [
        -1,
        -6
      ],
      [
        -4,
        -9
      ],
      [
        0,
        -2
      ],
      [
        -1,
        -1
      ],
      [
        2,
        -16
      ],
      [
        1,
        -5
      ],
      [
        0,
        -6
      ],
      [
        -2,
        -6
      ],
      [
        -3,
        -7
      ],
      [
        0,
        -14
      ],
      [
        -4,
        -5
      ],
      [
        -1,
        -3
      ],
      [
        0,
        -4
      ],
      [
        -4,
        -2
      ],
      [
        -1,
        5
      ],
      [
        -2,
        5
      ],
      [
        -1,
        5
      ],
      [
        -1,
        6
      ],
      [
        -1,
        21
      ],
      [
        1,
        10
      ],
      [
        1,
        0
      ],
      [
        2,
        8
      ],
      [
        0,
        17
      ],
      [
        -1,
        5
      ],
      [
        -3,
        13
      ],
      [
        -2,
        6
      ],
      [
        -3,
        1
      ],
      [
        -3,
        1
      ],
      [
        -2,
        13
      ],
      [
        -3,
        10
      ],
      [
        0,
        2
      ],
      [
        -2,
        3
      ],
      [
        0,
        8
      ]
    ],
    [
      [
        23711,
        55377
      ],
      [
        2,
        -1
      ],
      [
        2,
        0
      ],
      [
        1,
        1
      ],
      [
        58,
        0
      ]
    ],
    [
      [
        26094,
        61164
      ],
      [
        -13,
        -30
      ],
      [
        3,
        -9
      ],
      [
        -7,
        -34
      ],
      [
        -10,
        -20
      ],
      [
        0,
        -20
      ],
      [
        2,
        -10
      ],
      [
        -6,
        -18
      ],
      [
        -4,
        0
      ],
      [
        1,
        -13
      ],
      [
        -9,
        -29
      ],
      [
        -11,
        -22
      ],
      [
        -3,
        4
      ],
      [
        -9,
        -14
      ],
      [
        1,
        3
      ],
      [
        -5,
        3
      ]
    ],
    [
      [
        26187,
        61055
      ],
      [
        -4,
        87
      ]
    ],
    [
      [
        27450,
        56219
      ],
      [
        -10,
        22
      ],
      [
        -1,
        13
      ],
      [
        -7,
        -20
      ],
      [
        -10,
        13
      ],
      [
        -4,
        -12
      ],
      [
        -3,
        23
      ],
      [
        0,
        -17
      ],
      [
        -4,
        14
      ],
      [
        -7,
        -15
      ],
      [
        1,
        9
      ],
      [
        -7,
        6
      ],
      [
        -2,
        8
      ],
      [
        -4,
        -3
      ],
      [
        -2,
        18
      ],
      [
        -8,
        11
      ],
      [
        -4,
        15
      ],
      [
        -5,
        -8
      ],
      [
        -5,
        5
      ],
      [
        1,
        23
      ],
      [
        -8,
        -5
      ],
      [
        -3,
        14
      ],
      [
        -4,
        8
      ],
      [
        -6,
        1
      ],
      [
        0,
        10
      ],
      [
        -3,
        4
      ],
      [
        0,
        15
      ],
      [
        -4,
        8
      ]
    ],
    [
      [
        27155,
        51076
      ],
      [
        1,
        16
      ],
      [
        6,
        -1
      ],
      [
        -4,
        40
      ],
      [
        -20,
        -1
      ],
      [
        0,
        68
      ],
      [
        -9,
        0
      ],
      [
        -1,
        67
      ],
      [
        -18,
        -1
      ],
      [
        0,
        40
      ],
      [
        -5,
        -7
      ],
      [
        -13,
        0
      ],
      [
        -1,
        -11
      ],
      [
        -6,
        13
      ],
      [
        -9,
        -15
      ],
      [
        -11,
        -2
      ],
      [
        -8,
        -12
      ],
      [
        -7,
        -24
      ]
    ],
    [
      [
        24950,
        61122
      ],
      [
        99,
        -5
      ],
      [
        17,
        0
      ]
    ],
    [
      [
        28607,
        58329
      ],
      [
        -1,
        2
      ],
      [
        -3,
        -22
      ],
      [
        -21,
        -11
      ],
      [
        -12,
        11
      ],
      [
        -9,
        -33
      ],
      [
        9,
        -57
      ],
      [
        6,
        -86
      ],
      [
        -7,
        0
      ],
      [
        -29,
        47
      ],
      [
        -14,
        -10
      ],
      [
        -20,
        34
      ],
      [
        -31,
        30
      ],
      [
        -23,
        48
      ],
      [
        0,
        -23
      ],
      [
        -1,
        -6
      ],
      [
        17,
        -60
      ],
      [
        0,
        -1
      ],
      [
        21,
        -5
      ],
      [
        63,
        -102
      ],
      [
        16,
        -10
      ]
    ],
    [
      [
        28357,
        66502
      ],
      [
        0,
        106
      ],
      [
        3,
        38
      ],
      [
        5,
        38
      ],
      [
        6,
        30
      ],
      [
        1,
        3
      ],
      [
        53,
        2
      ],
      [
        42,
        1
      ]
    ],
    [
      [
        21992,
        49763
      ],
      [
        -1,
        16
      ],
      [
        -1,
        19
      ],
      [
        0,
        6
      ],
      [
        -1,
        4
      ],
      [
        -1,
        0
      ],
      [
        -6,
        -2
      ],
      [
        -1,
        3
      ],
      [
        -5,
        16
      ],
      [
        -3,
        21
      ],
      [
        -3,
        6
      ],
      [
        -1,
        6
      ],
      [
        0,
        7
      ],
      [
        2,
        19
      ],
      [
        0,
        19
      ],
      [
        -8,
        33
      ],
      [
        0,
        14
      ],
      [
        -1,
        5
      ],
      [
        -6,
        27
      ],
      [
        -1,
        5
      ],
      [
        -1,
        16
      ],
      [
        1,
        8
      ],
      [
        2,
        20
      ],
      [
        0,
        19
      ],
      [
        -1,
        7
      ],
      [
        -3,
        11
      ],
      [
        -2,
        6
      ],
      [
        -3,
        15
      ],
      [
        1,
        5
      ],
      [
        4,
        2
      ],
      [
        2,
        4
      ],
      [
        2,
        6
      ],
      [
        1,
        9
      ],
      [
        -1,
        3
      ],
      [
        -7,
        8
      ],
      [
        -5,
        3
      ],
      [
        -2,
        5
      ],
      [
        -5,
        24
      ],
      [
        -2,
        18
      ],
      [
        4,
        28
      ],
      [
        0,
        11
      ],
      [
        -9,
        13
      ],
      [
        -5,
        15
      ],
      [
        0,
        9
      ],
      [
        1,
        24
      ],
      [
        -1,
        5
      ],
      [
        -4,
        -1
      ],
      [
        -3,
        7
      ],
      [
        -2,
        10
      ],
      [
        -4,
        3
      ],
      [
        -1,
        4
      ],
      [
        -3,
        34
      ],
      [
        -1,
        17
      ],
      [
        2,
        13
      ],
      [
        0,
        28
      ],
      [
        -4,
        18
      ],
      [
        -4,
        8
      ],
      [
        -1,
        21
      ],
      [
        2,
        12
      ],
      [
        -1,
        17
      ],
      [
        -4,
        23
      ],
      [
        -1,
        3
      ],
      [
        -2,
        1
      ],
      [
        -3,
        -3
      ],
      [
        -1,
        3
      ],
      [
        -1,
        8
      ],
      [
        1,
        15
      ],
      [
        -2,
        8
      ],
      [
        -3,
        9
      ],
      [
        -2,
        14
      ],
      [
        -1,
        14
      ],
      [
        0,
        17
      ],
      [
        -7,
        2
      ],
      [
        -1,
        -1
      ],
      [
        -3,
        13
      ],
      [
        1,
        2
      ],
      [
        0,
        14
      ],
      [
        -4,
        18
      ],
      [
        2,
        16
      ],
      [
        0,
        34
      ],
      [
        -1,
        26
      ],
      [
        -1,
        8
      ],
      [
        -1,
        2
      ],
      [
        -1,
        17
      ],
      [
        -1,
        19
      ],
      [
        0,
        29
      ],
      [
        -1,
        13
      ]
    ],
    [
      [
        31637,
        38350
      ],
      [
        2,
        1
      ],
      [
        4,
        -13
      ],
      [
        1,
        -2
      ],
      [
        0,
        -26
      ],
      [
        1,
        -12
      ],
      [
        -1,
        -6
      ],
      [
        -3,
        10
      ],
      [
        -2,
        29
      ],
      [
        -3,
        8
      ],
      [
        1,
        11
      ]
    ],
    [
      [
        31616,
        38316
      ],
      [
        1,
        0
      ],
      [
        3,
        4
      ],
      [
        1,
        9
      ],
      [
        2,
        6
      ],
      [
        5,
        9
      ],
      [
        2,
        1
      ],
      [
        1,
        -7
      ],
      [
        -1,
        -17
      ],
      [
        -4,
        -23
      ],
      [
        0,
        -6
      ],
      [
        2,
        -12
      ],
      [
        1,
        -51
      ]
    ],
    [
      [
        24941,
        51321
      ],
      [
        4,
        2
      ],
      [
        7,
        12
      ],
      [
        3,
        3
      ],
      [
        3,
        -7
      ],
      [
        -4,
        -13
      ],
      [
        -3,
        -16
      ],
      [
        -2,
        -13
      ],
      [
        -5,
        15
      ],
      [
        -3,
        17
      ]
    ],
    [
      [
        24967,
        51478
      ],
      [
        6,
        -15
      ],
      [
        7,
        -31
      ],
      [
        0,
        -12
      ],
      [
        -5,
        13
      ],
      [
        -5,
        9
      ],
      [
        -3,
        11
      ],
      [
        -14,
        5
      ],
      [
        -8,
        -17
      ],
      [
        -8,
        11
      ],
      [
        -7,
        -5
      ],
      [
        18,
        -39
      ],
      [
        0,
        -32
      ],
      [
        -10,
        16
      ],
      [
        -3,
        20
      ],
      [
        -7,
        15
      ],
      [
        -3,
        -2
      ],
      [
        -1,
        -11
      ],
      [
        1,
        -14
      ],
      [
        4,
        -17
      ],
      [
        5,
        -2
      ],
      [
        3,
        -13
      ],
      [
        -6,
        -13
      ],
      [
        -6,
        -1
      ],
      [
        0,
        -15
      ],
      [
        1,
        -19
      ],
      [
        7,
        -2
      ],
      [
        4,
        -34
      ],
      [
        9,
        -15
      ],
      [
        11,
        4
      ],
      [
        -1,
        -22
      ],
      [
        6,
        -14
      ],
      [
        6,
        -10
      ],
      [
        -1,
        -23
      ],
      [
        0,
        -11
      ],
      [
        4,
        -29
      ],
      [
        3,
        -17
      ],
      [
        1,
        0
      ],
      [
        5,
        9
      ],
      [
        1,
        5
      ],
      [
        0,
        10
      ],
      [
        2,
        6
      ],
      [
        2,
        -12
      ],
      [
        3,
        -9
      ],
      [
        10,
        -3
      ],
      [
        12,
        1
      ],
      [
        2,
        -5
      ],
      [
        5,
        -7
      ],
      [
        4,
        0
      ],
      [
        1,
        -4
      ],
      [
        -3,
        -15
      ],
      [
        2,
        -11
      ],
      [
        5,
        8
      ],
      [
        3,
        30
      ],
      [
        11,
        -43
      ],
      [
        2,
        -7
      ],
      [
        2,
        -10
      ],
      [
        1,
        -16
      ],
      [
        4,
        -15
      ],
      [
        4,
        4
      ],
      [
        0,
        5
      ],
      [
        1,
        8
      ],
      [
        5,
        16
      ],
      [
        1,
        7
      ],
      [
        0,
        4
      ],
      [
        3,
        -3
      ],
      [
        3,
        -7
      ],
      [
        0,
        -14
      ],
      [
        4,
        -28
      ],
      [
        2,
        -8
      ],
      [
        5,
        -6
      ],
      [
        1,
        -14
      ],
      [
        -1,
        -5
      ],
      [
        2,
        -11
      ],
      [
        5,
        -15
      ],
      [
        -1,
        -39
      ],
      [
        1,
        -20
      ],
      [
        6,
        -13
      ],
      [
        7,
        8
      ],
      [
        3,
        15
      ],
      [
        8,
        5
      ],
      [
        7,
        -41
      ],
      [
        -3,
        -15
      ],
      [
        -5,
        16
      ],
      [
        -6,
        -12
      ],
      [
        -10,
        -4
      ],
      [
        -6,
        -16
      ],
      [
        4,
        -17
      ],
      [
        16,
        -3
      ],
      [
        -8,
        -52
      ],
      [
        -5,
        24
      ],
      [
        -4,
        7
      ],
      [
        -2,
        -7
      ],
      [
        -1,
        -36
      ],
      [
        -2,
        -8
      ],
      [
        -4,
        -4
      ],
      [
        -4,
        -22
      ],
      [
        -1,
        -26
      ],
      [
        3,
        -12
      ],
      [
        -1,
        -32
      ],
      [
        -21,
        36
      ],
      [
        0,
        39
      ],
      [
        -2,
        16
      ],
      [
        -8,
        16
      ],
      [
        -2,
        -29
      ],
      [
        -9,
        -20
      ],
      [
        -20,
        -89
      ],
      [
        -10,
        -36
      ],
      [
        -2,
        -2
      ],
      [
        -3,
        -3
      ],
      [
        7,
        67
      ],
      [
        9,
        29
      ],
      [
        5,
        48
      ],
      [
        4,
        3
      ],
      [
        5,
        18
      ],
      [
        -1,
        19
      ],
      [
        3,
        12
      ],
      [
        -2,
        23
      ],
      [
        4,
        10
      ],
      [
        0,
        9
      ],
      [
        5,
        4
      ],
      [
        -1,
        26
      ],
      [
        0,
        25
      ],
      [
        -4,
        20
      ],
      [
        -6,
        4
      ],
      [
        -3,
        -13
      ],
      [
        1,
        -16
      ],
      [
        -2,
        -33
      ],
      [
        -5,
        -22
      ],
      [
        -11,
        -7
      ],
      [
        -5,
        5
      ],
      [
        -3,
        12
      ],
      [
        -3,
        7
      ],
      [
        -1,
        5
      ],
      [
        -4,
        35
      ],
      [
        -2,
        14
      ],
      [
        -5,
        20
      ],
      [
        -3,
        8
      ],
      [
        -15,
        25
      ],
      [
        -19,
        18
      ],
      [
        -1,
        14
      ],
      [
        -4,
        6
      ],
      [
        -5,
        25
      ],
      [
        -9,
        -2
      ],
      [
        -7,
        9
      ],
      [
        -8,
        9
      ],
      [
        -15,
        8
      ],
      [
        -8,
        3
      ],
      [
        -9,
        6
      ],
      [
        -12,
        -14
      ],
      [
        -5,
        -14
      ]
    ],
    [
      [
        25469,
        68033
      ],
      [
        -1,
        -13
      ],
      [
        0,
        -8
      ],
      [
        2,
        -25
      ],
      [
        0,
        -49
      ],
      [
        8,
        -50
      ],
      [
        0,
        -8
      ],
      [
        -1,
        -12
      ],
      [
        -1,
        -6
      ],
      [
        -1,
        -2
      ],
      [
        0,
        -9
      ],
      [
        1,
        -15
      ],
      [
        1,
        -19
      ],
      [
        0,
        -22
      ],
      [
        -1,
        -9
      ],
      [
        -8,
        -47
      ],
      [
        -13,
        -71
      ],
      [
        -2,
        -18
      ],
      [
        -1,
        -23
      ]
    ],
    [
      [
        24969,
        52072
      ],
      [
        -1,
        -4
      ],
      [
        -2,
        -6
      ],
      [
        -5,
        -1
      ],
      [
        -2,
        -3
      ],
      [
        -2,
        -5
      ],
      [
        -1,
        -4
      ],
      [
        -4,
        -12
      ],
      [
        -2,
        -1
      ],
      [
        -1,
        3
      ],
      [
        -5,
        5
      ],
      [
        -2,
        -5
      ]
    ],
    [
      [
        27129,
        61967
      ],
      [
        -11,
        40
      ],
      [
        6,
        21
      ],
      [
        -11,
        54
      ],
      [
        -20,
        97
      ],
      [
        -2,
        14
      ],
      [
        0,
        4
      ]
    ],
    [
      [
        90343,
        33382
      ],
      [
        11,
        51
      ],
      [
        12,
        10
      ],
      [
        9,
        25
      ],
      [
        5,
        1
      ],
      [
        10,
        -10
      ],
      [
        -1,
        -18
      ],
      [
        -1,
        -17
      ],
      [
        -3,
        -10
      ],
      [
        -9,
        -3
      ],
      [
        -2,
        -20
      ],
      [
        -6,
        -19
      ],
      [
        -11,
        -6
      ],
      [
        -2,
        19
      ],
      [
        -3,
        4
      ],
      [
        -4,
        -14
      ],
      [
        -4,
        -1
      ],
      [
        -1,
        8
      ]
    ],
    [
      [
        31463,
        37795
      ],
      [
        -2,
        -4
      ],
      [
        -5,
        2
      ],
      [
        -3,
        7
      ],
      [
        1,
        15
      ],
      [
        -2,
        5
      ],
      [
        -2,
        9
      ],
      [
        -3,
        4
      ],
      [
        -4,
        -2
      ],
      [
        -2,
        15
      ],
      [
        -6,
        20
      ],
      [
        -2,
        2
      ],
      [
        -4,
        -2
      ]
    ],
    [
      [
        15781,
        72293
      ],
      [
        8,
        -6
      ],
      [
        0,
        -16
      ],
      [
        -4,
        -9
      ],
      [
        -3,
        4
      ],
      [
        -3,
        23
      ],
      [
        2,
        4
      ]
    ],
    [
      [
        15638,
        72257
      ],
      [
        14,
        76
      ],
      [
        14,
        41
      ],
      [
        17,
        33
      ],
      [
        14,
        5
      ],
      [
        14,
        21
      ],
      [
        1,
        2
      ],
      [
        3,
        73
      ],
      [
        2,
        2
      ],
      [
        3,
        13
      ],
      [
        1,
        14
      ],
      [
        1,
        8
      ],
      [
        7,
        12
      ],
      [
        2,
        24
      ],
      [
        1,
        2
      ],
      [
        9,
        29
      ],
      [
        7,
        12
      ],
      [
        2,
        17
      ],
      [
        2,
        7
      ],
      [
        10,
        1
      ],
      [
        0,
        20
      ],
      [
        -4,
        32
      ],
      [
        0,
        13
      ],
      [
        -3,
        8
      ],
      [
        -5,
        6
      ],
      [
        -1,
        7
      ],
      [
        1,
        9
      ],
      [
        1,
        2
      ],
      [
        2,
        0
      ],
      [
        7,
        -17
      ],
      [
        9,
        -8
      ],
      [
        6,
        -15
      ],
      [
        3,
        -30
      ],
      [
        1,
        -19
      ],
      [
        2,
        -38
      ],
      [
        1,
        -6
      ],
      [
        5,
        -13
      ],
      [
        0,
        -7
      ],
      [
        -1,
        -6
      ],
      [
        -2,
        -8
      ],
      [
        0,
        -12
      ],
      [
        6,
        -24
      ],
      [
        1,
        -11
      ],
      [
        -1,
        -8
      ],
      [
        -1,
        -5
      ],
      [
        -3,
        -2
      ],
      [
        -6,
        -1
      ],
      [
        -2,
        1
      ],
      [
        -1,
        3
      ],
      [
        -5,
        1
      ],
      [
        -5,
        -2
      ],
      [
        3,
        -40
      ],
      [
        4,
        -7
      ],
      [
        1,
        0
      ],
      [
        1,
        3
      ],
      [
        3,
        1
      ],
      [
        2,
        -11
      ],
      [
        0,
        -16
      ],
      [
        -1,
        -17
      ],
      [
        -3,
        -23
      ],
      [
        5,
        -14
      ],
      [
        2,
        -5
      ],
      [
        0,
        -13
      ],
      [
        -2,
        -7
      ],
      [
        1,
        -23
      ],
      [
        1,
        -10
      ],
      [
        3,
        -3
      ],
      [
        1,
        -4
      ],
      [
        -7,
        -9
      ],
      [
        -4,
        -2
      ],
      [
        -3,
        -6
      ],
      [
        -1,
        -3
      ],
      [
        -3,
        -11
      ],
      [
        1,
        -22
      ],
      [
        -2,
        -11
      ],
      [
        0,
        -5
      ],
      [
        4,
        -2
      ],
      [
        3,
        2
      ],
      [
        6,
        -10
      ],
      [
        2,
        -6
      ],
      [
        -10,
        -48
      ],
      [
        -1,
        -47
      ],
      [
        -4,
        -29
      ]
    ],
    [
      [
        26911,
        49121
      ],
      [
        5,
        32
      ],
      [
        4,
        24
      ],
      [
        3,
        14
      ],
      [
        5,
        16
      ],
      [
        1,
        0
      ],
      [
        2,
        1
      ],
      [
        2,
        3
      ],
      [
        0,
        15
      ],
      [
        -2,
        8
      ],
      [
        2,
        4
      ],
      [
        5,
        8
      ],
      [
        7,
        14
      ],
      [
        1,
        4
      ],
      [
        -1,
        7
      ],
      [
        4,
        23
      ],
      [
        0,
        11
      ],
      [
        2,
        9
      ],
      [
        3,
        2
      ],
      [
        2,
        28
      ],
      [
        0,
        1
      ],
      [
        -1,
        16
      ],
      [
        -1,
        36
      ],
      [
        -3,
        22
      ],
      [
        -6,
        0
      ],
      [
        -1,
        2
      ],
      [
        -4,
        5
      ],
      [
        -2,
        5
      ],
      [
        0,
        6
      ],
      [
        -1,
        4
      ],
      [
        -4,
        9
      ],
      [
        -4,
        -10
      ],
      [
        0,
        -6
      ],
      [
        1,
        -22
      ],
      [
        0,
        -37
      ],
      [
        2,
        -12
      ],
      [
        2,
        -7
      ],
      [
        1,
        -5
      ],
      [
        -1,
        -24
      ],
      [
        -1,
        -2
      ],
      [
        -4,
        2
      ],
      [
        -6,
        7
      ],
      [
        -11,
        23
      ],
      [
        0,
        17
      ],
      [
        4,
        3
      ],
      [
        1,
        6
      ],
      [
        1,
        8
      ],
      [
        -2,
        9
      ],
      [
        -1,
        7
      ],
      [
        0,
        3
      ],
      [
        2,
        5
      ],
      [
        1,
        7
      ],
      [
        -1,
        34
      ],
      [
        -2,
        18
      ],
      [
        -3,
        21
      ],
      [
        -7,
        3
      ],
      [
        -15,
        34
      ],
      [
        -3,
        21
      ],
      [
        -2,
        5
      ]
    ]
  ]
};
